function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/**
* plotly.js v2.0.0
* Copyright 2012-2021, Plotly, Inc.
* All rights reserved.
* Licensed under the MIT license
*/
!function (t) {
  if ("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module) module.exports = t();else if ("function" == typeof define && define.amd) define([], t);else {
    ("undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this).Plotly = t();
  }
}(function () {
  return function t(e, r, n) {
    function i(o, s) {
      if (!r[o]) {
        if (!e[o]) {
          var l = "function" == typeof require && require;
          if (!s && l) return l(o, !0);
          if (a) return a(o, !0);
          var c = new Error("Cannot find module '" + o + "'");
          throw c.code = "MODULE_NOT_FOUND", c;
        }

        var u = r[o] = {
          exports: {}
        };
        e[o][0].call(u.exports, function (t) {
          return i(e[o][1][t] || t);
        }, u, u.exports, t, e, r, n);
      }

      return r[o].exports;
    }

    for (var a = "function" == typeof require && require, o = 0; o < n.length; o++) {
      i(n[o]);
    }

    return i;
  }({
    1: [function (t, e, r) {
      "use strict";

      var n = t("../src/lib"),
          i = {
        "X,X div": "direction:ltr;font-family:'Open Sans', verdana, arial, sans-serif;margin:0;padding:0;",
        "X input,X button": "font-family:'Open Sans', verdana, arial, sans-serif;",
        "X input:focus,X button:focus": "outline:none;",
        "X a": "text-decoration:none;",
        "X a:hover": "text-decoration:none;",
        "X .crisp": "shape-rendering:crispEdges;",
        "X .user-select-none": "-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none;",
        "X svg": "overflow:hidden;",
        "X svg a": "fill:#447adb;",
        "X svg a:hover": "fill:#3c6dc5;",
        "X .main-svg": "position:absolute;top:0;left:0;pointer-events:none;",
        "X .main-svg .draglayer": "pointer-events:all;",
        "X .cursor-default": "cursor:default;",
        "X .cursor-pointer": "cursor:pointer;",
        "X .cursor-crosshair": "cursor:crosshair;",
        "X .cursor-move": "cursor:move;",
        "X .cursor-col-resize": "cursor:col-resize;",
        "X .cursor-row-resize": "cursor:row-resize;",
        "X .cursor-ns-resize": "cursor:ns-resize;",
        "X .cursor-ew-resize": "cursor:ew-resize;",
        "X .cursor-sw-resize": "cursor:sw-resize;",
        "X .cursor-s-resize": "cursor:s-resize;",
        "X .cursor-se-resize": "cursor:se-resize;",
        "X .cursor-w-resize": "cursor:w-resize;",
        "X .cursor-e-resize": "cursor:e-resize;",
        "X .cursor-nw-resize": "cursor:nw-resize;",
        "X .cursor-n-resize": "cursor:n-resize;",
        "X .cursor-ne-resize": "cursor:ne-resize;",
        "X .cursor-grab": "cursor:-webkit-grab;cursor:grab;",
        "X .modebar": "position:absolute;top:2px;right:2px;",
        "X .ease-bg": "-webkit-transition:background-color 0.3s ease 0s;-moz-transition:background-color 0.3s ease 0s;-ms-transition:background-color 0.3s ease 0s;-o-transition:background-color 0.3s ease 0s;transition:background-color 0.3s ease 0s;",
        "X .modebar--hover>:not(.watermark)": "opacity:0;-webkit-transition:opacity 0.3s ease 0s;-moz-transition:opacity 0.3s ease 0s;-ms-transition:opacity 0.3s ease 0s;-o-transition:opacity 0.3s ease 0s;transition:opacity 0.3s ease 0s;",
        "X:hover .modebar--hover .modebar-group": "opacity:1;",
        "X .modebar-group": "float:left;display:inline-block;box-sizing:border-box;padding-left:8px;position:relative;vertical-align:middle;white-space:nowrap;",
        "X .modebar-btn": "position:relative;font-size:16px;padding:3px 4px;height:22px;cursor:pointer;line-height:normal;box-sizing:border-box;",
        "X .modebar-btn svg": "position:relative;top:2px;",
        "X .modebar.vertical": "display:flex;flex-direction:column;flex-wrap:wrap;align-content:flex-end;max-height:100%;",
        "X .modebar.vertical svg": "top:-1px;",
        "X .modebar.vertical .modebar-group": "display:block;float:none;padding-left:0px;padding-bottom:8px;",
        "X .modebar.vertical .modebar-group .modebar-btn": "display:block;text-align:center;",
        "X [data-title]:before,X [data-title]:after": "position:absolute;-webkit-transform:translate3d(0, 0, 0);-moz-transform:translate3d(0, 0, 0);-ms-transform:translate3d(0, 0, 0);-o-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);display:none;opacity:0;z-index:1001;pointer-events:none;top:110%;right:50%;",
        "X [data-title]:hover:before,X [data-title]:hover:after": "display:block;opacity:1;",
        "X [data-title]:before": "content:'';position:absolute;background:transparent;border:6px solid transparent;z-index:1002;margin-top:-12px;border-bottom-color:#69738a;margin-right:-6px;",
        "X [data-title]:after": "content:attr(data-title);background:#69738a;color:white;padding:8px 10px;font-size:12px;line-height:12px;white-space:nowrap;margin-right:-18px;border-radius:2px;",
        "X .vertical [data-title]:before,X .vertical [data-title]:after": "top:0%;right:200%;",
        "X .vertical [data-title]:before": "border:6px solid transparent;border-left-color:#69738a;margin-top:8px;margin-right:-30px;",
        "X .select-outline": "fill:none;stroke-width:1;shape-rendering:crispEdges;",
        "X .select-outline-1": "stroke:white;",
        "X .select-outline-2": "stroke:black;stroke-dasharray:2px 2px;",
        Y: "font-family:'Open Sans', verdana, arial, sans-serif;position:fixed;top:50px;right:20px;z-index:10000;font-size:10pt;max-width:180px;",
        "Y p": "margin:0;",
        "Y .notifier-note": "min-width:180px;max-width:250px;border:1px solid #fff;z-index:3000;margin:0;background-color:#8c97af;background-color:rgba(140,151,175,0.9);color:#fff;padding:10px;overflow-wrap:break-word;word-wrap:break-word;-ms-hyphens:auto;-webkit-hyphens:auto;hyphens:auto;",
        "Y .notifier-close": "color:#fff;opacity:0.8;float:right;padding:0 5px;background:none;border:none;font-size:20px;font-weight:bold;line-height:20px;",
        "Y .notifier-close:hover": "color:#444;text-decoration:none;cursor:pointer;"
      };

      for (var a in i) {
        var o = a.replace(/^,/, " ,").replace(/X/g, ".js-plotly-plot .plotly").replace(/Y/g, ".plotly-notifier");
        n.addStyleRule(o, i[a]);
      }
    }, {
      "../src/lib": 795
    }],
    2: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/transforms/aggregate");
    }, {
      "../src/transforms/aggregate": 1377
    }],
    3: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/bar");
    }, {
      "../src/traces/bar": 941
    }],
    4: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/barpolar");
    }, {
      "../src/traces/barpolar": 954
    }],
    5: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/box");
    }, {
      "../src/traces/box": 964
    }],
    6: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/components/calendars");
    }, {
      "../src/components/calendars": 656
    }],
    7: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/candlestick");
    }, {
      "../src/traces/candlestick": 973
    }],
    8: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/carpet");
    }, {
      "../src/traces/carpet": 992
    }],
    9: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/choropleth");
    }, {
      "../src/traces/choropleth": 1006
    }],
    10: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/choroplethmapbox");
    }, {
      "../src/traces/choroplethmapbox": 1013
    }],
    11: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/cone");
    }, {
      "../src/traces/cone": 1019
    }],
    12: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/contour");
    }, {
      "../src/traces/contour": 1034
    }],
    13: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/contourcarpet");
    }, {
      "../src/traces/contourcarpet": 1045
    }],
    14: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/core");
    }, {
      "../src/core": 773
    }],
    15: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/densitymapbox");
    }, {
      "../src/traces/densitymapbox": 1053
    }],
    16: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/transforms/filter");
    }, {
      "../src/transforms/filter": 1378
    }],
    17: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/funnel");
    }, {
      "../src/traces/funnel": 1063
    }],
    18: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/funnelarea");
    }, {
      "../src/traces/funnelarea": 1072
    }],
    19: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/transforms/groupby");
    }, {
      "../src/transforms/groupby": 1379
    }],
    20: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/heatmap");
    }, {
      "../src/traces/heatmap": 1085
    }],
    21: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/heatmapgl");
    }, {
      "../src/traces/heatmapgl": 1095
    }],
    22: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/histogram");
    }, {
      "../src/traces/histogram": 1107
    }],
    23: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/histogram2d");
    }, {
      "../src/traces/histogram2d": 1113
    }],
    24: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/histogram2dcontour");
    }, {
      "../src/traces/histogram2dcontour": 1117
    }],
    25: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/image");
    }, {
      "../src/traces/image": 1125
    }],
    26: [function (t, e, r) {
      "use strict";

      var n = t("./core");
      n.register([t("./bar"), t("./box"), t("./heatmap"), t("./histogram"), t("./histogram2d"), t("./histogram2dcontour"), t("./contour"), t("./scatterternary"), t("./violin"), t("./funnel"), t("./waterfall"), t("./image"), t("./pie"), t("./sunburst"), t("./treemap"), t("./funnelarea"), t("./scatter3d"), t("./surface"), t("./isosurface"), t("./volume"), t("./mesh3d"), t("./cone"), t("./streamtube"), t("./scattergeo"), t("./choropleth"), t("./scattergl"), t("./splom"), t("./pointcloud"), t("./heatmapgl"), t("./parcoords"), t("./parcats"), t("./scattermapbox"), t("./choroplethmapbox"), t("./densitymapbox"), t("./sankey"), t("./indicator"), t("./table"), t("./carpet"), t("./scattercarpet"), t("./contourcarpet"), t("./ohlc"), t("./candlestick"), t("./scatterpolar"), t("./scatterpolargl"), t("./barpolar"), t("./aggregate"), t("./filter"), t("./groupby"), t("./sort"), t("./calendars")]), e.exports = n;
    }, {
      "./aggregate": 2,
      "./bar": 3,
      "./barpolar": 4,
      "./box": 5,
      "./calendars": 6,
      "./candlestick": 7,
      "./carpet": 8,
      "./choropleth": 9,
      "./choroplethmapbox": 10,
      "./cone": 11,
      "./contour": 12,
      "./contourcarpet": 13,
      "./core": 14,
      "./densitymapbox": 15,
      "./filter": 16,
      "./funnel": 17,
      "./funnelarea": 18,
      "./groupby": 19,
      "./heatmap": 20,
      "./heatmapgl": 21,
      "./histogram": 22,
      "./histogram2d": 23,
      "./histogram2dcontour": 24,
      "./image": 25,
      "./indicator": 27,
      "./isosurface": 28,
      "./mesh3d": 29,
      "./ohlc": 30,
      "./parcats": 31,
      "./parcoords": 32,
      "./pie": 33,
      "./pointcloud": 34,
      "./sankey": 35,
      "./scatter3d": 36,
      "./scattercarpet": 37,
      "./scattergeo": 38,
      "./scattergl": 39,
      "./scattermapbox": 40,
      "./scatterpolar": 41,
      "./scatterpolargl": 42,
      "./scatterternary": 43,
      "./sort": 44,
      "./splom": 45,
      "./streamtube": 46,
      "./sunburst": 47,
      "./surface": 48,
      "./table": 49,
      "./treemap": 50,
      "./violin": 51,
      "./volume": 52,
      "./waterfall": 53
    }],
    27: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/indicator");
    }, {
      "../src/traces/indicator": 1133
    }],
    28: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/isosurface");
    }, {
      "../src/traces/isosurface": 1139
    }],
    29: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/mesh3d");
    }, {
      "../src/traces/mesh3d": 1144
    }],
    30: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/ohlc");
    }, {
      "../src/traces/ohlc": 1149
    }],
    31: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/parcats");
    }, {
      "../src/traces/parcats": 1158
    }],
    32: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/parcoords");
    }, {
      "../src/traces/parcoords": 1168
    }],
    33: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/pie");
    }, {
      "../src/traces/pie": 1179
    }],
    34: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/pointcloud");
    }, {
      "../src/traces/pointcloud": 1188
    }],
    35: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/sankey");
    }, {
      "../src/traces/sankey": 1194
    }],
    36: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/scatter3d");
    }, {
      "../src/traces/scatter3d": 1232
    }],
    37: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/scattercarpet");
    }, {
      "../src/traces/scattercarpet": 1239
    }],
    38: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/scattergeo");
    }, {
      "../src/traces/scattergeo": 1247
    }],
    39: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/scattergl");
    }, {
      "../src/traces/scattergl": 1260
    }],
    40: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/scattermapbox");
    }, {
      "../src/traces/scattermapbox": 1270
    }],
    41: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/scatterpolar");
    }, {
      "../src/traces/scatterpolar": 1278
    }],
    42: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/scatterpolargl");
    }, {
      "../src/traces/scatterpolargl": 1285
    }],
    43: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/scatterternary");
    }, {
      "../src/traces/scatterternary": 1293
    }],
    44: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/transforms/sort");
    }, {
      "../src/transforms/sort": 1381
    }],
    45: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/splom");
    }, {
      "../src/traces/splom": 1302
    }],
    46: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/streamtube");
    }, {
      "../src/traces/streamtube": 1310
    }],
    47: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/sunburst");
    }, {
      "../src/traces/sunburst": 1318
    }],
    48: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/surface");
    }, {
      "../src/traces/surface": 1327
    }],
    49: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/table");
    }, {
      "../src/traces/table": 1335
    }],
    50: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/treemap");
    }, {
      "../src/traces/treemap": 1344
    }],
    51: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/violin");
    }, {
      "../src/traces/violin": 1356
    }],
    52: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/volume");
    }, {
      "../src/traces/volume": 1364
    }],
    53: [function (t, e, r) {
      "use strict";

      e.exports = t("../src/traces/waterfall");
    }, {
      "../src/traces/waterfall": 1372
    }],
    54: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        var e = (t = t || {}).eye || [0, 0, 1],
            r = t.center || [0, 0, 0],
            s = t.up || [0, 1, 0],
            l = t.distanceLimits || [0, 1 / 0],
            c = t.mode || "turntable",
            u = n(),
            f = i(),
            h = a();
        return u.setDistanceLimits(l[0], l[1]), u.lookAt(0, e, r, s), f.setDistanceLimits(l[0], l[1]), f.lookAt(0, e, r, s), h.setDistanceLimits(l[0], l[1]), h.lookAt(0, e, r, s), new o({
          turntable: u,
          orbit: f,
          matrix: h
        }, c);
      };

      var n = t("turntable-camera-controller"),
          i = t("orbit-camera-controller"),
          a = t("matrix-camera-controller");

      function o(t, e) {
        this._controllerNames = Object.keys(t), this._controllerList = this._controllerNames.map(function (e) {
          return t[e];
        }), this._mode = e, this._active = t[e], this._active || (this._mode = "turntable", this._active = t.turntable), this.modes = this._controllerNames, this.computedMatrix = this._active.computedMatrix, this.computedEye = this._active.computedEye, this.computedUp = this._active.computedUp, this.computedCenter = this._active.computedCenter, this.computedRadius = this._active.computedRadius;
      }

      var s = o.prototype;
      [["flush", 1], ["idle", 1], ["lookAt", 4], ["rotate", 4], ["pan", 4], ["translate", 4], ["setMatrix", 2], ["setDistanceLimits", 2], ["setDistance", 2]].forEach(function (t) {
        for (var e = t[0], r = [], n = 0; n < t[1]; ++n) {
          r.push("a" + n);
        }

        var i = "var cc=this._controllerList;for(var i=0;i<cc.length;++i){cc[i]." + t[0] + "(" + r.join() + ")}";
        s[e] = Function.apply(null, r.concat(i));
      }), s.recalcMatrix = function (t) {
        this._active.recalcMatrix(t);
      }, s.getDistance = function (t) {
        return this._active.getDistance(t);
      }, s.getDistanceLimits = function (t) {
        return this._active.getDistanceLimits(t);
      }, s.lastT = function () {
        return this._active.lastT();
      }, s.setMode = function (t) {
        if (t !== this._mode) {
          var e = this._controllerNames.indexOf(t);

          if (!(e < 0)) {
            var r = this._active,
                n = this._controllerList[e],
                i = Math.max(r.lastT(), n.lastT());
            r.recalcMatrix(i), n.setMatrix(i, r.computedMatrix), this._active = n, this._mode = t, this.computedMatrix = this._active.computedMatrix, this.computedEye = this._active.computedEye, this.computedUp = this._active.computedUp, this.computedCenter = this._active.computedCenter, this.computedRadius = this._active.computedRadius;
          }
        }
      }, s.getMode = function () {
        return this._mode;
      };
    }, {
      "matrix-camera-controller": 459,
      "orbit-camera-controller": 481,
      "turntable-camera-controller": 595
    }],
    55: [function (t, e, r) {
      !function (n, i) {
        "object" == _typeof(r) && void 0 !== e ? i(r, t("d3-array"), t("d3-collection"), t("d3-shape"), t("elementary-circuits-directed-graph")) : i(n.d3 = n.d3 || {}, n.d3, n.d3, n.d3, null);
      }(this, function (t, e, r, n, i) {
        "use strict";

        function a(t) {
          return t.target.depth;
        }

        function o(t, e) {
          return t.sourceLinks.length ? t.depth : e - 1;
        }

        function s(t) {
          return function () {
            return t;
          };
        }

        i = i && i.hasOwnProperty("default") ? i.default : i;
        var l = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
          return _typeof(t);
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
        };

        function c(t, e) {
          return f(t.source, e.source) || t.index - e.index;
        }

        function u(t, e) {
          return f(t.target, e.target) || t.index - e.index;
        }

        function f(t, e) {
          return t.partOfCycle === e.partOfCycle ? t.y0 - e.y0 : "top" === t.circularLinkType || "bottom" === e.circularLinkType ? -1 : 1;
        }

        function h(t) {
          return t.value;
        }

        function p(t) {
          return (t.y0 + t.y1) / 2;
        }

        function d(t) {
          return p(t.source);
        }

        function m(t) {
          return p(t.target);
        }

        function g(t) {
          return t.index;
        }

        function v(t) {
          return t.nodes;
        }

        function y(t) {
          return t.links;
        }

        function x(t, e) {
          var r = t.get(e);
          if (!r) throw new Error("missing: " + e);
          return r;
        }

        function b(t, e) {
          return e(t);
        }

        function _(t, e, r) {
          var n = 0;

          if (null === r) {
            for (var a = [], o = 0; o < t.links.length; o++) {
              var s = t.links[o],
                  l = s.source.index,
                  c = s.target.index;
              a[l] || (a[l] = []), a[c] || (a[c] = []), -1 === a[l].indexOf(c) && a[l].push(c);
            }

            var u = i(a);
            u.sort(function (t, e) {
              return t.length - e.length;
            });
            var f = {};

            for (o = 0; o < u.length; o++) {
              var h = u[o].slice(-2);
              f[h[0]] || (f[h[0]] = {}), f[h[0]][h[1]] = !0;
            }

            t.links.forEach(function (t) {
              var e = t.target.index,
                  r = t.source.index;
              e === r || f[r] && f[r][e] ? (t.circular = !0, t.circularLinkID = n, n += 1) : t.circular = !1;
            });
          } else t.links.forEach(function (t) {
            t.source[r] < t.target[r] ? t.circular = !1 : (t.circular = !0, t.circularLinkID = n, n += 1);
          });
        }

        function w(t, e) {
          var r = 0,
              n = 0;
          t.links.forEach(function (i) {
            i.circular && (i.source.circularLinkType || i.target.circularLinkType ? i.circularLinkType = i.source.circularLinkType ? i.source.circularLinkType : i.target.circularLinkType : i.circularLinkType = r < n ? "top" : "bottom", "top" == i.circularLinkType ? r += 1 : n += 1, t.nodes.forEach(function (t) {
              b(t, e) != b(i.source, e) && b(t, e) != b(i.target, e) || (t.circularLinkType = i.circularLinkType);
            }));
          }), t.links.forEach(function (t) {
            t.circular && (t.source.circularLinkType == t.target.circularLinkType && (t.circularLinkType = t.source.circularLinkType), H(t, e) && (t.circularLinkType = t.source.circularLinkType));
          });
        }

        function T(t) {
          var e = Math.abs(t.y1 - t.y0),
              r = Math.abs(t.target.x0 - t.source.x1);
          return Math.atan(r / e);
        }

        function k(t, e) {
          var r = 0;
          t.sourceLinks.forEach(function (t) {
            r = t.circular && !H(t, e) ? r + 1 : r;
          });
          var n = 0;
          return t.targetLinks.forEach(function (t) {
            n = t.circular && !H(t, e) ? n + 1 : n;
          }), r + n;
        }

        function M(t) {
          var e = t.source.sourceLinks,
              r = 0;
          e.forEach(function (t) {
            r = t.circular ? r + 1 : r;
          });
          var n = t.target.targetLinks,
              i = 0;
          return n.forEach(function (t) {
            i = t.circular ? i + 1 : i;
          }), !(r > 1 || i > 1);
        }

        function A(t, e, r) {
          return t.sort(E), t.forEach(function (n, i) {
            var a,
                o,
                s = 0;
            if (H(n, r) && M(n)) n.circularPathData.verticalBuffer = s + n.width / 2;else {
              for (var l = 0; l < i; l++) {
                if (a = t[i], o = t[l], !(a.source.column < o.target.column || a.target.column > o.source.column)) {
                  var c = t[l].circularPathData.verticalBuffer + t[l].width / 2 + e;
                  s = c > s ? c : s;
                }
              }

              n.circularPathData.verticalBuffer = s + n.width / 2;
            }
          }), t;
        }

        function S(t, r, i, a) {
          var o = e.min(t.links, function (t) {
            return t.source.y0;
          });
          t.links.forEach(function (t) {
            t.circular && (t.circularPathData = {});
          }), A(t.links.filter(function (t) {
            return "top" == t.circularLinkType;
          }), r, a), A(t.links.filter(function (t) {
            return "bottom" == t.circularLinkType;
          }), r, a), t.links.forEach(function (e) {
            if (e.circular) {
              if (e.circularPathData.arcRadius = e.width + 10, e.circularPathData.leftNodeBuffer = 5, e.circularPathData.rightNodeBuffer = 5, e.circularPathData.sourceWidth = e.source.x1 - e.source.x0, e.circularPathData.sourceX = e.source.x0 + e.circularPathData.sourceWidth, e.circularPathData.targetX = e.target.x0, e.circularPathData.sourceY = e.y0, e.circularPathData.targetY = e.y1, H(e, a) && M(e)) e.circularPathData.leftSmallArcRadius = 10 + e.width / 2, e.circularPathData.leftLargeArcRadius = 10 + e.width / 2, e.circularPathData.rightSmallArcRadius = 10 + e.width / 2, e.circularPathData.rightLargeArcRadius = 10 + e.width / 2, "bottom" == e.circularLinkType ? (e.circularPathData.verticalFullExtent = e.source.y1 + 25 + e.circularPathData.verticalBuffer, e.circularPathData.verticalLeftInnerExtent = e.circularPathData.verticalFullExtent - e.circularPathData.leftLargeArcRadius, e.circularPathData.verticalRightInnerExtent = e.circularPathData.verticalFullExtent - e.circularPathData.rightLargeArcRadius) : (e.circularPathData.verticalFullExtent = e.source.y0 - 25 - e.circularPathData.verticalBuffer, e.circularPathData.verticalLeftInnerExtent = e.circularPathData.verticalFullExtent + e.circularPathData.leftLargeArcRadius, e.circularPathData.verticalRightInnerExtent = e.circularPathData.verticalFullExtent + e.circularPathData.rightLargeArcRadius);else {
                var s = e.source.column,
                    l = e.circularLinkType,
                    c = t.links.filter(function (t) {
                  return t.source.column == s && t.circularLinkType == l;
                });
                "bottom" == e.circularLinkType ? c.sort(C) : c.sort(L);
                var u = 0;
                c.forEach(function (t, n) {
                  t.circularLinkID == e.circularLinkID && (e.circularPathData.leftSmallArcRadius = 10 + e.width / 2 + u, e.circularPathData.leftLargeArcRadius = 10 + e.width / 2 + n * r + u), u += t.width;
                }), s = e.target.column, c = t.links.filter(function (t) {
                  return t.target.column == s && t.circularLinkType == l;
                }), "bottom" == e.circularLinkType ? c.sort(I) : c.sort(P), u = 0, c.forEach(function (t, n) {
                  t.circularLinkID == e.circularLinkID && (e.circularPathData.rightSmallArcRadius = 10 + e.width / 2 + u, e.circularPathData.rightLargeArcRadius = 10 + e.width / 2 + n * r + u), u += t.width;
                }), "bottom" == e.circularLinkType ? (e.circularPathData.verticalFullExtent = Math.max(i, e.source.y1, e.target.y1) + 25 + e.circularPathData.verticalBuffer, e.circularPathData.verticalLeftInnerExtent = e.circularPathData.verticalFullExtent - e.circularPathData.leftLargeArcRadius, e.circularPathData.verticalRightInnerExtent = e.circularPathData.verticalFullExtent - e.circularPathData.rightLargeArcRadius) : (e.circularPathData.verticalFullExtent = o - 25 - e.circularPathData.verticalBuffer, e.circularPathData.verticalLeftInnerExtent = e.circularPathData.verticalFullExtent + e.circularPathData.leftLargeArcRadius, e.circularPathData.verticalRightInnerExtent = e.circularPathData.verticalFullExtent + e.circularPathData.rightLargeArcRadius);
              }
              e.circularPathData.leftInnerExtent = e.circularPathData.sourceX + e.circularPathData.leftNodeBuffer, e.circularPathData.rightInnerExtent = e.circularPathData.targetX - e.circularPathData.rightNodeBuffer, e.circularPathData.leftFullExtent = e.circularPathData.sourceX + e.circularPathData.leftLargeArcRadius + e.circularPathData.leftNodeBuffer, e.circularPathData.rightFullExtent = e.circularPathData.targetX - e.circularPathData.rightLargeArcRadius - e.circularPathData.rightNodeBuffer;
            }

            if (e.circular) e.path = function (t) {
              var e = "";
              e = "top" == t.circularLinkType ? "M" + t.circularPathData.sourceX + " " + t.circularPathData.sourceY + " L" + t.circularPathData.leftInnerExtent + " " + t.circularPathData.sourceY + " A" + t.circularPathData.leftLargeArcRadius + " " + t.circularPathData.leftSmallArcRadius + " 0 0 0 " + t.circularPathData.leftFullExtent + " " + (t.circularPathData.sourceY - t.circularPathData.leftSmallArcRadius) + " L" + t.circularPathData.leftFullExtent + " " + t.circularPathData.verticalLeftInnerExtent + " A" + t.circularPathData.leftLargeArcRadius + " " + t.circularPathData.leftLargeArcRadius + " 0 0 0 " + t.circularPathData.leftInnerExtent + " " + t.circularPathData.verticalFullExtent + " L" + t.circularPathData.rightInnerExtent + " " + t.circularPathData.verticalFullExtent + " A" + t.circularPathData.rightLargeArcRadius + " " + t.circularPathData.rightLargeArcRadius + " 0 0 0 " + t.circularPathData.rightFullExtent + " " + t.circularPathData.verticalRightInnerExtent + " L" + t.circularPathData.rightFullExtent + " " + (t.circularPathData.targetY - t.circularPathData.rightSmallArcRadius) + " A" + t.circularPathData.rightLargeArcRadius + " " + t.circularPathData.rightSmallArcRadius + " 0 0 0 " + t.circularPathData.rightInnerExtent + " " + t.circularPathData.targetY + " L" + t.circularPathData.targetX + " " + t.circularPathData.targetY : "M" + t.circularPathData.sourceX + " " + t.circularPathData.sourceY + " L" + t.circularPathData.leftInnerExtent + " " + t.circularPathData.sourceY + " A" + t.circularPathData.leftLargeArcRadius + " " + t.circularPathData.leftSmallArcRadius + " 0 0 1 " + t.circularPathData.leftFullExtent + " " + (t.circularPathData.sourceY + t.circularPathData.leftSmallArcRadius) + " L" + t.circularPathData.leftFullExtent + " " + t.circularPathData.verticalLeftInnerExtent + " A" + t.circularPathData.leftLargeArcRadius + " " + t.circularPathData.leftLargeArcRadius + " 0 0 1 " + t.circularPathData.leftInnerExtent + " " + t.circularPathData.verticalFullExtent + " L" + t.circularPathData.rightInnerExtent + " " + t.circularPathData.verticalFullExtent + " A" + t.circularPathData.rightLargeArcRadius + " " + t.circularPathData.rightLargeArcRadius + " 0 0 1 " + t.circularPathData.rightFullExtent + " " + t.circularPathData.verticalRightInnerExtent + " L" + t.circularPathData.rightFullExtent + " " + (t.circularPathData.targetY + t.circularPathData.rightSmallArcRadius) + " A" + t.circularPathData.rightLargeArcRadius + " " + t.circularPathData.rightSmallArcRadius + " 0 0 1 " + t.circularPathData.rightInnerExtent + " " + t.circularPathData.targetY + " L" + t.circularPathData.targetX + " " + t.circularPathData.targetY;
              return e;
            }(e);else {
              var f = n.linkHorizontal().source(function (t) {
                return [t.source.x0 + (t.source.x1 - t.source.x0), t.y0];
              }).target(function (t) {
                return [t.target.x0, t.y1];
              });
              e.path = f(e);
            }
          });
        }

        function E(t, e) {
          return O(t) == O(e) ? "bottom" == t.circularLinkType ? C(t, e) : L(t, e) : O(e) - O(t);
        }

        function L(t, e) {
          return t.y0 - e.y0;
        }

        function C(t, e) {
          return e.y0 - t.y0;
        }

        function P(t, e) {
          return t.y1 - e.y1;
        }

        function I(t, e) {
          return e.y1 - t.y1;
        }

        function O(t) {
          return t.target.column - t.source.column;
        }

        function z(t) {
          return t.target.x0 - t.source.x1;
        }

        function D(t, e) {
          var r = T(t),
              n = z(e) / Math.tan(r);
          return "up" == q(t) ? t.y1 + n : t.y1 - n;
        }

        function R(t, e) {
          var r = T(t),
              n = z(e) / Math.tan(r);
          return "up" == q(t) ? t.y1 - n : t.y1 + n;
        }

        function F(t, e, r, n) {
          t.links.forEach(function (i) {
            if (!i.circular && i.target.column - i.source.column > 1) {
              var a = i.source.column + 1,
                  o = i.target.column - 1,
                  s = 1,
                  l = o - a + 1;

              for (s = 1; a <= o; a++, s++) {
                t.nodes.forEach(function (o) {
                  if (o.column == a) {
                    var c,
                        u = s / (l + 1),
                        f = Math.pow(1 - u, 3),
                        h = 3 * u * Math.pow(1 - u, 2),
                        p = 3 * Math.pow(u, 2) * (1 - u),
                        d = Math.pow(u, 3),
                        m = f * i.y0 + h * i.y0 + p * i.y1 + d * i.y1,
                        g = m - i.width / 2,
                        v = m + i.width / 2;
                    g > o.y0 && g < o.y1 ? (c = o.y1 - g + 10, c = "bottom" == o.circularLinkType ? c : -c, o = N(o, c, e, r), t.nodes.forEach(function (t) {
                      b(t, n) != b(o, n) && t.column == o.column && B(o, t) && N(t, c, e, r);
                    })) : (v > o.y0 && v < o.y1 || g < o.y0 && v > o.y1) && (c = v - o.y0 + 10, o = N(o, c, e, r), t.nodes.forEach(function (t) {
                      b(t, n) != b(o, n) && t.column == o.column && t.y0 < o.y1 && t.y1 > o.y1 && N(t, c, e, r);
                    }));
                  }
                });
              }
            }
          });
        }

        function B(t, e) {
          return t.y0 > e.y0 && t.y0 < e.y1 || t.y1 > e.y0 && t.y1 < e.y1 || t.y0 < e.y0 && t.y1 > e.y1;
        }

        function N(t, e, r, n) {
          return t.y0 + e >= r && t.y1 + e <= n && (t.y0 = t.y0 + e, t.y1 = t.y1 + e, t.targetLinks.forEach(function (t) {
            t.y1 = t.y1 + e;
          }), t.sourceLinks.forEach(function (t) {
            t.y0 = t.y0 + e;
          })), t;
        }

        function j(t, e, r, n) {
          t.nodes.forEach(function (i) {
            n && i.y + (i.y1 - i.y0) > e && (i.y = i.y - (i.y + (i.y1 - i.y0) - e));
            var a = t.links.filter(function (t) {
              return b(t.source, r) == b(i, r);
            }),
                o = a.length;
            o > 1 && a.sort(function (t, e) {
              if (!t.circular && !e.circular) {
                if (t.target.column == e.target.column) return t.y1 - e.y1;
                if (!V(t, e)) return t.y1 - e.y1;

                if (t.target.column > e.target.column) {
                  var r = R(e, t);
                  return t.y1 - r;
                }

                if (e.target.column > t.target.column) return R(t, e) - e.y1;
              }

              return t.circular && !e.circular ? "top" == t.circularLinkType ? -1 : 1 : e.circular && !t.circular ? "top" == e.circularLinkType ? 1 : -1 : t.circular && e.circular ? t.circularLinkType === e.circularLinkType && "top" == t.circularLinkType ? t.target.column === e.target.column ? t.target.y1 - e.target.y1 : e.target.column - t.target.column : t.circularLinkType === e.circularLinkType && "bottom" == t.circularLinkType ? t.target.column === e.target.column ? e.target.y1 - t.target.y1 : t.target.column - e.target.column : "top" == t.circularLinkType ? -1 : 1 : void 0;
            });
            var s = i.y0;
            a.forEach(function (t) {
              t.y0 = s + t.width / 2, s += t.width;
            }), a.forEach(function (t, e) {
              if ("bottom" == t.circularLinkType) {
                for (var r = e + 1, n = 0; r < o; r++) {
                  n += a[r].width;
                }

                t.y0 = i.y1 - n - t.width / 2;
              }
            });
          });
        }

        function U(t, e, r) {
          t.nodes.forEach(function (e) {
            var n = t.links.filter(function (t) {
              return b(t.target, r) == b(e, r);
            }),
                i = n.length;
            i > 1 && n.sort(function (t, e) {
              if (!t.circular && !e.circular) {
                if (t.source.column == e.source.column) return t.y0 - e.y0;
                if (!V(t, e)) return t.y0 - e.y0;

                if (e.source.column < t.source.column) {
                  var r = D(e, t);
                  return t.y0 - r;
                }

                if (t.source.column < e.source.column) return D(t, e) - e.y0;
              }

              return t.circular && !e.circular ? "top" == t.circularLinkType ? -1 : 1 : e.circular && !t.circular ? "top" == e.circularLinkType ? 1 : -1 : t.circular && e.circular ? t.circularLinkType === e.circularLinkType && "top" == t.circularLinkType ? t.source.column === e.source.column ? t.source.y1 - e.source.y1 : t.source.column - e.source.column : t.circularLinkType === e.circularLinkType && "bottom" == t.circularLinkType ? t.source.column === e.source.column ? t.source.y1 - e.source.y1 : e.source.column - t.source.column : "top" == t.circularLinkType ? -1 : 1 : void 0;
            });
            var a = e.y0;
            n.forEach(function (t) {
              t.y1 = a + t.width / 2, a += t.width;
            }), n.forEach(function (t, r) {
              if ("bottom" == t.circularLinkType) {
                for (var a = r + 1, o = 0; a < i; a++) {
                  o += n[a].width;
                }

                t.y1 = e.y1 - o - t.width / 2;
              }
            });
          });
        }

        function V(t, e) {
          return q(t) == q(e);
        }

        function q(t) {
          return t.y0 - t.y1 > 0 ? "up" : "down";
        }

        function H(t, e) {
          return b(t.source, e) == b(t.target, e);
        }

        function G(t, r, n) {
          var i = t.nodes,
              a = t.links,
              o = !1,
              s = !1;

          if (a.forEach(function (t) {
            "top" == t.circularLinkType ? o = !0 : "bottom" == t.circularLinkType && (s = !0);
          }), 0 == o || 0 == s) {
            var l = e.min(i, function (t) {
              return t.y0;
            }),
                c = (n - r) / (e.max(i, function (t) {
              return t.y1;
            }) - l);
            i.forEach(function (t) {
              var e = (t.y1 - t.y0) * c;
              t.y0 = (t.y0 - l) * c, t.y1 = t.y0 + e;
            }), a.forEach(function (t) {
              t.y0 = (t.y0 - l) * c, t.y1 = (t.y1 - l) * c, t.width = t.width * c;
            });
          }
        }

        t.sankeyCircular = function () {
          var t,
              n,
              i = 0,
              a = 0,
              b = 1,
              T = 1,
              M = 24,
              A = g,
              E = o,
              L = v,
              C = y,
              P = 32,
              I = 2,
              O = null;

          function z() {
            var t = {
              nodes: L.apply(null, arguments),
              links: C.apply(null, arguments)
            };
            D(t), _(t, A, O), R(t), B(t), w(t, A), N(t, P, A), V(t);

            for (var e = 4, r = 0; r < e; r++) {
              j(t, T, A), U(t, T, A), F(t, a, T, A), j(t, T, A), U(t, T, A);
            }

            return G(t, a, T), S(t, I, T, A), t;
          }

          function D(t) {
            t.nodes.forEach(function (t, e) {
              t.index = e, t.sourceLinks = [], t.targetLinks = [];
            });
            var e = r.map(t.nodes, A);
            return t.links.forEach(function (t, r) {
              t.index = r;
              var n = t.source,
                  i = t.target;
              "object" !== (void 0 === n ? "undefined" : l(n)) && (n = t.source = x(e, n)), "object" !== (void 0 === i ? "undefined" : l(i)) && (i = t.target = x(e, i)), n.sourceLinks.push(t), i.targetLinks.push(t);
            }), t;
          }

          function R(t) {
            t.nodes.forEach(function (t) {
              t.partOfCycle = !1, t.value = Math.max(e.sum(t.sourceLinks, h), e.sum(t.targetLinks, h)), t.sourceLinks.forEach(function (e) {
                e.circular && (t.partOfCycle = !0, t.circularLinkType = e.circularLinkType);
              }), t.targetLinks.forEach(function (e) {
                e.circular && (t.partOfCycle = !0, t.circularLinkType = e.circularLinkType);
              });
            });
          }

          function B(t) {
            var e, r, n;

            for (e = t.nodes, r = [], n = 0; e.length; ++n, e = r, r = []) {
              e.forEach(function (t) {
                t.depth = n, t.sourceLinks.forEach(function (t) {
                  r.indexOf(t.target) < 0 && !t.circular && r.push(t.target);
                });
              });
            }

            for (e = t.nodes, r = [], n = 0; e.length; ++n, e = r, r = []) {
              e.forEach(function (t) {
                t.height = n, t.targetLinks.forEach(function (t) {
                  r.indexOf(t.source) < 0 && !t.circular && r.push(t.source);
                });
              });
            }

            t.nodes.forEach(function (t) {
              t.column = Math.floor(E.call(null, t, n));
            });
          }

          function N(o, s, l) {
            var c = r.nest().key(function (t) {
              return t.column;
            }).sortKeys(e.ascending).entries(o.nodes).map(function (t) {
              return t.values;
            });
            !function (r) {
              if (n) {
                var s = 1 / 0;
                c.forEach(function (t) {
                  var e = T * n / (t.length + 1);
                  s = e < s ? e : s;
                }), t = s;
              }

              var l = e.min(c, function (r) {
                return (T - a - (r.length - 1) * t) / e.sum(r, h);
              });
              l *= .3, o.links.forEach(function (t) {
                t.width = t.value * l;
              });

              var u = function (t) {
                var r = 0,
                    n = 0,
                    i = 0,
                    a = 0,
                    o = e.max(t.nodes, function (t) {
                  return t.column;
                });
                return t.links.forEach(function (t) {
                  t.circular && ("top" == t.circularLinkType ? r += t.width : n += t.width, 0 == t.target.column && (a += t.width), t.source.column == o && (i += t.width));
                }), {
                  top: r = r > 0 ? r + 25 + 10 : r,
                  bottom: n = n > 0 ? n + 25 + 10 : n,
                  left: a = a > 0 ? a + 25 + 10 : a,
                  right: i = i > 0 ? i + 25 + 10 : i
                };
              }(o),
                  f = function (t, r) {
                var n = e.max(t.nodes, function (t) {
                  return t.column;
                }),
                    o = b - i,
                    s = T - a,
                    l = o / (o + r.right + r.left),
                    c = s / (s + r.top + r.bottom);
                return i = i * l + r.left, b = 0 == r.right ? b : b * l, a = a * c + r.top, T *= c, t.nodes.forEach(function (t) {
                  t.x0 = i + t.column * ((b - i - M) / n), t.x1 = t.x0 + M;
                }), c;
              }(o, u);

              l *= f, o.links.forEach(function (t) {
                t.width = t.value * l;
              }), c.forEach(function (t) {
                var e = t.length;
                t.forEach(function (t, n) {
                  t.depth == c.length - 1 && 1 == e || 0 == t.depth && 1 == e ? (t.y0 = T / 2 - t.value * l, t.y1 = t.y0 + t.value * l) : t.partOfCycle ? 0 == k(t, r) ? (t.y0 = T / 2 + n, t.y1 = t.y0 + t.value * l) : "top" == t.circularLinkType ? (t.y0 = a + n, t.y1 = t.y0 + t.value * l) : (t.y0 = T - t.value * l - n, t.y1 = t.y0 + t.value * l) : 0 == u.top || 0 == u.bottom ? (t.y0 = (T - a) / e * n, t.y1 = t.y0 + t.value * l) : (t.y0 = (T - a) / 2 - e / 2 + n, t.y1 = t.y0 + t.value * l);
                });
              });
            }(l), y();

            for (var u = 1, g = s; g > 0; --g) {
              v(u *= .99, l), y();
            }

            function v(t, r) {
              var n = c.length;
              c.forEach(function (i) {
                var a = i.length,
                    o = i[0].depth;
                i.forEach(function (i) {
                  var s;
                  if (i.sourceLinks.length || i.targetLinks.length) if (i.partOfCycle && k(i, r) > 0) ;else if (0 == o && 1 == a) s = i.y1 - i.y0, i.y0 = T / 2 - s / 2, i.y1 = T / 2 + s / 2;else if (o == n - 1 && 1 == a) s = i.y1 - i.y0, i.y0 = T / 2 - s / 2, i.y1 = T / 2 + s / 2;else {
                    var l = e.mean(i.sourceLinks, m),
                        c = e.mean(i.targetLinks, d),
                        u = ((l && c ? (l + c) / 2 : l || c) - p(i)) * t;
                    i.y0 += u, i.y1 += u;
                  }
                });
              });
            }

            function y() {
              c.forEach(function (e) {
                var r,
                    n,
                    i,
                    o = a,
                    s = e.length;

                for (e.sort(f), i = 0; i < s; ++i) {
                  (n = o - (r = e[i]).y0) > 0 && (r.y0 += n, r.y1 += n), o = r.y1 + t;
                }

                if ((n = o - t - T) > 0) for (o = r.y0 -= n, r.y1 -= n, i = s - 2; i >= 0; --i) {
                  (n = (r = e[i]).y1 + t - o) > 0 && (r.y0 -= n, r.y1 -= n), o = r.y0;
                }
              });
            }
          }

          function V(t) {
            t.nodes.forEach(function (t) {
              t.sourceLinks.sort(u), t.targetLinks.sort(c);
            }), t.nodes.forEach(function (t) {
              var e = t.y0,
                  r = e,
                  n = t.y1,
                  i = n;
              t.sourceLinks.forEach(function (t) {
                t.circular ? (t.y0 = n - t.width / 2, n -= t.width) : (t.y0 = e + t.width / 2, e += t.width);
              }), t.targetLinks.forEach(function (t) {
                t.circular ? (t.y1 = i - t.width / 2, i -= t.width) : (t.y1 = r + t.width / 2, r += t.width);
              });
            });
          }

          return z.nodeId = function (t) {
            return arguments.length ? (A = "function" == typeof t ? t : s(t), z) : A;
          }, z.nodeAlign = function (t) {
            return arguments.length ? (E = "function" == typeof t ? t : s(t), z) : E;
          }, z.nodeWidth = function (t) {
            return arguments.length ? (M = +t, z) : M;
          }, z.nodePadding = function (e) {
            return arguments.length ? (t = +e, z) : t;
          }, z.nodes = function (t) {
            return arguments.length ? (L = "function" == typeof t ? t : s(t), z) : L;
          }, z.links = function (t) {
            return arguments.length ? (C = "function" == typeof t ? t : s(t), z) : C;
          }, z.size = function (t) {
            return arguments.length ? (i = a = 0, b = +t[0], T = +t[1], z) : [b - i, T - a];
          }, z.extent = function (t) {
            return arguments.length ? (i = +t[0][0], b = +t[1][0], a = +t[0][1], T = +t[1][1], z) : [[i, a], [b, T]];
          }, z.iterations = function (t) {
            return arguments.length ? (P = +t, z) : P;
          }, z.circularLinkGap = function (t) {
            return arguments.length ? (I = +t, z) : I;
          }, z.nodePaddingRatio = function (t) {
            return arguments.length ? (n = +t, z) : n;
          }, z.sortNodes = function (t) {
            return arguments.length ? (O = t, z) : O;
          }, z.update = function (t) {
            return w(t, A), V(t), t.links.forEach(function (t) {
              t.circular && (t.circularLinkType = t.y0 + t.y1 < T ? "top" : "bottom", t.source.circularLinkType = t.circularLinkType, t.target.circularLinkType = t.circularLinkType);
            }), j(t, T, A, !1), U(t, T, A), S(t, I, T, A), t;
          }, z;
        }, t.sankeyCenter = function (t) {
          return t.targetLinks.length ? t.depth : t.sourceLinks.length ? e.min(t.sourceLinks, a) - 1 : 0;
        }, t.sankeyLeft = function (t) {
          return t.depth;
        }, t.sankeyRight = function (t, e) {
          return e - 1 - t.height;
        }, t.sankeyJustify = o, Object.defineProperty(t, "__esModule", {
          value: !0
        });
      });
    }, {
      "d3-array": 157,
      "d3-collection": 158,
      "d3-shape": 166,
      "elementary-circuits-directed-graph": 179
    }],
    56: [function (t, e, r) {
      !function (n, i) {
        "object" == _typeof(r) && void 0 !== e ? i(r, t("d3-array"), t("d3-collection"), t("d3-shape")) : i(n.d3 = n.d3 || {}, n.d3, n.d3, n.d3);
      }(this, function (t, e, r, n) {
        "use strict";

        function i(t) {
          return t.target.depth;
        }

        function a(t, e) {
          return t.sourceLinks.length ? t.depth : e - 1;
        }

        function o(t) {
          return function () {
            return t;
          };
        }

        function s(t, e) {
          return c(t.source, e.source) || t.index - e.index;
        }

        function l(t, e) {
          return c(t.target, e.target) || t.index - e.index;
        }

        function c(t, e) {
          return t.y0 - e.y0;
        }

        function u(t) {
          return t.value;
        }

        function f(t) {
          return (t.y0 + t.y1) / 2;
        }

        function h(t) {
          return f(t.source) * t.value;
        }

        function p(t) {
          return f(t.target) * t.value;
        }

        function d(t) {
          return t.index;
        }

        function m(t) {
          return t.nodes;
        }

        function g(t) {
          return t.links;
        }

        function v(t, e) {
          var r = t.get(e);
          if (!r) throw new Error("missing: " + e);
          return r;
        }

        function y(t) {
          return [t.source.x1, t.y0];
        }

        function x(t) {
          return [t.target.x0, t.y1];
        }

        t.sankey = function () {
          var t = 0,
              n = 0,
              i = 1,
              y = 1,
              x = 24,
              b = 8,
              _ = d,
              w = a,
              T = m,
              k = g,
              M = 32;

          function A() {
            var t = {
              nodes: T.apply(null, arguments),
              links: k.apply(null, arguments)
            };
            return S(t), E(t), L(t), C(t), P(t), t;
          }

          function S(t) {
            t.nodes.forEach(function (t, e) {
              t.index = e, t.sourceLinks = [], t.targetLinks = [];
            });
            var e = r.map(t.nodes, _);
            t.links.forEach(function (t, r) {
              t.index = r;
              var n = t.source,
                  i = t.target;
              "object" != _typeof(n) && (n = t.source = v(e, n)), "object" != _typeof(i) && (i = t.target = v(e, i)), n.sourceLinks.push(t), i.targetLinks.push(t);
            });
          }

          function E(t) {
            t.nodes.forEach(function (t) {
              t.value = Math.max(e.sum(t.sourceLinks, u), e.sum(t.targetLinks, u));
            });
          }

          function L(e) {
            var r, n, a;

            for (r = e.nodes, n = [], a = 0; r.length; ++a, r = n, n = []) {
              r.forEach(function (t) {
                t.depth = a, t.sourceLinks.forEach(function (t) {
                  n.indexOf(t.target) < 0 && n.push(t.target);
                });
              });
            }

            for (r = e.nodes, n = [], a = 0; r.length; ++a, r = n, n = []) {
              r.forEach(function (t) {
                t.height = a, t.targetLinks.forEach(function (t) {
                  n.indexOf(t.source) < 0 && n.push(t.source);
                });
              });
            }

            var o = (i - t - x) / (a - 1);
            e.nodes.forEach(function (e) {
              e.x1 = (e.x0 = t + Math.max(0, Math.min(a - 1, Math.floor(w.call(null, e, a)))) * o) + x;
            });
          }

          function C(t) {
            var i = r.nest().key(function (t) {
              return t.x0;
            }).sortKeys(e.ascending).entries(t.nodes).map(function (t) {
              return t.values;
            });
            !function () {
              var r = e.max(i, function (t) {
                return t.length;
              }),
                  a = 2 / 3 * (y - n) / (r - 1);
              b > a && (b = a);
              var o = e.min(i, function (t) {
                return (y - n - (t.length - 1) * b) / e.sum(t, u);
              });
              i.forEach(function (t) {
                t.forEach(function (t, e) {
                  t.y1 = (t.y0 = e) + t.value * o;
                });
              }), t.links.forEach(function (t) {
                t.width = t.value * o;
              });
            }(), d();

            for (var a = 1, o = M; o > 0; --o) {
              l(a *= .99), d(), s(a), d();
            }

            function s(t) {
              i.forEach(function (r) {
                r.forEach(function (r) {
                  if (r.targetLinks.length) {
                    var n = (e.sum(r.targetLinks, h) / e.sum(r.targetLinks, u) - f(r)) * t;
                    r.y0 += n, r.y1 += n;
                  }
                });
              });
            }

            function l(t) {
              i.slice().reverse().forEach(function (r) {
                r.forEach(function (r) {
                  if (r.sourceLinks.length) {
                    var n = (e.sum(r.sourceLinks, p) / e.sum(r.sourceLinks, u) - f(r)) * t;
                    r.y0 += n, r.y1 += n;
                  }
                });
              });
            }

            function d() {
              i.forEach(function (t) {
                var e,
                    r,
                    i,
                    a = n,
                    o = t.length;

                for (t.sort(c), i = 0; i < o; ++i) {
                  (r = a - (e = t[i]).y0) > 0 && (e.y0 += r, e.y1 += r), a = e.y1 + b;
                }

                if ((r = a - b - y) > 0) for (a = e.y0 -= r, e.y1 -= r, i = o - 2; i >= 0; --i) {
                  (r = (e = t[i]).y1 + b - a) > 0 && (e.y0 -= r, e.y1 -= r), a = e.y0;
                }
              });
            }
          }

          function P(t) {
            t.nodes.forEach(function (t) {
              t.sourceLinks.sort(l), t.targetLinks.sort(s);
            }), t.nodes.forEach(function (t) {
              var e = t.y0,
                  r = e;
              t.sourceLinks.forEach(function (t) {
                t.y0 = e + t.width / 2, e += t.width;
              }), t.targetLinks.forEach(function (t) {
                t.y1 = r + t.width / 2, r += t.width;
              });
            });
          }

          return A.update = function (t) {
            return P(t), t;
          }, A.nodeId = function (t) {
            return arguments.length ? (_ = "function" == typeof t ? t : o(t), A) : _;
          }, A.nodeAlign = function (t) {
            return arguments.length ? (w = "function" == typeof t ? t : o(t), A) : w;
          }, A.nodeWidth = function (t) {
            return arguments.length ? (x = +t, A) : x;
          }, A.nodePadding = function (t) {
            return arguments.length ? (b = +t, A) : b;
          }, A.nodes = function (t) {
            return arguments.length ? (T = "function" == typeof t ? t : o(t), A) : T;
          }, A.links = function (t) {
            return arguments.length ? (k = "function" == typeof t ? t : o(t), A) : k;
          }, A.size = function (e) {
            return arguments.length ? (t = n = 0, i = +e[0], y = +e[1], A) : [i - t, y - n];
          }, A.extent = function (e) {
            return arguments.length ? (t = +e[0][0], i = +e[1][0], n = +e[0][1], y = +e[1][1], A) : [[t, n], [i, y]];
          }, A.iterations = function (t) {
            return arguments.length ? (M = +t, A) : M;
          }, A;
        }, t.sankeyCenter = function (t) {
          return t.targetLinks.length ? t.depth : t.sourceLinks.length ? e.min(t.sourceLinks, i) - 1 : 0;
        }, t.sankeyLeft = function (t) {
          return t.depth;
        }, t.sankeyRight = function (t, e) {
          return e - 1 - t.height;
        }, t.sankeyJustify = a, t.sankeyLinkHorizontal = function () {
          return n.linkHorizontal().source(y).target(x);
        }, Object.defineProperty(t, "__esModule", {
          value: !0
        });
      });
    }, {
      "d3-array": 157,
      "d3-collection": 158,
      "d3-shape": 166
    }],
    57: [function (t, e, r) {
      (function () {
        var t = {
          version: "3.6.0"
        },
            r = [].slice,
            n = function n(t) {
          return r.call(t);
        },
            i = this.document;

        function a(t) {
          return t && (t.ownerDocument || t.document || t).documentElement;
        }

        function o(t) {
          return t && (t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView);
        }

        if (i) try {
          n(i.documentElement.childNodes)[0].nodeType;
        } catch (t) {
          n = function n(t) {
            for (var e = t.length, r = new Array(e); e--;) {
              r[e] = t[e];
            }

            return r;
          };
        }
        if (Date.now || (Date.now = function () {
          return +new Date();
        }), i) try {
          i.createElement("DIV").style.setProperty("opacity", 0, "");
        } catch (t) {
          var s = this.Element.prototype,
              l = s.setAttribute,
              c = s.setAttributeNS,
              u = this.CSSStyleDeclaration.prototype,
              f = u.setProperty;
          s.setAttribute = function (t, e) {
            l.call(this, t, e + "");
          }, s.setAttributeNS = function (t, e, r) {
            c.call(this, t, e, r + "");
          }, u.setProperty = function (t, e, r) {
            f.call(this, t, e + "", r);
          };
        }

        function h(t, e) {
          return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
        }

        function p(t) {
          return null === t ? NaN : +t;
        }

        function d(t) {
          return !isNaN(t);
        }

        function m(t) {
          return {
            left: function left(e, r, n, i) {
              for (arguments.length < 3 && (n = 0), arguments.length < 4 && (i = e.length); n < i;) {
                var a = n + i >>> 1;
                t(e[a], r) < 0 ? n = a + 1 : i = a;
              }

              return n;
            },
            right: function right(e, r, n, i) {
              for (arguments.length < 3 && (n = 0), arguments.length < 4 && (i = e.length); n < i;) {
                var a = n + i >>> 1;
                t(e[a], r) > 0 ? i = a : n = a + 1;
              }

              return n;
            }
          };
        }

        t.ascending = h, t.descending = function (t, e) {
          return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
        }, t.min = function (t, e) {
          var r,
              n,
              i = -1,
              a = t.length;

          if (1 === arguments.length) {
            for (; ++i < a;) {
              if (null != (n = t[i]) && n >= n) {
                r = n;
                break;
              }
            }

            for (; ++i < a;) {
              null != (n = t[i]) && r > n && (r = n);
            }
          } else {
            for (; ++i < a;) {
              if (null != (n = e.call(t, t[i], i)) && n >= n) {
                r = n;
                break;
              }
            }

            for (; ++i < a;) {
              null != (n = e.call(t, t[i], i)) && r > n && (r = n);
            }
          }

          return r;
        }, t.max = function (t, e) {
          var r,
              n,
              i = -1,
              a = t.length;

          if (1 === arguments.length) {
            for (; ++i < a;) {
              if (null != (n = t[i]) && n >= n) {
                r = n;
                break;
              }
            }

            for (; ++i < a;) {
              null != (n = t[i]) && n > r && (r = n);
            }
          } else {
            for (; ++i < a;) {
              if (null != (n = e.call(t, t[i], i)) && n >= n) {
                r = n;
                break;
              }
            }

            for (; ++i < a;) {
              null != (n = e.call(t, t[i], i)) && n > r && (r = n);
            }
          }

          return r;
        }, t.extent = function (t, e) {
          var r,
              n,
              i,
              a = -1,
              o = t.length;

          if (1 === arguments.length) {
            for (; ++a < o;) {
              if (null != (n = t[a]) && n >= n) {
                r = i = n;
                break;
              }
            }

            for (; ++a < o;) {
              null != (n = t[a]) && (r > n && (r = n), i < n && (i = n));
            }
          } else {
            for (; ++a < o;) {
              if (null != (n = e.call(t, t[a], a)) && n >= n) {
                r = i = n;
                break;
              }
            }

            for (; ++a < o;) {
              null != (n = e.call(t, t[a], a)) && (r > n && (r = n), i < n && (i = n));
            }
          }

          return [r, i];
        }, t.sum = function (t, e) {
          var r,
              n = 0,
              i = t.length,
              a = -1;
          if (1 === arguments.length) for (; ++a < i;) {
            d(r = +t[a]) && (n += r);
          } else for (; ++a < i;) {
            d(r = +e.call(t, t[a], a)) && (n += r);
          }
          return n;
        }, t.mean = function (t, e) {
          var r,
              n = 0,
              i = t.length,
              a = -1,
              o = i;
          if (1 === arguments.length) for (; ++a < i;) {
            d(r = p(t[a])) ? n += r : --o;
          } else for (; ++a < i;) {
            d(r = p(e.call(t, t[a], a))) ? n += r : --o;
          }
          if (o) return n / o;
        }, t.quantile = function (t, e) {
          var r = (t.length - 1) * e + 1,
              n = Math.floor(r),
              i = +t[n - 1],
              a = r - n;
          return a ? i + a * (t[n] - i) : i;
        }, t.median = function (e, r) {
          var n,
              i = [],
              a = e.length,
              o = -1;
          if (1 === arguments.length) for (; ++o < a;) {
            d(n = p(e[o])) && i.push(n);
          } else for (; ++o < a;) {
            d(n = p(r.call(e, e[o], o))) && i.push(n);
          }
          if (i.length) return t.quantile(i.sort(h), .5);
        }, t.variance = function (t, e) {
          var r,
              n,
              i = t.length,
              a = 0,
              o = 0,
              s = -1,
              l = 0;
          if (1 === arguments.length) for (; ++s < i;) {
            d(r = p(t[s])) && (o += (n = r - a) * (r - (a += n / ++l)));
          } else for (; ++s < i;) {
            d(r = p(e.call(t, t[s], s))) && (o += (n = r - a) * (r - (a += n / ++l)));
          }
          if (l > 1) return o / (l - 1);
        }, t.deviation = function () {
          var e = t.variance.apply(this, arguments);
          return e ? Math.sqrt(e) : e;
        };
        var g = m(h);

        function v(t) {
          return t.length;
        }

        t.bisectLeft = g.left, t.bisect = t.bisectRight = g.right, t.bisector = function (t) {
          return m(1 === t.length ? function (e, r) {
            return h(t(e), r);
          } : t);
        }, t.shuffle = function (t, e, r) {
          (a = arguments.length) < 3 && (r = t.length, a < 2 && (e = 0));

          for (var n, i, a = r - e; a;) {
            i = Math.random() * a-- | 0, n = t[a + e], t[a + e] = t[i + e], t[i + e] = n;
          }

          return t;
        }, t.permute = function (t, e) {
          for (var r = e.length, n = new Array(r); r--;) {
            n[r] = t[e[r]];
          }

          return n;
        }, t.pairs = function (t) {
          for (var e = 0, r = t.length - 1, n = t[0], i = new Array(r < 0 ? 0 : r); e < r;) {
            i[e] = [n, n = t[++e]];
          }

          return i;
        }, t.transpose = function (e) {
          if (!(a = e.length)) return [];

          for (var r = -1, n = t.min(e, v), i = new Array(n); ++r < n;) {
            for (var a, o = -1, s = i[r] = new Array(a); ++o < a;) {
              s[o] = e[o][r];
            }
          }

          return i;
        }, t.zip = function () {
          return t.transpose(arguments);
        }, t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e;
        }, t.values = function (t) {
          var e = [];

          for (var r in t) {
            e.push(t[r]);
          }

          return e;
        }, t.entries = function (t) {
          var e = [];

          for (var r in t) {
            e.push({
              key: r,
              value: t[r]
            });
          }

          return e;
        }, t.merge = function (t) {
          for (var e, r, n, i = t.length, a = -1, o = 0; ++a < i;) {
            o += t[a].length;
          }

          for (r = new Array(o); --i >= 0;) {
            for (e = (n = t[i]).length; --e >= 0;) {
              r[--o] = n[e];
            }
          }

          return r;
        };
        var y = Math.abs;

        function x(t) {
          for (var e = 1; t * e % 1;) {
            e *= 10;
          }

          return e;
        }

        function b(t, e) {
          for (var r in e) {
            Object.defineProperty(t.prototype, r, {
              value: e[r],
              enumerable: !1
            });
          }
        }

        function _() {
          this._ = Object.create(null);
        }

        t.range = function (t, e, r) {
          if (arguments.length < 3 && (r = 1, arguments.length < 2 && (e = t, t = 0)), (e - t) / r == 1 / 0) throw new Error("infinite range");
          var n,
              i = [],
              a = x(y(r)),
              o = -1;
          if (t *= a, e *= a, (r *= a) < 0) for (; (n = t + r * ++o) > e;) {
            i.push(n / a);
          } else for (; (n = t + r * ++o) < e;) {
            i.push(n / a);
          }
          return i;
        }, t.map = function (t, e) {
          var r = new _();
          if (t instanceof _) t.forEach(function (t, e) {
            r.set(t, e);
          });else if (Array.isArray(t)) {
            var n,
                i = -1,
                a = t.length;
            if (1 === arguments.length) for (; ++i < a;) {
              r.set(i, t[i]);
            } else for (; ++i < a;) {
              r.set(e.call(t, n = t[i], i), n);
            }
          } else for (var o in t) {
            r.set(o, t[o]);
          }
          return r;
        };

        function w(t) {
          return "__proto__" == (t += "") || "\0" === t[0] ? "\0" + t : t;
        }

        function T(t) {
          return "\0" === (t += "")[0] ? t.slice(1) : t;
        }

        function k(t) {
          return w(t) in this._;
        }

        function M(t) {
          return (t = w(t)) in this._ && delete this._[t];
        }

        function A() {
          var t = [];

          for (var e in this._) {
            t.push(T(e));
          }

          return t;
        }

        function S() {
          var t = 0;

          for (var e in this._) {
            ++t;
          }

          return t;
        }

        function E() {
          for (var t in this._) {
            return !1;
          }

          return !0;
        }

        function L() {
          this._ = Object.create(null);
        }

        function C(t) {
          return t;
        }

        function P(t, e, r) {
          return function () {
            var n = r.apply(e, arguments);
            return n === e ? t : n;
          };
        }

        function I(t, e) {
          if (e in t) return e;
          e = e.charAt(0).toUpperCase() + e.slice(1);

          for (var r = 0, n = O.length; r < n; ++r) {
            var i = O[r] + e;
            if (i in t) return i;
          }
        }

        b(_, {
          has: k,
          get: function get(t) {
            return this._[w(t)];
          },
          set: function set(t, e) {
            return this._[w(t)] = e;
          },
          remove: M,
          keys: A,
          values: function values() {
            var t = [];

            for (var e in this._) {
              t.push(this._[e]);
            }

            return t;
          },
          entries: function entries() {
            var t = [];

            for (var e in this._) {
              t.push({
                key: T(e),
                value: this._[e]
              });
            }

            return t;
          },
          size: S,
          empty: E,
          forEach: function forEach(t) {
            for (var e in this._) {
              t.call(this, T(e), this._[e]);
            }
          }
        }), t.nest = function () {
          var e,
              r,
              n = {},
              i = [],
              a = [];

          function o(t, a, s) {
            if (s >= i.length) return r ? r.call(n, a) : e ? a.sort(e) : a;

            for (var l, c, u, f, h = -1, p = a.length, d = i[s++], m = new _(); ++h < p;) {
              (f = m.get(l = d(c = a[h]))) ? f.push(c) : m.set(l, [c]);
            }

            return t ? (c = t(), u = function u(e, r) {
              c.set(e, o(t, r, s));
            }) : (c = {}, u = function u(e, r) {
              c[e] = o(t, r, s);
            }), m.forEach(u), c;
          }

          return n.map = function (t, e) {
            return o(e, t, 0);
          }, n.entries = function (e) {
            return function t(e, r) {
              if (r >= i.length) return e;
              var n = [],
                  o = a[r++];
              return e.forEach(function (e, i) {
                n.push({
                  key: e,
                  values: t(i, r)
                });
              }), o ? n.sort(function (t, e) {
                return o(t.key, e.key);
              }) : n;
            }(o(t.map, e, 0), 0);
          }, n.key = function (t) {
            return i.push(t), n;
          }, n.sortKeys = function (t) {
            return a[i.length - 1] = t, n;
          }, n.sortValues = function (t) {
            return e = t, n;
          }, n.rollup = function (t) {
            return r = t, n;
          }, n;
        }, t.set = function (t) {
          var e = new L();
          if (t) for (var r = 0, n = t.length; r < n; ++r) {
            e.add(t[r]);
          }
          return e;
        }, b(L, {
          has: k,
          add: function add(t) {
            return this._[w(t += "")] = !0, t;
          },
          remove: M,
          values: A,
          size: S,
          empty: E,
          forEach: function forEach(t) {
            for (var e in this._) {
              t.call(this, T(e));
            }
          }
        }), t.behavior = {}, t.rebind = function (t, e) {
          for (var r, n = 1, i = arguments.length; ++n < i;) {
            t[r = arguments[n]] = P(t, e, e[r]);
          }

          return t;
        };
        var O = ["webkit", "ms", "moz", "Moz", "o", "O"];

        function z() {}

        function D() {}

        function R(t) {
          var e = [],
              r = new _();

          function n() {
            for (var r, n = e, i = -1, a = n.length; ++i < a;) {
              (r = n[i].on) && r.apply(this, arguments);
            }

            return t;
          }

          return n.on = function (n, i) {
            var a,
                o = r.get(n);
            return arguments.length < 2 ? o && o.on : (o && (o.on = null, e = e.slice(0, a = e.indexOf(o)).concat(e.slice(a + 1)), r.remove(n)), i && e.push(r.set(n, {
              on: i
            })), t);
          }, n;
        }

        function F() {
          t.event.preventDefault();
        }

        function B() {
          for (var e, r = t.event; e = r.sourceEvent;) {
            r = e;
          }

          return r;
        }

        function N(e) {
          for (var r = new D(), n = 0, i = arguments.length; ++n < i;) {
            r[arguments[n]] = R(r);
          }

          return r.of = function (n, i) {
            return function (a) {
              try {
                var o = a.sourceEvent = t.event;
                a.target = e, t.event = a, r[a.type].apply(n, i);
              } finally {
                t.event = o;
              }
            };
          }, r;
        }

        t.dispatch = function () {
          for (var t = new D(), e = -1, r = arguments.length; ++e < r;) {
            t[arguments[e]] = R(t);
          }

          return t;
        }, D.prototype.on = function (t, e) {
          var r = t.indexOf("."),
              n = "";
          if (r >= 0 && (n = t.slice(r + 1), t = t.slice(0, r)), t) return arguments.length < 2 ? this[t].on(n) : this[t].on(n, e);

          if (2 === arguments.length) {
            if (null == e) for (t in this) {
              this.hasOwnProperty(t) && this[t].on(n, null);
            }
            return this;
          }
        }, t.event = null, t.requote = function (t) {
          return t.replace(j, "\\$&");
        };
        var j = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g,
            U = {}.__proto__ ? function (t, e) {
          t.__proto__ = e;
        } : function (t, e) {
          for (var r in e) {
            t[r] = e[r];
          }
        };

        function V(t) {
          return U(t, Y), t;
        }

        var q = function q(t, e) {
          return e.querySelector(t);
        },
            H = function H(t, e) {
          return e.querySelectorAll(t);
        },
            _G = function G(t, e) {
          var r = t.matches || t[I(t, "matchesSelector")];
          return (_G = function G(t, e) {
            return r.call(t, e);
          })(t, e);
        };

        "function" == typeof Sizzle && (q = function q(t, e) {
          return Sizzle(t, e)[0] || null;
        }, H = Sizzle, _G = Sizzle.matchesSelector), t.selection = function () {
          return t.select(i.documentElement);
        };
        var Y = t.selection.prototype = [];

        function W(t) {
          return "function" == typeof t ? t : function () {
            return q(t, this);
          };
        }

        function X(t) {
          return "function" == typeof t ? t : function () {
            return H(t, this);
          };
        }

        Y.select = function (t) {
          var e,
              r,
              n,
              i,
              a = [];
          t = W(t);

          for (var o = -1, s = this.length; ++o < s;) {
            a.push(e = []), e.parentNode = (n = this[o]).parentNode;

            for (var l = -1, c = n.length; ++l < c;) {
              (i = n[l]) ? (e.push(r = t.call(i, i.__data__, l, o)), r && "__data__" in i && (r.__data__ = i.__data__)) : e.push(null);
            }
          }

          return V(a);
        }, Y.selectAll = function (t) {
          var e,
              r,
              i = [];
          t = X(t);

          for (var a = -1, o = this.length; ++a < o;) {
            for (var s = this[a], l = -1, c = s.length; ++l < c;) {
              (r = s[l]) && (i.push(e = n(t.call(r, r.__data__, l, a))), e.parentNode = r);
            }
          }

          return V(i);
        };
        var Z = "http://www.w3.org/1999/xhtml",
            J = {
          svg: "http://www.w3.org/2000/svg",
          xhtml: Z,
          xlink: "http://www.w3.org/1999/xlink",
          xml: "http://www.w3.org/XML/1998/namespace",
          xmlns: "http://www.w3.org/2000/xmlns/"
        };

        function K(e, r) {
          return e = t.ns.qualify(e), null == r ? e.local ? function () {
            this.removeAttributeNS(e.space, e.local);
          } : function () {
            this.removeAttribute(e);
          } : "function" == typeof r ? e.local ? function () {
            var t = r.apply(this, arguments);
            null == t ? this.removeAttributeNS(e.space, e.local) : this.setAttributeNS(e.space, e.local, t);
          } : function () {
            var t = r.apply(this, arguments);
            null == t ? this.removeAttribute(e) : this.setAttribute(e, t);
          } : e.local ? function () {
            this.setAttributeNS(e.space, e.local, r);
          } : function () {
            this.setAttribute(e, r);
          };
        }

        function Q(t) {
          return t.trim().replace(/\s+/g, " ");
        }

        function $(e) {
          return new RegExp("(?:^|\\s+)" + t.requote(e) + "(?:\\s+|$)", "g");
        }

        function tt(t) {
          return (t + "").trim().split(/^|\s+/);
        }

        function et(t, e) {
          var r = (t = tt(t).map(rt)).length;
          return "function" == typeof e ? function () {
            for (var n = -1, i = e.apply(this, arguments); ++n < r;) {
              t[n](this, i);
            }
          } : function () {
            for (var n = -1; ++n < r;) {
              t[n](this, e);
            }
          };
        }

        function rt(t) {
          var e = $(t);
          return function (r, n) {
            if (i = r.classList) return n ? i.add(t) : i.remove(t);
            var i = r.getAttribute("class") || "";
            n ? (e.lastIndex = 0, e.test(i) || r.setAttribute("class", Q(i + " " + t))) : r.setAttribute("class", Q(i.replace(e, " ")));
          };
        }

        function nt(t, e, r) {
          return null == e ? function () {
            this.style.removeProperty(t);
          } : "function" == typeof e ? function () {
            var n = e.apply(this, arguments);
            null == n ? this.style.removeProperty(t) : this.style.setProperty(t, n, r);
          } : function () {
            this.style.setProperty(t, e, r);
          };
        }

        function it(t, e) {
          return null == e ? function () {
            delete this[t];
          } : "function" == typeof e ? function () {
            var r = e.apply(this, arguments);
            null == r ? delete this[t] : this[t] = r;
          } : function () {
            this[t] = e;
          };
        }

        function at(e) {
          return "function" == typeof e ? e : (e = t.ns.qualify(e)).local ? function () {
            return this.ownerDocument.createElementNS(e.space, e.local);
          } : function () {
            var t = this.ownerDocument,
                r = this.namespaceURI;
            return r === Z && t.documentElement.namespaceURI === Z ? t.createElement(e) : t.createElementNS(r, e);
          };
        }

        function ot() {
          var t = this.parentNode;
          t && t.removeChild(this);
        }

        function st(t) {
          return {
            __data__: t
          };
        }

        function lt(t) {
          return function () {
            return _G(this, t);
          };
        }

        function ct(t) {
          return arguments.length || (t = h), function (e, r) {
            return e && r ? t(e.__data__, r.__data__) : !e - !r;
          };
        }

        function ut(t, e) {
          for (var r = 0, n = t.length; r < n; r++) {
            for (var i, a = t[r], o = 0, s = a.length; o < s; o++) {
              (i = a[o]) && e(i, o, r);
            }
          }

          return t;
        }

        function ft(t) {
          return U(t, ht), t;
        }

        t.ns = {
          prefix: J,
          qualify: function qualify(t) {
            var e = t.indexOf(":"),
                r = t;
            return e >= 0 && "xmlns" !== (r = t.slice(0, e)) && (t = t.slice(e + 1)), J.hasOwnProperty(r) ? {
              space: J[r],
              local: t
            } : t;
          }
        }, Y.attr = function (e, r) {
          if (arguments.length < 2) {
            if ("string" == typeof e) {
              var n = this.node();
              return (e = t.ns.qualify(e)).local ? n.getAttributeNS(e.space, e.local) : n.getAttribute(e);
            }

            for (r in e) {
              this.each(K(r, e[r]));
            }

            return this;
          }

          return this.each(K(e, r));
        }, Y.classed = function (t, e) {
          if (arguments.length < 2) {
            if ("string" == typeof t) {
              var r = this.node(),
                  n = (t = tt(t)).length,
                  i = -1;

              if (e = r.classList) {
                for (; ++i < n;) {
                  if (!e.contains(t[i])) return !1;
                }
              } else for (e = r.getAttribute("class"); ++i < n;) {
                if (!$(t[i]).test(e)) return !1;
              }

              return !0;
            }

            for (e in t) {
              this.each(et(e, t[e]));
            }

            return this;
          }

          return this.each(et(t, e));
        }, Y.style = function (t, e, r) {
          var n = arguments.length;

          if (n < 3) {
            if ("string" != typeof t) {
              for (r in n < 2 && (e = ""), t) {
                this.each(nt(r, t[r], e));
              }

              return this;
            }

            if (n < 2) {
              var i = this.node();
              return o(i).getComputedStyle(i, null).getPropertyValue(t);
            }

            r = "";
          }

          return this.each(nt(t, e, r));
        }, Y.property = function (t, e) {
          if (arguments.length < 2) {
            if ("string" == typeof t) return this.node()[t];

            for (e in t) {
              this.each(it(e, t[e]));
            }

            return this;
          }

          return this.each(it(t, e));
        }, Y.text = function (t) {
          return arguments.length ? this.each("function" == typeof t ? function () {
            var e = t.apply(this, arguments);
            this.textContent = null == e ? "" : e;
          } : null == t ? function () {
            this.textContent = "";
          } : function () {
            this.textContent = t;
          }) : this.node().textContent;
        }, Y.html = function (t) {
          return arguments.length ? this.each("function" == typeof t ? function () {
            var e = t.apply(this, arguments);
            this.innerHTML = null == e ? "" : e;
          } : null == t ? function () {
            this.innerHTML = "";
          } : function () {
            this.innerHTML = t;
          }) : this.node().innerHTML;
        }, Y.append = function (t) {
          return t = at(t), this.select(function () {
            return this.appendChild(t.apply(this, arguments));
          });
        }, Y.insert = function (t, e) {
          return t = at(t), e = W(e), this.select(function () {
            return this.insertBefore(t.apply(this, arguments), e.apply(this, arguments) || null);
          });
        }, Y.remove = function () {
          return this.each(ot);
        }, Y.data = function (t, e) {
          var r,
              n,
              i = -1,
              a = this.length;

          if (!arguments.length) {
            for (t = new Array(a = (r = this[0]).length); ++i < a;) {
              (n = r[i]) && (t[i] = n.__data__);
            }

            return t;
          }

          function o(t, r) {
            var n,
                i,
                a,
                o = t.length,
                u = r.length,
                f = Math.min(o, u),
                h = new Array(u),
                p = new Array(u),
                d = new Array(o);

            if (e) {
              var m,
                  g = new _(),
                  v = new Array(o);

              for (n = -1; ++n < o;) {
                (i = t[n]) && (g.has(m = e.call(i, i.__data__, n)) ? d[n] = i : g.set(m, i), v[n] = m);
              }

              for (n = -1; ++n < u;) {
                (i = g.get(m = e.call(r, a = r[n], n))) ? !0 !== i && (h[n] = i, i.__data__ = a) : p[n] = st(a), g.set(m, !0);
              }

              for (n = -1; ++n < o;) {
                n in v && !0 !== g.get(v[n]) && (d[n] = t[n]);
              }
            } else {
              for (n = -1; ++n < f;) {
                i = t[n], a = r[n], i ? (i.__data__ = a, h[n] = i) : p[n] = st(a);
              }

              for (; n < u; ++n) {
                p[n] = st(r[n]);
              }

              for (; n < o; ++n) {
                d[n] = t[n];
              }
            }

            p.update = h, p.parentNode = h.parentNode = d.parentNode = t.parentNode, s.push(p), l.push(h), c.push(d);
          }

          var s = ft([]),
              l = V([]),
              c = V([]);
          if ("function" == typeof t) for (; ++i < a;) {
            o(r = this[i], t.call(r, r.parentNode.__data__, i));
          } else for (; ++i < a;) {
            o(r = this[i], t);
          }
          return l.enter = function () {
            return s;
          }, l.exit = function () {
            return c;
          }, l;
        }, Y.datum = function (t) {
          return arguments.length ? this.property("__data__", t) : this.property("__data__");
        }, Y.filter = function (t) {
          var e,
              r,
              n,
              i = [];
          "function" != typeof t && (t = lt(t));

          for (var a = 0, o = this.length; a < o; a++) {
            i.push(e = []), e.parentNode = (r = this[a]).parentNode;

            for (var s = 0, l = r.length; s < l; s++) {
              (n = r[s]) && t.call(n, n.__data__, s, a) && e.push(n);
            }
          }

          return V(i);
        }, Y.order = function () {
          for (var t = -1, e = this.length; ++t < e;) {
            for (var r, n = this[t], i = n.length - 1, a = n[i]; --i >= 0;) {
              (r = n[i]) && (a && a !== r.nextSibling && a.parentNode.insertBefore(r, a), a = r);
            }
          }

          return this;
        }, Y.sort = function (t) {
          t = ct.apply(this, arguments);

          for (var e = -1, r = this.length; ++e < r;) {
            this[e].sort(t);
          }

          return this.order();
        }, Y.each = function (t) {
          return ut(this, function (e, r, n) {
            t.call(e, e.__data__, r, n);
          });
        }, Y.call = function (t) {
          var e = n(arguments);
          return t.apply(e[0] = this, e), this;
        }, Y.empty = function () {
          return !this.node();
        }, Y.node = function () {
          for (var t = 0, e = this.length; t < e; t++) {
            for (var r = this[t], n = 0, i = r.length; n < i; n++) {
              var a = r[n];
              if (a) return a;
            }
          }

          return null;
        }, Y.size = function () {
          var t = 0;
          return ut(this, function () {
            ++t;
          }), t;
        };
        var ht = [];

        function pt(t) {
          var e, r;
          return function (n, i, a) {
            var o,
                s = t[a].update,
                l = s.length;

            for (a != r && (r = a, e = 0), i >= e && (e = i + 1); !(o = s[e]) && ++e < l;) {
              ;
            }

            return o;
          };
        }

        function dt(e, r, i) {
          var a = "__on" + e,
              o = e.indexOf("."),
              s = gt;
          o > 0 && (e = e.slice(0, o));
          var l = mt.get(e);

          function c() {
            var t = this[a];
            t && (this.removeEventListener(e, t, t.$), delete this[a]);
          }

          return l && (e = l, s = vt), o ? r ? function () {
            var t = s(r, n(arguments));
            c.call(this), this.addEventListener(e, this[a] = t, t.$ = i), t._ = r;
          } : c : r ? z : function () {
            var r,
                n = new RegExp("^__on([^.]+)" + t.requote(e) + "$");

            for (var i in this) {
              if (r = i.match(n)) {
                var a = this[i];
                this.removeEventListener(r[1], a, a.$), delete this[i];
              }
            }
          };
        }

        t.selection.enter = ft, t.selection.enter.prototype = ht, ht.append = Y.append, ht.empty = Y.empty, ht.node = Y.node, ht.call = Y.call, ht.size = Y.size, ht.select = function (t) {
          for (var e, r, n, i, a, o = [], s = -1, l = this.length; ++s < l;) {
            n = (i = this[s]).update, o.push(e = []), e.parentNode = i.parentNode;

            for (var c = -1, u = i.length; ++c < u;) {
              (a = i[c]) ? (e.push(n[c] = r = t.call(i.parentNode, a.__data__, c, s)), r.__data__ = a.__data__) : e.push(null);
            }
          }

          return V(o);
        }, ht.insert = function (t, e) {
          return arguments.length < 2 && (e = pt(this)), Y.insert.call(this, t, e);
        }, t.select = function (t) {
          var e;
          return "string" == typeof t ? (e = [q(t, i)]).parentNode = i.documentElement : (e = [t]).parentNode = a(t), V([e]);
        }, t.selectAll = function (t) {
          var e;
          return "string" == typeof t ? (e = n(H(t, i))).parentNode = i.documentElement : (e = n(t)).parentNode = null, V([e]);
        }, Y.on = function (t, e, r) {
          var n = arguments.length;

          if (n < 3) {
            if ("string" != typeof t) {
              for (r in n < 2 && (e = !1), t) {
                this.each(dt(r, t[r], e));
              }

              return this;
            }

            if (n < 2) return (n = this.node()["__on" + t]) && n._;
            r = !1;
          }

          return this.each(dt(t, e, r));
        };
        var mt = t.map({
          mouseenter: "mouseover",
          mouseleave: "mouseout"
        });

        function gt(e, r) {
          return function (n) {
            var i = t.event;
            t.event = n, r[0] = this.__data__;

            try {
              e.apply(this, r);
            } finally {
              t.event = i;
            }
          };
        }

        function vt(t, e) {
          var r = gt(t, e);
          return function (t) {
            var e = t.relatedTarget;
            e && (e === this || 8 & e.compareDocumentPosition(this)) || r.call(this, t);
          };
        }

        i && mt.forEach(function (t) {
          "on" + t in i && mt.remove(t);
        });
        var yt,
            xt = 0;

        function bt(e) {
          var r = ".dragsuppress-" + ++xt,
              n = "click" + r,
              i = t.select(o(e)).on("touchmove" + r, F).on("dragstart" + r, F).on("selectstart" + r, F);

          if (null == yt && (yt = !("onselectstart" in e) && I(e.style, "userSelect")), yt) {
            var s = a(e).style,
                l = s[yt];
            s[yt] = "none";
          }

          return function (t) {
            if (i.on(r, null), yt && (s[yt] = l), t) {
              var e = function e() {
                i.on(n, null);
              };

              i.on(n, function () {
                F(), e();
              }, !0), setTimeout(e, 0);
            }
          };
        }

        t.mouse = function (t) {
          return wt(t, B());
        };

        var _t = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;

        function wt(e, r) {
          r.changedTouches && (r = r.changedTouches[0]);
          var n = e.ownerSVGElement || e;

          if (n.createSVGPoint) {
            var i = n.createSVGPoint();

            if (_t < 0) {
              var a = o(e);

              if (a.scrollX || a.scrollY) {
                var s = (n = t.select("body").append("svg").style({
                  position: "absolute",
                  top: 0,
                  left: 0,
                  margin: 0,
                  padding: 0,
                  border: "none"
                }, "important"))[0][0].getScreenCTM();
                _t = !(s.f || s.e), n.remove();
              }
            }

            return _t ? (i.x = r.pageX, i.y = r.pageY) : (i.x = r.clientX, i.y = r.clientY), [(i = i.matrixTransform(e.getScreenCTM().inverse())).x, i.y];
          }

          var l = e.getBoundingClientRect();
          return [r.clientX - l.left - e.clientLeft, r.clientY - l.top - e.clientTop];
        }

        function Tt() {
          return t.event.changedTouches[0].identifier;
        }

        t.touch = function (t, e, r) {
          if (arguments.length < 3 && (r = e, e = B().changedTouches), e) for (var n, i = 0, a = e.length; i < a; ++i) {
            if ((n = e[i]).identifier === r) return wt(t, n);
          }
        }, t.behavior.drag = function () {
          var e = N(a, "drag", "dragstart", "dragend"),
              r = null,
              n = s(z, t.mouse, o, "mousemove", "mouseup"),
              i = s(Tt, t.touch, C, "touchmove", "touchend");

          function a() {
            this.on("mousedown.drag", n).on("touchstart.drag", i);
          }

          function s(n, i, a, o, s) {
            return function () {
              var l,
                  c = this,
                  u = t.event.target.correspondingElement || t.event.target,
                  f = c.parentNode,
                  h = e.of(c, arguments),
                  p = 0,
                  d = n(),
                  m = ".drag" + (null == d ? "" : "-" + d),
                  g = t.select(a(u)).on(o + m, x).on(s + m, b),
                  v = bt(u),
                  y = i(f, d);

              function x() {
                var t,
                    e,
                    r = i(f, d);
                r && (t = r[0] - y[0], e = r[1] - y[1], p |= t | e, y = r, h({
                  type: "drag",
                  x: r[0] + l[0],
                  y: r[1] + l[1],
                  dx: t,
                  dy: e
                }));
              }

              function b() {
                i(f, d) && (g.on(o + m, null).on(s + m, null), v(p), h({
                  type: "dragend"
                }));
              }

              l = r ? [(l = r.apply(c, arguments)).x - y[0], l.y - y[1]] : [0, 0], h({
                type: "dragstart"
              });
            };
          }

          return a.origin = function (t) {
            return arguments.length ? (r = t, a) : r;
          }, t.rebind(a, e, "on");
        }, t.touches = function (t, e) {
          return arguments.length < 2 && (e = B().touches), e ? n(e).map(function (e) {
            var r = wt(t, e);
            return r.identifier = e.identifier, r;
          }) : [];
        };
        var kt = 1e-6,
            Mt = 1e-12,
            At = Math.PI,
            St = 2 * At,
            Et = St - kt,
            Lt = At / 2,
            Ct = At / 180,
            Pt = 180 / At;

        function It(t) {
          return t > 0 ? 1 : t < 0 ? -1 : 0;
        }

        function Ot(t, e, r) {
          return (e[0] - t[0]) * (r[1] - t[1]) - (e[1] - t[1]) * (r[0] - t[0]);
        }

        function zt(t) {
          return t > 1 ? 0 : t < -1 ? At : Math.acos(t);
        }

        function Dt(t) {
          return t > 1 ? Lt : t < -1 ? -Lt : Math.asin(t);
        }

        function Rt(t) {
          return ((t = Math.exp(t)) + 1 / t) / 2;
        }

        function Ft(t) {
          return (t = Math.sin(t / 2)) * t;
        }

        var Bt = Math.SQRT2;
        t.interpolateZoom = function (t, e) {
          var r,
              n,
              i = t[0],
              a = t[1],
              o = t[2],
              s = e[0],
              l = e[1],
              c = e[2],
              u = s - i,
              f = l - a,
              h = u * u + f * f;
          if (h < Mt) n = Math.log(c / o) / Bt, r = function r(t) {
            return [i + t * u, a + t * f, o * Math.exp(Bt * t * n)];
          };else {
            var p = Math.sqrt(h),
                d = (c * c - o * o + 4 * h) / (2 * o * 2 * p),
                m = (c * c - o * o - 4 * h) / (2 * c * 2 * p),
                g = Math.log(Math.sqrt(d * d + 1) - d),
                v = Math.log(Math.sqrt(m * m + 1) - m);
            n = (v - g) / Bt, r = function r(t) {
              var e,
                  r = t * n,
                  s = Rt(g),
                  l = o / (2 * p) * (s * (e = Bt * r + g, ((e = Math.exp(2 * e)) - 1) / (e + 1)) - function (t) {
                return ((t = Math.exp(t)) - 1 / t) / 2;
              }(g));

              return [i + l * u, a + l * f, o * s / Rt(Bt * r + g)];
            };
          }
          return r.duration = 1e3 * n, r;
        }, t.behavior.zoom = function () {
          var e,
              r,
              n,
              a,
              s,
              l,
              c,
              u,
              f,
              h = {
            x: 0,
            y: 0,
            k: 1
          },
              p = [960, 500],
              d = Ut,
              m = 250,
              g = 0,
              v = "mousedown.zoom",
              y = "mousemove.zoom",
              x = "mouseup.zoom",
              b = "touchstart.zoom",
              _ = N(w, "zoomstart", "zoom", "zoomend");

          function w(t) {
            t.on(v, P).on(jt + ".zoom", O).on("dblclick.zoom", z).on(b, I);
          }

          function T(t) {
            return [(t[0] - h.x) / h.k, (t[1] - h.y) / h.k];
          }

          function k(t) {
            h.k = Math.max(d[0], Math.min(d[1], t));
          }

          function M(t, e) {
            e = function (t) {
              return [t[0] * h.k + h.x, t[1] * h.k + h.y];
            }(e), h.x += t[0] - e[0], h.y += t[1] - e[1];
          }

          function A(e, n, i, a) {
            e.__chart__ = {
              x: h.x,
              y: h.y,
              k: h.k
            }, k(Math.pow(2, a)), M(r = n, i), e = t.select(e), m > 0 && (e = e.transition().duration(m)), e.call(w.event);
          }

          function S() {
            c && c.domain(l.range().map(function (t) {
              return (t - h.x) / h.k;
            }).map(l.invert)), f && f.domain(u.range().map(function (t) {
              return (t - h.y) / h.k;
            }).map(u.invert));
          }

          function E(t) {
            g++ || t({
              type: "zoomstart"
            });
          }

          function L(t) {
            S(), t({
              type: "zoom",
              scale: h.k,
              translate: [h.x, h.y]
            });
          }

          function C(t) {
            --g || (t({
              type: "zoomend"
            }), r = null);
          }

          function P() {
            var e = this,
                r = _.of(e, arguments),
                n = 0,
                i = t.select(o(e)).on(y, l).on(x, c),
                a = T(t.mouse(e)),
                s = bt(e);

            function l() {
              n = 1, M(t.mouse(e), a), L(r);
            }

            function c() {
              i.on(y, null).on(x, null), s(n), C(r);
            }

            vs.call(e), E(r);
          }

          function I() {
            var e,
                r = this,
                n = _.of(r, arguments),
                i = {},
                a = 0,
                o = ".zoom-" + t.event.changedTouches[0].identifier,
                l = "touchmove" + o,
                c = "touchend" + o,
                u = [],
                f = t.select(r),
                p = bt(r);

            function d() {
              var n = t.touches(r);
              return e = h.k, n.forEach(function (t) {
                t.identifier in i && (i[t.identifier] = T(t));
              }), n;
            }

            function m() {
              var e = t.event.target;
              t.select(e).on(l, g).on(c, y), u.push(e);

              for (var n = t.event.changedTouches, o = 0, f = n.length; o < f; ++o) {
                i[n[o].identifier] = null;
              }

              var p = d(),
                  m = Date.now();

              if (1 === p.length) {
                if (m - s < 500) {
                  var v = p[0];
                  A(r, v, i[v.identifier], Math.floor(Math.log(h.k) / Math.LN2) + 1), F();
                }

                s = m;
              } else if (p.length > 1) {
                v = p[0];

                var x = p[1],
                    b = v[0] - x[0],
                    _ = v[1] - x[1];

                a = b * b + _ * _;
              }
            }

            function g() {
              var o,
                  l,
                  c,
                  u,
                  f = t.touches(r);
              vs.call(r);

              for (var h = 0, p = f.length; h < p; ++h, u = null) {
                if (c = f[h], u = i[c.identifier]) {
                  if (l) break;
                  o = c, l = u;
                }
              }

              if (u) {
                var d = (d = c[0] - o[0]) * d + (d = c[1] - o[1]) * d,
                    m = a && Math.sqrt(d / a);
                o = [(o[0] + c[0]) / 2, (o[1] + c[1]) / 2], l = [(l[0] + u[0]) / 2, (l[1] + u[1]) / 2], k(m * e);
              }

              s = null, M(o, l), L(n);
            }

            function y() {
              if (t.event.touches.length) {
                for (var e = t.event.changedTouches, r = 0, a = e.length; r < a; ++r) {
                  delete i[e[r].identifier];
                }

                for (var s in i) {
                  return void d();
                }
              }

              t.selectAll(u).on(o, null), f.on(v, P).on(b, I), p(), C(n);
            }

            m(), E(n), f.on(v, null).on(b, m);
          }

          function O() {
            var i = _.of(this, arguments);

            a ? clearTimeout(a) : (vs.call(this), e = T(r = n || t.mouse(this)), E(i)), a = setTimeout(function () {
              a = null, C(i);
            }, 50), F(), k(Math.pow(2, .002 * Nt()) * h.k), M(r, e), L(i);
          }

          function z() {
            var e = t.mouse(this),
                r = Math.log(h.k) / Math.LN2;
            A(this, e, T(e), t.event.shiftKey ? Math.ceil(r) - 1 : Math.floor(r) + 1);
          }

          return jt || (jt = "onwheel" in i ? (Nt = function Nt() {
            return -t.event.deltaY * (t.event.deltaMode ? 120 : 1);
          }, "wheel") : "onmousewheel" in i ? (Nt = function Nt() {
            return t.event.wheelDelta;
          }, "mousewheel") : (Nt = function Nt() {
            return -t.event.detail;
          }, "MozMousePixelScroll")), w.event = function (e) {
            e.each(function () {
              var e = _.of(this, arguments),
                  n = h;

              bs ? t.select(this).transition().each("start.zoom", function () {
                h = this.__chart__ || {
                  x: 0,
                  y: 0,
                  k: 1
                }, E(e);
              }).tween("zoom:zoom", function () {
                var i = p[0],
                    a = p[1],
                    o = r ? r[0] : i / 2,
                    s = r ? r[1] : a / 2,
                    l = t.interpolateZoom([(o - h.x) / h.k, (s - h.y) / h.k, i / h.k], [(o - n.x) / n.k, (s - n.y) / n.k, i / n.k]);
                return function (t) {
                  var r = l(t),
                      n = i / r[2];
                  this.__chart__ = h = {
                    x: o - r[0] * n,
                    y: s - r[1] * n,
                    k: n
                  }, L(e);
                };
              }).each("interrupt.zoom", function () {
                C(e);
              }).each("end.zoom", function () {
                C(e);
              }) : (this.__chart__ = h, E(e), L(e), C(e));
            });
          }, w.translate = function (t) {
            return arguments.length ? (h = {
              x: +t[0],
              y: +t[1],
              k: h.k
            }, S(), w) : [h.x, h.y];
          }, w.scale = function (t) {
            return arguments.length ? (h = {
              x: h.x,
              y: h.y,
              k: null
            }, k(+t), S(), w) : h.k;
          }, w.scaleExtent = function (t) {
            return arguments.length ? (d = null == t ? Ut : [+t[0], +t[1]], w) : d;
          }, w.center = function (t) {
            return arguments.length ? (n = t && [+t[0], +t[1]], w) : n;
          }, w.size = function (t) {
            return arguments.length ? (p = t && [+t[0], +t[1]], w) : p;
          }, w.duration = function (t) {
            return arguments.length ? (m = +t, w) : m;
          }, w.x = function (t) {
            return arguments.length ? (c = t, l = t.copy(), h = {
              x: 0,
              y: 0,
              k: 1
            }, w) : c;
          }, w.y = function (t) {
            return arguments.length ? (f = t, u = t.copy(), h = {
              x: 0,
              y: 0,
              k: 1
            }, w) : f;
          }, t.rebind(w, _, "on");
        };
        var Nt,
            jt,
            Ut = [0, 1 / 0];

        function Vt() {}

        function qt(t, e, r) {
          return this instanceof qt ? (this.h = +t, this.s = +e, void (this.l = +r)) : arguments.length < 2 ? t instanceof qt ? new qt(t.h, t.s, t.l) : le("" + t, ce, qt) : new qt(t, e, r);
        }

        t.color = Vt, Vt.prototype.toString = function () {
          return this.rgb() + "";
        }, t.hsl = qt;
        var Ht = qt.prototype = new Vt();

        function Gt(t, e, r) {
          var n, i;

          function a(t) {
            return Math.round(255 * function (t) {
              return t > 360 ? t -= 360 : t < 0 && (t += 360), t < 60 ? n + (i - n) * t / 60 : t < 180 ? i : t < 240 ? n + (i - n) * (240 - t) / 60 : n;
            }(t));
          }

          return t = isNaN(t) ? 0 : (t %= 360) < 0 ? t + 360 : t, e = isNaN(e) || e < 0 ? 0 : e > 1 ? 1 : e, n = 2 * (r = r < 0 ? 0 : r > 1 ? 1 : r) - (i = r <= .5 ? r * (1 + e) : r + e - r * e), new ne(a(t + 120), a(t), a(t - 120));
        }

        function Yt(e, r, n) {
          return this instanceof Yt ? (this.h = +e, this.c = +r, void (this.l = +n)) : arguments.length < 2 ? e instanceof Yt ? new Yt(e.h, e.c, e.l) : $t(e instanceof Zt ? e.l : (e = ue((e = t.rgb(e)).r, e.g, e.b)).l, e.a, e.b) : new Yt(e, r, n);
        }

        Ht.brighter = function (t) {
          return t = Math.pow(.7, arguments.length ? t : 1), new qt(this.h, this.s, this.l / t);
        }, Ht.darker = function (t) {
          return t = Math.pow(.7, arguments.length ? t : 1), new qt(this.h, this.s, t * this.l);
        }, Ht.rgb = function () {
          return Gt(this.h, this.s, this.l);
        }, t.hcl = Yt;
        var Wt = Yt.prototype = new Vt();

        function Xt(t, e, r) {
          return isNaN(t) && (t = 0), isNaN(e) && (e = 0), new Zt(r, Math.cos(t *= Ct) * e, Math.sin(t) * e);
        }

        function Zt(t, e, r) {
          return this instanceof Zt ? (this.l = +t, this.a = +e, void (this.b = +r)) : arguments.length < 2 ? t instanceof Zt ? new Zt(t.l, t.a, t.b) : t instanceof Yt ? Xt(t.h, t.c, t.l) : ue((t = ne(t)).r, t.g, t.b) : new Zt(t, e, r);
        }

        Wt.brighter = function (t) {
          return new Yt(this.h, this.c, Math.min(100, this.l + Jt * (arguments.length ? t : 1)));
        }, Wt.darker = function (t) {
          return new Yt(this.h, this.c, Math.max(0, this.l - Jt * (arguments.length ? t : 1)));
        }, Wt.rgb = function () {
          return Xt(this.h, this.c, this.l).rgb();
        }, t.lab = Zt;
        var Jt = 18,
            Kt = Zt.prototype = new Vt();

        function Qt(t, e, r) {
          var n = (t + 16) / 116,
              i = n + e / 500,
              a = n - r / 200;
          return new ne(re(3.2404542 * (i = .95047 * te(i)) - 1.5371385 * (n = 1 * te(n)) - .4985314 * (a = 1.08883 * te(a))), re(-.969266 * i + 1.8760108 * n + .041556 * a), re(.0556434 * i - .2040259 * n + 1.0572252 * a));
        }

        function $t(t, e, r) {
          return t > 0 ? new Yt(Math.atan2(r, e) * Pt, Math.sqrt(e * e + r * r), t) : new Yt(NaN, NaN, t);
        }

        function te(t) {
          return t > .206893034 ? t * t * t : (t - 4 / 29) / 7.787037;
        }

        function ee(t) {
          return t > .008856 ? Math.pow(t, 1 / 3) : 7.787037 * t + 4 / 29;
        }

        function re(t) {
          return Math.round(255 * (t <= .00304 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - .055));
        }

        function ne(t, e, r) {
          return this instanceof ne ? (this.r = ~~t, this.g = ~~e, void (this.b = ~~r)) : arguments.length < 2 ? t instanceof ne ? new ne(t.r, t.g, t.b) : le("" + t, ne, Gt) : new ne(t, e, r);
        }

        function ie(t) {
          return new ne(t >> 16, t >> 8 & 255, 255 & t);
        }

        function ae(t) {
          return ie(t) + "";
        }

        Kt.brighter = function (t) {
          return new Zt(Math.min(100, this.l + Jt * (arguments.length ? t : 1)), this.a, this.b);
        }, Kt.darker = function (t) {
          return new Zt(Math.max(0, this.l - Jt * (arguments.length ? t : 1)), this.a, this.b);
        }, Kt.rgb = function () {
          return Qt(this.l, this.a, this.b);
        }, t.rgb = ne;
        var oe = ne.prototype = new Vt();

        function se(t) {
          return t < 16 ? "0" + Math.max(0, t).toString(16) : Math.min(255, t).toString(16);
        }

        function le(t, e, r) {
          var n,
              i,
              a,
              o = 0,
              s = 0,
              l = 0;
          if (n = /([a-z]+)\((.*)\)/.exec(t = t.toLowerCase())) switch (i = n[2].split(","), n[1]) {
            case "hsl":
              return r(parseFloat(i[0]), parseFloat(i[1]) / 100, parseFloat(i[2]) / 100);

            case "rgb":
              return e(he(i[0]), he(i[1]), he(i[2]));
          }
          return (a = pe.get(t)) ? e(a.r, a.g, a.b) : (null == t || "#" !== t.charAt(0) || isNaN(a = parseInt(t.slice(1), 16)) || (4 === t.length ? (o = (3840 & a) >> 4, o |= o >> 4, s = 240 & a, s |= s >> 4, l = 15 & a, l |= l << 4) : 7 === t.length && (o = (16711680 & a) >> 16, s = (65280 & a) >> 8, l = 255 & a)), e(o, s, l));
        }

        function ce(t, e, r) {
          var n,
              i,
              a = Math.min(t /= 255, e /= 255, r /= 255),
              o = Math.max(t, e, r),
              s = o - a,
              l = (o + a) / 2;
          return s ? (i = l < .5 ? s / (o + a) : s / (2 - o - a), n = t == o ? (e - r) / s + (e < r ? 6 : 0) : e == o ? (r - t) / s + 2 : (t - e) / s + 4, n *= 60) : (n = NaN, i = l > 0 && l < 1 ? 0 : n), new qt(n, i, l);
        }

        function ue(t, e, r) {
          var n = ee((.4124564 * (t = fe(t)) + .3575761 * (e = fe(e)) + .1804375 * (r = fe(r))) / .95047),
              i = ee((.2126729 * t + .7151522 * e + .072175 * r) / 1);
          return Zt(116 * i - 16, 500 * (n - i), 200 * (i - ee((.0193339 * t + .119192 * e + .9503041 * r) / 1.08883)));
        }

        function fe(t) {
          return (t /= 255) <= .04045 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4);
        }

        function he(t) {
          var e = parseFloat(t);
          return "%" === t.charAt(t.length - 1) ? Math.round(2.55 * e) : e;
        }

        oe.brighter = function (t) {
          t = Math.pow(.7, arguments.length ? t : 1);
          var e = this.r,
              r = this.g,
              n = this.b,
              i = 30;
          return e || r || n ? (e && e < i && (e = i), r && r < i && (r = i), n && n < i && (n = i), new ne(Math.min(255, e / t), Math.min(255, r / t), Math.min(255, n / t))) : new ne(i, i, i);
        }, oe.darker = function (t) {
          return new ne((t = Math.pow(.7, arguments.length ? t : 1)) * this.r, t * this.g, t * this.b);
        }, oe.hsl = function () {
          return ce(this.r, this.g, this.b);
        }, oe.toString = function () {
          return "#" + se(this.r) + se(this.g) + se(this.b);
        };
        var pe = t.map({
          aliceblue: 15792383,
          antiquewhite: 16444375,
          aqua: 65535,
          aquamarine: 8388564,
          azure: 15794175,
          beige: 16119260,
          bisque: 16770244,
          black: 0,
          blanchedalmond: 16772045,
          blue: 255,
          blueviolet: 9055202,
          brown: 10824234,
          burlywood: 14596231,
          cadetblue: 6266528,
          chartreuse: 8388352,
          chocolate: 13789470,
          coral: 16744272,
          cornflowerblue: 6591981,
          cornsilk: 16775388,
          crimson: 14423100,
          cyan: 65535,
          darkblue: 139,
          darkcyan: 35723,
          darkgoldenrod: 12092939,
          darkgray: 11119017,
          darkgreen: 25600,
          darkgrey: 11119017,
          darkkhaki: 12433259,
          darkmagenta: 9109643,
          darkolivegreen: 5597999,
          darkorange: 16747520,
          darkorchid: 10040012,
          darkred: 9109504,
          darksalmon: 15308410,
          darkseagreen: 9419919,
          darkslateblue: 4734347,
          darkslategray: 3100495,
          darkslategrey: 3100495,
          darkturquoise: 52945,
          darkviolet: 9699539,
          deeppink: 16716947,
          deepskyblue: 49151,
          dimgray: 6908265,
          dimgrey: 6908265,
          dodgerblue: 2003199,
          firebrick: 11674146,
          floralwhite: 16775920,
          forestgreen: 2263842,
          fuchsia: 16711935,
          gainsboro: 14474460,
          ghostwhite: 16316671,
          gold: 16766720,
          goldenrod: 14329120,
          gray: 8421504,
          green: 32768,
          greenyellow: 11403055,
          grey: 8421504,
          honeydew: 15794160,
          hotpink: 16738740,
          indianred: 13458524,
          indigo: 4915330,
          ivory: 16777200,
          khaki: 15787660,
          lavender: 15132410,
          lavenderblush: 16773365,
          lawngreen: 8190976,
          lemonchiffon: 16775885,
          lightblue: 11393254,
          lightcoral: 15761536,
          lightcyan: 14745599,
          lightgoldenrodyellow: 16448210,
          lightgray: 13882323,
          lightgreen: 9498256,
          lightgrey: 13882323,
          lightpink: 16758465,
          lightsalmon: 16752762,
          lightseagreen: 2142890,
          lightskyblue: 8900346,
          lightslategray: 7833753,
          lightslategrey: 7833753,
          lightsteelblue: 11584734,
          lightyellow: 16777184,
          lime: 65280,
          limegreen: 3329330,
          linen: 16445670,
          magenta: 16711935,
          maroon: 8388608,
          mediumaquamarine: 6737322,
          mediumblue: 205,
          mediumorchid: 12211667,
          mediumpurple: 9662683,
          mediumseagreen: 3978097,
          mediumslateblue: 8087790,
          mediumspringgreen: 64154,
          mediumturquoise: 4772300,
          mediumvioletred: 13047173,
          midnightblue: 1644912,
          mintcream: 16121850,
          mistyrose: 16770273,
          moccasin: 16770229,
          navajowhite: 16768685,
          navy: 128,
          oldlace: 16643558,
          olive: 8421376,
          olivedrab: 7048739,
          orange: 16753920,
          orangered: 16729344,
          orchid: 14315734,
          palegoldenrod: 15657130,
          palegreen: 10025880,
          paleturquoise: 11529966,
          palevioletred: 14381203,
          papayawhip: 16773077,
          peachpuff: 16767673,
          peru: 13468991,
          pink: 16761035,
          plum: 14524637,
          powderblue: 11591910,
          purple: 8388736,
          rebeccapurple: 6697881,
          red: 16711680,
          rosybrown: 12357519,
          royalblue: 4286945,
          saddlebrown: 9127187,
          salmon: 16416882,
          sandybrown: 16032864,
          seagreen: 3050327,
          seashell: 16774638,
          sienna: 10506797,
          silver: 12632256,
          skyblue: 8900331,
          slateblue: 6970061,
          slategray: 7372944,
          slategrey: 7372944,
          snow: 16775930,
          springgreen: 65407,
          steelblue: 4620980,
          tan: 13808780,
          teal: 32896,
          thistle: 14204888,
          tomato: 16737095,
          turquoise: 4251856,
          violet: 15631086,
          wheat: 16113331,
          white: 16777215,
          whitesmoke: 16119285,
          yellow: 16776960,
          yellowgreen: 10145074
        });

        function de(t) {
          return "function" == typeof t ? t : function () {
            return t;
          };
        }

        function me(t) {
          return function (e, r, n) {
            return 2 === arguments.length && "function" == typeof r && (n = r, r = null), ge(e, r, t, n);
          };
        }

        function ge(e, r, i, a) {
          var o = {},
              s = t.dispatch("beforesend", "progress", "load", "error"),
              l = {},
              c = new XMLHttpRequest(),
              u = null;

          function f() {
            var t,
                e = c.status;

            if (!e && function (t) {
              var e = t.responseType;
              return e && "text" !== e ? t.response : t.responseText;
            }(c) || e >= 200 && e < 300 || 304 === e) {
              try {
                t = i.call(o, c);
              } catch (t) {
                return void s.error.call(o, t);
              }

              s.load.call(o, t);
            } else s.error.call(o, c);
          }

          return this.XDomainRequest && !("withCredentials" in c) && /^(http(s)?:)?\/\//.test(e) && (c = new XDomainRequest()), "onload" in c ? c.onload = c.onerror = f : c.onreadystatechange = function () {
            c.readyState > 3 && f();
          }, c.onprogress = function (e) {
            var r = t.event;
            t.event = e;

            try {
              s.progress.call(o, c);
            } finally {
              t.event = r;
            }
          }, o.header = function (t, e) {
            return t = (t + "").toLowerCase(), arguments.length < 2 ? l[t] : (null == e ? delete l[t] : l[t] = e + "", o);
          }, o.mimeType = function (t) {
            return arguments.length ? (r = null == t ? null : t + "", o) : r;
          }, o.responseType = function (t) {
            return arguments.length ? (u = t, o) : u;
          }, o.response = function (t) {
            return i = t, o;
          }, ["get", "post"].forEach(function (t) {
            o[t] = function () {
              return o.send.apply(o, [t].concat(n(arguments)));
            };
          }), o.send = function (t, n, i) {
            if (2 === arguments.length && "function" == typeof n && (i = n, n = null), c.open(t, e, !0), null == r || "accept" in l || (l.accept = r + ",*/*"), c.setRequestHeader) for (var a in l) {
              c.setRequestHeader(a, l[a]);
            }
            return null != r && c.overrideMimeType && c.overrideMimeType(r), null != u && (c.responseType = u), null != i && o.on("error", i).on("load", function (t) {
              i(null, t);
            }), s.beforesend.call(o, c), c.send(null == n ? null : n), o;
          }, o.abort = function () {
            return c.abort(), o;
          }, t.rebind(o, s, "on"), null == a ? o : o.get(function (t) {
            return 1 === t.length ? function (e, r) {
              t(null == e ? r : null);
            } : t;
          }(a));
        }

        pe.forEach(function (t, e) {
          pe.set(t, ie(e));
        }), t.functor = de, t.xhr = me(C), t.dsv = function (t, e) {
          var r = new RegExp('["' + t + "\n]"),
              n = t.charCodeAt(0);

          function i(t, r, n) {
            arguments.length < 3 && (n = r, r = null);
            var i = ge(t, e, null == r ? a : o(r), n);
            return i.row = function (t) {
              return arguments.length ? i.response(null == (r = t) ? a : o(t)) : r;
            }, i;
          }

          function a(t) {
            return i.parse(t.responseText);
          }

          function o(t) {
            return function (e) {
              return i.parse(e.responseText, t);
            };
          }

          function s(e) {
            return e.map(l).join(t);
          }

          function l(t) {
            return r.test(t) ? '"' + t.replace(/\"/g, '""') + '"' : t;
          }

          return i.parse = function (t, e) {
            var r;
            return i.parseRows(t, function (t, n) {
              if (r) return r(t, n - 1);

              var i = function i(e) {
                for (var r = {}, n = t.length, i = 0; i < n; ++i) {
                  r[t[i]] = e[i];
                }

                return r;
              };

              r = e ? function (t, r) {
                return e(i(t), r);
              } : i;
            });
          }, i.parseRows = function (t, e) {
            var r,
                i,
                a = {},
                o = {},
                s = [],
                l = t.length,
                c = 0,
                u = 0;

            function f() {
              if (c >= l) return o;
              if (i) return i = !1, a;
              var e = c;

              if (34 === t.charCodeAt(e)) {
                for (var r = e; r++ < l;) {
                  if (34 === t.charCodeAt(r)) {
                    if (34 !== t.charCodeAt(r + 1)) break;
                    ++r;
                  }
                }

                return c = r + 2, 13 === (s = t.charCodeAt(r + 1)) ? (i = !0, 10 === t.charCodeAt(r + 2) && ++c) : 10 === s && (i = !0), t.slice(e + 1, r).replace(/""/g, '"');
              }

              for (; c < l;) {
                var s,
                    u = 1;
                if (10 === (s = t.charCodeAt(c++))) i = !0;else if (13 === s) i = !0, 10 === t.charCodeAt(c) && (++c, ++u);else if (s !== n) continue;
                return t.slice(e, c - u);
              }

              return t.slice(e);
            }

            for (; (r = f()) !== o;) {
              for (var h = []; r !== a && r !== o;) {
                h.push(r), r = f();
              }

              e && null == (h = e(h, u++)) || s.push(h);
            }

            return s;
          }, i.format = function (e) {
            if (Array.isArray(e[0])) return i.formatRows(e);
            var r = new L(),
                n = [];
            return e.forEach(function (t) {
              for (var e in t) {
                r.has(e) || n.push(r.add(e));
              }
            }), [n.map(l).join(t)].concat(e.map(function (e) {
              return n.map(function (t) {
                return l(e[t]);
              }).join(t);
            })).join("\n");
          }, i.formatRows = function (t) {
            return t.map(s).join("\n");
          }, i;
        }, t.csv = t.dsv(",", "text/csv"), t.tsv = t.dsv("\t", "text/tab-separated-values");

        var ve,
            ye,
            xe,
            be,
            _e = this[I(this, "requestAnimationFrame")] || function (t) {
          setTimeout(t, 17);
        };

        function we(t, e, r) {
          var n = arguments.length;
          n < 2 && (e = 0), n < 3 && (r = Date.now());
          var i = r + e,
              a = {
            c: t,
            t: i,
            n: null
          };
          return ye ? ye.n = a : ve = a, ye = a, xe || (be = clearTimeout(be), xe = 1, _e(Te)), a;
        }

        function Te() {
          var t = ke(),
              e = Me() - t;
          e > 24 ? (isFinite(e) && (clearTimeout(be), be = setTimeout(Te, e)), xe = 0) : (xe = 1, _e(Te));
        }

        function ke() {
          for (var t = Date.now(), e = ve; e;) {
            t >= e.t && e.c(t - e.t) && (e.c = null), e = e.n;
          }

          return t;
        }

        function Me() {
          for (var t, e = ve, r = 1 / 0; e;) {
            e.c ? (e.t < r && (r = e.t), e = (t = e).n) : e = t ? t.n = e.n : ve = e.n;
          }

          return ye = t, r;
        }

        function Ae(t, e) {
          return e - (t ? Math.ceil(Math.log(t) / Math.LN10) : 1);
        }

        t.timer = function () {
          we.apply(this, arguments);
        }, t.timer.flush = function () {
          ke(), Me();
        }, t.round = function (t, e) {
          return e ? Math.round(t * (e = Math.pow(10, e))) / e : Math.round(t);
        };
        var Se = ["y", "z", "a", "f", "p", "n", "\xb5", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"].map(function (t, e) {
          var r = Math.pow(10, 3 * y(8 - e));
          return {
            scale: e > 8 ? function (t) {
              return t / r;
            } : function (t) {
              return t * r;
            },
            symbol: t
          };
        });

        function Ee(e) {
          var r = e.decimal,
              n = e.thousands,
              i = e.grouping,
              a = e.currency,
              o = i && n ? function (t, e) {
            for (var r = t.length, a = [], o = 0, s = i[0], l = 0; r > 0 && s > 0 && (l + s + 1 > e && (s = Math.max(1, e - l)), a.push(t.substring(r -= s, r + s)), !((l += s + 1) > e));) {
              s = i[o = (o + 1) % i.length];
            }

            return a.reverse().join(n);
          } : C;
          return function (e) {
            var n = Le.exec(e),
                i = n[1] || " ",
                s = n[2] || ">",
                l = n[3] || "-",
                c = n[4] || "",
                u = n[5],
                f = +n[6],
                h = n[7],
                p = n[8],
                d = n[9],
                m = 1,
                g = "",
                v = "",
                y = !1,
                x = !0;

            switch (p && (p = +p.substring(1)), (u || "0" === i && "=" === s) && (u = i = "0", s = "="), d) {
              case "n":
                h = !0, d = "g";
                break;

              case "%":
                m = 100, v = "%", d = "f";
                break;

              case "p":
                m = 100, v = "%", d = "r";
                break;

              case "b":
              case "o":
              case "x":
              case "X":
                "#" === c && (g = "0" + d.toLowerCase());

              case "c":
                x = !1;

              case "d":
                y = !0, p = 0;
                break;

              case "s":
                m = -1, d = "r";
            }

            "$" === c && (g = a[0], v = a[1]), "r" != d || p || (d = "g"), null != p && ("g" == d ? p = Math.max(1, Math.min(21, p)) : "e" != d && "f" != d || (p = Math.max(0, Math.min(20, p)))), d = Ce.get(d) || Pe;
            var b = u && h;
            return function (e) {
              var n = v;
              if (y && e % 1) return "";
              var a = e < 0 || 0 === e && 1 / e < 0 ? (e = -e, "-") : "-" === l ? "" : l;

              if (m < 0) {
                var c = t.formatPrefix(e, p);
                e = c.scale(e), n = c.symbol + v;
              } else e *= m;

              var _,
                  w,
                  T = (e = d(e, p)).lastIndexOf(".");

              if (T < 0) {
                var k = x ? e.lastIndexOf("e") : -1;
                k < 0 ? (_ = e, w = "") : (_ = e.substring(0, k), w = e.substring(k));
              } else _ = e.substring(0, T), w = r + e.substring(T + 1);

              !u && h && (_ = o(_, 1 / 0));
              var M = g.length + _.length + w.length + (b ? 0 : a.length),
                  A = M < f ? new Array(M = f - M + 1).join(i) : "";
              return b && (_ = o(A + _, A.length ? f - w.length : 1 / 0)), a += g, e = _ + w, ("<" === s ? a + e + A : ">" === s ? A + a + e : "^" === s ? A.substring(0, M >>= 1) + a + e + A.substring(M) : a + (b ? e : A + e)) + n;
            };
          };
        }

        t.formatPrefix = function (e, r) {
          var n = 0;
          return (e = +e) && (e < 0 && (e *= -1), r && (e = t.round(e, Ae(e, r))), n = 1 + Math.floor(1e-12 + Math.log(e) / Math.LN10), n = Math.max(-24, Math.min(24, 3 * Math.floor((n - 1) / 3)))), Se[8 + n / 3];
        };

        var Le = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i,
            Ce = t.map({
          b: function b(t) {
            return t.toString(2);
          },
          c: function c(t) {
            return String.fromCharCode(t);
          },
          o: function o(t) {
            return t.toString(8);
          },
          x: function x(t) {
            return t.toString(16);
          },
          X: function X(t) {
            return t.toString(16).toUpperCase();
          },
          g: function g(t, e) {
            return t.toPrecision(e);
          },
          e: function e(t, _e2) {
            return t.toExponential(_e2);
          },
          f: function f(t, e) {
            return t.toFixed(e);
          },
          r: function r(e, _r2) {
            return (e = t.round(e, Ae(e, _r2))).toFixed(Math.max(0, Math.min(20, Ae(e * (1 + 1e-15), _r2))));
          }
        });

        function Pe(t) {
          return t + "";
        }

        var Ie = t.time = {},
            Oe = Date;

        function ze() {
          this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
        }

        ze.prototype = {
          getDate: function getDate() {
            return this._.getUTCDate();
          },
          getDay: function getDay() {
            return this._.getUTCDay();
          },
          getFullYear: function getFullYear() {
            return this._.getUTCFullYear();
          },
          getHours: function getHours() {
            return this._.getUTCHours();
          },
          getMilliseconds: function getMilliseconds() {
            return this._.getUTCMilliseconds();
          },
          getMinutes: function getMinutes() {
            return this._.getUTCMinutes();
          },
          getMonth: function getMonth() {
            return this._.getUTCMonth();
          },
          getSeconds: function getSeconds() {
            return this._.getUTCSeconds();
          },
          getTime: function getTime() {
            return this._.getTime();
          },
          getTimezoneOffset: function getTimezoneOffset() {
            return 0;
          },
          valueOf: function valueOf() {
            return this._.valueOf();
          },
          setDate: function setDate() {
            De.setUTCDate.apply(this._, arguments);
          },
          setDay: function setDay() {
            De.setUTCDay.apply(this._, arguments);
          },
          setFullYear: function setFullYear() {
            De.setUTCFullYear.apply(this._, arguments);
          },
          setHours: function setHours() {
            De.setUTCHours.apply(this._, arguments);
          },
          setMilliseconds: function setMilliseconds() {
            De.setUTCMilliseconds.apply(this._, arguments);
          },
          setMinutes: function setMinutes() {
            De.setUTCMinutes.apply(this._, arguments);
          },
          setMonth: function setMonth() {
            De.setUTCMonth.apply(this._, arguments);
          },
          setSeconds: function setSeconds() {
            De.setUTCSeconds.apply(this._, arguments);
          },
          setTime: function setTime() {
            De.setTime.apply(this._, arguments);
          }
        };
        var De = Date.prototype;

        function Re(t, e, r) {
          function n(e) {
            var r = t(e),
                n = a(r, 1);
            return e - r < n - e ? r : n;
          }

          function i(r) {
            return e(r = t(new Oe(r - 1)), 1), r;
          }

          function a(t, r) {
            return e(t = new Oe(+t), r), t;
          }

          function o(t, n, a) {
            var o = i(t),
                s = [];
            if (a > 1) for (; o < n;) {
              r(o) % a || s.push(new Date(+o)), e(o, 1);
            } else for (; o < n;) {
              s.push(new Date(+o)), e(o, 1);
            }
            return s;
          }

          t.floor = t, t.round = n, t.ceil = i, t.offset = a, t.range = o;
          var s = t.utc = Fe(t);
          return s.floor = s, s.round = Fe(n), s.ceil = Fe(i), s.offset = Fe(a), s.range = function (t, e, r) {
            try {
              Oe = ze;
              var n = new ze();
              return n._ = t, o(n, e, r);
            } finally {
              Oe = Date;
            }
          }, t;
        }

        function Fe(t) {
          return function (e, r) {
            try {
              Oe = ze;
              var n = new ze();
              return n._ = e, t(n, r)._;
            } finally {
              Oe = Date;
            }
          };
        }

        function Be(e) {
          var r = e.dateTime,
              n = e.date,
              i = e.time,
              a = e.periods,
              o = e.days,
              s = e.shortDays,
              l = e.months,
              c = e.shortMonths;

          function u(t) {
            var e = t.length;

            function r(r) {
              for (var n, i, a, o = [], s = -1, l = 0; ++s < e;) {
                37 === t.charCodeAt(s) && (o.push(t.slice(l, s)), null != (i = Ne[n = t.charAt(++s)]) && (n = t.charAt(++s)), (a = _[n]) && (n = a(r, null == i ? "e" === n ? " " : "0" : i)), o.push(n), l = s + 1);
              }

              return o.push(t.slice(l, s)), o.join("");
            }

            return r.parse = function (e) {
              var r = {
                y: 1900,
                m: 0,
                d: 1,
                H: 0,
                M: 0,
                S: 0,
                L: 0,
                Z: null
              };
              if (f(r, t, e, 0) != e.length) return null;
              "p" in r && (r.H = r.H % 12 + 12 * r.p);
              var n = null != r.Z && Oe !== ze,
                  i = new (n ? ze : Oe)();
              return "j" in r ? i.setFullYear(r.y, 0, r.j) : "W" in r || "U" in r ? ("w" in r || (r.w = "W" in r ? 1 : 0), i.setFullYear(r.y, 0, 1), i.setFullYear(r.y, 0, "W" in r ? (r.w + 6) % 7 + 7 * r.W - (i.getDay() + 5) % 7 : r.w + 7 * r.U - (i.getDay() + 6) % 7)) : i.setFullYear(r.y, r.m, r.d), i.setHours(r.H + (r.Z / 100 | 0), r.M + r.Z % 100, r.S, r.L), n ? i._ : i;
            }, r.toString = function () {
              return t;
            }, r;
          }

          function f(t, e, r, n) {
            for (var i, a, o, s = 0, l = e.length, c = r.length; s < l;) {
              if (n >= c) return -1;

              if (37 === (i = e.charCodeAt(s++))) {
                if (o = e.charAt(s++), !(a = w[o in Ne ? e.charAt(s++) : o]) || (n = a(t, r, n)) < 0) return -1;
              } else if (i != r.charCodeAt(n++)) return -1;
            }

            return n;
          }

          u.utc = function (t) {
            var e = u(t);

            function r(t) {
              try {
                var r = new (Oe = ze)();
                return r._ = t, e(r);
              } finally {
                Oe = Date;
              }
            }

            return r.parse = function (t) {
              try {
                Oe = ze;
                var r = e.parse(t);
                return r && r._;
              } finally {
                Oe = Date;
              }
            }, r.toString = e.toString, r;
          }, u.multi = u.utc.multi = or;

          var h = t.map(),
              p = qe(o),
              d = He(o),
              m = qe(s),
              g = He(s),
              v = qe(l),
              y = He(l),
              x = qe(c),
              _b = He(c);

          a.forEach(function (t, e) {
            h.set(t.toLowerCase(), e);
          });
          var _ = {
            a: function a(t) {
              return s[t.getDay()];
            },
            A: function A(t) {
              return o[t.getDay()];
            },
            b: function b(t) {
              return c[t.getMonth()];
            },
            B: function B(t) {
              return l[t.getMonth()];
            },
            c: u(r),
            d: function d(t, e) {
              return Ve(t.getDate(), e, 2);
            },
            e: function e(t, _e3) {
              return Ve(t.getDate(), _e3, 2);
            },
            H: function H(t, e) {
              return Ve(t.getHours(), e, 2);
            },
            I: function I(t, e) {
              return Ve(t.getHours() % 12 || 12, e, 2);
            },
            j: function j(t, e) {
              return Ve(1 + Ie.dayOfYear(t), e, 3);
            },
            L: function L(t, e) {
              return Ve(t.getMilliseconds(), e, 3);
            },
            m: function m(t, e) {
              return Ve(t.getMonth() + 1, e, 2);
            },
            M: function M(t, e) {
              return Ve(t.getMinutes(), e, 2);
            },
            p: function p(t) {
              return a[+(t.getHours() >= 12)];
            },
            S: function S(t, e) {
              return Ve(t.getSeconds(), e, 2);
            },
            U: function U(t, e) {
              return Ve(Ie.sundayOfYear(t), e, 2);
            },
            w: function w(t) {
              return t.getDay();
            },
            W: function W(t, e) {
              return Ve(Ie.mondayOfYear(t), e, 2);
            },
            x: u(n),
            X: u(i),
            y: function y(t, e) {
              return Ve(t.getFullYear() % 100, e, 2);
            },
            Y: function Y(t, e) {
              return Ve(t.getFullYear() % 1e4, e, 4);
            },
            Z: ir,
            "%": function _() {
              return "%";
            }
          },
              w = {
            a: function a(t, e, r) {
              m.lastIndex = 0;
              var n = m.exec(e.slice(r));
              return n ? (t.w = g.get(n[0].toLowerCase()), r + n[0].length) : -1;
            },
            A: function A(t, e, r) {
              p.lastIndex = 0;
              var n = p.exec(e.slice(r));
              return n ? (t.w = d.get(n[0].toLowerCase()), r + n[0].length) : -1;
            },
            b: function b(t, e, r) {
              x.lastIndex = 0;
              var n = x.exec(e.slice(r));
              return n ? (t.m = _b.get(n[0].toLowerCase()), r + n[0].length) : -1;
            },
            B: function B(t, e, r) {
              v.lastIndex = 0;
              var n = v.exec(e.slice(r));
              return n ? (t.m = y.get(n[0].toLowerCase()), r + n[0].length) : -1;
            },
            c: function c(t, e, r) {
              return f(t, _.c.toString(), e, r);
            },
            d: Qe,
            e: Qe,
            H: tr,
            I: tr,
            j: $e,
            L: nr,
            m: Ke,
            M: er,
            p: function p(t, e, r) {
              var n = h.get(e.slice(r, r += 2).toLowerCase());
              return null == n ? -1 : (t.p = n, r);
            },
            S: rr,
            U: Ye,
            w: Ge,
            W: We,
            x: function x(t, e, r) {
              return f(t, _.x.toString(), e, r);
            },
            X: function X(t, e, r) {
              return f(t, _.X.toString(), e, r);
            },
            y: Ze,
            Y: Xe,
            Z: Je,
            "%": ar
          };
          return u;
        }

        Ie.year = Re(function (t) {
          return (t = Ie.day(t)).setMonth(0, 1), t;
        }, function (t, e) {
          t.setFullYear(t.getFullYear() + e);
        }, function (t) {
          return t.getFullYear();
        }), Ie.years = Ie.year.range, Ie.years.utc = Ie.year.utc.range, Ie.day = Re(function (t) {
          var e = new Oe(2e3, 0);
          return e.setFullYear(t.getFullYear(), t.getMonth(), t.getDate()), e;
        }, function (t, e) {
          t.setDate(t.getDate() + e);
        }, function (t) {
          return t.getDate() - 1;
        }), Ie.days = Ie.day.range, Ie.days.utc = Ie.day.utc.range, Ie.dayOfYear = function (t) {
          var e = Ie.year(t);
          return Math.floor((t - e - 6e4 * (t.getTimezoneOffset() - e.getTimezoneOffset())) / 864e5);
        }, ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"].forEach(function (t, e) {
          e = 7 - e;
          var r = Ie[t] = Re(function (t) {
            return (t = Ie.day(t)).setDate(t.getDate() - (t.getDay() + e) % 7), t;
          }, function (t, e) {
            t.setDate(t.getDate() + 7 * Math.floor(e));
          }, function (t) {
            var r = Ie.year(t).getDay();
            return Math.floor((Ie.dayOfYear(t) + (r + e) % 7) / 7) - (r !== e);
          });
          Ie[t + "s"] = r.range, Ie[t + "s"].utc = r.utc.range, Ie[t + "OfYear"] = function (t) {
            var r = Ie.year(t).getDay();
            return Math.floor((Ie.dayOfYear(t) + (r + e) % 7) / 7);
          };
        }), Ie.week = Ie.sunday, Ie.weeks = Ie.sunday.range, Ie.weeks.utc = Ie.sunday.utc.range, Ie.weekOfYear = Ie.sundayOfYear;
        var Ne = {
          "-": "",
          _: " ",
          0: "0"
        },
            je = /^\s*\d+/,
            Ue = /^%/;

        function Ve(t, e, r) {
          var n = t < 0 ? "-" : "",
              i = (n ? -t : t) + "",
              a = i.length;
          return n + (a < r ? new Array(r - a + 1).join(e) + i : i);
        }

        function qe(e) {
          return new RegExp("^(?:" + e.map(t.requote).join("|") + ")", "i");
        }

        function He(t) {
          for (var e = new _(), r = -1, n = t.length; ++r < n;) {
            e.set(t[r].toLowerCase(), r);
          }

          return e;
        }

        function Ge(t, e, r) {
          je.lastIndex = 0;
          var n = je.exec(e.slice(r, r + 1));
          return n ? (t.w = +n[0], r + n[0].length) : -1;
        }

        function Ye(t, e, r) {
          je.lastIndex = 0;
          var n = je.exec(e.slice(r));
          return n ? (t.U = +n[0], r + n[0].length) : -1;
        }

        function We(t, e, r) {
          je.lastIndex = 0;
          var n = je.exec(e.slice(r));
          return n ? (t.W = +n[0], r + n[0].length) : -1;
        }

        function Xe(t, e, r) {
          je.lastIndex = 0;
          var n = je.exec(e.slice(r, r + 4));
          return n ? (t.y = +n[0], r + n[0].length) : -1;
        }

        function Ze(t, e, r) {
          je.lastIndex = 0;
          var n,
              i = je.exec(e.slice(r, r + 2));
          return i ? (t.y = (n = +i[0]) + (n > 68 ? 1900 : 2e3), r + i[0].length) : -1;
        }

        function Je(t, e, r) {
          return /^[+-]\d{4}$/.test(e = e.slice(r, r + 5)) ? (t.Z = -e, r + 5) : -1;
        }

        function Ke(t, e, r) {
          je.lastIndex = 0;
          var n = je.exec(e.slice(r, r + 2));
          return n ? (t.m = n[0] - 1, r + n[0].length) : -1;
        }

        function Qe(t, e, r) {
          je.lastIndex = 0;
          var n = je.exec(e.slice(r, r + 2));
          return n ? (t.d = +n[0], r + n[0].length) : -1;
        }

        function $e(t, e, r) {
          je.lastIndex = 0;
          var n = je.exec(e.slice(r, r + 3));
          return n ? (t.j = +n[0], r + n[0].length) : -1;
        }

        function tr(t, e, r) {
          je.lastIndex = 0;
          var n = je.exec(e.slice(r, r + 2));
          return n ? (t.H = +n[0], r + n[0].length) : -1;
        }

        function er(t, e, r) {
          je.lastIndex = 0;
          var n = je.exec(e.slice(r, r + 2));
          return n ? (t.M = +n[0], r + n[0].length) : -1;
        }

        function rr(t, e, r) {
          je.lastIndex = 0;
          var n = je.exec(e.slice(r, r + 2));
          return n ? (t.S = +n[0], r + n[0].length) : -1;
        }

        function nr(t, e, r) {
          je.lastIndex = 0;
          var n = je.exec(e.slice(r, r + 3));
          return n ? (t.L = +n[0], r + n[0].length) : -1;
        }

        function ir(t) {
          var e = t.getTimezoneOffset(),
              r = e > 0 ? "-" : "+",
              n = y(e) / 60 | 0,
              i = y(e) % 60;
          return r + Ve(n, "0", 2) + Ve(i, "0", 2);
        }

        function ar(t, e, r) {
          Ue.lastIndex = 0;
          var n = Ue.exec(e.slice(r, r + 1));
          return n ? r + n[0].length : -1;
        }

        function or(t) {
          for (var e = t.length, r = -1; ++r < e;) {
            t[r][0] = this(t[r][0]);
          }

          return function (e) {
            for (var r = 0, n = t[r]; !n[1](e);) {
              n = t[++r];
            }

            return n[0](e);
          };
        }

        t.locale = function (t) {
          return {
            numberFormat: Ee(t),
            timeFormat: Be(t)
          };
        };

        var sr = t.locale({
          decimal: ".",
          thousands: ",",
          grouping: [3],
          currency: ["$", ""],
          dateTime: "%a %b %e %X %Y",
          date: "%m/%d/%Y",
          time: "%H:%M:%S",
          periods: ["AM", "PM"],
          days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        });

        function lr() {}

        t.format = sr.numberFormat, t.geo = {}, lr.prototype = {
          s: 0,
          t: 0,
          add: function add(t) {
            ur(t, this.t, cr), ur(cr.s, this.s, this), this.s ? this.t += cr.t : this.s = cr.t;
          },
          reset: function reset() {
            this.s = this.t = 0;
          },
          valueOf: function valueOf() {
            return this.s;
          }
        };
        var cr = new lr();

        function ur(t, e, r) {
          var n = r.s = t + e,
              i = n - t,
              a = n - i;
          r.t = t - a + (e - i);
        }

        function fr(t, e) {
          t && pr.hasOwnProperty(t.type) && pr[t.type](t, e);
        }

        t.geo.stream = function (t, e) {
          t && hr.hasOwnProperty(t.type) ? hr[t.type](t, e) : fr(t, e);
        };

        var hr = {
          Feature: function Feature(t, e) {
            fr(t.geometry, e);
          },
          FeatureCollection: function FeatureCollection(t, e) {
            for (var r = t.features, n = -1, i = r.length; ++n < i;) {
              fr(r[n].geometry, e);
            }
          }
        },
            pr = {
          Sphere: function Sphere(t, e) {
            e.sphere();
          },
          Point: function Point(t, e) {
            t = t.coordinates, e.point(t[0], t[1], t[2]);
          },
          MultiPoint: function MultiPoint(t, e) {
            for (var r = t.coordinates, n = -1, i = r.length; ++n < i;) {
              t = r[n], e.point(t[0], t[1], t[2]);
            }
          },
          LineString: function LineString(t, e) {
            dr(t.coordinates, e, 0);
          },
          MultiLineString: function MultiLineString(t, e) {
            for (var r = t.coordinates, n = -1, i = r.length; ++n < i;) {
              dr(r[n], e, 0);
            }
          },
          Polygon: function Polygon(t, e) {
            mr(t.coordinates, e);
          },
          MultiPolygon: function MultiPolygon(t, e) {
            for (var r = t.coordinates, n = -1, i = r.length; ++n < i;) {
              mr(r[n], e);
            }
          },
          GeometryCollection: function GeometryCollection(t, e) {
            for (var r = t.geometries, n = -1, i = r.length; ++n < i;) {
              fr(r[n], e);
            }
          }
        };

        function dr(t, e, r) {
          var n,
              i = -1,
              a = t.length - r;

          for (e.lineStart(); ++i < a;) {
            n = t[i], e.point(n[0], n[1], n[2]);
          }

          e.lineEnd();
        }

        function mr(t, e) {
          var r = -1,
              n = t.length;

          for (e.polygonStart(); ++r < n;) {
            dr(t[r], e, 1);
          }

          e.polygonEnd();
        }

        t.geo.area = function (e) {
          return gr = 0, t.geo.stream(e, Lr), gr;
        };

        var gr,
            vr,
            yr,
            xr,
            br,
            _r,
            wr,
            Tr,
            kr,
            Mr,
            Ar,
            Sr,
            Er = new lr(),
            Lr = {
          sphere: function sphere() {
            gr += 4 * At;
          },
          point: z,
          lineStart: z,
          lineEnd: z,
          polygonStart: function polygonStart() {
            Er.reset(), Lr.lineStart = Cr;
          },
          polygonEnd: function polygonEnd() {
            var t = 2 * Er;
            gr += t < 0 ? 4 * At + t : t, Lr.lineStart = Lr.lineEnd = Lr.point = z;
          }
        };

        function Cr() {
          var t, e, r, n, i;

          function a(t, e) {
            e = e * Ct / 2 + At / 4;
            var a = (t *= Ct) - r,
                o = a >= 0 ? 1 : -1,
                s = o * a,
                l = Math.cos(e),
                c = Math.sin(e),
                u = i * c,
                f = n * l + u * Math.cos(s),
                h = u * o * Math.sin(s);
            Er.add(Math.atan2(h, f)), r = t, n = l, i = c;
          }

          Lr.point = function (o, s) {
            Lr.point = a, r = (t = o) * Ct, n = Math.cos(s = (e = s) * Ct / 2 + At / 4), i = Math.sin(s);
          }, Lr.lineEnd = function () {
            a(t, e);
          };
        }

        function Pr(t) {
          var e = t[0],
              r = t[1],
              n = Math.cos(r);
          return [n * Math.cos(e), n * Math.sin(e), Math.sin(r)];
        }

        function Ir(t, e) {
          return t[0] * e[0] + t[1] * e[1] + t[2] * e[2];
        }

        function Or(t, e) {
          return [t[1] * e[2] - t[2] * e[1], t[2] * e[0] - t[0] * e[2], t[0] * e[1] - t[1] * e[0]];
        }

        function zr(t, e) {
          t[0] += e[0], t[1] += e[1], t[2] += e[2];
        }

        function Dr(t, e) {
          return [t[0] * e, t[1] * e, t[2] * e];
        }

        function Rr(t) {
          var e = Math.sqrt(t[0] * t[0] + t[1] * t[1] + t[2] * t[2]);
          t[0] /= e, t[1] /= e, t[2] /= e;
        }

        function Fr(t) {
          return [Math.atan2(t[1], t[0]), Dt(t[2])];
        }

        function Br(t, e) {
          return y(t[0] - e[0]) < kt && y(t[1] - e[1]) < kt;
        }

        t.geo.bounds = function () {
          var e,
              r,
              n,
              i,
              a,
              o,
              s,
              l,
              c,
              u,
              f,
              h = {
            point: p,
            lineStart: m,
            lineEnd: g,
            polygonStart: function polygonStart() {
              h.point = v, h.lineStart = x, h.lineEnd = b, c = 0, Lr.polygonStart();
            },
            polygonEnd: function polygonEnd() {
              Lr.polygonEnd(), h.point = p, h.lineStart = m, h.lineEnd = g, Er < 0 ? (e = -(n = 180), r = -(i = 90)) : c > kt ? i = 90 : c < -kt && (r = -90), f[0] = e, f[1] = n;
            }
          };

          function p(t, a) {
            u.push(f = [e = t, n = t]), a < r && (r = a), a > i && (i = a);
          }

          function d(t, o) {
            var s = Pr([t * Ct, o * Ct]);

            if (l) {
              var c = Or(l, s),
                  u = Or([c[1], -c[0], 0], c);
              Rr(u), u = Fr(u);
              var f = t - a,
                  h = f > 0 ? 1 : -1,
                  d = u[0] * Pt * h,
                  m = y(f) > 180;
              if (m ^ (h * a < d && d < h * t)) (g = u[1] * Pt) > i && (i = g);else if (m ^ (h * a < (d = (d + 360) % 360 - 180) && d < h * t)) {
                var g;
                (g = -u[1] * Pt) < r && (r = g);
              } else o < r && (r = o), o > i && (i = o);
              m ? t < a ? _(e, t) > _(e, n) && (n = t) : _(t, n) > _(e, n) && (e = t) : n >= e ? (t < e && (e = t), t > n && (n = t)) : t > a ? _(e, t) > _(e, n) && (n = t) : _(t, n) > _(e, n) && (e = t);
            } else p(t, o);

            l = s, a = t;
          }

          function m() {
            h.point = d;
          }

          function g() {
            f[0] = e, f[1] = n, h.point = p, l = null;
          }

          function v(t, e) {
            if (l) {
              var r = t - a;
              c += y(r) > 180 ? r + (r > 0 ? 360 : -360) : r;
            } else o = t, s = e;

            Lr.point(t, e), d(t, e);
          }

          function x() {
            Lr.lineStart();
          }

          function b() {
            v(o, s), Lr.lineEnd(), y(c) > kt && (e = -(n = 180)), f[0] = e, f[1] = n, l = null;
          }

          function _(t, e) {
            return (e -= t) < 0 ? e + 360 : e;
          }

          function w(t, e) {
            return t[0] - e[0];
          }

          function T(t, e) {
            return e[0] <= e[1] ? e[0] <= t && t <= e[1] : t < e[0] || e[1] < t;
          }

          return function (a) {
            if (i = n = -(e = r = 1 / 0), u = [], t.geo.stream(a, h), c = u.length) {
              u.sort(w);

              for (var o = 1, s = [m = u[0]]; o < c; ++o) {
                T((p = u[o])[0], m) || T(p[1], m) ? (_(m[0], p[1]) > _(m[0], m[1]) && (m[1] = p[1]), _(p[0], m[1]) > _(m[0], m[1]) && (m[0] = p[0])) : s.push(m = p);
              }

              for (var l, c, p, d = -1 / 0, m = (o = 0, s[c = s.length - 1]); o <= c; m = p, ++o) {
                p = s[o], (l = _(m[1], p[0])) > d && (d = l, e = p[0], n = m[1]);
              }
            }

            return u = f = null, e === 1 / 0 || r === 1 / 0 ? [[NaN, NaN], [NaN, NaN]] : [[e, r], [n, i]];
          };
        }(), t.geo.centroid = function (e) {
          vr = yr = xr = br = _r = wr = Tr = kr = Mr = Ar = Sr = 0, t.geo.stream(e, Nr);
          var r = Mr,
              n = Ar,
              i = Sr,
              a = r * r + n * n + i * i;
          return a < Mt && (r = wr, n = Tr, i = kr, yr < kt && (r = xr, n = br, i = _r), (a = r * r + n * n + i * i) < Mt) ? [NaN, NaN] : [Math.atan2(n, r) * Pt, Dt(i / Math.sqrt(a)) * Pt];
        };
        var Nr = {
          sphere: z,
          point: jr,
          lineStart: Vr,
          lineEnd: qr,
          polygonStart: function polygonStart() {
            Nr.lineStart = Hr;
          },
          polygonEnd: function polygonEnd() {
            Nr.lineStart = Vr;
          }
        };

        function jr(t, e) {
          t *= Ct;
          var r = Math.cos(e *= Ct);
          Ur(r * Math.cos(t), r * Math.sin(t), Math.sin(e));
        }

        function Ur(t, e, r) {
          ++vr, xr += (t - xr) / vr, br += (e - br) / vr, _r += (r - _r) / vr;
        }

        function Vr() {
          var t, e, r;

          function n(n, i) {
            n *= Ct;
            var a = Math.cos(i *= Ct),
                o = a * Math.cos(n),
                s = a * Math.sin(n),
                l = Math.sin(i),
                c = Math.atan2(Math.sqrt((c = e * l - r * s) * c + (c = r * o - t * l) * c + (c = t * s - e * o) * c), t * o + e * s + r * l);
            yr += c, wr += c * (t + (t = o)), Tr += c * (e + (e = s)), kr += c * (r + (r = l)), Ur(t, e, r);
          }

          Nr.point = function (i, a) {
            i *= Ct;
            var o = Math.cos(a *= Ct);
            t = o * Math.cos(i), e = o * Math.sin(i), r = Math.sin(a), Nr.point = n, Ur(t, e, r);
          };
        }

        function qr() {
          Nr.point = jr;
        }

        function Hr() {
          var t, e, r, n, i;

          function a(t, e) {
            t *= Ct;
            var a = Math.cos(e *= Ct),
                o = a * Math.cos(t),
                s = a * Math.sin(t),
                l = Math.sin(e),
                c = n * l - i * s,
                u = i * o - r * l,
                f = r * s - n * o,
                h = Math.sqrt(c * c + u * u + f * f),
                p = r * o + n * s + i * l,
                d = h && -zt(p) / h,
                m = Math.atan2(h, p);
            Mr += d * c, Ar += d * u, Sr += d * f, yr += m, wr += m * (r + (r = o)), Tr += m * (n + (n = s)), kr += m * (i + (i = l)), Ur(r, n, i);
          }

          Nr.point = function (o, s) {
            t = o, e = s, Nr.point = a, o *= Ct;
            var l = Math.cos(s *= Ct);
            r = l * Math.cos(o), n = l * Math.sin(o), i = Math.sin(s), Ur(r, n, i);
          }, Nr.lineEnd = function () {
            a(t, e), Nr.lineEnd = qr, Nr.point = jr;
          };
        }

        function Gr(t, e) {
          function r(r, n) {
            return r = t(r, n), e(r[0], r[1]);
          }

          return t.invert && e.invert && (r.invert = function (r, n) {
            return (r = e.invert(r, n)) && t.invert(r[0], r[1]);
          }), r;
        }

        function Yr() {
          return !0;
        }

        function Wr(t, e, r, n, i) {
          var a = [],
              o = [];

          if (t.forEach(function (t) {
            if (!((e = t.length - 1) <= 0)) {
              var e,
                  r = t[0],
                  n = t[e];

              if (Br(r, n)) {
                i.lineStart();

                for (var s = 0; s < e; ++s) {
                  i.point((r = t[s])[0], r[1]);
                }

                i.lineEnd();
              } else {
                var l = new Zr(r, t, null, !0),
                    c = new Zr(r, null, l, !1);
                l.o = c, a.push(l), o.push(c), l = new Zr(n, t, null, !1), c = new Zr(n, null, l, !0), l.o = c, a.push(l), o.push(c);
              }
            }
          }), o.sort(e), Xr(a), Xr(o), a.length) {
            for (var s = 0, l = r, c = o.length; s < c; ++s) {
              o[s].e = l = !l;
            }

            for (var u, f, h = a[0];;) {
              for (var p = h, d = !0; p.v;) {
                if ((p = p.n) === h) return;
              }

              u = p.z, i.lineStart();

              do {
                if (p.v = p.o.v = !0, p.e) {
                  if (d) for (s = 0, c = u.length; s < c; ++s) {
                    i.point((f = u[s])[0], f[1]);
                  } else n(p.x, p.n.x, 1, i);
                  p = p.n;
                } else {
                  if (d) for (s = (u = p.p.z).length - 1; s >= 0; --s) {
                    i.point((f = u[s])[0], f[1]);
                  } else n(p.x, p.p.x, -1, i);
                  p = p.p;
                }

                u = (p = p.o).z, d = !d;
              } while (!p.v);

              i.lineEnd();
            }
          }
        }

        function Xr(t) {
          if (e = t.length) {
            for (var e, r, n = 0, i = t[0]; ++n < e;) {
              i.n = r = t[n], r.p = i, i = r;
            }

            i.n = r = t[0], r.p = i;
          }
        }

        function Zr(t, e, r, n) {
          this.x = t, this.z = e, this.o = r, this.e = n, this.v = !1, this.n = this.p = null;
        }

        function Jr(e, r, n, i) {
          return function (a, o) {
            var s,
                l = r(o),
                c = a.invert(i[0], i[1]),
                u = {
              point: f,
              lineStart: p,
              lineEnd: d,
              polygonStart: function polygonStart() {
                u.point = b, u.lineStart = _, u.lineEnd = w, s = [], m = [];
              },
              polygonEnd: function polygonEnd() {
                u.point = f, u.lineStart = p, u.lineEnd = d, s = t.merge(s);

                var e = function (t, e) {
                  var r = t[0],
                      n = t[1],
                      i = [Math.sin(r), -Math.cos(r), 0],
                      a = 0,
                      o = 0;
                  Er.reset();

                  for (var s = 0, l = e.length; s < l; ++s) {
                    var c = e[s],
                        u = c.length;
                    if (u) for (var f = c[0], h = f[0], p = f[1] / 2 + At / 4, d = Math.sin(p), m = Math.cos(p), g = 1;;) {
                      g === u && (g = 0);

                      var v = (t = c[g])[0],
                          y = t[1] / 2 + At / 4,
                          x = Math.sin(y),
                          b = Math.cos(y),
                          _ = v - h,
                          w = _ >= 0 ? 1 : -1,
                          T = w * _,
                          k = T > At,
                          M = d * x;

                      if (Er.add(Math.atan2(M * w * Math.sin(T), m * b + M * Math.cos(T))), a += k ? _ + w * St : _, k ^ h >= r ^ v >= r) {
                        var A = Or(Pr(f), Pr(t));
                        Rr(A);
                        var S = Or(i, A);
                        Rr(S);
                        var E = (k ^ _ >= 0 ? -1 : 1) * Dt(S[2]);
                        (n > E || n === E && (A[0] || A[1])) && (o += k ^ _ >= 0 ? 1 : -1);
                      }

                      if (!g++) break;
                      h = v, d = x, m = b, f = t;
                    }
                  }

                  return (a < -kt || a < kt && Er < -kt) ^ 1 & o;
                }(c, m);

                s.length ? (x || (o.polygonStart(), x = !0), Wr(s, $r, e, n, o)) : e && (x || (o.polygonStart(), x = !0), o.lineStart(), n(null, null, 1, o), o.lineEnd()), x && (o.polygonEnd(), x = !1), s = m = null;
              },
              sphere: function sphere() {
                o.polygonStart(), o.lineStart(), n(null, null, 1, o), o.lineEnd(), o.polygonEnd();
              }
            };

            function f(t, r) {
              var n = a(t, r);
              e(t = n[0], r = n[1]) && o.point(t, r);
            }

            function h(t, e) {
              var r = a(t, e);
              l.point(r[0], r[1]);
            }

            function p() {
              u.point = h, l.lineStart();
            }

            function d() {
              u.point = f, l.lineEnd();
            }

            var m,
                g,
                v = Qr(),
                y = r(v),
                x = !1;

            function b(t, e) {
              g.push([t, e]);
              var r = a(t, e);
              y.point(r[0], r[1]);
            }

            function _() {
              y.lineStart(), g = [];
            }

            function w() {
              b(g[0][0], g[0][1]), y.lineEnd();
              var t,
                  e = y.clean(),
                  r = v.buffer(),
                  n = r.length;
              if (g.pop(), m.push(g), g = null, n) if (1 & e) {
                var i,
                    a = -1;

                if ((n = (t = r[0]).length - 1) > 0) {
                  for (x || (o.polygonStart(), x = !0), o.lineStart(); ++a < n;) {
                    o.point((i = t[a])[0], i[1]);
                  }

                  o.lineEnd();
                }
              } else n > 1 && 2 & e && r.push(r.pop().concat(r.shift())), s.push(r.filter(Kr));
            }

            return u;
          };
        }

        function Kr(t) {
          return t.length > 1;
        }

        function Qr() {
          var t,
              e = [];
          return {
            lineStart: function lineStart() {
              e.push(t = []);
            },
            point: function point(e, r) {
              t.push([e, r]);
            },
            lineEnd: z,
            buffer: function buffer() {
              var r = e;
              return e = [], t = null, r;
            },
            rejoin: function rejoin() {
              e.length > 1 && e.push(e.pop().concat(e.shift()));
            }
          };
        }

        function $r(t, e) {
          return ((t = t.x)[0] < 0 ? t[1] - Lt - kt : Lt - t[1]) - ((e = e.x)[0] < 0 ? e[1] - Lt - kt : Lt - e[1]);
        }

        var tn = Jr(Yr, function (t) {
          var e,
              r = NaN,
              n = NaN,
              i = NaN;
          return {
            lineStart: function lineStart() {
              t.lineStart(), e = 1;
            },
            point: function point(a, o) {
              var s = a > 0 ? At : -At,
                  l = y(a - r);
              y(l - At) < kt ? (t.point(r, n = (n + o) / 2 > 0 ? Lt : -Lt), t.point(i, n), t.lineEnd(), t.lineStart(), t.point(s, n), t.point(a, n), e = 0) : i !== s && l >= At && (y(r - i) < kt && (r -= i * kt), y(a - s) < kt && (a -= s * kt), n = function (t, e, r, n) {
                var i,
                    a,
                    o = Math.sin(t - r);
                return y(o) > kt ? Math.atan((Math.sin(e) * (a = Math.cos(n)) * Math.sin(r) - Math.sin(n) * (i = Math.cos(e)) * Math.sin(t)) / (i * a * o)) : (e + n) / 2;
              }(r, n, a, o), t.point(i, n), t.lineEnd(), t.lineStart(), t.point(s, n), e = 0), t.point(r = a, n = o), i = s;
            },
            lineEnd: function lineEnd() {
              t.lineEnd(), r = n = NaN;
            },
            clean: function clean() {
              return 2 - e;
            }
          };
        }, function (t, e, r, n) {
          var i;
          if (null == t) i = r * Lt, n.point(-At, i), n.point(0, i), n.point(At, i), n.point(At, 0), n.point(At, -i), n.point(0, -i), n.point(-At, -i), n.point(-At, 0), n.point(-At, i);else if (y(t[0] - e[0]) > kt) {
            var a = t[0] < e[0] ? At : -At;
            i = r * a / 2, n.point(-a, i), n.point(0, i), n.point(a, i);
          } else n.point(e[0], e[1]);
        }, [-At, -At / 2]);

        function en(t) {
          var e = Math.cos(t),
              r = e > 0,
              n = y(e) > kt;
          return Jr(i, function (t) {
            var e, s, l, c, u;
            return {
              lineStart: function lineStart() {
                c = l = !1, u = 1;
              },
              point: function point(f, h) {
                var p,
                    d = [f, h],
                    m = i(f, h),
                    g = r ? m ? 0 : o(f, h) : m ? o(f + (f < 0 ? At : -At), h) : 0;
                if (!e && (c = l = m) && t.lineStart(), m !== l && (p = a(e, d), (Br(e, p) || Br(d, p)) && (d[0] += kt, d[1] += kt, m = i(d[0], d[1]))), m !== l) u = 0, m ? (t.lineStart(), p = a(d, e), t.point(p[0], p[1])) : (p = a(e, d), t.point(p[0], p[1]), t.lineEnd()), e = p;else if (n && e && r ^ m) {
                  var v;
                  g & s || !(v = a(d, e, !0)) || (u = 0, r ? (t.lineStart(), t.point(v[0][0], v[0][1]), t.point(v[1][0], v[1][1]), t.lineEnd()) : (t.point(v[1][0], v[1][1]), t.lineEnd(), t.lineStart(), t.point(v[0][0], v[0][1])));
                }
                !m || e && Br(e, d) || t.point(d[0], d[1]), e = d, l = m, s = g;
              },
              lineEnd: function lineEnd() {
                l && t.lineEnd(), e = null;
              },
              clean: function clean() {
                return u | (c && l) << 1;
              }
            };
          }, Bn(t, 6 * Ct), r ? [0, -t] : [-At, t - At]);

          function i(t, r) {
            return Math.cos(t) * Math.cos(r) > e;
          }

          function a(t, r, n) {
            var i = [1, 0, 0],
                a = Or(Pr(t), Pr(r)),
                o = Ir(a, a),
                s = a[0],
                l = o - s * s;
            if (!l) return !n && t;
            var c = e * o / l,
                u = -e * s / l,
                f = Or(i, a),
                h = Dr(i, c);
            zr(h, Dr(a, u));
            var p = f,
                d = Ir(h, p),
                m = Ir(p, p),
                g = d * d - m * (Ir(h, h) - 1);

            if (!(g < 0)) {
              var v = Math.sqrt(g),
                  x = Dr(p, (-d - v) / m);
              if (zr(x, h), x = Fr(x), !n) return x;
              var b,
                  _ = t[0],
                  w = r[0],
                  T = t[1],
                  k = r[1];
              w < _ && (b = _, _ = w, w = b);
              var M = w - _,
                  A = y(M - At) < kt;

              if (!A && k < T && (b = T, T = k, k = b), A || M < kt ? A ? T + k > 0 ^ x[1] < (y(x[0] - _) < kt ? T : k) : T <= x[1] && x[1] <= k : M > At ^ (_ <= x[0] && x[0] <= w)) {
                var S = Dr(p, (-d + v) / m);
                return zr(S, h), [x, Fr(S)];
              }
            }
          }

          function o(e, n) {
            var i = r ? t : At - t,
                a = 0;
            return e < -i ? a |= 1 : e > i && (a |= 2), n < -i ? a |= 4 : n > i && (a |= 8), a;
          }
        }

        function rn(t, e, r, n) {
          return function (i) {
            var a,
                o = i.a,
                s = i.b,
                l = o.x,
                c = o.y,
                u = 0,
                f = 1,
                h = s.x - l,
                p = s.y - c;

            if (a = t - l, h || !(a > 0)) {
              if (a /= h, h < 0) {
                if (a < u) return;
                a < f && (f = a);
              } else if (h > 0) {
                if (a > f) return;
                a > u && (u = a);
              }

              if (a = r - l, h || !(a < 0)) {
                if (a /= h, h < 0) {
                  if (a > f) return;
                  a > u && (u = a);
                } else if (h > 0) {
                  if (a < u) return;
                  a < f && (f = a);
                }

                if (a = e - c, p || !(a > 0)) {
                  if (a /= p, p < 0) {
                    if (a < u) return;
                    a < f && (f = a);
                  } else if (p > 0) {
                    if (a > f) return;
                    a > u && (u = a);
                  }

                  if (a = n - c, p || !(a < 0)) {
                    if (a /= p, p < 0) {
                      if (a > f) return;
                      a > u && (u = a);
                    } else if (p > 0) {
                      if (a < u) return;
                      a < f && (f = a);
                    }

                    return u > 0 && (i.a = {
                      x: l + u * h,
                      y: c + u * p
                    }), f < 1 && (i.b = {
                      x: l + f * h,
                      y: c + f * p
                    }), i;
                  }
                }
              }
            }
          };
        }

        function nn(e, r, n, i) {
          return function (l) {
            var c,
                u,
                f,
                h,
                p,
                d,
                m,
                g,
                v,
                y,
                x,
                b = l,
                _ = Qr(),
                w = rn(e, r, n, i),
                T = {
              point: A,
              lineStart: function lineStart() {
                T.point = S, u && u.push(f = []);
                y = !0, v = !1, m = g = NaN;
              },
              lineEnd: function lineEnd() {
                c && (S(h, p), d && v && _.rejoin(), c.push(_.buffer()));
                T.point = A, v && l.lineEnd();
              },
              polygonStart: function polygonStart() {
                l = _, c = [], u = [], x = !0;
              },
              polygonEnd: function polygonEnd() {
                l = b, c = t.merge(c);

                var r = function (t) {
                  for (var e = 0, r = u.length, n = t[1], i = 0; i < r; ++i) {
                    for (var a, o = 1, s = u[i], l = s.length, c = s[0]; o < l; ++o) {
                      a = s[o], c[1] <= n ? a[1] > n && Ot(c, a, t) > 0 && ++e : a[1] <= n && Ot(c, a, t) < 0 && --e, c = a;
                    }
                  }

                  return 0 !== e;
                }([e, i]),
                    n = x && r,
                    a = c.length;

                (n || a) && (l.polygonStart(), n && (l.lineStart(), k(null, null, 1, l), l.lineEnd()), a && Wr(c, o, r, k, l), l.polygonEnd()), c = u = f = null;
              }
            };

            function k(t, o, l, c) {
              var u = 0,
                  f = 0;
              if (null == t || (u = a(t, l)) !== (f = a(o, l)) || s(t, o) < 0 ^ l > 0) do {
                c.point(0 === u || 3 === u ? e : n, u > 1 ? i : r);
              } while ((u = (u + l + 4) % 4) !== f);else c.point(o[0], o[1]);
            }

            function M(t, a) {
              return e <= t && t <= n && r <= a && a <= i;
            }

            function A(t, e) {
              M(t, e) && l.point(t, e);
            }

            function S(t, e) {
              var r = M(t = Math.max(-1e9, Math.min(1e9, t)), e = Math.max(-1e9, Math.min(1e9, e)));
              if (u && f.push([t, e]), y) h = t, p = e, d = r, y = !1, r && (l.lineStart(), l.point(t, e));else if (r && v) l.point(t, e);else {
                var n = {
                  a: {
                    x: m,
                    y: g
                  },
                  b: {
                    x: t,
                    y: e
                  }
                };
                w(n) ? (v || (l.lineStart(), l.point(n.a.x, n.a.y)), l.point(n.b.x, n.b.y), r || l.lineEnd(), x = !1) : r && (l.lineStart(), l.point(t, e), x = !1);
              }
              m = t, g = e, v = r;
            }

            return T;
          };

          function a(t, i) {
            return y(t[0] - e) < kt ? i > 0 ? 0 : 3 : y(t[0] - n) < kt ? i > 0 ? 2 : 1 : y(t[1] - r) < kt ? i > 0 ? 1 : 0 : i > 0 ? 3 : 2;
          }

          function o(t, e) {
            return s(t.x, e.x);
          }

          function s(t, e) {
            var r = a(t, 1),
                n = a(e, 1);
            return r !== n ? r - n : 0 === r ? e[1] - t[1] : 1 === r ? t[0] - e[0] : 2 === r ? t[1] - e[1] : e[0] - t[0];
          }
        }

        function an(t) {
          var e = 0,
              r = At / 3,
              n = Cn(t),
              i = n(e, r);
          return i.parallels = function (t) {
            return arguments.length ? n(e = t[0] * At / 180, r = t[1] * At / 180) : [e / At * 180, r / At * 180];
          }, i;
        }

        function on(t, e) {
          var r = Math.sin(t),
              n = (r + Math.sin(e)) / 2,
              i = 1 + r * (2 * n - r),
              a = Math.sqrt(i) / n;

          function o(t, e) {
            var r = Math.sqrt(i - 2 * n * Math.sin(e)) / n;
            return [r * Math.sin(t *= n), a - r * Math.cos(t)];
          }

          return o.invert = function (t, e) {
            var r = a - e;
            return [Math.atan2(t, r) / n, Dt((i - (t * t + r * r) * n * n) / (2 * n))];
          }, o;
        }

        t.geo.clipExtent = function () {
          var t,
              e,
              r,
              n,
              i,
              a,
              o = {
            stream: function stream(t) {
              return i && (i.valid = !1), (i = a(t)).valid = !0, i;
            },
            extent: function extent(s) {
              return arguments.length ? (a = nn(t = +s[0][0], e = +s[0][1], r = +s[1][0], n = +s[1][1]), i && (i.valid = !1, i = null), o) : [[t, e], [r, n]];
            }
          };
          return o.extent([[0, 0], [960, 500]]);
        }, (t.geo.conicEqualArea = function () {
          return an(on);
        }).raw = on, t.geo.albers = function () {
          return t.geo.conicEqualArea().rotate([96, 0]).center([-.6, 38.7]).parallels([29.5, 45.5]).scale(1070);
        }, t.geo.albersUsa = function () {
          var e,
              r,
              n,
              i,
              a = t.geo.albers(),
              o = t.geo.conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]),
              s = t.geo.conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]),
              l = {
            point: function point(t, r) {
              e = [t, r];
            }
          };

          function c(t) {
            var a = t[0],
                o = t[1];
            return e = null, r(a, o), e || (n(a, o), e) || i(a, o), e;
          }

          return c.invert = function (t) {
            var e = a.scale(),
                r = a.translate(),
                n = (t[0] - r[0]) / e,
                i = (t[1] - r[1]) / e;
            return (i >= .12 && i < .234 && n >= -.425 && n < -.214 ? o : i >= .166 && i < .234 && n >= -.214 && n < -.115 ? s : a).invert(t);
          }, c.stream = function (t) {
            var e = a.stream(t),
                r = o.stream(t),
                n = s.stream(t);
            return {
              point: function point(t, i) {
                e.point(t, i), r.point(t, i), n.point(t, i);
              },
              sphere: function sphere() {
                e.sphere(), r.sphere(), n.sphere();
              },
              lineStart: function lineStart() {
                e.lineStart(), r.lineStart(), n.lineStart();
              },
              lineEnd: function lineEnd() {
                e.lineEnd(), r.lineEnd(), n.lineEnd();
              },
              polygonStart: function polygonStart() {
                e.polygonStart(), r.polygonStart(), n.polygonStart();
              },
              polygonEnd: function polygonEnd() {
                e.polygonEnd(), r.polygonEnd(), n.polygonEnd();
              }
            };
          }, c.precision = function (t) {
            return arguments.length ? (a.precision(t), o.precision(t), s.precision(t), c) : a.precision();
          }, c.scale = function (t) {
            return arguments.length ? (a.scale(t), o.scale(.35 * t), s.scale(t), c.translate(a.translate())) : a.scale();
          }, c.translate = function (t) {
            if (!arguments.length) return a.translate();
            var e = a.scale(),
                u = +t[0],
                f = +t[1];
            return r = a.translate(t).clipExtent([[u - .455 * e, f - .238 * e], [u + .455 * e, f + .238 * e]]).stream(l).point, n = o.translate([u - .307 * e, f + .201 * e]).clipExtent([[u - .425 * e + kt, f + .12 * e + kt], [u - .214 * e - kt, f + .234 * e - kt]]).stream(l).point, i = s.translate([u - .205 * e, f + .212 * e]).clipExtent([[u - .214 * e + kt, f + .166 * e + kt], [u - .115 * e - kt, f + .234 * e - kt]]).stream(l).point, c;
          }, c.scale(1070);
        };
        var sn,
            ln,
            cn,
            un,
            fn,
            hn,
            pn = {
          point: z,
          lineStart: z,
          lineEnd: z,
          polygonStart: function polygonStart() {
            ln = 0, pn.lineStart = dn;
          },
          polygonEnd: function polygonEnd() {
            pn.lineStart = pn.lineEnd = pn.point = z, sn += y(ln / 2);
          }
        };

        function dn() {
          var t, e, r, n;

          function i(t, e) {
            ln += n * t - r * e, r = t, n = e;
          }

          pn.point = function (a, o) {
            pn.point = i, t = r = a, e = n = o;
          }, pn.lineEnd = function () {
            i(t, e);
          };
        }

        var mn = {
          point: function point(t, e) {
            t < cn && (cn = t);
            t > fn && (fn = t);
            e < un && (un = e);
            e > hn && (hn = e);
          },
          lineStart: z,
          lineEnd: z,
          polygonStart: z,
          polygonEnd: z
        };

        function gn() {
          var t = vn(4.5),
              e = [],
              r = {
            point: n,
            lineStart: function lineStart() {
              r.point = i;
            },
            lineEnd: o,
            polygonStart: function polygonStart() {
              r.lineEnd = s;
            },
            polygonEnd: function polygonEnd() {
              r.lineEnd = o, r.point = n;
            },
            pointRadius: function pointRadius(e) {
              return t = vn(e), r;
            },
            result: function result() {
              if (e.length) {
                var t = e.join("");
                return e = [], t;
              }
            }
          };

          function n(r, n) {
            e.push("M", r, ",", n, t);
          }

          function i(t, n) {
            e.push("M", t, ",", n), r.point = a;
          }

          function a(t, r) {
            e.push("L", t, ",", r);
          }

          function o() {
            r.point = n;
          }

          function s() {
            e.push("Z");
          }

          return r;
        }

        function vn(t) {
          return "m0," + t + "a" + t + "," + t + " 0 1,1 0," + -2 * t + "a" + t + "," + t + " 0 1,1 0," + 2 * t + "z";
        }

        var yn,
            xn = {
          point: bn,
          lineStart: _n,
          lineEnd: wn,
          polygonStart: function polygonStart() {
            xn.lineStart = Tn;
          },
          polygonEnd: function polygonEnd() {
            xn.point = bn, xn.lineStart = _n, xn.lineEnd = wn;
          }
        };

        function bn(t, e) {
          xr += t, br += e, ++_r;
        }

        function _n() {
          var t, e;

          function r(r, n) {
            var i = r - t,
                a = n - e,
                o = Math.sqrt(i * i + a * a);
            wr += o * (t + r) / 2, Tr += o * (e + n) / 2, kr += o, bn(t = r, e = n);
          }

          xn.point = function (n, i) {
            xn.point = r, bn(t = n, e = i);
          };
        }

        function wn() {
          xn.point = bn;
        }

        function Tn() {
          var t, e, r, n;

          function i(t, e) {
            var i = t - r,
                a = e - n,
                o = Math.sqrt(i * i + a * a);
            wr += o * (r + t) / 2, Tr += o * (n + e) / 2, kr += o, Mr += (o = n * t - r * e) * (r + t), Ar += o * (n + e), Sr += 3 * o, bn(r = t, n = e);
          }

          xn.point = function (a, o) {
            xn.point = i, bn(t = r = a, e = n = o);
          }, xn.lineEnd = function () {
            i(t, e);
          };
        }

        function kn(t) {
          var e = 4.5,
              r = {
            point: n,
            lineStart: function lineStart() {
              r.point = i;
            },
            lineEnd: o,
            polygonStart: function polygonStart() {
              r.lineEnd = s;
            },
            polygonEnd: function polygonEnd() {
              r.lineEnd = o, r.point = n;
            },
            pointRadius: function pointRadius(t) {
              return e = t, r;
            },
            result: z
          };

          function n(r, n) {
            t.moveTo(r + e, n), t.arc(r, n, e, 0, St);
          }

          function i(e, n) {
            t.moveTo(e, n), r.point = a;
          }

          function a(e, r) {
            t.lineTo(e, r);
          }

          function o() {
            r.point = n;
          }

          function s() {
            t.closePath();
          }

          return r;
        }

        function Mn(t) {
          var e = .5,
              r = Math.cos(30 * Ct),
              n = 16;

          function i(t) {
            return (n ? o : a)(t);
          }

          function a(e) {
            return En(e, function (r, n) {
              r = t(r, n), e.point(r[0], r[1]);
            });
          }

          function o(e) {
            var r,
                i,
                a,
                o,
                l,
                c,
                u,
                f,
                h,
                p,
                d,
                m,
                g = {
              point: v,
              lineStart: y,
              lineEnd: b,
              polygonStart: function polygonStart() {
                e.polygonStart(), g.lineStart = _;
              },
              polygonEnd: function polygonEnd() {
                e.polygonEnd(), g.lineStart = y;
              }
            };

            function v(r, n) {
              r = t(r, n), e.point(r[0], r[1]);
            }

            function y() {
              f = NaN, g.point = x, e.lineStart();
            }

            function x(r, i) {
              var a = Pr([r, i]),
                  o = t(r, i);
              s(f, h, u, p, d, m, f = o[0], h = o[1], u = r, p = a[0], d = a[1], m = a[2], n, e), e.point(f, h);
            }

            function b() {
              g.point = v, e.lineEnd();
            }

            function _() {
              y(), g.point = w, g.lineEnd = T;
            }

            function w(t, e) {
              x(r = t, e), i = f, a = h, o = p, l = d, c = m, g.point = x;
            }

            function T() {
              s(f, h, u, p, d, m, i, a, r, o, l, c, n, e), g.lineEnd = b, b();
            }

            return g;
          }

          function s(n, i, a, o, l, c, u, f, h, p, d, m, g, v) {
            var x = u - n,
                b = f - i,
                _ = x * x + b * b;

            if (_ > 4 * e && g--) {
              var w = o + p,
                  T = l + d,
                  k = c + m,
                  M = Math.sqrt(w * w + T * T + k * k),
                  A = Math.asin(k /= M),
                  S = y(y(k) - 1) < kt || y(a - h) < kt ? (a + h) / 2 : Math.atan2(T, w),
                  E = t(S, A),
                  L = E[0],
                  C = E[1],
                  P = L - n,
                  I = C - i,
                  O = b * P - x * I;
              (O * O / _ > e || y((x * P + b * I) / _ - .5) > .3 || o * p + l * d + c * m < r) && (s(n, i, a, o, l, c, L, C, S, w /= M, T /= M, k, g, v), v.point(L, C), s(L, C, S, w, T, k, u, f, h, p, d, m, g, v));
            }
          }

          return i.precision = function (t) {
            return arguments.length ? (n = (e = t * t) > 0 && 16, i) : Math.sqrt(e);
          }, i;
        }

        function An(t) {
          var e = Mn(function (e, r) {
            return t([e * Pt, r * Pt]);
          });
          return function (t) {
            return Pn(e(t));
          };
        }

        function Sn(t) {
          this.stream = t;
        }

        function En(t, e) {
          return {
            point: e,
            sphere: function sphere() {
              t.sphere();
            },
            lineStart: function lineStart() {
              t.lineStart();
            },
            lineEnd: function lineEnd() {
              t.lineEnd();
            },
            polygonStart: function polygonStart() {
              t.polygonStart();
            },
            polygonEnd: function polygonEnd() {
              t.polygonEnd();
            }
          };
        }

        function Ln(t) {
          return Cn(function () {
            return t;
          })();
        }

        function Cn(e) {
          var r,
              n,
              i,
              a,
              o,
              s,
              l = Mn(function (t, e) {
            return [(t = r(t, e))[0] * c + a, o - t[1] * c];
          }),
              c = 150,
              u = 480,
              f = 250,
              h = 0,
              p = 0,
              d = 0,
              m = 0,
              g = 0,
              v = tn,
              y = C,
              x = null,
              b = null;

          function _(t) {
            return [(t = i(t[0] * Ct, t[1] * Ct))[0] * c + a, o - t[1] * c];
          }

          function w(t) {
            return (t = i.invert((t[0] - a) / c, (o - t[1]) / c)) && [t[0] * Pt, t[1] * Pt];
          }

          function T() {
            i = Gr(n = zn(d, m, g), r);
            var t = r(h, p);
            return a = u - t[0] * c, o = f + t[1] * c, k();
          }

          function k() {
            return s && (s.valid = !1, s = null), _;
          }

          return _.stream = function (t) {
            return s && (s.valid = !1), (s = Pn(v(n, l(y(t))))).valid = !0, s;
          }, _.clipAngle = function (t) {
            return arguments.length ? (v = null == t ? (x = t, tn) : en((x = +t) * Ct), k()) : x;
          }, _.clipExtent = function (t) {
            return arguments.length ? (b = t, y = t ? nn(t[0][0], t[0][1], t[1][0], t[1][1]) : C, k()) : b;
          }, _.scale = function (t) {
            return arguments.length ? (c = +t, T()) : c;
          }, _.translate = function (t) {
            return arguments.length ? (u = +t[0], f = +t[1], T()) : [u, f];
          }, _.center = function (t) {
            return arguments.length ? (h = t[0] % 360 * Ct, p = t[1] % 360 * Ct, T()) : [h * Pt, p * Pt];
          }, _.rotate = function (t) {
            return arguments.length ? (d = t[0] % 360 * Ct, m = t[1] % 360 * Ct, g = t.length > 2 ? t[2] % 360 * Ct : 0, T()) : [d * Pt, m * Pt, g * Pt];
          }, t.rebind(_, l, "precision"), function () {
            return r = e.apply(this, arguments), _.invert = r.invert && w, T();
          };
        }

        function Pn(t) {
          return En(t, function (e, r) {
            t.point(e * Ct, r * Ct);
          });
        }

        function In(t, e) {
          return [t, e];
        }

        function On(t, e) {
          return [t > At ? t - St : t < -At ? t + St : t, e];
        }

        function zn(t, e, r) {
          return t ? e || r ? Gr(Rn(t), Fn(e, r)) : Rn(t) : e || r ? Fn(e, r) : On;
        }

        function Dn(t) {
          return function (e, r) {
            return [(e += t) > At ? e - St : e < -At ? e + St : e, r];
          };
        }

        function Rn(t) {
          var e = Dn(t);
          return e.invert = Dn(-t), e;
        }

        function Fn(t, e) {
          var r = Math.cos(t),
              n = Math.sin(t),
              i = Math.cos(e),
              a = Math.sin(e);

          function o(t, e) {
            var o = Math.cos(e),
                s = Math.cos(t) * o,
                l = Math.sin(t) * o,
                c = Math.sin(e),
                u = c * r + s * n;
            return [Math.atan2(l * i - u * a, s * r - c * n), Dt(u * i + l * a)];
          }

          return o.invert = function (t, e) {
            var o = Math.cos(e),
                s = Math.cos(t) * o,
                l = Math.sin(t) * o,
                c = Math.sin(e),
                u = c * i - l * a;
            return [Math.atan2(l * i + c * a, s * r + u * n), Dt(u * r - s * n)];
          }, o;
        }

        function Bn(t, e) {
          var r = Math.cos(t),
              n = Math.sin(t);
          return function (i, a, o, s) {
            var l = o * e;
            null != i ? (i = Nn(r, i), a = Nn(r, a), (o > 0 ? i < a : i > a) && (i += o * St)) : (i = t + o * St, a = t - .5 * l);

            for (var c, u = i; o > 0 ? u > a : u < a; u -= l) {
              s.point((c = Fr([r, -n * Math.cos(u), -n * Math.sin(u)]))[0], c[1]);
            }
          };
        }

        function Nn(t, e) {
          var r = Pr(e);
          r[0] -= t, Rr(r);
          var n = zt(-r[1]);
          return ((-r[2] < 0 ? -n : n) + 2 * Math.PI - kt) % (2 * Math.PI);
        }

        function jn(e, r, n) {
          var i = t.range(e, r - kt, n).concat(r);
          return function (t) {
            return i.map(function (e) {
              return [t, e];
            });
          };
        }

        function Un(e, r, n) {
          var i = t.range(e, r - kt, n).concat(r);
          return function (t) {
            return i.map(function (e) {
              return [e, t];
            });
          };
        }

        function Vn(t) {
          return t.source;
        }

        function qn(t) {
          return t.target;
        }

        t.geo.path = function () {
          var e,
              r,
              n,
              i,
              a,
              o = 4.5;

          function s(e) {
            return e && ("function" == typeof o && i.pointRadius(+o.apply(this, arguments)), a && a.valid || (a = n(i)), t.geo.stream(e, a)), i.result();
          }

          function l() {
            return a = null, s;
          }

          return s.area = function (e) {
            return sn = 0, t.geo.stream(e, n(pn)), sn;
          }, s.centroid = function (e) {
            return xr = br = _r = wr = Tr = kr = Mr = Ar = Sr = 0, t.geo.stream(e, n(xn)), Sr ? [Mr / Sr, Ar / Sr] : kr ? [wr / kr, Tr / kr] : _r ? [xr / _r, br / _r] : [NaN, NaN];
          }, s.bounds = function (e) {
            return fn = hn = -(cn = un = 1 / 0), t.geo.stream(e, n(mn)), [[cn, un], [fn, hn]];
          }, s.projection = function (t) {
            return arguments.length ? (n = (e = t) ? t.stream || An(t) : C, l()) : e;
          }, s.context = function (t) {
            return arguments.length ? (i = null == (r = t) ? new gn() : new kn(t), "function" != typeof o && i.pointRadius(o), l()) : r;
          }, s.pointRadius = function (t) {
            return arguments.length ? (o = "function" == typeof t ? t : (i.pointRadius(+t), +t), s) : o;
          }, s.projection(t.geo.albersUsa()).context(null);
        }, t.geo.transform = function (t) {
          return {
            stream: function stream(e) {
              var r = new Sn(e);

              for (var n in t) {
                r[n] = t[n];
              }

              return r;
            }
          };
        }, Sn.prototype = {
          point: function point(t, e) {
            this.stream.point(t, e);
          },
          sphere: function sphere() {
            this.stream.sphere();
          },
          lineStart: function lineStart() {
            this.stream.lineStart();
          },
          lineEnd: function lineEnd() {
            this.stream.lineEnd();
          },
          polygonStart: function polygonStart() {
            this.stream.polygonStart();
          },
          polygonEnd: function polygonEnd() {
            this.stream.polygonEnd();
          }
        }, t.geo.projection = Ln, t.geo.projectionMutator = Cn, (t.geo.equirectangular = function () {
          return Ln(In);
        }).raw = In.invert = In, t.geo.rotation = function (t) {
          function e(e) {
            return (e = t(e[0] * Ct, e[1] * Ct))[0] *= Pt, e[1] *= Pt, e;
          }

          return t = zn(t[0] % 360 * Ct, t[1] * Ct, t.length > 2 ? t[2] * Ct : 0), e.invert = function (e) {
            return (e = t.invert(e[0] * Ct, e[1] * Ct))[0] *= Pt, e[1] *= Pt, e;
          }, e;
        }, On.invert = In, t.geo.circle = function () {
          var t,
              e,
              r = [0, 0],
              n = 6;

          function i() {
            var t = "function" == typeof r ? r.apply(this, arguments) : r,
                n = zn(-t[0] * Ct, -t[1] * Ct, 0).invert,
                i = [];
            return e(null, null, 1, {
              point: function point(t, e) {
                i.push(t = n(t, e)), t[0] *= Pt, t[1] *= Pt;
              }
            }), {
              type: "Polygon",
              coordinates: [i]
            };
          }

          return i.origin = function (t) {
            return arguments.length ? (r = t, i) : r;
          }, i.angle = function (r) {
            return arguments.length ? (e = Bn((t = +r) * Ct, n * Ct), i) : t;
          }, i.precision = function (r) {
            return arguments.length ? (e = Bn(t * Ct, (n = +r) * Ct), i) : n;
          }, i.angle(90);
        }, t.geo.distance = function (t, e) {
          var r,
              n = (e[0] - t[0]) * Ct,
              i = t[1] * Ct,
              a = e[1] * Ct,
              o = Math.sin(n),
              s = Math.cos(n),
              l = Math.sin(i),
              c = Math.cos(i),
              u = Math.sin(a),
              f = Math.cos(a);
          return Math.atan2(Math.sqrt((r = f * o) * r + (r = c * u - l * f * s) * r), l * u + c * f * s);
        }, t.geo.graticule = function () {
          var e,
              r,
              n,
              i,
              a,
              o,
              s,
              l,
              c,
              u,
              f,
              h,
              p = 10,
              d = p,
              m = 90,
              g = 360,
              v = 2.5;

          function x() {
            return {
              type: "MultiLineString",
              coordinates: b()
            };
          }

          function b() {
            return t.range(Math.ceil(i / m) * m, n, m).map(f).concat(t.range(Math.ceil(l / g) * g, s, g).map(h)).concat(t.range(Math.ceil(r / p) * p, e, p).filter(function (t) {
              return y(t % m) > kt;
            }).map(c)).concat(t.range(Math.ceil(o / d) * d, a, d).filter(function (t) {
              return y(t % g) > kt;
            }).map(u));
          }

          return x.lines = function () {
            return b().map(function (t) {
              return {
                type: "LineString",
                coordinates: t
              };
            });
          }, x.outline = function () {
            return {
              type: "Polygon",
              coordinates: [f(i).concat(h(s).slice(1), f(n).reverse().slice(1), h(l).reverse().slice(1))]
            };
          }, x.extent = function (t) {
            return arguments.length ? x.majorExtent(t).minorExtent(t) : x.minorExtent();
          }, x.majorExtent = function (t) {
            return arguments.length ? (i = +t[0][0], n = +t[1][0], l = +t[0][1], s = +t[1][1], i > n && (t = i, i = n, n = t), l > s && (t = l, l = s, s = t), x.precision(v)) : [[i, l], [n, s]];
          }, x.minorExtent = function (t) {
            return arguments.length ? (r = +t[0][0], e = +t[1][0], o = +t[0][1], a = +t[1][1], r > e && (t = r, r = e, e = t), o > a && (t = o, o = a, a = t), x.precision(v)) : [[r, o], [e, a]];
          }, x.step = function (t) {
            return arguments.length ? x.majorStep(t).minorStep(t) : x.minorStep();
          }, x.majorStep = function (t) {
            return arguments.length ? (m = +t[0], g = +t[1], x) : [m, g];
          }, x.minorStep = function (t) {
            return arguments.length ? (p = +t[0], d = +t[1], x) : [p, d];
          }, x.precision = function (t) {
            return arguments.length ? (v = +t, c = jn(o, a, 90), u = Un(r, e, v), f = jn(l, s, 90), h = Un(i, n, v), x) : v;
          }, x.majorExtent([[-180, -90 + kt], [180, 90 - kt]]).minorExtent([[-180, -80 - kt], [180, 80 + kt]]);
        }, t.geo.greatArc = function () {
          var e,
              r,
              n = Vn,
              i = qn;

          function a() {
            return {
              type: "LineString",
              coordinates: [e || n.apply(this, arguments), r || i.apply(this, arguments)]
            };
          }

          return a.distance = function () {
            return t.geo.distance(e || n.apply(this, arguments), r || i.apply(this, arguments));
          }, a.source = function (t) {
            return arguments.length ? (n = t, e = "function" == typeof t ? null : t, a) : n;
          }, a.target = function (t) {
            return arguments.length ? (i = t, r = "function" == typeof t ? null : t, a) : i;
          }, a.precision = function () {
            return arguments.length ? a : 0;
          }, a;
        }, t.geo.interpolate = function (t, e) {
          return r = t[0] * Ct, n = t[1] * Ct, i = e[0] * Ct, a = e[1] * Ct, o = Math.cos(n), s = Math.sin(n), l = Math.cos(a), c = Math.sin(a), u = o * Math.cos(r), f = o * Math.sin(r), h = l * Math.cos(i), p = l * Math.sin(i), d = 2 * Math.asin(Math.sqrt(Ft(a - n) + o * l * Ft(i - r))), m = 1 / Math.sin(d), (g = d ? function (t) {
            var e = Math.sin(t *= d) * m,
                r = Math.sin(d - t) * m,
                n = r * u + e * h,
                i = r * f + e * p,
                a = r * s + e * c;
            return [Math.atan2(i, n) * Pt, Math.atan2(a, Math.sqrt(n * n + i * i)) * Pt];
          } : function () {
            return [r * Pt, n * Pt];
          }).distance = d, g;
          var r, n, i, a, o, s, l, c, u, f, h, p, d, m, g;
        }, t.geo.length = function (e) {
          return yn = 0, t.geo.stream(e, Hn), yn;
        };
        var Hn = {
          sphere: z,
          point: z,
          lineStart: function lineStart() {
            var t, e, r;

            function n(n, i) {
              var a = Math.sin(i *= Ct),
                  o = Math.cos(i),
                  s = y((n *= Ct) - t),
                  l = Math.cos(s);
              yn += Math.atan2(Math.sqrt((s = o * Math.sin(s)) * s + (s = r * a - e * o * l) * s), e * a + r * o * l), t = n, e = a, r = o;
            }

            Hn.point = function (i, a) {
              t = i * Ct, e = Math.sin(a *= Ct), r = Math.cos(a), Hn.point = n;
            }, Hn.lineEnd = function () {
              Hn.point = Hn.lineEnd = z;
            };
          },
          lineEnd: z,
          polygonStart: z,
          polygonEnd: z
        };

        function Gn(t, e) {
          function r(e, r) {
            var n = Math.cos(e),
                i = Math.cos(r),
                a = t(n * i);
            return [a * i * Math.sin(e), a * Math.sin(r)];
          }

          return r.invert = function (t, r) {
            var n = Math.sqrt(t * t + r * r),
                i = e(n),
                a = Math.sin(i),
                o = Math.cos(i);
            return [Math.atan2(t * a, n * o), Math.asin(n && r * a / n)];
          }, r;
        }

        var Yn = Gn(function (t) {
          return Math.sqrt(2 / (1 + t));
        }, function (t) {
          return 2 * Math.asin(t / 2);
        });
        (t.geo.azimuthalEqualArea = function () {
          return Ln(Yn);
        }).raw = Yn;
        var Wn = Gn(function (t) {
          var e = Math.acos(t);
          return e && e / Math.sin(e);
        }, C);

        function Xn(t, e) {
          var r = Math.cos(t),
              n = function n(t) {
            return Math.tan(At / 4 + t / 2);
          },
              i = t === e ? Math.sin(t) : Math.log(r / Math.cos(e)) / Math.log(n(e) / n(t)),
              a = r * Math.pow(n(t), i) / i;

          if (!i) return Kn;

          function o(t, e) {
            a > 0 ? e < -Lt + kt && (e = -Lt + kt) : e > Lt - kt && (e = Lt - kt);
            var r = a / Math.pow(n(e), i);
            return [r * Math.sin(i * t), a - r * Math.cos(i * t)];
          }

          return o.invert = function (t, e) {
            var r = a - e,
                n = It(i) * Math.sqrt(t * t + r * r);
            return [Math.atan2(t, r) / i, 2 * Math.atan(Math.pow(a / n, 1 / i)) - Lt];
          }, o;
        }

        function Zn(t, e) {
          var r = Math.cos(t),
              n = t === e ? Math.sin(t) : (r - Math.cos(e)) / (e - t),
              i = r / n + t;
          if (y(n) < kt) return In;

          function a(t, e) {
            var r = i - e;
            return [r * Math.sin(n * t), i - r * Math.cos(n * t)];
          }

          return a.invert = function (t, e) {
            var r = i - e;
            return [Math.atan2(t, r) / n, i - It(n) * Math.sqrt(t * t + r * r)];
          }, a;
        }

        (t.geo.azimuthalEquidistant = function () {
          return Ln(Wn);
        }).raw = Wn, (t.geo.conicConformal = function () {
          return an(Xn);
        }).raw = Xn, (t.geo.conicEquidistant = function () {
          return an(Zn);
        }).raw = Zn;
        var Jn = Gn(function (t) {
          return 1 / t;
        }, Math.atan);

        function Kn(t, e) {
          return [t, Math.log(Math.tan(At / 4 + e / 2))];
        }

        function Qn(t) {
          var e,
              r = Ln(t),
              n = r.scale,
              i = r.translate,
              a = r.clipExtent;
          return r.scale = function () {
            var t = n.apply(r, arguments);
            return t === r ? e ? r.clipExtent(null) : r : t;
          }, r.translate = function () {
            var t = i.apply(r, arguments);
            return t === r ? e ? r.clipExtent(null) : r : t;
          }, r.clipExtent = function (t) {
            var o = a.apply(r, arguments);

            if (o === r) {
              if (e = null == t) {
                var s = At * n(),
                    l = i();
                a([[l[0] - s, l[1] - s], [l[0] + s, l[1] + s]]);
              }
            } else e && (o = null);

            return o;
          }, r.clipExtent(null);
        }

        (t.geo.gnomonic = function () {
          return Ln(Jn);
        }).raw = Jn, Kn.invert = function (t, e) {
          return [t, 2 * Math.atan(Math.exp(e)) - Lt];
        }, (t.geo.mercator = function () {
          return Qn(Kn);
        }).raw = Kn;
        var $n = Gn(function () {
          return 1;
        }, Math.asin);
        (t.geo.orthographic = function () {
          return Ln($n);
        }).raw = $n;
        var ti = Gn(function (t) {
          return 1 / (1 + t);
        }, function (t) {
          return 2 * Math.atan(t);
        });

        function ei(t, e) {
          return [Math.log(Math.tan(At / 4 + e / 2)), -t];
        }

        function ri(t) {
          return t[0];
        }

        function ni(t) {
          return t[1];
        }

        function ii(t) {
          for (var e = t.length, r = [0, 1], n = 2, i = 2; i < e; i++) {
            for (; n > 1 && Ot(t[r[n - 2]], t[r[n - 1]], t[i]) <= 0;) {
              --n;
            }

            r[n++] = i;
          }

          return r.slice(0, n);
        }

        function ai(t, e) {
          return t[0] - e[0] || t[1] - e[1];
        }

        (t.geo.stereographic = function () {
          return Ln(ti);
        }).raw = ti, ei.invert = function (t, e) {
          return [-e, 2 * Math.atan(Math.exp(t)) - Lt];
        }, (t.geo.transverseMercator = function () {
          var t = Qn(ei),
              e = t.center,
              r = t.rotate;
          return t.center = function (t) {
            return t ? e([-t[1], t[0]]) : [(t = e())[1], -t[0]];
          }, t.rotate = function (t) {
            return t ? r([t[0], t[1], t.length > 2 ? t[2] + 90 : 90]) : [(t = r())[0], t[1], t[2] - 90];
          }, r([0, 0, 90]);
        }).raw = ei, t.geom = {}, t.geom.hull = function (t) {
          var e = ri,
              r = ni;
          if (arguments.length) return n(t);

          function n(t) {
            if (t.length < 3) return [];
            var n,
                i = de(e),
                a = de(r),
                o = t.length,
                s = [],
                l = [];

            for (n = 0; n < o; n++) {
              s.push([+i.call(this, t[n], n), +a.call(this, t[n], n), n]);
            }

            for (s.sort(ai), n = 0; n < o; n++) {
              l.push([s[n][0], -s[n][1]]);
            }

            var c = ii(s),
                u = ii(l),
                f = u[0] === c[0],
                h = u[u.length - 1] === c[c.length - 1],
                p = [];

            for (n = c.length - 1; n >= 0; --n) {
              p.push(t[s[c[n]][2]]);
            }

            for (n = +f; n < u.length - h; ++n) {
              p.push(t[s[u[n]][2]]);
            }

            return p;
          }

          return n.x = function (t) {
            return arguments.length ? (e = t, n) : e;
          }, n.y = function (t) {
            return arguments.length ? (r = t, n) : r;
          }, n;
        }, t.geom.polygon = function (t) {
          return U(t, oi), t;
        };
        var oi = t.geom.polygon.prototype = [];

        function si(t, e, r) {
          return (r[0] - e[0]) * (t[1] - e[1]) < (r[1] - e[1]) * (t[0] - e[0]);
        }

        function li(t, e, r, n) {
          var i = t[0],
              a = r[0],
              o = e[0] - i,
              s = n[0] - a,
              l = t[1],
              c = r[1],
              u = e[1] - l,
              f = n[1] - c,
              h = (s * (l - c) - f * (i - a)) / (f * o - s * u);
          return [i + h * o, l + h * u];
        }

        function ci(t) {
          var e = t[0],
              r = t[t.length - 1];
          return !(e[0] - r[0] || e[1] - r[1]);
        }

        oi.area = function () {
          for (var t, e = -1, r = this.length, n = this[r - 1], i = 0; ++e < r;) {
            t = n, n = this[e], i += t[1] * n[0] - t[0] * n[1];
          }

          return .5 * i;
        }, oi.centroid = function (t) {
          var e,
              r,
              n = -1,
              i = this.length,
              a = 0,
              o = 0,
              s = this[i - 1];

          for (arguments.length || (t = -1 / (6 * this.area())); ++n < i;) {
            e = s, s = this[n], r = e[0] * s[1] - s[0] * e[1], a += (e[0] + s[0]) * r, o += (e[1] + s[1]) * r;
          }

          return [a * t, o * t];
        }, oi.clip = function (t) {
          for (var e, r, n, i, a, o, s = ci(t), l = -1, c = this.length - ci(this), u = this[c - 1]; ++l < c;) {
            for (e = t.slice(), t.length = 0, i = this[l], a = e[(n = e.length - s) - 1], r = -1; ++r < n;) {
              si(o = e[r], u, i) ? (si(a, u, i) || t.push(li(a, o, u, i)), t.push(o)) : si(a, u, i) && t.push(li(a, o, u, i)), a = o;
            }

            s && t.push(t[0]), u = i;
          }

          return t;
        };
        var ui,
            fi,
            hi,
            pi,
            di,
            mi = [],
            gi = [];

        function vi() {
          Ri(this), this.edge = this.site = this.circle = null;
        }

        function yi(t) {
          var e = mi.pop() || new vi();
          return e.site = t, e;
        }

        function xi(t) {
          Ei(t), hi.remove(t), mi.push(t), Ri(t);
        }

        function bi(t) {
          var e = t.circle,
              r = e.x,
              n = e.cy,
              i = {
            x: r,
            y: n
          },
              a = t.P,
              o = t.N,
              s = [t];
          xi(t);

          for (var l = a; l.circle && y(r - l.circle.x) < kt && y(n - l.circle.cy) < kt;) {
            a = l.P, s.unshift(l), xi(l), l = a;
          }

          s.unshift(l), Ei(l);

          for (var c = o; c.circle && y(r - c.circle.x) < kt && y(n - c.circle.cy) < kt;) {
            o = c.N, s.push(c), xi(c), c = o;
          }

          s.push(c), Ei(c);
          var u,
              f = s.length;

          for (u = 1; u < f; ++u) {
            c = s[u], l = s[u - 1], Oi(c.edge, l.site, c.site, i);
          }

          l = s[0], (c = s[f - 1]).edge = Pi(l.site, c.site, null, i), Si(l), Si(c);
        }

        function _i(t) {
          for (var e, r, n, i, a = t.x, o = t.y, s = hi._; s;) {
            if ((n = wi(s, o) - a) > kt) s = s.L;else {
              if (!((i = a - Ti(s, o)) > kt)) {
                n > -kt ? (e = s.P, r = s) : i > -kt ? (e = s, r = s.N) : e = r = s;
                break;
              }

              if (!s.R) {
                e = s;
                break;
              }

              s = s.R;
            }
          }

          var l = yi(t);

          if (hi.insert(e, l), e || r) {
            if (e === r) return Ei(e), r = yi(e.site), hi.insert(l, r), l.edge = r.edge = Pi(e.site, l.site), Si(e), void Si(r);

            if (r) {
              Ei(e), Ei(r);
              var c = e.site,
                  u = c.x,
                  f = c.y,
                  h = t.x - u,
                  p = t.y - f,
                  d = r.site,
                  m = d.x - u,
                  g = d.y - f,
                  v = 2 * (h * g - p * m),
                  y = h * h + p * p,
                  x = m * m + g * g,
                  b = {
                x: (g * y - p * x) / v + u,
                y: (h * x - m * y) / v + f
              };
              Oi(r.edge, c, d, b), l.edge = Pi(c, t, null, b), r.edge = Pi(t, d, null, b), Si(e), Si(r);
            } else l.edge = Pi(e.site, l.site);
          }
        }

        function wi(t, e) {
          var r = t.site,
              n = r.x,
              i = r.y,
              a = i - e;
          if (!a) return n;
          var o = t.P;
          if (!o) return -1 / 0;
          var s = (r = o.site).x,
              l = r.y,
              c = l - e;
          if (!c) return s;
          var u = s - n,
              f = 1 / a - 1 / c,
              h = u / c;
          return f ? (-h + Math.sqrt(h * h - 2 * f * (u * u / (-2 * c) - l + c / 2 + i - a / 2))) / f + n : (n + s) / 2;
        }

        function Ti(t, e) {
          var r = t.N;
          if (r) return wi(r, e);
          var n = t.site;
          return n.y === e ? n.x : 1 / 0;
        }

        function ki(t) {
          this.site = t, this.edges = [];
        }

        function Mi(t, e) {
          return e.angle - t.angle;
        }

        function Ai() {
          Ri(this), this.x = this.y = this.arc = this.site = this.cy = null;
        }

        function Si(t) {
          var e = t.P,
              r = t.N;

          if (e && r) {
            var n = e.site,
                i = t.site,
                a = r.site;

            if (n !== a) {
              var o = i.x,
                  s = i.y,
                  l = n.x - o,
                  c = n.y - s,
                  u = a.x - o,
                  f = 2 * (l * (g = a.y - s) - c * u);

              if (!(f >= -Mt)) {
                var h = l * l + c * c,
                    p = u * u + g * g,
                    d = (g * h - c * p) / f,
                    m = (l * p - u * h) / f,
                    g = m + s,
                    v = gi.pop() || new Ai();
                v.arc = t, v.site = i, v.x = d + o, v.y = g + Math.sqrt(d * d + m * m), v.cy = g, t.circle = v;

                for (var y = null, x = di._; x;) {
                  if (v.y < x.y || v.y === x.y && v.x <= x.x) {
                    if (!x.L) {
                      y = x.P;
                      break;
                    }

                    x = x.L;
                  } else {
                    if (!x.R) {
                      y = x;
                      break;
                    }

                    x = x.R;
                  }
                }

                di.insert(y, v), y || (pi = v);
              }
            }
          }
        }

        function Ei(t) {
          var e = t.circle;
          e && (e.P || (pi = e.N), di.remove(e), gi.push(e), Ri(e), t.circle = null);
        }

        function Li(t, e) {
          var r = t.b;
          if (r) return !0;
          var n,
              i,
              a = t.a,
              o = e[0][0],
              s = e[1][0],
              l = e[0][1],
              c = e[1][1],
              u = t.l,
              f = t.r,
              h = u.x,
              p = u.y,
              d = f.x,
              m = f.y,
              g = (h + d) / 2,
              v = (p + m) / 2;

          if (m === p) {
            if (g < o || g >= s) return;

            if (h > d) {
              if (a) {
                if (a.y >= c) return;
              } else a = {
                x: g,
                y: l
              };

              r = {
                x: g,
                y: c
              };
            } else {
              if (a) {
                if (a.y < l) return;
              } else a = {
                x: g,
                y: c
              };

              r = {
                x: g,
                y: l
              };
            }
          } else if (i = v - (n = (h - d) / (m - p)) * g, n < -1 || n > 1) {
            if (h > d) {
              if (a) {
                if (a.y >= c) return;
              } else a = {
                x: (l - i) / n,
                y: l
              };

              r = {
                x: (c - i) / n,
                y: c
              };
            } else {
              if (a) {
                if (a.y < l) return;
              } else a = {
                x: (c - i) / n,
                y: c
              };

              r = {
                x: (l - i) / n,
                y: l
              };
            }
          } else if (p < m) {
            if (a) {
              if (a.x >= s) return;
            } else a = {
              x: o,
              y: n * o + i
            };

            r = {
              x: s,
              y: n * s + i
            };
          } else {
            if (a) {
              if (a.x < o) return;
            } else a = {
              x: s,
              y: n * s + i
            };

            r = {
              x: o,
              y: n * o + i
            };
          }

          return t.a = a, t.b = r, !0;
        }

        function Ci(t, e) {
          this.l = t, this.r = e, this.a = this.b = null;
        }

        function Pi(t, e, r, n) {
          var i = new Ci(t, e);
          return ui.push(i), r && Oi(i, t, e, r), n && Oi(i, e, t, n), fi[t.i].edges.push(new zi(i, t, e)), fi[e.i].edges.push(new zi(i, e, t)), i;
        }

        function Ii(t, e, r) {
          var n = new Ci(t, null);
          return n.a = e, n.b = r, ui.push(n), n;
        }

        function Oi(t, e, r, n) {
          t.a || t.b ? t.l === r ? t.b = n : t.a = n : (t.a = n, t.l = e, t.r = r);
        }

        function zi(t, e, r) {
          var n = t.a,
              i = t.b;
          this.edge = t, this.site = e, this.angle = r ? Math.atan2(r.y - e.y, r.x - e.x) : t.l === e ? Math.atan2(i.x - n.x, n.y - i.y) : Math.atan2(n.x - i.x, i.y - n.y);
        }

        function Di() {
          this._ = null;
        }

        function Ri(t) {
          t.U = t.C = t.L = t.R = t.P = t.N = null;
        }

        function Fi(t, e) {
          var r = e,
              n = e.R,
              i = r.U;
          i ? i.L === r ? i.L = n : i.R = n : t._ = n, n.U = i, r.U = n, r.R = n.L, r.R && (r.R.U = r), n.L = r;
        }

        function Bi(t, e) {
          var r = e,
              n = e.L,
              i = r.U;
          i ? i.L === r ? i.L = n : i.R = n : t._ = n, n.U = i, r.U = n, r.L = n.R, r.L && (r.L.U = r), n.R = r;
        }

        function Ni(t) {
          for (; t.L;) {
            t = t.L;
          }

          return t;
        }

        function ji(t, e) {
          var r,
              n,
              i,
              a = t.sort(Ui).pop();

          for (ui = [], fi = new Array(t.length), hi = new Di(), di = new Di();;) {
            if (i = pi, a && (!i || a.y < i.y || a.y === i.y && a.x < i.x)) a.x === r && a.y === n || (fi[a.i] = new ki(a), _i(a), r = a.x, n = a.y), a = t.pop();else {
              if (!i) break;
              bi(i.arc);
            }
          }

          e && (function (t) {
            for (var e, r = ui, n = rn(t[0][0], t[0][1], t[1][0], t[1][1]), i = r.length; i--;) {
              (!Li(e = r[i], t) || !n(e) || y(e.a.x - e.b.x) < kt && y(e.a.y - e.b.y) < kt) && (e.a = e.b = null, r.splice(i, 1));
            }
          }(e), function (t) {
            for (var e, r, n, i, a, o, s, l, c, u, f = t[0][0], h = t[1][0], p = t[0][1], d = t[1][1], m = fi, g = m.length; g--;) {
              if ((a = m[g]) && a.prepare()) for (l = (s = a.edges).length, o = 0; o < l;) {
                n = (u = s[o].end()).x, i = u.y, e = (c = s[++o % l].start()).x, r = c.y, (y(n - e) > kt || y(i - r) > kt) && (s.splice(o, 0, new zi(Ii(a.site, u, y(n - f) < kt && d - i > kt ? {
                  x: f,
                  y: y(e - f) < kt ? r : d
                } : y(i - d) < kt && h - n > kt ? {
                  x: y(r - d) < kt ? e : h,
                  y: d
                } : y(n - h) < kt && i - p > kt ? {
                  x: h,
                  y: y(e - h) < kt ? r : p
                } : y(i - p) < kt && n - f > kt ? {
                  x: y(r - p) < kt ? e : f,
                  y: p
                } : null), a.site, null)), ++l);
              }
            }
          }(e));
          var o = {
            cells: fi,
            edges: ui
          };
          return hi = di = ui = fi = null, o;
        }

        function Ui(t, e) {
          return e.y - t.y || e.x - t.x;
        }

        ki.prototype.prepare = function () {
          for (var t, e = this.edges, r = e.length; r--;) {
            (t = e[r].edge).b && t.a || e.splice(r, 1);
          }

          return e.sort(Mi), e.length;
        }, zi.prototype = {
          start: function start() {
            return this.edge.l === this.site ? this.edge.a : this.edge.b;
          },
          end: function end() {
            return this.edge.l === this.site ? this.edge.b : this.edge.a;
          }
        }, Di.prototype = {
          insert: function insert(t, e) {
            var r, n, i;

            if (t) {
              if (e.P = t, e.N = t.N, t.N && (t.N.P = e), t.N = e, t.R) {
                for (t = t.R; t.L;) {
                  t = t.L;
                }

                t.L = e;
              } else t.R = e;

              r = t;
            } else this._ ? (t = Ni(this._), e.P = null, e.N = t, t.P = t.L = e, r = t) : (e.P = e.N = null, this._ = e, r = null);

            for (e.L = e.R = null, e.U = r, e.C = !0, t = e; r && r.C;) {
              r === (n = r.U).L ? (i = n.R) && i.C ? (r.C = i.C = !1, n.C = !0, t = n) : (t === r.R && (Fi(this, r), r = (t = r).U), r.C = !1, n.C = !0, Bi(this, n)) : (i = n.L) && i.C ? (r.C = i.C = !1, n.C = !0, t = n) : (t === r.L && (Bi(this, r), r = (t = r).U), r.C = !1, n.C = !0, Fi(this, n)), r = t.U;
            }

            this._.C = !1;
          },
          remove: function remove(t) {
            t.N && (t.N.P = t.P), t.P && (t.P.N = t.N), t.N = t.P = null;
            var e,
                r,
                n,
                i = t.U,
                a = t.L,
                o = t.R;
            if (r = a ? o ? Ni(o) : a : o, i ? i.L === t ? i.L = r : i.R = r : this._ = r, a && o ? (n = r.C, r.C = t.C, r.L = a, a.U = r, r !== o ? (i = r.U, r.U = t.U, t = r.R, i.L = t, r.R = o, o.U = r) : (r.U = i, i = r, t = r.R)) : (n = t.C, t = r), t && (t.U = i), !n) if (t && t.C) t.C = !1;else {
              do {
                if (t === this._) break;

                if (t === i.L) {
                  if ((e = i.R).C && (e.C = !1, i.C = !0, Fi(this, i), e = i.R), e.L && e.L.C || e.R && e.R.C) {
                    e.R && e.R.C || (e.L.C = !1, e.C = !0, Bi(this, e), e = i.R), e.C = i.C, i.C = e.R.C = !1, Fi(this, i), t = this._;
                    break;
                  }
                } else if ((e = i.L).C && (e.C = !1, i.C = !0, Bi(this, i), e = i.L), e.L && e.L.C || e.R && e.R.C) {
                  e.L && e.L.C || (e.R.C = !1, e.C = !0, Fi(this, e), e = i.L), e.C = i.C, i.C = e.L.C = !1, Bi(this, i), t = this._;
                  break;
                }

                e.C = !0, t = i, i = i.U;
              } while (!t.C);

              t && (t.C = !1);
            }
          }
        }, t.geom.voronoi = function (t) {
          var e = ri,
              r = ni,
              n = e,
              i = r,
              a = Vi;
          if (t) return o(t);

          function o(t) {
            var e = new Array(t.length),
                r = a[0][0],
                n = a[0][1],
                i = a[1][0],
                o = a[1][1];
            return ji(s(t), a).cells.forEach(function (a, s) {
              var l = a.edges,
                  c = a.site;
              (e[s] = l.length ? l.map(function (t) {
                var e = t.start();
                return [e.x, e.y];
              }) : c.x >= r && c.x <= i && c.y >= n && c.y <= o ? [[r, o], [i, o], [i, n], [r, n]] : []).point = t[s];
            }), e;
          }

          function s(t) {
            return t.map(function (t, e) {
              return {
                x: Math.round(n(t, e) / kt) * kt,
                y: Math.round(i(t, e) / kt) * kt,
                i: e
              };
            });
          }

          return o.links = function (t) {
            return ji(s(t)).edges.filter(function (t) {
              return t.l && t.r;
            }).map(function (e) {
              return {
                source: t[e.l.i],
                target: t[e.r.i]
              };
            });
          }, o.triangles = function (t) {
            var e = [];
            return ji(s(t)).cells.forEach(function (r, n) {
              for (var i, a, o, s, l = r.site, c = r.edges.sort(Mi), u = -1, f = c.length, h = c[f - 1].edge, p = h.l === l ? h.r : h.l; ++u < f;) {
                h, i = p, p = (h = c[u].edge).l === l ? h.r : h.l, n < i.i && n < p.i && (o = i, s = p, ((a = l).x - s.x) * (o.y - a.y) - (a.x - o.x) * (s.y - a.y) < 0) && e.push([t[n], t[i.i], t[p.i]]);
              }
            }), e;
          }, o.x = function (t) {
            return arguments.length ? (n = de(e = t), o) : e;
          }, o.y = function (t) {
            return arguments.length ? (i = de(r = t), o) : r;
          }, o.clipExtent = function (t) {
            return arguments.length ? (a = null == t ? Vi : t, o) : a === Vi ? null : a;
          }, o.size = function (t) {
            return arguments.length ? o.clipExtent(t && [[0, 0], t]) : a === Vi ? null : a && a[1];
          }, o;
        };
        var Vi = [[-1e6, -1e6], [1e6, 1e6]];

        function qi(t) {
          return t.x;
        }

        function Hi(t) {
          return t.y;
        }

        function Gi(t, e, r, n, i, a) {
          if (!t(e, r, n, i, a)) {
            var o = .5 * (r + i),
                s = .5 * (n + a),
                l = e.nodes;
            l[0] && Gi(t, l[0], r, n, o, s), l[1] && Gi(t, l[1], o, n, i, s), l[2] && Gi(t, l[2], r, s, o, a), l[3] && Gi(t, l[3], o, s, i, a);
          }
        }

        function Yi(t, e, r, n, i, a, o) {
          var s,
              l = 1 / 0;
          return function t(c, u, f, h, p) {
            if (!(u > a || f > o || h < n || p < i)) {
              if (d = c.point) {
                var d,
                    m = e - c.x,
                    g = r - c.y,
                    v = m * m + g * g;

                if (v < l) {
                  var y = Math.sqrt(l = v);
                  n = e - y, i = r - y, a = e + y, o = r + y, s = d;
                }
              }

              for (var x = c.nodes, b = .5 * (u + h), _ = .5 * (f + p), w = (r >= _) << 1 | e >= b, T = w + 4; w < T; ++w) {
                if (c = x[3 & w]) switch (3 & w) {
                  case 0:
                    t(c, u, f, b, _);
                    break;

                  case 1:
                    t(c, b, f, h, _);
                    break;

                  case 2:
                    t(c, u, _, b, p);
                    break;

                  case 3:
                    t(c, b, _, h, p);
                }
              }
            }
          }(t, n, i, a, o), s;
        }

        function Wi(e, r) {
          e = t.rgb(e), r = t.rgb(r);
          var n = e.r,
              i = e.g,
              a = e.b,
              o = r.r - n,
              s = r.g - i,
              l = r.b - a;
          return function (t) {
            return "#" + se(Math.round(n + o * t)) + se(Math.round(i + s * t)) + se(Math.round(a + l * t));
          };
        }

        function Xi(t, e) {
          var r,
              n = {},
              i = {};

          for (r in t) {
            r in e ? n[r] = $i(t[r], e[r]) : i[r] = t[r];
          }

          for (r in e) {
            r in t || (i[r] = e[r]);
          }

          return function (t) {
            for (r in n) {
              i[r] = n[r](t);
            }

            return i;
          };
        }

        function Zi(t, e) {
          return t = +t, e = +e, function (r) {
            return t * (1 - r) + e * r;
          };
        }

        function Ji(t, e) {
          var r,
              n,
              i,
              a = Ki.lastIndex = Qi.lastIndex = 0,
              o = -1,
              s = [],
              l = [];

          for (t += "", e += ""; (r = Ki.exec(t)) && (n = Qi.exec(e));) {
            (i = n.index) > a && (i = e.slice(a, i), s[o] ? s[o] += i : s[++o] = i), (r = r[0]) === (n = n[0]) ? s[o] ? s[o] += n : s[++o] = n : (s[++o] = null, l.push({
              i: o,
              x: Zi(r, n)
            })), a = Qi.lastIndex;
          }

          return a < e.length && (i = e.slice(a), s[o] ? s[o] += i : s[++o] = i), s.length < 2 ? l[0] ? (e = l[0].x, function (t) {
            return e(t) + "";
          }) : function () {
            return e;
          } : (e = l.length, function (t) {
            for (var r, n = 0; n < e; ++n) {
              s[(r = l[n]).i] = r.x(t);
            }

            return s.join("");
          });
        }

        t.geom.delaunay = function (e) {
          return t.geom.voronoi().triangles(e);
        }, t.geom.quadtree = function (t, e, r, n, i) {
          var a,
              o = ri,
              s = ni;
          if (a = arguments.length) return o = qi, s = Hi, 3 === a && (i = r, n = e, r = e = 0), l(t);

          function l(t) {
            var l,
                c,
                u,
                f,
                h,
                p,
                d,
                m,
                g,
                v = de(o),
                x = de(s);
            if (null != e) p = e, d = r, m = n, g = i;else if (m = g = -(p = d = 1 / 0), c = [], u = [], h = t.length, a) for (f = 0; f < h; ++f) {
              (l = t[f]).x < p && (p = l.x), l.y < d && (d = l.y), l.x > m && (m = l.x), l.y > g && (g = l.y), c.push(l.x), u.push(l.y);
            } else for (f = 0; f < h; ++f) {
              var b = +v(l = t[f], f),
                  _ = +x(l, f);

              b < p && (p = b), _ < d && (d = _), b > m && (m = b), _ > g && (g = _), c.push(b), u.push(_);
            }
            var w = m - p,
                T = g - d;

            function k(t, e, r, n, i, a, o, s) {
              if (!isNaN(r) && !isNaN(n)) if (t.leaf) {
                var l = t.x,
                    c = t.y;
                if (null != l) {
                  if (y(l - r) + y(c - n) < .01) M(t, e, r, n, i, a, o, s);else {
                    var u = t.point;
                    t.x = t.y = t.point = null, M(t, u, l, c, i, a, o, s), M(t, e, r, n, i, a, o, s);
                  }
                } else t.x = r, t.y = n, t.point = e;
              } else M(t, e, r, n, i, a, o, s);
            }

            function M(t, e, r, n, i, a, o, s) {
              var l = .5 * (i + o),
                  c = .5 * (a + s),
                  u = r >= l,
                  f = n >= c,
                  h = f << 1 | u;
              t.leaf = !1, u ? i = l : o = l, f ? a = c : s = c, k(t = t.nodes[h] || (t.nodes[h] = {
                leaf: !0,
                nodes: [],
                point: null,
                x: null,
                y: null
              }), e, r, n, i, a, o, s);
            }

            w > T ? g = d + w : m = p + T;
            var A = {
              leaf: !0,
              nodes: [],
              point: null,
              x: null,
              y: null,
              add: function add(t) {
                k(A, t, +v(t, ++f), +x(t, f), p, d, m, g);
              },
              visit: function visit(t) {
                Gi(t, A, p, d, m, g);
              },
              find: function find(t) {
                return Yi(A, t[0], t[1], p, d, m, g);
              }
            };

            if (f = -1, null == e) {
              for (; ++f < h;) {
                k(A, t[f], c[f], u[f], p, d, m, g);
              }

              --f;
            } else t.forEach(A.add);

            return c = u = t = l = null, A;
          }

          return l.x = function (t) {
            return arguments.length ? (o = t, l) : o;
          }, l.y = function (t) {
            return arguments.length ? (s = t, l) : s;
          }, l.extent = function (t) {
            return arguments.length ? (null == t ? e = r = n = i = null : (e = +t[0][0], r = +t[0][1], n = +t[1][0], i = +t[1][1]), l) : null == e ? null : [[e, r], [n, i]];
          }, l.size = function (t) {
            return arguments.length ? (null == t ? e = r = n = i = null : (e = r = 0, n = +t[0], i = +t[1]), l) : null == e ? null : [n - e, i - r];
          }, l;
        }, t.interpolateRgb = Wi, t.interpolateObject = Xi, t.interpolateNumber = Zi, t.interpolateString = Ji;
        var Ki = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
            Qi = new RegExp(Ki.source, "g");

        function $i(e, r) {
          for (var n, i = t.interpolators.length; --i >= 0 && !(n = t.interpolators[i](e, r));) {
            ;
          }

          return n;
        }

        function ta(t, e) {
          var r,
              n = [],
              i = [],
              a = t.length,
              o = e.length,
              s = Math.min(t.length, e.length);

          for (r = 0; r < s; ++r) {
            n.push($i(t[r], e[r]));
          }

          for (; r < a; ++r) {
            i[r] = t[r];
          }

          for (; r < o; ++r) {
            i[r] = e[r];
          }

          return function (t) {
            for (r = 0; r < s; ++r) {
              i[r] = n[r](t);
            }

            return i;
          };
        }

        t.interpolate = $i, t.interpolators = [function (t, e) {
          var r = _typeof(e);

          return ("string" === r ? pe.has(e.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(e) ? Wi : Ji : e instanceof Vt ? Wi : Array.isArray(e) ? ta : "object" === r && isNaN(e) ? Xi : Zi)(t, e);
        }], t.interpolateArray = ta;

        var ea = function ea() {
          return C;
        },
            ra = t.map({
          linear: ea,
          poly: function poly(t) {
            return function (e) {
              return Math.pow(e, t);
            };
          },
          quad: function quad() {
            return sa;
          },
          cubic: function cubic() {
            return la;
          },
          sin: function sin() {
            return ua;
          },
          exp: function exp() {
            return fa;
          },
          circle: function circle() {
            return ha;
          },
          elastic: function elastic(t, e) {
            var r;
            arguments.length < 2 && (e = .45);
            arguments.length ? r = e / St * Math.asin(1 / t) : (t = 1, r = e / 4);
            return function (n) {
              return 1 + t * Math.pow(2, -10 * n) * Math.sin((n - r) * St / e);
            };
          },
          back: function back(t) {
            t || (t = 1.70158);
            return function (e) {
              return e * e * ((t + 1) * e - t);
            };
          },
          bounce: function bounce() {
            return pa;
          }
        }),
            na = t.map({
          in: C,
          out: aa,
          "in-out": oa,
          "out-in": function outIn(t) {
            return oa(aa(t));
          }
        });

        function ia(t) {
          return function (e) {
            return e <= 0 ? 0 : e >= 1 ? 1 : t(e);
          };
        }

        function aa(t) {
          return function (e) {
            return 1 - t(1 - e);
          };
        }

        function oa(t) {
          return function (e) {
            return .5 * (e < .5 ? t(2 * e) : 2 - t(2 - 2 * e));
          };
        }

        function sa(t) {
          return t * t;
        }

        function la(t) {
          return t * t * t;
        }

        function ca(t) {
          if (t <= 0) return 0;
          if (t >= 1) return 1;
          var e = t * t,
              r = e * t;
          return 4 * (t < .5 ? r : 3 * (t - e) + r - .75);
        }

        function ua(t) {
          return 1 - Math.cos(t * Lt);
        }

        function fa(t) {
          return Math.pow(2, 10 * (t - 1));
        }

        function ha(t) {
          return 1 - Math.sqrt(1 - t * t);
        }

        function pa(t) {
          return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
        }

        function da(t, e) {
          return e -= t, function (r) {
            return Math.round(t + e * r);
          };
        }

        function ma(t) {
          var e,
              r,
              n,
              i = [t.a, t.b],
              a = [t.c, t.d],
              o = va(i),
              s = ga(i, a),
              l = va(((e = a)[0] += (n = -s) * (r = i)[0], e[1] += n * r[1], e)) || 0;
          i[0] * a[1] < a[0] * i[1] && (i[0] *= -1, i[1] *= -1, o *= -1, s *= -1), this.rotate = (o ? Math.atan2(i[1], i[0]) : Math.atan2(-a[0], a[1])) * Pt, this.translate = [t.e, t.f], this.scale = [o, l], this.skew = l ? Math.atan2(s, l) * Pt : 0;
        }

        function ga(t, e) {
          return t[0] * e[0] + t[1] * e[1];
        }

        function va(t) {
          var e = Math.sqrt(ga(t, t));
          return e && (t[0] /= e, t[1] /= e), e;
        }

        t.ease = function (t) {
          var e = t.indexOf("-"),
              n = e >= 0 ? t.slice(0, e) : t,
              i = e >= 0 ? t.slice(e + 1) : "in";
          return n = ra.get(n) || ea, ia((i = na.get(i) || C)(n.apply(null, r.call(arguments, 1))));
        }, t.interpolateHcl = function (e, r) {
          e = t.hcl(e), r = t.hcl(r);
          var n = e.h,
              i = e.c,
              a = e.l,
              o = r.h - n,
              s = r.c - i,
              l = r.l - a;
          isNaN(s) && (s = 0, i = isNaN(i) ? r.c : i);
          isNaN(o) ? (o = 0, n = isNaN(n) ? r.h : n) : o > 180 ? o -= 360 : o < -180 && (o += 360);
          return function (t) {
            return Xt(n + o * t, i + s * t, a + l * t) + "";
          };
        }, t.interpolateHsl = function (e, r) {
          e = t.hsl(e), r = t.hsl(r);
          var n = e.h,
              i = e.s,
              a = e.l,
              o = r.h - n,
              s = r.s - i,
              l = r.l - a;
          isNaN(s) && (s = 0, i = isNaN(i) ? r.s : i);
          isNaN(o) ? (o = 0, n = isNaN(n) ? r.h : n) : o > 180 ? o -= 360 : o < -180 && (o += 360);
          return function (t) {
            return Gt(n + o * t, i + s * t, a + l * t) + "";
          };
        }, t.interpolateLab = function (e, r) {
          e = t.lab(e), r = t.lab(r);
          var n = e.l,
              i = e.a,
              a = e.b,
              o = r.l - n,
              s = r.a - i,
              l = r.b - a;
          return function (t) {
            return Qt(n + o * t, i + s * t, a + l * t) + "";
          };
        }, t.interpolateRound = da, t.transform = function (e) {
          var r = i.createElementNS(t.ns.prefix.svg, "g");
          return (t.transform = function (t) {
            if (null != t) {
              r.setAttribute("transform", t);
              var e = r.transform.baseVal.consolidate();
            }

            return new ma(e ? e.matrix : ya);
          })(e);
        }, ma.prototype.toString = function () {
          return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
        };
        var ya = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: 0,
          f: 0
        };

        function xa(t) {
          return t.length ? t.pop() + "," : "";
        }

        function ba(e, r) {
          var n = [],
              i = [];
          return e = t.transform(e), r = t.transform(r), function (t, e, r, n) {
            if (t[0] !== e[0] || t[1] !== e[1]) {
              var i = r.push("translate(", null, ",", null, ")");
              n.push({
                i: i - 4,
                x: Zi(t[0], e[0])
              }, {
                i: i - 2,
                x: Zi(t[1], e[1])
              });
            } else (e[0] || e[1]) && r.push("translate(" + e + ")");
          }(e.translate, r.translate, n, i), function (t, e, r, n) {
            t !== e ? (t - e > 180 ? e += 360 : e - t > 180 && (t += 360), n.push({
              i: r.push(xa(r) + "rotate(", null, ")") - 2,
              x: Zi(t, e)
            })) : e && r.push(xa(r) + "rotate(" + e + ")");
          }(e.rotate, r.rotate, n, i), function (t, e, r, n) {
            t !== e ? n.push({
              i: r.push(xa(r) + "skewX(", null, ")") - 2,
              x: Zi(t, e)
            }) : e && r.push(xa(r) + "skewX(" + e + ")");
          }(e.skew, r.skew, n, i), function (t, e, r, n) {
            if (t[0] !== e[0] || t[1] !== e[1]) {
              var i = r.push(xa(r) + "scale(", null, ",", null, ")");
              n.push({
                i: i - 4,
                x: Zi(t[0], e[0])
              }, {
                i: i - 2,
                x: Zi(t[1], e[1])
              });
            } else 1 === e[0] && 1 === e[1] || r.push(xa(r) + "scale(" + e + ")");
          }(e.scale, r.scale, n, i), e = r = null, function (t) {
            for (var e, r = -1, a = i.length; ++r < a;) {
              n[(e = i[r]).i] = e.x(t);
            }

            return n.join("");
          };
        }

        function _a(t, e) {
          return e = (e -= t = +t) || 1 / e, function (r) {
            return (r - t) / e;
          };
        }

        function wa(t, e) {
          return e = (e -= t = +t) || 1 / e, function (r) {
            return Math.max(0, Math.min(1, (r - t) / e));
          };
        }

        function Ta(t) {
          for (var e = t.source, r = t.target, n = function (t, e) {
            if (t === e) return t;
            var r = ka(t),
                n = ka(e),
                i = r.pop(),
                a = n.pop(),
                o = null;

            for (; i === a;) {
              o = i, i = r.pop(), a = n.pop();
            }

            return o;
          }(e, r), i = [e]; e !== n;) {
            e = e.parent, i.push(e);
          }

          for (var a = i.length; r !== n;) {
            i.splice(a, 0, r), r = r.parent;
          }

          return i;
        }

        function ka(t) {
          for (var e = [], r = t.parent; null != r;) {
            e.push(t), t = r, r = r.parent;
          }

          return e.push(t), e;
        }

        function Ma(t) {
          t.fixed |= 2;
        }

        function Aa(t) {
          t.fixed &= -7;
        }

        function Sa(t) {
          t.fixed |= 4, t.px = t.x, t.py = t.y;
        }

        function Ea(t) {
          t.fixed &= -5;
        }

        t.interpolateTransform = ba, t.layout = {}, t.layout.bundle = function () {
          return function (t) {
            for (var e = [], r = -1, n = t.length; ++r < n;) {
              e.push(Ta(t[r]));
            }

            return e;
          };
        }, t.layout.chord = function () {
          var e,
              r,
              n,
              i,
              a,
              o,
              s,
              l = {},
              c = 0;

          function u() {
            var l,
                u,
                h,
                p,
                d,
                m = {},
                g = [],
                v = t.range(i),
                y = [];

            for (e = [], r = [], l = 0, p = -1; ++p < i;) {
              for (u = 0, d = -1; ++d < i;) {
                u += n[p][d];
              }

              g.push(u), y.push(t.range(i)), l += u;
            }

            for (a && v.sort(function (t, e) {
              return a(g[t], g[e]);
            }), o && y.forEach(function (t, e) {
              t.sort(function (t, r) {
                return o(n[e][t], n[e][r]);
              });
            }), l = (St - c * i) / l, u = 0, p = -1; ++p < i;) {
              for (h = u, d = -1; ++d < i;) {
                var x = v[p],
                    b = y[x][d],
                    _ = n[x][b],
                    w = u,
                    T = u += _ * l;
                m[x + "-" + b] = {
                  index: x,
                  subindex: b,
                  startAngle: w,
                  endAngle: T,
                  value: _
                };
              }

              r[x] = {
                index: x,
                startAngle: h,
                endAngle: u,
                value: g[x]
              }, u += c;
            }

            for (p = -1; ++p < i;) {
              for (d = p - 1; ++d < i;) {
                var k = m[p + "-" + d],
                    M = m[d + "-" + p];
                (k.value || M.value) && e.push(k.value < M.value ? {
                  source: M,
                  target: k
                } : {
                  source: k,
                  target: M
                });
              }
            }

            s && f();
          }

          function f() {
            e.sort(function (t, e) {
              return s((t.source.value + t.target.value) / 2, (e.source.value + e.target.value) / 2);
            });
          }

          return l.matrix = function (t) {
            return arguments.length ? (i = (n = t) && n.length, e = r = null, l) : n;
          }, l.padding = function (t) {
            return arguments.length ? (c = t, e = r = null, l) : c;
          }, l.sortGroups = function (t) {
            return arguments.length ? (a = t, e = r = null, l) : a;
          }, l.sortSubgroups = function (t) {
            return arguments.length ? (o = t, e = null, l) : o;
          }, l.sortChords = function (t) {
            return arguments.length ? (s = t, e && f(), l) : s;
          }, l.chords = function () {
            return e || u(), e;
          }, l.groups = function () {
            return r || u(), r;
          }, l;
        }, t.layout.force = function () {
          var e,
              r,
              n,
              i,
              a,
              o,
              s = {},
              l = t.dispatch("start", "tick", "end"),
              c = [1, 1],
              u = .9,
              f = La,
              h = Ca,
              p = -30,
              d = Pa,
              m = .1,
              g = .64,
              v = [],
              y = [];

          function x(t) {
            return function (e, r, n, i) {
              if (e.point !== t) {
                var a = e.cx - t.x,
                    o = e.cy - t.y,
                    s = i - r,
                    l = a * a + o * o;

                if (s * s / g < l) {
                  if (l < d) {
                    var c = e.charge / l;
                    t.px -= a * c, t.py -= o * c;
                  }

                  return !0;
                }

                if (e.point && l && l < d) {
                  c = e.pointCharge / l;
                  t.px -= a * c, t.py -= o * c;
                }
              }

              return !e.charge;
            };
          }

          function b(e) {
            e.px = t.event.x, e.py = t.event.y, s.resume();
          }

          return s.tick = function () {
            if ((n *= .99) < .005) return e = null, l.end({
              type: "end",
              alpha: n = 0
            }), !0;

            var r,
                s,
                f,
                h,
                d,
                g,
                b,
                _,
                w,
                T = v.length,
                k = y.length;

            for (s = 0; s < k; ++s) {
              h = (f = y[s]).source, (g = (_ = (d = f.target).x - h.x) * _ + (w = d.y - h.y) * w) && (_ *= g = n * a[s] * ((g = Math.sqrt(g)) - i[s]) / g, w *= g, d.x -= _ * (b = h.weight + d.weight ? h.weight / (h.weight + d.weight) : .5), d.y -= w * b, h.x += _ * (b = 1 - b), h.y += w * b);
            }

            if ((b = n * m) && (_ = c[0] / 2, w = c[1] / 2, s = -1, b)) for (; ++s < T;) {
              (f = v[s]).x += (_ - f.x) * b, f.y += (w - f.y) * b;
            }
            if (p) for (!function t(e, r, n) {
              var i = 0,
                  a = 0;
              if (e.charge = 0, !e.leaf) for (var o, s = e.nodes, l = s.length, c = -1; ++c < l;) {
                null != (o = s[c]) && (t(o, r, n), e.charge += o.charge, i += o.charge * o.cx, a += o.charge * o.cy);
              }

              if (e.point) {
                e.leaf || (e.point.x += Math.random() - .5, e.point.y += Math.random() - .5);
                var u = r * n[e.point.index];
                e.charge += e.pointCharge = u, i += u * e.point.x, a += u * e.point.y;
              }

              e.cx = i / e.charge, e.cy = a / e.charge;
            }(r = t.geom.quadtree(v), n, o), s = -1; ++s < T;) {
              (f = v[s]).fixed || r.visit(x(f));
            }

            for (s = -1; ++s < T;) {
              (f = v[s]).fixed ? (f.x = f.px, f.y = f.py) : (f.x -= (f.px - (f.px = f.x)) * u, f.y -= (f.py - (f.py = f.y)) * u);
            }

            l.tick({
              type: "tick",
              alpha: n
            });
          }, s.nodes = function (t) {
            return arguments.length ? (v = t, s) : v;
          }, s.links = function (t) {
            return arguments.length ? (y = t, s) : y;
          }, s.size = function (t) {
            return arguments.length ? (c = t, s) : c;
          }, s.linkDistance = function (t) {
            return arguments.length ? (f = "function" == typeof t ? t : +t, s) : f;
          }, s.distance = s.linkDistance, s.linkStrength = function (t) {
            return arguments.length ? (h = "function" == typeof t ? t : +t, s) : h;
          }, s.friction = function (t) {
            return arguments.length ? (u = +t, s) : u;
          }, s.charge = function (t) {
            return arguments.length ? (p = "function" == typeof t ? t : +t, s) : p;
          }, s.chargeDistance = function (t) {
            return arguments.length ? (d = t * t, s) : Math.sqrt(d);
          }, s.gravity = function (t) {
            return arguments.length ? (m = +t, s) : m;
          }, s.theta = function (t) {
            return arguments.length ? (g = t * t, s) : Math.sqrt(g);
          }, s.alpha = function (t) {
            return arguments.length ? (t = +t, n ? t > 0 ? n = t : (e.c = null, e.t = NaN, e = null, l.end({
              type: "end",
              alpha: n = 0
            })) : t > 0 && (l.start({
              type: "start",
              alpha: n = t
            }), e = we(s.tick)), s) : n;
          }, s.start = function () {
            var t,
                e,
                r,
                n = v.length,
                l = y.length,
                u = c[0],
                d = c[1];

            for (t = 0; t < n; ++t) {
              (r = v[t]).index = t, r.weight = 0;
            }

            for (t = 0; t < l; ++t) {
              "number" == typeof (r = y[t]).source && (r.source = v[r.source]), "number" == typeof r.target && (r.target = v[r.target]), ++r.source.weight, ++r.target.weight;
            }

            for (t = 0; t < n; ++t) {
              r = v[t], isNaN(r.x) && (r.x = m("x", u)), isNaN(r.y) && (r.y = m("y", d)), isNaN(r.px) && (r.px = r.x), isNaN(r.py) && (r.py = r.y);
            }

            if (i = [], "function" == typeof f) for (t = 0; t < l; ++t) {
              i[t] = +f.call(this, y[t], t);
            } else for (t = 0; t < l; ++t) {
              i[t] = f;
            }
            if (a = [], "function" == typeof h) for (t = 0; t < l; ++t) {
              a[t] = +h.call(this, y[t], t);
            } else for (t = 0; t < l; ++t) {
              a[t] = h;
            }
            if (o = [], "function" == typeof p) for (t = 0; t < n; ++t) {
              o[t] = +p.call(this, v[t], t);
            } else for (t = 0; t < n; ++t) {
              o[t] = p;
            }

            function m(r, i) {
              if (!e) {
                for (e = new Array(n), c = 0; c < n; ++c) {
                  e[c] = [];
                }

                for (c = 0; c < l; ++c) {
                  var a = y[c];
                  e[a.source.index].push(a.target), e[a.target.index].push(a.source);
                }
              }

              for (var o, s = e[t], c = -1, u = s.length; ++c < u;) {
                if (!isNaN(o = s[c][r])) return o;
              }

              return Math.random() * i;
            }

            return s.resume();
          }, s.resume = function () {
            return s.alpha(.1);
          }, s.stop = function () {
            return s.alpha(0);
          }, s.drag = function () {
            if (r || (r = t.behavior.drag().origin(C).on("dragstart.force", Ma).on("drag.force", b).on("dragend.force", Aa)), !arguments.length) return r;
            this.on("mouseover.force", Sa).on("mouseout.force", Ea).call(r);
          }, t.rebind(s, l, "on");
        };
        var La = 20,
            Ca = 1,
            Pa = 1 / 0;

        function Ia(e, r) {
          return t.rebind(e, r, "sort", "children", "value"), e.nodes = e, e.links = Ba, e;
        }

        function Oa(t, e) {
          for (var r = [t]; null != (t = r.pop());) {
            if (e(t), (i = t.children) && (n = i.length)) for (var n, i; --n >= 0;) {
              r.push(i[n]);
            }
          }
        }

        function za(t, e) {
          for (var r = [t], n = []; null != (t = r.pop());) {
            if (n.push(t), (a = t.children) && (i = a.length)) for (var i, a, o = -1; ++o < i;) {
              r.push(a[o]);
            }
          }

          for (; null != (t = n.pop());) {
            e(t);
          }
        }

        function Da(t) {
          return t.children;
        }

        function Ra(t) {
          return t.value;
        }

        function Fa(t, e) {
          return e.value - t.value;
        }

        function Ba(e) {
          return t.merge(e.map(function (t) {
            return (t.children || []).map(function (e) {
              return {
                source: t,
                target: e
              };
            });
          }));
        }

        t.layout.hierarchy = function () {
          var t = Fa,
              e = Da,
              r = Ra;

          function n(i) {
            var a,
                o = [i],
                s = [];

            for (i.depth = 0; null != (a = o.pop());) {
              if (s.push(a), (c = e.call(n, a, a.depth)) && (l = c.length)) {
                for (var l, c, u; --l >= 0;) {
                  o.push(u = c[l]), u.parent = a, u.depth = a.depth + 1;
                }

                r && (a.value = 0), a.children = c;
              } else r && (a.value = +r.call(n, a, a.depth) || 0), delete a.children;
            }

            return za(i, function (e) {
              var n, i;
              t && (n = e.children) && n.sort(t), r && (i = e.parent) && (i.value += e.value);
            }), s;
          }

          return n.sort = function (e) {
            return arguments.length ? (t = e, n) : t;
          }, n.children = function (t) {
            return arguments.length ? (e = t, n) : e;
          }, n.value = function (t) {
            return arguments.length ? (r = t, n) : r;
          }, n.revalue = function (t) {
            return r && (Oa(t, function (t) {
              t.children && (t.value = 0);
            }), za(t, function (t) {
              var e;
              t.children || (t.value = +r.call(n, t, t.depth) || 0), (e = t.parent) && (e.value += t.value);
            })), t;
          }, n;
        }, t.layout.partition = function () {
          var e = t.layout.hierarchy(),
              r = [1, 1];

          function n(t, n) {
            var i = e.call(this, t, n);
            return function t(e, r, n, i) {
              var a = e.children;

              if (e.x = r, e.y = e.depth * i, e.dx = n, e.dy = i, a && (o = a.length)) {
                var o,
                    s,
                    l,
                    c = -1;

                for (n = e.value ? n / e.value : 0; ++c < o;) {
                  t(s = a[c], r, l = s.value * n, i), r += l;
                }
              }
            }(i[0], 0, r[0], r[1] / function t(e) {
              var r = e.children,
                  n = 0;
              if (r && (i = r.length)) for (var i, a = -1; ++a < i;) {
                n = Math.max(n, t(r[a]));
              }
              return 1 + n;
            }(i[0])), i;
          }

          return n.size = function (t) {
            return arguments.length ? (r = t, n) : r;
          }, Ia(n, e);
        }, t.layout.pie = function () {
          var e = Number,
              r = Na,
              n = 0,
              i = St,
              a = 0;

          function o(s) {
            var l,
                c = s.length,
                u = s.map(function (t, r) {
              return +e.call(o, t, r);
            }),
                f = +("function" == typeof n ? n.apply(this, arguments) : n),
                h = ("function" == typeof i ? i.apply(this, arguments) : i) - f,
                p = Math.min(Math.abs(h) / c, +("function" == typeof a ? a.apply(this, arguments) : a)),
                d = p * (h < 0 ? -1 : 1),
                m = t.sum(u),
                g = m ? (h - c * d) / m : 0,
                v = t.range(c),
                y = [];
            return null != r && v.sort(r === Na ? function (t, e) {
              return u[e] - u[t];
            } : function (t, e) {
              return r(s[t], s[e]);
            }), v.forEach(function (t) {
              y[t] = {
                data: s[t],
                value: l = u[t],
                startAngle: f,
                endAngle: f += l * g + d,
                padAngle: p
              };
            }), y;
          }

          return o.value = function (t) {
            return arguments.length ? (e = t, o) : e;
          }, o.sort = function (t) {
            return arguments.length ? (r = t, o) : r;
          }, o.startAngle = function (t) {
            return arguments.length ? (n = t, o) : n;
          }, o.endAngle = function (t) {
            return arguments.length ? (i = t, o) : i;
          }, o.padAngle = function (t) {
            return arguments.length ? (a = t, o) : a;
          }, o;
        };
        var Na = {};

        function ja(t) {
          return t.x;
        }

        function Ua(t) {
          return t.y;
        }

        function Va(t, e, r) {
          t.y0 = e, t.y = r;
        }

        t.layout.stack = function () {
          var e = C,
              r = Ga,
              n = Ya,
              i = Va,
              a = ja,
              o = Ua;

          function s(l, c) {
            if (!(p = l.length)) return l;
            var u = l.map(function (t, r) {
              return e.call(s, t, r);
            }),
                f = u.map(function (t) {
              return t.map(function (t, e) {
                return [a.call(s, t, e), o.call(s, t, e)];
              });
            }),
                h = r.call(s, f, c);
            u = t.permute(u, h), f = t.permute(f, h);
            var p,
                d,
                m,
                g,
                v = n.call(s, f, c),
                y = u[0].length;

            for (m = 0; m < y; ++m) {
              for (i.call(s, u[0][m], g = v[m], f[0][m][1]), d = 1; d < p; ++d) {
                i.call(s, u[d][m], g += f[d - 1][m][1], f[d][m][1]);
              }
            }

            return l;
          }

          return s.values = function (t) {
            return arguments.length ? (e = t, s) : e;
          }, s.order = function (t) {
            return arguments.length ? (r = "function" == typeof t ? t : qa.get(t) || Ga, s) : r;
          }, s.offset = function (t) {
            return arguments.length ? (n = "function" == typeof t ? t : Ha.get(t) || Ya, s) : n;
          }, s.x = function (t) {
            return arguments.length ? (a = t, s) : a;
          }, s.y = function (t) {
            return arguments.length ? (o = t, s) : o;
          }, s.out = function (t) {
            return arguments.length ? (i = t, s) : i;
          }, s;
        };

        var qa = t.map({
          "inside-out": function insideOut(e) {
            var r,
                n,
                i = e.length,
                a = e.map(Wa),
                o = e.map(Xa),
                s = t.range(i).sort(function (t, e) {
              return a[t] - a[e];
            }),
                l = 0,
                c = 0,
                u = [],
                f = [];

            for (r = 0; r < i; ++r) {
              n = s[r], l < c ? (l += o[n], u.push(n)) : (c += o[n], f.push(n));
            }

            return f.reverse().concat(u);
          },
          reverse: function reverse(e) {
            return t.range(e.length).reverse();
          },
          default: Ga
        }),
            Ha = t.map({
          silhouette: function silhouette(t) {
            var e,
                r,
                n,
                i = t.length,
                a = t[0].length,
                o = [],
                s = 0,
                l = [];

            for (r = 0; r < a; ++r) {
              for (e = 0, n = 0; e < i; e++) {
                n += t[e][r][1];
              }

              n > s && (s = n), o.push(n);
            }

            for (r = 0; r < a; ++r) {
              l[r] = (s - o[r]) / 2;
            }

            return l;
          },
          wiggle: function wiggle(t) {
            var e,
                r,
                n,
                i,
                a,
                o,
                s,
                l,
                c,
                u = t.length,
                f = t[0],
                h = f.length,
                p = [];

            for (p[0] = l = c = 0, r = 1; r < h; ++r) {
              for (e = 0, i = 0; e < u; ++e) {
                i += t[e][r][1];
              }

              for (e = 0, a = 0, s = f[r][0] - f[r - 1][0]; e < u; ++e) {
                for (n = 0, o = (t[e][r][1] - t[e][r - 1][1]) / (2 * s); n < e; ++n) {
                  o += (t[n][r][1] - t[n][r - 1][1]) / s;
                }

                a += o * t[e][r][1];
              }

              p[r] = l -= i ? a / i * s : 0, l < c && (c = l);
            }

            for (r = 0; r < h; ++r) {
              p[r] -= c;
            }

            return p;
          },
          expand: function expand(t) {
            var e,
                r,
                n,
                i = t.length,
                a = t[0].length,
                o = 1 / i,
                s = [];

            for (r = 0; r < a; ++r) {
              for (e = 0, n = 0; e < i; e++) {
                n += t[e][r][1];
              }

              if (n) for (e = 0; e < i; e++) {
                t[e][r][1] /= n;
              } else for (e = 0; e < i; e++) {
                t[e][r][1] = o;
              }
            }

            for (r = 0; r < a; ++r) {
              s[r] = 0;
            }

            return s;
          },
          zero: Ya
        });

        function Ga(e) {
          return t.range(e.length);
        }

        function Ya(t) {
          for (var e = -1, r = t[0].length, n = []; ++e < r;) {
            n[e] = 0;
          }

          return n;
        }

        function Wa(t) {
          for (var e, r = 1, n = 0, i = t[0][1], a = t.length; r < a; ++r) {
            (e = t[r][1]) > i && (n = r, i = e);
          }

          return n;
        }

        function Xa(t) {
          return t.reduce(Za, 0);
        }

        function Za(t, e) {
          return t + e[1];
        }

        function Ja(t, e) {
          return Ka(t, Math.ceil(Math.log(e.length) / Math.LN2 + 1));
        }

        function Ka(t, e) {
          for (var r = -1, n = +t[0], i = (t[1] - n) / e, a = []; ++r <= e;) {
            a[r] = i * r + n;
          }

          return a;
        }

        function Qa(e) {
          return [t.min(e), t.max(e)];
        }

        function $a(t, e) {
          return t.value - e.value;
        }

        function to(t, e) {
          var r = t._pack_next;
          t._pack_next = e, e._pack_prev = t, e._pack_next = r, r._pack_prev = e;
        }

        function eo(t, e) {
          t._pack_next = e, e._pack_prev = t;
        }

        function ro(t, e) {
          var r = e.x - t.x,
              n = e.y - t.y,
              i = t.r + e.r;
          return .999 * i * i > r * r + n * n;
        }

        function no(t) {
          if ((e = t.children) && (l = e.length)) {
            var e,
                r,
                n,
                i,
                a,
                o,
                s,
                l,
                c = 1 / 0,
                u = -1 / 0,
                f = 1 / 0,
                h = -1 / 0;
            if (e.forEach(io), (r = e[0]).x = -r.r, r.y = 0, x(r), l > 1 && ((n = e[1]).x = n.r, n.y = 0, x(n), l > 2)) for (oo(r, n, i = e[2]), x(i), to(r, i), r._pack_prev = i, to(i, n), n = r._pack_next, a = 3; a < l; a++) {
              oo(r, n, i = e[a]);
              var p = 0,
                  d = 1,
                  m = 1;

              for (o = n._pack_next; o !== n; o = o._pack_next, d++) {
                if (ro(o, i)) {
                  p = 1;
                  break;
                }
              }

              if (1 == p) for (s = r._pack_prev; s !== o._pack_prev && !ro(s, i); s = s._pack_prev, m++) {
                ;
              }
              p ? (d < m || d == m && n.r < r.r ? eo(r, n = o) : eo(r = s, n), a--) : (to(r, i), n = i, x(i));
            }
            var g = (c + u) / 2,
                v = (f + h) / 2,
                y = 0;

            for (a = 0; a < l; a++) {
              (i = e[a]).x -= g, i.y -= v, y = Math.max(y, i.r + Math.sqrt(i.x * i.x + i.y * i.y));
            }

            t.r = y, e.forEach(ao);
          }

          function x(t) {
            c = Math.min(t.x - t.r, c), u = Math.max(t.x + t.r, u), f = Math.min(t.y - t.r, f), h = Math.max(t.y + t.r, h);
          }
        }

        function io(t) {
          t._pack_next = t._pack_prev = t;
        }

        function ao(t) {
          delete t._pack_next, delete t._pack_prev;
        }

        function oo(t, e, r) {
          var n = t.r + r.r,
              i = e.x - t.x,
              a = e.y - t.y;

          if (n && (i || a)) {
            var o = e.r + r.r,
                s = i * i + a * a,
                l = .5 + ((n *= n) - (o *= o)) / (2 * s),
                c = Math.sqrt(Math.max(0, 2 * o * (n + s) - (n -= s) * n - o * o)) / (2 * s);
            r.x = t.x + l * i + c * a, r.y = t.y + l * a - c * i;
          } else r.x = t.x + n, r.y = t.y;
        }

        function so(t, e) {
          return t.parent == e.parent ? 1 : 2;
        }

        function lo(t) {
          var e = t.children;
          return e.length ? e[0] : t.t;
        }

        function co(t) {
          var e,
              r = t.children;
          return (e = r.length) ? r[e - 1] : t.t;
        }

        function uo(t, e, r) {
          var n = r / (e.i - t.i);
          e.c -= n, e.s += r, t.c += n, e.z += r, e.m += r;
        }

        function fo(t, e, r) {
          return t.a.parent === e.parent ? t.a : r;
        }

        function ho(t) {
          return {
            x: t.x,
            y: t.y,
            dx: t.dx,
            dy: t.dy
          };
        }

        function po(t, e) {
          var r = t.x + e[3],
              n = t.y + e[0],
              i = t.dx - e[1] - e[3],
              a = t.dy - e[0] - e[2];
          return i < 0 && (r += i / 2, i = 0), a < 0 && (n += a / 2, a = 0), {
            x: r,
            y: n,
            dx: i,
            dy: a
          };
        }

        function mo(t) {
          var e = t[0],
              r = t[t.length - 1];
          return e < r ? [e, r] : [r, e];
        }

        function go(t) {
          return t.rangeExtent ? t.rangeExtent() : mo(t.range());
        }

        function vo(t, e, r, n) {
          var i = r(t[0], t[1]),
              a = n(e[0], e[1]);
          return function (t) {
            return a(i(t));
          };
        }

        function yo(t, e) {
          var r,
              n = 0,
              i = t.length - 1,
              a = t[n],
              o = t[i];
          return o < a && (r = n, n = i, i = r, r = a, a = o, o = r), t[n] = e.floor(a), t[i] = e.ceil(o), t;
        }

        function xo(t) {
          return t ? {
            floor: function floor(e) {
              return Math.floor(e / t) * t;
            },
            ceil: function ceil(e) {
              return Math.ceil(e / t) * t;
            }
          } : bo;
        }

        t.layout.histogram = function () {
          var e = !0,
              r = Number,
              n = Qa,
              i = Ja;

          function a(a, o) {
            for (var s, l, c = [], u = a.map(r, this), f = n.call(this, u, o), h = i.call(this, f, u, o), p = (o = -1, u.length), d = h.length - 1, m = e ? 1 : 1 / p; ++o < d;) {
              (s = c[o] = []).dx = h[o + 1] - (s.x = h[o]), s.y = 0;
            }

            if (d > 0) for (o = -1; ++o < p;) {
              (l = u[o]) >= f[0] && l <= f[1] && ((s = c[t.bisect(h, l, 1, d) - 1]).y += m, s.push(a[o]));
            }
            return c;
          }

          return a.value = function (t) {
            return arguments.length ? (r = t, a) : r;
          }, a.range = function (t) {
            return arguments.length ? (n = de(t), a) : n;
          }, a.bins = function (t) {
            return arguments.length ? (i = "number" == typeof t ? function (e) {
              return Ka(e, t);
            } : de(t), a) : i;
          }, a.frequency = function (t) {
            return arguments.length ? (e = !!t, a) : e;
          }, a;
        }, t.layout.pack = function () {
          var e,
              r = t.layout.hierarchy().sort($a),
              n = 0,
              i = [1, 1];

          function a(t, a) {
            var o = r.call(this, t, a),
                s = o[0],
                l = i[0],
                c = i[1],
                u = null == e ? Math.sqrt : "function" == typeof e ? e : function () {
              return e;
            };

            if (s.x = s.y = 0, za(s, function (t) {
              t.r = +u(t.value);
            }), za(s, no), n) {
              var f = n * (e ? 1 : Math.max(2 * s.r / l, 2 * s.r / c)) / 2;
              za(s, function (t) {
                t.r += f;
              }), za(s, no), za(s, function (t) {
                t.r -= f;
              });
            }

            return function t(e, r, n, i) {
              var a = e.children;
              if (e.x = r += i * e.x, e.y = n += i * e.y, e.r *= i, a) for (var o = -1, s = a.length; ++o < s;) {
                t(a[o], r, n, i);
              }
            }(s, l / 2, c / 2, e ? 1 : 1 / Math.max(2 * s.r / l, 2 * s.r / c)), o;
          }

          return a.size = function (t) {
            return arguments.length ? (i = t, a) : i;
          }, a.radius = function (t) {
            return arguments.length ? (e = null == t || "function" == typeof t ? t : +t, a) : e;
          }, a.padding = function (t) {
            return arguments.length ? (n = +t, a) : n;
          }, Ia(a, r);
        }, t.layout.tree = function () {
          var e = t.layout.hierarchy().sort(null).value(null),
              r = so,
              n = [1, 1],
              i = null;

          function a(t, a) {
            var c = e.call(this, t, a),
                u = c[0],
                f = function (t) {
              var e,
                  r = {
                A: null,
                children: [t]
              },
                  n = [r];

              for (; null != (e = n.pop());) {
                for (var i, a = e.children, o = 0, s = a.length; o < s; ++o) {
                  n.push((a[o] = i = {
                    _: a[o],
                    parent: e,
                    children: (i = a[o].children) && i.slice() || [],
                    A: null,
                    a: null,
                    z: 0,
                    m: 0,
                    c: 0,
                    s: 0,
                    t: null,
                    i: o
                  }).a = i);
                }
              }

              return r.children[0];
            }(u);

            if (za(f, o), f.parent.m = -f.z, Oa(f, s), i) Oa(u, l);else {
              var h = u,
                  p = u,
                  d = u;
              Oa(u, function (t) {
                t.x < h.x && (h = t), t.x > p.x && (p = t), t.depth > d.depth && (d = t);
              });
              var m = r(h, p) / 2 - h.x,
                  g = n[0] / (p.x + r(p, h) / 2 + m),
                  v = n[1] / (d.depth || 1);
              Oa(u, function (t) {
                t.x = (t.x + m) * g, t.y = t.depth * v;
              });
            }
            return c;
          }

          function o(t) {
            var e = t.children,
                n = t.parent.children,
                i = t.i ? n[t.i - 1] : null;

            if (e.length) {
              !function (t) {
                var e,
                    r = 0,
                    n = 0,
                    i = t.children,
                    a = i.length;

                for (; --a >= 0;) {
                  (e = i[a]).z += r, e.m += r, r += e.s + (n += e.c);
                }
              }(t);
              var a = (e[0].z + e[e.length - 1].z) / 2;
              i ? (t.z = i.z + r(t._, i._), t.m = t.z - a) : t.z = a;
            } else i && (t.z = i.z + r(t._, i._));

            t.parent.A = function (t, e, n) {
              if (e) {
                for (var i, a = t, o = t, s = e, l = a.parent.children[0], c = a.m, u = o.m, f = s.m, h = l.m; s = co(s), a = lo(a), s && a;) {
                  l = lo(l), (o = co(o)).a = t, (i = s.z + f - a.z - c + r(s._, a._)) > 0 && (uo(fo(s, t, n), t, i), c += i, u += i), f += s.m, c += a.m, h += l.m, u += o.m;
                }

                s && !co(o) && (o.t = s, o.m += f - u), a && !lo(l) && (l.t = a, l.m += c - h, n = t);
              }

              return n;
            }(t, i, t.parent.A || n[0]);
          }

          function s(t) {
            t._.x = t.z + t.parent.m, t.m += t.parent.m;
          }

          function l(t) {
            t.x *= n[0], t.y = t.depth * n[1];
          }

          return a.separation = function (t) {
            return arguments.length ? (r = t, a) : r;
          }, a.size = function (t) {
            return arguments.length ? (i = null == (n = t) ? l : null, a) : i ? null : n;
          }, a.nodeSize = function (t) {
            return arguments.length ? (i = null == (n = t) ? null : l, a) : i ? n : null;
          }, Ia(a, e);
        }, t.layout.cluster = function () {
          var e = t.layout.hierarchy().sort(null).value(null),
              r = so,
              n = [1, 1],
              i = !1;

          function a(a, o) {
            var s,
                l = e.call(this, a, o),
                c = l[0],
                u = 0;
            za(c, function (e) {
              var n = e.children;
              n && n.length ? (e.x = function (t) {
                return t.reduce(function (t, e) {
                  return t + e.x;
                }, 0) / t.length;
              }(n), e.y = function (e) {
                return 1 + t.max(e, function (t) {
                  return t.y;
                });
              }(n)) : (e.x = s ? u += r(e, s) : 0, e.y = 0, s = e);
            });

            var f = function t(e) {
              var r = e.children;
              return r && r.length ? t(r[0]) : e;
            }(c),
                h = function t(e) {
              var r,
                  n = e.children;
              return n && (r = n.length) ? t(n[r - 1]) : e;
            }(c),
                p = f.x - r(f, h) / 2,
                d = h.x + r(h, f) / 2;

            return za(c, i ? function (t) {
              t.x = (t.x - c.x) * n[0], t.y = (c.y - t.y) * n[1];
            } : function (t) {
              t.x = (t.x - p) / (d - p) * n[0], t.y = (1 - (c.y ? t.y / c.y : 1)) * n[1];
            }), l;
          }

          return a.separation = function (t) {
            return arguments.length ? (r = t, a) : r;
          }, a.size = function (t) {
            return arguments.length ? (i = null == (n = t), a) : i ? null : n;
          }, a.nodeSize = function (t) {
            return arguments.length ? (i = null != (n = t), a) : i ? n : null;
          }, Ia(a, e);
        }, t.layout.treemap = function () {
          var e,
              r = t.layout.hierarchy(),
              n = Math.round,
              i = [1, 1],
              a = null,
              o = ho,
              s = !1,
              l = "squarify",
              c = .5 * (1 + Math.sqrt(5));

          function u(t, e) {
            for (var r, n, i = -1, a = t.length; ++i < a;) {
              n = (r = t[i]).value * (e < 0 ? 0 : e), r.area = isNaN(n) || n <= 0 ? 0 : n;
            }
          }

          function f(t) {
            var e = t.children;

            if (e && e.length) {
              var r,
                  n,
                  i,
                  a = o(t),
                  s = [],
                  c = e.slice(),
                  h = 1 / 0,
                  m = "slice" === l ? a.dx : "dice" === l ? a.dy : "slice-dice" === l ? 1 & t.depth ? a.dy : a.dx : Math.min(a.dx, a.dy);

              for (u(c, a.dx * a.dy / t.value), s.area = 0; (i = c.length) > 0;) {
                s.push(r = c[i - 1]), s.area += r.area, "squarify" !== l || (n = p(s, m)) <= h ? (c.pop(), h = n) : (s.area -= s.pop().area, d(s, m, a, !1), m = Math.min(a.dx, a.dy), s.length = s.area = 0, h = 1 / 0);
              }

              s.length && (d(s, m, a, !0), s.length = s.area = 0), e.forEach(f);
            }
          }

          function h(t) {
            var e = t.children;

            if (e && e.length) {
              var r,
                  n = o(t),
                  i = e.slice(),
                  a = [];

              for (u(i, n.dx * n.dy / t.value), a.area = 0; r = i.pop();) {
                a.push(r), a.area += r.area, null != r.z && (d(a, r.z ? n.dx : n.dy, n, !i.length), a.length = a.area = 0);
              }

              e.forEach(h);
            }
          }

          function p(t, e) {
            for (var r, n = t.area, i = 0, a = 1 / 0, o = -1, s = t.length; ++o < s;) {
              (r = t[o].area) && (r < a && (a = r), r > i && (i = r));
            }

            return e *= e, (n *= n) ? Math.max(e * i * c / n, n / (e * a * c)) : 1 / 0;
          }

          function d(t, e, r, i) {
            var a,
                o = -1,
                s = t.length,
                l = r.x,
                c = r.y,
                u = e ? n(t.area / e) : 0;

            if (e == r.dx) {
              for ((i || u > r.dy) && (u = r.dy); ++o < s;) {
                (a = t[o]).x = l, a.y = c, a.dy = u, l += a.dx = Math.min(r.x + r.dx - l, u ? n(a.area / u) : 0);
              }

              a.z = !0, a.dx += r.x + r.dx - l, r.y += u, r.dy -= u;
            } else {
              for ((i || u > r.dx) && (u = r.dx); ++o < s;) {
                (a = t[o]).x = l, a.y = c, a.dx = u, c += a.dy = Math.min(r.y + r.dy - c, u ? n(a.area / u) : 0);
              }

              a.z = !1, a.dy += r.y + r.dy - c, r.x += u, r.dx -= u;
            }
          }

          function m(t) {
            var n = e || r(t),
                a = n[0];
            return a.x = a.y = 0, a.value ? (a.dx = i[0], a.dy = i[1]) : a.dx = a.dy = 0, e && r.revalue(a), u([a], a.dx * a.dy / a.value), (e ? h : f)(a), s && (e = n), n;
          }

          return m.size = function (t) {
            return arguments.length ? (i = t, m) : i;
          }, m.padding = function (t) {
            if (!arguments.length) return a;

            function e(e) {
              var r = t.call(m, e, e.depth);
              return null == r ? ho(e) : po(e, "number" == typeof r ? [r, r, r, r] : r);
            }

            function r(e) {
              return po(e, t);
            }

            var n;
            return o = null == (a = t) ? ho : "function" == (n = _typeof(t)) ? e : "number" === n ? (t = [t, t, t, t], r) : r, m;
          }, m.round = function (t) {
            return arguments.length ? (n = t ? Math.round : Number, m) : n != Number;
          }, m.sticky = function (t) {
            return arguments.length ? (s = t, e = null, m) : s;
          }, m.ratio = function (t) {
            return arguments.length ? (c = t, m) : c;
          }, m.mode = function (t) {
            return arguments.length ? (l = t + "", m) : l;
          }, Ia(m, r);
        }, t.random = {
          normal: function normal(t, e) {
            var r = arguments.length;
            return r < 2 && (e = 1), r < 1 && (t = 0), function () {
              var r, n, i;

              do {
                i = (r = 2 * Math.random() - 1) * r + (n = 2 * Math.random() - 1) * n;
              } while (!i || i > 1);

              return t + e * r * Math.sqrt(-2 * Math.log(i) / i);
            };
          },
          logNormal: function logNormal() {
            var e = t.random.normal.apply(t, arguments);
            return function () {
              return Math.exp(e());
            };
          },
          bates: function bates(e) {
            var r = t.random.irwinHall(e);
            return function () {
              return r() / e;
            };
          },
          irwinHall: function irwinHall(t) {
            return function () {
              for (var e = 0, r = 0; r < t; r++) {
                e += Math.random();
              }

              return e;
            };
          }
        }, t.scale = {};
        var bo = {
          floor: C,
          ceil: C
        };

        function _o(e, r, n, i) {
          var a = [],
              o = [],
              s = 0,
              l = Math.min(e.length, r.length) - 1;

          for (e[l] < e[0] && (e = e.slice().reverse(), r = r.slice().reverse()); ++s <= l;) {
            a.push(n(e[s - 1], e[s])), o.push(i(r[s - 1], r[s]));
          }

          return function (r) {
            var n = t.bisect(e, r, 1, l) - 1;
            return o[n](a[n](r));
          };
        }

        function wo(e, r) {
          return t.rebind(e, r, "range", "rangeRound", "interpolate", "clamp");
        }

        function To(t, e) {
          return yo(t, xo(ko(t, e)[2])), yo(t, xo(ko(t, e)[2])), t;
        }

        function ko(t, e) {
          null == e && (e = 10);
          var r = mo(t),
              n = r[1] - r[0],
              i = Math.pow(10, Math.floor(Math.log(n / e) / Math.LN10)),
              a = e / n * i;
          return a <= .15 ? i *= 10 : a <= .35 ? i *= 5 : a <= .75 && (i *= 2), r[0] = Math.ceil(r[0] / i) * i, r[1] = Math.floor(r[1] / i) * i + .5 * i, r[2] = i, r;
        }

        function Mo(e, r) {
          return t.range.apply(t, ko(e, r));
        }

        function Ao(e, r, n) {
          var i = ko(e, r);

          if (n) {
            var a = Le.exec(n);

            if (a.shift(), "s" === a[8]) {
              var o = t.formatPrefix(Math.max(y(i[0]), y(i[1])));
              return a[7] || (a[7] = "." + Eo(o.scale(i[2]))), a[8] = "f", n = t.format(a.join("")), function (t) {
                return n(o.scale(t)) + o.symbol;
              };
            }

            a[7] || (a[7] = "." + function (t, e) {
              var r = Eo(e[2]);
              return t in So ? Math.abs(r - Eo(Math.max(y(e[0]), y(e[1])))) + +("e" !== t) : r - 2 * ("%" === t);
            }(a[8], i)), n = a.join("");
          } else n = ",." + Eo(i[2]) + "f";

          return t.format(n);
        }

        t.scale.linear = function () {
          return function t(e, r, n, i) {
            var a, o;

            function s() {
              var t = Math.min(e.length, r.length) > 2 ? _o : vo,
                  s = i ? wa : _a;
              return a = t(e, r, s, n), o = t(r, e, s, $i), l;
            }

            function l(t) {
              return a(t);
            }

            return l.invert = function (t) {
              return o(t);
            }, l.domain = function (t) {
              return arguments.length ? (e = t.map(Number), s()) : e;
            }, l.range = function (t) {
              return arguments.length ? (r = t, s()) : r;
            }, l.rangeRound = function (t) {
              return l.range(t).interpolate(da);
            }, l.clamp = function (t) {
              return arguments.length ? (i = t, s()) : i;
            }, l.interpolate = function (t) {
              return arguments.length ? (n = t, s()) : n;
            }, l.ticks = function (t) {
              return Mo(e, t);
            }, l.tickFormat = function (t, r) {
              return Ao(e, t, r);
            }, l.nice = function (t) {
              return To(e, t), s();
            }, l.copy = function () {
              return t(e, r, n, i);
            }, s();
          }([0, 1], [0, 1], $i, !1);
        };

        var So = {
          s: 1,
          g: 1,
          p: 1,
          r: 1,
          e: 1
        };

        function Eo(t) {
          return -Math.floor(Math.log(t) / Math.LN10 + .01);
        }

        t.scale.log = function () {
          return function e(r, n, i, a) {
            function o(t) {
              return (i ? Math.log(t < 0 ? 0 : t) : -Math.log(t > 0 ? 0 : -t)) / Math.log(n);
            }

            function s(t) {
              return i ? Math.pow(n, t) : -Math.pow(n, -t);
            }

            function l(t) {
              return r(o(t));
            }

            return l.invert = function (t) {
              return s(r.invert(t));
            }, l.domain = function (t) {
              return arguments.length ? (i = t[0] >= 0, r.domain((a = t.map(Number)).map(o)), l) : a;
            }, l.base = function (t) {
              return arguments.length ? (n = +t, r.domain(a.map(o)), l) : n;
            }, l.nice = function () {
              var t = yo(a.map(o), i ? Math : Co);
              return r.domain(t), a = t.map(s), l;
            }, l.ticks = function () {
              var t = mo(a),
                  e = [],
                  r = t[0],
                  l = t[1],
                  c = Math.floor(o(r)),
                  u = Math.ceil(o(l)),
                  f = n % 1 ? 2 : n;

              if (isFinite(u - c)) {
                if (i) {
                  for (; c < u; c++) {
                    for (var h = 1; h < f; h++) {
                      e.push(s(c) * h);
                    }
                  }

                  e.push(s(c));
                } else for (e.push(s(c)); c++ < u;) {
                  for (h = f - 1; h > 0; h--) {
                    e.push(s(c) * h);
                  }
                }

                for (c = 0; e[c] < r; c++) {
                  ;
                }

                for (u = e.length; e[u - 1] > l; u--) {
                  ;
                }

                e = e.slice(c, u);
              }

              return e;
            }, l.tickFormat = function (e, r) {
              if (!arguments.length) return Lo;
              arguments.length < 2 ? r = Lo : "function" != typeof r && (r = t.format(r));
              var i = Math.max(1, n * e / l.ticks().length);
              return function (t) {
                var e = t / s(Math.round(o(t)));
                return e * n < n - .5 && (e *= n), e <= i ? r(t) : "";
              };
            }, l.copy = function () {
              return e(r.copy(), n, i, a);
            }, wo(l, r);
          }(t.scale.linear().domain([0, 1]), 10, !0, [1, 10]);
        };

        var Lo = t.format(".0e"),
            Co = {
          floor: function floor(t) {
            return -Math.ceil(-t);
          },
          ceil: function ceil(t) {
            return -Math.floor(-t);
          }
        };

        function Po(t) {
          return function (e) {
            return e < 0 ? -Math.pow(-e, t) : Math.pow(e, t);
          };
        }

        t.scale.pow = function () {
          return function t(e, r, n) {
            var i = Po(r),
                a = Po(1 / r);

            function o(t) {
              return e(i(t));
            }

            return o.invert = function (t) {
              return a(e.invert(t));
            }, o.domain = function (t) {
              return arguments.length ? (e.domain((n = t.map(Number)).map(i)), o) : n;
            }, o.ticks = function (t) {
              return Mo(n, t);
            }, o.tickFormat = function (t, e) {
              return Ao(n, t, e);
            }, o.nice = function (t) {
              return o.domain(To(n, t));
            }, o.exponent = function (t) {
              return arguments.length ? (i = Po(r = t), a = Po(1 / r), e.domain(n.map(i)), o) : r;
            }, o.copy = function () {
              return t(e.copy(), r, n);
            }, wo(o, e);
          }(t.scale.linear(), 1, [0, 1]);
        }, t.scale.sqrt = function () {
          return t.scale.pow().exponent(.5);
        }, t.scale.ordinal = function () {
          return function e(r, n) {
            var i, a, o;

            function s(t) {
              return a[((i.get(t) || ("range" === n.t ? i.set(t, r.push(t)) : NaN)) - 1) % a.length];
            }

            function l(e, n) {
              return t.range(r.length).map(function (t) {
                return e + n * t;
              });
            }

            return s.domain = function (t) {
              if (!arguments.length) return r;
              r = [], i = new _();

              for (var e, a = -1, o = t.length; ++a < o;) {
                i.has(e = t[a]) || i.set(e, r.push(e));
              }

              return s[n.t].apply(s, n.a);
            }, s.range = function (t) {
              return arguments.length ? (a = t, o = 0, n = {
                t: "range",
                a: arguments
              }, s) : a;
            }, s.rangePoints = function (t, e) {
              arguments.length < 2 && (e = 0);
              var i = t[0],
                  c = t[1],
                  u = r.length < 2 ? (i = (i + c) / 2, 0) : (c - i) / (r.length - 1 + e);
              return a = l(i + u * e / 2, u), o = 0, n = {
                t: "rangePoints",
                a: arguments
              }, s;
            }, s.rangeRoundPoints = function (t, e) {
              arguments.length < 2 && (e = 0);
              var i = t[0],
                  c = t[1],
                  u = r.length < 2 ? (i = c = Math.round((i + c) / 2), 0) : (c - i) / (r.length - 1 + e) | 0;
              return a = l(i + Math.round(u * e / 2 + (c - i - (r.length - 1 + e) * u) / 2), u), o = 0, n = {
                t: "rangeRoundPoints",
                a: arguments
              }, s;
            }, s.rangeBands = function (t, e, i) {
              arguments.length < 2 && (e = 0), arguments.length < 3 && (i = e);
              var c = t[1] < t[0],
                  u = t[c - 0],
                  f = t[1 - c],
                  h = (f - u) / (r.length - e + 2 * i);
              return a = l(u + h * i, h), c && a.reverse(), o = h * (1 - e), n = {
                t: "rangeBands",
                a: arguments
              }, s;
            }, s.rangeRoundBands = function (t, e, i) {
              arguments.length < 2 && (e = 0), arguments.length < 3 && (i = e);
              var c = t[1] < t[0],
                  u = t[c - 0],
                  f = t[1 - c],
                  h = Math.floor((f - u) / (r.length - e + 2 * i));
              return a = l(u + Math.round((f - u - (r.length - e) * h) / 2), h), c && a.reverse(), o = Math.round(h * (1 - e)), n = {
                t: "rangeRoundBands",
                a: arguments
              }, s;
            }, s.rangeBand = function () {
              return o;
            }, s.rangeExtent = function () {
              return mo(n.a[0]);
            }, s.copy = function () {
              return e(r, n);
            }, s.domain(r);
          }([], {
            t: "range",
            a: [[]]
          });
        }, t.scale.category10 = function () {
          return t.scale.ordinal().range(Io);
        }, t.scale.category20 = function () {
          return t.scale.ordinal().range(Oo);
        }, t.scale.category20b = function () {
          return t.scale.ordinal().range(zo);
        }, t.scale.category20c = function () {
          return t.scale.ordinal().range(Do);
        };
        var Io = [2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175].map(ae),
            Oo = [2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725].map(ae),
            zo = [3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654].map(ae),
            Do = [3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081].map(ae);

        function Ro() {
          return 0;
        }

        t.scale.quantile = function () {
          return function e(r, n) {
            var i;

            function a() {
              var e = 0,
                  a = n.length;

              for (i = []; ++e < a;) {
                i[e - 1] = t.quantile(r, e / a);
              }

              return o;
            }

            function o(e) {
              if (!isNaN(e = +e)) return n[t.bisect(i, e)];
            }

            return o.domain = function (t) {
              return arguments.length ? (r = t.map(p).filter(d).sort(h), a()) : r;
            }, o.range = function (t) {
              return arguments.length ? (n = t, a()) : n;
            }, o.quantiles = function () {
              return i;
            }, o.invertExtent = function (t) {
              return (t = n.indexOf(t)) < 0 ? [NaN, NaN] : [t > 0 ? i[t - 1] : r[0], t < i.length ? i[t] : r[r.length - 1]];
            }, o.copy = function () {
              return e(r, n);
            }, a();
          }([], []);
        }, t.scale.quantize = function () {
          return function t(e, r, n) {
            var i, a;

            function o(t) {
              return n[Math.max(0, Math.min(a, Math.floor(i * (t - e))))];
            }

            function s() {
              return i = n.length / (r - e), a = n.length - 1, o;
            }

            return o.domain = function (t) {
              return arguments.length ? (e = +t[0], r = +t[t.length - 1], s()) : [e, r];
            }, o.range = function (t) {
              return arguments.length ? (n = t, s()) : n;
            }, o.invertExtent = function (t) {
              return [t = (t = n.indexOf(t)) < 0 ? NaN : t / i + e, t + 1 / i];
            }, o.copy = function () {
              return t(e, r, n);
            }, s();
          }(0, 1, [0, 1]);
        }, t.scale.threshold = function () {
          return function e(r, n) {
            function i(e) {
              if (e <= e) return n[t.bisect(r, e)];
            }

            return i.domain = function (t) {
              return arguments.length ? (r = t, i) : r;
            }, i.range = function (t) {
              return arguments.length ? (n = t, i) : n;
            }, i.invertExtent = function (t) {
              return t = n.indexOf(t), [r[t - 1], r[t]];
            }, i.copy = function () {
              return e(r, n);
            }, i;
          }([.5], [0, 1]);
        }, t.scale.identity = function () {
          return function t(e) {
            function r(t) {
              return +t;
            }

            return r.invert = r, r.domain = r.range = function (t) {
              return arguments.length ? (e = t.map(r), r) : e;
            }, r.ticks = function (t) {
              return Mo(e, t);
            }, r.tickFormat = function (t, r) {
              return Ao(e, t, r);
            }, r.copy = function () {
              return t(e);
            }, r;
          }([0, 1]);
        }, t.svg = {}, t.svg.arc = function () {
          var t = Bo,
              e = No,
              r = Ro,
              n = Fo,
              i = jo,
              a = Uo,
              o = Vo;

          function s() {
            var s = Math.max(0, +t.apply(this, arguments)),
                c = Math.max(0, +e.apply(this, arguments)),
                u = i.apply(this, arguments) - Lt,
                f = a.apply(this, arguments) - Lt,
                h = Math.abs(f - u),
                p = u > f ? 0 : 1;
            if (c < s && (d = c, c = s, s = d), h >= Et) return l(c, p) + (s ? l(s, 1 - p) : "") + "Z";

            var d,
                m,
                g,
                v,
                y,
                x,
                b,
                _,
                w,
                T,
                k,
                M,
                A = 0,
                S = 0,
                E = [];

            if ((v = (+o.apply(this, arguments) || 0) / 2) && (g = n === Fo ? Math.sqrt(s * s + c * c) : +n.apply(this, arguments), p || (S *= -1), c && (S = Dt(g / c * Math.sin(v))), s && (A = Dt(g / s * Math.sin(v)))), c) {
              y = c * Math.cos(u + S), x = c * Math.sin(u + S), b = c * Math.cos(f - S), _ = c * Math.sin(f - S);
              var L = Math.abs(f - u - 2 * S) <= At ? 0 : 1;

              if (S && qo(y, x, b, _) === p ^ L) {
                var C = (u + f) / 2;
                y = c * Math.cos(C), x = c * Math.sin(C), b = _ = null;
              }
            } else y = x = 0;

            if (s) {
              w = s * Math.cos(f - A), T = s * Math.sin(f - A), k = s * Math.cos(u + A), M = s * Math.sin(u + A);
              var P = Math.abs(u - f + 2 * A) <= At ? 0 : 1;

              if (A && qo(w, T, k, M) === 1 - p ^ P) {
                var I = (u + f) / 2;
                w = s * Math.cos(I), T = s * Math.sin(I), k = M = null;
              }
            } else w = T = 0;

            if (h > kt && (d = Math.min(Math.abs(c - s) / 2, +r.apply(this, arguments))) > .001) {
              m = s < c ^ p ? 0 : 1;
              var O = d,
                  z = d;

              if (h < At) {
                var D = null == k ? [w, T] : null == b ? [y, x] : li([y, x], [k, M], [b, _], [w, T]),
                    R = y - D[0],
                    F = x - D[1],
                    B = b - D[0],
                    N = _ - D[1],
                    j = 1 / Math.sin(Math.acos((R * B + F * N) / (Math.sqrt(R * R + F * F) * Math.sqrt(B * B + N * N))) / 2),
                    U = Math.sqrt(D[0] * D[0] + D[1] * D[1]);
                z = Math.min(d, (s - U) / (j - 1)), O = Math.min(d, (c - U) / (j + 1));
              }

              if (null != b) {
                var V = Ho(null == k ? [w, T] : [k, M], [y, x], c, O, p),
                    q = Ho([b, _], [w, T], c, O, p);
                d === O ? E.push("M", V[0], "A", O, ",", O, " 0 0,", m, " ", V[1], "A", c, ",", c, " 0 ", 1 - p ^ qo(V[1][0], V[1][1], q[1][0], q[1][1]), ",", p, " ", q[1], "A", O, ",", O, " 0 0,", m, " ", q[0]) : E.push("M", V[0], "A", O, ",", O, " 0 1,", m, " ", q[0]);
              } else E.push("M", y, ",", x);

              if (null != k) {
                var H = Ho([y, x], [k, M], s, -z, p),
                    G = Ho([w, T], null == b ? [y, x] : [b, _], s, -z, p);
                d === z ? E.push("L", G[0], "A", z, ",", z, " 0 0,", m, " ", G[1], "A", s, ",", s, " 0 ", p ^ qo(G[1][0], G[1][1], H[1][0], H[1][1]), ",", 1 - p, " ", H[1], "A", z, ",", z, " 0 0,", m, " ", H[0]) : E.push("L", G[0], "A", z, ",", z, " 0 0,", m, " ", H[0]);
              } else E.push("L", w, ",", T);
            } else E.push("M", y, ",", x), null != b && E.push("A", c, ",", c, " 0 ", L, ",", p, " ", b, ",", _), E.push("L", w, ",", T), null != k && E.push("A", s, ",", s, " 0 ", P, ",", 1 - p, " ", k, ",", M);

            return E.push("Z"), E.join("");
          }

          function l(t, e) {
            return "M0," + t + "A" + t + "," + t + " 0 1," + e + " 0," + -t + "A" + t + "," + t + " 0 1," + e + " 0," + t;
          }

          return s.innerRadius = function (e) {
            return arguments.length ? (t = de(e), s) : t;
          }, s.outerRadius = function (t) {
            return arguments.length ? (e = de(t), s) : e;
          }, s.cornerRadius = function (t) {
            return arguments.length ? (r = de(t), s) : r;
          }, s.padRadius = function (t) {
            return arguments.length ? (n = t == Fo ? Fo : de(t), s) : n;
          }, s.startAngle = function (t) {
            return arguments.length ? (i = de(t), s) : i;
          }, s.endAngle = function (t) {
            return arguments.length ? (a = de(t), s) : a;
          }, s.padAngle = function (t) {
            return arguments.length ? (o = de(t), s) : o;
          }, s.centroid = function () {
            var r = (+t.apply(this, arguments) + +e.apply(this, arguments)) / 2,
                n = (+i.apply(this, arguments) + +a.apply(this, arguments)) / 2 - Lt;
            return [Math.cos(n) * r, Math.sin(n) * r];
          }, s;
        };
        var Fo = "auto";

        function Bo(t) {
          return t.innerRadius;
        }

        function No(t) {
          return t.outerRadius;
        }

        function jo(t) {
          return t.startAngle;
        }

        function Uo(t) {
          return t.endAngle;
        }

        function Vo(t) {
          return t && t.padAngle;
        }

        function qo(t, e, r, n) {
          return (t - r) * e - (e - n) * t > 0 ? 0 : 1;
        }

        function Ho(t, e, r, n, i) {
          var a = t[0] - e[0],
              o = t[1] - e[1],
              s = (i ? n : -n) / Math.sqrt(a * a + o * o),
              l = s * o,
              c = -s * a,
              u = t[0] + l,
              f = t[1] + c,
              h = e[0] + l,
              p = e[1] + c,
              d = (u + h) / 2,
              m = (f + p) / 2,
              g = h - u,
              v = p - f,
              y = g * g + v * v,
              x = r - n,
              b = u * p - h * f,
              _ = (v < 0 ? -1 : 1) * Math.sqrt(Math.max(0, x * x * y - b * b)),
              w = (b * v - g * _) / y,
              T = (-b * g - v * _) / y,
              k = (b * v + g * _) / y,
              M = (-b * g + v * _) / y,
              A = w - d,
              S = T - m,
              E = k - d,
              L = M - m;

          return A * A + S * S > E * E + L * L && (w = k, T = M), [[w - l, T - c], [w * r / x, T * r / x]];
        }

        function Go(t) {
          var e = ri,
              r = ni,
              n = Yr,
              i = Wo,
              a = i.key,
              o = .7;

          function s(a) {
            var s,
                l = [],
                c = [],
                u = -1,
                f = a.length,
                h = de(e),
                p = de(r);

            function d() {
              l.push("M", i(t(c), o));
            }

            for (; ++u < f;) {
              n.call(this, s = a[u], u) ? c.push([+h.call(this, s, u), +p.call(this, s, u)]) : c.length && (d(), c = []);
            }

            return c.length && d(), l.length ? l.join("") : null;
          }

          return s.x = function (t) {
            return arguments.length ? (e = t, s) : e;
          }, s.y = function (t) {
            return arguments.length ? (r = t, s) : r;
          }, s.defined = function (t) {
            return arguments.length ? (n = t, s) : n;
          }, s.interpolate = function (t) {
            return arguments.length ? (a = "function" == typeof t ? i = t : (i = Yo.get(t) || Wo).key, s) : a;
          }, s.tension = function (t) {
            return arguments.length ? (o = t, s) : o;
          }, s;
        }

        t.svg.line = function () {
          return Go(C);
        };

        var Yo = t.map({
          linear: Wo,
          "linear-closed": Xo,
          step: function step(t) {
            var e = 0,
                r = t.length,
                n = t[0],
                i = [n[0], ",", n[1]];

            for (; ++e < r;) {
              i.push("H", (n[0] + (n = t[e])[0]) / 2, "V", n[1]);
            }

            r > 1 && i.push("H", n[0]);
            return i.join("");
          },
          "step-before": Zo,
          "step-after": Jo,
          basis: $o,
          "basis-open": function basisOpen(t) {
            if (t.length < 4) return Wo(t);
            var e,
                r = [],
                n = -1,
                i = t.length,
                a = [0],
                o = [0];

            for (; ++n < 3;) {
              e = t[n], a.push(e[0]), o.push(e[1]);
            }

            r.push(ts(ns, a) + "," + ts(ns, o)), --n;

            for (; ++n < i;) {
              e = t[n], a.shift(), a.push(e[0]), o.shift(), o.push(e[1]), is(r, a, o);
            }

            return r.join("");
          },
          "basis-closed": function basisClosed(t) {
            var e,
                r,
                n = -1,
                i = t.length,
                a = i + 4,
                o = [],
                s = [];

            for (; ++n < 4;) {
              r = t[n % i], o.push(r[0]), s.push(r[1]);
            }

            e = [ts(ns, o), ",", ts(ns, s)], --n;

            for (; ++n < a;) {
              r = t[n % i], o.shift(), o.push(r[0]), s.shift(), s.push(r[1]), is(e, o, s);
            }

            return e.join("");
          },
          bundle: function bundle(t, e) {
            var r = t.length - 1;
            if (r) for (var n, i, a = t[0][0], o = t[0][1], s = t[r][0] - a, l = t[r][1] - o, c = -1; ++c <= r;) {
              n = t[c], i = c / r, n[0] = e * n[0] + (1 - e) * (a + i * s), n[1] = e * n[1] + (1 - e) * (o + i * l);
            }
            return $o(t);
          },
          cardinal: function cardinal(t, e) {
            return t.length < 3 ? Wo(t) : t[0] + Ko(t, Qo(t, e));
          },
          "cardinal-open": function cardinalOpen(t, e) {
            return t.length < 4 ? Wo(t) : t[1] + Ko(t.slice(1, -1), Qo(t, e));
          },
          "cardinal-closed": function cardinalClosed(t, e) {
            return t.length < 3 ? Xo(t) : t[0] + Ko((t.push(t[0]), t), Qo([t[t.length - 2]].concat(t, [t[1]]), e));
          },
          monotone: function monotone(t) {
            return t.length < 3 ? Wo(t) : t[0] + Ko(t, function (t) {
              var e,
                  r,
                  n,
                  i,
                  a = [],
                  o = function (t) {
                var e = 0,
                    r = t.length - 1,
                    n = [],
                    i = t[0],
                    a = t[1],
                    o = n[0] = as(i, a);

                for (; ++e < r;) {
                  n[e] = (o + (o = as(i = a, a = t[e + 1]))) / 2;
                }

                return n[e] = o, n;
              }(t),
                  s = -1,
                  l = t.length - 1;

              for (; ++s < l;) {
                e = as(t[s], t[s + 1]), y(e) < kt ? o[s] = o[s + 1] = 0 : (r = o[s] / e, n = o[s + 1] / e, (i = r * r + n * n) > 9 && (i = 3 * e / Math.sqrt(i), o[s] = i * r, o[s + 1] = i * n));
              }

              s = -1;

              for (; ++s <= l;) {
                i = (t[Math.min(l, s + 1)][0] - t[Math.max(0, s - 1)][0]) / (6 * (1 + o[s] * o[s])), a.push([i || 0, o[s] * i || 0]);
              }

              return a;
            }(t));
          }
        });

        function Wo(t) {
          return t.length > 1 ? t.join("L") : t + "Z";
        }

        function Xo(t) {
          return t.join("L") + "Z";
        }

        function Zo(t) {
          for (var e = 0, r = t.length, n = t[0], i = [n[0], ",", n[1]]; ++e < r;) {
            i.push("V", (n = t[e])[1], "H", n[0]);
          }

          return i.join("");
        }

        function Jo(t) {
          for (var e = 0, r = t.length, n = t[0], i = [n[0], ",", n[1]]; ++e < r;) {
            i.push("H", (n = t[e])[0], "V", n[1]);
          }

          return i.join("");
        }

        function Ko(t, e) {
          if (e.length < 1 || t.length != e.length && t.length != e.length + 2) return Wo(t);
          var r = t.length != e.length,
              n = "",
              i = t[0],
              a = t[1],
              o = e[0],
              s = o,
              l = 1;

          if (r && (n += "Q" + (a[0] - 2 * o[0] / 3) + "," + (a[1] - 2 * o[1] / 3) + "," + a[0] + "," + a[1], i = t[1], l = 2), e.length > 1) {
            s = e[1], a = t[l], l++, n += "C" + (i[0] + o[0]) + "," + (i[1] + o[1]) + "," + (a[0] - s[0]) + "," + (a[1] - s[1]) + "," + a[0] + "," + a[1];

            for (var c = 2; c < e.length; c++, l++) {
              a = t[l], s = e[c], n += "S" + (a[0] - s[0]) + "," + (a[1] - s[1]) + "," + a[0] + "," + a[1];
            }
          }

          if (r) {
            var u = t[l];
            n += "Q" + (a[0] + 2 * s[0] / 3) + "," + (a[1] + 2 * s[1] / 3) + "," + u[0] + "," + u[1];
          }

          return n;
        }

        function Qo(t, e) {
          for (var r, n = [], i = (1 - e) / 2, a = t[0], o = t[1], s = 1, l = t.length; ++s < l;) {
            r = a, a = o, o = t[s], n.push([i * (o[0] - r[0]), i * (o[1] - r[1])]);
          }

          return n;
        }

        function $o(t) {
          if (t.length < 3) return Wo(t);
          var e = 1,
              r = t.length,
              n = t[0],
              i = n[0],
              a = n[1],
              o = [i, i, i, (n = t[1])[0]],
              s = [a, a, a, n[1]],
              l = [i, ",", a, "L", ts(ns, o), ",", ts(ns, s)];

          for (t.push(t[r - 1]); ++e <= r;) {
            n = t[e], o.shift(), o.push(n[0]), s.shift(), s.push(n[1]), is(l, o, s);
          }

          return t.pop(), l.push("L", n), l.join("");
        }

        function ts(t, e) {
          return t[0] * e[0] + t[1] * e[1] + t[2] * e[2] + t[3] * e[3];
        }

        Yo.forEach(function (t, e) {
          e.key = t, e.closed = /-closed$/.test(t);
        });
        var es = [0, 2 / 3, 1 / 3, 0],
            rs = [0, 1 / 3, 2 / 3, 0],
            ns = [0, 1 / 6, 2 / 3, 1 / 6];

        function is(t, e, r) {
          t.push("C", ts(es, e), ",", ts(es, r), ",", ts(rs, e), ",", ts(rs, r), ",", ts(ns, e), ",", ts(ns, r));
        }

        function as(t, e) {
          return (e[1] - t[1]) / (e[0] - t[0]);
        }

        function os(t) {
          for (var e, r, n, i = -1, a = t.length; ++i < a;) {
            r = (e = t[i])[0], n = e[1] - Lt, e[0] = r * Math.cos(n), e[1] = r * Math.sin(n);
          }

          return t;
        }

        function ss(t) {
          var e = ri,
              r = ri,
              n = 0,
              i = ni,
              a = Yr,
              o = Wo,
              s = o.key,
              l = o,
              c = "L",
              u = .7;

          function f(s) {
            var f,
                h,
                p,
                d = [],
                m = [],
                g = [],
                v = -1,
                y = s.length,
                x = de(e),
                b = de(n),
                _ = e === r ? function () {
              return h;
            } : de(r),
                w = n === i ? function () {
              return p;
            } : de(i);

            function T() {
              d.push("M", o(t(g), u), c, l(t(m.reverse()), u), "Z");
            }

            for (; ++v < y;) {
              a.call(this, f = s[v], v) ? (m.push([h = +x.call(this, f, v), p = +b.call(this, f, v)]), g.push([+_.call(this, f, v), +w.call(this, f, v)])) : m.length && (T(), m = [], g = []);
            }

            return m.length && T(), d.length ? d.join("") : null;
          }

          return f.x = function (t) {
            return arguments.length ? (e = r = t, f) : r;
          }, f.x0 = function (t) {
            return arguments.length ? (e = t, f) : e;
          }, f.x1 = function (t) {
            return arguments.length ? (r = t, f) : r;
          }, f.y = function (t) {
            return arguments.length ? (n = i = t, f) : i;
          }, f.y0 = function (t) {
            return arguments.length ? (n = t, f) : n;
          }, f.y1 = function (t) {
            return arguments.length ? (i = t, f) : i;
          }, f.defined = function (t) {
            return arguments.length ? (a = t, f) : a;
          }, f.interpolate = function (t) {
            return arguments.length ? (s = "function" == typeof t ? o = t : (o = Yo.get(t) || Wo).key, l = o.reverse || o, c = o.closed ? "M" : "L", f) : s;
          }, f.tension = function (t) {
            return arguments.length ? (u = t, f) : u;
          }, f;
        }

        function ls(t) {
          return t.radius;
        }

        function cs(t) {
          return [t.x, t.y];
        }

        function us(t) {
          return function () {
            var e = t.apply(this, arguments),
                r = e[0],
                n = e[1] - Lt;
            return [r * Math.cos(n), r * Math.sin(n)];
          };
        }

        function fs() {
          return 64;
        }

        function hs() {
          return "circle";
        }

        function ps(t) {
          var e = Math.sqrt(t / At);
          return "M0," + e + "A" + e + "," + e + " 0 1,1 0," + -e + "A" + e + "," + e + " 0 1,1 0," + e + "Z";
        }

        t.svg.line.radial = function () {
          var t = Go(os);
          return t.radius = t.x, delete t.x, t.angle = t.y, delete t.y, t;
        }, Zo.reverse = Jo, Jo.reverse = Zo, t.svg.area = function () {
          return ss(C);
        }, t.svg.area.radial = function () {
          var t = ss(os);
          return t.radius = t.x, delete t.x, t.innerRadius = t.x0, delete t.x0, t.outerRadius = t.x1, delete t.x1, t.angle = t.y, delete t.y, t.startAngle = t.y0, delete t.y0, t.endAngle = t.y1, delete t.y1, t;
        }, t.svg.chord = function () {
          var t = Vn,
              e = qn,
              r = ls,
              n = jo,
              i = Uo;

          function a(r, n) {
            var i,
                a,
                c = o(this, t, r, n),
                u = o(this, e, r, n);
            return "M" + c.p0 + s(c.r, c.p1, c.a1 - c.a0) + (a = u, ((i = c).a0 == a.a0 && i.a1 == a.a1 ? l(c.r, c.p1, c.r, c.p0) : l(c.r, c.p1, u.r, u.p0) + s(u.r, u.p1, u.a1 - u.a0) + l(u.r, u.p1, c.r, c.p0)) + "Z");
          }

          function o(t, e, a, o) {
            var s = e.call(t, a, o),
                l = r.call(t, s, o),
                c = n.call(t, s, o) - Lt,
                u = i.call(t, s, o) - Lt;
            return {
              r: l,
              a0: c,
              a1: u,
              p0: [l * Math.cos(c), l * Math.sin(c)],
              p1: [l * Math.cos(u), l * Math.sin(u)]
            };
          }

          function s(t, e, r) {
            return "A" + t + "," + t + " 0 " + +(r > At) + ",1 " + e;
          }

          function l(t, e, r, n) {
            return "Q 0,0 " + n;
          }

          return a.radius = function (t) {
            return arguments.length ? (r = de(t), a) : r;
          }, a.source = function (e) {
            return arguments.length ? (t = de(e), a) : t;
          }, a.target = function (t) {
            return arguments.length ? (e = de(t), a) : e;
          }, a.startAngle = function (t) {
            return arguments.length ? (n = de(t), a) : n;
          }, a.endAngle = function (t) {
            return arguments.length ? (i = de(t), a) : i;
          }, a;
        }, t.svg.diagonal = function () {
          var t = Vn,
              e = qn,
              r = cs;

          function n(n, i) {
            var a = t.call(this, n, i),
                o = e.call(this, n, i),
                s = (a.y + o.y) / 2,
                l = [a, {
              x: a.x,
              y: s
            }, {
              x: o.x,
              y: s
            }, o];
            return "M" + (l = l.map(r))[0] + "C" + l[1] + " " + l[2] + " " + l[3];
          }

          return n.source = function (e) {
            return arguments.length ? (t = de(e), n) : t;
          }, n.target = function (t) {
            return arguments.length ? (e = de(t), n) : e;
          }, n.projection = function (t) {
            return arguments.length ? (r = t, n) : r;
          }, n;
        }, t.svg.diagonal.radial = function () {
          var e = t.svg.diagonal(),
              r = cs,
              n = e.projection;
          return e.projection = function (t) {
            return arguments.length ? n(us(r = t)) : r;
          }, e;
        }, t.svg.symbol = function () {
          var t = hs,
              e = fs;

          function r(r, n) {
            return (ds.get(t.call(this, r, n)) || ps)(e.call(this, r, n));
          }

          return r.type = function (e) {
            return arguments.length ? (t = de(e), r) : t;
          }, r.size = function (t) {
            return arguments.length ? (e = de(t), r) : e;
          }, r;
        };
        var ds = t.map({
          circle: ps,
          cross: function cross(t) {
            var e = Math.sqrt(t / 5) / 2;
            return "M" + -3 * e + "," + -e + "H" + -e + "V" + -3 * e + "H" + e + "V" + -e + "H" + 3 * e + "V" + e + "H" + e + "V" + 3 * e + "H" + -e + "V" + e + "H" + -3 * e + "Z";
          },
          diamond: function diamond(t) {
            var e = Math.sqrt(t / (2 * gs)),
                r = e * gs;
            return "M0," + -e + "L" + r + ",0 0," + e + " " + -r + ",0Z";
          },
          square: function square(t) {
            var e = Math.sqrt(t) / 2;
            return "M" + -e + "," + -e + "L" + e + "," + -e + " " + e + "," + e + " " + -e + "," + e + "Z";
          },
          "triangle-down": function triangleDown(t) {
            var e = Math.sqrt(t / ms),
                r = e * ms / 2;
            return "M0," + r + "L" + e + "," + -r + " " + -e + "," + -r + "Z";
          },
          "triangle-up": function triangleUp(t) {
            var e = Math.sqrt(t / ms),
                r = e * ms / 2;
            return "M0," + -r + "L" + e + "," + r + " " + -e + "," + r + "Z";
          }
        });
        t.svg.symbolTypes = ds.keys();
        var ms = Math.sqrt(3),
            gs = Math.tan(30 * Ct);
        Y.transition = function (t) {
          for (var e, r, n = bs || ++Ts, i = As(t), a = [], o = _s || {
            time: Date.now(),
            ease: ca,
            delay: 0,
            duration: 250
          }, s = -1, l = this.length; ++s < l;) {
            a.push(e = []);

            for (var c = this[s], u = -1, f = c.length; ++u < f;) {
              (r = c[u]) && Ss(r, u, i, n, o), e.push(r);
            }
          }

          return xs(a, i, n);
        }, Y.interrupt = function (t) {
          return this.each(null == t ? vs : ys(As(t)));
        };
        var vs = ys(As());

        function ys(t) {
          return function () {
            var e, r, n;
            (e = this[t]) && (n = e[r = e.active]) && (n.timer.c = null, n.timer.t = NaN, --e.count ? delete e[r] : delete this[t], e.active += .5, n.event && n.event.interrupt.call(this, this.__data__, n.index));
          };
        }

        function xs(t, e, r) {
          return U(t, ws), t.namespace = e, t.id = r, t;
        }

        var bs,
            _s,
            ws = [],
            Ts = 0;

        function ks(t, e, r, n) {
          var i = t.id,
              a = t.namespace;
          return ut(t, "function" == typeof r ? function (t, o, s) {
            t[a][i].tween.set(e, n(r.call(t, t.__data__, o, s)));
          } : (r = n(r), function (t) {
            t[a][i].tween.set(e, r);
          }));
        }

        function Ms(t) {
          return null == t && (t = ""), function () {
            this.textContent = t;
          };
        }

        function As(t) {
          return null == t ? "__transition__" : "__transition_" + t + "__";
        }

        function Ss(t, e, r, n, i) {
          var a,
              o,
              s,
              l,
              c,
              u = t[r] || (t[r] = {
            active: 0,
            count: 0
          }),
              f = u[n];

          function h(r) {
            var i = u.active,
                h = u[i];

            for (var d in h && (h.timer.c = null, h.timer.t = NaN, --u.count, delete u[i], h.event && h.event.interrupt.call(t, t.__data__, h.index)), u) {
              if (+d < n) {
                var m = u[d];
                m.timer.c = null, m.timer.t = NaN, --u.count, delete u[d];
              }
            }

            o.c = p, we(function () {
              return o.c && p(r || 1) && (o.c = null, o.t = NaN), 1;
            }, 0, a), u.active = n, f.event && f.event.start.call(t, t.__data__, e), c = [], f.tween.forEach(function (r, n) {
              (n = n.call(t, t.__data__, e)) && c.push(n);
            }), l = f.ease, s = f.duration;
          }

          function p(i) {
            for (var a = i / s, o = l(a), h = c.length; h > 0;) {
              c[--h].call(t, o);
            }

            if (a >= 1) return f.event && f.event.end.call(t, t.__data__, e), --u.count ? delete u[n] : delete t[r], 1;
          }

          f || (a = i.time, o = we(function (t) {
            var e = f.delay;
            if (o.t = e + a, e <= t) return h(t - e);
            o.c = h;
          }, 0, a), f = u[n] = {
            tween: new _(),
            time: a,
            timer: o,
            delay: i.delay,
            duration: i.duration,
            ease: i.ease,
            index: e
          }, i = null, ++u.count);
        }

        ws.call = Y.call, ws.empty = Y.empty, ws.node = Y.node, ws.size = Y.size, t.transition = function (e, r) {
          return e && e.transition ? bs ? e.transition(r) : e : t.selection().transition(e);
        }, t.transition.prototype = ws, ws.select = function (t) {
          var e,
              r,
              n,
              i = this.id,
              a = this.namespace,
              o = [];
          t = W(t);

          for (var s = -1, l = this.length; ++s < l;) {
            o.push(e = []);

            for (var c = this[s], u = -1, f = c.length; ++u < f;) {
              (n = c[u]) && (r = t.call(n, n.__data__, u, s)) ? ("__data__" in n && (r.__data__ = n.__data__), Ss(r, u, a, i, n[a][i]), e.push(r)) : e.push(null);
            }
          }

          return xs(o, a, i);
        }, ws.selectAll = function (t) {
          var e,
              r,
              n,
              i,
              a,
              o = this.id,
              s = this.namespace,
              l = [];
          t = X(t);

          for (var c = -1, u = this.length; ++c < u;) {
            for (var f = this[c], h = -1, p = f.length; ++h < p;) {
              if (n = f[h]) {
                a = n[s][o], r = t.call(n, n.__data__, h, c), l.push(e = []);

                for (var d = -1, m = r.length; ++d < m;) {
                  (i = r[d]) && Ss(i, d, s, o, a), e.push(i);
                }
              }
            }
          }

          return xs(l, s, o);
        }, ws.filter = function (t) {
          var e,
              r,
              n = [];
          "function" != typeof t && (t = lt(t));

          for (var i = 0, a = this.length; i < a; i++) {
            n.push(e = []);

            for (var o, s = 0, l = (o = this[i]).length; s < l; s++) {
              (r = o[s]) && t.call(r, r.__data__, s, i) && e.push(r);
            }
          }

          return xs(n, this.namespace, this.id);
        }, ws.tween = function (t, e) {
          var r = this.id,
              n = this.namespace;
          return arguments.length < 2 ? this.node()[n][r].tween.get(t) : ut(this, null == e ? function (e) {
            e[n][r].tween.remove(t);
          } : function (i) {
            i[n][r].tween.set(t, e);
          });
        }, ws.attr = function (e, r) {
          if (arguments.length < 2) {
            for (r in e) {
              this.attr(r, e[r]);
            }

            return this;
          }

          var n = "transform" == e ? ba : $i,
              i = t.ns.qualify(e);

          function a() {
            this.removeAttribute(i);
          }

          function o() {
            this.removeAttributeNS(i.space, i.local);
          }

          function s(t) {
            return null == t ? a : (t += "", function () {
              var e,
                  r = this.getAttribute(i);
              return r !== t && (e = n(r, t), function (t) {
                this.setAttribute(i, e(t));
              });
            });
          }

          function l(t) {
            return null == t ? o : (t += "", function () {
              var e,
                  r = this.getAttributeNS(i.space, i.local);
              return r !== t && (e = n(r, t), function (t) {
                this.setAttributeNS(i.space, i.local, e(t));
              });
            });
          }

          return ks(this, "attr." + e, r, i.local ? l : s);
        }, ws.attrTween = function (e, r) {
          var n = t.ns.qualify(e);
          return this.tween("attr." + e, n.local ? function (t, e) {
            var i = r.call(this, t, e, this.getAttributeNS(n.space, n.local));
            return i && function (t) {
              this.setAttributeNS(n.space, n.local, i(t));
            };
          } : function (t, e) {
            var i = r.call(this, t, e, this.getAttribute(n));
            return i && function (t) {
              this.setAttribute(n, i(t));
            };
          });
        }, ws.style = function (t, e, r) {
          var n = arguments.length;

          if (n < 3) {
            if ("string" != typeof t) {
              for (r in n < 2 && (e = ""), t) {
                this.style(r, t[r], e);
              }

              return this;
            }

            r = "";
          }

          function i() {
            this.style.removeProperty(t);
          }

          function a(e) {
            return null == e ? i : (e += "", function () {
              var n,
                  i = o(this).getComputedStyle(this, null).getPropertyValue(t);
              return i !== e && (n = $i(i, e), function (e) {
                this.style.setProperty(t, n(e), r);
              });
            });
          }

          return ks(this, "style." + t, e, a);
        }, ws.styleTween = function (t, e, r) {
          function n(n, i) {
            var a = e.call(this, n, i, o(this).getComputedStyle(this, null).getPropertyValue(t));
            return a && function (e) {
              this.style.setProperty(t, a(e), r);
            };
          }

          return arguments.length < 3 && (r = ""), this.tween("style." + t, n);
        }, ws.text = function (t) {
          return ks(this, "text", t, Ms);
        }, ws.remove = function () {
          var t = this.namespace;
          return this.each("end.transition", function () {
            var e;
            this[t].count < 2 && (e = this.parentNode) && e.removeChild(this);
          });
        }, ws.ease = function (e) {
          var r = this.id,
              n = this.namespace;
          return arguments.length < 1 ? this.node()[n][r].ease : ("function" != typeof e && (e = t.ease.apply(t, arguments)), ut(this, function (t) {
            t[n][r].ease = e;
          }));
        }, ws.delay = function (t) {
          var e = this.id,
              r = this.namespace;
          return arguments.length < 1 ? this.node()[r][e].delay : ut(this, "function" == typeof t ? function (n, i, a) {
            n[r][e].delay = +t.call(n, n.__data__, i, a);
          } : (t = +t, function (n) {
            n[r][e].delay = t;
          }));
        }, ws.duration = function (t) {
          var e = this.id,
              r = this.namespace;
          return arguments.length < 1 ? this.node()[r][e].duration : ut(this, "function" == typeof t ? function (n, i, a) {
            n[r][e].duration = Math.max(1, t.call(n, n.__data__, i, a));
          } : (t = Math.max(1, t), function (n) {
            n[r][e].duration = t;
          }));
        }, ws.each = function (e, r) {
          var n = this.id,
              i = this.namespace;

          if (arguments.length < 2) {
            var a = _s,
                o = bs;

            try {
              bs = n, ut(this, function (t, r, a) {
                _s = t[i][n], e.call(t, t.__data__, r, a);
              });
            } finally {
              _s = a, bs = o;
            }
          } else ut(this, function (a) {
            var o = a[i][n];
            (o.event || (o.event = t.dispatch("start", "end", "interrupt"))).on(e, r);
          });

          return this;
        }, ws.transition = function () {
          for (var t, e, r, n = this.id, i = ++Ts, a = this.namespace, o = [], s = 0, l = this.length; s < l; s++) {
            o.push(t = []);

            for (var c, u = 0, f = (c = this[s]).length; u < f; u++) {
              (e = c[u]) && Ss(e, u, a, i, {
                time: (r = e[a][n]).time,
                ease: r.ease,
                delay: r.delay + r.duration,
                duration: r.duration
              }), t.push(e);
            }
          }

          return xs(o, a, i);
        }, t.svg.axis = function () {
          var e,
              r = t.scale.linear(),
              i = Es,
              a = 6,
              o = 6,
              s = 3,
              l = [10],
              c = null;

          function u(n) {
            n.each(function () {
              var n,
                  u = t.select(this),
                  f = this.__chart__ || r,
                  h = this.__chart__ = r.copy(),
                  p = null == c ? h.ticks ? h.ticks.apply(h, l) : h.domain() : c,
                  d = null == e ? h.tickFormat ? h.tickFormat.apply(h, l) : C : e,
                  m = u.selectAll(".tick").data(p, h),
                  g = m.enter().insert("g", ".domain").attr("class", "tick").style("opacity", kt),
                  v = t.transition(m.exit()).style("opacity", kt).remove(),
                  y = t.transition(m.order()).style("opacity", 1),
                  x = Math.max(a, 0) + s,
                  b = go(h),
                  _ = u.selectAll(".domain").data([0]),
                  w = (_.enter().append("path").attr("class", "domain"), t.transition(_));

              g.append("line"), g.append("text");
              var T,
                  k,
                  M,
                  A,
                  S = g.select("line"),
                  E = y.select("line"),
                  L = m.select("text").text(d),
                  P = g.select("text"),
                  I = y.select("text"),
                  O = "top" === i || "left" === i ? -1 : 1;

              if ("bottom" === i || "top" === i ? (n = Cs, T = "x", M = "y", k = "x2", A = "y2", L.attr("dy", O < 0 ? "0em" : ".71em").style("text-anchor", "middle"), w.attr("d", "M" + b[0] + "," + O * o + "V0H" + b[1] + "V" + O * o)) : (n = Ps, T = "y", M = "x", k = "y2", A = "x2", L.attr("dy", ".32em").style("text-anchor", O < 0 ? "end" : "start"), w.attr("d", "M" + O * o + "," + b[0] + "H0V" + b[1] + "H" + O * o)), S.attr(A, O * a), P.attr(M, O * x), E.attr(k, 0).attr(A, O * a), I.attr(T, 0).attr(M, O * x), h.rangeBand) {
                var z = h,
                    D = z.rangeBand() / 2;

                f = h = function h(t) {
                  return z(t) + D;
                };
              } else f.rangeBand ? f = h : v.call(n, h, f);

              g.call(n, f, h), y.call(n, h, h);
            });
          }

          return u.scale = function (t) {
            return arguments.length ? (r = t, u) : r;
          }, u.orient = function (t) {
            return arguments.length ? (i = t in Ls ? t + "" : Es, u) : i;
          }, u.ticks = function () {
            return arguments.length ? (l = n(arguments), u) : l;
          }, u.tickValues = function (t) {
            return arguments.length ? (c = t, u) : c;
          }, u.tickFormat = function (t) {
            return arguments.length ? (e = t, u) : e;
          }, u.tickSize = function (t) {
            var e = arguments.length;
            return e ? (a = +t, o = +arguments[e - 1], u) : a;
          }, u.innerTickSize = function (t) {
            return arguments.length ? (a = +t, u) : a;
          }, u.outerTickSize = function (t) {
            return arguments.length ? (o = +t, u) : o;
          }, u.tickPadding = function (t) {
            return arguments.length ? (s = +t, u) : s;
          }, u.tickSubdivide = function () {
            return arguments.length && u;
          }, u;
        };
        var Es = "bottom",
            Ls = {
          top: 1,
          right: 1,
          bottom: 1,
          left: 1
        };

        function Cs(t, e, r) {
          t.attr("transform", function (t) {
            var n = e(t);
            return "translate(" + (isFinite(n) ? n : r(t)) + ",0)";
          });
        }

        function Ps(t, e, r) {
          t.attr("transform", function (t) {
            var n = e(t);
            return "translate(0," + (isFinite(n) ? n : r(t)) + ")";
          });
        }

        t.svg.brush = function () {
          var e,
              r,
              n = N(h, "brushstart", "brush", "brushend"),
              i = null,
              a = null,
              s = [0, 0],
              l = [0, 0],
              c = !0,
              u = !0,
              f = Os[0];

          function h(e) {
            e.each(function () {
              var e = t.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", g).on("touchstart.brush", g),
                  r = e.selectAll(".background").data([0]);
              r.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair"), e.selectAll(".extent").data([0]).enter().append("rect").attr("class", "extent").style("cursor", "move");
              var n = e.selectAll(".resize").data(f, C);
              n.exit().remove(), n.enter().append("g").attr("class", function (t) {
                return "resize " + t;
              }).style("cursor", function (t) {
                return Is[t];
              }).append("rect").attr("x", function (t) {
                return /[ew]$/.test(t) ? -3 : null;
              }).attr("y", function (t) {
                return /^[ns]/.test(t) ? -3 : null;
              }).attr("width", 6).attr("height", 6).style("visibility", "hidden"), n.style("display", h.empty() ? "none" : null);
              var o,
                  s = t.transition(e),
                  l = t.transition(r);
              i && (o = go(i), l.attr("x", o[0]).attr("width", o[1] - o[0]), d(s)), a && (o = go(a), l.attr("y", o[0]).attr("height", o[1] - o[0]), m(s)), p(s);
            });
          }

          function p(t) {
            t.selectAll(".resize").attr("transform", function (t) {
              return "translate(" + s[+/e$/.test(t)] + "," + l[+/^s/.test(t)] + ")";
            });
          }

          function d(t) {
            t.select(".extent").attr("x", s[0]), t.selectAll(".extent,.n>rect,.s>rect").attr("width", s[1] - s[0]);
          }

          function m(t) {
            t.select(".extent").attr("y", l[0]), t.selectAll(".extent,.e>rect,.w>rect").attr("height", l[1] - l[0]);
          }

          function g() {
            var f,
                g,
                v = this,
                y = t.select(t.event.target),
                x = n.of(v, arguments),
                b = t.select(v),
                _ = y.datum(),
                w = !/^(n|s)$/.test(_) && i,
                T = !/^(e|w)$/.test(_) && a,
                k = y.classed("extent"),
                M = bt(v),
                A = t.mouse(v),
                S = t.select(o(v)).on("keydown.brush", C).on("keyup.brush", P);

            if (t.event.changedTouches ? S.on("touchmove.brush", I).on("touchend.brush", z) : S.on("mousemove.brush", I).on("mouseup.brush", z), b.interrupt().selectAll("*").interrupt(), k) A[0] = s[0] - A[0], A[1] = l[0] - A[1];else if (_) {
              var E = +/w$/.test(_),
                  L = +/^n/.test(_);
              g = [s[1 - E] - A[0], l[1 - L] - A[1]], A[0] = s[E], A[1] = l[L];
            } else t.event.altKey && (f = A.slice());

            function C() {
              32 == t.event.keyCode && (k || (f = null, A[0] -= s[1], A[1] -= l[1], k = 2), F());
            }

            function P() {
              32 == t.event.keyCode && 2 == k && (A[0] += s[1], A[1] += l[1], k = 0, F());
            }

            function I() {
              var e = t.mouse(v),
                  r = !1;
              g && (e[0] += g[0], e[1] += g[1]), k || (t.event.altKey ? (f || (f = [(s[0] + s[1]) / 2, (l[0] + l[1]) / 2]), A[0] = s[+(e[0] < f[0])], A[1] = l[+(e[1] < f[1])]) : f = null), w && O(e, i, 0) && (d(b), r = !0), T && O(e, a, 1) && (m(b), r = !0), r && (p(b), x({
                type: "brush",
                mode: k ? "move" : "resize"
              }));
            }

            function O(t, n, i) {
              var a,
                  o,
                  h = go(n),
                  p = h[0],
                  d = h[1],
                  m = A[i],
                  g = i ? l : s,
                  v = g[1] - g[0];
              if (k && (p -= m, d -= v + m), a = (i ? u : c) ? Math.max(p, Math.min(d, t[i])) : t[i], k ? o = (a += m) + v : (f && (m = Math.max(p, Math.min(d, 2 * f[i] - a))), m < a ? (o = a, a = m) : o = m), g[0] != a || g[1] != o) return i ? r = null : e = null, g[0] = a, g[1] = o, !0;
            }

            function z() {
              I(), b.style("pointer-events", "all").selectAll(".resize").style("display", h.empty() ? "none" : null), t.select("body").style("cursor", null), S.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null), M(), x({
                type: "brushend"
              });
            }

            b.style("pointer-events", "none").selectAll(".resize").style("display", null), t.select("body").style("cursor", y.style("cursor")), x({
              type: "brushstart"
            }), I();
          }

          return h.event = function (i) {
            i.each(function () {
              var i = n.of(this, arguments),
                  a = {
                x: s,
                y: l,
                i: e,
                j: r
              },
                  o = this.__chart__ || a;
              this.__chart__ = a, bs ? t.select(this).transition().each("start.brush", function () {
                e = o.i, r = o.j, s = o.x, l = o.y, i({
                  type: "brushstart"
                });
              }).tween("brush:brush", function () {
                var t = ta(s, a.x),
                    n = ta(l, a.y);
                return e = r = null, function (e) {
                  s = a.x = t(e), l = a.y = n(e), i({
                    type: "brush",
                    mode: "resize"
                  });
                };
              }).each("end.brush", function () {
                e = a.i, r = a.j, i({
                  type: "brush",
                  mode: "resize"
                }), i({
                  type: "brushend"
                });
              }) : (i({
                type: "brushstart"
              }), i({
                type: "brush",
                mode: "resize"
              }), i({
                type: "brushend"
              }));
            });
          }, h.x = function (t) {
            return arguments.length ? (f = Os[!(i = t) << 1 | !a], h) : i;
          }, h.y = function (t) {
            return arguments.length ? (f = Os[!i << 1 | !(a = t)], h) : a;
          }, h.clamp = function (t) {
            return arguments.length ? (i && a ? (c = !!t[0], u = !!t[1]) : i ? c = !!t : a && (u = !!t), h) : i && a ? [c, u] : i ? c : a ? u : null;
          }, h.extent = function (t) {
            var n, o, c, u, f;
            return arguments.length ? (i && (n = t[0], o = t[1], a && (n = n[0], o = o[0]), e = [n, o], i.invert && (n = i(n), o = i(o)), o < n && (f = n, n = o, o = f), n == s[0] && o == s[1] || (s = [n, o])), a && (c = t[0], u = t[1], i && (c = c[1], u = u[1]), r = [c, u], a.invert && (c = a(c), u = a(u)), u < c && (f = c, c = u, u = f), c == l[0] && u == l[1] || (l = [c, u])), h) : (i && (e ? (n = e[0], o = e[1]) : (n = s[0], o = s[1], i.invert && (n = i.invert(n), o = i.invert(o)), o < n && (f = n, n = o, o = f))), a && (r ? (c = r[0], u = r[1]) : (c = l[0], u = l[1], a.invert && (c = a.invert(c), u = a.invert(u)), u < c && (f = c, c = u, u = f))), i && a ? [[n, c], [o, u]] : i ? [n, o] : a && [c, u]);
          }, h.clear = function () {
            return h.empty() || (s = [0, 0], l = [0, 0], e = r = null), h;
          }, h.empty = function () {
            return !!i && s[0] == s[1] || !!a && l[0] == l[1];
          }, t.rebind(h, n, "on");
        };

        var Is = {
          n: "ns-resize",
          e: "ew-resize",
          s: "ns-resize",
          w: "ew-resize",
          nw: "nwse-resize",
          ne: "nesw-resize",
          se: "nwse-resize",
          sw: "nesw-resize"
        },
            Os = [["n", "e", "s", "w", "nw", "ne", "se", "sw"], ["e", "w"], ["n", "s"], []],
            zs = Ie.format = sr.timeFormat,
            Ds = zs.utc,
            Rs = Ds("%Y-%m-%dT%H:%M:%S.%LZ");

        function Fs(t) {
          return t.toISOString();
        }

        function Bs(e, r, n) {
          function i(t) {
            return e(t);
          }

          function a(e, n) {
            var i = (e[1] - e[0]) / n,
                a = t.bisect(js, i);
            return a == js.length ? [r.year, ko(e.map(function (t) {
              return t / 31536e6;
            }), n)[2]] : a ? r[i / js[a - 1] < js[a] / i ? a - 1 : a] : [qs, ko(e, n)[2]];
          }

          return i.invert = function (t) {
            return Ns(e.invert(t));
          }, i.domain = function (t) {
            return arguments.length ? (e.domain(t), i) : e.domain().map(Ns);
          }, i.nice = function (t, e) {
            var r = i.domain(),
                n = mo(r),
                o = null == t ? a(n, 10) : "number" == typeof t && a(n, t);

            function s(r) {
              return !isNaN(r) && !t.range(r, Ns(+r + 1), e).length;
            }

            return o && (t = o[0], e = o[1]), i.domain(yo(r, e > 1 ? {
              floor: function floor(e) {
                for (; s(e = t.floor(e));) {
                  e = Ns(e - 1);
                }

                return e;
              },
              ceil: function ceil(e) {
                for (; s(e = t.ceil(e));) {
                  e = Ns(+e + 1);
                }

                return e;
              }
            } : t));
          }, i.ticks = function (t, e) {
            var r = mo(i.domain()),
                n = null == t ? a(r, 10) : "number" == typeof t ? a(r, t) : !t.range && [{
              range: t
            }, e];
            return n && (t = n[0], e = n[1]), t.range(r[0], Ns(+r[1] + 1), e < 1 ? 1 : e);
          }, i.tickFormat = function () {
            return n;
          }, i.copy = function () {
            return Bs(e.copy(), r, n);
          }, wo(i, e);
        }

        function Ns(t) {
          return new Date(t);
        }

        zs.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? Fs : Rs, Fs.parse = function (t) {
          var e = new Date(t);
          return isNaN(e) ? null : e;
        }, Fs.toString = Rs.toString, Ie.second = Re(function (t) {
          return new Oe(1e3 * Math.floor(t / 1e3));
        }, function (t, e) {
          t.setTime(t.getTime() + 1e3 * Math.floor(e));
        }, function (t) {
          return t.getSeconds();
        }), Ie.seconds = Ie.second.range, Ie.seconds.utc = Ie.second.utc.range, Ie.minute = Re(function (t) {
          return new Oe(6e4 * Math.floor(t / 6e4));
        }, function (t, e) {
          t.setTime(t.getTime() + 6e4 * Math.floor(e));
        }, function (t) {
          return t.getMinutes();
        }), Ie.minutes = Ie.minute.range, Ie.minutes.utc = Ie.minute.utc.range, Ie.hour = Re(function (t) {
          var e = t.getTimezoneOffset() / 60;
          return new Oe(36e5 * (Math.floor(t / 36e5 - e) + e));
        }, function (t, e) {
          t.setTime(t.getTime() + 36e5 * Math.floor(e));
        }, function (t) {
          return t.getHours();
        }), Ie.hours = Ie.hour.range, Ie.hours.utc = Ie.hour.utc.range, Ie.month = Re(function (t) {
          return (t = Ie.day(t)).setDate(1), t;
        }, function (t, e) {
          t.setMonth(t.getMonth() + e);
        }, function (t) {
          return t.getMonth();
        }), Ie.months = Ie.month.range, Ie.months.utc = Ie.month.utc.range;
        var js = [1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6],
            Us = [[Ie.second, 1], [Ie.second, 5], [Ie.second, 15], [Ie.second, 30], [Ie.minute, 1], [Ie.minute, 5], [Ie.minute, 15], [Ie.minute, 30], [Ie.hour, 1], [Ie.hour, 3], [Ie.hour, 6], [Ie.hour, 12], [Ie.day, 1], [Ie.day, 2], [Ie.week, 1], [Ie.month, 1], [Ie.month, 3], [Ie.year, 1]],
            Vs = zs.multi([[".%L", function (t) {
          return t.getMilliseconds();
        }], [":%S", function (t) {
          return t.getSeconds();
        }], ["%I:%M", function (t) {
          return t.getMinutes();
        }], ["%I %p", function (t) {
          return t.getHours();
        }], ["%a %d", function (t) {
          return t.getDay() && 1 != t.getDate();
        }], ["%b %d", function (t) {
          return 1 != t.getDate();
        }], ["%B", function (t) {
          return t.getMonth();
        }], ["%Y", Yr]]),
            qs = {
          range: function range(e, r, n) {
            return t.range(Math.ceil(e / n) * n, +r, n).map(Ns);
          },
          floor: C,
          ceil: C
        };
        Us.year = Ie.year, Ie.scale = function () {
          return Bs(t.scale.linear(), Us, Vs);
        };
        var Hs = Us.map(function (t) {
          return [t[0].utc, t[1]];
        }),
            Gs = Ds.multi([[".%L", function (t) {
          return t.getUTCMilliseconds();
        }], [":%S", function (t) {
          return t.getUTCSeconds();
        }], ["%I:%M", function (t) {
          return t.getUTCMinutes();
        }], ["%I %p", function (t) {
          return t.getUTCHours();
        }], ["%a %d", function (t) {
          return t.getUTCDay() && 1 != t.getUTCDate();
        }], ["%b %d", function (t) {
          return 1 != t.getUTCDate();
        }], ["%B", function (t) {
          return t.getUTCMonth();
        }], ["%Y", Yr]]);

        function Ys(t) {
          return JSON.parse(t.responseText);
        }

        function Ws(t) {
          var e = i.createRange();
          return e.selectNode(i.body), e.createContextualFragment(t.responseText);
        }

        Hs.year = Ie.year.utc, Ie.scale.utc = function () {
          return Bs(t.scale.linear(), Hs, Gs);
        }, t.text = me(function (t) {
          return t.responseText;
        }), t.json = function (t, e) {
          return ge(t, "application/json", Ys, e);
        }, t.html = function (t, e) {
          return ge(t, "text/html", Ws, e);
        }, t.xml = me(function (t) {
          return t.responseXML;
        }), "object" == _typeof(e) && e.exports ? e.exports = t : this.d3 = t;
      }).apply(self);
    }, {}],
    58: [function (t, e, r) {
      "use strict";

      e.exports = t("./quad");
    }, {
      "./quad": 59
    }],
    59: [function (t, e, r) {
      "use strict";

      var n = t("binary-search-bounds"),
          i = t("clamp"),
          a = t("parse-rect"),
          o = t("array-bounds"),
          s = t("pick-by-alias"),
          l = t("defined"),
          c = t("flatten-vertex-data"),
          u = t("is-obj"),
          f = t("dtype"),
          h = t("math-log2");

      function p(t, e) {
        for (var r = e[0], n = e[1], a = 1 / (e[2] - r), o = 1 / (e[3] - n), s = new Array(t.length), l = 0, c = t.length / 2; l < c; l++) {
          s[2 * l] = i((t[2 * l] - r) * a, 0, 1), s[2 * l + 1] = i((t[2 * l + 1] - n) * o, 0, 1);
        }

        return s;
      }

      e.exports = function (t, e) {
        e || (e = {}), t = c(t, "float64"), e = s(e, {
          bounds: "range bounds dataBox databox",
          maxDepth: "depth maxDepth maxdepth level maxLevel maxlevel levels",
          dtype: "type dtype format out dst output destination"
        });
        var r = l(e.maxDepth, 255),
            i = l(e.bounds, o(t, 2));
        i[0] === i[2] && i[2]++, i[1] === i[3] && i[3]++;
        var d,
            m = p(t, i),
            g = t.length >>> 1;
        e.dtype || (e.dtype = "array"), "string" == typeof e.dtype ? d = new (f(e.dtype))(g) : e.dtype && (d = e.dtype, Array.isArray(d) && (d.length = g));

        for (var v = 0; v < g; ++v) {
          d[v] = v;
        }

        var y = [],
            x = [],
            b = [],
            _ = [];
        !function t(e, n, i, a, o, s) {
          if (!a.length) return null;
          var l = y[o] || (y[o] = []),
              c = b[o] || (b[o] = []),
              u = x[o] || (x[o] = []),
              f = l.length;

          if (++o > r || s > 1073741824) {
            for (var h = 0; h < a.length; h++) {
              l.push(a[h]), c.push(s), u.push(null, null, null, null);
            }

            return f;
          }

          if (l.push(a[0]), c.push(s), a.length <= 1) return u.push(null, null, null, null), f;

          for (var p = .5 * i, d = e + p, g = n + p, v = [], _ = [], w = [], T = [], k = 1, M = a.length; k < M; k++) {
            var A = a[k],
                S = m[2 * A],
                E = m[2 * A + 1];
            S < d ? E < g ? v.push(A) : _.push(A) : E < g ? w.push(A) : T.push(A);
          }

          return s <<= 2, u.push(t(e, n, p, v, o, s), t(e, g, p, _, o, s + 1), t(d, n, p, w, o, s + 2), t(d, g, p, T, o, s + 3)), f;
        }(0, 0, 1, d, 0, 1);

        for (var w = 0, T = 0; T < y.length; T++) {
          var k = y[T];
          if (d.set) d.set(k, w);else for (var M = 0, A = k.length; M < A; M++) {
            d[M + w] = k[M];
          }
          var S = w + y[T].length;
          _[T] = [w, S], w = S;
        }

        return d.range = function () {
          var e,
              r = [],
              n = arguments.length;

          for (; n--;) {
            r[n] = arguments[n];
          }

          if (u(r[r.length - 1])) {
            var o = r.pop();
            r.length || null == o.x && null == o.l && null == o.left || (r = [o], e = {}), e = s(o, {
              level: "level maxLevel",
              d: "d diam diameter r radius px pxSize pixel pixelSize maxD size minSize",
              lod: "lod details ranges offsets"
            });
          } else e = {};

          r.length || (r = i);
          var c = a.apply(void 0, r),
              f = [Math.min(c.x, c.x + c.width), Math.min(c.y, c.y + c.height), Math.max(c.x, c.x + c.width), Math.max(c.y, c.y + c.height)],
              d = f[0],
              m = f[1],
              g = f[2],
              v = f[3],
              b = p([d, m, g, v], i),
              _ = b[0],
              w = b[1],
              T = b[2],
              k = b[3],
              M = l(e.level, y.length);

          if (null != e.d) {
            var A;
            "number" == typeof e.d ? A = [e.d, e.d] : e.d.length && (A = e.d), M = Math.min(Math.max(Math.ceil(-h(Math.abs(A[0]) / (i[2] - i[0]))), Math.ceil(-h(Math.abs(A[1]) / (i[3] - i[1])))), M);
          }

          if (M = Math.min(M, y.length), e.lod) return E(_, w, T, k, M);
          var S = [];

          function L(e, r, n, i, a, o) {
            if (null !== a && null !== o && !(_ > e + n || w > r + n || T < e || k < r || i >= M || a === o)) {
              var s = y[i];
              void 0 === o && (o = s.length);

              for (var l = a; l < o; l++) {
                var c = s[l],
                    u = t[2 * c],
                    f = t[2 * c + 1];
                u >= d && u <= g && f >= m && f <= v && S.push(c);
              }

              var h = x[i],
                  p = h[4 * a + 0],
                  b = h[4 * a + 1],
                  A = h[4 * a + 2],
                  E = h[4 * a + 3],
                  P = C(h, a + 1),
                  I = .5 * n,
                  O = i + 1;
              L(e, r, I, O, p, b || A || E || P), L(e, r + I, I, O, b, A || E || P), L(e + I, r, I, O, A, E || P), L(e + I, r + I, I, O, E, P);
            }
          }

          function C(t, e) {
            for (var r = null, n = 0; null === r;) {
              if (r = t[4 * e + n], ++n > t.length) return null;
            }

            return r;
          }

          return L(0, 0, 1, 0, 0, 1), S;
        }, d;

        function E(t, e, r, i, a) {
          for (var o = [], s = 0; s < a; s++) {
            var l = b[s],
                c = _[s][0],
                u = L(t, e, s),
                f = L(r, i, s),
                h = n.ge(l, u),
                p = n.gt(l, f, h, l.length - 1);
            o[s] = [h + c, p + c];
          }

          return o;
        }

        function L(t, e, r) {
          for (var n = 1, i = .5, a = .5, o = .5, s = 0; s < r; s++) {
            n <<= 2, n += t < i ? e < a ? 0 : 1 : e < a ? 2 : 3, o *= .5, i += t < i ? -o : o, a += e < a ? -o : o;
          }

          return n;
        }
      };
    }, {
      "array-bounds": 71,
      "binary-search-bounds": 98,
      clamp: 121,
      defined: 170,
      dtype: 175,
      "flatten-vertex-data": 243,
      "is-obj": 447,
      "math-log2": 458,
      "parse-rect": 484,
      "pick-by-alias": 490
    }],
    60: [function (t, e, r) {
      "use strict";

      Object.defineProperty(r, "__esModule", {
        value: !0
      });
      var n = t("@turf/meta");

      function i(t) {
        var e = 0;

        if (t && t.length > 0) {
          e += Math.abs(a(t[0]));

          for (var r = 1; r < t.length; r++) {
            e -= Math.abs(a(t[r]));
          }
        }

        return e;
      }

      function a(t) {
        var e,
            r,
            n,
            i,
            a,
            s,
            l = 0,
            c = t.length;

        if (c > 2) {
          for (s = 0; s < c; s++) {
            s === c - 2 ? (n = c - 2, i = c - 1, a = 0) : s === c - 1 ? (n = c - 1, i = 0, a = 1) : (n = s, i = s + 1, a = s + 2), e = t[n], r = t[i], l += (o(t[a][0]) - o(e[0])) * Math.sin(o(r[1]));
          }

          l = 6378137 * l * 6378137 / 2;
        }

        return l;
      }

      function o(t) {
        return t * Math.PI / 180;
      }

      r.default = function (t) {
        return n.geomReduce(t, function (t, e) {
          return t + function (t) {
            var e,
                r = 0;

            switch (t.type) {
              case "Polygon":
                return i(t.coordinates);

              case "MultiPolygon":
                for (e = 0; e < t.coordinates.length; e++) {
                  r += i(t.coordinates[e]);
                }

                return r;

              case "Point":
              case "MultiPoint":
              case "LineString":
              case "MultiLineString":
                return 0;
            }

            return 0;
          }(e);
        }, 0);
      };
    }, {
      "@turf/meta": 64
    }],
    61: [function (t, e, r) {
      "use strict";

      Object.defineProperty(r, "__esModule", {
        value: !0
      });
      var n = t("@turf/meta");

      r.default = function (t) {
        var e = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
        return n.coordEach(t, function (t) {
          e[0] > t[0] && (e[0] = t[0]), e[1] > t[1] && (e[1] = t[1]), e[2] < t[0] && (e[2] = t[0]), e[3] < t[1] && (e[3] = t[1]);
        }), e;
      };
    }, {
      "@turf/meta": 64
    }],
    62: [function (t, e, r) {
      "use strict";

      Object.defineProperty(r, "__esModule", {
        value: !0
      });
      var n = t("@turf/meta"),
          i = t("@turf/helpers");

      r.default = function (t, e) {
        void 0 === e && (e = {});
        var r = 0,
            a = 0,
            o = 0;
        return n.coordEach(t, function (t) {
          r += t[0], a += t[1], o++;
        }), i.point([r / o, a / o], e.properties);
      };
    }, {
      "@turf/helpers": 63,
      "@turf/meta": 64
    }],
    63: [function (t, e, r) {
      "use strict";

      function n(t, e, r) {
        void 0 === r && (r = {});
        var n = {
          type: "Feature"
        };
        return (0 === r.id || r.id) && (n.id = r.id), r.bbox && (n.bbox = r.bbox), n.properties = e || {}, n.geometry = t, n;
      }

      function i(t, e, r) {
        return void 0 === r && (r = {}), n({
          type: "Point",
          coordinates: t
        }, e, r);
      }

      function a(t, e, r) {
        void 0 === r && (r = {});

        for (var i = 0, a = t; i < a.length; i++) {
          var o = a[i];
          if (o.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");

          for (var s = 0; s < o[o.length - 1].length; s++) {
            if (o[o.length - 1][s] !== o[0][s]) throw new Error("First and last Position are not equivalent.");
          }
        }

        return n({
          type: "Polygon",
          coordinates: t
        }, e, r);
      }

      function o(t, e, r) {
        if (void 0 === r && (r = {}), t.length < 2) throw new Error("coordinates must be an array of two or more positions");
        return n({
          type: "LineString",
          coordinates: t
        }, e, r);
      }

      function s(t, e) {
        void 0 === e && (e = {});
        var r = {
          type: "FeatureCollection"
        };
        return e.id && (r.id = e.id), e.bbox && (r.bbox = e.bbox), r.features = t, r;
      }

      function l(t, e, r) {
        return void 0 === r && (r = {}), n({
          type: "MultiLineString",
          coordinates: t
        }, e, r);
      }

      function c(t, e, r) {
        return void 0 === r && (r = {}), n({
          type: "MultiPoint",
          coordinates: t
        }, e, r);
      }

      function u(t, e, r) {
        return void 0 === r && (r = {}), n({
          type: "MultiPolygon",
          coordinates: t
        }, e, r);
      }

      function f(t, e) {
        void 0 === e && (e = "kilometers");
        var n = r.factors[e];
        if (!n) throw new Error(e + " units is invalid");
        return t * n;
      }

      function h(t, e) {
        void 0 === e && (e = "kilometers");
        var n = r.factors[e];
        if (!n) throw new Error(e + " units is invalid");
        return t / n;
      }

      function p(t) {
        return 180 * (t % (2 * Math.PI)) / Math.PI;
      }

      function d(t) {
        return !isNaN(t) && null !== t && !Array.isArray(t) && !/^\s*$/.test(t);
      }

      Object.defineProperty(r, "__esModule", {
        value: !0
      }), r.earthRadius = 6371008.8, r.factors = {
        centimeters: 100 * r.earthRadius,
        centimetres: 100 * r.earthRadius,
        degrees: r.earthRadius / 111325,
        feet: 3.28084 * r.earthRadius,
        inches: 39.37 * r.earthRadius,
        kilometers: r.earthRadius / 1e3,
        kilometres: r.earthRadius / 1e3,
        meters: r.earthRadius,
        metres: r.earthRadius,
        miles: r.earthRadius / 1609.344,
        millimeters: 1e3 * r.earthRadius,
        millimetres: 1e3 * r.earthRadius,
        nauticalmiles: r.earthRadius / 1852,
        radians: 1,
        yards: r.earthRadius / 1.0936
      }, r.unitsFactors = {
        centimeters: 100,
        centimetres: 100,
        degrees: 1 / 111325,
        feet: 3.28084,
        inches: 39.37,
        kilometers: .001,
        kilometres: .001,
        meters: 1,
        metres: 1,
        miles: 1 / 1609.344,
        millimeters: 1e3,
        millimetres: 1e3,
        nauticalmiles: 1 / 1852,
        radians: 1 / r.earthRadius,
        yards: 1 / 1.0936
      }, r.areaFactors = {
        acres: 247105e-9,
        centimeters: 1e4,
        centimetres: 1e4,
        feet: 10.763910417,
        inches: 1550.003100006,
        kilometers: 1e-6,
        kilometres: 1e-6,
        meters: 1,
        metres: 1,
        miles: 386e-9,
        millimeters: 1e6,
        millimetres: 1e6,
        yards: 1.195990046
      }, r.feature = n, r.geometry = function (t, e, r) {
        switch (void 0 === r && (r = {}), t) {
          case "Point":
            return i(e).geometry;

          case "LineString":
            return o(e).geometry;

          case "Polygon":
            return a(e).geometry;

          case "MultiPoint":
            return c(e).geometry;

          case "MultiLineString":
            return l(e).geometry;

          case "MultiPolygon":
            return u(e).geometry;

          default:
            throw new Error(t + " is invalid");
        }
      }, r.point = i, r.points = function (t, e, r) {
        return void 0 === r && (r = {}), s(t.map(function (t) {
          return i(t, e);
        }), r);
      }, r.polygon = a, r.polygons = function (t, e, r) {
        return void 0 === r && (r = {}), s(t.map(function (t) {
          return a(t, e);
        }), r);
      }, r.lineString = o, r.lineStrings = function (t, e, r) {
        return void 0 === r && (r = {}), s(t.map(function (t) {
          return o(t, e);
        }), r);
      }, r.featureCollection = s, r.multiLineString = l, r.multiPoint = c, r.multiPolygon = u, r.geometryCollection = function (t, e, r) {
        return void 0 === r && (r = {}), n({
          type: "GeometryCollection",
          geometries: t
        }, e, r);
      }, r.round = function (t, e) {
        if (void 0 === e && (e = 0), e && !(e >= 0)) throw new Error("precision must be a positive number");
        var r = Math.pow(10, e || 0);
        return Math.round(t * r) / r;
      }, r.radiansToLength = f, r.lengthToRadians = h, r.lengthToDegrees = function (t, e) {
        return p(h(t, e));
      }, r.bearingToAzimuth = function (t) {
        var e = t % 360;
        return e < 0 && (e += 360), e;
      }, r.radiansToDegrees = p, r.degreesToRadians = function (t) {
        return t % 360 * Math.PI / 180;
      }, r.convertLength = function (t, e, r) {
        if (void 0 === e && (e = "kilometers"), void 0 === r && (r = "kilometers"), !(t >= 0)) throw new Error("length must be a positive number");
        return f(h(t, e), r);
      }, r.convertArea = function (t, e, n) {
        if (void 0 === e && (e = "meters"), void 0 === n && (n = "kilometers"), !(t >= 0)) throw new Error("area must be a positive number");
        var i = r.areaFactors[e];
        if (!i) throw new Error("invalid original units");
        var a = r.areaFactors[n];
        if (!a) throw new Error("invalid final units");
        return t / i * a;
      }, r.isNumber = d, r.isObject = function (t) {
        return !!t && t.constructor === Object;
      }, r.validateBBox = function (t) {
        if (!t) throw new Error("bbox is required");
        if (!Array.isArray(t)) throw new Error("bbox must be an Array");
        if (4 !== t.length && 6 !== t.length) throw new Error("bbox must be an Array of 4 or 6 numbers");
        t.forEach(function (t) {
          if (!d(t)) throw new Error("bbox must only contain numbers");
        });
      }, r.validateId = function (t) {
        if (!t) throw new Error("id is required");
        if (-1 === ["string", "number"].indexOf(_typeof(t))) throw new Error("id must be a number or a string");
      }, r.radians2degrees = function () {
        throw new Error("method has been renamed to `radiansToDegrees`");
      }, r.degrees2radians = function () {
        throw new Error("method has been renamed to `degreesToRadians`");
      }, r.distanceToDegrees = function () {
        throw new Error("method has been renamed to `lengthToDegrees`");
      }, r.distanceToRadians = function () {
        throw new Error("method has been renamed to `lengthToRadians`");
      }, r.radiansToDistance = function () {
        throw new Error("method has been renamed to `radiansToLength`");
      }, r.bearingToAngle = function () {
        throw new Error("method has been renamed to `bearingToAzimuth`");
      }, r.convertDistance = function () {
        throw new Error("method has been renamed to `convertLength`");
      };
    }, {}],
    64: [function (t, e, r) {
      "use strict";

      Object.defineProperty(r, "__esModule", {
        value: !0
      });
      var n = t("@turf/helpers");

      function i(t, e, r) {
        if (null !== t) for (var n, a, o, s, l, c, u, f, h = 0, p = 0, d = t.type, m = "FeatureCollection" === d, g = "Feature" === d, v = m ? t.features.length : 1, y = 0; y < v; y++) {
          l = (f = !!(u = m ? t.features[y].geometry : g ? t.geometry : t) && "GeometryCollection" === u.type) ? u.geometries.length : 1;

          for (var x = 0; x < l; x++) {
            var b = 0,
                _ = 0;

            if (null !== (s = f ? u.geometries[x] : u)) {
              c = s.coordinates;
              var w = s.type;

              switch (h = !r || "Polygon" !== w && "MultiPolygon" !== w ? 0 : 1, w) {
                case null:
                  break;

                case "Point":
                  if (!1 === e(c, p, y, b, _)) return !1;
                  p++, b++;
                  break;

                case "LineString":
                case "MultiPoint":
                  for (n = 0; n < c.length; n++) {
                    if (!1 === e(c[n], p, y, b, _)) return !1;
                    p++, "MultiPoint" === w && b++;
                  }

                  "LineString" === w && b++;
                  break;

                case "Polygon":
                case "MultiLineString":
                  for (n = 0; n < c.length; n++) {
                    for (a = 0; a < c[n].length - h; a++) {
                      if (!1 === e(c[n][a], p, y, b, _)) return !1;
                      p++;
                    }

                    "MultiLineString" === w && b++, "Polygon" === w && _++;
                  }

                  "Polygon" === w && b++;
                  break;

                case "MultiPolygon":
                  for (n = 0; n < c.length; n++) {
                    for (_ = 0, a = 0; a < c[n].length; a++) {
                      for (o = 0; o < c[n][a].length - h; o++) {
                        if (!1 === e(c[n][a][o], p, y, b, _)) return !1;
                        p++;
                      }

                      _++;
                    }

                    b++;
                  }

                  break;

                case "GeometryCollection":
                  for (n = 0; n < s.geometries.length; n++) {
                    if (!1 === i(s.geometries[n], e, r)) return !1;
                  }

                  break;

                default:
                  throw new Error("Unknown Geometry Type");
              }
            }
          }
        }
      }

      function a(t, e) {
        var r;

        switch (t.type) {
          case "FeatureCollection":
            for (r = 0; r < t.features.length && !1 !== e(t.features[r].properties, r); r++) {
              ;
            }

            break;

          case "Feature":
            e(t.properties, 0);
        }
      }

      function o(t, e) {
        if ("Feature" === t.type) e(t, 0);else if ("FeatureCollection" === t.type) for (var r = 0; r < t.features.length && !1 !== e(t.features[r], r); r++) {
          ;
        }
      }

      function s(t, e) {
        var r,
            n,
            i,
            a,
            o,
            s,
            l,
            c,
            u,
            f,
            h = 0,
            p = "FeatureCollection" === t.type,
            d = "Feature" === t.type,
            m = p ? t.features.length : 1;

        for (r = 0; r < m; r++) {
          for (s = p ? t.features[r].geometry : d ? t.geometry : t, c = p ? t.features[r].properties : d ? t.properties : {}, u = p ? t.features[r].bbox : d ? t.bbox : void 0, f = p ? t.features[r].id : d ? t.id : void 0, o = (l = !!s && "GeometryCollection" === s.type) ? s.geometries.length : 1, i = 0; i < o; i++) {
            if (null !== (a = l ? s.geometries[i] : s)) switch (a.type) {
              case "Point":
              case "LineString":
              case "MultiPoint":
              case "Polygon":
              case "MultiLineString":
              case "MultiPolygon":
                if (!1 === e(a, h, c, u, f)) return !1;
                break;

              case "GeometryCollection":
                for (n = 0; n < a.geometries.length; n++) {
                  if (!1 === e(a.geometries[n], h, c, u, f)) return !1;
                }

                break;

              default:
                throw new Error("Unknown Geometry Type");
            } else if (!1 === e(null, h, c, u, f)) return !1;
          }

          h++;
        }
      }

      function l(t, e) {
        s(t, function (t, r, i, a, o) {
          var s,
              l = null === t ? null : t.type;

          switch (l) {
            case null:
            case "Point":
            case "LineString":
            case "Polygon":
              return !1 !== e(n.feature(t, i, {
                bbox: a,
                id: o
              }), r, 0) && void 0;
          }

          switch (l) {
            case "MultiPoint":
              s = "Point";
              break;

            case "MultiLineString":
              s = "LineString";
              break;

            case "MultiPolygon":
              s = "Polygon";
          }

          for (var c = 0; c < t.coordinates.length; c++) {
            var u = {
              type: s,
              coordinates: t.coordinates[c]
            };
            if (!1 === e(n.feature(u, i), r, c)) return !1;
          }
        });
      }

      function c(t, e) {
        l(t, function (t, r, a) {
          var o = 0;

          if (t.geometry) {
            var s = t.geometry.type;

            if ("Point" !== s && "MultiPoint" !== s) {
              var l,
                  c = 0,
                  u = 0,
                  f = 0;
              return !1 !== i(t, function (i, s, h, p, d) {
                if (void 0 === l || r > c || p > u || d > f) return l = i, c = r, u = p, f = d, void (o = 0);
                var m = n.lineString([l, i], t.properties);
                if (!1 === e(m, r, a, d, o)) return !1;
                o++, l = i;
              }) && void 0;
            }
          }
        });
      }

      function u(t, e) {
        if (!t) throw new Error("geojson is required");
        l(t, function (t, r, i) {
          if (null !== t.geometry) {
            var a = t.geometry.type,
                o = t.geometry.coordinates;

            switch (a) {
              case "LineString":
                if (!1 === e(t, r, i, 0, 0)) return !1;
                break;

              case "Polygon":
                for (var s = 0; s < o.length; s++) {
                  if (!1 === e(n.lineString(o[s], t.properties), r, i, s)) return !1;
                }

            }
          }
        });
      }

      r.coordEach = i, r.coordReduce = function (t, e, r, n) {
        var a = r;
        return i(t, function (t, n, i, o, s) {
          a = 0 === n && void 0 === r ? t : e(a, t, n, i, o, s);
        }, n), a;
      }, r.propEach = a, r.propReduce = function (t, e, r) {
        var n = r;
        return a(t, function (t, i) {
          n = 0 === i && void 0 === r ? t : e(n, t, i);
        }), n;
      }, r.featureEach = o, r.featureReduce = function (t, e, r) {
        var n = r;
        return o(t, function (t, i) {
          n = 0 === i && void 0 === r ? t : e(n, t, i);
        }), n;
      }, r.coordAll = function (t) {
        var e = [];
        return i(t, function (t) {
          e.push(t);
        }), e;
      }, r.geomEach = s, r.geomReduce = function (t, e, r) {
        var n = r;
        return s(t, function (t, i, a, o, s) {
          n = 0 === i && void 0 === r ? t : e(n, t, i, a, o, s);
        }), n;
      }, r.flattenEach = l, r.flattenReduce = function (t, e, r) {
        var n = r;
        return l(t, function (t, i, a) {
          n = 0 === i && 0 === a && void 0 === r ? t : e(n, t, i, a);
        }), n;
      }, r.segmentEach = c, r.segmentReduce = function (t, e, r) {
        var n = r,
            i = !1;
        return c(t, function (t, a, o, s, l) {
          n = !1 === i && void 0 === r ? t : e(n, t, a, o, s, l), i = !0;
        }), n;
      }, r.lineEach = u, r.lineReduce = function (t, e, r) {
        var n = r;
        return u(t, function (t, i, a, o) {
          n = 0 === i && void 0 === r ? t : e(n, t, i, a, o);
        }), n;
      }, r.findSegment = function (t, e) {
        if (e = e || {}, !n.isObject(e)) throw new Error("options is invalid");
        var r,
            i = e.featureIndex || 0,
            a = e.multiFeatureIndex || 0,
            o = e.geometryIndex || 0,
            s = e.segmentIndex || 0,
            l = e.properties;

        switch (t.type) {
          case "FeatureCollection":
            i < 0 && (i = t.features.length + i), l = l || t.features[i].properties, r = t.features[i].geometry;
            break;

          case "Feature":
            l = l || t.properties, r = t.geometry;
            break;

          case "Point":
          case "MultiPoint":
            return null;

          case "LineString":
          case "Polygon":
          case "MultiLineString":
          case "MultiPolygon":
            r = t;
            break;

          default:
            throw new Error("geojson is invalid");
        }

        if (null === r) return null;
        var c = r.coordinates;

        switch (r.type) {
          case "Point":
          case "MultiPoint":
            return null;

          case "LineString":
            return s < 0 && (s = c.length + s - 1), n.lineString([c[s], c[s + 1]], l, e);

          case "Polygon":
            return o < 0 && (o = c.length + o), s < 0 && (s = c[o].length + s - 1), n.lineString([c[o][s], c[o][s + 1]], l, e);

          case "MultiLineString":
            return a < 0 && (a = c.length + a), s < 0 && (s = c[a].length + s - 1), n.lineString([c[a][s], c[a][s + 1]], l, e);

          case "MultiPolygon":
            return a < 0 && (a = c.length + a), o < 0 && (o = c[a].length + o), s < 0 && (s = c[a][o].length - s - 1), n.lineString([c[a][o][s], c[a][o][s + 1]], l, e);
        }

        throw new Error("geojson is invalid");
      }, r.findPoint = function (t, e) {
        if (e = e || {}, !n.isObject(e)) throw new Error("options is invalid");
        var r,
            i = e.featureIndex || 0,
            a = e.multiFeatureIndex || 0,
            o = e.geometryIndex || 0,
            s = e.coordIndex || 0,
            l = e.properties;

        switch (t.type) {
          case "FeatureCollection":
            i < 0 && (i = t.features.length + i), l = l || t.features[i].properties, r = t.features[i].geometry;
            break;

          case "Feature":
            l = l || t.properties, r = t.geometry;
            break;

          case "Point":
          case "MultiPoint":
            return null;

          case "LineString":
          case "Polygon":
          case "MultiLineString":
          case "MultiPolygon":
            r = t;
            break;

          default:
            throw new Error("geojson is invalid");
        }

        if (null === r) return null;
        var c = r.coordinates;

        switch (r.type) {
          case "Point":
            return n.point(c, l, e);

          case "MultiPoint":
            return a < 0 && (a = c.length + a), n.point(c[a], l, e);

          case "LineString":
            return s < 0 && (s = c.length + s), n.point(c[s], l, e);

          case "Polygon":
            return o < 0 && (o = c.length + o), s < 0 && (s = c[o].length + s), n.point(c[o][s], l, e);

          case "MultiLineString":
            return a < 0 && (a = c.length + a), s < 0 && (s = c[a].length + s), n.point(c[a][s], l, e);

          case "MultiPolygon":
            return a < 0 && (a = c.length + a), o < 0 && (o = c[a].length + o), s < 0 && (s = c[a][o].length - s), n.point(c[a][o][s], l, e);
        }

        throw new Error("geojson is invalid");
      };
    }, {
      "@turf/helpers": 63
    }],
    65: [function (t, e, r) {
      "use strict";

      var n = "undefined" == typeof WeakMap ? t("weak-map") : WeakMap,
          i = t("gl-buffer"),
          a = t("gl-vao"),
          o = new n();

      e.exports = function (t) {
        var e = o.get(t),
            r = e && (e._triangleBuffer.handle || e._triangleBuffer.buffer);

        if (!r || !t.isBuffer(r)) {
          var n = i(t, new Float32Array([-1, -1, -1, 4, 4, -1]));
          (e = a(t, [{
            buffer: n,
            type: t.FLOAT,
            size: 2
          }]))._triangleBuffer = n, o.set(t, e);
        }

        e.bind(), t.drawArrays(t.TRIANGLES, 0, 3), e.unbind();
      };
    }, {
      "gl-buffer": 258,
      "gl-vao": 352,
      "weak-map": 617
    }],
    66: [function (t, e, r) {
      e.exports = function (t) {
        var e = 0,
            r = 0,
            n = 0,
            i = 0;
        return t.map(function (t) {
          var a = (t = t.slice())[0],
              o = a.toUpperCase();
          if (a != o) switch (t[0] = o, a) {
            case "a":
              t[6] += n, t[7] += i;
              break;

            case "v":
              t[1] += i;
              break;

            case "h":
              t[1] += n;
              break;

            default:
              for (var s = 1; s < t.length;) {
                t[s++] += n, t[s++] += i;
              }

          }

          switch (o) {
            case "Z":
              n = e, i = r;
              break;

            case "H":
              n = t[1];
              break;

            case "V":
              i = t[1];
              break;

            case "M":
              n = e = t[1], i = r = t[2];
              break;

            default:
              n = t[t.length - 2], i = t[t.length - 1];
          }

          return t;
        });
      };
    }, {}],
    67: [function (t, e, r) {
      var n = t("pad-left");

      e.exports = function (t, e, r) {
        e = "number" == typeof e ? e : 1, r = r || ": ";
        var i = t.split(/\r?\n/),
            a = String(i.length + e - 1).length;
        return i.map(function (t, i) {
          var o = i + e,
              s = String(o).length;
          return n(o, a - s) + r + t;
        }).join("\n");
      };
    }, {
      "pad-left": 482
    }],
    68: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        var e = t.length;
        if (0 === e) return [];
        if (1 === e) return [0];

        for (var r = t[0].length, n = [t[0]], a = [0], o = 1; o < e; ++o) {
          if (n.push(t[o]), i(n, r)) {
            if (a.push(o), a.length === r + 1) return a;
          } else n.pop();
        }

        return a;
      };

      var n = t("robust-orientation");

      function i(t, e) {
        for (var r = new Array(e + 1), i = 0; i < t.length; ++i) {
          r[i] = t[i];
        }

        for (i = 0; i <= t.length; ++i) {
          for (var a = t.length; a <= e; ++a) {
            for (var o = new Array(e), s = 0; s < e; ++s) {
              o[s] = Math.pow(a + 1 - i, s);
            }

            r[a] = o;
          }

          if (n.apply(void 0, r)) return !0;
        }

        return !1;
      }
    }, {
      "robust-orientation": 540
    }],
    69: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        return n(e).filter(function (r) {
          for (var n = new Array(r.length), a = 0; a < r.length; ++a) {
            n[a] = e[r[a]];
          }

          return i(n) * t < 1;
        });
      };

      var n = t("delaunay-triangulate"),
          i = t("circumradius");
    }, {
      circumradius: 120,
      "delaunay-triangulate": 171
    }],
    70: [function (t, e, r) {
      e.exports = function (t, e) {
        return i(n(t, e));
      };

      var n = t("alpha-complex"),
          i = t("simplicial-complex-boundary");
    }, {
      "alpha-complex": 69,
      "simplicial-complex-boundary": 548
    }],
    71: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        if (!t || null == t.length) throw Error("Argument should be an array");
        e = null == e ? 1 : Math.floor(e);

        for (var r = Array(2 * e), n = 0; n < e; n++) {
          for (var i = -1 / 0, a = 1 / 0, o = n, s = t.length; o < s; o += e) {
            t[o] > i && (i = t[o]), t[o] < a && (a = t[o]);
          }

          r[n] = a, r[e + n] = i;
        }

        return r;
      };
    }, {}],
    72: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r) {
        if ("function" == typeof Array.prototype.findIndex) return t.findIndex(e, r);
        if ("function" != typeof e) throw new TypeError("predicate must be a function");
        var n = Object(t),
            i = n.length;
        if (0 === i) return -1;

        for (var a = 0; a < i; a++) {
          if (e.call(r, n[a], a, n)) return a;
        }

        return -1;
      };
    }, {}],
    73: [function (t, e, r) {
      "use strict";

      var n = t("array-bounds");

      e.exports = function (t, e, r) {
        if (!t || null == t.length) throw Error("Argument should be an array");
        null == e && (e = 1);
        null == r && (r = n(t, e));

        for (var i = 0; i < e; i++) {
          var a = r[e + i],
              o = r[i],
              s = i,
              l = t.length;
          if (a === 1 / 0 && o === -1 / 0) for (s = i; s < l; s += e) {
            t[s] = t[s] === a ? 1 : t[s] === o ? 0 : .5;
          } else if (a === 1 / 0) for (s = i; s < l; s += e) {
            t[s] = t[s] === a ? 1 : 0;
          } else if (o === -1 / 0) for (s = i; s < l; s += e) {
            t[s] = t[s] === o ? 0 : 1;
          } else {
            var c = a - o;

            for (s = i; s < l; s += e) {
              isNaN(t[s]) || (t[s] = 0 === c ? .5 : (t[s] - o) / c);
            }
          }
        }

        return t;
      };
    }, {
      "array-bounds": 71
    }],
    74: [function (t, e, r) {
      e.exports = function (t, e) {
        var r = "number" == typeof t,
            n = "number" == typeof e;
        r && !n ? (e = t, t = 0) : r || n || (t = 0, e = 0);
        var i = (e |= 0) - (t |= 0);
        if (i < 0) throw new Error("array length must be positive");

        for (var a = new Array(i), o = 0, s = t; o < i; o++, s++) {
          a[o] = s;
        }

        return a;
      };
    }, {}],
    75: [function (t, e, r) {
      (function (r) {
        (function () {
          "use strict";

          var n = t("object-assign");
          /*!
           * The buffer module from node.js, for the browser.
           *
           * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
           * @license  MIT
           */

          function i(t, e) {
            if (t === e) return 0;

            for (var r = t.length, n = e.length, i = 0, a = Math.min(r, n); i < a; ++i) {
              if (t[i] !== e[i]) {
                r = t[i], n = e[i];
                break;
              }
            }

            return r < n ? -1 : n < r ? 1 : 0;
          }

          function a(t) {
            return r.Buffer && "function" == typeof r.Buffer.isBuffer ? r.Buffer.isBuffer(t) : !(null == t || !t._isBuffer);
          }

          var o = t("util/"),
              s = Object.prototype.hasOwnProperty,
              l = Array.prototype.slice,
              c = "foo" === function () {}.name;

          function u(t) {
            return Object.prototype.toString.call(t);
          }

          function f(t) {
            return !a(t) && "function" == typeof r.ArrayBuffer && ("function" == typeof ArrayBuffer.isView ? ArrayBuffer.isView(t) : !!t && (t instanceof DataView || !!(t.buffer && t.buffer instanceof ArrayBuffer)));
          }

          var h = e.exports = y,
              p = /\s*function\s+([^\(\s]*)\s*/;

          function d(t) {
            if (o.isFunction(t)) {
              if (c) return t.name;
              var e = t.toString().match(p);
              return e && e[1];
            }
          }

          function m(t, e) {
            return "string" == typeof t ? t.length < e ? t : t.slice(0, e) : t;
          }

          function g(t) {
            if (c || !o.isFunction(t)) return o.inspect(t);
            var e = d(t);
            return "[Function" + (e ? ": " + e : "") + "]";
          }

          function v(t, e, r, n, i) {
            throw new h.AssertionError({
              message: r,
              actual: t,
              expected: e,
              operator: n,
              stackStartFunction: i
            });
          }

          function y(t, e) {
            t || v(t, !0, e, "==", h.ok);
          }

          function x(t, e, r, n) {
            if (t === e) return !0;
            if (a(t) && a(e)) return 0 === i(t, e);
            if (o.isDate(t) && o.isDate(e)) return t.getTime() === e.getTime();
            if (o.isRegExp(t) && o.isRegExp(e)) return t.source === e.source && t.global === e.global && t.multiline === e.multiline && t.lastIndex === e.lastIndex && t.ignoreCase === e.ignoreCase;

            if (null !== t && "object" == _typeof(t) || null !== e && "object" == _typeof(e)) {
              if (f(t) && f(e) && u(t) === u(e) && !(t instanceof Float32Array || t instanceof Float64Array)) return 0 === i(new Uint8Array(t.buffer), new Uint8Array(e.buffer));
              if (a(t) !== a(e)) return !1;
              var s = (n = n || {
                actual: [],
                expected: []
              }).actual.indexOf(t);
              return -1 !== s && s === n.expected.indexOf(e) || (n.actual.push(t), n.expected.push(e), function (t, e, r, n) {
                if (null == t || null == e) return !1;
                if (o.isPrimitive(t) || o.isPrimitive(e)) return t === e;
                if (r && Object.getPrototypeOf(t) !== Object.getPrototypeOf(e)) return !1;
                var i = b(t),
                    a = b(e);
                if (i && !a || !i && a) return !1;
                if (i) return t = l.call(t), e = l.call(e), x(t, e, r);
                var s,
                    c,
                    u = T(t),
                    f = T(e);
                if (u.length !== f.length) return !1;

                for (u.sort(), f.sort(), c = u.length - 1; c >= 0; c--) {
                  if (u[c] !== f[c]) return !1;
                }

                for (c = u.length - 1; c >= 0; c--) {
                  if (s = u[c], !x(t[s], e[s], r, n)) return !1;
                }

                return !0;
              }(t, e, r, n));
            }

            return r ? t === e : t == e;
          }

          function b(t) {
            return "[object Arguments]" == Object.prototype.toString.call(t);
          }

          function _(t, e) {
            if (!t || !e) return !1;
            if ("[object RegExp]" == Object.prototype.toString.call(e)) return e.test(t);

            try {
              if (t instanceof e) return !0;
            } catch (t) {}

            return !Error.isPrototypeOf(e) && !0 === e.call({}, t);
          }

          function w(t, e, r, n) {
            var i;
            if ("function" != typeof e) throw new TypeError('"block" argument must be a function');
            "string" == typeof r && (n = r, r = null), i = function (t) {
              var e;

              try {
                t();
              } catch (t) {
                e = t;
              }

              return e;
            }(e), n = (r && r.name ? " (" + r.name + ")." : ".") + (n ? " " + n : "."), t && !i && v(i, r, "Missing expected exception" + n);
            var a = "string" == typeof n,
                s = !t && i && !r;
            if ((!t && o.isError(i) && a && _(i, r) || s) && v(i, r, "Got unwanted exception" + n), t && i && r && !_(i, r) || !t && i) throw i;
          }

          h.AssertionError = function (t) {
            this.name = "AssertionError", this.actual = t.actual, this.expected = t.expected, this.operator = t.operator, t.message ? (this.message = t.message, this.generatedMessage = !1) : (this.message = function (t) {
              return m(g(t.actual), 128) + " " + t.operator + " " + m(g(t.expected), 128);
            }(this), this.generatedMessage = !0);
            var e = t.stackStartFunction || v;
            if (Error.captureStackTrace) Error.captureStackTrace(this, e);else {
              var r = new Error();

              if (r.stack) {
                var n = r.stack,
                    i = d(e),
                    a = n.indexOf("\n" + i);

                if (a >= 0) {
                  var o = n.indexOf("\n", a + 1);
                  n = n.substring(o + 1);
                }

                this.stack = n;
              }
            }
          }, o.inherits(h.AssertionError, Error), h.fail = v, h.ok = y, h.equal = function (t, e, r) {
            t != e && v(t, e, r, "==", h.equal);
          }, h.notEqual = function (t, e, r) {
            t == e && v(t, e, r, "!=", h.notEqual);
          }, h.deepEqual = function (t, e, r) {
            x(t, e, !1) || v(t, e, r, "deepEqual", h.deepEqual);
          }, h.deepStrictEqual = function (t, e, r) {
            x(t, e, !0) || v(t, e, r, "deepStrictEqual", h.deepStrictEqual);
          }, h.notDeepEqual = function (t, e, r) {
            x(t, e, !1) && v(t, e, r, "notDeepEqual", h.notDeepEqual);
          }, h.notDeepStrictEqual = function t(e, r, n) {
            x(e, r, !0) && v(e, r, n, "notDeepStrictEqual", t);
          }, h.strictEqual = function (t, e, r) {
            t !== e && v(t, e, r, "===", h.strictEqual);
          }, h.notStrictEqual = function (t, e, r) {
            t === e && v(t, e, r, "!==", h.notStrictEqual);
          }, h.throws = function (t, e, r) {
            w(!0, t, e, r);
          }, h.doesNotThrow = function (t, e, r) {
            w(!1, t, e, r);
          }, h.ifError = function (t) {
            if (t) throw t;
          }, h.strict = n(function t(e, r) {
            e || v(e, !0, r, "==", t);
          }, h, {
            equal: h.strictEqual,
            deepEqual: h.deepStrictEqual,
            notEqual: h.notStrictEqual,
            notDeepEqual: h.notDeepStrictEqual
          }), h.strict.strict = h.strict;

          var T = Object.keys || function (t) {
            var e = [];

            for (var r in t) {
              s.call(t, r) && e.push(r);
            }

            return e;
          };
        }).call(this);
      }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
    }, {
      "object-assign": 479,
      "util/": 78
    }],
    76: [function (t, e, r) {
      "function" == typeof Object.create ? e.exports = function (t, e) {
        t.super_ = e, t.prototype = Object.create(e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        });
      } : e.exports = function (t, e) {
        t.super_ = e;

        var r = function r() {};

        r.prototype = e.prototype, t.prototype = new r(), t.prototype.constructor = t;
      };
    }, {}],
    77: [function (t, e, r) {
      e.exports = function (t) {
        return t && "object" == _typeof(t) && "function" == typeof t.copy && "function" == typeof t.fill && "function" == typeof t.readUInt8;
      };
    }, {}],
    78: [function (t, e, r) {
      (function (e, n) {
        (function () {
          var i = /%[sdj%]/g;
          r.format = function (t) {
            if (!v(t)) {
              for (var e = [], r = 0; r < arguments.length; r++) {
                e.push(s(arguments[r]));
              }

              return e.join(" ");
            }

            r = 1;

            for (var n = arguments, a = n.length, o = String(t).replace(i, function (t) {
              if ("%%" === t) return "%";
              if (r >= a) return t;

              switch (t) {
                case "%s":
                  return String(n[r++]);

                case "%d":
                  return Number(n[r++]);

                case "%j":
                  try {
                    return JSON.stringify(n[r++]);
                  } catch (t) {
                    return "[Circular]";
                  }

                default:
                  return t;
              }
            }), l = n[r]; r < a; l = n[++r]) {
              m(l) || !b(l) ? o += " " + l : o += " " + s(l);
            }

            return o;
          }, r.deprecate = function (t, i) {
            if (y(n.process)) return function () {
              return r.deprecate(t, i).apply(this, arguments);
            };
            if (!0 === e.noDeprecation) return t;
            var a = !1;
            return function () {
              if (!a) {
                if (e.throwDeprecation) throw new Error(i);
                e.traceDeprecation ? console.trace(i) : console.error(i), a = !0;
              }

              return t.apply(this, arguments);
            };
          };
          var a,
              o = {};

          function s(t, e) {
            var n = {
              seen: [],
              stylize: c
            };
            return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), d(e) ? n.showHidden = e : e && r._extend(n, e), y(n.showHidden) && (n.showHidden = !1), y(n.depth) && (n.depth = 2), y(n.colors) && (n.colors = !1), y(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = l), u(n, t, n.depth);
          }

          function l(t, e) {
            var r = s.styles[e];
            return r ? "\x1b[" + s.colors[r][0] + "m" + t + "\x1b[" + s.colors[r][1] + "m" : t;
          }

          function c(t, e) {
            return t;
          }

          function u(t, e, n) {
            if (t.customInspect && e && T(e.inspect) && e.inspect !== r.inspect && (!e.constructor || e.constructor.prototype !== e)) {
              var i = e.inspect(n, t);
              return v(i) || (i = u(t, i, n)), i;
            }

            var a = function (t, e) {
              if (y(e)) return t.stylize("undefined", "undefined");

              if (v(e)) {
                var r = "'" + JSON.stringify(e).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                return t.stylize(r, "string");
              }

              if (g(e)) return t.stylize("" + e, "number");
              if (d(e)) return t.stylize("" + e, "boolean");
              if (m(e)) return t.stylize("null", "null");
            }(t, e);

            if (a) return a;

            var o = Object.keys(e),
                s = function (t) {
              var e = {};
              return t.forEach(function (t, r) {
                e[t] = !0;
              }), e;
            }(o);

            if (t.showHidden && (o = Object.getOwnPropertyNames(e)), w(e) && (o.indexOf("message") >= 0 || o.indexOf("description") >= 0)) return f(e);

            if (0 === o.length) {
              if (T(e)) {
                var l = e.name ? ": " + e.name : "";
                return t.stylize("[Function" + l + "]", "special");
              }

              if (x(e)) return t.stylize(RegExp.prototype.toString.call(e), "regexp");
              if (_(e)) return t.stylize(Date.prototype.toString.call(e), "date");
              if (w(e)) return f(e);
            }

            var c,
                b = "",
                k = !1,
                M = ["{", "}"];
            (p(e) && (k = !0, M = ["[", "]"]), T(e)) && (b = " [Function" + (e.name ? ": " + e.name : "") + "]");
            return x(e) && (b = " " + RegExp.prototype.toString.call(e)), _(e) && (b = " " + Date.prototype.toUTCString.call(e)), w(e) && (b = " " + f(e)), 0 !== o.length || k && 0 != e.length ? n < 0 ? x(e) ? t.stylize(RegExp.prototype.toString.call(e), "regexp") : t.stylize("[Object]", "special") : (t.seen.push(e), c = k ? function (t, e, r, n, i) {
              for (var a = [], o = 0, s = e.length; o < s; ++o) {
                E(e, String(o)) ? a.push(h(t, e, r, n, String(o), !0)) : a.push("");
              }

              return i.forEach(function (i) {
                i.match(/^\d+$/) || a.push(h(t, e, r, n, i, !0));
              }), a;
            }(t, e, n, s, o) : o.map(function (r) {
              return h(t, e, n, s, r, k);
            }), t.seen.pop(), function (t, e, r) {
              if (t.reduce(function (t, e) {
                return e.indexOf("\n") >= 0 && 0, t + e.replace(/\u001b\[\d\d?m/g, "").length + 1;
              }, 0) > 60) return r[0] + ("" === e ? "" : e + "\n ") + " " + t.join(",\n  ") + " " + r[1];
              return r[0] + e + " " + t.join(", ") + " " + r[1];
            }(c, b, M)) : M[0] + b + M[1];
          }

          function f(t) {
            return "[" + Error.prototype.toString.call(t) + "]";
          }

          function h(t, e, r, n, i, a) {
            var o, s, l;

            if ((l = Object.getOwnPropertyDescriptor(e, i) || {
              value: e[i]
            }).get ? s = l.set ? t.stylize("[Getter/Setter]", "special") : t.stylize("[Getter]", "special") : l.set && (s = t.stylize("[Setter]", "special")), E(n, i) || (o = "[" + i + "]"), s || (t.seen.indexOf(l.value) < 0 ? (s = m(r) ? u(t, l.value, null) : u(t, l.value, r - 1)).indexOf("\n") > -1 && (s = a ? s.split("\n").map(function (t) {
              return "  " + t;
            }).join("\n").substr(2) : "\n" + s.split("\n").map(function (t) {
              return "   " + t;
            }).join("\n")) : s = t.stylize("[Circular]", "special")), y(o)) {
              if (a && i.match(/^\d+$/)) return s;
              (o = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o = o.substr(1, o.length - 2), o = t.stylize(o, "name")) : (o = o.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), o = t.stylize(o, "string"));
            }

            return o + ": " + s;
          }

          function p(t) {
            return Array.isArray(t);
          }

          function d(t) {
            return "boolean" == typeof t;
          }

          function m(t) {
            return null === t;
          }

          function g(t) {
            return "number" == typeof t;
          }

          function v(t) {
            return "string" == typeof t;
          }

          function y(t) {
            return void 0 === t;
          }

          function x(t) {
            return b(t) && "[object RegExp]" === k(t);
          }

          function b(t) {
            return "object" == _typeof(t) && null !== t;
          }

          function _(t) {
            return b(t) && "[object Date]" === k(t);
          }

          function w(t) {
            return b(t) && ("[object Error]" === k(t) || t instanceof Error);
          }

          function T(t) {
            return "function" == typeof t;
          }

          function k(t) {
            return Object.prototype.toString.call(t);
          }

          function M(t) {
            return t < 10 ? "0" + t.toString(10) : t.toString(10);
          }

          r.debuglog = function (t) {
            if (y(a) && (a = e.env.NODE_DEBUG || ""), t = t.toUpperCase(), !o[t]) if (new RegExp("\\b" + t + "\\b", "i").test(a)) {
              var n = e.pid;

              o[t] = function () {
                var e = r.format.apply(r, arguments);
                console.error("%s %d: %s", t, n, e);
              };
            } else o[t] = function () {};
            return o[t];
          }, r.inspect = s, s.colors = {
            bold: [1, 22],
            italic: [3, 23],
            underline: [4, 24],
            inverse: [7, 27],
            white: [37, 39],
            grey: [90, 39],
            black: [30, 39],
            blue: [34, 39],
            cyan: [36, 39],
            green: [32, 39],
            magenta: [35, 39],
            red: [31, 39],
            yellow: [33, 39]
          }, s.styles = {
            special: "cyan",
            number: "yellow",
            boolean: "yellow",
            undefined: "grey",
            null: "bold",
            string: "green",
            date: "magenta",
            regexp: "red"
          }, r.isArray = p, r.isBoolean = d, r.isNull = m, r.isNullOrUndefined = function (t) {
            return null == t;
          }, r.isNumber = g, r.isString = v, r.isSymbol = function (t) {
            return "symbol" == _typeof(t);
          }, r.isUndefined = y, r.isRegExp = x, r.isObject = b, r.isDate = _, r.isError = w, r.isFunction = T, r.isPrimitive = function (t) {
            return null === t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || "symbol" == _typeof(t) || void 0 === t;
          }, r.isBuffer = t("./support/isBuffer");
          var A = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

          function S() {
            var t = new Date(),
                e = [M(t.getHours()), M(t.getMinutes()), M(t.getSeconds())].join(":");
            return [t.getDate(), A[t.getMonth()], e].join(" ");
          }

          function E(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
          }

          r.log = function () {
            console.log("%s - %s", S(), r.format.apply(r, arguments));
          }, r.inherits = t("inherits"), r._extend = function (t, e) {
            if (!e || !b(e)) return t;

            for (var r = Object.keys(e), n = r.length; n--;) {
              t[r[n]] = e[r[n]];
            }

            return t;
          };
        }).call(this);
      }).call(this, t("_process"), "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
    }, {
      "./support/isBuffer": 77,
      _process: 520,
      inherits: 76
    }],
    79: [function (t, e, r) {
      e.exports = function (t) {
        return atob(t);
      };
    }, {}],
    80: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        for (var r = e.length, a = new Array(r + 1), o = 0; o < r; ++o) {
          for (var s = new Array(r + 1), l = 0; l <= r; ++l) {
            s[l] = t[l][o];
          }

          a[o] = s;
        }

        a[r] = new Array(r + 1);

        for (o = 0; o <= r; ++o) {
          a[r][o] = 1;
        }

        var c = new Array(r + 1);

        for (o = 0; o < r; ++o) {
          c[o] = e[o];
        }

        c[r] = 1;
        var u = n(a, c),
            f = i(u[r + 1]);
        0 === f && (f = 1);
        var h = new Array(r + 1);

        for (o = 0; o <= r; ++o) {
          h[o] = i(u[o]) / f;
        }

        return h;
      };

      var n = t("robust-linear-solve");

      function i(t) {
        for (var e = 0, r = 0; r < t.length; ++r) {
          e += t[r];
        }

        return e;
      }
    }, {
      "robust-linear-solve": 539
    }],
    81: [function (t, e, r) {
      "use strict";

      r.byteLength = function (t) {
        var e = c(t),
            r = e[0],
            n = e[1];
        return 3 * (r + n) / 4 - n;
      }, r.toByteArray = function (t) {
        var e,
            r,
            n = c(t),
            o = n[0],
            s = n[1],
            l = new a(function (t, e, r) {
          return 3 * (e + r) / 4 - r;
        }(0, o, s)),
            u = 0,
            f = s > 0 ? o - 4 : o;

        for (r = 0; r < f; r += 4) {
          e = i[t.charCodeAt(r)] << 18 | i[t.charCodeAt(r + 1)] << 12 | i[t.charCodeAt(r + 2)] << 6 | i[t.charCodeAt(r + 3)], l[u++] = e >> 16 & 255, l[u++] = e >> 8 & 255, l[u++] = 255 & e;
        }

        2 === s && (e = i[t.charCodeAt(r)] << 2 | i[t.charCodeAt(r + 1)] >> 4, l[u++] = 255 & e);
        1 === s && (e = i[t.charCodeAt(r)] << 10 | i[t.charCodeAt(r + 1)] << 4 | i[t.charCodeAt(r + 2)] >> 2, l[u++] = e >> 8 & 255, l[u++] = 255 & e);
        return l;
      }, r.fromByteArray = function (t) {
        for (var e, r = t.length, i = r % 3, a = [], o = 0, s = r - i; o < s; o += 16383) {
          a.push(u(t, o, o + 16383 > s ? s : o + 16383));
        }

        1 === i ? (e = t[r - 1], a.push(n[e >> 2] + n[e << 4 & 63] + "==")) : 2 === i && (e = (t[r - 2] << 8) + t[r - 1], a.push(n[e >> 10] + n[e >> 4 & 63] + n[e << 2 & 63] + "="));
        return a.join("");
      };

      for (var n = [], i = [], a = "undefined" != typeof Uint8Array ? Uint8Array : Array, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = 0, l = o.length; s < l; ++s) {
        n[s] = o[s], i[o.charCodeAt(s)] = s;
      }

      function c(t) {
        var e = t.length;
        if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
        var r = t.indexOf("=");
        return -1 === r && (r = e), [r, r === e ? 0 : 4 - r % 4];
      }

      function u(t, e, r) {
        for (var i, a, o = [], s = e; s < r; s += 3) {
          i = (t[s] << 16 & 16711680) + (t[s + 1] << 8 & 65280) + (255 & t[s + 2]), o.push(n[(a = i) >> 18 & 63] + n[a >> 12 & 63] + n[a >> 6 & 63] + n[63 & a]);
        }

        return o.join("");
      }

      i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
    }, {}],
    82: [function (t, e, r) {
      "use strict";

      var n = t("./lib/rationalize");

      e.exports = function (t, e) {
        return n(t[0].mul(e[1]).add(e[0].mul(t[1])), t[1].mul(e[1]));
      };
    }, {
      "./lib/rationalize": 92
    }],
    83: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        return t[0].mul(e[1]).cmp(e[0].mul(t[1]));
      };
    }, {}],
    84: [function (t, e, r) {
      "use strict";

      var n = t("./lib/rationalize");

      e.exports = function (t, e) {
        return n(t[0].mul(e[1]), t[1].mul(e[0]));
      };
    }, {
      "./lib/rationalize": 92
    }],
    85: [function (t, e, r) {
      "use strict";

      var n = t("./is-rat"),
          i = t("./lib/is-bn"),
          a = t("./lib/num-to-bn"),
          o = t("./lib/str-to-bn"),
          s = t("./lib/rationalize"),
          l = t("./div");

      e.exports = function t(e, r) {
        if (n(e)) return r ? l(e, t(r)) : [e[0].clone(), e[1].clone()];
        var c,
            u,
            f = 0;
        if (i(e)) c = e.clone();else if ("string" == typeof e) c = o(e);else {
          if (0 === e) return [a(0), a(1)];
          if (e === Math.floor(e)) c = a(e);else {
            for (; e !== Math.floor(e);) {
              e *= Math.pow(2, 256), f -= 256;
            }

            c = a(e);
          }
        }
        if (n(r)) c.mul(r[1]), u = r[0].clone();else if (i(r)) u = r.clone();else if ("string" == typeof r) u = o(r);else if (r) {
          if (r === Math.floor(r)) u = a(r);else {
            for (; r !== Math.floor(r);) {
              r *= Math.pow(2, 256), f += 256;
            }

            u = a(r);
          }
        } else u = a(1);
        f > 0 ? c = c.ushln(f) : f < 0 && (u = u.ushln(-f));
        return s(c, u);
      };
    }, {
      "./div": 84,
      "./is-rat": 86,
      "./lib/is-bn": 90,
      "./lib/num-to-bn": 91,
      "./lib/rationalize": 92,
      "./lib/str-to-bn": 93
    }],
    86: [function (t, e, r) {
      "use strict";

      var n = t("./lib/is-bn");

      e.exports = function (t) {
        return Array.isArray(t) && 2 === t.length && n(t[0]) && n(t[1]);
      };
    }, {
      "./lib/is-bn": 90
    }],
    87: [function (t, e, r) {
      "use strict";

      var n = t("bn.js");

      e.exports = function (t) {
        return t.cmp(new n(0));
      };
    }, {
      "bn.js": 101
    }],
    88: [function (t, e, r) {
      "use strict";

      var n = t("./bn-sign");

      e.exports = function (t) {
        var e = t.length,
            r = t.words,
            i = 0;
        if (1 === e) i = r[0];else if (2 === e) i = r[0] + 67108864 * r[1];else for (var a = 0; a < e; a++) {
          var o = r[a];
          i += o * Math.pow(67108864, a);
        }
        return n(t) * i;
      };
    }, {
      "./bn-sign": 87
    }],
    89: [function (t, e, r) {
      "use strict";

      var n = t("double-bits"),
          i = t("bit-twiddle").countTrailingZeros;

      e.exports = function (t) {
        var e = i(n.lo(t));
        if (e < 32) return e;
        var r = i(n.hi(t));
        if (r > 20) return 52;
        return r + 32;
      };
    }, {
      "bit-twiddle": 99,
      "double-bits": 173
    }],
    90: [function (t, e, r) {
      "use strict";

      t("bn.js");

      e.exports = function (t) {
        return t && "object" == _typeof(t) && Boolean(t.words);
      };
    }, {
      "bn.js": 101
    }],
    91: [function (t, e, r) {
      "use strict";

      var n = t("bn.js"),
          i = t("double-bits");

      e.exports = function (t) {
        var e = i.exponent(t);
        return e < 52 ? new n(t) : new n(t * Math.pow(2, 52 - e)).ushln(e - 52);
      };
    }, {
      "bn.js": 101,
      "double-bits": 173
    }],
    92: [function (t, e, r) {
      "use strict";

      var n = t("./num-to-bn"),
          i = t("./bn-sign");

      e.exports = function (t, e) {
        var r = i(t),
            a = i(e);
        if (0 === r) return [n(0), n(1)];
        if (0 === a) return [n(0), n(0)];
        a < 0 && (t = t.neg(), e = e.neg());
        var o = t.gcd(e);
        if (o.cmpn(1)) return [t.div(o), e.div(o)];
        return [t, e];
      };
    }, {
      "./bn-sign": 87,
      "./num-to-bn": 91
    }],
    93: [function (t, e, r) {
      "use strict";

      var n = t("bn.js");

      e.exports = function (t) {
        return new n(t);
      };
    }, {
      "bn.js": 101
    }],
    94: [function (t, e, r) {
      "use strict";

      var n = t("./lib/rationalize");

      e.exports = function (t, e) {
        return n(t[0].mul(e[0]), t[1].mul(e[1]));
      };
    }, {
      "./lib/rationalize": 92
    }],
    95: [function (t, e, r) {
      "use strict";

      var n = t("./lib/bn-sign");

      e.exports = function (t) {
        return n(t[0]) * n(t[1]);
      };
    }, {
      "./lib/bn-sign": 87
    }],
    96: [function (t, e, r) {
      "use strict";

      var n = t("./lib/rationalize");

      e.exports = function (t, e) {
        return n(t[0].mul(e[1]).sub(t[1].mul(e[0])), t[1].mul(e[1]));
      };
    }, {
      "./lib/rationalize": 92
    }],
    97: [function (t, e, r) {
      "use strict";

      var n = t("./lib/bn-to-num"),
          i = t("./lib/ctz");

      e.exports = function (t) {
        var e = t[0],
            r = t[1];
        if (0 === e.cmpn(0)) return 0;
        var a = e.abs().divmod(r.abs()),
            o = a.div,
            s = n(o),
            l = a.mod,
            c = e.negative !== r.negative ? -1 : 1;
        if (0 === l.cmpn(0)) return c * s;

        if (s) {
          var u = i(s) + 4,
              f = n(l.ushln(u).divRound(r));
          return c * (s + f * Math.pow(2, -u));
        }

        var h = r.bitLength() - l.bitLength() + 53;
        f = n(l.ushln(h).divRound(r));
        return h < 1023 ? c * f * Math.pow(2, -h) : (f *= Math.pow(2, -1023), c * f * Math.pow(2, 1023 - h));
      };
    }, {
      "./lib/bn-to-num": 88,
      "./lib/ctz": 89
    }],
    98: [function (t, e, r) {
      "use strict";

      function n(t, e, r, n, i) {
        for (var a = i + 1; n <= i;) {
          var o = n + i >>> 1,
              s = t[o];
          (void 0 !== r ? r(s, e) : s - e) >= 0 ? (a = o, i = o - 1) : n = o + 1;
        }

        return a;
      }

      function i(t, e, r, n, i) {
        for (var a = i + 1; n <= i;) {
          var o = n + i >>> 1,
              s = t[o];
          (void 0 !== r ? r(s, e) : s - e) > 0 ? (a = o, i = o - 1) : n = o + 1;
        }

        return a;
      }

      function a(t, e, r, n, i) {
        for (var a = n - 1; n <= i;) {
          var o = n + i >>> 1,
              s = t[o];
          (void 0 !== r ? r(s, e) : s - e) < 0 ? (a = o, n = o + 1) : i = o - 1;
        }

        return a;
      }

      function o(t, e, r, n, i) {
        for (var a = n - 1; n <= i;) {
          var o = n + i >>> 1,
              s = t[o];
          (void 0 !== r ? r(s, e) : s - e) <= 0 ? (a = o, n = o + 1) : i = o - 1;
        }

        return a;
      }

      function s(t, e, r, n, i) {
        for (; n <= i;) {
          var a = n + i >>> 1,
              o = t[a],
              s = void 0 !== r ? r(o, e) : o - e;
          if (0 === s) return a;
          s <= 0 ? n = a + 1 : i = a - 1;
        }

        return -1;
      }

      function l(t, e, r, n, i, a) {
        return "function" == typeof r ? a(t, e, r, void 0 === n ? 0 : 0 | n, void 0 === i ? t.length - 1 : 0 | i) : a(t, e, void 0, void 0 === r ? 0 : 0 | r, void 0 === n ? t.length - 1 : 0 | n);
      }

      e.exports = {
        ge: function ge(t, e, r, i, a) {
          return l(t, e, r, i, a, n);
        },
        gt: function gt(t, e, r, n, a) {
          return l(t, e, r, n, a, i);
        },
        lt: function lt(t, e, r, n, i) {
          return l(t, e, r, n, i, a);
        },
        le: function le(t, e, r, n, i) {
          return l(t, e, r, n, i, o);
        },
        eq: function eq(t, e, r, n, i) {
          return l(t, e, r, n, i, s);
        }
      };
    }, {}],
    99: [function (t, e, r) {
      "use strict";

      function n(t) {
        var e = 32;
        return (t &= -t) && e--, 65535 & t && (e -= 16), 16711935 & t && (e -= 8), 252645135 & t && (e -= 4), 858993459 & t && (e -= 2), 1431655765 & t && (e -= 1), e;
      }

      r.INT_BITS = 32, r.INT_MAX = 2147483647, r.INT_MIN = -1 << 31, r.sign = function (t) {
        return (t > 0) - (t < 0);
      }, r.abs = function (t) {
        var e = t >> 31;
        return (t ^ e) - e;
      }, r.min = function (t, e) {
        return e ^ (t ^ e) & -(t < e);
      }, r.max = function (t, e) {
        return t ^ (t ^ e) & -(t < e);
      }, r.isPow2 = function (t) {
        return !(t & t - 1 || !t);
      }, r.log2 = function (t) {
        var e, r;
        return e = (t > 65535) << 4, e |= r = ((t >>>= e) > 255) << 3, e |= r = ((t >>>= r) > 15) << 2, (e |= r = ((t >>>= r) > 3) << 1) | (t >>>= r) >> 1;
      }, r.log10 = function (t) {
        return t >= 1e9 ? 9 : t >= 1e8 ? 8 : t >= 1e7 ? 7 : t >= 1e6 ? 6 : t >= 1e5 ? 5 : t >= 1e4 ? 4 : t >= 1e3 ? 3 : t >= 100 ? 2 : t >= 10 ? 1 : 0;
      }, r.popCount = function (t) {
        return 16843009 * ((t = (858993459 & (t -= t >>> 1 & 1431655765)) + (t >>> 2 & 858993459)) + (t >>> 4) & 252645135) >>> 24;
      }, r.countTrailingZeros = n, r.nextPow2 = function (t) {
        return t += 0 === t, --t, t |= t >>> 1, t |= t >>> 2, t |= t >>> 4, t |= t >>> 8, (t |= t >>> 16) + 1;
      }, r.prevPow2 = function (t) {
        return t |= t >>> 1, t |= t >>> 2, t |= t >>> 4, t |= t >>> 8, (t |= t >>> 16) - (t >>> 1);
      }, r.parity = function (t) {
        return t ^= t >>> 16, t ^= t >>> 8, t ^= t >>> 4, 27030 >>> (t &= 15) & 1;
      };
      var i = new Array(256);
      !function (t) {
        for (var e = 0; e < 256; ++e) {
          var r = e,
              n = e,
              i = 7;

          for (r >>>= 1; r; r >>>= 1) {
            n <<= 1, n |= 1 & r, --i;
          }

          t[e] = n << i & 255;
        }
      }(i), r.reverse = function (t) {
        return i[255 & t] << 24 | i[t >>> 8 & 255] << 16 | i[t >>> 16 & 255] << 8 | i[t >>> 24 & 255];
      }, r.interleave2 = function (t, e) {
        return (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t &= 65535) | t << 8)) | t << 4)) | t << 2)) | t << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e &= 65535) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
      }, r.deinterleave2 = function (t, e) {
        return (t = 65535 & ((t = 16711935 & ((t = 252645135 & ((t = 858993459 & ((t = t >>> e & 1431655765) | t >>> 1)) | t >>> 2)) | t >>> 4)) | t >>> 16)) << 16 >> 16;
      }, r.interleave3 = function (t, e, r) {
        return t = 1227133513 & ((t = 3272356035 & ((t = 251719695 & ((t = 4278190335 & ((t &= 1023) | t << 16)) | t << 8)) | t << 4)) | t << 2), (t |= (e = 1227133513 & ((e = 3272356035 & ((e = 251719695 & ((e = 4278190335 & ((e &= 1023) | e << 16)) | e << 8)) | e << 4)) | e << 2)) << 1) | (r = 1227133513 & ((r = 3272356035 & ((r = 251719695 & ((r = 4278190335 & ((r &= 1023) | r << 16)) | r << 8)) | r << 4)) | r << 2)) << 2;
      }, r.deinterleave3 = function (t, e) {
        return (t = 1023 & ((t = 4278190335 & ((t = 251719695 & ((t = 3272356035 & ((t = t >>> e & 1227133513) | t >>> 2)) | t >>> 4)) | t >>> 8)) | t >>> 16)) << 22 >> 22;
      }, r.nextCombination = function (t) {
        var e = t | t - 1;
        return e + 1 | (~e & -~e) - 1 >>> n(t) + 1;
      };
    }, {}],
    100: [function (t, e, r) {
      "use strict";

      var n = t("clamp");

      e.exports = function (t, e) {
        e || (e = {});
        var r,
            o,
            s,
            l,
            c,
            u,
            f,
            h,
            p,
            d,
            m,
            g = null == e.cutoff ? .25 : e.cutoff,
            v = null == e.radius ? 8 : e.radius,
            y = e.channel || 0;

        if (ArrayBuffer.isView(t) || Array.isArray(t)) {
          if (!e.width || !e.height) throw Error("For raw data width and height should be provided by options");
          r = e.width, o = e.height, l = t, u = e.stride ? e.stride : Math.floor(t.length / r / o);
        } else window.HTMLCanvasElement && t instanceof window.HTMLCanvasElement ? (f = (h = t).getContext("2d"), r = h.width, o = h.height, p = f.getImageData(0, 0, r, o), l = p.data, u = 4) : window.CanvasRenderingContext2D && t instanceof window.CanvasRenderingContext2D ? (h = t.canvas, f = t, r = h.width, o = h.height, p = f.getImageData(0, 0, r, o), l = p.data, u = 4) : window.ImageData && t instanceof window.ImageData && (p = t, r = t.width, o = t.height, l = p.data, u = 4);

        if (s = Math.max(r, o), window.Uint8ClampedArray && l instanceof window.Uint8ClampedArray || window.Uint8Array && l instanceof window.Uint8Array) for (c = l, l = Array(r * o), d = 0, m = c.length; d < m; d++) {
          l[d] = c[d * u + y] / 255;
        } else if (1 !== u) throw Error("Raw data can have only 1 value per pixel");

        var x = Array(r * o),
            b = Array(r * o),
            _ = Array(s),
            w = Array(s),
            T = Array(s + 1),
            k = Array(s);

        for (d = 0, m = r * o; d < m; d++) {
          var M = l[d];
          x[d] = 1 === M ? 0 : 0 === M ? i : Math.pow(Math.max(0, .5 - M), 2), b[d] = 1 === M ? i : 0 === M ? 0 : Math.pow(Math.max(0, M - .5), 2);
        }

        a(x, r, o, _, w, k, T), a(b, r, o, _, w, k, T);
        var A = window.Float32Array ? new Float32Array(r * o) : new Array(r * o);

        for (d = 0, m = r * o; d < m; d++) {
          A[d] = n(1 - ((x[d] - b[d]) / v + g), 0, 1);
        }

        return A;
      };

      var i = 1e20;

      function a(t, e, r, n, i, a, s) {
        for (var l = 0; l < e; l++) {
          for (var c = 0; c < r; c++) {
            n[c] = t[c * e + l];
          }

          for (o(n, i, a, s, r), c = 0; c < r; c++) {
            t[c * e + l] = i[c];
          }
        }

        for (c = 0; c < r; c++) {
          for (l = 0; l < e; l++) {
            n[l] = t[c * e + l];
          }

          for (o(n, i, a, s, e), l = 0; l < e; l++) {
            t[c * e + l] = Math.sqrt(i[l]);
          }
        }
      }

      function o(t, e, r, n, a) {
        r[0] = 0, n[0] = -i, n[1] = +i;

        for (var o = 1, s = 0; o < a; o++) {
          for (var l = (t[o] + o * o - (t[r[s]] + r[s] * r[s])) / (2 * o - 2 * r[s]); l <= n[s];) {
            s--, l = (t[o] + o * o - (t[r[s]] + r[s] * r[s])) / (2 * o - 2 * r[s]);
          }

          r[++s] = o, n[s] = l, n[s + 1] = +i;
        }

        for (o = 0, s = 0; o < a; o++) {
          for (; n[s + 1] < o;) {
            s++;
          }

          e[o] = (o - r[s]) * (o - r[s]) + t[r[s]];
        }
      }
    }, {
      clamp: 121
    }],
    101: [function (t, e, r) {
      !function (e, r) {
        "use strict";

        function n(t, e) {
          if (!t) throw new Error(e || "Assertion failed");
        }

        function i(t, e) {
          t.super_ = e;

          var r = function r() {};

          r.prototype = e.prototype, t.prototype = new r(), t.prototype.constructor = t;
        }

        function a(t, e, r) {
          if (a.isBN(t)) return t;
          this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== t && ("le" !== e && "be" !== e || (r = e, e = 10), this._init(t || 0, e || 10, r || "be"));
        }

        var o;
        "object" == _typeof(e) ? e.exports = a : r.BN = a, a.BN = a, a.wordSize = 26;

        try {
          o = t("buffer").Buffer;
        } catch (t) {}

        function s(t, e, r) {
          for (var n = 0, i = Math.min(t.length, r), a = e; a < i; a++) {
            var o = t.charCodeAt(a) - 48;
            n <<= 4, n |= o >= 49 && o <= 54 ? o - 49 + 10 : o >= 17 && o <= 22 ? o - 17 + 10 : 15 & o;
          }

          return n;
        }

        function l(t, e, r, n) {
          for (var i = 0, a = Math.min(t.length, r), o = e; o < a; o++) {
            var s = t.charCodeAt(o) - 48;
            i *= n, i += s >= 49 ? s - 49 + 10 : s >= 17 ? s - 17 + 10 : s;
          }

          return i;
        }

        a.isBN = function (t) {
          return t instanceof a || null !== t && "object" == _typeof(t) && t.constructor.wordSize === a.wordSize && Array.isArray(t.words);
        }, a.max = function (t, e) {
          return t.cmp(e) > 0 ? t : e;
        }, a.min = function (t, e) {
          return t.cmp(e) < 0 ? t : e;
        }, a.prototype._init = function (t, e, r) {
          if ("number" == typeof t) return this._initNumber(t, e, r);
          if ("object" == _typeof(t)) return this._initArray(t, e, r);
          "hex" === e && (e = 16), n(e === (0 | e) && e >= 2 && e <= 36);
          var i = 0;
          "-" === (t = t.toString().replace(/\s+/g, ""))[0] && i++, 16 === e ? this._parseHex(t, i) : this._parseBase(t, e, i), "-" === t[0] && (this.negative = 1), this.strip(), "le" === r && this._initArray(this.toArray(), e, r);
        }, a.prototype._initNumber = function (t, e, r) {
          t < 0 && (this.negative = 1, t = -t), t < 67108864 ? (this.words = [67108863 & t], this.length = 1) : t < 4503599627370496 ? (this.words = [67108863 & t, t / 67108864 & 67108863], this.length = 2) : (n(t < 9007199254740992), this.words = [67108863 & t, t / 67108864 & 67108863, 1], this.length = 3), "le" === r && this._initArray(this.toArray(), e, r);
        }, a.prototype._initArray = function (t, e, r) {
          if (n("number" == typeof t.length), t.length <= 0) return this.words = [0], this.length = 1, this;
          this.length = Math.ceil(t.length / 3), this.words = new Array(this.length);

          for (var i = 0; i < this.length; i++) {
            this.words[i] = 0;
          }

          var a,
              o,
              s = 0;
          if ("be" === r) for (i = t.length - 1, a = 0; i >= 0; i -= 3) {
            o = t[i] | t[i - 1] << 8 | t[i - 2] << 16, this.words[a] |= o << s & 67108863, this.words[a + 1] = o >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, a++);
          } else if ("le" === r) for (i = 0, a = 0; i < t.length; i += 3) {
            o = t[i] | t[i + 1] << 8 | t[i + 2] << 16, this.words[a] |= o << s & 67108863, this.words[a + 1] = o >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, a++);
          }
          return this.strip();
        }, a.prototype._parseHex = function (t, e) {
          this.length = Math.ceil((t.length - e) / 6), this.words = new Array(this.length);

          for (var r = 0; r < this.length; r++) {
            this.words[r] = 0;
          }

          var n,
              i,
              a = 0;

          for (r = t.length - 6, n = 0; r >= e; r -= 6) {
            i = s(t, r, r + 6), this.words[n] |= i << a & 67108863, this.words[n + 1] |= i >>> 26 - a & 4194303, (a += 24) >= 26 && (a -= 26, n++);
          }

          r + 6 !== e && (i = s(t, e, r + 6), this.words[n] |= i << a & 67108863, this.words[n + 1] |= i >>> 26 - a & 4194303), this.strip();
        }, a.prototype._parseBase = function (t, e, r) {
          this.words = [0], this.length = 1;

          for (var n = 0, i = 1; i <= 67108863; i *= e) {
            n++;
          }

          n--, i = i / e | 0;

          for (var a = t.length - r, o = a % n, s = Math.min(a, a - o) + r, c = 0, u = r; u < s; u += n) {
            c = l(t, u, u + n, e), this.imuln(i), this.words[0] + c < 67108864 ? this.words[0] += c : this._iaddn(c);
          }

          if (0 !== o) {
            var f = 1;

            for (c = l(t, u, t.length, e), u = 0; u < o; u++) {
              f *= e;
            }

            this.imuln(f), this.words[0] + c < 67108864 ? this.words[0] += c : this._iaddn(c);
          }
        }, a.prototype.copy = function (t) {
          t.words = new Array(this.length);

          for (var e = 0; e < this.length; e++) {
            t.words[e] = this.words[e];
          }

          t.length = this.length, t.negative = this.negative, t.red = this.red;
        }, a.prototype.clone = function () {
          var t = new a(null);
          return this.copy(t), t;
        }, a.prototype._expand = function (t) {
          for (; this.length < t;) {
            this.words[this.length++] = 0;
          }

          return this;
        }, a.prototype.strip = function () {
          for (; this.length > 1 && 0 === this.words[this.length - 1];) {
            this.length--;
          }

          return this._normSign();
        }, a.prototype._normSign = function () {
          return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
        }, a.prototype.inspect = function () {
          return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
        };
        var c = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
            u = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
            f = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];

        function h(t, e, r) {
          r.negative = e.negative ^ t.negative;
          var n = t.length + e.length | 0;
          r.length = n, n = n - 1 | 0;
          var i = 0 | t.words[0],
              a = 0 | e.words[0],
              o = i * a,
              s = 67108863 & o,
              l = o / 67108864 | 0;
          r.words[0] = s;

          for (var c = 1; c < n; c++) {
            for (var u = l >>> 26, f = 67108863 & l, h = Math.min(c, e.length - 1), p = Math.max(0, c - t.length + 1); p <= h; p++) {
              var d = c - p | 0;
              u += (o = (i = 0 | t.words[d]) * (a = 0 | e.words[p]) + f) / 67108864 | 0, f = 67108863 & o;
            }

            r.words[c] = 0 | f, l = 0 | u;
          }

          return 0 !== l ? r.words[c] = 0 | l : r.length--, r.strip();
        }

        a.prototype.toString = function (t, e) {
          var r;

          if (e = 0 | e || 1, 16 === (t = t || 10) || "hex" === t) {
            r = "";

            for (var i = 0, a = 0, o = 0; o < this.length; o++) {
              var s = this.words[o],
                  l = (16777215 & (s << i | a)).toString(16);
              r = 0 !== (a = s >>> 24 - i & 16777215) || o !== this.length - 1 ? c[6 - l.length] + l + r : l + r, (i += 2) >= 26 && (i -= 26, o--);
            }

            for (0 !== a && (r = a.toString(16) + r); r.length % e != 0;) {
              r = "0" + r;
            }

            return 0 !== this.negative && (r = "-" + r), r;
          }

          if (t === (0 | t) && t >= 2 && t <= 36) {
            var h = u[t],
                p = f[t];
            r = "";
            var d = this.clone();

            for (d.negative = 0; !d.isZero();) {
              var m = d.modn(p).toString(t);
              r = (d = d.idivn(p)).isZero() ? m + r : c[h - m.length] + m + r;
            }

            for (this.isZero() && (r = "0" + r); r.length % e != 0;) {
              r = "0" + r;
            }

            return 0 !== this.negative && (r = "-" + r), r;
          }

          n(!1, "Base should be between 2 and 36");
        }, a.prototype.toNumber = function () {
          var t = this.words[0];
          return 2 === this.length ? t += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? t += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -t : t;
        }, a.prototype.toJSON = function () {
          return this.toString(16);
        }, a.prototype.toBuffer = function (t, e) {
          return n(void 0 !== o), this.toArrayLike(o, t, e);
        }, a.prototype.toArray = function (t, e) {
          return this.toArrayLike(Array, t, e);
        }, a.prototype.toArrayLike = function (t, e, r) {
          var i = this.byteLength(),
              a = r || Math.max(1, i);
          n(i <= a, "byte array longer than desired length"), n(a > 0, "Requested array length <= 0"), this.strip();
          var o,
              s,
              l = "le" === e,
              c = new t(a),
              u = this.clone();

          if (l) {
            for (s = 0; !u.isZero(); s++) {
              o = u.andln(255), u.iushrn(8), c[s] = o;
            }

            for (; s < a; s++) {
              c[s] = 0;
            }
          } else {
            for (s = 0; s < a - i; s++) {
              c[s] = 0;
            }

            for (s = 0; !u.isZero(); s++) {
              o = u.andln(255), u.iushrn(8), c[a - s - 1] = o;
            }
          }

          return c;
        }, Math.clz32 ? a.prototype._countBits = function (t) {
          return 32 - Math.clz32(t);
        } : a.prototype._countBits = function (t) {
          var e = t,
              r = 0;
          return e >= 4096 && (r += 13, e >>>= 13), e >= 64 && (r += 7, e >>>= 7), e >= 8 && (r += 4, e >>>= 4), e >= 2 && (r += 2, e >>>= 2), r + e;
        }, a.prototype._zeroBits = function (t) {
          if (0 === t) return 26;
          var e = t,
              r = 0;
          return 0 == (8191 & e) && (r += 13, e >>>= 13), 0 == (127 & e) && (r += 7, e >>>= 7), 0 == (15 & e) && (r += 4, e >>>= 4), 0 == (3 & e) && (r += 2, e >>>= 2), 0 == (1 & e) && r++, r;
        }, a.prototype.bitLength = function () {
          var t = this.words[this.length - 1],
              e = this._countBits(t);

          return 26 * (this.length - 1) + e;
        }, a.prototype.zeroBits = function () {
          if (this.isZero()) return 0;

          for (var t = 0, e = 0; e < this.length; e++) {
            var r = this._zeroBits(this.words[e]);

            if (t += r, 26 !== r) break;
          }

          return t;
        }, a.prototype.byteLength = function () {
          return Math.ceil(this.bitLength() / 8);
        }, a.prototype.toTwos = function (t) {
          return 0 !== this.negative ? this.abs().inotn(t).iaddn(1) : this.clone();
        }, a.prototype.fromTwos = function (t) {
          return this.testn(t - 1) ? this.notn(t).iaddn(1).ineg() : this.clone();
        }, a.prototype.isNeg = function () {
          return 0 !== this.negative;
        }, a.prototype.neg = function () {
          return this.clone().ineg();
        }, a.prototype.ineg = function () {
          return this.isZero() || (this.negative ^= 1), this;
        }, a.prototype.iuor = function (t) {
          for (; this.length < t.length;) {
            this.words[this.length++] = 0;
          }

          for (var e = 0; e < t.length; e++) {
            this.words[e] = this.words[e] | t.words[e];
          }

          return this.strip();
        }, a.prototype.ior = function (t) {
          return n(0 == (this.negative | t.negative)), this.iuor(t);
        }, a.prototype.or = function (t) {
          return this.length > t.length ? this.clone().ior(t) : t.clone().ior(this);
        }, a.prototype.uor = function (t) {
          return this.length > t.length ? this.clone().iuor(t) : t.clone().iuor(this);
        }, a.prototype.iuand = function (t) {
          var e;
          e = this.length > t.length ? t : this;

          for (var r = 0; r < e.length; r++) {
            this.words[r] = this.words[r] & t.words[r];
          }

          return this.length = e.length, this.strip();
        }, a.prototype.iand = function (t) {
          return n(0 == (this.negative | t.negative)), this.iuand(t);
        }, a.prototype.and = function (t) {
          return this.length > t.length ? this.clone().iand(t) : t.clone().iand(this);
        }, a.prototype.uand = function (t) {
          return this.length > t.length ? this.clone().iuand(t) : t.clone().iuand(this);
        }, a.prototype.iuxor = function (t) {
          var e, r;
          this.length > t.length ? (e = this, r = t) : (e = t, r = this);

          for (var n = 0; n < r.length; n++) {
            this.words[n] = e.words[n] ^ r.words[n];
          }

          if (this !== e) for (; n < e.length; n++) {
            this.words[n] = e.words[n];
          }
          return this.length = e.length, this.strip();
        }, a.prototype.ixor = function (t) {
          return n(0 == (this.negative | t.negative)), this.iuxor(t);
        }, a.prototype.xor = function (t) {
          return this.length > t.length ? this.clone().ixor(t) : t.clone().ixor(this);
        }, a.prototype.uxor = function (t) {
          return this.length > t.length ? this.clone().iuxor(t) : t.clone().iuxor(this);
        }, a.prototype.inotn = function (t) {
          n("number" == typeof t && t >= 0);
          var e = 0 | Math.ceil(t / 26),
              r = t % 26;
          this._expand(e), r > 0 && e--;

          for (var i = 0; i < e; i++) {
            this.words[i] = 67108863 & ~this.words[i];
          }

          return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this.strip();
        }, a.prototype.notn = function (t) {
          return this.clone().inotn(t);
        }, a.prototype.setn = function (t, e) {
          n("number" == typeof t && t >= 0);
          var r = t / 26 | 0,
              i = t % 26;
          return this._expand(r + 1), this.words[r] = e ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this.strip();
        }, a.prototype.iadd = function (t) {
          var e, r, n;
          if (0 !== this.negative && 0 === t.negative) return this.negative = 0, e = this.isub(t), this.negative ^= 1, this._normSign();
          if (0 === this.negative && 0 !== t.negative) return t.negative = 0, e = this.isub(t), t.negative = 1, e._normSign();
          this.length > t.length ? (r = this, n = t) : (r = t, n = this);

          for (var i = 0, a = 0; a < n.length; a++) {
            e = (0 | r.words[a]) + (0 | n.words[a]) + i, this.words[a] = 67108863 & e, i = e >>> 26;
          }

          for (; 0 !== i && a < r.length; a++) {
            e = (0 | r.words[a]) + i, this.words[a] = 67108863 & e, i = e >>> 26;
          }

          if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;else if (r !== this) for (; a < r.length; a++) {
            this.words[a] = r.words[a];
          }
          return this;
        }, a.prototype.add = function (t) {
          var e;
          return 0 !== t.negative && 0 === this.negative ? (t.negative = 0, e = this.sub(t), t.negative ^= 1, e) : 0 === t.negative && 0 !== this.negative ? (this.negative = 0, e = t.sub(this), this.negative = 1, e) : this.length > t.length ? this.clone().iadd(t) : t.clone().iadd(this);
        }, a.prototype.isub = function (t) {
          if (0 !== t.negative) {
            t.negative = 0;
            var e = this.iadd(t);
            return t.negative = 1, e._normSign();
          }

          if (0 !== this.negative) return this.negative = 0, this.iadd(t), this.negative = 1, this._normSign();
          var r,
              n,
              i = this.cmp(t);
          if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
          i > 0 ? (r = this, n = t) : (r = t, n = this);

          for (var a = 0, o = 0; o < n.length; o++) {
            a = (e = (0 | r.words[o]) - (0 | n.words[o]) + a) >> 26, this.words[o] = 67108863 & e;
          }

          for (; 0 !== a && o < r.length; o++) {
            a = (e = (0 | r.words[o]) + a) >> 26, this.words[o] = 67108863 & e;
          }

          if (0 === a && o < r.length && r !== this) for (; o < r.length; o++) {
            this.words[o] = r.words[o];
          }
          return this.length = Math.max(this.length, o), r !== this && (this.negative = 1), this.strip();
        }, a.prototype.sub = function (t) {
          return this.clone().isub(t);
        };

        var p = function p(t, e, r) {
          var n,
              i,
              a,
              o = t.words,
              s = e.words,
              l = r.words,
              c = 0,
              u = 0 | o[0],
              f = 8191 & u,
              h = u >>> 13,
              p = 0 | o[1],
              d = 8191 & p,
              m = p >>> 13,
              g = 0 | o[2],
              v = 8191 & g,
              y = g >>> 13,
              x = 0 | o[3],
              b = 8191 & x,
              _ = x >>> 13,
              w = 0 | o[4],
              T = 8191 & w,
              k = w >>> 13,
              M = 0 | o[5],
              A = 8191 & M,
              S = M >>> 13,
              E = 0 | o[6],
              L = 8191 & E,
              C = E >>> 13,
              P = 0 | o[7],
              I = 8191 & P,
              O = P >>> 13,
              z = 0 | o[8],
              D = 8191 & z,
              R = z >>> 13,
              F = 0 | o[9],
              B = 8191 & F,
              N = F >>> 13,
              j = 0 | s[0],
              U = 8191 & j,
              V = j >>> 13,
              q = 0 | s[1],
              H = 8191 & q,
              G = q >>> 13,
              Y = 0 | s[2],
              W = 8191 & Y,
              X = Y >>> 13,
              Z = 0 | s[3],
              J = 8191 & Z,
              K = Z >>> 13,
              Q = 0 | s[4],
              $ = 8191 & Q,
              tt = Q >>> 13,
              et = 0 | s[5],
              rt = 8191 & et,
              nt = et >>> 13,
              it = 0 | s[6],
              at = 8191 & it,
              ot = it >>> 13,
              st = 0 | s[7],
              lt = 8191 & st,
              ct = st >>> 13,
              ut = 0 | s[8],
              ft = 8191 & ut,
              ht = ut >>> 13,
              pt = 0 | s[9],
              dt = 8191 & pt,
              mt = pt >>> 13;

          r.negative = t.negative ^ e.negative, r.length = 19;
          var gt = (c + (n = Math.imul(f, U)) | 0) + ((8191 & (i = (i = Math.imul(f, V)) + Math.imul(h, U) | 0)) << 13) | 0;
          c = ((a = Math.imul(h, V)) + (i >>> 13) | 0) + (gt >>> 26) | 0, gt &= 67108863, n = Math.imul(d, U), i = (i = Math.imul(d, V)) + Math.imul(m, U) | 0, a = Math.imul(m, V);
          var vt = (c + (n = n + Math.imul(f, H) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(f, G) | 0) + Math.imul(h, H) | 0)) << 13) | 0;
          c = ((a = a + Math.imul(h, G) | 0) + (i >>> 13) | 0) + (vt >>> 26) | 0, vt &= 67108863, n = Math.imul(v, U), i = (i = Math.imul(v, V)) + Math.imul(y, U) | 0, a = Math.imul(y, V), n = n + Math.imul(d, H) | 0, i = (i = i + Math.imul(d, G) | 0) + Math.imul(m, H) | 0, a = a + Math.imul(m, G) | 0;
          var yt = (c + (n = n + Math.imul(f, W) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(f, X) | 0) + Math.imul(h, W) | 0)) << 13) | 0;
          c = ((a = a + Math.imul(h, X) | 0) + (i >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, n = Math.imul(b, U), i = (i = Math.imul(b, V)) + Math.imul(_, U) | 0, a = Math.imul(_, V), n = n + Math.imul(v, H) | 0, i = (i = i + Math.imul(v, G) | 0) + Math.imul(y, H) | 0, a = a + Math.imul(y, G) | 0, n = n + Math.imul(d, W) | 0, i = (i = i + Math.imul(d, X) | 0) + Math.imul(m, W) | 0, a = a + Math.imul(m, X) | 0;
          var xt = (c + (n = n + Math.imul(f, J) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(f, K) | 0) + Math.imul(h, J) | 0)) << 13) | 0;
          c = ((a = a + Math.imul(h, K) | 0) + (i >>> 13) | 0) + (xt >>> 26) | 0, xt &= 67108863, n = Math.imul(T, U), i = (i = Math.imul(T, V)) + Math.imul(k, U) | 0, a = Math.imul(k, V), n = n + Math.imul(b, H) | 0, i = (i = i + Math.imul(b, G) | 0) + Math.imul(_, H) | 0, a = a + Math.imul(_, G) | 0, n = n + Math.imul(v, W) | 0, i = (i = i + Math.imul(v, X) | 0) + Math.imul(y, W) | 0, a = a + Math.imul(y, X) | 0, n = n + Math.imul(d, J) | 0, i = (i = i + Math.imul(d, K) | 0) + Math.imul(m, J) | 0, a = a + Math.imul(m, K) | 0;
          var bt = (c + (n = n + Math.imul(f, $) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(f, tt) | 0) + Math.imul(h, $) | 0)) << 13) | 0;
          c = ((a = a + Math.imul(h, tt) | 0) + (i >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, n = Math.imul(A, U), i = (i = Math.imul(A, V)) + Math.imul(S, U) | 0, a = Math.imul(S, V), n = n + Math.imul(T, H) | 0, i = (i = i + Math.imul(T, G) | 0) + Math.imul(k, H) | 0, a = a + Math.imul(k, G) | 0, n = n + Math.imul(b, W) | 0, i = (i = i + Math.imul(b, X) | 0) + Math.imul(_, W) | 0, a = a + Math.imul(_, X) | 0, n = n + Math.imul(v, J) | 0, i = (i = i + Math.imul(v, K) | 0) + Math.imul(y, J) | 0, a = a + Math.imul(y, K) | 0, n = n + Math.imul(d, $) | 0, i = (i = i + Math.imul(d, tt) | 0) + Math.imul(m, $) | 0, a = a + Math.imul(m, tt) | 0;

          var _t = (c + (n = n + Math.imul(f, rt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(f, nt) | 0) + Math.imul(h, rt) | 0)) << 13) | 0;

          c = ((a = a + Math.imul(h, nt) | 0) + (i >>> 13) | 0) + (_t >>> 26) | 0, _t &= 67108863, n = Math.imul(L, U), i = (i = Math.imul(L, V)) + Math.imul(C, U) | 0, a = Math.imul(C, V), n = n + Math.imul(A, H) | 0, i = (i = i + Math.imul(A, G) | 0) + Math.imul(S, H) | 0, a = a + Math.imul(S, G) | 0, n = n + Math.imul(T, W) | 0, i = (i = i + Math.imul(T, X) | 0) + Math.imul(k, W) | 0, a = a + Math.imul(k, X) | 0, n = n + Math.imul(b, J) | 0, i = (i = i + Math.imul(b, K) | 0) + Math.imul(_, J) | 0, a = a + Math.imul(_, K) | 0, n = n + Math.imul(v, $) | 0, i = (i = i + Math.imul(v, tt) | 0) + Math.imul(y, $) | 0, a = a + Math.imul(y, tt) | 0, n = n + Math.imul(d, rt) | 0, i = (i = i + Math.imul(d, nt) | 0) + Math.imul(m, rt) | 0, a = a + Math.imul(m, nt) | 0;
          var wt = (c + (n = n + Math.imul(f, at) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(f, ot) | 0) + Math.imul(h, at) | 0)) << 13) | 0;
          c = ((a = a + Math.imul(h, ot) | 0) + (i >>> 13) | 0) + (wt >>> 26) | 0, wt &= 67108863, n = Math.imul(I, U), i = (i = Math.imul(I, V)) + Math.imul(O, U) | 0, a = Math.imul(O, V), n = n + Math.imul(L, H) | 0, i = (i = i + Math.imul(L, G) | 0) + Math.imul(C, H) | 0, a = a + Math.imul(C, G) | 0, n = n + Math.imul(A, W) | 0, i = (i = i + Math.imul(A, X) | 0) + Math.imul(S, W) | 0, a = a + Math.imul(S, X) | 0, n = n + Math.imul(T, J) | 0, i = (i = i + Math.imul(T, K) | 0) + Math.imul(k, J) | 0, a = a + Math.imul(k, K) | 0, n = n + Math.imul(b, $) | 0, i = (i = i + Math.imul(b, tt) | 0) + Math.imul(_, $) | 0, a = a + Math.imul(_, tt) | 0, n = n + Math.imul(v, rt) | 0, i = (i = i + Math.imul(v, nt) | 0) + Math.imul(y, rt) | 0, a = a + Math.imul(y, nt) | 0, n = n + Math.imul(d, at) | 0, i = (i = i + Math.imul(d, ot) | 0) + Math.imul(m, at) | 0, a = a + Math.imul(m, ot) | 0;
          var Tt = (c + (n = n + Math.imul(f, lt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(f, ct) | 0) + Math.imul(h, lt) | 0)) << 13) | 0;
          c = ((a = a + Math.imul(h, ct) | 0) + (i >>> 13) | 0) + (Tt >>> 26) | 0, Tt &= 67108863, n = Math.imul(D, U), i = (i = Math.imul(D, V)) + Math.imul(R, U) | 0, a = Math.imul(R, V), n = n + Math.imul(I, H) | 0, i = (i = i + Math.imul(I, G) | 0) + Math.imul(O, H) | 0, a = a + Math.imul(O, G) | 0, n = n + Math.imul(L, W) | 0, i = (i = i + Math.imul(L, X) | 0) + Math.imul(C, W) | 0, a = a + Math.imul(C, X) | 0, n = n + Math.imul(A, J) | 0, i = (i = i + Math.imul(A, K) | 0) + Math.imul(S, J) | 0, a = a + Math.imul(S, K) | 0, n = n + Math.imul(T, $) | 0, i = (i = i + Math.imul(T, tt) | 0) + Math.imul(k, $) | 0, a = a + Math.imul(k, tt) | 0, n = n + Math.imul(b, rt) | 0, i = (i = i + Math.imul(b, nt) | 0) + Math.imul(_, rt) | 0, a = a + Math.imul(_, nt) | 0, n = n + Math.imul(v, at) | 0, i = (i = i + Math.imul(v, ot) | 0) + Math.imul(y, at) | 0, a = a + Math.imul(y, ot) | 0, n = n + Math.imul(d, lt) | 0, i = (i = i + Math.imul(d, ct) | 0) + Math.imul(m, lt) | 0, a = a + Math.imul(m, ct) | 0;
          var kt = (c + (n = n + Math.imul(f, ft) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(f, ht) | 0) + Math.imul(h, ft) | 0)) << 13) | 0;
          c = ((a = a + Math.imul(h, ht) | 0) + (i >>> 13) | 0) + (kt >>> 26) | 0, kt &= 67108863, n = Math.imul(B, U), i = (i = Math.imul(B, V)) + Math.imul(N, U) | 0, a = Math.imul(N, V), n = n + Math.imul(D, H) | 0, i = (i = i + Math.imul(D, G) | 0) + Math.imul(R, H) | 0, a = a + Math.imul(R, G) | 0, n = n + Math.imul(I, W) | 0, i = (i = i + Math.imul(I, X) | 0) + Math.imul(O, W) | 0, a = a + Math.imul(O, X) | 0, n = n + Math.imul(L, J) | 0, i = (i = i + Math.imul(L, K) | 0) + Math.imul(C, J) | 0, a = a + Math.imul(C, K) | 0, n = n + Math.imul(A, $) | 0, i = (i = i + Math.imul(A, tt) | 0) + Math.imul(S, $) | 0, a = a + Math.imul(S, tt) | 0, n = n + Math.imul(T, rt) | 0, i = (i = i + Math.imul(T, nt) | 0) + Math.imul(k, rt) | 0, a = a + Math.imul(k, nt) | 0, n = n + Math.imul(b, at) | 0, i = (i = i + Math.imul(b, ot) | 0) + Math.imul(_, at) | 0, a = a + Math.imul(_, ot) | 0, n = n + Math.imul(v, lt) | 0, i = (i = i + Math.imul(v, ct) | 0) + Math.imul(y, lt) | 0, a = a + Math.imul(y, ct) | 0, n = n + Math.imul(d, ft) | 0, i = (i = i + Math.imul(d, ht) | 0) + Math.imul(m, ft) | 0, a = a + Math.imul(m, ht) | 0;
          var Mt = (c + (n = n + Math.imul(f, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(f, mt) | 0) + Math.imul(h, dt) | 0)) << 13) | 0;
          c = ((a = a + Math.imul(h, mt) | 0) + (i >>> 13) | 0) + (Mt >>> 26) | 0, Mt &= 67108863, n = Math.imul(B, H), i = (i = Math.imul(B, G)) + Math.imul(N, H) | 0, a = Math.imul(N, G), n = n + Math.imul(D, W) | 0, i = (i = i + Math.imul(D, X) | 0) + Math.imul(R, W) | 0, a = a + Math.imul(R, X) | 0, n = n + Math.imul(I, J) | 0, i = (i = i + Math.imul(I, K) | 0) + Math.imul(O, J) | 0, a = a + Math.imul(O, K) | 0, n = n + Math.imul(L, $) | 0, i = (i = i + Math.imul(L, tt) | 0) + Math.imul(C, $) | 0, a = a + Math.imul(C, tt) | 0, n = n + Math.imul(A, rt) | 0, i = (i = i + Math.imul(A, nt) | 0) + Math.imul(S, rt) | 0, a = a + Math.imul(S, nt) | 0, n = n + Math.imul(T, at) | 0, i = (i = i + Math.imul(T, ot) | 0) + Math.imul(k, at) | 0, a = a + Math.imul(k, ot) | 0, n = n + Math.imul(b, lt) | 0, i = (i = i + Math.imul(b, ct) | 0) + Math.imul(_, lt) | 0, a = a + Math.imul(_, ct) | 0, n = n + Math.imul(v, ft) | 0, i = (i = i + Math.imul(v, ht) | 0) + Math.imul(y, ft) | 0, a = a + Math.imul(y, ht) | 0;
          var At = (c + (n = n + Math.imul(d, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, mt) | 0) + Math.imul(m, dt) | 0)) << 13) | 0;
          c = ((a = a + Math.imul(m, mt) | 0) + (i >>> 13) | 0) + (At >>> 26) | 0, At &= 67108863, n = Math.imul(B, W), i = (i = Math.imul(B, X)) + Math.imul(N, W) | 0, a = Math.imul(N, X), n = n + Math.imul(D, J) | 0, i = (i = i + Math.imul(D, K) | 0) + Math.imul(R, J) | 0, a = a + Math.imul(R, K) | 0, n = n + Math.imul(I, $) | 0, i = (i = i + Math.imul(I, tt) | 0) + Math.imul(O, $) | 0, a = a + Math.imul(O, tt) | 0, n = n + Math.imul(L, rt) | 0, i = (i = i + Math.imul(L, nt) | 0) + Math.imul(C, rt) | 0, a = a + Math.imul(C, nt) | 0, n = n + Math.imul(A, at) | 0, i = (i = i + Math.imul(A, ot) | 0) + Math.imul(S, at) | 0, a = a + Math.imul(S, ot) | 0, n = n + Math.imul(T, lt) | 0, i = (i = i + Math.imul(T, ct) | 0) + Math.imul(k, lt) | 0, a = a + Math.imul(k, ct) | 0, n = n + Math.imul(b, ft) | 0, i = (i = i + Math.imul(b, ht) | 0) + Math.imul(_, ft) | 0, a = a + Math.imul(_, ht) | 0;
          var St = (c + (n = n + Math.imul(v, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(v, mt) | 0) + Math.imul(y, dt) | 0)) << 13) | 0;
          c = ((a = a + Math.imul(y, mt) | 0) + (i >>> 13) | 0) + (St >>> 26) | 0, St &= 67108863, n = Math.imul(B, J), i = (i = Math.imul(B, K)) + Math.imul(N, J) | 0, a = Math.imul(N, K), n = n + Math.imul(D, $) | 0, i = (i = i + Math.imul(D, tt) | 0) + Math.imul(R, $) | 0, a = a + Math.imul(R, tt) | 0, n = n + Math.imul(I, rt) | 0, i = (i = i + Math.imul(I, nt) | 0) + Math.imul(O, rt) | 0, a = a + Math.imul(O, nt) | 0, n = n + Math.imul(L, at) | 0, i = (i = i + Math.imul(L, ot) | 0) + Math.imul(C, at) | 0, a = a + Math.imul(C, ot) | 0, n = n + Math.imul(A, lt) | 0, i = (i = i + Math.imul(A, ct) | 0) + Math.imul(S, lt) | 0, a = a + Math.imul(S, ct) | 0, n = n + Math.imul(T, ft) | 0, i = (i = i + Math.imul(T, ht) | 0) + Math.imul(k, ft) | 0, a = a + Math.imul(k, ht) | 0;
          var Et = (c + (n = n + Math.imul(b, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(b, mt) | 0) + Math.imul(_, dt) | 0)) << 13) | 0;
          c = ((a = a + Math.imul(_, mt) | 0) + (i >>> 13) | 0) + (Et >>> 26) | 0, Et &= 67108863, n = Math.imul(B, $), i = (i = Math.imul(B, tt)) + Math.imul(N, $) | 0, a = Math.imul(N, tt), n = n + Math.imul(D, rt) | 0, i = (i = i + Math.imul(D, nt) | 0) + Math.imul(R, rt) | 0, a = a + Math.imul(R, nt) | 0, n = n + Math.imul(I, at) | 0, i = (i = i + Math.imul(I, ot) | 0) + Math.imul(O, at) | 0, a = a + Math.imul(O, ot) | 0, n = n + Math.imul(L, lt) | 0, i = (i = i + Math.imul(L, ct) | 0) + Math.imul(C, lt) | 0, a = a + Math.imul(C, ct) | 0, n = n + Math.imul(A, ft) | 0, i = (i = i + Math.imul(A, ht) | 0) + Math.imul(S, ft) | 0, a = a + Math.imul(S, ht) | 0;
          var Lt = (c + (n = n + Math.imul(T, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(T, mt) | 0) + Math.imul(k, dt) | 0)) << 13) | 0;
          c = ((a = a + Math.imul(k, mt) | 0) + (i >>> 13) | 0) + (Lt >>> 26) | 0, Lt &= 67108863, n = Math.imul(B, rt), i = (i = Math.imul(B, nt)) + Math.imul(N, rt) | 0, a = Math.imul(N, nt), n = n + Math.imul(D, at) | 0, i = (i = i + Math.imul(D, ot) | 0) + Math.imul(R, at) | 0, a = a + Math.imul(R, ot) | 0, n = n + Math.imul(I, lt) | 0, i = (i = i + Math.imul(I, ct) | 0) + Math.imul(O, lt) | 0, a = a + Math.imul(O, ct) | 0, n = n + Math.imul(L, ft) | 0, i = (i = i + Math.imul(L, ht) | 0) + Math.imul(C, ft) | 0, a = a + Math.imul(C, ht) | 0;
          var Ct = (c + (n = n + Math.imul(A, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(A, mt) | 0) + Math.imul(S, dt) | 0)) << 13) | 0;
          c = ((a = a + Math.imul(S, mt) | 0) + (i >>> 13) | 0) + (Ct >>> 26) | 0, Ct &= 67108863, n = Math.imul(B, at), i = (i = Math.imul(B, ot)) + Math.imul(N, at) | 0, a = Math.imul(N, ot), n = n + Math.imul(D, lt) | 0, i = (i = i + Math.imul(D, ct) | 0) + Math.imul(R, lt) | 0, a = a + Math.imul(R, ct) | 0, n = n + Math.imul(I, ft) | 0, i = (i = i + Math.imul(I, ht) | 0) + Math.imul(O, ft) | 0, a = a + Math.imul(O, ht) | 0;
          var Pt = (c + (n = n + Math.imul(L, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(L, mt) | 0) + Math.imul(C, dt) | 0)) << 13) | 0;
          c = ((a = a + Math.imul(C, mt) | 0) + (i >>> 13) | 0) + (Pt >>> 26) | 0, Pt &= 67108863, n = Math.imul(B, lt), i = (i = Math.imul(B, ct)) + Math.imul(N, lt) | 0, a = Math.imul(N, ct), n = n + Math.imul(D, ft) | 0, i = (i = i + Math.imul(D, ht) | 0) + Math.imul(R, ft) | 0, a = a + Math.imul(R, ht) | 0;
          var It = (c + (n = n + Math.imul(I, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(I, mt) | 0) + Math.imul(O, dt) | 0)) << 13) | 0;
          c = ((a = a + Math.imul(O, mt) | 0) + (i >>> 13) | 0) + (It >>> 26) | 0, It &= 67108863, n = Math.imul(B, ft), i = (i = Math.imul(B, ht)) + Math.imul(N, ft) | 0, a = Math.imul(N, ht);
          var Ot = (c + (n = n + Math.imul(D, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(D, mt) | 0) + Math.imul(R, dt) | 0)) << 13) | 0;
          c = ((a = a + Math.imul(R, mt) | 0) + (i >>> 13) | 0) + (Ot >>> 26) | 0, Ot &= 67108863;
          var zt = (c + (n = Math.imul(B, dt)) | 0) + ((8191 & (i = (i = Math.imul(B, mt)) + Math.imul(N, dt) | 0)) << 13) | 0;
          return c = ((a = Math.imul(N, mt)) + (i >>> 13) | 0) + (zt >>> 26) | 0, zt &= 67108863, l[0] = gt, l[1] = vt, l[2] = yt, l[3] = xt, l[4] = bt, l[5] = _t, l[6] = wt, l[7] = Tt, l[8] = kt, l[9] = Mt, l[10] = At, l[11] = St, l[12] = Et, l[13] = Lt, l[14] = Ct, l[15] = Pt, l[16] = It, l[17] = Ot, l[18] = zt, 0 !== c && (l[19] = c, r.length++), r;
        };

        function d(t, e, r) {
          return new m().mulp(t, e, r);
        }

        function m(t, e) {
          this.x = t, this.y = e;
        }

        Math.imul || (p = h), a.prototype.mulTo = function (t, e) {
          var r = this.length + t.length;
          return 10 === this.length && 10 === t.length ? p(this, t, e) : r < 63 ? h(this, t, e) : r < 1024 ? function (t, e, r) {
            r.negative = e.negative ^ t.negative, r.length = t.length + e.length;

            for (var n = 0, i = 0, a = 0; a < r.length - 1; a++) {
              var o = i;
              i = 0;

              for (var s = 67108863 & n, l = Math.min(a, e.length - 1), c = Math.max(0, a - t.length + 1); c <= l; c++) {
                var u = a - c,
                    f = (0 | t.words[u]) * (0 | e.words[c]),
                    h = 67108863 & f;
                s = 67108863 & (h = h + s | 0), i += (o = (o = o + (f / 67108864 | 0) | 0) + (h >>> 26) | 0) >>> 26, o &= 67108863;
              }

              r.words[a] = s, n = o, o = i;
            }

            return 0 !== n ? r.words[a] = n : r.length--, r.strip();
          }(this, t, e) : d(this, t, e);
        }, m.prototype.makeRBT = function (t) {
          for (var e = new Array(t), r = a.prototype._countBits(t) - 1, n = 0; n < t; n++) {
            e[n] = this.revBin(n, r, t);
          }

          return e;
        }, m.prototype.revBin = function (t, e, r) {
          if (0 === t || t === r - 1) return t;

          for (var n = 0, i = 0; i < e; i++) {
            n |= (1 & t) << e - i - 1, t >>= 1;
          }

          return n;
        }, m.prototype.permute = function (t, e, r, n, i, a) {
          for (var o = 0; o < a; o++) {
            n[o] = e[t[o]], i[o] = r[t[o]];
          }
        }, m.prototype.transform = function (t, e, r, n, i, a) {
          this.permute(a, t, e, r, n, i);

          for (var o = 1; o < i; o <<= 1) {
            for (var s = o << 1, l = Math.cos(2 * Math.PI / s), c = Math.sin(2 * Math.PI / s), u = 0; u < i; u += s) {
              for (var f = l, h = c, p = 0; p < o; p++) {
                var d = r[u + p],
                    m = n[u + p],
                    g = r[u + p + o],
                    v = n[u + p + o],
                    y = f * g - h * v;
                v = f * v + h * g, g = y, r[u + p] = d + g, n[u + p] = m + v, r[u + p + o] = d - g, n[u + p + o] = m - v, p !== s && (y = l * f - c * h, h = l * h + c * f, f = y);
              }
            }
          }
        }, m.prototype.guessLen13b = function (t, e) {
          var r = 1 | Math.max(e, t),
              n = 1 & r,
              i = 0;

          for (r = r / 2 | 0; r; r >>>= 1) {
            i++;
          }

          return 1 << i + 1 + n;
        }, m.prototype.conjugate = function (t, e, r) {
          if (!(r <= 1)) for (var n = 0; n < r / 2; n++) {
            var i = t[n];
            t[n] = t[r - n - 1], t[r - n - 1] = i, i = e[n], e[n] = -e[r - n - 1], e[r - n - 1] = -i;
          }
        }, m.prototype.normalize13b = function (t, e) {
          for (var r = 0, n = 0; n < e / 2; n++) {
            var i = 8192 * Math.round(t[2 * n + 1] / e) + Math.round(t[2 * n] / e) + r;
            t[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
          }

          return t;
        }, m.prototype.convert13b = function (t, e, r, i) {
          for (var a = 0, o = 0; o < e; o++) {
            a += 0 | t[o], r[2 * o] = 8191 & a, a >>>= 13, r[2 * o + 1] = 8191 & a, a >>>= 13;
          }

          for (o = 2 * e; o < i; ++o) {
            r[o] = 0;
          }

          n(0 === a), n(0 == (-8192 & a));
        }, m.prototype.stub = function (t) {
          for (var e = new Array(t), r = 0; r < t; r++) {
            e[r] = 0;
          }

          return e;
        }, m.prototype.mulp = function (t, e, r) {
          var n = 2 * this.guessLen13b(t.length, e.length),
              i = this.makeRBT(n),
              a = this.stub(n),
              o = new Array(n),
              s = new Array(n),
              l = new Array(n),
              c = new Array(n),
              u = new Array(n),
              f = new Array(n),
              h = r.words;
          h.length = n, this.convert13b(t.words, t.length, o, n), this.convert13b(e.words, e.length, c, n), this.transform(o, a, s, l, n, i), this.transform(c, a, u, f, n, i);

          for (var p = 0; p < n; p++) {
            var d = s[p] * u[p] - l[p] * f[p];
            l[p] = s[p] * f[p] + l[p] * u[p], s[p] = d;
          }

          return this.conjugate(s, l, n), this.transform(s, l, h, a, n, i), this.conjugate(h, a, n), this.normalize13b(h, n), r.negative = t.negative ^ e.negative, r.length = t.length + e.length, r.strip();
        }, a.prototype.mul = function (t) {
          var e = new a(null);
          return e.words = new Array(this.length + t.length), this.mulTo(t, e);
        }, a.prototype.mulf = function (t) {
          var e = new a(null);
          return e.words = new Array(this.length + t.length), d(this, t, e);
        }, a.prototype.imul = function (t) {
          return this.clone().mulTo(t, this);
        }, a.prototype.imuln = function (t) {
          n("number" == typeof t), n(t < 67108864);

          for (var e = 0, r = 0; r < this.length; r++) {
            var i = (0 | this.words[r]) * t,
                a = (67108863 & i) + (67108863 & e);
            e >>= 26, e += i / 67108864 | 0, e += a >>> 26, this.words[r] = 67108863 & a;
          }

          return 0 !== e && (this.words[r] = e, this.length++), this;
        }, a.prototype.muln = function (t) {
          return this.clone().imuln(t);
        }, a.prototype.sqr = function () {
          return this.mul(this);
        }, a.prototype.isqr = function () {
          return this.imul(this.clone());
        }, a.prototype.pow = function (t) {
          var e = function (t) {
            for (var e = new Array(t.bitLength()), r = 0; r < e.length; r++) {
              var n = r / 26 | 0,
                  i = r % 26;
              e[r] = (t.words[n] & 1 << i) >>> i;
            }

            return e;
          }(t);

          if (0 === e.length) return new a(1);

          for (var r = this, n = 0; n < e.length && 0 === e[n]; n++, r = r.sqr()) {
            ;
          }

          if (++n < e.length) for (var i = r.sqr(); n < e.length; n++, i = i.sqr()) {
            0 !== e[n] && (r = r.mul(i));
          }
          return r;
        }, a.prototype.iushln = function (t) {
          n("number" == typeof t && t >= 0);
          var e,
              r = t % 26,
              i = (t - r) / 26,
              a = 67108863 >>> 26 - r << 26 - r;

          if (0 !== r) {
            var o = 0;

            for (e = 0; e < this.length; e++) {
              var s = this.words[e] & a,
                  l = (0 | this.words[e]) - s << r;
              this.words[e] = l | o, o = s >>> 26 - r;
            }

            o && (this.words[e] = o, this.length++);
          }

          if (0 !== i) {
            for (e = this.length - 1; e >= 0; e--) {
              this.words[e + i] = this.words[e];
            }

            for (e = 0; e < i; e++) {
              this.words[e] = 0;
            }

            this.length += i;
          }

          return this.strip();
        }, a.prototype.ishln = function (t) {
          return n(0 === this.negative), this.iushln(t);
        }, a.prototype.iushrn = function (t, e, r) {
          var i;
          n("number" == typeof t && t >= 0), i = e ? (e - e % 26) / 26 : 0;
          var a = t % 26,
              o = Math.min((t - a) / 26, this.length),
              s = 67108863 ^ 67108863 >>> a << a,
              l = r;

          if (i -= o, i = Math.max(0, i), l) {
            for (var c = 0; c < o; c++) {
              l.words[c] = this.words[c];
            }

            l.length = o;
          }

          if (0 === o) ;else if (this.length > o) for (this.length -= o, c = 0; c < this.length; c++) {
            this.words[c] = this.words[c + o];
          } else this.words[0] = 0, this.length = 1;
          var u = 0;

          for (c = this.length - 1; c >= 0 && (0 !== u || c >= i); c--) {
            var f = 0 | this.words[c];
            this.words[c] = u << 26 - a | f >>> a, u = f & s;
          }

          return l && 0 !== u && (l.words[l.length++] = u), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
        }, a.prototype.ishrn = function (t, e, r) {
          return n(0 === this.negative), this.iushrn(t, e, r);
        }, a.prototype.shln = function (t) {
          return this.clone().ishln(t);
        }, a.prototype.ushln = function (t) {
          return this.clone().iushln(t);
        }, a.prototype.shrn = function (t) {
          return this.clone().ishrn(t);
        }, a.prototype.ushrn = function (t) {
          return this.clone().iushrn(t);
        }, a.prototype.testn = function (t) {
          n("number" == typeof t && t >= 0);
          var e = t % 26,
              r = (t - e) / 26,
              i = 1 << e;
          return !(this.length <= r) && !!(this.words[r] & i);
        }, a.prototype.imaskn = function (t) {
          n("number" == typeof t && t >= 0);
          var e = t % 26,
              r = (t - e) / 26;
          if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;

          if (0 !== e && r++, this.length = Math.min(r, this.length), 0 !== e) {
            var i = 67108863 ^ 67108863 >>> e << e;
            this.words[this.length - 1] &= i;
          }

          return this.strip();
        }, a.prototype.maskn = function (t) {
          return this.clone().imaskn(t);
        }, a.prototype.iaddn = function (t) {
          return n("number" == typeof t), n(t < 67108864), t < 0 ? this.isubn(-t) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < t ? (this.words[0] = t - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(t), this.negative = 1, this) : this._iaddn(t);
        }, a.prototype._iaddn = function (t) {
          this.words[0] += t;

          for (var e = 0; e < this.length && this.words[e] >= 67108864; e++) {
            this.words[e] -= 67108864, e === this.length - 1 ? this.words[e + 1] = 1 : this.words[e + 1]++;
          }

          return this.length = Math.max(this.length, e + 1), this;
        }, a.prototype.isubn = function (t) {
          if (n("number" == typeof t), n(t < 67108864), t < 0) return this.iaddn(-t);
          if (0 !== this.negative) return this.negative = 0, this.iaddn(t), this.negative = 1, this;
          if (this.words[0] -= t, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var e = 0; e < this.length && this.words[e] < 0; e++) {
            this.words[e] += 67108864, this.words[e + 1] -= 1;
          }
          return this.strip();
        }, a.prototype.addn = function (t) {
          return this.clone().iaddn(t);
        }, a.prototype.subn = function (t) {
          return this.clone().isubn(t);
        }, a.prototype.iabs = function () {
          return this.negative = 0, this;
        }, a.prototype.abs = function () {
          return this.clone().iabs();
        }, a.prototype._ishlnsubmul = function (t, e, r) {
          var i,
              a,
              o = t.length + r;

          this._expand(o);

          var s = 0;

          for (i = 0; i < t.length; i++) {
            a = (0 | this.words[i + r]) + s;
            var l = (0 | t.words[i]) * e;
            s = ((a -= 67108863 & l) >> 26) - (l / 67108864 | 0), this.words[i + r] = 67108863 & a;
          }

          for (; i < this.length - r; i++) {
            s = (a = (0 | this.words[i + r]) + s) >> 26, this.words[i + r] = 67108863 & a;
          }

          if (0 === s) return this.strip();

          for (n(-1 === s), s = 0, i = 0; i < this.length; i++) {
            s = (a = -(0 | this.words[i]) + s) >> 26, this.words[i] = 67108863 & a;
          }

          return this.negative = 1, this.strip();
        }, a.prototype._wordDiv = function (t, e) {
          var r = (this.length, t.length),
              n = this.clone(),
              i = t,
              o = 0 | i.words[i.length - 1];
          0 !== (r = 26 - this._countBits(o)) && (i = i.ushln(r), n.iushln(r), o = 0 | i.words[i.length - 1]);
          var s,
              l = n.length - i.length;

          if ("mod" !== e) {
            (s = new a(null)).length = l + 1, s.words = new Array(s.length);

            for (var c = 0; c < s.length; c++) {
              s.words[c] = 0;
            }
          }

          var u = n.clone()._ishlnsubmul(i, 1, l);

          0 === u.negative && (n = u, s && (s.words[l] = 1));

          for (var f = l - 1; f >= 0; f--) {
            var h = 67108864 * (0 | n.words[i.length + f]) + (0 | n.words[i.length + f - 1]);

            for (h = Math.min(h / o | 0, 67108863), n._ishlnsubmul(i, h, f); 0 !== n.negative;) {
              h--, n.negative = 0, n._ishlnsubmul(i, 1, f), n.isZero() || (n.negative ^= 1);
            }

            s && (s.words[f] = h);
          }

          return s && s.strip(), n.strip(), "div" !== e && 0 !== r && n.iushrn(r), {
            div: s || null,
            mod: n
          };
        }, a.prototype.divmod = function (t, e, r) {
          return n(!t.isZero()), this.isZero() ? {
            div: new a(0),
            mod: new a(0)
          } : 0 !== this.negative && 0 === t.negative ? (s = this.neg().divmod(t, e), "mod" !== e && (i = s.div.neg()), "div" !== e && (o = s.mod.neg(), r && 0 !== o.negative && o.iadd(t)), {
            div: i,
            mod: o
          }) : 0 === this.negative && 0 !== t.negative ? (s = this.divmod(t.neg(), e), "mod" !== e && (i = s.div.neg()), {
            div: i,
            mod: s.mod
          }) : 0 != (this.negative & t.negative) ? (s = this.neg().divmod(t.neg(), e), "div" !== e && (o = s.mod.neg(), r && 0 !== o.negative && o.isub(t)), {
            div: s.div,
            mod: o
          }) : t.length > this.length || this.cmp(t) < 0 ? {
            div: new a(0),
            mod: this
          } : 1 === t.length ? "div" === e ? {
            div: this.divn(t.words[0]),
            mod: null
          } : "mod" === e ? {
            div: null,
            mod: new a(this.modn(t.words[0]))
          } : {
            div: this.divn(t.words[0]),
            mod: new a(this.modn(t.words[0]))
          } : this._wordDiv(t, e);
          var i, o, s;
        }, a.prototype.div = function (t) {
          return this.divmod(t, "div", !1).div;
        }, a.prototype.mod = function (t) {
          return this.divmod(t, "mod", !1).mod;
        }, a.prototype.umod = function (t) {
          return this.divmod(t, "mod", !0).mod;
        }, a.prototype.divRound = function (t) {
          var e = this.divmod(t);
          if (e.mod.isZero()) return e.div;
          var r = 0 !== e.div.negative ? e.mod.isub(t) : e.mod,
              n = t.ushrn(1),
              i = t.andln(1),
              a = r.cmp(n);
          return a < 0 || 1 === i && 0 === a ? e.div : 0 !== e.div.negative ? e.div.isubn(1) : e.div.iaddn(1);
        }, a.prototype.modn = function (t) {
          n(t <= 67108863);

          for (var e = (1 << 26) % t, r = 0, i = this.length - 1; i >= 0; i--) {
            r = (e * r + (0 | this.words[i])) % t;
          }

          return r;
        }, a.prototype.idivn = function (t) {
          n(t <= 67108863);

          for (var e = 0, r = this.length - 1; r >= 0; r--) {
            var i = (0 | this.words[r]) + 67108864 * e;
            this.words[r] = i / t | 0, e = i % t;
          }

          return this.strip();
        }, a.prototype.divn = function (t) {
          return this.clone().idivn(t);
        }, a.prototype.egcd = function (t) {
          n(0 === t.negative), n(!t.isZero());
          var e = this,
              r = t.clone();
          e = 0 !== e.negative ? e.umod(t) : e.clone();

          for (var i = new a(1), o = new a(0), s = new a(0), l = new a(1), c = 0; e.isEven() && r.isEven();) {
            e.iushrn(1), r.iushrn(1), ++c;
          }

          for (var u = r.clone(), f = e.clone(); !e.isZero();) {
            for (var h = 0, p = 1; 0 == (e.words[0] & p) && h < 26; ++h, p <<= 1) {
              ;
            }

            if (h > 0) for (e.iushrn(h); h-- > 0;) {
              (i.isOdd() || o.isOdd()) && (i.iadd(u), o.isub(f)), i.iushrn(1), o.iushrn(1);
            }

            for (var d = 0, m = 1; 0 == (r.words[0] & m) && d < 26; ++d, m <<= 1) {
              ;
            }

            if (d > 0) for (r.iushrn(d); d-- > 0;) {
              (s.isOdd() || l.isOdd()) && (s.iadd(u), l.isub(f)), s.iushrn(1), l.iushrn(1);
            }
            e.cmp(r) >= 0 ? (e.isub(r), i.isub(s), o.isub(l)) : (r.isub(e), s.isub(i), l.isub(o));
          }

          return {
            a: s,
            b: l,
            gcd: r.iushln(c)
          };
        }, a.prototype._invmp = function (t) {
          n(0 === t.negative), n(!t.isZero());
          var e = this,
              r = t.clone();
          e = 0 !== e.negative ? e.umod(t) : e.clone();

          for (var i, o = new a(1), s = new a(0), l = r.clone(); e.cmpn(1) > 0 && r.cmpn(1) > 0;) {
            for (var c = 0, u = 1; 0 == (e.words[0] & u) && c < 26; ++c, u <<= 1) {
              ;
            }

            if (c > 0) for (e.iushrn(c); c-- > 0;) {
              o.isOdd() && o.iadd(l), o.iushrn(1);
            }

            for (var f = 0, h = 1; 0 == (r.words[0] & h) && f < 26; ++f, h <<= 1) {
              ;
            }

            if (f > 0) for (r.iushrn(f); f-- > 0;) {
              s.isOdd() && s.iadd(l), s.iushrn(1);
            }
            e.cmp(r) >= 0 ? (e.isub(r), o.isub(s)) : (r.isub(e), s.isub(o));
          }

          return (i = 0 === e.cmpn(1) ? o : s).cmpn(0) < 0 && i.iadd(t), i;
        }, a.prototype.gcd = function (t) {
          if (this.isZero()) return t.abs();
          if (t.isZero()) return this.abs();
          var e = this.clone(),
              r = t.clone();
          e.negative = 0, r.negative = 0;

          for (var n = 0; e.isEven() && r.isEven(); n++) {
            e.iushrn(1), r.iushrn(1);
          }

          for (;;) {
            for (; e.isEven();) {
              e.iushrn(1);
            }

            for (; r.isEven();) {
              r.iushrn(1);
            }

            var i = e.cmp(r);

            if (i < 0) {
              var a = e;
              e = r, r = a;
            } else if (0 === i || 0 === r.cmpn(1)) break;

            e.isub(r);
          }

          return r.iushln(n);
        }, a.prototype.invm = function (t) {
          return this.egcd(t).a.umod(t);
        }, a.prototype.isEven = function () {
          return 0 == (1 & this.words[0]);
        }, a.prototype.isOdd = function () {
          return 1 == (1 & this.words[0]);
        }, a.prototype.andln = function (t) {
          return this.words[0] & t;
        }, a.prototype.bincn = function (t) {
          n("number" == typeof t);
          var e = t % 26,
              r = (t - e) / 26,
              i = 1 << e;
          if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;

          for (var a = i, o = r; 0 !== a && o < this.length; o++) {
            var s = 0 | this.words[o];
            a = (s += a) >>> 26, s &= 67108863, this.words[o] = s;
          }

          return 0 !== a && (this.words[o] = a, this.length++), this;
        }, a.prototype.isZero = function () {
          return 1 === this.length && 0 === this.words[0];
        }, a.prototype.cmpn = function (t) {
          var e,
              r = t < 0;
          if (0 !== this.negative && !r) return -1;
          if (0 === this.negative && r) return 1;
          if (this.strip(), this.length > 1) e = 1;else {
            r && (t = -t), n(t <= 67108863, "Number is too big");
            var i = 0 | this.words[0];
            e = i === t ? 0 : i < t ? -1 : 1;
          }
          return 0 !== this.negative ? 0 | -e : e;
        }, a.prototype.cmp = function (t) {
          if (0 !== this.negative && 0 === t.negative) return -1;
          if (0 === this.negative && 0 !== t.negative) return 1;
          var e = this.ucmp(t);
          return 0 !== this.negative ? 0 | -e : e;
        }, a.prototype.ucmp = function (t) {
          if (this.length > t.length) return 1;
          if (this.length < t.length) return -1;

          for (var e = 0, r = this.length - 1; r >= 0; r--) {
            var n = 0 | this.words[r],
                i = 0 | t.words[r];

            if (n !== i) {
              n < i ? e = -1 : n > i && (e = 1);
              break;
            }
          }

          return e;
        }, a.prototype.gtn = function (t) {
          return 1 === this.cmpn(t);
        }, a.prototype.gt = function (t) {
          return 1 === this.cmp(t);
        }, a.prototype.gten = function (t) {
          return this.cmpn(t) >= 0;
        }, a.prototype.gte = function (t) {
          return this.cmp(t) >= 0;
        }, a.prototype.ltn = function (t) {
          return -1 === this.cmpn(t);
        }, a.prototype.lt = function (t) {
          return -1 === this.cmp(t);
        }, a.prototype.lten = function (t) {
          return this.cmpn(t) <= 0;
        }, a.prototype.lte = function (t) {
          return this.cmp(t) <= 0;
        }, a.prototype.eqn = function (t) {
          return 0 === this.cmpn(t);
        }, a.prototype.eq = function (t) {
          return 0 === this.cmp(t);
        }, a.red = function (t) {
          return new w(t);
        }, a.prototype.toRed = function (t) {
          return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), t.convertTo(this)._forceRed(t);
        }, a.prototype.fromRed = function () {
          return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
        }, a.prototype._forceRed = function (t) {
          return this.red = t, this;
        }, a.prototype.forceRed = function (t) {
          return n(!this.red, "Already a number in reduction context"), this._forceRed(t);
        }, a.prototype.redAdd = function (t) {
          return n(this.red, "redAdd works only with red numbers"), this.red.add(this, t);
        }, a.prototype.redIAdd = function (t) {
          return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, t);
        }, a.prototype.redSub = function (t) {
          return n(this.red, "redSub works only with red numbers"), this.red.sub(this, t);
        }, a.prototype.redISub = function (t) {
          return n(this.red, "redISub works only with red numbers"), this.red.isub(this, t);
        }, a.prototype.redShl = function (t) {
          return n(this.red, "redShl works only with red numbers"), this.red.shl(this, t);
        }, a.prototype.redMul = function (t) {
          return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.mul(this, t);
        }, a.prototype.redIMul = function (t) {
          return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.imul(this, t);
        }, a.prototype.redSqr = function () {
          return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
        }, a.prototype.redISqr = function () {
          return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
        }, a.prototype.redSqrt = function () {
          return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
        }, a.prototype.redInvm = function () {
          return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
        }, a.prototype.redNeg = function () {
          return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
        }, a.prototype.redPow = function (t) {
          return n(this.red && !t.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, t);
        };
        var g = {
          k256: null,
          p224: null,
          p192: null,
          p25519: null
        };

        function v(t, e) {
          this.name = t, this.p = new a(e, 16), this.n = this.p.bitLength(), this.k = new a(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
        }

        function y() {
          v.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
        }

        function x() {
          v.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
        }

        function b() {
          v.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
        }

        function _() {
          v.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
        }

        function w(t) {
          if ("string" == typeof t) {
            var e = a._prime(t);

            this.m = e.p, this.prime = e;
          } else n(t.gtn(1), "modulus must be greater than 1"), this.m = t, this.prime = null;
        }

        function T(t) {
          w.call(this, t), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new a(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
        }

        v.prototype._tmp = function () {
          var t = new a(null);
          return t.words = new Array(Math.ceil(this.n / 13)), t;
        }, v.prototype.ireduce = function (t) {
          var e,
              r = t;

          do {
            this.split(r, this.tmp), e = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
          } while (e > this.n);

          var n = e < this.n ? -1 : r.ucmp(this.p);
          return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : r.strip(), r;
        }, v.prototype.split = function (t, e) {
          t.iushrn(this.n, 0, e);
        }, v.prototype.imulK = function (t) {
          return t.imul(this.k);
        }, i(y, v), y.prototype.split = function (t, e) {
          for (var r = Math.min(t.length, 9), n = 0; n < r; n++) {
            e.words[n] = t.words[n];
          }

          if (e.length = r, t.length <= 9) return t.words[0] = 0, void (t.length = 1);
          var i = t.words[9];

          for (e.words[e.length++] = 4194303 & i, n = 10; n < t.length; n++) {
            var a = 0 | t.words[n];
            t.words[n - 10] = (4194303 & a) << 4 | i >>> 22, i = a;
          }

          i >>>= 22, t.words[n - 10] = i, 0 === i && t.length > 10 ? t.length -= 10 : t.length -= 9;
        }, y.prototype.imulK = function (t) {
          t.words[t.length] = 0, t.words[t.length + 1] = 0, t.length += 2;

          for (var e = 0, r = 0; r < t.length; r++) {
            var n = 0 | t.words[r];
            e += 977 * n, t.words[r] = 67108863 & e, e = 64 * n + (e / 67108864 | 0);
          }

          return 0 === t.words[t.length - 1] && (t.length--, 0 === t.words[t.length - 1] && t.length--), t;
        }, i(x, v), i(b, v), i(_, v), _.prototype.imulK = function (t) {
          for (var e = 0, r = 0; r < t.length; r++) {
            var n = 19 * (0 | t.words[r]) + e,
                i = 67108863 & n;
            n >>>= 26, t.words[r] = i, e = n;
          }

          return 0 !== e && (t.words[t.length++] = e), t;
        }, a._prime = function (t) {
          if (g[t]) return g[t];
          var e;
          if ("k256" === t) e = new y();else if ("p224" === t) e = new x();else if ("p192" === t) e = new b();else {
            if ("p25519" !== t) throw new Error("Unknown prime " + t);
            e = new _();
          }
          return g[t] = e, e;
        }, w.prototype._verify1 = function (t) {
          n(0 === t.negative, "red works only with positives"), n(t.red, "red works only with red numbers");
        }, w.prototype._verify2 = function (t, e) {
          n(0 == (t.negative | e.negative), "red works only with positives"), n(t.red && t.red === e.red, "red works only with red numbers");
        }, w.prototype.imod = function (t) {
          return this.prime ? this.prime.ireduce(t)._forceRed(this) : t.umod(this.m)._forceRed(this);
        }, w.prototype.neg = function (t) {
          return t.isZero() ? t.clone() : this.m.sub(t)._forceRed(this);
        }, w.prototype.add = function (t, e) {
          this._verify2(t, e);

          var r = t.add(e);
          return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
        }, w.prototype.iadd = function (t, e) {
          this._verify2(t, e);

          var r = t.iadd(e);
          return r.cmp(this.m) >= 0 && r.isub(this.m), r;
        }, w.prototype.sub = function (t, e) {
          this._verify2(t, e);

          var r = t.sub(e);
          return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
        }, w.prototype.isub = function (t, e) {
          this._verify2(t, e);

          var r = t.isub(e);
          return r.cmpn(0) < 0 && r.iadd(this.m), r;
        }, w.prototype.shl = function (t, e) {
          return this._verify1(t), this.imod(t.ushln(e));
        }, w.prototype.imul = function (t, e) {
          return this._verify2(t, e), this.imod(t.imul(e));
        }, w.prototype.mul = function (t, e) {
          return this._verify2(t, e), this.imod(t.mul(e));
        }, w.prototype.isqr = function (t) {
          return this.imul(t, t.clone());
        }, w.prototype.sqr = function (t) {
          return this.mul(t, t);
        }, w.prototype.sqrt = function (t) {
          if (t.isZero()) return t.clone();
          var e = this.m.andln(3);

          if (n(e % 2 == 1), 3 === e) {
            var r = this.m.add(new a(1)).iushrn(2);
            return this.pow(t, r);
          }

          for (var i = this.m.subn(1), o = 0; !i.isZero() && 0 === i.andln(1);) {
            o++, i.iushrn(1);
          }

          n(!i.isZero());
          var s = new a(1).toRed(this),
              l = s.redNeg(),
              c = this.m.subn(1).iushrn(1),
              u = this.m.bitLength();

          for (u = new a(2 * u * u).toRed(this); 0 !== this.pow(u, c).cmp(l);) {
            u.redIAdd(l);
          }

          for (var f = this.pow(u, i), h = this.pow(t, i.addn(1).iushrn(1)), p = this.pow(t, i), d = o; 0 !== p.cmp(s);) {
            for (var m = p, g = 0; 0 !== m.cmp(s); g++) {
              m = m.redSqr();
            }

            n(g < d);
            var v = this.pow(f, new a(1).iushln(d - g - 1));
            h = h.redMul(v), f = v.redSqr(), p = p.redMul(f), d = g;
          }

          return h;
        }, w.prototype.invm = function (t) {
          var e = t._invmp(this.m);

          return 0 !== e.negative ? (e.negative = 0, this.imod(e).redNeg()) : this.imod(e);
        }, w.prototype.pow = function (t, e) {
          if (e.isZero()) return new a(1).toRed(this);
          if (0 === e.cmpn(1)) return t.clone();
          var r = new Array(16);
          r[0] = new a(1).toRed(this), r[1] = t;

          for (var n = 2; n < r.length; n++) {
            r[n] = this.mul(r[n - 1], t);
          }

          var i = r[0],
              o = 0,
              s = 0,
              l = e.bitLength() % 26;

          for (0 === l && (l = 26), n = e.length - 1; n >= 0; n--) {
            for (var c = e.words[n], u = l - 1; u >= 0; u--) {
              var f = c >> u & 1;
              i !== r[0] && (i = this.sqr(i)), 0 !== f || 0 !== o ? (o <<= 1, o |= f, (4 === ++s || 0 === n && 0 === u) && (i = this.mul(i, r[o]), s = 0, o = 0)) : s = 0;
            }

            l = 26;
          }

          return i;
        }, w.prototype.convertTo = function (t) {
          var e = t.umod(this.m);
          return e === t ? e.clone() : e;
        }, w.prototype.convertFrom = function (t) {
          var e = t.clone();
          return e.red = null, e;
        }, a.mont = function (t) {
          return new T(t);
        }, i(T, w), T.prototype.convertTo = function (t) {
          return this.imod(t.ushln(this.shift));
        }, T.prototype.convertFrom = function (t) {
          var e = this.imod(t.mul(this.rinv));
          return e.red = null, e;
        }, T.prototype.imul = function (t, e) {
          if (t.isZero() || e.isZero()) return t.words[0] = 0, t.length = 1, t;
          var r = t.imul(e),
              n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
              i = r.isub(n).iushrn(this.shift),
              a = i;
          return i.cmp(this.m) >= 0 ? a = i.isub(this.m) : i.cmpn(0) < 0 && (a = i.iadd(this.m)), a._forceRed(this);
        }, T.prototype.mul = function (t, e) {
          if (t.isZero() || e.isZero()) return new a(0)._forceRed(this);
          var r = t.mul(e),
              n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
              i = r.isub(n).iushrn(this.shift),
              o = i;
          return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
        }, T.prototype.invm = function (t) {
          return this.imod(t._invmp(this.m).mul(this.r2))._forceRed(this);
        };
      }(void 0 === e || e, this);
    }, {
      buffer: 110
    }],
    102: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        var e,
            r,
            n,
            i = t.length,
            a = 0;

        for (e = 0; e < i; ++e) {
          a += t[e].length;
        }

        var o = new Array(a),
            s = 0;

        for (e = 0; e < i; ++e) {
          var l = t[e],
              c = l.length;

          for (r = 0; r < c; ++r) {
            var u = o[s++] = new Array(c - 1),
                f = 0;

            for (n = 0; n < c; ++n) {
              n !== r && (u[f++] = l[n]);
            }

            if (1 & r) {
              var h = u[1];
              u[1] = u[0], u[0] = h;
            }
          }
        }

        return o;
      };
    }, {}],
    103: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r) {
        switch (arguments.length) {
          case 1:
            return f(t);

          case 2:
            return "function" == typeof e ? c(t, t, e, !0) : h(t, e);

          case 3:
            return c(t, e, r, !1);

          default:
            throw new Error("box-intersect: Invalid arguments");
        }
      };

      var n,
          i = t("typedarray-pool"),
          a = t("./lib/sweep"),
          o = t("./lib/intersect");

      function s(t, e) {
        for (var r = 0; r < t; ++r) {
          if (!(e[r] <= e[r + t])) return !0;
        }

        return !1;
      }

      function l(t, e, r, n) {
        for (var i = 0, a = 0, o = 0, l = t.length; o < l; ++o) {
          var c = t[o];

          if (!s(e, c)) {
            for (var u = 0; u < 2 * e; ++u) {
              r[i++] = c[u];
            }

            n[a++] = o;
          }
        }

        return a;
      }

      function c(t, e, r, n) {
        var s = t.length,
            c = e.length;

        if (!(s <= 0 || c <= 0)) {
          var u = t[0].length >>> 1;

          if (!(u <= 0)) {
            var f,
                h = i.mallocDouble(2 * u * s),
                p = i.mallocInt32(s);

            if ((s = l(t, u, h, p)) > 0) {
              if (1 === u && n) a.init(s), f = a.sweepComplete(u, r, 0, s, h, p, 0, s, h, p);else {
                var d = i.mallocDouble(2 * u * c),
                    m = i.mallocInt32(c);
                (c = l(e, u, d, m)) > 0 && (a.init(s + c), f = 1 === u ? a.sweepBipartite(u, r, 0, s, h, p, 0, c, d, m) : o(u, r, n, s, h, p, c, d, m), i.free(d), i.free(m));
              }
              i.free(h), i.free(p);
            }

            return f;
          }
        }
      }

      function u(t, e) {
        n.push([t, e]);
      }

      function f(t) {
        return n = [], c(t, t, u, !0), n;
      }

      function h(t, e) {
        return n = [], c(t, e, u, !1), n;
      }
    }, {
      "./lib/intersect": 105,
      "./lib/sweep": 109,
      "typedarray-pool": 609
    }],
    104: [function (t, e, r) {
      "use strict";

      var n = ["d", "ax", "vv", "rs", "re", "rb", "ri", "bs", "be", "bb", "bi"];

      function i(t) {
        var e = "bruteForce" + (t ? "Full" : "Partial"),
            r = [],
            i = n.slice();
        t || i.splice(3, 0, "fp");
        var a = ["function " + e + "(" + i.join() + "){"];

        function o(e, i) {
          var o = function (t, e, r) {
            var i = "bruteForce" + (t ? "Red" : "Blue") + (e ? "Flip" : "") + (r ? "Full" : ""),
                a = ["function ", i, "(", n.join(), "){", "var ", "es", "=2*", "d", ";"],
                o = "for(var i=rs,rp=es*rs;i<re;++i,rp+=es){var x0=rb[ax+rp],x1=rb[ax+rp+d],xi=ri[i];",
                s = "for(var j=bs,bp=es*bs;j<be;++j,bp+=es){var y0=bb[ax+bp]," + (r ? "y1=bb[ax+bp+d]," : "") + "yi=bi[j];";
            return t ? a.push(o, "Q", ":", s) : a.push(s, "Q", ":", o), r ? a.push("if(y1<x0||x1<y0)continue;") : e ? a.push("if(y0<=x0||x1<y0)continue;") : a.push("if(y0<x0||x1<y0)continue;"), a.push("for(var k=ax+1;k<d;++k){var r0=rb[k+rp],r1=rb[k+d+rp],b0=bb[k+bp],b1=bb[k+d+bp];if(r1<b0||b1<r0)continue Q;}var rv=vv("), e ? a.push("yi,xi") : a.push("xi,yi"), a.push(");if(rv!==void 0)return rv;}}}"), {
              name: i,
              code: a.join("")
            };
          }(e, i, t);

          r.push(o.code), a.push("return " + o.name + "(" + n.join() + ");");
        }

        a.push("if(re-rs>be-bs){"), t ? (o(!0, !1), a.push("}else{"), o(!1, !1)) : (a.push("if(fp){"), o(!0, !0), a.push("}else{"), o(!0, !1), a.push("}}else{if(fp){"), o(!1, !0), a.push("}else{"), o(!1, !1), a.push("}")), a.push("}}return " + e);
        var s = r.join("") + a.join("");
        return new Function(s)();
      }

      r.partial = i(!1), r.full = i(!0);
    }, {}],
    105: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, a, u, w, T, k, M) {
        !function (t, e) {
          var r = 8 * i.log2(e + 1) * (t + 1) | 0,
              a = i.nextPow2(6 * r);
          v.length < a && (n.free(v), v = n.mallocInt32(a));
          var o = i.nextPow2(2 * r);
          y.length < o && (n.free(y), y = n.mallocDouble(o));
        }(t, a + T);
        var A,
            S = 0,
            E = 2 * t;
        x(S++, 0, 0, a, 0, T, r ? 16 : 0, -1 / 0, 1 / 0), r || x(S++, 0, 0, T, 0, a, 1, -1 / 0, 1 / 0);

        for (; S > 0;) {
          var L = 6 * (S -= 1),
              C = v[L],
              P = v[L + 1],
              I = v[L + 2],
              O = v[L + 3],
              z = v[L + 4],
              D = v[L + 5],
              R = 2 * S,
              F = y[R],
              B = y[R + 1],
              N = 1 & D,
              j = !!(16 & D),
              U = u,
              V = w,
              q = k,
              H = M;

          if (N && (U = k, V = M, q = u, H = w), !(2 & D && (I = p(t, C, P, I, U, V, B), P >= I) || 4 & D && (P = d(t, C, P, I, U, V, F)) >= I)) {
            var G = I - P,
                Y = z - O;

            if (j) {
              if (t * G * (G + Y) < 1 << 22) {
                if (void 0 !== (A = l.scanComplete(t, C, e, P, I, U, V, O, z, q, H))) return A;
                continue;
              }
            } else {
              if (t * Math.min(G, Y) < 128) {
                if (void 0 !== (A = o(t, C, e, N, P, I, U, V, O, z, q, H))) return A;
                continue;
              }

              if (t * G * Y < 1 << 22) {
                if (void 0 !== (A = l.scanBipartite(t, C, e, N, P, I, U, V, O, z, q, H))) return A;
                continue;
              }
            }

            var W = f(t, C, P, I, U, V, F, B);
            if (P < W) if (t * (W - P) < 128) {
              if (void 0 !== (A = s(t, C + 1, e, P, W, U, V, O, z, q, H))) return A;
            } else if (C === t - 2) {
              if (void 0 !== (A = N ? l.sweepBipartite(t, e, O, z, q, H, P, W, U, V) : l.sweepBipartite(t, e, P, W, U, V, O, z, q, H))) return A;
            } else x(S++, C + 1, P, W, O, z, N, -1 / 0, 1 / 0), x(S++, C + 1, O, z, P, W, 1 ^ N, -1 / 0, 1 / 0);

            if (W < I) {
              var X = c(t, C, O, z, q, H),
                  Z = q[E * X + C],
                  J = h(t, C, X, z, q, H, Z);

              if (J < z && x(S++, C, W, I, J, z, (4 | N) + (j ? 16 : 0), Z, B), O < X && x(S++, C, W, I, O, X, (2 | N) + (j ? 16 : 0), F, Z), X + 1 === J) {
                if (void 0 !== (A = j ? _(t, C, e, W, I, U, V, X, q, H[X]) : b(t, C, e, N, W, I, U, V, X, q, H[X]))) return A;
              } else if (X < J) {
                var K;

                if (j) {
                  if (K = m(t, C, W, I, U, V, Z), W < K) {
                    var Q = h(t, C, W, K, U, V, Z);

                    if (C === t - 2) {
                      if (W < Q && void 0 !== (A = l.sweepComplete(t, e, W, Q, U, V, X, J, q, H))) return A;
                      if (Q < K && void 0 !== (A = l.sweepBipartite(t, e, Q, K, U, V, X, J, q, H))) return A;
                    } else W < Q && x(S++, C + 1, W, Q, X, J, 16, -1 / 0, 1 / 0), Q < K && (x(S++, C + 1, Q, K, X, J, 0, -1 / 0, 1 / 0), x(S++, C + 1, X, J, Q, K, 1, -1 / 0, 1 / 0));
                  }
                } else K = N ? g(t, C, W, I, U, V, Z) : m(t, C, W, I, U, V, Z), W < K && (C === t - 2 ? A = N ? l.sweepBipartite(t, e, X, J, q, H, W, K, U, V) : l.sweepBipartite(t, e, W, K, U, V, X, J, q, H) : (x(S++, C + 1, W, K, X, J, N, -1 / 0, 1 / 0), x(S++, C + 1, X, J, W, K, 1 ^ N, -1 / 0, 1 / 0)));
              }
            }
          }
        }
      };

      var n = t("typedarray-pool"),
          i = t("bit-twiddle"),
          a = t("./brute"),
          o = a.partial,
          s = a.full,
          l = t("./sweep"),
          c = t("./median"),
          u = t("./partition"),
          f = u("!(lo>=p0)&&!(p1>=hi)", ["p0", "p1"]),
          h = u("lo===p0", ["p0"]),
          p = u("lo<p0", ["p0"]),
          d = u("hi<=p0", ["p0"]),
          m = u("lo<=p0&&p0<=hi", ["p0"]),
          g = u("lo<p0&&p0<=hi", ["p0"]),
          v = n.mallocInt32(1024),
          y = n.mallocDouble(1024);

      function x(t, e, r, n, i, a, o, s, l) {
        var c = 6 * t;
        v[c] = e, v[c + 1] = r, v[c + 2] = n, v[c + 3] = i, v[c + 4] = a, v[c + 5] = o;
        var u = 2 * t;
        y[u] = s, y[u + 1] = l;
      }

      function b(t, e, r, n, i, a, o, s, l, c, u) {
        var f = 2 * t,
            h = l * f,
            p = c[h + e];

        t: for (var d = i, m = i * f; d < a; ++d, m += f) {
          var g = o[m + e],
              v = o[m + e + t];

          if (!(p < g || v < p) && (!n || p !== g)) {
            for (var y, x = s[d], b = e + 1; b < t; ++b) {
              g = o[m + b], v = o[m + b + t];
              var _ = c[h + b],
                  w = c[h + b + t];
              if (v < _ || w < g) continue t;
            }

            if (void 0 !== (y = n ? r(u, x) : r(x, u))) return y;
          }
        }
      }

      function _(t, e, r, n, i, a, o, s, l, c) {
        var u = 2 * t,
            f = s * u,
            h = l[f + e];

        t: for (var p = n, d = n * u; p < i; ++p, d += u) {
          var m = o[p];

          if (m !== c) {
            var g = a[d + e],
                v = a[d + e + t];

            if (!(h < g || v < h)) {
              for (var y = e + 1; y < t; ++y) {
                g = a[d + y], v = a[d + y + t];
                var x = l[f + y],
                    b = l[f + y + t];
                if (v < x || b < g) continue t;
              }

              var _ = r(m, c);

              if (void 0 !== _) return _;
            }
          }
        }
      }
    }, {
      "./brute": 104,
      "./median": 106,
      "./partition": 107,
      "./sweep": 109,
      "bit-twiddle": 99,
      "typedarray-pool": 609
    }],
    106: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, a, o, s) {
        if (a <= r + 1) return r;
        var l = r,
            c = a,
            u = a + r >>> 1,
            f = 2 * t,
            h = u,
            p = o[f * u + e];

        for (; l < c;) {
          if (c - l < 8) {
            i(t, e, l, c, o, s), p = o[f * u + e];
            break;
          }

          var d = c - l,
              m = Math.random() * d + l | 0,
              g = o[f * m + e],
              v = Math.random() * d + l | 0,
              y = o[f * v + e],
              x = Math.random() * d + l | 0,
              b = o[f * x + e];
          g <= y ? b >= y ? (h = v, p = y) : g >= b ? (h = m, p = g) : (h = x, p = b) : y >= b ? (h = v, p = y) : b >= g ? (h = m, p = g) : (h = x, p = b);

          for (var _ = f * (c - 1), w = f * h, T = 0; T < f; ++T, ++_, ++w) {
            var k = o[_];
            o[_] = o[w], o[w] = k;
          }

          var M = s[c - 1];
          s[c - 1] = s[h], s[h] = M, h = n(t, e, l, c - 1, o, s, p);

          for (_ = f * (c - 1), w = f * h, T = 0; T < f; ++T, ++_, ++w) {
            k = o[_];
            o[_] = o[w], o[w] = k;
          }

          M = s[c - 1];

          if (s[c - 1] = s[h], s[h] = M, u < h) {
            for (c = h - 1; l < c && o[f * (c - 1) + e] === p;) {
              c -= 1;
            }

            c += 1;
          } else {
            if (!(h < u)) break;

            for (l = h + 1; l < c && o[f * l + e] === p;) {
              l += 1;
            }
          }
        }

        return n(t, e, r, u, o, s, o[f * u + e]);
      };

      var n = t("./partition")("lo<p0", ["p0"]);

      function i(t, e, r, n, i, a) {
        for (var o = 2 * t, s = o * (r + 1) + e, l = r + 1; l < n; ++l, s += o) {
          for (var c = i[s], u = l, f = o * (l - 1); u > r && i[f + e] > c; --u, f -= o) {
            for (var h = f, p = f + o, d = 0; d < o; ++d, ++h, ++p) {
              var m = i[h];
              i[h] = i[p], i[p] = m;
            }

            var g = a[u];
            a[u] = a[u - 1], a[u - 1] = g;
          }
        }
      }
    }, {
      "./partition": 107
    }],
    107: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        var r = "abcdef".split("").concat(e),
            n = [];
        t.indexOf("lo") >= 0 && n.push("lo=e[k+n]");
        t.indexOf("hi") >= 0 && n.push("hi=e[k+o]");
        return r.push("for(var j=2*a,k=j*c,l=k,m=c,n=b,o=a+b,p=c;d>p;++p,k+=j){var _;if($)if(m===p)m+=1,l+=j;else{for(var s=0;j>s;++s){var t=e[k+s];e[k+s]=e[l],e[l++]=t}var u=f[p];f[p]=f[m],f[m++]=u}}return m".replace("_", n.join()).replace("$", t)), Function.apply(void 0, r);
      };
    }, {}],
    108: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        e <= 128 ? n(0, e - 1, t) : function t(e, r, u) {
          var f = (r - e + 1) / 6 | 0,
              h = e + f,
              p = r - f,
              d = e + r >> 1,
              m = d - f,
              g = d + f,
              v = h,
              y = m,
              x = d,
              b = g,
              _ = p,
              w = e + 1,
              T = r - 1,
              k = 0;
          l(v, y, u) && (k = v, v = y, y = k);
          l(b, _, u) && (k = b, b = _, _ = k);
          l(v, x, u) && (k = v, v = x, x = k);
          l(y, x, u) && (k = y, y = x, x = k);
          l(v, b, u) && (k = v, v = b, b = k);
          l(x, b, u) && (k = x, x = b, b = k);
          l(y, _, u) && (k = y, y = _, _ = k);
          l(y, x, u) && (k = y, y = x, x = k);
          l(b, _, u) && (k = b, b = _, _ = k);

          for (var M = u[2 * y], A = u[2 * y + 1], S = u[2 * b], E = u[2 * b + 1], L = 2 * v, C = 2 * x, P = 2 * _, I = 2 * h, O = 2 * d, z = 2 * p, D = 0; D < 2; ++D) {
            var R = u[L + D],
                F = u[C + D],
                B = u[P + D];
            u[I + D] = R, u[O + D] = F, u[z + D] = B;
          }

          a(m, e, u), a(g, r, u);

          for (var N = w; N <= T; ++N) {
            if (c(N, M, A, u)) N !== w && i(N, w, u), ++w;else if (!c(N, S, E, u)) for (;;) {
              if (c(T, S, E, u)) {
                c(T, M, A, u) ? (o(N, w, T, u), ++w, --T) : (i(N, T, u), --T);
                break;
              }

              if (--T < N) break;
            }
          }

          s(e, w - 1, M, A, u), s(r, T + 1, S, E, u), w - 2 - e <= 32 ? n(e, w - 2, u) : t(e, w - 2, u);
          r - (T + 2) <= 32 ? n(T + 2, r, u) : t(T + 2, r, u);
          T - w <= 32 ? n(w, T, u) : t(w, T, u);
        }(0, e - 1, t);
      };

      function n(t, e, r) {
        for (var n = 2 * (t + 1), i = t + 1; i <= e; ++i) {
          for (var a = r[n++], o = r[n++], s = i, l = n - 2; s-- > t;) {
            var c = r[l - 2],
                u = r[l - 1];
            if (c < a) break;
            if (c === a && u < o) break;
            r[l] = c, r[l + 1] = u, l -= 2;
          }

          r[l] = a, r[l + 1] = o;
        }
      }

      function i(t, e, r) {
        e *= 2;
        var n = r[t *= 2],
            i = r[t + 1];
        r[t] = r[e], r[t + 1] = r[e + 1], r[e] = n, r[e + 1] = i;
      }

      function a(t, e, r) {
        e *= 2, r[t *= 2] = r[e], r[t + 1] = r[e + 1];
      }

      function o(t, e, r, n) {
        e *= 2, r *= 2;
        var i = n[t *= 2],
            a = n[t + 1];
        n[t] = n[e], n[t + 1] = n[e + 1], n[e] = n[r], n[e + 1] = n[r + 1], n[r] = i, n[r + 1] = a;
      }

      function s(t, e, r, n, i) {
        e *= 2, i[t *= 2] = i[e], i[e] = r, i[t + 1] = i[e + 1], i[e + 1] = n;
      }

      function l(t, e, r) {
        e *= 2;
        var n = r[t *= 2],
            i = r[e];
        return !(n < i) && (n !== i || r[t + 1] > r[e + 1]);
      }

      function c(t, e, r, n) {
        var i = n[t *= 2];
        return i < e || i === e && n[t + 1] < r;
      }
    }, {}],
    109: [function (t, e, r) {
      "use strict";

      e.exports = {
        init: function init(t) {
          var e = i.nextPow2(t);
          o.length < e && (n.free(o), o = n.mallocInt32(e));
          s.length < e && (n.free(s), s = n.mallocInt32(e));
          l.length < e && (n.free(l), l = n.mallocInt32(e));
          c.length < e && (n.free(c), c = n.mallocInt32(e));
          u.length < e && (n.free(u), u = n.mallocInt32(e));
          f.length < e && (n.free(f), f = n.mallocInt32(e));
          var r = 8 * e;
          h.length < r && (n.free(h), h = n.mallocDouble(r));
        },
        sweepBipartite: function sweepBipartite(t, e, r, n, i, u, f, m, g, v) {
          for (var y = 0, x = 2 * t, b = t - 1, _ = x - 1, w = r; w < n; ++w) {
            var T = u[w],
                k = x * w;
            h[y++] = i[k + b], h[y++] = -(T + 1), h[y++] = i[k + _], h[y++] = T;
          }

          for (w = f; w < m; ++w) {
            T = v[w] + (1 << 28);
            var M = x * w;
            h[y++] = g[M + b], h[y++] = -T, h[y++] = g[M + _], h[y++] = T;
          }

          var A = y >>> 1;
          a(h, A);
          var S = 0,
              E = 0;

          for (w = 0; w < A; ++w) {
            var L = 0 | h[2 * w + 1];
            if (L >= 1 << 28) p(l, c, E--, L = L - (1 << 28) | 0);else if (L >= 0) p(o, s, S--, L);else if (L <= -(1 << 28)) {
              L = -L - (1 << 28) | 0;

              for (var C = 0; C < S; ++C) {
                if (void 0 !== (P = e(o[C], L))) return P;
              }

              d(l, c, E++, L);
            } else {
              L = -L - 1 | 0;

              for (C = 0; C < E; ++C) {
                var P;
                if (void 0 !== (P = e(L, l[C]))) return P;
              }

              d(o, s, S++, L);
            }
          }
        },
        sweepComplete: function sweepComplete(t, e, r, n, i, m, g, v, y, x) {
          for (var b = 0, _ = 2 * t, w = t - 1, T = _ - 1, k = r; k < n; ++k) {
            var M = m[k] + 1 << 1,
                A = _ * k;
            h[b++] = i[A + w], h[b++] = -M, h[b++] = i[A + T], h[b++] = M;
          }

          for (k = g; k < v; ++k) {
            M = x[k] + 1 << 1;
            var S = _ * k;
            h[b++] = y[S + w], h[b++] = 1 | -M, h[b++] = y[S + T], h[b++] = 1 | M;
          }

          var E = b >>> 1;
          a(h, E);
          var L = 0,
              C = 0,
              P = 0;

          for (k = 0; k < E; ++k) {
            var I = 0 | h[2 * k + 1],
                O = 1 & I;

            if (k < E - 1 && I >> 1 == h[2 * k + 3] >> 1 && (O = 2, k += 1), I < 0) {
              for (var z = -(I >> 1) - 1, D = 0; D < P; ++D) {
                if (void 0 !== (R = e(u[D], z))) return R;
              }

              if (0 !== O) for (D = 0; D < L; ++D) {
                if (void 0 !== (R = e(o[D], z))) return R;
              }
              if (1 !== O) for (D = 0; D < C; ++D) {
                var R;
                if (void 0 !== (R = e(l[D], z))) return R;
              }
              0 === O ? d(o, s, L++, z) : 1 === O ? d(l, c, C++, z) : 2 === O && d(u, f, P++, z);
            } else {
              z = (I >> 1) - 1;
              0 === O ? p(o, s, L--, z) : 1 === O ? p(l, c, C--, z) : 2 === O && p(u, f, P--, z);
            }
          }
        },
        scanBipartite: function scanBipartite(t, e, r, n, i, l, c, u, f, m, g, v) {
          var y = 0,
              x = 2 * t,
              b = e,
              _ = e + t,
              w = 1,
              T = 1;

          n ? T = 1 << 28 : w = 1 << 28;

          for (var k = i; k < l; ++k) {
            var M = k + w,
                A = x * k;
            h[y++] = c[A + b], h[y++] = -M, h[y++] = c[A + _], h[y++] = M;
          }

          for (k = f; k < m; ++k) {
            M = k + T;
            var S = x * k;
            h[y++] = g[S + b], h[y++] = -M;
          }

          var E = y >>> 1;
          a(h, E);
          var L = 0;

          for (k = 0; k < E; ++k) {
            var C = 0 | h[2 * k + 1];

            if (C < 0) {
              var P = !1;
              if ((M = -C) >= 1 << 28 ? (P = !n, M -= 1 << 28) : (P = !!n, M -= 1), P) d(o, s, L++, M);else {
                var I = v[M],
                    O = x * M,
                    z = g[O + e + 1],
                    D = g[O + e + 1 + t];

                t: for (var R = 0; R < L; ++R) {
                  var F = o[R],
                      B = x * F;

                  if (!(D < c[B + e + 1] || c[B + e + 1 + t] < z)) {
                    for (var N = e + 2; N < t; ++N) {
                      if (g[O + N + t] < c[B + N] || c[B + N + t] < g[O + N]) continue t;
                    }

                    var j,
                        U = u[F];
                    if (void 0 !== (j = n ? r(I, U) : r(U, I))) return j;
                  }
                }
              }
            } else p(o, s, L--, C - w);
          }
        },
        scanComplete: function scanComplete(t, e, r, n, i, s, l, c, u, f, p) {
          for (var d = 0, m = 2 * t, g = e, v = e + t, y = n; y < i; ++y) {
            var x = y + (1 << 28),
                b = m * y;
            h[d++] = s[b + g], h[d++] = -x, h[d++] = s[b + v], h[d++] = x;
          }

          for (y = c; y < u; ++y) {
            x = y + 1;

            var _ = m * y;

            h[d++] = f[_ + g], h[d++] = -x;
          }

          var w = d >>> 1;
          a(h, w);
          var T = 0;

          for (y = 0; y < w; ++y) {
            var k = 0 | h[2 * y + 1];

            if (k < 0) {
              if ((x = -k) >= 1 << 28) o[T++] = x - (1 << 28);else {
                var M = p[x -= 1],
                    A = m * x,
                    S = f[A + e + 1],
                    E = f[A + e + 1 + t];

                t: for (var L = 0; L < T; ++L) {
                  var C = o[L],
                      P = l[C];
                  if (P === M) break;
                  var I = m * C;

                  if (!(E < s[I + e + 1] || s[I + e + 1 + t] < S)) {
                    for (var O = e + 2; O < t; ++O) {
                      if (f[A + O + t] < s[I + O] || s[I + O + t] < f[A + O]) continue t;
                    }

                    var z = r(P, M);
                    if (void 0 !== z) return z;
                  }
                }
              }
            } else {
              for (x = k - (1 << 28), L = T - 1; L >= 0; --L) {
                if (o[L] === x) {
                  for (O = L + 1; O < T; ++O) {
                    o[O - 1] = o[O];
                  }

                  break;
                }
              }

              --T;
            }
          }
        }
      };
      var n = t("typedarray-pool"),
          i = t("bit-twiddle"),
          a = t("./sort"),
          o = n.mallocInt32(1024),
          s = n.mallocInt32(1024),
          l = n.mallocInt32(1024),
          c = n.mallocInt32(1024),
          u = n.mallocInt32(1024),
          f = n.mallocInt32(1024),
          h = n.mallocDouble(8192);

      function p(t, e, r, n) {
        var i = e[n],
            a = t[r - 1];
        t[i] = a, e[a] = i;
      }

      function d(t, e, r, n) {
        t[r] = n, e[n] = r;
      }
    }, {
      "./sort": 108,
      "bit-twiddle": 99,
      "typedarray-pool": 609
    }],
    110: [function (t, e, r) {}, {}],
    111: [function (t, e, r) {
      "use strict";

      var n,
          i = "object" == (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) ? Reflect : null,
          a = i && "function" == typeof i.apply ? i.apply : function (t, e, r) {
        return Function.prototype.apply.call(t, e, r);
      };
      n = i && "function" == typeof i.ownKeys ? i.ownKeys : Object.getOwnPropertySymbols ? function (t) {
        return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
      } : function (t) {
        return Object.getOwnPropertyNames(t);
      };

      var o = Number.isNaN || function (t) {
        return t != t;
      };

      function s() {
        s.init.call(this);
      }

      e.exports = s, e.exports.once = function (t, e) {
        return new Promise(function (r, n) {
          function i() {
            void 0 !== a && t.removeListener("error", a), r([].slice.call(arguments));
          }

          var a;
          "error" !== e && (a = function a(r) {
            t.removeListener(e, i), n(r);
          }, t.once("error", a)), t.once(e, i);
        });
      }, s.EventEmitter = s, s.prototype._events = void 0, s.prototype._eventsCount = 0, s.prototype._maxListeners = void 0;
      var l = 10;

      function c(t) {
        if ("function" != typeof t) throw new TypeError('The "listener" argument must be of type Function. Received type ' + _typeof(t));
      }

      function u(t) {
        return void 0 === t._maxListeners ? s.defaultMaxListeners : t._maxListeners;
      }

      function f(t, e, r, n) {
        var i, a, o, s;
        if (c(r), void 0 === (a = t._events) ? (a = t._events = Object.create(null), t._eventsCount = 0) : (void 0 !== a.newListener && (t.emit("newListener", e, r.listener ? r.listener : r), a = t._events), o = a[e]), void 0 === o) o = a[e] = r, ++t._eventsCount;else if ("function" == typeof o ? o = a[e] = n ? [r, o] : [o, r] : n ? o.unshift(r) : o.push(r), (i = u(t)) > 0 && o.length > i && !o.warned) {
          o.warned = !0;
          var l = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
          l.name = "MaxListenersExceededWarning", l.emitter = t, l.type = e, l.count = o.length, s = l, console && console.warn && console.warn(s);
        }
        return t;
      }

      function h() {
        if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
      }

      function p(t, e, r) {
        var n = {
          fired: !1,
          wrapFn: void 0,
          target: t,
          type: e,
          listener: r
        },
            i = h.bind(n);
        return i.listener = r, n.wrapFn = i, i;
      }

      function d(t, e, r) {
        var n = t._events;
        if (void 0 === n) return [];
        var i = n[e];
        return void 0 === i ? [] : "function" == typeof i ? r ? [i.listener || i] : [i] : r ? function (t) {
          for (var e = new Array(t.length), r = 0; r < e.length; ++r) {
            e[r] = t[r].listener || t[r];
          }

          return e;
        }(i) : g(i, i.length);
      }

      function m(t) {
        var e = this._events;

        if (void 0 !== e) {
          var r = e[t];
          if ("function" == typeof r) return 1;
          if (void 0 !== r) return r.length;
        }

        return 0;
      }

      function g(t, e) {
        for (var r = new Array(e), n = 0; n < e; ++n) {
          r[n] = t[n];
        }

        return r;
      }

      Object.defineProperty(s, "defaultMaxListeners", {
        enumerable: !0,
        get: function get() {
          return l;
        },
        set: function set(t) {
          if ("number" != typeof t || t < 0 || o(t)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
          l = t;
        }
      }), s.init = function () {
        void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
      }, s.prototype.setMaxListeners = function (t) {
        if ("number" != typeof t || t < 0 || o(t)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
        return this._maxListeners = t, this;
      }, s.prototype.getMaxListeners = function () {
        return u(this);
      }, s.prototype.emit = function (t) {
        for (var e = [], r = 1; r < arguments.length; r++) {
          e.push(arguments[r]);
        }

        var n = "error" === t,
            i = this._events;
        if (void 0 !== i) n = n && void 0 === i.error;else if (!n) return !1;

        if (n) {
          var o;
          if (e.length > 0 && (o = e[0]), o instanceof Error) throw o;
          var s = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
          throw s.context = o, s;
        }

        var l = i[t];
        if (void 0 === l) return !1;
        if ("function" == typeof l) a(l, this, e);else {
          var c = l.length,
              u = g(l, c);

          for (r = 0; r < c; ++r) {
            a(u[r], this, e);
          }
        }
        return !0;
      }, s.prototype.addListener = function (t, e) {
        return f(this, t, e, !1);
      }, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function (t, e) {
        return f(this, t, e, !0);
      }, s.prototype.once = function (t, e) {
        return c(e), this.on(t, p(this, t, e)), this;
      }, s.prototype.prependOnceListener = function (t, e) {
        return c(e), this.prependListener(t, p(this, t, e)), this;
      }, s.prototype.removeListener = function (t, e) {
        var r, n, i, a, o;
        if (c(e), void 0 === (n = this._events)) return this;
        if (void 0 === (r = n[t])) return this;
        if (r === e || r.listener === e) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete n[t], n.removeListener && this.emit("removeListener", t, r.listener || e));else if ("function" != typeof r) {
          for (i = -1, a = r.length - 1; a >= 0; a--) {
            if (r[a] === e || r[a].listener === e) {
              o = r[a].listener, i = a;
              break;
            }
          }

          if (i < 0) return this;
          0 === i ? r.shift() : function (t, e) {
            for (; e + 1 < t.length; e++) {
              t[e] = t[e + 1];
            }

            t.pop();
          }(r, i), 1 === r.length && (n[t] = r[0]), void 0 !== n.removeListener && this.emit("removeListener", t, o || e);
        }
        return this;
      }, s.prototype.off = s.prototype.removeListener, s.prototype.removeAllListeners = function (t) {
        var e, r, n;
        if (void 0 === (r = this._events)) return this;
        if (void 0 === r.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== r[t] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete r[t]), this;

        if (0 === arguments.length) {
          var i,
              a = Object.keys(r);

          for (n = 0; n < a.length; ++n) {
            "removeListener" !== (i = a[n]) && this.removeAllListeners(i);
          }

          return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
        }

        if ("function" == typeof (e = r[t])) this.removeListener(t, e);else if (void 0 !== e) for (n = e.length - 1; n >= 0; n--) {
          this.removeListener(t, e[n]);
        }
        return this;
      }, s.prototype.listeners = function (t) {
        return d(this, t, !0);
      }, s.prototype.rawListeners = function (t) {
        return d(this, t, !1);
      }, s.listenerCount = function (t, e) {
        return "function" == typeof t.listenerCount ? t.listenerCount(e) : m.call(t, e);
      }, s.prototype.listenerCount = m, s.prototype.eventNames = function () {
        return this._eventsCount > 0 ? n(this._events) : [];
      };
    }, {}],
    112: [function (t, e, r) {
      (function (e) {
        (function () {
          /*!
           * The buffer module from node.js, for the browser.
           *
           * @author   Feross Aboukhadijeh <https://feross.org>
           * @license  MIT
           */
          "use strict";

          var e = t("base64-js"),
              n = t("ieee754");
          r.Buffer = a, r.SlowBuffer = function (t) {
            +t != t && (t = 0);
            return a.alloc(+t);
          }, r.INSPECT_MAX_BYTES = 50;

          function i(t) {
            if (t > 2147483647) throw new RangeError('The value "' + t + '" is invalid for option "size"');
            var e = new Uint8Array(t);
            return e.__proto__ = a.prototype, e;
          }

          function a(t, e, r) {
            if ("number" == typeof t) {
              if ("string" == typeof e) throw new TypeError('The "string" argument must be of type string. Received type number');
              return l(t);
            }

            return o(t, e, r);
          }

          function o(t, e, r) {
            if ("string" == typeof t) return function (t, e) {
              "string" == typeof e && "" !== e || (e = "utf8");
              if (!a.isEncoding(e)) throw new TypeError("Unknown encoding: " + e);
              var r = 0 | f(t, e),
                  n = i(r),
                  o = n.write(t, e);
              o !== r && (n = n.slice(0, o));
              return n;
            }(t, e);
            if (ArrayBuffer.isView(t)) return c(t);
            if (null == t) throw TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + _typeof(t));
            if (B(t, ArrayBuffer) || t && B(t.buffer, ArrayBuffer)) return function (t, e, r) {
              if (e < 0 || t.byteLength < e) throw new RangeError('"offset" is outside of buffer bounds');
              if (t.byteLength < e + (r || 0)) throw new RangeError('"length" is outside of buffer bounds');
              var n;
              n = void 0 === e && void 0 === r ? new Uint8Array(t) : void 0 === r ? new Uint8Array(t, e) : new Uint8Array(t, e, r);
              return n.__proto__ = a.prototype, n;
            }(t, e, r);
            if ("number" == typeof t) throw new TypeError('The "value" argument must not be of type number. Received type number');
            var n = t.valueOf && t.valueOf();
            if (null != n && n !== t) return a.from(n, e, r);

            var o = function (t) {
              if (a.isBuffer(t)) {
                var e = 0 | u(t.length),
                    r = i(e);
                return 0 === r.length || t.copy(r, 0, 0, e), r;
              }

              if (void 0 !== t.length) return "number" != typeof t.length || N(t.length) ? i(0) : c(t);
              if ("Buffer" === t.type && Array.isArray(t.data)) return c(t.data);
            }(t);

            if (o) return o;
            if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof t[Symbol.toPrimitive]) return a.from(t[Symbol.toPrimitive]("string"), e, r);
            throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + _typeof(t));
          }

          function s(t) {
            if ("number" != typeof t) throw new TypeError('"size" argument must be of type number');
            if (t < 0) throw new RangeError('The value "' + t + '" is invalid for option "size"');
          }

          function l(t) {
            return s(t), i(t < 0 ? 0 : 0 | u(t));
          }

          function c(t) {
            for (var e = t.length < 0 ? 0 : 0 | u(t.length), r = i(e), n = 0; n < e; n += 1) {
              r[n] = 255 & t[n];
            }

            return r;
          }

          function u(t) {
            if (t >= 2147483647) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + 2147483647..toString(16) + " bytes");
            return 0 | t;
          }

          function f(t, e) {
            if (a.isBuffer(t)) return t.length;
            if (ArrayBuffer.isView(t) || B(t, ArrayBuffer)) return t.byteLength;
            if ("string" != typeof t) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + _typeof(t));
            var r = t.length,
                n = arguments.length > 2 && !0 === arguments[2];
            if (!n && 0 === r) return 0;

            for (var i = !1;;) {
              switch (e) {
                case "ascii":
                case "latin1":
                case "binary":
                  return r;

                case "utf8":
                case "utf-8":
                  return D(t).length;

                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return 2 * r;

                case "hex":
                  return r >>> 1;

                case "base64":
                  return R(t).length;

                default:
                  if (i) return n ? -1 : D(t).length;
                  e = ("" + e).toLowerCase(), i = !0;
              }
            }
          }

          function h(t, e, r) {
            var n = !1;
            if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
            if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
            if ((r >>>= 0) <= (e >>>= 0)) return "";

            for (t || (t = "utf8");;) {
              switch (t) {
                case "hex":
                  return A(this, e, r);

                case "utf8":
                case "utf-8":
                  return T(this, e, r);

                case "ascii":
                  return k(this, e, r);

                case "latin1":
                case "binary":
                  return M(this, e, r);

                case "base64":
                  return w(this, e, r);

                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return S(this, e, r);

                default:
                  if (n) throw new TypeError("Unknown encoding: " + t);
                  t = (t + "").toLowerCase(), n = !0;
              }
            }
          }

          function p(t, e, r) {
            var n = t[e];
            t[e] = t[r], t[r] = n;
          }

          function d(t, e, r, n, i) {
            if (0 === t.length) return -1;

            if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), N(r = +r) && (r = i ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
              if (i) return -1;
              r = t.length - 1;
            } else if (r < 0) {
              if (!i) return -1;
              r = 0;
            }

            if ("string" == typeof e && (e = a.from(e, n)), a.isBuffer(e)) return 0 === e.length ? -1 : m(t, e, r, n, i);
            if ("number" == typeof e) return e &= 255, "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : m(t, [e], r, n, i);
            throw new TypeError("val must be string, number or Buffer");
          }

          function m(t, e, r, n, i) {
            var a,
                o = 1,
                s = t.length,
                l = e.length;

            if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
              if (t.length < 2 || e.length < 2) return -1;
              o = 2, s /= 2, l /= 2, r /= 2;
            }

            function c(t, e) {
              return 1 === o ? t[e] : t.readUInt16BE(e * o);
            }

            if (i) {
              var u = -1;

              for (a = r; a < s; a++) {
                if (c(t, a) === c(e, -1 === u ? 0 : a - u)) {
                  if (-1 === u && (u = a), a - u + 1 === l) return u * o;
                } else -1 !== u && (a -= a - u), u = -1;
              }
            } else for (r + l > s && (r = s - l), a = r; a >= 0; a--) {
              for (var f = !0, h = 0; h < l; h++) {
                if (c(t, a + h) !== c(e, h)) {
                  f = !1;
                  break;
                }
              }

              if (f) return a;
            }

            return -1;
          }

          function g(t, e, r, n) {
            r = Number(r) || 0;
            var i = t.length - r;
            n ? (n = Number(n)) > i && (n = i) : n = i;
            var a = e.length;
            n > a / 2 && (n = a / 2);

            for (var o = 0; o < n; ++o) {
              var s = parseInt(e.substr(2 * o, 2), 16);
              if (N(s)) return o;
              t[r + o] = s;
            }

            return o;
          }

          function v(t, e, r, n) {
            return F(D(e, t.length - r), t, r, n);
          }

          function y(t, e, r, n) {
            return F(function (t) {
              for (var e = [], r = 0; r < t.length; ++r) {
                e.push(255 & t.charCodeAt(r));
              }

              return e;
            }(e), t, r, n);
          }

          function x(t, e, r, n) {
            return y(t, e, r, n);
          }

          function b(t, e, r, n) {
            return F(R(e), t, r, n);
          }

          function _(t, e, r, n) {
            return F(function (t, e) {
              for (var r, n, i, a = [], o = 0; o < t.length && !((e -= 2) < 0); ++o) {
                r = t.charCodeAt(o), n = r >> 8, i = r % 256, a.push(i), a.push(n);
              }

              return a;
            }(e, t.length - r), t, r, n);
          }

          function w(t, r, n) {
            return 0 === r && n === t.length ? e.fromByteArray(t) : e.fromByteArray(t.slice(r, n));
          }

          function T(t, e, r) {
            r = Math.min(t.length, r);

            for (var n = [], i = e; i < r;) {
              var a,
                  o,
                  s,
                  l,
                  c = t[i],
                  u = null,
                  f = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
              if (i + f <= r) switch (f) {
                case 1:
                  c < 128 && (u = c);
                  break;

                case 2:
                  128 == (192 & (a = t[i + 1])) && (l = (31 & c) << 6 | 63 & a) > 127 && (u = l);
                  break;

                case 3:
                  a = t[i + 1], o = t[i + 2], 128 == (192 & a) && 128 == (192 & o) && (l = (15 & c) << 12 | (63 & a) << 6 | 63 & o) > 2047 && (l < 55296 || l > 57343) && (u = l);
                  break;

                case 4:
                  a = t[i + 1], o = t[i + 2], s = t[i + 3], 128 == (192 & a) && 128 == (192 & o) && 128 == (192 & s) && (l = (15 & c) << 18 | (63 & a) << 12 | (63 & o) << 6 | 63 & s) > 65535 && l < 1114112 && (u = l);
              }
              null === u ? (u = 65533, f = 1) : u > 65535 && (u -= 65536, n.push(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n.push(u), i += f;
            }

            return function (t) {
              var e = t.length;
              if (e <= 4096) return String.fromCharCode.apply(String, t);
              var r = "",
                  n = 0;

              for (; n < e;) {
                r += String.fromCharCode.apply(String, t.slice(n, n += 4096));
              }

              return r;
            }(n);
          }

          r.kMaxLength = 2147483647, a.TYPED_ARRAY_SUPPORT = function () {
            try {
              var t = new Uint8Array(1);
              return t.__proto__ = {
                __proto__: Uint8Array.prototype,
                foo: function foo() {
                  return 42;
                }
              }, 42 === t.foo();
            } catch (t) {
              return !1;
            }
          }(), a.TYPED_ARRAY_SUPPORT || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(a.prototype, "parent", {
            enumerable: !0,
            get: function get() {
              if (a.isBuffer(this)) return this.buffer;
            }
          }), Object.defineProperty(a.prototype, "offset", {
            enumerable: !0,
            get: function get() {
              if (a.isBuffer(this)) return this.byteOffset;
            }
          }), "undefined" != typeof Symbol && null != Symbol.species && a[Symbol.species] === a && Object.defineProperty(a, Symbol.species, {
            value: null,
            configurable: !0,
            enumerable: !1,
            writable: !1
          }), a.poolSize = 8192, a.from = function (t, e, r) {
            return o(t, e, r);
          }, a.prototype.__proto__ = Uint8Array.prototype, a.__proto__ = Uint8Array, a.alloc = function (t, e, r) {
            return function (t, e, r) {
              return s(t), t <= 0 ? i(t) : void 0 !== e ? "string" == typeof r ? i(t).fill(e, r) : i(t).fill(e) : i(t);
            }(t, e, r);
          }, a.allocUnsafe = function (t) {
            return l(t);
          }, a.allocUnsafeSlow = function (t) {
            return l(t);
          }, a.isBuffer = function (t) {
            return null != t && !0 === t._isBuffer && t !== a.prototype;
          }, a.compare = function (t, e) {
            if (B(t, Uint8Array) && (t = a.from(t, t.offset, t.byteLength)), B(e, Uint8Array) && (e = a.from(e, e.offset, e.byteLength)), !a.isBuffer(t) || !a.isBuffer(e)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
            if (t === e) return 0;

            for (var r = t.length, n = e.length, i = 0, o = Math.min(r, n); i < o; ++i) {
              if (t[i] !== e[i]) {
                r = t[i], n = e[i];
                break;
              }
            }

            return r < n ? -1 : n < r ? 1 : 0;
          }, a.isEncoding = function (t) {
            switch (String(t).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "latin1":
              case "binary":
              case "base64":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;

              default:
                return !1;
            }
          }, a.concat = function (t, e) {
            if (!Array.isArray(t)) throw new TypeError('"list" argument must be an Array of Buffers');
            if (0 === t.length) return a.alloc(0);
            var r;
            if (void 0 === e) for (e = 0, r = 0; r < t.length; ++r) {
              e += t[r].length;
            }
            var n = a.allocUnsafe(e),
                i = 0;

            for (r = 0; r < t.length; ++r) {
              var o = t[r];
              if (B(o, Uint8Array) && (o = a.from(o)), !a.isBuffer(o)) throw new TypeError('"list" argument must be an Array of Buffers');
              o.copy(n, i), i += o.length;
            }

            return n;
          }, a.byteLength = f, a.prototype._isBuffer = !0, a.prototype.swap16 = function () {
            var t = this.length;
            if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

            for (var e = 0; e < t; e += 2) {
              p(this, e, e + 1);
            }

            return this;
          }, a.prototype.swap32 = function () {
            var t = this.length;
            if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

            for (var e = 0; e < t; e += 4) {
              p(this, e, e + 3), p(this, e + 1, e + 2);
            }

            return this;
          }, a.prototype.swap64 = function () {
            var t = this.length;
            if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

            for (var e = 0; e < t; e += 8) {
              p(this, e, e + 7), p(this, e + 1, e + 6), p(this, e + 2, e + 5), p(this, e + 3, e + 4);
            }

            return this;
          }, a.prototype.toString = function () {
            var t = this.length;
            return 0 === t ? "" : 0 === arguments.length ? T(this, 0, t) : h.apply(this, arguments);
          }, a.prototype.toLocaleString = a.prototype.toString, a.prototype.equals = function (t) {
            if (!a.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
            return this === t || 0 === a.compare(this, t);
          }, a.prototype.inspect = function () {
            var t = "",
                e = r.INSPECT_MAX_BYTES;
            return t = this.toString("hex", 0, e).replace(/(.{2})/g, "$1 ").trim(), this.length > e && (t += " ... "), "<Buffer " + t + ">";
          }, a.prototype.compare = function (t, e, r, n, i) {
            if (B(t, Uint8Array) && (t = a.from(t, t.offset, t.byteLength)), !a.isBuffer(t)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + _typeof(t));
            if (void 0 === e && (e = 0), void 0 === r && (r = t ? t.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), e < 0 || r > t.length || n < 0 || i > this.length) throw new RangeError("out of range index");
            if (n >= i && e >= r) return 0;
            if (n >= i) return -1;
            if (e >= r) return 1;
            if (this === t) return 0;

            for (var o = (i >>>= 0) - (n >>>= 0), s = (r >>>= 0) - (e >>>= 0), l = Math.min(o, s), c = this.slice(n, i), u = t.slice(e, r), f = 0; f < l; ++f) {
              if (c[f] !== u[f]) {
                o = c[f], s = u[f];
                break;
              }
            }

            return o < s ? -1 : s < o ? 1 : 0;
          }, a.prototype.includes = function (t, e, r) {
            return -1 !== this.indexOf(t, e, r);
          }, a.prototype.indexOf = function (t, e, r) {
            return d(this, t, e, r, !0);
          }, a.prototype.lastIndexOf = function (t, e, r) {
            return d(this, t, e, r, !1);
          }, a.prototype.write = function (t, e, r, n) {
            if (void 0 === e) n = "utf8", r = this.length, e = 0;else if (void 0 === r && "string" == typeof e) n = e, r = this.length, e = 0;else {
              if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
              e >>>= 0, isFinite(r) ? (r >>>= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
            }
            var i = this.length - e;
            if ((void 0 === r || r > i) && (r = i), t.length > 0 && (r < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
            n || (n = "utf8");

            for (var a = !1;;) {
              switch (n) {
                case "hex":
                  return g(this, t, e, r);

                case "utf8":
                case "utf-8":
                  return v(this, t, e, r);

                case "ascii":
                  return y(this, t, e, r);

                case "latin1":
                case "binary":
                  return x(this, t, e, r);

                case "base64":
                  return b(this, t, e, r);

                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return _(this, t, e, r);

                default:
                  if (a) throw new TypeError("Unknown encoding: " + n);
                  n = ("" + n).toLowerCase(), a = !0;
              }
            }
          }, a.prototype.toJSON = function () {
            return {
              type: "Buffer",
              data: Array.prototype.slice.call(this._arr || this, 0)
            };
          };

          function k(t, e, r) {
            var n = "";
            r = Math.min(t.length, r);

            for (var i = e; i < r; ++i) {
              n += String.fromCharCode(127 & t[i]);
            }

            return n;
          }

          function M(t, e, r) {
            var n = "";
            r = Math.min(t.length, r);

            for (var i = e; i < r; ++i) {
              n += String.fromCharCode(t[i]);
            }

            return n;
          }

          function A(t, e, r) {
            var n = t.length;
            (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);

            for (var i = "", a = e; a < r; ++a) {
              i += z(t[a]);
            }

            return i;
          }

          function S(t, e, r) {
            for (var n = t.slice(e, r), i = "", a = 0; a < n.length; a += 2) {
              i += String.fromCharCode(n[a] + 256 * n[a + 1]);
            }

            return i;
          }

          function E(t, e, r) {
            if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
            if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
          }

          function L(t, e, r, n, i, o) {
            if (!a.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
            if (e > i || e < o) throw new RangeError('"value" argument is out of bounds');
            if (r + n > t.length) throw new RangeError("Index out of range");
          }

          function C(t, e, r, n, i, a) {
            if (r + n > t.length) throw new RangeError("Index out of range");
            if (r < 0) throw new RangeError("Index out of range");
          }

          function P(t, e, r, i, a) {
            return e = +e, r >>>= 0, a || C(t, 0, r, 4), n.write(t, e, r, i, 23, 4), r + 4;
          }

          function I(t, e, r, i, a) {
            return e = +e, r >>>= 0, a || C(t, 0, r, 8), n.write(t, e, r, i, 52, 8), r + 8;
          }

          a.prototype.slice = function (t, e) {
            var r = this.length;
            (t = ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), (e = void 0 === e ? r : ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), e < t && (e = t);
            var n = this.subarray(t, e);
            return n.__proto__ = a.prototype, n;
          }, a.prototype.readUIntLE = function (t, e, r) {
            t >>>= 0, e >>>= 0, r || E(t, e, this.length);

            for (var n = this[t], i = 1, a = 0; ++a < e && (i *= 256);) {
              n += this[t + a] * i;
            }

            return n;
          }, a.prototype.readUIntBE = function (t, e, r) {
            t >>>= 0, e >>>= 0, r || E(t, e, this.length);

            for (var n = this[t + --e], i = 1; e > 0 && (i *= 256);) {
              n += this[t + --e] * i;
            }

            return n;
          }, a.prototype.readUInt8 = function (t, e) {
            return t >>>= 0, e || E(t, 1, this.length), this[t];
          }, a.prototype.readUInt16LE = function (t, e) {
            return t >>>= 0, e || E(t, 2, this.length), this[t] | this[t + 1] << 8;
          }, a.prototype.readUInt16BE = function (t, e) {
            return t >>>= 0, e || E(t, 2, this.length), this[t] << 8 | this[t + 1];
          }, a.prototype.readUInt32LE = function (t, e) {
            return t >>>= 0, e || E(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
          }, a.prototype.readUInt32BE = function (t, e) {
            return t >>>= 0, e || E(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
          }, a.prototype.readIntLE = function (t, e, r) {
            t >>>= 0, e >>>= 0, r || E(t, e, this.length);

            for (var n = this[t], i = 1, a = 0; ++a < e && (i *= 256);) {
              n += this[t + a] * i;
            }

            return n >= (i *= 128) && (n -= Math.pow(2, 8 * e)), n;
          }, a.prototype.readIntBE = function (t, e, r) {
            t >>>= 0, e >>>= 0, r || E(t, e, this.length);

            for (var n = e, i = 1, a = this[t + --n]; n > 0 && (i *= 256);) {
              a += this[t + --n] * i;
            }

            return a >= (i *= 128) && (a -= Math.pow(2, 8 * e)), a;
          }, a.prototype.readInt8 = function (t, e) {
            return t >>>= 0, e || E(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
          }, a.prototype.readInt16LE = function (t, e) {
            t >>>= 0, e || E(t, 2, this.length);
            var r = this[t] | this[t + 1] << 8;
            return 32768 & r ? 4294901760 | r : r;
          }, a.prototype.readInt16BE = function (t, e) {
            t >>>= 0, e || E(t, 2, this.length);
            var r = this[t + 1] | this[t] << 8;
            return 32768 & r ? 4294901760 | r : r;
          }, a.prototype.readInt32LE = function (t, e) {
            return t >>>= 0, e || E(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
          }, a.prototype.readInt32BE = function (t, e) {
            return t >>>= 0, e || E(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
          }, a.prototype.readFloatLE = function (t, e) {
            return t >>>= 0, e || E(t, 4, this.length), n.read(this, t, !0, 23, 4);
          }, a.prototype.readFloatBE = function (t, e) {
            return t >>>= 0, e || E(t, 4, this.length), n.read(this, t, !1, 23, 4);
          }, a.prototype.readDoubleLE = function (t, e) {
            return t >>>= 0, e || E(t, 8, this.length), n.read(this, t, !0, 52, 8);
          }, a.prototype.readDoubleBE = function (t, e) {
            return t >>>= 0, e || E(t, 8, this.length), n.read(this, t, !1, 52, 8);
          }, a.prototype.writeUIntLE = function (t, e, r, n) {
            (t = +t, e >>>= 0, r >>>= 0, n) || L(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
            var i = 1,
                a = 0;

            for (this[e] = 255 & t; ++a < r && (i *= 256);) {
              this[e + a] = t / i & 255;
            }

            return e + r;
          }, a.prototype.writeUIntBE = function (t, e, r, n) {
            (t = +t, e >>>= 0, r >>>= 0, n) || L(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
            var i = r - 1,
                a = 1;

            for (this[e + i] = 255 & t; --i >= 0 && (a *= 256);) {
              this[e + i] = t / a & 255;
            }

            return e + r;
          }, a.prototype.writeUInt8 = function (t, e, r) {
            return t = +t, e >>>= 0, r || L(this, t, e, 1, 255, 0), this[e] = 255 & t, e + 1;
          }, a.prototype.writeUInt16LE = function (t, e, r) {
            return t = +t, e >>>= 0, r || L(this, t, e, 2, 65535, 0), this[e] = 255 & t, this[e + 1] = t >>> 8, e + 2;
          }, a.prototype.writeUInt16BE = function (t, e, r) {
            return t = +t, e >>>= 0, r || L(this, t, e, 2, 65535, 0), this[e] = t >>> 8, this[e + 1] = 255 & t, e + 2;
          }, a.prototype.writeUInt32LE = function (t, e, r) {
            return t = +t, e >>>= 0, r || L(this, t, e, 4, 4294967295, 0), this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t, e + 4;
          }, a.prototype.writeUInt32BE = function (t, e, r) {
            return t = +t, e >>>= 0, r || L(this, t, e, 4, 4294967295, 0), this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t, e + 4;
          }, a.prototype.writeIntLE = function (t, e, r, n) {
            if (t = +t, e >>>= 0, !n) {
              var i = Math.pow(2, 8 * r - 1);
              L(this, t, e, r, i - 1, -i);
            }

            var a = 0,
                o = 1,
                s = 0;

            for (this[e] = 255 & t; ++a < r && (o *= 256);) {
              t < 0 && 0 === s && 0 !== this[e + a - 1] && (s = 1), this[e + a] = (t / o >> 0) - s & 255;
            }

            return e + r;
          }, a.prototype.writeIntBE = function (t, e, r, n) {
            if (t = +t, e >>>= 0, !n) {
              var i = Math.pow(2, 8 * r - 1);
              L(this, t, e, r, i - 1, -i);
            }

            var a = r - 1,
                o = 1,
                s = 0;

            for (this[e + a] = 255 & t; --a >= 0 && (o *= 256);) {
              t < 0 && 0 === s && 0 !== this[e + a + 1] && (s = 1), this[e + a] = (t / o >> 0) - s & 255;
            }

            return e + r;
          }, a.prototype.writeInt8 = function (t, e, r) {
            return t = +t, e >>>= 0, r || L(this, t, e, 1, 127, -128), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
          }, a.prototype.writeInt16LE = function (t, e, r) {
            return t = +t, e >>>= 0, r || L(this, t, e, 2, 32767, -32768), this[e] = 255 & t, this[e + 1] = t >>> 8, e + 2;
          }, a.prototype.writeInt16BE = function (t, e, r) {
            return t = +t, e >>>= 0, r || L(this, t, e, 2, 32767, -32768), this[e] = t >>> 8, this[e + 1] = 255 & t, e + 2;
          }, a.prototype.writeInt32LE = function (t, e, r) {
            return t = +t, e >>>= 0, r || L(this, t, e, 4, 2147483647, -2147483648), this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24, e + 4;
          }, a.prototype.writeInt32BE = function (t, e, r) {
            return t = +t, e >>>= 0, r || L(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t, e + 4;
          }, a.prototype.writeFloatLE = function (t, e, r) {
            return P(this, t, e, !0, r);
          }, a.prototype.writeFloatBE = function (t, e, r) {
            return P(this, t, e, !1, r);
          }, a.prototype.writeDoubleLE = function (t, e, r) {
            return I(this, t, e, !0, r);
          }, a.prototype.writeDoubleBE = function (t, e, r) {
            return I(this, t, e, !1, r);
          }, a.prototype.copy = function (t, e, r, n) {
            if (!a.isBuffer(t)) throw new TypeError("argument should be a Buffer");
            if (r || (r = 0), n || 0 === n || (n = this.length), e >= t.length && (e = t.length), e || (e = 0), n > 0 && n < r && (n = r), n === r) return 0;
            if (0 === t.length || 0 === this.length) return 0;
            if (e < 0) throw new RangeError("targetStart out of bounds");
            if (r < 0 || r >= this.length) throw new RangeError("Index out of range");
            if (n < 0) throw new RangeError("sourceEnd out of bounds");
            n > this.length && (n = this.length), t.length - e < n - r && (n = t.length - e + r);
            var i = n - r;
            if (this === t && "function" == typeof Uint8Array.prototype.copyWithin) this.copyWithin(e, r, n);else if (this === t && r < e && e < n) for (var o = i - 1; o >= 0; --o) {
              t[o + e] = this[o + r];
            } else Uint8Array.prototype.set.call(t, this.subarray(r, n), e);
            return i;
          }, a.prototype.fill = function (t, e, r, n) {
            if ("string" == typeof t) {
              if ("string" == typeof e ? (n = e, e = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
              if ("string" == typeof n && !a.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);

              if (1 === t.length) {
                var i = t.charCodeAt(0);
                ("utf8" === n && i < 128 || "latin1" === n) && (t = i);
              }
            } else "number" == typeof t && (t &= 255);

            if (e < 0 || this.length < e || this.length < r) throw new RangeError("Out of range index");
            if (r <= e) return this;
            var o;
            if (e >>>= 0, r = void 0 === r ? this.length : r >>> 0, t || (t = 0), "number" == typeof t) for (o = e; o < r; ++o) {
              this[o] = t;
            } else {
              var s = a.isBuffer(t) ? t : a.from(t, n),
                  l = s.length;
              if (0 === l) throw new TypeError('The value "' + t + '" is invalid for argument "value"');

              for (o = 0; o < r - e; ++o) {
                this[o + e] = s[o % l];
              }
            }
            return this;
          };
          var O = /[^+/0-9A-Za-z-_]/g;

          function z(t) {
            return t < 16 ? "0" + t.toString(16) : t.toString(16);
          }

          function D(t, e) {
            var r;
            e = e || 1 / 0;

            for (var n = t.length, i = null, a = [], o = 0; o < n; ++o) {
              if ((r = t.charCodeAt(o)) > 55295 && r < 57344) {
                if (!i) {
                  if (r > 56319) {
                    (e -= 3) > -1 && a.push(239, 191, 189);
                    continue;
                  }

                  if (o + 1 === n) {
                    (e -= 3) > -1 && a.push(239, 191, 189);
                    continue;
                  }

                  i = r;
                  continue;
                }

                if (r < 56320) {
                  (e -= 3) > -1 && a.push(239, 191, 189), i = r;
                  continue;
                }

                r = 65536 + (i - 55296 << 10 | r - 56320);
              } else i && (e -= 3) > -1 && a.push(239, 191, 189);

              if (i = null, r < 128) {
                if ((e -= 1) < 0) break;
                a.push(r);
              } else if (r < 2048) {
                if ((e -= 2) < 0) break;
                a.push(r >> 6 | 192, 63 & r | 128);
              } else if (r < 65536) {
                if ((e -= 3) < 0) break;
                a.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
              } else {
                if (!(r < 1114112)) throw new Error("Invalid code point");
                if ((e -= 4) < 0) break;
                a.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
              }
            }

            return a;
          }

          function R(t) {
            return e.toByteArray(function (t) {
              if ((t = (t = t.split("=")[0]).trim().replace(O, "")).length < 2) return "";

              for (; t.length % 4 != 0;) {
                t += "=";
              }

              return t;
            }(t));
          }

          function F(t, e, r, n) {
            for (var i = 0; i < n && !(i + r >= e.length || i >= t.length); ++i) {
              e[i + r] = t[i];
            }

            return i;
          }

          function B(t, e) {
            return t instanceof e || null != t && null != t.constructor && null != t.constructor.name && t.constructor.name === e.name;
          }

          function N(t) {
            return t != t;
          }
        }).call(this);
      }).call(this, t("buffer").Buffer);
    }, {
      "base64-js": 81,
      buffer: 112,
      ieee754: 436
    }],
    113: [function (t, e, r) {
      "use strict";

      var n = t("./lib/monotone"),
          i = t("./lib/triangulation"),
          a = t("./lib/delaunay"),
          o = t("./lib/filter");

      function s(t) {
        return [Math.min(t[0], t[1]), Math.max(t[0], t[1])];
      }

      function l(t, e) {
        return t[0] - e[0] || t[1] - e[1];
      }

      function c(t, e, r) {
        return e in t ? t[e] : r;
      }

      e.exports = function (t, e, r) {
        Array.isArray(e) ? (r = r || {}, e = e || []) : (r = e || {}, e = []);
        var u = !!c(r, "delaunay", !0),
            f = !!c(r, "interior", !0),
            h = !!c(r, "exterior", !0),
            p = !!c(r, "infinity", !1);
        if (!f && !h || 0 === t.length) return [];
        var d = n(t, e);

        if (u || f !== h || p) {
          for (var m = i(t.length, function (t) {
            return t.map(s).sort(l);
          }(e)), g = 0; g < d.length; ++g) {
            var v = d[g];
            m.addTriangle(v[0], v[1], v[2]);
          }

          return u && a(t, m), h ? f ? p ? o(m, 0, p) : m.cells() : o(m, 1, p) : o(m, -1);
        }

        return d;
      };
    }, {
      "./lib/delaunay": 114,
      "./lib/filter": 115,
      "./lib/monotone": 116,
      "./lib/triangulation": 117
    }],
    114: [function (t, e, r) {
      "use strict";

      var n = t("robust-in-sphere")[4];
      t("binary-search-bounds");

      function i(t, e, r, i, a, o) {
        var s = e.opposite(i, a);

        if (!(s < 0)) {
          if (a < i) {
            var l = i;
            i = a, a = l, l = o, o = s, s = l;
          }

          e.isConstraint(i, a) || n(t[i], t[a], t[o], t[s]) < 0 && r.push(i, a);
        }
      }

      e.exports = function (t, e) {
        for (var r = [], a = t.length, o = e.stars, s = 0; s < a; ++s) {
          for (var l = o[s], c = 1; c < l.length; c += 2) {
            if (!((p = l[c]) < s) && !e.isConstraint(s, p)) {
              for (var u = l[c - 1], f = -1, h = 1; h < l.length; h += 2) {
                if (l[h - 1] === p) {
                  f = l[h];
                  break;
                }
              }

              f < 0 || n(t[s], t[p], t[u], t[f]) < 0 && r.push(s, p);
            }
          }
        }

        for (; r.length > 0;) {
          for (var p = r.pop(), d = (s = r.pop(), u = -1, f = -1, l = o[s], 1); d < l.length; d += 2) {
            var m = l[d - 1],
                g = l[d];
            m === p ? f = g : g === p && (u = m);
          }

          u < 0 || f < 0 || n(t[s], t[p], t[u], t[f]) >= 0 || (e.flip(s, p), i(t, e, r, u, s, f), i(t, e, r, s, f, u), i(t, e, r, f, p, u), i(t, e, r, p, u, f));
        }
      };
    }, {
      "binary-search-bounds": 98,
      "robust-in-sphere": 538
    }],
    115: [function (t, e, r) {
      "use strict";

      var n,
          i = t("binary-search-bounds");

      function a(t, e, r, n, i, a, o) {
        this.cells = t, this.neighbor = e, this.flags = n, this.constraint = r, this.active = i, this.next = a, this.boundary = o;
      }

      function o(t, e) {
        return t[0] - e[0] || t[1] - e[1] || t[2] - e[2];
      }

      e.exports = function (t, e, r) {
        var n = function (t, e) {
          for (var r = t.cells(), n = r.length, i = 0; i < n; ++i) {
            var s = (v = r[i])[0],
                l = v[1],
                c = v[2];
            l < c ? l < s && (v[0] = l, v[1] = c, v[2] = s) : c < s && (v[0] = c, v[1] = s, v[2] = l);
          }

          r.sort(o);
          var u = new Array(n);

          for (i = 0; i < u.length; ++i) {
            u[i] = 0;
          }

          var f = [],
              h = [],
              p = new Array(3 * n),
              d = new Array(3 * n),
              m = null;
          e && (m = []);
          var g = new a(r, p, d, u, f, h, m);

          for (i = 0; i < n; ++i) {
            for (var v = r[i], y = 0; y < 3; ++y) {
              s = v[y], l = v[(y + 1) % 3];
              var x = p[3 * i + y] = g.locate(l, s, t.opposite(l, s)),
                  b = d[3 * i + y] = t.isConstraint(s, l);
              x < 0 && (b ? h.push(i) : (f.push(i), u[i] = 1), e && m.push([l, s, -1]));
            }
          }

          return g;
        }(t, r);

        if (0 === e) return r ? n.cells.concat(n.boundary) : n.cells;
        var i = 1,
            s = n.active,
            l = n.next,
            c = n.flags,
            u = n.cells,
            f = n.constraint,
            h = n.neighbor;

        for (; s.length > 0 || l.length > 0;) {
          for (; s.length > 0;) {
            var p = s.pop();

            if (c[p] !== -i) {
              c[p] = i;
              u[p];

              for (var d = 0; d < 3; ++d) {
                var m = h[3 * p + d];
                m >= 0 && 0 === c[m] && (f[3 * p + d] ? l.push(m) : (s.push(m), c[m] = i));
              }
            }
          }

          var g = l;
          l = s, s = g, l.length = 0, i = -i;
        }

        var v = function (t, e, r) {
          for (var n = 0, i = 0; i < t.length; ++i) {
            e[i] === r && (t[n++] = t[i]);
          }

          return t.length = n, t;
        }(u, c, e);

        if (r) return v.concat(n.boundary);
        return v;
      }, a.prototype.locate = (n = [0, 0, 0], function (t, e, r) {
        var a = t,
            s = e,
            l = r;
        return e < r ? e < t && (a = e, s = r, l = t) : r < t && (a = r, s = t, l = e), a < 0 ? -1 : (n[0] = a, n[1] = s, n[2] = l, i.eq(this.cells, n, o));
      });
    }, {
      "binary-search-bounds": 98
    }],
    116: [function (t, e, r) {
      "use strict";

      var n = t("binary-search-bounds"),
          i = t("robust-orientation")[3];

      function a(t, e, r, n, i) {
        this.a = t, this.b = e, this.idx = r, this.lowerIds = n, this.upperIds = i;
      }

      function o(t, e, r, n) {
        this.a = t, this.b = e, this.type = r, this.idx = n;
      }

      function s(t, e) {
        var r = t.a[0] - e.a[0] || t.a[1] - e.a[1] || t.type - e.type;
        return r || (0 !== t.type && (r = i(t.a, t.b, e.b)) ? r : t.idx - e.idx);
      }

      function l(t, e) {
        return i(t.a, t.b, e);
      }

      function c(t, e, r, a, o) {
        for (var s = n.lt(e, a, l), c = n.gt(e, a, l), u = s; u < c; ++u) {
          for (var f = e[u], h = f.lowerIds, p = h.length; p > 1 && i(r[h[p - 2]], r[h[p - 1]], a) > 0;) {
            t.push([h[p - 1], h[p - 2], o]), p -= 1;
          }

          h.length = p, h.push(o);
          var d = f.upperIds;

          for (p = d.length; p > 1 && i(r[d[p - 2]], r[d[p - 1]], a) < 0;) {
            t.push([d[p - 2], d[p - 1], o]), p -= 1;
          }

          d.length = p, d.push(o);
        }
      }

      function u(t, e) {
        var r;
        return (r = t.a[0] < e.a[0] ? i(t.a, t.b, e.a) : i(e.b, e.a, t.a)) ? r : (r = e.b[0] < t.b[0] ? i(t.a, t.b, e.b) : i(e.b, e.a, t.b)) || t.idx - e.idx;
      }

      function f(t, e, r) {
        var i = n.le(t, r, u),
            o = t[i],
            s = o.upperIds,
            l = s[s.length - 1];
        o.upperIds = [l], t.splice(i + 1, 0, new a(r.a, r.b, r.idx, [l], s));
      }

      function h(t, e, r) {
        var i = r.a;
        r.a = r.b, r.b = i;
        var a = n.eq(t, r, u),
            o = t[a];
        t[a - 1].upperIds = o.upperIds, t.splice(a, 1);
      }

      e.exports = function (t, e) {
        for (var r = t.length, n = e.length, i = [], l = 0; l < r; ++l) {
          i.push(new o(t[l], null, 0, l));
        }

        for (l = 0; l < n; ++l) {
          var u = e[l],
              p = t[u[0]],
              d = t[u[1]];
          p[0] < d[0] ? i.push(new o(p, d, 2, l), new o(d, p, 1, l)) : p[0] > d[0] && i.push(new o(d, p, 2, l), new o(p, d, 1, l));
        }

        i.sort(s);

        for (var m = i[0].a[0] - (1 + Math.abs(i[0].a[0])) * Math.pow(2, -52), g = [new a([m, 1], [m, 0], -1, [], [], [], [])], v = [], y = (l = 0, i.length); l < y; ++l) {
          var x = i[l],
              b = x.type;
          0 === b ? c(v, g, t, x.a, x.idx) : 2 === b ? f(g, t, x) : h(g, t, x);
        }

        return v;
      };
    }, {
      "binary-search-bounds": 98,
      "robust-orientation": 540
    }],
    117: [function (t, e, r) {
      "use strict";

      var n = t("binary-search-bounds");

      function i(t, e) {
        this.stars = t, this.edges = e;
      }

      e.exports = function (t, e) {
        for (var r = new Array(t), n = 0; n < t; ++n) {
          r[n] = [];
        }

        return new i(r, e);
      };

      var a = i.prototype;

      function o(t, e, r) {
        for (var n = 1, i = t.length; n < i; n += 2) {
          if (t[n - 1] === e && t[n] === r) return t[n - 1] = t[i - 2], t[n] = t[i - 1], void (t.length = i - 2);
        }
      }

      a.isConstraint = function () {
        var t = [0, 0];

        function e(t, e) {
          return t[0] - e[0] || t[1] - e[1];
        }

        return function (r, i) {
          return t[0] = Math.min(r, i), t[1] = Math.max(r, i), n.eq(this.edges, t, e) >= 0;
        };
      }(), a.removeTriangle = function (t, e, r) {
        var n = this.stars;
        o(n[t], e, r), o(n[e], r, t), o(n[r], t, e);
      }, a.addTriangle = function (t, e, r) {
        var n = this.stars;
        n[t].push(e, r), n[e].push(r, t), n[r].push(t, e);
      }, a.opposite = function (t, e) {
        for (var r = this.stars[e], n = 1, i = r.length; n < i; n += 2) {
          if (r[n] === t) return r[n - 1];
        }

        return -1;
      }, a.flip = function (t, e) {
        var r = this.opposite(t, e),
            n = this.opposite(e, t);
        this.removeTriangle(t, e, r), this.removeTriangle(e, t, n), this.addTriangle(t, n, r), this.addTriangle(e, r, n);
      }, a.edges = function () {
        for (var t = this.stars, e = [], r = 0, n = t.length; r < n; ++r) {
          for (var i = t[r], a = 0, o = i.length; a < o; a += 2) {
            e.push([i[a], i[a + 1]]);
          }
        }

        return e;
      }, a.cells = function () {
        for (var t = this.stars, e = [], r = 0, n = t.length; r < n; ++r) {
          for (var i = t[r], a = 0, o = i.length; a < o; a += 2) {
            var s = i[a],
                l = i[a + 1];
            r < Math.min(s, l) && e.push([r, s, l]);
          }
        }

        return e;
      };
    }, {
      "binary-search-bounds": 98
    }],
    118: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        for (var e = 1, r = 1; r < t.length; ++r) {
          for (var n = 0; n < r; ++n) {
            if (t[r] < t[n]) e = -e;else if (t[n] === t[r]) return 0;
          }
        }

        return e;
      };
    }, {}],
    119: [function (t, e, r) {
      "use strict";

      var n = t("dup"),
          i = t("robust-linear-solve");

      function a(t, e) {
        for (var r = 0, n = t.length, i = 0; i < n; ++i) {
          r += t[i] * e[i];
        }

        return r;
      }

      function o(t) {
        var e = t.length;
        if (0 === e) return [];
        t[0].length;
        var r = n([t.length + 1, t.length + 1], 1),
            o = n([t.length + 1], 1);
        r[e][e] = 0;

        for (var s = 0; s < e; ++s) {
          for (var l = 0; l <= s; ++l) {
            r[l][s] = r[s][l] = 2 * a(t[s], t[l]);
          }

          o[s] = a(t[s], t[s]);
        }

        var c = i(r, o),
            u = 0,
            f = c[e + 1];

        for (s = 0; s < f.length; ++s) {
          u += f[s];
        }

        var h = new Array(e);

        for (s = 0; s < e; ++s) {
          f = c[s];
          var p = 0;

          for (l = 0; l < f.length; ++l) {
            p += f[l];
          }

          h[s] = p / u;
        }

        return h;
      }

      function s(t) {
        if (0 === t.length) return [];

        for (var e = t[0].length, r = n([e]), i = o(t), a = 0; a < t.length; ++a) {
          for (var s = 0; s < e; ++s) {
            r[s] += t[a][s] * i[a];
          }
        }

        return r;
      }

      s.barycenetric = o, e.exports = s;
    }, {
      dup: 176,
      "robust-linear-solve": 539
    }],
    120: [function (t, e, r) {
      e.exports = function (t) {
        for (var e = n(t), r = 0, i = 0; i < t.length; ++i) {
          for (var a = t[i], o = 0; o < e.length; ++o) {
            r += Math.pow(a[o] - e[o], 2);
          }
        }

        return Math.sqrt(r / t.length);
      };

      var n = t("circumcenter");
    }, {
      circumcenter: 119
    }],
    121: [function (t, e, r) {
      e.exports = function (t, e, r) {
        return e < r ? t < e ? e : t > r ? r : t : t < r ? r : t > e ? e : t;
      };
    }, {}],
    122: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r) {
        var n;

        if (r) {
          n = e;

          for (var i = new Array(e.length), a = 0; a < e.length; ++a) {
            var o = e[a];
            i[a] = [o[0], o[1], r[a]];
          }

          e = i;
        }

        var s = function (t, e, r) {
          var n = d(t, [], p(t));
          return v(e, n, r), !!n;
        }(t, e, !!r);

        for (; y(t, e, !!r);) {
          s = !0;
        }

        if (r && s) {
          n.length = 0, r.length = 0;

          for (a = 0; a < e.length; ++a) {
            o = e[a];
            n.push([o[0], o[1]]), r.push(o[2]);
          }
        }

        return s;
      };

      var n = t("union-find"),
          i = t("box-intersect"),
          a = t("robust-segment-intersect"),
          o = t("big-rat"),
          s = t("big-rat/cmp"),
          l = t("big-rat/to-float"),
          c = t("rat-vec"),
          u = t("nextafter"),
          f = t("./lib/rat-seg-intersect");

      function h(t) {
        var e = l(t);
        return [u(e, -1 / 0), u(e, 1 / 0)];
      }

      function p(t) {
        for (var e = new Array(t.length), r = 0; r < t.length; ++r) {
          var n = t[r];
          e[r] = [u(n[0], -1 / 0), u(n[1], -1 / 0), u(n[0], 1 / 0), u(n[1], 1 / 0)];
        }

        return e;
      }

      function d(t, e, r) {
        for (var a = e.length, o = new n(a), s = [], l = 0; l < e.length; ++l) {
          var c = e[l],
              f = h(c[0]),
              p = h(c[1]);
          s.push([u(f[0], -1 / 0), u(p[0], -1 / 0), u(f[1], 1 / 0), u(p[1], 1 / 0)]);
        }

        i(s, function (t, e) {
          o.link(t, e);
        });
        var d = !0,
            m = new Array(a);

        for (l = 0; l < a; ++l) {
          (v = o.find(l)) !== l && (d = !1, t[v] = [Math.min(t[l][0], t[v][0]), Math.min(t[l][1], t[v][1])]);
        }

        if (d) return null;
        var g = 0;

        for (l = 0; l < a; ++l) {
          var v;
          (v = o.find(l)) === l ? (m[l] = g, t[g++] = t[l]) : m[l] = -1;
        }

        t.length = g;

        for (l = 0; l < a; ++l) {
          m[l] < 0 && (m[l] = m[o.find(l)]);
        }

        return m;
      }

      function m(t, e) {
        return t[0] - e[0] || t[1] - e[1];
      }

      function g(t, e) {
        var r = t[0] - e[0] || t[1] - e[1];
        return r || (t[2] < e[2] ? -1 : t[2] > e[2] ? 1 : 0);
      }

      function v(t, e, r) {
        if (0 !== t.length) {
          if (e) for (var n = 0; n < t.length; ++n) {
            var i = e[(o = t[n])[0]],
                a = e[o[1]];
            o[0] = Math.min(i, a), o[1] = Math.max(i, a);
          } else for (n = 0; n < t.length; ++n) {
            var o;
            i = (o = t[n])[0], a = o[1];
            o[0] = Math.min(i, a), o[1] = Math.max(i, a);
          }
          r ? t.sort(g) : t.sort(m);
          var s = 1;

          for (n = 1; n < t.length; ++n) {
            var l = t[n - 1],
                c = t[n];
            (c[0] !== l[0] || c[1] !== l[1] || r && c[2] !== l[2]) && (t[s++] = c);
          }

          t.length = s;
        }
      }

      function y(t, e, r) {
        var n = function (t, e) {
          for (var r = new Array(e.length), n = 0; n < e.length; ++n) {
            var i = e[n],
                a = t[i[0]],
                o = t[i[1]];
            r[n] = [u(Math.min(a[0], o[0]), -1 / 0), u(Math.min(a[1], o[1]), -1 / 0), u(Math.max(a[0], o[0]), 1 / 0), u(Math.max(a[1], o[1]), 1 / 0)];
          }

          return r;
        }(t, e),
            h = function (t, e, r) {
          var n = [];
          return i(r, function (r, i) {
            var o = e[r],
                s = e[i];

            if (o[0] !== s[0] && o[0] !== s[1] && o[1] !== s[0] && o[1] !== s[1]) {
              var l = t[o[0]],
                  c = t[o[1]],
                  u = t[s[0]],
                  f = t[s[1]];
              a(l, c, u, f) && n.push([r, i]);
            }
          }), n;
        }(t, e, n),
            m = p(t),
            g = function (t, e, r, n) {
          var o = [];
          return i(r, n, function (r, n) {
            var i = e[r];

            if (i[0] !== n && i[1] !== n) {
              var s = t[n],
                  l = t[i[0]],
                  c = t[i[1]];
              a(l, c, s, s) && o.push([r, n]);
            }
          }), o;
        }(t, e, n, m),
            y = d(t, function (t, e, r, n, i) {
          var a,
              u,
              h = t.map(function (t) {
            return [o(t[0]), o(t[1])];
          });

          for (a = 0; a < r.length; ++a) {
            var p = r[a];
            u = p[0];
            var d = p[1],
                m = e[u],
                g = e[d],
                v = f(c(t[m[0]]), c(t[m[1]]), c(t[g[0]]), c(t[g[1]]));

            if (v) {
              var y = t.length;
              t.push([l(v[0]), l(v[1])]), h.push(v), n.push([u, y], [d, y]);
            }
          }

          for (n.sort(function (t, e) {
            if (t[0] !== e[0]) return t[0] - e[0];
            var r = h[t[1]],
                n = h[e[1]];
            return s(r[0], n[0]) || s(r[1], n[1]);
          }), a = n.length - 1; a >= 0; --a) {
            var x = e[u = (S = n[a])[0]],
                b = x[0],
                _ = x[1],
                w = t[b],
                T = t[_];

            if ((w[0] - T[0] || w[1] - T[1]) < 0) {
              var k = b;
              b = _, _ = k;
            }

            x[0] = b;
            var M,
                A = x[1] = S[1];

            for (i && (M = x[2]); a > 0 && n[a - 1][0] === u;) {
              var S,
                  E = (S = n[--a])[1];
              i ? e.push([A, E, M]) : e.push([A, E]), A = E;
            }

            i ? e.push([A, _, M]) : e.push([A, _]);
          }

          return h;
        }(t, e, h, g, r));

        return v(e, y, r), !!y || h.length > 0 || g.length > 0;
      }
    }, {
      "./lib/rat-seg-intersect": 123,
      "big-rat": 85,
      "big-rat/cmp": 83,
      "big-rat/to-float": 97,
      "box-intersect": 103,
      nextafter: 476,
      "rat-vec": 524,
      "robust-segment-intersect": 543,
      "union-find": 610
    }],
    123: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, n) {
        var a = s(e, t),
            f = s(n, r),
            h = u(a, f);
        if (0 === o(h)) return null;
        var p = s(t, r),
            d = u(f, p),
            m = i(d, h),
            g = c(a, m);
        return l(t, g);
      };

      var n = t("big-rat/mul"),
          i = t("big-rat/div"),
          a = t("big-rat/sub"),
          o = t("big-rat/sign"),
          s = t("rat-vec/sub"),
          l = t("rat-vec/add"),
          c = t("rat-vec/muls");

      function u(t, e) {
        return a(n(t[0], e[1]), n(t[1], e[0]));
      }
    }, {
      "big-rat/div": 84,
      "big-rat/mul": 94,
      "big-rat/sign": 95,
      "big-rat/sub": 96,
      "rat-vec/add": 523,
      "rat-vec/muls": 525,
      "rat-vec/sub": 526
    }],
    124: [function (t, e, r) {
      "use strict";

      var n = t("clamp");

      function i(t, e) {
        null == e && (e = !0);
        var r = t[0],
            i = t[1],
            a = t[2],
            o = t[3];
        return null == o && (o = e ? 1 : 255), e && (r *= 255, i *= 255, a *= 255, o *= 255), 16777216 * (r = 255 & n(r, 0, 255)) + ((i = 255 & n(i, 0, 255)) << 16) + ((a = 255 & n(a, 0, 255)) << 8) + (o = 255 & n(o, 0, 255));
      }

      e.exports = i, e.exports.to = i, e.exports.from = function (t, e) {
        var r = (t = +t) >>> 24,
            n = (16711680 & t) >>> 16,
            i = (65280 & t) >>> 8,
            a = 255 & t;
        return !1 === e ? [r, n, i, a] : [r / 255, n / 255, i / 255, a / 255];
      };
    }, {
      clamp: 121
    }],
    125: [function (t, e, r) {
      "use strict";

      e.exports = {
        aliceblue: [240, 248, 255],
        antiquewhite: [250, 235, 215],
        aqua: [0, 255, 255],
        aquamarine: [127, 255, 212],
        azure: [240, 255, 255],
        beige: [245, 245, 220],
        bisque: [255, 228, 196],
        black: [0, 0, 0],
        blanchedalmond: [255, 235, 205],
        blue: [0, 0, 255],
        blueviolet: [138, 43, 226],
        brown: [165, 42, 42],
        burlywood: [222, 184, 135],
        cadetblue: [95, 158, 160],
        chartreuse: [127, 255, 0],
        chocolate: [210, 105, 30],
        coral: [255, 127, 80],
        cornflowerblue: [100, 149, 237],
        cornsilk: [255, 248, 220],
        crimson: [220, 20, 60],
        cyan: [0, 255, 255],
        darkblue: [0, 0, 139],
        darkcyan: [0, 139, 139],
        darkgoldenrod: [184, 134, 11],
        darkgray: [169, 169, 169],
        darkgreen: [0, 100, 0],
        darkgrey: [169, 169, 169],
        darkkhaki: [189, 183, 107],
        darkmagenta: [139, 0, 139],
        darkolivegreen: [85, 107, 47],
        darkorange: [255, 140, 0],
        darkorchid: [153, 50, 204],
        darkred: [139, 0, 0],
        darksalmon: [233, 150, 122],
        darkseagreen: [143, 188, 143],
        darkslateblue: [72, 61, 139],
        darkslategray: [47, 79, 79],
        darkslategrey: [47, 79, 79],
        darkturquoise: [0, 206, 209],
        darkviolet: [148, 0, 211],
        deeppink: [255, 20, 147],
        deepskyblue: [0, 191, 255],
        dimgray: [105, 105, 105],
        dimgrey: [105, 105, 105],
        dodgerblue: [30, 144, 255],
        firebrick: [178, 34, 34],
        floralwhite: [255, 250, 240],
        forestgreen: [34, 139, 34],
        fuchsia: [255, 0, 255],
        gainsboro: [220, 220, 220],
        ghostwhite: [248, 248, 255],
        gold: [255, 215, 0],
        goldenrod: [218, 165, 32],
        gray: [128, 128, 128],
        green: [0, 128, 0],
        greenyellow: [173, 255, 47],
        grey: [128, 128, 128],
        honeydew: [240, 255, 240],
        hotpink: [255, 105, 180],
        indianred: [205, 92, 92],
        indigo: [75, 0, 130],
        ivory: [255, 255, 240],
        khaki: [240, 230, 140],
        lavender: [230, 230, 250],
        lavenderblush: [255, 240, 245],
        lawngreen: [124, 252, 0],
        lemonchiffon: [255, 250, 205],
        lightblue: [173, 216, 230],
        lightcoral: [240, 128, 128],
        lightcyan: [224, 255, 255],
        lightgoldenrodyellow: [250, 250, 210],
        lightgray: [211, 211, 211],
        lightgreen: [144, 238, 144],
        lightgrey: [211, 211, 211],
        lightpink: [255, 182, 193],
        lightsalmon: [255, 160, 122],
        lightseagreen: [32, 178, 170],
        lightskyblue: [135, 206, 250],
        lightslategray: [119, 136, 153],
        lightslategrey: [119, 136, 153],
        lightsteelblue: [176, 196, 222],
        lightyellow: [255, 255, 224],
        lime: [0, 255, 0],
        limegreen: [50, 205, 50],
        linen: [250, 240, 230],
        magenta: [255, 0, 255],
        maroon: [128, 0, 0],
        mediumaquamarine: [102, 205, 170],
        mediumblue: [0, 0, 205],
        mediumorchid: [186, 85, 211],
        mediumpurple: [147, 112, 219],
        mediumseagreen: [60, 179, 113],
        mediumslateblue: [123, 104, 238],
        mediumspringgreen: [0, 250, 154],
        mediumturquoise: [72, 209, 204],
        mediumvioletred: [199, 21, 133],
        midnightblue: [25, 25, 112],
        mintcream: [245, 255, 250],
        mistyrose: [255, 228, 225],
        moccasin: [255, 228, 181],
        navajowhite: [255, 222, 173],
        navy: [0, 0, 128],
        oldlace: [253, 245, 230],
        olive: [128, 128, 0],
        olivedrab: [107, 142, 35],
        orange: [255, 165, 0],
        orangered: [255, 69, 0],
        orchid: [218, 112, 214],
        palegoldenrod: [238, 232, 170],
        palegreen: [152, 251, 152],
        paleturquoise: [175, 238, 238],
        palevioletred: [219, 112, 147],
        papayawhip: [255, 239, 213],
        peachpuff: [255, 218, 185],
        peru: [205, 133, 63],
        pink: [255, 192, 203],
        plum: [221, 160, 221],
        powderblue: [176, 224, 230],
        purple: [128, 0, 128],
        rebeccapurple: [102, 51, 153],
        red: [255, 0, 0],
        rosybrown: [188, 143, 143],
        royalblue: [65, 105, 225],
        saddlebrown: [139, 69, 19],
        salmon: [250, 128, 114],
        sandybrown: [244, 164, 96],
        seagreen: [46, 139, 87],
        seashell: [255, 245, 238],
        sienna: [160, 82, 45],
        silver: [192, 192, 192],
        skyblue: [135, 206, 235],
        slateblue: [106, 90, 205],
        slategray: [112, 128, 144],
        slategrey: [112, 128, 144],
        snow: [255, 250, 250],
        springgreen: [0, 255, 127],
        steelblue: [70, 130, 180],
        tan: [210, 180, 140],
        teal: [0, 128, 128],
        thistle: [216, 191, 216],
        tomato: [255, 99, 71],
        turquoise: [64, 224, 208],
        violet: [238, 130, 238],
        wheat: [245, 222, 179],
        white: [255, 255, 255],
        whitesmoke: [245, 245, 245],
        yellow: [255, 255, 0],
        yellowgreen: [154, 205, 50]
      };
    }, {}],
    126: [function (t, e, r) {
      "use strict";

      var n = t("color-rgba"),
          i = t("clamp"),
          a = t("dtype");

      e.exports = function (t, e) {
        "float" !== e && e || (e = "array"), "uint" === e && (e = "uint8"), "uint_clamped" === e && (e = "uint8_clamped");
        var r = new (a(e))(4),
            o = "uint8" !== e && "uint8_clamped" !== e;
        return t.length && "string" != typeof t || ((t = n(t))[0] /= 255, t[1] /= 255, t[2] /= 255), function (t) {
          return t instanceof Uint8Array || t instanceof Uint8ClampedArray || !!(Array.isArray(t) && (t[0] > 1 || 0 === t[0]) && (t[1] > 1 || 0 === t[1]) && (t[2] > 1 || 0 === t[2]) && (!t[3] || t[3] > 1));
        }(t) ? (r[0] = t[0], r[1] = t[1], r[2] = t[2], r[3] = null != t[3] ? t[3] : 255, o && (r[0] /= 255, r[1] /= 255, r[2] /= 255, r[3] /= 255), r) : (o ? (r[0] = t[0], r[1] = t[1], r[2] = t[2], r[3] = null != t[3] ? t[3] : 1) : (r[0] = i(Math.floor(255 * t[0]), 0, 255), r[1] = i(Math.floor(255 * t[1]), 0, 255), r[2] = i(Math.floor(255 * t[2]), 0, 255), r[3] = null == t[3] ? 255 : i(Math.floor(255 * t[3]), 0, 255)), r);
      };
    }, {
      clamp: 121,
      "color-rgba": 128,
      dtype: 175
    }],
    127: [function (t, e, r) {
      (function (r) {
        (function () {
          "use strict";

          var n = t("color-name"),
              i = t("is-plain-obj"),
              a = t("defined");

          e.exports = function (t) {
            var e,
                s,
                l = [],
                c = 1;
            if ("string" == typeof t) {
              if (n[t]) l = n[t].slice(), s = "rgb";else if ("transparent" === t) c = 0, s = "rgb", l = [0, 0, 0];else if (/^#[A-Fa-f0-9]+$/.test(t)) {
                var u = (p = t.slice(1)).length;
                c = 1, u <= 4 ? (l = [parseInt(p[0] + p[0], 16), parseInt(p[1] + p[1], 16), parseInt(p[2] + p[2], 16)], 4 === u && (c = parseInt(p[3] + p[3], 16) / 255)) : (l = [parseInt(p[0] + p[1], 16), parseInt(p[2] + p[3], 16), parseInt(p[4] + p[5], 16)], 8 === u && (c = parseInt(p[6] + p[7], 16) / 255)), l[0] || (l[0] = 0), l[1] || (l[1] = 0), l[2] || (l[2] = 0), s = "rgb";
              } else if (e = /^((?:rgb|hs[lvb]|hwb|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms)a?)\s*\(([^\)]*)\)/.exec(t)) {
                var f = e[1],
                    h = "rgb" === f,
                    p = f.replace(/a$/, "");
                s = p;
                u = "cmyk" === p ? 4 : "gray" === p ? 1 : 3;
                l = e[2].trim().split(/\s*,\s*/).map(function (t, e) {
                  if (/%$/.test(t)) return e === u ? parseFloat(t) / 100 : "rgb" === p ? 255 * parseFloat(t) / 100 : parseFloat(t);

                  if ("h" === p[e]) {
                    if (/deg$/.test(t)) return parseFloat(t);
                    if (void 0 !== o[t]) return o[t];
                  }

                  return parseFloat(t);
                }), f === p && l.push(1), c = h || void 0 === l[u] ? 1 : l[u], l = l.slice(0, u);
              } else t.length > 10 && /[0-9](?:\s|\/)/.test(t) && (l = t.match(/([0-9]+)/g).map(function (t) {
                return parseFloat(t);
              }), s = t.match(/([a-z])/gi).join("").toLowerCase());
            } else if (isNaN(t)) {
              if (i(t)) {
                var d = a(t.r, t.red, t.R, null);
                null !== d ? (s = "rgb", l = [d, a(t.g, t.green, t.G), a(t.b, t.blue, t.B)]) : (s = "hsl", l = [a(t.h, t.hue, t.H), a(t.s, t.saturation, t.S), a(t.l, t.lightness, t.L, t.b, t.brightness)]), c = a(t.a, t.alpha, t.opacity, 1), null != t.opacity && (c /= 100);
              } else (Array.isArray(t) || r.ArrayBuffer && ArrayBuffer.isView && ArrayBuffer.isView(t)) && (l = [t[0], t[1], t[2]], s = "rgb", c = 4 === t.length ? t[3] : 1);
            } else s = "rgb", l = [t >>> 16, (65280 & t) >>> 8, 255 & t];
            return {
              space: s,
              values: l,
              alpha: c
            };
          };

          var o = {
            red: 0,
            orange: 60,
            yellow: 120,
            green: 180,
            blue: 240,
            purple: 300
          };
        }).call(this);
      }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
    }, {
      "color-name": 125,
      defined: 170,
      "is-plain-obj": 448
    }],
    128: [function (t, e, r) {
      "use strict";

      var n = t("color-parse"),
          i = t("color-space/hsl"),
          a = t("clamp");

      e.exports = function (t) {
        var e,
            r = n(t);
        return r.space ? ((e = Array(3))[0] = a(r.values[0], 0, 255), e[1] = a(r.values[1], 0, 255), e[2] = a(r.values[2], 0, 255), "h" === r.space[0] && (e = i.rgb(e)), e.push(a(r.alpha, 0, 1)), e) : [];
      };
    }, {
      clamp: 121,
      "color-parse": 127,
      "color-space/hsl": 129
    }],
    129: [function (t, e, r) {
      "use strict";

      var n = t("./rgb");
      e.exports = {
        name: "hsl",
        min: [0, 0, 0],
        max: [360, 100, 100],
        channel: ["hue", "saturation", "lightness"],
        alias: ["HSL"],
        rgb: function rgb(t) {
          var e,
              r,
              n,
              i,
              a,
              o = t[0] / 360,
              s = t[1] / 100,
              l = t[2] / 100;
          if (0 === s) return [a = 255 * l, a, a];
          e = 2 * l - (r = l < .5 ? l * (1 + s) : l + s - l * s), i = [0, 0, 0];

          for (var c = 0; c < 3; c++) {
            (n = o + 1 / 3 * -(c - 1)) < 0 ? n++ : n > 1 && n--, a = 6 * n < 1 ? e + 6 * (r - e) * n : 2 * n < 1 ? r : 3 * n < 2 ? e + (r - e) * (2 / 3 - n) * 6 : e, i[c] = 255 * a;
          }

          return i;
        }
      }, n.hsl = function (t) {
        var e,
            r,
            n = t[0] / 255,
            i = t[1] / 255,
            a = t[2] / 255,
            o = Math.min(n, i, a),
            s = Math.max(n, i, a),
            l = s - o;
        return s === o ? e = 0 : n === s ? e = (i - a) / l : i === s ? e = 2 + (a - n) / l : a === s && (e = 4 + (n - i) / l), (e = Math.min(60 * e, 360)) < 0 && (e += 360), r = (o + s) / 2, [e, 100 * (s === o ? 0 : r <= .5 ? l / (s + o) : l / (2 - s - o)), 100 * r];
      };
    }, {
      "./rgb": 130
    }],
    130: [function (t, e, r) {
      "use strict";

      e.exports = {
        name: "rgb",
        min: [0, 0, 0],
        max: [255, 255, 255],
        channel: ["red", "green", "blue"],
        alias: ["RGB"]
      };
    }, {}],
    131: [function (t, e, r) {
      e.exports = {
        jet: [{
          index: 0,
          rgb: [0, 0, 131]
        }, {
          index: .125,
          rgb: [0, 60, 170]
        }, {
          index: .375,
          rgb: [5, 255, 255]
        }, {
          index: .625,
          rgb: [255, 255, 0]
        }, {
          index: .875,
          rgb: [250, 0, 0]
        }, {
          index: 1,
          rgb: [128, 0, 0]
        }],
        hsv: [{
          index: 0,
          rgb: [255, 0, 0]
        }, {
          index: .169,
          rgb: [253, 255, 2]
        }, {
          index: .173,
          rgb: [247, 255, 2]
        }, {
          index: .337,
          rgb: [0, 252, 4]
        }, {
          index: .341,
          rgb: [0, 252, 10]
        }, {
          index: .506,
          rgb: [1, 249, 255]
        }, {
          index: .671,
          rgb: [2, 0, 253]
        }, {
          index: .675,
          rgb: [8, 0, 253]
        }, {
          index: .839,
          rgb: [255, 0, 251]
        }, {
          index: .843,
          rgb: [255, 0, 245]
        }, {
          index: 1,
          rgb: [255, 0, 6]
        }],
        hot: [{
          index: 0,
          rgb: [0, 0, 0]
        }, {
          index: .3,
          rgb: [230, 0, 0]
        }, {
          index: .6,
          rgb: [255, 210, 0]
        }, {
          index: 1,
          rgb: [255, 255, 255]
        }],
        spring: [{
          index: 0,
          rgb: [255, 0, 255]
        }, {
          index: 1,
          rgb: [255, 255, 0]
        }],
        summer: [{
          index: 0,
          rgb: [0, 128, 102]
        }, {
          index: 1,
          rgb: [255, 255, 102]
        }],
        autumn: [{
          index: 0,
          rgb: [255, 0, 0]
        }, {
          index: 1,
          rgb: [255, 255, 0]
        }],
        winter: [{
          index: 0,
          rgb: [0, 0, 255]
        }, {
          index: 1,
          rgb: [0, 255, 128]
        }],
        bone: [{
          index: 0,
          rgb: [0, 0, 0]
        }, {
          index: .376,
          rgb: [84, 84, 116]
        }, {
          index: .753,
          rgb: [169, 200, 200]
        }, {
          index: 1,
          rgb: [255, 255, 255]
        }],
        copper: [{
          index: 0,
          rgb: [0, 0, 0]
        }, {
          index: .804,
          rgb: [255, 160, 102]
        }, {
          index: 1,
          rgb: [255, 199, 127]
        }],
        greys: [{
          index: 0,
          rgb: [0, 0, 0]
        }, {
          index: 1,
          rgb: [255, 255, 255]
        }],
        yignbu: [{
          index: 0,
          rgb: [8, 29, 88]
        }, {
          index: .125,
          rgb: [37, 52, 148]
        }, {
          index: .25,
          rgb: [34, 94, 168]
        }, {
          index: .375,
          rgb: [29, 145, 192]
        }, {
          index: .5,
          rgb: [65, 182, 196]
        }, {
          index: .625,
          rgb: [127, 205, 187]
        }, {
          index: .75,
          rgb: [199, 233, 180]
        }, {
          index: .875,
          rgb: [237, 248, 217]
        }, {
          index: 1,
          rgb: [255, 255, 217]
        }],
        greens: [{
          index: 0,
          rgb: [0, 68, 27]
        }, {
          index: .125,
          rgb: [0, 109, 44]
        }, {
          index: .25,
          rgb: [35, 139, 69]
        }, {
          index: .375,
          rgb: [65, 171, 93]
        }, {
          index: .5,
          rgb: [116, 196, 118]
        }, {
          index: .625,
          rgb: [161, 217, 155]
        }, {
          index: .75,
          rgb: [199, 233, 192]
        }, {
          index: .875,
          rgb: [229, 245, 224]
        }, {
          index: 1,
          rgb: [247, 252, 245]
        }],
        yiorrd: [{
          index: 0,
          rgb: [128, 0, 38]
        }, {
          index: .125,
          rgb: [189, 0, 38]
        }, {
          index: .25,
          rgb: [227, 26, 28]
        }, {
          index: .375,
          rgb: [252, 78, 42]
        }, {
          index: .5,
          rgb: [253, 141, 60]
        }, {
          index: .625,
          rgb: [254, 178, 76]
        }, {
          index: .75,
          rgb: [254, 217, 118]
        }, {
          index: .875,
          rgb: [255, 237, 160]
        }, {
          index: 1,
          rgb: [255, 255, 204]
        }],
        bluered: [{
          index: 0,
          rgb: [0, 0, 255]
        }, {
          index: 1,
          rgb: [255, 0, 0]
        }],
        rdbu: [{
          index: 0,
          rgb: [5, 10, 172]
        }, {
          index: .35,
          rgb: [106, 137, 247]
        }, {
          index: .5,
          rgb: [190, 190, 190]
        }, {
          index: .6,
          rgb: [220, 170, 132]
        }, {
          index: .7,
          rgb: [230, 145, 90]
        }, {
          index: 1,
          rgb: [178, 10, 28]
        }],
        picnic: [{
          index: 0,
          rgb: [0, 0, 255]
        }, {
          index: .1,
          rgb: [51, 153, 255]
        }, {
          index: .2,
          rgb: [102, 204, 255]
        }, {
          index: .3,
          rgb: [153, 204, 255]
        }, {
          index: .4,
          rgb: [204, 204, 255]
        }, {
          index: .5,
          rgb: [255, 255, 255]
        }, {
          index: .6,
          rgb: [255, 204, 255]
        }, {
          index: .7,
          rgb: [255, 153, 255]
        }, {
          index: .8,
          rgb: [255, 102, 204]
        }, {
          index: .9,
          rgb: [255, 102, 102]
        }, {
          index: 1,
          rgb: [255, 0, 0]
        }],
        rainbow: [{
          index: 0,
          rgb: [150, 0, 90]
        }, {
          index: .125,
          rgb: [0, 0, 200]
        }, {
          index: .25,
          rgb: [0, 25, 255]
        }, {
          index: .375,
          rgb: [0, 152, 255]
        }, {
          index: .5,
          rgb: [44, 255, 150]
        }, {
          index: .625,
          rgb: [151, 255, 0]
        }, {
          index: .75,
          rgb: [255, 234, 0]
        }, {
          index: .875,
          rgb: [255, 111, 0]
        }, {
          index: 1,
          rgb: [255, 0, 0]
        }],
        portland: [{
          index: 0,
          rgb: [12, 51, 131]
        }, {
          index: .25,
          rgb: [10, 136, 186]
        }, {
          index: .5,
          rgb: [242, 211, 56]
        }, {
          index: .75,
          rgb: [242, 143, 56]
        }, {
          index: 1,
          rgb: [217, 30, 30]
        }],
        blackbody: [{
          index: 0,
          rgb: [0, 0, 0]
        }, {
          index: .2,
          rgb: [230, 0, 0]
        }, {
          index: .4,
          rgb: [230, 210, 0]
        }, {
          index: .7,
          rgb: [255, 255, 255]
        }, {
          index: 1,
          rgb: [160, 200, 255]
        }],
        earth: [{
          index: 0,
          rgb: [0, 0, 130]
        }, {
          index: .1,
          rgb: [0, 180, 180]
        }, {
          index: .2,
          rgb: [40, 210, 40]
        }, {
          index: .4,
          rgb: [230, 230, 50]
        }, {
          index: .6,
          rgb: [120, 70, 20]
        }, {
          index: 1,
          rgb: [255, 255, 255]
        }],
        electric: [{
          index: 0,
          rgb: [0, 0, 0]
        }, {
          index: .15,
          rgb: [30, 0, 100]
        }, {
          index: .4,
          rgb: [120, 0, 100]
        }, {
          index: .6,
          rgb: [160, 90, 0]
        }, {
          index: .8,
          rgb: [230, 200, 0]
        }, {
          index: 1,
          rgb: [255, 250, 220]
        }],
        alpha: [{
          index: 0,
          rgb: [255, 255, 255, 0]
        }, {
          index: 1,
          rgb: [255, 255, 255, 1]
        }],
        viridis: [{
          index: 0,
          rgb: [68, 1, 84]
        }, {
          index: .13,
          rgb: [71, 44, 122]
        }, {
          index: .25,
          rgb: [59, 81, 139]
        }, {
          index: .38,
          rgb: [44, 113, 142]
        }, {
          index: .5,
          rgb: [33, 144, 141]
        }, {
          index: .63,
          rgb: [39, 173, 129]
        }, {
          index: .75,
          rgb: [92, 200, 99]
        }, {
          index: .88,
          rgb: [170, 220, 50]
        }, {
          index: 1,
          rgb: [253, 231, 37]
        }],
        inferno: [{
          index: 0,
          rgb: [0, 0, 4]
        }, {
          index: .13,
          rgb: [31, 12, 72]
        }, {
          index: .25,
          rgb: [85, 15, 109]
        }, {
          index: .38,
          rgb: [136, 34, 106]
        }, {
          index: .5,
          rgb: [186, 54, 85]
        }, {
          index: .63,
          rgb: [227, 89, 51]
        }, {
          index: .75,
          rgb: [249, 140, 10]
        }, {
          index: .88,
          rgb: [249, 201, 50]
        }, {
          index: 1,
          rgb: [252, 255, 164]
        }],
        magma: [{
          index: 0,
          rgb: [0, 0, 4]
        }, {
          index: .13,
          rgb: [28, 16, 68]
        }, {
          index: .25,
          rgb: [79, 18, 123]
        }, {
          index: .38,
          rgb: [129, 37, 129]
        }, {
          index: .5,
          rgb: [181, 54, 122]
        }, {
          index: .63,
          rgb: [229, 80, 100]
        }, {
          index: .75,
          rgb: [251, 135, 97]
        }, {
          index: .88,
          rgb: [254, 194, 135]
        }, {
          index: 1,
          rgb: [252, 253, 191]
        }],
        plasma: [{
          index: 0,
          rgb: [13, 8, 135]
        }, {
          index: .13,
          rgb: [75, 3, 161]
        }, {
          index: .25,
          rgb: [125, 3, 168]
        }, {
          index: .38,
          rgb: [168, 34, 150]
        }, {
          index: .5,
          rgb: [203, 70, 121]
        }, {
          index: .63,
          rgb: [229, 107, 93]
        }, {
          index: .75,
          rgb: [248, 148, 65]
        }, {
          index: .88,
          rgb: [253, 195, 40]
        }, {
          index: 1,
          rgb: [240, 249, 33]
        }],
        warm: [{
          index: 0,
          rgb: [125, 0, 179]
        }, {
          index: .13,
          rgb: [172, 0, 187]
        }, {
          index: .25,
          rgb: [219, 0, 170]
        }, {
          index: .38,
          rgb: [255, 0, 130]
        }, {
          index: .5,
          rgb: [255, 63, 74]
        }, {
          index: .63,
          rgb: [255, 123, 0]
        }, {
          index: .75,
          rgb: [234, 176, 0]
        }, {
          index: .88,
          rgb: [190, 228, 0]
        }, {
          index: 1,
          rgb: [147, 255, 0]
        }],
        cool: [{
          index: 0,
          rgb: [125, 0, 179]
        }, {
          index: .13,
          rgb: [116, 0, 218]
        }, {
          index: .25,
          rgb: [98, 74, 237]
        }, {
          index: .38,
          rgb: [68, 146, 231]
        }, {
          index: .5,
          rgb: [0, 204, 197]
        }, {
          index: .63,
          rgb: [0, 247, 146]
        }, {
          index: .75,
          rgb: [0, 255, 88]
        }, {
          index: .88,
          rgb: [40, 255, 8]
        }, {
          index: 1,
          rgb: [147, 255, 0]
        }],
        "rainbow-soft": [{
          index: 0,
          rgb: [125, 0, 179]
        }, {
          index: .1,
          rgb: [199, 0, 180]
        }, {
          index: .2,
          rgb: [255, 0, 121]
        }, {
          index: .3,
          rgb: [255, 108, 0]
        }, {
          index: .4,
          rgb: [222, 194, 0]
        }, {
          index: .5,
          rgb: [150, 255, 0]
        }, {
          index: .6,
          rgb: [0, 255, 55]
        }, {
          index: .7,
          rgb: [0, 246, 150]
        }, {
          index: .8,
          rgb: [50, 167, 222]
        }, {
          index: .9,
          rgb: [103, 51, 235]
        }, {
          index: 1,
          rgb: [124, 0, 186]
        }],
        bathymetry: [{
          index: 0,
          rgb: [40, 26, 44]
        }, {
          index: .13,
          rgb: [59, 49, 90]
        }, {
          index: .25,
          rgb: [64, 76, 139]
        }, {
          index: .38,
          rgb: [63, 110, 151]
        }, {
          index: .5,
          rgb: [72, 142, 158]
        }, {
          index: .63,
          rgb: [85, 174, 163]
        }, {
          index: .75,
          rgb: [120, 206, 163]
        }, {
          index: .88,
          rgb: [187, 230, 172]
        }, {
          index: 1,
          rgb: [253, 254, 204]
        }],
        cdom: [{
          index: 0,
          rgb: [47, 15, 62]
        }, {
          index: .13,
          rgb: [87, 23, 86]
        }, {
          index: .25,
          rgb: [130, 28, 99]
        }, {
          index: .38,
          rgb: [171, 41, 96]
        }, {
          index: .5,
          rgb: [206, 67, 86]
        }, {
          index: .63,
          rgb: [230, 106, 84]
        }, {
          index: .75,
          rgb: [242, 149, 103]
        }, {
          index: .88,
          rgb: [249, 193, 135]
        }, {
          index: 1,
          rgb: [254, 237, 176]
        }],
        chlorophyll: [{
          index: 0,
          rgb: [18, 36, 20]
        }, {
          index: .13,
          rgb: [25, 63, 41]
        }, {
          index: .25,
          rgb: [24, 91, 59]
        }, {
          index: .38,
          rgb: [13, 119, 72]
        }, {
          index: .5,
          rgb: [18, 148, 80]
        }, {
          index: .63,
          rgb: [80, 173, 89]
        }, {
          index: .75,
          rgb: [132, 196, 122]
        }, {
          index: .88,
          rgb: [175, 221, 162]
        }, {
          index: 1,
          rgb: [215, 249, 208]
        }],
        density: [{
          index: 0,
          rgb: [54, 14, 36]
        }, {
          index: .13,
          rgb: [89, 23, 80]
        }, {
          index: .25,
          rgb: [110, 45, 132]
        }, {
          index: .38,
          rgb: [120, 77, 178]
        }, {
          index: .5,
          rgb: [120, 113, 213]
        }, {
          index: .63,
          rgb: [115, 151, 228]
        }, {
          index: .75,
          rgb: [134, 185, 227]
        }, {
          index: .88,
          rgb: [177, 214, 227]
        }, {
          index: 1,
          rgb: [230, 241, 241]
        }],
        "freesurface-blue": [{
          index: 0,
          rgb: [30, 4, 110]
        }, {
          index: .13,
          rgb: [47, 14, 176]
        }, {
          index: .25,
          rgb: [41, 45, 236]
        }, {
          index: .38,
          rgb: [25, 99, 212]
        }, {
          index: .5,
          rgb: [68, 131, 200]
        }, {
          index: .63,
          rgb: [114, 156, 197]
        }, {
          index: .75,
          rgb: [157, 181, 203]
        }, {
          index: .88,
          rgb: [200, 208, 216]
        }, {
          index: 1,
          rgb: [241, 237, 236]
        }],
        "freesurface-red": [{
          index: 0,
          rgb: [60, 9, 18]
        }, {
          index: .13,
          rgb: [100, 17, 27]
        }, {
          index: .25,
          rgb: [142, 20, 29]
        }, {
          index: .38,
          rgb: [177, 43, 27]
        }, {
          index: .5,
          rgb: [192, 87, 63]
        }, {
          index: .63,
          rgb: [205, 125, 105]
        }, {
          index: .75,
          rgb: [216, 162, 148]
        }, {
          index: .88,
          rgb: [227, 199, 193]
        }, {
          index: 1,
          rgb: [241, 237, 236]
        }],
        oxygen: [{
          index: 0,
          rgb: [64, 5, 5]
        }, {
          index: .13,
          rgb: [106, 6, 15]
        }, {
          index: .25,
          rgb: [144, 26, 7]
        }, {
          index: .38,
          rgb: [168, 64, 3]
        }, {
          index: .5,
          rgb: [188, 100, 4]
        }, {
          index: .63,
          rgb: [206, 136, 11]
        }, {
          index: .75,
          rgb: [220, 174, 25]
        }, {
          index: .88,
          rgb: [231, 215, 44]
        }, {
          index: 1,
          rgb: [248, 254, 105]
        }],
        par: [{
          index: 0,
          rgb: [51, 20, 24]
        }, {
          index: .13,
          rgb: [90, 32, 35]
        }, {
          index: .25,
          rgb: [129, 44, 34]
        }, {
          index: .38,
          rgb: [159, 68, 25]
        }, {
          index: .5,
          rgb: [182, 99, 19]
        }, {
          index: .63,
          rgb: [199, 134, 22]
        }, {
          index: .75,
          rgb: [212, 171, 35]
        }, {
          index: .88,
          rgb: [221, 210, 54]
        }, {
          index: 1,
          rgb: [225, 253, 75]
        }],
        phase: [{
          index: 0,
          rgb: [145, 105, 18]
        }, {
          index: .13,
          rgb: [184, 71, 38]
        }, {
          index: .25,
          rgb: [186, 58, 115]
        }, {
          index: .38,
          rgb: [160, 71, 185]
        }, {
          index: .5,
          rgb: [110, 97, 218]
        }, {
          index: .63,
          rgb: [50, 123, 164]
        }, {
          index: .75,
          rgb: [31, 131, 110]
        }, {
          index: .88,
          rgb: [77, 129, 34]
        }, {
          index: 1,
          rgb: [145, 105, 18]
        }],
        salinity: [{
          index: 0,
          rgb: [42, 24, 108]
        }, {
          index: .13,
          rgb: [33, 50, 162]
        }, {
          index: .25,
          rgb: [15, 90, 145]
        }, {
          index: .38,
          rgb: [40, 118, 137]
        }, {
          index: .5,
          rgb: [59, 146, 135]
        }, {
          index: .63,
          rgb: [79, 175, 126]
        }, {
          index: .75,
          rgb: [120, 203, 104]
        }, {
          index: .88,
          rgb: [193, 221, 100]
        }, {
          index: 1,
          rgb: [253, 239, 154]
        }],
        temperature: [{
          index: 0,
          rgb: [4, 35, 51]
        }, {
          index: .13,
          rgb: [23, 51, 122]
        }, {
          index: .25,
          rgb: [85, 59, 157]
        }, {
          index: .38,
          rgb: [129, 79, 143]
        }, {
          index: .5,
          rgb: [175, 95, 130]
        }, {
          index: .63,
          rgb: [222, 112, 101]
        }, {
          index: .75,
          rgb: [249, 146, 66]
        }, {
          index: .88,
          rgb: [249, 196, 65]
        }, {
          index: 1,
          rgb: [232, 250, 91]
        }],
        turbidity: [{
          index: 0,
          rgb: [34, 31, 27]
        }, {
          index: .13,
          rgb: [65, 50, 41]
        }, {
          index: .25,
          rgb: [98, 69, 52]
        }, {
          index: .38,
          rgb: [131, 89, 57]
        }, {
          index: .5,
          rgb: [161, 112, 59]
        }, {
          index: .63,
          rgb: [185, 140, 66]
        }, {
          index: .75,
          rgb: [202, 174, 88]
        }, {
          index: .88,
          rgb: [216, 209, 126]
        }, {
          index: 1,
          rgb: [233, 246, 171]
        }],
        "velocity-blue": [{
          index: 0,
          rgb: [17, 32, 64]
        }, {
          index: .13,
          rgb: [35, 52, 116]
        }, {
          index: .25,
          rgb: [29, 81, 156]
        }, {
          index: .38,
          rgb: [31, 113, 162]
        }, {
          index: .5,
          rgb: [50, 144, 169]
        }, {
          index: .63,
          rgb: [87, 173, 176]
        }, {
          index: .75,
          rgb: [149, 196, 189]
        }, {
          index: .88,
          rgb: [203, 221, 211]
        }, {
          index: 1,
          rgb: [254, 251, 230]
        }],
        "velocity-green": [{
          index: 0,
          rgb: [23, 35, 19]
        }, {
          index: .13,
          rgb: [24, 64, 38]
        }, {
          index: .25,
          rgb: [11, 95, 45]
        }, {
          index: .38,
          rgb: [39, 123, 35]
        }, {
          index: .5,
          rgb: [95, 146, 12]
        }, {
          index: .63,
          rgb: [152, 165, 18]
        }, {
          index: .75,
          rgb: [201, 186, 69]
        }, {
          index: .88,
          rgb: [233, 216, 137]
        }, {
          index: 1,
          rgb: [255, 253, 205]
        }],
        cubehelix: [{
          index: 0,
          rgb: [0, 0, 0]
        }, {
          index: .07,
          rgb: [22, 5, 59]
        }, {
          index: .13,
          rgb: [60, 4, 105]
        }, {
          index: .2,
          rgb: [109, 1, 135]
        }, {
          index: .27,
          rgb: [161, 0, 147]
        }, {
          index: .33,
          rgb: [210, 2, 142]
        }, {
          index: .4,
          rgb: [251, 11, 123]
        }, {
          index: .47,
          rgb: [255, 29, 97]
        }, {
          index: .53,
          rgb: [255, 54, 69]
        }, {
          index: .6,
          rgb: [255, 85, 46]
        }, {
          index: .67,
          rgb: [255, 120, 34]
        }, {
          index: .73,
          rgb: [255, 157, 37]
        }, {
          index: .8,
          rgb: [241, 191, 57]
        }, {
          index: .87,
          rgb: [224, 220, 93]
        }, {
          index: .93,
          rgb: [218, 241, 142]
        }, {
          index: 1,
          rgb: [227, 253, 198]
        }]
      };
    }, {}],
    132: [function (t, e, r) {
      "use strict";

      var n = t("./colorScale"),
          i = t("lerp");

      function a(t) {
        return [t[0] / 255, t[1] / 255, t[2] / 255, t[3]];
      }

      function o(t) {
        for (var e, r = "#", n = 0; n < 3; ++n) {
          r += ("00" + (e = (e = t[n]).toString(16))).substr(e.length);
        }

        return r;
      }

      function s(t) {
        return "rgba(" + t.join(",") + ")";
      }

      e.exports = function (t) {
        var e, r, l, c, u, f, h, p, d, m;
        t || (t = {});
        p = (t.nshades || 72) - 1, h = t.format || "hex", (f = t.colormap) || (f = "jet");

        if ("string" == typeof f) {
          if (f = f.toLowerCase(), !n[f]) throw Error(f + " not a supported colorscale");
          u = n[f];
        } else {
          if (!Array.isArray(f)) throw Error("unsupported colormap option", f);
          u = f.slice();
        }

        if (u.length > p + 1) throw new Error(f + " map requires nshades to be at least size " + u.length);
        d = Array.isArray(t.alpha) ? 2 !== t.alpha.length ? [1, 1] : t.alpha.slice() : "number" == typeof t.alpha ? [t.alpha, t.alpha] : [1, 1];
        e = u.map(function (t) {
          return Math.round(t.index * p);
        }), d[0] = Math.min(Math.max(d[0], 0), 1), d[1] = Math.min(Math.max(d[1], 0), 1);
        var g = u.map(function (t, e) {
          var r = u[e].index,
              n = u[e].rgb.slice();
          return 4 === n.length && n[3] >= 0 && n[3] <= 1 || (n[3] = d[0] + (d[1] - d[0]) * r), n;
        }),
            v = [];

        for (m = 0; m < e.length - 1; ++m) {
          c = e[m + 1] - e[m], r = g[m], l = g[m + 1];

          for (var y = 0; y < c; y++) {
            var x = y / c;
            v.push([Math.round(i(r[0], l[0], x)), Math.round(i(r[1], l[1], x)), Math.round(i(r[2], l[2], x)), i(r[3], l[3], x)]);
          }
        }

        v.push(u[u.length - 1].rgb.concat(d[1])), "hex" === h ? v = v.map(o) : "rgbaString" === h ? v = v.map(s) : "float" === h && (v = v.map(a));
        return v;
      };
    }, {
      "./colorScale": 131,
      lerp: 451
    }],
    133: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, a) {
        var o = n(e, r, a);

        if (0 === o) {
          var s = i(n(t, e, r)),
              c = i(n(t, e, a));

          if (s === c) {
            if (0 === s) {
              var u = l(t, e, r),
                  f = l(t, e, a);
              return u === f ? 0 : u ? 1 : -1;
            }

            return 0;
          }

          return 0 === c ? s > 0 || l(t, e, a) ? -1 : 1 : 0 === s ? c > 0 || l(t, e, r) ? 1 : -1 : i(c - s);
        }

        var h = n(t, e, r);
        return h > 0 ? o > 0 && n(t, e, a) > 0 ? 1 : -1 : h < 0 ? o > 0 || n(t, e, a) > 0 ? 1 : -1 : n(t, e, a) > 0 || l(t, e, r) ? 1 : -1;
      };

      var n = t("robust-orientation"),
          i = t("signum"),
          a = t("two-sum"),
          o = t("robust-product"),
          s = t("robust-sum");

      function l(t, e, r) {
        var n = a(t[0], -e[0]),
            i = a(t[1], -e[1]),
            l = a(r[0], -e[0]),
            c = a(r[1], -e[1]),
            u = s(o(n, l), o(i, c));
        return u[u.length - 1] >= 0;
      }
    }, {
      "robust-orientation": 540,
      "robust-product": 541,
      "robust-sum": 545,
      signum: 547,
      "two-sum": 597
    }],
    134: [function (t, e, r) {
      e.exports = function (t, e) {
        var r = t.length,
            a = t.length - e.length;
        if (a) return a;

        switch (r) {
          case 0:
            return 0;

          case 1:
            return t[0] - e[0];

          case 2:
            return t[0] + t[1] - e[0] - e[1] || n(t[0], t[1]) - n(e[0], e[1]);

          case 3:
            var o = t[0] + t[1],
                s = e[0] + e[1];
            if (a = o + t[2] - (s + e[2])) return a;
            var l = n(t[0], t[1]),
                c = n(e[0], e[1]);
            return n(l, t[2]) - n(c, e[2]) || n(l + t[2], o) - n(c + e[2], s);

          case 4:
            var u = t[0],
                f = t[1],
                h = t[2],
                p = t[3],
                d = e[0],
                m = e[1],
                g = e[2],
                v = e[3];
            return u + f + h + p - (d + m + g + v) || n(u, f, h, p) - n(d, m, g, v, d) || n(u + f, u + h, u + p, f + h, f + p, h + p) - n(d + m, d + g, d + v, m + g, m + v, g + v) || n(u + f + h, u + f + p, u + h + p, f + h + p) - n(d + m + g, d + m + v, d + g + v, m + g + v);

          default:
            for (var y = t.slice().sort(i), x = e.slice().sort(i), b = 0; b < r; ++b) {
              if (a = y[b] - x[b]) return a;
            }

            return 0;
        }
      };

      var n = Math.min;

      function i(t, e) {
        return t - e;
      }
    }, {}],
    135: [function (t, e, r) {
      "use strict";

      var n = t("compare-cell"),
          i = t("cell-orientation");

      e.exports = function (t, e) {
        return n(t, e) || i(t) - i(e);
      };
    }, {
      "cell-orientation": 118,
      "compare-cell": 134
    }],
    136: [function (t, e, r) {
      "use strict";

      var n = t("./lib/ch1d"),
          i = t("./lib/ch2d"),
          a = t("./lib/chnd");

      e.exports = function (t) {
        var e = t.length;
        if (0 === e) return [];
        if (1 === e) return [[0]];
        var r = t[0].length;
        if (0 === r) return [];
        if (1 === r) return n(t);
        if (2 === r) return i(t);
        return a(t, r);
      };
    }, {
      "./lib/ch1d": 137,
      "./lib/ch2d": 138,
      "./lib/chnd": 139
    }],
    137: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        for (var e = 0, r = 0, n = 1; n < t.length; ++n) {
          t[n][0] < t[e][0] && (e = n), t[n][0] > t[r][0] && (r = n);
        }

        return e < r ? [[e], [r]] : e > r ? [[r], [e]] : [[e]];
      };
    }, {}],
    138: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        var e = n(t),
            r = e.length;
        if (r <= 2) return [];

        for (var i = new Array(r), a = e[r - 1], o = 0; o < r; ++o) {
          var s = e[o];
          i[o] = [a, s], a = s;
        }

        return i;
      };

      var n = t("monotone-convex-hull-2d");
    }, {
      "monotone-convex-hull-2d": 461
    }],
    139: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        try {
          return n(t, !0);
        } catch (o) {
          var r = i(t);
          if (r.length <= e) return [];

          var a = function (t, e) {
            for (var r = t.length, n = new Array(r), i = 0; i < e.length; ++i) {
              n[i] = t[e[i]];
            }

            var a = e.length;

            for (i = 0; i < r; ++i) {
              e.indexOf(i) < 0 && (n[a++] = t[i]);
            }

            return n;
          }(t, r);

          return function (t, e) {
            for (var r = t.length, n = e.length, i = 0; i < r; ++i) {
              for (var a = t[i], o = 0; o < a.length; ++o) {
                var s = a[o];
                if (s < n) a[o] = e[s];else {
                  s -= n;

                  for (var l = 0; l < n; ++l) {
                    s >= e[l] && (s += 1);
                  }

                  a[o] = s;
                }
              }
            }

            return t;
          }(n(a, !0), r);
        }
      };

      var n = t("incremental-convex-hull"),
          i = t("affine-hull");
    }, {
      "affine-hull": 68,
      "incremental-convex-hull": 437
    }],
    140: [function (t, e, r) {
      e.exports = {
        AFG: "afghan",
        ALA: "\\b\\wland",
        ALB: "albania",
        DZA: "algeria",
        ASM: "^(?=.*americ).*samoa",
        AND: "andorra",
        AGO: "angola",
        AIA: "anguill?a",
        ATA: "antarctica",
        ATG: "antigua",
        ARG: "argentin",
        ARM: "armenia",
        ABW: "^(?!.*bonaire).*\\baruba",
        AUS: "australia",
        AUT: "^(?!.*hungary).*austria|\\baustri.*\\bemp",
        AZE: "azerbaijan",
        BHS: "bahamas",
        BHR: "bahrain",
        BGD: "bangladesh|^(?=.*east).*paki?stan",
        BRB: "barbados",
        BLR: "belarus|byelo",
        BEL: "^(?!.*luxem).*belgium",
        BLZ: "belize|^(?=.*british).*honduras",
        BEN: "benin|dahome",
        BMU: "bermuda",
        BTN: "bhutan",
        BOL: "bolivia",
        BES: "^(?=.*bonaire).*eustatius|^(?=.*carib).*netherlands|\\bbes.?islands",
        BIH: "herzegovina|bosnia",
        BWA: "botswana|bechuana",
        BVT: "bouvet",
        BRA: "brazil",
        IOT: "british.?indian.?ocean",
        BRN: "brunei",
        BGR: "bulgaria",
        BFA: "burkina|\\bfaso|upper.?volta",
        BDI: "burundi",
        CPV: "verde",
        KHM: "cambodia|kampuchea|khmer",
        CMR: "cameroon",
        CAN: "canada",
        CYM: "cayman",
        CAF: "\\bcentral.african.republic",
        TCD: "\\bchad",
        CHL: "\\bchile",
        CHN: "^(?!.*\\bmac)(?!.*\\bhong)(?!.*\\btai)(?!.*\\brep).*china|^(?=.*peo)(?=.*rep).*china",
        CXR: "christmas",
        CCK: "\\bcocos|keeling",
        COL: "colombia",
        COM: "comoro",
        COG: "^(?!.*\\bdem)(?!.*\\bd[\\.]?r)(?!.*kinshasa)(?!.*zaire)(?!.*belg)(?!.*l.opoldville)(?!.*free).*\\bcongo",
        COK: "\\bcook",
        CRI: "costa.?rica",
        CIV: "ivoire|ivory",
        HRV: "croatia",
        CUB: "\\bcuba",
        CUW: "^(?!.*bonaire).*\\bcura(c|\xe7)ao",
        CYP: "cyprus",
        CSK: "czechoslovakia",
        CZE: "^(?=.*rep).*czech|czechia|bohemia",
        COD: "\\bdem.*congo|congo.*\\bdem|congo.*\\bd[\\.]?r|\\bd[\\.]?r.*congo|belgian.?congo|congo.?free.?state|kinshasa|zaire|l.opoldville|drc|droc|rdc",
        DNK: "denmark",
        DJI: "djibouti",
        DMA: "dominica(?!n)",
        DOM: "dominican.rep",
        ECU: "ecuador",
        EGY: "egypt",
        SLV: "el.?salvador",
        GNQ: "guine.*eq|eq.*guine|^(?=.*span).*guinea",
        ERI: "eritrea",
        EST: "estonia",
        ETH: "ethiopia|abyssinia",
        FLK: "falkland|malvinas",
        FRO: "faroe|faeroe",
        FJI: "fiji",
        FIN: "finland",
        FRA: "^(?!.*\\bdep)(?!.*martinique).*france|french.?republic|\\bgaul",
        GUF: "^(?=.*french).*guiana",
        PYF: "french.?polynesia|tahiti",
        ATF: "french.?southern",
        GAB: "gabon",
        GMB: "gambia",
        GEO: "^(?!.*south).*georgia",
        DDR: "german.?democratic.?republic|democratic.?republic.*germany|east.germany",
        DEU: "^(?!.*east).*germany|^(?=.*\\bfed.*\\brep).*german",
        GHA: "ghana|gold.?coast",
        GIB: "gibraltar",
        GRC: "greece|hellenic|hellas",
        GRL: "greenland",
        GRD: "grenada",
        GLP: "guadeloupe",
        GUM: "\\bguam",
        GTM: "guatemala",
        GGY: "guernsey",
        GIN: "^(?!.*eq)(?!.*span)(?!.*bissau)(?!.*portu)(?!.*new).*guinea",
        GNB: "bissau|^(?=.*portu).*guinea",
        GUY: "guyana|british.?guiana",
        HTI: "haiti",
        HMD: "heard.*mcdonald",
        VAT: "holy.?see|vatican|papal.?st",
        HND: "^(?!.*brit).*honduras",
        HKG: "hong.?kong",
        HUN: "^(?!.*austr).*hungary",
        ISL: "iceland",
        IND: "india(?!.*ocea)",
        IDN: "indonesia",
        IRN: "\\biran|persia",
        IRQ: "\\biraq|mesopotamia",
        IRL: "(^ireland)|(^republic.*ireland)",
        IMN: "^(?=.*isle).*\\bman",
        ISR: "israel",
        ITA: "italy",
        JAM: "jamaica",
        JPN: "japan",
        JEY: "jersey",
        JOR: "jordan",
        KAZ: "kazak",
        KEN: "kenya|british.?east.?africa|east.?africa.?prot",
        KIR: "kiribati",
        PRK: "^(?=.*democrat|people|north|d.*p.*.r).*\\bkorea|dprk|korea.*(d.*p.*r)",
        KWT: "kuwait",
        KGZ: "kyrgyz|kirghiz",
        LAO: "\\blaos?\\b",
        LVA: "latvia",
        LBN: "lebanon",
        LSO: "lesotho|basuto",
        LBR: "liberia",
        LBY: "libya",
        LIE: "liechtenstein",
        LTU: "lithuania",
        LUX: "^(?!.*belg).*luxem",
        MAC: "maca(o|u)",
        MDG: "madagascar|malagasy",
        MWI: "malawi|nyasa",
        MYS: "malaysia",
        MDV: "maldive",
        MLI: "\\bmali\\b",
        MLT: "\\bmalta",
        MHL: "marshall",
        MTQ: "martinique",
        MRT: "mauritania",
        MUS: "mauritius",
        MYT: "\\bmayotte",
        MEX: "\\bmexic",
        FSM: "fed.*micronesia|micronesia.*fed",
        MCO: "monaco",
        MNG: "mongolia",
        MNE: "^(?!.*serbia).*montenegro",
        MSR: "montserrat",
        MAR: "morocco|\\bmaroc",
        MOZ: "mozambique",
        MMR: "myanmar|burma",
        NAM: "namibia",
        NRU: "nauru",
        NPL: "nepal",
        NLD: "^(?!.*\\bant)(?!.*\\bcarib).*netherlands",
        ANT: "^(?=.*\\bant).*(nether|dutch)",
        NCL: "new.?caledonia",
        NZL: "new.?zealand",
        NIC: "nicaragua",
        NER: "\\bniger(?!ia)",
        NGA: "nigeria",
        NIU: "niue",
        NFK: "norfolk",
        MNP: "mariana",
        NOR: "norway",
        OMN: "\\boman|trucial",
        PAK: "^(?!.*east).*paki?stan",
        PLW: "palau",
        PSE: "palestin|\\bgaza|west.?bank",
        PAN: "panama",
        PNG: "papua|new.?guinea",
        PRY: "paraguay",
        PER: "peru",
        PHL: "philippines",
        PCN: "pitcairn",
        POL: "poland",
        PRT: "portugal",
        PRI: "puerto.?rico",
        QAT: "qatar",
        KOR: "^(?!.*d.*p.*r)(?!.*democrat)(?!.*people)(?!.*north).*\\bkorea(?!.*d.*p.*r)",
        MDA: "moldov|b(a|e)ssarabia",
        REU: "r(e|\xe9)union",
        ROU: "r(o|u|ou)mania",
        RUS: "\\brussia|soviet.?union|u\\.?s\\.?s\\.?r|socialist.?republics",
        RWA: "rwanda",
        BLM: "barth(e|\xe9)lemy",
        SHN: "helena",
        KNA: "kitts|\\bnevis",
        LCA: "\\blucia",
        MAF: "^(?=.*collectivity).*martin|^(?=.*france).*martin(?!ique)|^(?=.*french).*martin(?!ique)",
        SPM: "miquelon",
        VCT: "vincent",
        WSM: "^(?!.*amer).*samoa",
        SMR: "san.?marino",
        STP: "\\bs(a|\xe3)o.?tom(e|\xe9)",
        SAU: "\\bsa\\w*.?arabia",
        SEN: "senegal",
        SRB: "^(?!.*monte).*serbia",
        SYC: "seychell",
        SLE: "sierra",
        SGP: "singapore",
        SXM: "^(?!.*martin)(?!.*saba).*maarten",
        SVK: "^(?!.*cze).*slovak",
        SVN: "slovenia",
        SLB: "solomon",
        SOM: "somali",
        ZAF: "south.africa|s\\\\..?africa",
        SGS: "south.?georgia|sandwich",
        SSD: "\\bs\\w*.?sudan",
        ESP: "spain",
        LKA: "sri.?lanka|ceylon",
        SDN: "^(?!.*\\bs(?!u)).*sudan",
        SUR: "surinam|dutch.?guiana",
        SJM: "svalbard",
        SWZ: "swaziland",
        SWE: "sweden",
        CHE: "switz|swiss",
        SYR: "syria",
        TWN: "taiwan|taipei|formosa|^(?!.*peo)(?=.*rep).*china",
        TJK: "tajik",
        THA: "thailand|\\bsiam",
        MKD: "macedonia|fyrom",
        TLS: "^(?=.*leste).*timor|^(?=.*east).*timor",
        TGO: "togo",
        TKL: "tokelau",
        TON: "tonga",
        TTO: "trinidad|tobago",
        TUN: "tunisia",
        TUR: "turkey",
        TKM: "turkmen",
        TCA: "turks",
        TUV: "tuvalu",
        UGA: "uganda",
        UKR: "ukrain",
        ARE: "emirates|^u\\.?a\\.?e\\.?$|united.?arab.?em",
        GBR: "united.?kingdom|britain|^u\\.?k\\.?$",
        TZA: "tanzania",
        USA: "united.?states\\b(?!.*islands)|\\bu\\.?s\\.?a\\.?\\b|^\\s*u\\.?s\\.?\\b(?!.*islands)",
        UMI: "minor.?outlying.?is",
        URY: "uruguay",
        UZB: "uzbek",
        VUT: "vanuatu|new.?hebrides",
        VEN: "venezuela",
        VNM: "^(?!.*republic).*viet.?nam|^(?=.*socialist).*viet.?nam",
        VGB: "^(?=.*\\bu\\.?\\s?k).*virgin|^(?=.*brit).*virgin|^(?=.*kingdom).*virgin",
        VIR: "^(?=.*\\bu\\.?\\s?s).*virgin|^(?=.*states).*virgin",
        WLF: "futuna|wallis",
        ESH: "western.sahara",
        YEM: "^(?!.*arab)(?!.*north)(?!.*sana)(?!.*peo)(?!.*dem)(?!.*south)(?!.*aden)(?!.*\\bp\\.?d\\.?r).*yemen",
        YMD: "^(?=.*peo).*yemen|^(?!.*rep)(?=.*dem).*yemen|^(?=.*south).*yemen|^(?=.*aden).*yemen|^(?=.*\\bp\\.?d\\.?r).*yemen",
        YUG: "yugoslavia",
        ZMB: "zambia|northern.?rhodesia",
        EAZ: "zanzibar",
        ZWE: "zimbabwe|^(?!.*northern).*rhodesia"
      };
    }, {}],
    141: [function (t, e, r) {
      e.exports = ["xx-small", "x-small", "small", "medium", "large", "x-large", "xx-large", "larger", "smaller"];
    }, {}],
    142: [function (t, e, r) {
      e.exports = ["normal", "condensed", "semi-condensed", "extra-condensed", "ultra-condensed", "expanded", "semi-expanded", "extra-expanded", "ultra-expanded"];
    }, {}],
    143: [function (t, e, r) {
      e.exports = ["normal", "italic", "oblique"];
    }, {}],
    144: [function (t, e, r) {
      e.exports = ["normal", "bold", "bolder", "lighter", "100", "200", "300", "400", "500", "600", "700", "800", "900"];
    }, {}],
    145: [function (t, e, r) {
      "use strict";

      e.exports = {
        parse: t("./parse"),
        stringify: t("./stringify")
      };
    }, {
      "./parse": 147,
      "./stringify": 148
    }],
    146: [function (t, e, r) {
      "use strict";

      var n = t("css-font-size-keywords");
      e.exports = {
        isSize: function isSize(t) {
          return /^[\d\.]/.test(t) || -1 !== t.indexOf("/") || -1 !== n.indexOf(t);
        }
      };
    }, {
      "css-font-size-keywords": 141
    }],
    147: [function (t, e, r) {
      "use strict";

      var n = t("unquote"),
          i = t("css-global-keywords"),
          a = t("css-system-font-keywords"),
          o = t("css-font-weight-keywords"),
          s = t("css-font-style-keywords"),
          l = t("css-font-stretch-keywords"),
          c = t("string-split-by"),
          u = t("./lib/util").isSize;
      e.exports = h;
      var f = h.cache = {};

      function h(t) {
        if ("string" != typeof t) throw new Error("Font argument must be a string.");
        if (f[t]) return f[t];
        if ("" === t) throw new Error("Cannot parse an empty string.");
        if (-1 !== a.indexOf(t)) return f[t] = {
          system: t
        };

        for (var e, r = {
          style: "normal",
          variant: "normal",
          weight: "normal",
          stretch: "normal",
          lineHeight: "normal",
          size: "1rem",
          family: ["serif"]
        }, h = c(t, /\s+/); e = h.shift();) {
          if (-1 !== i.indexOf(e)) return ["style", "variant", "weight", "stretch"].forEach(function (t) {
            r[t] = e;
          }), f[t] = r;
          if (-1 === s.indexOf(e)) {
            if ("normal" !== e && "small-caps" !== e) {
              if (-1 === l.indexOf(e)) {
                if (-1 === o.indexOf(e)) {
                  if (u(e)) {
                    var d = c(e, "/");
                    if (r.size = d[0], null != d[1] ? r.lineHeight = p(d[1]) : "/" === h[0] && (h.shift(), r.lineHeight = p(h.shift())), !h.length) throw new Error("Missing required font-family.");
                    return r.family = c(h.join(" "), /\s*,\s*/).map(n), f[t] = r;
                  }

                  throw new Error("Unknown or unsupported font token: " + e);
                }

                r.weight = e;
              } else r.stretch = e;
            } else r.variant = e;
          } else r.style = e;
        }

        throw new Error("Missing required font-size.");
      }

      function p(t) {
        var e = parseFloat(t);
        return e.toString() === t ? e : t;
      }
    }, {
      "./lib/util": 146,
      "css-font-stretch-keywords": 142,
      "css-font-style-keywords": 143,
      "css-font-weight-keywords": 144,
      "css-global-keywords": 149,
      "css-system-font-keywords": 150,
      "string-split-by": 581,
      unquote: 612
    }],
    148: [function (t, e, r) {
      "use strict";

      var n = t("pick-by-alias"),
          i = t("./lib/util").isSize,
          a = m(t("css-global-keywords")),
          o = m(t("css-system-font-keywords")),
          s = m(t("css-font-weight-keywords")),
          l = m(t("css-font-style-keywords")),
          c = m(t("css-font-stretch-keywords")),
          u = {
        normal: 1,
        "small-caps": 1
      },
          f = {
        serif: 1,
        "sans-serif": 1,
        monospace: 1,
        cursive: 1,
        fantasy: 1,
        "system-ui": 1
      },
          h = "1rem",
          p = "serif";

      function d(t, e) {
        if (t && !e[t] && !a[t]) throw Error("Unknown keyword `" + t + "`");
        return t;
      }

      function m(t) {
        for (var e = {}, r = 0; r < t.length; r++) {
          e[t[r]] = 1;
        }

        return e;
      }

      e.exports = function (t) {
        if ((t = n(t, {
          style: "style fontstyle fontStyle font-style slope distinction",
          variant: "variant font-variant fontVariant fontvariant var capitalization",
          weight: "weight w font-weight fontWeight fontweight",
          stretch: "stretch font-stretch fontStretch fontstretch width",
          size: "size s font-size fontSize fontsize height em emSize",
          lineHeight: "lh line-height lineHeight lineheight leading",
          family: "font family fontFamily font-family fontfamily type typeface face",
          system: "system reserved default global"
        })).system) return t.system && d(t.system, o), t.system;
        if (d(t.style, l), d(t.variant, u), d(t.weight, s), d(t.stretch, c), null == t.size && (t.size = h), "number" == typeof t.size && (t.size += "px"), !i) throw Error("Bad size value `" + t.size + "`");
        t.family || (t.family = p), Array.isArray(t.family) && (t.family.length || (t.family = [p]), t.family = t.family.map(function (t) {
          return f[t] ? t : '"' + t + '"';
        }).join(", "));
        var e = [];
        return e.push(t.style), t.variant !== t.style && e.push(t.variant), t.weight !== t.variant && t.weight !== t.style && e.push(t.weight), t.stretch !== t.weight && t.stretch !== t.variant && t.stretch !== t.style && e.push(t.stretch), e.push(t.size + (null == t.lineHeight || "normal" === t.lineHeight || t.lineHeight + "" == "1" ? "" : "/" + t.lineHeight)), e.push(t.family), e.filter(Boolean).join(" ");
      };
    }, {
      "./lib/util": 146,
      "css-font-stretch-keywords": 142,
      "css-font-style-keywords": 143,
      "css-font-weight-keywords": 144,
      "css-global-keywords": 149,
      "css-system-font-keywords": 150,
      "pick-by-alias": 490
    }],
    149: [function (t, e, r) {
      e.exports = ["inherit", "initial", "unset"];
    }, {}],
    150: [function (t, e, r) {
      e.exports = ["caption", "icon", "menu", "message-box", "small-caption", "status-bar"];
    }, {}],
    151: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, n, i, a) {
        var o = i - 1,
            s = i * i,
            l = o * o,
            c = (1 + 2 * i) * l,
            u = i * l,
            f = s * (3 - 2 * i),
            h = s * o;

        if (t.length) {
          a || (a = new Array(t.length));

          for (var p = t.length - 1; p >= 0; --p) {
            a[p] = c * t[p] + u * e[p] + f * r[p] + h * n[p];
          }

          return a;
        }

        return c * t + u * e + f * r + h * n;
      }, e.exports.derivative = function (t, e, r, n, i, a) {
        var o = 6 * i * i - 6 * i,
            s = 3 * i * i - 4 * i + 1,
            l = -6 * i * i + 6 * i,
            c = 3 * i * i - 2 * i;

        if (t.length) {
          a || (a = new Array(t.length));

          for (var u = t.length - 1; u >= 0; --u) {
            a[u] = o * t[u] + s * e[u] + l * r[u] + c * n[u];
          }

          return a;
        }

        return o * t + s * e + l * r[u] + c * n;
      };
    }, {}],
    152: [function (t, e, r) {
      "use strict";

      var n = t("./lib/thunk.js");

      function i() {
        this.argTypes = [], this.shimArgs = [], this.arrayArgs = [], this.arrayBlockIndices = [], this.scalarArgs = [], this.offsetArgs = [], this.offsetArgIndex = [], this.indexArgs = [], this.shapeArgs = [], this.funcName = "", this.pre = null, this.body = null, this.post = null, this.debug = !1;
      }

      e.exports = function (t) {
        var e = new i();
        e.pre = t.pre, e.body = t.body, e.post = t.post;
        var r = t.args.slice(0);
        e.argTypes = r;

        for (var a = 0; a < r.length; ++a) {
          var o = r[a];

          if ("array" === o || "object" == _typeof(o) && o.blockIndices) {
            if (e.argTypes[a] = "array", e.arrayArgs.push(a), e.arrayBlockIndices.push(o.blockIndices ? o.blockIndices : 0), e.shimArgs.push("array" + a), a < e.pre.args.length && e.pre.args[a].count > 0) throw new Error("cwise: pre() block may not reference array args");
            if (a < e.post.args.length && e.post.args[a].count > 0) throw new Error("cwise: post() block may not reference array args");
          } else if ("scalar" === o) e.scalarArgs.push(a), e.shimArgs.push("scalar" + a);else if ("index" === o) {
            if (e.indexArgs.push(a), a < e.pre.args.length && e.pre.args[a].count > 0) throw new Error("cwise: pre() block may not reference array index");
            if (a < e.body.args.length && e.body.args[a].lvalue) throw new Error("cwise: body() block may not write to array index");
            if (a < e.post.args.length && e.post.args[a].count > 0) throw new Error("cwise: post() block may not reference array index");
          } else if ("shape" === o) {
            if (e.shapeArgs.push(a), a < e.pre.args.length && e.pre.args[a].lvalue) throw new Error("cwise: pre() block may not write to array shape");
            if (a < e.body.args.length && e.body.args[a].lvalue) throw new Error("cwise: body() block may not write to array shape");
            if (a < e.post.args.length && e.post.args[a].lvalue) throw new Error("cwise: post() block may not write to array shape");
          } else {
            if ("object" != _typeof(o) || !o.offset) throw new Error("cwise: Unknown argument type " + r[a]);
            e.argTypes[a] = "offset", e.offsetArgs.push({
              array: o.array,
              offset: o.offset
            }), e.offsetArgIndex.push(a);
          }
        }

        if (e.arrayArgs.length <= 0) throw new Error("cwise: No array arguments specified");
        if (e.pre.args.length > r.length) throw new Error("cwise: Too many arguments in pre() block");
        if (e.body.args.length > r.length) throw new Error("cwise: Too many arguments in body() block");
        if (e.post.args.length > r.length) throw new Error("cwise: Too many arguments in post() block");
        return e.debug = !!t.printCode || !!t.debug, e.funcName = t.funcName || "cwise", e.blockSize = t.blockSize || 64, n(e);
      };
    }, {
      "./lib/thunk.js": 154
    }],
    153: [function (t, e, r) {
      "use strict";

      var n = t("uniq");

      function i(t, e, r) {
        var n,
            i,
            a = t.length,
            o = e.arrayArgs.length,
            s = e.indexArgs.length > 0,
            l = [],
            c = [],
            u = 0,
            f = 0;

        for (n = 0; n < a; ++n) {
          c.push(["i", n, "=0"].join(""));
        }

        for (i = 0; i < o; ++i) {
          for (n = 0; n < a; ++n) {
            f = u, u = t[n], 0 === n ? c.push(["d", i, "s", n, "=t", i, "p", u].join("")) : c.push(["d", i, "s", n, "=(t", i, "p", u, "-s", f, "*t", i, "p", f, ")"].join(""));
          }
        }

        for (c.length > 0 && l.push("var " + c.join(",")), n = a - 1; n >= 0; --n) {
          u = t[n], l.push(["for(i", n, "=0;i", n, "<s", u, ";++i", n, "){"].join(""));
        }

        for (l.push(r), n = 0; n < a; ++n) {
          for (f = u, u = t[n], i = 0; i < o; ++i) {
            l.push(["p", i, "+=d", i, "s", n].join(""));
          }

          s && (n > 0 && l.push(["index[", f, "]-=s", f].join("")), l.push(["++index[", u, "]"].join(""))), l.push("}");
        }

        return l.join("\n");
      }

      function a(t, e, r) {
        for (var n = t.body, i = [], a = [], o = 0; o < t.args.length; ++o) {
          var s = t.args[o];

          if (!(s.count <= 0)) {
            var l = new RegExp(s.name, "g"),
                c = "",
                u = e.arrayArgs.indexOf(o);

            switch (e.argTypes[o]) {
              case "offset":
                var f = e.offsetArgIndex.indexOf(o);
                u = e.offsetArgs[f].array, c = "+q" + f;

              case "array":
                c = "p" + u + c;
                var h = "l" + o,
                    p = "a" + u;
                if (0 === e.arrayBlockIndices[u]) 1 === s.count ? "generic" === r[u] ? s.lvalue ? (i.push(["var ", h, "=", p, ".get(", c, ")"].join("")), n = n.replace(l, h), a.push([p, ".set(", c, ",", h, ")"].join(""))) : n = n.replace(l, [p, ".get(", c, ")"].join("")) : n = n.replace(l, [p, "[", c, "]"].join("")) : "generic" === r[u] ? (i.push(["var ", h, "=", p, ".get(", c, ")"].join("")), n = n.replace(l, h), s.lvalue && a.push([p, ".set(", c, ",", h, ")"].join(""))) : (i.push(["var ", h, "=", p, "[", c, "]"].join("")), n = n.replace(l, h), s.lvalue && a.push([p, "[", c, "]=", h].join("")));else {
                  for (var d = [s.name], m = [c], g = 0; g < Math.abs(e.arrayBlockIndices[u]); g++) {
                    d.push("\\s*\\[([^\\]]+)\\]"), m.push("$" + (g + 1) + "*t" + u + "b" + g);
                  }

                  if (l = new RegExp(d.join(""), "g"), c = m.join("+"), "generic" === r[u]) throw new Error("cwise: Generic arrays not supported in combination with blocks!");
                  n = n.replace(l, [p, "[", c, "]"].join(""));
                }
                break;

              case "scalar":
                n = n.replace(l, "Y" + e.scalarArgs.indexOf(o));
                break;

              case "index":
                n = n.replace(l, "index");
                break;

              case "shape":
                n = n.replace(l, "shape");
            }
          }
        }

        return [i.join("\n"), n, a.join("\n")].join("\n").trim();
      }

      function o(t) {
        for (var e = new Array(t.length), r = !0, n = 0; n < t.length; ++n) {
          var i = t[n],
              a = i.match(/\d+/);
          a = a ? a[0] : "", 0 === i.charAt(0) ? e[n] = "u" + i.charAt(1) + a : e[n] = i.charAt(0) + a, n > 0 && (r = r && e[n] === e[n - 1]);
        }

        return r ? e[0] : e.join("");
      }

      e.exports = function (t, e) {
        for (var r = e[1].length - Math.abs(t.arrayBlockIndices[0]) | 0, s = new Array(t.arrayArgs.length), l = new Array(t.arrayArgs.length), c = 0; c < t.arrayArgs.length; ++c) {
          l[c] = e[2 * c], s[c] = e[2 * c + 1];
        }

        var u = [],
            f = [],
            h = [],
            p = [],
            d = [];

        for (c = 0; c < t.arrayArgs.length; ++c) {
          t.arrayBlockIndices[c] < 0 ? (h.push(0), p.push(r), u.push(r), f.push(r + t.arrayBlockIndices[c])) : (h.push(t.arrayBlockIndices[c]), p.push(t.arrayBlockIndices[c] + r), u.push(0), f.push(t.arrayBlockIndices[c]));

          for (var m = [], g = 0; g < s[c].length; g++) {
            h[c] <= s[c][g] && s[c][g] < p[c] && m.push(s[c][g] - h[c]);
          }

          d.push(m);
        }

        var v = ["SS"],
            y = ["'use strict'"],
            x = [];

        for (g = 0; g < r; ++g) {
          x.push(["s", g, "=SS[", g, "]"].join(""));
        }

        for (c = 0; c < t.arrayArgs.length; ++c) {
          v.push("a" + c), v.push("t" + c), v.push("p" + c);

          for (g = 0; g < r; ++g) {
            x.push(["t", c, "p", g, "=t", c, "[", h[c] + g, "]"].join(""));
          }

          for (g = 0; g < Math.abs(t.arrayBlockIndices[c]); ++g) {
            x.push(["t", c, "b", g, "=t", c, "[", u[c] + g, "]"].join(""));
          }
        }

        for (c = 0; c < t.scalarArgs.length; ++c) {
          v.push("Y" + c);
        }

        if (t.shapeArgs.length > 0 && x.push("shape=SS.slice(0)"), t.indexArgs.length > 0) {
          var b = new Array(r);

          for (c = 0; c < r; ++c) {
            b[c] = "0";
          }

          x.push(["index=[", b.join(","), "]"].join(""));
        }

        for (c = 0; c < t.offsetArgs.length; ++c) {
          var _ = t.offsetArgs[c],
              w = [];

          for (g = 0; g < _.offset.length; ++g) {
            0 !== _.offset[g] && (1 === _.offset[g] ? w.push(["t", _.array, "p", g].join("")) : w.push([_.offset[g], "*t", _.array, "p", g].join("")));
          }

          0 === w.length ? x.push("q" + c + "=0") : x.push(["q", c, "=", w.join("+")].join(""));
        }

        var T = n([].concat(t.pre.thisVars).concat(t.body.thisVars).concat(t.post.thisVars));

        for ((x = x.concat(T)).length > 0 && y.push("var " + x.join(",")), c = 0; c < t.arrayArgs.length; ++c) {
          y.push("p" + c + "|=0");
        }

        t.pre.body.length > 3 && y.push(a(t.pre, t, l));

        var k = a(t.body, t, l),
            M = function (t) {
          for (var e = 0, r = t[0].length; e < r;) {
            for (var n = 1; n < t.length; ++n) {
              if (t[n][e] !== t[0][e]) return e;
            }

            ++e;
          }

          return e;
        }(d);

        M < r ? y.push(function (t, e, r, n) {
          for (var a = e.length, o = r.arrayArgs.length, s = r.blockSize, l = r.indexArgs.length > 0, c = [], u = 0; u < o; ++u) {
            c.push(["var offset", u, "=p", u].join(""));
          }

          for (u = t; u < a; ++u) {
            c.push(["for(var j" + u + "=SS[", e[u], "]|0;j", u, ">0;){"].join("")), c.push(["if(j", u, "<", s, "){"].join("")), c.push(["s", e[u], "=j", u].join("")), c.push(["j", u, "=0"].join("")), c.push(["}else{s", e[u], "=", s].join("")), c.push(["j", u, "-=", s, "}"].join("")), l && c.push(["index[", e[u], "]=j", u].join(""));
          }

          for (u = 0; u < o; ++u) {
            for (var f = ["offset" + u], h = t; h < a; ++h) {
              f.push(["j", h, "*t", u, "p", e[h]].join(""));
            }

            c.push(["p", u, "=(", f.join("+"), ")"].join(""));
          }

          for (c.push(i(e, r, n)), u = t; u < a; ++u) {
            c.push("}");
          }

          return c.join("\n");
        }(M, d[0], t, k)) : y.push(i(d[0], t, k)), t.post.body.length > 3 && y.push(a(t.post, t, l)), t.debug && console.log("-----Generated cwise routine for ", e, ":\n" + y.join("\n") + "\n----------");
        var A = [t.funcName || "unnamed", "_cwise_loop_", s[0].join("s"), "m", M, o(l)].join("");
        return new Function(["function ", A, "(", v.join(","), "){", y.join("\n"), "} return ", A].join(""))();
      };
    }, {
      uniq: 611
    }],
    154: [function (t, e, r) {
      "use strict";

      var n = t("./compile.js");

      e.exports = function (t) {
        var e = ["'use strict'", "var CACHED={}"],
            r = [],
            i = t.funcName + "_cwise_thunk";
        e.push(["return function ", i, "(", t.shimArgs.join(","), "){"].join(""));

        for (var a = [], o = [], s = [["array", t.arrayArgs[0], ".shape.slice(", Math.max(0, t.arrayBlockIndices[0]), t.arrayBlockIndices[0] < 0 ? "," + t.arrayBlockIndices[0] + ")" : ")"].join("")], l = [], c = [], u = 0; u < t.arrayArgs.length; ++u) {
          var f = t.arrayArgs[u];
          r.push(["t", f, "=array", f, ".dtype,", "r", f, "=array", f, ".order"].join("")), a.push("t" + f), a.push("r" + f), o.push("t" + f), o.push("r" + f + ".join()"), s.push("array" + f + ".data"), s.push("array" + f + ".stride"), s.push("array" + f + ".offset|0"), u > 0 && (l.push("array" + t.arrayArgs[0] + ".shape.length===array" + f + ".shape.length+" + (Math.abs(t.arrayBlockIndices[0]) - Math.abs(t.arrayBlockIndices[u]))), c.push("array" + t.arrayArgs[0] + ".shape[shapeIndex+" + Math.max(0, t.arrayBlockIndices[0]) + "]===array" + f + ".shape[shapeIndex+" + Math.max(0, t.arrayBlockIndices[u]) + "]"));
        }

        for (t.arrayArgs.length > 1 && (e.push("if (!(" + l.join(" && ") + ")) throw new Error('cwise: Arrays do not all have the same dimensionality!')"), e.push("for(var shapeIndex=array" + t.arrayArgs[0] + ".shape.length-" + Math.abs(t.arrayBlockIndices[0]) + "; shapeIndex--\x3e0;) {"), e.push("if (!(" + c.join(" && ") + ")) throw new Error('cwise: Arrays do not all have the same shape!')"), e.push("}")), u = 0; u < t.scalarArgs.length; ++u) {
          s.push("scalar" + t.scalarArgs[u]);
        }

        return r.push(["type=[", o.join(","), "].join()"].join("")), r.push("proc=CACHED[type]"), e.push("var " + r.join(",")), e.push(["if(!proc){", "CACHED[type]=proc=compile([", a.join(","), "])}", "return proc(", s.join(","), ")}"].join("")), t.debug && console.log("-----Generated thunk:\n" + e.join("\n") + "\n----------"), new Function("compile", e.join("\n"))(n.bind(void 0, t));
      };
    }, {
      "./compile.js": 153
    }],
    155: [function (t, e, r) {
      "use strict";

      var n,
          i = t("type/value/is"),
          a = t("type/value/ensure"),
          o = t("type/plain-function/ensure"),
          s = t("es5-ext/object/copy"),
          l = t("es5-ext/object/normalize-options"),
          c = t("es5-ext/object/map"),
          u = Function.prototype.bind,
          f = Object.defineProperty,
          h = Object.prototype.hasOwnProperty;
      n = function n(t, e, r) {
        var n,
            i = a(e) && o(e.value);
        return delete (n = s(e)).writable, delete n.value, n.get = function () {
          return !r.overwriteDefinition && h.call(this, t) ? i : (e.value = u.call(i, r.resolveContext ? r.resolveContext(this) : this), f(this, t, e), this[t]);
        }, n;
      }, e.exports = function (t) {
        var e = l(arguments[1]);
        return i(e.resolveContext) && o(e.resolveContext), c(t, function (t, r) {
          return n(r, t, e);
        });
      };
    }, {
      "es5-ext/object/copy": 196,
      "es5-ext/object/map": 204,
      "es5-ext/object/normalize-options": 205,
      "type/plain-function/ensure": 603,
      "type/value/ensure": 607,
      "type/value/is": 608
    }],
    156: [function (t, e, r) {
      "use strict";

      var n = t("type/value/is"),
          i = t("type/plain-function/is"),
          a = t("es5-ext/object/assign"),
          o = t("es5-ext/object/normalize-options"),
          s = t("es5-ext/string/#/contains");

      (e.exports = function (t, e) {
        var r, i, l, c, u;
        return arguments.length < 2 || "string" != typeof t ? (c = e, e = t, t = null) : c = arguments[2], n(t) ? (r = s.call(t, "c"), i = s.call(t, "e"), l = s.call(t, "w")) : (r = l = !0, i = !1), u = {
          value: e,
          configurable: r,
          enumerable: i,
          writable: l
        }, c ? a(o(c), u) : u;
      }).gs = function (t, e, r) {
        var l, c, u, f;
        return "string" != typeof t ? (u = r, r = e, e = t, t = null) : u = arguments[3], n(e) ? i(e) ? n(r) ? i(r) || (u = r, r = void 0) : r = void 0 : (u = e, e = r = void 0) : e = void 0, n(t) ? (l = s.call(t, "c"), c = s.call(t, "e")) : (l = !0, c = !1), f = {
          get: e,
          set: r,
          configurable: l,
          enumerable: c
        }, u ? a(o(u), f) : f;
      };
    }, {
      "es5-ext/object/assign": 193,
      "es5-ext/object/normalize-options": 205,
      "es5-ext/string/#/contains": 212,
      "type/plain-function/is": 604,
      "type/value/is": 608
    }],
    157: [function (t, e, r) {
      !function (t, n) {
        n("object" == _typeof(r) && void 0 !== e ? r : t.d3 = t.d3 || {});
      }(this, function (t) {
        "use strict";

        function e(t, e) {
          return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
        }

        function r(t) {
          var r;
          return 1 === t.length && (r = t, t = function t(_t2, n) {
            return e(r(_t2), n);
          }), {
            left: function left(e, r, n, i) {
              for (null == n && (n = 0), null == i && (i = e.length); n < i;) {
                var a = n + i >>> 1;
                t(e[a], r) < 0 ? n = a + 1 : i = a;
              }

              return n;
            },
            right: function right(e, r, n, i) {
              for (null == n && (n = 0), null == i && (i = e.length); n < i;) {
                var a = n + i >>> 1;
                t(e[a], r) > 0 ? i = a : n = a + 1;
              }

              return n;
            }
          };
        }

        var n = r(e),
            i = n.right,
            a = n.left;

        function o(t, e) {
          return [t, e];
        }

        function s(t) {
          return null === t ? NaN : +t;
        }

        function l(t, e) {
          var r,
              n,
              i = t.length,
              a = 0,
              o = -1,
              l = 0,
              c = 0;
          if (null == e) for (; ++o < i;) {
            isNaN(r = s(t[o])) || (c += (n = r - l) * (r - (l += n / ++a)));
          } else for (; ++o < i;) {
            isNaN(r = s(e(t[o], o, t))) || (c += (n = r - l) * (r - (l += n / ++a)));
          }
          if (a > 1) return c / (a - 1);
        }

        function c(t, e) {
          var r = l(t, e);
          return r ? Math.sqrt(r) : r;
        }

        function u(t, e) {
          var r,
              n,
              i,
              a = t.length,
              o = -1;

          if (null == e) {
            for (; ++o < a;) {
              if (null != (r = t[o]) && r >= r) for (n = i = r; ++o < a;) {
                null != (r = t[o]) && (n > r && (n = r), i < r && (i = r));
              }
            }
          } else for (; ++o < a;) {
            if (null != (r = e(t[o], o, t)) && r >= r) for (n = i = r; ++o < a;) {
              null != (r = e(t[o], o, t)) && (n > r && (n = r), i < r && (i = r));
            }
          }

          return [n, i];
        }

        var f = Array.prototype,
            h = f.slice,
            p = f.map;

        function d(t) {
          return function () {
            return t;
          };
        }

        function m(t) {
          return t;
        }

        function g(t, e, r) {
          t = +t, e = +e, r = (i = arguments.length) < 2 ? (e = t, t = 0, 1) : i < 3 ? 1 : +r;

          for (var n = -1, i = 0 | Math.max(0, Math.ceil((e - t) / r)), a = new Array(i); ++n < i;) {
            a[n] = t + n * r;
          }

          return a;
        }

        var v = Math.sqrt(50),
            y = Math.sqrt(10),
            x = Math.sqrt(2);

        function b(t, e, r) {
          var n = (e - t) / Math.max(0, r),
              i = Math.floor(Math.log(n) / Math.LN10),
              a = n / Math.pow(10, i);
          return i >= 0 ? (a >= v ? 10 : a >= y ? 5 : a >= x ? 2 : 1) * Math.pow(10, i) : -Math.pow(10, -i) / (a >= v ? 10 : a >= y ? 5 : a >= x ? 2 : 1);
        }

        function _(t, e, r) {
          var n = Math.abs(e - t) / Math.max(0, r),
              i = Math.pow(10, Math.floor(Math.log(n) / Math.LN10)),
              a = n / i;
          return a >= v ? i *= 10 : a >= y ? i *= 5 : a >= x && (i *= 2), e < t ? -i : i;
        }

        function w(t) {
          return Math.ceil(Math.log(t.length) / Math.LN2) + 1;
        }

        function T(t, e, r) {
          if (null == r && (r = s), n = t.length) {
            if ((e = +e) <= 0 || n < 2) return +r(t[0], 0, t);
            if (e >= 1) return +r(t[n - 1], n - 1, t);
            var n,
                i = (n - 1) * e,
                a = Math.floor(i),
                o = +r(t[a], a, t);
            return o + (+r(t[a + 1], a + 1, t) - o) * (i - a);
          }
        }

        function k(t, e) {
          var r,
              n,
              i = t.length,
              a = -1;

          if (null == e) {
            for (; ++a < i;) {
              if (null != (r = t[a]) && r >= r) for (n = r; ++a < i;) {
                null != (r = t[a]) && n > r && (n = r);
              }
            }
          } else for (; ++a < i;) {
            if (null != (r = e(t[a], a, t)) && r >= r) for (n = r; ++a < i;) {
              null != (r = e(t[a], a, t)) && n > r && (n = r);
            }
          }

          return n;
        }

        function M(t) {
          if (!(i = t.length)) return [];

          for (var e = -1, r = k(t, A), n = new Array(r); ++e < r;) {
            for (var i, a = -1, o = n[e] = new Array(i); ++a < i;) {
              o[a] = t[a][e];
            }
          }

          return n;
        }

        function A(t) {
          return t.length;
        }

        t.bisect = i, t.bisectRight = i, t.bisectLeft = a, t.ascending = e, t.bisector = r, t.cross = function (t, e, r) {
          var n,
              i,
              a,
              s,
              l = t.length,
              c = e.length,
              u = new Array(l * c);

          for (null == r && (r = o), n = a = 0; n < l; ++n) {
            for (s = t[n], i = 0; i < c; ++i, ++a) {
              u[a] = r(s, e[i]);
            }
          }

          return u;
        }, t.descending = function (t, e) {
          return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
        }, t.deviation = c, t.extent = u, t.histogram = function () {
          var t = m,
              e = u,
              r = w;

          function n(n) {
            var a,
                o,
                s = n.length,
                l = new Array(s);

            for (a = 0; a < s; ++a) {
              l[a] = t(n[a], a, n);
            }

            var c = e(l),
                u = c[0],
                f = c[1],
                h = r(l, u, f);
            Array.isArray(h) || (h = _(u, f, h), h = g(Math.ceil(u / h) * h, f, h));

            for (var p = h.length; h[0] <= u;) {
              h.shift(), --p;
            }

            for (; h[p - 1] > f;) {
              h.pop(), --p;
            }

            var d,
                m = new Array(p + 1);

            for (a = 0; a <= p; ++a) {
              (d = m[a] = []).x0 = a > 0 ? h[a - 1] : u, d.x1 = a < p ? h[a] : f;
            }

            for (a = 0; a < s; ++a) {
              u <= (o = l[a]) && o <= f && m[i(h, o, 0, p)].push(n[a]);
            }

            return m;
          }

          return n.value = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : d(e), n) : t;
          }, n.domain = function (t) {
            return arguments.length ? (e = "function" == typeof t ? t : d([t[0], t[1]]), n) : e;
          }, n.thresholds = function (t) {
            return arguments.length ? (r = "function" == typeof t ? t : Array.isArray(t) ? d(h.call(t)) : d(t), n) : r;
          }, n;
        }, t.thresholdFreedmanDiaconis = function (t, r, n) {
          return t = p.call(t, s).sort(e), Math.ceil((n - r) / (2 * (T(t, .75) - T(t, .25)) * Math.pow(t.length, -1 / 3)));
        }, t.thresholdScott = function (t, e, r) {
          return Math.ceil((r - e) / (3.5 * c(t) * Math.pow(t.length, -1 / 3)));
        }, t.thresholdSturges = w, t.max = function (t, e) {
          var r,
              n,
              i = t.length,
              a = -1;

          if (null == e) {
            for (; ++a < i;) {
              if (null != (r = t[a]) && r >= r) for (n = r; ++a < i;) {
                null != (r = t[a]) && r > n && (n = r);
              }
            }
          } else for (; ++a < i;) {
            if (null != (r = e(t[a], a, t)) && r >= r) for (n = r; ++a < i;) {
              null != (r = e(t[a], a, t)) && r > n && (n = r);
            }
          }

          return n;
        }, t.mean = function (t, e) {
          var r,
              n = t.length,
              i = n,
              a = -1,
              o = 0;
          if (null == e) for (; ++a < n;) {
            isNaN(r = s(t[a])) ? --i : o += r;
          } else for (; ++a < n;) {
            isNaN(r = s(e(t[a], a, t))) ? --i : o += r;
          }
          if (i) return o / i;
        }, t.median = function (t, r) {
          var n,
              i = t.length,
              a = -1,
              o = [];
          if (null == r) for (; ++a < i;) {
            isNaN(n = s(t[a])) || o.push(n);
          } else for (; ++a < i;) {
            isNaN(n = s(r(t[a], a, t))) || o.push(n);
          }
          return T(o.sort(e), .5);
        }, t.merge = function (t) {
          for (var e, r, n, i = t.length, a = -1, o = 0; ++a < i;) {
            o += t[a].length;
          }

          for (r = new Array(o); --i >= 0;) {
            for (e = (n = t[i]).length; --e >= 0;) {
              r[--o] = n[e];
            }
          }

          return r;
        }, t.min = k, t.pairs = function (t, e) {
          null == e && (e = o);

          for (var r = 0, n = t.length - 1, i = t[0], a = new Array(n < 0 ? 0 : n); r < n;) {
            a[r] = e(i, i = t[++r]);
          }

          return a;
        }, t.permute = function (t, e) {
          for (var r = e.length, n = new Array(r); r--;) {
            n[r] = t[e[r]];
          }

          return n;
        }, t.quantile = T, t.range = g, t.scan = function (t, r) {
          if (n = t.length) {
            var n,
                i,
                a = 0,
                o = 0,
                s = t[o];

            for (null == r && (r = e); ++a < n;) {
              (r(i = t[a], s) < 0 || 0 !== r(s, s)) && (s = i, o = a);
            }

            return 0 === r(s, s) ? o : void 0;
          }
        }, t.shuffle = function (t, e, r) {
          for (var n, i, a = (null == r ? t.length : r) - (e = null == e ? 0 : +e); a;) {
            i = Math.random() * a-- | 0, n = t[a + e], t[a + e] = t[i + e], t[i + e] = n;
          }

          return t;
        }, t.sum = function (t, e) {
          var r,
              n = t.length,
              i = -1,
              a = 0;
          if (null == e) for (; ++i < n;) {
            (r = +t[i]) && (a += r);
          } else for (; ++i < n;) {
            (r = +e(t[i], i, t)) && (a += r);
          }
          return a;
        }, t.ticks = function (t, e, r) {
          var n,
              i,
              a,
              o,
              s = -1;
          if (r = +r, (t = +t) === (e = +e) && r > 0) return [t];
          if ((n = e < t) && (i = t, t = e, e = i), 0 === (o = b(t, e, r)) || !isFinite(o)) return [];
          if (o > 0) for (t = Math.ceil(t / o), e = Math.floor(e / o), a = new Array(i = Math.ceil(e - t + 1)); ++s < i;) {
            a[s] = (t + s) * o;
          } else for (t = Math.floor(t * o), e = Math.ceil(e * o), a = new Array(i = Math.ceil(t - e + 1)); ++s < i;) {
            a[s] = (t - s) / o;
          }
          return n && a.reverse(), a;
        }, t.tickIncrement = b, t.tickStep = _, t.transpose = M, t.variance = l, t.zip = function () {
          return M(arguments);
        }, Object.defineProperty(t, "__esModule", {
          value: !0
        });
      });
    }, {}],
    158: [function (t, e, r) {
      !function (t, n) {
        n("object" == _typeof(r) && void 0 !== e ? r : t.d3 = t.d3 || {});
      }(this, function (t) {
        "use strict";

        function e() {}

        function r(t, r) {
          var n = new e();
          if (t instanceof e) t.each(function (t, e) {
            n.set(e, t);
          });else if (Array.isArray(t)) {
            var i,
                a = -1,
                o = t.length;
            if (null == r) for (; ++a < o;) {
              n.set(a, t[a]);
            } else for (; ++a < o;) {
              n.set(r(i = t[a], a, t), i);
            }
          } else if (t) for (var s in t) {
            n.set(s, t[s]);
          }
          return n;
        }

        function n() {
          return {};
        }

        function i(t, e, r) {
          t[e] = r;
        }

        function a() {
          return r();
        }

        function o(t, e, r) {
          t.set(e, r);
        }

        function s() {}

        e.prototype = r.prototype = {
          constructor: e,
          has: function has(t) {
            return "$" + t in this;
          },
          get: function get(t) {
            return this["$" + t];
          },
          set: function set(t, e) {
            return this["$" + t] = e, this;
          },
          remove: function remove(t) {
            var e = "$" + t;
            return e in this && delete this[e];
          },
          clear: function clear() {
            for (var t in this) {
              "$" === t[0] && delete this[t];
            }
          },
          keys: function keys() {
            var t = [];

            for (var e in this) {
              "$" === e[0] && t.push(e.slice(1));
            }

            return t;
          },
          values: function values() {
            var t = [];

            for (var e in this) {
              "$" === e[0] && t.push(this[e]);
            }

            return t;
          },
          entries: function entries() {
            var t = [];

            for (var e in this) {
              "$" === e[0] && t.push({
                key: e.slice(1),
                value: this[e]
              });
            }

            return t;
          },
          size: function size() {
            var t = 0;

            for (var e in this) {
              "$" === e[0] && ++t;
            }

            return t;
          },
          empty: function empty() {
            for (var t in this) {
              if ("$" === t[0]) return !1;
            }

            return !0;
          },
          each: function each(t) {
            for (var e in this) {
              "$" === e[0] && t(this[e], e.slice(1), this);
            }
          }
        };
        var l = r.prototype;

        function c(t, e) {
          var r = new s();
          if (t instanceof s) t.each(function (t) {
            r.add(t);
          });else if (t) {
            var n = -1,
                i = t.length;
            if (null == e) for (; ++n < i;) {
              r.add(t[n]);
            } else for (; ++n < i;) {
              r.add(e(t[n], n, t));
            }
          }
          return r;
        }

        s.prototype = c.prototype = {
          constructor: s,
          has: l.has,
          add: function add(t) {
            return this["$" + (t += "")] = t, this;
          },
          remove: l.remove,
          clear: l.clear,
          values: l.keys,
          size: l.size,
          empty: l.empty,
          each: l.each
        }, t.nest = function () {
          var t,
              e,
              s,
              l = [],
              c = [];

          function u(n, i, a, o) {
            if (i >= l.length) return null != t && n.sort(t), null != e ? e(n) : n;

            for (var s, c, f, h = -1, p = n.length, d = l[i++], m = r(), g = a(); ++h < p;) {
              (f = m.get(s = d(c = n[h]) + "")) ? f.push(c) : m.set(s, [c]);
            }

            return m.each(function (t, e) {
              o(g, e, u(t, i, a, o));
            }), g;
          }

          return s = {
            object: function object(t) {
              return u(t, 0, n, i);
            },
            map: function map(t) {
              return u(t, 0, a, o);
            },
            entries: function entries(t) {
              return function t(r, n) {
                if (++n > l.length) return r;
                var i,
                    a = c[n - 1];
                return null != e && n >= l.length ? i = r.entries() : (i = [], r.each(function (e, r) {
                  i.push({
                    key: r,
                    values: t(e, n)
                  });
                })), null != a ? i.sort(function (t, e) {
                  return a(t.key, e.key);
                }) : i;
              }(u(t, 0, a, o), 0);
            },
            key: function key(t) {
              return l.push(t), s;
            },
            sortKeys: function sortKeys(t) {
              return c[l.length - 1] = t, s;
            },
            sortValues: function sortValues(e) {
              return t = e, s;
            },
            rollup: function rollup(t) {
              return e = t, s;
            }
          };
        }, t.set = c, t.map = r, t.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e;
        }, t.values = function (t) {
          var e = [];

          for (var r in t) {
            e.push(t[r]);
          }

          return e;
        }, t.entries = function (t) {
          var e = [];

          for (var r in t) {
            e.push({
              key: r,
              value: t[r]
            });
          }

          return e;
        }, Object.defineProperty(t, "__esModule", {
          value: !0
        });
      });
    }, {}],
    159: [function (t, e, r) {
      !function (t, n) {
        "object" == _typeof(r) && void 0 !== e ? n(r) : n((t = t || self).d3 = t.d3 || {});
      }(this, function (t) {
        "use strict";

        function e(t, e, r) {
          t.prototype = e.prototype = r, r.constructor = t;
        }

        function r(t, e) {
          var r = Object.create(t.prototype);

          for (var n in e) {
            r[n] = e[n];
          }

          return r;
        }

        function n() {}

        var i = "\\s*([+-]?\\d+)\\s*",
            a = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
            o = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
            s = /^#([0-9a-f]{3,8})$/,
            l = new RegExp("^rgb\\(" + [i, i, i] + "\\)$"),
            c = new RegExp("^rgb\\(" + [o, o, o] + "\\)$"),
            u = new RegExp("^rgba\\(" + [i, i, i, a] + "\\)$"),
            f = new RegExp("^rgba\\(" + [o, o, o, a] + "\\)$"),
            h = new RegExp("^hsl\\(" + [a, o, o] + "\\)$"),
            p = new RegExp("^hsla\\(" + [a, o, o, a] + "\\)$"),
            d = {
          aliceblue: 15792383,
          antiquewhite: 16444375,
          aqua: 65535,
          aquamarine: 8388564,
          azure: 15794175,
          beige: 16119260,
          bisque: 16770244,
          black: 0,
          blanchedalmond: 16772045,
          blue: 255,
          blueviolet: 9055202,
          brown: 10824234,
          burlywood: 14596231,
          cadetblue: 6266528,
          chartreuse: 8388352,
          chocolate: 13789470,
          coral: 16744272,
          cornflowerblue: 6591981,
          cornsilk: 16775388,
          crimson: 14423100,
          cyan: 65535,
          darkblue: 139,
          darkcyan: 35723,
          darkgoldenrod: 12092939,
          darkgray: 11119017,
          darkgreen: 25600,
          darkgrey: 11119017,
          darkkhaki: 12433259,
          darkmagenta: 9109643,
          darkolivegreen: 5597999,
          darkorange: 16747520,
          darkorchid: 10040012,
          darkred: 9109504,
          darksalmon: 15308410,
          darkseagreen: 9419919,
          darkslateblue: 4734347,
          darkslategray: 3100495,
          darkslategrey: 3100495,
          darkturquoise: 52945,
          darkviolet: 9699539,
          deeppink: 16716947,
          deepskyblue: 49151,
          dimgray: 6908265,
          dimgrey: 6908265,
          dodgerblue: 2003199,
          firebrick: 11674146,
          floralwhite: 16775920,
          forestgreen: 2263842,
          fuchsia: 16711935,
          gainsboro: 14474460,
          ghostwhite: 16316671,
          gold: 16766720,
          goldenrod: 14329120,
          gray: 8421504,
          green: 32768,
          greenyellow: 11403055,
          grey: 8421504,
          honeydew: 15794160,
          hotpink: 16738740,
          indianred: 13458524,
          indigo: 4915330,
          ivory: 16777200,
          khaki: 15787660,
          lavender: 15132410,
          lavenderblush: 16773365,
          lawngreen: 8190976,
          lemonchiffon: 16775885,
          lightblue: 11393254,
          lightcoral: 15761536,
          lightcyan: 14745599,
          lightgoldenrodyellow: 16448210,
          lightgray: 13882323,
          lightgreen: 9498256,
          lightgrey: 13882323,
          lightpink: 16758465,
          lightsalmon: 16752762,
          lightseagreen: 2142890,
          lightskyblue: 8900346,
          lightslategray: 7833753,
          lightslategrey: 7833753,
          lightsteelblue: 11584734,
          lightyellow: 16777184,
          lime: 65280,
          limegreen: 3329330,
          linen: 16445670,
          magenta: 16711935,
          maroon: 8388608,
          mediumaquamarine: 6737322,
          mediumblue: 205,
          mediumorchid: 12211667,
          mediumpurple: 9662683,
          mediumseagreen: 3978097,
          mediumslateblue: 8087790,
          mediumspringgreen: 64154,
          mediumturquoise: 4772300,
          mediumvioletred: 13047173,
          midnightblue: 1644912,
          mintcream: 16121850,
          mistyrose: 16770273,
          moccasin: 16770229,
          navajowhite: 16768685,
          navy: 128,
          oldlace: 16643558,
          olive: 8421376,
          olivedrab: 7048739,
          orange: 16753920,
          orangered: 16729344,
          orchid: 14315734,
          palegoldenrod: 15657130,
          palegreen: 10025880,
          paleturquoise: 11529966,
          palevioletred: 14381203,
          papayawhip: 16773077,
          peachpuff: 16767673,
          peru: 13468991,
          pink: 16761035,
          plum: 14524637,
          powderblue: 11591910,
          purple: 8388736,
          rebeccapurple: 6697881,
          red: 16711680,
          rosybrown: 12357519,
          royalblue: 4286945,
          saddlebrown: 9127187,
          salmon: 16416882,
          sandybrown: 16032864,
          seagreen: 3050327,
          seashell: 16774638,
          sienna: 10506797,
          silver: 12632256,
          skyblue: 8900331,
          slateblue: 6970061,
          slategray: 7372944,
          slategrey: 7372944,
          snow: 16775930,
          springgreen: 65407,
          steelblue: 4620980,
          tan: 13808780,
          teal: 32896,
          thistle: 14204888,
          tomato: 16737095,
          turquoise: 4251856,
          violet: 15631086,
          wheat: 16113331,
          white: 16777215,
          whitesmoke: 16119285,
          yellow: 16776960,
          yellowgreen: 10145074
        };

        function m() {
          return this.rgb().formatHex();
        }

        function g() {
          return this.rgb().formatRgb();
        }

        function v(t) {
          var e, r;
          return t = (t + "").trim().toLowerCase(), (e = s.exec(t)) ? (r = e[1].length, e = parseInt(e[1], 16), 6 === r ? y(e) : 3 === r ? new w(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, (15 & e) << 4 | 15 & e, 1) : 8 === r ? x(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (255 & e) / 255) : 4 === r ? x(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, ((15 & e) << 4 | 15 & e) / 255) : null) : (e = l.exec(t)) ? new w(e[1], e[2], e[3], 1) : (e = c.exec(t)) ? new w(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, 1) : (e = u.exec(t)) ? x(e[1], e[2], e[3], e[4]) : (e = f.exec(t)) ? x(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, e[4]) : (e = h.exec(t)) ? A(e[1], e[2] / 100, e[3] / 100, 1) : (e = p.exec(t)) ? A(e[1], e[2] / 100, e[3] / 100, e[4]) : d.hasOwnProperty(t) ? y(d[t]) : "transparent" === t ? new w(NaN, NaN, NaN, 0) : null;
        }

        function y(t) {
          return new w(t >> 16 & 255, t >> 8 & 255, 255 & t, 1);
        }

        function x(t, e, r, n) {
          return n <= 0 && (t = e = r = NaN), new w(t, e, r, n);
        }

        function b(t) {
          return t instanceof n || (t = v(t)), t ? new w((t = t.rgb()).r, t.g, t.b, t.opacity) : new w();
        }

        function _(t, e, r, n) {
          return 1 === arguments.length ? b(t) : new w(t, e, r, null == n ? 1 : n);
        }

        function w(t, e, r, n) {
          this.r = +t, this.g = +e, this.b = +r, this.opacity = +n;
        }

        function T() {
          return "#" + M(this.r) + M(this.g) + M(this.b);
        }

        function k() {
          var t = this.opacity;
          return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (1 === t ? ")" : ", " + t + ")");
        }

        function M(t) {
          return ((t = Math.max(0, Math.min(255, Math.round(t) || 0))) < 16 ? "0" : "") + t.toString(16);
        }

        function A(t, e, r, n) {
          return n <= 0 ? t = e = r = NaN : r <= 0 || r >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new L(t, e, r, n);
        }

        function S(t) {
          if (t instanceof L) return new L(t.h, t.s, t.l, t.opacity);
          if (t instanceof n || (t = v(t)), !t) return new L();
          if (t instanceof L) return t;
          var e = (t = t.rgb()).r / 255,
              r = t.g / 255,
              i = t.b / 255,
              a = Math.min(e, r, i),
              o = Math.max(e, r, i),
              s = NaN,
              l = o - a,
              c = (o + a) / 2;
          return l ? (s = e === o ? (r - i) / l + 6 * (r < i) : r === o ? (i - e) / l + 2 : (e - r) / l + 4, l /= c < .5 ? o + a : 2 - o - a, s *= 60) : l = c > 0 && c < 1 ? 0 : s, new L(s, l, c, t.opacity);
        }

        function E(t, e, r, n) {
          return 1 === arguments.length ? S(t) : new L(t, e, r, null == n ? 1 : n);
        }

        function L(t, e, r, n) {
          this.h = +t, this.s = +e, this.l = +r, this.opacity = +n;
        }

        function C(t, e, r) {
          return 255 * (t < 60 ? e + (r - e) * t / 60 : t < 180 ? r : t < 240 ? e + (r - e) * (240 - t) / 60 : e);
        }

        e(n, v, {
          copy: function copy(t) {
            return Object.assign(new this.constructor(), this, t);
          },
          displayable: function displayable() {
            return this.rgb().displayable();
          },
          hex: m,
          formatHex: m,
          formatHsl: function formatHsl() {
            return S(this).formatHsl();
          },
          formatRgb: g,
          toString: g
        }), e(w, _, r(n, {
          brighter: function brighter(t) {
            return t = null == t ? 1 / .7 : Math.pow(1 / .7, t), new w(this.r * t, this.g * t, this.b * t, this.opacity);
          },
          darker: function darker(t) {
            return t = null == t ? .7 : Math.pow(.7, t), new w(this.r * t, this.g * t, this.b * t, this.opacity);
          },
          rgb: function rgb() {
            return this;
          },
          displayable: function displayable() {
            return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
          },
          hex: T,
          formatHex: T,
          formatRgb: k,
          toString: k
        })), e(L, E, r(n, {
          brighter: function brighter(t) {
            return t = null == t ? 1 / .7 : Math.pow(1 / .7, t), new L(this.h, this.s, this.l * t, this.opacity);
          },
          darker: function darker(t) {
            return t = null == t ? .7 : Math.pow(.7, t), new L(this.h, this.s, this.l * t, this.opacity);
          },
          rgb: function rgb() {
            var t = this.h % 360 + 360 * (this.h < 0),
                e = isNaN(t) || isNaN(this.s) ? 0 : this.s,
                r = this.l,
                n = r + (r < .5 ? r : 1 - r) * e,
                i = 2 * r - n;
            return new w(C(t >= 240 ? t - 240 : t + 120, i, n), C(t, i, n), C(t < 120 ? t + 240 : t - 120, i, n), this.opacity);
          },
          displayable: function displayable() {
            return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
          },
          formatHsl: function formatHsl() {
            var t = this.opacity;
            return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "hsl(" : "hsla(") + (this.h || 0) + ", " + 100 * (this.s || 0) + "%, " + 100 * (this.l || 0) + "%" + (1 === t ? ")" : ", " + t + ")");
          }
        }));
        var P = Math.PI / 180,
            I = 180 / Math.PI,
            O = 6 / 29,
            z = 3 * O * O;

        function D(t) {
          if (t instanceof F) return new F(t.l, t.a, t.b, t.opacity);
          if (t instanceof H) return G(t);
          t instanceof w || (t = b(t));
          var e,
              r,
              n = U(t.r),
              i = U(t.g),
              a = U(t.b),
              o = B((.2225045 * n + .7168786 * i + .0606169 * a) / 1);
          return n === i && i === a ? e = r = o : (e = B((.4360747 * n + .3850649 * i + .1430804 * a) / .96422), r = B((.0139322 * n + .0971045 * i + .7141733 * a) / .82521)), new F(116 * o - 16, 500 * (e - o), 200 * (o - r), t.opacity);
        }

        function R(t, e, r, n) {
          return 1 === arguments.length ? D(t) : new F(t, e, r, null == n ? 1 : n);
        }

        function F(t, e, r, n) {
          this.l = +t, this.a = +e, this.b = +r, this.opacity = +n;
        }

        function B(t) {
          return t > .008856451679035631 ? Math.pow(t, 1 / 3) : t / z + 4 / 29;
        }

        function N(t) {
          return t > O ? t * t * t : z * (t - 4 / 29);
        }

        function j(t) {
          return 255 * (t <= .0031308 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - .055);
        }

        function U(t) {
          return (t /= 255) <= .04045 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4);
        }

        function V(t) {
          if (t instanceof H) return new H(t.h, t.c, t.l, t.opacity);
          if (t instanceof F || (t = D(t)), 0 === t.a && 0 === t.b) return new H(NaN, 0 < t.l && t.l < 100 ? 0 : NaN, t.l, t.opacity);
          var e = Math.atan2(t.b, t.a) * I;
          return new H(e < 0 ? e + 360 : e, Math.sqrt(t.a * t.a + t.b * t.b), t.l, t.opacity);
        }

        function q(t, e, r, n) {
          return 1 === arguments.length ? V(t) : new H(t, e, r, null == n ? 1 : n);
        }

        function H(t, e, r, n) {
          this.h = +t, this.c = +e, this.l = +r, this.opacity = +n;
        }

        function G(t) {
          if (isNaN(t.h)) return new F(t.l, 0, 0, t.opacity);
          var e = t.h * P;
          return new F(t.l, Math.cos(e) * t.c, Math.sin(e) * t.c, t.opacity);
        }

        e(F, R, r(n, {
          brighter: function brighter(t) {
            return new F(this.l + 18 * (null == t ? 1 : t), this.a, this.b, this.opacity);
          },
          darker: function darker(t) {
            return new F(this.l - 18 * (null == t ? 1 : t), this.a, this.b, this.opacity);
          },
          rgb: function rgb() {
            var t = (this.l + 16) / 116,
                e = isNaN(this.a) ? t : t + this.a / 500,
                r = isNaN(this.b) ? t : t - this.b / 200;
            return new w(j(3.1338561 * (e = .96422 * N(e)) - 1.6168667 * (t = 1 * N(t)) - .4906146 * (r = .82521 * N(r))), j(-.9787684 * e + 1.9161415 * t + .033454 * r), j(.0719453 * e - .2289914 * t + 1.4052427 * r), this.opacity);
          }
        })), e(H, q, r(n, {
          brighter: function brighter(t) {
            return new H(this.h, this.c, this.l + 18 * (null == t ? 1 : t), this.opacity);
          },
          darker: function darker(t) {
            return new H(this.h, this.c, this.l - 18 * (null == t ? 1 : t), this.opacity);
          },
          rgb: function rgb() {
            return G(this).rgb();
          }
        }));
        var Y = -.14861,
            W = 1.78277,
            X = -.29227,
            Z = -.90649,
            J = 1.97294,
            K = J * Z,
            Q = J * W,
            $ = W * X - Z * Y;

        function tt(t) {
          if (t instanceof rt) return new rt(t.h, t.s, t.l, t.opacity);
          t instanceof w || (t = b(t));
          var e = t.r / 255,
              r = t.g / 255,
              n = t.b / 255,
              i = ($ * n + K * e - Q * r) / ($ + K - Q),
              a = n - i,
              o = (J * (r - i) - X * a) / Z,
              s = Math.sqrt(o * o + a * a) / (J * i * (1 - i)),
              l = s ? Math.atan2(o, a) * I - 120 : NaN;
          return new rt(l < 0 ? l + 360 : l, s, i, t.opacity);
        }

        function et(t, e, r, n) {
          return 1 === arguments.length ? tt(t) : new rt(t, e, r, null == n ? 1 : n);
        }

        function rt(t, e, r, n) {
          this.h = +t, this.s = +e, this.l = +r, this.opacity = +n;
        }

        e(rt, et, r(n, {
          brighter: function brighter(t) {
            return t = null == t ? 1 / .7 : Math.pow(1 / .7, t), new rt(this.h, this.s, this.l * t, this.opacity);
          },
          darker: function darker(t) {
            return t = null == t ? .7 : Math.pow(.7, t), new rt(this.h, this.s, this.l * t, this.opacity);
          },
          rgb: function rgb() {
            var t = isNaN(this.h) ? 0 : (this.h + 120) * P,
                e = +this.l,
                r = isNaN(this.s) ? 0 : this.s * e * (1 - e),
                n = Math.cos(t),
                i = Math.sin(t);
            return new w(255 * (e + r * (Y * n + W * i)), 255 * (e + r * (X * n + Z * i)), 255 * (e + r * (J * n)), this.opacity);
          }
        })), t.color = v, t.cubehelix = et, t.gray = function (t, e) {
          return new F(t, 0, 0, null == e ? 1 : e);
        }, t.hcl = q, t.hsl = E, t.lab = R, t.lch = function (t, e, r, n) {
          return 1 === arguments.length ? V(t) : new H(r, e, t, null == n ? 1 : n);
        }, t.rgb = _, Object.defineProperty(t, "__esModule", {
          value: !0
        });
      });
    }, {}],
    160: [function (t, e, r) {
      !function (t, n) {
        "object" == _typeof(r) && void 0 !== e ? n(r) : n((t = t || self).d3 = t.d3 || {});
      }(this, function (t) {
        "use strict";

        var e = {
          value: function value() {}
        };

        function r() {
          for (var t, e = 0, r = arguments.length, i = {}; e < r; ++e) {
            if (!(t = arguments[e] + "") || t in i || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
            i[t] = [];
          }

          return new n(i);
        }

        function n(t) {
          this._ = t;
        }

        function i(t, e) {
          return t.trim().split(/^|\s+/).map(function (t) {
            var r = "",
                n = t.indexOf(".");
            if (n >= 0 && (r = t.slice(n + 1), t = t.slice(0, n)), t && !e.hasOwnProperty(t)) throw new Error("unknown type: " + t);
            return {
              type: t,
              name: r
            };
          });
        }

        function a(t, e) {
          for (var r, n = 0, i = t.length; n < i; ++n) {
            if ((r = t[n]).name === e) return r.value;
          }
        }

        function o(t, r, n) {
          for (var i = 0, a = t.length; i < a; ++i) {
            if (t[i].name === r) {
              t[i] = e, t = t.slice(0, i).concat(t.slice(i + 1));
              break;
            }
          }

          return null != n && t.push({
            name: r,
            value: n
          }), t;
        }

        n.prototype = r.prototype = {
          constructor: n,
          on: function on(t, e) {
            var r,
                n = this._,
                s = i(t + "", n),
                l = -1,
                c = s.length;

            if (!(arguments.length < 2)) {
              if (null != e && "function" != typeof e) throw new Error("invalid callback: " + e);

              for (; ++l < c;) {
                if (r = (t = s[l]).type) n[r] = o(n[r], t.name, e);else if (null == e) for (r in n) {
                  n[r] = o(n[r], t.name, null);
                }
              }

              return this;
            }

            for (; ++l < c;) {
              if ((r = (t = s[l]).type) && (r = a(n[r], t.name))) return r;
            }
          },
          copy: function copy() {
            var t = {},
                e = this._;

            for (var r in e) {
              t[r] = e[r].slice();
            }

            return new n(t);
          },
          call: function call(t, e) {
            if ((r = arguments.length - 2) > 0) for (var r, n, i = new Array(r), a = 0; a < r; ++a) {
              i[a] = arguments[a + 2];
            }
            if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);

            for (a = 0, r = (n = this._[t]).length; a < r; ++a) {
              n[a].value.apply(e, i);
            }
          },
          apply: function apply(t, e, r) {
            if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);

            for (var n = this._[t], i = 0, a = n.length; i < a; ++i) {
              n[i].value.apply(e, r);
            }
          }
        }, t.dispatch = r, Object.defineProperty(t, "__esModule", {
          value: !0
        });
      });
    }, {}],
    161: [function (t, e, r) {
      !function (n, i) {
        "object" == _typeof(r) && void 0 !== e ? i(r, t("d3-quadtree"), t("d3-collection"), t("d3-dispatch"), t("d3-timer")) : i(n.d3 = n.d3 || {}, n.d3, n.d3, n.d3, n.d3);
      }(this, function (t, e, r, n, i) {
        "use strict";

        function a(t) {
          return function () {
            return t;
          };
        }

        function o() {
          return 1e-6 * (Math.random() - .5);
        }

        function s(t) {
          return t.x + t.vx;
        }

        function l(t) {
          return t.y + t.vy;
        }

        function c(t) {
          return t.index;
        }

        function u(t, e) {
          var r = t.get(e);
          if (!r) throw new Error("missing: " + e);
          return r;
        }

        function f(t) {
          return t.x;
        }

        function h(t) {
          return t.y;
        }

        var p = Math.PI * (3 - Math.sqrt(5));
        t.forceCenter = function (t, e) {
          var r;

          function n() {
            var n,
                i,
                a = r.length,
                o = 0,
                s = 0;

            for (n = 0; n < a; ++n) {
              o += (i = r[n]).x, s += i.y;
            }

            for (o = o / a - t, s = s / a - e, n = 0; n < a; ++n) {
              (i = r[n]).x -= o, i.y -= s;
            }
          }

          return null == t && (t = 0), null == e && (e = 0), n.initialize = function (t) {
            r = t;
          }, n.x = function (e) {
            return arguments.length ? (t = +e, n) : t;
          }, n.y = function (t) {
            return arguments.length ? (e = +t, n) : e;
          }, n;
        }, t.forceCollide = function (t) {
          var r,
              n,
              i = 1,
              c = 1;

          function u() {
            for (var t, a, u, h, p, d, m, g = r.length, v = 0; v < c; ++v) {
              for (a = e.quadtree(r, s, l).visitAfter(f), t = 0; t < g; ++t) {
                u = r[t], d = n[u.index], m = d * d, h = u.x + u.vx, p = u.y + u.vy, a.visit(y);
              }
            }

            function y(t, e, r, n, a) {
              var s = t.data,
                  l = t.r,
                  c = d + l;
              if (!s) return e > h + c || n < h - c || r > p + c || a < p - c;

              if (s.index > u.index) {
                var f = h - s.x - s.vx,
                    g = p - s.y - s.vy,
                    v = f * f + g * g;
                v < c * c && (0 === f && (v += (f = o()) * f), 0 === g && (v += (g = o()) * g), v = (c - (v = Math.sqrt(v))) / v * i, u.vx += (f *= v) * (c = (l *= l) / (m + l)), u.vy += (g *= v) * c, s.vx -= f * (c = 1 - c), s.vy -= g * c);
              }
            }
          }

          function f(t) {
            if (t.data) return t.r = n[t.data.index];

            for (var e = t.r = 0; e < 4; ++e) {
              t[e] && t[e].r > t.r && (t.r = t[e].r);
            }
          }

          function h() {
            if (r) {
              var e,
                  i,
                  a = r.length;

              for (n = new Array(a), e = 0; e < a; ++e) {
                i = r[e], n[i.index] = +t(i, e, r);
              }
            }
          }

          return "function" != typeof t && (t = a(null == t ? 1 : +t)), u.initialize = function (t) {
            r = t, h();
          }, u.iterations = function (t) {
            return arguments.length ? (c = +t, u) : c;
          }, u.strength = function (t) {
            return arguments.length ? (i = +t, u) : i;
          }, u.radius = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : a(+e), h(), u) : t;
          }, u;
        }, t.forceLink = function (t) {
          var e,
              n,
              i,
              s,
              l,
              f = c,
              h = function h(t) {
            return 1 / Math.min(s[t.source.index], s[t.target.index]);
          },
              p = a(30),
              d = 1;

          function m(r) {
            for (var i = 0, a = t.length; i < d; ++i) {
              for (var s, c, u, f, h, p, m, g = 0; g < a; ++g) {
                c = (s = t[g]).source, f = (u = s.target).x + u.vx - c.x - c.vx || o(), h = u.y + u.vy - c.y - c.vy || o(), f *= p = ((p = Math.sqrt(f * f + h * h)) - n[g]) / p * r * e[g], h *= p, u.vx -= f * (m = l[g]), u.vy -= h * m, c.vx += f * (m = 1 - m), c.vy += h * m;
              }
            }
          }

          function g() {
            if (i) {
              var a,
                  o,
                  c = i.length,
                  h = t.length,
                  p = r.map(i, f);

              for (a = 0, s = new Array(c); a < h; ++a) {
                (o = t[a]).index = a, "object" != _typeof(o.source) && (o.source = u(p, o.source)), "object" != _typeof(o.target) && (o.target = u(p, o.target)), s[o.source.index] = (s[o.source.index] || 0) + 1, s[o.target.index] = (s[o.target.index] || 0) + 1;
              }

              for (a = 0, l = new Array(h); a < h; ++a) {
                o = t[a], l[a] = s[o.source.index] / (s[o.source.index] + s[o.target.index]);
              }

              e = new Array(h), v(), n = new Array(h), y();
            }
          }

          function v() {
            if (i) for (var r = 0, n = t.length; r < n; ++r) {
              e[r] = +h(t[r], r, t);
            }
          }

          function y() {
            if (i) for (var e = 0, r = t.length; e < r; ++e) {
              n[e] = +p(t[e], e, t);
            }
          }

          return null == t && (t = []), m.initialize = function (t) {
            i = t, g();
          }, m.links = function (e) {
            return arguments.length ? (t = e, g(), m) : t;
          }, m.id = function (t) {
            return arguments.length ? (f = t, m) : f;
          }, m.iterations = function (t) {
            return arguments.length ? (d = +t, m) : d;
          }, m.strength = function (t) {
            return arguments.length ? (h = "function" == typeof t ? t : a(+t), v(), m) : h;
          }, m.distance = function (t) {
            return arguments.length ? (p = "function" == typeof t ? t : a(+t), y(), m) : p;
          }, m;
        }, t.forceManyBody = function () {
          var t,
              r,
              n,
              i,
              s = a(-30),
              l = 1,
              c = 1 / 0,
              u = .81;

          function p(i) {
            var a,
                o = t.length,
                s = e.quadtree(t, f, h).visitAfter(m);

            for (n = i, a = 0; a < o; ++a) {
              r = t[a], s.visit(g);
            }
          }

          function d() {
            if (t) {
              var e,
                  r,
                  n = t.length;

              for (i = new Array(n), e = 0; e < n; ++e) {
                r = t[e], i[r.index] = +s(r, e, t);
              }
            }
          }

          function m(t) {
            var e,
                r,
                n,
                a,
                o,
                s = 0,
                l = 0;

            if (t.length) {
              for (n = a = o = 0; o < 4; ++o) {
                (e = t[o]) && (r = Math.abs(e.value)) && (s += e.value, l += r, n += r * e.x, a += r * e.y);
              }

              t.x = n / l, t.y = a / l;
            } else {
              (e = t).x = e.data.x, e.y = e.data.y;

              do {
                s += i[e.data.index];
              } while (e = e.next);
            }

            t.value = s;
          }

          function g(t, e, a, s) {
            if (!t.value) return !0;
            var f = t.x - r.x,
                h = t.y - r.y,
                p = s - e,
                d = f * f + h * h;
            if (p * p / u < d) return d < c && (0 === f && (d += (f = o()) * f), 0 === h && (d += (h = o()) * h), d < l && (d = Math.sqrt(l * d)), r.vx += f * t.value * n / d, r.vy += h * t.value * n / d), !0;

            if (!(t.length || d >= c)) {
              (t.data !== r || t.next) && (0 === f && (d += (f = o()) * f), 0 === h && (d += (h = o()) * h), d < l && (d = Math.sqrt(l * d)));

              do {
                t.data !== r && (p = i[t.data.index] * n / d, r.vx += f * p, r.vy += h * p);
              } while (t = t.next);
            }
          }

          return p.initialize = function (e) {
            t = e, d();
          }, p.strength = function (t) {
            return arguments.length ? (s = "function" == typeof t ? t : a(+t), d(), p) : s;
          }, p.distanceMin = function (t) {
            return arguments.length ? (l = t * t, p) : Math.sqrt(l);
          }, p.distanceMax = function (t) {
            return arguments.length ? (c = t * t, p) : Math.sqrt(c);
          }, p.theta = function (t) {
            return arguments.length ? (u = t * t, p) : Math.sqrt(u);
          }, p;
        }, t.forceRadial = function (t, e, r) {
          var n,
              i,
              o,
              s = a(.1);

          function l(t) {
            for (var a = 0, s = n.length; a < s; ++a) {
              var l = n[a],
                  c = l.x - e || 1e-6,
                  u = l.y - r || 1e-6,
                  f = Math.sqrt(c * c + u * u),
                  h = (o[a] - f) * i[a] * t / f;
              l.vx += c * h, l.vy += u * h;
            }
          }

          function c() {
            if (n) {
              var e,
                  r = n.length;

              for (i = new Array(r), o = new Array(r), e = 0; e < r; ++e) {
                o[e] = +t(n[e], e, n), i[e] = isNaN(o[e]) ? 0 : +s(n[e], e, n);
              }
            }
          }

          return "function" != typeof t && (t = a(+t)), null == e && (e = 0), null == r && (r = 0), l.initialize = function (t) {
            n = t, c();
          }, l.strength = function (t) {
            return arguments.length ? (s = "function" == typeof t ? t : a(+t), c(), l) : s;
          }, l.radius = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : a(+e), c(), l) : t;
          }, l.x = function (t) {
            return arguments.length ? (e = +t, l) : e;
          }, l.y = function (t) {
            return arguments.length ? (r = +t, l) : r;
          }, l;
        }, t.forceSimulation = function (t) {
          var e,
              a = 1,
              o = .001,
              s = 1 - Math.pow(o, 1 / 300),
              l = 0,
              c = .6,
              u = r.map(),
              f = i.timer(d),
              h = n.dispatch("tick", "end");

          function d() {
            m(), h.call("tick", e), a < o && (f.stop(), h.call("end", e));
          }

          function m(r) {
            var n,
                i,
                o = t.length;
            void 0 === r && (r = 1);

            for (var f = 0; f < r; ++f) {
              for (a += (l - a) * s, u.each(function (t) {
                t(a);
              }), n = 0; n < o; ++n) {
                null == (i = t[n]).fx ? i.x += i.vx *= c : (i.x = i.fx, i.vx = 0), null == i.fy ? i.y += i.vy *= c : (i.y = i.fy, i.vy = 0);
              }
            }

            return e;
          }

          function g() {
            for (var e, r = 0, n = t.length; r < n; ++r) {
              if ((e = t[r]).index = r, null != e.fx && (e.x = e.fx), null != e.fy && (e.y = e.fy), isNaN(e.x) || isNaN(e.y)) {
                var i = 10 * Math.sqrt(r),
                    a = r * p;
                e.x = i * Math.cos(a), e.y = i * Math.sin(a);
              }

              (isNaN(e.vx) || isNaN(e.vy)) && (e.vx = e.vy = 0);
            }
          }

          function v(e) {
            return e.initialize && e.initialize(t), e;
          }

          return null == t && (t = []), g(), e = {
            tick: m,
            restart: function restart() {
              return f.restart(d), e;
            },
            stop: function stop() {
              return f.stop(), e;
            },
            nodes: function nodes(r) {
              return arguments.length ? (t = r, g(), u.each(v), e) : t;
            },
            alpha: function alpha(t) {
              return arguments.length ? (a = +t, e) : a;
            },
            alphaMin: function alphaMin(t) {
              return arguments.length ? (o = +t, e) : o;
            },
            alphaDecay: function alphaDecay(t) {
              return arguments.length ? (s = +t, e) : +s;
            },
            alphaTarget: function alphaTarget(t) {
              return arguments.length ? (l = +t, e) : l;
            },
            velocityDecay: function velocityDecay(t) {
              return arguments.length ? (c = 1 - t, e) : 1 - c;
            },
            force: function force(t, r) {
              return arguments.length > 1 ? (null == r ? u.remove(t) : u.set(t, v(r)), e) : u.get(t);
            },
            find: function find(e, r, n) {
              var i,
                  a,
                  o,
                  s,
                  l,
                  c = 0,
                  u = t.length;

              for (null == n ? n = 1 / 0 : n *= n, c = 0; c < u; ++c) {
                (o = (i = e - (s = t[c]).x) * i + (a = r - s.y) * a) < n && (l = s, n = o);
              }

              return l;
            },
            on: function on(t, r) {
              return arguments.length > 1 ? (h.on(t, r), e) : h.on(t);
            }
          };
        }, t.forceX = function (t) {
          var e,
              r,
              n,
              i = a(.1);

          function o(t) {
            for (var i, a = 0, o = e.length; a < o; ++a) {
              (i = e[a]).vx += (n[a] - i.x) * r[a] * t;
            }
          }

          function s() {
            if (e) {
              var a,
                  o = e.length;

              for (r = new Array(o), n = new Array(o), a = 0; a < o; ++a) {
                r[a] = isNaN(n[a] = +t(e[a], a, e)) ? 0 : +i(e[a], a, e);
              }
            }
          }

          return "function" != typeof t && (t = a(null == t ? 0 : +t)), o.initialize = function (t) {
            e = t, s();
          }, o.strength = function (t) {
            return arguments.length ? (i = "function" == typeof t ? t : a(+t), s(), o) : i;
          }, o.x = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : a(+e), s(), o) : t;
          }, o;
        }, t.forceY = function (t) {
          var e,
              r,
              n,
              i = a(.1);

          function o(t) {
            for (var i, a = 0, o = e.length; a < o; ++a) {
              (i = e[a]).vy += (n[a] - i.y) * r[a] * t;
            }
          }

          function s() {
            if (e) {
              var a,
                  o = e.length;

              for (r = new Array(o), n = new Array(o), a = 0; a < o; ++a) {
                r[a] = isNaN(n[a] = +t(e[a], a, e)) ? 0 : +i(e[a], a, e);
              }
            }
          }

          return "function" != typeof t && (t = a(null == t ? 0 : +t)), o.initialize = function (t) {
            e = t, s();
          }, o.strength = function (t) {
            return arguments.length ? (i = "function" == typeof t ? t : a(+t), s(), o) : i;
          }, o.y = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : a(+e), s(), o) : t;
          }, o;
        }, Object.defineProperty(t, "__esModule", {
          value: !0
        });
      });
    }, {
      "d3-collection": 158,
      "d3-dispatch": 160,
      "d3-quadtree": 165,
      "d3-timer": 169
    }],
    162: [function (t, e, r) {
      !function (t, n) {
        "object" == _typeof(r) && void 0 !== e ? n(r) : n((t = t || self).d3 = t.d3 || {});
      }(this, function (t) {
        "use strict";

        function e(t, e) {
          return t.parent === e.parent ? 1 : 2;
        }

        function r(t, e) {
          return t + e.x;
        }

        function n(t, e) {
          return Math.max(t, e.y);
        }

        function i(t) {
          var e = 0,
              r = t.children,
              n = r && r.length;
          if (n) for (; --n >= 0;) {
            e += r[n].value;
          } else e = 1;
          t.value = e;
        }

        function a(t, e) {
          var r,
              n,
              i,
              a,
              s,
              u = new c(t),
              f = +t.value && (u.value = t.value),
              h = [u];

          for (null == e && (e = o); r = h.pop();) {
            if (f && (r.value = +r.data.value), (i = e(r.data)) && (s = i.length)) for (r.children = new Array(s), a = s - 1; a >= 0; --a) {
              h.push(n = r.children[a] = new c(i[a])), n.parent = r, n.depth = r.depth + 1;
            }
          }

          return u.eachBefore(l);
        }

        function o(t) {
          return t.children;
        }

        function s(t) {
          t.data = t.data.data;
        }

        function l(t) {
          var e = 0;

          do {
            t.height = e;
          } while ((t = t.parent) && t.height < ++e);
        }

        function c(t) {
          this.data = t, this.depth = this.height = 0, this.parent = null;
        }

        c.prototype = a.prototype = {
          constructor: c,
          count: function count() {
            return this.eachAfter(i);
          },
          each: function each(t) {
            var e,
                r,
                n,
                i,
                a = this,
                o = [a];

            do {
              for (e = o.reverse(), o = []; a = e.pop();) {
                if (t(a), r = a.children) for (n = 0, i = r.length; n < i; ++n) {
                  o.push(r[n]);
                }
              }
            } while (o.length);

            return this;
          },
          eachAfter: function eachAfter(t) {
            for (var e, r, n, i = this, a = [i], o = []; i = a.pop();) {
              if (o.push(i), e = i.children) for (r = 0, n = e.length; r < n; ++r) {
                a.push(e[r]);
              }
            }

            for (; i = o.pop();) {
              t(i);
            }

            return this;
          },
          eachBefore: function eachBefore(t) {
            for (var e, r, n = this, i = [n]; n = i.pop();) {
              if (t(n), e = n.children) for (r = e.length - 1; r >= 0; --r) {
                i.push(e[r]);
              }
            }

            return this;
          },
          sum: function sum(t) {
            return this.eachAfter(function (e) {
              for (var r = +t(e.data) || 0, n = e.children, i = n && n.length; --i >= 0;) {
                r += n[i].value;
              }

              e.value = r;
            });
          },
          sort: function sort(t) {
            return this.eachBefore(function (e) {
              e.children && e.children.sort(t);
            });
          },
          path: function path(t) {
            for (var e = this, r = function (t, e) {
              if (t === e) return t;
              var r = t.ancestors(),
                  n = e.ancestors(),
                  i = null;
              t = r.pop(), e = n.pop();

              for (; t === e;) {
                i = t, t = r.pop(), e = n.pop();
              }

              return i;
            }(e, t), n = [e]; e !== r;) {
              e = e.parent, n.push(e);
            }

            for (var i = n.length; t !== r;) {
              n.splice(i, 0, t), t = t.parent;
            }

            return n;
          },
          ancestors: function ancestors() {
            for (var t = this, e = [t]; t = t.parent;) {
              e.push(t);
            }

            return e;
          },
          descendants: function descendants() {
            var t = [];
            return this.each(function (e) {
              t.push(e);
            }), t;
          },
          leaves: function leaves() {
            var t = [];
            return this.eachBefore(function (e) {
              e.children || t.push(e);
            }), t;
          },
          links: function links() {
            var t = this,
                e = [];
            return t.each(function (r) {
              r !== t && e.push({
                source: r.parent,
                target: r
              });
            }), e;
          },
          copy: function copy() {
            return a(this).eachBefore(s);
          }
        };
        var u = Array.prototype.slice;

        function f(t) {
          for (var e, r, n = 0, i = (t = function (t) {
            for (var e, r, n = t.length; n;) {
              r = Math.random() * n-- | 0, e = t[n], t[n] = t[r], t[r] = e;
            }

            return t;
          }(u.call(t))).length, a = []; n < i;) {
            e = t[n], r && d(r, e) ? ++n : (r = g(a = h(a, e)), n = 0);
          }

          return r;
        }

        function h(t, e) {
          var r, n;
          if (m(e, t)) return [e];

          for (r = 0; r < t.length; ++r) {
            if (p(e, t[r]) && m(v(t[r], e), t)) return [t[r], e];
          }

          for (r = 0; r < t.length - 1; ++r) {
            for (n = r + 1; n < t.length; ++n) {
              if (p(v(t[r], t[n]), e) && p(v(t[r], e), t[n]) && p(v(t[n], e), t[r]) && m(y(t[r], t[n], e), t)) return [t[r], t[n], e];
            }
          }

          throw new Error();
        }

        function p(t, e) {
          var r = t.r - e.r,
              n = e.x - t.x,
              i = e.y - t.y;
          return r < 0 || r * r < n * n + i * i;
        }

        function d(t, e) {
          var r = t.r - e.r + 1e-6,
              n = e.x - t.x,
              i = e.y - t.y;
          return r > 0 && r * r > n * n + i * i;
        }

        function m(t, e) {
          for (var r = 0; r < e.length; ++r) {
            if (!d(t, e[r])) return !1;
          }

          return !0;
        }

        function g(t) {
          switch (t.length) {
            case 1:
              return {
                x: (e = t[0]).x,
                y: e.y,
                r: e.r
              };

            case 2:
              return v(t[0], t[1]);

            case 3:
              return y(t[0], t[1], t[2]);
          }

          var e;
        }

        function v(t, e) {
          var r = t.x,
              n = t.y,
              i = t.r,
              a = e.x,
              o = e.y,
              s = e.r,
              l = a - r,
              c = o - n,
              u = s - i,
              f = Math.sqrt(l * l + c * c);
          return {
            x: (r + a + l / f * u) / 2,
            y: (n + o + c / f * u) / 2,
            r: (f + i + s) / 2
          };
        }

        function y(t, e, r) {
          var n = t.x,
              i = t.y,
              a = t.r,
              o = e.x,
              s = e.y,
              l = e.r,
              c = r.x,
              u = r.y,
              f = r.r,
              h = n - o,
              p = n - c,
              d = i - s,
              m = i - u,
              g = l - a,
              v = f - a,
              y = n * n + i * i - a * a,
              x = y - o * o - s * s + l * l,
              b = y - c * c - u * u + f * f,
              _ = p * d - h * m,
              w = (d * b - m * x) / (2 * _) - n,
              T = (m * g - d * v) / _,
              k = (p * x - h * b) / (2 * _) - i,
              M = (h * v - p * g) / _,
              A = T * T + M * M - 1,
              S = 2 * (a + w * T + k * M),
              E = w * w + k * k - a * a,
              L = -(A ? (S + Math.sqrt(S * S - 4 * A * E)) / (2 * A) : E / S);

          return {
            x: n + w + T * L,
            y: i + k + M * L,
            r: L
          };
        }

        function x(t, e, r) {
          var n,
              i,
              a,
              o,
              s = t.x - e.x,
              l = t.y - e.y,
              c = s * s + l * l;
          c ? (i = e.r + r.r, i *= i, o = t.r + r.r, i > (o *= o) ? (n = (c + o - i) / (2 * c), a = Math.sqrt(Math.max(0, o / c - n * n)), r.x = t.x - n * s - a * l, r.y = t.y - n * l + a * s) : (n = (c + i - o) / (2 * c), a = Math.sqrt(Math.max(0, i / c - n * n)), r.x = e.x + n * s - a * l, r.y = e.y + n * l + a * s)) : (r.x = e.x + r.r, r.y = e.y);
        }

        function b(t, e) {
          var r = t.r + e.r - 1e-6,
              n = e.x - t.x,
              i = e.y - t.y;
          return r > 0 && r * r > n * n + i * i;
        }

        function _(t) {
          var e = t._,
              r = t.next._,
              n = e.r + r.r,
              i = (e.x * r.r + r.x * e.r) / n,
              a = (e.y * r.r + r.y * e.r) / n;
          return i * i + a * a;
        }

        function w(t) {
          this._ = t, this.next = null, this.previous = null;
        }

        function T(t) {
          if (!(i = t.length)) return 0;
          var e, r, n, i, a, o, s, l, c, u, h;
          if ((e = t[0]).x = 0, e.y = 0, !(i > 1)) return e.r;
          if (r = t[1], e.x = -r.r, r.x = e.r, r.y = 0, !(i > 2)) return e.r + r.r;
          x(r, e, n = t[2]), e = new w(e), r = new w(r), n = new w(n), e.next = n.previous = r, r.next = e.previous = n, n.next = r.previous = e;

          t: for (s = 3; s < i; ++s) {
            x(e._, r._, n = t[s]), n = new w(n), l = r.next, c = e.previous, u = r._.r, h = e._.r;

            do {
              if (u <= h) {
                if (b(l._, n._)) {
                  r = l, e.next = r, r.previous = e, --s;
                  continue t;
                }

                u += l._.r, l = l.next;
              } else {
                if (b(c._, n._)) {
                  (e = c).next = r, r.previous = e, --s;
                  continue t;
                }

                h += c._.r, c = c.previous;
              }
            } while (l !== c.next);

            for (n.previous = e, n.next = r, e.next = r.previous = r = n, a = _(e); (n = n.next) !== r;) {
              (o = _(n)) < a && (e = n, a = o);
            }

            r = e.next;
          }

          for (e = [r._], n = r; (n = n.next) !== r;) {
            e.push(n._);
          }

          for (n = f(e), s = 0; s < i; ++s) {
            (e = t[s]).x -= n.x, e.y -= n.y;
          }

          return n.r;
        }

        function k(t) {
          return null == t ? null : M(t);
        }

        function M(t) {
          if ("function" != typeof t) throw new Error();
          return t;
        }

        function A() {
          return 0;
        }

        function S(t) {
          return function () {
            return t;
          };
        }

        function E(t) {
          return Math.sqrt(t.value);
        }

        function L(t) {
          return function (e) {
            e.children || (e.r = Math.max(0, +t(e) || 0));
          };
        }

        function C(t, e) {
          return function (r) {
            if (n = r.children) {
              var n,
                  i,
                  a,
                  o = n.length,
                  s = t(r) * e || 0;
              if (s) for (i = 0; i < o; ++i) {
                n[i].r += s;
              }
              if (a = T(n), s) for (i = 0; i < o; ++i) {
                n[i].r -= s;
              }
              r.r = a + s;
            }
          };
        }

        function P(t) {
          return function (e) {
            var r = e.parent;
            e.r *= t, r && (e.x = r.x + t * e.x, e.y = r.y + t * e.y);
          };
        }

        function I(t) {
          t.x0 = Math.round(t.x0), t.y0 = Math.round(t.y0), t.x1 = Math.round(t.x1), t.y1 = Math.round(t.y1);
        }

        function O(t, e, r, n, i) {
          for (var a, o = t.children, s = -1, l = o.length, c = t.value && (n - e) / t.value; ++s < l;) {
            (a = o[s]).y0 = r, a.y1 = i, a.x0 = e, a.x1 = e += a.value * c;
          }
        }

        var z = {
          depth: -1
        },
            D = {};

        function R(t) {
          return t.id;
        }

        function F(t) {
          return t.parentId;
        }

        function B(t, e) {
          return t.parent === e.parent ? 1 : 2;
        }

        function N(t) {
          var e = t.children;
          return e ? e[0] : t.t;
        }

        function j(t) {
          var e = t.children;
          return e ? e[e.length - 1] : t.t;
        }

        function U(t, e, r) {
          var n = r / (e.i - t.i);
          e.c -= n, e.s += r, t.c += n, e.z += r, e.m += r;
        }

        function V(t, e, r) {
          return t.a.parent === e.parent ? t.a : r;
        }

        function q(t, e) {
          this._ = t, this.parent = null, this.children = null, this.A = null, this.a = this, this.z = 0, this.m = 0, this.c = 0, this.s = 0, this.t = null, this.i = e;
        }

        function H(t, e, r, n, i) {
          for (var a, o = t.children, s = -1, l = o.length, c = t.value && (i - r) / t.value; ++s < l;) {
            (a = o[s]).x0 = e, a.x1 = n, a.y0 = r, a.y1 = r += a.value * c;
          }
        }

        q.prototype = Object.create(c.prototype);
        var G = (1 + Math.sqrt(5)) / 2;

        function Y(t, e, r, n, i, a) {
          for (var o, s, l, c, u, f, h, p, d, m, g, v = [], y = e.children, x = 0, b = 0, _ = y.length, w = e.value; x < _;) {
            l = i - r, c = a - n;

            do {
              u = y[b++].value;
            } while (!u && b < _);

            for (f = h = u, g = u * u * (m = Math.max(c / l, l / c) / (w * t)), d = Math.max(h / g, g / f); b < _; ++b) {
              if (u += s = y[b].value, s < f && (f = s), s > h && (h = s), g = u * u * m, (p = Math.max(h / g, g / f)) > d) {
                u -= s;
                break;
              }

              d = p;
            }

            v.push(o = {
              value: u,
              dice: l < c,
              children: y.slice(x, b)
            }), o.dice ? O(o, r, n, i, w ? n += c * u / w : a) : H(o, r, n, w ? r += l * u / w : i, a), w -= u, x = b;
          }

          return v;
        }

        var W = function t(e) {
          function r(t, r, n, i, a) {
            Y(e, t, r, n, i, a);
          }

          return r.ratio = function (e) {
            return t((e = +e) > 1 ? e : 1);
          }, r;
        }(G);

        var X = function t(e) {
          function r(t, r, n, i, a) {
            if ((o = t._squarify) && o.ratio === e) for (var o, s, l, c, u, f = -1, h = o.length, p = t.value; ++f < h;) {
              for (l = (s = o[f]).children, c = s.value = 0, u = l.length; c < u; ++c) {
                s.value += l[c].value;
              }

              s.dice ? O(s, r, n, i, n += (a - n) * s.value / p) : H(s, r, n, r += (i - r) * s.value / p, a), p -= s.value;
            } else t._squarify = o = Y(e, t, r, n, i, a), o.ratio = e;
          }

          return r.ratio = function (e) {
            return t((e = +e) > 1 ? e : 1);
          }, r;
        }(G);

        t.cluster = function () {
          var t = e,
              i = 1,
              a = 1,
              o = !1;

          function s(e) {
            var s,
                l = 0;
            e.eachAfter(function (e) {
              var i = e.children;
              i ? (e.x = function (t) {
                return t.reduce(r, 0) / t.length;
              }(i), e.y = function (t) {
                return 1 + t.reduce(n, 0);
              }(i)) : (e.x = s ? l += t(e, s) : 0, e.y = 0, s = e);
            });

            var c = function (t) {
              for (var e; e = t.children;) {
                t = e[0];
              }

              return t;
            }(e),
                u = function (t) {
              for (var e; e = t.children;) {
                t = e[e.length - 1];
              }

              return t;
            }(e),
                f = c.x - t(c, u) / 2,
                h = u.x + t(u, c) / 2;

            return e.eachAfter(o ? function (t) {
              t.x = (t.x - e.x) * i, t.y = (e.y - t.y) * a;
            } : function (t) {
              t.x = (t.x - f) / (h - f) * i, t.y = (1 - (e.y ? t.y / e.y : 1)) * a;
            });
          }

          return s.separation = function (e) {
            return arguments.length ? (t = e, s) : t;
          }, s.size = function (t) {
            return arguments.length ? (o = !1, i = +t[0], a = +t[1], s) : o ? null : [i, a];
          }, s.nodeSize = function (t) {
            return arguments.length ? (o = !0, i = +t[0], a = +t[1], s) : o ? [i, a] : null;
          }, s;
        }, t.hierarchy = a, t.pack = function () {
          var t = null,
              e = 1,
              r = 1,
              n = A;

          function i(i) {
            return i.x = e / 2, i.y = r / 2, t ? i.eachBefore(L(t)).eachAfter(C(n, .5)).eachBefore(P(1)) : i.eachBefore(L(E)).eachAfter(C(A, 1)).eachAfter(C(n, i.r / Math.min(e, r))).eachBefore(P(Math.min(e, r) / (2 * i.r))), i;
          }

          return i.radius = function (e) {
            return arguments.length ? (t = k(e), i) : t;
          }, i.size = function (t) {
            return arguments.length ? (e = +t[0], r = +t[1], i) : [e, r];
          }, i.padding = function (t) {
            return arguments.length ? (n = "function" == typeof t ? t : S(+t), i) : n;
          }, i;
        }, t.packEnclose = f, t.packSiblings = function (t) {
          return T(t), t;
        }, t.partition = function () {
          var t = 1,
              e = 1,
              r = 0,
              n = !1;

          function i(i) {
            var a = i.height + 1;
            return i.x0 = i.y0 = r, i.x1 = t, i.y1 = e / a, i.eachBefore(function (t, e) {
              return function (n) {
                n.children && O(n, n.x0, t * (n.depth + 1) / e, n.x1, t * (n.depth + 2) / e);
                var i = n.x0,
                    a = n.y0,
                    o = n.x1 - r,
                    s = n.y1 - r;
                o < i && (i = o = (i + o) / 2), s < a && (a = s = (a + s) / 2), n.x0 = i, n.y0 = a, n.x1 = o, n.y1 = s;
              };
            }(e, a)), n && i.eachBefore(I), i;
          }

          return i.round = function (t) {
            return arguments.length ? (n = !!t, i) : n;
          }, i.size = function (r) {
            return arguments.length ? (t = +r[0], e = +r[1], i) : [t, e];
          }, i.padding = function (t) {
            return arguments.length ? (r = +t, i) : r;
          }, i;
        }, t.stratify = function () {
          var t = R,
              e = F;

          function r(r) {
            var n,
                i,
                a,
                o,
                s,
                u,
                f,
                h = r.length,
                p = new Array(h),
                d = {};

            for (i = 0; i < h; ++i) {
              n = r[i], s = p[i] = new c(n), null != (u = t(n, i, r)) && (u += "") && (d[f = "$" + (s.id = u)] = f in d ? D : s);
            }

            for (i = 0; i < h; ++i) {
              if (s = p[i], null != (u = e(r[i], i, r)) && (u += "")) {
                if (!(o = d["$" + u])) throw new Error("missing: " + u);
                if (o === D) throw new Error("ambiguous: " + u);
                o.children ? o.children.push(s) : o.children = [s], s.parent = o;
              } else {
                if (a) throw new Error("multiple roots");
                a = s;
              }
            }

            if (!a) throw new Error("no root");
            if (a.parent = z, a.eachBefore(function (t) {
              t.depth = t.parent.depth + 1, --h;
            }).eachBefore(l), a.parent = null, h > 0) throw new Error("cycle");
            return a;
          }

          return r.id = function (e) {
            return arguments.length ? (t = M(e), r) : t;
          }, r.parentId = function (t) {
            return arguments.length ? (e = M(t), r) : e;
          }, r;
        }, t.tree = function () {
          var t = B,
              e = 1,
              r = 1,
              n = null;

          function i(i) {
            var l = function (t) {
              for (var e, r, n, i, a, o = new q(t, 0), s = [o]; e = s.pop();) {
                if (n = e._.children) for (e.children = new Array(a = n.length), i = a - 1; i >= 0; --i) {
                  s.push(r = e.children[i] = new q(n[i], i)), r.parent = e;
                }
              }

              return (o.parent = new q(null, 0)).children = [o], o;
            }(i);

            if (l.eachAfter(a), l.parent.m = -l.z, l.eachBefore(o), n) i.eachBefore(s);else {
              var c = i,
                  u = i,
                  f = i;
              i.eachBefore(function (t) {
                t.x < c.x && (c = t), t.x > u.x && (u = t), t.depth > f.depth && (f = t);
              });
              var h = c === u ? 1 : t(c, u) / 2,
                  p = h - c.x,
                  d = e / (u.x + h + p),
                  m = r / (f.depth || 1);
              i.eachBefore(function (t) {
                t.x = (t.x + p) * d, t.y = t.depth * m;
              });
            }
            return i;
          }

          function a(e) {
            var r = e.children,
                n = e.parent.children,
                i = e.i ? n[e.i - 1] : null;

            if (r) {
              !function (t) {
                for (var e, r = 0, n = 0, i = t.children, a = i.length; --a >= 0;) {
                  (e = i[a]).z += r, e.m += r, r += e.s + (n += e.c);
                }
              }(e);
              var a = (r[0].z + r[r.length - 1].z) / 2;
              i ? (e.z = i.z + t(e._, i._), e.m = e.z - a) : e.z = a;
            } else i && (e.z = i.z + t(e._, i._));

            e.parent.A = function (e, r, n) {
              if (r) {
                for (var i, a = e, o = e, s = r, l = a.parent.children[0], c = a.m, u = o.m, f = s.m, h = l.m; s = j(s), a = N(a), s && a;) {
                  l = N(l), (o = j(o)).a = e, (i = s.z + f - a.z - c + t(s._, a._)) > 0 && (U(V(s, e, n), e, i), c += i, u += i), f += s.m, c += a.m, h += l.m, u += o.m;
                }

                s && !j(o) && (o.t = s, o.m += f - u), a && !N(l) && (l.t = a, l.m += c - h, n = e);
              }

              return n;
            }(e, i, e.parent.A || n[0]);
          }

          function o(t) {
            t._.x = t.z + t.parent.m, t.m += t.parent.m;
          }

          function s(t) {
            t.x *= e, t.y = t.depth * r;
          }

          return i.separation = function (e) {
            return arguments.length ? (t = e, i) : t;
          }, i.size = function (t) {
            return arguments.length ? (n = !1, e = +t[0], r = +t[1], i) : n ? null : [e, r];
          }, i.nodeSize = function (t) {
            return arguments.length ? (n = !0, e = +t[0], r = +t[1], i) : n ? [e, r] : null;
          }, i;
        }, t.treemap = function () {
          var t = W,
              e = !1,
              r = 1,
              n = 1,
              i = [0],
              a = A,
              o = A,
              s = A,
              l = A,
              c = A;

          function u(t) {
            return t.x0 = t.y0 = 0, t.x1 = r, t.y1 = n, t.eachBefore(f), i = [0], e && t.eachBefore(I), t;
          }

          function f(e) {
            var r = i[e.depth],
                n = e.x0 + r,
                u = e.y0 + r,
                f = e.x1 - r,
                h = e.y1 - r;
            f < n && (n = f = (n + f) / 2), h < u && (u = h = (u + h) / 2), e.x0 = n, e.y0 = u, e.x1 = f, e.y1 = h, e.children && (r = i[e.depth + 1] = a(e) / 2, n += c(e) - r, u += o(e) - r, (f -= s(e) - r) < n && (n = f = (n + f) / 2), (h -= l(e) - r) < u && (u = h = (u + h) / 2), t(e, n, u, f, h));
          }

          return u.round = function (t) {
            return arguments.length ? (e = !!t, u) : e;
          }, u.size = function (t) {
            return arguments.length ? (r = +t[0], n = +t[1], u) : [r, n];
          }, u.tile = function (e) {
            return arguments.length ? (t = M(e), u) : t;
          }, u.padding = function (t) {
            return arguments.length ? u.paddingInner(t).paddingOuter(t) : u.paddingInner();
          }, u.paddingInner = function (t) {
            return arguments.length ? (a = "function" == typeof t ? t : S(+t), u) : a;
          }, u.paddingOuter = function (t) {
            return arguments.length ? u.paddingTop(t).paddingRight(t).paddingBottom(t).paddingLeft(t) : u.paddingTop();
          }, u.paddingTop = function (t) {
            return arguments.length ? (o = "function" == typeof t ? t : S(+t), u) : o;
          }, u.paddingRight = function (t) {
            return arguments.length ? (s = "function" == typeof t ? t : S(+t), u) : s;
          }, u.paddingBottom = function (t) {
            return arguments.length ? (l = "function" == typeof t ? t : S(+t), u) : l;
          }, u.paddingLeft = function (t) {
            return arguments.length ? (c = "function" == typeof t ? t : S(+t), u) : c;
          }, u;
        }, t.treemapBinary = function (t, e, r, n, i) {
          var a,
              o,
              s = t.children,
              l = s.length,
              c = new Array(l + 1);

          for (c[0] = o = a = 0; a < l; ++a) {
            c[a + 1] = o += s[a].value;
          }

          !function t(e, r, n, i, a, o, l) {
            if (e >= r - 1) {
              var u = s[e];
              return u.x0 = i, u.y0 = a, u.x1 = o, void (u.y1 = l);
            }

            var f = c[e],
                h = n / 2 + f,
                p = e + 1,
                d = r - 1;

            for (; p < d;) {
              var m = p + d >>> 1;
              c[m] < h ? p = m + 1 : d = m;
            }

            h - c[p - 1] < c[p] - h && e + 1 < p && --p;
            var g = c[p] - f,
                v = n - g;

            if (o - i > l - a) {
              var y = (i * v + o * g) / n;
              t(e, p, g, i, a, y, l), t(p, r, v, y, a, o, l);
            } else {
              var x = (a * v + l * g) / n;
              t(e, p, g, i, a, o, x), t(p, r, v, i, x, o, l);
            }
          }(0, l, t.value, e, r, n, i);
        }, t.treemapDice = O, t.treemapResquarify = X, t.treemapSlice = H, t.treemapSliceDice = function (t, e, r, n, i) {
          (1 & t.depth ? H : O)(t, e, r, n, i);
        }, t.treemapSquarify = W, Object.defineProperty(t, "__esModule", {
          value: !0
        });
      });
    }, {}],
    163: [function (t, e, r) {
      !function (n, i) {
        "object" == _typeof(r) && void 0 !== e ? i(r, t("d3-color")) : i((n = n || self).d3 = n.d3 || {}, n.d3);
      }(this, function (t, e) {
        "use strict";

        function r(t, e, r, n, i) {
          var a = t * t,
              o = a * t;
          return ((1 - 3 * t + 3 * a - o) * e + (4 - 6 * a + 3 * o) * r + (1 + 3 * t + 3 * a - 3 * o) * n + o * i) / 6;
        }

        function n(t) {
          var e = t.length - 1;
          return function (n) {
            var i = n <= 0 ? n = 0 : n >= 1 ? (n = 1, e - 1) : Math.floor(n * e),
                a = t[i],
                o = t[i + 1],
                s = i > 0 ? t[i - 1] : 2 * a - o,
                l = i < e - 1 ? t[i + 2] : 2 * o - a;
            return r((n - i / e) * e, s, a, o, l);
          };
        }

        function i(t) {
          var e = t.length;
          return function (n) {
            var i = Math.floor(((n %= 1) < 0 ? ++n : n) * e),
                a = t[(i + e - 1) % e],
                o = t[i % e],
                s = t[(i + 1) % e],
                l = t[(i + 2) % e];
            return r((n - i / e) * e, a, o, s, l);
          };
        }

        function a(t) {
          return function () {
            return t;
          };
        }

        function o(t, e) {
          return function (r) {
            return t + r * e;
          };
        }

        function s(t, e) {
          var r = e - t;
          return r ? o(t, r > 180 || r < -180 ? r - 360 * Math.round(r / 360) : r) : a(isNaN(t) ? e : t);
        }

        function l(t) {
          return 1 == (t = +t) ? c : function (e, r) {
            return r - e ? function (t, e, r) {
              return t = Math.pow(t, r), e = Math.pow(e, r) - t, r = 1 / r, function (n) {
                return Math.pow(t + n * e, r);
              };
            }(e, r, t) : a(isNaN(e) ? r : e);
          };
        }

        function c(t, e) {
          var r = e - t;
          return r ? o(t, r) : a(isNaN(t) ? e : t);
        }

        var u = function t(r) {
          var n = l(r);

          function i(t, r) {
            var i = n((t = e.rgb(t)).r, (r = e.rgb(r)).r),
                a = n(t.g, r.g),
                o = n(t.b, r.b),
                s = c(t.opacity, r.opacity);
            return function (e) {
              return t.r = i(e), t.g = a(e), t.b = o(e), t.opacity = s(e), t + "";
            };
          }

          return i.gamma = t, i;
        }(1);

        function f(t) {
          return function (r) {
            var n,
                i,
                a = r.length,
                o = new Array(a),
                s = new Array(a),
                l = new Array(a);

            for (n = 0; n < a; ++n) {
              i = e.rgb(r[n]), o[n] = i.r || 0, s[n] = i.g || 0, l[n] = i.b || 0;
            }

            return o = t(o), s = t(s), l = t(l), i.opacity = 1, function (t) {
              return i.r = o(t), i.g = s(t), i.b = l(t), i + "";
            };
          };
        }

        var h = f(n),
            p = f(i);

        function d(t, e) {
          e || (e = []);
          var r,
              n = t ? Math.min(e.length, t.length) : 0,
              i = e.slice();
          return function (a) {
            for (r = 0; r < n; ++r) {
              i[r] = t[r] * (1 - a) + e[r] * a;
            }

            return i;
          };
        }

        function m(t) {
          return ArrayBuffer.isView(t) && !(t instanceof DataView);
        }

        function g(t, e) {
          var r,
              n = e ? e.length : 0,
              i = t ? Math.min(n, t.length) : 0,
              a = new Array(i),
              o = new Array(n);

          for (r = 0; r < i; ++r) {
            a[r] = T(t[r], e[r]);
          }

          for (; r < n; ++r) {
            o[r] = e[r];
          }

          return function (t) {
            for (r = 0; r < i; ++r) {
              o[r] = a[r](t);
            }

            return o;
          };
        }

        function v(t, e) {
          var r = new Date();
          return t = +t, e = +e, function (n) {
            return r.setTime(t * (1 - n) + e * n), r;
          };
        }

        function y(t, e) {
          return t = +t, e = +e, function (r) {
            return t * (1 - r) + e * r;
          };
        }

        function x(t, e) {
          var r,
              n = {},
              i = {};

          for (r in null !== t && "object" == _typeof(t) || (t = {}), null !== e && "object" == _typeof(e) || (e = {}), e) {
            r in t ? n[r] = T(t[r], e[r]) : i[r] = e[r];
          }

          return function (t) {
            for (r in n) {
              i[r] = n[r](t);
            }

            return i;
          };
        }

        var b = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
            _ = new RegExp(b.source, "g");

        function w(t, e) {
          var r,
              n,
              i,
              a = b.lastIndex = _.lastIndex = 0,
              o = -1,
              s = [],
              l = [];

          for (t += "", e += ""; (r = b.exec(t)) && (n = _.exec(e));) {
            (i = n.index) > a && (i = e.slice(a, i), s[o] ? s[o] += i : s[++o] = i), (r = r[0]) === (n = n[0]) ? s[o] ? s[o] += n : s[++o] = n : (s[++o] = null, l.push({
              i: o,
              x: y(r, n)
            })), a = _.lastIndex;
          }

          return a < e.length && (i = e.slice(a), s[o] ? s[o] += i : s[++o] = i), s.length < 2 ? l[0] ? function (t) {
            return function (e) {
              return t(e) + "";
            };
          }(l[0].x) : function (t) {
            return function () {
              return t;
            };
          }(e) : (e = l.length, function (t) {
            for (var r, n = 0; n < e; ++n) {
              s[(r = l[n]).i] = r.x(t);
            }

            return s.join("");
          });
        }

        function T(t, r) {
          var n,
              i = _typeof(r);

          return null == r || "boolean" === i ? a(r) : ("number" === i ? y : "string" === i ? (n = e.color(r)) ? (r = n, u) : w : r instanceof e.color ? u : r instanceof Date ? v : m(r) ? d : Array.isArray(r) ? g : "function" != typeof r.valueOf && "function" != typeof r.toString || isNaN(r) ? x : y)(t, r);
        }

        var k,
            M,
            A,
            S,
            E = 180 / Math.PI,
            L = {
          translateX: 0,
          translateY: 0,
          rotate: 0,
          skewX: 0,
          scaleX: 1,
          scaleY: 1
        };

        function C(t, e, r, n, i, a) {
          var o, s, l;
          return (o = Math.sqrt(t * t + e * e)) && (t /= o, e /= o), (l = t * r + e * n) && (r -= t * l, n -= e * l), (s = Math.sqrt(r * r + n * n)) && (r /= s, n /= s, l /= s), t * n < e * r && (t = -t, e = -e, l = -l, o = -o), {
            translateX: i,
            translateY: a,
            rotate: Math.atan2(e, t) * E,
            skewX: Math.atan(l) * E,
            scaleX: o,
            scaleY: s
          };
        }

        function P(t, e, r, n) {
          function i(t) {
            return t.length ? t.pop() + " " : "";
          }

          return function (a, o) {
            var s = [],
                l = [];
            return a = t(a), o = t(o), function (t, n, i, a, o, s) {
              if (t !== i || n !== a) {
                var l = o.push("translate(", null, e, null, r);
                s.push({
                  i: l - 4,
                  x: y(t, i)
                }, {
                  i: l - 2,
                  x: y(n, a)
                });
              } else (i || a) && o.push("translate(" + i + e + a + r);
            }(a.translateX, a.translateY, o.translateX, o.translateY, s, l), function (t, e, r, a) {
              t !== e ? (t - e > 180 ? e += 360 : e - t > 180 && (t += 360), a.push({
                i: r.push(i(r) + "rotate(", null, n) - 2,
                x: y(t, e)
              })) : e && r.push(i(r) + "rotate(" + e + n);
            }(a.rotate, o.rotate, s, l), function (t, e, r, a) {
              t !== e ? a.push({
                i: r.push(i(r) + "skewX(", null, n) - 2,
                x: y(t, e)
              }) : e && r.push(i(r) + "skewX(" + e + n);
            }(a.skewX, o.skewX, s, l), function (t, e, r, n, a, o) {
              if (t !== r || e !== n) {
                var s = a.push(i(a) + "scale(", null, ",", null, ")");
                o.push({
                  i: s - 4,
                  x: y(t, r)
                }, {
                  i: s - 2,
                  x: y(e, n)
                });
              } else 1 === r && 1 === n || a.push(i(a) + "scale(" + r + "," + n + ")");
            }(a.scaleX, a.scaleY, o.scaleX, o.scaleY, s, l), a = o = null, function (t) {
              for (var e, r = -1, n = l.length; ++r < n;) {
                s[(e = l[r]).i] = e.x(t);
              }

              return s.join("");
            };
          };
        }

        var I = P(function (t) {
          return "none" === t ? L : (k || (k = document.createElement("DIV"), M = document.documentElement, A = document.defaultView), k.style.transform = t, t = A.getComputedStyle(M.appendChild(k), null).getPropertyValue("transform"), M.removeChild(k), C(+(t = t.slice(7, -1).split(","))[0], +t[1], +t[2], +t[3], +t[4], +t[5]));
        }, "px, ", "px)", "deg)"),
            O = P(function (t) {
          return null == t ? L : (S || (S = document.createElementNS("http://www.w3.org/2000/svg", "g")), S.setAttribute("transform", t), (t = S.transform.baseVal.consolidate()) ? C((t = t.matrix).a, t.b, t.c, t.d, t.e, t.f) : L);
        }, ", ", ")", ")"),
            z = Math.SQRT2;

        function D(t) {
          return ((t = Math.exp(t)) + 1 / t) / 2;
        }

        function R(t) {
          return function (r, n) {
            var i = t((r = e.hsl(r)).h, (n = e.hsl(n)).h),
                a = c(r.s, n.s),
                o = c(r.l, n.l),
                s = c(r.opacity, n.opacity);
            return function (t) {
              return r.h = i(t), r.s = a(t), r.l = o(t), r.opacity = s(t), r + "";
            };
          };
        }

        var F = R(s),
            B = R(c);

        function N(t) {
          return function (r, n) {
            var i = t((r = e.hcl(r)).h, (n = e.hcl(n)).h),
                a = c(r.c, n.c),
                o = c(r.l, n.l),
                s = c(r.opacity, n.opacity);
            return function (t) {
              return r.h = i(t), r.c = a(t), r.l = o(t), r.opacity = s(t), r + "";
            };
          };
        }

        var j = N(s),
            U = N(c);

        function V(t) {
          return function r(n) {
            function i(r, i) {
              var a = t((r = e.cubehelix(r)).h, (i = e.cubehelix(i)).h),
                  o = c(r.s, i.s),
                  s = c(r.l, i.l),
                  l = c(r.opacity, i.opacity);
              return function (t) {
                return r.h = a(t), r.s = o(t), r.l = s(Math.pow(t, n)), r.opacity = l(t), r + "";
              };
            }

            return n = +n, i.gamma = r, i;
          }(1);
        }

        var q = V(s),
            H = V(c);
        t.interpolate = T, t.interpolateArray = function (t, e) {
          return (m(e) ? d : g)(t, e);
        }, t.interpolateBasis = n, t.interpolateBasisClosed = i, t.interpolateCubehelix = q, t.interpolateCubehelixLong = H, t.interpolateDate = v, t.interpolateDiscrete = function (t) {
          var e = t.length;
          return function (r) {
            return t[Math.max(0, Math.min(e - 1, Math.floor(r * e)))];
          };
        }, t.interpolateHcl = j, t.interpolateHclLong = U, t.interpolateHsl = F, t.interpolateHslLong = B, t.interpolateHue = function (t, e) {
          var r = s(+t, +e);
          return function (t) {
            var e = r(t);
            return e - 360 * Math.floor(e / 360);
          };
        }, t.interpolateLab = function (t, r) {
          var n = c((t = e.lab(t)).l, (r = e.lab(r)).l),
              i = c(t.a, r.a),
              a = c(t.b, r.b),
              o = c(t.opacity, r.opacity);
          return function (e) {
            return t.l = n(e), t.a = i(e), t.b = a(e), t.opacity = o(e), t + "";
          };
        }, t.interpolateNumber = y, t.interpolateNumberArray = d, t.interpolateObject = x, t.interpolateRgb = u, t.interpolateRgbBasis = h, t.interpolateRgbBasisClosed = p, t.interpolateRound = function (t, e) {
          return t = +t, e = +e, function (r) {
            return Math.round(t * (1 - r) + e * r);
          };
        }, t.interpolateString = w, t.interpolateTransformCss = I, t.interpolateTransformSvg = O, t.interpolateZoom = function (t, e) {
          var r,
              n,
              i = t[0],
              a = t[1],
              o = t[2],
              s = e[0],
              l = e[1],
              c = e[2],
              u = s - i,
              f = l - a,
              h = u * u + f * f;
          if (h < 1e-12) n = Math.log(c / o) / z, r = function r(t) {
            return [i + t * u, a + t * f, o * Math.exp(z * t * n)];
          };else {
            var p = Math.sqrt(h),
                d = (c * c - o * o + 4 * h) / (2 * o * 2 * p),
                m = (c * c - o * o - 4 * h) / (2 * c * 2 * p),
                g = Math.log(Math.sqrt(d * d + 1) - d),
                v = Math.log(Math.sqrt(m * m + 1) - m);
            n = (v - g) / z, r = function r(t) {
              var e,
                  r = t * n,
                  s = D(g),
                  l = o / (2 * p) * (s * (e = z * r + g, ((e = Math.exp(2 * e)) - 1) / (e + 1)) - function (t) {
                return ((t = Math.exp(t)) - 1 / t) / 2;
              }(g));

              return [i + l * u, a + l * f, o * s / D(z * r + g)];
            };
          }
          return r.duration = 1e3 * n, r;
        }, t.piecewise = function (t, e) {
          for (var r = 0, n = e.length - 1, i = e[0], a = new Array(n < 0 ? 0 : n); r < n;) {
            a[r] = t(i, i = e[++r]);
          }

          return function (t) {
            var e = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
            return a[e](t - e);
          };
        }, t.quantize = function (t, e) {
          for (var r = new Array(e), n = 0; n < e; ++n) {
            r[n] = t(n / (e - 1));
          }

          return r;
        }, Object.defineProperty(t, "__esModule", {
          value: !0
        });
      });
    }, {
      "d3-color": 159
    }],
    164: [function (t, e, r) {
      !function (t, n) {
        "object" == _typeof(r) && void 0 !== e ? n(r) : n((t = t || self).d3 = t.d3 || {});
      }(this, function (t) {
        "use strict";

        var e = Math.PI,
            r = 2 * e,
            n = r - 1e-6;

        function i() {
          this._x0 = this._y0 = this._x1 = this._y1 = null, this._ = "";
        }

        function a() {
          return new i();
        }

        i.prototype = a.prototype = {
          constructor: i,
          moveTo: function moveTo(t, e) {
            this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e);
          },
          closePath: function closePath() {
            null !== this._x1 && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
          },
          lineTo: function lineTo(t, e) {
            this._ += "L" + (this._x1 = +t) + "," + (this._y1 = +e);
          },
          quadraticCurveTo: function quadraticCurveTo(t, e, r, n) {
            this._ += "Q" + +t + "," + +e + "," + (this._x1 = +r) + "," + (this._y1 = +n);
          },
          bezierCurveTo: function bezierCurveTo(t, e, r, n, i, a) {
            this._ += "C" + +t + "," + +e + "," + +r + "," + +n + "," + (this._x1 = +i) + "," + (this._y1 = +a);
          },
          arcTo: function arcTo(t, r, n, i, a) {
            t = +t, r = +r, n = +n, i = +i, a = +a;
            var o = this._x1,
                s = this._y1,
                l = n - t,
                c = i - r,
                u = o - t,
                f = s - r,
                h = u * u + f * f;
            if (a < 0) throw new Error("negative radius: " + a);
            if (null === this._x1) this._ += "M" + (this._x1 = t) + "," + (this._y1 = r);else if (h > 1e-6) {
              if (Math.abs(f * l - c * u) > 1e-6 && a) {
                var p = n - o,
                    d = i - s,
                    m = l * l + c * c,
                    g = p * p + d * d,
                    v = Math.sqrt(m),
                    y = Math.sqrt(h),
                    x = a * Math.tan((e - Math.acos((m + h - g) / (2 * v * y))) / 2),
                    b = x / y,
                    _ = x / v;

                Math.abs(b - 1) > 1e-6 && (this._ += "L" + (t + b * u) + "," + (r + b * f)), this._ += "A" + a + "," + a + ",0,0," + +(f * p > u * d) + "," + (this._x1 = t + _ * l) + "," + (this._y1 = r + _ * c);
              } else this._ += "L" + (this._x1 = t) + "," + (this._y1 = r);
            } else ;
          },
          arc: function arc(t, i, a, o, s, l) {
            t = +t, i = +i, l = !!l;
            var c = (a = +a) * Math.cos(o),
                u = a * Math.sin(o),
                f = t + c,
                h = i + u,
                p = 1 ^ l,
                d = l ? o - s : s - o;
            if (a < 0) throw new Error("negative radius: " + a);
            null === this._x1 ? this._ += "M" + f + "," + h : (Math.abs(this._x1 - f) > 1e-6 || Math.abs(this._y1 - h) > 1e-6) && (this._ += "L" + f + "," + h), a && (d < 0 && (d = d % r + r), d > n ? this._ += "A" + a + "," + a + ",0,1," + p + "," + (t - c) + "," + (i - u) + "A" + a + "," + a + ",0,1," + p + "," + (this._x1 = f) + "," + (this._y1 = h) : d > 1e-6 && (this._ += "A" + a + "," + a + ",0," + +(d >= e) + "," + p + "," + (this._x1 = t + a * Math.cos(s)) + "," + (this._y1 = i + a * Math.sin(s))));
          },
          rect: function rect(t, e, r, n) {
            this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e) + "h" + +r + "v" + +n + "h" + -r + "Z";
          },
          toString: function toString() {
            return this._;
          }
        }, t.path = a, Object.defineProperty(t, "__esModule", {
          value: !0
        });
      });
    }, {}],
    165: [function (t, e, r) {
      !function (t, n) {
        "object" == _typeof(r) && void 0 !== e ? n(r) : n((t = t || self).d3 = t.d3 || {});
      }(this, function (t) {
        "use strict";

        function e(t, e, r, n) {
          if (isNaN(e) || isNaN(r)) return t;
          var i,
              a,
              o,
              s,
              l,
              c,
              u,
              f,
              h,
              p = t._root,
              d = {
            data: n
          },
              m = t._x0,
              g = t._y0,
              v = t._x1,
              y = t._y1;
          if (!p) return t._root = d, t;

          for (; p.length;) {
            if ((c = e >= (a = (m + v) / 2)) ? m = a : v = a, (u = r >= (o = (g + y) / 2)) ? g = o : y = o, i = p, !(p = p[f = u << 1 | c])) return i[f] = d, t;
          }

          if (s = +t._x.call(null, p.data), l = +t._y.call(null, p.data), e === s && r === l) return d.next = p, i ? i[f] = d : t._root = d, t;

          do {
            i = i ? i[f] = new Array(4) : t._root = new Array(4), (c = e >= (a = (m + v) / 2)) ? m = a : v = a, (u = r >= (o = (g + y) / 2)) ? g = o : y = o;
          } while ((f = u << 1 | c) == (h = (l >= o) << 1 | s >= a));

          return i[h] = p, i[f] = d, t;
        }

        function r(t, e, r, n, i) {
          this.node = t, this.x0 = e, this.y0 = r, this.x1 = n, this.y1 = i;
        }

        function n(t) {
          return t[0];
        }

        function i(t) {
          return t[1];
        }

        function a(t, e, r) {
          var a = new o(null == e ? n : e, null == r ? i : r, NaN, NaN, NaN, NaN);
          return null == t ? a : a.addAll(t);
        }

        function o(t, e, r, n, i, a) {
          this._x = t, this._y = e, this._x0 = r, this._y0 = n, this._x1 = i, this._y1 = a, this._root = void 0;
        }

        function s(t) {
          for (var e = {
            data: t.data
          }, r = e; t = t.next;) {
            r = r.next = {
              data: t.data
            };
          }

          return e;
        }

        var l = a.prototype = o.prototype;
        l.copy = function () {
          var t,
              e,
              r = new o(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
              n = this._root;
          if (!n) return r;
          if (!n.length) return r._root = s(n), r;

          for (t = [{
            source: n,
            target: r._root = new Array(4)
          }]; n = t.pop();) {
            for (var i = 0; i < 4; ++i) {
              (e = n.source[i]) && (e.length ? t.push({
                source: e,
                target: n.target[i] = new Array(4)
              }) : n.target[i] = s(e));
            }
          }

          return r;
        }, l.add = function (t) {
          var r = +this._x.call(null, t),
              n = +this._y.call(null, t);
          return e(this.cover(r, n), r, n, t);
        }, l.addAll = function (t) {
          var r,
              n,
              i,
              a,
              o = t.length,
              s = new Array(o),
              l = new Array(o),
              c = 1 / 0,
              u = 1 / 0,
              f = -1 / 0,
              h = -1 / 0;

          for (n = 0; n < o; ++n) {
            isNaN(i = +this._x.call(null, r = t[n])) || isNaN(a = +this._y.call(null, r)) || (s[n] = i, l[n] = a, i < c && (c = i), i > f && (f = i), a < u && (u = a), a > h && (h = a));
          }

          if (c > f || u > h) return this;

          for (this.cover(c, u).cover(f, h), n = 0; n < o; ++n) {
            e(this, s[n], l[n], t[n]);
          }

          return this;
        }, l.cover = function (t, e) {
          if (isNaN(t = +t) || isNaN(e = +e)) return this;
          var r = this._x0,
              n = this._y0,
              i = this._x1,
              a = this._y1;
          if (isNaN(r)) i = (r = Math.floor(t)) + 1, a = (n = Math.floor(e)) + 1;else {
            for (var o, s, l = i - r, c = this._root; r > t || t >= i || n > e || e >= a;) {
              switch (s = (e < n) << 1 | t < r, (o = new Array(4))[s] = c, c = o, l *= 2, s) {
                case 0:
                  i = r + l, a = n + l;
                  break;

                case 1:
                  r = i - l, a = n + l;
                  break;

                case 2:
                  i = r + l, n = a - l;
                  break;

                case 3:
                  r = i - l, n = a - l;
              }
            }

            this._root && this._root.length && (this._root = c);
          }
          return this._x0 = r, this._y0 = n, this._x1 = i, this._y1 = a, this;
        }, l.data = function () {
          var t = [];
          return this.visit(function (e) {
            if (!e.length) do {
              t.push(e.data);
            } while (e = e.next);
          }), t;
        }, l.extent = function (t) {
          return arguments.length ? this.cover(+t[0][0], +t[0][1]).cover(+t[1][0], +t[1][1]) : isNaN(this._x0) ? void 0 : [[this._x0, this._y0], [this._x1, this._y1]];
        }, l.find = function (t, e, n) {
          var i,
              a,
              o,
              s,
              l,
              c,
              u,
              f = this._x0,
              h = this._y0,
              p = this._x1,
              d = this._y1,
              m = [],
              g = this._root;

          for (g && m.push(new r(g, f, h, p, d)), null == n ? n = 1 / 0 : (f = t - n, h = e - n, p = t + n, d = e + n, n *= n); c = m.pop();) {
            if (!(!(g = c.node) || (a = c.x0) > p || (o = c.y0) > d || (s = c.x1) < f || (l = c.y1) < h)) if (g.length) {
              var v = (a + s) / 2,
                  y = (o + l) / 2;
              m.push(new r(g[3], v, y, s, l), new r(g[2], a, y, v, l), new r(g[1], v, o, s, y), new r(g[0], a, o, v, y)), (u = (e >= y) << 1 | t >= v) && (c = m[m.length - 1], m[m.length - 1] = m[m.length - 1 - u], m[m.length - 1 - u] = c);
            } else {
              var x = t - +this._x.call(null, g.data),
                  b = e - +this._y.call(null, g.data),
                  _ = x * x + b * b;

              if (_ < n) {
                var w = Math.sqrt(n = _);
                f = t - w, h = e - w, p = t + w, d = e + w, i = g.data;
              }
            }
          }

          return i;
        }, l.remove = function (t) {
          if (isNaN(a = +this._x.call(null, t)) || isNaN(o = +this._y.call(null, t))) return this;
          var e,
              r,
              n,
              i,
              a,
              o,
              s,
              l,
              c,
              u,
              f,
              h,
              p = this._root,
              d = this._x0,
              m = this._y0,
              g = this._x1,
              v = this._y1;
          if (!p) return this;
          if (p.length) for (;;) {
            if ((c = a >= (s = (d + g) / 2)) ? d = s : g = s, (u = o >= (l = (m + v) / 2)) ? m = l : v = l, e = p, !(p = p[f = u << 1 | c])) return this;
            if (!p.length) break;
            (e[f + 1 & 3] || e[f + 2 & 3] || e[f + 3 & 3]) && (r = e, h = f);
          }

          for (; p.data !== t;) {
            if (n = p, !(p = p.next)) return this;
          }

          return (i = p.next) && delete p.next, n ? (i ? n.next = i : delete n.next, this) : e ? (i ? e[f] = i : delete e[f], (p = e[0] || e[1] || e[2] || e[3]) && p === (e[3] || e[2] || e[1] || e[0]) && !p.length && (r ? r[h] = p : this._root = p), this) : (this._root = i, this);
        }, l.removeAll = function (t) {
          for (var e = 0, r = t.length; e < r; ++e) {
            this.remove(t[e]);
          }

          return this;
        }, l.root = function () {
          return this._root;
        }, l.size = function () {
          var t = 0;
          return this.visit(function (e) {
            if (!e.length) do {
              ++t;
            } while (e = e.next);
          }), t;
        }, l.visit = function (t) {
          var e,
              n,
              i,
              a,
              o,
              s,
              l = [],
              c = this._root;

          for (c && l.push(new r(c, this._x0, this._y0, this._x1, this._y1)); e = l.pop();) {
            if (!t(c = e.node, i = e.x0, a = e.y0, o = e.x1, s = e.y1) && c.length) {
              var u = (i + o) / 2,
                  f = (a + s) / 2;
              (n = c[3]) && l.push(new r(n, u, f, o, s)), (n = c[2]) && l.push(new r(n, i, f, u, s)), (n = c[1]) && l.push(new r(n, u, a, o, f)), (n = c[0]) && l.push(new r(n, i, a, u, f));
            }
          }

          return this;
        }, l.visitAfter = function (t) {
          var e,
              n = [],
              i = [];

          for (this._root && n.push(new r(this._root, this._x0, this._y0, this._x1, this._y1)); e = n.pop();) {
            var a = e.node;

            if (a.length) {
              var o,
                  s = e.x0,
                  l = e.y0,
                  c = e.x1,
                  u = e.y1,
                  f = (s + c) / 2,
                  h = (l + u) / 2;
              (o = a[0]) && n.push(new r(o, s, l, f, h)), (o = a[1]) && n.push(new r(o, f, l, c, h)), (o = a[2]) && n.push(new r(o, s, h, f, u)), (o = a[3]) && n.push(new r(o, f, h, c, u));
            }

            i.push(e);
          }

          for (; e = i.pop();) {
            t(e.node, e.x0, e.y0, e.x1, e.y1);
          }

          return this;
        }, l.x = function (t) {
          return arguments.length ? (this._x = t, this) : this._x;
        }, l.y = function (t) {
          return arguments.length ? (this._y = t, this) : this._y;
        }, t.quadtree = a, Object.defineProperty(t, "__esModule", {
          value: !0
        });
      });
    }, {}],
    166: [function (t, e, r) {
      !function (n, i) {
        "object" == _typeof(r) && void 0 !== e ? i(r, t("d3-path")) : i((n = n || self).d3 = n.d3 || {}, n.d3);
      }(this, function (t, e) {
        "use strict";

        function r(t) {
          return function () {
            return t;
          };
        }

        var n = Math.abs,
            i = Math.atan2,
            a = Math.cos,
            o = Math.max,
            s = Math.min,
            l = Math.sin,
            c = Math.sqrt,
            u = Math.PI,
            f = u / 2,
            h = 2 * u;

        function p(t) {
          return t > 1 ? 0 : t < -1 ? u : Math.acos(t);
        }

        function d(t) {
          return t >= 1 ? f : t <= -1 ? -f : Math.asin(t);
        }

        function m(t) {
          return t.innerRadius;
        }

        function g(t) {
          return t.outerRadius;
        }

        function v(t) {
          return t.startAngle;
        }

        function y(t) {
          return t.endAngle;
        }

        function x(t) {
          return t && t.padAngle;
        }

        function b(t, e, r, n, i, a, o, s) {
          var l = r - t,
              c = n - e,
              u = o - i,
              f = s - a,
              h = f * l - u * c;
          if (!(h * h < 1e-12)) return [t + (h = (u * (e - a) - f * (t - i)) / h) * l, e + h * c];
        }

        function _(t, e, r, n, i, a, s) {
          var l = t - r,
              u = e - n,
              f = (s ? a : -a) / c(l * l + u * u),
              h = f * u,
              p = -f * l,
              d = t + h,
              m = e + p,
              g = r + h,
              v = n + p,
              y = (d + g) / 2,
              x = (m + v) / 2,
              b = g - d,
              _ = v - m,
              w = b * b + _ * _,
              T = i - a,
              k = d * v - g * m,
              M = (_ < 0 ? -1 : 1) * c(o(0, T * T * w - k * k)),
              A = (k * _ - b * M) / w,
              S = (-k * b - _ * M) / w,
              E = (k * _ + b * M) / w,
              L = (-k * b + _ * M) / w,
              C = A - y,
              P = S - x,
              I = E - y,
              O = L - x;

          return C * C + P * P > I * I + O * O && (A = E, S = L), {
            cx: A,
            cy: S,
            x01: -h,
            y01: -p,
            x11: A * (i / T - 1),
            y11: S * (i / T - 1)
          };
        }

        function w(t) {
          this._context = t;
        }

        function T(t) {
          return new w(t);
        }

        function k(t) {
          return t[0];
        }

        function M(t) {
          return t[1];
        }

        function A() {
          var t = k,
              n = M,
              i = r(!0),
              a = null,
              o = T,
              s = null;

          function l(r) {
            var l,
                c,
                u,
                f = r.length,
                h = !1;

            for (null == a && (s = o(u = e.path())), l = 0; l <= f; ++l) {
              !(l < f && i(c = r[l], l, r)) === h && ((h = !h) ? s.lineStart() : s.lineEnd()), h && s.point(+t(c, l, r), +n(c, l, r));
            }

            if (u) return s = null, u + "" || null;
          }

          return l.x = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : r(+e), l) : t;
          }, l.y = function (t) {
            return arguments.length ? (n = "function" == typeof t ? t : r(+t), l) : n;
          }, l.defined = function (t) {
            return arguments.length ? (i = "function" == typeof t ? t : r(!!t), l) : i;
          }, l.curve = function (t) {
            return arguments.length ? (o = t, null != a && (s = o(a)), l) : o;
          }, l.context = function (t) {
            return arguments.length ? (null == t ? a = s = null : s = o(a = t), l) : a;
          }, l;
        }

        function S() {
          var t = k,
              n = null,
              i = r(0),
              a = M,
              o = r(!0),
              s = null,
              l = T,
              c = null;

          function u(r) {
            var u,
                f,
                h,
                p,
                d,
                m = r.length,
                g = !1,
                v = new Array(m),
                y = new Array(m);

            for (null == s && (c = l(d = e.path())), u = 0; u <= m; ++u) {
              if (!(u < m && o(p = r[u], u, r)) === g) if (g = !g) f = u, c.areaStart(), c.lineStart();else {
                for (c.lineEnd(), c.lineStart(), h = u - 1; h >= f; --h) {
                  c.point(v[h], y[h]);
                }

                c.lineEnd(), c.areaEnd();
              }
              g && (v[u] = +t(p, u, r), y[u] = +i(p, u, r), c.point(n ? +n(p, u, r) : v[u], a ? +a(p, u, r) : y[u]));
            }

            if (d) return c = null, d + "" || null;
          }

          function f() {
            return A().defined(o).curve(l).context(s);
          }

          return u.x = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : r(+e), n = null, u) : t;
          }, u.x0 = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : r(+e), u) : t;
          }, u.x1 = function (t) {
            return arguments.length ? (n = null == t ? null : "function" == typeof t ? t : r(+t), u) : n;
          }, u.y = function (t) {
            return arguments.length ? (i = "function" == typeof t ? t : r(+t), a = null, u) : i;
          }, u.y0 = function (t) {
            return arguments.length ? (i = "function" == typeof t ? t : r(+t), u) : i;
          }, u.y1 = function (t) {
            return arguments.length ? (a = null == t ? null : "function" == typeof t ? t : r(+t), u) : a;
          }, u.lineX0 = u.lineY0 = function () {
            return f().x(t).y(i);
          }, u.lineY1 = function () {
            return f().x(t).y(a);
          }, u.lineX1 = function () {
            return f().x(n).y(i);
          }, u.defined = function (t) {
            return arguments.length ? (o = "function" == typeof t ? t : r(!!t), u) : o;
          }, u.curve = function (t) {
            return arguments.length ? (l = t, null != s && (c = l(s)), u) : l;
          }, u.context = function (t) {
            return arguments.length ? (null == t ? s = c = null : c = l(s = t), u) : s;
          }, u;
        }

        function E(t, e) {
          return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
        }

        function L(t) {
          return t;
        }

        w.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._point = 0;
          },
          lineEnd: function lineEnd() {
            (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
          },
          point: function point(t, e) {
            switch (t = +t, e = +e, this._point) {
              case 0:
                this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
                break;

              case 1:
                this._point = 2;

              default:
                this._context.lineTo(t, e);

            }
          }
        };
        var C = I(T);

        function P(t) {
          this._curve = t;
        }

        function I(t) {
          function e(e) {
            return new P(t(e));
          }

          return e._curve = t, e;
        }

        function O(t) {
          var e = t.curve;
          return t.angle = t.x, delete t.x, t.radius = t.y, delete t.y, t.curve = function (t) {
            return arguments.length ? e(I(t)) : e()._curve;
          }, t;
        }

        function z() {
          return O(A().curve(C));
        }

        function D() {
          var t = S().curve(C),
              e = t.curve,
              r = t.lineX0,
              n = t.lineX1,
              i = t.lineY0,
              a = t.lineY1;
          return t.angle = t.x, delete t.x, t.startAngle = t.x0, delete t.x0, t.endAngle = t.x1, delete t.x1, t.radius = t.y, delete t.y, t.innerRadius = t.y0, delete t.y0, t.outerRadius = t.y1, delete t.y1, t.lineStartAngle = function () {
            return O(r());
          }, delete t.lineX0, t.lineEndAngle = function () {
            return O(n());
          }, delete t.lineX1, t.lineInnerRadius = function () {
            return O(i());
          }, delete t.lineY0, t.lineOuterRadius = function () {
            return O(a());
          }, delete t.lineY1, t.curve = function (t) {
            return arguments.length ? e(I(t)) : e()._curve;
          }, t;
        }

        function R(t, e) {
          return [(e = +e) * Math.cos(t -= Math.PI / 2), e * Math.sin(t)];
        }

        P.prototype = {
          areaStart: function areaStart() {
            this._curve.areaStart();
          },
          areaEnd: function areaEnd() {
            this._curve.areaEnd();
          },
          lineStart: function lineStart() {
            this._curve.lineStart();
          },
          lineEnd: function lineEnd() {
            this._curve.lineEnd();
          },
          point: function point(t, e) {
            this._curve.point(e * Math.sin(t), e * -Math.cos(t));
          }
        };
        var F = Array.prototype.slice;

        function B(t) {
          return t.source;
        }

        function N(t) {
          return t.target;
        }

        function j(t) {
          var n = B,
              i = N,
              a = k,
              o = M,
              s = null;

          function l() {
            var r,
                l = F.call(arguments),
                c = n.apply(this, l),
                u = i.apply(this, l);
            if (s || (s = r = e.path()), t(s, +a.apply(this, (l[0] = c, l)), +o.apply(this, l), +a.apply(this, (l[0] = u, l)), +o.apply(this, l)), r) return s = null, r + "" || null;
          }

          return l.source = function (t) {
            return arguments.length ? (n = t, l) : n;
          }, l.target = function (t) {
            return arguments.length ? (i = t, l) : i;
          }, l.x = function (t) {
            return arguments.length ? (a = "function" == typeof t ? t : r(+t), l) : a;
          }, l.y = function (t) {
            return arguments.length ? (o = "function" == typeof t ? t : r(+t), l) : o;
          }, l.context = function (t) {
            return arguments.length ? (s = null == t ? null : t, l) : s;
          }, l;
        }

        function U(t, e, r, n, i) {
          t.moveTo(e, r), t.bezierCurveTo(e = (e + n) / 2, r, e, i, n, i);
        }

        function V(t, e, r, n, i) {
          t.moveTo(e, r), t.bezierCurveTo(e, r = (r + i) / 2, n, r, n, i);
        }

        function q(t, e, r, n, i) {
          var a = R(e, r),
              o = R(e, r = (r + i) / 2),
              s = R(n, r),
              l = R(n, i);
          t.moveTo(a[0], a[1]), t.bezierCurveTo(o[0], o[1], s[0], s[1], l[0], l[1]);
        }

        var H = {
          draw: function draw(t, e) {
            var r = Math.sqrt(e / u);
            t.moveTo(r, 0), t.arc(0, 0, r, 0, h);
          }
        },
            G = {
          draw: function draw(t, e) {
            var r = Math.sqrt(e / 5) / 2;
            t.moveTo(-3 * r, -r), t.lineTo(-r, -r), t.lineTo(-r, -3 * r), t.lineTo(r, -3 * r), t.lineTo(r, -r), t.lineTo(3 * r, -r), t.lineTo(3 * r, r), t.lineTo(r, r), t.lineTo(r, 3 * r), t.lineTo(-r, 3 * r), t.lineTo(-r, r), t.lineTo(-3 * r, r), t.closePath();
          }
        },
            Y = Math.sqrt(1 / 3),
            W = 2 * Y,
            X = {
          draw: function draw(t, e) {
            var r = Math.sqrt(e / W),
                n = r * Y;
            t.moveTo(0, -r), t.lineTo(n, 0), t.lineTo(0, r), t.lineTo(-n, 0), t.closePath();
          }
        },
            Z = Math.sin(u / 10) / Math.sin(7 * u / 10),
            J = Math.sin(h / 10) * Z,
            K = -Math.cos(h / 10) * Z,
            Q = {
          draw: function draw(t, e) {
            var r = Math.sqrt(.8908130915292852 * e),
                n = J * r,
                i = K * r;
            t.moveTo(0, -r), t.lineTo(n, i);

            for (var a = 1; a < 5; ++a) {
              var o = h * a / 5,
                  s = Math.cos(o),
                  l = Math.sin(o);
              t.lineTo(l * r, -s * r), t.lineTo(s * n - l * i, l * n + s * i);
            }

            t.closePath();
          }
        },
            $ = {
          draw: function draw(t, e) {
            var r = Math.sqrt(e),
                n = -r / 2;
            t.rect(n, n, r, r);
          }
        },
            tt = Math.sqrt(3),
            et = {
          draw: function draw(t, e) {
            var r = -Math.sqrt(e / (3 * tt));
            t.moveTo(0, 2 * r), t.lineTo(-tt * r, -r), t.lineTo(tt * r, -r), t.closePath();
          }
        },
            rt = -.5,
            nt = Math.sqrt(3) / 2,
            it = 1 / Math.sqrt(12),
            at = 3 * (it / 2 + 1),
            ot = {
          draw: function draw(t, e) {
            var r = Math.sqrt(e / at),
                n = r / 2,
                i = r * it,
                a = n,
                o = r * it + r,
                s = -a,
                l = o;
            t.moveTo(n, i), t.lineTo(a, o), t.lineTo(s, l), t.lineTo(rt * n - nt * i, nt * n + rt * i), t.lineTo(rt * a - nt * o, nt * a + rt * o), t.lineTo(rt * s - nt * l, nt * s + rt * l), t.lineTo(rt * n + nt * i, rt * i - nt * n), t.lineTo(rt * a + nt * o, rt * o - nt * a), t.lineTo(rt * s + nt * l, rt * l - nt * s), t.closePath();
          }
        },
            st = [H, G, X, $, Q, et, ot];

        function lt() {}

        function ct(t, e, r) {
          t._context.bezierCurveTo((2 * t._x0 + t._x1) / 3, (2 * t._y0 + t._y1) / 3, (t._x0 + 2 * t._x1) / 3, (t._y0 + 2 * t._y1) / 3, (t._x0 + 4 * t._x1 + e) / 6, (t._y0 + 4 * t._y1 + r) / 6);
        }

        function ut(t) {
          this._context = t;
        }

        function ft(t) {
          this._context = t;
        }

        function ht(t) {
          this._context = t;
        }

        function pt(t, e) {
          this._basis = new ut(t), this._beta = e;
        }

        ut.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
          },
          lineEnd: function lineEnd() {
            switch (this._point) {
              case 3:
                ct(this, this._x1, this._y1);

              case 2:
                this._context.lineTo(this._x1, this._y1);

            }

            (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
          },
          point: function point(t, e) {
            switch (t = +t, e = +e, this._point) {
              case 0:
                this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
                break;

              case 1:
                this._point = 2;
                break;

              case 2:
                this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);

              default:
                ct(this, t, e);
            }

            this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
          }
        }, ft.prototype = {
          areaStart: lt,
          areaEnd: lt,
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
          },
          lineEnd: function lineEnd() {
            switch (this._point) {
              case 1:
                this._context.moveTo(this._x2, this._y2), this._context.closePath();
                break;

              case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
                break;

              case 3:
                this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
            }
          },
          point: function point(t, e) {
            switch (t = +t, e = +e, this._point) {
              case 0:
                this._point = 1, this._x2 = t, this._y2 = e;
                break;

              case 1:
                this._point = 2, this._x3 = t, this._y3 = e;
                break;

              case 2:
                this._point = 3, this._x4 = t, this._y4 = e, this._context.moveTo((this._x0 + 4 * this._x1 + t) / 6, (this._y0 + 4 * this._y1 + e) / 6);
                break;

              default:
                ct(this, t, e);
            }

            this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
          }
        }, ht.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
          },
          lineEnd: function lineEnd() {
            (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
          },
          point: function point(t, e) {
            switch (t = +t, e = +e, this._point) {
              case 0:
                this._point = 1;
                break;

              case 1:
                this._point = 2;
                break;

              case 2:
                this._point = 3;
                var r = (this._x0 + 4 * this._x1 + t) / 6,
                    n = (this._y0 + 4 * this._y1 + e) / 6;
                this._line ? this._context.lineTo(r, n) : this._context.moveTo(r, n);
                break;

              case 3:
                this._point = 4;

              default:
                ct(this, t, e);
            }

            this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
          }
        }, pt.prototype = {
          lineStart: function lineStart() {
            this._x = [], this._y = [], this._basis.lineStart();
          },
          lineEnd: function lineEnd() {
            var t = this._x,
                e = this._y,
                r = t.length - 1;
            if (r > 0) for (var n, i = t[0], a = e[0], o = t[r] - i, s = e[r] - a, l = -1; ++l <= r;) {
              n = l / r, this._basis.point(this._beta * t[l] + (1 - this._beta) * (i + n * o), this._beta * e[l] + (1 - this._beta) * (a + n * s));
            }
            this._x = this._y = null, this._basis.lineEnd();
          },
          point: function point(t, e) {
            this._x.push(+t), this._y.push(+e);
          }
        };

        var dt = function t(e) {
          function r(t) {
            return 1 === e ? new ut(t) : new pt(t, e);
          }

          return r.beta = function (e) {
            return t(+e);
          }, r;
        }(.85);

        function mt(t, e, r) {
          t._context.bezierCurveTo(t._x1 + t._k * (t._x2 - t._x0), t._y1 + t._k * (t._y2 - t._y0), t._x2 + t._k * (t._x1 - e), t._y2 + t._k * (t._y1 - r), t._x2, t._y2);
        }

        function gt(t, e) {
          this._context = t, this._k = (1 - e) / 6;
        }

        gt.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
          },
          lineEnd: function lineEnd() {
            switch (this._point) {
              case 2:
                this._context.lineTo(this._x2, this._y2);

                break;

              case 3:
                mt(this, this._x1, this._y1);
            }

            (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
          },
          point: function point(t, e) {
            switch (t = +t, e = +e, this._point) {
              case 0:
                this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
                break;

              case 1:
                this._point = 2, this._x1 = t, this._y1 = e;
                break;

              case 2:
                this._point = 3;

              default:
                mt(this, t, e);
            }

            this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
          }
        };

        var vt = function t(e) {
          function r(t) {
            return new gt(t, e);
          }

          return r.tension = function (e) {
            return t(+e);
          }, r;
        }(0);

        function yt(t, e) {
          this._context = t, this._k = (1 - e) / 6;
        }

        yt.prototype = {
          areaStart: lt,
          areaEnd: lt,
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._point = 0;
          },
          lineEnd: function lineEnd() {
            switch (this._point) {
              case 1:
                this._context.moveTo(this._x3, this._y3), this._context.closePath();
                break;

              case 2:
                this._context.lineTo(this._x3, this._y3), this._context.closePath();
                break;

              case 3:
                this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
            }
          },
          point: function point(t, e) {
            switch (t = +t, e = +e, this._point) {
              case 0:
                this._point = 1, this._x3 = t, this._y3 = e;
                break;

              case 1:
                this._point = 2, this._context.moveTo(this._x4 = t, this._y4 = e);
                break;

              case 2:
                this._point = 3, this._x5 = t, this._y5 = e;
                break;

              default:
                mt(this, t, e);
            }

            this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
          }
        };

        var xt = function t(e) {
          function r(t) {
            return new yt(t, e);
          }

          return r.tension = function (e) {
            return t(+e);
          }, r;
        }(0);

        function bt(t, e) {
          this._context = t, this._k = (1 - e) / 6;
        }

        bt.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
          },
          lineEnd: function lineEnd() {
            (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
          },
          point: function point(t, e) {
            switch (t = +t, e = +e, this._point) {
              case 0:
                this._point = 1;
                break;

              case 1:
                this._point = 2;
                break;

              case 2:
                this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;

              case 3:
                this._point = 4;

              default:
                mt(this, t, e);
            }

            this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
          }
        };

        var _t = function t(e) {
          function r(t) {
            return new bt(t, e);
          }

          return r.tension = function (e) {
            return t(+e);
          }, r;
        }(0);

        function wt(t, e, r) {
          var n = t._x1,
              i = t._y1,
              a = t._x2,
              o = t._y2;

          if (t._l01_a > 1e-12) {
            var s = 2 * t._l01_2a + 3 * t._l01_a * t._l12_a + t._l12_2a,
                l = 3 * t._l01_a * (t._l01_a + t._l12_a);
            n = (n * s - t._x0 * t._l12_2a + t._x2 * t._l01_2a) / l, i = (i * s - t._y0 * t._l12_2a + t._y2 * t._l01_2a) / l;
          }

          if (t._l23_a > 1e-12) {
            var c = 2 * t._l23_2a + 3 * t._l23_a * t._l12_a + t._l12_2a,
                u = 3 * t._l23_a * (t._l23_a + t._l12_a);
            a = (a * c + t._x1 * t._l23_2a - e * t._l12_2a) / u, o = (o * c + t._y1 * t._l23_2a - r * t._l12_2a) / u;
          }

          t._context.bezierCurveTo(n, i, a, o, t._x2, t._y2);
        }

        function Tt(t, e) {
          this._context = t, this._alpha = e;
        }

        Tt.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
          },
          lineEnd: function lineEnd() {
            switch (this._point) {
              case 2:
                this._context.lineTo(this._x2, this._y2);

                break;

              case 3:
                this.point(this._x2, this._y2);
            }

            (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
          },
          point: function point(t, e) {
            if (t = +t, e = +e, this._point) {
              var r = this._x2 - t,
                  n = this._y2 - e;
              this._l23_a = Math.sqrt(this._l23_2a = Math.pow(r * r + n * n, this._alpha));
            }

            switch (this._point) {
              case 0:
                this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
                break;

              case 1:
                this._point = 2;
                break;

              case 2:
                this._point = 3;

              default:
                wt(this, t, e);
            }

            this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
          }
        };

        var kt = function t(e) {
          function r(t) {
            return e ? new Tt(t, e) : new gt(t, 0);
          }

          return r.alpha = function (e) {
            return t(+e);
          }, r;
        }(.5);

        function Mt(t, e) {
          this._context = t, this._alpha = e;
        }

        Mt.prototype = {
          areaStart: lt,
          areaEnd: lt,
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
          },
          lineEnd: function lineEnd() {
            switch (this._point) {
              case 1:
                this._context.moveTo(this._x3, this._y3), this._context.closePath();
                break;

              case 2:
                this._context.lineTo(this._x3, this._y3), this._context.closePath();
                break;

              case 3:
                this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
            }
          },
          point: function point(t, e) {
            if (t = +t, e = +e, this._point) {
              var r = this._x2 - t,
                  n = this._y2 - e;
              this._l23_a = Math.sqrt(this._l23_2a = Math.pow(r * r + n * n, this._alpha));
            }

            switch (this._point) {
              case 0:
                this._point = 1, this._x3 = t, this._y3 = e;
                break;

              case 1:
                this._point = 2, this._context.moveTo(this._x4 = t, this._y4 = e);
                break;

              case 2:
                this._point = 3, this._x5 = t, this._y5 = e;
                break;

              default:
                wt(this, t, e);
            }

            this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
          }
        };

        var At = function t(e) {
          function r(t) {
            return e ? new Mt(t, e) : new yt(t, 0);
          }

          return r.alpha = function (e) {
            return t(+e);
          }, r;
        }(.5);

        function St(t, e) {
          this._context = t, this._alpha = e;
        }

        St.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
          },
          lineEnd: function lineEnd() {
            (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
          },
          point: function point(t, e) {
            if (t = +t, e = +e, this._point) {
              var r = this._x2 - t,
                  n = this._y2 - e;
              this._l23_a = Math.sqrt(this._l23_2a = Math.pow(r * r + n * n, this._alpha));
            }

            switch (this._point) {
              case 0:
                this._point = 1;
                break;

              case 1:
                this._point = 2;
                break;

              case 2:
                this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;

              case 3:
                this._point = 4;

              default:
                wt(this, t, e);
            }

            this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
          }
        };

        var Et = function t(e) {
          function r(t) {
            return e ? new St(t, e) : new bt(t, 0);
          }

          return r.alpha = function (e) {
            return t(+e);
          }, r;
        }(.5);

        function Lt(t) {
          this._context = t;
        }

        function Ct(t) {
          return t < 0 ? -1 : 1;
        }

        function Pt(t, e, r) {
          var n = t._x1 - t._x0,
              i = e - t._x1,
              a = (t._y1 - t._y0) / (n || i < 0 && -0),
              o = (r - t._y1) / (i || n < 0 && -0),
              s = (a * i + o * n) / (n + i);
          return (Ct(a) + Ct(o)) * Math.min(Math.abs(a), Math.abs(o), .5 * Math.abs(s)) || 0;
        }

        function It(t, e) {
          var r = t._x1 - t._x0;
          return r ? (3 * (t._y1 - t._y0) / r - e) / 2 : e;
        }

        function Ot(t, e, r) {
          var n = t._x0,
              i = t._y0,
              a = t._x1,
              o = t._y1,
              s = (a - n) / 3;

          t._context.bezierCurveTo(n + s, i + s * e, a - s, o - s * r, a, o);
        }

        function zt(t) {
          this._context = t;
        }

        function Dt(t) {
          this._context = new Rt(t);
        }

        function Rt(t) {
          this._context = t;
        }

        function Ft(t) {
          this._context = t;
        }

        function Bt(t) {
          var e,
              r,
              n = t.length - 1,
              i = new Array(n),
              a = new Array(n),
              o = new Array(n);

          for (i[0] = 0, a[0] = 2, o[0] = t[0] + 2 * t[1], e = 1; e < n - 1; ++e) {
            i[e] = 1, a[e] = 4, o[e] = 4 * t[e] + 2 * t[e + 1];
          }

          for (i[n - 1] = 2, a[n - 1] = 7, o[n - 1] = 8 * t[n - 1] + t[n], e = 1; e < n; ++e) {
            r = i[e] / a[e - 1], a[e] -= r, o[e] -= r * o[e - 1];
          }

          for (i[n - 1] = o[n - 1] / a[n - 1], e = n - 2; e >= 0; --e) {
            i[e] = (o[e] - i[e + 1]) / a[e];
          }

          for (a[n - 1] = (t[n] + i[n - 1]) / 2, e = 0; e < n - 1; ++e) {
            a[e] = 2 * t[e + 1] - i[e + 1];
          }

          return [i, a];
        }

        function Nt(t, e) {
          this._context = t, this._t = e;
        }

        function jt(t, e) {
          if ((i = t.length) > 1) for (var r, n, i, a = 1, o = t[e[0]], s = o.length; a < i; ++a) {
            for (n = o, o = t[e[a]], r = 0; r < s; ++r) {
              o[r][1] += o[r][0] = isNaN(n[r][1]) ? n[r][0] : n[r][1];
            }
          }
        }

        function Ut(t) {
          for (var e = t.length, r = new Array(e); --e >= 0;) {
            r[e] = e;
          }

          return r;
        }

        function Vt(t, e) {
          return t[e];
        }

        function qt(t) {
          var e = t.map(Ht);
          return Ut(t).sort(function (t, r) {
            return e[t] - e[r];
          });
        }

        function Ht(t) {
          for (var e, r = -1, n = 0, i = t.length, a = -1 / 0; ++r < i;) {
            (e = +t[r][1]) > a && (a = e, n = r);
          }

          return n;
        }

        function Gt(t) {
          var e = t.map(Yt);
          return Ut(t).sort(function (t, r) {
            return e[t] - e[r];
          });
        }

        function Yt(t) {
          for (var e, r = 0, n = -1, i = t.length; ++n < i;) {
            (e = +t[n][1]) && (r += e);
          }

          return r;
        }

        Lt.prototype = {
          areaStart: lt,
          areaEnd: lt,
          lineStart: function lineStart() {
            this._point = 0;
          },
          lineEnd: function lineEnd() {
            this._point && this._context.closePath();
          },
          point: function point(t, e) {
            t = +t, e = +e, this._point ? this._context.lineTo(t, e) : (this._point = 1, this._context.moveTo(t, e));
          }
        }, zt.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
          },
          lineEnd: function lineEnd() {
            switch (this._point) {
              case 2:
                this._context.lineTo(this._x1, this._y1);

                break;

              case 3:
                Ot(this, this._t0, It(this, this._t0));
            }

            (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
          },
          point: function point(t, e) {
            var r = NaN;

            if (e = +e, (t = +t) !== this._x1 || e !== this._y1) {
              switch (this._point) {
                case 0:
                  this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
                  break;

                case 1:
                  this._point = 2;
                  break;

                case 2:
                  this._point = 3, Ot(this, It(this, r = Pt(this, t, e)), r);
                  break;

                default:
                  Ot(this, this._t0, r = Pt(this, t, e));
              }

              this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e, this._t0 = r;
            }
          }
        }, (Dt.prototype = Object.create(zt.prototype)).point = function (t, e) {
          zt.prototype.point.call(this, e, t);
        }, Rt.prototype = {
          moveTo: function moveTo(t, e) {
            this._context.moveTo(e, t);
          },
          closePath: function closePath() {
            this._context.closePath();
          },
          lineTo: function lineTo(t, e) {
            this._context.lineTo(e, t);
          },
          bezierCurveTo: function bezierCurveTo(t, e, r, n, i, a) {
            this._context.bezierCurveTo(e, t, n, r, a, i);
          }
        }, Ft.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x = [], this._y = [];
          },
          lineEnd: function lineEnd() {
            var t = this._x,
                e = this._y,
                r = t.length;
            if (r) if (this._line ? this._context.lineTo(t[0], e[0]) : this._context.moveTo(t[0], e[0]), 2 === r) this._context.lineTo(t[1], e[1]);else for (var n = Bt(t), i = Bt(e), a = 0, o = 1; o < r; ++a, ++o) {
              this._context.bezierCurveTo(n[0][a], i[0][a], n[1][a], i[1][a], t[o], e[o]);
            }
            (this._line || 0 !== this._line && 1 === r) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
          },
          point: function point(t, e) {
            this._x.push(+t), this._y.push(+e);
          }
        }, Nt.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x = this._y = NaN, this._point = 0;
          },
          lineEnd: function lineEnd() {
            0 < this._t && this._t < 1 && 2 === this._point && this._context.lineTo(this._x, this._y), (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
          },
          point: function point(t, e) {
            switch (t = +t, e = +e, this._point) {
              case 0:
                this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
                break;

              case 1:
                this._point = 2;

              default:
                if (this._t <= 0) this._context.lineTo(this._x, e), this._context.lineTo(t, e);else {
                  var r = this._x * (1 - this._t) + t * this._t;
                  this._context.lineTo(r, this._y), this._context.lineTo(r, e);
                }
            }

            this._x = t, this._y = e;
          }
        }, t.arc = function () {
          var t = m,
              o = g,
              w = r(0),
              T = null,
              k = v,
              M = y,
              A = x,
              S = null;

          function E() {
            var r,
                m,
                g = +t.apply(this, arguments),
                v = +o.apply(this, arguments),
                y = k.apply(this, arguments) - f,
                x = M.apply(this, arguments) - f,
                E = n(x - y),
                L = x > y;
            if (S || (S = r = e.path()), v < g && (m = v, v = g, g = m), v > 1e-12) {
              if (E > h - 1e-12) S.moveTo(v * a(y), v * l(y)), S.arc(0, 0, v, y, x, !L), g > 1e-12 && (S.moveTo(g * a(x), g * l(x)), S.arc(0, 0, g, x, y, L));else {
                var C,
                    P,
                    I = y,
                    O = x,
                    z = y,
                    D = x,
                    R = E,
                    F = E,
                    B = A.apply(this, arguments) / 2,
                    N = B > 1e-12 && (T ? +T.apply(this, arguments) : c(g * g + v * v)),
                    j = s(n(v - g) / 2, +w.apply(this, arguments)),
                    U = j,
                    V = j;

                if (N > 1e-12) {
                  var q = d(N / g * l(B)),
                      H = d(N / v * l(B));
                  (R -= 2 * q) > 1e-12 ? (z += q *= L ? 1 : -1, D -= q) : (R = 0, z = D = (y + x) / 2), (F -= 2 * H) > 1e-12 ? (I += H *= L ? 1 : -1, O -= H) : (F = 0, I = O = (y + x) / 2);
                }

                var G = v * a(I),
                    Y = v * l(I),
                    W = g * a(D),
                    X = g * l(D);

                if (j > 1e-12) {
                  var Z,
                      J = v * a(O),
                      K = v * l(O),
                      Q = g * a(z),
                      $ = g * l(z);

                  if (E < u && (Z = b(G, Y, Q, $, J, K, W, X))) {
                    var tt = G - Z[0],
                        et = Y - Z[1],
                        rt = J - Z[0],
                        nt = K - Z[1],
                        it = 1 / l(p((tt * rt + et * nt) / (c(tt * tt + et * et) * c(rt * rt + nt * nt))) / 2),
                        at = c(Z[0] * Z[0] + Z[1] * Z[1]);
                    U = s(j, (g - at) / (it - 1)), V = s(j, (v - at) / (it + 1));
                  }
                }

                F > 1e-12 ? V > 1e-12 ? (C = _(Q, $, G, Y, v, V, L), P = _(J, K, W, X, v, V, L), S.moveTo(C.cx + C.x01, C.cy + C.y01), V < j ? S.arc(C.cx, C.cy, V, i(C.y01, C.x01), i(P.y01, P.x01), !L) : (S.arc(C.cx, C.cy, V, i(C.y01, C.x01), i(C.y11, C.x11), !L), S.arc(0, 0, v, i(C.cy + C.y11, C.cx + C.x11), i(P.cy + P.y11, P.cx + P.x11), !L), S.arc(P.cx, P.cy, V, i(P.y11, P.x11), i(P.y01, P.x01), !L))) : (S.moveTo(G, Y), S.arc(0, 0, v, I, O, !L)) : S.moveTo(G, Y), g > 1e-12 && R > 1e-12 ? U > 1e-12 ? (C = _(W, X, J, K, g, -U, L), P = _(G, Y, Q, $, g, -U, L), S.lineTo(C.cx + C.x01, C.cy + C.y01), U < j ? S.arc(C.cx, C.cy, U, i(C.y01, C.x01), i(P.y01, P.x01), !L) : (S.arc(C.cx, C.cy, U, i(C.y01, C.x01), i(C.y11, C.x11), !L), S.arc(0, 0, g, i(C.cy + C.y11, C.cx + C.x11), i(P.cy + P.y11, P.cx + P.x11), L), S.arc(P.cx, P.cy, U, i(P.y11, P.x11), i(P.y01, P.x01), !L))) : S.arc(0, 0, g, D, z, L) : S.lineTo(W, X);
              }
            } else S.moveTo(0, 0);
            if (S.closePath(), r) return S = null, r + "" || null;
          }

          return E.centroid = function () {
            var e = (+t.apply(this, arguments) + +o.apply(this, arguments)) / 2,
                r = (+k.apply(this, arguments) + +M.apply(this, arguments)) / 2 - u / 2;
            return [a(r) * e, l(r) * e];
          }, E.innerRadius = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : r(+e), E) : t;
          }, E.outerRadius = function (t) {
            return arguments.length ? (o = "function" == typeof t ? t : r(+t), E) : o;
          }, E.cornerRadius = function (t) {
            return arguments.length ? (w = "function" == typeof t ? t : r(+t), E) : w;
          }, E.padRadius = function (t) {
            return arguments.length ? (T = null == t ? null : "function" == typeof t ? t : r(+t), E) : T;
          }, E.startAngle = function (t) {
            return arguments.length ? (k = "function" == typeof t ? t : r(+t), E) : k;
          }, E.endAngle = function (t) {
            return arguments.length ? (M = "function" == typeof t ? t : r(+t), E) : M;
          }, E.padAngle = function (t) {
            return arguments.length ? (A = "function" == typeof t ? t : r(+t), E) : A;
          }, E.context = function (t) {
            return arguments.length ? (S = null == t ? null : t, E) : S;
          }, E;
        }, t.area = S, t.areaRadial = D, t.curveBasis = function (t) {
          return new ut(t);
        }, t.curveBasisClosed = function (t) {
          return new ft(t);
        }, t.curveBasisOpen = function (t) {
          return new ht(t);
        }, t.curveBundle = dt, t.curveCardinal = vt, t.curveCardinalClosed = xt, t.curveCardinalOpen = _t, t.curveCatmullRom = kt, t.curveCatmullRomClosed = At, t.curveCatmullRomOpen = Et, t.curveLinear = T, t.curveLinearClosed = function (t) {
          return new Lt(t);
        }, t.curveMonotoneX = function (t) {
          return new zt(t);
        }, t.curveMonotoneY = function (t) {
          return new Dt(t);
        }, t.curveNatural = function (t) {
          return new Ft(t);
        }, t.curveStep = function (t) {
          return new Nt(t, .5);
        }, t.curveStepAfter = function (t) {
          return new Nt(t, 1);
        }, t.curveStepBefore = function (t) {
          return new Nt(t, 0);
        }, t.line = A, t.lineRadial = z, t.linkHorizontal = function () {
          return j(U);
        }, t.linkRadial = function () {
          var t = j(q);
          return t.angle = t.x, delete t.x, t.radius = t.y, delete t.y, t;
        }, t.linkVertical = function () {
          return j(V);
        }, t.pie = function () {
          var t = L,
              e = E,
              n = null,
              i = r(0),
              a = r(h),
              o = r(0);

          function s(r) {
            var s,
                l,
                c,
                u,
                f,
                p = r.length,
                d = 0,
                m = new Array(p),
                g = new Array(p),
                v = +i.apply(this, arguments),
                y = Math.min(h, Math.max(-h, a.apply(this, arguments) - v)),
                x = Math.min(Math.abs(y) / p, o.apply(this, arguments)),
                b = x * (y < 0 ? -1 : 1);

            for (s = 0; s < p; ++s) {
              (f = g[m[s] = s] = +t(r[s], s, r)) > 0 && (d += f);
            }

            for (null != e ? m.sort(function (t, r) {
              return e(g[t], g[r]);
            }) : null != n && m.sort(function (t, e) {
              return n(r[t], r[e]);
            }), s = 0, c = d ? (y - p * b) / d : 0; s < p; ++s, v = u) {
              l = m[s], u = v + ((f = g[l]) > 0 ? f * c : 0) + b, g[l] = {
                data: r[l],
                index: s,
                value: f,
                startAngle: v,
                endAngle: u,
                padAngle: x
              };
            }

            return g;
          }

          return s.value = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : r(+e), s) : t;
          }, s.sortValues = function (t) {
            return arguments.length ? (e = t, n = null, s) : e;
          }, s.sort = function (t) {
            return arguments.length ? (n = t, e = null, s) : n;
          }, s.startAngle = function (t) {
            return arguments.length ? (i = "function" == typeof t ? t : r(+t), s) : i;
          }, s.endAngle = function (t) {
            return arguments.length ? (a = "function" == typeof t ? t : r(+t), s) : a;
          }, s.padAngle = function (t) {
            return arguments.length ? (o = "function" == typeof t ? t : r(+t), s) : o;
          }, s;
        }, t.pointRadial = R, t.radialArea = D, t.radialLine = z, t.stack = function () {
          var t = r([]),
              e = Ut,
              n = jt,
              i = Vt;

          function a(r) {
            var a,
                o,
                s = t.apply(this, arguments),
                l = r.length,
                c = s.length,
                u = new Array(c);

            for (a = 0; a < c; ++a) {
              for (var f, h = s[a], p = u[a] = new Array(l), d = 0; d < l; ++d) {
                p[d] = f = [0, +i(r[d], h, d, r)], f.data = r[d];
              }

              p.key = h;
            }

            for (a = 0, o = e(u); a < c; ++a) {
              u[o[a]].index = a;
            }

            return n(u, o), u;
          }

          return a.keys = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : r(F.call(e)), a) : t;
          }, a.value = function (t) {
            return arguments.length ? (i = "function" == typeof t ? t : r(+t), a) : i;
          }, a.order = function (t) {
            return arguments.length ? (e = null == t ? Ut : "function" == typeof t ? t : r(F.call(t)), a) : e;
          }, a.offset = function (t) {
            return arguments.length ? (n = null == t ? jt : t, a) : n;
          }, a;
        }, t.stackOffsetDiverging = function (t, e) {
          if ((s = t.length) > 0) for (var r, n, i, a, o, s, l = 0, c = t[e[0]].length; l < c; ++l) {
            for (a = o = 0, r = 0; r < s; ++r) {
              (i = (n = t[e[r]][l])[1] - n[0]) > 0 ? (n[0] = a, n[1] = a += i) : i < 0 ? (n[1] = o, n[0] = o += i) : (n[0] = 0, n[1] = i);
            }
          }
        }, t.stackOffsetExpand = function (t, e) {
          if ((n = t.length) > 0) {
            for (var r, n, i, a = 0, o = t[0].length; a < o; ++a) {
              for (i = r = 0; r < n; ++r) {
                i += t[r][a][1] || 0;
              }

              if (i) for (r = 0; r < n; ++r) {
                t[r][a][1] /= i;
              }
            }

            jt(t, e);
          }
        }, t.stackOffsetNone = jt, t.stackOffsetSilhouette = function (t, e) {
          if ((r = t.length) > 0) {
            for (var r, n = 0, i = t[e[0]], a = i.length; n < a; ++n) {
              for (var o = 0, s = 0; o < r; ++o) {
                s += t[o][n][1] || 0;
              }

              i[n][1] += i[n][0] = -s / 2;
            }

            jt(t, e);
          }
        }, t.stackOffsetWiggle = function (t, e) {
          if ((i = t.length) > 0 && (n = (r = t[e[0]]).length) > 0) {
            for (var r, n, i, a = 0, o = 1; o < n; ++o) {
              for (var s = 0, l = 0, c = 0; s < i; ++s) {
                for (var u = t[e[s]], f = u[o][1] || 0, h = (f - (u[o - 1][1] || 0)) / 2, p = 0; p < s; ++p) {
                  var d = t[e[p]];
                  h += (d[o][1] || 0) - (d[o - 1][1] || 0);
                }

                l += f, c += h * f;
              }

              r[o - 1][1] += r[o - 1][0] = a, l && (a -= c / l);
            }

            r[o - 1][1] += r[o - 1][0] = a, jt(t, e);
          }
        }, t.stackOrderAppearance = qt, t.stackOrderAscending = Gt, t.stackOrderDescending = function (t) {
          return Gt(t).reverse();
        }, t.stackOrderInsideOut = function (t) {
          var e,
              r,
              n = t.length,
              i = t.map(Yt),
              a = qt(t),
              o = 0,
              s = 0,
              l = [],
              c = [];

          for (e = 0; e < n; ++e) {
            r = a[e], o < s ? (o += i[r], l.push(r)) : (s += i[r], c.push(r));
          }

          return c.reverse().concat(l);
        }, t.stackOrderNone = Ut, t.stackOrderReverse = function (t) {
          return Ut(t).reverse();
        }, t.symbol = function () {
          var t = r(H),
              n = r(64),
              i = null;

          function a() {
            var r;
            if (i || (i = r = e.path()), t.apply(this, arguments).draw(i, +n.apply(this, arguments)), r) return i = null, r + "" || null;
          }

          return a.type = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : r(e), a) : t;
          }, a.size = function (t) {
            return arguments.length ? (n = "function" == typeof t ? t : r(+t), a) : n;
          }, a.context = function (t) {
            return arguments.length ? (i = null == t ? null : t, a) : i;
          }, a;
        }, t.symbolCircle = H, t.symbolCross = G, t.symbolDiamond = X, t.symbolSquare = $, t.symbolStar = Q, t.symbolTriangle = et, t.symbolWye = ot, t.symbols = st, Object.defineProperty(t, "__esModule", {
          value: !0
        });
      });
    }, {
      "d3-path": 164
    }],
    167: [function (t, e, r) {
      !function (n, i) {
        "object" == _typeof(r) && void 0 !== e ? i(r, t("d3-time")) : i((n = n || self).d3 = n.d3 || {}, n.d3);
      }(this, function (t, e) {
        "use strict";

        function r(t) {
          if (0 <= t.y && t.y < 100) {
            var e = new Date(-1, t.m, t.d, t.H, t.M, t.S, t.L);
            return e.setFullYear(t.y), e;
          }

          return new Date(t.y, t.m, t.d, t.H, t.M, t.S, t.L);
        }

        function n(t) {
          if (0 <= t.y && t.y < 100) {
            var e = new Date(Date.UTC(-1, t.m, t.d, t.H, t.M, t.S, t.L));
            return e.setUTCFullYear(t.y), e;
          }

          return new Date(Date.UTC(t.y, t.m, t.d, t.H, t.M, t.S, t.L));
        }

        function i(t, e, r) {
          return {
            y: t,
            m: e,
            d: r,
            H: 0,
            M: 0,
            S: 0,
            L: 0
          };
        }

        function a(t) {
          var a = t.dateTime,
              o = t.date,
              l = t.time,
              c = t.periods,
              u = t.days,
              f = t.shortDays,
              h = t.months,
              yt = t.shortMonths,
              xt = p(c),
              bt = d(c),
              _t = p(u),
              wt = d(u),
              Tt = p(f),
              kt = d(f),
              Mt = p(h),
              At = d(h),
              St = p(yt),
              Et = d(yt),
              Lt = {
            a: function a(t) {
              return f[t.getDay()];
            },
            A: function A(t) {
              return u[t.getDay()];
            },
            b: function b(t) {
              return yt[t.getMonth()];
            },
            B: function B(t) {
              return h[t.getMonth()];
            },
            c: null,
            d: D,
            e: D,
            f: j,
            H: R,
            I: F,
            j: B,
            L: N,
            m: U,
            M: V,
            p: function p(t) {
              return c[+(t.getHours() >= 12)];
            },
            q: function q(t) {
              return 1 + ~~(t.getMonth() / 3);
            },
            Q: gt,
            s: vt,
            S: q,
            u: H,
            U: G,
            V: Y,
            w: W,
            W: X,
            x: null,
            X: null,
            y: Z,
            Y: J,
            Z: K,
            "%": mt
          },
              Ct = {
            a: function a(t) {
              return f[t.getUTCDay()];
            },
            A: function A(t) {
              return u[t.getUTCDay()];
            },
            b: function b(t) {
              return yt[t.getUTCMonth()];
            },
            B: function B(t) {
              return h[t.getUTCMonth()];
            },
            c: null,
            d: Q,
            e: Q,
            f: nt,
            H: $,
            I: tt,
            j: et,
            L: rt,
            m: it,
            M: at,
            p: function p(t) {
              return c[+(t.getUTCHours() >= 12)];
            },
            q: function q(t) {
              return 1 + ~~(t.getUTCMonth() / 3);
            },
            Q: gt,
            s: vt,
            S: ot,
            u: st,
            U: lt,
            V: ct,
            w: ut,
            W: ft,
            x: null,
            X: null,
            y: ht,
            Y: pt,
            Z: dt,
            "%": mt
          },
              Pt = {
            a: function a(t, e, r) {
              var n = Tt.exec(e.slice(r));
              return n ? (t.w = kt[n[0].toLowerCase()], r + n[0].length) : -1;
            },
            A: function A(t, e, r) {
              var n = _t.exec(e.slice(r));

              return n ? (t.w = wt[n[0].toLowerCase()], r + n[0].length) : -1;
            },
            b: function b(t, e, r) {
              var n = St.exec(e.slice(r));
              return n ? (t.m = Et[n[0].toLowerCase()], r + n[0].length) : -1;
            },
            B: function B(t, e, r) {
              var n = Mt.exec(e.slice(r));
              return n ? (t.m = At[n[0].toLowerCase()], r + n[0].length) : -1;
            },
            c: function c(t, e, r) {
              return zt(t, a, e, r);
            },
            d: M,
            e: M,
            f: P,
            H: S,
            I: S,
            j: A,
            L: C,
            m: k,
            M: E,
            p: function p(t, e, r) {
              var n = xt.exec(e.slice(r));
              return n ? (t.p = bt[n[0].toLowerCase()], r + n[0].length) : -1;
            },
            q: T,
            Q: O,
            s: z,
            S: L,
            u: g,
            U: v,
            V: y,
            w: m,
            W: x,
            x: function x(t, e, r) {
              return zt(t, o, e, r);
            },
            X: function X(t, e, r) {
              return zt(t, l, e, r);
            },
            y: _,
            Y: b,
            Z: w,
            "%": I
          };

          function It(t, e) {
            return function (r) {
              var n,
                  i,
                  a,
                  o = [],
                  l = -1,
                  c = 0,
                  u = t.length;

              for (r instanceof Date || (r = new Date(+r)); ++l < u;) {
                37 === t.charCodeAt(l) && (o.push(t.slice(c, l)), null != (i = s[n = t.charAt(++l)]) ? n = t.charAt(++l) : i = "e" === n ? " " : "0", (a = e[n]) && (n = a(r, i)), o.push(n), c = l + 1);
              }

              return o.push(t.slice(c, l)), o.join("");
            };
          }

          function Ot(t, a) {
            return function (o) {
              var s,
                  l,
                  c = i(1900, void 0, 1);
              if (zt(c, t, o += "", 0) != o.length) return null;
              if ("Q" in c) return new Date(c.Q);
              if ("s" in c) return new Date(1e3 * c.s + ("L" in c ? c.L : 0));

              if (a && !("Z" in c) && (c.Z = 0), "p" in c && (c.H = c.H % 12 + 12 * c.p), void 0 === c.m && (c.m = "q" in c ? c.q : 0), "V" in c) {
                if (c.V < 1 || c.V > 53) return null;
                "w" in c || (c.w = 1), "Z" in c ? (l = (s = n(i(c.y, 0, 1))).getUTCDay(), s = l > 4 || 0 === l ? e.utcMonday.ceil(s) : e.utcMonday(s), s = e.utcDay.offset(s, 7 * (c.V - 1)), c.y = s.getUTCFullYear(), c.m = s.getUTCMonth(), c.d = s.getUTCDate() + (c.w + 6) % 7) : (l = (s = r(i(c.y, 0, 1))).getDay(), s = l > 4 || 0 === l ? e.timeMonday.ceil(s) : e.timeMonday(s), s = e.timeDay.offset(s, 7 * (c.V - 1)), c.y = s.getFullYear(), c.m = s.getMonth(), c.d = s.getDate() + (c.w + 6) % 7);
              } else ("W" in c || "U" in c) && ("w" in c || (c.w = "u" in c ? c.u % 7 : "W" in c ? 1 : 0), l = "Z" in c ? n(i(c.y, 0, 1)).getUTCDay() : r(i(c.y, 0, 1)).getDay(), c.m = 0, c.d = "W" in c ? (c.w + 6) % 7 + 7 * c.W - (l + 5) % 7 : c.w + 7 * c.U - (l + 6) % 7);

              return "Z" in c ? (c.H += c.Z / 100 | 0, c.M += c.Z % 100, n(c)) : r(c);
            };
          }

          function zt(t, e, r, n) {
            for (var i, a, o = 0, l = e.length, c = r.length; o < l;) {
              if (n >= c) return -1;

              if (37 === (i = e.charCodeAt(o++))) {
                if (i = e.charAt(o++), !(a = Pt[i in s ? e.charAt(o++) : i]) || (n = a(t, r, n)) < 0) return -1;
              } else if (i != r.charCodeAt(n++)) return -1;
            }

            return n;
          }

          return Lt.x = It(o, Lt), Lt.X = It(l, Lt), Lt.c = It(a, Lt), Ct.x = It(o, Ct), Ct.X = It(l, Ct), Ct.c = It(a, Ct), {
            format: function format(t) {
              var e = It(t += "", Lt);
              return e.toString = function () {
                return t;
              }, e;
            },
            parse: function parse(t) {
              var e = Ot(t += "", !1);
              return e.toString = function () {
                return t;
              }, e;
            },
            utcFormat: function utcFormat(t) {
              var e = It(t += "", Ct);
              return e.toString = function () {
                return t;
              }, e;
            },
            utcParse: function utcParse(t) {
              var e = Ot(t += "", !0);
              return e.toString = function () {
                return t;
              }, e;
            }
          };
        }

        var o,
            s = {
          "-": "",
          _: " ",
          0: "0"
        },
            l = /^\s*\d+/,
            c = /^%/,
            u = /[\\^$*+?|[\]().{}]/g;

        function f(t, e, r) {
          var n = t < 0 ? "-" : "",
              i = (n ? -t : t) + "",
              a = i.length;
          return n + (a < r ? new Array(r - a + 1).join(e) + i : i);
        }

        function h(t) {
          return t.replace(u, "\\$&");
        }

        function p(t) {
          return new RegExp("^(?:" + t.map(h).join("|") + ")", "i");
        }

        function d(t) {
          for (var e = {}, r = -1, n = t.length; ++r < n;) {
            e[t[r].toLowerCase()] = r;
          }

          return e;
        }

        function m(t, e, r) {
          var n = l.exec(e.slice(r, r + 1));
          return n ? (t.w = +n[0], r + n[0].length) : -1;
        }

        function g(t, e, r) {
          var n = l.exec(e.slice(r, r + 1));
          return n ? (t.u = +n[0], r + n[0].length) : -1;
        }

        function v(t, e, r) {
          var n = l.exec(e.slice(r, r + 2));
          return n ? (t.U = +n[0], r + n[0].length) : -1;
        }

        function y(t, e, r) {
          var n = l.exec(e.slice(r, r + 2));
          return n ? (t.V = +n[0], r + n[0].length) : -1;
        }

        function x(t, e, r) {
          var n = l.exec(e.slice(r, r + 2));
          return n ? (t.W = +n[0], r + n[0].length) : -1;
        }

        function b(t, e, r) {
          var n = l.exec(e.slice(r, r + 4));
          return n ? (t.y = +n[0], r + n[0].length) : -1;
        }

        function _(t, e, r) {
          var n = l.exec(e.slice(r, r + 2));
          return n ? (t.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
        }

        function w(t, e, r) {
          var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(r, r + 6));
          return n ? (t.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
        }

        function T(t, e, r) {
          var n = l.exec(e.slice(r, r + 1));
          return n ? (t.q = 3 * n[0] - 3, r + n[0].length) : -1;
        }

        function k(t, e, r) {
          var n = l.exec(e.slice(r, r + 2));
          return n ? (t.m = n[0] - 1, r + n[0].length) : -1;
        }

        function M(t, e, r) {
          var n = l.exec(e.slice(r, r + 2));
          return n ? (t.d = +n[0], r + n[0].length) : -1;
        }

        function A(t, e, r) {
          var n = l.exec(e.slice(r, r + 3));
          return n ? (t.m = 0, t.d = +n[0], r + n[0].length) : -1;
        }

        function S(t, e, r) {
          var n = l.exec(e.slice(r, r + 2));
          return n ? (t.H = +n[0], r + n[0].length) : -1;
        }

        function E(t, e, r) {
          var n = l.exec(e.slice(r, r + 2));
          return n ? (t.M = +n[0], r + n[0].length) : -1;
        }

        function L(t, e, r) {
          var n = l.exec(e.slice(r, r + 2));
          return n ? (t.S = +n[0], r + n[0].length) : -1;
        }

        function C(t, e, r) {
          var n = l.exec(e.slice(r, r + 3));
          return n ? (t.L = +n[0], r + n[0].length) : -1;
        }

        function P(t, e, r) {
          var n = l.exec(e.slice(r, r + 6));
          return n ? (t.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
        }

        function I(t, e, r) {
          var n = c.exec(e.slice(r, r + 1));
          return n ? r + n[0].length : -1;
        }

        function O(t, e, r) {
          var n = l.exec(e.slice(r));
          return n ? (t.Q = +n[0], r + n[0].length) : -1;
        }

        function z(t, e, r) {
          var n = l.exec(e.slice(r));
          return n ? (t.s = +n[0], r + n[0].length) : -1;
        }

        function D(t, e) {
          return f(t.getDate(), e, 2);
        }

        function R(t, e) {
          return f(t.getHours(), e, 2);
        }

        function F(t, e) {
          return f(t.getHours() % 12 || 12, e, 2);
        }

        function B(t, r) {
          return f(1 + e.timeDay.count(e.timeYear(t), t), r, 3);
        }

        function N(t, e) {
          return f(t.getMilliseconds(), e, 3);
        }

        function j(t, e) {
          return N(t, e) + "000";
        }

        function U(t, e) {
          return f(t.getMonth() + 1, e, 2);
        }

        function V(t, e) {
          return f(t.getMinutes(), e, 2);
        }

        function q(t, e) {
          return f(t.getSeconds(), e, 2);
        }

        function H(t) {
          var e = t.getDay();
          return 0 === e ? 7 : e;
        }

        function G(t, r) {
          return f(e.timeSunday.count(e.timeYear(t) - 1, t), r, 2);
        }

        function Y(t, r) {
          var n = t.getDay();
          return t = n >= 4 || 0 === n ? e.timeThursday(t) : e.timeThursday.ceil(t), f(e.timeThursday.count(e.timeYear(t), t) + (4 === e.timeYear(t).getDay()), r, 2);
        }

        function W(t) {
          return t.getDay();
        }

        function X(t, r) {
          return f(e.timeMonday.count(e.timeYear(t) - 1, t), r, 2);
        }

        function Z(t, e) {
          return f(t.getFullYear() % 100, e, 2);
        }

        function J(t, e) {
          return f(t.getFullYear() % 1e4, e, 4);
        }

        function K(t) {
          var e = t.getTimezoneOffset();
          return (e > 0 ? "-" : (e *= -1, "+")) + f(e / 60 | 0, "0", 2) + f(e % 60, "0", 2);
        }

        function Q(t, e) {
          return f(t.getUTCDate(), e, 2);
        }

        function $(t, e) {
          return f(t.getUTCHours(), e, 2);
        }

        function tt(t, e) {
          return f(t.getUTCHours() % 12 || 12, e, 2);
        }

        function et(t, r) {
          return f(1 + e.utcDay.count(e.utcYear(t), t), r, 3);
        }

        function rt(t, e) {
          return f(t.getUTCMilliseconds(), e, 3);
        }

        function nt(t, e) {
          return rt(t, e) + "000";
        }

        function it(t, e) {
          return f(t.getUTCMonth() + 1, e, 2);
        }

        function at(t, e) {
          return f(t.getUTCMinutes(), e, 2);
        }

        function ot(t, e) {
          return f(t.getUTCSeconds(), e, 2);
        }

        function st(t) {
          var e = t.getUTCDay();
          return 0 === e ? 7 : e;
        }

        function lt(t, r) {
          return f(e.utcSunday.count(e.utcYear(t) - 1, t), r, 2);
        }

        function ct(t, r) {
          var n = t.getUTCDay();
          return t = n >= 4 || 0 === n ? e.utcThursday(t) : e.utcThursday.ceil(t), f(e.utcThursday.count(e.utcYear(t), t) + (4 === e.utcYear(t).getUTCDay()), r, 2);
        }

        function ut(t) {
          return t.getUTCDay();
        }

        function ft(t, r) {
          return f(e.utcMonday.count(e.utcYear(t) - 1, t), r, 2);
        }

        function ht(t, e) {
          return f(t.getUTCFullYear() % 100, e, 2);
        }

        function pt(t, e) {
          return f(t.getUTCFullYear() % 1e4, e, 4);
        }

        function dt() {
          return "+0000";
        }

        function mt() {
          return "%";
        }

        function gt(t) {
          return +t;
        }

        function vt(t) {
          return Math.floor(+t / 1e3);
        }

        function yt(e) {
          return o = a(e), t.timeFormat = o.format, t.timeParse = o.parse, t.utcFormat = o.utcFormat, t.utcParse = o.utcParse, o;
        }

        yt({
          dateTime: "%x, %X",
          date: "%-m/%-d/%Y",
          time: "%-I:%M:%S %p",
          periods: ["AM", "PM"],
          days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        });
        var xt = Date.prototype.toISOString ? function (t) {
          return t.toISOString();
        } : t.utcFormat("%Y-%m-%dT%H:%M:%S.%LZ");
        var bt = +new Date("2000-01-01T00:00:00.000Z") ? function (t) {
          var e = new Date(t);
          return isNaN(e) ? null : e;
        } : t.utcParse("%Y-%m-%dT%H:%M:%S.%LZ");
        t.isoFormat = xt, t.isoParse = bt, t.timeFormatDefaultLocale = yt, t.timeFormatLocale = a, Object.defineProperty(t, "__esModule", {
          value: !0
        });
      });
    }, {
      "d3-time": 168
    }],
    168: [function (t, e, r) {
      !function (t, n) {
        "object" == _typeof(r) && void 0 !== e ? n(r) : n((t = t || self).d3 = t.d3 || {});
      }(this, function (t) {
        "use strict";

        var e = new Date(),
            r = new Date();

        function n(t, i, a, o) {
          function s(e) {
            return t(e = 0 === arguments.length ? new Date() : new Date(+e)), e;
          }

          return s.floor = function (e) {
            return t(e = new Date(+e)), e;
          }, s.ceil = function (e) {
            return t(e = new Date(e - 1)), i(e, 1), t(e), e;
          }, s.round = function (t) {
            var e = s(t),
                r = s.ceil(t);
            return t - e < r - t ? e : r;
          }, s.offset = function (t, e) {
            return i(t = new Date(+t), null == e ? 1 : Math.floor(e)), t;
          }, s.range = function (e, r, n) {
            var a,
                o = [];
            if (e = s.ceil(e), n = null == n ? 1 : Math.floor(n), !(e < r && n > 0)) return o;

            do {
              o.push(a = new Date(+e)), i(e, n), t(e);
            } while (a < e && e < r);

            return o;
          }, s.filter = function (e) {
            return n(function (r) {
              if (r >= r) for (; t(r), !e(r);) {
                r.setTime(r - 1);
              }
            }, function (t, r) {
              if (t >= t) if (r < 0) for (; ++r <= 0;) {
                for (; i(t, -1), !e(t);) {
                  ;
                }
              } else for (; --r >= 0;) {
                for (; i(t, 1), !e(t);) {
                  ;
                }
              }
            });
          }, a && (s.count = function (n, i) {
            return e.setTime(+n), r.setTime(+i), t(e), t(r), Math.floor(a(e, r));
          }, s.every = function (t) {
            return t = Math.floor(t), isFinite(t) && t > 0 ? t > 1 ? s.filter(o ? function (e) {
              return o(e) % t == 0;
            } : function (e) {
              return s.count(0, e) % t == 0;
            }) : s : null;
          }), s;
        }

        var i = n(function () {}, function (t, e) {
          t.setTime(+t + e);
        }, function (t, e) {
          return e - t;
        });

        i.every = function (t) {
          return t = Math.floor(t), isFinite(t) && t > 0 ? t > 1 ? n(function (e) {
            e.setTime(Math.floor(e / t) * t);
          }, function (e, r) {
            e.setTime(+e + r * t);
          }, function (e, r) {
            return (r - e) / t;
          }) : i : null;
        };

        var a = i.range,
            o = n(function (t) {
          t.setTime(t - t.getMilliseconds());
        }, function (t, e) {
          t.setTime(+t + 1e3 * e);
        }, function (t, e) {
          return (e - t) / 1e3;
        }, function (t) {
          return t.getUTCSeconds();
        }),
            s = o.range,
            l = n(function (t) {
          t.setTime(t - t.getMilliseconds() - 1e3 * t.getSeconds());
        }, function (t, e) {
          t.setTime(+t + 6e4 * e);
        }, function (t, e) {
          return (e - t) / 6e4;
        }, function (t) {
          return t.getMinutes();
        }),
            c = l.range,
            u = n(function (t) {
          t.setTime(t - t.getMilliseconds() - 1e3 * t.getSeconds() - 6e4 * t.getMinutes());
        }, function (t, e) {
          t.setTime(+t + 36e5 * e);
        }, function (t, e) {
          return (e - t) / 36e5;
        }, function (t) {
          return t.getHours();
        }),
            f = u.range,
            h = n(function (t) {
          t.setHours(0, 0, 0, 0);
        }, function (t, e) {
          t.setDate(t.getDate() + e);
        }, function (t, e) {
          return (e - t - 6e4 * (e.getTimezoneOffset() - t.getTimezoneOffset())) / 864e5;
        }, function (t) {
          return t.getDate() - 1;
        }),
            p = h.range;

        function d(t) {
          return n(function (e) {
            e.setDate(e.getDate() - (e.getDay() + 7 - t) % 7), e.setHours(0, 0, 0, 0);
          }, function (t, e) {
            t.setDate(t.getDate() + 7 * e);
          }, function (t, e) {
            return (e - t - 6e4 * (e.getTimezoneOffset() - t.getTimezoneOffset())) / 6048e5;
          });
        }

        var m = d(0),
            g = d(1),
            v = d(2),
            y = d(3),
            x = d(4),
            b = d(5),
            _ = d(6),
            w = m.range,
            T = g.range,
            k = v.range,
            M = y.range,
            A = x.range,
            S = b.range,
            E = _.range,
            L = n(function (t) {
          t.setDate(1), t.setHours(0, 0, 0, 0);
        }, function (t, e) {
          t.setMonth(t.getMonth() + e);
        }, function (t, e) {
          return e.getMonth() - t.getMonth() + 12 * (e.getFullYear() - t.getFullYear());
        }, function (t) {
          return t.getMonth();
        }),
            C = L.range,
            P = n(function (t) {
          t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
        }, function (t, e) {
          t.setFullYear(t.getFullYear() + e);
        }, function (t, e) {
          return e.getFullYear() - t.getFullYear();
        }, function (t) {
          return t.getFullYear();
        });

        P.every = function (t) {
          return isFinite(t = Math.floor(t)) && t > 0 ? n(function (e) {
            e.setFullYear(Math.floor(e.getFullYear() / t) * t), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
          }, function (e, r) {
            e.setFullYear(e.getFullYear() + r * t);
          }) : null;
        };

        var I = P.range,
            O = n(function (t) {
          t.setUTCSeconds(0, 0);
        }, function (t, e) {
          t.setTime(+t + 6e4 * e);
        }, function (t, e) {
          return (e - t) / 6e4;
        }, function (t) {
          return t.getUTCMinutes();
        }),
            z = O.range,
            D = n(function (t) {
          t.setUTCMinutes(0, 0, 0);
        }, function (t, e) {
          t.setTime(+t + 36e5 * e);
        }, function (t, e) {
          return (e - t) / 36e5;
        }, function (t) {
          return t.getUTCHours();
        }),
            R = D.range,
            F = n(function (t) {
          t.setUTCHours(0, 0, 0, 0);
        }, function (t, e) {
          t.setUTCDate(t.getUTCDate() + e);
        }, function (t, e) {
          return (e - t) / 864e5;
        }, function (t) {
          return t.getUTCDate() - 1;
        }),
            B = F.range;

        function N(t) {
          return n(function (e) {
            e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - t) % 7), e.setUTCHours(0, 0, 0, 0);
          }, function (t, e) {
            t.setUTCDate(t.getUTCDate() + 7 * e);
          }, function (t, e) {
            return (e - t) / 6048e5;
          });
        }

        var j = N(0),
            U = N(1),
            V = N(2),
            q = N(3),
            H = N(4),
            G = N(5),
            Y = N(6),
            W = j.range,
            X = U.range,
            Z = V.range,
            J = q.range,
            K = H.range,
            Q = G.range,
            $ = Y.range,
            tt = n(function (t) {
          t.setUTCDate(1), t.setUTCHours(0, 0, 0, 0);
        }, function (t, e) {
          t.setUTCMonth(t.getUTCMonth() + e);
        }, function (t, e) {
          return e.getUTCMonth() - t.getUTCMonth() + 12 * (e.getUTCFullYear() - t.getUTCFullYear());
        }, function (t) {
          return t.getUTCMonth();
        }),
            et = tt.range,
            rt = n(function (t) {
          t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
        }, function (t, e) {
          t.setUTCFullYear(t.getUTCFullYear() + e);
        }, function (t, e) {
          return e.getUTCFullYear() - t.getUTCFullYear();
        }, function (t) {
          return t.getUTCFullYear();
        });

        rt.every = function (t) {
          return isFinite(t = Math.floor(t)) && t > 0 ? n(function (e) {
            e.setUTCFullYear(Math.floor(e.getUTCFullYear() / t) * t), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
          }, function (e, r) {
            e.setUTCFullYear(e.getUTCFullYear() + r * t);
          }) : null;
        };

        var nt = rt.range;
        t.timeDay = h, t.timeDays = p, t.timeFriday = b, t.timeFridays = S, t.timeHour = u, t.timeHours = f, t.timeInterval = n, t.timeMillisecond = i, t.timeMilliseconds = a, t.timeMinute = l, t.timeMinutes = c, t.timeMonday = g, t.timeMondays = T, t.timeMonth = L, t.timeMonths = C, t.timeSaturday = _, t.timeSaturdays = E, t.timeSecond = o, t.timeSeconds = s, t.timeSunday = m, t.timeSundays = w, t.timeThursday = x, t.timeThursdays = A, t.timeTuesday = v, t.timeTuesdays = k, t.timeWednesday = y, t.timeWednesdays = M, t.timeWeek = m, t.timeWeeks = w, t.timeYear = P, t.timeYears = I, t.utcDay = F, t.utcDays = B, t.utcFriday = G, t.utcFridays = Q, t.utcHour = D, t.utcHours = R, t.utcMillisecond = i, t.utcMilliseconds = a, t.utcMinute = O, t.utcMinutes = z, t.utcMonday = U, t.utcMondays = X, t.utcMonth = tt, t.utcMonths = et, t.utcSaturday = Y, t.utcSaturdays = $, t.utcSecond = o, t.utcSeconds = s, t.utcSunday = j, t.utcSundays = W, t.utcThursday = H, t.utcThursdays = K, t.utcTuesday = V, t.utcTuesdays = Z, t.utcWednesday = q, t.utcWednesdays = J, t.utcWeek = j, t.utcWeeks = W, t.utcYear = rt, t.utcYears = nt, Object.defineProperty(t, "__esModule", {
          value: !0
        });
      });
    }, {}],
    169: [function (t, e, r) {
      !function (t, n) {
        "object" == _typeof(r) && void 0 !== e ? n(r) : n((t = t || self).d3 = t.d3 || {});
      }(this, function (t) {
        "use strict";

        var e,
            r,
            n = 0,
            i = 0,
            a = 0,
            o = 0,
            s = 0,
            l = 0,
            c = "object" == (typeof performance === "undefined" ? "undefined" : _typeof(performance)) && performance.now ? performance : Date,
            u = "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (t) {
          setTimeout(t, 17);
        };

        function f() {
          return s || (u(h), s = c.now() + l);
        }

        function h() {
          s = 0;
        }

        function p() {
          this._call = this._time = this._next = null;
        }

        function d(t, e, r) {
          var n = new p();
          return n.restart(t, e, r), n;
        }

        function m() {
          f(), ++n;

          for (var t, r = e; r;) {
            (t = s - r._time) >= 0 && r._call.call(null, t), r = r._next;
          }

          --n;
        }

        function g() {
          s = (o = c.now()) + l, n = i = 0;

          try {
            m();
          } finally {
            n = 0, function () {
              var t,
                  n,
                  i = e,
                  a = 1 / 0;

              for (; i;) {
                i._call ? (a > i._time && (a = i._time), t = i, i = i._next) : (n = i._next, i._next = null, i = t ? t._next = n : e = n);
              }

              r = t, y(a);
            }(), s = 0;
          }
        }

        function v() {
          var t = c.now(),
              e = t - o;
          e > 1e3 && (l -= e, o = t);
        }

        function y(t) {
          n || (i && (i = clearTimeout(i)), t - s > 24 ? (t < 1 / 0 && (i = setTimeout(g, t - c.now() - l)), a && (a = clearInterval(a))) : (a || (o = c.now(), a = setInterval(v, 1e3)), n = 1, u(g)));
        }

        p.prototype = d.prototype = {
          constructor: p,
          restart: function restart(t, n, i) {
            if ("function" != typeof t) throw new TypeError("callback is not a function");
            i = (null == i ? f() : +i) + (null == n ? 0 : +n), this._next || r === this || (r ? r._next = this : e = this, r = this), this._call = t, this._time = i, y();
          },
          stop: function stop() {
            this._call && (this._call = null, this._time = 1 / 0, y());
          }
        }, t.interval = function (t, e, r) {
          var n = new p(),
              i = e;
          return null == e ? (n.restart(t, e, r), n) : (e = +e, r = null == r ? f() : +r, n.restart(function a(o) {
            o += i, n.restart(a, i += e, r), t(o);
          }, e, r), n);
        }, t.now = f, t.timeout = function (t, e, r) {
          var n = new p();
          return e = null == e ? 0 : +e, n.restart(function (r) {
            n.stop(), t(r + e);
          }, e, r), n;
        }, t.timer = d, t.timerFlush = m, Object.defineProperty(t, "__esModule", {
          value: !0
        });
      });
    }, {}],
    170: [function (t, e, r) {
      e.exports = function () {
        for (var t = 0; t < arguments.length; t++) {
          if (void 0 !== arguments[t]) return arguments[t];
        }
      };
    }, {}],
    171: [function (t, e, r) {
      "use strict";

      var n = t("incremental-convex-hull"),
          i = t("uniq");

      function a(t, e) {
        this.point = t, this.index = e;
      }

      function o(t, e) {
        for (var r = t.point, n = e.point, i = r.length, a = 0; a < i; ++a) {
          var o = n[a] - r[a];
          if (o) return o;
        }

        return 0;
      }

      e.exports = function (t, e) {
        var r = t.length;
        if (0 === r) return [];
        var s = t[0].length;
        if (s < 1) return [];
        if (1 === s) return function (t, e, r) {
          if (1 === t) return r ? [[-1, 0]] : [];
          var n = e.map(function (t, e) {
            return [t[0], e];
          });
          n.sort(function (t, e) {
            return t[0] - e[0];
          });

          for (var i = new Array(t - 1), a = 1; a < t; ++a) {
            var o = n[a - 1],
                s = n[a];
            i[a - 1] = [o[1], s[1]];
          }

          r && i.push([-1, i[0][1]], [i[t - 1][1], -1]);
          return i;
        }(r, t, e);

        for (var l = new Array(r), c = 1, u = 0; u < r; ++u) {
          for (var f = t[u], h = new Array(s + 1), p = 0, d = 0; d < s; ++d) {
            var m = f[d];
            h[d] = m, p += m * m;
          }

          h[s] = p, l[u] = new a(h, u), c = Math.max(p, c);
        }

        i(l, o), r = l.length;
        var g = new Array(r + s + 1),
            v = new Array(r + s + 1),
            y = (s + 1) * (s + 1) * c,
            x = new Array(s + 1);

        for (u = 0; u <= s; ++u) {
          x[u] = 0;
        }

        x[s] = y, g[0] = x.slice(), v[0] = -1;

        for (u = 0; u <= s; ++u) {
          (h = x.slice())[u] = 1, g[u + 1] = h, v[u + 1] = -1;
        }

        for (u = 0; u < r; ++u) {
          var b = l[u];
          g[u + s + 1] = b.point, v[u + s + 1] = b.index;
        }

        var _ = n(g, !1);

        _ = e ? _.filter(function (t) {
          for (var e = 0, r = 0; r <= s; ++r) {
            var n = v[t[r]];
            if (n < 0 && ++e >= 2) return !1;
            t[r] = n;
          }

          return !0;
        }) : _.filter(function (t) {
          for (var e = 0; e <= s; ++e) {
            var r = v[t[e]];
            if (r < 0) return !1;
            t[e] = r;
          }

          return !0;
        });
        if (1 & s) for (u = 0; u < _.length; ++u) {
          h = (b = _[u])[0];
          b[0] = b[1], b[1] = h;
        }
        return _;
      };
    }, {
      "incremental-convex-hull": 437,
      uniq: 611
    }],
    172: [function (t, e, r) {
      "use strict";

      e.exports = a;
      var n = (a.canvas = document.createElement("canvas")).getContext("2d"),
          i = o([32, 126]);

      function a(t, e) {
        Array.isArray(t) && (t = t.join(", "));
        var r,
            a = {},
            s = 16,
            l = .05;
        e && (2 === e.length && "number" == typeof e[0] ? r = o(e) : Array.isArray(e) ? r = e : (e.o ? r = o(e.o) : e.pairs && (r = e.pairs), e.fontSize && (s = e.fontSize), null != e.threshold && (l = e.threshold))), r || (r = i), n.font = s + "px " + t;

        for (var c = 0; c < r.length; c++) {
          var u = r[c],
              f = n.measureText(u[0]).width + n.measureText(u[1]).width,
              h = n.measureText(u).width;

          if (Math.abs(f - h) > s * l) {
            var p = (h - f) / s;
            a[u] = 1e3 * p;
          }
        }

        return a;
      }

      function o(t) {
        for (var e = [], r = t[0]; r <= t[1]; r++) {
          for (var n = String.fromCharCode(r), i = t[0]; i < t[1]; i++) {
            var a = n + String.fromCharCode(i);
            e.push(a);
          }
        }

        return e;
      }

      a.createPairs = o, a.ascii = i;
    }, {}],
    173: [function (t, e, r) {
      (function (t) {
        (function () {
          var r = !1;

          if ("undefined" != typeof Float64Array) {
            var n = new Float64Array(1),
                i = new Uint32Array(n.buffer);

            if (n[0] = 1, r = !0, 1072693248 === i[1]) {
              e.exports = function (t) {
                return n[0] = t, [i[0], i[1]];
              }, e.exports.pack = function (t, e) {
                return i[0] = t, i[1] = e, n[0];
              }, e.exports.lo = function (t) {
                return n[0] = t, i[0];
              }, e.exports.hi = function (t) {
                return n[0] = t, i[1];
              };
            } else if (1072693248 === i[0]) {
              e.exports = function (t) {
                return n[0] = t, [i[1], i[0]];
              }, e.exports.pack = function (t, e) {
                return i[1] = t, i[0] = e, n[0];
              }, e.exports.lo = function (t) {
                return n[0] = t, i[1];
              }, e.exports.hi = function (t) {
                return n[0] = t, i[0];
              };
            } else r = !1;
          }

          if (!r) {
            var a = new t(8);
            e.exports = function (t) {
              return a.writeDoubleLE(t, 0, !0), [a.readUInt32LE(0, !0), a.readUInt32LE(4, !0)];
            }, e.exports.pack = function (t, e) {
              return a.writeUInt32LE(t, 0, !0), a.writeUInt32LE(e, 4, !0), a.readDoubleLE(0, !0);
            }, e.exports.lo = function (t) {
              return a.writeDoubleLE(t, 0, !0), a.readUInt32LE(0, !0);
            }, e.exports.hi = function (t) {
              return a.writeDoubleLE(t, 0, !0), a.readUInt32LE(4, !0);
            };
          }

          e.exports.sign = function (t) {
            return e.exports.hi(t) >>> 31;
          }, e.exports.exponent = function (t) {
            return (e.exports.hi(t) << 1 >>> 21) - 1023;
          }, e.exports.fraction = function (t) {
            var r = e.exports.lo(t),
                n = e.exports.hi(t),
                i = 1048575 & n;
            return 2146435072 & n && (i += 1 << 20), [r, i];
          }, e.exports.denormalized = function (t) {
            return !(2146435072 & e.exports.hi(t));
          };
        }).call(this);
      }).call(this, t("buffer").Buffer);
    }, {
      buffer: 112
    }],
    174: [function (t, e, r) {
      var n = t("abs-svg-path"),
          i = t("normalize-svg-path"),
          a = {
        M: "moveTo",
        C: "bezierCurveTo"
      };

      e.exports = function (t, e) {
        t.beginPath(), i(n(e)).forEach(function (e) {
          var r = e[0],
              n = e.slice(1);
          t[a[r]].apply(t, n);
        }), t.closePath();
      };
    }, {
      "abs-svg-path": 66,
      "normalize-svg-path": 477
    }],
    175: [function (t, e, r) {
      e.exports = function (t) {
        switch (t) {
          case "int8":
            return Int8Array;

          case "int16":
            return Int16Array;

          case "int32":
            return Int32Array;

          case "uint8":
            return Uint8Array;

          case "uint16":
            return Uint16Array;

          case "uint32":
            return Uint32Array;

          case "float32":
            return Float32Array;

          case "float64":
            return Float64Array;

          case "array":
            return Array;

          case "uint8_clamped":
            return Uint8ClampedArray;
        }
      };
    }, {}],
    176: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        switch (void 0 === e && (e = 0), _typeof(t)) {
          case "number":
            if (t > 0) return function (t, e) {
              var r, n;

              for (r = new Array(t), n = 0; n < t; ++n) {
                r[n] = e;
              }

              return r;
            }(0 | t, e);
            break;

          case "object":
            if ("number" == typeof t.length) return function t(e, r, n) {
              var i = 0 | e[n];
              if (i <= 0) return [];
              var a,
                  o = new Array(i);
              if (n === e.length - 1) for (a = 0; a < i; ++a) {
                o[a] = r;
              } else for (a = 0; a < i; ++a) {
                o[a] = t(e, r, n + 1);
              }
              return o;
            }(t, e, 0);
        }

        return [];
      };
    }, {}],
    177: [function (t, e, r) {
      "use strict";

      function n(t, e, r) {
        r = r || 2;
        var n,
            s,
            l,
            c,
            u,
            p,
            d,
            g = e && e.length,
            v = g ? e[0] * r : t.length,
            y = i(t, 0, v, r, !0),
            x = [];
        if (!y || y.next === y.prev) return x;

        if (g && (y = function (t, e, r, n) {
          var o,
              s,
              l,
              c,
              u,
              p = [];

          for (o = 0, s = e.length; o < s; o++) {
            l = e[o] * n, c = o < s - 1 ? e[o + 1] * n : t.length, (u = i(t, l, c, n, !1)) === u.next && (u.steiner = !0), p.push(m(u));
          }

          for (p.sort(f), o = 0; o < p.length; o++) {
            h(p[o], r), r = a(r, r.next);
          }

          return r;
        }(t, e, y, r)), t.length > 80 * r) {
          n = l = t[0], s = c = t[1];

          for (var b = r; b < v; b += r) {
            (u = t[b]) < n && (n = u), (p = t[b + 1]) < s && (s = p), u > l && (l = u), p > c && (c = p);
          }

          d = 0 !== (d = Math.max(l - n, c - s)) ? 1 / d : 0;
        }

        return o(y, x, r, n, s, d), x;
      }

      function i(t, e, r, n, i) {
        var a, o;
        if (i === E(t, e, r, n) > 0) for (a = e; a < r; a += n) {
          o = M(a, t[a], t[a + 1], o);
        } else for (a = r - n; a >= e; a -= n) {
          o = M(a, t[a], t[a + 1], o);
        }
        return o && x(o, o.next) && (A(o), o = o.next), o;
      }

      function a(t, e) {
        if (!t) return t;
        e || (e = t);
        var r,
            n = t;

        do {
          if (r = !1, n.steiner || !x(n, n.next) && 0 !== y(n.prev, n, n.next)) n = n.next;else {
            if (A(n), (n = e = n.prev) === n.next) break;
            r = !0;
          }
        } while (r || n !== e);

        return e;
      }

      function o(t, e, r, n, i, f, h) {
        if (t) {
          !h && f && function (t, e, r, n) {
            var i = t;

            do {
              null === i.z && (i.z = d(i.x, i.y, e, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
            } while (i !== t);

            i.prevZ.nextZ = null, i.prevZ = null, function (t) {
              var e,
                  r,
                  n,
                  i,
                  a,
                  o,
                  s,
                  l,
                  c = 1;

              do {
                for (r = t, t = null, a = null, o = 0; r;) {
                  for (o++, n = r, s = 0, e = 0; e < c && (s++, n = n.nextZ); e++) {
                    ;
                  }

                  for (l = c; s > 0 || l > 0 && n;) {
                    0 !== s && (0 === l || !n || r.z <= n.z) ? (i = r, r = r.nextZ, s--) : (i = n, n = n.nextZ, l--), a ? a.nextZ = i : t = i, i.prevZ = a, a = i;
                  }

                  r = n;
                }

                a.nextZ = null, c *= 2;
              } while (o > 1);
            }(i);
          }(t, n, i, f);

          for (var p, m, g = t; t.prev !== t.next;) {
            if (p = t.prev, m = t.next, f ? l(t, n, i, f) : s(t)) e.push(p.i / r), e.push(t.i / r), e.push(m.i / r), A(t), t = m.next, g = m.next;else if ((t = m) === g) {
              h ? 1 === h ? o(t = c(a(t), e, r), e, r, n, i, f, 2) : 2 === h && u(t, e, r, n, i, f) : o(a(t), e, r, n, i, f, 1);
              break;
            }
          }
        }
      }

      function s(t) {
        var e = t.prev,
            r = t,
            n = t.next;
        if (y(e, r, n) >= 0) return !1;

        for (var i = t.next.next; i !== t.prev;) {
          if (g(e.x, e.y, r.x, r.y, n.x, n.y, i.x, i.y) && y(i.prev, i, i.next) >= 0) return !1;
          i = i.next;
        }

        return !0;
      }

      function l(t, e, r, n) {
        var i = t.prev,
            a = t,
            o = t.next;
        if (y(i, a, o) >= 0) return !1;

        for (var s = i.x < a.x ? i.x < o.x ? i.x : o.x : a.x < o.x ? a.x : o.x, l = i.y < a.y ? i.y < o.y ? i.y : o.y : a.y < o.y ? a.y : o.y, c = i.x > a.x ? i.x > o.x ? i.x : o.x : a.x > o.x ? a.x : o.x, u = i.y > a.y ? i.y > o.y ? i.y : o.y : a.y > o.y ? a.y : o.y, f = d(s, l, e, r, n), h = d(c, u, e, r, n), p = t.prevZ, m = t.nextZ; p && p.z >= f && m && m.z <= h;) {
          if (p !== t.prev && p !== t.next && g(i.x, i.y, a.x, a.y, o.x, o.y, p.x, p.y) && y(p.prev, p, p.next) >= 0) return !1;
          if (p = p.prevZ, m !== t.prev && m !== t.next && g(i.x, i.y, a.x, a.y, o.x, o.y, m.x, m.y) && y(m.prev, m, m.next) >= 0) return !1;
          m = m.nextZ;
        }

        for (; p && p.z >= f;) {
          if (p !== t.prev && p !== t.next && g(i.x, i.y, a.x, a.y, o.x, o.y, p.x, p.y) && y(p.prev, p, p.next) >= 0) return !1;
          p = p.prevZ;
        }

        for (; m && m.z <= h;) {
          if (m !== t.prev && m !== t.next && g(i.x, i.y, a.x, a.y, o.x, o.y, m.x, m.y) && y(m.prev, m, m.next) >= 0) return !1;
          m = m.nextZ;
        }

        return !0;
      }

      function c(t, e, r) {
        var n = t;

        do {
          var i = n.prev,
              o = n.next.next;
          !x(i, o) && b(i, n, n.next, o) && T(i, o) && T(o, i) && (e.push(i.i / r), e.push(n.i / r), e.push(o.i / r), A(n), A(n.next), n = t = o), n = n.next;
        } while (n !== t);

        return a(n);
      }

      function u(t, e, r, n, i, s) {
        var l = t;

        do {
          for (var c = l.next.next; c !== l.prev;) {
            if (l.i !== c.i && v(l, c)) {
              var u = k(l, c);
              return l = a(l, l.next), u = a(u, u.next), o(l, e, r, n, i, s), void o(u, e, r, n, i, s);
            }

            c = c.next;
          }

          l = l.next;
        } while (l !== t);
      }

      function f(t, e) {
        return t.x - e.x;
      }

      function h(t, e) {
        if (e = function (t, e) {
          var r,
              n = e,
              i = t.x,
              a = t.y,
              o = -1 / 0;

          do {
            if (a <= n.y && a >= n.next.y && n.next.y !== n.y) {
              var s = n.x + (a - n.y) * (n.next.x - n.x) / (n.next.y - n.y);

              if (s <= i && s > o) {
                if (o = s, s === i) {
                  if (a === n.y) return n;
                  if (a === n.next.y) return n.next;
                }

                r = n.x < n.next.x ? n : n.next;
              }
            }

            n = n.next;
          } while (n !== e);

          if (!r) return null;
          if (i === o) return r;
          var l,
              c = r,
              u = r.x,
              f = r.y,
              h = 1 / 0;
          n = r;

          do {
            i >= n.x && n.x >= u && i !== n.x && g(a < f ? i : o, a, u, f, a < f ? o : i, a, n.x, n.y) && (l = Math.abs(a - n.y) / (i - n.x), T(n, t) && (l < h || l === h && (n.x > r.x || n.x === r.x && p(r, n))) && (r = n, h = l)), n = n.next;
          } while (n !== c);

          return r;
        }(t, e)) {
          var r = k(e, t);
          a(e, e.next), a(r, r.next);
        }
      }

      function p(t, e) {
        return y(t.prev, t, e.prev) < 0 && y(e.next, t, t.next) < 0;
      }

      function d(t, e, r, n, i) {
        return (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = 32767 * (t - r) * i) | t << 8)) | t << 4)) | t << 2)) | t << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = 32767 * (e - n) * i) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
      }

      function m(t) {
        var e = t,
            r = t;

        do {
          (e.x < r.x || e.x === r.x && e.y < r.y) && (r = e), e = e.next;
        } while (e !== t);

        return r;
      }

      function g(t, e, r, n, i, a, o, s) {
        return (i - o) * (e - s) - (t - o) * (a - s) >= 0 && (t - o) * (n - s) - (r - o) * (e - s) >= 0 && (r - o) * (a - s) - (i - o) * (n - s) >= 0;
      }

      function v(t, e) {
        return t.next.i !== e.i && t.prev.i !== e.i && !function (t, e) {
          var r = t;

          do {
            if (r.i !== t.i && r.next.i !== t.i && r.i !== e.i && r.next.i !== e.i && b(r, r.next, t, e)) return !0;
            r = r.next;
          } while (r !== t);

          return !1;
        }(t, e) && (T(t, e) && T(e, t) && function (t, e) {
          var r = t,
              n = !1,
              i = (t.x + e.x) / 2,
              a = (t.y + e.y) / 2;

          do {
            r.y > a != r.next.y > a && r.next.y !== r.y && i < (r.next.x - r.x) * (a - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
          } while (r !== t);

          return n;
        }(t, e) && (y(t.prev, t, e.prev) || y(t, e.prev, e)) || x(t, e) && y(t.prev, t, t.next) > 0 && y(e.prev, e, e.next) > 0);
      }

      function y(t, e, r) {
        return (e.y - t.y) * (r.x - e.x) - (e.x - t.x) * (r.y - e.y);
      }

      function x(t, e) {
        return t.x === e.x && t.y === e.y;
      }

      function b(t, e, r, n) {
        var i = w(y(t, e, r)),
            a = w(y(t, e, n)),
            o = w(y(r, n, t)),
            s = w(y(r, n, e));
        return i !== a && o !== s || !(0 !== i || !_(t, r, e)) || !(0 !== a || !_(t, n, e)) || !(0 !== o || !_(r, t, n)) || !(0 !== s || !_(r, e, n));
      }

      function _(t, e, r) {
        return e.x <= Math.max(t.x, r.x) && e.x >= Math.min(t.x, r.x) && e.y <= Math.max(t.y, r.y) && e.y >= Math.min(t.y, r.y);
      }

      function w(t) {
        return t > 0 ? 1 : t < 0 ? -1 : 0;
      }

      function T(t, e) {
        return y(t.prev, t, t.next) < 0 ? y(t, e, t.next) >= 0 && y(t, t.prev, e) >= 0 : y(t, e, t.prev) < 0 || y(t, t.next, e) < 0;
      }

      function k(t, e) {
        var r = new S(t.i, t.x, t.y),
            n = new S(e.i, e.x, e.y),
            i = t.next,
            a = e.prev;
        return t.next = e, e.prev = t, r.next = i, i.prev = r, n.next = r, r.prev = n, a.next = n, n.prev = a, n;
      }

      function M(t, e, r, n) {
        var i = new S(t, e, r);
        return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
      }

      function A(t) {
        t.next.prev = t.prev, t.prev.next = t.next, t.prevZ && (t.prevZ.nextZ = t.nextZ), t.nextZ && (t.nextZ.prevZ = t.prevZ);
      }

      function S(t, e, r) {
        this.i = t, this.x = e, this.y = r, this.prev = null, this.next = null, this.z = null, this.prevZ = null, this.nextZ = null, this.steiner = !1;
      }

      function E(t, e, r, n) {
        for (var i = 0, a = e, o = r - n; a < r; a += n) {
          i += (t[o] - t[a]) * (t[a + 1] + t[o + 1]), o = a;
        }

        return i;
      }

      e.exports = n, e.exports.default = n, n.deviation = function (t, e, r, n) {
        var i = e && e.length,
            a = i ? e[0] * r : t.length,
            o = Math.abs(E(t, 0, a, r));
        if (i) for (var s = 0, l = e.length; s < l; s++) {
          var c = e[s] * r,
              u = s < l - 1 ? e[s + 1] * r : t.length;
          o -= Math.abs(E(t, c, u, r));
        }
        var f = 0;

        for (s = 0; s < n.length; s += 3) {
          var h = n[s] * r,
              p = n[s + 1] * r,
              d = n[s + 2] * r;
          f += Math.abs((t[h] - t[d]) * (t[p + 1] - t[h + 1]) - (t[h] - t[p]) * (t[d + 1] - t[h + 1]));
        }

        return 0 === o && 0 === f ? 0 : Math.abs((f - o) / o);
      }, n.flatten = function (t) {
        for (var e = t[0][0].length, r = {
          vertices: [],
          holes: [],
          dimensions: e
        }, n = 0, i = 0; i < t.length; i++) {
          for (var a = 0; a < t[i].length; a++) {
            for (var o = 0; o < e; o++) {
              r.vertices.push(t[i][a][o]);
            }
          }

          i > 0 && (n += t[i - 1].length, r.holes.push(n));
        }

        return r;
      };
    }, {}],
    178: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        var r = t.length;

        if ("number" != typeof e) {
          e = 0;

          for (var i = 0; i < r; ++i) {
            var a = t[i];
            e = Math.max(e, a[0], a[1]);
          }

          e = 1 + (0 | e);
        }

        e |= 0;
        var o = new Array(e);

        for (i = 0; i < e; ++i) {
          o[i] = [];
        }

        for (i = 0; i < r; ++i) {
          a = t[i];
          o[a[0]].push(a[1]), o[a[1]].push(a[0]);
        }

        for (var s = 0; s < e; ++s) {
          n(o[s], function (t, e) {
            return t - e;
          });
        }

        return o;
      };

      var n = t("uniq");
    }, {
      uniq: 611
    }],
    179: [function (t, e, r) {
      var n = t("strongly-connected-components");

      e.exports = function (t, e) {
        var r,
            i = [],
            a = [],
            o = [],
            s = {},
            l = [];

        function c(t) {
          var e,
              n,
              i = !1;

          for (a.push(t), o[t] = !0, e = 0; e < l[t].length; e++) {
            (n = l[t][e]) === r ? (u(r, a), i = !0) : o[n] || (i = c(n));
          }

          if (i) !function t(e) {
            o[e] = !1, s.hasOwnProperty(e) && Object.keys(s[e]).forEach(function (r) {
              delete s[e][r], o[r] && t(r);
            });
          }(t);else for (e = 0; e < l[t].length; e++) {
            n = l[t][e];
            var f = s[n];
            f || (f = {}, s[n] = f), f[n] = !0;
          }
          return a.pop(), i;
        }

        function u(t, r) {
          var n = [].concat(r).concat(t);
          e ? e(c) : i.push(n);
        }

        function f(e) {
          !function (e) {
            for (var r = 0; r < t.length; r++) {
              r < e && (t[r] = []), t[r] = t[r].filter(function (t) {
                return t >= e;
              });
            }
          }(e);

          for (var r, i = n(t).components.filter(function (t) {
            return t.length > 1;
          }), a = 1 / 0, o = 0; o < i.length; o++) {
            for (var s = 0; s < i[o].length; s++) {
              i[o][s] < a && (a = i[o][s], r = o);
            }
          }

          var l = i[r];
          return !!l && {
            leastVertex: a,
            adjList: t.map(function (t, e) {
              return -1 === l.indexOf(e) ? [] : t.filter(function (t) {
                return -1 !== l.indexOf(t);
              });
            })
          };
        }

        r = 0;

        for (var h = t.length; r < h;) {
          var p = f(r);

          if (r = p.leastVertex, l = p.adjList) {
            for (var d = 0; d < l.length; d++) {
              for (var m = 0; m < l[d].length; m++) {
                var g = l[d][m];
                o[+g] = !1, s[g] = {};
              }
            }

            c(r), r += 1;
          } else r = h;
        }

        return e ? void 0 : i;
      };
    }, {
      "strongly-connected-components": 582
    }],
    180: [function (t, e, r) {
      "use strict";

      var n = t("../../object/valid-value");

      e.exports = function () {
        return n(this).length = 0, this;
      };
    }, {
      "../../object/valid-value": 211
    }],
    181: [function (t, e, r) {
      "use strict";

      e.exports = t("./is-implemented")() ? Array.from : t("./shim");
    }, {
      "./is-implemented": 182,
      "./shim": 183
    }],
    182: [function (t, e, r) {
      "use strict";

      e.exports = function () {
        var t,
            e,
            r = Array.from;
        return "function" == typeof r && (e = r(t = ["raz", "dwa"]), Boolean(e && e !== t && "dwa" === e[1]));
      };
    }, {}],
    183: [function (t, e, r) {
      "use strict";

      var n = t("es6-symbol").iterator,
          i = t("../../function/is-arguments"),
          a = t("../../function/is-function"),
          o = t("../../number/to-pos-integer"),
          s = t("../../object/valid-callable"),
          l = t("../../object/valid-value"),
          c = t("../../object/is-value"),
          u = t("../../string/is-string"),
          f = Array.isArray,
          h = Function.prototype.call,
          p = {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        value: null
      },
          d = Object.defineProperty;

      e.exports = function (t) {
        var e,
            r,
            m,
            g,
            v,
            y,
            x,
            b,
            _,
            w,
            T = arguments[1],
            k = arguments[2];

        if (t = Object(l(t)), c(T) && s(T), this && this !== Array && a(this)) e = this;else {
          if (!T) {
            if (i(t)) return 1 !== (v = t.length) ? Array.apply(null, t) : ((g = new Array(1))[0] = t[0], g);

            if (f(t)) {
              for (g = new Array(v = t.length), r = 0; r < v; ++r) {
                g[r] = t[r];
              }

              return g;
            }
          }

          g = [];
        }
        if (!f(t)) if (void 0 !== (_ = t[n])) {
          for (x = s(_).call(t), e && (g = new e()), b = x.next(), r = 0; !b.done;) {
            w = T ? h.call(T, k, b.value, r) : b.value, e ? (p.value = w, d(g, r, p)) : g[r] = w, b = x.next(), ++r;
          }

          v = r;
        } else if (u(t)) {
          for (v = t.length, e && (g = new e()), r = 0, m = 0; r < v; ++r) {
            w = t[r], r + 1 < v && (y = w.charCodeAt(0)) >= 55296 && y <= 56319 && (w += t[++r]), w = T ? h.call(T, k, w, m) : w, e ? (p.value = w, d(g, m, p)) : g[m] = w, ++m;
          }

          v = m;
        }
        if (void 0 === v) for (v = o(t.length), e && (g = new e(v)), r = 0; r < v; ++r) {
          w = T ? h.call(T, k, t[r], r) : t[r], e ? (p.value = w, d(g, r, p)) : g[r] = w;
        }
        return e && (p.value = null, g.length = v), g;
      };
    }, {
      "../../function/is-arguments": 184,
      "../../function/is-function": 185,
      "../../number/to-pos-integer": 191,
      "../../object/is-value": 200,
      "../../object/valid-callable": 209,
      "../../object/valid-value": 211,
      "../../string/is-string": 215,
      "es6-symbol": 224
    }],
    184: [function (t, e, r) {
      "use strict";

      var n = Object.prototype.toString,
          i = n.call(function () {
        return arguments;
      }());

      e.exports = function (t) {
        return n.call(t) === i;
      };
    }, {}],
    185: [function (t, e, r) {
      "use strict";

      var n = Object.prototype.toString,
          i = RegExp.prototype.test.bind(/^[object [A-Za-z0-9]*Function]$/);

      e.exports = function (t) {
        return "function" == typeof t && i(n.call(t));
      };
    }, {}],
    186: [function (t, e, r) {
      "use strict";

      e.exports = function () {};
    }, {}],
    187: [function (t, e, r) {
      "use strict";

      e.exports = t("./is-implemented")() ? Math.sign : t("./shim");
    }, {
      "./is-implemented": 188,
      "./shim": 189
    }],
    188: [function (t, e, r) {
      "use strict";

      e.exports = function () {
        var t = Math.sign;
        return "function" == typeof t && 1 === t(10) && -1 === t(-20);
      };
    }, {}],
    189: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        return t = Number(t), isNaN(t) || 0 === t ? t : t > 0 ? 1 : -1;
      };
    }, {}],
    190: [function (t, e, r) {
      "use strict";

      var n = t("../math/sign"),
          i = Math.abs,
          a = Math.floor;

      e.exports = function (t) {
        return isNaN(t) ? 0 : 0 !== (t = Number(t)) && isFinite(t) ? n(t) * a(i(t)) : t;
      };
    }, {
      "../math/sign": 187
    }],
    191: [function (t, e, r) {
      "use strict";

      var n = t("./to-integer"),
          i = Math.max;

      e.exports = function (t) {
        return i(0, n(t));
      };
    }, {
      "./to-integer": 190
    }],
    192: [function (t, e, r) {
      "use strict";

      var n = t("./valid-callable"),
          i = t("./valid-value"),
          a = Function.prototype.bind,
          o = Function.prototype.call,
          s = Object.keys,
          l = Object.prototype.propertyIsEnumerable;

      e.exports = function (t, e) {
        return function (r, c) {
          var u,
              f = arguments[2],
              h = arguments[3];
          return r = Object(i(r)), n(c), u = s(r), h && u.sort("function" == typeof h ? a.call(h, r) : void 0), "function" != typeof t && (t = u[t]), o.call(t, u, function (t, n) {
            return l.call(r, t) ? o.call(c, f, r[t], t, r, n) : e;
          });
        };
      };
    }, {
      "./valid-callable": 209,
      "./valid-value": 211
    }],
    193: [function (t, e, r) {
      "use strict";

      e.exports = t("./is-implemented")() ? Object.assign : t("./shim");
    }, {
      "./is-implemented": 194,
      "./shim": 195
    }],
    194: [function (t, e, r) {
      "use strict";

      e.exports = function () {
        var t,
            e = Object.assign;
        return "function" == typeof e && (e(t = {
          foo: "raz"
        }, {
          bar: "dwa"
        }, {
          trzy: "trzy"
        }), t.foo + t.bar + t.trzy === "razdwatrzy");
      };
    }, {}],
    195: [function (t, e, r) {
      "use strict";

      var n = t("../keys"),
          i = t("../valid-value"),
          a = Math.max;

      e.exports = function (t, e) {
        var r,
            o,
            s,
            l = a(arguments.length, 2);

        for (t = Object(i(t)), s = function s(n) {
          try {
            t[n] = e[n];
          } catch (t) {
            r || (r = t);
          }
        }, o = 1; o < l; ++o) {
          n(e = arguments[o]).forEach(s);
        }

        if (void 0 !== r) throw r;
        return t;
      };
    }, {
      "../keys": 201,
      "../valid-value": 211
    }],
    196: [function (t, e, r) {
      "use strict";

      var n = t("../array/from"),
          i = t("./assign"),
          a = t("./valid-value");

      e.exports = function (t) {
        var e = Object(a(t)),
            r = arguments[1],
            o = Object(arguments[2]);
        if (e !== t && !r) return e;
        var s = {};
        return r ? n(r, function (e) {
          (o.ensure || e in t) && (s[e] = t[e]);
        }) : i(s, t), s;
      };
    }, {
      "../array/from": 181,
      "./assign": 193,
      "./valid-value": 211
    }],
    197: [function (t, e, r) {
      "use strict";

      var n,
          i,
          a,
          o,
          s = Object.create;
      t("./set-prototype-of/is-implemented")() || (n = t("./set-prototype-of/shim")), e.exports = n ? 1 !== n.level ? s : (i = {}, a = {}, o = {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: void 0
      }, Object.getOwnPropertyNames(Object.prototype).forEach(function (t) {
        a[t] = "__proto__" !== t ? o : {
          configurable: !0,
          enumerable: !1,
          writable: !0,
          value: void 0
        };
      }), Object.defineProperties(i, a), Object.defineProperty(n, "nullPolyfill", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: i
      }), function (t, e) {
        return s(null === t ? i : t, e);
      }) : s;
    }, {
      "./set-prototype-of/is-implemented": 207,
      "./set-prototype-of/shim": 208
    }],
    198: [function (t, e, r) {
      "use strict";

      e.exports = t("./_iterate")("forEach");
    }, {
      "./_iterate": 192
    }],
    199: [function (t, e, r) {
      "use strict";

      var n = t("./is-value"),
          i = {
        function: !0,
        object: !0
      };

      e.exports = function (t) {
        return n(t) && i[_typeof(t)] || !1;
      };
    }, {
      "./is-value": 200
    }],
    200: [function (t, e, r) {
      "use strict";

      var n = t("../function/noop")();

      e.exports = function (t) {
        return t !== n && null !== t;
      };
    }, {
      "../function/noop": 186
    }],
    201: [function (t, e, r) {
      "use strict";

      e.exports = t("./is-implemented")() ? Object.keys : t("./shim");
    }, {
      "./is-implemented": 202,
      "./shim": 203
    }],
    202: [function (t, e, r) {
      "use strict";

      e.exports = function () {
        try {
          return Object.keys("primitive"), !0;
        } catch (t) {
          return !1;
        }
      };
    }, {}],
    203: [function (t, e, r) {
      "use strict";

      var n = t("../is-value"),
          i = Object.keys;

      e.exports = function (t) {
        return i(n(t) ? Object(t) : t);
      };
    }, {
      "../is-value": 200
    }],
    204: [function (t, e, r) {
      "use strict";

      var n = t("./valid-callable"),
          i = t("./for-each"),
          a = Function.prototype.call;

      e.exports = function (t, e) {
        var r = {},
            o = arguments[2];
        return n(e), i(t, function (t, n, i, s) {
          r[n] = a.call(e, o, t, n, i, s);
        }), r;
      };
    }, {
      "./for-each": 198,
      "./valid-callable": 209
    }],
    205: [function (t, e, r) {
      "use strict";

      var n = t("./is-value"),
          i = Array.prototype.forEach,
          a = Object.create,
          o = function o(t, e) {
        var r;

        for (r in t) {
          e[r] = t[r];
        }
      };

      e.exports = function (t) {
        var e = a(null);
        return i.call(arguments, function (t) {
          n(t) && o(Object(t), e);
        }), e;
      };
    }, {
      "./is-value": 200
    }],
    206: [function (t, e, r) {
      "use strict";

      e.exports = t("./is-implemented")() ? Object.setPrototypeOf : t("./shim");
    }, {
      "./is-implemented": 207,
      "./shim": 208
    }],
    207: [function (t, e, r) {
      "use strict";

      var n = Object.create,
          i = Object.getPrototypeOf,
          a = {};

      e.exports = function () {
        var t = Object.setPrototypeOf,
            e = arguments[0] || n;
        return "function" == typeof t && i(t(e(null), a)) === a;
      };
    }, {}],
    208: [function (t, e, r) {
      "use strict";

      var n,
          i = t("../is-object"),
          a = t("../valid-value"),
          o = Object.prototype.isPrototypeOf,
          s = Object.defineProperty,
          l = {
        configurable: !0,
        enumerable: !1,
        writable: !0,
        value: void 0
      };
      n = function n(t, e) {
        if (a(t), null === e || i(e)) return t;
        throw new TypeError("Prototype must be null or an object");
      }, e.exports = function (t) {
        var e, r;
        return t ? (2 === t.level ? t.set ? (r = t.set, e = function e(t, _e4) {
          return r.call(n(t, _e4), _e4), t;
        }) : e = function e(t, _e5) {
          return n(t, _e5).__proto__ = _e5, t;
        } : e = function t(e, r) {
          var i;
          return n(e, r), (i = o.call(t.nullPolyfill, e)) && delete t.nullPolyfill.__proto__, null === r && (r = t.nullPolyfill), e.__proto__ = r, i && s(t.nullPolyfill, "__proto__", l), e;
        }, Object.defineProperty(e, "level", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: t.level
        })) : null;
      }(function () {
        var t,
            e = Object.create(null),
            r = {},
            n = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__");

        if (n) {
          try {
            (t = n.set).call(e, r);
          } catch (t) {}

          if (Object.getPrototypeOf(e) === r) return {
            set: t,
            level: 2
          };
        }

        return e.__proto__ = r, Object.getPrototypeOf(e) === r ? {
          level: 2
        } : ((e = {}).__proto__ = r, Object.getPrototypeOf(e) === r && {
          level: 1
        });
      }()), t("../create");
    }, {
      "../create": 197,
      "../is-object": 199,
      "../valid-value": 211
    }],
    209: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        if ("function" != typeof t) throw new TypeError(t + " is not a function");
        return t;
      };
    }, {}],
    210: [function (t, e, r) {
      "use strict";

      var n = t("./is-object");

      e.exports = function (t) {
        if (!n(t)) throw new TypeError(t + " is not an Object");
        return t;
      };
    }, {
      "./is-object": 199
    }],
    211: [function (t, e, r) {
      "use strict";

      var n = t("./is-value");

      e.exports = function (t) {
        if (!n(t)) throw new TypeError("Cannot use null or undefined");
        return t;
      };
    }, {
      "./is-value": 200
    }],
    212: [function (t, e, r) {
      "use strict";

      e.exports = t("./is-implemented")() ? String.prototype.contains : t("./shim");
    }, {
      "./is-implemented": 213,
      "./shim": 214
    }],
    213: [function (t, e, r) {
      "use strict";

      var n = "razdwatrzy";

      e.exports = function () {
        return "function" == typeof n.contains && !0 === n.contains("dwa") && !1 === n.contains("foo");
      };
    }, {}],
    214: [function (t, e, r) {
      "use strict";

      var n = String.prototype.indexOf;

      e.exports = function (t) {
        return n.call(this, t, arguments[1]) > -1;
      };
    }, {}],
    215: [function (t, e, r) {
      "use strict";

      var n = Object.prototype.toString,
          i = n.call("");

      e.exports = function (t) {
        return "string" == typeof t || t && "object" == _typeof(t) && (t instanceof String || n.call(t) === i) || !1;
      };
    }, {}],
    216: [function (t, e, r) {
      "use strict";

      var n = Object.create(null),
          i = Math.random;

      e.exports = function () {
        var t;

        do {
          t = i().toString(36).slice(2);
        } while (n[t]);

        return t;
      };
    }, {}],
    217: [function (t, e, r) {
      "use strict";

      var n,
          i = t("es5-ext/object/set-prototype-of"),
          a = t("es5-ext/string/#/contains"),
          o = t("d"),
          s = t("es6-symbol"),
          l = t("./"),
          c = Object.defineProperty;
      n = e.exports = function (t, e) {
        if (!(this instanceof n)) throw new TypeError("Constructor requires 'new'");
        l.call(this, t), e = e ? a.call(e, "key+value") ? "key+value" : a.call(e, "key") ? "key" : "value" : "value", c(this, "__kind__", o("", e));
      }, i && i(n, l), delete n.prototype.constructor, n.prototype = Object.create(l.prototype, {
        _resolve: o(function (t) {
          return "value" === this.__kind__ ? this.__list__[t] : "key+value" === this.__kind__ ? [t, this.__list__[t]] : t;
        })
      }), c(n.prototype, s.toStringTag, o("c", "Array Iterator"));
    }, {
      "./": 220,
      d: 156,
      "es5-ext/object/set-prototype-of": 206,
      "es5-ext/string/#/contains": 212,
      "es6-symbol": 224
    }],
    218: [function (t, e, r) {
      "use strict";

      var n = t("es5-ext/function/is-arguments"),
          i = t("es5-ext/object/valid-callable"),
          a = t("es5-ext/string/is-string"),
          o = t("./get"),
          s = Array.isArray,
          l = Function.prototype.call,
          c = Array.prototype.some;

      e.exports = function (t, e) {
        var r,
            u,
            f,
            h,
            p,
            d,
            m,
            g,
            v = arguments[2];
        if (s(t) || n(t) ? r = "array" : a(t) ? r = "string" : t = o(t), i(e), f = function f() {
          h = !0;
        }, "array" !== r) {
          if ("string" !== r) for (u = t.next(); !u.done;) {
            if (l.call(e, v, u.value, f), h) return;
            u = t.next();
          } else for (d = t.length, p = 0; p < d && (m = t[p], p + 1 < d && (g = m.charCodeAt(0)) >= 55296 && g <= 56319 && (m += t[++p]), l.call(e, v, m, f), !h); ++p) {
            ;
          }
        } else c.call(t, function (t) {
          return l.call(e, v, t, f), h;
        });
      };
    }, {
      "./get": 219,
      "es5-ext/function/is-arguments": 184,
      "es5-ext/object/valid-callable": 209,
      "es5-ext/string/is-string": 215
    }],
    219: [function (t, e, r) {
      "use strict";

      var n = t("es5-ext/function/is-arguments"),
          i = t("es5-ext/string/is-string"),
          a = t("./array"),
          o = t("./string"),
          s = t("./valid-iterable"),
          l = t("es6-symbol").iterator;

      e.exports = function (t) {
        return "function" == typeof s(t)[l] ? t[l]() : n(t) ? new a(t) : i(t) ? new o(t) : new a(t);
      };
    }, {
      "./array": 217,
      "./string": 222,
      "./valid-iterable": 223,
      "es5-ext/function/is-arguments": 184,
      "es5-ext/string/is-string": 215,
      "es6-symbol": 224
    }],
    220: [function (t, e, r) {
      "use strict";

      var _n2,
          i = t("es5-ext/array/#/clear"),
          a = t("es5-ext/object/assign"),
          o = t("es5-ext/object/valid-callable"),
          s = t("es5-ext/object/valid-value"),
          l = t("d"),
          c = t("d/auto-bind"),
          u = t("es6-symbol"),
          f = Object.defineProperty,
          h = Object.defineProperties;

      e.exports = _n2 = function n(t, e) {
        if (!(this instanceof _n2)) throw new TypeError("Constructor requires 'new'");
        h(this, {
          __list__: l("w", s(t)),
          __context__: l("w", e),
          __nextIndex__: l("w", 0)
        }), e && (o(e.on), e.on("_add", this._onAdd), e.on("_delete", this._onDelete), e.on("_clear", this._onClear));
      }, delete _n2.prototype.constructor, h(_n2.prototype, a({
        _next: l(function () {
          var t;
          if (this.__list__) return this.__redo__ && void 0 !== (t = this.__redo__.shift()) ? t : this.__nextIndex__ < this.__list__.length ? this.__nextIndex__++ : void this._unBind();
        }),
        next: l(function () {
          return this._createResult(this._next());
        }),
        _createResult: l(function (t) {
          return void 0 === t ? {
            done: !0,
            value: void 0
          } : {
            done: !1,
            value: this._resolve(t)
          };
        }),
        _resolve: l(function (t) {
          return this.__list__[t];
        }),
        _unBind: l(function () {
          this.__list__ = null, delete this.__redo__, this.__context__ && (this.__context__.off("_add", this._onAdd), this.__context__.off("_delete", this._onDelete), this.__context__.off("_clear", this._onClear), this.__context__ = null);
        }),
        toString: l(function () {
          return "[object " + (this[u.toStringTag] || "Object") + "]";
        })
      }, c({
        _onAdd: l(function (t) {
          t >= this.__nextIndex__ || (++this.__nextIndex__, this.__redo__ ? (this.__redo__.forEach(function (e, r) {
            e >= t && (this.__redo__[r] = ++e);
          }, this), this.__redo__.push(t)) : f(this, "__redo__", l("c", [t])));
        }),
        _onDelete: l(function (t) {
          var e;
          t >= this.__nextIndex__ || (--this.__nextIndex__, this.__redo__ && (-1 !== (e = this.__redo__.indexOf(t)) && this.__redo__.splice(e, 1), this.__redo__.forEach(function (e, r) {
            e > t && (this.__redo__[r] = --e);
          }, this)));
        }),
        _onClear: l(function () {
          this.__redo__ && i.call(this.__redo__), this.__nextIndex__ = 0;
        })
      }))), f(_n2.prototype, u.iterator, l(function () {
        return this;
      }));
    }, {
      d: 156,
      "d/auto-bind": 155,
      "es5-ext/array/#/clear": 180,
      "es5-ext/object/assign": 193,
      "es5-ext/object/valid-callable": 209,
      "es5-ext/object/valid-value": 211,
      "es6-symbol": 224
    }],
    221: [function (t, e, r) {
      "use strict";

      var n = t("es5-ext/function/is-arguments"),
          i = t("es5-ext/object/is-value"),
          a = t("es5-ext/string/is-string"),
          o = t("es6-symbol").iterator,
          s = Array.isArray;

      e.exports = function (t) {
        return !!i(t) && (!!s(t) || !!a(t) || !!n(t) || "function" == typeof t[o]);
      };
    }, {
      "es5-ext/function/is-arguments": 184,
      "es5-ext/object/is-value": 200,
      "es5-ext/string/is-string": 215,
      "es6-symbol": 224
    }],
    222: [function (t, e, r) {
      "use strict";

      var n,
          i = t("es5-ext/object/set-prototype-of"),
          a = t("d"),
          o = t("es6-symbol"),
          s = t("./"),
          l = Object.defineProperty;
      n = e.exports = function (t) {
        if (!(this instanceof n)) throw new TypeError("Constructor requires 'new'");
        t = String(t), s.call(this, t), l(this, "__length__", a("", t.length));
      }, i && i(n, s), delete n.prototype.constructor, n.prototype = Object.create(s.prototype, {
        _next: a(function () {
          if (this.__list__) return this.__nextIndex__ < this.__length__ ? this.__nextIndex__++ : void this._unBind();
        }),
        _resolve: a(function (t) {
          var e,
              r = this.__list__[t];
          return this.__nextIndex__ === this.__length__ ? r : (e = r.charCodeAt(0)) >= 55296 && e <= 56319 ? r + this.__list__[this.__nextIndex__++] : r;
        })
      }), l(n.prototype, o.toStringTag, a("c", "String Iterator"));
    }, {
      "./": 220,
      d: 156,
      "es5-ext/object/set-prototype-of": 206,
      "es6-symbol": 224
    }],
    223: [function (t, e, r) {
      "use strict";

      var n = t("./is-iterable");

      e.exports = function (t) {
        if (!n(t)) throw new TypeError(t + " is not iterable");
        return t;
      };
    }, {
      "./is-iterable": 221
    }],
    224: [function (t, e, r) {
      "use strict";

      e.exports = t("./is-implemented")() ? t("ext/global-this").Symbol : t("./polyfill");
    }, {
      "./is-implemented": 225,
      "./polyfill": 230,
      "ext/global-this": 237
    }],
    225: [function (t, e, r) {
      "use strict";

      var n = t("ext/global-this"),
          i = {
        object: !0,
        symbol: !0
      };

      e.exports = function () {
        var t,
            e = n.Symbol;
        if ("function" != typeof e) return !1;
        t = e("test symbol");

        try {
          String(t);
        } catch (t) {
          return !1;
        }

        return !!i[_typeof(e.iterator)] && !!i[_typeof(e.toPrimitive)] && !!i[_typeof(e.toStringTag)];
      };
    }, {
      "ext/global-this": 237
    }],
    226: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        return !!t && ("symbol" == _typeof(t) || !!t.constructor && "Symbol" === t.constructor.name && "Symbol" === t[t.constructor.toStringTag]);
      };
    }, {}],
    227: [function (t, e, r) {
      "use strict";

      var n = t("d"),
          i = Object.create,
          a = Object.defineProperty,
          o = Object.prototype,
          s = i(null);

      e.exports = function (t) {
        for (var e, r, i = 0; s[t + (i || "")];) {
          ++i;
        }

        return s[t += i || ""] = !0, a(o, e = "@@" + t, n.gs(null, function (t) {
          r || (r = !0, a(this, e, n(t)), r = !1);
        })), e;
      };
    }, {
      d: 156
    }],
    228: [function (t, e, r) {
      "use strict";

      var n = t("d"),
          i = t("ext/global-this").Symbol;

      e.exports = function (t) {
        return Object.defineProperties(t, {
          hasInstance: n("", i && i.hasInstance || t("hasInstance")),
          isConcatSpreadable: n("", i && i.isConcatSpreadable || t("isConcatSpreadable")),
          iterator: n("", i && i.iterator || t("iterator")),
          match: n("", i && i.match || t("match")),
          replace: n("", i && i.replace || t("replace")),
          search: n("", i && i.search || t("search")),
          species: n("", i && i.species || t("species")),
          split: n("", i && i.split || t("split")),
          toPrimitive: n("", i && i.toPrimitive || t("toPrimitive")),
          toStringTag: n("", i && i.toStringTag || t("toStringTag")),
          unscopables: n("", i && i.unscopables || t("unscopables"))
        });
      };
    }, {
      d: 156,
      "ext/global-this": 237
    }],
    229: [function (t, e, r) {
      "use strict";

      var n = t("d"),
          i = t("../../../validate-symbol"),
          a = Object.create(null);

      e.exports = function (t) {
        return Object.defineProperties(t, {
          for: n(function (e) {
            return a[e] ? a[e] : a[e] = t(String(e));
          }),
          keyFor: n(function (t) {
            var e;

            for (e in i(t), a) {
              if (a[e] === t) return e;
            }
          })
        });
      };
    }, {
      "../../../validate-symbol": 231,
      d: 156
    }],
    230: [function (t, e, r) {
      "use strict";

      var n,
          _i2,
          a,
          o = t("d"),
          s = t("./validate-symbol"),
          l = t("ext/global-this").Symbol,
          c = t("./lib/private/generate-name"),
          u = t("./lib/private/setup/standard-symbols"),
          f = t("./lib/private/setup/symbol-registry"),
          h = Object.create,
          p = Object.defineProperties,
          d = Object.defineProperty;

      if ("function" == typeof l) try {
        String(l()), a = !0;
      } catch (t) {} else l = null;
      _i2 = function i(t) {
        if (this instanceof _i2) throw new TypeError("Symbol is not a constructor");
        return n(t);
      }, e.exports = n = function t(e) {
        var r;
        if (this instanceof t) throw new TypeError("Symbol is not a constructor");
        return a ? l(e) : (r = h(_i2.prototype), e = void 0 === e ? "" : String(e), p(r, {
          __description__: o("", e),
          __name__: o("", c(e))
        }));
      }, u(n), f(n), p(_i2.prototype, {
        constructor: o(n),
        toString: o("", function () {
          return this.__name__;
        })
      }), p(n.prototype, {
        toString: o(function () {
          return "Symbol (" + s(this).__description__ + ")";
        }),
        valueOf: o(function () {
          return s(this);
        })
      }), d(n.prototype, n.toPrimitive, o("", function () {
        var t = s(this);
        return "symbol" == _typeof(t) ? t : t.toString();
      })), d(n.prototype, n.toStringTag, o("c", "Symbol")), d(_i2.prototype, n.toStringTag, o("c", n.prototype[n.toStringTag])), d(_i2.prototype, n.toPrimitive, o("c", n.prototype[n.toPrimitive]));
    }, {
      "./lib/private/generate-name": 227,
      "./lib/private/setup/standard-symbols": 228,
      "./lib/private/setup/symbol-registry": 229,
      "./validate-symbol": 231,
      d: 156,
      "ext/global-this": 237
    }],
    231: [function (t, e, r) {
      "use strict";

      var n = t("./is-symbol");

      e.exports = function (t) {
        if (!n(t)) throw new TypeError(t + " is not a symbol");
        return t;
      };
    }, {
      "./is-symbol": 226
    }],
    232: [function (t, e, r) {
      "use strict";

      e.exports = t("./is-implemented")() ? WeakMap : t("./polyfill");
    }, {
      "./is-implemented": 233,
      "./polyfill": 235
    }],
    233: [function (t, e, r) {
      "use strict";

      e.exports = function () {
        var t, e;
        if ("function" != typeof WeakMap) return !1;

        try {
          t = new WeakMap([[e = {}, "one"], [{}, "two"], [{}, "three"]]);
        } catch (t) {
          return !1;
        }

        return "[object WeakMap]" === String(t) && "function" == typeof t.set && t.set({}, 1) === t && "function" == typeof t.delete && "function" == typeof t.has && "one" === t.get(e);
      };
    }, {}],
    234: [function (t, e, r) {
      "use strict";

      e.exports = "function" == typeof WeakMap && "[object WeakMap]" === Object.prototype.toString.call(new WeakMap());
    }, {}],
    235: [function (t, e, r) {
      "use strict";

      var _n3,
          i = t("es5-ext/object/is-value"),
          a = t("es5-ext/object/set-prototype-of"),
          o = t("es5-ext/object/valid-object"),
          s = t("es5-ext/object/valid-value"),
          l = t("es5-ext/string/random-uniq"),
          c = t("d"),
          u = t("es6-iterator/get"),
          f = t("es6-iterator/for-of"),
          h = t("es6-symbol").toStringTag,
          p = t("./is-native-implemented"),
          d = Array.isArray,
          m = Object.defineProperty,
          g = Object.prototype.hasOwnProperty,
          v = Object.getPrototypeOf;

      e.exports = _n3 = function n() {
        var t,
            e = arguments[0];
        if (!(this instanceof _n3)) throw new TypeError("Constructor requires 'new'");
        return t = p && a && WeakMap !== _n3 ? a(new WeakMap(), v(this)) : this, i(e) && (d(e) || (e = u(e))), m(t, "__weakMapData__", c("c", "$weakMap$" + l())), e ? (f(e, function (e) {
          s(e), t.set(e[0], e[1]);
        }), t) : t;
      }, p && (a && a(_n3, WeakMap), _n3.prototype = Object.create(WeakMap.prototype, {
        constructor: c(_n3)
      })), Object.defineProperties(_n3.prototype, {
        delete: c(function (t) {
          return !!g.call(o(t), this.__weakMapData__) && (delete t[this.__weakMapData__], !0);
        }),
        get: c(function (t) {
          if (g.call(o(t), this.__weakMapData__)) return t[this.__weakMapData__];
        }),
        has: c(function (t) {
          return g.call(o(t), this.__weakMapData__);
        }),
        set: c(function (t, e) {
          return m(o(t), this.__weakMapData__, c("c", e)), this;
        }),
        toString: c(function () {
          return "[object WeakMap]";
        })
      }), m(_n3.prototype, h, c("c", "WeakMap"));
    }, {
      "./is-native-implemented": 234,
      d: 156,
      "es5-ext/object/is-value": 200,
      "es5-ext/object/set-prototype-of": 206,
      "es5-ext/object/valid-object": 210,
      "es5-ext/object/valid-value": 211,
      "es5-ext/string/random-uniq": 216,
      "es6-iterator/for-of": 218,
      "es6-iterator/get": 219,
      "es6-symbol": 224
    }],
    236: [function (t, e, r) {
      var n = function n() {
        if ("object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self) return self;
        if ("object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window) return window;
        throw new Error("Unable to resolve global `this`");
      };

      e.exports = function () {
        if (this) return this;

        try {
          Object.defineProperty(Object.prototype, "__global__", {
            get: function get() {
              return this;
            },
            configurable: !0
          });
        } catch (t) {
          return n();
        }

        try {
          return __global__ || n();
        } finally {
          delete Object.prototype.__global__;
        }
      }();
    }, {}],
    237: [function (t, e, r) {
      "use strict";

      e.exports = t("./is-implemented")() ? globalThis : t("./implementation");
    }, {
      "./implementation": 236,
      "./is-implemented": 238
    }],
    238: [function (t, e, r) {
      "use strict";

      e.exports = function () {
        return "object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) && !!globalThis && globalThis.Array === Array;
      };
    }, {}],
    239: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r) {
        var n = e || 0,
            i = r || 1;
        return [[t[12] + t[0], t[13] + t[1], t[14] + t[2], t[15] + t[3]], [t[12] - t[0], t[13] - t[1], t[14] - t[2], t[15] - t[3]], [t[12] + t[4], t[13] + t[5], t[14] + t[6], t[15] + t[7]], [t[12] - t[4], t[13] - t[5], t[14] - t[6], t[15] - t[7]], [n * t[12] + t[8], n * t[13] + t[9], n * t[14] + t[10], n * t[15] + t[11]], [i * t[12] - t[8], i * t[13] - t[9], i * t[14] - t[10], i * t[15] - t[11]]];
      };
    }, {}],
    240: [function (t, e, r) {
      "use strict";

      var n = t("is-string-blank");

      e.exports = function (t) {
        var e = _typeof(t);

        if ("string" === e) {
          var r = t;
          if (0 === (t = +t) && n(r)) return !1;
        } else if ("number" !== e) return !1;

        return t - t < 1;
      };
    }, {
      "is-string-blank": 449
    }],
    241: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r) {
        switch (arguments.length) {
          case 0:
            return new o([0], [0], 0);

          case 1:
            return "number" == typeof t ? new o(n = l(t), n, 0) : new o(t, l(t.length), 0);

          case 2:
            if ("number" == typeof e) {
              var n = l(t.length);
              return new o(t, n, +e);
            }

            r = 0;

          case 3:
            if (t.length !== e.length) throw new Error("state and velocity lengths must match");
            return new o(t, e, r);
        }
      };

      var n = t("cubic-hermite"),
          i = t("binary-search-bounds");

      function a(t, e, r) {
        return Math.min(e, Math.max(t, r));
      }

      function o(t, e, r) {
        this.dimension = t.length, this.bounds = [new Array(this.dimension), new Array(this.dimension)];

        for (var n = 0; n < this.dimension; ++n) {
          this.bounds[0][n] = -1 / 0, this.bounds[1][n] = 1 / 0;
        }

        this._state = t.slice().reverse(), this._velocity = e.slice().reverse(), this._time = [r], this._scratch = [t.slice(), t.slice(), t.slice(), t.slice(), t.slice()];
      }

      var s = o.prototype;

      function l(t) {
        for (var e = new Array(t), r = 0; r < t; ++r) {
          e[r] = 0;
        }

        return e;
      }

      s.flush = function (t) {
        var e = i.gt(this._time, t) - 1;
        e <= 0 || (this._time.splice(0, e), this._state.splice(0, e * this.dimension), this._velocity.splice(0, e * this.dimension));
      }, s.curve = function (t) {
        var e = this._time,
            r = e.length,
            o = i.le(e, t),
            s = this._scratch[0],
            l = this._state,
            c = this._velocity,
            u = this.dimension,
            f = this.bounds;
        if (o < 0) for (var h = u - 1, p = 0; p < u; ++p, --h) {
          s[p] = l[h];
        } else if (o >= r - 1) {
          h = l.length - 1;
          var d = t - e[r - 1];

          for (p = 0; p < u; ++p, --h) {
            s[p] = l[h] + d * c[h];
          }
        } else {
          h = u * (o + 1) - 1;

          var m = e[o],
              g = e[o + 1] - m || 1,
              v = this._scratch[1],
              y = this._scratch[2],
              x = this._scratch[3],
              b = this._scratch[4],
              _ = !0;

          for (p = 0; p < u; ++p, --h) {
            v[p] = l[h], x[p] = c[h] * g, y[p] = l[h + u], b[p] = c[h + u] * g, _ = _ && v[p] === y[p] && x[p] === b[p] && 0 === x[p];
          }

          if (_) for (p = 0; p < u; ++p) {
            s[p] = v[p];
          } else n(v, x, y, b, (t - m) / g, s);
        }
        var w = f[0],
            T = f[1];

        for (p = 0; p < u; ++p) {
          s[p] = a(w[p], T[p], s[p]);
        }

        return s;
      }, s.dcurve = function (t) {
        var e = this._time,
            r = e.length,
            a = i.le(e, t),
            o = this._scratch[0],
            s = this._state,
            l = this._velocity,
            c = this.dimension;
        if (a >= r - 1) for (var u = s.length - 1, f = (e[r - 1], 0); f < c; ++f, --u) {
          o[f] = l[u];
        } else {
          u = c * (a + 1) - 1;
          var h = e[a],
              p = e[a + 1] - h || 1,
              d = this._scratch[1],
              m = this._scratch[2],
              g = this._scratch[3],
              v = this._scratch[4],
              y = !0;

          for (f = 0; f < c; ++f, --u) {
            d[f] = s[u], g[f] = l[u] * p, m[f] = s[u + c], v[f] = l[u + c] * p, y = y && d[f] === m[f] && g[f] === v[f] && 0 === g[f];
          }

          if (y) for (f = 0; f < c; ++f) {
            o[f] = 0;
          } else {
            n.derivative(d, g, m, v, (t - h) / p, o);

            for (f = 0; f < c; ++f) {
              o[f] /= p;
            }
          }
        }
        return o;
      }, s.lastT = function () {
        var t = this._time;
        return t[t.length - 1];
      }, s.stable = function () {
        for (var t = this._velocity, e = t.length, r = this.dimension - 1; r >= 0; --r) {
          if (t[--e]) return !1;
        }

        return !0;
      }, s.jump = function (t) {
        var e = this.lastT(),
            r = this.dimension;

        if (!(t < e || arguments.length !== r + 1)) {
          var n = this._state,
              i = this._velocity,
              o = n.length - this.dimension,
              s = this.bounds,
              l = s[0],
              c = s[1];

          this._time.push(e, t);

          for (var u = 0; u < 2; ++u) {
            for (var f = 0; f < r; ++f) {
              n.push(n[o++]), i.push(0);
            }
          }

          this._time.push(t);

          for (f = r; f > 0; --f) {
            n.push(a(l[f - 1], c[f - 1], arguments[f])), i.push(0);
          }
        }
      }, s.push = function (t) {
        var e = this.lastT(),
            r = this.dimension;

        if (!(t < e || arguments.length !== r + 1)) {
          var n = this._state,
              i = this._velocity,
              o = n.length - this.dimension,
              s = t - e,
              l = this.bounds,
              c = l[0],
              u = l[1],
              f = s > 1e-6 ? 1 / s : 0;

          this._time.push(t);

          for (var h = r; h > 0; --h) {
            var p = a(c[h - 1], u[h - 1], arguments[h]);
            n.push(p), i.push((p - n[o++]) * f);
          }
        }
      }, s.set = function (t) {
        var e = this.dimension;

        if (!(t < this.lastT() || arguments.length !== e + 1)) {
          var r = this._state,
              n = this._velocity,
              i = this.bounds,
              o = i[0],
              s = i[1];

          this._time.push(t);

          for (var l = e; l > 0; --l) {
            r.push(a(o[l - 1], s[l - 1], arguments[l])), n.push(0);
          }
        }
      }, s.move = function (t) {
        var e = this.lastT(),
            r = this.dimension;

        if (!(t <= e || arguments.length !== r + 1)) {
          var n = this._state,
              i = this._velocity,
              o = n.length - this.dimension,
              s = this.bounds,
              l = s[0],
              c = s[1],
              u = t - e,
              f = u > 1e-6 ? 1 / u : 0;

          this._time.push(t);

          for (var h = r; h > 0; --h) {
            var p = arguments[h];
            n.push(a(l[h - 1], c[h - 1], n[o++] + p)), i.push(p * f);
          }
        }
      }, s.idle = function (t) {
        var e = this.lastT();

        if (!(t < e)) {
          var r = this.dimension,
              n = this._state,
              i = this._velocity,
              o = n.length - r,
              s = this.bounds,
              l = s[0],
              c = s[1],
              u = t - e;

          this._time.push(t);

          for (var f = r - 1; f >= 0; --f) {
            n.push(a(l[f], c[f], n[o] + u * i[o])), i.push(0), o += 1;
          }
        }
      };
    }, {
      "binary-search-bounds": 242,
      "cubic-hermite": 151
    }],
    242: [function (t, e, r) {
      "use strict";

      function n(t, e, r, n, i, a) {
        var o = ["function ", t, "(a,l,h,", n.join(","), "){", a ? "" : "var i=", r ? "l-1" : "h+1", ";while(l<=h){var m=(l+h)>>>1,x=a", i ? ".get(m)" : "[m]"];
        return a ? e.indexOf("c") < 0 ? o.push(";if(x===y){return m}else if(x<=y){") : o.push(";var p=c(x,y);if(p===0){return m}else if(p<=0){") : o.push(";if(", e, "){i=m;"), r ? o.push("l=m+1}else{h=m-1}") : o.push("h=m-1}else{l=m+1}"), o.push("}"), a ? o.push("return -1};") : o.push("return i};"), o.join("");
      }

      function i(t, e, r, i) {
        return new Function([n("A", "x" + t + "y", e, ["y"], !1, i), n("B", "x" + t + "y", e, ["y"], !0, i), n("P", "c(x,y)" + t + "0", e, ["y", "c"], !1, i), n("Q", "c(x,y)" + t + "0", e, ["y", "c"], !0, i), "function dispatchBsearch", r, "(a,y,c,l,h){if(a.shape){if(typeof(c)==='function'){return Q(a,(l===undefined)?0:l|0,(h===undefined)?a.shape[0]-1:h|0,y,c)}else{return B(a,(c===undefined)?0:c|0,(l===undefined)?a.shape[0]-1:l|0,y)}}else{if(typeof(c)==='function'){return P(a,(l===undefined)?0:l|0,(h===undefined)?a.length-1:h|0,y,c)}else{return A(a,(c===undefined)?0:c|0,(l===undefined)?a.length-1:l|0,y)}}}return dispatchBsearch", r].join(""))();
      }

      e.exports = {
        ge: i(">=", !1, "GE"),
        gt: i(">", !1, "GT"),
        lt: i("<", !0, "LT"),
        le: i("<=", !0, "LE"),
        eq: i("-", !0, "EQ", !0)
      };
    }, {}],
    243: [function (t, e, r) {
      var n = t("dtype");

      e.exports = function (t, e, r) {
        if (!t) throw new TypeError("must specify data as first parameter");

        if (r = 0 | +(r || 0), Array.isArray(t) && t[0] && "number" == typeof t[0][0]) {
          var i,
              a,
              o,
              s,
              l = t[0].length,
              c = t.length * l;
          e && "string" != typeof e || (e = new (n(e || "float32"))(c + r));
          var u = e.length - r;
          if (c !== u) throw new Error("source length " + c + " (" + l + "x" + t.length + ") does not match destination length " + u);

          for (i = 0, o = r; i < t.length; i++) {
            for (a = 0; a < l; a++) {
              e[o++] = null === t[i][a] ? NaN : t[i][a];
            }
          }
        } else if (e && "string" != typeof e) e.set(t, r);else {
          var f = n(e || "float32");
          if (Array.isArray(t) || "array" === e) for (e = new f(t.length + r), i = 0, o = r, s = e.length; o < s; o++, i++) {
            e[o] = null === t[i] ? NaN : t[i];
          } else 0 === r ? e = new f(t) : (e = new f(t.length + r)).set(t, r);
        }

        return e;
      };
    }, {
      dtype: 175
    }],
    244: [function (t, e, r) {
      "use strict";

      var n = t("css-font/stringify"),
          i = [32, 126];

      e.exports = function (t) {
        var e = (t = t || {}).shape ? t.shape : t.canvas ? [t.canvas.width, t.canvas.height] : [512, 512],
            r = t.canvas || document.createElement("canvas"),
            a = t.font,
            o = "number" == typeof t.step ? [t.step, t.step] : t.step || [32, 32],
            s = t.chars || i;
        a && "string" != typeof a && (a = n(a));

        if (Array.isArray(s)) {
          if (2 === s.length && "number" == typeof s[0] && "number" == typeof s[1]) {
            for (var l = [], c = s[0], u = 0; c <= s[1]; c++) {
              l[u++] = String.fromCharCode(c);
            }

            s = l;
          }
        } else s = String(s).split("");

        e = e.slice(), r.width = e[0], r.height = e[1];
        var f = r.getContext("2d");
        f.fillStyle = "#000", f.fillRect(0, 0, r.width, r.height), f.font = a, f.textAlign = "center", f.textBaseline = "middle", f.fillStyle = "#fff";
        var h = o[0] / 2,
            p = o[1] / 2;

        for (c = 0; c < s.length; c++) {
          f.fillText(s[c], h, p), (h += o[0]) > e[0] - o[0] / 2 && (h = o[0] / 2, p += o[1]);
        }

        return r;
      };
    }, {
      "css-font/stringify": 148
    }],
    245: [function (t, e, r) {
      "use strict";

      function n(t, e) {
        e || (e = {}), ("string" == typeof t || Array.isArray(t)) && (e.family = t);
        var r = Array.isArray(e.family) ? e.family.join(", ") : e.family;
        if (!r) throw Error("`family` must be defined");
        var s = e.size || e.fontSize || e.em || 48,
            l = e.weight || e.fontWeight || "",
            c = (t = [e.style || e.fontStyle || "", l, s].join(" ") + "px " + r, e.origin || "top");
        if (n.cache[r] && s <= n.cache[r].em) return i(n.cache[r], c);
        var u = e.canvas || n.canvas,
            f = u.getContext("2d"),
            h = {
          upper: void 0 !== e.upper ? e.upper : "H",
          lower: void 0 !== e.lower ? e.lower : "x",
          descent: void 0 !== e.descent ? e.descent : "p",
          ascent: void 0 !== e.ascent ? e.ascent : "h",
          tittle: void 0 !== e.tittle ? e.tittle : "i",
          overshoot: void 0 !== e.overshoot ? e.overshoot : "O"
        },
            p = Math.ceil(1.5 * s);
        u.height = p, u.width = .5 * p, f.font = t;
        var d = {
          top: 0
        };
        f.clearRect(0, 0, p, p), f.textBaseline = "top", f.fillStyle = "black", f.fillText("H", 0, 0);
        var m = a(f.getImageData(0, 0, p, p));
        f.clearRect(0, 0, p, p), f.textBaseline = "bottom", f.fillText("H", 0, p);
        var g = a(f.getImageData(0, 0, p, p));
        d.lineHeight = d.bottom = p - g + m, f.clearRect(0, 0, p, p), f.textBaseline = "alphabetic", f.fillText("H", 0, p);
        var v = p - a(f.getImageData(0, 0, p, p)) - 1 + m;
        d.baseline = d.alphabetic = v, f.clearRect(0, 0, p, p), f.textBaseline = "middle", f.fillText("H", 0, .5 * p);
        var y = a(f.getImageData(0, 0, p, p));
        d.median = d.middle = p - y - 1 + m - .5 * p, f.clearRect(0, 0, p, p), f.textBaseline = "hanging", f.fillText("H", 0, .5 * p);
        var x = a(f.getImageData(0, 0, p, p));
        d.hanging = p - x - 1 + m - .5 * p, f.clearRect(0, 0, p, p), f.textBaseline = "ideographic", f.fillText("H", 0, p);
        var b = a(f.getImageData(0, 0, p, p));

        if (d.ideographic = p - b - 1 + m, h.upper && (f.clearRect(0, 0, p, p), f.textBaseline = "top", f.fillText(h.upper, 0, 0), d.upper = a(f.getImageData(0, 0, p, p)), d.capHeight = d.baseline - d.upper), h.lower && (f.clearRect(0, 0, p, p), f.textBaseline = "top", f.fillText(h.lower, 0, 0), d.lower = a(f.getImageData(0, 0, p, p)), d.xHeight = d.baseline - d.lower), h.tittle && (f.clearRect(0, 0, p, p), f.textBaseline = "top", f.fillText(h.tittle, 0, 0), d.tittle = a(f.getImageData(0, 0, p, p))), h.ascent && (f.clearRect(0, 0, p, p), f.textBaseline = "top", f.fillText(h.ascent, 0, 0), d.ascent = a(f.getImageData(0, 0, p, p))), h.descent && (f.clearRect(0, 0, p, p), f.textBaseline = "top", f.fillText(h.descent, 0, 0), d.descent = o(f.getImageData(0, 0, p, p))), h.overshoot) {
          f.clearRect(0, 0, p, p), f.textBaseline = "top", f.fillText(h.overshoot, 0, 0);

          var _ = o(f.getImageData(0, 0, p, p));

          d.overshoot = _ - v;
        }

        for (var w in d) {
          d[w] /= s;
        }

        return d.em = s, n.cache[r] = d, i(d, c);
      }

      function i(t, e) {
        var r = {};

        for (var n in "string" == typeof e && (e = t[e]), t) {
          "em" !== n && (r[n] = t[n] - e);
        }

        return r;
      }

      function a(t) {
        for (var e = t.height, r = t.data, n = 3; n < r.length; n += 4) {
          if (0 !== r[n]) return Math.floor(.25 * (n - 3) / e);
        }
      }

      function o(t) {
        for (var e = t.height, r = t.data, n = r.length - 1; n > 0; n -= 4) {
          if (0 !== r[n]) return Math.floor(.25 * (n - 3) / e);
        }
      }

      e.exports = n, n.canvas = document.createElement("canvas"), n.cache = {};
    }, {}],
    246: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        return new s(t || m, null);
      };

      function n(t, e, r, n, i, a) {
        this._color = t, this.key = e, this.value = r, this.left = n, this.right = i, this._count = a;
      }

      function i(t) {
        return new n(t._color, t.key, t.value, t.left, t.right, t._count);
      }

      function a(t, e) {
        return new n(t, e.key, e.value, e.left, e.right, e._count);
      }

      function o(t) {
        t._count = 1 + (t.left ? t.left._count : 0) + (t.right ? t.right._count : 0);
      }

      function s(t, e) {
        this._compare = t, this.root = e;
      }

      var l = s.prototype;

      function c(t, e) {
        var r;
        if (e.left && (r = c(t, e.left))) return r;
        return (r = t(e.key, e.value)) || (e.right ? c(t, e.right) : void 0);
      }

      function u(t, e, r, n) {
        if (e(t, n.key) <= 0) {
          var i;
          if (n.left) if (i = u(t, e, r, n.left)) return i;
          if (i = r(n.key, n.value)) return i;
        }

        if (n.right) return u(t, e, r, n.right);
      }

      function f(t, e, r, n, i) {
        var a,
            o = r(t, i.key),
            s = r(e, i.key);

        if (o <= 0) {
          if (i.left && (a = f(t, e, r, n, i.left))) return a;
          if (s > 0 && (a = n(i.key, i.value))) return a;
        }

        if (s > 0 && i.right) return f(t, e, r, n, i.right);
      }

      function h(t, e) {
        this.tree = t, this._stack = e;
      }

      Object.defineProperty(l, "keys", {
        get: function get() {
          var t = [];
          return this.forEach(function (e, r) {
            t.push(e);
          }), t;
        }
      }), Object.defineProperty(l, "values", {
        get: function get() {
          var t = [];
          return this.forEach(function (e, r) {
            t.push(r);
          }), t;
        }
      }), Object.defineProperty(l, "length", {
        get: function get() {
          return this.root ? this.root._count : 0;
        }
      }), l.insert = function (t, e) {
        for (var r = this._compare, i = this.root, l = [], c = []; i;) {
          var u = r(t, i.key);
          l.push(i), c.push(u), i = u <= 0 ? i.left : i.right;
        }

        l.push(new n(0, t, e, null, null, 1));

        for (var f = l.length - 2; f >= 0; --f) {
          i = l[f];
          c[f] <= 0 ? l[f] = new n(i._color, i.key, i.value, l[f + 1], i.right, i._count + 1) : l[f] = new n(i._color, i.key, i.value, i.left, l[f + 1], i._count + 1);
        }

        for (f = l.length - 1; f > 1; --f) {
          var h = l[f - 1];
          i = l[f];
          if (1 === h._color || 1 === i._color) break;
          var p = l[f - 2];
          if (p.left === h) {
            if (h.left === i) {
              if (!(d = p.right) || 0 !== d._color) {
                if (p._color = 0, p.left = h.right, h._color = 1, h.right = p, l[f - 2] = h, l[f - 1] = i, o(p), o(h), f >= 3) (m = l[f - 3]).left === p ? m.left = h : m.right = h;
                break;
              }

              h._color = 1, p.right = a(1, d), p._color = 0, f -= 1;
            } else {
              if (!(d = p.right) || 0 !== d._color) {
                if (h.right = i.left, p._color = 0, p.left = i.right, i._color = 1, i.left = h, i.right = p, l[f - 2] = i, l[f - 1] = h, o(p), o(h), o(i), f >= 3) (m = l[f - 3]).left === p ? m.left = i : m.right = i;
                break;
              }

              h._color = 1, p.right = a(1, d), p._color = 0, f -= 1;
            }
          } else if (h.right === i) {
            if (!(d = p.left) || 0 !== d._color) {
              if (p._color = 0, p.right = h.left, h._color = 1, h.left = p, l[f - 2] = h, l[f - 1] = i, o(p), o(h), f >= 3) (m = l[f - 3]).right === p ? m.right = h : m.left = h;
              break;
            }

            h._color = 1, p.left = a(1, d), p._color = 0, f -= 1;
          } else {
            var d;

            if (!(d = p.left) || 0 !== d._color) {
              var m;
              if (h.left = i.right, p._color = 0, p.right = i.left, i._color = 1, i.right = h, i.left = p, l[f - 2] = i, l[f - 1] = h, o(p), o(h), o(i), f >= 3) (m = l[f - 3]).right === p ? m.right = i : m.left = i;
              break;
            }

            h._color = 1, p.left = a(1, d), p._color = 0, f -= 1;
          }
        }

        return l[0]._color = 1, new s(r, l[0]);
      }, l.forEach = function (t, e, r) {
        if (this.root) switch (arguments.length) {
          case 1:
            return c(t, this.root);

          case 2:
            return u(e, this._compare, t, this.root);

          case 3:
            if (this._compare(e, r) >= 0) return;
            return f(e, r, this._compare, t, this.root);
        }
      }, Object.defineProperty(l, "begin", {
        get: function get() {
          for (var t = [], e = this.root; e;) {
            t.push(e), e = e.left;
          }

          return new h(this, t);
        }
      }), Object.defineProperty(l, "end", {
        get: function get() {
          for (var t = [], e = this.root; e;) {
            t.push(e), e = e.right;
          }

          return new h(this, t);
        }
      }), l.at = function (t) {
        if (t < 0) return new h(this, []);

        for (var e = this.root, r = [];;) {
          if (r.push(e), e.left) {
            if (t < e.left._count) {
              e = e.left;
              continue;
            }

            t -= e.left._count;
          }

          if (!t) return new h(this, r);
          if (t -= 1, !e.right) break;
          if (t >= e.right._count) break;
          e = e.right;
        }

        return new h(this, []);
      }, l.ge = function (t) {
        for (var e = this._compare, r = this.root, n = [], i = 0; r;) {
          var a = e(t, r.key);
          n.push(r), a <= 0 && (i = n.length), r = a <= 0 ? r.left : r.right;
        }

        return n.length = i, new h(this, n);
      }, l.gt = function (t) {
        for (var e = this._compare, r = this.root, n = [], i = 0; r;) {
          var a = e(t, r.key);
          n.push(r), a < 0 && (i = n.length), r = a < 0 ? r.left : r.right;
        }

        return n.length = i, new h(this, n);
      }, l.lt = function (t) {
        for (var e = this._compare, r = this.root, n = [], i = 0; r;) {
          var a = e(t, r.key);
          n.push(r), a > 0 && (i = n.length), r = a <= 0 ? r.left : r.right;
        }

        return n.length = i, new h(this, n);
      }, l.le = function (t) {
        for (var e = this._compare, r = this.root, n = [], i = 0; r;) {
          var a = e(t, r.key);
          n.push(r), a >= 0 && (i = n.length), r = a < 0 ? r.left : r.right;
        }

        return n.length = i, new h(this, n);
      }, l.find = function (t) {
        for (var e = this._compare, r = this.root, n = []; r;) {
          var i = e(t, r.key);
          if (n.push(r), 0 === i) return new h(this, n);
          r = i <= 0 ? r.left : r.right;
        }

        return new h(this, []);
      }, l.remove = function (t) {
        var e = this.find(t);
        return e ? e.remove() : this;
      }, l.get = function (t) {
        for (var e = this._compare, r = this.root; r;) {
          var n = e(t, r.key);
          if (0 === n) return r.value;
          r = n <= 0 ? r.left : r.right;
        }
      };
      var p = h.prototype;

      function d(t, e) {
        t.key = e.key, t.value = e.value, t.left = e.left, t.right = e.right, t._color = e._color, t._count = e._count;
      }

      function m(t, e) {
        return t < e ? -1 : t > e ? 1 : 0;
      }

      Object.defineProperty(p, "valid", {
        get: function get() {
          return this._stack.length > 0;
        }
      }), Object.defineProperty(p, "node", {
        get: function get() {
          return this._stack.length > 0 ? this._stack[this._stack.length - 1] : null;
        },
        enumerable: !0
      }), p.clone = function () {
        return new h(this.tree, this._stack.slice());
      }, p.remove = function () {
        var t = this._stack;
        if (0 === t.length) return this.tree;
        var e = new Array(t.length),
            r = t[t.length - 1];
        e[e.length - 1] = new n(r._color, r.key, r.value, r.left, r.right, r._count);

        for (var l = t.length - 2; l >= 0; --l) {
          (r = t[l]).left === t[l + 1] ? e[l] = new n(r._color, r.key, r.value, e[l + 1], r.right, r._count) : e[l] = new n(r._color, r.key, r.value, r.left, e[l + 1], r._count);
        }

        if ((r = e[e.length - 1]).left && r.right) {
          var c = e.length;

          for (r = r.left; r.right;) {
            e.push(r), r = r.right;
          }

          var u = e[c - 1];
          e.push(new n(r._color, u.key, u.value, r.left, r.right, r._count)), e[c - 1].key = r.key, e[c - 1].value = r.value;

          for (l = e.length - 2; l >= c; --l) {
            r = e[l], e[l] = new n(r._color, r.key, r.value, r.left, e[l + 1], r._count);
          }

          e[c - 1].left = e[c];
        }

        if (0 === (r = e[e.length - 1])._color) {
          var f = e[e.length - 2];
          f.left === r ? f.left = null : f.right === r && (f.right = null), e.pop();

          for (l = 0; l < e.length; ++l) {
            e[l]._count--;
          }

          return new s(this.tree._compare, e[0]);
        }

        if (r.left || r.right) {
          r.left ? d(r, r.left) : r.right && d(r, r.right), r._color = 1;

          for (l = 0; l < e.length - 1; ++l) {
            e[l]._count--;
          }

          return new s(this.tree._compare, e[0]);
        }

        if (1 === e.length) return new s(this.tree._compare, null);

        for (l = 0; l < e.length; ++l) {
          e[l]._count--;
        }

        var h = e[e.length - 2];
        return function (t) {
          for (var e, r, n, s, l = t.length - 1; l >= 0; --l) {
            if (e = t[l], 0 === l) return void (e._color = 1);

            if ((r = t[l - 1]).left === e) {
              if ((n = r.right).right && 0 === n.right._color) {
                if (s = (n = r.right = i(n)).right = i(n.right), r.right = n.left, n.left = r, n.right = s, n._color = r._color, e._color = 1, r._color = 1, s._color = 1, o(r), o(n), l > 1) (c = t[l - 2]).left === r ? c.left = n : c.right = n;
                return void (t[l - 1] = n);
              }

              if (n.left && 0 === n.left._color) {
                if (s = (n = r.right = i(n)).left = i(n.left), r.right = s.left, n.left = s.right, s.left = r, s.right = n, s._color = r._color, r._color = 1, n._color = 1, e._color = 1, o(r), o(n), o(s), l > 1) (c = t[l - 2]).left === r ? c.left = s : c.right = s;
                return void (t[l - 1] = s);
              }

              if (1 === n._color) {
                if (0 === r._color) return r._color = 1, void (r.right = a(0, n));
                r.right = a(0, n);
                continue;
              }

              n = i(n), r.right = n.left, n.left = r, n._color = r._color, r._color = 0, o(r), o(n), l > 1 && ((c = t[l - 2]).left === r ? c.left = n : c.right = n), t[l - 1] = n, t[l] = r, l + 1 < t.length ? t[l + 1] = e : t.push(e), l += 2;
            } else {
              if ((n = r.left).left && 0 === n.left._color) {
                if (s = (n = r.left = i(n)).left = i(n.left), r.left = n.right, n.right = r, n.left = s, n._color = r._color, e._color = 1, r._color = 1, s._color = 1, o(r), o(n), l > 1) (c = t[l - 2]).right === r ? c.right = n : c.left = n;
                return void (t[l - 1] = n);
              }

              if (n.right && 0 === n.right._color) {
                if (s = (n = r.left = i(n)).right = i(n.right), r.left = s.right, n.right = s.left, s.right = r, s.left = n, s._color = r._color, r._color = 1, n._color = 1, e._color = 1, o(r), o(n), o(s), l > 1) (c = t[l - 2]).right === r ? c.right = s : c.left = s;
                return void (t[l - 1] = s);
              }

              if (1 === n._color) {
                if (0 === r._color) return r._color = 1, void (r.left = a(0, n));
                r.left = a(0, n);
                continue;
              }

              var c;
              n = i(n), r.left = n.right, n.right = r, n._color = r._color, r._color = 0, o(r), o(n), l > 1 && ((c = t[l - 2]).right === r ? c.right = n : c.left = n), t[l - 1] = n, t[l] = r, l + 1 < t.length ? t[l + 1] = e : t.push(e), l += 2;
            }
          }
        }(e), h.left === r ? h.left = null : h.right = null, new s(this.tree._compare, e[0]);
      }, Object.defineProperty(p, "key", {
        get: function get() {
          if (this._stack.length > 0) return this._stack[this._stack.length - 1].key;
        },
        enumerable: !0
      }), Object.defineProperty(p, "value", {
        get: function get() {
          if (this._stack.length > 0) return this._stack[this._stack.length - 1].value;
        },
        enumerable: !0
      }), Object.defineProperty(p, "index", {
        get: function get() {
          var t = 0,
              e = this._stack;

          if (0 === e.length) {
            var r = this.tree.root;
            return r ? r._count : 0;
          }

          e[e.length - 1].left && (t = e[e.length - 1].left._count);

          for (var n = e.length - 2; n >= 0; --n) {
            e[n + 1] === e[n].right && (++t, e[n].left && (t += e[n].left._count));
          }

          return t;
        },
        enumerable: !0
      }), p.next = function () {
        var t = this._stack;

        if (0 !== t.length) {
          var e = t[t.length - 1];
          if (e.right) for (e = e.right; e;) {
            t.push(e), e = e.left;
          } else for (t.pop(); t.length > 0 && t[t.length - 1].right === e;) {
            e = t[t.length - 1], t.pop();
          }
        }
      }, Object.defineProperty(p, "hasNext", {
        get: function get() {
          var t = this._stack;
          if (0 === t.length) return !1;
          if (t[t.length - 1].right) return !0;

          for (var e = t.length - 1; e > 0; --e) {
            if (t[e - 1].left === t[e]) return !0;
          }

          return !1;
        }
      }), p.update = function (t) {
        var e = this._stack;
        if (0 === e.length) throw new Error("Can't update empty node!");
        var r = new Array(e.length),
            i = e[e.length - 1];
        r[r.length - 1] = new n(i._color, i.key, t, i.left, i.right, i._count);

        for (var a = e.length - 2; a >= 0; --a) {
          (i = e[a]).left === e[a + 1] ? r[a] = new n(i._color, i.key, i.value, r[a + 1], i.right, i._count) : r[a] = new n(i._color, i.key, i.value, i.left, r[a + 1], i._count);
        }

        return new s(this.tree._compare, r[0]);
      }, p.prev = function () {
        var t = this._stack;

        if (0 !== t.length) {
          var e = t[t.length - 1];
          if (e.left) for (e = e.left; e;) {
            t.push(e), e = e.right;
          } else for (t.pop(); t.length > 0 && t[t.length - 1].left === e;) {
            e = t[t.length - 1], t.pop();
          }
        }
      }, Object.defineProperty(p, "hasPrev", {
        get: function get() {
          var t = this._stack;
          if (0 === t.length) return !1;
          if (t[t.length - 1].left) return !0;

          for (var e = t.length - 1; e > 0; --e) {
            if (t[e - 1].right === t[e]) return !0;
          }

          return !1;
        }
      });
    }, {}],
    247: [function (t, e, r) {
      var n = [.9999999999998099, 676.5203681218851, -1259.1392167224028, 771.3234287776531, -176.6150291621406, 12.507343278686905, -.13857109526572012, 9984369578019572e-21, 1.5056327351493116e-7],
          i = [.9999999999999971, 57.15623566586292, -59.59796035547549, 14.136097974741746, -.4919138160976202, 3399464998481189e-20, 4652362892704858e-20, -9837447530487956e-20, .0001580887032249125, -.00021026444172410488, .00021743961811521265, -.0001643181065367639, 8441822398385275e-20, -26190838401581408e-21, 36899182659531625e-22];

      function a(t) {
        if (t < 0) return Number("0/0");

        for (var e = i[0], r = i.length - 1; r > 0; --r) {
          e += i[r] / (t + r);
        }

        var n = t + 607 / 128 + .5;
        return .5 * Math.log(2 * Math.PI) + (t + .5) * Math.log(n) - n + Math.log(e) - Math.log(t);
      }

      e.exports = function t(e) {
        if (e < .5) return Math.PI / (Math.sin(Math.PI * e) * t(1 - e));
        if (e > 100) return Math.exp(a(e));
        e -= 1;

        for (var r = n[0], i = 1; i < 9; i++) {
          r += n[i] / (e + i);
        }

        var o = e + 7 + .5;
        return Math.sqrt(2 * Math.PI) * Math.pow(o, e + .5) * Math.exp(-o) * r;
      }, e.exports.log = a;
    }, {}],
    248: [function (t, e, r) {
      e.exports = function (t, e) {
        if ("string" != typeof t) throw new TypeError("must specify type string");
        if (e = e || {}, "undefined" == typeof document && !e.canvas) return null;
        var r = e.canvas || document.createElement("canvas");
        "number" == typeof e.width && (r.width = e.width);
        "number" == typeof e.height && (r.height = e.height);
        var n,
            i = e;

        try {
          var a = [t];
          0 === t.indexOf("webgl") && a.push("experimental-" + t);

          for (var o = 0; o < a.length; o++) {
            if (n = r.getContext(a[o], i)) return n;
          }
        } catch (t) {
          n = null;
        }

        return n || null;
      };
    }, {}],
    249: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        var r = new u(t);
        return r.update(e), r;
      };

      var n = t("./lib/text.js"),
          i = t("./lib/lines.js"),
          a = t("./lib/background.js"),
          o = t("./lib/cube.js"),
          s = t("./lib/ticks.js"),
          l = new Float32Array([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);

      function c(t, e) {
        return t[0] = e[0], t[1] = e[1], t[2] = e[2], t;
      }

      function u(t) {
        this.gl = t, this.pixelRatio = 1, this.bounds = [[-10, -10, -10], [10, 10, 10]], this.ticks = [[], [], []], this.autoTicks = !0, this.tickSpacing = [1, 1, 1], this.tickEnable = [!0, !0, !0], this.tickFont = ["sans-serif", "sans-serif", "sans-serif"], this.tickSize = [12, 12, 12], this.tickAngle = [0, 0, 0], this.tickAlign = ["auto", "auto", "auto"], this.tickColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.tickPad = [10, 10, 10], this.lastCubeProps = {
          cubeEdges: [0, 0, 0],
          axis: [0, 0, 0]
        }, this.labels = ["x", "y", "z"], this.labelEnable = [!0, !0, !0], this.labelFont = "sans-serif", this.labelSize = [20, 20, 20], this.labelAngle = [0, 0, 0], this.labelAlign = ["auto", "auto", "auto"], this.labelColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.labelPad = [10, 10, 10], this.lineEnable = [!0, !0, !0], this.lineMirror = [!1, !1, !1], this.lineWidth = [1, 1, 1], this.lineColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.lineTickEnable = [!0, !0, !0], this.lineTickMirror = [!1, !1, !1], this.lineTickLength = [0, 0, 0], this.lineTickWidth = [1, 1, 1], this.lineTickColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.gridEnable = [!0, !0, !0], this.gridWidth = [1, 1, 1], this.gridColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.zeroEnable = [!0, !0, !0], this.zeroLineColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.zeroLineWidth = [2, 2, 2], this.backgroundEnable = [!1, !1, !1], this.backgroundColor = [[.8, .8, .8, .5], [.8, .8, .8, .5], [.8, .8, .8, .5]], this._firstInit = !0, this._text = null, this._lines = null, this._background = a(t);
      }

      var f = u.prototype;

      function h() {
        this.primalOffset = [0, 0, 0], this.primalMinor = [0, 0, 0], this.mirrorOffset = [0, 0, 0], this.mirrorMinor = [0, 0, 0];
      }

      f.update = function (t) {
        function e(e, r, n) {
          if (n in t) {
            var i,
                a = t[n],
                o = this[n];
            (e ? Array.isArray(a) && Array.isArray(a[0]) : Array.isArray(a)) ? this[n] = i = [r(a[0]), r(a[1]), r(a[2])] : this[n] = i = [r(a), r(a), r(a)];

            for (var s = 0; s < 3; ++s) {
              if (i[s] !== o[s]) return !0;
            }
          }

          return !1;
        }

        t = t || {};
        var r,
            a = e.bind(this, !1, Number),
            o = e.bind(this, !1, Boolean),
            l = e.bind(this, !1, String),
            c = e.bind(this, !0, function (t) {
          if (Array.isArray(t)) {
            if (3 === t.length) return [+t[0], +t[1], +t[2], 1];
            if (4 === t.length) return [+t[0], +t[1], +t[2], +t[3]];
          }

          return [0, 0, 0, 1];
        }),
            u = !1,
            f = !1;
        if ("bounds" in t) for (var h = t.bounds, p = 0; p < 2; ++p) {
          for (var d = 0; d < 3; ++d) {
            h[p][d] !== this.bounds[p][d] && (f = !0), this.bounds[p][d] = h[p][d];
          }
        }

        if ("ticks" in t) {
          r = t.ticks, u = !0, this.autoTicks = !1;

          for (p = 0; p < 3; ++p) {
            this.tickSpacing[p] = 0;
          }
        } else a("tickSpacing") && (this.autoTicks = !0, f = !0);

        if (this._firstInit && ("ticks" in t || "tickSpacing" in t || (this.autoTicks = !0), f = !0, u = !0, this._firstInit = !1), f && this.autoTicks && (r = s.create(this.bounds, this.tickSpacing), u = !0), u) {
          for (p = 0; p < 3; ++p) {
            r[p].sort(function (t, e) {
              return t.x - e.x;
            });
          }

          s.equal(r, this.ticks) ? u = !1 : this.ticks = r;
        }

        o("tickEnable"), l("tickFont") && (u = !0), a("tickSize"), a("tickAngle"), a("tickPad"), c("tickColor");
        var m = l("labels");
        l("labelFont") && (m = !0), o("labelEnable"), a("labelSize"), a("labelPad"), c("labelColor"), o("lineEnable"), o("lineMirror"), a("lineWidth"), c("lineColor"), o("lineTickEnable"), o("lineTickMirror"), a("lineTickLength"), a("lineTickWidth"), c("lineTickColor"), o("gridEnable"), a("gridWidth"), c("gridColor"), o("zeroEnable"), c("zeroLineColor"), a("zeroLineWidth"), o("backgroundEnable"), c("backgroundColor"), this._text ? this._text && (m || u) && this._text.update(this.bounds, this.labels, this.labelFont, this.ticks, this.tickFont) : this._text = n(this.gl, this.bounds, this.labels, this.labelFont, this.ticks, this.tickFont), this._lines && u && (this._lines.dispose(), this._lines = null), this._lines || (this._lines = i(this.gl, this.bounds, this.ticks));
      };

      var p = [new h(), new h(), new h()];

      function d(t, e, r, n, i) {
        for (var a = t.primalOffset, o = t.primalMinor, s = t.mirrorOffset, l = t.mirrorMinor, c = n[e], u = 0; u < 3; ++u) {
          if (e !== u) {
            var f = a,
                h = s,
                p = o,
                d = l;
            c & 1 << u && (f = s, h = a, p = l, d = o), f[u] = r[0][u], h[u] = r[1][u], i[u] > 0 ? (p[u] = -1, d[u] = 0) : (p[u] = 0, d[u] = 1);
          }
        }
      }

      var m = [0, 0, 0],
          g = {
        model: l,
        view: l,
        projection: l,
        _ortho: !1
      };
      f.isOpaque = function () {
        return !0;
      }, f.isTransparent = function () {
        return !1;
      }, f.drawTransparent = function (t) {};
      var v = [0, 0, 0],
          y = [0, 0, 0],
          x = [0, 0, 0];
      f.draw = function (t) {
        t = t || g;

        for (var e = this.gl, r = t.model || l, n = t.view || l, i = t.projection || l, a = this.bounds, s = t._ortho || !1, u = o(r, n, i, a, s), f = u.cubeEdges, h = u.axis, b = n[12], _ = n[13], w = n[14], T = n[15], k = (s ? 2 : 1) * this.pixelRatio * (i[3] * b + i[7] * _ + i[11] * w + i[15] * T) / e.drawingBufferHeight, M = 0; M < 3; ++M) {
          this.lastCubeProps.cubeEdges[M] = f[M], this.lastCubeProps.axis[M] = h[M];
        }

        var A = p;

        for (M = 0; M < 3; ++M) {
          d(p[M], M, this.bounds, f, h);
        }

        e = this.gl;
        var S,
            E = m;

        for (M = 0; M < 3; ++M) {
          this.backgroundEnable[M] ? E[M] = h[M] : E[M] = 0;
        }

        this._background.draw(r, n, i, a, E, this.backgroundColor), this._lines.bind(r, n, i, this);

        for (M = 0; M < 3; ++M) {
          var L = [0, 0, 0];
          h[M] > 0 ? L[M] = a[1][M] : L[M] = a[0][M];

          for (var C = 0; C < 2; ++C) {
            var P = (M + 1 + C) % 3,
                I = (M + 1 + (1 ^ C)) % 3;
            this.gridEnable[P] && this._lines.drawGrid(P, I, this.bounds, L, this.gridColor[P], this.gridWidth[P] * this.pixelRatio);
          }

          for (C = 0; C < 2; ++C) {
            P = (M + 1 + C) % 3, I = (M + 1 + (1 ^ C)) % 3;
            this.zeroEnable[I] && Math.min(a[0][I], a[1][I]) <= 0 && Math.max(a[0][I], a[1][I]) >= 0 && this._lines.drawZero(P, I, this.bounds, L, this.zeroLineColor[I], this.zeroLineWidth[I] * this.pixelRatio);
          }
        }

        for (M = 0; M < 3; ++M) {
          this.lineEnable[M] && this._lines.drawAxisLine(M, this.bounds, A[M].primalOffset, this.lineColor[M], this.lineWidth[M] * this.pixelRatio), this.lineMirror[M] && this._lines.drawAxisLine(M, this.bounds, A[M].mirrorOffset, this.lineColor[M], this.lineWidth[M] * this.pixelRatio);
          var O = c(v, A[M].primalMinor),
              z = c(y, A[M].mirrorMinor),
              D = this.lineTickLength;

          for (C = 0; C < 3; ++C) {
            var R = k / r[5 * C];
            O[C] *= D[C] * R, z[C] *= D[C] * R;
          }

          this.lineTickEnable[M] && this._lines.drawAxisTicks(M, A[M].primalOffset, O, this.lineTickColor[M], this.lineTickWidth[M] * this.pixelRatio), this.lineTickMirror[M] && this._lines.drawAxisTicks(M, A[M].mirrorOffset, z, this.lineTickColor[M], this.lineTickWidth[M] * this.pixelRatio);
        }

        this._lines.unbind(), this._text.bind(r, n, i, this.pixelRatio);
        var F, B;

        function N(t) {
          (B = [0, 0, 0])[t] = 1;
        }

        function j(t, e, r) {
          var n = (t + 1) % 3,
              i = (t + 2) % 3,
              a = e[n],
              o = e[i],
              s = r[n],
              l = r[i];
          a > 0 && l > 0 || a > 0 && l < 0 || a < 0 && l > 0 || a < 0 && l < 0 ? N(n) : (o > 0 && s > 0 || o > 0 && s < 0 || o < 0 && s > 0 || o < 0 && s < 0) && N(i);
        }

        for (M = 0; M < 3; ++M) {
          var U = A[M].primalMinor,
              V = A[M].mirrorMinor,
              q = c(x, A[M].primalOffset);

          for (C = 0; C < 3; ++C) {
            this.lineTickEnable[M] && (q[C] += k * U[C] * Math.max(this.lineTickLength[C], 0) / r[5 * C]);
          }

          var H = [0, 0, 0];

          if (H[M] = 1, this.tickEnable[M]) {
            -3600 === this.tickAngle[M] ? (this.tickAngle[M] = 0, this.tickAlign[M] = "auto") : this.tickAlign[M] = -1, F = 1, "auto" === (S = [this.tickAlign[M], .5, F])[0] ? S[0] = 0 : S[0] = parseInt("" + S[0]), B = [0, 0, 0], j(M, U, V);

            for (C = 0; C < 3; ++C) {
              q[C] += k * U[C] * this.tickPad[C] / r[5 * C];
            }

            this._text.drawTicks(M, this.tickSize[M], this.tickAngle[M], q, this.tickColor[M], H, B, S);
          }

          if (this.labelEnable[M]) {
            F = 0, B = [0, 0, 0], this.labels[M].length > 4 && (N(M), F = 1), "auto" === (S = [this.labelAlign[M], .5, F])[0] ? S[0] = 0 : S[0] = parseInt("" + S[0]);

            for (C = 0; C < 3; ++C) {
              q[C] += k * U[C] * this.labelPad[C] / r[5 * C];
            }

            q[M] += .5 * (a[0][M] + a[1][M]), this._text.drawLabel(M, this.labelSize[M], this.labelAngle[M], q, this.labelColor[M], [0, 0, 0], B, S);
          }
        }

        this._text.unbind();
      }, f.dispose = function () {
        this._text.dispose(), this._lines.dispose(), this._background.dispose(), this._lines = null, this._text = null, this._background = null, this.gl = null;
      };
    }, {
      "./lib/background.js": 250,
      "./lib/cube.js": 251,
      "./lib/lines.js": 252,
      "./lib/text.js": 254,
      "./lib/ticks.js": 255
    }],
    250: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        for (var e = [], r = [], s = 0, l = 0; l < 3; ++l) {
          for (var c = (l + 1) % 3, u = (l + 2) % 3, f = [0, 0, 0], h = [0, 0, 0], p = -1; p <= 1; p += 2) {
            r.push(s, s + 2, s + 1, s + 1, s + 2, s + 3), f[l] = p, h[l] = p;

            for (var d = -1; d <= 1; d += 2) {
              f[c] = d;

              for (var m = -1; m <= 1; m += 2) {
                f[u] = m, e.push(f[0], f[1], f[2], h[0], h[1], h[2]), s += 1;
              }
            }

            var g = c;
            c = u, u = g;
          }
        }

        var v = n(t, new Float32Array(e)),
            y = n(t, new Uint16Array(r), t.ELEMENT_ARRAY_BUFFER),
            x = i(t, [{
          buffer: v,
          type: t.FLOAT,
          size: 3,
          offset: 0,
          stride: 24
        }, {
          buffer: v,
          type: t.FLOAT,
          size: 3,
          offset: 12,
          stride: 24
        }], y),
            b = a(t);
        return b.attributes.position.location = 0, b.attributes.normal.location = 1, new o(t, v, x, b);
      };

      var n = t("gl-buffer"),
          i = t("gl-vao"),
          a = t("./shaders").bg;

      function o(t, e, r, n) {
        this.gl = t, this.buffer = e, this.vao = r, this.shader = n;
      }

      var s = o.prototype;
      s.draw = function (t, e, r, n, i, a) {
        for (var o = !1, s = 0; s < 3; ++s) {
          o = o || i[s];
        }

        if (o) {
          var l = this.gl;
          l.enable(l.POLYGON_OFFSET_FILL), l.polygonOffset(1, 2), this.shader.bind(), this.shader.uniforms = {
            model: t,
            view: e,
            projection: r,
            bounds: n,
            enable: i,
            colors: a
          }, this.vao.bind(), this.vao.draw(this.gl.TRIANGLES, 36), this.vao.unbind(), l.disable(l.POLYGON_OFFSET_FILL);
        }
      }, s.dispose = function () {
        this.vao.dispose(), this.buffer.dispose(), this.shader.dispose();
      };
    }, {
      "./shaders": 253,
      "gl-buffer": 258,
      "gl-vao": 352
    }],
    251: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, a, p) {
        i(s, e, t), i(s, r, s);

        for (var y = 0, x = 0; x < 2; ++x) {
          u[2] = a[x][2];

          for (var b = 0; b < 2; ++b) {
            u[1] = a[b][1];

            for (var _ = 0; _ < 2; ++_) {
              u[0] = a[_][0], h(l[y], u, s), y += 1;
            }
          }
        }

        var w = -1;

        for (x = 0; x < 8; ++x) {
          for (var T = l[x][3], k = 0; k < 3; ++k) {
            c[x][k] = l[x][k] / T;
          }

          p && (c[x][2] *= -1), T < 0 && (w < 0 || c[x][2] < c[w][2]) && (w = x);
        }

        if (w < 0) {
          w = 0;

          for (var M = 0; M < 3; ++M) {
            for (var A = (M + 2) % 3, S = (M + 1) % 3, E = -1, L = -1, C = 0; C < 2; ++C) {
              var P = (O = C << M) + (C << A) + (1 - C << S),
                  I = O + (1 - C << A) + (C << S);
              o(c[O], c[P], c[I], f) < 0 || (C ? E = 1 : L = 1);
            }

            if (E < 0 || L < 0) L > E && (w |= 1 << M);else {
              for (C = 0; C < 2; ++C) {
                P = (O = C << M) + (C << A) + (1 - C << S), I = O + (1 - C << A) + (C << S);
                var O,
                    z = d([l[O], l[P], l[I], l[O + (1 << A) + (1 << S)]]);
                C ? E = z : L = z;
              }

              L > E && (w |= 1 << M);
            }
          }
        }

        var D = 7 ^ w,
            R = -1;

        for (x = 0; x < 8; ++x) {
          x !== w && x !== D && (R < 0 || c[R][1] > c[x][1]) && (R = x);
        }

        var F = -1;

        for (x = 0; x < 3; ++x) {
          if ((N = R ^ 1 << x) !== w && N !== D) F < 0 && (F = N), (S = c[N])[0] < c[F][0] && (F = N);
        }

        var B = -1;

        for (x = 0; x < 3; ++x) {
          var N;
          if ((N = R ^ 1 << x) !== w && N !== D && N !== F) B < 0 && (B = N), (S = c[N])[0] > c[B][0] && (B = N);
        }

        var j = m;
        j[0] = j[1] = j[2] = 0, j[n.log2(F ^ R)] = R & F, j[n.log2(R ^ B)] = R & B;
        var U = 7 ^ B;
        U === w || U === D ? (U = 7 ^ F, j[n.log2(B ^ U)] = U & B) : j[n.log2(F ^ U)] = U & F;
        var V = g,
            q = w;

        for (M = 0; M < 3; ++M) {
          V[M] = q & 1 << M ? -1 : 1;
        }

        return v;
      };

      var n = t("bit-twiddle"),
          i = t("gl-mat4/multiply"),
          a = t("split-polygon"),
          o = t("robust-orientation"),
          s = new Array(16),
          l = new Array(8),
          c = new Array(8),
          u = new Array(3),
          f = [0, 0, 0];

      function h(t, e, r) {
        for (var n = 0; n < 4; ++n) {
          t[n] = r[12 + n];

          for (var i = 0; i < 3; ++i) {
            t[n] += e[i] * r[4 * i + n];
          }
        }
      }

      !function () {
        for (var t = 0; t < 8; ++t) {
          l[t] = [1, 1, 1, 1], c[t] = [1, 1, 1];
        }
      }();
      var p = [[0, 0, 1, 0, 0], [0, 0, -1, 1, 0], [0, -1, 0, 1, 0], [0, 1, 0, 1, 0], [-1, 0, 0, 1, 0], [1, 0, 0, 1, 0]];

      function d(t) {
        for (var e = 0; e < p.length; ++e) {
          if ((t = a.positive(t, p[e])).length < 3) return 0;
        }

        var r = t[0],
            n = r[0] / r[3],
            i = r[1] / r[3],
            o = 0;

        for (e = 1; e + 1 < t.length; ++e) {
          var s = t[e],
              l = t[e + 1],
              c = s[0] / s[3] - n,
              u = s[1] / s[3] - i,
              f = l[0] / l[3] - n,
              h = l[1] / l[3] - i;
          o += Math.abs(c * h - u * f);
        }

        return o;
      }

      var m = [1, 1, 1],
          g = [0, 0, 0],
          v = {
        cubeEdges: m,
        axis: g
      };
    }, {
      "bit-twiddle": 99,
      "gl-mat4/multiply": 292,
      "robust-orientation": 540,
      "split-polygon": 559
    }],
    252: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r) {
        var o = [],
            s = [0, 0, 0],
            l = [0, 0, 0],
            c = [0, 0, 0],
            u = [0, 0, 0];
        o.push(0, 0, 1, 0, 1, 1, 0, 0, -1, 0, 0, -1, 0, 1, 1, 0, 1, -1);

        for (var f = 0; f < 3; ++f) {
          for (var h = o.length / 3 | 0, d = 0; d < r[f].length; ++d) {
            var m = +r[f][d].x;
            o.push(m, 0, 1, m, 1, 1, m, 0, -1, m, 0, -1, m, 1, 1, m, 1, -1);
          }

          var g = o.length / 3 | 0;
          s[f] = h, l[f] = g - h;
          h = o.length / 3 | 0;

          for (var v = 0; v < r[f].length; ++v) {
            m = +r[f][v].x;
            o.push(m, 0, 1, m, 1, 1, m, 0, -1, m, 0, -1, m, 1, 1, m, 1, -1);
          }

          g = o.length / 3 | 0;
          c[f] = h, u[f] = g - h;
        }

        var y = n(t, new Float32Array(o)),
            x = i(t, [{
          buffer: y,
          type: t.FLOAT,
          size: 3,
          stride: 0,
          offset: 0
        }]),
            b = a(t);
        return b.attributes.position.location = 0, new p(t, y, x, b, l, s, u, c);
      };

      var n = t("gl-buffer"),
          i = t("gl-vao"),
          a = t("./shaders").line,
          o = [0, 0, 0],
          s = [0, 0, 0],
          l = [0, 0, 0],
          c = [0, 0, 0],
          u = [1, 1];

      function f(t) {
        return t[0] = t[1] = t[2] = 0, t;
      }

      function h(t, e) {
        return t[0] = e[0], t[1] = e[1], t[2] = e[2], t;
      }

      function p(t, e, r, n, i, a, o, s) {
        this.gl = t, this.vertBuffer = e, this.vao = r, this.shader = n, this.tickCount = i, this.tickOffset = a, this.gridCount = o, this.gridOffset = s;
      }

      var d = p.prototype;
      d.bind = function (t, e, r) {
        this.shader.bind(), this.shader.uniforms.model = t, this.shader.uniforms.view = e, this.shader.uniforms.projection = r, u[0] = this.gl.drawingBufferWidth, u[1] = this.gl.drawingBufferHeight, this.shader.uniforms.screenShape = u, this.vao.bind();
      }, d.unbind = function () {
        this.vao.unbind();
      }, d.drawAxisLine = function (t, e, r, n, i) {
        var a = f(s);
        this.shader.uniforms.majorAxis = s, a[t] = e[1][t] - e[0][t], this.shader.uniforms.minorAxis = a;
        var o,
            u = h(c, r);
        u[t] += e[0][t], this.shader.uniforms.offset = u, this.shader.uniforms.lineWidth = i, this.shader.uniforms.color = n, (o = f(l))[(t + 2) % 3] = 1, this.shader.uniforms.screenAxis = o, this.vao.draw(this.gl.TRIANGLES, 6), (o = f(l))[(t + 1) % 3] = 1, this.shader.uniforms.screenAxis = o, this.vao.draw(this.gl.TRIANGLES, 6);
      }, d.drawAxisTicks = function (t, e, r, n, i) {
        if (this.tickCount[t]) {
          var a = f(o);
          a[t] = 1, this.shader.uniforms.majorAxis = a, this.shader.uniforms.offset = e, this.shader.uniforms.minorAxis = r, this.shader.uniforms.color = n, this.shader.uniforms.lineWidth = i;
          var s = f(l);
          s[t] = 1, this.shader.uniforms.screenAxis = s, this.vao.draw(this.gl.TRIANGLES, this.tickCount[t], this.tickOffset[t]);
        }
      }, d.drawGrid = function (t, e, r, n, i, a) {
        if (this.gridCount[t]) {
          var u = f(s);
          u[e] = r[1][e] - r[0][e], this.shader.uniforms.minorAxis = u;
          var p = h(c, n);
          p[e] += r[0][e], this.shader.uniforms.offset = p;
          var d = f(o);
          d[t] = 1, this.shader.uniforms.majorAxis = d;
          var m = f(l);
          m[t] = 1, this.shader.uniforms.screenAxis = m, this.shader.uniforms.lineWidth = a, this.shader.uniforms.color = i, this.vao.draw(this.gl.TRIANGLES, this.gridCount[t], this.gridOffset[t]);
        }
      }, d.drawZero = function (t, e, r, n, i, a) {
        var o = f(s);
        this.shader.uniforms.majorAxis = o, o[t] = r[1][t] - r[0][t], this.shader.uniforms.minorAxis = o;
        var u = h(c, n);
        u[t] += r[0][t], this.shader.uniforms.offset = u;
        var p = f(l);
        p[e] = 1, this.shader.uniforms.screenAxis = p, this.shader.uniforms.lineWidth = a, this.shader.uniforms.color = i, this.vao.draw(this.gl.TRIANGLES, 6);
      }, d.dispose = function () {
        this.vao.dispose(), this.vertBuffer.dispose(), this.shader.dispose();
      };
    }, {
      "./shaders": 253,
      "gl-buffer": 258,
      "gl-vao": 352
    }],
    253: [function (t, e, r) {
      "use strict";

      var n = t("glslify"),
          i = t("gl-shader"),
          a = n(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\nuniform vec3 offset, majorAxis, minorAxis, screenAxis;\nuniform float lineWidth;\nuniform vec2 screenShape;\n\nvec3 project(vec3 p) {\n  vec4 pp = projection * view * model * vec4(p, 1.0);\n  return pp.xyz / max(pp.w, 0.0001);\n}\n\nvoid main() {\n  vec3 major = position.x * majorAxis;\n  vec3 minor = position.y * minorAxis;\n\n  vec3 vPosition = major + minor + offset;\n  vec3 pPosition = project(vPosition);\n  vec3 offset = project(vPosition + screenAxis * position.z);\n\n  vec2 screen = normalize((offset - pPosition).xy * screenShape) / screenShape;\n\n  gl_Position = vec4(pPosition + vec3(0.5 * screen * lineWidth, 0), 1.0);\n}\n"]),
          o = n(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = color;\n}"]);

      r.line = function (t) {
        return i(t, a, o, null, [{
          name: "position",
          type: "vec3"
        }]);
      };

      var s = n(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\nuniform vec3 offset, axis, alignDir, alignOpt;\nuniform float scale, angle, pixelScale;\nuniform vec2 resolution;\n\nvec3 project(vec3 p) {\n  vec4 pp = projection * view * model * vec4(p, 1.0);\n  return pp.xyz / max(pp.w, 0.0001);\n}\n\nfloat computeViewAngle(vec3 a, vec3 b) {\n  vec3 A = project(a);\n  vec3 B = project(b);\n\n  return atan(\n    (B.y - A.y) * resolution.y,\n    (B.x - A.x) * resolution.x\n  );\n}\n\nconst float PI = 3.141592;\nconst float TWO_PI = 2.0 * PI;\nconst float HALF_PI = 0.5 * PI;\nconst float ONE_AND_HALF_PI = 1.5 * PI;\n\nint option = int(floor(alignOpt.x + 0.001));\nfloat hv_ratio =       alignOpt.y;\nbool enableAlign =    (alignOpt.z != 0.0);\n\nfloat mod_angle(float a) {\n  return mod(a, PI);\n}\n\nfloat positive_angle(float a) {\n  return mod_angle((a < 0.0) ?\n    a + TWO_PI :\n    a\n  );\n}\n\nfloat look_upwards(float a) {\n  float b = positive_angle(a);\n  return ((b > HALF_PI) && (b <= ONE_AND_HALF_PI)) ?\n    b - PI :\n    b;\n}\n\nfloat look_horizontal_or_vertical(float a, float ratio) {\n  // ratio controls the ratio between being horizontal to (vertical + horizontal)\n  // if ratio is set to 0.5 then it is 50%, 50%.\n  // when using a higher ratio e.g. 0.75 the result would\n  // likely be more horizontal than vertical.\n\n  float b = positive_angle(a);\n\n  return\n    (b < (      ratio) * HALF_PI) ? 0.0 :\n    (b < (2.0 - ratio) * HALF_PI) ? -HALF_PI :\n    (b < (2.0 + ratio) * HALF_PI) ? 0.0 :\n    (b < (4.0 - ratio) * HALF_PI) ? HALF_PI :\n                                    0.0;\n}\n\nfloat roundTo(float a, float b) {\n  return float(b * floor((a + 0.5 * b) / b));\n}\n\nfloat look_round_n_directions(float a, int n) {\n  float b = positive_angle(a);\n  float div = TWO_PI / float(n);\n  float c = roundTo(b, div);\n  return look_upwards(c);\n}\n\nfloat applyAlignOption(float rawAngle, float delta) {\n  return\n    (option >  2) ? look_round_n_directions(rawAngle + delta, option) :       // option 3-n: round to n directions\n    (option == 2) ? look_horizontal_or_vertical(rawAngle + delta, hv_ratio) : // horizontal or vertical\n    (option == 1) ? rawAngle + delta :       // use free angle, and flip to align with one direction of the axis\n    (option == 0) ? look_upwards(rawAngle) : // use free angle, and stay upwards\n    (option ==-1) ? 0.0 :                    // useful for backward compatibility, all texts remains horizontal\n                    rawAngle;                // otherwise return back raw input angle\n}\n\nbool isAxisTitle = (axis.x == 0.0) &&\n                   (axis.y == 0.0) &&\n                   (axis.z == 0.0);\n\nvoid main() {\n  //Compute world offset\n  float axisDistance = position.z;\n  vec3 dataPosition = axisDistance * axis + offset;\n\n  float beta = angle; // i.e. user defined attributes for each tick\n\n  float axisAngle;\n  float clipAngle;\n  float flip;\n\n  if (enableAlign) {\n    axisAngle = (isAxisTitle) ? HALF_PI :\n                      computeViewAngle(dataPosition, dataPosition + axis);\n    clipAngle = computeViewAngle(dataPosition, dataPosition + alignDir);\n\n    axisAngle += (sin(axisAngle) < 0.0) ? PI : 0.0;\n    clipAngle += (sin(clipAngle) < 0.0) ? PI : 0.0;\n\n    flip = (dot(vec2(cos(axisAngle), sin(axisAngle)),\n                vec2(sin(clipAngle),-cos(clipAngle))) > 0.0) ? 1.0 : 0.0;\n\n    beta += applyAlignOption(clipAngle, flip * PI);\n  }\n\n  //Compute plane offset\n  vec2 planeCoord = position.xy * pixelScale;\n\n  mat2 planeXform = scale * mat2(\n     cos(beta), sin(beta),\n    -sin(beta), cos(beta)\n  );\n\n  vec2 viewOffset = 2.0 * planeXform * planeCoord / resolution;\n\n  //Compute clip position\n  vec3 clipPosition = project(dataPosition);\n\n  //Apply text offset in clip coordinates\n  clipPosition += vec3(viewOffset, 0.0);\n\n  //Done\n  gl_Position = vec4(clipPosition, 1.0);\n}"]),
          l = n(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = color;\n}"]);

      r.text = function (t) {
        return i(t, s, l, null, [{
          name: "position",
          type: "vec3"
        }]);
      };

      var c = n(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec3 normal;\n\nuniform mat4 model, view, projection;\nuniform vec3 enable;\nuniform vec3 bounds[2];\n\nvarying vec3 colorChannel;\n\nvoid main() {\n\n  vec3 signAxis = sign(bounds[1] - bounds[0]);\n\n  vec3 realNormal = signAxis * normal;\n\n  if(dot(realNormal, enable) > 0.0) {\n    vec3 minRange = min(bounds[0], bounds[1]);\n    vec3 maxRange = max(bounds[0], bounds[1]);\n    vec3 nPosition = mix(minRange, maxRange, 0.5 * (position + 1.0));\n    gl_Position = projection * view * model * vec4(nPosition, 1.0);\n  } else {\n    gl_Position = vec4(0,0,0,0);\n  }\n\n  colorChannel = abs(realNormal);\n}"]),
          u = n(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 colors[3];\n\nvarying vec3 colorChannel;\n\nvoid main() {\n  gl_FragColor = colorChannel.x * colors[0] +\n                 colorChannel.y * colors[1] +\n                 colorChannel.z * colors[2];\n}"]);

      r.bg = function (t) {
        return i(t, c, u, null, [{
          name: "position",
          type: "vec3"
        }, {
          name: "normal",
          type: "vec3"
        }]);
      };
    }, {
      "gl-shader": 330,
      glslify: 256
    }],
    254: [function (t, e, r) {
      (function (r) {
        (function () {
          "use strict";

          e.exports = function (t, e, r, a, s, l) {
            var u = n(t),
                f = i(t, [{
              buffer: u,
              size: 3
            }]),
                h = o(t);
            h.attributes.position.location = 0;
            var p = new c(t, h, u, f);
            return p.update(e, r, a, s, l), p;
          };

          var n = t("gl-buffer"),
              i = t("gl-vao"),
              a = t("vectorize-text"),
              o = t("./shaders").text,
              s = window || r.global || {},
              l = s.__TEXT_CACHE || {};
          s.__TEXT_CACHE = {};

          function c(t, e, r, n) {
            this.gl = t, this.shader = e, this.buffer = r, this.vao = n, this.tickOffset = this.tickCount = this.labelOffset = this.labelCount = null;
          }

          var u = c.prototype,
              f = [0, 0];
          u.bind = function (t, e, r, n) {
            this.vao.bind(), this.shader.bind();
            var i = this.shader.uniforms;
            i.model = t, i.view = e, i.projection = r, i.pixelScale = n, f[0] = this.gl.drawingBufferWidth, f[1] = this.gl.drawingBufferHeight, this.shader.uniforms.resolution = f;
          }, u.unbind = function () {
            this.vao.unbind();
          }, u.update = function (t, e, r, n, i) {
            var o = [];

            function s(t, e, r, n, i, s) {
              var c = l[r];
              c || (c = l[r] = {});
              var u = c[e];
              u || (u = c[e] = function (t, e) {
                try {
                  return a(t, e);
                } catch (e) {
                  return console.warn('error vectorizing text:"' + t + '" error:', e), {
                    cells: [],
                    positions: []
                  };
                }
              }(e, {
                triangles: !0,
                font: r,
                textAlign: "center",
                textBaseline: "middle",
                lineSpacing: i,
                styletags: s
              }));

              for (var f = (n || 12) / 12, h = u.positions, p = u.cells, d = 0, m = p.length; d < m; ++d) {
                for (var g = p[d], v = 2; v >= 0; --v) {
                  var y = h[g[v]];
                  o.push(f * y[0], -f * y[1], t);
                }
              }
            }

            for (var c = [0, 0, 0], u = [0, 0, 0], f = [0, 0, 0], h = [0, 0, 0], p = {
              breaklines: !0,
              bolds: !0,
              italics: !0,
              subscripts: !0,
              superscripts: !0
            }, d = 0; d < 3; ++d) {
              f[d] = o.length / 3 | 0, s(.5 * (t[0][d] + t[1][d]), e[d], r[d], 12, 1.25, p), h[d] = (o.length / 3 | 0) - f[d], c[d] = o.length / 3 | 0;

              for (var m = 0; m < n[d].length; ++m) {
                n[d][m].text && s(n[d][m].x, n[d][m].text, n[d][m].font || i, n[d][m].fontSize || 12, 1.25, p);
              }

              u[d] = (o.length / 3 | 0) - c[d];
            }

            this.buffer.update(o), this.tickOffset = c, this.tickCount = u, this.labelOffset = f, this.labelCount = h;
          }, u.drawTicks = function (t, e, r, n, i, a, o, s) {
            this.tickCount[t] && (this.shader.uniforms.axis = a, this.shader.uniforms.color = i, this.shader.uniforms.angle = r, this.shader.uniforms.scale = e, this.shader.uniforms.offset = n, this.shader.uniforms.alignDir = o, this.shader.uniforms.alignOpt = s, this.vao.draw(this.gl.TRIANGLES, this.tickCount[t], this.tickOffset[t]));
          }, u.drawLabel = function (t, e, r, n, i, a, o, s) {
            this.labelCount[t] && (this.shader.uniforms.axis = a, this.shader.uniforms.color = i, this.shader.uniforms.angle = r, this.shader.uniforms.scale = e, this.shader.uniforms.offset = n, this.shader.uniforms.alignDir = o, this.shader.uniforms.alignOpt = s, this.vao.draw(this.gl.TRIANGLES, this.labelCount[t], this.labelOffset[t]));
          }, u.dispose = function () {
            this.shader.dispose(), this.vao.dispose(), this.buffer.dispose();
          };
        }).call(this);
      }).call(this, t("_process"));
    }, {
      "./shaders": 253,
      _process: 520,
      "gl-buffer": 258,
      "gl-vao": 352,
      "vectorize-text": 615
    }],
    255: [function (t, e, r) {
      "use strict";

      function n(t, e) {
        var r = t + "",
            n = r.indexOf("."),
            i = 0;
        n >= 0 && (i = r.length - n - 1);
        var a = Math.pow(10, i),
            o = Math.round(t * e * a),
            s = o + "";
        if (s.indexOf("e") >= 0) return s;
        var l = o / a,
            c = o % a;
        o < 0 ? (l = 0 | -Math.ceil(l), c = 0 | -c) : (l = 0 | Math.floor(l), c |= 0);
        var u = "" + l;

        if (o < 0 && (u = "-" + u), i) {
          for (var f = "" + c; f.length < i;) {
            f = "0" + f;
          }

          return u + "." + f;
        }

        return u;
      }

      r.create = function (t, e) {
        for (var r = [], i = 0; i < 3; ++i) {
          for (var a = [], o = (t[0][i], t[1][i], 0); o * e[i] <= t[1][i]; ++o) {
            a.push({
              x: o * e[i],
              text: n(e[i], o)
            });
          }

          for (o = -1; o * e[i] >= t[0][i]; --o) {
            a.push({
              x: o * e[i],
              text: n(e[i], o)
            });
          }

          r.push(a);
        }

        return r;
      }, r.equal = function (t, e) {
        for (var r = 0; r < 3; ++r) {
          if (t[r].length !== e[r].length) return !1;

          for (var n = 0; n < t[r].length; ++n) {
            var i = t[r][n],
                a = e[r][n];
            if (i.x !== a.x || i.text !== a.text || i.font !== a.font || i.fontColor !== a.fontColor || i.fontSize !== a.fontSize || i.dx !== a.dx || i.dy !== a.dy) return !1;
          }
        }

        return !0;
      };
    }, {}],
    256: [function (t, e, r) {
      e.exports = function (t) {
        "string" == typeof t && (t = [t]);

        for (var e = [].slice.call(arguments, 1), r = [], n = 0; n < t.length - 1; n++) {
          r.push(t[n], e[n] || "");
        }

        return r.push(t[n]), r.join("");
      };
    }, {}],
    257: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, l, f) {
        var h = e.model || c,
            p = e.view || c,
            v = e.projection || c,
            y = e._ortho || !1,
            x = t.bounds,
            b = (f = f || a(h, p, v, x, y)).axis;
        o(u, p, h), o(u, v, u);

        for (var _ = m, w = 0; w < 3; ++w) {
          _[w].lo = 1 / 0, _[w].hi = -1 / 0, _[w].pixelsPerDataUnit = 1 / 0;
        }

        var T = n(s(u, u));
        s(u, u);

        for (var k = 0; k < 3; ++k) {
          var M = (k + 1) % 3,
              A = (k + 2) % 3,
              S = g;

          t: for (w = 0; w < 2; ++w) {
            var E = [];

            if (b[k] < 0 != !!w) {
              S[k] = x[w][k];

              for (var L = 0; L < 2; ++L) {
                S[M] = x[L ^ w][M];

                for (var C = 0; C < 2; ++C) {
                  S[A] = x[C ^ L ^ w][A], E.push(S.slice());
                }
              }

              var P = y ? 5 : 4;

              for (L = P; L === P; ++L) {
                if (0 === E.length) continue t;
                E = i.positive(E, T[L]);
              }

              for (L = 0; L < E.length; ++L) {
                A = E[L];
                var I = d(g, u, A, r, l);

                for (C = 0; C < 3; ++C) {
                  _[C].lo = Math.min(_[C].lo, A[C]), _[C].hi = Math.max(_[C].hi, A[C]), C !== k && (_[C].pixelsPerDataUnit = Math.min(_[C].pixelsPerDataUnit, Math.abs(I[C])));
                }
              }
            }
          }
        }

        return _;
      };

      var n = t("extract-frustum-planes"),
          i = t("split-polygon"),
          a = t("./lib/cube.js"),
          o = t("gl-mat4/multiply"),
          s = t("gl-mat4/transpose"),
          l = t("gl-vec4/transformMat4"),
          c = new Float32Array([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]),
          u = new Float32Array(16);

      function f(t, e, r) {
        this.lo = t, this.hi = e, this.pixelsPerDataUnit = r;
      }

      var h = [0, 0, 0, 1],
          p = [0, 0, 0, 1];

      function d(t, e, r, n, i) {
        for (var a = 0; a < 3; ++a) {
          for (var o = h, s = p, c = 0; c < 3; ++c) {
            s[c] = o[c] = r[c];
          }

          s[3] = o[3] = 1, s[a] += 1, l(s, s, e), s[3] < 0 && (t[a] = 1 / 0), o[a] -= 1, l(o, o, e), o[3] < 0 && (t[a] = 1 / 0);
          var u = (o[0] / o[3] - s[0] / s[3]) * n,
              f = (o[1] / o[3] - s[1] / s[3]) * i;
          t[a] = .25 * Math.sqrt(u * u + f * f);
        }

        return t;
      }

      var m = [new f(1 / 0, -1 / 0, 1 / 0), new f(1 / 0, -1 / 0, 1 / 0), new f(1 / 0, -1 / 0, 1 / 0)],
          g = [0, 0, 0];
    }, {
      "./lib/cube.js": 251,
      "extract-frustum-planes": 239,
      "gl-mat4/multiply": 292,
      "gl-mat4/transpose": 303,
      "gl-vec4/transformMat4": 423,
      "split-polygon": 559
    }],
    258: [function (t, e, r) {
      "use strict";

      var n = t("typedarray-pool"),
          i = t("ndarray-ops"),
          a = t("ndarray"),
          o = ["uint8", "uint8_clamped", "uint16", "uint32", "int8", "int16", "int32", "float32"];

      function s(t, e, r, n, i) {
        this.gl = t, this.type = e, this.handle = r, this.length = n, this.usage = i;
      }

      var l = s.prototype;

      function c(t, e, r, n, i, a) {
        var o = i.length * i.BYTES_PER_ELEMENT;
        if (a < 0) return t.bufferData(e, i, n), o;
        if (o + a > r) throw new Error("gl-buffer: If resizing buffer, must not specify offset");
        return t.bufferSubData(e, a, i), r;
      }

      function u(t, e) {
        for (var r = n.malloc(t.length, e), i = t.length, a = 0; a < i; ++a) {
          r[a] = t[a];
        }

        return r;
      }

      l.bind = function () {
        this.gl.bindBuffer(this.type, this.handle);
      }, l.unbind = function () {
        this.gl.bindBuffer(this.type, null);
      }, l.dispose = function () {
        this.gl.deleteBuffer(this.handle);
      }, l.update = function (t, e) {
        if ("number" != typeof e && (e = -1), this.bind(), "object" == _typeof(t) && void 0 !== t.shape) {
          var r = t.dtype;
          if (o.indexOf(r) < 0 && (r = "float32"), this.type === this.gl.ELEMENT_ARRAY_BUFFER) r = gl.getExtension("OES_element_index_uint") && "uint16" !== r ? "uint32" : "uint16";
          if (r === t.dtype && function (t, e) {
            for (var r = 1, n = e.length - 1; n >= 0; --n) {
              if (e[n] !== r) return !1;
              r *= t[n];
            }

            return !0;
          }(t.shape, t.stride)) 0 === t.offset && t.data.length === t.shape[0] ? this.length = c(this.gl, this.type, this.length, this.usage, t.data, e) : this.length = c(this.gl, this.type, this.length, this.usage, t.data.subarray(t.offset, t.shape[0]), e);else {
            var s = n.malloc(t.size, r),
                l = a(s, t.shape);
            i.assign(l, t), this.length = c(this.gl, this.type, this.length, this.usage, e < 0 ? s : s.subarray(0, t.size), e), n.free(s);
          }
        } else if (Array.isArray(t)) {
          var f;
          f = this.type === this.gl.ELEMENT_ARRAY_BUFFER ? u(t, "uint16") : u(t, "float32"), this.length = c(this.gl, this.type, this.length, this.usage, e < 0 ? f : f.subarray(0, t.length), e), n.free(f);
        } else if ("object" == _typeof(t) && "number" == typeof t.length) this.length = c(this.gl, this.type, this.length, this.usage, t, e);else {
          if ("number" != typeof t && void 0 !== t) throw new Error("gl-buffer: Invalid data type");
          if (e >= 0) throw new Error("gl-buffer: Cannot specify offset when resizing buffer");
          (t |= 0) <= 0 && (t = 1), this.gl.bufferData(this.type, 0 | t, this.usage), this.length = t;
        }
      }, e.exports = function (t, e, r, n) {
        if (r = r || t.ARRAY_BUFFER, n = n || t.DYNAMIC_DRAW, r !== t.ARRAY_BUFFER && r !== t.ELEMENT_ARRAY_BUFFER) throw new Error("gl-buffer: Invalid type for webgl buffer, must be either gl.ARRAY_BUFFER or gl.ELEMENT_ARRAY_BUFFER");
        if (n !== t.DYNAMIC_DRAW && n !== t.STATIC_DRAW && n !== t.STREAM_DRAW) throw new Error("gl-buffer: Invalid usage for buffer, must be either gl.DYNAMIC_DRAW, gl.STATIC_DRAW or gl.STREAM_DRAW");
        var i = t.createBuffer(),
            a = new s(t, r, i, 0, n);
        return a.update(e), a;
      };
    }, {
      ndarray: 475,
      "ndarray-ops": 470,
      "typedarray-pool": 609
    }],
    259: [function (t, e, r) {
      "use strict";

      var n = t("gl-vec3");

      e.exports = function (t, e) {
        var r = t.positions,
            i = t.vectors,
            a = {
          positions: [],
          vertexIntensity: [],
          vertexIntensityBounds: t.vertexIntensityBounds,
          vectors: [],
          cells: [],
          coneOffset: t.coneOffset,
          colormap: t.colormap
        };
        if (0 === t.positions.length) return e && (e[0] = [0, 0, 0], e[1] = [0, 0, 0]), a;

        for (var o = 0, s = 1 / 0, l = -1 / 0, c = 1 / 0, u = -1 / 0, f = 1 / 0, h = -1 / 0, p = null, d = null, m = [], g = 1 / 0, v = !1, y = 0; y < r.length; y++) {
          var x = r[y];
          s = Math.min(x[0], s), l = Math.max(x[0], l), c = Math.min(x[1], c), u = Math.max(x[1], u), f = Math.min(x[2], f), h = Math.max(x[2], h);
          var b = i[y];

          if (n.length(b) > o && (o = n.length(b)), y) {
            var _ = 2 * n.distance(p, x) / (n.length(d) + n.length(b));

            _ ? (g = Math.min(g, _), v = !1) : v = !0;
          }

          v || (p = x, d = b), m.push(b);
        }

        var w = [s, c, f],
            T = [l, u, h];
        e && (e[0] = w, e[1] = T), 0 === o && (o = 1);
        var k = 1 / o;
        isFinite(g) || (g = 1), a.vectorScale = g;
        var M = t.coneSize || .5;
        t.absoluteConeSize && (M = t.absoluteConeSize * k), a.coneScale = M;
        y = 0;

        for (var A = 0; y < r.length; y++) {
          for (var S = (x = r[y])[0], E = x[1], L = x[2], C = m[y], P = n.length(C) * k, I = 0; I < 8; I++) {
            a.positions.push([S, E, L, A++]), a.positions.push([S, E, L, A++]), a.positions.push([S, E, L, A++]), a.positions.push([S, E, L, A++]), a.positions.push([S, E, L, A++]), a.positions.push([S, E, L, A++]), a.vectors.push(C), a.vectors.push(C), a.vectors.push(C), a.vectors.push(C), a.vectors.push(C), a.vectors.push(C), a.vertexIntensity.push(P, P, P), a.vertexIntensity.push(P, P, P);
            var O = a.positions.length;
            a.cells.push([O - 6, O - 5, O - 4], [O - 3, O - 2, O - 1]);
          }
        }

        return a;
      };

      var i = t("./lib/shaders");
      e.exports.createMesh = t("./create_mesh"), e.exports.createConeMesh = function (t, r) {
        return e.exports.createMesh(t, r, {
          shaders: i,
          traceType: "cone"
        });
      };
    }, {
      "./create_mesh": 260,
      "./lib/shaders": 261,
      "gl-vec3": 371
    }],
    260: [function (t, e, r) {
      "use strict";

      var n = t("gl-shader"),
          i = t("gl-buffer"),
          a = t("gl-vao"),
          o = t("gl-texture2d"),
          s = t("gl-mat4/multiply"),
          l = t("gl-mat4/invert"),
          c = t("ndarray"),
          u = t("colormap"),
          f = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];

      function h(t, e, r, n, i, a, o, s, l, c, u) {
        this.gl = t, this.pixelRatio = 1, this.cells = [], this.positions = [], this.intensity = [], this.texture = e, this.dirty = !0, this.triShader = r, this.pickShader = n, this.trianglePositions = i, this.triangleVectors = a, this.triangleColors = s, this.triangleUVs = l, this.triangleIds = o, this.triangleVAO = c, this.triangleCount = 0, this.pickId = 1, this.bounds = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]], this.clipBounds = [[-1 / 0, -1 / 0, -1 / 0], [1 / 0, 1 / 0, 1 / 0]], this.lightPosition = [1e5, 1e5, 0], this.ambientLight = .8, this.diffuseLight = .8, this.specularLight = 2, this.roughness = .5, this.fresnel = 1.5, this.opacity = 1, this.traceType = u, this.tubeScale = 1, this.coneScale = 2, this.vectorScale = 1, this.coneOffset = .25, this._model = f, this._view = f, this._projection = f, this._resolution = [1, 1];
      }

      var p = h.prototype;

      function d(t, e) {
        var r = n(t, e.meshShader.vertex, e.meshShader.fragment, null, e.meshShader.attributes);
        return r.attributes.position.location = 0, r.attributes.color.location = 2, r.attributes.uv.location = 3, r.attributes.vector.location = 4, r;
      }

      function m(t, e) {
        var r = n(t, e.pickShader.vertex, e.pickShader.fragment, null, e.pickShader.attributes);
        return r.attributes.position.location = 0, r.attributes.id.location = 1, r.attributes.vector.location = 4, r;
      }

      p.isOpaque = function () {
        return this.opacity >= 1;
      }, p.isTransparent = function () {
        return this.opacity < 1;
      }, p.pickSlots = 1, p.setPickBase = function (t) {
        this.pickId = t;
      }, p.update = function (t) {
        t = t || {};
        var e = this.gl;
        this.dirty = !0, "lightPosition" in t && (this.lightPosition = t.lightPosition), "opacity" in t && (this.opacity = t.opacity), "ambient" in t && (this.ambientLight = t.ambient), "diffuse" in t && (this.diffuseLight = t.diffuse), "specular" in t && (this.specularLight = t.specular), "roughness" in t && (this.roughness = t.roughness), "fresnel" in t && (this.fresnel = t.fresnel), void 0 !== t.tubeScale && (this.tubeScale = t.tubeScale), void 0 !== t.vectorScale && (this.vectorScale = t.vectorScale), void 0 !== t.coneScale && (this.coneScale = t.coneScale), void 0 !== t.coneOffset && (this.coneOffset = t.coneOffset), t.colormap && (this.texture.shape = [256, 256], this.texture.minFilter = e.LINEAR_MIPMAP_LINEAR, this.texture.magFilter = e.LINEAR, this.texture.setPixels(function (t) {
          for (var e = u({
            colormap: t,
            nshades: 256,
            format: "rgba"
          }), r = new Uint8Array(1024), n = 0; n < 256; ++n) {
            for (var i = e[n], a = 0; a < 3; ++a) {
              r[4 * n + a] = i[a];
            }

            r[4 * n + 3] = 255 * i[3];
          }

          return c(r, [256, 256, 4], [4, 0, 1]);
        }(t.colormap)), this.texture.generateMipmap());
        var r = t.cells,
            n = t.positions,
            i = t.vectors;

        if (n && r && i) {
          var a = [],
              o = [],
              s = [],
              l = [],
              f = [];
          this.cells = r, this.positions = n, this.vectors = i;
          var h = t.meshColor || [1, 1, 1, 1],
              p = t.vertexIntensity,
              d = 1 / 0,
              m = -1 / 0;
          if (p) {
            if (t.vertexIntensityBounds) d = +t.vertexIntensityBounds[0], m = +t.vertexIntensityBounds[1];else for (var g = 0; g < p.length; ++g) {
              var v = p[g];
              d = Math.min(d, v), m = Math.max(m, v);
            }
          } else for (g = 0; g < n.length; ++g) {
            v = n[g][2];
            d = Math.min(d, v), m = Math.max(m, v);
          }
          this.intensity = p || function (t) {
            for (var e = t.length, r = new Array(e), n = 0; n < e; ++n) {
              r[n] = t[n][2];
            }

            return r;
          }(n), this.bounds = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]];

          for (g = 0; g < n.length; ++g) {
            for (var y = n[g], x = 0; x < 3; ++x) {
              !isNaN(y[x]) && isFinite(y[x]) && (this.bounds[0][x] = Math.min(this.bounds[0][x], y[x]), this.bounds[1][x] = Math.max(this.bounds[1][x], y[x]));
            }
          }

          var b = 0;

          t: for (g = 0; g < r.length; ++g) {
            var _ = r[g];

            switch (_.length) {
              case 3:
                for (x = 0; x < 3; ++x) {
                  y = n[T = _[x]];

                  for (var w = 0; w < 3; ++w) {
                    if (isNaN(y[w]) || !isFinite(y[w])) continue t;
                  }
                }

                for (x = 0; x < 3; ++x) {
                  var T;
                  y = n[T = _[2 - x]];
                  a.push(y[0], y[1], y[2], y[3]);
                  var k = i[T];
                  o.push(k[0], k[1], k[2], k[3] || 0);
                  var M,
                      A = h;
                  3 === A.length ? s.push(A[0], A[1], A[2], 1) : s.push(A[0], A[1], A[2], A[3]), M = p ? [(p[T] - d) / (m - d), 0] : [(y[2] - d) / (m - d), 0], l.push(M[0], M[1]), f.push(g);
                }

                b += 1;
            }
          }

          this.triangleCount = b, this.trianglePositions.update(a), this.triangleVectors.update(o), this.triangleColors.update(s), this.triangleUVs.update(l), this.triangleIds.update(new Uint32Array(f));
        }
      }, p.drawTransparent = p.draw = function (t) {
        t = t || {};

        for (var e = this.gl, r = t.model || f, n = t.view || f, i = t.projection || f, a = [[-1e6, -1e6, -1e6], [1e6, 1e6, 1e6]], o = 0; o < 3; ++o) {
          a[0][o] = Math.max(a[0][o], this.clipBounds[0][o]), a[1][o] = Math.min(a[1][o], this.clipBounds[1][o]);
        }

        var c = {
          model: r,
          view: n,
          projection: i,
          inverseModel: f.slice(),
          clipBounds: a,
          kambient: this.ambientLight,
          kdiffuse: this.diffuseLight,
          kspecular: this.specularLight,
          roughness: this.roughness,
          fresnel: this.fresnel,
          eyePosition: [0, 0, 0],
          lightPosition: [0, 0, 0],
          opacity: this.opacity,
          tubeScale: this.tubeScale,
          vectorScale: this.vectorScale,
          coneScale: this.coneScale,
          coneOffset: this.coneOffset,
          texture: 0
        };
        c.inverseModel = l(c.inverseModel, c.model), e.disable(e.CULL_FACE), this.texture.bind(0);
        var u = new Array(16);
        s(u, c.view, c.model), s(u, c.projection, u), l(u, u);

        for (o = 0; o < 3; ++o) {
          c.eyePosition[o] = u[12 + o] / u[15];
        }

        var h = u[15];

        for (o = 0; o < 3; ++o) {
          h += this.lightPosition[o] * u[4 * o + 3];
        }

        for (o = 0; o < 3; ++o) {
          for (var p = u[12 + o], d = 0; d < 3; ++d) {
            p += u[4 * d + o] * this.lightPosition[d];
          }

          c.lightPosition[o] = p / h;
        }

        if (this.triangleCount > 0) {
          var m = this.triShader;
          m.bind(), m.uniforms = c, this.triangleVAO.bind(), e.drawArrays(e.TRIANGLES, 0, 3 * this.triangleCount), this.triangleVAO.unbind();
        }
      }, p.drawPick = function (t) {
        t = t || {};

        for (var e = this.gl, r = t.model || f, n = t.view || f, i = t.projection || f, a = [[-1e6, -1e6, -1e6], [1e6, 1e6, 1e6]], o = 0; o < 3; ++o) {
          a[0][o] = Math.max(a[0][o], this.clipBounds[0][o]), a[1][o] = Math.min(a[1][o], this.clipBounds[1][o]);
        }

        this._model = [].slice.call(r), this._view = [].slice.call(n), this._projection = [].slice.call(i), this._resolution = [e.drawingBufferWidth, e.drawingBufferHeight];
        var s = {
          model: r,
          view: n,
          projection: i,
          clipBounds: a,
          tubeScale: this.tubeScale,
          vectorScale: this.vectorScale,
          coneScale: this.coneScale,
          coneOffset: this.coneOffset,
          pickId: this.pickId / 255
        },
            l = this.pickShader;
        l.bind(), l.uniforms = s, this.triangleCount > 0 && (this.triangleVAO.bind(), e.drawArrays(e.TRIANGLES, 0, 3 * this.triangleCount), this.triangleVAO.unbind());
      }, p.pick = function (t) {
        if (!t) return null;
        if (t.id !== this.pickId) return null;
        var e = t.value[0] + 256 * t.value[1] + 65536 * t.value[2],
            r = this.cells[e],
            n = this.positions[r[1]].slice(0, 3),
            i = {
          position: n,
          dataCoordinate: n,
          index: Math.floor(r[1] / 48)
        };
        return "cone" === this.traceType ? i.index = Math.floor(r[1] / 48) : "streamtube" === this.traceType && (i.intensity = this.intensity[r[1]], i.velocity = this.vectors[r[1]].slice(0, 3), i.divergence = this.vectors[r[1]][3], i.index = e), i;
      }, p.dispose = function () {
        this.texture.dispose(), this.triShader.dispose(), this.pickShader.dispose(), this.triangleVAO.dispose(), this.trianglePositions.dispose(), this.triangleVectors.dispose(), this.triangleColors.dispose(), this.triangleUVs.dispose(), this.triangleIds.dispose();
      }, e.exports = function (t, e, r) {
        var n = r.shaders;
        1 === arguments.length && (t = (e = t).gl);
        var s = d(t, n),
            l = m(t, n),
            u = o(t, c(new Uint8Array([255, 255, 255, 255]), [1, 1, 4]));
        u.generateMipmap(), u.minFilter = t.LINEAR_MIPMAP_LINEAR, u.magFilter = t.LINEAR;
        var f = i(t),
            p = i(t),
            g = i(t),
            v = i(t),
            y = i(t),
            x = a(t, [{
          buffer: f,
          type: t.FLOAT,
          size: 4
        }, {
          buffer: y,
          type: t.UNSIGNED_BYTE,
          size: 4,
          normalized: !0
        }, {
          buffer: g,
          type: t.FLOAT,
          size: 4
        }, {
          buffer: v,
          type: t.FLOAT,
          size: 2
        }, {
          buffer: p,
          type: t.FLOAT,
          size: 4
        }]),
            b = new h(t, u, s, l, f, p, y, g, v, x, r.traceType || "cone");
        return b.update(e), b;
      };
    }, {
      colormap: 132,
      "gl-buffer": 258,
      "gl-mat4/invert": 290,
      "gl-mat4/multiply": 292,
      "gl-shader": 330,
      "gl-texture2d": 347,
      "gl-vao": 352,
      ndarray: 475
    }],
    261: [function (t, e, r) {
      var n = t("glslify"),
          i = n(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the cone vertex and normal at the given index.\n//\n// The returned vertex is for a cone with its top at origin and height of 1.0,\n// pointing in the direction of the vector attribute.\n//\n// Each cone is made up of a top vertex, a center base vertex and base perimeter vertices.\n// These vertices are used to make up the triangles of the cone by the following:\n//   segment + 0 top vertex\n//   segment + 1 perimeter vertex a+1\n//   segment + 2 perimeter vertex a\n//   segment + 3 center base vertex\n//   segment + 4 perimeter vertex a\n//   segment + 5 perimeter vertex a+1\n// Where segment is the number of the radial segment * 6 and a is the angle at that radial segment.\n// To go from index to segment, floor(index / 6)\n// To go from segment to angle, 2*pi * (segment/segmentCount)\n// To go from index to segment index, index - (segment*6)\n//\nvec3 getConePosition(vec3 d, float rawIndex, float coneOffset, out vec3 normal) {\n\n  const float segmentCount = 8.0;\n\n  float index = rawIndex - floor(rawIndex /\n    (segmentCount * 6.0)) *\n    (segmentCount * 6.0);\n\n  float segment = floor(0.001 + index/6.0);\n  float segmentIndex = index - (segment*6.0);\n\n  normal = -normalize(d);\n\n  if (segmentIndex > 2.99 && segmentIndex < 3.01) {\n    return mix(vec3(0.0), -d, coneOffset);\n  }\n\n  float nextAngle = (\n    (segmentIndex > 0.99 &&  segmentIndex < 1.01) ||\n    (segmentIndex > 4.99 &&  segmentIndex < 5.01)\n  ) ? 1.0 : 0.0;\n  float angle = 2.0 * 3.14159 * ((segment + nextAngle) / segmentCount);\n\n  vec3 v1 = mix(d, vec3(0.0), coneOffset);\n  vec3 v2 = v1 - d;\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d)*0.25;\n  vec3 y = v * sin(angle) * length(d)*0.25;\n  vec3 v3 = v2 + x + y;\n  if (segmentIndex < 3.0) {\n    vec3 tx = u * sin(angle);\n    vec3 ty = v * -cos(angle);\n    vec3 tangent = tx + ty;\n    normal = normalize(cross(v3 - v1, tangent));\n  }\n\n  if (segmentIndex == 0.0) {\n    return mix(d, vec3(0.0), coneOffset);\n  }\n  return v3;\n}\n\nattribute vec3 vector;\nattribute vec4 color, position;\nattribute vec2 uv;\n\nuniform float vectorScale, coneScale, coneOffset;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 eyePosition, lightPosition;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  // Scale the vector magnitude to stay constant with\n  // model & view changes.\n  vec3 normal;\n  vec3 XYZ = getConePosition(mat3(model) * ((vectorScale * coneScale) * vector), position.w, coneOffset, normal);\n  vec4 conePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * conePosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  // vec4 m_position  = model * vec4(conePosition, 1.0);\n  vec4 t_position  = view * conePosition;\n  gl_Position      = projection * t_position;\n\n  f_color          = color;\n  f_data           = conePosition.xyz;\n  f_position       = position.xyz;\n  f_uv             = uv;\n}\n"]),
          a = n(["#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform sampler2D texture;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = f_color * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * opacity;\n}\n"]),
          o = n(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the cone vertex and normal at the given index.\n//\n// The returned vertex is for a cone with its top at origin and height of 1.0,\n// pointing in the direction of the vector attribute.\n//\n// Each cone is made up of a top vertex, a center base vertex and base perimeter vertices.\n// These vertices are used to make up the triangles of the cone by the following:\n//   segment + 0 top vertex\n//   segment + 1 perimeter vertex a+1\n//   segment + 2 perimeter vertex a\n//   segment + 3 center base vertex\n//   segment + 4 perimeter vertex a\n//   segment + 5 perimeter vertex a+1\n// Where segment is the number of the radial segment * 6 and a is the angle at that radial segment.\n// To go from index to segment, floor(index / 6)\n// To go from segment to angle, 2*pi * (segment/segmentCount)\n// To go from index to segment index, index - (segment*6)\n//\nvec3 getConePosition(vec3 d, float rawIndex, float coneOffset, out vec3 normal) {\n\n  const float segmentCount = 8.0;\n\n  float index = rawIndex - floor(rawIndex /\n    (segmentCount * 6.0)) *\n    (segmentCount * 6.0);\n\n  float segment = floor(0.001 + index/6.0);\n  float segmentIndex = index - (segment*6.0);\n\n  normal = -normalize(d);\n\n  if (segmentIndex > 2.99 && segmentIndex < 3.01) {\n    return mix(vec3(0.0), -d, coneOffset);\n  }\n\n  float nextAngle = (\n    (segmentIndex > 0.99 &&  segmentIndex < 1.01) ||\n    (segmentIndex > 4.99 &&  segmentIndex < 5.01)\n  ) ? 1.0 : 0.0;\n  float angle = 2.0 * 3.14159 * ((segment + nextAngle) / segmentCount);\n\n  vec3 v1 = mix(d, vec3(0.0), coneOffset);\n  vec3 v2 = v1 - d;\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d)*0.25;\n  vec3 y = v * sin(angle) * length(d)*0.25;\n  vec3 v3 = v2 + x + y;\n  if (segmentIndex < 3.0) {\n    vec3 tx = u * sin(angle);\n    vec3 ty = v * -cos(angle);\n    vec3 tangent = tx + ty;\n    normal = normalize(cross(v3 - v1, tangent));\n  }\n\n  if (segmentIndex == 0.0) {\n    return mix(d, vec3(0.0), coneOffset);\n  }\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform float vectorScale, coneScale, coneOffset;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  vec3 normal;\n  vec3 XYZ = getConePosition(mat3(model) * ((vectorScale * coneScale) * vector.xyz), position.w, coneOffset, normal);\n  vec4 conePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n  gl_Position = projection * view * conePosition;\n  f_id        = id;\n  f_position  = position.xyz;\n}\n"]),
          s = n(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"]);
      r.meshShader = {
        vertex: i,
        fragment: a,
        attributes: [{
          name: "position",
          type: "vec4"
        }, {
          name: "color",
          type: "vec4"
        }, {
          name: "uv",
          type: "vec2"
        }, {
          name: "vector",
          type: "vec3"
        }]
      }, r.pickShader = {
        vertex: o,
        fragment: s,
        attributes: [{
          name: "position",
          type: "vec4"
        }, {
          name: "id",
          type: "vec4"
        }, {
          name: "vector",
          type: "vec3"
        }]
      };
    }, {
      glslify: 433
    }],
    262: [function (t, e, r) {
      e.exports = {
        0: "NONE",
        1: "ONE",
        2: "LINE_LOOP",
        3: "LINE_STRIP",
        4: "TRIANGLES",
        5: "TRIANGLE_STRIP",
        6: "TRIANGLE_FAN",
        256: "DEPTH_BUFFER_BIT",
        512: "NEVER",
        513: "LESS",
        514: "EQUAL",
        515: "LEQUAL",
        516: "GREATER",
        517: "NOTEQUAL",
        518: "GEQUAL",
        519: "ALWAYS",
        768: "SRC_COLOR",
        769: "ONE_MINUS_SRC_COLOR",
        770: "SRC_ALPHA",
        771: "ONE_MINUS_SRC_ALPHA",
        772: "DST_ALPHA",
        773: "ONE_MINUS_DST_ALPHA",
        774: "DST_COLOR",
        775: "ONE_MINUS_DST_COLOR",
        776: "SRC_ALPHA_SATURATE",
        1024: "STENCIL_BUFFER_BIT",
        1028: "FRONT",
        1029: "BACK",
        1032: "FRONT_AND_BACK",
        1280: "INVALID_ENUM",
        1281: "INVALID_VALUE",
        1282: "INVALID_OPERATION",
        1285: "OUT_OF_MEMORY",
        1286: "INVALID_FRAMEBUFFER_OPERATION",
        2304: "CW",
        2305: "CCW",
        2849: "LINE_WIDTH",
        2884: "CULL_FACE",
        2885: "CULL_FACE_MODE",
        2886: "FRONT_FACE",
        2928: "DEPTH_RANGE",
        2929: "DEPTH_TEST",
        2930: "DEPTH_WRITEMASK",
        2931: "DEPTH_CLEAR_VALUE",
        2932: "DEPTH_FUNC",
        2960: "STENCIL_TEST",
        2961: "STENCIL_CLEAR_VALUE",
        2962: "STENCIL_FUNC",
        2963: "STENCIL_VALUE_MASK",
        2964: "STENCIL_FAIL",
        2965: "STENCIL_PASS_DEPTH_FAIL",
        2966: "STENCIL_PASS_DEPTH_PASS",
        2967: "STENCIL_REF",
        2968: "STENCIL_WRITEMASK",
        2978: "VIEWPORT",
        3024: "DITHER",
        3042: "BLEND",
        3088: "SCISSOR_BOX",
        3089: "SCISSOR_TEST",
        3106: "COLOR_CLEAR_VALUE",
        3107: "COLOR_WRITEMASK",
        3317: "UNPACK_ALIGNMENT",
        3333: "PACK_ALIGNMENT",
        3379: "MAX_TEXTURE_SIZE",
        3386: "MAX_VIEWPORT_DIMS",
        3408: "SUBPIXEL_BITS",
        3410: "RED_BITS",
        3411: "GREEN_BITS",
        3412: "BLUE_BITS",
        3413: "ALPHA_BITS",
        3414: "DEPTH_BITS",
        3415: "STENCIL_BITS",
        3553: "TEXTURE_2D",
        4352: "DONT_CARE",
        4353: "FASTEST",
        4354: "NICEST",
        5120: "BYTE",
        5121: "UNSIGNED_BYTE",
        5122: "SHORT",
        5123: "UNSIGNED_SHORT",
        5124: "INT",
        5125: "UNSIGNED_INT",
        5126: "FLOAT",
        5386: "INVERT",
        5890: "TEXTURE",
        6401: "STENCIL_INDEX",
        6402: "DEPTH_COMPONENT",
        6406: "ALPHA",
        6407: "RGB",
        6408: "RGBA",
        6409: "LUMINANCE",
        6410: "LUMINANCE_ALPHA",
        7680: "KEEP",
        7681: "REPLACE",
        7682: "INCR",
        7683: "DECR",
        7936: "VENDOR",
        7937: "RENDERER",
        7938: "VERSION",
        9728: "NEAREST",
        9729: "LINEAR",
        9984: "NEAREST_MIPMAP_NEAREST",
        9985: "LINEAR_MIPMAP_NEAREST",
        9986: "NEAREST_MIPMAP_LINEAR",
        9987: "LINEAR_MIPMAP_LINEAR",
        10240: "TEXTURE_MAG_FILTER",
        10241: "TEXTURE_MIN_FILTER",
        10242: "TEXTURE_WRAP_S",
        10243: "TEXTURE_WRAP_T",
        10497: "REPEAT",
        10752: "POLYGON_OFFSET_UNITS",
        16384: "COLOR_BUFFER_BIT",
        32769: "CONSTANT_COLOR",
        32770: "ONE_MINUS_CONSTANT_COLOR",
        32771: "CONSTANT_ALPHA",
        32772: "ONE_MINUS_CONSTANT_ALPHA",
        32773: "BLEND_COLOR",
        32774: "FUNC_ADD",
        32777: "BLEND_EQUATION_RGB",
        32778: "FUNC_SUBTRACT",
        32779: "FUNC_REVERSE_SUBTRACT",
        32819: "UNSIGNED_SHORT_4_4_4_4",
        32820: "UNSIGNED_SHORT_5_5_5_1",
        32823: "POLYGON_OFFSET_FILL",
        32824: "POLYGON_OFFSET_FACTOR",
        32854: "RGBA4",
        32855: "RGB5_A1",
        32873: "TEXTURE_BINDING_2D",
        32926: "SAMPLE_ALPHA_TO_COVERAGE",
        32928: "SAMPLE_COVERAGE",
        32936: "SAMPLE_BUFFERS",
        32937: "SAMPLES",
        32938: "SAMPLE_COVERAGE_VALUE",
        32939: "SAMPLE_COVERAGE_INVERT",
        32968: "BLEND_DST_RGB",
        32969: "BLEND_SRC_RGB",
        32970: "BLEND_DST_ALPHA",
        32971: "BLEND_SRC_ALPHA",
        33071: "CLAMP_TO_EDGE",
        33170: "GENERATE_MIPMAP_HINT",
        33189: "DEPTH_COMPONENT16",
        33306: "DEPTH_STENCIL_ATTACHMENT",
        33635: "UNSIGNED_SHORT_5_6_5",
        33648: "MIRRORED_REPEAT",
        33901: "ALIASED_POINT_SIZE_RANGE",
        33902: "ALIASED_LINE_WIDTH_RANGE",
        33984: "TEXTURE0",
        33985: "TEXTURE1",
        33986: "TEXTURE2",
        33987: "TEXTURE3",
        33988: "TEXTURE4",
        33989: "TEXTURE5",
        33990: "TEXTURE6",
        33991: "TEXTURE7",
        33992: "TEXTURE8",
        33993: "TEXTURE9",
        33994: "TEXTURE10",
        33995: "TEXTURE11",
        33996: "TEXTURE12",
        33997: "TEXTURE13",
        33998: "TEXTURE14",
        33999: "TEXTURE15",
        34e3: "TEXTURE16",
        34001: "TEXTURE17",
        34002: "TEXTURE18",
        34003: "TEXTURE19",
        34004: "TEXTURE20",
        34005: "TEXTURE21",
        34006: "TEXTURE22",
        34007: "TEXTURE23",
        34008: "TEXTURE24",
        34009: "TEXTURE25",
        34010: "TEXTURE26",
        34011: "TEXTURE27",
        34012: "TEXTURE28",
        34013: "TEXTURE29",
        34014: "TEXTURE30",
        34015: "TEXTURE31",
        34016: "ACTIVE_TEXTURE",
        34024: "MAX_RENDERBUFFER_SIZE",
        34041: "DEPTH_STENCIL",
        34055: "INCR_WRAP",
        34056: "DECR_WRAP",
        34067: "TEXTURE_CUBE_MAP",
        34068: "TEXTURE_BINDING_CUBE_MAP",
        34069: "TEXTURE_CUBE_MAP_POSITIVE_X",
        34070: "TEXTURE_CUBE_MAP_NEGATIVE_X",
        34071: "TEXTURE_CUBE_MAP_POSITIVE_Y",
        34072: "TEXTURE_CUBE_MAP_NEGATIVE_Y",
        34073: "TEXTURE_CUBE_MAP_POSITIVE_Z",
        34074: "TEXTURE_CUBE_MAP_NEGATIVE_Z",
        34076: "MAX_CUBE_MAP_TEXTURE_SIZE",
        34338: "VERTEX_ATTRIB_ARRAY_ENABLED",
        34339: "VERTEX_ATTRIB_ARRAY_SIZE",
        34340: "VERTEX_ATTRIB_ARRAY_STRIDE",
        34341: "VERTEX_ATTRIB_ARRAY_TYPE",
        34342: "CURRENT_VERTEX_ATTRIB",
        34373: "VERTEX_ATTRIB_ARRAY_POINTER",
        34466: "NUM_COMPRESSED_TEXTURE_FORMATS",
        34467: "COMPRESSED_TEXTURE_FORMATS",
        34660: "BUFFER_SIZE",
        34661: "BUFFER_USAGE",
        34816: "STENCIL_BACK_FUNC",
        34817: "STENCIL_BACK_FAIL",
        34818: "STENCIL_BACK_PASS_DEPTH_FAIL",
        34819: "STENCIL_BACK_PASS_DEPTH_PASS",
        34877: "BLEND_EQUATION_ALPHA",
        34921: "MAX_VERTEX_ATTRIBS",
        34922: "VERTEX_ATTRIB_ARRAY_NORMALIZED",
        34930: "MAX_TEXTURE_IMAGE_UNITS",
        34962: "ARRAY_BUFFER",
        34963: "ELEMENT_ARRAY_BUFFER",
        34964: "ARRAY_BUFFER_BINDING",
        34965: "ELEMENT_ARRAY_BUFFER_BINDING",
        34975: "VERTEX_ATTRIB_ARRAY_BUFFER_BINDING",
        35040: "STREAM_DRAW",
        35044: "STATIC_DRAW",
        35048: "DYNAMIC_DRAW",
        35632: "FRAGMENT_SHADER",
        35633: "VERTEX_SHADER",
        35660: "MAX_VERTEX_TEXTURE_IMAGE_UNITS",
        35661: "MAX_COMBINED_TEXTURE_IMAGE_UNITS",
        35663: "SHADER_TYPE",
        35664: "FLOAT_VEC2",
        35665: "FLOAT_VEC3",
        35666: "FLOAT_VEC4",
        35667: "INT_VEC2",
        35668: "INT_VEC3",
        35669: "INT_VEC4",
        35670: "BOOL",
        35671: "BOOL_VEC2",
        35672: "BOOL_VEC3",
        35673: "BOOL_VEC4",
        35674: "FLOAT_MAT2",
        35675: "FLOAT_MAT3",
        35676: "FLOAT_MAT4",
        35678: "SAMPLER_2D",
        35680: "SAMPLER_CUBE",
        35712: "DELETE_STATUS",
        35713: "COMPILE_STATUS",
        35714: "LINK_STATUS",
        35715: "VALIDATE_STATUS",
        35716: "INFO_LOG_LENGTH",
        35717: "ATTACHED_SHADERS",
        35718: "ACTIVE_UNIFORMS",
        35719: "ACTIVE_UNIFORM_MAX_LENGTH",
        35720: "SHADER_SOURCE_LENGTH",
        35721: "ACTIVE_ATTRIBUTES",
        35722: "ACTIVE_ATTRIBUTE_MAX_LENGTH",
        35724: "SHADING_LANGUAGE_VERSION",
        35725: "CURRENT_PROGRAM",
        36003: "STENCIL_BACK_REF",
        36004: "STENCIL_BACK_VALUE_MASK",
        36005: "STENCIL_BACK_WRITEMASK",
        36006: "FRAMEBUFFER_BINDING",
        36007: "RENDERBUFFER_BINDING",
        36048: "FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE",
        36049: "FRAMEBUFFER_ATTACHMENT_OBJECT_NAME",
        36050: "FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL",
        36051: "FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE",
        36053: "FRAMEBUFFER_COMPLETE",
        36054: "FRAMEBUFFER_INCOMPLETE_ATTACHMENT",
        36055: "FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT",
        36057: "FRAMEBUFFER_INCOMPLETE_DIMENSIONS",
        36061: "FRAMEBUFFER_UNSUPPORTED",
        36064: "COLOR_ATTACHMENT0",
        36096: "DEPTH_ATTACHMENT",
        36128: "STENCIL_ATTACHMENT",
        36160: "FRAMEBUFFER",
        36161: "RENDERBUFFER",
        36162: "RENDERBUFFER_WIDTH",
        36163: "RENDERBUFFER_HEIGHT",
        36164: "RENDERBUFFER_INTERNAL_FORMAT",
        36168: "STENCIL_INDEX8",
        36176: "RENDERBUFFER_RED_SIZE",
        36177: "RENDERBUFFER_GREEN_SIZE",
        36178: "RENDERBUFFER_BLUE_SIZE",
        36179: "RENDERBUFFER_ALPHA_SIZE",
        36180: "RENDERBUFFER_DEPTH_SIZE",
        36181: "RENDERBUFFER_STENCIL_SIZE",
        36194: "RGB565",
        36336: "LOW_FLOAT",
        36337: "MEDIUM_FLOAT",
        36338: "HIGH_FLOAT",
        36339: "LOW_INT",
        36340: "MEDIUM_INT",
        36341: "HIGH_INT",
        36346: "SHADER_COMPILER",
        36347: "MAX_VERTEX_UNIFORM_VECTORS",
        36348: "MAX_VARYING_VECTORS",
        36349: "MAX_FRAGMENT_UNIFORM_VECTORS",
        37440: "UNPACK_FLIP_Y_WEBGL",
        37441: "UNPACK_PREMULTIPLY_ALPHA_WEBGL",
        37442: "CONTEXT_LOST_WEBGL",
        37443: "UNPACK_COLORSPACE_CONVERSION_WEBGL",
        37444: "BROWSER_DEFAULT_WEBGL"
      };
    }, {}],
    263: [function (t, e, r) {
      var n = t("./1.0/numbers");

      e.exports = function (t) {
        return n[t];
      };
    }, {
      "./1.0/numbers": 262
    }],
    264: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        var e = t.gl,
            r = n(e),
            o = i(e, [{
          buffer: r,
          type: e.FLOAT,
          size: 3,
          offset: 0,
          stride: 40
        }, {
          buffer: r,
          type: e.FLOAT,
          size: 4,
          offset: 12,
          stride: 40
        }, {
          buffer: r,
          type: e.FLOAT,
          size: 3,
          offset: 28,
          stride: 40
        }]),
            l = a(e);
        l.attributes.position.location = 0, l.attributes.color.location = 1, l.attributes.offset.location = 2;
        var c = new s(e, r, o, l);
        return c.update(t), c;
      };

      var n = t("gl-buffer"),
          i = t("gl-vao"),
          a = t("./shaders/index"),
          o = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];

      function s(t, e, r, n) {
        this.gl = t, this.shader = n, this.buffer = e, this.vao = r, this.pixelRatio = 1, this.bounds = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]], this.clipBounds = [[-1 / 0, -1 / 0, -1 / 0], [1 / 0, 1 / 0, 1 / 0]], this.lineWidth = [1, 1, 1], this.capSize = [10, 10, 10], this.lineCount = [0, 0, 0], this.lineOffset = [0, 0, 0], this.opacity = 1, this.hasAlpha = !1;
      }

      var l = s.prototype;

      function c(t, e) {
        for (var r = 0; r < 3; ++r) {
          t[0][r] = Math.min(t[0][r], e[r]), t[1][r] = Math.max(t[1][r], e[r]);
        }
      }

      l.isOpaque = function () {
        return !this.hasAlpha;
      }, l.isTransparent = function () {
        return this.hasAlpha;
      }, l.drawTransparent = l.draw = function (t) {
        var e = this.gl,
            r = this.shader.uniforms;
        this.shader.bind();
        var n = r.view = t.view || o,
            i = r.projection = t.projection || o;
        r.model = t.model || o, r.clipBounds = this.clipBounds, r.opacity = this.opacity;
        var a = n[12],
            s = n[13],
            l = n[14],
            c = n[15],
            u = (t._ortho || !1 ? 2 : 1) * this.pixelRatio * (i[3] * a + i[7] * s + i[11] * l + i[15] * c) / e.drawingBufferHeight;
        this.vao.bind();

        for (var f = 0; f < 3; ++f) {
          e.lineWidth(this.lineWidth[f] * this.pixelRatio), r.capSize = this.capSize[f] * u, this.lineCount[f] && e.drawArrays(e.LINES, this.lineOffset[f], this.lineCount[f]);
        }

        this.vao.unbind();
      };

      var u = function () {
        for (var t = new Array(3), e = 0; e < 3; ++e) {
          for (var r = [], n = 1; n <= 2; ++n) {
            for (var i = -1; i <= 1; i += 2) {
              var a = [0, 0, 0];
              a[(n + e) % 3] = i, r.push(a);
            }
          }

          t[e] = r;
        }

        return t;
      }();

      function f(t, e, r, n) {
        for (var i = u[n], a = 0; a < i.length; ++a) {
          var o = i[a];
          t.push(e[0], e[1], e[2], r[0], r[1], r[2], r[3], o[0], o[1], o[2]);
        }

        return i.length;
      }

      l.update = function (t) {
        "lineWidth" in (t = t || {}) && (this.lineWidth = t.lineWidth, Array.isArray(this.lineWidth) || (this.lineWidth = [this.lineWidth, this.lineWidth, this.lineWidth])), "capSize" in t && (this.capSize = t.capSize, Array.isArray(this.capSize) || (this.capSize = [this.capSize, this.capSize, this.capSize])), this.hasAlpha = !1, "opacity" in t && (this.opacity = +t.opacity, this.opacity < 1 && (this.hasAlpha = !0));
        var e = t.color || [[0, 0, 0], [0, 0, 0], [0, 0, 0]],
            r = t.position,
            n = t.error;

        if (Array.isArray(e[0]) || (e = [e, e, e]), r && n) {
          var i = [],
              a = r.length,
              o = 0;
          this.bounds = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]], this.lineCount = [0, 0, 0];

          for (var s = 0; s < 3; ++s) {
            this.lineOffset[s] = o;

            t: for (var l = 0; l < a; ++l) {
              for (var u = r[l], h = 0; h < 3; ++h) {
                if (isNaN(u[h]) || !isFinite(u[h])) continue t;
              }

              var p = n[l],
                  d = e[s];

              if (Array.isArray(d[0]) && (d = e[l]), 3 === d.length ? d = [d[0], d[1], d[2], 1] : 4 === d.length && (d = [d[0], d[1], d[2], d[3]], !this.hasAlpha && d[3] < 1 && (this.hasAlpha = !0)), !isNaN(p[0][s]) && !isNaN(p[1][s])) {
                var m;
                if (p[0][s] < 0) (m = u.slice())[s] += p[0][s], i.push(u[0], u[1], u[2], d[0], d[1], d[2], d[3], 0, 0, 0, m[0], m[1], m[2], d[0], d[1], d[2], d[3], 0, 0, 0), c(this.bounds, m), o += 2 + f(i, m, d, s);
                if (p[1][s] > 0) (m = u.slice())[s] += p[1][s], i.push(u[0], u[1], u[2], d[0], d[1], d[2], d[3], 0, 0, 0, m[0], m[1], m[2], d[0], d[1], d[2], d[3], 0, 0, 0), c(this.bounds, m), o += 2 + f(i, m, d, s);
              }
            }

            this.lineCount[s] = o - this.lineOffset[s];
          }

          this.buffer.update(i);
        }
      }, l.dispose = function () {
        this.shader.dispose(), this.buffer.dispose(), this.vao.dispose();
      };
    }, {
      "./shaders/index": 266,
      "gl-buffer": 258,
      "gl-vao": 352
    }],
    265: [function (t, e, r) {
      arguments[4][256][0].apply(r, arguments);
    }, {
      dup: 256
    }],
    266: [function (t, e, r) {
      "use strict";

      var n = t("glslify"),
          i = t("gl-shader"),
          a = n(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, offset;\nattribute vec4 color;\nuniform mat4 model, view, projection;\nuniform float capSize;\nvarying vec4 fragColor;\nvarying vec3 fragPosition;\n\nvoid main() {\n  vec4 worldPosition  = model * vec4(position, 1.0);\n  worldPosition       = (worldPosition / worldPosition.w) + vec4(capSize * offset, 0.0);\n  gl_Position         = projection * view * worldPosition;\n  fragColor           = color;\n  fragPosition        = position;\n}"]),
          o = n(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float opacity;\nvarying vec3 fragPosition;\nvarying vec4 fragColor;\n\nvoid main() {\n  if (\n    outOfRange(clipBounds[0], clipBounds[1], fragPosition) ||\n    fragColor.a * opacity == 0.\n  ) discard;\n\n  gl_FragColor = opacity * fragColor;\n}"]);

      e.exports = function (t) {
        return i(t, a, o, null, [{
          name: "position",
          type: "vec3"
        }, {
          name: "color",
          type: "vec4"
        }, {
          name: "offset",
          type: "vec3"
        }]);
      };
    }, {
      "gl-shader": 330,
      glslify: 265
    }],
    267: [function (t, e, r) {
      "use strict";

      var n = t("gl-texture2d");

      e.exports = function (t, e, r, n) {
        i || (i = t.FRAMEBUFFER_UNSUPPORTED, a = t.FRAMEBUFFER_INCOMPLETE_ATTACHMENT, o = t.FRAMEBUFFER_INCOMPLETE_DIMENSIONS, s = t.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT);
        var c = t.getExtension("WEBGL_draw_buffers");
        !l && c && function (t, e) {
          var r = t.getParameter(e.MAX_COLOR_ATTACHMENTS_WEBGL);
          l = new Array(r + 1);

          for (var n = 0; n <= r; ++n) {
            for (var i = new Array(r), a = 0; a < n; ++a) {
              i[a] = t.COLOR_ATTACHMENT0 + a;
            }

            for (a = n; a < r; ++a) {
              i[a] = t.NONE;
            }

            l[n] = i;
          }
        }(t, c);
        Array.isArray(e) && (n = r, r = 0 | e[1], e = 0 | e[0]);
        if ("number" != typeof e) throw new Error("gl-fbo: Missing shape parameter");
        var u = t.getParameter(t.MAX_RENDERBUFFER_SIZE);
        if (e < 0 || e > u || r < 0 || r > u) throw new Error("gl-fbo: Parameters are too large for FBO");
        var f = 1;

        if ("color" in (n = n || {})) {
          if ((f = Math.max(0 | n.color, 0)) < 0) throw new Error("gl-fbo: Must specify a nonnegative number of colors");

          if (f > 1) {
            if (!c) throw new Error("gl-fbo: Multiple draw buffer extension not supported");
            if (f > t.getParameter(c.MAX_COLOR_ATTACHMENTS_WEBGL)) throw new Error("gl-fbo: Context does not support " + f + " draw buffers");
          }
        }

        var h = t.UNSIGNED_BYTE,
            p = t.getExtension("OES_texture_float");

        if (n.float && f > 0) {
          if (!p) throw new Error("gl-fbo: Context does not support floating point textures");
          h = t.FLOAT;
        } else n.preferFloat && f > 0 && p && (h = t.FLOAT);

        var m = !0;
        "depth" in n && (m = !!n.depth);
        var g = !1;
        "stencil" in n && (g = !!n.stencil);
        return new d(t, e, r, h, f, m, g, c);
      };

      var i,
          a,
          o,
          s,
          l = null;

      function c(t) {
        return [t.getParameter(t.FRAMEBUFFER_BINDING), t.getParameter(t.RENDERBUFFER_BINDING), t.getParameter(t.TEXTURE_BINDING_2D)];
      }

      function u(t, e) {
        t.bindFramebuffer(t.FRAMEBUFFER, e[0]), t.bindRenderbuffer(t.RENDERBUFFER, e[1]), t.bindTexture(t.TEXTURE_2D, e[2]);
      }

      function f(t) {
        switch (t) {
          case i:
            throw new Error("gl-fbo: Framebuffer unsupported");

          case a:
            throw new Error("gl-fbo: Framebuffer incomplete attachment");

          case o:
            throw new Error("gl-fbo: Framebuffer incomplete dimensions");

          case s:
            throw new Error("gl-fbo: Framebuffer incomplete missing attachment");

          default:
            throw new Error("gl-fbo: Framebuffer failed for unspecified reason");
        }
      }

      function h(t, e, r, i, a, o) {
        if (!i) return null;
        var s = n(t, e, r, a, i);
        return s.magFilter = t.NEAREST, s.minFilter = t.NEAREST, s.mipSamples = 1, s.bind(), t.framebufferTexture2D(t.FRAMEBUFFER, o, t.TEXTURE_2D, s.handle, 0), s;
      }

      function p(t, e, r, n, i) {
        var a = t.createRenderbuffer();
        return t.bindRenderbuffer(t.RENDERBUFFER, a), t.renderbufferStorage(t.RENDERBUFFER, n, e, r), t.framebufferRenderbuffer(t.FRAMEBUFFER, i, t.RENDERBUFFER, a), a;
      }

      function d(t, e, r, n, i, a, o, s) {
        this.gl = t, this._shape = [0 | e, 0 | r], this._destroyed = !1, this._ext = s, this.color = new Array(i);

        for (var d = 0; d < i; ++d) {
          this.color[d] = null;
        }

        this._color_rb = null, this.depth = null, this._depth_rb = null, this._colorType = n, this._useDepth = a, this._useStencil = o;
        var m = this,
            g = [0 | e, 0 | r];
        Object.defineProperties(g, {
          0: {
            get: function get() {
              return m._shape[0];
            },
            set: function set(t) {
              return m.width = t;
            }
          },
          1: {
            get: function get() {
              return m._shape[1];
            },
            set: function set(t) {
              return m.height = t;
            }
          }
        }), this._shapeVector = g, function (t) {
          var e = c(t.gl),
              r = t.gl,
              n = t.handle = r.createFramebuffer(),
              i = t._shape[0],
              a = t._shape[1],
              o = t.color.length,
              s = t._ext,
              d = t._useStencil,
              m = t._useDepth,
              g = t._colorType;
          r.bindFramebuffer(r.FRAMEBUFFER, n);

          for (var v = 0; v < o; ++v) {
            t.color[v] = h(r, i, a, g, r.RGBA, r.COLOR_ATTACHMENT0 + v);
          }

          0 === o ? (t._color_rb = p(r, i, a, r.RGBA4, r.COLOR_ATTACHMENT0), s && s.drawBuffersWEBGL(l[0])) : o > 1 && s.drawBuffersWEBGL(l[o]);
          var y = r.getExtension("WEBGL_depth_texture");
          y ? d ? t.depth = h(r, i, a, y.UNSIGNED_INT_24_8_WEBGL, r.DEPTH_STENCIL, r.DEPTH_STENCIL_ATTACHMENT) : m && (t.depth = h(r, i, a, r.UNSIGNED_SHORT, r.DEPTH_COMPONENT, r.DEPTH_ATTACHMENT)) : m && d ? t._depth_rb = p(r, i, a, r.DEPTH_STENCIL, r.DEPTH_STENCIL_ATTACHMENT) : m ? t._depth_rb = p(r, i, a, r.DEPTH_COMPONENT16, r.DEPTH_ATTACHMENT) : d && (t._depth_rb = p(r, i, a, r.STENCIL_INDEX, r.STENCIL_ATTACHMENT));
          var x = r.checkFramebufferStatus(r.FRAMEBUFFER);

          if (x !== r.FRAMEBUFFER_COMPLETE) {
            t._destroyed = !0, r.bindFramebuffer(r.FRAMEBUFFER, null), r.deleteFramebuffer(t.handle), t.handle = null, t.depth && (t.depth.dispose(), t.depth = null), t._depth_rb && (r.deleteRenderbuffer(t._depth_rb), t._depth_rb = null);

            for (v = 0; v < t.color.length; ++v) {
              t.color[v].dispose(), t.color[v] = null;
            }

            t._color_rb && (r.deleteRenderbuffer(t._color_rb), t._color_rb = null), u(r, e), f(x);
          }

          u(r, e);
        }(this);
      }

      var m = d.prototype;

      function g(t, e, r) {
        if (t._destroyed) throw new Error("gl-fbo: Can't resize destroyed FBO");

        if (t._shape[0] !== e || t._shape[1] !== r) {
          var n = t.gl,
              i = n.getParameter(n.MAX_RENDERBUFFER_SIZE);
          if (e < 0 || e > i || r < 0 || r > i) throw new Error("gl-fbo: Can't resize FBO, invalid dimensions");
          t._shape[0] = e, t._shape[1] = r;

          for (var a = c(n), o = 0; o < t.color.length; ++o) {
            t.color[o].shape = t._shape;
          }

          t._color_rb && (n.bindRenderbuffer(n.RENDERBUFFER, t._color_rb), n.renderbufferStorage(n.RENDERBUFFER, n.RGBA4, t._shape[0], t._shape[1])), t.depth && (t.depth.shape = t._shape), t._depth_rb && (n.bindRenderbuffer(n.RENDERBUFFER, t._depth_rb), t._useDepth && t._useStencil ? n.renderbufferStorage(n.RENDERBUFFER, n.DEPTH_STENCIL, t._shape[0], t._shape[1]) : t._useDepth ? n.renderbufferStorage(n.RENDERBUFFER, n.DEPTH_COMPONENT16, t._shape[0], t._shape[1]) : t._useStencil && n.renderbufferStorage(n.RENDERBUFFER, n.STENCIL_INDEX, t._shape[0], t._shape[1])), n.bindFramebuffer(n.FRAMEBUFFER, t.handle);
          var s = n.checkFramebufferStatus(n.FRAMEBUFFER);
          s !== n.FRAMEBUFFER_COMPLETE && (t.dispose(), u(n, a), f(s)), u(n, a);
        }
      }

      Object.defineProperties(m, {
        shape: {
          get: function get() {
            return this._destroyed ? [0, 0] : this._shapeVector;
          },
          set: function set(t) {
            if (Array.isArray(t) || (t = [0 | t, 0 | t]), 2 !== t.length) throw new Error("gl-fbo: Shape vector must be length 2");
            var e = 0 | t[0],
                r = 0 | t[1];
            return g(this, e, r), [e, r];
          },
          enumerable: !1
        },
        width: {
          get: function get() {
            return this._destroyed ? 0 : this._shape[0];
          },
          set: function set(t) {
            return g(this, t |= 0, this._shape[1]), t;
          },
          enumerable: !1
        },
        height: {
          get: function get() {
            return this._destroyed ? 0 : this._shape[1];
          },
          set: function set(t) {
            return t |= 0, g(this, this._shape[0], t), t;
          },
          enumerable: !1
        }
      }), m.bind = function () {
        if (!this._destroyed) {
          var t = this.gl;
          t.bindFramebuffer(t.FRAMEBUFFER, this.handle), t.viewport(0, 0, this._shape[0], this._shape[1]);
        }
      }, m.dispose = function () {
        if (!this._destroyed) {
          this._destroyed = !0;
          var t = this.gl;
          t.deleteFramebuffer(this.handle), this.handle = null, this.depth && (this.depth.dispose(), this.depth = null), this._depth_rb && (t.deleteRenderbuffer(this._depth_rb), this._depth_rb = null);

          for (var e = 0; e < this.color.length; ++e) {
            this.color[e].dispose(), this.color[e] = null;
          }

          this._color_rb && (t.deleteRenderbuffer(this._color_rb), this._color_rb = null);
        }
      };
    }, {
      "gl-texture2d": 347
    }],
    268: [function (t, e, r) {
      var n = t("sprintf-js").sprintf,
          i = t("gl-constants/lookup"),
          a = t("glsl-shader-name"),
          o = t("add-line-numbers");

      e.exports = function (t, e, r) {
        "use strict";

        var s = a(e) || "of unknown name (see npm glsl-shader-name)",
            l = "unknown type";
        void 0 !== r && (l = r === i.FRAGMENT_SHADER ? "fragment" : "vertex");

        for (var c = n("Error compiling %s shader %s:\n", l, s), u = n("%s%s", c, t), f = t.split("\n"), h = {}, p = 0; p < f.length; p++) {
          var d = f[p];

          if ("" !== d && "\0" !== d) {
            var m = parseInt(d.split(":")[2]);
            if (isNaN(m)) throw new Error(n("Could not parse error: %s", d));
            h[m] = d;
          }
        }

        var g = o(e).split("\n");

        for (p = 0; p < g.length; p++) {
          if (h[p + 3] || h[p + 2] || h[p + 1]) {
            var v = g[p];

            if (c += v + "\n", h[p + 1]) {
              var y = h[p + 1];
              y = y.substr(y.split(":", 3).join(":").length + 1).trim(), c += n("^^^ %s\n\n", y);
            }
          }
        }

        return {
          long: c.trim(),
          short: u.trim()
        };
      };
    }, {
      "add-line-numbers": 67,
      "gl-constants/lookup": 263,
      "glsl-shader-name": 425,
      "sprintf-js": 560
    }],
    269: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        var r = t.gl,
            n = o(r, l.vertex, l.fragment),
            i = o(r, l.pickVertex, l.pickFragment),
            a = s(r),
            u = s(r),
            f = s(r),
            h = s(r),
            p = new c(t, n, i, a, u, f, h);
        return p.update(e), t.addObject(p), p;
      };

      var n = t("binary-search-bounds"),
          i = t("iota-array"),
          a = t("typedarray-pool"),
          o = t("gl-shader"),
          s = t("gl-buffer"),
          l = t("./lib/shaders");

      function c(t, e, r, n, i, a, o) {
        this.plot = t, this.shader = e, this.pickShader = r, this.positionBuffer = n, this.weightBuffer = i, this.colorBuffer = a, this.idBuffer = o, this.xData = [], this.yData = [], this.shape = [0, 0], this.bounds = [1 / 0, 1 / 0, -1 / 0, -1 / 0], this.pickOffset = 0;
      }

      var u,
          f = c.prototype,
          h = [0, 0, 1, 0, 0, 1, 1, 0, 1, 1, 0, 1];
      f.draw = (u = [1, 0, 0, 0, 1, 0, 0, 0, 1], function () {
        var t = this.plot,
            e = this.shader,
            r = this.bounds,
            n = this.numVertices;

        if (!(n <= 0)) {
          var i = t.gl,
              a = t.dataBox,
              o = r[2] - r[0],
              s = r[3] - r[1],
              l = a[2] - a[0],
              c = a[3] - a[1];
          u[0] = 2 * o / l, u[4] = 2 * s / c, u[6] = 2 * (r[0] - a[0]) / l - 1, u[7] = 2 * (r[1] - a[1]) / c - 1, e.bind();
          var f = e.uniforms;
          f.viewTransform = u, f.shape = this.shape;
          var h = e.attributes;
          this.positionBuffer.bind(), h.position.pointer(), this.weightBuffer.bind(), h.weight.pointer(i.UNSIGNED_BYTE, !1), this.colorBuffer.bind(), h.color.pointer(i.UNSIGNED_BYTE, !0), i.drawArrays(i.TRIANGLES, 0, n);
        }
      }), f.drawPick = function () {
        var t = [1, 0, 0, 0, 1, 0, 0, 0, 1],
            e = [0, 0, 0, 0];
        return function (r) {
          var n = this.plot,
              i = this.pickShader,
              a = this.bounds,
              o = this.numVertices;

          if (!(o <= 0)) {
            var s = n.gl,
                l = n.dataBox,
                c = a[2] - a[0],
                u = a[3] - a[1],
                f = l[2] - l[0],
                h = l[3] - l[1];
            t[0] = 2 * c / f, t[4] = 2 * u / h, t[6] = 2 * (a[0] - l[0]) / f - 1, t[7] = 2 * (a[1] - l[1]) / h - 1;

            for (var p = 0; p < 4; ++p) {
              e[p] = r >> 8 * p & 255;
            }

            this.pickOffset = r, i.bind();
            var d = i.uniforms;
            d.viewTransform = t, d.pickOffset = e, d.shape = this.shape;
            var m = i.attributes;
            return this.positionBuffer.bind(), m.position.pointer(), this.weightBuffer.bind(), m.weight.pointer(s.UNSIGNED_BYTE, !1), this.idBuffer.bind(), m.pickId.pointer(s.UNSIGNED_BYTE, !1), s.drawArrays(s.TRIANGLES, 0, o), r + this.shape[0] * this.shape[1];
          }
        };
      }(), f.pick = function (t, e, r) {
        var n = this.pickOffset,
            i = this.shape[0] * this.shape[1];
        if (r < n || r >= n + i) return null;
        var a = r - n,
            o = this.xData,
            s = this.yData;
        return {
          object: this,
          pointId: a,
          dataCoord: [o[a % this.shape[0]], s[a / this.shape[0] | 0]]
        };
      }, f.update = function (t) {
        var e = (t = t || {}).shape || [0, 0],
            r = t.x || i(e[0]),
            o = t.y || i(e[1]),
            s = t.z || new Float32Array(e[0] * e[1]),
            l = !1 !== t.zsmooth;
        this.xData = r, this.yData = o;
        var c,
            u,
            f,
            p,
            d = t.colorLevels || [0],
            m = t.colorValues || [0, 0, 0, 1],
            g = d.length,
            v = this.bounds;
        l ? (c = v[0] = r[0], u = v[1] = o[0], f = v[2] = r[r.length - 1], p = v[3] = o[o.length - 1]) : (c = v[0] = r[0] + (r[1] - r[0]) / 2, u = v[1] = o[0] + (o[1] - o[0]) / 2, f = v[2] = r[r.length - 1] + (r[r.length - 1] - r[r.length - 2]) / 2, p = v[3] = o[o.length - 1] + (o[o.length - 1] - o[o.length - 2]) / 2);
        var y = 1 / (f - c),
            x = 1 / (p - u),
            b = e[0],
            _ = e[1];
        this.shape = [b, _];
        var w = (l ? (b - 1) * (_ - 1) : b * _) * (h.length >>> 1);
        this.numVertices = w;

        for (var T = a.mallocUint8(4 * w), k = a.mallocFloat32(2 * w), M = a.mallocUint8(2 * w), A = a.mallocUint32(w), S = 0, E = l ? b - 1 : b, L = l ? _ - 1 : _, C = 0; C < L; ++C) {
          var P, I;
          l ? (P = x * (o[C] - u), I = x * (o[C + 1] - u)) : (P = C < _ - 1 ? x * (o[C] - (o[C + 1] - o[C]) / 2 - u) : x * (o[C] - (o[C] - o[C - 1]) / 2 - u), I = C < _ - 1 ? x * (o[C] + (o[C + 1] - o[C]) / 2 - u) : x * (o[C] + (o[C] - o[C - 1]) / 2 - u));

          for (var O = 0; O < E; ++O) {
            var z, D;
            l ? (z = y * (r[O] - c), D = y * (r[O + 1] - c)) : (z = O < b - 1 ? y * (r[O] - (r[O + 1] - r[O]) / 2 - c) : y * (r[O] - (r[O] - r[O - 1]) / 2 - c), D = O < b - 1 ? y * (r[O] + (r[O + 1] - r[O]) / 2 - c) : y * (r[O] + (r[O] - r[O - 1]) / 2 - c));

            for (var R = 0; R < h.length; R += 2) {
              var F,
                  B,
                  N,
                  j,
                  U = h[R],
                  V = h[R + 1],
                  q = s[l ? (C + V) * b + (O + U) : C * b + O],
                  H = n.le(d, q);
              if (H < 0) F = m[0], B = m[1], N = m[2], j = m[3];else if (H === g - 1) F = m[4 * g - 4], B = m[4 * g - 3], N = m[4 * g - 2], j = m[4 * g - 1];else {
                var G = (q - d[H]) / (d[H + 1] - d[H]),
                    Y = 1 - G,
                    W = 4 * H,
                    X = 4 * (H + 1);
                F = Y * m[W] + G * m[X], B = Y * m[W + 1] + G * m[X + 1], N = Y * m[W + 2] + G * m[X + 2], j = Y * m[W + 3] + G * m[X + 3];
              }
              T[4 * S] = 255 * F, T[4 * S + 1] = 255 * B, T[4 * S + 2] = 255 * N, T[4 * S + 3] = 255 * j, k[2 * S] = .5 * z + .5 * D, k[2 * S + 1] = .5 * P + .5 * I, M[2 * S] = U, M[2 * S + 1] = V, A[S] = C * b + O, S += 1;
            }
          }
        }

        this.positionBuffer.update(k), this.weightBuffer.update(M), this.colorBuffer.update(T), this.idBuffer.update(A), a.free(k), a.free(T), a.free(M), a.free(A);
      }, f.dispose = function () {
        this.shader.dispose(), this.pickShader.dispose(), this.positionBuffer.dispose(), this.weightBuffer.dispose(), this.colorBuffer.dispose(), this.idBuffer.dispose(), this.plot.removeObject(this);
      };
    }, {
      "./lib/shaders": 270,
      "binary-search-bounds": 98,
      "gl-buffer": 258,
      "gl-shader": 330,
      "iota-array": 442,
      "typedarray-pool": 609
    }],
    270: [function (t, e, r) {
      "use strict";

      var n = t("glslify");
      e.exports = {
        fragment: n(["precision lowp float;\n#define GLSLIFY 1\nvarying vec4 fragColor;\nvoid main() {\n  gl_FragColor = vec4(fragColor.rgb * fragColor.a, fragColor.a);\n}\n"]),
        vertex: n(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\nattribute vec4 color;\nattribute vec2 weight;\n\nuniform vec2 shape;\nuniform mat3 viewTransform;\n\nvarying vec4 fragColor;\n\nvoid main() {\n  vec3 vPosition = viewTransform * vec3( position + (weight-.5)/(shape-1.) , 1.0);\n  fragColor = color;\n  gl_Position = vec4(vPosition.xy, 0, vPosition.z);\n}\n"]),
        pickFragment: n(["precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 fragId;\nvarying vec2 vWeight;\n\nuniform vec2 shape;\nuniform vec4 pickOffset;\n\nvoid main() {\n  vec2 d = step(.5, vWeight);\n  vec4 id = fragId + pickOffset;\n  id.x += d.x + d.y*shape.x;\n\n  id.y += floor(id.x / 256.0);\n  id.x -= floor(id.x / 256.0) * 256.0;\n\n  id.z += floor(id.y / 256.0);\n  id.y -= floor(id.y / 256.0) * 256.0;\n\n  id.w += floor(id.z / 256.0);\n  id.z -= floor(id.z / 256.0) * 256.0;\n\n  gl_FragColor = id/255.;\n}\n"]),
        pickVertex: n(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\nattribute vec4 pickId;\nattribute vec2 weight;\n\nuniform vec2 shape;\nuniform mat3 viewTransform;\n\nvarying vec4 fragId;\nvarying vec2 vWeight;\n\nvoid main() {\n  vWeight = weight;\n\n  fragId = pickId;\n\n  vec3 vPosition = viewTransform * vec3( position + (weight-.5)/(shape-1.) , 1.0);\n  gl_Position = vec4(vPosition.xy, 0, vPosition.z);\n}\n"])
      };
    }, {
      glslify: 433
    }],
    271: [function (t, e, r) {
      var n = t("glslify"),
          i = t("gl-shader"),
          a = n(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, nextPosition;\nattribute float arcLength, lineWidth;\nattribute vec4 color;\n\nuniform vec2 screenShape;\nuniform float pixelRatio;\nuniform mat4 model, view, projection;\n\nvarying vec4 fragColor;\nvarying vec3 worldPosition;\nvarying float pixelArcLength;\n\nvec4 project(vec3 p) {\n  return projection * view * model * vec4(p, 1.0);\n}\n\nvoid main() {\n  vec4 startPoint = project(position);\n  vec4 endPoint   = project(nextPosition);\n\n  vec2 A = startPoint.xy / startPoint.w;\n  vec2 B =   endPoint.xy /   endPoint.w;\n\n  float clipAngle = atan(\n    (B.y - A.y) * screenShape.y,\n    (B.x - A.x) * screenShape.x\n  );\n\n  vec2 offset = 0.5 * pixelRatio * lineWidth * vec2(\n    sin(clipAngle),\n    -cos(clipAngle)\n  ) / screenShape;\n\n  gl_Position = vec4(startPoint.xy + startPoint.w * offset, startPoint.zw);\n\n  worldPosition = position;\n  pixelArcLength = arcLength;\n  fragColor = color;\n}\n"]),
          o = n(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3      clipBounds[2];\nuniform sampler2D dashTexture;\nuniform float     dashScale;\nuniform float     opacity;\n\nvarying vec3    worldPosition;\nvarying float   pixelArcLength;\nvarying vec4    fragColor;\n\nvoid main() {\n  if (\n    outOfRange(clipBounds[0], clipBounds[1], worldPosition) ||\n    fragColor.a * opacity == 0.\n  ) discard;\n\n  float dashWeight = texture2D(dashTexture, vec2(dashScale * pixelArcLength, 0)).r;\n  if(dashWeight < 0.5) {\n    discard;\n  }\n  gl_FragColor = fragColor * opacity;\n}\n"]),
          s = n(["precision highp float;\n#define GLSLIFY 1\n\n#define FLOAT_MAX  1.70141184e38\n#define FLOAT_MIN  1.17549435e-38\n\n// https://github.com/mikolalysenko/glsl-read-float/blob/master/index.glsl\nvec4 packFloat(float v) {\n  float av = abs(v);\n\n  //Handle special cases\n  if(av < FLOAT_MIN) {\n    return vec4(0.0, 0.0, 0.0, 0.0);\n  } else if(v > FLOAT_MAX) {\n    return vec4(127.0, 128.0, 0.0, 0.0) / 255.0;\n  } else if(v < -FLOAT_MAX) {\n    return vec4(255.0, 128.0, 0.0, 0.0) / 255.0;\n  }\n\n  vec4 c = vec4(0,0,0,0);\n\n  //Compute exponent and mantissa\n  float e = floor(log2(av));\n  float m = av * pow(2.0, -e) - 1.0;\n\n  //Unpack mantissa\n  c[1] = floor(128.0 * m);\n  m -= c[1] / 128.0;\n  c[2] = floor(32768.0 * m);\n  m -= c[2] / 32768.0;\n  c[3] = floor(8388608.0 * m);\n\n  //Unpack exponent\n  float ebias = e + 127.0;\n  c[0] = floor(ebias / 2.0);\n  ebias -= c[0] * 2.0;\n  c[1] += floor(ebias) * 128.0;\n\n  //Unpack sign bit\n  c[0] += 128.0 * step(0.0, -v);\n\n  //Scale back to range\n  return c / 255.0;\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform float pickId;\nuniform vec3 clipBounds[2];\n\nvarying vec3 worldPosition;\nvarying float pixelArcLength;\nvarying vec4 fragColor;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], worldPosition)) discard;\n\n  gl_FragColor = vec4(pickId/255.0, packFloat(pixelArcLength).xyz);\n}"]),
          l = [{
        name: "position",
        type: "vec3"
      }, {
        name: "nextPosition",
        type: "vec3"
      }, {
        name: "arcLength",
        type: "float"
      }, {
        name: "lineWidth",
        type: "float"
      }, {
        name: "color",
        type: "vec4"
      }];
      r.createShader = function (t) {
        return i(t, a, o, null, l);
      }, r.createPickShader = function (t) {
        return i(t, a, s, null, l);
      };
    }, {
      "gl-shader": 330,
      glslify: 273
    }],
    272: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        var e = t.gl || t.scene && t.scene.gl,
            r = f(e);
        r.attributes.position.location = 0, r.attributes.nextPosition.location = 1, r.attributes.arcLength.location = 2, r.attributes.lineWidth.location = 3, r.attributes.color.location = 4;
        var o = h(e);
        o.attributes.position.location = 0, o.attributes.nextPosition.location = 1, o.attributes.arcLength.location = 2, o.attributes.lineWidth.location = 3, o.attributes.color.location = 4;

        for (var s = n(e), l = i(e, [{
          buffer: s,
          size: 3,
          offset: 0,
          stride: 48
        }, {
          buffer: s,
          size: 3,
          offset: 12,
          stride: 48
        }, {
          buffer: s,
          size: 1,
          offset: 24,
          stride: 48
        }, {
          buffer: s,
          size: 1,
          offset: 28,
          stride: 48
        }, {
          buffer: s,
          size: 4,
          offset: 32,
          stride: 48
        }]), u = c(new Array(1024), [256, 1, 4]), p = 0; p < 1024; ++p) {
          u.data[p] = 255;
        }

        var d = a(e, u);
        d.wrap = e.REPEAT;
        var m = new v(e, r, o, s, l, d);
        return m.update(t), m;
      };

      var n = t("gl-buffer"),
          i = t("gl-vao"),
          a = t("gl-texture2d"),
          o = new Uint8Array(4),
          s = new Float32Array(o.buffer);
      var l = t("binary-search-bounds"),
          c = t("ndarray"),
          u = t("./lib/shaders"),
          f = u.createShader,
          h = u.createPickShader,
          p = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];

      function d(t, e) {
        for (var r = 0, n = 0; n < 3; ++n) {
          var i = t[n] - e[n];
          r += i * i;
        }

        return Math.sqrt(r);
      }

      function m(t) {
        for (var e = [[-1e6, -1e6, -1e6], [1e6, 1e6, 1e6]], r = 0; r < 3; ++r) {
          e[0][r] = Math.max(t[0][r], e[0][r]), e[1][r] = Math.min(t[1][r], e[1][r]);
        }

        return e;
      }

      function g(t, e, r, n) {
        this.arcLength = t, this.position = e, this.index = r, this.dataCoordinate = n;
      }

      function v(t, e, r, n, i, a) {
        this.gl = t, this.shader = e, this.pickShader = r, this.buffer = n, this.vao = i, this.clipBounds = [[-1 / 0, -1 / 0, -1 / 0], [1 / 0, 1 / 0, 1 / 0]], this.points = [], this.arcLength = [], this.vertexCount = 0, this.bounds = [[0, 0, 0], [0, 0, 0]], this.pickId = 0, this.lineWidth = 1, this.texture = a, this.dashScale = 1, this.opacity = 1, this.hasAlpha = !1, this.dirty = !0, this.pixelRatio = 1;
      }

      var y = v.prototype;
      y.isTransparent = function () {
        return this.hasAlpha;
      }, y.isOpaque = function () {
        return !this.hasAlpha;
      }, y.pickSlots = 1, y.setPickBase = function (t) {
        this.pickId = t;
      }, y.drawTransparent = y.draw = function (t) {
        if (this.vertexCount) {
          var e = this.gl,
              r = this.shader,
              n = this.vao;
          r.bind(), r.uniforms = {
            model: t.model || p,
            view: t.view || p,
            projection: t.projection || p,
            clipBounds: m(this.clipBounds),
            dashTexture: this.texture.bind(),
            dashScale: this.dashScale / this.arcLength[this.arcLength.length - 1],
            opacity: this.opacity,
            screenShape: [e.drawingBufferWidth, e.drawingBufferHeight],
            pixelRatio: this.pixelRatio
          }, n.bind(), n.draw(e.TRIANGLE_STRIP, this.vertexCount), n.unbind();
        }
      }, y.drawPick = function (t) {
        if (this.vertexCount) {
          var e = this.gl,
              r = this.pickShader,
              n = this.vao;
          r.bind(), r.uniforms = {
            model: t.model || p,
            view: t.view || p,
            projection: t.projection || p,
            pickId: this.pickId,
            clipBounds: m(this.clipBounds),
            screenShape: [e.drawingBufferWidth, e.drawingBufferHeight],
            pixelRatio: this.pixelRatio
          }, n.bind(), n.draw(e.TRIANGLE_STRIP, this.vertexCount), n.unbind();
        }
      }, y.update = function (t) {
        var e, r;
        this.dirty = !0;
        var n = !!t.connectGaps;
        "dashScale" in t && (this.dashScale = t.dashScale), this.hasAlpha = !1, "opacity" in t && (this.opacity = +t.opacity, this.opacity < 1 && (this.hasAlpha = !0));
        var i = [],
            a = [],
            o = [],
            s = 0,
            u = 0,
            f = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]],
            h = t.position || t.positions;

        if (h) {
          var p = t.color || t.colors || [0, 0, 0, 1],
              m = t.lineWidth || 1,
              g = !1;

          t: for (e = 1; e < h.length; ++e) {
            var v,
                y,
                x,
                b = h[e - 1],
                _ = h[e];

            for (a.push(s), o.push(b.slice()), r = 0; r < 3; ++r) {
              if (isNaN(b[r]) || isNaN(_[r]) || !isFinite(b[r]) || !isFinite(_[r])) {
                if (!n && i.length > 0) {
                  for (var w = 0; w < 24; ++w) {
                    i.push(i[i.length - 12]);
                  }

                  u += 2, g = !0;
                }

                continue t;
              }

              f[0][r] = Math.min(f[0][r], b[r], _[r]), f[1][r] = Math.max(f[1][r], b[r], _[r]);
            }

            Array.isArray(p[0]) ? (v = p.length > e - 1 ? p[e - 1] : p.length > 0 ? p[p.length - 1] : [0, 0, 0, 1], y = p.length > e ? p[e] : p.length > 0 ? p[p.length - 1] : [0, 0, 0, 1]) : v = y = p, 3 === v.length && (v = [v[0], v[1], v[2], 1]), 3 === y.length && (y = [y[0], y[1], y[2], 1]), !this.hasAlpha && v[3] < 1 && (this.hasAlpha = !0), x = Array.isArray(m) ? m.length > e - 1 ? m[e - 1] : m.length > 0 ? m[m.length - 1] : [0, 0, 0, 1] : m;
            var T = s;

            if (s += d(b, _), g) {
              for (r = 0; r < 2; ++r) {
                i.push(b[0], b[1], b[2], _[0], _[1], _[2], T, x, v[0], v[1], v[2], v[3]);
              }

              u += 2, g = !1;
            }

            i.push(b[0], b[1], b[2], _[0], _[1], _[2], T, x, v[0], v[1], v[2], v[3], b[0], b[1], b[2], _[0], _[1], _[2], T, -x, v[0], v[1], v[2], v[3], _[0], _[1], _[2], b[0], b[1], b[2], s, -x, y[0], y[1], y[2], y[3], _[0], _[1], _[2], b[0], b[1], b[2], s, x, y[0], y[1], y[2], y[3]), u += 4;
          }
        }

        if (this.buffer.update(i), a.push(s), o.push(h[h.length - 1].slice()), this.bounds = f, this.vertexCount = u, this.points = o, this.arcLength = a, "dashes" in t) {
          var k = t.dashes.slice();

          for (k.unshift(0), e = 1; e < k.length; ++e) {
            k[e] = k[e - 1] + k[e];
          }

          var M = c(new Array(1024), [256, 1, 4]);

          for (e = 0; e < 256; ++e) {
            for (r = 0; r < 4; ++r) {
              M.set(e, 0, r, 0);
            }

            1 & l.le(k, k[k.length - 1] * e / 255) ? M.set(e, 0, 0, 0) : M.set(e, 0, 0, 255);
          }

          this.texture.setPixels(M);
        }
      }, y.dispose = function () {
        this.shader.dispose(), this.vao.dispose(), this.buffer.dispose();
      }, y.pick = function (t) {
        if (!t) return null;
        if (t.id !== this.pickId) return null;

        var e = function (t, e, r, n) {
          return o[0] = n, o[1] = r, o[2] = e, o[3] = t, s[0];
        }(t.value[0], t.value[1], t.value[2], 0),
            r = l.le(this.arcLength, e);

        if (r < 0) return null;
        if (r === this.arcLength.length - 1) return new g(this.arcLength[this.arcLength.length - 1], this.points[this.points.length - 1].slice(), r);

        for (var n = this.points[r], i = this.points[Math.min(r + 1, this.points.length - 1)], a = (e - this.arcLength[r]) / (this.arcLength[r + 1] - this.arcLength[r]), c = 1 - a, u = [0, 0, 0], f = 0; f < 3; ++f) {
          u[f] = c * n[f] + a * i[f];
        }

        var h = Math.min(a < .5 ? r : r + 1, this.points.length - 1);
        return new g(e, u, h, this.points[h]);
      };
    }, {
      "./lib/shaders": 271,
      "binary-search-bounds": 98,
      "gl-buffer": 258,
      "gl-texture2d": 347,
      "gl-vao": 352,
      ndarray: 475
    }],
    273: [function (t, e, r) {
      arguments[4][256][0].apply(r, arguments);
    }, {
      dup: 256
    }],
    274: [function (t, e, r) {
      e.exports = function (t, e) {
        var r = e[0],
            n = e[1],
            i = e[2],
            a = e[3],
            o = e[4],
            s = e[5],
            l = e[6],
            c = e[7],
            u = e[8],
            f = e[9],
            h = e[10],
            p = e[11],
            d = e[12],
            m = e[13],
            g = e[14],
            v = e[15];
        return t[0] = s * (h * v - p * g) - f * (l * v - c * g) + m * (l * p - c * h), t[1] = -(n * (h * v - p * g) - f * (i * v - a * g) + m * (i * p - a * h)), t[2] = n * (l * v - c * g) - s * (i * v - a * g) + m * (i * c - a * l), t[3] = -(n * (l * p - c * h) - s * (i * p - a * h) + f * (i * c - a * l)), t[4] = -(o * (h * v - p * g) - u * (l * v - c * g) + d * (l * p - c * h)), t[5] = r * (h * v - p * g) - u * (i * v - a * g) + d * (i * p - a * h), t[6] = -(r * (l * v - c * g) - o * (i * v - a * g) + d * (i * c - a * l)), t[7] = r * (l * p - c * h) - o * (i * p - a * h) + u * (i * c - a * l), t[8] = o * (f * v - p * m) - u * (s * v - c * m) + d * (s * p - c * f), t[9] = -(r * (f * v - p * m) - u * (n * v - a * m) + d * (n * p - a * f)), t[10] = r * (s * v - c * m) - o * (n * v - a * m) + d * (n * c - a * s), t[11] = -(r * (s * p - c * f) - o * (n * p - a * f) + u * (n * c - a * s)), t[12] = -(o * (f * g - h * m) - u * (s * g - l * m) + d * (s * h - l * f)), t[13] = r * (f * g - h * m) - u * (n * g - i * m) + d * (n * h - i * f), t[14] = -(r * (s * g - l * m) - o * (n * g - i * m) + d * (n * l - i * s)), t[15] = r * (s * h - l * f) - o * (n * h - i * f) + u * (n * l - i * s), t;
      };
    }, {}],
    275: [function (t, e, r) {
      e.exports = function (t) {
        var e = new Float32Array(16);
        return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
      };
    }, {}],
    276: [function (t, e, r) {
      e.exports = function (t, e) {
        return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
      };
    }, {}],
    277: [function (t, e, r) {
      e.exports = function () {
        var t = new Float32Array(16);
        return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
      };
    }, {}],
    278: [function (t, e, r) {
      e.exports = function (t) {
        var e = t[0],
            r = t[1],
            n = t[2],
            i = t[3],
            a = t[4],
            o = t[5],
            s = t[6],
            l = t[7],
            c = t[8],
            u = t[9],
            f = t[10],
            h = t[11],
            p = t[12],
            d = t[13],
            m = t[14],
            g = t[15];
        return (e * o - r * a) * (f * g - h * m) - (e * s - n * a) * (u * g - h * d) + (e * l - i * a) * (u * m - f * d) + (r * s - n * o) * (c * g - h * p) - (r * l - i * o) * (c * m - f * p) + (n * l - i * s) * (c * d - u * p);
      };
    }, {}],
    279: [function (t, e, r) {
      e.exports = function (t, e) {
        var r = e[0],
            n = e[1],
            i = e[2],
            a = e[3],
            o = r + r,
            s = n + n,
            l = i + i,
            c = r * o,
            u = n * o,
            f = n * s,
            h = i * o,
            p = i * s,
            d = i * l,
            m = a * o,
            g = a * s,
            v = a * l;
        return t[0] = 1 - f - d, t[1] = u + v, t[2] = h - g, t[3] = 0, t[4] = u - v, t[5] = 1 - c - d, t[6] = p + m, t[7] = 0, t[8] = h + g, t[9] = p - m, t[10] = 1 - c - f, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
      };
    }, {}],
    280: [function (t, e, r) {
      e.exports = function (t, e, r) {
        var n,
            i,
            a,
            o = r[0],
            s = r[1],
            l = r[2],
            c = Math.sqrt(o * o + s * s + l * l);
        if (Math.abs(c) < 1e-6) return null;
        return o *= c = 1 / c, s *= c, l *= c, n = Math.sin(e), i = Math.cos(e), a = 1 - i, t[0] = o * o * a + i, t[1] = s * o * a + l * n, t[2] = l * o * a - s * n, t[3] = 0, t[4] = o * s * a - l * n, t[5] = s * s * a + i, t[6] = l * s * a + o * n, t[7] = 0, t[8] = o * l * a + s * n, t[9] = s * l * a - o * n, t[10] = l * l * a + i, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
      };
    }, {}],
    281: [function (t, e, r) {
      e.exports = function (t, e, r) {
        var n = e[0],
            i = e[1],
            a = e[2],
            o = e[3],
            s = n + n,
            l = i + i,
            c = a + a,
            u = n * s,
            f = n * l,
            h = n * c,
            p = i * l,
            d = i * c,
            m = a * c,
            g = o * s,
            v = o * l,
            y = o * c;
        return t[0] = 1 - (p + m), t[1] = f + y, t[2] = h - v, t[3] = 0, t[4] = f - y, t[5] = 1 - (u + m), t[6] = d + g, t[7] = 0, t[8] = h + v, t[9] = d - g, t[10] = 1 - (u + p), t[11] = 0, t[12] = r[0], t[13] = r[1], t[14] = r[2], t[15] = 1, t;
      };
    }, {}],
    282: [function (t, e, r) {
      e.exports = function (t, e) {
        return t[0] = e[0], t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = e[1], t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = e[2], t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
      };
    }, {}],
    283: [function (t, e, r) {
      e.exports = function (t, e) {
        return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = e[0], t[13] = e[1], t[14] = e[2], t[15] = 1, t;
      };
    }, {}],
    284: [function (t, e, r) {
      e.exports = function (t, e) {
        var r = Math.sin(e),
            n = Math.cos(e);
        return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = n, t[6] = r, t[7] = 0, t[8] = 0, t[9] = -r, t[10] = n, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
      };
    }, {}],
    285: [function (t, e, r) {
      e.exports = function (t, e) {
        var r = Math.sin(e),
            n = Math.cos(e);
        return t[0] = n, t[1] = 0, t[2] = -r, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = r, t[9] = 0, t[10] = n, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
      };
    }, {}],
    286: [function (t, e, r) {
      e.exports = function (t, e) {
        var r = Math.sin(e),
            n = Math.cos(e);
        return t[0] = n, t[1] = r, t[2] = 0, t[3] = 0, t[4] = -r, t[5] = n, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
      };
    }, {}],
    287: [function (t, e, r) {
      e.exports = function (t, e, r, n, i, a, o) {
        var s = 1 / (r - e),
            l = 1 / (i - n),
            c = 1 / (a - o);
        return t[0] = 2 * a * s, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 2 * a * l, t[6] = 0, t[7] = 0, t[8] = (r + e) * s, t[9] = (i + n) * l, t[10] = (o + a) * c, t[11] = -1, t[12] = 0, t[13] = 0, t[14] = o * a * 2 * c, t[15] = 0, t;
      };
    }, {}],
    288: [function (t, e, r) {
      e.exports = function (t) {
        return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
      };
    }, {}],
    289: [function (t, e, r) {
      e.exports = {
        create: t("./create"),
        clone: t("./clone"),
        copy: t("./copy"),
        identity: t("./identity"),
        transpose: t("./transpose"),
        invert: t("./invert"),
        adjoint: t("./adjoint"),
        determinant: t("./determinant"),
        multiply: t("./multiply"),
        translate: t("./translate"),
        scale: t("./scale"),
        rotate: t("./rotate"),
        rotateX: t("./rotateX"),
        rotateY: t("./rotateY"),
        rotateZ: t("./rotateZ"),
        fromRotation: t("./fromRotation"),
        fromRotationTranslation: t("./fromRotationTranslation"),
        fromScaling: t("./fromScaling"),
        fromTranslation: t("./fromTranslation"),
        fromXRotation: t("./fromXRotation"),
        fromYRotation: t("./fromYRotation"),
        fromZRotation: t("./fromZRotation"),
        fromQuat: t("./fromQuat"),
        frustum: t("./frustum"),
        perspective: t("./perspective"),
        perspectiveFromFieldOfView: t("./perspectiveFromFieldOfView"),
        ortho: t("./ortho"),
        lookAt: t("./lookAt"),
        str: t("./str")
      };
    }, {
      "./adjoint": 274,
      "./clone": 275,
      "./copy": 276,
      "./create": 277,
      "./determinant": 278,
      "./fromQuat": 279,
      "./fromRotation": 280,
      "./fromRotationTranslation": 281,
      "./fromScaling": 282,
      "./fromTranslation": 283,
      "./fromXRotation": 284,
      "./fromYRotation": 285,
      "./fromZRotation": 286,
      "./frustum": 287,
      "./identity": 288,
      "./invert": 290,
      "./lookAt": 291,
      "./multiply": 292,
      "./ortho": 293,
      "./perspective": 294,
      "./perspectiveFromFieldOfView": 295,
      "./rotate": 296,
      "./rotateX": 297,
      "./rotateY": 298,
      "./rotateZ": 299,
      "./scale": 300,
      "./str": 301,
      "./translate": 302,
      "./transpose": 303
    }],
    290: [function (t, e, r) {
      e.exports = function (t, e) {
        var r = e[0],
            n = e[1],
            i = e[2],
            a = e[3],
            o = e[4],
            s = e[5],
            l = e[6],
            c = e[7],
            u = e[8],
            f = e[9],
            h = e[10],
            p = e[11],
            d = e[12],
            m = e[13],
            g = e[14],
            v = e[15],
            y = r * s - n * o,
            x = r * l - i * o,
            b = r * c - a * o,
            _ = n * l - i * s,
            w = n * c - a * s,
            T = i * c - a * l,
            k = u * m - f * d,
            M = u * g - h * d,
            A = u * v - p * d,
            S = f * g - h * m,
            E = f * v - p * m,
            L = h * v - p * g,
            C = y * L - x * E + b * S + _ * A - w * M + T * k;

        if (!C) return null;
        return C = 1 / C, t[0] = (s * L - l * E + c * S) * C, t[1] = (i * E - n * L - a * S) * C, t[2] = (m * T - g * w + v * _) * C, t[3] = (h * w - f * T - p * _) * C, t[4] = (l * A - o * L - c * M) * C, t[5] = (r * L - i * A + a * M) * C, t[6] = (g * b - d * T - v * x) * C, t[7] = (u * T - h * b + p * x) * C, t[8] = (o * E - s * A + c * k) * C, t[9] = (n * A - r * E - a * k) * C, t[10] = (d * w - m * b + v * y) * C, t[11] = (f * b - u * w - p * y) * C, t[12] = (s * M - o * S - l * k) * C, t[13] = (r * S - n * M + i * k) * C, t[14] = (m * x - d * _ - g * y) * C, t[15] = (u * _ - f * x + h * y) * C, t;
      };
    }, {}],
    291: [function (t, e, r) {
      var n = t("./identity");

      e.exports = function (t, e, r, i) {
        var a,
            o,
            s,
            l,
            c,
            u,
            f,
            h,
            p,
            d,
            m = e[0],
            g = e[1],
            v = e[2],
            y = i[0],
            x = i[1],
            b = i[2],
            _ = r[0],
            w = r[1],
            T = r[2];
        if (Math.abs(m - _) < 1e-6 && Math.abs(g - w) < 1e-6 && Math.abs(v - T) < 1e-6) return n(t);
        f = m - _, h = g - w, p = v - T, d = 1 / Math.sqrt(f * f + h * h + p * p), a = x * (p *= d) - b * (h *= d), o = b * (f *= d) - y * p, s = y * h - x * f, (d = Math.sqrt(a * a + o * o + s * s)) ? (a *= d = 1 / d, o *= d, s *= d) : (a = 0, o = 0, s = 0);
        l = h * s - p * o, c = p * a - f * s, u = f * o - h * a, (d = Math.sqrt(l * l + c * c + u * u)) ? (l *= d = 1 / d, c *= d, u *= d) : (l = 0, c = 0, u = 0);
        return t[0] = a, t[1] = l, t[2] = f, t[3] = 0, t[4] = o, t[5] = c, t[6] = h, t[7] = 0, t[8] = s, t[9] = u, t[10] = p, t[11] = 0, t[12] = -(a * m + o * g + s * v), t[13] = -(l * m + c * g + u * v), t[14] = -(f * m + h * g + p * v), t[15] = 1, t;
      };
    }, {
      "./identity": 288
    }],
    292: [function (t, e, r) {
      e.exports = function (t, e, r) {
        var n = e[0],
            i = e[1],
            a = e[2],
            o = e[3],
            s = e[4],
            l = e[5],
            c = e[6],
            u = e[7],
            f = e[8],
            h = e[9],
            p = e[10],
            d = e[11],
            m = e[12],
            g = e[13],
            v = e[14],
            y = e[15],
            x = r[0],
            b = r[1],
            _ = r[2],
            w = r[3];
        return t[0] = x * n + b * s + _ * f + w * m, t[1] = x * i + b * l + _ * h + w * g, t[2] = x * a + b * c + _ * p + w * v, t[3] = x * o + b * u + _ * d + w * y, x = r[4], b = r[5], _ = r[6], w = r[7], t[4] = x * n + b * s + _ * f + w * m, t[5] = x * i + b * l + _ * h + w * g, t[6] = x * a + b * c + _ * p + w * v, t[7] = x * o + b * u + _ * d + w * y, x = r[8], b = r[9], _ = r[10], w = r[11], t[8] = x * n + b * s + _ * f + w * m, t[9] = x * i + b * l + _ * h + w * g, t[10] = x * a + b * c + _ * p + w * v, t[11] = x * o + b * u + _ * d + w * y, x = r[12], b = r[13], _ = r[14], w = r[15], t[12] = x * n + b * s + _ * f + w * m, t[13] = x * i + b * l + _ * h + w * g, t[14] = x * a + b * c + _ * p + w * v, t[15] = x * o + b * u + _ * d + w * y, t;
      };
    }, {}],
    293: [function (t, e, r) {
      e.exports = function (t, e, r, n, i, a, o) {
        var s = 1 / (e - r),
            l = 1 / (n - i),
            c = 1 / (a - o);
        return t[0] = -2 * s, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = -2 * l, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 2 * c, t[11] = 0, t[12] = (e + r) * s, t[13] = (i + n) * l, t[14] = (o + a) * c, t[15] = 1, t;
      };
    }, {}],
    294: [function (t, e, r) {
      e.exports = function (t, e, r, n, i) {
        var a = 1 / Math.tan(e / 2),
            o = 1 / (n - i);
        return t[0] = a / r, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = a, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = (i + n) * o, t[11] = -1, t[12] = 0, t[13] = 0, t[14] = 2 * i * n * o, t[15] = 0, t;
      };
    }, {}],
    295: [function (t, e, r) {
      e.exports = function (t, e, r, n) {
        var i = Math.tan(e.upDegrees * Math.PI / 180),
            a = Math.tan(e.downDegrees * Math.PI / 180),
            o = Math.tan(e.leftDegrees * Math.PI / 180),
            s = Math.tan(e.rightDegrees * Math.PI / 180),
            l = 2 / (o + s),
            c = 2 / (i + a);
        return t[0] = l, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = c, t[6] = 0, t[7] = 0, t[8] = -(o - s) * l * .5, t[9] = (i - a) * c * .5, t[10] = n / (r - n), t[11] = -1, t[12] = 0, t[13] = 0, t[14] = n * r / (r - n), t[15] = 0, t;
      };
    }, {}],
    296: [function (t, e, r) {
      e.exports = function (t, e, r, n) {
        var i,
            a,
            o,
            s,
            l,
            c,
            u,
            f,
            h,
            p,
            d,
            m,
            g,
            v,
            y,
            x,
            b,
            _,
            w,
            T,
            k,
            M,
            A,
            S,
            E = n[0],
            L = n[1],
            C = n[2],
            P = Math.sqrt(E * E + L * L + C * C);

        if (Math.abs(P) < 1e-6) return null;
        E *= P = 1 / P, L *= P, C *= P, i = Math.sin(r), a = Math.cos(r), o = 1 - a, s = e[0], l = e[1], c = e[2], u = e[3], f = e[4], h = e[5], p = e[6], d = e[7], m = e[8], g = e[9], v = e[10], y = e[11], x = E * E * o + a, b = L * E * o + C * i, _ = C * E * o - L * i, w = E * L * o - C * i, T = L * L * o + a, k = C * L * o + E * i, M = E * C * o + L * i, A = L * C * o - E * i, S = C * C * o + a, t[0] = s * x + f * b + m * _, t[1] = l * x + h * b + g * _, t[2] = c * x + p * b + v * _, t[3] = u * x + d * b + y * _, t[4] = s * w + f * T + m * k, t[5] = l * w + h * T + g * k, t[6] = c * w + p * T + v * k, t[7] = u * w + d * T + y * k, t[8] = s * M + f * A + m * S, t[9] = l * M + h * A + g * S, t[10] = c * M + p * A + v * S, t[11] = u * M + d * A + y * S, e !== t && (t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]);
        return t;
      };
    }, {}],
    297: [function (t, e, r) {
      e.exports = function (t, e, r) {
        var n = Math.sin(r),
            i = Math.cos(r),
            a = e[4],
            o = e[5],
            s = e[6],
            l = e[7],
            c = e[8],
            u = e[9],
            f = e[10],
            h = e[11];
        e !== t && (t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]);
        return t[4] = a * i + c * n, t[5] = o * i + u * n, t[6] = s * i + f * n, t[7] = l * i + h * n, t[8] = c * i - a * n, t[9] = u * i - o * n, t[10] = f * i - s * n, t[11] = h * i - l * n, t;
      };
    }, {}],
    298: [function (t, e, r) {
      e.exports = function (t, e, r) {
        var n = Math.sin(r),
            i = Math.cos(r),
            a = e[0],
            o = e[1],
            s = e[2],
            l = e[3],
            c = e[8],
            u = e[9],
            f = e[10],
            h = e[11];
        e !== t && (t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]);
        return t[0] = a * i - c * n, t[1] = o * i - u * n, t[2] = s * i - f * n, t[3] = l * i - h * n, t[8] = a * n + c * i, t[9] = o * n + u * i, t[10] = s * n + f * i, t[11] = l * n + h * i, t;
      };
    }, {}],
    299: [function (t, e, r) {
      e.exports = function (t, e, r) {
        var n = Math.sin(r),
            i = Math.cos(r),
            a = e[0],
            o = e[1],
            s = e[2],
            l = e[3],
            c = e[4],
            u = e[5],
            f = e[6],
            h = e[7];
        e !== t && (t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]);
        return t[0] = a * i + c * n, t[1] = o * i + u * n, t[2] = s * i + f * n, t[3] = l * i + h * n, t[4] = c * i - a * n, t[5] = u * i - o * n, t[6] = f * i - s * n, t[7] = h * i - l * n, t;
      };
    }, {}],
    300: [function (t, e, r) {
      e.exports = function (t, e, r) {
        var n = r[0],
            i = r[1],
            a = r[2];
        return t[0] = e[0] * n, t[1] = e[1] * n, t[2] = e[2] * n, t[3] = e[3] * n, t[4] = e[4] * i, t[5] = e[5] * i, t[6] = e[6] * i, t[7] = e[7] * i, t[8] = e[8] * a, t[9] = e[9] * a, t[10] = e[10] * a, t[11] = e[11] * a, t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
      };
    }, {}],
    301: [function (t, e, r) {
      e.exports = function (t) {
        return "mat4(" + t[0] + ", " + t[1] + ", " + t[2] + ", " + t[3] + ", " + t[4] + ", " + t[5] + ", " + t[6] + ", " + t[7] + ", " + t[8] + ", " + t[9] + ", " + t[10] + ", " + t[11] + ", " + t[12] + ", " + t[13] + ", " + t[14] + ", " + t[15] + ")";
      };
    }, {}],
    302: [function (t, e, r) {
      e.exports = function (t, e, r) {
        var n,
            i,
            a,
            o,
            s,
            l,
            c,
            u,
            f,
            h,
            p,
            d,
            m = r[0],
            g = r[1],
            v = r[2];
        e === t ? (t[12] = e[0] * m + e[4] * g + e[8] * v + e[12], t[13] = e[1] * m + e[5] * g + e[9] * v + e[13], t[14] = e[2] * m + e[6] * g + e[10] * v + e[14], t[15] = e[3] * m + e[7] * g + e[11] * v + e[15]) : (n = e[0], i = e[1], a = e[2], o = e[3], s = e[4], l = e[5], c = e[6], u = e[7], f = e[8], h = e[9], p = e[10], d = e[11], t[0] = n, t[1] = i, t[2] = a, t[3] = o, t[4] = s, t[5] = l, t[6] = c, t[7] = u, t[8] = f, t[9] = h, t[10] = p, t[11] = d, t[12] = n * m + s * g + f * v + e[12], t[13] = i * m + l * g + h * v + e[13], t[14] = a * m + c * g + p * v + e[14], t[15] = o * m + u * g + d * v + e[15]);
        return t;
      };
    }, {}],
    303: [function (t, e, r) {
      e.exports = function (t, e) {
        if (t === e) {
          var r = e[1],
              n = e[2],
              i = e[3],
              a = e[6],
              o = e[7],
              s = e[11];
          t[1] = e[4], t[2] = e[8], t[3] = e[12], t[4] = r, t[6] = e[9], t[7] = e[13], t[8] = n, t[9] = a, t[11] = e[14], t[12] = i, t[13] = o, t[14] = s;
        } else t[0] = e[0], t[1] = e[4], t[2] = e[8], t[3] = e[12], t[4] = e[1], t[5] = e[5], t[6] = e[9], t[7] = e[13], t[8] = e[2], t[9] = e[6], t[10] = e[10], t[11] = e[14], t[12] = e[3], t[13] = e[7], t[14] = e[11], t[15] = e[15];

        return t;
      };
    }, {}],
    304: [function (t, e, r) {
      "use strict";

      var n = t("barycentric"),
          i = t("polytope-closest-point/lib/closest_point_2d.js");

      function a(t, e) {
        for (var r = [0, 0, 0, 0], n = 0; n < 4; ++n) {
          for (var i = 0; i < 4; ++i) {
            r[i] += t[4 * n + i] * e[n];
          }
        }

        return r;
      }

      function o(t, e, r, n, i) {
        for (var o = a(n, a(r, a(e, [t[0], t[1], t[2], 1]))), s = 0; s < 3; ++s) {
          o[s] /= o[3];
        }

        return [.5 * i[0] * (1 + o[0]), .5 * i[1] * (1 - o[1])];
      }

      function s(t, e) {
        for (var r = [0, 0, 0], n = 0; n < t.length; ++n) {
          for (var i = t[n], a = e[n], o = 0; o < 3; ++o) {
            r[o] += a * i[o];
          }
        }

        return r;
      }

      e.exports = function (t, e, r, a, l, c) {
        if (1 === t.length) return [0, t[0].slice()];

        for (var u = new Array(t.length), f = 0; f < t.length; ++f) {
          u[f] = o(t[f], r, a, l, c);
        }

        var h = 0,
            p = 1 / 0;

        for (f = 0; f < u.length; ++f) {
          for (var d = 0, m = 0; m < 2; ++m) {
            d += Math.pow(u[f][m] - e[m], 2);
          }

          d < p && (p = d, h = f);
        }

        var g = function (t, e) {
          if (2 === t.length) {
            for (var r = 0, a = 0, o = 0; o < 2; ++o) {
              r += Math.pow(e[o] - t[0][o], 2), a += Math.pow(e[o] - t[1][o], 2);
            }

            return r = Math.sqrt(r), a = Math.sqrt(a), r + a < 1e-6 ? [1, 0] : [a / (r + a), r / (a + r)];
          }

          if (3 === t.length) {
            var s = [0, 0];
            return i(t[0], t[1], t[2], e, s), n(t, s);
          }

          return [];
        }(u, e),
            v = 0;

        for (f = 0; f < 3; ++f) {
          if (g[f] < -.001 || g[f] > 1.0001) return null;
          v += g[f];
        }

        if (Math.abs(v - 1) > .001) return null;
        return [h, s(t, g), g];
      };
    }, {
      barycentric: 80,
      "polytope-closest-point/lib/closest_point_2d.js": 504
    }],
    305: [function (t, e, r) {
      var n = t("glslify"),
          i = n(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, normal;\nattribute vec4 color;\nattribute vec2 uv;\n\nuniform mat4 model\n           , view\n           , projection\n           , inverseModel;\nuniform vec3 eyePosition\n           , lightPosition;\n\nvarying vec3 f_normal\n           , f_lightDirection\n           , f_eyeDirection\n           , f_data;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvec4 project(vec3 p) {\n  return projection * view * model * vec4(p, 1.0);\n}\n\nvoid main() {\n  gl_Position      = project(position);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * vec4(position , 1.0);\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal  = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  f_color          = color;\n  f_data           = position;\n  f_uv             = uv;\n}\n"]),
          a = n(["#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\n//#pragma glslify: beckmann = require(glsl-specular-beckmann) // used in gl-surface3d\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness\n            , fresnel\n            , kambient\n            , kdiffuse\n            , kspecular;\nuniform sampler2D texture;\n\nvarying vec3 f_normal\n           , f_lightDirection\n           , f_eyeDirection\n           , f_data;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (f_color.a == 0.0 ||\n    outOfRange(clipBounds[0], clipBounds[1], f_data)\n  ) discard;\n\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  //float specular = max(0.0, beckmann(L, V, N, roughness)); // used in gl-surface3d\n\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = vec4(f_color.rgb, 1.0) * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * f_color.a;\n}\n"]),
          o = n(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 uv;\n\nuniform mat4 model, view, projection;\n\nvarying vec4 f_color;\nvarying vec3 f_data;\nvarying vec2 f_uv;\n\nvoid main() {\n  gl_Position = projection * view * model * vec4(position, 1.0);\n  f_color = color;\n  f_data  = position;\n  f_uv    = uv;\n}"]),
          s = n(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform sampler2D texture;\nuniform float opacity;\n\nvarying vec4 f_color;\nvarying vec3 f_data;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_data)) discard;\n\n  gl_FragColor = f_color * texture2D(texture, f_uv) * opacity;\n}"]),
          l = n(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 uv;\nattribute float pointSize;\n\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0.0, 0.0 ,0.0 ,0.0);\n  } else {\n    gl_Position = projection * view * model * vec4(position, 1.0);\n  }\n  gl_PointSize = pointSize;\n  f_color = color;\n  f_uv = uv;\n}"]),
          c = n(["precision highp float;\n#define GLSLIFY 1\n\nuniform sampler2D texture;\nuniform float opacity;\n\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  vec2 pointR = gl_PointCoord.xy - vec2(0.5, 0.5);\n  if(dot(pointR, pointR) > 0.25) {\n    discard;\n  }\n  gl_FragColor = f_color * texture2D(texture, f_uv) * opacity;\n}"]),
          u = n(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  gl_Position = projection * view * model * vec4(position, 1.0);\n  f_id        = id;\n  f_position  = position;\n}"]),
          f = n(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"]),
          h = n(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3  position;\nattribute float pointSize;\nattribute vec4  id;\n\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0.0, 0.0, 0.0, 0.0);\n  } else {\n    gl_Position  = projection * view * model * vec4(position, 1.0);\n    gl_PointSize = pointSize;\n  }\n  f_id         = id;\n  f_position   = position;\n}"]),
          p = n(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\n\nvoid main() {\n  gl_Position = projection * view * model * vec4(position, 1.0);\n}"]),
          d = n(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec3 contourColor;\n\nvoid main() {\n  gl_FragColor = vec4(contourColor, 1.0);\n}\n"]);
      r.meshShader = {
        vertex: i,
        fragment: a,
        attributes: [{
          name: "position",
          type: "vec3"
        }, {
          name: "normal",
          type: "vec3"
        }, {
          name: "color",
          type: "vec4"
        }, {
          name: "uv",
          type: "vec2"
        }]
      }, r.wireShader = {
        vertex: o,
        fragment: s,
        attributes: [{
          name: "position",
          type: "vec3"
        }, {
          name: "color",
          type: "vec4"
        }, {
          name: "uv",
          type: "vec2"
        }]
      }, r.pointShader = {
        vertex: l,
        fragment: c,
        attributes: [{
          name: "position",
          type: "vec3"
        }, {
          name: "color",
          type: "vec4"
        }, {
          name: "uv",
          type: "vec2"
        }, {
          name: "pointSize",
          type: "float"
        }]
      }, r.pickShader = {
        vertex: u,
        fragment: f,
        attributes: [{
          name: "position",
          type: "vec3"
        }, {
          name: "id",
          type: "vec4"
        }]
      }, r.pointPickShader = {
        vertex: h,
        fragment: f,
        attributes: [{
          name: "position",
          type: "vec3"
        }, {
          name: "pointSize",
          type: "float"
        }, {
          name: "id",
          type: "vec4"
        }]
      }, r.contourShader = {
        vertex: p,
        fragment: d,
        attributes: [{
          name: "position",
          type: "vec3"
        }]
      };
    }, {
      glslify: 433
    }],
    306: [function (t, e, r) {
      "use strict";

      var n = t("gl-shader"),
          i = t("gl-buffer"),
          a = t("gl-vao"),
          o = t("gl-texture2d"),
          s = t("normals"),
          l = t("gl-mat4/multiply"),
          c = t("gl-mat4/invert"),
          u = t("ndarray"),
          f = t("colormap"),
          h = t("simplicial-complex-contour"),
          p = t("typedarray-pool"),
          d = t("./lib/shaders"),
          m = t("./lib/closest-point"),
          g = d.meshShader,
          v = d.wireShader,
          y = d.pointShader,
          x = d.pickShader,
          b = d.pointPickShader,
          _ = d.contourShader,
          w = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];

      function T(t, e, r, n, i, a, o, s, l, c, u, f, h, p, d, m, g, v, y, x, b, _, T, k, M, A, S) {
        this.gl = t, this.pixelRatio = 1, this.cells = [], this.positions = [], this.intensity = [], this.texture = e, this.dirty = !0, this.triShader = r, this.lineShader = n, this.pointShader = i, this.pickShader = a, this.pointPickShader = o, this.contourShader = s, this.trianglePositions = l, this.triangleColors = u, this.triangleNormals = h, this.triangleUVs = f, this.triangleIds = c, this.triangleVAO = p, this.triangleCount = 0, this.lineWidth = 1, this.edgePositions = d, this.edgeColors = g, this.edgeUVs = v, this.edgeIds = m, this.edgeVAO = y, this.edgeCount = 0, this.pointPositions = x, this.pointColors = _, this.pointUVs = T, this.pointSizes = k, this.pointIds = b, this.pointVAO = M, this.pointCount = 0, this.contourLineWidth = 1, this.contourPositions = A, this.contourVAO = S, this.contourCount = 0, this.contourColor = [0, 0, 0], this.contourEnable = !0, this.pickVertex = !0, this.pickId = 1, this.bounds = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]], this.clipBounds = [[-1 / 0, -1 / 0, -1 / 0], [1 / 0, 1 / 0, 1 / 0]], this.lightPosition = [1e5, 1e5, 0], this.ambientLight = .8, this.diffuseLight = .8, this.specularLight = 2, this.roughness = .5, this.fresnel = 1.5, this.opacity = 1, this.hasAlpha = !1, this.opacityscale = !1, this._model = w, this._view = w, this._projection = w, this._resolution = [1, 1];
      }

      var k = T.prototype;

      function M(t, e) {
        if (!e) return 1;
        if (!e.length) return 1;

        for (var r = 0; r < e.length; ++r) {
          if (e.length < 2) return 1;
          if (e[r][0] === t) return e[r][1];

          if (e[r][0] > t && r > 0) {
            var n = (e[r][0] - t) / (e[r][0] - e[r - 1][0]);
            return e[r][1] * (1 - n) + n * e[r - 1][1];
          }
        }

        return 1;
      }

      function A(t) {
        var e = n(t, g.vertex, g.fragment);
        return e.attributes.position.location = 0, e.attributes.color.location = 2, e.attributes.uv.location = 3, e.attributes.normal.location = 4, e;
      }

      function S(t) {
        var e = n(t, v.vertex, v.fragment);
        return e.attributes.position.location = 0, e.attributes.color.location = 2, e.attributes.uv.location = 3, e;
      }

      function E(t) {
        var e = n(t, y.vertex, y.fragment);
        return e.attributes.position.location = 0, e.attributes.color.location = 2, e.attributes.uv.location = 3, e.attributes.pointSize.location = 4, e;
      }

      function L(t) {
        var e = n(t, x.vertex, x.fragment);
        return e.attributes.position.location = 0, e.attributes.id.location = 1, e;
      }

      function C(t) {
        var e = n(t, b.vertex, b.fragment);
        return e.attributes.position.location = 0, e.attributes.id.location = 1, e.attributes.pointSize.location = 4, e;
      }

      function P(t) {
        var e = n(t, _.vertex, _.fragment);
        return e.attributes.position.location = 0, e;
      }

      k.isOpaque = function () {
        return !this.hasAlpha;
      }, k.isTransparent = function () {
        return this.hasAlpha;
      }, k.pickSlots = 1, k.setPickBase = function (t) {
        this.pickId = t;
      }, k.highlight = function (t) {
        if (t && this.contourEnable) {
          for (var e = h(this.cells, this.intensity, t.intensity), r = e.cells, n = e.vertexIds, i = e.vertexWeights, a = r.length, o = p.mallocFloat32(6 * a), s = 0, l = 0; l < a; ++l) {
            for (var c = r[l], u = 0; u < 2; ++u) {
              var f = c[0];
              2 === c.length && (f = c[u]);

              for (var d = n[f][0], m = n[f][1], g = i[f], v = 1 - g, y = this.positions[d], x = this.positions[m], b = 0; b < 3; ++b) {
                o[s++] = g * y[b] + v * x[b];
              }
            }
          }

          this.contourCount = s / 3 | 0, this.contourPositions.update(o.subarray(0, s)), p.free(o);
        } else this.contourCount = 0;
      }, k.update = function (t) {
        t = t || {};
        var e = this.gl;
        this.dirty = !0, "contourEnable" in t && (this.contourEnable = t.contourEnable), "contourColor" in t && (this.contourColor = t.contourColor), "lineWidth" in t && (this.lineWidth = t.lineWidth), "lightPosition" in t && (this.lightPosition = t.lightPosition), this.hasAlpha = !1, "opacity" in t && (this.opacity = t.opacity, this.opacity < 1 && (this.hasAlpha = !0)), "opacityscale" in t && (this.opacityscale = t.opacityscale, this.hasAlpha = !0), "ambient" in t && (this.ambientLight = t.ambient), "diffuse" in t && (this.diffuseLight = t.diffuse), "specular" in t && (this.specularLight = t.specular), "roughness" in t && (this.roughness = t.roughness), "fresnel" in t && (this.fresnel = t.fresnel), t.texture ? (this.texture.dispose(), this.texture = o(e, t.texture)) : t.colormap && (this.texture.shape = [256, 256], this.texture.minFilter = e.LINEAR_MIPMAP_LINEAR, this.texture.magFilter = e.LINEAR, this.texture.setPixels(function (t, e) {
          for (var r = f({
            colormap: t,
            nshades: 256,
            format: "rgba"
          }), n = new Uint8Array(1024), i = 0; i < 256; ++i) {
            for (var a = r[i], o = 0; o < 3; ++o) {
              n[4 * i + o] = a[o];
            }

            n[4 * i + 3] = e ? 255 * M(i / 255, e) : 255 * a[3];
          }

          return u(n, [256, 256, 4], [4, 0, 1]);
        }(t.colormap, this.opacityscale)), this.texture.generateMipmap());
        var r = t.cells,
            n = t.positions;

        if (n && r) {
          var i = [],
              a = [],
              l = [],
              c = [],
              h = [],
              p = [],
              d = [],
              m = [],
              g = [],
              v = [],
              y = [],
              x = [],
              b = [],
              _ = [];
          this.cells = r, this.positions = n;
          var w = t.vertexNormals,
              T = t.cellNormals,
              k = void 0 === t.vertexNormalsEpsilon ? 1e-6 : t.vertexNormalsEpsilon,
              A = void 0 === t.faceNormalsEpsilon ? 1e-6 : t.faceNormalsEpsilon;
          t.useFacetNormals && !T && (T = s.faceNormals(r, n, A)), T || w || (w = s.vertexNormals(r, n, k));
          var S = t.vertexColors,
              E = t.cellColors,
              L = t.meshColor || [1, 1, 1, 1],
              C = t.vertexUVs,
              P = t.vertexIntensity,
              I = t.cellUVs,
              O = t.cellIntensity,
              z = 1 / 0,
              D = -1 / 0;
          if (!C && !I) if (P) {
            if (t.vertexIntensityBounds) z = +t.vertexIntensityBounds[0], D = +t.vertexIntensityBounds[1];else for (var R = 0; R < P.length; ++R) {
              var F = P[R];
              z = Math.min(z, F), D = Math.max(D, F);
            }
          } else if (O) {
            if (t.cellIntensityBounds) z = +t.cellIntensityBounds[0], D = +t.cellIntensityBounds[1];else for (R = 0; R < O.length; ++R) {
              F = O[R];
              z = Math.min(z, F), D = Math.max(D, F);
            }
          } else for (R = 0; R < n.length; ++R) {
            F = n[R][2];
            z = Math.min(z, F), D = Math.max(D, F);
          }
          this.intensity = P || O || function (t) {
            for (var e = t.length, r = new Array(e), n = 0; n < e; ++n) {
              r[n] = t[n][2];
            }

            return r;
          }(n), this.pickVertex = !(O || E);
          var B = t.pointSizes,
              N = t.pointSize || 1;
          this.bounds = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]];

          for (R = 0; R < n.length; ++R) {
            for (var j = n[R], U = 0; U < 3; ++U) {
              !isNaN(j[U]) && isFinite(j[U]) && (this.bounds[0][U] = Math.min(this.bounds[0][U], j[U]), this.bounds[1][U] = Math.max(this.bounds[1][U], j[U]));
            }
          }

          var V = 0,
              q = 0,
              H = 0;

          t: for (R = 0; R < r.length; ++R) {
            var G = r[R];

            switch (G.length) {
              case 1:
                for (j = n[W = G[0]], U = 0; U < 3; ++U) {
                  if (isNaN(j[U]) || !isFinite(j[U])) continue t;
                }

                v.push(j[0], j[1], j[2]), X = S ? S[W] : E ? E[R] : L, this.opacityscale && P ? a.push(X[0], X[1], X[2], this.opacity * M((P[W] - z) / (D - z), this.opacityscale)) : 3 === X.length ? y.push(X[0], X[1], X[2], this.opacity) : (y.push(X[0], X[1], X[2], X[3] * this.opacity), X[3] < 1 && (this.hasAlpha = !0)), Z = C ? C[W] : P ? [(P[W] - z) / (D - z), 0] : I ? I[R] : O ? [(O[R] - z) / (D - z), 0] : [(j[2] - z) / (D - z), 0], x.push(Z[0], Z[1]), B ? b.push(B[W]) : b.push(N), _.push(R), H += 1;
                break;

              case 2:
                for (U = 0; U < 2; ++U) {
                  j = n[W = G[U]];

                  for (var Y = 0; Y < 3; ++Y) {
                    if (isNaN(j[Y]) || !isFinite(j[Y])) continue t;
                  }
                }

                for (U = 0; U < 2; ++U) {
                  j = n[W = G[U]];
                  p.push(j[0], j[1], j[2]), X = S ? S[W] : E ? E[R] : L, this.opacityscale && P ? a.push(X[0], X[1], X[2], this.opacity * M((P[W] - z) / (D - z), this.opacityscale)) : 3 === X.length ? d.push(X[0], X[1], X[2], this.opacity) : (d.push(X[0], X[1], X[2], X[3] * this.opacity), X[3] < 1 && (this.hasAlpha = !0)), Z = C ? C[W] : P ? [(P[W] - z) / (D - z), 0] : I ? I[R] : O ? [(O[R] - z) / (D - z), 0] : [(j[2] - z) / (D - z), 0], m.push(Z[0], Z[1]), g.push(R);
                }

                q += 1;
                break;

              case 3:
                for (U = 0; U < 3; ++U) {
                  for (j = n[W = G[U]], Y = 0; Y < 3; ++Y) {
                    if (isNaN(j[Y]) || !isFinite(j[Y])) continue t;
                  }
                }

                for (U = 0; U < 3; ++U) {
                  var W, X, Z, J;
                  j = n[W = G[2 - U]];
                  i.push(j[0], j[1], j[2]), (X = S ? S[W] : E ? E[R] : L) ? this.opacityscale && P ? a.push(X[0], X[1], X[2], this.opacity * M((P[W] - z) / (D - z), this.opacityscale)) : 3 === X.length ? a.push(X[0], X[1], X[2], this.opacity) : (a.push(X[0], X[1], X[2], X[3] * this.opacity), X[3] < 1 && (this.hasAlpha = !0)) : a.push(.5, .5, .5, 1), Z = C ? C[W] : P ? [(P[W] - z) / (D - z), 0] : I ? I[R] : O ? [(O[R] - z) / (D - z), 0] : [(j[2] - z) / (D - z), 0], c.push(Z[0], Z[1]), J = w ? w[W] : T[R], l.push(J[0], J[1], J[2]), h.push(R);
                }

                V += 1;
            }
          }

          this.pointCount = H, this.edgeCount = q, this.triangleCount = V, this.pointPositions.update(v), this.pointColors.update(y), this.pointUVs.update(x), this.pointSizes.update(b), this.pointIds.update(new Uint32Array(_)), this.edgePositions.update(p), this.edgeColors.update(d), this.edgeUVs.update(m), this.edgeIds.update(new Uint32Array(g)), this.trianglePositions.update(i), this.triangleColors.update(a), this.triangleUVs.update(c), this.triangleNormals.update(l), this.triangleIds.update(new Uint32Array(h));
        }
      }, k.drawTransparent = k.draw = function (t) {
        t = t || {};

        for (var e = this.gl, r = t.model || w, n = t.view || w, i = t.projection || w, a = [[-1e6, -1e6, -1e6], [1e6, 1e6, 1e6]], o = 0; o < 3; ++o) {
          a[0][o] = Math.max(a[0][o], this.clipBounds[0][o]), a[1][o] = Math.min(a[1][o], this.clipBounds[1][o]);
        }

        var s = {
          model: r,
          view: n,
          projection: i,
          inverseModel: w.slice(),
          clipBounds: a,
          kambient: this.ambientLight,
          kdiffuse: this.diffuseLight,
          kspecular: this.specularLight,
          roughness: this.roughness,
          fresnel: this.fresnel,
          eyePosition: [0, 0, 0],
          lightPosition: [0, 0, 0],
          contourColor: this.contourColor,
          texture: 0
        };
        s.inverseModel = c(s.inverseModel, s.model), e.disable(e.CULL_FACE), this.texture.bind(0);
        var u = new Array(16);
        l(u, s.view, s.model), l(u, s.projection, u), c(u, u);

        for (o = 0; o < 3; ++o) {
          s.eyePosition[o] = u[12 + o] / u[15];
        }

        var f,
            h = u[15];

        for (o = 0; o < 3; ++o) {
          h += this.lightPosition[o] * u[4 * o + 3];
        }

        for (o = 0; o < 3; ++o) {
          for (var p = u[12 + o], d = 0; d < 3; ++d) {
            p += u[4 * d + o] * this.lightPosition[d];
          }

          s.lightPosition[o] = p / h;
        }

        this.triangleCount > 0 && ((f = this.triShader).bind(), f.uniforms = s, this.triangleVAO.bind(), e.drawArrays(e.TRIANGLES, 0, 3 * this.triangleCount), this.triangleVAO.unbind());
        this.edgeCount > 0 && this.lineWidth > 0 && ((f = this.lineShader).bind(), f.uniforms = s, this.edgeVAO.bind(), e.lineWidth(this.lineWidth * this.pixelRatio), e.drawArrays(e.LINES, 0, 2 * this.edgeCount), this.edgeVAO.unbind());
        this.pointCount > 0 && ((f = this.pointShader).bind(), f.uniforms = s, this.pointVAO.bind(), e.drawArrays(e.POINTS, 0, this.pointCount), this.pointVAO.unbind());
        this.contourEnable && this.contourCount > 0 && this.contourLineWidth > 0 && ((f = this.contourShader).bind(), f.uniforms = s, this.contourVAO.bind(), e.drawArrays(e.LINES, 0, this.contourCount), this.contourVAO.unbind());
      }, k.drawPick = function (t) {
        t = t || {};

        for (var e = this.gl, r = t.model || w, n = t.view || w, i = t.projection || w, a = [[-1e6, -1e6, -1e6], [1e6, 1e6, 1e6]], o = 0; o < 3; ++o) {
          a[0][o] = Math.max(a[0][o], this.clipBounds[0][o]), a[1][o] = Math.min(a[1][o], this.clipBounds[1][o]);
        }

        this._model = [].slice.call(r), this._view = [].slice.call(n), this._projection = [].slice.call(i), this._resolution = [e.drawingBufferWidth, e.drawingBufferHeight];
        var s,
            l = {
          model: r,
          view: n,
          projection: i,
          clipBounds: a,
          pickId: this.pickId / 255
        };
        ((s = this.pickShader).bind(), s.uniforms = l, this.triangleCount > 0 && (this.triangleVAO.bind(), e.drawArrays(e.TRIANGLES, 0, 3 * this.triangleCount), this.triangleVAO.unbind()), this.edgeCount > 0 && (this.edgeVAO.bind(), e.lineWidth(this.lineWidth * this.pixelRatio), e.drawArrays(e.LINES, 0, 2 * this.edgeCount), this.edgeVAO.unbind()), this.pointCount > 0) && ((s = this.pointPickShader).bind(), s.uniforms = l, this.pointVAO.bind(), e.drawArrays(e.POINTS, 0, this.pointCount), this.pointVAO.unbind());
      }, k.pick = function (t) {
        if (!t) return null;
        if (t.id !== this.pickId) return null;

        for (var e = t.value[0] + 256 * t.value[1] + 65536 * t.value[2], r = this.cells[e], n = this.positions, i = new Array(r.length), a = 0; a < r.length; ++a) {
          i[a] = n[r[a]];
        }

        var o = t.coord[0],
            s = t.coord[1];

        if (!this.pickVertex) {
          var l = this.positions[r[0]],
              c = this.positions[r[1]],
              u = this.positions[r[2]],
              f = [(l[0] + c[0] + u[0]) / 3, (l[1] + c[1] + u[1]) / 3, (l[2] + c[2] + u[2]) / 3];
          return {
            _cellCenter: !0,
            position: [o, s],
            index: e,
            cell: r,
            cellId: e,
            intensity: this.intensity[e],
            dataCoordinate: f
          };
        }

        var h = m(i, [o * this.pixelRatio, this._resolution[1] - s * this.pixelRatio], this._model, this._view, this._projection, this._resolution);
        if (!h) return null;
        var p = h[2],
            d = 0;

        for (a = 0; a < r.length; ++a) {
          d += p[a] * this.intensity[r[a]];
        }

        return {
          position: h[1],
          index: r[h[0]],
          cell: r,
          cellId: e,
          intensity: d,
          dataCoordinate: this.positions[r[h[0]]]
        };
      }, k.dispose = function () {
        this.texture.dispose(), this.triShader.dispose(), this.lineShader.dispose(), this.pointShader.dispose(), this.pickShader.dispose(), this.pointPickShader.dispose(), this.triangleVAO.dispose(), this.trianglePositions.dispose(), this.triangleColors.dispose(), this.triangleUVs.dispose(), this.triangleNormals.dispose(), this.triangleIds.dispose(), this.edgeVAO.dispose(), this.edgePositions.dispose(), this.edgeColors.dispose(), this.edgeUVs.dispose(), this.edgeIds.dispose(), this.pointVAO.dispose(), this.pointPositions.dispose(), this.pointColors.dispose(), this.pointUVs.dispose(), this.pointSizes.dispose(), this.pointIds.dispose(), this.contourVAO.dispose(), this.contourPositions.dispose(), this.contourShader.dispose();
      }, e.exports = function (t, e) {
        1 === arguments.length && (t = (e = t).gl);
        var r = t.getExtension("OES_standard_derivatives") || t.getExtension("MOZ_OES_standard_derivatives") || t.getExtension("WEBKIT_OES_standard_derivatives");
        if (!r) throw new Error("derivatives not supported");
        var n = A(t),
            s = S(t),
            l = E(t),
            c = L(t),
            f = C(t),
            h = P(t),
            p = o(t, u(new Uint8Array([255, 255, 255, 255]), [1, 1, 4]));
        p.generateMipmap(), p.minFilter = t.LINEAR_MIPMAP_LINEAR, p.magFilter = t.LINEAR;

        var d = i(t),
            m = i(t),
            g = i(t),
            v = i(t),
            y = i(t),
            x = a(t, [{
          buffer: d,
          type: t.FLOAT,
          size: 3
        }, {
          buffer: y,
          type: t.UNSIGNED_BYTE,
          size: 4,
          normalized: !0
        }, {
          buffer: m,
          type: t.FLOAT,
          size: 4
        }, {
          buffer: g,
          type: t.FLOAT,
          size: 2
        }, {
          buffer: v,
          type: t.FLOAT,
          size: 3
        }]),
            b = i(t),
            _ = i(t),
            w = i(t),
            k = i(t),
            M = a(t, [{
          buffer: b,
          type: t.FLOAT,
          size: 3
        }, {
          buffer: k,
          type: t.UNSIGNED_BYTE,
          size: 4,
          normalized: !0
        }, {
          buffer: _,
          type: t.FLOAT,
          size: 4
        }, {
          buffer: w,
          type: t.FLOAT,
          size: 2
        }]),
            I = i(t),
            O = i(t),
            z = i(t),
            D = i(t),
            R = i(t),
            F = a(t, [{
          buffer: I,
          type: t.FLOAT,
          size: 3
        }, {
          buffer: R,
          type: t.UNSIGNED_BYTE,
          size: 4,
          normalized: !0
        }, {
          buffer: O,
          type: t.FLOAT,
          size: 4
        }, {
          buffer: z,
          type: t.FLOAT,
          size: 2
        }, {
          buffer: D,
          type: t.FLOAT,
          size: 1
        }]),
            B = i(t),
            N = a(t, [{
          buffer: B,
          type: t.FLOAT,
          size: 3
        }]),
            j = new T(t, p, n, s, l, c, f, h, d, y, m, g, v, x, b, k, _, w, M, I, R, O, z, D, F, B, N);

        return j.update(e), j;
      };
    }, {
      "./lib/closest-point": 304,
      "./lib/shaders": 305,
      colormap: 132,
      "gl-buffer": 258,
      "gl-mat4/invert": 290,
      "gl-mat4/multiply": 292,
      "gl-shader": 330,
      "gl-texture2d": 347,
      "gl-vao": 352,
      ndarray: 475,
      normals: 478,
      "simplicial-complex-contour": 549,
      "typedarray-pool": 609
    }],
    307: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        var e = t.gl,
            r = n(e, [0, 0, 0, 1, 1, 0, 1, 1]),
            s = i(e, a.boxVert, a.lineFrag);
        return new o(t, r, s);
      };

      var n = t("gl-buffer"),
          i = t("gl-shader"),
          a = t("./shaders");

      function o(t, e, r) {
        this.plot = t, this.vbo = e, this.shader = r;
      }

      var s,
          l,
          c = o.prototype;
      c.bind = function () {
        var t = this.shader;
        this.vbo.bind(), this.shader.bind(), t.attributes.coord.pointer(), t.uniforms.screenBox = this.plot.screenBox;
      }, c.drawBox = (s = [0, 0], l = [0, 0], function (t, e, r, n, i) {
        var a = this.plot,
            o = this.shader,
            c = a.gl;
        s[0] = t, s[1] = e, l[0] = r, l[1] = n, o.uniforms.lo = s, o.uniforms.hi = l, o.uniforms.color = i, c.drawArrays(c.TRIANGLE_STRIP, 0, 4);
      }), c.dispose = function () {
        this.vbo.dispose(), this.shader.dispose();
      };
    }, {
      "./shaders": 310,
      "gl-buffer": 258,
      "gl-shader": 330
    }],
    308: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        var e = t.gl,
            r = n(e),
            a = i(e, o.gridVert, o.gridFrag),
            l = i(e, o.tickVert, o.gridFrag);
        return new s(t, r, a, l);
      };

      var n = t("gl-buffer"),
          i = t("gl-shader"),
          a = t("binary-search-bounds"),
          o = t("./shaders");

      function s(t, e, r, n) {
        this.plot = t, this.vbo = e, this.shader = r, this.tickShader = n, this.ticks = [[], []];
      }

      function l(t, e) {
        return t - e;
      }

      var c,
          u,
          f,
          h,
          p,
          d = s.prototype;
      d.draw = (c = [0, 0], u = [0, 0], f = [0, 0], function () {
        for (var t = this.plot, e = this.vbo, r = this.shader, n = this.ticks, i = t.gl, a = t._tickBounds, o = t.dataBox, s = t.viewBox, l = t.gridLineWidth, h = t.gridLineColor, p = t.gridLineEnable, d = t.pixelRatio, m = 0; m < 2; ++m) {
          var g = a[m],
              v = a[m + 2] - g,
              y = .5 * (o[m + 2] + o[m]),
              x = o[m + 2] - o[m];
          u[m] = 2 * v / x, c[m] = 2 * (g - y) / x;
        }

        r.bind(), e.bind(), r.attributes.dataCoord.pointer(), r.uniforms.dataShift = c, r.uniforms.dataScale = u;
        var b = 0;

        for (m = 0; m < 2; ++m) {
          f[0] = f[1] = 0, f[m] = 1, r.uniforms.dataAxis = f, r.uniforms.lineWidth = l[m] / (s[m + 2] - s[m]) * d, r.uniforms.color = h[m];

          var _ = 6 * n[m].length;

          p[m] && _ && i.drawArrays(i.TRIANGLES, b, _), b += _;
        }
      }), d.drawTickMarks = function () {
        var t = [0, 0],
            e = [0, 0],
            r = [1, 0],
            n = [0, 1],
            i = [0, 0],
            o = [0, 0];
        return function () {
          for (var s = this.plot, c = this.vbo, u = this.tickShader, f = this.ticks, h = s.gl, p = s._tickBounds, d = s.dataBox, m = s.viewBox, g = s.pixelRatio, v = s.screenBox, y = v[2] - v[0], x = v[3] - v[1], b = m[2] - m[0], _ = m[3] - m[1], w = 0; w < 2; ++w) {
            var T = p[w],
                k = p[w + 2] - T,
                M = .5 * (d[w + 2] + d[w]),
                A = d[w + 2] - d[w];
            e[w] = 2 * k / A, t[w] = 2 * (T - M) / A;
          }

          e[0] *= b / y, t[0] *= b / y, e[1] *= _ / x, t[1] *= _ / x, u.bind(), c.bind(), u.attributes.dataCoord.pointer();
          var S = u.uniforms;
          S.dataShift = t, S.dataScale = e;
          var E = s.tickMarkLength,
              L = s.tickMarkWidth,
              C = s.tickMarkColor,
              P = 6 * f[0].length,
              I = Math.min(a.ge(f[0], (d[0] - p[0]) / (p[2] - p[0]), l), f[0].length),
              O = Math.min(a.gt(f[0], (d[2] - p[0]) / (p[2] - p[0]), l), f[0].length),
              z = 0 + 6 * I,
              D = 6 * Math.max(0, O - I),
              R = Math.min(a.ge(f[1], (d[1] - p[1]) / (p[3] - p[1]), l), f[1].length),
              F = Math.min(a.gt(f[1], (d[3] - p[1]) / (p[3] - p[1]), l), f[1].length),
              B = P + 6 * R,
              N = 6 * Math.max(0, F - R);
          i[0] = 2 * (m[0] - E[1]) / y - 1, i[1] = (m[3] + m[1]) / x - 1, o[0] = E[1] * g / y, o[1] = L[1] * g / x, N && (S.color = C[1], S.tickScale = o, S.dataAxis = n, S.screenOffset = i, h.drawArrays(h.TRIANGLES, B, N)), i[0] = (m[2] + m[0]) / y - 1, i[1] = 2 * (m[1] - E[0]) / x - 1, o[0] = L[0] * g / y, o[1] = E[0] * g / x, D && (S.color = C[0], S.tickScale = o, S.dataAxis = r, S.screenOffset = i, h.drawArrays(h.TRIANGLES, z, D)), i[0] = 2 * (m[2] + E[3]) / y - 1, i[1] = (m[3] + m[1]) / x - 1, o[0] = E[3] * g / y, o[1] = L[3] * g / x, N && (S.color = C[3], S.tickScale = o, S.dataAxis = n, S.screenOffset = i, h.drawArrays(h.TRIANGLES, B, N)), i[0] = (m[2] + m[0]) / y - 1, i[1] = 2 * (m[3] + E[2]) / x - 1, o[0] = L[2] * g / y, o[1] = E[2] * g / x, D && (S.color = C[2], S.tickScale = o, S.dataAxis = r, S.screenOffset = i, h.drawArrays(h.TRIANGLES, z, D));
        };
      }(), d.update = (h = [1, 1, -1, -1, 1, -1], p = [1, -1, 1, 1, -1, -1], function (t) {
        for (var e = t.ticks, r = t.bounds, n = new Float32Array(18 * (e[0].length + e[1].length)), i = (this.plot.zeroLineEnable, 0), a = [[], []], o = 0; o < 2; ++o) {
          for (var s = a[o], l = e[o], c = r[o], u = r[o + 2], f = 0; f < l.length; ++f) {
            var d = (l[f].x - c) / (u - c);
            s.push(d);

            for (var m = 0; m < 6; ++m) {
              n[i++] = d, n[i++] = h[m], n[i++] = p[m];
            }
          }
        }

        this.ticks = a, this.vbo.update(n);
      }), d.dispose = function () {
        this.vbo.dispose(), this.shader.dispose(), this.tickShader.dispose();
      };
    }, {
      "./shaders": 310,
      "binary-search-bounds": 98,
      "gl-buffer": 258,
      "gl-shader": 330
    }],
    309: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        var e = t.gl,
            r = n(e, [-1, -1, -1, 1, 1, -1, 1, 1]),
            s = i(e, a.lineVert, a.lineFrag);
        return new o(t, r, s);
      };

      var n = t("gl-buffer"),
          i = t("gl-shader"),
          a = t("./shaders");

      function o(t, e, r) {
        this.plot = t, this.vbo = e, this.shader = r;
      }

      var s,
          l,
          c = o.prototype;
      c.bind = function () {
        var t = this.shader;
        this.vbo.bind(), this.shader.bind(), t.attributes.coord.pointer(), t.uniforms.screenBox = this.plot.screenBox;
      }, c.drawLine = (s = [0, 0], l = [0, 0], function (t, e, r, n, i, a) {
        var o = this.plot,
            c = this.shader,
            u = o.gl;
        s[0] = t, s[1] = e, l[0] = r, l[1] = n, c.uniforms.start = s, c.uniforms.end = l, c.uniforms.width = i * o.pixelRatio, c.uniforms.color = a, u.drawArrays(u.TRIANGLE_STRIP, 0, 4);
      }), c.dispose = function () {
        this.vbo.dispose(), this.shader.dispose();
      };
    }, {
      "./shaders": 310,
      "gl-buffer": 258,
      "gl-shader": 330
    }],
    310: [function (t, e, r) {
      "use strict";

      var n = t("glslify"),
          i = n(["precision lowp float;\n#define GLSLIFY 1\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = vec4(color.xyz * color.w, color.w);\n}\n"]);
      e.exports = {
        lineVert: n(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 coord;\n\nuniform vec4 screenBox;\nuniform vec2 start, end;\nuniform float width;\n\nvec2 perp(vec2 v) {\n  return vec2(v.y, -v.x);\n}\n\nvec2 screen(vec2 v) {\n  return 2.0 * (v - screenBox.xy) / (screenBox.zw - screenBox.xy) - 1.0;\n}\n\nvoid main() {\n  vec2 delta = normalize(perp(start - end));\n  vec2 offset = mix(start, end, 0.5 * (coord.y+1.0));\n  gl_Position = vec4(screen(offset + 0.5 * width * delta * coord.x), 0, 1);\n}\n"]),
        lineFrag: i,
        textVert: n(["#define GLSLIFY 1\nattribute vec3 textCoordinate;\n\nuniform vec2 dataScale, dataShift, dataAxis, screenOffset, textScale;\nuniform float angle;\n\nvoid main() {\n  float dataOffset  = textCoordinate.z;\n  vec2 glyphOffset  = textCoordinate.xy;\n  mat2 glyphMatrix = mat2(cos(angle), sin(angle), -sin(angle), cos(angle));\n  vec2 screenCoordinate = dataAxis * (dataScale * dataOffset + dataShift) +\n    glyphMatrix * glyphOffset * textScale + screenOffset;\n  gl_Position = vec4(screenCoordinate, 0, 1);\n}\n"]),
        textFrag: i,
        gridVert: n(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 dataCoord;\n\nuniform vec2 dataAxis, dataShift, dataScale;\nuniform float lineWidth;\n\nvoid main() {\n  vec2 pos = dataAxis * (dataScale * dataCoord.x + dataShift);\n  pos += 10.0 * dataCoord.y * vec2(dataAxis.y, -dataAxis.x) + dataCoord.z * lineWidth;\n  gl_Position = vec4(pos, 0, 1);\n}\n"]),
        gridFrag: i,
        boxVert: n(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 coord;\n\nuniform vec4 screenBox;\nuniform vec2 lo, hi;\n\nvec2 screen(vec2 v) {\n  return 2.0 * (v - screenBox.xy) / (screenBox.zw - screenBox.xy) - 1.0;\n}\n\nvoid main() {\n  gl_Position = vec4(screen(mix(lo, hi, coord)), 0, 1);\n}\n"]),
        tickVert: n(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 dataCoord;\n\nuniform vec2 dataAxis, dataShift, dataScale, screenOffset, tickScale;\n\nvoid main() {\n  vec2 pos = dataAxis * (dataScale * dataCoord.x + dataShift);\n  gl_Position = vec4(pos + tickScale*dataCoord.yz + screenOffset, 0, 1);\n}\n"])
      };
    }, {
      glslify: 312
    }],
    311: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        var e = t.gl,
            r = n(e),
            a = i(e, s.textVert, s.textFrag);
        return new l(t, r, a);
      };

      var n = t("gl-buffer"),
          i = t("gl-shader"),
          a = t("text-cache"),
          o = t("binary-search-bounds"),
          s = t("./shaders");

      function l(t, e, r) {
        this.plot = t, this.vbo = e, this.shader = r, this.tickOffset = [[], []], this.tickX = [[], []], this.labelOffset = [0, 0], this.labelCount = [0, 0];
      }

      var c,
          u,
          f,
          h,
          p,
          d,
          m = l.prototype;
      m.drawTicks = (c = [0, 0], u = [0, 0], f = [0, 0], function (t) {
        var e = this.plot,
            r = this.shader,
            n = this.tickX[t],
            i = this.tickOffset[t],
            a = e.gl,
            s = e.viewBox,
            l = e.dataBox,
            h = e.screenBox,
            p = e.pixelRatio,
            d = e.tickEnable,
            m = e.tickPad,
            g = e.tickColor,
            v = e.tickAngle,
            y = e.labelEnable,
            x = e.labelPad,
            b = e.labelColor,
            _ = e.labelAngle,
            w = this.labelOffset[t],
            T = this.labelCount[t],
            k = o.lt(n, l[t]),
            M = o.le(n, l[t + 2]);
        c[0] = c[1] = 0, c[t] = 1, u[t] = (s[2 + t] + s[t]) / (h[2 + t] - h[t]) - 1;
        var A = 2 / h[2 + (1 ^ t)] - h[1 ^ t];
        u[1 ^ t] = A * s[1 ^ t] - 1, d[t] && (u[1 ^ t] -= A * p * m[t], k < M && i[M] > i[k] && (r.uniforms.dataAxis = c, r.uniforms.screenOffset = u, r.uniforms.color = g[t], r.uniforms.angle = v[t], a.drawArrays(a.TRIANGLES, i[k], i[M] - i[k]))), y[t] && T && (u[1 ^ t] -= A * p * x[t], r.uniforms.dataAxis = f, r.uniforms.screenOffset = u, r.uniforms.color = b[t], r.uniforms.angle = _[t], a.drawArrays(a.TRIANGLES, w, T)), u[1 ^ t] = A * s[2 + (1 ^ t)] - 1, d[t + 2] && (u[1 ^ t] += A * p * m[t + 2], k < M && i[M] > i[k] && (r.uniforms.dataAxis = c, r.uniforms.screenOffset = u, r.uniforms.color = g[t + 2], r.uniforms.angle = v[t + 2], a.drawArrays(a.TRIANGLES, i[k], i[M] - i[k]))), y[t + 2] && T && (u[1 ^ t] += A * p * x[t + 2], r.uniforms.dataAxis = f, r.uniforms.screenOffset = u, r.uniforms.color = b[t + 2], r.uniforms.angle = _[t + 2], a.drawArrays(a.TRIANGLES, w, T));
      }), m.drawTitle = function () {
        var t = [0, 0],
            e = [0, 0];
        return function () {
          var r = this.plot,
              n = this.shader,
              i = r.gl,
              a = r.screenBox,
              o = r.titleCenter,
              s = r.titleAngle,
              l = r.titleColor,
              c = r.pixelRatio;

          if (this.titleCount) {
            for (var u = 0; u < 2; ++u) {
              e[u] = 2 * (o[u] * c - a[u]) / (a[2 + u] - a[u]) - 1;
            }

            n.bind(), n.uniforms.dataAxis = t, n.uniforms.screenOffset = e, n.uniforms.angle = s, n.uniforms.color = l, i.drawArrays(i.TRIANGLES, this.titleOffset, this.titleCount);
          }
        };
      }(), m.bind = (h = [0, 0], p = [0, 0], d = [0, 0], function () {
        var t = this.plot,
            e = this.shader,
            r = t._tickBounds,
            n = t.dataBox,
            i = t.screenBox,
            a = t.viewBox;
        e.bind();

        for (var o = 0; o < 2; ++o) {
          var s = r[o],
              l = r[o + 2] - s,
              c = .5 * (n[o + 2] + n[o]),
              u = n[o + 2] - n[o],
              f = a[o],
              m = a[o + 2] - f,
              g = i[o],
              v = i[o + 2] - g;
          p[o] = 2 * l / u * m / v, h[o] = 2 * (s - c) / u * m / v;
        }

        d[1] = 2 * t.pixelRatio / (i[3] - i[1]), d[0] = d[1] * (i[3] - i[1]) / (i[2] - i[0]), e.uniforms.dataScale = p, e.uniforms.dataShift = h, e.uniforms.textScale = d, this.vbo.bind(), e.attributes.textCoordinate.pointer();
      }), m.update = function (t) {
        var e,
            r,
            n,
            i,
            o,
            s = [],
            l = t.ticks,
            c = t.bounds;

        for (o = 0; o < 2; ++o) {
          var u = [Math.floor(s.length / 3)],
              f = [-1 / 0],
              h = l[o];

          for (e = 0; e < h.length; ++e) {
            var p = h[e],
                d = p.x,
                m = p.text,
                g = p.font || "sans-serif";
            i = p.fontSize || 12;

            for (var v = 1 / (c[o + 2] - c[o]), y = c[o], x = m.split("\n"), b = 0; b < x.length; b++) {
              for (n = a(g, x[b]).data, r = 0; r < n.length; r += 2) {
                s.push(n[r] * i, -n[r + 1] * i - b * i * 1.2, (d - y) * v);
              }
            }

            u.push(Math.floor(s.length / 3)), f.push(d);
          }

          this.tickOffset[o] = u, this.tickX[o] = f;
        }

        for (o = 0; o < 2; ++o) {
          for (this.labelOffset[o] = Math.floor(s.length / 3), n = a(t.labelFont[o], t.labels[o], {
            textAlign: "center"
          }).data, i = t.labelSize[o], e = 0; e < n.length; e += 2) {
            s.push(n[e] * i, -n[e + 1] * i, 0);
          }

          this.labelCount[o] = Math.floor(s.length / 3) - this.labelOffset[o];
        }

        for (this.titleOffset = Math.floor(s.length / 3), n = a(t.titleFont, t.title).data, i = t.titleSize, e = 0; e < n.length; e += 2) {
          s.push(n[e] * i, -n[e + 1] * i, 0);
        }

        this.titleCount = Math.floor(s.length / 3) - this.titleOffset, this.vbo.update(s);
      }, m.dispose = function () {
        this.vbo.dispose(), this.shader.dispose();
      };
    }, {
      "./shaders": 310,
      "binary-search-bounds": 98,
      "gl-buffer": 258,
      "gl-shader": 330,
      "text-cache": 588
    }],
    312: [function (t, e, r) {
      arguments[4][256][0].apply(r, arguments);
    }, {
      dup: 256
    }],
    313: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        var e = t.gl,
            r = n(e, [e.drawingBufferWidth, e.drawingBufferHeight]),
            c = new l(e, r);
        return c.grid = i(c), c.text = a(c), c.line = o(c), c.box = s(c), c.update(t), c;
      };

      var n = t("gl-select-static"),
          i = t("./lib/grid"),
          a = t("./lib/text"),
          o = t("./lib/line"),
          s = t("./lib/box");

      function l(t, e) {
        this.gl = t, this.pickBuffer = e, this.screenBox = [0, 0, t.drawingBufferWidth, t.drawingBufferHeight], this.viewBox = [0, 0, 0, 0], this.dataBox = [-10, -10, 10, 10], this.gridLineEnable = [!0, !0], this.gridLineWidth = [1, 1], this.gridLineColor = [[0, 0, 0, 1], [0, 0, 0, 1]], this.pixelRatio = 1, this.tickMarkLength = [0, 0, 0, 0], this.tickMarkWidth = [0, 0, 0, 0], this.tickMarkColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.tickPad = [15, 15, 15, 15], this.tickAngle = [0, 0, 0, 0], this.tickEnable = [!0, !0, !0, !0], this.tickColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.labelPad = [15, 15, 15, 15], this.labelAngle = [0, Math.PI / 2, 0, 3 * Math.PI / 2], this.labelEnable = [!0, !0, !0, !0], this.labelColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.titleCenter = [0, 0], this.titleEnable = !0, this.titleAngle = 0, this.titleColor = [0, 0, 0, 1], this.borderColor = [0, 0, 0, 0], this.backgroundColor = [0, 0, 0, 0], this.zeroLineEnable = [!0, !0], this.zeroLineWidth = [4, 4], this.zeroLineColor = [[0, 0, 0, 1], [0, 0, 0, 1]], this.borderLineEnable = [!0, !0, !0, !0], this.borderLineWidth = [2, 2, 2, 2], this.borderLineColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.grid = null, this.text = null, this.line = null, this.box = null, this.objects = [], this.overlays = [], this._tickBounds = [1 / 0, 1 / 0, -1 / 0, -1 / 0], this.static = !1, this.dirty = !1, this.pickDirty = !1, this.pickDelay = 120, this.pickRadius = 10, this._pickTimeout = null, this._drawPick = this.drawPick.bind(this), this._depthCounter = 0;
      }

      var c = l.prototype;

      function u(t) {
        for (var e = t.slice(), r = 0; r < e.length; ++r) {
          e[r] = e[r].slice();
        }

        return e;
      }

      function f(t, e) {
        return t.x - e.x;
      }

      c.setDirty = function () {
        this.dirty = this.pickDirty = !0;
      }, c.setOverlayDirty = function () {
        this.dirty = !0;
      }, c.nextDepthValue = function () {
        return this._depthCounter++ / 65536;
      }, c.draw = function () {
        var t = this.gl,
            e = this.screenBox,
            r = this.viewBox,
            n = this.dataBox,
            i = this.pixelRatio,
            a = this.grid,
            o = this.line,
            s = this.text,
            l = this.objects;

        if (this._depthCounter = 0, this.pickDirty && (this._pickTimeout && clearTimeout(this._pickTimeout), this.pickDirty = !1, this._pickTimeout = setTimeout(this._drawPick, this.pickDelay)), this.dirty) {
          if (this.dirty = !1, t.bindFramebuffer(t.FRAMEBUFFER, null), t.enable(t.SCISSOR_TEST), t.disable(t.DEPTH_TEST), t.depthFunc(t.LESS), t.depthMask(!1), t.enable(t.BLEND), t.blendEquation(t.FUNC_ADD, t.FUNC_ADD), t.blendFunc(t.ONE, t.ONE_MINUS_SRC_ALPHA), this.borderColor) {
            t.scissor(e[0], e[1], e[2] - e[0], e[3] - e[1]);
            var c = this.borderColor;
            t.clearColor(c[0] * c[3], c[1] * c[3], c[2] * c[3], c[3]), t.clear(t.COLOR_BUFFER_BIT | t.DEPTH_BUFFER_BIT);
          }

          t.scissor(r[0], r[1], r[2] - r[0], r[3] - r[1]), t.viewport(r[0], r[1], r[2] - r[0], r[3] - r[1]);
          var u = this.backgroundColor;
          t.clearColor(u[0] * u[3], u[1] * u[3], u[2] * u[3], u[3]), t.clear(t.COLOR_BUFFER_BIT), a.draw();
          var f = this.zeroLineEnable,
              h = this.zeroLineColor,
              p = this.zeroLineWidth;

          if (f[0] || f[1]) {
            o.bind();

            for (var d = 0; d < 2; ++d) {
              if (f[d] && n[d] <= 0 && n[d + 2] >= 0) {
                var m = e[d] - n[d] * (e[d + 2] - e[d]) / (n[d + 2] - n[d]);
                0 === d ? o.drawLine(m, e[1], m, e[3], p[d], h[d]) : o.drawLine(e[0], m, e[2], m, p[d], h[d]);
              }
            }
          }

          for (d = 0; d < l.length; ++d) {
            l[d].draw();
          }

          t.viewport(e[0], e[1], e[2] - e[0], e[3] - e[1]), t.scissor(e[0], e[1], e[2] - e[0], e[3] - e[1]), this.grid.drawTickMarks(), o.bind();
          var g = this.borderLineEnable,
              v = this.borderLineWidth,
              y = this.borderLineColor;

          for (g[1] && o.drawLine(r[0], r[1] - .5 * v[1] * i, r[0], r[3] + .5 * v[3] * i, v[1], y[1]), g[0] && o.drawLine(r[0] - .5 * v[0] * i, r[1], r[2] + .5 * v[2] * i, r[1], v[0], y[0]), g[3] && o.drawLine(r[2], r[1] - .5 * v[1] * i, r[2], r[3] + .5 * v[3] * i, v[3], y[3]), g[2] && o.drawLine(r[0] - .5 * v[0] * i, r[3], r[2] + .5 * v[2] * i, r[3], v[2], y[2]), s.bind(), d = 0; d < 2; ++d) {
            s.drawTicks(d);
          }

          this.titleEnable && s.drawTitle();
          var x = this.overlays;

          for (d = 0; d < x.length; ++d) {
            x[d].draw();
          }

          t.disable(t.SCISSOR_TEST), t.disable(t.BLEND), t.depthMask(!0);
        }
      }, c.drawPick = function () {
        if (!this.static) {
          var t = this.pickBuffer;
          this.gl, this._pickTimeout = null, t.begin();

          for (var e = 1, r = this.objects, n = 0; n < r.length; ++n) {
            e = r[n].drawPick(e);
          }

          t.end();
        }
      }, c.pick = function (t, e) {
        if (!this.static) {
          var r = this.pixelRatio,
              n = this.pickPixelRatio,
              i = this.viewBox,
              a = 0 | Math.round((t - i[0] / r) * n),
              o = 0 | Math.round((e - i[1] / r) * n),
              s = this.pickBuffer.query(a, o, this.pickRadius);
          if (!s) return null;

          for (var l = s.id + (s.value[0] << 8) + (s.value[1] << 16) + (s.value[2] << 24), c = this.objects, u = 0; u < c.length; ++u) {
            var f = c[u].pick(a, o, l);
            if (f) return f;
          }

          return null;
        }
      }, c.setScreenBox = function (t) {
        var e = this.screenBox,
            r = this.pixelRatio;
        e[0] = 0 | Math.round(t[0] * r), e[1] = 0 | Math.round(t[1] * r), e[2] = 0 | Math.round(t[2] * r), e[3] = 0 | Math.round(t[3] * r), this.setDirty();
      }, c.setDataBox = function (t) {
        var e = this.dataBox;
        (e[0] !== t[0] || e[1] !== t[1] || e[2] !== t[2] || e[3] !== t[3]) && (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], this.setDirty());
      }, c.setViewBox = function (t) {
        var e = this.pixelRatio,
            r = this.viewBox;
        r[0] = 0 | Math.round(t[0] * e), r[1] = 0 | Math.round(t[1] * e), r[2] = 0 | Math.round(t[2] * e), r[3] = 0 | Math.round(t[3] * e);
        var n = this.pickPixelRatio;
        this.pickBuffer.shape = [0 | Math.round((t[2] - t[0]) * n), 0 | Math.round((t[3] - t[1]) * n)], this.setDirty();
      }, c.update = function (t) {
        t = t || {};
        var e = this.gl;
        this.pixelRatio = t.pixelRatio || 1;
        var r = this.pixelRatio;
        this.pickPixelRatio = Math.max(r, 1), this.setScreenBox(t.screenBox || [0, 0, e.drawingBufferWidth / r, e.drawingBufferHeight / r]);
        this.screenBox;
        this.setViewBox(t.viewBox || [.125 * (this.screenBox[2] - this.screenBox[0]) / r, .125 * (this.screenBox[3] - this.screenBox[1]) / r, .875 * (this.screenBox[2] - this.screenBox[0]) / r, .875 * (this.screenBox[3] - this.screenBox[1]) / r]);
        var n = this.viewBox,
            i = (n[2] - n[0]) / (n[3] - n[1]);
        this.setDataBox(t.dataBox || [-10, -10 / i, 10, 10 / i]), this.borderColor = !1 !== t.borderColor && (t.borderColor || [0, 0, 0, 0]).slice(), this.backgroundColor = (t.backgroundColor || [0, 0, 0, 0]).slice(), this.gridLineEnable = (t.gridLineEnable || [!0, !0]).slice(), this.gridLineWidth = (t.gridLineWidth || [1, 1]).slice(), this.gridLineColor = u(t.gridLineColor || [[.5, .5, .5, 1], [.5, .5, .5, 1]]), this.zeroLineEnable = (t.zeroLineEnable || [!0, !0]).slice(), this.zeroLineWidth = (t.zeroLineWidth || [4, 4]).slice(), this.zeroLineColor = u(t.zeroLineColor || [[0, 0, 0, 1], [0, 0, 0, 1]]), this.tickMarkLength = (t.tickMarkLength || [0, 0, 0, 0]).slice(), this.tickMarkWidth = (t.tickMarkWidth || [0, 0, 0, 0]).slice(), this.tickMarkColor = u(t.tickMarkColor || [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]]), this.titleCenter = (t.titleCenter || [.5 * (n[0] + n[2]) / r, (n[3] + 120) / r]).slice(), this.titleEnable = !("titleEnable" in t) || !!t.titleEnable, this.titleAngle = t.titleAngle || 0, this.titleColor = (t.titleColor || [0, 0, 0, 1]).slice(), this.labelPad = (t.labelPad || [15, 15, 15, 15]).slice(), this.labelAngle = (t.labelAngle || [0, Math.PI / 2, 0, 3 * Math.PI / 2]).slice(), this.labelEnable = (t.labelEnable || [!0, !0, !0, !0]).slice(), this.labelColor = u(t.labelColor || [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]]), this.tickPad = (t.tickPad || [15, 15, 15, 15]).slice(), this.tickAngle = (t.tickAngle || [0, 0, 0, 0]).slice(), this.tickEnable = (t.tickEnable || [!0, !0, !0, !0]).slice(), this.tickColor = u(t.tickColor || [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]]), this.borderLineEnable = (t.borderLineEnable || [!0, !0, !0, !0]).slice(), this.borderLineWidth = (t.borderLineWidth || [2, 2, 2, 2]).slice(), this.borderLineColor = u(t.borderLineColor || [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]]);
        var a = t.ticks || [[], []],
            o = this._tickBounds;
        o[0] = o[1] = 1 / 0, o[2] = o[3] = -1 / 0;

        for (var s = 0; s < 2; ++s) {
          var l = a[s].slice(0);
          0 !== l.length && (l.sort(f), o[s] = Math.min(o[s], l[0].x), o[s + 2] = Math.max(o[s + 2], l[l.length - 1].x));
        }

        this.grid.update({
          bounds: o,
          ticks: a
        }), this.text.update({
          bounds: o,
          ticks: a,
          labels: t.labels || ["x", "y"],
          labelSize: t.labelSize || [12, 12],
          labelFont: t.labelFont || ["sans-serif", "sans-serif"],
          title: t.title || "",
          titleSize: t.titleSize || 18,
          titleFont: t.titleFont || "sans-serif"
        }), this.static = !!t.static, this.setDirty();
      }, c.dispose = function () {
        this.box.dispose(), this.grid.dispose(), this.text.dispose(), this.line.dispose();

        for (var t = this.objects.length - 1; t >= 0; --t) {
          this.objects[t].dispose();
        }

        this.objects.length = 0;

        for (t = this.overlays.length - 1; t >= 0; --t) {
          this.overlays[t].dispose();
        }

        this.overlays.length = 0, this.gl = null;
      }, c.addObject = function (t) {
        this.objects.indexOf(t) < 0 && (this.objects.push(t), this.setDirty());
      }, c.removeObject = function (t) {
        for (var e = this.objects, r = 0; r < e.length; ++r) {
          if (e[r] === t) {
            e.splice(r, 1), this.setDirty();
            break;
          }
        }
      }, c.addOverlay = function (t) {
        this.overlays.indexOf(t) < 0 && (this.overlays.push(t), this.setOverlayDirty());
      }, c.removeOverlay = function (t) {
        for (var e = this.overlays, r = 0; r < e.length; ++r) {
          if (e[r] === t) {
            e.splice(r, 1), this.setOverlayDirty();
            break;
          }
        }
      };
    }, {
      "./lib/box": 307,
      "./lib/grid": 308,
      "./lib/line": 309,
      "./lib/text": 311,
      "gl-select-static": 329
    }],
    314: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        t = t || document.body, e = e || {};
        var r = [.01, 1 / 0];
        "distanceLimits" in e && (r[0] = e.distanceLimits[0], r[1] = e.distanceLimits[1]);
        "zoomMin" in e && (r[0] = e.zoomMin);
        "zoomMax" in e && (r[1] = e.zoomMax);
        var c = i({
          center: e.center || [0, 0, 0],
          up: e.up || [0, 1, 0],
          eye: e.eye || [0, 0, 10],
          mode: e.mode || "orbit",
          distanceLimits: r
        }),
            u = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            f = 0,
            h = t.clientWidth,
            p = t.clientHeight,
            d = {
          keyBindingMode: "rotate",
          enableWheel: !0,
          view: c,
          element: t,
          delay: e.delay || 16,
          rotateSpeed: e.rotateSpeed || 1,
          zoomSpeed: e.zoomSpeed || 1,
          translateSpeed: e.translateSpeed || 1,
          flipX: !!e.flipX,
          flipY: !!e.flipY,
          modes: c.modes,
          _ortho: e._ortho || e.projection && "orthographic" === e.projection.type || !1,
          tick: function tick() {
            var e = n(),
                r = this.delay,
                i = e - 2 * r;
            c.idle(e - r), c.recalcMatrix(i), c.flush(e - (100 + 2 * r));

            for (var a = !0, o = c.computedMatrix, s = 0; s < 16; ++s) {
              a = a && u[s] === o[s], u[s] = o[s];
            }

            var l = t.clientWidth === h && t.clientHeight === p;
            return h = t.clientWidth, p = t.clientHeight, a ? !l : (f = Math.exp(c.computedRadius[0]), !0);
          },
          lookAt: function lookAt(t, e, r) {
            c.lookAt(c.lastT(), t, e, r);
          },
          rotate: function rotate(t, e, r) {
            c.rotate(c.lastT(), t, e, r);
          },
          pan: function pan(t, e, r) {
            c.pan(c.lastT(), t, e, r);
          },
          translate: function translate(t, e, r) {
            c.translate(c.lastT(), t, e, r);
          }
        };
        return Object.defineProperties(d, {
          matrix: {
            get: function get() {
              return c.computedMatrix;
            },
            set: function set(t) {
              return c.setMatrix(c.lastT(), t), c.computedMatrix;
            },
            enumerable: !0
          },
          mode: {
            get: function get() {
              return c.getMode();
            },
            set: function set(t) {
              var e = c.computedUp.slice(),
                  r = c.computedEye.slice(),
                  i = c.computedCenter.slice();

              if (c.setMode(t), "turntable" === t) {
                var a = n();
                c._active.lookAt(a, r, i, e), c._active.lookAt(a + 500, r, i, [0, 0, 1]), c._active.flush(a);
              }

              return c.getMode();
            },
            enumerable: !0
          },
          center: {
            get: function get() {
              return c.computedCenter;
            },
            set: function set(t) {
              return c.lookAt(c.lastT(), null, t), c.computedCenter;
            },
            enumerable: !0
          },
          eye: {
            get: function get() {
              return c.computedEye;
            },
            set: function set(t) {
              return c.lookAt(c.lastT(), t), c.computedEye;
            },
            enumerable: !0
          },
          up: {
            get: function get() {
              return c.computedUp;
            },
            set: function set(t) {
              return c.lookAt(c.lastT(), null, null, t), c.computedUp;
            },
            enumerable: !0
          },
          distance: {
            get: function get() {
              return f;
            },
            set: function set(t) {
              return c.setDistance(c.lastT(), t), t;
            },
            enumerable: !0
          },
          distanceLimits: {
            get: function get() {
              return c.getDistanceLimits(r);
            },
            set: function set(t) {
              return c.setDistanceLimits(t), t;
            },
            enumerable: !0
          }
        }), t.addEventListener("contextmenu", function (t) {
          return t.preventDefault(), !1;
        }), d._lastX = -1, d._lastY = -1, d._lastMods = {
          shift: !1,
          control: !1,
          alt: !1,
          meta: !1
        }, d.enableMouseListeners = function () {
          function e(e, r, i, a) {
            var o = d.keyBindingMode;

            if (!1 !== o) {
              var s = "rotate" === o,
                  l = "pan" === o,
                  u = "zoom" === o,
                  h = !!a.control,
                  p = !!a.alt,
                  m = !!a.shift,
                  g = !!(1 & e),
                  v = !!(2 & e),
                  y = !!(4 & e),
                  x = 1 / t.clientHeight,
                  b = x * (r - d._lastX),
                  _ = x * (i - d._lastY),
                  w = d.flipX ? 1 : -1,
                  T = d.flipY ? 1 : -1,
                  k = Math.PI * d.rotateSpeed,
                  M = n();

              if (-1 !== d._lastX && -1 !== d._lastY && ((s && g && !h && !p && !m || g && !h && !p && m) && c.rotate(M, w * k * b, -T * k * _, 0), (l && g && !h && !p && !m || v || g && h && !p && !m) && c.pan(M, -d.translateSpeed * b * f, d.translateSpeed * _ * f, 0), u && g && !h && !p && !m || y || g && !h && p && !m)) {
                var A = -d.zoomSpeed * _ / window.innerHeight * (M - c.lastT()) * 100;
                c.pan(M, 0, 0, f * (Math.exp(A) - 1));
              }

              return d._lastX = r, d._lastY = i, d._lastMods = a, !0;
            }
          }

          d.mouseListener = a(t, e), t.addEventListener("touchstart", function (r) {
            var n = s(r.changedTouches[0], t);
            e(0, n[0], n[1], d._lastMods), e(1, n[0], n[1], d._lastMods);
          }, !!l && {
            passive: !0
          }), t.addEventListener("touchmove", function (r) {
            var n = s(r.changedTouches[0], t);
            e(1, n[0], n[1], d._lastMods), r.preventDefault();
          }, !!l && {
            passive: !1
          }), t.addEventListener("touchend", function (t) {
            e(0, d._lastX, d._lastY, d._lastMods);
          }, !!l && {
            passive: !0
          }), d.wheelListener = o(t, function (t, e) {
            if (!1 !== d.keyBindingMode && d.enableWheel) {
              var r = d.flipX ? 1 : -1,
                  i = d.flipY ? 1 : -1,
                  a = n();
              if (Math.abs(t) > Math.abs(e)) c.rotate(a, 0, 0, -t * r * Math.PI * d.rotateSpeed / window.innerWidth);else if (!d._ortho) {
                var o = -d.zoomSpeed * i * e / window.innerHeight * (a - c.lastT()) / 20;
                c.pan(a, 0, 0, f * (Math.exp(o) - 1));
              }
            }
          }, !0);
        }, d.enableMouseListeners(), d;
      };

      var n = t("right-now"),
          i = t("3d-view"),
          a = t("mouse-change"),
          o = t("mouse-wheel"),
          s = t("mouse-event-offset"),
          l = t("has-passive-events");
    }, {
      "3d-view": 54,
      "has-passive-events": 435,
      "mouse-change": 462,
      "mouse-event-offset": 463,
      "mouse-wheel": 465,
      "right-now": 534
    }],
    315: [function (t, e, r) {
      var n = t("glslify"),
          i = t("gl-shader"),
          a = n(["precision mediump float;\n#define GLSLIFY 1\nattribute vec2 position;\nvarying vec2 uv;\nvoid main() {\n  uv = position;\n  gl_Position = vec4(position, 0, 1);\n}"]),
          o = n(["precision mediump float;\n#define GLSLIFY 1\n\nuniform sampler2D accumBuffer;\nvarying vec2 uv;\n\nvoid main() {\n  vec4 accum = texture2D(accumBuffer, 0.5 * (uv + 1.0));\n  gl_FragColor = min(vec4(1,1,1,1), accum);\n}"]);

      e.exports = function (t) {
        return i(t, a, o, null, [{
          name: "position",
          type: "vec2"
        }]);
      };
    }, {
      "gl-shader": 330,
      glslify: 316
    }],
    316: [function (t, e, r) {
      arguments[4][256][0].apply(r, arguments);
    }, {
      dup: 256
    }],
    317: [function (t, e, r) {
      "use strict";

      var n = t("./camera.js"),
          i = t("gl-axes3d"),
          a = t("gl-axes3d/properties"),
          o = t("gl-spikes3d"),
          s = t("gl-select-static"),
          l = t("gl-fbo"),
          c = t("a-big-triangle"),
          u = t("mouse-change"),
          f = t("gl-mat4/perspective"),
          h = t("gl-mat4/ortho"),
          p = t("./lib/shader"),
          d = t("is-mobile")({
        tablet: !0,
        featureDetect: !0
      });

      function m() {
        this.mouse = [-1, -1], this.screen = null, this.distance = 1 / 0, this.index = null, this.dataCoordinate = null, this.dataPosition = null, this.object = null, this.data = null;
      }

      function g(t) {
        var e = Math.round(Math.log(Math.abs(t)) / Math.log(10));

        if (e < 0) {
          var r = Math.round(Math.pow(10, -e));
          return Math.ceil(t * r) / r;
        }

        if (e > 0) {
          r = Math.round(Math.pow(10, e));
          return Math.ceil(t / r) * r;
        }

        return Math.ceil(t);
      }

      function v(t) {
        return "boolean" != typeof t || t;
      }

      e.exports = {
        createScene: function createScene(t) {
          (t = t || {}).camera = t.camera || {};
          var e = t.canvas;

          if (!e) {
            if (e = document.createElement("canvas"), t.container) t.container.appendChild(e);else document.body.appendChild(e);
          }

          var r = t.gl;
          r || (t.glOptions && (d = !!t.glOptions.preserveDrawingBuffer), r = function (t, e) {
            var r = null;

            try {
              (r = t.getContext("webgl", e)) || (r = t.getContext("experimental-webgl", e));
            } catch (t) {
              return null;
            }

            return r;
          }(e, t.glOptions || {
            premultipliedAlpha: !0,
            antialias: !0,
            preserveDrawingBuffer: d
          }));
          if (!r) throw new Error("webgl not supported");

          var y = t.bounds || [[-10, -10, -10], [10, 10, 10]],
              x = new m(),
              b = l(r, r.drawingBufferWidth, r.drawingBufferHeight, {
            preferFloat: !d
          }),
              _ = p(r),
              w = t.cameraObject && !0 === t.cameraObject._ortho || t.camera.projection && "orthographic" === t.camera.projection.type || !1,
              T = {
            eye: t.camera.eye || [2, 0, 0],
            center: t.camera.center || [0, 0, 0],
            up: t.camera.up || [0, 1, 0],
            zoomMin: t.camera.zoomMax || .1,
            zoomMax: t.camera.zoomMin || 100,
            mode: t.camera.mode || "turntable",
            _ortho: w
          },
              k = t.axes || {},
              M = i(r, k);

          M.enable = !k.disable;
          var A = t.spikes || {},
              S = o(r, A),
              E = [],
              L = [],
              C = [],
              P = [],
              I = !0,
              O = !0,
              z = new Array(16),
              D = new Array(16),
              R = {
            view: null,
            projection: z,
            model: D,
            _ortho: !1
          },
              F = (O = !0, [r.drawingBufferWidth, r.drawingBufferHeight]),
              B = t.cameraObject || n(e, T),
              N = {
            gl: r,
            contextLost: !1,
            pixelRatio: t.pixelRatio || 1,
            canvas: e,
            selection: x,
            camera: B,
            axes: M,
            axesPixels: null,
            spikes: S,
            bounds: y,
            objects: E,
            shape: F,
            aspect: t.aspectRatio || [1, 1, 1],
            pickRadius: t.pickRadius || 10,
            zNear: t.zNear || .01,
            zFar: t.zFar || 1e3,
            fovy: t.fovy || Math.PI / 4,
            clearColor: t.clearColor || [0, 0, 0, 0],
            autoResize: v(t.autoResize),
            autoBounds: v(t.autoBounds),
            autoScale: !!t.autoScale,
            autoCenter: v(t.autoCenter),
            clipToBounds: v(t.clipToBounds),
            snapToData: !!t.snapToData,
            onselect: t.onselect || null,
            onrender: t.onrender || null,
            onclick: t.onclick || null,
            cameraParams: R,
            oncontextloss: null,
            mouseListener: null,
            _stopped: !1,
            getAspectratio: function getAspectratio() {
              return {
                x: this.aspect[0],
                y: this.aspect[1],
                z: this.aspect[2]
              };
            },
            setAspectratio: function setAspectratio(t) {
              this.aspect[0] = t.x, this.aspect[1] = t.y, this.aspect[2] = t.z, O = !0;
            },
            setBounds: function setBounds(t, e) {
              this.bounds[0][t] = e.min, this.bounds[1][t] = e.max;
            },
            setClearColor: function setClearColor(t) {
              this.clearColor = t;
            },
            clearRGBA: function clearRGBA() {
              this.gl.clearColor(this.clearColor[0], this.clearColor[1], this.clearColor[2], this.clearColor[3]), this.gl.clear(this.gl.COLOR_BUFFER_BIT | this.gl.DEPTH_BUFFER_BIT);
            }
          },
              j = [r.drawingBufferWidth / N.pixelRatio | 0, r.drawingBufferHeight / N.pixelRatio | 0];

          function U() {
            if (!N._stopped && N.autoResize) {
              var t = e.parentNode,
                  r = 1,
                  n = 1;
              t && t !== document.body ? (r = t.clientWidth, n = t.clientHeight) : (r = window.innerWidth, n = window.innerHeight);
              var i = 0 | Math.ceil(r * N.pixelRatio),
                  a = 0 | Math.ceil(n * N.pixelRatio);

              if (i !== e.width || a !== e.height) {
                e.width = i, e.height = a;
                var o = e.style;
                o.position = o.position || "absolute", o.left = "0px", o.top = "0px", o.width = r + "px", o.height = n + "px", I = !0;
              }
            }
          }

          N.autoResize && U();

          function V() {
            for (var t = E.length, e = P.length, n = 0; n < e; ++n) {
              C[n] = 0;
            }

            t: for (n = 0; n < t; ++n) {
              var i = E[n],
                  a = i.pickSlots;

              if (a) {
                for (var o = 0; o < e; ++o) {
                  if (C[o] + a < 255) {
                    L[n] = o, i.setPickBase(C[o] + 1), C[o] += a;
                    continue t;
                  }
                }

                var l = s(r, F);
                L[n] = e, P.push(l), C.push(a), i.setPickBase(1), e += 1;
              } else L[n] = -1;
            }

            for (; e > 0 && 0 === C[e - 1];) {
              C.pop(), P.pop().dispose();
            }
          }

          function q() {
            if (N.contextLost) return !0;
            r.isContextLost() && (N.contextLost = !0, N.mouseListener.enabled = !1, N.selection.object = null, N.oncontextloss && N.oncontextloss());
          }

          window.addEventListener("resize", U), N.update = function (t) {
            N._stopped || (t = t || {}, I = !0, O = !0);
          }, N.add = function (t) {
            N._stopped || (t.axes = M, E.push(t), L.push(-1), I = !0, O = !0, V());
          }, N.remove = function (t) {
            if (!N._stopped) {
              var e = E.indexOf(t);
              e < 0 || (E.splice(e, 1), L.pop(), I = !0, O = !0, V());
            }
          }, N.dispose = function () {
            if (!N._stopped && (N._stopped = !0, window.removeEventListener("resize", U), e.removeEventListener("webglcontextlost", q), N.mouseListener.enabled = !1, !N.contextLost)) {
              M.dispose(), S.dispose();

              for (var t = 0; t < E.length; ++t) {
                E[t].dispose();
              }

              b.dispose();

              for (t = 0; t < P.length; ++t) {
                P[t].dispose();
              }

              _.dispose(), r = null, M = null, S = null, E = [];
            }
          }, N._mouseRotating = !1, N._prevButtons = 0, N.enableMouseListeners = function () {
            N.mouseListener = u(e, function (t, e, r) {
              if (!N._stopped) {
                var n = P.length,
                    i = E.length,
                    a = x.object;
                x.distance = 1 / 0, x.mouse[0] = e, x.mouse[1] = r, x.object = null, x.screen = null, x.dataCoordinate = x.dataPosition = null;
                var o = !1;
                if (t && N._prevButtons) N._mouseRotating = !0;else {
                  N._mouseRotating && (O = !0), N._mouseRotating = !1;

                  for (var s = 0; s < n; ++s) {
                    var l = P[s].query(e, j[1] - r - 1, N.pickRadius);

                    if (l) {
                      if (l.distance > x.distance) continue;

                      for (var c = 0; c < i; ++c) {
                        var u = E[c];

                        if (L[c] === s) {
                          var f = u.pick(l);
                          f && (x.buttons = t, x.screen = l.coord, x.distance = l.distance, x.object = u, x.index = f.distance, x.dataPosition = f.position, x.dataCoordinate = f.dataCoordinate, x.data = f, o = !0);
                        }
                      }
                    }
                  }
                }
                a && a !== x.object && (a.highlight && a.highlight(null), I = !0), x.object && (x.object.highlight && x.object.highlight(x.data), I = !0), (o = o || x.object !== a) && N.onselect && N.onselect(x), 1 & t && !(1 & N._prevButtons) && N.onclick && N.onclick(x), N._prevButtons = t;
              }
            });
          }, e.addEventListener("webglcontextlost", q);
          var H = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]],
              G = [H[0].slice(), H[1].slice()];

          function Y() {
            if (!q()) {
              U();
              var t = N.camera.tick();
              R.view = N.camera.matrix, I = I || t, O = O || t, M.pixelRatio = N.pixelRatio, S.pixelRatio = N.pixelRatio;
              var e = E.length,
                  n = H[0],
                  i = H[1];
              n[0] = n[1] = n[2] = 1 / 0, i[0] = i[1] = i[2] = -1 / 0;

              for (var o = 0; o < e; ++o) {
                (C = E[o]).pixelRatio = N.pixelRatio, C.axes = N.axes, I = I || !!C.dirty, O = O || !!C.dirty;
                var s = C.bounds;
                if (s) for (var l = s[0], u = s[1], p = 0; p < 3; ++p) {
                  n[p] = Math.min(n[p], l[p]), i[p] = Math.max(i[p], u[p]);
                }
              }

              var d = N.bounds;
              if (N.autoBounds) for (p = 0; p < 3; ++p) {
                if (i[p] < n[p]) n[p] = -1, i[p] = 1;else {
                  n[p] === i[p] && (n[p] -= 1, i[p] += 1);
                  var m = .05 * (i[p] - n[p]);
                  n[p] = n[p] - m, i[p] = i[p] + m;
                }
                d[0][p] = n[p], d[1][p] = i[p];
              }
              var v = !1;

              for (p = 0; p < 3; ++p) {
                v = v || G[0][p] !== d[0][p] || G[1][p] !== d[1][p], G[0][p] = d[0][p], G[1][p] = d[1][p];
              }

              if (O = O || v, I = I || v) {
                if (v) {
                  var y = [0, 0, 0];

                  for (o = 0; o < 3; ++o) {
                    y[o] = g((d[1][o] - d[0][o]) / 10);
                  }

                  M.autoTicks ? M.update({
                    bounds: d,
                    tickSpacing: y
                  }) : M.update({
                    bounds: d
                  });
                }

                var T = r.drawingBufferWidth,
                    k = r.drawingBufferHeight;
                F[0] = T, F[1] = k, j[0] = 0 | Math.max(T / N.pixelRatio, 1), j[1] = 0 | Math.max(k / N.pixelRatio, 1), function (t, e) {
                  var r = t.bounds,
                      n = t.cameraParams,
                      i = n.projection,
                      a = n.model,
                      o = t.gl.drawingBufferWidth,
                      s = t.gl.drawingBufferHeight,
                      l = t.zNear,
                      c = t.zFar,
                      u = t.fovy,
                      p = o / s;
                  e ? (h(i, -p, p, -1, 1, l, c), n._ortho = !0) : (f(i, u, p, l, c), n._ortho = !1);

                  for (var d = 0; d < 16; ++d) {
                    a[d] = 0;
                  }

                  a[15] = 1;
                  var m = 0;

                  for (d = 0; d < 3; ++d) {
                    m = Math.max(m, r[1][d] - r[0][d]);
                  }

                  for (d = 0; d < 3; ++d) {
                    t.autoScale ? a[5 * d] = t.aspect[d] / (r[1][d] - r[0][d]) : a[5 * d] = 1 / m, t.autoCenter && (a[12 + d] = .5 * -a[5 * d] * (r[0][d] + r[1][d]));
                  }
                }(N, w);

                for (o = 0; o < e; ++o) {
                  (C = E[o]).axesBounds = d, N.clipToBounds && (C.clipBounds = d);
                }

                x.object && (N.snapToData ? S.position = x.dataCoordinate : S.position = x.dataPosition, S.bounds = d), O && (O = !1, function () {
                  if (!q()) {
                    r.colorMask(!0, !0, !0, !0), r.depthMask(!0), r.disable(r.BLEND), r.enable(r.DEPTH_TEST), r.depthFunc(r.LEQUAL);

                    for (var t = E.length, e = P.length, n = 0; n < e; ++n) {
                      var i = P[n];
                      i.shape = j, i.begin();

                      for (var a = 0; a < t; ++a) {
                        if (L[a] === n) {
                          var o = E[a];
                          o.drawPick && (o.pixelRatio = 1, o.drawPick(R));
                        }
                      }

                      i.end();
                    }
                  }
                }()), N.axesPixels = a(N.axes, R, T, k), N.onrender && N.onrender(), r.bindFramebuffer(r.FRAMEBUFFER, null), r.viewport(0, 0, T, k), N.clearRGBA(), r.depthMask(!0), r.colorMask(!0, !0, !0, !0), r.enable(r.DEPTH_TEST), r.depthFunc(r.LEQUAL), r.disable(r.BLEND), r.disable(r.CULL_FACE);
                var A = !1;
                M.enable && (A = A || M.isTransparent(), M.draw(R)), S.axes = M, x.object && S.draw(R), r.disable(r.CULL_FACE);

                for (o = 0; o < e; ++o) {
                  (C = E[o]).axes = M, C.pixelRatio = N.pixelRatio, C.isOpaque && C.isOpaque() && C.draw(R), C.isTransparent && C.isTransparent() && (A = !0);
                }

                if (A) {
                  b.shape = F, b.bind(), r.clear(r.DEPTH_BUFFER_BIT), r.colorMask(!1, !1, !1, !1), r.depthMask(!0), r.depthFunc(r.LESS), M.enable && M.isTransparent() && M.drawTransparent(R);

                  for (o = 0; o < e; ++o) {
                    (C = E[o]).isOpaque && C.isOpaque() && C.draw(R);
                  }

                  r.enable(r.BLEND), r.blendEquation(r.FUNC_ADD), r.blendFunc(r.ONE, r.ONE_MINUS_SRC_ALPHA), r.colorMask(!0, !0, !0, !0), r.depthMask(!1), r.clearColor(0, 0, 0, 0), r.clear(r.COLOR_BUFFER_BIT), M.isTransparent() && M.drawTransparent(R);

                  for (o = 0; o < e; ++o) {
                    var C;
                    (C = E[o]).isTransparent && C.isTransparent() && C.drawTransparent(R);
                  }

                  r.bindFramebuffer(r.FRAMEBUFFER, null), r.blendFunc(r.ONE, r.ONE_MINUS_SRC_ALPHA), r.disable(r.DEPTH_TEST), _.bind(), b.color[0].bind(0), _.uniforms.accumBuffer = 0, c(r), r.disable(r.BLEND);
                }

                I = !1;

                for (o = 0; o < e; ++o) {
                  E[o].dirty = !1;
                }
              }
            }
          }

          return N.enableMouseListeners(), function t() {
            if (N._stopped || N.contextLost) return;
            Y(), requestAnimationFrame(t);
          }(), N.redraw = function () {
            N._stopped || (I = !0, Y());
          }, N;
        },
        createCamera: n
      };
    }, {
      "./camera.js": 314,
      "./lib/shader": 315,
      "a-big-triangle": 65,
      "gl-axes3d": 249,
      "gl-axes3d/properties": 257,
      "gl-fbo": 267,
      "gl-mat4/ortho": 293,
      "gl-mat4/perspective": 294,
      "gl-select-static": 329,
      "gl-spikes3d": 340,
      "is-mobile": 446,
      "mouse-change": 462
    }],
    318: [function (t, e, r) {
      var n = t("glslify");
      r.pointVertex = n(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\n\nuniform mat3 matrix;\nuniform float pointSize;\nuniform float pointCloud;\n\nhighp float rand(vec2 co) {\n  highp float a = 12.9898;\n  highp float b = 78.233;\n  highp float c = 43758.5453;\n  highp float d = dot(co.xy, vec2(a, b));\n  highp float e = mod(d, 3.14);\n  return fract(sin(e) * c);\n}\n\nvoid main() {\n  vec3 hgPosition = matrix * vec3(position, 1);\n  gl_Position  = vec4(hgPosition.xy, 0, hgPosition.z);\n    // if we don't jitter the point size a bit, overall point cloud\n    // saturation 'jumps' on zooming, which is disturbing and confusing\n  gl_PointSize = pointSize * ((19.5 + rand(position)) / 20.0);\n  if(pointCloud != 0.0) { // pointCloud is truthy\n    // get the same square surface as circle would be\n    gl_PointSize *= 0.886;\n  }\n}"]), r.pointFragment = n(["precision mediump float;\n#define GLSLIFY 1\n\nuniform vec4 color, borderColor;\nuniform float centerFraction;\nuniform float pointCloud;\n\nvoid main() {\n  float radius;\n  vec4 baseColor;\n  if(pointCloud != 0.0) { // pointCloud is truthy\n    if(centerFraction == 1.0) {\n      gl_FragColor = color;\n    } else {\n      gl_FragColor = mix(borderColor, color, centerFraction);\n    }\n  } else {\n    radius = length(2.0 * gl_PointCoord.xy - 1.0);\n    if(radius > 1.0) {\n      discard;\n    }\n    baseColor = mix(borderColor, color, step(radius, centerFraction));\n    gl_FragColor = vec4(baseColor.rgb * baseColor.a, baseColor.a);\n  }\n}\n"]), r.pickVertex = n(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\nattribute vec4 pickId;\n\nuniform mat3 matrix;\nuniform float pointSize;\nuniform vec4 pickOffset;\n\nvarying vec4 fragId;\n\nvoid main() {\n  vec3 hgPosition = matrix * vec3(position, 1);\n  gl_Position  = vec4(hgPosition.xy, 0, hgPosition.z);\n  gl_PointSize = pointSize;\n\n  vec4 id = pickId + pickOffset;\n  id.y += floor(id.x / 256.0);\n  id.x -= floor(id.x / 256.0) * 256.0;\n\n  id.z += floor(id.y / 256.0);\n  id.y -= floor(id.y / 256.0) * 256.0;\n\n  id.w += floor(id.z / 256.0);\n  id.z -= floor(id.z / 256.0) * 256.0;\n\n  fragId = id;\n}\n"]), r.pickFragment = n(["precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 fragId;\n\nvoid main() {\n  float radius = length(2.0 * gl_PointCoord.xy - 1.0);\n  if(radius > 1.0) {\n    discard;\n  }\n  gl_FragColor = fragId / 255.0;\n}\n"]);
    }, {
      glslify: 433
    }],
    319: [function (t, e, r) {
      "use strict";

      var n = t("gl-shader"),
          i = t("gl-buffer"),
          a = t("typedarray-pool"),
          o = t("./lib/shader");

      function s(t, e, r, n, i) {
        this.plot = t, this.offsetBuffer = e, this.pickBuffer = r, this.shader = n, this.pickShader = i, this.sizeMin = .5, this.sizeMinCap = 2, this.sizeMax = 20, this.areaRatio = 1, this.pointCount = 0, this.color = [1, 0, 0, 1], this.borderColor = [0, 0, 0, 1], this.blend = !1, this.pickOffset = 0, this.points = null;
      }

      e.exports = function (t, e) {
        var r = t.gl,
            a = i(r),
            l = i(r),
            c = n(r, o.pointVertex, o.pointFragment),
            u = n(r, o.pickVertex, o.pickFragment),
            f = new s(t, a, l, c, u);
        return f.update(e), t.addObject(f), f;
      };

      var l,
          c,
          u = s.prototype;
      u.dispose = function () {
        this.shader.dispose(), this.pickShader.dispose(), this.offsetBuffer.dispose(), this.pickBuffer.dispose(), this.plot.removeObject(this);
      }, u.update = function (t) {
        var e;

        function r(e, r) {
          return e in t ? t[e] : r;
        }

        t = t || {}, this.sizeMin = r("sizeMin", .5), this.sizeMax = r("sizeMax", 20), this.color = r("color", [1, 0, 0, 1]).slice(), this.areaRatio = r("areaRatio", 1), this.borderColor = r("borderColor", [0, 0, 0, 1]).slice(), this.blend = r("blend", !1);
        var n = t.positions.length >>> 1,
            i = t.positions instanceof Float32Array,
            o = t.idToIndex instanceof Int32Array && t.idToIndex.length >= n,
            s = t.positions,
            l = i ? s : a.mallocFloat32(s.length),
            c = o ? t.idToIndex : a.mallocInt32(n);
        if (i || l.set(s), !o) for (l.set(s), e = 0; e < n; e++) {
          c[e] = e;
        }
        this.points = s, this.offsetBuffer.update(l), this.pickBuffer.update(c), i || a.free(l), o || a.free(c), this.pointCount = n, this.pickOffset = 0;
      }, u.unifiedDraw = (l = [1, 0, 0, 0, 1, 0, 0, 0, 1], c = [0, 0, 0, 0], function (t) {
        var e = void 0 !== t,
            r = e ? this.pickShader : this.shader,
            n = this.plot.gl,
            i = this.plot.dataBox;
        if (0 === this.pointCount) return t;

        var a = i[2] - i[0],
            o = i[3] - i[1],
            s = function (t, e) {
          var r,
              n = 0,
              i = t.length >>> 1;

          for (r = 0; r < i; r++) {
            var a = t[2 * r],
                o = t[2 * r + 1];
            a >= e[0] && a <= e[2] && o >= e[1] && o <= e[3] && n++;
          }

          return n;
        }(this.points, i),
            u = this.plot.pickPixelRatio * Math.max(Math.min(this.sizeMinCap, this.sizeMin), Math.min(this.sizeMax, this.sizeMax / Math.pow(s, .33333)));

        l[0] = 2 / a, l[4] = 2 / o, l[6] = -2 * i[0] / a - 1, l[7] = -2 * i[1] / o - 1, this.offsetBuffer.bind(), r.bind(), r.attributes.position.pointer(), r.uniforms.matrix = l, r.uniforms.color = this.color, r.uniforms.borderColor = this.borderColor, r.uniforms.pointCloud = u < 5, r.uniforms.pointSize = u, r.uniforms.centerFraction = Math.min(1, Math.max(0, Math.sqrt(1 - this.areaRatio))), e && (c[0] = 255 & t, c[1] = t >> 8 & 255, c[2] = t >> 16 & 255, c[3] = t >> 24 & 255, this.pickBuffer.bind(), r.attributes.pickId.pointer(n.UNSIGNED_BYTE), r.uniforms.pickOffset = c, this.pickOffset = t);
        var f = n.getParameter(n.BLEND),
            h = n.getParameter(n.DITHER);
        return f && !this.blend && n.disable(n.BLEND), h && n.disable(n.DITHER), n.drawArrays(n.POINTS, 0, this.pointCount), f && !this.blend && n.enable(n.BLEND), h && n.enable(n.DITHER), t + this.pointCount;
      }), u.draw = u.unifiedDraw, u.drawPick = u.unifiedDraw, u.pick = function (t, e, r) {
        var n = this.pickOffset,
            i = this.pointCount;
        if (r < n || r >= n + i) return null;
        var a = r - n,
            o = this.points;
        return {
          object: this,
          pointId: a,
          dataCoord: [o[2 * a], o[2 * a + 1]]
        };
      };
    }, {
      "./lib/shader": 318,
      "gl-buffer": 258,
      "gl-shader": 330,
      "typedarray-pool": 609
    }],
    320: [function (t, e, r) {
      e.exports = function (t, e, r, n) {
        var i,
            a,
            o,
            s,
            l,
            c = e[0],
            u = e[1],
            f = e[2],
            h = e[3],
            p = r[0],
            d = r[1],
            m = r[2],
            g = r[3];
        (a = c * p + u * d + f * m + h * g) < 0 && (a = -a, p = -p, d = -d, m = -m, g = -g);
        1 - a > 1e-6 ? (i = Math.acos(a), o = Math.sin(i), s = Math.sin((1 - n) * i) / o, l = Math.sin(n * i) / o) : (s = 1 - n, l = n);
        return t[0] = s * c + l * p, t[1] = s * u + l * d, t[2] = s * f + l * m, t[3] = s * h + l * g, t;
      };
    }, {}],
    321: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        return t || 0 === t ? t.toString() : "";
      };
    }, {}],
    322: [function (t, e, r) {
      "use strict";

      var n = t("vectorize-text");

      e.exports = function (t, e, r) {
        var a = i[e];
        a || (a = i[e] = {});
        if (t in a) return a[t];
        var o = {
          textAlign: "center",
          textBaseline: "middle",
          lineHeight: 1,
          font: e,
          lineSpacing: 1.25,
          styletags: {
            breaklines: !0,
            bolds: !0,
            italics: !0,
            subscripts: !0,
            superscripts: !0
          },
          triangles: !0
        },
            s = n(t, o);
        o.triangles = !1;
        var l,
            c,
            u = n(t, o);

        if (r && 1 !== r) {
          for (l = 0; l < s.positions.length; ++l) {
            for (c = 0; c < s.positions[l].length; ++c) {
              s.positions[l][c] /= r;
            }
          }

          for (l = 0; l < u.positions.length; ++l) {
            for (c = 0; c < u.positions[l].length; ++c) {
              u.positions[l][c] /= r;
            }
          }
        }

        var f = [[1 / 0, 1 / 0], [-1 / 0, -1 / 0]],
            h = u.positions.length;

        for (l = 0; l < h; ++l) {
          var p = u.positions[l];

          for (c = 0; c < 2; ++c) {
            f[0][c] = Math.min(f[0][c], p[c]), f[1][c] = Math.max(f[1][c], p[c]);
          }
        }

        return a[t] = [s, u, f];
      };

      var i = {};
    }, {
      "vectorize-text": 615
    }],
    323: [function (t, e, r) {
      var n = t("gl-shader"),
          i = t("glslify"),
          a = i(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform vec4 highlightId;\nuniform float highlightScale;\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float scale = 1.0;\n    if(distance(highlightId, id) < 0.0001) {\n      scale = highlightScale;\n    }\n\n    vec4 worldPosition = model * vec4(position, 1);\n    vec4 viewPosition = view * worldPosition;\n    viewPosition = viewPosition / viewPosition.w;\n    vec4 clipPosition = projection * (viewPosition + scale * vec4(glyph.x, -glyph.y, 0, 0));\n\n    gl_Position = clipPosition;\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = position;\n  }\n}"]),
          o = i(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform vec2 screenSize;\nuniform vec3 clipBounds[2];\nuniform float highlightScale, pixelRatio;\nuniform vec4 highlightId;\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float scale = pixelRatio;\n    if(distance(highlightId.bgr, id.bgr) < 0.001) {\n      scale *= highlightScale;\n    }\n\n    vec4 worldPosition = model * vec4(position, 1.0);\n    vec4 viewPosition = view * worldPosition;\n    vec4 clipPosition = projection * viewPosition;\n    clipPosition /= clipPosition.w;\n\n    gl_Position = clipPosition + vec4(screenSize * scale * vec2(glyph.x, -glyph.y), 0.0, 0.0);\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = position;\n  }\n}"]),
          s = i(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform float highlightScale;\nuniform vec4 highlightId;\nuniform vec3 axes[2];\nuniform mat4 model, view, projection;\nuniform vec2 screenSize;\nuniform vec3 clipBounds[2];\nuniform float scale, pixelRatio;\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float lscale = pixelRatio * scale;\n    if(distance(highlightId, id) < 0.0001) {\n      lscale *= highlightScale;\n    }\n\n    vec4 clipCenter   = projection * view * model * vec4(position, 1);\n    vec3 dataPosition = position + 0.5*lscale*(axes[0] * glyph.x + axes[1] * glyph.y) * clipCenter.w * screenSize.y;\n    vec4 clipPosition = projection * view * model * vec4(dataPosition, 1);\n\n    gl_Position = clipPosition;\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = dataPosition;\n  }\n}\n"]),
          l = i(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 fragClipBounds[2];\nuniform float opacity;\n\nvarying vec4 interpColor;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (\n    outOfRange(fragClipBounds[0], fragClipBounds[1], dataCoordinate) ||\n    interpColor.a * opacity == 0.\n  ) discard;\n  gl_FragColor = interpColor * opacity;\n}\n"]),
          c = i(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 fragClipBounds[2];\nuniform float pickGroup;\n\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(fragClipBounds[0], fragClipBounds[1], dataCoordinate)) discard;\n\n  gl_FragColor = vec4(pickGroup, pickId.bgr);\n}"]),
          u = [{
        name: "position",
        type: "vec3"
      }, {
        name: "color",
        type: "vec4"
      }, {
        name: "glyph",
        type: "vec2"
      }, {
        name: "id",
        type: "vec4"
      }],
          f = {
        vertex: a,
        fragment: l,
        attributes: u
      },
          h = {
        vertex: o,
        fragment: l,
        attributes: u
      },
          p = {
        vertex: s,
        fragment: l,
        attributes: u
      },
          d = {
        vertex: a,
        fragment: c,
        attributes: u
      },
          m = {
        vertex: o,
        fragment: c,
        attributes: u
      },
          g = {
        vertex: s,
        fragment: c,
        attributes: u
      };

      function v(t, e) {
        var r = n(t, e),
            i = r.attributes;
        return i.position.location = 0, i.color.location = 1, i.glyph.location = 2, i.id.location = 3, r;
      }

      r.createPerspective = function (t) {
        return v(t, f);
      }, r.createOrtho = function (t) {
        return v(t, h);
      }, r.createProject = function (t) {
        return v(t, p);
      }, r.createPickPerspective = function (t) {
        return v(t, d);
      }, r.createPickOrtho = function (t) {
        return v(t, m);
      }, r.createPickProject = function (t) {
        return v(t, g);
      };
    }, {
      "gl-shader": 330,
      glslify: 324
    }],
    324: [function (t, e, r) {
      arguments[4][256][0].apply(r, arguments);
    }, {
      dup: 256
    }],
    325: [function (t, e, r) {
      "use strict";

      var n = t("is-string-blank"),
          i = t("gl-buffer"),
          a = t("gl-vao"),
          o = t("typedarray-pool"),
          s = t("gl-mat4/multiply"),
          l = t("./lib/shaders"),
          c = t("./lib/glyphs"),
          u = t("./lib/get-simple-string"),
          f = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];

      function h(t, e) {
        var r = t[0],
            n = t[1],
            i = t[2],
            a = t[3];
        return t[0] = e[0] * r + e[4] * n + e[8] * i + e[12] * a, t[1] = e[1] * r + e[5] * n + e[9] * i + e[13] * a, t[2] = e[2] * r + e[6] * n + e[10] * i + e[14] * a, t[3] = e[3] * r + e[7] * n + e[11] * i + e[15] * a, t;
      }

      function p(t, e, r, n) {
        return h(n, n), h(n, n), h(n, n);
      }

      function d(t, e) {
        this.index = t, this.dataCoordinate = this.position = e;
      }

      function m(t) {
        return !0 === t || t > 1 ? 1 : t;
      }

      function g(t, e, r, n, i, a, o, s, l, c, u, f) {
        this.gl = t, this.pixelRatio = 1, this.shader = e, this.orthoShader = r, this.projectShader = n, this.pointBuffer = i, this.colorBuffer = a, this.glyphBuffer = o, this.idBuffer = s, this.vao = l, this.vertexCount = 0, this.lineVertexCount = 0, this.opacity = 1, this.hasAlpha = !1, this.lineWidth = 0, this.projectScale = [2 / 3, 2 / 3, 2 / 3], this.projectOpacity = [1, 1, 1], this.projectHasAlpha = !1, this.pickId = 0, this.pickPerspectiveShader = c, this.pickOrthoShader = u, this.pickProjectShader = f, this.points = [], this._selectResult = new d(0, [0, 0, 0]), this.useOrtho = !0, this.bounds = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]], this.axesProject = [!0, !0, !0], this.axesBounds = [[-1 / 0, -1 / 0, -1 / 0], [1 / 0, 1 / 0, 1 / 0]], this.highlightId = [1, 1, 1, 1], this.highlightScale = 2, this.clipBounds = [[-1 / 0, -1 / 0, -1 / 0], [1 / 0, 1 / 0, 1 / 0]], this.dirty = !0;
      }

      e.exports = function (t) {
        var e = t.gl,
            r = l.createPerspective(e),
            n = l.createOrtho(e),
            o = l.createProject(e),
            s = l.createPickPerspective(e),
            c = l.createPickOrtho(e),
            u = l.createPickProject(e),
            f = i(e),
            h = i(e),
            p = i(e),
            d = i(e),
            m = a(e, [{
          buffer: f,
          size: 3,
          type: e.FLOAT
        }, {
          buffer: h,
          size: 4,
          type: e.FLOAT
        }, {
          buffer: p,
          size: 2,
          type: e.FLOAT
        }, {
          buffer: d,
          size: 4,
          type: e.UNSIGNED_BYTE,
          normalized: !0
        }]),
            v = new g(e, r, n, o, f, h, p, d, m, s, c, u);
        return v.update(t), v;
      };

      var v = g.prototype;
      v.pickSlots = 1, v.setPickBase = function (t) {
        this.pickId = t;
      }, v.isTransparent = function () {
        if (this.hasAlpha) return !0;

        for (var t = 0; t < 3; ++t) {
          if (this.axesProject[t] && this.projectHasAlpha) return !0;
        }

        return !1;
      }, v.isOpaque = function () {
        if (!this.hasAlpha) return !0;

        for (var t = 0; t < 3; ++t) {
          if (this.axesProject[t] && !this.projectHasAlpha) return !0;
        }

        return !1;
      };
      var y = [0, 0],
          x = [0, 0, 0],
          b = [0, 0, 0],
          _ = [0, 0, 0, 1],
          w = [0, 0, 0, 1],
          T = f.slice(),
          k = [0, 0, 0],
          M = [[0, 0, 0], [0, 0, 0]];

      function A(t) {
        return t[0] = t[1] = t[2] = 0, t;
      }

      function S(t, e) {
        return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = 1, t;
      }

      function E(t, e, r, n) {
        return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[r] = n, t;
      }

      function L(t, e, r, n) {
        var i,
            a = e.axesProject,
            o = e.gl,
            l = t.uniforms,
            c = r.model || f,
            u = r.view || f,
            h = r.projection || f,
            d = e.axesBounds,
            m = function (t) {
          for (var e = M, r = 0; r < 2; ++r) {
            for (var n = 0; n < 3; ++n) {
              e[r][n] = Math.max(Math.min(t[r][n], 1e8), -1e8);
            }
          }

          return e;
        }(e.clipBounds);

        i = e.axes && e.axes.lastCubeProps ? e.axes.lastCubeProps.axis : [1, 1, 1], y[0] = 2 / o.drawingBufferWidth, y[1] = 2 / o.drawingBufferHeight, t.bind(), l.view = u, l.projection = h, l.screenSize = y, l.highlightId = e.highlightId, l.highlightScale = e.highlightScale, l.clipBounds = m, l.pickGroup = e.pickId / 255, l.pixelRatio = n;

        for (var g = 0; g < 3; ++g) {
          if (a[g]) {
            l.scale = e.projectScale[g], l.opacity = e.projectOpacity[g];

            for (var v = T, L = 0; L < 16; ++L) {
              v[L] = 0;
            }

            for (L = 0; L < 4; ++L) {
              v[5 * L] = 1;
            }

            v[5 * g] = 0, i[g] < 0 ? v[12 + g] = d[0][g] : v[12 + g] = d[1][g], s(v, c, v), l.model = v;
            var C = (g + 1) % 3,
                P = (g + 2) % 3,
                I = A(x),
                O = A(b);
            I[C] = 1, O[P] = 1;
            var z = p(0, 0, 0, S(_, I)),
                D = p(0, 0, 0, S(w, O));

            if (Math.abs(z[1]) > Math.abs(D[1])) {
              var R = z;
              z = D, D = R, R = I, I = O, O = R;
              var F = C;
              C = P, P = F;
            }

            z[0] < 0 && (I[C] = -1), D[1] > 0 && (O[P] = -1);
            var B = 0,
                N = 0;

            for (L = 0; L < 4; ++L) {
              B += Math.pow(c[4 * C + L], 2), N += Math.pow(c[4 * P + L], 2);
            }

            I[C] /= Math.sqrt(B), O[P] /= Math.sqrt(N), l.axes[0] = I, l.axes[1] = O, l.fragClipBounds[0] = E(k, m[0], g, -1e8), l.fragClipBounds[1] = E(k, m[1], g, 1e8), e.vao.bind(), e.vao.draw(o.TRIANGLES, e.vertexCount), e.lineWidth > 0 && (o.lineWidth(e.lineWidth * n), e.vao.draw(o.LINES, e.lineVertexCount, e.vertexCount)), e.vao.unbind();
          }
        }
      }

      var C = [[-1e8, -1e8, -1e8], [1e8, 1e8, 1e8]];

      function P(t, e, r, n, i, a, o) {
        var s = r.gl;

        if ((a === r.projectHasAlpha || o) && L(e, r, n, i), a === r.hasAlpha || o) {
          t.bind();
          var l = t.uniforms;
          l.model = n.model || f, l.view = n.view || f, l.projection = n.projection || f, y[0] = 2 / s.drawingBufferWidth, y[1] = 2 / s.drawingBufferHeight, l.screenSize = y, l.highlightId = r.highlightId, l.highlightScale = r.highlightScale, l.fragClipBounds = C, l.clipBounds = r.axes.bounds, l.opacity = r.opacity, l.pickGroup = r.pickId / 255, l.pixelRatio = i, r.vao.bind(), r.vao.draw(s.TRIANGLES, r.vertexCount), r.lineWidth > 0 && (s.lineWidth(r.lineWidth * i), r.vao.draw(s.LINES, r.lineVertexCount, r.vertexCount)), r.vao.unbind();
        }
      }

      function I(t, e, r, i) {
        var a;
        a = Array.isArray(t) ? e < t.length ? t[e] : void 0 : t, a = u(a);
        var o = !0;
        n(a) && (a = "\u25BC", o = !1);
        var s = c(a, r, i);
        return {
          mesh: s[0],
          lines: s[1],
          bounds: s[2],
          visible: o
        };
      }

      v.draw = function (t) {
        P(this.useOrtho ? this.orthoShader : this.shader, this.projectShader, this, t, this.pixelRatio, !1, !1);
      }, v.drawTransparent = function (t) {
        P(this.useOrtho ? this.orthoShader : this.shader, this.projectShader, this, t, this.pixelRatio, !0, !1);
      }, v.drawPick = function (t) {
        P(this.useOrtho ? this.pickOrthoShader : this.pickPerspectiveShader, this.pickProjectShader, this, t, 1, !0, !0);
      }, v.pick = function (t) {
        if (!t) return null;
        if (t.id !== this.pickId) return null;
        var e = t.value[2] + (t.value[1] << 8) + (t.value[0] << 16);
        if (e >= this.pointCount || e < 0) return null;
        var r = this.points[e],
            n = this._selectResult;
        n.index = e;

        for (var i = 0; i < 3; ++i) {
          n.position[i] = n.dataCoordinate[i] = r[i];
        }

        return n;
      }, v.highlight = function (t) {
        if (t) {
          var e = t.index,
              r = 255 & e,
              n = e >> 8 & 255,
              i = e >> 16 & 255;
          this.highlightId = [r / 255, n / 255, i / 255, 0];
        } else this.highlightId = [1, 1, 1, 1];
      }, v.update = function (t) {
        if ("perspective" in (t = t || {}) && (this.useOrtho = !t.perspective), "orthographic" in t && (this.useOrtho = !!t.orthographic), "lineWidth" in t && (this.lineWidth = t.lineWidth), "project" in t) if (Array.isArray(t.project)) this.axesProject = t.project;else {
          var e = !!t.project;
          this.axesProject = [e, e, e];
        }
        if ("projectScale" in t) if (Array.isArray(t.projectScale)) this.projectScale = t.projectScale.slice();else {
          var r = +t.projectScale;
          this.projectScale = [r, r, r];
        }

        if (this.projectHasAlpha = !1, "projectOpacity" in t) {
          if (Array.isArray(t.projectOpacity)) this.projectOpacity = t.projectOpacity.slice();else {
            r = +t.projectOpacity;
            this.projectOpacity = [r, r, r];
          }

          for (var n = 0; n < 3; ++n) {
            this.projectOpacity[n] = m(this.projectOpacity[n]), this.projectOpacity[n] < 1 && (this.projectHasAlpha = !0);
          }
        }

        this.hasAlpha = !1, "opacity" in t && (this.opacity = m(t.opacity), this.opacity < 1 && (this.hasAlpha = !0)), this.dirty = !0;
        var i,
            a,
            s = t.position,
            l = t.font || "normal",
            c = t.alignment || [0, 0];
        if (2 === c.length) i = c[0], a = c[1];else {
          i = [], a = [];

          for (n = 0; n < c.length; ++n) {
            i[n] = c[n][0], a[n] = c[n][1];
          }
        }
        var u = [1 / 0, 1 / 0, 1 / 0],
            f = [-1 / 0, -1 / 0, -1 / 0],
            h = t.glyph,
            p = t.color,
            d = t.size,
            g = t.angle,
            v = t.lineColor,
            y = -1,
            x = 0,
            b = 0,
            _ = 0;

        if (s.length) {
          _ = s.length;

          t: for (n = 0; n < _; ++n) {
            for (var w = s[n], T = 0; T < 3; ++T) {
              if (isNaN(w[T]) || !isFinite(w[T])) continue t;
            }

            var k = (N = I(h, n, l, this.pixelRatio)).mesh,
                M = N.lines,
                A = N.bounds;
            x += 3 * k.cells.length, b += 2 * M.edges.length;
          }
        }

        var S = x + b,
            E = o.mallocFloat(3 * S),
            L = o.mallocFloat(4 * S),
            C = o.mallocFloat(2 * S),
            P = o.mallocUint32(S);

        if (S > 0) {
          var O = 0,
              z = x,
              D = [0, 0, 0, 1],
              R = [0, 0, 0, 1],
              F = Array.isArray(p) && Array.isArray(p[0]),
              B = Array.isArray(v) && Array.isArray(v[0]);

          t: for (n = 0; n < _; ++n) {
            y += 1;

            for (w = s[n], T = 0; T < 3; ++T) {
              if (isNaN(w[T]) || !isFinite(w[T])) continue t;
              f[T] = Math.max(f[T], w[T]), u[T] = Math.min(u[T], w[T]);
            }

            k = (N = I(h, n, l, this.pixelRatio)).mesh, M = N.lines, A = N.bounds;
            var N,
                j = N.visible;
            if (j) {
              if (Array.isArray(p)) {
                if (3 === (U = F ? n < p.length ? p[n] : [0, 0, 0, 0] : p).length) {
                  for (T = 0; T < 3; ++T) {
                    D[T] = U[T];
                  }

                  D[3] = 1;
                } else if (4 === U.length) {
                  for (T = 0; T < 4; ++T) {
                    D[T] = U[T];
                  }

                  !this.hasAlpha && U[3] < 1 && (this.hasAlpha = !0);
                }
              } else D[0] = D[1] = D[2] = 0, D[3] = 1;
            } else D = [1, 1, 1, 0];
            if (j) {
              if (Array.isArray(v)) {
                var U;

                if (3 === (U = B ? n < v.length ? v[n] : [0, 0, 0, 0] : v).length) {
                  for (T = 0; T < 3; ++T) {
                    R[T] = U[T];
                  }

                  R[T] = 1;
                } else if (4 === U.length) {
                  for (T = 0; T < 4; ++T) {
                    R[T] = U[T];
                  }

                  !this.hasAlpha && U[3] < 1 && (this.hasAlpha = !0);
                }
              } else R[0] = R[1] = R[2] = 0, R[3] = 1;
            } else R = [1, 1, 1, 0];
            var V = .5;
            j ? Array.isArray(d) ? V = n < d.length ? +d[n] : 12 : d ? V = +d : this.useOrtho && (V = 12) : V = 0;
            var q = 0;
            Array.isArray(g) ? q = n < g.length ? +g[n] : 0 : g && (q = +g);
            var H = Math.cos(q),
                G = Math.sin(q);

            for (w = s[n], T = 0; T < 3; ++T) {
              f[T] = Math.max(f[T], w[T]), u[T] = Math.min(u[T], w[T]);
            }

            var Y = i,
                W = a;
            Y = 0;
            Array.isArray(i) ? Y = n < i.length ? i[n] : 0 : i && (Y = i);
            W = 0;
            Array.isArray(a) ? W = n < a.length ? a[n] : 0 : a && (W = a);
            var X = [Y *= Y > 0 ? 1 - A[0][0] : Y < 0 ? 1 + A[1][0] : 1, W *= W > 0 ? 1 - A[0][1] : W < 0 ? 1 + A[1][1] : 1],
                Z = k.cells || [],
                J = k.positions || [];

            for (T = 0; T < Z.length; ++T) {
              for (var K = Z[T], Q = 0; Q < 3; ++Q) {
                for (var $ = 0; $ < 3; ++$) {
                  E[3 * O + $] = w[$];
                }

                for ($ = 0; $ < 4; ++$) {
                  L[4 * O + $] = D[$];
                }

                P[O] = y;
                var tt = J[K[Q]];
                C[2 * O] = V * (H * tt[0] - G * tt[1] + X[0]), C[2 * O + 1] = V * (G * tt[0] + H * tt[1] + X[1]), O += 1;
              }
            }

            for (Z = M.edges, J = M.positions, T = 0; T < Z.length; ++T) {
              for (K = Z[T], Q = 0; Q < 2; ++Q) {
                for ($ = 0; $ < 3; ++$) {
                  E[3 * z + $] = w[$];
                }

                for ($ = 0; $ < 4; ++$) {
                  L[4 * z + $] = R[$];
                }

                P[z] = y;
                tt = J[K[Q]];
                C[2 * z] = V * (H * tt[0] - G * tt[1] + X[0]), C[2 * z + 1] = V * (G * tt[0] + H * tt[1] + X[1]), z += 1;
              }
            }
          }
        }

        this.bounds = [u, f], this.points = s, this.pointCount = s.length, this.vertexCount = x, this.lineVertexCount = b, this.pointBuffer.update(E), this.colorBuffer.update(L), this.glyphBuffer.update(C), this.idBuffer.update(P), o.free(E), o.free(L), o.free(C), o.free(P);
      }, v.dispose = function () {
        this.shader.dispose(), this.orthoShader.dispose(), this.pickPerspectiveShader.dispose(), this.pickOrthoShader.dispose(), this.vao.dispose(), this.pointBuffer.dispose(), this.colorBuffer.dispose(), this.glyphBuffer.dispose(), this.idBuffer.dispose();
      };
    }, {
      "./lib/get-simple-string": 321,
      "./lib/glyphs": 322,
      "./lib/shaders": 323,
      "gl-buffer": 258,
      "gl-mat4/multiply": 292,
      "gl-vao": 352,
      "is-string-blank": 449,
      "typedarray-pool": 609
    }],
    326: [function (t, e, r) {
      "use strict";

      var n = t("glslify");
      r.boxVertex = n(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 vertex;\n\nuniform vec2 cornerA, cornerB;\n\nvoid main() {\n  gl_Position = vec4(mix(cornerA, cornerB, vertex), 0, 1);\n}\n"]), r.boxFragment = n(["precision mediump float;\n#define GLSLIFY 1\n\nuniform vec4 color;\n\nvoid main() {\n  gl_FragColor = color;\n}\n"]);
    }, {
      glslify: 327
    }],
    327: [function (t, e, r) {
      arguments[4][256][0].apply(r, arguments);
    }, {
      dup: 256
    }],
    328: [function (t, e, r) {
      "use strict";

      var n = t("gl-shader"),
          i = t("gl-buffer"),
          a = t("./lib/shaders");

      function o(t, e, r) {
        this.plot = t, this.boxBuffer = e, this.boxShader = r, this.enabled = !0, this.selectBox = [1 / 0, 1 / 0, -1 / 0, -1 / 0], this.borderColor = [0, 0, 0, 1], this.innerFill = !1, this.innerColor = [0, 0, 0, .25], this.outerFill = !0, this.outerColor = [0, 0, 0, .5], this.borderWidth = 10;
      }

      e.exports = function (t, e) {
        var r = t.gl,
            s = i(r, [0, 0, 0, 1, 1, 0, 1, 1]),
            l = n(r, a.boxVertex, a.boxFragment),
            c = new o(t, s, l);
        return c.update(e), t.addOverlay(c), c;
      };

      var s = o.prototype;
      s.draw = function () {
        if (this.enabled) {
          var t = this.plot,
              e = this.selectBox,
              r = this.borderWidth,
              n = (this.innerFill, this.innerColor),
              i = (this.outerFill, this.outerColor),
              a = this.borderColor,
              o = t.box,
              s = t.screenBox,
              l = t.dataBox,
              c = t.viewBox,
              u = t.pixelRatio,
              f = (e[0] - l[0]) * (c[2] - c[0]) / (l[2] - l[0]) + c[0],
              h = (e[1] - l[1]) * (c[3] - c[1]) / (l[3] - l[1]) + c[1],
              p = (e[2] - l[0]) * (c[2] - c[0]) / (l[2] - l[0]) + c[0],
              d = (e[3] - l[1]) * (c[3] - c[1]) / (l[3] - l[1]) + c[1];

          if (f = Math.max(f, c[0]), h = Math.max(h, c[1]), p = Math.min(p, c[2]), d = Math.min(d, c[3]), !(p < f || d < h)) {
            o.bind();
            var m = s[2] - s[0],
                g = s[3] - s[1];

            if (this.outerFill && (o.drawBox(0, 0, m, h, i), o.drawBox(0, h, f, d, i), o.drawBox(0, d, m, g, i), o.drawBox(p, h, m, d, i)), this.innerFill && o.drawBox(f, h, p, d, n), r > 0) {
              var v = r * u;
              o.drawBox(f - v, h - v, p + v, h + v, a), o.drawBox(f - v, d - v, p + v, d + v, a), o.drawBox(f - v, h - v, f + v, d + v, a), o.drawBox(p - v, h - v, p + v, d + v, a);
            }
          }
        }
      }, s.update = function (t) {
        t = t || {}, this.innerFill = !!t.innerFill, this.outerFill = !!t.outerFill, this.innerColor = (t.innerColor || [0, 0, 0, .5]).slice(), this.outerColor = (t.outerColor || [0, 0, 0, .5]).slice(), this.borderColor = (t.borderColor || [0, 0, 0, 1]).slice(), this.borderWidth = t.borderWidth || 0, this.selectBox = (t.selectBox || this.selectBox).slice();
      }, s.dispose = function () {
        this.boxBuffer.dispose(), this.boxShader.dispose(), this.plot.removeOverlay(this);
      };
    }, {
      "./lib/shaders": 326,
      "gl-buffer": 258,
      "gl-shader": 330
    }],
    329: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        var r = e[0],
            a = e[1],
            o = n(t, r, a, {}),
            s = i.mallocUint8(r * a * 4);
        return new l(t, o, s);
      };

      var n = t("gl-fbo"),
          i = t("typedarray-pool"),
          a = t("ndarray"),
          o = t("bit-twiddle").nextPow2;

      function s(t, e, r, n, i) {
        this.coord = [t, e], this.id = r, this.value = n, this.distance = i;
      }

      function l(t, e, r) {
        this.gl = t, this.fbo = e, this.buffer = r, this._readTimeout = null;
        var n = this;

        this._readCallback = function () {
          n.gl && (e.bind(), t.readPixels(0, 0, e.shape[0], e.shape[1], t.RGBA, t.UNSIGNED_BYTE, n.buffer), n._readTimeout = null);
        };
      }

      var c = l.prototype;
      Object.defineProperty(c, "shape", {
        get: function get() {
          return this.gl ? this.fbo.shape.slice() : [0, 0];
        },
        set: function set(t) {
          if (this.gl) {
            this.fbo.shape = t;
            var e = this.fbo.shape[0],
                r = this.fbo.shape[1];

            if (r * e * 4 > this.buffer.length) {
              i.free(this.buffer);

              for (var n = this.buffer = i.mallocUint8(o(r * e * 4)), a = 0; a < r * e * 4; ++a) {
                n[a] = 255;
              }
            }

            return t;
          }
        }
      }), c.begin = function () {
        var t = this.gl;
        this.shape;
        t && (this.fbo.bind(), t.clearColor(1, 1, 1, 1), t.clear(t.COLOR_BUFFER_BIT | t.DEPTH_BUFFER_BIT));
      }, c.end = function () {
        var t = this.gl;
        t && (t.bindFramebuffer(t.FRAMEBUFFER, null), this._readTimeout || clearTimeout(this._readTimeout), this._readTimeout = setTimeout(this._readCallback, 1));
      }, c.query = function (t, e, r) {
        if (!this.gl) return null;
        var n = this.fbo.shape.slice();
        t |= 0, e |= 0, "number" != typeof r && (r = 1);
        var i = 0 | Math.min(Math.max(t - r, 0), n[0]),
            o = 0 | Math.min(Math.max(t + r, 0), n[0]),
            l = 0 | Math.min(Math.max(e - r, 0), n[1]),
            c = 0 | Math.min(Math.max(e + r, 0), n[1]);
        if (o <= i || c <= l) return null;

        var u = [o - i, c - l],
            f = a(this.buffer, [u[0], u[1], 4], [4, 4 * n[0], 1], 4 * (i + n[0] * l)),
            h = function (t, e, r) {
          for (var n = 1e8, i = -1, a = -1, o = t.shape[0], s = t.shape[1], l = 0; l < o; l++) {
            for (var c = 0; c < s; c++) {
              var u = t.get(l, c, 0),
                  f = t.get(l, c, 1),
                  h = t.get(l, c, 2),
                  p = t.get(l, c, 3);

              if (u < 255 || f < 255 || h < 255 || p < 255) {
                var d = e - l,
                    m = r - c,
                    g = d * d + m * m;
                g < n && (n = g, i = l, a = c);
              }
            }
          }

          return [i, a, n];
        }(f.hi(u[0], u[1], 1), r, r),
            p = h[0],
            d = h[1];

        return p < 0 || Math.pow(this.radius, 2) < h[2] ? null : new s(p + i | 0, d + l | 0, f.get(p, d, 0), [f.get(p, d, 1), f.get(p, d, 2), f.get(p, d, 3)], Math.sqrt(h[2]));
      }, c.dispose = function () {
        this.gl && (this.fbo.dispose(), i.free(this.buffer), this.gl = null, this._readTimeout && clearTimeout(this._readTimeout));
      };
    }, {
      "bit-twiddle": 99,
      "gl-fbo": 267,
      ndarray: 475,
      "typedarray-pool": 609
    }],
    330: [function (t, e, r) {
      "use strict";

      var n = t("./lib/create-uniforms"),
          i = t("./lib/create-attributes"),
          a = t("./lib/reflect"),
          o = t("./lib/shader-cache"),
          s = t("./lib/runtime-reflect"),
          l = t("./lib/GLError");

      function c(t) {
        this.gl = t, this.gl.lastAttribCount = 0, this._vref = this._fref = this._relink = this.vertShader = this.fragShader = this.program = this.attributes = this.uniforms = this.types = null;
      }

      var u = c.prototype;

      function f(t, e) {
        return t.name < e.name ? -1 : 1;
      }

      u.bind = function () {
        var t;
        this.program || this._relink();
        var e = this.gl.getProgramParameter(this.program, this.gl.ACTIVE_ATTRIBUTES),
            r = this.gl.lastAttribCount;
        if (e > r) for (t = r; t < e; t++) {
          this.gl.enableVertexAttribArray(t);
        } else if (r > e) for (t = e; t < r; t++) {
          this.gl.disableVertexAttribArray(t);
        }
        this.gl.lastAttribCount = e, this.gl.useProgram(this.program);
      }, u.dispose = function () {
        for (var t = this.gl.lastAttribCount, e = 0; e < t; e++) {
          this.gl.disableVertexAttribArray(e);
        }

        this.gl.lastAttribCount = 0, this._fref && this._fref.dispose(), this._vref && this._vref.dispose(), this.attributes = this.types = this.vertShader = this.fragShader = this.program = this._relink = this._fref = this._vref = null;
      }, u.update = function (t, e, r, c) {
        if (!e || 1 === arguments.length) {
          var u = t;
          t = u.vertex, e = u.fragment, r = u.uniforms, c = u.attributes;
        }

        var h = this,
            p = h.gl,
            d = h._vref;
        h._vref = o.shader(p, p.VERTEX_SHADER, t), d && d.dispose(), h.vertShader = h._vref.shader;
        var m = this._fref;

        if (h._fref = o.shader(p, p.FRAGMENT_SHADER, e), m && m.dispose(), h.fragShader = h._fref.shader, !r || !c) {
          var g = p.createProgram();

          if (p.attachShader(g, h.fragShader), p.attachShader(g, h.vertShader), p.linkProgram(g), !p.getProgramParameter(g, p.LINK_STATUS)) {
            var v = p.getProgramInfoLog(g);
            throw new l(v, "Error linking program:" + v);
          }

          r = r || s.uniforms(p, g), c = c || s.attributes(p, g), p.deleteProgram(g);
        }

        (c = c.slice()).sort(f);
        var y,
            x = [],
            b = [],
            _ = [];

        for (y = 0; y < c.length; ++y) {
          var w = c[y];

          if (w.type.indexOf("mat") >= 0) {
            for (var T = 0 | w.type.charAt(w.type.length - 1), k = new Array(T), M = 0; M < T; ++M) {
              k[M] = _.length, b.push(w.name + "[" + M + "]"), "number" == typeof w.location ? _.push(w.location + M) : Array.isArray(w.location) && w.location.length === T && "number" == typeof w.location[M] ? _.push(0 | w.location[M]) : _.push(-1);
            }

            x.push({
              name: w.name,
              type: w.type,
              locations: k
            });
          } else x.push({
            name: w.name,
            type: w.type,
            locations: [_.length]
          }), b.push(w.name), "number" == typeof w.location ? _.push(0 | w.location) : _.push(-1);
        }

        var A = 0;

        for (y = 0; y < _.length; ++y) {
          if (_[y] < 0) {
            for (; _.indexOf(A) >= 0;) {
              A += 1;
            }

            _[y] = A;
          }
        }

        var S = new Array(r.length);

        function E() {
          h.program = o.program(p, h._vref, h._fref, b, _);

          for (var t = 0; t < r.length; ++t) {
            S[t] = p.getUniformLocation(h.program, r[t].name);
          }
        }

        E(), h._relink = E, h.types = {
          uniforms: a(r),
          attributes: a(c)
        }, h.attributes = i(p, h, x, _), Object.defineProperty(h, "uniforms", n(p, h, r, S));
      }, e.exports = function (t, e, r, n, i) {
        var a = new c(t);
        return a.update(e, r, n, i), a;
      };
    }, {
      "./lib/GLError": 331,
      "./lib/create-attributes": 332,
      "./lib/create-uniforms": 333,
      "./lib/reflect": 334,
      "./lib/runtime-reflect": 335,
      "./lib/shader-cache": 336
    }],
    331: [function (t, e, r) {
      function n(t, e, r) {
        this.shortMessage = e || "", this.longMessage = r || "", this.rawError = t || "", this.message = "gl-shader: " + (e || t || "") + (r ? "\n" + r : ""), this.stack = new Error().stack;
      }

      n.prototype = new Error(), n.prototype.name = "GLError", n.prototype.constructor = n, e.exports = n;
    }, {}],
    332: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, i) {
        for (var a = {}, l = 0, c = r.length; l < c; ++l) {
          var u = r[l],
              f = u.name,
              h = u.type,
              p = u.locations;

          switch (h) {
            case "bool":
            case "int":
            case "float":
              o(t, e, p[0], i, 1, a, f);
              break;

            default:
              if (h.indexOf("vec") >= 0) {
                if ((d = h.charCodeAt(h.length - 1) - 48) < 2 || d > 4) throw new n("", "Invalid data type for attribute " + f + ": " + h);
                o(t, e, p[0], i, d, a, f);
              } else {
                if (!(h.indexOf("mat") >= 0)) throw new n("", "Unknown data type for attribute " + f + ": " + h);
                var d;
                if ((d = h.charCodeAt(h.length - 1) - 48) < 2 || d > 4) throw new n("", "Invalid data type for attribute " + f + ": " + h);
                s(t, e, p, i, d, a, f);
              }

          }
        }

        return a;
      };

      var n = t("./GLError");

      function i(t, e, r, n, i, a) {
        this._gl = t, this._wrapper = e, this._index = r, this._locations = n, this._dimension = i, this._constFunc = a;
      }

      var a = i.prototype;

      function o(t, e, r, n, a, o, s) {
        for (var l = ["gl", "v"], c = [], u = 0; u < a; ++u) {
          l.push("x" + u), c.push("x" + u);
        }

        l.push("if(x0.length===void 0){return gl.vertexAttrib" + a + "f(v," + c.join() + ")}else{return gl.vertexAttrib" + a + "fv(v,x0)}");
        var f = Function.apply(null, l),
            h = new i(t, e, r, n, a, f);
        Object.defineProperty(o, s, {
          set: function set(e) {
            return t.disableVertexAttribArray(n[r]), f(t, n[r], e), e;
          },
          get: function get() {
            return h;
          },
          enumerable: !0
        });
      }

      function s(t, e, r, n, i, a, s) {
        for (var l = new Array(i), c = new Array(i), u = 0; u < i; ++u) {
          o(t, e, r[u], n, i, l, u), c[u] = l[u];
        }

        Object.defineProperty(l, "location", {
          set: function set(t) {
            if (Array.isArray(t)) for (var e = 0; e < i; ++e) {
              c[e].location = t[e];
            } else for (e = 0; e < i; ++e) {
              c[e].location = t + e;
            }
            return t;
          },
          get: function get() {
            for (var t = new Array(i), e = 0; e < i; ++e) {
              t[e] = n[r[e]];
            }

            return t;
          },
          enumerable: !0
        }), l.pointer = function (e, a, o, s) {
          e = e || t.FLOAT, a = !!a, o = o || i * i, s = s || 0;

          for (var l = 0; l < i; ++l) {
            var c = n[r[l]];
            t.vertexAttribPointer(c, i, e, a, o, s + l * i), t.enableVertexAttribArray(c);
          }
        };
        var f = new Array(i),
            h = t["vertexAttrib" + i + "fv"];
        Object.defineProperty(a, s, {
          set: function set(e) {
            for (var a = 0; a < i; ++a) {
              var o = n[r[a]];
              if (t.disableVertexAttribArray(o), Array.isArray(e[0])) h.call(t, o, e[a]);else {
                for (var s = 0; s < i; ++s) {
                  f[s] = e[i * a + s];
                }

                h.call(t, o, f);
              }
            }

            return e;
          },
          get: function get() {
            return l;
          },
          enumerable: !0
        });
      }

      a.pointer = function (t, e, r, n) {
        var i = this._gl,
            a = this._locations[this._index];
        i.vertexAttribPointer(a, this._dimension, t || i.FLOAT, !!e, r || 0, n || 0), i.enableVertexAttribArray(a);
      }, a.set = function (t, e, r, n) {
        return this._constFunc(this._locations[this._index], t, e, r, n);
      }, Object.defineProperty(a, "location", {
        get: function get() {
          return this._locations[this._index];
        },
        set: function set(t) {
          return t !== this._locations[this._index] && (this._locations[this._index] = 0 | t, this._wrapper.program = null), 0 | t;
        }
      });
    }, {
      "./GLError": 331
    }],
    333: [function (t, e, r) {
      "use strict";

      var n = t("./reflect"),
          i = t("./GLError");

      function a(t) {
        return new Function("y", "return function(){return y}")(t);
      }

      function o(t, e) {
        for (var r = new Array(t), n = 0; n < t; ++n) {
          r[n] = e;
        }

        return r;
      }

      e.exports = function (t, e, r, s) {
        function l(t, e, r) {
          switch (r) {
            case "bool":
            case "int":
            case "sampler2D":
            case "samplerCube":
              return "gl.uniform1i(locations[" + e + "],obj" + t + ")";

            case "float":
              return "gl.uniform1f(locations[" + e + "],obj" + t + ")";

            default:
              var n = r.indexOf("vec");

              if (!(0 <= n && n <= 1 && r.length === 4 + n)) {
                if (0 === r.indexOf("mat") && 4 === r.length) {
                  var a;
                  if ((a = r.charCodeAt(r.length - 1) - 48) < 2 || a > 4) throw new i("", "Invalid uniform dimension type for matrix " + name + ": " + r);
                  return "gl.uniformMatrix" + a + "fv(locations[" + e + "],false,obj" + t + ")";
                }

                throw new i("", "Unknown uniform data type for " + name + ": " + r);
              }

              if ((a = r.charCodeAt(r.length - 1) - 48) < 2 || a > 4) throw new i("", "Invalid data type");

              switch (r.charAt(0)) {
                case "b":
                case "i":
                  return "gl.uniform" + a + "iv(locations[" + e + "],obj" + t + ")";

                case "v":
                  return "gl.uniform" + a + "fv(locations[" + e + "],obj" + t + ")";

                default:
                  throw new i("", "Unrecognized data type for vector " + name + ": " + r);
              }

          }
        }

        function c(e) {
          for (var n = ["return function updateProperty(obj){"], i = function t(e, r) {
            if ("object" != _typeof(r)) return [[e, r]];
            var n = [];

            for (var i in r) {
              var a = r[i],
                  o = e;
              parseInt(i) + "" === i ? o += "[" + i + "]" : o += "." + i, "object" == _typeof(a) ? n.push.apply(n, t(o, a)) : n.push([o, a]);
            }

            return n;
          }("", e), a = 0; a < i.length; ++a) {
            var o = i[a],
                c = o[0],
                u = o[1];
            s[u] && n.push(l(c, u, r[u].type));
          }

          return n.push("return obj}"), new Function("gl", "locations", n.join("\n"))(t, s);
        }

        function u(n, l, u) {
          if ("object" == _typeof(u)) {
            var h = f(u);
            Object.defineProperty(n, l, {
              get: a(h),
              set: c(u),
              enumerable: !0,
              configurable: !1
            });
          } else s[u] ? Object.defineProperty(n, l, {
            get: (p = u, new Function("gl", "wrapper", "locations", "return function(){return gl.getUniform(wrapper.program,locations[" + p + "])}")(t, e, s)),
            set: c(u),
            enumerable: !0,
            configurable: !1
          }) : n[l] = function (t) {
            switch (t) {
              case "bool":
                return !1;

              case "int":
              case "sampler2D":
              case "samplerCube":
              case "float":
                return 0;

              default:
                var e = t.indexOf("vec");

                if (0 <= e && e <= 1 && t.length === 4 + e) {
                  if ((r = t.charCodeAt(t.length - 1) - 48) < 2 || r > 4) throw new i("", "Invalid data type");
                  return "b" === t.charAt(0) ? o(r, !1) : o(r, 0);
                }

                if (0 === t.indexOf("mat") && 4 === t.length) {
                  var r;
                  if ((r = t.charCodeAt(t.length - 1) - 48) < 2 || r > 4) throw new i("", "Invalid uniform dimension type for matrix " + name + ": " + t);
                  return o(r * r, 0);
                }

                throw new i("", "Unknown uniform data type for " + name + ": " + t);
            }
          }(r[u].type);

          var p;
        }

        function f(t) {
          var e;

          if (Array.isArray(t)) {
            e = new Array(t.length);

            for (var r = 0; r < t.length; ++r) {
              u(e, r, t[r]);
            }
          } else for (var n in e = {}, t) {
            u(e, n, t[n]);
          }

          return e;
        }

        var h = n(r, !0);
        return {
          get: a(f(h)),
          set: c(h),
          enumerable: !0,
          configurable: !0
        };
      };
    }, {
      "./GLError": 331,
      "./reflect": 334
    }],
    334: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        for (var r = {}, n = 0; n < t.length; ++n) {
          for (var i = t[n].name.split("."), a = r, o = 0; o < i.length; ++o) {
            var s = i[o].split("[");

            if (s.length > 1) {
              s[0] in a || (a[s[0]] = []), a = a[s[0]];

              for (var l = 1; l < s.length; ++l) {
                var c = parseInt(s[l]);
                l < s.length - 1 || o < i.length - 1 ? (c in a || (l < s.length - 1 ? a[c] = [] : a[c] = {}), a = a[c]) : a[c] = e ? n : t[n].type;
              }
            } else o < i.length - 1 ? (s[0] in a || (a[s[0]] = {}), a = a[s[0]]) : a[s[0]] = e ? n : t[n].type;
          }
        }

        return r;
      };
    }, {}],
    335: [function (t, e, r) {
      "use strict";

      r.uniforms = function (t, e) {
        for (var r = t.getProgramParameter(e, t.ACTIVE_UNIFORMS), n = [], i = 0; i < r; ++i) {
          var o = t.getActiveUniform(e, i);

          if (o) {
            var s = a(t, o.type);
            if (o.size > 1) for (var l = 0; l < o.size; ++l) {
              n.push({
                name: o.name.replace("[0]", "[" + l + "]"),
                type: s
              });
            } else n.push({
              name: o.name,
              type: s
            });
          }
        }

        return n;
      }, r.attributes = function (t, e) {
        for (var r = t.getProgramParameter(e, t.ACTIVE_ATTRIBUTES), n = [], i = 0; i < r; ++i) {
          var o = t.getActiveAttrib(e, i);
          o && n.push({
            name: o.name,
            type: a(t, o.type)
          });
        }

        return n;
      };
      var n = {
        FLOAT: "float",
        FLOAT_VEC2: "vec2",
        FLOAT_VEC3: "vec3",
        FLOAT_VEC4: "vec4",
        INT: "int",
        INT_VEC2: "ivec2",
        INT_VEC3: "ivec3",
        INT_VEC4: "ivec4",
        BOOL: "bool",
        BOOL_VEC2: "bvec2",
        BOOL_VEC3: "bvec3",
        BOOL_VEC4: "bvec4",
        FLOAT_MAT2: "mat2",
        FLOAT_MAT3: "mat3",
        FLOAT_MAT4: "mat4",
        SAMPLER_2D: "sampler2D",
        SAMPLER_CUBE: "samplerCube"
      },
          i = null;

      function a(t, e) {
        if (!i) {
          var r = Object.keys(n);
          i = {};

          for (var a = 0; a < r.length; ++a) {
            var o = r[a];
            i[t[o]] = n[o];
          }
        }

        return i[e];
      }
    }, {}],
    336: [function (t, e, r) {
      "use strict";

      r.shader = function (t, e, r) {
        return u(t).getShaderReference(e, r);
      }, r.program = function (t, e, r, n, i) {
        return u(t).getProgram(e, r, n, i);
      };
      var n = t("./GLError"),
          i = t("gl-format-compiler-error"),
          a = new ("undefined" == typeof WeakMap ? t("weakmap-shim") : WeakMap)(),
          o = 0;

      function s(t, e, r, n, i, a, o) {
        this.id = t, this.src = e, this.type = r, this.shader = n, this.count = a, this.programs = [], this.cache = o;
      }

      function l(t) {
        this.gl = t, this.shaders = [{}, {}], this.programs = {};
      }

      s.prototype.dispose = function () {
        if (0 == --this.count) {
          for (var t = this.cache, e = t.gl, r = this.programs, n = 0, i = r.length; n < i; ++n) {
            var a = t.programs[r[n]];
            a && (delete t.programs[n], e.deleteProgram(a));
          }

          e.deleteShader(this.shader), delete t.shaders[this.type === e.FRAGMENT_SHADER | 0][this.src];
        }
      };

      var c = l.prototype;

      function u(t) {
        var e = a.get(t);
        return e || (e = new l(t), a.set(t, e)), e;
      }

      c.getShaderReference = function (t, e) {
        var r = this.gl,
            a = this.shaders[t === r.FRAGMENT_SHADER | 0],
            l = a[e];
        if (l && r.isShader(l.shader)) l.count += 1;else {
          var c = function (t, e, r) {
            var a = t.createShader(e);

            if (t.shaderSource(a, r), t.compileShader(a), !t.getShaderParameter(a, t.COMPILE_STATUS)) {
              var o = t.getShaderInfoLog(a);

              try {
                var s = i(o, r, e);
              } catch (t) {
                throw console.warn("Failed to format compiler error: " + t), new n(o, "Error compiling shader:\n" + o);
              }

              throw new n(o, s.short, s.long);
            }

            return a;
          }(r, t, e);

          l = a[e] = new s(o++, e, t, c, [], 1, this);
        }
        return l;
      }, c.getProgram = function (t, e, r, i) {
        var a = [t.id, e.id, r.join(":"), i.join(":")].join("@"),
            o = this.programs[a];
        return o && this.gl.isProgram(o) || (this.programs[a] = o = function (t, e, r, i, a) {
          var o = t.createProgram();
          t.attachShader(o, e), t.attachShader(o, r);

          for (var s = 0; s < i.length; ++s) {
            t.bindAttribLocation(o, a[s], i[s]);
          }

          if (t.linkProgram(o), !t.getProgramParameter(o, t.LINK_STATUS)) {
            var l = t.getProgramInfoLog(o);
            throw new n(l, "Error linking program: " + l);
          }

          return o;
        }(this.gl, t.shader, e.shader, r, i), t.programs.push(a), e.programs.push(a)), o;
      };
    }, {
      "./GLError": 331,
      "gl-format-compiler-error": 268,
      "weakmap-shim": 620
    }],
    337: [function (t, e, r) {
      "use strict";

      function n(t) {
        this.plot = t, this.enable = [!0, !0, !1, !1], this.width = [1, 1, 1, 1], this.color = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.center = [1 / 0, 1 / 0];
      }

      e.exports = function (t, e) {
        var r = new n(t);
        return r.update(e), t.addOverlay(r), r;
      };

      var i = n.prototype;
      i.update = function (t) {
        t = t || {}, this.enable = (t.enable || [!0, !0, !1, !1]).slice(), this.width = (t.width || [1, 1, 1, 1]).slice(), this.color = (t.color || [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]]).map(function (t) {
          return t.slice();
        }), this.center = (t.center || [1 / 0, 1 / 0]).slice(), this.plot.setOverlayDirty();
      }, i.draw = function () {
        var t = this.enable,
            e = this.width,
            r = this.color,
            n = this.center,
            i = this.plot,
            a = i.line,
            o = i.dataBox,
            s = i.viewBox;

        if (a.bind(), o[0] <= n[0] && n[0] <= o[2] && o[1] <= n[1] && n[1] <= o[3]) {
          var l = s[0] + (n[0] - o[0]) / (o[2] - o[0]) * (s[2] - s[0]),
              c = s[1] + (n[1] - o[1]) / (o[3] - o[1]) * (s[3] - s[1]);
          t[0] && a.drawLine(l, c, s[0], c, e[0], r[0]), t[1] && a.drawLine(l, c, l, s[1], e[1], r[1]), t[2] && a.drawLine(l, c, s[2], c, e[2], r[2]), t[3] && a.drawLine(l, c, l, s[3], e[3], r[3]);
        }
      }, i.dispose = function () {
        this.plot.removeOverlay(this);
      };
    }, {}],
    338: [function (t, e, r) {
      arguments[4][256][0].apply(r, arguments);
    }, {
      dup: 256
    }],
    339: [function (t, e, r) {
      "use strict";

      var n = t("glslify"),
          i = t("gl-shader"),
          a = n(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 position, color;\nattribute float weight;\n\nuniform mat4 model, view, projection;\nuniform vec3 coordinates[3];\nuniform vec4 colors[3];\nuniform vec2 screenShape;\nuniform float lineWidth;\n\nvarying vec4 fragColor;\n\nvoid main() {\n  vec3 vertexPosition = mix(coordinates[0],\n    mix(coordinates[2], coordinates[1], 0.5 * (position + 1.0)), abs(position));\n\n  vec4 clipPos = projection * view * model * vec4(vertexPosition, 1.0);\n  vec2 clipOffset = (projection * view * model * vec4(color, 0.0)).xy;\n  vec2 delta = weight * clipOffset * screenShape;\n  vec2 lineOffset = normalize(vec2(delta.y, -delta.x)) / screenShape;\n\n  gl_Position   = vec4(clipPos.xy + clipPos.w * 0.5 * lineWidth * lineOffset, clipPos.z, clipPos.w);\n  fragColor     = color.x * colors[0] + color.y * colors[1] + color.z * colors[2];\n}\n"]),
          o = n(["precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nvoid main() {\n  gl_FragColor = fragColor;\n}"]);

      e.exports = function (t) {
        return i(t, a, o, null, [{
          name: "position",
          type: "vec3"
        }, {
          name: "color",
          type: "vec3"
        }, {
          name: "weight",
          type: "float"
        }]);
      };
    }, {
      "gl-shader": 330,
      glslify: 338
    }],
    340: [function (t, e, r) {
      "use strict";

      var n = t("gl-buffer"),
          i = t("gl-vao"),
          a = t("./shaders/index");

      e.exports = function (t, e) {
        var r = [];

        function o(t, e, n, i, a, o) {
          var s = [t, e, n, 0, 0, 0, 1];
          s[i + 3] = 1, s[i] = a, r.push.apply(r, s), s[6] = -1, r.push.apply(r, s), s[i] = o, r.push.apply(r, s), r.push.apply(r, s), s[6] = 1, r.push.apply(r, s), s[i] = a, r.push.apply(r, s);
        }

        o(0, 0, 0, 0, 0, 1), o(0, 0, 0, 1, 0, 1), o(0, 0, 0, 2, 0, 1), o(1, 0, 0, 1, -1, 1), o(1, 0, 0, 2, -1, 1), o(0, 1, 0, 0, -1, 1), o(0, 1, 0, 2, -1, 1), o(0, 0, 1, 0, -1, 1), o(0, 0, 1, 1, -1, 1);
        var l = n(t, r),
            c = i(t, [{
          type: t.FLOAT,
          buffer: l,
          size: 3,
          offset: 0,
          stride: 28
        }, {
          type: t.FLOAT,
          buffer: l,
          size: 3,
          offset: 12,
          stride: 28
        }, {
          type: t.FLOAT,
          buffer: l,
          size: 1,
          offset: 24,
          stride: 28
        }]),
            u = a(t);
        u.attributes.position.location = 0, u.attributes.color.location = 1, u.attributes.weight.location = 2;
        var f = new s(t, l, c, u);
        return f.update(e), f;
      };

      var o = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];

      function s(t, e, r, n) {
        this.gl = t, this.buffer = e, this.vao = r, this.shader = n, this.pixelRatio = 1, this.bounds = [[-1e3, -1e3, -1e3], [1e3, 1e3, 1e3]], this.position = [0, 0, 0], this.lineWidth = [2, 2, 2], this.colors = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.enabled = [!0, !0, !0], this.drawSides = [!0, !0, !0], this.axes = null;
      }

      var l = s.prototype,
          c = [0, 0, 0],
          u = [0, 0, 0],
          f = [0, 0];
      l.isTransparent = function () {
        return !1;
      }, l.drawTransparent = function (t) {}, l.draw = function (t) {
        var e = this.gl,
            r = this.vao,
            n = this.shader;
        r.bind(), n.bind();
        var i,
            a = t.model || o,
            s = t.view || o,
            l = t.projection || o;
        this.axes && (i = this.axes.lastCubeProps.axis);

        for (var h = c, p = u, d = 0; d < 3; ++d) {
          i && i[d] < 0 ? (h[d] = this.bounds[0][d], p[d] = this.bounds[1][d]) : (h[d] = this.bounds[1][d], p[d] = this.bounds[0][d]);
        }

        f[0] = e.drawingBufferWidth, f[1] = e.drawingBufferHeight, n.uniforms.model = a, n.uniforms.view = s, n.uniforms.projection = l, n.uniforms.coordinates = [this.position, h, p], n.uniforms.colors = this.colors, n.uniforms.screenShape = f;

        for (d = 0; d < 3; ++d) {
          n.uniforms.lineWidth = this.lineWidth[d] * this.pixelRatio, this.enabled[d] && (r.draw(e.TRIANGLES, 6, 6 * d), this.drawSides[d] && r.draw(e.TRIANGLES, 12, 18 + 12 * d));
        }

        r.unbind();
      }, l.update = function (t) {
        t && ("bounds" in t && (this.bounds = t.bounds), "position" in t && (this.position = t.position), "lineWidth" in t && (this.lineWidth = t.lineWidth), "colors" in t && (this.colors = t.colors), "enabled" in t && (this.enabled = t.enabled), "drawSides" in t && (this.drawSides = t.drawSides));
      }, l.dispose = function () {
        this.vao.dispose(), this.buffer.dispose(), this.shader.dispose();
      };
    }, {
      "./shaders/index": 339,
      "gl-buffer": 258,
      "gl-vao": 352
    }],
    341: [function (t, e, r) {
      var n = t("glslify"),
          i = n(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the tube vertex and normal at the given index.\n//\n// The returned vertex is for a tube ring with its center at origin, radius of length(d), pointing in the direction of d.\n//\n// Each tube segment is made up of a ring of vertices.\n// These vertices are used to make up the triangles of the tube by connecting them together in the vertex array.\n// The indexes of tube segments run from 0 to 8.\n//\nvec3 getTubePosition(vec3 d, float index, out vec3 normal) {\n  float segmentCount = 8.0;\n\n  float angle = 2.0 * 3.14159 * (index / segmentCount);\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d);\n  vec3 y = v * sin(angle) * length(d);\n  vec3 v3 = x + y;\n\n  normal = normalize(v3);\n\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 color, position;\nattribute vec2 uv;\n\nuniform float vectorScale, tubeScale;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 eyePosition, lightPosition;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  // Scale the vector magnitude to stay constant with\n  // model & view changes.\n  vec3 normal;\n  vec3 XYZ = getTubePosition(mat3(model) * (tubeScale * vector.w * normalize(vector.xyz)), position.w, normal);\n  vec4 tubePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * tubePosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  // vec4 m_position  = model * vec4(tubePosition, 1.0);\n  vec4 t_position  = view * tubePosition;\n  gl_Position      = projection * t_position;\n\n  f_color          = color;\n  f_data           = tubePosition.xyz;\n  f_position       = position.xyz;\n  f_uv             = uv;\n}\n"]),
          a = n(["#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform sampler2D texture;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = f_color * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * opacity;\n}\n"]),
          o = n(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the tube vertex and normal at the given index.\n//\n// The returned vertex is for a tube ring with its center at origin, radius of length(d), pointing in the direction of d.\n//\n// Each tube segment is made up of a ring of vertices.\n// These vertices are used to make up the triangles of the tube by connecting them together in the vertex array.\n// The indexes of tube segments run from 0 to 8.\n//\nvec3 getTubePosition(vec3 d, float index, out vec3 normal) {\n  float segmentCount = 8.0;\n\n  float angle = 2.0 * 3.14159 * (index / segmentCount);\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d);\n  vec3 y = v * sin(angle) * length(d);\n  vec3 v3 = x + y;\n\n  normal = normalize(v3);\n\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform float tubeScale;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  vec3 normal;\n  vec3 XYZ = getTubePosition(mat3(model) * (tubeScale * vector.w * normalize(vector.xyz)), position.w, normal);\n  vec4 tubePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  gl_Position = projection * view * tubePosition;\n  f_id        = id;\n  f_position  = position.xyz;\n}\n"]),
          s = n(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"]);
      r.meshShader = {
        vertex: i,
        fragment: a,
        attributes: [{
          name: "position",
          type: "vec4"
        }, {
          name: "color",
          type: "vec4"
        }, {
          name: "uv",
          type: "vec2"
        }, {
          name: "vector",
          type: "vec4"
        }]
      }, r.pickShader = {
        vertex: o,
        fragment: s,
        attributes: [{
          name: "position",
          type: "vec4"
        }, {
          name: "id",
          type: "vec4"
        }, {
          name: "vector",
          type: "vec4"
        }]
      };
    }, {
      glslify: 342
    }],
    342: [function (t, e, r) {
      arguments[4][256][0].apply(r, arguments);
    }, {
      dup: 256
    }],
    343: [function (t, e, r) {
      "use strict";

      var n = t("gl-vec3"),
          i = t("gl-vec4"),
          a = ["xyz", "xzy", "yxz", "yzx", "zxy", "zyx"],
          o = function o(t, e, r, a) {
        for (var o = 0, s = 0; s < t.length; s++) {
          for (var l = t[s].velocities, c = 0; c < l.length; c++) {
            o = Math.max(o, n.length(l[c]));
          }
        }

        var u = t.map(function (t) {
          return function (t, e, r, a) {
            for (var o = t.points, s = t.velocities, l = t.divergences, c = [], u = [], f = [], h = [], p = [], d = [], m = 0, g = 0, v = i.create(), y = i.create(), x = 0; x < o.length; x++) {
              var b = o[x],
                  _ = s[x],
                  w = l[x];
              0 === e && (w = .05 * r), g = n.length(_) / a, v = i.create(), n.copy(v, _), v[3] = w;

              for (var T = 0; T < 8; T++) {
                p[T] = [b[0], b[1], b[2], T];
              }

              if (h.length > 0) for (T = 0; T < 8; T++) {
                var k = (T + 1) % 8;
                c.push(h[T], p[T], p[k], p[k], h[k], h[T]), f.push(y, v, v, v, y, y), d.push(m, g, g, g, m, m);
                var M = c.length;
                u.push([M - 6, M - 5, M - 4], [M - 3, M - 2, M - 1]);
              }
              var A = h;
              h = p, p = A;
              var S = y;
              y = v, v = S;
              var E = m;
              m = g, g = E;
            }

            return {
              positions: c,
              cells: u,
              vectors: f,
              vertexIntensity: d
            };
          }(t, r, a, o);
        }),
            f = [],
            h = [],
            p = [],
            d = [];

        for (s = 0; s < u.length; s++) {
          var m = u[s],
              g = f.length;
          f = f.concat(m.positions), p = p.concat(m.vectors), d = d.concat(m.vertexIntensity);

          for (c = 0; c < m.cells.length; c++) {
            var v = m.cells[c],
                y = [];
            h.push(y);

            for (var x = 0; x < v.length; x++) {
              y.push(v[x] + g);
            }
          }
        }

        return {
          positions: f,
          cells: h,
          vectors: p,
          vertexIntensity: d,
          colormap: e
        };
      },
          s = function s(t, e) {
        var r,
            n = t.length;

        for (r = 0; r < n; r++) {
          var i = t[r];
          if (i === e) return r;
          if (i > e) return r - 1;
        }

        return r;
      },
          l = function l(t, e, r) {
        return t < e ? e : t > r ? r : t;
      },
          c = function c(t) {
        var e = 1 / 0;
        t.sort(function (t, e) {
          return t - e;
        });

        for (var r = t.length, n = 1; n < r; n++) {
          var i = Math.abs(t[n] - t[n - 1]);
          i < e && (e = i);
        }

        return e;
      };

      e.exports = function (t, e) {
        var r = t.startingPositions,
            i = t.maxLength || 1e3,
            u = t.tubeSize || 1,
            f = t.absoluteTubeSize,
            h = t.gridFill || "+x+y+z",
            p = {};
        -1 !== h.indexOf("-x") && (p.reversedX = !0), -1 !== h.indexOf("-y") && (p.reversedY = !0), -1 !== h.indexOf("-z") && (p.reversedZ = !0), p.filled = a.indexOf(h.replace(/-/g, "").replace(/\+/g, ""));

        var d = t.getVelocity || function (e) {
          return function (t, e, r) {
            var i = e.vectors,
                a = e.meshgrid,
                o = t[0],
                c = t[1],
                u = t[2],
                f = a[0].length,
                h = a[1].length,
                p = a[2].length,
                d = s(a[0], o),
                m = s(a[1], c),
                g = s(a[2], u),
                v = d + 1,
                y = m + 1,
                x = g + 1;
            if (d = l(d, 0, f - 1), v = l(v, 0, f - 1), m = l(m, 0, h - 1), y = l(y, 0, h - 1), g = l(g, 0, p - 1), x = l(x, 0, p - 1), d < 0 || m < 0 || g < 0 || v > f - 1 || y > h - 1 || x > p - 1) return n.create();

            var b,
                _,
                w,
                T,
                k,
                M,
                A = a[0][d],
                S = a[0][v],
                E = a[1][m],
                L = a[1][y],
                C = a[2][g],
                P = (o - A) / (S - A),
                I = (c - E) / (L - E),
                O = (u - C) / (a[2][x] - C);

            switch (isFinite(P) || (P = .5), isFinite(I) || (I = .5), isFinite(O) || (O = .5), r.reversedX && (d = f - 1 - d, v = f - 1 - v), r.reversedY && (m = h - 1 - m, y = h - 1 - y), r.reversedZ && (g = p - 1 - g, x = p - 1 - x), r.filled) {
              case 5:
                k = g, M = x, w = m * p, T = y * p, b = d * p * h, _ = v * p * h;
                break;

              case 4:
                k = g, M = x, b = d * p, _ = v * p, w = m * p * f, T = y * p * f;
                break;

              case 3:
                w = m, T = y, k = g * h, M = x * h, b = d * h * p, _ = v * h * p;
                break;

              case 2:
                w = m, T = y, b = d * h, _ = v * h, k = g * h * f, M = x * h * f;
                break;

              case 1:
                b = d, _ = v, k = g * f, M = x * f, w = m * f * p, T = y * f * p;
                break;

              default:
                b = d, _ = v, w = m * f, T = y * f, k = g * f * h, M = x * f * h;
            }

            var z = i[b + w + k],
                D = i[b + w + M],
                R = i[b + T + k],
                F = i[b + T + M],
                B = i[_ + w + k],
                N = i[_ + w + M],
                j = i[_ + T + k],
                U = i[_ + T + M],
                V = n.create(),
                q = n.create(),
                H = n.create(),
                G = n.create();
            n.lerp(V, z, B, P), n.lerp(q, D, N, P), n.lerp(H, R, j, P), n.lerp(G, F, U, P);
            var Y = n.create(),
                W = n.create();
            n.lerp(Y, V, H, I), n.lerp(W, q, G, I);
            var X = n.create();
            return n.lerp(X, Y, W, O), X;
          }(e, t, p);
        },
            m = t.getDivergence || function (t, e) {
          var r = n.create(),
              i = 1e-4;
          n.add(r, t, [i, 0, 0]);
          var a = d(r);
          n.subtract(a, a, e), n.scale(a, a, 1 / i), n.add(r, t, [0, i, 0]);
          var o = d(r);
          n.subtract(o, o, e), n.scale(o, o, 1 / i), n.add(r, t, [0, 0, i]);
          var s = d(r);
          return n.subtract(s, s, e), n.scale(s, s, 1 / i), n.add(r, a, o), n.add(r, r, s), r;
        },
            g = [],
            v = e[0][0],
            y = e[0][1],
            x = e[0][2],
            b = e[1][0],
            _ = e[1][1],
            w = e[1][2],
            T = function T(t) {
          var e = t[0],
              r = t[1],
              n = t[2];
          return !(e < v || e > b || r < y || r > _ || n < x || n > w);
        },
            k = 10 * n.distance(e[0], e[1]) / i,
            M = k * k,
            A = 1,
            S = 0,
            E = r.length;

        E > 1 && (A = function (t) {
          for (var e = [], r = [], n = [], i = {}, a = {}, o = {}, s = t.length, l = 0; l < s; l++) {
            var u = t[l],
                f = u[0],
                h = u[1],
                p = u[2];
            i[f] || (e.push(f), i[f] = !0), a[h] || (r.push(h), a[h] = !0), o[p] || (n.push(p), o[p] = !0);
          }

          var d = c(e),
              m = c(r),
              g = c(n),
              v = Math.min(d, m, g);
          return isFinite(v) ? v : 1;
        }(r));

        for (var L = 0; L < E; L++) {
          var C = n.create();
          n.copy(C, r[L]);
          var P = [C],
              I = [],
              O = d(C),
              z = C;
          I.push(O);
          var D = [],
              R = m(C, O),
              F = n.length(R);
          isFinite(F) && F > S && (S = F), D.push(F), g.push({
            points: P,
            velocities: I,
            divergences: D
          });

          for (var B = 0; B < 100 * i && P.length < i && T(C);) {
            B++;
            var N = n.clone(O),
                j = n.squaredLength(N);
            if (0 === j) break;

            if (j > M && n.scale(N, N, k / Math.sqrt(j)), n.add(N, N, C), O = d(N), n.squaredDistance(z, N) - M > -1e-4 * M) {
              P.push(N), z = N, I.push(O);
              R = m(N, O), F = n.length(R);
              isFinite(F) && F > S && (S = F), D.push(F);
            }

            C = N;
          }
        }

        var U = o(g, t.colormap, S, A);
        return f ? U.tubeScale = f : (0 === S && (S = 1), U.tubeScale = .5 * u * A / S), U;
      };

      var u = t("./lib/shaders"),
          f = t("gl-cone3d").createMesh;

      e.exports.createTubeMesh = function (t, e) {
        return f(t, e, {
          shaders: u,
          traceType: "streamtube"
        });
      };
    }, {
      "./lib/shaders": 341,
      "gl-cone3d": 259,
      "gl-vec3": 371,
      "gl-vec4": 407
    }],
    344: [function (t, e, r) {
      var n = t("gl-shader"),
          i = t("glslify"),
          a = i(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec4 uv;\nattribute vec3 f;\nattribute vec3 normal;\n\nuniform vec3 objectOffset;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 lightPosition, eyePosition;\nuniform sampler2D colormap;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  vec3 localCoordinate = vec3(uv.zw, f.x);\n  worldCoordinate = objectOffset + localCoordinate;\n  vec4 worldPosition = model * vec4(worldCoordinate, 1.0);\n  vec4 clipPosition = projection * view * worldPosition;\n  gl_Position = clipPosition;\n  kill = f.y;\n  value = f.z;\n  planeCoordinate = uv.xy;\n\n  vColor = texture2D(colormap, vec2(value, value));\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * worldPosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  lightDirection = lightPosition - cameraCoordinate.xyz;\n  eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  surfaceNormal  = normalize((vec4(normal,0) * inverseModel).xyz);\n}\n"]),
          o = i(["precision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat beckmannSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness) {\n  return beckmannDistribution(dot(surfaceNormal, normalize(lightDirection + viewDirection)), roughness);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 lowerBound, upperBound;\nuniform float contourTint;\nuniform vec4 contourColor;\nuniform sampler2D colormap;\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform float vertexColor;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  if (\n    kill > 0.0 ||\n    vColor.a == 0.0 ||\n    outOfRange(clipBounds[0], clipBounds[1], worldCoordinate)\n  ) discard;\n\n  vec3 N = normalize(surfaceNormal);\n  vec3 V = normalize(eyeDirection);\n  vec3 L = normalize(lightDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = max(beckmannSpecular(L, V, N, roughness), 0.);\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  //decide how to interpolate color \u2014 in vertex or in fragment\n  vec4 surfaceColor =\n    step(vertexColor, .5) * texture2D(colormap, vec2(value, value)) +\n    step(.5, vertexColor) * vColor;\n\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = mix(litColor, contourColor, contourTint) * opacity;\n}\n"]),
          s = i(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec4 uv;\nattribute float f;\n\nuniform vec3 objectOffset;\nuniform mat3 permutation;\nuniform mat4 model, view, projection;\nuniform float height, zOffset;\nuniform sampler2D colormap;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  vec3 dataCoordinate = permutation * vec3(uv.xy, height);\n  worldCoordinate = objectOffset + dataCoordinate;\n  vec4 worldPosition = model * vec4(worldCoordinate, 1.0);\n\n  vec4 clipPosition = projection * view * worldPosition;\n  clipPosition.z += zOffset;\n\n  gl_Position = clipPosition;\n  value = f + objectOffset.z;\n  kill = -1.0;\n  planeCoordinate = uv.zw;\n\n  vColor = texture2D(colormap, vec2(value, value));\n\n  //Don't do lighting for contours\n  surfaceNormal   = vec3(1,0,0);\n  eyeDirection    = vec3(0,1,0);\n  lightDirection  = vec3(0,0,1);\n}\n"]),
          l = i(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec2 shape;\nuniform vec3 clipBounds[2];\nuniform float pickId;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 surfaceNormal;\n\nvec2 splitFloat(float v) {\n  float vh = 255.0 * v;\n  float upper = floor(vh);\n  float lower = fract(vh);\n  return vec2(upper / 255.0, floor(lower * 16.0) / 16.0);\n}\n\nvoid main() {\n  if ((kill > 0.0) ||\n      (outOfRange(clipBounds[0], clipBounds[1], worldCoordinate))) discard;\n\n  vec2 ux = splitFloat(planeCoordinate.x / shape.x);\n  vec2 uy = splitFloat(planeCoordinate.y / shape.y);\n  gl_FragColor = vec4(pickId, ux.x, uy.x, ux.y + (uy.y/16.0));\n}\n"]);
      r.createShader = function (t) {
        var e = n(t, a, o, null, [{
          name: "uv",
          type: "vec4"
        }, {
          name: "f",
          type: "vec3"
        }, {
          name: "normal",
          type: "vec3"
        }]);
        return e.attributes.uv.location = 0, e.attributes.f.location = 1, e.attributes.normal.location = 2, e;
      }, r.createPickShader = function (t) {
        var e = n(t, a, l, null, [{
          name: "uv",
          type: "vec4"
        }, {
          name: "f",
          type: "vec3"
        }, {
          name: "normal",
          type: "vec3"
        }]);
        return e.attributes.uv.location = 0, e.attributes.f.location = 1, e.attributes.normal.location = 2, e;
      }, r.createContourShader = function (t) {
        var e = n(t, s, o, null, [{
          name: "uv",
          type: "vec4"
        }, {
          name: "f",
          type: "float"
        }]);
        return e.attributes.uv.location = 0, e.attributes.f.location = 1, e;
      }, r.createPickContourShader = function (t) {
        var e = n(t, s, l, null, [{
          name: "uv",
          type: "vec4"
        }, {
          name: "f",
          type: "float"
        }]);
        return e.attributes.uv.location = 0, e.attributes.f.location = 1, e;
      };
    }, {
      "gl-shader": 330,
      glslify: 433
    }],
    345: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        var e = t.gl,
            r = y(e),
            n = b(e),
            s = x(e),
            l = _(e),
            c = i(e),
            u = a(e, [{
          buffer: c,
          size: 4,
          stride: 40,
          offset: 0
        }, {
          buffer: c,
          size: 3,
          stride: 40,
          offset: 16
        }, {
          buffer: c,
          size: 3,
          stride: 40,
          offset: 28
        }]),
            f = i(e),
            h = a(e, [{
          buffer: f,
          size: 4,
          stride: 20,
          offset: 0
        }, {
          buffer: f,
          size: 1,
          stride: 20,
          offset: 16
        }]),
            p = i(e),
            d = a(e, [{
          buffer: p,
          size: 2,
          type: e.FLOAT
        }]),
            m = o(e, 1, 256, e.RGBA, e.UNSIGNED_BYTE);

        m.minFilter = e.LINEAR, m.magFilter = e.LINEAR;
        var g = new A(e, [0, 0], [[0, 0, 0], [0, 0, 0]], r, n, c, u, m, s, l, f, h, p, d, [0, 0, 0]),
            v = {
          levels: [[], [], []]
        };

        for (var w in t) {
          v[w] = t[w];
        }

        return v.colormap = v.colormap || "jet", g.update(v), g;
      };

      var n = t("bit-twiddle"),
          i = t("gl-buffer"),
          a = t("gl-vao"),
          o = t("gl-texture2d"),
          s = t("typedarray-pool"),
          l = t("colormap"),
          c = t("ndarray-ops"),
          u = t("ndarray-pack"),
          f = t("ndarray"),
          h = t("surface-nets"),
          p = t("gl-mat4/multiply"),
          d = t("gl-mat4/invert"),
          m = t("binary-search-bounds"),
          g = t("ndarray-gradient"),
          v = t("./lib/shaders"),
          y = v.createShader,
          x = v.createContourShader,
          b = v.createPickShader,
          _ = v.createPickContourShader,
          w = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
          T = [[0, 0], [0, 1], [1, 0], [1, 1], [1, 0], [0, 1]],
          k = [[0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0]];

      function M(t, e, r, n, i) {
        this.position = t, this.index = e, this.uv = r, this.level = n, this.dataCoordinate = i;
      }

      !function () {
        for (var t = 0; t < 3; ++t) {
          var e = k[t],
              r = (t + 2) % 3;
          e[(t + 1) % 3 + 0] = 1, e[r + 3] = 1, e[t + 6] = 1;
        }
      }();

      function A(t, e, r, n, i, a, o, l, c, u, h, p, d, m, g) {
        this.gl = t, this.shape = e, this.bounds = r, this.objectOffset = g, this.intensityBounds = [], this._shader = n, this._pickShader = i, this._coordinateBuffer = a, this._vao = o, this._colorMap = l, this._contourShader = c, this._contourPickShader = u, this._contourBuffer = h, this._contourVAO = p, this._contourOffsets = [[], [], []], this._contourCounts = [[], [], []], this._vertexCount = 0, this._pickResult = new M([0, 0, 0], [0, 0], [0, 0], [0, 0, 0], [0, 0, 0]), this._dynamicBuffer = d, this._dynamicVAO = m, this._dynamicOffsets = [0, 0, 0], this._dynamicCounts = [0, 0, 0], this.contourWidth = [1, 1, 1], this.contourLevels = [[1], [1], [1]], this.contourTint = [0, 0, 0], this.contourColor = [[.5, .5, .5, 1], [.5, .5, .5, 1], [.5, .5, .5, 1]], this.showContour = !0, this.showSurface = !0, this.enableHighlight = [!0, !0, !0], this.highlightColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.highlightTint = [1, 1, 1], this.highlightLevel = [-1, -1, -1], this.enableDynamic = [!0, !0, !0], this.dynamicLevel = [NaN, NaN, NaN], this.dynamicColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.dynamicTint = [1, 1, 1], this.dynamicWidth = [1, 1, 1], this.axesBounds = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]], this.surfaceProject = [!1, !1, !1], this.contourProject = [[!1, !1, !1], [!1, !1, !1], [!1, !1, !1]], this.colorBounds = [!1, !1], this._field = [f(s.mallocFloat(1024), [0, 0]), f(s.mallocFloat(1024), [0, 0]), f(s.mallocFloat(1024), [0, 0])], this.pickId = 1, this.clipBounds = [[-1 / 0, -1 / 0, -1 / 0], [1 / 0, 1 / 0, 1 / 0]], this.snapToData = !1, this.pixelRatio = 1, this.opacity = 1, this.lightPosition = [10, 1e4, 0], this.ambientLight = .8, this.diffuseLight = .8, this.specularLight = 2, this.roughness = .5, this.fresnel = 1.5, this.vertexColor = 0, this.dirty = !0;
      }

      var S = A.prototype;
      S.genColormap = function (t, e) {
        var r = !1,
            n = u([l({
          colormap: t,
          nshades: 256,
          format: "rgba"
        }).map(function (t, n) {
          var i = e ? function (t, e) {
            if (!e) return 1;
            if (!e.length) return 1;

            for (var r = 0; r < e.length; ++r) {
              if (e.length < 2) return 1;
              if (e[r][0] === t) return e[r][1];

              if (e[r][0] > t && r > 0) {
                var n = (e[r][0] - t) / (e[r][0] - e[r - 1][0]);
                return e[r][1] * (1 - n) + n * e[r - 1][1];
              }
            }

            return 1;
          }(n / 255, e) : t[3];
          return i < 1 && (r = !0), [t[0], t[1], t[2], 255 * i];
        })]);
        return c.divseq(n, 255), this.hasAlphaScale = r, n;
      }, S.isTransparent = function () {
        return this.opacity < 1 || this.hasAlphaScale;
      }, S.isOpaque = function () {
        return !this.isTransparent();
      }, S.pickSlots = 1, S.setPickBase = function (t) {
        this.pickId = t;
      };
      var E = [0, 0, 0],
          L = {
        showSurface: !1,
        showContour: !1,
        projections: [w.slice(), w.slice(), w.slice()],
        clipBounds: [[[0, 0, 0], [0, 0, 0]], [[0, 0, 0], [0, 0, 0]], [[0, 0, 0], [0, 0, 0]]]
      };

      function C(t, e) {
        var r,
            n,
            i,
            a = e.axes && e.axes.lastCubeProps.axis || E,
            o = e.showSurface,
            s = e.showContour;

        for (r = 0; r < 3; ++r) {
          for (o = o || e.surfaceProject[r], n = 0; n < 3; ++n) {
            s = s || e.contourProject[r][n];
          }
        }

        for (r = 0; r < 3; ++r) {
          var l = L.projections[r];

          for (n = 0; n < 16; ++n) {
            l[n] = 0;
          }

          for (n = 0; n < 4; ++n) {
            l[5 * n] = 1;
          }

          l[5 * r] = 0, l[12 + r] = e.axesBounds[+(a[r] > 0)][r], p(l, t.model, l);
          var c = L.clipBounds[r];

          for (i = 0; i < 2; ++i) {
            for (n = 0; n < 3; ++n) {
              c[i][n] = t.clipBounds[i][n];
            }
          }

          c[0][r] = -1e8, c[1][r] = 1e8;
        }

        return L.showSurface = o, L.showContour = s, L;
      }

      var P = {
        model: w,
        view: w,
        projection: w,
        inverseModel: w.slice(),
        lowerBound: [0, 0, 0],
        upperBound: [0, 0, 0],
        colorMap: 0,
        clipBounds: [[0, 0, 0], [0, 0, 0]],
        height: 0,
        contourTint: 0,
        contourColor: [0, 0, 0, 1],
        permutation: [1, 0, 0, 0, 1, 0, 0, 0, 1],
        zOffset: -1e-4,
        objectOffset: [0, 0, 0],
        kambient: 1,
        kdiffuse: 1,
        kspecular: 1,
        lightPosition: [1e3, 1e3, 1e3],
        eyePosition: [0, 0, 0],
        roughness: 1,
        fresnel: 1,
        opacity: 1,
        vertexColor: 0
      },
          I = w.slice(),
          O = [1, 0, 0, 0, 1, 0, 0, 0, 1];

      function z(t, e) {
        t = t || {};
        var r = this.gl;
        r.disable(r.CULL_FACE), this._colorMap.bind(0);
        var n = P;
        n.model = t.model || w, n.view = t.view || w, n.projection = t.projection || w, n.lowerBound = [this.bounds[0][0], this.bounds[0][1], this.colorBounds[0] || this.bounds[0][2]], n.upperBound = [this.bounds[1][0], this.bounds[1][1], this.colorBounds[1] || this.bounds[1][2]], n.objectOffset = this.objectOffset, n.contourColor = this.contourColor[0], n.inverseModel = d(n.inverseModel, n.model);

        for (var i = 0; i < 2; ++i) {
          for (var a = n.clipBounds[i], o = 0; o < 3; ++o) {
            a[o] = Math.min(Math.max(this.clipBounds[i][o], -1e8), 1e8);
          }
        }

        n.kambient = this.ambientLight, n.kdiffuse = this.diffuseLight, n.kspecular = this.specularLight, n.roughness = this.roughness, n.fresnel = this.fresnel, n.opacity = this.opacity, n.height = 0, n.permutation = O, n.vertexColor = this.vertexColor;
        var s = I;

        for (p(s, n.view, n.model), p(s, n.projection, s), d(s, s), i = 0; i < 3; ++i) {
          n.eyePosition[i] = s[12 + i] / s[15];
        }

        var l = s[15];

        for (i = 0; i < 3; ++i) {
          l += this.lightPosition[i] * s[4 * i + 3];
        }

        for (i = 0; i < 3; ++i) {
          var c = s[12 + i];

          for (o = 0; o < 3; ++o) {
            c += s[4 * o + i] * this.lightPosition[o];
          }

          n.lightPosition[i] = c / l;
        }

        var u = C(n, this);

        if (u.showSurface) {
          for (this._shader.bind(), this._shader.uniforms = n, this._vao.bind(), this.showSurface && this._vertexCount && this._vao.draw(r.TRIANGLES, this._vertexCount), i = 0; i < 3; ++i) {
            this.surfaceProject[i] && this.vertexCount && (this._shader.uniforms.model = u.projections[i], this._shader.uniforms.clipBounds = u.clipBounds[i], this._vao.draw(r.TRIANGLES, this._vertexCount));
          }

          this._vao.unbind();
        }

        if (u.showContour) {
          var f = this._contourShader;
          n.kambient = 1, n.kdiffuse = 0, n.kspecular = 0, n.opacity = 1, f.bind(), f.uniforms = n;
          var h = this._contourVAO;

          for (h.bind(), i = 0; i < 3; ++i) {
            for (f.uniforms.permutation = k[i], r.lineWidth(this.contourWidth[i] * this.pixelRatio), o = 0; o < this.contourLevels[i].length; ++o) {
              o === this.highlightLevel[i] ? (f.uniforms.contourColor = this.highlightColor[i], f.uniforms.contourTint = this.highlightTint[i]) : 0 !== o && o - 1 !== this.highlightLevel[i] || (f.uniforms.contourColor = this.contourColor[i], f.uniforms.contourTint = this.contourTint[i]), this._contourCounts[i][o] && (f.uniforms.height = this.contourLevels[i][o], h.draw(r.LINES, this._contourCounts[i][o], this._contourOffsets[i][o]));
            }
          }

          for (i = 0; i < 3; ++i) {
            for (f.uniforms.model = u.projections[i], f.uniforms.clipBounds = u.clipBounds[i], o = 0; o < 3; ++o) {
              if (this.contourProject[i][o]) {
                f.uniforms.permutation = k[o], r.lineWidth(this.contourWidth[o] * this.pixelRatio);

                for (var m = 0; m < this.contourLevels[o].length; ++m) {
                  m === this.highlightLevel[o] ? (f.uniforms.contourColor = this.highlightColor[o], f.uniforms.contourTint = this.highlightTint[o]) : 0 !== m && m - 1 !== this.highlightLevel[o] || (f.uniforms.contourColor = this.contourColor[o], f.uniforms.contourTint = this.contourTint[o]), this._contourCounts[o][m] && (f.uniforms.height = this.contourLevels[o][m], h.draw(r.LINES, this._contourCounts[o][m], this._contourOffsets[o][m]));
                }
              }
            }
          }

          for (h.unbind(), (h = this._dynamicVAO).bind(), i = 0; i < 3; ++i) {
            if (0 !== this._dynamicCounts[i]) for (f.uniforms.model = n.model, f.uniforms.clipBounds = n.clipBounds, f.uniforms.permutation = k[i], r.lineWidth(this.dynamicWidth[i] * this.pixelRatio), f.uniforms.contourColor = this.dynamicColor[i], f.uniforms.contourTint = this.dynamicTint[i], f.uniforms.height = this.dynamicLevel[i], h.draw(r.LINES, this._dynamicCounts[i], this._dynamicOffsets[i]), o = 0; o < 3; ++o) {
              this.contourProject[o][i] && (f.uniforms.model = u.projections[o], f.uniforms.clipBounds = u.clipBounds[o], h.draw(r.LINES, this._dynamicCounts[i], this._dynamicOffsets[i]));
            }
          }

          h.unbind();
        }
      }

      S.draw = function (t) {
        return z.call(this, t, !1);
      }, S.drawTransparent = function (t) {
        return z.call(this, t, !0);
      };
      var D = {
        model: w,
        view: w,
        projection: w,
        inverseModel: w,
        clipBounds: [[0, 0, 0], [0, 0, 0]],
        height: 0,
        shape: [0, 0],
        pickId: 0,
        lowerBound: [0, 0, 0],
        upperBound: [0, 0, 0],
        zOffset: 0,
        objectOffset: [0, 0, 0],
        permutation: [1, 0, 0, 0, 1, 0, 0, 0, 1],
        lightPosition: [0, 0, 0],
        eyePosition: [0, 0, 0]
      };

      function R(t, e) {
        return Array.isArray(t) ? [e(t[0]), e(t[1]), e(t[2])] : [e(t), e(t), e(t)];
      }

      function F(t) {
        return Array.isArray(t) ? 3 === t.length ? [t[0], t[1], t[2], 1] : [t[0], t[1], t[2], t[3]] : [0, 0, 0, 1];
      }

      function B(t) {
        if (Array.isArray(t)) {
          if (Array.isArray(t)) return [F(t[0]), F(t[1]), F(t[2])];
          var e = F(t);
          return [e.slice(), e.slice(), e.slice()];
        }
      }

      S.drawPick = function (t) {
        t = t || {};
        var e = this.gl;
        e.disable(e.CULL_FACE);
        var r = D;
        r.model = t.model || w, r.view = t.view || w, r.projection = t.projection || w, r.shape = this._field[2].shape, r.pickId = this.pickId / 255, r.lowerBound = this.bounds[0], r.upperBound = this.bounds[1], r.objectOffset = this.objectOffset, r.permutation = O;

        for (var n = 0; n < 2; ++n) {
          for (var i = r.clipBounds[n], a = 0; a < 3; ++a) {
            i[a] = Math.min(Math.max(this.clipBounds[n][a], -1e8), 1e8);
          }
        }

        var o = C(r, this);

        if (o.showSurface) {
          for (this._pickShader.bind(), this._pickShader.uniforms = r, this._vao.bind(), this._vao.draw(e.TRIANGLES, this._vertexCount), n = 0; n < 3; ++n) {
            this.surfaceProject[n] && (this._pickShader.uniforms.model = o.projections[n], this._pickShader.uniforms.clipBounds = o.clipBounds[n], this._vao.draw(e.TRIANGLES, this._vertexCount));
          }

          this._vao.unbind();
        }

        if (o.showContour) {
          var s = this._contourPickShader;
          s.bind(), s.uniforms = r;
          var l = this._contourVAO;

          for (l.bind(), a = 0; a < 3; ++a) {
            for (e.lineWidth(this.contourWidth[a] * this.pixelRatio), s.uniforms.permutation = k[a], n = 0; n < this.contourLevels[a].length; ++n) {
              this._contourCounts[a][n] && (s.uniforms.height = this.contourLevels[a][n], l.draw(e.LINES, this._contourCounts[a][n], this._contourOffsets[a][n]));
            }
          }

          for (n = 0; n < 3; ++n) {
            for (s.uniforms.model = o.projections[n], s.uniforms.clipBounds = o.clipBounds[n], a = 0; a < 3; ++a) {
              if (this.contourProject[n][a]) {
                s.uniforms.permutation = k[a], e.lineWidth(this.contourWidth[a] * this.pixelRatio);

                for (var c = 0; c < this.contourLevels[a].length; ++c) {
                  this._contourCounts[a][c] && (s.uniforms.height = this.contourLevels[a][c], l.draw(e.LINES, this._contourCounts[a][c], this._contourOffsets[a][c]));
                }
              }
            }
          }

          l.unbind();
        }
      }, S.pick = function (t) {
        if (!t) return null;
        if (t.id !== this.pickId) return null;
        var e = this._field[2].shape,
            r = this._pickResult,
            n = e[0] * (t.value[0] + (t.value[2] >> 4) / 16) / 255,
            i = Math.floor(n),
            a = n - i,
            o = e[1] * (t.value[1] + (15 & t.value[2]) / 16) / 255,
            s = Math.floor(o),
            l = o - s;
        i += 1, s += 1;
        var c = r.position;
        c[0] = c[1] = c[2] = 0;

        for (var u = 0; u < 2; ++u) {
          for (var f = u ? a : 1 - a, h = 0; h < 2; ++h) {
            for (var p = i + u, d = s + h, g = f * (h ? l : 1 - l), v = 0; v < 3; ++v) {
              c[v] += this._field[v].get(p, d) * g;
            }
          }
        }

        for (var y = this._pickResult.level, x = 0; x < 3; ++x) {
          if (y[x] = m.le(this.contourLevels[x], c[x]), y[x] < 0) this.contourLevels[x].length > 0 && (y[x] = 0);else if (y[x] < this.contourLevels[x].length - 1) {
            var b = this.contourLevels[x][y[x]],
                _ = this.contourLevels[x][y[x] + 1];
            Math.abs(b - c[x]) > Math.abs(_ - c[x]) && (y[x] += 1);
          }
        }

        for (r.index[0] = a < .5 ? i : i + 1, r.index[1] = l < .5 ? s : s + 1, r.uv[0] = n / e[0], r.uv[1] = o / e[1], v = 0; v < 3; ++v) {
          r.dataCoordinate[v] = this._field[v].get(r.index[0], r.index[1]);
        }

        return r;
      }, S.padField = function (t, e) {
        var r = e.shape.slice(),
            n = t.shape.slice();
        c.assign(t.lo(1, 1).hi(r[0], r[1]), e), c.assign(t.lo(1).hi(r[0], 1), e.hi(r[0], 1)), c.assign(t.lo(1, n[1] - 1).hi(r[0], 1), e.lo(0, r[1] - 1).hi(r[0], 1)), c.assign(t.lo(0, 1).hi(1, r[1]), e.hi(1)), c.assign(t.lo(n[0] - 1, 1).hi(1, r[1]), e.lo(r[0] - 1)), t.set(0, 0, e.get(0, 0)), t.set(0, n[1] - 1, e.get(0, r[1] - 1)), t.set(n[0] - 1, 0, e.get(r[0] - 1, 0)), t.set(n[0] - 1, n[1] - 1, e.get(r[0] - 1, r[1] - 1));
      }, S.update = function (t) {
        t = t || {}, this.objectOffset = t.objectOffset || this.objectOffset, this.dirty = !0, "contourWidth" in t && (this.contourWidth = R(t.contourWidth, Number)), "showContour" in t && (this.showContour = R(t.showContour, Boolean)), "showSurface" in t && (this.showSurface = !!t.showSurface), "contourTint" in t && (this.contourTint = R(t.contourTint, Boolean)), "contourColor" in t && (this.contourColor = B(t.contourColor)), "contourProject" in t && (this.contourProject = R(t.contourProject, function (t) {
          return R(t, Boolean);
        })), "surfaceProject" in t && (this.surfaceProject = t.surfaceProject), "dynamicColor" in t && (this.dynamicColor = B(t.dynamicColor)), "dynamicTint" in t && (this.dynamicTint = R(t.dynamicTint, Number)), "dynamicWidth" in t && (this.dynamicWidth = R(t.dynamicWidth, Number)), "opacity" in t && (this.opacity = t.opacity), "opacityscale" in t && (this.opacityscale = t.opacityscale), "colorBounds" in t && (this.colorBounds = t.colorBounds), "vertexColor" in t && (this.vertexColor = t.vertexColor ? 1 : 0), "colormap" in t && this._colorMap.setPixels(this.genColormap(t.colormap, this.opacityscale));
        var e = t.field || t.coords && t.coords[2] || null,
            r = !1;

        if (e || (e = this._field[2].shape[0] || this._field[2].shape[2] ? this._field[2].lo(1, 1).hi(this._field[2].shape[0] - 2, this._field[2].shape[1] - 2) : this._field[2].hi(0, 0)), "field" in t || "coords" in t) {
          var i = (e.shape[0] + 2) * (e.shape[1] + 2);
          i > this._field[2].data.length && (s.freeFloat(this._field[2].data), this._field[2].data = s.mallocFloat(n.nextPow2(i))), this._field[2] = f(this._field[2].data, [e.shape[0] + 2, e.shape[1] + 2]), this.padField(this._field[2], e), this.shape = e.shape.slice();

          for (var a = this.shape, o = 0; o < 2; ++o) {
            this._field[2].size > this._field[o].data.length && (s.freeFloat(this._field[o].data), this._field[o].data = s.mallocFloat(this._field[2].size)), this._field[o] = f(this._field[o].data, [a[0] + 2, a[1] + 2]);
          }

          if (t.coords) {
            var l = t.coords;
            if (!Array.isArray(l) || 3 !== l.length) throw new Error("gl-surface: invalid coordinates for x/y");

            for (o = 0; o < 2; ++o) {
              var c = l[o];

              for (v = 0; v < 2; ++v) {
                if (c.shape[v] !== a[v]) throw new Error("gl-surface: coords have incorrect shape");
              }

              this.padField(this._field[o], c);
            }
          } else if (t.ticks) {
            var u = t.ticks;
            if (!Array.isArray(u) || 2 !== u.length) throw new Error("gl-surface: invalid ticks");

            for (o = 0; o < 2; ++o) {
              var p = u[o];
              if ((Array.isArray(p) || p.length) && (p = f(p)), p.shape[0] !== a[o]) throw new Error("gl-surface: invalid tick length");
              var d = f(p.data, a);
              d.stride[o] = p.stride[0], d.stride[1 ^ o] = 0, this.padField(this._field[o], d);
            }
          } else {
            for (o = 0; o < 2; ++o) {
              var m = [0, 0];
              m[o] = 1, this._field[o] = f(this._field[o].data, [a[0] + 2, a[1] + 2], m, 0);
            }

            this._field[0].set(0, 0, 0);

            for (var v = 0; v < a[0]; ++v) {
              this._field[0].set(v + 1, 0, v);
            }

            for (this._field[0].set(a[0] + 1, 0, a[0] - 1), this._field[1].set(0, 0, 0), v = 0; v < a[1]; ++v) {
              this._field[1].set(0, v + 1, v);
            }

            this._field[1].set(0, a[1] + 1, a[1] - 1);
          }

          var y = this._field,
              x = f(s.mallocFloat(3 * y[2].size * 2), [3, a[0] + 2, a[1] + 2, 2]);

          for (o = 0; o < 3; ++o) {
            g(x.pick(o), y[o], "mirror");
          }

          var b = f(s.mallocFloat(3 * y[2].size), [a[0] + 2, a[1] + 2, 3]);

          for (o = 0; o < a[0] + 2; ++o) {
            for (v = 0; v < a[1] + 2; ++v) {
              var _ = x.get(0, o, v, 0),
                  w = x.get(0, o, v, 1),
                  k = x.get(1, o, v, 0),
                  M = x.get(1, o, v, 1),
                  A = x.get(2, o, v, 0),
                  S = x.get(2, o, v, 1),
                  E = k * S - M * A,
                  L = A * w - S * _,
                  C = _ * M - w * k,
                  P = Math.sqrt(E * E + L * L + C * C);

              P < 1e-8 ? (P = Math.max(Math.abs(E), Math.abs(L), Math.abs(C))) < 1e-8 ? (C = 1, L = E = 0, P = 1) : P = 1 / P : P = 1 / Math.sqrt(P), b.set(o, v, 0, E * P), b.set(o, v, 1, L * P), b.set(o, v, 2, C * P);
            }
          }

          s.free(x.data);
          var I = [1 / 0, 1 / 0, 1 / 0],
              O = [-1 / 0, -1 / 0, -1 / 0],
              z = 1 / 0,
              D = -1 / 0,
              F = (a[0] - 1) * (a[1] - 1) * 6,
              N = s.mallocFloat(n.nextPow2(10 * F)),
              j = 0,
              U = 0;

          for (o = 0; o < a[0] - 1; ++o) {
            t: for (v = 0; v < a[1] - 1; ++v) {
              for (var V = 0; V < 2; ++V) {
                for (var q = 0; q < 2; ++q) {
                  for (var H = 0; H < 3; ++H) {
                    var G = this._field[H].get(1 + o + V, 1 + v + q);

                    if (isNaN(G) || !isFinite(G)) continue t;
                  }
                }
              }

              for (H = 0; H < 6; ++H) {
                var Y = o + T[H][0],
                    W = v + T[H][1],
                    X = this._field[0].get(Y + 1, W + 1),
                    Z = this._field[1].get(Y + 1, W + 1);

                G = this._field[2].get(Y + 1, W + 1), E = b.get(Y + 1, W + 1, 0), L = b.get(Y + 1, W + 1, 1), C = b.get(Y + 1, W + 1, 2), t.intensity && (J = t.intensity.get(Y, W));
                var J = t.intensity ? t.intensity.get(Y, W) : G + this.objectOffset[2];
                N[j++] = Y, N[j++] = W, N[j++] = X, N[j++] = Z, N[j++] = G, N[j++] = 0, N[j++] = J, N[j++] = E, N[j++] = L, N[j++] = C, I[0] = Math.min(I[0], X + this.objectOffset[0]), I[1] = Math.min(I[1], Z + this.objectOffset[1]), I[2] = Math.min(I[2], G + this.objectOffset[2]), z = Math.min(z, J), O[0] = Math.max(O[0], X + this.objectOffset[0]), O[1] = Math.max(O[1], Z + this.objectOffset[1]), O[2] = Math.max(O[2], G + this.objectOffset[2]), D = Math.max(D, J), U += 1;
              }
            }
          }

          for (t.intensityBounds && (z = +t.intensityBounds[0], D = +t.intensityBounds[1]), o = 6; o < j; o += 10) {
            N[o] = (N[o] - z) / (D - z);
          }

          this._vertexCount = U, this._coordinateBuffer.update(N.subarray(0, j)), s.freeFloat(N), s.free(b.data), this.bounds = [I, O], this.intensity = t.intensity || this._field[2], this.intensityBounds[0] === z && this.intensityBounds[1] === D || (r = !0), this.intensityBounds = [z, D];
        }

        if ("levels" in t) {
          var K = t.levels;

          for (K = Array.isArray(K[0]) ? K.slice() : [[], [], K], o = 0; o < 3; ++o) {
            K[o] = K[o].slice(), K[o].sort(function (t, e) {
              return t - e;
            });
          }

          for (o = 0; o < 3; ++o) {
            for (v = 0; v < K[o].length; ++v) {
              K[o][v] -= this.objectOffset[o];
            }
          }

          t: for (o = 0; o < 3; ++o) {
            if (K[o].length !== this.contourLevels[o].length) {
              r = !0;
              break;
            }

            for (v = 0; v < K[o].length; ++v) {
              if (K[o][v] !== this.contourLevels[o][v]) {
                r = !0;
                break t;
              }
            }
          }

          this.contourLevels = K;
        }

        if (r) {
          y = this._field, a = this.shape;

          for (var Q = [], $ = 0; $ < 3; ++$) {
            var tt = this.contourLevels[$],
                et = [],
                rt = [],
                nt = [0, 0, 0];

            for (o = 0; o < tt.length; ++o) {
              var it = h(this._field[$], tt[o]);
              et.push(Q.length / 5 | 0), U = 0;

              t: for (v = 0; v < it.cells.length; ++v) {
                var at = it.cells[v];

                for (H = 0; H < 2; ++H) {
                  var ot = it.positions[at[H]],
                      st = ot[0],
                      lt = 0 | Math.floor(st),
                      ct = st - lt,
                      ut = ot[1],
                      ft = 0 | Math.floor(ut),
                      ht = ut - ft,
                      pt = !1;

                  e: for (var dt = 0; dt < 3; ++dt) {
                    nt[dt] = 0;
                    var mt = ($ + dt + 1) % 3;

                    for (V = 0; V < 2; ++V) {
                      var gt = V ? ct : 1 - ct;

                      for (Y = 0 | Math.min(Math.max(lt + V, 0), a[0]), q = 0; q < 2; ++q) {
                        var vt = q ? ht : 1 - ht;

                        if (W = 0 | Math.min(Math.max(ft + q, 0), a[1]), G = dt < 2 ? this._field[mt].get(Y, W) : (this.intensity.get(Y, W) - this.intensityBounds[0]) / (this.intensityBounds[1] - this.intensityBounds[0]), !isFinite(G) || isNaN(G)) {
                          pt = !0;
                          break e;
                        }

                        var yt = gt * vt;
                        nt[dt] += yt * G;
                      }
                    }
                  }

                  if (pt) {
                    if (H > 0) {
                      for (var xt = 0; xt < 5; ++xt) {
                        Q.pop();
                      }

                      U -= 1;
                    }

                    continue t;
                  }

                  Q.push(nt[0], nt[1], ot[0], ot[1], nt[2]), U += 1;
                }
              }

              rt.push(U);
            }

            this._contourOffsets[$] = et, this._contourCounts[$] = rt;
          }

          var bt = s.mallocFloat(Q.length);

          for (o = 0; o < Q.length; ++o) {
            bt[o] = Q[o];
          }

          this._contourBuffer.update(bt), s.freeFloat(bt);
        }
      }, S.dispose = function () {
        this._shader.dispose(), this._vao.dispose(), this._coordinateBuffer.dispose(), this._colorMap.dispose(), this._contourBuffer.dispose(), this._contourVAO.dispose(), this._contourShader.dispose(), this._contourPickShader.dispose(), this._dynamicBuffer.dispose(), this._dynamicVAO.dispose();

        for (var t = 0; t < 3; ++t) {
          s.freeFloat(this._field[t].data);
        }
      }, S.highlight = function (t) {
        var e, r;
        if (!t) return this._dynamicCounts = [0, 0, 0], this.dyanamicLevel = [NaN, NaN, NaN], void (this.highlightLevel = [-1, -1, -1]);

        for (e = 0; e < 3; ++e) {
          this.enableHighlight[e] ? this.highlightLevel[e] = t.level[e] : this.highlightLevel[e] = -1;
        }

        for (r = this.snapToData ? t.dataCoordinate : t.position, e = 0; e < 3; ++e) {
          r[e] -= this.objectOffset[e];
        }

        if (this.enableDynamic[0] && r[0] !== this.dynamicLevel[0] || this.enableDynamic[1] && r[1] !== this.dynamicLevel[1] || this.enableDynamic[2] && r[2] !== this.dynamicLevel[2]) {
          for (var n = 0, i = this.shape, a = s.mallocFloat(12 * i[0] * i[1]), o = 0; o < 3; ++o) {
            if (this.enableDynamic[o]) {
              this.dynamicLevel[o] = r[o];
              var l = (o + 1) % 3,
                  c = (o + 2) % 3,
                  u = this._field[o],
                  f = this._field[l],
                  p = this._field[c],
                  d = h(u, r[o]),
                  m = d.cells,
                  g = d.positions;

              for (this._dynamicOffsets[o] = n, e = 0; e < m.length; ++e) {
                for (var v = m[e], y = 0; y < 2; ++y) {
                  var x = g[v[y]],
                      b = +x[0],
                      _ = 0 | b,
                      w = 0 | Math.min(_ + 1, i[0]),
                      T = b - _,
                      k = 1 - T,
                      M = +x[1],
                      A = 0 | M,
                      S = 0 | Math.min(A + 1, i[1]),
                      E = M - A,
                      L = 1 - E,
                      C = k * L,
                      P = k * E,
                      I = T * L,
                      O = T * E,
                      z = C * f.get(_, A) + P * f.get(_, S) + I * f.get(w, A) + O * f.get(w, S),
                      D = C * p.get(_, A) + P * p.get(_, S) + I * p.get(w, A) + O * p.get(w, S);

                  if (isNaN(z) || isNaN(D)) {
                    y && (n -= 1);
                    break;
                  }

                  a[2 * n + 0] = z, a[2 * n + 1] = D, n += 1;
                }
              }

              this._dynamicCounts[o] = n - this._dynamicOffsets[o];
            } else this.dynamicLevel[o] = NaN, this._dynamicCounts[o] = 0;
          }

          this._dynamicBuffer.update(a.subarray(0, 2 * n)), s.freeFloat(a);
        }
      };
    }, {
      "./lib/shaders": 344,
      "binary-search-bounds": 98,
      "bit-twiddle": 99,
      colormap: 132,
      "gl-buffer": 258,
      "gl-mat4/invert": 290,
      "gl-mat4/multiply": 292,
      "gl-texture2d": 347,
      "gl-vao": 352,
      ndarray: 475,
      "ndarray-gradient": 468,
      "ndarray-ops": 470,
      "ndarray-pack": 471,
      "surface-nets": 583,
      "typedarray-pool": 609
    }],
    346: [function (t, e, r) {
      "use strict";

      var n = t("css-font"),
          i = t("pick-by-alias"),
          a = t("regl"),
          o = t("gl-util/context"),
          s = t("es6-weak-map"),
          l = t("color-normalize"),
          c = t("font-atlas"),
          u = t("typedarray-pool"),
          f = t("parse-rect"),
          h = t("is-plain-obj"),
          p = t("parse-unit"),
          d = t("to-px"),
          m = t("detect-kerning"),
          g = t("object-assign"),
          v = t("font-measure"),
          y = t("flatten-vertex-data"),
          x = t("bit-twiddle").nextPow2,
          b = new s(),
          _ = !1;

      if (document.body) {
        var w = document.body.appendChild(document.createElement("div"));
        w.style.font = "italic small-caps bold condensed 16px/2 cursive", getComputedStyle(w).fontStretch && (_ = !0), document.body.removeChild(w);
      }

      var T = function T(t) {
        !function (t) {
          return "function" == typeof t && t._gl && t.prop && t.texture && t.buffer;
        }(t) ? this.gl = o(t) : (t = {
          regl: t
        }, this.gl = t.regl._gl), this.shader = b.get(this.gl), this.shader ? this.regl = this.shader.regl : this.regl = t.regl || a({
          gl: this.gl
        }), this.charBuffer = this.regl.buffer({
          type: "uint8",
          usage: "stream"
        }), this.sizeBuffer = this.regl.buffer({
          type: "float",
          usage: "stream"
        }), this.shader || (this.shader = this.createShader(), b.set(this.gl, this.shader)), this.batch = [], this.fontSize = [], this.font = [], this.fontAtlas = [], this.draw = this.shader.draw.bind(this), this.render = function () {
          this.regl._refresh(), this.draw(this.batch);
        }, this.canvas = this.gl.canvas, this.update(h(t) ? t : {});
      };

      T.prototype.createShader = function () {
        var t = this.regl,
            e = t({
          blend: {
            enable: !0,
            color: [0, 0, 0, 1],
            func: {
              srcRGB: "src alpha",
              dstRGB: "one minus src alpha",
              srcAlpha: "one minus dst alpha",
              dstAlpha: "one"
            }
          },
          stencil: {
            enable: !1
          },
          depth: {
            enable: !1
          },
          count: t.prop("count"),
          offset: t.prop("offset"),
          attributes: {
            charOffset: {
              offset: 4,
              stride: 8,
              buffer: t.this("sizeBuffer")
            },
            width: {
              offset: 0,
              stride: 8,
              buffer: t.this("sizeBuffer")
            },
            char: t.this("charBuffer"),
            position: t.this("position")
          },
          uniforms: {
            atlasSize: function atlasSize(t, e) {
              return [e.atlas.width, e.atlas.height];
            },
            atlasDim: function atlasDim(t, e) {
              return [e.atlas.cols, e.atlas.rows];
            },
            atlas: function atlas(t, e) {
              return e.atlas.texture;
            },
            charStep: function charStep(t, e) {
              return e.atlas.step;
            },
            em: function em(t, e) {
              return e.atlas.em;
            },
            color: t.prop("color"),
            opacity: t.prop("opacity"),
            viewport: t.this("viewportArray"),
            scale: t.this("scale"),
            align: t.prop("align"),
            baseline: t.prop("baseline"),
            translate: t.this("translate"),
            positionOffset: t.prop("positionOffset")
          },
          primitive: "points",
          viewport: t.this("viewport"),
          vert: "\n\t\t\tprecision highp float;\n\t\t\tattribute float width, charOffset, char;\n\t\t\tattribute vec2 position;\n\t\t\tuniform float fontSize, charStep, em, align, baseline;\n\t\t\tuniform vec4 viewport;\n\t\t\tuniform vec4 color;\n\t\t\tuniform vec2 atlasSize, atlasDim, scale, translate, positionOffset;\n\t\t\tvarying vec2 charCoord, charId;\n\t\t\tvarying float charWidth;\n\t\t\tvarying vec4 fontColor;\n\t\t\tvoid main () {\n\t\t\t\t" + (T.normalViewport ? "" : "vec2 positionOffset = vec2(positionOffset.x,- positionOffset.y);") + "\n\n\t\t\t\tvec2 offset = floor(em * (vec2(align + charOffset, baseline)\n\t\t\t\t\t+ positionOffset))\n\t\t\t\t\t/ (viewport.zw * scale.xy);\n\n\t\t\t\tvec2 position = (position + translate) * scale;\n\t\t\t\tposition += offset * scale;\n\n\t\t\t\t" + (T.normalViewport ? "position.y = 1. - position.y;" : "") + "\n\n\t\t\t\tcharCoord = position * viewport.zw + viewport.xy;\n\n\t\t\t\tgl_Position = vec4(position * 2. - 1., 0, 1);\n\n\t\t\t\tgl_PointSize = charStep;\n\n\t\t\t\tcharId.x = mod(char, atlasDim.x);\n\t\t\t\tcharId.y = floor(char / atlasDim.x);\n\n\t\t\t\tcharWidth = width * em;\n\n\t\t\t\tfontColor = color / 255.;\n\t\t\t}",
          frag: "\n\t\t\tprecision highp float;\n\t\t\tuniform sampler2D atlas;\n\t\t\tuniform float fontSize, charStep, opacity;\n\t\t\tuniform vec2 atlasSize;\n\t\t\tuniform vec4 viewport;\n\t\t\tvarying vec4 fontColor;\n\t\t\tvarying vec2 charCoord, charId;\n\t\t\tvarying float charWidth;\n\n\t\t\tfloat lightness(vec4 color) {\n\t\t\t\treturn color.r * 0.299 + color.g * 0.587 + color.b * 0.114;\n\t\t\t}\n\n\t\t\tvoid main () {\n\t\t\t\tvec2 uv = gl_FragCoord.xy - charCoord + charStep * .5;\n\t\t\t\tfloat halfCharStep = floor(charStep * .5 + .5);\n\n\t\t\t\t// invert y and shift by 1px (FF expecially needs that)\n\t\t\t\tuv.y = charStep - uv.y;\n\n\t\t\t\t// ignore points outside of character bounding box\n\t\t\t\tfloat halfCharWidth = ceil(charWidth * .5);\n\t\t\t\tif (floor(uv.x) > halfCharStep + halfCharWidth ||\n\t\t\t\t\tfloor(uv.x) < halfCharStep - halfCharWidth) return;\n\n\t\t\t\tuv += charId * charStep;\n\t\t\t\tuv = uv / atlasSize;\n\n\t\t\t\tvec4 color = fontColor;\n\t\t\t\tvec4 mask = texture2D(atlas, uv);\n\n\t\t\t\tfloat maskY = lightness(mask);\n\t\t\t\t// float colorY = lightness(color);\n\t\t\t\tcolor.a *= maskY;\n\t\t\t\tcolor.a *= opacity;\n\n\t\t\t\t// color.a += .1;\n\n\t\t\t\t// antialiasing, see yiq color space y-channel formula\n\t\t\t\t// color.rgb += (1. - color.rgb) * (1. - mask.rgb);\n\n\t\t\t\tgl_FragColor = color;\n\t\t\t}"
        });
        return {
          regl: t,
          draw: e,
          atlas: {}
        };
      }, T.prototype.update = function (t) {
        var e = this;
        if ("string" == typeof t) t = {
          text: t
        };else if (!t) return;
        null != (t = i(t, {
          position: "position positions coord coords coordinates",
          font: "font fontFace fontface typeface cssFont css-font family fontFamily",
          fontSize: "fontSize fontsize size font-size",
          text: "text texts chars characters value values symbols",
          align: "align alignment textAlign textbaseline",
          baseline: "baseline textBaseline textbaseline",
          direction: "dir direction textDirection",
          color: "color colour fill fill-color fillColor textColor textcolor",
          kerning: "kerning kern",
          range: "range dataBox",
          viewport: "vp viewport viewBox viewbox viewPort",
          opacity: "opacity alpha transparency visible visibility opaque",
          offset: "offset positionOffset padding shift indent indentation"
        }, !0)).opacity && (Array.isArray(t.opacity) ? this.opacity = t.opacity.map(function (t) {
          return parseFloat(t);
        }) : this.opacity = parseFloat(t.opacity)), null != t.viewport && (this.viewport = f(t.viewport), T.normalViewport && (this.viewport.y = this.canvas.height - this.viewport.y - this.viewport.height), this.viewportArray = [this.viewport.x, this.viewport.y, this.viewport.width, this.viewport.height]), null == this.viewport && (this.viewport = {
          x: 0,
          y: 0,
          width: this.gl.drawingBufferWidth,
          height: this.gl.drawingBufferHeight
        }, this.viewportArray = [this.viewport.x, this.viewport.y, this.viewport.width, this.viewport.height]), null != t.kerning && (this.kerning = t.kerning), null != t.offset && ("number" == typeof t.offset && (t.offset = [t.offset, 0]), this.positionOffset = y(t.offset)), t.direction && (this.direction = t.direction), t.range && (this.range = t.range, this.scale = [1 / (t.range[2] - t.range[0]), 1 / (t.range[3] - t.range[1])], this.translate = [-t.range[0], -t.range[1]]), t.scale && (this.scale = t.scale), t.translate && (this.translate = t.translate), this.scale || (this.scale = [1 / this.viewport.width, 1 / this.viewport.height]), this.translate || (this.translate = [0, 0]), this.font.length || t.font || (t.font = T.baseFontSize + "px sans-serif");
        var r,
            a = !1,
            o = !1;

        if (t.font && (Array.isArray(t.font) ? t.font : [t.font]).forEach(function (t, r) {
          if ("string" == typeof t) try {
            t = n.parse(t);
          } catch (e) {
            t = n.parse(T.baseFontSize + "px " + t);
          } else t = n.parse(n.stringify(t));
          var i = n.stringify({
            size: T.baseFontSize,
            family: t.family,
            stretch: _ ? t.stretch : void 0,
            variant: t.variant,
            weight: t.weight,
            style: t.style
          }),
              s = p(t.size),
              l = Math.round(s[0] * d(s[1]));

          if (l !== e.fontSize[r] && (o = !0, e.fontSize[r] = l), !(e.font[r] && i == e.font[r].baseString || (a = !0, e.font[r] = T.fonts[i], e.font[r]))) {
            var c = t.family.join(", "),
                u = [t.style];
            t.style != t.variant && u.push(t.variant), t.variant != t.weight && u.push(t.weight), _ && t.weight != t.stretch && u.push(t.stretch), e.font[r] = {
              baseString: i,
              family: c,
              weight: t.weight,
              stretch: t.stretch,
              style: t.style,
              variant: t.variant,
              width: {},
              kerning: {},
              metrics: v(c, {
                origin: "top",
                fontSize: T.baseFontSize,
                fontStyle: u.join(" ")
              })
            }, T.fonts[i] = e.font[r];
          }
        }), (a || o) && this.font.forEach(function (r, i) {
          var a = n.stringify({
            size: e.fontSize[i],
            family: r.family,
            stretch: _ ? r.stretch : void 0,
            variant: r.variant,
            weight: r.weight,
            style: r.style
          });

          if (e.fontAtlas[i] = e.shader.atlas[a], !e.fontAtlas[i]) {
            var o = r.metrics;
            e.shader.atlas[a] = e.fontAtlas[i] = {
              fontString: a,
              step: 2 * Math.ceil(e.fontSize[i] * o.bottom * .5),
              em: e.fontSize[i],
              cols: 0,
              rows: 0,
              height: 0,
              width: 0,
              chars: [],
              ids: {},
              texture: e.regl.texture()
            };
          }

          null == t.text && (t.text = e.text);
        }), "string" == typeof t.text && t.position && t.position.length > 2) {
          for (var s = Array(.5 * t.position.length), h = 0; h < s.length; h++) {
            s[h] = t.text;
          }

          t.text = s;
        }

        if (null != t.text || a) {
          if (this.textOffsets = [0], Array.isArray(t.text)) {
            this.count = t.text[0].length, this.counts = [this.count];

            for (var b = 1; b < t.text.length; b++) {
              this.textOffsets[b] = this.textOffsets[b - 1] + t.text[b - 1].length, this.count += t.text[b].length, this.counts.push(t.text[b].length);
            }

            this.text = t.text.join("");
          } else this.text = t.text, this.count = this.text.length, this.counts = [this.count];

          r = [], this.font.forEach(function (t, n) {
            T.atlasContext.font = t.baseString;

            for (var i = e.fontAtlas[n], a = 0; a < e.text.length; a++) {
              var o = e.text.charAt(a);

              if (null == i.ids[o] && (i.ids[o] = i.chars.length, i.chars.push(o), r.push(o)), null == t.width[o] && (t.width[o] = T.atlasContext.measureText(o).width / T.baseFontSize, e.kerning)) {
                var s = [];

                for (var l in t.width) {
                  s.push(l + o, o + l);
                }

                g(t.kerning, m(t.family, {
                  pairs: s
                }));
              }
            }
          });
        }

        if (t.position) if (t.position.length > 2) {
          for (var w = !t.position[0].length, k = u.mallocFloat(2 * this.count), M = 0, A = 0; M < this.counts.length; M++) {
            var S = this.counts[M];
            if (w) for (var E = 0; E < S; E++) {
              k[A++] = t.position[2 * M], k[A++] = t.position[2 * M + 1];
            } else for (var L = 0; L < S; L++) {
              k[A++] = t.position[M][0], k[A++] = t.position[M][1];
            }
          }

          this.position.call ? this.position({
            type: "float",
            data: k
          }) : this.position = this.regl.buffer({
            type: "float",
            data: k
          }), u.freeFloat(k);
        } else this.position.destroy && this.position.destroy(), this.position = {
          constant: t.position
        };

        if (t.text || a) {
          var C = u.mallocUint8(this.count),
              P = u.mallocFloat(2 * this.count);
          this.textWidth = [];

          for (var I = 0, O = 0; I < this.counts.length; I++) {
            for (var z = this.counts[I], D = this.font[I] || this.font[0], R = this.fontAtlas[I] || this.fontAtlas[0], F = 0; F < z; F++) {
              var B = this.text.charAt(O),
                  N = this.text.charAt(O - 1);

              if (C[O] = R.ids[B], P[2 * O] = D.width[B], F) {
                var j = P[2 * O - 2],
                    U = P[2 * O],
                    V = P[2 * O - 1] + .5 * j + .5 * U;

                if (this.kerning) {
                  var q = D.kerning[N + B];
                  q && (V += .001 * q);
                }

                P[2 * O + 1] = V;
              } else P[2 * O + 1] = .5 * P[2 * O];

              O++;
            }

            this.textWidth.push(P.length ? .5 * P[2 * O - 2] + P[2 * O - 1] : 0);
          }

          t.align || (t.align = this.align), this.charBuffer({
            data: C,
            type: "uint8",
            usage: "stream"
          }), this.sizeBuffer({
            data: P,
            type: "float",
            usage: "stream"
          }), u.freeUint8(C), u.freeFloat(P), r.length && this.font.forEach(function (t, r) {
            var n = e.fontAtlas[r],
                i = n.step,
                a = Math.floor(T.maxAtlasSize / i),
                o = Math.min(a, n.chars.length),
                s = Math.ceil(n.chars.length / o),
                l = x(o * i),
                u = x(s * i);
            n.width = l, n.height = u, n.rows = s, n.cols = o, n.em && n.texture({
              data: c({
                canvas: T.atlasCanvas,
                font: n.fontString,
                chars: n.chars,
                shape: [l, u],
                step: [i, i]
              })
            });
          });
        }

        if (t.align && (this.align = t.align, this.alignOffset = this.textWidth.map(function (t, r) {
          var n = Array.isArray(e.align) ? e.align.length > 1 ? e.align[r] : e.align[0] : e.align;
          if ("number" == typeof n) return n;

          switch (n) {
            case "right":
            case "end":
              return -t;

            case "center":
            case "centre":
            case "middle":
              return .5 * -t;
          }

          return 0;
        })), null == this.baseline && null == t.baseline && (t.baseline = 0), null != t.baseline && (this.baseline = t.baseline, Array.isArray(this.baseline) || (this.baseline = [this.baseline]), this.baselineOffset = this.baseline.map(function (t, r) {
          var n = (e.font[r] || e.font[0]).metrics,
              i = 0;
          return i += .5 * n.bottom, i += "number" == typeof t ? t - n.baseline : -n[t], T.normalViewport || (i *= -1), i;
        })), null != t.color) if (t.color || (t.color = "transparent"), "string" != typeof t.color && isNaN(t.color)) {
          var H;

          if ("number" == typeof t.color[0] && t.color.length > this.counts.length) {
            var G = t.color.length;
            H = u.mallocUint8(G);

            for (var Y = (t.color.subarray || t.color.slice).bind(t.color), W = 0; W < G; W += 4) {
              H.set(l(Y(W, W + 4), "uint8"), W);
            }
          } else {
            var X = t.color.length;
            H = u.mallocUint8(4 * X);

            for (var Z = 0; Z < X; Z++) {
              H.set(l(t.color[Z] || 0, "uint8"), 4 * Z);
            }
          }

          this.color = H;
        } else this.color = l(t.color, "uint8");
        if (t.position || t.text || t.color || t.baseline || t.align || t.font || t.offset || t.opacity) if (this.color.length > 4 || this.baselineOffset.length > 1 || this.align && this.align.length > 1 || this.fontAtlas.length > 1 || this.positionOffset.length > 2) {
          var J = Math.max(.5 * this.position.length || 0, .25 * this.color.length || 0, this.baselineOffset.length || 0, this.alignOffset.length || 0, this.font.length || 0, this.opacity.length || 0, .5 * this.positionOffset.length || 0);
          this.batch = Array(J);

          for (var K = 0; K < this.batch.length; K++) {
            this.batch[K] = {
              count: this.counts.length > 1 ? this.counts[K] : this.counts[0],
              offset: this.textOffsets.length > 1 ? this.textOffsets[K] : this.textOffsets[0],
              color: this.color ? this.color.length <= 4 ? this.color : this.color.subarray(4 * K, 4 * K + 4) : [0, 0, 0, 255],
              opacity: Array.isArray(this.opacity) ? this.opacity[K] : this.opacity,
              baseline: null != this.baselineOffset[K] ? this.baselineOffset[K] : this.baselineOffset[0],
              align: this.align ? null != this.alignOffset[K] ? this.alignOffset[K] : this.alignOffset[0] : 0,
              atlas: this.fontAtlas[K] || this.fontAtlas[0],
              positionOffset: this.positionOffset.length > 2 ? this.positionOffset.subarray(2 * K, 2 * K + 2) : this.positionOffset
            };
          }
        } else this.count ? this.batch = [{
          count: this.count,
          offset: 0,
          color: this.color || [0, 0, 0, 255],
          opacity: Array.isArray(this.opacity) ? this.opacity[0] : this.opacity,
          baseline: this.baselineOffset[0],
          align: this.alignOffset ? this.alignOffset[0] : 0,
          atlas: this.fontAtlas[0],
          positionOffset: this.positionOffset
        }] : this.batch = [];
      }, T.prototype.destroy = function () {}, T.prototype.kerning = !0, T.prototype.position = {
        constant: new Float32Array(2)
      }, T.prototype.translate = null, T.prototype.scale = null, T.prototype.font = null, T.prototype.text = "", T.prototype.positionOffset = [0, 0], T.prototype.opacity = 1, T.prototype.color = new Uint8Array([0, 0, 0, 255]), T.prototype.alignOffset = [0, 0], T.normalViewport = !1, T.maxAtlasSize = 1024, T.atlasCanvas = document.createElement("canvas"), T.atlasContext = T.atlasCanvas.getContext("2d", {
        alpha: !1
      }), T.baseFontSize = 64, T.fonts = {}, e.exports = T;
    }, {
      "bit-twiddle": 99,
      "color-normalize": 126,
      "css-font": 145,
      "detect-kerning": 172,
      "es6-weak-map": 232,
      "flatten-vertex-data": 243,
      "font-atlas": 244,
      "font-measure": 245,
      "gl-util/context": 348,
      "is-plain-obj": 448,
      "object-assign": 479,
      "parse-rect": 484,
      "parse-unit": 486,
      "pick-by-alias": 490,
      regl: 532,
      "to-px": 592,
      "typedarray-pool": 609
    }],
    347: [function (t, e, r) {
      "use strict";

      var n = t("ndarray"),
          i = t("ndarray-ops"),
          a = t("typedarray-pool");

      e.exports = function (t) {
        if (arguments.length <= 1) throw new Error("gl-texture2d: Missing arguments for texture2d constructor");
        o || c(t);
        if ("number" == typeof arguments[1]) return v(t, arguments[1], arguments[2], arguments[3] || t.RGBA, arguments[4] || t.UNSIGNED_BYTE);
        if (Array.isArray(arguments[1])) return v(t, 0 | arguments[1][0], 0 | arguments[1][1], arguments[2] || t.RGBA, arguments[3] || t.UNSIGNED_BYTE);

        if ("object" == _typeof(arguments[1])) {
          var e = arguments[1],
              r = u(e) ? e : e.raw;
          if (r) return y(t, r, 0 | e.width, 0 | e.height, arguments[2] || t.RGBA, arguments[3] || t.UNSIGNED_BYTE);
          if (e.shape && e.data && e.stride) return x(t, e);
        }

        throw new Error("gl-texture2d: Invalid arguments for texture2d constructor");
      };

      var o = null,
          s = null,
          l = null;

      function c(t) {
        o = [t.LINEAR, t.NEAREST_MIPMAP_LINEAR, t.LINEAR_MIPMAP_NEAREST, t.LINEAR_MIPMAP_NEAREST], s = [t.NEAREST, t.LINEAR, t.NEAREST_MIPMAP_NEAREST, t.NEAREST_MIPMAP_LINEAR, t.LINEAR_MIPMAP_NEAREST, t.LINEAR_MIPMAP_LINEAR], l = [t.REPEAT, t.CLAMP_TO_EDGE, t.MIRRORED_REPEAT];
      }

      function u(t) {
        return "undefined" != typeof HTMLCanvasElement && t instanceof HTMLCanvasElement || "undefined" != typeof HTMLImageElement && t instanceof HTMLImageElement || "undefined" != typeof HTMLVideoElement && t instanceof HTMLVideoElement || "undefined" != typeof ImageData && t instanceof ImageData;
      }

      var f = function f(t, e) {
        i.muls(t, e, 255);
      };

      function h(t, e, r) {
        var n = t.gl,
            i = n.getParameter(n.MAX_TEXTURE_SIZE);
        if (e < 0 || e > i || r < 0 || r > i) throw new Error("gl-texture2d: Invalid texture size");
        return t._shape = [e, r], t.bind(), n.texImage2D(n.TEXTURE_2D, 0, t.format, e, r, 0, t.format, t.type, null), t._mipLevels = [0], t;
      }

      function p(t, e, r, n, i, a) {
        this.gl = t, this.handle = e, this.format = i, this.type = a, this._shape = [r, n], this._mipLevels = [0], this._magFilter = t.NEAREST, this._minFilter = t.NEAREST, this._wrapS = t.CLAMP_TO_EDGE, this._wrapT = t.CLAMP_TO_EDGE, this._anisoSamples = 1;
        var o = this,
            s = [this._wrapS, this._wrapT];
        Object.defineProperties(s, [{
          get: function get() {
            return o._wrapS;
          },
          set: function set(t) {
            return o.wrapS = t;
          }
        }, {
          get: function get() {
            return o._wrapT;
          },
          set: function set(t) {
            return o.wrapT = t;
          }
        }]), this._wrapVector = s;
        var l = [this._shape[0], this._shape[1]];
        Object.defineProperties(l, [{
          get: function get() {
            return o._shape[0];
          },
          set: function set(t) {
            return o.width = t;
          }
        }, {
          get: function get() {
            return o._shape[1];
          },
          set: function set(t) {
            return o.height = t;
          }
        }]), this._shapeVector = l;
      }

      var d = p.prototype;

      function m(t, e) {
        return 3 === t.length ? 1 === e[2] && e[1] === t[0] * t[2] && e[0] === t[2] : 1 === e[0] && e[1] === t[0];
      }

      function g(t) {
        var e = t.createTexture();
        return t.bindTexture(t.TEXTURE_2D, e), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.NEAREST), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.NEAREST), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE), e;
      }

      function v(t, e, r, n, i) {
        var a = t.getParameter(t.MAX_TEXTURE_SIZE);
        if (e < 0 || e > a || r < 0 || r > a) throw new Error("gl-texture2d: Invalid texture shape");
        if (i === t.FLOAT && !t.getExtension("OES_texture_float")) throw new Error("gl-texture2d: Floating point textures not supported on this platform");
        var o = g(t);
        return t.texImage2D(t.TEXTURE_2D, 0, n, e, r, 0, n, i, null), new p(t, o, e, r, n, i);
      }

      function y(t, e, r, n, i, a) {
        var o = g(t);
        return t.texImage2D(t.TEXTURE_2D, 0, i, i, a, e), new p(t, o, r, n, i, a);
      }

      function x(t, e) {
        var r = e.dtype,
            o = e.shape.slice(),
            s = t.getParameter(t.MAX_TEXTURE_SIZE);
        if (o[0] < 0 || o[0] > s || o[1] < 0 || o[1] > s) throw new Error("gl-texture2d: Invalid texture size");
        var l = m(o, e.stride.slice()),
            c = 0;
        "float32" === r ? c = t.FLOAT : "float64" === r ? (c = t.FLOAT, l = !1, r = "float32") : "uint8" === r ? c = t.UNSIGNED_BYTE : (c = t.UNSIGNED_BYTE, l = !1, r = "uint8");
        var u,
            h,
            d = 0;
        if (2 === o.length) d = t.LUMINANCE, o = [o[0], o[1], 1], e = n(e.data, o, [e.stride[0], e.stride[1], 1], e.offset);else {
          if (3 !== o.length) throw new Error("gl-texture2d: Invalid shape for texture");
          if (1 === o[2]) d = t.ALPHA;else if (2 === o[2]) d = t.LUMINANCE_ALPHA;else if (3 === o[2]) d = t.RGB;else {
            if (4 !== o[2]) throw new Error("gl-texture2d: Invalid shape for pixel coords");
            d = t.RGBA;
          }
        }
        c !== t.FLOAT || t.getExtension("OES_texture_float") || (c = t.UNSIGNED_BYTE, l = !1);
        var v = e.size;
        if (l) u = 0 === e.offset && e.data.length === v ? e.data : e.data.subarray(e.offset, e.offset + v);else {
          var y = [o[2], o[2] * o[0], 1];
          h = a.malloc(v, r);
          var x = n(h, o, y, 0);
          "float32" !== r && "float64" !== r || c !== t.UNSIGNED_BYTE ? i.assign(x, e) : f(x, e), u = h.subarray(0, v);
        }
        var b = g(t);
        return t.texImage2D(t.TEXTURE_2D, 0, d, o[0], o[1], 0, d, c, u), l || a.free(h), new p(t, b, o[0], o[1], d, c);
      }

      Object.defineProperties(d, {
        minFilter: {
          get: function get() {
            return this._minFilter;
          },
          set: function set(t) {
            this.bind();
            var e = this.gl;
            if (this.type === e.FLOAT && o.indexOf(t) >= 0 && (e.getExtension("OES_texture_float_linear") || (t = e.NEAREST)), s.indexOf(t) < 0) throw new Error("gl-texture2d: Unknown filter mode " + t);
            return e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, t), this._minFilter = t;
          }
        },
        magFilter: {
          get: function get() {
            return this._magFilter;
          },
          set: function set(t) {
            this.bind();
            var e = this.gl;
            if (this.type === e.FLOAT && o.indexOf(t) >= 0 && (e.getExtension("OES_texture_float_linear") || (t = e.NEAREST)), s.indexOf(t) < 0) throw new Error("gl-texture2d: Unknown filter mode " + t);
            return e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, t), this._magFilter = t;
          }
        },
        mipSamples: {
          get: function get() {
            return this._anisoSamples;
          },
          set: function set(t) {
            var e = this._anisoSamples;

            if (this._anisoSamples = 0 | Math.max(t, 1), e !== this._anisoSamples) {
              var r = this.gl.getExtension("EXT_texture_filter_anisotropic");
              r && this.gl.texParameterf(this.gl.TEXTURE_2D, r.TEXTURE_MAX_ANISOTROPY_EXT, this._anisoSamples);
            }

            return this._anisoSamples;
          }
        },
        wrapS: {
          get: function get() {
            return this._wrapS;
          },
          set: function set(t) {
            if (this.bind(), l.indexOf(t) < 0) throw new Error("gl-texture2d: Unknown wrap mode " + t);
            return this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, t), this._wrapS = t;
          }
        },
        wrapT: {
          get: function get() {
            return this._wrapT;
          },
          set: function set(t) {
            if (this.bind(), l.indexOf(t) < 0) throw new Error("gl-texture2d: Unknown wrap mode " + t);
            return this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, t), this._wrapT = t;
          }
        },
        wrap: {
          get: function get() {
            return this._wrapVector;
          },
          set: function set(t) {
            if (Array.isArray(t) || (t = [t, t]), 2 !== t.length) throw new Error("gl-texture2d: Must specify wrap mode for rows and columns");

            for (var e = 0; e < 2; ++e) {
              if (l.indexOf(t[e]) < 0) throw new Error("gl-texture2d: Unknown wrap mode " + t);
            }

            this._wrapS = t[0], this._wrapT = t[1];
            var r = this.gl;
            return this.bind(), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, this._wrapS), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, this._wrapT), t;
          }
        },
        shape: {
          get: function get() {
            return this._shapeVector;
          },
          set: function set(t) {
            if (Array.isArray(t)) {
              if (2 !== t.length) throw new Error("gl-texture2d: Invalid texture shape");
            } else t = [0 | t, 0 | t];

            return h(this, 0 | t[0], 0 | t[1]), [0 | t[0], 0 | t[1]];
          }
        },
        width: {
          get: function get() {
            return this._shape[0];
          },
          set: function set(t) {
            return h(this, t |= 0, this._shape[1]), t;
          }
        },
        height: {
          get: function get() {
            return this._shape[1];
          },
          set: function set(t) {
            return t |= 0, h(this, this._shape[0], t), t;
          }
        }
      }), d.bind = function (t) {
        var e = this.gl;
        return void 0 !== t && e.activeTexture(e.TEXTURE0 + (0 | t)), e.bindTexture(e.TEXTURE_2D, this.handle), void 0 !== t ? 0 | t : e.getParameter(e.ACTIVE_TEXTURE) - e.TEXTURE0;
      }, d.dispose = function () {
        this.gl.deleteTexture(this.handle);
      }, d.generateMipmap = function () {
        this.bind(), this.gl.generateMipmap(this.gl.TEXTURE_2D);

        for (var t = Math.min(this._shape[0], this._shape[1]), e = 0; t > 0; ++e, t >>>= 1) {
          this._mipLevels.indexOf(e) < 0 && this._mipLevels.push(e);
        }
      }, d.setPixels = function (t, e, r, o) {
        var s = this.gl;
        this.bind(), Array.isArray(e) ? (o = r, r = 0 | e[1], e = 0 | e[0]) : (e = e || 0, r = r || 0), o = o || 0;
        var l = u(t) ? t : t.raw;

        if (l) {
          this._mipLevels.indexOf(o) < 0 ? (s.texImage2D(s.TEXTURE_2D, 0, this.format, this.format, this.type, l), this._mipLevels.push(o)) : s.texSubImage2D(s.TEXTURE_2D, o, e, r, this.format, this.type, l);
        } else {
          if (!(t.shape && t.stride && t.data)) throw new Error("gl-texture2d: Unsupported data type");
          if (t.shape.length < 2 || e + t.shape[1] > this._shape[1] >>> o || r + t.shape[0] > this._shape[0] >>> o || e < 0 || r < 0) throw new Error("gl-texture2d: Texture dimensions are out of bounds");
          !function (t, e, r, o, s, l, c, u) {
            var h = u.dtype,
                p = u.shape.slice();
            if (p.length < 2 || p.length > 3) throw new Error("gl-texture2d: Invalid ndarray, must be 2d or 3d");
            var d = 0,
                g = 0,
                v = m(p, u.stride.slice());
            "float32" === h ? d = t.FLOAT : "float64" === h ? (d = t.FLOAT, v = !1, h = "float32") : "uint8" === h ? d = t.UNSIGNED_BYTE : (d = t.UNSIGNED_BYTE, v = !1, h = "uint8");
            if (2 === p.length) g = t.LUMINANCE, p = [p[0], p[1], 1], u = n(u.data, p, [u.stride[0], u.stride[1], 1], u.offset);else {
              if (3 !== p.length) throw new Error("gl-texture2d: Invalid shape for texture");
              if (1 === p[2]) g = t.ALPHA;else if (2 === p[2]) g = t.LUMINANCE_ALPHA;else if (3 === p[2]) g = t.RGB;else {
                if (4 !== p[2]) throw new Error("gl-texture2d: Invalid shape for pixel coords");
                g = t.RGBA;
              }
              p[2];
            }
            g !== t.LUMINANCE && g !== t.ALPHA || s !== t.LUMINANCE && s !== t.ALPHA || (g = s);
            if (g !== s) throw new Error("gl-texture2d: Incompatible texture format for setPixels");
            var y = u.size,
                x = c.indexOf(o) < 0;
            x && c.push(o);
            if (d === l && v) 0 === u.offset && u.data.length === y ? x ? t.texImage2D(t.TEXTURE_2D, o, s, p[0], p[1], 0, s, l, u.data) : t.texSubImage2D(t.TEXTURE_2D, o, e, r, p[0], p[1], s, l, u.data) : x ? t.texImage2D(t.TEXTURE_2D, o, s, p[0], p[1], 0, s, l, u.data.subarray(u.offset, u.offset + y)) : t.texSubImage2D(t.TEXTURE_2D, o, e, r, p[0], p[1], s, l, u.data.subarray(u.offset, u.offset + y));else {
              var b;
              b = l === t.FLOAT ? a.mallocFloat32(y) : a.mallocUint8(y);

              var _ = n(b, p, [p[2], p[2] * p[0], 1]);

              d === t.FLOAT && l === t.UNSIGNED_BYTE ? f(_, u) : i.assign(_, u), x ? t.texImage2D(t.TEXTURE_2D, o, s, p[0], p[1], 0, s, l, b.subarray(0, y)) : t.texSubImage2D(t.TEXTURE_2D, o, e, r, p[0], p[1], s, l, b.subarray(0, y)), l === t.FLOAT ? a.freeFloat32(b) : a.freeUint8(b);
            }
          }(s, e, r, o, this.format, this.type, this._mipLevels, t);
        }
      };
    }, {
      ndarray: 475,
      "ndarray-ops": 470,
      "typedarray-pool": 609
    }],
    348: [function (t, e, r) {
      (function (r) {
        (function () {
          "use strict";

          var n = t("pick-by-alias");

          function i(t) {
            if (t.container) if (t.container == document.body) document.body.style.width || (t.canvas.width = t.width || t.pixelRatio * r.innerWidth), document.body.style.height || (t.canvas.height = t.height || t.pixelRatio * r.innerHeight);else {
              var e = t.container.getBoundingClientRect();
              t.canvas.width = t.width || e.right - e.left, t.canvas.height = t.height || e.bottom - e.top;
            }
          }

          function a(t) {
            return "function" == typeof t.getContext && "width" in t && "height" in t;
          }

          function o() {
            var t = document.createElement("canvas");
            return t.style.position = "absolute", t.style.top = 0, t.style.left = 0, t;
          }

          e.exports = function (t) {
            var e;
            if (t ? "string" == typeof t && (t = {
              container: t
            }) : t = {}, a(t) ? t = {
              container: t
            } : t = "string" == typeof (e = t).nodeName && "function" == typeof e.appendChild && "function" == typeof e.getBoundingClientRect ? {
              container: t
            } : function (t) {
              return "function" == typeof t.drawArrays || "function" == typeof t.drawElements;
            }(t) ? {
              gl: t
            } : n(t, {
              container: "container target element el canvas holder parent parentNode wrapper use ref root node",
              gl: "gl context webgl glContext",
              attrs: "attributes attrs contextAttributes",
              pixelRatio: "pixelRatio pxRatio px ratio pxratio pixelratio",
              width: "w width",
              height: "h height"
            }, !0), t.pixelRatio || (t.pixelRatio = r.pixelRatio || 1), t.gl) return t.gl;

            if (t.canvas && (t.container = t.canvas.parentNode), t.container) {
              if ("string" == typeof t.container) {
                var s = document.querySelector(t.container);
                if (!s) throw Error("Element " + t.container + " is not found");
                t.container = s;
              }

              a(t.container) ? (t.canvas = t.container, t.container = t.canvas.parentNode) : t.canvas || (t.canvas = o(), t.container.appendChild(t.canvas), i(t));
            } else if (!t.canvas) {
              if ("undefined" == typeof document) throw Error("Not DOM environment. Use headless-gl.");
              t.container = document.body || document.documentElement, t.canvas = o(), t.container.appendChild(t.canvas), i(t);
            }

            if (!t.gl) try {
              t.gl = t.canvas.getContext("webgl", t.attrs);
            } catch (e) {
              try {
                t.gl = t.canvas.getContext("experimental-webgl", t.attrs);
              } catch (e) {
                t.gl = t.canvas.getContext("webgl-experimental", t.attrs);
              }
            }
            return t.gl;
          };
        }).call(this);
      }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
    }, {
      "pick-by-alias": 490
    }],
    349: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r) {
        e ? e.bind() : t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, null);
        var n = 0 | t.getParameter(t.MAX_VERTEX_ATTRIBS);

        if (r) {
          if (r.length > n) throw new Error("gl-vao: Too many vertex attributes");

          for (var i = 0; i < r.length; ++i) {
            var a = r[i];

            if (a.buffer) {
              var o = a.buffer,
                  s = a.size || 4,
                  l = a.type || t.FLOAT,
                  c = !!a.normalized,
                  u = a.stride || 0,
                  f = a.offset || 0;
              o.bind(), t.enableVertexAttribArray(i), t.vertexAttribPointer(i, s, l, c, u, f);
            } else {
              if ("number" == typeof a) t.vertexAttrib1f(i, a);else if (1 === a.length) t.vertexAttrib1f(i, a[0]);else if (2 === a.length) t.vertexAttrib2f(i, a[0], a[1]);else if (3 === a.length) t.vertexAttrib3f(i, a[0], a[1], a[2]);else {
                if (4 !== a.length) throw new Error("gl-vao: Invalid vertex attribute");
                t.vertexAttrib4f(i, a[0], a[1], a[2], a[3]);
              }
              t.disableVertexAttribArray(i);
            }
          }

          for (; i < n; ++i) {
            t.disableVertexAttribArray(i);
          }
        } else {
          t.bindBuffer(t.ARRAY_BUFFER, null);

          for (i = 0; i < n; ++i) {
            t.disableVertexAttribArray(i);
          }
        }
      };
    }, {}],
    350: [function (t, e, r) {
      "use strict";

      var n = t("./do-bind.js");

      function i(t) {
        this.gl = t, this._elements = null, this._attributes = null, this._elementsType = t.UNSIGNED_SHORT;
      }

      i.prototype.bind = function () {
        n(this.gl, this._elements, this._attributes);
      }, i.prototype.update = function (t, e, r) {
        this._elements = e, this._attributes = t, this._elementsType = r || this.gl.UNSIGNED_SHORT;
      }, i.prototype.dispose = function () {}, i.prototype.unbind = function () {}, i.prototype.draw = function (t, e, r) {
        r = r || 0;
        var n = this.gl;
        this._elements ? n.drawElements(t, e, this._elementsType, r) : n.drawArrays(t, r, e);
      }, e.exports = function (t) {
        return new i(t);
      };
    }, {
      "./do-bind.js": 349
    }],
    351: [function (t, e, r) {
      "use strict";

      var n = t("./do-bind.js");

      function i(t, e, r, n, i, a) {
        this.location = t, this.dimension = e, this.a = r, this.b = n, this.c = i, this.d = a;
      }

      function a(t, e, r) {
        this.gl = t, this._ext = e, this.handle = r, this._attribs = [], this._useElements = !1, this._elementsType = t.UNSIGNED_SHORT;
      }

      i.prototype.bind = function (t) {
        switch (this.dimension) {
          case 1:
            t.vertexAttrib1f(this.location, this.a);
            break;

          case 2:
            t.vertexAttrib2f(this.location, this.a, this.b);
            break;

          case 3:
            t.vertexAttrib3f(this.location, this.a, this.b, this.c);
            break;

          case 4:
            t.vertexAttrib4f(this.location, this.a, this.b, this.c, this.d);
        }
      }, a.prototype.bind = function () {
        this._ext.bindVertexArrayOES(this.handle);

        for (var t = 0; t < this._attribs.length; ++t) {
          this._attribs[t].bind(this.gl);
        }
      }, a.prototype.unbind = function () {
        this._ext.bindVertexArrayOES(null);
      }, a.prototype.dispose = function () {
        this._ext.deleteVertexArrayOES(this.handle);
      }, a.prototype.update = function (t, e, r) {
        if (this.bind(), n(this.gl, e, t), this.unbind(), this._attribs.length = 0, t) for (var a = 0; a < t.length; ++a) {
          var o = t[a];
          "number" == typeof o ? this._attribs.push(new i(a, 1, o)) : Array.isArray(o) && this._attribs.push(new i(a, o.length, o[0], o[1], o[2], o[3]));
        }
        this._useElements = !!e, this._elementsType = r || this.gl.UNSIGNED_SHORT;
      }, a.prototype.draw = function (t, e, r) {
        r = r || 0;
        var n = this.gl;
        this._useElements ? n.drawElements(t, e, this._elementsType, r) : n.drawArrays(t, r, e);
      }, e.exports = function (t, e) {
        return new a(t, e, e.createVertexArrayOES());
      };
    }, {
      "./do-bind.js": 349
    }],
    352: [function (t, e, r) {
      "use strict";

      var n = t("./lib/vao-native.js"),
          i = t("./lib/vao-emulated.js");

      function a(t) {
        this.bindVertexArrayOES = t.bindVertexArray.bind(t), this.createVertexArrayOES = t.createVertexArray.bind(t), this.deleteVertexArrayOES = t.deleteVertexArray.bind(t);
      }

      e.exports = function (t, e, r, o) {
        var s,
            l = t.createVertexArray ? new a(t) : t.getExtension("OES_vertex_array_object");
        return (s = l ? n(t, l) : i(t)).update(e, r, o), s;
      };
    }, {
      "./lib/vao-emulated.js": 350,
      "./lib/vao-native.js": 351
    }],
    353: [function (t, e, r) {
      e.exports = function (t, e, r) {
        return t[0] = e[0] + r[0], t[1] = e[1] + r[1], t[2] = e[2] + r[2], t;
      };
    }, {}],
    354: [function (t, e, r) {
      e.exports = function (t, e) {
        var r = n(t[0], t[1], t[2]),
            o = n(e[0], e[1], e[2]);
        i(r, r), i(o, o);
        var s = a(r, o);
        return s > 1 ? 0 : Math.acos(s);
      };

      var n = t("./fromValues"),
          i = t("./normalize"),
          a = t("./dot");
    }, {
      "./dot": 364,
      "./fromValues": 370,
      "./normalize": 381
    }],
    355: [function (t, e, r) {
      e.exports = function (t, e) {
        return t[0] = Math.ceil(e[0]), t[1] = Math.ceil(e[1]), t[2] = Math.ceil(e[2]), t;
      };
    }, {}],
    356: [function (t, e, r) {
      e.exports = function (t) {
        var e = new Float32Array(3);
        return e[0] = t[0], e[1] = t[1], e[2] = t[2], e;
      };
    }, {}],
    357: [function (t, e, r) {
      e.exports = function (t, e) {
        return t[0] = e[0], t[1] = e[1], t[2] = e[2], t;
      };
    }, {}],
    358: [function (t, e, r) {
      e.exports = function () {
        var t = new Float32Array(3);
        return t[0] = 0, t[1] = 0, t[2] = 0, t;
      };
    }, {}],
    359: [function (t, e, r) {
      e.exports = function (t, e, r) {
        var n = e[0],
            i = e[1],
            a = e[2],
            o = r[0],
            s = r[1],
            l = r[2];
        return t[0] = i * l - a * s, t[1] = a * o - n * l, t[2] = n * s - i * o, t;
      };
    }, {}],
    360: [function (t, e, r) {
      e.exports = t("./distance");
    }, {
      "./distance": 361
    }],
    361: [function (t, e, r) {
      e.exports = function (t, e) {
        var r = e[0] - t[0],
            n = e[1] - t[1],
            i = e[2] - t[2];
        return Math.sqrt(r * r + n * n + i * i);
      };
    }, {}],
    362: [function (t, e, r) {
      e.exports = t("./divide");
    }, {
      "./divide": 363
    }],
    363: [function (t, e, r) {
      e.exports = function (t, e, r) {
        return t[0] = e[0] / r[0], t[1] = e[1] / r[1], t[2] = e[2] / r[2], t;
      };
    }, {}],
    364: [function (t, e, r) {
      e.exports = function (t, e) {
        return t[0] * e[0] + t[1] * e[1] + t[2] * e[2];
      };
    }, {}],
    365: [function (t, e, r) {
      e.exports = 1e-6;
    }, {}],
    366: [function (t, e, r) {
      e.exports = function (t, e) {
        var r = t[0],
            i = t[1],
            a = t[2],
            o = e[0],
            s = e[1],
            l = e[2];
        return Math.abs(r - o) <= n * Math.max(1, Math.abs(r), Math.abs(o)) && Math.abs(i - s) <= n * Math.max(1, Math.abs(i), Math.abs(s)) && Math.abs(a - l) <= n * Math.max(1, Math.abs(a), Math.abs(l));
      };

      var n = t("./epsilon");
    }, {
      "./epsilon": 365
    }],
    367: [function (t, e, r) {
      e.exports = function (t, e) {
        return t[0] === e[0] && t[1] === e[1] && t[2] === e[2];
      };
    }, {}],
    368: [function (t, e, r) {
      e.exports = function (t, e) {
        return t[0] = Math.floor(e[0]), t[1] = Math.floor(e[1]), t[2] = Math.floor(e[2]), t;
      };
    }, {}],
    369: [function (t, e, r) {
      e.exports = function (t, e, r, i, a, o) {
        var s, l;
        e || (e = 3);
        r || (r = 0);
        l = i ? Math.min(i * e + r, t.length) : t.length;

        for (s = r; s < l; s += e) {
          n[0] = t[s], n[1] = t[s + 1], n[2] = t[s + 2], a(n, n, o), t[s] = n[0], t[s + 1] = n[1], t[s + 2] = n[2];
        }

        return t;
      };

      var n = t("./create")();
    }, {
      "./create": 358
    }],
    370: [function (t, e, r) {
      e.exports = function (t, e, r) {
        var n = new Float32Array(3);
        return n[0] = t, n[1] = e, n[2] = r, n;
      };
    }, {}],
    371: [function (t, e, r) {
      e.exports = {
        EPSILON: t("./epsilon"),
        create: t("./create"),
        clone: t("./clone"),
        angle: t("./angle"),
        fromValues: t("./fromValues"),
        copy: t("./copy"),
        set: t("./set"),
        equals: t("./equals"),
        exactEquals: t("./exactEquals"),
        add: t("./add"),
        subtract: t("./subtract"),
        sub: t("./sub"),
        multiply: t("./multiply"),
        mul: t("./mul"),
        divide: t("./divide"),
        div: t("./div"),
        min: t("./min"),
        max: t("./max"),
        floor: t("./floor"),
        ceil: t("./ceil"),
        round: t("./round"),
        scale: t("./scale"),
        scaleAndAdd: t("./scaleAndAdd"),
        distance: t("./distance"),
        dist: t("./dist"),
        squaredDistance: t("./squaredDistance"),
        sqrDist: t("./sqrDist"),
        length: t("./length"),
        len: t("./len"),
        squaredLength: t("./squaredLength"),
        sqrLen: t("./sqrLen"),
        negate: t("./negate"),
        inverse: t("./inverse"),
        normalize: t("./normalize"),
        dot: t("./dot"),
        cross: t("./cross"),
        lerp: t("./lerp"),
        random: t("./random"),
        transformMat4: t("./transformMat4"),
        transformMat3: t("./transformMat3"),
        transformQuat: t("./transformQuat"),
        rotateX: t("./rotateX"),
        rotateY: t("./rotateY"),
        rotateZ: t("./rotateZ"),
        forEach: t("./forEach")
      };
    }, {
      "./add": 353,
      "./angle": 354,
      "./ceil": 355,
      "./clone": 356,
      "./copy": 357,
      "./create": 358,
      "./cross": 359,
      "./dist": 360,
      "./distance": 361,
      "./div": 362,
      "./divide": 363,
      "./dot": 364,
      "./epsilon": 365,
      "./equals": 366,
      "./exactEquals": 367,
      "./floor": 368,
      "./forEach": 369,
      "./fromValues": 370,
      "./inverse": 372,
      "./len": 373,
      "./length": 374,
      "./lerp": 375,
      "./max": 376,
      "./min": 377,
      "./mul": 378,
      "./multiply": 379,
      "./negate": 380,
      "./normalize": 381,
      "./random": 382,
      "./rotateX": 383,
      "./rotateY": 384,
      "./rotateZ": 385,
      "./round": 386,
      "./scale": 387,
      "./scaleAndAdd": 388,
      "./set": 389,
      "./sqrDist": 390,
      "./sqrLen": 391,
      "./squaredDistance": 392,
      "./squaredLength": 393,
      "./sub": 394,
      "./subtract": 395,
      "./transformMat3": 396,
      "./transformMat4": 397,
      "./transformQuat": 398
    }],
    372: [function (t, e, r) {
      e.exports = function (t, e) {
        return t[0] = 1 / e[0], t[1] = 1 / e[1], t[2] = 1 / e[2], t;
      };
    }, {}],
    373: [function (t, e, r) {
      e.exports = t("./length");
    }, {
      "./length": 374
    }],
    374: [function (t, e, r) {
      e.exports = function (t) {
        var e = t[0],
            r = t[1],
            n = t[2];
        return Math.sqrt(e * e + r * r + n * n);
      };
    }, {}],
    375: [function (t, e, r) {
      e.exports = function (t, e, r, n) {
        var i = e[0],
            a = e[1],
            o = e[2];
        return t[0] = i + n * (r[0] - i), t[1] = a + n * (r[1] - a), t[2] = o + n * (r[2] - o), t;
      };
    }, {}],
    376: [function (t, e, r) {
      e.exports = function (t, e, r) {
        return t[0] = Math.max(e[0], r[0]), t[1] = Math.max(e[1], r[1]), t[2] = Math.max(e[2], r[2]), t;
      };
    }, {}],
    377: [function (t, e, r) {
      e.exports = function (t, e, r) {
        return t[0] = Math.min(e[0], r[0]), t[1] = Math.min(e[1], r[1]), t[2] = Math.min(e[2], r[2]), t;
      };
    }, {}],
    378: [function (t, e, r) {
      e.exports = t("./multiply");
    }, {
      "./multiply": 379
    }],
    379: [function (t, e, r) {
      e.exports = function (t, e, r) {
        return t[0] = e[0] * r[0], t[1] = e[1] * r[1], t[2] = e[2] * r[2], t;
      };
    }, {}],
    380: [function (t, e, r) {
      e.exports = function (t, e) {
        return t[0] = -e[0], t[1] = -e[1], t[2] = -e[2], t;
      };
    }, {}],
    381: [function (t, e, r) {
      e.exports = function (t, e) {
        var r = e[0],
            n = e[1],
            i = e[2],
            a = r * r + n * n + i * i;
        a > 0 && (a = 1 / Math.sqrt(a), t[0] = e[0] * a, t[1] = e[1] * a, t[2] = e[2] * a);
        return t;
      };
    }, {}],
    382: [function (t, e, r) {
      e.exports = function (t, e) {
        e = e || 1;
        var r = 2 * Math.random() * Math.PI,
            n = 2 * Math.random() - 1,
            i = Math.sqrt(1 - n * n) * e;
        return t[0] = Math.cos(r) * i, t[1] = Math.sin(r) * i, t[2] = n * e, t;
      };
    }, {}],
    383: [function (t, e, r) {
      e.exports = function (t, e, r, n) {
        var i = r[1],
            a = r[2],
            o = e[1] - i,
            s = e[2] - a,
            l = Math.sin(n),
            c = Math.cos(n);
        return t[0] = e[0], t[1] = i + o * c - s * l, t[2] = a + o * l + s * c, t;
      };
    }, {}],
    384: [function (t, e, r) {
      e.exports = function (t, e, r, n) {
        var i = r[0],
            a = r[2],
            o = e[0] - i,
            s = e[2] - a,
            l = Math.sin(n),
            c = Math.cos(n);
        return t[0] = i + s * l + o * c, t[1] = e[1], t[2] = a + s * c - o * l, t;
      };
    }, {}],
    385: [function (t, e, r) {
      e.exports = function (t, e, r, n) {
        var i = r[0],
            a = r[1],
            o = e[0] - i,
            s = e[1] - a,
            l = Math.sin(n),
            c = Math.cos(n);
        return t[0] = i + o * c - s * l, t[1] = a + o * l + s * c, t[2] = e[2], t;
      };
    }, {}],
    386: [function (t, e, r) {
      e.exports = function (t, e) {
        return t[0] = Math.round(e[0]), t[1] = Math.round(e[1]), t[2] = Math.round(e[2]), t;
      };
    }, {}],
    387: [function (t, e, r) {
      e.exports = function (t, e, r) {
        return t[0] = e[0] * r, t[1] = e[1] * r, t[2] = e[2] * r, t;
      };
    }, {}],
    388: [function (t, e, r) {
      e.exports = function (t, e, r, n) {
        return t[0] = e[0] + r[0] * n, t[1] = e[1] + r[1] * n, t[2] = e[2] + r[2] * n, t;
      };
    }, {}],
    389: [function (t, e, r) {
      e.exports = function (t, e, r, n) {
        return t[0] = e, t[1] = r, t[2] = n, t;
      };
    }, {}],
    390: [function (t, e, r) {
      e.exports = t("./squaredDistance");
    }, {
      "./squaredDistance": 392
    }],
    391: [function (t, e, r) {
      e.exports = t("./squaredLength");
    }, {
      "./squaredLength": 393
    }],
    392: [function (t, e, r) {
      e.exports = function (t, e) {
        var r = e[0] - t[0],
            n = e[1] - t[1],
            i = e[2] - t[2];
        return r * r + n * n + i * i;
      };
    }, {}],
    393: [function (t, e, r) {
      e.exports = function (t) {
        var e = t[0],
            r = t[1],
            n = t[2];
        return e * e + r * r + n * n;
      };
    }, {}],
    394: [function (t, e, r) {
      e.exports = t("./subtract");
    }, {
      "./subtract": 395
    }],
    395: [function (t, e, r) {
      e.exports = function (t, e, r) {
        return t[0] = e[0] - r[0], t[1] = e[1] - r[1], t[2] = e[2] - r[2], t;
      };
    }, {}],
    396: [function (t, e, r) {
      e.exports = function (t, e, r) {
        var n = e[0],
            i = e[1],
            a = e[2];
        return t[0] = n * r[0] + i * r[3] + a * r[6], t[1] = n * r[1] + i * r[4] + a * r[7], t[2] = n * r[2] + i * r[5] + a * r[8], t;
      };
    }, {}],
    397: [function (t, e, r) {
      e.exports = function (t, e, r) {
        var n = e[0],
            i = e[1],
            a = e[2],
            o = r[3] * n + r[7] * i + r[11] * a + r[15];
        return o = o || 1, t[0] = (r[0] * n + r[4] * i + r[8] * a + r[12]) / o, t[1] = (r[1] * n + r[5] * i + r[9] * a + r[13]) / o, t[2] = (r[2] * n + r[6] * i + r[10] * a + r[14]) / o, t;
      };
    }, {}],
    398: [function (t, e, r) {
      e.exports = function (t, e, r) {
        var n = e[0],
            i = e[1],
            a = e[2],
            o = r[0],
            s = r[1],
            l = r[2],
            c = r[3],
            u = c * n + s * a - l * i,
            f = c * i + l * n - o * a,
            h = c * a + o * i - s * n,
            p = -o * n - s * i - l * a;
        return t[0] = u * c + p * -o + f * -l - h * -s, t[1] = f * c + p * -s + h * -o - u * -l, t[2] = h * c + p * -l + u * -s - f * -o, t;
      };
    }, {}],
    399: [function (t, e, r) {
      e.exports = function (t, e, r) {
        return t[0] = e[0] + r[0], t[1] = e[1] + r[1], t[2] = e[2] + r[2], t[3] = e[3] + r[3], t;
      };
    }, {}],
    400: [function (t, e, r) {
      e.exports = function (t) {
        var e = new Float32Array(4);
        return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e;
      };
    }, {}],
    401: [function (t, e, r) {
      e.exports = function (t, e) {
        return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t;
      };
    }, {}],
    402: [function (t, e, r) {
      e.exports = function () {
        var t = new Float32Array(4);
        return t[0] = 0, t[1] = 0, t[2] = 0, t[3] = 0, t;
      };
    }, {}],
    403: [function (t, e, r) {
      e.exports = function (t, e) {
        var r = e[0] - t[0],
            n = e[1] - t[1],
            i = e[2] - t[2],
            a = e[3] - t[3];
        return Math.sqrt(r * r + n * n + i * i + a * a);
      };
    }, {}],
    404: [function (t, e, r) {
      e.exports = function (t, e, r) {
        return t[0] = e[0] / r[0], t[1] = e[1] / r[1], t[2] = e[2] / r[2], t[3] = e[3] / r[3], t;
      };
    }, {}],
    405: [function (t, e, r) {
      e.exports = function (t, e) {
        return t[0] * e[0] + t[1] * e[1] + t[2] * e[2] + t[3] * e[3];
      };
    }, {}],
    406: [function (t, e, r) {
      e.exports = function (t, e, r, n) {
        var i = new Float32Array(4);
        return i[0] = t, i[1] = e, i[2] = r, i[3] = n, i;
      };
    }, {}],
    407: [function (t, e, r) {
      e.exports = {
        create: t("./create"),
        clone: t("./clone"),
        fromValues: t("./fromValues"),
        copy: t("./copy"),
        set: t("./set"),
        add: t("./add"),
        subtract: t("./subtract"),
        multiply: t("./multiply"),
        divide: t("./divide"),
        min: t("./min"),
        max: t("./max"),
        scale: t("./scale"),
        scaleAndAdd: t("./scaleAndAdd"),
        distance: t("./distance"),
        squaredDistance: t("./squaredDistance"),
        length: t("./length"),
        squaredLength: t("./squaredLength"),
        negate: t("./negate"),
        inverse: t("./inverse"),
        normalize: t("./normalize"),
        dot: t("./dot"),
        lerp: t("./lerp"),
        random: t("./random"),
        transformMat4: t("./transformMat4"),
        transformQuat: t("./transformQuat")
      };
    }, {
      "./add": 399,
      "./clone": 400,
      "./copy": 401,
      "./create": 402,
      "./distance": 403,
      "./divide": 404,
      "./dot": 405,
      "./fromValues": 406,
      "./inverse": 408,
      "./length": 409,
      "./lerp": 410,
      "./max": 411,
      "./min": 412,
      "./multiply": 413,
      "./negate": 414,
      "./normalize": 415,
      "./random": 416,
      "./scale": 417,
      "./scaleAndAdd": 418,
      "./set": 419,
      "./squaredDistance": 420,
      "./squaredLength": 421,
      "./subtract": 422,
      "./transformMat4": 423,
      "./transformQuat": 424
    }],
    408: [function (t, e, r) {
      e.exports = function (t, e) {
        return t[0] = 1 / e[0], t[1] = 1 / e[1], t[2] = 1 / e[2], t[3] = 1 / e[3], t;
      };
    }, {}],
    409: [function (t, e, r) {
      e.exports = function (t) {
        var e = t[0],
            r = t[1],
            n = t[2],
            i = t[3];
        return Math.sqrt(e * e + r * r + n * n + i * i);
      };
    }, {}],
    410: [function (t, e, r) {
      e.exports = function (t, e, r, n) {
        var i = e[0],
            a = e[1],
            o = e[2],
            s = e[3];
        return t[0] = i + n * (r[0] - i), t[1] = a + n * (r[1] - a), t[2] = o + n * (r[2] - o), t[3] = s + n * (r[3] - s), t;
      };
    }, {}],
    411: [function (t, e, r) {
      e.exports = function (t, e, r) {
        return t[0] = Math.max(e[0], r[0]), t[1] = Math.max(e[1], r[1]), t[2] = Math.max(e[2], r[2]), t[3] = Math.max(e[3], r[3]), t;
      };
    }, {}],
    412: [function (t, e, r) {
      e.exports = function (t, e, r) {
        return t[0] = Math.min(e[0], r[0]), t[1] = Math.min(e[1], r[1]), t[2] = Math.min(e[2], r[2]), t[3] = Math.min(e[3], r[3]), t;
      };
    }, {}],
    413: [function (t, e, r) {
      e.exports = function (t, e, r) {
        return t[0] = e[0] * r[0], t[1] = e[1] * r[1], t[2] = e[2] * r[2], t[3] = e[3] * r[3], t;
      };
    }, {}],
    414: [function (t, e, r) {
      e.exports = function (t, e) {
        return t[0] = -e[0], t[1] = -e[1], t[2] = -e[2], t[3] = -e[3], t;
      };
    }, {}],
    415: [function (t, e, r) {
      e.exports = function (t, e) {
        var r = e[0],
            n = e[1],
            i = e[2],
            a = e[3],
            o = r * r + n * n + i * i + a * a;
        o > 0 && (o = 1 / Math.sqrt(o), t[0] = r * o, t[1] = n * o, t[2] = i * o, t[3] = a * o);
        return t;
      };
    }, {}],
    416: [function (t, e, r) {
      var n = t("./normalize"),
          i = t("./scale");

      e.exports = function (t, e) {
        return e = e || 1, t[0] = Math.random(), t[1] = Math.random(), t[2] = Math.random(), t[3] = Math.random(), n(t, t), i(t, t, e), t;
      };
    }, {
      "./normalize": 415,
      "./scale": 417
    }],
    417: [function (t, e, r) {
      e.exports = function (t, e, r) {
        return t[0] = e[0] * r, t[1] = e[1] * r, t[2] = e[2] * r, t[3] = e[3] * r, t;
      };
    }, {}],
    418: [function (t, e, r) {
      e.exports = function (t, e, r, n) {
        return t[0] = e[0] + r[0] * n, t[1] = e[1] + r[1] * n, t[2] = e[2] + r[2] * n, t[3] = e[3] + r[3] * n, t;
      };
    }, {}],
    419: [function (t, e, r) {
      e.exports = function (t, e, r, n, i) {
        return t[0] = e, t[1] = r, t[2] = n, t[3] = i, t;
      };
    }, {}],
    420: [function (t, e, r) {
      e.exports = function (t, e) {
        var r = e[0] - t[0],
            n = e[1] - t[1],
            i = e[2] - t[2],
            a = e[3] - t[3];
        return r * r + n * n + i * i + a * a;
      };
    }, {}],
    421: [function (t, e, r) {
      e.exports = function (t) {
        var e = t[0],
            r = t[1],
            n = t[2],
            i = t[3];
        return e * e + r * r + n * n + i * i;
      };
    }, {}],
    422: [function (t, e, r) {
      e.exports = function (t, e, r) {
        return t[0] = e[0] - r[0], t[1] = e[1] - r[1], t[2] = e[2] - r[2], t[3] = e[3] - r[3], t;
      };
    }, {}],
    423: [function (t, e, r) {
      e.exports = function (t, e, r) {
        var n = e[0],
            i = e[1],
            a = e[2],
            o = e[3];
        return t[0] = r[0] * n + r[4] * i + r[8] * a + r[12] * o, t[1] = r[1] * n + r[5] * i + r[9] * a + r[13] * o, t[2] = r[2] * n + r[6] * i + r[10] * a + r[14] * o, t[3] = r[3] * n + r[7] * i + r[11] * a + r[15] * o, t;
      };
    }, {}],
    424: [function (t, e, r) {
      e.exports = function (t, e, r) {
        var n = e[0],
            i = e[1],
            a = e[2],
            o = r[0],
            s = r[1],
            l = r[2],
            c = r[3],
            u = c * n + s * a - l * i,
            f = c * i + l * n - o * a,
            h = c * a + o * i - s * n,
            p = -o * n - s * i - l * a;
        return t[0] = u * c + p * -o + f * -l - h * -s, t[1] = f * c + p * -s + h * -o - u * -l, t[2] = h * c + p * -l + u * -s - f * -o, t[3] = e[3], t;
      };
    }, {}],
    425: [function (t, e, r) {
      var n = t("glsl-tokenizer"),
          i = t("atob-lite");

      e.exports = function (t) {
        for (var e = Array.isArray(t) ? t : n(t), r = 0; r < e.length; r++) {
          var a = e[r];

          if ("preprocessor" === a.type) {
            var o = a.data.match(/\#define\s+SHADER_NAME(_B64)?\s+(.+)$/);

            if (o && o[2]) {
              var s = o[1],
                  l = o[2];
              return (s ? i(l) : l).trim();
            }
          }
        }
      };
    }, {
      "atob-lite": 79,
      "glsl-tokenizer": 432
    }],
    426: [function (t, e, r) {
      e.exports = function (t) {
        var e,
            r,
            c,
            u = 0,
            f = 0,
            h = 999,
            p = [],
            d = [],
            m = 1,
            g = 0,
            v = 0,
            y = !1,
            x = !1,
            b = "",
            _ = a,
            w = n;
        "300 es" === (t = t || {}).version && (_ = s, w = o);
        var T = {},
            k = {};

        for (u = 0; u < _.length; u++) {
          T[_[u]] = !0;
        }

        for (u = 0; u < w.length; u++) {
          k[w[u]] = !0;
        }

        return function (t) {
          return d = [], null !== t ? function (t) {
            u = 0, t.toString && (t = t.toString());
            var r;
            b += t.replace(/\r\n/g, "\n"), c = b.length;

            for (; e = b[u], u < c;) {
              switch (r = u, h) {
                case 0:
                  u = L();
                  break;

                case 1:
                case 2:
                  u = E();
                  break;

                case 3:
                  u = C();
                  break;

                case 4:
                  u = O();
                  break;

                case 11:
                  u = I();
                  break;

                case 5:
                  u = z();
                  break;

                case 9999:
                  u = D();
                  break;

                case 9:
                  u = S();
                  break;

                case 999:
                  u = A();
              }

              if (r !== u) switch (b[r]) {
                case "\n":
                  g = 0, ++m;
                  break;

                default:
                  ++g;
              }
            }

            return f += u, b = b.slice(u), d;
          }(t) : function (t) {
            p.length && M(p.join(""));
            return h = 10, M("(eof)"), d;
          }();
        };

        function M(t) {
          t.length && d.push({
            type: l[h],
            data: t,
            position: v,
            line: m,
            column: g
          });
        }

        function A() {
          return p = p.length ? [] : p, "/" === r && "*" === e ? (v = f + u - 1, h = 0, r = e, u + 1) : "/" === r && "/" === e ? (v = f + u - 1, h = 1, r = e, u + 1) : "#" === e ? (h = 2, v = f + u, u) : /\s/.test(e) ? (h = 9, v = f + u, u) : (y = /\d/.test(e), x = /[^\w_]/.test(e), v = f + u, h = y ? 4 : x ? 3 : 9999, u);
        }

        function S() {
          return /[^\s]/g.test(e) ? (M(p.join("")), h = 999, u) : (p.push(e), r = e, u + 1);
        }

        function E() {
          return "\r" !== e && "\n" !== e || "\\" === r ? (p.push(e), r = e, u + 1) : (M(p.join("")), h = 999, u);
        }

        function L() {
          return "/" === e && "*" === r ? (p.push(e), M(p.join("")), h = 999, u + 1) : (p.push(e), r = e, u + 1);
        }

        function C() {
          if ("." === r && /\d/.test(e)) return h = 5, u;
          if ("/" === r && "*" === e) return h = 0, u;
          if ("/" === r && "/" === e) return h = 1, u;

          if ("." === e && p.length) {
            for (; P(p);) {
              ;
            }

            return h = 5, u;
          }

          if (";" === e || ")" === e || "(" === e) {
            if (p.length) for (; P(p);) {
              ;
            }
            return M(e), h = 999, u + 1;
          }

          var t = 2 === p.length && "=" !== e;

          if (/[\w_\d\s]/.test(e) || t) {
            for (; P(p);) {
              ;
            }

            return h = 999, u;
          }

          return p.push(e), r = e, u + 1;
        }

        function P(t) {
          for (var e, r, n = 0;;) {
            if (e = i.indexOf(t.slice(0, t.length + n).join("")), r = i[e], -1 === e) {
              if (n-- + t.length > 0) continue;
              r = t.slice(0, 1).join("");
            }

            return M(r), v += r.length, (p = p.slice(r.length)).length;
          }
        }

        function I() {
          return /[^a-fA-F0-9]/.test(e) ? (M(p.join("")), h = 999, u) : (p.push(e), r = e, u + 1);
        }

        function O() {
          return "." === e || /[eE]/.test(e) ? (p.push(e), h = 5, r = e, u + 1) : "x" === e && 1 === p.length && "0" === p[0] ? (h = 11, p.push(e), r = e, u + 1) : /[^\d]/.test(e) ? (M(p.join("")), h = 999, u) : (p.push(e), r = e, u + 1);
        }

        function z() {
          return "f" === e && (p.push(e), r = e, u += 1), /[eE]/.test(e) ? (p.push(e), r = e, u + 1) : ("-" !== e && "+" !== e || !/[eE]/.test(r)) && /[^\d]/.test(e) ? (M(p.join("")), h = 999, u) : (p.push(e), r = e, u + 1);
        }

        function D() {
          if (/[^\d\w_]/.test(e)) {
            var t = p.join("");
            return h = k[t] ? 8 : T[t] ? 7 : 6, M(p.join("")), h = 999, u;
          }

          return p.push(e), r = e, u + 1;
        }
      };

      var n = t("./lib/literals"),
          i = t("./lib/operators"),
          a = t("./lib/builtins"),
          o = t("./lib/literals-300es"),
          s = t("./lib/builtins-300es"),
          l = ["block-comment", "line-comment", "preprocessor", "operator", "integer", "float", "ident", "builtin", "keyword", "whitespace", "eof", "integer"];
    }, {
      "./lib/builtins": 428,
      "./lib/builtins-300es": 427,
      "./lib/literals": 430,
      "./lib/literals-300es": 429,
      "./lib/operators": 431
    }],
    427: [function (t, e, r) {
      var n = t("./builtins");
      n = n.slice().filter(function (t) {
        return !/^(gl\_|texture)/.test(t);
      }), e.exports = n.concat(["gl_VertexID", "gl_InstanceID", "gl_Position", "gl_PointSize", "gl_FragCoord", "gl_FrontFacing", "gl_FragDepth", "gl_PointCoord", "gl_MaxVertexAttribs", "gl_MaxVertexUniformVectors", "gl_MaxVertexOutputVectors", "gl_MaxFragmentInputVectors", "gl_MaxVertexTextureImageUnits", "gl_MaxCombinedTextureImageUnits", "gl_MaxTextureImageUnits", "gl_MaxFragmentUniformVectors", "gl_MaxDrawBuffers", "gl_MinProgramTexelOffset", "gl_MaxProgramTexelOffset", "gl_DepthRangeParameters", "gl_DepthRange", "trunc", "round", "roundEven", "isnan", "isinf", "floatBitsToInt", "floatBitsToUint", "intBitsToFloat", "uintBitsToFloat", "packSnorm2x16", "unpackSnorm2x16", "packUnorm2x16", "unpackUnorm2x16", "packHalf2x16", "unpackHalf2x16", "outerProduct", "transpose", "determinant", "inverse", "texture", "textureSize", "textureProj", "textureLod", "textureOffset", "texelFetch", "texelFetchOffset", "textureProjOffset", "textureLodOffset", "textureProjLod", "textureProjLodOffset", "textureGrad", "textureGradOffset", "textureProjGrad", "textureProjGradOffset"]);
    }, {
      "./builtins": 428
    }],
    428: [function (t, e, r) {
      e.exports = ["abs", "acos", "all", "any", "asin", "atan", "ceil", "clamp", "cos", "cross", "dFdx", "dFdy", "degrees", "distance", "dot", "equal", "exp", "exp2", "faceforward", "floor", "fract", "gl_BackColor", "gl_BackLightModelProduct", "gl_BackLightProduct", "gl_BackMaterial", "gl_BackSecondaryColor", "gl_ClipPlane", "gl_ClipVertex", "gl_Color", "gl_DepthRange", "gl_DepthRangeParameters", "gl_EyePlaneQ", "gl_EyePlaneR", "gl_EyePlaneS", "gl_EyePlaneT", "gl_Fog", "gl_FogCoord", "gl_FogFragCoord", "gl_FogParameters", "gl_FragColor", "gl_FragCoord", "gl_FragData", "gl_FragDepth", "gl_FragDepthEXT", "gl_FrontColor", "gl_FrontFacing", "gl_FrontLightModelProduct", "gl_FrontLightProduct", "gl_FrontMaterial", "gl_FrontSecondaryColor", "gl_LightModel", "gl_LightModelParameters", "gl_LightModelProducts", "gl_LightProducts", "gl_LightSource", "gl_LightSourceParameters", "gl_MaterialParameters", "gl_MaxClipPlanes", "gl_MaxCombinedTextureImageUnits", "gl_MaxDrawBuffers", "gl_MaxFragmentUniformComponents", "gl_MaxLights", "gl_MaxTextureCoords", "gl_MaxTextureImageUnits", "gl_MaxTextureUnits", "gl_MaxVaryingFloats", "gl_MaxVertexAttribs", "gl_MaxVertexTextureImageUnits", "gl_MaxVertexUniformComponents", "gl_ModelViewMatrix", "gl_ModelViewMatrixInverse", "gl_ModelViewMatrixInverseTranspose", "gl_ModelViewMatrixTranspose", "gl_ModelViewProjectionMatrix", "gl_ModelViewProjectionMatrixInverse", "gl_ModelViewProjectionMatrixInverseTranspose", "gl_ModelViewProjectionMatrixTranspose", "gl_MultiTexCoord0", "gl_MultiTexCoord1", "gl_MultiTexCoord2", "gl_MultiTexCoord3", "gl_MultiTexCoord4", "gl_MultiTexCoord5", "gl_MultiTexCoord6", "gl_MultiTexCoord7", "gl_Normal", "gl_NormalMatrix", "gl_NormalScale", "gl_ObjectPlaneQ", "gl_ObjectPlaneR", "gl_ObjectPlaneS", "gl_ObjectPlaneT", "gl_Point", "gl_PointCoord", "gl_PointParameters", "gl_PointSize", "gl_Position", "gl_ProjectionMatrix", "gl_ProjectionMatrixInverse", "gl_ProjectionMatrixInverseTranspose", "gl_ProjectionMatrixTranspose", "gl_SecondaryColor", "gl_TexCoord", "gl_TextureEnvColor", "gl_TextureMatrix", "gl_TextureMatrixInverse", "gl_TextureMatrixInverseTranspose", "gl_TextureMatrixTranspose", "gl_Vertex", "greaterThan", "greaterThanEqual", "inversesqrt", "length", "lessThan", "lessThanEqual", "log", "log2", "matrixCompMult", "max", "min", "mix", "mod", "normalize", "not", "notEqual", "pow", "radians", "reflect", "refract", "sign", "sin", "smoothstep", "sqrt", "step", "tan", "texture2D", "texture2DLod", "texture2DProj", "texture2DProjLod", "textureCube", "textureCubeLod", "texture2DLodEXT", "texture2DProjLodEXT", "textureCubeLodEXT", "texture2DGradEXT", "texture2DProjGradEXT", "textureCubeGradEXT"];
    }, {}],
    429: [function (t, e, r) {
      var n = t("./literals");
      e.exports = n.slice().concat(["layout", "centroid", "smooth", "case", "mat2x2", "mat2x3", "mat2x4", "mat3x2", "mat3x3", "mat3x4", "mat4x2", "mat4x3", "mat4x4", "uvec2", "uvec3", "uvec4", "samplerCubeShadow", "sampler2DArray", "sampler2DArrayShadow", "isampler2D", "isampler3D", "isamplerCube", "isampler2DArray", "usampler2D", "usampler3D", "usamplerCube", "usampler2DArray", "coherent", "restrict", "readonly", "writeonly", "resource", "atomic_uint", "noperspective", "patch", "sample", "subroutine", "common", "partition", "active", "filter", "image1D", "image2D", "image3D", "imageCube", "iimage1D", "iimage2D", "iimage3D", "iimageCube", "uimage1D", "uimage2D", "uimage3D", "uimageCube", "image1DArray", "image2DArray", "iimage1DArray", "iimage2DArray", "uimage1DArray", "uimage2DArray", "image1DShadow", "image2DShadow", "image1DArrayShadow", "image2DArrayShadow", "imageBuffer", "iimageBuffer", "uimageBuffer", "sampler1DArray", "sampler1DArrayShadow", "isampler1D", "isampler1DArray", "usampler1D", "usampler1DArray", "isampler2DRect", "usampler2DRect", "samplerBuffer", "isamplerBuffer", "usamplerBuffer", "sampler2DMS", "isampler2DMS", "usampler2DMS", "sampler2DMSArray", "isampler2DMSArray", "usampler2DMSArray"]);
    }, {
      "./literals": 430
    }],
    430: [function (t, e, r) {
      e.exports = ["precision", "highp", "mediump", "lowp", "attribute", "const", "uniform", "varying", "break", "continue", "do", "for", "while", "if", "else", "in", "out", "inout", "float", "int", "uint", "void", "bool", "true", "false", "discard", "return", "mat2", "mat3", "mat4", "vec2", "vec3", "vec4", "ivec2", "ivec3", "ivec4", "bvec2", "bvec3", "bvec4", "sampler1D", "sampler2D", "sampler3D", "samplerCube", "sampler1DShadow", "sampler2DShadow", "struct", "asm", "class", "union", "enum", "typedef", "template", "this", "packed", "goto", "switch", "default", "inline", "noinline", "volatile", "public", "static", "extern", "external", "interface", "long", "short", "double", "half", "fixed", "unsigned", "input", "output", "hvec2", "hvec3", "hvec4", "dvec2", "dvec3", "dvec4", "fvec2", "fvec3", "fvec4", "sampler2DRect", "sampler3DRect", "sampler2DRectShadow", "sizeof", "cast", "namespace", "using"];
    }, {}],
    431: [function (t, e, r) {
      e.exports = ["<<=", ">>=", "++", "--", "<<", ">>", "<=", ">=", "==", "!=", "&&", "||", "+=", "-=", "*=", "/=", "%=", "&=", "^^", "^=", "|=", "(", ")", "[", "]", ".", "!", "~", "*", "/", "%", "+", "-", "<", ">", "&", "^", "|", "?", ":", "=", ",", ";", "{", "}"];
    }, {}],
    432: [function (t, e, r) {
      var n = t("./index");

      e.exports = function (t, e) {
        var r = n(e),
            i = [];
        return i = (i = i.concat(r(t))).concat(r(null));
      };
    }, {
      "./index": 426
    }],
    433: [function (t, e, r) {
      arguments[4][256][0].apply(r, arguments);
    }, {
      dup: 256
    }],
    434: [function (t, e, r) {
      (function (r) {
        (function () {
          "use strict";

          var n,
              i = t("is-browser");
          n = "function" == typeof r.matchMedia ? !r.matchMedia("(hover: none)").matches : i, e.exports = n;
        }).call(this);
      }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
    }, {
      "is-browser": 443
    }],
    435: [function (t, e, r) {
      "use strict";

      var n = t("is-browser");

      e.exports = n && function () {
        var t = !1;

        try {
          var e = Object.defineProperty({}, "passive", {
            get: function get() {
              t = !0;
            }
          });
          window.addEventListener("test", null, e), window.removeEventListener("test", null, e);
        } catch (e) {
          t = !1;
        }

        return t;
      }();
    }, {
      "is-browser": 443
    }],
    436: [function (t, e, r) {
      r.read = function (t, e, r, n, i) {
        var a,
            o,
            s = 8 * i - n - 1,
            l = (1 << s) - 1,
            c = l >> 1,
            u = -7,
            f = r ? i - 1 : 0,
            h = r ? -1 : 1,
            p = t[e + f];

        for (f += h, a = p & (1 << -u) - 1, p >>= -u, u += s; u > 0; a = 256 * a + t[e + f], f += h, u -= 8) {
          ;
        }

        for (o = a & (1 << -u) - 1, a >>= -u, u += n; u > 0; o = 256 * o + t[e + f], f += h, u -= 8) {
          ;
        }

        if (0 === a) a = 1 - c;else {
          if (a === l) return o ? NaN : 1 / 0 * (p ? -1 : 1);
          o += Math.pow(2, n), a -= c;
        }
        return (p ? -1 : 1) * o * Math.pow(2, a - n);
      }, r.write = function (t, e, r, n, i, a) {
        var o,
            s,
            l,
            c = 8 * a - i - 1,
            u = (1 << c) - 1,
            f = u >> 1,
            h = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
            p = n ? 0 : a - 1,
            d = n ? 1 : -1,
            m = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

        for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, o = u) : (o = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), (e += o + f >= 1 ? h / l : h * Math.pow(2, 1 - f)) * l >= 2 && (o++, l /= 2), o + f >= u ? (s = 0, o = u) : o + f >= 1 ? (s = (e * l - 1) * Math.pow(2, i), o += f) : (s = e * Math.pow(2, f - 1) * Math.pow(2, i), o = 0)); i >= 8; t[r + p] = 255 & s, p += d, s /= 256, i -= 8) {
          ;
        }

        for (o = o << i | s, c += i; c > 0; t[r + p] = 255 & o, p += d, o /= 256, c -= 8) {
          ;
        }

        t[r + p - d] |= 128 * m;
      };
    }, {}],
    437: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        var r = t.length;
        if (0 === r) throw new Error("Must have at least d+1 points");
        var i = t[0].length;
        if (r <= i) throw new Error("Must input at least d+1 points");
        var o = t.slice(0, i + 1),
            s = n.apply(void 0, o);
        if (0 === s) throw new Error("Input not in general position");

        for (var l = new Array(i + 1), u = 0; u <= i; ++u) {
          l[u] = u;
        }

        s < 0 && (l[0] = 1, l[1] = 0);
        var f = new a(l, new Array(i + 1), !1),
            h = f.adjacent,
            p = new Array(i + 2);

        for (u = 0; u <= i; ++u) {
          for (var d = l.slice(), m = 0; m <= i; ++m) {
            m === u && (d[m] = -1);
          }

          var g = d[0];
          d[0] = d[1], d[1] = g;
          var v = new a(d, new Array(i + 1), !0);
          h[u] = v, p[u] = v;
        }

        p[i + 1] = f;

        for (u = 0; u <= i; ++u) {
          d = h[u].vertices;
          var y = h[u].adjacent;

          for (m = 0; m <= i; ++m) {
            var x = d[m];
            if (x < 0) y[m] = f;else for (var b = 0; b <= i; ++b) {
              h[b].vertices.indexOf(x) < 0 && (y[m] = h[b]);
            }
          }
        }

        var _ = new c(i, o, p),
            w = !!e;

        for (u = i + 1; u < r; ++u) {
          _.insert(t[u], w);
        }

        return _.boundary();
      };

      var n = t("robust-orientation"),
          i = t("simplicial-complex").compareCells;

      function a(t, e, r) {
        this.vertices = t, this.adjacent = e, this.boundary = r, this.lastVisited = -1;
      }

      function o(t, e, r) {
        this.vertices = t, this.cell = e, this.index = r;
      }

      function s(t, e) {
        return i(t.vertices, e.vertices);
      }

      a.prototype.flip = function () {
        var t = this.vertices[0];
        this.vertices[0] = this.vertices[1], this.vertices[1] = t;
        var e = this.adjacent[0];
        this.adjacent[0] = this.adjacent[1], this.adjacent[1] = e;
      };

      var l = [];

      function c(t, e, r) {
        this.dimension = t, this.vertices = e, this.simplices = r, this.interior = r.filter(function (t) {
          return !t.boundary;
        }), this.tuple = new Array(t + 1);

        for (var i = 0; i <= t; ++i) {
          this.tuple[i] = this.vertices[i];
        }

        var a = l[t];
        a || (a = l[t] = function (t) {
          for (var e = ["function orient(){var tuple=this.tuple;return test("], r = 0; r <= t; ++r) {
            r > 0 && e.push(","), e.push("tuple[", r, "]");
          }

          e.push(")}return orient");
          var i = new Function("test", e.join("")),
              a = n[t + 1];
          return a || (a = n), i(a);
        }(t)), this.orient = a;
      }

      var u = c.prototype;
      u.handleBoundaryDegeneracy = function (t, e) {
        var r = this.dimension,
            n = this.vertices.length - 1,
            i = this.tuple,
            a = this.vertices,
            o = [t];

        for (t.lastVisited = -n; o.length > 0;) {
          (t = o.pop()).vertices;

          for (var s = t.adjacent, l = 0; l <= r; ++l) {
            var c = s[l];

            if (c.boundary && !(c.lastVisited <= -n)) {
              for (var u = c.vertices, f = 0; f <= r; ++f) {
                var h = u[f];
                i[f] = h < 0 ? e : a[h];
              }

              var p = this.orient();
              if (p > 0) return c;
              c.lastVisited = -n, 0 === p && o.push(c);
            }
          }
        }

        return null;
      }, u.walk = function (t, e) {
        var r = this.vertices.length - 1,
            n = this.dimension,
            i = this.vertices,
            a = this.tuple,
            o = e ? this.interior.length * Math.random() | 0 : this.interior.length - 1,
            s = this.interior[o];

        t: for (; !s.boundary;) {
          for (var l = s.vertices, c = s.adjacent, u = 0; u <= n; ++u) {
            a[u] = i[l[u]];
          }

          s.lastVisited = r;

          for (u = 0; u <= n; ++u) {
            var f = c[u];

            if (!(f.lastVisited >= r)) {
              var h = a[u];
              a[u] = t;
              var p = this.orient();

              if (a[u] = h, p < 0) {
                s = f;
                continue t;
              }

              f.boundary ? f.lastVisited = -r : f.lastVisited = r;
            }
          }

          return;
        }

        return s;
      }, u.addPeaks = function (t, e) {
        var r = this.vertices.length - 1,
            n = this.dimension,
            i = this.vertices,
            l = this.tuple,
            c = this.interior,
            u = this.simplices,
            f = [e];
        e.lastVisited = r, e.vertices[e.vertices.indexOf(-1)] = r, e.boundary = !1, c.push(e);

        for (var h = []; f.length > 0;) {
          var p = (e = f.pop()).vertices,
              d = e.adjacent,
              m = p.indexOf(r);
          if (!(m < 0)) for (var g = 0; g <= n; ++g) {
            if (g !== m) {
              var v = d[g];

              if (v.boundary && !(v.lastVisited >= r)) {
                var y = v.vertices;

                if (v.lastVisited !== -r) {
                  for (var x = 0, b = 0; b <= n; ++b) {
                    y[b] < 0 ? (x = b, l[b] = t) : l[b] = i[y[b]];
                  }

                  if (this.orient() > 0) {
                    y[x] = r, v.boundary = !1, c.push(v), f.push(v), v.lastVisited = r;
                    continue;
                  }

                  v.lastVisited = -r;
                }

                var _ = v.adjacent,
                    w = p.slice(),
                    T = d.slice(),
                    k = new a(w, T, !0);
                u.push(k);

                var M = _.indexOf(e);

                if (!(M < 0)) {
                  _[M] = k, T[m] = v, w[g] = -1, T[g] = e, d[g] = k, k.flip();

                  for (b = 0; b <= n; ++b) {
                    var A = w[b];

                    if (!(A < 0 || A === r)) {
                      for (var S = new Array(n - 1), E = 0, L = 0; L <= n; ++L) {
                        var C = w[L];
                        C < 0 || L === b || (S[E++] = C);
                      }

                      h.push(new o(S, k, b));
                    }
                  }
                }
              }
            }
          }
        }

        h.sort(s);

        for (g = 0; g + 1 < h.length; g += 2) {
          var P = h[g],
              I = h[g + 1],
              O = P.index,
              z = I.index;
          O < 0 || z < 0 || (P.cell.adjacent[P.index] = I.cell, I.cell.adjacent[I.index] = P.cell);
        }
      }, u.insert = function (t, e) {
        var r = this.vertices;
        r.push(t);
        var n = this.walk(t, e);

        if (n) {
          for (var i = this.dimension, a = this.tuple, o = 0; o <= i; ++o) {
            var s = n.vertices[o];
            a[o] = s < 0 ? t : r[s];
          }

          var l = this.orient(a);
          l < 0 || (0 !== l || (n = this.handleBoundaryDegeneracy(n, t))) && this.addPeaks(t, n);
        }
      }, u.boundary = function () {
        for (var t = this.dimension, e = [], r = this.simplices, n = r.length, i = 0; i < n; ++i) {
          var a = r[i];

          if (a.boundary) {
            for (var o = new Array(t), s = a.vertices, l = 0, c = 0, u = 0; u <= t; ++u) {
              s[u] >= 0 ? o[l++] = s[u] : c = 1 & u;
            }

            if (c === (1 & t)) {
              var f = o[0];
              o[0] = o[1], o[1] = f;
            }

            e.push(o);
          }
        }

        return e;
      };
    }, {
      "robust-orientation": 540,
      "simplicial-complex": 551
    }],
    438: [function (t, e, r) {
      "function" == typeof Object.create ? e.exports = function (t, e) {
        e && (t.super_ = e, t.prototype = Object.create(e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }));
      } : e.exports = function (t, e) {
        if (e) {
          t.super_ = e;

          var r = function r() {};

          r.prototype = e.prototype, t.prototype = new r(), t.prototype.constructor = t;
        }
      };
    }, {}],
    439: [function (t, e, r) {
      "use strict";

      var n = t("binary-search-bounds");

      function i(t, e, r, n, i) {
        this.mid = t, this.left = e, this.right = r, this.leftPoints = n, this.rightPoints = i, this.count = (e ? e.count : 0) + (r ? r.count : 0) + n.length;
      }

      e.exports = function (t) {
        if (!t || 0 === t.length) return new v(null);
        return new v(g(t));
      };

      var a = i.prototype;

      function o(t, e) {
        t.mid = e.mid, t.left = e.left, t.right = e.right, t.leftPoints = e.leftPoints, t.rightPoints = e.rightPoints, t.count = e.count;
      }

      function s(t, e) {
        var r = g(e);
        t.mid = r.mid, t.left = r.left, t.right = r.right, t.leftPoints = r.leftPoints, t.rightPoints = r.rightPoints, t.count = r.count;
      }

      function l(t, e) {
        var r = t.intervals([]);
        r.push(e), s(t, r);
      }

      function c(t, e) {
        var r = t.intervals([]),
            n = r.indexOf(e);
        return n < 0 ? 0 : (r.splice(n, 1), s(t, r), 1);
      }

      function u(t, e, r) {
        for (var n = 0; n < t.length && t[n][0] <= e; ++n) {
          var i = r(t[n]);
          if (i) return i;
        }
      }

      function f(t, e, r) {
        for (var n = t.length - 1; n >= 0 && t[n][1] >= e; --n) {
          var i = r(t[n]);
          if (i) return i;
        }
      }

      function h(t, e) {
        for (var r = 0; r < t.length; ++r) {
          var n = e(t[r]);
          if (n) return n;
        }
      }

      function p(t, e) {
        return t - e;
      }

      function d(t, e) {
        var r = t[0] - e[0];
        return r || t[1] - e[1];
      }

      function m(t, e) {
        var r = t[1] - e[1];
        return r || t[0] - e[0];
      }

      function g(t) {
        if (0 === t.length) return null;

        for (var e = [], r = 0; r < t.length; ++r) {
          e.push(t[r][0], t[r][1]);
        }

        e.sort(p);
        var n = e[e.length >> 1],
            a = [],
            o = [],
            s = [];

        for (r = 0; r < t.length; ++r) {
          var l = t[r];
          l[1] < n ? a.push(l) : n < l[0] ? o.push(l) : s.push(l);
        }

        var c = s,
            u = s.slice();
        return c.sort(d), u.sort(m), new i(n, g(a), g(o), c, u);
      }

      function v(t) {
        this.root = t;
      }

      a.intervals = function (t) {
        return t.push.apply(t, this.leftPoints), this.left && this.left.intervals(t), this.right && this.right.intervals(t), t;
      }, a.insert = function (t) {
        var e = this.count - this.leftPoints.length;
        if (this.count += 1, t[1] < this.mid) this.left ? 4 * (this.left.count + 1) > 3 * (e + 1) ? l(this, t) : this.left.insert(t) : this.left = g([t]);else if (t[0] > this.mid) this.right ? 4 * (this.right.count + 1) > 3 * (e + 1) ? l(this, t) : this.right.insert(t) : this.right = g([t]);else {
          var r = n.ge(this.leftPoints, t, d),
              i = n.ge(this.rightPoints, t, m);
          this.leftPoints.splice(r, 0, t), this.rightPoints.splice(i, 0, t);
        }
      }, a.remove = function (t) {
        var e = this.count - this.leftPoints;
        if (t[1] < this.mid) return this.left ? 4 * (this.right ? this.right.count : 0) > 3 * (e - 1) ? c(this, t) : 2 === (s = this.left.remove(t)) ? (this.left = null, this.count -= 1, 1) : (1 === s && (this.count -= 1), s) : 0;
        if (t[0] > this.mid) return this.right ? 4 * (this.left ? this.left.count : 0) > 3 * (e - 1) ? c(this, t) : 2 === (s = this.right.remove(t)) ? (this.right = null, this.count -= 1, 1) : (1 === s && (this.count -= 1), s) : 0;
        if (1 === this.count) return this.leftPoints[0] === t ? 2 : 0;

        if (1 === this.leftPoints.length && this.leftPoints[0] === t) {
          if (this.left && this.right) {
            for (var r = this, i = this.left; i.right;) {
              r = i, i = i.right;
            }

            if (r === this) i.right = this.right;else {
              var a = this.left,
                  s = this.right;
              r.count -= i.count, r.right = i.left, i.left = a, i.right = s;
            }
            o(this, i), this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
          } else this.left ? o(this, this.left) : o(this, this.right);

          return 1;
        }

        for (a = n.ge(this.leftPoints, t, d); a < this.leftPoints.length && this.leftPoints[a][0] === t[0]; ++a) {
          if (this.leftPoints[a] === t) {
            this.count -= 1, this.leftPoints.splice(a, 1);

            for (s = n.ge(this.rightPoints, t, m); s < this.rightPoints.length && this.rightPoints[s][1] === t[1]; ++s) {
              if (this.rightPoints[s] === t) return this.rightPoints.splice(s, 1), 1;
            }
          }
        }

        return 0;
      }, a.queryPoint = function (t, e) {
        if (t < this.mid) {
          if (this.left) if (r = this.left.queryPoint(t, e)) return r;
          return u(this.leftPoints, t, e);
        }

        if (t > this.mid) {
          var r;
          if (this.right) if (r = this.right.queryPoint(t, e)) return r;
          return f(this.rightPoints, t, e);
        }

        return h(this.leftPoints, e);
      }, a.queryInterval = function (t, e, r) {
        var n;
        if (t < this.mid && this.left && (n = this.left.queryInterval(t, e, r))) return n;
        if (e > this.mid && this.right && (n = this.right.queryInterval(t, e, r))) return n;
        return e < this.mid ? u(this.leftPoints, e, r) : t > this.mid ? f(this.rightPoints, t, r) : h(this.leftPoints, r);
      };
      var y = v.prototype;
      y.insert = function (t) {
        this.root ? this.root.insert(t) : this.root = new i(t[0], null, null, [t], [t]);
      }, y.remove = function (t) {
        if (this.root) {
          var e = this.root.remove(t);
          return 2 === e && (this.root = null), 0 !== e;
        }

        return !1;
      }, y.queryPoint = function (t, e) {
        if (this.root) return this.root.queryPoint(t, e);
      }, y.queryInterval = function (t, e, r) {
        if (t <= e && this.root) return this.root.queryInterval(t, e, r);
      }, Object.defineProperty(y, "count", {
        get: function get() {
          return this.root ? this.root.count : 0;
        }
      }), Object.defineProperty(y, "intervals", {
        get: function get() {
          return this.root ? this.root.intervals([]) : [];
        }
      });
    }, {
      "binary-search-bounds": 440
    }],
    440: [function (t, e, r) {
      arguments[4][242][0].apply(r, arguments);
    }, {
      dup: 242
    }],
    441: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        e = e || new Array(t.length);

        for (var r = 0; r < t.length; ++r) {
          e[t[r]] = r;
        }

        return e;
      };
    }, {}],
    442: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        for (var e = new Array(t), r = 0; r < t; ++r) {
          e[r] = r;
        }

        return e;
      };
    }, {}],
    443: [function (t, e, r) {
      e.exports = !0;
    }, {}],
    444: [function (t, e, r) {
      function n(t) {
        return !!t.constructor && "function" == typeof t.constructor.isBuffer && t.constructor.isBuffer(t);
      }
      /*!
       * Determine if an object is a Buffer
       *
       * @author   Feross Aboukhadijeh <https://feross.org>
       * @license  MIT
       */


      e.exports = function (t) {
        return null != t && (n(t) || function (t) {
          return "function" == typeof t.readFloatLE && "function" == typeof t.slice && n(t.slice(0, 0));
        }(t) || !!t._isBuffer);
      };
    }, {}],
    445: [function (t, e, r) {
      "use strict";

      e.exports = "undefined" != typeof navigator && (/MSIE/.test(navigator.userAgent) || /Trident\//.test(navigator.appVersion));
    }, {}],
    446: [function (t, e, r) {
      "use strict";

      e.exports = a, e.exports.isMobile = a, e.exports.default = a;
      var n = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i,
          i = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i;

      function a(t) {
        t || (t = {});
        var e = t.ua;
        if (e || "undefined" == typeof navigator || (e = navigator.userAgent), e && e.headers && "string" == typeof e.headers["user-agent"] && (e = e.headers["user-agent"]), "string" != typeof e) return !1;
        var r = t.tablet ? i.test(e) : n.test(e);
        return !r && t.tablet && t.featureDetect && navigator && navigator.maxTouchPoints > 1 && -1 !== e.indexOf("Macintosh") && -1 !== e.indexOf("Safari") && (r = !0), r;
      }
    }, {}],
    447: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        var e = _typeof(t);

        return null !== t && ("object" === e || "function" === e);
      };
    }, {}],
    448: [function (t, e, r) {
      "use strict";

      var n = Object.prototype.toString;

      e.exports = function (t) {
        var e;
        return "[object Object]" === n.call(t) && (null === (e = Object.getPrototypeOf(t)) || e === Object.getPrototypeOf({}));
      };
    }, {}],
    449: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        for (var e, r = t.length, n = 0; n < r; n++) {
          if (((e = t.charCodeAt(n)) < 9 || e > 13) && 32 !== e && 133 !== e && 160 !== e && 5760 !== e && 6158 !== e && (e < 8192 || e > 8205) && 8232 !== e && 8233 !== e && 8239 !== e && 8287 !== e && 8288 !== e && 12288 !== e && 65279 !== e) return !1;
        }

        return !0;
      };
    }, {}],
    450: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        return "string" == typeof t && (t = t.trim(), !!(/^[mzlhvcsqta]\s*[-+.0-9][^mlhvzcsqta]+/i.test(t) && /[\dz]$/i.test(t) && t.length > 4));
      };
    }, {}],
    451: [function (t, e, r) {
      e.exports = function (t, e, r) {
        return t * (1 - r) + e * r;
      };
    }, {}],
    452: [function (t, e, r) {
      !function (t, n) {
        "object" == _typeof(r) && void 0 !== e ? e.exports = n() : (t = t || self).mapboxgl = n();
      }(this, function () {
        "use strict";

        var t, e, r;

        function n(n, i) {
          if (t) {
            if (e) {
              var a = "var sharedChunk = {}; (" + t + ")(sharedChunk); (" + e + ")(sharedChunk);",
                  o = {};
              t(o), (r = i(o)).workerUrl = window.URL.createObjectURL(new Blob([a], {
                type: "text/javascript"
              }));
            } else e = i;
          } else t = i;
        }

        return n(0, function (t) {
          function e(t, e) {
            return t(e = {
              exports: {}
            }, e.exports), e.exports;
          }

          var r = n;

          function n(t, e, r, n) {
            this.cx = 3 * t, this.bx = 3 * (r - t) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e, this.by = 3 * (n - e) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t, this.p1y = n, this.p2x = r, this.p2y = n;
          }

          n.prototype.sampleCurveX = function (t) {
            return ((this.ax * t + this.bx) * t + this.cx) * t;
          }, n.prototype.sampleCurveY = function (t) {
            return ((this.ay * t + this.by) * t + this.cy) * t;
          }, n.prototype.sampleCurveDerivativeX = function (t) {
            return (3 * this.ax * t + 2 * this.bx) * t + this.cx;
          }, n.prototype.solveCurveX = function (t, e) {
            var r, n, i, a, o;

            for (void 0 === e && (e = 1e-6), i = t, o = 0; o < 8; o++) {
              if (a = this.sampleCurveX(i) - t, Math.abs(a) < e) return i;
              var s = this.sampleCurveDerivativeX(i);
              if (Math.abs(s) < 1e-6) break;
              i -= a / s;
            }

            if ((i = t) < (r = 0)) return r;
            if (i > (n = 1)) return n;

            for (; r < n;) {
              if (a = this.sampleCurveX(i), Math.abs(a - t) < e) return i;
              t > a ? r = i : n = i, i = .5 * (n - r) + r;
            }

            return i;
          }, n.prototype.solve = function (t, e) {
            return this.sampleCurveY(this.solveCurveX(t, e));
          };
          var i = a;

          function a(t, e) {
            this.x = t, this.y = e;
          }

          function o(t, e, n, i) {
            var a = new r(t, e, n, i);
            return function (t) {
              return a.solve(t);
            };
          }

          a.prototype = {
            clone: function clone() {
              return new a(this.x, this.y);
            },
            add: function add(t) {
              return this.clone()._add(t);
            },
            sub: function sub(t) {
              return this.clone()._sub(t);
            },
            multByPoint: function multByPoint(t) {
              return this.clone()._multByPoint(t);
            },
            divByPoint: function divByPoint(t) {
              return this.clone()._divByPoint(t);
            },
            mult: function mult(t) {
              return this.clone()._mult(t);
            },
            div: function div(t) {
              return this.clone()._div(t);
            },
            rotate: function rotate(t) {
              return this.clone()._rotate(t);
            },
            rotateAround: function rotateAround(t, e) {
              return this.clone()._rotateAround(t, e);
            },
            matMult: function matMult(t) {
              return this.clone()._matMult(t);
            },
            unit: function unit() {
              return this.clone()._unit();
            },
            perp: function perp() {
              return this.clone()._perp();
            },
            round: function round() {
              return this.clone()._round();
            },
            mag: function mag() {
              return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            equals: function equals(t) {
              return this.x === t.x && this.y === t.y;
            },
            dist: function dist(t) {
              return Math.sqrt(this.distSqr(t));
            },
            distSqr: function distSqr(t) {
              var e = t.x - this.x,
                  r = t.y - this.y;
              return e * e + r * r;
            },
            angle: function angle() {
              return Math.atan2(this.y, this.x);
            },
            angleTo: function angleTo(t) {
              return Math.atan2(this.y - t.y, this.x - t.x);
            },
            angleWith: function angleWith(t) {
              return this.angleWithSep(t.x, t.y);
            },
            angleWithSep: function angleWithSep(t, e) {
              return Math.atan2(this.x * e - this.y * t, this.x * t + this.y * e);
            },
            _matMult: function _matMult(t) {
              var e = t[0] * this.x + t[1] * this.y,
                  r = t[2] * this.x + t[3] * this.y;
              return this.x = e, this.y = r, this;
            },
            _add: function _add(t) {
              return this.x += t.x, this.y += t.y, this;
            },
            _sub: function _sub(t) {
              return this.x -= t.x, this.y -= t.y, this;
            },
            _mult: function _mult(t) {
              return this.x *= t, this.y *= t, this;
            },
            _div: function _div(t) {
              return this.x /= t, this.y /= t, this;
            },
            _multByPoint: function _multByPoint(t) {
              return this.x *= t.x, this.y *= t.y, this;
            },
            _divByPoint: function _divByPoint(t) {
              return this.x /= t.x, this.y /= t.y, this;
            },
            _unit: function _unit() {
              return this._div(this.mag()), this;
            },
            _perp: function _perp() {
              var t = this.y;
              return this.y = this.x, this.x = -t, this;
            },
            _rotate: function _rotate(t) {
              var e = Math.cos(t),
                  r = Math.sin(t),
                  n = e * this.x - r * this.y,
                  i = r * this.x + e * this.y;
              return this.x = n, this.y = i, this;
            },
            _rotateAround: function _rotateAround(t, e) {
              var r = Math.cos(t),
                  n = Math.sin(t),
                  i = e.x + r * (this.x - e.x) - n * (this.y - e.y),
                  a = e.y + n * (this.x - e.x) + r * (this.y - e.y);
              return this.x = i, this.y = a, this;
            },
            _round: function _round() {
              return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            }
          }, a.convert = function (t) {
            return t instanceof a ? t : Array.isArray(t) ? new a(t[0], t[1]) : t;
          };
          var s = o(.25, .1, .25, 1);

          function l(t, e, r) {
            return Math.min(r, Math.max(e, t));
          }

          function c(t, e, r) {
            var n = r - e,
                i = ((t - e) % n + n) % n + e;
            return i === e ? r : i;
          }

          function u(t) {
            for (var e = [], r = arguments.length - 1; r-- > 0;) {
              e[r] = arguments[r + 1];
            }

            for (var n = 0, i = e; n < i.length; n += 1) {
              var a = i[n];

              for (var o in a) {
                t[o] = a[o];
              }
            }

            return t;
          }

          var f = 1;

          function h() {
            return f++;
          }

          function p() {
            return function t(e) {
              return e ? (e ^ 16 * Math.random() >> e / 4).toString(16) : ([1e7] + -[1e3] + -4e3 + -8e3 + -1e11).replace(/[018]/g, t);
            }();
          }

          function d(t) {
            return !!t && /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t);
          }

          function m(t, e) {
            t.forEach(function (t) {
              e[t] && (e[t] = e[t].bind(e));
            });
          }

          function g(t, e) {
            return -1 !== t.indexOf(e, t.length - e.length);
          }

          function v(t, e, r) {
            var n = {};

            for (var i in t) {
              n[i] = e.call(r || this, t[i], i, t);
            }

            return n;
          }

          function y(t, e, r) {
            var n = {};

            for (var i in t) {
              e.call(r || this, t[i], i, t) && (n[i] = t[i]);
            }

            return n;
          }

          function x(t) {
            return Array.isArray(t) ? t.map(x) : "object" == _typeof(t) && t ? v(t, x) : t;
          }

          var b = {};

          function _(t) {
            b[t] || ("undefined" != typeof console && console.warn(t), b[t] = !0);
          }

          function w(t, e, r) {
            return (r.y - t.y) * (e.x - t.x) > (e.y - t.y) * (r.x - t.x);
          }

          function T(t) {
            for (var e = 0, r = 0, n = t.length, i = n - 1, a = void 0, o = void 0; r < n; i = r++) {
              a = t[r], e += ((o = t[i]).x - a.x) * (a.y + o.y);
            }

            return e;
          }

          function k() {
            return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope;
          }

          function M(t) {
            var e = {};

            if (t.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, function (t, r, n, i) {
              var a = n || i;
              return e[r] = !a || a.toLowerCase(), "";
            }), e["max-age"]) {
              var r = parseInt(e["max-age"], 10);
              isNaN(r) ? delete e["max-age"] : e["max-age"] = r;
            }

            return e;
          }

          var A = null;

          function S(t) {
            if (null == A) {
              var e = t.navigator ? t.navigator.userAgent : null;
              A = !!t.safari || !(!e || !(/\b(iPad|iPhone|iPod)\b/.test(e) || e.match("Safari") && !e.match("Chrome")));
            }

            return A;
          }

          function E(t) {
            try {
              var e = self[t];
              return e.setItem("_mapbox_test_", 1), e.removeItem("_mapbox_test_"), !0;
            } catch (t) {
              return !1;
            }
          }

          var L,
              C,
              P,
              I,
              O = self.performance && self.performance.now ? self.performance.now.bind(self.performance) : Date.now.bind(Date),
              z = self.requestAnimationFrame || self.mozRequestAnimationFrame || self.webkitRequestAnimationFrame || self.msRequestAnimationFrame,
              D = self.cancelAnimationFrame || self.mozCancelAnimationFrame || self.webkitCancelAnimationFrame || self.msCancelAnimationFrame,
              R = {
            now: O,
            frame: function frame(t) {
              var e = z(t);
              return {
                cancel: function cancel() {
                  return D(e);
                }
              };
            },
            getImageData: function getImageData(t, e) {
              void 0 === e && (e = 0);
              var r = self.document.createElement("canvas"),
                  n = r.getContext("2d");
              if (!n) throw new Error("failed to create canvas 2d context");
              return r.width = t.width, r.height = t.height, n.drawImage(t, 0, 0, t.width, t.height), n.getImageData(-e, -e, t.width + 2 * e, t.height + 2 * e);
            },
            resolveURL: function resolveURL(t) {
              return L || (L = self.document.createElement("a")), L.href = t, L.href;
            },
            hardwareConcurrency: self.navigator.hardwareConcurrency || 4,

            get devicePixelRatio() {
              return self.devicePixelRatio;
            },

            get prefersReducedMotion() {
              return !!self.matchMedia && (null == C && (C = self.matchMedia("(prefers-reduced-motion: reduce)")), C.matches);
            }

          },
              F = {
            API_URL: "https://api.mapbox.com",

            get EVENTS_URL() {
              return this.API_URL ? 0 === this.API_URL.indexOf("https://api.mapbox.cn") ? "https://events.mapbox.cn/events/v2" : 0 === this.API_URL.indexOf("https://api.mapbox.com") ? "https://events.mapbox.com/events/v2" : null : null;
            },

            FEEDBACK_URL: "https://apps.mapbox.com/feedback",
            REQUIRE_ACCESS_TOKEN: !0,
            ACCESS_TOKEN: null,
            MAX_PARALLEL_IMAGE_REQUESTS: 16
          },
              B = {
            supported: !1,
            testSupport: function testSupport(t) {
              if (N || !I) return;
              j ? U(t) : P = t;
            }
          },
              N = !1,
              j = !1;

          function U(t) {
            var e = t.createTexture();
            t.bindTexture(t.TEXTURE_2D, e);

            try {
              if (t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, I), t.isContextLost()) return;
              B.supported = !0;
            } catch (t) {}

            t.deleteTexture(e), N = !0;
          }

          self.document && ((I = self.document.createElement("img")).onload = function () {
            P && U(P), P = null, j = !0;
          }, I.onerror = function () {
            N = !0, P = null;
          }, I.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
          var V = "01";

          var q = function q(t, e) {
            this._transformRequestFn = t, this._customAccessToken = e, this._createSkuToken();
          };

          function H(t) {
            return 0 === t.indexOf("mapbox:");
          }

          q.prototype._createSkuToken = function () {
            var t = function () {
              for (var t = "", e = 0; e < 10; e++) {
                t += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
              }

              return {
                token: ["1", V, t].join(""),
                tokenExpiresAt: Date.now() + 432e5
              };
            }();

            this._skuToken = t.token, this._skuTokenExpiresAt = t.tokenExpiresAt;
          }, q.prototype._isSkuTokenExpired = function () {
            return Date.now() > this._skuTokenExpiresAt;
          }, q.prototype.transformRequest = function (t, e) {
            return this._transformRequestFn && this._transformRequestFn(t, e) || {
              url: t
            };
          }, q.prototype.normalizeStyleURL = function (t, e) {
            if (!H(t)) return t;
            var r = X(t);
            return r.path = "/styles/v1" + r.path, this._makeAPIURL(r, this._customAccessToken || e);
          }, q.prototype.normalizeGlyphsURL = function (t, e) {
            if (!H(t)) return t;
            var r = X(t);
            return r.path = "/fonts/v1" + r.path, this._makeAPIURL(r, this._customAccessToken || e);
          }, q.prototype.normalizeSourceURL = function (t, e) {
            if (!H(t)) return t;
            var r = X(t);
            return r.path = "/v4/" + r.authority + ".json", r.params.push("secure"), this._makeAPIURL(r, this._customAccessToken || e);
          }, q.prototype.normalizeSpriteURL = function (t, e, r, n) {
            var i = X(t);
            return H(t) ? (i.path = "/styles/v1" + i.path + "/sprite" + e + r, this._makeAPIURL(i, this._customAccessToken || n)) : (i.path += "" + e + r, Z(i));
          }, q.prototype.normalizeTileURL = function (t, e) {
            if (this._isSkuTokenExpired() && this._createSkuToken(), t && !H(t)) return t;
            var r = X(t),
                n = R.devicePixelRatio >= 2 || 512 === e ? "@2x" : "",
                i = B.supported ? ".webp" : "$1";
            r.path = r.path.replace(/(\.(png|jpg)\d*)(?=$)/, "" + n + i), r.path = r.path.replace(/^.+\/v4\//, "/"), r.path = "/v4" + r.path;

            var a = this._customAccessToken || function (t) {
              for (var e = 0, r = t; e < r.length; e += 1) {
                var n = r[e].match(/^access_token=(.*)$/);
                if (n) return n[1];
              }

              return null;
            }(r.params) || F.ACCESS_TOKEN;

            return F.REQUIRE_ACCESS_TOKEN && a && this._skuToken && r.params.push("sku=" + this._skuToken), this._makeAPIURL(r, a);
          }, q.prototype.canonicalizeTileURL = function (t, e) {
            var r = X(t);
            if (!r.path.match(/(^\/v4\/)/) || !r.path.match(/\.[\w]+$/)) return t;
            var n = "mapbox://tiles/";
            n += r.path.replace("/v4/", "");
            var i = r.params;
            return e && (i = i.filter(function (t) {
              return !t.match(/^access_token=/);
            })), i.length && (n += "?" + i.join("&")), n;
          }, q.prototype.canonicalizeTileset = function (t, e) {
            for (var r = !!e && H(e), n = [], i = 0, a = t.tiles || []; i < a.length; i += 1) {
              var o = a[i];
              Y(o) ? n.push(this.canonicalizeTileURL(o, r)) : n.push(o);
            }

            return n;
          }, q.prototype._makeAPIURL = function (t, e) {
            var r = "See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes",
                n = X(F.API_URL);
            if (t.protocol = n.protocol, t.authority = n.authority, "/" !== n.path && (t.path = "" + n.path + t.path), !F.REQUIRE_ACCESS_TOKEN) return Z(t);
            if (!(e = e || F.ACCESS_TOKEN)) throw new Error("An API access token is required to use Mapbox GL. " + r);
            if ("s" === e[0]) throw new Error("Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). " + r);
            return t.params = t.params.filter(function (t) {
              return -1 === t.indexOf("access_token");
            }), t.params.push("access_token=" + e), Z(t);
          };
          var G = /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;

          function Y(t) {
            return G.test(t);
          }

          var W = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;

          function X(t) {
            var e = t.match(W);
            if (!e) throw new Error("Unable to parse URL object");
            return {
              protocol: e[1],
              authority: e[2],
              path: e[3] || "/",
              params: e[4] ? e[4].split("&") : []
            };
          }

          function Z(t) {
            var e = t.params.length ? "?" + t.params.join("&") : "";
            return t.protocol + "://" + t.authority + t.path + e;
          }

          function J(t) {
            if (!t) return null;
            var e,
                r = t.split(".");
            if (!r || 3 !== r.length) return null;

            try {
              return JSON.parse((e = r[1], decodeURIComponent(self.atob(e).split("").map(function (t) {
                return "%" + ("00" + t.charCodeAt(0).toString(16)).slice(-2);
              }).join(""))));
            } catch (t) {
              return null;
            }
          }

          var K = function K(t) {
            this.type = t, this.anonId = null, this.eventData = {}, this.queue = [], this.pendingRequest = null;
          };

          K.prototype.getStorageKey = function (t) {
            var e,
                r = J(F.ACCESS_TOKEN),
                n = "";
            return r && r.u ? (e = r.u, n = self.btoa(encodeURIComponent(e).replace(/%([0-9A-F]{2})/g, function (t, e) {
              return String.fromCharCode(Number("0x" + e));
            }))) : n = F.ACCESS_TOKEN || "", t ? "mapbox.eventData." + t + ":" + n : "mapbox.eventData:" + n;
          }, K.prototype.fetchEventData = function () {
            var t = E("localStorage"),
                e = this.getStorageKey(),
                r = this.getStorageKey("uuid");
            if (t) try {
              var n = self.localStorage.getItem(e);
              n && (this.eventData = JSON.parse(n));
              var i = self.localStorage.getItem(r);
              i && (this.anonId = i);
            } catch (t) {
              _("Unable to read from LocalStorage");
            }
          }, K.prototype.saveEventData = function () {
            var t = E("localStorage"),
                e = this.getStorageKey(),
                r = this.getStorageKey("uuid");
            if (t) try {
              self.localStorage.setItem(r, this.anonId), Object.keys(this.eventData).length >= 1 && self.localStorage.setItem(e, JSON.stringify(this.eventData));
            } catch (t) {
              _("Unable to write to LocalStorage");
            }
          }, K.prototype.processRequests = function (t) {}, K.prototype.postEvent = function (t, e, r, n) {
            var i = this;

            if (F.EVENTS_URL) {
              var a = X(F.EVENTS_URL);
              a.params.push("access_token=" + (n || F.ACCESS_TOKEN || ""));
              var o = {
                event: this.type,
                created: new Date(t).toISOString(),
                sdkIdentifier: "mapbox-gl-js",
                sdkVersion: "1.10.1",
                skuId: V,
                userId: this.anonId
              },
                  s = e ? u(o, e) : o,
                  l = {
                url: Z(a),
                headers: {
                  "Content-Type": "text/plain"
                },
                body: JSON.stringify([s])
              };
              this.pendingRequest = bt(l, function (t) {
                i.pendingRequest = null, r(t), i.saveEventData(), i.processRequests(n);
              });
            }
          }, K.prototype.queueRequest = function (t, e) {
            this.queue.push(t), this.processRequests(e);
          };

          var Q,
              $,
              tt = function (t) {
            function e() {
              t.call(this, "map.load"), this.success = {}, this.skuToken = "";
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.postMapLoadEvent = function (t, e, r, n) {
              this.skuToken = r, (F.EVENTS_URL && n || F.ACCESS_TOKEN && Array.isArray(t) && t.some(function (t) {
                return H(t) || Y(t);
              })) && this.queueRequest({
                id: e,
                timestamp: Date.now()
              }, n);
            }, e.prototype.processRequests = function (t) {
              var e = this;

              if (!this.pendingRequest && 0 !== this.queue.length) {
                var r = this.queue.shift(),
                    n = r.id,
                    i = r.timestamp;
                n && this.success[n] || (this.anonId || this.fetchEventData(), d(this.anonId) || (this.anonId = p()), this.postEvent(i, {
                  skuToken: this.skuToken
                }, function (t) {
                  t || n && (e.success[n] = !0);
                }, t));
              }
            }, e;
          }(K),
              et = new (function (t) {
            function e(e) {
              t.call(this, "appUserTurnstile"), this._customAccessToken = e;
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.postTurnstileEvent = function (t, e) {
              F.EVENTS_URL && F.ACCESS_TOKEN && Array.isArray(t) && t.some(function (t) {
                return H(t) || Y(t);
              }) && this.queueRequest(Date.now(), e);
            }, e.prototype.processRequests = function (t) {
              var e = this;

              if (!this.pendingRequest && 0 !== this.queue.length) {
                this.anonId && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
                var r = J(F.ACCESS_TOKEN),
                    n = r ? r.u : F.ACCESS_TOKEN,
                    i = n !== this.eventData.tokenU;
                d(this.anonId) || (this.anonId = p(), i = !0);
                var a = this.queue.shift();

                if (this.eventData.lastSuccess) {
                  var o = new Date(this.eventData.lastSuccess),
                      s = new Date(a),
                      l = (a - this.eventData.lastSuccess) / 864e5;
                  i = i || l >= 1 || l < -1 || o.getDate() !== s.getDate();
                } else i = !0;

                if (!i) return this.processRequests();
                this.postEvent(a, {
                  "enabled.telemetry": !1
                }, function (t) {
                  t || (e.eventData.lastSuccess = a, e.eventData.tokenU = n);
                }, t);
              }
            }, e;
          }(K))(),
              rt = et.postTurnstileEvent.bind(et),
              nt = new tt(),
              it = nt.postMapLoadEvent.bind(nt),
              at = 500,
              ot = 50;

          function st() {
            self.caches && !Q && (Q = self.caches.open("mapbox-tiles"));
          }

          function lt(t, e, r) {
            if (st(), Q) {
              var n = {
                status: e.status,
                statusText: e.statusText,
                headers: new self.Headers()
              };
              e.headers.forEach(function (t, e) {
                return n.headers.set(e, t);
              });
              var i = M(e.headers.get("Cache-Control") || "");
              if (!i["no-store"]) i["max-age"] && n.headers.set("Expires", new Date(r + 1e3 * i["max-age"]).toUTCString()), new Date(n.headers.get("Expires")).getTime() - r < 42e4 || function (t, e) {
                if (void 0 === $) try {
                  new Response(new ReadableStream()), $ = !0;
                } catch (t) {
                  $ = !1;
                }
                $ ? e(t.body) : t.blob().then(e);
              }(e, function (e) {
                var r = new self.Response(e, n);
                st(), Q && Q.then(function (e) {
                  return e.put(ct(t.url), r);
                }).catch(function (t) {
                  return _(t.message);
                });
              });
            }
          }

          function ct(t) {
            var e = t.indexOf("?");
            return e < 0 ? t : t.slice(0, e);
          }

          function ut(t, e) {
            if (st(), !Q) return e(null);
            var r = ct(t.url);
            Q.then(function (t) {
              t.match(r).then(function (n) {
                var i = function (t) {
                  if (!t) return !1;
                  var e = new Date(t.headers.get("Expires") || 0),
                      r = M(t.headers.get("Cache-Control") || "");
                  return e > Date.now() && !r["no-cache"];
                }(n);

                t.delete(r), i && t.put(r, n.clone()), e(null, n, i);
              }).catch(e);
            }).catch(e);
          }

          var ft,
              ht = 1 / 0;

          function pt() {
            return null == ft && (ft = self.OffscreenCanvas && new self.OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof self.createImageBitmap), ft;
          }

          var dt = {
            Unknown: "Unknown",
            Style: "Style",
            Source: "Source",
            Tile: "Tile",
            Glyphs: "Glyphs",
            SpriteImage: "SpriteImage",
            SpriteJSON: "SpriteJSON",
            Image: "Image"
          };
          "function" == typeof Object.freeze && Object.freeze(dt);

          var mt = function (t) {
            function e(e, r, n) {
              401 === r && Y(n) && (e += ": you may have provided an invalid Mapbox access token. See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes"), t.call(this, e), this.status = r, this.url = n, this.name = this.constructor.name, this.message = e;
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.toString = function () {
              return this.name + ": " + this.message + " (" + this.status + "): " + this.url;
            }, e;
          }(Error),
              gt = k() ? function () {
            return self.worker && self.worker.referrer;
          } : function () {
            return ("blob:" === self.location.protocol ? self.parent : self).location.href;
          };

          function vt(t, e) {
            var r,
                n = new self.AbortController(),
                i = new self.Request(t.url, {
              method: t.method || "GET",
              body: t.body,
              credentials: t.credentials,
              headers: t.headers,
              referrer: gt(),
              signal: n.signal
            }),
                a = !1,
                o = !1,
                s = (r = i.url).indexOf("sku=") > 0 && Y(r);
            "json" === t.type && i.headers.set("Accept", "application/json");

            var l = function l(r, n, a) {
              if (!o) {
                if (r && "SecurityError" !== r.message && _(r), n && a) return c(n);
                var l = Date.now();
                self.fetch(i).then(function (r) {
                  if (r.ok) {
                    var n = s ? r.clone() : null;
                    return c(r, n, l);
                  }

                  return e(new mt(r.statusText, r.status, t.url));
                }).catch(function (t) {
                  20 !== t.code && e(new Error(t.message));
                });
              }
            },
                c = function c(r, n, s) {
              ("arrayBuffer" === t.type ? r.arrayBuffer() : "json" === t.type ? r.json() : r.text()).then(function (t) {
                o || (n && s && lt(i, n, s), a = !0, e(null, t, r.headers.get("Cache-Control"), r.headers.get("Expires")));
              }).catch(function (t) {
                o || e(new Error(t.message));
              });
            };

            return s ? ut(i, l) : l(null, null), {
              cancel: function cancel() {
                o = !0, a || n.abort();
              }
            };
          }

          var yt = function yt(t, e) {
            if (r = t.url, !(/^file:/.test(r) || /^file:/.test(gt()) && !/^\w+:/.test(r))) {
              if (self.fetch && self.Request && self.AbortController && self.Request.prototype.hasOwnProperty("signal")) return vt(t, e);

              if (k() && self.worker && self.worker.actor) {
                return self.worker.actor.send("getResource", t, e, void 0, !0);
              }
            }

            var r;
            return function (t, e) {
              var r = new self.XMLHttpRequest();

              for (var n in r.open(t.method || "GET", t.url, !0), "arrayBuffer" === t.type && (r.responseType = "arraybuffer"), t.headers) {
                r.setRequestHeader(n, t.headers[n]);
              }

              return "json" === t.type && (r.responseType = "text", r.setRequestHeader("Accept", "application/json")), r.withCredentials = "include" === t.credentials, r.onerror = function () {
                e(new Error(r.statusText));
              }, r.onload = function () {
                if ((r.status >= 200 && r.status < 300 || 0 === r.status) && null !== r.response) {
                  var n = r.response;
                  if ("json" === t.type) try {
                    n = JSON.parse(r.response);
                  } catch (t) {
                    return e(t);
                  }
                  e(null, n, r.getResponseHeader("Cache-Control"), r.getResponseHeader("Expires"));
                } else e(new mt(r.statusText, r.status, t.url));
              }, r.send(t.body), {
                cancel: function cancel() {
                  return r.abort();
                }
              };
            }(t, e);
          },
              xt = function xt(t, e) {
            return yt(u(t, {
              type: "arrayBuffer"
            }), e);
          },
              bt = function bt(t, e) {
            return yt(u(t, {
              method: "POST"
            }), e);
          };

          var _t, wt;

          _t = [], wt = 0;

          var Tt = function Tt(t, e) {
            if (B.supported && (t.headers || (t.headers = {}), t.headers.accept = "image/webp,*/*"), wt >= F.MAX_PARALLEL_IMAGE_REQUESTS) {
              var r = {
                requestParameters: t,
                callback: e,
                cancelled: !1,
                cancel: function cancel() {
                  this.cancelled = !0;
                }
              };
              return _t.push(r), r;
            }

            wt++;

            var n = !1,
                i = function i() {
              if (!n) for (n = !0, wt--; _t.length && wt < F.MAX_PARALLEL_IMAGE_REQUESTS;) {
                var t = _t.shift(),
                    e = t.requestParameters,
                    r = t.callback;

                t.cancelled || (t.cancel = Tt(e, r).cancel);
              }
            },
                a = xt(t, function (t, r, n, a) {
              i(), t ? e(t) : r && (pt() ? function (t, e) {
                var r = new self.Blob([new Uint8Array(t)], {
                  type: "image/png"
                });
                self.createImageBitmap(r).then(function (t) {
                  e(null, t);
                }).catch(function (t) {
                  e(new Error("Could not load image because of " + t.message + ". Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                });
              }(r, e) : function (t, e, r, n) {
                var i = new self.Image(),
                    a = self.URL;
                i.onload = function () {
                  e(null, i), a.revokeObjectURL(i.src);
                }, i.onerror = function () {
                  return e(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                };
                var o = new self.Blob([new Uint8Array(t)], {
                  type: "image/png"
                });
                i.cacheControl = r, i.expires = n, i.src = t.byteLength ? a.createObjectURL(o) : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
              }(r, e, n, a));
            });

            return {
              cancel: function cancel() {
                a.cancel(), i();
              }
            };
          };

          function kt(t, e, r) {
            r[t] && -1 !== r[t].indexOf(e) || (r[t] = r[t] || [], r[t].push(e));
          }

          function Mt(t, e, r) {
            if (r && r[t]) {
              var n = r[t].indexOf(e);
              -1 !== n && r[t].splice(n, 1);
            }
          }

          var At = function At(t, e) {
            void 0 === e && (e = {}), u(this, e), this.type = t;
          },
              St = function (t) {
            function e(e, r) {
              void 0 === r && (r = {}), t.call(this, "error", u({
                error: e
              }, r));
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
          }(At),
              Et = function Et() {};

          Et.prototype.on = function (t, e) {
            return this._listeners = this._listeners || {}, kt(t, e, this._listeners), this;
          }, Et.prototype.off = function (t, e) {
            return Mt(t, e, this._listeners), Mt(t, e, this._oneTimeListeners), this;
          }, Et.prototype.once = function (t, e) {
            return this._oneTimeListeners = this._oneTimeListeners || {}, kt(t, e, this._oneTimeListeners), this;
          }, Et.prototype.fire = function (t, e) {
            "string" == typeof t && (t = new At(t, e || {}));
            var r = t.type;

            if (this.listens(r)) {
              t.target = this;

              for (var n = 0, i = this._listeners && this._listeners[r] ? this._listeners[r].slice() : []; n < i.length; n += 1) {
                i[n].call(this, t);
              }

              for (var a = 0, o = this._oneTimeListeners && this._oneTimeListeners[r] ? this._oneTimeListeners[r].slice() : []; a < o.length; a += 1) {
                var s = o[a];
                Mt(r, s, this._oneTimeListeners), s.call(this, t);
              }

              var l = this._eventedParent;
              l && (u(t, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), l.fire(t));
            } else t instanceof St && console.error(t.error);

            return this;
          }, Et.prototype.listens = function (t) {
            return this._listeners && this._listeners[t] && this._listeners[t].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t] && this._oneTimeListeners[t].length > 0 || this._eventedParent && this._eventedParent.listens(t);
          }, Et.prototype.setEventedParent = function (t, e) {
            return this._eventedParent = t, this._eventedParentData = e, this;
          };

          var Lt = {
            $version: 8,
            $root: {
              version: {
                required: !0,
                type: "enum",
                values: [8]
              },
              name: {
                type: "string"
              },
              metadata: {
                type: "*"
              },
              center: {
                type: "array",
                value: "number"
              },
              zoom: {
                type: "number"
              },
              bearing: {
                type: "number",
                default: 0,
                period: 360,
                units: "degrees"
              },
              pitch: {
                type: "number",
                default: 0,
                units: "degrees"
              },
              light: {
                type: "light"
              },
              sources: {
                required: !0,
                type: "sources"
              },
              sprite: {
                type: "string"
              },
              glyphs: {
                type: "string"
              },
              transition: {
                type: "transition"
              },
              layers: {
                required: !0,
                type: "array",
                value: "layer"
              }
            },
            sources: {
              "*": {
                type: "source"
              }
            },
            source: ["source_vector", "source_raster", "source_raster_dem", "source_geojson", "source_video", "source_image"],
            source_vector: {
              type: {
                required: !0,
                type: "enum",
                values: {
                  vector: {}
                }
              },
              url: {
                type: "string"
              },
              tiles: {
                type: "array",
                value: "string"
              },
              bounds: {
                type: "array",
                value: "number",
                length: 4,
                default: [-180, -85.051129, 180, 85.051129]
              },
              scheme: {
                type: "enum",
                values: {
                  xyz: {},
                  tms: {}
                },
                default: "xyz"
              },
              minzoom: {
                type: "number",
                default: 0
              },
              maxzoom: {
                type: "number",
                default: 22
              },
              attribution: {
                type: "string"
              },
              promoteId: {
                type: "promoteId"
              },
              "*": {
                type: "*"
              }
            },
            source_raster: {
              type: {
                required: !0,
                type: "enum",
                values: {
                  raster: {}
                }
              },
              url: {
                type: "string"
              },
              tiles: {
                type: "array",
                value: "string"
              },
              bounds: {
                type: "array",
                value: "number",
                length: 4,
                default: [-180, -85.051129, 180, 85.051129]
              },
              minzoom: {
                type: "number",
                default: 0
              },
              maxzoom: {
                type: "number",
                default: 22
              },
              tileSize: {
                type: "number",
                default: 512,
                units: "pixels"
              },
              scheme: {
                type: "enum",
                values: {
                  xyz: {},
                  tms: {}
                },
                default: "xyz"
              },
              attribution: {
                type: "string"
              },
              "*": {
                type: "*"
              }
            },
            source_raster_dem: {
              type: {
                required: !0,
                type: "enum",
                values: {
                  "raster-dem": {}
                }
              },
              url: {
                type: "string"
              },
              tiles: {
                type: "array",
                value: "string"
              },
              bounds: {
                type: "array",
                value: "number",
                length: 4,
                default: [-180, -85.051129, 180, 85.051129]
              },
              minzoom: {
                type: "number",
                default: 0
              },
              maxzoom: {
                type: "number",
                default: 22
              },
              tileSize: {
                type: "number",
                default: 512,
                units: "pixels"
              },
              attribution: {
                type: "string"
              },
              encoding: {
                type: "enum",
                values: {
                  terrarium: {},
                  mapbox: {}
                },
                default: "mapbox"
              },
              "*": {
                type: "*"
              }
            },
            source_geojson: {
              type: {
                required: !0,
                type: "enum",
                values: {
                  geojson: {}
                }
              },
              data: {
                type: "*"
              },
              maxzoom: {
                type: "number",
                default: 18
              },
              attribution: {
                type: "string"
              },
              buffer: {
                type: "number",
                default: 128,
                maximum: 512,
                minimum: 0
              },
              tolerance: {
                type: "number",
                default: .375
              },
              cluster: {
                type: "boolean",
                default: !1
              },
              clusterRadius: {
                type: "number",
                default: 50,
                minimum: 0
              },
              clusterMaxZoom: {
                type: "number"
              },
              clusterProperties: {
                type: "*"
              },
              lineMetrics: {
                type: "boolean",
                default: !1
              },
              generateId: {
                type: "boolean",
                default: !1
              },
              promoteId: {
                type: "promoteId"
              }
            },
            source_video: {
              type: {
                required: !0,
                type: "enum",
                values: {
                  video: {}
                }
              },
              urls: {
                required: !0,
                type: "array",
                value: "string"
              },
              coordinates: {
                required: !0,
                type: "array",
                length: 4,
                value: {
                  type: "array",
                  length: 2,
                  value: "number"
                }
              }
            },
            source_image: {
              type: {
                required: !0,
                type: "enum",
                values: {
                  image: {}
                }
              },
              url: {
                required: !0,
                type: "string"
              },
              coordinates: {
                required: !0,
                type: "array",
                length: 4,
                value: {
                  type: "array",
                  length: 2,
                  value: "number"
                }
              }
            },
            layer: {
              id: {
                type: "string",
                required: !0
              },
              type: {
                type: "enum",
                values: {
                  fill: {},
                  line: {},
                  symbol: {},
                  circle: {},
                  heatmap: {},
                  "fill-extrusion": {},
                  raster: {},
                  hillshade: {},
                  background: {}
                },
                required: !0
              },
              metadata: {
                type: "*"
              },
              source: {
                type: "string"
              },
              "source-layer": {
                type: "string"
              },
              minzoom: {
                type: "number",
                minimum: 0,
                maximum: 24
              },
              maxzoom: {
                type: "number",
                minimum: 0,
                maximum: 24
              },
              filter: {
                type: "filter"
              },
              layout: {
                type: "layout"
              },
              paint: {
                type: "paint"
              }
            },
            layout: ["layout_fill", "layout_line", "layout_circle", "layout_heatmap", "layout_fill-extrusion", "layout_symbol", "layout_raster", "layout_hillshade", "layout_background"],
            layout_background: {
              visibility: {
                type: "enum",
                values: {
                  visible: {},
                  none: {}
                },
                default: "visible",
                "property-type": "constant"
              }
            },
            layout_fill: {
              "fill-sort-key": {
                type: "number",
                expression: {
                  interpolated: !1,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "data-driven"
              },
              visibility: {
                type: "enum",
                values: {
                  visible: {},
                  none: {}
                },
                default: "visible",
                "property-type": "constant"
              }
            },
            layout_circle: {
              "circle-sort-key": {
                type: "number",
                expression: {
                  interpolated: !1,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "data-driven"
              },
              visibility: {
                type: "enum",
                values: {
                  visible: {},
                  none: {}
                },
                default: "visible",
                "property-type": "constant"
              }
            },
            layout_heatmap: {
              visibility: {
                type: "enum",
                values: {
                  visible: {},
                  none: {}
                },
                default: "visible",
                "property-type": "constant"
              }
            },
            "layout_fill-extrusion": {
              visibility: {
                type: "enum",
                values: {
                  visible: {},
                  none: {}
                },
                default: "visible",
                "property-type": "constant"
              }
            },
            layout_line: {
              "line-cap": {
                type: "enum",
                values: {
                  butt: {},
                  round: {},
                  square: {}
                },
                default: "butt",
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "line-join": {
                type: "enum",
                values: {
                  bevel: {},
                  round: {},
                  miter: {}
                },
                default: "miter",
                expression: {
                  interpolated: !1,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "data-driven"
              },
              "line-miter-limit": {
                type: "number",
                default: 2,
                requires: [{
                  "line-join": "miter"
                }],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "line-round-limit": {
                type: "number",
                default: 1.05,
                requires: [{
                  "line-join": "round"
                }],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "line-sort-key": {
                type: "number",
                expression: {
                  interpolated: !1,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "data-driven"
              },
              visibility: {
                type: "enum",
                values: {
                  visible: {},
                  none: {}
                },
                default: "visible",
                "property-type": "constant"
              }
            },
            layout_symbol: {
              "symbol-placement": {
                type: "enum",
                values: {
                  point: {},
                  line: {},
                  "line-center": {}
                },
                default: "point",
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "symbol-spacing": {
                type: "number",
                default: 250,
                minimum: 1,
                units: "pixels",
                requires: [{
                  "symbol-placement": "line"
                }],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "symbol-avoid-edges": {
                type: "boolean",
                default: !1,
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "symbol-sort-key": {
                type: "number",
                expression: {
                  interpolated: !1,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "data-driven"
              },
              "symbol-z-order": {
                type: "enum",
                values: {
                  auto: {},
                  "viewport-y": {},
                  source: {}
                },
                default: "auto",
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "icon-allow-overlap": {
                type: "boolean",
                default: !1,
                requires: ["icon-image"],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "icon-ignore-placement": {
                type: "boolean",
                default: !1,
                requires: ["icon-image"],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "icon-optional": {
                type: "boolean",
                default: !1,
                requires: ["icon-image", "text-field"],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "icon-rotation-alignment": {
                type: "enum",
                values: {
                  map: {},
                  viewport: {},
                  auto: {}
                },
                default: "auto",
                requires: ["icon-image"],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "icon-size": {
                type: "number",
                default: 1,
                minimum: 0,
                units: "factor of the original icon size",
                requires: ["icon-image"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "data-driven"
              },
              "icon-text-fit": {
                type: "enum",
                values: {
                  none: {},
                  width: {},
                  height: {},
                  both: {}
                },
                default: "none",
                requires: ["icon-image", "text-field"],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "icon-text-fit-padding": {
                type: "array",
                value: "number",
                length: 4,
                default: [0, 0, 0, 0],
                units: "pixels",
                requires: ["icon-image", "text-field", {
                  "icon-text-fit": ["both", "width", "height"]
                }],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "icon-image": {
                type: "resolvedImage",
                tokens: !0,
                expression: {
                  interpolated: !1,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "data-driven"
              },
              "icon-rotate": {
                type: "number",
                default: 0,
                period: 360,
                units: "degrees",
                requires: ["icon-image"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "data-driven"
              },
              "icon-padding": {
                type: "number",
                default: 2,
                minimum: 0,
                units: "pixels",
                requires: ["icon-image"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "icon-keep-upright": {
                type: "boolean",
                default: !1,
                requires: ["icon-image", {
                  "icon-rotation-alignment": "map"
                }, {
                  "symbol-placement": ["line", "line-center"]
                }],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "icon-offset": {
                type: "array",
                value: "number",
                length: 2,
                default: [0, 0],
                requires: ["icon-image"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "data-driven"
              },
              "icon-anchor": {
                type: "enum",
                values: {
                  center: {},
                  left: {},
                  right: {},
                  top: {},
                  bottom: {},
                  "top-left": {},
                  "top-right": {},
                  "bottom-left": {},
                  "bottom-right": {}
                },
                default: "center",
                requires: ["icon-image"],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "data-driven"
              },
              "icon-pitch-alignment": {
                type: "enum",
                values: {
                  map: {},
                  viewport: {},
                  auto: {}
                },
                default: "auto",
                requires: ["icon-image"],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "text-pitch-alignment": {
                type: "enum",
                values: {
                  map: {},
                  viewport: {},
                  auto: {}
                },
                default: "auto",
                requires: ["text-field"],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "text-rotation-alignment": {
                type: "enum",
                values: {
                  map: {},
                  viewport: {},
                  auto: {}
                },
                default: "auto",
                requires: ["text-field"],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "text-field": {
                type: "formatted",
                default: "",
                tokens: !0,
                expression: {
                  interpolated: !1,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "data-driven"
              },
              "text-font": {
                type: "array",
                value: "string",
                default: ["Open Sans Regular", "Arial Unicode MS Regular"],
                requires: ["text-field"],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "data-driven"
              },
              "text-size": {
                type: "number",
                default: 16,
                minimum: 0,
                units: "pixels",
                requires: ["text-field"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "data-driven"
              },
              "text-max-width": {
                type: "number",
                default: 10,
                minimum: 0,
                units: "ems",
                requires: ["text-field"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "data-driven"
              },
              "text-line-height": {
                type: "number",
                default: 1.2,
                units: "ems",
                requires: ["text-field"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "text-letter-spacing": {
                type: "number",
                default: 0,
                units: "ems",
                requires: ["text-field"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "data-driven"
              },
              "text-justify": {
                type: "enum",
                values: {
                  auto: {},
                  left: {},
                  center: {},
                  right: {}
                },
                default: "center",
                requires: ["text-field"],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "data-driven"
              },
              "text-radial-offset": {
                type: "number",
                units: "ems",
                default: 0,
                requires: ["text-field"],
                "property-type": "data-driven",
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature"]
                }
              },
              "text-variable-anchor": {
                type: "array",
                value: "enum",
                values: {
                  center: {},
                  left: {},
                  right: {},
                  top: {},
                  bottom: {},
                  "top-left": {},
                  "top-right": {},
                  "bottom-left": {},
                  "bottom-right": {}
                },
                requires: ["text-field", {
                  "symbol-placement": ["point"]
                }],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "text-anchor": {
                type: "enum",
                values: {
                  center: {},
                  left: {},
                  right: {},
                  top: {},
                  bottom: {},
                  "top-left": {},
                  "top-right": {},
                  "bottom-left": {},
                  "bottom-right": {}
                },
                default: "center",
                requires: ["text-field", {
                  "!": "text-variable-anchor"
                }],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "data-driven"
              },
              "text-max-angle": {
                type: "number",
                default: 45,
                units: "degrees",
                requires: ["text-field", {
                  "symbol-placement": ["line", "line-center"]
                }],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "text-writing-mode": {
                type: "array",
                value: "enum",
                values: {
                  horizontal: {},
                  vertical: {}
                },
                requires: ["text-field", {
                  "symbol-placement": ["point"]
                }],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "text-rotate": {
                type: "number",
                default: 0,
                period: 360,
                units: "degrees",
                requires: ["text-field"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "data-driven"
              },
              "text-padding": {
                type: "number",
                default: 2,
                minimum: 0,
                units: "pixels",
                requires: ["text-field"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "text-keep-upright": {
                type: "boolean",
                default: !0,
                requires: ["text-field", {
                  "text-rotation-alignment": "map"
                }, {
                  "symbol-placement": ["line", "line-center"]
                }],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "text-transform": {
                type: "enum",
                values: {
                  none: {},
                  uppercase: {},
                  lowercase: {}
                },
                default: "none",
                requires: ["text-field"],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "data-driven"
              },
              "text-offset": {
                type: "array",
                value: "number",
                units: "ems",
                length: 2,
                default: [0, 0],
                requires: ["text-field", {
                  "!": "text-radial-offset"
                }],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "data-driven"
              },
              "text-allow-overlap": {
                type: "boolean",
                default: !1,
                requires: ["text-field"],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "text-ignore-placement": {
                type: "boolean",
                default: !1,
                requires: ["text-field"],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "text-optional": {
                type: "boolean",
                default: !1,
                requires: ["text-field", "icon-image"],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              visibility: {
                type: "enum",
                values: {
                  visible: {},
                  none: {}
                },
                default: "visible",
                "property-type": "constant"
              }
            },
            layout_raster: {
              visibility: {
                type: "enum",
                values: {
                  visible: {},
                  none: {}
                },
                default: "visible",
                "property-type": "constant"
              }
            },
            layout_hillshade: {
              visibility: {
                type: "enum",
                values: {
                  visible: {},
                  none: {}
                },
                default: "visible",
                "property-type": "constant"
              }
            },
            filter: {
              type: "array",
              value: "*"
            },
            filter_operator: {
              type: "enum",
              values: {
                "==": {},
                "!=": {},
                ">": {},
                ">=": {},
                "<": {},
                "<=": {},
                in: {},
                "!in": {},
                all: {},
                any: {},
                none: {},
                has: {},
                "!has": {},
                within: {}
              }
            },
            geometry_type: {
              type: "enum",
              values: {
                Point: {},
                LineString: {},
                Polygon: {}
              }
            },
            function: {
              expression: {
                type: "expression"
              },
              stops: {
                type: "array",
                value: "function_stop"
              },
              base: {
                type: "number",
                default: 1,
                minimum: 0
              },
              property: {
                type: "string",
                default: "$zoom"
              },
              type: {
                type: "enum",
                values: {
                  identity: {},
                  exponential: {},
                  interval: {},
                  categorical: {}
                },
                default: "exponential"
              },
              colorSpace: {
                type: "enum",
                values: {
                  rgb: {},
                  lab: {},
                  hcl: {}
                },
                default: "rgb"
              },
              default: {
                type: "*",
                required: !1
              }
            },
            function_stop: {
              type: "array",
              minimum: 0,
              maximum: 24,
              value: ["number", "color"],
              length: 2
            },
            expression: {
              type: "array",
              value: "*",
              minimum: 1
            },
            expression_name: {
              type: "enum",
              values: {
                let: {
                  group: "Variable binding"
                },
                var: {
                  group: "Variable binding"
                },
                literal: {
                  group: "Types"
                },
                array: {
                  group: "Types"
                },
                at: {
                  group: "Lookup"
                },
                in: {
                  group: "Lookup"
                },
                "index-of": {
                  group: "Lookup"
                },
                slice: {
                  group: "Lookup"
                },
                case: {
                  group: "Decision"
                },
                match: {
                  group: "Decision"
                },
                coalesce: {
                  group: "Decision"
                },
                step: {
                  group: "Ramps, scales, curves"
                },
                interpolate: {
                  group: "Ramps, scales, curves"
                },
                "interpolate-hcl": {
                  group: "Ramps, scales, curves"
                },
                "interpolate-lab": {
                  group: "Ramps, scales, curves"
                },
                ln2: {
                  group: "Math"
                },
                pi: {
                  group: "Math"
                },
                e: {
                  group: "Math"
                },
                typeof: {
                  group: "Types"
                },
                string: {
                  group: "Types"
                },
                number: {
                  group: "Types"
                },
                boolean: {
                  group: "Types"
                },
                object: {
                  group: "Types"
                },
                collator: {
                  group: "Types"
                },
                format: {
                  group: "Types"
                },
                image: {
                  group: "Types"
                },
                "number-format": {
                  group: "Types"
                },
                "to-string": {
                  group: "Types"
                },
                "to-number": {
                  group: "Types"
                },
                "to-boolean": {
                  group: "Types"
                },
                "to-rgba": {
                  group: "Color"
                },
                "to-color": {
                  group: "Types"
                },
                rgb: {
                  group: "Color"
                },
                rgba: {
                  group: "Color"
                },
                get: {
                  group: "Lookup"
                },
                has: {
                  group: "Lookup"
                },
                length: {
                  group: "Lookup"
                },
                properties: {
                  group: "Feature data"
                },
                "feature-state": {
                  group: "Feature data"
                },
                "geometry-type": {
                  group: "Feature data"
                },
                id: {
                  group: "Feature data"
                },
                zoom: {
                  group: "Zoom"
                },
                "heatmap-density": {
                  group: "Heatmap"
                },
                "line-progress": {
                  group: "Feature data"
                },
                accumulated: {
                  group: "Feature data"
                },
                "+": {
                  group: "Math"
                },
                "*": {
                  group: "Math"
                },
                "-": {
                  group: "Math"
                },
                "/": {
                  group: "Math"
                },
                "%": {
                  group: "Math"
                },
                "^": {
                  group: "Math"
                },
                sqrt: {
                  group: "Math"
                },
                log10: {
                  group: "Math"
                },
                ln: {
                  group: "Math"
                },
                log2: {
                  group: "Math"
                },
                sin: {
                  group: "Math"
                },
                cos: {
                  group: "Math"
                },
                tan: {
                  group: "Math"
                },
                asin: {
                  group: "Math"
                },
                acos: {
                  group: "Math"
                },
                atan: {
                  group: "Math"
                },
                min: {
                  group: "Math"
                },
                max: {
                  group: "Math"
                },
                round: {
                  group: "Math"
                },
                abs: {
                  group: "Math"
                },
                ceil: {
                  group: "Math"
                },
                floor: {
                  group: "Math"
                },
                distance: {
                  group: "Math"
                },
                "==": {
                  group: "Decision"
                },
                "!=": {
                  group: "Decision"
                },
                ">": {
                  group: "Decision"
                },
                "<": {
                  group: "Decision"
                },
                ">=": {
                  group: "Decision"
                },
                "<=": {
                  group: "Decision"
                },
                all: {
                  group: "Decision"
                },
                any: {
                  group: "Decision"
                },
                "!": {
                  group: "Decision"
                },
                within: {
                  group: "Decision"
                },
                "is-supported-script": {
                  group: "String"
                },
                upcase: {
                  group: "String"
                },
                downcase: {
                  group: "String"
                },
                concat: {
                  group: "String"
                },
                "resolved-locale": {
                  group: "String"
                }
              }
            },
            light: {
              anchor: {
                type: "enum",
                default: "viewport",
                values: {
                  map: {},
                  viewport: {}
                },
                "property-type": "data-constant",
                transition: !1,
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                }
              },
              position: {
                type: "array",
                default: [1.15, 210, 30],
                length: 3,
                value: "number",
                "property-type": "data-constant",
                transition: !0,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                }
              },
              color: {
                type: "color",
                "property-type": "data-constant",
                default: "#ffffff",
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                transition: !0
              },
              intensity: {
                type: "number",
                "property-type": "data-constant",
                default: .5,
                minimum: 0,
                maximum: 1,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                transition: !0
              }
            },
            paint: ["paint_fill", "paint_line", "paint_circle", "paint_heatmap", "paint_fill-extrusion", "paint_symbol", "paint_raster", "paint_hillshade", "paint_background"],
            paint_fill: {
              "fill-antialias": {
                type: "boolean",
                default: !0,
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "fill-opacity": {
                type: "number",
                default: 1,
                minimum: 0,
                maximum: 1,
                transition: !0,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "fill-color": {
                type: "color",
                default: "#000000",
                transition: !0,
                requires: [{
                  "!": "fill-pattern"
                }],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "fill-outline-color": {
                type: "color",
                transition: !0,
                requires: [{
                  "!": "fill-pattern"
                }, {
                  "fill-antialias": !0
                }],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "fill-translate": {
                type: "array",
                value: "number",
                length: 2,
                default: [0, 0],
                transition: !0,
                units: "pixels",
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "fill-translate-anchor": {
                type: "enum",
                values: {
                  map: {},
                  viewport: {}
                },
                default: "map",
                requires: ["fill-translate"],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "fill-pattern": {
                type: "resolvedImage",
                transition: !0,
                expression: {
                  interpolated: !1,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "cross-faded-data-driven"
              }
            },
            "paint_fill-extrusion": {
              "fill-extrusion-opacity": {
                type: "number",
                default: 1,
                minimum: 0,
                maximum: 1,
                transition: !0,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "fill-extrusion-color": {
                type: "color",
                default: "#000000",
                transition: !0,
                requires: [{
                  "!": "fill-extrusion-pattern"
                }],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "fill-extrusion-translate": {
                type: "array",
                value: "number",
                length: 2,
                default: [0, 0],
                transition: !0,
                units: "pixels",
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "fill-extrusion-translate-anchor": {
                type: "enum",
                values: {
                  map: {},
                  viewport: {}
                },
                default: "map",
                requires: ["fill-extrusion-translate"],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "fill-extrusion-pattern": {
                type: "resolvedImage",
                transition: !0,
                expression: {
                  interpolated: !1,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "cross-faded-data-driven"
              },
              "fill-extrusion-height": {
                type: "number",
                default: 0,
                minimum: 0,
                units: "meters",
                transition: !0,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "fill-extrusion-base": {
                type: "number",
                default: 0,
                minimum: 0,
                units: "meters",
                transition: !0,
                requires: ["fill-extrusion-height"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "fill-extrusion-vertical-gradient": {
                type: "boolean",
                default: !0,
                transition: !1,
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              }
            },
            paint_line: {
              "line-opacity": {
                type: "number",
                default: 1,
                minimum: 0,
                maximum: 1,
                transition: !0,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "line-color": {
                type: "color",
                default: "#000000",
                transition: !0,
                requires: [{
                  "!": "line-pattern"
                }],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "line-translate": {
                type: "array",
                value: "number",
                length: 2,
                default: [0, 0],
                transition: !0,
                units: "pixels",
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "line-translate-anchor": {
                type: "enum",
                values: {
                  map: {},
                  viewport: {}
                },
                default: "map",
                requires: ["line-translate"],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "line-width": {
                type: "number",
                default: 1,
                minimum: 0,
                transition: !0,
                units: "pixels",
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "line-gap-width": {
                type: "number",
                default: 0,
                minimum: 0,
                transition: !0,
                units: "pixels",
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "line-offset": {
                type: "number",
                default: 0,
                transition: !0,
                units: "pixels",
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "line-blur": {
                type: "number",
                default: 0,
                minimum: 0,
                transition: !0,
                units: "pixels",
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "line-dasharray": {
                type: "array",
                value: "number",
                minimum: 0,
                transition: !0,
                units: "line widths",
                requires: [{
                  "!": "line-pattern"
                }],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "cross-faded"
              },
              "line-pattern": {
                type: "resolvedImage",
                transition: !0,
                expression: {
                  interpolated: !1,
                  parameters: ["zoom", "feature"]
                },
                "property-type": "cross-faded-data-driven"
              },
              "line-gradient": {
                type: "color",
                transition: !1,
                requires: [{
                  "!": "line-dasharray"
                }, {
                  "!": "line-pattern"
                }, {
                  source: "geojson",
                  has: {
                    lineMetrics: !0
                  }
                }],
                expression: {
                  interpolated: !0,
                  parameters: ["line-progress"]
                },
                "property-type": "color-ramp"
              }
            },
            paint_circle: {
              "circle-radius": {
                type: "number",
                default: 5,
                minimum: 0,
                transition: !0,
                units: "pixels",
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "circle-color": {
                type: "color",
                default: "#000000",
                transition: !0,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "circle-blur": {
                type: "number",
                default: 0,
                transition: !0,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "circle-opacity": {
                type: "number",
                default: 1,
                minimum: 0,
                maximum: 1,
                transition: !0,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "circle-translate": {
                type: "array",
                value: "number",
                length: 2,
                default: [0, 0],
                transition: !0,
                units: "pixels",
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "circle-translate-anchor": {
                type: "enum",
                values: {
                  map: {},
                  viewport: {}
                },
                default: "map",
                requires: ["circle-translate"],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "circle-pitch-scale": {
                type: "enum",
                values: {
                  map: {},
                  viewport: {}
                },
                default: "map",
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "circle-pitch-alignment": {
                type: "enum",
                values: {
                  map: {},
                  viewport: {}
                },
                default: "viewport",
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "circle-stroke-width": {
                type: "number",
                default: 0,
                minimum: 0,
                transition: !0,
                units: "pixels",
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "circle-stroke-color": {
                type: "color",
                default: "#000000",
                transition: !0,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "circle-stroke-opacity": {
                type: "number",
                default: 1,
                minimum: 0,
                maximum: 1,
                transition: !0,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              }
            },
            paint_heatmap: {
              "heatmap-radius": {
                type: "number",
                default: 30,
                minimum: 1,
                transition: !0,
                units: "pixels",
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "heatmap-weight": {
                type: "number",
                default: 1,
                minimum: 0,
                transition: !1,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "heatmap-intensity": {
                type: "number",
                default: 1,
                minimum: 0,
                transition: !0,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "heatmap-color": {
                type: "color",
                default: ["interpolate", ["linear"], ["heatmap-density"], 0, "rgba(0, 0, 255, 0)", .1, "royalblue", .3, "cyan", .5, "lime", .7, "yellow", 1, "red"],
                transition: !1,
                expression: {
                  interpolated: !0,
                  parameters: ["heatmap-density"]
                },
                "property-type": "color-ramp"
              },
              "heatmap-opacity": {
                type: "number",
                default: 1,
                minimum: 0,
                maximum: 1,
                transition: !0,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              }
            },
            paint_symbol: {
              "icon-opacity": {
                type: "number",
                default: 1,
                minimum: 0,
                maximum: 1,
                transition: !0,
                requires: ["icon-image"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "icon-color": {
                type: "color",
                default: "#000000",
                transition: !0,
                requires: ["icon-image"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "icon-halo-color": {
                type: "color",
                default: "rgba(0, 0, 0, 0)",
                transition: !0,
                requires: ["icon-image"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "icon-halo-width": {
                type: "number",
                default: 0,
                minimum: 0,
                transition: !0,
                units: "pixels",
                requires: ["icon-image"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "icon-halo-blur": {
                type: "number",
                default: 0,
                minimum: 0,
                transition: !0,
                units: "pixels",
                requires: ["icon-image"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "icon-translate": {
                type: "array",
                value: "number",
                length: 2,
                default: [0, 0],
                transition: !0,
                units: "pixels",
                requires: ["icon-image"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "icon-translate-anchor": {
                type: "enum",
                values: {
                  map: {},
                  viewport: {}
                },
                default: "map",
                requires: ["icon-image", "icon-translate"],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "text-opacity": {
                type: "number",
                default: 1,
                minimum: 0,
                maximum: 1,
                transition: !0,
                requires: ["text-field"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "text-color": {
                type: "color",
                default: "#000000",
                transition: !0,
                overridable: !0,
                requires: ["text-field"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "text-halo-color": {
                type: "color",
                default: "rgba(0, 0, 0, 0)",
                transition: !0,
                requires: ["text-field"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "text-halo-width": {
                type: "number",
                default: 0,
                minimum: 0,
                transition: !0,
                units: "pixels",
                requires: ["text-field"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "text-halo-blur": {
                type: "number",
                default: 0,
                minimum: 0,
                transition: !0,
                units: "pixels",
                requires: ["text-field"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom", "feature", "feature-state"]
                },
                "property-type": "data-driven"
              },
              "text-translate": {
                type: "array",
                value: "number",
                length: 2,
                default: [0, 0],
                transition: !0,
                units: "pixels",
                requires: ["text-field"],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "text-translate-anchor": {
                type: "enum",
                values: {
                  map: {},
                  viewport: {}
                },
                default: "map",
                requires: ["text-field", "text-translate"],
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              }
            },
            paint_raster: {
              "raster-opacity": {
                type: "number",
                default: 1,
                minimum: 0,
                maximum: 1,
                transition: !0,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "raster-hue-rotate": {
                type: "number",
                default: 0,
                period: 360,
                transition: !0,
                units: "degrees",
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "raster-brightness-min": {
                type: "number",
                default: 0,
                minimum: 0,
                maximum: 1,
                transition: !0,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "raster-brightness-max": {
                type: "number",
                default: 1,
                minimum: 0,
                maximum: 1,
                transition: !0,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "raster-saturation": {
                type: "number",
                default: 0,
                minimum: -1,
                maximum: 1,
                transition: !0,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "raster-contrast": {
                type: "number",
                default: 0,
                minimum: -1,
                maximum: 1,
                transition: !0,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "raster-resampling": {
                type: "enum",
                values: {
                  linear: {},
                  nearest: {}
                },
                default: "linear",
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "raster-fade-duration": {
                type: "number",
                default: 300,
                minimum: 0,
                transition: !1,
                units: "milliseconds",
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              }
            },
            paint_hillshade: {
              "hillshade-illumination-direction": {
                type: "number",
                default: 335,
                minimum: 0,
                maximum: 359,
                transition: !1,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "hillshade-illumination-anchor": {
                type: "enum",
                values: {
                  map: {},
                  viewport: {}
                },
                default: "viewport",
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "hillshade-exaggeration": {
                type: "number",
                default: .5,
                minimum: 0,
                maximum: 1,
                transition: !0,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "hillshade-shadow-color": {
                type: "color",
                default: "#000000",
                transition: !0,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "hillshade-highlight-color": {
                type: "color",
                default: "#FFFFFF",
                transition: !0,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "hillshade-accent-color": {
                type: "color",
                default: "#000000",
                transition: !0,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              }
            },
            paint_background: {
              "background-color": {
                type: "color",
                default: "#000000",
                transition: !0,
                requires: [{
                  "!": "background-pattern"
                }],
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              },
              "background-pattern": {
                type: "resolvedImage",
                transition: !0,
                expression: {
                  interpolated: !1,
                  parameters: ["zoom"]
                },
                "property-type": "cross-faded"
              },
              "background-opacity": {
                type: "number",
                default: 1,
                minimum: 0,
                maximum: 1,
                transition: !0,
                expression: {
                  interpolated: !0,
                  parameters: ["zoom"]
                },
                "property-type": "data-constant"
              }
            },
            transition: {
              duration: {
                type: "number",
                default: 300,
                minimum: 0,
                units: "milliseconds"
              },
              delay: {
                type: "number",
                default: 0,
                minimum: 0,
                units: "milliseconds"
              }
            },
            "property-type": {
              "data-driven": {
                type: "property-type"
              },
              "cross-faded": {
                type: "property-type"
              },
              "cross-faded-data-driven": {
                type: "property-type"
              },
              "color-ramp": {
                type: "property-type"
              },
              "data-constant": {
                type: "property-type"
              },
              constant: {
                type: "property-type"
              }
            },
            promoteId: {
              "*": {
                type: "string"
              }
            }
          },
              Ct = function Ct(t, e, r, n) {
            this.message = (t ? t + ": " : "") + r, n && (this.identifier = n), null != e && e.__line__ && (this.line = e.__line__);
          };

          function Pt(t) {
            var e = t.key,
                r = t.value;
            return r ? [new Ct(e, r, "constants have been deprecated as of v8")] : [];
          }

          function It(t) {
            for (var e = [], r = arguments.length - 1; r-- > 0;) {
              e[r] = arguments[r + 1];
            }

            for (var n = 0, i = e; n < i.length; n += 1) {
              var a = i[n];

              for (var o in a) {
                t[o] = a[o];
              }
            }

            return t;
          }

          function Ot(t) {
            return t instanceof Number || t instanceof String || t instanceof Boolean ? t.valueOf() : t;
          }

          function zt(t) {
            if (Array.isArray(t)) return t.map(zt);

            if (t instanceof Object && !(t instanceof Number || t instanceof String || t instanceof Boolean)) {
              var e = {};

              for (var r in t) {
                e[r] = zt(t[r]);
              }

              return e;
            }

            return Ot(t);
          }

          var Dt = function (t) {
            function e(e, r) {
              t.call(this, r), this.message = r, this.key = e;
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
          }(Error),
              Rt = function Rt(t, e) {
            void 0 === e && (e = []), this.parent = t, this.bindings = {};

            for (var r = 0, n = e; r < n.length; r += 1) {
              var i = n[r],
                  a = i[0],
                  o = i[1];
              this.bindings[a] = o;
            }
          };

          Rt.prototype.concat = function (t) {
            return new Rt(this, t);
          }, Rt.prototype.get = function (t) {
            if (this.bindings[t]) return this.bindings[t];
            if (this.parent) return this.parent.get(t);
            throw new Error(t + " not found in scope.");
          }, Rt.prototype.has = function (t) {
            return !!this.bindings[t] || !!this.parent && this.parent.has(t);
          };
          var Ft = {
            kind: "null"
          },
              Bt = {
            kind: "number"
          },
              Nt = {
            kind: "string"
          },
              jt = {
            kind: "boolean"
          },
              Ut = {
            kind: "color"
          },
              Vt = {
            kind: "object"
          },
              qt = {
            kind: "value"
          },
              Ht = {
            kind: "collator"
          },
              Gt = {
            kind: "formatted"
          },
              Yt = {
            kind: "resolvedImage"
          };

          function Wt(t, e) {
            return {
              kind: "array",
              itemType: t,
              N: e
            };
          }

          function Xt(t) {
            if ("array" === t.kind) {
              var e = Xt(t.itemType);
              return "number" == typeof t.N ? "array<" + e + ", " + t.N + ">" : "value" === t.itemType.kind ? "array" : "array<" + e + ">";
            }

            return t.kind;
          }

          var Zt = [Ft, Bt, Nt, jt, Ut, Gt, Vt, Wt(qt), Yt];

          function Jt(t, e) {
            if ("error" === e.kind) return null;

            if ("array" === t.kind) {
              if ("array" === e.kind && (0 === e.N && "value" === e.itemType.kind || !Jt(t.itemType, e.itemType)) && ("number" != typeof t.N || t.N === e.N)) return null;
            } else {
              if (t.kind === e.kind) return null;
              if ("value" === t.kind) for (var r = 0, n = Zt; r < n.length; r += 1) {
                if (!Jt(n[r], e)) return null;
              }
            }

            return "Expected " + Xt(t) + " but found " + Xt(e) + " instead.";
          }

          function Kt(t, e) {
            return e.some(function (e) {
              return e.kind === t.kind;
            });
          }

          function Qt(t, e) {
            return e.some(function (e) {
              return "null" === e ? null === t : "array" === e ? Array.isArray(t) : "object" === e ? t && !Array.isArray(t) && "object" == _typeof(t) : e === _typeof(t);
            });
          }

          var $t = e(function (t, e) {
            var r = {
              transparent: [0, 0, 0, 0],
              aliceblue: [240, 248, 255, 1],
              antiquewhite: [250, 235, 215, 1],
              aqua: [0, 255, 255, 1],
              aquamarine: [127, 255, 212, 1],
              azure: [240, 255, 255, 1],
              beige: [245, 245, 220, 1],
              bisque: [255, 228, 196, 1],
              black: [0, 0, 0, 1],
              blanchedalmond: [255, 235, 205, 1],
              blue: [0, 0, 255, 1],
              blueviolet: [138, 43, 226, 1],
              brown: [165, 42, 42, 1],
              burlywood: [222, 184, 135, 1],
              cadetblue: [95, 158, 160, 1],
              chartreuse: [127, 255, 0, 1],
              chocolate: [210, 105, 30, 1],
              coral: [255, 127, 80, 1],
              cornflowerblue: [100, 149, 237, 1],
              cornsilk: [255, 248, 220, 1],
              crimson: [220, 20, 60, 1],
              cyan: [0, 255, 255, 1],
              darkblue: [0, 0, 139, 1],
              darkcyan: [0, 139, 139, 1],
              darkgoldenrod: [184, 134, 11, 1],
              darkgray: [169, 169, 169, 1],
              darkgreen: [0, 100, 0, 1],
              darkgrey: [169, 169, 169, 1],
              darkkhaki: [189, 183, 107, 1],
              darkmagenta: [139, 0, 139, 1],
              darkolivegreen: [85, 107, 47, 1],
              darkorange: [255, 140, 0, 1],
              darkorchid: [153, 50, 204, 1],
              darkred: [139, 0, 0, 1],
              darksalmon: [233, 150, 122, 1],
              darkseagreen: [143, 188, 143, 1],
              darkslateblue: [72, 61, 139, 1],
              darkslategray: [47, 79, 79, 1],
              darkslategrey: [47, 79, 79, 1],
              darkturquoise: [0, 206, 209, 1],
              darkviolet: [148, 0, 211, 1],
              deeppink: [255, 20, 147, 1],
              deepskyblue: [0, 191, 255, 1],
              dimgray: [105, 105, 105, 1],
              dimgrey: [105, 105, 105, 1],
              dodgerblue: [30, 144, 255, 1],
              firebrick: [178, 34, 34, 1],
              floralwhite: [255, 250, 240, 1],
              forestgreen: [34, 139, 34, 1],
              fuchsia: [255, 0, 255, 1],
              gainsboro: [220, 220, 220, 1],
              ghostwhite: [248, 248, 255, 1],
              gold: [255, 215, 0, 1],
              goldenrod: [218, 165, 32, 1],
              gray: [128, 128, 128, 1],
              green: [0, 128, 0, 1],
              greenyellow: [173, 255, 47, 1],
              grey: [128, 128, 128, 1],
              honeydew: [240, 255, 240, 1],
              hotpink: [255, 105, 180, 1],
              indianred: [205, 92, 92, 1],
              indigo: [75, 0, 130, 1],
              ivory: [255, 255, 240, 1],
              khaki: [240, 230, 140, 1],
              lavender: [230, 230, 250, 1],
              lavenderblush: [255, 240, 245, 1],
              lawngreen: [124, 252, 0, 1],
              lemonchiffon: [255, 250, 205, 1],
              lightblue: [173, 216, 230, 1],
              lightcoral: [240, 128, 128, 1],
              lightcyan: [224, 255, 255, 1],
              lightgoldenrodyellow: [250, 250, 210, 1],
              lightgray: [211, 211, 211, 1],
              lightgreen: [144, 238, 144, 1],
              lightgrey: [211, 211, 211, 1],
              lightpink: [255, 182, 193, 1],
              lightsalmon: [255, 160, 122, 1],
              lightseagreen: [32, 178, 170, 1],
              lightskyblue: [135, 206, 250, 1],
              lightslategray: [119, 136, 153, 1],
              lightslategrey: [119, 136, 153, 1],
              lightsteelblue: [176, 196, 222, 1],
              lightyellow: [255, 255, 224, 1],
              lime: [0, 255, 0, 1],
              limegreen: [50, 205, 50, 1],
              linen: [250, 240, 230, 1],
              magenta: [255, 0, 255, 1],
              maroon: [128, 0, 0, 1],
              mediumaquamarine: [102, 205, 170, 1],
              mediumblue: [0, 0, 205, 1],
              mediumorchid: [186, 85, 211, 1],
              mediumpurple: [147, 112, 219, 1],
              mediumseagreen: [60, 179, 113, 1],
              mediumslateblue: [123, 104, 238, 1],
              mediumspringgreen: [0, 250, 154, 1],
              mediumturquoise: [72, 209, 204, 1],
              mediumvioletred: [199, 21, 133, 1],
              midnightblue: [25, 25, 112, 1],
              mintcream: [245, 255, 250, 1],
              mistyrose: [255, 228, 225, 1],
              moccasin: [255, 228, 181, 1],
              navajowhite: [255, 222, 173, 1],
              navy: [0, 0, 128, 1],
              oldlace: [253, 245, 230, 1],
              olive: [128, 128, 0, 1],
              olivedrab: [107, 142, 35, 1],
              orange: [255, 165, 0, 1],
              orangered: [255, 69, 0, 1],
              orchid: [218, 112, 214, 1],
              palegoldenrod: [238, 232, 170, 1],
              palegreen: [152, 251, 152, 1],
              paleturquoise: [175, 238, 238, 1],
              palevioletred: [219, 112, 147, 1],
              papayawhip: [255, 239, 213, 1],
              peachpuff: [255, 218, 185, 1],
              peru: [205, 133, 63, 1],
              pink: [255, 192, 203, 1],
              plum: [221, 160, 221, 1],
              powderblue: [176, 224, 230, 1],
              purple: [128, 0, 128, 1],
              rebeccapurple: [102, 51, 153, 1],
              red: [255, 0, 0, 1],
              rosybrown: [188, 143, 143, 1],
              royalblue: [65, 105, 225, 1],
              saddlebrown: [139, 69, 19, 1],
              salmon: [250, 128, 114, 1],
              sandybrown: [244, 164, 96, 1],
              seagreen: [46, 139, 87, 1],
              seashell: [255, 245, 238, 1],
              sienna: [160, 82, 45, 1],
              silver: [192, 192, 192, 1],
              skyblue: [135, 206, 235, 1],
              slateblue: [106, 90, 205, 1],
              slategray: [112, 128, 144, 1],
              slategrey: [112, 128, 144, 1],
              snow: [255, 250, 250, 1],
              springgreen: [0, 255, 127, 1],
              steelblue: [70, 130, 180, 1],
              tan: [210, 180, 140, 1],
              teal: [0, 128, 128, 1],
              thistle: [216, 191, 216, 1],
              tomato: [255, 99, 71, 1],
              turquoise: [64, 224, 208, 1],
              violet: [238, 130, 238, 1],
              wheat: [245, 222, 179, 1],
              white: [255, 255, 255, 1],
              whitesmoke: [245, 245, 245, 1],
              yellow: [255, 255, 0, 1],
              yellowgreen: [154, 205, 50, 1]
            };

            function n(t) {
              return (t = Math.round(t)) < 0 ? 0 : t > 255 ? 255 : t;
            }

            function i(t) {
              return t < 0 ? 0 : t > 1 ? 1 : t;
            }

            function a(t) {
              return "%" === t[t.length - 1] ? n(parseFloat(t) / 100 * 255) : n(parseInt(t));
            }

            function o(t) {
              return "%" === t[t.length - 1] ? i(parseFloat(t) / 100) : i(parseFloat(t));
            }

            function s(t, e, r) {
              return r < 0 ? r += 1 : r > 1 && (r -= 1), 6 * r < 1 ? t + (e - t) * r * 6 : 2 * r < 1 ? e : 3 * r < 2 ? t + (e - t) * (2 / 3 - r) * 6 : t;
            }

            try {
              e.parseCSSColor = function (t) {
                var e,
                    i = t.replace(/ /g, "").toLowerCase();
                if (i in r) return r[i].slice();
                if ("#" === i[0]) return 4 === i.length ? (e = parseInt(i.substr(1), 16)) >= 0 && e <= 4095 ? [(3840 & e) >> 4 | (3840 & e) >> 8, 240 & e | (240 & e) >> 4, 15 & e | (15 & e) << 4, 1] : null : 7 === i.length && (e = parseInt(i.substr(1), 16)) >= 0 && e <= 16777215 ? [(16711680 & e) >> 16, (65280 & e) >> 8, 255 & e, 1] : null;
                var l = i.indexOf("("),
                    c = i.indexOf(")");

                if (-1 !== l && c + 1 === i.length) {
                  var u = i.substr(0, l),
                      f = i.substr(l + 1, c - (l + 1)).split(","),
                      h = 1;

                  switch (u) {
                    case "rgba":
                      if (4 !== f.length) return null;
                      h = o(f.pop());

                    case "rgb":
                      return 3 !== f.length ? null : [a(f[0]), a(f[1]), a(f[2]), h];

                    case "hsla":
                      if (4 !== f.length) return null;
                      h = o(f.pop());

                    case "hsl":
                      if (3 !== f.length) return null;
                      var p = (parseFloat(f[0]) % 360 + 360) % 360 / 360,
                          d = o(f[1]),
                          m = o(f[2]),
                          g = m <= .5 ? m * (d + 1) : m + d - m * d,
                          v = 2 * m - g;
                      return [n(255 * s(v, g, p + 1 / 3)), n(255 * s(v, g, p)), n(255 * s(v, g, p - 1 / 3)), h];

                    default:
                      return null;
                  }
                }

                return null;
              };
            } catch (t) {}
          }).parseCSSColor,
              te = function te(t, e, r, n) {
            void 0 === n && (n = 1), this.r = t, this.g = e, this.b = r, this.a = n;
          };

          te.parse = function (t) {
            if (t) {
              if (t instanceof te) return t;

              if ("string" == typeof t) {
                var e = $t(t);
                if (e) return new te(e[0] / 255 * e[3], e[1] / 255 * e[3], e[2] / 255 * e[3], e[3]);
              }
            }
          }, te.prototype.toString = function () {
            var t = this.toArray(),
                e = t[0],
                r = t[1],
                n = t[2],
                i = t[3];
            return "rgba(" + Math.round(e) + "," + Math.round(r) + "," + Math.round(n) + "," + i + ")";
          }, te.prototype.toArray = function () {
            var t = this.r,
                e = this.g,
                r = this.b,
                n = this.a;
            return 0 === n ? [0, 0, 0, 0] : [255 * t / n, 255 * e / n, 255 * r / n, n];
          }, te.black = new te(0, 0, 0, 1), te.white = new te(1, 1, 1, 1), te.transparent = new te(0, 0, 0, 0), te.red = new te(1, 0, 0, 1);

          var ee = function ee(t, e, r) {
            this.sensitivity = t ? e ? "variant" : "case" : e ? "accent" : "base", this.locale = r, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
              sensitivity: this.sensitivity,
              usage: "search"
            });
          };

          ee.prototype.compare = function (t, e) {
            return this.collator.compare(t, e);
          }, ee.prototype.resolvedLocale = function () {
            return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
          };

          var re = function re(t, e, r, n, i) {
            this.text = t, this.image = e, this.scale = r, this.fontStack = n, this.textColor = i;
          },
              ne = function ne(t) {
            this.sections = t;
          };

          ne.fromString = function (t) {
            return new ne([new re(t, null, null, null, null)]);
          }, ne.prototype.isEmpty = function () {
            return 0 === this.sections.length || !this.sections.some(function (t) {
              return 0 !== t.text.length || t.image && 0 !== t.image.name.length;
            });
          }, ne.factory = function (t) {
            return t instanceof ne ? t : ne.fromString(t);
          }, ne.prototype.toString = function () {
            return 0 === this.sections.length ? "" : this.sections.map(function (t) {
              return t.text;
            }).join("");
          }, ne.prototype.serialize = function () {
            for (var t = ["format"], e = 0, r = this.sections; e < r.length; e += 1) {
              var n = r[e];
              if (n.image) t.push(["image", n.image.name]);else {
                t.push(n.text);
                var i = {};
                n.fontStack && (i["text-font"] = ["literal", n.fontStack.split(",")]), n.scale && (i["font-scale"] = n.scale), n.textColor && (i["text-color"] = ["rgba"].concat(n.textColor.toArray())), t.push(i);
              }
            }

            return t;
          };

          var ie = function ie(t) {
            this.name = t.name, this.available = t.available;
          };

          function ae(t, e, r, n) {
            return "number" == typeof t && t >= 0 && t <= 255 && "number" == typeof e && e >= 0 && e <= 255 && "number" == typeof r && r >= 0 && r <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : "Invalid rgba value [" + [t, e, r, n].join(", ") + "]: 'a' must be between 0 and 1." : "Invalid rgba value [" + ("number" == typeof n ? [t, e, r, n] : [t, e, r]).join(", ") + "]: 'r', 'g', and 'b' must be between 0 and 255.";
          }

          function oe(t) {
            if (null === t) return !0;
            if ("string" == typeof t) return !0;
            if ("boolean" == typeof t) return !0;
            if ("number" == typeof t) return !0;
            if (t instanceof te) return !0;
            if (t instanceof ee) return !0;
            if (t instanceof ne) return !0;
            if (t instanceof ie) return !0;

            if (Array.isArray(t)) {
              for (var e = 0, r = t; e < r.length; e += 1) {
                if (!oe(r[e])) return !1;
              }

              return !0;
            }

            if ("object" == _typeof(t)) {
              for (var n in t) {
                if (!oe(t[n])) return !1;
              }

              return !0;
            }

            return !1;
          }

          function se(t) {
            if (null === t) return Ft;
            if ("string" == typeof t) return Nt;
            if ("boolean" == typeof t) return jt;
            if ("number" == typeof t) return Bt;
            if (t instanceof te) return Ut;
            if (t instanceof ee) return Ht;
            if (t instanceof ne) return Gt;
            if (t instanceof ie) return Yt;

            if (Array.isArray(t)) {
              for (var e, r = t.length, n = 0, i = t; n < i.length; n += 1) {
                var a = se(i[n]);

                if (e) {
                  if (e === a) continue;
                  e = qt;
                  break;
                }

                e = a;
              }

              return Wt(e || qt, r);
            }

            return Vt;
          }

          function le(t) {
            var e = _typeof(t);

            return null === t ? "" : "string" === e || "number" === e || "boolean" === e ? String(t) : t instanceof te || t instanceof ne || t instanceof ie ? t.toString() : JSON.stringify(t);
          }

          ie.prototype.toString = function () {
            return this.name;
          }, ie.fromString = function (t) {
            return t ? new ie({
              name: t,
              available: !1
            }) : null;
          }, ie.prototype.serialize = function () {
            return ["image", this.name];
          };

          var ce = function ce(t, e) {
            this.type = t, this.value = e;
          };

          ce.parse = function (t, e) {
            if (2 !== t.length) return e.error("'literal' expression requires exactly one argument, but found " + (t.length - 1) + " instead.");
            if (!oe(t[1])) return e.error("invalid value");
            var r = t[1],
                n = se(r),
                i = e.expectedType;
            return "array" !== n.kind || 0 !== n.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (n = i), new ce(n, r);
          }, ce.prototype.evaluate = function () {
            return this.value;
          }, ce.prototype.eachChild = function () {}, ce.prototype.outputDefined = function () {
            return !0;
          }, ce.prototype.serialize = function () {
            return "array" === this.type.kind || "object" === this.type.kind ? ["literal", this.value] : this.value instanceof te ? ["rgba"].concat(this.value.toArray()) : this.value instanceof ne ? this.value.serialize() : this.value;
          };

          var ue = function ue(t) {
            this.name = "ExpressionEvaluationError", this.message = t;
          };

          ue.prototype.toJSON = function () {
            return this.message;
          };

          var fe = {
            string: Nt,
            number: Bt,
            boolean: jt,
            object: Vt
          },
              he = function he(t, e) {
            this.type = t, this.args = e;
          };

          he.parse = function (t, e) {
            if (t.length < 2) return e.error("Expected at least one argument.");
            var r,
                n = 1,
                i = t[0];

            if ("array" === i) {
              var a, o;

              if (t.length > 2) {
                var s = t[1];
                if ("string" != typeof s || !(s in fe) || "object" === s) return e.error('The item type argument of "array" must be one of string, number, boolean', 1);
                a = fe[s], n++;
              } else a = qt;

              if (t.length > 3) {
                if (null !== t[2] && ("number" != typeof t[2] || t[2] < 0 || t[2] !== Math.floor(t[2]))) return e.error('The length argument to "array" must be a positive integer literal', 2);
                o = t[2], n++;
              }

              r = Wt(a, o);
            } else r = fe[i];

            for (var l = []; n < t.length; n++) {
              var c = e.parse(t[n], n, qt);
              if (!c) return null;
              l.push(c);
            }

            return new he(r, l);
          }, he.prototype.evaluate = function (t) {
            for (var e = 0; e < this.args.length; e++) {
              var r = this.args[e].evaluate(t);
              if (!Jt(this.type, se(r))) return r;
              if (e === this.args.length - 1) throw new ue("Expected value to be of type " + Xt(this.type) + ", but found " + Xt(se(r)) + " instead.");
            }

            return null;
          }, he.prototype.eachChild = function (t) {
            this.args.forEach(t);
          }, he.prototype.outputDefined = function () {
            return this.args.every(function (t) {
              return t.outputDefined();
            });
          }, he.prototype.serialize = function () {
            var t = this.type,
                e = [t.kind];

            if ("array" === t.kind) {
              var r = t.itemType;

              if ("string" === r.kind || "number" === r.kind || "boolean" === r.kind) {
                e.push(r.kind);
                var n = t.N;
                ("number" == typeof n || this.args.length > 1) && e.push(n);
              }
            }

            return e.concat(this.args.map(function (t) {
              return t.serialize();
            }));
          };

          var pe = function pe(t) {
            this.type = Gt, this.sections = t;
          };

          pe.parse = function (t, e) {
            if (t.length < 2) return e.error("Expected at least one argument.");
            var r = t[1];
            if (!Array.isArray(r) && "object" == _typeof(r)) return e.error("First argument must be an image or text section.");

            for (var n = [], i = !1, a = 1; a <= t.length - 1; ++a) {
              var o = t[a];

              if (i && "object" == _typeof(o) && !Array.isArray(o)) {
                i = !1;
                var s = null;
                if (o["font-scale"] && !(s = e.parse(o["font-scale"], 1, Bt))) return null;
                var l = null;
                if (o["text-font"] && !(l = e.parse(o["text-font"], 1, Wt(Nt)))) return null;
                var c = null;
                if (o["text-color"] && !(c = e.parse(o["text-color"], 1, Ut))) return null;
                var u = n[n.length - 1];
                u.scale = s, u.font = l, u.textColor = c;
              } else {
                var f = e.parse(t[a], 1, qt);
                if (!f) return null;
                var h = f.type.kind;
                if ("string" !== h && "value" !== h && "null" !== h && "resolvedImage" !== h) return e.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                i = !0, n.push({
                  content: f,
                  scale: null,
                  font: null,
                  textColor: null
                });
              }
            }

            return new pe(n);
          }, pe.prototype.evaluate = function (t) {
            return new ne(this.sections.map(function (e) {
              var r = e.content.evaluate(t);
              return se(r) === Yt ? new re("", r, null, null, null) : new re(le(r), null, e.scale ? e.scale.evaluate(t) : null, e.font ? e.font.evaluate(t).join(",") : null, e.textColor ? e.textColor.evaluate(t) : null);
            }));
          }, pe.prototype.eachChild = function (t) {
            for (var e = 0, r = this.sections; e < r.length; e += 1) {
              var n = r[e];
              t(n.content), n.scale && t(n.scale), n.font && t(n.font), n.textColor && t(n.textColor);
            }
          }, pe.prototype.outputDefined = function () {
            return !1;
          }, pe.prototype.serialize = function () {
            for (var t = ["format"], e = 0, r = this.sections; e < r.length; e += 1) {
              var n = r[e];
              t.push(n.content.serialize());
              var i = {};
              n.scale && (i["font-scale"] = n.scale.serialize()), n.font && (i["text-font"] = n.font.serialize()), n.textColor && (i["text-color"] = n.textColor.serialize()), t.push(i);
            }

            return t;
          };

          var de = function de(t) {
            this.type = Yt, this.input = t;
          };

          de.parse = function (t, e) {
            if (2 !== t.length) return e.error("Expected two arguments.");
            var r = e.parse(t[1], 1, Nt);
            return r ? new de(r) : e.error("No image name provided.");
          }, de.prototype.evaluate = function (t) {
            var e = this.input.evaluate(t),
                r = ie.fromString(e);
            return r && t.availableImages && (r.available = t.availableImages.indexOf(e) > -1), r;
          }, de.prototype.eachChild = function (t) {
            t(this.input);
          }, de.prototype.outputDefined = function () {
            return !1;
          }, de.prototype.serialize = function () {
            return ["image", this.input.serialize()];
          };

          var me = {
            "to-boolean": jt,
            "to-color": Ut,
            "to-number": Bt,
            "to-string": Nt
          },
              ge = function ge(t, e) {
            this.type = t, this.args = e;
          };

          ge.parse = function (t, e) {
            if (t.length < 2) return e.error("Expected at least one argument.");
            var r = t[0];
            if (("to-boolean" === r || "to-string" === r) && 2 !== t.length) return e.error("Expected one argument.");

            for (var n = me[r], i = [], a = 1; a < t.length; a++) {
              var o = e.parse(t[a], a, qt);
              if (!o) return null;
              i.push(o);
            }

            return new ge(n, i);
          }, ge.prototype.evaluate = function (t) {
            if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(t));

            if ("color" === this.type.kind) {
              for (var e, r, n = 0, i = this.args; n < i.length; n += 1) {
                if (r = null, (e = i[n].evaluate(t)) instanceof te) return e;

                if ("string" == typeof e) {
                  var a = t.parseColor(e);
                  if (a) return a;
                } else if (Array.isArray(e) && !(r = e.length < 3 || e.length > 4 ? "Invalid rbga value " + JSON.stringify(e) + ": expected an array containing either three or four numeric values." : ae(e[0], e[1], e[2], e[3]))) return new te(e[0] / 255, e[1] / 255, e[2] / 255, e[3]);
              }

              throw new ue(r || "Could not parse color from value '" + ("string" == typeof e ? e : String(JSON.stringify(e))) + "'");
            }

            if ("number" === this.type.kind) {
              for (var o = null, s = 0, l = this.args; s < l.length; s += 1) {
                if (null === (o = l[s].evaluate(t))) return 0;
                var c = Number(o);
                if (!isNaN(c)) return c;
              }

              throw new ue("Could not convert " + JSON.stringify(o) + " to number.");
            }

            return "formatted" === this.type.kind ? ne.fromString(le(this.args[0].evaluate(t))) : "resolvedImage" === this.type.kind ? ie.fromString(le(this.args[0].evaluate(t))) : le(this.args[0].evaluate(t));
          }, ge.prototype.eachChild = function (t) {
            this.args.forEach(t);
          }, ge.prototype.outputDefined = function () {
            return this.args.every(function (t) {
              return t.outputDefined();
            });
          }, ge.prototype.serialize = function () {
            if ("formatted" === this.type.kind) return new pe([{
              content: this.args[0],
              scale: null,
              font: null,
              textColor: null
            }]).serialize();
            if ("resolvedImage" === this.type.kind) return new de(this.args[0]).serialize();
            var t = ["to-" + this.type.kind];
            return this.eachChild(function (e) {
              t.push(e.serialize());
            }), t;
          };

          var ve = ["Unknown", "Point", "LineString", "Polygon"],
              ye = function ye() {
            this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null;
          };

          ye.prototype.id = function () {
            return this.feature && "id" in this.feature ? this.feature.id : null;
          }, ye.prototype.geometryType = function () {
            return this.feature ? "number" == typeof this.feature.type ? ve[this.feature.type] : this.feature.type : null;
          }, ye.prototype.geometry = function () {
            return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
          }, ye.prototype.canonicalID = function () {
            return this.canonical;
          }, ye.prototype.properties = function () {
            return this.feature && this.feature.properties || {};
          }, ye.prototype.parseColor = function (t) {
            var e = this._parseColorCache[t];
            return e || (e = this._parseColorCache[t] = te.parse(t)), e;
          };

          var xe = function xe(t, e, r, n) {
            this.name = t, this.type = e, this._evaluate = r, this.args = n;
          };

          xe.prototype.evaluate = function (t) {
            return this._evaluate(t, this.args);
          }, xe.prototype.eachChild = function (t) {
            this.args.forEach(t);
          }, xe.prototype.outputDefined = function () {
            return !1;
          }, xe.prototype.serialize = function () {
            return [this.name].concat(this.args.map(function (t) {
              return t.serialize();
            }));
          }, xe.parse = function (t, e) {
            var r,
                n = t[0],
                i = xe.definitions[n];
            if (!i) return e.error('Unknown expression "' + n + '". If you wanted a literal array, use ["literal", [...]].', 0);

            for (var a = Array.isArray(i) ? i[0] : i.type, o = Array.isArray(i) ? [[i[1], i[2]]] : i.overloads, s = o.filter(function (e) {
              var r = e[0];
              return !Array.isArray(r) || r.length === t.length - 1;
            }), l = null, c = 0, u = s; c < u.length; c += 1) {
              var f = u[c],
                  h = f[0],
                  p = f[1];
              l = new Ue(e.registry, e.path, null, e.scope);

              for (var d = [], m = !1, g = 1; g < t.length; g++) {
                var v = t[g],
                    y = Array.isArray(h) ? h[g - 1] : h.type,
                    x = l.parse(v, 1 + d.length, y);

                if (!x) {
                  m = !0;
                  break;
                }

                d.push(x);
              }

              if (!m) if (Array.isArray(h) && h.length !== d.length) l.error("Expected " + h.length + " arguments, but found " + d.length + " instead.");else {
                for (var b = 0; b < d.length; b++) {
                  var _ = Array.isArray(h) ? h[b] : h.type,
                      w = d[b];

                  l.concat(b + 1).checkSubtype(_, w.type);
                }

                if (0 === l.errors.length) return new xe(n, a, p, d);
              }
            }

            if (1 === s.length) (r = e.errors).push.apply(r, l.errors);else {
              for (var T = (s.length ? s : o).map(function (t) {
                var e,
                    r = t[0];
                return e = r, Array.isArray(e) ? "(" + e.map(Xt).join(", ") + ")" : "(" + Xt(e.type) + "...)";
              }).join(" | "), k = [], M = 1; M < t.length; M++) {
                var A = e.parse(t[M], 1 + k.length);
                if (!A) return null;
                k.push(Xt(A.type));
              }

              e.error("Expected arguments of type " + T + ", but found (" + k.join(", ") + ") instead.");
            }
            return null;
          }, xe.register = function (t, e) {
            for (var r in xe.definitions = e, e) {
              t[r] = xe;
            }
          };

          var be = function be(t, e, r) {
            this.type = Ht, this.locale = r, this.caseSensitive = t, this.diacriticSensitive = e;
          };

          be.parse = function (t, e) {
            if (2 !== t.length) return e.error("Expected one argument.");
            var r = t[1];
            if ("object" != _typeof(r) || Array.isArray(r)) return e.error("Collator options argument must be an object.");
            var n = e.parse(void 0 !== r["case-sensitive"] && r["case-sensitive"], 1, jt);
            if (!n) return null;
            var i = e.parse(void 0 !== r["diacritic-sensitive"] && r["diacritic-sensitive"], 1, jt);
            if (!i) return null;
            var a = null;
            return r.locale && !(a = e.parse(r.locale, 1, Nt)) ? null : new be(n, i, a);
          }, be.prototype.evaluate = function (t) {
            return new ee(this.caseSensitive.evaluate(t), this.diacriticSensitive.evaluate(t), this.locale ? this.locale.evaluate(t) : null);
          }, be.prototype.eachChild = function (t) {
            t(this.caseSensitive), t(this.diacriticSensitive), this.locale && t(this.locale);
          }, be.prototype.outputDefined = function () {
            return !1;
          }, be.prototype.serialize = function () {
            var t = {};
            return t["case-sensitive"] = this.caseSensitive.serialize(), t["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (t.locale = this.locale.serialize()), ["collator", t];
          };

          function _e(t, e) {
            t[0] = Math.min(t[0], e[0]), t[1] = Math.min(t[1], e[1]), t[2] = Math.max(t[2], e[0]), t[3] = Math.max(t[3], e[1]);
          }

          function we(t, e) {
            return !(t[0] <= e[0]) && !(t[2] >= e[2]) && !(t[1] <= e[1]) && !(t[3] >= e[3]);
          }

          function Te(t, e) {
            var r,
                n = (180 + t[0]) / 360,
                i = (r = t[1], (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + r * Math.PI / 360))) / 360),
                a = Math.pow(2, e.z);
            return [Math.round(n * a * 8192), Math.round(i * a * 8192)];
          }

          function ke(t, e, r) {
            return e[1] > t[1] != r[1] > t[1] && t[0] < (r[0] - e[0]) * (t[1] - e[1]) / (r[1] - e[1]) + e[0];
          }

          function Me(t, e) {
            for (var r, n, i, a, o, s, l, c = !1, u = 0, f = e.length; u < f; u++) {
              for (var h = e[u], p = 0, d = h.length; p < d - 1; p++) {
                if (r = t, n = h[p], i = h[p + 1], a = void 0, o = void 0, s = void 0, l = void 0, a = r[0] - n[0], o = r[1] - n[1], s = r[0] - i[0], l = r[1] - i[1], a * l - s * o == 0 && a * s <= 0 && o * l <= 0) return !1;
                ke(t, h[p], h[p + 1]) && (c = !c);
              }
            }

            return c;
          }

          function Ae(t, e) {
            for (var r = 0; r < e.length; r++) {
              if (Me(t, e[r])) return !0;
            }

            return !1;
          }

          function Se(t, e, r, n) {
            var i = t[0] - r[0],
                a = t[1] - r[1],
                o = e[0] - r[0],
                s = e[1] - r[1],
                l = n[0] - r[0],
                c = n[1] - r[1],
                u = i * c - l * a,
                f = o * c - l * s;
            return u > 0 && f < 0 || u < 0 && f > 0;
          }

          function Ee(t, e, r) {
            for (var n = 0, i = r; n < i.length; n += 1) {
              for (var a = i[n], o = 0; o < a.length - 1; ++o) {
                if (s = t, l = e, c = a[o], u = a[o + 1], f = void 0, h = void 0, p = void 0, d = void 0, p = [l[0] - s[0], l[1] - s[1]], d = [u[0] - c[0], u[1] - c[1]], 0 != (f = d)[0] * (h = p)[1] - f[1] * h[0] && Se(s, l, c, u) && Se(c, u, s, l)) return !0;
              }
            }

            var s, l, c, u, f, h, p, d;
            return !1;
          }

          function Le(t, e) {
            for (var r = 0; r < t.length; ++r) {
              if (!Me(t[r], e)) return !1;
            }

            for (var n = 0; n < t.length - 1; ++n) {
              if (Ee(t[n], t[n + 1], e)) return !1;
            }

            return !0;
          }

          function Ce(t, e) {
            for (var r = 0; r < e.length; r++) {
              if (Le(t, e[r])) return !0;
            }

            return !1;
          }

          function Pe(t, e, r) {
            for (var n = [], i = 0; i < t.length; i++) {
              for (var a = [], o = 0; o < t[i].length; o++) {
                var s = Te(t[i][o], r);
                _e(e, s), a.push(s);
              }

              n.push(a);
            }

            return n;
          }

          function Ie(t, e, r) {
            for (var n = [], i = 0; i < t.length; i++) {
              var a = Pe(t[i], e, r);
              n.push(a);
            }

            return n;
          }

          function Oe(t, e, r, n) {
            if (t[0] < r[0] || t[0] > r[2]) {
              var i = .5 * n,
                  a = t[0] - r[0] > i ? -n : r[0] - t[0] > i ? n : 0;
              0 === a && (a = t[0] - r[2] > i ? -n : r[2] - t[0] > i ? n : 0), t[0] += a;
            }

            _e(e, t);
          }

          function ze(t, e, r, n) {
            for (var i = 8192 * Math.pow(2, n.z), a = [8192 * n.x, 8192 * n.y], o = [], s = 0, l = t; s < l.length; s += 1) {
              for (var c = 0, u = l[s]; c < u.length; c += 1) {
                var f = u[c],
                    h = [f.x + a[0], f.y + a[1]];
                Oe(h, e, r, i), o.push(h);
              }
            }

            return o;
          }

          function De(t, e, r, n) {
            for (var i, a = 8192 * Math.pow(2, n.z), o = [8192 * n.x, 8192 * n.y], s = [], l = 0, c = t; l < c.length; l += 1) {
              for (var u = [], f = 0, h = c[l]; f < h.length; f += 1) {
                var p = h[f],
                    d = [p.x + o[0], p.y + o[1]];
                _e(e, d), u.push(d);
              }

              s.push(u);
            }

            if (e[2] - e[0] <= a / 2) {
              (i = e)[0] = i[1] = 1 / 0, i[2] = i[3] = -1 / 0;

              for (var m = 0, g = s; m < g.length; m += 1) {
                for (var v = 0, y = g[m]; v < y.length; v += 1) {
                  Oe(y[v], e, r, a);
                }
              }
            }

            return s;
          }

          var Re = function Re(t, e) {
            this.type = jt, this.geojson = t, this.geometries = e;
          };

          function Fe(t) {
            if (t instanceof xe) {
              if ("get" === t.name && 1 === t.args.length) return !1;
              if ("feature-state" === t.name) return !1;
              if ("has" === t.name && 1 === t.args.length) return !1;
              if ("properties" === t.name || "geometry-type" === t.name || "id" === t.name) return !1;
              if (/^filter-/.test(t.name)) return !1;
            }

            if (t instanceof Re) return !1;
            var e = !0;
            return t.eachChild(function (t) {
              e && !Fe(t) && (e = !1);
            }), e;
          }

          function Be(t) {
            if (t instanceof xe && "feature-state" === t.name) return !1;
            var e = !0;
            return t.eachChild(function (t) {
              e && !Be(t) && (e = !1);
            }), e;
          }

          function Ne(t, e) {
            if (t instanceof xe && e.indexOf(t.name) >= 0) return !1;
            var r = !0;
            return t.eachChild(function (t) {
              r && !Ne(t, e) && (r = !1);
            }), r;
          }

          Re.parse = function (t, e) {
            if (2 !== t.length) return e.error("'within' expression requires exactly one argument, but found " + (t.length - 1) + " instead.");

            if (oe(t[1])) {
              var r = t[1];
              if ("FeatureCollection" === r.type) for (var n = 0; n < r.features.length; ++n) {
                var i = r.features[n].geometry.type;
                if ("Polygon" === i || "MultiPolygon" === i) return new Re(r, r.features[n].geometry);
              } else if ("Feature" === r.type) {
                var a = r.geometry.type;
                if ("Polygon" === a || "MultiPolygon" === a) return new Re(r, r.geometry);
              } else if ("Polygon" === r.type || "MultiPolygon" === r.type) return new Re(r, r);
            }

            return e.error("'within' expression requires valid geojson object that contains polygon geometry type.");
          }, Re.prototype.evaluate = function (t) {
            if (null != t.geometry() && null != t.canonicalID()) {
              if ("Point" === t.geometryType()) return function (t, e) {
                var r = [1 / 0, 1 / 0, -1 / 0, -1 / 0],
                    n = [1 / 0, 1 / 0, -1 / 0, -1 / 0],
                    i = t.canonicalID();

                if ("Polygon" === e.type) {
                  var a = Pe(e.coordinates, n, i),
                      o = ze(t.geometry(), r, n, i);
                  if (!we(r, n)) return !1;

                  for (var s = 0, l = o; s < l.length; s += 1) {
                    if (!Me(l[s], a)) return !1;
                  }
                }

                if ("MultiPolygon" === e.type) {
                  var c = Ie(e.coordinates, n, i),
                      u = ze(t.geometry(), r, n, i);
                  if (!we(r, n)) return !1;

                  for (var f = 0, h = u; f < h.length; f += 1) {
                    if (!Ae(h[f], c)) return !1;
                  }
                }

                return !0;
              }(t, this.geometries);
              if ("LineString" === t.geometryType()) return function (t, e) {
                var r = [1 / 0, 1 / 0, -1 / 0, -1 / 0],
                    n = [1 / 0, 1 / 0, -1 / 0, -1 / 0],
                    i = t.canonicalID();

                if ("Polygon" === e.type) {
                  var a = Pe(e.coordinates, n, i),
                      o = De(t.geometry(), r, n, i);
                  if (!we(r, n)) return !1;

                  for (var s = 0, l = o; s < l.length; s += 1) {
                    if (!Le(l[s], a)) return !1;
                  }
                }

                if ("MultiPolygon" === e.type) {
                  var c = Ie(e.coordinates, n, i),
                      u = De(t.geometry(), r, n, i);
                  if (!we(r, n)) return !1;

                  for (var f = 0, h = u; f < h.length; f += 1) {
                    if (!Ce(h[f], c)) return !1;
                  }
                }

                return !0;
              }(t, this.geometries);
            }

            return !1;
          }, Re.prototype.eachChild = function () {}, Re.prototype.outputDefined = function () {
            return !0;
          }, Re.prototype.serialize = function () {
            return ["within", this.geojson];
          };

          var je = function je(t, e) {
            this.type = e.type, this.name = t, this.boundExpression = e;
          };

          je.parse = function (t, e) {
            if (2 !== t.length || "string" != typeof t[1]) return e.error("'var' expression requires exactly one string literal argument.");
            var r = t[1];
            return e.scope.has(r) ? new je(r, e.scope.get(r)) : e.error('Unknown variable "' + r + '". Make sure "' + r + '" has been bound in an enclosing "let" expression before using it.', 1);
          }, je.prototype.evaluate = function (t) {
            return this.boundExpression.evaluate(t);
          }, je.prototype.eachChild = function () {}, je.prototype.outputDefined = function () {
            return !1;
          }, je.prototype.serialize = function () {
            return ["var", this.name];
          };

          var Ue = function Ue(t, e, r, n, i) {
            void 0 === e && (e = []), void 0 === n && (n = new Rt()), void 0 === i && (i = []), this.registry = t, this.path = e, this.key = e.map(function (t) {
              return "[" + t + "]";
            }).join(""), this.scope = n, this.errors = i, this.expectedType = r;
          };

          function Ve(t, e) {
            for (var r, n, i = t.length - 1, a = 0, o = i, s = 0; a <= o;) {
              if (r = t[s = Math.floor((a + o) / 2)], n = t[s + 1], r <= e) {
                if (s === i || e < n) return s;
                a = s + 1;
              } else {
                if (!(r > e)) throw new ue("Input is not a number.");
                o = s - 1;
              }
            }

            return 0;
          }

          Ue.prototype.parse = function (t, e, r, n, i) {
            return void 0 === i && (i = {}), e ? this.concat(e, r, n)._parse(t, i) : this._parse(t, i);
          }, Ue.prototype._parse = function (t, e) {
            function r(t, e, r) {
              return "assert" === r ? new he(e, [t]) : "coerce" === r ? new ge(e, [t]) : t;
            }

            if (null !== t && "string" != typeof t && "boolean" != typeof t && "number" != typeof t || (t = ["literal", t]), Array.isArray(t)) {
              if (0 === t.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
              var n = t[0];
              if ("string" != typeof n) return this.error("Expression name must be a string, but found " + _typeof(n) + ' instead. If you wanted a literal array, use ["literal", [...]].', 0), null;
              var i = this.registry[n];

              if (i) {
                var a = i.parse(t, this);
                if (!a) return null;

                if (this.expectedType) {
                  var o = this.expectedType,
                      s = a.type;
                  if ("string" !== o.kind && "number" !== o.kind && "boolean" !== o.kind && "object" !== o.kind && "array" !== o.kind || "value" !== s.kind) {
                    if ("color" !== o.kind && "formatted" !== o.kind && "resolvedImage" !== o.kind || "value" !== s.kind && "string" !== s.kind) {
                      if (this.checkSubtype(o, s)) return null;
                    } else a = r(a, o, e.typeAnnotation || "coerce");
                  } else a = r(a, o, e.typeAnnotation || "assert");
                }

                if (!(a instanceof ce) && "resolvedImage" !== a.type.kind && function t(e) {
                  if (e instanceof je) return t(e.boundExpression);
                  if (e instanceof xe && "error" === e.name) return !1;
                  if (e instanceof be) return !1;
                  if (e instanceof Re) return !1;
                  var r = e instanceof ge || e instanceof he,
                      n = !0;
                  if (e.eachChild(function (e) {
                    n = r ? n && t(e) : n && e instanceof ce;
                  }), !n) return !1;
                  return Fe(e) && Ne(e, ["zoom", "heatmap-density", "line-progress", "accumulated", "is-supported-script"]);
                }(a)) {
                  var l = new ye();

                  try {
                    a = new ce(a.type, a.evaluate(l));
                  } catch (t) {
                    return this.error(t.message), null;
                  }
                }

                return a;
              }

              return this.error('Unknown expression "' + n + '". If you wanted a literal array, use ["literal", [...]].', 0);
            }

            return void 0 === t ? this.error("'undefined' value invalid. Use null instead.") : "object" == _typeof(t) ? this.error('Bare objects invalid. Use ["literal", {...}] instead.') : this.error("Expected an array, but found " + _typeof(t) + " instead.");
          }, Ue.prototype.concat = function (t, e, r) {
            var n = "number" == typeof t ? this.path.concat(t) : this.path,
                i = r ? this.scope.concat(r) : this.scope;
            return new Ue(this.registry, n, e || null, i, this.errors);
          }, Ue.prototype.error = function (t) {
            for (var e = [], r = arguments.length - 1; r-- > 0;) {
              e[r] = arguments[r + 1];
            }

            var n = "" + this.key + e.map(function (t) {
              return "[" + t + "]";
            }).join("");
            this.errors.push(new Dt(n, t));
          }, Ue.prototype.checkSubtype = function (t, e) {
            var r = Jt(t, e);
            return r && this.error(r), r;
          };

          var qe = function qe(t, e, r) {
            this.type = t, this.input = e, this.labels = [], this.outputs = [];

            for (var n = 0, i = r; n < i.length; n += 1) {
              var a = i[n],
                  o = a[0],
                  s = a[1];
              this.labels.push(o), this.outputs.push(s);
            }
          };

          function He(t, e, r) {
            return t * (1 - r) + e * r;
          }

          qe.parse = function (t, e) {
            if (t.length - 1 < 4) return e.error("Expected at least 4 arguments, but found only " + (t.length - 1) + ".");
            if ((t.length - 1) % 2 != 0) return e.error("Expected an even number of arguments.");
            var r = e.parse(t[1], 1, Bt);
            if (!r) return null;
            var n = [],
                i = null;
            e.expectedType && "value" !== e.expectedType.kind && (i = e.expectedType);

            for (var a = 1; a < t.length; a += 2) {
              var o = 1 === a ? -1 / 0 : t[a],
                  s = t[a + 1],
                  l = a,
                  c = a + 1;
              if ("number" != typeof o) return e.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', l);
              if (n.length && n[n.length - 1][0] >= o) return e.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', l);
              var u = e.parse(s, c, i);
              if (!u) return null;
              i = i || u.type, n.push([o, u]);
            }

            return new qe(i, r, n);
          }, qe.prototype.evaluate = function (t) {
            var e = this.labels,
                r = this.outputs;
            if (1 === e.length) return r[0].evaluate(t);
            var n = this.input.evaluate(t);
            if (n <= e[0]) return r[0].evaluate(t);
            var i = e.length;
            return n >= e[i - 1] ? r[i - 1].evaluate(t) : r[Ve(e, n)].evaluate(t);
          }, qe.prototype.eachChild = function (t) {
            t(this.input);

            for (var e = 0, r = this.outputs; e < r.length; e += 1) {
              t(r[e]);
            }
          }, qe.prototype.outputDefined = function () {
            return this.outputs.every(function (t) {
              return t.outputDefined();
            });
          }, qe.prototype.serialize = function () {
            for (var t = ["step", this.input.serialize()], e = 0; e < this.labels.length; e++) {
              e > 0 && t.push(this.labels[e]), t.push(this.outputs[e].serialize());
            }

            return t;
          };
          var Ge = Object.freeze({
            __proto__: null,
            number: He,
            color: function color(t, e, r) {
              return new te(He(t.r, e.r, r), He(t.g, e.g, r), He(t.b, e.b, r), He(t.a, e.a, r));
            },
            array: function array(t, e, r) {
              return t.map(function (t, n) {
                return He(t, e[n], r);
              });
            }
          }),
              Ye = 6 / 29,
              We = 3 * Ye * Ye,
              Xe = Math.PI / 180,
              Ze = 180 / Math.PI;

          function Je(t) {
            return t > .008856451679035631 ? Math.pow(t, 1 / 3) : t / We + 4 / 29;
          }

          function Ke(t) {
            return t > Ye ? t * t * t : We * (t - 4 / 29);
          }

          function Qe(t) {
            return 255 * (t <= .0031308 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - .055);
          }

          function $e(t) {
            return (t /= 255) <= .04045 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4);
          }

          function tr(t) {
            var e = $e(t.r),
                r = $e(t.g),
                n = $e(t.b),
                i = Je((.4124564 * e + .3575761 * r + .1804375 * n) / .95047),
                a = Je((.2126729 * e + .7151522 * r + .072175 * n) / 1);
            return {
              l: 116 * a - 16,
              a: 500 * (i - a),
              b: 200 * (a - Je((.0193339 * e + .119192 * r + .9503041 * n) / 1.08883)),
              alpha: t.a
            };
          }

          function er(t) {
            var e = (t.l + 16) / 116,
                r = isNaN(t.a) ? e : e + t.a / 500,
                n = isNaN(t.b) ? e : e - t.b / 200;
            return e = 1 * Ke(e), r = .95047 * Ke(r), n = 1.08883 * Ke(n), new te(Qe(3.2404542 * r - 1.5371385 * e - .4985314 * n), Qe(-.969266 * r + 1.8760108 * e + .041556 * n), Qe(.0556434 * r - .2040259 * e + 1.0572252 * n), t.alpha);
          }

          function rr(t, e, r) {
            var n = e - t;
            return t + r * (n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n);
          }

          var nr = {
            forward: tr,
            reverse: er,
            interpolate: function interpolate(t, e, r) {
              return {
                l: He(t.l, e.l, r),
                a: He(t.a, e.a, r),
                b: He(t.b, e.b, r),
                alpha: He(t.alpha, e.alpha, r)
              };
            }
          },
              ir = {
            forward: function forward(t) {
              var e = tr(t),
                  r = e.l,
                  n = e.a,
                  i = e.b,
                  a = Math.atan2(i, n) * Ze;
              return {
                h: a < 0 ? a + 360 : a,
                c: Math.sqrt(n * n + i * i),
                l: r,
                alpha: t.a
              };
            },
            reverse: function reverse(t) {
              var e = t.h * Xe,
                  r = t.c;
              return er({
                l: t.l,
                a: Math.cos(e) * r,
                b: Math.sin(e) * r,
                alpha: t.alpha
              });
            },
            interpolate: function interpolate(t, e, r) {
              return {
                h: rr(t.h, e.h, r),
                c: He(t.c, e.c, r),
                l: He(t.l, e.l, r),
                alpha: He(t.alpha, e.alpha, r)
              };
            }
          },
              ar = Object.freeze({
            __proto__: null,
            lab: nr,
            hcl: ir
          }),
              or = function or(t, e, r, n, i) {
            this.type = t, this.operator = e, this.interpolation = r, this.input = n, this.labels = [], this.outputs = [];

            for (var a = 0, o = i; a < o.length; a += 1) {
              var s = o[a],
                  l = s[0],
                  c = s[1];
              this.labels.push(l), this.outputs.push(c);
            }
          };

          function sr(t, e, r, n) {
            var i = n - r,
                a = t - r;
            return 0 === i ? 0 : 1 === e ? a / i : (Math.pow(e, a) - 1) / (Math.pow(e, i) - 1);
          }

          or.interpolationFactor = function (t, e, n, i) {
            var a = 0;
            if ("exponential" === t.name) a = sr(e, t.base, n, i);else if ("linear" === t.name) a = sr(e, 1, n, i);else if ("cubic-bezier" === t.name) {
              var o = t.controlPoints;
              a = new r(o[0], o[1], o[2], o[3]).solve(sr(e, 1, n, i));
            }
            return a;
          }, or.parse = function (t, e) {
            var r = t[0],
                n = t[1],
                i = t[2],
                a = t.slice(3);
            if (!Array.isArray(n) || 0 === n.length) return e.error("Expected an interpolation type expression.", 1);
            if ("linear" === n[0]) n = {
              name: "linear"
            };else if ("exponential" === n[0]) {
              var o = n[1];
              if ("number" != typeof o) return e.error("Exponential interpolation requires a numeric base.", 1, 1);
              n = {
                name: "exponential",
                base: o
              };
            } else {
              if ("cubic-bezier" !== n[0]) return e.error("Unknown interpolation type " + String(n[0]), 1, 0);
              var s = n.slice(1);
              if (4 !== s.length || s.some(function (t) {
                return "number" != typeof t || t < 0 || t > 1;
              })) return e.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
              n = {
                name: "cubic-bezier",
                controlPoints: s
              };
            }
            if (t.length - 1 < 4) return e.error("Expected at least 4 arguments, but found only " + (t.length - 1) + ".");
            if ((t.length - 1) % 2 != 0) return e.error("Expected an even number of arguments.");
            if (!(i = e.parse(i, 2, Bt))) return null;
            var l = [],
                c = null;
            "interpolate-hcl" === r || "interpolate-lab" === r ? c = Ut : e.expectedType && "value" !== e.expectedType.kind && (c = e.expectedType);

            for (var u = 0; u < a.length; u += 2) {
              var f = a[u],
                  h = a[u + 1],
                  p = u + 3,
                  d = u + 4;
              if ("number" != typeof f) return e.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', p);
              if (l.length && l[l.length - 1][0] >= f) return e.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', p);
              var m = e.parse(h, d, c);
              if (!m) return null;
              c = c || m.type, l.push([f, m]);
            }

            return "number" === c.kind || "color" === c.kind || "array" === c.kind && "number" === c.itemType.kind && "number" == typeof c.N ? new or(c, r, n, i, l) : e.error("Type " + Xt(c) + " is not interpolatable.");
          }, or.prototype.evaluate = function (t) {
            var e = this.labels,
                r = this.outputs;
            if (1 === e.length) return r[0].evaluate(t);
            var n = this.input.evaluate(t);
            if (n <= e[0]) return r[0].evaluate(t);
            var i = e.length;
            if (n >= e[i - 1]) return r[i - 1].evaluate(t);
            var a = Ve(e, n),
                o = e[a],
                s = e[a + 1],
                l = or.interpolationFactor(this.interpolation, n, o, s),
                c = r[a].evaluate(t),
                u = r[a + 1].evaluate(t);
            return "interpolate" === this.operator ? Ge[this.type.kind.toLowerCase()](c, u, l) : "interpolate-hcl" === this.operator ? ir.reverse(ir.interpolate(ir.forward(c), ir.forward(u), l)) : nr.reverse(nr.interpolate(nr.forward(c), nr.forward(u), l));
          }, or.prototype.eachChild = function (t) {
            t(this.input);

            for (var e = 0, r = this.outputs; e < r.length; e += 1) {
              t(r[e]);
            }
          }, or.prototype.outputDefined = function () {
            return this.outputs.every(function (t) {
              return t.outputDefined();
            });
          }, or.prototype.serialize = function () {
            var t;
            t = "linear" === this.interpolation.name ? ["linear"] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? ["linear"] : ["exponential", this.interpolation.base] : ["cubic-bezier"].concat(this.interpolation.controlPoints);

            for (var e = [this.operator, t, this.input.serialize()], r = 0; r < this.labels.length; r++) {
              e.push(this.labels[r], this.outputs[r].serialize());
            }

            return e;
          };

          var lr = function lr(t, e) {
            this.type = t, this.args = e;
          };

          lr.parse = function (t, e) {
            if (t.length < 2) return e.error("Expectected at least one argument.");
            var r = null,
                n = e.expectedType;
            n && "value" !== n.kind && (r = n);

            for (var i = [], a = 0, o = t.slice(1); a < o.length; a += 1) {
              var s = o[a],
                  l = e.parse(s, 1 + i.length, r, void 0, {
                typeAnnotation: "omit"
              });
              if (!l) return null;
              r = r || l.type, i.push(l);
            }

            var c = n && i.some(function (t) {
              return Jt(n, t.type);
            });
            return new lr(c ? qt : r, i);
          }, lr.prototype.evaluate = function (t) {
            for (var e, r = null, n = 0, i = 0, a = this.args; i < a.length; i += 1) {
              if (n++, (r = a[i].evaluate(t)) && r instanceof ie && !r.available && (e || (e = r.name), r = null, n === this.args.length && (r = e)), null !== r) break;
            }

            return r;
          }, lr.prototype.eachChild = function (t) {
            this.args.forEach(t);
          }, lr.prototype.outputDefined = function () {
            return this.args.every(function (t) {
              return t.outputDefined();
            });
          }, lr.prototype.serialize = function () {
            var t = ["coalesce"];
            return this.eachChild(function (e) {
              t.push(e.serialize());
            }), t;
          };

          var cr = function cr(t, e) {
            this.type = e.type, this.bindings = [].concat(t), this.result = e;
          };

          cr.prototype.evaluate = function (t) {
            return this.result.evaluate(t);
          }, cr.prototype.eachChild = function (t) {
            for (var e = 0, r = this.bindings; e < r.length; e += 1) {
              t(r[e][1]);
            }

            t(this.result);
          }, cr.parse = function (t, e) {
            if (t.length < 4) return e.error("Expected at least 3 arguments, but found " + (t.length - 1) + " instead.");

            for (var r = [], n = 1; n < t.length - 1; n += 2) {
              var i = t[n];
              if ("string" != typeof i) return e.error("Expected string, but found " + _typeof(i) + " instead.", n);
              if (/[^a-zA-Z0-9_]/.test(i)) return e.error("Variable names must contain only alphanumeric characters or '_'.", n);
              var a = e.parse(t[n + 1], n + 1);
              if (!a) return null;
              r.push([i, a]);
            }

            var o = e.parse(t[t.length - 1], t.length - 1, e.expectedType, r);
            return o ? new cr(r, o) : null;
          }, cr.prototype.outputDefined = function () {
            return this.result.outputDefined();
          }, cr.prototype.serialize = function () {
            for (var t = ["let"], e = 0, r = this.bindings; e < r.length; e += 1) {
              var n = r[e],
                  i = n[0],
                  a = n[1];
              t.push(i, a.serialize());
            }

            return t.push(this.result.serialize()), t;
          };

          var ur = function ur(t, e, r) {
            this.type = t, this.index = e, this.input = r;
          };

          ur.parse = function (t, e) {
            if (3 !== t.length) return e.error("Expected 2 arguments, but found " + (t.length - 1) + " instead.");
            var r = e.parse(t[1], 1, Bt),
                n = e.parse(t[2], 2, Wt(e.expectedType || qt));
            if (!r || !n) return null;
            var i = n.type;
            return new ur(i.itemType, r, n);
          }, ur.prototype.evaluate = function (t) {
            var e = this.index.evaluate(t),
                r = this.input.evaluate(t);
            if (e < 0) throw new ue("Array index out of bounds: " + e + " < 0.");
            if (e >= r.length) throw new ue("Array index out of bounds: " + e + " > " + (r.length - 1) + ".");
            if (e !== Math.floor(e)) throw new ue("Array index must be an integer, but found " + e + " instead.");
            return r[e];
          }, ur.prototype.eachChild = function (t) {
            t(this.index), t(this.input);
          }, ur.prototype.outputDefined = function () {
            return !1;
          }, ur.prototype.serialize = function () {
            return ["at", this.index.serialize(), this.input.serialize()];
          };

          var fr = function fr(t, e) {
            this.type = jt, this.needle = t, this.haystack = e;
          };

          fr.parse = function (t, e) {
            if (3 !== t.length) return e.error("Expected 2 arguments, but found " + (t.length - 1) + " instead.");
            var r = e.parse(t[1], 1, qt),
                n = e.parse(t[2], 2, qt);
            return r && n ? Kt(r.type, [jt, Nt, Bt, Ft, qt]) ? new fr(r, n) : e.error("Expected first argument to be of type boolean, string, number or null, but found " + Xt(r.type) + " instead") : null;
          }, fr.prototype.evaluate = function (t) {
            var e = this.needle.evaluate(t),
                r = this.haystack.evaluate(t);
            if (!r) return !1;
            if (!Qt(e, ["boolean", "string", "number", "null"])) throw new ue("Expected first argument to be of type boolean, string, number or null, but found " + Xt(se(e)) + " instead.");
            if (!Qt(r, ["string", "array"])) throw new ue("Expected second argument to be of type array or string, but found " + Xt(se(r)) + " instead.");
            return r.indexOf(e) >= 0;
          }, fr.prototype.eachChild = function (t) {
            t(this.needle), t(this.haystack);
          }, fr.prototype.outputDefined = function () {
            return !0;
          }, fr.prototype.serialize = function () {
            return ["in", this.needle.serialize(), this.haystack.serialize()];
          };

          var hr = function hr(t, e, r) {
            this.type = Bt, this.needle = t, this.haystack = e, this.fromIndex = r;
          };

          hr.parse = function (t, e) {
            if (t.length <= 2 || t.length >= 5) return e.error("Expected 3 or 4 arguments, but found " + (t.length - 1) + " instead.");
            var r = e.parse(t[1], 1, qt),
                n = e.parse(t[2], 2, qt);
            if (!r || !n) return null;
            if (!Kt(r.type, [jt, Nt, Bt, Ft, qt])) return e.error("Expected first argument to be of type boolean, string, number or null, but found " + Xt(r.type) + " instead");

            if (4 === t.length) {
              var i = e.parse(t[3], 3, Bt);
              return i ? new hr(r, n, i) : null;
            }

            return new hr(r, n);
          }, hr.prototype.evaluate = function (t) {
            var e = this.needle.evaluate(t),
                r = this.haystack.evaluate(t);
            if (!Qt(e, ["boolean", "string", "number", "null"])) throw new ue("Expected first argument to be of type boolean, string, number or null, but found " + Xt(se(e)) + " instead.");
            if (!Qt(r, ["string", "array"])) throw new ue("Expected second argument to be of type array or string, but found " + Xt(se(r)) + " instead.");

            if (this.fromIndex) {
              var n = this.fromIndex.evaluate(t);
              return r.indexOf(e, n);
            }

            return r.indexOf(e);
          }, hr.prototype.eachChild = function (t) {
            t(this.needle), t(this.haystack), this.fromIndex && t(this.fromIndex);
          }, hr.prototype.outputDefined = function () {
            return !1;
          }, hr.prototype.serialize = function () {
            if (null != this.fromIndex && void 0 !== this.fromIndex) {
              var t = this.fromIndex.serialize();
              return ["index-of", this.needle.serialize(), this.haystack.serialize(), t];
            }

            return ["index-of", this.needle.serialize(), this.haystack.serialize()];
          };

          var pr = function pr(t, e, r, n, i, a) {
            this.inputType = t, this.type = e, this.input = r, this.cases = n, this.outputs = i, this.otherwise = a;
          };

          pr.parse = function (t, e) {
            if (t.length < 5) return e.error("Expected at least 4 arguments, but found only " + (t.length - 1) + ".");
            if (t.length % 2 != 1) return e.error("Expected an even number of arguments.");
            var r, n;
            e.expectedType && "value" !== e.expectedType.kind && (n = e.expectedType);

            for (var i = {}, a = [], o = 2; o < t.length - 1; o += 2) {
              var s = t[o],
                  l = t[o + 1];
              Array.isArray(s) || (s = [s]);
              var c = e.concat(o);
              if (0 === s.length) return c.error("Expected at least one branch label.");

              for (var u = 0, f = s; u < f.length; u += 1) {
                var h = f[u];
                if ("number" != typeof h && "string" != typeof h) return c.error("Branch labels must be numbers or strings.");
                if ("number" == typeof h && Math.abs(h) > Number.MAX_SAFE_INTEGER) return c.error("Branch labels must be integers no larger than " + Number.MAX_SAFE_INTEGER + ".");
                if ("number" == typeof h && Math.floor(h) !== h) return c.error("Numeric branch labels must be integer values.");

                if (r) {
                  if (c.checkSubtype(r, se(h))) return null;
                } else r = se(h);

                if (void 0 !== i[String(h)]) return c.error("Branch labels must be unique.");
                i[String(h)] = a.length;
              }

              var p = e.parse(l, o, n);
              if (!p) return null;
              n = n || p.type, a.push(p);
            }

            var d = e.parse(t[1], 1, qt);
            if (!d) return null;
            var m = e.parse(t[t.length - 1], t.length - 1, n);
            return m ? "value" !== d.type.kind && e.concat(1).checkSubtype(r, d.type) ? null : new pr(r, n, d, i, a, m) : null;
          }, pr.prototype.evaluate = function (t) {
            var e = this.input.evaluate(t);
            return (se(e) === this.inputType && this.outputs[this.cases[e]] || this.otherwise).evaluate(t);
          }, pr.prototype.eachChild = function (t) {
            t(this.input), this.outputs.forEach(t), t(this.otherwise);
          }, pr.prototype.outputDefined = function () {
            return this.outputs.every(function (t) {
              return t.outputDefined();
            }) && this.otherwise.outputDefined();
          }, pr.prototype.serialize = function () {
            for (var t = this, e = ["match", this.input.serialize()], r = [], n = {}, i = 0, a = Object.keys(this.cases).sort(); i < a.length; i += 1) {
              var o = a[i];
              void 0 === (f = n[this.cases[o]]) ? (n[this.cases[o]] = r.length, r.push([this.cases[o], [o]])) : r[f][1].push(o);
            }

            for (var s = function s(e) {
              return "number" === t.inputType.kind ? Number(e) : e;
            }, l = 0, c = r; l < c.length; l += 1) {
              var u = c[l],
                  f = u[0],
                  h = u[1];
              1 === h.length ? e.push(s(h[0])) : e.push(h.map(s)), e.push(this.outputs[outputIndex$1].serialize());
            }

            return e.push(this.otherwise.serialize()), e;
          };

          var dr = function dr(t, e, r) {
            this.type = t, this.branches = e, this.otherwise = r;
          };

          dr.parse = function (t, e) {
            if (t.length < 4) return e.error("Expected at least 3 arguments, but found only " + (t.length - 1) + ".");
            if (t.length % 2 != 0) return e.error("Expected an odd number of arguments.");
            var r;
            e.expectedType && "value" !== e.expectedType.kind && (r = e.expectedType);

            for (var n = [], i = 1; i < t.length - 1; i += 2) {
              var a = e.parse(t[i], i, jt);
              if (!a) return null;
              var o = e.parse(t[i + 1], i + 1, r);
              if (!o) return null;
              n.push([a, o]), r = r || o.type;
            }

            var s = e.parse(t[t.length - 1], t.length - 1, r);
            return s ? new dr(r, n, s) : null;
          }, dr.prototype.evaluate = function (t) {
            for (var e = 0, r = this.branches; e < r.length; e += 1) {
              var n = r[e],
                  i = n[0],
                  a = n[1];
              if (i.evaluate(t)) return a.evaluate(t);
            }

            return this.otherwise.evaluate(t);
          }, dr.prototype.eachChild = function (t) {
            for (var e = 0, r = this.branches; e < r.length; e += 1) {
              var n = r[e],
                  i = n[0],
                  a = n[1];
              t(i), t(a);
            }

            t(this.otherwise);
          }, dr.prototype.outputDefined = function () {
            return this.branches.every(function (t) {
              t[0];
              return t[1].outputDefined();
            }) && this.otherwise.outputDefined();
          }, dr.prototype.serialize = function () {
            var t = ["case"];
            return this.eachChild(function (e) {
              t.push(e.serialize());
            }), t;
          };

          var mr = function mr(t, e, r, n) {
            this.type = t, this.input = e, this.beginIndex = r, this.endIndex = n;
          };

          function gr(t, e) {
            return "==" === t || "!=" === t ? "boolean" === e.kind || "string" === e.kind || "number" === e.kind || "null" === e.kind || "value" === e.kind : "string" === e.kind || "number" === e.kind || "value" === e.kind;
          }

          function vr(t, e, r, n) {
            return 0 === n.compare(e, r);
          }

          function yr(t, e, r) {
            var n = "==" !== t && "!=" !== t;
            return function () {
              function i(t, e, r) {
                this.type = jt, this.lhs = t, this.rhs = e, this.collator = r, this.hasUntypedArgument = "value" === t.type.kind || "value" === e.type.kind;
              }

              return i.parse = function (t, e) {
                if (3 !== t.length && 4 !== t.length) return e.error("Expected two or three arguments.");
                var r = t[0],
                    a = e.parse(t[1], 1, qt);
                if (!a) return null;
                if (!gr(r, a.type)) return e.concat(1).error('"' + r + "\" comparisons are not supported for type '" + Xt(a.type) + "'.");
                var o = e.parse(t[2], 2, qt);
                if (!o) return null;
                if (!gr(r, o.type)) return e.concat(2).error('"' + r + "\" comparisons are not supported for type '" + Xt(o.type) + "'.");
                if (a.type.kind !== o.type.kind && "value" !== a.type.kind && "value" !== o.type.kind) return e.error("Cannot compare types '" + Xt(a.type) + "' and '" + Xt(o.type) + "'.");
                n && ("value" === a.type.kind && "value" !== o.type.kind ? a = new he(o.type, [a]) : "value" !== a.type.kind && "value" === o.type.kind && (o = new he(a.type, [o])));
                var s = null;

                if (4 === t.length) {
                  if ("string" !== a.type.kind && "string" !== o.type.kind && "value" !== a.type.kind && "value" !== o.type.kind) return e.error("Cannot use collator to compare non-string types.");
                  if (!(s = e.parse(t[3], 3, Ht))) return null;
                }

                return new i(a, o, s);
              }, i.prototype.evaluate = function (i) {
                var a = this.lhs.evaluate(i),
                    o = this.rhs.evaluate(i);

                if (n && this.hasUntypedArgument) {
                  var s = se(a),
                      l = se(o);
                  if (s.kind !== l.kind || "string" !== s.kind && "number" !== s.kind) throw new ue('Expected arguments for "' + t + '" to be (string, string) or (number, number), but found (' + s.kind + ", " + l.kind + ") instead.");
                }

                if (this.collator && !n && this.hasUntypedArgument) {
                  var c = se(a),
                      u = se(o);
                  if ("string" !== c.kind || "string" !== u.kind) return e(i, a, o);
                }

                return this.collator ? r(i, a, o, this.collator.evaluate(i)) : e(i, a, o);
              }, i.prototype.eachChild = function (t) {
                t(this.lhs), t(this.rhs), this.collator && t(this.collator);
              }, i.prototype.outputDefined = function () {
                return !0;
              }, i.prototype.serialize = function () {
                var e = [t];
                return this.eachChild(function (t) {
                  e.push(t.serialize());
                }), e;
              }, i;
            }();
          }

          mr.parse = function (t, e) {
            if (t.length <= 2 || t.length >= 5) return e.error("Expected 3 or 4 arguments, but found " + (t.length - 1) + " instead.");
            var r = e.parse(t[1], 1, qt),
                n = e.parse(t[2], 2, Bt);
            if (!r || !n) return null;
            if (!Kt(r.type, [Wt(qt), Nt, qt])) return e.error("Expected first argument to be of type array or string, but found " + Xt(r.type) + " instead");

            if (4 === t.length) {
              var i = e.parse(t[3], 3, Bt);
              return i ? new mr(r.type, r, n, i) : null;
            }

            return new mr(r.type, r, n);
          }, mr.prototype.evaluate = function (t) {
            var e = this.input.evaluate(t),
                r = this.beginIndex.evaluate(t);
            if (!Qt(e, ["string", "array"])) throw new ue("Expected first argument to be of type array or string, but found " + Xt(se(e)) + " instead.");

            if (this.endIndex) {
              var n = this.endIndex.evaluate(t);
              return e.slice(r, n);
            }

            return e.slice(r);
          }, mr.prototype.eachChild = function (t) {
            t(this.input), t(this.beginIndex), this.endIndex && t(this.endIndex);
          }, mr.prototype.outputDefined = function () {
            return !1;
          }, mr.prototype.serialize = function () {
            if (null != this.endIndex && void 0 !== this.endIndex) {
              var t = this.endIndex.serialize();
              return ["slice", this.input.serialize(), this.beginIndex.serialize(), t];
            }

            return ["slice", this.input.serialize(), this.beginIndex.serialize()];
          };

          var xr = yr("==", function (t, e, r) {
            return e === r;
          }, vr),
              br = yr("!=", function (t, e, r) {
            return e !== r;
          }, function (t, e, r, n) {
            return !vr(0, e, r, n);
          }),
              _r = yr("<", function (t, e, r) {
            return e < r;
          }, function (t, e, r, n) {
            return n.compare(e, r) < 0;
          }),
              wr = yr(">", function (t, e, r) {
            return e > r;
          }, function (t, e, r, n) {
            return n.compare(e, r) > 0;
          }),
              Tr = yr("<=", function (t, e, r) {
            return e <= r;
          }, function (t, e, r, n) {
            return n.compare(e, r) <= 0;
          }),
              kr = yr(">=", function (t, e, r) {
            return e >= r;
          }, function (t, e, r, n) {
            return n.compare(e, r) >= 0;
          }),
              Mr = function Mr(t, e, r, n, i) {
            this.type = Nt, this.number = t, this.locale = e, this.currency = r, this.minFractionDigits = n, this.maxFractionDigits = i;
          };

          Mr.parse = function (t, e) {
            if (3 !== t.length) return e.error("Expected two arguments.");
            var r = e.parse(t[1], 1, Bt);
            if (!r) return null;
            var n = t[2];
            if ("object" != _typeof(n) || Array.isArray(n)) return e.error("NumberFormat options argument must be an object.");
            var i = null;
            if (n.locale && !(i = e.parse(n.locale, 1, Nt))) return null;
            var a = null;
            if (n.currency && !(a = e.parse(n.currency, 1, Nt))) return null;
            var o = null;
            if (n["min-fraction-digits"] && !(o = e.parse(n["min-fraction-digits"], 1, Bt))) return null;
            var s = null;
            return n["max-fraction-digits"] && !(s = e.parse(n["max-fraction-digits"], 1, Bt)) ? null : new Mr(r, i, a, o, s);
          }, Mr.prototype.evaluate = function (t) {
            return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t) : [], {
              style: this.currency ? "currency" : "decimal",
              currency: this.currency ? this.currency.evaluate(t) : void 0,
              minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t) : void 0,
              maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t) : void 0
            }).format(this.number.evaluate(t));
          }, Mr.prototype.eachChild = function (t) {
            t(this.number), this.locale && t(this.locale), this.currency && t(this.currency), this.minFractionDigits && t(this.minFractionDigits), this.maxFractionDigits && t(this.maxFractionDigits);
          }, Mr.prototype.outputDefined = function () {
            return !1;
          }, Mr.prototype.serialize = function () {
            var t = {};
            return this.locale && (t.locale = this.locale.serialize()), this.currency && (t.currency = this.currency.serialize()), this.minFractionDigits && (t["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (t["max-fraction-digits"] = this.maxFractionDigits.serialize()), ["number-format", this.number.serialize(), t];
          };

          var Ar = function Ar(t) {
            this.type = Bt, this.input = t;
          };

          Ar.parse = function (t, e) {
            if (2 !== t.length) return e.error("Expected 1 argument, but found " + (t.length - 1) + " instead.");
            var r = e.parse(t[1], 1);
            return r ? "array" !== r.type.kind && "string" !== r.type.kind && "value" !== r.type.kind ? e.error("Expected argument of type string or array, but found " + Xt(r.type) + " instead.") : new Ar(r) : null;
          }, Ar.prototype.evaluate = function (t) {
            var e = this.input.evaluate(t);
            if ("string" == typeof e) return e.length;
            if (Array.isArray(e)) return e.length;
            throw new ue("Expected value to be of type string or array, but found " + Xt(se(e)) + " instead.");
          }, Ar.prototype.eachChild = function (t) {
            t(this.input);
          }, Ar.prototype.outputDefined = function () {
            return !1;
          }, Ar.prototype.serialize = function () {
            var t = ["length"];
            return this.eachChild(function (e) {
              t.push(e.serialize());
            }), t;
          };
          var Sr = {
            "==": xr,
            "!=": br,
            ">": wr,
            "<": _r,
            ">=": kr,
            "<=": Tr,
            array: he,
            at: ur,
            boolean: he,
            case: dr,
            coalesce: lr,
            collator: be,
            format: pe,
            image: de,
            in: fr,
            "index-of": hr,
            interpolate: or,
            "interpolate-hcl": or,
            "interpolate-lab": or,
            length: Ar,
            let: cr,
            literal: ce,
            match: pr,
            number: he,
            "number-format": Mr,
            object: he,
            slice: mr,
            step: qe,
            string: he,
            "to-boolean": ge,
            "to-color": ge,
            "to-number": ge,
            "to-string": ge,
            var: je,
            within: Re
          };

          function Er(t, e) {
            var r = e[0],
                n = e[1],
                i = e[2],
                a = e[3];
            r = r.evaluate(t), n = n.evaluate(t), i = i.evaluate(t);
            var o = a ? a.evaluate(t) : 1,
                s = ae(r, n, i, o);
            if (s) throw new ue(s);
            return new te(r / 255 * o, n / 255 * o, i / 255 * o, o);
          }

          function Lr(t, e) {
            return t in e;
          }

          function Cr(t, e) {
            var r = e[t];
            return void 0 === r ? null : r;
          }

          function Pr(t) {
            return {
              type: t
            };
          }

          function Ir(t) {
            return {
              result: "success",
              value: t
            };
          }

          function Or(t) {
            return {
              result: "error",
              value: t
            };
          }

          function zr(t) {
            return "data-driven" === t["property-type"] || "cross-faded-data-driven" === t["property-type"];
          }

          function Dr(t) {
            return !!t.expression && t.expression.parameters.indexOf("zoom") > -1;
          }

          function Rr(t) {
            return !!t.expression && t.expression.interpolated;
          }

          function Fr(t) {
            return t instanceof Number ? "number" : t instanceof String ? "string" : t instanceof Boolean ? "boolean" : Array.isArray(t) ? "array" : null === t ? "null" : _typeof(t);
          }

          function Br(t) {
            return "object" == _typeof(t) && null !== t && !Array.isArray(t);
          }

          function Nr(t) {
            return t;
          }

          function jr(t, e, r) {
            return void 0 !== t ? t : void 0 !== e ? e : void 0 !== r ? r : void 0;
          }

          function Ur(t, e, r, n, i) {
            return jr(_typeof(r) === i ? n[r] : void 0, t.default, e.default);
          }

          function Vr(t, e, r) {
            if ("number" !== Fr(r)) return jr(t.default, e.default);
            var n = t.stops.length;
            if (1 === n) return t.stops[0][1];
            if (r <= t.stops[0][0]) return t.stops[0][1];
            if (r >= t.stops[n - 1][0]) return t.stops[n - 1][1];
            var i = Ve(t.stops.map(function (t) {
              return t[0];
            }), r);
            return t.stops[i][1];
          }

          function qr(t, e, r) {
            var n = void 0 !== t.base ? t.base : 1;
            if ("number" !== Fr(r)) return jr(t.default, e.default);
            var i = t.stops.length;
            if (1 === i) return t.stops[0][1];
            if (r <= t.stops[0][0]) return t.stops[0][1];
            if (r >= t.stops[i - 1][0]) return t.stops[i - 1][1];

            var a = Ve(t.stops.map(function (t) {
              return t[0];
            }), r),
                o = function (t, e, r, n) {
              var i = n - r,
                  a = t - r;
              return 0 === i ? 0 : 1 === e ? a / i : (Math.pow(e, a) - 1) / (Math.pow(e, i) - 1);
            }(r, n, t.stops[a][0], t.stops[a + 1][0]),
                s = t.stops[a][1],
                l = t.stops[a + 1][1],
                c = Ge[e.type] || Nr;

            if (t.colorSpace && "rgb" !== t.colorSpace) {
              var u = ar[t.colorSpace];

              c = function c(t, e) {
                return u.reverse(u.interpolate(u.forward(t), u.forward(e), o));
              };
            }

            return "function" == typeof s.evaluate ? {
              evaluate: function evaluate() {
                for (var t = [], e = arguments.length; e--;) {
                  t[e] = arguments[e];
                }

                var r = s.evaluate.apply(void 0, t),
                    n = l.evaluate.apply(void 0, t);
                if (void 0 !== r && void 0 !== n) return c(r, n, o);
              }
            } : c(s, l, o);
          }

          function Hr(t, e, r) {
            return "color" === e.type ? r = te.parse(r) : "formatted" === e.type ? r = ne.fromString(r.toString()) : "resolvedImage" === e.type ? r = ie.fromString(r.toString()) : Fr(r) === e.type || "enum" === e.type && e.values[r] || (r = void 0), jr(r, t.default, e.default);
          }

          xe.register(Sr, {
            error: [{
              kind: "error"
            }, [Nt], function (t, e) {
              var r = e[0];
              throw new ue(r.evaluate(t));
            }],
            typeof: [Nt, [qt], function (t, e) {
              return Xt(se(e[0].evaluate(t)));
            }],
            "to-rgba": [Wt(Bt, 4), [Ut], function (t, e) {
              return e[0].evaluate(t).toArray();
            }],
            rgb: [Ut, [Bt, Bt, Bt], Er],
            rgba: [Ut, [Bt, Bt, Bt, Bt], Er],
            has: {
              type: jt,
              overloads: [[[Nt], function (t, e) {
                return Lr(e[0].evaluate(t), t.properties());
              }], [[Nt, Vt], function (t, e) {
                var r = e[0],
                    n = e[1];
                return Lr(r.evaluate(t), n.evaluate(t));
              }]]
            },
            get: {
              type: qt,
              overloads: [[[Nt], function (t, e) {
                return Cr(e[0].evaluate(t), t.properties());
              }], [[Nt, Vt], function (t, e) {
                var r = e[0],
                    n = e[1];
                return Cr(r.evaluate(t), n.evaluate(t));
              }]]
            },
            "feature-state": [qt, [Nt], function (t, e) {
              return Cr(e[0].evaluate(t), t.featureState || {});
            }],
            properties: [Vt, [], function (t) {
              return t.properties();
            }],
            "geometry-type": [Nt, [], function (t) {
              return t.geometryType();
            }],
            id: [qt, [], function (t) {
              return t.id();
            }],
            zoom: [Bt, [], function (t) {
              return t.globals.zoom;
            }],
            "heatmap-density": [Bt, [], function (t) {
              return t.globals.heatmapDensity || 0;
            }],
            "line-progress": [Bt, [], function (t) {
              return t.globals.lineProgress || 0;
            }],
            accumulated: [qt, [], function (t) {
              return void 0 === t.globals.accumulated ? null : t.globals.accumulated;
            }],
            "+": [Bt, Pr(Bt), function (t, e) {
              for (var r = 0, n = 0, i = e; n < i.length; n += 1) {
                r += i[n].evaluate(t);
              }

              return r;
            }],
            "*": [Bt, Pr(Bt), function (t, e) {
              for (var r = 1, n = 0, i = e; n < i.length; n += 1) {
                r *= i[n].evaluate(t);
              }

              return r;
            }],
            "-": {
              type: Bt,
              overloads: [[[Bt, Bt], function (t, e) {
                var r = e[0],
                    n = e[1];
                return r.evaluate(t) - n.evaluate(t);
              }], [[Bt], function (t, e) {
                return -e[0].evaluate(t);
              }]]
            },
            "/": [Bt, [Bt, Bt], function (t, e) {
              var r = e[0],
                  n = e[1];
              return r.evaluate(t) / n.evaluate(t);
            }],
            "%": [Bt, [Bt, Bt], function (t, e) {
              var r = e[0],
                  n = e[1];
              return r.evaluate(t) % n.evaluate(t);
            }],
            ln2: [Bt, [], function () {
              return Math.LN2;
            }],
            pi: [Bt, [], function () {
              return Math.PI;
            }],
            e: [Bt, [], function () {
              return Math.E;
            }],
            "^": [Bt, [Bt, Bt], function (t, e) {
              var r = e[0],
                  n = e[1];
              return Math.pow(r.evaluate(t), n.evaluate(t));
            }],
            sqrt: [Bt, [Bt], function (t, e) {
              var r = e[0];
              return Math.sqrt(r.evaluate(t));
            }],
            log10: [Bt, [Bt], function (t, e) {
              var r = e[0];
              return Math.log(r.evaluate(t)) / Math.LN10;
            }],
            ln: [Bt, [Bt], function (t, e) {
              var r = e[0];
              return Math.log(r.evaluate(t));
            }],
            log2: [Bt, [Bt], function (t, e) {
              var r = e[0];
              return Math.log(r.evaluate(t)) / Math.LN2;
            }],
            sin: [Bt, [Bt], function (t, e) {
              var r = e[0];
              return Math.sin(r.evaluate(t));
            }],
            cos: [Bt, [Bt], function (t, e) {
              var r = e[0];
              return Math.cos(r.evaluate(t));
            }],
            tan: [Bt, [Bt], function (t, e) {
              var r = e[0];
              return Math.tan(r.evaluate(t));
            }],
            asin: [Bt, [Bt], function (t, e) {
              var r = e[0];
              return Math.asin(r.evaluate(t));
            }],
            acos: [Bt, [Bt], function (t, e) {
              var r = e[0];
              return Math.acos(r.evaluate(t));
            }],
            atan: [Bt, [Bt], function (t, e) {
              var r = e[0];
              return Math.atan(r.evaluate(t));
            }],
            min: [Bt, Pr(Bt), function (t, e) {
              return Math.min.apply(Math, e.map(function (e) {
                return e.evaluate(t);
              }));
            }],
            max: [Bt, Pr(Bt), function (t, e) {
              return Math.max.apply(Math, e.map(function (e) {
                return e.evaluate(t);
              }));
            }],
            abs: [Bt, [Bt], function (t, e) {
              var r = e[0];
              return Math.abs(r.evaluate(t));
            }],
            round: [Bt, [Bt], function (t, e) {
              var r = e[0].evaluate(t);
              return r < 0 ? -Math.round(-r) : Math.round(r);
            }],
            floor: [Bt, [Bt], function (t, e) {
              var r = e[0];
              return Math.floor(r.evaluate(t));
            }],
            ceil: [Bt, [Bt], function (t, e) {
              var r = e[0];
              return Math.ceil(r.evaluate(t));
            }],
            "filter-==": [jt, [Nt, qt], function (t, e) {
              var r = e[0],
                  n = e[1];
              return t.properties()[r.value] === n.value;
            }],
            "filter-id-==": [jt, [qt], function (t, e) {
              var r = e[0];
              return t.id() === r.value;
            }],
            "filter-type-==": [jt, [Nt], function (t, e) {
              var r = e[0];
              return t.geometryType() === r.value;
            }],
            "filter-<": [jt, [Nt, qt], function (t, e) {
              var r = e[0],
                  n = e[1],
                  i = t.properties()[r.value],
                  a = n.value;
              return _typeof(i) == _typeof(a) && i < a;
            }],
            "filter-id-<": [jt, [qt], function (t, e) {
              var r = e[0],
                  n = t.id(),
                  i = r.value;
              return _typeof(n) == _typeof(i) && n < i;
            }],
            "filter->": [jt, [Nt, qt], function (t, e) {
              var r = e[0],
                  n = e[1],
                  i = t.properties()[r.value],
                  a = n.value;
              return _typeof(i) == _typeof(a) && i > a;
            }],
            "filter-id->": [jt, [qt], function (t, e) {
              var r = e[0],
                  n = t.id(),
                  i = r.value;
              return _typeof(n) == _typeof(i) && n > i;
            }],
            "filter-<=": [jt, [Nt, qt], function (t, e) {
              var r = e[0],
                  n = e[1],
                  i = t.properties()[r.value],
                  a = n.value;
              return _typeof(i) == _typeof(a) && i <= a;
            }],
            "filter-id-<=": [jt, [qt], function (t, e) {
              var r = e[0],
                  n = t.id(),
                  i = r.value;
              return _typeof(n) == _typeof(i) && n <= i;
            }],
            "filter->=": [jt, [Nt, qt], function (t, e) {
              var r = e[0],
                  n = e[1],
                  i = t.properties()[r.value],
                  a = n.value;
              return _typeof(i) == _typeof(a) && i >= a;
            }],
            "filter-id->=": [jt, [qt], function (t, e) {
              var r = e[0],
                  n = t.id(),
                  i = r.value;
              return _typeof(n) == _typeof(i) && n >= i;
            }],
            "filter-has": [jt, [qt], function (t, e) {
              return e[0].value in t.properties();
            }],
            "filter-has-id": [jt, [], function (t) {
              return null !== t.id() && void 0 !== t.id();
            }],
            "filter-type-in": [jt, [Wt(Nt)], function (t, e) {
              return e[0].value.indexOf(t.geometryType()) >= 0;
            }],
            "filter-id-in": [jt, [Wt(qt)], function (t, e) {
              return e[0].value.indexOf(t.id()) >= 0;
            }],
            "filter-in-small": [jt, [Nt, Wt(qt)], function (t, e) {
              var r = e[0];
              return e[1].value.indexOf(t.properties()[r.value]) >= 0;
            }],
            "filter-in-large": [jt, [Nt, Wt(qt)], function (t, e) {
              var r = e[0],
                  n = e[1];
              return function (t, e, r, n) {
                for (; r <= n;) {
                  var i = r + n >> 1;
                  if (e[i] === t) return !0;
                  e[i] > t ? n = i - 1 : r = i + 1;
                }

                return !1;
              }(t.properties()[r.value], n.value, 0, n.value.length - 1);
            }],
            all: {
              type: jt,
              overloads: [[[jt, jt], function (t, e) {
                var r = e[0],
                    n = e[1];
                return r.evaluate(t) && n.evaluate(t);
              }], [Pr(jt), function (t, e) {
                for (var r = 0, n = e; r < n.length; r += 1) {
                  if (!n[r].evaluate(t)) return !1;
                }

                return !0;
              }]]
            },
            any: {
              type: jt,
              overloads: [[[jt, jt], function (t, e) {
                var r = e[0],
                    n = e[1];
                return r.evaluate(t) || n.evaluate(t);
              }], [Pr(jt), function (t, e) {
                for (var r = 0, n = e; r < n.length; r += 1) {
                  if (n[r].evaluate(t)) return !0;
                }

                return !1;
              }]]
            },
            "!": [jt, [jt], function (t, e) {
              return !e[0].evaluate(t);
            }],
            "is-supported-script": [jt, [Nt], function (t, e) {
              var r = e[0],
                  n = t.globals && t.globals.isSupportedScript;
              return !n || n(r.evaluate(t));
            }],
            upcase: [Nt, [Nt], function (t, e) {
              return e[0].evaluate(t).toUpperCase();
            }],
            downcase: [Nt, [Nt], function (t, e) {
              return e[0].evaluate(t).toLowerCase();
            }],
            concat: [Nt, Pr(qt), function (t, e) {
              return e.map(function (e) {
                return le(e.evaluate(t));
              }).join("");
            }],
            "resolved-locale": [Nt, [Ht], function (t, e) {
              return e[0].evaluate(t).resolvedLocale();
            }]
          });

          var Gr = function Gr(t, e) {
            this.expression = t, this._warningHistory = {}, this._evaluator = new ye(), this._defaultValue = e ? function (t) {
              return "color" === t.type && Br(t.default) ? new te(0, 0, 0, 0) : "color" === t.type ? te.parse(t.default) || null : void 0 === t.default ? null : t.default;
            }(e) : null, this._enumValues = e && "enum" === e.type ? e.values : null;
          };

          function Yr(t) {
            return Array.isArray(t) && t.length > 0 && "string" == typeof t[0] && t[0] in Sr;
          }

          function Wr(t, e) {
            var r = new Ue(Sr, [], e ? function (t) {
              var e = {
                color: Ut,
                string: Nt,
                number: Bt,
                enum: Nt,
                boolean: jt,
                formatted: Gt,
                resolvedImage: Yt
              };
              if ("array" === t.type) return Wt(e[t.value] || qt, t.length);
              return e[t.type];
            }(e) : void 0),
                n = r.parse(t, void 0, void 0, void 0, e && "string" === e.type ? {
              typeAnnotation: "coerce"
            } : void 0);
            return n ? Ir(new Gr(n, e)) : Or(r.errors);
          }

          Gr.prototype.evaluateWithoutErrorHandling = function (t, e, r, n, i, a) {
            return this._evaluator.globals = t, this._evaluator.feature = e, this._evaluator.featureState = r, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a, this.expression.evaluate(this._evaluator);
          }, Gr.prototype.evaluate = function (t, e, r, n, i, a) {
            this._evaluator.globals = t, this._evaluator.feature = e || null, this._evaluator.featureState = r || null, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a || null;

            try {
              var o = this.expression.evaluate(this._evaluator);
              if (null == o || "number" == typeof o && o != o) return this._defaultValue;
              if (this._enumValues && !(o in this._enumValues)) throw new ue("Expected value to be one of " + Object.keys(this._enumValues).map(function (t) {
                return JSON.stringify(t);
              }).join(", ") + ", but found " + JSON.stringify(o) + " instead.");
              return o;
            } catch (t) {
              return this._warningHistory[t.message] || (this._warningHistory[t.message] = !0, "undefined" != typeof console && console.warn(t.message)), this._defaultValue;
            }
          };

          var Xr = function Xr(t, e) {
            this.kind = t, this._styleExpression = e, this.isStateDependent = "constant" !== t && !Be(e.expression);
          };

          Xr.prototype.evaluateWithoutErrorHandling = function (t, e, r, n, i, a) {
            return this._styleExpression.evaluateWithoutErrorHandling(t, e, r, n, i, a);
          }, Xr.prototype.evaluate = function (t, e, r, n, i, a) {
            return this._styleExpression.evaluate(t, e, r, n, i, a);
          };

          var Zr = function Zr(t, e, r, n) {
            this.kind = t, this.zoomStops = r, this._styleExpression = e, this.isStateDependent = "camera" !== t && !Be(e.expression), this.interpolationType = n;
          };

          function Jr(t, e) {
            if ("error" === (t = Wr(t, e)).result) return t;
            var r = t.value.expression,
                n = Fe(r);
            if (!n && !zr(e)) return Or([new Dt("", "data expressions not supported")]);
            var i = Ne(r, ["zoom"]);
            if (!i && !Dr(e)) return Or([new Dt("", "zoom expressions not supported")]);

            var a = function t(e) {
              var r = null;
              if (e instanceof cr) r = t(e.result);else if (e instanceof lr) for (var n = 0, i = e.args; n < i.length; n += 1) {
                var a = i[n];
                if (r = t(a)) break;
              } else (e instanceof qe || e instanceof or) && e.input instanceof xe && "zoom" === e.input.name && (r = e);
              if (r instanceof Dt) return r;
              return e.eachChild(function (e) {
                var n = t(e);
                n instanceof Dt ? r = n : !r && n ? r = new Dt("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : r && n && r !== n && (r = new Dt("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
              }), r;
            }(r);

            if (!a && !i) return Or([new Dt("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')]);
            if (a instanceof Dt) return Or([a]);
            if (a instanceof or && !Rr(e)) return Or([new Dt("", '"interpolate" expressions cannot be used with this property')]);
            if (!a) return Ir(new Xr(n ? "constant" : "source", t.value));
            var o = a instanceof or ? a.interpolation : void 0;
            return Ir(new Zr(n ? "camera" : "composite", t.value, a.labels, o));
          }

          Zr.prototype.evaluateWithoutErrorHandling = function (t, e, r, n, i, a) {
            return this._styleExpression.evaluateWithoutErrorHandling(t, e, r, n, i, a);
          }, Zr.prototype.evaluate = function (t, e, r, n, i, a) {
            return this._styleExpression.evaluate(t, e, r, n, i, a);
          }, Zr.prototype.interpolationFactor = function (t, e, r) {
            return this.interpolationType ? or.interpolationFactor(this.interpolationType, t, e, r) : 0;
          };

          var Kr = function Kr(t, e) {
            this._parameters = t, this._specification = e, It(this, function t(e, r) {
              var n,
                  i,
                  a,
                  o = "color" === r.type,
                  s = e.stops && "object" == _typeof(e.stops[0][0]),
                  l = s || void 0 !== e.property,
                  c = s || !l,
                  u = e.type || (Rr(r) ? "exponential" : "interval");

              if (o && ((e = It({}, e)).stops && (e.stops = e.stops.map(function (t) {
                return [t[0], te.parse(t[1])];
              })), e.default ? e.default = te.parse(e.default) : e.default = te.parse(r.default)), e.colorSpace && "rgb" !== e.colorSpace && !ar[e.colorSpace]) throw new Error("Unknown color space: " + e.colorSpace);
              if ("exponential" === u) n = qr;else if ("interval" === u) n = Vr;else if ("categorical" === u) {
                n = Ur, i = Object.create(null);

                for (var f = 0, h = e.stops; f < h.length; f += 1) {
                  var p = h[f];
                  i[p[0]] = p[1];
                }

                a = _typeof(e.stops[0][0]);
              } else {
                if ("identity" !== u) throw new Error('Unknown function type "' + u + '"');
                n = Hr;
              }

              if (s) {
                for (var d = {}, m = [], g = 0; g < e.stops.length; g++) {
                  var v = e.stops[g],
                      y = v[0].zoom;
                  void 0 === d[y] && (d[y] = {
                    zoom: y,
                    type: e.type,
                    property: e.property,
                    default: e.default,
                    stops: []
                  }, m.push(y)), d[y].stops.push([v[0].value, v[1]]);
                }

                for (var x = [], b = 0, _ = m; b < _.length; b += 1) {
                  var w = _[b];
                  x.push([d[w].zoom, t(d[w], r)]);
                }

                var T = {
                  name: "linear"
                };
                return {
                  kind: "composite",
                  interpolationType: T,
                  interpolationFactor: or.interpolationFactor.bind(void 0, T),
                  zoomStops: x.map(function (t) {
                    return t[0];
                  }),
                  evaluate: function evaluate(t, n) {
                    var i = t.zoom;
                    return qr({
                      stops: x,
                      base: e.base
                    }, r, i).evaluate(i, n);
                  }
                };
              }

              if (c) {
                var k = "exponential" === u ? {
                  name: "exponential",
                  base: void 0 !== e.base ? e.base : 1
                } : null;
                return {
                  kind: "camera",
                  interpolationType: k,
                  interpolationFactor: or.interpolationFactor.bind(void 0, k),
                  zoomStops: e.stops.map(function (t) {
                    return t[0];
                  }),
                  evaluate: function evaluate(t) {
                    var o = t.zoom;
                    return n(e, r, o, i, a);
                  }
                };
              }

              return {
                kind: "source",
                evaluate: function evaluate(t, o) {
                  var s = o && o.properties ? o.properties[e.property] : void 0;
                  return void 0 === s ? jr(e.default, r.default) : n(e, r, s, i, a);
                }
              };
            }(this._parameters, this._specification));
          };

          function Qr(t) {
            var e = t.key,
                r = t.value,
                n = t.valueSpec || {},
                i = t.objectElementValidators || {},
                a = t.style,
                o = t.styleSpec,
                s = [],
                l = Fr(r);
            if ("object" !== l) return [new Ct(e, r, "object expected, " + l + " found")];

            for (var c in r) {
              var u = c.split(".")[0],
                  f = n[u] || n["*"],
                  h = void 0;
              if (i[u]) h = i[u];else if (n[u]) h = kn;else if (i["*"]) h = i["*"];else {
                if (!n["*"]) {
                  s.push(new Ct(e, r[c], 'unknown property "' + c + '"'));
                  continue;
                }

                h = kn;
              }
              s = s.concat(h({
                key: (e ? e + "." : e) + c,
                value: r[c],
                valueSpec: f,
                style: a,
                styleSpec: o,
                object: r,
                objectKey: c
              }, r));
            }

            for (var p in n) {
              i[p] || n[p].required && void 0 === n[p].default && void 0 === r[p] && s.push(new Ct(e, r, 'missing required property "' + p + '"'));
            }

            return s;
          }

          function $r(t) {
            var e = t.value,
                r = t.valueSpec,
                n = t.style,
                i = t.styleSpec,
                a = t.key,
                o = t.arrayElementValidator || kn;
            if ("array" !== Fr(e)) return [new Ct(a, e, "array expected, " + Fr(e) + " found")];
            if (r.length && e.length !== r.length) return [new Ct(a, e, "array length " + r.length + " expected, length " + e.length + " found")];
            if (r["min-length"] && e.length < r["min-length"]) return [new Ct(a, e, "array length at least " + r["min-length"] + " expected, length " + e.length + " found")];
            var s = {
              type: r.value,
              values: r.values
            };
            i.$version < 7 && (s.function = r.function), "object" === Fr(r.value) && (s = r.value);

            for (var l = [], c = 0; c < e.length; c++) {
              l = l.concat(o({
                array: e,
                arrayIndex: c,
                value: e[c],
                valueSpec: s,
                style: n,
                styleSpec: i,
                key: a + "[" + c + "]"
              }));
            }

            return l;
          }

          function tn(t) {
            var e = t.key,
                r = t.value,
                n = t.valueSpec,
                i = Fr(r);
            return "number" === i && r != r && (i = "NaN"), "number" !== i ? [new Ct(e, r, "number expected, " + i + " found")] : "minimum" in n && r < n.minimum ? [new Ct(e, r, r + " is less than the minimum value " + n.minimum)] : "maximum" in n && r > n.maximum ? [new Ct(e, r, r + " is greater than the maximum value " + n.maximum)] : [];
          }

          function en(t) {
            var e,
                r,
                n,
                i = t.valueSpec,
                a = Ot(t.value.type),
                o = {},
                s = "categorical" !== a && void 0 === t.value.property,
                l = !s,
                c = "array" === Fr(t.value.stops) && "array" === Fr(t.value.stops[0]) && "object" === Fr(t.value.stops[0][0]),
                u = Qr({
              key: t.key,
              value: t.value,
              valueSpec: t.styleSpec.function,
              style: t.style,
              styleSpec: t.styleSpec,
              objectElementValidators: {
                stops: function stops(t) {
                  if ("identity" === a) return [new Ct(t.key, t.value, 'identity function may not have a "stops" property')];
                  var e = [],
                      r = t.value;
                  e = e.concat($r({
                    key: t.key,
                    value: r,
                    valueSpec: t.valueSpec,
                    style: t.style,
                    styleSpec: t.styleSpec,
                    arrayElementValidator: f
                  })), "array" === Fr(r) && 0 === r.length && e.push(new Ct(t.key, r, "array must have at least one stop"));
                  return e;
                },
                default: function _default(t) {
                  return kn({
                    key: t.key,
                    value: t.value,
                    valueSpec: i,
                    style: t.style,
                    styleSpec: t.styleSpec
                  });
                }
              }
            });
            return "identity" === a && s && u.push(new Ct(t.key, t.value, 'missing required property "property"')), "identity" === a || t.value.stops || u.push(new Ct(t.key, t.value, 'missing required property "stops"')), "exponential" === a && t.valueSpec.expression && !Rr(t.valueSpec) && u.push(new Ct(t.key, t.value, "exponential functions not supported")), t.styleSpec.$version >= 8 && (l && !zr(t.valueSpec) ? u.push(new Ct(t.key, t.value, "property functions not supported")) : s && !Dr(t.valueSpec) && u.push(new Ct(t.key, t.value, "zoom functions not supported"))), "categorical" !== a && !c || void 0 !== t.value.property || u.push(new Ct(t.key, t.value, '"property" property is required')), u;

            function f(t) {
              var e = [],
                  a = t.value,
                  s = t.key;
              if ("array" !== Fr(a)) return [new Ct(s, a, "array expected, " + Fr(a) + " found")];
              if (2 !== a.length) return [new Ct(s, a, "array length 2 expected, length " + a.length + " found")];

              if (c) {
                if ("object" !== Fr(a[0])) return [new Ct(s, a, "object expected, " + Fr(a[0]) + " found")];
                if (void 0 === a[0].zoom) return [new Ct(s, a, "object stop key must have zoom")];
                if (void 0 === a[0].value) return [new Ct(s, a, "object stop key must have value")];
                if (n && n > Ot(a[0].zoom)) return [new Ct(s, a[0].zoom, "stop zoom values must appear in ascending order")];
                Ot(a[0].zoom) !== n && (n = Ot(a[0].zoom), r = void 0, o = {}), e = e.concat(Qr({
                  key: s + "[0]",
                  value: a[0],
                  valueSpec: {
                    zoom: {}
                  },
                  style: t.style,
                  styleSpec: t.styleSpec,
                  objectElementValidators: {
                    zoom: tn,
                    value: h
                  }
                }));
              } else e = e.concat(h({
                key: s + "[0]",
                value: a[0],
                valueSpec: {},
                style: t.style,
                styleSpec: t.styleSpec
              }, a));

              return Yr(zt(a[1])) ? e.concat([new Ct(s + "[1]", a[1], "expressions are not allowed in function stops.")]) : e.concat(kn({
                key: s + "[1]",
                value: a[1],
                valueSpec: i,
                style: t.style,
                styleSpec: t.styleSpec
              }));
            }

            function h(t, n) {
              var s = Fr(t.value),
                  l = Ot(t.value),
                  c = null !== t.value ? t.value : n;

              if (e) {
                if (s !== e) return [new Ct(t.key, c, s + " stop domain type must match previous stop domain type " + e)];
              } else e = s;

              if ("number" !== s && "string" !== s && "boolean" !== s) return [new Ct(t.key, c, "stop domain value must be a number, string, or boolean")];

              if ("number" !== s && "categorical" !== a) {
                var u = "number expected, " + s + " found";
                return zr(i) && void 0 === a && (u += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [new Ct(t.key, c, u)];
              }

              return "categorical" !== a || "number" !== s || isFinite(l) && Math.floor(l) === l ? "categorical" !== a && "number" === s && void 0 !== r && l < r ? [new Ct(t.key, c, "stop domain values must appear in ascending order")] : (r = l, "categorical" === a && l in o ? [new Ct(t.key, c, "stop domain values must be unique")] : (o[l] = !0, [])) : [new Ct(t.key, c, "integer expected, found " + l)];
            }
          }

          function rn(t) {
            var e = ("property" === t.expressionContext ? Jr : Wr)(zt(t.value), t.valueSpec);
            if ("error" === e.result) return e.value.map(function (e) {
              return new Ct("" + t.key + e.key, t.value, e.message);
            });
            var r = e.value.expression || e.value._styleExpression.expression;
            if ("property" === t.expressionContext && "text-font" === t.propertyKey && !r.outputDefined()) return [new Ct(t.key, t.value, 'Invalid data expression for "' + t.propertyKey + '". Output values must be contained as literals within the expression.')];
            if ("property" === t.expressionContext && "layout" === t.propertyType && !Be(r)) return [new Ct(t.key, t.value, '"feature-state" data expressions are not supported with layout properties.')];
            if ("filter" === t.expressionContext && !Be(r)) return [new Ct(t.key, t.value, '"feature-state" data expressions are not supported with filters.')];

            if (t.expressionContext && 0 === t.expressionContext.indexOf("cluster")) {
              if (!Ne(r, ["zoom", "feature-state"])) return [new Ct(t.key, t.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')];
              if ("cluster-initial" === t.expressionContext && !Fe(r)) return [new Ct(t.key, t.value, "Feature data expressions are not supported with initial expression part of cluster properties.")];
            }

            return [];
          }

          function nn(t) {
            var e = t.key,
                r = t.value,
                n = t.valueSpec,
                i = [];
            return Array.isArray(n.values) ? -1 === n.values.indexOf(Ot(r)) && i.push(new Ct(e, r, "expected one of [" + n.values.join(", ") + "], " + JSON.stringify(r) + " found")) : -1 === Object.keys(n.values).indexOf(Ot(r)) && i.push(new Ct(e, r, "expected one of [" + Object.keys(n.values).join(", ") + "], " + JSON.stringify(r) + " found")), i;
          }

          function an(t) {
            if (!0 === t || !1 === t) return !0;
            if (!Array.isArray(t) || 0 === t.length) return !1;

            switch (t[0]) {
              case "has":
                return t.length >= 2 && "$id" !== t[1] && "$type" !== t[1];

              case "in":
                return t.length >= 3 && ("string" != typeof t[1] || Array.isArray(t[2]));

              case "!in":
              case "!has":
              case "none":
                return !1;

              case "==":
              case "!=":
              case ">":
              case ">=":
              case "<":
              case "<=":
                return 3 !== t.length || Array.isArray(t[1]) || Array.isArray(t[2]);

              case "any":
              case "all":
                for (var e = 0, r = t.slice(1); e < r.length; e += 1) {
                  var n = r[e];
                  if (!an(n) && "boolean" != typeof n) return !1;
                }

                return !0;

              default:
                return !0;
            }
          }

          Kr.deserialize = function (t) {
            return new Kr(t._parameters, t._specification);
          }, Kr.serialize = function (t) {
            return {
              _parameters: t._parameters,
              _specification: t._specification
            };
          };
          var on = {
            type: "boolean",
            default: !1,
            transition: !1,
            "property-type": "data-driven",
            expression: {
              interpolated: !1,
              parameters: ["zoom", "feature"]
            }
          };

          function sn(t) {
            if (null == t) return {
              filter: function filter() {
                return !0;
              },
              needGeometry: !1
            };
            an(t) || (t = cn(t));
            var e = Wr(t, on);
            if ("error" === e.result) throw new Error(e.value.map(function (t) {
              return t.key + ": " + t.message;
            }).join(", "));
            return {
              filter: function filter(t, r, n) {
                return e.value.evaluate(t, r, {}, n);
              },
              needGeometry: function t(e) {
                if (!Array.isArray(e)) return !1;
                if ("within" === e[0]) return !0;

                for (var r = 1; r < e.length; r++) {
                  if (t(e[r])) return !0;
                }

                return !1;
              }(t)
            };
          }

          function ln(t, e) {
            return t < e ? -1 : t > e ? 1 : 0;
          }

          function cn(t) {
            if (!t) return !0;
            var e,
                r = t[0];
            return t.length <= 1 ? "any" !== r : "==" === r ? un(t[1], t[2], "==") : "!=" === r ? pn(un(t[1], t[2], "==")) : "<" === r || ">" === r || "<=" === r || ">=" === r ? un(t[1], t[2], r) : "any" === r ? (e = t.slice(1), ["any"].concat(e.map(cn))) : "all" === r ? ["all"].concat(t.slice(1).map(cn)) : "none" === r ? ["all"].concat(t.slice(1).map(cn).map(pn)) : "in" === r ? fn(t[1], t.slice(2)) : "!in" === r ? pn(fn(t[1], t.slice(2))) : "has" === r ? hn(t[1]) : "!has" === r ? pn(hn(t[1])) : "within" !== r || t;
          }

          function un(t, e, r) {
            switch (t) {
              case "$type":
                return ["filter-type-" + r, e];

              case "$id":
                return ["filter-id-" + r, e];

              default:
                return ["filter-" + r, t, e];
            }
          }

          function fn(t, e) {
            if (0 === e.length) return !1;

            switch (t) {
              case "$type":
                return ["filter-type-in", ["literal", e]];

              case "$id":
                return ["filter-id-in", ["literal", e]];

              default:
                return e.length > 200 && !e.some(function (t) {
                  return _typeof(t) != _typeof(e[0]);
                }) ? ["filter-in-large", t, ["literal", e.sort(ln)]] : ["filter-in-small", t, ["literal", e]];
            }
          }

          function hn(t) {
            switch (t) {
              case "$type":
                return !0;

              case "$id":
                return ["filter-has-id"];

              default:
                return ["filter-has", t];
            }
          }

          function pn(t) {
            return ["!", t];
          }

          function dn(t) {
            return an(zt(t.value)) ? rn(It({}, t, {
              expressionContext: "filter",
              valueSpec: {
                value: "boolean"
              }
            })) : function t(e) {
              var r = e.value,
                  n = e.key;
              if ("array" !== Fr(r)) return [new Ct(n, r, "array expected, " + Fr(r) + " found")];
              var i,
                  a = e.styleSpec,
                  o = [];
              if (r.length < 1) return [new Ct(n, r, "filter array must have at least 1 element")];

              switch (o = o.concat(nn({
                key: n + "[0]",
                value: r[0],
                valueSpec: a.filter_operator,
                style: e.style,
                styleSpec: e.styleSpec
              })), Ot(r[0])) {
                case "<":
                case "<=":
                case ">":
                case ">=":
                  r.length >= 2 && "$type" === Ot(r[1]) && o.push(new Ct(n, r, '"$type" cannot be use with operator "' + r[0] + '"'));

                case "==":
                case "!=":
                  3 !== r.length && o.push(new Ct(n, r, 'filter array for operator "' + r[0] + '" must have 3 elements'));

                case "in":
                case "!in":
                  r.length >= 2 && "string" !== (i = Fr(r[1])) && o.push(new Ct(n + "[1]", r[1], "string expected, " + i + " found"));

                  for (var s = 2; s < r.length; s++) {
                    i = Fr(r[s]), "$type" === Ot(r[1]) ? o = o.concat(nn({
                      key: n + "[" + s + "]",
                      value: r[s],
                      valueSpec: a.geometry_type,
                      style: e.style,
                      styleSpec: e.styleSpec
                    })) : "string" !== i && "number" !== i && "boolean" !== i && o.push(new Ct(n + "[" + s + "]", r[s], "string, number, or boolean expected, " + i + " found"));
                  }

                  break;

                case "any":
                case "all":
                case "none":
                  for (var l = 1; l < r.length; l++) {
                    o = o.concat(t({
                      key: n + "[" + l + "]",
                      value: r[l],
                      style: e.style,
                      styleSpec: e.styleSpec
                    }));
                  }

                  break;

                case "has":
                case "!has":
                  i = Fr(r[1]), 2 !== r.length ? o.push(new Ct(n, r, 'filter array for "' + r[0] + '" operator must have 2 elements')) : "string" !== i && o.push(new Ct(n + "[1]", r[1], "string expected, " + i + " found"));
                  break;

                case "within":
                  i = Fr(r[1]), 2 !== r.length ? o.push(new Ct(n, r, 'filter array for "' + r[0] + '" operator must have 2 elements')) : "object" !== i && o.push(new Ct(n + "[1]", r[1], "object expected, " + i + " found"));
              }

              return o;
            }(t);
          }

          function mn(t, e) {
            var r = t.key,
                n = t.style,
                i = t.styleSpec,
                a = t.value,
                o = t.objectKey,
                s = i[e + "_" + t.layerType];
            if (!s) return [];
            var l = o.match(/^(.*)-transition$/);
            if ("paint" === e && l && s[l[1]] && s[l[1]].transition) return kn({
              key: r,
              value: a,
              valueSpec: i.transition,
              style: n,
              styleSpec: i
            });
            var c,
                u = t.valueSpec || s[o];
            if (!u) return [new Ct(r, a, 'unknown property "' + o + '"')];
            if ("string" === Fr(a) && zr(u) && !u.tokens && (c = /^{([^}]+)}$/.exec(a))) return [new Ct(r, a, '"' + o + '" does not support interpolation syntax\nUse an identity property function instead: `{ "type": "identity", "property": ' + JSON.stringify(c[1]) + " }`.")];
            var f = [];
            return "symbol" === t.layerType && ("text-field" === o && n && !n.glyphs && f.push(new Ct(r, a, 'use of "text-field" requires a style "glyphs" property')), "text-font" === o && Br(zt(a)) && "identity" === Ot(a.type) && f.push(new Ct(r, a, '"text-font" does not support identity functions'))), f.concat(kn({
              key: t.key,
              value: a,
              valueSpec: u,
              style: n,
              styleSpec: i,
              expressionContext: "property",
              propertyType: e,
              propertyKey: o
            }));
          }

          function gn(t) {
            return mn(t, "paint");
          }

          function vn(t) {
            return mn(t, "layout");
          }

          function yn(t) {
            var e = [],
                r = t.value,
                n = t.key,
                i = t.style,
                a = t.styleSpec;
            r.type || r.ref || e.push(new Ct(n, r, 'either "type" or "ref" is required'));
            var o,
                s = Ot(r.type),
                l = Ot(r.ref);
            if (r.id) for (var c = Ot(r.id), u = 0; u < t.arrayIndex; u++) {
              var f = i.layers[u];
              Ot(f.id) === c && e.push(new Ct(n, r.id, 'duplicate layer id "' + r.id + '", previously used at line ' + f.id.__line__));
            }
            if ("ref" in r) ["type", "source", "source-layer", "filter", "layout"].forEach(function (t) {
              t in r && e.push(new Ct(n, r[t], '"' + t + '" is prohibited for ref layers'));
            }), i.layers.forEach(function (t) {
              Ot(t.id) === l && (o = t);
            }), o ? o.ref ? e.push(new Ct(n, r.ref, "ref cannot reference another ref layer")) : s = Ot(o.type) : e.push(new Ct(n, r.ref, 'ref layer "' + l + '" not found'));else if ("background" !== s) if (r.source) {
              var h = i.sources && i.sources[r.source],
                  p = h && Ot(h.type);
              h ? "vector" === p && "raster" === s ? e.push(new Ct(n, r.source, 'layer "' + r.id + '" requires a raster source')) : "raster" === p && "raster" !== s ? e.push(new Ct(n, r.source, 'layer "' + r.id + '" requires a vector source')) : "vector" !== p || r["source-layer"] ? "raster-dem" === p && "hillshade" !== s ? e.push(new Ct(n, r.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "line" !== s || !r.paint || !r.paint["line-gradient"] || "geojson" === p && h.lineMetrics || e.push(new Ct(n, r, 'layer "' + r.id + '" specifies a line-gradient, which requires a GeoJSON source with `lineMetrics` enabled.')) : e.push(new Ct(n, r, 'layer "' + r.id + '" must specify a "source-layer"')) : e.push(new Ct(n, r.source, 'source "' + r.source + '" not found'));
            } else e.push(new Ct(n, r, 'missing required property "source"'));
            return e = e.concat(Qr({
              key: n,
              value: r,
              valueSpec: a.layer,
              style: t.style,
              styleSpec: t.styleSpec,
              objectElementValidators: {
                "*": function _() {
                  return [];
                },
                type: function type() {
                  return kn({
                    key: n + ".type",
                    value: r.type,
                    valueSpec: a.layer.type,
                    style: t.style,
                    styleSpec: t.styleSpec,
                    object: r,
                    objectKey: "type"
                  });
                },
                filter: dn,
                layout: function layout(t) {
                  return Qr({
                    layer: r,
                    key: t.key,
                    value: t.value,
                    style: t.style,
                    styleSpec: t.styleSpec,
                    objectElementValidators: {
                      "*": function _(t) {
                        return vn(It({
                          layerType: s
                        }, t));
                      }
                    }
                  });
                },
                paint: function paint(t) {
                  return Qr({
                    layer: r,
                    key: t.key,
                    value: t.value,
                    style: t.style,
                    styleSpec: t.styleSpec,
                    objectElementValidators: {
                      "*": function _(t) {
                        return gn(It({
                          layerType: s
                        }, t));
                      }
                    }
                  });
                }
              }
            }));
          }

          function xn(t) {
            var e = t.value,
                r = t.key,
                n = Fr(e);
            return "string" !== n ? [new Ct(r, e, "string expected, " + n + " found")] : [];
          }

          var bn = {
            promoteId: function promoteId(t) {
              var e = t.key,
                  r = t.value;
              if ("string" === Fr(r)) return xn({
                key: e,
                value: r
              });
              var n = [];

              for (var i in r) {
                n.push.apply(n, xn({
                  key: e + "." + i,
                  value: r[i]
                }));
              }

              return n;
            }
          };

          function _n(t) {
            var e = t.value,
                r = t.key,
                n = t.styleSpec,
                i = t.style;
            if (!e.type) return [new Ct(r, e, '"type" is required')];
            var a,
                o = Ot(e.type);

            switch (o) {
              case "vector":
              case "raster":
              case "raster-dem":
                return a = Qr({
                  key: r,
                  value: e,
                  valueSpec: n["source_" + o.replace("-", "_")],
                  style: t.style,
                  styleSpec: n,
                  objectElementValidators: bn
                });

              case "geojson":
                if (a = Qr({
                  key: r,
                  value: e,
                  valueSpec: n.source_geojson,
                  style: i,
                  styleSpec: n,
                  objectElementValidators: bn
                }), e.cluster) for (var s in e.clusterProperties) {
                  var l = e.clusterProperties[s],
                      c = l[0],
                      u = l[1],
                      f = "string" == typeof c ? [c, ["accumulated"], ["get", s]] : c;
                  a.push.apply(a, rn({
                    key: r + "." + s + ".map",
                    value: u,
                    expressionContext: "cluster-map"
                  })), a.push.apply(a, rn({
                    key: r + "." + s + ".reduce",
                    value: f,
                    expressionContext: "cluster-reduce"
                  }));
                }
                return a;

              case "video":
                return Qr({
                  key: r,
                  value: e,
                  valueSpec: n.source_video,
                  style: i,
                  styleSpec: n
                });

              case "image":
                return Qr({
                  key: r,
                  value: e,
                  valueSpec: n.source_image,
                  style: i,
                  styleSpec: n
                });

              case "canvas":
                return [new Ct(r, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")];

              default:
                return nn({
                  key: r + ".type",
                  value: e.type,
                  valueSpec: {
                    values: ["vector", "raster", "raster-dem", "geojson", "video", "image"]
                  },
                  style: i,
                  styleSpec: n
                });
            }
          }

          function wn(t) {
            var e = t.value,
                r = t.styleSpec,
                n = r.light,
                i = t.style,
                a = [],
                o = Fr(e);
            if (void 0 === e) return a;
            if ("object" !== o) return a = a.concat([new Ct("light", e, "object expected, " + o + " found")]);

            for (var s in e) {
              var l = s.match(/^(.*)-transition$/);
              a = l && n[l[1]] && n[l[1]].transition ? a.concat(kn({
                key: s,
                value: e[s],
                valueSpec: r.transition,
                style: i,
                styleSpec: r
              })) : n[s] ? a.concat(kn({
                key: s,
                value: e[s],
                valueSpec: n[s],
                style: i,
                styleSpec: r
              })) : a.concat([new Ct(s, e[s], 'unknown property "' + s + '"')]);
            }

            return a;
          }

          var Tn = {
            "*": function _() {
              return [];
            },
            array: $r,
            boolean: function boolean(t) {
              var e = t.value,
                  r = t.key,
                  n = Fr(e);
              return "boolean" !== n ? [new Ct(r, e, "boolean expected, " + n + " found")] : [];
            },
            number: tn,
            color: function color(t) {
              var e = t.key,
                  r = t.value,
                  n = Fr(r);
              return "string" !== n ? [new Ct(e, r, "color expected, " + n + " found")] : null === $t(r) ? [new Ct(e, r, 'color expected, "' + r + '" found')] : [];
            },
            constants: Pt,
            enum: nn,
            filter: dn,
            function: en,
            layer: yn,
            object: Qr,
            source: _n,
            light: wn,
            string: xn,
            formatted: function formatted(t) {
              return 0 === xn(t).length ? [] : rn(t);
            },
            resolvedImage: function resolvedImage(t) {
              return 0 === xn(t).length ? [] : rn(t);
            }
          };

          function kn(t) {
            var e = t.value,
                r = t.valueSpec,
                n = t.styleSpec;
            return r.expression && Br(Ot(e)) ? en(t) : r.expression && Yr(zt(e)) ? rn(t) : r.type && Tn[r.type] ? Tn[r.type](t) : Qr(It({}, t, {
              valueSpec: r.type ? n[r.type] : r
            }));
          }

          function Mn(t) {
            var e = t.value,
                r = t.key,
                n = xn(t);
            return n.length || (-1 === e.indexOf("{fontstack}") && n.push(new Ct(r, e, '"glyphs" url must include a "{fontstack}" token')), -1 === e.indexOf("{range}") && n.push(new Ct(r, e, '"glyphs" url must include a "{range}" token'))), n;
          }

          function An(t, e) {
            void 0 === e && (e = Lt);
            var r = [];
            return r = r.concat(kn({
              key: "",
              value: t,
              valueSpec: e.$root,
              styleSpec: e,
              style: t,
              objectElementValidators: {
                glyphs: Mn,
                "*": function _() {
                  return [];
                }
              }
            })), t.constants && (r = r.concat(Pt({
              key: "constants",
              value: t.constants,
              style: t,
              styleSpec: e
            }))), Sn(r);
          }

          function Sn(t) {
            return [].concat(t).sort(function (t, e) {
              return t.line - e.line;
            });
          }

          function En(t) {
            return function () {
              for (var e = [], r = arguments.length; r--;) {
                e[r] = arguments[r];
              }

              return Sn(t.apply(this, e));
            };
          }

          An.source = En(_n), An.light = En(wn), An.layer = En(yn), An.filter = En(dn), An.paintProperty = En(gn), An.layoutProperty = En(vn);
          var Ln = An,
              Cn = Ln.light,
              Pn = Ln.paintProperty,
              In = Ln.layoutProperty;

          function On(t, e) {
            var r = !1;
            if (e && e.length) for (var n = 0, i = e; n < i.length; n += 1) {
              var a = i[n];
              t.fire(new St(new Error(a.message))), r = !0;
            }
            return r;
          }

          var zn = Dn;

          function Dn(t, e, r) {
            var n = this.cells = [];

            if (t instanceof ArrayBuffer) {
              this.arrayBuffer = t;
              var i = new Int32Array(this.arrayBuffer);
              t = i[0], e = i[1], r = i[2], this.d = e + 2 * r;

              for (var a = 0; a < this.d * this.d; a++) {
                var o = i[3 + a],
                    s = i[3 + a + 1];
                n.push(o === s ? null : i.subarray(o, s));
              }

              var l = i[3 + n.length],
                  c = i[3 + n.length + 1];
              this.keys = i.subarray(l, c), this.bboxes = i.subarray(c), this.insert = this._insertReadonly;
            } else {
              this.d = e + 2 * r;

              for (var u = 0; u < this.d * this.d; u++) {
                n.push([]);
              }

              this.keys = [], this.bboxes = [];
            }

            this.n = e, this.extent = t, this.padding = r, this.scale = e / t, this.uid = 0;
            var f = r / e * t;
            this.min = -f, this.max = t + f;
          }

          Dn.prototype.insert = function (t, e, r, n, i) {
            this._forEachCell(e, r, n, i, this._insertCell, this.uid++), this.keys.push(t), this.bboxes.push(e), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
          }, Dn.prototype._insertReadonly = function () {
            throw "Cannot insert into a GridIndex created from an ArrayBuffer.";
          }, Dn.prototype._insertCell = function (t, e, r, n, i, a) {
            this.cells[i].push(a);
          }, Dn.prototype.query = function (t, e, r, n, i) {
            var a = this.min,
                o = this.max;
            if (t <= a && e <= a && o <= r && o <= n && !i) return Array.prototype.slice.call(this.keys);
            var s = [];
            return this._forEachCell(t, e, r, n, this._queryCell, s, {}, i), s;
          }, Dn.prototype._queryCell = function (t, e, r, n, i, a, o, s) {
            var l = this.cells[i];
            if (null !== l) for (var c = this.keys, u = this.bboxes, f = 0; f < l.length; f++) {
              var h = l[f];

              if (void 0 === o[h]) {
                var p = 4 * h;
                (s ? s(u[p + 0], u[p + 1], u[p + 2], u[p + 3]) : t <= u[p + 2] && e <= u[p + 3] && r >= u[p + 0] && n >= u[p + 1]) ? (o[h] = !0, a.push(c[h])) : o[h] = !1;
              }
            }
          }, Dn.prototype._forEachCell = function (t, e, r, n, i, a, o, s) {
            for (var l = this._convertToCellCoord(t), c = this._convertToCellCoord(e), u = this._convertToCellCoord(r), f = this._convertToCellCoord(n), h = l; h <= u; h++) {
              for (var p = c; p <= f; p++) {
                var d = this.d * p + h;
                if ((!s || s(this._convertFromCellCoord(h), this._convertFromCellCoord(p), this._convertFromCellCoord(h + 1), this._convertFromCellCoord(p + 1))) && i.call(this, t, e, r, n, d, a, o, s)) return;
              }
            }
          }, Dn.prototype._convertFromCellCoord = function (t) {
            return (t - this.padding) / this.scale;
          }, Dn.prototype._convertToCellCoord = function (t) {
            return Math.max(0, Math.min(this.d - 1, Math.floor(t * this.scale) + this.padding));
          }, Dn.prototype.toArrayBuffer = function () {
            if (this.arrayBuffer) return this.arrayBuffer;

            for (var t = this.cells, e = 3 + this.cells.length + 1 + 1, r = 0, n = 0; n < this.cells.length; n++) {
              r += this.cells[n].length;
            }

            var i = new Int32Array(e + r + this.keys.length + this.bboxes.length);
            i[0] = this.extent, i[1] = this.n, i[2] = this.padding;

            for (var a = e, o = 0; o < t.length; o++) {
              var s = t[o];
              i[3 + o] = a, i.set(s, a), a += s.length;
            }

            return i[3 + t.length] = a, i.set(this.keys, a), a += this.keys.length, i[3 + t.length + 1] = a, i.set(this.bboxes, a), a += this.bboxes.length, i.buffer;
          };
          var Rn = self.ImageData,
              Fn = self.ImageBitmap,
              Bn = {};

          function Nn(t, e, r) {
            void 0 === r && (r = {}), Object.defineProperty(e, "_classRegistryKey", {
              value: t,
              writeable: !1
            }), Bn[t] = {
              klass: e,
              omit: r.omit || [],
              shallow: r.shallow || []
            };
          }

          for (var jn in Nn("Object", Object), zn.serialize = function (t, e) {
            var r = t.toArrayBuffer();
            return e && e.push(r), {
              buffer: r
            };
          }, zn.deserialize = function (t) {
            return new zn(t.buffer);
          }, Nn("Grid", zn), Nn("Color", te), Nn("Error", Error), Nn("ResolvedImage", ie), Nn("StylePropertyFunction", Kr), Nn("StyleExpression", Gr, {
            omit: ["_evaluator"]
          }), Nn("ZoomDependentExpression", Zr), Nn("ZoomConstantExpression", Xr), Nn("CompoundExpression", xe, {
            omit: ["_evaluate"]
          }), Sr) {
            Sr[jn]._classRegistryKey || Nn("Expression_" + jn, Sr[jn]);
          }

          function Un(t) {
            return t && "undefined" != typeof ArrayBuffer && (t instanceof ArrayBuffer || t.constructor && "ArrayBuffer" === t.constructor.name);
          }

          function Vn(t) {
            return Fn && t instanceof Fn;
          }

          function qn(t, e) {
            if (null == t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || t instanceof Boolean || t instanceof Number || t instanceof String || t instanceof Date || t instanceof RegExp) return t;
            if (Un(t) || Vn(t)) return e && e.push(t), t;

            if (ArrayBuffer.isView(t)) {
              var r = t;
              return e && e.push(r.buffer), r;
            }

            if (t instanceof Rn) return e && e.push(t.data.buffer), t;

            if (Array.isArray(t)) {
              for (var n = [], i = 0, a = t; i < a.length; i += 1) {
                var o = a[i];
                n.push(qn(o, e));
              }

              return n;
            }

            if ("object" == _typeof(t)) {
              var s = t.constructor,
                  l = s._classRegistryKey;
              if (!l) throw new Error("can't serialize object of unregistered class");
              var c = s.serialize ? s.serialize(t, e) : {};

              if (!s.serialize) {
                for (var u in t) {
                  if (t.hasOwnProperty(u) && !(Bn[l].omit.indexOf(u) >= 0)) {
                    var f = t[u];
                    c[u] = Bn[l].shallow.indexOf(u) >= 0 ? f : qn(f, e);
                  }
                }

                t instanceof Error && (c.message = t.message);
              }

              if (c.$name) throw new Error("$name property is reserved for worker serialization logic.");
              return "Object" !== l && (c.$name = l), c;
            }

            throw new Error("can't serialize object of type " + _typeof(t));
          }

          function Hn(t) {
            if (null == t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || t instanceof Boolean || t instanceof Number || t instanceof String || t instanceof Date || t instanceof RegExp || Un(t) || Vn(t) || ArrayBuffer.isView(t) || t instanceof Rn) return t;
            if (Array.isArray(t)) return t.map(Hn);

            if ("object" == _typeof(t)) {
              var e = t.$name || "Object",
                  r = Bn[e].klass;
              if (!r) throw new Error("can't deserialize unregistered class " + e);
              if (r.deserialize) return r.deserialize(t);

              for (var n = Object.create(r.prototype), i = 0, a = Object.keys(t); i < a.length; i += 1) {
                var o = a[i];

                if ("$name" !== o) {
                  var s = t[o];
                  n[o] = Bn[e].shallow.indexOf(o) >= 0 ? s : Hn(s);
                }
              }

              return n;
            }

            throw new Error("can't deserialize object of type " + _typeof(t));
          }

          var Gn = function Gn() {
            this.first = !0;
          };

          Gn.prototype.update = function (t, e) {
            var r = Math.floor(t);
            return this.first ? (this.first = !1, this.lastIntegerZoom = r, this.lastIntegerZoomTime = 0, this.lastZoom = t, this.lastFloorZoom = r, !0) : (this.lastFloorZoom > r ? (this.lastIntegerZoom = r + 1, this.lastIntegerZoomTime = e) : this.lastFloorZoom < r && (this.lastIntegerZoom = r, this.lastIntegerZoomTime = e), t !== this.lastZoom && (this.lastZoom = t, this.lastFloorZoom = r, !0));
          };

          var Yn = {
            "Latin-1 Supplement": function Latin1Supplement(t) {
              return t >= 128 && t <= 255;
            },
            Arabic: function Arabic(t) {
              return t >= 1536 && t <= 1791;
            },
            "Arabic Supplement": function ArabicSupplement(t) {
              return t >= 1872 && t <= 1919;
            },
            "Arabic Extended-A": function ArabicExtendedA(t) {
              return t >= 2208 && t <= 2303;
            },
            "Hangul Jamo": function HangulJamo(t) {
              return t >= 4352 && t <= 4607;
            },
            "Unified Canadian Aboriginal Syllabics": function UnifiedCanadianAboriginalSyllabics(t) {
              return t >= 5120 && t <= 5759;
            },
            Khmer: function Khmer(t) {
              return t >= 6016 && t <= 6143;
            },
            "Unified Canadian Aboriginal Syllabics Extended": function UnifiedCanadianAboriginalSyllabicsExtended(t) {
              return t >= 6320 && t <= 6399;
            },
            "General Punctuation": function GeneralPunctuation(t) {
              return t >= 8192 && t <= 8303;
            },
            "Letterlike Symbols": function LetterlikeSymbols(t) {
              return t >= 8448 && t <= 8527;
            },
            "Number Forms": function NumberForms(t) {
              return t >= 8528 && t <= 8591;
            },
            "Miscellaneous Technical": function MiscellaneousTechnical(t) {
              return t >= 8960 && t <= 9215;
            },
            "Control Pictures": function ControlPictures(t) {
              return t >= 9216 && t <= 9279;
            },
            "Optical Character Recognition": function OpticalCharacterRecognition(t) {
              return t >= 9280 && t <= 9311;
            },
            "Enclosed Alphanumerics": function EnclosedAlphanumerics(t) {
              return t >= 9312 && t <= 9471;
            },
            "Geometric Shapes": function GeometricShapes(t) {
              return t >= 9632 && t <= 9727;
            },
            "Miscellaneous Symbols": function MiscellaneousSymbols(t) {
              return t >= 9728 && t <= 9983;
            },
            "Miscellaneous Symbols and Arrows": function MiscellaneousSymbolsAndArrows(t) {
              return t >= 11008 && t <= 11263;
            },
            "CJK Radicals Supplement": function CJKRadicalsSupplement(t) {
              return t >= 11904 && t <= 12031;
            },
            "Kangxi Radicals": function KangxiRadicals(t) {
              return t >= 12032 && t <= 12255;
            },
            "Ideographic Description Characters": function IdeographicDescriptionCharacters(t) {
              return t >= 12272 && t <= 12287;
            },
            "CJK Symbols and Punctuation": function CJKSymbolsAndPunctuation(t) {
              return t >= 12288 && t <= 12351;
            },
            Hiragana: function Hiragana(t) {
              return t >= 12352 && t <= 12447;
            },
            Katakana: function Katakana(t) {
              return t >= 12448 && t <= 12543;
            },
            Bopomofo: function Bopomofo(t) {
              return t >= 12544 && t <= 12591;
            },
            "Hangul Compatibility Jamo": function HangulCompatibilityJamo(t) {
              return t >= 12592 && t <= 12687;
            },
            Kanbun: function Kanbun(t) {
              return t >= 12688 && t <= 12703;
            },
            "Bopomofo Extended": function BopomofoExtended(t) {
              return t >= 12704 && t <= 12735;
            },
            "CJK Strokes": function CJKStrokes(t) {
              return t >= 12736 && t <= 12783;
            },
            "Katakana Phonetic Extensions": function KatakanaPhoneticExtensions(t) {
              return t >= 12784 && t <= 12799;
            },
            "Enclosed CJK Letters and Months": function EnclosedCJKLettersAndMonths(t) {
              return t >= 12800 && t <= 13055;
            },
            "CJK Compatibility": function CJKCompatibility(t) {
              return t >= 13056 && t <= 13311;
            },
            "CJK Unified Ideographs Extension A": function CJKUnifiedIdeographsExtensionA(t) {
              return t >= 13312 && t <= 19903;
            },
            "Yijing Hexagram Symbols": function YijingHexagramSymbols(t) {
              return t >= 19904 && t <= 19967;
            },
            "CJK Unified Ideographs": function CJKUnifiedIdeographs(t) {
              return t >= 19968 && t <= 40959;
            },
            "Yi Syllables": function YiSyllables(t) {
              return t >= 40960 && t <= 42127;
            },
            "Yi Radicals": function YiRadicals(t) {
              return t >= 42128 && t <= 42191;
            },
            "Hangul Jamo Extended-A": function HangulJamoExtendedA(t) {
              return t >= 43360 && t <= 43391;
            },
            "Hangul Syllables": function HangulSyllables(t) {
              return t >= 44032 && t <= 55215;
            },
            "Hangul Jamo Extended-B": function HangulJamoExtendedB(t) {
              return t >= 55216 && t <= 55295;
            },
            "Private Use Area": function PrivateUseArea(t) {
              return t >= 57344 && t <= 63743;
            },
            "CJK Compatibility Ideographs": function CJKCompatibilityIdeographs(t) {
              return t >= 63744 && t <= 64255;
            },
            "Arabic Presentation Forms-A": function ArabicPresentationFormsA(t) {
              return t >= 64336 && t <= 65023;
            },
            "Vertical Forms": function VerticalForms(t) {
              return t >= 65040 && t <= 65055;
            },
            "CJK Compatibility Forms": function CJKCompatibilityForms(t) {
              return t >= 65072 && t <= 65103;
            },
            "Small Form Variants": function SmallFormVariants(t) {
              return t >= 65104 && t <= 65135;
            },
            "Arabic Presentation Forms-B": function ArabicPresentationFormsB(t) {
              return t >= 65136 && t <= 65279;
            },
            "Halfwidth and Fullwidth Forms": function HalfwidthAndFullwidthForms(t) {
              return t >= 65280 && t <= 65519;
            }
          };

          function Wn(t) {
            for (var e = 0, r = t; e < r.length; e += 1) {
              if (Zn(r[e].charCodeAt(0))) return !0;
            }

            return !1;
          }

          function Xn(t) {
            return !Yn.Arabic(t) && !Yn["Arabic Supplement"](t) && !Yn["Arabic Extended-A"](t) && !Yn["Arabic Presentation Forms-A"](t) && !Yn["Arabic Presentation Forms-B"](t);
          }

          function Zn(t) {
            return 746 === t || 747 === t || !(t < 4352) && (!!Yn["Bopomofo Extended"](t) || !!Yn.Bopomofo(t) || !(!Yn["CJK Compatibility Forms"](t) || t >= 65097 && t <= 65103) || !!Yn["CJK Compatibility Ideographs"](t) || !!Yn["CJK Compatibility"](t) || !!Yn["CJK Radicals Supplement"](t) || !!Yn["CJK Strokes"](t) || !(!Yn["CJK Symbols and Punctuation"](t) || t >= 12296 && t <= 12305 || t >= 12308 && t <= 12319 || 12336 === t) || !!Yn["CJK Unified Ideographs Extension A"](t) || !!Yn["CJK Unified Ideographs"](t) || !!Yn["Enclosed CJK Letters and Months"](t) || !!Yn["Hangul Compatibility Jamo"](t) || !!Yn["Hangul Jamo Extended-A"](t) || !!Yn["Hangul Jamo Extended-B"](t) || !!Yn["Hangul Jamo"](t) || !!Yn["Hangul Syllables"](t) || !!Yn.Hiragana(t) || !!Yn["Ideographic Description Characters"](t) || !!Yn.Kanbun(t) || !!Yn["Kangxi Radicals"](t) || !!Yn["Katakana Phonetic Extensions"](t) || !(!Yn.Katakana(t) || 12540 === t) || !(!Yn["Halfwidth and Fullwidth Forms"](t) || 65288 === t || 65289 === t || 65293 === t || t >= 65306 && t <= 65310 || 65339 === t || 65341 === t || 65343 === t || t >= 65371 && t <= 65503 || 65507 === t || t >= 65512 && t <= 65519) || !(!Yn["Small Form Variants"](t) || t >= 65112 && t <= 65118 || t >= 65123 && t <= 65126) || !!Yn["Unified Canadian Aboriginal Syllabics"](t) || !!Yn["Unified Canadian Aboriginal Syllabics Extended"](t) || !!Yn["Vertical Forms"](t) || !!Yn["Yijing Hexagram Symbols"](t) || !!Yn["Yi Syllables"](t) || !!Yn["Yi Radicals"](t));
          }

          function Jn(t) {
            return !(Zn(t) || function (t) {
              return !(!Yn["Latin-1 Supplement"](t) || 167 !== t && 169 !== t && 174 !== t && 177 !== t && 188 !== t && 189 !== t && 190 !== t && 215 !== t && 247 !== t) || !(!Yn["General Punctuation"](t) || 8214 !== t && 8224 !== t && 8225 !== t && 8240 !== t && 8241 !== t && 8251 !== t && 8252 !== t && 8258 !== t && 8263 !== t && 8264 !== t && 8265 !== t && 8273 !== t) || !!Yn["Letterlike Symbols"](t) || !!Yn["Number Forms"](t) || !(!Yn["Miscellaneous Technical"](t) || !(t >= 8960 && t <= 8967 || t >= 8972 && t <= 8991 || t >= 8996 && t <= 9e3 || 9003 === t || t >= 9085 && t <= 9114 || t >= 9150 && t <= 9165 || 9167 === t || t >= 9169 && t <= 9179 || t >= 9186 && t <= 9215)) || !(!Yn["Control Pictures"](t) || 9251 === t) || !!Yn["Optical Character Recognition"](t) || !!Yn["Enclosed Alphanumerics"](t) || !!Yn["Geometric Shapes"](t) || !(!Yn["Miscellaneous Symbols"](t) || t >= 9754 && t <= 9759) || !(!Yn["Miscellaneous Symbols and Arrows"](t) || !(t >= 11026 && t <= 11055 || t >= 11088 && t <= 11097 || t >= 11192 && t <= 11243)) || !!Yn["CJK Symbols and Punctuation"](t) || !!Yn.Katakana(t) || !!Yn["Private Use Area"](t) || !!Yn["CJK Compatibility Forms"](t) || !!Yn["Small Form Variants"](t) || !!Yn["Halfwidth and Fullwidth Forms"](t) || 8734 === t || 8756 === t || 8757 === t || t >= 9984 && t <= 10087 || t >= 10102 && t <= 10131 || 65532 === t || 65533 === t;
            }(t));
          }

          function Kn(t) {
            return t >= 1424 && t <= 2303 || Yn["Arabic Presentation Forms-A"](t) || Yn["Arabic Presentation Forms-B"](t);
          }

          function Qn(t, e) {
            return !(!e && Kn(t)) && !(t >= 2304 && t <= 3583 || t >= 3840 && t <= 4255 || Yn.Khmer(t));
          }

          function $n(t) {
            for (var e = 0, r = t; e < r.length; e += 1) {
              if (Kn(r[e].charCodeAt(0))) return !0;
            }

            return !1;
          }

          var ti = "deferred",
              ei = "loading",
              ri = "loaded",
              ni = "error",
              ii = null,
              ai = "unavailable",
              oi = null,
              si = function si(t) {
            t && "string" == typeof t && t.indexOf("NetworkError") > -1 && (ai = ni), ii && ii(t);
          };

          function li() {
            ci.fire(new At("pluginStateChange", {
              pluginStatus: ai,
              pluginURL: oi
            }));
          }

          var ci = new Et(),
              ui = function ui() {
            return ai;
          },
              fi = function fi() {
            if (ai !== ti || !oi) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
            ai = ei, li(), oi && xt({
              url: oi
            }, function (t) {
              t ? si(t) : (ai = ri, li());
            });
          },
              hi = {
            applyArabicShaping: null,
            processBidirectionalText: null,
            processStyledBidirectionalText: null,
            isLoaded: function isLoaded() {
              return ai === ri || null != hi.applyArabicShaping;
            },
            isLoading: function isLoading() {
              return ai === ei;
            },
            setState: function setState(t) {
              ai = t.pluginStatus, oi = t.pluginURL;
            },
            isParsed: function isParsed() {
              return null != hi.applyArabicShaping && null != hi.processBidirectionalText && null != hi.processStyledBidirectionalText;
            },
            getPluginURL: function getPluginURL() {
              return oi;
            }
          },
              pi = function pi(t, e) {
            this.zoom = t, e ? (this.now = e.now, this.fadeDuration = e.fadeDuration, this.zoomHistory = e.zoomHistory, this.transition = e.transition) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new Gn(), this.transition = {});
          };

          pi.prototype.isSupportedScript = function (t) {
            return function (t, e) {
              for (var r = 0, n = t; r < n.length; r += 1) {
                if (!Qn(n[r].charCodeAt(0), e)) return !1;
              }

              return !0;
            }(t, hi.isLoaded());
          }, pi.prototype.crossFadingFactor = function () {
            return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
          }, pi.prototype.getCrossfadeParameters = function () {
            var t = this.zoom,
                e = t - Math.floor(t),
                r = this.crossFadingFactor();
            return t > this.zoomHistory.lastIntegerZoom ? {
              fromScale: 2,
              toScale: 1,
              t: e + (1 - e) * r
            } : {
              fromScale: .5,
              toScale: 1,
              t: 1 - (1 - r) * e
            };
          };

          var di = function di(t, e) {
            this.property = t, this.value = e, this.expression = function (t, e) {
              if (Br(t)) return new Kr(t, e);

              if (Yr(t)) {
                var r = Jr(t, e);
                if ("error" === r.result) throw new Error(r.value.map(function (t) {
                  return t.key + ": " + t.message;
                }).join(", "));
                return r.value;
              }

              var n = t;
              return "string" == typeof t && "color" === e.type && (n = te.parse(t)), {
                kind: "constant",
                evaluate: function evaluate() {
                  return n;
                }
              };
            }(void 0 === e ? t.specification.default : e, t.specification);
          };

          di.prototype.isDataDriven = function () {
            return "source" === this.expression.kind || "composite" === this.expression.kind;
          }, di.prototype.possiblyEvaluate = function (t, e, r) {
            return this.property.possiblyEvaluate(this, t, e, r);
          };

          var mi = function mi(t) {
            this.property = t, this.value = new di(t, void 0);
          };

          mi.prototype.transitioned = function (t, e) {
            return new vi(this.property, this.value, e, u({}, t.transition, this.transition), t.now);
          }, mi.prototype.untransitioned = function () {
            return new vi(this.property, this.value, null, {}, 0);
          };

          var gi = function gi(t) {
            this._properties = t, this._values = Object.create(t.defaultTransitionablePropertyValues);
          };

          gi.prototype.getValue = function (t) {
            return x(this._values[t].value.value);
          }, gi.prototype.setValue = function (t, e) {
            this._values.hasOwnProperty(t) || (this._values[t] = new mi(this._values[t].property)), this._values[t].value = new di(this._values[t].property, null === e ? void 0 : x(e));
          }, gi.prototype.getTransition = function (t) {
            return x(this._values[t].transition);
          }, gi.prototype.setTransition = function (t, e) {
            this._values.hasOwnProperty(t) || (this._values[t] = new mi(this._values[t].property)), this._values[t].transition = x(e) || void 0;
          }, gi.prototype.serialize = function () {
            for (var t = {}, e = 0, r = Object.keys(this._values); e < r.length; e += 1) {
              var n = r[e],
                  i = this.getValue(n);
              void 0 !== i && (t[n] = i);
              var a = this.getTransition(n);
              void 0 !== a && (t[n + "-transition"] = a);
            }

            return t;
          }, gi.prototype.transitioned = function (t, e) {
            for (var r = new yi(this._properties), n = 0, i = Object.keys(this._values); n < i.length; n += 1) {
              var a = i[n];
              r._values[a] = this._values[a].transitioned(t, e._values[a]);
            }

            return r;
          }, gi.prototype.untransitioned = function () {
            for (var t = new yi(this._properties), e = 0, r = Object.keys(this._values); e < r.length; e += 1) {
              var n = r[e];
              t._values[n] = this._values[n].untransitioned();
            }

            return t;
          };

          var vi = function vi(t, e, r, n, i) {
            this.property = t, this.value = e, this.begin = i + n.delay || 0, this.end = this.begin + n.duration || 0, t.specification.transition && (n.delay || n.duration) && (this.prior = r);
          };

          vi.prototype.possiblyEvaluate = function (t, e, r) {
            var n = t.now || 0,
                i = this.value.possiblyEvaluate(t, e, r),
                a = this.prior;

            if (a) {
              if (n > this.end) return this.prior = null, i;
              if (this.value.isDataDriven()) return this.prior = null, i;
              if (n < this.begin) return a.possiblyEvaluate(t, e, r);
              var o = (n - this.begin) / (this.end - this.begin);
              return this.property.interpolate(a.possiblyEvaluate(t, e, r), i, function (t) {
                if (t <= 0) return 0;
                if (t >= 1) return 1;
                var e = t * t,
                    r = e * t;
                return 4 * (t < .5 ? r : 3 * (t - e) + r - .75);
              }(o));
            }

            return i;
          };

          var yi = function yi(t) {
            this._properties = t, this._values = Object.create(t.defaultTransitioningPropertyValues);
          };

          yi.prototype.possiblyEvaluate = function (t, e, r) {
            for (var n = new _i(this._properties), i = 0, a = Object.keys(this._values); i < a.length; i += 1) {
              var o = a[i];
              n._values[o] = this._values[o].possiblyEvaluate(t, e, r);
            }

            return n;
          }, yi.prototype.hasTransition = function () {
            for (var t = 0, e = Object.keys(this._values); t < e.length; t += 1) {
              var r = e[t];
              if (this._values[r].prior) return !0;
            }

            return !1;
          };

          var xi = function xi(t) {
            this._properties = t, this._values = Object.create(t.defaultPropertyValues);
          };

          xi.prototype.getValue = function (t) {
            return x(this._values[t].value);
          }, xi.prototype.setValue = function (t, e) {
            this._values[t] = new di(this._values[t].property, null === e ? void 0 : x(e));
          }, xi.prototype.serialize = function () {
            for (var t = {}, e = 0, r = Object.keys(this._values); e < r.length; e += 1) {
              var n = r[e],
                  i = this.getValue(n);
              void 0 !== i && (t[n] = i);
            }

            return t;
          }, xi.prototype.possiblyEvaluate = function (t, e, r) {
            for (var n = new _i(this._properties), i = 0, a = Object.keys(this._values); i < a.length; i += 1) {
              var o = a[i];
              n._values[o] = this._values[o].possiblyEvaluate(t, e, r);
            }

            return n;
          };

          var bi = function bi(t, e, r) {
            this.property = t, this.value = e, this.parameters = r;
          };

          bi.prototype.isConstant = function () {
            return "constant" === this.value.kind;
          }, bi.prototype.constantOr = function (t) {
            return "constant" === this.value.kind ? this.value.value : t;
          }, bi.prototype.evaluate = function (t, e, r, n) {
            return this.property.evaluate(this.value, this.parameters, t, e, r, n);
          };

          var _i = function _i(t) {
            this._properties = t, this._values = Object.create(t.defaultPossiblyEvaluatedValues);
          };

          _i.prototype.get = function (t) {
            return this._values[t];
          };

          var wi = function wi(t) {
            this.specification = t;
          };

          wi.prototype.possiblyEvaluate = function (t, e) {
            return t.expression.evaluate(e);
          }, wi.prototype.interpolate = function (t, e, r) {
            var n = Ge[this.specification.type];
            return n ? n(t, e, r) : t;
          };

          var Ti = function Ti(t, e) {
            this.specification = t, this.overrides = e;
          };

          Ti.prototype.possiblyEvaluate = function (t, e, r, n) {
            return "constant" === t.expression.kind || "camera" === t.expression.kind ? new bi(this, {
              kind: "constant",
              value: t.expression.evaluate(e, null, {}, r, n)
            }, e) : new bi(this, t.expression, e);
          }, Ti.prototype.interpolate = function (t, e, r) {
            if ("constant" !== t.value.kind || "constant" !== e.value.kind) return t;
            if (void 0 === t.value.value || void 0 === e.value.value) return new bi(this, {
              kind: "constant",
              value: void 0
            }, t.parameters);
            var n = Ge[this.specification.type];
            return n ? new bi(this, {
              kind: "constant",
              value: n(t.value.value, e.value.value, r)
            }, t.parameters) : t;
          }, Ti.prototype.evaluate = function (t, e, r, n, i, a) {
            return "constant" === t.kind ? t.value : t.evaluate(e, r, n, i, a);
          };

          var ki = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.possiblyEvaluate = function (t, e, r, n) {
              if (void 0 === t.value) return new bi(this, {
                kind: "constant",
                value: void 0
              }, e);

              if ("constant" === t.expression.kind) {
                var i = t.expression.evaluate(e, null, {}, r, n),
                    a = "resolvedImage" === t.property.specification.type && "string" != typeof i ? i.name : i,
                    o = this._calculate(a, a, a, e);

                return new bi(this, {
                  kind: "constant",
                  value: o
                }, e);
              }

              if ("camera" === t.expression.kind) {
                var s = this._calculate(t.expression.evaluate({
                  zoom: e.zoom - 1
                }), t.expression.evaluate({
                  zoom: e.zoom
                }), t.expression.evaluate({
                  zoom: e.zoom + 1
                }), e);

                return new bi(this, {
                  kind: "constant",
                  value: s
                }, e);
              }

              return new bi(this, t.expression, e);
            }, e.prototype.evaluate = function (t, e, r, n, i, a) {
              if ("source" === t.kind) {
                var o = t.evaluate(e, r, n, i, a);
                return this._calculate(o, o, o, e);
              }

              return "composite" === t.kind ? this._calculate(t.evaluate({
                zoom: Math.floor(e.zoom) - 1
              }, r, n), t.evaluate({
                zoom: Math.floor(e.zoom)
              }, r, n), t.evaluate({
                zoom: Math.floor(e.zoom) + 1
              }, r, n), e) : t.value;
            }, e.prototype._calculate = function (t, e, r, n) {
              return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                from: t,
                to: e
              } : {
                from: r,
                to: e
              };
            }, e.prototype.interpolate = function (t) {
              return t;
            }, e;
          }(Ti),
              Mi = function Mi(t) {
            this.specification = t;
          };

          Mi.prototype.possiblyEvaluate = function (t, e, r, n) {
            if (void 0 !== t.value) {
              if ("constant" === t.expression.kind) {
                var i = t.expression.evaluate(e, null, {}, r, n);
                return this._calculate(i, i, i, e);
              }

              return this._calculate(t.expression.evaluate(new pi(Math.floor(e.zoom - 1), e)), t.expression.evaluate(new pi(Math.floor(e.zoom), e)), t.expression.evaluate(new pi(Math.floor(e.zoom + 1), e)), e);
            }
          }, Mi.prototype._calculate = function (t, e, r, n) {
            return n.zoom > n.zoomHistory.lastIntegerZoom ? {
              from: t,
              to: e
            } : {
              from: r,
              to: e
            };
          }, Mi.prototype.interpolate = function (t) {
            return t;
          };

          var Ai = function Ai(t) {
            this.specification = t;
          };

          Ai.prototype.possiblyEvaluate = function (t, e, r, n) {
            return !!t.expression.evaluate(e, null, {}, r, n);
          }, Ai.prototype.interpolate = function () {
            return !1;
          };

          var Si = function Si(t) {
            for (var e in this.properties = t, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [], t) {
              var r = t[e];
              r.specification.overridable && this.overridableProperties.push(e);
              var n = this.defaultPropertyValues[e] = new di(r, void 0),
                  i = this.defaultTransitionablePropertyValues[e] = new mi(r);
              this.defaultTransitioningPropertyValues[e] = i.untransitioned(), this.defaultPossiblyEvaluatedValues[e] = n.possiblyEvaluate({});
            }
          };

          Nn("DataDrivenProperty", Ti), Nn("DataConstantProperty", wi), Nn("CrossFadedDataDrivenProperty", ki), Nn("CrossFadedProperty", Mi), Nn("ColorRampProperty", Ai);

          var Ei = function (t) {
            function e(e, r) {
              if (t.call(this), this.id = e.id, this.type = e.type, this._featureFilter = {
                filter: function filter() {
                  return !0;
                },
                needGeometry: !1
              }, "custom" !== e.type && (e = e, this.metadata = e.metadata, this.minzoom = e.minzoom, this.maxzoom = e.maxzoom, "background" !== e.type && (this.source = e.source, this.sourceLayer = e["source-layer"], this.filter = e.filter), r.layout && (this._unevaluatedLayout = new xi(r.layout)), r.paint)) {
                for (var n in this._transitionablePaint = new gi(r.paint), e.paint) {
                  this.setPaintProperty(n, e.paint[n], {
                    validate: !1
                  });
                }

                for (var i in e.layout) {
                  this.setLayoutProperty(i, e.layout[i], {
                    validate: !1
                  });
                }

                this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new _i(r.paint);
              }
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getCrossfadeParameters = function () {
              return this._crossfadeParameters;
            }, e.prototype.getLayoutProperty = function (t) {
              return "visibility" === t ? this.visibility : this._unevaluatedLayout.getValue(t);
            }, e.prototype.setLayoutProperty = function (t, e, r) {
              if (void 0 === r && (r = {}), null != e) {
                var n = "layers." + this.id + ".layout." + t;
                if (this._validate(In, n, t, e, r)) return;
              }

              "visibility" !== t ? this._unevaluatedLayout.setValue(t, e) : this.visibility = e;
            }, e.prototype.getPaintProperty = function (t) {
              return g(t, "-transition") ? this._transitionablePaint.getTransition(t.slice(0, -"-transition".length)) : this._transitionablePaint.getValue(t);
            }, e.prototype.setPaintProperty = function (t, e, r) {
              if (void 0 === r && (r = {}), null != e) {
                var n = "layers." + this.id + ".paint." + t;
                if (this._validate(Pn, n, t, e, r)) return !1;
              }

              if (g(t, "-transition")) return this._transitionablePaint.setTransition(t.slice(0, -"-transition".length), e || void 0), !1;
              var i = this._transitionablePaint._values[t],
                  a = "cross-faded-data-driven" === i.property.specification["property-type"],
                  o = i.value.isDataDriven(),
                  s = i.value;
              this._transitionablePaint.setValue(t, e), this._handleSpecialPaintPropertyUpdate(t);
              var l = this._transitionablePaint._values[t].value;
              return l.isDataDriven() || o || a || this._handleOverridablePaintPropertyUpdate(t, s, l);
            }, e.prototype._handleSpecialPaintPropertyUpdate = function (t) {}, e.prototype._handleOverridablePaintPropertyUpdate = function (t, e, r) {
              return !1;
            }, e.prototype.isHidden = function (t) {
              return !!(this.minzoom && t < this.minzoom) || !!(this.maxzoom && t >= this.maxzoom) || "none" === this.visibility;
            }, e.prototype.updateTransitions = function (t) {
              this._transitioningPaint = this._transitionablePaint.transitioned(t, this._transitioningPaint);
            }, e.prototype.hasTransition = function () {
              return this._transitioningPaint.hasTransition();
            }, e.prototype.recalculate = function (t, e) {
              t.getCrossfadeParameters && (this._crossfadeParameters = t.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t, void 0, e)), this.paint = this._transitioningPaint.possiblyEvaluate(t, void 0, e);
            }, e.prototype.serialize = function () {
              var t = {
                id: this.id,
                type: this.type,
                source: this.source,
                "source-layer": this.sourceLayer,
                metadata: this.metadata,
                minzoom: this.minzoom,
                maxzoom: this.maxzoom,
                filter: this.filter,
                layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                paint: this._transitionablePaint && this._transitionablePaint.serialize()
              };
              return this.visibility && (t.layout = t.layout || {}, t.layout.visibility = this.visibility), y(t, function (t, e) {
                return !(void 0 === t || "layout" === e && !Object.keys(t).length || "paint" === e && !Object.keys(t).length);
              });
            }, e.prototype._validate = function (t, e, r, n, i) {
              return void 0 === i && (i = {}), (!i || !1 !== i.validate) && On(this, t.call(Ln, {
                key: e,
                layerType: this.type,
                objectKey: r,
                value: n,
                styleSpec: Lt,
                style: {
                  glyphs: !0,
                  sprite: !0
                }
              }));
            }, e.prototype.is3D = function () {
              return !1;
            }, e.prototype.isTileClipped = function () {
              return !1;
            }, e.prototype.hasOffscreenPass = function () {
              return !1;
            }, e.prototype.resize = function () {}, e.prototype.isStateDependent = function () {
              for (var t in this.paint._values) {
                var e = this.paint.get(t);
                if (e instanceof bi && zr(e.property.specification) && ("source" === e.value.kind || "composite" === e.value.kind) && e.value.isStateDependent) return !0;
              }

              return !1;
            }, e;
          }(Et),
              Li = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
          },
              Ci = function Ci(t, e) {
            this._structArray = t, this._pos1 = e * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
          },
              Pi = function Pi() {
            this.isTransferred = !1, this.capacity = -1, this.resize(0);
          };

          function Ii(t, e) {
            void 0 === e && (e = 1);
            var r = 0,
                n = 0;
            return {
              members: t.map(function (t) {
                var i,
                    a = (i = t.type, Li[i].BYTES_PER_ELEMENT),
                    o = r = Oi(r, Math.max(e, a)),
                    s = t.components || 1;
                return n = Math.max(n, a), r += a * s, {
                  name: t.name,
                  type: t.type,
                  components: s,
                  offset: o
                };
              }),
              size: Oi(r, Math.max(n, e)),
              alignment: e
            };
          }

          function Oi(t, e) {
            return Math.ceil(t / e) * e;
          }

          Pi.serialize = function (t, e) {
            return t._trim(), e && (t.isTransferred = !0, e.push(t.arrayBuffer)), {
              length: t.length,
              arrayBuffer: t.arrayBuffer
            };
          }, Pi.deserialize = function (t) {
            var e = Object.create(this.prototype);
            return e.arrayBuffer = t.arrayBuffer, e.length = t.length, e.capacity = t.arrayBuffer.byteLength / e.bytesPerElement, e._refreshViews(), e;
          }, Pi.prototype._trim = function () {
            this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
          }, Pi.prototype.clear = function () {
            this.length = 0;
          }, Pi.prototype.resize = function (t) {
            this.reserve(t), this.length = t;
          }, Pi.prototype.reserve = function (t) {
            if (t > this.capacity) {
              this.capacity = Math.max(t, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
              var e = this.uint8;
              this._refreshViews(), e && this.uint8.set(e);
            }
          }, Pi.prototype._refreshViews = function () {
            throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
          };

          var zi = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._refreshViews = function () {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }, e.prototype.emplaceBack = function (t, e) {
              var r = this.length;
              return this.resize(r + 1), this.emplace(r, t, e);
            }, e.prototype.emplace = function (t, e, r) {
              var n = 2 * t;
              return this.int16[n + 0] = e, this.int16[n + 1] = r, t;
            }, e;
          }(Pi);

          zi.prototype.bytesPerElement = 4, Nn("StructArrayLayout2i4", zi);

          var Di = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._refreshViews = function () {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }, e.prototype.emplaceBack = function (t, e, r, n) {
              var i = this.length;
              return this.resize(i + 1), this.emplace(i, t, e, r, n);
            }, e.prototype.emplace = function (t, e, r, n, i) {
              var a = 4 * t;
              return this.int16[a + 0] = e, this.int16[a + 1] = r, this.int16[a + 2] = n, this.int16[a + 3] = i, t;
            }, e;
          }(Pi);

          Di.prototype.bytesPerElement = 8, Nn("StructArrayLayout4i8", Di);

          var Ri = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._refreshViews = function () {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }, e.prototype.emplaceBack = function (t, e, r, n, i, a) {
              var o = this.length;
              return this.resize(o + 1), this.emplace(o, t, e, r, n, i, a);
            }, e.prototype.emplace = function (t, e, r, n, i, a, o) {
              var s = 6 * t;
              return this.int16[s + 0] = e, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, this.int16[s + 4] = a, this.int16[s + 5] = o, t;
            }, e;
          }(Pi);

          Ri.prototype.bytesPerElement = 12, Nn("StructArrayLayout2i4i12", Ri);

          var Fi = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._refreshViews = function () {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }, e.prototype.emplaceBack = function (t, e, r, n, i, a) {
              var o = this.length;
              return this.resize(o + 1), this.emplace(o, t, e, r, n, i, a);
            }, e.prototype.emplace = function (t, e, r, n, i, a, o) {
              var s = 4 * t,
                  l = 8 * t;
              return this.int16[s + 0] = e, this.int16[s + 1] = r, this.uint8[l + 4] = n, this.uint8[l + 5] = i, this.uint8[l + 6] = a, this.uint8[l + 7] = o, t;
            }, e;
          }(Pi);

          Fi.prototype.bytesPerElement = 8, Nn("StructArrayLayout2i4ub8", Fi);

          var Bi = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._refreshViews = function () {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }, e.prototype.emplaceBack = function (t, e, r, n, i, a, o, s, l, c) {
              var u = this.length;
              return this.resize(u + 1), this.emplace(u, t, e, r, n, i, a, o, s, l, c);
            }, e.prototype.emplace = function (t, e, r, n, i, a, o, s, l, c, u) {
              var f = 9 * t,
                  h = 18 * t;
              return this.uint16[f + 0] = e, this.uint16[f + 1] = r, this.uint16[f + 2] = n, this.uint16[f + 3] = i, this.uint16[f + 4] = a, this.uint16[f + 5] = o, this.uint16[f + 6] = s, this.uint16[f + 7] = l, this.uint8[h + 16] = c, this.uint8[h + 17] = u, t;
            }, e;
          }(Pi);

          Bi.prototype.bytesPerElement = 18, Nn("StructArrayLayout8ui2ub18", Bi);

          var Ni = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._refreshViews = function () {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }, e.prototype.emplaceBack = function (t, e, r, n, i, a, o, s, l, c, u, f) {
              var h = this.length;
              return this.resize(h + 1), this.emplace(h, t, e, r, n, i, a, o, s, l, c, u, f);
            }, e.prototype.emplace = function (t, e, r, n, i, a, o, s, l, c, u, f, h) {
              var p = 12 * t;
              return this.int16[p + 0] = e, this.int16[p + 1] = r, this.int16[p + 2] = n, this.int16[p + 3] = i, this.uint16[p + 4] = a, this.uint16[p + 5] = o, this.uint16[p + 6] = s, this.uint16[p + 7] = l, this.int16[p + 8] = c, this.int16[p + 9] = u, this.int16[p + 10] = f, this.int16[p + 11] = h, t;
            }, e;
          }(Pi);

          Ni.prototype.bytesPerElement = 24, Nn("StructArrayLayout4i4ui4i24", Ni);

          var ji = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._refreshViews = function () {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }, e.prototype.emplaceBack = function (t, e, r) {
              var n = this.length;
              return this.resize(n + 1), this.emplace(n, t, e, r);
            }, e.prototype.emplace = function (t, e, r, n) {
              var i = 3 * t;
              return this.float32[i + 0] = e, this.float32[i + 1] = r, this.float32[i + 2] = n, t;
            }, e;
          }(Pi);

          ji.prototype.bytesPerElement = 12, Nn("StructArrayLayout3f12", ji);

          var Ui = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._refreshViews = function () {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }, e.prototype.emplaceBack = function (t) {
              var e = this.length;
              return this.resize(e + 1), this.emplace(e, t);
            }, e.prototype.emplace = function (t, e) {
              var r = 1 * t;
              return this.uint32[r + 0] = e, t;
            }, e;
          }(Pi);

          Ui.prototype.bytesPerElement = 4, Nn("StructArrayLayout1ul4", Ui);

          var Vi = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._refreshViews = function () {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }, e.prototype.emplaceBack = function (t, e, r, n, i, a, o, s, l) {
              var c = this.length;
              return this.resize(c + 1), this.emplace(c, t, e, r, n, i, a, o, s, l);
            }, e.prototype.emplace = function (t, e, r, n, i, a, o, s, l, c) {
              var u = 10 * t,
                  f = 5 * t;
              return this.int16[u + 0] = e, this.int16[u + 1] = r, this.int16[u + 2] = n, this.int16[u + 3] = i, this.int16[u + 4] = a, this.int16[u + 5] = o, this.uint32[f + 3] = s, this.uint16[u + 8] = l, this.uint16[u + 9] = c, t;
            }, e;
          }(Pi);

          Vi.prototype.bytesPerElement = 20, Nn("StructArrayLayout6i1ul2ui20", Vi);

          var qi = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._refreshViews = function () {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }, e.prototype.emplaceBack = function (t, e, r, n, i, a) {
              var o = this.length;
              return this.resize(o + 1), this.emplace(o, t, e, r, n, i, a);
            }, e.prototype.emplace = function (t, e, r, n, i, a, o) {
              var s = 6 * t;
              return this.int16[s + 0] = e, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, this.int16[s + 4] = a, this.int16[s + 5] = o, t;
            }, e;
          }(Pi);

          qi.prototype.bytesPerElement = 12, Nn("StructArrayLayout2i2i2i12", qi);

          var Hi = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._refreshViews = function () {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }, e.prototype.emplaceBack = function (t, e, r, n, i) {
              var a = this.length;
              return this.resize(a + 1), this.emplace(a, t, e, r, n, i);
            }, e.prototype.emplace = function (t, e, r, n, i, a) {
              var o = 4 * t,
                  s = 8 * t;
              return this.float32[o + 0] = e, this.float32[o + 1] = r, this.float32[o + 2] = n, this.int16[s + 6] = i, this.int16[s + 7] = a, t;
            }, e;
          }(Pi);

          Hi.prototype.bytesPerElement = 16, Nn("StructArrayLayout2f1f2i16", Hi);

          var Gi = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._refreshViews = function () {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }, e.prototype.emplaceBack = function (t, e, r, n) {
              var i = this.length;
              return this.resize(i + 1), this.emplace(i, t, e, r, n);
            }, e.prototype.emplace = function (t, e, r, n, i) {
              var a = 12 * t,
                  o = 3 * t;
              return this.uint8[a + 0] = e, this.uint8[a + 1] = r, this.float32[o + 1] = n, this.float32[o + 2] = i, t;
            }, e;
          }(Pi);

          Gi.prototype.bytesPerElement = 12, Nn("StructArrayLayout2ub2f12", Gi);

          var Yi = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._refreshViews = function () {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }, e.prototype.emplaceBack = function (t, e, r) {
              var n = this.length;
              return this.resize(n + 1), this.emplace(n, t, e, r);
            }, e.prototype.emplace = function (t, e, r, n) {
              var i = 3 * t;
              return this.uint16[i + 0] = e, this.uint16[i + 1] = r, this.uint16[i + 2] = n, t;
            }, e;
          }(Pi);

          Yi.prototype.bytesPerElement = 6, Nn("StructArrayLayout3ui6", Yi);

          var Wi = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._refreshViews = function () {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }, e.prototype.emplaceBack = function (t, e, r, n, i, a, o, s, l, c, u, f, h, p, d, m, g) {
              var v = this.length;
              return this.resize(v + 1), this.emplace(v, t, e, r, n, i, a, o, s, l, c, u, f, h, p, d, m, g);
            }, e.prototype.emplace = function (t, e, r, n, i, a, o, s, l, c, u, f, h, p, d, m, g, v) {
              var y = 24 * t,
                  x = 12 * t,
                  b = 48 * t;
              return this.int16[y + 0] = e, this.int16[y + 1] = r, this.uint16[y + 2] = n, this.uint16[y + 3] = i, this.uint32[x + 2] = a, this.uint32[x + 3] = o, this.uint32[x + 4] = s, this.uint16[y + 10] = l, this.uint16[y + 11] = c, this.uint16[y + 12] = u, this.float32[x + 7] = f, this.float32[x + 8] = h, this.uint8[b + 36] = p, this.uint8[b + 37] = d, this.uint8[b + 38] = m, this.uint32[x + 10] = g, this.int16[y + 22] = v, t;
            }, e;
          }(Pi);

          Wi.prototype.bytesPerElement = 48, Nn("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", Wi);

          var Xi = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._refreshViews = function () {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }, e.prototype.emplaceBack = function (t, e, r, n, i, a, o, s, l, c, u, f, h, p, d, m, g, v, y, x, b, _, w, T, k, M, A, S) {
              var E = this.length;
              return this.resize(E + 1), this.emplace(E, t, e, r, n, i, a, o, s, l, c, u, f, h, p, d, m, g, v, y, x, b, _, w, T, k, M, A, S);
            }, e.prototype.emplace = function (t, e, r, n, i, a, o, s, l, c, u, f, h, p, d, m, g, v, y, x, b, _, w, T, k, M, A, S, E) {
              var L = 34 * t,
                  C = 17 * t;
              return this.int16[L + 0] = e, this.int16[L + 1] = r, this.int16[L + 2] = n, this.int16[L + 3] = i, this.int16[L + 4] = a, this.int16[L + 5] = o, this.int16[L + 6] = s, this.int16[L + 7] = l, this.uint16[L + 8] = c, this.uint16[L + 9] = u, this.uint16[L + 10] = f, this.uint16[L + 11] = h, this.uint16[L + 12] = p, this.uint16[L + 13] = d, this.uint16[L + 14] = m, this.uint16[L + 15] = g, this.uint16[L + 16] = v, this.uint16[L + 17] = y, this.uint16[L + 18] = x, this.uint16[L + 19] = b, this.uint16[L + 20] = _, this.uint16[L + 21] = w, this.uint16[L + 22] = T, this.uint32[C + 12] = k, this.float32[C + 13] = M, this.float32[C + 14] = A, this.float32[C + 15] = S, this.float32[C + 16] = E, t;
            }, e;
          }(Pi);

          Xi.prototype.bytesPerElement = 68, Nn("StructArrayLayout8i15ui1ul4f68", Xi);

          var Zi = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._refreshViews = function () {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }, e.prototype.emplaceBack = function (t) {
              var e = this.length;
              return this.resize(e + 1), this.emplace(e, t);
            }, e.prototype.emplace = function (t, e) {
              var r = 1 * t;
              return this.float32[r + 0] = e, t;
            }, e;
          }(Pi);

          Zi.prototype.bytesPerElement = 4, Nn("StructArrayLayout1f4", Zi);

          var Ji = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._refreshViews = function () {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }, e.prototype.emplaceBack = function (t, e, r) {
              var n = this.length;
              return this.resize(n + 1), this.emplace(n, t, e, r);
            }, e.prototype.emplace = function (t, e, r, n) {
              var i = 3 * t;
              return this.int16[i + 0] = e, this.int16[i + 1] = r, this.int16[i + 2] = n, t;
            }, e;
          }(Pi);

          Ji.prototype.bytesPerElement = 6, Nn("StructArrayLayout3i6", Ji);

          var Ki = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._refreshViews = function () {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }, e.prototype.emplaceBack = function (t, e, r) {
              var n = this.length;
              return this.resize(n + 1), this.emplace(n, t, e, r);
            }, e.prototype.emplace = function (t, e, r, n) {
              var i = 2 * t,
                  a = 4 * t;
              return this.uint32[i + 0] = e, this.uint16[a + 2] = r, this.uint16[a + 3] = n, t;
            }, e;
          }(Pi);

          Ki.prototype.bytesPerElement = 8, Nn("StructArrayLayout1ul2ui8", Ki);

          var Qi = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._refreshViews = function () {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }, e.prototype.emplaceBack = function (t, e) {
              var r = this.length;
              return this.resize(r + 1), this.emplace(r, t, e);
            }, e.prototype.emplace = function (t, e, r) {
              var n = 2 * t;
              return this.uint16[n + 0] = e, this.uint16[n + 1] = r, t;
            }, e;
          }(Pi);

          Qi.prototype.bytesPerElement = 4, Nn("StructArrayLayout2ui4", Qi);

          var $i = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._refreshViews = function () {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }, e.prototype.emplaceBack = function (t) {
              var e = this.length;
              return this.resize(e + 1), this.emplace(e, t);
            }, e.prototype.emplace = function (t, e) {
              var r = 1 * t;
              return this.uint16[r + 0] = e, t;
            }, e;
          }(Pi);

          $i.prototype.bytesPerElement = 2, Nn("StructArrayLayout1ui2", $i);

          var ta = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._refreshViews = function () {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }, e.prototype.emplaceBack = function (t, e) {
              var r = this.length;
              return this.resize(r + 1), this.emplace(r, t, e);
            }, e.prototype.emplace = function (t, e, r) {
              var n = 2 * t;
              return this.float32[n + 0] = e, this.float32[n + 1] = r, t;
            }, e;
          }(Pi);

          ta.prototype.bytesPerElement = 8, Nn("StructArrayLayout2f8", ta);

          var ea = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._refreshViews = function () {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }, e.prototype.emplaceBack = function (t, e, r, n) {
              var i = this.length;
              return this.resize(i + 1), this.emplace(i, t, e, r, n);
            }, e.prototype.emplace = function (t, e, r, n, i) {
              var a = 4 * t;
              return this.float32[a + 0] = e, this.float32[a + 1] = r, this.float32[a + 2] = n, this.float32[a + 3] = i, t;
            }, e;
          }(Pi);

          ea.prototype.bytesPerElement = 16, Nn("StructArrayLayout4f16", ea);

          var ra = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
            var r = {
              anchorPointX: {
                configurable: !0
              },
              anchorPointY: {
                configurable: !0
              },
              x1: {
                configurable: !0
              },
              y1: {
                configurable: !0
              },
              x2: {
                configurable: !0
              },
              y2: {
                configurable: !0
              },
              featureIndex: {
                configurable: !0
              },
              sourceLayerIndex: {
                configurable: !0
              },
              bucketIndex: {
                configurable: !0
              },
              anchorPoint: {
                configurable: !0
              }
            };
            return r.anchorPointX.get = function () {
              return this._structArray.int16[this._pos2 + 0];
            }, r.anchorPointY.get = function () {
              return this._structArray.int16[this._pos2 + 1];
            }, r.x1.get = function () {
              return this._structArray.int16[this._pos2 + 2];
            }, r.y1.get = function () {
              return this._structArray.int16[this._pos2 + 3];
            }, r.x2.get = function () {
              return this._structArray.int16[this._pos2 + 4];
            }, r.y2.get = function () {
              return this._structArray.int16[this._pos2 + 5];
            }, r.featureIndex.get = function () {
              return this._structArray.uint32[this._pos4 + 3];
            }, r.sourceLayerIndex.get = function () {
              return this._structArray.uint16[this._pos2 + 8];
            }, r.bucketIndex.get = function () {
              return this._structArray.uint16[this._pos2 + 9];
            }, r.anchorPoint.get = function () {
              return new i(this.anchorPointX, this.anchorPointY);
            }, Object.defineProperties(e.prototype, r), e;
          }(Ci);

          ra.prototype.size = 20;

          var na = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function (t) {
              return new ra(this, t);
            }, e;
          }(Vi);

          Nn("CollisionBoxArray", na);

          var ia = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
            var r = {
              anchorX: {
                configurable: !0
              },
              anchorY: {
                configurable: !0
              },
              glyphStartIndex: {
                configurable: !0
              },
              numGlyphs: {
                configurable: !0
              },
              vertexStartIndex: {
                configurable: !0
              },
              lineStartIndex: {
                configurable: !0
              },
              lineLength: {
                configurable: !0
              },
              segment: {
                configurable: !0
              },
              lowerSize: {
                configurable: !0
              },
              upperSize: {
                configurable: !0
              },
              lineOffsetX: {
                configurable: !0
              },
              lineOffsetY: {
                configurable: !0
              },
              writingMode: {
                configurable: !0
              },
              placedOrientation: {
                configurable: !0
              },
              hidden: {
                configurable: !0
              },
              crossTileID: {
                configurable: !0
              },
              associatedIconIndex: {
                configurable: !0
              }
            };
            return r.anchorX.get = function () {
              return this._structArray.int16[this._pos2 + 0];
            }, r.anchorY.get = function () {
              return this._structArray.int16[this._pos2 + 1];
            }, r.glyphStartIndex.get = function () {
              return this._structArray.uint16[this._pos2 + 2];
            }, r.numGlyphs.get = function () {
              return this._structArray.uint16[this._pos2 + 3];
            }, r.vertexStartIndex.get = function () {
              return this._structArray.uint32[this._pos4 + 2];
            }, r.lineStartIndex.get = function () {
              return this._structArray.uint32[this._pos4 + 3];
            }, r.lineLength.get = function () {
              return this._structArray.uint32[this._pos4 + 4];
            }, r.segment.get = function () {
              return this._structArray.uint16[this._pos2 + 10];
            }, r.lowerSize.get = function () {
              return this._structArray.uint16[this._pos2 + 11];
            }, r.upperSize.get = function () {
              return this._structArray.uint16[this._pos2 + 12];
            }, r.lineOffsetX.get = function () {
              return this._structArray.float32[this._pos4 + 7];
            }, r.lineOffsetY.get = function () {
              return this._structArray.float32[this._pos4 + 8];
            }, r.writingMode.get = function () {
              return this._structArray.uint8[this._pos1 + 36];
            }, r.placedOrientation.get = function () {
              return this._structArray.uint8[this._pos1 + 37];
            }, r.placedOrientation.set = function (t) {
              this._structArray.uint8[this._pos1 + 37] = t;
            }, r.hidden.get = function () {
              return this._structArray.uint8[this._pos1 + 38];
            }, r.hidden.set = function (t) {
              this._structArray.uint8[this._pos1 + 38] = t;
            }, r.crossTileID.get = function () {
              return this._structArray.uint32[this._pos4 + 10];
            }, r.crossTileID.set = function (t) {
              this._structArray.uint32[this._pos4 + 10] = t;
            }, r.associatedIconIndex.get = function () {
              return this._structArray.int16[this._pos2 + 22];
            }, Object.defineProperties(e.prototype, r), e;
          }(Ci);

          ia.prototype.size = 48;

          var aa = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function (t) {
              return new ia(this, t);
            }, e;
          }(Wi);

          Nn("PlacedSymbolArray", aa);

          var oa = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
            var r = {
              anchorX: {
                configurable: !0
              },
              anchorY: {
                configurable: !0
              },
              rightJustifiedTextSymbolIndex: {
                configurable: !0
              },
              centerJustifiedTextSymbolIndex: {
                configurable: !0
              },
              leftJustifiedTextSymbolIndex: {
                configurable: !0
              },
              verticalPlacedTextSymbolIndex: {
                configurable: !0
              },
              placedIconSymbolIndex: {
                configurable: !0
              },
              verticalPlacedIconSymbolIndex: {
                configurable: !0
              },
              key: {
                configurable: !0
              },
              textBoxStartIndex: {
                configurable: !0
              },
              textBoxEndIndex: {
                configurable: !0
              },
              verticalTextBoxStartIndex: {
                configurable: !0
              },
              verticalTextBoxEndIndex: {
                configurable: !0
              },
              iconBoxStartIndex: {
                configurable: !0
              },
              iconBoxEndIndex: {
                configurable: !0
              },
              verticalIconBoxStartIndex: {
                configurable: !0
              },
              verticalIconBoxEndIndex: {
                configurable: !0
              },
              featureIndex: {
                configurable: !0
              },
              numHorizontalGlyphVertices: {
                configurable: !0
              },
              numVerticalGlyphVertices: {
                configurable: !0
              },
              numIconVertices: {
                configurable: !0
              },
              numVerticalIconVertices: {
                configurable: !0
              },
              useRuntimeCollisionCircles: {
                configurable: !0
              },
              crossTileID: {
                configurable: !0
              },
              textBoxScale: {
                configurable: !0
              },
              textOffset0: {
                configurable: !0
              },
              textOffset1: {
                configurable: !0
              },
              collisionCircleDiameter: {
                configurable: !0
              }
            };
            return r.anchorX.get = function () {
              return this._structArray.int16[this._pos2 + 0];
            }, r.anchorY.get = function () {
              return this._structArray.int16[this._pos2 + 1];
            }, r.rightJustifiedTextSymbolIndex.get = function () {
              return this._structArray.int16[this._pos2 + 2];
            }, r.centerJustifiedTextSymbolIndex.get = function () {
              return this._structArray.int16[this._pos2 + 3];
            }, r.leftJustifiedTextSymbolIndex.get = function () {
              return this._structArray.int16[this._pos2 + 4];
            }, r.verticalPlacedTextSymbolIndex.get = function () {
              return this._structArray.int16[this._pos2 + 5];
            }, r.placedIconSymbolIndex.get = function () {
              return this._structArray.int16[this._pos2 + 6];
            }, r.verticalPlacedIconSymbolIndex.get = function () {
              return this._structArray.int16[this._pos2 + 7];
            }, r.key.get = function () {
              return this._structArray.uint16[this._pos2 + 8];
            }, r.textBoxStartIndex.get = function () {
              return this._structArray.uint16[this._pos2 + 9];
            }, r.textBoxEndIndex.get = function () {
              return this._structArray.uint16[this._pos2 + 10];
            }, r.verticalTextBoxStartIndex.get = function () {
              return this._structArray.uint16[this._pos2 + 11];
            }, r.verticalTextBoxEndIndex.get = function () {
              return this._structArray.uint16[this._pos2 + 12];
            }, r.iconBoxStartIndex.get = function () {
              return this._structArray.uint16[this._pos2 + 13];
            }, r.iconBoxEndIndex.get = function () {
              return this._structArray.uint16[this._pos2 + 14];
            }, r.verticalIconBoxStartIndex.get = function () {
              return this._structArray.uint16[this._pos2 + 15];
            }, r.verticalIconBoxEndIndex.get = function () {
              return this._structArray.uint16[this._pos2 + 16];
            }, r.featureIndex.get = function () {
              return this._structArray.uint16[this._pos2 + 17];
            }, r.numHorizontalGlyphVertices.get = function () {
              return this._structArray.uint16[this._pos2 + 18];
            }, r.numVerticalGlyphVertices.get = function () {
              return this._structArray.uint16[this._pos2 + 19];
            }, r.numIconVertices.get = function () {
              return this._structArray.uint16[this._pos2 + 20];
            }, r.numVerticalIconVertices.get = function () {
              return this._structArray.uint16[this._pos2 + 21];
            }, r.useRuntimeCollisionCircles.get = function () {
              return this._structArray.uint16[this._pos2 + 22];
            }, r.crossTileID.get = function () {
              return this._structArray.uint32[this._pos4 + 12];
            }, r.crossTileID.set = function (t) {
              this._structArray.uint32[this._pos4 + 12] = t;
            }, r.textBoxScale.get = function () {
              return this._structArray.float32[this._pos4 + 13];
            }, r.textOffset0.get = function () {
              return this._structArray.float32[this._pos4 + 14];
            }, r.textOffset1.get = function () {
              return this._structArray.float32[this._pos4 + 15];
            }, r.collisionCircleDiameter.get = function () {
              return this._structArray.float32[this._pos4 + 16];
            }, Object.defineProperties(e.prototype, r), e;
          }(Ci);

          oa.prototype.size = 68;

          var sa = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function (t) {
              return new oa(this, t);
            }, e;
          }(Xi);

          Nn("SymbolInstanceArray", sa);

          var la = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getoffsetX = function (t) {
              return this.float32[1 * t + 0];
            }, e;
          }(Zi);

          Nn("GlyphOffsetArray", la);

          var ca = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getx = function (t) {
              return this.int16[3 * t + 0];
            }, e.prototype.gety = function (t) {
              return this.int16[3 * t + 1];
            }, e.prototype.gettileUnitDistanceFromAnchor = function (t) {
              return this.int16[3 * t + 2];
            }, e;
          }(Ji);

          Nn("SymbolLineVertexArray", ca);

          var ua = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
            var r = {
              featureIndex: {
                configurable: !0
              },
              sourceLayerIndex: {
                configurable: !0
              },
              bucketIndex: {
                configurable: !0
              }
            };
            return r.featureIndex.get = function () {
              return this._structArray.uint32[this._pos4 + 0];
            }, r.sourceLayerIndex.get = function () {
              return this._structArray.uint16[this._pos2 + 2];
            }, r.bucketIndex.get = function () {
              return this._structArray.uint16[this._pos2 + 3];
            }, Object.defineProperties(e.prototype, r), e;
          }(Ci);

          ua.prototype.size = 8;

          var fa = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function (t) {
              return new ua(this, t);
            }, e;
          }(Ki);

          Nn("FeatureIndexArray", fa);

          var ha = Ii([{
            name: "a_pos",
            components: 2,
            type: "Int16"
          }], 4).members,
              pa = function pa(t) {
            void 0 === t && (t = []), this.segments = t;
          };

          function da(t, e) {
            return 256 * (t = l(Math.floor(t), 0, 255)) + (e = l(Math.floor(e), 0, 255));
          }

          pa.prototype.prepareSegment = function (t, e, r, n) {
            var i = this.segments[this.segments.length - 1];
            return t > pa.MAX_VERTEX_ARRAY_LENGTH && _("Max vertices per segment is " + pa.MAX_VERTEX_ARRAY_LENGTH + ": bucket requested " + t), (!i || i.vertexLength + t > pa.MAX_VERTEX_ARRAY_LENGTH || i.sortKey !== n) && (i = {
              vertexOffset: e.length,
              primitiveOffset: r.length,
              vertexLength: 0,
              primitiveLength: 0
            }, void 0 !== n && (i.sortKey = n), this.segments.push(i)), i;
          }, pa.prototype.get = function () {
            return this.segments;
          }, pa.prototype.destroy = function () {
            for (var t = 0, e = this.segments; t < e.length; t += 1) {
              var r = e[t];

              for (var n in r.vaos) {
                r.vaos[n].destroy();
              }
            }
          }, pa.simpleSegment = function (t, e, r, n) {
            return new pa([{
              vertexOffset: t,
              primitiveOffset: e,
              vertexLength: r,
              primitiveLength: n,
              vaos: {},
              sortKey: 0
            }]);
          }, pa.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, Nn("SegmentVector", pa);
          var ma = Ii([{
            name: "a_pattern_from",
            components: 4,
            type: "Uint16"
          }, {
            name: "a_pattern_to",
            components: 4,
            type: "Uint16"
          }, {
            name: "a_pixel_ratio_from",
            components: 1,
            type: "Uint8"
          }, {
            name: "a_pixel_ratio_to",
            components: 1,
            type: "Uint8"
          }]),
              ga = e(function (t) {
            t.exports = function (t, e) {
              var r, n, i, a, o, s, l, c;

              for (r = 3 & t.length, n = t.length - r, i = e, o = 3432918353, s = 461845907, c = 0; c < n;) {
                l = 255 & t.charCodeAt(c) | (255 & t.charCodeAt(++c)) << 8 | (255 & t.charCodeAt(++c)) << 16 | (255 & t.charCodeAt(++c)) << 24, ++c, i = 27492 + (65535 & (a = 5 * (65535 & (i = (i ^= l = (65535 & (l = (l = (65535 & l) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (a >>> 16) & 65535) << 16);
              }

              switch (l = 0, r) {
                case 3:
                  l ^= (255 & t.charCodeAt(c + 2)) << 16;

                case 2:
                  l ^= (255 & t.charCodeAt(c + 1)) << 8;

                case 1:
                  i ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & t.charCodeAt(c))) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295;
              }

              return i ^= t.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
            };
          }),
              va = e(function (t) {
            t.exports = function (t, e) {
              for (var r, n = t.length, i = e ^ n, a = 0; n >= 4;) {
                r = 1540483477 * (65535 & (r = 255 & t.charCodeAt(a) | (255 & t.charCodeAt(++a)) << 8 | (255 & t.charCodeAt(++a)) << 16 | (255 & t.charCodeAt(++a)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), n -= 4, ++a;
              }

              switch (n) {
                case 3:
                  i ^= (255 & t.charCodeAt(a + 2)) << 16;

                case 2:
                  i ^= (255 & t.charCodeAt(a + 1)) << 8;

                case 1:
                  i = 1540483477 * (65535 & (i ^= 255 & t.charCodeAt(a))) + ((1540483477 * (i >>> 16) & 65535) << 16);
              }

              return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
            };
          }),
              ya = ga,
              xa = ga,
              ba = va;
          ya.murmur3 = xa, ya.murmur2 = ba;

          var _a = function _a() {
            this.ids = [], this.positions = [], this.indexed = !1;
          };

          _a.prototype.add = function (t, e, r, n) {
            this.ids.push(Ta(t)), this.positions.push(e, r, n);
          }, _a.prototype.getPositions = function (t) {
            for (var e = Ta(t), r = 0, n = this.ids.length - 1; r < n;) {
              var i = r + n >> 1;
              this.ids[i] >= e ? n = i : r = i + 1;
            }

            for (var a = []; this.ids[r] === e;) {
              var o = this.positions[3 * r],
                  s = this.positions[3 * r + 1],
                  l = this.positions[3 * r + 2];
              a.push({
                index: o,
                start: s,
                end: l
              }), r++;
            }

            return a;
          }, _a.serialize = function (t, e) {
            var r = new Float64Array(t.ids),
                n = new Uint32Array(t.positions);
            return function t(e, r, n, i) {
              for (; n < i;) {
                for (var a = e[n + i >> 1], o = n - 1, s = i + 1;;) {
                  do {
                    o++;
                  } while (e[o] < a);

                  do {
                    s--;
                  } while (e[s] > a);

                  if (o >= s) break;
                  ka(e, o, s), ka(r, 3 * o, 3 * s), ka(r, 3 * o + 1, 3 * s + 1), ka(r, 3 * o + 2, 3 * s + 2);
                }

                s - n < i - s ? (t(e, r, n, s), n = s + 1) : (t(e, r, s + 1, i), i = s);
              }
            }(r, n, 0, r.length - 1), e && e.push(r.buffer, n.buffer), {
              ids: r,
              positions: n
            };
          }, _a.deserialize = function (t) {
            var e = new _a();
            return e.ids = t.ids, e.positions = t.positions, e.indexed = !0, e;
          };
          var wa = Math.pow(2, 53) - 1;

          function Ta(t) {
            var e = +t;
            return !isNaN(e) && e <= wa ? e : ya(String(t));
          }

          function ka(t, e, r) {
            var n = t[e];
            t[e] = t[r], t[r] = n;
          }

          Nn("FeaturePositionMap", _a);

          var Ma = function Ma(t, e) {
            this.gl = t.gl, this.location = e;
          },
              Aa = function (t) {
            function e(e, r) {
              t.call(this, e, r), this.current = 0;
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.set = function (t) {
              this.current !== t && (this.current = t, this.gl.uniform1i(this.location, t));
            }, e;
          }(Ma),
              Sa = function (t) {
            function e(e, r) {
              t.call(this, e, r), this.current = 0;
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.set = function (t) {
              this.current !== t && (this.current = t, this.gl.uniform1f(this.location, t));
            }, e;
          }(Ma),
              Ea = function (t) {
            function e(e, r) {
              t.call(this, e, r), this.current = [0, 0];
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.set = function (t) {
              t[0] === this.current[0] && t[1] === this.current[1] || (this.current = t, this.gl.uniform2f(this.location, t[0], t[1]));
            }, e;
          }(Ma),
              La = function (t) {
            function e(e, r) {
              t.call(this, e, r), this.current = [0, 0, 0];
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.set = function (t) {
              t[0] === this.current[0] && t[1] === this.current[1] && t[2] === this.current[2] || (this.current = t, this.gl.uniform3f(this.location, t[0], t[1], t[2]));
            }, e;
          }(Ma),
              Ca = function (t) {
            function e(e, r) {
              t.call(this, e, r), this.current = [0, 0, 0, 0];
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.set = function (t) {
              t[0] === this.current[0] && t[1] === this.current[1] && t[2] === this.current[2] && t[3] === this.current[3] || (this.current = t, this.gl.uniform4f(this.location, t[0], t[1], t[2], t[3]));
            }, e;
          }(Ma),
              Pa = function (t) {
            function e(e, r) {
              t.call(this, e, r), this.current = te.transparent;
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.set = function (t) {
              t.r === this.current.r && t.g === this.current.g && t.b === this.current.b && t.a === this.current.a || (this.current = t, this.gl.uniform4f(this.location, t.r, t.g, t.b, t.a));
            }, e;
          }(Ma),
              Ia = new Float32Array(16),
              Oa = function (t) {
            function e(e, r) {
              t.call(this, e, r), this.current = Ia;
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.set = function (t) {
              if (t[12] !== this.current[12] || t[0] !== this.current[0]) return this.current = t, void this.gl.uniformMatrix4fv(this.location, !1, t);

              for (var e = 1; e < 16; e++) {
                if (t[e] !== this.current[e]) {
                  this.current = t, this.gl.uniformMatrix4fv(this.location, !1, t);
                  break;
                }
              }
            }, e;
          }(Ma);

          function za(t) {
            return [da(255 * t.r, 255 * t.g), da(255 * t.b, 255 * t.a)];
          }

          var Da = function Da(t, e, r) {
            this.value = t, this.uniformNames = e.map(function (t) {
              return "u_" + t;
            }), this.type = r;
          };

          Da.prototype.setUniform = function (t, e, r) {
            t.set(r.constantOr(this.value));
          }, Da.prototype.getBinding = function (t, e, r) {
            return "color" === this.type ? new Pa(t, e) : new Sa(t, e);
          };

          var Ra = function Ra(t, e) {
            this.uniformNames = e.map(function (t) {
              return "u_" + t;
            }), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
          };

          Ra.prototype.setConstantPatternPositions = function (t, e) {
            this.pixelRatioFrom = e.pixelRatio, this.pixelRatioTo = t.pixelRatio, this.patternFrom = e.tlbr, this.patternTo = t.tlbr;
          }, Ra.prototype.setUniform = function (t, e, r, n) {
            var i = "u_pattern_to" === n ? this.patternTo : "u_pattern_from" === n ? this.patternFrom : "u_pixel_ratio_to" === n ? this.pixelRatioTo : "u_pixel_ratio_from" === n ? this.pixelRatioFrom : null;
            i && t.set(i);
          }, Ra.prototype.getBinding = function (t, e, r) {
            return "u_pattern" === r.substr(0, 9) ? new Ca(t, e) : new Sa(t, e);
          };

          var Fa = function Fa(t, e, r, n) {
            this.expression = t, this.type = r, this.maxValue = 0, this.paintVertexAttributes = e.map(function (t) {
              return {
                name: "a_" + t,
                type: "Float32",
                components: "color" === r ? 2 : 1,
                offset: 0
              };
            }), this.paintVertexArray = new n();
          };

          Fa.prototype.populatePaintArray = function (t, e, r, n, i) {
            var a = this.paintVertexArray.length,
                o = this.expression.evaluate(new pi(0), e, {}, n, [], i);
            this.paintVertexArray.resize(t), this._setPaintValue(a, t, o);
          }, Fa.prototype.updatePaintArray = function (t, e, r, n) {
            var i = this.expression.evaluate({
              zoom: 0
            }, r, n);

            this._setPaintValue(t, e, i);
          }, Fa.prototype._setPaintValue = function (t, e, r) {
            if ("color" === this.type) for (var n = za(r), i = t; i < e; i++) {
              this.paintVertexArray.emplace(i, n[0], n[1]);
            } else {
              for (var a = t; a < e; a++) {
                this.paintVertexArray.emplace(a, r);
              }

              this.maxValue = Math.max(this.maxValue, Math.abs(r));
            }
          }, Fa.prototype.upload = function (t) {
            this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
          }, Fa.prototype.destroy = function () {
            this.paintVertexBuffer && this.paintVertexBuffer.destroy();
          };

          var Ba = function Ba(t, e, r, n, i, a) {
            this.expression = t, this.uniformNames = e.map(function (t) {
              return "u_" + t + "_t";
            }), this.type = r, this.useIntegerZoom = n, this.zoom = i, this.maxValue = 0, this.paintVertexAttributes = e.map(function (t) {
              return {
                name: "a_" + t,
                type: "Float32",
                components: "color" === r ? 4 : 2,
                offset: 0
              };
            }), this.paintVertexArray = new a();
          };

          Ba.prototype.populatePaintArray = function (t, e, r, n, i) {
            var a = this.expression.evaluate(new pi(this.zoom), e, {}, n, [], i),
                o = this.expression.evaluate(new pi(this.zoom + 1), e, {}, n, [], i),
                s = this.paintVertexArray.length;
            this.paintVertexArray.resize(t), this._setPaintValue(s, t, a, o);
          }, Ba.prototype.updatePaintArray = function (t, e, r, n) {
            var i = this.expression.evaluate({
              zoom: this.zoom
            }, r, n),
                a = this.expression.evaluate({
              zoom: this.zoom + 1
            }, r, n);

            this._setPaintValue(t, e, i, a);
          }, Ba.prototype._setPaintValue = function (t, e, r, n) {
            if ("color" === this.type) for (var i = za(r), a = za(n), o = t; o < e; o++) {
              this.paintVertexArray.emplace(o, i[0], i[1], a[0], a[1]);
            } else {
              for (var s = t; s < e; s++) {
                this.paintVertexArray.emplace(s, r, n);
              }

              this.maxValue = Math.max(this.maxValue, Math.abs(r), Math.abs(n));
            }
          }, Ba.prototype.upload = function (t) {
            this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
          }, Ba.prototype.destroy = function () {
            this.paintVertexBuffer && this.paintVertexBuffer.destroy();
          }, Ba.prototype.setUniform = function (t, e) {
            var r = this.useIntegerZoom ? Math.floor(e.zoom) : e.zoom,
                n = l(this.expression.interpolationFactor(r, this.zoom, this.zoom + 1), 0, 1);
            t.set(n);
          }, Ba.prototype.getBinding = function (t, e, r) {
            return new Sa(t, e);
          };

          var Na = function Na(t, e, r, n, i, a) {
            this.expression = t, this.type = e, this.useIntegerZoom = r, this.zoom = n, this.layerId = a, this.zoomInPaintVertexArray = new i(), this.zoomOutPaintVertexArray = new i();
          };

          Na.prototype.populatePaintArray = function (t, e, r) {
            var n = this.zoomInPaintVertexArray.length;
            this.zoomInPaintVertexArray.resize(t), this.zoomOutPaintVertexArray.resize(t), this._setPaintValues(n, t, e.patterns && e.patterns[this.layerId], r);
          }, Na.prototype.updatePaintArray = function (t, e, r, n, i) {
            this._setPaintValues(t, e, r.patterns && r.patterns[this.layerId], i);
          }, Na.prototype._setPaintValues = function (t, e, r, n) {
            if (n && r) {
              var i = r.min,
                  a = r.mid,
                  o = r.max,
                  s = n[i],
                  l = n[a],
                  c = n[o];
              if (s && l && c) for (var u = t; u < e; u++) {
                this.zoomInPaintVertexArray.emplace(u, l.tl[0], l.tl[1], l.br[0], l.br[1], s.tl[0], s.tl[1], s.br[0], s.br[1], l.pixelRatio, s.pixelRatio), this.zoomOutPaintVertexArray.emplace(u, l.tl[0], l.tl[1], l.br[0], l.br[1], c.tl[0], c.tl[1], c.br[0], c.br[1], l.pixelRatio, c.pixelRatio);
              }
            }
          }, Na.prototype.upload = function (t) {
            this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer && (this.zoomInPaintVertexBuffer = t.createVertexBuffer(this.zoomInPaintVertexArray, ma.members, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = t.createVertexBuffer(this.zoomOutPaintVertexArray, ma.members, this.expression.isStateDependent));
          }, Na.prototype.destroy = function () {
            this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
          };

          var ja = function ja(t, e, r, n) {
            this.binders = {}, this.layoutAttributes = n, this._buffers = [];
            var i = [];

            for (var a in t.paint._values) {
              if (r(a)) {
                var o = t.paint.get(a);

                if (o instanceof bi && zr(o.property.specification)) {
                  var s = Va(a, t.type),
                      l = o.value,
                      c = o.property.specification.type,
                      u = o.property.useIntegerZoom,
                      f = o.property.specification["property-type"],
                      h = "cross-faded" === f || "cross-faded-data-driven" === f;
                  if ("constant" === l.kind) this.binders[a] = h ? new Ra(l.value, s) : new Da(l.value, s, c), i.push("/u_" + a);else if ("source" === l.kind || h) {
                    var p = qa(a, c, "source");
                    this.binders[a] = h ? new Na(l, c, u, e, p, t.id) : new Fa(l, s, c, p), i.push("/a_" + a);
                  } else {
                    var d = qa(a, c, "composite");
                    this.binders[a] = new Ba(l, s, c, u, e, d), i.push("/z_" + a);
                  }
                }
              }
            }

            this.cacheKey = i.sort().join("");
          };

          ja.prototype.getMaxValue = function (t) {
            var e = this.binders[t];
            return e instanceof Fa || e instanceof Ba ? e.maxValue : 0;
          }, ja.prototype.populatePaintArrays = function (t, e, r, n, i) {
            for (var a in this.binders) {
              var o = this.binders[a];
              (o instanceof Fa || o instanceof Ba || o instanceof Na) && o.populatePaintArray(t, e, r, n, i);
            }
          }, ja.prototype.setConstantPatternPositions = function (t, e) {
            for (var r in this.binders) {
              var n = this.binders[r];
              n instanceof Ra && n.setConstantPatternPositions(t, e);
            }
          }, ja.prototype.updatePaintArrays = function (t, e, r, n, i) {
            var a = !1;

            for (var o in t) {
              for (var s = 0, l = e.getPositions(o); s < l.length; s += 1) {
                var c = l[s],
                    u = r.feature(c.index);

                for (var f in this.binders) {
                  var h = this.binders[f];

                  if ((h instanceof Fa || h instanceof Ba || h instanceof Na) && !0 === h.expression.isStateDependent) {
                    var p = n.paint.get(f);
                    h.expression = p.value, h.updatePaintArray(c.start, c.end, u, t[o], i), a = !0;
                  }
                }
              }
            }

            return a;
          }, ja.prototype.defines = function () {
            var t = [];

            for (var e in this.binders) {
              var r = this.binders[e];
              (r instanceof Da || r instanceof Ra) && t.push.apply(t, r.uniformNames.map(function (t) {
                return "#define HAS_UNIFORM_" + t;
              }));
            }

            return t;
          }, ja.prototype.getPaintVertexBuffers = function () {
            return this._buffers;
          }, ja.prototype.getUniforms = function (t, e) {
            var r = [];

            for (var n in this.binders) {
              var i = this.binders[n];
              if (i instanceof Da || i instanceof Ra || i instanceof Ba) for (var a = 0, o = i.uniformNames; a < o.length; a += 1) {
                var s = o[a];

                if (e[s]) {
                  var l = i.getBinding(t, e[s], s);
                  r.push({
                    name: s,
                    property: n,
                    binding: l
                  });
                }
              }
            }

            return r;
          }, ja.prototype.setUniforms = function (t, e, r, n) {
            for (var i = 0, a = e; i < a.length; i += 1) {
              var o = a[i],
                  s = o.name,
                  l = o.property,
                  c = o.binding;
              this.binders[l].setUniform(c, n, r.get(l), s);
            }
          }, ja.prototype.updatePaintBuffers = function (t) {
            for (var e in this._buffers = [], this.binders) {
              var r = this.binders[e];

              if (t && r instanceof Na) {
                var n = 2 === t.fromScale ? r.zoomInPaintVertexBuffer : r.zoomOutPaintVertexBuffer;
                n && this._buffers.push(n);
              } else (r instanceof Fa || r instanceof Ba) && r.paintVertexBuffer && this._buffers.push(r.paintVertexBuffer);
            }
          }, ja.prototype.upload = function (t) {
            for (var e in this.binders) {
              var r = this.binders[e];
              (r instanceof Fa || r instanceof Ba || r instanceof Na) && r.upload(t);
            }

            this.updatePaintBuffers();
          }, ja.prototype.destroy = function () {
            for (var t in this.binders) {
              var e = this.binders[t];
              (e instanceof Fa || e instanceof Ba || e instanceof Na) && e.destroy();
            }
          };

          var Ua = function Ua(t, e, r, n) {
            void 0 === n && (n = function n() {
              return !0;
            }), this.programConfigurations = {};

            for (var i = 0, a = e; i < a.length; i += 1) {
              var o = a[i];
              this.programConfigurations[o.id] = new ja(o, r, n, t);
            }

            this.needsUpload = !1, this._featureMap = new _a(), this._bufferOffset = 0;
          };

          function Va(t, e) {
            return {
              "text-opacity": ["opacity"],
              "icon-opacity": ["opacity"],
              "text-color": ["fill_color"],
              "icon-color": ["fill_color"],
              "text-halo-color": ["halo_color"],
              "icon-halo-color": ["halo_color"],
              "text-halo-blur": ["halo_blur"],
              "icon-halo-blur": ["halo_blur"],
              "text-halo-width": ["halo_width"],
              "icon-halo-width": ["halo_width"],
              "line-gap-width": ["gapwidth"],
              "line-pattern": ["pattern_to", "pattern_from", "pixel_ratio_to", "pixel_ratio_from"],
              "fill-pattern": ["pattern_to", "pattern_from", "pixel_ratio_to", "pixel_ratio_from"],
              "fill-extrusion-pattern": ["pattern_to", "pattern_from", "pixel_ratio_to", "pixel_ratio_from"]
            }[t] || [t.replace(e + "-", "").replace(/-/g, "_")];
          }

          function qa(t, e, r) {
            var n = {
              color: {
                source: ta,
                composite: ea
              },
              number: {
                source: Zi,
                composite: ta
              }
            },
                i = function (t) {
              return {
                "line-pattern": {
                  source: Bi,
                  composite: Bi
                },
                "fill-pattern": {
                  source: Bi,
                  composite: Bi
                },
                "fill-extrusion-pattern": {
                  source: Bi,
                  composite: Bi
                }
              }[t];
            }(t);

            return i && i[r] || n[e][r];
          }

          Ua.prototype.populatePaintArrays = function (t, e, r, n, i, a) {
            for (var o in this.programConfigurations) {
              this.programConfigurations[o].populatePaintArrays(t, e, n, i, a);
            }

            void 0 !== e.id && this._featureMap.add(e.id, r, this._bufferOffset, t), this._bufferOffset = t, this.needsUpload = !0;
          }, Ua.prototype.updatePaintArrays = function (t, e, r, n) {
            for (var i = 0, a = r; i < a.length; i += 1) {
              var o = a[i];
              this.needsUpload = this.programConfigurations[o.id].updatePaintArrays(t, this._featureMap, e, o, n) || this.needsUpload;
            }
          }, Ua.prototype.get = function (t) {
            return this.programConfigurations[t];
          }, Ua.prototype.upload = function (t) {
            if (this.needsUpload) {
              for (var e in this.programConfigurations) {
                this.programConfigurations[e].upload(t);
              }

              this.needsUpload = !1;
            }
          }, Ua.prototype.destroy = function () {
            for (var t in this.programConfigurations) {
              this.programConfigurations[t].destroy();
            }
          }, Nn("ConstantBinder", Da), Nn("CrossFadedConstantBinder", Ra), Nn("SourceExpressionBinder", Fa), Nn("CrossFadedCompositeBinder", Na), Nn("CompositeExpressionBinder", Ba), Nn("ProgramConfiguration", ja, {
            omit: ["_buffers"]
          }), Nn("ProgramConfigurationSet", Ua);
          var Ha,
              Ga = (Ha = 15, {
            min: -1 * Math.pow(2, Ha - 1),
            max: Math.pow(2, Ha - 1) - 1
          });

          function Ya(t) {
            for (var e = 8192 / t.extent, r = t.loadGeometry(), n = 0; n < r.length; n++) {
              for (var i = r[n], a = 0; a < i.length; a++) {
                var o = i[a];
                o.x = Math.round(o.x * e), o.y = Math.round(o.y * e), (o.x < Ga.min || o.x > Ga.max || o.y < Ga.min || o.y > Ga.max) && (_("Geometry exceeds allowed extent, reduce your vector tile buffer size"), o.x = l(o.x, Ga.min, Ga.max), o.y = l(o.y, Ga.min, Ga.max));
              }
            }

            return r;
          }

          function Wa(t, e, r, n, i) {
            t.emplaceBack(2 * e + (n + 1) / 2, 2 * r + (i + 1) / 2);
          }

          var Xa = function Xa(t) {
            this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map(function (t) {
              return t.id;
            }), this.index = t.index, this.hasPattern = !1, this.layoutVertexArray = new zi(), this.indexArray = new Yi(), this.segments = new pa(), this.programConfigurations = new Ua(ha, t.layers, t.zoom), this.stateDependentLayerIds = this.layers.filter(function (t) {
              return t.isStateDependent();
            }).map(function (t) {
              return t.id;
            });
          };

          function Za(t, e) {
            for (var r = 0; r < t.length; r++) {
              if (io(e, t[r])) return !0;
            }

            for (var n = 0; n < e.length; n++) {
              if (io(t, e[n])) return !0;
            }

            return !!$a(t, e);
          }

          function Ja(t, e, r) {
            return !!io(t, e) || !!eo(e, t, r);
          }

          function Ka(t, e) {
            if (1 === t.length) return no(e, t[0]);

            for (var r = 0; r < e.length; r++) {
              for (var n = e[r], i = 0; i < n.length; i++) {
                if (io(t, n[i])) return !0;
              }
            }

            for (var a = 0; a < t.length; a++) {
              if (no(e, t[a])) return !0;
            }

            for (var o = 0; o < e.length; o++) {
              if ($a(t, e[o])) return !0;
            }

            return !1;
          }

          function Qa(t, e, r) {
            if (t.length > 1) {
              if ($a(t, e)) return !0;

              for (var n = 0; n < e.length; n++) {
                if (eo(e[n], t, r)) return !0;
              }
            }

            for (var i = 0; i < t.length; i++) {
              if (eo(t[i], e, r)) return !0;
            }

            return !1;
          }

          function $a(t, e) {
            if (0 === t.length || 0 === e.length) return !1;

            for (var r = 0; r < t.length - 1; r++) {
              for (var n = t[r], i = t[r + 1], a = 0; a < e.length - 1; a++) {
                if (to(n, i, e[a], e[a + 1])) return !0;
              }
            }

            return !1;
          }

          function to(t, e, r, n) {
            return w(t, r, n) !== w(e, r, n) && w(t, e, r) !== w(t, e, n);
          }

          function eo(t, e, r) {
            var n = r * r;
            if (1 === e.length) return t.distSqr(e[0]) < n;

            for (var i = 1; i < e.length; i++) {
              if (ro(t, e[i - 1], e[i]) < n) return !0;
            }

            return !1;
          }

          function ro(t, e, r) {
            var n = e.distSqr(r);
            if (0 === n) return t.distSqr(e);
            var i = ((t.x - e.x) * (r.x - e.x) + (t.y - e.y) * (r.y - e.y)) / n;
            return i < 0 ? t.distSqr(e) : i > 1 ? t.distSqr(r) : t.distSqr(r.sub(e)._mult(i)._add(e));
          }

          function no(t, e) {
            for (var r, n, i, a = !1, o = 0; o < t.length; o++) {
              for (var s = 0, l = (r = t[o]).length - 1; s < r.length; l = s++) {
                n = r[s], i = r[l], n.y > e.y != i.y > e.y && e.x < (i.x - n.x) * (e.y - n.y) / (i.y - n.y) + n.x && (a = !a);
              }
            }

            return a;
          }

          function io(t, e) {
            for (var r = !1, n = 0, i = t.length - 1; n < t.length; i = n++) {
              var a = t[n],
                  o = t[i];
              a.y > e.y != o.y > e.y && e.x < (o.x - a.x) * (e.y - a.y) / (o.y - a.y) + a.x && (r = !r);
            }

            return r;
          }

          function ao(t, e, r) {
            var n = r[0],
                i = r[2];
            if (t.x < n.x && e.x < n.x || t.x > i.x && e.x > i.x || t.y < n.y && e.y < n.y || t.y > i.y && e.y > i.y) return !1;
            var a = w(t, e, r[0]);
            return a !== w(t, e, r[1]) || a !== w(t, e, r[2]) || a !== w(t, e, r[3]);
          }

          function oo(t, e, r) {
            var n = e.paint.get(t).value;
            return "constant" === n.kind ? n.value : r.programConfigurations.get(e.id).getMaxValue(t);
          }

          function so(t) {
            return Math.sqrt(t[0] * t[0] + t[1] * t[1]);
          }

          function lo(t, e, r, n, a) {
            if (!e[0] && !e[1]) return t;

            var o = i.convert(e)._mult(a);

            "viewport" === r && o._rotate(-n);

            for (var s = [], l = 0; l < t.length; l++) {
              var c = t[l];
              s.push(c.sub(o));
            }

            return s;
          }

          Xa.prototype.populate = function (t, e, r) {
            var n = this.layers[0],
                i = [],
                a = null;
            "circle" === n.type && (a = n.layout.get("circle-sort-key"));

            for (var o = 0, s = t; o < s.length; o += 1) {
              var l = s[o],
                  c = l.feature,
                  u = l.id,
                  f = l.index,
                  h = l.sourceLayerIndex,
                  p = this.layers[0]._featureFilter.needGeometry,
                  d = {
                type: c.type,
                id: u,
                properties: c.properties,
                geometry: p ? Ya(c) : []
              };

              if (this.layers[0]._featureFilter.filter(new pi(this.zoom), d, r)) {
                p || (d.geometry = Ya(c));
                var m = a ? a.evaluate(d, {}, r) : void 0,
                    g = {
                  id: u,
                  properties: c.properties,
                  type: c.type,
                  sourceLayerIndex: h,
                  index: f,
                  geometry: d.geometry,
                  patterns: {},
                  sortKey: m
                };
                i.push(g);
              }
            }

            a && i.sort(function (t, e) {
              return t.sortKey - e.sortKey;
            });

            for (var v = 0, y = i; v < y.length; v += 1) {
              var x = y[v],
                  b = x,
                  _ = b.geometry,
                  w = b.index,
                  T = b.sourceLayerIndex,
                  k = t[w].feature;
              this.addFeature(x, _, w, r), e.featureIndex.insert(k, _, w, T, this.index);
            }
          }, Xa.prototype.update = function (t, e, r) {
            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e, this.stateDependentLayers, r);
          }, Xa.prototype.isEmpty = function () {
            return 0 === this.layoutVertexArray.length;
          }, Xa.prototype.uploadPending = function () {
            return !this.uploaded || this.programConfigurations.needsUpload;
          }, Xa.prototype.upload = function (t) {
            this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, ha), this.indexBuffer = t.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t), this.uploaded = !0;
          }, Xa.prototype.destroy = function () {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
          }, Xa.prototype.addFeature = function (t, e, r, n) {
            for (var i = 0, a = e; i < a.length; i += 1) {
              for (var o = 0, s = a[i]; o < s.length; o += 1) {
                var l = s[o],
                    c = l.x,
                    u = l.y;

                if (!(c < 0 || c >= 8192 || u < 0 || u >= 8192)) {
                  var f = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, t.sortKey),
                      h = f.vertexLength;
                  Wa(this.layoutVertexArray, c, u, -1, -1), Wa(this.layoutVertexArray, c, u, 1, -1), Wa(this.layoutVertexArray, c, u, 1, 1), Wa(this.layoutVertexArray, c, u, -1, 1), this.indexArray.emplaceBack(h, h + 1, h + 2), this.indexArray.emplaceBack(h, h + 3, h + 2), f.vertexLength += 4, f.primitiveLength += 2;
                }
              }
            }

            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, {}, n);
          }, Nn("CircleBucket", Xa, {
            omit: ["layers"]
          });
          var co = new Si({
            "circle-sort-key": new Ti(Lt.layout_circle["circle-sort-key"])
          }),
              uo = {
            paint: new Si({
              "circle-radius": new Ti(Lt.paint_circle["circle-radius"]),
              "circle-color": new Ti(Lt.paint_circle["circle-color"]),
              "circle-blur": new Ti(Lt.paint_circle["circle-blur"]),
              "circle-opacity": new Ti(Lt.paint_circle["circle-opacity"]),
              "circle-translate": new wi(Lt.paint_circle["circle-translate"]),
              "circle-translate-anchor": new wi(Lt.paint_circle["circle-translate-anchor"]),
              "circle-pitch-scale": new wi(Lt.paint_circle["circle-pitch-scale"]),
              "circle-pitch-alignment": new wi(Lt.paint_circle["circle-pitch-alignment"]),
              "circle-stroke-width": new Ti(Lt.paint_circle["circle-stroke-width"]),
              "circle-stroke-color": new Ti(Lt.paint_circle["circle-stroke-color"]),
              "circle-stroke-opacity": new Ti(Lt.paint_circle["circle-stroke-opacity"])
            }),
            layout: co
          },
              fo = "undefined" != typeof Float32Array ? Float32Array : Array;

          function ho(t) {
            return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
          }

          function po(t, e, r) {
            var n = e[0],
                i = e[1],
                a = e[2],
                o = e[3],
                s = e[4],
                l = e[5],
                c = e[6],
                u = e[7],
                f = e[8],
                h = e[9],
                p = e[10],
                d = e[11],
                m = e[12],
                g = e[13],
                v = e[14],
                y = e[15],
                x = r[0],
                b = r[1],
                _ = r[2],
                w = r[3];
            return t[0] = x * n + b * s + _ * f + w * m, t[1] = x * i + b * l + _ * h + w * g, t[2] = x * a + b * c + _ * p + w * v, t[3] = x * o + b * u + _ * d + w * y, x = r[4], b = r[5], _ = r[6], w = r[7], t[4] = x * n + b * s + _ * f + w * m, t[5] = x * i + b * l + _ * h + w * g, t[6] = x * a + b * c + _ * p + w * v, t[7] = x * o + b * u + _ * d + w * y, x = r[8], b = r[9], _ = r[10], w = r[11], t[8] = x * n + b * s + _ * f + w * m, t[9] = x * i + b * l + _ * h + w * g, t[10] = x * a + b * c + _ * p + w * v, t[11] = x * o + b * u + _ * d + w * y, x = r[12], b = r[13], _ = r[14], w = r[15], t[12] = x * n + b * s + _ * f + w * m, t[13] = x * i + b * l + _ * h + w * g, t[14] = x * a + b * c + _ * p + w * v, t[15] = x * o + b * u + _ * d + w * y, t;
          }

          Math.hypot || (Math.hypot = function () {
            for (var t = arguments, e = 0, r = arguments.length; r--;) {
              e += t[r] * t[r];
            }

            return Math.sqrt(e);
          });
          var mo = po;

          var go,
              vo,
              yo = function yo(t, e, r) {
            return t[0] = e[0] - r[0], t[1] = e[1] - r[1], t[2] = e[2] - r[2], t;
          };

          go = new fo(3), fo != Float32Array && (go[0] = 0, go[1] = 0, go[2] = 0), vo = go;

          function xo(t, e, r) {
            var n = e[0],
                i = e[1],
                a = e[2],
                o = e[3];
            return t[0] = r[0] * n + r[4] * i + r[8] * a + r[12] * o, t[1] = r[1] * n + r[5] * i + r[9] * a + r[13] * o, t[2] = r[2] * n + r[6] * i + r[10] * a + r[14] * o, t[3] = r[3] * n + r[7] * i + r[11] * a + r[15] * o, t;
          }

          !function () {
            var t = function () {
              var t = new fo(4);
              return fo != Float32Array && (t[0] = 0, t[1] = 0, t[2] = 0, t[3] = 0), t;
            }();
          }();

          var bo = function bo(t) {
            var e = t[0],
                r = t[1];
            return e * e + r * r;
          },
              _o = (function () {
            var t = function () {
              var t = new fo(2);
              return fo != Float32Array && (t[0] = 0, t[1] = 0), t;
            }();
          }(), function (t) {
            function e(e) {
              t.call(this, e, uo);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.createBucket = function (t) {
              return new Xa(t);
            }, e.prototype.queryRadius = function (t) {
              var e = t;
              return oo("circle-radius", this, e) + oo("circle-stroke-width", this, e) + so(this.paint.get("circle-translate"));
            }, e.prototype.queryIntersectsFeature = function (t, e, r, n, i, a, o, s) {
              for (var l = lo(t, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), a.angle, o), c = this.paint.get("circle-radius").evaluate(e, r) + this.paint.get("circle-stroke-width").evaluate(e, r), u = "map" === this.paint.get("circle-pitch-alignment"), f = u ? l : function (t, e) {
                return t.map(function (t) {
                  return wo(t, e);
                });
              }(l, s), h = u ? c * o : c, p = 0, d = n; p < d.length; p += 1) {
                for (var m = 0, g = d[p]; m < g.length; m += 1) {
                  var v = g[m],
                      y = u ? v : wo(v, s),
                      x = h,
                      b = xo([], [v.x, v.y, 0, 1], s);
                  if ("viewport" === this.paint.get("circle-pitch-scale") && "map" === this.paint.get("circle-pitch-alignment") ? x *= b[3] / a.cameraToCenterDistance : "map" === this.paint.get("circle-pitch-scale") && "viewport" === this.paint.get("circle-pitch-alignment") && (x *= a.cameraToCenterDistance / b[3]), Ja(f, y, x)) return !0;
                }
              }

              return !1;
            }, e;
          }(Ei));

          function wo(t, e) {
            var r = xo([], [t.x, t.y, 0, 1], e);
            return new i(r[0] / r[3], r[1] / r[3]);
          }

          var To = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
          }(Xa);

          function ko(t, e, r, n) {
            var i = e.width,
                a = e.height;

            if (n) {
              if (n instanceof Uint8ClampedArray) n = new Uint8Array(n.buffer);else if (n.length !== i * a * r) throw new RangeError("mismatched image size");
            } else n = new Uint8Array(i * a * r);

            return t.width = i, t.height = a, t.data = n, t;
          }

          function Mo(t, e, r) {
            var n = e.width,
                i = e.height;

            if (n !== t.width || i !== t.height) {
              var a = ko({}, {
                width: n,
                height: i
              }, r);
              Ao(t, a, {
                x: 0,
                y: 0
              }, {
                x: 0,
                y: 0
              }, {
                width: Math.min(t.width, n),
                height: Math.min(t.height, i)
              }, r), t.width = n, t.height = i, t.data = a.data;
            }
          }

          function Ao(t, e, r, n, i, a) {
            if (0 === i.width || 0 === i.height) return e;
            if (i.width > t.width || i.height > t.height || r.x > t.width - i.width || r.y > t.height - i.height) throw new RangeError("out of range source coordinates for image copy");
            if (i.width > e.width || i.height > e.height || n.x > e.width - i.width || n.y > e.height - i.height) throw new RangeError("out of range destination coordinates for image copy");

            for (var o = t.data, s = e.data, l = 0; l < i.height; l++) {
              for (var c = ((r.y + l) * t.width + r.x) * a, u = ((n.y + l) * e.width + n.x) * a, f = 0; f < i.width * a; f++) {
                s[u + f] = o[c + f];
              }
            }

            return e;
          }

          Nn("HeatmapBucket", To, {
            omit: ["layers"]
          });

          var So = function So(t, e) {
            ko(this, t, 1, e);
          };

          So.prototype.resize = function (t) {
            Mo(this, t, 1);
          }, So.prototype.clone = function () {
            return new So({
              width: this.width,
              height: this.height
            }, new Uint8Array(this.data));
          }, So.copy = function (t, e, r, n, i) {
            Ao(t, e, r, n, i, 1);
          };

          var Eo = function Eo(t, e) {
            ko(this, t, 4, e);
          };

          Eo.prototype.resize = function (t) {
            Mo(this, t, 4);
          }, Eo.prototype.replace = function (t, e) {
            e ? this.data.set(t) : t instanceof Uint8ClampedArray ? this.data = new Uint8Array(t.buffer) : this.data = t;
          }, Eo.prototype.clone = function () {
            return new Eo({
              width: this.width,
              height: this.height
            }, new Uint8Array(this.data));
          }, Eo.copy = function (t, e, r, n, i) {
            Ao(t, e, r, n, i, 4);
          }, Nn("AlphaImage", So), Nn("RGBAImage", Eo);
          var Lo = {
            paint: new Si({
              "heatmap-radius": new Ti(Lt.paint_heatmap["heatmap-radius"]),
              "heatmap-weight": new Ti(Lt.paint_heatmap["heatmap-weight"]),
              "heatmap-intensity": new wi(Lt.paint_heatmap["heatmap-intensity"]),
              "heatmap-color": new Ai(Lt.paint_heatmap["heatmap-color"]),
              "heatmap-opacity": new wi(Lt.paint_heatmap["heatmap-opacity"])
            })
          };

          function Co(t, e) {
            for (var r = new Uint8Array(1024), n = {}, i = 0, a = 0; i < 256; i++, a += 4) {
              n[e] = i / 255;
              var o = t.evaluate(n);
              r[a + 0] = Math.floor(255 * o.r / o.a), r[a + 1] = Math.floor(255 * o.g / o.a), r[a + 2] = Math.floor(255 * o.b / o.a), r[a + 3] = Math.floor(255 * o.a);
            }

            return new Eo({
              width: 256,
              height: 1
            }, r);
          }

          var Po = function (t) {
            function e(e) {
              t.call(this, e, Lo), this._updateColorRamp();
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.createBucket = function (t) {
              return new To(t);
            }, e.prototype._handleSpecialPaintPropertyUpdate = function (t) {
              "heatmap-color" === t && this._updateColorRamp();
            }, e.prototype._updateColorRamp = function () {
              var t = this._transitionablePaint._values["heatmap-color"].value.expression;
              this.colorRamp = Co(t, "heatmapDensity"), this.colorRampTexture = null;
            }, e.prototype.resize = function () {
              this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
            }, e.prototype.queryRadius = function () {
              return 0;
            }, e.prototype.queryIntersectsFeature = function () {
              return !1;
            }, e.prototype.hasOffscreenPass = function () {
              return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
            }, e;
          }(Ei),
              Io = {
            paint: new Si({
              "hillshade-illumination-direction": new wi(Lt.paint_hillshade["hillshade-illumination-direction"]),
              "hillshade-illumination-anchor": new wi(Lt.paint_hillshade["hillshade-illumination-anchor"]),
              "hillshade-exaggeration": new wi(Lt.paint_hillshade["hillshade-exaggeration"]),
              "hillshade-shadow-color": new wi(Lt.paint_hillshade["hillshade-shadow-color"]),
              "hillshade-highlight-color": new wi(Lt.paint_hillshade["hillshade-highlight-color"]),
              "hillshade-accent-color": new wi(Lt.paint_hillshade["hillshade-accent-color"])
            })
          },
              Oo = function (t) {
            function e(e) {
              t.call(this, e, Io);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.hasOffscreenPass = function () {
              return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
            }, e;
          }(Ei),
              zo = Ii([{
            name: "a_pos",
            components: 2,
            type: "Int16"
          }], 4).members,
              Do = Fo,
              Ro = Fo;

          function Fo(t, e, r) {
            r = r || 2;
            var n,
                i,
                a,
                o,
                s,
                l,
                c,
                u = e && e.length,
                f = u ? e[0] * r : t.length,
                h = Bo(t, 0, f, r, !0),
                p = [];
            if (!h || h.next === h.prev) return p;

            if (u && (h = function (t, e, r, n) {
              var i,
                  a,
                  o,
                  s,
                  l,
                  c = [];

              for (i = 0, a = e.length; i < a; i++) {
                o = e[i] * n, s = i < a - 1 ? e[i + 1] * n : t.length, (l = Bo(t, o, s, n, !1)) === l.next && (l.steiner = !0), c.push(Zo(l));
              }

              for (c.sort(Go), i = 0; i < c.length; i++) {
                Yo(c[i], r), r = No(r, r.next);
              }

              return r;
            }(t, e, h, r)), t.length > 80 * r) {
              n = a = t[0], i = o = t[1];

              for (var d = r; d < f; d += r) {
                (s = t[d]) < n && (n = s), (l = t[d + 1]) < i && (i = l), s > a && (a = s), l > o && (o = l);
              }

              c = 0 !== (c = Math.max(a - n, o - i)) ? 1 / c : 0;
            }

            return jo(h, p, r, n, i, c), p;
          }

          function Bo(t, e, r, n, i) {
            var a, o;
            if (i === ls(t, e, r, n) > 0) for (a = e; a < r; a += n) {
              o = as(a, t[a], t[a + 1], o);
            } else for (a = r - n; a >= e; a -= n) {
              o = as(a, t[a], t[a + 1], o);
            }
            return o && $o(o, o.next) && (os(o), o = o.next), o;
          }

          function No(t, e) {
            if (!t) return t;
            e || (e = t);
            var r,
                n = t;

            do {
              if (r = !1, n.steiner || !$o(n, n.next) && 0 !== Qo(n.prev, n, n.next)) n = n.next;else {
                if (os(n), (n = e = n.prev) === n.next) break;
                r = !0;
              }
            } while (r || n !== e);

            return e;
          }

          function jo(t, e, r, n, i, a, o) {
            if (t) {
              !o && a && function (t, e, r, n) {
                var i = t;

                do {
                  null === i.z && (i.z = Xo(i.x, i.y, e, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                } while (i !== t);

                i.prevZ.nextZ = null, i.prevZ = null, function (t) {
                  var e,
                      r,
                      n,
                      i,
                      a,
                      o,
                      s,
                      l,
                      c = 1;

                  do {
                    for (r = t, t = null, a = null, o = 0; r;) {
                      for (o++, n = r, s = 0, e = 0; e < c && (s++, n = n.nextZ); e++) {
                        ;
                      }

                      for (l = c; s > 0 || l > 0 && n;) {
                        0 !== s && (0 === l || !n || r.z <= n.z) ? (i = r, r = r.nextZ, s--) : (i = n, n = n.nextZ, l--), a ? a.nextZ = i : t = i, i.prevZ = a, a = i;
                      }

                      r = n;
                    }

                    a.nextZ = null, c *= 2;
                  } while (o > 1);
                }(i);
              }(t, n, i, a);

              for (var s, l, c = t; t.prev !== t.next;) {
                if (s = t.prev, l = t.next, a ? Vo(t, n, i, a) : Uo(t)) e.push(s.i / r), e.push(t.i / r), e.push(l.i / r), os(t), t = l.next, c = l.next;else if ((t = l) === c) {
                  o ? 1 === o ? jo(t = qo(No(t), e, r), e, r, n, i, a, 2) : 2 === o && Ho(t, e, r, n, i, a) : jo(No(t), e, r, n, i, a, 1);
                  break;
                }
              }
            }
          }

          function Uo(t) {
            var e = t.prev,
                r = t,
                n = t.next;
            if (Qo(e, r, n) >= 0) return !1;

            for (var i = t.next.next; i !== t.prev;) {
              if (Jo(e.x, e.y, r.x, r.y, n.x, n.y, i.x, i.y) && Qo(i.prev, i, i.next) >= 0) return !1;
              i = i.next;
            }

            return !0;
          }

          function Vo(t, e, r, n) {
            var i = t.prev,
                a = t,
                o = t.next;
            if (Qo(i, a, o) >= 0) return !1;

            for (var s = i.x < a.x ? i.x < o.x ? i.x : o.x : a.x < o.x ? a.x : o.x, l = i.y < a.y ? i.y < o.y ? i.y : o.y : a.y < o.y ? a.y : o.y, c = i.x > a.x ? i.x > o.x ? i.x : o.x : a.x > o.x ? a.x : o.x, u = i.y > a.y ? i.y > o.y ? i.y : o.y : a.y > o.y ? a.y : o.y, f = Xo(s, l, e, r, n), h = Xo(c, u, e, r, n), p = t.prevZ, d = t.nextZ; p && p.z >= f && d && d.z <= h;) {
              if (p !== t.prev && p !== t.next && Jo(i.x, i.y, a.x, a.y, o.x, o.y, p.x, p.y) && Qo(p.prev, p, p.next) >= 0) return !1;
              if (p = p.prevZ, d !== t.prev && d !== t.next && Jo(i.x, i.y, a.x, a.y, o.x, o.y, d.x, d.y) && Qo(d.prev, d, d.next) >= 0) return !1;
              d = d.nextZ;
            }

            for (; p && p.z >= f;) {
              if (p !== t.prev && p !== t.next && Jo(i.x, i.y, a.x, a.y, o.x, o.y, p.x, p.y) && Qo(p.prev, p, p.next) >= 0) return !1;
              p = p.prevZ;
            }

            for (; d && d.z <= h;) {
              if (d !== t.prev && d !== t.next && Jo(i.x, i.y, a.x, a.y, o.x, o.y, d.x, d.y) && Qo(d.prev, d, d.next) >= 0) return !1;
              d = d.nextZ;
            }

            return !0;
          }

          function qo(t, e, r) {
            var n = t;

            do {
              var i = n.prev,
                  a = n.next.next;
              !$o(i, a) && ts(i, n, n.next, a) && ns(i, a) && ns(a, i) && (e.push(i.i / r), e.push(n.i / r), e.push(a.i / r), os(n), os(n.next), n = t = a), n = n.next;
            } while (n !== t);

            return No(n);
          }

          function Ho(t, e, r, n, i, a) {
            var o = t;

            do {
              for (var s = o.next.next; s !== o.prev;) {
                if (o.i !== s.i && Ko(o, s)) {
                  var l = is(o, s);
                  return o = No(o, o.next), l = No(l, l.next), jo(o, e, r, n, i, a), void jo(l, e, r, n, i, a);
                }

                s = s.next;
              }

              o = o.next;
            } while (o !== t);
          }

          function Go(t, e) {
            return t.x - e.x;
          }

          function Yo(t, e) {
            if (e = function (t, e) {
              var r,
                  n = e,
                  i = t.x,
                  a = t.y,
                  o = -1 / 0;

              do {
                if (a <= n.y && a >= n.next.y && n.next.y !== n.y) {
                  var s = n.x + (a - n.y) * (n.next.x - n.x) / (n.next.y - n.y);

                  if (s <= i && s > o) {
                    if (o = s, s === i) {
                      if (a === n.y) return n;
                      if (a === n.next.y) return n.next;
                    }

                    r = n.x < n.next.x ? n : n.next;
                  }
                }

                n = n.next;
              } while (n !== e);

              if (!r) return null;
              if (i === o) return r;
              var l,
                  c = r,
                  u = r.x,
                  f = r.y,
                  h = 1 / 0;
              n = r;

              do {
                i >= n.x && n.x >= u && i !== n.x && Jo(a < f ? i : o, a, u, f, a < f ? o : i, a, n.x, n.y) && (l = Math.abs(a - n.y) / (i - n.x), ns(n, t) && (l < h || l === h && (n.x > r.x || n.x === r.x && Wo(r, n))) && (r = n, h = l)), n = n.next;
              } while (n !== c);

              return r;
            }(t, e)) {
              var r = is(e, t);
              No(e, e.next), No(r, r.next);
            }
          }

          function Wo(t, e) {
            return Qo(t.prev, t, e.prev) < 0 && Qo(e.next, t, t.next) < 0;
          }

          function Xo(t, e, r, n, i) {
            return (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = 32767 * (t - r) * i) | t << 8)) | t << 4)) | t << 2)) | t << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = 32767 * (e - n) * i) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
          }

          function Zo(t) {
            var e = t,
                r = t;

            do {
              (e.x < r.x || e.x === r.x && e.y < r.y) && (r = e), e = e.next;
            } while (e !== t);

            return r;
          }

          function Jo(t, e, r, n, i, a, o, s) {
            return (i - o) * (e - s) - (t - o) * (a - s) >= 0 && (t - o) * (n - s) - (r - o) * (e - s) >= 0 && (r - o) * (a - s) - (i - o) * (n - s) >= 0;
          }

          function Ko(t, e) {
            return t.next.i !== e.i && t.prev.i !== e.i && !function (t, e) {
              var r = t;

              do {
                if (r.i !== t.i && r.next.i !== t.i && r.i !== e.i && r.next.i !== e.i && ts(r, r.next, t, e)) return !0;
                r = r.next;
              } while (r !== t);

              return !1;
            }(t, e) && (ns(t, e) && ns(e, t) && function (t, e) {
              var r = t,
                  n = !1,
                  i = (t.x + e.x) / 2,
                  a = (t.y + e.y) / 2;

              do {
                r.y > a != r.next.y > a && r.next.y !== r.y && i < (r.next.x - r.x) * (a - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
              } while (r !== t);

              return n;
            }(t, e) && (Qo(t.prev, t, e.prev) || Qo(t, e.prev, e)) || $o(t, e) && Qo(t.prev, t, t.next) > 0 && Qo(e.prev, e, e.next) > 0);
          }

          function Qo(t, e, r) {
            return (e.y - t.y) * (r.x - e.x) - (e.x - t.x) * (r.y - e.y);
          }

          function $o(t, e) {
            return t.x === e.x && t.y === e.y;
          }

          function ts(t, e, r, n) {
            var i = rs(Qo(t, e, r)),
                a = rs(Qo(t, e, n)),
                o = rs(Qo(r, n, t)),
                s = rs(Qo(r, n, e));
            return i !== a && o !== s || !(0 !== i || !es(t, r, e)) || !(0 !== a || !es(t, n, e)) || !(0 !== o || !es(r, t, n)) || !(0 !== s || !es(r, e, n));
          }

          function es(t, e, r) {
            return e.x <= Math.max(t.x, r.x) && e.x >= Math.min(t.x, r.x) && e.y <= Math.max(t.y, r.y) && e.y >= Math.min(t.y, r.y);
          }

          function rs(t) {
            return t > 0 ? 1 : t < 0 ? -1 : 0;
          }

          function ns(t, e) {
            return Qo(t.prev, t, t.next) < 0 ? Qo(t, e, t.next) >= 0 && Qo(t, t.prev, e) >= 0 : Qo(t, e, t.prev) < 0 || Qo(t, t.next, e) < 0;
          }

          function is(t, e) {
            var r = new ss(t.i, t.x, t.y),
                n = new ss(e.i, e.x, e.y),
                i = t.next,
                a = e.prev;
            return t.next = e, e.prev = t, r.next = i, i.prev = r, n.next = r, r.prev = n, a.next = n, n.prev = a, n;
          }

          function as(t, e, r, n) {
            var i = new ss(t, e, r);
            return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
          }

          function os(t) {
            t.next.prev = t.prev, t.prev.next = t.next, t.prevZ && (t.prevZ.nextZ = t.nextZ), t.nextZ && (t.nextZ.prevZ = t.prevZ);
          }

          function ss(t, e, r) {
            this.i = t, this.x = e, this.y = r, this.prev = null, this.next = null, this.z = null, this.prevZ = null, this.nextZ = null, this.steiner = !1;
          }

          function ls(t, e, r, n) {
            for (var i = 0, a = e, o = r - n; a < r; a += n) {
              i += (t[o] - t[a]) * (t[a + 1] + t[o + 1]), o = a;
            }

            return i;
          }

          function cs(t, e, r, n, i) {
            !function t(e, r, n, i, a) {
              for (; i > n;) {
                if (i - n > 600) {
                  var o = i - n + 1,
                      s = r - n + 1,
                      l = Math.log(o),
                      c = .5 * Math.exp(2 * l / 3),
                      u = .5 * Math.sqrt(l * c * (o - c) / o) * (s - o / 2 < 0 ? -1 : 1),
                      f = Math.max(n, Math.floor(r - s * c / o + u)),
                      h = Math.min(i, Math.floor(r + (o - s) * c / o + u));
                  t(e, r, f, h, a);
                }

                var p = e[r],
                    d = n,
                    m = i;

                for (us(e, n, r), a(e[i], p) > 0 && us(e, n, i); d < m;) {
                  for (us(e, d, m), d++, m--; a(e[d], p) < 0;) {
                    d++;
                  }

                  for (; a(e[m], p) > 0;) {
                    m--;
                  }
                }

                0 === a(e[n], p) ? us(e, n, m) : (m++, us(e, m, i)), m <= r && (n = m + 1), r <= m && (i = m - 1);
              }
            }(t, e, r || 0, n || t.length - 1, i || fs);
          }

          function us(t, e, r) {
            var n = t[e];
            t[e] = t[r], t[r] = n;
          }

          function fs(t, e) {
            return t < e ? -1 : t > e ? 1 : 0;
          }

          function hs(t, e) {
            var r = t.length;
            if (r <= 1) return [t];

            for (var n, i, a = [], o = 0; o < r; o++) {
              var s = T(t[o]);
              0 !== s && (t[o].area = Math.abs(s), void 0 === i && (i = s < 0), i === s < 0 ? (n && a.push(n), n = [t[o]]) : n.push(t[o]));
            }

            if (n && a.push(n), e > 1) for (var l = 0; l < a.length; l++) {
              a[l].length <= e || (cs(a[l], e, 1, a[l].length - 1, ps), a[l] = a[l].slice(0, e));
            }
            return a;
          }

          function ps(t, e) {
            return e.area - t.area;
          }

          function ds(t, e, r) {
            for (var n = r.patternDependencies, i = !1, a = 0, o = e; a < o.length; a += 1) {
              var s = o[a].paint.get(t + "-pattern");
              s.isConstant() || (i = !0);
              var l = s.constantOr(null);
              l && (i = !0, n[l.to] = !0, n[l.from] = !0);
            }

            return i;
          }

          function ms(t, e, r, n, i) {
            for (var a = i.patternDependencies, o = 0, s = e; o < s.length; o += 1) {
              var l = s[o],
                  c = l.paint.get(t + "-pattern").value;

              if ("constant" !== c.kind) {
                var u = c.evaluate({
                  zoom: n - 1
                }, r, {}, i.availableImages),
                    f = c.evaluate({
                  zoom: n
                }, r, {}, i.availableImages),
                    h = c.evaluate({
                  zoom: n + 1
                }, r, {}, i.availableImages);
                u = u && u.name ? u.name : u, f = f && f.name ? f.name : f, h = h && h.name ? h.name : h, a[u] = !0, a[f] = !0, a[h] = !0, r.patterns[l.id] = {
                  min: u,
                  mid: f,
                  max: h
                };
              }
            }

            return r;
          }

          Fo.deviation = function (t, e, r, n) {
            var i = e && e.length,
                a = i ? e[0] * r : t.length,
                o = Math.abs(ls(t, 0, a, r));
            if (i) for (var s = 0, l = e.length; s < l; s++) {
              var c = e[s] * r,
                  u = s < l - 1 ? e[s + 1] * r : t.length;
              o -= Math.abs(ls(t, c, u, r));
            }
            var f = 0;

            for (s = 0; s < n.length; s += 3) {
              var h = n[s] * r,
                  p = n[s + 1] * r,
                  d = n[s + 2] * r;
              f += Math.abs((t[h] - t[d]) * (t[p + 1] - t[h + 1]) - (t[h] - t[p]) * (t[d + 1] - t[h + 1]));
            }

            return 0 === o && 0 === f ? 0 : Math.abs((f - o) / o);
          }, Fo.flatten = function (t) {
            for (var e = t[0][0].length, r = {
              vertices: [],
              holes: [],
              dimensions: e
            }, n = 0, i = 0; i < t.length; i++) {
              for (var a = 0; a < t[i].length; a++) {
                for (var o = 0; o < e; o++) {
                  r.vertices.push(t[i][a][o]);
                }
              }

              i > 0 && (n += t[i - 1].length, r.holes.push(n));
            }

            return r;
          }, Do.default = Ro;

          var gs = function gs(t) {
            this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map(function (t) {
              return t.id;
            }), this.index = t.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new zi(), this.indexArray = new Yi(), this.indexArray2 = new Qi(), this.programConfigurations = new Ua(zo, t.layers, t.zoom), this.segments = new pa(), this.segments2 = new pa(), this.stateDependentLayerIds = this.layers.filter(function (t) {
              return t.isStateDependent();
            }).map(function (t) {
              return t.id;
            });
          };

          gs.prototype.populate = function (t, e, r) {
            this.hasPattern = ds("fill", this.layers, e);

            for (var n = this.layers[0].layout.get("fill-sort-key"), i = [], a = 0, o = t; a < o.length; a += 1) {
              var s = o[a],
                  l = s.feature,
                  c = s.id,
                  u = s.index,
                  f = s.sourceLayerIndex,
                  h = this.layers[0]._featureFilter.needGeometry,
                  p = {
                type: l.type,
                id: c,
                properties: l.properties,
                geometry: h ? Ya(l) : []
              };

              if (this.layers[0]._featureFilter.filter(new pi(this.zoom), p, r)) {
                h || (p.geometry = Ya(l));
                var d = n ? n.evaluate(p, {}, r, e.availableImages) : void 0,
                    m = {
                  id: c,
                  properties: l.properties,
                  type: l.type,
                  sourceLayerIndex: f,
                  index: u,
                  geometry: p.geometry,
                  patterns: {},
                  sortKey: d
                };
                i.push(m);
              }
            }

            n && i.sort(function (t, e) {
              return t.sortKey - e.sortKey;
            });

            for (var g = 0, v = i; g < v.length; g += 1) {
              var y = v[g],
                  x = y,
                  b = x.geometry,
                  _ = x.index,
                  w = x.sourceLayerIndex;

              if (this.hasPattern) {
                var T = ms("fill", this.layers, y, this.zoom, e);
                this.patternFeatures.push(T);
              } else this.addFeature(y, b, _, r, {});

              var k = t[_].feature;
              e.featureIndex.insert(k, b, _, w, this.index);
            }
          }, gs.prototype.update = function (t, e, r) {
            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e, this.stateDependentLayers, r);
          }, gs.prototype.addFeatures = function (t, e, r) {
            for (var n = 0, i = this.patternFeatures; n < i.length; n += 1) {
              var a = i[n];
              this.addFeature(a, a.geometry, a.index, e, r);
            }
          }, gs.prototype.isEmpty = function () {
            return 0 === this.layoutVertexArray.length;
          }, gs.prototype.uploadPending = function () {
            return !this.uploaded || this.programConfigurations.needsUpload;
          }, gs.prototype.upload = function (t) {
            this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, zo), this.indexBuffer = t.createIndexBuffer(this.indexArray), this.indexBuffer2 = t.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t), this.uploaded = !0;
          }, gs.prototype.destroy = function () {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
          }, gs.prototype.addFeature = function (t, e, r, n, i) {
            for (var a = 0, o = hs(e, 500); a < o.length; a += 1) {
              for (var s = o[a], l = 0, c = 0, u = s; c < u.length; c += 1) {
                l += u[c].length;
              }

              for (var f = this.segments.prepareSegment(l, this.layoutVertexArray, this.indexArray), h = f.vertexLength, p = [], d = [], m = 0, g = s; m < g.length; m += 1) {
                var v = g[m];

                if (0 !== v.length) {
                  v !== s[0] && d.push(p.length / 2);
                  var y = this.segments2.prepareSegment(v.length, this.layoutVertexArray, this.indexArray2),
                      x = y.vertexLength;
                  this.layoutVertexArray.emplaceBack(v[0].x, v[0].y), this.indexArray2.emplaceBack(x + v.length - 1, x), p.push(v[0].x), p.push(v[0].y);

                  for (var b = 1; b < v.length; b++) {
                    this.layoutVertexArray.emplaceBack(v[b].x, v[b].y), this.indexArray2.emplaceBack(x + b - 1, x + b), p.push(v[b].x), p.push(v[b].y);
                  }

                  y.vertexLength += v.length, y.primitiveLength += v.length;
                }
              }

              for (var _ = Do(p, d), w = 0; w < _.length; w += 3) {
                this.indexArray.emplaceBack(h + _[w], h + _[w + 1], h + _[w + 2]);
              }

              f.vertexLength += l, f.primitiveLength += _.length / 3;
            }

            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, i, n);
          }, Nn("FillBucket", gs, {
            omit: ["layers", "patternFeatures"]
          });

          var vs = new Si({
            "fill-sort-key": new Ti(Lt.layout_fill["fill-sort-key"])
          }),
              ys = {
            paint: new Si({
              "fill-antialias": new wi(Lt.paint_fill["fill-antialias"]),
              "fill-opacity": new Ti(Lt.paint_fill["fill-opacity"]),
              "fill-color": new Ti(Lt.paint_fill["fill-color"]),
              "fill-outline-color": new Ti(Lt.paint_fill["fill-outline-color"]),
              "fill-translate": new wi(Lt.paint_fill["fill-translate"]),
              "fill-translate-anchor": new wi(Lt.paint_fill["fill-translate-anchor"]),
              "fill-pattern": new ki(Lt.paint_fill["fill-pattern"])
            }),
            layout: vs
          },
              xs = function (t) {
            function e(e) {
              t.call(this, e, ys);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.recalculate = function (e, r) {
              t.prototype.recalculate.call(this, e, r);
              var n = this.paint._values["fill-outline-color"];
              "constant" === n.value.kind && void 0 === n.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
            }, e.prototype.createBucket = function (t) {
              return new gs(t);
            }, e.prototype.queryRadius = function () {
              return so(this.paint.get("fill-translate"));
            }, e.prototype.queryIntersectsFeature = function (t, e, r, n, i, a, o) {
              return Ka(lo(t, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), a.angle, o), n);
            }, e.prototype.isTileClipped = function () {
              return !0;
            }, e;
          }(Ei),
              bs = Ii([{
            name: "a_pos",
            components: 2,
            type: "Int16"
          }, {
            name: "a_normal_ed",
            components: 4,
            type: "Int16"
          }], 4).members,
              _s = ws;

          function ws(t, e, r, n, i) {
            this.properties = {}, this.extent = r, this.type = 0, this._pbf = t, this._geometry = -1, this._keys = n, this._values = i, t.readFields(Ts, this, e);
          }

          function Ts(t, e, r) {
            1 == t ? e.id = r.readVarint() : 2 == t ? function (t, e) {
              var r = t.readVarint() + t.pos;

              for (; t.pos < r;) {
                var n = e._keys[t.readVarint()],
                    i = e._values[t.readVarint()];

                e.properties[n] = i;
              }
            }(r, e) : 3 == t ? e.type = r.readVarint() : 4 == t && (e._geometry = r.pos);
          }

          function ks(t) {
            for (var e, r, n = 0, i = 0, a = t.length, o = a - 1; i < a; o = i++) {
              e = t[i], n += ((r = t[o]).x - e.x) * (e.y + r.y);
            }

            return n;
          }

          ws.types = ["Unknown", "Point", "LineString", "Polygon"], ws.prototype.loadGeometry = function () {
            var t = this._pbf;
            t.pos = this._geometry;

            for (var e, r = t.readVarint() + t.pos, n = 1, a = 0, o = 0, s = 0, l = []; t.pos < r;) {
              if (a <= 0) {
                var c = t.readVarint();
                n = 7 & c, a = c >> 3;
              }

              if (a--, 1 === n || 2 === n) o += t.readSVarint(), s += t.readSVarint(), 1 === n && (e && l.push(e), e = []), e.push(new i(o, s));else {
                if (7 !== n) throw new Error("unknown command " + n);
                e && e.push(e[0].clone());
              }
            }

            return e && l.push(e), l;
          }, ws.prototype.bbox = function () {
            var t = this._pbf;
            t.pos = this._geometry;

            for (var e = t.readVarint() + t.pos, r = 1, n = 0, i = 0, a = 0, o = 1 / 0, s = -1 / 0, l = 1 / 0, c = -1 / 0; t.pos < e;) {
              if (n <= 0) {
                var u = t.readVarint();
                r = 7 & u, n = u >> 3;
              }

              if (n--, 1 === r || 2 === r) (i += t.readSVarint()) < o && (o = i), i > s && (s = i), (a += t.readSVarint()) < l && (l = a), a > c && (c = a);else if (7 !== r) throw new Error("unknown command " + r);
            }

            return [o, l, s, c];
          }, ws.prototype.toGeoJSON = function (t, e, r) {
            var n,
                i,
                a = this.extent * Math.pow(2, r),
                o = this.extent * t,
                s = this.extent * e,
                l = this.loadGeometry(),
                c = ws.types[this.type];

            function u(t) {
              for (var e = 0; e < t.length; e++) {
                var r = t[e],
                    n = 180 - 360 * (r.y + s) / a;
                t[e] = [360 * (r.x + o) / a - 180, 360 / Math.PI * Math.atan(Math.exp(n * Math.PI / 180)) - 90];
              }
            }

            switch (this.type) {
              case 1:
                var f = [];

                for (n = 0; n < l.length; n++) {
                  f[n] = l[n][0];
                }

                u(l = f);
                break;

              case 2:
                for (n = 0; n < l.length; n++) {
                  u(l[n]);
                }

                break;

              case 3:
                for (l = function (t) {
                  var e = t.length;
                  if (e <= 1) return [t];

                  for (var r, n, i = [], a = 0; a < e; a++) {
                    var o = ks(t[a]);
                    0 !== o && (void 0 === n && (n = o < 0), n === o < 0 ? (r && i.push(r), r = [t[a]]) : r.push(t[a]));
                  }

                  r && i.push(r);
                  return i;
                }(l), n = 0; n < l.length; n++) {
                  for (i = 0; i < l[n].length; i++) {
                    u(l[n][i]);
                  }
                }

            }

            1 === l.length ? l = l[0] : c = "Multi" + c;
            var h = {
              type: "Feature",
              geometry: {
                type: c,
                coordinates: l
              },
              properties: this.properties
            };
            return "id" in this && (h.id = this.id), h;
          };
          var Ms = As;

          function As(t, e) {
            this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = t, this._keys = [], this._values = [], this._features = [], t.readFields(Ss, this, e), this.length = this._features.length;
          }

          function Ss(t, e, r) {
            15 === t ? e.version = r.readVarint() : 1 === t ? e.name = r.readString() : 5 === t ? e.extent = r.readVarint() : 2 === t ? e._features.push(r.pos) : 3 === t ? e._keys.push(r.readString()) : 4 === t && e._values.push(function (t) {
              var e = null,
                  r = t.readVarint() + t.pos;

              for (; t.pos < r;) {
                var n = t.readVarint() >> 3;
                e = 1 === n ? t.readString() : 2 === n ? t.readFloat() : 3 === n ? t.readDouble() : 4 === n ? t.readVarint64() : 5 === n ? t.readVarint() : 6 === n ? t.readSVarint() : 7 === n ? t.readBoolean() : null;
              }

              return e;
            }(r));
          }

          function Es(t, e, r) {
            if (3 === t) {
              var n = new Ms(r, r.readVarint() + r.pos);
              n.length && (e[n.name] = n);
            }
          }

          As.prototype.feature = function (t) {
            if (t < 0 || t >= this._features.length) throw new Error("feature index out of bounds");
            this._pbf.pos = this._features[t];

            var e = this._pbf.readVarint() + this._pbf.pos;

            return new _s(this._pbf, e, this.extent, this._keys, this._values);
          };

          var Ls = {
            VectorTile: function VectorTile(t, e) {
              this.layers = t.readFields(Es, {}, e);
            },
            VectorTileFeature: _s,
            VectorTileLayer: Ms
          },
              Cs = Ls.VectorTileFeature.types,
              Ps = Math.pow(2, 13);

          function Is(t, e, r, n, i, a, o, s) {
            t.emplaceBack(e, r, 2 * Math.floor(n * Ps) + o, i * Ps * 2, a * Ps * 2, Math.round(s));
          }

          var Os = function Os(t) {
            this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map(function (t) {
              return t.id;
            }), this.index = t.index, this.hasPattern = !1, this.layoutVertexArray = new Ri(), this.indexArray = new Yi(), this.programConfigurations = new Ua(bs, t.layers, t.zoom), this.segments = new pa(), this.stateDependentLayerIds = this.layers.filter(function (t) {
              return t.isStateDependent();
            }).map(function (t) {
              return t.id;
            });
          };

          function zs(t, e) {
            return t.x === e.x && (t.x < 0 || t.x > 8192) || t.y === e.y && (t.y < 0 || t.y > 8192);
          }

          function Ds(t) {
            return t.every(function (t) {
              return t.x < 0;
            }) || t.every(function (t) {
              return t.x > 8192;
            }) || t.every(function (t) {
              return t.y < 0;
            }) || t.every(function (t) {
              return t.y > 8192;
            });
          }

          Os.prototype.populate = function (t, e, r) {
            this.features = [], this.hasPattern = ds("fill-extrusion", this.layers, e);

            for (var n = 0, i = t; n < i.length; n += 1) {
              var a = i[n],
                  o = a.feature,
                  s = a.id,
                  l = a.index,
                  c = a.sourceLayerIndex,
                  u = this.layers[0]._featureFilter.needGeometry,
                  f = {
                type: o.type,
                id: s,
                properties: o.properties,
                geometry: u ? Ya(o) : []
              };

              if (this.layers[0]._featureFilter.filter(new pi(this.zoom), f, r)) {
                var h = {
                  id: s,
                  sourceLayerIndex: c,
                  index: l,
                  geometry: u ? f.geometry : Ya(o),
                  properties: o.properties,
                  type: o.type,
                  patterns: {}
                };
                void 0 !== o.id && (h.id = o.id), this.hasPattern ? this.features.push(ms("fill-extrusion", this.layers, h, this.zoom, e)) : this.addFeature(h, h.geometry, l, r, {}), e.featureIndex.insert(o, h.geometry, l, c, this.index, !0);
              }
            }
          }, Os.prototype.addFeatures = function (t, e, r) {
            for (var n = 0, i = this.features; n < i.length; n += 1) {
              var a = i[n],
                  o = a.geometry;
              this.addFeature(a, o, a.index, e, r);
            }
          }, Os.prototype.update = function (t, e, r) {
            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e, this.stateDependentLayers, r);
          }, Os.prototype.isEmpty = function () {
            return 0 === this.layoutVertexArray.length;
          }, Os.prototype.uploadPending = function () {
            return !this.uploaded || this.programConfigurations.needsUpload;
          }, Os.prototype.upload = function (t) {
            this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, bs), this.indexBuffer = t.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t), this.uploaded = !0;
          }, Os.prototype.destroy = function () {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
          }, Os.prototype.addFeature = function (t, e, r, n, i) {
            for (var a = 0, o = hs(e, 500); a < o.length; a += 1) {
              for (var s = o[a], l = 0, c = 0, u = s; c < u.length; c += 1) {
                l += u[c].length;
              }

              for (var f = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray), h = 0, p = s; h < p.length; h += 1) {
                var d = p[h];
                if (0 !== d.length && !Ds(d)) for (var m = 0, g = 0; g < d.length; g++) {
                  var v = d[g];

                  if (g >= 1) {
                    var y = d[g - 1];

                    if (!zs(v, y)) {
                      f.vertexLength + 4 > pa.MAX_VERTEX_ARRAY_LENGTH && (f = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));

                      var x = v.sub(y)._perp()._unit(),
                          b = y.dist(v);

                      m + b > 32768 && (m = 0), Is(this.layoutVertexArray, v.x, v.y, x.x, x.y, 0, 0, m), Is(this.layoutVertexArray, v.x, v.y, x.x, x.y, 0, 1, m), m += b, Is(this.layoutVertexArray, y.x, y.y, x.x, x.y, 0, 0, m), Is(this.layoutVertexArray, y.x, y.y, x.x, x.y, 0, 1, m);
                      var _ = f.vertexLength;
                      this.indexArray.emplaceBack(_, _ + 2, _ + 1), this.indexArray.emplaceBack(_ + 1, _ + 2, _ + 3), f.vertexLength += 4, f.primitiveLength += 2;
                    }
                  }
                }
              }

              if (f.vertexLength + l > pa.MAX_VERTEX_ARRAY_LENGTH && (f = this.segments.prepareSegment(l, this.layoutVertexArray, this.indexArray)), "Polygon" === Cs[t.type]) {
                for (var w = [], T = [], k = f.vertexLength, M = 0, A = s; M < A.length; M += 1) {
                  var S = A[M];

                  if (0 !== S.length) {
                    S !== s[0] && T.push(w.length / 2);

                    for (var E = 0; E < S.length; E++) {
                      var L = S[E];
                      Is(this.layoutVertexArray, L.x, L.y, 0, 0, 1, 1, 0), w.push(L.x), w.push(L.y);
                    }
                  }
                }

                for (var C = Do(w, T), P = 0; P < C.length; P += 3) {
                  this.indexArray.emplaceBack(k + C[P], k + C[P + 2], k + C[P + 1]);
                }

                f.primitiveLength += C.length / 3, f.vertexLength += l;
              }
            }

            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, i, n);
          }, Nn("FillExtrusionBucket", Os, {
            omit: ["layers", "features"]
          });

          var Rs = {
            paint: new Si({
              "fill-extrusion-opacity": new wi(Lt["paint_fill-extrusion"]["fill-extrusion-opacity"]),
              "fill-extrusion-color": new Ti(Lt["paint_fill-extrusion"]["fill-extrusion-color"]),
              "fill-extrusion-translate": new wi(Lt["paint_fill-extrusion"]["fill-extrusion-translate"]),
              "fill-extrusion-translate-anchor": new wi(Lt["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
              "fill-extrusion-pattern": new ki(Lt["paint_fill-extrusion"]["fill-extrusion-pattern"]),
              "fill-extrusion-height": new Ti(Lt["paint_fill-extrusion"]["fill-extrusion-height"]),
              "fill-extrusion-base": new Ti(Lt["paint_fill-extrusion"]["fill-extrusion-base"]),
              "fill-extrusion-vertical-gradient": new wi(Lt["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
            })
          },
              Fs = function (t) {
            function e(e) {
              t.call(this, e, Rs);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.createBucket = function (t) {
              return new Os(t);
            }, e.prototype.queryRadius = function () {
              return so(this.paint.get("fill-extrusion-translate"));
            }, e.prototype.is3D = function () {
              return !0;
            }, e.prototype.queryIntersectsFeature = function (t, e, r, n, a, o, s, l) {
              var c = lo(t, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), o.angle, s),
                  u = this.paint.get("fill-extrusion-height").evaluate(e, r),
                  f = this.paint.get("fill-extrusion-base").evaluate(e, r),
                  h = function (t, e, r, n) {
                for (var a = [], o = 0, s = t; o < s.length; o += 1) {
                  var l = s[o],
                      c = [l.x, l.y, n, 1];
                  xo(c, c, e), a.push(new i(c[0] / c[3], c[1] / c[3]));
                }

                return a;
              }(c, l, 0, 0),
                  p = function (t, e, r, n) {
                for (var a = [], o = [], s = n[8] * e, l = n[9] * e, c = n[10] * e, u = n[11] * e, f = n[8] * r, h = n[9] * r, p = n[10] * r, d = n[11] * r, m = 0, g = t; m < g.length; m += 1) {
                  for (var v = g[m], y = [], x = [], b = 0, _ = v; b < _.length; b += 1) {
                    var w = _[b],
                        T = w.x,
                        k = w.y,
                        M = n[0] * T + n[4] * k + n[12],
                        A = n[1] * T + n[5] * k + n[13],
                        S = n[2] * T + n[6] * k + n[14],
                        E = n[3] * T + n[7] * k + n[15],
                        L = S + c,
                        C = E + u,
                        P = M + f,
                        I = A + h,
                        O = S + p,
                        z = E + d,
                        D = new i((M + s) / C, (A + l) / C);
                    D.z = L / C, y.push(D);
                    var R = new i(P / z, I / z);
                    R.z = O / z, x.push(R);
                  }

                  a.push(y), o.push(x);
                }

                return [a, o];
              }(n, f, u, l);

              return function (t, e, r) {
                var n = 1 / 0;
                Ka(r, e) && (n = Ns(r, e[0]));

                for (var i = 0; i < e.length; i++) {
                  for (var a = e[i], o = t[i], s = 0; s < a.length - 1; s++) {
                    var l = a[s],
                        c = a[s + 1],
                        u = o[s],
                        f = o[s + 1],
                        h = [l, c, f, u, l];
                    Za(r, h) && (n = Math.min(n, Ns(r, h)));
                  }
                }

                return n !== 1 / 0 && n;
              }(p[0], p[1], h);
            }, e;
          }(Ei);

          function Bs(t, e) {
            return t.x * e.x + t.y * e.y;
          }

          function Ns(t, e) {
            if (1 === t.length) {
              for (var r, n = 0, i = e[n++]; !r || i.equals(r);) {
                if (!(r = e[n++])) return 1 / 0;
              }

              for (; n < e.length; n++) {
                var a = e[n],
                    o = t[0],
                    s = r.sub(i),
                    l = a.sub(i),
                    c = o.sub(i),
                    u = Bs(s, s),
                    f = Bs(s, l),
                    h = Bs(l, l),
                    p = Bs(c, s),
                    d = Bs(c, l),
                    m = u * h - f * f,
                    g = (h * p - f * d) / m,
                    v = (u * d - f * p) / m,
                    y = 1 - g - v,
                    x = i.z * y + r.z * g + a.z * v;
                if (isFinite(x)) return x;
              }

              return 1 / 0;
            }

            for (var b = 1 / 0, _ = 0, w = e; _ < w.length; _ += 1) {
              var T = w[_];
              b = Math.min(b, T.z);
            }

            return b;
          }

          var js = Ii([{
            name: "a_pos_normal",
            components: 2,
            type: "Int16"
          }, {
            name: "a_data",
            components: 4,
            type: "Uint8"
          }], 4).members,
              Us = Ls.VectorTileFeature.types,
              Vs = Math.cos(Math.PI / 180 * 37.5),
              qs = Math.pow(2, 14) / .5,
              Hs = function Hs(t) {
            this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map(function (t) {
              return t.id;
            }), this.index = t.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new Fi(), this.indexArray = new Yi(), this.programConfigurations = new Ua(js, t.layers, t.zoom), this.segments = new pa(), this.stateDependentLayerIds = this.layers.filter(function (t) {
              return t.isStateDependent();
            }).map(function (t) {
              return t.id;
            });
          };

          Hs.prototype.populate = function (t, e, r) {
            this.hasPattern = ds("line", this.layers, e);

            for (var n = this.layers[0].layout.get("line-sort-key"), i = [], a = 0, o = t; a < o.length; a += 1) {
              var s = o[a],
                  l = s.feature,
                  c = s.id,
                  u = s.index,
                  f = s.sourceLayerIndex,
                  h = this.layers[0]._featureFilter.needGeometry,
                  p = {
                type: l.type,
                id: c,
                properties: l.properties,
                geometry: h ? Ya(l) : []
              };

              if (this.layers[0]._featureFilter.filter(new pi(this.zoom), p, r)) {
                h || (p.geometry = Ya(l));
                var d = n ? n.evaluate(p, {}, r) : void 0,
                    m = {
                  id: c,
                  properties: l.properties,
                  type: l.type,
                  sourceLayerIndex: f,
                  index: u,
                  geometry: p.geometry,
                  patterns: {},
                  sortKey: d
                };
                i.push(m);
              }
            }

            n && i.sort(function (t, e) {
              return t.sortKey - e.sortKey;
            });

            for (var g = 0, v = i; g < v.length; g += 1) {
              var y = v[g],
                  x = y,
                  b = x.geometry,
                  _ = x.index,
                  w = x.sourceLayerIndex;

              if (this.hasPattern) {
                var T = ms("line", this.layers, y, this.zoom, e);
                this.patternFeatures.push(T);
              } else this.addFeature(y, b, _, r, {});

              var k = t[_].feature;
              e.featureIndex.insert(k, b, _, w, this.index);
            }
          }, Hs.prototype.update = function (t, e, r) {
            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e, this.stateDependentLayers, r);
          }, Hs.prototype.addFeatures = function (t, e, r) {
            for (var n = 0, i = this.patternFeatures; n < i.length; n += 1) {
              var a = i[n];
              this.addFeature(a, a.geometry, a.index, e, r);
            }
          }, Hs.prototype.isEmpty = function () {
            return 0 === this.layoutVertexArray.length;
          }, Hs.prototype.uploadPending = function () {
            return !this.uploaded || this.programConfigurations.needsUpload;
          }, Hs.prototype.upload = function (t) {
            this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, js), this.indexBuffer = t.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t), this.uploaded = !0;
          }, Hs.prototype.destroy = function () {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
          }, Hs.prototype.addFeature = function (t, e, r, n, i) {
            for (var a = this.layers[0].layout, o = a.get("line-join").evaluate(t, {}), s = a.get("line-cap"), l = a.get("line-miter-limit"), c = a.get("line-round-limit"), u = 0, f = e; u < f.length; u += 1) {
              var h = f[u];
              this.addLine(h, t, o, s, l, c);
            }

            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, i, n);
          }, Hs.prototype.addLine = function (t, e, r, n, i, a) {
            if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, e.properties && e.properties.hasOwnProperty("mapbox_clip_start") && e.properties.hasOwnProperty("mapbox_clip_end")) {
              this.clipStart = +e.properties.mapbox_clip_start, this.clipEnd = +e.properties.mapbox_clip_end;

              for (var o = 0; o < t.length - 1; o++) {
                this.totalDistance += t[o].dist(t[o + 1]);
              }

              this.updateScaledDistance();
            }

            for (var s = "Polygon" === Us[e.type], l = t.length; l >= 2 && t[l - 1].equals(t[l - 2]);) {
              l--;
            }

            for (var c = 0; c < l - 1 && t[c].equals(t[c + 1]);) {
              c++;
            }

            if (!(l < (s ? 3 : 2))) {
              "bevel" === r && (i = 1.05);
              var u,
                  f = this.overscaling <= 16 ? 122880 / (512 * this.overscaling) : 0,
                  h = this.segments.prepareSegment(10 * l, this.layoutVertexArray, this.indexArray),
                  p = void 0,
                  d = void 0,
                  m = void 0,
                  g = void 0;
              this.e1 = this.e2 = -1, s && (u = t[l - 2], g = t[c].sub(u)._unit()._perp());

              for (var v = c; v < l; v++) {
                if (!(d = v === l - 1 ? s ? t[c + 1] : void 0 : t[v + 1]) || !t[v].equals(d)) {
                  g && (m = g), u && (p = u), u = t[v], g = d ? d.sub(u)._unit()._perp() : m;
                  var y = (m = m || g).add(g);
                  0 === y.x && 0 === y.y || y._unit();

                  var x = m.x * g.x + m.y * g.y,
                      b = y.x * g.x + y.y * g.y,
                      _ = 0 !== b ? 1 / b : 1 / 0,
                      w = 2 * Math.sqrt(2 - 2 * b),
                      T = b < Vs && p && d,
                      k = m.x * g.y - m.y * g.x > 0;

                  if (T && v > c) {
                    var M = u.dist(p);

                    if (M > 2 * f) {
                      var A = u.sub(u.sub(p)._mult(f / M)._round());
                      this.updateDistance(p, A), this.addCurrentVertex(A, m, 0, 0, h), p = A;
                    }
                  }

                  var S = p && d,
                      E = S ? r : s ? "butt" : n;
                  if (S && "round" === E && (_ < a ? E = "miter" : _ <= 2 && (E = "fakeround")), "miter" === E && _ > i && (E = "bevel"), "bevel" === E && (_ > 2 && (E = "flipbevel"), _ < i && (E = "miter")), p && this.updateDistance(p, u), "miter" === E) y._mult(_), this.addCurrentVertex(u, y, 0, 0, h);else if ("flipbevel" === E) {
                    if (_ > 100) y = g.mult(-1);else {
                      var L = _ * m.add(g).mag() / m.sub(g).mag();

                      y._perp()._mult(L * (k ? -1 : 1));
                    }
                    this.addCurrentVertex(u, y, 0, 0, h), this.addCurrentVertex(u, y.mult(-1), 0, 0, h);
                  } else if ("bevel" === E || "fakeround" === E) {
                    var C = -Math.sqrt(_ * _ - 1),
                        P = k ? C : 0,
                        I = k ? 0 : C;
                    if (p && this.addCurrentVertex(u, m, P, I, h), "fakeround" === E) for (var O = Math.round(180 * w / Math.PI / 20), z = 1; z < O; z++) {
                      var D = z / O;

                      if (.5 !== D) {
                        var R = D - .5;
                        D += D * R * (D - 1) * ((1.0904 + x * (x * (3.55645 - 1.43519 * x) - 3.2452)) * R * R + (.848013 + x * (.215638 * x - 1.06021)));
                      }

                      var F = g.sub(m)._mult(D)._add(m)._unit()._mult(k ? -1 : 1);

                      this.addHalfVertex(u, F.x, F.y, !1, k, 0, h);
                    }
                    d && this.addCurrentVertex(u, g, -P, -I, h);
                  } else if ("butt" === E) this.addCurrentVertex(u, y, 0, 0, h);else if ("square" === E) {
                    var B = p ? 1 : -1;
                    this.addCurrentVertex(u, y, B, B, h);
                  } else "round" === E && (p && (this.addCurrentVertex(u, m, 0, 0, h), this.addCurrentVertex(u, m, 1, 1, h, !0)), d && (this.addCurrentVertex(u, g, -1, -1, h, !0), this.addCurrentVertex(u, g, 0, 0, h)));

                  if (T && v < l - 1) {
                    var N = u.dist(d);

                    if (N > 2 * f) {
                      var j = u.add(d.sub(u)._mult(f / N)._round());
                      this.updateDistance(u, j), this.addCurrentVertex(j, g, 0, 0, h), u = j;
                    }
                  }
                }
              }
            }
          }, Hs.prototype.addCurrentVertex = function (t, e, r, n, i, a) {
            void 0 === a && (a = !1);
            var o = e.x + e.y * r,
                s = e.y - e.x * r,
                l = -e.x + e.y * n,
                c = -e.y - e.x * n;
            this.addHalfVertex(t, o, s, a, !1, r, i), this.addHalfVertex(t, l, c, a, !0, -n, i), this.distance > qs / 2 && 0 === this.totalDistance && (this.distance = 0, this.addCurrentVertex(t, e, r, n, i, a));
          }, Hs.prototype.addHalfVertex = function (t, e, r, n, i, a, o) {
            var s = t.x,
                l = t.y,
                c = .5 * this.scaledDistance;
            this.layoutVertexArray.emplaceBack((s << 1) + (n ? 1 : 0), (l << 1) + (i ? 1 : 0), Math.round(63 * e) + 128, Math.round(63 * r) + 128, 1 + (0 === a ? 0 : a < 0 ? -1 : 1) | (63 & c) << 2, c >> 6);
            var u = o.vertexLength++;
            this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, u), o.primitiveLength++), i ? this.e2 = u : this.e1 = u;
          }, Hs.prototype.updateScaledDistance = function () {
            this.scaledDistance = this.totalDistance > 0 ? (this.clipStart + (this.clipEnd - this.clipStart) * this.distance / this.totalDistance) * (qs - 1) : this.distance;
          }, Hs.prototype.updateDistance = function (t, e) {
            this.distance += t.dist(e), this.updateScaledDistance();
          }, Nn("LineBucket", Hs, {
            omit: ["layers", "patternFeatures"]
          });
          var Gs = new Si({
            "line-cap": new wi(Lt.layout_line["line-cap"]),
            "line-join": new Ti(Lt.layout_line["line-join"]),
            "line-miter-limit": new wi(Lt.layout_line["line-miter-limit"]),
            "line-round-limit": new wi(Lt.layout_line["line-round-limit"]),
            "line-sort-key": new Ti(Lt.layout_line["line-sort-key"])
          }),
              Ys = {
            paint: new Si({
              "line-opacity": new Ti(Lt.paint_line["line-opacity"]),
              "line-color": new Ti(Lt.paint_line["line-color"]),
              "line-translate": new wi(Lt.paint_line["line-translate"]),
              "line-translate-anchor": new wi(Lt.paint_line["line-translate-anchor"]),
              "line-width": new Ti(Lt.paint_line["line-width"]),
              "line-gap-width": new Ti(Lt.paint_line["line-gap-width"]),
              "line-offset": new Ti(Lt.paint_line["line-offset"]),
              "line-blur": new Ti(Lt.paint_line["line-blur"]),
              "line-dasharray": new Mi(Lt.paint_line["line-dasharray"]),
              "line-pattern": new ki(Lt.paint_line["line-pattern"]),
              "line-gradient": new Ai(Lt.paint_line["line-gradient"])
            }),
            layout: Gs
          },
              Ws = new (function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.possiblyEvaluate = function (e, r) {
              return r = new pi(Math.floor(r.zoom), {
                now: r.now,
                fadeDuration: r.fadeDuration,
                zoomHistory: r.zoomHistory,
                transition: r.transition
              }), t.prototype.possiblyEvaluate.call(this, e, r);
            }, e.prototype.evaluate = function (e, r, n, i) {
              return r = u({}, r, {
                zoom: Math.floor(r.zoom)
              }), t.prototype.evaluate.call(this, e, r, n, i);
            }, e;
          }(Ti))(Ys.paint.properties["line-width"].specification);
          Ws.useIntegerZoom = !0;

          var Xs = function (t) {
            function e(e) {
              t.call(this, e, Ys);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._handleSpecialPaintPropertyUpdate = function (t) {
              "line-gradient" === t && this._updateGradient();
            }, e.prototype._updateGradient = function () {
              var t = this._transitionablePaint._values["line-gradient"].value.expression;
              this.gradient = Co(t, "lineProgress"), this.gradientTexture = null;
            }, e.prototype.recalculate = function (e, r) {
              t.prototype.recalculate.call(this, e, r), this.paint._values["line-floorwidth"] = Ws.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, e);
            }, e.prototype.createBucket = function (t) {
              return new Hs(t);
            }, e.prototype.queryRadius = function (t) {
              var e = t,
                  r = Zs(oo("line-width", this, e), oo("line-gap-width", this, e)),
                  n = oo("line-offset", this, e);
              return r / 2 + Math.abs(n) + so(this.paint.get("line-translate"));
            }, e.prototype.queryIntersectsFeature = function (t, e, r, n, a, o, s) {
              var l = lo(t, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), o.angle, s),
                  c = s / 2 * Zs(this.paint.get("line-width").evaluate(e, r), this.paint.get("line-gap-width").evaluate(e, r)),
                  u = this.paint.get("line-offset").evaluate(e, r);
              return u && (n = function (t, e) {
                for (var r = [], n = new i(0, 0), a = 0; a < t.length; a++) {
                  for (var o = t[a], s = [], l = 0; l < o.length; l++) {
                    var c = o[l - 1],
                        u = o[l],
                        f = o[l + 1],
                        h = 0 === l ? n : u.sub(c)._unit()._perp(),
                        p = l === o.length - 1 ? n : f.sub(u)._unit()._perp(),
                        d = h._add(p)._unit(),
                        m = d.x * p.x + d.y * p.y;

                    d._mult(1 / m), s.push(d._mult(e)._add(u));
                  }

                  r.push(s);
                }

                return r;
              }(n, u * s)), function (t, e, r) {
                for (var n = 0; n < e.length; n++) {
                  var i = e[n];
                  if (t.length >= 3) for (var a = 0; a < i.length; a++) {
                    if (io(t, i[a])) return !0;
                  }
                  if (Qa(t, i, r)) return !0;
                }

                return !1;
              }(l, n, c);
            }, e.prototype.isTileClipped = function () {
              return !0;
            }, e;
          }(Ei);

          function Zs(t, e) {
            return e > 0 ? e + 2 * t : t;
          }

          var Js = Ii([{
            name: "a_pos_offset",
            components: 4,
            type: "Int16"
          }, {
            name: "a_data",
            components: 4,
            type: "Uint16"
          }, {
            name: "a_pixeloffset",
            components: 4,
            type: "Int16"
          }], 4),
              Ks = Ii([{
            name: "a_projected_pos",
            components: 3,
            type: "Float32"
          }], 4),
              Qs = (Ii([{
            name: "a_fade_opacity",
            components: 1,
            type: "Uint32"
          }], 4), Ii([{
            name: "a_placed",
            components: 2,
            type: "Uint8"
          }, {
            name: "a_shift",
            components: 2,
            type: "Float32"
          }])),
              $s = (Ii([{
            type: "Int16",
            name: "anchorPointX"
          }, {
            type: "Int16",
            name: "anchorPointY"
          }, {
            type: "Int16",
            name: "x1"
          }, {
            type: "Int16",
            name: "y1"
          }, {
            type: "Int16",
            name: "x2"
          }, {
            type: "Int16",
            name: "y2"
          }, {
            type: "Uint32",
            name: "featureIndex"
          }, {
            type: "Uint16",
            name: "sourceLayerIndex"
          }, {
            type: "Uint16",
            name: "bucketIndex"
          }]), Ii([{
            name: "a_pos",
            components: 2,
            type: "Int16"
          }, {
            name: "a_anchor_pos",
            components: 2,
            type: "Int16"
          }, {
            name: "a_extrude",
            components: 2,
            type: "Int16"
          }], 4)),
              tl = Ii([{
            name: "a_pos",
            components: 2,
            type: "Float32"
          }, {
            name: "a_radius",
            components: 1,
            type: "Float32"
          }, {
            name: "a_flags",
            components: 2,
            type: "Int16"
          }], 4);
          Ii([{
            name: "triangle",
            components: 3,
            type: "Uint16"
          }]), Ii([{
            type: "Int16",
            name: "anchorX"
          }, {
            type: "Int16",
            name: "anchorY"
          }, {
            type: "Uint16",
            name: "glyphStartIndex"
          }, {
            type: "Uint16",
            name: "numGlyphs"
          }, {
            type: "Uint32",
            name: "vertexStartIndex"
          }, {
            type: "Uint32",
            name: "lineStartIndex"
          }, {
            type: "Uint32",
            name: "lineLength"
          }, {
            type: "Uint16",
            name: "segment"
          }, {
            type: "Uint16",
            name: "lowerSize"
          }, {
            type: "Uint16",
            name: "upperSize"
          }, {
            type: "Float32",
            name: "lineOffsetX"
          }, {
            type: "Float32",
            name: "lineOffsetY"
          }, {
            type: "Uint8",
            name: "writingMode"
          }, {
            type: "Uint8",
            name: "placedOrientation"
          }, {
            type: "Uint8",
            name: "hidden"
          }, {
            type: "Uint32",
            name: "crossTileID"
          }, {
            type: "Int16",
            name: "associatedIconIndex"
          }]), Ii([{
            type: "Int16",
            name: "anchorX"
          }, {
            type: "Int16",
            name: "anchorY"
          }, {
            type: "Int16",
            name: "rightJustifiedTextSymbolIndex"
          }, {
            type: "Int16",
            name: "centerJustifiedTextSymbolIndex"
          }, {
            type: "Int16",
            name: "leftJustifiedTextSymbolIndex"
          }, {
            type: "Int16",
            name: "verticalPlacedTextSymbolIndex"
          }, {
            type: "Int16",
            name: "placedIconSymbolIndex"
          }, {
            type: "Int16",
            name: "verticalPlacedIconSymbolIndex"
          }, {
            type: "Uint16",
            name: "key"
          }, {
            type: "Uint16",
            name: "textBoxStartIndex"
          }, {
            type: "Uint16",
            name: "textBoxEndIndex"
          }, {
            type: "Uint16",
            name: "verticalTextBoxStartIndex"
          }, {
            type: "Uint16",
            name: "verticalTextBoxEndIndex"
          }, {
            type: "Uint16",
            name: "iconBoxStartIndex"
          }, {
            type: "Uint16",
            name: "iconBoxEndIndex"
          }, {
            type: "Uint16",
            name: "verticalIconBoxStartIndex"
          }, {
            type: "Uint16",
            name: "verticalIconBoxEndIndex"
          }, {
            type: "Uint16",
            name: "featureIndex"
          }, {
            type: "Uint16",
            name: "numHorizontalGlyphVertices"
          }, {
            type: "Uint16",
            name: "numVerticalGlyphVertices"
          }, {
            type: "Uint16",
            name: "numIconVertices"
          }, {
            type: "Uint16",
            name: "numVerticalIconVertices"
          }, {
            type: "Uint16",
            name: "useRuntimeCollisionCircles"
          }, {
            type: "Uint32",
            name: "crossTileID"
          }, {
            type: "Float32",
            name: "textBoxScale"
          }, {
            type: "Float32",
            components: 2,
            name: "textOffset"
          }, {
            type: "Float32",
            name: "collisionCircleDiameter"
          }]), Ii([{
            type: "Float32",
            name: "offsetX"
          }]), Ii([{
            type: "Int16",
            name: "x"
          }, {
            type: "Int16",
            name: "y"
          }, {
            type: "Int16",
            name: "tileUnitDistanceFromAnchor"
          }]);

          function el(t, e, r) {
            return t.sections.forEach(function (t) {
              t.text = function (t, e, r) {
                var n = e.layout.get("text-transform").evaluate(r, {});
                return "uppercase" === n ? t = t.toLocaleUpperCase() : "lowercase" === n && (t = t.toLocaleLowerCase()), hi.applyArabicShaping && (t = hi.applyArabicShaping(t)), t;
              }(t.text, e, r);
            }), t;
          }

          var rl = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42"
          };

          var nl = function nl(t, e, r, n, i) {
            var a,
                o,
                s = 8 * i - n - 1,
                l = (1 << s) - 1,
                c = l >> 1,
                u = -7,
                f = r ? i - 1 : 0,
                h = r ? -1 : 1,
                p = t[e + f];

            for (f += h, a = p & (1 << -u) - 1, p >>= -u, u += s; u > 0; a = 256 * a + t[e + f], f += h, u -= 8) {
              ;
            }

            for (o = a & (1 << -u) - 1, a >>= -u, u += n; u > 0; o = 256 * o + t[e + f], f += h, u -= 8) {
              ;
            }

            if (0 === a) a = 1 - c;else {
              if (a === l) return o ? NaN : 1 / 0 * (p ? -1 : 1);
              o += Math.pow(2, n), a -= c;
            }
            return (p ? -1 : 1) * o * Math.pow(2, a - n);
          },
              il = function il(t, e, r, n, i, a) {
            var o,
                s,
                l,
                c = 8 * a - i - 1,
                u = (1 << c) - 1,
                f = u >> 1,
                h = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
                p = n ? 0 : a - 1,
                d = n ? 1 : -1,
                m = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

            for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, o = u) : (o = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), (e += o + f >= 1 ? h / l : h * Math.pow(2, 1 - f)) * l >= 2 && (o++, l /= 2), o + f >= u ? (s = 0, o = u) : o + f >= 1 ? (s = (e * l - 1) * Math.pow(2, i), o += f) : (s = e * Math.pow(2, f - 1) * Math.pow(2, i), o = 0)); i >= 8; t[r + p] = 255 & s, p += d, s /= 256, i -= 8) {
              ;
            }

            for (o = o << i | s, c += i; c > 0; t[r + p] = 255 & o, p += d, o /= 256, c -= 8) {
              ;
            }

            t[r + p - d] |= 128 * m;
          },
              al = ol;

          function ol(t) {
            this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t) ? t : new Uint8Array(t || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
          }

          ol.Varint = 0, ol.Fixed64 = 1, ol.Bytes = 2, ol.Fixed32 = 5;
          var sl = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf8");

          function ll(t) {
            return t.type === ol.Bytes ? t.readVarint() + t.pos : t.pos + 1;
          }

          function cl(t, e, r) {
            return r ? 4294967296 * e + (t >>> 0) : 4294967296 * (e >>> 0) + (t >>> 0);
          }

          function ul(t, e, r) {
            var n = e <= 16383 ? 1 : e <= 2097151 ? 2 : e <= 268435455 ? 3 : Math.floor(Math.log(e) / (7 * Math.LN2));
            r.realloc(n);

            for (var i = r.pos - 1; i >= t; i--) {
              r.buf[i + n] = r.buf[i];
            }
          }

          function fl(t, e) {
            for (var r = 0; r < t.length; r++) {
              e.writeVarint(t[r]);
            }
          }

          function hl(t, e) {
            for (var r = 0; r < t.length; r++) {
              e.writeSVarint(t[r]);
            }
          }

          function pl(t, e) {
            for (var r = 0; r < t.length; r++) {
              e.writeFloat(t[r]);
            }
          }

          function dl(t, e) {
            for (var r = 0; r < t.length; r++) {
              e.writeDouble(t[r]);
            }
          }

          function ml(t, e) {
            for (var r = 0; r < t.length; r++) {
              e.writeBoolean(t[r]);
            }
          }

          function gl(t, e) {
            for (var r = 0; r < t.length; r++) {
              e.writeFixed32(t[r]);
            }
          }

          function vl(t, e) {
            for (var r = 0; r < t.length; r++) {
              e.writeSFixed32(t[r]);
            }
          }

          function yl(t, e) {
            for (var r = 0; r < t.length; r++) {
              e.writeFixed64(t[r]);
            }
          }

          function xl(t, e) {
            for (var r = 0; r < t.length; r++) {
              e.writeSFixed64(t[r]);
            }
          }

          function bl(t, e) {
            return (t[e] | t[e + 1] << 8 | t[e + 2] << 16) + 16777216 * t[e + 3];
          }

          function _l(t, e, r) {
            t[r] = e, t[r + 1] = e >>> 8, t[r + 2] = e >>> 16, t[r + 3] = e >>> 24;
          }

          function wl(t, e) {
            return (t[e] | t[e + 1] << 8 | t[e + 2] << 16) + (t[e + 3] << 24);
          }

          ol.prototype = {
            destroy: function destroy() {
              this.buf = null;
            },
            readFields: function readFields(t, e, r) {
              for (r = r || this.length; this.pos < r;) {
                var n = this.readVarint(),
                    i = n >> 3,
                    a = this.pos;
                this.type = 7 & n, t(i, e, this), this.pos === a && this.skip(n);
              }

              return e;
            },
            readMessage: function readMessage(t, e) {
              return this.readFields(t, e, this.readVarint() + this.pos);
            },
            readFixed32: function readFixed32() {
              var t = bl(this.buf, this.pos);
              return this.pos += 4, t;
            },
            readSFixed32: function readSFixed32() {
              var t = wl(this.buf, this.pos);
              return this.pos += 4, t;
            },
            readFixed64: function readFixed64() {
              var t = bl(this.buf, this.pos) + 4294967296 * bl(this.buf, this.pos + 4);
              return this.pos += 8, t;
            },
            readSFixed64: function readSFixed64() {
              var t = bl(this.buf, this.pos) + 4294967296 * wl(this.buf, this.pos + 4);
              return this.pos += 8, t;
            },
            readFloat: function readFloat() {
              var t = nl(this.buf, this.pos, !0, 23, 4);
              return this.pos += 4, t;
            },
            readDouble: function readDouble() {
              var t = nl(this.buf, this.pos, !0, 52, 8);
              return this.pos += 8, t;
            },
            readVarint: function readVarint(t) {
              var e,
                  r,
                  n = this.buf;
              return e = 127 & (r = n[this.pos++]), r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 7, r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 14, r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 21, r < 128 ? e : function (t, e, r) {
                var n,
                    i,
                    a = r.buf;
                if (i = a[r.pos++], n = (112 & i) >> 4, i < 128) return cl(t, n, e);
                if (i = a[r.pos++], n |= (127 & i) << 3, i < 128) return cl(t, n, e);
                if (i = a[r.pos++], n |= (127 & i) << 10, i < 128) return cl(t, n, e);
                if (i = a[r.pos++], n |= (127 & i) << 17, i < 128) return cl(t, n, e);
                if (i = a[r.pos++], n |= (127 & i) << 24, i < 128) return cl(t, n, e);
                if (i = a[r.pos++], n |= (1 & i) << 31, i < 128) return cl(t, n, e);
                throw new Error("Expected varint not more than 10 bytes");
              }(e |= (15 & (r = n[this.pos])) << 28, t, this))));
            },
            readVarint64: function readVarint64() {
              return this.readVarint(!0);
            },
            readSVarint: function readSVarint() {
              var t = this.readVarint();
              return t % 2 == 1 ? (t + 1) / -2 : t / 2;
            },
            readBoolean: function readBoolean() {
              return Boolean(this.readVarint());
            },
            readString: function readString() {
              var t = this.readVarint() + this.pos,
                  e = this.pos;
              return this.pos = t, t - e >= 12 && sl ? function (t, e, r) {
                return sl.decode(t.subarray(e, r));
              }(this.buf, e, t) : function (t, e, r) {
                var n = "",
                    i = e;

                for (; i < r;) {
                  var a,
                      o,
                      s,
                      l = t[i],
                      c = null,
                      u = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
                  if (i + u > r) break;
                  1 === u ? l < 128 && (c = l) : 2 === u ? 128 == (192 & (a = t[i + 1])) && (c = (31 & l) << 6 | 63 & a) <= 127 && (c = null) : 3 === u ? (a = t[i + 1], o = t[i + 2], 128 == (192 & a) && 128 == (192 & o) && ((c = (15 & l) << 12 | (63 & a) << 6 | 63 & o) <= 2047 || c >= 55296 && c <= 57343) && (c = null)) : 4 === u && (a = t[i + 1], o = t[i + 2], s = t[i + 3], 128 == (192 & a) && 128 == (192 & o) && 128 == (192 & s) && ((c = (15 & l) << 18 | (63 & a) << 12 | (63 & o) << 6 | 63 & s) <= 65535 || c >= 1114112) && (c = null)), null === c ? (c = 65533, u = 1) : c > 65535 && (c -= 65536, n += String.fromCharCode(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), n += String.fromCharCode(c), i += u;
                }

                return n;
              }(this.buf, e, t);
            },
            readBytes: function readBytes() {
              var t = this.readVarint() + this.pos,
                  e = this.buf.subarray(this.pos, t);
              return this.pos = t, e;
            },
            readPackedVarint: function readPackedVarint(t, e) {
              if (this.type !== ol.Bytes) return t.push(this.readVarint(e));
              var r = ll(this);

              for (t = t || []; this.pos < r;) {
                t.push(this.readVarint(e));
              }

              return t;
            },
            readPackedSVarint: function readPackedSVarint(t) {
              if (this.type !== ol.Bytes) return t.push(this.readSVarint());
              var e = ll(this);

              for (t = t || []; this.pos < e;) {
                t.push(this.readSVarint());
              }

              return t;
            },
            readPackedBoolean: function readPackedBoolean(t) {
              if (this.type !== ol.Bytes) return t.push(this.readBoolean());
              var e = ll(this);

              for (t = t || []; this.pos < e;) {
                t.push(this.readBoolean());
              }

              return t;
            },
            readPackedFloat: function readPackedFloat(t) {
              if (this.type !== ol.Bytes) return t.push(this.readFloat());
              var e = ll(this);

              for (t = t || []; this.pos < e;) {
                t.push(this.readFloat());
              }

              return t;
            },
            readPackedDouble: function readPackedDouble(t) {
              if (this.type !== ol.Bytes) return t.push(this.readDouble());
              var e = ll(this);

              for (t = t || []; this.pos < e;) {
                t.push(this.readDouble());
              }

              return t;
            },
            readPackedFixed32: function readPackedFixed32(t) {
              if (this.type !== ol.Bytes) return t.push(this.readFixed32());
              var e = ll(this);

              for (t = t || []; this.pos < e;) {
                t.push(this.readFixed32());
              }

              return t;
            },
            readPackedSFixed32: function readPackedSFixed32(t) {
              if (this.type !== ol.Bytes) return t.push(this.readSFixed32());
              var e = ll(this);

              for (t = t || []; this.pos < e;) {
                t.push(this.readSFixed32());
              }

              return t;
            },
            readPackedFixed64: function readPackedFixed64(t) {
              if (this.type !== ol.Bytes) return t.push(this.readFixed64());
              var e = ll(this);

              for (t = t || []; this.pos < e;) {
                t.push(this.readFixed64());
              }

              return t;
            },
            readPackedSFixed64: function readPackedSFixed64(t) {
              if (this.type !== ol.Bytes) return t.push(this.readSFixed64());
              var e = ll(this);

              for (t = t || []; this.pos < e;) {
                t.push(this.readSFixed64());
              }

              return t;
            },
            skip: function skip(t) {
              var e = 7 & t;
              if (e === ol.Varint) for (; this.buf[this.pos++] > 127;) {
                ;
              } else if (e === ol.Bytes) this.pos = this.readVarint() + this.pos;else if (e === ol.Fixed32) this.pos += 4;else {
                if (e !== ol.Fixed64) throw new Error("Unimplemented type: " + e);
                this.pos += 8;
              }
            },
            writeTag: function writeTag(t, e) {
              this.writeVarint(t << 3 | e);
            },
            realloc: function realloc(t) {
              for (var e = this.length || 16; e < this.pos + t;) {
                e *= 2;
              }

              if (e !== this.length) {
                var r = new Uint8Array(e);
                r.set(this.buf), this.buf = r, this.length = e;
              }
            },
            finish: function finish() {
              return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
            },
            writeFixed32: function writeFixed32(t) {
              this.realloc(4), _l(this.buf, t, this.pos), this.pos += 4;
            },
            writeSFixed32: function writeSFixed32(t) {
              this.realloc(4), _l(this.buf, t, this.pos), this.pos += 4;
            },
            writeFixed64: function writeFixed64(t) {
              this.realloc(8), _l(this.buf, -1 & t, this.pos), _l(this.buf, Math.floor(t * (1 / 4294967296)), this.pos + 4), this.pos += 8;
            },
            writeSFixed64: function writeSFixed64(t) {
              this.realloc(8), _l(this.buf, -1 & t, this.pos), _l(this.buf, Math.floor(t * (1 / 4294967296)), this.pos + 4), this.pos += 8;
            },
            writeVarint: function writeVarint(t) {
              (t = +t || 0) > 268435455 || t < 0 ? function (t, e) {
                var r, n;
                t >= 0 ? (r = t % 4294967296 | 0, n = t / 4294967296 | 0) : (n = ~(-t / 4294967296), 4294967295 ^ (r = ~(-t % 4294967296)) ? r = r + 1 | 0 : (r = 0, n = n + 1 | 0));
                if (t >= 0x10000000000000000 || t < -0x10000000000000000) throw new Error("Given varint doesn't fit into 10 bytes");
                e.realloc(10), function (t, e, r) {
                  r.buf[r.pos++] = 127 & t | 128, t >>>= 7, r.buf[r.pos++] = 127 & t | 128, t >>>= 7, r.buf[r.pos++] = 127 & t | 128, t >>>= 7, r.buf[r.pos++] = 127 & t | 128, t >>>= 7, r.buf[r.pos] = 127 & t;
                }(r, 0, e), function (t, e) {
                  var r = (7 & t) << 4;
                  if (e.buf[e.pos++] |= r | ((t >>>= 3) ? 128 : 0), !t) return;
                  if (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), !t) return;
                  if (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), !t) return;
                  if (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), !t) return;
                  if (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), !t) return;
                  e.buf[e.pos++] = 127 & t;
                }(n, e);
              }(t, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = 127 & (t >>>= 7) | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = 127 & (t >>>= 7) | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = t >>> 7 & 127))));
            },
            writeSVarint: function writeSVarint(t) {
              this.writeVarint(t < 0 ? 2 * -t - 1 : 2 * t);
            },
            writeBoolean: function writeBoolean(t) {
              this.writeVarint(Boolean(t));
            },
            writeString: function writeString(t) {
              t = String(t), this.realloc(4 * t.length), this.pos++;
              var e = this.pos;

              this.pos = function (t, e, r) {
                for (var n, i, a = 0; a < e.length; a++) {
                  if ((n = e.charCodeAt(a)) > 55295 && n < 57344) {
                    if (!i) {
                      n > 56319 || a + 1 === e.length ? (t[r++] = 239, t[r++] = 191, t[r++] = 189) : i = n;
                      continue;
                    }

                    if (n < 56320) {
                      t[r++] = 239, t[r++] = 191, t[r++] = 189, i = n;
                      continue;
                    }

                    n = i - 55296 << 10 | n - 56320 | 65536, i = null;
                  } else i && (t[r++] = 239, t[r++] = 191, t[r++] = 189, i = null);

                  n < 128 ? t[r++] = n : (n < 2048 ? t[r++] = n >> 6 | 192 : (n < 65536 ? t[r++] = n >> 12 | 224 : (t[r++] = n >> 18 | 240, t[r++] = n >> 12 & 63 | 128), t[r++] = n >> 6 & 63 | 128), t[r++] = 63 & n | 128);
                }

                return r;
              }(this.buf, t, this.pos);

              var r = this.pos - e;
              r >= 128 && ul(e, r, this), this.pos = e - 1, this.writeVarint(r), this.pos += r;
            },
            writeFloat: function writeFloat(t) {
              this.realloc(4), il(this.buf, t, this.pos, !0, 23, 4), this.pos += 4;
            },
            writeDouble: function writeDouble(t) {
              this.realloc(8), il(this.buf, t, this.pos, !0, 52, 8), this.pos += 8;
            },
            writeBytes: function writeBytes(t) {
              var e = t.length;
              this.writeVarint(e), this.realloc(e);

              for (var r = 0; r < e; r++) {
                this.buf[this.pos++] = t[r];
              }
            },
            writeRawMessage: function writeRawMessage(t, e) {
              this.pos++;
              var r = this.pos;
              t(e, this);
              var n = this.pos - r;
              n >= 128 && ul(r, n, this), this.pos = r - 1, this.writeVarint(n), this.pos += n;
            },
            writeMessage: function writeMessage(t, e, r) {
              this.writeTag(t, ol.Bytes), this.writeRawMessage(e, r);
            },
            writePackedVarint: function writePackedVarint(t, e) {
              e.length && this.writeMessage(t, fl, e);
            },
            writePackedSVarint: function writePackedSVarint(t, e) {
              e.length && this.writeMessage(t, hl, e);
            },
            writePackedBoolean: function writePackedBoolean(t, e) {
              e.length && this.writeMessage(t, ml, e);
            },
            writePackedFloat: function writePackedFloat(t, e) {
              e.length && this.writeMessage(t, pl, e);
            },
            writePackedDouble: function writePackedDouble(t, e) {
              e.length && this.writeMessage(t, dl, e);
            },
            writePackedFixed32: function writePackedFixed32(t, e) {
              e.length && this.writeMessage(t, gl, e);
            },
            writePackedSFixed32: function writePackedSFixed32(t, e) {
              e.length && this.writeMessage(t, vl, e);
            },
            writePackedFixed64: function writePackedFixed64(t, e) {
              e.length && this.writeMessage(t, yl, e);
            },
            writePackedSFixed64: function writePackedSFixed64(t, e) {
              e.length && this.writeMessage(t, xl, e);
            },
            writeBytesField: function writeBytesField(t, e) {
              this.writeTag(t, ol.Bytes), this.writeBytes(e);
            },
            writeFixed32Field: function writeFixed32Field(t, e) {
              this.writeTag(t, ol.Fixed32), this.writeFixed32(e);
            },
            writeSFixed32Field: function writeSFixed32Field(t, e) {
              this.writeTag(t, ol.Fixed32), this.writeSFixed32(e);
            },
            writeFixed64Field: function writeFixed64Field(t, e) {
              this.writeTag(t, ol.Fixed64), this.writeFixed64(e);
            },
            writeSFixed64Field: function writeSFixed64Field(t, e) {
              this.writeTag(t, ol.Fixed64), this.writeSFixed64(e);
            },
            writeVarintField: function writeVarintField(t, e) {
              this.writeTag(t, ol.Varint), this.writeVarint(e);
            },
            writeSVarintField: function writeSVarintField(t, e) {
              this.writeTag(t, ol.Varint), this.writeSVarint(e);
            },
            writeStringField: function writeStringField(t, e) {
              this.writeTag(t, ol.Bytes), this.writeString(e);
            },
            writeFloatField: function writeFloatField(t, e) {
              this.writeTag(t, ol.Fixed32), this.writeFloat(e);
            },
            writeDoubleField: function writeDoubleField(t, e) {
              this.writeTag(t, ol.Fixed64), this.writeDouble(e);
            },
            writeBooleanField: function writeBooleanField(t, e) {
              this.writeVarintField(t, Boolean(e));
            }
          };

          function Tl(t, e, r) {
            1 === t && r.readMessage(kl, e);
          }

          function kl(t, e, r) {
            if (3 === t) {
              var n = r.readMessage(Ml, {}),
                  i = n.id,
                  a = n.bitmap,
                  o = n.width,
                  s = n.height,
                  l = n.left,
                  c = n.top,
                  u = n.advance;
              e.push({
                id: i,
                bitmap: new So({
                  width: o + 6,
                  height: s + 6
                }, a),
                metrics: {
                  width: o,
                  height: s,
                  left: l,
                  top: c,
                  advance: u
                }
              });
            }
          }

          function Ml(t, e, r) {
            1 === t ? e.id = r.readVarint() : 2 === t ? e.bitmap = r.readBytes() : 3 === t ? e.width = r.readVarint() : 4 === t ? e.height = r.readVarint() : 5 === t ? e.left = r.readSVarint() : 6 === t ? e.top = r.readSVarint() : 7 === t && (e.advance = r.readVarint());
          }

          function Al(t) {
            for (var e = 0, r = 0, n = 0, i = t; n < i.length; n += 1) {
              var a = i[n];
              e += a.w * a.h, r = Math.max(r, a.w);
            }

            t.sort(function (t, e) {
              return e.h - t.h;
            });

            for (var o = [{
              x: 0,
              y: 0,
              w: Math.max(Math.ceil(Math.sqrt(e / .95)), r),
              h: 1 / 0
            }], s = 0, l = 0, c = 0, u = t; c < u.length; c += 1) {
              for (var f = u[c], h = o.length - 1; h >= 0; h--) {
                var p = o[h];

                if (!(f.w > p.w || f.h > p.h)) {
                  if (f.x = p.x, f.y = p.y, l = Math.max(l, f.y + f.h), s = Math.max(s, f.x + f.w), f.w === p.w && f.h === p.h) {
                    var d = o.pop();
                    h < o.length && (o[h] = d);
                  } else f.h === p.h ? (p.x += f.w, p.w -= f.w) : f.w === p.w ? (p.y += f.h, p.h -= f.h) : (o.push({
                    x: p.x + f.w,
                    y: p.y,
                    w: p.w - f.w,
                    h: f.h
                  }), p.y += f.h, p.h -= f.h);

                  break;
                }
              }
            }

            return {
              w: s,
              h: l,
              fill: e / (s * l) || 0
            };
          }

          var Sl = function Sl(t, e) {
            var r = e.pixelRatio,
                n = e.version,
                i = e.stretchX,
                a = e.stretchY,
                o = e.content;
            this.paddedRect = t, this.pixelRatio = r, this.stretchX = i, this.stretchY = a, this.content = o, this.version = n;
          },
              El = {
            tl: {
              configurable: !0
            },
            br: {
              configurable: !0
            },
            tlbr: {
              configurable: !0
            },
            displaySize: {
              configurable: !0
            }
          };

          El.tl.get = function () {
            return [this.paddedRect.x + 1, this.paddedRect.y + 1];
          }, El.br.get = function () {
            return [this.paddedRect.x + this.paddedRect.w - 1, this.paddedRect.y + this.paddedRect.h - 1];
          }, El.tlbr.get = function () {
            return this.tl.concat(this.br);
          }, El.displaySize.get = function () {
            return [(this.paddedRect.w - 2) / this.pixelRatio, (this.paddedRect.h - 2) / this.pixelRatio];
          }, Object.defineProperties(Sl.prototype, El);

          var Ll = function Ll(t, e) {
            var r = {},
                n = {};
            this.haveRenderCallbacks = [];
            var i = [];
            this.addImages(t, r, i), this.addImages(e, n, i);
            var a = Al(i),
                o = a.w,
                s = a.h,
                l = new Eo({
              width: o || 1,
              height: s || 1
            });

            for (var c in t) {
              var u = t[c],
                  f = r[c].paddedRect;
              Eo.copy(u.data, l, {
                x: 0,
                y: 0
              }, {
                x: f.x + 1,
                y: f.y + 1
              }, u.data);
            }

            for (var h in e) {
              var p = e[h],
                  d = n[h].paddedRect,
                  m = d.x + 1,
                  g = d.y + 1,
                  v = p.data.width,
                  y = p.data.height;
              Eo.copy(p.data, l, {
                x: 0,
                y: 0
              }, {
                x: m,
                y: g
              }, p.data), Eo.copy(p.data, l, {
                x: 0,
                y: y - 1
              }, {
                x: m,
                y: g - 1
              }, {
                width: v,
                height: 1
              }), Eo.copy(p.data, l, {
                x: 0,
                y: 0
              }, {
                x: m,
                y: g + y
              }, {
                width: v,
                height: 1
              }), Eo.copy(p.data, l, {
                x: v - 1,
                y: 0
              }, {
                x: m - 1,
                y: g
              }, {
                width: 1,
                height: y
              }), Eo.copy(p.data, l, {
                x: 0,
                y: 0
              }, {
                x: m + v,
                y: g
              }, {
                width: 1,
                height: y
              });
            }

            this.image = l, this.iconPositions = r, this.patternPositions = n;
          };

          Ll.prototype.addImages = function (t, e, r) {
            for (var n in t) {
              var i = t[n],
                  a = {
                x: 0,
                y: 0,
                w: i.data.width + 2,
                h: i.data.height + 2
              };
              r.push(a), e[n] = new Sl(a, i), i.hasRenderCallback && this.haveRenderCallbacks.push(n);
            }
          }, Ll.prototype.patchUpdatedImages = function (t, e) {
            for (var r in t.dispatchRenderCallbacks(this.haveRenderCallbacks), t.updatedImages) {
              this.patchUpdatedImage(this.iconPositions[r], t.getImage(r), e), this.patchUpdatedImage(this.patternPositions[r], t.getImage(r), e);
            }
          }, Ll.prototype.patchUpdatedImage = function (t, e, r) {
            if (t && e && t.version !== e.version) {
              t.version = e.version;
              var n = t.tl,
                  i = n[0],
                  a = n[1];
              r.update(e.data, void 0, {
                x: i,
                y: a
              });
            }
          }, Nn("ImagePosition", Sl), Nn("ImageAtlas", Ll);
          var Cl = {
            horizontal: 1,
            vertical: 2,
            horizontalOnly: 3
          };

          var Pl = function Pl() {
            this.scale = 1, this.fontStack = "", this.imageName = null;
          };

          Pl.forText = function (t, e) {
            var r = new Pl();
            return r.scale = t || 1, r.fontStack = e, r;
          }, Pl.forImage = function (t) {
            var e = new Pl();
            return e.imageName = t, e;
          };

          var Il = function Il() {
            this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
          };

          function Ol(t, e, r, n, i, a, o, s, l, c, u, f, h, p, d, m) {
            var g,
                v = Il.fromFeature(t, i);
            f === Cl.vertical && v.verticalizePunctuation();
            var y = hi.processBidirectionalText,
                x = hi.processStyledBidirectionalText;

            if (y && 1 === v.sections.length) {
              g = [];

              for (var b = 0, _ = y(v.toString(), jl(v, c, a, e, n, p, d)); b < _.length; b += 1) {
                var w = _[b],
                    T = new Il();
                T.text = w, T.sections = v.sections;

                for (var k = 0; k < w.length; k++) {
                  T.sectionIndex.push(0);
                }

                g.push(T);
              }
            } else if (x) {
              g = [];

              for (var M = 0, A = x(v.text, v.sectionIndex, jl(v, c, a, e, n, p, d)); M < A.length; M += 1) {
                var S = A[M],
                    E = new Il();
                E.text = S[0], E.sectionIndex = S[1], E.sections = v.sections, g.push(E);
              }
            } else g = function (t, e) {
              for (var r = [], n = t.text, i = 0, a = 0, o = e; a < o.length; a += 1) {
                var s = o[a];
                r.push(t.substring(i, s)), i = s;
              }

              return i < n.length && r.push(t.substring(i, n.length)), r;
            }(v, jl(v, c, a, e, n, p, d));

            var L = [],
                C = {
              positionedLines: L,
              text: v.toString(),
              top: u[1],
              bottom: u[1],
              left: u[0],
              right: u[0],
              writingMode: f,
              iconsInText: !1,
              verticalizable: !1
            };
            return function (t, e, r, n, i, a, o, s, l, c, u, f) {
              for (var h = 0, p = -17, d = 0, m = 0, g = "right" === s ? 1 : "left" === s ? 0 : .5, v = 0, y = 0, x = i; y < x.length; y += 1) {
                var b = x[y];
                b.trim();

                var _ = b.getMaxScale(),
                    w = 24 * (_ - 1),
                    T = {
                  positionedGlyphs: [],
                  lineOffset: 0
                };

                t.positionedLines[v] = T;
                var k = T.positionedGlyphs,
                    M = 0;

                if (b.length()) {
                  for (var A = 0; A < b.length(); A++) {
                    var S = b.getSection(A),
                        E = b.getSectionIndex(A),
                        L = b.getCharCode(A),
                        C = 0,
                        P = null,
                        I = null,
                        O = null,
                        z = 24,
                        D = !(l === Cl.horizontal || !u && !Zn(L) || u && (zl[L] || (Y = L, Yn.Arabic(Y) || Yn["Arabic Supplement"](Y) || Yn["Arabic Extended-A"](Y) || Yn["Arabic Presentation Forms-A"](Y) || Yn["Arabic Presentation Forms-B"](Y))));

                    if (S.imageName) {
                      var R = n[S.imageName];
                      if (!R) continue;
                      O = S.imageName, t.iconsInText = t.iconsInText || !0, I = R.paddedRect;
                      var F = R.displaySize;
                      S.scale = 24 * S.scale / f, P = {
                        width: F[0],
                        height: F[1],
                        left: 1,
                        top: -3,
                        advance: D ? F[1] : F[0]
                      };
                      var B = 24 - F[1] * S.scale;
                      C = w + B, z = P.advance;
                      var N = D ? F[0] * S.scale - 24 * _ : F[1] * S.scale - 24 * _;
                      N > 0 && N > M && (M = N);
                    } else {
                      var j = r[S.fontStack],
                          U = j && j[L];
                      if (U && U.rect) I = U.rect, P = U.metrics;else {
                        var V = e[S.fontStack],
                            q = V && V[L];
                        if (!q) continue;
                        P = q.metrics;
                      }
                      C = 24 * (_ - S.scale);
                    }

                    D ? (t.verticalizable = !0, k.push({
                      glyph: L,
                      imageName: O,
                      x: h,
                      y: p + C,
                      vertical: D,
                      scale: S.scale,
                      fontStack: S.fontStack,
                      sectionIndex: E,
                      metrics: P,
                      rect: I
                    }), h += z * S.scale + c) : (k.push({
                      glyph: L,
                      imageName: O,
                      x: h,
                      y: p + C,
                      vertical: D,
                      scale: S.scale,
                      fontStack: S.fontStack,
                      sectionIndex: E,
                      metrics: P,
                      rect: I
                    }), h += P.advance * S.scale + c);
                  }

                  if (0 !== k.length) {
                    var H = h - c;
                    d = Math.max(H, d), Vl(k, 0, k.length - 1, g, M);
                  }

                  h = 0;
                  var G = a * _ + M;
                  T.lineOffset = Math.max(M, w), p += G, m = Math.max(G, m), ++v;
                } else p += a, ++v;
              }

              var Y;
              var W = p - -17,
                  X = Ul(o),
                  Z = X.horizontalAlign,
                  J = X.verticalAlign;
              (function (t, e, r, n, i, a, o, s, l) {
                var c = (e - r) * i,
                    u = 0;
                u = a !== o ? -s * n - -17 : (-n * l + .5) * o;

                for (var f = 0, h = t; f < h.length; f += 1) {
                  for (var p = h[f], d = 0, m = p.positionedGlyphs; d < m.length; d += 1) {
                    var g = m[d];
                    g.x += c, g.y += u;
                  }
                }
              })(t.positionedLines, g, Z, J, d, m, a, W, i.length), t.top += -J * W, t.bottom = t.top + W, t.left += -Z * d, t.right = t.left + d;
            }(C, e, r, n, g, o, s, l, f, c, h, m), !function (t) {
              for (var e = 0, r = t; e < r.length; e += 1) {
                if (0 !== r[e].positionedGlyphs.length) return !1;
              }

              return !0;
            }(L) && C;
          }

          Il.fromFeature = function (t, e) {
            for (var r = new Il(), n = 0; n < t.sections.length; n++) {
              var i = t.sections[n];
              i.image ? r.addImageSection(i) : r.addTextSection(i, e);
            }

            return r;
          }, Il.prototype.length = function () {
            return this.text.length;
          }, Il.prototype.getSection = function (t) {
            return this.sections[this.sectionIndex[t]];
          }, Il.prototype.getSectionIndex = function (t) {
            return this.sectionIndex[t];
          }, Il.prototype.getCharCode = function (t) {
            return this.text.charCodeAt(t);
          }, Il.prototype.verticalizePunctuation = function () {
            this.text = function (t) {
              for (var e = "", r = 0; r < t.length; r++) {
                var n = t.charCodeAt(r + 1) || null,
                    i = t.charCodeAt(r - 1) || null;
                (!n || !Jn(n) || rl[t[r + 1]]) && (!i || !Jn(i) || rl[t[r - 1]]) && rl[t[r]] ? e += rl[t[r]] : e += t[r];
              }

              return e;
            }(this.text);
          }, Il.prototype.trim = function () {
            for (var t = 0, e = 0; e < this.text.length && zl[this.text.charCodeAt(e)]; e++) {
              t++;
            }

            for (var r = this.text.length, n = this.text.length - 1; n >= 0 && n >= t && zl[this.text.charCodeAt(n)]; n--) {
              r--;
            }

            this.text = this.text.substring(t, r), this.sectionIndex = this.sectionIndex.slice(t, r);
          }, Il.prototype.substring = function (t, e) {
            var r = new Il();
            return r.text = this.text.substring(t, e), r.sectionIndex = this.sectionIndex.slice(t, e), r.sections = this.sections, r;
          }, Il.prototype.toString = function () {
            return this.text;
          }, Il.prototype.getMaxScale = function () {
            var t = this;
            return this.sectionIndex.reduce(function (e, r) {
              return Math.max(e, t.sections[r].scale);
            }, 0);
          }, Il.prototype.addTextSection = function (t, e) {
            this.text += t.text, this.sections.push(Pl.forText(t.scale, t.fontStack || e));

            for (var r = this.sections.length - 1, n = 0; n < t.text.length; ++n) {
              this.sectionIndex.push(r);
            }
          }, Il.prototype.addImageSection = function (t) {
            var e = t.image ? t.image.name : "";

            if (0 !== e.length) {
              var r = this.getNextImageSectionCharCode();
              r ? (this.text += String.fromCharCode(r), this.sections.push(Pl.forImage(e)), this.sectionIndex.push(this.sections.length - 1)) : _("Reached maximum number of images 6401");
            } else _("Can't add FormattedSection with an empty image.");
          }, Il.prototype.getNextImageSectionCharCode = function () {
            return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
          };
          var zl = {
            9: !0,
            10: !0,
            11: !0,
            12: !0,
            13: !0,
            32: !0
          },
              Dl = {};

          function Rl(t, e, r, n, i, a) {
            if (e.imageName) {
              var o = n[e.imageName];
              return o ? o.displaySize[0] * e.scale * 24 / a + i : 0;
            }

            var s = r[e.fontStack],
                l = s && s[t];
            return l ? l.metrics.advance * e.scale + i : 0;
          }

          function Fl(t, e, r, n) {
            var i = Math.pow(t - e, 2);
            return n ? t < e ? i / 2 : 2 * i : i + Math.abs(r) * r;
          }

          function Bl(t, e, r) {
            var n = 0;
            return 10 === t && (n -= 1e4), r && (n += 150), 40 !== t && 65288 !== t || (n += 50), 41 !== e && 65289 !== e || (n += 50), n;
          }

          function Nl(t, e, r, n, i, a) {
            for (var o = null, s = Fl(e, r, i, a), l = 0, c = n; l < c.length; l += 1) {
              var u = c[l],
                  f = Fl(e - u.x, r, i, a) + u.badness;
              f <= s && (o = u, s = f);
            }

            return {
              index: t,
              x: e,
              priorBreak: o,
              badness: s
            };
          }

          function jl(t, e, r, n, i, a, o) {
            if ("point" !== a) return [];
            if (!t) return [];

            for (var s, l = [], c = function (t, e, r, n, i, a) {
              for (var o = 0, s = 0; s < t.length(); s++) {
                var l = t.getSection(s);
                o += Rl(t.getCharCode(s), l, n, i, e, a);
              }

              return o / Math.max(1, Math.ceil(o / r));
            }(t, e, r, n, i, o), u = t.text.indexOf("\u200B") >= 0, f = 0, h = 0; h < t.length(); h++) {
              var p = t.getSection(h),
                  d = t.getCharCode(h);

              if (zl[d] || (f += Rl(d, p, n, i, e, o)), h < t.length() - 1) {
                var m = !!(!((s = d) < 11904) && (Yn["Bopomofo Extended"](s) || Yn.Bopomofo(s) || Yn["CJK Compatibility Forms"](s) || Yn["CJK Compatibility Ideographs"](s) || Yn["CJK Compatibility"](s) || Yn["CJK Radicals Supplement"](s) || Yn["CJK Strokes"](s) || Yn["CJK Symbols and Punctuation"](s) || Yn["CJK Unified Ideographs Extension A"](s) || Yn["CJK Unified Ideographs"](s) || Yn["Enclosed CJK Letters and Months"](s) || Yn["Halfwidth and Fullwidth Forms"](s) || Yn.Hiragana(s) || Yn["Ideographic Description Characters"](s) || Yn["Kangxi Radicals"](s) || Yn["Katakana Phonetic Extensions"](s) || Yn.Katakana(s) || Yn["Vertical Forms"](s) || Yn["Yi Radicals"](s) || Yn["Yi Syllables"](s)));
                (Dl[d] || m || p.imageName) && l.push(Nl(h + 1, f, c, l, Bl(d, t.getCharCode(h + 1), m && u), !1));
              }
            }

            return function t(e) {
              return e ? t(e.priorBreak).concat(e.index) : [];
            }(Nl(t.length(), f, c, l, 0, !0));
          }

          function Ul(t) {
            var e = .5,
                r = .5;

            switch (t) {
              case "right":
              case "top-right":
              case "bottom-right":
                e = 1;
                break;

              case "left":
              case "top-left":
              case "bottom-left":
                e = 0;
            }

            switch (t) {
              case "bottom":
              case "bottom-right":
              case "bottom-left":
                r = 1;
                break;

              case "top":
              case "top-right":
              case "top-left":
                r = 0;
            }

            return {
              horizontalAlign: e,
              verticalAlign: r
            };
          }

          function Vl(t, e, r, n, i) {
            if (n || i) for (var a = t[r], o = a.metrics.advance * a.scale, s = (t[r].x + o) * n, l = e; l <= r; l++) {
              t[l].x -= s, t[l].y += i;
            }
          }

          function ql(t, e, r, n, i, a) {
            var o,
                s = t.image;

            if (s.content) {
              var l = s.content,
                  c = s.pixelRatio || 1;
              o = [l[0] / c, l[1] / c, s.displaySize[0] - l[2] / c, s.displaySize[1] - l[3] / c];
            }

            var u,
                f,
                h,
                p,
                d = e.left * a,
                m = e.right * a;
            "width" === r || "both" === r ? (p = i[0] + d - n[3], f = i[0] + m + n[1]) : f = (p = i[0] + (d + m - s.displaySize[0]) / 2) + s.displaySize[0];
            var g = e.top * a,
                v = e.bottom * a;
            return "height" === r || "both" === r ? (u = i[1] + g - n[0], h = i[1] + v + n[2]) : h = (u = i[1] + (g + v - s.displaySize[1]) / 2) + s.displaySize[1], {
              image: s,
              top: u,
              right: f,
              bottom: h,
              left: p,
              collisionPadding: o
            };
          }

          Dl[10] = !0, Dl[32] = !0, Dl[38] = !0, Dl[40] = !0, Dl[41] = !0, Dl[43] = !0, Dl[45] = !0, Dl[47] = !0, Dl[173] = !0, Dl[183] = !0, Dl[8203] = !0, Dl[8208] = !0, Dl[8211] = !0, Dl[8231] = !0;

          var Hl = function (t) {
            function e(e, r, n, i) {
              t.call(this, e, r), this.angle = n, void 0 !== i && (this.segment = i);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.clone = function () {
              return new e(this.x, this.y, this.angle, this.segment);
            }, e;
          }(i);

          Nn("Anchor", Hl);

          function Gl(t, e) {
            var r = e.expression;
            if ("constant" === r.kind) return {
              kind: "constant",
              layoutSize: r.evaluate(new pi(t + 1))
            };
            if ("source" === r.kind) return {
              kind: "source"
            };

            for (var n = r.zoomStops, i = r.interpolationType, a = 0; a < n.length && n[a] <= t;) {
              a++;
            }

            for (var o = a = Math.max(0, a - 1); o < n.length && n[o] < t + 1;) {
              o++;
            }

            o = Math.min(n.length - 1, o);
            var s = n[a],
                l = n[o];
            return "composite" === r.kind ? {
              kind: "composite",
              minZoom: s,
              maxZoom: l,
              interpolationType: i
            } : {
              kind: "camera",
              minZoom: s,
              maxZoom: l,
              minSize: r.evaluate(new pi(s)),
              maxSize: r.evaluate(new pi(l)),
              interpolationType: i
            };
          }

          function Yl(t, e, r) {
            var n = e.uSize,
                i = e.uSizeT,
                a = r.lowerSize,
                o = r.upperSize;
            return "source" === t.kind ? a / 128 : "composite" === t.kind ? He(a / 128, o / 128, i) : n;
          }

          function Wl(t, e) {
            var r = 0,
                n = 0;
            if ("constant" === t.kind) n = t.layoutSize;else if ("source" !== t.kind) {
              var i = t.interpolationType,
                  a = t.minZoom,
                  o = t.maxZoom,
                  s = i ? l(or.interpolationFactor(i, e, a, o), 0, 1) : 0;
              "camera" === t.kind ? n = He(t.minSize, t.maxSize, s) : r = s;
            }
            return {
              uSizeT: r,
              uSize: n
            };
          }

          var Xl = Object.freeze({
            __proto__: null,
            getSizeData: Gl,
            evaluateSizeForFeature: Yl,
            evaluateSizeForZoom: Wl,
            SIZE_PACK_FACTOR: 128
          });

          function Zl(t, e, r, n, i) {
            if (void 0 === e.segment) return !0;

            for (var a = e, o = e.segment + 1, s = 0; s > -r / 2;) {
              if (--o < 0) return !1;
              s -= t[o].dist(a), a = t[o];
            }

            s += t[o].dist(t[o + 1]), o++;

            for (var l = [], c = 0; s < r / 2;) {
              var u = t[o - 1],
                  f = t[o],
                  h = t[o + 1];
              if (!h) return !1;
              var p = u.angleTo(f) - f.angleTo(h);

              for (p = Math.abs((p + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                distance: s,
                angleDelta: p
              }), c += p; s - l[0].distance > n;) {
                c -= l.shift().angleDelta;
              }

              if (c > i) return !1;
              o++, s += f.dist(h);
            }

            return !0;
          }

          function Jl(t) {
            for (var e = 0, r = 0; r < t.length - 1; r++) {
              e += t[r].dist(t[r + 1]);
            }

            return e;
          }

          function Kl(t, e, r) {
            return t ? .6 * e * r : 0;
          }

          function Ql(t, e) {
            return Math.max(t ? t.right - t.left : 0, e ? e.right - e.left : 0);
          }

          function $l(t, e, r, n, i, a) {
            for (var o = Kl(r, i, a), s = Ql(r, n) * a, l = 0, c = Jl(t) / 2, u = 0; u < t.length - 1; u++) {
              var f = t[u],
                  h = t[u + 1],
                  p = f.dist(h);

              if (l + p > c) {
                var d = (c - l) / p,
                    m = He(f.x, h.x, d),
                    g = He(f.y, h.y, d),
                    v = new Hl(m, g, h.angleTo(f), u);
                return v._round(), !o || Zl(t, v, s, o, e) ? v : void 0;
              }

              l += p;
            }
          }

          function tc(t, e, r, n, i, a, o, s, l) {
            var c = Kl(n, a, o),
                u = Ql(n, i),
                f = u * o,
                h = 0 === t[0].x || t[0].x === l || 0 === t[0].y || t[0].y === l;
            return e - f < e / 4 && (e = f + e / 4), function t(e, r, n, i, a, o, s, l, c) {
              for (var u = o / 2, f = Jl(e), h = 0, p = r - n, d = [], m = 0; m < e.length - 1; m++) {
                for (var g = e[m], v = e[m + 1], y = g.dist(v), x = v.angleTo(g); p + n < h + y;) {
                  var b = ((p += n) - h) / y,
                      _ = He(g.x, v.x, b),
                      w = He(g.y, v.y, b);

                  if (_ >= 0 && _ < c && w >= 0 && w < c && p - u >= 0 && p + u <= f) {
                    var T = new Hl(_, w, x, m);
                    T._round(), i && !Zl(e, T, o, i, a) || d.push(T);
                  }
                }

                h += y;
              }

              l || d.length || s || (d = t(e, h / 2, n, i, a, o, s, !0, c));
              return d;
            }(t, h ? e / 2 * s % e : (u / 2 + 2 * a) * o * s % e, e, c, r, f, h, !1, l);
          }

          function ec(t, e, r, n, a) {
            for (var o = [], s = 0; s < t.length; s++) {
              for (var l = t[s], c = void 0, u = 0; u < l.length - 1; u++) {
                var f = l[u],
                    h = l[u + 1];
                f.x < e && h.x < e || (f.x < e ? f = new i(e, f.y + (h.y - f.y) * ((e - f.x) / (h.x - f.x)))._round() : h.x < e && (h = new i(e, f.y + (h.y - f.y) * ((e - f.x) / (h.x - f.x)))._round()), f.y < r && h.y < r || (f.y < r ? f = new i(f.x + (h.x - f.x) * ((r - f.y) / (h.y - f.y)), r)._round() : h.y < r && (h = new i(f.x + (h.x - f.x) * ((r - f.y) / (h.y - f.y)), r)._round()), f.x >= n && h.x >= n || (f.x >= n ? f = new i(n, f.y + (h.y - f.y) * ((n - f.x) / (h.x - f.x)))._round() : h.x >= n && (h = new i(n, f.y + (h.y - f.y) * ((n - f.x) / (h.x - f.x)))._round()), f.y >= a && h.y >= a || (f.y >= a ? f = new i(f.x + (h.x - f.x) * ((a - f.y) / (h.y - f.y)), a)._round() : h.y >= a && (h = new i(f.x + (h.x - f.x) * ((a - f.y) / (h.y - f.y)), a)._round()), c && f.equals(c[c.length - 1]) || (c = [f], o.push(c)), c.push(h)))));
              }
            }

            return o;
          }

          function rc(t, e, r, n) {
            var a = [],
                o = t.image,
                s = o.pixelRatio,
                l = o.paddedRect.w - 2,
                c = o.paddedRect.h - 2,
                u = t.right - t.left,
                f = t.bottom - t.top,
                h = o.stretchX || [[0, l]],
                p = o.stretchY || [[0, c]],
                d = function d(t, e) {
              return t + e[1] - e[0];
            },
                m = h.reduce(d, 0),
                g = p.reduce(d, 0),
                v = l - m,
                y = c - g,
                x = 0,
                b = m,
                _ = 0,
                w = g,
                T = 0,
                k = v,
                M = 0,
                A = y;

            if (o.content && n) {
              var S = o.content;
              x = nc(h, 0, S[0]), _ = nc(p, 0, S[1]), b = nc(h, S[0], S[2]), w = nc(p, S[1], S[3]), T = S[0] - x, M = S[1] - _, k = S[2] - S[0] - b, A = S[3] - S[1] - w;
            }

            var E = function E(n, a, l, c) {
              var h = ac(n.stretch - x, b, u, t.left),
                  p = oc(n.fixed - T, k, n.stretch, m),
                  d = ac(a.stretch - _, w, f, t.top),
                  v = oc(a.fixed - M, A, a.stretch, g),
                  y = ac(l.stretch - x, b, u, t.left),
                  S = oc(l.fixed - T, k, l.stretch, m),
                  E = ac(c.stretch - _, w, f, t.top),
                  L = oc(c.fixed - M, A, c.stretch, g),
                  C = new i(h, d),
                  P = new i(y, d),
                  I = new i(y, E),
                  O = new i(h, E),
                  z = new i(p / s, v / s),
                  D = new i(S / s, L / s),
                  R = e * Math.PI / 180;

              if (R) {
                var F = Math.sin(R),
                    B = Math.cos(R),
                    N = [B, -F, F, B];
                C._matMult(N), P._matMult(N), O._matMult(N), I._matMult(N);
              }

              var j = n.stretch + n.fixed,
                  U = l.stretch + l.fixed,
                  V = a.stretch + a.fixed,
                  q = c.stretch + c.fixed;
              return {
                tl: C,
                tr: P,
                bl: O,
                br: I,
                tex: {
                  x: o.paddedRect.x + 1 + j,
                  y: o.paddedRect.y + 1 + V,
                  w: U - j,
                  h: q - V
                },
                writingMode: void 0,
                glyphOffset: [0, 0],
                sectionIndex: 0,
                pixelOffsetTL: z,
                pixelOffsetBR: D,
                minFontScaleX: k / s / u,
                minFontScaleY: A / s / f,
                isSDF: r
              };
            };

            if (n && (o.stretchX || o.stretchY)) for (var L = ic(h, v, m), C = ic(p, y, g), P = 0; P < L.length - 1; P++) {
              for (var I = L[P], O = L[P + 1], z = 0; z < C.length - 1; z++) {
                var D = C[z],
                    R = C[z + 1];
                a.push(E(I, D, O, R));
              }
            } else a.push(E({
              fixed: 0,
              stretch: -1
            }, {
              fixed: 0,
              stretch: -1
            }, {
              fixed: 0,
              stretch: l + 1
            }, {
              fixed: 0,
              stretch: c + 1
            }));
            return a;
          }

          function nc(t, e, r) {
            for (var n = 0, i = 0, a = t; i < a.length; i += 1) {
              var o = a[i];
              n += Math.max(e, Math.min(r, o[1])) - Math.max(e, Math.min(r, o[0]));
            }

            return n;
          }

          function ic(t, e, r) {
            for (var n = [{
              fixed: -1,
              stretch: 0
            }], i = 0, a = t; i < a.length; i += 1) {
              var o = a[i],
                  s = o[0],
                  l = o[1],
                  c = n[n.length - 1];
              n.push({
                fixed: s - c.stretch,
                stretch: c.stretch
              }), n.push({
                fixed: s - c.stretch,
                stretch: c.stretch + (l - s)
              });
            }

            return n.push({
              fixed: e + 1,
              stretch: r
            }), n;
          }

          function ac(t, e, r, n) {
            return t / e * r + n;
          }

          function oc(t, e, r, n) {
            return t - e * r / n;
          }

          var sc = function sc(t, e, r, n, a, o, s, l, c, u) {
            if (this.boxStartIndex = t.length, c) {
              var f = o.top,
                  h = o.bottom,
                  p = o.collisionPadding;
              p && (f -= p[1], h += p[3]);
              var d = h - f;
              d > 0 && (d = Math.max(10, d), this.circleDiameter = d);
            } else {
              var m = o.top * s - l,
                  g = o.bottom * s + l,
                  v = o.left * s - l,
                  y = o.right * s + l,
                  x = o.collisionPadding;

              if (x && (v -= x[0] * s, m -= x[1] * s, y += x[2] * s, g += x[3] * s), u) {
                var b = new i(v, m),
                    _ = new i(y, m),
                    w = new i(v, g),
                    T = new i(y, g),
                    k = u * Math.PI / 180;

                b._rotate(k), _._rotate(k), w._rotate(k), T._rotate(k), v = Math.min(b.x, _.x, w.x, T.x), y = Math.max(b.x, _.x, w.x, T.x), m = Math.min(b.y, _.y, w.y, T.y), g = Math.max(b.y, _.y, w.y, T.y);
              }

              t.emplaceBack(e.x, e.y, v, m, y, g, r, n, a);
            }

            this.boxEndIndex = t.length;
          },
              lc = function lc(t, e) {
            if (void 0 === t && (t = []), void 0 === e && (e = cc), this.data = t, this.length = this.data.length, this.compare = e, this.length > 0) for (var r = (this.length >> 1) - 1; r >= 0; r--) {
              this._down(r);
            }
          };

          function cc(t, e) {
            return t < e ? -1 : t > e ? 1 : 0;
          }

          function uc(t, e, r) {
            void 0 === e && (e = 1), void 0 === r && (r = !1);

            for (var n = 1 / 0, a = 1 / 0, o = -1 / 0, s = -1 / 0, l = t[0], c = 0; c < l.length; c++) {
              var u = l[c];
              (!c || u.x < n) && (n = u.x), (!c || u.y < a) && (a = u.y), (!c || u.x > o) && (o = u.x), (!c || u.y > s) && (s = u.y);
            }

            var f = o - n,
                h = s - a,
                p = Math.min(f, h),
                d = p / 2,
                m = new lc([], fc);
            if (0 === p) return new i(n, a);

            for (var g = n; g < o; g += p) {
              for (var v = a; v < s; v += p) {
                m.push(new hc(g + d, v + d, d, t));
              }
            }

            for (var y = function (t) {
              for (var e = 0, r = 0, n = 0, i = t[0], a = 0, o = i.length, s = o - 1; a < o; s = a++) {
                var l = i[a],
                    c = i[s],
                    u = l.x * c.y - c.x * l.y;
                r += (l.x + c.x) * u, n += (l.y + c.y) * u, e += 3 * u;
              }

              return new hc(r / e, n / e, 0, t);
            }(t), x = m.length; m.length;) {
              var b = m.pop();
              (b.d > y.d || !y.d) && (y = b, r && console.log("found best %d after %d probes", Math.round(1e4 * b.d) / 1e4, x)), b.max - y.d <= e || (d = b.h / 2, m.push(new hc(b.p.x - d, b.p.y - d, d, t)), m.push(new hc(b.p.x + d, b.p.y - d, d, t)), m.push(new hc(b.p.x - d, b.p.y + d, d, t)), m.push(new hc(b.p.x + d, b.p.y + d, d, t)), x += 4);
            }

            return r && (console.log("num probes: " + x), console.log("best distance: " + y.d)), y.p;
          }

          function fc(t, e) {
            return e.max - t.max;
          }

          function hc(t, e, r, n) {
            this.p = new i(t, e), this.h = r, this.d = function (t, e) {
              for (var r = !1, n = 1 / 0, i = 0; i < e.length; i++) {
                for (var a = e[i], o = 0, s = a.length, l = s - 1; o < s; l = o++) {
                  var c = a[o],
                      u = a[l];
                  c.y > t.y != u.y > t.y && t.x < (u.x - c.x) * (t.y - c.y) / (u.y - c.y) + c.x && (r = !r), n = Math.min(n, ro(t, c, u));
                }
              }

              return (r ? 1 : -1) * Math.sqrt(n);
            }(this.p, n), this.max = this.d + this.h * Math.SQRT2;
          }

          lc.prototype.push = function (t) {
            this.data.push(t), this.length++, this._up(this.length - 1);
          }, lc.prototype.pop = function () {
            if (0 !== this.length) {
              var t = this.data[0],
                  e = this.data.pop();
              return this.length--, this.length > 0 && (this.data[0] = e, this._down(0)), t;
            }
          }, lc.prototype.peek = function () {
            return this.data[0];
          }, lc.prototype._up = function (t) {
            for (var e = this.data, r = this.compare, n = e[t]; t > 0;) {
              var i = t - 1 >> 1,
                  a = e[i];
              if (r(n, a) >= 0) break;
              e[t] = a, t = i;
            }

            e[t] = n;
          }, lc.prototype._down = function (t) {
            for (var e = this.data, r = this.compare, n = this.length >> 1, i = e[t]; t < n;) {
              var a = 1 + (t << 1),
                  o = e[a],
                  s = a + 1;
              if (s < this.length && r(e[s], o) < 0 && (a = s, o = e[s]), r(o, i) >= 0) break;
              e[t] = o, t = a;
            }

            e[t] = i;
          };
          var pc = Number.POSITIVE_INFINITY;

          function dc(t, e) {
            return e[1] !== pc ? function (t, e, r) {
              var n = 0,
                  i = 0;

              switch (e = Math.abs(e), r = Math.abs(r), t) {
                case "top-right":
                case "top-left":
                case "top":
                  i = r - 7;
                  break;

                case "bottom-right":
                case "bottom-left":
                case "bottom":
                  i = 7 - r;
              }

              switch (t) {
                case "top-right":
                case "bottom-right":
                case "right":
                  n = -e;
                  break;

                case "top-left":
                case "bottom-left":
                case "left":
                  n = e;
              }

              return [n, i];
            }(t, e[0], e[1]) : function (t, e) {
              var r = 0,
                  n = 0;
              e < 0 && (e = 0);
              var i = e / Math.sqrt(2);

              switch (t) {
                case "top-right":
                case "top-left":
                  n = i - 7;
                  break;

                case "bottom-right":
                case "bottom-left":
                  n = 7 - i;
                  break;

                case "bottom":
                  n = 7 - e;
                  break;

                case "top":
                  n = e - 7;
              }

              switch (t) {
                case "top-right":
                case "bottom-right":
                  r = -i;
                  break;

                case "top-left":
                case "bottom-left":
                  r = i;
                  break;

                case "left":
                  r = e;
                  break;

                case "right":
                  r = -e;
              }

              return [r, n];
            }(t, e[0]);
          }

          function mc(t) {
            switch (t) {
              case "right":
              case "top-right":
              case "bottom-right":
                return "right";

              case "left":
              case "top-left":
              case "bottom-left":
                return "left";
            }

            return "center";
          }

          function gc(t, e, r, n, a, o, s, l, c, u, f, h, p, d, m) {
            var g = function (t, e, r, n, a, o, s, l) {
              for (var c = n.layout.get("text-rotate").evaluate(o, {}) * Math.PI / 180, u = [], f = 0, h = e.positionedLines; f < h.length; f += 1) {
                for (var p = h[f], d = 0, m = p.positionedGlyphs; d < m.length; d += 1) {
                  var g = m[d];

                  if (g.rect) {
                    var v = g.rect || {},
                        y = 4,
                        x = !0,
                        b = 1,
                        _ = 0,
                        w = (a || l) && g.vertical,
                        T = g.metrics.advance * g.scale / 2;

                    if (l && e.verticalizable) {
                      var k = 24 * (g.scale - 1),
                          M = (24 - g.metrics.width * g.scale) / 2;
                      _ = p.lineOffset / 2 - (g.imageName ? -M : k);
                    }

                    if (g.imageName) {
                      var A = s[g.imageName];
                      x = A.sdf, y = 1 / (b = A.pixelRatio);
                    }

                    var S = a ? [g.x + T, g.y] : [0, 0],
                        E = a ? [0, 0] : [g.x + T + r[0], g.y + r[1] - _],
                        L = [0, 0];
                    w && (L = E, E = [0, 0]);
                    var C = (g.metrics.left - y) * g.scale - T + E[0],
                        P = (-g.metrics.top - y) * g.scale + E[1],
                        I = C + v.w * g.scale / b,
                        O = P + v.h * g.scale / b,
                        z = new i(C, P),
                        D = new i(I, P),
                        R = new i(C, O),
                        F = new i(I, O);

                    if (w) {
                      var B = new i(-T, T - -17),
                          N = -Math.PI / 2,
                          j = 12 - T,
                          U = g.imageName ? j : 0,
                          V = new i(22 - j, -U),
                          q = new (Function.prototype.bind.apply(i, [null].concat(L)))();
                      z._rotateAround(N, B)._add(V)._add(q), D._rotateAround(N, B)._add(V)._add(q), R._rotateAround(N, B)._add(V)._add(q), F._rotateAround(N, B)._add(V)._add(q);
                    }

                    if (c) {
                      var H = Math.sin(c),
                          G = Math.cos(c),
                          Y = [G, -H, H, G];
                      z._matMult(Y), D._matMult(Y), R._matMult(Y), F._matMult(Y);
                    }

                    var W = new i(0, 0),
                        X = new i(0, 0);
                    u.push({
                      tl: z,
                      tr: D,
                      bl: R,
                      br: F,
                      tex: v,
                      writingMode: e.writingMode,
                      glyphOffset: S,
                      sectionIndex: g.sectionIndex,
                      isSDF: x,
                      pixelOffsetTL: W,
                      pixelOffsetBR: X,
                      minFontScaleX: 0,
                      minFontScaleY: 0
                    });
                  }
                }
              }

              return u;
            }(0, r, l, a, o, s, n, t.allowVerticalPlacement),
                v = t.textSizeData,
                y = null;

            "source" === v.kind ? (y = [128 * a.layout.get("text-size").evaluate(s, {})])[0] > 32640 && _(t.layerIds[0] + ': Value for "text-size" is >= 255. Reduce your "text-size".') : "composite" === v.kind && ((y = [128 * d.compositeTextSizes[0].evaluate(s, {}, m), 128 * d.compositeTextSizes[1].evaluate(s, {}, m)])[0] > 32640 || y[1] > 32640) && _(t.layerIds[0] + ': Value for "text-size" is >= 255. Reduce your "text-size".'), t.addSymbols(t.text, g, y, l, o, s, u, e, c.lineStartIndex, c.lineLength, p, m);

            for (var x = 0, b = f; x < b.length; x += 1) {
              h[b[x]] = t.text.placedSymbolArray.length - 1;
            }

            return 4 * g.length;
          }

          function vc(t) {
            for (var e in t) {
              return t[e];
            }

            return null;
          }

          function yc(t, e, r, n) {
            var i = t.compareText;

            if (e in i) {
              for (var a = i[e], o = a.length - 1; o >= 0; o--) {
                if (n.dist(a[o]) < r) return !0;
              }
            } else i[e] = [];

            return i[e].push(n), !1;
          }

          var xc = Ls.VectorTileFeature.types,
              bc = [{
            name: "a_fade_opacity",
            components: 1,
            type: "Uint8",
            offset: 0
          }];

          function _c(t, e, r, n, i, a, o, s, l, c, u, f, h) {
            var p = s ? Math.min(32640, Math.round(s[0])) : 0,
                d = s ? Math.min(32640, Math.round(s[1])) : 0;
            t.emplaceBack(e, r, Math.round(32 * n), Math.round(32 * i), a, o, (p << 1) + (l ? 1 : 0), d, 16 * c, 16 * u, 256 * f, 256 * h);
          }

          function wc(t, e, r) {
            t.emplaceBack(e.x, e.y, r), t.emplaceBack(e.x, e.y, r), t.emplaceBack(e.x, e.y, r), t.emplaceBack(e.x, e.y, r);
          }

          function Tc(t) {
            for (var e = 0, r = t.sections; e < r.length; e += 1) {
              if ($n(r[e].text)) return !0;
            }

            return !1;
          }

          var kc = function kc(t) {
            this.layoutVertexArray = new Ni(), this.indexArray = new Yi(), this.programConfigurations = t, this.segments = new pa(), this.dynamicLayoutVertexArray = new ji(), this.opacityVertexArray = new Ui(), this.placedSymbolArray = new aa();
          };

          kc.prototype.isEmpty = function () {
            return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
          }, kc.prototype.upload = function (t, e, r, n) {
            this.isEmpty() || (r && (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, Js.members), this.indexBuffer = t.createIndexBuffer(this.indexArray, e), this.dynamicLayoutVertexBuffer = t.createVertexBuffer(this.dynamicLayoutVertexArray, Ks.members, !0), this.opacityVertexBuffer = t.createVertexBuffer(this.opacityVertexArray, bc, !0), this.opacityVertexBuffer.itemSize = 1), (r || n) && this.programConfigurations.upload(t));
          }, kc.prototype.destroy = function () {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
          }, Nn("SymbolBuffers", kc);

          var Mc = function Mc(t, e, r) {
            this.layoutVertexArray = new t(), this.layoutAttributes = e, this.indexArray = new r(), this.segments = new pa(), this.collisionVertexArray = new Gi();
          };

          Mc.prototype.upload = function (t) {
            this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t.createVertexBuffer(this.collisionVertexArray, Qs.members, !0);
          }, Mc.prototype.destroy = function () {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
          }, Nn("CollisionBuffers", Mc);

          var Ac = function Ac(t) {
            this.collisionBoxArray = t.collisionBoxArray, this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map(function (t) {
              return t.id;
            }), this.index = t.index, this.pixelRatio = t.pixelRatio, this.sourceLayerIndex = t.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = ho([]), this.placementViewportMatrix = ho([]);
            var e = this.layers[0]._unevaluatedLayout._values;
            this.textSizeData = Gl(this.zoom, e["text-size"]), this.iconSizeData = Gl(this.zoom, e["icon-size"]);
            var r = this.layers[0].layout,
                n = r.get("symbol-sort-key"),
                i = r.get("symbol-z-order");
            this.sortFeaturesByKey = "viewport-y" !== i && void 0 !== n.constantOr(1);
            var a = "viewport-y" === i || "auto" === i && !this.sortFeaturesByKey;
            this.sortFeaturesByY = a && (r.get("text-allow-overlap") || r.get("icon-allow-overlap") || r.get("text-ignore-placement") || r.get("icon-ignore-placement")), "point" === r.get("symbol-placement") && (this.writingModes = r.get("text-writing-mode").map(function (t) {
              return Cl[t];
            })), this.stateDependentLayerIds = this.layers.filter(function (t) {
              return t.isStateDependent();
            }).map(function (t) {
              return t.id;
            }), this.sourceID = t.sourceID;
          };

          Ac.prototype.createArrays = function () {
            this.text = new kc(new Ua(Js.members, this.layers, this.zoom, function (t) {
              return /^text/.test(t);
            })), this.icon = new kc(new Ua(Js.members, this.layers, this.zoom, function (t) {
              return /^icon/.test(t);
            })), this.glyphOffsetArray = new la(), this.lineVertexArray = new ca(), this.symbolInstances = new sa();
          }, Ac.prototype.calculateGlyphDependencies = function (t, e, r, n, i) {
            for (var a = 0; a < t.length; a++) {
              if (e[t.charCodeAt(a)] = !0, (r || n) && i) {
                var o = rl[t.charAt(a)];
                o && (e[o.charCodeAt(0)] = !0);
              }
            }
          }, Ac.prototype.populate = function (t, e, r) {
            var n = this.layers[0],
                i = n.layout,
                a = i.get("text-font"),
                o = i.get("text-field"),
                s = i.get("icon-image"),
                l = ("constant" !== o.value.kind || o.value.value instanceof ne && !o.value.value.isEmpty() || o.value.value.toString().length > 0) && ("constant" !== a.value.kind || a.value.value.length > 0),
                c = "constant" !== s.value.kind || !!s.value.value || Object.keys(s.parameters).length > 0,
                u = i.get("symbol-sort-key");

            if (this.features = [], l || c) {
              for (var f = e.iconDependencies, h = e.glyphDependencies, p = e.availableImages, d = new pi(this.zoom), m = 0, g = t; m < g.length; m += 1) {
                var v = g[m],
                    y = v.feature,
                    x = v.id,
                    b = v.index,
                    _ = v.sourceLayerIndex,
                    w = n._featureFilter.needGeometry,
                    T = {
                  type: y.type,
                  id: x,
                  properties: y.properties,
                  geometry: w ? Ya(y) : []
                };

                if (n._featureFilter.filter(d, T, r)) {
                  w || (T.geometry = Ya(y));
                  var k = void 0;

                  if (l) {
                    var M = n.getValueAndResolveTokens("text-field", T, r, p),
                        A = ne.factory(M);
                    Tc(A) && (this.hasRTLText = !0), (!this.hasRTLText || "unavailable" === ui() || this.hasRTLText && hi.isParsed()) && (k = el(A, n, T));
                  }

                  var S = void 0;

                  if (c) {
                    var E = n.getValueAndResolveTokens("icon-image", T, r, p);
                    S = E instanceof ie ? E : ie.fromString(E);
                  }

                  if (k || S) {
                    var L = this.sortFeaturesByKey ? u.evaluate(T, {}, r) : void 0,
                        C = {
                      id: x,
                      text: k,
                      icon: S,
                      index: b,
                      sourceLayerIndex: _,
                      geometry: Ya(y),
                      properties: y.properties,
                      type: xc[y.type],
                      sortKey: L
                    };

                    if (this.features.push(C), S && (f[S.name] = !0), k) {
                      var P = a.evaluate(T, {}, r).join(","),
                          I = "map" === i.get("text-rotation-alignment") && "point" !== i.get("symbol-placement");
                      this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(Cl.vertical) >= 0;

                      for (var O = 0, z = k.sections; O < z.length; O += 1) {
                        var D = z[O];
                        if (D.image) f[D.image.name] = !0;else {
                          var R = Wn(k.toString()),
                              F = D.fontStack || P,
                              B = h[F] = h[F] || {};
                          this.calculateGlyphDependencies(D.text, B, I, this.allowVerticalPlacement, R);
                        }
                      }
                    }
                  }
                }
              }

              "line" === i.get("symbol-placement") && (this.features = function (t) {
                var e = {},
                    r = {},
                    n = [],
                    i = 0;

                function a(e) {
                  n.push(t[e]), i++;
                }

                function o(t, e, i) {
                  var a = r[t];
                  return delete r[t], r[e] = a, n[a].geometry[0].pop(), n[a].geometry[0] = n[a].geometry[0].concat(i[0]), a;
                }

                function s(t, r, i) {
                  var a = e[r];
                  return delete e[r], e[t] = a, n[a].geometry[0].shift(), n[a].geometry[0] = i[0].concat(n[a].geometry[0]), a;
                }

                function l(t, e, r) {
                  var n = r ? e[0][e[0].length - 1] : e[0][0];
                  return t + ":" + n.x + ":" + n.y;
                }

                for (var c = 0; c < t.length; c++) {
                  var u = t[c],
                      f = u.geometry,
                      h = u.text ? u.text.toString() : null;

                  if (h) {
                    var p = l(h, f),
                        d = l(h, f, !0);

                    if (p in r && d in e && r[p] !== e[d]) {
                      var m = s(p, d, f),
                          g = o(p, d, n[m].geometry);
                      delete e[p], delete r[d], r[l(h, n[g].geometry, !0)] = g, n[m].geometry = null;
                    } else p in r ? o(p, d, f) : d in e ? s(p, d, f) : (a(c), e[p] = i - 1, r[d] = i - 1);
                  } else a(c);
                }

                return n.filter(function (t) {
                  return t.geometry;
                });
              }(this.features)), this.sortFeaturesByKey && this.features.sort(function (t, e) {
                return t.sortKey - e.sortKey;
              });
            }
          }, Ac.prototype.update = function (t, e, r) {
            this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(t, e, this.layers, r), this.icon.programConfigurations.updatePaintArrays(t, e, this.layers, r));
          }, Ac.prototype.isEmpty = function () {
            return 0 === this.symbolInstances.length && !this.hasRTLText;
          }, Ac.prototype.uploadPending = function () {
            return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
          }, Ac.prototype.upload = function (t) {
            !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t), this.iconCollisionBox.upload(t)), this.text.upload(t, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(t, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
          }, Ac.prototype.destroyDebugData = function () {
            this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
          }, Ac.prototype.destroy = function () {
            this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
          }, Ac.prototype.addToLineVertexArray = function (t, e) {
            var r = this.lineVertexArray.length;

            if (void 0 !== t.segment) {
              for (var n = t.dist(e[t.segment + 1]), i = t.dist(e[t.segment]), a = {}, o = t.segment + 1; o < e.length; o++) {
                a[o] = {
                  x: e[o].x,
                  y: e[o].y,
                  tileUnitDistanceFromAnchor: n
                }, o < e.length - 1 && (n += e[o + 1].dist(e[o]));
              }

              for (var s = t.segment || 0; s >= 0; s--) {
                a[s] = {
                  x: e[s].x,
                  y: e[s].y,
                  tileUnitDistanceFromAnchor: i
                }, s > 0 && (i += e[s - 1].dist(e[s]));
              }

              for (var l = 0; l < e.length; l++) {
                var c = a[l];
                this.lineVertexArray.emplaceBack(c.x, c.y, c.tileUnitDistanceFromAnchor);
              }
            }

            return {
              lineStartIndex: r,
              lineLength: this.lineVertexArray.length - r
            };
          }, Ac.prototype.addSymbols = function (t, e, r, n, i, a, o, s, l, c, u, f) {
            for (var h = t.indexArray, p = t.layoutVertexArray, d = t.segments.prepareSegment(4 * e.length, p, h, a.sortKey), m = this.glyphOffsetArray.length, g = d.vertexLength, v = this.allowVerticalPlacement && o === Cl.vertical ? Math.PI / 2 : 0, y = a.text && a.text.sections, x = 0; x < e.length; x++) {
              var b = e[x],
                  _ = b.tl,
                  w = b.tr,
                  T = b.bl,
                  k = b.br,
                  M = b.tex,
                  A = b.pixelOffsetTL,
                  S = b.pixelOffsetBR,
                  E = b.minFontScaleX,
                  L = b.minFontScaleY,
                  C = b.glyphOffset,
                  P = b.isSDF,
                  I = b.sectionIndex,
                  O = d.vertexLength,
                  z = C[1];
              _c(p, s.x, s.y, _.x, z + _.y, M.x, M.y, r, P, A.x, A.y, E, L), _c(p, s.x, s.y, w.x, z + w.y, M.x + M.w, M.y, r, P, S.x, A.y, E, L), _c(p, s.x, s.y, T.x, z + T.y, M.x, M.y + M.h, r, P, A.x, S.y, E, L), _c(p, s.x, s.y, k.x, z + k.y, M.x + M.w, M.y + M.h, r, P, S.x, S.y, E, L), wc(t.dynamicLayoutVertexArray, s, v), h.emplaceBack(O, O + 1, O + 2), h.emplaceBack(O + 1, O + 2, O + 3), d.vertexLength += 4, d.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(C[0]), x !== e.length - 1 && I === e[x + 1].sectionIndex || t.programConfigurations.populatePaintArrays(p.length, a, a.index, {}, f, y && y[I]);
            }

            t.placedSymbolArray.emplaceBack(s.x, s.y, m, this.glyphOffsetArray.length - m, g, l, c, s.segment, r ? r[0] : 0, r ? r[1] : 0, n[0], n[1], o, 0, !1, 0, u);
          }, Ac.prototype._addCollisionDebugVertex = function (t, e, r, n, i, a) {
            return e.emplaceBack(0, 0), t.emplaceBack(r.x, r.y, n, i, Math.round(a.x), Math.round(a.y));
          }, Ac.prototype.addCollisionDebugVertices = function (t, e, r, n, a, o, s) {
            var l = a.segments.prepareSegment(4, a.layoutVertexArray, a.indexArray),
                c = l.vertexLength,
                u = a.layoutVertexArray,
                f = a.collisionVertexArray,
                h = s.anchorX,
                p = s.anchorY;
            this._addCollisionDebugVertex(u, f, o, h, p, new i(t, e)), this._addCollisionDebugVertex(u, f, o, h, p, new i(r, e)), this._addCollisionDebugVertex(u, f, o, h, p, new i(r, n)), this._addCollisionDebugVertex(u, f, o, h, p, new i(t, n)), l.vertexLength += 4;
            var d = a.indexArray;
            d.emplaceBack(c, c + 1), d.emplaceBack(c + 1, c + 2), d.emplaceBack(c + 2, c + 3), d.emplaceBack(c + 3, c), l.primitiveLength += 4;
          }, Ac.prototype.addDebugCollisionBoxes = function (t, e, r, n) {
            for (var i = t; i < e; i++) {
              var a = this.collisionBoxArray.get(i),
                  o = a.x1,
                  s = a.y1,
                  l = a.x2,
                  c = a.y2;
              this.addCollisionDebugVertices(o, s, l, c, n ? this.textCollisionBox : this.iconCollisionBox, a.anchorPoint, r);
            }
          }, Ac.prototype.generateCollisionDebugBuffers = function () {
            this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new Mc(qi, $s.members, Qi), this.iconCollisionBox = new Mc(qi, $s.members, Qi);

            for (var t = 0; t < this.symbolInstances.length; t++) {
              var e = this.symbolInstances.get(t);
              this.addDebugCollisionBoxes(e.textBoxStartIndex, e.textBoxEndIndex, e, !0), this.addDebugCollisionBoxes(e.verticalTextBoxStartIndex, e.verticalTextBoxEndIndex, e, !0), this.addDebugCollisionBoxes(e.iconBoxStartIndex, e.iconBoxEndIndex, e, !1), this.addDebugCollisionBoxes(e.verticalIconBoxStartIndex, e.verticalIconBoxEndIndex, e, !1);
            }
          }, Ac.prototype._deserializeCollisionBoxesForSymbol = function (t, e, r, n, i, a, o, s, l) {
            for (var c = {}, u = e; u < r; u++) {
              var f = t.get(u);
              c.textBox = {
                x1: f.x1,
                y1: f.y1,
                x2: f.x2,
                y2: f.y2,
                anchorPointX: f.anchorPointX,
                anchorPointY: f.anchorPointY
              }, c.textFeatureIndex = f.featureIndex;
              break;
            }

            for (var h = n; h < i; h++) {
              var p = t.get(h);
              c.verticalTextBox = {
                x1: p.x1,
                y1: p.y1,
                x2: p.x2,
                y2: p.y2,
                anchorPointX: p.anchorPointX,
                anchorPointY: p.anchorPointY
              }, c.verticalTextFeatureIndex = p.featureIndex;
              break;
            }

            for (var d = a; d < o; d++) {
              var m = t.get(d);
              c.iconBox = {
                x1: m.x1,
                y1: m.y1,
                x2: m.x2,
                y2: m.y2,
                anchorPointX: m.anchorPointX,
                anchorPointY: m.anchorPointY
              }, c.iconFeatureIndex = m.featureIndex;
              break;
            }

            for (var g = s; g < l; g++) {
              var v = t.get(g);
              c.verticalIconBox = {
                x1: v.x1,
                y1: v.y1,
                x2: v.x2,
                y2: v.y2,
                anchorPointX: v.anchorPointX,
                anchorPointY: v.anchorPointY
              }, c.verticalIconFeatureIndex = v.featureIndex;
              break;
            }

            return c;
          }, Ac.prototype.deserializeCollisionBoxes = function (t) {
            this.collisionArrays = [];

            for (var e = 0; e < this.symbolInstances.length; e++) {
              var r = this.symbolInstances.get(e);
              this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t, r.textBoxStartIndex, r.textBoxEndIndex, r.verticalTextBoxStartIndex, r.verticalTextBoxEndIndex, r.iconBoxStartIndex, r.iconBoxEndIndex, r.verticalIconBoxStartIndex, r.verticalIconBoxEndIndex));
            }
          }, Ac.prototype.hasTextData = function () {
            return this.text.segments.get().length > 0;
          }, Ac.prototype.hasIconData = function () {
            return this.icon.segments.get().length > 0;
          }, Ac.prototype.hasDebugData = function () {
            return this.textCollisionBox && this.iconCollisionBox;
          }, Ac.prototype.hasTextCollisionBoxData = function () {
            return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
          }, Ac.prototype.hasIconCollisionBoxData = function () {
            return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
          }, Ac.prototype.addIndicesForPlacedSymbol = function (t, e) {
            for (var r = t.placedSymbolArray.get(e), n = r.vertexStartIndex + 4 * r.numGlyphs, i = r.vertexStartIndex; i < n; i += 4) {
              t.indexArray.emplaceBack(i, i + 1, i + 2), t.indexArray.emplaceBack(i + 1, i + 2, i + 3);
            }
          }, Ac.prototype.getSortedSymbolIndexes = function (t) {
            if (this.sortedAngle === t && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;

            for (var e = Math.sin(t), r = Math.cos(t), n = [], i = [], a = [], o = 0; o < this.symbolInstances.length; ++o) {
              a.push(o);
              var s = this.symbolInstances.get(o);
              n.push(0 | Math.round(e * s.anchorX + r * s.anchorY)), i.push(s.featureIndex);
            }

            return a.sort(function (t, e) {
              return n[t] - n[e] || i[e] - i[t];
            }), a;
          }, Ac.prototype.addToSortKeyRanges = function (t, e) {
            var r = this.sortKeyRanges[this.sortKeyRanges.length - 1];
            r && r.sortKey === e ? r.symbolInstanceEnd = t + 1 : this.sortKeyRanges.push({
              sortKey: e,
              symbolInstanceStart: t,
              symbolInstanceEnd: t + 1
            });
          }, Ac.prototype.sortFeatures = function (t) {
            var e = this;

            if (this.sortFeaturesByY && this.sortedAngle !== t && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
              this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t), this.sortedAngle = t, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];

              for (var r = 0, n = this.symbolInstanceIndexes; r < n.length; r += 1) {
                var i = n[r],
                    a = this.symbolInstances.get(i);
                this.featureSortOrder.push(a.featureIndex), [a.rightJustifiedTextSymbolIndex, a.centerJustifiedTextSymbolIndex, a.leftJustifiedTextSymbolIndex].forEach(function (t, r, n) {
                  t >= 0 && n.indexOf(t) === r && e.addIndicesForPlacedSymbol(e.text, t);
                }), a.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, a.verticalPlacedTextSymbolIndex), a.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, a.placedIconSymbolIndex), a.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, a.verticalPlacedIconSymbolIndex);
              }

              this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
            }
          }, Nn("SymbolBucket", Ac, {
            omit: ["layers", "collisionBoxArray", "features", "compareText"]
          }), Ac.MAX_GLYPHS = 65535, Ac.addDynamicAttributes = wc;

          var Sc = new Si({
            "symbol-placement": new wi(Lt.layout_symbol["symbol-placement"]),
            "symbol-spacing": new wi(Lt.layout_symbol["symbol-spacing"]),
            "symbol-avoid-edges": new wi(Lt.layout_symbol["symbol-avoid-edges"]),
            "symbol-sort-key": new Ti(Lt.layout_symbol["symbol-sort-key"]),
            "symbol-z-order": new wi(Lt.layout_symbol["symbol-z-order"]),
            "icon-allow-overlap": new wi(Lt.layout_symbol["icon-allow-overlap"]),
            "icon-ignore-placement": new wi(Lt.layout_symbol["icon-ignore-placement"]),
            "icon-optional": new wi(Lt.layout_symbol["icon-optional"]),
            "icon-rotation-alignment": new wi(Lt.layout_symbol["icon-rotation-alignment"]),
            "icon-size": new Ti(Lt.layout_symbol["icon-size"]),
            "icon-text-fit": new wi(Lt.layout_symbol["icon-text-fit"]),
            "icon-text-fit-padding": new wi(Lt.layout_symbol["icon-text-fit-padding"]),
            "icon-image": new Ti(Lt.layout_symbol["icon-image"]),
            "icon-rotate": new Ti(Lt.layout_symbol["icon-rotate"]),
            "icon-padding": new wi(Lt.layout_symbol["icon-padding"]),
            "icon-keep-upright": new wi(Lt.layout_symbol["icon-keep-upright"]),
            "icon-offset": new Ti(Lt.layout_symbol["icon-offset"]),
            "icon-anchor": new Ti(Lt.layout_symbol["icon-anchor"]),
            "icon-pitch-alignment": new wi(Lt.layout_symbol["icon-pitch-alignment"]),
            "text-pitch-alignment": new wi(Lt.layout_symbol["text-pitch-alignment"]),
            "text-rotation-alignment": new wi(Lt.layout_symbol["text-rotation-alignment"]),
            "text-field": new Ti(Lt.layout_symbol["text-field"]),
            "text-font": new Ti(Lt.layout_symbol["text-font"]),
            "text-size": new Ti(Lt.layout_symbol["text-size"]),
            "text-max-width": new Ti(Lt.layout_symbol["text-max-width"]),
            "text-line-height": new wi(Lt.layout_symbol["text-line-height"]),
            "text-letter-spacing": new Ti(Lt.layout_symbol["text-letter-spacing"]),
            "text-justify": new Ti(Lt.layout_symbol["text-justify"]),
            "text-radial-offset": new Ti(Lt.layout_symbol["text-radial-offset"]),
            "text-variable-anchor": new wi(Lt.layout_symbol["text-variable-anchor"]),
            "text-anchor": new Ti(Lt.layout_symbol["text-anchor"]),
            "text-max-angle": new wi(Lt.layout_symbol["text-max-angle"]),
            "text-writing-mode": new wi(Lt.layout_symbol["text-writing-mode"]),
            "text-rotate": new Ti(Lt.layout_symbol["text-rotate"]),
            "text-padding": new wi(Lt.layout_symbol["text-padding"]),
            "text-keep-upright": new wi(Lt.layout_symbol["text-keep-upright"]),
            "text-transform": new Ti(Lt.layout_symbol["text-transform"]),
            "text-offset": new Ti(Lt.layout_symbol["text-offset"]),
            "text-allow-overlap": new wi(Lt.layout_symbol["text-allow-overlap"]),
            "text-ignore-placement": new wi(Lt.layout_symbol["text-ignore-placement"]),
            "text-optional": new wi(Lt.layout_symbol["text-optional"])
          }),
              Ec = {
            paint: new Si({
              "icon-opacity": new Ti(Lt.paint_symbol["icon-opacity"]),
              "icon-color": new Ti(Lt.paint_symbol["icon-color"]),
              "icon-halo-color": new Ti(Lt.paint_symbol["icon-halo-color"]),
              "icon-halo-width": new Ti(Lt.paint_symbol["icon-halo-width"]),
              "icon-halo-blur": new Ti(Lt.paint_symbol["icon-halo-blur"]),
              "icon-translate": new wi(Lt.paint_symbol["icon-translate"]),
              "icon-translate-anchor": new wi(Lt.paint_symbol["icon-translate-anchor"]),
              "text-opacity": new Ti(Lt.paint_symbol["text-opacity"]),
              "text-color": new Ti(Lt.paint_symbol["text-color"], {
                runtimeType: Ut,
                getOverride: function getOverride(t) {
                  return t.textColor;
                },
                hasOverride: function hasOverride(t) {
                  return !!t.textColor;
                }
              }),
              "text-halo-color": new Ti(Lt.paint_symbol["text-halo-color"]),
              "text-halo-width": new Ti(Lt.paint_symbol["text-halo-width"]),
              "text-halo-blur": new Ti(Lt.paint_symbol["text-halo-blur"]),
              "text-translate": new wi(Lt.paint_symbol["text-translate"]),
              "text-translate-anchor": new wi(Lt.paint_symbol["text-translate-anchor"])
            }),
            layout: Sc
          },
              Lc = function Lc(t) {
            this.type = t.property.overrides ? t.property.overrides.runtimeType : Ft, this.defaultValue = t;
          };

          Lc.prototype.evaluate = function (t) {
            if (t.formattedSection) {
              var e = this.defaultValue.property.overrides;
              if (e && e.hasOverride(t.formattedSection)) return e.getOverride(t.formattedSection);
            }

            return t.feature && t.featureState ? this.defaultValue.evaluate(t.feature, t.featureState) : this.defaultValue.property.specification.default;
          }, Lc.prototype.eachChild = function (t) {
            this.defaultValue.isConstant() || t(this.defaultValue.value._styleExpression.expression);
          }, Lc.prototype.outputDefined = function () {
            return !1;
          }, Lc.prototype.serialize = function () {
            return null;
          }, Nn("FormatSectionOverride", Lc, {
            omit: ["defaultValue"]
          });

          var Cc = function (t) {
            function e(e) {
              t.call(this, e, Ec);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.recalculate = function (e, r) {
              if (t.prototype.recalculate.call(this, e, r), "auto" === this.layout.get("icon-rotation-alignment") && ("point" !== this.layout.get("symbol-placement") ? this.layout._values["icon-rotation-alignment"] = "map" : this.layout._values["icon-rotation-alignment"] = "viewport"), "auto" === this.layout.get("text-rotation-alignment") && ("point" !== this.layout.get("symbol-placement") ? this.layout._values["text-rotation-alignment"] = "map" : this.layout._values["text-rotation-alignment"] = "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), "point" === this.layout.get("symbol-placement")) {
                var n = this.layout.get("text-writing-mode");

                if (n) {
                  for (var i = [], a = 0, o = n; a < o.length; a += 1) {
                    var s = o[a];
                    i.indexOf(s) < 0 && i.push(s);
                  }

                  this.layout._values["text-writing-mode"] = i;
                } else this.layout._values["text-writing-mode"] = ["horizontal"];
              }

              this._setPaintOverrides();
            }, e.prototype.getValueAndResolveTokens = function (t, e, r, n) {
              var i = this.layout.get(t).evaluate(e, {}, r, n),
                  a = this._unevaluatedLayout._values[t];
              return a.isDataDriven() || Yr(a.value) || !i ? i : function (t, e) {
                return e.replace(/{([^{}]+)}/g, function (e, r) {
                  return r in t ? String(t[r]) : "";
                });
              }(e.properties, i);
            }, e.prototype.createBucket = function (t) {
              return new Ac(t);
            }, e.prototype.queryRadius = function () {
              return 0;
            }, e.prototype.queryIntersectsFeature = function () {
              return !1;
            }, e.prototype._setPaintOverrides = function () {
              for (var t = 0, r = Ec.paint.overridableProperties; t < r.length; t += 1) {
                var n = r[t];

                if (e.hasPaintOverride(this.layout, n)) {
                  var i = this.paint.get(n),
                      a = new Lc(i),
                      o = new Gr(a, i.property.specification),
                      s = null;
                  s = "constant" === i.value.kind || "source" === i.value.kind ? new Xr("source", o) : new Zr("composite", o, i.value.zoomStops, i.value._interpolationType), this.paint._values[n] = new bi(i.property, s, i.parameters);
                }
              }
            }, e.prototype._handleOverridablePaintPropertyUpdate = function (t, r, n) {
              return !(!this.layout || r.isDataDriven() || n.isDataDriven()) && e.hasPaintOverride(this.layout, t);
            }, e.hasPaintOverride = function (t, e) {
              var r = t.get("text-field"),
                  n = Ec.paint.properties[e],
                  i = !1,
                  a = function a(t) {
                for (var e = 0, r = t; e < r.length; e += 1) {
                  var a = r[e];
                  if (n.overrides && n.overrides.hasOverride(a)) return void (i = !0);
                }
              };

              if ("constant" === r.value.kind && r.value.value instanceof ne) a(r.value.value.sections);else if ("source" === r.value.kind) {
                var o = function o(t) {
                  if (!i) if (t instanceof ce && se(t.value) === Gt) {
                    var e = t.value;
                    a(e.sections);
                  } else t instanceof pe ? a(t.sections) : t.eachChild(o);
                },
                    s = r.value;

                s._styleExpression && o(s._styleExpression.expression);
              }
              return i;
            }, e;
          }(Ei),
              Pc = {
            paint: new Si({
              "background-color": new wi(Lt.paint_background["background-color"]),
              "background-pattern": new Mi(Lt.paint_background["background-pattern"]),
              "background-opacity": new wi(Lt.paint_background["background-opacity"])
            })
          },
              Ic = function (t) {
            function e(e) {
              t.call(this, e, Pc);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
          }(Ei),
              Oc = {
            paint: new Si({
              "raster-opacity": new wi(Lt.paint_raster["raster-opacity"]),
              "raster-hue-rotate": new wi(Lt.paint_raster["raster-hue-rotate"]),
              "raster-brightness-min": new wi(Lt.paint_raster["raster-brightness-min"]),
              "raster-brightness-max": new wi(Lt.paint_raster["raster-brightness-max"]),
              "raster-saturation": new wi(Lt.paint_raster["raster-saturation"]),
              "raster-contrast": new wi(Lt.paint_raster["raster-contrast"]),
              "raster-resampling": new wi(Lt.paint_raster["raster-resampling"]),
              "raster-fade-duration": new wi(Lt.paint_raster["raster-fade-duration"])
            })
          },
              zc = function (t) {
            function e(e) {
              t.call(this, e, Oc);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
          }(Ei);

          var Dc = function (t) {
            function e(e) {
              t.call(this, e, {}), this.implementation = e;
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.is3D = function () {
              return "3d" === this.implementation.renderingMode;
            }, e.prototype.hasOffscreenPass = function () {
              return void 0 !== this.implementation.prerender;
            }, e.prototype.recalculate = function () {}, e.prototype.updateTransitions = function () {}, e.prototype.hasTransition = function () {}, e.prototype.serialize = function () {}, e.prototype.onAdd = function (t) {
              this.implementation.onAdd && this.implementation.onAdd(t, t.painter.context.gl);
            }, e.prototype.onRemove = function (t) {
              this.implementation.onRemove && this.implementation.onRemove(t, t.painter.context.gl);
            }, e;
          }(Ei),
              Rc = {
            circle: _o,
            heatmap: Po,
            hillshade: Oo,
            fill: xs,
            "fill-extrusion": Fs,
            line: Xs,
            symbol: Cc,
            background: Ic,
            raster: zc
          };

          var Fc = self.HTMLImageElement,
              Bc = self.HTMLCanvasElement,
              Nc = self.HTMLVideoElement,
              jc = self.ImageData,
              Uc = self.ImageBitmap,
              Vc = function Vc(t, e, r, n) {
            this.context = t, this.format = r, this.texture = t.gl.createTexture(), this.update(e, n);
          };

          Vc.prototype.update = function (t, e, r) {
            var n = t.width,
                i = t.height,
                a = !(this.size && this.size[0] === n && this.size[1] === i || r),
                o = this.context,
                s = o.gl;
            if (this.useMipmap = Boolean(e && e.useMipmap), s.bindTexture(s.TEXTURE_2D, this.texture), o.pixelStoreUnpackFlipY.set(!1), o.pixelStoreUnpack.set(1), o.pixelStoreUnpackPremultiplyAlpha.set(this.format === s.RGBA && (!e || !1 !== e.premultiply)), a) this.size = [n, i], t instanceof Fc || t instanceof Bc || t instanceof Nc || t instanceof jc || Uc && t instanceof Uc ? s.texImage2D(s.TEXTURE_2D, 0, this.format, this.format, s.UNSIGNED_BYTE, t) : s.texImage2D(s.TEXTURE_2D, 0, this.format, n, i, 0, this.format, s.UNSIGNED_BYTE, t.data);else {
              var l = r || {
                x: 0,
                y: 0
              },
                  c = l.x,
                  u = l.y;
              t instanceof Fc || t instanceof Bc || t instanceof Nc || t instanceof jc || Uc && t instanceof Uc ? s.texSubImage2D(s.TEXTURE_2D, 0, c, u, s.RGBA, s.UNSIGNED_BYTE, t) : s.texSubImage2D(s.TEXTURE_2D, 0, c, u, n, i, s.RGBA, s.UNSIGNED_BYTE, t.data);
            }
            this.useMipmap && this.isSizePowerOfTwo() && s.generateMipmap(s.TEXTURE_2D);
          }, Vc.prototype.bind = function (t, e, r) {
            var n = this.context.gl;
            n.bindTexture(n.TEXTURE_2D, this.texture), r !== n.LINEAR_MIPMAP_NEAREST || this.isSizePowerOfTwo() || (r = n.LINEAR), t !== this.filter && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, t), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, r || t), this.filter = t), e !== this.wrap && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, e), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, e), this.wrap = e);
          }, Vc.prototype.isSizePowerOfTwo = function () {
            return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
          }, Vc.prototype.destroy = function () {
            this.context.gl.deleteTexture(this.texture), this.texture = null;
          };

          var qc = function qc(t) {
            var e = this;
            this._callback = t, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel(), this._channel.port2.onmessage = function () {
              e._triggered = !1, e._callback();
            });
          };

          qc.prototype.trigger = function () {
            var t = this;
            this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(function () {
              t._triggered = !1, t._callback();
            }, 0));
          }, qc.prototype.remove = function () {
            delete this._channel, this._callback = function () {};
          };

          var Hc = function Hc(t, e, r) {
            this.target = t, this.parent = e, this.mapId = r, this.callbacks = {}, this.tasks = {}, this.taskQueue = [], this.cancelCallbacks = {}, m(["receive", "process"], this), this.invoker = new qc(this.process), this.target.addEventListener("message", this.receive, !1), this.globalScope = k() ? t : self;
          };

          function Gc(t, e, r) {
            var n = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r);
            return [t * n - 2 * Math.PI * 6378137 / 2, e * n - 2 * Math.PI * 6378137 / 2];
          }

          Hc.prototype.send = function (t, e, r, n, i) {
            var a = this;
            void 0 === i && (i = !1);
            var o = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
            r && (this.callbacks[o] = r);
            var s = S(this.globalScope) ? void 0 : [];
            return this.target.postMessage({
              id: o,
              type: t,
              hasCallback: !!r,
              targetMapId: n,
              mustQueue: i,
              sourceMapId: this.mapId,
              data: qn(e, s)
            }, s), {
              cancel: function cancel() {
                r && delete a.callbacks[o], a.target.postMessage({
                  id: o,
                  type: "<cancel>",
                  targetMapId: n,
                  sourceMapId: a.mapId
                });
              }
            };
          }, Hc.prototype.receive = function (t) {
            var e = t.data,
                r = e.id;
            if (r && (!e.targetMapId || this.mapId === e.targetMapId)) if ("<cancel>" === e.type) {
              delete this.tasks[r];
              var n = this.cancelCallbacks[r];
              delete this.cancelCallbacks[r], n && n();
            } else k() || e.mustQueue ? (this.tasks[r] = e, this.taskQueue.push(r), this.invoker.trigger()) : this.processTask(r, e);
          }, Hc.prototype.process = function () {
            if (this.taskQueue.length) {
              var t = this.taskQueue.shift(),
                  e = this.tasks[t];
              delete this.tasks[t], this.taskQueue.length && this.invoker.trigger(), e && this.processTask(t, e);
            }
          }, Hc.prototype.processTask = function (t, e) {
            var r = this;

            if ("<response>" === e.type) {
              var n = this.callbacks[t];
              delete this.callbacks[t], n && (e.error ? n(Hn(e.error)) : n(null, Hn(e.data)));
            } else {
              var i = !1,
                  a = S(this.globalScope) ? void 0 : [],
                  o = e.hasCallback ? function (e, n) {
                i = !0, delete r.cancelCallbacks[t], r.target.postMessage({
                  id: t,
                  type: "<response>",
                  sourceMapId: r.mapId,
                  error: e ? qn(e) : null,
                  data: qn(n, a)
                }, a);
              } : function (t) {
                i = !0;
              },
                  s = null,
                  l = Hn(e.data);
              if (this.parent[e.type]) s = this.parent[e.type](e.sourceMapId, l, o);else if (this.parent.getWorkerSource) {
                var c = e.type.split(".");
                s = this.parent.getWorkerSource(e.sourceMapId, c[0], l.source)[c[1]](l, o);
              } else o(new Error("Could not find function " + e.type));
              !i && s && s.cancel && (this.cancelCallbacks[t] = s.cancel);
            }
          }, Hc.prototype.remove = function () {
            this.invoker.remove(), this.target.removeEventListener("message", this.receive, !1);
          };

          var Yc = function Yc(t, e) {
            t && (e ? this.setSouthWest(t).setNorthEast(e) : 4 === t.length ? this.setSouthWest([t[0], t[1]]).setNorthEast([t[2], t[3]]) : this.setSouthWest(t[0]).setNorthEast(t[1]));
          };

          Yc.prototype.setNorthEast = function (t) {
            return this._ne = t instanceof Wc ? new Wc(t.lng, t.lat) : Wc.convert(t), this;
          }, Yc.prototype.setSouthWest = function (t) {
            return this._sw = t instanceof Wc ? new Wc(t.lng, t.lat) : Wc.convert(t), this;
          }, Yc.prototype.extend = function (t) {
            var e,
                r,
                n = this._sw,
                i = this._ne;
            if (t instanceof Wc) e = t, r = t;else {
              if (!(t instanceof Yc)) {
                if (Array.isArray(t)) {
                  if (4 === t.length || t.every(Array.isArray)) {
                    var a = t;
                    return this.extend(Yc.convert(a));
                  }

                  var o = t;
                  return this.extend(Wc.convert(o));
                }

                return this;
              }

              if (e = t._sw, r = t._ne, !e || !r) return this;
            }
            return n || i ? (n.lng = Math.min(e.lng, n.lng), n.lat = Math.min(e.lat, n.lat), i.lng = Math.max(r.lng, i.lng), i.lat = Math.max(r.lat, i.lat)) : (this._sw = new Wc(e.lng, e.lat), this._ne = new Wc(r.lng, r.lat)), this;
          }, Yc.prototype.getCenter = function () {
            return new Wc((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
          }, Yc.prototype.getSouthWest = function () {
            return this._sw;
          }, Yc.prototype.getNorthEast = function () {
            return this._ne;
          }, Yc.prototype.getNorthWest = function () {
            return new Wc(this.getWest(), this.getNorth());
          }, Yc.prototype.getSouthEast = function () {
            return new Wc(this.getEast(), this.getSouth());
          }, Yc.prototype.getWest = function () {
            return this._sw.lng;
          }, Yc.prototype.getSouth = function () {
            return this._sw.lat;
          }, Yc.prototype.getEast = function () {
            return this._ne.lng;
          }, Yc.prototype.getNorth = function () {
            return this._ne.lat;
          }, Yc.prototype.toArray = function () {
            return [this._sw.toArray(), this._ne.toArray()];
          }, Yc.prototype.toString = function () {
            return "LngLatBounds(" + this._sw.toString() + ", " + this._ne.toString() + ")";
          }, Yc.prototype.isEmpty = function () {
            return !(this._sw && this._ne);
          }, Yc.prototype.contains = function (t) {
            var e = Wc.convert(t),
                r = e.lng,
                n = e.lat,
                i = this._sw.lat <= n && n <= this._ne.lat,
                a = this._sw.lng <= r && r <= this._ne.lng;
            return this._sw.lng > this._ne.lng && (a = this._sw.lng >= r && r >= this._ne.lng), i && a;
          }, Yc.convert = function (t) {
            return !t || t instanceof Yc ? t : new Yc(t);
          };

          var Wc = function Wc(t, e) {
            if (isNaN(t) || isNaN(e)) throw new Error("Invalid LngLat object: (" + t + ", " + e + ")");
            if (this.lng = +t, this.lat = +e, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
          };

          Wc.prototype.wrap = function () {
            return new Wc(c(this.lng, -180, 180), this.lat);
          }, Wc.prototype.toArray = function () {
            return [this.lng, this.lat];
          }, Wc.prototype.toString = function () {
            return "LngLat(" + this.lng + ", " + this.lat + ")";
          }, Wc.prototype.distanceTo = function (t) {
            var e = Math.PI / 180,
                r = this.lat * e,
                n = t.lat * e,
                i = Math.sin(r) * Math.sin(n) + Math.cos(r) * Math.cos(n) * Math.cos((t.lng - this.lng) * e);
            return 6371008.8 * Math.acos(Math.min(i, 1));
          }, Wc.prototype.toBounds = function (t) {
            void 0 === t && (t = 0);
            var e = 360 * t / 40075017,
                r = e / Math.cos(Math.PI / 180 * this.lat);
            return new Yc(new Wc(this.lng - r, this.lat - e), new Wc(this.lng + r, this.lat + e));
          }, Wc.convert = function (t) {
            if (t instanceof Wc) return t;
            if (Array.isArray(t) && (2 === t.length || 3 === t.length)) return new Wc(Number(t[0]), Number(t[1]));
            if (!Array.isArray(t) && "object" == _typeof(t) && null !== t) return new Wc(Number("lng" in t ? t.lng : t.lon), Number(t.lat));
            throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
          };
          var Xc = 2 * Math.PI * 6371008.8;

          function Zc(t) {
            return Xc * Math.cos(t * Math.PI / 180);
          }

          function Jc(t) {
            return (180 + t) / 360;
          }

          function Kc(t) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t * Math.PI / 360))) / 360;
          }

          function Qc(t, e) {
            return t / Zc(e);
          }

          function $c(t) {
            var e = 180 - 360 * t;
            return 360 / Math.PI * Math.atan(Math.exp(e * Math.PI / 180)) - 90;
          }

          var tu = function tu(t, e, r) {
            void 0 === r && (r = 0), this.x = +t, this.y = +e, this.z = +r;
          };

          tu.fromLngLat = function (t, e) {
            void 0 === e && (e = 0);
            var r = Wc.convert(t);
            return new tu(Jc(r.lng), Kc(r.lat), Qc(e, r.lat));
          }, tu.prototype.toLngLat = function () {
            return new Wc(360 * this.x - 180, $c(this.y));
          }, tu.prototype.toAltitude = function () {
            return t = this.z, e = this.y, t * Zc($c(e));
            var t, e;
          }, tu.prototype.meterInMercatorCoordinateUnits = function () {
            return 1 / Xc * (t = $c(this.y), 1 / Math.cos(t * Math.PI / 180));
            var t;
          };

          var eu = function eu(t, e, r) {
            this.z = t, this.x = e, this.y = r, this.key = iu(0, t, t, e, r);
          };

          eu.prototype.equals = function (t) {
            return this.z === t.z && this.x === t.x && this.y === t.y;
          }, eu.prototype.url = function (t, e) {
            var r,
                n,
                i,
                a,
                o,
                s = (r = this.x, n = this.y, i = this.z, a = Gc(256 * r, 256 * (n = Math.pow(2, i) - n - 1), i), o = Gc(256 * (r + 1), 256 * (n + 1), i), a[0] + "," + a[1] + "," + o[0] + "," + o[1]),
                l = function (t, e, r) {
              for (var n, i = "", a = t; a > 0; a--) {
                i += (e & (n = 1 << a - 1) ? 1 : 0) + (r & n ? 2 : 0);
              }

              return i;
            }(this.z, this.x, this.y);

            return t[(this.x + this.y) % t.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace("{z}", String(this.z)).replace("{x}", String(this.x)).replace("{y}", String("tms" === e ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", l).replace("{bbox-epsg-3857}", s);
          }, eu.prototype.getTilePoint = function (t) {
            var e = Math.pow(2, this.z);
            return new i(8192 * (t.x * e - this.x), 8192 * (t.y * e - this.y));
          }, eu.prototype.toString = function () {
            return this.z + "/" + this.x + "/" + this.y;
          };

          var ru = function ru(t, e) {
            this.wrap = t, this.canonical = e, this.key = iu(t, e.z, e.z, e.x, e.y);
          },
              nu = function nu(t, e, r, n, i) {
            this.overscaledZ = t, this.wrap = e, this.canonical = new eu(r, +n, +i), this.key = iu(e, t, r, n, i);
          };

          function iu(t, e, r, n, i) {
            (t *= 2) < 0 && (t = -1 * t - 1);
            var a = 1 << r;
            return (a * a * t + a * i + n).toString(36) + r.toString(36) + e.toString(36);
          }

          nu.prototype.equals = function (t) {
            return this.overscaledZ === t.overscaledZ && this.wrap === t.wrap && this.canonical.equals(t.canonical);
          }, nu.prototype.scaledTo = function (t) {
            var e = this.canonical.z - t;
            return t > this.canonical.z ? new nu(t, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new nu(t, this.wrap, t, this.canonical.x >> e, this.canonical.y >> e);
          }, nu.prototype.calculateScaledKey = function (t, e) {
            var r = this.canonical.z - t;
            return t > this.canonical.z ? iu(this.wrap * +e, t, this.canonical.z, this.canonical.x, this.canonical.y) : iu(this.wrap * +e, t, t, this.canonical.x >> r, this.canonical.y >> r);
          }, nu.prototype.isChildOf = function (t) {
            if (t.wrap !== this.wrap) return !1;
            var e = this.canonical.z - t.canonical.z;
            return 0 === t.overscaledZ || t.overscaledZ < this.overscaledZ && t.canonical.x === this.canonical.x >> e && t.canonical.y === this.canonical.y >> e;
          }, nu.prototype.children = function (t) {
            if (this.overscaledZ >= t) return [new nu(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)];
            var e = this.canonical.z + 1,
                r = 2 * this.canonical.x,
                n = 2 * this.canonical.y;
            return [new nu(e, this.wrap, e, r, n), new nu(e, this.wrap, e, r + 1, n), new nu(e, this.wrap, e, r, n + 1), new nu(e, this.wrap, e, r + 1, n + 1)];
          }, nu.prototype.isLessThan = function (t) {
            return this.wrap < t.wrap || !(this.wrap > t.wrap) && (this.overscaledZ < t.overscaledZ || !(this.overscaledZ > t.overscaledZ) && (this.canonical.x < t.canonical.x || !(this.canonical.x > t.canonical.x) && this.canonical.y < t.canonical.y));
          }, nu.prototype.wrapped = function () {
            return new nu(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
          }, nu.prototype.unwrapTo = function (t) {
            return new nu(this.overscaledZ, t, this.canonical.z, this.canonical.x, this.canonical.y);
          }, nu.prototype.overscaleFactor = function () {
            return Math.pow(2, this.overscaledZ - this.canonical.z);
          }, nu.prototype.toUnwrapped = function () {
            return new ru(this.wrap, this.canonical);
          }, nu.prototype.toString = function () {
            return this.overscaledZ + "/" + this.canonical.x + "/" + this.canonical.y;
          }, nu.prototype.getTilePoint = function (t) {
            return this.canonical.getTilePoint(new tu(t.x - this.wrap, t.y));
          }, Nn("CanonicalTileID", eu), Nn("OverscaledTileID", nu, {
            omit: ["posMatrix"]
          });

          var au = function au(t, e, r) {
            if (this.uid = t, e.height !== e.width) throw new RangeError("DEM tiles must be square");
            if (r && "mapbox" !== r && "terrarium" !== r) return _('"' + r + '" is not a valid encoding type. Valid types include "mapbox" and "terrarium".');
            this.stride = e.height;
            var n = this.dim = e.height - 2;
            this.data = new Uint32Array(e.data.buffer), this.encoding = r || "mapbox";

            for (var i = 0; i < n; i++) {
              this.data[this._idx(-1, i)] = this.data[this._idx(0, i)], this.data[this._idx(n, i)] = this.data[this._idx(n - 1, i)], this.data[this._idx(i, -1)] = this.data[this._idx(i, 0)], this.data[this._idx(i, n)] = this.data[this._idx(i, n - 1)];
            }

            this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(n, -1)] = this.data[this._idx(n - 1, 0)], this.data[this._idx(-1, n)] = this.data[this._idx(0, n - 1)], this.data[this._idx(n, n)] = this.data[this._idx(n - 1, n - 1)];
          };

          au.prototype.get = function (t, e) {
            var r = new Uint8Array(this.data.buffer),
                n = 4 * this._idx(t, e);

            return ("terrarium" === this.encoding ? this._unpackTerrarium : this._unpackMapbox)(r[n], r[n + 1], r[n + 2]);
          }, au.prototype.getUnpackVector = function () {
            return "terrarium" === this.encoding ? [256, 1, 1 / 256, 32768] : [6553.6, 25.6, .1, 1e4];
          }, au.prototype._idx = function (t, e) {
            if (t < -1 || t >= this.dim + 1 || e < -1 || e >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
            return (e + 1) * this.stride + (t + 1);
          }, au.prototype._unpackMapbox = function (t, e, r) {
            return (256 * t * 256 + 256 * e + r) / 10 - 1e4;
          }, au.prototype._unpackTerrarium = function (t, e, r) {
            return 256 * t + e + r / 256 - 32768;
          }, au.prototype.getPixels = function () {
            return new Eo({
              width: this.stride,
              height: this.stride
            }, new Uint8Array(this.data.buffer));
          }, au.prototype.backfillBorder = function (t, e, r) {
            if (this.dim !== t.dim) throw new Error("dem dimension mismatch");
            var n = e * this.dim,
                i = e * this.dim + this.dim,
                a = r * this.dim,
                o = r * this.dim + this.dim;

            switch (e) {
              case -1:
                n = i - 1;
                break;

              case 1:
                i = n + 1;
            }

            switch (r) {
              case -1:
                a = o - 1;
                break;

              case 1:
                o = a + 1;
            }

            for (var s = -e * this.dim, l = -r * this.dim, c = a; c < o; c++) {
              for (var u = n; u < i; u++) {
                this.data[this._idx(u, c)] = t.data[this._idx(u + s, c + l)];
              }
            }
          }, Nn("DEMData", au);

          var ou = function ou(t) {
            this._stringToNumber = {}, this._numberToString = [];

            for (var e = 0; e < t.length; e++) {
              var r = t[e];
              this._stringToNumber[r] = e, this._numberToString[e] = r;
            }
          };

          ou.prototype.encode = function (t) {
            return this._stringToNumber[t];
          }, ou.prototype.decode = function (t) {
            return this._numberToString[t];
          };

          var su = function su(t, e, r, n, i) {
            this.type = "Feature", this._vectorTileFeature = t, t._z = e, t._x = r, t._y = n, this.properties = t.properties, this.id = i;
          },
              lu = {
            geometry: {
              configurable: !0
            }
          };

          lu.geometry.get = function () {
            return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry), this._geometry;
          }, lu.geometry.set = function (t) {
            this._geometry = t;
          }, su.prototype.toJSON = function () {
            var t = {
              geometry: this.geometry
            };

            for (var e in this) {
              "_geometry" !== e && "_vectorTileFeature" !== e && (t[e] = this[e]);
            }

            return t;
          }, Object.defineProperties(su.prototype, lu);

          var cu = function cu() {
            this.state = {}, this.stateChanges = {}, this.deletedStates = {};
          };

          cu.prototype.updateState = function (t, e, r) {
            var n = String(e);
            if (this.stateChanges[t] = this.stateChanges[t] || {}, this.stateChanges[t][n] = this.stateChanges[t][n] || {}, u(this.stateChanges[t][n], r), null === this.deletedStates[t]) for (var i in this.deletedStates[t] = {}, this.state[t]) {
              i !== n && (this.deletedStates[t][i] = null);
            } else if (this.deletedStates[t] && null === this.deletedStates[t][n]) for (var a in this.deletedStates[t][n] = {}, this.state[t][n]) {
              r[a] || (this.deletedStates[t][n][a] = null);
            } else for (var o in r) {
              this.deletedStates[t] && this.deletedStates[t][n] && null === this.deletedStates[t][n][o] && delete this.deletedStates[t][n][o];
            }
          }, cu.prototype.removeFeatureState = function (t, e, r) {
            if (!(null === this.deletedStates[t])) {
              var n = String(e);
              if (this.deletedStates[t] = this.deletedStates[t] || {}, r && void 0 !== e) null !== this.deletedStates[t][n] && (this.deletedStates[t][n] = this.deletedStates[t][n] || {}, this.deletedStates[t][n][r] = null);else if (void 0 !== e) {
                if (this.stateChanges[t] && this.stateChanges[t][n]) for (r in this.deletedStates[t][n] = {}, this.stateChanges[t][n]) {
                  this.deletedStates[t][n][r] = null;
                } else this.deletedStates[t][n] = null;
              } else this.deletedStates[t] = null;
            }
          }, cu.prototype.getState = function (t, e) {
            var r = String(e),
                n = this.state[t] || {},
                i = this.stateChanges[t] || {},
                a = u({}, n[r], i[r]);
            if (null === this.deletedStates[t]) return {};

            if (this.deletedStates[t]) {
              var o = this.deletedStates[t][e];
              if (null === o) return {};

              for (var s in o) {
                delete a[s];
              }
            }

            return a;
          }, cu.prototype.initializeTileState = function (t, e) {
            t.setFeatureState(this.state, e);
          }, cu.prototype.coalesceChanges = function (t, e) {
            var r = {};

            for (var n in this.stateChanges) {
              this.state[n] = this.state[n] || {};
              var i = {};

              for (var a in this.stateChanges[n]) {
                this.state[n][a] || (this.state[n][a] = {}), u(this.state[n][a], this.stateChanges[n][a]), i[a] = this.state[n][a];
              }

              r[n] = i;
            }

            for (var o in this.deletedStates) {
              this.state[o] = this.state[o] || {};
              var s = {};
              if (null === this.deletedStates[o]) for (var l in this.state[o]) {
                s[l] = {}, this.state[o][l] = {};
              } else for (var c in this.deletedStates[o]) {
                if (null === this.deletedStates[o][c]) this.state[o][c] = {};else for (var f = 0, h = Object.keys(this.deletedStates[o][c]); f < h.length; f += 1) {
                  var p = h[f];
                  delete this.state[o][c][p];
                }
                s[c] = this.state[o][c];
              }
              r[o] = r[o] || {}, u(r[o], s);
            }

            if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(r).length) for (var d in t) {
              t[d].setFeatureState(r, e);
            }
          };

          var uu = function uu(t, e) {
            this.tileID = t, this.x = t.canonical.x, this.y = t.canonical.y, this.z = t.canonical.z, this.grid = new zn(8192, 16, 0), this.grid3D = new zn(8192, 16, 0), this.featureIndexArray = new fa(), this.promoteId = e;
          };

          function fu(t, e, r, n, i) {
            return v(t, function (t, a) {
              var o = e instanceof _i ? e.get(a) : null;
              return o && o.evaluate ? o.evaluate(r, n, i) : o;
            });
          }

          function hu(t) {
            for (var e = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0, a = 0, o = t; a < o.length; a += 1) {
              var s = o[a];
              e = Math.min(e, s.x), r = Math.min(r, s.y), n = Math.max(n, s.x), i = Math.max(i, s.y);
            }

            return {
              minX: e,
              minY: r,
              maxX: n,
              maxY: i
            };
          }

          function pu(t, e) {
            return e - t;
          }

          uu.prototype.insert = function (t, e, r, n, i, a) {
            var o = this.featureIndexArray.length;
            this.featureIndexArray.emplaceBack(r, n, i);

            for (var s = a ? this.grid3D : this.grid, l = 0; l < e.length; l++) {
              for (var c = e[l], u = [1 / 0, 1 / 0, -1 / 0, -1 / 0], f = 0; f < c.length; f++) {
                var h = c[f];
                u[0] = Math.min(u[0], h.x), u[1] = Math.min(u[1], h.y), u[2] = Math.max(u[2], h.x), u[3] = Math.max(u[3], h.y);
              }

              u[0] < 8192 && u[1] < 8192 && u[2] >= 0 && u[3] >= 0 && s.insert(o, u[0], u[1], u[2], u[3]);
            }
          }, uu.prototype.loadVTLayers = function () {
            return this.vtLayers || (this.vtLayers = new Ls.VectorTile(new al(this.rawTileData)).layers, this.sourceLayerCoder = new ou(this.vtLayers ? Object.keys(this.vtLayers).sort() : ["_geojsonTileLayer"])), this.vtLayers;
          }, uu.prototype.query = function (t, e, r, n) {
            var a = this;
            this.loadVTLayers();

            for (var o = t.params || {}, s = 8192 / t.tileSize / t.scale, l = sn(o.filter), c = t.queryGeometry, u = t.queryPadding * s, f = hu(c), h = this.grid.query(f.minX - u, f.minY - u, f.maxX + u, f.maxY + u), p = hu(t.cameraQueryGeometry), d = this.grid3D.query(p.minX - u, p.minY - u, p.maxX + u, p.maxY + u, function (e, r, n, a) {
              return function (t, e, r, n, a) {
                for (var o = 0, s = t; o < s.length; o += 1) {
                  var l = s[o];
                  if (e <= l.x && r <= l.y && n >= l.x && a >= l.y) return !0;
                }

                var c = [new i(e, r), new i(e, a), new i(n, a), new i(n, r)];
                if (t.length > 2) for (var u = 0, f = c; u < f.length; u += 1) {
                  if (io(t, f[u])) return !0;
                }

                for (var h = 0; h < t.length - 1; h++) {
                  if (ao(t[h], t[h + 1], c)) return !0;
                }

                return !1;
              }(t.cameraQueryGeometry, e - u, r - u, n + u, a + u);
            }), m = 0, g = d; m < g.length; m += 1) {
              var v = g[m];
              h.push(v);
            }

            h.sort(pu);

            for (var y, x = {}, b = function b(i) {
              var u = h[i];

              if (u !== y) {
                y = u;
                var f = a.featureIndexArray.get(u),
                    p = null;
                a.loadMatchingFeature(x, f.bucketIndex, f.sourceLayerIndex, f.featureIndex, l, o.layers, o.availableImages, e, r, n, function (e, r, n) {
                  return p || (p = Ya(e)), r.queryIntersectsFeature(c, e, n, p, a.z, t.transform, s, t.pixelPosMatrix);
                });
              }
            }, _ = 0; _ < h.length; _++) {
              b(_);
            }

            return x;
          }, uu.prototype.loadMatchingFeature = function (t, e, r, n, i, a, o, s, l, c, u) {
            var f = this.bucketLayerIDs[e];

            if (!a || function (t, e) {
              for (var r = 0; r < t.length; r++) {
                if (e.indexOf(t[r]) >= 0) return !0;
              }

              return !1;
            }(a, f)) {
              var h = this.sourceLayerCoder.decode(r),
                  p = this.vtLayers[h].feature(n);
              if (i.filter(new pi(this.tileID.overscaledZ), p)) for (var d = this.getId(p, h), m = 0; m < f.length; m++) {
                var g = f[m];

                if (!(a && a.indexOf(g) < 0)) {
                  var v = s[g];

                  if (v) {
                    var y = {};
                    void 0 !== d && c && (y = c.getState(v.sourceLayer || "_geojsonTileLayer", d));
                    var x = l[g];
                    x.paint = fu(x.paint, v.paint, p, y, o), x.layout = fu(x.layout, v.layout, p, y, o);
                    var b = !u || u(p, v, y);

                    if (b) {
                      var _ = new su(p, this.z, this.x, this.y, d);

                      _.layer = x;
                      var w = t[g];
                      void 0 === w && (w = t[g] = []), w.push({
                        featureIndex: n,
                        feature: _,
                        intersectionZ: b
                      });
                    }
                  }
                }
              }
            }
          }, uu.prototype.lookupSymbolFeatures = function (t, e, r, n, i, a, o, s) {
            var l = {};
            this.loadVTLayers();

            for (var c = sn(i), u = 0, f = t; u < f.length; u += 1) {
              var h = f[u];
              this.loadMatchingFeature(l, r, n, h, c, a, o, s, e);
            }

            return l;
          }, uu.prototype.hasLayer = function (t) {
            for (var e = 0, r = this.bucketLayerIDs; e < r.length; e += 1) {
              for (var n = 0, i = r[e]; n < i.length; n += 1) {
                if (t === i[n]) return !0;
              }
            }

            return !1;
          }, uu.prototype.getId = function (t, e) {
            var r = t.id;

            if (this.promoteId) {
              var n = "string" == typeof this.promoteId ? this.promoteId : this.promoteId[e];
              "boolean" == typeof (r = t.properties[n]) && (r = Number(r));
            }

            return r;
          }, Nn("FeatureIndex", uu, {
            omit: ["rawTileData", "sourceLayerCoder"]
          });

          var du = function du(t, e) {
            this.tileID = t, this.uid = h(), this.uses = 0, this.tileSize = e, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.expiredRequestCount = 0, this.state = "loading";
          };

          du.prototype.registerFadeDuration = function (t) {
            var e = t + this.timeAdded;
            e < R.now() || this.fadeEndTime && e < this.fadeEndTime || (this.fadeEndTime = e);
          }, du.prototype.wasRequested = function () {
            return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
          }, du.prototype.loadVectorData = function (t, e, r) {
            if (this.hasData() && this.unloadVectorData(), this.state = "loaded", t) {
              for (var n in t.featureIndex && (this.latestFeatureIndex = t.featureIndex, t.rawTileData ? (this.latestRawTileData = t.rawTileData, this.latestFeatureIndex.rawTileData = t.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = t.collisionBoxArray, this.buckets = function (t, e) {
                var r = {};
                if (!e) return r;

                for (var n = function n() {
                  var t = a[i],
                      n = t.layerIds.map(function (t) {
                    return e.getLayer(t);
                  }).filter(Boolean);

                  if (0 !== n.length) {
                    t.layers = n, t.stateDependentLayerIds && (t.stateDependentLayers = t.stateDependentLayerIds.map(function (t) {
                      return n.filter(function (e) {
                        return e.id === t;
                      })[0];
                    }));

                    for (var o = 0, s = n; o < s.length; o += 1) {
                      var l = s[o];
                      r[l.id] = t;
                    }
                  }
                }, i = 0, a = t; i < a.length; i += 1) {
                  n();
                }

                return r;
              }(t.buckets, e.style), this.hasSymbolBuckets = !1, this.buckets) {
                var i = this.buckets[n];

                if (i instanceof Ac) {
                  if (this.hasSymbolBuckets = !0, !r) break;
                  i.justReloaded = !0;
                }
              }

              if (this.hasRTLText = !1, this.hasSymbolBuckets) for (var a in this.buckets) {
                var o = this.buckets[a];

                if (o instanceof Ac && o.hasRTLText) {
                  this.hasRTLText = !0, hi.isLoading() || hi.isLoaded() || "deferred" !== ui() || fi();
                  break;
                }
              }

              for (var s in this.queryPadding = 0, this.buckets) {
                var l = this.buckets[s];
                this.queryPadding = Math.max(this.queryPadding, e.style.getLayer(s).queryRadius(l));
              }

              t.imageAtlas && (this.imageAtlas = t.imageAtlas), t.glyphAtlasImage && (this.glyphAtlasImage = t.glyphAtlasImage);
            } else this.collisionBoxArray = new na();
          }, du.prototype.unloadVectorData = function () {
            for (var t in this.buckets) {
              this.buckets[t].destroy();
            }

            this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.imageAtlas && (this.imageAtlas = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.latestFeatureIndex = null, this.state = "unloaded";
          }, du.prototype.getBucket = function (t) {
            return this.buckets[t.id];
          }, du.prototype.upload = function (t) {
            for (var e in this.buckets) {
              var r = this.buckets[e];
              r.uploadPending() && r.upload(t);
            }

            var n = t.gl;
            this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new Vc(t, this.imageAtlas.image, n.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new Vc(t, this.glyphAtlasImage, n.ALPHA), this.glyphAtlasImage = null);
          }, du.prototype.prepare = function (t) {
            this.imageAtlas && this.imageAtlas.patchUpdatedImages(t, this.imageAtlasTexture);
          }, du.prototype.queryRenderedFeatures = function (t, e, r, n, i, a, o, s, l, c) {
            return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({
              queryGeometry: n,
              cameraQueryGeometry: i,
              scale: a,
              tileSize: this.tileSize,
              pixelPosMatrix: c,
              transform: s,
              params: o,
              queryPadding: this.queryPadding * l
            }, t, e, r) : {};
          }, du.prototype.querySourceFeatures = function (t, e) {
            var r = this.latestFeatureIndex;

            if (r && r.rawTileData) {
              var n = r.loadVTLayers(),
                  i = e ? e.sourceLayer : "",
                  a = n._geojsonTileLayer || n[i];
              if (a) for (var o = sn(e && e.filter), s = this.tileID.canonical, l = s.z, c = s.x, u = s.y, f = {
                z: l,
                x: c,
                y: u
              }, h = 0; h < a.length; h++) {
                var p = a.feature(h);

                if (o.filter(new pi(this.tileID.overscaledZ), p)) {
                  var d = r.getId(p, i),
                      m = new su(p, l, c, u, d);
                  m.tile = f, t.push(m);
                }
              }
            }
          }, du.prototype.hasData = function () {
            return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
          }, du.prototype.patternsLoaded = function () {
            return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
          }, du.prototype.setExpiryData = function (t) {
            var e = this.expirationTime;

            if (t.cacheControl) {
              var r = M(t.cacheControl);
              r["max-age"] && (this.expirationTime = Date.now() + 1e3 * r["max-age"]);
            } else t.expires && (this.expirationTime = new Date(t.expires).getTime());

            if (this.expirationTime) {
              var n = Date.now(),
                  i = !1;
              if (this.expirationTime > n) i = !1;else if (e) {
                if (this.expirationTime < e) i = !0;else {
                  var a = this.expirationTime - e;
                  a ? this.expirationTime = n + Math.max(a, 3e4) : i = !0;
                }
              } else i = !0;
              i ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
            }
          }, du.prototype.getExpiryTimeout = function () {
            if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - new Date().getTime(), Math.pow(2, 31) - 1);
          }, du.prototype.setFeatureState = function (t, e) {
            if (this.latestFeatureIndex && this.latestFeatureIndex.rawTileData && 0 !== Object.keys(t).length) {
              var r = this.latestFeatureIndex.loadVTLayers();

              for (var n in this.buckets) {
                if (e.style.hasLayer(n)) {
                  var i = this.buckets[n],
                      a = i.layers[0].sourceLayer || "_geojsonTileLayer",
                      o = r[a],
                      s = t[a];

                  if (o && s && 0 !== Object.keys(s).length) {
                    i.update(s, o, this.imageAtlas && this.imageAtlas.patternPositions || {});
                    var l = e && e.style && e.style.getLayer(n);
                    l && (this.queryPadding = Math.max(this.queryPadding, l.queryRadius(i)));
                  }
                }
              }
            }
          }, du.prototype.holdingForFade = function () {
            return void 0 !== this.symbolFadeHoldUntil;
          }, du.prototype.symbolFadeFinished = function () {
            return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < R.now();
          }, du.prototype.clearFadeHold = function () {
            this.symbolFadeHoldUntil = void 0;
          }, du.prototype.setHoldDuration = function (t) {
            this.symbolFadeHoldUntil = R.now() + t;
          }, du.prototype.setDependencies = function (t, e) {
            for (var r = {}, n = 0, i = e; n < i.length; n += 1) {
              r[i[n]] = !0;
            }

            this.dependencies[t] = r;
          }, du.prototype.hasDependency = function (t, e) {
            for (var r = 0, n = t; r < n.length; r += 1) {
              var i = n[r],
                  a = this.dependencies[i];
              if (a) for (var o = 0, s = e; o < s.length; o += 1) {
                if (a[s[o]]) return !0;
              }
            }

            return !1;
          };

          var mu = self.performance,
              gu = function gu(t) {
            this._marks = {
              start: [t.url, "start"].join("#"),
              end: [t.url, "end"].join("#"),
              measure: t.url.toString()
            }, mu.mark(this._marks.start);
          };

          gu.prototype.finish = function () {
            mu.mark(this._marks.end);
            var t = mu.getEntriesByName(this._marks.measure);
            return 0 === t.length && (mu.measure(this._marks.measure, this._marks.start, this._marks.end), t = mu.getEntriesByName(this._marks.measure), mu.clearMarks(this._marks.start), mu.clearMarks(this._marks.end), mu.clearMeasures(this._marks.measure)), t;
          }, t.Actor = Hc, t.AlphaImage = So, t.CanonicalTileID = eu, t.CollisionBoxArray = na, t.Color = te, t.DEMData = au, t.DataConstantProperty = wi, t.DictionaryCoder = ou, t.EXTENT = 8192, t.ErrorEvent = St, t.EvaluationParameters = pi, t.Event = At, t.Evented = Et, t.FeatureIndex = uu, t.FillBucket = gs, t.FillExtrusionBucket = Os, t.ImageAtlas = Ll, t.ImagePosition = Sl, t.LineBucket = Hs, t.LngLat = Wc, t.LngLatBounds = Yc, t.MercatorCoordinate = tu, t.ONE_EM = 24, t.OverscaledTileID = nu, t.Point = i, t.Point$1 = i, t.Properties = Si, t.Protobuf = al, t.RGBAImage = Eo, t.RequestManager = q, t.RequestPerformance = gu, t.ResourceType = dt, t.SegmentVector = pa, t.SourceFeatureState = cu, t.StructArrayLayout1ui2 = $i, t.StructArrayLayout2f1f2i16 = Hi, t.StructArrayLayout2i4 = zi, t.StructArrayLayout3ui6 = Yi, t.StructArrayLayout4i8 = Di, t.SymbolBucket = Ac, t.Texture = Vc, t.Tile = du, t.Transitionable = gi, t.Uniform1f = Sa, t.Uniform1i = Aa, t.Uniform2f = Ea, t.Uniform3f = La, t.Uniform4f = Ca, t.UniformColor = Pa, t.UniformMatrix4f = Oa, t.UnwrappedTileID = ru, t.ValidationError = Ct, t.WritingMode = Cl, t.ZoomHistory = Gn, t.add = function (t, e, r) {
            return t[0] = e[0] + r[0], t[1] = e[1] + r[1], t[2] = e[2] + r[2], t;
          }, t.addDynamicAttributes = wc, t.asyncAll = function (t, e, r) {
            if (!t.length) return r(null, []);
            var n = t.length,
                i = new Array(t.length),
                a = null;
            t.forEach(function (t, o) {
              e(t, function (t, e) {
                t && (a = t), i[o] = e, 0 == --n && r(a, i);
              });
            });
          }, t.bezier = o, t.bindAll = m, t.browser = R, t.cacheEntryPossiblyAdded = function (t) {
            ++ht > ot && (t.getActor().send("enforceCacheSizeLimit", at), ht = 0);
          }, t.clamp = l, t.clearTileCache = function (t) {
            var e = self.caches.delete("mapbox-tiles");
            t && e.catch(t).then(function () {
              return t();
            });
          }, t.clipLine = ec, t.clone = function (t) {
            var e = new fo(16);
            return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
          }, t.clone$1 = x, t.clone$2 = function (t) {
            var e = new fo(3);
            return e[0] = t[0], e[1] = t[1], e[2] = t[2], e;
          }, t.collisionCircleLayout = tl, t.config = F, t.create = function () {
            var t = new fo(16);
            return fo != Float32Array && (t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0), t[0] = 1, t[5] = 1, t[10] = 1, t[15] = 1, t;
          }, t.create$1 = function () {
            var t = new fo(9);
            return fo != Float32Array && (t[1] = 0, t[2] = 0, t[3] = 0, t[5] = 0, t[6] = 0, t[7] = 0), t[0] = 1, t[4] = 1, t[8] = 1, t;
          }, t.create$2 = function () {
            var t = new fo(4);
            return fo != Float32Array && (t[1] = 0, t[2] = 0), t[0] = 1, t[3] = 1, t;
          }, t.createCommonjsModule = e, t.createExpression = Wr, t.createLayout = Ii, t.createStyleLayer = function (t) {
            return "custom" === t.type ? new Dc(t) : new Rc[t.type](t);
          }, t.cross = function (t, e, r) {
            var n = e[0],
                i = e[1],
                a = e[2],
                o = r[0],
                s = r[1],
                l = r[2];
            return t[0] = i * l - a * s, t[1] = a * o - n * l, t[2] = n * s - i * o, t;
          }, t.deepEqual = function t(e, r) {
            if (Array.isArray(e)) {
              if (!Array.isArray(r) || e.length !== r.length) return !1;

              for (var n = 0; n < e.length; n++) {
                if (!t(e[n], r[n])) return !1;
              }

              return !0;
            }

            if ("object" == _typeof(e) && null !== e && null !== r) {
              if ("object" != _typeof(r)) return !1;
              if (Object.keys(e).length !== Object.keys(r).length) return !1;

              for (var i in e) {
                if (!t(e[i], r[i])) return !1;
              }

              return !0;
            }

            return e === r;
          }, t.dot = function (t, e) {
            return t[0] * e[0] + t[1] * e[1] + t[2] * e[2];
          }, t.dot$1 = function (t, e) {
            return t[0] * e[0] + t[1] * e[1] + t[2] * e[2] + t[3] * e[3];
          }, t.ease = s, t.emitValidationErrors = On, t.endsWith = g, t.enforceCacheSizeLimit = function (t) {
            st(), Q && Q.then(function (e) {
              e.keys().then(function (r) {
                for (var n = 0; n < r.length - t; n++) {
                  e.delete(r[n]);
                }
              });
            });
          }, t.evaluateSizeForFeature = Yl, t.evaluateSizeForZoom = Wl, t.evaluateVariableOffset = dc, t.evented = ci, t.extend = u, t.featureFilter = sn, t.filterObject = y, t.fromRotation = function (t, e) {
            var r = Math.sin(e),
                n = Math.cos(e);
            return t[0] = n, t[1] = r, t[2] = 0, t[3] = -r, t[4] = n, t[5] = 0, t[6] = 0, t[7] = 0, t[8] = 1, t;
          }, t.getAnchorAlignment = Ul, t.getAnchorJustification = mc, t.getArrayBuffer = xt, t.getImage = Tt, t.getJSON = function (t, e) {
            return yt(u(t, {
              type: "json"
            }), e);
          }, t.getRTLTextPluginStatus = ui, t.getReferrer = gt, t.getVideo = function (t, e) {
            var r,
                n,
                i = self.document.createElement("video");
            i.muted = !0, i.onloadstart = function () {
              e(null, i);
            };

            for (var a = 0; a < t.length; a++) {
              var o = self.document.createElement("source");
              r = t[a], n = void 0, (n = self.document.createElement("a")).href = r, (n.protocol !== self.document.location.protocol || n.host !== self.document.location.host) && (i.crossOrigin = "Anonymous"), o.src = t[a], i.appendChild(o);
            }

            return {
              cancel: function cancel() {}
            };
          }, t.identity = ho, t.invert = function (t, e) {
            var r = e[0],
                n = e[1],
                i = e[2],
                a = e[3],
                o = e[4],
                s = e[5],
                l = e[6],
                c = e[7],
                u = e[8],
                f = e[9],
                h = e[10],
                p = e[11],
                d = e[12],
                m = e[13],
                g = e[14],
                v = e[15],
                y = r * s - n * o,
                x = r * l - i * o,
                b = r * c - a * o,
                _ = n * l - i * s,
                w = n * c - a * s,
                T = i * c - a * l,
                k = u * m - f * d,
                M = u * g - h * d,
                A = u * v - p * d,
                S = f * g - h * m,
                E = f * v - p * m,
                L = h * v - p * g,
                C = y * L - x * E + b * S + _ * A - w * M + T * k;

            return C ? (C = 1 / C, t[0] = (s * L - l * E + c * S) * C, t[1] = (i * E - n * L - a * S) * C, t[2] = (m * T - g * w + v * _) * C, t[3] = (h * w - f * T - p * _) * C, t[4] = (l * A - o * L - c * M) * C, t[5] = (r * L - i * A + a * M) * C, t[6] = (g * b - d * T - v * x) * C, t[7] = (u * T - h * b + p * x) * C, t[8] = (o * E - s * A + c * k) * C, t[9] = (n * A - r * E - a * k) * C, t[10] = (d * w - m * b + v * y) * C, t[11] = (f * b - u * w - p * y) * C, t[12] = (s * M - o * S - l * k) * C, t[13] = (r * S - n * M + i * k) * C, t[14] = (m * x - d * _ - g * y) * C, t[15] = (u * _ - f * x + h * y) * C, t) : null;
          }, t.isChar = Yn, t.isMapboxURL = H, t.keysDifference = function (t, e) {
            var r = [];

            for (var n in t) {
              n in e || r.push(n);
            }

            return r;
          }, t.makeRequest = yt, t.mapObject = v, t.mercatorXfromLng = Jc, t.mercatorYfromLat = Kc, t.mercatorZfromAltitude = Qc, t.mul = mo, t.multiply = po, t.mvt = Ls, t.normalize = function (t, e) {
            var r = e[0],
                n = e[1],
                i = e[2],
                a = r * r + n * n + i * i;
            return a > 0 && (a = 1 / Math.sqrt(a)), t[0] = e[0] * a, t[1] = e[1] * a, t[2] = e[2] * a, t;
          }, t.number = He, t.offscreenCanvasSupported = pt, t.ortho = function (t, e, r, n, i, a, o) {
            var s = 1 / (e - r),
                l = 1 / (n - i),
                c = 1 / (a - o);
            return t[0] = -2 * s, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = -2 * l, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 2 * c, t[11] = 0, t[12] = (e + r) * s, t[13] = (i + n) * l, t[14] = (o + a) * c, t[15] = 1, t;
          }, t.parseGlyphPBF = function (t) {
            return new al(t).readFields(Tl, []);
          }, t.pbf = al, t.performSymbolLayout = function (t, e, r, n, i, a, o) {
            t.createArrays();
            var s = 512 * t.overscaling;
            t.tilePixelRatio = 8192 / s, t.compareText = {}, t.iconsNeedLinear = !1;
            var l = t.layers[0].layout,
                c = t.layers[0]._unevaluatedLayout._values,
                u = {};

            if ("composite" === t.textSizeData.kind) {
              var f = t.textSizeData,
                  h = f.minZoom,
                  p = f.maxZoom;
              u.compositeTextSizes = [c["text-size"].possiblyEvaluate(new pi(h), o), c["text-size"].possiblyEvaluate(new pi(p), o)];
            }

            if ("composite" === t.iconSizeData.kind) {
              var d = t.iconSizeData,
                  m = d.minZoom,
                  g = d.maxZoom;
              u.compositeIconSizes = [c["icon-size"].possiblyEvaluate(new pi(m), o), c["icon-size"].possiblyEvaluate(new pi(g), o)];
            }

            u.layoutTextSize = c["text-size"].possiblyEvaluate(new pi(t.zoom + 1), o), u.layoutIconSize = c["icon-size"].possiblyEvaluate(new pi(t.zoom + 1), o), u.textMaxSize = c["text-size"].possiblyEvaluate(new pi(18));

            for (var v = 24 * l.get("text-line-height"), y = "map" === l.get("text-rotation-alignment") && "point" !== l.get("symbol-placement"), x = l.get("text-keep-upright"), b = l.get("text-size"), w = function w() {
              var a = k[T],
                  s = l.get("text-font").evaluate(a, {}, o).join(","),
                  c = b.evaluate(a, {}, o),
                  f = u.layoutTextSize.evaluate(a, {}, o),
                  h = u.layoutIconSize.evaluate(a, {}, o),
                  p = {
                horizontal: {},
                vertical: void 0
              },
                  d = a.text,
                  m = [0, 0];

              if (d) {
                var g = d.toString(),
                    w = 24 * l.get("text-letter-spacing").evaluate(a, {}, o),
                    M = function (t) {
                  for (var e = 0, r = t; e < r.length; e += 1) {
                    if (!Xn(r[e].charCodeAt(0))) return !1;
                  }

                  return !0;
                }(g) ? w : 0,
                    A = l.get("text-anchor").evaluate(a, {}, o),
                    S = l.get("text-variable-anchor");

                if (!S) {
                  var E = l.get("text-radial-offset").evaluate(a, {}, o);
                  m = E ? dc(A, [24 * E, pc]) : l.get("text-offset").evaluate(a, {}, o).map(function (t) {
                    return 24 * t;
                  });
                }

                var L = y ? "center" : l.get("text-justify").evaluate(a, {}, o),
                    C = l.get("symbol-placement"),
                    P = "point" === C ? 24 * l.get("text-max-width").evaluate(a, {}, o) : 0,
                    I = function I() {
                  t.allowVerticalPlacement && Wn(g) && (p.vertical = Ol(d, e, r, i, s, P, v, A, "left", M, m, Cl.vertical, !0, C, f, c));
                };

                if (!y && S) {
                  for (var O = "auto" === L ? S.map(function (t) {
                    return mc(t);
                  }) : [L], z = !1, D = 0; D < O.length; D++) {
                    var R = O[D];
                    if (!p.horizontal[R]) if (z) p.horizontal[R] = p.horizontal[0];else {
                      var F = Ol(d, e, r, i, s, P, v, "center", R, M, m, Cl.horizontal, !1, C, f, c);
                      F && (p.horizontal[R] = F, z = 1 === F.positionedLines.length);
                    }
                  }

                  I();
                } else {
                  "auto" === L && (L = mc(A));
                  var B = Ol(d, e, r, i, s, P, v, A, L, M, m, Cl.horizontal, !1, C, f, c);
                  B && (p.horizontal[L] = B), I(), Wn(g) && y && x && (p.vertical = Ol(d, e, r, i, s, P, v, A, L, M, m, Cl.vertical, !1, C, f, c));
                }
              }

              var N = void 0,
                  j = !1;

              if (a.icon && a.icon.name) {
                var U = n[a.icon.name];
                U && (N = function (t, e, r) {
                  var n = Ul(r),
                      i = n.horizontalAlign,
                      a = n.verticalAlign,
                      o = e[0],
                      s = e[1],
                      l = o - t.displaySize[0] * i,
                      c = l + t.displaySize[0],
                      u = s - t.displaySize[1] * a;
                  return {
                    image: t,
                    top: u,
                    bottom: u + t.displaySize[1],
                    left: l,
                    right: c
                  };
                }(i[a.icon.name], l.get("icon-offset").evaluate(a, {}, o), l.get("icon-anchor").evaluate(a, {}, o)), j = U.sdf, void 0 === t.sdfIcons ? t.sdfIcons = U.sdf : t.sdfIcons !== U.sdf && _("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (U.pixelRatio !== t.pixelRatio || 0 !== l.get("icon-rotate").constantOr(1)) && (t.iconsNeedLinear = !0));
              }

              var V = vc(p.horizontal) || p.vertical;
              t.iconsInText = !!V && V.iconsInText, (V || N) && function (t, e, r, n, i, a, o, s, l, c, u) {
                var f = a.textMaxSize.evaluate(e, {});
                void 0 === f && (f = o);
                var h,
                    p = t.layers[0].layout,
                    d = p.get("icon-offset").evaluate(e, {}, u),
                    m = vc(r.horizontal),
                    g = o / 24,
                    v = t.tilePixelRatio * g,
                    y = t.tilePixelRatio * f / 24,
                    x = t.tilePixelRatio * s,
                    b = t.tilePixelRatio * p.get("symbol-spacing"),
                    w = p.get("text-padding") * t.tilePixelRatio,
                    T = p.get("icon-padding") * t.tilePixelRatio,
                    k = p.get("text-max-angle") / 180 * Math.PI,
                    M = "map" === p.get("text-rotation-alignment") && "point" !== p.get("symbol-placement"),
                    A = "map" === p.get("icon-rotation-alignment") && "point" !== p.get("symbol-placement"),
                    S = p.get("symbol-placement"),
                    E = b / 2,
                    L = p.get("icon-text-fit");
                n && "none" !== L && (t.allowVerticalPlacement && r.vertical && (h = ql(n, r.vertical, L, p.get("icon-text-fit-padding"), d, g)), m && (n = ql(n, m, L, p.get("icon-text-fit-padding"), d, g)));

                var C = function C(s, f) {
                  f.x < 0 || f.x >= 8192 || f.y < 0 || f.y >= 8192 || function (t, e, r, n, i, a, o, s, l, c, u, f, h, p, d, m, g, v, y, x, b, w, T, k, M) {
                    var A,
                        S,
                        E,
                        L,
                        C,
                        P = t.addToLineVertexArray(e, r),
                        I = 0,
                        O = 0,
                        z = 0,
                        D = 0,
                        R = -1,
                        F = -1,
                        B = {},
                        N = ya(""),
                        j = 0,
                        U = 0;
                    void 0 === s._unevaluatedLayout.getValue("text-radial-offset") ? (A = s.layout.get("text-offset").evaluate(b, {}, k).map(function (t) {
                      return 24 * t;
                    }), j = A[0], U = A[1]) : (j = 24 * s.layout.get("text-radial-offset").evaluate(b, {}, k), U = pc);

                    if (t.allowVerticalPlacement && n.vertical) {
                      var V = s.layout.get("text-rotate").evaluate(b, {}, k) + 90,
                          q = n.vertical;
                      L = new sc(l, e, c, u, f, q, h, p, d, V), o && (C = new sc(l, e, c, u, f, o, g, v, d, V));
                    }

                    if (i) {
                      var H = s.layout.get("icon-rotate").evaluate(b, {}),
                          G = "none" !== s.layout.get("icon-text-fit"),
                          Y = rc(i, H, T, G),
                          W = o ? rc(o, H, T, G) : void 0;
                      E = new sc(l, e, c, u, f, i, g, v, !1, H), I = 4 * Y.length;
                      var X = t.iconSizeData,
                          Z = null;
                      "source" === X.kind ? (Z = [128 * s.layout.get("icon-size").evaluate(b, {})])[0] > 32640 && _(t.layerIds[0] + ': Value for "icon-size" is >= 255. Reduce your "icon-size".') : "composite" === X.kind && ((Z = [128 * w.compositeIconSizes[0].evaluate(b, {}, k), 128 * w.compositeIconSizes[1].evaluate(b, {}, k)])[0] > 32640 || Z[1] > 32640) && _(t.layerIds[0] + ': Value for "icon-size" is >= 255. Reduce your "icon-size".'), t.addSymbols(t.icon, Y, Z, x, y, b, !1, e, P.lineStartIndex, P.lineLength, -1, k), R = t.icon.placedSymbolArray.length - 1, W && (O = 4 * W.length, t.addSymbols(t.icon, W, Z, x, y, b, Cl.vertical, e, P.lineStartIndex, P.lineLength, -1, k), F = t.icon.placedSymbolArray.length - 1);
                    }

                    for (var J in n.horizontal) {
                      var K = n.horizontal[J];

                      if (!S) {
                        N = ya(K.text);
                        var Q = s.layout.get("text-rotate").evaluate(b, {}, k);
                        S = new sc(l, e, c, u, f, K, h, p, d, Q);
                      }

                      var $ = 1 === K.positionedLines.length;
                      if (z += gc(t, e, K, a, s, d, b, m, P, n.vertical ? Cl.horizontal : Cl.horizontalOnly, $ ? Object.keys(n.horizontal) : [J], B, R, w, k), $) break;
                    }

                    n.vertical && (D += gc(t, e, n.vertical, a, s, d, b, m, P, Cl.vertical, ["vertical"], B, F, w, k));

                    var tt = S ? S.boxStartIndex : t.collisionBoxArray.length,
                        et = S ? S.boxEndIndex : t.collisionBoxArray.length,
                        rt = L ? L.boxStartIndex : t.collisionBoxArray.length,
                        nt = L ? L.boxEndIndex : t.collisionBoxArray.length,
                        it = E ? E.boxStartIndex : t.collisionBoxArray.length,
                        at = E ? E.boxEndIndex : t.collisionBoxArray.length,
                        ot = C ? C.boxStartIndex : t.collisionBoxArray.length,
                        st = C ? C.boxEndIndex : t.collisionBoxArray.length,
                        lt = -1,
                        ct = function ct(t, e) {
                      return t && t.circleDiameter ? Math.max(t.circleDiameter, e) : e;
                    };

                    lt = ct(S, lt), lt = ct(L, lt), lt = ct(E, lt);
                    var ut = (lt = ct(C, lt)) > -1 ? 1 : 0;
                    ut && (lt *= M / 24);
                    t.glyphOffsetArray.length >= Ac.MAX_GLYPHS && _("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907");
                    void 0 !== b.sortKey && t.addToSortKeyRanges(t.symbolInstances.length, b.sortKey);
                    t.symbolInstances.emplaceBack(e.x, e.y, B.right >= 0 ? B.right : -1, B.center >= 0 ? B.center : -1, B.left >= 0 ? B.left : -1, B.vertical || -1, R, F, N, tt, et, rt, nt, it, at, ot, st, c, z, D, I, O, ut, 0, h, j, U, lt);
                  }(t, f, s, r, n, i, h, t.layers[0], t.collisionBoxArray, e.index, e.sourceLayerIndex, t.index, v, w, M, l, x, T, A, d, e, a, c, u, o);
                };

                if ("line" === S) for (var P = 0, I = ec(e.geometry, 0, 0, 8192, 8192); P < I.length; P += 1) {
                  for (var O = I[P], z = tc(O, b, k, r.vertical || m, n, 24, y, t.overscaling, 8192), D = 0, R = z; D < R.length; D += 1) {
                    var F = R[D],
                        B = m;
                    B && yc(t, B.text, E, F) || C(O, F);
                  }
                } else if ("line-center" === S) for (var N = 0, j = e.geometry; N < j.length; N += 1) {
                  var U = j[N];

                  if (U.length > 1) {
                    var V = $l(U, k, r.vertical || m, n, 24, y);
                    V && C(U, V);
                  }
                } else if ("Polygon" === e.type) for (var q = 0, H = hs(e.geometry, 0); q < H.length; q += 1) {
                  var G = H[q],
                      Y = uc(G, 16);
                  C(G[0], new Hl(Y.x, Y.y, 0));
                } else if ("LineString" === e.type) for (var W = 0, X = e.geometry; W < X.length; W += 1) {
                  var Z = X[W];
                  C(Z, new Hl(Z[0].x, Z[0].y, 0));
                } else if ("Point" === e.type) for (var J = 0, K = e.geometry; J < K.length; J += 1) {
                  for (var Q = K[J], $ = 0, tt = Q; $ < tt.length; $ += 1) {
                    var et = tt[$];
                    C([et], new Hl(et.x, et.y, 0));
                  }
                }
              }(t, a, p, N, n, u, f, h, m, j, o);
            }, T = 0, k = t.features; T < k.length; T += 1) {
              w();
            }

            a && t.generateCollisionDebugBuffers();
          }, t.perspective = function (t, e, r, n, i) {
            var a,
                o = 1 / Math.tan(e / 2);
            return t[0] = o / r, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = o, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[11] = -1, t[12] = 0, t[13] = 0, t[15] = 0, null != i && i !== 1 / 0 ? (a = 1 / (n - i), t[10] = (i + n) * a, t[14] = 2 * i * n * a) : (t[10] = -1, t[14] = -2 * n), t;
          }, t.pick = function (t, e) {
            for (var r = {}, n = 0; n < e.length; n++) {
              var i = e[n];
              i in t && (r[i] = t[i]);
            }

            return r;
          }, t.plugin = hi, t.polygonIntersectsPolygon = Za, t.postMapLoadEvent = it, t.postTurnstileEvent = rt, t.potpack = Al, t.refProperties = ["type", "source", "source-layer", "minzoom", "maxzoom", "filter", "layout"], t.register = Nn, t.registerForPluginStateChange = function (t) {
            return t({
              pluginStatus: ai,
              pluginURL: oi
            }), ci.on("pluginStateChange", t), t;
          }, t.rotate = function (t, e, r) {
            var n = e[0],
                i = e[1],
                a = e[2],
                o = e[3],
                s = Math.sin(r),
                l = Math.cos(r);
            return t[0] = n * l + a * s, t[1] = i * l + o * s, t[2] = n * -s + a * l, t[3] = i * -s + o * l, t;
          }, t.rotateX = function (t, e, r) {
            var n = Math.sin(r),
                i = Math.cos(r),
                a = e[4],
                o = e[5],
                s = e[6],
                l = e[7],
                c = e[8],
                u = e[9],
                f = e[10],
                h = e[11];
            return e !== t && (t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[4] = a * i + c * n, t[5] = o * i + u * n, t[6] = s * i + f * n, t[7] = l * i + h * n, t[8] = c * i - a * n, t[9] = u * i - o * n, t[10] = f * i - s * n, t[11] = h * i - l * n, t;
          }, t.rotateZ = function (t, e, r) {
            var n = Math.sin(r),
                i = Math.cos(r),
                a = e[0],
                o = e[1],
                s = e[2],
                l = e[3],
                c = e[4],
                u = e[5],
                f = e[6],
                h = e[7];
            return e !== t && (t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[0] = a * i + c * n, t[1] = o * i + u * n, t[2] = s * i + f * n, t[3] = l * i + h * n, t[4] = c * i - a * n, t[5] = u * i - o * n, t[6] = f * i - s * n, t[7] = h * i - l * n, t;
          }, t.scale = function (t, e, r) {
            var n = r[0],
                i = r[1],
                a = r[2];
            return t[0] = e[0] * n, t[1] = e[1] * n, t[2] = e[2] * n, t[3] = e[3] * n, t[4] = e[4] * i, t[5] = e[5] * i, t[6] = e[6] * i, t[7] = e[7] * i, t[8] = e[8] * a, t[9] = e[9] * a, t[10] = e[10] * a, t[11] = e[11] * a, t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
          }, t.scale$1 = function (t, e, r) {
            return t[0] = e[0] * r, t[1] = e[1] * r, t[2] = e[2] * r, t[3] = e[3] * r, t;
          }, t.scale$2 = function (t, e, r) {
            return t[0] = e[0] * r, t[1] = e[1] * r, t[2] = e[2] * r, t;
          }, t.setCacheLimits = function (t, e) {
            at = t, ot = e;
          }, t.setRTLTextPlugin = function (t, e, r) {
            if (void 0 === r && (r = !1), ai === ti || ai === ei || ai === ri) throw new Error("setRTLTextPlugin cannot be called multiple times.");
            oi = R.resolveURL(t), ai = ti, ii = e, li(), r || fi();
          }, t.sphericalToCartesian = function (t) {
            var e = t[0],
                r = t[1],
                n = t[2];
            return r += 90, r *= Math.PI / 180, n *= Math.PI / 180, {
              x: e * Math.cos(r) * Math.sin(n),
              y: e * Math.sin(r) * Math.sin(n),
              z: e * Math.cos(n)
            };
          }, t.sqrLen = bo, t.styleSpec = Lt, t.sub = yo, t.symbolSize = Xl, t.transformMat3 = function (t, e, r) {
            var n = e[0],
                i = e[1],
                a = e[2];
            return t[0] = n * r[0] + i * r[3] + a * r[6], t[1] = n * r[1] + i * r[4] + a * r[7], t[2] = n * r[2] + i * r[5] + a * r[8], t;
          }, t.transformMat4 = xo, t.translate = function (t, e, r) {
            var n,
                i,
                a,
                o,
                s,
                l,
                c,
                u,
                f,
                h,
                p,
                d,
                m = r[0],
                g = r[1],
                v = r[2];
            return e === t ? (t[12] = e[0] * m + e[4] * g + e[8] * v + e[12], t[13] = e[1] * m + e[5] * g + e[9] * v + e[13], t[14] = e[2] * m + e[6] * g + e[10] * v + e[14], t[15] = e[3] * m + e[7] * g + e[11] * v + e[15]) : (n = e[0], i = e[1], a = e[2], o = e[3], s = e[4], l = e[5], c = e[6], u = e[7], f = e[8], h = e[9], p = e[10], d = e[11], t[0] = n, t[1] = i, t[2] = a, t[3] = o, t[4] = s, t[5] = l, t[6] = c, t[7] = u, t[8] = f, t[9] = h, t[10] = p, t[11] = d, t[12] = n * m + s * g + f * v + e[12], t[13] = i * m + l * g + h * v + e[13], t[14] = a * m + c * g + p * v + e[14], t[15] = o * m + u * g + d * v + e[15]), t;
          }, t.triggerPluginCompletionEvent = si, t.uniqueId = h, t.validateCustomStyleLayer = function (t) {
            var e = [],
                r = t.id;
            return void 0 === r && e.push({
              message: "layers." + r + ': missing required property "id"'
            }), void 0 === t.render && e.push({
              message: "layers." + r + ': missing required method "render"'
            }), t.renderingMode && "2d" !== t.renderingMode && "3d" !== t.renderingMode && e.push({
              message: "layers." + r + ': property "renderingMode" must be either "2d" or "3d"'
            }), e;
          }, t.validateLight = Cn, t.validateStyle = Ln, t.values = function (t) {
            var e = [];

            for (var r in t) {
              e.push(t[r]);
            }

            return e;
          }, t.vectorTile = Ls, t.version = "1.10.1", t.warnOnce = _, t.webpSupported = B, t.window = self, t.wrap = c;
        }), n(0, function (t) {
          function e(t) {
            var r = _typeof(t);

            if ("number" === r || "boolean" === r || "string" === r || null == t) return JSON.stringify(t);

            if (Array.isArray(t)) {
              for (var n = "[", i = 0, a = t; i < a.length; i += 1) {
                n += e(a[i]) + ",";
              }

              return n + "]";
            }

            for (var o = Object.keys(t).sort(), s = "{", l = 0; l < o.length; l++) {
              s += JSON.stringify(o[l]) + ":" + e(t[o[l]]) + ",";
            }

            return s + "}";
          }

          function r(r) {
            for (var n = "", i = 0, a = t.refProperties; i < a.length; i += 1) {
              n += "/" + e(r[a[i]]);
            }

            return n;
          }

          var n = function n(t) {
            this.keyCache = {}, t && this.replace(t);
          };

          n.prototype.replace = function (t) {
            this._layerConfigs = {}, this._layers = {}, this.update(t, []);
          }, n.prototype.update = function (e, n) {
            for (var i = this, a = 0, o = e; a < o.length; a += 1) {
              var s = o[a];
              this._layerConfigs[s.id] = s;
              var l = this._layers[s.id] = t.createStyleLayer(s);
              l._featureFilter = t.featureFilter(l.filter), this.keyCache[s.id] && delete this.keyCache[s.id];
            }

            for (var c = 0, u = n; c < u.length; c += 1) {
              var f = u[c];
              delete this.keyCache[f], delete this._layerConfigs[f], delete this._layers[f];
            }

            this.familiesBySource = {};

            for (var h = 0, p = function (t, e) {
              for (var n = {}, i = 0; i < t.length; i++) {
                var a = e && e[t[i].id] || r(t[i]);
                e && (e[t[i].id] = a);
                var o = n[a];
                o || (o = n[a] = []), o.push(t[i]);
              }

              var s = [];

              for (var l in n) {
                s.push(n[l]);
              }

              return s;
            }(t.values(this._layerConfigs), this.keyCache); h < p.length; h += 1) {
              var d = p[h].map(function (t) {
                return i._layers[t.id];
              }),
                  m = d[0];

              if ("none" !== m.visibility) {
                var g = m.source || "",
                    v = this.familiesBySource[g];
                v || (v = this.familiesBySource[g] = {});
                var y = m.sourceLayer || "_geojsonTileLayer",
                    x = v[y];
                x || (x = v[y] = []), x.push(d);
              }
            }
          };

          var i = function i(e) {
            var r = {},
                n = [];

            for (var i in e) {
              var a = e[i],
                  o = r[i] = {};

              for (var s in a) {
                var l = a[+s];

                if (l && 0 !== l.bitmap.width && 0 !== l.bitmap.height) {
                  var c = {
                    x: 0,
                    y: 0,
                    w: l.bitmap.width + 2,
                    h: l.bitmap.height + 2
                  };
                  n.push(c), o[s] = {
                    rect: c,
                    metrics: l.metrics
                  };
                }
              }
            }

            var u = t.potpack(n),
                f = u.w,
                h = u.h,
                p = new t.AlphaImage({
              width: f || 1,
              height: h || 1
            });

            for (var d in e) {
              var m = e[d];

              for (var g in m) {
                var v = m[+g];

                if (v && 0 !== v.bitmap.width && 0 !== v.bitmap.height) {
                  var y = r[d][g].rect;
                  t.AlphaImage.copy(v.bitmap, p, {
                    x: 0,
                    y: 0
                  }, {
                    x: y.x + 1,
                    y: y.y + 1
                  }, v.bitmap);
                }
              }
            }

            this.image = p, this.positions = r;
          };

          t.register("GlyphAtlas", i);

          var a = function a(e) {
            this.tileID = new t.OverscaledTileID(e.tileID.overscaledZ, e.tileID.wrap, e.tileID.canonical.z, e.tileID.canonical.x, e.tileID.canonical.y), this.uid = e.uid, this.zoom = e.zoom, this.pixelRatio = e.pixelRatio, this.tileSize = e.tileSize, this.source = e.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = e.showCollisionBoxes, this.collectResourceTiming = !!e.collectResourceTiming, this.returnDependencies = !!e.returnDependencies, this.promoteId = e.promoteId;
          };

          function o(e, r, n) {
            for (var i = new t.EvaluationParameters(r), a = 0, o = e; a < o.length; a += 1) {
              o[a].recalculate(i, n);
            }
          }

          function s(e, r) {
            var n = t.getArrayBuffer(e.request, function (e, n, i, a) {
              e ? r(e) : n && r(null, {
                vectorTile: new t.vectorTile.VectorTile(new t.pbf(n)),
                rawData: n,
                cacheControl: i,
                expires: a
              });
            });
            return function () {
              n.cancel(), r();
            };
          }

          a.prototype.parse = function (e, r, n, a, s) {
            var l = this;
            this.status = "parsing", this.data = e, this.collisionBoxArray = new t.CollisionBoxArray();
            var c = new t.DictionaryCoder(Object.keys(e.layers).sort()),
                u = new t.FeatureIndex(this.tileID, this.promoteId);
            u.bucketLayerIDs = [];
            var f,
                h,
                p,
                d,
                m = {},
                g = {
              featureIndex: u,
              iconDependencies: {},
              patternDependencies: {},
              glyphDependencies: {},
              availableImages: n
            },
                v = r.familiesBySource[this.source];

            for (var y in v) {
              var x = e.layers[y];

              if (x) {
                1 === x.version && t.warnOnce('Vector tile source "' + this.source + '" layer "' + y + '" does not use vector tile spec v2 and therefore may have some rendering errors.');

                for (var b = c.encode(y), _ = [], w = 0; w < x.length; w++) {
                  var T = x.feature(w),
                      k = u.getId(T, y);

                  _.push({
                    feature: T,
                    id: k,
                    index: w,
                    sourceLayerIndex: b
                  });
                }

                for (var M = 0, A = v[y]; M < A.length; M += 1) {
                  var S = A[M],
                      E = S[0];
                  if (!(E.minzoom && this.zoom < Math.floor(E.minzoom))) if (!(E.maxzoom && this.zoom >= E.maxzoom)) if ("none" !== E.visibility) o(S, this.zoom, n), (m[E.id] = E.createBucket({
                    index: u.bucketLayerIDs.length,
                    layers: S,
                    zoom: this.zoom,
                    pixelRatio: this.pixelRatio,
                    overscaling: this.overscaling,
                    collisionBoxArray: this.collisionBoxArray,
                    sourceLayerIndex: b,
                    sourceID: this.source
                  })).populate(_, g, this.tileID.canonical), u.bucketLayerIDs.push(S.map(function (t) {
                    return t.id;
                  }));
                }
              }
            }

            var L = t.mapObject(g.glyphDependencies, function (t) {
              return Object.keys(t).map(Number);
            });
            Object.keys(L).length ? a.send("getGlyphs", {
              uid: this.uid,
              stacks: L
            }, function (t, e) {
              f || (f = t, h = e, I.call(l));
            }) : h = {};
            var C = Object.keys(g.iconDependencies);
            C.length ? a.send("getImages", {
              icons: C,
              source: this.source,
              tileID: this.tileID,
              type: "icons"
            }, function (t, e) {
              f || (f = t, p = e, I.call(l));
            }) : p = {};
            var P = Object.keys(g.patternDependencies);

            function I() {
              if (f) return s(f);

              if (h && p && d) {
                var e = new i(h),
                    r = new t.ImageAtlas(p, d);

                for (var a in m) {
                  var l = m[a];
                  l instanceof t.SymbolBucket ? (o(l.layers, this.zoom, n), t.performSymbolLayout(l, h, e.positions, p, r.iconPositions, this.showCollisionBoxes, this.tileID.canonical)) : l.hasPattern && (l instanceof t.LineBucket || l instanceof t.FillBucket || l instanceof t.FillExtrusionBucket) && (o(l.layers, this.zoom, n), l.addFeatures(g, this.tileID.canonical, r.patternPositions));
                }

                this.status = "done", s(null, {
                  buckets: t.values(m).filter(function (t) {
                    return !t.isEmpty();
                  }),
                  featureIndex: u,
                  collisionBoxArray: this.collisionBoxArray,
                  glyphAtlasImage: e.image,
                  imageAtlas: r,
                  glyphMap: this.returnDependencies ? h : null,
                  iconMap: this.returnDependencies ? p : null,
                  glyphPositions: this.returnDependencies ? e.positions : null
                });
              }
            }

            P.length ? a.send("getImages", {
              icons: P,
              source: this.source,
              tileID: this.tileID,
              type: "patterns"
            }, function (t, e) {
              f || (f = t, d = e, I.call(l));
            }) : d = {}, I.call(this);
          };

          var l = function l(t, e, r, n) {
            this.actor = t, this.layerIndex = e, this.availableImages = r, this.loadVectorData = n || s, this.loading = {}, this.loaded = {};
          };

          l.prototype.loadTile = function (e, r) {
            var n = this,
                i = e.uid;
            this.loading || (this.loading = {});
            var o = !!(e && e.request && e.request.collectResourceTiming) && new t.RequestPerformance(e.request),
                s = this.loading[i] = new a(e);
            s.abort = this.loadVectorData(e, function (e, a) {
              if (delete n.loading[i], e || !a) return s.status = "done", n.loaded[i] = s, r(e);
              var l = a.rawData,
                  c = {};
              a.expires && (c.expires = a.expires), a.cacheControl && (c.cacheControl = a.cacheControl);
              var u = {};

              if (o) {
                var f = o.finish();
                f && (u.resourceTiming = JSON.parse(JSON.stringify(f)));
              }

              s.vectorTile = a.vectorTile, s.parse(a.vectorTile, n.layerIndex, n.availableImages, n.actor, function (e, n) {
                if (e || !n) return r(e);
                r(null, t.extend({
                  rawTileData: l.slice(0)
                }, n, c, u));
              }), n.loaded = n.loaded || {}, n.loaded[i] = s;
            });
          }, l.prototype.reloadTile = function (t, e) {
            var r = this,
                n = this.loaded,
                i = t.uid,
                a = this;

            if (n && n[i]) {
              var o = n[i];
              o.showCollisionBoxes = t.showCollisionBoxes;

              var s = function s(t, n) {
                var i = o.reloadCallback;
                i && (delete o.reloadCallback, o.parse(o.vectorTile, a.layerIndex, r.availableImages, a.actor, i)), e(t, n);
              };

              "parsing" === o.status ? o.reloadCallback = s : "done" === o.status && (o.vectorTile ? o.parse(o.vectorTile, this.layerIndex, this.availableImages, this.actor, s) : s());
            }
          }, l.prototype.abortTile = function (t, e) {
            var r = this.loading,
                n = t.uid;
            r && r[n] && r[n].abort && (r[n].abort(), delete r[n]), e();
          }, l.prototype.removeTile = function (t, e) {
            var r = this.loaded,
                n = t.uid;
            r && r[n] && delete r[n], e();
          };

          var c = t.window.ImageBitmap,
              u = function u() {
            this.loaded = {};
          };

          u.prototype.loadTile = function (e, r) {
            var n = e.uid,
                i = e.encoding,
                a = e.rawImageData,
                o = c && a instanceof c ? this.getImageData(a) : a,
                s = new t.DEMData(n, o, i);
            this.loaded = this.loaded || {}, this.loaded[n] = s, r(null, s);
          }, u.prototype.getImageData = function (e) {
            this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(e.width, e.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d")), this.offscreenCanvas.width = e.width, this.offscreenCanvas.height = e.height, this.offscreenCanvasContext.drawImage(e, 0, 0, e.width, e.height);
            var r = this.offscreenCanvasContext.getImageData(-1, -1, e.width + 2, e.height + 2);
            return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), new t.RGBAImage({
              width: r.width,
              height: r.height
            }, r.data);
          }, u.prototype.removeTile = function (t) {
            var e = this.loaded,
                r = t.uid;
            e && e[r] && delete e[r];
          };

          var f = function t(e, r) {
            var n,
                i = e && e.type;
            if ("FeatureCollection" === i) for (n = 0; n < e.features.length; n++) {
              t(e.features[n], r);
            } else if ("GeometryCollection" === i) for (n = 0; n < e.geometries.length; n++) {
              t(e.geometries[n], r);
            } else if ("Feature" === i) t(e.geometry, r);else if ("Polygon" === i) h(e.coordinates, r);else if ("MultiPolygon" === i) for (n = 0; n < e.coordinates.length; n++) {
              h(e.coordinates[n], r);
            }
            return e;
          };

          function h(t, e) {
            if (0 !== t.length) {
              p(t[0], e);

              for (var r = 1; r < t.length; r++) {
                p(t[r], !e);
              }
            }
          }

          function p(t, e) {
            for (var r = 0, n = 0, i = t.length, a = i - 1; n < i; a = n++) {
              r += (t[n][0] - t[a][0]) * (t[a][1] + t[n][1]);
            }

            r >= 0 != !!e && t.reverse();
          }

          var d = t.vectorTile.VectorTileFeature.prototype.toGeoJSON,
              m = function m(e) {
            this._feature = e, this.extent = t.EXTENT, this.type = e.type, this.properties = e.tags, "id" in e && !isNaN(e.id) && (this.id = parseInt(e.id, 10));
          };

          m.prototype.loadGeometry = function () {
            if (1 === this._feature.type) {
              for (var e = [], r = 0, n = this._feature.geometry; r < n.length; r += 1) {
                var i = n[r];
                e.push([new t.Point$1(i[0], i[1])]);
              }

              return e;
            }

            for (var a = [], o = 0, s = this._feature.geometry; o < s.length; o += 1) {
              for (var l = [], c = 0, u = s[o]; c < u.length; c += 1) {
                var f = u[c];
                l.push(new t.Point$1(f[0], f[1]));
              }

              a.push(l);
            }

            return a;
          }, m.prototype.toGeoJSON = function (t, e, r) {
            return d.call(this, t, e, r);
          };

          var g = function g(e) {
            this.layers = {
              _geojsonTileLayer: this
            }, this.name = "_geojsonTileLayer", this.extent = t.EXTENT, this.length = e.length, this._features = e;
          };

          g.prototype.feature = function (t) {
            return new m(this._features[t]);
          };

          var v = t.vectorTile.VectorTileFeature,
              y = x;

          function x(t, e) {
            this.options = e || {}, this.features = t, this.length = t.length;
          }

          function b(t, e) {
            this.id = "number" == typeof t.id ? t.id : void 0, this.type = t.type, this.rawGeometry = 1 === t.type ? [t.geometry] : t.geometry, this.properties = t.tags, this.extent = e || 4096;
          }

          x.prototype.feature = function (t) {
            return new b(this.features[t], this.options.extent);
          }, b.prototype.loadGeometry = function () {
            var e = this.rawGeometry;
            this.geometry = [];

            for (var r = 0; r < e.length; r++) {
              for (var n = e[r], i = [], a = 0; a < n.length; a++) {
                i.push(new t.Point$1(n[a][0], n[a][1]));
              }

              this.geometry.push(i);
            }

            return this.geometry;
          }, b.prototype.bbox = function () {
            this.geometry || this.loadGeometry();

            for (var t = this.geometry, e = 1 / 0, r = -1 / 0, n = 1 / 0, i = -1 / 0, a = 0; a < t.length; a++) {
              for (var o = t[a], s = 0; s < o.length; s++) {
                var l = o[s];
                e = Math.min(e, l.x), r = Math.max(r, l.x), n = Math.min(n, l.y), i = Math.max(i, l.y);
              }
            }

            return [e, n, r, i];
          }, b.prototype.toGeoJSON = v.prototype.toGeoJSON;

          var _ = M,
              w = M,
              T = function T(t, e) {
            e = e || {};
            var r = {};

            for (var n in t) {
              r[n] = new y(t[n].features, e), r[n].name = n, r[n].version = e.version, r[n].extent = e.extent;
            }

            return M({
              layers: r
            });
          },
              k = y;

          function M(e) {
            var r = new t.pbf();
            return function (t, e) {
              for (var r in t.layers) {
                e.writeMessage(3, A, t.layers[r]);
              }
            }(e, r), r.finish();
          }

          function A(t, e) {
            var r;
            e.writeVarintField(15, t.version || 1), e.writeStringField(1, t.name || ""), e.writeVarintField(5, t.extent || 4096);
            var n = {
              keys: [],
              values: [],
              keycache: {},
              valuecache: {}
            };

            for (r = 0; r < t.length; r++) {
              n.feature = t.feature(r), e.writeMessage(2, S, n);
            }

            var i = n.keys;

            for (r = 0; r < i.length; r++) {
              e.writeStringField(3, i[r]);
            }

            var a = n.values;

            for (r = 0; r < a.length; r++) {
              e.writeMessage(4, I, a[r]);
            }
          }

          function S(t, e) {
            var r = t.feature;
            void 0 !== r.id && e.writeVarintField(1, r.id), e.writeMessage(2, E, t), e.writeVarintField(3, r.type), e.writeMessage(4, P, r);
          }

          function E(t, e) {
            var r = t.feature,
                n = t.keys,
                i = t.values,
                a = t.keycache,
                o = t.valuecache;

            for (var s in r.properties) {
              var l = a[s];
              void 0 === l && (n.push(s), l = n.length - 1, a[s] = l), e.writeVarint(l);

              var c = r.properties[s],
                  u = _typeof(c);

              "string" !== u && "boolean" !== u && "number" !== u && (c = JSON.stringify(c));
              var f = u + ":" + c,
                  h = o[f];
              void 0 === h && (i.push(c), h = i.length - 1, o[f] = h), e.writeVarint(h);
            }
          }

          function L(t, e) {
            return (e << 3) + (7 & t);
          }

          function C(t) {
            return t << 1 ^ t >> 31;
          }

          function P(t, e) {
            for (var r = t.loadGeometry(), n = t.type, i = 0, a = 0, o = r.length, s = 0; s < o; s++) {
              var l = r[s],
                  c = 1;
              1 === n && (c = l.length), e.writeVarint(L(1, c));

              for (var u = 3 === n ? l.length - 1 : l.length, f = 0; f < u; f++) {
                1 === f && 1 !== n && e.writeVarint(L(2, u - 1));
                var h = l[f].x - i,
                    p = l[f].y - a;
                e.writeVarint(C(h)), e.writeVarint(C(p)), i += h, a += p;
              }

              3 === n && e.writeVarint(L(7, 1));
            }
          }

          function I(t, e) {
            var r = _typeof(t);

            "string" === r ? e.writeStringField(1, t) : "boolean" === r ? e.writeBooleanField(7, t) : "number" === r && (t % 1 != 0 ? e.writeDoubleField(3, t) : t < 0 ? e.writeSVarintField(6, t) : e.writeVarintField(5, t));
          }

          function O(t, e, r, n, i, a) {
            if (!(i - n <= r)) {
              var o = n + i >> 1;
              !function t(e, r, n, i, a, o) {
                for (; a > i;) {
                  if (a - i > 600) {
                    var s = a - i + 1,
                        l = n - i + 1,
                        c = Math.log(s),
                        u = .5 * Math.exp(2 * c / 3),
                        f = .5 * Math.sqrt(c * u * (s - u) / s) * (l - s / 2 < 0 ? -1 : 1),
                        h = Math.max(i, Math.floor(n - l * u / s + f)),
                        p = Math.min(a, Math.floor(n + (s - l) * u / s + f));
                    t(e, r, n, h, p, o);
                  }

                  var d = r[2 * n + o],
                      m = i,
                      g = a;

                  for (z(e, r, i, n), r[2 * a + o] > d && z(e, r, i, a); m < g;) {
                    for (z(e, r, m, g), m++, g--; r[2 * m + o] < d;) {
                      m++;
                    }

                    for (; r[2 * g + o] > d;) {
                      g--;
                    }
                  }

                  r[2 * i + o] === d ? z(e, r, i, g) : (g++, z(e, r, g, a)), g <= n && (i = g + 1), n <= g && (a = g - 1);
                }
              }(t, e, o, n, i, a % 2), O(t, e, r, n, o - 1, a + 1), O(t, e, r, o + 1, i, a + 1);
            }
          }

          function z(t, e, r, n) {
            D(t, r, n), D(e, 2 * r, 2 * n), D(e, 2 * r + 1, 2 * n + 1);
          }

          function D(t, e, r) {
            var n = t[e];
            t[e] = t[r], t[r] = n;
          }

          function R(t, e, r, n) {
            var i = t - r,
                a = e - n;
            return i * i + a * a;
          }

          _.fromVectorTileJs = w, _.fromGeojsonVt = T, _.GeoJSONWrapper = k;

          var F = function F(t) {
            return t[0];
          },
              B = function B(t) {
            return t[1];
          },
              N = function N(t, e, r, n, i) {
            void 0 === e && (e = F), void 0 === r && (r = B), void 0 === n && (n = 64), void 0 === i && (i = Float64Array), this.nodeSize = n, this.points = t;

            for (var a = t.length < 65536 ? Uint16Array : Uint32Array, o = this.ids = new a(t.length), s = this.coords = new i(2 * t.length), l = 0; l < t.length; l++) {
              o[l] = l, s[2 * l] = e(t[l]), s[2 * l + 1] = r(t[l]);
            }

            O(o, s, n, 0, o.length - 1, 0);
          };

          N.prototype.range = function (t, e, r, n) {
            return function (t, e, r, n, i, a, o) {
              for (var s, l, c = [0, t.length - 1, 0], u = []; c.length;) {
                var f = c.pop(),
                    h = c.pop(),
                    p = c.pop();
                if (h - p <= o) for (var d = p; d <= h; d++) {
                  s = e[2 * d], l = e[2 * d + 1], s >= r && s <= i && l >= n && l <= a && u.push(t[d]);
                } else {
                  var m = Math.floor((p + h) / 2);
                  s = e[2 * m], l = e[2 * m + 1], s >= r && s <= i && l >= n && l <= a && u.push(t[m]);
                  var g = (f + 1) % 2;
                  (0 === f ? r <= s : n <= l) && (c.push(p), c.push(m - 1), c.push(g)), (0 === f ? i >= s : a >= l) && (c.push(m + 1), c.push(h), c.push(g));
                }
              }

              return u;
            }(this.ids, this.coords, t, e, r, n, this.nodeSize);
          }, N.prototype.within = function (t, e, r) {
            return function (t, e, r, n, i, a) {
              for (var o = [0, t.length - 1, 0], s = [], l = i * i; o.length;) {
                var c = o.pop(),
                    u = o.pop(),
                    f = o.pop();
                if (u - f <= a) for (var h = f; h <= u; h++) {
                  R(e[2 * h], e[2 * h + 1], r, n) <= l && s.push(t[h]);
                } else {
                  var p = Math.floor((f + u) / 2),
                      d = e[2 * p],
                      m = e[2 * p + 1];
                  R(d, m, r, n) <= l && s.push(t[p]);
                  var g = (c + 1) % 2;
                  (0 === c ? r - i <= d : n - i <= m) && (o.push(f), o.push(p - 1), o.push(g)), (0 === c ? r + i >= d : n + i >= m) && (o.push(p + 1), o.push(u), o.push(g));
                }
              }

              return s;
            }(this.ids, this.coords, t, e, r, this.nodeSize);
          };

          var j = {
            minZoom: 0,
            maxZoom: 16,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: function map(t) {
              return t;
            }
          },
              U = function U(t) {
            this.options = X(Object.create(j), t), this.trees = new Array(this.options.maxZoom + 1);
          };

          function V(t, e, r, n, i) {
            return {
              x: t,
              y: e,
              zoom: 1 / 0,
              id: r,
              parentId: -1,
              numPoints: n,
              properties: i
            };
          }

          function q(t, e) {
            var r = t.geometry.coordinates,
                n = r[0],
                i = r[1];
            return {
              x: Y(n),
              y: W(i),
              zoom: 1 / 0,
              index: e,
              parentId: -1
            };
          }

          function H(t) {
            return {
              type: "Feature",
              id: t.id,
              properties: G(t),
              geometry: {
                type: "Point",
                coordinates: [(n = t.x, 360 * (n - .5)), (e = t.y, r = (180 - 360 * e) * Math.PI / 180, 360 * Math.atan(Math.exp(r)) / Math.PI - 90)]
              }
            };
            var e, r, n;
          }

          function G(t) {
            var e = t.numPoints,
                r = e >= 1e4 ? Math.round(e / 1e3) + "k" : e >= 1e3 ? Math.round(e / 100) / 10 + "k" : e;
            return X(X({}, t.properties), {
              cluster: !0,
              cluster_id: t.id,
              point_count: e,
              point_count_abbreviated: r
            });
          }

          function Y(t) {
            return t / 360 + .5;
          }

          function W(t) {
            var e = Math.sin(t * Math.PI / 180),
                r = .5 - .25 * Math.log((1 + e) / (1 - e)) / Math.PI;
            return r < 0 ? 0 : r > 1 ? 1 : r;
          }

          function X(t, e) {
            for (var r in e) {
              t[r] = e[r];
            }

            return t;
          }

          function Z(t) {
            return t.x;
          }

          function J(t) {
            return t.y;
          }

          function K(t, e, r, n, i, a) {
            var o = i - r,
                s = a - n;

            if (0 !== o || 0 !== s) {
              var l = ((t - r) * o + (e - n) * s) / (o * o + s * s);
              l > 1 ? (r = i, n = a) : l > 0 && (r += o * l, n += s * l);
            }

            return (o = t - r) * o + (s = e - n) * s;
          }

          function Q(t, e, r, n) {
            var i = {
              id: void 0 === t ? null : t,
              type: e,
              geometry: r,
              tags: n,
              minX: 1 / 0,
              minY: 1 / 0,
              maxX: -1 / 0,
              maxY: -1 / 0
            };
            return function (t) {
              var e = t.geometry,
                  r = t.type;
              if ("Point" === r || "MultiPoint" === r || "LineString" === r) $(t, e);else if ("Polygon" === r || "MultiLineString" === r) for (var n = 0; n < e.length; n++) {
                $(t, e[n]);
              } else if ("MultiPolygon" === r) for (n = 0; n < e.length; n++) {
                for (var i = 0; i < e[n].length; i++) {
                  $(t, e[n][i]);
                }
              }
            }(i), i;
          }

          function $(t, e) {
            for (var r = 0; r < e.length; r += 3) {
              t.minX = Math.min(t.minX, e[r]), t.minY = Math.min(t.minY, e[r + 1]), t.maxX = Math.max(t.maxX, e[r]), t.maxY = Math.max(t.maxY, e[r + 1]);
            }
          }

          function tt(t, e, r, n) {
            if (e.geometry) {
              var i = e.geometry.coordinates,
                  a = e.geometry.type,
                  o = Math.pow(r.tolerance / ((1 << r.maxZoom) * r.extent), 2),
                  s = [],
                  l = e.id;
              if (r.promoteId ? l = e.properties[r.promoteId] : r.generateId && (l = n || 0), "Point" === a) et(i, s);else if ("MultiPoint" === a) for (var c = 0; c < i.length; c++) {
                et(i[c], s);
              } else if ("LineString" === a) rt(i, s, o, !1);else if ("MultiLineString" === a) {
                if (r.lineMetrics) {
                  for (c = 0; c < i.length; c++) {
                    s = [], rt(i[c], s, o, !1), t.push(Q(l, "LineString", s, e.properties));
                  }

                  return;
                }

                nt(i, s, o, !1);
              } else if ("Polygon" === a) nt(i, s, o, !0);else {
                if ("MultiPolygon" !== a) {
                  if ("GeometryCollection" === a) {
                    for (c = 0; c < e.geometry.geometries.length; c++) {
                      tt(t, {
                        id: l,
                        geometry: e.geometry.geometries[c],
                        properties: e.properties
                      }, r, n);
                    }

                    return;
                  }

                  throw new Error("Input data is not a valid GeoJSON object.");
                }

                for (c = 0; c < i.length; c++) {
                  var u = [];
                  nt(i[c], u, o, !0), s.push(u);
                }
              }
              t.push(Q(l, a, s, e.properties));
            }
          }

          function et(t, e) {
            e.push(it(t[0])), e.push(at(t[1])), e.push(0);
          }

          function rt(t, e, r, n) {
            for (var i, a, o = 0, s = 0; s < t.length; s++) {
              var l = it(t[s][0]),
                  c = at(t[s][1]);
              e.push(l), e.push(c), e.push(0), s > 0 && (o += n ? (i * c - l * a) / 2 : Math.sqrt(Math.pow(l - i, 2) + Math.pow(c - a, 2))), i = l, a = c;
            }

            var u = e.length - 3;
            e[2] = 1, function t(e, r, n, i) {
              for (var a, o = i, s = n - r >> 1, l = n - r, c = e[r], u = e[r + 1], f = e[n], h = e[n + 1], p = r + 3; p < n; p += 3) {
                var d = K(e[p], e[p + 1], c, u, f, h);
                if (d > o) a = p, o = d;else if (d === o) {
                  var m = Math.abs(p - s);
                  m < l && (a = p, l = m);
                }
              }

              o > i && (a - r > 3 && t(e, r, a, i), e[a + 2] = o, n - a > 3 && t(e, a, n, i));
            }(e, 0, u, r), e[u + 2] = 1, e.size = Math.abs(o), e.start = 0, e.end = e.size;
          }

          function nt(t, e, r, n) {
            for (var i = 0; i < t.length; i++) {
              var a = [];
              rt(t[i], a, r, n), e.push(a);
            }
          }

          function it(t) {
            return t / 360 + .5;
          }

          function at(t) {
            var e = Math.sin(t * Math.PI / 180),
                r = .5 - .25 * Math.log((1 + e) / (1 - e)) / Math.PI;
            return r < 0 ? 0 : r > 1 ? 1 : r;
          }

          function ot(t, e, r, n, i, a, o, s) {
            if (n /= e, a >= (r /= e) && o < n) return t;
            if (o < r || a >= n) return null;

            for (var l = [], c = 0; c < t.length; c++) {
              var u = t[c],
                  f = u.geometry,
                  h = u.type,
                  p = 0 === i ? u.minX : u.minY,
                  d = 0 === i ? u.maxX : u.maxY;
              if (p >= r && d < n) l.push(u);else if (!(d < r || p >= n)) {
                var m = [];
                if ("Point" === h || "MultiPoint" === h) st(f, m, r, n, i);else if ("LineString" === h) lt(f, m, r, n, i, !1, s.lineMetrics);else if ("MultiLineString" === h) ut(f, m, r, n, i, !1);else if ("Polygon" === h) ut(f, m, r, n, i, !0);else if ("MultiPolygon" === h) for (var g = 0; g < f.length; g++) {
                  var v = [];
                  ut(f[g], v, r, n, i, !0), v.length && m.push(v);
                }

                if (m.length) {
                  if (s.lineMetrics && "LineString" === h) {
                    for (g = 0; g < m.length; g++) {
                      l.push(Q(u.id, h, m[g], u.tags));
                    }

                    continue;
                  }

                  "LineString" !== h && "MultiLineString" !== h || (1 === m.length ? (h = "LineString", m = m[0]) : h = "MultiLineString"), "Point" !== h && "MultiPoint" !== h || (h = 3 === m.length ? "Point" : "MultiPoint"), l.push(Q(u.id, h, m, u.tags));
                }
              }
            }

            return l.length ? l : null;
          }

          function st(t, e, r, n, i) {
            for (var a = 0; a < t.length; a += 3) {
              var o = t[a + i];
              o >= r && o <= n && (e.push(t[a]), e.push(t[a + 1]), e.push(t[a + 2]));
            }
          }

          function lt(t, e, r, n, i, a, o) {
            for (var s, l, c = ct(t), u = 0 === i ? ht : pt, f = t.start, h = 0; h < t.length - 3; h += 3) {
              var p = t[h],
                  d = t[h + 1],
                  m = t[h + 2],
                  g = t[h + 3],
                  v = t[h + 4],
                  y = 0 === i ? p : d,
                  x = 0 === i ? g : v,
                  b = !1;
              o && (s = Math.sqrt(Math.pow(p - g, 2) + Math.pow(d - v, 2))), y < r ? x > r && (l = u(c, p, d, g, v, r), o && (c.start = f + s * l)) : y > n ? x < n && (l = u(c, p, d, g, v, n), o && (c.start = f + s * l)) : ft(c, p, d, m), x < r && y >= r && (l = u(c, p, d, g, v, r), b = !0), x > n && y <= n && (l = u(c, p, d, g, v, n), b = !0), !a && b && (o && (c.end = f + s * l), e.push(c), c = ct(t)), o && (f += s);
            }

            var _ = t.length - 3;

            p = t[_], d = t[_ + 1], m = t[_ + 2], (y = 0 === i ? p : d) >= r && y <= n && ft(c, p, d, m), _ = c.length - 3, a && _ >= 3 && (c[_] !== c[0] || c[_ + 1] !== c[1]) && ft(c, c[0], c[1], c[2]), c.length && e.push(c);
          }

          function ct(t) {
            var e = [];
            return e.size = t.size, e.start = t.start, e.end = t.end, e;
          }

          function ut(t, e, r, n, i, a) {
            for (var o = 0; o < t.length; o++) {
              lt(t[o], e, r, n, i, a, !1);
            }
          }

          function ft(t, e, r, n) {
            t.push(e), t.push(r), t.push(n);
          }

          function ht(t, e, r, n, i, a) {
            var o = (a - e) / (n - e);
            return t.push(a), t.push(r + (i - r) * o), t.push(1), o;
          }

          function pt(t, e, r, n, i, a) {
            var o = (a - r) / (i - r);
            return t.push(e + (n - e) * o), t.push(a), t.push(1), o;
          }

          function dt(t, e) {
            for (var r = [], n = 0; n < t.length; n++) {
              var i,
                  a = t[n],
                  o = a.type;
              if ("Point" === o || "MultiPoint" === o || "LineString" === o) i = mt(a.geometry, e);else if ("MultiLineString" === o || "Polygon" === o) {
                i = [];

                for (var s = 0; s < a.geometry.length; s++) {
                  i.push(mt(a.geometry[s], e));
                }
              } else if ("MultiPolygon" === o) for (i = [], s = 0; s < a.geometry.length; s++) {
                for (var l = [], c = 0; c < a.geometry[s].length; c++) {
                  l.push(mt(a.geometry[s][c], e));
                }

                i.push(l);
              }
              r.push(Q(a.id, o, i, a.tags));
            }

            return r;
          }

          function mt(t, e) {
            var r = [];
            r.size = t.size, void 0 !== t.start && (r.start = t.start, r.end = t.end);

            for (var n = 0; n < t.length; n += 3) {
              r.push(t[n] + e, t[n + 1], t[n + 2]);
            }

            return r;
          }

          function gt(t, e) {
            if (t.transformed) return t;
            var r,
                n,
                i,
                a = 1 << t.z,
                o = t.x,
                s = t.y;

            for (r = 0; r < t.features.length; r++) {
              var l = t.features[r],
                  c = l.geometry,
                  u = l.type;
              if (l.geometry = [], 1 === u) for (n = 0; n < c.length; n += 2) {
                l.geometry.push(vt(c[n], c[n + 1], e, a, o, s));
              } else for (n = 0; n < c.length; n++) {
                var f = [];

                for (i = 0; i < c[n].length; i += 2) {
                  f.push(vt(c[n][i], c[n][i + 1], e, a, o, s));
                }

                l.geometry.push(f);
              }
            }

            return t.transformed = !0, t;
          }

          function vt(t, e, r, n, i, a) {
            return [Math.round(r * (t * n - i)), Math.round(r * (e * n - a))];
          }

          function yt(t, e, r, n, i) {
            for (var a = e === i.maxZoom ? 0 : i.tolerance / ((1 << e) * i.extent), o = {
              features: [],
              numPoints: 0,
              numSimplified: 0,
              numFeatures: 0,
              source: null,
              x: r,
              y: n,
              z: e,
              transformed: !1,
              minX: 2,
              minY: 1,
              maxX: -1,
              maxY: 0
            }, s = 0; s < t.length; s++) {
              o.numFeatures++, xt(o, t[s], a, i);
              var l = t[s].minX,
                  c = t[s].minY,
                  u = t[s].maxX,
                  f = t[s].maxY;
              l < o.minX && (o.minX = l), c < o.minY && (o.minY = c), u > o.maxX && (o.maxX = u), f > o.maxY && (o.maxY = f);
            }

            return o;
          }

          function xt(t, e, r, n) {
            var i = e.geometry,
                a = e.type,
                o = [];
            if ("Point" === a || "MultiPoint" === a) for (var s = 0; s < i.length; s += 3) {
              o.push(i[s]), o.push(i[s + 1]), t.numPoints++, t.numSimplified++;
            } else if ("LineString" === a) bt(o, i, t, r, !1, !1);else if ("MultiLineString" === a || "Polygon" === a) for (s = 0; s < i.length; s++) {
              bt(o, i[s], t, r, "Polygon" === a, 0 === s);
            } else if ("MultiPolygon" === a) for (var l = 0; l < i.length; l++) {
              var c = i[l];

              for (s = 0; s < c.length; s++) {
                bt(o, c[s], t, r, !0, 0 === s);
              }
            }

            if (o.length) {
              var u = e.tags || null;

              if ("LineString" === a && n.lineMetrics) {
                for (var f in u = {}, e.tags) {
                  u[f] = e.tags[f];
                }

                u.mapbox_clip_start = i.start / i.size, u.mapbox_clip_end = i.end / i.size;
              }

              var h = {
                geometry: o,
                type: "Polygon" === a || "MultiPolygon" === a ? 3 : "LineString" === a || "MultiLineString" === a ? 2 : 1,
                tags: u
              };
              null !== e.id && (h.id = e.id), t.features.push(h);
            }
          }

          function bt(t, e, r, n, i, a) {
            var o = n * n;
            if (n > 0 && e.size < (i ? o : n)) r.numPoints += e.length / 3;else {
              for (var s = [], l = 0; l < e.length; l += 3) {
                (0 === n || e[l + 2] > o) && (r.numSimplified++, s.push(e[l]), s.push(e[l + 1])), r.numPoints++;
              }

              i && function (t, e) {
                for (var r = 0, n = 0, i = t.length, a = i - 2; n < i; a = n, n += 2) {
                  r += (t[n] - t[a]) * (t[n + 1] + t[a + 1]);
                }

                if (r > 0 === e) for (n = 0, i = t.length; n < i / 2; n += 2) {
                  var o = t[n],
                      s = t[n + 1];
                  t[n] = t[i - 2 - n], t[n + 1] = t[i - 1 - n], t[i - 2 - n] = o, t[i - 1 - n] = s;
                }
              }(s, a), t.push(s);
            }
          }

          function _t(t, e) {
            var r = (e = this.options = function (t, e) {
              for (var r in e) {
                t[r] = e[r];
              }

              return t;
            }(Object.create(this.options), e)).debug;

            if (r && console.time("preprocess data"), e.maxZoom < 0 || e.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
            if (e.promoteId && e.generateId) throw new Error("promoteId and generateId cannot be used together.");

            var n = function (t, e) {
              var r = [];
              if ("FeatureCollection" === t.type) for (var n = 0; n < t.features.length; n++) {
                tt(r, t.features[n], e, n);
              } else "Feature" === t.type ? tt(r, t, e) : tt(r, {
                geometry: t
              }, e);
              return r;
            }(t, e);

            this.tiles = {}, this.tileCoords = [], r && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", e.indexMaxZoom, e.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), (n = function (t, e) {
              var r = e.buffer / e.extent,
                  n = t,
                  i = ot(t, 1, -1 - r, r, 0, -1, 2, e),
                  a = ot(t, 1, 1 - r, 2 + r, 0, -1, 2, e);
              return (i || a) && (n = ot(t, 1, -r, 1 + r, 0, -1, 2, e) || [], i && (n = dt(i, 1).concat(n)), a && (n = n.concat(dt(a, -1)))), n;
            }(n, e)).length && this.splitTile(n, 0, 0, 0), r && (n.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
          }

          function wt(t, e, r) {
            return 32 * ((1 << t) * r + e) + t;
          }

          function Tt(t, e) {
            var r = t.tileID.canonical;
            if (!this._geoJSONIndex) return e(null, null);

            var n = this._geoJSONIndex.getTile(r.z, r.x, r.y);

            if (!n) return e(null, null);

            var i = new g(n.features),
                a = _(i);

            0 === a.byteOffset && a.byteLength === a.buffer.byteLength || (a = new Uint8Array(a)), e(null, {
              vectorTile: i,
              rawData: a.buffer
            });
          }

          U.prototype.load = function (t) {
            var e = this.options,
                r = e.log,
                n = e.minZoom,
                i = e.maxZoom,
                a = e.nodeSize;
            r && console.time("total time");
            var o = "prepare " + t.length + " points";
            r && console.time(o), this.points = t;

            for (var s = [], l = 0; l < t.length; l++) {
              t[l].geometry && s.push(q(t[l], l));
            }

            this.trees[i + 1] = new N(s, Z, J, a, Float32Array), r && console.timeEnd(o);

            for (var c = i; c >= n; c--) {
              var u = +Date.now();
              s = this._cluster(s, c), this.trees[c] = new N(s, Z, J, a, Float32Array), r && console.log("z%d: %d clusters in %dms", c, s.length, +Date.now() - u);
            }

            return r && console.timeEnd("total time"), this;
          }, U.prototype.getClusters = function (t, e) {
            var r = ((t[0] + 180) % 360 + 360) % 360 - 180,
                n = Math.max(-90, Math.min(90, t[1])),
                i = 180 === t[2] ? 180 : ((t[2] + 180) % 360 + 360) % 360 - 180,
                a = Math.max(-90, Math.min(90, t[3]));
            if (t[2] - t[0] >= 360) r = -180, i = 180;else if (r > i) {
              var o = this.getClusters([r, n, 180, a], e),
                  s = this.getClusters([-180, n, i, a], e);
              return o.concat(s);
            }

            for (var l = this.trees[this._limitZoom(e)], c = [], u = 0, f = l.range(Y(r), W(a), Y(i), W(n)); u < f.length; u += 1) {
              var h = f[u],
                  p = l.points[h];
              c.push(p.numPoints ? H(p) : this.points[p.index]);
            }

            return c;
          }, U.prototype.getChildren = function (t) {
            var e = this._getOriginId(t),
                r = this._getOriginZoom(t),
                n = "No cluster with the specified id.",
                i = this.trees[r];

            if (!i) throw new Error(n);
            var a = i.points[e];
            if (!a) throw new Error(n);

            for (var o = this.options.radius / (this.options.extent * Math.pow(2, r - 1)), s = [], l = 0, c = i.within(a.x, a.y, o); l < c.length; l += 1) {
              var u = c[l],
                  f = i.points[u];
              f.parentId === t && s.push(f.numPoints ? H(f) : this.points[f.index]);
            }

            if (0 === s.length) throw new Error(n);
            return s;
          }, U.prototype.getLeaves = function (t, e, r) {
            e = e || 10, r = r || 0;
            var n = [];
            return this._appendLeaves(n, t, e, r, 0), n;
          }, U.prototype.getTile = function (t, e, r) {
            var n = this.trees[this._limitZoom(t)],
                i = Math.pow(2, t),
                a = this.options,
                o = a.extent,
                s = a.radius / o,
                l = (r - s) / i,
                c = (r + 1 + s) / i,
                u = {
              features: []
            };

            return this._addTileFeatures(n.range((e - s) / i, l, (e + 1 + s) / i, c), n.points, e, r, i, u), 0 === e && this._addTileFeatures(n.range(1 - s / i, l, 1, c), n.points, i, r, i, u), e === i - 1 && this._addTileFeatures(n.range(0, l, s / i, c), n.points, -1, r, i, u), u.features.length ? u : null;
          }, U.prototype.getClusterExpansionZoom = function (t) {
            for (var e = this._getOriginZoom(t) - 1; e <= this.options.maxZoom;) {
              var r = this.getChildren(t);
              if (e++, 1 !== r.length) break;
              t = r[0].properties.cluster_id;
            }

            return e;
          }, U.prototype._appendLeaves = function (t, e, r, n, i) {
            for (var a = 0, o = this.getChildren(e); a < o.length; a += 1) {
              var s = o[a],
                  l = s.properties;
              if (l && l.cluster ? i + l.point_count <= n ? i += l.point_count : i = this._appendLeaves(t, l.cluster_id, r, n, i) : i < n ? i++ : t.push(s), t.length === r) break;
            }

            return i;
          }, U.prototype._addTileFeatures = function (t, e, r, n, i, a) {
            for (var o = 0, s = t; o < s.length; o += 1) {
              var l = e[s[o]],
                  c = l.numPoints,
                  u = {
                type: 1,
                geometry: [[Math.round(this.options.extent * (l.x * i - r)), Math.round(this.options.extent * (l.y * i - n))]],
                tags: c ? G(l) : this.points[l.index].properties
              },
                  f = void 0;
              c ? f = l.id : this.options.generateId ? f = l.index : this.points[l.index].id && (f = this.points[l.index].id), void 0 !== f && (u.id = f), a.features.push(u);
            }
          }, U.prototype._limitZoom = function (t) {
            return Math.max(this.options.minZoom, Math.min(t, this.options.maxZoom + 1));
          }, U.prototype._cluster = function (t, e) {
            for (var r = [], n = this.options, i = n.radius, a = n.extent, o = n.reduce, s = i / (a * Math.pow(2, e)), l = 0; l < t.length; l++) {
              var c = t[l];

              if (!(c.zoom <= e)) {
                c.zoom = e;

                for (var u = this.trees[e + 1], f = u.within(c.x, c.y, s), h = c.numPoints || 1, p = c.x * h, d = c.y * h, m = o && h > 1 ? this._map(c, !0) : null, g = (l << 5) + (e + 1) + this.points.length, v = 0, y = f; v < y.length; v += 1) {
                  var x = y[v],
                      b = u.points[x];

                  if (!(b.zoom <= e)) {
                    b.zoom = e;

                    var _ = b.numPoints || 1;

                    p += b.x * _, d += b.y * _, h += _, b.parentId = g, o && (m || (m = this._map(c, !0)), o(m, this._map(b)));
                  }
                }

                1 === h ? r.push(c) : (c.parentId = g, r.push(V(p / h, d / h, g, h, m)));
              }
            }

            return r;
          }, U.prototype._getOriginId = function (t) {
            return t - this.points.length >> 5;
          }, U.prototype._getOriginZoom = function (t) {
            return (t - this.points.length) % 32;
          }, U.prototype._map = function (t, e) {
            if (t.numPoints) return e ? X({}, t.properties) : t.properties;
            var r = this.points[t.index].properties,
                n = this.options.map(r);
            return e && n === r ? X({}, n) : n;
          }, _t.prototype.options = {
            maxZoom: 14,
            indexMaxZoom: 5,
            indexMaxPoints: 1e5,
            tolerance: 3,
            extent: 4096,
            buffer: 64,
            lineMetrics: !1,
            promoteId: null,
            generateId: !1,
            debug: 0
          }, _t.prototype.splitTile = function (t, e, r, n, i, a, o) {
            for (var s = [t, e, r, n], l = this.options, c = l.debug; s.length;) {
              n = s.pop(), r = s.pop(), e = s.pop(), t = s.pop();
              var u = 1 << e,
                  f = wt(e, r, n),
                  h = this.tiles[f];

              if (!h && (c > 1 && console.time("creation"), h = this.tiles[f] = yt(t, e, r, n, l), this.tileCoords.push({
                z: e,
                x: r,
                y: n
              }), c)) {
                c > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", e, r, n, h.numFeatures, h.numPoints, h.numSimplified), console.timeEnd("creation"));
                var p = "z" + e;
                this.stats[p] = (this.stats[p] || 0) + 1, this.total++;
              }

              if (h.source = t, i) {
                if (e === l.maxZoom || e === i) continue;
                var d = 1 << i - e;
                if (r !== Math.floor(a / d) || n !== Math.floor(o / d)) continue;
              } else if (e === l.indexMaxZoom || h.numPoints <= l.indexMaxPoints) continue;

              if (h.source = null, 0 !== t.length) {
                c > 1 && console.time("clipping");

                var m,
                    g,
                    v,
                    y,
                    x,
                    b,
                    _ = .5 * l.buffer / l.extent,
                    w = .5 - _,
                    T = .5 + _,
                    k = 1 + _;

                m = g = v = y = null, x = ot(t, u, r - _, r + T, 0, h.minX, h.maxX, l), b = ot(t, u, r + w, r + k, 0, h.minX, h.maxX, l), t = null, x && (m = ot(x, u, n - _, n + T, 1, h.minY, h.maxY, l), g = ot(x, u, n + w, n + k, 1, h.minY, h.maxY, l), x = null), b && (v = ot(b, u, n - _, n + T, 1, h.minY, h.maxY, l), y = ot(b, u, n + w, n + k, 1, h.minY, h.maxY, l), b = null), c > 1 && console.timeEnd("clipping"), s.push(m || [], e + 1, 2 * r, 2 * n), s.push(g || [], e + 1, 2 * r, 2 * n + 1), s.push(v || [], e + 1, 2 * r + 1, 2 * n), s.push(y || [], e + 1, 2 * r + 1, 2 * n + 1);
              }
            }
          }, _t.prototype.getTile = function (t, e, r) {
            var n = this.options,
                i = n.extent,
                a = n.debug;
            if (t < 0 || t > 24) return null;
            var o = 1 << t,
                s = wt(t, e = (e % o + o) % o, r);
            if (this.tiles[s]) return gt(this.tiles[s], i);
            a > 1 && console.log("drilling down to z%d-%d-%d", t, e, r);

            for (var l, c = t, u = e, f = r; !l && c > 0;) {
              c--, u = Math.floor(u / 2), f = Math.floor(f / 2), l = this.tiles[wt(c, u, f)];
            }

            return l && l.source ? (a > 1 && console.log("found parent tile z%d-%d-%d", c, u, f), a > 1 && console.time("drilling down"), this.splitTile(l.source, c, u, f, t, e, r), a > 1 && console.timeEnd("drilling down"), this.tiles[s] ? gt(this.tiles[s], i) : null) : null;
          };

          var kt = function (e) {
            function r(t, r, n, i) {
              e.call(this, t, r, n, Tt), i && (this.loadGeoJSON = i);
            }

            return e && (r.__proto__ = e), r.prototype = Object.create(e && e.prototype), r.prototype.constructor = r, r.prototype.loadData = function (t, e) {
              this._pendingCallback && this._pendingCallback(null, {
                abandoned: !0
              }), this._pendingCallback = e, this._pendingLoadDataParams = t, this._state && "Idle" !== this._state ? this._state = "NeedsLoadData" : (this._state = "Coalescing", this._loadData());
            }, r.prototype._loadData = function () {
              var e = this;

              if (this._pendingCallback && this._pendingLoadDataParams) {
                var r = this._pendingCallback,
                    n = this._pendingLoadDataParams;
                delete this._pendingCallback, delete this._pendingLoadDataParams;
                var i = !!(n && n.request && n.request.collectResourceTiming) && new t.RequestPerformance(n.request);
                this.loadGeoJSON(n, function (a, o) {
                  if (a || !o) return r(a);
                  if ("object" != _typeof(o)) return r(new Error("Input data given to '" + n.source + "' is not a valid GeoJSON object."));
                  f(o, !0);

                  try {
                    e._geoJSONIndex = n.cluster ? new U(function (e) {
                      var r = e.superclusterOptions,
                          n = e.clusterProperties;
                      if (!n || !r) return r;

                      for (var i = {}, a = {}, o = {
                        accumulated: null,
                        zoom: 0
                      }, s = {
                        properties: null
                      }, l = Object.keys(n), c = 0, u = l; c < u.length; c += 1) {
                        var f = u[c],
                            h = n[f],
                            p = h[0],
                            d = h[1],
                            m = t.createExpression(d),
                            g = t.createExpression("string" == typeof p ? [p, ["accumulated"], ["get", f]] : p);
                        i[f] = m.value, a[f] = g.value;
                      }

                      return r.map = function (t) {
                        s.properties = t;

                        for (var e = {}, r = 0, n = l; r < n.length; r += 1) {
                          var a = n[r];
                          e[a] = i[a].evaluate(o, s);
                        }

                        return e;
                      }, r.reduce = function (t, e) {
                        s.properties = e;

                        for (var r = 0, n = l; r < n.length; r += 1) {
                          var i = n[r];
                          o.accumulated = t[i], t[i] = a[i].evaluate(o, s);
                        }
                      }, r;
                    }(n)).load(o.features) : function (t, e) {
                      return new _t(t, e);
                    }(o, n.geojsonVtOptions);
                  } catch (a) {
                    return r(a);
                  }

                  e.loaded = {};
                  var s = {};

                  if (i) {
                    var l = i.finish();
                    l && (s.resourceTiming = {}, s.resourceTiming[n.source] = JSON.parse(JSON.stringify(l)));
                  }

                  r(null, s);
                });
              }
            }, r.prototype.coalesce = function () {
              "Coalescing" === this._state ? this._state = "Idle" : "NeedsLoadData" === this._state && (this._state = "Coalescing", this._loadData());
            }, r.prototype.reloadTile = function (t, r) {
              var n = this.loaded,
                  i = t.uid;
              return n && n[i] ? e.prototype.reloadTile.call(this, t, r) : this.loadTile(t, r);
            }, r.prototype.loadGeoJSON = function (e, r) {
              if (e.request) t.getJSON(e.request, r);else {
                if ("string" != typeof e.data) return r(new Error("Input data given to '" + e.source + "' is not a valid GeoJSON object."));

                try {
                  return r(null, JSON.parse(e.data));
                } catch (t) {
                  return r(new Error("Input data given to '" + e.source + "' is not a valid GeoJSON object."));
                }
              }
            }, r.prototype.removeSource = function (t, e) {
              this._pendingCallback && this._pendingCallback(null, {
                abandoned: !0
              }), e();
            }, r.prototype.getClusterExpansionZoom = function (t, e) {
              try {
                e(null, this._geoJSONIndex.getClusterExpansionZoom(t.clusterId));
              } catch (t) {
                e(t);
              }
            }, r.prototype.getClusterChildren = function (t, e) {
              try {
                e(null, this._geoJSONIndex.getChildren(t.clusterId));
              } catch (t) {
                e(t);
              }
            }, r.prototype.getClusterLeaves = function (t, e) {
              try {
                e(null, this._geoJSONIndex.getLeaves(t.clusterId, t.limit, t.offset));
              } catch (t) {
                e(t);
              }
            }, r;
          }(l);

          var Mt = function Mt(e) {
            var r = this;
            this.self = e, this.actor = new t.Actor(e, this), this.layerIndexes = {}, this.availableImages = {}, this.workerSourceTypes = {
              vector: l,
              geojson: kt
            }, this.workerSources = {}, this.demWorkerSources = {}, this.self.registerWorkerSource = function (t, e) {
              if (r.workerSourceTypes[t]) throw new Error('Worker source with name "' + t + '" already registered.');
              r.workerSourceTypes[t] = e;
            }, this.self.registerRTLTextPlugin = function (e) {
              if (t.plugin.isParsed()) throw new Error("RTL text plugin already registered.");
              t.plugin.applyArabicShaping = e.applyArabicShaping, t.plugin.processBidirectionalText = e.processBidirectionalText, t.plugin.processStyledBidirectionalText = e.processStyledBidirectionalText;
            };
          };

          return Mt.prototype.setReferrer = function (t, e) {
            this.referrer = e;
          }, Mt.prototype.setImages = function (t, e, r) {
            for (var n in this.availableImages[t] = e, this.workerSources[t]) {
              var i = this.workerSources[t][n];

              for (var a in i) {
                i[a].availableImages = e;
              }
            }

            r();
          }, Mt.prototype.setLayers = function (t, e, r) {
            this.getLayerIndex(t).replace(e), r();
          }, Mt.prototype.updateLayers = function (t, e, r) {
            this.getLayerIndex(t).update(e.layers, e.removedIds), r();
          }, Mt.prototype.loadTile = function (t, e, r) {
            this.getWorkerSource(t, e.type, e.source).loadTile(e, r);
          }, Mt.prototype.loadDEMTile = function (t, e, r) {
            this.getDEMWorkerSource(t, e.source).loadTile(e, r);
          }, Mt.prototype.reloadTile = function (t, e, r) {
            this.getWorkerSource(t, e.type, e.source).reloadTile(e, r);
          }, Mt.prototype.abortTile = function (t, e, r) {
            this.getWorkerSource(t, e.type, e.source).abortTile(e, r);
          }, Mt.prototype.removeTile = function (t, e, r) {
            this.getWorkerSource(t, e.type, e.source).removeTile(e, r);
          }, Mt.prototype.removeDEMTile = function (t, e) {
            this.getDEMWorkerSource(t, e.source).removeTile(e);
          }, Mt.prototype.removeSource = function (t, e, r) {
            if (this.workerSources[t] && this.workerSources[t][e.type] && this.workerSources[t][e.type][e.source]) {
              var n = this.workerSources[t][e.type][e.source];
              delete this.workerSources[t][e.type][e.source], void 0 !== n.removeSource ? n.removeSource(e, r) : r();
            }
          }, Mt.prototype.loadWorkerSource = function (t, e, r) {
            try {
              this.self.importScripts(e.url), r();
            } catch (t) {
              r(t.toString());
            }
          }, Mt.prototype.syncRTLPluginState = function (e, r, n) {
            try {
              t.plugin.setState(r);
              var i = t.plugin.getPluginURL();

              if (t.plugin.isLoaded() && !t.plugin.isParsed() && null != i) {
                this.self.importScripts(i);
                var a = t.plugin.isParsed();
                n(a ? void 0 : new Error("RTL Text Plugin failed to import scripts from " + i), a);
              }
            } catch (t) {
              n(t.toString());
            }
          }, Mt.prototype.getAvailableImages = function (t) {
            var e = this.availableImages[t];
            return e || (e = []), e;
          }, Mt.prototype.getLayerIndex = function (t) {
            var e = this.layerIndexes[t];
            return e || (e = this.layerIndexes[t] = new n()), e;
          }, Mt.prototype.getWorkerSource = function (t, e, r) {
            var n = this;

            if (this.workerSources[t] || (this.workerSources[t] = {}), this.workerSources[t][e] || (this.workerSources[t][e] = {}), !this.workerSources[t][e][r]) {
              var i = {
                send: function send(e, r, i) {
                  n.actor.send(e, r, i, t);
                }
              };
              this.workerSources[t][e][r] = new this.workerSourceTypes[e](i, this.getLayerIndex(t), this.getAvailableImages(t));
            }

            return this.workerSources[t][e][r];
          }, Mt.prototype.getDEMWorkerSource = function (t, e) {
            return this.demWorkerSources[t] || (this.demWorkerSources[t] = {}), this.demWorkerSources[t][e] || (this.demWorkerSources[t][e] = new u()), this.demWorkerSources[t][e];
          }, Mt.prototype.enforceCacheSizeLimit = function (e, r) {
            t.enforceCacheSizeLimit(r);
          }, "undefined" != typeof WorkerGlobalScope && void 0 !== t.window && t.window instanceof WorkerGlobalScope && (t.window.worker = new Mt(t.window)), Mt;
        }), n(0, function (t) {
          var e = t.createCommonjsModule(function (t) {
            function e(t) {
              return !r(t);
            }

            function r(t) {
              return "undefined" == typeof window || "undefined" == typeof document ? "not a browser" : Array.prototype && Array.prototype.every && Array.prototype.filter && Array.prototype.forEach && Array.prototype.indexOf && Array.prototype.lastIndexOf && Array.prototype.map && Array.prototype.some && Array.prototype.reduce && Array.prototype.reduceRight && Array.isArray ? Function.prototype && Function.prototype.bind ? Object.keys && Object.create && Object.getPrototypeOf && Object.getOwnPropertyNames && Object.isSealed && Object.isFrozen && Object.isExtensible && Object.getOwnPropertyDescriptor && Object.defineProperty && Object.defineProperties && Object.seal && Object.freeze && Object.preventExtensions ? "JSON" in window && "parse" in JSON && "stringify" in JSON ? function () {
                if (!("Worker" in window && "Blob" in window && "URL" in window)) return !1;
                var t,
                    e,
                    r = new Blob([""], {
                  type: "text/javascript"
                }),
                    n = URL.createObjectURL(r);

                try {
                  e = new Worker(n), t = !0;
                } catch (e) {
                  t = !1;
                }

                e && e.terminate();
                return URL.revokeObjectURL(n), t;
              }() ? "Uint8ClampedArray" in window ? ArrayBuffer.isView ? function () {
                var t = document.createElement("canvas");
                t.width = t.height = 1;
                var e = t.getContext("2d");
                if (!e) return !1;
                var r = e.getImageData(0, 0, 1, 1);
                return r && r.width === t.width;
              }() ? function (t) {
                void 0 === n[t] && (n[t] = function (t) {
                  var r = function (t) {
                    var r = document.createElement("canvas"),
                        n = Object.create(e.webGLContextAttributes);
                    return n.failIfMajorPerformanceCaveat = t, r.probablySupportsContext ? r.probablySupportsContext("webgl", n) || r.probablySupportsContext("experimental-webgl", n) : r.supportsContext ? r.supportsContext("webgl", n) || r.supportsContext("experimental-webgl", n) : r.getContext("webgl", n) || r.getContext("experimental-webgl", n);
                  }(t);

                  if (!r) return !1;
                  var n = r.createShader(r.VERTEX_SHADER);
                  if (!n || r.isContextLost()) return !1;
                  return r.shaderSource(n, "void main() {}"), r.compileShader(n), !0 === r.getShaderParameter(n, r.COMPILE_STATUS);
                }(t));
                return n[t];
              }(t && t.failIfMajorPerformanceCaveat) ? void 0 : "insufficient WebGL support" : "insufficient Canvas/getImageData support" : "insufficient ArrayBuffer support" : "insufficient Uint8ClampedArray support" : "insufficient worker support" : "insufficient JSON support" : "insufficient Object support" : "insufficient Function support" : "insufficent Array support";
            }

            t.exports ? t.exports = e : window && (window.mapboxgl = window.mapboxgl || {}, window.mapboxgl.supported = e, window.mapboxgl.notSupportedReason = r);
            var n = {};
            e.webGLContextAttributes = {
              antialias: !1,
              alpha: !0,
              stencil: !0,
              depth: !0
            };
          }),
              r = {
            create: function create(e, r, n) {
              var i = t.window.document.createElement(e);
              return void 0 !== r && (i.className = r), n && n.appendChild(i), i;
            },
            createNS: function createNS(e, r) {
              return t.window.document.createElementNS(e, r);
            }
          },
              n = t.window.document.documentElement.style;

          function i(t) {
            if (!n) return t[0];

            for (var e = 0; e < t.length; e++) {
              if (t[e] in n) return t[e];
            }

            return t[0];
          }

          var a,
              o = i(["userSelect", "MozUserSelect", "WebkitUserSelect", "msUserSelect"]);
          r.disableDrag = function () {
            n && o && (a = n[o], n[o] = "none");
          }, r.enableDrag = function () {
            n && o && (n[o] = a);
          };
          var s = i(["transform", "WebkitTransform"]);

          r.setTransform = function (t, e) {
            t.style[s] = e;
          };

          var l = !1;

          try {
            var c = Object.defineProperty({}, "passive", {
              get: function get() {
                l = !0;
              }
            });
            t.window.addEventListener("test", c, c), t.window.removeEventListener("test", c, c);
          } catch (t) {
            l = !1;
          }

          r.addEventListener = function (t, e, r, n) {
            void 0 === n && (n = {}), "passive" in n && l ? t.addEventListener(e, r, n) : t.addEventListener(e, r, n.capture);
          }, r.removeEventListener = function (t, e, r, n) {
            void 0 === n && (n = {}), "passive" in n && l ? t.removeEventListener(e, r, n) : t.removeEventListener(e, r, n.capture);
          };

          var u = function u(e) {
            e.preventDefault(), e.stopPropagation(), t.window.removeEventListener("click", u, !0);
          };

          function f(t) {
            var e = t.userImage;
            if (e && e.render && e.render()) return t.data.replace(new Uint8Array(e.data.buffer)), !0;
            return !1;
          }

          r.suppressClick = function () {
            t.window.addEventListener("click", u, !0), t.window.setTimeout(function () {
              t.window.removeEventListener("click", u, !0);
            }, 0);
          }, r.mousePos = function (e, r) {
            var n = e.getBoundingClientRect();
            return new t.Point(r.clientX - n.left - e.clientLeft, r.clientY - n.top - e.clientTop);
          }, r.touchPos = function (e, r) {
            for (var n = e.getBoundingClientRect(), i = [], a = 0; a < r.length; a++) {
              i.push(new t.Point(r[a].clientX - n.left - e.clientLeft, r[a].clientY - n.top - e.clientTop));
            }

            return i;
          }, r.mouseButton = function (e) {
            return void 0 !== t.window.InstallTrigger && 2 === e.button && e.ctrlKey && t.window.navigator.platform.toUpperCase().indexOf("MAC") >= 0 ? 0 : e.button;
          }, r.remove = function (t) {
            t.parentNode && t.parentNode.removeChild(t);
          };

          var h = function (e) {
            function r() {
              e.call(this), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = !1, this.requestors = [], this.patterns = {}, this.atlasImage = new t.RGBAImage({
                width: 1,
                height: 1
              }), this.dirty = !0;
            }

            return e && (r.__proto__ = e), r.prototype = Object.create(e && e.prototype), r.prototype.constructor = r, r.prototype.isLoaded = function () {
              return this.loaded;
            }, r.prototype.setLoaded = function (t) {
              if (this.loaded !== t && (this.loaded = t, t)) {
                for (var e = 0, r = this.requestors; e < r.length; e += 1) {
                  var n = r[e],
                      i = n.ids,
                      a = n.callback;

                  this._notify(i, a);
                }

                this.requestors = [];
              }
            }, r.prototype.getImage = function (t) {
              return this.images[t];
            }, r.prototype.addImage = function (t, e) {
              this._validate(t, e) && (this.images[t] = e);
            }, r.prototype._validate = function (e, r) {
              var n = !0;
              return this._validateStretch(r.stretchX, r.data && r.data.width) || (this.fire(new t.ErrorEvent(new Error('Image "' + e + '" has invalid "stretchX" value'))), n = !1), this._validateStretch(r.stretchY, r.data && r.data.height) || (this.fire(new t.ErrorEvent(new Error('Image "' + e + '" has invalid "stretchY" value'))), n = !1), this._validateContent(r.content, r) || (this.fire(new t.ErrorEvent(new Error('Image "' + e + '" has invalid "content" value'))), n = !1), n;
            }, r.prototype._validateStretch = function (t, e) {
              if (!t) return !0;

              for (var r = 0, n = 0, i = t; n < i.length; n += 1) {
                var a = i[n];
                if (a[0] < r || a[1] < a[0] || e < a[1]) return !1;
                r = a[1];
              }

              return !0;
            }, r.prototype._validateContent = function (t, e) {
              return !t || 4 === t.length && !(t[0] < 0 || e.data.width < t[0]) && !(t[1] < 0 || e.data.height < t[1]) && !(t[2] < 0 || e.data.width < t[2]) && !(t[3] < 0 || e.data.height < t[3]) && !(t[2] < t[0]) && !(t[3] < t[1]);
            }, r.prototype.updateImage = function (t, e) {
              var r = this.images[t];
              e.version = r.version + 1, this.images[t] = e, this.updatedImages[t] = !0;
            }, r.prototype.removeImage = function (t) {
              var e = this.images[t];
              delete this.images[t], delete this.patterns[t], e.userImage && e.userImage.onRemove && e.userImage.onRemove();
            }, r.prototype.listImages = function () {
              return Object.keys(this.images);
            }, r.prototype.getImages = function (t, e) {
              var r = !0;
              if (!this.isLoaded()) for (var n = 0, i = t; n < i.length; n += 1) {
                var a = i[n];
                this.images[a] || (r = !1);
              }
              this.isLoaded() || r ? this._notify(t, e) : this.requestors.push({
                ids: t,
                callback: e
              });
            }, r.prototype._notify = function (e, r) {
              for (var n = {}, i = 0, a = e; i < a.length; i += 1) {
                var o = a[i];
                this.images[o] || this.fire(new t.Event("styleimagemissing", {
                  id: o
                }));
                var s = this.images[o];
                s ? n[o] = {
                  data: s.data.clone(),
                  pixelRatio: s.pixelRatio,
                  sdf: s.sdf,
                  version: s.version,
                  stretchX: s.stretchX,
                  stretchY: s.stretchY,
                  content: s.content,
                  hasRenderCallback: Boolean(s.userImage && s.userImage.render)
                } : t.warnOnce('Image "' + o + '" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.');
              }

              r(null, n);
            }, r.prototype.getPixelSize = function () {
              var t = this.atlasImage;
              return {
                width: t.width,
                height: t.height
              };
            }, r.prototype.getPattern = function (e) {
              var r = this.patterns[e],
                  n = this.getImage(e);
              if (!n) return null;
              if (r && r.position.version === n.version) return r.position;
              if (r) r.position.version = n.version;else {
                var i = {
                  w: n.data.width + 2,
                  h: n.data.height + 2,
                  x: 0,
                  y: 0
                },
                    a = new t.ImagePosition(i, n);
                this.patterns[e] = {
                  bin: i,
                  position: a
                };
              }
              return this._updatePatternAtlas(), this.patterns[e].position;
            }, r.prototype.bind = function (e) {
              var r = e.gl;
              this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = !1) : this.atlasTexture = new t.Texture(e, this.atlasImage, r.RGBA), this.atlasTexture.bind(r.LINEAR, r.CLAMP_TO_EDGE);
            }, r.prototype._updatePatternAtlas = function () {
              var e = [];

              for (var r in this.patterns) {
                e.push(this.patterns[r].bin);
              }

              var n = t.potpack(e),
                  i = n.w,
                  a = n.h,
                  o = this.atlasImage;

              for (var s in o.resize({
                width: i || 1,
                height: a || 1
              }), this.patterns) {
                var l = this.patterns[s].bin,
                    c = l.x + 1,
                    u = l.y + 1,
                    f = this.images[s].data,
                    h = f.width,
                    p = f.height;
                t.RGBAImage.copy(f, o, {
                  x: 0,
                  y: 0
                }, {
                  x: c,
                  y: u
                }, {
                  width: h,
                  height: p
                }), t.RGBAImage.copy(f, o, {
                  x: 0,
                  y: p - 1
                }, {
                  x: c,
                  y: u - 1
                }, {
                  width: h,
                  height: 1
                }), t.RGBAImage.copy(f, o, {
                  x: 0,
                  y: 0
                }, {
                  x: c,
                  y: u + p
                }, {
                  width: h,
                  height: 1
                }), t.RGBAImage.copy(f, o, {
                  x: h - 1,
                  y: 0
                }, {
                  x: c - 1,
                  y: u
                }, {
                  width: 1,
                  height: p
                }), t.RGBAImage.copy(f, o, {
                  x: 0,
                  y: 0
                }, {
                  x: c + h,
                  y: u
                }, {
                  width: 1,
                  height: p
                });
              }

              this.dirty = !0;
            }, r.prototype.beginFrame = function () {
              this.callbackDispatchedThisFrame = {};
            }, r.prototype.dispatchRenderCallbacks = function (t) {
              for (var e = 0, r = t; e < r.length; e += 1) {
                var n = r[e];

                if (!this.callbackDispatchedThisFrame[n]) {
                  this.callbackDispatchedThisFrame[n] = !0;
                  var i = this.images[n];
                  f(i) && this.updateImage(n, i);
                }
              }
            }, r;
          }(t.Evented);

          var p = g,
              d = g,
              m = 1e20;

          function g(t, e, r, n, i, a) {
            this.fontSize = t || 24, this.buffer = void 0 === e ? 3 : e, this.cutoff = n || .25, this.fontFamily = i || "sans-serif", this.fontWeight = a || "normal", this.radius = r || 8;
            var o = this.size = this.fontSize + 2 * this.buffer;
            this.canvas = document.createElement("canvas"), this.canvas.width = this.canvas.height = o, this.ctx = this.canvas.getContext("2d"), this.ctx.font = this.fontWeight + " " + this.fontSize + "px " + this.fontFamily, this.ctx.textBaseline = "middle", this.ctx.fillStyle = "black", this.gridOuter = new Float64Array(o * o), this.gridInner = new Float64Array(o * o), this.f = new Float64Array(o), this.d = new Float64Array(o), this.z = new Float64Array(o + 1), this.v = new Int16Array(o), this.middle = Math.round(o / 2 * (navigator.userAgent.indexOf("Gecko/") >= 0 ? 1.2 : 1));
          }

          function v(t, e, r, n, i, a, o) {
            for (var s = 0; s < e; s++) {
              for (var l = 0; l < r; l++) {
                n[l] = t[l * e + s];
              }

              for (y(n, i, a, o, r), l = 0; l < r; l++) {
                t[l * e + s] = i[l];
              }
            }

            for (l = 0; l < r; l++) {
              for (s = 0; s < e; s++) {
                n[s] = t[l * e + s];
              }

              for (y(n, i, a, o, e), s = 0; s < e; s++) {
                t[l * e + s] = Math.sqrt(i[s]);
              }
            }
          }

          function y(t, e, r, n, i) {
            r[0] = 0, n[0] = -m, n[1] = +m;

            for (var a = 1, o = 0; a < i; a++) {
              for (var s = (t[a] + a * a - (t[r[o]] + r[o] * r[o])) / (2 * a - 2 * r[o]); s <= n[o];) {
                o--, s = (t[a] + a * a - (t[r[o]] + r[o] * r[o])) / (2 * a - 2 * r[o]);
              }

              r[++o] = a, n[o] = s, n[o + 1] = +m;
            }

            for (a = 0, o = 0; a < i; a++) {
              for (; n[o + 1] < a;) {
                o++;
              }

              e[a] = (a - r[o]) * (a - r[o]) + t[r[o]];
            }
          }

          g.prototype.draw = function (t) {
            this.ctx.clearRect(0, 0, this.size, this.size), this.ctx.fillText(t, this.buffer, this.middle);

            for (var e = this.ctx.getImageData(0, 0, this.size, this.size), r = new Uint8ClampedArray(this.size * this.size), n = 0; n < this.size * this.size; n++) {
              var i = e.data[4 * n + 3] / 255;
              this.gridOuter[n] = 1 === i ? 0 : 0 === i ? m : Math.pow(Math.max(0, .5 - i), 2), this.gridInner[n] = 1 === i ? m : 0 === i ? 0 : Math.pow(Math.max(0, i - .5), 2);
            }

            for (v(this.gridOuter, this.size, this.size, this.f, this.d, this.v, this.z), v(this.gridInner, this.size, this.size, this.f, this.d, this.v, this.z), n = 0; n < this.size * this.size; n++) {
              var a = this.gridOuter[n] - this.gridInner[n];
              r[n] = Math.max(0, Math.min(255, Math.round(255 - 255 * (a / this.radius + this.cutoff))));
            }

            return r;
          }, p.default = d;

          var x = function x(t, e) {
            this.requestManager = t, this.localIdeographFontFamily = e, this.entries = {};
          };

          x.prototype.setURL = function (t) {
            this.url = t;
          }, x.prototype.getGlyphs = function (e, r) {
            var n = this,
                i = [];

            for (var a in e) {
              for (var o = 0, s = e[a]; o < s.length; o += 1) {
                var l = s[o];
                i.push({
                  stack: a,
                  id: l
                });
              }
            }

            t.asyncAll(i, function (t, e) {
              var r = t.stack,
                  i = t.id,
                  a = n.entries[r];
              a || (a = n.entries[r] = {
                glyphs: {},
                requests: {},
                ranges: {}
              });
              var o = a.glyphs[i];

              if (void 0 === o) {
                if (o = n._tinySDF(a, r, i)) return a.glyphs[i] = o, void e(null, {
                  stack: r,
                  id: i,
                  glyph: o
                });
                var s = Math.floor(i / 256);
                if (256 * s > 65535) e(new Error("glyphs > 65535 not supported"));else if (a.ranges[s]) e(null, {
                  stack: r,
                  id: i,
                  glyph: o
                });else {
                  var l = a.requests[s];
                  l || (l = a.requests[s] = [], x.loadGlyphRange(r, s, n.url, n.requestManager, function (t, e) {
                    if (e) {
                      for (var r in e) {
                        n._doesCharSupportLocalGlyph(+r) || (a.glyphs[+r] = e[+r]);
                      }

                      a.ranges[s] = !0;
                    }

                    for (var i = 0, o = l; i < o.length; i += 1) {
                      (0, o[i])(t, e);
                    }

                    delete a.requests[s];
                  })), l.push(function (t, n) {
                    t ? e(t) : n && e(null, {
                      stack: r,
                      id: i,
                      glyph: n[i] || null
                    });
                  });
                }
              } else e(null, {
                stack: r,
                id: i,
                glyph: o
              });
            }, function (t, e) {
              if (t) r(t);else if (e) {
                for (var n = {}, i = 0, a = e; i < a.length; i += 1) {
                  var o = a[i],
                      s = o.stack,
                      l = o.id,
                      c = o.glyph;
                  (n[s] || (n[s] = {}))[l] = c && {
                    id: c.id,
                    bitmap: c.bitmap.clone(),
                    metrics: c.metrics
                  };
                }

                r(null, n);
              }
            });
          }, x.prototype._doesCharSupportLocalGlyph = function (e) {
            return !!this.localIdeographFontFamily && (t.isChar["CJK Unified Ideographs"](e) || t.isChar["Hangul Syllables"](e) || t.isChar.Hiragana(e) || t.isChar.Katakana(e));
          }, x.prototype._tinySDF = function (e, r, n) {
            var i = this.localIdeographFontFamily;

            if (i && this._doesCharSupportLocalGlyph(n)) {
              var a = e.tinySDF;

              if (!a) {
                var o = "400";
                /bold/i.test(r) ? o = "900" : /medium/i.test(r) ? o = "500" : /light/i.test(r) && (o = "200"), a = e.tinySDF = new x.TinySDF(24, 3, 8, .25, i, o);
              }

              return {
                id: n,
                bitmap: new t.AlphaImage({
                  width: 30,
                  height: 30
                }, a.draw(String.fromCharCode(n))),
                metrics: {
                  width: 24,
                  height: 24,
                  left: 0,
                  top: -8,
                  advance: 24
                }
              };
            }
          }, x.loadGlyphRange = function (e, r, n, i, a) {
            var o = 256 * r,
                s = o + 255,
                l = i.transformRequest(i.normalizeGlyphsURL(n).replace("{fontstack}", e).replace("{range}", o + "-" + s), t.ResourceType.Glyphs);
            t.getArrayBuffer(l, function (e, r) {
              if (e) a(e);else if (r) {
                for (var n = {}, i = 0, o = t.parseGlyphPBF(r); i < o.length; i += 1) {
                  var s = o[i];
                  n[s.id] = s;
                }

                a(null, n);
              }
            });
          }, x.TinySDF = p;

          var b = function b() {
            this.specification = t.styleSpec.light.position;
          };

          b.prototype.possiblyEvaluate = function (e, r) {
            return t.sphericalToCartesian(e.expression.evaluate(r));
          }, b.prototype.interpolate = function (e, r, n) {
            return {
              x: t.number(e.x, r.x, n),
              y: t.number(e.y, r.y, n),
              z: t.number(e.z, r.z, n)
            };
          };

          var _ = new t.Properties({
            anchor: new t.DataConstantProperty(t.styleSpec.light.anchor),
            position: new b(),
            color: new t.DataConstantProperty(t.styleSpec.light.color),
            intensity: new t.DataConstantProperty(t.styleSpec.light.intensity)
          }),
              w = function (e) {
            function r(r) {
              e.call(this), this._transitionable = new t.Transitionable(_), this.setLight(r), this._transitioning = this._transitionable.untransitioned();
            }

            return e && (r.__proto__ = e), r.prototype = Object.create(e && e.prototype), r.prototype.constructor = r, r.prototype.getLight = function () {
              return this._transitionable.serialize();
            }, r.prototype.setLight = function (e, r) {
              if (void 0 === r && (r = {}), !this._validate(t.validateLight, e, r)) for (var n in e) {
                var i = e[n];
                t.endsWith(n, "-transition") ? this._transitionable.setTransition(n.slice(0, -"-transition".length), i) : this._transitionable.setValue(n, i);
              }
            }, r.prototype.updateTransitions = function (t) {
              this._transitioning = this._transitionable.transitioned(t, this._transitioning);
            }, r.prototype.hasTransition = function () {
              return this._transitioning.hasTransition();
            }, r.prototype.recalculate = function (t) {
              this.properties = this._transitioning.possiblyEvaluate(t);
            }, r.prototype._validate = function (e, r, n) {
              return (!n || !1 !== n.validate) && t.emitValidationErrors(this, e.call(t.validateStyle, t.extend({
                value: r,
                style: {
                  glyphs: !0,
                  sprite: !0
                },
                styleSpec: t.styleSpec
              })));
            }, r;
          }(t.Evented),
              T = function T(t, e) {
            this.width = t, this.height = e, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
          };

          T.prototype.getDash = function (t, e) {
            var r = t.join(",") + String(e);
            return this.dashEntry[r] || (this.dashEntry[r] = this.addDash(t, e)), this.dashEntry[r];
          }, T.prototype.getDashRanges = function (t, e, r) {
            var n = [],
                i = t.length % 2 == 1 ? -t[t.length - 1] * r : 0,
                a = t[0] * r,
                o = !0;
            n.push({
              left: i,
              right: a,
              isDash: o,
              zeroLength: 0 === t[0]
            });

            for (var s = t[0], l = 1; l < t.length; l++) {
              o = !o;
              var c = t[l];
              i = s * r, a = (s += c) * r, n.push({
                left: i,
                right: a,
                isDash: o,
                zeroLength: 0 === c
              });
            }

            return n;
          }, T.prototype.addRoundDash = function (t, e, r) {
            for (var n = e / 2, i = -r; i <= r; i++) {
              for (var a = this.nextRow + r + i, o = this.width * a, s = 0, l = t[s], c = 0; c < this.width; c++) {
                c / l.right > 1 && (l = t[++s]);
                var u = Math.abs(c - l.left),
                    f = Math.abs(c - l.right),
                    h = Math.min(u, f),
                    p = void 0,
                    d = i / r * (n + 1);

                if (l.isDash) {
                  var m = n - Math.abs(d);
                  p = Math.sqrt(h * h + m * m);
                } else p = n - Math.sqrt(h * h + d * d);

                this.data[o + c] = Math.max(0, Math.min(255, p + 128));
              }
            }
          }, T.prototype.addRegularDash = function (t) {
            for (var e = t.length - 1; e >= 0; --e) {
              var r = t[e],
                  n = t[e + 1];
              r.zeroLength ? t.splice(e, 1) : n && n.isDash === r.isDash && (n.left = r.left, t.splice(e, 1));
            }

            var i = t[0],
                a = t[t.length - 1];
            i.isDash === a.isDash && (i.left = a.left - this.width, a.right = i.right + this.width);

            for (var o = this.width * this.nextRow, s = 0, l = t[s], c = 0; c < this.width; c++) {
              c / l.right > 1 && (l = t[++s]);
              var u = Math.abs(c - l.left),
                  f = Math.abs(c - l.right),
                  h = Math.min(u, f),
                  p = l.isDash ? h : -h;
              this.data[o + c] = Math.max(0, Math.min(255, p + 128));
            }
          }, T.prototype.addDash = function (e, r) {
            var n = r ? 7 : 0,
                i = 2 * n + 1;
            if (this.nextRow + i > this.height) return t.warnOnce("LineAtlas out of space"), null;

            for (var a = 0, o = 0; o < e.length; o++) {
              a += e[o];
            }

            if (0 !== a) {
              var s = this.width / a,
                  l = this.getDashRanges(e, this.width, s);
              r ? this.addRoundDash(l, s, n) : this.addRegularDash(l);
            }

            var c = {
              y: (this.nextRow + n + .5) / this.height,
              height: 2 * n / this.height,
              width: a
            };
            return this.nextRow += i, this.dirty = !0, c;
          }, T.prototype.bind = function (t) {
            var e = t.gl;
            this.texture ? (e.bindTexture(e.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, e.texSubImage2D(e.TEXTURE_2D, 0, 0, 0, this.width, this.height, e.ALPHA, e.UNSIGNED_BYTE, this.data))) : (this.texture = e.createTexture(), e.bindTexture(e.TEXTURE_2D, this.texture), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.REPEAT), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.REPEAT), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.LINEAR), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.LINEAR), e.texImage2D(e.TEXTURE_2D, 0, e.ALPHA, this.width, this.height, 0, e.ALPHA, e.UNSIGNED_BYTE, this.data));
          };

          var k = function e(r, n) {
            this.workerPool = r, this.actors = [], this.currentActor = 0, this.id = t.uniqueId();

            for (var i = this.workerPool.acquire(this.id), a = 0; a < i.length; a++) {
              var o = i[a],
                  s = new e.Actor(o, n, this.id);
              s.name = "Worker " + a, this.actors.push(s);
            }
          };

          function M(e, r, n) {
            var i = function i(_i3, a) {
              if (_i3) return n(_i3);

              if (a) {
                var o = t.pick(t.extend(a, e), ["tiles", "minzoom", "maxzoom", "attribution", "mapbox_logo", "bounds", "scheme", "tileSize", "encoding"]);
                a.vector_layers && (o.vectorLayers = a.vector_layers, o.vectorLayerIds = o.vectorLayers.map(function (t) {
                  return t.id;
                })), o.tiles = r.canonicalizeTileset(o, e.url), n(null, o);
              }
            };

            return e.url ? t.getJSON(r.transformRequest(r.normalizeSourceURL(e.url), t.ResourceType.Source), i) : t.browser.frame(function () {
              return i(null, e);
            });
          }

          k.prototype.broadcast = function (e, r, n) {
            n = n || function () {}, t.asyncAll(this.actors, function (t, n) {
              t.send(e, r, n);
            }, n);
          }, k.prototype.getActor = function () {
            return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
          }, k.prototype.remove = function () {
            this.actors.forEach(function (t) {
              t.remove();
            }), this.actors = [], this.workerPool.release(this.id);
          }, k.Actor = t.Actor;

          var A = function A(e, r, n) {
            this.bounds = t.LngLatBounds.convert(this.validateBounds(e)), this.minzoom = r || 0, this.maxzoom = n || 24;
          };

          A.prototype.validateBounds = function (t) {
            return Array.isArray(t) && 4 === t.length ? [Math.max(-180, t[0]), Math.max(-90, t[1]), Math.min(180, t[2]), Math.min(90, t[3])] : [-180, -90, 180, 90];
          }, A.prototype.contains = function (e) {
            var r = Math.pow(2, e.z),
                n = Math.floor(t.mercatorXfromLng(this.bounds.getWest()) * r),
                i = Math.floor(t.mercatorYfromLat(this.bounds.getNorth()) * r),
                a = Math.ceil(t.mercatorXfromLng(this.bounds.getEast()) * r),
                o = Math.ceil(t.mercatorYfromLat(this.bounds.getSouth()) * r);
            return e.x >= n && e.x < a && e.y >= i && e.y < o;
          };

          var S = function (e) {
            function r(r, n, i, a) {
              if (e.call(this), this.id = r, this.dispatcher = i, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, t.extend(this, t.pick(n, ["url", "scheme", "tileSize", "promoteId"])), this._options = t.extend({
                type: "vector"
              }, n), this._collectResourceTiming = n.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
              this.setEventedParent(a);
            }

            return e && (r.__proto__ = e), r.prototype = Object.create(e && e.prototype), r.prototype.constructor = r, r.prototype.load = function () {
              var e = this;
              this._loaded = !1, this.fire(new t.Event("dataloading", {
                dataType: "source"
              })), this._tileJSONRequest = M(this._options, this.map._requestManager, function (r, n) {
                e._tileJSONRequest = null, e._loaded = !0, r ? e.fire(new t.ErrorEvent(r)) : n && (t.extend(e, n), n.bounds && (e.tileBounds = new A(n.bounds, e.minzoom, e.maxzoom)), t.postTurnstileEvent(n.tiles, e.map._requestManager._customAccessToken), t.postMapLoadEvent(n.tiles, e.map._getMapId(), e.map._requestManager._skuToken, e.map._requestManager._customAccessToken), e.fire(new t.Event("data", {
                  dataType: "source",
                  sourceDataType: "metadata"
                })), e.fire(new t.Event("data", {
                  dataType: "source",
                  sourceDataType: "content"
                })));
              });
            }, r.prototype.loaded = function () {
              return this._loaded;
            }, r.prototype.hasTile = function (t) {
              return !this.tileBounds || this.tileBounds.contains(t.canonical);
            }, r.prototype.onAdd = function (t) {
              this.map = t, this.load();
            }, r.prototype.onRemove = function () {
              this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }, r.prototype.serialize = function () {
              return t.extend({}, this._options);
            }, r.prototype.loadTile = function (e, r) {
              var n = this.map._requestManager.normalizeTileURL(e.tileID.canonical.url(this.tiles, this.scheme)),
                  i = {
                request: this.map._requestManager.transformRequest(n, t.ResourceType.Tile),
                uid: e.uid,
                tileID: e.tileID,
                zoom: e.tileID.overscaledZ,
                tileSize: this.tileSize * e.tileID.overscaleFactor(),
                type: this.type,
                source: this.id,
                pixelRatio: t.browser.devicePixelRatio,
                showCollisionBoxes: this.map.showCollisionBoxes,
                promoteId: this.promoteId
              };

              function a(n, i) {
                return delete e.request, e.aborted ? r(null) : n && 404 !== n.status ? r(n) : (i && i.resourceTiming && (e.resourceTiming = i.resourceTiming), this.map._refreshExpiredTiles && i && e.setExpiryData(i), e.loadVectorData(i, this.map.painter), t.cacheEntryPossiblyAdded(this.dispatcher), r(null), void (e.reloadCallback && (this.loadTile(e, e.reloadCallback), e.reloadCallback = null)));
              }

              i.request.collectResourceTiming = this._collectResourceTiming, e.actor && "expired" !== e.state ? "loading" === e.state ? e.reloadCallback = r : e.request = e.actor.send("reloadTile", i, a.bind(this)) : (e.actor = this.dispatcher.getActor(), e.request = e.actor.send("loadTile", i, a.bind(this)));
            }, r.prototype.abortTile = function (t) {
              t.request && (t.request.cancel(), delete t.request), t.actor && t.actor.send("abortTile", {
                uid: t.uid,
                type: this.type,
                source: this.id
              }, void 0);
            }, r.prototype.unloadTile = function (t) {
              t.unloadVectorData(), t.actor && t.actor.send("removeTile", {
                uid: t.uid,
                type: this.type,
                source: this.id
              }, void 0);
            }, r.prototype.hasTransition = function () {
              return !1;
            }, r;
          }(t.Evented),
              E = function (e) {
            function r(r, n, i, a) {
              e.call(this), this.id = r, this.dispatcher = i, this.setEventedParent(a), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = t.extend({
                type: "raster"
              }, n), t.extend(this, t.pick(n, ["url", "scheme", "tileSize"]));
            }

            return e && (r.__proto__ = e), r.prototype = Object.create(e && e.prototype), r.prototype.constructor = r, r.prototype.load = function () {
              var e = this;
              this._loaded = !1, this.fire(new t.Event("dataloading", {
                dataType: "source"
              })), this._tileJSONRequest = M(this._options, this.map._requestManager, function (r, n) {
                e._tileJSONRequest = null, e._loaded = !0, r ? e.fire(new t.ErrorEvent(r)) : n && (t.extend(e, n), n.bounds && (e.tileBounds = new A(n.bounds, e.minzoom, e.maxzoom)), t.postTurnstileEvent(n.tiles), t.postMapLoadEvent(n.tiles, e.map._getMapId(), e.map._requestManager._skuToken), e.fire(new t.Event("data", {
                  dataType: "source",
                  sourceDataType: "metadata"
                })), e.fire(new t.Event("data", {
                  dataType: "source",
                  sourceDataType: "content"
                })));
              });
            }, r.prototype.loaded = function () {
              return this._loaded;
            }, r.prototype.onAdd = function (t) {
              this.map = t, this.load();
            }, r.prototype.onRemove = function () {
              this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }, r.prototype.serialize = function () {
              return t.extend({}, this._options);
            }, r.prototype.hasTile = function (t) {
              return !this.tileBounds || this.tileBounds.contains(t.canonical);
            }, r.prototype.loadTile = function (e, r) {
              var n = this,
                  i = this.map._requestManager.normalizeTileURL(e.tileID.canonical.url(this.tiles, this.scheme), this.tileSize);

              e.request = t.getImage(this.map._requestManager.transformRequest(i, t.ResourceType.Tile), function (i, a) {
                if (delete e.request, e.aborted) e.state = "unloaded", r(null);else if (i) e.state = "errored", r(i);else if (a) {
                  n.map._refreshExpiredTiles && e.setExpiryData(a), delete a.cacheControl, delete a.expires;
                  var o = n.map.painter.context,
                      s = o.gl;
                  e.texture = n.map.painter.getTileTexture(a.width), e.texture ? e.texture.update(a, {
                    useMipmap: !0
                  }) : (e.texture = new t.Texture(o, a, s.RGBA, {
                    useMipmap: !0
                  }), e.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE, s.LINEAR_MIPMAP_NEAREST), o.extTextureFilterAnisotropic && s.texParameterf(s.TEXTURE_2D, o.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, o.extTextureFilterAnisotropicMax)), e.state = "loaded", t.cacheEntryPossiblyAdded(n.dispatcher), r(null);
                }
              });
            }, r.prototype.abortTile = function (t, e) {
              t.request && (t.request.cancel(), delete t.request), e();
            }, r.prototype.unloadTile = function (t, e) {
              t.texture && this.map.painter.saveTileTexture(t.texture), e();
            }, r.prototype.hasTransition = function () {
              return !1;
            }, r;
          }(t.Evented),
              L = function (e) {
            function r(r, n, i, a) {
              e.call(this, r, n, i, a), this.type = "raster-dem", this.maxzoom = 22, this._options = t.extend({
                type: "raster-dem"
              }, n), this.encoding = n.encoding || "mapbox";
            }

            return e && (r.__proto__ = e), r.prototype = Object.create(e && e.prototype), r.prototype.constructor = r, r.prototype.serialize = function () {
              return {
                type: "raster-dem",
                url: this.url,
                tileSize: this.tileSize,
                tiles: this.tiles,
                bounds: this.bounds,
                encoding: this.encoding
              };
            }, r.prototype.loadTile = function (e, r) {
              var n = this.map._requestManager.normalizeTileURL(e.tileID.canonical.url(this.tiles, this.scheme), this.tileSize);

              function i(t, n) {
                t && (e.state = "errored", r(t)), n && (e.dem = n, e.needsHillshadePrepare = !0, e.state = "loaded", r(null));
              }

              e.request = t.getImage(this.map._requestManager.transformRequest(n, t.ResourceType.Tile), function (n, a) {
                if (delete e.request, e.aborted) e.state = "unloaded", r(null);else if (n) e.state = "errored", r(n);else if (a) {
                  this.map._refreshExpiredTiles && e.setExpiryData(a), delete a.cacheControl, delete a.expires;
                  var o = t.window.ImageBitmap && a instanceof t.window.ImageBitmap && t.offscreenCanvasSupported() ? a : t.browser.getImageData(a, 1),
                      s = {
                    uid: e.uid,
                    coord: e.tileID,
                    source: this.id,
                    rawImageData: o,
                    encoding: this.encoding
                  };
                  e.actor && "expired" !== e.state || (e.actor = this.dispatcher.getActor(), e.actor.send("loadDEMTile", s, i.bind(this)));
                }
              }.bind(this)), e.neighboringTiles = this._getNeighboringTiles(e.tileID);
            }, r.prototype._getNeighboringTiles = function (e) {
              var r = e.canonical,
                  n = Math.pow(2, r.z),
                  i = (r.x - 1 + n) % n,
                  a = 0 === r.x ? e.wrap - 1 : e.wrap,
                  o = (r.x + 1 + n) % n,
                  s = r.x + 1 === n ? e.wrap + 1 : e.wrap,
                  l = {};
              return l[new t.OverscaledTileID(e.overscaledZ, a, r.z, i, r.y).key] = {
                backfilled: !1
              }, l[new t.OverscaledTileID(e.overscaledZ, s, r.z, o, r.y).key] = {
                backfilled: !1
              }, r.y > 0 && (l[new t.OverscaledTileID(e.overscaledZ, a, r.z, i, r.y - 1).key] = {
                backfilled: !1
              }, l[new t.OverscaledTileID(e.overscaledZ, e.wrap, r.z, r.x, r.y - 1).key] = {
                backfilled: !1
              }, l[new t.OverscaledTileID(e.overscaledZ, s, r.z, o, r.y - 1).key] = {
                backfilled: !1
              }), r.y + 1 < n && (l[new t.OverscaledTileID(e.overscaledZ, a, r.z, i, r.y + 1).key] = {
                backfilled: !1
              }, l[new t.OverscaledTileID(e.overscaledZ, e.wrap, r.z, r.x, r.y + 1).key] = {
                backfilled: !1
              }, l[new t.OverscaledTileID(e.overscaledZ, s, r.z, o, r.y + 1).key] = {
                backfilled: !1
              }), l;
            }, r.prototype.unloadTile = function (t) {
              t.demTexture && this.map.painter.saveTileTexture(t.demTexture), t.fbo && (t.fbo.destroy(), delete t.fbo), t.dem && delete t.dem, delete t.neighboringTiles, t.state = "unloaded", t.actor && t.actor.send("removeDEMTile", {
                uid: t.uid,
                source: this.id
              });
            }, r;
          }(E),
              C = function (e) {
            function r(r, n, i, a) {
              e.call(this), this.id = r, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._loaded = !1, this.actor = i.getActor(), this.setEventedParent(a), this._data = n.data, this._options = t.extend({}, n), this._collectResourceTiming = n.collectResourceTiming, this._resourceTiming = [], void 0 !== n.maxzoom && (this.maxzoom = n.maxzoom), n.type && (this.type = n.type), n.attribution && (this.attribution = n.attribution), this.promoteId = n.promoteId;
              var o = t.EXTENT / this.tileSize;
              this.workerOptions = t.extend({
                source: this.id,
                cluster: n.cluster || !1,
                geojsonVtOptions: {
                  buffer: (void 0 !== n.buffer ? n.buffer : 128) * o,
                  tolerance: (void 0 !== n.tolerance ? n.tolerance : .375) * o,
                  extent: t.EXTENT,
                  maxZoom: this.maxzoom,
                  lineMetrics: n.lineMetrics || !1,
                  generateId: n.generateId || !1
                },
                superclusterOptions: {
                  maxZoom: void 0 !== n.clusterMaxZoom ? Math.min(n.clusterMaxZoom, this.maxzoom - 1) : this.maxzoom - 1,
                  extent: t.EXTENT,
                  radius: (n.clusterRadius || 50) * o,
                  log: !1,
                  generateId: n.generateId || !1
                },
                clusterProperties: n.clusterProperties
              }, n.workerOptions);
            }

            return e && (r.__proto__ = e), r.prototype = Object.create(e && e.prototype), r.prototype.constructor = r, r.prototype.load = function () {
              var e = this;
              this.fire(new t.Event("dataloading", {
                dataType: "source"
              })), this._updateWorkerData(function (r) {
                if (r) e.fire(new t.ErrorEvent(r));else {
                  var n = {
                    dataType: "source",
                    sourceDataType: "metadata"
                  };
                  e._collectResourceTiming && e._resourceTiming && e._resourceTiming.length > 0 && (n.resourceTiming = e._resourceTiming, e._resourceTiming = []), e.fire(new t.Event("data", n));
                }
              });
            }, r.prototype.onAdd = function (t) {
              this.map = t, this.load();
            }, r.prototype.setData = function (e) {
              var r = this;
              return this._data = e, this.fire(new t.Event("dataloading", {
                dataType: "source"
              })), this._updateWorkerData(function (e) {
                if (e) r.fire(new t.ErrorEvent(e));else {
                  var n = {
                    dataType: "source",
                    sourceDataType: "content"
                  };
                  r._collectResourceTiming && r._resourceTiming && r._resourceTiming.length > 0 && (n.resourceTiming = r._resourceTiming, r._resourceTiming = []), r.fire(new t.Event("data", n));
                }
              }), this;
            }, r.prototype.getClusterExpansionZoom = function (t, e) {
              return this.actor.send("geojson.getClusterExpansionZoom", {
                clusterId: t,
                source: this.id
              }, e), this;
            }, r.prototype.getClusterChildren = function (t, e) {
              return this.actor.send("geojson.getClusterChildren", {
                clusterId: t,
                source: this.id
              }, e), this;
            }, r.prototype.getClusterLeaves = function (t, e, r, n) {
              return this.actor.send("geojson.getClusterLeaves", {
                source: this.id,
                clusterId: t,
                limit: e,
                offset: r
              }, n), this;
            }, r.prototype._updateWorkerData = function (e) {
              var r = this;
              this._loaded = !1;
              var n = t.extend({}, this.workerOptions),
                  i = this._data;
              "string" == typeof i ? (n.request = this.map._requestManager.transformRequest(t.browser.resolveURL(i), t.ResourceType.Source), n.request.collectResourceTiming = this._collectResourceTiming) : n.data = JSON.stringify(i), this.actor.send(this.type + ".loadData", n, function (t, i) {
                r._removed || i && i.abandoned || (r._loaded = !0, i && i.resourceTiming && i.resourceTiming[r.id] && (r._resourceTiming = i.resourceTiming[r.id].slice(0)), r.actor.send(r.type + ".coalesce", {
                  source: n.source
                }, null), e(t));
              });
            }, r.prototype.loaded = function () {
              return this._loaded;
            }, r.prototype.loadTile = function (e, r) {
              var n = this,
                  i = e.actor ? "reloadTile" : "loadTile";
              e.actor = this.actor;
              var a = {
                type: this.type,
                uid: e.uid,
                tileID: e.tileID,
                zoom: e.tileID.overscaledZ,
                maxZoom: this.maxzoom,
                tileSize: this.tileSize,
                source: this.id,
                pixelRatio: t.browser.devicePixelRatio,
                showCollisionBoxes: this.map.showCollisionBoxes,
                promoteId: this.promoteId
              };
              e.request = this.actor.send(i, a, function (t, a) {
                return delete e.request, e.unloadVectorData(), e.aborted ? r(null) : t ? r(t) : (e.loadVectorData(a, n.map.painter, "reloadTile" === i), r(null));
              });
            }, r.prototype.abortTile = function (t) {
              t.request && (t.request.cancel(), delete t.request), t.aborted = !0;
            }, r.prototype.unloadTile = function (t) {
              t.unloadVectorData(), this.actor.send("removeTile", {
                uid: t.uid,
                type: this.type,
                source: this.id
              });
            }, r.prototype.onRemove = function () {
              this._removed = !0, this.actor.send("removeSource", {
                type: this.type,
                source: this.id
              });
            }, r.prototype.serialize = function () {
              return t.extend({}, this._options, {
                type: this.type,
                data: this._data
              });
            }, r.prototype.hasTransition = function () {
              return !1;
            }, r;
          }(t.Evented),
              P = t.createLayout([{
            name: "a_pos",
            type: "Int16",
            components: 2
          }, {
            name: "a_texture_pos",
            type: "Int16",
            components: 2
          }]),
              I = function (e) {
            function r(t, r, n, i) {
              e.call(this), this.id = t, this.dispatcher = n, this.coordinates = r.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(i), this.options = r;
            }

            return e && (r.__proto__ = e), r.prototype = Object.create(e && e.prototype), r.prototype.constructor = r, r.prototype.load = function (e, r) {
              var n = this;
              this._loaded = !1, this.fire(new t.Event("dataloading", {
                dataType: "source"
              })), this.url = this.options.url, t.getImage(this.map._requestManager.transformRequest(this.url, t.ResourceType.Image), function (i, a) {
                n._loaded = !0, i ? n.fire(new t.ErrorEvent(i)) : a && (n.image = a, e && (n.coordinates = e), r && r(), n._finishLoading());
              });
            }, r.prototype.loaded = function () {
              return this._loaded;
            }, r.prototype.updateImage = function (t) {
              var e = this;
              return this.image && t.url ? (this.options.url = t.url, this.load(t.coordinates, function () {
                e.texture = null;
              }), this) : this;
            }, r.prototype._finishLoading = function () {
              this.map && (this.setCoordinates(this.coordinates), this.fire(new t.Event("data", {
                dataType: "source",
                sourceDataType: "metadata"
              })));
            }, r.prototype.onAdd = function (t) {
              this.map = t, this.load();
            }, r.prototype.setCoordinates = function (e) {
              var r = this;
              this.coordinates = e;
              var n = e.map(t.MercatorCoordinate.fromLngLat);
              this.tileID = function (e) {
                for (var r = 1 / 0, n = 1 / 0, i = -1 / 0, a = -1 / 0, o = 0, s = e; o < s.length; o += 1) {
                  var l = s[o];
                  r = Math.min(r, l.x), n = Math.min(n, l.y), i = Math.max(i, l.x), a = Math.max(a, l.y);
                }

                var c = i - r,
                    u = a - n,
                    f = Math.max(c, u),
                    h = Math.max(0, Math.floor(-Math.log(f) / Math.LN2)),
                    p = Math.pow(2, h);
                return new t.CanonicalTileID(h, Math.floor((r + i) / 2 * p), Math.floor((n + a) / 2 * p));
              }(n), this.minzoom = this.maxzoom = this.tileID.z;
              var i = n.map(function (t) {
                return r.tileID.getTilePoint(t)._round();
              });
              return this._boundsArray = new t.StructArrayLayout4i8(), this._boundsArray.emplaceBack(i[0].x, i[0].y, 0, 0), this._boundsArray.emplaceBack(i[1].x, i[1].y, t.EXTENT, 0), this._boundsArray.emplaceBack(i[3].x, i[3].y, 0, t.EXTENT), this._boundsArray.emplaceBack(i[2].x, i[2].y, t.EXTENT, t.EXTENT), this.boundsBuffer && (this.boundsBuffer.destroy(), delete this.boundsBuffer), this.fire(new t.Event("data", {
                dataType: "source",
                sourceDataType: "content"
              })), this;
            }, r.prototype.prepare = function () {
              if (0 !== Object.keys(this.tiles).length && this.image) {
                var e = this.map.painter.context,
                    r = e.gl;

                for (var n in this.boundsBuffer || (this.boundsBuffer = e.createVertexBuffer(this._boundsArray, P.members)), this.boundsSegments || (this.boundsSegments = t.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture || (this.texture = new t.Texture(e, this.image, r.RGBA), this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE)), this.tiles) {
                  var i = this.tiles[n];
                  "loaded" !== i.state && (i.state = "loaded", i.texture = this.texture);
                }
              }
            }, r.prototype.loadTile = function (t, e) {
              this.tileID && this.tileID.equals(t.tileID.canonical) ? (this.tiles[String(t.tileID.wrap)] = t, t.buckets = {}, e(null)) : (t.state = "errored", e(null));
            }, r.prototype.serialize = function () {
              return {
                type: "image",
                url: this.options.url,
                coordinates: this.coordinates
              };
            }, r.prototype.hasTransition = function () {
              return !1;
            }, r;
          }(t.Evented);

          var O = function (e) {
            function r(t, r, n, i) {
              e.call(this, t, r, n, i), this.roundZoom = !0, this.type = "video", this.options = r;
            }

            return e && (r.__proto__ = e), r.prototype = Object.create(e && e.prototype), r.prototype.constructor = r, r.prototype.load = function () {
              var e = this;
              this._loaded = !1;
              var r = this.options;
              this.urls = [];

              for (var n = 0, i = r.urls; n < i.length; n += 1) {
                var a = i[n];
                this.urls.push(this.map._requestManager.transformRequest(a, t.ResourceType.Source).url);
              }

              t.getVideo(this.urls, function (r, n) {
                e._loaded = !0, r ? e.fire(new t.ErrorEvent(r)) : n && (e.video = n, e.video.loop = !0, e.video.addEventListener("playing", function () {
                  e.map.triggerRepaint();
                }), e.map && e.video.play(), e._finishLoading());
              });
            }, r.prototype.pause = function () {
              this.video && this.video.pause();
            }, r.prototype.play = function () {
              this.video && this.video.play();
            }, r.prototype.seek = function (e) {
              if (this.video) {
                var r = this.video.seekable;
                e < r.start(0) || e > r.end(0) ? this.fire(new t.ErrorEvent(new t.ValidationError("sources." + this.id, null, "Playback for this video can be set only between the " + r.start(0) + " and " + r.end(0) + "-second mark."))) : this.video.currentTime = e;
              }
            }, r.prototype.getVideo = function () {
              return this.video;
            }, r.prototype.onAdd = function (t) {
              this.map || (this.map = t, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
            }, r.prototype.prepare = function () {
              if (!(0 === Object.keys(this.tiles).length || this.video.readyState < 2)) {
                var e = this.map.painter.context,
                    r = e.gl;

                for (var n in this.boundsBuffer || (this.boundsBuffer = e.createVertexBuffer(this._boundsArray, P.members)), this.boundsSegments || (this.boundsSegments = t.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture ? this.video.paused || (this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE), r.texSubImage2D(r.TEXTURE_2D, 0, 0, 0, r.RGBA, r.UNSIGNED_BYTE, this.video)) : (this.texture = new t.Texture(e, this.video, r.RGBA), this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE)), this.tiles) {
                  var i = this.tiles[n];
                  "loaded" !== i.state && (i.state = "loaded", i.texture = this.texture);
                }
              }
            }, r.prototype.serialize = function () {
              return {
                type: "video",
                urls: this.urls,
                coordinates: this.coordinates
              };
            }, r.prototype.hasTransition = function () {
              return this.video && !this.video.paused;
            }, r;
          }(I),
              z = function (e) {
            function r(r, n, i, a) {
              e.call(this, r, n, i, a), n.coordinates ? Array.isArray(n.coordinates) && 4 === n.coordinates.length && !n.coordinates.some(function (t) {
                return !Array.isArray(t) || 2 !== t.length || t.some(function (t) {
                  return "number" != typeof t;
                });
              }) || this.fire(new t.ErrorEvent(new t.ValidationError("sources." + r, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new t.ErrorEvent(new t.ValidationError("sources." + r, null, 'missing required property "coordinates"'))), n.animate && "boolean" != typeof n.animate && this.fire(new t.ErrorEvent(new t.ValidationError("sources." + r, null, 'optional "animate" property must be a boolean value'))), n.canvas ? "string" == typeof n.canvas || n.canvas instanceof t.window.HTMLCanvasElement || this.fire(new t.ErrorEvent(new t.ValidationError("sources." + r, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new t.ErrorEvent(new t.ValidationError("sources." + r, null, 'missing required property "canvas"'))), this.options = n, this.animate = void 0 === n.animate || n.animate;
            }

            return e && (r.__proto__ = e), r.prototype = Object.create(e && e.prototype), r.prototype.constructor = r, r.prototype.load = function () {
              this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof t.window.HTMLCanvasElement ? this.options.canvas : t.window.document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new t.ErrorEvent(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function () {
                this._playing = !0, this.map.triggerRepaint();
              }, this.pause = function () {
                this._playing && (this.prepare(), this._playing = !1);
              }, this._finishLoading());
            }, r.prototype.getCanvas = function () {
              return this.canvas;
            }, r.prototype.onAdd = function (t) {
              this.map = t, this.load(), this.canvas && this.animate && this.play();
            }, r.prototype.onRemove = function () {
              this.pause();
            }, r.prototype.prepare = function () {
              var e = !1;

              if (this.canvas.width !== this.width && (this.width = this.canvas.width, e = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, e = !0), !this._hasInvalidDimensions() && 0 !== Object.keys(this.tiles).length) {
                var r = this.map.painter.context,
                    n = r.gl;

                for (var i in this.boundsBuffer || (this.boundsBuffer = r.createVertexBuffer(this._boundsArray, P.members)), this.boundsSegments || (this.boundsSegments = t.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture ? (e || this._playing) && this.texture.update(this.canvas, {
                  premultiply: !0
                }) : this.texture = new t.Texture(r, this.canvas, n.RGBA, {
                  premultiply: !0
                }), this.tiles) {
                  var a = this.tiles[i];
                  "loaded" !== a.state && (a.state = "loaded", a.texture = this.texture);
                }
              }
            }, r.prototype.serialize = function () {
              return {
                type: "canvas",
                coordinates: this.coordinates
              };
            }, r.prototype.hasTransition = function () {
              return this._playing;
            }, r.prototype._hasInvalidDimensions = function () {
              for (var t = 0, e = [this.canvas.width, this.canvas.height]; t < e.length; t += 1) {
                var r = e[t];
                if (isNaN(r) || r <= 0) return !0;
              }

              return !1;
            }, r;
          }(I),
              D = {
            vector: S,
            raster: E,
            "raster-dem": L,
            geojson: C,
            video: O,
            image: I,
            canvas: z
          };

          function R(e, r) {
            var n = t.identity([]);
            return t.translate(n, n, [1, 1, 0]), t.scale(n, n, [.5 * e.width, .5 * e.height, 1]), t.multiply(n, n, e.calculatePosMatrix(r.toUnwrapped()));
          }

          function F(t, e, r, n, i, a) {
            var o = function (t, e, r) {
              if (t) for (var n = 0, i = t; n < i.length; n += 1) {
                var a = e[i[n]];
                if (a && a.source === r && "fill-extrusion" === a.type) return !0;
              } else for (var o in e) {
                var s = e[o];
                if (s.source === r && "fill-extrusion" === s.type) return !0;
              }
              return !1;
            }(i && i.layers, e, t.id),
                s = a.maxPitchScaleFactor(),
                l = t.tilesIn(n, s, o);

            l.sort(B);

            for (var c = [], u = 0, f = l; u < f.length; u += 1) {
              var h = f[u];
              c.push({
                wrappedTileID: h.tileID.wrapped().key,
                queryResults: h.tile.queryRenderedFeatures(e, r, t._state, h.queryGeometry, h.cameraQueryGeometry, h.scale, i, a, s, R(t.transform, h.tileID))
              });
            }

            var p = function (t) {
              for (var e = {}, r = {}, n = 0, i = t; n < i.length; n += 1) {
                var a = i[n],
                    o = a.queryResults,
                    s = a.wrappedTileID,
                    l = r[s] = r[s] || {};

                for (var c in o) {
                  for (var u = o[c], f = l[c] = l[c] || {}, h = e[c] = e[c] || [], p = 0, d = u; p < d.length; p += 1) {
                    var m = d[p];
                    f[m.featureIndex] || (f[m.featureIndex] = !0, h.push(m));
                  }
                }
              }

              return e;
            }(c);

            for (var d in p) {
              p[d].forEach(function (e) {
                var r = e.feature,
                    n = t.getFeatureState(r.layer["source-layer"], r.id);
                r.source = r.layer.source, r.layer["source-layer"] && (r.sourceLayer = r.layer["source-layer"]), r.state = n;
              });
            }

            return p;
          }

          function B(t, e) {
            var r = t.tileID,
                n = e.tileID;
            return r.overscaledZ - n.overscaledZ || r.canonical.y - n.canonical.y || r.wrap - n.wrap || r.canonical.x - n.canonical.x;
          }

          var N = function N(t, e) {
            this.max = t, this.onRemove = e, this.reset();
          };

          N.prototype.reset = function () {
            for (var t in this.data) {
              for (var e = 0, r = this.data[t]; e < r.length; e += 1) {
                var n = r[e];
                n.timeout && clearTimeout(n.timeout), this.onRemove(n.value);
              }
            }

            return this.data = {}, this.order = [], this;
          }, N.prototype.add = function (t, e, r) {
            var n = this,
                i = t.wrapped().key;
            void 0 === this.data[i] && (this.data[i] = []);
            var a = {
              value: e,
              timeout: void 0
            };

            if (void 0 !== r && (a.timeout = setTimeout(function () {
              n.remove(t, a);
            }, r)), this.data[i].push(a), this.order.push(i), this.order.length > this.max) {
              var o = this._getAndRemoveByKey(this.order[0]);

              o && this.onRemove(o);
            }

            return this;
          }, N.prototype.has = function (t) {
            return t.wrapped().key in this.data;
          }, N.prototype.getAndRemove = function (t) {
            return this.has(t) ? this._getAndRemoveByKey(t.wrapped().key) : null;
          }, N.prototype._getAndRemoveByKey = function (t) {
            var e = this.data[t].shift();
            return e.timeout && clearTimeout(e.timeout), 0 === this.data[t].length && delete this.data[t], this.order.splice(this.order.indexOf(t), 1), e.value;
          }, N.prototype.getByKey = function (t) {
            var e = this.data[t];
            return e ? e[0].value : null;
          }, N.prototype.get = function (t) {
            return this.has(t) ? this.data[t.wrapped().key][0].value : null;
          }, N.prototype.remove = function (t, e) {
            if (!this.has(t)) return this;
            var r = t.wrapped().key,
                n = void 0 === e ? 0 : this.data[r].indexOf(e),
                i = this.data[r][n];
            return this.data[r].splice(n, 1), i.timeout && clearTimeout(i.timeout), 0 === this.data[r].length && delete this.data[r], this.onRemove(i.value), this.order.splice(this.order.indexOf(r), 1), this;
          }, N.prototype.setMaxSize = function (t) {
            for (this.max = t; this.order.length > this.max;) {
              var e = this._getAndRemoveByKey(this.order[0]);

              e && this.onRemove(e);
            }

            return this;
          }, N.prototype.filter = function (t) {
            var e = [];

            for (var r in this.data) {
              for (var n = 0, i = this.data[r]; n < i.length; n += 1) {
                var a = i[n];
                t(a.value) || e.push(a);
              }
            }

            for (var o = 0, s = e; o < s.length; o += 1) {
              var l = s[o];
              this.remove(l.value.tileID, l);
            }
          };

          var j = function j(t, e, r) {
            this.context = t;
            var n = t.gl;
            this.buffer = n.createBuffer(), this.dynamicDraw = Boolean(r), this.context.unbindVAO(), t.bindElementBuffer.set(this.buffer), n.bufferData(n.ELEMENT_ARRAY_BUFFER, e.arrayBuffer, this.dynamicDraw ? n.DYNAMIC_DRAW : n.STATIC_DRAW), this.dynamicDraw || delete e.arrayBuffer;
          };

          j.prototype.bind = function () {
            this.context.bindElementBuffer.set(this.buffer);
          }, j.prototype.updateData = function (t) {
            var e = this.context.gl;
            this.context.unbindVAO(), this.bind(), e.bufferSubData(e.ELEMENT_ARRAY_BUFFER, 0, t.arrayBuffer);
          }, j.prototype.destroy = function () {
            var t = this.context.gl;
            this.buffer && (t.deleteBuffer(this.buffer), delete this.buffer);
          };

          var U = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
          },
              V = function V(t, e, r, n) {
            this.length = e.length, this.attributes = r, this.itemSize = e.bytesPerElement, this.dynamicDraw = n, this.context = t;
            var i = t.gl;
            this.buffer = i.createBuffer(), t.bindVertexBuffer.set(this.buffer), i.bufferData(i.ARRAY_BUFFER, e.arrayBuffer, this.dynamicDraw ? i.DYNAMIC_DRAW : i.STATIC_DRAW), this.dynamicDraw || delete e.arrayBuffer;
          };

          V.prototype.bind = function () {
            this.context.bindVertexBuffer.set(this.buffer);
          }, V.prototype.updateData = function (t) {
            var e = this.context.gl;
            this.bind(), e.bufferSubData(e.ARRAY_BUFFER, 0, t.arrayBuffer);
          }, V.prototype.enableAttributes = function (t, e) {
            for (var r = 0; r < this.attributes.length; r++) {
              var n = this.attributes[r],
                  i = e.attributes[n.name];
              void 0 !== i && t.enableVertexAttribArray(i);
            }
          }, V.prototype.setVertexAttribPointers = function (t, e, r) {
            for (var n = 0; n < this.attributes.length; n++) {
              var i = this.attributes[n],
                  a = e.attributes[i.name];
              void 0 !== a && t.vertexAttribPointer(a, i.components, t[U[i.type]], !1, this.itemSize, i.offset + this.itemSize * (r || 0));
            }
          }, V.prototype.destroy = function () {
            var t = this.context.gl;
            this.buffer && (t.deleteBuffer(this.buffer), delete this.buffer);
          };

          var q = function q(t) {
            this.gl = t.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
          };

          q.prototype.get = function () {
            return this.current;
          }, q.prototype.set = function (t) {}, q.prototype.getDefault = function () {
            return this.default;
          }, q.prototype.setDefault = function () {
            this.set(this.default);
          };

          var H = function (e) {
            function r() {
              e.apply(this, arguments);
            }

            return e && (r.__proto__ = e), r.prototype = Object.create(e && e.prototype), r.prototype.constructor = r, r.prototype.getDefault = function () {
              return t.Color.transparent;
            }, r.prototype.set = function (t) {
              var e = this.current;
              (t.r !== e.r || t.g !== e.g || t.b !== e.b || t.a !== e.a || this.dirty) && (this.gl.clearColor(t.r, t.g, t.b, t.a), this.current = t, this.dirty = !1);
            }, r;
          }(q),
              G = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return 1;
            }, e.prototype.set = function (t) {
              (t !== this.current || this.dirty) && (this.gl.clearDepth(t), this.current = t, this.dirty = !1);
            }, e;
          }(q),
              Y = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return 0;
            }, e.prototype.set = function (t) {
              (t !== this.current || this.dirty) && (this.gl.clearStencil(t), this.current = t, this.dirty = !1);
            }, e;
          }(q),
              W = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return [!0, !0, !0, !0];
            }, e.prototype.set = function (t) {
              var e = this.current;
              (t[0] !== e[0] || t[1] !== e[1] || t[2] !== e[2] || t[3] !== e[3] || this.dirty) && (this.gl.colorMask(t[0], t[1], t[2], t[3]), this.current = t, this.dirty = !1);
            }, e;
          }(q),
              X = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return !0;
            }, e.prototype.set = function (t) {
              (t !== this.current || this.dirty) && (this.gl.depthMask(t), this.current = t, this.dirty = !1);
            }, e;
          }(q),
              Z = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return 255;
            }, e.prototype.set = function (t) {
              (t !== this.current || this.dirty) && (this.gl.stencilMask(t), this.current = t, this.dirty = !1);
            }, e;
          }(q),
              J = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return {
                func: this.gl.ALWAYS,
                ref: 0,
                mask: 255
              };
            }, e.prototype.set = function (t) {
              var e = this.current;
              (t.func !== e.func || t.ref !== e.ref || t.mask !== e.mask || this.dirty) && (this.gl.stencilFunc(t.func, t.ref, t.mask), this.current = t, this.dirty = !1);
            }, e;
          }(q),
              K = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              var t = this.gl;
              return [t.KEEP, t.KEEP, t.KEEP];
            }, e.prototype.set = function (t) {
              var e = this.current;
              (t[0] !== e[0] || t[1] !== e[1] || t[2] !== e[2] || this.dirty) && (this.gl.stencilOp(t[0], t[1], t[2]), this.current = t, this.dirty = !1);
            }, e;
          }(q),
              Q = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return !1;
            }, e.prototype.set = function (t) {
              if (t !== this.current || this.dirty) {
                var e = this.gl;
                t ? e.enable(e.STENCIL_TEST) : e.disable(e.STENCIL_TEST), this.current = t, this.dirty = !1;
              }
            }, e;
          }(q),
              $ = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return [0, 1];
            }, e.prototype.set = function (t) {
              var e = this.current;
              (t[0] !== e[0] || t[1] !== e[1] || this.dirty) && (this.gl.depthRange(t[0], t[1]), this.current = t, this.dirty = !1);
            }, e;
          }(q),
              tt = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return !1;
            }, e.prototype.set = function (t) {
              if (t !== this.current || this.dirty) {
                var e = this.gl;
                t ? e.enable(e.DEPTH_TEST) : e.disable(e.DEPTH_TEST), this.current = t, this.dirty = !1;
              }
            }, e;
          }(q),
              et = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return this.gl.LESS;
            }, e.prototype.set = function (t) {
              (t !== this.current || this.dirty) && (this.gl.depthFunc(t), this.current = t, this.dirty = !1);
            }, e;
          }(q),
              rt = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return !1;
            }, e.prototype.set = function (t) {
              if (t !== this.current || this.dirty) {
                var e = this.gl;
                t ? e.enable(e.BLEND) : e.disable(e.BLEND), this.current = t, this.dirty = !1;
              }
            }, e;
          }(q),
              nt = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              var t = this.gl;
              return [t.ONE, t.ZERO];
            }, e.prototype.set = function (t) {
              var e = this.current;
              (t[0] !== e[0] || t[1] !== e[1] || this.dirty) && (this.gl.blendFunc(t[0], t[1]), this.current = t, this.dirty = !1);
            }, e;
          }(q),
              it = function (e) {
            function r() {
              e.apply(this, arguments);
            }

            return e && (r.__proto__ = e), r.prototype = Object.create(e && e.prototype), r.prototype.constructor = r, r.prototype.getDefault = function () {
              return t.Color.transparent;
            }, r.prototype.set = function (t) {
              var e = this.current;
              (t.r !== e.r || t.g !== e.g || t.b !== e.b || t.a !== e.a || this.dirty) && (this.gl.blendColor(t.r, t.g, t.b, t.a), this.current = t, this.dirty = !1);
            }, r;
          }(q),
              at = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return this.gl.FUNC_ADD;
            }, e.prototype.set = function (t) {
              (t !== this.current || this.dirty) && (this.gl.blendEquation(t), this.current = t, this.dirty = !1);
            }, e;
          }(q),
              ot = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return !1;
            }, e.prototype.set = function (t) {
              if (t !== this.current || this.dirty) {
                var e = this.gl;
                t ? e.enable(e.CULL_FACE) : e.disable(e.CULL_FACE), this.current = t, this.dirty = !1;
              }
            }, e;
          }(q),
              st = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return this.gl.BACK;
            }, e.prototype.set = function (t) {
              (t !== this.current || this.dirty) && (this.gl.cullFace(t), this.current = t, this.dirty = !1);
            }, e;
          }(q),
              lt = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return this.gl.CCW;
            }, e.prototype.set = function (t) {
              (t !== this.current || this.dirty) && (this.gl.frontFace(t), this.current = t, this.dirty = !1);
            }, e;
          }(q),
              ct = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return null;
            }, e.prototype.set = function (t) {
              (t !== this.current || this.dirty) && (this.gl.useProgram(t), this.current = t, this.dirty = !1);
            }, e;
          }(q),
              ut = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return this.gl.TEXTURE0;
            }, e.prototype.set = function (t) {
              (t !== this.current || this.dirty) && (this.gl.activeTexture(t), this.current = t, this.dirty = !1);
            }, e;
          }(q),
              ft = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              var t = this.gl;
              return [0, 0, t.drawingBufferWidth, t.drawingBufferHeight];
            }, e.prototype.set = function (t) {
              var e = this.current;
              (t[0] !== e[0] || t[1] !== e[1] || t[2] !== e[2] || t[3] !== e[3] || this.dirty) && (this.gl.viewport(t[0], t[1], t[2], t[3]), this.current = t, this.dirty = !1);
            }, e;
          }(q),
              ht = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return null;
            }, e.prototype.set = function (t) {
              if (t !== this.current || this.dirty) {
                var e = this.gl;
                e.bindFramebuffer(e.FRAMEBUFFER, t), this.current = t, this.dirty = !1;
              }
            }, e;
          }(q),
              pt = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return null;
            }, e.prototype.set = function (t) {
              if (t !== this.current || this.dirty) {
                var e = this.gl;
                e.bindRenderbuffer(e.RENDERBUFFER, t), this.current = t, this.dirty = !1;
              }
            }, e;
          }(q),
              dt = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return null;
            }, e.prototype.set = function (t) {
              if (t !== this.current || this.dirty) {
                var e = this.gl;
                e.bindTexture(e.TEXTURE_2D, t), this.current = t, this.dirty = !1;
              }
            }, e;
          }(q),
              mt = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return null;
            }, e.prototype.set = function (t) {
              if (t !== this.current || this.dirty) {
                var e = this.gl;
                e.bindBuffer(e.ARRAY_BUFFER, t), this.current = t, this.dirty = !1;
              }
            }, e;
          }(q),
              gt = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return null;
            }, e.prototype.set = function (t) {
              var e = this.gl;
              e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, t), this.current = t, this.dirty = !1;
            }, e;
          }(q),
              vt = function (t) {
            function e(e) {
              t.call(this, e), this.vao = e.extVertexArrayObject;
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return null;
            }, e.prototype.set = function (t) {
              this.vao && (t !== this.current || this.dirty) && (this.vao.bindVertexArrayOES(t), this.current = t, this.dirty = !1);
            }, e;
          }(q),
              yt = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return 4;
            }, e.prototype.set = function (t) {
              if (t !== this.current || this.dirty) {
                var e = this.gl;
                e.pixelStorei(e.UNPACK_ALIGNMENT, t), this.current = t, this.dirty = !1;
              }
            }, e;
          }(q),
              xt = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return !1;
            }, e.prototype.set = function (t) {
              if (t !== this.current || this.dirty) {
                var e = this.gl;
                e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t), this.current = t, this.dirty = !1;
              }
            }, e;
          }(q),
              bt = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return !1;
            }, e.prototype.set = function (t) {
              if (t !== this.current || this.dirty) {
                var e = this.gl;
                e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, t), this.current = t, this.dirty = !1;
              }
            }, e;
          }(q),
              _t = function (t) {
            function e(e, r) {
              t.call(this, e), this.context = e, this.parent = r;
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDefault = function () {
              return null;
            }, e;
          }(q),
              wt = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.setDirty = function () {
              this.dirty = !0;
            }, e.prototype.set = function (t) {
              if (t !== this.current || this.dirty) {
                this.context.bindFramebuffer.set(this.parent);
                var e = this.gl;
                e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, t, 0), this.current = t, this.dirty = !1;
              }
            }, e;
          }(_t),
              Tt = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.set = function (t) {
              if (t !== this.current || this.dirty) {
                this.context.bindFramebuffer.set(this.parent);
                var e = this.gl;
                e.framebufferRenderbuffer(e.FRAMEBUFFER, e.DEPTH_ATTACHMENT, e.RENDERBUFFER, t), this.current = t, this.dirty = !1;
              }
            }, e;
          }(_t),
              kt = function kt(t, e, r, n) {
            this.context = t, this.width = e, this.height = r;
            var i = t.gl,
                a = this.framebuffer = i.createFramebuffer();
            this.colorAttachment = new wt(t, a), n && (this.depthAttachment = new Tt(t, a));
          };

          kt.prototype.destroy = function () {
            var t = this.context.gl,
                e = this.colorAttachment.get();

            if (e && t.deleteTexture(e), this.depthAttachment) {
              var r = this.depthAttachment.get();
              r && t.deleteRenderbuffer(r);
            }

            t.deleteFramebuffer(this.framebuffer);
          };

          var Mt = function Mt(t, e, r) {
            this.func = t, this.mask = e, this.range = r;
          };

          Mt.ReadOnly = !1, Mt.ReadWrite = !0, Mt.disabled = new Mt(519, Mt.ReadOnly, [0, 1]);

          var At = function At(t, e, r, n, i, a) {
            this.test = t, this.ref = e, this.mask = r, this.fail = n, this.depthFail = i, this.pass = a;
          };

          At.disabled = new At({
            func: 519,
            mask: 0
          }, 0, 0, 7680, 7680, 7680);

          var St = function St(t, e, r) {
            this.blendFunction = t, this.blendColor = e, this.mask = r;
          };

          St.disabled = new St(St.Replace = [1, 0], t.Color.transparent, [!1, !1, !1, !1]), St.unblended = new St(St.Replace, t.Color.transparent, [!0, !0, !0, !0]), St.alphaBlended = new St([1, 771], t.Color.transparent, [!0, !0, !0, !0]);

          var Et = function Et(t, e, r) {
            this.enable = t, this.mode = e, this.frontFace = r;
          };

          Et.disabled = new Et(!1, 1029, 2305), Et.backCCW = new Et(!0, 1029, 2305);

          var Lt = function Lt(t) {
            this.gl = t, this.extVertexArrayObject = this.gl.getExtension("OES_vertex_array_object"), this.clearColor = new H(this), this.clearDepth = new G(this), this.clearStencil = new Y(this), this.colorMask = new W(this), this.depthMask = new X(this), this.stencilMask = new Z(this), this.stencilFunc = new J(this), this.stencilOp = new K(this), this.stencilTest = new Q(this), this.depthRange = new $(this), this.depthTest = new tt(this), this.depthFunc = new et(this), this.blend = new rt(this), this.blendFunc = new nt(this), this.blendColor = new it(this), this.blendEquation = new at(this), this.cullFace = new ot(this), this.cullFaceSide = new st(this), this.frontFace = new lt(this), this.program = new ct(this), this.activeTexture = new ut(this), this.viewport = new ft(this), this.bindFramebuffer = new ht(this), this.bindRenderbuffer = new pt(this), this.bindTexture = new dt(this), this.bindVertexBuffer = new mt(this), this.bindElementBuffer = new gt(this), this.bindVertexArrayOES = this.extVertexArrayObject && new vt(this), this.pixelStoreUnpack = new yt(this), this.pixelStoreUnpackPremultiplyAlpha = new xt(this), this.pixelStoreUnpackFlipY = new bt(this), this.extTextureFilterAnisotropic = t.getExtension("EXT_texture_filter_anisotropic") || t.getExtension("MOZ_EXT_texture_filter_anisotropic") || t.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = t.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.extTextureHalfFloat = t.getExtension("OES_texture_half_float"), this.extTextureHalfFloat && (t.getExtension("OES_texture_half_float_linear"), this.extRenderToTextureHalfFloat = t.getExtension("EXT_color_buffer_half_float")), this.extTimerQuery = t.getExtension("EXT_disjoint_timer_query");
          };

          Lt.prototype.setDefault = function () {
            this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
          }, Lt.prototype.setDirty = function () {
            this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.extVertexArrayObject && (this.bindVertexArrayOES.dirty = !0), this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
          }, Lt.prototype.createIndexBuffer = function (t, e) {
            return new j(this, t, e);
          }, Lt.prototype.createVertexBuffer = function (t, e, r) {
            return new V(this, t, e, r);
          }, Lt.prototype.createRenderbuffer = function (t, e, r) {
            var n = this.gl,
                i = n.createRenderbuffer();
            return this.bindRenderbuffer.set(i), n.renderbufferStorage(n.RENDERBUFFER, t, e, r), this.bindRenderbuffer.set(null), i;
          }, Lt.prototype.createFramebuffer = function (t, e, r) {
            return new kt(this, t, e, r);
          }, Lt.prototype.clear = function (t) {
            var e = t.color,
                r = t.depth,
                n = this.gl,
                i = 0;
            e && (i |= n.COLOR_BUFFER_BIT, this.clearColor.set(e), this.colorMask.set([!0, !0, !0, !0])), void 0 !== r && (i |= n.DEPTH_BUFFER_BIT, this.depthRange.set([0, 1]), this.clearDepth.set(r), this.depthMask.set(!0)), n.clear(i);
          }, Lt.prototype.setCullFace = function (t) {
            !1 === t.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(t.mode), this.frontFace.set(t.frontFace));
          }, Lt.prototype.setDepthMode = function (t) {
            t.func !== this.gl.ALWAYS || t.mask ? (this.depthTest.set(!0), this.depthFunc.set(t.func), this.depthMask.set(t.mask), this.depthRange.set(t.range)) : this.depthTest.set(!1);
          }, Lt.prototype.setStencilMode = function (t) {
            t.test.func !== this.gl.ALWAYS || t.mask ? (this.stencilTest.set(!0), this.stencilMask.set(t.mask), this.stencilOp.set([t.fail, t.depthFail, t.pass]), this.stencilFunc.set({
              func: t.test.func,
              ref: t.ref,
              mask: t.test.mask
            })) : this.stencilTest.set(!1);
          }, Lt.prototype.setColorMode = function (e) {
            t.deepEqual(e.blendFunction, St.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(e.blendFunction), this.blendColor.set(e.blendColor)), this.colorMask.set(e.mask);
          }, Lt.prototype.unbindVAO = function () {
            this.extVertexArrayObject && this.bindVertexArrayOES.set(null);
          };

          var Ct = function (e) {
            function r(r, n, i) {
              var a = this;
              e.call(this), this.id = r, this.dispatcher = i, this.on("data", function (t) {
                "source" === t.dataType && "metadata" === t.sourceDataType && (a._sourceLoaded = !0), a._sourceLoaded && !a._paused && "source" === t.dataType && "content" === t.sourceDataType && (a.reload(), a.transform && a.update(a.transform));
              }), this.on("error", function () {
                a._sourceErrored = !0;
              }), this._source = function (e, r, n, i) {
                var a = new D[r.type](e, r, n, i);
                if (a.id !== e) throw new Error("Expected Source id to be " + e + " instead of " + a.id);
                return t.bindAll(["load", "abort", "unload", "serialize", "prepare"], a), a;
              }(r, n, i, this), this._tiles = {}, this._cache = new N(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._maxTileCacheSize = null, this._loadedParentTiles = {}, this._coveredTiles = {}, this._state = new t.SourceFeatureState();
            }

            return e && (r.__proto__ = e), r.prototype = Object.create(e && e.prototype), r.prototype.constructor = r, r.prototype.onAdd = function (t) {
              this.map = t, this._maxTileCacheSize = t ? t._maxTileCacheSize : null, this._source && this._source.onAdd && this._source.onAdd(t);
            }, r.prototype.onRemove = function (t) {
              this._source && this._source.onRemove && this._source.onRemove(t);
            }, r.prototype.loaded = function () {
              if (this._sourceErrored) return !0;
              if (!this._sourceLoaded) return !1;
              if (!this._source.loaded()) return !1;

              for (var t in this._tiles) {
                var e = this._tiles[t];
                if ("loaded" !== e.state && "errored" !== e.state) return !1;
              }

              return !0;
            }, r.prototype.getSource = function () {
              return this._source;
            }, r.prototype.pause = function () {
              this._paused = !0;
            }, r.prototype.resume = function () {
              if (this._paused) {
                var t = this._shouldReloadOnResume;
                this._paused = !1, this._shouldReloadOnResume = !1, t && this.reload(), this.transform && this.update(this.transform);
              }
            }, r.prototype._loadTile = function (t, e) {
              return this._source.loadTile(t, e);
            }, r.prototype._unloadTile = function (t) {
              if (this._source.unloadTile) return this._source.unloadTile(t, function () {});
            }, r.prototype._abortTile = function (t) {
              if (this._source.abortTile) return this._source.abortTile(t, function () {});
            }, r.prototype.serialize = function () {
              return this._source.serialize();
            }, r.prototype.prepare = function (t) {
              for (var e in this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null), this._tiles) {
                var r = this._tiles[e];
                r.upload(t), r.prepare(this.map.style.imageManager);
              }
            }, r.prototype.getIds = function () {
              return t.values(this._tiles).map(function (t) {
                return t.tileID;
              }).sort(Pt).map(function (t) {
                return t.key;
              });
            }, r.prototype.getRenderableIds = function (e) {
              var r = this,
                  n = [];

              for (var i in this._tiles) {
                this._isIdRenderable(i, e) && n.push(this._tiles[i]);
              }

              return e ? n.sort(function (e, n) {
                var i = e.tileID,
                    a = n.tileID,
                    o = new t.Point(i.canonical.x, i.canonical.y)._rotate(r.transform.angle),
                    s = new t.Point(a.canonical.x, a.canonical.y)._rotate(r.transform.angle);

                return i.overscaledZ - a.overscaledZ || s.y - o.y || s.x - o.x;
              }).map(function (t) {
                return t.tileID.key;
              }) : n.map(function (t) {
                return t.tileID;
              }).sort(Pt).map(function (t) {
                return t.key;
              });
            }, r.prototype.hasRenderableParent = function (t) {
              var e = this.findLoadedParent(t, 0);
              return !!e && this._isIdRenderable(e.tileID.key);
            }, r.prototype._isIdRenderable = function (t, e) {
              return this._tiles[t] && this._tiles[t].hasData() && !this._coveredTiles[t] && (e || !this._tiles[t].holdingForFade());
            }, r.prototype.reload = function () {
              if (this._paused) this._shouldReloadOnResume = !0;else for (var t in this._cache.reset(), this._tiles) {
                "errored" !== this._tiles[t].state && this._reloadTile(t, "reloading");
              }
            }, r.prototype._reloadTile = function (t, e) {
              var r = this._tiles[t];
              r && ("loading" !== r.state && (r.state = e), this._loadTile(r, this._tileLoaded.bind(this, r, t, e)));
            }, r.prototype._tileLoaded = function (e, r, n, i) {
              if (i) return e.state = "errored", void (404 !== i.status ? this._source.fire(new t.ErrorEvent(i, {
                tile: e
              })) : this.update(this.transform));
              e.timeAdded = t.browser.now(), "expired" === n && (e.refreshedUponExpiration = !0), this._setTileReloadTimer(r, e), "raster-dem" === this.getSource().type && e.dem && this._backfillDEM(e), this._state.initializeTileState(e, this.map ? this.map.painter : null), this._source.fire(new t.Event("data", {
                dataType: "source",
                tile: e,
                coord: e.tileID
              }));
            }, r.prototype._backfillDEM = function (t) {
              for (var e = this.getRenderableIds(), r = 0; r < e.length; r++) {
                var n = e[r];

                if (t.neighboringTiles && t.neighboringTiles[n]) {
                  var i = this.getTileByID(n);
                  a(t, i), a(i, t);
                }
              }

              function a(t, e) {
                t.needsHillshadePrepare = !0;
                var r = e.tileID.canonical.x - t.tileID.canonical.x,
                    n = e.tileID.canonical.y - t.tileID.canonical.y,
                    i = Math.pow(2, t.tileID.canonical.z),
                    a = e.tileID.key;
                0 === r && 0 === n || Math.abs(n) > 1 || (Math.abs(r) > 1 && (1 === Math.abs(r + i) ? r += i : 1 === Math.abs(r - i) && (r -= i)), e.dem && t.dem && (t.dem.backfillBorder(e.dem, r, n), t.neighboringTiles && t.neighboringTiles[a] && (t.neighboringTiles[a].backfilled = !0)));
              }
            }, r.prototype.getTile = function (t) {
              return this.getTileByID(t.key);
            }, r.prototype.getTileByID = function (t) {
              return this._tiles[t];
            }, r.prototype._retainLoadedChildren = function (t, e, r, n) {
              for (var i in this._tiles) {
                var a = this._tiles[i];

                if (!(n[i] || !a.hasData() || a.tileID.overscaledZ <= e || a.tileID.overscaledZ > r)) {
                  for (var o = a.tileID; a && a.tileID.overscaledZ > e + 1;) {
                    var s = a.tileID.scaledTo(a.tileID.overscaledZ - 1);
                    (a = this._tiles[s.key]) && a.hasData() && (o = s);
                  }

                  for (var l = o; l.overscaledZ > e;) {
                    if (t[(l = l.scaledTo(l.overscaledZ - 1)).key]) {
                      n[o.key] = o;
                      break;
                    }
                  }
                }
              }
            }, r.prototype.findLoadedParent = function (t, e) {
              if (t.key in this._loadedParentTiles) {
                var r = this._loadedParentTiles[t.key];
                return r && r.tileID.overscaledZ >= e ? r : null;
              }

              for (var n = t.overscaledZ - 1; n >= e; n--) {
                var i = t.scaledTo(n),
                    a = this._getLoadedTile(i);

                if (a) return a;
              }
            }, r.prototype._getLoadedTile = function (t) {
              var e = this._tiles[t.key];
              return e && e.hasData() ? e : this._cache.getByKey(t.wrapped().key);
            }, r.prototype.updateCacheSize = function (t) {
              var e = (Math.ceil(t.width / this._source.tileSize) + 1) * (Math.ceil(t.height / this._source.tileSize) + 1),
                  r = Math.floor(5 * e),
                  n = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, r) : r;

              this._cache.setMaxSize(n);
            }, r.prototype.handleWrapJump = function (t) {
              var e = (t - (void 0 === this._prevLng ? t : this._prevLng)) / 360,
                  r = Math.round(e);

              if (this._prevLng = t, r) {
                var n = {};

                for (var i in this._tiles) {
                  var a = this._tiles[i];
                  a.tileID = a.tileID.unwrapTo(a.tileID.wrap + r), n[a.tileID.key] = a;
                }

                for (var o in this._tiles = n, this._timers) {
                  clearTimeout(this._timers[o]), delete this._timers[o];
                }

                for (var s in this._tiles) {
                  var l = this._tiles[s];

                  this._setTileReloadTimer(s, l);
                }
              }
            }, r.prototype.update = function (e) {
              var n = this;

              if (this.transform = e, this._sourceLoaded && !this._paused) {
                var i;
                this.updateCacheSize(e), this.handleWrapJump(this.transform.center.lng), this._coveredTiles = {}, this.used ? this._source.tileID ? i = e.getVisibleUnwrappedCoordinates(this._source.tileID).map(function (e) {
                  return new t.OverscaledTileID(e.canonical.z, e.wrap, e.canonical.z, e.canonical.x, e.canonical.y);
                }) : (i = e.coveringTiles({
                  tileSize: this._source.tileSize,
                  minzoom: this._source.minzoom,
                  maxzoom: this._source.maxzoom,
                  roundZoom: this._source.roundZoom,
                  reparseOverscaled: this._source.reparseOverscaled
                }), this._source.hasTile && (i = i.filter(function (t) {
                  return n._source.hasTile(t);
                }))) : i = [];

                var a = e.coveringZoomLevel(this._source),
                    o = Math.max(a - r.maxOverzooming, this._source.minzoom),
                    s = Math.max(a + r.maxUnderzooming, this._source.minzoom),
                    l = this._updateRetainedTiles(i, a);

                if (It(this._source.type)) {
                  for (var c = {}, u = {}, f = 0, h = Object.keys(l); f < h.length; f += 1) {
                    var p = h[f],
                        d = l[p],
                        m = this._tiles[p];

                    if (m && !(m.fadeEndTime && m.fadeEndTime <= t.browser.now())) {
                      var g = this.findLoadedParent(d, o);
                      g && (this._addTile(g.tileID), c[g.tileID.key] = g.tileID), u[p] = d;
                    }
                  }

                  for (var v in this._retainLoadedChildren(u, a, s, l), c) {
                    l[v] || (this._coveredTiles[v] = !0, l[v] = c[v]);
                  }
                }

                for (var y in l) {
                  this._tiles[y].clearFadeHold();
                }

                for (var x = 0, b = t.keysDifference(this._tiles, l); x < b.length; x += 1) {
                  var _ = b[x],
                      w = this._tiles[_];
                  w.hasSymbolBuckets && !w.holdingForFade() ? w.setHoldDuration(this.map._fadeDuration) : w.hasSymbolBuckets && !w.symbolFadeFinished() || this._removeTile(_);
                }

                this._updateLoadedParentTileCache();
              }
            }, r.prototype.releaseSymbolFadeTiles = function () {
              for (var t in this._tiles) {
                this._tiles[t].holdingForFade() && this._removeTile(t);
              }
            }, r.prototype._updateRetainedTiles = function (t, e) {
              for (var n = {}, i = {}, a = Math.max(e - r.maxOverzooming, this._source.minzoom), o = Math.max(e + r.maxUnderzooming, this._source.minzoom), s = {}, l = 0, c = t; l < c.length; l += 1) {
                var u = c[l],
                    f = this._addTile(u);

                n[u.key] = u, f.hasData() || e < this._source.maxzoom && (s[u.key] = u);
              }

              this._retainLoadedChildren(s, e, o, n);

              for (var h = 0, p = t; h < p.length; h += 1) {
                var d = p[h],
                    m = this._tiles[d.key];

                if (!m.hasData()) {
                  if (e + 1 > this._source.maxzoom) {
                    var g = d.children(this._source.maxzoom)[0],
                        v = this.getTile(g);

                    if (v && v.hasData()) {
                      n[g.key] = g;
                      continue;
                    }
                  } else {
                    var y = d.children(this._source.maxzoom);
                    if (n[y[0].key] && n[y[1].key] && n[y[2].key] && n[y[3].key]) continue;
                  }

                  for (var x = m.wasRequested(), b = d.overscaledZ - 1; b >= a; --b) {
                    var _ = d.scaledTo(b);

                    if (i[_.key]) break;
                    if (i[_.key] = !0, !(m = this.getTile(_)) && x && (m = this._addTile(_)), m && (n[_.key] = _, x = m.wasRequested(), m.hasData())) break;
                  }
                }
              }

              return n;
            }, r.prototype._updateLoadedParentTileCache = function () {
              for (var t in this._loadedParentTiles = {}, this._tiles) {
                for (var e = [], r = void 0, n = this._tiles[t].tileID; n.overscaledZ > 0;) {
                  if (n.key in this._loadedParentTiles) {
                    r = this._loadedParentTiles[n.key];
                    break;
                  }

                  e.push(n.key);
                  var i = n.scaledTo(n.overscaledZ - 1);
                  if (r = this._getLoadedTile(i)) break;
                  n = i;
                }

                for (var a = 0, o = e; a < o.length; a += 1) {
                  var s = o[a];
                  this._loadedParentTiles[s] = r;
                }
              }
            }, r.prototype._addTile = function (e) {
              var r = this._tiles[e.key];
              if (r) return r;
              (r = this._cache.getAndRemove(e)) && (this._setTileReloadTimer(e.key, r), r.tileID = e, this._state.initializeTileState(r, this.map ? this.map.painter : null), this._cacheTimers[e.key] && (clearTimeout(this._cacheTimers[e.key]), delete this._cacheTimers[e.key], this._setTileReloadTimer(e.key, r)));
              var n = Boolean(r);
              return n || (r = new t.Tile(e, this._source.tileSize * e.overscaleFactor()), this._loadTile(r, this._tileLoaded.bind(this, r, e.key, r.state))), r ? (r.uses++, this._tiles[e.key] = r, n || this._source.fire(new t.Event("dataloading", {
                tile: r,
                coord: r.tileID,
                dataType: "source"
              })), r) : null;
            }, r.prototype._setTileReloadTimer = function (t, e) {
              var r = this;
              t in this._timers && (clearTimeout(this._timers[t]), delete this._timers[t]);
              var n = e.getExpiryTimeout();
              n && (this._timers[t] = setTimeout(function () {
                r._reloadTile(t, "expired"), delete r._timers[t];
              }, n));
            }, r.prototype._removeTile = function (t) {
              var e = this._tiles[t];
              e && (e.uses--, delete this._tiles[t], this._timers[t] && (clearTimeout(this._timers[t]), delete this._timers[t]), e.uses > 0 || (e.hasData() && "reloading" !== e.state ? this._cache.add(e.tileID, e, e.getExpiryTimeout()) : (e.aborted = !0, this._abortTile(e), this._unloadTile(e))));
            }, r.prototype.clearTiles = function () {
              for (var t in this._shouldReloadOnResume = !1, this._paused = !1, this._tiles) {
                this._removeTile(t);
              }

              this._cache.reset();
            }, r.prototype.tilesIn = function (e, r, n) {
              var i = this,
                  a = [],
                  o = this.transform;
              if (!o) return a;

              for (var s = n ? o.getCameraQueryGeometry(e) : e, l = e.map(function (t) {
                return o.pointCoordinate(t);
              }), c = s.map(function (t) {
                return o.pointCoordinate(t);
              }), u = this.getIds(), f = 1 / 0, h = 1 / 0, p = -1 / 0, d = -1 / 0, m = 0, g = c; m < g.length; m += 1) {
                var v = g[m];
                f = Math.min(f, v.x), h = Math.min(h, v.y), p = Math.max(p, v.x), d = Math.max(d, v.y);
              }

              for (var y = function y(e) {
                var n = i._tiles[u[e]];

                if (!n.holdingForFade()) {
                  var s = n.tileID,
                      m = Math.pow(2, o.zoom - n.tileID.overscaledZ),
                      g = r * n.queryPadding * t.EXTENT / n.tileSize / m,
                      v = [s.getTilePoint(new t.MercatorCoordinate(f, h)), s.getTilePoint(new t.MercatorCoordinate(p, d))];

                  if (v[0].x - g < t.EXTENT && v[0].y - g < t.EXTENT && v[1].x + g >= 0 && v[1].y + g >= 0) {
                    var y = l.map(function (t) {
                      return s.getTilePoint(t);
                    }),
                        x = c.map(function (t) {
                      return s.getTilePoint(t);
                    });
                    a.push({
                      tile: n,
                      tileID: s,
                      queryGeometry: y,
                      cameraQueryGeometry: x,
                      scale: m
                    });
                  }
                }
              }, x = 0; x < u.length; x++) {
                y(x);
              }

              return a;
            }, r.prototype.getVisibleCoordinates = function (t) {
              for (var e = this, r = this.getRenderableIds(t).map(function (t) {
                return e._tiles[t].tileID;
              }), n = 0, i = r; n < i.length; n += 1) {
                var a = i[n];
                a.posMatrix = this.transform.calculatePosMatrix(a.toUnwrapped());
              }

              return r;
            }, r.prototype.hasTransition = function () {
              if (this._source.hasTransition()) return !0;
              if (It(this._source.type)) for (var e in this._tiles) {
                var r = this._tiles[e];
                if (void 0 !== r.fadeEndTime && r.fadeEndTime >= t.browser.now()) return !0;
              }
              return !1;
            }, r.prototype.setFeatureState = function (t, e, r) {
              t = t || "_geojsonTileLayer", this._state.updateState(t, e, r);
            }, r.prototype.removeFeatureState = function (t, e, r) {
              t = t || "_geojsonTileLayer", this._state.removeFeatureState(t, e, r);
            }, r.prototype.getFeatureState = function (t, e) {
              return t = t || "_geojsonTileLayer", this._state.getState(t, e);
            }, r.prototype.setDependencies = function (t, e, r) {
              var n = this._tiles[t];
              n && n.setDependencies(e, r);
            }, r.prototype.reloadTilesForDependencies = function (t, e) {
              for (var r in this._tiles) {
                this._tiles[r].hasDependency(t, e) && this._reloadTile(r, "reloading");
              }

              this._cache.filter(function (r) {
                return !r.hasDependency(t, e);
              });
            }, r;
          }(t.Evented);

          function Pt(t, e) {
            var r = Math.abs(2 * t.wrap) - +(t.wrap < 0),
                n = Math.abs(2 * e.wrap) - +(e.wrap < 0);
            return t.overscaledZ - e.overscaledZ || n - r || e.canonical.y - t.canonical.y || e.canonical.x - t.canonical.x;
          }

          function It(t) {
            return "raster" === t || "image" === t || "video" === t;
          }

          function Ot() {
            return new t.window.Worker(Zi.workerUrl);
          }

          Ct.maxOverzooming = 10, Ct.maxUnderzooming = 3;

          var zt = "mapboxgl_preloaded_worker_pool",
              Dt = function Dt() {
            this.active = {};
          };

          Dt.prototype.acquire = function (t) {
            if (!this.workers) for (this.workers = []; this.workers.length < Dt.workerCount;) {
              this.workers.push(new Ot());
            }
            return this.active[t] = !0, this.workers.slice();
          }, Dt.prototype.release = function (t) {
            delete this.active[t], 0 === this.numActive() && (this.workers.forEach(function (t) {
              t.terminate();
            }), this.workers = null);
          }, Dt.prototype.isPreloaded = function () {
            return !!this.active[zt];
          }, Dt.prototype.numActive = function () {
            return Object.keys(this.active).length;
          };
          var Rt,
              Ft = Math.floor(t.browser.hardwareConcurrency / 2);

          function Bt() {
            return Rt || (Rt = new Dt()), Rt;
          }

          function Nt(e, r) {
            var n = {};

            for (var i in e) {
              "ref" !== i && (n[i] = e[i]);
            }

            return t.refProperties.forEach(function (t) {
              t in r && (n[t] = r[t]);
            }), n;
          }

          function jt(t) {
            t = t.slice();

            for (var e = Object.create(null), r = 0; r < t.length; r++) {
              e[t[r].id] = t[r];
            }

            for (var n = 0; n < t.length; n++) {
              "ref" in t[n] && (t[n] = Nt(t[n], e[t[n].ref]));
            }

            return t;
          }

          Dt.workerCount = Math.max(Math.min(Ft, 6), 1);
          var Ut = {
            setStyle: "setStyle",
            addLayer: "addLayer",
            removeLayer: "removeLayer",
            setPaintProperty: "setPaintProperty",
            setLayoutProperty: "setLayoutProperty",
            setFilter: "setFilter",
            addSource: "addSource",
            removeSource: "removeSource",
            setGeoJSONSourceData: "setGeoJSONSourceData",
            setLayerZoomRange: "setLayerZoomRange",
            setLayerProperty: "setLayerProperty",
            setCenter: "setCenter",
            setZoom: "setZoom",
            setBearing: "setBearing",
            setPitch: "setPitch",
            setSprite: "setSprite",
            setGlyphs: "setGlyphs",
            setTransition: "setTransition",
            setLight: "setLight"
          };

          function Vt(t, e, r) {
            r.push({
              command: Ut.addSource,
              args: [t, e[t]]
            });
          }

          function qt(t, e, r) {
            e.push({
              command: Ut.removeSource,
              args: [t]
            }), r[t] = !0;
          }

          function Ht(t, e, r, n) {
            qt(t, r, n), Vt(t, e, r);
          }

          function Gt(e, r, n) {
            var i;

            for (i in e[n]) {
              if (e[n].hasOwnProperty(i) && "data" !== i && !t.deepEqual(e[n][i], r[n][i])) return !1;
            }

            for (i in r[n]) {
              if (r[n].hasOwnProperty(i) && "data" !== i && !t.deepEqual(e[n][i], r[n][i])) return !1;
            }

            return !0;
          }

          function Yt(e, r, n, i, a, o) {
            var s;

            for (s in r = r || {}, e = e || {}) {
              e.hasOwnProperty(s) && (t.deepEqual(e[s], r[s]) || n.push({
                command: o,
                args: [i, s, r[s], a]
              }));
            }

            for (s in r) {
              r.hasOwnProperty(s) && !e.hasOwnProperty(s) && (t.deepEqual(e[s], r[s]) || n.push({
                command: o,
                args: [i, s, r[s], a]
              }));
            }
          }

          function Wt(t) {
            return t.id;
          }

          function Xt(t, e) {
            return t[e.id] = e, t;
          }

          function Zt(e, r) {
            if (!e) return [{
              command: Ut.setStyle,
              args: [r]
            }];
            var n = [];

            try {
              if (!t.deepEqual(e.version, r.version)) return [{
                command: Ut.setStyle,
                args: [r]
              }];
              t.deepEqual(e.center, r.center) || n.push({
                command: Ut.setCenter,
                args: [r.center]
              }), t.deepEqual(e.zoom, r.zoom) || n.push({
                command: Ut.setZoom,
                args: [r.zoom]
              }), t.deepEqual(e.bearing, r.bearing) || n.push({
                command: Ut.setBearing,
                args: [r.bearing]
              }), t.deepEqual(e.pitch, r.pitch) || n.push({
                command: Ut.setPitch,
                args: [r.pitch]
              }), t.deepEqual(e.sprite, r.sprite) || n.push({
                command: Ut.setSprite,
                args: [r.sprite]
              }), t.deepEqual(e.glyphs, r.glyphs) || n.push({
                command: Ut.setGlyphs,
                args: [r.glyphs]
              }), t.deepEqual(e.transition, r.transition) || n.push({
                command: Ut.setTransition,
                args: [r.transition]
              }), t.deepEqual(e.light, r.light) || n.push({
                command: Ut.setLight,
                args: [r.light]
              });
              var i = {},
                  a = [];
              !function (e, r, n, i) {
                var a;

                for (a in r = r || {}, e = e || {}) {
                  e.hasOwnProperty(a) && (r.hasOwnProperty(a) || qt(a, n, i));
                }

                for (a in r) {
                  r.hasOwnProperty(a) && (e.hasOwnProperty(a) ? t.deepEqual(e[a], r[a]) || ("geojson" === e[a].type && "geojson" === r[a].type && Gt(e, r, a) ? n.push({
                    command: Ut.setGeoJSONSourceData,
                    args: [a, r[a].data]
                  }) : Ht(a, r, n, i)) : Vt(a, r, n));
                }
              }(e.sources, r.sources, a, i);
              var o = [];
              e.layers && e.layers.forEach(function (t) {
                i[t.source] ? n.push({
                  command: Ut.removeLayer,
                  args: [t.id]
                }) : o.push(t);
              }), n = n.concat(a), function (e, r, n) {
                r = r || [];
                var i,
                    a,
                    o,
                    s,
                    l,
                    c,
                    u,
                    f = (e = e || []).map(Wt),
                    h = r.map(Wt),
                    p = e.reduce(Xt, {}),
                    d = r.reduce(Xt, {}),
                    m = f.slice(),
                    g = Object.create(null);

                for (i = 0, a = 0; i < f.length; i++) {
                  o = f[i], d.hasOwnProperty(o) ? a++ : (n.push({
                    command: Ut.removeLayer,
                    args: [o]
                  }), m.splice(m.indexOf(o, a), 1));
                }

                for (i = 0, a = 0; i < h.length; i++) {
                  o = h[h.length - 1 - i], m[m.length - 1 - i] !== o && (p.hasOwnProperty(o) ? (n.push({
                    command: Ut.removeLayer,
                    args: [o]
                  }), m.splice(m.lastIndexOf(o, m.length - a), 1)) : a++, c = m[m.length - i], n.push({
                    command: Ut.addLayer,
                    args: [d[o], c]
                  }), m.splice(m.length - i, 0, o), g[o] = !0);
                }

                for (i = 0; i < h.length; i++) {
                  if (s = p[o = h[i]], l = d[o], !g[o] && !t.deepEqual(s, l)) if (t.deepEqual(s.source, l.source) && t.deepEqual(s["source-layer"], l["source-layer"]) && t.deepEqual(s.type, l.type)) {
                    for (u in Yt(s.layout, l.layout, n, o, null, Ut.setLayoutProperty), Yt(s.paint, l.paint, n, o, null, Ut.setPaintProperty), t.deepEqual(s.filter, l.filter) || n.push({
                      command: Ut.setFilter,
                      args: [o, l.filter]
                    }), t.deepEqual(s.minzoom, l.minzoom) && t.deepEqual(s.maxzoom, l.maxzoom) || n.push({
                      command: Ut.setLayerZoomRange,
                      args: [o, l.minzoom, l.maxzoom]
                    }), s) {
                      s.hasOwnProperty(u) && "layout" !== u && "paint" !== u && "filter" !== u && "metadata" !== u && "minzoom" !== u && "maxzoom" !== u && (0 === u.indexOf("paint.") ? Yt(s[u], l[u], n, o, u.slice(6), Ut.setPaintProperty) : t.deepEqual(s[u], l[u]) || n.push({
                        command: Ut.setLayerProperty,
                        args: [o, u, l[u]]
                      }));
                    }

                    for (u in l) {
                      l.hasOwnProperty(u) && !s.hasOwnProperty(u) && "layout" !== u && "paint" !== u && "filter" !== u && "metadata" !== u && "minzoom" !== u && "maxzoom" !== u && (0 === u.indexOf("paint.") ? Yt(s[u], l[u], n, o, u.slice(6), Ut.setPaintProperty) : t.deepEqual(s[u], l[u]) || n.push({
                        command: Ut.setLayerProperty,
                        args: [o, u, l[u]]
                      }));
                    }
                  } else n.push({
                    command: Ut.removeLayer,
                    args: [o]
                  }), c = m[m.lastIndexOf(o) + 1], n.push({
                    command: Ut.addLayer,
                    args: [l, c]
                  });
                }
              }(o, r.layers, n);
            } catch (t) {
              console.warn("Unable to compute style diff:", t), n = [{
                command: Ut.setStyle,
                args: [r]
              }];
            }

            return n;
          }

          var Jt = function Jt(t, e) {
            this.reset(t, e);
          };

          Jt.prototype.reset = function (t, e) {
            this.points = t || [], this._distances = [0];

            for (var r = 1; r < this.points.length; r++) {
              this._distances[r] = this._distances[r - 1] + this.points[r].dist(this.points[r - 1]);
            }

            this.length = this._distances[this._distances.length - 1], this.padding = Math.min(e || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
          }, Jt.prototype.lerp = function (e) {
            if (1 === this.points.length) return this.points[0];
            e = t.clamp(e, 0, 1);

            for (var r = 1, n = this._distances[r], i = e * this.paddedLength + this.padding; n < i && r < this._distances.length;) {
              n = this._distances[++r];
            }

            var a = r - 1,
                o = this._distances[a],
                s = n - o,
                l = s > 0 ? (i - o) / s : 0;
            return this.points[a].mult(1 - l).add(this.points[r].mult(l));
          };

          var Kt = function Kt(t, e, r) {
            var n = this.boxCells = [],
                i = this.circleCells = [];
            this.xCellCount = Math.ceil(t / r), this.yCellCount = Math.ceil(e / r);

            for (var a = 0; a < this.xCellCount * this.yCellCount; a++) {
              n.push([]), i.push([]);
            }

            this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = t, this.height = e, this.xScale = this.xCellCount / t, this.yScale = this.yCellCount / e, this.boxUid = 0, this.circleUid = 0;
          };

          function Qt(e, r, n, i, a) {
            var o = t.create();
            return r ? (t.scale(o, o, [1 / a, 1 / a, 1]), n || t.rotateZ(o, o, i.angle)) : t.multiply(o, i.labelPlaneMatrix, e), o;
          }

          function $t(e, r, n, i, a) {
            if (r) {
              var o = t.clone(e);
              return t.scale(o, o, [a, a, 1]), n || t.rotateZ(o, o, -i.angle), o;
            }

            return i.glCoordMatrix;
          }

          function te(e, r) {
            var n = [e.x, e.y, 0, 1];
            fe(n, n, r);
            var i = n[3];
            return {
              point: new t.Point(n[0] / i, n[1] / i),
              signedDistanceFromCamera: i
            };
          }

          function ee(t, e) {
            return .5 + t / e * .5;
          }

          function re(t, e) {
            var r = t[0] / t[3],
                n = t[1] / t[3];
            return r >= -e[0] && r <= e[0] && n >= -e[1] && n <= e[1];
          }

          function ne(e, r, n, i, a, o, s, l) {
            var c = i ? e.textSizeData : e.iconSizeData,
                u = t.evaluateSizeForZoom(c, n.transform.zoom),
                f = [256 / n.width * 2 + 1, 256 / n.height * 2 + 1],
                h = i ? e.text.dynamicLayoutVertexArray : e.icon.dynamicLayoutVertexArray;
            h.clear();

            for (var p = e.lineVertexArray, d = i ? e.text.placedSymbolArray : e.icon.placedSymbolArray, m = n.transform.width / n.transform.height, g = !1, v = 0; v < d.length; v++) {
              var y = d.get(v);
              if (y.hidden || y.writingMode === t.WritingMode.vertical && !g) ue(y.numGlyphs, h);else {
                g = !1;
                var x = [y.anchorX, y.anchorY, 0, 1];

                if (t.transformMat4(x, x, r), re(x, f)) {
                  var b = x[3],
                      _ = ee(n.transform.cameraToCenterDistance, b),
                      w = t.evaluateSizeForFeature(c, u, y),
                      T = s ? w / _ : w * _,
                      k = new t.Point(y.anchorX, y.anchorY),
                      M = te(k, a).point,
                      A = {},
                      S = oe(y, T, !1, l, r, a, o, e.glyphOffsetArray, p, h, M, k, A, m);

                  g = S.useVertical, (S.notEnoughRoom || g || S.needsFlipping && oe(y, T, !0, l, r, a, o, e.glyphOffsetArray, p, h, M, k, A, m).notEnoughRoom) && ue(y.numGlyphs, h);
                } else ue(y.numGlyphs, h);
              }
            }

            i ? e.text.dynamicLayoutVertexBuffer.updateData(h) : e.icon.dynamicLayoutVertexBuffer.updateData(h);
          }

          function ie(t, e, r, n, i, a, o, s, l, c, u) {
            var f = s.glyphStartIndex + s.numGlyphs,
                h = s.lineStartIndex,
                p = s.lineStartIndex + s.lineLength,
                d = e.getoffsetX(s.glyphStartIndex),
                m = e.getoffsetX(f - 1),
                g = le(t * d, r, n, i, a, o, s.segment, h, p, l, c, u);
            if (!g) return null;
            var v = le(t * m, r, n, i, a, o, s.segment, h, p, l, c, u);
            return v ? {
              first: g,
              last: v
            } : null;
          }

          function ae(e, r, n, i) {
            if (e === t.WritingMode.horizontal && Math.abs(n.y - r.y) > Math.abs(n.x - r.x) * i) return {
              useVertical: !0
            };
            return (e === t.WritingMode.vertical ? r.y < n.y : r.x > n.x) ? {
              needsFlipping: !0
            } : null;
          }

          function oe(e, r, n, i, a, o, s, l, c, u, f, h, p, d) {
            var m,
                g = r / 24,
                v = e.lineOffsetX * g,
                y = e.lineOffsetY * g;

            if (e.numGlyphs > 1) {
              var x = e.glyphStartIndex + e.numGlyphs,
                  b = e.lineStartIndex,
                  _ = e.lineStartIndex + e.lineLength,
                  w = ie(g, l, v, y, n, f, h, e, c, o, p);

              if (!w) return {
                notEnoughRoom: !0
              };
              var T = te(w.first.point, s).point,
                  k = te(w.last.point, s).point;

              if (i && !n) {
                var M = ae(e.writingMode, T, k, d);
                if (M) return M;
              }

              m = [w.first];

              for (var A = e.glyphStartIndex + 1; A < x - 1; A++) {
                m.push(le(g * l.getoffsetX(A), v, y, n, f, h, e.segment, b, _, c, o, p));
              }

              m.push(w.last);
            } else {
              if (i && !n) {
                var S = te(h, a).point,
                    E = e.lineStartIndex + e.segment + 1,
                    L = new t.Point(c.getx(E), c.gety(E)),
                    C = te(L, a),
                    P = C.signedDistanceFromCamera > 0 ? C.point : se(h, L, S, 1, a),
                    I = ae(e.writingMode, S, P, d);
                if (I) return I;
              }

              var O = le(g * l.getoffsetX(e.glyphStartIndex), v, y, n, f, h, e.segment, e.lineStartIndex, e.lineStartIndex + e.lineLength, c, o, p);
              if (!O) return {
                notEnoughRoom: !0
              };
              m = [O];
            }

            for (var z = 0, D = m; z < D.length; z += 1) {
              var R = D[z];
              t.addDynamicAttributes(u, R.point, R.angle);
            }

            return {};
          }

          function se(t, e, r, n, i) {
            var a = te(t.add(t.sub(e)._unit()), i).point,
                o = r.sub(a);
            return r.add(o._mult(n / o.mag()));
          }

          function le(e, r, n, i, a, o, s, l, c, u, f, h) {
            var p = i ? e - r : e + r,
                d = p > 0 ? 1 : -1,
                m = 0;
            i && (d *= -1, m = Math.PI), d < 0 && (m += Math.PI);

            for (var g = d > 0 ? l + s : l + s + 1, v = a, y = a, x = 0, b = 0, _ = Math.abs(p), w = []; x + b <= _;) {
              if ((g += d) < l || g >= c) return null;

              if (y = v, w.push(v), void 0 === (v = h[g])) {
                var T = new t.Point(u.getx(g), u.gety(g)),
                    k = te(T, f);
                if (k.signedDistanceFromCamera > 0) v = h[g] = k.point;else {
                  var M = g - d;
                  v = se(0 === x ? o : new t.Point(u.getx(M), u.gety(M)), T, y, _ - x + 1, f);
                }
              }

              x += b, b = y.dist(v);
            }

            var A = (_ - x) / b,
                S = v.sub(y),
                E = S.mult(A)._add(y);

            E._add(S._unit()._perp()._mult(n * d));

            var L = m + Math.atan2(v.y - y.y, v.x - y.x);
            return w.push(E), {
              point: E,
              angle: L,
              path: w
            };
          }

          Kt.prototype.keysLength = function () {
            return this.boxKeys.length + this.circleKeys.length;
          }, Kt.prototype.insert = function (t, e, r, n, i) {
            this._forEachCell(e, r, n, i, this._insertBoxCell, this.boxUid++), this.boxKeys.push(t), this.bboxes.push(e), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
          }, Kt.prototype.insertCircle = function (t, e, r, n) {
            this._forEachCell(e - n, r - n, e + n, r + n, this._insertCircleCell, this.circleUid++), this.circleKeys.push(t), this.circles.push(e), this.circles.push(r), this.circles.push(n);
          }, Kt.prototype._insertBoxCell = function (t, e, r, n, i, a) {
            this.boxCells[i].push(a);
          }, Kt.prototype._insertCircleCell = function (t, e, r, n, i, a) {
            this.circleCells[i].push(a);
          }, Kt.prototype._query = function (t, e, r, n, i, a) {
            if (r < 0 || t > this.width || n < 0 || e > this.height) return !i && [];
            var o = [];

            if (t <= 0 && e <= 0 && this.width <= r && this.height <= n) {
              if (i) return !0;

              for (var s = 0; s < this.boxKeys.length; s++) {
                o.push({
                  key: this.boxKeys[s],
                  x1: this.bboxes[4 * s],
                  y1: this.bboxes[4 * s + 1],
                  x2: this.bboxes[4 * s + 2],
                  y2: this.bboxes[4 * s + 3]
                });
              }

              for (var l = 0; l < this.circleKeys.length; l++) {
                var c = this.circles[3 * l],
                    u = this.circles[3 * l + 1],
                    f = this.circles[3 * l + 2];
                o.push({
                  key: this.circleKeys[l],
                  x1: c - f,
                  y1: u - f,
                  x2: c + f,
                  y2: u + f
                });
              }

              return a ? o.filter(a) : o;
            }

            var h = {
              hitTest: i,
              seenUids: {
                box: {},
                circle: {}
              }
            };
            return this._forEachCell(t, e, r, n, this._queryCell, o, h, a), i ? o.length > 0 : o;
          }, Kt.prototype._queryCircle = function (t, e, r, n, i) {
            var a = t - r,
                o = t + r,
                s = e - r,
                l = e + r;
            if (o < 0 || a > this.width || l < 0 || s > this.height) return !n && [];
            var c = [],
                u = {
              hitTest: n,
              circle: {
                x: t,
                y: e,
                radius: r
              },
              seenUids: {
                box: {},
                circle: {}
              }
            };
            return this._forEachCell(a, s, o, l, this._queryCellCircle, c, u, i), n ? c.length > 0 : c;
          }, Kt.prototype.query = function (t, e, r, n, i) {
            return this._query(t, e, r, n, !1, i);
          }, Kt.prototype.hitTest = function (t, e, r, n, i) {
            return this._query(t, e, r, n, !0, i);
          }, Kt.prototype.hitTestCircle = function (t, e, r, n) {
            return this._queryCircle(t, e, r, !0, n);
          }, Kt.prototype._queryCell = function (t, e, r, n, i, a, o, s) {
            var l = o.seenUids,
                c = this.boxCells[i];
            if (null !== c) for (var u = this.bboxes, f = 0, h = c; f < h.length; f += 1) {
              var p = h[f];

              if (!l.box[p]) {
                l.box[p] = !0;
                var d = 4 * p;

                if (t <= u[d + 2] && e <= u[d + 3] && r >= u[d + 0] && n >= u[d + 1] && (!s || s(this.boxKeys[p]))) {
                  if (o.hitTest) return a.push(!0), !0;
                  a.push({
                    key: this.boxKeys[p],
                    x1: u[d],
                    y1: u[d + 1],
                    x2: u[d + 2],
                    y2: u[d + 3]
                  });
                }
              }
            }
            var m = this.circleCells[i];
            if (null !== m) for (var g = this.circles, v = 0, y = m; v < y.length; v += 1) {
              var x = y[v];

              if (!l.circle[x]) {
                l.circle[x] = !0;
                var b = 3 * x;

                if (this._circleAndRectCollide(g[b], g[b + 1], g[b + 2], t, e, r, n) && (!s || s(this.circleKeys[x]))) {
                  if (o.hitTest) return a.push(!0), !0;
                  var _ = g[b],
                      w = g[b + 1],
                      T = g[b + 2];
                  a.push({
                    key: this.circleKeys[x],
                    x1: _ - T,
                    y1: w - T,
                    x2: _ + T,
                    y2: w + T
                  });
                }
              }
            }
          }, Kt.prototype._queryCellCircle = function (t, e, r, n, i, a, o, s) {
            var l = o.circle,
                c = o.seenUids,
                u = this.boxCells[i];
            if (null !== u) for (var f = this.bboxes, h = 0, p = u; h < p.length; h += 1) {
              var d = p[h];

              if (!c.box[d]) {
                c.box[d] = !0;
                var m = 4 * d;
                if (this._circleAndRectCollide(l.x, l.y, l.radius, f[m + 0], f[m + 1], f[m + 2], f[m + 3]) && (!s || s(this.boxKeys[d]))) return a.push(!0), !0;
              }
            }
            var g = this.circleCells[i];
            if (null !== g) for (var v = this.circles, y = 0, x = g; y < x.length; y += 1) {
              var b = x[y];

              if (!c.circle[b]) {
                c.circle[b] = !0;

                var _ = 3 * b;

                if (this._circlesCollide(v[_], v[_ + 1], v[_ + 2], l.x, l.y, l.radius) && (!s || s(this.circleKeys[b]))) return a.push(!0), !0;
              }
            }
          }, Kt.prototype._forEachCell = function (t, e, r, n, i, a, o, s) {
            for (var l = this._convertToXCellCoord(t), c = this._convertToYCellCoord(e), u = this._convertToXCellCoord(r), f = this._convertToYCellCoord(n), h = l; h <= u; h++) {
              for (var p = c; p <= f; p++) {
                var d = this.xCellCount * p + h;
                if (i.call(this, t, e, r, n, d, a, o, s)) return;
              }
            }
          }, Kt.prototype._convertToXCellCoord = function (t) {
            return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(t * this.xScale)));
          }, Kt.prototype._convertToYCellCoord = function (t) {
            return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(t * this.yScale)));
          }, Kt.prototype._circlesCollide = function (t, e, r, n, i, a) {
            var o = n - t,
                s = i - e,
                l = r + a;
            return l * l > o * o + s * s;
          }, Kt.prototype._circleAndRectCollide = function (t, e, r, n, i, a, o) {
            var s = (a - n) / 2,
                l = Math.abs(t - (n + s));
            if (l > s + r) return !1;
            var c = (o - i) / 2,
                u = Math.abs(e - (i + c));
            if (u > c + r) return !1;
            if (l <= s || u <= c) return !0;
            var f = l - s,
                h = u - c;
            return f * f + h * h <= r * r;
          };
          var ce = new Float32Array([-1 / 0, -1 / 0, 0, -1 / 0, -1 / 0, 0, -1 / 0, -1 / 0, 0, -1 / 0, -1 / 0, 0]);

          function ue(t, e) {
            for (var r = 0; r < t; r++) {
              var n = e.length;
              e.resize(n + 4), e.float32.set(ce, 3 * n);
            }
          }

          function fe(t, e, r) {
            var n = e[0],
                i = e[1];
            return t[0] = r[0] * n + r[4] * i + r[12], t[1] = r[1] * n + r[5] * i + r[13], t[3] = r[3] * n + r[7] * i + r[15], t;
          }

          var he = function he(t, e, r) {
            void 0 === e && (e = new Kt(t.width + 200, t.height + 200, 25)), void 0 === r && (r = new Kt(t.width + 200, t.height + 200, 25)), this.transform = t, this.grid = e, this.ignoredGrid = r, this.pitchfactor = Math.cos(t._pitch) * t.cameraToCenterDistance, this.screenRightBoundary = t.width + 100, this.screenBottomBoundary = t.height + 100, this.gridRightBoundary = t.width + 200, this.gridBottomBoundary = t.height + 200;
          };

          function pe(e, r, n) {
            return r * (t.EXTENT / (e.tileSize * Math.pow(2, n - e.tileID.overscaledZ)));
          }

          he.prototype.placeCollisionBox = function (t, e, r, n, i) {
            var a = this.projectAndGetPerspectiveRatio(n, t.anchorPointX, t.anchorPointY),
                o = r * a.perspectiveRatio,
                s = t.x1 * o + a.point.x,
                l = t.y1 * o + a.point.y,
                c = t.x2 * o + a.point.x,
                u = t.y2 * o + a.point.y;
            return !this.isInsideGrid(s, l, c, u) || !e && this.grid.hitTest(s, l, c, u, i) ? {
              box: [],
              offscreen: !1
            } : {
              box: [s, l, c, u],
              offscreen: this.isOffscreen(s, l, c, u)
            };
          }, he.prototype.placeCollisionCircles = function (e, r, n, i, a, o, s, l, c, u, f, h, p) {
            var d = [],
                m = new t.Point(r.anchorX, r.anchorY),
                g = te(m, o),
                v = ee(this.transform.cameraToCenterDistance, g.signedDistanceFromCamera),
                y = (u ? a / v : a * v) / t.ONE_EM,
                x = te(m, s).point,
                b = ie(y, i, r.lineOffsetX * y, r.lineOffsetY * y, !1, x, m, r, n, s, {}),
                _ = !1,
                w = !1,
                T = !0;

            if (b) {
              for (var k = .5 * h * v + p, M = new t.Point(-100, -100), A = new t.Point(this.screenRightBoundary, this.screenBottomBoundary), S = new Jt(), E = b.first, L = b.last, C = [], P = E.path.length - 1; P >= 1; P--) {
                C.push(E.path[P]);
              }

              for (var I = 1; I < L.path.length; I++) {
                C.push(L.path[I]);
              }

              var O = 2.5 * k;

              if (l) {
                var z = C.map(function (t) {
                  return te(t, l);
                });
                C = z.some(function (t) {
                  return t.signedDistanceFromCamera <= 0;
                }) ? [] : z.map(function (t) {
                  return t.point;
                });
              }

              var D = [];

              if (C.length > 0) {
                for (var R = C[0].clone(), F = C[0].clone(), B = 1; B < C.length; B++) {
                  R.x = Math.min(R.x, C[B].x), R.y = Math.min(R.y, C[B].y), F.x = Math.max(F.x, C[B].x), F.y = Math.max(F.y, C[B].y);
                }

                D = R.x >= M.x && F.x <= A.x && R.y >= M.y && F.y <= A.y ? [C] : F.x < M.x || R.x > A.x || F.y < M.y || R.y > A.y ? [] : t.clipLine([C], M.x, M.y, A.x, A.y);
              }

              for (var N = 0, j = D; N < j.length; N += 1) {
                var U = j[N];
                S.reset(U, .25 * k);
                var V = 0;
                V = S.length <= .5 * k ? 1 : Math.ceil(S.paddedLength / O) + 1;

                for (var q = 0; q < V; q++) {
                  var H = q / Math.max(V - 1, 1),
                      G = S.lerp(H),
                      Y = G.x + 100,
                      W = G.y + 100;
                  d.push(Y, W, k, 0);
                  var X = Y - k,
                      Z = W - k,
                      J = Y + k,
                      K = W + k;
                  if (T = T && this.isOffscreen(X, Z, J, K), w = w || this.isInsideGrid(X, Z, J, K), !e && this.grid.hitTestCircle(Y, W, k, f) && (_ = !0, !c)) return {
                    circles: [],
                    offscreen: !1,
                    collisionDetected: _
                  };
                }
              }
            }

            return {
              circles: !c && _ || !w ? [] : d,
              offscreen: T,
              collisionDetected: _
            };
          }, he.prototype.queryRenderedSymbols = function (e) {
            if (0 === e.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};

            for (var r = [], n = 1 / 0, i = 1 / 0, a = -1 / 0, o = -1 / 0, s = 0, l = e; s < l.length; s += 1) {
              var c = l[s],
                  u = new t.Point(c.x + 100, c.y + 100);
              n = Math.min(n, u.x), i = Math.min(i, u.y), a = Math.max(a, u.x), o = Math.max(o, u.y), r.push(u);
            }

            for (var f = {}, h = {}, p = 0, d = this.grid.query(n, i, a, o).concat(this.ignoredGrid.query(n, i, a, o)); p < d.length; p += 1) {
              var m = d[p],
                  g = m.key;

              if (void 0 === f[g.bucketInstanceId] && (f[g.bucketInstanceId] = {}), !f[g.bucketInstanceId][g.featureIndex]) {
                var v = [new t.Point(m.x1, m.y1), new t.Point(m.x2, m.y1), new t.Point(m.x2, m.y2), new t.Point(m.x1, m.y2)];
                t.polygonIntersectsPolygon(r, v) && (f[g.bucketInstanceId][g.featureIndex] = !0, void 0 === h[g.bucketInstanceId] && (h[g.bucketInstanceId] = []), h[g.bucketInstanceId].push(g.featureIndex));
              }
            }

            return h;
          }, he.prototype.insertCollisionBox = function (t, e, r, n, i) {
            var a = {
              bucketInstanceId: r,
              featureIndex: n,
              collisionGroupID: i
            };
            (e ? this.ignoredGrid : this.grid).insert(a, t[0], t[1], t[2], t[3]);
          }, he.prototype.insertCollisionCircles = function (t, e, r, n, i) {
            for (var a = e ? this.ignoredGrid : this.grid, o = {
              bucketInstanceId: r,
              featureIndex: n,
              collisionGroupID: i
            }, s = 0; s < t.length; s += 4) {
              a.insertCircle(o, t[s], t[s + 1], t[s + 2]);
            }
          }, he.prototype.projectAndGetPerspectiveRatio = function (e, r, n) {
            var i = [r, n, 0, 1];
            return fe(i, i, e), {
              point: new t.Point((i[0] / i[3] + 1) / 2 * this.transform.width + 100, (-i[1] / i[3] + 1) / 2 * this.transform.height + 100),
              perspectiveRatio: .5 + this.transform.cameraToCenterDistance / i[3] * .5
            };
          }, he.prototype.isOffscreen = function (t, e, r, n) {
            return r < 100 || t >= this.screenRightBoundary || n < 100 || e > this.screenBottomBoundary;
          }, he.prototype.isInsideGrid = function (t, e, r, n) {
            return r >= 0 && t < this.gridRightBoundary && n >= 0 && e < this.gridBottomBoundary;
          }, he.prototype.getViewportMatrix = function () {
            var e = t.identity([]);
            return t.translate(e, e, [-100, -100, 0]), e;
          };

          var de = function de(t, e, r, n) {
            this.opacity = t ? Math.max(0, Math.min(1, t.opacity + (t.placed ? e : -e))) : n && r ? 1 : 0, this.placed = r;
          };

          de.prototype.isHidden = function () {
            return 0 === this.opacity && !this.placed;
          };

          var me = function me(t, e, r, n, i) {
            this.text = new de(t ? t.text : null, e, r, i), this.icon = new de(t ? t.icon : null, e, n, i);
          };

          me.prototype.isHidden = function () {
            return this.text.isHidden() && this.icon.isHidden();
          };

          var ge = function ge(t, e, r) {
            this.text = t, this.icon = e, this.skipFade = r;
          },
              ve = function ve() {
            this.invProjMatrix = t.create(), this.viewportMatrix = t.create(), this.circles = [];
          },
              ye = function ye(t, e, r, n, i) {
            this.bucketInstanceId = t, this.featureIndex = e, this.sourceLayerIndex = r, this.bucketIndex = n, this.tileID = i;
          },
              xe = function xe(t) {
            this.crossSourceCollisions = t, this.maxGroupID = 0, this.collisionGroups = {};
          };

          function be(e, r, n, i, a) {
            var o = t.getAnchorAlignment(e),
                s = -(o.horizontalAlign - .5) * r,
                l = -(o.verticalAlign - .5) * n,
                c = t.evaluateVariableOffset(e, i);
            return new t.Point(s + c[0] * a, l + c[1] * a);
          }

          function _e(e, r, n, i, a, o) {
            var s = e.x1,
                l = e.x2,
                c = e.y1,
                u = e.y2,
                f = e.anchorPointX,
                h = e.anchorPointY,
                p = new t.Point(r, n);
            return i && p._rotate(a ? o : -o), {
              x1: s + p.x,
              y1: c + p.y,
              x2: l + p.x,
              y2: u + p.y,
              anchorPointX: f,
              anchorPointY: h
            };
          }

          xe.prototype.get = function (t) {
            if (this.crossSourceCollisions) return {
              ID: 0,
              predicate: null
            };

            if (!this.collisionGroups[t]) {
              var e = ++this.maxGroupID;
              this.collisionGroups[t] = {
                ID: e,
                predicate: function predicate(t) {
                  return t.collisionGroupID === e;
                }
              };
            }

            return this.collisionGroups[t];
          };

          var we = function we(t, e, r, n) {
            this.transform = t.clone(), this.collisionIndex = new he(this.transform), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = e, this.retainedQueryData = {}, this.collisionGroups = new xe(r), this.collisionCircleArrays = {}, this.prevPlacement = n, n && (n.prevPlacement = void 0), this.placedOrientations = {};
          };

          function Te(t, e, r, n, i) {
            t.emplaceBack(e ? 1 : 0, r ? 1 : 0, n || 0, i || 0), t.emplaceBack(e ? 1 : 0, r ? 1 : 0, n || 0, i || 0), t.emplaceBack(e ? 1 : 0, r ? 1 : 0, n || 0, i || 0), t.emplaceBack(e ? 1 : 0, r ? 1 : 0, n || 0, i || 0);
          }

          we.prototype.getBucketParts = function (e, r, n, i) {
            var a = n.getBucket(r),
                o = n.latestFeatureIndex;

            if (a && o && r.id === a.layerIds[0]) {
              var s = n.collisionBoxArray,
                  l = a.layers[0].layout,
                  c = Math.pow(2, this.transform.zoom - n.tileID.overscaledZ),
                  u = n.tileSize / t.EXTENT,
                  f = this.transform.calculatePosMatrix(n.tileID.toUnwrapped()),
                  h = "map" === l.get("text-pitch-alignment"),
                  p = "map" === l.get("text-rotation-alignment"),
                  d = pe(n, 1, this.transform.zoom),
                  m = Qt(f, h, p, this.transform, d),
                  g = null;

              if (h) {
                var v = $t(f, h, p, this.transform, d);
                g = t.multiply([], this.transform.labelPlaneMatrix, v);
              }

              this.retainedQueryData[a.bucketInstanceId] = new ye(a.bucketInstanceId, o, a.sourceLayerIndex, a.index, n.tileID);
              var y = {
                bucket: a,
                layout: l,
                posMatrix: f,
                textLabelPlaneMatrix: m,
                labelToScreenMatrix: g,
                scale: c,
                textPixelRatio: u,
                holdingForFade: n.holdingForFade(),
                collisionBoxArray: s,
                partiallyEvaluatedTextSize: t.evaluateSizeForZoom(a.textSizeData, this.transform.zoom),
                collisionGroup: this.collisionGroups.get(a.sourceID)
              };
              if (i) for (var x = 0, b = a.sortKeyRanges; x < b.length; x += 1) {
                var _ = b[x],
                    w = _.sortKey,
                    T = _.symbolInstanceStart,
                    k = _.symbolInstanceEnd;
                e.push({
                  sortKey: w,
                  symbolInstanceStart: T,
                  symbolInstanceEnd: k,
                  parameters: y
                });
              } else e.push({
                symbolInstanceStart: 0,
                symbolInstanceEnd: a.symbolInstances.length,
                parameters: y
              });
            }
          }, we.prototype.attemptAnchorPlacement = function (t, e, r, n, i, a, o, s, l, c, u, f, h, p, d) {
            var m,
                g = [f.textOffset0, f.textOffset1],
                v = be(t, r, n, g, i),
                y = this.collisionIndex.placeCollisionBox(_e(e, v.x, v.y, a, o, this.transform.angle), u, s, l, c.predicate);
            if (d && 0 === this.collisionIndex.placeCollisionBox(_e(d, v.x, v.y, a, o, this.transform.angle), u, s, l, c.predicate).box.length) return;
            if (y.box.length > 0) return this.prevPlacement && this.prevPlacement.variableOffsets[f.crossTileID] && this.prevPlacement.placements[f.crossTileID] && this.prevPlacement.placements[f.crossTileID].text && (m = this.prevPlacement.variableOffsets[f.crossTileID].anchor), this.variableOffsets[f.crossTileID] = {
              textOffset: g,
              width: r,
              height: n,
              anchor: t,
              textBoxScale: i,
              prevAnchor: m
            }, this.markUsedJustification(h, t, f, p), h.allowVerticalPlacement && (this.markUsedOrientation(h, p, f), this.placedOrientations[f.crossTileID] = p), {
              shift: v,
              placedGlyphBoxes: y
            };
          }, we.prototype.placeLayerBucketPart = function (e, r, n) {
            var i = this,
                a = e.parameters,
                o = a.bucket,
                s = a.layout,
                l = a.posMatrix,
                c = a.textLabelPlaneMatrix,
                u = a.labelToScreenMatrix,
                f = a.textPixelRatio,
                h = a.holdingForFade,
                p = a.collisionBoxArray,
                d = a.partiallyEvaluatedTextSize,
                m = a.collisionGroup,
                g = s.get("text-optional"),
                v = s.get("icon-optional"),
                y = s.get("text-allow-overlap"),
                x = s.get("icon-allow-overlap"),
                b = "map" === s.get("text-rotation-alignment"),
                _ = "map" === s.get("text-pitch-alignment"),
                w = "none" !== s.get("icon-text-fit"),
                T = "viewport-y" === s.get("symbol-z-order"),
                k = y && (x || !o.hasIconData() || v),
                M = x && (y || !o.hasTextData() || g);

            !o.collisionArrays && p && o.deserializeCollisionBoxes(p);

            var A = function A(e, a) {
              if (!r[e.crossTileID]) if (h) i.placements[e.crossTileID] = new ge(!1, !1, !1);else {
                var p,
                    T = !1,
                    A = !1,
                    S = !0,
                    E = null,
                    L = {
                  box: null,
                  offscreen: null
                },
                    C = {
                  box: null,
                  offscreen: null
                },
                    P = null,
                    I = null,
                    O = 0,
                    z = 0,
                    D = 0;
                a.textFeatureIndex ? O = a.textFeatureIndex : e.useRuntimeCollisionCircles && (O = e.featureIndex), a.verticalTextFeatureIndex && (z = a.verticalTextFeatureIndex);
                var R = a.textBox;

                if (R) {
                  var F = function F(r) {
                    var n = t.WritingMode.horizontal;

                    if (o.allowVerticalPlacement && !r && i.prevPlacement) {
                      var a = i.prevPlacement.placedOrientations[e.crossTileID];
                      a && (i.placedOrientations[e.crossTileID] = a, n = a, i.markUsedOrientation(o, n, e));
                    }

                    return n;
                  },
                      B = function B(r, n) {
                    if (o.allowVerticalPlacement && e.numVerticalGlyphVertices > 0 && a.verticalTextBox) for (var i = 0, s = o.writingModes; i < s.length; i += 1) {
                      if (s[i] === t.WritingMode.vertical ? (L = n(), C = L) : L = r(), L && L.box && L.box.length) break;
                    } else L = r();
                  };

                  if (s.get("text-variable-anchor")) {
                    var N = s.get("text-variable-anchor");

                    if (i.prevPlacement && i.prevPlacement.variableOffsets[e.crossTileID]) {
                      var j = i.prevPlacement.variableOffsets[e.crossTileID];
                      N.indexOf(j.anchor) > 0 && (N = N.filter(function (t) {
                        return t !== j.anchor;
                      })).unshift(j.anchor);
                    }

                    var U = function U(t, r, n) {
                      for (var a = t.x2 - t.x1, s = t.y2 - t.y1, c = e.textBoxScale, u = w && !x ? r : null, h = {
                        box: [],
                        offscreen: !1
                      }, p = y ? 2 * N.length : N.length, d = 0; d < p; ++d) {
                        var g = N[d % N.length],
                            v = d >= N.length,
                            k = i.attemptAnchorPlacement(g, t, a, s, c, b, _, f, l, m, v, e, o, n, u);

                        if (k && (h = k.placedGlyphBoxes) && h.box && h.box.length) {
                          T = !0, E = k.shift;
                          break;
                        }
                      }

                      return h;
                    };

                    B(function () {
                      return U(R, a.iconBox, t.WritingMode.horizontal);
                    }, function () {
                      var r = a.verticalTextBox,
                          n = L && L.box && L.box.length;
                      return o.allowVerticalPlacement && !n && e.numVerticalGlyphVertices > 0 && r ? U(r, a.verticalIconBox, t.WritingMode.vertical) : {
                        box: null,
                        offscreen: null
                      };
                    }), L && (T = L.box, S = L.offscreen);
                    var V = F(L && L.box);

                    if (!T && i.prevPlacement) {
                      var q = i.prevPlacement.variableOffsets[e.crossTileID];
                      q && (i.variableOffsets[e.crossTileID] = q, i.markUsedJustification(o, q.anchor, e, V));
                    }
                  } else {
                    var H = function H(t, r) {
                      var n = i.collisionIndex.placeCollisionBox(t, y, f, l, m.predicate);
                      return n && n.box && n.box.length && (i.markUsedOrientation(o, r, e), i.placedOrientations[e.crossTileID] = r), n;
                    };

                    B(function () {
                      return H(R, t.WritingMode.horizontal);
                    }, function () {
                      var r = a.verticalTextBox;
                      return o.allowVerticalPlacement && e.numVerticalGlyphVertices > 0 && r ? H(r, t.WritingMode.vertical) : {
                        box: null,
                        offscreen: null
                      };
                    }), F(L && L.box && L.box.length);
                  }
                }

                if (T = (p = L) && p.box && p.box.length > 0, S = p && p.offscreen, e.useRuntimeCollisionCircles) {
                  var G = o.text.placedSymbolArray.get(e.centerJustifiedTextSymbolIndex),
                      Y = t.evaluateSizeForFeature(o.textSizeData, d, G),
                      W = s.get("text-padding"),
                      X = e.collisionCircleDiameter;
                  P = i.collisionIndex.placeCollisionCircles(y, G, o.lineVertexArray, o.glyphOffsetArray, Y, l, c, u, n, _, m.predicate, X, W), T = y || P.circles.length > 0 && !P.collisionDetected, S = S && P.offscreen;
                }

                if (a.iconFeatureIndex && (D = a.iconFeatureIndex), a.iconBox) {
                  var Z = function Z(t) {
                    var e = w && E ? _e(t, E.x, E.y, b, _, i.transform.angle) : t;
                    return i.collisionIndex.placeCollisionBox(e, x, f, l, m.predicate);
                  };

                  A = C && C.box && C.box.length && a.verticalIconBox ? (I = Z(a.verticalIconBox)).box.length > 0 : (I = Z(a.iconBox)).box.length > 0, S = S && I.offscreen;
                }

                var J = g || 0 === e.numHorizontalGlyphVertices && 0 === e.numVerticalGlyphVertices,
                    K = v || 0 === e.numIconVertices;

                if (J || K ? K ? J || (A = A && T) : T = A && T : A = T = A && T, T && p && p.box && (C && C.box && z ? i.collisionIndex.insertCollisionBox(p.box, s.get("text-ignore-placement"), o.bucketInstanceId, z, m.ID) : i.collisionIndex.insertCollisionBox(p.box, s.get("text-ignore-placement"), o.bucketInstanceId, O, m.ID)), A && I && i.collisionIndex.insertCollisionBox(I.box, s.get("icon-ignore-placement"), o.bucketInstanceId, D, m.ID), P && (T && i.collisionIndex.insertCollisionCircles(P.circles, s.get("text-ignore-placement"), o.bucketInstanceId, O, m.ID), n)) {
                  var Q = o.bucketInstanceId,
                      $ = i.collisionCircleArrays[Q];
                  void 0 === $ && ($ = i.collisionCircleArrays[Q] = new ve());

                  for (var tt = 0; tt < P.circles.length; tt += 4) {
                    $.circles.push(P.circles[tt + 0]), $.circles.push(P.circles[tt + 1]), $.circles.push(P.circles[tt + 2]), $.circles.push(P.collisionDetected ? 1 : 0);
                  }
                }

                i.placements[e.crossTileID] = new ge(T || k, A || M, S || o.justReloaded), r[e.crossTileID] = !0;
              }
            };

            if (T) for (var S = o.getSortedSymbolIndexes(this.transform.angle), E = S.length - 1; E >= 0; --E) {
              var L = S[E];
              A(o.symbolInstances.get(L), o.collisionArrays[L]);
            } else for (var C = e.symbolInstanceStart; C < e.symbolInstanceEnd; C++) {
              A(o.symbolInstances.get(C), o.collisionArrays[C]);
            }

            if (n && o.bucketInstanceId in this.collisionCircleArrays) {
              var P = this.collisionCircleArrays[o.bucketInstanceId];
              t.invert(P.invProjMatrix, l), P.viewportMatrix = this.collisionIndex.getViewportMatrix();
            }

            o.justReloaded = !1;
          }, we.prototype.markUsedJustification = function (e, r, n, i) {
            var a,
                o = {
              left: n.leftJustifiedTextSymbolIndex,
              center: n.centerJustifiedTextSymbolIndex,
              right: n.rightJustifiedTextSymbolIndex
            };
            a = i === t.WritingMode.vertical ? n.verticalPlacedTextSymbolIndex : o[t.getAnchorJustification(r)];

            for (var s = 0, l = [n.leftJustifiedTextSymbolIndex, n.centerJustifiedTextSymbolIndex, n.rightJustifiedTextSymbolIndex, n.verticalPlacedTextSymbolIndex]; s < l.length; s += 1) {
              var c = l[s];
              c >= 0 && (e.text.placedSymbolArray.get(c).crossTileID = a >= 0 && c !== a ? 0 : n.crossTileID);
            }
          }, we.prototype.markUsedOrientation = function (e, r, n) {
            for (var i = r === t.WritingMode.horizontal || r === t.WritingMode.horizontalOnly ? r : 0, a = r === t.WritingMode.vertical ? r : 0, o = 0, s = [n.leftJustifiedTextSymbolIndex, n.centerJustifiedTextSymbolIndex, n.rightJustifiedTextSymbolIndex]; o < s.length; o += 1) {
              var l = s[o];
              e.text.placedSymbolArray.get(l).placedOrientation = i;
            }

            n.verticalPlacedTextSymbolIndex && (e.text.placedSymbolArray.get(n.verticalPlacedTextSymbolIndex).placedOrientation = a);
          }, we.prototype.commit = function (t) {
            this.commitTime = t, this.zoomAtLastRecencyCheck = this.transform.zoom;
            var e = this.prevPlacement,
                r = !1;
            this.prevZoomAdjustment = e ? e.zoomAdjustment(this.transform.zoom) : 0;
            var n = e ? e.symbolFadeChange(t) : 1,
                i = e ? e.opacities : {},
                a = e ? e.variableOffsets : {},
                o = e ? e.placedOrientations : {};

            for (var s in this.placements) {
              var l = this.placements[s],
                  c = i[s];
              c ? (this.opacities[s] = new me(c, n, l.text, l.icon), r = r || l.text !== c.text.placed || l.icon !== c.icon.placed) : (this.opacities[s] = new me(null, n, l.text, l.icon, l.skipFade), r = r || l.text || l.icon);
            }

            for (var u in i) {
              var f = i[u];

              if (!this.opacities[u]) {
                var h = new me(f, n, !1, !1);
                h.isHidden() || (this.opacities[u] = h, r = r || f.text.placed || f.icon.placed);
              }
            }

            for (var p in a) {
              this.variableOffsets[p] || !this.opacities[p] || this.opacities[p].isHidden() || (this.variableOffsets[p] = a[p]);
            }

            for (var d in o) {
              this.placedOrientations[d] || !this.opacities[d] || this.opacities[d].isHidden() || (this.placedOrientations[d] = o[d]);
            }

            r ? this.lastPlacementChangeTime = t : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = e ? e.lastPlacementChangeTime : t);
          }, we.prototype.updateLayerOpacities = function (t, e) {
            for (var r = {}, n = 0, i = e; n < i.length; n += 1) {
              var a = i[n],
                  o = a.getBucket(t);
              o && a.latestFeatureIndex && t.id === o.layerIds[0] && this.updateBucketOpacities(o, r, a.collisionBoxArray);
            }
          }, we.prototype.updateBucketOpacities = function (e, r, n) {
            var i = this;
            e.hasTextData() && e.text.opacityVertexArray.clear(), e.hasIconData() && e.icon.opacityVertexArray.clear(), e.hasIconCollisionBoxData() && e.iconCollisionBox.collisionVertexArray.clear(), e.hasTextCollisionBoxData() && e.textCollisionBox.collisionVertexArray.clear();
            var a = e.layers[0].layout,
                o = new me(null, 0, !1, !1, !0),
                s = a.get("text-allow-overlap"),
                l = a.get("icon-allow-overlap"),
                c = a.get("text-variable-anchor"),
                u = "map" === a.get("text-rotation-alignment"),
                f = "map" === a.get("text-pitch-alignment"),
                h = "none" !== a.get("icon-text-fit"),
                p = new me(null, 0, s && (l || !e.hasIconData() || a.get("icon-optional")), l && (s || !e.hasTextData() || a.get("text-optional")), !0);
            !e.collisionArrays && n && (e.hasIconCollisionBoxData() || e.hasTextCollisionBoxData()) && e.deserializeCollisionBoxes(n);

            for (var d = function d(t, e, r) {
              for (var n = 0; n < e / 4; n++) {
                t.opacityVertexArray.emplaceBack(r);
              }
            }, m = function m(n) {
              var a = e.symbolInstances.get(n),
                  s = a.numHorizontalGlyphVertices,
                  l = a.numVerticalGlyphVertices,
                  m = a.crossTileID,
                  g = r[m],
                  v = i.opacities[m];
              g ? v = o : v || (v = p, i.opacities[m] = v), r[m] = !0;

              var y = s > 0 || l > 0,
                  x = a.numIconVertices > 0,
                  b = i.placedOrientations[a.crossTileID],
                  _ = b === t.WritingMode.vertical,
                  w = b === t.WritingMode.horizontal || b === t.WritingMode.horizontalOnly;

              if (y) {
                var T = Pe(v.text),
                    k = _ ? Ie : T;
                d(e.text, s, k);
                var M = w ? Ie : T;
                d(e.text, l, M);
                var A = v.text.isHidden();
                [a.rightJustifiedTextSymbolIndex, a.centerJustifiedTextSymbolIndex, a.leftJustifiedTextSymbolIndex].forEach(function (t) {
                  t >= 0 && (e.text.placedSymbolArray.get(t).hidden = A || _ ? 1 : 0);
                }), a.verticalPlacedTextSymbolIndex >= 0 && (e.text.placedSymbolArray.get(a.verticalPlacedTextSymbolIndex).hidden = A || w ? 1 : 0);
                var S = i.variableOffsets[a.crossTileID];
                S && i.markUsedJustification(e, S.anchor, a, b);
                var E = i.placedOrientations[a.crossTileID];
                E && (i.markUsedJustification(e, "left", a, E), i.markUsedOrientation(e, E, a));
              }

              if (x) {
                var L = Pe(v.icon),
                    C = !(h && a.verticalPlacedIconSymbolIndex && _);

                if (a.placedIconSymbolIndex >= 0) {
                  var P = C ? L : Ie;
                  d(e.icon, a.numIconVertices, P), e.icon.placedSymbolArray.get(a.placedIconSymbolIndex).hidden = v.icon.isHidden();
                }

                if (a.verticalPlacedIconSymbolIndex >= 0) {
                  var I = C ? Ie : L;
                  d(e.icon, a.numVerticalIconVertices, I), e.icon.placedSymbolArray.get(a.verticalPlacedIconSymbolIndex).hidden = v.icon.isHidden();
                }
              }

              if (e.hasIconCollisionBoxData() || e.hasTextCollisionBoxData()) {
                var O = e.collisionArrays[n];

                if (O) {
                  var z = new t.Point(0, 0);

                  if (O.textBox || O.verticalTextBox) {
                    var D = !0;

                    if (c) {
                      var R = i.variableOffsets[m];
                      R ? (z = be(R.anchor, R.width, R.height, R.textOffset, R.textBoxScale), u && z._rotate(f ? i.transform.angle : -i.transform.angle)) : D = !1;
                    }

                    O.textBox && Te(e.textCollisionBox.collisionVertexArray, v.text.placed, !D || _, z.x, z.y), O.verticalTextBox && Te(e.textCollisionBox.collisionVertexArray, v.text.placed, !D || w, z.x, z.y);
                  }

                  var F = Boolean(!w && O.verticalIconBox);
                  O.iconBox && Te(e.iconCollisionBox.collisionVertexArray, v.icon.placed, F, h ? z.x : 0, h ? z.y : 0), O.verticalIconBox && Te(e.iconCollisionBox.collisionVertexArray, v.icon.placed, !F, h ? z.x : 0, h ? z.y : 0);
                }
              }
            }, g = 0; g < e.symbolInstances.length; g++) {
              m(g);
            }

            if (e.sortFeatures(this.transform.angle), this.retainedQueryData[e.bucketInstanceId] && (this.retainedQueryData[e.bucketInstanceId].featureSortOrder = e.featureSortOrder), e.hasTextData() && e.text.opacityVertexBuffer && e.text.opacityVertexBuffer.updateData(e.text.opacityVertexArray), e.hasIconData() && e.icon.opacityVertexBuffer && e.icon.opacityVertexBuffer.updateData(e.icon.opacityVertexArray), e.hasIconCollisionBoxData() && e.iconCollisionBox.collisionVertexBuffer && e.iconCollisionBox.collisionVertexBuffer.updateData(e.iconCollisionBox.collisionVertexArray), e.hasTextCollisionBoxData() && e.textCollisionBox.collisionVertexBuffer && e.textCollisionBox.collisionVertexBuffer.updateData(e.textCollisionBox.collisionVertexArray), e.bucketInstanceId in this.collisionCircleArrays) {
              var v = this.collisionCircleArrays[e.bucketInstanceId];
              e.placementInvProjMatrix = v.invProjMatrix, e.placementViewportMatrix = v.viewportMatrix, e.collisionCircleArray = v.circles, delete this.collisionCircleArrays[e.bucketInstanceId];
            }
          }, we.prototype.symbolFadeChange = function (t) {
            return 0 === this.fadeDuration ? 1 : (t - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
          }, we.prototype.zoomAdjustment = function (t) {
            return Math.max(0, (this.transform.zoom - t) / 1.5);
          }, we.prototype.hasTransitions = function (t) {
            return this.stale || t - this.lastPlacementChangeTime < this.fadeDuration;
          }, we.prototype.stillRecent = function (t, e) {
            var r = this.zoomAtLastRecencyCheck === e ? 1 - this.zoomAdjustment(e) : 1;
            return this.zoomAtLastRecencyCheck = e, this.commitTime + this.fadeDuration * r > t;
          }, we.prototype.setStale = function () {
            this.stale = !0;
          };
          var ke = Math.pow(2, 25),
              Me = Math.pow(2, 24),
              Ae = Math.pow(2, 17),
              Se = Math.pow(2, 16),
              Ee = Math.pow(2, 9),
              Le = Math.pow(2, 8),
              Ce = Math.pow(2, 1);

          function Pe(t) {
            if (0 === t.opacity && !t.placed) return 0;
            if (1 === t.opacity && t.placed) return 4294967295;
            var e = t.placed ? 1 : 0,
                r = Math.floor(127 * t.opacity);
            return r * ke + e * Me + r * Ae + e * Se + r * Ee + e * Le + r * Ce + e;
          }

          var Ie = 0,
              Oe = function Oe(t) {
            this._sortAcrossTiles = "viewport-y" !== t.layout.get("symbol-z-order") && void 0 !== t.layout.get("symbol-sort-key").constantOr(1), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
          };

          Oe.prototype.continuePlacement = function (t, e, r, n, i) {
            for (var a = this._bucketParts; this._currentTileIndex < t.length;) {
              var o = t[this._currentTileIndex];
              if (e.getBucketParts(a, n, o, this._sortAcrossTiles), this._currentTileIndex++, i()) return !0;
            }

            for (this._sortAcrossTiles && (this._sortAcrossTiles = !1, a.sort(function (t, e) {
              return t.sortKey - e.sortKey;
            })); this._currentPartIndex < a.length;) {
              var s = a[this._currentPartIndex];
              if (e.placeLayerBucketPart(s, this._seenCrossTileIDs, r), this._currentPartIndex++, i()) return !0;
            }

            return !1;
          };

          var ze = function ze(t, e, r, n, i, a, o) {
            this.placement = new we(t, i, a, o), this._currentPlacementIndex = e.length - 1, this._forceFullPlacement = r, this._showCollisionBoxes = n, this._done = !1;
          };

          ze.prototype.isDone = function () {
            return this._done;
          }, ze.prototype.continuePlacement = function (e, r, n) {
            for (var i = this, a = t.browser.now(), o = function o() {
              var e = t.browser.now() - a;
              return !i._forceFullPlacement && e > 2;
            }; this._currentPlacementIndex >= 0;) {
              var s = r[e[this._currentPlacementIndex]],
                  l = this.placement.collisionIndex.transform.zoom;

              if ("symbol" === s.type && (!s.minzoom || s.minzoom <= l) && (!s.maxzoom || s.maxzoom > l)) {
                if (this._inProgressLayer || (this._inProgressLayer = new Oe(s)), this._inProgressLayer.continuePlacement(n[s.source], this.placement, this._showCollisionBoxes, s, o)) return;
                delete this._inProgressLayer;
              }

              this._currentPlacementIndex--;
            }

            this._done = !0;
          }, ze.prototype.commit = function (t) {
            return this.placement.commit(t), this.placement;
          };

          var De = 512 / t.EXTENT / 2,
              Re = function Re(t, e, r) {
            this.tileID = t, this.indexedSymbolInstances = {}, this.bucketInstanceId = r;

            for (var n = 0; n < e.length; n++) {
              var i = e.get(n),
                  a = i.key;
              this.indexedSymbolInstances[a] || (this.indexedSymbolInstances[a] = []), this.indexedSymbolInstances[a].push({
                crossTileID: i.crossTileID,
                coord: this.getScaledCoordinates(i, t)
              });
            }
          };

          Re.prototype.getScaledCoordinates = function (e, r) {
            var n = r.canonical.z - this.tileID.canonical.z,
                i = De / Math.pow(2, n);
            return {
              x: Math.floor((r.canonical.x * t.EXTENT + e.anchorX) * i),
              y: Math.floor((r.canonical.y * t.EXTENT + e.anchorY) * i)
            };
          }, Re.prototype.findMatches = function (t, e, r) {
            for (var n = this.tileID.canonical.z < e.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - e.canonical.z), i = 0; i < t.length; i++) {
              var a = t.get(i);

              if (!a.crossTileID) {
                var o = this.indexedSymbolInstances[a.key];
                if (o) for (var s = this.getScaledCoordinates(a, e), l = 0, c = o; l < c.length; l += 1) {
                  var u = c[l];

                  if (Math.abs(u.coord.x - s.x) <= n && Math.abs(u.coord.y - s.y) <= n && !r[u.crossTileID]) {
                    r[u.crossTileID] = !0, a.crossTileID = u.crossTileID;
                    break;
                  }
                }
              }
            }
          };

          var Fe = function Fe() {
            this.maxCrossTileID = 0;
          };

          Fe.prototype.generate = function () {
            return ++this.maxCrossTileID;
          };

          var Be = function Be() {
            this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
          };

          Be.prototype.handleWrapJump = function (t) {
            var e = Math.round((t - this.lng) / 360);
            if (0 !== e) for (var r in this.indexes) {
              var n = this.indexes[r],
                  i = {};

              for (var a in n) {
                var o = n[a];
                o.tileID = o.tileID.unwrapTo(o.tileID.wrap + e), i[o.tileID.key] = o;
              }

              this.indexes[r] = i;
            }
            this.lng = t;
          }, Be.prototype.addBucket = function (t, e, r) {
            if (this.indexes[t.overscaledZ] && this.indexes[t.overscaledZ][t.key]) {
              if (this.indexes[t.overscaledZ][t.key].bucketInstanceId === e.bucketInstanceId) return !1;
              this.removeBucketCrossTileIDs(t.overscaledZ, this.indexes[t.overscaledZ][t.key]);
            }

            for (var n = 0; n < e.symbolInstances.length; n++) {
              e.symbolInstances.get(n).crossTileID = 0;
            }

            this.usedCrossTileIDs[t.overscaledZ] || (this.usedCrossTileIDs[t.overscaledZ] = {});
            var i = this.usedCrossTileIDs[t.overscaledZ];

            for (var a in this.indexes) {
              var o = this.indexes[a];
              if (Number(a) > t.overscaledZ) for (var s in o) {
                var l = o[s];
                l.tileID.isChildOf(t) && l.findMatches(e.symbolInstances, t, i);
              } else {
                var c = o[t.scaledTo(Number(a)).key];
                c && c.findMatches(e.symbolInstances, t, i);
              }
            }

            for (var u = 0; u < e.symbolInstances.length; u++) {
              var f = e.symbolInstances.get(u);
              f.crossTileID || (f.crossTileID = r.generate(), i[f.crossTileID] = !0);
            }

            return void 0 === this.indexes[t.overscaledZ] && (this.indexes[t.overscaledZ] = {}), this.indexes[t.overscaledZ][t.key] = new Re(t, e.symbolInstances, e.bucketInstanceId), !0;
          }, Be.prototype.removeBucketCrossTileIDs = function (t, e) {
            for (var r in e.indexedSymbolInstances) {
              for (var n = 0, i = e.indexedSymbolInstances[r]; n < i.length; n += 1) {
                var a = i[n];
                delete this.usedCrossTileIDs[t][a.crossTileID];
              }
            }
          }, Be.prototype.removeStaleBuckets = function (t) {
            var e = !1;

            for (var r in this.indexes) {
              var n = this.indexes[r];

              for (var i in n) {
                t[n[i].bucketInstanceId] || (this.removeBucketCrossTileIDs(r, n[i]), delete n[i], e = !0);
              }
            }

            return e;
          };

          var Ne = function Ne() {
            this.layerIndexes = {}, this.crossTileIDs = new Fe(), this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
          };

          Ne.prototype.addLayer = function (t, e, r) {
            var n = this.layerIndexes[t.id];
            void 0 === n && (n = this.layerIndexes[t.id] = new Be());
            var i = !1,
                a = {};
            n.handleWrapJump(r);

            for (var o = 0, s = e; o < s.length; o += 1) {
              var l = s[o],
                  c = l.getBucket(t);
              c && t.id === c.layerIds[0] && (c.bucketInstanceId || (c.bucketInstanceId = ++this.maxBucketInstanceId), n.addBucket(l.tileID, c, this.crossTileIDs) && (i = !0), a[c.bucketInstanceId] = !0);
            }

            return n.removeStaleBuckets(a) && (i = !0), i;
          }, Ne.prototype.pruneUnusedLayers = function (t) {
            var e = {};

            for (var r in t.forEach(function (t) {
              e[t] = !0;
            }), this.layerIndexes) {
              e[r] || delete this.layerIndexes[r];
            }
          };

          var je = function je(e, r) {
            return t.emitValidationErrors(e, r && r.filter(function (t) {
              return "source.canvas" !== t.identifier;
            }));
          },
              Ue = t.pick(Ut, ["addLayer", "removeLayer", "setPaintProperty", "setLayoutProperty", "setFilter", "addSource", "removeSource", "setLayerZoomRange", "setLight", "setTransition", "setGeoJSONSourceData"]),
              Ve = t.pick(Ut, ["setCenter", "setZoom", "setBearing", "setPitch"]),
              qe = function () {
            var e = {},
                r = t.styleSpec.$version;

            for (var n in t.styleSpec.$root) {
              var i = t.styleSpec.$root[n];

              if (i.required) {
                var a = null;
                null != (a = "version" === n ? r : "array" === i.type ? [] : {}) && (e[n] = a);
              }
            }

            return e;
          }(),
              He = function (e) {
            function r(n, i) {
              var a = this;
              void 0 === i && (i = {}), e.call(this), this.map = n, this.dispatcher = new k(Bt(), this), this.imageManager = new h(), this.imageManager.setEventedParent(this), this.glyphManager = new x(n._requestManager, i.localIdeographFontFamily), this.lineAtlas = new T(256, 512), this.crossTileSymbolIndex = new Ne(), this._layers = {}, this._serializedLayers = {}, this._order = [], this.sourceCaches = {}, this.zoomHistory = new t.ZoomHistory(), this._loaded = !1, this._availableImages = [], this._resetUpdates(), this.dispatcher.broadcast("setReferrer", t.getReferrer());
              var o = this;
              this._rtlTextPluginCallback = r.registerForPluginStateChange(function (e) {
                var r = {
                  pluginStatus: e.pluginStatus,
                  pluginURL: e.pluginURL
                };
                o.dispatcher.broadcast("syncRTLPluginState", r, function (e, r) {
                  if ((t.triggerPluginCompletionEvent(e), r) && r.every(function (t) {
                    return t;
                  })) for (var n in o.sourceCaches) {
                    o.sourceCaches[n].reload();
                  }
                });
              }), this.on("data", function (t) {
                if ("source" === t.dataType && "metadata" === t.sourceDataType) {
                  var e = a.sourceCaches[t.sourceId];

                  if (e) {
                    var r = e.getSource();
                    if (r && r.vectorLayerIds) for (var n in a._layers) {
                      var i = a._layers[n];
                      i.source === r.id && a._validateLayer(i);
                    }
                  }
                }
              });
            }

            return e && (r.__proto__ = e), r.prototype = Object.create(e && e.prototype), r.prototype.constructor = r, r.prototype.loadURL = function (e, r) {
              var n = this;
              void 0 === r && (r = {}), this.fire(new t.Event("dataloading", {
                dataType: "style"
              }));
              var i = "boolean" == typeof r.validate ? r.validate : !t.isMapboxURL(e);
              e = this.map._requestManager.normalizeStyleURL(e, r.accessToken);

              var a = this.map._requestManager.transformRequest(e, t.ResourceType.Style);

              this._request = t.getJSON(a, function (e, r) {
                n._request = null, e ? n.fire(new t.ErrorEvent(e)) : r && n._load(r, i);
              });
            }, r.prototype.loadJSON = function (e, r) {
              var n = this;
              void 0 === r && (r = {}), this.fire(new t.Event("dataloading", {
                dataType: "style"
              })), this._request = t.browser.frame(function () {
                n._request = null, n._load(e, !1 !== r.validate);
              });
            }, r.prototype.loadEmpty = function () {
              this.fire(new t.Event("dataloading", {
                dataType: "style"
              })), this._load(qe, !1);
            }, r.prototype._load = function (e, r) {
              if (!r || !je(this, t.validateStyle(e))) {
                for (var n in this._loaded = !0, this.stylesheet = e, e.sources) {
                  this.addSource(n, e.sources[n], {
                    validate: !1
                  });
                }

                e.sprite ? this._loadSprite(e.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(e.glyphs);
                var i = jt(this.stylesheet.layers);
                this._order = i.map(function (t) {
                  return t.id;
                }), this._layers = {}, this._serializedLayers = {};

                for (var a = 0, o = i; a < o.length; a += 1) {
                  var s = o[a];
                  (s = t.createStyleLayer(s)).setEventedParent(this, {
                    layer: {
                      id: s.id
                    }
                  }), this._layers[s.id] = s, this._serializedLayers[s.id] = s.serialize();
                }

                this.dispatcher.broadcast("setLayers", this._serializeLayers(this._order)), this.light = new w(this.stylesheet.light), this.fire(new t.Event("data", {
                  dataType: "style"
                })), this.fire(new t.Event("style.load"));
              }
            }, r.prototype._loadSprite = function (e) {
              var r = this;

              this._spriteRequest = function (e, r, n) {
                var i,
                    a,
                    o,
                    s = t.browser.devicePixelRatio > 1 ? "@2x" : "",
                    l = t.getJSON(r.transformRequest(r.normalizeSpriteURL(e, s, ".json"), t.ResourceType.SpriteJSON), function (t, e) {
                  l = null, o || (o = t, i = e, u());
                }),
                    c = t.getImage(r.transformRequest(r.normalizeSpriteURL(e, s, ".png"), t.ResourceType.SpriteImage), function (t, e) {
                  c = null, o || (o = t, a = e, u());
                });

                function u() {
                  if (o) n(o);else if (i && a) {
                    var e = t.browser.getImageData(a),
                        r = {};

                    for (var s in i) {
                      var l = i[s],
                          c = l.width,
                          u = l.height,
                          f = l.x,
                          h = l.y,
                          p = l.sdf,
                          d = l.pixelRatio,
                          m = l.stretchX,
                          g = l.stretchY,
                          v = l.content,
                          y = new t.RGBAImage({
                        width: c,
                        height: u
                      });
                      t.RGBAImage.copy(e, y, {
                        x: f,
                        y: h
                      }, {
                        x: 0,
                        y: 0
                      }, {
                        width: c,
                        height: u
                      }), r[s] = {
                        data: y,
                        pixelRatio: d,
                        sdf: p,
                        stretchX: m,
                        stretchY: g,
                        content: v
                      };
                    }

                    n(null, r);
                  }
                }

                return {
                  cancel: function cancel() {
                    l && (l.cancel(), l = null), c && (c.cancel(), c = null);
                  }
                };
              }(e, this.map._requestManager, function (e, n) {
                if (r._spriteRequest = null, e) r.fire(new t.ErrorEvent(e));else if (n) for (var i in n) {
                  r.imageManager.addImage(i, n[i]);
                }
                r.imageManager.setLoaded(!0), r._availableImages = r.imageManager.listImages(), r.dispatcher.broadcast("setImages", r._availableImages), r.fire(new t.Event("data", {
                  dataType: "style"
                }));
              });
            }, r.prototype._validateLayer = function (e) {
              var r = this.sourceCaches[e.source];

              if (r) {
                var n = e.sourceLayer;

                if (n) {
                  var i = r.getSource();
                  ("geojson" === i.type || i.vectorLayerIds && -1 === i.vectorLayerIds.indexOf(n)) && this.fire(new t.ErrorEvent(new Error('Source layer "' + n + '" does not exist on source "' + i.id + '" as specified by style layer "' + e.id + '"')));
                }
              }
            }, r.prototype.loaded = function () {
              if (!this._loaded) return !1;
              if (Object.keys(this._updatedSources).length) return !1;

              for (var t in this.sourceCaches) {
                if (!this.sourceCaches[t].loaded()) return !1;
              }

              return !!this.imageManager.isLoaded();
            }, r.prototype._serializeLayers = function (t) {
              for (var e = [], r = 0, n = t; r < n.length; r += 1) {
                var i = n[r],
                    a = this._layers[i];
                "custom" !== a.type && e.push(a.serialize());
              }

              return e;
            }, r.prototype.hasTransitions = function () {
              if (this.light && this.light.hasTransition()) return !0;

              for (var t in this.sourceCaches) {
                if (this.sourceCaches[t].hasTransition()) return !0;
              }

              for (var e in this._layers) {
                if (this._layers[e].hasTransition()) return !0;
              }

              return !1;
            }, r.prototype._checkLoaded = function () {
              if (!this._loaded) throw new Error("Style is not done loading");
            }, r.prototype.update = function (e) {
              if (this._loaded) {
                var r = this._changed;

                if (this._changed) {
                  var n = Object.keys(this._updatedLayers),
                      i = Object.keys(this._removedLayers);

                  for (var a in (n.length || i.length) && this._updateWorkerLayers(n, i), this._updatedSources) {
                    var o = this._updatedSources[a];
                    "reload" === o ? this._reloadSource(a) : "clear" === o && this._clearSource(a);
                  }

                  for (var s in this._updateTilesForChangedImages(), this._updatedPaintProps) {
                    this._layers[s].updateTransitions(e);
                  }

                  this.light.updateTransitions(e), this._resetUpdates();
                }

                for (var l in this.sourceCaches) {
                  this.sourceCaches[l].used = !1;
                }

                for (var c = 0, u = this._order; c < u.length; c += 1) {
                  var f = u[c],
                      h = this._layers[f];
                  h.recalculate(e, this._availableImages), !h.isHidden(e.zoom) && h.source && (this.sourceCaches[h.source].used = !0);
                }

                this.light.recalculate(e), this.z = e.zoom, r && this.fire(new t.Event("data", {
                  dataType: "style"
                }));
              }
            }, r.prototype._updateTilesForChangedImages = function () {
              var t = Object.keys(this._changedImages);

              if (t.length) {
                for (var e in this.sourceCaches) {
                  this.sourceCaches[e].reloadTilesForDependencies(["icons", "patterns"], t);
                }

                this._changedImages = {};
              }
            }, r.prototype._updateWorkerLayers = function (t, e) {
              this.dispatcher.broadcast("updateLayers", {
                layers: this._serializeLayers(t),
                removedIds: e
              });
            }, r.prototype._resetUpdates = function () {
              this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {};
            }, r.prototype.setState = function (e) {
              var r = this;
              if (this._checkLoaded(), je(this, t.validateStyle(e))) return !1;
              (e = t.clone$1(e)).layers = jt(e.layers);
              var n = Zt(this.serialize(), e).filter(function (t) {
                return !(t.command in Ve);
              });
              if (0 === n.length) return !1;
              var i = n.filter(function (t) {
                return !(t.command in Ue);
              });
              if (i.length > 0) throw new Error("Unimplemented: " + i.map(function (t) {
                return t.command;
              }).join(", ") + ".");
              return n.forEach(function (t) {
                "setTransition" !== t.command && r[t.command].apply(r, t.args);
              }), this.stylesheet = e, !0;
            }, r.prototype.addImage = function (e, r) {
              if (this.getImage(e)) return this.fire(new t.ErrorEvent(new Error("An image with this name already exists.")));
              this.imageManager.addImage(e, r), this._availableImages = this.imageManager.listImages(), this._changedImages[e] = !0, this._changed = !0, this.fire(new t.Event("data", {
                dataType: "style"
              }));
            }, r.prototype.updateImage = function (t, e) {
              this.imageManager.updateImage(t, e);
            }, r.prototype.getImage = function (t) {
              return this.imageManager.getImage(t);
            }, r.prototype.removeImage = function (e) {
              if (!this.getImage(e)) return this.fire(new t.ErrorEvent(new Error("No image with this name exists.")));
              this.imageManager.removeImage(e), this._availableImages = this.imageManager.listImages(), this._changedImages[e] = !0, this._changed = !0, this.fire(new t.Event("data", {
                dataType: "style"
              }));
            }, r.prototype.listImages = function () {
              return this._checkLoaded(), this.imageManager.listImages();
            }, r.prototype.addSource = function (e, r, n) {
              var i = this;
              if (void 0 === n && (n = {}), this._checkLoaded(), void 0 !== this.sourceCaches[e]) throw new Error("There is already a source with this ID");
              if (!r.type) throw new Error("The type property must be defined, but the only the following properties were given: " + Object.keys(r).join(", ") + ".");

              if (!(["vector", "raster", "geojson", "video", "image"].indexOf(r.type) >= 0) || !this._validate(t.validateStyle.source, "sources." + e, r, null, n)) {
                this.map && this.map._collectResourceTiming && (r.collectResourceTiming = !0);
                var a = this.sourceCaches[e] = new Ct(e, r, this.dispatcher);
                a.style = this, a.setEventedParent(this, function () {
                  return {
                    isSourceLoaded: i.loaded(),
                    source: a.serialize(),
                    sourceId: e
                  };
                }), a.onAdd(this.map), this._changed = !0;
              }
            }, r.prototype.removeSource = function (e) {
              if (this._checkLoaded(), void 0 === this.sourceCaches[e]) throw new Error("There is no source with this ID");

              for (var r in this._layers) {
                if (this._layers[r].source === e) return this.fire(new t.ErrorEvent(new Error('Source "' + e + '" cannot be removed while layer "' + r + '" is using it.')));
              }

              var n = this.sourceCaches[e];
              delete this.sourceCaches[e], delete this._updatedSources[e], n.fire(new t.Event("data", {
                sourceDataType: "metadata",
                dataType: "source",
                sourceId: e
              })), n.setEventedParent(null), n.clearTiles(), n.onRemove && n.onRemove(this.map), this._changed = !0;
            }, r.prototype.setGeoJSONSourceData = function (t, e) {
              this._checkLoaded(), this.sourceCaches[t].getSource().setData(e), this._changed = !0;
            }, r.prototype.getSource = function (t) {
              return this.sourceCaches[t] && this.sourceCaches[t].getSource();
            }, r.prototype.addLayer = function (e, r, n) {
              void 0 === n && (n = {}), this._checkLoaded();
              var i = e.id;
              if (this.getLayer(i)) this.fire(new t.ErrorEvent(new Error('Layer with id "' + i + '" already exists on this map')));else {
                var a;

                if ("custom" === e.type) {
                  if (je(this, t.validateCustomStyleLayer(e))) return;
                  a = t.createStyleLayer(e);
                } else {
                  if ("object" == _typeof(e.source) && (this.addSource(i, e.source), e = t.clone$1(e), e = t.extend(e, {
                    source: i
                  })), this._validate(t.validateStyle.layer, "layers." + i, e, {
                    arrayIndex: -1
                  }, n)) return;
                  a = t.createStyleLayer(e), this._validateLayer(a), a.setEventedParent(this, {
                    layer: {
                      id: i
                    }
                  }), this._serializedLayers[a.id] = a.serialize();
                }

                var o = r ? this._order.indexOf(r) : this._order.length;
                if (r && -1 === o) this.fire(new t.ErrorEvent(new Error('Layer with id "' + r + '" does not exist on this map.')));else {
                  if (this._order.splice(o, 0, i), this._layerOrderChanged = !0, this._layers[i] = a, this._removedLayers[i] && a.source && "custom" !== a.type) {
                    var s = this._removedLayers[i];
                    delete this._removedLayers[i], s.type !== a.type ? this._updatedSources[a.source] = "clear" : (this._updatedSources[a.source] = "reload", this.sourceCaches[a.source].pause());
                  }

                  this._updateLayer(a), a.onAdd && a.onAdd(this.map);
                }
              }
            }, r.prototype.moveLayer = function (e, r) {
              if (this._checkLoaded(), this._changed = !0, this._layers[e]) {
                if (e !== r) {
                  var n = this._order.indexOf(e);

                  this._order.splice(n, 1);

                  var i = r ? this._order.indexOf(r) : this._order.length;
                  r && -1 === i ? this.fire(new t.ErrorEvent(new Error('Layer with id "' + r + '" does not exist on this map.'))) : (this._order.splice(i, 0, e), this._layerOrderChanged = !0);
                }
              } else this.fire(new t.ErrorEvent(new Error("The layer '" + e + "' does not exist in the map's style and cannot be moved.")));
            }, r.prototype.removeLayer = function (e) {
              this._checkLoaded();

              var r = this._layers[e];

              if (r) {
                r.setEventedParent(null);

                var n = this._order.indexOf(e);

                this._order.splice(n, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[e] = r, delete this._layers[e], delete this._serializedLayers[e], delete this._updatedLayers[e], delete this._updatedPaintProps[e], r.onRemove && r.onRemove(this.map);
              } else this.fire(new t.ErrorEvent(new Error("The layer '" + e + "' does not exist in the map's style and cannot be removed.")));
            }, r.prototype.getLayer = function (t) {
              return this._layers[t];
            }, r.prototype.hasLayer = function (t) {
              return t in this._layers;
            }, r.prototype.setLayerZoomRange = function (e, r, n) {
              this._checkLoaded();

              var i = this.getLayer(e);
              i ? i.minzoom === r && i.maxzoom === n || (null != r && (i.minzoom = r), null != n && (i.maxzoom = n), this._updateLayer(i)) : this.fire(new t.ErrorEvent(new Error("The layer '" + e + "' does not exist in the map's style and cannot have zoom extent.")));
            }, r.prototype.setFilter = function (e, r, n) {
              void 0 === n && (n = {}), this._checkLoaded();
              var i = this.getLayer(e);

              if (i) {
                if (!t.deepEqual(i.filter, r)) return null == r ? (i.filter = void 0, void this._updateLayer(i)) : void (this._validate(t.validateStyle.filter, "layers." + i.id + ".filter", r, null, n) || (i.filter = t.clone$1(r), this._updateLayer(i)));
              } else this.fire(new t.ErrorEvent(new Error("The layer '" + e + "' does not exist in the map's style and cannot be filtered.")));
            }, r.prototype.getFilter = function (e) {
              return t.clone$1(this.getLayer(e).filter);
            }, r.prototype.setLayoutProperty = function (e, r, n, i) {
              void 0 === i && (i = {}), this._checkLoaded();
              var a = this.getLayer(e);
              a ? t.deepEqual(a.getLayoutProperty(r), n) || (a.setLayoutProperty(r, n, i), this._updateLayer(a)) : this.fire(new t.ErrorEvent(new Error("The layer '" + e + "' does not exist in the map's style and cannot be styled.")));
            }, r.prototype.getLayoutProperty = function (e, r) {
              var n = this.getLayer(e);
              if (n) return n.getLayoutProperty(r);
              this.fire(new t.ErrorEvent(new Error("The layer '" + e + "' does not exist in the map's style.")));
            }, r.prototype.setPaintProperty = function (e, r, n, i) {
              void 0 === i && (i = {}), this._checkLoaded();
              var a = this.getLayer(e);
              a ? t.deepEqual(a.getPaintProperty(r), n) || (a.setPaintProperty(r, n, i) && this._updateLayer(a), this._changed = !0, this._updatedPaintProps[e] = !0) : this.fire(new t.ErrorEvent(new Error("The layer '" + e + "' does not exist in the map's style and cannot be styled.")));
            }, r.prototype.getPaintProperty = function (t, e) {
              return this.getLayer(t).getPaintProperty(e);
            }, r.prototype.setFeatureState = function (e, r) {
              this._checkLoaded();

              var n = e.source,
                  i = e.sourceLayer,
                  a = this.sourceCaches[n];

              if (void 0 !== a) {
                var o = a.getSource().type;
                "geojson" === o && i ? this.fire(new t.ErrorEvent(new Error("GeoJSON sources cannot have a sourceLayer parameter."))) : "vector" !== o || i ? (void 0 === e.id && this.fire(new t.ErrorEvent(new Error("The feature id parameter must be provided."))), a.setFeatureState(i, e.id, r)) : this.fire(new t.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
              } else this.fire(new t.ErrorEvent(new Error("The source '" + n + "' does not exist in the map's style.")));
            }, r.prototype.removeFeatureState = function (e, r) {
              this._checkLoaded();

              var n = e.source,
                  i = this.sourceCaches[n];

              if (void 0 !== i) {
                var a = i.getSource().type,
                    o = "vector" === a ? e.sourceLayer : void 0;
                "vector" !== a || o ? r && "string" != typeof e.id && "number" != typeof e.id ? this.fire(new t.ErrorEvent(new Error("A feature id is requred to remove its specific state property."))) : i.removeFeatureState(o, e.id, r) : this.fire(new t.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
              } else this.fire(new t.ErrorEvent(new Error("The source '" + n + "' does not exist in the map's style.")));
            }, r.prototype.getFeatureState = function (e) {
              this._checkLoaded();

              var r = e.source,
                  n = e.sourceLayer,
                  i = this.sourceCaches[r];

              if (void 0 !== i) {
                if ("vector" !== i.getSource().type || n) return void 0 === e.id && this.fire(new t.ErrorEvent(new Error("The feature id parameter must be provided."))), i.getFeatureState(n, e.id);
                this.fire(new t.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
              } else this.fire(new t.ErrorEvent(new Error("The source '" + r + "' does not exist in the map's style.")));
            }, r.prototype.getTransition = function () {
              return t.extend({
                duration: 300,
                delay: 0
              }, this.stylesheet && this.stylesheet.transition);
            }, r.prototype.serialize = function () {
              return t.filterObject({
                version: this.stylesheet.version,
                name: this.stylesheet.name,
                metadata: this.stylesheet.metadata,
                light: this.stylesheet.light,
                center: this.stylesheet.center,
                zoom: this.stylesheet.zoom,
                bearing: this.stylesheet.bearing,
                pitch: this.stylesheet.pitch,
                sprite: this.stylesheet.sprite,
                glyphs: this.stylesheet.glyphs,
                transition: this.stylesheet.transition,
                sources: t.mapObject(this.sourceCaches, function (t) {
                  return t.serialize();
                }),
                layers: this._serializeLayers(this._order)
              }, function (t) {
                return void 0 !== t;
              });
            }, r.prototype._updateLayer = function (t) {
              this._updatedLayers[t.id] = !0, t.source && !this._updatedSources[t.source] && "raster" !== this.sourceCaches[t.source].getSource().type && (this._updatedSources[t.source] = "reload", this.sourceCaches[t.source].pause()), this._changed = !0;
            }, r.prototype._flattenAndSortRenderedFeatures = function (t) {
              for (var e = this, r = function r(t) {
                return "fill-extrusion" === e._layers[t].type;
              }, n = {}, i = [], a = this._order.length - 1; a >= 0; a--) {
                var o = this._order[a];

                if (r(o)) {
                  n[o] = a;

                  for (var s = 0, l = t; s < l.length; s += 1) {
                    var c = l[s][o];
                    if (c) for (var u = 0, f = c; u < f.length; u += 1) {
                      var h = f[u];
                      i.push(h);
                    }
                  }
                }
              }

              i.sort(function (t, e) {
                return e.intersectionZ - t.intersectionZ;
              });

              for (var p = [], d = this._order.length - 1; d >= 0; d--) {
                var m = this._order[d];
                if (r(m)) for (var g = i.length - 1; g >= 0; g--) {
                  var v = i[g].feature;
                  if (n[v.layer.id] < d) break;
                  p.push(v), i.pop();
                } else for (var y = 0, x = t; y < x.length; y += 1) {
                  var b = x[y][m];
                  if (b) for (var _ = 0, w = b; _ < w.length; _ += 1) {
                    var T = w[_];
                    p.push(T.feature);
                  }
                }
              }

              return p;
            }, r.prototype.queryRenderedFeatures = function (e, r, n) {
              r && r.filter && this._validate(t.validateStyle.filter, "queryRenderedFeatures.filter", r.filter, null, r);
              var i = {};

              if (r && r.layers) {
                if (!Array.isArray(r.layers)) return this.fire(new t.ErrorEvent(new Error("parameters.layers must be an Array."))), [];

                for (var a = 0, o = r.layers; a < o.length; a += 1) {
                  var s = o[a],
                      l = this._layers[s];
                  if (!l) return this.fire(new t.ErrorEvent(new Error("The layer '" + s + "' does not exist in the map's style and cannot be queried for features."))), [];
                  i[l.source] = !0;
                }
              }

              var c = [];

              for (var u in r.availableImages = this._availableImages, this.sourceCaches) {
                r.layers && !i[u] || c.push(F(this.sourceCaches[u], this._layers, this._serializedLayers, e, r, n));
              }

              return this.placement && c.push(function (t, e, r, n, i, a, o) {
                for (var s = {}, l = a.queryRenderedSymbols(n), c = [], u = 0, f = Object.keys(l).map(Number); u < f.length; u += 1) {
                  var h = f[u];
                  c.push(o[h]);
                }

                c.sort(B);

                for (var p = function p() {
                  var r = m[d],
                      n = r.featureIndex.lookupSymbolFeatures(l[r.bucketInstanceId], e, r.bucketIndex, r.sourceLayerIndex, i.filter, i.layers, i.availableImages, t);

                  for (var a in n) {
                    var o = s[a] = s[a] || [],
                        c = n[a];
                    c.sort(function (t, e) {
                      var n = r.featureSortOrder;

                      if (n) {
                        var i = n.indexOf(t.featureIndex);
                        return n.indexOf(e.featureIndex) - i;
                      }

                      return e.featureIndex - t.featureIndex;
                    });

                    for (var u = 0, f = c; u < f.length; u += 1) {
                      var h = f[u];
                      o.push(h);
                    }
                  }
                }, d = 0, m = c; d < m.length; d += 1) {
                  p();
                }

                var g = function g(e) {
                  s[e].forEach(function (n) {
                    var i = n.feature,
                        a = t[e],
                        o = r[a.source].getFeatureState(i.layer["source-layer"], i.id);
                    i.source = i.layer.source, i.layer["source-layer"] && (i.sourceLayer = i.layer["source-layer"]), i.state = o;
                  });
                };

                for (var v in s) {
                  g(v);
                }

                return s;
              }(this._layers, this._serializedLayers, this.sourceCaches, e, r, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(c);
            }, r.prototype.querySourceFeatures = function (e, r) {
              r && r.filter && this._validate(t.validateStyle.filter, "querySourceFeatures.filter", r.filter, null, r);
              var n = this.sourceCaches[e];
              return n ? function (t, e) {
                for (var r = t.getRenderableIds().map(function (e) {
                  return t.getTileByID(e);
                }), n = [], i = {}, a = 0; a < r.length; a++) {
                  var o = r[a],
                      s = o.tileID.canonical.key;
                  i[s] || (i[s] = !0, o.querySourceFeatures(n, e));
                }

                return n;
              }(n, r) : [];
            }, r.prototype.addSourceType = function (t, e, n) {
              return r.getSourceType(t) ? n(new Error('A source type called "' + t + '" already exists.')) : (r.setSourceType(t, e), e.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", {
                name: t,
                url: e.workerSourceURL
              }, n) : n(null, null));
            }, r.prototype.getLight = function () {
              return this.light.getLight();
            }, r.prototype.setLight = function (e, r) {
              void 0 === r && (r = {}), this._checkLoaded();
              var n = this.light.getLight(),
                  i = !1;

              for (var a in e) {
                if (!t.deepEqual(e[a], n[a])) {
                  i = !0;
                  break;
                }
              }

              if (i) {
                var o = {
                  now: t.browser.now(),
                  transition: t.extend({
                    duration: 300,
                    delay: 0
                  }, this.stylesheet.transition)
                };
                this.light.setLight(e, r), this.light.updateTransitions(o);
              }
            }, r.prototype._validate = function (e, r, n, i, a) {
              return void 0 === a && (a = {}), (!a || !1 !== a.validate) && je(this, e.call(t.validateStyle, t.extend({
                key: r,
                style: this.serialize(),
                value: n,
                styleSpec: t.styleSpec
              }, i)));
            }, r.prototype._remove = function () {
              for (var e in this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), t.evented.off("pluginStateChange", this._rtlTextPluginCallback), this._layers) {
                this._layers[e].setEventedParent(null);
              }

              for (var r in this.sourceCaches) {
                this.sourceCaches[r].clearTiles(), this.sourceCaches[r].setEventedParent(null);
              }

              this.imageManager.setEventedParent(null), this.setEventedParent(null), this.dispatcher.remove();
            }, r.prototype._clearSource = function (t) {
              this.sourceCaches[t].clearTiles();
            }, r.prototype._reloadSource = function (t) {
              this.sourceCaches[t].resume(), this.sourceCaches[t].reload();
            }, r.prototype._updateSources = function (t) {
              for (var e in this.sourceCaches) {
                this.sourceCaches[e].update(t);
              }
            }, r.prototype._generateCollisionBoxes = function () {
              for (var t in this.sourceCaches) {
                this._reloadSource(t);
              }
            }, r.prototype._updatePlacement = function (e, r, n, i, a) {
              void 0 === a && (a = !1);

              for (var o = !1, s = !1, l = {}, c = 0, u = this._order; c < u.length; c += 1) {
                var f = u[c],
                    h = this._layers[f];

                if ("symbol" === h.type) {
                  if (!l[h.source]) {
                    var p = this.sourceCaches[h.source];
                    l[h.source] = p.getRenderableIds(!0).map(function (t) {
                      return p.getTileByID(t);
                    }).sort(function (t, e) {
                      return e.tileID.overscaledZ - t.tileID.overscaledZ || (t.tileID.isLessThan(e.tileID) ? -1 : 1);
                    });
                  }

                  var d = this.crossTileSymbolIndex.addLayer(h, l[h.source], e.center.lng);
                  o = o || d;
                }
              }

              if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), ((a = a || this._layerOrderChanged || 0 === n) || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(t.browser.now(), e.zoom)) && (this.pauseablePlacement = new ze(e, this._order, a, r, n, i, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, l), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(t.browser.now()), s = !0), o && this.pauseablePlacement.placement.setStale()), s || o) for (var m = 0, g = this._order; m < g.length; m += 1) {
                var v = g[m],
                    y = this._layers[v];
                "symbol" === y.type && this.placement.updateLayerOpacities(y, l[y.source]);
              }
              return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(t.browser.now());
            }, r.prototype._releaseSymbolFadeTiles = function () {
              for (var t in this.sourceCaches) {
                this.sourceCaches[t].releaseSymbolFadeTiles();
              }
            }, r.prototype.getImages = function (t, e, r) {
              this.imageManager.getImages(e.icons, r), this._updateTilesForChangedImages();
              var n = this.sourceCaches[e.source];
              n && n.setDependencies(e.tileID.key, e.type, e.icons);
            }, r.prototype.getGlyphs = function (t, e, r) {
              this.glyphManager.getGlyphs(e.stacks, r);
            }, r.prototype.getResource = function (e, r, n) {
              return t.makeRequest(r, n);
            }, r;
          }(t.Evented);

          He.getSourceType = function (t) {
            return D[t];
          }, He.setSourceType = function (t, e) {
            D[t] = e;
          }, He.registerForPluginStateChange = t.registerForPluginStateChange;
          var Ge = t.createLayout([{
            name: "a_pos",
            type: "Int16",
            components: 2
          }]),
              Ye = yr("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif", "#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}"),
              We = yr("uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
              Xe = yr("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"),
              Ze = yr("varying vec3 v_data;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;varying vec3 v_data;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,0,1);} else {gl_Position=u_matrix*vec4(circle_center,0,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"),
              Je = yr("void main() {gl_FragColor=vec4(1.0);}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
              Ke = yr("uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,0,1);gl_Position=u_matrix*pos;}"),
              Qe = yr("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"),
              $e = yr("varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}", "attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;attribute vec2 a_shift;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,0.0,1.0);gl_Position.xy+=(a_extrude+a_shift)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}"),
              tr = yr("varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}", "attribute vec2 a_pos;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
              er = yr("uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}", "attribute vec2 a_pos;varying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*u_overlay_scale,0,1);}"),
              rr = yr("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_FragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);}"),
              nr = yr("varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),
              ir = yr("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),
              ar = yr("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"),
              or = yr("varying vec4 v_color;void main() {gl_FragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"),
              sr = yr("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"),
              lr = yr("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform float u_maxzoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggeration=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/ pow(2.0,(u_zoom-u_maxzoom)*exaggeration+19.2562-u_zoom);gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
              cr = yr("uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;\n#define PI 3.141592653589793\nvoid main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}"),
              ur = yr("uniform lowp float u_device_pixel_ratio;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}"),
              fr = yr("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp float v_lineprogress;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,vec2(v_lineprogress,0.5));gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define MAX_LINE_DISTANCE 32767.0\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_lineprogress;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_lineprogress=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0/MAX_LINE_DISTANCE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}"),
              hr = yr("uniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}"),
              pr = yr("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}"),
              dr = yr("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"),
              mr = yr("uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0),0.0,1.0);v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;v_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));}"),
              gr = yr("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset),0.0,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}"),
              vr = yr("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale),0.0,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}");

          function yr(t, e) {
            var r = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g,
                n = {};
            return {
              fragmentSource: t = t.replace(r, function (t, e, r, i, a) {
                return n[a] = !0, "define" === e ? "\n#ifndef HAS_UNIFORM_u_" + a + "\nvarying " + r + " " + i + " " + a + ";\n#else\nuniform " + r + " " + i + " u_" + a + ";\n#endif\n" : "\n#ifdef HAS_UNIFORM_u_" + a + "\n    " + r + " " + i + " " + a + " = u_" + a + ";\n#endif\n";
              }),
              vertexSource: e = e.replace(r, function (t, e, r, i, a) {
                var o = "float" === i ? "vec2" : "vec4",
                    s = a.match(/color/) ? "color" : o;
                return n[a] ? "define" === e ? "\n#ifndef HAS_UNIFORM_u_" + a + "\nuniform lowp float u_" + a + "_t;\nattribute " + r + " " + o + " a_" + a + ";\nvarying " + r + " " + i + " " + a + ";\n#else\nuniform " + r + " " + i + " u_" + a + ";\n#endif\n" : "vec4" === s ? "\n#ifndef HAS_UNIFORM_u_" + a + "\n    " + a + " = a_" + a + ";\n#else\n    " + r + " " + i + " " + a + " = u_" + a + ";\n#endif\n" : "\n#ifndef HAS_UNIFORM_u_" + a + "\n    " + a + " = unpack_mix_" + s + "(a_" + a + ", u_" + a + "_t);\n#else\n    " + r + " " + i + " " + a + " = u_" + a + ";\n#endif\n" : "define" === e ? "\n#ifndef HAS_UNIFORM_u_" + a + "\nuniform lowp float u_" + a + "_t;\nattribute " + r + " " + o + " a_" + a + ";\n#else\nuniform " + r + " " + i + " u_" + a + ";\n#endif\n" : "vec4" === s ? "\n#ifndef HAS_UNIFORM_u_" + a + "\n    " + r + " " + i + " " + a + " = a_" + a + ";\n#else\n    " + r + " " + i + " " + a + " = u_" + a + ";\n#endif\n" : "\n#ifndef HAS_UNIFORM_u_" + a + "\n    " + r + " " + i + " " + a + " = unpack_mix_" + s + "(a_" + a + ", u_" + a + "_t);\n#else\n    " + r + " " + i + " " + a + " = u_" + a + ";\n#endif\n";
              })
            };
          }

          var xr = Object.freeze({
            __proto__: null,
            prelude: Ye,
            background: We,
            backgroundPattern: Xe,
            circle: Ze,
            clippingMask: Je,
            heatmap: Ke,
            heatmapTexture: Qe,
            collisionBox: $e,
            collisionCircle: tr,
            debug: er,
            fill: rr,
            fillOutline: nr,
            fillOutlinePattern: ir,
            fillPattern: ar,
            fillExtrusion: or,
            fillExtrusionPattern: sr,
            hillshadePrepare: lr,
            hillshade: cr,
            line: ur,
            lineGradient: fr,
            linePattern: hr,
            lineSDF: pr,
            raster: dr,
            symbolIcon: mr,
            symbolSDF: gr,
            symbolTextAndIcon: vr
          }),
              br = function br() {
            this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
          };

          br.prototype.bind = function (t, e, r, n, i, a, o, s) {
            this.context = t;

            for (var l = this.boundPaintVertexBuffers.length !== n.length, c = 0; !l && c < n.length; c++) {
              this.boundPaintVertexBuffers[c] !== n[c] && (l = !0);
            }

            var u = !this.vao || this.boundProgram !== e || this.boundLayoutVertexBuffer !== r || l || this.boundIndexBuffer !== i || this.boundVertexOffset !== a || this.boundDynamicVertexBuffer !== o || this.boundDynamicVertexBuffer2 !== s;
            !t.extVertexArrayObject || u ? this.freshBind(e, r, n, i, a, o, s) : (t.bindVertexArrayOES.set(this.vao), o && o.bind(), i && i.dynamicDraw && i.bind(), s && s.bind());
          }, br.prototype.freshBind = function (t, e, r, n, i, a, o) {
            var s,
                l = t.numAttributes,
                c = this.context,
                u = c.gl;
            if (c.extVertexArrayObject) this.vao && this.destroy(), this.vao = c.extVertexArrayObject.createVertexArrayOES(), c.bindVertexArrayOES.set(this.vao), s = 0, this.boundProgram = t, this.boundLayoutVertexBuffer = e, this.boundPaintVertexBuffers = r, this.boundIndexBuffer = n, this.boundVertexOffset = i, this.boundDynamicVertexBuffer = a, this.boundDynamicVertexBuffer2 = o;else {
              s = c.currentNumAttributes || 0;

              for (var f = l; f < s; f++) {
                u.disableVertexAttribArray(f);
              }
            }
            e.enableAttributes(u, t);

            for (var h = 0, p = r; h < p.length; h += 1) {
              p[h].enableAttributes(u, t);
            }

            a && a.enableAttributes(u, t), o && o.enableAttributes(u, t), e.bind(), e.setVertexAttribPointers(u, t, i);

            for (var d = 0, m = r; d < m.length; d += 1) {
              var g = m[d];
              g.bind(), g.setVertexAttribPointers(u, t, i);
            }

            a && (a.bind(), a.setVertexAttribPointers(u, t, i)), n && n.bind(), o && (o.bind(), o.setVertexAttribPointers(u, t, i)), c.currentNumAttributes = l;
          }, br.prototype.destroy = function () {
            this.vao && (this.context.extVertexArrayObject.deleteVertexArrayOES(this.vao), this.vao = null);
          };

          var _r = function _r(t, e, r, n, i) {
            var a = t.gl;
            this.program = a.createProgram();
            var o = r ? r.defines() : [];
            i && o.push("#define OVERDRAW_INSPECTOR;");
            var s = o.concat(Ye.fragmentSource, e.fragmentSource).join("\n"),
                l = o.concat(Ye.vertexSource, e.vertexSource).join("\n"),
                c = a.createShader(a.FRAGMENT_SHADER);
            if (a.isContextLost()) this.failedToCreate = !0;else {
              a.shaderSource(c, s), a.compileShader(c), a.attachShader(this.program, c);
              var u = a.createShader(a.VERTEX_SHADER);
              if (a.isContextLost()) this.failedToCreate = !0;else {
                a.shaderSource(u, l), a.compileShader(u), a.attachShader(this.program, u);

                for (var f = r ? r.layoutAttributes : [], h = 0; h < f.length; h++) {
                  a.bindAttribLocation(this.program, h, f[h].name);
                }

                a.linkProgram(this.program), a.deleteShader(u), a.deleteShader(c), this.numAttributes = a.getProgramParameter(this.program, a.ACTIVE_ATTRIBUTES), this.attributes = {};

                for (var p = {}, d = 0; d < this.numAttributes; d++) {
                  var m = a.getActiveAttrib(this.program, d);
                  m && (this.attributes[m.name] = a.getAttribLocation(this.program, m.name));
                }

                for (var g = a.getProgramParameter(this.program, a.ACTIVE_UNIFORMS), v = 0; v < g; v++) {
                  var y = a.getActiveUniform(this.program, v);
                  y && (p[y.name] = a.getUniformLocation(this.program, y.name));
                }

                this.fixedUniforms = n(t, p), this.binderUniforms = r ? r.getUniforms(t, p) : [];
              }
            }
          };

          function wr(t, e, r) {
            var n = 1 / pe(r, 1, e.transform.tileZoom),
                i = Math.pow(2, r.tileID.overscaledZ),
                a = r.tileSize * Math.pow(2, e.transform.tileZoom) / i,
                o = a * (r.tileID.canonical.x + r.tileID.wrap * i),
                s = a * r.tileID.canonical.y;
            return {
              u_image: 0,
              u_texsize: r.imageAtlasTexture.size,
              u_scale: [n, t.fromScale, t.toScale],
              u_fade: t.t,
              u_pixel_coord_upper: [o >> 16, s >> 16],
              u_pixel_coord_lower: [65535 & o, 65535 & s]
            };
          }

          _r.prototype.draw = function (t, e, r, n, i, a, o, s, l, c, u, f, h, p, d, m) {
            var g,
                v = t.gl;

            if (!this.failedToCreate) {
              for (var y in t.program.set(this.program), t.setDepthMode(r), t.setStencilMode(n), t.setColorMode(i), t.setCullFace(a), this.fixedUniforms) {
                this.fixedUniforms[y].set(o[y]);
              }

              p && p.setUniforms(t, this.binderUniforms, f, {
                zoom: h
              });

              for (var x = (g = {}, g[v.LINES] = 2, g[v.TRIANGLES] = 3, g[v.LINE_STRIP] = 1, g)[e], b = 0, _ = u.get(); b < _.length; b += 1) {
                var w = _[b],
                    T = w.vaos || (w.vaos = {});
                (T[s] || (T[s] = new br())).bind(t, this, l, p ? p.getPaintVertexBuffers() : [], c, w.vertexOffset, d, m), v.drawElements(e, w.primitiveLength * x, v.UNSIGNED_SHORT, w.primitiveOffset * x * 2);
              }
            }
          };

          var Tr = function Tr(e, r, n, i) {
            var a = r.style.light,
                o = a.properties.get("position"),
                s = [o.x, o.y, o.z],
                l = t.create$1();
            "viewport" === a.properties.get("anchor") && t.fromRotation(l, -r.transform.angle), t.transformMat3(s, s, l);
            var c = a.properties.get("color");
            return {
              u_matrix: e,
              u_lightpos: s,
              u_lightintensity: a.properties.get("intensity"),
              u_lightcolor: [c.r, c.g, c.b],
              u_vertical_gradient: +n,
              u_opacity: i
            };
          },
              kr = function kr(e, r, n, i, a, o, s) {
            return t.extend(Tr(e, r, n, i), wr(o, r, s), {
              u_height_factor: -Math.pow(2, a.overscaledZ) / s.tileSize / 8
            });
          },
              Mr = function Mr(t) {
            return {
              u_matrix: t
            };
          },
              Ar = function Ar(e, r, n, i) {
            return t.extend(Mr(e), wr(n, r, i));
          },
              Sr = function Sr(t, e) {
            return {
              u_matrix: t,
              u_world: e
            };
          },
              Er = function Er(e, r, n, i, a) {
            return t.extend(Ar(e, r, n, i), {
              u_world: a
            });
          },
              Lr = function Lr(e, r, n, i) {
            var a,
                o,
                s = e.transform;

            if ("map" === i.paint.get("circle-pitch-alignment")) {
              var l = pe(n, 1, s.zoom);
              a = !0, o = [l, l];
            } else a = !1, o = s.pixelsToGLUnits;

            return {
              u_camera_to_center_distance: s.cameraToCenterDistance,
              u_scale_with_map: +("map" === i.paint.get("circle-pitch-scale")),
              u_matrix: e.translatePosMatrix(r.posMatrix, n, i.paint.get("circle-translate"), i.paint.get("circle-translate-anchor")),
              u_pitch_with_map: +a,
              u_device_pixel_ratio: t.browser.devicePixelRatio,
              u_extrude_scale: o
            };
          },
              Cr = function Cr(t, e, r) {
            var n = pe(r, 1, e.zoom),
                i = Math.pow(2, e.zoom - r.tileID.overscaledZ),
                a = r.tileID.overscaleFactor();
            return {
              u_matrix: t,
              u_camera_to_center_distance: e.cameraToCenterDistance,
              u_pixels_to_tile_units: n,
              u_extrude_scale: [e.pixelsToGLUnits[0] / (n * i), e.pixelsToGLUnits[1] / (n * i)],
              u_overscale_factor: a
            };
          },
              Pr = function Pr(t, e, r) {
            return {
              u_matrix: t,
              u_inv_matrix: e,
              u_camera_to_center_distance: r.cameraToCenterDistance,
              u_viewport_size: [r.width, r.height]
            };
          },
              Ir = function Ir(t, e, r) {
            return void 0 === r && (r = 1), {
              u_matrix: t,
              u_color: e,
              u_overlay: 0,
              u_overlay_scale: r
            };
          },
              Or = function Or(t) {
            return {
              u_matrix: t
            };
          },
              zr = function zr(t, e, r, n) {
            return {
              u_matrix: t,
              u_extrude_scale: pe(e, 1, r),
              u_intensity: n
            };
          };

          function Dr(e, r) {
            var n = Math.pow(2, r.canonical.z),
                i = r.canonical.y;
            return [new t.MercatorCoordinate(0, i / n).toLngLat().lat, new t.MercatorCoordinate(0, (i + 1) / n).toLngLat().lat];
          }

          var Rr = function Rr(e, r, n) {
            var i = e.transform;
            return {
              u_matrix: Ur(e, r, n),
              u_ratio: 1 / pe(r, 1, i.zoom),
              u_device_pixel_ratio: t.browser.devicePixelRatio,
              u_units_to_pixels: [1 / i.pixelsToGLUnits[0], 1 / i.pixelsToGLUnits[1]]
            };
          },
              Fr = function Fr(e, r, n) {
            return t.extend(Rr(e, r, n), {
              u_image: 0
            });
          },
              Br = function Br(e, r, n, i) {
            var a = e.transform,
                o = jr(r, a);
            return {
              u_matrix: Ur(e, r, n),
              u_texsize: r.imageAtlasTexture.size,
              u_ratio: 1 / pe(r, 1, a.zoom),
              u_device_pixel_ratio: t.browser.devicePixelRatio,
              u_image: 0,
              u_scale: [o, i.fromScale, i.toScale],
              u_fade: i.t,
              u_units_to_pixels: [1 / a.pixelsToGLUnits[0], 1 / a.pixelsToGLUnits[1]]
            };
          },
              Nr = function Nr(e, r, n, i, a) {
            var o = e.transform,
                s = e.lineAtlas,
                l = jr(r, o),
                c = "round" === n.layout.get("line-cap"),
                u = s.getDash(i.from, c),
                f = s.getDash(i.to, c),
                h = u.width * a.fromScale,
                p = f.width * a.toScale;
            return t.extend(Rr(e, r, n), {
              u_patternscale_a: [l / h, -u.height / 2],
              u_patternscale_b: [l / p, -f.height / 2],
              u_sdfgamma: s.width / (256 * Math.min(h, p) * t.browser.devicePixelRatio) / 2,
              u_image: 0,
              u_tex_y_a: u.y,
              u_tex_y_b: f.y,
              u_mix: a.t
            });
          };

          function jr(t, e) {
            return 1 / pe(t, 1, e.tileZoom);
          }

          function Ur(t, e, r) {
            return t.translatePosMatrix(e.tileID.posMatrix, e, r.paint.get("line-translate"), r.paint.get("line-translate-anchor"));
          }

          var Vr = function Vr(t, e, r, n, i) {
            return {
              u_matrix: t,
              u_tl_parent: e,
              u_scale_parent: r,
              u_buffer_scale: 1,
              u_fade_t: n.mix,
              u_opacity: n.opacity * i.paint.get("raster-opacity"),
              u_image0: 0,
              u_image1: 1,
              u_brightness_low: i.paint.get("raster-brightness-min"),
              u_brightness_high: i.paint.get("raster-brightness-max"),
              u_saturation_factor: (o = i.paint.get("raster-saturation"), o > 0 ? 1 - 1 / (1.001 - o) : -o),
              u_contrast_factor: (a = i.paint.get("raster-contrast"), a > 0 ? 1 / (1 - a) : 1 + a),
              u_spin_weights: qr(i.paint.get("raster-hue-rotate"))
            };
            var a, o;
          };

          function qr(t) {
            t *= Math.PI / 180;
            var e = Math.sin(t),
                r = Math.cos(t);
            return [(2 * r + 1) / 3, (-Math.sqrt(3) * e - r + 1) / 3, (Math.sqrt(3) * e - r + 1) / 3];
          }

          var Hr,
              Gr = function Gr(t, e, r, n, i, a, o, s, l, c) {
            var u = i.transform;
            return {
              u_is_size_zoom_constant: +("constant" === t || "source" === t),
              u_is_size_feature_constant: +("constant" === t || "camera" === t),
              u_size_t: e ? e.uSizeT : 0,
              u_size: e ? e.uSize : 0,
              u_camera_to_center_distance: u.cameraToCenterDistance,
              u_pitch: u.pitch / 360 * 2 * Math.PI,
              u_rotate_symbol: +r,
              u_aspect_ratio: u.width / u.height,
              u_fade_change: i.options.fadeDuration ? i.symbolFadeChange : 1,
              u_matrix: a,
              u_label_plane_matrix: o,
              u_coord_matrix: s,
              u_is_text: +l,
              u_pitch_with_map: +n,
              u_texsize: c,
              u_texture: 0
            };
          },
              Yr = function Yr(e, r, n, i, a, o, s, l, c, u, f) {
            var h = a.transform;
            return t.extend(Gr(e, r, n, i, a, o, s, l, c, u), {
              u_gamma_scale: i ? Math.cos(h._pitch) * h.cameraToCenterDistance : 1,
              u_device_pixel_ratio: t.browser.devicePixelRatio,
              u_is_halo: +f
            });
          },
              Wr = function Wr(e, r, n, i, a, o, s, l, c, u) {
            return t.extend(Yr(e, r, n, i, a, o, s, l, !0, c, !0), {
              u_texsize_icon: u,
              u_texture_icon: 1
            });
          },
              Xr = function Xr(t, e, r) {
            return {
              u_matrix: t,
              u_opacity: e,
              u_color: r
            };
          },
              Zr = function Zr(e, r, n, i, a, o) {
            return t.extend(function (t, e, r, n) {
              var i = r.imageManager.getPattern(t.from.toString()),
                  a = r.imageManager.getPattern(t.to.toString()),
                  o = r.imageManager.getPixelSize(),
                  s = o.width,
                  l = o.height,
                  c = Math.pow(2, n.tileID.overscaledZ),
                  u = n.tileSize * Math.pow(2, r.transform.tileZoom) / c,
                  f = u * (n.tileID.canonical.x + n.tileID.wrap * c),
                  h = u * n.tileID.canonical.y;
              return {
                u_image: 0,
                u_pattern_tl_a: i.tl,
                u_pattern_br_a: i.br,
                u_pattern_tl_b: a.tl,
                u_pattern_br_b: a.br,
                u_texsize: [s, l],
                u_mix: e.t,
                u_pattern_size_a: i.displaySize,
                u_pattern_size_b: a.displaySize,
                u_scale_a: e.fromScale,
                u_scale_b: e.toScale,
                u_tile_units_to_pixels: 1 / pe(n, 1, r.transform.tileZoom),
                u_pixel_coord_upper: [f >> 16, h >> 16],
                u_pixel_coord_lower: [65535 & f, 65535 & h]
              };
            }(i, o, n, a), {
              u_matrix: e,
              u_opacity: r
            });
          },
              Jr = {
            fillExtrusion: function fillExtrusion(e, r) {
              return {
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix),
                u_lightpos: new t.Uniform3f(e, r.u_lightpos),
                u_lightintensity: new t.Uniform1f(e, r.u_lightintensity),
                u_lightcolor: new t.Uniform3f(e, r.u_lightcolor),
                u_vertical_gradient: new t.Uniform1f(e, r.u_vertical_gradient),
                u_opacity: new t.Uniform1f(e, r.u_opacity)
              };
            },
            fillExtrusionPattern: function fillExtrusionPattern(e, r) {
              return {
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix),
                u_lightpos: new t.Uniform3f(e, r.u_lightpos),
                u_lightintensity: new t.Uniform1f(e, r.u_lightintensity),
                u_lightcolor: new t.Uniform3f(e, r.u_lightcolor),
                u_vertical_gradient: new t.Uniform1f(e, r.u_vertical_gradient),
                u_height_factor: new t.Uniform1f(e, r.u_height_factor),
                u_image: new t.Uniform1i(e, r.u_image),
                u_texsize: new t.Uniform2f(e, r.u_texsize),
                u_pixel_coord_upper: new t.Uniform2f(e, r.u_pixel_coord_upper),
                u_pixel_coord_lower: new t.Uniform2f(e, r.u_pixel_coord_lower),
                u_scale: new t.Uniform3f(e, r.u_scale),
                u_fade: new t.Uniform1f(e, r.u_fade),
                u_opacity: new t.Uniform1f(e, r.u_opacity)
              };
            },
            fill: function fill(e, r) {
              return {
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix)
              };
            },
            fillPattern: function fillPattern(e, r) {
              return {
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix),
                u_image: new t.Uniform1i(e, r.u_image),
                u_texsize: new t.Uniform2f(e, r.u_texsize),
                u_pixel_coord_upper: new t.Uniform2f(e, r.u_pixel_coord_upper),
                u_pixel_coord_lower: new t.Uniform2f(e, r.u_pixel_coord_lower),
                u_scale: new t.Uniform3f(e, r.u_scale),
                u_fade: new t.Uniform1f(e, r.u_fade)
              };
            },
            fillOutline: function fillOutline(e, r) {
              return {
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix),
                u_world: new t.Uniform2f(e, r.u_world)
              };
            },
            fillOutlinePattern: function fillOutlinePattern(e, r) {
              return {
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix),
                u_world: new t.Uniform2f(e, r.u_world),
                u_image: new t.Uniform1i(e, r.u_image),
                u_texsize: new t.Uniform2f(e, r.u_texsize),
                u_pixel_coord_upper: new t.Uniform2f(e, r.u_pixel_coord_upper),
                u_pixel_coord_lower: new t.Uniform2f(e, r.u_pixel_coord_lower),
                u_scale: new t.Uniform3f(e, r.u_scale),
                u_fade: new t.Uniform1f(e, r.u_fade)
              };
            },
            circle: function circle(e, r) {
              return {
                u_camera_to_center_distance: new t.Uniform1f(e, r.u_camera_to_center_distance),
                u_scale_with_map: new t.Uniform1i(e, r.u_scale_with_map),
                u_pitch_with_map: new t.Uniform1i(e, r.u_pitch_with_map),
                u_extrude_scale: new t.Uniform2f(e, r.u_extrude_scale),
                u_device_pixel_ratio: new t.Uniform1f(e, r.u_device_pixel_ratio),
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix)
              };
            },
            collisionBox: function collisionBox(e, r) {
              return {
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix),
                u_camera_to_center_distance: new t.Uniform1f(e, r.u_camera_to_center_distance),
                u_pixels_to_tile_units: new t.Uniform1f(e, r.u_pixels_to_tile_units),
                u_extrude_scale: new t.Uniform2f(e, r.u_extrude_scale),
                u_overscale_factor: new t.Uniform1f(e, r.u_overscale_factor)
              };
            },
            collisionCircle: function collisionCircle(e, r) {
              return {
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix),
                u_inv_matrix: new t.UniformMatrix4f(e, r.u_inv_matrix),
                u_camera_to_center_distance: new t.Uniform1f(e, r.u_camera_to_center_distance),
                u_viewport_size: new t.Uniform2f(e, r.u_viewport_size)
              };
            },
            debug: function debug(e, r) {
              return {
                u_color: new t.UniformColor(e, r.u_color),
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix),
                u_overlay: new t.Uniform1i(e, r.u_overlay),
                u_overlay_scale: new t.Uniform1f(e, r.u_overlay_scale)
              };
            },
            clippingMask: function clippingMask(e, r) {
              return {
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix)
              };
            },
            heatmap: function heatmap(e, r) {
              return {
                u_extrude_scale: new t.Uniform1f(e, r.u_extrude_scale),
                u_intensity: new t.Uniform1f(e, r.u_intensity),
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix)
              };
            },
            heatmapTexture: function heatmapTexture(e, r) {
              return {
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix),
                u_world: new t.Uniform2f(e, r.u_world),
                u_image: new t.Uniform1i(e, r.u_image),
                u_color_ramp: new t.Uniform1i(e, r.u_color_ramp),
                u_opacity: new t.Uniform1f(e, r.u_opacity)
              };
            },
            hillshade: function hillshade(e, r) {
              return {
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix),
                u_image: new t.Uniform1i(e, r.u_image),
                u_latrange: new t.Uniform2f(e, r.u_latrange),
                u_light: new t.Uniform2f(e, r.u_light),
                u_shadow: new t.UniformColor(e, r.u_shadow),
                u_highlight: new t.UniformColor(e, r.u_highlight),
                u_accent: new t.UniformColor(e, r.u_accent)
              };
            },
            hillshadePrepare: function hillshadePrepare(e, r) {
              return {
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix),
                u_image: new t.Uniform1i(e, r.u_image),
                u_dimension: new t.Uniform2f(e, r.u_dimension),
                u_zoom: new t.Uniform1f(e, r.u_zoom),
                u_maxzoom: new t.Uniform1f(e, r.u_maxzoom),
                u_unpack: new t.Uniform4f(e, r.u_unpack)
              };
            },
            line: function line(e, r) {
              return {
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix),
                u_ratio: new t.Uniform1f(e, r.u_ratio),
                u_device_pixel_ratio: new t.Uniform1f(e, r.u_device_pixel_ratio),
                u_units_to_pixels: new t.Uniform2f(e, r.u_units_to_pixels)
              };
            },
            lineGradient: function lineGradient(e, r) {
              return {
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix),
                u_ratio: new t.Uniform1f(e, r.u_ratio),
                u_device_pixel_ratio: new t.Uniform1f(e, r.u_device_pixel_ratio),
                u_units_to_pixels: new t.Uniform2f(e, r.u_units_to_pixels),
                u_image: new t.Uniform1i(e, r.u_image)
              };
            },
            linePattern: function linePattern(e, r) {
              return {
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix),
                u_texsize: new t.Uniform2f(e, r.u_texsize),
                u_ratio: new t.Uniform1f(e, r.u_ratio),
                u_device_pixel_ratio: new t.Uniform1f(e, r.u_device_pixel_ratio),
                u_image: new t.Uniform1i(e, r.u_image),
                u_units_to_pixels: new t.Uniform2f(e, r.u_units_to_pixels),
                u_scale: new t.Uniform3f(e, r.u_scale),
                u_fade: new t.Uniform1f(e, r.u_fade)
              };
            },
            lineSDF: function lineSDF(e, r) {
              return {
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix),
                u_ratio: new t.Uniform1f(e, r.u_ratio),
                u_device_pixel_ratio: new t.Uniform1f(e, r.u_device_pixel_ratio),
                u_units_to_pixels: new t.Uniform2f(e, r.u_units_to_pixels),
                u_patternscale_a: new t.Uniform2f(e, r.u_patternscale_a),
                u_patternscale_b: new t.Uniform2f(e, r.u_patternscale_b),
                u_sdfgamma: new t.Uniform1f(e, r.u_sdfgamma),
                u_image: new t.Uniform1i(e, r.u_image),
                u_tex_y_a: new t.Uniform1f(e, r.u_tex_y_a),
                u_tex_y_b: new t.Uniform1f(e, r.u_tex_y_b),
                u_mix: new t.Uniform1f(e, r.u_mix)
              };
            },
            raster: function raster(e, r) {
              return {
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix),
                u_tl_parent: new t.Uniform2f(e, r.u_tl_parent),
                u_scale_parent: new t.Uniform1f(e, r.u_scale_parent),
                u_buffer_scale: new t.Uniform1f(e, r.u_buffer_scale),
                u_fade_t: new t.Uniform1f(e, r.u_fade_t),
                u_opacity: new t.Uniform1f(e, r.u_opacity),
                u_image0: new t.Uniform1i(e, r.u_image0),
                u_image1: new t.Uniform1i(e, r.u_image1),
                u_brightness_low: new t.Uniform1f(e, r.u_brightness_low),
                u_brightness_high: new t.Uniform1f(e, r.u_brightness_high),
                u_saturation_factor: new t.Uniform1f(e, r.u_saturation_factor),
                u_contrast_factor: new t.Uniform1f(e, r.u_contrast_factor),
                u_spin_weights: new t.Uniform3f(e, r.u_spin_weights)
              };
            },
            symbolIcon: function symbolIcon(e, r) {
              return {
                u_is_size_zoom_constant: new t.Uniform1i(e, r.u_is_size_zoom_constant),
                u_is_size_feature_constant: new t.Uniform1i(e, r.u_is_size_feature_constant),
                u_size_t: new t.Uniform1f(e, r.u_size_t),
                u_size: new t.Uniform1f(e, r.u_size),
                u_camera_to_center_distance: new t.Uniform1f(e, r.u_camera_to_center_distance),
                u_pitch: new t.Uniform1f(e, r.u_pitch),
                u_rotate_symbol: new t.Uniform1i(e, r.u_rotate_symbol),
                u_aspect_ratio: new t.Uniform1f(e, r.u_aspect_ratio),
                u_fade_change: new t.Uniform1f(e, r.u_fade_change),
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix),
                u_label_plane_matrix: new t.UniformMatrix4f(e, r.u_label_plane_matrix),
                u_coord_matrix: new t.UniformMatrix4f(e, r.u_coord_matrix),
                u_is_text: new t.Uniform1i(e, r.u_is_text),
                u_pitch_with_map: new t.Uniform1i(e, r.u_pitch_with_map),
                u_texsize: new t.Uniform2f(e, r.u_texsize),
                u_texture: new t.Uniform1i(e, r.u_texture)
              };
            },
            symbolSDF: function symbolSDF(e, r) {
              return {
                u_is_size_zoom_constant: new t.Uniform1i(e, r.u_is_size_zoom_constant),
                u_is_size_feature_constant: new t.Uniform1i(e, r.u_is_size_feature_constant),
                u_size_t: new t.Uniform1f(e, r.u_size_t),
                u_size: new t.Uniform1f(e, r.u_size),
                u_camera_to_center_distance: new t.Uniform1f(e, r.u_camera_to_center_distance),
                u_pitch: new t.Uniform1f(e, r.u_pitch),
                u_rotate_symbol: new t.Uniform1i(e, r.u_rotate_symbol),
                u_aspect_ratio: new t.Uniform1f(e, r.u_aspect_ratio),
                u_fade_change: new t.Uniform1f(e, r.u_fade_change),
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix),
                u_label_plane_matrix: new t.UniformMatrix4f(e, r.u_label_plane_matrix),
                u_coord_matrix: new t.UniformMatrix4f(e, r.u_coord_matrix),
                u_is_text: new t.Uniform1i(e, r.u_is_text),
                u_pitch_with_map: new t.Uniform1i(e, r.u_pitch_with_map),
                u_texsize: new t.Uniform2f(e, r.u_texsize),
                u_texture: new t.Uniform1i(e, r.u_texture),
                u_gamma_scale: new t.Uniform1f(e, r.u_gamma_scale),
                u_device_pixel_ratio: new t.Uniform1f(e, r.u_device_pixel_ratio),
                u_is_halo: new t.Uniform1i(e, r.u_is_halo)
              };
            },
            symbolTextAndIcon: function symbolTextAndIcon(e, r) {
              return {
                u_is_size_zoom_constant: new t.Uniform1i(e, r.u_is_size_zoom_constant),
                u_is_size_feature_constant: new t.Uniform1i(e, r.u_is_size_feature_constant),
                u_size_t: new t.Uniform1f(e, r.u_size_t),
                u_size: new t.Uniform1f(e, r.u_size),
                u_camera_to_center_distance: new t.Uniform1f(e, r.u_camera_to_center_distance),
                u_pitch: new t.Uniform1f(e, r.u_pitch),
                u_rotate_symbol: new t.Uniform1i(e, r.u_rotate_symbol),
                u_aspect_ratio: new t.Uniform1f(e, r.u_aspect_ratio),
                u_fade_change: new t.Uniform1f(e, r.u_fade_change),
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix),
                u_label_plane_matrix: new t.UniformMatrix4f(e, r.u_label_plane_matrix),
                u_coord_matrix: new t.UniformMatrix4f(e, r.u_coord_matrix),
                u_is_text: new t.Uniform1i(e, r.u_is_text),
                u_pitch_with_map: new t.Uniform1i(e, r.u_pitch_with_map),
                u_texsize: new t.Uniform2f(e, r.u_texsize),
                u_texsize_icon: new t.Uniform2f(e, r.u_texsize_icon),
                u_texture: new t.Uniform1i(e, r.u_texture),
                u_texture_icon: new t.Uniform1i(e, r.u_texture_icon),
                u_gamma_scale: new t.Uniform1f(e, r.u_gamma_scale),
                u_device_pixel_ratio: new t.Uniform1f(e, r.u_device_pixel_ratio),
                u_is_halo: new t.Uniform1i(e, r.u_is_halo)
              };
            },
            background: function background(e, r) {
              return {
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix),
                u_opacity: new t.Uniform1f(e, r.u_opacity),
                u_color: new t.UniformColor(e, r.u_color)
              };
            },
            backgroundPattern: function backgroundPattern(e, r) {
              return {
                u_matrix: new t.UniformMatrix4f(e, r.u_matrix),
                u_opacity: new t.Uniform1f(e, r.u_opacity),
                u_image: new t.Uniform1i(e, r.u_image),
                u_pattern_tl_a: new t.Uniform2f(e, r.u_pattern_tl_a),
                u_pattern_br_a: new t.Uniform2f(e, r.u_pattern_br_a),
                u_pattern_tl_b: new t.Uniform2f(e, r.u_pattern_tl_b),
                u_pattern_br_b: new t.Uniform2f(e, r.u_pattern_br_b),
                u_texsize: new t.Uniform2f(e, r.u_texsize),
                u_mix: new t.Uniform1f(e, r.u_mix),
                u_pattern_size_a: new t.Uniform2f(e, r.u_pattern_size_a),
                u_pattern_size_b: new t.Uniform2f(e, r.u_pattern_size_b),
                u_scale_a: new t.Uniform1f(e, r.u_scale_a),
                u_scale_b: new t.Uniform1f(e, r.u_scale_b),
                u_pixel_coord_upper: new t.Uniform2f(e, r.u_pixel_coord_upper),
                u_pixel_coord_lower: new t.Uniform2f(e, r.u_pixel_coord_lower),
                u_tile_units_to_pixels: new t.Uniform1f(e, r.u_tile_units_to_pixels)
              };
            }
          };

          function Kr(e, r, n, i, a, o, s) {
            for (var l = e.context, c = l.gl, u = e.useProgram("collisionBox"), f = [], h = 0, p = 0, d = 0; d < i.length; d++) {
              var m = i[d],
                  g = r.getTile(m),
                  v = g.getBucket(n);

              if (v) {
                var y = m.posMatrix;
                0 === a[0] && 0 === a[1] || (y = e.translatePosMatrix(m.posMatrix, g, a, o));
                var x = s ? v.textCollisionBox : v.iconCollisionBox,
                    b = v.collisionCircleArray;

                if (b.length > 0) {
                  var _ = t.create(),
                      w = y;

                  t.mul(_, v.placementInvProjMatrix, e.transform.glCoordMatrix), t.mul(_, _, v.placementViewportMatrix), f.push({
                    circleArray: b,
                    circleOffset: p,
                    transform: w,
                    invTransform: _
                  }), p = h += b.length / 4;
                }

                x && u.draw(l, c.LINES, Mt.disabled, At.disabled, e.colorModeForRenderPass(), Et.disabled, Cr(y, e.transform, g), n.id, x.layoutVertexBuffer, x.indexBuffer, x.segments, null, e.transform.zoom, null, null, x.collisionVertexBuffer);
              }
            }

            if (s && f.length) {
              var T = e.useProgram("collisionCircle"),
                  k = new t.StructArrayLayout2f1f2i16();
              k.resize(4 * h), k._trim();

              for (var M = 0, A = 0, S = f; A < S.length; A += 1) {
                for (var E = S[A], L = 0; L < E.circleArray.length / 4; L++) {
                  var C = 4 * L,
                      P = E.circleArray[C + 0],
                      I = E.circleArray[C + 1],
                      O = E.circleArray[C + 2],
                      z = E.circleArray[C + 3];
                  k.emplace(M++, P, I, O, z, 0), k.emplace(M++, P, I, O, z, 1), k.emplace(M++, P, I, O, z, 2), k.emplace(M++, P, I, O, z, 3);
                }
              }

              (!Hr || Hr.length < 2 * h) && (Hr = function (e) {
                var r = 2 * e,
                    n = new t.StructArrayLayout3ui6();
                n.resize(r), n._trim();

                for (var i = 0; i < r; i++) {
                  var a = 6 * i;
                  n.uint16[a + 0] = 4 * i + 0, n.uint16[a + 1] = 4 * i + 1, n.uint16[a + 2] = 4 * i + 2, n.uint16[a + 3] = 4 * i + 2, n.uint16[a + 4] = 4 * i + 3, n.uint16[a + 5] = 4 * i + 0;
                }

                return n;
              }(h));

              for (var D = l.createIndexBuffer(Hr, !0), R = l.createVertexBuffer(k, t.collisionCircleLayout.members, !0), F = 0, B = f; F < B.length; F += 1) {
                var N = B[F],
                    j = Pr(N.transform, N.invTransform, e.transform);
                T.draw(l, c.TRIANGLES, Mt.disabled, At.disabled, e.colorModeForRenderPass(), Et.disabled, j, n.id, R, D, t.SegmentVector.simpleSegment(0, 2 * N.circleOffset, N.circleArray.length, N.circleArray.length / 2), null, e.transform.zoom, null, null, null);
              }

              R.destroy(), D.destroy();
            }
          }

          var Qr = t.identity(new Float32Array(16));

          function $r(e, r, n, i, a, o) {
            var s = t.getAnchorAlignment(e),
                l = -(s.horizontalAlign - .5) * r,
                c = -(s.verticalAlign - .5) * n,
                u = t.evaluateVariableOffset(e, i);
            return new t.Point((l / a + u[0]) * o, (c / a + u[1]) * o);
          }

          function tn(e, r, n, i, a, o, s, l, c, u, f) {
            var h = e.text.placedSymbolArray,
                p = e.text.dynamicLayoutVertexArray,
                d = e.icon.dynamicLayoutVertexArray,
                m = {};
            p.clear();

            for (var g = 0; g < h.length; g++) {
              var v = h.get(g),
                  y = e.allowVerticalPlacement && !v.placedOrientation,
                  x = v.hidden || !v.crossTileID || y ? null : i[v.crossTileID];

              if (x) {
                var b = new t.Point(v.anchorX, v.anchorY),
                    _ = te(b, n ? l : s),
                    w = ee(o.cameraToCenterDistance, _.signedDistanceFromCamera),
                    T = a.evaluateSizeForFeature(e.textSizeData, u, v) * w / t.ONE_EM;

                n && (T *= e.tilePixelRatio / c);

                for (var k = x.width, M = x.height, A = $r(x.anchor, k, M, x.textOffset, x.textBoxScale, T), S = n ? te(b.add(A), s).point : _.point.add(r ? A.rotate(-o.angle) : A), E = e.allowVerticalPlacement && v.placedOrientation === t.WritingMode.vertical ? Math.PI / 2 : 0, L = 0; L < v.numGlyphs; L++) {
                  t.addDynamicAttributes(p, S, E);
                }

                f && v.associatedIconIndex >= 0 && (m[v.associatedIconIndex] = {
                  shiftedAnchor: S,
                  angle: E
                });
              } else ue(v.numGlyphs, p);
            }

            if (f) {
              d.clear();

              for (var C = e.icon.placedSymbolArray, P = 0; P < C.length; P++) {
                var I = C.get(P);
                if (I.hidden) ue(I.numGlyphs, d);else {
                  var O = m[P];
                  if (O) for (var z = 0; z < I.numGlyphs; z++) {
                    t.addDynamicAttributes(d, O.shiftedAnchor, O.angle);
                  } else ue(I.numGlyphs, d);
                }
              }

              e.icon.dynamicLayoutVertexBuffer.updateData(d);
            }

            e.text.dynamicLayoutVertexBuffer.updateData(p);
          }

          function en(t, e, r) {
            return r.iconsInText && e ? "symbolTextAndIcon" : t ? "symbolSDF" : "symbolIcon";
          }

          function rn(e, r, n, i, a, o, s, l, c, u, f, h) {
            for (var p = e.context, d = p.gl, m = e.transform, g = "map" === l, v = "map" === c, y = g && "point" !== n.layout.get("symbol-placement"), x = g && !v && !y, b = void 0 !== n.layout.get("symbol-sort-key").constantOr(1), _ = e.depthModeForSublayer(0, Mt.ReadOnly), w = n.layout.get("text-variable-anchor"), T = [], k = 0, M = i; k < M.length; k += 1) {
              var A = M[k],
                  S = r.getTile(A),
                  E = S.getBucket(n);

              if (E) {
                var L = a ? E.text : E.icon;

                if (L && L.segments.get().length) {
                  var C = L.programConfigurations.get(n.id),
                      P = a || E.sdfIcons,
                      I = a ? E.textSizeData : E.iconSizeData,
                      O = v || 0 !== m.pitch,
                      z = e.useProgram(en(P, a, E), C),
                      D = t.evaluateSizeForZoom(I, m.zoom),
                      R = void 0,
                      F = [0, 0],
                      B = void 0,
                      N = void 0,
                      j = null,
                      U = void 0;

                  if (a) {
                    if (B = S.glyphAtlasTexture, N = d.LINEAR, R = S.glyphAtlasTexture.size, E.iconsInText) {
                      F = S.imageAtlasTexture.size, j = S.imageAtlasTexture;
                      var V = "composite" === I.kind || "camera" === I.kind;
                      U = O || e.options.rotating || e.options.zooming || V ? d.LINEAR : d.NEAREST;
                    }
                  } else {
                    var q = 1 !== n.layout.get("icon-size").constantOr(0) || E.iconsNeedLinear;
                    B = S.imageAtlasTexture, N = P || e.options.rotating || e.options.zooming || q || O ? d.LINEAR : d.NEAREST, R = S.imageAtlasTexture.size;
                  }

                  var H = pe(S, 1, e.transform.zoom),
                      G = Qt(A.posMatrix, v, g, e.transform, H),
                      Y = $t(A.posMatrix, v, g, e.transform, H),
                      W = w && E.hasTextData(),
                      X = "none" !== n.layout.get("icon-text-fit") && W && E.hasIconData();
                  y && ne(E, A.posMatrix, e, a, G, Y, v, u);
                  var Z = e.translatePosMatrix(A.posMatrix, S, o, s),
                      J = y || a && w || X ? Qr : G,
                      K = e.translatePosMatrix(Y, S, o, s, !0),
                      Q = P && 0 !== n.paint.get(a ? "text-halo-width" : "icon-halo-width").constantOr(1),
                      $ = {
                    program: z,
                    buffers: L,
                    uniformValues: P ? E.iconsInText ? Wr(I.kind, D, x, v, e, Z, J, K, R, F) : Yr(I.kind, D, x, v, e, Z, J, K, a, R, !0) : Gr(I.kind, D, x, v, e, Z, J, K, a, R),
                    atlasTexture: B,
                    atlasTextureIcon: j,
                    atlasInterpolation: N,
                    atlasInterpolationIcon: U,
                    isSDF: P,
                    hasHalo: Q
                  };
                  if (b) for (var tt = 0, et = L.segments.get(); tt < et.length; tt += 1) {
                    var rt = et[tt];
                    T.push({
                      segments: new t.SegmentVector([rt]),
                      sortKey: rt.sortKey,
                      state: $
                    });
                  } else T.push({
                    segments: L.segments,
                    sortKey: 0,
                    state: $
                  });
                }
              }
            }

            b && T.sort(function (t, e) {
              return t.sortKey - e.sortKey;
            });

            for (var nt = 0, it = T; nt < it.length; nt += 1) {
              var at = it[nt],
                  ot = at.state;

              if (p.activeTexture.set(d.TEXTURE0), ot.atlasTexture.bind(ot.atlasInterpolation, d.CLAMP_TO_EDGE), ot.atlasTextureIcon && (p.activeTexture.set(d.TEXTURE1), ot.atlasTextureIcon && ot.atlasTextureIcon.bind(ot.atlasInterpolationIcon, d.CLAMP_TO_EDGE)), ot.isSDF) {
                var st = ot.uniformValues;
                ot.hasHalo && (st.u_is_halo = 1, nn(ot.buffers, at.segments, n, e, ot.program, _, f, h, st)), st.u_is_halo = 0;
              }

              nn(ot.buffers, at.segments, n, e, ot.program, _, f, h, ot.uniformValues);
            }
          }

          function nn(t, e, r, n, i, a, o, s, l) {
            var c = n.context,
                u = c.gl;
            i.draw(c, u.TRIANGLES, a, o, s, Et.disabled, l, r.id, t.layoutVertexBuffer, t.indexBuffer, e, r.paint, n.transform.zoom, t.programConfigurations.get(r.id), t.dynamicLayoutVertexBuffer, t.opacityVertexBuffer);
          }

          function an(t, e, r, n, i, a, o) {
            var s,
                l,
                c,
                u,
                f,
                h = t.context.gl,
                p = r.paint.get("fill-pattern"),
                d = p && p.constantOr(1),
                m = r.getCrossfadeParameters();
            o ? (l = d && !r.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", s = h.LINES) : (l = d ? "fillPattern" : "fill", s = h.TRIANGLES);

            for (var g = 0, v = n; g < v.length; g += 1) {
              var y = v[g],
                  x = e.getTile(y);

              if (!d || x.patternsLoaded()) {
                var b = x.getBucket(r);

                if (b) {
                  var _ = b.programConfigurations.get(r.id),
                      w = t.useProgram(l, _);

                  d && (t.context.activeTexture.set(h.TEXTURE0), x.imageAtlasTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), _.updatePaintBuffers(m));
                  var T = p.constantOr(null);

                  if (T && x.imageAtlas) {
                    var k = x.imageAtlas,
                        M = k.patternPositions[T.to.toString()],
                        A = k.patternPositions[T.from.toString()];
                    M && A && _.setConstantPatternPositions(M, A);
                  }

                  var S = t.translatePosMatrix(y.posMatrix, x, r.paint.get("fill-translate"), r.paint.get("fill-translate-anchor"));

                  if (o) {
                    u = b.indexBuffer2, f = b.segments2;
                    var E = [h.drawingBufferWidth, h.drawingBufferHeight];
                    c = "fillOutlinePattern" === l && d ? Er(S, t, m, x, E) : Sr(S, E);
                  } else u = b.indexBuffer, f = b.segments, c = d ? Ar(S, t, m, x) : Mr(S);

                  w.draw(t.context, s, i, t.stencilModeForClipping(y), a, Et.disabled, c, r.id, b.layoutVertexBuffer, u, f, r.paint, t.transform.zoom, _);
                }
              }
            }
          }

          function on(t, e, r, n, i, a, o) {
            for (var s = t.context, l = s.gl, c = r.paint.get("fill-extrusion-pattern"), u = c.constantOr(1), f = r.getCrossfadeParameters(), h = r.paint.get("fill-extrusion-opacity"), p = 0, d = n; p < d.length; p += 1) {
              var m = d[p],
                  g = e.getTile(m),
                  v = g.getBucket(r);

              if (v) {
                var y = v.programConfigurations.get(r.id),
                    x = t.useProgram(u ? "fillExtrusionPattern" : "fillExtrusion", y);
                u && (t.context.activeTexture.set(l.TEXTURE0), g.imageAtlasTexture.bind(l.LINEAR, l.CLAMP_TO_EDGE), y.updatePaintBuffers(f));
                var b = c.constantOr(null);

                if (b && g.imageAtlas) {
                  var _ = g.imageAtlas,
                      w = _.patternPositions[b.to.toString()],
                      T = _.patternPositions[b.from.toString()];

                  w && T && y.setConstantPatternPositions(w, T);
                }

                var k = t.translatePosMatrix(m.posMatrix, g, r.paint.get("fill-extrusion-translate"), r.paint.get("fill-extrusion-translate-anchor")),
                    M = r.paint.get("fill-extrusion-vertical-gradient"),
                    A = u ? kr(k, t, M, h, m, f, g) : Tr(k, t, M, h);
                x.draw(s, s.gl.TRIANGLES, i, a, o, Et.backCCW, A, r.id, v.layoutVertexBuffer, v.indexBuffer, v.segments, r.paint, t.transform.zoom, y);
              }
            }
          }

          function sn(t, e, r, n, i, a) {
            var o = t.context,
                s = o.gl,
                l = e.fbo;

            if (l) {
              var c = t.useProgram("hillshade");
              o.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_2D, l.colorAttachment.get());

              var u = function (t, e, r) {
                var n = r.paint.get("hillshade-shadow-color"),
                    i = r.paint.get("hillshade-highlight-color"),
                    a = r.paint.get("hillshade-accent-color"),
                    o = r.paint.get("hillshade-illumination-direction") * (Math.PI / 180);
                "viewport" === r.paint.get("hillshade-illumination-anchor") && (o -= t.transform.angle);
                var s = !t.options.moving;
                return {
                  u_matrix: t.transform.calculatePosMatrix(e.tileID.toUnwrapped(), s),
                  u_image: 0,
                  u_latrange: Dr(t, e.tileID),
                  u_light: [r.paint.get("hillshade-exaggeration"), o],
                  u_shadow: n,
                  u_highlight: i,
                  u_accent: a
                };
              }(t, e, r);

              c.draw(o, s.TRIANGLES, n, i, a, Et.disabled, u, r.id, t.rasterBoundsBuffer, t.quadTriangleIndexBuffer, t.rasterBoundsSegments);
            }
          }

          function ln(e, r, n, i, a, o, s) {
            var l = e.context,
                c = l.gl,
                u = r.dem;

            if (u && u.data) {
              var f = u.dim,
                  h = u.stride,
                  p = u.getPixels();

              if (l.activeTexture.set(c.TEXTURE1), l.pixelStoreUnpackPremultiplyAlpha.set(!1), r.demTexture = r.demTexture || e.getTileTexture(h), r.demTexture) {
                var d = r.demTexture;
                d.update(p, {
                  premultiply: !1
                }), d.bind(c.NEAREST, c.CLAMP_TO_EDGE);
              } else r.demTexture = new t.Texture(l, p, c.RGBA, {
                premultiply: !1
              }), r.demTexture.bind(c.NEAREST, c.CLAMP_TO_EDGE);

              l.activeTexture.set(c.TEXTURE0);
              var m = r.fbo;

              if (!m) {
                var g = new t.Texture(l, {
                  width: f,
                  height: f,
                  data: null
                }, c.RGBA);
                g.bind(c.LINEAR, c.CLAMP_TO_EDGE), (m = r.fbo = l.createFramebuffer(f, f, !0)).colorAttachment.set(g.texture);
              }

              l.bindFramebuffer.set(m.framebuffer), l.viewport.set([0, 0, f, f]), e.useProgram("hillshadePrepare").draw(l, c.TRIANGLES, a, o, s, Et.disabled, function (e, r, n) {
                var i = r.stride,
                    a = t.create();
                return t.ortho(a, 0, t.EXTENT, -t.EXTENT, 0, 0, 1), t.translate(a, a, [0, -t.EXTENT, 0]), {
                  u_matrix: a,
                  u_image: 1,
                  u_dimension: [i, i],
                  u_zoom: e.overscaledZ,
                  u_maxzoom: n,
                  u_unpack: r.getUnpackVector()
                };
              }(r.tileID, u, i), n.id, e.rasterBoundsBuffer, e.quadTriangleIndexBuffer, e.rasterBoundsSegments), r.needsHillshadePrepare = !1;
            }
          }

          function cn(e, r, n, i, a) {
            var o = i.paint.get("raster-fade-duration");

            if (o > 0) {
              var s = t.browser.now(),
                  l = (s - e.timeAdded) / o,
                  c = r ? (s - r.timeAdded) / o : -1,
                  u = n.getSource(),
                  f = a.coveringZoomLevel({
                tileSize: u.tileSize,
                roundZoom: u.roundZoom
              }),
                  h = !r || Math.abs(r.tileID.overscaledZ - f) > Math.abs(e.tileID.overscaledZ - f),
                  p = h && e.refreshedUponExpiration ? 1 : t.clamp(h ? l : 1 - c, 0, 1);
              return e.refreshedUponExpiration && l >= 1 && (e.refreshedUponExpiration = !1), r ? {
                opacity: 1,
                mix: 1 - p
              } : {
                opacity: p,
                mix: 0
              };
            }

            return {
              opacity: 1,
              mix: 0
            };
          }

          var un = new t.Color(1, 0, 0, 1),
              fn = new t.Color(0, 1, 0, 1),
              hn = new t.Color(0, 0, 1, 1),
              pn = new t.Color(1, 0, 1, 1),
              dn = new t.Color(0, 1, 1, 1);

          function mn(t) {
            var e = t.transform.padding;
            gn(t, t.transform.height - (e.top || 0), 3, un), gn(t, e.bottom || 0, 3, fn), vn(t, e.left || 0, 3, hn), vn(t, t.transform.width - (e.right || 0), 3, pn);
            var r = t.transform.centerPoint;
            !function (t, e, r, n) {
              yn(t, e - 1, r - 10, 2, 20, n), yn(t, e - 10, r - 1, 20, 2, n);
            }(t, r.x, t.transform.height - r.y, dn);
          }

          function gn(t, e, r, n) {
            yn(t, 0, e + r / 2, t.transform.width, r, n);
          }

          function vn(t, e, r, n) {
            yn(t, e - r / 2, 0, r, t.transform.height, n);
          }

          function yn(e, r, n, i, a, o) {
            var s = e.context,
                l = s.gl;
            l.enable(l.SCISSOR_TEST), l.scissor(r * t.browser.devicePixelRatio, n * t.browser.devicePixelRatio, i * t.browser.devicePixelRatio, a * t.browser.devicePixelRatio), s.clear({
              color: o
            }), l.disable(l.SCISSOR_TEST);
          }

          function xn(e, r, n) {
            var i = e.context,
                a = i.gl,
                o = n.posMatrix,
                s = e.useProgram("debug"),
                l = Mt.disabled,
                c = At.disabled,
                u = e.colorModeForRenderPass();
            i.activeTexture.set(a.TEXTURE0), e.emptyTexture.bind(a.LINEAR, a.CLAMP_TO_EDGE), s.draw(i, a.LINE_STRIP, l, c, u, Et.disabled, Ir(o, t.Color.red), "$debug", e.debugBuffer, e.tileBorderIndexBuffer, e.debugSegments);
            var f = r.getTileByID(n.key).latestRawTileData,
                h = f && f.byteLength || 0,
                p = Math.floor(h / 1024),
                d = r.getTile(n).tileSize,
                m = 512 / Math.min(d, 512) * (n.overscaledZ / e.transform.zoom) * .5,
                g = n.canonical.toString();
            n.overscaledZ !== n.canonical.z && (g += " => " + n.overscaledZ), function (t, e) {
              t.initDebugOverlayCanvas();
              var r = t.debugOverlayCanvas,
                  n = t.context.gl,
                  i = t.debugOverlayCanvas.getContext("2d");
              i.clearRect(0, 0, r.width, r.height), i.shadowColor = "white", i.shadowBlur = 2, i.lineWidth = 1.5, i.strokeStyle = "white", i.textBaseline = "top", i.font = "bold 36px Open Sans, sans-serif", i.fillText(e, 5, 5), i.strokeText(e, 5, 5), t.debugOverlayTexture.update(r), t.debugOverlayTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE);
            }(e, g + " " + p + "kb"), s.draw(i, a.TRIANGLES, l, c, St.alphaBlended, Et.disabled, Ir(o, t.Color.transparent, m), "$debug", e.debugBuffer, e.quadTriangleIndexBuffer, e.debugSegments);
          }

          var bn = {
            symbol: function symbol(e, r, n, i, a) {
              if ("translucent" === e.renderPass) {
                var o = At.disabled,
                    s = e.colorModeForRenderPass();
                n.layout.get("text-variable-anchor") && function (e, r, n, i, a, o, s) {
                  for (var l = r.transform, c = "map" === a, u = "map" === o, f = 0, h = e; f < h.length; f += 1) {
                    var p = h[f],
                        d = i.getTile(p),
                        m = d.getBucket(n);

                    if (m && m.text && m.text.segments.get().length) {
                      var g = m.textSizeData,
                          v = t.evaluateSizeForZoom(g, l.zoom),
                          y = pe(d, 1, r.transform.zoom),
                          x = Qt(p.posMatrix, u, c, r.transform, y),
                          b = "none" !== n.layout.get("icon-text-fit") && m.hasIconData();

                      if (v) {
                        var _ = Math.pow(2, l.zoom - d.tileID.overscaledZ);

                        tn(m, c, u, s, t.symbolSize, l, x, p.posMatrix, _, v, b);
                      }
                    }
                  }
                }(i, e, n, r, n.layout.get("text-rotation-alignment"), n.layout.get("text-pitch-alignment"), a), 0 !== n.paint.get("icon-opacity").constantOr(1) && rn(e, r, n, i, !1, n.paint.get("icon-translate"), n.paint.get("icon-translate-anchor"), n.layout.get("icon-rotation-alignment"), n.layout.get("icon-pitch-alignment"), n.layout.get("icon-keep-upright"), o, s), 0 !== n.paint.get("text-opacity").constantOr(1) && rn(e, r, n, i, !0, n.paint.get("text-translate"), n.paint.get("text-translate-anchor"), n.layout.get("text-rotation-alignment"), n.layout.get("text-pitch-alignment"), n.layout.get("text-keep-upright"), o, s), r.map.showCollisionBoxes && (Kr(e, r, n, i, n.paint.get("text-translate"), n.paint.get("text-translate-anchor"), !0), Kr(e, r, n, i, n.paint.get("icon-translate"), n.paint.get("icon-translate-anchor"), !1));
              }
            },
            circle: function circle(e, r, n, i) {
              if ("translucent" === e.renderPass) {
                var a = n.paint.get("circle-opacity"),
                    o = n.paint.get("circle-stroke-width"),
                    s = n.paint.get("circle-stroke-opacity"),
                    l = void 0 !== n.layout.get("circle-sort-key").constantOr(1);

                if (0 !== a.constantOr(1) || 0 !== o.constantOr(1) && 0 !== s.constantOr(1)) {
                  for (var c = e.context, u = c.gl, f = e.depthModeForSublayer(0, Mt.ReadOnly), h = At.disabled, p = e.colorModeForRenderPass(), d = [], m = 0; m < i.length; m++) {
                    var g = i[m],
                        v = r.getTile(g),
                        y = v.getBucket(n);

                    if (y) {
                      var x = y.programConfigurations.get(n.id),
                          b = {
                        programConfiguration: x,
                        program: e.useProgram("circle", x),
                        layoutVertexBuffer: y.layoutVertexBuffer,
                        indexBuffer: y.indexBuffer,
                        uniformValues: Lr(e, g, v, n)
                      };
                      if (l) for (var _ = 0, w = y.segments.get(); _ < w.length; _ += 1) {
                        var T = w[_];
                        d.push({
                          segments: new t.SegmentVector([T]),
                          sortKey: T.sortKey,
                          state: b
                        });
                      } else d.push({
                        segments: y.segments,
                        sortKey: 0,
                        state: b
                      });
                    }
                  }

                  l && d.sort(function (t, e) {
                    return t.sortKey - e.sortKey;
                  });

                  for (var k = 0, M = d; k < M.length; k += 1) {
                    var A = M[k],
                        S = A.state,
                        E = S.programConfiguration,
                        L = S.program,
                        C = S.layoutVertexBuffer,
                        P = S.indexBuffer,
                        I = S.uniformValues,
                        O = A.segments;
                    L.draw(c, u.TRIANGLES, f, h, p, Et.disabled, I, n.id, C, P, O, n.paint, e.transform.zoom, E);
                  }
                }
              }
            },
            heatmap: function heatmap(e, r, n, i) {
              if (0 !== n.paint.get("heatmap-opacity")) if ("offscreen" === e.renderPass) {
                var a = e.context,
                    o = a.gl,
                    s = At.disabled,
                    l = new St([o.ONE, o.ONE], t.Color.transparent, [!0, !0, !0, !0]);
                !function (t, e, r) {
                  var n = t.gl;
                  t.activeTexture.set(n.TEXTURE1), t.viewport.set([0, 0, e.width / 4, e.height / 4]);
                  var i = r.heatmapFbo;
                  if (i) n.bindTexture(n.TEXTURE_2D, i.colorAttachment.get()), t.bindFramebuffer.set(i.framebuffer);else {
                    var a = n.createTexture();
                    n.bindTexture(n.TEXTURE_2D, a), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, n.LINEAR), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, n.LINEAR), i = r.heatmapFbo = t.createFramebuffer(e.width / 4, e.height / 4, !1), function (t, e, r, n) {
                      var i = t.gl,
                          a = t.extRenderToTextureHalfFloat ? t.extTextureHalfFloat.HALF_FLOAT_OES : i.UNSIGNED_BYTE;
                      i.texImage2D(i.TEXTURE_2D, 0, i.RGBA, e.width / 4, e.height / 4, 0, i.RGBA, a, null), n.colorAttachment.set(r);
                    }(t, e, a, i);
                  }
                }(a, e, n), a.clear({
                  color: t.Color.transparent
                });

                for (var c = 0; c < i.length; c++) {
                  var u = i[c];

                  if (!r.hasRenderableParent(u)) {
                    var f = r.getTile(u),
                        h = f.getBucket(n);

                    if (h) {
                      var p = h.programConfigurations.get(n.id),
                          d = e.useProgram("heatmap", p),
                          m = e.transform.zoom;
                      d.draw(a, o.TRIANGLES, Mt.disabled, s, l, Et.disabled, zr(u.posMatrix, f, m, n.paint.get("heatmap-intensity")), n.id, h.layoutVertexBuffer, h.indexBuffer, h.segments, n.paint, e.transform.zoom, p);
                    }
                  }
                }

                a.viewport.set([0, 0, e.width, e.height]);
              } else "translucent" === e.renderPass && (e.context.setColorMode(e.colorModeForRenderPass()), function (e, r) {
                var n = e.context,
                    i = n.gl,
                    a = r.heatmapFbo;
                if (!a) return;
                n.activeTexture.set(i.TEXTURE0), i.bindTexture(i.TEXTURE_2D, a.colorAttachment.get()), n.activeTexture.set(i.TEXTURE1);
                var o = r.colorRampTexture;
                o || (o = r.colorRampTexture = new t.Texture(n, r.colorRamp, i.RGBA));
                o.bind(i.LINEAR, i.CLAMP_TO_EDGE), e.useProgram("heatmapTexture").draw(n, i.TRIANGLES, Mt.disabled, At.disabled, e.colorModeForRenderPass(), Et.disabled, function (e, r, n, i) {
                  var a = t.create();
                  t.ortho(a, 0, e.width, e.height, 0, 0, 1);
                  var o = e.context.gl;
                  return {
                    u_matrix: a,
                    u_world: [o.drawingBufferWidth, o.drawingBufferHeight],
                    u_image: n,
                    u_color_ramp: i,
                    u_opacity: r.paint.get("heatmap-opacity")
                  };
                }(e, r, 0, 1), r.id, e.viewportBuffer, e.quadTriangleIndexBuffer, e.viewportSegments, r.paint, e.transform.zoom);
              }(e, n));
            },
            line: function line(e, r, n, i) {
              if ("translucent" === e.renderPass) {
                var a = n.paint.get("line-opacity"),
                    o = n.paint.get("line-width");

                if (0 !== a.constantOr(1) && 0 !== o.constantOr(1)) {
                  var s = e.depthModeForSublayer(0, Mt.ReadOnly),
                      l = e.colorModeForRenderPass(),
                      c = n.paint.get("line-dasharray"),
                      u = n.paint.get("line-pattern"),
                      f = u.constantOr(1),
                      h = n.paint.get("line-gradient"),
                      p = n.getCrossfadeParameters(),
                      d = f ? "linePattern" : c ? "lineSDF" : h ? "lineGradient" : "line",
                      m = e.context,
                      g = m.gl,
                      v = !0;

                  if (h) {
                    m.activeTexture.set(g.TEXTURE0);
                    var y = n.gradientTexture;
                    if (!n.gradient) return;
                    y || (y = n.gradientTexture = new t.Texture(m, n.gradient, g.RGBA)), y.bind(g.LINEAR, g.CLAMP_TO_EDGE);
                  }

                  for (var x = 0, b = i; x < b.length; x += 1) {
                    var _ = b[x],
                        w = r.getTile(_);

                    if (!f || w.patternsLoaded()) {
                      var T = w.getBucket(n);

                      if (T) {
                        var k = T.programConfigurations.get(n.id),
                            M = e.context.program.get(),
                            A = e.useProgram(d, k),
                            S = v || A.program !== M,
                            E = u.constantOr(null);

                        if (E && w.imageAtlas) {
                          var L = w.imageAtlas,
                              C = L.patternPositions[E.to.toString()],
                              P = L.patternPositions[E.from.toString()];
                          C && P && k.setConstantPatternPositions(C, P);
                        }

                        var I = f ? Br(e, w, n, p) : c ? Nr(e, w, n, c, p) : h ? Fr(e, w, n) : Rr(e, w, n);
                        f ? (m.activeTexture.set(g.TEXTURE0), w.imageAtlasTexture.bind(g.LINEAR, g.CLAMP_TO_EDGE), k.updatePaintBuffers(p)) : c && (S || e.lineAtlas.dirty) && (m.activeTexture.set(g.TEXTURE0), e.lineAtlas.bind(m)), A.draw(m, g.TRIANGLES, s, e.stencilModeForClipping(_), l, Et.disabled, I, n.id, T.layoutVertexBuffer, T.indexBuffer, T.segments, n.paint, e.transform.zoom, k), v = !1;
                      }
                    }
                  }
                }
              }
            },
            fill: function fill(e, r, n, i) {
              var a = n.paint.get("fill-color"),
                  o = n.paint.get("fill-opacity");

              if (0 !== o.constantOr(1)) {
                var s = e.colorModeForRenderPass(),
                    l = n.paint.get("fill-pattern"),
                    c = e.opaquePassEnabledForLayer() && !l.constantOr(1) && 1 === a.constantOr(t.Color.transparent).a && 1 === o.constantOr(0) ? "opaque" : "translucent";

                if (e.renderPass === c) {
                  var u = e.depthModeForSublayer(1, "opaque" === e.renderPass ? Mt.ReadWrite : Mt.ReadOnly);
                  an(e, r, n, i, u, s, !1);
                }

                if ("translucent" === e.renderPass && n.paint.get("fill-antialias")) {
                  var f = e.depthModeForSublayer(n.getPaintProperty("fill-outline-color") ? 2 : 0, Mt.ReadOnly);
                  an(e, r, n, i, f, s, !0);
                }
              }
            },
            "fill-extrusion": function fillExtrusion(t, e, r, n) {
              var i = r.paint.get("fill-extrusion-opacity");

              if (0 !== i && "translucent" === t.renderPass) {
                var a = new Mt(t.context.gl.LEQUAL, Mt.ReadWrite, t.depthRangeFor3D);
                if (1 !== i || r.paint.get("fill-extrusion-pattern").constantOr(1)) on(t, e, r, n, a, At.disabled, St.disabled), on(t, e, r, n, a, t.stencilModeFor3D(), t.colorModeForRenderPass());else {
                  var o = t.colorModeForRenderPass();
                  on(t, e, r, n, a, At.disabled, o);
                }
              }
            },
            hillshade: function hillshade(t, e, r, n) {
              if ("offscreen" === t.renderPass || "translucent" === t.renderPass) {
                for (var i = t.context, a = e.getSource().maxzoom, o = t.depthModeForSublayer(0, Mt.ReadOnly), s = t.colorModeForRenderPass(), l = "translucent" === t.renderPass ? t.stencilConfigForOverlap(n) : [{}, n], c = l[0], u = 0, f = l[1]; u < f.length; u += 1) {
                  var h = f[u],
                      p = e.getTile(h);
                  p.needsHillshadePrepare && "offscreen" === t.renderPass ? ln(t, p, r, a, o, At.disabled, s) : "translucent" === t.renderPass && sn(t, p, r, o, c[h.overscaledZ], s);
                }

                i.viewport.set([0, 0, t.width, t.height]);
              }
            },
            raster: function raster(t, e, r, n) {
              if ("translucent" === t.renderPass && 0 !== r.paint.get("raster-opacity") && n.length) for (var i = t.context, a = i.gl, o = e.getSource(), s = t.useProgram("raster"), l = t.colorModeForRenderPass(), c = o instanceof I ? [{}, n] : t.stencilConfigForOverlap(n), u = c[0], f = c[1], h = f[f.length - 1].overscaledZ, p = !t.options.moving, d = 0, m = f; d < m.length; d += 1) {
                var g = m[d],
                    v = t.depthModeForSublayer(g.overscaledZ - h, 1 === r.paint.get("raster-opacity") ? Mt.ReadWrite : Mt.ReadOnly, a.LESS),
                    y = e.getTile(g),
                    x = t.transform.calculatePosMatrix(g.toUnwrapped(), p);
                y.registerFadeDuration(r.paint.get("raster-fade-duration"));

                var b = e.findLoadedParent(g, 0),
                    _ = cn(y, b, e, r, t.transform),
                    w = void 0,
                    T = void 0,
                    k = "nearest" === r.paint.get("raster-resampling") ? a.NEAREST : a.LINEAR;

                i.activeTexture.set(a.TEXTURE0), y.texture.bind(k, a.CLAMP_TO_EDGE, a.LINEAR_MIPMAP_NEAREST), i.activeTexture.set(a.TEXTURE1), b ? (b.texture.bind(k, a.CLAMP_TO_EDGE, a.LINEAR_MIPMAP_NEAREST), w = Math.pow(2, b.tileID.overscaledZ - y.tileID.overscaledZ), T = [y.tileID.canonical.x * w % 1, y.tileID.canonical.y * w % 1]) : y.texture.bind(k, a.CLAMP_TO_EDGE, a.LINEAR_MIPMAP_NEAREST);
                var M = Vr(x, T || [0, 0], w || 1, _, r);
                o instanceof I ? s.draw(i, a.TRIANGLES, v, At.disabled, l, Et.disabled, M, r.id, o.boundsBuffer, t.quadTriangleIndexBuffer, o.boundsSegments) : s.draw(i, a.TRIANGLES, v, u[g.overscaledZ], l, Et.disabled, M, r.id, t.rasterBoundsBuffer, t.quadTriangleIndexBuffer, t.rasterBoundsSegments);
              }
            },
            background: function background(t, e, r) {
              var n = r.paint.get("background-color"),
                  i = r.paint.get("background-opacity");

              if (0 !== i) {
                var a = t.context,
                    o = a.gl,
                    s = t.transform,
                    l = s.tileSize,
                    c = r.paint.get("background-pattern");

                if (!t.isPatternMissing(c)) {
                  var u = !c && 1 === n.a && 1 === i && t.opaquePassEnabledForLayer() ? "opaque" : "translucent";

                  if (t.renderPass === u) {
                    var f = At.disabled,
                        h = t.depthModeForSublayer(0, "opaque" === u ? Mt.ReadWrite : Mt.ReadOnly),
                        p = t.colorModeForRenderPass(),
                        d = t.useProgram(c ? "backgroundPattern" : "background"),
                        m = s.coveringTiles({
                      tileSize: l
                    });
                    c && (a.activeTexture.set(o.TEXTURE0), t.imageManager.bind(t.context));

                    for (var g = r.getCrossfadeParameters(), v = 0, y = m; v < y.length; v += 1) {
                      var x = y[v],
                          b = t.transform.calculatePosMatrix(x.toUnwrapped()),
                          _ = c ? Zr(b, i, t, c, {
                        tileID: x,
                        tileSize: l
                      }, g) : Xr(b, i, n);

                      d.draw(a, o.TRIANGLES, h, f, p, Et.disabled, _, r.id, t.tileExtentBuffer, t.quadTriangleIndexBuffer, t.tileExtentSegments);
                    }
                  }
                }
              }
            },
            debug: function debug(t, e, r) {
              for (var n = 0; n < r.length; n++) {
                xn(t, e, r[n]);
              }
            },
            custom: function custom(t, e, r) {
              var n = t.context,
                  i = r.implementation;

              if ("offscreen" === t.renderPass) {
                var a = i.prerender;
                a && (t.setCustomLayerDefaults(), n.setColorMode(t.colorModeForRenderPass()), a.call(i, n.gl, t.transform.customLayerMatrix()), n.setDirty(), t.setBaseState());
              } else if ("translucent" === t.renderPass) {
                t.setCustomLayerDefaults(), n.setColorMode(t.colorModeForRenderPass()), n.setStencilMode(At.disabled);
                var o = "3d" === i.renderingMode ? new Mt(t.context.gl.LEQUAL, Mt.ReadWrite, t.depthRangeFor3D) : t.depthModeForSublayer(0, Mt.ReadOnly);
                n.setDepthMode(o), i.render(n.gl, t.transform.customLayerMatrix()), n.setDirty(), t.setBaseState(), n.bindFramebuffer.set(null);
              }
            }
          },
              _n = function _n(t, e) {
            this.context = new Lt(t), this.transform = e, this._tileTextures = {}, this.setup(), this.numSublayers = Ct.maxUnderzooming + Ct.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new Ne(), this.gpuTimers = {};
          };

          _n.prototype.resize = function (e, r) {
            if (this.width = e * t.browser.devicePixelRatio, this.height = r * t.browser.devicePixelRatio, this.context.viewport.set([0, 0, this.width, this.height]), this.style) for (var n = 0, i = this.style._order; n < i.length; n += 1) {
              var a = i[n];

              this.style._layers[a].resize();
            }
          }, _n.prototype.setup = function () {
            var e = this.context,
                r = new t.StructArrayLayout2i4();
            r.emplaceBack(0, 0), r.emplaceBack(t.EXTENT, 0), r.emplaceBack(0, t.EXTENT), r.emplaceBack(t.EXTENT, t.EXTENT), this.tileExtentBuffer = e.createVertexBuffer(r, Ge.members), this.tileExtentSegments = t.SegmentVector.simpleSegment(0, 0, 4, 2);
            var n = new t.StructArrayLayout2i4();
            n.emplaceBack(0, 0), n.emplaceBack(t.EXTENT, 0), n.emplaceBack(0, t.EXTENT), n.emplaceBack(t.EXTENT, t.EXTENT), this.debugBuffer = e.createVertexBuffer(n, Ge.members), this.debugSegments = t.SegmentVector.simpleSegment(0, 0, 4, 5);
            var i = new t.StructArrayLayout4i8();
            i.emplaceBack(0, 0, 0, 0), i.emplaceBack(t.EXTENT, 0, t.EXTENT, 0), i.emplaceBack(0, t.EXTENT, 0, t.EXTENT), i.emplaceBack(t.EXTENT, t.EXTENT, t.EXTENT, t.EXTENT), this.rasterBoundsBuffer = e.createVertexBuffer(i, P.members), this.rasterBoundsSegments = t.SegmentVector.simpleSegment(0, 0, 4, 2);
            var a = new t.StructArrayLayout2i4();
            a.emplaceBack(0, 0), a.emplaceBack(1, 0), a.emplaceBack(0, 1), a.emplaceBack(1, 1), this.viewportBuffer = e.createVertexBuffer(a, Ge.members), this.viewportSegments = t.SegmentVector.simpleSegment(0, 0, 4, 2);
            var o = new t.StructArrayLayout1ui2();
            o.emplaceBack(0), o.emplaceBack(1), o.emplaceBack(3), o.emplaceBack(2), o.emplaceBack(0), this.tileBorderIndexBuffer = e.createIndexBuffer(o);
            var s = new t.StructArrayLayout3ui6();
            s.emplaceBack(0, 1, 2), s.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = e.createIndexBuffer(s), this.emptyTexture = new t.Texture(e, {
              width: 1,
              height: 1,
              data: new Uint8Array([0, 0, 0, 0])
            }, e.gl.RGBA);
            var l = this.context.gl;
            this.stencilClearMode = new At({
              func: l.ALWAYS,
              mask: 0
            }, 0, 255, l.ZERO, l.ZERO, l.ZERO);
          }, _n.prototype.clearStencil = function () {
            var e = this.context,
                r = e.gl;
            this.nextStencilID = 1, this.currentStencilSource = void 0;
            var n = t.create();
            t.ortho(n, 0, this.width, this.height, 0, 0, 1), t.scale(n, n, [r.drawingBufferWidth, r.drawingBufferHeight, 0]), this.useProgram("clippingMask").draw(e, r.TRIANGLES, Mt.disabled, this.stencilClearMode, St.disabled, Et.disabled, Or(n), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
          }, _n.prototype._renderTileClippingMasks = function (t, e) {
            if (this.currentStencilSource !== t.source && t.isTileClipped() && e && e.length) {
              this.currentStencilSource = t.source;
              var r = this.context,
                  n = r.gl;
              this.nextStencilID + e.length > 256 && this.clearStencil(), r.setColorMode(St.disabled), r.setDepthMode(Mt.disabled);
              var i = this.useProgram("clippingMask");
              this._tileClippingMaskIDs = {};

              for (var a = 0, o = e; a < o.length; a += 1) {
                var s = o[a],
                    l = this._tileClippingMaskIDs[s.key] = this.nextStencilID++;
                i.draw(r, n.TRIANGLES, Mt.disabled, new At({
                  func: n.ALWAYS,
                  mask: 0
                }, l, 255, n.KEEP, n.KEEP, n.REPLACE), St.disabled, Et.disabled, Or(s.posMatrix), "$clipping", this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
              }
            }
          }, _n.prototype.stencilModeFor3D = function () {
            this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
            var t = this.nextStencilID++,
                e = this.context.gl;
            return new At({
              func: e.NOTEQUAL,
              mask: 255
            }, t, 255, e.KEEP, e.KEEP, e.REPLACE);
          }, _n.prototype.stencilModeForClipping = function (t) {
            var e = this.context.gl;
            return new At({
              func: e.EQUAL,
              mask: 255
            }, this._tileClippingMaskIDs[t.key], 0, e.KEEP, e.KEEP, e.REPLACE);
          }, _n.prototype.stencilConfigForOverlap = function (t) {
            var e,
                r = this.context.gl,
                n = t.sort(function (t, e) {
              return e.overscaledZ - t.overscaledZ;
            }),
                i = n[n.length - 1].overscaledZ,
                a = n[0].overscaledZ - i + 1;

            if (a > 1) {
              this.currentStencilSource = void 0, this.nextStencilID + a > 256 && this.clearStencil();

              for (var o = {}, s = 0; s < a; s++) {
                o[s + i] = new At({
                  func: r.GEQUAL,
                  mask: 255
                }, s + this.nextStencilID, 255, r.KEEP, r.KEEP, r.REPLACE);
              }

              return this.nextStencilID += a, [o, n];
            }

            return [(e = {}, e[i] = At.disabled, e), n];
          }, _n.prototype.colorModeForRenderPass = function () {
            var e = this.context.gl;

            if (this._showOverdrawInspector) {
              return new St([e.CONSTANT_COLOR, e.ONE], new t.Color(1 / 8, 1 / 8, 1 / 8, 0), [!0, !0, !0, !0]);
            }

            return "opaque" === this.renderPass ? St.unblended : St.alphaBlended;
          }, _n.prototype.depthModeForSublayer = function (t, e, r) {
            if (!this.opaquePassEnabledForLayer()) return Mt.disabled;
            var n = 1 - ((1 + this.currentLayer) * this.numSublayers + t) * this.depthEpsilon;
            return new Mt(r || this.context.gl.LEQUAL, e, [n, n]);
          }, _n.prototype.opaquePassEnabledForLayer = function () {
            return this.currentLayer < this.opaquePassCutoff;
          }, _n.prototype.render = function (e, r) {
            var n = this;
            this.style = e, this.options = r, this.lineAtlas = e.lineAtlas, this.imageManager = e.imageManager, this.glyphManager = e.glyphManager, this.symbolFadeChange = e.placement.symbolFadeChange(t.browser.now()), this.imageManager.beginFrame();
            var i = this.style._order,
                a = this.style.sourceCaches;

            for (var o in a) {
              var s = a[o];
              s.used && s.prepare(this.context);
            }

            var l,
                c,
                u = {},
                f = {},
                h = {};

            for (var p in a) {
              var d = a[p];
              u[p] = d.getVisibleCoordinates(), f[p] = u[p].slice().reverse(), h[p] = d.getVisibleCoordinates(!0).reverse();
            }

            this.opaquePassCutoff = 1 / 0;

            for (var m = 0; m < i.length; m++) {
              var g = i[m];

              if (this.style._layers[g].is3D()) {
                this.opaquePassCutoff = m;
                break;
              }
            }

            this.renderPass = "offscreen";

            for (var v = 0, y = i; v < y.length; v += 1) {
              var x = y[v],
                  b = this.style._layers[x];

              if (b.hasOffscreenPass() && !b.isHidden(this.transform.zoom)) {
                var _ = f[b.source];
                ("custom" === b.type || _.length) && this.renderLayer(this, a[b.source], b, _);
              }
            }

            for (this.context.bindFramebuffer.set(null), this.context.clear({
              color: r.showOverdrawInspector ? t.Color.black : t.Color.transparent,
              depth: 1
            }), this.clearStencil(), this._showOverdrawInspector = r.showOverdrawInspector, this.depthRangeFor3D = [0, 1 - (e._order.length + 2) * this.numSublayers * this.depthEpsilon], this.renderPass = "opaque", this.currentLayer = i.length - 1; this.currentLayer >= 0; this.currentLayer--) {
              var w = this.style._layers[i[this.currentLayer]],
                  T = a[w.source],
                  k = u[w.source];
              this._renderTileClippingMasks(w, k), this.renderLayer(this, T, w, k);
            }

            for (this.renderPass = "translucent", this.currentLayer = 0; this.currentLayer < i.length; this.currentLayer++) {
              var M = this.style._layers[i[this.currentLayer]],
                  A = a[M.source],
                  S = ("symbol" === M.type ? h : f)[M.source];
              this._renderTileClippingMasks(M, u[M.source]), this.renderLayer(this, A, M, S);
            }

            this.options.showTileBoundaries && (t.values(this.style._layers).forEach(function (t) {
              t.source && !t.isHidden(n.transform.zoom) && (t.source !== (c && c.id) && (c = n.style.sourceCaches[t.source]), (!l || l.getSource().maxzoom < c.getSource().maxzoom) && (l = c));
            }), l && bn.debug(this, l, l.getVisibleCoordinates()));
            this.options.showPadding && mn(this), this.context.setDefault();
          }, _n.prototype.renderLayer = function (t, e, r, n) {
            r.isHidden(this.transform.zoom) || ("background" === r.type || "custom" === r.type || n.length) && (this.id = r.id, this.gpuTimingStart(r), bn[r.type](t, e, r, n, this.style.placement.variableOffsets), this.gpuTimingEnd());
          }, _n.prototype.gpuTimingStart = function (t) {
            if (this.options.gpuTiming) {
              var e = this.context.extTimerQuery,
                  r = this.gpuTimers[t.id];
              r || (r = this.gpuTimers[t.id] = {
                calls: 0,
                cpuTime: 0,
                query: e.createQueryEXT()
              }), r.calls++, e.beginQueryEXT(e.TIME_ELAPSED_EXT, r.query);
            }
          }, _n.prototype.gpuTimingEnd = function () {
            if (this.options.gpuTiming) {
              var t = this.context.extTimerQuery;
              t.endQueryEXT(t.TIME_ELAPSED_EXT);
            }
          }, _n.prototype.collectGpuTimers = function () {
            var t = this.gpuTimers;
            return this.gpuTimers = {}, t;
          }, _n.prototype.queryGpuTimers = function (t) {
            var e = {};

            for (var r in t) {
              var n = t[r],
                  i = this.context.extTimerQuery,
                  a = i.getQueryObjectEXT(n.query, i.QUERY_RESULT_EXT) / 1e6;
              i.deleteQueryEXT(n.query), e[r] = a;
            }

            return e;
          }, _n.prototype.translatePosMatrix = function (e, r, n, i, a) {
            if (!n[0] && !n[1]) return e;
            var o = a ? "map" === i ? this.transform.angle : 0 : "viewport" === i ? -this.transform.angle : 0;

            if (o) {
              var s = Math.sin(o),
                  l = Math.cos(o);
              n = [n[0] * l - n[1] * s, n[0] * s + n[1] * l];
            }

            var c = [a ? n[0] : pe(r, n[0], this.transform.zoom), a ? n[1] : pe(r, n[1], this.transform.zoom), 0],
                u = new Float32Array(16);
            return t.translate(u, e, c), u;
          }, _n.prototype.saveTileTexture = function (t) {
            var e = this._tileTextures[t.size[0]];
            e ? e.push(t) : this._tileTextures[t.size[0]] = [t];
          }, _n.prototype.getTileTexture = function (t) {
            var e = this._tileTextures[t];
            return e && e.length > 0 ? e.pop() : null;
          }, _n.prototype.isPatternMissing = function (t) {
            if (!t) return !1;
            if (!t.from || !t.to) return !0;
            var e = this.imageManager.getPattern(t.from.toString()),
                r = this.imageManager.getPattern(t.to.toString());
            return !e || !r;
          }, _n.prototype.useProgram = function (t, e) {
            this.cache = this.cache || {};
            var r = "" + t + (e ? e.cacheKey : "") + (this._showOverdrawInspector ? "/overdraw" : "");
            return this.cache[r] || (this.cache[r] = new _r(this.context, xr[t], e, Jr[t], this._showOverdrawInspector)), this.cache[r];
          }, _n.prototype.setCustomLayerDefaults = function () {
            this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
          }, _n.prototype.setBaseState = function () {
            var t = this.context.gl;
            this.context.cullFace.set(!1), this.context.viewport.set([0, 0, this.width, this.height]), this.context.blendEquation.set(t.FUNC_ADD);
          }, _n.prototype.initDebugOverlayCanvas = function () {
            if (null == this.debugOverlayCanvas) {
              this.debugOverlayCanvas = t.window.document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512;
              var e = this.context.gl;
              this.debugOverlayTexture = new t.Texture(this.context, this.debugOverlayCanvas, e.RGBA);
            }
          }, _n.prototype.destroy = function () {
            this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy();
          };

          var wn = function wn(t, e) {
            this.points = t, this.planes = e;
          };

          wn.fromInvProjectionMatrix = function (e, r, n) {
            var i = Math.pow(2, n),
                a = [[-1, 1, -1, 1], [1, 1, -1, 1], [1, -1, -1, 1], [-1, -1, -1, 1], [-1, 1, 1, 1], [1, 1, 1, 1], [1, -1, 1, 1], [-1, -1, 1, 1]].map(function (r) {
              return t.transformMat4([], r, e);
            }).map(function (e) {
              return t.scale$1([], e, 1 / e[3] / r * i);
            }),
                o = [[0, 1, 2], [6, 5, 4], [0, 3, 7], [2, 1, 5], [3, 2, 6], [0, 4, 5]].map(function (e) {
              var r = t.sub([], a[e[0]], a[e[1]]),
                  n = t.sub([], a[e[2]], a[e[1]]),
                  i = t.normalize([], t.cross([], r, n)),
                  o = -t.dot(i, a[e[1]]);
              return i.concat(o);
            });
            return new wn(a, o);
          };

          var Tn = function Tn(e, r) {
            this.min = e, this.max = r, this.center = t.scale$2([], t.add([], this.min, this.max), .5);
          };

          Tn.prototype.quadrant = function (e) {
            for (var r = [e % 2 == 0, e < 2], n = t.clone$2(this.min), i = t.clone$2(this.max), a = 0; a < r.length; a++) {
              n[a] = r[a] ? this.min[a] : this.center[a], i[a] = r[a] ? this.center[a] : this.max[a];
            }

            return i[2] = this.max[2], new Tn(n, i);
          }, Tn.prototype.distanceX = function (t) {
            return Math.max(Math.min(this.max[0], t[0]), this.min[0]) - t[0];
          }, Tn.prototype.distanceY = function (t) {
            return Math.max(Math.min(this.max[1], t[1]), this.min[1]) - t[1];
          }, Tn.prototype.intersects = function (e) {
            for (var r = [[this.min[0], this.min[1], 0, 1], [this.max[0], this.min[1], 0, 1], [this.max[0], this.max[1], 0, 1], [this.min[0], this.max[1], 0, 1]], n = !0, i = 0; i < e.planes.length; i++) {
              for (var a = e.planes[i], o = 0, s = 0; s < r.length; s++) {
                o += t.dot$1(a, r[s]) >= 0;
              }

              if (0 === o) return 0;
              o !== r.length && (n = !1);
            }

            if (n) return 2;

            for (var l = 0; l < 3; l++) {
              for (var c = Number.MAX_VALUE, u = -Number.MAX_VALUE, f = 0; f < e.points.length; f++) {
                var h = e.points[f][l] - this.min[l];
                c = Math.min(c, h), u = Math.max(u, h);
              }

              if (u < 0 || c > this.max[l] - this.min[l]) return 0;
            }

            return 1;
          };

          var kn = function kn(t, e, r, n) {
            if (void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === r && (r = 0), void 0 === n && (n = 0), isNaN(t) || t < 0 || isNaN(e) || e < 0 || isNaN(r) || r < 0 || isNaN(n) || n < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
            this.top = t, this.bottom = e, this.left = r, this.right = n;
          };

          kn.prototype.interpolate = function (e, r, n) {
            return null != r.top && null != e.top && (this.top = t.number(e.top, r.top, n)), null != r.bottom && null != e.bottom && (this.bottom = t.number(e.bottom, r.bottom, n)), null != r.left && null != e.left && (this.left = t.number(e.left, r.left, n)), null != r.right && null != e.right && (this.right = t.number(e.right, r.right, n)), this;
          }, kn.prototype.getCenter = function (e, r) {
            var n = t.clamp((this.left + e - this.right) / 2, 0, e),
                i = t.clamp((this.top + r - this.bottom) / 2, 0, r);
            return new t.Point(n, i);
          }, kn.prototype.equals = function (t) {
            return this.top === t.top && this.bottom === t.bottom && this.left === t.left && this.right === t.right;
          }, kn.prototype.clone = function () {
            return new kn(this.top, this.bottom, this.left, this.right);
          }, kn.prototype.toJSON = function () {
            return {
              top: this.top,
              bottom: this.bottom,
              left: this.left,
              right: this.right
            };
          };

          var Mn = function Mn(e, r, n, i, a) {
            this.tileSize = 512, this.maxValidLatitude = 85.051129, this._renderWorldCopies = void 0 === a || a, this._minZoom = e || 0, this._maxZoom = r || 22, this._minPitch = null == n ? 0 : n, this._maxPitch = null == i ? 60 : i, this.setMaxBounds(), this.width = 0, this.height = 0, this._center = new t.LngLat(0, 0), this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._unmodified = !0, this._edgeInsets = new kn(), this._posMatrixCache = {}, this._alignedPosMatrixCache = {};
          },
              An = {
            minZoom: {
              configurable: !0
            },
            maxZoom: {
              configurable: !0
            },
            minPitch: {
              configurable: !0
            },
            maxPitch: {
              configurable: !0
            },
            renderWorldCopies: {
              configurable: !0
            },
            worldSize: {
              configurable: !0
            },
            centerOffset: {
              configurable: !0
            },
            size: {
              configurable: !0
            },
            bearing: {
              configurable: !0
            },
            pitch: {
              configurable: !0
            },
            fov: {
              configurable: !0
            },
            zoom: {
              configurable: !0
            },
            center: {
              configurable: !0
            },
            padding: {
              configurable: !0
            },
            centerPoint: {
              configurable: !0
            },
            unmodified: {
              configurable: !0
            },
            point: {
              configurable: !0
            }
          };

          Mn.prototype.clone = function () {
            var t = new Mn(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies);
            return t.tileSize = this.tileSize, t.latRange = this.latRange, t.width = this.width, t.height = this.height, t._center = this._center, t.zoom = this.zoom, t.angle = this.angle, t._fov = this._fov, t._pitch = this._pitch, t._unmodified = this._unmodified, t._edgeInsets = this._edgeInsets.clone(), t._calcMatrices(), t;
          }, An.minZoom.get = function () {
            return this._minZoom;
          }, An.minZoom.set = function (t) {
            this._minZoom !== t && (this._minZoom = t, this.zoom = Math.max(this.zoom, t));
          }, An.maxZoom.get = function () {
            return this._maxZoom;
          }, An.maxZoom.set = function (t) {
            this._maxZoom !== t && (this._maxZoom = t, this.zoom = Math.min(this.zoom, t));
          }, An.minPitch.get = function () {
            return this._minPitch;
          }, An.minPitch.set = function (t) {
            this._minPitch !== t && (this._minPitch = t, this.pitch = Math.max(this.pitch, t));
          }, An.maxPitch.get = function () {
            return this._maxPitch;
          }, An.maxPitch.set = function (t) {
            this._maxPitch !== t && (this._maxPitch = t, this.pitch = Math.min(this.pitch, t));
          }, An.renderWorldCopies.get = function () {
            return this._renderWorldCopies;
          }, An.renderWorldCopies.set = function (t) {
            void 0 === t ? t = !0 : null === t && (t = !1), this._renderWorldCopies = t;
          }, An.worldSize.get = function () {
            return this.tileSize * this.scale;
          }, An.centerOffset.get = function () {
            return this.centerPoint._sub(this.size._div(2));
          }, An.size.get = function () {
            return new t.Point(this.width, this.height);
          }, An.bearing.get = function () {
            return -this.angle / Math.PI * 180;
          }, An.bearing.set = function (e) {
            var r = -t.wrap(e, -180, 180) * Math.PI / 180;
            this.angle !== r && (this._unmodified = !1, this.angle = r, this._calcMatrices(), this.rotationMatrix = t.create$2(), t.rotate(this.rotationMatrix, this.rotationMatrix, this.angle));
          }, An.pitch.get = function () {
            return this._pitch / Math.PI * 180;
          }, An.pitch.set = function (e) {
            var r = t.clamp(e, this.minPitch, this.maxPitch) / 180 * Math.PI;
            this._pitch !== r && (this._unmodified = !1, this._pitch = r, this._calcMatrices());
          }, An.fov.get = function () {
            return this._fov / Math.PI * 180;
          }, An.fov.set = function (t) {
            t = Math.max(.01, Math.min(60, t)), this._fov !== t && (this._unmodified = !1, this._fov = t / 180 * Math.PI, this._calcMatrices());
          }, An.zoom.get = function () {
            return this._zoom;
          }, An.zoom.set = function (t) {
            var e = Math.min(Math.max(t, this.minZoom), this.maxZoom);
            this._zoom !== e && (this._unmodified = !1, this._zoom = e, this.scale = this.zoomScale(e), this.tileZoom = Math.floor(e), this.zoomFraction = e - this.tileZoom, this._constrain(), this._calcMatrices());
          }, An.center.get = function () {
            return this._center;
          }, An.center.set = function (t) {
            t.lat === this._center.lat && t.lng === this._center.lng || (this._unmodified = !1, this._center = t, this._constrain(), this._calcMatrices());
          }, An.padding.get = function () {
            return this._edgeInsets.toJSON();
          }, An.padding.set = function (t) {
            this._edgeInsets.equals(t) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, t, 1), this._calcMatrices());
          }, An.centerPoint.get = function () {
            return this._edgeInsets.getCenter(this.width, this.height);
          }, Mn.prototype.isPaddingEqual = function (t) {
            return this._edgeInsets.equals(t);
          }, Mn.prototype.interpolatePadding = function (t, e, r) {
            this._unmodified = !1, this._edgeInsets.interpolate(t, e, r), this._constrain(), this._calcMatrices();
          }, Mn.prototype.coveringZoomLevel = function (t) {
            var e = (t.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / t.tileSize));
            return Math.max(0, e);
          }, Mn.prototype.getVisibleUnwrappedCoordinates = function (e) {
            var r = [new t.UnwrappedTileID(0, e)];
            if (this._renderWorldCopies) for (var n = this.pointCoordinate(new t.Point(0, 0)), i = this.pointCoordinate(new t.Point(this.width, 0)), a = this.pointCoordinate(new t.Point(this.width, this.height)), o = this.pointCoordinate(new t.Point(0, this.height)), s = Math.floor(Math.min(n.x, i.x, a.x, o.x)), l = Math.floor(Math.max(n.x, i.x, a.x, o.x)), c = s - 1; c <= l + 1; c++) {
              0 !== c && r.push(new t.UnwrappedTileID(c, e));
            }
            return r;
          }, Mn.prototype.coveringTiles = function (e) {
            var r = this.coveringZoomLevel(e),
                n = r;
            if (void 0 !== e.minzoom && r < e.minzoom) return [];
            void 0 !== e.maxzoom && r > e.maxzoom && (r = e.maxzoom);
            var i = t.MercatorCoordinate.fromLngLat(this.center),
                a = Math.pow(2, r),
                o = [a * i.x, a * i.y, 0],
                s = wn.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, r),
                l = e.minzoom || 0;
            this.pitch <= 60 && this._edgeInsets.top < .1 && (l = r);

            var c = function c(t) {
              return {
                aabb: new Tn([t * a, 0, 0], [(t + 1) * a, a, 0]),
                zoom: 0,
                x: 0,
                y: 0,
                wrap: t,
                fullyVisible: !1
              };
            },
                u = [],
                f = [],
                h = r,
                p = e.reparseOverscaled ? n : r;

            if (this._renderWorldCopies) for (var d = 1; d <= 3; d++) {
              u.push(c(-d)), u.push(c(d));
            }

            for (u.push(c(0)); u.length > 0;) {
              var m = u.pop(),
                  g = m.x,
                  v = m.y,
                  y = m.fullyVisible;

              if (!y) {
                var x = m.aabb.intersects(s);
                if (0 === x) continue;
                y = 2 === x;
              }

              var b = m.aabb.distanceX(o),
                  _ = m.aabb.distanceY(o),
                  w = Math.max(Math.abs(b), Math.abs(_)),
                  T = 3 + (1 << h - m.zoom) - 2;

              if (m.zoom === h || w > T && m.zoom >= l) f.push({
                tileID: new t.OverscaledTileID(m.zoom === h ? p : m.zoom, m.wrap, m.zoom, g, v),
                distanceSq: t.sqrLen([o[0] - .5 - g, o[1] - .5 - v])
              });else for (var k = 0; k < 4; k++) {
                var M = (g << 1) + k % 2,
                    A = (v << 1) + (k >> 1);
                u.push({
                  aabb: m.aabb.quadrant(k),
                  zoom: m.zoom + 1,
                  x: M,
                  y: A,
                  wrap: m.wrap,
                  fullyVisible: y
                });
              }
            }

            return f.sort(function (t, e) {
              return t.distanceSq - e.distanceSq;
            }).map(function (t) {
              return t.tileID;
            });
          }, Mn.prototype.resize = function (t, e) {
            this.width = t, this.height = e, this.pixelsToGLUnits = [2 / t, -2 / e], this._constrain(), this._calcMatrices();
          }, An.unmodified.get = function () {
            return this._unmodified;
          }, Mn.prototype.zoomScale = function (t) {
            return Math.pow(2, t);
          }, Mn.prototype.scaleZoom = function (t) {
            return Math.log(t) / Math.LN2;
          }, Mn.prototype.project = function (e) {
            var r = t.clamp(e.lat, -this.maxValidLatitude, this.maxValidLatitude);
            return new t.Point(t.mercatorXfromLng(e.lng) * this.worldSize, t.mercatorYfromLat(r) * this.worldSize);
          }, Mn.prototype.unproject = function (e) {
            return new t.MercatorCoordinate(e.x / this.worldSize, e.y / this.worldSize).toLngLat();
          }, An.point.get = function () {
            return this.project(this.center);
          }, Mn.prototype.setLocationAtPoint = function (e, r) {
            var n = this.pointCoordinate(r),
                i = this.pointCoordinate(this.centerPoint),
                a = this.locationCoordinate(e),
                o = new t.MercatorCoordinate(a.x - (n.x - i.x), a.y - (n.y - i.y));
            this.center = this.coordinateLocation(o), this._renderWorldCopies && (this.center = this.center.wrap());
          }, Mn.prototype.locationPoint = function (t) {
            return this.coordinatePoint(this.locationCoordinate(t));
          }, Mn.prototype.pointLocation = function (t) {
            return this.coordinateLocation(this.pointCoordinate(t));
          }, Mn.prototype.locationCoordinate = function (e) {
            return t.MercatorCoordinate.fromLngLat(e);
          }, Mn.prototype.coordinateLocation = function (t) {
            return t.toLngLat();
          }, Mn.prototype.pointCoordinate = function (e) {
            var r = [e.x, e.y, 0, 1],
                n = [e.x, e.y, 1, 1];
            t.transformMat4(r, r, this.pixelMatrixInverse), t.transformMat4(n, n, this.pixelMatrixInverse);
            var i = r[3],
                a = n[3],
                o = r[0] / i,
                s = n[0] / a,
                l = r[1] / i,
                c = n[1] / a,
                u = r[2] / i,
                f = n[2] / a,
                h = u === f ? 0 : (0 - u) / (f - u);
            return new t.MercatorCoordinate(t.number(o, s, h) / this.worldSize, t.number(l, c, h) / this.worldSize);
          }, Mn.prototype.coordinatePoint = function (e) {
            var r = [e.x * this.worldSize, e.y * this.worldSize, 0, 1];
            return t.transformMat4(r, r, this.pixelMatrix), new t.Point(r[0] / r[3], r[1] / r[3]);
          }, Mn.prototype.getBounds = function () {
            return new t.LngLatBounds().extend(this.pointLocation(new t.Point(0, 0))).extend(this.pointLocation(new t.Point(this.width, 0))).extend(this.pointLocation(new t.Point(this.width, this.height))).extend(this.pointLocation(new t.Point(0, this.height)));
          }, Mn.prototype.getMaxBounds = function () {
            return this.latRange && 2 === this.latRange.length && this.lngRange && 2 === this.lngRange.length ? new t.LngLatBounds([this.lngRange[0], this.latRange[0]], [this.lngRange[1], this.latRange[1]]) : null;
          }, Mn.prototype.setMaxBounds = function (t) {
            t ? (this.lngRange = [t.getWest(), t.getEast()], this.latRange = [t.getSouth(), t.getNorth()], this._constrain()) : (this.lngRange = null, this.latRange = [-this.maxValidLatitude, this.maxValidLatitude]);
          }, Mn.prototype.calculatePosMatrix = function (e, r) {
            void 0 === r && (r = !1);
            var n = e.key,
                i = r ? this._alignedPosMatrixCache : this._posMatrixCache;
            if (i[n]) return i[n];
            var a = e.canonical,
                o = this.worldSize / this.zoomScale(a.z),
                s = a.x + Math.pow(2, a.z) * e.wrap,
                l = t.identity(new Float64Array(16));
            return t.translate(l, l, [s * o, a.y * o, 0]), t.scale(l, l, [o / t.EXTENT, o / t.EXTENT, 1]), t.multiply(l, r ? this.alignedProjMatrix : this.projMatrix, l), i[n] = new Float32Array(l), i[n];
          }, Mn.prototype.customLayerMatrix = function () {
            return this.mercatorMatrix.slice();
          }, Mn.prototype._constrain = function () {
            if (this.center && this.width && this.height && !this._constraining) {
              this._constraining = !0;
              var e,
                  r,
                  n,
                  i,
                  a = -90,
                  o = 90,
                  s = -180,
                  l = 180,
                  c = this.size,
                  u = this._unmodified;

              if (this.latRange) {
                var f = this.latRange;
                a = t.mercatorYfromLat(f[1]) * this.worldSize, e = (o = t.mercatorYfromLat(f[0]) * this.worldSize) - a < c.y ? c.y / (o - a) : 0;
              }

              if (this.lngRange) {
                var h = this.lngRange;
                s = t.mercatorXfromLng(h[0]) * this.worldSize, r = (l = t.mercatorXfromLng(h[1]) * this.worldSize) - s < c.x ? c.x / (l - s) : 0;
              }

              var p = this.point,
                  d = Math.max(r || 0, e || 0);
              if (d) return this.center = this.unproject(new t.Point(r ? (l + s) / 2 : p.x, e ? (o + a) / 2 : p.y)), this.zoom += this.scaleZoom(d), this._unmodified = u, void (this._constraining = !1);

              if (this.latRange) {
                var m = p.y,
                    g = c.y / 2;
                m - g < a && (i = a + g), m + g > o && (i = o - g);
              }

              if (this.lngRange) {
                var v = p.x,
                    y = c.x / 2;
                v - y < s && (n = s + y), v + y > l && (n = l - y);
              }

              void 0 === n && void 0 === i || (this.center = this.unproject(new t.Point(void 0 !== n ? n : p.x, void 0 !== i ? i : p.y))), this._unmodified = u, this._constraining = !1;
            }
          }, Mn.prototype._calcMatrices = function () {
            if (this.height) {
              var e = this._fov / 2,
                  r = this.centerOffset;
              this.cameraToCenterDistance = .5 / Math.tan(e) * this.height;
              var n = Math.PI / 2 + this._pitch,
                  i = this._fov * (.5 + r.y / this.height),
                  a = Math.sin(i) * this.cameraToCenterDistance / Math.sin(t.clamp(Math.PI - n - i, .01, Math.PI - .01)),
                  o = this.point,
                  s = o.x,
                  l = o.y,
                  c = 1.01 * (Math.cos(Math.PI / 2 - this._pitch) * a + this.cameraToCenterDistance),
                  u = this.height / 50,
                  f = new Float64Array(16);
              t.perspective(f, this._fov, this.width / this.height, u, c), f[8] = 2 * -r.x / this.width, f[9] = 2 * r.y / this.height, t.scale(f, f, [1, -1, 1]), t.translate(f, f, [0, 0, -this.cameraToCenterDistance]), t.rotateX(f, f, this._pitch), t.rotateZ(f, f, this.angle), t.translate(f, f, [-s, -l, 0]), this.mercatorMatrix = t.scale([], f, [this.worldSize, this.worldSize, this.worldSize]), t.scale(f, f, [1, 1, t.mercatorZfromAltitude(1, this.center.lat) * this.worldSize, 1]), this.projMatrix = f, this.invProjMatrix = t.invert([], this.projMatrix);
              var h = this.width % 2 / 2,
                  p = this.height % 2 / 2,
                  d = Math.cos(this.angle),
                  m = Math.sin(this.angle),
                  g = s - Math.round(s) + d * h + m * p,
                  v = l - Math.round(l) + d * p + m * h,
                  y = new Float64Array(f);
              if (t.translate(y, y, [g > .5 ? g - 1 : g, v > .5 ? v - 1 : v, 0]), this.alignedProjMatrix = y, f = t.create(), t.scale(f, f, [this.width / 2, -this.height / 2, 1]), t.translate(f, f, [1, -1, 0]), this.labelPlaneMatrix = f, f = t.create(), t.scale(f, f, [1, -1, 1]), t.translate(f, f, [-1, -1, 0]), t.scale(f, f, [2 / this.width, 2 / this.height, 1]), this.glCoordMatrix = f, this.pixelMatrix = t.multiply(new Float64Array(16), this.labelPlaneMatrix, this.projMatrix), !(f = t.invert(new Float64Array(16), this.pixelMatrix))) throw new Error("failed to invert matrix");
              this.pixelMatrixInverse = f, this._posMatrixCache = {}, this._alignedPosMatrixCache = {};
            }
          }, Mn.prototype.maxPitchScaleFactor = function () {
            if (!this.pixelMatrixInverse) return 1;
            var e = this.pointCoordinate(new t.Point(0, 0)),
                r = [e.x * this.worldSize, e.y * this.worldSize, 0, 1];
            return t.transformMat4(r, r, this.pixelMatrix)[3] / this.cameraToCenterDistance;
          }, Mn.prototype.getCameraPoint = function () {
            var e = this._pitch,
                r = Math.tan(e) * (this.cameraToCenterDistance || 1);
            return this.centerPoint.add(new t.Point(0, r));
          }, Mn.prototype.getCameraQueryGeometry = function (e) {
            var r = this.getCameraPoint();
            if (1 === e.length) return [e[0], r];

            for (var n = r.x, i = r.y, a = r.x, o = r.y, s = 0, l = e; s < l.length; s += 1) {
              var c = l[s];
              n = Math.min(n, c.x), i = Math.min(i, c.y), a = Math.max(a, c.x), o = Math.max(o, c.y);
            }

            return [new t.Point(n, i), new t.Point(a, i), new t.Point(a, o), new t.Point(n, o), new t.Point(n, i)];
          }, Object.defineProperties(Mn.prototype, An);

          var Sn = function Sn(e) {
            var r, n, i, a, _o2;

            this._hashName = e && encodeURIComponent(e), t.bindAll(["_getCurrentHash", "_onHashChange", "_updateHash"], this), this._updateHash = (r = this._updateHashUnthrottled.bind(this), n = 300, i = !1, a = null, _o2 = function o() {
              a = null, i && (r(), a = setTimeout(_o2, n), i = !1);
            }, function () {
              return i = !0, a || _o2(), a;
            });
          };

          Sn.prototype.addTo = function (e) {
            return this._map = e, t.window.addEventListener("hashchange", this._onHashChange, !1), this._map.on("moveend", this._updateHash), this;
          }, Sn.prototype.remove = function () {
            return t.window.removeEventListener("hashchange", this._onHashChange, !1), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), delete this._map, this;
          }, Sn.prototype.getHashString = function (e) {
            var r = this._map.getCenter(),
                n = Math.round(100 * this._map.getZoom()) / 100,
                i = Math.ceil((n * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10),
                a = Math.pow(10, i),
                o = Math.round(r.lng * a) / a,
                s = Math.round(r.lat * a) / a,
                l = this._map.getBearing(),
                c = this._map.getPitch(),
                u = "";

            if (u += e ? "/" + o + "/" + s + "/" + n : n + "/" + s + "/" + o, (l || c) && (u += "/" + Math.round(10 * l) / 10), c && (u += "/" + Math.round(c)), this._hashName) {
              var f = this._hashName,
                  h = !1,
                  p = t.window.location.hash.slice(1).split("&").map(function (t) {
                var e = t.split("=")[0];
                return e === f ? (h = !0, e + "=" + u) : t;
              }).filter(function (t) {
                return t;
              });
              return h || p.push(f + "=" + u), "#" + p.join("&");
            }

            return "#" + u;
          }, Sn.prototype._getCurrentHash = function () {
            var e,
                r = this,
                n = t.window.location.hash.replace("#", "");
            return this._hashName ? (n.split("&").map(function (t) {
              return t.split("=");
            }).forEach(function (t) {
              t[0] === r._hashName && (e = t);
            }), (e && e[1] || "").split("/")) : n.split("/");
          }, Sn.prototype._onHashChange = function () {
            var t = this._getCurrentHash();

            if (t.length >= 3 && !t.some(function (t) {
              return isNaN(t);
            })) {
              var e = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(t[3] || 0) : this._map.getBearing();
              return this._map.jumpTo({
                center: [+t[2], +t[1]],
                zoom: +t[0],
                bearing: e,
                pitch: +(t[4] || 0)
              }), !0;
            }

            return !1;
          }, Sn.prototype._updateHashUnthrottled = function () {
            var e = this.getHashString();

            try {
              t.window.history.replaceState(t.window.history.state, "", e);
            } catch (t) {}
          };

          var En = {
            linearity: .3,
            easing: t.bezier(0, 0, .3, 1)
          },
              Ln = t.extend({
            deceleration: 2500,
            maxSpeed: 1400
          }, En),
              Cn = t.extend({
            deceleration: 20,
            maxSpeed: 1400
          }, En),
              Pn = t.extend({
            deceleration: 1e3,
            maxSpeed: 360
          }, En),
              In = t.extend({
            deceleration: 1e3,
            maxSpeed: 90
          }, En),
              On = function On(t) {
            this._map = t, this.clear();
          };

          function zn(t, e) {
            (!t.duration || t.duration < e.duration) && (t.duration = e.duration, t.easing = e.easing);
          }

          function Dn(e, r, n) {
            var i = n.maxSpeed,
                a = n.linearity,
                o = n.deceleration,
                s = t.clamp(e * a / (r / 1e3), -i, i),
                l = Math.abs(s) / (o * a);
            return {
              easing: n.easing,
              duration: 1e3 * l,
              amount: s * (l / 2)
            };
          }

          On.prototype.clear = function () {
            this._inertiaBuffer = [];
          }, On.prototype.record = function (e) {
            this._drainInertiaBuffer(), this._inertiaBuffer.push({
              time: t.browser.now(),
              settings: e
            });
          }, On.prototype._drainInertiaBuffer = function () {
            for (var e = this._inertiaBuffer, r = t.browser.now(); e.length > 0 && r - e[0].time > 160;) {
              e.shift();
            }
          }, On.prototype._onMoveEnd = function (e) {
            if (this._drainInertiaBuffer(), !(this._inertiaBuffer.length < 2)) {
              for (var r = {
                zoom: 0,
                bearing: 0,
                pitch: 0,
                pan: new t.Point(0, 0),
                pinchAround: void 0,
                around: void 0
              }, n = 0, i = this._inertiaBuffer; n < i.length; n += 1) {
                var a = i[n].settings;
                r.zoom += a.zoomDelta || 0, r.bearing += a.bearingDelta || 0, r.pitch += a.pitchDelta || 0, a.panDelta && r.pan._add(a.panDelta), a.around && (r.around = a.around), a.pinchAround && (r.pinchAround = a.pinchAround);
              }

              var o = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time,
                  s = {};

              if (r.pan.mag()) {
                var l = Dn(r.pan.mag(), o, t.extend({}, Ln, e || {}));
                s.offset = r.pan.mult(l.amount / r.pan.mag()), s.center = this._map.transform.center, zn(s, l);
              }

              if (r.zoom) {
                var c = Dn(r.zoom, o, Cn);
                s.zoom = this._map.transform.zoom + c.amount, zn(s, c);
              }

              if (r.bearing) {
                var u = Dn(r.bearing, o, Pn);
                s.bearing = this._map.transform.bearing + t.clamp(u.amount, -179, 179), zn(s, u);
              }

              if (r.pitch) {
                var f = Dn(r.pitch, o, In);
                s.pitch = this._map.transform.pitch + f.amount, zn(s, f);
              }

              if (s.zoom || s.bearing) {
                var h = void 0 === r.pinchAround ? r.around : r.pinchAround;
                s.around = h ? this._map.unproject(h) : this._map.getCenter();
              }

              return this.clear(), t.extend(s, {
                noMoveStart: !0
              });
            }
          };

          var Rn = function (e) {
            function n(n, i, a, o) {
              void 0 === o && (o = {});
              var s = r.mousePos(i.getCanvasContainer(), a),
                  l = i.unproject(s);
              e.call(this, n, t.extend({
                point: s,
                lngLat: l,
                originalEvent: a
              }, o)), this._defaultPrevented = !1, this.target = i;
            }

            e && (n.__proto__ = e), n.prototype = Object.create(e && e.prototype), n.prototype.constructor = n;
            var i = {
              defaultPrevented: {
                configurable: !0
              }
            };
            return n.prototype.preventDefault = function () {
              this._defaultPrevented = !0;
            }, i.defaultPrevented.get = function () {
              return this._defaultPrevented;
            }, Object.defineProperties(n.prototype, i), n;
          }(t.Event),
              Fn = function (e) {
            function n(n, i, a) {
              var o = "touchend" === n ? a.changedTouches : a.touches,
                  s = r.touchPos(i.getCanvasContainer(), o),
                  l = s.map(function (t) {
                return i.unproject(t);
              }),
                  c = s.reduce(function (t, e, r, n) {
                return t.add(e.div(n.length));
              }, new t.Point(0, 0)),
                  u = i.unproject(c);
              e.call(this, n, {
                points: s,
                point: c,
                lngLats: l,
                lngLat: u,
                originalEvent: a
              }), this._defaultPrevented = !1;
            }

            e && (n.__proto__ = e), n.prototype = Object.create(e && e.prototype), n.prototype.constructor = n;
            var i = {
              defaultPrevented: {
                configurable: !0
              }
            };
            return n.prototype.preventDefault = function () {
              this._defaultPrevented = !0;
            }, i.defaultPrevented.get = function () {
              return this._defaultPrevented;
            }, Object.defineProperties(n.prototype, i), n;
          }(t.Event),
              Bn = function (t) {
            function e(e, r, n) {
              t.call(this, e, {
                originalEvent: n
              }), this._defaultPrevented = !1;
            }

            t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
            var r = {
              defaultPrevented: {
                configurable: !0
              }
            };
            return e.prototype.preventDefault = function () {
              this._defaultPrevented = !0;
            }, r.defaultPrevented.get = function () {
              return this._defaultPrevented;
            }, Object.defineProperties(e.prototype, r), e;
          }(t.Event),
              Nn = function Nn(t, e) {
            this._map = t, this._clickTolerance = e.clickTolerance;
          };

          Nn.prototype.reset = function () {
            delete this._mousedownPos;
          }, Nn.prototype.wheel = function (t) {
            return this._firePreventable(new Bn(t.type, this._map, t));
          }, Nn.prototype.mousedown = function (t, e) {
            return this._mousedownPos = e, this._firePreventable(new Rn(t.type, this._map, t));
          }, Nn.prototype.mouseup = function (t) {
            this._map.fire(new Rn(t.type, this._map, t));
          }, Nn.prototype.click = function (t, e) {
            this._mousedownPos && this._mousedownPos.dist(e) >= this._clickTolerance || this._map.fire(new Rn(t.type, this._map, t));
          }, Nn.prototype.dblclick = function (t) {
            return this._firePreventable(new Rn(t.type, this._map, t));
          }, Nn.prototype.mouseover = function (t) {
            this._map.fire(new Rn(t.type, this._map, t));
          }, Nn.prototype.mouseout = function (t) {
            this._map.fire(new Rn(t.type, this._map, t));
          }, Nn.prototype.touchstart = function (t) {
            return this._firePreventable(new Fn(t.type, this._map, t));
          }, Nn.prototype.touchmove = function (t) {
            this._map.fire(new Fn(t.type, this._map, t));
          }, Nn.prototype.touchend = function (t) {
            this._map.fire(new Fn(t.type, this._map, t));
          }, Nn.prototype.touchcancel = function (t) {
            this._map.fire(new Fn(t.type, this._map, t));
          }, Nn.prototype._firePreventable = function (t) {
            if (this._map.fire(t), t.defaultPrevented) return {};
          }, Nn.prototype.isEnabled = function () {
            return !0;
          }, Nn.prototype.isActive = function () {
            return !1;
          }, Nn.prototype.enable = function () {}, Nn.prototype.disable = function () {};

          var jn = function jn(t) {
            this._map = t;
          };

          jn.prototype.reset = function () {
            this._delayContextMenu = !1, delete this._contextMenuEvent;
          }, jn.prototype.mousemove = function (t) {
            this._map.fire(new Rn(t.type, this._map, t));
          }, jn.prototype.mousedown = function () {
            this._delayContextMenu = !0;
          }, jn.prototype.mouseup = function () {
            this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new Rn("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
          }, jn.prototype.contextmenu = function (t) {
            this._delayContextMenu ? this._contextMenuEvent = t : this._map.fire(new Rn(t.type, this._map, t)), this._map.listens("contextmenu") && t.preventDefault();
          }, jn.prototype.isEnabled = function () {
            return !0;
          }, jn.prototype.isActive = function () {
            return !1;
          }, jn.prototype.enable = function () {}, jn.prototype.disable = function () {};

          var Un = function Un(t, e) {
            this._map = t, this._el = t.getCanvasContainer(), this._container = t.getContainer(), this._clickTolerance = e.clickTolerance || 1;
          };

          function Vn(t, e) {
            for (var r = {}, n = 0; n < t.length; n++) {
              r[t[n].identifier] = e[n];
            }

            return r;
          }

          Un.prototype.isEnabled = function () {
            return !!this._enabled;
          }, Un.prototype.isActive = function () {
            return !!this._active;
          }, Un.prototype.enable = function () {
            this.isEnabled() || (this._enabled = !0);
          }, Un.prototype.disable = function () {
            this.isEnabled() && (this._enabled = !1);
          }, Un.prototype.mousedown = function (t, e) {
            this.isEnabled() && t.shiftKey && 0 === t.button && (r.disableDrag(), this._startPos = this._lastPos = e, this._active = !0);
          }, Un.prototype.mousemoveWindow = function (t, e) {
            if (this._active) {
              var n = e;

              if (!(this._lastPos.equals(n) || !this._box && n.dist(this._startPos) < this._clickTolerance)) {
                var i = this._startPos;
                this._lastPos = n, this._box || (this._box = r.create("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", t));
                var a = Math.min(i.x, n.x),
                    o = Math.max(i.x, n.x),
                    s = Math.min(i.y, n.y),
                    l = Math.max(i.y, n.y);
                r.setTransform(this._box, "translate(" + a + "px," + s + "px)"), this._box.style.width = o - a + "px", this._box.style.height = l - s + "px";
              }
            }
          }, Un.prototype.mouseupWindow = function (e, n) {
            var i = this;

            if (this._active && 0 === e.button) {
              var a = this._startPos,
                  o = n;
              if (this.reset(), r.suppressClick(), a.x !== o.x || a.y !== o.y) return this._map.fire(new t.Event("boxzoomend", {
                originalEvent: e
              })), {
                cameraAnimation: function cameraAnimation(t) {
                  return t.fitScreenCoordinates(a, o, i._map.getBearing(), {
                    linear: !0
                  });
                }
              };

              this._fireEvent("boxzoomcancel", e);
            }
          }, Un.prototype.keydown = function (t) {
            this._active && 27 === t.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", t));
          }, Un.prototype.reset = function () {
            this._active = !1, this._container.classList.remove("mapboxgl-crosshair"), this._box && (r.remove(this._box), this._box = null), r.enableDrag(), delete this._startPos, delete this._lastPos;
          }, Un.prototype._fireEvent = function (e, r) {
            return this._map.fire(new t.Event(e, {
              originalEvent: r
            }));
          };

          var qn = function qn(t) {
            this.reset(), this.numTouches = t.numTouches;
          };

          qn.prototype.reset = function () {
            delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
          }, qn.prototype.touchstart = function (e, r, n) {
            (this.centroid || n.length > this.numTouches) && (this.aborted = !0), this.aborted || (void 0 === this.startTime && (this.startTime = e.timeStamp), n.length === this.numTouches && (this.centroid = function (e) {
              for (var r = new t.Point(0, 0), n = 0, i = e; n < i.length; n += 1) {
                var a = i[n];

                r._add(a);
              }

              return r.div(e.length);
            }(r), this.touches = Vn(n, r)));
          }, qn.prototype.touchmove = function (t, e, r) {
            if (!this.aborted && this.centroid) {
              var n = Vn(r, e);

              for (var i in this.touches) {
                var a = this.touches[i],
                    o = n[i];
                (!o || o.dist(a) > 30) && (this.aborted = !0);
              }
            }
          }, qn.prototype.touchend = function (t, e, r) {
            if ((!this.centroid || t.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === r.length) {
              var n = !this.aborted && this.centroid;
              if (this.reset(), n) return n;
            }
          };

          var Hn = function Hn(t) {
            this.singleTap = new qn(t), this.numTaps = t.numTaps, this.reset();
          };

          Hn.prototype.reset = function () {
            this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
          }, Hn.prototype.touchstart = function (t, e, r) {
            this.singleTap.touchstart(t, e, r);
          }, Hn.prototype.touchmove = function (t, e, r) {
            this.singleTap.touchmove(t, e, r);
          }, Hn.prototype.touchend = function (t, e, r) {
            var n = this.singleTap.touchend(t, e, r);

            if (n) {
              var i = t.timeStamp - this.lastTime < 500,
                  a = !this.lastTap || this.lastTap.dist(n) < 30;
              if (i && a || this.reset(), this.count++, this.lastTime = t.timeStamp, this.lastTap = n, this.count === this.numTaps) return this.reset(), n;
            }
          };

          var Gn = function Gn() {
            this._zoomIn = new Hn({
              numTouches: 1,
              numTaps: 2
            }), this._zoomOut = new Hn({
              numTouches: 2,
              numTaps: 1
            }), this.reset();
          };

          Gn.prototype.reset = function () {
            this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
          }, Gn.prototype.touchstart = function (t, e, r) {
            this._zoomIn.touchstart(t, e, r), this._zoomOut.touchstart(t, e, r);
          }, Gn.prototype.touchmove = function (t, e, r) {
            this._zoomIn.touchmove(t, e, r), this._zoomOut.touchmove(t, e, r);
          }, Gn.prototype.touchend = function (t, e, r) {
            var n = this,
                i = this._zoomIn.touchend(t, e, r),
                a = this._zoomOut.touchend(t, e, r);

            return i ? (this._active = !0, t.preventDefault(), setTimeout(function () {
              return n.reset();
            }, 0), {
              cameraAnimation: function cameraAnimation(e) {
                return e.easeTo({
                  duration: 300,
                  zoom: e.getZoom() + 1,
                  around: e.unproject(i)
                }, {
                  originalEvent: t
                });
              }
            }) : a ? (this._active = !0, t.preventDefault(), setTimeout(function () {
              return n.reset();
            }, 0), {
              cameraAnimation: function cameraAnimation(e) {
                return e.easeTo({
                  duration: 300,
                  zoom: e.getZoom() - 1,
                  around: e.unproject(a)
                }, {
                  originalEvent: t
                });
              }
            }) : void 0;
          }, Gn.prototype.touchcancel = function () {
            this.reset();
          }, Gn.prototype.enable = function () {
            this._enabled = !0;
          }, Gn.prototype.disable = function () {
            this._enabled = !1, this.reset();
          }, Gn.prototype.isEnabled = function () {
            return this._enabled;
          }, Gn.prototype.isActive = function () {
            return this._active;
          };

          var Yn = function Yn(t) {
            this.reset(), this._clickTolerance = t.clickTolerance || 1;
          };

          Yn.prototype.reset = function () {
            this._active = !1, this._moved = !1, delete this._lastPoint, delete this._eventButton;
          }, Yn.prototype._correctButton = function (t, e) {
            return !1;
          }, Yn.prototype._move = function (t, e) {
            return {};
          }, Yn.prototype.mousedown = function (t, e) {
            if (!this._lastPoint) {
              var n = r.mouseButton(t);
              this._correctButton(t, n) && (this._lastPoint = e, this._eventButton = n);
            }
          }, Yn.prototype.mousemoveWindow = function (t, e) {
            var r = this._lastPoint;
            if (r && (t.preventDefault(), this._moved || !(e.dist(r) < this._clickTolerance))) return this._moved = !0, this._lastPoint = e, this._move(r, e);
          }, Yn.prototype.mouseupWindow = function (t) {
            r.mouseButton(t) === this._eventButton && (this._moved && r.suppressClick(), this.reset());
          }, Yn.prototype.enable = function () {
            this._enabled = !0;
          }, Yn.prototype.disable = function () {
            this._enabled = !1, this.reset();
          }, Yn.prototype.isEnabled = function () {
            return this._enabled;
          }, Yn.prototype.isActive = function () {
            return this._active;
          };

          var Wn = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.mousedown = function (e, r) {
              t.prototype.mousedown.call(this, e, r), this._lastPoint && (this._active = !0);
            }, e.prototype._correctButton = function (t, e) {
              return 0 === e && !t.ctrlKey;
            }, e.prototype._move = function (t, e) {
              return {
                around: e,
                panDelta: e.sub(t)
              };
            }, e;
          }(Yn),
              Xn = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._correctButton = function (t, e) {
              return 0 === e && t.ctrlKey || 2 === e;
            }, e.prototype._move = function (t, e) {
              var r = .8 * (e.x - t.x);
              if (r) return this._active = !0, {
                bearingDelta: r
              };
            }, e.prototype.contextmenu = function (t) {
              t.preventDefault();
            }, e;
          }(Yn),
              Zn = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype._correctButton = function (t, e) {
              return 0 === e && t.ctrlKey || 2 === e;
            }, e.prototype._move = function (t, e) {
              var r = -.5 * (e.y - t.y);
              if (r) return this._active = !0, {
                pitchDelta: r
              };
            }, e.prototype.contextmenu = function (t) {
              t.preventDefault();
            }, e;
          }(Yn),
              Jn = function Jn(t) {
            this._minTouches = 1, this._clickTolerance = t.clickTolerance || 1, this.reset();
          };

          Jn.prototype.reset = function () {
            this._active = !1, this._touches = {}, this._sum = new t.Point(0, 0);
          }, Jn.prototype.touchstart = function (t, e, r) {
            return this._calculateTransform(t, e, r);
          }, Jn.prototype.touchmove = function (t, e, r) {
            if (this._active) return t.preventDefault(), this._calculateTransform(t, e, r);
          }, Jn.prototype.touchend = function (t, e, r) {
            this._calculateTransform(t, e, r), this._active && r.length < this._minTouches && this.reset();
          }, Jn.prototype.touchcancel = function () {
            this.reset();
          }, Jn.prototype._calculateTransform = function (e, r, n) {
            n.length > 0 && (this._active = !0);
            var i = Vn(n, r),
                a = new t.Point(0, 0),
                o = new t.Point(0, 0),
                s = 0;

            for (var l in i) {
              var c = i[l],
                  u = this._touches[l];
              u && (a._add(c), o._add(c.sub(u)), s++, i[l] = c);
            }

            if (this._touches = i, !(s < this._minTouches) && o.mag()) {
              var f = o.div(s);
              if (this._sum._add(f), !(this._sum.mag() < this._clickTolerance)) return {
                around: a.div(s),
                panDelta: f
              };
            }
          }, Jn.prototype.enable = function () {
            this._enabled = !0;
          }, Jn.prototype.disable = function () {
            this._enabled = !1, this.reset();
          }, Jn.prototype.isEnabled = function () {
            return this._enabled;
          }, Jn.prototype.isActive = function () {
            return this._active;
          };

          var Kn = function Kn() {
            this.reset();
          };

          function Qn(t, e, r) {
            for (var n = 0; n < t.length; n++) {
              if (t[n].identifier === r) return e[n];
            }
          }

          Kn.prototype.reset = function () {
            this._active = !1, delete this._firstTwoTouches;
          }, Kn.prototype._start = function (t) {}, Kn.prototype._move = function (t, e, r) {
            return {};
          }, Kn.prototype.touchstart = function (t, e, r) {
            this._firstTwoTouches || r.length < 2 || (this._firstTwoTouches = [r[0].identifier, r[1].identifier], this._start([e[0], e[1]]));
          }, Kn.prototype.touchmove = function (t, e, r) {
            if (this._firstTwoTouches) {
              t.preventDefault();
              var n = this._firstTwoTouches,
                  i = n[0],
                  a = n[1],
                  o = Qn(r, e, i),
                  s = Qn(r, e, a);

              if (o && s) {
                var l = this._aroundCenter ? null : o.add(s).div(2);
                return this._move([o, s], l, t);
              }
            }
          }, Kn.prototype.touchend = function (t, e, n) {
            if (this._firstTwoTouches) {
              var i = this._firstTwoTouches,
                  a = i[0],
                  o = i[1],
                  s = Qn(n, e, a),
                  l = Qn(n, e, o);
              s && l || (this._active && r.suppressClick(), this.reset());
            }
          }, Kn.prototype.touchcancel = function () {
            this.reset();
          }, Kn.prototype.enable = function (t) {
            this._enabled = !0, this._aroundCenter = !!t && "center" === t.around;
          }, Kn.prototype.disable = function () {
            this._enabled = !1, this.reset();
          }, Kn.prototype.isEnabled = function () {
            return this._enabled;
          }, Kn.prototype.isActive = function () {
            return this._active;
          };

          function $n(t, e) {
            return Math.log(t / e) / Math.LN2;
          }

          var ti = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.reset = function () {
              t.prototype.reset.call(this), delete this._distance, delete this._startDistance;
            }, e.prototype._start = function (t) {
              this._startDistance = this._distance = t[0].dist(t[1]);
            }, e.prototype._move = function (t, e) {
              var r = this._distance;
              if (this._distance = t[0].dist(t[1]), this._active || !(Math.abs($n(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                zoomDelta: $n(this._distance, r),
                pinchAround: e
              };
            }, e;
          }(Kn);

          function ei(t, e) {
            return 180 * t.angleWith(e) / Math.PI;
          }

          var ri = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.reset = function () {
              t.prototype.reset.call(this), delete this._minDiameter, delete this._startVector, delete this._vector;
            }, e.prototype._start = function (t) {
              this._startVector = this._vector = t[0].sub(t[1]), this._minDiameter = t[0].dist(t[1]);
            }, e.prototype._move = function (t, e) {
              var r = this._vector;
              if (this._vector = t[0].sub(t[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, {
                bearingDelta: ei(this._vector, r),
                pinchAround: e
              };
            }, e.prototype._isBelowThreshold = function (t) {
              this._minDiameter = Math.min(this._minDiameter, t.mag());
              var e = 25 / (Math.PI * this._minDiameter) * 360,
                  r = ei(t, this._startVector);
              return Math.abs(r) < e;
            }, e;
          }(Kn);

          function ni(t) {
            return Math.abs(t.y) > Math.abs(t.x);
          }

          var ii = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.reset = function () {
              t.prototype.reset.call(this), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
            }, e.prototype._start = function (t) {
              this._lastPoints = t, ni(t[0].sub(t[1])) && (this._valid = !1);
            }, e.prototype._move = function (t, e, r) {
              var n = t[0].sub(this._lastPoints[0]),
                  i = t[1].sub(this._lastPoints[1]);

              if (this._valid = this.gestureBeginsVertically(n, i, r.timeStamp), this._valid) {
                this._lastPoints = t, this._active = !0;
                return {
                  pitchDelta: -.5 * ((n.y + i.y) / 2)
                };
              }
            }, e.prototype.gestureBeginsVertically = function (t, e, r) {
              if (void 0 !== this._valid) return this._valid;
              var n = t.mag() >= 2,
                  i = e.mag() >= 2;

              if (n || i) {
                if (!n || !i) return void 0 === this._firstMove && (this._firstMove = r), r - this._firstMove < 100 && void 0;
                var a = t.y > 0 == e.y > 0;
                return ni(t) && ni(e) && a;
              }
            }, e;
          }(Kn),
              ai = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
          },
              oi = function oi() {
            var t = ai;
            this._panStep = t.panStep, this._bearingStep = t.bearingStep, this._pitchStep = t.pitchStep;
          };

          function si(t) {
            return t * (2 - t);
          }

          oi.prototype.reset = function () {
            this._active = !1;
          }, oi.prototype.keydown = function (t) {
            var e = this;

            if (!(t.altKey || t.ctrlKey || t.metaKey)) {
              var r = 0,
                  n = 0,
                  i = 0,
                  a = 0,
                  o = 0;

              switch (t.keyCode) {
                case 61:
                case 107:
                case 171:
                case 187:
                  r = 1;
                  break;

                case 189:
                case 109:
                case 173:
                  r = -1;
                  break;

                case 37:
                  t.shiftKey ? n = -1 : (t.preventDefault(), a = -1);
                  break;

                case 39:
                  t.shiftKey ? n = 1 : (t.preventDefault(), a = 1);
                  break;

                case 38:
                  t.shiftKey ? i = 1 : (t.preventDefault(), o = -1);
                  break;

                case 40:
                  t.shiftKey ? i = -1 : (t.preventDefault(), o = 1);
                  break;

                default:
                  return;
              }

              return {
                cameraAnimation: function cameraAnimation(s) {
                  var l = s.getZoom();
                  s.easeTo({
                    duration: 300,
                    easeId: "keyboardHandler",
                    easing: si,
                    zoom: r ? Math.round(l) + r * (t.shiftKey ? 2 : 1) : l,
                    bearing: s.getBearing() + n * e._bearingStep,
                    pitch: s.getPitch() + i * e._pitchStep,
                    offset: [-a * e._panStep, -o * e._panStep],
                    center: s.getCenter()
                  }, {
                    originalEvent: t
                  });
                }
              };
            }
          }, oi.prototype.enable = function () {
            this._enabled = !0;
          }, oi.prototype.disable = function () {
            this._enabled = !1, this.reset();
          }, oi.prototype.isEnabled = function () {
            return this._enabled;
          }, oi.prototype.isActive = function () {
            return this._active;
          };

          var li = function li(e, r) {
            this._map = e, this._el = e.getCanvasContainer(), this._handler = r, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = 1 / 450, t.bindAll(["_onWheel", "_onTimeout", "_onScrollFrame", "_onScrollFinished"], this);
          };

          li.prototype.setZoomRate = function (t) {
            this._defaultZoomRate = t;
          }, li.prototype.setWheelZoomRate = function (t) {
            this._wheelZoomRate = t;
          }, li.prototype.isEnabled = function () {
            return !!this._enabled;
          }, li.prototype.isActive = function () {
            return !!this._active || void 0 !== this._finishTimeout;
          }, li.prototype.isZooming = function () {
            return !!this._zooming;
          }, li.prototype.enable = function (t) {
            this.isEnabled() || (this._enabled = !0, this._aroundCenter = t && "center" === t.around);
          }, li.prototype.disable = function () {
            this.isEnabled() && (this._enabled = !1);
          }, li.prototype.wheel = function (e) {
            if (this.isEnabled()) {
              var r = e.deltaMode === t.window.WheelEvent.DOM_DELTA_LINE ? 40 * e.deltaY : e.deltaY,
                  n = t.browser.now(),
                  i = n - (this._lastWheelEventTime || 0);
              this._lastWheelEventTime = n, 0 !== r && r % 4.000244140625 == 0 ? this._type = "wheel" : 0 !== r && Math.abs(r) < 4 ? this._type = "trackpad" : i > 400 ? (this._type = null, this._lastValue = r, this._timeout = setTimeout(this._onTimeout, 40, e)) : this._type || (this._type = Math.abs(i * r) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, r += this._lastValue)), e.shiftKey && r && (r /= 4), this._type && (this._lastWheelEvent = e, this._delta -= r, this._active || this._start(e)), e.preventDefault();
            }
          }, li.prototype._onTimeout = function (t) {
            this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(t);
          }, li.prototype._start = function (e) {
            if (this._delta) {
              this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
              var n = r.mousePos(this._el, e);
              this._around = t.LngLat.convert(this._aroundCenter ? this._map.getCenter() : this._map.unproject(n)), this._aroundPoint = this._map.transform.locationPoint(this._around), this._frameId || (this._frameId = !0, this._handler._triggerRenderFrame());
            }
          }, li.prototype.renderFrame = function () {
            return this._onScrollFrame();
          }, li.prototype._onScrollFrame = function () {
            var e = this;

            if (this._frameId && (this._frameId = null, this.isActive())) {
              var r = this._map.transform;

              if (0 !== this._delta) {
                var n = "wheel" === this._type && Math.abs(this._delta) > 4.000244140625 ? this._wheelZoomRate : this._defaultZoomRate,
                    i = 2 / (1 + Math.exp(-Math.abs(this._delta * n)));
                this._delta < 0 && 0 !== i && (i = 1 / i);
                var a = "number" == typeof this._targetZoom ? r.zoomScale(this._targetZoom) : r.scale;
                this._targetZoom = Math.min(r.maxZoom, Math.max(r.minZoom, r.scaleZoom(a * i))), "wheel" === this._type && (this._startZoom = r.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
              }

              var o,
                  s = "number" == typeof this._targetZoom ? this._targetZoom : r.zoom,
                  l = this._startZoom,
                  c = this._easing,
                  u = !1;

              if ("wheel" === this._type && l && c) {
                var f = Math.min((t.browser.now() - this._lastWheelEventTime) / 200, 1),
                    h = c(f);
                o = t.number(l, s, h), f < 1 ? this._frameId || (this._frameId = !0) : u = !0;
              } else o = s, u = !0;

              return this._active = !0, u && (this._active = !1, this._finishTimeout = setTimeout(function () {
                e._zooming = !1, e._handler._triggerRenderFrame(), delete e._targetZoom, delete e._finishTimeout;
              }, 200)), {
                noInertia: !0,
                needsRenderFrame: !u,
                zoomDelta: o - r.zoom,
                around: this._aroundPoint,
                originalEvent: this._lastWheelEvent
              };
            }
          }, li.prototype._smoothOutEasing = function (e) {
            var r = t.ease;

            if (this._prevEase) {
              var n = this._prevEase,
                  i = (t.browser.now() - n.start) / n.duration,
                  a = n.easing(i + .01) - n.easing(i),
                  o = .27 / Math.sqrt(a * a + 1e-4) * .01,
                  s = Math.sqrt(.0729 - o * o);
              r = t.bezier(o, s, .25, 1);
            }

            return this._prevEase = {
              start: t.browser.now(),
              duration: e,
              easing: r
            }, r;
          }, li.prototype.reset = function () {
            this._active = !1;
          };

          var ci = function ci(t, e) {
            this._clickZoom = t, this._tapZoom = e;
          };

          ci.prototype.enable = function () {
            this._clickZoom.enable(), this._tapZoom.enable();
          }, ci.prototype.disable = function () {
            this._clickZoom.disable(), this._tapZoom.disable();
          }, ci.prototype.isEnabled = function () {
            return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
          }, ci.prototype.isActive = function () {
            return this._clickZoom.isActive() || this._tapZoom.isActive();
          };

          var ui = function ui() {
            this.reset();
          };

          ui.prototype.reset = function () {
            this._active = !1;
          }, ui.prototype.dblclick = function (t, e) {
            return t.preventDefault(), {
              cameraAnimation: function cameraAnimation(r) {
                r.easeTo({
                  duration: 300,
                  zoom: r.getZoom() + (t.shiftKey ? -1 : 1),
                  around: r.unproject(e)
                }, {
                  originalEvent: t
                });
              }
            };
          }, ui.prototype.enable = function () {
            this._enabled = !0;
          }, ui.prototype.disable = function () {
            this._enabled = !1, this.reset();
          }, ui.prototype.isEnabled = function () {
            return this._enabled;
          }, ui.prototype.isActive = function () {
            return this._active;
          };

          var fi = function fi() {
            this._tap = new Hn({
              numTouches: 1,
              numTaps: 1
            }), this.reset();
          };

          fi.prototype.reset = function () {
            this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, this._tap.reset();
          }, fi.prototype.touchstart = function (t, e, r) {
            this._swipePoint || (this._tapTime && t.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? r.length > 0 && (this._swipePoint = e[0], this._swipeTouch = r[0].identifier) : this._tap.touchstart(t, e, r));
          }, fi.prototype.touchmove = function (t, e, r) {
            if (this._tapTime) {
              if (this._swipePoint) {
                if (r[0].identifier !== this._swipeTouch) return;
                var n = e[0],
                    i = n.y - this._swipePoint.y;
                return this._swipePoint = n, t.preventDefault(), this._active = !0, {
                  zoomDelta: i / 128
                };
              }
            } else this._tap.touchmove(t, e, r);
          }, fi.prototype.touchend = function (t, e, r) {
            this._tapTime ? this._swipePoint && 0 === r.length && this.reset() : this._tap.touchend(t, e, r) && (this._tapTime = t.timeStamp);
          }, fi.prototype.touchcancel = function () {
            this.reset();
          }, fi.prototype.enable = function () {
            this._enabled = !0;
          }, fi.prototype.disable = function () {
            this._enabled = !1, this.reset();
          }, fi.prototype.isEnabled = function () {
            return this._enabled;
          }, fi.prototype.isActive = function () {
            return this._active;
          };

          var hi = function hi(t, e, r) {
            this._el = t, this._mousePan = e, this._touchPan = r;
          };

          hi.prototype.enable = function (t) {
            this._inertiaOptions = t || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
          }, hi.prototype.disable = function () {
            this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
          }, hi.prototype.isEnabled = function () {
            return this._mousePan.isEnabled() && this._touchPan.isEnabled();
          }, hi.prototype.isActive = function () {
            return this._mousePan.isActive() || this._touchPan.isActive();
          };

          var pi = function pi(t, e, r) {
            this._pitchWithRotate = t.pitchWithRotate, this._mouseRotate = e, this._mousePitch = r;
          };

          pi.prototype.enable = function () {
            this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
          }, pi.prototype.disable = function () {
            this._mouseRotate.disable(), this._mousePitch.disable();
          }, pi.prototype.isEnabled = function () {
            return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
          }, pi.prototype.isActive = function () {
            return this._mouseRotate.isActive() || this._mousePitch.isActive();
          };

          var di = function di(t, e, r, n) {
            this._el = t, this._touchZoom = e, this._touchRotate = r, this._tapDragZoom = n, this._rotationDisabled = !1, this._enabled = !0;
          };

          di.prototype.enable = function (t) {
            this._touchZoom.enable(t), this._rotationDisabled || this._touchRotate.enable(t), this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
          }, di.prototype.disable = function () {
            this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
          }, di.prototype.isEnabled = function () {
            return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
          }, di.prototype.isActive = function () {
            return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
          }, di.prototype.disableRotation = function () {
            this._rotationDisabled = !0, this._touchRotate.disable();
          }, di.prototype.enableRotation = function () {
            this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
          };

          var mi = function mi(t) {
            return t.zoom || t.drag || t.pitch || t.rotate;
          },
              gi = function (t) {
            function e() {
              t.apply(this, arguments);
            }

            return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
          }(t.Event);

          function vi(t) {
            return t.panDelta && t.panDelta.mag() || t.zoomDelta || t.bearingDelta || t.pitchDelta;
          }

          var yi = function yi(e, n) {
            this._map = e, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new On(e), this._bearingSnap = n.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(n), t.bindAll(["handleEvent", "handleWindowEvent"], this);
            var i = this._el;
            this._listeners = [[i, "touchstart", {
              passive: !1
            }], [i, "touchmove", {
              passive: !1
            }], [i, "touchend", void 0], [i, "touchcancel", void 0], [i, "mousedown", void 0], [i, "mousemove", void 0], [i, "mouseup", void 0], [t.window.document, "mousemove", {
              capture: !0
            }], [t.window.document, "mouseup", void 0], [i, "mouseover", void 0], [i, "mouseout", void 0], [i, "dblclick", void 0], [i, "click", void 0], [i, "keydown", {
              capture: !1
            }], [i, "keyup", void 0], [i, "wheel", {
              passive: !1
            }], [i, "contextmenu", void 0], [t.window, "blur", void 0]];

            for (var a = 0, o = this._listeners; a < o.length; a += 1) {
              var s = o[a],
                  l = s[0],
                  c = s[1],
                  u = s[2];
              r.addEventListener(l, c, l === t.window.document ? this.handleWindowEvent : this.handleEvent, u);
            }
          };

          yi.prototype.destroy = function () {
            for (var e = 0, n = this._listeners; e < n.length; e += 1) {
              var i = n[e],
                  a = i[0],
                  o = i[1],
                  s = i[2];
              r.removeEventListener(a, o, a === t.window.document ? this.handleWindowEvent : this.handleEvent, s);
            }
          }, yi.prototype._addDefaultHandlers = function (t) {
            var e = this._map,
                r = e.getCanvasContainer();

            this._add("mapEvent", new Nn(e, t));

            var n = e.boxZoom = new Un(e, t);

            this._add("boxZoom", n);

            var i = new Gn(),
                a = new ui();
            e.doubleClickZoom = new ci(a, i), this._add("tapZoom", i), this._add("clickZoom", a);
            var o = new fi();

            this._add("tapDragZoom", o);

            var s = e.touchPitch = new ii();

            this._add("touchPitch", s);

            var l = new Xn(t),
                c = new Zn(t);
            e.dragRotate = new pi(t, l, c), this._add("mouseRotate", l, ["mousePitch"]), this._add("mousePitch", c, ["mouseRotate"]);
            var u = new Wn(t),
                f = new Jn(t);
            e.dragPan = new hi(r, u, f), this._add("mousePan", u), this._add("touchPan", f, ["touchZoom", "touchRotate"]);
            var h = new ri(),
                p = new ti();
            e.touchZoomRotate = new di(r, p, h, o), this._add("touchRotate", h, ["touchPan", "touchZoom"]), this._add("touchZoom", p, ["touchPan", "touchRotate"]);
            var d = e.scrollZoom = new li(e, this);

            this._add("scrollZoom", d, ["mousePan"]);

            var m = e.keyboard = new oi();
            this._add("keyboard", m), this._add("blockableMapEvent", new jn(e));

            for (var g = 0, v = ["boxZoom", "doubleClickZoom", "tapDragZoom", "touchPitch", "dragRotate", "dragPan", "touchZoomRotate", "scrollZoom", "keyboard"]; g < v.length; g += 1) {
              var y = v[g];
              t.interactive && t[y] && e[y].enable(t[y]);
            }
          }, yi.prototype._add = function (t, e, r) {
            this._handlers.push({
              handlerName: t,
              handler: e,
              allowed: r
            }), this._handlersById[t] = e;
          }, yi.prototype.stop = function () {
            if (!this._updatingCamera) {
              for (var t = 0, e = this._handlers; t < e.length; t += 1) {
                e[t].handler.reset();
              }

              this._inertia.clear(), this._fireEvents({}, {}), this._changes = [];
            }
          }, yi.prototype.isActive = function () {
            for (var t = 0, e = this._handlers; t < e.length; t += 1) {
              if (e[t].handler.isActive()) return !0;
            }

            return !1;
          }, yi.prototype.isZooming = function () {
            return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
          }, yi.prototype.isRotating = function () {
            return !!this._eventsInProgress.rotate;
          }, yi.prototype.isMoving = function () {
            return Boolean(mi(this._eventsInProgress)) || this.isZooming();
          }, yi.prototype._blockedByActive = function (t, e, r) {
            for (var n in t) {
              if (n !== r && (!e || e.indexOf(n) < 0)) return !0;
            }

            return !1;
          }, yi.prototype.handleWindowEvent = function (t) {
            this.handleEvent(t, t.type + "Window");
          }, yi.prototype._getMapTouches = function (t) {
            for (var e = [], r = 0, n = t; r < n.length; r += 1) {
              var i = n[r],
                  a = i.target;
              this._el.contains(a) && e.push(i);
            }

            return e;
          }, yi.prototype.handleEvent = function (t, e) {
            if ("blur" !== t.type) {
              this._updatingCamera = !0;

              for (var n = "renderFrame" === t.type ? void 0 : t, i = {
                needsRenderFrame: !1
              }, a = {}, o = {}, s = t.touches ? this._getMapTouches(t.touches) : void 0, l = s ? r.touchPos(this._el, s) : r.mousePos(this._el, t), c = 0, u = this._handlers; c < u.length; c += 1) {
                var f = u[c],
                    h = f.handlerName,
                    p = f.handler,
                    d = f.allowed;

                if (p.isEnabled()) {
                  var m = void 0;
                  this._blockedByActive(o, d, h) ? p.reset() : p[e || t.type] && (m = p[e || t.type](t, l, s), this.mergeHandlerResult(i, a, m, h, n), m && m.needsRenderFrame && this._triggerRenderFrame()), (m || p.isActive()) && (o[h] = p);
                }
              }

              var g = {};

              for (var v in this._previousActiveHandlers) {
                o[v] || (g[v] = n);
              }

              this._previousActiveHandlers = o, (Object.keys(g).length || vi(i)) && (this._changes.push([i, a, g]), this._triggerRenderFrame()), (Object.keys(o).length || vi(i)) && this._map._stop(!0), this._updatingCamera = !1;
              var y = i.cameraAnimation;
              y && (this._inertia.clear(), this._fireEvents({}, {}), this._changes = [], y(this._map));
            } else this.stop();
          }, yi.prototype.mergeHandlerResult = function (e, r, n, i, a) {
            if (n) {
              t.extend(e, n);
              var o = {
                handlerName: i,
                originalEvent: n.originalEvent || a
              };
              void 0 !== n.zoomDelta && (r.zoom = o), void 0 !== n.panDelta && (r.drag = o), void 0 !== n.pitchDelta && (r.pitch = o), void 0 !== n.bearingDelta && (r.rotate = o);
            }
          }, yi.prototype._applyChanges = function () {
            for (var e = {}, r = {}, n = {}, i = 0, a = this._changes; i < a.length; i += 1) {
              var o = a[i],
                  s = o[0],
                  l = o[1],
                  c = o[2];
              s.panDelta && (e.panDelta = (e.panDelta || new t.Point(0, 0))._add(s.panDelta)), s.zoomDelta && (e.zoomDelta = (e.zoomDelta || 0) + s.zoomDelta), s.bearingDelta && (e.bearingDelta = (e.bearingDelta || 0) + s.bearingDelta), s.pitchDelta && (e.pitchDelta = (e.pitchDelta || 0) + s.pitchDelta), void 0 !== s.around && (e.around = s.around), void 0 !== s.pinchAround && (e.pinchAround = s.pinchAround), s.noInertia && (e.noInertia = s.noInertia), t.extend(r, l), t.extend(n, c);
            }

            this._updateMapTransform(e, r, n), this._changes = [];
          }, yi.prototype._updateMapTransform = function (t, e, r) {
            var n = this._map,
                i = n.transform;
            if (!vi(t)) return this._fireEvents(e, r);
            var a = t.panDelta,
                o = t.zoomDelta,
                s = t.bearingDelta,
                l = t.pitchDelta,
                c = t.around,
                u = t.pinchAround;
            void 0 !== u && (c = u), n._stop(!0), c = c || n.transform.centerPoint;
            var f = i.pointLocation(a ? c.sub(a) : c);
            s && (i.bearing += s), l && (i.pitch += l), o && (i.zoom += o), i.setLocationAtPoint(f, c), this._map._update(), t.noInertia || this._inertia.record(t), this._fireEvents(e, r);
          }, yi.prototype._fireEvents = function (e, r) {
            var n = this,
                i = mi(this._eventsInProgress),
                a = mi(e),
                o = {};

            for (var s in e) {
              var l = e[s].originalEvent;
              this._eventsInProgress[s] || (o[s + "start"] = l), this._eventsInProgress[s] = e[s];
            }

            for (var c in !i && a && this._fireEvent("movestart", a.originalEvent), o) {
              this._fireEvent(c, o[c]);
            }

            for (var u in e.rotate && (this._bearingChanged = !0), a && this._fireEvent("move", a.originalEvent), e) {
              var f = e[u].originalEvent;

              this._fireEvent(u, f);
            }

            var h,
                p = {};

            for (var d in this._eventsInProgress) {
              var m = this._eventsInProgress[d],
                  g = m.handlerName,
                  v = m.originalEvent;
              this._handlersById[g].isActive() || (delete this._eventsInProgress[d], h = r[g] || v, p[d + "end"] = h);
            }

            for (var y in p) {
              this._fireEvent(y, p[y]);
            }

            var x = mi(this._eventsInProgress);

            if ((i || a) && !x) {
              this._updatingCamera = !0;

              var b = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions),
                  _ = function _(t) {
                return 0 !== t && -n._bearingSnap < t && t < n._bearingSnap;
              };

              b ? (_(b.bearing || this._map.getBearing()) && (b.bearing = 0), this._map.easeTo(b, {
                originalEvent: h
              })) : (this._map.fire(new t.Event("moveend", {
                originalEvent: h
              })), _(this._map.getBearing()) && this._map.resetNorth()), this._bearingChanged = !1, this._updatingCamera = !1;
            }
          }, yi.prototype._fireEvent = function (e, r) {
            this._map.fire(new t.Event(e, r ? {
              originalEvent: r
            } : {}));
          }, yi.prototype._triggerRenderFrame = function () {
            var t = this;
            void 0 === this._frameId && (this._frameId = this._map._requestRenderFrame(function (e) {
              delete t._frameId, t.handleEvent(new gi("renderFrame", {
                timeStamp: e
              })), t._applyChanges();
            }));
          };

          var xi = function (e) {
            function r(r, n) {
              e.call(this), this._moving = !1, this._zooming = !1, this.transform = r, this._bearingSnap = n.bearingSnap, t.bindAll(["_renderFrameCallback"], this);
            }

            return e && (r.__proto__ = e), r.prototype = Object.create(e && e.prototype), r.prototype.constructor = r, r.prototype.getCenter = function () {
              return new t.LngLat(this.transform.center.lng, this.transform.center.lat);
            }, r.prototype.setCenter = function (t, e) {
              return this.jumpTo({
                center: t
              }, e);
            }, r.prototype.panBy = function (e, r, n) {
              return e = t.Point.convert(e).mult(-1), this.panTo(this.transform.center, t.extend({
                offset: e
              }, r), n);
            }, r.prototype.panTo = function (e, r, n) {
              return this.easeTo(t.extend({
                center: e
              }, r), n);
            }, r.prototype.getZoom = function () {
              return this.transform.zoom;
            }, r.prototype.setZoom = function (t, e) {
              return this.jumpTo({
                zoom: t
              }, e), this;
            }, r.prototype.zoomTo = function (e, r, n) {
              return this.easeTo(t.extend({
                zoom: e
              }, r), n);
            }, r.prototype.zoomIn = function (t, e) {
              return this.zoomTo(this.getZoom() + 1, t, e), this;
            }, r.prototype.zoomOut = function (t, e) {
              return this.zoomTo(this.getZoom() - 1, t, e), this;
            }, r.prototype.getBearing = function () {
              return this.transform.bearing;
            }, r.prototype.setBearing = function (t, e) {
              return this.jumpTo({
                bearing: t
              }, e), this;
            }, r.prototype.getPadding = function () {
              return this.transform.padding;
            }, r.prototype.setPadding = function (t, e) {
              return this.jumpTo({
                padding: t
              }, e), this;
            }, r.prototype.rotateTo = function (e, r, n) {
              return this.easeTo(t.extend({
                bearing: e
              }, r), n);
            }, r.prototype.resetNorth = function (e, r) {
              return this.rotateTo(0, t.extend({
                duration: 1e3
              }, e), r), this;
            }, r.prototype.resetNorthPitch = function (e, r) {
              return this.easeTo(t.extend({
                bearing: 0,
                pitch: 0,
                duration: 1e3
              }, e), r), this;
            }, r.prototype.snapToNorth = function (t, e) {
              return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(t, e) : this;
            }, r.prototype.getPitch = function () {
              return this.transform.pitch;
            }, r.prototype.setPitch = function (t, e) {
              return this.jumpTo({
                pitch: t
              }, e), this;
            }, r.prototype.cameraForBounds = function (e, r) {
              return e = t.LngLatBounds.convert(e), this._cameraForBoxAndBearing(e.getNorthWest(), e.getSouthEast(), 0, r);
            }, r.prototype._cameraForBoxAndBearing = function (e, r, n, i) {
              var a = {
                top: 0,
                bottom: 0,
                right: 0,
                left: 0
              };

              if ("number" == typeof (i = t.extend({
                padding: a,
                offset: [0, 0],
                maxZoom: this.transform.maxZoom
              }, i)).padding) {
                var o = i.padding;
                i.padding = {
                  top: o,
                  bottom: o,
                  right: o,
                  left: o
                };
              }

              i.padding = t.extend(a, i.padding);
              var s = this.transform,
                  l = s.padding,
                  c = s.project(t.LngLat.convert(e)),
                  u = s.project(t.LngLat.convert(r)),
                  f = c.rotate(-n * Math.PI / 180),
                  h = u.rotate(-n * Math.PI / 180),
                  p = new t.Point(Math.max(f.x, h.x), Math.max(f.y, h.y)),
                  d = new t.Point(Math.min(f.x, h.x), Math.min(f.y, h.y)),
                  m = p.sub(d),
                  g = (s.width - (l.left + l.right + i.padding.left + i.padding.right)) / m.x,
                  v = (s.height - (l.top + l.bottom + i.padding.top + i.padding.bottom)) / m.y;

              if (!(v < 0 || g < 0)) {
                var y = Math.min(s.scaleZoom(s.scale * Math.min(g, v)), i.maxZoom),
                    x = t.Point.convert(i.offset),
                    b = (i.padding.left - i.padding.right) / 2,
                    _ = (i.padding.top - i.padding.bottom) / 2,
                    w = new t.Point(x.x + b, x.y + _).mult(s.scale / s.zoomScale(y));

                return {
                  center: s.unproject(c.add(u).div(2).sub(w)),
                  zoom: y,
                  bearing: n
                };
              }

              t.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
            }, r.prototype.fitBounds = function (t, e, r) {
              return this._fitInternal(this.cameraForBounds(t, e), e, r);
            }, r.prototype.fitScreenCoordinates = function (e, r, n, i, a) {
              return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(t.Point.convert(e)), this.transform.pointLocation(t.Point.convert(r)), n, i), i, a);
            }, r.prototype._fitInternal = function (e, r, n) {
              return e ? (delete (r = t.extend(e, r)).padding, r.linear ? this.easeTo(r, n) : this.flyTo(r, n)) : this;
            }, r.prototype.jumpTo = function (e, r) {
              this.stop();
              var n = this.transform,
                  i = !1,
                  a = !1,
                  o = !1;
              return "zoom" in e && n.zoom !== +e.zoom && (i = !0, n.zoom = +e.zoom), void 0 !== e.center && (n.center = t.LngLat.convert(e.center)), "bearing" in e && n.bearing !== +e.bearing && (a = !0, n.bearing = +e.bearing), "pitch" in e && n.pitch !== +e.pitch && (o = !0, n.pitch = +e.pitch), null == e.padding || n.isPaddingEqual(e.padding) || (n.padding = e.padding), this.fire(new t.Event("movestart", r)).fire(new t.Event("move", r)), i && this.fire(new t.Event("zoomstart", r)).fire(new t.Event("zoom", r)).fire(new t.Event("zoomend", r)), a && this.fire(new t.Event("rotatestart", r)).fire(new t.Event("rotate", r)).fire(new t.Event("rotateend", r)), o && this.fire(new t.Event("pitchstart", r)).fire(new t.Event("pitch", r)).fire(new t.Event("pitchend", r)), this.fire(new t.Event("moveend", r));
            }, r.prototype.easeTo = function (e, r) {
              var n = this;
              this._stop(!1, e.easeId), (!1 === (e = t.extend({
                offset: [0, 0],
                duration: 500,
                easing: t.ease
              }, e)).animate || !e.essential && t.browser.prefersReducedMotion) && (e.duration = 0);
              var i = this.transform,
                  a = this.getZoom(),
                  o = this.getBearing(),
                  s = this.getPitch(),
                  l = this.getPadding(),
                  c = "zoom" in e ? +e.zoom : a,
                  u = "bearing" in e ? this._normalizeBearing(e.bearing, o) : o,
                  f = "pitch" in e ? +e.pitch : s,
                  h = "padding" in e ? e.padding : i.padding,
                  p = t.Point.convert(e.offset),
                  d = i.centerPoint.add(p),
                  m = i.pointLocation(d),
                  g = t.LngLat.convert(e.center || m);

              this._normalizeCenter(g);

              var v,
                  y,
                  x = i.project(m),
                  b = i.project(g).sub(x),
                  _ = i.zoomScale(c - a);

              e.around && (v = t.LngLat.convert(e.around), y = i.locationPoint(v));
              var w = {
                moving: this._moving,
                zooming: this._zooming,
                rotating: this._rotating,
                pitching: this._pitching
              };
              return this._zooming = this._zooming || c !== a, this._rotating = this._rotating || o !== u, this._pitching = this._pitching || f !== s, this._padding = !i.isPaddingEqual(h), this._easeId = e.easeId, this._prepareEase(r, e.noMoveStart, w), clearTimeout(this._easeEndTimeoutID), this._ease(function (e) {
                if (n._zooming && (i.zoom = t.number(a, c, e)), n._rotating && (i.bearing = t.number(o, u, e)), n._pitching && (i.pitch = t.number(s, f, e)), n._padding && (i.interpolatePadding(l, h, e), d = i.centerPoint.add(p)), v) i.setLocationAtPoint(v, y);else {
                  var m = i.zoomScale(i.zoom - a),
                      g = c > a ? Math.min(2, _) : Math.max(.5, _),
                      w = Math.pow(g, 1 - e),
                      T = i.unproject(x.add(b.mult(e * w)).mult(m));
                  i.setLocationAtPoint(i.renderWorldCopies ? T.wrap() : T, d);
                }

                n._fireMoveEvents(r);
              }, function (t) {
                n._afterEase(r, t);
              }, e), this;
            }, r.prototype._prepareEase = function (e, r, n) {
              void 0 === n && (n = {}), this._moving = !0, r || n.moving || this.fire(new t.Event("movestart", e)), this._zooming && !n.zooming && this.fire(new t.Event("zoomstart", e)), this._rotating && !n.rotating && this.fire(new t.Event("rotatestart", e)), this._pitching && !n.pitching && this.fire(new t.Event("pitchstart", e));
            }, r.prototype._fireMoveEvents = function (e) {
              this.fire(new t.Event("move", e)), this._zooming && this.fire(new t.Event("zoom", e)), this._rotating && this.fire(new t.Event("rotate", e)), this._pitching && this.fire(new t.Event("pitch", e));
            }, r.prototype._afterEase = function (e, r) {
              if (!this._easeId || !r || this._easeId !== r) {
                delete this._easeId;
                var n = this._zooming,
                    i = this._rotating,
                    a = this._pitching;
                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, n && this.fire(new t.Event("zoomend", e)), i && this.fire(new t.Event("rotateend", e)), a && this.fire(new t.Event("pitchend", e)), this.fire(new t.Event("moveend", e));
              }
            }, r.prototype.flyTo = function (e, r) {
              var n = this;

              if (!e.essential && t.browser.prefersReducedMotion) {
                var i = t.pick(e, ["center", "zoom", "bearing", "pitch", "around"]);
                return this.jumpTo(i, r);
              }

              this.stop(), e = t.extend({
                offset: [0, 0],
                speed: 1.2,
                curve: 1.42,
                easing: t.ease
              }, e);
              var a = this.transform,
                  o = this.getZoom(),
                  s = this.getBearing(),
                  l = this.getPitch(),
                  c = this.getPadding(),
                  u = "zoom" in e ? t.clamp(+e.zoom, a.minZoom, a.maxZoom) : o,
                  f = "bearing" in e ? this._normalizeBearing(e.bearing, s) : s,
                  h = "pitch" in e ? +e.pitch : l,
                  p = "padding" in e ? e.padding : a.padding,
                  d = a.zoomScale(u - o),
                  m = t.Point.convert(e.offset),
                  g = a.centerPoint.add(m),
                  v = a.pointLocation(g),
                  y = t.LngLat.convert(e.center || v);

              this._normalizeCenter(y);

              var x = a.project(v),
                  b = a.project(y).sub(x),
                  _ = e.curve,
                  w = Math.max(a.width, a.height),
                  T = w / d,
                  k = b.mag();

              if ("minZoom" in e) {
                var M = t.clamp(Math.min(e.minZoom, o, u), a.minZoom, a.maxZoom),
                    A = w / a.zoomScale(M - o);
                _ = Math.sqrt(A / k * 2);
              }

              var S = _ * _;

              function E(t) {
                var e = (T * T - w * w + (t ? -1 : 1) * S * S * k * k) / (2 * (t ? T : w) * S * k);
                return Math.log(Math.sqrt(e * e + 1) - e);
              }

              function L(t) {
                return (Math.exp(t) - Math.exp(-t)) / 2;
              }

              function C(t) {
                return (Math.exp(t) + Math.exp(-t)) / 2;
              }

              var P = E(0),
                  I = function I(t) {
                return C(P) / C(P + _ * t);
              },
                  O = function O(t) {
                return w * ((C(P) * (L(e = P + _ * t) / C(e)) - L(P)) / S) / k;
                var e;
              },
                  z = (E(1) - P) / _;

              if (Math.abs(k) < 1e-6 || !isFinite(z)) {
                if (Math.abs(w - T) < 1e-6) return this.easeTo(e, r);
                var D = T < w ? -1 : 1;
                z = Math.abs(Math.log(T / w)) / _, O = function O() {
                  return 0;
                }, I = function I(t) {
                  return Math.exp(D * _ * t);
                };
              }

              if ("duration" in e) e.duration = +e.duration;else {
                var R = "screenSpeed" in e ? +e.screenSpeed / _ : +e.speed;
                e.duration = 1e3 * z / R;
              }
              return e.maxDuration && e.duration > e.maxDuration && (e.duration = 0), this._zooming = !0, this._rotating = s !== f, this._pitching = h !== l, this._padding = !a.isPaddingEqual(p), this._prepareEase(r, !1), this._ease(function (e) {
                var i = e * z,
                    d = 1 / I(i);
                a.zoom = 1 === e ? u : o + a.scaleZoom(d), n._rotating && (a.bearing = t.number(s, f, e)), n._pitching && (a.pitch = t.number(l, h, e)), n._padding && (a.interpolatePadding(c, p, e), g = a.centerPoint.add(m));
                var v = 1 === e ? y : a.unproject(x.add(b.mult(O(i))).mult(d));
                a.setLocationAtPoint(a.renderWorldCopies ? v.wrap() : v, g), n._fireMoveEvents(r);
              }, function () {
                return n._afterEase(r);
              }, e), this;
            }, r.prototype.isEasing = function () {
              return !!this._easeFrameId;
            }, r.prototype.stop = function () {
              return this._stop();
            }, r.prototype._stop = function (t, e) {
              if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
                var r = this._onEaseEnd;
                delete this._onEaseEnd, r.call(this, e);
              }

              if (!t) {
                var n = this.handlers;
                n && n.stop();
              }

              return this;
            }, r.prototype._ease = function (e, r, n) {
              !1 === n.animate || 0 === n.duration ? (e(1), r()) : (this._easeStart = t.browser.now(), this._easeOptions = n, this._onEaseFrame = e, this._onEaseEnd = r, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }, r.prototype._renderFrameCallback = function () {
              var e = Math.min((t.browser.now() - this._easeStart) / this._easeOptions.duration, 1);
              this._onEaseFrame(this._easeOptions.easing(e)), e < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
            }, r.prototype._normalizeBearing = function (e, r) {
              e = t.wrap(e, -180, 180);
              var n = Math.abs(e - r);
              return Math.abs(e - 360 - r) < n && (e -= 360), Math.abs(e + 360 - r) < n && (e += 360), e;
            }, r.prototype._normalizeCenter = function (t) {
              var e = this.transform;

              if (e.renderWorldCopies && !e.lngRange) {
                var r = t.lng - e.center.lng;
                t.lng += r > 180 ? -360 : r < -180 ? 360 : 0;
              }
            }, r;
          }(t.Evented),
              bi = function bi(e) {
            void 0 === e && (e = {}), this.options = e, t.bindAll(["_updateEditLink", "_updateData", "_updateCompact"], this);
          };

          bi.prototype.getDefaultPosition = function () {
            return "bottom-right";
          }, bi.prototype.onAdd = function (t) {
            var e = this.options && this.options.compact;
            return this._map = t, this._container = r.create("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._innerContainer = r.create("div", "mapboxgl-ctrl-attrib-inner", this._container), e && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), void 0 === e && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
          }, bi.prototype.onRemove = function () {
            r.remove(this._container), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
          }, bi.prototype._updateEditLink = function () {
            var e = this._editLink;
            e || (e = this._editLink = this._container.querySelector(".mapbox-improve-map"));
            var r = [{
              key: "owner",
              value: this.styleOwner
            }, {
              key: "id",
              value: this.styleId
            }, {
              key: "access_token",
              value: this._map._requestManager._customAccessToken || t.config.ACCESS_TOKEN
            }];

            if (e) {
              var n = r.reduce(function (t, e, n) {
                return e.value && (t += e.key + "=" + e.value + (n < r.length - 1 ? "&" : "")), t;
              }, "?");
              e.href = t.config.FEEDBACK_URL + "/" + n + (this._map._hash ? this._map._hash.getHashString(!0) : ""), e.rel = "noopener nofollow";
            }
          }, bi.prototype._updateData = function (t) {
            !t || "metadata" !== t.sourceDataType && "style" !== t.dataType || (this._updateAttributions(), this._updateEditLink());
          }, bi.prototype._updateAttributions = function () {
            if (this._map.style) {
              var t = [];

              if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? t = t.concat(this.options.customAttribution.map(function (t) {
                return "string" != typeof t ? "" : t;
              })) : "string" == typeof this.options.customAttribution && t.push(this.options.customAttribution)), this._map.style.stylesheet) {
                var e = this._map.style.stylesheet;
                this.styleOwner = e.owner, this.styleId = e.id;
              }

              var r = this._map.style.sourceCaches;

              for (var n in r) {
                var i = r[n];

                if (i.used) {
                  var a = i.getSource();
                  a.attribution && t.indexOf(a.attribution) < 0 && t.push(a.attribution);
                }
              }

              t.sort(function (t, e) {
                return t.length - e.length;
              });
              var o = (t = t.filter(function (e, r) {
                for (var n = r + 1; n < t.length; n++) {
                  if (t[n].indexOf(e) >= 0) return !1;
                }

                return !0;
              })).join(" | ");
              o !== this._attribHTML && (this._attribHTML = o, t.length ? (this._innerContainer.innerHTML = o, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
            }
          }, bi.prototype._updateCompact = function () {
            this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact");
          };

          var _i = function _i() {
            t.bindAll(["_updateLogo"], this), t.bindAll(["_updateCompact"], this);
          };

          _i.prototype.onAdd = function (t) {
            this._map = t, this._container = r.create("div", "mapboxgl-ctrl");
            var e = r.create("a", "mapboxgl-ctrl-logo");
            return e.target = "_blank", e.rel = "noopener nofollow", e.href = "https://www.mapbox.com/", e.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), e.setAttribute("rel", "noopener nofollow"), this._container.appendChild(e), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
          }, _i.prototype.onRemove = function () {
            r.remove(this._container), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
          }, _i.prototype.getDefaultPosition = function () {
            return "bottom-left";
          }, _i.prototype._updateLogo = function (t) {
            t && "metadata" !== t.sourceDataType || (this._container.style.display = this._logoRequired() ? "block" : "none");
          }, _i.prototype._logoRequired = function () {
            if (this._map.style) {
              var t = this._map.style.sourceCaches;

              for (var e in t) {
                if (t[e].getSource().mapbox_logo) return !0;
              }

              return !1;
            }
          }, _i.prototype._updateCompact = function () {
            var t = this._container.children;

            if (t.length) {
              var e = t[0];
              this._map.getCanvasContainer().offsetWidth < 250 ? e.classList.add("mapboxgl-compact") : e.classList.remove("mapboxgl-compact");
            }
          };

          var wi = function wi() {
            this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
          };

          wi.prototype.add = function (t) {
            var e = ++this._id;
            return this._queue.push({
              callback: t,
              id: e,
              cancelled: !1
            }), e;
          }, wi.prototype.remove = function (t) {
            for (var e = this._currentlyRunning, r = 0, n = e ? this._queue.concat(e) : this._queue; r < n.length; r += 1) {
              var i = n[r];
              if (i.id === t) return void (i.cancelled = !0);
            }
          }, wi.prototype.run = function (t) {
            void 0 === t && (t = 0);
            var e = this._currentlyRunning = this._queue;
            this._queue = [];

            for (var r = 0, n = e; r < n.length; r += 1) {
              var i = n[r];
              if (!i.cancelled && (i.callback(t), this._cleared)) break;
            }

            this._cleared = !1, this._currentlyRunning = !1;
          }, wi.prototype.clear = function () {
            this._currentlyRunning && (this._cleared = !0), this._queue = [];
          };

          var Ti = {
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "Mapbox logo",
            "NavigationControl.ResetBearing": "Reset bearing to north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "ScaleControl.Feet": "ft",
            "ScaleControl.Meters": "m",
            "ScaleControl.Kilometers": "km",
            "ScaleControl.Miles": "mi",
            "ScaleControl.NauticalMiles": "nm"
          },
              ki = t.window.HTMLImageElement,
              Mi = t.window.HTMLElement,
              Ai = t.window.ImageBitmap,
              Si = {
            center: [0, 0],
            zoom: 0,
            bearing: 0,
            pitch: 0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 60,
            interactive: !0,
            scrollZoom: !0,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            bearingSnap: 7,
            clickTolerance: 3,
            pitchWithRotate: !0,
            hash: !1,
            attributionControl: !0,
            failIfMajorPerformanceCaveat: !1,
            preserveDrawingBuffer: !1,
            trackResize: !0,
            renderWorldCopies: !0,
            refreshExpiredTiles: !0,
            maxTileCacheSize: null,
            localIdeographFontFamily: "sans-serif",
            transformRequest: null,
            accessToken: null,
            fadeDuration: 300,
            crossSourceCollisions: !0
          },
              Ei = function (n) {
            function i(e) {
              var r = this;
              if (null != (e = t.extend({}, Si, e)).minZoom && null != e.maxZoom && e.minZoom > e.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
              if (null != e.minPitch && null != e.maxPitch && e.minPitch > e.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
              if (null != e.minPitch && e.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
              if (null != e.maxPitch && e.maxPitch > 60) throw new Error("maxPitch must be less than or equal to 60");
              var i = new Mn(e.minZoom, e.maxZoom, e.minPitch, e.maxPitch, e.renderWorldCopies);

              if (n.call(this, i, e), this._interactive = e.interactive, this._maxTileCacheSize = e.maxTileCacheSize, this._failIfMajorPerformanceCaveat = e.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = e.preserveDrawingBuffer, this._antialias = e.antialias, this._trackResize = e.trackResize, this._bearingSnap = e.bearingSnap, this._refreshExpiredTiles = e.refreshExpiredTiles, this._fadeDuration = e.fadeDuration, this._crossSourceCollisions = e.crossSourceCollisions, this._crossFadingFactor = 1, this._collectResourceTiming = e.collectResourceTiming, this._renderTaskQueue = new wi(), this._controls = [], this._mapId = t.uniqueId(), this._locale = t.extend({}, Ti, e.locale), this._requestManager = new t.RequestManager(e.transformRequest, e.accessToken), "string" == typeof e.container) {
                if (this._container = t.window.document.getElementById(e.container), !this._container) throw new Error("Container '" + e.container + "' not found.");
              } else {
                if (!(e.container instanceof Mi)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                this._container = e.container;
              }

              if (e.maxBounds && this.setMaxBounds(e.maxBounds), t.bindAll(["_onWindowOnline", "_onWindowResize", "_contextLost", "_contextRestored"], this), this._setupContainer(), this._setupPainter(), void 0 === this.painter) throw new Error("Failed to initialize WebGL.");
              this.on("move", function () {
                return r._update(!1);
              }), this.on("moveend", function () {
                return r._update(!1);
              }), this.on("zoom", function () {
                return r._update(!0);
              }), void 0 !== t.window && (t.window.addEventListener("online", this._onWindowOnline, !1), t.window.addEventListener("resize", this._onWindowResize, !1)), this.handlers = new yi(this, e);
              var a = "string" == typeof e.hash && e.hash || void 0;
              this._hash = e.hash && new Sn(a).addTo(this), this._hash && this._hash._onHashChange() || (this.jumpTo({
                center: e.center,
                zoom: e.zoom,
                bearing: e.bearing,
                pitch: e.pitch
              }), e.bounds && (this.resize(), this.fitBounds(e.bounds, t.extend({}, e.fitBoundsOptions, {
                duration: 0
              })))), this.resize(), this._localIdeographFontFamily = e.localIdeographFontFamily, e.style && this.setStyle(e.style, {
                localIdeographFontFamily: e.localIdeographFontFamily
              }), e.attributionControl && this.addControl(new bi({
                customAttribution: e.customAttribution
              })), this.addControl(new _i(), e.logoPosition), this.on("style.load", function () {
                r.transform.unmodified && r.jumpTo(r.style.stylesheet);
              }), this.on("data", function (e) {
                r._update("style" === e.dataType), r.fire(new t.Event(e.dataType + "data", e));
              }), this.on("dataloading", function (e) {
                r.fire(new t.Event(e.dataType + "dataloading", e));
              });
            }

            n && (i.__proto__ = n), i.prototype = Object.create(n && n.prototype), i.prototype.constructor = i;
            var a = {
              showTileBoundaries: {
                configurable: !0
              },
              showPadding: {
                configurable: !0
              },
              showCollisionBoxes: {
                configurable: !0
              },
              showOverdrawInspector: {
                configurable: !0
              },
              repaint: {
                configurable: !0
              },
              vertices: {
                configurable: !0
              },
              version: {
                configurable: !0
              }
            };
            return i.prototype._getMapId = function () {
              return this._mapId;
            }, i.prototype.addControl = function (e, r) {
              if (void 0 === r && e.getDefaultPosition && (r = e.getDefaultPosition()), void 0 === r && (r = "top-right"), !e || !e.onAdd) return this.fire(new t.ErrorEvent(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
              var n = e.onAdd(this);

              this._controls.push(e);

              var i = this._controlPositions[r];
              return -1 !== r.indexOf("bottom") ? i.insertBefore(n, i.firstChild) : i.appendChild(n), this;
            }, i.prototype.removeControl = function (e) {
              if (!e || !e.onRemove) return this.fire(new t.ErrorEvent(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));

              var r = this._controls.indexOf(e);

              return r > -1 && this._controls.splice(r, 1), e.onRemove(this), this;
            }, i.prototype.resize = function (e) {
              var r = this._containerDimensions(),
                  n = r[0],
                  i = r[1];

              this._resizeCanvas(n, i), this.transform.resize(n, i), this.painter.resize(n, i);
              var a = !this._moving;
              return a && (this.stop(), this.fire(new t.Event("movestart", e)).fire(new t.Event("move", e))), this.fire(new t.Event("resize", e)), a && this.fire(new t.Event("moveend", e)), this;
            }, i.prototype.getBounds = function () {
              return this.transform.getBounds();
            }, i.prototype.getMaxBounds = function () {
              return this.transform.getMaxBounds();
            }, i.prototype.setMaxBounds = function (e) {
              return this.transform.setMaxBounds(t.LngLatBounds.convert(e)), this._update();
            }, i.prototype.setMinZoom = function (t) {
              if ((t = null == t ? -2 : t) >= -2 && t <= this.transform.maxZoom) return this.transform.minZoom = t, this._update(), this.getZoom() < t && this.setZoom(t), this;
              throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
            }, i.prototype.getMinZoom = function () {
              return this.transform.minZoom;
            }, i.prototype.setMaxZoom = function (t) {
              if ((t = null == t ? 22 : t) >= this.transform.minZoom) return this.transform.maxZoom = t, this._update(), this.getZoom() > t && this.setZoom(t), this;
              throw new Error("maxZoom must be greater than the current minZoom");
            }, i.prototype.getMaxZoom = function () {
              return this.transform.maxZoom;
            }, i.prototype.setMinPitch = function (t) {
              if ((t = null == t ? 0 : t) < 0) throw new Error("minPitch must be greater than or equal to 0");
              if (t >= 0 && t <= this.transform.maxPitch) return this.transform.minPitch = t, this._update(), this.getPitch() < t && this.setPitch(t), this;
              throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
            }, i.prototype.getMinPitch = function () {
              return this.transform.minPitch;
            }, i.prototype.setMaxPitch = function (t) {
              if ((t = null == t ? 60 : t) > 60) throw new Error("maxPitch must be less than or equal to 60");
              if (t >= this.transform.minPitch) return this.transform.maxPitch = t, this._update(), this.getPitch() > t && this.setPitch(t), this;
              throw new Error("maxPitch must be greater than the current minPitch");
            }, i.prototype.getMaxPitch = function () {
              return this.transform.maxPitch;
            }, i.prototype.getRenderWorldCopies = function () {
              return this.transform.renderWorldCopies;
            }, i.prototype.setRenderWorldCopies = function (t) {
              return this.transform.renderWorldCopies = t, this._update();
            }, i.prototype.project = function (e) {
              return this.transform.locationPoint(t.LngLat.convert(e));
            }, i.prototype.unproject = function (e) {
              return this.transform.pointLocation(t.Point.convert(e));
            }, i.prototype.isMoving = function () {
              return this._moving || this.handlers.isMoving();
            }, i.prototype.isZooming = function () {
              return this._zooming || this.handlers.isZooming();
            }, i.prototype.isRotating = function () {
              return this._rotating || this.handlers.isRotating();
            }, i.prototype._createDelegatedListener = function (t, e, r) {
              var n,
                  i = this;

              if ("mouseenter" === t || "mouseover" === t) {
                var a = !1;
                return {
                  layer: e,
                  listener: r,
                  delegates: {
                    mousemove: function mousemove(n) {
                      var o = i.getLayer(e) ? i.queryRenderedFeatures(n.point, {
                        layers: [e]
                      }) : [];
                      o.length ? a || (a = !0, r.call(i, new Rn(t, i, n.originalEvent, {
                        features: o
                      }))) : a = !1;
                    },
                    mouseout: function mouseout() {
                      a = !1;
                    }
                  }
                };
              }

              if ("mouseleave" === t || "mouseout" === t) {
                var o = !1;
                return {
                  layer: e,
                  listener: r,
                  delegates: {
                    mousemove: function mousemove(n) {
                      (i.getLayer(e) ? i.queryRenderedFeatures(n.point, {
                        layers: [e]
                      }) : []).length ? o = !0 : o && (o = !1, r.call(i, new Rn(t, i, n.originalEvent)));
                    },
                    mouseout: function mouseout(e) {
                      o && (o = !1, r.call(i, new Rn(t, i, e.originalEvent)));
                    }
                  }
                };
              }

              return {
                layer: e,
                listener: r,
                delegates: (n = {}, n[t] = function (t) {
                  var n = i.getLayer(e) ? i.queryRenderedFeatures(t.point, {
                    layers: [e]
                  }) : [];
                  n.length && (t.features = n, r.call(i, t), delete t.features);
                }, n)
              };
            }, i.prototype.on = function (t, e, r) {
              if (void 0 === r) return n.prototype.on.call(this, t, e);

              var i = this._createDelegatedListener(t, e, r);

              for (var a in this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[t] = this._delegatedListeners[t] || [], this._delegatedListeners[t].push(i), i.delegates) {
                this.on(a, i.delegates[a]);
              }

              return this;
            }, i.prototype.once = function (t, e, r) {
              if (void 0 === r) return n.prototype.once.call(this, t, e);

              var i = this._createDelegatedListener(t, e, r);

              for (var a in i.delegates) {
                this.once(a, i.delegates[a]);
              }

              return this;
            }, i.prototype.off = function (t, e, r) {
              var i = this;
              if (void 0 === r) return n.prototype.off.call(this, t, e);
              return this._delegatedListeners && this._delegatedListeners[t] && function (n) {
                for (var a = n[t], o = 0; o < a.length; o++) {
                  var s = a[o];

                  if (s.layer === e && s.listener === r) {
                    for (var l in s.delegates) {
                      i.off(l, s.delegates[l]);
                    }

                    return a.splice(o, 1), i;
                  }
                }
              }(this._delegatedListeners), this;
            }, i.prototype.queryRenderedFeatures = function (e, r) {
              if (!this.style) return [];
              var n;
              if (void 0 !== r || void 0 === e || e instanceof t.Point || Array.isArray(e) || (r = e, e = void 0), r = r || {}, (e = e || [[0, 0], [this.transform.width, this.transform.height]]) instanceof t.Point || "number" == typeof e[0]) n = [t.Point.convert(e)];else {
                var i = t.Point.convert(e[0]),
                    a = t.Point.convert(e[1]);
                n = [i, new t.Point(a.x, i.y), a, new t.Point(i.x, a.y), i];
              }
              return this.style.queryRenderedFeatures(n, r, this.transform);
            }, i.prototype.querySourceFeatures = function (t, e) {
              return this.style.querySourceFeatures(t, e);
            }, i.prototype.setStyle = function (e, r) {
              return !1 !== (r = t.extend({}, {
                localIdeographFontFamily: this._localIdeographFontFamily
              }, r)).diff && r.localIdeographFontFamily === this._localIdeographFontFamily && this.style && e ? (this._diffStyle(e, r), this) : (this._localIdeographFontFamily = r.localIdeographFontFamily, this._updateStyle(e, r));
            }, i.prototype._getUIString = function (t) {
              var e = this._locale[t];
              if (null == e) throw new Error("Missing UI string '" + t + "'");
              return e;
            }, i.prototype._updateStyle = function (t, e) {
              return this.style && (this.style.setEventedParent(null), this.style._remove()), t ? (this.style = new He(this, e || {}), this.style.setEventedParent(this, {
                style: this.style
              }), "string" == typeof t ? this.style.loadURL(t) : this.style.loadJSON(t), this) : (delete this.style, this);
            }, i.prototype._lazyInitEmptyStyle = function () {
              this.style || (this.style = new He(this, {}), this.style.setEventedParent(this, {
                style: this.style
              }), this.style.loadEmpty());
            }, i.prototype._diffStyle = function (e, r) {
              var n = this;

              if ("string" == typeof e) {
                var i = this._requestManager.normalizeStyleURL(e),
                    a = this._requestManager.transformRequest(i, t.ResourceType.Style);

                t.getJSON(a, function (e, i) {
                  e ? n.fire(new t.ErrorEvent(e)) : i && n._updateDiff(i, r);
                });
              } else "object" == _typeof(e) && this._updateDiff(e, r);
            }, i.prototype._updateDiff = function (e, r) {
              try {
                this.style.setState(e) && this._update(!0);
              } catch (n) {
                t.warnOnce("Unable to perform style diff: " + (n.message || n.error || n) + ".  Rebuilding the style from scratch."), this._updateStyle(e, r);
              }
            }, i.prototype.getStyle = function () {
              if (this.style) return this.style.serialize();
            }, i.prototype.isStyleLoaded = function () {
              return this.style ? this.style.loaded() : t.warnOnce("There is no style added to the map.");
            }, i.prototype.addSource = function (t, e) {
              return this._lazyInitEmptyStyle(), this.style.addSource(t, e), this._update(!0);
            }, i.prototype.isSourceLoaded = function (e) {
              var r = this.style && this.style.sourceCaches[e];
              if (void 0 !== r) return r.loaded();
              this.fire(new t.ErrorEvent(new Error("There is no source with ID '" + e + "'")));
            }, i.prototype.areTilesLoaded = function () {
              var t = this.style && this.style.sourceCaches;

              for (var e in t) {
                var r = t[e]._tiles;

                for (var n in r) {
                  var i = r[n];
                  if ("loaded" !== i.state && "errored" !== i.state) return !1;
                }
              }

              return !0;
            }, i.prototype.addSourceType = function (t, e, r) {
              return this._lazyInitEmptyStyle(), this.style.addSourceType(t, e, r);
            }, i.prototype.removeSource = function (t) {
              return this.style.removeSource(t), this._update(!0);
            }, i.prototype.getSource = function (t) {
              return this.style.getSource(t);
            }, i.prototype.addImage = function (e, r, n) {
              void 0 === n && (n = {});
              var i = n.pixelRatio;
              void 0 === i && (i = 1);
              var a = n.sdf;
              void 0 === a && (a = !1);
              var o = n.stretchX,
                  s = n.stretchY,
                  l = n.content;

              this._lazyInitEmptyStyle();

              if (r instanceof ki || Ai && r instanceof Ai) {
                var c = t.browser.getImageData(r),
                    u = c.width,
                    f = c.height,
                    h = c.data;
                this.style.addImage(e, {
                  data: new t.RGBAImage({
                    width: u,
                    height: f
                  }, h),
                  pixelRatio: i,
                  stretchX: o,
                  stretchY: s,
                  content: l,
                  sdf: a,
                  version: 0
                });
              } else {
                if (void 0 === r.width || void 0 === r.height) return this.fire(new t.ErrorEvent(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                var p = r.width,
                    d = r.height,
                    m = r.data,
                    g = r;
                this.style.addImage(e, {
                  data: new t.RGBAImage({
                    width: p,
                    height: d
                  }, new Uint8Array(m)),
                  pixelRatio: i,
                  stretchX: o,
                  stretchY: s,
                  content: l,
                  sdf: a,
                  version: 0,
                  userImage: g
                }), g.onAdd && g.onAdd(this, e);
              }
            }, i.prototype.updateImage = function (e, r) {
              var n = this.style.getImage(e);
              if (!n) return this.fire(new t.ErrorEvent(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
              var i = r instanceof ki || Ai && r instanceof Ai ? t.browser.getImageData(r) : r,
                  a = i.width,
                  o = i.height,
                  s = i.data;
              if (void 0 === a || void 0 === o) return this.fire(new t.ErrorEvent(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
              if (a !== n.data.width || o !== n.data.height) return this.fire(new t.ErrorEvent(new Error("The width and height of the updated image must be that same as the previous version of the image")));
              var l = !(r instanceof ki || Ai && r instanceof Ai);
              n.data.replace(s, l), this.style.updateImage(e, n);
            }, i.prototype.hasImage = function (e) {
              return e ? !!this.style.getImage(e) : (this.fire(new t.ErrorEvent(new Error("Missing required image id"))), !1);
            }, i.prototype.removeImage = function (t) {
              this.style.removeImage(t);
            }, i.prototype.loadImage = function (e, r) {
              t.getImage(this._requestManager.transformRequest(e, t.ResourceType.Image), r);
            }, i.prototype.listImages = function () {
              return this.style.listImages();
            }, i.prototype.addLayer = function (t, e) {
              return this._lazyInitEmptyStyle(), this.style.addLayer(t, e), this._update(!0);
            }, i.prototype.moveLayer = function (t, e) {
              return this.style.moveLayer(t, e), this._update(!0);
            }, i.prototype.removeLayer = function (t) {
              return this.style.removeLayer(t), this._update(!0);
            }, i.prototype.getLayer = function (t) {
              return this.style.getLayer(t);
            }, i.prototype.setLayerZoomRange = function (t, e, r) {
              return this.style.setLayerZoomRange(t, e, r), this._update(!0);
            }, i.prototype.setFilter = function (t, e, r) {
              return void 0 === r && (r = {}), this.style.setFilter(t, e, r), this._update(!0);
            }, i.prototype.getFilter = function (t) {
              return this.style.getFilter(t);
            }, i.prototype.setPaintProperty = function (t, e, r, n) {
              return void 0 === n && (n = {}), this.style.setPaintProperty(t, e, r, n), this._update(!0);
            }, i.prototype.getPaintProperty = function (t, e) {
              return this.style.getPaintProperty(t, e);
            }, i.prototype.setLayoutProperty = function (t, e, r, n) {
              return void 0 === n && (n = {}), this.style.setLayoutProperty(t, e, r, n), this._update(!0);
            }, i.prototype.getLayoutProperty = function (t, e) {
              return this.style.getLayoutProperty(t, e);
            }, i.prototype.setLight = function (t, e) {
              return void 0 === e && (e = {}), this._lazyInitEmptyStyle(), this.style.setLight(t, e), this._update(!0);
            }, i.prototype.getLight = function () {
              return this.style.getLight();
            }, i.prototype.setFeatureState = function (t, e) {
              return this.style.setFeatureState(t, e), this._update();
            }, i.prototype.removeFeatureState = function (t, e) {
              return this.style.removeFeatureState(t, e), this._update();
            }, i.prototype.getFeatureState = function (t) {
              return this.style.getFeatureState(t);
            }, i.prototype.getContainer = function () {
              return this._container;
            }, i.prototype.getCanvasContainer = function () {
              return this._canvasContainer;
            }, i.prototype.getCanvas = function () {
              return this._canvas;
            }, i.prototype._containerDimensions = function () {
              var t = 0,
                  e = 0;
              return this._container && (t = this._container.clientWidth || 400, e = this._container.clientHeight || 300), [t, e];
            }, i.prototype._detectMissingCSS = function () {
              "rgb(250, 128, 114)" !== t.window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") && t.warnOnce("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
            }, i.prototype._setupContainer = function () {
              var t = this._container;
              t.classList.add("mapboxgl-map"), (this._missingCSSCanary = r.create("div", "mapboxgl-canary", t)).style.visibility = "hidden", this._detectMissingCSS();
              var e = this._canvasContainer = r.create("div", "mapboxgl-canvas-container", t);
              this._interactive && e.classList.add("mapboxgl-interactive"), this._canvas = r.create("canvas", "mapboxgl-canvas", e), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", "0"), this._canvas.setAttribute("aria-label", "Map");

              var n = this._containerDimensions();

              this._resizeCanvas(n[0], n[1]);

              var i = this._controlContainer = r.create("div", "mapboxgl-control-container", t),
                  a = this._controlPositions = {};
              ["top-left", "top-right", "bottom-left", "bottom-right"].forEach(function (t) {
                a[t] = r.create("div", "mapboxgl-ctrl-" + t, i);
              });
            }, i.prototype._resizeCanvas = function (e, r) {
              var n = t.browser.devicePixelRatio || 1;
              this._canvas.width = n * e, this._canvas.height = n * r, this._canvas.style.width = e + "px", this._canvas.style.height = r + "px";
            }, i.prototype._setupPainter = function () {
              var r = t.extend({}, e.webGLContextAttributes, {
                failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                preserveDrawingBuffer: this._preserveDrawingBuffer,
                antialias: this._antialias || !1
              }),
                  n = this._canvas.getContext("webgl", r) || this._canvas.getContext("experimental-webgl", r);

              n ? (this.painter = new _n(n, this.transform), t.webpSupported.testSupport(n)) : this.fire(new t.ErrorEvent(new Error("Failed to initialize WebGL")));
            }, i.prototype._contextLost = function (e) {
              e.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new t.Event("webglcontextlost", {
                originalEvent: e
              }));
            }, i.prototype._contextRestored = function (e) {
              this._setupPainter(), this.resize(), this._update(), this.fire(new t.Event("webglcontextrestored", {
                originalEvent: e
              }));
            }, i.prototype.loaded = function () {
              return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
            }, i.prototype._update = function (t) {
              return this.style ? (this._styleDirty = this._styleDirty || t, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
            }, i.prototype._requestRenderFrame = function (t) {
              return this._update(), this._renderTaskQueue.add(t);
            }, i.prototype._cancelRenderFrame = function (t) {
              this._renderTaskQueue.remove(t);
            }, i.prototype._render = function (e) {
              var r,
                  n = this,
                  i = 0,
                  a = this.painter.context.extTimerQuery;

              if (this.listens("gpu-timing-frame") && (r = a.createQueryEXT(), a.beginQueryEXT(a.TIME_ELAPSED_EXT, r), i = t.browser.now()), this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(e), !this._removed) {
                var o = !1;

                if (this.style && this._styleDirty) {
                  this._styleDirty = !1;
                  var s = this.transform.zoom,
                      l = t.browser.now();
                  this.style.zoomHistory.update(s, l);
                  var c = new t.EvaluationParameters(s, {
                    now: l,
                    fadeDuration: this._fadeDuration,
                    zoomHistory: this.style.zoomHistory,
                    transition: this.style.getTransition()
                  }),
                      u = c.crossFadingFactor();
                  1 === u && u === this._crossFadingFactor || (o = !0, this._crossFadingFactor = u), this.style.update(c);
                }

                if (this.style && this._sourcesDirty && (this._sourcesDirty = !1, this.style._updateSources(this.transform)), this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, this._fadeDuration, this._crossSourceCollisions), this.painter.render(this.style, {
                  showTileBoundaries: this.showTileBoundaries,
                  showOverdrawInspector: this._showOverdrawInspector,
                  rotating: this.isRotating(),
                  zooming: this.isZooming(),
                  moving: this.isMoving(),
                  fadeDuration: this._fadeDuration,
                  showPadding: this.showPadding,
                  gpuTiming: !!this.listens("gpu-timing-layer")
                }), this.fire(new t.Event("render")), this.loaded() && !this._loaded && (this._loaded = !0, this.fire(new t.Event("load"))), this.style && (this.style.hasTransitions() || o) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), this.listens("gpu-timing-frame")) {
                  var f = t.browser.now() - i;
                  a.endQueryEXT(a.TIME_ELAPSED_EXT, r), setTimeout(function () {
                    var e = a.getQueryObjectEXT(r, a.QUERY_RESULT_EXT) / 1e6;
                    a.deleteQueryEXT(r), n.fire(new t.Event("gpu-timing-frame", {
                      cpuTime: f,
                      gpuTime: e
                    }));
                  }, 50);
                }

                if (this.listens("gpu-timing-layer")) {
                  var h = this.painter.collectGpuTimers();
                  setTimeout(function () {
                    var e = n.painter.queryGpuTimers(h);
                    n.fire(new t.Event("gpu-timing-layer", {
                      layerTimes: e
                    }));
                  }, 50);
                }

                return this._sourcesDirty || this._styleDirty || this._placementDirty || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && (this._fullyLoaded || (this._fullyLoaded = !0), this.fire(new t.Event("idle"))), this;
              }
            }, i.prototype.remove = function () {
              this._hash && this._hash.remove();

              for (var e = 0, r = this._controls; e < r.length; e += 1) {
                r[e].onRemove(this);
              }

              this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this.painter.destroy(), this.handlers.destroy(), delete this.handlers, this.setStyle(null), void 0 !== t.window && (t.window.removeEventListener("resize", this._onWindowResize, !1), t.window.removeEventListener("online", this._onWindowOnline, !1));
              var n = this.painter.context.gl.getExtension("WEBGL_lose_context");
              n && n.loseContext(), Li(this._canvasContainer), Li(this._controlContainer), Li(this._missingCSSCanary), this._container.classList.remove("mapboxgl-map"), this._removed = !0, this.fire(new t.Event("remove"));
            }, i.prototype.triggerRepaint = function () {
              var e = this;
              this.style && !this._frame && (this._frame = t.browser.frame(function (t) {
                e._frame = null, e._render(t);
              }));
            }, i.prototype._onWindowOnline = function () {
              this._update();
            }, i.prototype._onWindowResize = function (t) {
              this._trackResize && this.resize({
                originalEvent: t
              })._update();
            }, a.showTileBoundaries.get = function () {
              return !!this._showTileBoundaries;
            }, a.showTileBoundaries.set = function (t) {
              this._showTileBoundaries !== t && (this._showTileBoundaries = t, this._update());
            }, a.showPadding.get = function () {
              return !!this._showPadding;
            }, a.showPadding.set = function (t) {
              this._showPadding !== t && (this._showPadding = t, this._update());
            }, a.showCollisionBoxes.get = function () {
              return !!this._showCollisionBoxes;
            }, a.showCollisionBoxes.set = function (t) {
              this._showCollisionBoxes !== t && (this._showCollisionBoxes = t, t ? this.style._generateCollisionBoxes() : this._update());
            }, a.showOverdrawInspector.get = function () {
              return !!this._showOverdrawInspector;
            }, a.showOverdrawInspector.set = function (t) {
              this._showOverdrawInspector !== t && (this._showOverdrawInspector = t, this._update());
            }, a.repaint.get = function () {
              return !!this._repaint;
            }, a.repaint.set = function (t) {
              this._repaint !== t && (this._repaint = t, this.triggerRepaint());
            }, a.vertices.get = function () {
              return !!this._vertices;
            }, a.vertices.set = function (t) {
              this._vertices = t, this._update();
            }, i.prototype._setCacheLimits = function (e, r) {
              t.setCacheLimits(e, r);
            }, a.version.get = function () {
              return t.version;
            }, Object.defineProperties(i.prototype, a), i;
          }(xi);

          function Li(t) {
            t.parentNode && t.parentNode.removeChild(t);
          }

          var Ci = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1
          },
              Pi = function Pi(e) {
            var n = this;
            this.options = t.extend({}, Ci, e), this._container = r.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", function (t) {
              return t.preventDefault();
            }), this.options.showZoom && (t.bindAll(["_setButtonTitle", "_updateZoomButtons"], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", function (t) {
              return n._map.zoomIn({}, {
                originalEvent: t
              });
            }), r.create("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", !0), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", function (t) {
              return n._map.zoomOut({}, {
                originalEvent: t
              });
            }), r.create("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", !0)), this.options.showCompass && (t.bindAll(["_rotateCompassArrow"], this), this._compass = this._createButton("mapboxgl-ctrl-compass", function (t) {
              n.options.visualizePitch ? n._map.resetNorthPitch({}, {
                originalEvent: t
              }) : n._map.resetNorth({}, {
                originalEvent: t
              });
            }), this._compassIcon = r.create("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", !0));
          };

          Pi.prototype._updateZoomButtons = function () {
            var t = this._map.getZoom();

            this._zoomInButton.disabled = t === this._map.getMaxZoom(), this._zoomOutButton.disabled = t === this._map.getMinZoom();
          }, Pi.prototype._rotateCompassArrow = function () {
            var t = this.options.visualizePitch ? "scale(" + 1 / Math.pow(Math.cos(this._map.transform.pitch * (Math.PI / 180)), .5) + ") rotateX(" + this._map.transform.pitch + "deg) rotateZ(" + this._map.transform.angle * (180 / Math.PI) + "deg)" : "rotate(" + this._map.transform.angle * (180 / Math.PI) + "deg)";
            this._compassIcon.style.transform = t;
          }, Pi.prototype.onAdd = function (t) {
            return this._map = t, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new Ii(this._map, this._compass, this.options.visualizePitch)), this._container;
          }, Pi.prototype.onRemove = function () {
            r.remove(this._container), this.options.showZoom && this._map.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
          }, Pi.prototype._createButton = function (t, e) {
            var n = r.create("button", t, this._container);
            return n.type = "button", n.addEventListener("click", e), n;
          }, Pi.prototype._setButtonTitle = function (t, e) {
            var r = this._map._getUIString("NavigationControl." + e);

            t.title = r, t.setAttribute("aria-label", r);
          };

          var Ii = function Ii(e, n, i) {
            void 0 === i && (i = !1), this._clickTolerance = 10, this.element = n, this.mouseRotate = new Xn({
              clickTolerance: e.dragRotate._mouseRotate._clickTolerance
            }), this.map = e, i && (this.mousePitch = new Zn({
              clickTolerance: e.dragRotate._mousePitch._clickTolerance
            })), t.bindAll(["mousedown", "mousemove", "mouseup", "touchstart", "touchmove", "touchend", "reset"], this), r.addEventListener(n, "mousedown", this.mousedown), r.addEventListener(n, "touchstart", this.touchstart, {
              passive: !1
            }), r.addEventListener(n, "touchmove", this.touchmove), r.addEventListener(n, "touchend", this.touchend), r.addEventListener(n, "touchcancel", this.reset);
          };

          function Oi(e, r, n) {
            if (e = new t.LngLat(e.lng, e.lat), r) {
              var i = new t.LngLat(e.lng - 360, e.lat),
                  a = new t.LngLat(e.lng + 360, e.lat),
                  o = n.locationPoint(e).distSqr(r);
              n.locationPoint(i).distSqr(r) < o ? e = i : n.locationPoint(a).distSqr(r) < o && (e = a);
            }

            for (; Math.abs(e.lng - n.center.lng) > 180;) {
              var s = n.locationPoint(e);
              if (s.x >= 0 && s.y >= 0 && s.x <= n.width && s.y <= n.height) break;
              e.lng > n.center.lng ? e.lng -= 360 : e.lng += 360;
            }

            return e;
          }

          Ii.prototype.down = function (t, e) {
            this.mouseRotate.mousedown(t, e), this.mousePitch && this.mousePitch.mousedown(t, e), r.disableDrag();
          }, Ii.prototype.move = function (t, e) {
            var r = this.map,
                n = this.mouseRotate.mousemoveWindow(t, e);

            if (n && n.bearingDelta && r.setBearing(r.getBearing() + n.bearingDelta), this.mousePitch) {
              var i = this.mousePitch.mousemoveWindow(t, e);
              i && i.pitchDelta && r.setPitch(r.getPitch() + i.pitchDelta);
            }
          }, Ii.prototype.off = function () {
            var t = this.element;
            r.removeEventListener(t, "mousedown", this.mousedown), r.removeEventListener(t, "touchstart", this.touchstart, {
              passive: !1
            }), r.removeEventListener(t, "touchmove", this.touchmove), r.removeEventListener(t, "touchend", this.touchend), r.removeEventListener(t, "touchcancel", this.reset), this.offTemp();
          }, Ii.prototype.offTemp = function () {
            r.enableDrag(), r.removeEventListener(t.window, "mousemove", this.mousemove), r.removeEventListener(t.window, "mouseup", this.mouseup);
          }, Ii.prototype.mousedown = function (e) {
            this.down(t.extend({}, e, {
              ctrlKey: !0,
              preventDefault: function preventDefault() {
                return e.preventDefault();
              }
            }), r.mousePos(this.element, e)), r.addEventListener(t.window, "mousemove", this.mousemove), r.addEventListener(t.window, "mouseup", this.mouseup);
          }, Ii.prototype.mousemove = function (t) {
            this.move(t, r.mousePos(this.element, t));
          }, Ii.prototype.mouseup = function (t) {
            this.mouseRotate.mouseupWindow(t), this.mousePitch && this.mousePitch.mouseupWindow(t), this.offTemp();
          }, Ii.prototype.touchstart = function (t) {
            1 !== t.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = r.touchPos(this.element, t.targetTouches)[0], this.down({
              type: "mousedown",
              button: 0,
              ctrlKey: !0,
              preventDefault: function preventDefault() {
                return t.preventDefault();
              }
            }, this._startPos));
          }, Ii.prototype.touchmove = function (t) {
            1 !== t.targetTouches.length ? this.reset() : (this._lastPos = r.touchPos(this.element, t.targetTouches)[0], this.move({
              preventDefault: function preventDefault() {
                return t.preventDefault();
              }
            }, this._lastPos));
          }, Ii.prototype.touchend = function (t) {
            0 === t.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
          }, Ii.prototype.reset = function () {
            this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
          };
          var zi = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
          };

          function Di(t, e, r) {
            var n = t.classList;

            for (var i in zi) {
              n.remove("mapboxgl-" + r + "-anchor-" + i);
            }

            n.add("mapboxgl-" + r + "-anchor-" + e);
          }

          var Ri,
              Fi = function (e) {
            function n(n, i) {
              var a = this;
              if (e.call(this), (n instanceof t.window.HTMLElement || i) && (n = t.extend({
                element: n
              }, i)), t.bindAll(["_update", "_onMove", "_onUp", "_addDragHandler", "_onMapClick", "_onKeyPress"], this), this._anchor = n && n.anchor || "center", this._color = n && n.color || "#3FB1CE", this._draggable = n && n.draggable || !1, this._state = "inactive", this._rotation = n && n.rotation || 0, this._rotationAlignment = n && n.rotationAlignment || "auto", this._pitchAlignment = n && n.pitchAlignment && "auto" !== n.pitchAlignment ? n.pitchAlignment : this._rotationAlignment, n && n.element) this._element = n.element, this._offset = t.Point.convert(n && n.offset || [0, 0]);else {
                this._defaultMarker = !0, this._element = r.create("div"), this._element.setAttribute("aria-label", "Map marker");
                var o = r.createNS("http://www.w3.org/2000/svg", "svg");
                o.setAttributeNS(null, "display", "block"), o.setAttributeNS(null, "height", "41px"), o.setAttributeNS(null, "width", "27px"), o.setAttributeNS(null, "viewBox", "0 0 27 41");
                var s = r.createNS("http://www.w3.org/2000/svg", "g");
                s.setAttributeNS(null, "stroke", "none"), s.setAttributeNS(null, "stroke-width", "1"), s.setAttributeNS(null, "fill", "none"), s.setAttributeNS(null, "fill-rule", "evenodd");
                var l = r.createNS("http://www.w3.org/2000/svg", "g");
                l.setAttributeNS(null, "fill-rule", "nonzero");
                var c = r.createNS("http://www.w3.org/2000/svg", "g");
                c.setAttributeNS(null, "transform", "translate(3.0, 29.0)"), c.setAttributeNS(null, "fill", "#000000");

                for (var u = 0, f = [{
                  rx: "10.5",
                  ry: "5.25002273"
                }, {
                  rx: "10.5",
                  ry: "5.25002273"
                }, {
                  rx: "9.5",
                  ry: "4.77275007"
                }, {
                  rx: "8.5",
                  ry: "4.29549936"
                }, {
                  rx: "7.5",
                  ry: "3.81822308"
                }, {
                  rx: "6.5",
                  ry: "3.34094679"
                }, {
                  rx: "5.5",
                  ry: "2.86367051"
                }, {
                  rx: "4.5",
                  ry: "2.38636864"
                }]; u < f.length; u += 1) {
                  var h = f[u],
                      p = r.createNS("http://www.w3.org/2000/svg", "ellipse");
                  p.setAttributeNS(null, "opacity", "0.04"), p.setAttributeNS(null, "cx", "10.5"), p.setAttributeNS(null, "cy", "5.80029008"), p.setAttributeNS(null, "rx", h.rx), p.setAttributeNS(null, "ry", h.ry), c.appendChild(p);
                }

                var d = r.createNS("http://www.w3.org/2000/svg", "g");
                d.setAttributeNS(null, "fill", this._color);
                var m = r.createNS("http://www.w3.org/2000/svg", "path");
                m.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"), d.appendChild(m);
                var g = r.createNS("http://www.w3.org/2000/svg", "g");
                g.setAttributeNS(null, "opacity", "0.25"), g.setAttributeNS(null, "fill", "#000000");
                var v = r.createNS("http://www.w3.org/2000/svg", "path");
                v.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"), g.appendChild(v);
                var y = r.createNS("http://www.w3.org/2000/svg", "g");
                y.setAttributeNS(null, "transform", "translate(6.0, 7.0)"), y.setAttributeNS(null, "fill", "#FFFFFF");
                var x = r.createNS("http://www.w3.org/2000/svg", "g");
                x.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
                var b = r.createNS("http://www.w3.org/2000/svg", "circle");
                b.setAttributeNS(null, "fill", "#000000"), b.setAttributeNS(null, "opacity", "0.25"), b.setAttributeNS(null, "cx", "5.5"), b.setAttributeNS(null, "cy", "5.5"), b.setAttributeNS(null, "r", "5.4999962");

                var _ = r.createNS("http://www.w3.org/2000/svg", "circle");

                _.setAttributeNS(null, "fill", "#FFFFFF"), _.setAttributeNS(null, "cx", "5.5"), _.setAttributeNS(null, "cy", "5.5"), _.setAttributeNS(null, "r", "5.4999962"), x.appendChild(b), x.appendChild(_), l.appendChild(c), l.appendChild(d), l.appendChild(g), l.appendChild(y), l.appendChild(x), o.appendChild(l), this._element.appendChild(o), this._offset = t.Point.convert(n && n.offset || [0, -14]);
              }
              this._element.classList.add("mapboxgl-marker"), this._element.addEventListener("dragstart", function (t) {
                t.preventDefault();
              }), this._element.addEventListener("mousedown", function (t) {
                t.preventDefault();
              }), this._element.addEventListener("focus", function () {
                var t = a._map.getContainer();

                t.scrollTop = 0, t.scrollLeft = 0;
              }), Di(this._element, this._anchor, "marker"), this._popup = null;
            }

            return e && (n.__proto__ = e), n.prototype = Object.create(e && e.prototype), n.prototype.constructor = n, n.prototype.addTo = function (t) {
              return this.remove(), this._map = t, t.getCanvasContainer().appendChild(this._element), t.on("move", this._update), t.on("moveend", this._update), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick), this;
            }, n.prototype.remove = function () {
              return this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._update), this._map.off("moveend", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), delete this._map), r.remove(this._element), this._popup && this._popup.remove(), this;
            }, n.prototype.getLngLat = function () {
              return this._lngLat;
            }, n.prototype.setLngLat = function (e) {
              return this._lngLat = t.LngLat.convert(e), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(), this;
            }, n.prototype.getElement = function () {
              return this._element;
            }, n.prototype.setPopup = function (t) {
              if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), t) {
                if (!("offset" in t.options)) {
                  var e = Math.sqrt(Math.pow(13.5, 2) / 2);
                  t.options.offset = this._defaultMarker ? {
                    top: [0, 0],
                    "top-left": [0, 0],
                    "top-right": [0, 0],
                    bottom: [0, -38.1],
                    "bottom-left": [e, -1 * (24.6 + e)],
                    "bottom-right": [-e, -1 * (24.6 + e)],
                    left: [13.5, -24.6],
                    right: [-13.5, -24.6]
                  } : this._offset;
                }

                this._popup = t, this._lngLat && this._popup.setLngLat(this._lngLat), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress);
              }

              return this;
            }, n.prototype._onKeyPress = function (t) {
              var e = t.code,
                  r = t.charCode || t.keyCode;
              "Space" !== e && "Enter" !== e && 32 !== r && 13 !== r || this.togglePopup();
            }, n.prototype._onMapClick = function (t) {
              var e = t.originalEvent.target,
                  r = this._element;
              this._popup && (e === r || r.contains(e)) && this.togglePopup();
            }, n.prototype.getPopup = function () {
              return this._popup;
            }, n.prototype.togglePopup = function () {
              var t = this._popup;
              return t ? (t.isOpen() ? t.remove() : t.addTo(this._map), this) : this;
            }, n.prototype._update = function (t) {
              if (this._map) {
                this._map.transform.renderWorldCopies && (this._lngLat = Oi(this._lngLat, this._pos, this._map.transform)), this._pos = this._map.project(this._lngLat)._add(this._offset);
                var e = "";
                "viewport" === this._rotationAlignment || "auto" === this._rotationAlignment ? e = "rotateZ(" + this._rotation + "deg)" : "map" === this._rotationAlignment && (e = "rotateZ(" + (this._rotation - this._map.getBearing()) + "deg)");
                var n = "";
                "viewport" === this._pitchAlignment || "auto" === this._pitchAlignment ? n = "rotateX(0deg)" : "map" === this._pitchAlignment && (n = "rotateX(" + this._map.getPitch() + "deg)"), t && "moveend" !== t.type || (this._pos = this._pos.round()), r.setTransform(this._element, zi[this._anchor] + " translate(" + this._pos.x + "px, " + this._pos.y + "px) " + n + " " + e);
              }
            }, n.prototype.getOffset = function () {
              return this._offset;
            }, n.prototype.setOffset = function (e) {
              return this._offset = t.Point.convert(e), this._update(), this;
            }, n.prototype._onMove = function (e) {
              this._pos = e.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new t.Event("dragstart"))), this.fire(new t.Event("drag"));
            }, n.prototype._onUp = function () {
              this._element.style.pointerEvents = "auto", this._positionDelta = null, this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), "active" === this._state && this.fire(new t.Event("dragend")), this._state = "inactive";
            }, n.prototype._addDragHandler = function (t) {
              this._element.contains(t.originalEvent.target) && (t.preventDefault(), this._positionDelta = t.point.sub(this._pos).add(this._offset), this._state = "pending", this._map.on("mousemove", this._onMove), this._map.on("touchmove", this._onMove), this._map.once("mouseup", this._onUp), this._map.once("touchend", this._onUp));
            }, n.prototype.setDraggable = function (t) {
              return this._draggable = !!t, this._map && (t ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this;
            }, n.prototype.isDraggable = function () {
              return this._draggable;
            }, n.prototype.setRotation = function (t) {
              return this._rotation = t || 0, this._update(), this;
            }, n.prototype.getRotation = function () {
              return this._rotation;
            }, n.prototype.setRotationAlignment = function (t) {
              return this._rotationAlignment = t || "auto", this._update(), this;
            }, n.prototype.getRotationAlignment = function () {
              return this._rotationAlignment;
            }, n.prototype.setPitchAlignment = function (t) {
              return this._pitchAlignment = t && "auto" !== t ? t : this._rotationAlignment, this._update(), this;
            }, n.prototype.getPitchAlignment = function () {
              return this._pitchAlignment;
            }, n;
          }(t.Evented),
              Bi = {
            positionOptions: {
              enableHighAccuracy: !1,
              maximumAge: 0,
              timeout: 6e3
            },
            fitBoundsOptions: {
              maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0
          };

          var Ni = 0,
              ji = !1,
              Ui = function (e) {
            function n(r) {
              e.call(this), this.options = t.extend({}, Bi, r), t.bindAll(["_onSuccess", "_onError", "_onZoom", "_finish", "_setupUI", "_updateCamera", "_updateMarker"], this);
            }

            return e && (n.__proto__ = e), n.prototype = Object.create(e && e.prototype), n.prototype.constructor = n, n.prototype.onAdd = function (e) {
              var n;
              return this._map = e, this._container = r.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), n = this._setupUI, void 0 !== Ri ? n(Ri) : void 0 !== t.window.navigator.permissions ? t.window.navigator.permissions.query({
                name: "geolocation"
              }).then(function (t) {
                Ri = "denied" !== t.state, n(Ri);
              }) : (Ri = !!t.window.navigator.geolocation, n(Ri)), this._container;
            }, n.prototype.onRemove = function () {
              void 0 !== this._geolocationWatchID && (t.window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), r.remove(this._container), this._map.off("zoom", this._onZoom), this._map = void 0, Ni = 0, ji = !1;
            }, n.prototype._isOutOfMapMaxBounds = function (t) {
              var e = this._map.getMaxBounds(),
                  r = t.coords;

              return e && (r.longitude < e.getWest() || r.longitude > e.getEast() || r.latitude < e.getSouth() || r.latitude > e.getNorth());
            }, n.prototype._setErrorState = function () {
              switch (this._watchState) {
                case "WAITING_ACTIVE":
                  this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                  break;

                case "ACTIVE_LOCK":
                  this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                  break;

                case "BACKGROUND":
                  this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
              }
            }, n.prototype._onSuccess = function (e) {
              if (this._map) {
                if (this._isOutOfMapMaxBounds(e)) return this._setErrorState(), this.fire(new t.Event("outofmaxbounds", e)), this._updateMarker(), void this._finish();
                if (this.options.trackUserLocation) switch (this._lastKnownPosition = e, this._watchState) {
                  case "WAITING_ACTIVE":
                  case "ACTIVE_LOCK":
                  case "ACTIVE_ERROR":
                    this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                    break;

                  case "BACKGROUND":
                  case "BACKGROUND_ERROR":
                    this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                }
                this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(e), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(e), this.options.showUserLocation && this._dotElement.classList.remove("mapboxgl-user-location-dot-stale"), this.fire(new t.Event("geolocate", e)), this._finish();
              }
            }, n.prototype._updateCamera = function (e) {
              var r = new t.LngLat(e.coords.longitude, e.coords.latitude),
                  n = e.coords.accuracy,
                  i = this._map.getBearing(),
                  a = t.extend({
                bearing: i
              }, this.options.fitBoundsOptions);

              this._map.fitBounds(r.toBounds(n), a, {
                geolocateSource: !0
              });
            }, n.prototype._updateMarker = function (e) {
              if (e) {
                var r = new t.LngLat(e.coords.longitude, e.coords.latitude);
                this._accuracyCircleMarker.setLngLat(r).addTo(this._map), this._userLocationDotMarker.setLngLat(r).addTo(this._map), this._accuracy = e.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
              } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
            }, n.prototype._updateCircleRadius = function () {
              var t = this._map._container.clientHeight / 2,
                  e = this._map.unproject([0, t]),
                  r = this._map.unproject([1, t]),
                  n = e.distanceTo(r),
                  i = Math.ceil(2 * this._accuracy / n);

              this._circleElement.style.width = i + "px", this._circleElement.style.height = i + "px";
            }, n.prototype._onZoom = function () {
              this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
            }, n.prototype._onError = function (e) {
              if (this._map) {
                if (this.options.trackUserLocation) if (1 === e.code) {
                  this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;

                  var r = this._map._getUIString("GeolocateControl.LocationNotAvailable");

                  this._geolocateButton.title = r, this._geolocateButton.setAttribute("aria-label", r), void 0 !== this._geolocationWatchID && this._clearWatch();
                } else {
                  if (3 === e.code && ji) return;

                  this._setErrorState();
                }
                "OFF" !== this._watchState && this.options.showUserLocation && this._dotElement.classList.add("mapboxgl-user-location-dot-stale"), this.fire(new t.Event("error", e)), this._finish();
              }
            }, n.prototype._finish = function () {
              this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
            }, n.prototype._setupUI = function (e) {
              var n = this;

              if (this._container.addEventListener("contextmenu", function (t) {
                return t.preventDefault();
              }), this._geolocateButton = r.create("button", "mapboxgl-ctrl-geolocate", this._container), r.create("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", !0), this._geolocateButton.type = "button", !1 === e) {
                t.warnOnce("Geolocation support is not available so the GeolocateControl will be disabled.");

                var i = this._map._getUIString("GeolocateControl.LocationNotAvailable");

                this._geolocateButton.disabled = !0, this._geolocateButton.title = i, this._geolocateButton.setAttribute("aria-label", i);
              } else {
                var a = this._map._getUIString("GeolocateControl.FindMyLocation");

                this._geolocateButton.title = a, this._geolocateButton.setAttribute("aria-label", a);
              }

              this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = r.create("div", "mapboxgl-user-location-dot"), this._userLocationDotMarker = new Fi(this._dotElement), this._circleElement = r.create("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new Fi({
                element: this._circleElement,
                pitchAlignment: "map"
              }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", function (e) {
                var r = e.originalEvent && "resize" === e.originalEvent.type;
                e.geolocateSource || "ACTIVE_LOCK" !== n._watchState || r || (n._watchState = "BACKGROUND", n._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), n._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), n.fire(new t.Event("trackuserlocationend")));
              });
            }, n.prototype.trigger = function () {
              if (!this._setup) return t.warnOnce("Geolocate control triggered before added to a map"), !1;

              if (this.options.trackUserLocation) {
                switch (this._watchState) {
                  case "OFF":
                    this._watchState = "WAITING_ACTIVE", this.fire(new t.Event("trackuserlocationstart"));
                    break;

                  case "WAITING_ACTIVE":
                  case "ACTIVE_LOCK":
                  case "ACTIVE_ERROR":
                  case "BACKGROUND_ERROR":
                    Ni--, ji = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this.fire(new t.Event("trackuserlocationend"));
                    break;

                  case "BACKGROUND":
                    this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new t.Event("trackuserlocationstart"));
                }

                switch (this._watchState) {
                  case "WAITING_ACTIVE":
                    this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                    break;

                  case "ACTIVE_LOCK":
                    this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");

                    break;

                  case "ACTIVE_ERROR":
                    this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                    break;

                  case "BACKGROUND":
                    this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");

                    break;

                  case "BACKGROUND_ERROR":
                    this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
                }

                if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();else if (void 0 === this._geolocationWatchID) {
                  var e;
                  this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), ++Ni > 1 ? (e = {
                    maximumAge: 6e5,
                    timeout: 0
                  }, ji = !0) : (e = this.options.positionOptions, ji = !1), this._geolocationWatchID = t.window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, e);
                }
              } else t.window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);

              return !0;
            }, n.prototype._clearWatch = function () {
              t.window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
            }, n;
          }(t.Evented),
              Vi = {
            maxWidth: 100,
            unit: "metric"
          },
              qi = function qi(e) {
            this.options = t.extend({}, Vi, e), t.bindAll(["_onMove", "setUnit"], this);
          };

          function Hi(t, e, r) {
            var n = r && r.maxWidth || 100,
                i = t._container.clientHeight / 2,
                a = t.unproject([0, i]),
                o = t.unproject([n, i]),
                s = a.distanceTo(o);

            if (r && "imperial" === r.unit) {
              var l = 3.2808 * s;
              if (l > 5280) Gi(e, n, l / 5280, t._getUIString("ScaleControl.Miles"));else Gi(e, n, l, t._getUIString("ScaleControl.Feet"));
            } else if (r && "nautical" === r.unit) {
              Gi(e, n, s / 1852, t._getUIString("ScaleControl.NauticalMiles"));
            } else s >= 1e3 ? Gi(e, n, s / 1e3, t._getUIString("ScaleControl.Kilometers")) : Gi(e, n, s, t._getUIString("ScaleControl.Meters"));
          }

          function Gi(t, e, r, n) {
            var i,
                a,
                o,
                s = (i = r, a = Math.pow(10, ("" + Math.floor(i)).length - 1), o = (o = i / a) >= 10 ? 10 : o >= 5 ? 5 : o >= 3 ? 3 : o >= 2 ? 2 : o >= 1 ? 1 : function (t) {
              var e = Math.pow(10, Math.ceil(-Math.log(t) / Math.LN10));
              return Math.round(t * e) / e;
            }(o), a * o),
                l = s / r;
            t.style.width = e * l + "px", t.innerHTML = s + "&nbsp;" + n;
          }

          qi.prototype.getDefaultPosition = function () {
            return "bottom-left";
          }, qi.prototype._onMove = function () {
            Hi(this._map, this._container, this.options);
          }, qi.prototype.onAdd = function (t) {
            return this._map = t, this._container = r.create("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", t.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
          }, qi.prototype.onRemove = function () {
            r.remove(this._container), this._map.off("move", this._onMove), this._map = void 0;
          }, qi.prototype.setUnit = function (t) {
            this.options.unit = t, Hi(this._map, this._container, this.options);
          };

          var Yi = function Yi(e) {
            this._fullscreen = !1, e && e.container && (e.container instanceof t.window.HTMLElement ? this._container = e.container : t.warnOnce("Full screen control 'container' must be a DOM element.")), t.bindAll(["_onClickFullscreen", "_changeIcon"], this), "onfullscreenchange" in t.window.document ? this._fullscreenchange = "fullscreenchange" : "onmozfullscreenchange" in t.window.document ? this._fullscreenchange = "mozfullscreenchange" : "onwebkitfullscreenchange" in t.window.document ? this._fullscreenchange = "webkitfullscreenchange" : "onmsfullscreenchange" in t.window.document && (this._fullscreenchange = "MSFullscreenChange");
          };

          Yi.prototype.onAdd = function (e) {
            return this._map = e, this._container || (this._container = this._map.getContainer()), this._controlContainer = r.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", t.warnOnce("This device does not support fullscreen mode.")), this._controlContainer;
          }, Yi.prototype.onRemove = function () {
            r.remove(this._controlContainer), this._map = null, t.window.document.removeEventListener(this._fullscreenchange, this._changeIcon);
          }, Yi.prototype._checkFullscreenSupport = function () {
            return !!(t.window.document.fullscreenEnabled || t.window.document.mozFullScreenEnabled || t.window.document.msFullscreenEnabled || t.window.document.webkitFullscreenEnabled);
          }, Yi.prototype._setupUI = function () {
            var e = this._fullscreenButton = r.create("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
            r.create("span", "mapboxgl-ctrl-icon", e).setAttribute("aria-hidden", !0), e.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), t.window.document.addEventListener(this._fullscreenchange, this._changeIcon);
          }, Yi.prototype._updateTitle = function () {
            var t = this._getTitle();

            this._fullscreenButton.setAttribute("aria-label", t), this._fullscreenButton.title = t;
          }, Yi.prototype._getTitle = function () {
            return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
          }, Yi.prototype._isFullscreen = function () {
            return this._fullscreen;
          }, Yi.prototype._changeIcon = function () {
            (t.window.document.fullscreenElement || t.window.document.mozFullScreenElement || t.window.document.webkitFullscreenElement || t.window.document.msFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
          }, Yi.prototype._onClickFullscreen = function () {
            this._isFullscreen() ? t.window.document.exitFullscreen ? t.window.document.exitFullscreen() : t.window.document.mozCancelFullScreen ? t.window.document.mozCancelFullScreen() : t.window.document.msExitFullscreen ? t.window.document.msExitFullscreen() : t.window.document.webkitCancelFullScreen && t.window.document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.mozRequestFullScreen ? this._container.mozRequestFullScreen() : this._container.msRequestFullscreen ? this._container.msRequestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
          };

          var Wi = {
            closeButton: !0,
            closeOnClick: !0,
            className: "",
            maxWidth: "240px"
          },
              Xi = function (e) {
            function n(r) {
              e.call(this), this.options = t.extend(Object.create(Wi), r), t.bindAll(["_update", "_onClose", "remove", "_onMouseMove", "_onMouseUp", "_onDrag"], this);
            }

            return e && (n.__proto__ = e), n.prototype = Object.create(e && e.prototype), n.prototype.constructor = n, n.prototype.addTo = function (e) {
              return this._map && this.remove(), this._map = e, this.options.closeOnClick && this._map.on("click", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._update(), this._trackPointer ? (this._map.on("mousemove", this._onMouseMove), this._map.on("mouseup", this._onMouseUp), this._container && this._container.classList.add("mapboxgl-popup-track-pointer"), this._map._canvasContainer.classList.add("mapboxgl-track-pointer")) : this._map.on("move", this._update), this.fire(new t.Event("open")), this;
            }, n.prototype.isOpen = function () {
              return !!this._map;
            }, n.prototype.remove = function () {
              return this._content && r.remove(this._content), this._container && (r.remove(this._container), delete this._container), this._map && (this._map.off("move", this._update), this._map.off("move", this._onClose), this._map.off("click", this._onClose), this._map.off("remove", this.remove), this._map.off("mousemove", this._onMouseMove), this._map.off("mouseup", this._onMouseUp), this._map.off("drag", this._onDrag), delete this._map), this.fire(new t.Event("close")), this;
            }, n.prototype.getLngLat = function () {
              return this._lngLat;
            }, n.prototype.setLngLat = function (e) {
              return this._lngLat = t.LngLat.convert(e), this._pos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._onMouseMove), this._container && this._container.classList.remove("mapboxgl-popup-track-pointer"), this._map._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
            }, n.prototype.trackPointer = function () {
              return this._trackPointer = !0, this._pos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._onMouseMove), this._map.on("drag", this._onDrag), this._container && this._container.classList.add("mapboxgl-popup-track-pointer"), this._map._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
            }, n.prototype.getElement = function () {
              return this._container;
            }, n.prototype.setText = function (e) {
              return this.setDOMContent(t.window.document.createTextNode(e));
            }, n.prototype.setHTML = function (e) {
              var r,
                  n = t.window.document.createDocumentFragment(),
                  i = t.window.document.createElement("body");

              for (i.innerHTML = e; r = i.firstChild;) {
                n.appendChild(r);
              }

              return this.setDOMContent(n);
            }, n.prototype.getMaxWidth = function () {
              return this._container && this._container.style.maxWidth;
            }, n.prototype.setMaxWidth = function (t) {
              return this.options.maxWidth = t, this._update(), this;
            }, n.prototype.setDOMContent = function (t) {
              return this._createContent(), this._content.appendChild(t), this._update(), this;
            }, n.prototype.addClassName = function (t) {
              this._container && this._container.classList.add(t);
            }, n.prototype.removeClassName = function (t) {
              this._container && this._container.classList.remove(t);
            }, n.prototype.toggleClassName = function (t) {
              if (this._container) return this._container.classList.toggle(t);
            }, n.prototype._createContent = function () {
              this._content && r.remove(this._content), this._content = r.create("div", "mapboxgl-popup-content", this._container), this.options.closeButton && (this._closeButton = r.create("button", "mapboxgl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.setAttribute("aria-label", "Close popup"), this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
            }, n.prototype._onMouseUp = function (t) {
              this._update(t.point);
            }, n.prototype._onMouseMove = function (t) {
              this._update(t.point);
            }, n.prototype._onDrag = function (t) {
              this._update(t.point);
            }, n.prototype._update = function (e) {
              var n = this,
                  i = this._lngLat || this._trackPointer;

              if (this._map && i && this._content && (this._container || (this._container = r.create("div", "mapboxgl-popup", this._map.getContainer()), this._tip = r.create("div", "mapboxgl-popup-tip", this._container), this._container.appendChild(this._content), this.options.className && this.options.className.split(" ").forEach(function (t) {
                return n._container.classList.add(t);
              }), this._trackPointer && this._container.classList.add("mapboxgl-popup-track-pointer")), this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._map.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = Oi(this._lngLat, this._pos, this._map.transform)), !this._trackPointer || e)) {
                var a = this._pos = this._trackPointer && e ? e : this._map.project(this._lngLat),
                    o = this.options.anchor,
                    s = function e(r) {
                  if (r) {
                    if ("number" == typeof r) {
                      var n = Math.round(Math.sqrt(.5 * Math.pow(r, 2)));
                      return {
                        center: new t.Point(0, 0),
                        top: new t.Point(0, r),
                        "top-left": new t.Point(n, n),
                        "top-right": new t.Point(-n, n),
                        bottom: new t.Point(0, -r),
                        "bottom-left": new t.Point(n, -n),
                        "bottom-right": new t.Point(-n, -n),
                        left: new t.Point(r, 0),
                        right: new t.Point(-r, 0)
                      };
                    }

                    if (r instanceof t.Point || Array.isArray(r)) {
                      var i = t.Point.convert(r);
                      return {
                        center: i,
                        top: i,
                        "top-left": i,
                        "top-right": i,
                        bottom: i,
                        "bottom-left": i,
                        "bottom-right": i,
                        left: i,
                        right: i
                      };
                    }

                    return {
                      center: t.Point.convert(r.center || [0, 0]),
                      top: t.Point.convert(r.top || [0, 0]),
                      "top-left": t.Point.convert(r["top-left"] || [0, 0]),
                      "top-right": t.Point.convert(r["top-right"] || [0, 0]),
                      bottom: t.Point.convert(r.bottom || [0, 0]),
                      "bottom-left": t.Point.convert(r["bottom-left"] || [0, 0]),
                      "bottom-right": t.Point.convert(r["bottom-right"] || [0, 0]),
                      left: t.Point.convert(r.left || [0, 0]),
                      right: t.Point.convert(r.right || [0, 0])
                    };
                  }

                  return e(new t.Point(0, 0));
                }(this.options.offset);

                if (!o) {
                  var l,
                      c = this._container.offsetWidth,
                      u = this._container.offsetHeight;
                  l = a.y + s.bottom.y < u ? ["top"] : a.y > this._map.transform.height - u ? ["bottom"] : [], a.x < c / 2 ? l.push("left") : a.x > this._map.transform.width - c / 2 && l.push("right"), o = 0 === l.length ? "bottom" : l.join("-");
                }

                var f = a.add(s[o]).round();
                r.setTransform(this._container, zi[o] + " translate(" + f.x + "px," + f.y + "px)"), Di(this._container, o, "popup");
              }
            }, n.prototype._onClose = function () {
              this.remove();
            }, n;
          }(t.Evented);

          var Zi = {
            version: t.version,
            supported: e,
            setRTLTextPlugin: t.setRTLTextPlugin,
            getRTLTextPluginStatus: t.getRTLTextPluginStatus,
            Map: Ei,
            NavigationControl: Pi,
            GeolocateControl: Ui,
            AttributionControl: bi,
            ScaleControl: qi,
            FullscreenControl: Yi,
            Popup: Xi,
            Marker: Fi,
            Style: He,
            LngLat: t.LngLat,
            LngLatBounds: t.LngLatBounds,
            Point: t.Point,
            MercatorCoordinate: t.MercatorCoordinate,
            Evented: t.Evented,
            config: t.config,
            prewarm: function prewarm() {
              Bt().acquire(zt);
            },
            clearPrewarmedResources: function clearPrewarmedResources() {
              var t = Rt;
              t && (t.isPreloaded() && 1 === t.numActive() ? (t.release(zt), Rt = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
            },

            get accessToken() {
              return t.config.ACCESS_TOKEN;
            },

            set accessToken(e) {
              t.config.ACCESS_TOKEN = e;
            },

            get baseApiUrl() {
              return t.config.API_URL;
            },

            set baseApiUrl(e) {
              t.config.API_URL = e;
            },

            get workerCount() {
              return Dt.workerCount;
            },

            set workerCount(t) {
              Dt.workerCount = t;
            },

            get maxParallelImageRequests() {
              return t.config.MAX_PARALLEL_IMAGE_REQUESTS;
            },

            set maxParallelImageRequests(e) {
              t.config.MAX_PARALLEL_IMAGE_REQUESTS = e;
            },

            clearStorage: function clearStorage(e) {
              t.clearTileCache(e);
            },
            workerUrl: ""
          };
          return Zi;
        }), r;
      });
    }, {}],
    453: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        for (var e = 1 << t + 1, r = new Array(e), n = 0; n < e; ++n) {
          r[n] = a(t, n);
        }

        return r;
      };

      var n = t("convex-hull");

      function i(t, e, r) {
        for (var n = new Array(t), i = 0; i < t; ++i) {
          n[i] = 0, i === e && (n[i] += .5), i === r && (n[i] += .5);
        }

        return n;
      }

      function a(t, e) {
        if (0 === e || e === (1 << t + 1) - 1) return [];

        for (var r = [], a = [], o = 0; o <= t; ++o) {
          if (e & 1 << o) {
            r.push(i(t, o - 1, o - 1)), a.push(null);

            for (var s = 0; s <= t; ++s) {
              ~e & 1 << s && (r.push(i(t, o - 1, s - 1)), a.push([o, s]));
            }
          }
        }

        var l = n(r),
            c = [];

        t: for (o = 0; o < l.length; ++o) {
          var u = l[o],
              f = [];

          for (s = 0; s < u.length; ++s) {
            if (!a[u[s]]) continue t;
            f.push(a[u[s]].slice());
          }

          c.push(f);
        }

        return c;
      }
    }, {
      "convex-hull": 136
    }],
    454: [function (t, e, r) {
      var n = t("./normalize"),
          i = t("gl-mat4/create"),
          a = t("gl-mat4/clone"),
          o = t("gl-mat4/determinant"),
          s = t("gl-mat4/invert"),
          l = t("gl-mat4/transpose"),
          c = {
        length: t("gl-vec3/length"),
        normalize: t("gl-vec3/normalize"),
        dot: t("gl-vec3/dot"),
        cross: t("gl-vec3/cross")
      },
          u = i(),
          f = i(),
          h = [0, 0, 0, 0],
          p = [[0, 0, 0], [0, 0, 0], [0, 0, 0]],
          d = [0, 0, 0];

      function m(t, e, r, n, i) {
        t[0] = e[0] * n + r[0] * i, t[1] = e[1] * n + r[1] * i, t[2] = e[2] * n + r[2] * i;
      }

      e.exports = function (t, e, r, i, g, v) {
        if (e || (e = [0, 0, 0]), r || (r = [0, 0, 0]), i || (i = [0, 0, 0]), g || (g = [0, 0, 0, 1]), v || (v = [0, 0, 0, 1]), !n(u, t)) return !1;
        if (a(f, u), f[3] = 0, f[7] = 0, f[11] = 0, f[15] = 1, Math.abs(o(f) < 1e-8)) return !1;

        var y,
            x,
            b,
            _,
            w,
            T,
            k,
            M = u[3],
            A = u[7],
            S = u[11],
            E = u[12],
            L = u[13],
            C = u[14],
            P = u[15];

        if (0 !== M || 0 !== A || 0 !== S) {
          if (h[0] = M, h[1] = A, h[2] = S, h[3] = P, !s(f, f)) return !1;
          l(f, f), y = g, b = f, _ = (x = h)[0], w = x[1], T = x[2], k = x[3], y[0] = b[0] * _ + b[4] * w + b[8] * T + b[12] * k, y[1] = b[1] * _ + b[5] * w + b[9] * T + b[13] * k, y[2] = b[2] * _ + b[6] * w + b[10] * T + b[14] * k, y[3] = b[3] * _ + b[7] * w + b[11] * T + b[15] * k;
        } else g[0] = g[1] = g[2] = 0, g[3] = 1;

        if (e[0] = E, e[1] = L, e[2] = C, function (t, e) {
          t[0][0] = e[0], t[0][1] = e[1], t[0][2] = e[2], t[1][0] = e[4], t[1][1] = e[5], t[1][2] = e[6], t[2][0] = e[8], t[2][1] = e[9], t[2][2] = e[10];
        }(p, u), r[0] = c.length(p[0]), c.normalize(p[0], p[0]), i[0] = c.dot(p[0], p[1]), m(p[1], p[1], p[0], 1, -i[0]), r[1] = c.length(p[1]), c.normalize(p[1], p[1]), i[0] /= r[1], i[1] = c.dot(p[0], p[2]), m(p[2], p[2], p[0], 1, -i[1]), i[2] = c.dot(p[1], p[2]), m(p[2], p[2], p[1], 1, -i[2]), r[2] = c.length(p[2]), c.normalize(p[2], p[2]), i[1] /= r[2], i[2] /= r[2], c.cross(d, p[1], p[2]), c.dot(p[0], d) < 0) for (var I = 0; I < 3; I++) {
          r[I] *= -1, p[I][0] *= -1, p[I][1] *= -1, p[I][2] *= -1;
        }
        return v[0] = .5 * Math.sqrt(Math.max(1 + p[0][0] - p[1][1] - p[2][2], 0)), v[1] = .5 * Math.sqrt(Math.max(1 - p[0][0] + p[1][1] - p[2][2], 0)), v[2] = .5 * Math.sqrt(Math.max(1 - p[0][0] - p[1][1] + p[2][2], 0)), v[3] = .5 * Math.sqrt(Math.max(1 + p[0][0] + p[1][1] + p[2][2], 0)), p[2][1] > p[1][2] && (v[0] = -v[0]), p[0][2] > p[2][0] && (v[1] = -v[1]), p[1][0] > p[0][1] && (v[2] = -v[2]), !0;
      };
    }, {
      "./normalize": 455,
      "gl-mat4/clone": 275,
      "gl-mat4/create": 277,
      "gl-mat4/determinant": 278,
      "gl-mat4/invert": 290,
      "gl-mat4/transpose": 303,
      "gl-vec3/cross": 359,
      "gl-vec3/dot": 364,
      "gl-vec3/length": 374,
      "gl-vec3/normalize": 381
    }],
    455: [function (t, e, r) {
      e.exports = function (t, e) {
        var r = e[15];
        if (0 === r) return !1;

        for (var n = 1 / r, i = 0; i < 16; i++) {
          t[i] = e[i] * n;
        }

        return !0;
      };
    }, {}],
    456: [function (t, e, r) {
      var n = t("gl-vec3/lerp"),
          i = t("mat4-recompose"),
          a = t("mat4-decompose"),
          o = t("gl-mat4/determinant"),
          s = t("quat-slerp"),
          l = f(),
          c = f(),
          u = f();

      function f() {
        return {
          translate: h(),
          scale: h(1),
          skew: h(),
          perspective: [0, 0, 0, 1],
          quaternion: [0, 0, 0, 1]
        };
      }

      function h(t) {
        return [t || 0, t || 0, t || 0];
      }

      e.exports = function (t, e, r, f) {
        if (0 === o(e) || 0 === o(r)) return !1;
        var h = a(e, l.translate, l.scale, l.skew, l.perspective, l.quaternion),
            p = a(r, c.translate, c.scale, c.skew, c.perspective, c.quaternion);
        return !(!h || !p) && (n(u.translate, l.translate, c.translate, f), n(u.skew, l.skew, c.skew, f), n(u.scale, l.scale, c.scale, f), n(u.perspective, l.perspective, c.perspective, f), s(u.quaternion, l.quaternion, c.quaternion, f), i(t, u.translate, u.scale, u.skew, u.perspective, u.quaternion), !0);
      };
    }, {
      "gl-mat4/determinant": 278,
      "gl-vec3/lerp": 375,
      "mat4-decompose": 454,
      "mat4-recompose": 457,
      "quat-slerp": 521
    }],
    457: [function (t, e, r) {
      var n = {
        identity: t("gl-mat4/identity"),
        translate: t("gl-mat4/translate"),
        multiply: t("gl-mat4/multiply"),
        create: t("gl-mat4/create"),
        scale: t("gl-mat4/scale"),
        fromRotationTranslation: t("gl-mat4/fromRotationTranslation")
      },
          i = (n.create(), n.create());

      e.exports = function (t, e, r, a, o, s) {
        return n.identity(t), n.fromRotationTranslation(t, s, e), t[3] = o[0], t[7] = o[1], t[11] = o[2], t[15] = o[3], n.identity(i), 0 !== a[2] && (i[9] = a[2], n.multiply(t, t, i)), 0 !== a[1] && (i[9] = 0, i[8] = a[1], n.multiply(t, t, i)), 0 !== a[0] && (i[8] = 0, i[4] = a[0], n.multiply(t, t, i)), n.scale(t, t, r), t;
      };
    }, {
      "gl-mat4/create": 277,
      "gl-mat4/fromRotationTranslation": 281,
      "gl-mat4/identity": 288,
      "gl-mat4/multiply": 292,
      "gl-mat4/scale": 300,
      "gl-mat4/translate": 302
    }],
    458: [function (t, e, r) {
      "use strict";

      e.exports = Math.log2 || function (t) {
        return Math.log(t) * Math.LOG2E;
      };
    }, {}],
    459: [function (t, e, r) {
      "use strict";

      var n = t("binary-search-bounds"),
          i = t("mat4-interpolate"),
          a = t("gl-mat4/invert"),
          o = t("gl-mat4/rotateX"),
          s = t("gl-mat4/rotateY"),
          l = t("gl-mat4/rotateZ"),
          c = t("gl-mat4/lookAt"),
          u = t("gl-mat4/translate"),
          f = (t("gl-mat4/scale"), t("gl-vec3/normalize")),
          h = [0, 0, 0];

      function p(t) {
        this._components = t.slice(), this._time = [0], this.prevMatrix = t.slice(), this.nextMatrix = t.slice(), this.computedMatrix = t.slice(), this.computedInverse = t.slice(), this.computedEye = [0, 0, 0], this.computedUp = [0, 0, 0], this.computedCenter = [0, 0, 0], this.computedRadius = [0], this._limits = [-1 / 0, 1 / 0];
      }

      e.exports = function (t) {
        return new p((t = t || {}).matrix || [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
      };

      var d = p.prototype;
      d.recalcMatrix = function (t) {
        var e = this._time,
            r = n.le(e, t),
            o = this.computedMatrix;

        if (!(r < 0)) {
          var s = this._components;
          if (r === e.length - 1) for (var l = 16 * r, c = 0; c < 16; ++c) {
            o[c] = s[l++];
          } else {
            var u = e[r + 1] - e[r],
                h = (l = 16 * r, this.prevMatrix),
                p = !0;

            for (c = 0; c < 16; ++c) {
              h[c] = s[l++];
            }

            var d = this.nextMatrix;

            for (c = 0; c < 16; ++c) {
              d[c] = s[l++], p = p && h[c] === d[c];
            }

            if (u < 1e-6 || p) for (c = 0; c < 16; ++c) {
              o[c] = h[c];
            } else i(o, h, d, (t - e[r]) / u);
          }
          var m = this.computedUp;
          m[0] = o[1], m[1] = o[5], m[2] = o[9], f(m, m);
          var g = this.computedInverse;
          a(g, o);
          var v = this.computedEye,
              y = g[15];
          v[0] = g[12] / y, v[1] = g[13] / y, v[2] = g[14] / y;
          var x = this.computedCenter,
              b = Math.exp(this.computedRadius[0]);

          for (c = 0; c < 3; ++c) {
            x[c] = v[c] - o[2 + 4 * c] * b;
          }
        }
      }, d.idle = function (t) {
        if (!(t < this.lastT())) {
          for (var e = this._components, r = e.length - 16, n = 0; n < 16; ++n) {
            e.push(e[r++]);
          }

          this._time.push(t);
        }
      }, d.flush = function (t) {
        var e = n.gt(this._time, t) - 2;
        e < 0 || (this._time.splice(0, e), this._components.splice(0, 16 * e));
      }, d.lastT = function () {
        return this._time[this._time.length - 1];
      }, d.lookAt = function (t, e, r, n) {
        this.recalcMatrix(t), e = e || this.computedEye, r = r || h, n = n || this.computedUp, this.setMatrix(t, c(this.computedMatrix, e, r, n));

        for (var i = 0, a = 0; a < 3; ++a) {
          i += Math.pow(r[a] - e[a], 2);
        }

        i = Math.log(Math.sqrt(i)), this.computedRadius[0] = i;
      }, d.rotate = function (t, e, r, n) {
        this.recalcMatrix(t);
        var i = this.computedInverse;
        e && s(i, i, e), r && o(i, i, r), n && l(i, i, n), this.setMatrix(t, a(this.computedMatrix, i));
      };
      var m = [0, 0, 0];
      d.pan = function (t, e, r, n) {
        m[0] = -(e || 0), m[1] = -(r || 0), m[2] = -(n || 0), this.recalcMatrix(t);
        var i = this.computedInverse;
        u(i, i, m), this.setMatrix(t, a(i, i));
      }, d.translate = function (t, e, r, n) {
        m[0] = e || 0, m[1] = r || 0, m[2] = n || 0, this.recalcMatrix(t);
        var i = this.computedMatrix;
        u(i, i, m), this.setMatrix(t, i);
      }, d.setMatrix = function (t, e) {
        if (!(t < this.lastT())) {
          this._time.push(t);

          for (var r = 0; r < 16; ++r) {
            this._components.push(e[r]);
          }
        }
      }, d.setDistance = function (t, e) {
        this.computedRadius[0] = e;
      }, d.setDistanceLimits = function (t, e) {
        var r = this._limits;
        r[0] = t, r[1] = e;
      }, d.getDistanceLimits = function (t) {
        var e = this._limits;
        return t ? (t[0] = e[0], t[1] = e[1], t) : e;
      };
    }, {
      "binary-search-bounds": 460,
      "gl-mat4/invert": 290,
      "gl-mat4/lookAt": 291,
      "gl-mat4/rotateX": 297,
      "gl-mat4/rotateY": 298,
      "gl-mat4/rotateZ": 299,
      "gl-mat4/scale": 300,
      "gl-mat4/translate": 302,
      "gl-vec3/normalize": 381,
      "mat4-interpolate": 456
    }],
    460: [function (t, e, r) {
      arguments[4][242][0].apply(r, arguments);
    }, {
      dup: 242
    }],
    461: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        var e = t.length;

        if (e < 3) {
          for (var r = new Array(e), i = 0; i < e; ++i) {
            r[i] = i;
          }

          return 2 === e && t[0][0] === t[1][0] && t[0][1] === t[1][1] ? [0] : r;
        }

        var a = new Array(e);

        for (i = 0; i < e; ++i) {
          a[i] = i;
        }

        a.sort(function (e, r) {
          var n = t[e][0] - t[r][0];
          return n || t[e][1] - t[r][1];
        });
        var o = [a[0], a[1]],
            s = [a[0], a[1]];

        for (i = 2; i < e; ++i) {
          for (var l = a[i], c = t[l], u = o.length; u > 1 && n(t[o[u - 2]], t[o[u - 1]], c) <= 0;) {
            u -= 1, o.pop();
          }

          for (o.push(l), u = s.length; u > 1 && n(t[s[u - 2]], t[s[u - 1]], c) >= 0;) {
            u -= 1, s.pop();
          }

          s.push(l);
        }

        r = new Array(s.length + o.length - 2);

        for (var f = 0, h = (i = 0, o.length); i < h; ++i) {
          r[f++] = o[i];
        }

        for (var p = s.length - 2; p > 0; --p) {
          r[f++] = s[p];
        }

        return r;
      };

      var n = t("robust-orientation")[3];
    }, {
      "robust-orientation": 540
    }],
    462: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        e || (e = t, t = window);
        var r = 0,
            i = 0,
            a = 0,
            o = {
          shift: !1,
          alt: !1,
          control: !1,
          meta: !1
        },
            s = !1;

        function l(t) {
          var e = !1;
          return "altKey" in t && (e = e || t.altKey !== o.alt, o.alt = !!t.altKey), "shiftKey" in t && (e = e || t.shiftKey !== o.shift, o.shift = !!t.shiftKey), "ctrlKey" in t && (e = e || t.ctrlKey !== o.control, o.control = !!t.ctrlKey), "metaKey" in t && (e = e || t.metaKey !== o.meta, o.meta = !!t.metaKey), e;
        }

        function c(t, s) {
          var c = n.x(s),
              u = n.y(s);
          "buttons" in s && (t = 0 | s.buttons), (t !== r || c !== i || u !== a || l(s)) && (r = 0 | t, i = c || 0, a = u || 0, e && e(r, i, a, o));
        }

        function u(t) {
          c(0, t);
        }

        function f() {
          (r || i || a || o.shift || o.alt || o.meta || o.control) && (i = a = 0, r = 0, o.shift = o.alt = o.control = o.meta = !1, e && e(0, 0, 0, o));
        }

        function h(t) {
          l(t) && e && e(r, i, a, o);
        }

        function p(t) {
          0 === n.buttons(t) ? c(0, t) : c(r, t);
        }

        function d(t) {
          c(r | n.buttons(t), t);
        }

        function m(t) {
          c(r & ~n.buttons(t), t);
        }

        function g() {
          s || (s = !0, t.addEventListener("mousemove", p), t.addEventListener("mousedown", d), t.addEventListener("mouseup", m), t.addEventListener("mouseleave", u), t.addEventListener("mouseenter", u), t.addEventListener("mouseout", u), t.addEventListener("mouseover", u), t.addEventListener("blur", f), t.addEventListener("keyup", h), t.addEventListener("keydown", h), t.addEventListener("keypress", h), t !== window && (window.addEventListener("blur", f), window.addEventListener("keyup", h), window.addEventListener("keydown", h), window.addEventListener("keypress", h)));
        }

        g();
        var v = {
          element: t
        };
        return Object.defineProperties(v, {
          enabled: {
            get: function get() {
              return s;
            },
            set: function set(e) {
              e ? g() : function () {
                if (!s) return;
                s = !1, t.removeEventListener("mousemove", p), t.removeEventListener("mousedown", d), t.removeEventListener("mouseup", m), t.removeEventListener("mouseleave", u), t.removeEventListener("mouseenter", u), t.removeEventListener("mouseout", u), t.removeEventListener("mouseover", u), t.removeEventListener("blur", f), t.removeEventListener("keyup", h), t.removeEventListener("keydown", h), t.removeEventListener("keypress", h), t !== window && (window.removeEventListener("blur", f), window.removeEventListener("keyup", h), window.removeEventListener("keydown", h), window.removeEventListener("keypress", h));
              }();
            },
            enumerable: !0
          },
          buttons: {
            get: function get() {
              return r;
            },
            enumerable: !0
          },
          x: {
            get: function get() {
              return i;
            },
            enumerable: !0
          },
          y: {
            get: function get() {
              return a;
            },
            enumerable: !0
          },
          mods: {
            get: function get() {
              return o;
            },
            enumerable: !0
          }
        }), v;
      };

      var n = t("mouse-event");
    }, {
      "mouse-event": 464
    }],
    463: [function (t, e, r) {
      var n = {
        left: 0,
        top: 0
      };

      e.exports = function (t, e, r) {
        e = e || t.currentTarget || t.srcElement, Array.isArray(r) || (r = [0, 0]);
        var i = t.clientX || 0,
            a = t.clientY || 0,
            o = (s = e, s === window || s === document || s === document.body ? n : s.getBoundingClientRect());
        var s;
        return r[0] = i - o.left, r[1] = a - o.top, r;
      };
    }, {}],
    464: [function (t, e, r) {
      "use strict";

      function n(t) {
        return t.target || t.srcElement || window;
      }

      r.buttons = function (t) {
        if ("object" == _typeof(t)) {
          if ("buttons" in t) return t.buttons;

          if ("which" in t) {
            if (2 === (e = t.which)) return 4;
            if (3 === e) return 2;
            if (e > 0) return 1 << e - 1;
          } else if ("button" in t) {
            var e;
            if (1 === (e = t.button)) return 4;
            if (2 === e) return 2;
            if (e >= 0) return 1 << e;
          }
        }

        return 0;
      }, r.element = n, r.x = function (t) {
        if ("object" == _typeof(t)) {
          if ("offsetX" in t) return t.offsetX;
          var e = n(t).getBoundingClientRect();
          return t.clientX - e.left;
        }

        return 0;
      }, r.y = function (t) {
        if ("object" == _typeof(t)) {
          if ("offsetY" in t) return t.offsetY;
          var e = n(t).getBoundingClientRect();
          return t.clientY - e.top;
        }

        return 0;
      };
    }, {}],
    465: [function (t, e, r) {
      "use strict";

      var n = t("to-px");

      e.exports = function (t, e, r) {
        "function" == typeof t && (r = !!e, e = t, t = window);

        var i = n("ex", t),
            a = function a(t) {
          r && t.preventDefault();
          var n = t.deltaX || 0,
              a = t.deltaY || 0,
              o = t.deltaZ || 0,
              s = 1;

          switch (t.deltaMode) {
            case 1:
              s = i;
              break;

            case 2:
              s = window.innerHeight;
          }

          if (a *= s, o *= s, (n *= s) || a || o) return e(n, a, o, t);
        };

        return t.addEventListener("wheel", a), a;
      };
    }, {
      "to-px": 592
    }],
    466: [function (t, e, r) {
      (function (t, r) {
        (function () {
          /*! Native Promise Only
              v0.8.1 (c) Kyle Simpson
              MIT License: http://getify.mit-license.org
          */
          !function (t, r, n) {
            r[t] = r[t] || n(), void 0 !== e && e.exports && (e.exports = r[t]);
          }("Promise", void 0 !== t ? t : this, function () {
            "use strict";

            var t,
                e,
                n,
                i = Object.prototype.toString,
                a = void 0 !== r ? function (t) {
              return r(t);
            } : setTimeout;

            try {
              Object.defineProperty({}, "x", {}), t = function t(_t3, e, r, n) {
                return Object.defineProperty(_t3, e, {
                  value: r,
                  writable: !0,
                  configurable: !1 !== n
                });
              };
            } catch (e) {
              t = function t(_t4, e, r) {
                return _t4[e] = r, _t4;
              };
            }

            function o(t, r) {
              n.add(t, r), e || (e = a(n.drain));
            }

            function s(t) {
              var e,
                  r = _typeof(t);

              return null == t || "object" != r && "function" != r || (e = t.then), "function" == typeof e && e;
            }

            function l() {
              for (var t = 0; t < this.chain.length; t++) {
                c(this, 1 === this.state ? this.chain[t].success : this.chain[t].failure, this.chain[t]);
              }

              this.chain.length = 0;
            }

            function c(t, e, r) {
              var n, i;

              try {
                !1 === e ? r.reject(t.msg) : (n = !0 === e ? t.msg : e.call(void 0, t.msg)) === r.promise ? r.reject(TypeError("Promise-chain cycle")) : (i = s(n)) ? i.call(n, r.resolve, r.reject) : r.resolve(n);
              } catch (t) {
                r.reject(t);
              }
            }

            function u(t) {
              var e,
                  r = this;

              if (!r.triggered) {
                r.triggered = !0, r.def && (r = r.def);

                try {
                  (e = s(t)) ? o(function () {
                    var n = new p(r);

                    try {
                      e.call(t, function () {
                        u.apply(n, arguments);
                      }, function () {
                        f.apply(n, arguments);
                      });
                    } catch (t) {
                      f.call(n, t);
                    }
                  }) : (r.msg = t, r.state = 1, r.chain.length > 0 && o(l, r));
                } catch (t) {
                  f.call(new p(r), t);
                }
              }
            }

            function f(t) {
              var e = this;
              e.triggered || (e.triggered = !0, e.def && (e = e.def), e.msg = t, e.state = 2, e.chain.length > 0 && o(l, e));
            }

            function h(t, e, r, n) {
              for (var i = 0; i < e.length; i++) {
                !function (i) {
                  t.resolve(e[i]).then(function (t) {
                    r(i, t);
                  }, n);
                }(i);
              }
            }

            function p(t) {
              this.def = t, this.triggered = !1;
            }

            function d(t) {
              this.promise = t, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
            }

            function m(t) {
              if ("function" != typeof t) throw TypeError("Not a function");
              if (0 !== this.__NPO__) throw TypeError("Not a promise");
              this.__NPO__ = 1;
              var e = new d(this);
              this.then = function (t, r) {
                var n = {
                  success: "function" != typeof t || t,
                  failure: "function" == typeof r && r
                };
                return n.promise = new this.constructor(function (t, e) {
                  if ("function" != typeof t || "function" != typeof e) throw TypeError("Not a function");
                  n.resolve = t, n.reject = e;
                }), e.chain.push(n), 0 !== e.state && o(l, e), n.promise;
              }, this.catch = function (t) {
                return this.then(void 0, t);
              };

              try {
                t.call(void 0, function (t) {
                  u.call(e, t);
                }, function (t) {
                  f.call(e, t);
                });
              } catch (t) {
                f.call(e, t);
              }
            }

            n = function () {
              var t, r, n;

              function i(t, e) {
                this.fn = t, this.self = e, this.next = void 0;
              }

              return {
                add: function add(e, a) {
                  n = new i(e, a), r ? r.next = n : t = n, r = n, n = void 0;
                },
                drain: function drain() {
                  var n = t;

                  for (t = r = e = void 0; n;) {
                    n.fn.call(n.self), n = n.next;
                  }
                }
              };
            }();

            var g = t({}, "constructor", m, !1);
            return m.prototype = g, t(g, "__NPO__", 0, !1), t(m, "resolve", function (t) {
              return t && "object" == _typeof(t) && 1 === t.__NPO__ ? t : new this(function (e, r) {
                if ("function" != typeof e || "function" != typeof r) throw TypeError("Not a function");
                e(t);
              });
            }), t(m, "reject", function (t) {
              return new this(function (e, r) {
                if ("function" != typeof e || "function" != typeof r) throw TypeError("Not a function");
                r(t);
              });
            }), t(m, "all", function (t) {
              var e = this;
              return "[object Array]" != i.call(t) ? e.reject(TypeError("Not an array")) : 0 === t.length ? e.resolve([]) : new e(function (r, n) {
                if ("function" != typeof r || "function" != typeof n) throw TypeError("Not a function");
                var i = t.length,
                    a = Array(i),
                    o = 0;
                h(e, t, function (t, e) {
                  a[t] = e, ++o === i && r(a);
                }, n);
              });
            }), t(m, "race", function (t) {
              var e = this;
              return "[object Array]" != i.call(t) ? e.reject(TypeError("Not an array")) : new e(function (r, n) {
                if ("function" != typeof r || "function" != typeof n) throw TypeError("Not a function");
                h(e, t, function (t, e) {
                  r(e);
                }, n);
              });
            }), m;
          });
        }).call(this);
      }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, t("timers").setImmediate);
    }, {
      timers: 589
    }],
    467: [function (t, e, r) {
      "use strict";

      var n = t("typedarray-pool");

      function i(t) {
        return "a" + t;
      }

      function a(t) {
        return "d" + t;
      }

      function o(t, e) {
        return "c" + t + "_" + e;
      }

      function s(t) {
        return "s" + t;
      }

      function l(t, e) {
        return "t" + t + "_" + e;
      }

      function c(t) {
        return "o" + t;
      }

      function u(t) {
        return "x" + t;
      }

      function f(t) {
        return "p" + t;
      }

      function h(t, e) {
        return "d" + t + "_" + e;
      }

      function p(t) {
        return "i" + t;
      }

      function d(t, e) {
        return "u" + t + "_" + e;
      }

      function m(t) {
        return "b" + t;
      }

      function g(t) {
        return "y" + t;
      }

      function v(t) {
        return "e" + t;
      }

      function y(t) {
        return "v" + t;
      }

      e.exports = function (t) {
        function e(t) {
          throw new Error("ndarray-extract-contour: " + t);
        }

        "object" != _typeof(t) && e("Must specify arguments");
        var r = t.order;
        Array.isArray(r) || e("Must specify order");
        var b = t.arrayArguments || 1;
        b < 1 && e("Must have at least one array argument");

        var _ = t.scalarArguments || 0;

        _ < 0 && e("Scalar arg count must be > 0");
        "function" != typeof t.vertex && e("Must specify vertex creation function");
        "function" != typeof t.cell && e("Must specify cell creation function");
        "function" != typeof t.phase && e("Must specify phase function");

        for (var w = t.getters || [], T = new Array(b), k = 0; k < b; ++k) {
          w.indexOf(k) >= 0 ? T[k] = !0 : T[k] = !1;
        }

        return function (t, e, r, b, _, w) {
          var T = w.length,
              k = _.length;
          if (k < 2) throw new Error("ndarray-extract-contour: Dimension must be at least 2");

          for (var M = "extractContour" + _.join("_"), A = [], S = [], E = [], L = 0; L < T; ++L) {
            E.push(i(L));
          }

          for (L = 0; L < b; ++L) {
            E.push(u(L));
          }

          for (L = 0; L < k; ++L) {
            S.push(s(L) + "=" + i(0) + ".shape[" + L + "]|0");
          }

          for (L = 0; L < T; ++L) {
            S.push(a(L) + "=" + i(L) + ".data", c(L) + "=" + i(L) + ".offset|0");

            for (var C = 0; C < k; ++C) {
              S.push(l(L, C) + "=" + i(L) + ".stride[" + C + "]|0");
            }
          }

          for (L = 0; L < T; ++L) {
            S.push(f(L) + "=" + c(L)), S.push(o(L, 0));

            for (C = 1; C < 1 << k; ++C) {
              for (var P = [], I = 0; I < k; ++I) {
                C & 1 << I && P.push("-" + l(L, I));
              }

              S.push(h(L, C) + "=(" + P.join("") + ")|0"), S.push(o(L, C) + "=0");
            }
          }

          for (L = 0; L < T; ++L) {
            for (C = 0; C < k; ++C) {
              var O = [l(L, _[C])];
              C > 0 && O.push(l(L, _[C - 1]) + "*" + s(_[C - 1])), S.push(d(L, _[C]) + "=(" + O.join("-") + ")|0");
            }
          }

          for (L = 0; L < k; ++L) {
            S.push(p(L) + "=0");
          }

          S.push("N=0");
          var z = ["2"];

          for (L = k - 2; L >= 0; --L) {
            z.push(s(_[L]));
          }

          S.push("Q=(" + z.join("*") + ")|0", "P=mallocUint32(Q)", "V=mallocUint32(Q)", "X=0"), S.push(m(0) + "=0");

          for (C = 1; C < 1 << k; ++C) {
            var D = [],
                R = [];

            for (I = 0; I < k; ++I) {
              C & 1 << I && (0 === R.length ? D.push("1") : D.unshift(R.join("*"))), R.push(s(_[I]));
            }

            var F = "";
            D[0].indexOf(s(_[k - 2])) < 0 && (F = "-");
            var B = x(k, C, _);
            S.push(v(B) + "=(-" + D.join("-") + ")|0", g(B) + "=(" + F + D.join("-") + ")|0", m(B) + "=0");
          }

          function N(t, e) {
            A.push("for(", p(_[t]), "=", e, ";", p(_[t]), "<", s(_[t]), ";", "++", p(_[t]), "){");
          }

          function j(t) {
            for (var e = 0; e < T; ++e) {
              A.push(f(e), "+=", d(e, _[t]), ";");
            }

            A.push("}");
          }

          function U() {
            for (var t = 1; t < 1 << k; ++t) {
              A.push("T", "=", v(t), ";", v(t), "=", g(t), ";", g(t), "=", "T", ";");
            }
          }

          S.push(y(0) + "=0", "T=0"), function t(e, r) {
            if (e < 0) !function (t) {
              for (var e = 0; e < T; ++e) {
                w[e] ? A.push(o(e, 0), "=", a(e), ".get(", f(e), ");") : A.push(o(e, 0), "=", a(e), "[", f(e), "];");
              }

              var r = [];

              for (e = 0; e < T; ++e) {
                r.push(o(e, 0));
              }

              for (e = 0; e < b; ++e) {
                r.push(u(e));
              }

              A.push(m(0), "=", "P", "[", "X", "]=phase(", r.join(), ");");

              for (var n = 1; n < 1 << k; ++n) {
                A.push(m(n), "=", "P", "[", "X", "+", v(n), "];");
              }

              var i = [];

              for (n = 1; n < 1 << k; ++n) {
                i.push("(" + m(0) + "!==" + m(n) + ")");
              }

              A.push("if(", i.join("||"), "){");
              var s = [];

              for (e = 0; e < k; ++e) {
                s.push(p(e));
              }

              for (e = 0; e < T; ++e) {
                s.push(o(e, 0));

                for (n = 1; n < 1 << k; ++n) {
                  w[e] ? A.push(o(e, n), "=", a(e), ".get(", f(e), "+", h(e, n), ");") : A.push(o(e, n), "=", a(e), "[", f(e), "+", h(e, n), "];"), s.push(o(e, n));
                }
              }

              for (e = 0; e < 1 << k; ++e) {
                s.push(m(e));
              }

              for (e = 0; e < b; ++e) {
                s.push(u(e));
              }

              A.push("vertex(", s.join(), ");", y(0), "=", "V", "[", "X", "]=", "N", "++;");
              var l = (1 << k) - 1,
                  c = m(l);

              for (n = 0; n < k; ++n) {
                if (0 == (t & ~(1 << n))) {
                  for (var d = l ^ 1 << n, g = m(d), x = [], _ = d; _ > 0; _ = _ - 1 & d) {
                    x.push("V[X+" + v(_) + "]");
                  }

                  x.push(y(0));

                  for (_ = 0; _ < T; ++_) {
                    1 & n ? x.push(o(_, l), o(_, d)) : x.push(o(_, d), o(_, l));
                  }

                  1 & n ? x.push(c, g) : x.push(g, c);

                  for (_ = 0; _ < b; ++_) {
                    x.push(u(_));
                  }

                  A.push("if(", c, "!==", g, "){", "face(", x.join(), ")}");
                }
              }

              A.push("}", "X", "+=1;");
            }(r);else {
              !function (t) {
                for (var e = t - 1; e >= 0; --e) {
                  N(e, 0);
                }

                var r = [];

                for (e = 0; e < T; ++e) {
                  w[e] ? r.push(a(e) + ".get(" + f(e) + ")") : r.push(a(e) + "[" + f(e) + "]");
                }

                for (e = 0; e < b; ++e) {
                  r.push(u(e));
                }

                for (A.push("P", "[", "X", "++]=phase(", r.join(), ");"), e = 0; e < t; ++e) {
                  j(e);
                }

                for (var n = 0; n < T; ++n) {
                  A.push(f(n), "+=", d(n, _[t]), ";");
                }
              }(e), A.push("if(", s(_[e]), ">0){", p(_[e]), "=1;"), t(e - 1, r | 1 << _[e]);

              for (var n = 0; n < T; ++n) {
                A.push(f(n), "+=", d(n, _[e]), ";");
              }

              e === k - 1 && (A.push("X", "=0;"), U()), N(e, 2), t(e - 1, r), e === k - 1 && (A.push("if(", p(_[k - 1]), "&1){", "X", "=0;}"), U()), j(e), A.push("}");
            }
          }(k - 1, 0), A.push("freeUint32(", "V", ");freeUint32(", "P", ");");
          var V = ["'use strict';", "function ", M, "(", E.join(), "){", "var ", S.join(), ";", A.join(""), "}", "return ", M].join("");
          return new Function("vertex", "face", "phase", "mallocUint32", "freeUint32", V)(t, e, r, n.mallocUint32, n.freeUint32);
        }(t.vertex, t.cell, t.phase, _, r, T);
      };

      function x(t, e, r) {
        for (var n = 0, i = 0; i < t; ++i) {
          e & 1 << i && (n |= 1 << r[i]);
        }

        return n;
      }
    }, {
      "typedarray-pool": 609
    }],
    468: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r) {
        if (Array.isArray(r)) {
          if (r.length !== e.dimension) throw new Error("ndarray-gradient: invalid boundary conditions");
        } else r = n(e.dimension, "string" == typeof r ? r : "clamp");

        if (t.dimension !== e.dimension + 1) throw new Error("ndarray-gradient: output dimension must be +1 input dimension");
        if (t.shape[e.dimension] !== e.dimension) throw new Error("ndarray-gradient: output shape must match input shape");

        for (var i = 0; i < e.dimension; ++i) {
          if (t.shape[i] !== e.shape[i]) throw new Error("ndarray-gradient: shape mismatch");
        }

        if (0 === e.size) return t;
        if (e.dimension <= 0) return t.set(0), t;
        return function (t) {
          var e = t.join();
          if (v = o[e]) return v;
          var r = t.length,
              n = ["function gradient(dst,src){var s=src.shape.slice();"];

          function i(e) {
            for (var i = r - e.length, a = [], o = [], s = [], l = 0; l < r; ++l) {
              e.indexOf(l + 1) >= 0 ? s.push("0") : e.indexOf(-(l + 1)) >= 0 ? s.push("s[" + l + "]-1") : (s.push("-1"), a.push("1"), o.push("s[" + l + "]-2"));
            }

            var c = ".lo(" + a.join() + ").hi(" + o.join() + ")";

            if (0 === a.length && (c = ""), i > 0) {
              n.push("if(1");

              for (l = 0; l < r; ++l) {
                e.indexOf(l + 1) >= 0 || e.indexOf(-(l + 1)) >= 0 || n.push("&&s[", l, "]>2");
              }

              n.push("){grad", i, "(src.pick(", s.join(), ")", c);

              for (l = 0; l < r; ++l) {
                e.indexOf(l + 1) >= 0 || e.indexOf(-(l + 1)) >= 0 || n.push(",dst.pick(", s.join(), ",", l, ")", c);
              }

              n.push(");");
            }

            for (l = 0; l < e.length; ++l) {
              var u = Math.abs(e[l]) - 1,
                  f = "dst.pick(" + s.join() + "," + u + ")" + c;

              switch (t[u]) {
                case "clamp":
                  var h = s.slice(),
                      p = s.slice();
                  e[l] < 0 ? h[u] = "s[" + u + "]-2" : p[u] = "1", 0 === i ? n.push("if(s[", u, "]>1){dst.set(", s.join(), ",", u, ",0.5*(src.get(", h.join(), ")-src.get(", p.join(), ")))}else{dst.set(", s.join(), ",", u, ",0)};") : n.push("if(s[", u, "]>1){diff(", f, ",src.pick(", h.join(), ")", c, ",src.pick(", p.join(), ")", c, ");}else{zero(", f, ");};");
                  break;

                case "mirror":
                  0 === i ? n.push("dst.set(", s.join(), ",", u, ",0);") : n.push("zero(", f, ");");
                  break;

                case "wrap":
                  var d = s.slice(),
                      m = s.slice();
                  e[l] < 0 ? (d[u] = "s[" + u + "]-2", m[u] = "0") : (d[u] = "s[" + u + "]-1", m[u] = "1"), 0 === i ? n.push("if(s[", u, "]>2){dst.set(", s.join(), ",", u, ",0.5*(src.get(", d.join(), ")-src.get(", m.join(), ")))}else{dst.set(", s.join(), ",", u, ",0)};") : n.push("if(s[", u, "]>2){diff(", f, ",src.pick(", d.join(), ")", c, ",src.pick(", m.join(), ")", c, ");}else{zero(", f, ");};");
                  break;

                default:
                  throw new Error("ndarray-gradient: Invalid boundary condition");
              }
            }

            i > 0 && n.push("};");
          }

          for (var s = 0; s < 1 << r; ++s) {
            for (var f = [], h = 0; h < r; ++h) {
              s & 1 << h && f.push(h + 1);
            }

            for (var p = 0; p < 1 << f.length; ++p) {
              var d = f.slice();

              for (h = 0; h < f.length; ++h) {
                p & 1 << h && (d[h] = -d[h]);
              }

              i(d);
            }
          }

          n.push("return dst;};return gradient");
          var m = ["diff", "zero"],
              g = [l, c];

          for (s = 1; s <= r; ++s) {
            m.push("grad" + s), g.push(u(s));
          }

          m.push(n.join(""));
          var v = Function.apply(void 0, m).apply(void 0, g);
          return a[e] = v, v;
        }(r)(t, e);
      };

      var n = t("dup"),
          i = t("cwise-compiler"),
          a = {},
          o = {},
          s = {
        body: "",
        args: [],
        thisVars: [],
        localVars: []
      },
          l = i({
        args: ["array", "array", "array"],
        pre: s,
        post: s,
        body: {
          args: [{
            name: "out",
            lvalue: !0,
            rvalue: !1,
            count: 1
          }, {
            name: "left",
            lvalue: !1,
            rvalue: !0,
            count: 1
          }, {
            name: "right",
            lvalue: !1,
            rvalue: !0,
            count: 1
          }],
          body: "out=0.5*(left-right)",
          thisVars: [],
          localVars: []
        },
        funcName: "cdiff"
      }),
          c = i({
        args: ["array"],
        pre: s,
        post: s,
        body: {
          args: [{
            name: "out",
            lvalue: !0,
            rvalue: !1,
            count: 1
          }],
          body: "out=0",
          thisVars: [],
          localVars: []
        },
        funcName: "zero"
      });

      function u(t) {
        if (t in a) return a[t];

        for (var e = [], r = 0; r < t; ++r) {
          e.push("out", r, "s=0.5*(inp", r, "l-inp", r, "r);");
        }

        var o = ["array"],
            l = ["junk"];

        for (r = 0; r < t; ++r) {
          o.push("array"), l.push("out" + r + "s");
          var c = n(t);
          c[r] = -1, o.push({
            array: 0,
            offset: c.slice()
          }), c[r] = 1, o.push({
            array: 0,
            offset: c.slice()
          }), l.push("inp" + r + "l", "inp" + r + "r");
        }

        return a[t] = i({
          args: o,
          pre: s,
          post: s,
          body: {
            body: e.join(""),
            args: l.map(function (t) {
              return {
                name: t,
                lvalue: 0 === t.indexOf("out"),
                rvalue: 0 === t.indexOf("inp"),
                count: "junk" !== t | 0
              };
            }),
            thisVars: [],
            localVars: []
          },
          funcName: "fdTemplate" + t
        });
      }
    }, {
      "cwise-compiler": 152,
      dup: 176
    }],
    469: [function (t, e, r) {
      "use strict";

      function n(t, e) {
        var r = Math.floor(e),
            n = e - r,
            i = 0 <= r && r < t.shape[0],
            a = 0 <= r + 1 && r + 1 < t.shape[0];
        return (1 - n) * (i ? +t.get(r) : 0) + n * (a ? +t.get(r + 1) : 0);
      }

      function i(t, e, r) {
        var n = Math.floor(e),
            i = e - n,
            a = 0 <= n && n < t.shape[0],
            o = 0 <= n + 1 && n + 1 < t.shape[0],
            s = Math.floor(r),
            l = r - s,
            c = 0 <= s && s < t.shape[1],
            u = 0 <= s + 1 && s + 1 < t.shape[1],
            f = a && c ? t.get(n, s) : 0,
            h = a && u ? t.get(n, s + 1) : 0;
        return (1 - l) * ((1 - i) * f + i * (o && c ? t.get(n + 1, s) : 0)) + l * ((1 - i) * h + i * (o && u ? t.get(n + 1, s + 1) : 0));
      }

      function a(t, e, r, n) {
        var i = Math.floor(e),
            a = e - i,
            o = 0 <= i && i < t.shape[0],
            s = 0 <= i + 1 && i + 1 < t.shape[0],
            l = Math.floor(r),
            c = r - l,
            u = 0 <= l && l < t.shape[1],
            f = 0 <= l + 1 && l + 1 < t.shape[1],
            h = Math.floor(n),
            p = n - h,
            d = 0 <= h && h < t.shape[2],
            m = 0 <= h + 1 && h + 1 < t.shape[2],
            g = o && u && d ? t.get(i, l, h) : 0,
            v = o && f && d ? t.get(i, l + 1, h) : 0,
            y = s && u && d ? t.get(i + 1, l, h) : 0,
            x = s && f && d ? t.get(i + 1, l + 1, h) : 0,
            b = o && u && m ? t.get(i, l, h + 1) : 0,
            _ = o && f && m ? t.get(i, l + 1, h + 1) : 0;

        return (1 - p) * ((1 - c) * ((1 - a) * g + a * y) + c * ((1 - a) * v + a * x)) + p * ((1 - c) * ((1 - a) * b + a * (s && u && m ? t.get(i + 1, l, h + 1) : 0)) + c * ((1 - a) * _ + a * (s && f && m ? t.get(i + 1, l + 1, h + 1) : 0)));
      }

      function o(t) {
        var e,
            r,
            n = 0 | t.shape.length,
            i = new Array(n),
            a = new Array(n),
            o = new Array(n),
            s = new Array(n);

        for (e = 0; e < n; ++e) {
          r = +arguments[e + 1], i[e] = Math.floor(r), a[e] = r - i[e], o[e] = 0 <= i[e] && i[e] < t.shape[e], s[e] = 0 <= i[e] + 1 && i[e] + 1 < t.shape[e];
        }

        var l,
            c,
            u,
            f = 0;

        t: for (e = 0; e < 1 << n; ++e) {
          for (c = 1, u = t.offset, l = 0; l < n; ++l) {
            if (e & 1 << l) {
              if (!s[l]) continue t;
              c *= a[l], u += t.stride[l] * (i[l] + 1);
            } else {
              if (!o[l]) continue t;
              c *= 1 - a[l], u += t.stride[l] * i[l];
            }
          }

          f += c * t.data[u];
        }

        return f;
      }

      e.exports = function (t, e, r, s) {
        switch (t.shape.length) {
          case 0:
            return 0;

          case 1:
            return n(t, e);

          case 2:
            return i(t, e, r);

          case 3:
            return a(t, e, r, s);

          default:
            return o.apply(void 0, arguments);
        }
      }, e.exports.d1 = n, e.exports.d2 = i, e.exports.d3 = a;
    }, {}],
    470: [function (t, e, r) {
      "use strict";

      var n = t("cwise-compiler"),
          i = {
        body: "",
        args: [],
        thisVars: [],
        localVars: []
      };

      function a(t) {
        if (!t) return i;

        for (var e = 0; e < t.args.length; ++e) {
          var r = t.args[e];
          t.args[e] = 0 === e ? {
            name: r,
            lvalue: !0,
            rvalue: !!t.rvalue,
            count: t.count || 1
          } : {
            name: r,
            lvalue: !1,
            rvalue: !0,
            count: 1
          };
        }

        return t.thisVars || (t.thisVars = []), t.localVars || (t.localVars = []), t;
      }

      function o(t) {
        for (var e = [], r = 0; r < t.args.length; ++r) {
          e.push("a" + r);
        }

        return new Function("P", ["return function ", t.funcName, "_ndarrayops(", e.join(","), ") {P(", e.join(","), ");return a0}"].join(""))(function (t) {
          return n({
            args: t.args,
            pre: a(t.pre),
            body: a(t.body),
            post: a(t.proc),
            funcName: t.funcName
          });
        }(t));
      }

      var s = {
        add: "+",
        sub: "-",
        mul: "*",
        div: "/",
        mod: "%",
        band: "&",
        bor: "|",
        bxor: "^",
        lshift: "<<",
        rshift: ">>",
        rrshift: ">>>"
      };
      !function () {
        for (var t in s) {
          var e = s[t];
          r[t] = o({
            args: ["array", "array", "array"],
            body: {
              args: ["a", "b", "c"],
              body: "a=b" + e + "c"
            },
            funcName: t
          }), r[t + "eq"] = o({
            args: ["array", "array"],
            body: {
              args: ["a", "b"],
              body: "a" + e + "=b"
            },
            rvalue: !0,
            funcName: t + "eq"
          }), r[t + "s"] = o({
            args: ["array", "array", "scalar"],
            body: {
              args: ["a", "b", "s"],
              body: "a=b" + e + "s"
            },
            funcName: t + "s"
          }), r[t + "seq"] = o({
            args: ["array", "scalar"],
            body: {
              args: ["a", "s"],
              body: "a" + e + "=s"
            },
            rvalue: !0,
            funcName: t + "seq"
          });
        }
      }();
      var l = {
        not: "!",
        bnot: "~",
        neg: "-",
        recip: "1.0/"
      };
      !function () {
        for (var t in l) {
          var e = l[t];
          r[t] = o({
            args: ["array", "array"],
            body: {
              args: ["a", "b"],
              body: "a=" + e + "b"
            },
            funcName: t
          }), r[t + "eq"] = o({
            args: ["array"],
            body: {
              args: ["a"],
              body: "a=" + e + "a"
            },
            rvalue: !0,
            count: 2,
            funcName: t + "eq"
          });
        }
      }();
      var c = {
        and: "&&",
        or: "||",
        eq: "===",
        neq: "!==",
        lt: "<",
        gt: ">",
        leq: "<=",
        geq: ">="
      };
      !function () {
        for (var t in c) {
          var e = c[t];
          r[t] = o({
            args: ["array", "array", "array"],
            body: {
              args: ["a", "b", "c"],
              body: "a=b" + e + "c"
            },
            funcName: t
          }), r[t + "s"] = o({
            args: ["array", "array", "scalar"],
            body: {
              args: ["a", "b", "s"],
              body: "a=b" + e + "s"
            },
            funcName: t + "s"
          }), r[t + "eq"] = o({
            args: ["array", "array"],
            body: {
              args: ["a", "b"],
              body: "a=a" + e + "b"
            },
            rvalue: !0,
            count: 2,
            funcName: t + "eq"
          }), r[t + "seq"] = o({
            args: ["array", "scalar"],
            body: {
              args: ["a", "s"],
              body: "a=a" + e + "s"
            },
            rvalue: !0,
            count: 2,
            funcName: t + "seq"
          });
        }
      }();
      var u = ["abs", "acos", "asin", "atan", "ceil", "cos", "exp", "floor", "log", "round", "sin", "sqrt", "tan"];
      !function () {
        for (var t = 0; t < u.length; ++t) {
          var e = u[t];
          r[e] = o({
            args: ["array", "array"],
            pre: {
              args: [],
              body: "this_f=Math." + e,
              thisVars: ["this_f"]
            },
            body: {
              args: ["a", "b"],
              body: "a=this_f(b)",
              thisVars: ["this_f"]
            },
            funcName: e
          }), r[e + "eq"] = o({
            args: ["array"],
            pre: {
              args: [],
              body: "this_f=Math." + e,
              thisVars: ["this_f"]
            },
            body: {
              args: ["a"],
              body: "a=this_f(a)",
              thisVars: ["this_f"]
            },
            rvalue: !0,
            count: 2,
            funcName: e + "eq"
          });
        }
      }();
      var f = ["max", "min", "atan2", "pow"];
      !function () {
        for (var t = 0; t < f.length; ++t) {
          var e = f[t];
          r[e] = o({
            args: ["array", "array", "array"],
            pre: {
              args: [],
              body: "this_f=Math." + e,
              thisVars: ["this_f"]
            },
            body: {
              args: ["a", "b", "c"],
              body: "a=this_f(b,c)",
              thisVars: ["this_f"]
            },
            funcName: e
          }), r[e + "s"] = o({
            args: ["array", "array", "scalar"],
            pre: {
              args: [],
              body: "this_f=Math." + e,
              thisVars: ["this_f"]
            },
            body: {
              args: ["a", "b", "c"],
              body: "a=this_f(b,c)",
              thisVars: ["this_f"]
            },
            funcName: e + "s"
          }), r[e + "eq"] = o({
            args: ["array", "array"],
            pre: {
              args: [],
              body: "this_f=Math." + e,
              thisVars: ["this_f"]
            },
            body: {
              args: ["a", "b"],
              body: "a=this_f(a,b)",
              thisVars: ["this_f"]
            },
            rvalue: !0,
            count: 2,
            funcName: e + "eq"
          }), r[e + "seq"] = o({
            args: ["array", "scalar"],
            pre: {
              args: [],
              body: "this_f=Math." + e,
              thisVars: ["this_f"]
            },
            body: {
              args: ["a", "b"],
              body: "a=this_f(a,b)",
              thisVars: ["this_f"]
            },
            rvalue: !0,
            count: 2,
            funcName: e + "seq"
          });
        }
      }();
      var h = ["atan2", "pow"];
      !function () {
        for (var t = 0; t < h.length; ++t) {
          var e = h[t];
          r[e + "op"] = o({
            args: ["array", "array", "array"],
            pre: {
              args: [],
              body: "this_f=Math." + e,
              thisVars: ["this_f"]
            },
            body: {
              args: ["a", "b", "c"],
              body: "a=this_f(c,b)",
              thisVars: ["this_f"]
            },
            funcName: e + "op"
          }), r[e + "ops"] = o({
            args: ["array", "array", "scalar"],
            pre: {
              args: [],
              body: "this_f=Math." + e,
              thisVars: ["this_f"]
            },
            body: {
              args: ["a", "b", "c"],
              body: "a=this_f(c,b)",
              thisVars: ["this_f"]
            },
            funcName: e + "ops"
          }), r[e + "opeq"] = o({
            args: ["array", "array"],
            pre: {
              args: [],
              body: "this_f=Math." + e,
              thisVars: ["this_f"]
            },
            body: {
              args: ["a", "b"],
              body: "a=this_f(b,a)",
              thisVars: ["this_f"]
            },
            rvalue: !0,
            count: 2,
            funcName: e + "opeq"
          }), r[e + "opseq"] = o({
            args: ["array", "scalar"],
            pre: {
              args: [],
              body: "this_f=Math." + e,
              thisVars: ["this_f"]
            },
            body: {
              args: ["a", "b"],
              body: "a=this_f(b,a)",
              thisVars: ["this_f"]
            },
            rvalue: !0,
            count: 2,
            funcName: e + "opseq"
          });
        }
      }(), r.any = n({
        args: ["array"],
        pre: i,
        body: {
          args: [{
            name: "a",
            lvalue: !1,
            rvalue: !0,
            count: 1
          }],
          body: "if(a){return true}",
          localVars: [],
          thisVars: []
        },
        post: {
          args: [],
          localVars: [],
          thisVars: [],
          body: "return false"
        },
        funcName: "any"
      }), r.all = n({
        args: ["array"],
        pre: i,
        body: {
          args: [{
            name: "x",
            lvalue: !1,
            rvalue: !0,
            count: 1
          }],
          body: "if(!x){return false}",
          localVars: [],
          thisVars: []
        },
        post: {
          args: [],
          localVars: [],
          thisVars: [],
          body: "return true"
        },
        funcName: "all"
      }), r.sum = n({
        args: ["array"],
        pre: {
          args: [],
          localVars: [],
          thisVars: ["this_s"],
          body: "this_s=0"
        },
        body: {
          args: [{
            name: "a",
            lvalue: !1,
            rvalue: !0,
            count: 1
          }],
          body: "this_s+=a",
          localVars: [],
          thisVars: ["this_s"]
        },
        post: {
          args: [],
          localVars: [],
          thisVars: ["this_s"],
          body: "return this_s"
        },
        funcName: "sum"
      }), r.prod = n({
        args: ["array"],
        pre: {
          args: [],
          localVars: [],
          thisVars: ["this_s"],
          body: "this_s=1"
        },
        body: {
          args: [{
            name: "a",
            lvalue: !1,
            rvalue: !0,
            count: 1
          }],
          body: "this_s*=a",
          localVars: [],
          thisVars: ["this_s"]
        },
        post: {
          args: [],
          localVars: [],
          thisVars: ["this_s"],
          body: "return this_s"
        },
        funcName: "prod"
      }), r.norm2squared = n({
        args: ["array"],
        pre: {
          args: [],
          localVars: [],
          thisVars: ["this_s"],
          body: "this_s=0"
        },
        body: {
          args: [{
            name: "a",
            lvalue: !1,
            rvalue: !0,
            count: 2
          }],
          body: "this_s+=a*a",
          localVars: [],
          thisVars: ["this_s"]
        },
        post: {
          args: [],
          localVars: [],
          thisVars: ["this_s"],
          body: "return this_s"
        },
        funcName: "norm2squared"
      }), r.norm2 = n({
        args: ["array"],
        pre: {
          args: [],
          localVars: [],
          thisVars: ["this_s"],
          body: "this_s=0"
        },
        body: {
          args: [{
            name: "a",
            lvalue: !1,
            rvalue: !0,
            count: 2
          }],
          body: "this_s+=a*a",
          localVars: [],
          thisVars: ["this_s"]
        },
        post: {
          args: [],
          localVars: [],
          thisVars: ["this_s"],
          body: "return Math.sqrt(this_s)"
        },
        funcName: "norm2"
      }), r.norminf = n({
        args: ["array"],
        pre: {
          args: [],
          localVars: [],
          thisVars: ["this_s"],
          body: "this_s=0"
        },
        body: {
          args: [{
            name: "a",
            lvalue: !1,
            rvalue: !0,
            count: 4
          }],
          body: "if(-a>this_s){this_s=-a}else if(a>this_s){this_s=a}",
          localVars: [],
          thisVars: ["this_s"]
        },
        post: {
          args: [],
          localVars: [],
          thisVars: ["this_s"],
          body: "return this_s"
        },
        funcName: "norminf"
      }), r.norm1 = n({
        args: ["array"],
        pre: {
          args: [],
          localVars: [],
          thisVars: ["this_s"],
          body: "this_s=0"
        },
        body: {
          args: [{
            name: "a",
            lvalue: !1,
            rvalue: !0,
            count: 3
          }],
          body: "this_s+=a<0?-a:a",
          localVars: [],
          thisVars: ["this_s"]
        },
        post: {
          args: [],
          localVars: [],
          thisVars: ["this_s"],
          body: "return this_s"
        },
        funcName: "norm1"
      }), r.sup = n({
        args: ["array"],
        pre: {
          body: "this_h=-Infinity",
          args: [],
          thisVars: ["this_h"],
          localVars: []
        },
        body: {
          body: "if(_inline_1_arg0_>this_h)this_h=_inline_1_arg0_",
          args: [{
            name: "_inline_1_arg0_",
            lvalue: !1,
            rvalue: !0,
            count: 2
          }],
          thisVars: ["this_h"],
          localVars: []
        },
        post: {
          body: "return this_h",
          args: [],
          thisVars: ["this_h"],
          localVars: []
        }
      }), r.inf = n({
        args: ["array"],
        pre: {
          body: "this_h=Infinity",
          args: [],
          thisVars: ["this_h"],
          localVars: []
        },
        body: {
          body: "if(_inline_1_arg0_<this_h)this_h=_inline_1_arg0_",
          args: [{
            name: "_inline_1_arg0_",
            lvalue: !1,
            rvalue: !0,
            count: 2
          }],
          thisVars: ["this_h"],
          localVars: []
        },
        post: {
          body: "return this_h",
          args: [],
          thisVars: ["this_h"],
          localVars: []
        }
      }), r.argmin = n({
        args: ["index", "array", "shape"],
        pre: {
          body: "{this_v=Infinity;this_i=_inline_0_arg2_.slice(0)}",
          args: [{
            name: "_inline_0_arg0_",
            lvalue: !1,
            rvalue: !1,
            count: 0
          }, {
            name: "_inline_0_arg1_",
            lvalue: !1,
            rvalue: !1,
            count: 0
          }, {
            name: "_inline_0_arg2_",
            lvalue: !1,
            rvalue: !0,
            count: 1
          }],
          thisVars: ["this_i", "this_v"],
          localVars: []
        },
        body: {
          body: "{if(_inline_1_arg1_<this_v){this_v=_inline_1_arg1_;for(var _inline_1_k=0;_inline_1_k<_inline_1_arg0_.length;++_inline_1_k){this_i[_inline_1_k]=_inline_1_arg0_[_inline_1_k]}}}",
          args: [{
            name: "_inline_1_arg0_",
            lvalue: !1,
            rvalue: !0,
            count: 2
          }, {
            name: "_inline_1_arg1_",
            lvalue: !1,
            rvalue: !0,
            count: 2
          }],
          thisVars: ["this_i", "this_v"],
          localVars: ["_inline_1_k"]
        },
        post: {
          body: "{return this_i}",
          args: [],
          thisVars: ["this_i"],
          localVars: []
        }
      }), r.argmax = n({
        args: ["index", "array", "shape"],
        pre: {
          body: "{this_v=-Infinity;this_i=_inline_0_arg2_.slice(0)}",
          args: [{
            name: "_inline_0_arg0_",
            lvalue: !1,
            rvalue: !1,
            count: 0
          }, {
            name: "_inline_0_arg1_",
            lvalue: !1,
            rvalue: !1,
            count: 0
          }, {
            name: "_inline_0_arg2_",
            lvalue: !1,
            rvalue: !0,
            count: 1
          }],
          thisVars: ["this_i", "this_v"],
          localVars: []
        },
        body: {
          body: "{if(_inline_1_arg1_>this_v){this_v=_inline_1_arg1_;for(var _inline_1_k=0;_inline_1_k<_inline_1_arg0_.length;++_inline_1_k){this_i[_inline_1_k]=_inline_1_arg0_[_inline_1_k]}}}",
          args: [{
            name: "_inline_1_arg0_",
            lvalue: !1,
            rvalue: !0,
            count: 2
          }, {
            name: "_inline_1_arg1_",
            lvalue: !1,
            rvalue: !0,
            count: 2
          }],
          thisVars: ["this_i", "this_v"],
          localVars: ["_inline_1_k"]
        },
        post: {
          body: "{return this_i}",
          args: [],
          thisVars: ["this_i"],
          localVars: []
        }
      }), r.random = o({
        args: ["array"],
        pre: {
          args: [],
          body: "this_f=Math.random",
          thisVars: ["this_f"]
        },
        body: {
          args: ["a"],
          body: "a=this_f()",
          thisVars: ["this_f"]
        },
        funcName: "random"
      }), r.assign = o({
        args: ["array", "array"],
        body: {
          args: ["a", "b"],
          body: "a=b"
        },
        funcName: "assign"
      }), r.assigns = o({
        args: ["array", "scalar"],
        body: {
          args: ["a", "b"],
          body: "a=b"
        },
        funcName: "assigns"
      }), r.equals = n({
        args: ["array", "array"],
        pre: i,
        body: {
          args: [{
            name: "x",
            lvalue: !1,
            rvalue: !0,
            count: 1
          }, {
            name: "y",
            lvalue: !1,
            rvalue: !0,
            count: 1
          }],
          body: "if(x!==y){return false}",
          localVars: [],
          thisVars: []
        },
        post: {
          args: [],
          localVars: [],
          thisVars: [],
          body: "return true"
        },
        funcName: "equals"
      });
    }, {
      "cwise-compiler": 152
    }],
    471: [function (t, e, r) {
      "use strict";

      var n = t("ndarray"),
          i = t("./doConvert.js");

      e.exports = function (t, e) {
        for (var r = [], a = t, o = 1; Array.isArray(a);) {
          r.push(a.length), o *= a.length, a = a[0];
        }

        return 0 === r.length ? n() : (e || (e = n(new Float64Array(o), r)), i(e, t), e);
      };
    }, {
      "./doConvert.js": 472,
      ndarray: 475
    }],
    472: [function (t, e, r) {
      e.exports = t("cwise-compiler")({
        args: ["array", "scalar", "index"],
        pre: {
          body: "{}",
          args: [],
          thisVars: [],
          localVars: []
        },
        body: {
          body: "{\nvar _inline_1_v=_inline_1_arg1_,_inline_1_i\nfor(_inline_1_i=0;_inline_1_i<_inline_1_arg2_.length-1;++_inline_1_i) {\n_inline_1_v=_inline_1_v[_inline_1_arg2_[_inline_1_i]]\n}\n_inline_1_arg0_=_inline_1_v[_inline_1_arg2_[_inline_1_arg2_.length-1]]\n}",
          args: [{
            name: "_inline_1_arg0_",
            lvalue: !0,
            rvalue: !1,
            count: 1
          }, {
            name: "_inline_1_arg1_",
            lvalue: !1,
            rvalue: !0,
            count: 1
          }, {
            name: "_inline_1_arg2_",
            lvalue: !1,
            rvalue: !0,
            count: 4
          }],
          thisVars: [],
          localVars: ["_inline_1_i", "_inline_1_v"]
        },
        post: {
          body: "{}",
          args: [],
          thisVars: [],
          localVars: []
        },
        funcName: "convert",
        blockSize: 64
      });
    }, {
      "cwise-compiler": 152
    }],
    473: [function (t, e, r) {
      "use strict";

      var n = t("typedarray-pool"),
          i = 32;

      function a(t) {
        switch (t) {
          case "uint8":
            return [n.mallocUint8, n.freeUint8];

          case "uint16":
            return [n.mallocUint16, n.freeUint16];

          case "uint32":
            return [n.mallocUint32, n.freeUint32];

          case "int8":
            return [n.mallocInt8, n.freeInt8];

          case "int16":
            return [n.mallocInt16, n.freeInt16];

          case "int32":
            return [n.mallocInt32, n.freeInt32];

          case "float32":
            return [n.mallocFloat, n.freeFloat];

          case "float64":
            return [n.mallocDouble, n.freeDouble];

          default:
            return null;
        }
      }

      function o(t) {
        for (var e = [], r = 0; r < t; ++r) {
          e.push("s" + r);
        }

        for (r = 0; r < t; ++r) {
          e.push("n" + r);
        }

        for (r = 1; r < t; ++r) {
          e.push("d" + r);
        }

        for (r = 1; r < t; ++r) {
          e.push("e" + r);
        }

        for (r = 1; r < t; ++r) {
          e.push("f" + r);
        }

        return e;
      }

      e.exports = function (t, e) {
        var r = ["'use strict'"],
            n = ["ndarraySortWrapper", t.join("d"), e].join("");
        r.push(["function ", n, "(", ["array"].join(","), "){"].join(""));

        for (var s = ["data=array.data,offset=array.offset|0,shape=array.shape,stride=array.stride"], l = 0; l < t.length; ++l) {
          s.push(["s", l, "=stride[", l, "]|0,n", l, "=shape[", l, "]|0"].join(""));
        }

        var c = new Array(t.length),
            u = [];

        for (l = 0; l < t.length; ++l) {
          0 !== (p = t[l]) && (0 === u.length ? c[p] = "1" : c[p] = u.join("*"), u.push("n" + p));
        }

        var f = -1,
            h = -1;

        for (l = 0; l < t.length; ++l) {
          var p,
              d = t[l];
          0 !== d && (f > 0 ? s.push(["d", d, "=s", d, "-d", f, "*n", f].join("")) : s.push(["d", d, "=s", d].join("")), f = d), 0 !== (p = t.length - 1 - l) && (h > 0 ? s.push(["e", p, "=s", p, "-e", h, "*n", h, ",f", p, "=", c[p], "-f", h, "*n", h].join("")) : s.push(["e", p, "=s", p, ",f", p, "=", c[p]].join("")), h = p);
        }

        r.push("var " + s.join(","));
        var m = ["0", "n0-1", "data", "offset"].concat(o(t.length));
        r.push(["if(n0<=", i, "){", "insertionSort(", m.join(","), ")}else{", "quickSort(", m.join(","), ")}"].join("")), r.push("}return " + n);

        var g = new Function("insertionSort", "quickSort", r.join("\n")),
            v = function (t, e) {
          var r = ["'use strict'"],
              n = ["ndarrayInsertionSort", t.join("d"), e].join(""),
              i = ["left", "right", "data", "offset"].concat(o(t.length)),
              s = a(e),
              l = ["i,j,cptr,ptr=left*s0+offset"];

          if (t.length > 1) {
            for (var c = [], u = 1; u < t.length; ++u) {
              l.push("i" + u), c.push("n" + u);
            }

            s ? l.push("scratch=malloc(" + c.join("*") + ")") : l.push("scratch=new Array(" + c.join("*") + ")"), l.push("dptr", "sptr", "a", "b");
          } else l.push("scratch");

          function f(t) {
            return "generic" === e ? ["data.get(", t, ")"].join("") : ["data[", t, "]"].join("");
          }

          function h(t, r) {
            return "generic" === e ? ["data.set(", t, ",", r, ")"].join("") : ["data[", t, "]=", r].join("");
          }

          if (r.push(["function ", n, "(", i.join(","), "){var ", l.join(",")].join(""), "for(i=left+1;i<=right;++i){", "j=i;ptr+=s0", "cptr=ptr"), t.length > 1) {
            r.push("dptr=0;sptr=ptr");

            for (u = t.length - 1; u >= 0; --u) {
              0 !== (p = t[u]) && r.push(["for(i", p, "=0;i", p, "<n", p, ";++i", p, "){"].join(""));
            }

            r.push("scratch[dptr++]=", f("sptr"));

            for (u = 0; u < t.length; ++u) {
              0 !== (p = t[u]) && r.push("sptr+=d" + p, "}");
            }

            r.push("__g:while(j--\x3eleft){", "dptr=0", "sptr=cptr-s0");

            for (u = 1; u < t.length; ++u) {
              1 === u && r.push("__l:"), r.push(["for(i", u, "=0;i", u, "<n", u, ";++i", u, "){"].join(""));
            }

            r.push(["a=", f("sptr"), "\nb=scratch[dptr]\nif(a<b){break __g}\nif(a>b){break __l}"].join(""));

            for (u = t.length - 1; u >= 1; --u) {
              r.push("sptr+=e" + u, "dptr+=f" + u, "}");
            }

            r.push("dptr=cptr;sptr=cptr-s0");

            for (u = t.length - 1; u >= 0; --u) {
              0 !== (p = t[u]) && r.push(["for(i", p, "=0;i", p, "<n", p, ";++i", p, "){"].join(""));
            }

            r.push(h("dptr", f("sptr")));

            for (u = 0; u < t.length; ++u) {
              0 !== (p = t[u]) && r.push(["dptr+=d", p, ";sptr+=d", p].join(""), "}");
            }

            r.push("cptr-=s0\n}"), r.push("dptr=cptr;sptr=0");

            for (u = t.length - 1; u >= 0; --u) {
              0 !== (p = t[u]) && r.push(["for(i", p, "=0;i", p, "<n", p, ";++i", p, "){"].join(""));
            }

            r.push(h("dptr", "scratch[sptr++]"));

            for (u = 0; u < t.length; ++u) {
              var p;
              0 !== (p = t[u]) && r.push("dptr+=d" + p, "}");
            }
          } else r.push("scratch=" + f("ptr"), "while((j--\x3eleft)&&(" + f("cptr-s0") + ">scratch)){", h("cptr", f("cptr-s0")), "cptr-=s0", "}", h("cptr", "scratch"));

          return r.push("}"), t.length > 1 && s && r.push("free(scratch)"), r.push("} return " + n), s ? new Function("malloc", "free", r.join("\n"))(s[0], s[1]) : new Function(r.join("\n"))();
        }(t, e),
            y = function (t, e, r) {
          var n = ["'use strict'"],
              s = ["ndarrayQuickSort", t.join("d"), e].join(""),
              l = ["left", "right", "data", "offset"].concat(o(t.length)),
              c = a(e),
              u = 0;
          n.push(["function ", s, "(", l.join(","), "){"].join(""));
          var f = ["sixth=((right-left+1)/6)|0", "index1=left+sixth", "index5=right-sixth", "index3=(left+right)>>1", "index2=index3-sixth", "index4=index3+sixth", "el1=index1", "el2=index2", "el3=index3", "el4=index4", "el5=index5", "less=left+1", "great=right-1", "pivots_are_equal=true", "tmp", "tmp0", "x", "y", "z", "k", "ptr0", "ptr1", "ptr2", "comp_pivot1=0", "comp_pivot2=0", "comp=0"];

          if (t.length > 1) {
            for (var h = [], p = 1; p < t.length; ++p) {
              h.push("n" + p), f.push("i" + p);
            }

            for (p = 0; p < 8; ++p) {
              f.push("b_ptr" + p);
            }

            f.push("ptr3", "ptr4", "ptr5", "ptr6", "ptr7", "pivot_ptr", "ptr_shift", "elementSize=" + h.join("*")), c ? f.push("pivot1=malloc(elementSize)", "pivot2=malloc(elementSize)") : f.push("pivot1=new Array(elementSize),pivot2=new Array(elementSize)");
          } else f.push("pivot1", "pivot2");

          function d(t) {
            return ["(offset+", t, "*s0)"].join("");
          }

          function m(t) {
            return "generic" === e ? ["data.get(", t, ")"].join("") : ["data[", t, "]"].join("");
          }

          function g(t, r) {
            return "generic" === e ? ["data.set(", t, ",", r, ")"].join("") : ["data[", t, "]=", r].join("");
          }

          function v(e, r, i) {
            if (1 === e.length) n.push("ptr0=" + d(e[0]));else for (var a = 0; a < e.length; ++a) {
              n.push(["b_ptr", a, "=s0*", e[a]].join(""));
            }
            r && n.push("pivot_ptr=0"), n.push("ptr_shift=offset");

            for (a = t.length - 1; a >= 0; --a) {
              0 !== (o = t[a]) && n.push(["for(i", o, "=0;i", o, "<n", o, ";++i", o, "){"].join(""));
            }

            if (e.length > 1) for (a = 0; a < e.length; ++a) {
              n.push(["ptr", a, "=b_ptr", a, "+ptr_shift"].join(""));
            }
            n.push(i), r && n.push("++pivot_ptr");

            for (a = 0; a < t.length; ++a) {
              var o;
              0 !== (o = t[a]) && (e.length > 1 ? n.push("ptr_shift+=d" + o) : n.push("ptr0+=d" + o), n.push("}"));
            }
          }

          function y(e, r, i, a) {
            if (1 === r.length) n.push("ptr0=" + d(r[0]));else {
              for (var o = 0; o < r.length; ++o) {
                n.push(["b_ptr", o, "=s0*", r[o]].join(""));
              }

              n.push("ptr_shift=offset");
            }
            i && n.push("pivot_ptr=0"), e && n.push(e + ":");

            for (o = 1; o < t.length; ++o) {
              n.push(["for(i", o, "=0;i", o, "<n", o, ";++i", o, "){"].join(""));
            }

            if (r.length > 1) for (o = 0; o < r.length; ++o) {
              n.push(["ptr", o, "=b_ptr", o, "+ptr_shift"].join(""));
            }
            n.push(a);

            for (o = t.length - 1; o >= 1; --o) {
              i && n.push("pivot_ptr+=f" + o), r.length > 1 ? n.push("ptr_shift+=e" + o) : n.push("ptr0+=e" + o), n.push("}");
            }
          }

          function x() {
            t.length > 1 && c && n.push("free(pivot1)", "free(pivot2)");
          }

          function b(e, r) {
            var i = "el" + e,
                a = "el" + r;

            if (t.length > 1) {
              var o = "__l" + ++u;
              y(o, [i, a], !1, ["comp=", m("ptr0"), "-", m("ptr1"), "\n", "if(comp>0){tmp0=", i, ";", i, "=", a, ";", a, "=tmp0;break ", o, "}\n", "if(comp<0){break ", o, "}"].join(""));
            } else n.push(["if(", m(d(i)), ">", m(d(a)), "){tmp0=", i, ";", i, "=", a, ";", a, "=tmp0}"].join(""));
          }

          function _(e, r) {
            t.length > 1 ? v([e, r], !1, g("ptr0", m("ptr1"))) : n.push(g(d(e), m(d(r))));
          }

          function w(e, r, i) {
            if (t.length > 1) {
              var a = "__l" + ++u;
              y(a, [r], !0, [e, "=", m("ptr0"), "-pivot", i, "[pivot_ptr]\n", "if(", e, "!==0){break ", a, "}"].join(""));
            } else n.push([e, "=", m(d(r)), "-pivot", i].join(""));
          }

          function T(e, r) {
            t.length > 1 ? v([e, r], !1, ["tmp=", m("ptr0"), "\n", g("ptr0", m("ptr1")), "\n", g("ptr1", "tmp")].join("")) : n.push(["ptr0=", d(e), "\n", "ptr1=", d(r), "\n", "tmp=", m("ptr0"), "\n", g("ptr0", m("ptr1")), "\n", g("ptr1", "tmp")].join(""));
          }

          function k(e, r, i) {
            t.length > 1 ? (v([e, r, i], !1, ["tmp=", m("ptr0"), "\n", g("ptr0", m("ptr1")), "\n", g("ptr1", m("ptr2")), "\n", g("ptr2", "tmp")].join("")), n.push("++" + r, "--" + i)) : n.push(["ptr0=", d(e), "\n", "ptr1=", d(r), "\n", "ptr2=", d(i), "\n", "++", r, "\n", "--", i, "\n", "tmp=", m("ptr0"), "\n", g("ptr0", m("ptr1")), "\n", g("ptr1", m("ptr2")), "\n", g("ptr2", "tmp")].join(""));
          }

          function M(t, e) {
            T(t, e), n.push("--" + e);
          }

          function A(e, r, i) {
            t.length > 1 ? v([e, r], !0, [g("ptr0", m("ptr1")), "\n", g("ptr1", ["pivot", i, "[pivot_ptr]"].join(""))].join("")) : n.push(g(d(e), m(d(r))), g(d(r), "pivot" + i));
          }

          function S(e, r) {
            n.push(["if((", r, "-", e, ")<=", i, "){\n", "insertionSort(", e, ",", r, ",data,offset,", o(t.length).join(","), ")\n", "}else{\n", s, "(", e, ",", r, ",data,offset,", o(t.length).join(","), ")\n", "}"].join(""));
          }

          function E(e, r, i) {
            t.length > 1 ? (n.push(["__l", ++u, ":while(true){"].join("")), v([e], !0, ["if(", m("ptr0"), "!==pivot", r, "[pivot_ptr]){break __l", u, "}"].join("")), n.push(i, "}")) : n.push(["while(", m(d(e)), "===pivot", r, "){", i, "}"].join(""));
          }

          return n.push("var " + f.join(",")), b(1, 2), b(4, 5), b(1, 3), b(2, 3), b(1, 4), b(3, 4), b(2, 5), b(2, 3), b(4, 5), t.length > 1 ? v(["el1", "el2", "el3", "el4", "el5", "index1", "index3", "index5"], !0, ["pivot1[pivot_ptr]=", m("ptr1"), "\n", "pivot2[pivot_ptr]=", m("ptr3"), "\n", "pivots_are_equal=pivots_are_equal&&(pivot1[pivot_ptr]===pivot2[pivot_ptr])\n", "x=", m("ptr0"), "\n", "y=", m("ptr2"), "\n", "z=", m("ptr4"), "\n", g("ptr5", "x"), "\n", g("ptr6", "y"), "\n", g("ptr7", "z")].join("")) : n.push(["pivot1=", m(d("el2")), "\n", "pivot2=", m(d("el4")), "\n", "pivots_are_equal=pivot1===pivot2\n", "x=", m(d("el1")), "\n", "y=", m(d("el3")), "\n", "z=", m(d("el5")), "\n", g(d("index1"), "x"), "\n", g(d("index3"), "y"), "\n", g(d("index5"), "z")].join("")), _("index2", "left"), _("index4", "right"), n.push("if(pivots_are_equal){"), n.push("for(k=less;k<=great;++k){"), w("comp", "k", 1), n.push("if(comp===0){continue}"), n.push("if(comp<0){"), n.push("if(k!==less){"), T("k", "less"), n.push("}"), n.push("++less"), n.push("}else{"), n.push("while(true){"), w("comp", "great", 1), n.push("if(comp>0){"), n.push("great--"), n.push("}else if(comp<0){"), k("k", "less", "great"), n.push("break"), n.push("}else{"), M("k", "great"), n.push("break"), n.push("}"), n.push("}"), n.push("}"), n.push("}"), n.push("}else{"), n.push("for(k=less;k<=great;++k){"), w("comp_pivot1", "k", 1), n.push("if(comp_pivot1<0){"), n.push("if(k!==less){"), T("k", "less"), n.push("}"), n.push("++less"), n.push("}else{"), w("comp_pivot2", "k", 2), n.push("if(comp_pivot2>0){"), n.push("while(true){"), w("comp", "great", 2), n.push("if(comp>0){"), n.push("if(--great<k){break}"), n.push("continue"), n.push("}else{"), w("comp", "great", 1), n.push("if(comp<0){"), k("k", "less", "great"), n.push("}else{"), M("k", "great"), n.push("}"), n.push("break"), n.push("}"), n.push("}"), n.push("}"), n.push("}"), n.push("}"), n.push("}"), A("left", "(less-1)", 1), A("right", "(great+1)", 2), S("left", "(less-2)"), S("(great+2)", "right"), n.push("if(pivots_are_equal){"), x(), n.push("return"), n.push("}"), n.push("if(less<index1&&great>index5){"), E("less", 1, "++less"), E("great", 2, "--great"), n.push("for(k=less;k<=great;++k){"), w("comp_pivot1", "k", 1), n.push("if(comp_pivot1===0){"), n.push("if(k!==less){"), T("k", "less"), n.push("}"), n.push("++less"), n.push("}else{"), w("comp_pivot2", "k", 2), n.push("if(comp_pivot2===0){"), n.push("while(true){"), w("comp", "great", 2), n.push("if(comp===0){"), n.push("if(--great<k){break}"), n.push("continue"), n.push("}else{"), w("comp", "great", 1), n.push("if(comp<0){"), k("k", "less", "great"), n.push("}else{"), M("k", "great"), n.push("}"), n.push("break"), n.push("}"), n.push("}"), n.push("}"), n.push("}"), n.push("}"), n.push("}"), x(), S("less", "great"), n.push("}return " + s), t.length > 1 && c ? new Function("insertionSort", "malloc", "free", n.join("\n"))(r, c[0], c[1]) : new Function("insertionSort", n.join("\n"))(r);
        }(t, e, v);

        return g(v, y);
      };
    }, {
      "typedarray-pool": 609
    }],
    474: [function (t, e, r) {
      "use strict";

      var n = t("./lib/compile_sort.js"),
          i = {};

      e.exports = function (t) {
        var e = t.order,
            r = t.dtype,
            a = [e, r].join(":"),
            o = i[a];
        return o || (i[a] = o = n(e, r)), o(t), t;
      };
    }, {
      "./lib/compile_sort.js": 473
    }],
    475: [function (t, e, r) {
      var n = t("iota-array"),
          i = t("is-buffer"),
          a = "undefined" != typeof Float64Array;

      function o(t, e) {
        return t[0] - e[0];
      }

      function s() {
        var t,
            e = this.stride,
            r = new Array(e.length);

        for (t = 0; t < r.length; ++t) {
          r[t] = [Math.abs(e[t]), t];
        }

        r.sort(o);
        var n = new Array(r.length);

        for (t = 0; t < n.length; ++t) {
          n[t] = r[t][1];
        }

        return n;
      }

      function l(t, e) {
        var r = ["View", e, "d", t].join("");
        e < 0 && (r = "View_Nil" + t);
        var i = "generic" === t;

        if (-1 === e) {
          var a = "function " + r + "(a){this.data=a;};var proto=" + r + ".prototype;proto.dtype='" + t + "';proto.index=function(){return -1};proto.size=0;proto.dimension=-1;proto.shape=proto.stride=proto.order=[];proto.lo=proto.hi=proto.transpose=proto.step=function(){return new " + r + "(this.data);};proto.get=proto.set=function(){};proto.pick=function(){return null};return function construct_" + r + "(a){return new " + r + "(a);}";
          return new Function(a)();
        }

        if (0 === e) {
          a = "function " + r + "(a,d) {this.data = a;this.offset = d};var proto=" + r + ".prototype;proto.dtype='" + t + "';proto.index=function(){return this.offset};proto.dimension=0;proto.size=1;proto.shape=proto.stride=proto.order=[];proto.lo=proto.hi=proto.transpose=proto.step=function " + r + "_copy() {return new " + r + "(this.data,this.offset)};proto.pick=function " + r + "_pick(){return TrivialArray(this.data);};proto.valueOf=proto.get=function " + r + "_get(){return " + (i ? "this.data.get(this.offset)" : "this.data[this.offset]") + "};proto.set=function " + r + "_set(v){return " + (i ? "this.data.set(this.offset,v)" : "this.data[this.offset]=v") + "};return function construct_" + r + "(a,b,c,d){return new " + r + "(a,d)}";
          return new Function("TrivialArray", a)(c[t][0]);
        }

        a = ["'use strict'"];
        var o = n(e),
            l = o.map(function (t) {
          return "i" + t;
        }),
            u = "this.offset+" + o.map(function (t) {
          return "this.stride[" + t + "]*i" + t;
        }).join("+"),
            f = o.map(function (t) {
          return "b" + t;
        }).join(","),
            h = o.map(function (t) {
          return "c" + t;
        }).join(",");
        a.push("function " + r + "(a," + f + "," + h + ",d){this.data=a", "this.shape=[" + f + "]", "this.stride=[" + h + "]", "this.offset=d|0}", "var proto=" + r + ".prototype", "proto.dtype='" + t + "'", "proto.dimension=" + e), a.push("Object.defineProperty(proto,'size',{get:function " + r + "_size(){return " + o.map(function (t) {
          return "this.shape[" + t + "]";
        }).join("*"), "}})"), 1 === e ? a.push("proto.order=[0]") : (a.push("Object.defineProperty(proto,'order',{get:"), e < 4 ? (a.push("function " + r + "_order(){"), 2 === e ? a.push("return (Math.abs(this.stride[0])>Math.abs(this.stride[1]))?[1,0]:[0,1]}})") : 3 === e && a.push("var s0=Math.abs(this.stride[0]),s1=Math.abs(this.stride[1]),s2=Math.abs(this.stride[2]);if(s0>s1){if(s1>s2){return [2,1,0];}else if(s0>s2){return [1,2,0];}else{return [1,0,2];}}else if(s0>s2){return [2,0,1];}else if(s2>s1){return [0,1,2];}else{return [0,2,1];}}})")) : a.push("ORDER})")), a.push("proto.set=function " + r + "_set(" + l.join(",") + ",v){"), i ? a.push("return this.data.set(" + u + ",v)}") : a.push("return this.data[" + u + "]=v}"), a.push("proto.get=function " + r + "_get(" + l.join(",") + "){"), i ? a.push("return this.data.get(" + u + ")}") : a.push("return this.data[" + u + "]}"), a.push("proto.index=function " + r + "_index(", l.join(), "){return " + u + "}"), a.push("proto.hi=function " + r + "_hi(" + l.join(",") + "){return new " + r + "(this.data," + o.map(function (t) {
          return ["(typeof i", t, "!=='number'||i", t, "<0)?this.shape[", t, "]:i", t, "|0"].join("");
        }).join(",") + "," + o.map(function (t) {
          return "this.stride[" + t + "]";
        }).join(",") + ",this.offset)}");
        var p = o.map(function (t) {
          return "a" + t + "=this.shape[" + t + "]";
        }),
            d = o.map(function (t) {
          return "c" + t + "=this.stride[" + t + "]";
        });
        a.push("proto.lo=function " + r + "_lo(" + l.join(",") + "){var b=this.offset,d=0," + p.join(",") + "," + d.join(","));

        for (var m = 0; m < e; ++m) {
          a.push("if(typeof i" + m + "==='number'&&i" + m + ">=0){d=i" + m + "|0;b+=c" + m + "*d;a" + m + "-=d}");
        }

        a.push("return new " + r + "(this.data," + o.map(function (t) {
          return "a" + t;
        }).join(",") + "," + o.map(function (t) {
          return "c" + t;
        }).join(",") + ",b)}"), a.push("proto.step=function " + r + "_step(" + l.join(",") + "){var " + o.map(function (t) {
          return "a" + t + "=this.shape[" + t + "]";
        }).join(",") + "," + o.map(function (t) {
          return "b" + t + "=this.stride[" + t + "]";
        }).join(",") + ",c=this.offset,d=0,ceil=Math.ceil");

        for (m = 0; m < e; ++m) {
          a.push("if(typeof i" + m + "==='number'){d=i" + m + "|0;if(d<0){c+=b" + m + "*(a" + m + "-1);a" + m + "=ceil(-a" + m + "/d)}else{a" + m + "=ceil(a" + m + "/d)}b" + m + "*=d}");
        }

        a.push("return new " + r + "(this.data," + o.map(function (t) {
          return "a" + t;
        }).join(",") + "," + o.map(function (t) {
          return "b" + t;
        }).join(",") + ",c)}");
        var g = new Array(e),
            v = new Array(e);

        for (m = 0; m < e; ++m) {
          g[m] = "a[i" + m + "]", v[m] = "b[i" + m + "]";
        }

        a.push("proto.transpose=function " + r + "_transpose(" + l + "){" + l.map(function (t, e) {
          return t + "=(" + t + "===undefined?" + e + ":" + t + "|0)";
        }).join(";"), "var a=this.shape,b=this.stride;return new " + r + "(this.data," + g.join(",") + "," + v.join(",") + ",this.offset)}"), a.push("proto.pick=function " + r + "_pick(" + l + "){var a=[],b=[],c=this.offset");

        for (m = 0; m < e; ++m) {
          a.push("if(typeof i" + m + "==='number'&&i" + m + ">=0){c=(c+this.stride[" + m + "]*i" + m + ")|0}else{a.push(this.shape[" + m + "]);b.push(this.stride[" + m + "])}");
        }

        return a.push("var ctor=CTOR_LIST[a.length+1];return ctor(this.data,a,b,c)}"), a.push("return function construct_" + r + "(data,shape,stride,offset){return new " + r + "(data," + o.map(function (t) {
          return "shape[" + t + "]";
        }).join(",") + "," + o.map(function (t) {
          return "stride[" + t + "]";
        }).join(",") + ",offset)}"), new Function("CTOR_LIST", "ORDER", a.join("\n"))(c[t], s);
      }

      var c = {
        float32: [],
        float64: [],
        int8: [],
        int16: [],
        int32: [],
        uint8: [],
        uint16: [],
        uint32: [],
        array: [],
        uint8_clamped: [],
        bigint64: [],
        biguint64: [],
        buffer: [],
        generic: []
      };

      e.exports = function (t, e, r, n) {
        if (void 0 === t) return (0, c.array[0])([]);
        "number" == typeof t && (t = [t]), void 0 === e && (e = [t.length]);
        var o = e.length;

        if (void 0 === r) {
          r = new Array(o);

          for (var s = o - 1, u = 1; s >= 0; --s) {
            r[s] = u, u *= e[s];
          }
        }

        if (void 0 === n) {
          n = 0;

          for (s = 0; s < o; ++s) {
            r[s] < 0 && (n -= (e[s] - 1) * r[s]);
          }
        }

        for (var f = function (t) {
          if (i(t)) return "buffer";
          if (a) switch (Object.prototype.toString.call(t)) {
            case "[object Float64Array]":
              return "float64";

            case "[object Float32Array]":
              return "float32";

            case "[object Int8Array]":
              return "int8";

            case "[object Int16Array]":
              return "int16";

            case "[object Int32Array]":
              return "int32";

            case "[object Uint8Array]":
              return "uint8";

            case "[object Uint16Array]":
              return "uint16";

            case "[object Uint32Array]":
              return "uint32";

            case "[object Uint8ClampedArray]":
              return "uint8_clamped";

            case "[object BigInt64Array]":
              return "bigint64";

            case "[object BigUint64Array]":
              return "biguint64";
          }
          return Array.isArray(t) ? "array" : "generic";
        }(t), h = c[f]; h.length <= o + 1;) {
          h.push(l(f, h.length - 1));
        }

        return (0, h[o + 1])(t, e, r, n);
      };
    }, {
      "iota-array": 442,
      "is-buffer": 444
    }],
    476: [function (t, e, r) {
      "use strict";

      var n = t("double-bits"),
          i = Math.pow(2, -1074);

      e.exports = function (t, e) {
        if (isNaN(t) || isNaN(e)) return NaN;
        if (t === e) return t;
        if (0 === t) return e < 0 ? -i : i;
        var r = n.hi(t),
            a = n.lo(t);
        e > t == t > 0 ? a === -1 >>> 0 ? (r += 1, a = 0) : a += 1 : 0 === a ? (a = -1 >>> 0, r -= 1) : a -= 1;
        return n.pack(a, r);
      };
    }, {
      "double-bits": 173
    }],
    477: [function (t, e, r) {
      var n = Math.PI,
          i = c(120);

      function a(t, e, r, n) {
        return ["C", t, e, r, n, r, n];
      }

      function o(t, e, r, n, i, a) {
        return ["C", t / 3 + 2 / 3 * r, e / 3 + 2 / 3 * n, i / 3 + 2 / 3 * r, a / 3 + 2 / 3 * n, i, a];
      }

      function s(t, e, r, a, o, c, u, f, h, p) {
        if (p) T = p[0], k = p[1], _ = p[2], w = p[3];else {
          var d = l(t, e, -o);
          t = d.x, e = d.y;
          var m = (t - (f = (d = l(f, h, -o)).x)) / 2,
              g = (e - (h = d.y)) / 2,
              v = m * m / (r * r) + g * g / (a * a);
          v > 1 && (r *= v = Math.sqrt(v), a *= v);
          var y = r * r,
              x = a * a,
              b = (c == u ? -1 : 1) * Math.sqrt(Math.abs((y * x - y * g * g - x * m * m) / (y * g * g + x * m * m)));
          b == 1 / 0 && (b = 1);

          var _ = b * r * g / a + (t + f) / 2,
              w = b * -a * m / r + (e + h) / 2,
              T = Math.asin(((e - w) / a).toFixed(9)),
              k = Math.asin(((h - w) / a).toFixed(9));

          (T = t < _ ? n - T : T) < 0 && (T = 2 * n + T), (k = f < _ ? n - k : k) < 0 && (k = 2 * n + k), u && T > k && (T -= 2 * n), !u && k > T && (k -= 2 * n);
        }

        if (Math.abs(k - T) > i) {
          var M = k,
              A = f,
              S = h;
          k = T + i * (u && k > T ? 1 : -1);
          var E = s(f = _ + r * Math.cos(k), h = w + a * Math.sin(k), r, a, o, 0, u, A, S, [k, M, _, w]);
        }

        var L = Math.tan((k - T) / 4),
            C = 4 / 3 * r * L,
            P = 4 / 3 * a * L,
            I = [2 * t - (t + C * Math.sin(T)), 2 * e - (e - P * Math.cos(T)), f + C * Math.sin(k), h - P * Math.cos(k), f, h];
        if (p) return I;
        E && (I = I.concat(E));

        for (var O = 0; O < I.length;) {
          var z = l(I[O], I[O + 1], o);
          I[O++] = z.x, I[O++] = z.y;
        }

        return I;
      }

      function l(t, e, r) {
        return {
          x: t * Math.cos(r) - e * Math.sin(r),
          y: t * Math.sin(r) + e * Math.cos(r)
        };
      }

      function c(t) {
        return t * (n / 180);
      }

      e.exports = function (t) {
        for (var e, r = [], n = 0, i = 0, l = 0, u = 0, f = null, h = null, p = 0, d = 0, m = 0, g = t.length; m < g; m++) {
          var v = t[m],
              y = v[0];

          switch (y) {
            case "M":
              l = v[1], u = v[2];
              break;

            case "A":
              (v = s(p, d, v[1], v[2], c(v[3]), v[4], v[5], v[6], v[7])).unshift("C"), v.length > 7 && (r.push(v.splice(0, 7)), v.unshift("C"));
              break;

            case "S":
              var x = p,
                  b = d;
              "C" != e && "S" != e || (x += x - n, b += b - i), v = ["C", x, b, v[1], v[2], v[3], v[4]];
              break;

            case "T":
              "Q" == e || "T" == e ? (f = 2 * p - f, h = 2 * d - h) : (f = p, h = d), v = o(p, d, f, h, v[1], v[2]);
              break;

            case "Q":
              f = v[1], h = v[2], v = o(p, d, v[1], v[2], v[3], v[4]);
              break;

            case "L":
              v = a(p, d, v[1], v[2]);
              break;

            case "H":
              v = a(p, d, v[1], d);
              break;

            case "V":
              v = a(p, d, p, v[1]);
              break;

            case "Z":
              v = a(p, d, l, u);
          }

          e = y, p = v[v.length - 2], d = v[v.length - 1], v.length > 4 ? (n = v[v.length - 4], i = v[v.length - 3]) : (n = p, i = d), r.push(v);
        }

        return r;
      };
    }, {}],
    478: [function (t, e, r) {
      r.vertexNormals = function (t, e, r) {
        for (var n = e.length, i = new Array(n), a = void 0 === r ? 1e-6 : r, o = 0; o < n; ++o) {
          i[o] = [0, 0, 0];
        }

        for (o = 0; o < t.length; ++o) {
          for (var s = t[o], l = 0, c = s[s.length - 1], u = s[0], f = 0; f < s.length; ++f) {
            l = c, c = u, u = s[(f + 1) % s.length];

            for (var h = e[l], p = e[c], d = e[u], m = new Array(3), g = 0, v = new Array(3), y = 0, x = 0; x < 3; ++x) {
              m[x] = h[x] - p[x], g += m[x] * m[x], v[x] = d[x] - p[x], y += v[x] * v[x];
            }

            if (g * y > a) {
              var b = i[c],
                  _ = 1 / Math.sqrt(g * y);

              for (x = 0; x < 3; ++x) {
                var w = (x + 1) % 3,
                    T = (x + 2) % 3;
                b[x] += _ * (v[w] * m[T] - v[T] * m[w]);
              }
            }
          }
        }

        for (o = 0; o < n; ++o) {
          b = i[o];
          var k = 0;

          for (x = 0; x < 3; ++x) {
            k += b[x] * b[x];
          }

          if (k > a) for (_ = 1 / Math.sqrt(k), x = 0; x < 3; ++x) {
            b[x] *= _;
          } else for (x = 0; x < 3; ++x) {
            b[x] = 0;
          }
        }

        return i;
      }, r.faceNormals = function (t, e, r) {
        for (var n = t.length, i = new Array(n), a = void 0 === r ? 1e-6 : r, o = 0; o < n; ++o) {
          for (var s = t[o], l = new Array(3), c = 0; c < 3; ++c) {
            l[c] = e[s[c]];
          }

          var u = new Array(3),
              f = new Array(3);

          for (c = 0; c < 3; ++c) {
            u[c] = l[1][c] - l[0][c], f[c] = l[2][c] - l[0][c];
          }

          var h = new Array(3),
              p = 0;

          for (c = 0; c < 3; ++c) {
            var d = (c + 1) % 3,
                m = (c + 2) % 3;
            h[c] = u[d] * f[m] - u[m] * f[d], p += h[c] * h[c];
          }

          p = p > a ? 1 / Math.sqrt(p) : 0;

          for (c = 0; c < 3; ++c) {
            h[c] *= p;
          }

          i[o] = h;
        }

        return i;
      };
    }, {}],
    479: [function (t, e, r) {
      /*
      object-assign
      (c) Sindre Sorhus
      @license MIT
      */
      "use strict";

      var n = Object.getOwnPropertySymbols,
          i = Object.prototype.hasOwnProperty,
          a = Object.prototype.propertyIsEnumerable;

      function o(t) {
        if (null == t) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(t);
      }

      e.exports = function () {
        try {
          if (!Object.assign) return !1;
          var t = new String("abc");
          if (t[5] = "de", "5" === Object.getOwnPropertyNames(t)[0]) return !1;

          for (var e = {}, r = 0; r < 10; r++) {
            e["_" + String.fromCharCode(r)] = r;
          }

          if ("0123456789" !== Object.getOwnPropertyNames(e).map(function (t) {
            return e[t];
          }).join("")) return !1;
          var n = {};
          return "abcdefghijklmnopqrst".split("").forEach(function (t) {
            n[t] = t;
          }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
        } catch (t) {
          return !1;
        }
      }() ? Object.assign : function (t, e) {
        for (var r, s, l = o(t), c = 1; c < arguments.length; c++) {
          for (var u in r = Object(arguments[c])) {
            i.call(r, u) && (l[u] = r[u]);
          }

          if (n) {
            s = n(r);

            for (var f = 0; f < s.length; f++) {
              a.call(r, s[f]) && (l[s[f]] = r[s[f]]);
            }
          }
        }

        return l;
      };
    }, {}],
    480: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, n, i, a, o, s, l, c) {
        var u = e + a + c;

        if (f > 0) {
          var f = Math.sqrt(u + 1);
          t[0] = .5 * (o - l) / f, t[1] = .5 * (s - n) / f, t[2] = .5 * (r - a) / f, t[3] = .5 * f;
        } else {
          var h = Math.max(e, a, c);
          f = Math.sqrt(2 * h - u + 1);
          e >= h ? (t[0] = .5 * f, t[1] = .5 * (i + r) / f, t[2] = .5 * (s + n) / f, t[3] = .5 * (o - l) / f) : a >= h ? (t[0] = .5 * (r + i) / f, t[1] = .5 * f, t[2] = .5 * (l + o) / f, t[3] = .5 * (s - n) / f) : (t[0] = .5 * (n + s) / f, t[1] = .5 * (o + l) / f, t[2] = .5 * f, t[3] = .5 * (r - i) / f);
        }

        return t;
      };
    }, {}],
    481: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        var e = (t = t || {}).center || [0, 0, 0],
            r = t.rotation || [0, 0, 0, 1],
            n = t.radius || 1;
        e = [].slice.call(e, 0, 3), u(r = [].slice.call(r, 0, 4), r);
        var i = new f(r, e, Math.log(n));
        i.setDistanceLimits(t.zoomMin, t.zoomMax), ("eye" in t || "up" in t) && i.lookAt(0, t.eye, t.center, t.up);
        return i;
      };

      var n = t("filtered-vector"),
          i = t("gl-mat4/lookAt"),
          a = t("gl-mat4/fromQuat"),
          o = t("gl-mat4/invert"),
          s = t("./lib/quatFromFrame");

      function l(t, e, r) {
        return Math.sqrt(Math.pow(t, 2) + Math.pow(e, 2) + Math.pow(r, 2));
      }

      function c(t, e, r, n) {
        return Math.sqrt(Math.pow(t, 2) + Math.pow(e, 2) + Math.pow(r, 2) + Math.pow(n, 2));
      }

      function u(t, e) {
        var r = e[0],
            n = e[1],
            i = e[2],
            a = e[3],
            o = c(r, n, i, a);
        o > 1e-6 ? (t[0] = r / o, t[1] = n / o, t[2] = i / o, t[3] = a / o) : (t[0] = t[1] = t[2] = 0, t[3] = 1);
      }

      function f(t, e, r) {
        this.radius = n([r]), this.center = n(e), this.rotation = n(t), this.computedRadius = this.radius.curve(0), this.computedCenter = this.center.curve(0), this.computedRotation = this.rotation.curve(0), this.computedUp = [.1, 0, 0], this.computedEye = [.1, 0, 0], this.computedMatrix = [.1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], this.recalcMatrix(0);
      }

      var h = f.prototype;
      h.lastT = function () {
        return Math.max(this.radius.lastT(), this.center.lastT(), this.rotation.lastT());
      }, h.recalcMatrix = function (t) {
        this.radius.curve(t), this.center.curve(t), this.rotation.curve(t);
        var e = this.computedRotation;
        u(e, e);
        var r = this.computedMatrix;
        a(r, e);
        var n = this.computedCenter,
            i = this.computedEye,
            o = this.computedUp,
            s = Math.exp(this.computedRadius[0]);
        i[0] = n[0] + s * r[2], i[1] = n[1] + s * r[6], i[2] = n[2] + s * r[10], o[0] = r[1], o[1] = r[5], o[2] = r[9];

        for (var l = 0; l < 3; ++l) {
          for (var c = 0, f = 0; f < 3; ++f) {
            c += r[l + 4 * f] * i[f];
          }

          r[12 + l] = -c;
        }
      }, h.getMatrix = function (t, e) {
        this.recalcMatrix(t);
        var r = this.computedMatrix;

        if (e) {
          for (var n = 0; n < 16; ++n) {
            e[n] = r[n];
          }

          return e;
        }

        return r;
      }, h.idle = function (t) {
        this.center.idle(t), this.radius.idle(t), this.rotation.idle(t);
      }, h.flush = function (t) {
        this.center.flush(t), this.radius.flush(t), this.rotation.flush(t);
      }, h.pan = function (t, e, r, n) {
        e = e || 0, r = r || 0, n = n || 0, this.recalcMatrix(t);
        var i = this.computedMatrix,
            a = i[1],
            o = i[5],
            s = i[9],
            c = l(a, o, s);
        a /= c, o /= c, s /= c;
        var u = i[0],
            f = i[4],
            h = i[8],
            p = u * a + f * o + h * s,
            d = l(u -= a * p, f -= o * p, h -= s * p);
        u /= d, f /= d, h /= d;
        var m = i[2],
            g = i[6],
            v = i[10],
            y = m * a + g * o + v * s,
            x = m * u + g * f + v * h,
            b = l(m -= y * a + x * u, g -= y * o + x * f, v -= y * s + x * h);
        m /= b, g /= b, v /= b;

        var _ = u * e + a * r,
            w = f * e + o * r,
            T = h * e + s * r;

        this.center.move(t, _, w, T);
        var k = Math.exp(this.computedRadius[0]);
        k = Math.max(1e-4, k + n), this.radius.set(t, Math.log(k));
      }, h.rotate = function (t, e, r, n) {
        this.recalcMatrix(t), e = e || 0, r = r || 0;

        var i = this.computedMatrix,
            a = i[0],
            o = i[4],
            s = i[8],
            u = i[1],
            f = i[5],
            h = i[9],
            p = i[2],
            d = i[6],
            m = i[10],
            g = e * a + r * u,
            v = e * o + r * f,
            y = e * s + r * h,
            x = -(d * y - m * v),
            b = -(m * g - p * y),
            _ = -(p * v - d * g),
            w = Math.sqrt(Math.max(0, 1 - Math.pow(x, 2) - Math.pow(b, 2) - Math.pow(_, 2))),
            T = c(x, b, _, w);

        T > 1e-6 ? (x /= T, b /= T, _ /= T, w /= T) : (x = b = _ = 0, w = 1);
        var k = this.computedRotation,
            M = k[0],
            A = k[1],
            S = k[2],
            E = k[3],
            L = M * w + E * x + A * _ - S * b,
            C = A * w + E * b + S * x - M * _,
            P = S * w + E * _ + M * b - A * x,
            I = E * w - M * x - A * b - S * _;

        if (n) {
          x = p, b = d, _ = m;
          var O = Math.sin(n) / l(x, b, _);
          x *= O, b *= O, _ *= O, I = I * (w = Math.cos(e)) - (L = L * w + I * x + C * _ - P * b) * x - (C = C * w + I * b + P * x - L * _) * b - (P = P * w + I * _ + L * b - C * x) * _;
        }

        var z = c(L, C, P, I);
        z > 1e-6 ? (L /= z, C /= z, P /= z, I /= z) : (L = C = P = 0, I = 1), this.rotation.set(t, L, C, P, I);
      }, h.lookAt = function (t, e, r, n) {
        this.recalcMatrix(t), r = r || this.computedCenter, e = e || this.computedEye, n = n || this.computedUp;
        var a = this.computedMatrix;
        i(a, e, r, n);
        var o = this.computedRotation;
        s(o, a[0], a[1], a[2], a[4], a[5], a[6], a[8], a[9], a[10]), u(o, o), this.rotation.set(t, o[0], o[1], o[2], o[3]);

        for (var l = 0, c = 0; c < 3; ++c) {
          l += Math.pow(r[c] - e[c], 2);
        }

        this.radius.set(t, .5 * Math.log(Math.max(l, 1e-6))), this.center.set(t, r[0], r[1], r[2]);
      }, h.translate = function (t, e, r, n) {
        this.center.move(t, e || 0, r || 0, n || 0);
      }, h.setMatrix = function (t, e) {
        var r = this.computedRotation;
        s(r, e[0], e[1], e[2], e[4], e[5], e[6], e[8], e[9], e[10]), u(r, r), this.rotation.set(t, r[0], r[1], r[2], r[3]);
        var n = this.computedMatrix;
        o(n, e);
        var i = n[15];

        if (Math.abs(i) > 1e-6) {
          var a = n[12] / i,
              l = n[13] / i,
              c = n[14] / i;
          this.recalcMatrix(t);
          var f = Math.exp(this.computedRadius[0]);
          this.center.set(t, a - n[2] * f, l - n[6] * f, c - n[10] * f), this.radius.idle(t);
        } else this.center.idle(t), this.radius.idle(t);
      }, h.setDistance = function (t, e) {
        e > 0 && this.radius.set(t, Math.log(e));
      }, h.setDistanceLimits = function (t, e) {
        t = t > 0 ? Math.log(t) : -1 / 0, e = e > 0 ? Math.log(e) : 1 / 0, e = Math.max(e, t), this.radius.bounds[0][0] = t, this.radius.bounds[1][0] = e;
      }, h.getDistanceLimits = function (t) {
        var e = this.radius.bounds;
        return t ? (t[0] = Math.exp(e[0][0]), t[1] = Math.exp(e[1][0]), t) : [Math.exp(e[0][0]), Math.exp(e[1][0])];
      }, h.toJSON = function () {
        return this.recalcMatrix(this.lastT()), {
          center: this.computedCenter.slice(),
          rotation: this.computedRotation.slice(),
          distance: Math.log(this.computedRadius[0]),
          zoomMin: this.radius.bounds[0][0],
          zoomMax: this.radius.bounds[1][0]
        };
      }, h.fromJSON = function (t) {
        var e = this.lastT(),
            r = t.center;
        r && this.center.set(e, r[0], r[1], r[2]);
        var n = t.rotation;
        n && this.rotation.set(e, n[0], n[1], n[2], n[3]);
        var i = t.distance;
        i && i > 0 && this.radius.set(e, Math.log(i)), this.setDistanceLimits(t.zoomMin, t.zoomMax);
      };
    }, {
      "./lib/quatFromFrame": 480,
      "filtered-vector": 241,
      "gl-mat4/fromQuat": 279,
      "gl-mat4/invert": 290,
      "gl-mat4/lookAt": 291
    }],
    482: [function (t, e, r) {
      /*!
       * pad-left <https://github.com/jonschlinkert/pad-left>
       *
       * Copyright (c) 2014-2015, Jon Schlinkert.
       * Licensed under the MIT license.
       */
      "use strict";

      var n = t("repeat-string");

      e.exports = function (t, e, r) {
        return n(r = void 0 !== r ? r + "" : " ", e) + t;
      };
    }, {
      "repeat-string": 533
    }],
    483: [function (t, e, r) {
      "use strict";

      function n(t, e) {
        if ("string" != typeof t) return [t];
        var r = [t];
        "string" == typeof e || Array.isArray(e) ? e = {
          brackets: e
        } : e || (e = {});
        var n = e.brackets ? Array.isArray(e.brackets) ? e.brackets : [e.brackets] : ["{}", "[]", "()"],
            i = e.escape || "___",
            a = !!e.flat;
        n.forEach(function (t) {
          var e = new RegExp(["\\", t[0], "[^\\", t[0], "\\", t[1], "]*\\", t[1]].join("")),
              n = [];

          function a(e, a, o) {
            var s = r.push(e.slice(t[0].length, -t[1].length)) - 1;
            return n.push(s), i + s + i;
          }

          r.forEach(function (t, n) {
            for (var i, o = 0; t != i;) {
              if (i = t, t = t.replace(e, a), o++ > 1e4) throw Error("References have circular dependency. Please, check them.");
            }

            r[n] = t;
          }), n = n.reverse(), r = r.map(function (e) {
            return n.forEach(function (r) {
              e = e.replace(new RegExp("(\\" + i + r + "\\" + i + ")", "g"), t[0] + "$1" + t[1]);
            }), e;
          });
        });
        var o = new RegExp("\\" + i + "([0-9]+)\\" + i);
        return a ? r : function t(e, r, n) {
          for (var i, a = [], s = 0; i = o.exec(e);) {
            if (s++ > 1e4) throw Error("Circular references in parenthesis");
            a.push(e.slice(0, i.index)), a.push(t(r[i[1]], r)), e = e.slice(i.index + i[0].length);
          }

          return a.push(e), a;
        }(r[0], r);
      }

      function i(t, e) {
        if (e && e.flat) {
          var r,
              n = e && e.escape || "___",
              i = t[0];
          if (!i) return "";

          for (var a = new RegExp("\\" + n + "([0-9]+)\\" + n), o = 0; i != r;) {
            if (o++ > 1e4) throw Error("Circular references in " + t);
            r = i, i = i.replace(a, s);
          }

          return i;
        }

        return t.reduce(function t(e, r) {
          return Array.isArray(r) && (r = r.reduce(t, "")), e + r;
        }, "");

        function s(e, r) {
          if (null == t[r]) throw Error("Reference " + r + "is undefined");
          return t[r];
        }
      }

      function a(t, e) {
        return Array.isArray(t) ? i(t, e) : n(t, e);
      }

      a.parse = n, a.stringify = i, e.exports = a;
    }, {}],
    484: [function (t, e, r) {
      "use strict";

      var n = t("pick-by-alias");

      e.exports = function (t) {
        var e;
        arguments.length > 1 && (t = arguments);
        "string" == typeof t ? t = t.split(/\s/).map(parseFloat) : "number" == typeof t && (t = [t]);
        t.length && "number" == typeof t[0] ? e = 1 === t.length ? {
          width: t[0],
          height: t[0],
          x: 0,
          y: 0
        } : 2 === t.length ? {
          width: t[0],
          height: t[1],
          x: 0,
          y: 0
        } : {
          x: t[0],
          y: t[1],
          width: t[2] - t[0] || 0,
          height: t[3] - t[1] || 0
        } : t && (t = n(t, {
          left: "x l left Left",
          top: "y t top Top",
          width: "w width W Width",
          height: "h height W Width",
          bottom: "b bottom Bottom",
          right: "r right Right"
        }), e = {
          x: t.left || 0,
          y: t.top || 0
        }, null == t.width ? t.right ? e.width = t.right - e.x : e.width = 0 : e.width = t.width, null == t.height ? t.bottom ? e.height = t.bottom - e.y : e.height = 0 : e.height = t.height);
        return e;
      };
    }, {
      "pick-by-alias": 490
    }],
    485: [function (t, e, r) {
      e.exports = function (t) {
        var e = [];
        return t.replace(i, function (t, r, i) {
          var o = r.toLowerCase();

          for (i = function (t) {
            var e = t.match(a);
            return e ? e.map(Number) : [];
          }(i), "m" == o && i.length > 2 && (e.push([r].concat(i.splice(0, 2))), o = "l", r = "m" == r ? "l" : "L");;) {
            if (i.length == n[o]) return i.unshift(r), e.push(i);
            if (i.length < n[o]) throw new Error("malformed path data");
            e.push([r].concat(i.splice(0, n[o])));
          }
        }), e;
      };

      var n = {
        a: 7,
        c: 6,
        h: 1,
        l: 2,
        m: 2,
        q: 4,
        s: 4,
        t: 2,
        v: 1,
        z: 0
      },
          i = /([astvzqmhlc])([^astvzqmhlc]*)/gi;
      var a = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi;
    }, {}],
    486: [function (t, e, r) {
      e.exports = function (t, e) {
        e || (e = [0, ""]), t = String(t);
        var r = parseFloat(t, 10);
        return e[0] = r, e[1] = t.match(/[\d.\-\+]*\s*(.*)/)[1] || "", e;
      };
    }, {}],
    487: [function (t, e, r) {
      (function (t) {
        (function () {
          (function () {
            var r, n, i, a, o, s;
            "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function () {
              return performance.now();
            } : null != t && t.hrtime ? (e.exports = function () {
              return (r() - o) / 1e6;
            }, n = t.hrtime, a = (r = function r() {
              var t;
              return 1e9 * (t = n())[0] + t[1];
            })(), s = 1e9 * t.uptime(), o = a - s) : Date.now ? (e.exports = function () {
              return Date.now() - i;
            }, i = Date.now()) : (e.exports = function () {
              return new Date().getTime() - i;
            }, i = new Date().getTime());
          }).call(this);
        }).call(this);
      }).call(this, t("_process"));
    }, {
      _process: 520
    }],
    488: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        var e = t.length;

        if (e < 32) {
          for (var r = 1, i = 0; i < e; ++i) {
            for (var a = 0; a < i; ++a) {
              if (t[i] < t[a]) r = -r;else if (t[i] === t[a]) return 0;
            }
          }

          return r;
        }

        var o = n.mallocUint8(e);

        for (i = 0; i < e; ++i) {
          o[i] = 0;
        }

        for (r = 1, i = 0; i < e; ++i) {
          if (!o[i]) {
            var s = 1;
            o[i] = 1;

            for (a = t[i]; a !== i; a = t[a]) {
              if (o[a]) return n.freeUint8(o), 0;
              s += 1, o[a] = 1;
            }

            1 & s || (r = -r);
          }
        }

        return n.freeUint8(o), r;
      };

      var n = t("typedarray-pool");
    }, {
      "typedarray-pool": 609
    }],
    489: [function (t, e, r) {
      "use strict";

      var n = t("typedarray-pool"),
          i = t("invert-permutation");
      r.rank = function (t) {
        var e = t.length;

        switch (e) {
          case 0:
          case 1:
            return 0;

          case 2:
            return t[1];
        }

        var r,
            a,
            o,
            s = n.mallocUint32(e),
            l = n.mallocUint32(e),
            c = 0;

        for (i(t, l), o = 0; o < e; ++o) {
          s[o] = t[o];
        }

        for (o = e - 1; o > 0; --o) {
          a = l[o], r = s[o], s[o] = s[a], s[a] = r, l[o] = l[r], l[r] = a, c = (c + r) * o;
        }

        return n.freeUint32(l), n.freeUint32(s), c;
      }, r.unrank = function (t, e, r) {
        switch (t) {
          case 0:
            return r || [];

          case 1:
            return r ? (r[0] = 0, r) : [0];

          case 2:
            return r ? (e ? (r[0] = 0, r[1] = 1) : (r[0] = 1, r[1] = 0), r) : e ? [0, 1] : [1, 0];
        }

        var n,
            i,
            a,
            o = 1;

        for ((r = r || new Array(t))[0] = 0, a = 1; a < t; ++a) {
          r[a] = a, o = o * a | 0;
        }

        for (a = t - 1; a > 0; --a) {
          e = e - (n = e / o | 0) * o | 0, o = o / a | 0, i = 0 | r[a], r[a] = 0 | r[n], r[n] = 0 | i;
        }

        return r;
      };
    }, {
      "invert-permutation": 441,
      "typedarray-pool": 609
    }],
    490: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r) {
        var n,
            a,
            o = {};

        if ("string" == typeof e && (e = i(e)), Array.isArray(e)) {
          var s = {};

          for (a = 0; a < e.length; a++) {
            s[e[a]] = !0;
          }

          e = s;
        }

        for (n in e) {
          e[n] = i(e[n]);
        }

        var l = {};

        for (n in e) {
          var c = e[n];
          if (Array.isArray(c)) for (a = 0; a < c.length; a++) {
            var u = c[a];

            if (r && (l[u] = !0), u in t) {
              if (o[n] = t[u], r) for (var f = a; f < c.length; f++) {
                l[c[f]] = !0;
              }
              break;
            }
          } else n in t && (e[n] && (o[n] = t[n]), r && (l[n] = !0));
        }

        if (r) for (n in t) {
          l[n] || (o[n] = t[n]);
        }
        return o;
      };

      var n = {};

      function i(t) {
        return n[t] ? n[t] : ("string" == typeof t && (t = n[t] = t.split(/\s*,\s*|\s+/)), t);
      }
    }, {}],
    491: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        for (var r = 0 | e.length, i = t.length, a = [new Array(r), new Array(r)], o = 0; o < r; ++o) {
          a[0][o] = [], a[1][o] = [];
        }

        for (o = 0; o < i; ++o) {
          var s = t[o];
          a[0][s[0]].push(s), a[1][s[1]].push(s);
        }

        var l = [];

        for (o = 0; o < r; ++o) {
          a[0][o].length + a[1][o].length === 0 && l.push([o]);
        }

        function c(t, e) {
          var r = a[e][t[e]];
          r.splice(r.indexOf(t), 1);
        }

        function u(t, r, i) {
          for (var o, s, l, u = 0; u < 2; ++u) {
            if (a[u][r].length > 0) {
              o = a[u][r][0], l = u;
              break;
            }
          }

          s = o[1 ^ l];

          for (var f = 0; f < 2; ++f) {
            for (var h = a[f][r], p = 0; p < h.length; ++p) {
              var d = h[p],
                  m = d[1 ^ f];
              n(e[t], e[r], e[s], e[m]) > 0 && (o = d, s = m, l = f);
            }
          }

          return i || o && c(o, l), s;
        }

        function f(t, r) {
          var i = a[r][t][0],
              o = [t];
          c(i, r);

          for (var s = i[1 ^ r];;) {
            for (; s !== t;) {
              o.push(s), s = u(o[o.length - 2], s, !1);
            }

            if (a[0][t].length + a[1][t].length === 0) break;
            var l = o[o.length - 1],
                f = t,
                h = o[1],
                p = u(l, f, !0);
            if (n(e[l], e[f], e[h], e[p]) < 0) break;
            o.push(t), s = u(l, f);
          }

          return o;
        }

        function h(t, e) {
          return e[1] === e[e.length - 1];
        }

        for (o = 0; o < r; ++o) {
          for (var p = 0; p < 2; ++p) {
            for (var d = []; a[p][o].length > 0;) {
              a[0][o].length;
              var m = f(o, p);
              h(0, m) ? d.push.apply(d, m) : (d.length > 0 && l.push(d), d = m);
            }

            d.length > 0 && l.push(d);
          }
        }

        return l;
      };

      var n = t("compare-angle");
    }, {
      "compare-angle": 133
    }],
    492: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        for (var r = n(t, e.length), i = new Array(e.length), a = new Array(e.length), o = [], s = 0; s < e.length; ++s) {
          var l = r[s].length;
          a[s] = l, i[s] = !0, l <= 1 && o.push(s);
        }

        for (; o.length > 0;) {
          var c = o.pop();
          i[c] = !1;
          var u = r[c];

          for (s = 0; s < u.length; ++s) {
            var f = u[s];
            0 == --a[f] && o.push(f);
          }
        }

        var h = new Array(e.length),
            p = [];

        for (s = 0; s < e.length; ++s) {
          if (i[s]) {
            c = p.length;
            h[s] = c, p.push(e[s]);
          } else h[s] = -1;
        }

        var d = [];

        for (s = 0; s < t.length; ++s) {
          var m = t[s];
          i[m[0]] && i[m[1]] && d.push([h[m[0]], h[m[1]]]);
        }

        return [d, p];
      };

      var n = t("edges-to-adjacency-list");
    }, {
      "edges-to-adjacency-list": 178
    }],
    493: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        var r = c(t, e);
        t = r[0];

        for (var f = (e = r[1]).length, h = (t.length, n(t, e.length)), p = 0; p < f; ++p) {
          if (h[p].length % 2 == 1) throw new Error("planar-graph-to-polyline: graph must be manifold");
        }

        var d = i(t, e);
        var m = (d = d.filter(function (t) {
          for (var r = t.length, n = [0], i = 0; i < r; ++i) {
            var a = e[t[i]],
                l = e[t[(i + 1) % r]],
                c = o(-a[0], a[1]),
                u = o(-a[0], l[1]),
                f = o(l[0], a[1]),
                h = o(l[0], l[1]);
            n = s(n, s(s(c, u), s(f, h)));
          }

          return n[n.length - 1] > 0;
        })).length,
            g = new Array(m),
            v = new Array(m);

        for (p = 0; p < m; ++p) {
          g[p] = p;
          var y = new Array(m),
              x = d[p].map(function (t) {
            return e[t];
          }),
              b = a([x]),
              _ = 0;

          t: for (var w = 0; w < m; ++w) {
            if (y[w] = 0, p !== w) {
              for (var T = (q = d[w]).length, k = 0; k < T; ++k) {
                var M = b(e[q[k]]);

                if (0 !== M) {
                  M < 0 && (y[w] = 1, _ += 1);
                  continue t;
                }
              }

              y[w] = 1, _ += 1;
            }
          }

          v[p] = [_, p, y];
        }

        v.sort(function (t, e) {
          return e[0] - t[0];
        });

        for (p = 0; p < m; ++p) {
          var A = (y = v[p])[1],
              S = y[2];

          for (w = 0; w < m; ++w) {
            S[w] && (g[w] = A);
          }
        }

        var E = function (t) {
          for (var e = new Array(t), r = 0; r < t; ++r) {
            e[r] = [];
          }

          return e;
        }(m);

        for (p = 0; p < m; ++p) {
          E[p].push(g[p]), E[g[p]].push(p);
        }

        var L = {},
            C = u(f, !1);

        for (p = 0; p < m; ++p) {
          for (T = (q = d[p]).length, w = 0; w < T; ++w) {
            var P = q[w],
                I = q[(w + 1) % T],
                O = Math.min(P, I) + ":" + Math.max(P, I);

            if (O in L) {
              var z = L[O];
              E[z].push(p), E[p].push(z), C[P] = C[I] = !0;
            } else L[O] = p;
          }
        }

        function D(t) {
          for (var e = t.length, r = 0; r < e; ++r) {
            if (!C[t[r]]) return !1;
          }

          return !0;
        }

        var R = [],
            F = u(m, -1);

        for (p = 0; p < m; ++p) {
          g[p] !== p || D(d[p]) ? F[p] = -1 : (R.push(p), F[p] = 0);
        }

        r = [];

        for (; R.length > 0;) {
          var B = R.pop(),
              N = E[B];
          l(N, function (t, e) {
            return t - e;
          });
          var j,
              U = N.length,
              V = F[B];

          if (0 === V) {
            var q = d[B];
            j = [q];
          }

          for (p = 0; p < U; ++p) {
            var H = N[p];
            if (!(F[H] >= 0)) if (F[H] = 1 ^ V, R.push(H), 0 === V) D(q = d[H]) || (q.reverse(), j.push(q));
          }

          0 === V && r.push(j);
        }

        return r;
      };

      var n = t("edges-to-adjacency-list"),
          i = t("planar-dual"),
          a = t("point-in-big-polygon"),
          o = t("two-product"),
          s = t("robust-sum"),
          l = t("uniq"),
          c = t("./lib/trim-leaves");

      function u(t, e) {
        for (var r = new Array(t), n = 0; n < t; ++n) {
          r[n] = e;
        }

        return r;
      }
    }, {
      "./lib/trim-leaves": 492,
      "edges-to-adjacency-list": 178,
      "planar-dual": 491,
      "point-in-big-polygon": 495,
      "robust-sum": 545,
      "two-product": 596,
      uniq: 611
    }],
    494: [function (t, e, r) {
      arguments[4][242][0].apply(r, arguments);
    }, {
      dup: 242
    }],
    495: [function (t, e, r) {
      e.exports = function (t) {
        for (var e = t.length, r = [], a = [], s = 0; s < e; ++s) {
          for (var u = t[s], f = u.length, h = f - 1, p = 0; p < f; h = p++) {
            var d = u[h],
                m = u[p];
            d[0] === m[0] ? a.push([d, m]) : r.push([d, m]);
          }
        }

        if (0 === r.length) return 0 === a.length ? c : (g = l(a), function (t) {
          return g(t[0], t[1]) ? 0 : 1;
        });
        var g;

        var v = i(r),
            y = function (t, e) {
          return function (r) {
            var i = o.le(e, r[0]);
            if (i < 0) return 1;
            var a = t[i];

            if (!a) {
              if (!(i > 0 && e[i] === r[0])) return 1;
              a = t[i - 1];
            }

            for (var s = 1; a;) {
              var l = a.key,
                  c = n(r, l[0], l[1]);
              if (l[0][0] < l[1][0]) {
                if (c < 0) a = a.left;else {
                  if (!(c > 0)) return 0;
                  s = -1, a = a.right;
                }
              } else if (c > 0) a = a.left;else {
                if (!(c < 0)) return 0;
                s = 1, a = a.right;
              }
            }

            return s;
          };
        }(v.slabs, v.coordinates);

        return 0 === a.length ? y : function (t, e) {
          return function (r) {
            return t(r[0], r[1]) ? 0 : e(r);
          };
        }(l(a), y);
      };

      var n = t("robust-orientation")[3],
          i = t("slab-decomposition"),
          a = t("interval-tree-1d"),
          o = t("binary-search-bounds");

      function s() {
        return !0;
      }

      function l(t) {
        for (var e = {}, r = 0; r < t.length; ++r) {
          var n = t[r],
              i = n[0][0],
              o = n[0][1],
              l = n[1][1],
              c = [Math.min(o, l), Math.max(o, l)];
          i in e ? e[i].push(c) : e[i] = [c];
        }

        var u = {},
            f = Object.keys(e);

        for (r = 0; r < f.length; ++r) {
          var h = e[f[r]];
          u[f[r]] = a(h);
        }

        return function (t) {
          return function (e, r) {
            var n = t[e];
            return !!n && !!n.queryPoint(r, s);
          };
        }(u);
      }

      function c(t) {
        return 1;
      }
    }, {
      "binary-search-bounds": 494,
      "interval-tree-1d": 439,
      "robust-orientation": 540,
      "slab-decomposition": 558
    }],
    496: [function (t, e, r) {
      /*
       * @copyright 2016 Sean Connelly (@voidqk), http://syntheti.cc
       * @license MIT
       * @preserve Project Home: https://github.com/voidqk/polybooljs
       */
      var n,
          i = t("./lib/build-log"),
          a = t("./lib/epsilon"),
          o = t("./lib/intersecter"),
          s = t("./lib/segment-chainer"),
          l = t("./lib/segment-selector"),
          c = t("./lib/geojson"),
          u = !1,
          f = a();

      function h(t, e, r) {
        var i = n.segments(t),
            a = n.segments(e),
            o = r(n.combine(i, a));
        return n.polygon(o);
      }

      n = {
        buildLog: function buildLog(t) {
          return !0 === t ? u = i() : !1 === t && (u = !1), !1 !== u && u.list;
        },
        epsilon: function epsilon(t) {
          return f.epsilon(t);
        },
        segments: function segments(t) {
          var e = o(!0, f, u);
          return t.regions.forEach(e.addRegion), {
            segments: e.calculate(t.inverted),
            inverted: t.inverted
          };
        },
        combine: function combine(t, e) {
          return {
            combined: o(!1, f, u).calculate(t.segments, t.inverted, e.segments, e.inverted),
            inverted1: t.inverted,
            inverted2: e.inverted
          };
        },
        selectUnion: function selectUnion(t) {
          return {
            segments: l.union(t.combined, u),
            inverted: t.inverted1 || t.inverted2
          };
        },
        selectIntersect: function selectIntersect(t) {
          return {
            segments: l.intersect(t.combined, u),
            inverted: t.inverted1 && t.inverted2
          };
        },
        selectDifference: function selectDifference(t) {
          return {
            segments: l.difference(t.combined, u),
            inverted: t.inverted1 && !t.inverted2
          };
        },
        selectDifferenceRev: function selectDifferenceRev(t) {
          return {
            segments: l.differenceRev(t.combined, u),
            inverted: !t.inverted1 && t.inverted2
          };
        },
        selectXor: function selectXor(t) {
          return {
            segments: l.xor(t.combined, u),
            inverted: t.inverted1 !== t.inverted2
          };
        },
        polygon: function polygon(t) {
          return {
            regions: s(t.segments, f, u),
            inverted: t.inverted
          };
        },
        polygonFromGeoJSON: function polygonFromGeoJSON(t) {
          return c.toPolygon(n, t);
        },
        polygonToGeoJSON: function polygonToGeoJSON(t) {
          return c.fromPolygon(n, f, t);
        },
        union: function union(t, e) {
          return h(t, e, n.selectUnion);
        },
        intersect: function intersect(t, e) {
          return h(t, e, n.selectIntersect);
        },
        difference: function difference(t, e) {
          return h(t, e, n.selectDifference);
        },
        differenceRev: function differenceRev(t, e) {
          return h(t, e, n.selectDifferenceRev);
        },
        xor: function xor(t, e) {
          return h(t, e, n.selectXor);
        }
      }, "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (window.PolyBool = n), e.exports = n;
    }, {
      "./lib/build-log": 497,
      "./lib/epsilon": 498,
      "./lib/geojson": 499,
      "./lib/intersecter": 500,
      "./lib/segment-chainer": 502,
      "./lib/segment-selector": 503
    }],
    497: [function (t, e, r) {
      e.exports = function () {
        var t,
            e = 0,
            r = !1;

        function n(e, r) {
          return t.list.push({
            type: e,
            data: r ? JSON.parse(JSON.stringify(r)) : void 0
          }), t;
        }

        return t = {
          list: [],
          segmentId: function segmentId() {
            return e++;
          },
          checkIntersection: function checkIntersection(t, e) {
            return n("check", {
              seg1: t,
              seg2: e
            });
          },
          segmentChop: function segmentChop(t, e) {
            return n("div_seg", {
              seg: t,
              pt: e
            }), n("chop", {
              seg: t,
              pt: e
            });
          },
          statusRemove: function statusRemove(t) {
            return n("pop_seg", {
              seg: t
            });
          },
          segmentUpdate: function segmentUpdate(t) {
            return n("seg_update", {
              seg: t
            });
          },
          segmentNew: function segmentNew(t, e) {
            return n("new_seg", {
              seg: t,
              primary: e
            });
          },
          segmentRemove: function segmentRemove(t) {
            return n("rem_seg", {
              seg: t
            });
          },
          tempStatus: function tempStatus(t, e, r) {
            return n("temp_status", {
              seg: t,
              above: e,
              below: r
            });
          },
          rewind: function rewind(t) {
            return n("rewind", {
              seg: t
            });
          },
          status: function status(t, e, r) {
            return n("status", {
              seg: t,
              above: e,
              below: r
            });
          },
          vert: function vert(e) {
            return e === r ? t : (r = e, n("vert", {
              x: e
            }));
          },
          log: function log(t) {
            return "string" != typeof t && (t = JSON.stringify(t, !1, "  ")), n("log", {
              txt: t
            });
          },
          reset: function reset() {
            return n("reset");
          },
          selected: function selected(t) {
            return n("selected", {
              segs: t
            });
          },
          chainStart: function chainStart(t) {
            return n("chain_start", {
              seg: t
            });
          },
          chainRemoveHead: function chainRemoveHead(t, e) {
            return n("chain_rem_head", {
              index: t,
              pt: e
            });
          },
          chainRemoveTail: function chainRemoveTail(t, e) {
            return n("chain_rem_tail", {
              index: t,
              pt: e
            });
          },
          chainNew: function chainNew(t, e) {
            return n("chain_new", {
              pt1: t,
              pt2: e
            });
          },
          chainMatch: function chainMatch(t) {
            return n("chain_match", {
              index: t
            });
          },
          chainClose: function chainClose(t) {
            return n("chain_close", {
              index: t
            });
          },
          chainAddHead: function chainAddHead(t, e) {
            return n("chain_add_head", {
              index: t,
              pt: e
            });
          },
          chainAddTail: function chainAddTail(t, e) {
            return n("chain_add_tail", {
              index: t,
              pt: e
            });
          },
          chainConnect: function chainConnect(t, e) {
            return n("chain_con", {
              index1: t,
              index2: e
            });
          },
          chainReverse: function chainReverse(t) {
            return n("chain_rev", {
              index: t
            });
          },
          chainJoin: function chainJoin(t, e) {
            return n("chain_join", {
              index1: t,
              index2: e
            });
          },
          done: function done() {
            return n("done");
          }
        };
      };
    }, {}],
    498: [function (t, e, r) {
      e.exports = function (t) {
        "number" != typeof t && (t = 1e-10);
        var e = {
          epsilon: function epsilon(e) {
            return "number" == typeof e && (t = e), t;
          },
          pointAboveOrOnLine: function pointAboveOrOnLine(e, r, n) {
            var i = r[0],
                a = r[1],
                o = n[0],
                s = n[1],
                l = e[0];
            return (o - i) * (e[1] - a) - (s - a) * (l - i) >= -t;
          },
          pointBetween: function pointBetween(e, r, n) {
            var i = e[1] - r[1],
                a = n[0] - r[0],
                o = e[0] - r[0],
                s = n[1] - r[1],
                l = o * a + i * s;
            return !(l < t) && !(l - (a * a + s * s) > -t);
          },
          pointsSameX: function pointsSameX(e, r) {
            return Math.abs(e[0] - r[0]) < t;
          },
          pointsSameY: function pointsSameY(e, r) {
            return Math.abs(e[1] - r[1]) < t;
          },
          pointsSame: function pointsSame(t, r) {
            return e.pointsSameX(t, r) && e.pointsSameY(t, r);
          },
          pointsCompare: function pointsCompare(t, r) {
            return e.pointsSameX(t, r) ? e.pointsSameY(t, r) ? 0 : t[1] < r[1] ? -1 : 1 : t[0] < r[0] ? -1 : 1;
          },
          pointsCollinear: function pointsCollinear(e, r, n) {
            var i = e[0] - r[0],
                a = e[1] - r[1],
                o = r[0] - n[0],
                s = r[1] - n[1];
            return Math.abs(i * s - o * a) < t;
          },
          linesIntersect: function linesIntersect(e, r, n, i) {
            var a = r[0] - e[0],
                o = r[1] - e[1],
                s = i[0] - n[0],
                l = i[1] - n[1],
                c = a * l - o * s;
            if (Math.abs(c) < t) return !1;
            var u = e[0] - n[0],
                f = e[1] - n[1],
                h = (s * f - l * u) / c,
                p = (a * f - o * u) / c,
                d = {
              alongA: 0,
              alongB: 0,
              pt: [e[0] + h * a, e[1] + h * o]
            };
            return d.alongA = h <= -t ? -2 : h < t ? -1 : h - 1 <= -t ? 0 : h - 1 < t ? 1 : 2, d.alongB = p <= -t ? -2 : p < t ? -1 : p - 1 <= -t ? 0 : p - 1 < t ? 1 : 2, d;
          },
          pointInsideRegion: function pointInsideRegion(e, r) {
            for (var n = e[0], i = e[1], a = r[r.length - 1][0], o = r[r.length - 1][1], s = !1, l = 0; l < r.length; l++) {
              var c = r[l][0],
                  u = r[l][1];
              u - i > t != o - i > t && (a - c) * (i - u) / (o - u) + c - n > t && (s = !s), a = c, o = u;
            }

            return s;
          }
        };
        return e;
      };
    }, {}],
    499: [function (t, e, r) {
      var n = {
        toPolygon: function toPolygon(t, e) {
          function r(e) {
            if (e.length <= 0) return t.segments({
              inverted: !1,
              regions: []
            });

            function r(e) {
              var r = e.slice(0, e.length - 1);
              return t.segments({
                inverted: !1,
                regions: [r]
              });
            }

            for (var n = r(e[0]), i = 1; i < e.length; i++) {
              n = t.selectDifference(t.combine(n, r(e[i])));
            }

            return n;
          }

          if ("Polygon" === e.type) return t.polygon(r(e.coordinates));

          if ("MultiPolygon" === e.type) {
            for (var n = t.segments({
              inverted: !1,
              regions: []
            }), i = 0; i < e.coordinates.length; i++) {
              n = t.selectUnion(t.combine(n, r(e.coordinates[i])));
            }

            return t.polygon(n);
          }

          throw new Error("PolyBool: Cannot convert GeoJSON object to PolyBool polygon");
        },
        fromPolygon: function fromPolygon(t, e, r) {
          function n(t, r) {
            return e.pointInsideRegion([.5 * (t[0][0] + t[1][0]), .5 * (t[0][1] + t[1][1])], r);
          }

          function i(t) {
            return {
              region: t,
              children: []
            };
          }

          r = t.polygon(t.segments(r));
          var a = i(null);

          function o(t, e) {
            for (var r = 0; r < t.children.length; r++) {
              if (n(e, (s = t.children[r]).region)) return void o(s, e);
            }

            var a = i(e);

            for (r = 0; r < t.children.length; r++) {
              var s;
              n((s = t.children[r]).region, e) && (a.children.push(s), t.children.splice(r, 1), r--);
            }

            t.children.push(a);
          }

          for (var s = 0; s < r.regions.length; s++) {
            var l = r.regions[s];
            l.length < 3 || o(a, l);
          }

          function c(t, e) {
            for (var r = 0, n = t[t.length - 1][0], i = t[t.length - 1][1], a = [], o = 0; o < t.length; o++) {
              var s = t[o][0],
                  l = t[o][1];
              a.push([s, l]), r += l * n - s * i, n = s, i = l;
            }

            return r < 0 !== e && a.reverse(), a.push([a[0][0], a[0][1]]), a;
          }

          var u = [];

          function f(t) {
            var e = [c(t.region, !1)];
            u.push(e);

            for (var r = 0; r < t.children.length; r++) {
              e.push(h(t.children[r]));
            }
          }

          function h(t) {
            for (var e = 0; e < t.children.length; e++) {
              f(t.children[e]);
            }

            return c(t.region, !0);
          }

          for (s = 0; s < a.children.length; s++) {
            f(a.children[s]);
          }

          return u.length <= 0 ? {
            type: "Polygon",
            coordinates: []
          } : 1 == u.length ? {
            type: "Polygon",
            coordinates: u[0]
          } : {
            type: "MultiPolygon",
            coordinates: u
          };
        }
      };
      e.exports = n;
    }, {}],
    500: [function (t, e, r) {
      var n = t("./linked-list");

      e.exports = function (t, e, r) {
        function i(t, e, n) {
          return {
            id: r ? r.segmentId() : -1,
            start: t,
            end: e,
            myFill: {
              above: n.myFill.above,
              below: n.myFill.below
            },
            otherFill: null
          };
        }

        var a = n.create();

        function o(t, r) {
          a.insertBefore(t, function (n) {
            return function (t, r, n, i, a, o) {
              var s = e.pointsCompare(r, a);
              return 0 !== s ? s : e.pointsSame(n, o) ? 0 : t !== i ? t ? 1 : -1 : e.pointAboveOrOnLine(n, i ? a : o, i ? o : a) ? 1 : -1;
            }(t.isStart, t.pt, r, n.isStart, n.pt, n.other.pt) < 0;
          });
        }

        function s(t, e) {
          var r = function (t, e) {
            var r = n.node({
              isStart: !0,
              pt: t.start,
              seg: t,
              primary: e,
              other: null,
              status: null
            });
            return o(r, t.end), r;
          }(t, e);

          return function (t, e, r) {
            var i = n.node({
              isStart: !1,
              pt: e.end,
              seg: e,
              primary: r,
              other: t,
              status: null
            });
            t.other = i, o(i, t.pt);
          }(r, t, e), r;
        }

        function l(t, e) {
          var n = i(e, t.seg.end, t.seg);
          return function (t, e) {
            r && r.segmentChop(t.seg, e), t.other.remove(), t.seg.end = e, t.other.pt = e, o(t.other, t.pt);
          }(t, e), s(n, t.primary);
        }

        function c(i, o) {
          var s = n.create();

          function c(t) {
            return s.findTransition(function (r) {
              var n, i, a, o, s, l;
              return (n = t, i = r.ev, a = n.seg.start, o = n.seg.end, s = i.seg.start, l = i.seg.end, e.pointsCollinear(a, s, l) ? e.pointsCollinear(o, s, l) || e.pointAboveOrOnLine(o, s, l) ? 1 : -1 : e.pointAboveOrOnLine(a, s, l) ? 1 : -1) > 0;
            });
          }

          function u(t, n) {
            var i = t.seg,
                a = n.seg,
                o = i.start,
                s = i.end,
                c = a.start,
                u = a.end;
            r && r.checkIntersection(i, a);
            var f = e.linesIntersect(o, s, c, u);

            if (!1 === f) {
              if (!e.pointsCollinear(o, s, c)) return !1;
              if (e.pointsSame(o, u) || e.pointsSame(s, c)) return !1;
              var h = e.pointsSame(o, c),
                  p = e.pointsSame(s, u);
              if (h && p) return n;
              var d = !h && e.pointBetween(o, c, u),
                  m = !p && e.pointBetween(s, c, u);
              if (h) return m ? l(n, s) : l(t, u), n;
              d && (p || (m ? l(n, s) : l(t, u)), l(n, o));
            } else 0 === f.alongA && (-1 === f.alongB ? l(t, c) : 0 === f.alongB ? l(t, f.pt) : 1 === f.alongB && l(t, u)), 0 === f.alongB && (-1 === f.alongA ? l(n, o) : 0 === f.alongA ? l(n, f.pt) : 1 === f.alongA && l(n, s));

            return !1;
          }

          for (var f = []; !a.isEmpty();) {
            var h = a.getHead();

            if (r && r.vert(h.pt[0]), h.isStart) {
              r && r.segmentNew(h.seg, h.primary);
              var p = c(h),
                  d = p.before ? p.before.ev : null,
                  m = p.after ? p.after.ev : null;

              function g() {
                if (d) {
                  var t = u(h, d);
                  if (t) return t;
                }

                return !!m && u(h, m);
              }

              r && r.tempStatus(h.seg, !!d && d.seg, !!m && m.seg);
              var v,
                  y = g();

              if (y) {
                var x;
                if (t) (x = null === h.seg.myFill.below || h.seg.myFill.above !== h.seg.myFill.below) && (y.seg.myFill.above = !y.seg.myFill.above);else y.seg.otherFill = h.seg.myFill;
                r && r.segmentUpdate(y.seg), h.other.remove(), h.remove();
              }

              if (a.getHead() !== h) {
                r && r.rewind(h.seg);
                continue;
              }

              if (t) x = null === h.seg.myFill.below || h.seg.myFill.above !== h.seg.myFill.below, h.seg.myFill.below = m ? m.seg.myFill.above : i, h.seg.myFill.above = x ? !h.seg.myFill.below : h.seg.myFill.below;else if (null === h.seg.otherFill) v = m ? h.primary === m.primary ? m.seg.otherFill.above : m.seg.myFill.above : h.primary ? o : i, h.seg.otherFill = {
                above: v,
                below: v
              };
              r && r.status(h.seg, !!d && d.seg, !!m && m.seg), h.other.status = p.insert(n.node({
                ev: h
              }));
            } else {
              var b = h.status;
              if (null === b) throw new Error("PolyBool: Zero-length segment detected; your epsilon is probably too small or too large");

              if (s.exists(b.prev) && s.exists(b.next) && u(b.prev.ev, b.next.ev), r && r.statusRemove(b.ev.seg), b.remove(), !h.primary) {
                var _ = h.seg.myFill;
                h.seg.myFill = h.seg.otherFill, h.seg.otherFill = _;
              }

              f.push(h.seg);
            }

            a.getHead().remove();
          }

          return r && r.done(), f;
        }

        return t ? {
          addRegion: function addRegion(t) {
            for (var n, i, a, o = t[t.length - 1], l = 0; l < t.length; l++) {
              n = o, o = t[l];
              var c = e.pointsCompare(n, o);
              0 !== c && s((i = c < 0 ? n : o, a = c < 0 ? o : n, {
                id: r ? r.segmentId() : -1,
                start: i,
                end: a,
                myFill: {
                  above: null,
                  below: null
                },
                otherFill: null
              }), !0);
            }
          },
          calculate: function calculate(t) {
            return c(t, !1);
          }
        } : {
          calculate: function calculate(t, e, r, n) {
            return t.forEach(function (t) {
              s(i(t.start, t.end, t), !0);
            }), r.forEach(function (t) {
              s(i(t.start, t.end, t), !1);
            }), c(e, n);
          }
        };
      };
    }, {
      "./linked-list": 501
    }],
    501: [function (t, e, r) {
      e.exports = {
        create: function create() {
          var t = {
            root: {
              root: !0,
              next: null
            },
            exists: function exists(e) {
              return null !== e && e !== t.root;
            },
            isEmpty: function isEmpty() {
              return null === t.root.next;
            },
            getHead: function getHead() {
              return t.root.next;
            },
            insertBefore: function insertBefore(e, r) {
              for (var n = t.root, i = t.root.next; null !== i;) {
                if (r(i)) return e.prev = i.prev, e.next = i, i.prev.next = e, void (i.prev = e);
                n = i, i = i.next;
              }

              n.next = e, e.prev = n, e.next = null;
            },
            findTransition: function findTransition(e) {
              for (var r = t.root, n = t.root.next; null !== n && !e(n);) {
                r = n, n = n.next;
              }

              return {
                before: r === t.root ? null : r,
                after: n,
                insert: function insert(t) {
                  return t.prev = r, t.next = n, r.next = t, null !== n && (n.prev = t), t;
                }
              };
            }
          };
          return t;
        },
        node: function node(t) {
          return t.prev = null, t.next = null, t.remove = function () {
            t.prev.next = t.next, t.next && (t.next.prev = t.prev), t.prev = null, t.next = null;
          }, t;
        }
      };
    }, {}],
    502: [function (t, e, r) {
      e.exports = function (t, e, r) {
        var n = [],
            i = [];
        return t.forEach(function (t) {
          var a = t.start,
              o = t.end;
          if (e.pointsSame(a, o)) console.warn("PolyBool: Warning: Zero-length segment detected; your epsilon is probably too small or too large");else {
            r && r.chainStart(t);

            for (var s = {
              index: 0,
              matches_head: !1,
              matches_pt1: !1
            }, l = {
              index: 0,
              matches_head: !1,
              matches_pt1: !1
            }, c = s, u = 0; u < n.length; u++) {
              var f = (g = n[u])[0],
                  h = (g[1], g[g.length - 1]);
              g[g.length - 2];

              if (e.pointsSame(f, a)) {
                if (k(u, !0, !0)) break;
              } else if (e.pointsSame(f, o)) {
                if (k(u, !0, !1)) break;
              } else if (e.pointsSame(h, a)) {
                if (k(u, !1, !0)) break;
              } else if (e.pointsSame(h, o) && k(u, !1, !1)) break;
            }

            if (c === s) return n.push([a, o]), void (r && r.chainNew(a, o));

            if (c === l) {
              r && r.chainMatch(s.index);
              var p = s.index,
                  d = s.matches_pt1 ? o : a,
                  m = s.matches_head,
                  g = n[p],
                  v = m ? g[0] : g[g.length - 1],
                  y = m ? g[1] : g[g.length - 2],
                  x = m ? g[g.length - 1] : g[0],
                  b = m ? g[g.length - 2] : g[1];
              return e.pointsCollinear(y, v, d) && (m ? (r && r.chainRemoveHead(s.index, d), g.shift()) : (r && r.chainRemoveTail(s.index, d), g.pop()), v = y), e.pointsSame(x, d) ? (n.splice(p, 1), e.pointsCollinear(b, x, v) && (m ? (r && r.chainRemoveTail(s.index, v), g.pop()) : (r && r.chainRemoveHead(s.index, v), g.shift())), r && r.chainClose(s.index), void i.push(g)) : void (m ? (r && r.chainAddHead(s.index, d), g.unshift(d)) : (r && r.chainAddTail(s.index, d), g.push(d)));
            }

            var _ = s.index,
                w = l.index;
            r && r.chainConnect(_, w);
            var T = n[_].length < n[w].length;
            s.matches_head ? l.matches_head ? T ? (M(_), A(_, w)) : (M(w), A(w, _)) : A(w, _) : l.matches_head ? A(_, w) : T ? (M(_), A(w, _)) : (M(w), A(_, w));
          }

          function k(t, e, r) {
            return c.index = t, c.matches_head = e, c.matches_pt1 = r, c === s ? (c = l, !1) : (c = null, !0);
          }

          function M(t) {
            r && r.chainReverse(t), n[t].reverse();
          }

          function A(t, i) {
            var a = n[t],
                o = n[i],
                s = a[a.length - 1],
                l = a[a.length - 2],
                c = o[0],
                u = o[1];
            e.pointsCollinear(l, s, c) && (r && r.chainRemoveTail(t, s), a.pop(), s = l), e.pointsCollinear(s, c, u) && (r && r.chainRemoveHead(i, c), o.shift()), r && r.chainJoin(t, i), n[t] = a.concat(o), n.splice(i, 1);
          }
        }), i;
      };
    }, {}],
    503: [function (t, e, r) {
      function n(t, e, r) {
        var n = [];
        return t.forEach(function (t) {
          var i = (t.myFill.above ? 8 : 0) + (t.myFill.below ? 4 : 0) + (t.otherFill && t.otherFill.above ? 2 : 0) + (t.otherFill && t.otherFill.below ? 1 : 0);
          0 !== e[i] && n.push({
            id: r ? r.segmentId() : -1,
            start: t.start,
            end: t.end,
            myFill: {
              above: 1 === e[i],
              below: 2 === e[i]
            },
            otherFill: null
          });
        }), r && r.selected(n), n;
      }

      var i = {
        union: function union(t, e) {
          return n(t, [0, 2, 1, 0, 2, 2, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0], e);
        },
        intersect: function intersect(t, e) {
          return n(t, [0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 1, 1, 0, 2, 1, 0], e);
        },
        difference: function difference(t, e) {
          return n(t, [0, 0, 0, 0, 2, 0, 2, 0, 1, 1, 0, 0, 0, 1, 2, 0], e);
        },
        differenceRev: function differenceRev(t, e) {
          return n(t, [0, 2, 1, 0, 0, 0, 1, 1, 0, 2, 0, 2, 0, 0, 0, 0], e);
        },
        xor: function xor(t, e) {
          return n(t, [0, 2, 1, 0, 2, 0, 0, 1, 1, 0, 0, 2, 0, 1, 2, 0], e);
        }
      };
      e.exports = i;
    }, {}],
    504: [function (t, e, r) {
      "use strict";

      var n = new Float64Array(4),
          i = new Float64Array(4),
          a = new Float64Array(4);

      e.exports = function (t, e, r, o, s) {
        n.length < o.length && (n = new Float64Array(o.length), i = new Float64Array(o.length), a = new Float64Array(o.length));

        for (var l = 0; l < o.length; ++l) {
          n[l] = t[l] - o[l], i[l] = e[l] - t[l], a[l] = r[l] - t[l];
        }

        var c = 0,
            u = 0,
            f = 0,
            h = 0,
            p = 0,
            d = 0;

        for (l = 0; l < o.length; ++l) {
          var m = i[l],
              g = a[l],
              v = n[l];
          c += m * m, u += m * g, f += g * g, h += v * m, p += v * g, d += v * v;
        }

        var y,
            x,
            b,
            _,
            w,
            T = Math.abs(c * f - u * u),
            k = u * p - f * h,
            M = u * h - c * p;

        if (k + M <= T) {
          if (k < 0) M < 0 && h < 0 ? (M = 0, -h >= c ? (k = 1, y = c + 2 * h + d) : y = h * (k = -h / c) + d) : (k = 0, p >= 0 ? (M = 0, y = d) : -p >= f ? (M = 1, y = f + 2 * p + d) : y = p * (M = -p / f) + d);else if (M < 0) M = 0, h >= 0 ? (k = 0, y = d) : -h >= c ? (k = 1, y = c + 2 * h + d) : y = h * (k = -h / c) + d;else {
            var A = 1 / T;
            y = (k *= A) * (c * k + u * (M *= A) + 2 * h) + M * (u * k + f * M + 2 * p) + d;
          }
        } else k < 0 ? (b = f + p) > (x = u + h) ? (_ = b - x) >= (w = c - 2 * u + f) ? (k = 1, M = 0, y = c + 2 * h + d) : y = (k = _ / w) * (c * k + u * (M = 1 - k) + 2 * h) + M * (u * k + f * M + 2 * p) + d : (k = 0, b <= 0 ? (M = 1, y = f + 2 * p + d) : p >= 0 ? (M = 0, y = d) : y = p * (M = -p / f) + d) : M < 0 ? (b = c + h) > (x = u + p) ? (_ = b - x) >= (w = c - 2 * u + f) ? (M = 1, k = 0, y = f + 2 * p + d) : y = (k = 1 - (M = _ / w)) * (c * k + u * M + 2 * h) + M * (u * k + f * M + 2 * p) + d : (M = 0, b <= 0 ? (k = 1, y = c + 2 * h + d) : h >= 0 ? (k = 0, y = d) : y = h * (k = -h / c) + d) : (_ = f + p - u - h) <= 0 ? (k = 0, M = 1, y = f + 2 * p + d) : _ >= (w = c - 2 * u + f) ? (k = 1, M = 0, y = c + 2 * h + d) : y = (k = _ / w) * (c * k + u * (M = 1 - k) + 2 * h) + M * (u * k + f * M + 2 * p) + d;
        var S = 1 - k - M;

        for (l = 0; l < o.length; ++l) {
          s[l] = S * t[l] + k * e[l] + M * r[l];
        }

        return y < 0 ? 0 : y;
      };
    }, {}],
    505: [function (t, e, r) {
      "use strict";

      var n = t("stream").Transform,
          i = t("stream-parser");

      function a() {
        n.call(this, {
          readableObjectMode: !0
        });
      }

      function o(t, e, r) {
        Error.call(this), Error.captureStackTrace(this, this.constructor), this.name = this.constructor.name, this.message = t, e && (this.code = e), r && (this.statusCode = r);
      }

      a.prototype = Object.create(n.prototype), a.prototype.constructor = a, i(a.prototype), r.ParserStream = a, r.sliceEq = function (t, e, r) {
        for (var n = e, i = 0; i < r.length;) {
          if (t[n++] !== r[i++]) return !1;
        }

        return !0;
      }, r.str2arr = function (t, e) {
        var r = [],
            n = 0;
        if (e && "hex" === e) for (; n < t.length;) {
          r.push(parseInt(t.slice(n, n + 2), 16)), n += 2;
        } else for (; n < t.length; n++) {
          r.push(255 & t.charCodeAt(n));
        }
        return r;
      }, r.readUInt16LE = function (t, e) {
        return t[e] | t[e + 1] << 8;
      }, r.readUInt16BE = function (t, e) {
        return t[e + 1] | t[e] << 8;
      }, r.readUInt32LE = function (t, e) {
        return t[e] | t[e + 1] << 8 | t[e + 2] << 16 | 16777216 * t[e + 3];
      }, r.readUInt32BE = function (t, e) {
        return t[e + 3] | t[e + 2] << 8 | t[e + 1] << 16 | 16777216 * t[e];
      }, o.prototype = Object.create(Error.prototype), o.prototype.constructor = o, r.ProbeError = o;
    }, {
      stream: 561,
      "stream-parser": 577
    }],
    506: [function (t, e, r) {
      "use strict";

      function n(t, e) {
        var r = new Error(t);
        return r.code = e, r;
      }

      function i(t) {
        try {
          return decodeURIComponent(escape(t));
        } catch (e) {
          return t;
        }
      }

      function a(t, e, r) {
        this.input = t.subarray(e, r), this.start = e;
        var i = String.fromCharCode.apply(null, this.input.subarray(0, 4));
        if ("II*\0" !== i && "MM\0*" !== i) throw n("invalid TIFF signature", "EBADDATA");
        this.big_endian = "M" === i[0];
      }

      a.prototype.each = function (t) {
        this.aborted = !1;
        var e = this.read_uint32(4);

        for (this.ifds_to_read = [{
          id: 0,
          offset: e
        }]; this.ifds_to_read.length > 0 && !this.aborted;) {
          var r = this.ifds_to_read.shift();
          r.offset && this.scan_ifd(r.id, r.offset, t);
        }
      }, a.prototype.read_uint16 = function (t) {
        var e = this.input;
        if (t + 2 > e.length) throw n("unexpected EOF", "EBADDATA");
        return this.big_endian ? 256 * e[t] + e[t + 1] : e[t] + 256 * e[t + 1];
      }, a.prototype.read_uint32 = function (t) {
        var e = this.input;
        if (t + 4 > e.length) throw n("unexpected EOF", "EBADDATA");
        return this.big_endian ? 16777216 * e[t] + 65536 * e[t + 1] + 256 * e[t + 2] + e[t + 3] : e[t] + 256 * e[t + 1] + 65536 * e[t + 2] + 16777216 * e[t + 3];
      }, a.prototype.is_subifd_link = function (t, e) {
        return 0 === t && 34665 === e || 0 === t && 34853 === e || 34665 === t && 40965 === e;
      }, a.prototype.exif_format_length = function (t) {
        switch (t) {
          case 1:
          case 2:
          case 6:
          case 7:
            return 1;

          case 3:
          case 8:
            return 2;

          case 4:
          case 9:
          case 11:
            return 4;

          case 5:
          case 10:
          case 12:
            return 8;

          default:
            return 0;
        }
      }, a.prototype.exif_format_read = function (t, e) {
        var r;

        switch (t) {
          case 1:
          case 2:
            return r = this.input[e];

          case 6:
            return (r = this.input[e]) | 33554430 * (128 & r);

          case 3:
            return r = this.read_uint16(e);

          case 8:
            return (r = this.read_uint16(e)) | 131070 * (32768 & r);

          case 4:
            return r = this.read_uint32(e);

          case 9:
            return 0 | (r = this.read_uint32(e));

          case 5:
          case 10:
          case 11:
          case 12:
          case 7:
          default:
            return null;
        }
      }, a.prototype.scan_ifd = function (t, e, r) {
        var a = this.read_uint16(e);
        e += 2;

        for (var o = 0; o < a; o++) {
          var s = this.read_uint16(e),
              l = this.read_uint16(e + 2),
              c = this.read_uint32(e + 4),
              u = this.exif_format_length(l),
              f = c * u,
              h = f <= 4 ? e + 8 : this.read_uint32(e + 8),
              p = !1;
          if (h + f > this.input.length) throw n("unexpected EOF", "EBADDATA");

          for (var d = [], m = h, g = 0; g < c; g++, m += u) {
            var v = this.exif_format_read(l, m);

            if (null === v) {
              d = null;
              break;
            }

            d.push(v);
          }

          if (Array.isArray(d) && 2 === l && (d = i(String.fromCharCode.apply(null, d))) && "\0" === d[d.length - 1] && (d = d.slice(0, -1)), this.is_subifd_link(t, s) && Array.isArray(d) && Number.isInteger(d[0]) && d[0] > 0 && (this.ifds_to_read.push({
            id: s,
            offset: d[0]
          }), p = !0), !1 === r({
            is_big_endian: this.big_endian,
            ifd: t,
            tag: s,
            format: l,
            count: c,
            entry_offset: e + this.start,
            data_length: f,
            data_offset: h + this.start,
            value: d,
            is_subifd_link: p
          })) return void (this.aborted = !0);
          e += 12;
        }

        0 === t && this.ifds_to_read.push({
          id: 1,
          offset: this.read_uint32(e)
        });
      }, e.exports.ExifParser = a, e.exports.get_orientation = function (t) {
        var e = 0;

        try {
          return new a(t, 0, t.length).each(function (t) {
            if (0 === t.ifd && 274 === t.tag && Array.isArray(t.value)) return e = t.value[0], !1;
          }), e;
        } catch (t) {
          return -1;
        }
      };
    }, {}],
    507: [function (t, e, r) {
      "use strict";

      var n = t("./common").readUInt16BE,
          i = t("./common").readUInt32BE;

      function a(t, e) {
        if (t.length < 4 + e) return null;
        var r = i(t, e);
        return t.length < r + e || r < 8 ? null : {
          boxtype: String.fromCharCode.apply(null, t.slice(e + 4, e + 8)),
          data: t.slice(e + 8, e + r),
          end: e + r
        };
      }

      function o(t, e) {
        for (var r = 0;;) {
          var n = a(t, r);
          if (!n) break;

          switch (n.boxtype) {
            case "ispe":
              e.sizes.push({
                width: i(n.data, 4),
                height: i(n.data, 8)
              });
              break;

            case "irot":
              e.transforms.push({
                type: "irot",
                value: 3 & n.data[0]
              });
              break;

            case "imir":
              e.transforms.push({
                type: "imir",
                value: 1 & n.data[0]
              });
          }

          r = n.end;
        }
      }

      function s(t, e, r) {
        for (var n = 0, i = 0; i < r; i++) {
          n = 256 * n + (t[e + i] || 0);
        }

        return n;
      }

      function l(t, e) {
        for (var r = t[4] >> 4 & 15, i = 15 & t[4], a = t[5] >> 4 & 15, o = n(t, 6), l = 8, c = 0; c < o; c++) {
          var u = n(t, l),
              f = n(t, l += 2),
              h = s(t, l += 2, a),
              p = n(t, l += a);

          if (l += 2, 0 === f && 1 === p) {
            var d = s(t, l, r),
                m = s(t, l + r, i);
            e.item_loc[u] = {
              length: m,
              offset: d + h
            };
          }

          l += p * (r + i);
        }
      }

      function c(t, e) {
        for (var r = n(t, 4), i = 6, o = 0; o < r; o++) {
          var s = a(t, i);
          if (!s) break;

          if ("infe" === s.boxtype) {
            for (var l = n(s.data, 4), c = "", u = 8; u < s.data.length && s.data[u]; u++) {
              c += String.fromCharCode(s.data[u]);
            }

            e.item_inf[c] = l;
          }

          i = s.end;
        }
      }

      function u(t, e) {
        for (var r = 0;;) {
          var n = a(t, r);
          if (!n) break;
          "ipco" === n.boxtype && o(n.data, e), r = n.end;
        }
      }

      e.exports.unbox = a, e.exports.readSizeFromMeta = function (t) {
        var e = {
          sizes: [],
          transforms: [],
          item_inf: {},
          item_loc: {}
        };

        if (function (t, e) {
          for (var r = 4;;) {
            var n = a(t, r);
            if (!n) break;
            "iprp" === n.boxtype && u(n.data, e), "iloc" === n.boxtype && l(n.data, e), "iinf" === n.boxtype && c(n.data, e), r = n.end;
          }
        }(t, e), e.sizes.length) {
          var r,
              n,
              i,
              o = (r = e.sizes, n = r.reduce(function (t, e) {
            return t.width > e.width || t.width === e.width && t.height > e.height ? t : e;
          }), i = r.reduce(function (t, e) {
            return t.height > e.height || t.height === e.height && t.width > e.width ? t : e;
          }), n.width > i.height || n.width === i.height && n.height > i.width ? n : i),
              s = 1;
          e.transforms.forEach(function (t) {
            var e = {
              1: 6,
              2: 5,
              3: 8,
              4: 7,
              5: 4,
              6: 3,
              7: 2,
              8: 1
            },
                r = {
              1: 4,
              2: 3,
              3: 2,
              4: 1,
              5: 6,
              6: 5,
              7: 8,
              8: 7
            };
            if ("imir" === t.type && (s = 0 === t.value ? r[s] : e[s = e[s = r[s]]]), "irot" === t.type) for (var n = 0; n < t.value; n++) {
              s = e[s];
            }
          });
          var f = null;
          return e.item_inf.Exif && (f = e.item_loc[e.item_inf.Exif]), {
            width: o.width,
            height: o.height,
            orientation: e.transforms.length ? s : null,
            variants: e.sizes,
            exif_location: f
          };
        }
      }, e.exports.getMimeType = function (t) {
        var e = String.fromCharCode.apply(null, t.slice(0, 4)),
            r = {};
        r[e] = !0;

        for (var n = 8; n < t.length; n += 4) {
          r[String.fromCharCode.apply(null, t.slice(n, n + 4))] = !0;
        }

        if (r.mif1 || r.msf1 || r.miaf) return "avif" === e || "avis" === e || "avio" === e ? {
          type: "avif",
          mime: "image/avif"
        } : "heic" === e || "heix" === e ? {
          type: "heic",
          mime: "image/heic"
        } : "hevc" === e || "hevx" === e ? {
          type: "heic",
          mime: "image/heic-sequence"
        } : r.avif || r.avis ? {
          type: "avif",
          mime: "image/avif"
        } : r.heic || r.heix || r.hevc || r.hevx || r.heis ? r.msf1 ? {
          type: "heif",
          mime: "image/heif-sequence"
        } : {
          type: "heif",
          mime: "image/heif"
        } : {
          type: "avif",
          mime: "image/avif"
        };
      };
    }, {
      "./common": 505
    }],
    508: [function (t, e, r) {
      "use strict";

      var n = t("../common").str2arr,
          i = t("../common").sliceEq,
          a = t("../common").readUInt32BE,
          o = t("../miaf_utils"),
          s = t("../exif_utils"),
          l = n("ftyp");

      e.exports = function (t) {
        if (i(t, 4, l)) {
          var e = o.unbox(t, 0);

          if (e) {
            var r = o.getMimeType(e.data);

            if (r) {
              for (var n, c = e.end;;) {
                var u = o.unbox(t, c);
                if (!u) break;
                if (c = u.end, "mdat" === u.boxtype) return;

                if ("meta" === u.boxtype) {
                  n = u.data;
                  break;
                }
              }

              if (n) {
                var f = o.readSizeFromMeta(n);

                if (f) {
                  var h = {
                    width: f.width,
                    height: f.height,
                    type: r.type,
                    mime: r.mime,
                    wUnits: "px",
                    hUnits: "px"
                  };

                  if (f.variants.length > 1 && (h.variants = f.variants), f.orientation && (h.orientation = f.orientation), f.exif_location && f.exif_location.offset + f.exif_location.length <= t.length) {
                    var p = a(t, f.exif_location.offset),
                        d = t.slice(f.exif_location.offset + p + 4, f.exif_location.offset + f.exif_location.length),
                        m = s.get_orientation(d);
                    m > 0 && (h.orientation = m);
                  }

                  return h;
                }
              }
            }
          }
        }
      };
    }, {
      "../common": 505,
      "../exif_utils": 506,
      "../miaf_utils": 507
    }],
    509: [function (t, e, r) {
      "use strict";

      var n = t("../common").str2arr,
          i = t("../common").sliceEq,
          a = t("../common").readUInt16LE,
          o = n("BM");

      e.exports = function (t) {
        if (!(t.length < 26) && i(t, 0, o)) return {
          width: a(t, 18),
          height: a(t, 22),
          type: "bmp",
          mime: "image/bmp",
          wUnits: "px",
          hUnits: "px"
        };
      };
    }, {
      "../common": 505
    }],
    510: [function (t, e, r) {
      "use strict";

      var n = t("../common").str2arr,
          i = t("../common").sliceEq,
          a = t("../common").readUInt16LE,
          o = n("GIF87a"),
          s = n("GIF89a");

      e.exports = function (t) {
        if (!(t.length < 10) && (i(t, 0, o) || i(t, 0, s))) return {
          width: a(t, 6),
          height: a(t, 8),
          type: "gif",
          mime: "image/gif",
          wUnits: "px",
          hUnits: "px"
        };
      };
    }, {
      "../common": 505
    }],
    511: [function (t, e, r) {
      "use strict";

      var n = t("../common").readUInt16LE;

      e.exports = function (t) {
        var e = n(t, 0),
            r = n(t, 2),
            i = n(t, 4);

        if (0 === e && 1 === r && i) {
          for (var a = [], o = {
            width: 0,
            height: 0
          }, s = 0; s < i; s++) {
            var l = t[6 + 16 * s] || 256,
                c = t[6 + 16 * s + 1] || 256,
                u = {
              width: l,
              height: c
            };
            a.push(u), (l > o.width || c > o.height) && (o = u);
          }

          return {
            width: o.width,
            height: o.height,
            variants: a,
            type: "ico",
            mime: "image/x-icon",
            wUnits: "px",
            hUnits: "px"
          };
        }
      };
    }, {
      "../common": 505
    }],
    512: [function (t, e, r) {
      "use strict";

      var n = t("../common").readUInt16BE,
          i = t("../common").str2arr,
          a = t("../common").sliceEq,
          o = t("../exif_utils"),
          s = i("Exif\0\0");

      e.exports = function (t) {
        if (!(t.length < 2) && 255 === t[0] && 216 === t[1]) for (var e = 2;;) {
          if (t.length - e < 2) return;
          if (255 !== t[e++]) return;

          for (var r, i, l = t[e++]; 255 === l;) {
            l = t[e++];
          }

          if (208 <= l && l <= 217 || 1 === l) r = 0;else {
            if (!(192 <= l && l <= 254)) return;
            if (t.length - e < 2) return;
            r = n(t, e) - 2, e += 2;
          }
          if (217 === l || 218 === l) return;

          if (225 === l && r >= 10 && a(t, e, s) && (i = o.get_orientation(t.slice(e + 6, e + r))), r >= 5 && 192 <= l && l <= 207 && 196 !== l && 200 !== l && 204 !== l) {
            if (t.length - e < r) return;
            var c = {
              width: n(t, e + 3),
              height: n(t, e + 1),
              type: "jpg",
              mime: "image/jpeg",
              wUnits: "px",
              hUnits: "px"
            };
            return i > 0 && (c.orientation = i), c;
          }

          e += r;
        }
      };
    }, {
      "../common": 505,
      "../exif_utils": 506
    }],
    513: [function (t, e, r) {
      "use strict";

      var n = t("../common").str2arr,
          i = t("../common").sliceEq,
          a = t("../common").readUInt32BE,
          o = n("\x89PNG\r\n\x1a\n"),
          s = n("IHDR");

      e.exports = function (t) {
        if (!(t.length < 24) && i(t, 0, o) && i(t, 12, s)) return {
          width: a(t, 16),
          height: a(t, 20),
          type: "png",
          mime: "image/png",
          wUnits: "px",
          hUnits: "px"
        };
      };
    }, {
      "../common": 505
    }],
    514: [function (t, e, r) {
      "use strict";

      var n = t("../common").str2arr,
          i = t("../common").sliceEq,
          a = t("../common").readUInt32BE,
          o = n("8BPS\0\x01");

      e.exports = function (t) {
        if (!(t.length < 22) && i(t, 0, o)) return {
          width: a(t, 18),
          height: a(t, 14),
          type: "psd",
          mime: "image/vnd.adobe.photoshop",
          wUnits: "px",
          hUnits: "px"
        };
      };
    }, {
      "../common": 505
    }],
    515: [function (t, e, r) {
      "use strict";

      function n(t) {
        return "number" == typeof t && isFinite(t) && t > 0;
      }

      var i = /<svg\s[^>]+>/,
          a = /[^-]\bwidth="([^%]+?)"|[^-]\bwidth='([^%]+?)'/,
          o = /\bheight="([^%]+?)"|\bheight='([^%]+?)'/,
          s = /\bview[bB]ox="(.+?)"|\bview[bB]ox='(.+?)'/,
          l = /in$|mm$|cm$|pt$|pc$|px$|em$|ex$/;

      function c(t) {
        return l.test(t) ? t.match(l)[0] : "px";
      }

      e.exports = function (t) {
        if (function (t) {
          for (var e, r = 0, n = t.length; r < n && (32 === (e = t[r]) || 9 === e || 13 === e || 10 === e);) {
            r++;
          }

          return r !== n && 60 === t[r];
        }(t)) {
          for (var e = "", r = 0; r < t.length; r++) {
            e += String.fromCharCode(t[r]);
          }

          if (i.test(e)) {
            var l = function (t) {
              var e = t.match(a),
                  r = t.match(o),
                  n = t.match(s);
              return {
                width: e && (e[1] || e[2]),
                height: r && (r[1] || r[2]),
                viewbox: n && (n[1] || n[2])
              };
            }(e.match(i)[0]),
                u = parseFloat(l.width),
                f = parseFloat(l.height);

            if (l.width && l.height) {
              if (!n(u) || !n(f)) return;
              return {
                width: u,
                height: f,
                type: "svg",
                mime: "image/svg+xml",
                wUnits: c(l.width),
                hUnits: c(l.height)
              };
            }

            var h = (l.viewbox || "").split(" "),
                p = {
              width: h[2],
              height: h[3]
            },
                d = parseFloat(p.width),
                m = parseFloat(p.height);

            if (n(d) && n(m) && c(p.width) === c(p.height)) {
              var g = d / m;

              if (l.width) {
                if (!n(u)) return;
                return {
                  width: u,
                  height: u / g,
                  type: "svg",
                  mime: "image/svg+xml",
                  wUnits: c(l.width),
                  hUnits: c(l.width)
                };
              }

              if (l.height) {
                if (!n(f)) return;
                return {
                  width: f * g,
                  height: f,
                  type: "svg",
                  mime: "image/svg+xml",
                  wUnits: c(l.height),
                  hUnits: c(l.height)
                };
              }

              return {
                width: d,
                height: m,
                type: "svg",
                mime: "image/svg+xml",
                wUnits: c(p.width),
                hUnits: c(p.height)
              };
            }
          }
        }
      };
    }, {}],
    516: [function (t, e, r) {
      "use strict";

      var n = t("../common").str2arr,
          i = t("../common").sliceEq,
          a = t("../common").readUInt16LE,
          o = t("../common").readUInt16BE,
          s = t("../common").readUInt32LE,
          l = t("../common").readUInt32BE,
          c = n("II*\0"),
          u = n("MM\0*");

      function f(t, e, r) {
        return r ? o(t, e) : a(t, e);
      }

      function h(t, e, r) {
        return r ? l(t, e) : s(t, e);
      }

      function p(t, e, r) {
        var n = f(t, e + 2, r);
        return 1 !== h(t, e + 4, r) || 3 !== n && 4 !== n ? null : 3 === n ? f(t, e + 8, r) : h(t, e + 8, r);
      }

      e.exports = function (t) {
        if (!(t.length < 8) && (i(t, 0, c) || i(t, 0, u))) {
          var e = 77 === t[0],
              r = h(t, 4, e) - 8;

          if (!(r < 0)) {
            var n = r + 8;

            if (!(t.length - n < 2)) {
              var a = 12 * f(t, n + 0, e);

              if (!(a <= 0 || (n += 2, t.length - n < a))) {
                var o, s, l, d;

                for (o = 0; o < a; o += 12) {
                  256 === (d = f(t, n + o, e)) ? s = p(t, n + o, e) : 257 === d && (l = p(t, n + o, e));
                }

                return s && l ? {
                  width: s,
                  height: l,
                  type: "tiff",
                  mime: "image/tiff",
                  wUnits: "px",
                  hUnits: "px"
                } : void 0;
              }
            }
          }
        }
      };
    }, {
      "../common": 505
    }],
    517: [function (t, e, r) {
      "use strict";

      var n = t("../common").str2arr,
          i = t("../common").sliceEq,
          a = t("../common").readUInt16LE,
          o = t("../common").readUInt32LE,
          s = t("../exif_utils"),
          l = n("RIFF"),
          c = n("WEBP");

      function u(t, e) {
        if (157 === t[e + 3] && 1 === t[e + 4] && 42 === t[e + 5]) return {
          width: 16383 & a(t, e + 6),
          height: 16383 & a(t, e + 8),
          type: "webp",
          mime: "image/webp",
          wUnits: "px",
          hUnits: "px"
        };
      }

      function f(t, e) {
        if (47 === t[e]) {
          var r = o(t, e + 1);
          return {
            width: 1 + (16383 & r),
            height: 1 + (r >> 14 & 16383),
            type: "webp",
            mime: "image/webp",
            wUnits: "px",
            hUnits: "px"
          };
        }
      }

      function h(t, e) {
        return {
          width: 1 + (t[e + 6] << 16 | t[e + 5] << 8 | t[e + 4]),
          height: 1 + (t[e + 9] << e | t[e + 8] << 8 | t[e + 7]),
          type: "webp",
          mime: "image/webp",
          wUnits: "px",
          hUnits: "px"
        };
      }

      e.exports = function (t) {
        if (!(t.length < 16) && (i(t, 0, l) || i(t, 8, c))) {
          var e = 12,
              r = null,
              n = 0,
              a = o(t, 4) + 8;

          if (!(a > t.length)) {
            for (; e + 8 < a;) {
              if (0 !== t[e]) {
                var p = String.fromCharCode.apply(null, t.slice(e, e + 4)),
                    d = o(t, e + 4);
                "VP8 " === p && d >= 10 ? r = r || u(t, e + 8) : "VP8L" === p && d >= 9 ? r = r || f(t, e + 8) : "VP8X" === p && d >= 10 ? r = r || h(t, e + 8) : "EXIF" === p && (n = s.get_orientation(t.slice(e + 8, e + 8 + d)), e = 1 / 0), e += 8 + d;
              } else e++;
            }

            if (r) return n > 0 && (r.orientation = n), r;
          }
        }
      };
    }, {
      "../common": 505,
      "../exif_utils": 506
    }],
    518: [function (t, e, r) {
      "use strict";

      e.exports = {
        avif: t("./parse_sync/avif"),
        bmp: t("./parse_sync/bmp"),
        gif: t("./parse_sync/gif"),
        ico: t("./parse_sync/ico"),
        jpeg: t("./parse_sync/jpeg"),
        png: t("./parse_sync/png"),
        psd: t("./parse_sync/psd"),
        svg: t("./parse_sync/svg"),
        tiff: t("./parse_sync/tiff"),
        webp: t("./parse_sync/webp")
      };
    }, {
      "./parse_sync/avif": 508,
      "./parse_sync/bmp": 509,
      "./parse_sync/gif": 510,
      "./parse_sync/ico": 511,
      "./parse_sync/jpeg": 512,
      "./parse_sync/png": 513,
      "./parse_sync/psd": 514,
      "./parse_sync/svg": 515,
      "./parse_sync/tiff": 516,
      "./parse_sync/webp": 517
    }],
    519: [function (t, e, r) {
      "use strict";

      var n = t("./lib/parsers_sync");
      e.exports = function (t) {
        return function (t) {
          for (var e = Object.keys(n), r = 0; r < e.length; r++) {
            var i = n[e[r]](t);
            if (i) return i;
          }

          return null;
        }(t);
      }, e.exports.parsers = n;
    }, {
      "./lib/parsers_sync": 518
    }],
    520: [function (t, e, r) {
      var n,
          i,
          a = e.exports = {};

      function o() {
        throw new Error("setTimeout has not been defined");
      }

      function s() {
        throw new Error("clearTimeout has not been defined");
      }

      function l(t) {
        if (n === setTimeout) return setTimeout(t, 0);
        if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(t, 0);

        try {
          return n(t, 0);
        } catch (e) {
          try {
            return n.call(null, t, 0);
          } catch (e) {
            return n.call(this, t, 0);
          }
        }
      }

      !function () {
        try {
          n = "function" == typeof setTimeout ? setTimeout : o;
        } catch (t) {
          n = o;
        }

        try {
          i = "function" == typeof clearTimeout ? clearTimeout : s;
        } catch (t) {
          i = s;
        }
      }();
      var c,
          u = [],
          f = !1,
          h = -1;

      function p() {
        f && c && (f = !1, c.length ? u = c.concat(u) : h = -1, u.length && d());
      }

      function d() {
        if (!f) {
          var t = l(p);
          f = !0;

          for (var e = u.length; e;) {
            for (c = u, u = []; ++h < e;) {
              c && c[h].run();
            }

            h = -1, e = u.length;
          }

          c = null, f = !1, function (t) {
            if (i === clearTimeout) return clearTimeout(t);
            if ((i === s || !i) && clearTimeout) return i = clearTimeout, clearTimeout(t);

            try {
              i(t);
            } catch (e) {
              try {
                return i.call(null, t);
              } catch (e) {
                return i.call(this, t);
              }
            }
          }(t);
        }
      }

      function m(t, e) {
        this.fun = t, this.array = e;
      }

      function g() {}

      a.nextTick = function (t) {
        var e = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
          e[r - 1] = arguments[r];
        }
        u.push(new m(t, e)), 1 !== u.length || f || l(d);
      }, m.prototype.run = function () {
        this.fun.apply(null, this.array);
      }, a.title = "browser", a.browser = !0, a.env = {}, a.argv = [], a.version = "", a.versions = {}, a.on = g, a.addListener = g, a.once = g, a.off = g, a.removeListener = g, a.removeAllListeners = g, a.emit = g, a.prependListener = g, a.prependOnceListener = g, a.listeners = function (t) {
        return [];
      }, a.binding = function (t) {
        throw new Error("process.binding is not supported");
      }, a.cwd = function () {
        return "/";
      }, a.chdir = function (t) {
        throw new Error("process.chdir is not supported");
      }, a.umask = function () {
        return 0;
      };
    }, {}],
    521: [function (t, e, r) {
      e.exports = t("gl-quat/slerp");
    }, {
      "gl-quat/slerp": 320
    }],
    522: [function (t, e, r) {
      (function (r) {
        (function () {
          for (var n = t("performance-now"), i = "undefined" == typeof window ? r : window, a = ["moz", "webkit"], o = "AnimationFrame", s = i["request" + o], l = i["cancel" + o] || i["cancelRequest" + o], c = 0; !s && c < a.length; c++) {
            s = i[a[c] + "Request" + o], l = i[a[c] + "Cancel" + o] || i[a[c] + "CancelRequest" + o];
          }

          if (!s || !l) {
            var u = 0,
                f = 0,
                h = [];
            s = function s(t) {
              if (0 === h.length) {
                var e = n(),
                    r = Math.max(0, 1e3 / 60 - (e - u));
                u = r + e, setTimeout(function () {
                  var t = h.slice(0);
                  h.length = 0;

                  for (var e = 0; e < t.length; e++) {
                    if (!t[e].cancelled) try {
                      t[e].callback(u);
                    } catch (t) {
                      setTimeout(function () {
                        throw t;
                      }, 0);
                    }
                  }
                }, Math.round(r));
              }

              return h.push({
                handle: ++f,
                callback: t,
                cancelled: !1
              }), f;
            }, l = function l(t) {
              for (var e = 0; e < h.length; e++) {
                h[e].handle === t && (h[e].cancelled = !0);
              }
            };
          }

          e.exports = function (t) {
            return s.call(i, t);
          }, e.exports.cancel = function () {
            l.apply(i, arguments);
          }, e.exports.polyfill = function (t) {
            t || (t = i), t.requestAnimationFrame = s, t.cancelAnimationFrame = l;
          };
        }).call(this);
      }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
    }, {
      "performance-now": 487
    }],
    523: [function (t, e, r) {
      "use strict";

      var n = t("big-rat/add");

      e.exports = function (t, e) {
        for (var r = t.length, i = new Array(r), a = 0; a < r; ++a) {
          i[a] = n(t[a], e[a]);
        }

        return i;
      };
    }, {
      "big-rat/add": 82
    }],
    524: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        for (var e = new Array(t.length), r = 0; r < t.length; ++r) {
          e[r] = n(t[r]);
        }

        return e;
      };

      var n = t("big-rat");
    }, {
      "big-rat": 85
    }],
    525: [function (t, e, r) {
      "use strict";

      var n = t("big-rat"),
          i = t("big-rat/mul");

      e.exports = function (t, e) {
        for (var r = n(e), a = t.length, o = new Array(a), s = 0; s < a; ++s) {
          o[s] = i(t[s], r);
        }

        return o;
      };
    }, {
      "big-rat": 85,
      "big-rat/mul": 94
    }],
    526: [function (t, e, r) {
      "use strict";

      var n = t("big-rat/sub");

      e.exports = function (t, e) {
        for (var r = t.length, i = new Array(r), a = 0; a < r; ++a) {
          i[a] = n(t[a], e[a]);
        }

        return i;
      };
    }, {
      "big-rat/sub": 96
    }],
    527: [function (t, e, r) {
      "use strict";

      var n = t("compare-cell"),
          i = t("compare-oriented-cell"),
          a = t("cell-orientation");

      e.exports = function (t) {
        t.sort(i);

        for (var e = t.length, r = 0, o = 0; o < e; ++o) {
          var s = t[o],
              l = a(s);

          if (0 !== l) {
            if (r > 0) {
              var c = t[r - 1];

              if (0 === n(s, c) && a(c) !== l) {
                r -= 1;
                continue;
              }
            }

            t[r++] = s;
          }
        }

        return t.length = r, t;
      };
    }, {
      "cell-orientation": 118,
      "compare-cell": 134,
      "compare-oriented-cell": 135
    }],
    528: [function (t, e, r) {
      "use strict";

      var n = t("array-bounds"),
          i = t("color-normalize"),
          a = t("update-diff"),
          o = t("pick-by-alias"),
          s = t("object-assign"),
          l = t("flatten-vertex-data"),
          c = t("to-float32"),
          u = c.float32,
          f = c.fract32;

      e.exports = function (t, e) {
        "function" == typeof t ? (e || (e = {}), e.regl = t) : e = t;
        e.length && (e.positions = e);
        if (!(t = e.regl).hasExtension("ANGLE_instanced_arrays")) throw Error("regl-error2d: `ANGLE_instanced_arrays` extension should be enabled");
        var r,
            c,
            p,
            d,
            m,
            g,
            v = t._gl,
            y = {
          color: "black",
          capSize: 5,
          lineWidth: 1,
          opacity: 1,
          viewport: null,
          range: null,
          offset: 0,
          count: 0,
          bounds: null,
          positions: [],
          errors: []
        },
            x = [];
        return d = t.buffer({
          usage: "dynamic",
          type: "uint8",
          data: new Uint8Array(0)
        }), c = t.buffer({
          usage: "dynamic",
          type: "float",
          data: new Uint8Array(0)
        }), p = t.buffer({
          usage: "dynamic",
          type: "float",
          data: new Uint8Array(0)
        }), m = t.buffer({
          usage: "dynamic",
          type: "float",
          data: new Uint8Array(0)
        }), g = t.buffer({
          usage: "static",
          type: "float",
          data: h
        }), T(e), r = t({
          vert: "\n\t\tprecision highp float;\n\n\t\tattribute vec2 position, positionFract;\n\t\tattribute vec4 error;\n\t\tattribute vec4 color;\n\n\t\tattribute vec2 direction, lineOffset, capOffset;\n\n\t\tuniform vec4 viewport;\n\t\tuniform float lineWidth, capSize;\n\t\tuniform vec2 scale, scaleFract, translate, translateFract;\n\n\t\tvarying vec4 fragColor;\n\n\t\tvoid main() {\n\t\t\tfragColor = color / 255.;\n\n\t\t\tvec2 pixelOffset = lineWidth * lineOffset + (capSize + lineWidth) * capOffset;\n\n\t\t\tvec2 dxy = -step(.5, direction.xy) * error.xz + step(direction.xy, vec2(-.5)) * error.yw;\n\n\t\t\tvec2 position = position + dxy;\n\n\t\t\tvec2 pos = (position + translate) * scale\n\t\t\t\t+ (positionFract + translateFract) * scale\n\t\t\t\t+ (position + translate) * scaleFract\n\t\t\t\t+ (positionFract + translateFract) * scaleFract;\n\n\t\t\tpos += pixelOffset / viewport.zw;\n\n\t\t\tgl_Position = vec4(pos * 2. - 1., 0, 1);\n\t\t}\n\t\t",
          frag: "\n\t\tprecision highp float;\n\n\t\tvarying vec4 fragColor;\n\n\t\tuniform float opacity;\n\n\t\tvoid main() {\n\t\t\tgl_FragColor = fragColor;\n\t\t\tgl_FragColor.a *= opacity;\n\t\t}\n\t\t",
          uniforms: {
            range: t.prop("range"),
            lineWidth: t.prop("lineWidth"),
            capSize: t.prop("capSize"),
            opacity: t.prop("opacity"),
            scale: t.prop("scale"),
            translate: t.prop("translate"),
            scaleFract: t.prop("scaleFract"),
            translateFract: t.prop("translateFract"),
            viewport: function viewport(t, e) {
              return [e.viewport.x, e.viewport.y, t.viewportWidth, t.viewportHeight];
            }
          },
          attributes: {
            color: {
              buffer: d,
              offset: function offset(t, e) {
                return 4 * e.offset;
              },
              divisor: 1
            },
            position: {
              buffer: c,
              offset: function offset(t, e) {
                return 8 * e.offset;
              },
              divisor: 1
            },
            positionFract: {
              buffer: p,
              offset: function offset(t, e) {
                return 8 * e.offset;
              },
              divisor: 1
            },
            error: {
              buffer: m,
              offset: function offset(t, e) {
                return 16 * e.offset;
              },
              divisor: 1
            },
            direction: {
              buffer: g,
              stride: 24,
              offset: 0
            },
            lineOffset: {
              buffer: g,
              stride: 24,
              offset: 8
            },
            capOffset: {
              buffer: g,
              stride: 24,
              offset: 16
            }
          },
          primitive: "triangles",
          blend: {
            enable: !0,
            color: [0, 0, 0, 0],
            equation: {
              rgb: "add",
              alpha: "add"
            },
            func: {
              srcRGB: "src alpha",
              dstRGB: "one minus src alpha",
              srcAlpha: "one minus dst alpha",
              dstAlpha: "one"
            }
          },
          depth: {
            enable: !1
          },
          scissor: {
            enable: !0,
            box: t.prop("viewport")
          },
          viewport: t.prop("viewport"),
          stencil: !1,
          instances: t.prop("count"),
          count: h.length
        }), s(b, {
          update: T,
          draw: _,
          destroy: k,
          regl: t,
          gl: v,
          canvas: v.canvas,
          groups: x
        }), b;

        function b(t) {
          t ? T(t) : null === t && k(), _();
        }

        function _(e) {
          if ("number" == typeof e) return w(e);
          e && !Array.isArray(e) && (e = [e]), t._refresh(), x.forEach(function (t, r) {
            t && (e && (e[r] ? t.draw = !0 : t.draw = !1), t.draw ? w(r) : t.draw = !0);
          });
        }

        function w(t) {
          "number" == typeof t && (t = x[t]), null != t && t && t.count && t.color && t.opacity && t.positions && t.positions.length > 1 && (t.scaleRatio = [t.scale[0] * t.viewport.width, t.scale[1] * t.viewport.height], r(t), t.after && t.after(t));
        }

        function T(t) {
          if (t) {
            null != t.length ? "number" == typeof t[0] && (t = [{
              positions: t
            }]) : Array.isArray(t) || (t = [t]);
            var e = 0,
                r = 0;

            if (b.groups = x = t.map(function (t, c) {
              var u = x[c];
              return t ? ("function" == typeof t ? t = {
                after: t
              } : "number" == typeof t[0] && (t = {
                positions: t
              }), t = o(t, {
                color: "color colors fill",
                capSize: "capSize cap capsize cap-size",
                lineWidth: "lineWidth line-width width line thickness",
                opacity: "opacity alpha",
                range: "range dataBox",
                viewport: "viewport viewBox",
                errors: "errors error",
                positions: "positions position data points"
              }), u || (x[c] = u = {
                id: c,
                scale: null,
                translate: null,
                scaleFract: null,
                translateFract: null,
                draw: !0
              }, t = s({}, y, t)), a(u, t, [{
                lineWidth: function lineWidth(t) {
                  return .5 * +t;
                },
                capSize: function capSize(t) {
                  return .5 * +t;
                },
                opacity: parseFloat,
                errors: function errors(t) {
                  return t = l(t), r += t.length, t;
                },
                positions: function positions(t, r) {
                  return t = l(t, "float64"), r.count = Math.floor(t.length / 2), r.bounds = n(t, 2), r.offset = e, e += r.count, t;
                }
              }, {
                color: function color(t, e) {
                  var r = e.count;

                  if (t || (t = "transparent"), !Array.isArray(t) || "number" == typeof t[0]) {
                    var n = t;
                    t = Array(r);

                    for (var a = 0; a < r; a++) {
                      t[a] = n;
                    }
                  }

                  if (t.length < r) throw Error("Not enough colors");

                  for (var o = new Uint8Array(4 * r), s = 0; s < r; s++) {
                    var l = i(t[s], "uint8");
                    o.set(l, 4 * s);
                  }

                  return o;
                },
                range: function range(t, e, r) {
                  var n = e.bounds;
                  return t || (t = n), e.scale = [1 / (t[2] - t[0]), 1 / (t[3] - t[1])], e.translate = [-t[0], -t[1]], e.scaleFract = f(e.scale), e.translateFract = f(e.translate), t;
                },
                viewport: function viewport(t) {
                  var e;
                  return Array.isArray(t) ? e = {
                    x: t[0],
                    y: t[1],
                    width: t[2] - t[0],
                    height: t[3] - t[1]
                  } : t ? (e = {
                    x: t.x || t.left || 0,
                    y: t.y || t.top || 0
                  }, t.right ? e.width = t.right - e.x : e.width = t.w || t.width || 0, t.bottom ? e.height = t.bottom - e.y : e.height = t.h || t.height || 0) : e = {
                    x: 0,
                    y: 0,
                    width: v.drawingBufferWidth,
                    height: v.drawingBufferHeight
                  }, e;
                }
              }]), u) : u;
            }), e || r) {
              var h = x.reduce(function (t, e, r) {
                return t + (e ? e.count : 0);
              }, 0),
                  g = new Float64Array(2 * h),
                  _ = new Uint8Array(4 * h),
                  w = new Float32Array(4 * h);

              x.forEach(function (t, e) {
                if (t) {
                  var r = t.positions,
                      n = t.count,
                      i = t.offset,
                      a = t.color,
                      o = t.errors;
                  n && (_.set(a, 4 * i), w.set(o, 4 * i), g.set(r, 2 * i));
                }
              }), c(u(g)), p(f(g)), d(_), m(w);
            }
          }
        }

        function k() {
          c.destroy(), p.destroy(), d.destroy(), m.destroy(), g.destroy();
        }
      };

      var h = [[1, 0, 0, 1, 0, 0], [1, 0, 0, -1, 0, 0], [-1, 0, 0, -1, 0, 0], [-1, 0, 0, -1, 0, 0], [-1, 0, 0, 1, 0, 0], [1, 0, 0, 1, 0, 0], [1, 0, -1, 0, 0, 1], [1, 0, -1, 0, 0, -1], [1, 0, 1, 0, 0, -1], [1, 0, 1, 0, 0, -1], [1, 0, 1, 0, 0, 1], [1, 0, -1, 0, 0, 1], [-1, 0, -1, 0, 0, 1], [-1, 0, -1, 0, 0, -1], [-1, 0, 1, 0, 0, -1], [-1, 0, 1, 0, 0, -1], [-1, 0, 1, 0, 0, 1], [-1, 0, -1, 0, 0, 1], [0, 1, 1, 0, 0, 0], [0, 1, -1, 0, 0, 0], [0, -1, -1, 0, 0, 0], [0, -1, -1, 0, 0, 0], [0, 1, 1, 0, 0, 0], [0, -1, 1, 0, 0, 0], [0, 1, 0, -1, 1, 0], [0, 1, 0, -1, -1, 0], [0, 1, 0, 1, -1, 0], [0, 1, 0, 1, 1, 0], [0, 1, 0, -1, 1, 0], [0, 1, 0, 1, -1, 0], [0, -1, 0, -1, 1, 0], [0, -1, 0, -1, -1, 0], [0, -1, 0, 1, -1, 0], [0, -1, 0, 1, 1, 0], [0, -1, 0, -1, 1, 0], [0, -1, 0, 1, -1, 0]];
    }, {
      "array-bounds": 71,
      "color-normalize": 126,
      "flatten-vertex-data": 243,
      "object-assign": 479,
      "pick-by-alias": 490,
      "to-float32": 591,
      "update-diff": 613
    }],
    529: [function (t, e, r) {
      "use strict";

      var n = t("color-normalize"),
          i = t("array-bounds"),
          a = t("object-assign"),
          o = t("glslify"),
          s = t("pick-by-alias"),
          l = t("flatten-vertex-data"),
          c = t("earcut"),
          u = t("array-normalize"),
          f = t("to-float32"),
          h = f.float32,
          p = f.fract32,
          d = t("es6-weak-map"),
          m = t("parse-rect"),
          g = t("array-find-index");

      function v(t, e) {
        if (!(this instanceof v)) return new v(t, e);
        if ("function" == typeof t ? (e || (e = {}), e.regl = t) : e = t, e.length && (e.positions = e), !(t = e.regl).hasExtension("ANGLE_instanced_arrays")) throw Error("regl-error2d: `ANGLE_instanced_arrays` extension should be enabled");
        this.gl = t._gl, this.regl = t, this.passes = [], this.shaders = v.shaders.has(t) ? v.shaders.get(t) : v.shaders.set(t, v.createShaders(t)).get(t), this.update(e);
      }

      e.exports = v, v.dashMult = 2, v.maxPatternLength = 256, v.precisionThreshold = 3e6, v.maxPoints = 1e4, v.maxLines = 2048, v.shaders = new d(), v.createShaders = function (t) {
        var e,
            r = t.buffer({
          usage: "static",
          type: "float",
          data: [0, 1, 0, 0, 1, 1, 1, 0]
        }),
            n = {
          primitive: "triangle strip",
          instances: t.prop("count"),
          count: 4,
          offset: 0,
          uniforms: {
            miterMode: function miterMode(t, e) {
              return "round" === e.join ? 2 : 1;
            },
            miterLimit: t.prop("miterLimit"),
            scale: t.prop("scale"),
            scaleFract: t.prop("scaleFract"),
            translateFract: t.prop("translateFract"),
            translate: t.prop("translate"),
            thickness: t.prop("thickness"),
            dashPattern: t.prop("dashTexture"),
            opacity: t.prop("opacity"),
            pixelRatio: t.context("pixelRatio"),
            id: t.prop("id"),
            dashSize: t.prop("dashLength"),
            viewport: function viewport(t, e) {
              return [e.viewport.x, e.viewport.y, t.viewportWidth, t.viewportHeight];
            },
            depth: t.prop("depth")
          },
          blend: {
            enable: !0,
            color: [0, 0, 0, 0],
            equation: {
              rgb: "add",
              alpha: "add"
            },
            func: {
              srcRGB: "src alpha",
              dstRGB: "one minus src alpha",
              srcAlpha: "one minus dst alpha",
              dstAlpha: "one"
            }
          },
          depth: {
            enable: function enable(t, e) {
              return !e.overlay;
            }
          },
          stencil: {
            enable: !1
          },
          scissor: {
            enable: !0,
            box: t.prop("viewport")
          },
          viewport: t.prop("viewport")
        },
            i = t(a({
          vert: o(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec2 aCoord, bCoord, aCoordFract, bCoordFract;\nattribute vec4 color;\nattribute float lineEnd, lineTop;\n\nuniform vec2 scale, scaleFract, translate, translateFract;\nuniform float thickness, pixelRatio, id, depth;\nuniform vec4 viewport;\n\nvarying vec4 fragColor;\nvarying vec2 tangent;\n\nvec2 project(vec2 position, vec2 positionFract, vec2 scale, vec2 scaleFract, vec2 translate, vec2 translateFract) {\n\t// the order is important\n\treturn position * scale + translate\n       + positionFract * scale + translateFract\n       + position * scaleFract\n       + positionFract * scaleFract;\n}\n\nvoid main() {\n\tfloat lineStart = 1. - lineEnd;\n\tfloat lineOffset = lineTop * 2. - 1.;\n\n\tvec2 diff = (bCoord + bCoordFract - aCoord - aCoordFract);\n\ttangent = normalize(diff * scale * viewport.zw);\n\tvec2 normal = vec2(-tangent.y, tangent.x);\n\n\tvec2 position = project(aCoord, aCoordFract, scale, scaleFract, translate, translateFract) * lineStart\n\t\t+ project(bCoord, bCoordFract, scale, scaleFract, translate, translateFract) * lineEnd\n\n\t\t+ thickness * normal * .5 * lineOffset / viewport.zw;\n\n\tgl_Position = vec4(position * 2.0 - 1.0, depth, 1);\n\n\tfragColor = color / 255.;\n}\n"]),
          frag: o(["precision highp float;\n#define GLSLIFY 1\n\nuniform sampler2D dashPattern;\n\nuniform float dashSize, pixelRatio, thickness, opacity, id;\n\nvarying vec4 fragColor;\nvarying vec2 tangent;\n\nvoid main() {\n\tfloat alpha = 1.;\n\n\tfloat t = fract(dot(tangent, gl_FragCoord.xy) / dashSize) * .5 + .25;\n\tfloat dash = texture2D(dashPattern, vec2(t, .5)).r;\n\n\tgl_FragColor = fragColor;\n\tgl_FragColor.a *= alpha * opacity * dash;\n}\n"]),
          attributes: {
            lineEnd: {
              buffer: r,
              divisor: 0,
              stride: 8,
              offset: 0
            },
            lineTop: {
              buffer: r,
              divisor: 0,
              stride: 8,
              offset: 4
            },
            aCoord: {
              buffer: t.prop("positionBuffer"),
              stride: 8,
              offset: 8,
              divisor: 1
            },
            bCoord: {
              buffer: t.prop("positionBuffer"),
              stride: 8,
              offset: 16,
              divisor: 1
            },
            aCoordFract: {
              buffer: t.prop("positionFractBuffer"),
              stride: 8,
              offset: 8,
              divisor: 1
            },
            bCoordFract: {
              buffer: t.prop("positionFractBuffer"),
              stride: 8,
              offset: 16,
              divisor: 1
            },
            color: {
              buffer: t.prop("colorBuffer"),
              stride: 4,
              offset: 0,
              divisor: 1
            }
          }
        }, n));

        try {
          e = t(a({
            cull: {
              enable: !0,
              face: "back"
            },
            vert: o(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec2 aCoord, bCoord, nextCoord, prevCoord;\nattribute vec4 aColor, bColor;\nattribute float lineEnd, lineTop;\n\nuniform vec2 scale, translate;\nuniform float thickness, pixelRatio, id, depth;\nuniform vec4 viewport;\nuniform float miterLimit, miterMode;\n\nvarying vec4 fragColor;\nvarying vec4 startCutoff, endCutoff;\nvarying vec2 tangent;\nvarying vec2 startCoord, endCoord;\nvarying float enableStartMiter, enableEndMiter;\n\nconst float REVERSE_THRESHOLD = -.875;\nconst float MIN_DIFF = 1e-6;\n\n// TODO: possible optimizations: avoid overcalculating all for vertices and calc just one instead\n// TODO: precalculate dot products, normalize things beforehead etc.\n// TODO: refactor to rectangular algorithm\n\nfloat distToLine(vec2 p, vec2 a, vec2 b) {\n\tvec2 diff = b - a;\n\tvec2 perp = normalize(vec2(-diff.y, diff.x));\n\treturn dot(p - a, perp);\n}\n\nbool isNaN( float val ){\n  return ( val < 0.0 || 0.0 < val || val == 0.0 ) ? false : true;\n}\n\nvoid main() {\n\tvec2 aCoord = aCoord, bCoord = bCoord, prevCoord = prevCoord, nextCoord = nextCoord;\n\n  vec2 adjustedScale;\n  adjustedScale.x = (abs(scale.x) < MIN_DIFF) ? MIN_DIFF : scale.x;\n  adjustedScale.y = (abs(scale.y) < MIN_DIFF) ? MIN_DIFF : scale.y;\n\n  vec2 scaleRatio = adjustedScale * viewport.zw;\n\tvec2 normalWidth = thickness / scaleRatio;\n\n\tfloat lineStart = 1. - lineEnd;\n\tfloat lineBot = 1. - lineTop;\n\n\tfragColor = (lineStart * aColor + lineEnd * bColor) / 255.;\n\n\tif (isNaN(aCoord.x) || isNaN(aCoord.y) || isNaN(bCoord.x) || isNaN(bCoord.y)) return;\n\n\tif (aCoord == prevCoord) prevCoord = aCoord + normalize(bCoord - aCoord);\n\tif (bCoord == nextCoord) nextCoord = bCoord - normalize(bCoord - aCoord);\n\n\tvec2 prevDiff = aCoord - prevCoord;\n\tvec2 currDiff = bCoord - aCoord;\n\tvec2 nextDiff = nextCoord - bCoord;\n\n\tvec2 prevTangent = normalize(prevDiff * scaleRatio);\n\tvec2 currTangent = normalize(currDiff * scaleRatio);\n\tvec2 nextTangent = normalize(nextDiff * scaleRatio);\n\n\tvec2 prevNormal = vec2(-prevTangent.y, prevTangent.x);\n\tvec2 currNormal = vec2(-currTangent.y, currTangent.x);\n\tvec2 nextNormal = vec2(-nextTangent.y, nextTangent.x);\n\n\tvec2 startJoinDirection = normalize(prevTangent - currTangent);\n\tvec2 endJoinDirection = normalize(currTangent - nextTangent);\n\n\t// collapsed/unidirectional segment cases\n\t// FIXME: there should be more elegant solution\n\tvec2 prevTanDiff = abs(prevTangent - currTangent);\n\tvec2 nextTanDiff = abs(nextTangent - currTangent);\n\tif (max(prevTanDiff.x, prevTanDiff.y) < MIN_DIFF) {\n\t\tstartJoinDirection = currNormal;\n\t}\n\tif (max(nextTanDiff.x, nextTanDiff.y) < MIN_DIFF) {\n\t\tendJoinDirection = currNormal;\n\t}\n\tif (aCoord == bCoord) {\n\t\tendJoinDirection = startJoinDirection;\n\t\tcurrNormal = prevNormal;\n\t\tcurrTangent = prevTangent;\n\t}\n\n\ttangent = currTangent;\n\n\t//calculate join shifts relative to normals\n\tfloat startJoinShift = dot(currNormal, startJoinDirection);\n\tfloat endJoinShift = dot(currNormal, endJoinDirection);\n\n\tfloat startMiterRatio = abs(1. / startJoinShift);\n\tfloat endMiterRatio = abs(1. / endJoinShift);\n\n\tvec2 startJoin = startJoinDirection * startMiterRatio;\n\tvec2 endJoin = endJoinDirection * endMiterRatio;\n\n\tvec2 startTopJoin, startBotJoin, endTopJoin, endBotJoin;\n\tstartTopJoin = sign(startJoinShift) * startJoin * .5;\n\tstartBotJoin = -startTopJoin;\n\n\tendTopJoin = sign(endJoinShift) * endJoin * .5;\n\tendBotJoin = -endTopJoin;\n\n\tvec2 aTopCoord = aCoord + normalWidth * startTopJoin;\n\tvec2 bTopCoord = bCoord + normalWidth * endTopJoin;\n\tvec2 aBotCoord = aCoord + normalWidth * startBotJoin;\n\tvec2 bBotCoord = bCoord + normalWidth * endBotJoin;\n\n\t//miter anti-clipping\n\tfloat baClipping = distToLine(bCoord, aCoord, aBotCoord) / dot(normalize(normalWidth * endBotJoin), normalize(normalWidth.yx * vec2(-startBotJoin.y, startBotJoin.x)));\n\tfloat abClipping = distToLine(aCoord, bCoord, bTopCoord) / dot(normalize(normalWidth * startBotJoin), normalize(normalWidth.yx * vec2(-endBotJoin.y, endBotJoin.x)));\n\n\t//prevent close to reverse direction switch\n\tbool prevReverse = dot(currTangent, prevTangent) <= REVERSE_THRESHOLD && abs(dot(currTangent, prevNormal)) * min(length(prevDiff), length(currDiff)) <  length(normalWidth * currNormal);\n\tbool nextReverse = dot(currTangent, nextTangent) <= REVERSE_THRESHOLD && abs(dot(currTangent, nextNormal)) * min(length(nextDiff), length(currDiff)) <  length(normalWidth * currNormal);\n\n\tif (prevReverse) {\n\t\t//make join rectangular\n\t\tvec2 miterShift = normalWidth * startJoinDirection * miterLimit * .5;\n\t\tfloat normalAdjust = 1. - min(miterLimit / startMiterRatio, 1.);\n\t\taBotCoord = aCoord + miterShift - normalAdjust * normalWidth * currNormal * .5;\n\t\taTopCoord = aCoord + miterShift + normalAdjust * normalWidth * currNormal * .5;\n\t}\n\telse if (!nextReverse && baClipping > 0. && baClipping < length(normalWidth * endBotJoin)) {\n\t\t//handle miter clipping\n\t\tbTopCoord -= normalWidth * endTopJoin;\n\t\tbTopCoord += normalize(endTopJoin * normalWidth) * baClipping;\n\t}\n\n\tif (nextReverse) {\n\t\t//make join rectangular\n\t\tvec2 miterShift = normalWidth * endJoinDirection * miterLimit * .5;\n\t\tfloat normalAdjust = 1. - min(miterLimit / endMiterRatio, 1.);\n\t\tbBotCoord = bCoord + miterShift - normalAdjust * normalWidth * currNormal * .5;\n\t\tbTopCoord = bCoord + miterShift + normalAdjust * normalWidth * currNormal * .5;\n\t}\n\telse if (!prevReverse && abClipping > 0. && abClipping < length(normalWidth * startBotJoin)) {\n\t\t//handle miter clipping\n\t\taBotCoord -= normalWidth * startBotJoin;\n\t\taBotCoord += normalize(startBotJoin * normalWidth) * abClipping;\n\t}\n\n\tvec2 aTopPosition = (aTopCoord) * adjustedScale + translate;\n\tvec2 aBotPosition = (aBotCoord) * adjustedScale + translate;\n\n\tvec2 bTopPosition = (bTopCoord) * adjustedScale + translate;\n\tvec2 bBotPosition = (bBotCoord) * adjustedScale + translate;\n\n\t//position is normalized 0..1 coord on the screen\n\tvec2 position = (aTopPosition * lineTop + aBotPosition * lineBot) * lineStart + (bTopPosition * lineTop + bBotPosition * lineBot) * lineEnd;\n\n\tstartCoord = aCoord * scaleRatio + translate * viewport.zw + viewport.xy;\n\tendCoord = bCoord * scaleRatio + translate * viewport.zw + viewport.xy;\n\n\tgl_Position = vec4(position  * 2.0 - 1.0, depth, 1);\n\n\tenableStartMiter = step(dot(currTangent, prevTangent), .5);\n\tenableEndMiter = step(dot(currTangent, nextTangent), .5);\n\n\t//bevel miter cutoffs\n\tif (miterMode == 1.) {\n\t\tif (enableStartMiter == 1.) {\n\t\t\tvec2 startMiterWidth = vec2(startJoinDirection) * thickness * miterLimit * .5;\n\t\t\tstartCutoff = vec4(aCoord, aCoord);\n\t\t\tstartCutoff.zw += vec2(-startJoinDirection.y, startJoinDirection.x) / scaleRatio;\n\t\t\tstartCutoff = startCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n\t\t\tstartCutoff += viewport.xyxy;\n\t\t\tstartCutoff += startMiterWidth.xyxy;\n\t\t}\n\n\t\tif (enableEndMiter == 1.) {\n\t\t\tvec2 endMiterWidth = vec2(endJoinDirection) * thickness * miterLimit * .5;\n\t\t\tendCutoff = vec4(bCoord, bCoord);\n\t\t\tendCutoff.zw += vec2(-endJoinDirection.y, endJoinDirection.x)  / scaleRatio;\n\t\t\tendCutoff = endCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n\t\t\tendCutoff += viewport.xyxy;\n\t\t\tendCutoff += endMiterWidth.xyxy;\n\t\t}\n\t}\n\n\t//round miter cutoffs\n\telse if (miterMode == 2.) {\n\t\tif (enableStartMiter == 1.) {\n\t\t\tvec2 startMiterWidth = vec2(startJoinDirection) * thickness * abs(dot(startJoinDirection, currNormal)) * .5;\n\t\t\tstartCutoff = vec4(aCoord, aCoord);\n\t\t\tstartCutoff.zw += vec2(-startJoinDirection.y, startJoinDirection.x) / scaleRatio;\n\t\t\tstartCutoff = startCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n\t\t\tstartCutoff += viewport.xyxy;\n\t\t\tstartCutoff += startMiterWidth.xyxy;\n\t\t}\n\n\t\tif (enableEndMiter == 1.) {\n\t\t\tvec2 endMiterWidth = vec2(endJoinDirection) * thickness * abs(dot(endJoinDirection, currNormal)) * .5;\n\t\t\tendCutoff = vec4(bCoord, bCoord);\n\t\t\tendCutoff.zw += vec2(-endJoinDirection.y, endJoinDirection.x)  / scaleRatio;\n\t\t\tendCutoff = endCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n\t\t\tendCutoff += viewport.xyxy;\n\t\t\tendCutoff += endMiterWidth.xyxy;\n\t\t}\n\t}\n}\n"]),
            frag: o(["precision highp float;\n#define GLSLIFY 1\n\nuniform sampler2D dashPattern;\nuniform float dashSize, pixelRatio, thickness, opacity, id, miterMode;\n\nvarying vec4 fragColor;\nvarying vec2 tangent;\nvarying vec4 startCutoff, endCutoff;\nvarying vec2 startCoord, endCoord;\nvarying float enableStartMiter, enableEndMiter;\n\nfloat distToLine(vec2 p, vec2 a, vec2 b) {\n\tvec2 diff = b - a;\n\tvec2 perp = normalize(vec2(-diff.y, diff.x));\n\treturn dot(p - a, perp);\n}\n\nvoid main() {\n\tfloat alpha = 1., distToStart, distToEnd;\n\tfloat cutoff = thickness * .5;\n\n\t//bevel miter\n\tif (miterMode == 1.) {\n\t\tif (enableStartMiter == 1.) {\n\t\t\tdistToStart = distToLine(gl_FragCoord.xy, startCutoff.xy, startCutoff.zw);\n\t\t\tif (distToStart < -1.) {\n\t\t\t\tdiscard;\n\t\t\t\treturn;\n\t\t\t}\n\t\t\talpha *= min(max(distToStart + 1., 0.), 1.);\n\t\t}\n\n\t\tif (enableEndMiter == 1.) {\n\t\t\tdistToEnd = distToLine(gl_FragCoord.xy, endCutoff.xy, endCutoff.zw);\n\t\t\tif (distToEnd < -1.) {\n\t\t\t\tdiscard;\n\t\t\t\treturn;\n\t\t\t}\n\t\t\talpha *= min(max(distToEnd + 1., 0.), 1.);\n\t\t}\n\t}\n\n\t// round miter\n\telse if (miterMode == 2.) {\n\t\tif (enableStartMiter == 1.) {\n\t\t\tdistToStart = distToLine(gl_FragCoord.xy, startCutoff.xy, startCutoff.zw);\n\t\t\tif (distToStart < 0.) {\n\t\t\t\tfloat radius = length(gl_FragCoord.xy - startCoord);\n\n\t\t\t\tif(radius > cutoff + .5) {\n\t\t\t\t\tdiscard;\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\talpha -= smoothstep(cutoff - .5, cutoff + .5, radius);\n\t\t\t}\n\t\t}\n\n\t\tif (enableEndMiter == 1.) {\n\t\t\tdistToEnd = distToLine(gl_FragCoord.xy, endCutoff.xy, endCutoff.zw);\n\t\t\tif (distToEnd < 0.) {\n\t\t\t\tfloat radius = length(gl_FragCoord.xy - endCoord);\n\n\t\t\t\tif(radius > cutoff + .5) {\n\t\t\t\t\tdiscard;\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\talpha -= smoothstep(cutoff - .5, cutoff + .5, radius);\n\t\t\t}\n\t\t}\n\t}\n\n\tfloat t = fract(dot(tangent, gl_FragCoord.xy) / dashSize) * .5 + .25;\n\tfloat dash = texture2D(dashPattern, vec2(t, .5)).r;\n\n\tgl_FragColor = fragColor;\n\tgl_FragColor.a *= alpha * opacity * dash;\n}\n"]),
            attributes: {
              lineEnd: {
                buffer: r,
                divisor: 0,
                stride: 8,
                offset: 0
              },
              lineTop: {
                buffer: r,
                divisor: 0,
                stride: 8,
                offset: 4
              },
              aColor: {
                buffer: t.prop("colorBuffer"),
                stride: 4,
                offset: 0,
                divisor: 1
              },
              bColor: {
                buffer: t.prop("colorBuffer"),
                stride: 4,
                offset: 4,
                divisor: 1
              },
              prevCoord: {
                buffer: t.prop("positionBuffer"),
                stride: 8,
                offset: 0,
                divisor: 1
              },
              aCoord: {
                buffer: t.prop("positionBuffer"),
                stride: 8,
                offset: 8,
                divisor: 1
              },
              bCoord: {
                buffer: t.prop("positionBuffer"),
                stride: 8,
                offset: 16,
                divisor: 1
              },
              nextCoord: {
                buffer: t.prop("positionBuffer"),
                stride: 8,
                offset: 24,
                divisor: 1
              }
            }
          }, n));
        } catch (t) {
          e = i;
        }

        return {
          fill: t({
            primitive: "triangle",
            elements: function elements(t, e) {
              return e.triangles;
            },
            offset: 0,
            vert: o(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec2 position, positionFract;\n\nuniform vec4 color;\nuniform vec2 scale, scaleFract, translate, translateFract;\nuniform float pixelRatio, id;\nuniform vec4 viewport;\nuniform float opacity;\n\nvarying vec4 fragColor;\n\nconst float MAX_LINES = 256.;\n\nvoid main() {\n\tfloat depth = (MAX_LINES - 4. - id) / (MAX_LINES);\n\n\tvec2 position = position * scale + translate\n       + positionFract * scale + translateFract\n       + position * scaleFract\n       + positionFract * scaleFract;\n\n\tgl_Position = vec4(position * 2.0 - 1.0, depth, 1);\n\n\tfragColor = color / 255.;\n\tfragColor.a *= opacity;\n}\n"]),
            frag: o(["precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nvoid main() {\n\tgl_FragColor = fragColor;\n}\n"]),
            uniforms: {
              scale: t.prop("scale"),
              color: t.prop("fill"),
              scaleFract: t.prop("scaleFract"),
              translateFract: t.prop("translateFract"),
              translate: t.prop("translate"),
              opacity: t.prop("opacity"),
              pixelRatio: t.context("pixelRatio"),
              id: t.prop("id"),
              viewport: function viewport(t, e) {
                return [e.viewport.x, e.viewport.y, t.viewportWidth, t.viewportHeight];
              }
            },
            attributes: {
              position: {
                buffer: t.prop("positionBuffer"),
                stride: 8,
                offset: 8
              },
              positionFract: {
                buffer: t.prop("positionFractBuffer"),
                stride: 8,
                offset: 8
              }
            },
            blend: n.blend,
            depth: {
              enable: !1
            },
            scissor: n.scissor,
            stencil: n.stencil,
            viewport: n.viewport
          }),
          rect: i,
          miter: e
        };
      }, v.defaults = {
        dashes: null,
        join: "miter",
        miterLimit: 1,
        thickness: 10,
        cap: "square",
        color: "black",
        opacity: 1,
        overlay: !1,
        viewport: null,
        range: null,
        close: !1,
        fill: null
      }, v.prototype.render = function () {
        for (var t, e = [], r = arguments.length; r--;) {
          e[r] = arguments[r];
        }

        e.length && (t = this).update.apply(t, e), this.draw();
      }, v.prototype.draw = function () {
        for (var t = this, e = [], r = arguments.length; r--;) {
          e[r] = arguments[r];
        }

        return (e.length ? e : this.passes).forEach(function (e, r) {
          var n;
          if (e && Array.isArray(e)) return (n = t).draw.apply(n, e);
          "number" == typeof e && (e = t.passes[e]), e && e.count > 1 && e.opacity && (t.regl._refresh(), e.fill && e.triangles && e.triangles.length > 2 && t.shaders.fill(e), e.thickness && (e.scale[0] * e.viewport.width > v.precisionThreshold || e.scale[1] * e.viewport.height > v.precisionThreshold || "rect" === e.join || !e.join && (e.thickness <= 2 || e.count >= v.maxPoints) ? t.shaders.rect(e) : t.shaders.miter(e)));
        }), this;
      }, v.prototype.update = function (t) {
        var e = this;

        if (t) {
          null != t.length ? "number" == typeof t[0] && (t = [{
            positions: t
          }]) : Array.isArray(t) || (t = [t]);
          var r = this.regl,
              o = this.gl;

          if (t.forEach(function (t, f) {
            var d = e.passes[f];
            if (void 0 !== t) if (null !== t) {
              if ("number" == typeof t[0] && (t = {
                positions: t
              }), t = s(t, {
                positions: "positions points data coords",
                thickness: "thickness lineWidth lineWidths line-width linewidth width stroke-width strokewidth strokeWidth",
                join: "lineJoin linejoin join type mode",
                miterLimit: "miterlimit miterLimit",
                dashes: "dash dashes dasharray dash-array dashArray",
                color: "color colour stroke colors colours stroke-color strokeColor",
                fill: "fill fill-color fillColor",
                opacity: "alpha opacity",
                overlay: "overlay crease overlap intersect",
                close: "closed close closed-path closePath",
                range: "range dataBox",
                viewport: "viewport viewBox",
                hole: "holes hole hollow",
                splitNull: "splitNull"
              }), d || (e.passes[f] = d = {
                id: f,
                scale: null,
                scaleFract: null,
                translate: null,
                translateFract: null,
                count: 0,
                hole: [],
                depth: 0,
                dashLength: 1,
                dashTexture: r.texture({
                  channels: 1,
                  data: new Uint8Array([255]),
                  width: 1,
                  height: 1,
                  mag: "linear",
                  min: "linear"
                }),
                colorBuffer: r.buffer({
                  usage: "dynamic",
                  type: "uint8",
                  data: new Uint8Array()
                }),
                positionBuffer: r.buffer({
                  usage: "dynamic",
                  type: "float",
                  data: new Uint8Array()
                }),
                positionFractBuffer: r.buffer({
                  usage: "dynamic",
                  type: "float",
                  data: new Uint8Array()
                })
              }, t = a({}, v.defaults, t)), null != t.thickness && (d.thickness = parseFloat(t.thickness)), null != t.opacity && (d.opacity = parseFloat(t.opacity)), null != t.miterLimit && (d.miterLimit = parseFloat(t.miterLimit)), null != t.overlay && (d.overlay = !!t.overlay, f < v.maxLines && (d.depth = 2 * (v.maxLines - 1 - f % v.maxLines) / v.maxLines - 1)), null != t.join && (d.join = t.join), null != t.hole && (d.hole = t.hole), null != t.fill && (d.fill = t.fill ? n(t.fill, "uint8") : null), null != t.viewport && (d.viewport = m(t.viewport)), d.viewport || (d.viewport = m([o.drawingBufferWidth, o.drawingBufferHeight])), null != t.close && (d.close = t.close), null === t.positions && (t.positions = []), t.positions) {
                var y, x;

                if (t.positions.x && t.positions.y) {
                  var b = t.positions.x,
                      _ = t.positions.y;
                  x = d.count = Math.max(b.length, _.length), y = new Float64Array(2 * x);

                  for (var w = 0; w < x; w++) {
                    y[2 * w] = b[w], y[2 * w + 1] = _[w];
                  }
                } else y = l(t.positions, "float64"), x = d.count = Math.floor(y.length / 2);

                var T = d.bounds = i(y, 2);

                if (d.fill) {
                  for (var k = [], M = {}, A = 0, S = 0, E = 0, L = d.count; S < L; S++) {
                    var C = y[2 * S],
                        P = y[2 * S + 1];
                    isNaN(C) || isNaN(P) || null == C || null == P ? (C = y[2 * A], P = y[2 * A + 1], M[S] = A) : A = S, k[E++] = C, k[E++] = P;
                  }

                  if (t.splitNull) {
                    d.count - 1 in M || (M[d.count] = d.count - 1);
                    var I = Object.keys(M).map(Number).sort(function (t, e) {
                      return t - e;
                    }),
                        O = [],
                        z = 0,
                        D = null != d.hole ? d.hole[0] : null;

                    if (null != D) {
                      var R = g(I, function (t) {
                        return t >= D;
                      });
                      (I = I.slice(0, R)).push(D);
                    }

                    for (var F = function F(t) {
                      var e = k.slice(2 * z, 2 * I[t]).concat(D ? k.slice(2 * D) : []),
                          r = (d.hole || []).map(function (e) {
                        return e - D + (I[t] - z);
                      }),
                          n = c(e, r);
                      n = n.map(function (e) {
                        return e + z + (e + z < I[t] ? 0 : D - I[t]);
                      }), O.push.apply(O, n), z = I[t] + 1;
                    }, B = 0; B < I.length; B++) {
                      F(B);
                    }

                    for (var N = 0, j = O.length; N < j; N++) {
                      null != M[O[N]] && (O[N] = M[O[N]]);
                    }

                    d.triangles = O;
                  } else {
                    for (var U = c(k, d.hole || []), V = 0, q = U.length; V < q; V++) {
                      null != M[U[V]] && (U[V] = M[U[V]]);
                    }

                    d.triangles = U;
                  }
                }

                var H = new Float64Array(y);
                u(H, 2, T);
                var G = new Float64Array(2 * x + 6);
                d.close ? y[0] === y[2 * x - 2] && y[1] === y[2 * x - 1] ? (G[0] = H[2 * x - 4], G[1] = H[2 * x - 3]) : (G[0] = H[2 * x - 2], G[1] = H[2 * x - 1]) : (G[0] = H[0], G[1] = H[1]), G.set(H, 2), d.close ? y[0] === y[2 * x - 2] && y[1] === y[2 * x - 1] ? (G[2 * x + 2] = H[2], G[2 * x + 3] = H[3], d.count -= 1) : (G[2 * x + 2] = H[0], G[2 * x + 3] = H[1], G[2 * x + 4] = H[2], G[2 * x + 5] = H[3]) : (G[2 * x + 2] = H[2 * x - 2], G[2 * x + 3] = H[2 * x - 1], G[2 * x + 4] = H[2 * x - 2], G[2 * x + 5] = H[2 * x - 1]), d.positionBuffer(h(G)), d.positionFractBuffer(p(G));
              }

              if (t.range ? d.range = t.range : d.range || (d.range = d.bounds), (t.range || t.positions) && d.count) {
                var Y = d.bounds,
                    W = Y[2] - Y[0],
                    X = Y[3] - Y[1],
                    Z = d.range[2] - d.range[0],
                    J = d.range[3] - d.range[1];
                d.scale = [W / Z, X / J], d.translate = [-d.range[0] / Z + Y[0] / Z || 0, -d.range[1] / J + Y[1] / J || 0], d.scaleFract = p(d.scale), d.translateFract = p(d.translate);
              }

              if (t.dashes) {
                var K,
                    Q = 0;
                if (!t.dashes || t.dashes.length < 2) Q = 1, K = new Uint8Array([255, 255, 255, 255, 255, 255, 255, 255]);else {
                  Q = 0;

                  for (var $ = 0; $ < t.dashes.length; ++$) {
                    Q += t.dashes[$];
                  }

                  K = new Uint8Array(Q * v.dashMult);

                  for (var tt = 0, et = 255, rt = 0; rt < 2; rt++) {
                    for (var nt = 0; nt < t.dashes.length; ++nt) {
                      for (var it = 0, at = t.dashes[nt] * v.dashMult * .5; it < at; ++it) {
                        K[tt++] = et;
                      }

                      et ^= 255;
                    }
                  }
                }
                d.dashLength = Q, d.dashTexture({
                  channels: 1,
                  data: K,
                  width: K.length,
                  height: 1,
                  mag: "linear",
                  min: "linear"
                }, 0, 0);
              }

              if (t.color) {
                var ot = d.count,
                    st = t.color;
                st || (st = "transparent");
                var lt = new Uint8Array(4 * ot + 4);

                if (Array.isArray(st) && "number" != typeof st[0]) {
                  for (var ct = 0; ct < ot; ct++) {
                    var ut = n(st[ct], "uint8");
                    lt.set(ut, 4 * ct);
                  }

                  lt.set(n(st[0], "uint8"), 4 * ot);
                } else for (var ft = n(st, "uint8"), ht = 0; ht < ot + 1; ht++) {
                  lt.set(ft, 4 * ht);
                }

                d.colorBuffer({
                  usage: "dynamic",
                  type: "uint8",
                  data: lt
                });
              }
            } else e.passes[f] = null;
          }), t.length < this.passes.length) {
            for (var f = t.length; f < this.passes.length; f++) {
              var d = this.passes[f];
              d && (d.colorBuffer.destroy(), d.positionBuffer.destroy(), d.dashTexture.destroy());
            }

            this.passes.length = t.length;
          }

          for (var y = [], x = 0; x < this.passes.length; x++) {
            null !== this.passes[x] && y.push(this.passes[x]);
          }

          return this.passes = y, this;
        }
      }, v.prototype.destroy = function () {
        return this.passes.forEach(function (t) {
          t.colorBuffer.destroy(), t.positionBuffer.destroy(), t.dashTexture.destroy();
        }), this.passes.length = 0, this;
      };
    }, {
      "array-bounds": 71,
      "array-find-index": 72,
      "array-normalize": 73,
      "color-normalize": 126,
      earcut: 177,
      "es6-weak-map": 232,
      "flatten-vertex-data": 243,
      glslify: 433,
      "object-assign": 479,
      "parse-rect": 484,
      "pick-by-alias": 490,
      "to-float32": 591
    }],
    530: [function (t, e, r) {
      "use strict";

      function n(t, e) {
        return function (t) {
          if (Array.isArray(t)) return t;
        }(t) || function (t, e) {
          if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
          var r = [],
              n = !0,
              i = !1,
              a = void 0;

          try {
            for (var o, s = t[Symbol.iterator](); !(n = (o = s.next()).done) && (r.push(o.value), !e || r.length !== e); n = !0) {
              ;
            }
          } catch (t) {
            i = !0, a = t;
          } finally {
            try {
              n || null == s.return || s.return();
            } finally {
              if (i) throw a;
            }
          }

          return r;
        }(t, e) || a(t, e) || function () {
          throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }

      function i(t) {
        return function (t) {
          if (Array.isArray(t)) return o(t);
        }(t) || function (t) {
          if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
        }(t) || a(t) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }

      function a(t, e) {
        if (t) {
          if ("string" == typeof t) return o(t, e);
          var r = Object.prototype.toString.call(t).slice(8, -1);
          return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? o(t, e) : void 0;
        }
      }

      function o(t, e) {
        (null == e || e > t.length) && (e = t.length);

        for (var r = 0, n = new Array(e); r < e; r++) {
          n[r] = t[r];
        }

        return n;
      }

      var s = t("color-normalize"),
          l = t("array-bounds"),
          c = t("color-id"),
          u = t("@plotly/point-cluster"),
          f = t("object-assign"),
          h = t("glslify"),
          p = t("pick-by-alias"),
          d = t("update-diff"),
          m = t("flatten-vertex-data"),
          g = t("is-iexplorer"),
          v = t("to-float32"),
          y = t("parse-rect"),
          x = b;

      function b(t, e) {
        var r = this;
        if (!(this instanceof b)) return new b(t, e);
        "function" == typeof t ? (e || (e = {}), e.regl = t) : (e = t, t = null), e && e.length && (e.positions = e);
        var n,
            i = (t = e.regl)._gl,
            a = [];
        this.tooManyColors = g, n = t.texture({
          data: new Uint8Array(1020),
          width: 255,
          height: 1,
          type: "uint8",
          format: "rgba",
          wrapS: "clamp",
          wrapT: "clamp",
          mag: "nearest",
          min: "nearest"
        }), f(this, {
          regl: t,
          gl: i,
          groups: [],
          markerCache: [null],
          markerTextures: [null],
          palette: a,
          paletteIds: {},
          paletteTexture: n,
          maxColors: 255,
          maxSize: 100,
          canvas: i.canvas
        }), this.update(e);
        var o = {
          uniforms: {
            constPointSize: !!e.constPointSize,
            pixelRatio: t.context("pixelRatio"),
            palette: n,
            paletteSize: function paletteSize(t, e) {
              return [r.tooManyColors ? 0 : 255, n.height];
            },
            scale: t.prop("scale"),
            scaleFract: t.prop("scaleFract"),
            translate: t.prop("translate"),
            translateFract: t.prop("translateFract"),
            opacity: t.prop("opacity"),
            marker: t.prop("markerTexture")
          },
          attributes: {
            x: function x(t, e) {
              return e.xAttr || {
                buffer: e.positionBuffer,
                stride: 8,
                offset: 0
              };
            },
            y: function y(t, e) {
              return e.yAttr || {
                buffer: e.positionBuffer,
                stride: 8,
                offset: 4
              };
            },
            xFract: function xFract(t, e) {
              return e.xAttr ? {
                constant: [0, 0]
              } : {
                buffer: e.positionFractBuffer,
                stride: 8,
                offset: 0
              };
            },
            yFract: function yFract(t, e) {
              return e.yAttr ? {
                constant: [0, 0]
              } : {
                buffer: e.positionFractBuffer,
                stride: 8,
                offset: 4
              };
            },
            size: function size(t, e) {
              return e.size.length ? {
                buffer: e.sizeBuffer,
                stride: 2,
                offset: 0
              } : {
                constant: [Math.round(255 * e.size / r.maxSize)]
              };
            },
            borderSize: function borderSize(t, e) {
              return e.borderSize.length ? {
                buffer: e.sizeBuffer,
                stride: 2,
                offset: 1
              } : {
                constant: [Math.round(255 * e.borderSize / r.maxSize)]
              };
            },
            colorId: function colorId(t, e) {
              return e.color.length ? {
                buffer: e.colorBuffer,
                stride: r.tooManyColors ? 8 : 4,
                offset: 0
              } : {
                constant: r.tooManyColors ? a.slice(4 * e.color, 4 * e.color + 4) : [e.color]
              };
            },
            borderColorId: function borderColorId(t, e) {
              return e.borderColor.length ? {
                buffer: e.colorBuffer,
                stride: r.tooManyColors ? 8 : 4,
                offset: r.tooManyColors ? 4 : 2
              } : {
                constant: r.tooManyColors ? a.slice(4 * e.borderColor, 4 * e.borderColor + 4) : [e.borderColor]
              };
            },
            isActive: function isActive(t, e) {
              return !0 === e.activation ? {
                constant: [1]
              } : e.activation ? e.activation : {
                constant: [0]
              };
            }
          },
          blend: {
            enable: !0,
            color: [0, 0, 0, 1],
            func: {
              srcRGB: "src alpha",
              dstRGB: "one minus src alpha",
              srcAlpha: "one minus dst alpha",
              dstAlpha: "one"
            }
          },
          scissor: {
            enable: !0,
            box: t.prop("viewport")
          },
          viewport: t.prop("viewport"),
          stencil: {
            enable: !1
          },
          depth: {
            enable: !1
          },
          elements: t.prop("elements"),
          count: t.prop("count"),
          offset: t.prop("offset"),
          primitive: "points"
        },
            s = f({}, o);
        s.frag = h(["precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragWidth, fragBorderColorLevel, fragColorLevel;\n\nuniform sampler2D marker;\nuniform float opacity;\n\nfloat smoothStep(float x, float y) {\n  return 1.0 / (1.0 + exp(50.0*(x - y)));\n}\n\nvoid main() {\n  float dist = texture2D(marker, gl_PointCoord).r, delta = fragWidth;\n\n  // max-distance alpha\n  if (dist < 0.003) discard;\n\n  // null-border case\n  if (fragBorderColorLevel == fragColorLevel || fragBorderColor.a == 0.) {\n    float colorAmt = smoothstep(.5 - delta, .5 + delta, dist);\n    gl_FragColor = vec4(fragColor.rgb, colorAmt * fragColor.a * opacity);\n  }\n  else {\n    float borderColorAmt = smoothstep(fragBorderColorLevel - delta, fragBorderColorLevel + delta, dist);\n    float colorAmt = smoothstep(fragColorLevel - delta, fragColorLevel + delta, dist);\n\n    vec4 color = fragBorderColor;\n    color.a *= borderColorAmt;\n    color = mix(color, fragColor, colorAmt);\n    color.a *= opacity;\n\n    gl_FragColor = color;\n  }\n\n}\n"]), s.vert = h(["precision highp float;\n#define GLSLIFY 1\n\nattribute float x, y, xFract, yFract;\nattribute float size, borderSize;\nattribute vec4 colorId, borderColorId;\nattribute float isActive;\n\nuniform vec2 scale, scaleFract, translate, translateFract, paletteSize;\nuniform float pixelRatio;\nuniform bool constPointSize;\nuniform sampler2D palette;\n\nconst float maxSize = 100.;\nconst float borderLevel = .5;\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragPointSize, fragBorderRadius, fragWidth, fragBorderColorLevel, fragColorLevel;\n\nfloat pointSizeScale = (constPointSize) ? 2. : pixelRatio;\n\nbool isDirect = (paletteSize.x < 1.);\n\nvec4 getColor(vec4 id) {\n  return isDirect ? id / 255. : texture2D(palette,\n    vec2(\n      (id.x + .5) / paletteSize.x,\n      (id.y + .5) / paletteSize.y\n    )\n  );\n}\n\nvoid main() {\n  // ignore inactive points\n  if (isActive == 0.) return;\n\n  vec2 position = vec2(x, y);\n  vec2 positionFract = vec2(xFract, yFract);\n\n  vec4 color = getColor(colorId);\n  vec4 borderColor = getColor(borderColorId);\n\n  float size = size * maxSize / 255.;\n  float borderSize = borderSize * maxSize / 255.;\n\n  gl_PointSize = 2. * size * pointSizeScale;\n  fragPointSize = size * pixelRatio;\n\n  vec2 pos = (position + translate) * scale\n      + (positionFract + translateFract) * scale\n      + (position + translate) * scaleFract\n      + (positionFract + translateFract) * scaleFract;\n\n  gl_Position = vec4(pos * 2. - 1., 0., 1.);\n\n  fragColor = color;\n  fragBorderColor = borderColor;\n  fragWidth = 1. / gl_PointSize;\n\n  fragBorderColorLevel = clamp(borderLevel - borderLevel * borderSize / size, 0., 1.);\n  fragColorLevel = clamp(borderLevel + (1. - borderLevel) * borderSize / size, 0., 1.);\n}"]), this.drawMarker = t(s);
        var l = f({}, o);
        l.frag = h(["precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor, fragBorderColor;\n\nuniform float opacity;\nvarying float fragBorderRadius, fragWidth;\n\nfloat smoothStep(float edge0, float edge1, float x) {\n\tfloat t;\n\tt = clamp((x - edge0) / (edge1 - edge0), 0.0, 1.0);\n\treturn t * t * (3.0 - 2.0 * t);\n}\n\nvoid main() {\n\tfloat radius, alpha = 1.0, delta = fragWidth;\n\n\tradius = length(2.0 * gl_PointCoord.xy - 1.0);\n\n\tif (radius > 1.0 + delta) {\n\t\tdiscard;\n\t}\n\n\talpha -= smoothstep(1.0 - delta, 1.0 + delta, radius);\n\n\tfloat borderRadius = fragBorderRadius;\n\tfloat ratio = smoothstep(borderRadius - delta, borderRadius + delta, radius);\n\tvec4 color = mix(fragColor, fragBorderColor, ratio);\n\tcolor.a *= alpha * opacity;\n\tgl_FragColor = color;\n}\n"]), l.vert = h(["precision highp float;\n#define GLSLIFY 1\n\nattribute float x, y, xFract, yFract;\nattribute float size, borderSize;\nattribute vec4 colorId, borderColorId;\nattribute float isActive;\n\nuniform vec2 scale, scaleFract, translate, translateFract;\nuniform float pixelRatio;\nuniform bool constPointSize;\nuniform sampler2D palette;\nuniform vec2 paletteSize;\n\nconst float maxSize = 100.;\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragBorderRadius, fragWidth;\n\nfloat pointSizeScale = (constPointSize) ? 2. : pixelRatio;\n\nbool isDirect = (paletteSize.x < 1.);\n\nvec4 getColor(vec4 id) {\n  return isDirect ? id / 255. : texture2D(palette,\n    vec2(\n      (id.x + .5) / paletteSize.x,\n      (id.y + .5) / paletteSize.y\n    )\n  );\n}\n\nvoid main() {\n  // ignore inactive points\n  if (isActive == 0.) return;\n\n  vec2 position = vec2(x, y);\n  vec2 positionFract = vec2(xFract, yFract);\n\n  vec4 color = getColor(colorId);\n  vec4 borderColor = getColor(borderColorId);\n\n  float size = size * maxSize / 255.;\n  float borderSize = borderSize * maxSize / 255.;\n\n  gl_PointSize = (size + borderSize) * pointSizeScale;\n\n  vec2 pos = (position + translate) * scale\n      + (positionFract + translateFract) * scale\n      + (position + translate) * scaleFract\n      + (positionFract + translateFract) * scaleFract;\n\n  gl_Position = vec4(pos * 2. - 1., 0., 1.);\n\n  fragBorderRadius = 1. - 2. * borderSize / (size + borderSize);\n  fragColor = color;\n  fragBorderColor = borderColor.a == 0. || borderSize == 0. ? vec4(color.rgb, 0.) : borderColor;\n  fragWidth = 1. / gl_PointSize;\n}\n"]), g && (l.frag = l.frag.replace("smoothstep", "smoothStep"), s.frag = s.frag.replace("smoothstep", "smoothStep")), this.drawCircle = t(l);
      }

      b.defaults = {
        color: "black",
        borderColor: "transparent",
        borderSize: 0,
        size: 12,
        opacity: 1,
        marker: void 0,
        viewport: null,
        range: null,
        pixelSize: null,
        count: 0,
        offset: 0,
        bounds: null,
        positions: [],
        snap: 1e4
      }, b.prototype.render = function () {
        return arguments.length && this.update.apply(this, arguments), this.draw(), this;
      }, b.prototype.draw = function () {
        for (var t = this, e = arguments.length, r = new Array(e), n = 0; n < e; n++) {
          r[n] = arguments[n];
        }

        var i = this.groups;
        if (1 === r.length && Array.isArray(r[0]) && (null === r[0][0] || Array.isArray(r[0][0])) && (r = r[0]), this.regl._refresh(), r.length) for (var a = 0; a < r.length; a++) {
          this.drawItem(a, r[a]);
        } else i.forEach(function (e, r) {
          t.drawItem(r);
        });
        return this;
      }, b.prototype.drawItem = function (t, e) {
        var r = this.groups,
            n = r[t];

        if ("number" == typeof e && (t = e, n = r[e], e = null), n && n.count && n.opacity) {
          n.activation[0] && this.drawCircle(this.getMarkerDrawOptions(0, n, e));

          for (var a = [], o = 1; o < n.activation.length; o++) {
            n.activation[o] && (!0 === n.activation[o] || n.activation[o].data.length) && a.push.apply(a, i(this.getMarkerDrawOptions(o, n, e)));
          }

          a.length && this.drawMarker(a);
        }
      }, b.prototype.getMarkerDrawOptions = function (t, e, r) {
        var i = e.range,
            a = e.tree,
            o = e.viewport,
            s = e.activation,
            l = e.selectionBuffer,
            c = e.count;
        this.regl;
        if (!a) return r ? [f({}, e, {
          markerTexture: this.markerTextures[t],
          activation: s[t],
          count: r.length,
          elements: r,
          offset: 0
        })] : [f({}, e, {
          markerTexture: this.markerTextures[t],
          activation: s[t],
          offset: 0
        })];
        var u = [],
            h = a.range(i, {
          lod: !0,
          px: [(i[2] - i[0]) / o.width, (i[3] - i[1]) / o.height]
        });

        if (r) {
          for (var p = s[t].data, d = new Uint8Array(c), m = 0; m < r.length; m++) {
            var g = r[m];
            d[g] = p ? p[g] : 1;
          }

          l.subdata(d);
        }

        for (var v = h.length; v--;) {
          var y = n(h[v], 2),
              x = y[0],
              b = y[1];
          u.push(f({}, e, {
            markerTexture: this.markerTextures[t],
            activation: r ? l : s[t],
            offset: x,
            count: b - x
          }));
        }

        return u;
      }, b.prototype.update = function () {
        for (var t = this, e = arguments.length, r = new Array(e), n = 0; n < e; n++) {
          r[n] = arguments[n];
        }

        if (r.length) {
          1 === r.length && Array.isArray(r[0]) && (r = r[0]);
          var i = this.groups,
              a = this.gl,
              o = this.regl,
              s = this.maxSize,
              c = this.maxColors,
              h = this.palette;
          this.groups = i = r.map(function (e, r) {
            var n = i[r];
            if (void 0 === e) return n;
            null === e ? e = {
              positions: null
            } : "function" == typeof e ? e = {
              ondraw: e
            } : "number" == typeof e[0] && (e = {
              positions: e
            }), null === (e = p(e, {
              positions: "positions data points",
              snap: "snap cluster lod tree",
              size: "sizes size radius",
              borderSize: "borderSizes borderSize border-size bordersize borderWidth borderWidths border-width borderwidth stroke-width strokeWidth strokewidth outline",
              color: "colors color fill fill-color fillColor",
              borderColor: "borderColors borderColor stroke stroke-color strokeColor",
              marker: "markers marker shape",
              range: "range dataBox databox",
              viewport: "viewport viewPort viewBox viewbox",
              opacity: "opacity alpha transparency",
              bounds: "bound bounds boundaries limits",
              tooManyColors: "tooManyColors palette paletteMode optimizePalette enablePalette"
            })).positions && (e.positions = []), null != e.tooManyColors && (t.tooManyColors = e.tooManyColors), n || (i[r] = n = {
              id: r,
              scale: null,
              translate: null,
              scaleFract: null,
              translateFract: null,
              activation: [],
              selectionBuffer: o.buffer({
                data: new Uint8Array(0),
                usage: "stream",
                type: "uint8"
              }),
              sizeBuffer: o.buffer({
                data: new Uint8Array(0),
                usage: "dynamic",
                type: "uint8"
              }),
              colorBuffer: o.buffer({
                data: new Uint8Array(0),
                usage: "dynamic",
                type: "uint8"
              }),
              positionBuffer: o.buffer({
                data: new Uint8Array(0),
                usage: "dynamic",
                type: "float"
              }),
              positionFractBuffer: o.buffer({
                data: new Uint8Array(0),
                usage: "dynamic",
                type: "float"
              })
            }, e = f({}, b.defaults, e)), e.positions && !("marker" in e) && (e.marker = n.marker, delete n.marker), e.marker && !("positions" in e) && (e.positions = n.positions, delete n.positions);
            var g = 0,
                x = 0;

            if (d(n, e, [{
              snap: !0,
              size: function size(t, e) {
                return null == t && (t = b.defaults.size), g += t && t.length ? 1 : 0, t;
              },
              borderSize: function borderSize(t, e) {
                return null == t && (t = b.defaults.borderSize), g += t && t.length ? 1 : 0, t;
              },
              opacity: parseFloat,
              color: function color(e, r) {
                return null == e && (e = b.defaults.color), e = t.updateColor(e), x++, e;
              },
              borderColor: function borderColor(e, r) {
                return null == e && (e = b.defaults.borderColor), e = t.updateColor(e), x++, e;
              },
              bounds: function bounds(t, e, r) {
                return "range" in r || (r.range = null), t;
              },
              positions: function positions(t, e, r) {
                var n = e.snap,
                    i = e.positionBuffer,
                    a = e.positionFractBuffer,
                    s = e.selectionBuffer;
                if (t.x || t.y) return t.x.length ? e.xAttr = {
                  buffer: o.buffer(t.x),
                  offset: 0,
                  stride: 4,
                  count: t.x.length
                } : e.xAttr = {
                  buffer: t.x.buffer,
                  offset: 4 * t.x.offset || 0,
                  stride: 4 * (t.x.stride || 1),
                  count: t.x.count
                }, t.y.length ? e.yAttr = {
                  buffer: o.buffer(t.y),
                  offset: 0,
                  stride: 4,
                  count: t.y.length
                } : e.yAttr = {
                  buffer: t.y.buffer,
                  offset: 4 * t.y.offset || 0,
                  stride: 4 * (t.y.stride || 1),
                  count: t.y.count
                }, e.count = Math.max(e.xAttr.count, e.yAttr.count), t;
                t = m(t, "float64");
                var c = e.count = Math.floor(t.length / 2),
                    f = e.bounds = c ? l(t, 2) : null;

                if (r.range || e.range || (delete e.range, r.range = f), r.marker || e.marker || (delete e.marker, r.marker = null), n && (!0 === n || c > n) ? e.tree = u(t, {
                  bounds: f
                }) : n && n.length && (e.tree = n), e.tree) {
                  var h = {
                    primitive: "points",
                    usage: "static",
                    data: e.tree,
                    type: "uint32"
                  };
                  e.elements ? e.elements(h) : e.elements = o.elements(h);
                }

                return i({
                  data: v.float(t),
                  usage: "dynamic"
                }), a({
                  data: v.fract(t),
                  usage: "dynamic"
                }), s({
                  data: new Uint8Array(c),
                  type: "uint8",
                  usage: "stream"
                }), t;
              }
            }, {
              marker: function marker(e, r, n) {
                var i = r.activation;

                if (i.forEach(function (t) {
                  return t && t.destroy && t.destroy();
                }), i.length = 0, e && "number" != typeof e[0]) {
                  for (var a = [], s = 0, l = Math.min(e.length, r.count); s < l; s++) {
                    var c = t.addMarker(e[s]);
                    a[c] || (a[c] = new Uint8Array(r.count)), a[c][s] = 1;
                  }

                  for (var u = 0; u < a.length; u++) {
                    if (a[u]) {
                      var f = {
                        data: a[u],
                        type: "uint8",
                        usage: "static"
                      };
                      i[u] ? i[u](f) : i[u] = o.buffer(f), i[u].data = a[u];
                    }
                  }
                } else {
                  i[t.addMarker(e)] = !0;
                }

                return e;
              },
              range: function range(t, e, r) {
                var n = e.bounds;
                if (n) return t || (t = n), e.scale = [1 / (t[2] - t[0]), 1 / (t[3] - t[1])], e.translate = [-t[0], -t[1]], e.scaleFract = v.fract(e.scale), e.translateFract = v.fract(e.translate), t;
              },
              viewport: function viewport(t) {
                return y(t || [a.drawingBufferWidth, a.drawingBufferHeight]);
              }
            }]), g) {
              var _ = n,
                  w = _.count,
                  T = _.size,
                  k = _.borderSize,
                  M = _.sizeBuffer,
                  A = new Uint8Array(2 * w);
              if (T.length || k.length) for (var S = 0; S < w; S++) {
                A[2 * S] = Math.round(255 * (null == T[S] ? T : T[S]) / s), A[2 * S + 1] = Math.round(255 * (null == k[S] ? k : k[S]) / s);
              }
              M({
                data: A,
                usage: "dynamic"
              });
            }

            if (x) {
              var E,
                  L = n,
                  C = L.count,
                  P = L.color,
                  I = L.borderColor,
                  O = L.colorBuffer;

              if (t.tooManyColors) {
                if (P.length || I.length) {
                  E = new Uint8Array(8 * C);

                  for (var z = 0; z < C; z++) {
                    var D = P[z];
                    E[8 * z] = h[4 * D], E[8 * z + 1] = h[4 * D + 1], E[8 * z + 2] = h[4 * D + 2], E[8 * z + 3] = h[4 * D + 3];
                    var R = I[z];
                    E[8 * z + 4] = h[4 * R], E[8 * z + 5] = h[4 * R + 1], E[8 * z + 6] = h[4 * R + 2], E[8 * z + 7] = h[4 * R + 3];
                  }
                }
              } else if (P.length || I.length) {
                E = new Uint8Array(4 * C + 2);

                for (var F = 0; F < C; F++) {
                  null != P[F] && (E[4 * F] = P[F] % c, E[4 * F + 1] = Math.floor(P[F] / c)), null != I[F] && (E[4 * F + 2] = I[F] % c, E[4 * F + 3] = Math.floor(I[F] / c));
                }
              }

              O({
                data: E || new Uint8Array(0),
                type: "uint8",
                usage: "dynamic"
              });
            }

            return n;
          });
        }
      }, b.prototype.addMarker = function (t) {
        var e,
            r = this.markerTextures,
            n = this.regl,
            i = this.markerCache,
            a = null == t ? 0 : i.indexOf(t);
        if (a >= 0) return a;
        if (t instanceof Uint8Array || t instanceof Uint8ClampedArray) e = t;else {
          e = new Uint8Array(t.length);

          for (var o = 0, s = t.length; o < s; o++) {
            e[o] = 255 * t[o];
          }
        }
        var l = Math.floor(Math.sqrt(e.length));
        return a = r.length, i.push(t), r.push(n.texture({
          channels: 1,
          data: e,
          radius: l,
          mag: "linear",
          min: "linear"
        })), a;
      }, b.prototype.updateColor = function (t) {
        var e = this.paletteIds,
            r = this.palette,
            n = this.maxColors;
        Array.isArray(t) || (t = [t]);
        var i = [];

        if ("number" == typeof t[0]) {
          var a = [];
          if (Array.isArray(t)) for (var o = 0; o < t.length; o += 4) {
            a.push(t.slice(o, o + 4));
          } else for (var l = 0; l < t.length; l += 4) {
            a.push(t.subarray(l, l + 4));
          }
          t = a;
        }

        for (var u = 0; u < t.length; u++) {
          var f = t[u];
          f = s(f, "uint8");
          var h = c(f, !1);

          if (null == e[h]) {
            var p = r.length;
            e[h] = Math.floor(p / 4), r[p] = f[0], r[p + 1] = f[1], r[p + 2] = f[2], r[p + 3] = f[3];
          }

          i[u] = e[h];
        }

        return !this.tooManyColors && r.length > 4 * n && (this.tooManyColors = !0), this.updatePalette(r), 1 === i.length ? i[0] : i;
      }, b.prototype.updatePalette = function (t) {
        if (!this.tooManyColors) {
          var e = this.maxColors,
              r = this.paletteTexture,
              n = Math.ceil(.25 * t.length / e);
          if (n > 1) for (var i = .25 * (t = t.slice()).length % e; i < n * e; i++) {
            t.push(0, 0, 0, 0);
          }
          r.height < n && r.resize(e, n), r.subimage({
            width: Math.min(.25 * t.length, e),
            height: n,
            data: t
          }, 0, 0);
        }
      }, b.prototype.destroy = function () {
        return this.groups.forEach(function (t) {
          t.sizeBuffer.destroy(), t.positionBuffer.destroy(), t.positionFractBuffer.destroy(), t.colorBuffer.destroy(), t.activation.forEach(function (t) {
            return t && t.destroy && t.destroy();
          }), t.selectionBuffer.destroy(), t.elements && t.elements.destroy();
        }), this.groups.length = 0, this.paletteTexture.destroy(), this.markerTextures.forEach(function (t) {
          return t && t.destroy && t.destroy();
        }), this;
      };

      var _ = t("object-assign");

      e.exports = function (t, e) {
        var r = new x(t, e),
            n = r.render.bind(r);
        return _(n, {
          render: n,
          update: r.update.bind(r),
          draw: r.draw.bind(r),
          destroy: r.destroy.bind(r),
          regl: r.regl,
          gl: r.gl,
          canvas: r.gl.canvas,
          groups: r.groups,
          markers: r.markerCache,
          palette: r.palette
        }), n;
      };
    }, {
      "@plotly/point-cluster": 58,
      "array-bounds": 71,
      "color-id": 124,
      "color-normalize": 126,
      "flatten-vertex-data": 243,
      glslify: 433,
      "is-iexplorer": 445,
      "object-assign": 479,
      "parse-rect": 484,
      "pick-by-alias": 490,
      "to-float32": 591,
      "update-diff": 613
    }],
    531: [function (t, e, r) {
      "use strict";

      var n = t("regl-scatter2d"),
          i = t("pick-by-alias"),
          a = t("array-bounds"),
          o = t("raf"),
          s = t("array-range"),
          l = t("parse-rect"),
          c = t("flatten-vertex-data");

      function u(t, e) {
        if (!(this instanceof u)) return new u(t, e);
        this.traces = [], this.passes = {}, this.regl = t, this.scatter = n(t), this.canvas = this.scatter.canvas;
      }

      function f(t, e, r) {
        return (null != t.id ? t.id : t) << 16 | (255 & e) << 8 | 255 & r;
      }

      function h(t, e, r) {
        var n,
            i,
            a,
            o,
            s = t[e],
            l = t[r];
        return s.length > 2 ? (s[0], s[2], n = s[1], i = s[3]) : s.length ? (n = s[0], i = s[1]) : (s.x, n = s.y, s.x + s.width, i = s.y + s.height), l.length > 2 ? (a = l[0], o = l[2], l[1], l[3]) : l.length ? (a = l[0], o = l[1]) : (a = l.x, l.y, o = l.x + l.width, l.y + l.height), [a, n, o, i];
      }

      function p(t) {
        if ("number" == typeof t) return [t, t, t, t];
        if (2 === t.length) return [t[0], t[1], t[0], t[1]];
        var e = l(t);
        return [e.x, e.y, e.x + e.width, e.y + e.height];
      }

      e.exports = u, u.prototype.render = function () {
        for (var t, e = this, r = [], n = arguments.length; n--;) {
          r[n] = arguments[n];
        }

        return r.length && (t = this).update.apply(t, r), this.regl.attributes.preserveDrawingBuffer ? this.draw() : (this.dirty ? null == this.planned && (this.planned = o(function () {
          e.draw(), e.dirty = !0, e.planned = null;
        })) : (this.draw(), this.dirty = !0, o(function () {
          e.dirty = !1;
        })), this);
      }, u.prototype.update = function () {
        for (var t, e = [], r = arguments.length; r--;) {
          e[r] = arguments[r];
        }

        if (e.length) {
          for (var n = 0; n < e.length; n++) {
            this.updateItem(n, e[n]);
          }

          this.traces = this.traces.filter(Boolean);

          for (var i = [], a = 0, o = 0; o < this.traces.length; o++) {
            for (var s = this.traces[o], l = this.traces[o].passes, c = 0; c < l.length; c++) {
              i.push(this.passes[l[c]]);
            }

            s.passOffset = a, a += s.passes.length;
          }

          return (t = this.scatter).update.apply(t, i), this;
        }
      }, u.prototype.updateItem = function (t, e) {
        var r = this.regl;
        if (null === e) return this.traces[t] = null, this;
        if (!e) return this;
        var n,
            o = i(e, {
          data: "data items columns rows values dimensions samples x",
          snap: "snap cluster",
          size: "sizes size radius",
          color: "colors color fill fill-color fillColor",
          opacity: "opacity alpha transparency opaque",
          borderSize: "borderSizes borderSize border-size bordersize borderWidth borderWidths border-width borderwidth stroke-width strokeWidth strokewidth outline",
          borderColor: "borderColors borderColor bordercolor stroke stroke-color strokeColor",
          marker: "markers marker shape",
          range: "range ranges databox dataBox",
          viewport: "viewport viewBox viewbox",
          domain: "domain domains area areas",
          padding: "pad padding paddings pads margin margins",
          transpose: "transpose transposed",
          diagonal: "diagonal diag showDiagonal",
          upper: "upper up top upperhalf upperHalf showupperhalf showUpper showUpperHalf",
          lower: "lower low bottom lowerhalf lowerHalf showlowerhalf showLowerHalf showLower"
        }),
            s = this.traces[t] || (this.traces[t] = {
          id: t,
          buffer: r.buffer({
            usage: "dynamic",
            type: "float",
            data: new Uint8Array()
          }),
          color: "black",
          marker: null,
          size: 12,
          borderColor: "transparent",
          borderSize: 1,
          viewport: l([r._gl.drawingBufferWidth, r._gl.drawingBufferHeight]),
          padding: [0, 0, 0, 0],
          opacity: 1,
          diagonal: !0,
          upper: !0,
          lower: !0
        });

        if (null != o.color && (s.color = o.color), null != o.size && (s.size = o.size), null != o.marker && (s.marker = o.marker), null != o.borderColor && (s.borderColor = o.borderColor), null != o.borderSize && (s.borderSize = o.borderSize), null != o.opacity && (s.opacity = o.opacity), o.viewport && (s.viewport = l(o.viewport)), null != o.diagonal && (s.diagonal = o.diagonal), null != o.upper && (s.upper = o.upper), null != o.lower && (s.lower = o.lower), o.data) {
          s.buffer(c(o.data)), s.columns = o.data.length, s.count = o.data[0].length, s.bounds = [];

          for (var u = 0; u < s.columns; u++) {
            s.bounds[u] = a(o.data[u], 1);
          }
        }

        o.range && (s.range = o.range, n = s.range && "number" != typeof s.range[0]), o.domain && (s.domain = o.domain);
        var d = !1;
        null != o.padding && (Array.isArray(o.padding) && o.padding.length === s.columns && "number" == typeof o.padding[o.padding.length - 1] ? (s.padding = o.padding.map(p), d = !0) : s.padding = p(o.padding));

        var m = s.columns,
            g = s.count,
            v = s.viewport.width,
            y = s.viewport.height,
            x = s.viewport.x,
            b = s.viewport.y,
            _ = v / m,
            w = y / m;

        s.passes = [];

        for (var T = 0; T < m; T++) {
          for (var k = 0; k < m; k++) {
            if ((s.diagonal || k !== T) && (s.upper || !(T > k)) && (s.lower || !(T < k))) {
              var M = f(s.id, T, k),
                  A = this.passes[M] || (this.passes[M] = {});

              if (o.data && (o.transpose ? A.positions = {
                x: {
                  buffer: s.buffer,
                  offset: k,
                  count: g,
                  stride: m
                },
                y: {
                  buffer: s.buffer,
                  offset: T,
                  count: g,
                  stride: m
                }
              } : A.positions = {
                x: {
                  buffer: s.buffer,
                  offset: k * g,
                  count: g
                },
                y: {
                  buffer: s.buffer,
                  offset: T * g,
                  count: g
                }
              }, A.bounds = h(s.bounds, T, k)), o.domain || o.viewport || o.data) {
                var S = d ? h(s.padding, T, k) : s.padding;

                if (s.domain) {
                  var E = h(s.domain, T, k),
                      L = E[0],
                      C = E[1],
                      P = E[2],
                      I = E[3];
                  A.viewport = [x + L * v + S[0], b + C * y + S[1], x + P * v - S[2], b + I * y - S[3]];
                } else A.viewport = [x + k * _ + _ * S[0], b + T * w + w * S[1], x + (k + 1) * _ - _ * S[2], b + (T + 1) * w - w * S[3]];
              }

              o.color && (A.color = s.color), o.size && (A.size = s.size), o.marker && (A.marker = s.marker), o.borderSize && (A.borderSize = s.borderSize), o.borderColor && (A.borderColor = s.borderColor), o.opacity && (A.opacity = s.opacity), o.range && (A.range = n ? h(s.range, T, k) : s.range || A.bounds), s.passes.push(M);
            }
          }
        }

        return this;
      }, u.prototype.draw = function () {
        for (var t, e = [], r = arguments.length; r--;) {
          e[r] = arguments[r];
        }

        if (e.length) {
          for (var n = [], i = 0; i < e.length; i++) {
            if ("number" == typeof e[i]) {
              var a = this.traces[e[i]],
                  o = a.passes,
                  l = a.passOffset;
              n.push.apply(n, s(l, l + o.length));
            } else if (e[i].length) {
              var c = e[i],
                  u = this.traces[i],
                  f = u.passes,
                  h = u.passOffset;
              f = f.map(function (t, e) {
                n[h + e] = c;
              });
            }
          }

          (t = this.scatter).draw.apply(t, n);
        } else this.scatter.draw();

        return this;
      }, u.prototype.destroy = function () {
        return this.traces.forEach(function (t) {
          t.buffer && t.buffer.destroy && t.buffer.destroy();
        }), this.traces = null, this.passes = null, this.scatter.destroy(), this;
      };
    }, {
      "array-bounds": 71,
      "array-range": 74,
      "flatten-vertex-data": 243,
      "parse-rect": 484,
      "pick-by-alias": 490,
      raf: 522,
      "regl-scatter2d": 530
    }],
    532: [function (t, e, r) {
      !function (t, n) {
        "object" == _typeof(r) && void 0 !== e ? e.exports = n() : t.createREGL = n();
      }(this, function () {
        function t(t, e) {
          this.id = V++, this.type = t, this.data = e;
        }

        function e(t) {
          return "[" + function t(e) {
            if (0 === e.length) return [];
            var r = e.charAt(0),
                n = e.charAt(e.length - 1);
            if (1 < e.length && r === n && ('"' === r || "'" === r)) return ['"' + e.substr(1, e.length - 2).replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"'];
            if (r = /\[(false|true|null|\d+|'[^']*'|"[^"]*")\]/.exec(e)) return t(e.substr(0, r.index)).concat(t(r[1])).concat(t(e.substr(r.index + r[0].length)));
            if (1 === (r = e.split(".")).length) return ['"' + e.replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"'];

            for (e = [], n = 0; n < r.length; ++n) {
              e = e.concat(t(r[n]));
            }

            return e;
          }(t).join("][") + "]";
        }

        function r(t) {
          return "string" == typeof t ? t.split() : t;
        }

        function n(t) {
          return "string" == typeof t ? document.querySelector(t) : t;
        }

        function i(t) {
          var e,
              i,
              a,
              o,
              s = t || {};
          t = {};

          var l = [],
              c = [],
              u = "undefined" == typeof window ? 1 : window.devicePixelRatio,
              f = !1,
              h = function h(t) {},
              p = function p() {};

          if ("string" == typeof s ? e = document.querySelector(s) : "object" == _typeof(s) && ("string" == typeof s.nodeName && "function" == typeof s.appendChild && "function" == typeof s.getBoundingClientRect ? e = s : "function" == typeof s.drawArrays || "function" == typeof s.drawElements ? a = (o = s).canvas : ("gl" in s ? o = s.gl : "canvas" in s ? a = n(s.canvas) : "container" in s && (i = n(s.container)), "attributes" in s && (t = s.attributes), "extensions" in s && (l = r(s.extensions)), "optionalExtensions" in s && (c = r(s.optionalExtensions)), "onDone" in s && (h = s.onDone), "profile" in s && (f = !!s.profile), "pixelRatio" in s && (u = +s.pixelRatio))), e && ("canvas" === e.nodeName.toLowerCase() ? a = e : i = e), !o) {
            if (!a) {
              if (!(e = function (t, e, r) {
                function n() {
                  var e = window.innerWidth,
                      n = window.innerHeight;
                  t !== document.body && (e = (n = t.getBoundingClientRect()).right - n.left, n = n.bottom - n.top), a.width = r * e, a.height = r * n, U(a.style, {
                    width: e + "px",
                    height: n + "px"
                  });
                }

                var i,
                    a = document.createElement("canvas");
                return U(a.style, {
                  border: 0,
                  margin: 0,
                  padding: 0,
                  top: 0,
                  left: 0
                }), t.appendChild(a), t === document.body && (a.style.position = "absolute", U(t.style, {
                  margin: 0,
                  padding: 0
                })), t !== document.body && "function" == typeof ResizeObserver ? (i = new ResizeObserver(function () {
                  setTimeout(n);
                })).observe(t) : window.addEventListener("resize", n, !1), n(), {
                  canvas: a,
                  onDestroy: function onDestroy() {
                    i ? i.disconnect() : window.removeEventListener("resize", n), t.removeChild(a);
                  }
                };
              }(i || document.body, 0, u))) return null;
              a = e.canvas, p = e.onDestroy;
            }

            void 0 === t.premultipliedAlpha && (t.premultipliedAlpha = !0), o = function (t, e) {
              function r(r) {
                try {
                  return t.getContext(r, e);
                } catch (t) {
                  return null;
                }
              }

              return r("webgl") || r("experimental-webgl") || r("webgl-experimental");
            }(a, t);
          }

          return o ? {
            gl: o,
            canvas: a,
            container: i,
            extensions: l,
            optionalExtensions: c,
            pixelRatio: u,
            profile: f,
            onDone: h,
            onDestroy: p
          } : (p(), h("webgl not supported, try upgrading your browser or graphics drivers http://get.webgl.org"), null);
        }

        function a(t, e) {
          for (var r = Array(t), n = 0; n < t; ++n) {
            r[n] = e(n);
          }

          return r;
        }

        function o(t) {
          var e, r;
          return e = (65535 < t) << 4, e |= r = (255 < (t >>>= e)) << 3, (e |= r = (15 < (t >>>= r)) << 2) | (r = (3 < (t >>>= r)) << 1) | t >>> r >> 1;
        }

        function s() {
          function t(t) {
            t: {
              for (var e = 16; 268435456 >= e; e *= 16) {
                if (t <= e) {
                  t = e;
                  break t;
                }
              }

              t = 0;
            }

            return 0 < (e = r[o(t) >> 2]).length ? e.pop() : new ArrayBuffer(t);
          }

          function e(t) {
            r[o(t.byteLength) >> 2].push(t);
          }

          var r = a(8, function () {
            return [];
          });
          return {
            alloc: t,
            free: e,
            allocType: function allocType(e, r) {
              var n = null;

              switch (e) {
                case 5120:
                  n = new Int8Array(t(r), 0, r);
                  break;

                case 5121:
                  n = new Uint8Array(t(r), 0, r);
                  break;

                case 5122:
                  n = new Int16Array(t(2 * r), 0, r);
                  break;

                case 5123:
                  n = new Uint16Array(t(2 * r), 0, r);
                  break;

                case 5124:
                  n = new Int32Array(t(4 * r), 0, r);
                  break;

                case 5125:
                  n = new Uint32Array(t(4 * r), 0, r);
                  break;

                case 5126:
                  n = new Float32Array(t(4 * r), 0, r);
                  break;

                default:
                  return null;
              }

              return n.length !== r ? n.subarray(0, r) : n;
            },
            freeType: function freeType(t) {
              e(t.buffer);
            }
          };
        }

        function l(t) {
          return !!t && "object" == _typeof(t) && Array.isArray(t.shape) && Array.isArray(t.stride) && "number" == typeof t.offset && t.shape.length === t.stride.length && (Array.isArray(t.data) || X(t.data));
        }

        function c(t, e, r, n, i, a) {
          for (var o = 0; o < e; ++o) {
            for (var s = t[o], l = 0; l < r; ++l) {
              for (var c = s[l], u = 0; u < n; ++u) {
                i[a++] = c[u];
              }
            }
          }
        }

        function u(t) {
          return 0 | K[Object.prototype.toString.call(t)];
        }

        function f(t, e) {
          for (var r = 0; r < e.length; ++r) {
            t[r] = e[r];
          }
        }

        function h(t, e, r, n, i, a, o) {
          for (var s = 0, l = 0; l < r; ++l) {
            for (var c = 0; c < n; ++c) {
              t[s++] = e[i * l + a * c + o];
            }
          }
        }

        function p(t, e, r, n) {
          function i(e) {
            this.id = c++, this.buffer = t.createBuffer(), this.type = e, this.usage = 35044, this.byteLength = 0, this.dimension = 1, this.dtype = 5121, this.persistentData = null, r.profile && (this.stats = {
              size: 0
            });
          }

          function a(e, r, n) {
            e.byteLength = r.byteLength, t.bufferData(e.type, r, n);
          }

          function o(t, e, r, n, i, o) {
            if (t.usage = r, Array.isArray(e)) {
              if (t.dtype = n || 5126, 0 < e.length) if (Array.isArray(e[0])) {
                i = et(e);

                for (var s = n = 1; s < i.length; ++s) {
                  n *= i[s];
                }

                t.dimension = n, a(t, e = tt(e, i, t.dtype), r), o ? t.persistentData = e : Y.freeType(e);
              } else "number" == typeof e[0] ? (t.dimension = i, f(i = Y.allocType(t.dtype, e.length), e), a(t, i, r), o ? t.persistentData = i : Y.freeType(i)) : X(e[0]) && (t.dimension = e[0].length, t.dtype = n || u(e[0]) || 5126, a(t, e = tt(e, [e.length, e[0].length], t.dtype), r), o ? t.persistentData = e : Y.freeType(e));
            } else if (X(e)) t.dtype = n || u(e), t.dimension = i, a(t, e, r), o && (t.persistentData = new Uint8Array(new Uint8Array(e.buffer)));else if (l(e)) {
              i = e.shape;
              var c = e.stride,
                  p = (s = e.offset, 0),
                  d = 0,
                  m = 0,
                  g = 0;
              1 === i.length ? (p = i[0], d = 1, m = c[0], g = 0) : 2 === i.length && (p = i[0], d = i[1], m = c[0], g = c[1]), t.dtype = n || u(e.data) || 5126, t.dimension = d, h(i = Y.allocType(t.dtype, p * d), e.data, p, d, m, g, s), a(t, i, r), o ? t.persistentData = i : Y.freeType(i);
            } else e instanceof ArrayBuffer && (t.dtype = 5121, t.dimension = i, a(t, e, r), o && (t.persistentData = new Uint8Array(new Uint8Array(e))));
          }

          function s(r) {
            e.bufferCount--, n(r), t.deleteBuffer(r.buffer), r.buffer = null, delete p[r.id];
          }

          var c = 0,
              p = {};
          i.prototype.bind = function () {
            t.bindBuffer(this.type, this.buffer);
          }, i.prototype.destroy = function () {
            s(this);
          };
          var d = [];
          return r.profile && (e.getTotalBufferSize = function () {
            var t = 0;
            return Object.keys(p).forEach(function (e) {
              t += p[e].stats.size;
            }), t;
          }), {
            create: function create(n, a, c, d) {
              function m(e) {
                var n = 35044,
                    i = null,
                    a = 0,
                    s = 0,
                    c = 1;
                return Array.isArray(e) || X(e) || l(e) || e instanceof ArrayBuffer ? i = e : "number" == typeof e ? a = 0 | e : e && ("data" in e && (i = e.data), "usage" in e && (n = $[e.usage]), "type" in e && (s = Q[e.type]), "dimension" in e && (c = 0 | e.dimension), "length" in e && (a = 0 | e.length)), g.bind(), i ? o(g, i, n, s, c, d) : (a && t.bufferData(g.type, a, n), g.dtype = s || 5121, g.usage = n, g.dimension = c, g.byteLength = a), r.profile && (g.stats.size = g.byteLength * rt[g.dtype]), m;
              }

              e.bufferCount++;
              var g = new i(a);
              return p[g.id] = g, c || m(n), m._reglType = "buffer", m._buffer = g, m.subdata = function (e, r) {
                var n,
                    i = 0 | (r || 0);
                if (g.bind(), X(e) || e instanceof ArrayBuffer) t.bufferSubData(g.type, i, e);else if (Array.isArray(e)) {
                  if (0 < e.length) if ("number" == typeof e[0]) {
                    var a = Y.allocType(g.dtype, e.length);
                    f(a, e), t.bufferSubData(g.type, i, a), Y.freeType(a);
                  } else (Array.isArray(e[0]) || X(e[0])) && (n = et(e), a = tt(e, n, g.dtype), t.bufferSubData(g.type, i, a), Y.freeType(a));
                } else if (l(e)) {
                  n = e.shape;
                  var o = e.stride,
                      s = a = 0,
                      c = 0,
                      p = 0;
                  1 === n.length ? (a = n[0], s = 1, c = o[0], p = 0) : 2 === n.length && (a = n[0], s = n[1], c = o[0], p = o[1]), n = Array.isArray(e.data) ? g.dtype : u(e.data), h(n = Y.allocType(n, a * s), e.data, a, s, c, p, e.offset), t.bufferSubData(g.type, i, n), Y.freeType(n);
                }
                return m;
              }, r.profile && (m.stats = g.stats), m.destroy = function () {
                s(g);
              }, m;
            },
            createStream: function createStream(t, e) {
              var r = d.pop();
              return r || (r = new i(t)), r.bind(), o(r, e, 35040, 0, 1, !1), r;
            },
            destroyStream: function destroyStream(t) {
              d.push(t);
            },
            clear: function clear() {
              Z(p).forEach(s), d.forEach(s);
            },
            getBuffer: function getBuffer(t) {
              return t && t._buffer instanceof i ? t._buffer : null;
            },
            restore: function restore() {
              Z(p).forEach(function (e) {
                e.buffer = t.createBuffer(), t.bindBuffer(e.type, e.buffer), t.bufferData(e.type, e.persistentData || e.byteLength, e.usage);
              });
            },
            _initBuffer: o
          };
        }

        function d(t, e, r, n) {
          function i(t) {
            this.id = c++, s[this.id] = this, this.buffer = t, this.primType = 4, this.type = this.vertCount = 0;
          }

          function a(n, i, a, o, s, c, u) {
            var f;

            if (n.buffer.bind(), i ? ((f = u) || X(i) && (!l(i) || X(i.data)) || (f = e.oes_element_index_uint ? 5125 : 5123), r._initBuffer(n.buffer, i, a, f, 3)) : (t.bufferData(34963, c, a), n.buffer.dtype = f || 5121, n.buffer.usage = a, n.buffer.dimension = 3, n.buffer.byteLength = c), f = u, !u) {
              switch (n.buffer.dtype) {
                case 5121:
                case 5120:
                  f = 5121;
                  break;

                case 5123:
                case 5122:
                  f = 5123;
                  break;

                case 5125:
                case 5124:
                  f = 5125;
              }

              n.buffer.dtype = f;
            }

            n.type = f, 0 > (i = s) && (i = n.buffer.byteLength, 5123 === f ? i >>= 1 : 5125 === f && (i >>= 2)), n.vertCount = i, i = o, 0 > o && (i = 4, 1 === (o = n.buffer.dimension) && (i = 0), 2 === o && (i = 1), 3 === o && (i = 4)), n.primType = i;
          }

          function o(t) {
            n.elementsCount--, delete s[t.id], t.buffer.destroy(), t.buffer = null;
          }

          var s = {},
              c = 0,
              u = {
            uint8: 5121,
            uint16: 5123
          };
          e.oes_element_index_uint && (u.uint32 = 5125), i.prototype.bind = function () {
            this.buffer.bind();
          };
          var f = [];
          return {
            create: function create(t, e) {
              function s(t) {
                if (t) {
                  if ("number" == typeof t) c(t), f.primType = 4, f.vertCount = 0 | t, f.type = 5121;else {
                    var e = null,
                        r = 35044,
                        n = -1,
                        i = -1,
                        o = 0,
                        h = 0;
                    Array.isArray(t) || X(t) || l(t) ? e = t : ("data" in t && (e = t.data), "usage" in t && (r = $[t.usage]), "primitive" in t && (n = nt[t.primitive]), "count" in t && (i = 0 | t.count), "type" in t && (h = u[t.type]), "length" in t ? o = 0 | t.length : (o = i, 5123 === h || 5122 === h ? o *= 2 : 5125 !== h && 5124 !== h || (o *= 4))), a(f, e, r, n, i, o, h);
                  }
                } else c(), f.primType = 4, f.vertCount = 0, f.type = 5121;
                return s;
              }

              var c = r.create(null, 34963, !0),
                  f = new i(c._buffer);
              return n.elementsCount++, s(t), s._reglType = "elements", s._elements = f, s.subdata = function (t, e) {
                return c.subdata(t, e), s;
              }, s.destroy = function () {
                o(f);
              }, s;
            },
            createStream: function createStream(t) {
              var e = f.pop();
              return e || (e = new i(r.create(null, 34963, !0, !1)._buffer)), a(e, t, 35040, -1, -1, 0, 0), e;
            },
            destroyStream: function destroyStream(t) {
              f.push(t);
            },
            getElements: function getElements(t) {
              return "function" == typeof t && t._elements instanceof i ? t._elements : null;
            },
            clear: function clear() {
              Z(s).forEach(o);
            }
          };
        }

        function m(t) {
          for (var e = Y.allocType(5123, t.length), r = 0; r < t.length; ++r) {
            if (isNaN(t[r])) e[r] = 65535;else if (1 / 0 === t[r]) e[r] = 31744;else if (-1 / 0 === t[r]) e[r] = 64512;else {
              it[0] = t[r];
              var n = (a = at[0]) >>> 31 << 15,
                  i = (a << 1 >>> 24) - 127,
                  a = a >> 13 & 1023;
              e[r] = -24 > i ? n : -14 > i ? n + (a + 1024 >> -14 - i) : 15 < i ? n + 31744 : n + (i + 15 << 10) + a;
            }
          }

          return e;
        }

        function g(t) {
          return Array.isArray(t) || X(t);
        }

        function v(t) {
          return "[object " + t + "]";
        }

        function y(t) {
          return Array.isArray(t) && (0 === t.length || "number" == typeof t[0]);
        }

        function x(t) {
          return !(!Array.isArray(t) || 0 === t.length || !g(t[0]));
        }

        function b(t) {
          return Object.prototype.toString.call(t);
        }

        function _(t) {
          if (!t) return !1;
          var e = b(t);
          return 0 <= mt.indexOf(e) || y(t) || x(t) || l(t);
        }

        function w(t, e) {
          36193 === t.type ? (t.data = m(e), Y.freeType(e)) : t.data = e;
        }

        function T(t, e, r, n, i, a) {
          if (t = void 0 !== vt[t] ? vt[t] : lt[t] * gt[e], a && (t *= 6), i) {
            for (n = 0; 1 <= r;) {
              n += t * r * r, r /= 2;
            }

            return n;
          }

          return t * r * n;
        }

        function k(t, e, r, n, i, a, o) {
          function s() {
            this.format = this.internalformat = 6408, this.type = 5121, this.flipY = this.premultiplyAlpha = this.compressed = !1, this.unpackAlignment = 1, this.colorSpace = 37444, this.channels = this.height = this.width = 0;
          }

          function c(t, e) {
            t.internalformat = e.internalformat, t.format = e.format, t.type = e.type, t.compressed = e.compressed, t.premultiplyAlpha = e.premultiplyAlpha, t.flipY = e.flipY, t.unpackAlignment = e.unpackAlignment, t.colorSpace = e.colorSpace, t.width = e.width, t.height = e.height, t.channels = e.channels;
          }

          function u(t, e) {
            if ("object" == _typeof(e) && e) {
              "premultiplyAlpha" in e && (t.premultiplyAlpha = e.premultiplyAlpha), "flipY" in e && (t.flipY = e.flipY), "alignment" in e && (t.unpackAlignment = e.alignment), "colorSpace" in e && (t.colorSpace = q[e.colorSpace]), "type" in e && (t.type = H[e.type]);
              var r = t.width,
                  n = t.height,
                  i = t.channels,
                  a = !1;
              "shape" in e ? (r = e.shape[0], n = e.shape[1], 3 === e.shape.length && (i = e.shape[2], a = !0)) : ("radius" in e && (r = n = e.radius), "width" in e && (r = e.width), "height" in e && (n = e.height), "channels" in e && (i = e.channels, a = !0)), t.width = 0 | r, t.height = 0 | n, t.channels = 0 | i, r = !1, "format" in e && (r = e.format, n = t.internalformat = G[r], t.format = at[n], r in H && !("type" in e) && (t.type = H[r]), r in W && (t.compressed = !0), r = !0), !a && r ? t.channels = lt[t.format] : a && !r && t.channels !== st[t.format] && (t.format = t.internalformat = st[t.channels]);
            }
          }

          function f(e) {
            t.pixelStorei(37440, e.flipY), t.pixelStorei(37441, e.premultiplyAlpha), t.pixelStorei(37443, e.colorSpace), t.pixelStorei(3317, e.unpackAlignment);
          }

          function h() {
            s.call(this), this.yOffset = this.xOffset = 0, this.data = null, this.needsFree = !1, this.element = null, this.needsCopy = !1;
          }

          function p(t, e) {
            var r = null;

            if (_(e) ? r = e : e && (u(t, e), "x" in e && (t.xOffset = 0 | e.x), "y" in e && (t.yOffset = 0 | e.y), _(e.data) && (r = e.data)), e.copy) {
              var n = i.viewportWidth,
                  a = i.viewportHeight;
              t.width = t.width || n - t.xOffset, t.height = t.height || a - t.yOffset, t.needsCopy = !0;
            } else if (r) {
              if (X(r)) t.channels = t.channels || 4, t.data = r, "type" in e || 5121 !== t.type || (t.type = 0 | K[Object.prototype.toString.call(r)]);else if (y(r)) {
                switch (t.channels = t.channels || 4, a = (n = r).length, t.type) {
                  case 5121:
                  case 5123:
                  case 5125:
                  case 5126:
                    (a = Y.allocType(t.type, a)).set(n), t.data = a;
                    break;

                  case 36193:
                    t.data = m(n);
                }

                t.alignment = 1, t.needsFree = !0;
              } else if (l(r)) {
                n = r.data, Array.isArray(n) || 5121 !== t.type || (t.type = 0 | K[Object.prototype.toString.call(n)]);
                a = r.shape;
                var o,
                    s,
                    c,
                    f,
                    h = r.stride;
                3 === a.length ? (c = a[2], f = h[2]) : f = c = 1, o = a[0], s = a[1], a = h[0], h = h[1], t.alignment = 1, t.width = o, t.height = s, t.channels = c, t.format = t.internalformat = st[c], t.needsFree = !0, o = f, r = r.offset, c = t.width, f = t.height, s = t.channels;

                for (var p = Y.allocType(36193 === t.type ? 5126 : t.type, c * f * s), d = 0, v = 0; v < f; ++v) {
                  for (var T = 0; T < c; ++T) {
                    for (var k = 0; k < s; ++k) {
                      p[d++] = n[a * T + h * v + o * k + r];
                    }
                  }
                }

                w(t, p);
              } else if (b(r) === ct || b(r) === ut || b(r) === ft) b(r) === ct || b(r) === ut ? t.element = r : t.element = r.canvas, t.width = t.element.width, t.height = t.element.height, t.channels = 4;else if (b(r) === ht) t.element = r, t.width = r.width, t.height = r.height, t.channels = 4;else if (b(r) === pt) t.element = r, t.width = r.naturalWidth, t.height = r.naturalHeight, t.channels = 4;else if (b(r) === dt) t.element = r, t.width = r.videoWidth, t.height = r.videoHeight, t.channels = 4;else if (x(r)) {
                for (n = t.width || r[0].length, a = t.height || r.length, h = t.channels, h = g(r[0][0]) ? h || r[0][0].length : h || 1, o = J.shape(r), c = 1, f = 0; f < o.length; ++f) {
                  c *= o[f];
                }

                c = Y.allocType(36193 === t.type ? 5126 : t.type, c), J.flatten(r, o, "", c), w(t, c), t.alignment = 1, t.width = n, t.height = a, t.channels = h, t.format = t.internalformat = st[h], t.needsFree = !0;
              }
            } else t.width = t.width || 1, t.height = t.height || 1, t.channels = t.channels || 4;
          }

          function d(e, r, i, a, o) {
            var s = e.element,
                l = e.data,
                c = e.internalformat,
                u = e.format,
                h = e.type,
                p = e.width,
                d = e.height;
            f(e), s ? t.texSubImage2D(r, o, i, a, u, h, s) : e.compressed ? t.compressedTexSubImage2D(r, o, i, a, c, p, d, l) : e.needsCopy ? (n(), t.copyTexSubImage2D(r, o, i, a, e.xOffset, e.yOffset, p, d)) : t.texSubImage2D(r, o, i, a, p, d, u, h, l);
          }

          function v() {
            return mt.pop() || new h();
          }

          function k(t) {
            t.needsFree && Y.freeType(t.data), h.call(t), mt.push(t);
          }

          function M() {
            s.call(this), this.genMipmaps = !1, this.mipmapHint = 4352, this.mipmask = 0, this.images = Array(16);
          }

          function A(t, e, r) {
            var n = t.images[0] = v();
            t.mipmask = 1, n.width = t.width = e, n.height = t.height = r, n.channels = t.channels = 4;
          }

          function S(t, e) {
            var r = null;
            if (_(e)) c(r = t.images[0] = v(), t), p(r, e), t.mipmask = 1;else if (u(t, e), Array.isArray(e.mipmap)) for (var n = e.mipmap, i = 0; i < n.length; ++i) {
              c(r = t.images[i] = v(), t), r.width >>= i, r.height >>= i, p(r, n[i]), t.mipmask |= 1 << i;
            } else c(r = t.images[0] = v(), t), p(r, e), t.mipmask = 1;
            c(t, t.images[0]);
          }

          function E(e, r) {
            for (var i = e.images, a = 0; a < i.length && i[a]; ++a) {
              var o = i[a],
                  s = r,
                  l = a,
                  c = o.element,
                  u = o.data,
                  h = o.internalformat,
                  p = o.format,
                  d = o.type,
                  m = o.width,
                  g = o.height;
              f(o), c ? t.texImage2D(s, l, p, p, d, c) : o.compressed ? t.compressedTexImage2D(s, l, h, m, g, 0, u) : o.needsCopy ? (n(), t.copyTexImage2D(s, l, p, o.xOffset, o.yOffset, m, g, 0)) : t.texImage2D(s, l, p, m, g, 0, p, d, u || null);
            }
          }

          function L() {
            var t = gt.pop() || new M();
            s.call(t);

            for (var e = t.mipmask = 0; 16 > e; ++e) {
              t.images[e] = null;
            }

            return t;
          }

          function C(t) {
            for (var e = t.images, r = 0; r < e.length; ++r) {
              e[r] && k(e[r]), e[r] = null;
            }

            gt.push(t);
          }

          function P() {
            this.magFilter = this.minFilter = 9728, this.wrapT = this.wrapS = 33071, this.anisotropic = 1, this.genMipmaps = !1, this.mipmapHint = 4352;
          }

          function I(t, e) {
            "min" in e && (t.minFilter = V[e.min], 0 <= ot.indexOf(t.minFilter) && !("faces" in e) && (t.genMipmaps = !0)), "mag" in e && (t.magFilter = j[e.mag]);
            var r = t.wrapS,
                n = t.wrapT;

            if ("wrap" in e) {
              var i = e.wrap;
              "string" == typeof i ? r = n = N[i] : Array.isArray(i) && (r = N[i[0]], n = N[i[1]]);
            } else "wrapS" in e && (r = N[e.wrapS]), "wrapT" in e && (n = N[e.wrapT]);

            if (t.wrapS = r, t.wrapT = n, "anisotropic" in e && (t.anisotropic = e.anisotropic), "mipmap" in e) {
              switch (r = !1, _typeof(e.mipmap)) {
                case "string":
                  t.mipmapHint = B[e.mipmap], r = t.genMipmaps = !0;
                  break;

                case "boolean":
                  r = t.genMipmaps = e.mipmap;
                  break;

                case "object":
                  t.genMipmaps = !1, r = !0;
              }

              !r || "min" in e || (t.minFilter = 9984);
            }
          }

          function O(r, n) {
            t.texParameteri(n, 10241, r.minFilter), t.texParameteri(n, 10240, r.magFilter), t.texParameteri(n, 10242, r.wrapS), t.texParameteri(n, 10243, r.wrapT), e.ext_texture_filter_anisotropic && t.texParameteri(n, 34046, r.anisotropic), r.genMipmaps && (t.hint(33170, r.mipmapHint), t.generateMipmap(n));
          }

          function z(e) {
            s.call(this), this.mipmask = 0, this.internalformat = 6408, this.id = vt++, this.refCount = 1, this.target = e, this.texture = t.createTexture(), this.unit = -1, this.bindCount = 0, this.texInfo = new P(), o.profile && (this.stats = {
              size: 0
            });
          }

          function D(e) {
            t.activeTexture(33984), t.bindTexture(e.target, e.texture);
          }

          function R() {
            var e = bt[0];
            e ? t.bindTexture(e.target, e.texture) : t.bindTexture(3553, null);
          }

          function F(e) {
            var r = e.texture,
                n = e.unit,
                i = e.target;
            0 <= n && (t.activeTexture(33984 + n), t.bindTexture(i, null), bt[n] = null), t.deleteTexture(r), e.texture = null, e.params = null, e.pixels = null, e.refCount = 0, delete yt[e.id], a.textureCount--;
          }

          var B = {
            "don't care": 4352,
            "dont care": 4352,
            nice: 4354,
            fast: 4353
          },
              N = {
            repeat: 10497,
            clamp: 33071,
            mirror: 33648
          },
              j = {
            nearest: 9728,
            linear: 9729
          },
              V = U({
            mipmap: 9987,
            "nearest mipmap nearest": 9984,
            "linear mipmap nearest": 9985,
            "nearest mipmap linear": 9986,
            "linear mipmap linear": 9987
          }, j),
              q = {
            none: 0,
            browser: 37444
          },
              H = {
            uint8: 5121,
            rgba4: 32819,
            rgb565: 33635,
            "rgb5 a1": 32820
          },
              G = {
            alpha: 6406,
            luminance: 6409,
            "luminance alpha": 6410,
            rgb: 6407,
            rgba: 6408,
            rgba4: 32854,
            "rgb5 a1": 32855,
            rgb565: 36194
          },
              W = {};
          e.ext_srgb && (G.srgb = 35904, G.srgba = 35906), e.oes_texture_float && (H.float32 = H.float = 5126), e.oes_texture_half_float && (H.float16 = H["half float"] = 36193), e.webgl_depth_texture && (U(G, {
            depth: 6402,
            "depth stencil": 34041
          }), U(H, {
            uint16: 5123,
            uint32: 5125,
            "depth stencil": 34042
          })), e.webgl_compressed_texture_s3tc && U(W, {
            "rgb s3tc dxt1": 33776,
            "rgba s3tc dxt1": 33777,
            "rgba s3tc dxt3": 33778,
            "rgba s3tc dxt5": 33779
          }), e.webgl_compressed_texture_atc && U(W, {
            "rgb atc": 35986,
            "rgba atc explicit alpha": 35987,
            "rgba atc interpolated alpha": 34798
          }), e.webgl_compressed_texture_pvrtc && U(W, {
            "rgb pvrtc 4bppv1": 35840,
            "rgb pvrtc 2bppv1": 35841,
            "rgba pvrtc 4bppv1": 35842,
            "rgba pvrtc 2bppv1": 35843
          }), e.webgl_compressed_texture_etc1 && (W["rgb etc1"] = 36196);
          var Q = Array.prototype.slice.call(t.getParameter(34467));
          Object.keys(W).forEach(function (t) {
            var e = W[t];
            0 <= Q.indexOf(e) && (G[t] = e);
          });
          var $ = Object.keys(G);
          r.textureFormats = $;
          var tt = [];
          Object.keys(G).forEach(function (t) {
            tt[G[t]] = t;
          });
          var et = [];
          Object.keys(H).forEach(function (t) {
            et[H[t]] = t;
          });
          var rt = [];
          Object.keys(j).forEach(function (t) {
            rt[j[t]] = t;
          });
          var nt = [];
          Object.keys(V).forEach(function (t) {
            nt[V[t]] = t;
          });
          var it = [];
          Object.keys(N).forEach(function (t) {
            it[N[t]] = t;
          });
          var at = $.reduce(function (t, r) {
            var n = G[r];
            return 6409 === n || 6406 === n || 6409 === n || 6410 === n || 6402 === n || 34041 === n || e.ext_srgb && (35904 === n || 35906 === n) ? t[n] = n : 32855 === n || 0 <= r.indexOf("rgba") ? t[n] = 6408 : t[n] = 6407, t;
          }, {}),
              mt = [],
              gt = [],
              vt = 0,
              yt = {},
              xt = r.maxTextureUnits,
              bt = Array(xt).map(function () {
            return null;
          });
          return U(z.prototype, {
            bind: function bind() {
              this.bindCount += 1;
              var e = this.unit;

              if (0 > e) {
                for (var r = 0; r < xt; ++r) {
                  var n = bt[r];

                  if (n) {
                    if (0 < n.bindCount) continue;
                    n.unit = -1;
                  }

                  bt[r] = this, e = r;
                  break;
                }

                o.profile && a.maxTextureUnits < e + 1 && (a.maxTextureUnits = e + 1), this.unit = e, t.activeTexture(33984 + e), t.bindTexture(this.target, this.texture);
              }

              return e;
            },
            unbind: function unbind() {
              --this.bindCount;
            },
            decRef: function decRef() {
              0 >= --this.refCount && F(this);
            }
          }), o.profile && (a.getTotalTextureSize = function () {
            var t = 0;
            return Object.keys(yt).forEach(function (e) {
              t += yt[e].stats.size;
            }), t;
          }), {
            create2D: function create2D(e, r) {
              function n(t, e) {
                var r = i.texInfo;
                P.call(r);
                var a = L();
                return "number" == typeof t ? A(a, 0 | t, "number" == typeof e ? 0 | e : 0 | t) : t ? (I(r, t), S(a, t)) : A(a, 1, 1), r.genMipmaps && (a.mipmask = (a.width << 1) - 1), i.mipmask = a.mipmask, c(i, a), i.internalformat = a.internalformat, n.width = a.width, n.height = a.height, D(i), E(a, 3553), O(r, 3553), R(), C(a), o.profile && (i.stats.size = T(i.internalformat, i.type, a.width, a.height, r.genMipmaps, !1)), n.format = tt[i.internalformat], n.type = et[i.type], n.mag = rt[r.magFilter], n.min = nt[r.minFilter], n.wrapS = it[r.wrapS], n.wrapT = it[r.wrapT], n;
              }

              var i = new z(3553);
              return yt[i.id] = i, a.textureCount++, n(e, r), n.subimage = function (t, e, r, a) {
                e |= 0, r |= 0, a |= 0;
                var o = v();
                return c(o, i), o.width = 0, o.height = 0, p(o, t), o.width = o.width || (i.width >> a) - e, o.height = o.height || (i.height >> a) - r, D(i), d(o, 3553, e, r, a), R(), k(o), n;
              }, n.resize = function (e, r) {
                var a = 0 | e,
                    s = 0 | r || a;
                if (a === i.width && s === i.height) return n;
                n.width = i.width = a, n.height = i.height = s, D(i);

                for (var l = 0; i.mipmask >> l; ++l) {
                  var c = a >> l,
                      u = s >> l;
                  if (!c || !u) break;
                  t.texImage2D(3553, l, i.format, c, u, 0, i.format, i.type, null);
                }

                return R(), o.profile && (i.stats.size = T(i.internalformat, i.type, a, s, !1, !1)), n;
              }, n._reglType = "texture2d", n._texture = i, o.profile && (n.stats = i.stats), n.destroy = function () {
                i.decRef();
              }, n;
            },
            createCube: function createCube(e, r, n, i, s, l) {
              function f(t, e, r, n, i, a) {
                var s,
                    l = h.texInfo;

                for (P.call(l), s = 0; 6 > s; ++s) {
                  m[s] = L();
                }

                if ("number" != typeof t && t) {
                  if ("object" == _typeof(t)) if (e) S(m[0], t), S(m[1], e), S(m[2], r), S(m[3], n), S(m[4], i), S(m[5], a);else if (I(l, t), u(h, t), "faces" in t) for (t = t.faces, s = 0; 6 > s; ++s) {
                    c(m[s], h), S(m[s], t[s]);
                  } else for (s = 0; 6 > s; ++s) {
                    S(m[s], t);
                  }
                } else for (t = 0 | t || 1, s = 0; 6 > s; ++s) {
                  A(m[s], t, t);
                }

                for (c(h, m[0]), h.mipmask = l.genMipmaps ? (m[0].width << 1) - 1 : m[0].mipmask, h.internalformat = m[0].internalformat, f.width = m[0].width, f.height = m[0].height, D(h), s = 0; 6 > s; ++s) {
                  E(m[s], 34069 + s);
                }

                for (O(l, 34067), R(), o.profile && (h.stats.size = T(h.internalformat, h.type, f.width, f.height, l.genMipmaps, !0)), f.format = tt[h.internalformat], f.type = et[h.type], f.mag = rt[l.magFilter], f.min = nt[l.minFilter], f.wrapS = it[l.wrapS], f.wrapT = it[l.wrapT], s = 0; 6 > s; ++s) {
                  C(m[s]);
                }

                return f;
              }

              var h = new z(34067);
              yt[h.id] = h, a.cubeCount++;
              var m = Array(6);
              return f(e, r, n, i, s, l), f.subimage = function (t, e, r, n, i) {
                r |= 0, n |= 0, i |= 0;
                var a = v();
                return c(a, h), a.width = 0, a.height = 0, p(a, e), a.width = a.width || (h.width >> i) - r, a.height = a.height || (h.height >> i) - n, D(h), d(a, 34069 + t, r, n, i), R(), k(a), f;
              }, f.resize = function (e) {
                if ((e |= 0) !== h.width) {
                  f.width = h.width = e, f.height = h.height = e, D(h);

                  for (var r = 0; 6 > r; ++r) {
                    for (var n = 0; h.mipmask >> n; ++n) {
                      t.texImage2D(34069 + r, n, h.format, e >> n, e >> n, 0, h.format, h.type, null);
                    }
                  }

                  return R(), o.profile && (h.stats.size = T(h.internalformat, h.type, f.width, f.height, !1, !0)), f;
                }
              }, f._reglType = "textureCube", f._texture = h, o.profile && (f.stats = h.stats), f.destroy = function () {
                h.decRef();
              }, f;
            },
            clear: function clear() {
              for (var e = 0; e < xt; ++e) {
                t.activeTexture(33984 + e), t.bindTexture(3553, null), bt[e] = null;
              }

              Z(yt).forEach(F), a.cubeCount = 0, a.textureCount = 0;
            },
            getTexture: function getTexture(t) {
              return null;
            },
            restore: function restore() {
              for (var e = 0; e < xt; ++e) {
                var r = bt[e];
                r && (r.bindCount = 0, r.unit = -1, bt[e] = null);
              }

              Z(yt).forEach(function (e) {
                e.texture = t.createTexture(), t.bindTexture(e.target, e.texture);

                for (var r = 0; 32 > r; ++r) {
                  if (0 != (e.mipmask & 1 << r)) if (3553 === e.target) t.texImage2D(3553, r, e.internalformat, e.width >> r, e.height >> r, 0, e.internalformat, e.type, null);else for (var n = 0; 6 > n; ++n) {
                    t.texImage2D(34069 + n, r, e.internalformat, e.width >> r, e.height >> r, 0, e.internalformat, e.type, null);
                  }
                }

                O(e.texInfo, e.target);
              });
            }
          };
        }

        function M(t, e, r, n, i, a) {
          function o(t, e, r) {
            this.target = t, this.texture = e, this.renderbuffer = r;
            var n = t = 0;
            e ? (t = e.width, n = e.height) : r && (t = r.width, n = r.height), this.width = t, this.height = n;
          }

          function s(t) {
            t && (t.texture && t.texture._texture.decRef(), t.renderbuffer && t.renderbuffer._renderbuffer.decRef());
          }

          function l(t, e, r) {
            t && (t.texture ? t.texture._texture.refCount += 1 : t.renderbuffer._renderbuffer.refCount += 1);
          }

          function c(e, r) {
            r && (r.texture ? t.framebufferTexture2D(36160, e, r.target, r.texture._texture.texture, 0) : t.framebufferRenderbuffer(36160, e, 36161, r.renderbuffer._renderbuffer.renderbuffer));
          }

          function u(t) {
            var e = 3553,
                r = null,
                n = null,
                i = t;
            return "object" == _typeof(t) && (i = t.data, "target" in t && (e = 0 | t.target)), "texture2d" === (t = i._reglType) || "textureCube" === t ? r = i : "renderbuffer" === t && (n = i, e = 36161), new o(e, r, n);
          }

          function f(t, e, r, a, s) {
            return r ? ((t = n.create2D({
              width: t,
              height: e,
              format: a,
              type: s
            }))._texture.refCount = 0, new o(3553, t, null)) : ((t = i.create({
              width: t,
              height: e,
              format: a
            }))._renderbuffer.refCount = 0, new o(36161, null, t));
          }

          function h(t) {
            return t && (t.texture || t.renderbuffer);
          }

          function p(t, e, r) {
            t && (t.texture ? t.texture.resize(e, r) : t.renderbuffer && t.renderbuffer.resize(e, r), t.width = e, t.height = r);
          }

          function d() {
            this.id = T++, k[this.id] = this, this.framebuffer = t.createFramebuffer(), this.height = this.width = 0, this.colorAttachments = [], this.depthStencilAttachment = this.stencilAttachment = this.depthAttachment = null;
          }

          function m(t) {
            t.colorAttachments.forEach(s), s(t.depthAttachment), s(t.stencilAttachment), s(t.depthStencilAttachment);
          }

          function g(e) {
            t.deleteFramebuffer(e.framebuffer), e.framebuffer = null, a.framebufferCount--, delete k[e.id];
          }

          function v(e) {
            var n;
            t.bindFramebuffer(36160, e.framebuffer);
            var i = e.colorAttachments;

            for (n = 0; n < i.length; ++n) {
              c(36064 + n, i[n]);
            }

            for (n = i.length; n < r.maxColorAttachments; ++n) {
              t.framebufferTexture2D(36160, 36064 + n, 3553, null, 0);
            }

            t.framebufferTexture2D(36160, 33306, 3553, null, 0), t.framebufferTexture2D(36160, 36096, 3553, null, 0), t.framebufferTexture2D(36160, 36128, 3553, null, 0), c(36096, e.depthAttachment), c(36128, e.stencilAttachment), c(33306, e.depthStencilAttachment), t.checkFramebufferStatus(36160), t.isContextLost(), t.bindFramebuffer(36160, x.next ? x.next.framebuffer : null), x.cur = x.next, t.getError();
          }

          function y(t, e) {
            function r(t, e) {
              var i,
                  a = 0,
                  o = 0,
                  s = !0,
                  c = !0;
              i = null;
              var p = !0,
                  d = "rgba",
                  g = "uint8",
                  y = 1,
                  x = null,
                  w = null,
                  T = null,
                  k = !1;
              "number" == typeof t ? (a = 0 | t, o = 0 | e || a) : t ? ("shape" in t ? (a = (o = t.shape)[0], o = o[1]) : ("radius" in t && (a = o = t.radius), "width" in t && (a = t.width), "height" in t && (o = t.height)), ("color" in t || "colors" in t) && (i = t.color || t.colors, Array.isArray(i)), i || ("colorCount" in t && (y = 0 | t.colorCount), "colorTexture" in t && (p = !!t.colorTexture, d = "rgba4"), "colorType" in t && (g = t.colorType, !p) && ("half float" === g || "float16" === g ? d = "rgba16f" : "float" !== g && "float32" !== g || (d = "rgba32f")), "colorFormat" in t && (d = t.colorFormat, 0 <= b.indexOf(d) ? p = !0 : 0 <= _.indexOf(d) && (p = !1))), ("depthTexture" in t || "depthStencilTexture" in t) && (k = !(!t.depthTexture && !t.depthStencilTexture)), "depth" in t && ("boolean" == typeof t.depth ? s = t.depth : (x = t.depth, c = !1)), "stencil" in t && ("boolean" == typeof t.stencil ? c = t.stencil : (w = t.stencil, s = !1)), "depthStencil" in t && ("boolean" == typeof t.depthStencil ? s = c = t.depthStencil : (T = t.depthStencil, c = s = !1))) : a = o = 1;
              var M = null,
                  A = null,
                  S = null,
                  E = null;
              if (Array.isArray(i)) M = i.map(u);else if (i) M = [u(i)];else for (M = Array(y), i = 0; i < y; ++i) {
                M[i] = f(a, o, p, d, g);
              }

              for (a = a || M[0].width, o = o || M[0].height, x ? A = u(x) : s && !c && (A = f(a, o, k, "depth", "uint32")), w ? S = u(w) : c && !s && (S = f(a, o, !1, "stencil", "uint8")), T ? E = u(T) : !x && !w && c && s && (E = f(a, o, k, "depth stencil", "depth stencil")), s = null, i = 0; i < M.length; ++i) {
                l(M[i]), M[i] && M[i].texture && (c = bt[M[i].texture._texture.format] * _t[M[i].texture._texture.type], null === s && (s = c));
              }

              return l(A), l(S), l(E), m(n), n.width = a, n.height = o, n.colorAttachments = M, n.depthAttachment = A, n.stencilAttachment = S, n.depthStencilAttachment = E, r.color = M.map(h), r.depth = h(A), r.stencil = h(S), r.depthStencil = h(E), r.width = n.width, r.height = n.height, v(n), r;
            }

            var n = new d();
            return a.framebufferCount++, r(t, e), U(r, {
              resize: function resize(t, e) {
                var i = Math.max(0 | t, 1),
                    a = Math.max(0 | e || i, 1);
                if (i === n.width && a === n.height) return r;

                for (var o = n.colorAttachments, s = 0; s < o.length; ++s) {
                  p(o[s], i, a);
                }

                return p(n.depthAttachment, i, a), p(n.stencilAttachment, i, a), p(n.depthStencilAttachment, i, a), n.width = r.width = i, n.height = r.height = a, v(n), r;
              },
              _reglType: "framebuffer",
              _framebuffer: n,
              destroy: function destroy() {
                g(n), m(n);
              },
              use: function use(t) {
                x.setFBO({
                  framebuffer: r
                }, t);
              }
            });
          }

          var x = {
            cur: null,
            next: null,
            dirty: !1,
            setFBO: null
          },
              b = ["rgba"],
              _ = ["rgba4", "rgb565", "rgb5 a1"];
          e.ext_srgb && _.push("srgba"), e.ext_color_buffer_half_float && _.push("rgba16f", "rgb16f"), e.webgl_color_buffer_float && _.push("rgba32f");
          var w = ["uint8"];
          e.oes_texture_half_float && w.push("half float", "float16"), e.oes_texture_float && w.push("float", "float32");
          var T = 0,
              k = {};
          return U(x, {
            getFramebuffer: function getFramebuffer(t) {
              return "function" == typeof t && "framebuffer" === t._reglType && (t = t._framebuffer) instanceof d ? t : null;
            },
            create: y,
            createCube: function createCube(t) {
              function e(t) {
                var i,
                    a = {
                  color: null
                },
                    o = 0,
                    s = null;
                i = "rgba";
                var l = "uint8",
                    c = 1;
                if ("number" == typeof t ? o = 0 | t : t ? ("shape" in t ? o = t.shape[0] : ("radius" in t && (o = 0 | t.radius), "width" in t ? o = 0 | t.width : "height" in t && (o = 0 | t.height)), ("color" in t || "colors" in t) && (s = t.color || t.colors, Array.isArray(s)), s || ("colorCount" in t && (c = 0 | t.colorCount), "colorType" in t && (l = t.colorType), "colorFormat" in t && (i = t.colorFormat)), "depth" in t && (a.depth = t.depth), "stencil" in t && (a.stencil = t.stencil), "depthStencil" in t && (a.depthStencil = t.depthStencil)) : o = 1, s) {
                  if (Array.isArray(s)) for (t = [], i = 0; i < s.length; ++i) {
                    t[i] = s[i];
                  } else t = [s];
                } else for (t = Array(c), s = {
                  radius: o,
                  format: i,
                  type: l
                }, i = 0; i < c; ++i) {
                  t[i] = n.createCube(s);
                }

                for (a.color = Array(t.length), i = 0; i < t.length; ++i) {
                  c = t[i], o = o || c.width, a.color[i] = {
                    target: 34069,
                    data: t[i]
                  };
                }

                for (i = 0; 6 > i; ++i) {
                  for (c = 0; c < t.length; ++c) {
                    a.color[c].target = 34069 + i;
                  }

                  0 < i && (a.depth = r[0].depth, a.stencil = r[0].stencil, a.depthStencil = r[0].depthStencil), r[i] ? r[i](a) : r[i] = y(a);
                }

                return U(e, {
                  width: o,
                  height: o,
                  color: t
                });
              }

              var r = Array(6);
              return e(t), U(e, {
                faces: r,
                resize: function resize(t) {
                  var n = 0 | t;
                  if (n === e.width) return e;
                  var i = e.color;

                  for (t = 0; t < i.length; ++t) {
                    i[t].resize(n);
                  }

                  for (t = 0; 6 > t; ++t) {
                    r[t].resize(n);
                  }

                  return e.width = e.height = n, e;
                },
                _reglType: "framebufferCube",
                destroy: function destroy() {
                  r.forEach(function (t) {
                    t.destroy();
                  });
                }
              });
            },
            clear: function clear() {
              Z(k).forEach(g);
            },
            restore: function restore() {
              x.cur = null, x.next = null, x.dirty = !0, Z(k).forEach(function (e) {
                e.framebuffer = t.createFramebuffer(), v(e);
              });
            }
          });
        }

        function A() {
          this.w = this.z = this.y = this.x = this.state = 0, this.buffer = null, this.size = 0, this.normalized = !1, this.type = 5126, this.divisor = this.stride = this.offset = 0;
        }

        function S(t, e, r, n, i) {
          function a() {
            this.id = ++c, this.attributes = [];
            var t = e.oes_vertex_array_object;
            this.vao = t ? t.createVertexArrayOES() : null, u[this.id] = this, this.buffers = [];
          }

          var o = r.maxAttributes,
              s = Array(o);

          for (r = 0; r < o; ++r) {
            s[r] = new A();
          }

          var c = 0,
              u = {},
              f = {
            Record: A,
            scope: {},
            state: s,
            currentVAO: null,
            targetVAO: null,
            restore: e.oes_vertex_array_object ? function () {
              e.oes_vertex_array_object && Z(u).forEach(function (t) {
                t.refresh();
              });
            } : function () {},
            createVAO: function createVAO(t) {
              function e(t) {
                for (var n = 0; n < r.buffers.length; ++n) {
                  r.buffers[n].destroy();
                }

                r.buffers.length = 0, (n = r.attributes).length = t.length;

                for (var a = 0; a < t.length; ++a) {
                  var o = t[a],
                      s = n[a] = new A();
                  Array.isArray(o) || X(o) || l(o) ? (o = i.create(o, 34962, !1, !0), s.buffer = i.getBuffer(o), s.size = 0 | s.buffer.dimension, s.normalized = !1, s.type = s.buffer.dtype, s.offset = 0, s.stride = 0, s.divisor = 0, s.state = 1, r.buffers.push(o)) : i.getBuffer(o) ? (s.buffer = i.getBuffer(o), s.size = 0 | s.buffer.dimension, s.normalized = !1, s.type = s.buffer.dtype, s.offset = 0, s.stride = 0, s.divisor = 0, s.state = 1) : i.getBuffer(o.buffer) ? (s.buffer = i.getBuffer(o.buffer), s.size = 0 | (+o.size || s.buffer.dimension), s.normalized = !!o.normalized || !1, s.type = "type" in o ? Q[o.type] : s.buffer.dtype, s.offset = 0 | (o.offset || 0), s.stride = 0 | (o.stride || 0), s.divisor = 0 | (o.divisor || 0), s.state = 1) : "x" in o && (s.x = +o.x || 0, s.y = +o.y || 0, s.z = +o.z || 0, s.w = +o.w || 0, s.state = 2);
                }

                return r.refresh(), e;
              }

              var r = new a();
              return n.vaoCount += 1, e.destroy = function () {
                r.destroy();
              }, e._vao = r, e._reglType = "vao", e(t);
            },
            getVAO: function getVAO(t) {
              return "function" == typeof t && t._vao ? t._vao : null;
            },
            destroyBuffer: function destroyBuffer(e) {
              for (var r = 0; r < s.length; ++r) {
                var n = s[r];
                n.buffer === e && (t.disableVertexAttribArray(r), n.buffer = null);
              }
            },
            setVAO: e.oes_vertex_array_object ? function (t) {
              if (t !== f.currentVAO) {
                var r = e.oes_vertex_array_object;
                t ? r.bindVertexArrayOES(t.vao) : r.bindVertexArrayOES(null), f.currentVAO = t;
              }
            } : function (r) {
              if (r !== f.currentVAO) {
                if (r) r.bindAttrs();else for (var n = e.angle_instanced_arrays, i = 0; i < s.length; ++i) {
                  var a = s[i];
                  a.buffer ? (t.enableVertexAttribArray(i), t.vertexAttribPointer(i, a.size, a.type, a.normalized, a.stride, a.offfset), n && n.vertexAttribDivisorANGLE(i, a.divisor)) : (t.disableVertexAttribArray(i), t.vertexAttrib4f(i, a.x, a.y, a.z, a.w));
                }
                f.currentVAO = r;
              }
            },
            clear: e.oes_vertex_array_object ? function () {
              Z(u).forEach(function (t) {
                t.destroy();
              });
            } : function () {}
          };
          return a.prototype.bindAttrs = function () {
            for (var r = e.angle_instanced_arrays, n = this.attributes, i = 0; i < n.length; ++i) {
              var a = n[i];
              a.buffer ? (t.enableVertexAttribArray(i), t.bindBuffer(34962, a.buffer.buffer), t.vertexAttribPointer(i, a.size, a.type, a.normalized, a.stride, a.offset), r && r.vertexAttribDivisorANGLE(i, a.divisor)) : (t.disableVertexAttribArray(i), t.vertexAttrib4f(i, a.x, a.y, a.z, a.w));
            }

            for (r = n.length; r < o; ++r) {
              t.disableVertexAttribArray(r);
            }
          }, a.prototype.refresh = function () {
            var t = e.oes_vertex_array_object;
            t && (t.bindVertexArrayOES(this.vao), this.bindAttrs(), f.currentVAO = this);
          }, a.prototype.destroy = function () {
            if (this.vao) {
              var t = e.oes_vertex_array_object;
              this === f.currentVAO && (f.currentVAO = null, t.bindVertexArrayOES(null)), t.deleteVertexArrayOES(this.vao), this.vao = null;
            }

            u[this.id] && (delete u[this.id], --n.vaoCount);
          }, f;
        }

        function E(t, e, r, n) {
          function i(t, e, r, n) {
            this.name = t, this.id = e, this.location = r, this.info = n;
          }

          function a(t, e) {
            for (var r = 0; r < t.length; ++r) {
              if (t[r].id === e.id) return void (t[r].location = e.location);
            }

            t.push(e);
          }

          function o(r, n, i) {
            if (!(o = (i = 35632 === r ? c : u)[n])) {
              var a = e.str(n),
                  o = t.createShader(r);
              t.shaderSource(o, a), t.compileShader(o), i[n] = o;
            }

            return o;
          }

          function s(t, e) {
            this.id = p++, this.fragId = t, this.vertId = e, this.program = null, this.uniforms = [], this.attributes = [], n.profile && (this.stats = {
              uniformsCount: 0,
              attributesCount: 0
            });
          }

          function l(r, s, l) {
            var c;
            c = o(35632, r.fragId);
            var u = o(35633, r.vertId);
            if (s = r.program = t.createProgram(), t.attachShader(s, c), t.attachShader(s, u), l) for (c = 0; c < l.length; ++c) {
              u = l[c], t.bindAttribLocation(s, u[0], u[1]);
            }
            t.linkProgram(s), u = t.getProgramParameter(s, 35718), n.profile && (r.stats.uniformsCount = u);
            var f = r.uniforms;

            for (c = 0; c < u; ++c) {
              if (l = t.getActiveUniform(s, c)) if (1 < l.size) for (var h = 0; h < l.size; ++h) {
                var p = l.name.replace("[0]", "[" + h + "]");
                a(f, new i(p, e.id(p), t.getUniformLocation(s, p), l));
              } else a(f, new i(l.name, e.id(l.name), t.getUniformLocation(s, l.name), l));
            }

            for (u = t.getProgramParameter(s, 35721), n.profile && (r.stats.attributesCount = u), r = r.attributes, c = 0; c < u; ++c) {
              (l = t.getActiveAttrib(s, c)) && a(r, new i(l.name, e.id(l.name), t.getAttribLocation(s, l.name), l));
            }
          }

          var c = {},
              u = {},
              f = {},
              h = [],
              p = 0;
          return n.profile && (r.getMaxUniformsCount = function () {
            var t = 0;
            return h.forEach(function (e) {
              e.stats.uniformsCount > t && (t = e.stats.uniformsCount);
            }), t;
          }, r.getMaxAttributesCount = function () {
            var t = 0;
            return h.forEach(function (e) {
              e.stats.attributesCount > t && (t = e.stats.attributesCount);
            }), t;
          }), {
            clear: function clear() {
              var e = t.deleteShader.bind(t);
              Z(c).forEach(e), c = {}, Z(u).forEach(e), u = {}, h.forEach(function (e) {
                t.deleteProgram(e.program);
              }), h.length = 0, f = {}, r.shaderCount = 0;
            },
            program: function program(t, e, n, i) {
              var a = f[e];
              a || (a = f[e] = {});
              var o = a[t];
              return o && !i ? o : (e = new s(e, t), r.shaderCount++, l(e, n, i), o || (a[t] = e), h.push(e), e);
            },
            restore: function restore() {
              c = {}, u = {};

              for (var t = 0; t < h.length; ++t) {
                l(h[t], null, h[t].attributes.map(function (t) {
                  return [t.location, t.name];
                }));
              }
            },
            shader: o,
            frag: -1,
            vert: -1
          };
        }

        function L(t, e, r, n, i, a, o) {
          function s(i) {
            var a;
            a = null === e.next ? 5121 : e.next.colorAttachments[0].texture._texture.type;
            var o = 0,
                s = 0,
                l = n.framebufferWidth,
                c = n.framebufferHeight,
                u = null;
            return X(i) ? u = i : i && (o = 0 | i.x, s = 0 | i.y, l = 0 | (i.width || n.framebufferWidth - o), c = 0 | (i.height || n.framebufferHeight - s), u = i.data || null), r(), i = l * c * 4, u || (5121 === a ? u = new Uint8Array(i) : 5126 === a && (u = u || new Float32Array(i))), t.pixelStorei(3333, 4), t.readPixels(o, s, l, c, 6408, a, u), u;
          }

          return function (t) {
            return t && "framebuffer" in t ? function (t) {
              var r;
              return e.setFBO({
                framebuffer: t.framebuffer
              }, function () {
                r = s(t);
              }), r;
            }(t) : s(t);
          };
        }

        function C(t) {
          return Array.prototype.slice.call(t);
        }

        function P(t) {
          return C(t).join("");
        }

        function I() {
          function t() {
            var t = [],
                e = [];
            return U(function () {
              t.push.apply(t, C(arguments));
            }, {
              def: function def() {
                var n = "v" + r++;
                return e.push(n), 0 < arguments.length && (t.push(n, "="), t.push.apply(t, C(arguments)), t.push(";")), n;
              },
              toString: function toString() {
                return P([0 < e.length ? "var " + e.join(",") + ";" : "", P(t)]);
              }
            });
          }

          function e() {
            function e(t, e) {
              n(t, e, "=", r.def(t, e), ";");
            }

            var r = t(),
                n = t(),
                i = r.toString,
                a = n.toString;
            return U(function () {
              r.apply(r, C(arguments));
            }, {
              def: r.def,
              entry: r,
              exit: n,
              save: e,
              set: function set(t, n, i) {
                e(t, n), r(t, n, "=", i, ";");
              },
              toString: function toString() {
                return i() + a();
              }
            });
          }

          var r = 0,
              n = [],
              i = [],
              a = t(),
              o = {};
          return {
            global: a,
            link: function link(t) {
              for (var e = 0; e < i.length; ++e) {
                if (i[e] === t) return n[e];
              }

              return e = "g" + r++, n.push(e), i.push(t), e;
            },
            block: t,
            proc: function proc(t, r) {
              function n() {
                var t = "a" + i.length;
                return i.push(t), t;
              }

              var i = [];
              r = r || 0;

              for (var a = 0; a < r; ++a) {
                n();
              }

              var s = (a = e()).toString;
              return o[t] = U(a, {
                arg: n,
                toString: function toString() {
                  return P(["function(", i.join(), "){", s(), "}"]);
                }
              });
            },
            scope: e,
            cond: function cond() {
              var t = P(arguments),
                  r = e(),
                  n = e(),
                  i = r.toString,
                  a = n.toString;
              return U(r, {
                then: function then() {
                  return r.apply(r, C(arguments)), this;
                },
                else: function _else() {
                  return n.apply(n, C(arguments)), this;
                },
                toString: function toString() {
                  var e = a();
                  return e && (e = "else{" + e + "}"), P(["if(", t, "){", i(), "}", e]);
                }
              });
            },
            compile: function compile() {
              var t = ['"use strict";', a, "return {"];
              Object.keys(o).forEach(function (e) {
                t.push('"', e, '":', o[e].toString(), ",");
              }), t.push("}");
              var e = P(t).replace(/;/g, ";\n").replace(/}/g, "}\n").replace(/{/g, "{\n");
              return Function.apply(null, n.concat(e)).apply(null, i);
            }
          };
        }

        function O(t) {
          return Array.isArray(t) || X(t) || l(t);
        }

        function z(t) {
          return t.sort(function (t, e) {
            return "viewport" === t ? -1 : "viewport" === e ? 1 : t < e ? -1 : 1;
          });
        }

        function D(t, e, r, n) {
          this.thisDep = t, this.contextDep = e, this.propDep = r, this.append = n;
        }

        function R(t) {
          return t && !(t.thisDep || t.contextDep || t.propDep);
        }

        function F(t) {
          return new D(!1, !1, !1, t);
        }

        function B(t, e) {
          var r = t.type;
          return 0 === r ? new D(!0, 1 <= (r = t.data.length), 2 <= r, e) : 4 === r ? new D((r = t.data).thisDep, r.contextDep, r.propDep, e) : new D(3 === r, 2 === r, 1 === r, e);
        }

        function N(t, e, r, n, i, o, s, l, c, u, f, h, p, d, m) {
          function v(t) {
            return t.replace(".", "_");
          }

          function y(t, e, r) {
            var n = v(t);
            rt.push(t), et[n] = tt[n] = !!r, it[n] = e;
          }

          function x(t, e, r) {
            var n = v(t);
            rt.push(t), Array.isArray(r) ? (tt[n] = r.slice(), et[n] = r.slice()) : tt[n] = et[n] = r, at[n] = e;
          }

          function b() {
            var t = I(),
                r = t.link,
                n = t.global;
            t.id = lt++, t.batchId = "0";
            var i = r(ot),
                a = t.shared = {
              props: "a0"
            };
            Object.keys(ot).forEach(function (t) {
              a[t] = n.def(i, ".", t);
            });
            var o = t.next = {},
                s = t.current = {};
            Object.keys(at).forEach(function (t) {
              Array.isArray(tt[t]) && (o[t] = n.def(a.next, ".", t), s[t] = n.def(a.current, ".", t));
            });
            var l = t.constants = {};
            Object.keys(st).forEach(function (t) {
              l[t] = n.def(JSON.stringify(st[t]));
            }), t.invoke = function (e, n) {
              switch (n.type) {
                case 0:
                  var i = ["this", a.context, a.props, t.batchId];
                  return e.def(r(n.data), ".call(", i.slice(0, Math.max(n.data.length + 1, 4)), ")");

                case 1:
                  return e.def(a.props, n.data);

                case 2:
                  return e.def(a.context, n.data);

                case 3:
                  return e.def("this", n.data);

                case 4:
                  return n.data.append(t, e), n.data.ref;
              }
            }, t.attribCache = {};
            var c = {};
            return t.scopeAttrib = function (t) {
              if ((t = e.id(t)) in c) return c[t];
              var n = u.scope[t];
              return n || (n = u.scope[t] = new Z()), c[t] = r(n);
            }, t;
          }

          function _(t, e) {
            var r = t.static,
                n = t.dynamic;

            if ("framebuffer" in r) {
              var i = r.framebuffer;
              return i ? (i = l.getFramebuffer(i), F(function (t, e) {
                var r = t.link(i),
                    n = t.shared;
                return e.set(n.framebuffer, ".next", r), n = n.context, e.set(n, ".framebufferWidth", r + ".width"), e.set(n, ".framebufferHeight", r + ".height"), r;
              })) : F(function (t, e) {
                var r = t.shared;
                return e.set(r.framebuffer, ".next", "null"), r = r.context, e.set(r, ".framebufferWidth", r + ".drawingBufferWidth"), e.set(r, ".framebufferHeight", r + ".drawingBufferHeight"), "null";
              });
            }

            if ("framebuffer" in n) {
              var a = n.framebuffer;
              return B(a, function (t, e) {
                var r = t.invoke(e, a),
                    n = t.shared,
                    i = n.framebuffer;
                r = e.def(i, ".getFramebuffer(", r, ")");
                return e.set(i, ".next", r), n = n.context, e.set(n, ".framebufferWidth", r + "?" + r + ".width:" + n + ".drawingBufferWidth"), e.set(n, ".framebufferHeight", r + "?" + r + ".height:" + n + ".drawingBufferHeight"), r;
              });
            }

            return null;
          }

          function w(t, r, n) {
            function i(t) {
              if (t in a) {
                var r = e.id(a[t]);
                return (t = F(function () {
                  return r;
                })).id = r, t;
              }

              if (t in o) {
                var n = o[t];
                return B(n, function (t, e) {
                  var r = t.invoke(e, n);
                  return e.def(t.shared.strings, ".id(", r, ")");
                });
              }

              return null;
            }

            var a = t.static,
                o = t.dynamic,
                s = i("frag"),
                l = i("vert"),
                c = null;
            return R(s) && R(l) ? (c = f.program(l.id, s.id, null, n), t = F(function (t, e) {
              return t.link(c);
            })) : t = new D(s && s.thisDep || l && l.thisDep, s && s.contextDep || l && l.contextDep, s && s.propDep || l && l.propDep, function (t, e) {
              var r,
                  n,
                  i = t.shared.shader;
              return r = s ? s.append(t, e) : e.def(i, ".", "frag"), n = l ? l.append(t, e) : e.def(i, ".", "vert"), e.def(i + ".program(" + n + "," + r + ")");
            }), {
              frag: s,
              vert: l,
              progVar: t,
              program: c
            };
          }

          function T(t, e) {
            function r(t, e) {
              if (t in n) {
                var r = 0 | n[t];
                return F(function (t, n) {
                  return e && (t.OFFSET = r), r;
                });
              }

              if (t in i) {
                var o = i[t];
                return B(o, function (t, r) {
                  var n = t.invoke(r, o);
                  return e && (t.OFFSET = n), n;
                });
              }

              return e && a ? F(function (t, e) {
                return t.OFFSET = "0", 0;
              }) : null;
            }

            var n = t.static,
                i = t.dynamic,
                a = function () {
              if ("elements" in n) {
                var t = n.elements;
                O(t) ? t = o.getElements(o.create(t, !0)) : t && (t = o.getElements(t));
                var e = F(function (e, r) {
                  if (t) {
                    var n = e.link(t);
                    return e.ELEMENTS = n;
                  }

                  return e.ELEMENTS = null;
                });
                return e.value = t, e;
              }

              if ("elements" in i) {
                var r = i.elements;
                return B(r, function (t, e) {
                  var n = (i = t.shared).isBufferArgs,
                      i = i.elements,
                      a = t.invoke(e, r),
                      o = e.def("null");
                  n = e.def(n, "(", a, ")"), a = t.cond(n).then(o, "=", i, ".createStream(", a, ");").else(o, "=", i, ".getElements(", a, ");");
                  return e.entry(a), e.exit(t.cond(n).then(i, ".destroyStream(", o, ");")), t.ELEMENTS = o;
                });
              }

              return null;
            }(),
                s = r("offset", !0);

            return {
              elements: a,
              primitive: function () {
                if ("primitive" in n) {
                  var t = n.primitive;
                  return F(function (e, r) {
                    return nt[t];
                  });
                }

                if ("primitive" in i) {
                  var e = i.primitive;
                  return B(e, function (t, r) {
                    var n = t.constants.primTypes,
                        i = t.invoke(r, e);
                    return r.def(n, "[", i, "]");
                  });
                }

                return a ? R(a) ? a.value ? F(function (t, e) {
                  return e.def(t.ELEMENTS, ".primType");
                }) : F(function () {
                  return 4;
                }) : new D(a.thisDep, a.contextDep, a.propDep, function (t, e) {
                  var r = t.ELEMENTS;
                  return e.def(r, "?", r, ".primType:", 4);
                }) : null;
              }(),
              count: function () {
                if ("count" in n) {
                  var t = 0 | n.count;
                  return F(function () {
                    return t;
                  });
                }

                if ("count" in i) {
                  var e = i.count;
                  return B(e, function (t, r) {
                    return t.invoke(r, e);
                  });
                }

                return a ? R(a) ? a ? s ? new D(s.thisDep, s.contextDep, s.propDep, function (t, e) {
                  return e.def(t.ELEMENTS, ".vertCount-", t.OFFSET);
                }) : F(function (t, e) {
                  return e.def(t.ELEMENTS, ".vertCount");
                }) : F(function () {
                  return -1;
                }) : new D(a.thisDep || s.thisDep, a.contextDep || s.contextDep, a.propDep || s.propDep, function (t, e) {
                  var r = t.ELEMENTS;
                  return t.OFFSET ? e.def(r, "?", r, ".vertCount-", t.OFFSET, ":-1") : e.def(r, "?", r, ".vertCount:-1");
                }) : null;
              }(),
              instances: r("instances", !1),
              offset: s
            };
          }

          function k(t, r) {
            var n = t.static,
                a = t.dynamic,
                o = {};
            return Object.keys(n).forEach(function (t) {
              var r = n[t],
                  a = e.id(t),
                  s = new Z();
              if (O(r)) s.state = 1, s.buffer = i.getBuffer(i.create(r, 34962, !1, !0)), s.type = 0;else if (c = i.getBuffer(r)) s.state = 1, s.buffer = c, s.type = 0;else if ("constant" in r) {
                var l = r.constant;
                s.buffer = "null", s.state = 2, "number" == typeof l ? s.x = l : wt.forEach(function (t, e) {
                  e < l.length && (s[t] = l[e]);
                });
              } else {
                var c = O(r.buffer) ? i.getBuffer(i.create(r.buffer, 34962, !1, !0)) : i.getBuffer(r.buffer),
                    u = 0 | r.offset,
                    f = 0 | r.stride,
                    h = 0 | r.size,
                    p = !!r.normalized,
                    d = 0;
                "type" in r && (d = Q[r.type]), r = 0 | r.divisor, s.buffer = c, s.state = 1, s.size = h, s.normalized = p, s.type = d || c.dtype, s.offset = u, s.stride = f, s.divisor = r;
              }
              o[t] = F(function (t, e) {
                var r = t.attribCache;
                if (a in r) return r[a];
                var n = {
                  isStream: !1
                };
                return Object.keys(s).forEach(function (t) {
                  n[t] = s[t];
                }), s.buffer && (n.buffer = t.link(s.buffer), n.type = n.type || n.buffer + ".dtype"), r[a] = n;
              });
            }), Object.keys(a).forEach(function (t) {
              var e = a[t];
              o[t] = B(e, function (t, r) {
                function n(t) {
                  r(l[t], "=", i, ".", t, "|0;");
                }

                var i = t.invoke(r, e),
                    a = t.shared,
                    o = t.constants,
                    s = a.isBufferArgs,
                    l = (a = a.buffer, {
                  isStream: r.def(!1)
                }),
                    c = new Z();
                c.state = 1, Object.keys(c).forEach(function (t) {
                  l[t] = r.def("" + c[t]);
                });
                var u = l.buffer,
                    f = l.type;
                return r("if(", s, "(", i, ")){", l.isStream, "=true;", u, "=", a, ".createStream(", 34962, ",", i, ");", f, "=", u, ".dtype;", "}else{", u, "=", a, ".getBuffer(", i, ");", "if(", u, "){", f, "=", u, ".dtype;", '}else if("constant" in ', i, "){", l.state, "=", 2, ";", "if(typeof " + i + '.constant === "number"){', l[wt[0]], "=", i, ".constant;", wt.slice(1).map(function (t) {
                  return l[t];
                }).join("="), "=0;", "}else{", wt.map(function (t, e) {
                  return l[t] + "=" + i + ".constant.length>" + e + "?" + i + ".constant[" + e + "]:0;";
                }).join(""), "}}else{", "if(", s, "(", i, ".buffer)){", u, "=", a, ".createStream(", 34962, ",", i, ".buffer);", "}else{", u, "=", a, ".getBuffer(", i, ".buffer);", "}", f, '="type" in ', i, "?", o.glTypes, "[", i, ".type]:", u, ".dtype;", l.normalized, "=!!", i, ".normalized;"), n("size"), n("offset"), n("stride"), n("divisor"), r("}}"), r.exit("if(", l.isStream, "){", a, ".destroyStream(", u, ");", "}"), l;
              });
            }), o;
          }

          function M(t, e, n, i, o) {
            function s(t) {
              var e = c[t];
              e && (h[t] = e);
            }

            var l = function (t, e) {
              if ("string" == typeof (r = t.static).frag && "string" == typeof r.vert) {
                if (0 < Object.keys(e.dynamic).length) return null;
                var r = e.static,
                    n = Object.keys(r);

                if (0 < n.length && "number" == typeof r[n[0]]) {
                  for (var i = [], a = 0; a < n.length; ++a) {
                    i.push([0 | r[n[a]], n[a]]);
                  }

                  return i;
                }
              }

              return null;
            }(t, e),
                c = function (t, e, r) {
              function n(t) {
                if (t in i) {
                  var r = i[t];
                  t = !0;
                  var n,
                      o,
                      s = 0 | r.x,
                      l = 0 | r.y;
                  return "width" in r ? n = 0 | r.width : t = !1, "height" in r ? o = 0 | r.height : t = !1, new D(!t && e && e.thisDep, !t && e && e.contextDep, !t && e && e.propDep, function (t, e) {
                    var i = t.shared.context,
                        a = n;
                    "width" in r || (a = e.def(i, ".", "framebufferWidth", "-", s));
                    var c = o;
                    return "height" in r || (c = e.def(i, ".", "framebufferHeight", "-", l)), [s, l, a, c];
                  });
                }

                if (t in a) {
                  var c = a[t];
                  return t = B(c, function (t, e) {
                    var r = t.invoke(e, c),
                        n = t.shared.context,
                        i = e.def(r, ".x|0"),
                        a = e.def(r, ".y|0");
                    return [i, a, e.def('"width" in ', r, "?", r, ".width|0:", "(", n, ".", "framebufferWidth", "-", i, ")"), r = e.def('"height" in ', r, "?", r, ".height|0:", "(", n, ".", "framebufferHeight", "-", a, ")")];
                  }), e && (t.thisDep = t.thisDep || e.thisDep, t.contextDep = t.contextDep || e.contextDep, t.propDep = t.propDep || e.propDep), t;
                }

                return e ? new D(e.thisDep, e.contextDep, e.propDep, function (t, e) {
                  var r = t.shared.context;
                  return [0, 0, e.def(r, ".", "framebufferWidth"), e.def(r, ".", "framebufferHeight")];
                }) : null;
              }

              var i = t.static,
                  a = t.dynamic;

              if (t = n("viewport")) {
                var o = t;
                t = new D(t.thisDep, t.contextDep, t.propDep, function (t, e) {
                  var r = o.append(t, e),
                      n = t.shared.context;
                  return e.set(n, ".viewportWidth", r[2]), e.set(n, ".viewportHeight", r[3]), r;
                });
              }

              return {
                viewport: t,
                scissor_box: n("scissor.box")
              };
            }(t, d = _(t)),
                f = T(t),
                h = function (t, e) {
              var r = t.static,
                  n = t.dynamic,
                  i = {};
              return rt.forEach(function (t) {
                function e(e, a) {
                  if (t in r) {
                    var s = e(r[t]);
                    i[o] = F(function () {
                      return s;
                    });
                  } else if (t in n) {
                    var l = n[t];
                    i[o] = B(l, function (t, e) {
                      return a(t, e, t.invoke(e, l));
                    });
                  }
                }

                var o = v(t);

                switch (t) {
                  case "cull.enable":
                  case "blend.enable":
                  case "dither":
                  case "stencil.enable":
                  case "depth.enable":
                  case "scissor.enable":
                  case "polygonOffset.enable":
                  case "sample.alpha":
                  case "sample.enable":
                  case "depth.mask":
                    return e(function (t) {
                      return t;
                    }, function (t, e, r) {
                      return r;
                    });

                  case "depth.func":
                    return e(function (t) {
                      return Mt[t];
                    }, function (t, e, r) {
                      return e.def(t.constants.compareFuncs, "[", r, "]");
                    });

                  case "depth.range":
                    return e(function (t) {
                      return t;
                    }, function (t, e, r) {
                      return [e.def("+", r, "[0]"), e = e.def("+", r, "[1]")];
                    });

                  case "blend.func":
                    return e(function (t) {
                      return [kt["srcRGB" in t ? t.srcRGB : t.src], kt["dstRGB" in t ? t.dstRGB : t.dst], kt["srcAlpha" in t ? t.srcAlpha : t.src], kt["dstAlpha" in t ? t.dstAlpha : t.dst]];
                    }, function (t, e, r) {
                      function n(t, n) {
                        return e.def('"', t, n, '" in ', r, "?", r, ".", t, n, ":", r, ".", t);
                      }

                      t = t.constants.blendFuncs;
                      var i = n("src", "RGB"),
                          a = n("dst", "RGB"),
                          o = (i = e.def(t, "[", i, "]"), e.def(t, "[", n("src", "Alpha"), "]"));
                      return [i, a = e.def(t, "[", a, "]"), o, t = e.def(t, "[", n("dst", "Alpha"), "]")];
                    });

                  case "blend.equation":
                    return e(function (t) {
                      return "string" == typeof t ? [J[t], J[t]] : "object" == _typeof(t) ? [J[t.rgb], J[t.alpha]] : void 0;
                    }, function (t, e, r) {
                      var n = t.constants.blendEquations,
                          i = e.def(),
                          a = e.def();
                      return (t = t.cond("typeof ", r, '==="string"')).then(i, "=", a, "=", n, "[", r, "];"), t.else(i, "=", n, "[", r, ".rgb];", a, "=", n, "[", r, ".alpha];"), e(t), [i, a];
                    });

                  case "blend.color":
                    return e(function (t) {
                      return a(4, function (e) {
                        return +t[e];
                      });
                    }, function (t, e, r) {
                      return a(4, function (t) {
                        return e.def("+", r, "[", t, "]");
                      });
                    });

                  case "stencil.mask":
                    return e(function (t) {
                      return 0 | t;
                    }, function (t, e, r) {
                      return e.def(r, "|0");
                    });

                  case "stencil.func":
                    return e(function (t) {
                      return [Mt[t.cmp || "keep"], t.ref || 0, "mask" in t ? t.mask : -1];
                    }, function (t, e, r) {
                      return [t = e.def('"cmp" in ', r, "?", t.constants.compareFuncs, "[", r, ".cmp]", ":", 7680), e.def(r, ".ref|0"), e = e.def('"mask" in ', r, "?", r, ".mask|0:-1")];
                    });

                  case "stencil.opFront":
                  case "stencil.opBack":
                    return e(function (e) {
                      return ["stencil.opBack" === t ? 1029 : 1028, At[e.fail || "keep"], At[e.zfail || "keep"], At[e.zpass || "keep"]];
                    }, function (e, r, n) {
                      function i(t) {
                        return r.def('"', t, '" in ', n, "?", a, "[", n, ".", t, "]:", 7680);
                      }

                      var a = e.constants.stencilOps;
                      return ["stencil.opBack" === t ? 1029 : 1028, i("fail"), i("zfail"), i("zpass")];
                    });

                  case "polygonOffset.offset":
                    return e(function (t) {
                      return [0 | t.factor, 0 | t.units];
                    }, function (t, e, r) {
                      return [e.def(r, ".factor|0"), e = e.def(r, ".units|0")];
                    });

                  case "cull.face":
                    return e(function (t) {
                      var e = 0;
                      return "front" === t ? e = 1028 : "back" === t && (e = 1029), e;
                    }, function (t, e, r) {
                      return e.def(r, '==="front"?', 1028, ":", 1029);
                    });

                  case "lineWidth":
                    return e(function (t) {
                      return t;
                    }, function (t, e, r) {
                      return r;
                    });

                  case "frontFace":
                    return e(function (t) {
                      return St[t];
                    }, function (t, e, r) {
                      return e.def(r + '==="cw"?2304:2305');
                    });

                  case "colorMask":
                    return e(function (t) {
                      return t.map(function (t) {
                        return !!t;
                      });
                    }, function (t, e, r) {
                      return a(4, function (t) {
                        return "!!" + r + "[" + t + "]";
                      });
                    });

                  case "sample.coverage":
                    return e(function (t) {
                      return ["value" in t ? t.value : 1, !!t.invert];
                    }, function (t, e, r) {
                      return [e.def('"value" in ', r, "?+", r, ".value:1"), e = e.def("!!", r, ".invert")];
                    });
                }
              }), i;
            }(t),
                p = w(t, 0, l);

            s("viewport"), s(v("scissor.box"));
            var d,
                m = 0 < Object.keys(h).length;

            if ((d = {
              framebuffer: d,
              draw: f,
              shader: p,
              state: h,
              dirty: m,
              scopeVAO: null,
              drawVAO: null,
              useVAO: !1,
              attributes: {}
            }).profile = function (t) {
              var e,
                  r = t.static;

              if (t = t.dynamic, "profile" in r) {
                var n = !!r.profile;
                (e = F(function (t, e) {
                  return n;
                })).enable = n;
              } else if ("profile" in t) {
                var i = t.profile;
                e = B(i, function (t, e) {
                  return t.invoke(e, i);
                });
              }

              return e;
            }(t), d.uniforms = function (t, e) {
              var r = t.static,
                  n = t.dynamic,
                  i = {};
              return Object.keys(r).forEach(function (t) {
                var e,
                    n = r[t];
                if ("number" == typeof n || "boolean" == typeof n) e = F(function () {
                  return n;
                });else if ("function" == typeof n) {
                  var o = n._reglType;
                  "texture2d" === o || "textureCube" === o ? e = F(function (t) {
                    return t.link(n);
                  }) : "framebuffer" !== o && "framebufferCube" !== o || (e = F(function (t) {
                    return t.link(n.color[0]);
                  }));
                } else g(n) && (e = F(function (t) {
                  return t.global.def("[", a(n.length, function (t) {
                    return n[t];
                  }), "]");
                }));
                e.value = n, i[t] = e;
              }), Object.keys(n).forEach(function (t) {
                var e = n[t];
                i[t] = B(e, function (t, r) {
                  return t.invoke(r, e);
                });
              }), i;
            }(n), d.drawVAO = d.scopeVAO = function (t, e) {
              var r = t.static,
                  n = t.dynamic;

              if ("vao" in r) {
                var i = r.vao;
                return null !== i && null === u.getVAO(i) && (i = u.createVAO(i)), F(function (t) {
                  return t.link(u.getVAO(i));
                });
              }

              if ("vao" in n) {
                var a = n.vao;
                return B(a, function (t, e) {
                  var r = t.invoke(e, a);
                  return e.def(t.shared.vao + ".getVAO(" + r + ")");
                });
              }

              return null;
            }(t), !d.drawVAO && p.program && !l && r.angle_instanced_arrays) {
              var y = !0;

              if (t = p.program.attributes.map(function (t) {
                return t = e.static[t], y = y && !!t, t;
              }), y && 0 < t.length) {
                var x = u.getVAO(u.createVAO(t));
                d.drawVAO = new D(null, null, null, function (t, e) {
                  return t.link(x);
                }), d.useVAO = !0;
              }
            }

            return l ? d.useVAO = !0 : d.attributes = k(e), d.context = function (t) {
              var e = t.static,
                  r = t.dynamic,
                  n = {};
              return Object.keys(e).forEach(function (t) {
                var r = e[t];
                n[t] = F(function (t, e) {
                  return "number" == typeof r || "boolean" == typeof r ? "" + r : t.link(r);
                });
              }), Object.keys(r).forEach(function (t) {
                var e = r[t];
                n[t] = B(e, function (t, r) {
                  return t.invoke(r, e);
                });
              }), n;
            }(i), d;
          }

          function A(t, e, r) {
            var n = t.shared.context,
                i = t.scope();
            Object.keys(r).forEach(function (a) {
              e.save(n, "." + a), i(n, ".", a, "=", r[a].append(t, e), ";");
            }), e(i);
          }

          function S(t, e, r, n) {
            var i,
                a = (s = t.shared).gl,
                o = s.framebuffer;
            $ && (i = e.def(s.extensions, ".webgl_draw_buffers"));
            var s = (l = t.constants).drawBuffer,
                l = l.backBuffer;
            t = r ? r.append(t, e) : e.def(o, ".next"), n || e("if(", t, "!==", o, ".cur){"), e("if(", t, "){", a, ".bindFramebuffer(", 36160, ",", t, ".framebuffer);"), $ && e(i, ".drawBuffersWEBGL(", s, "[", t, ".colorAttachments.length]);"), e("}else{", a, ".bindFramebuffer(", 36160, ",null);"), $ && e(i, ".drawBuffersWEBGL(", l, ");"), e("}", o, ".cur=", t, ";"), n || e("}");
          }

          function E(t, e, r) {
            var n = t.shared,
                i = n.gl,
                o = t.current,
                s = t.next,
                l = n.current,
                c = n.next,
                u = t.cond(l, ".dirty");
            rt.forEach(function (e) {
              var n, f;
              if (!((e = v(e)) in r.state)) if (e in s) {
                n = s[e], f = o[e];
                var h = a(tt[e].length, function (t) {
                  return u.def(n, "[", t, "]");
                });
                u(t.cond(h.map(function (t, e) {
                  return t + "!==" + f + "[" + e + "]";
                }).join("||")).then(i, ".", at[e], "(", h, ");", h.map(function (t, e) {
                  return f + "[" + e + "]=" + t;
                }).join(";"), ";"));
              } else n = u.def(c, ".", e), h = t.cond(n, "!==", l, ".", e), u(h), e in it ? h(t.cond(n).then(i, ".enable(", it[e], ");").else(i, ".disable(", it[e], ");"), l, ".", e, "=", n, ";") : h(i, ".", at[e], "(", n, ");", l, ".", e, "=", n, ";");
            }), 0 === Object.keys(r.state).length && u(l, ".dirty=false;"), e(u);
          }

          function L(t, e, r, n) {
            var i = t.shared,
                a = t.current,
                o = i.current,
                s = i.gl;
            z(Object.keys(r)).forEach(function (i) {
              var l = r[i];

              if (!n || n(l)) {
                var c = l.append(t, e);

                if (it[i]) {
                  var u = it[i];
                  R(l) ? e(s, c ? ".enable(" : ".disable(", u, ");") : e(t.cond(c).then(s, ".enable(", u, ");").else(s, ".disable(", u, ");")), e(o, ".", i, "=", c, ";");
                } else if (g(c)) {
                  var f = a[i];
                  e(s, ".", at[i], "(", c, ");", c.map(function (t, e) {
                    return f + "[" + e + "]=" + t;
                  }).join(";"), ";");
                } else e(s, ".", at[i], "(", c, ");", o, ".", i, "=", c, ";");
              }
            });
          }

          function C(t, e) {
            K && (t.instancing = e.def(t.shared.extensions, ".angle_instanced_arrays"));
          }

          function P(t, e, r, n, i) {
            function a() {
              return "undefined" == typeof performance ? "Date.now()" : "performance.now()";
            }

            function o(t) {
              t(c = e.def(), "=", a(), ";"), "string" == typeof i ? t(h, ".count+=", i, ";") : t(h, ".count++;"), d && (n ? t(u = e.def(), "=", m, ".getNumPendingQueries();") : t(m, ".beginQuery(", h, ");"));
            }

            function s(t) {
              t(h, ".cpuTime+=", a(), "-", c, ";"), d && (n ? t(m, ".pushScopeStats(", u, ",", m, ".getNumPendingQueries(),", h, ");") : t(m, ".endQuery();"));
            }

            function l(t) {
              var r = e.def(p, ".profile");
              e(p, ".profile=", t, ";"), e.exit(p, ".profile=", r, ";");
            }

            var c,
                u,
                f = t.shared,
                h = t.stats,
                p = f.current,
                m = f.timer;

            if (r = r.profile) {
              if (R(r)) return void (r.enable ? (o(e), s(e.exit), l("true")) : l("false"));
              l(r = r.append(t, e));
            } else r = e.def(p, ".profile");

            o(f = t.block()), e("if(", r, "){", f, "}"), s(t = t.block()), e.exit("if(", r, "){", t, "}");
          }

          function N(t, e, r, n, i) {
            function a(r, n, i) {
              function a() {
                e("if(!", u, ".buffer){", l, ".enableVertexAttribArray(", c, ");}");
                var r,
                    a = i.type;
                r = i.size ? e.def(i.size, "||", n) : n, e("if(", u, ".type!==", a, "||", u, ".size!==", r, "||", p.map(function (t) {
                  return u + "." + t + "!==" + i[t];
                }).join("||"), "){", l, ".bindBuffer(", 34962, ",", f, ".buffer);", l, ".vertexAttribPointer(", [c, r, a, i.normalized, i.stride, i.offset], ");", u, ".type=", a, ";", u, ".size=", r, ";", p.map(function (t) {
                  return u + "." + t + "=" + i[t] + ";";
                }).join(""), "}"), K && (a = i.divisor, e("if(", u, ".divisor!==", a, "){", t.instancing, ".vertexAttribDivisorANGLE(", [c, a], ");", u, ".divisor=", a, ";}"));
              }

              function s() {
                e("if(", u, ".buffer){", l, ".disableVertexAttribArray(", c, ");", u, ".buffer=null;", "}if(", wt.map(function (t, e) {
                  return u + "." + t + "!==" + h[e];
                }).join("||"), "){", l, ".vertexAttrib4f(", c, ",", h, ");", wt.map(function (t, e) {
                  return u + "." + t + "=" + h[e] + ";";
                }).join(""), "}");
              }

              var l = o.gl,
                  c = e.def(r, ".location"),
                  u = e.def(o.attributes, "[", c, "]");
              r = i.state;
              var f = i.buffer,
                  h = [i.x, i.y, i.z, i.w],
                  p = ["buffer", "normalized", "offset", "stride"];
              1 === r ? a() : 2 === r ? s() : (e("if(", r, "===", 1, "){"), a(), e("}else{"), s(), e("}"));
            }

            var o = t.shared;
            n.forEach(function (n) {
              var o,
                  s = n.name,
                  l = r.attributes[s];

              if (l) {
                if (!i(l)) return;
                o = l.append(t, e);
              } else {
                if (!i(Et)) return;
                var c = t.scopeAttrib(s);
                o = {}, Object.keys(new Z()).forEach(function (t) {
                  o[t] = e.def(c, ".", t);
                });
              }

              a(t.link(n), function (t) {
                switch (t) {
                  case 35664:
                  case 35667:
                  case 35671:
                    return 2;

                  case 35665:
                  case 35668:
                  case 35672:
                    return 3;

                  case 35666:
                  case 35669:
                  case 35673:
                    return 4;

                  default:
                    return 1;
                }
              }(n.info.type), o);
            });
          }

          function j(t, r, n, i, o) {
            for (var s, l = t.shared, c = l.gl, u = 0; u < i.length; ++u) {
              var f,
                  h = (m = i[u]).name,
                  p = m.info.type,
                  d = n.uniforms[h],
                  m = t.link(m) + ".location";

              if (d) {
                if (!o(d)) continue;

                if (R(d)) {
                  if (h = d.value, 35678 === p || 35680 === p) r(c, ".uniform1i(", m, ",", (p = t.link(h._texture || h.color[0]._texture)) + ".bind());"), r.exit(p, ".unbind();");else if (35674 === p || 35675 === p || 35676 === p) d = 2, 35675 === p ? d = 3 : 35676 === p && (d = 4), r(c, ".uniformMatrix", d, "fv(", m, ",false,", h = t.global.def("new Float32Array([" + Array.prototype.slice.call(h) + "])"), ");");else {
                    switch (p) {
                      case 5126:
                        s = "1f";
                        break;

                      case 35664:
                        s = "2f";
                        break;

                      case 35665:
                        s = "3f";
                        break;

                      case 35666:
                        s = "4f";
                        break;

                      case 35670:
                      case 5124:
                        s = "1i";
                        break;

                      case 35671:
                      case 35667:
                        s = "2i";
                        break;

                      case 35672:
                      case 35668:
                        s = "3i";
                        break;

                      case 35673:
                        s = "4i";
                        break;

                      case 35669:
                        s = "4i";
                    }

                    r(c, ".uniform", s, "(", m, ",", g(h) ? Array.prototype.slice.call(h) : h, ");");
                  }
                  continue;
                }

                f = d.append(t, r);
              } else {
                if (!o(Et)) continue;
                f = r.def(l.uniforms, "[", e.id(h), "]");
              }

              switch (35678 === p ? r("if(", f, "&&", f, '._reglType==="framebuffer"){', f, "=", f, ".color[0];", "}") : 35680 === p && r("if(", f, "&&", f, '._reglType==="framebufferCube"){', f, "=", f, ".color[0];", "}"), h = 1, p) {
                case 35678:
                case 35680:
                  p = r.def(f, "._texture"), r(c, ".uniform1i(", m, ",", p, ".bind());"), r.exit(p, ".unbind();");
                  continue;

                case 5124:
                case 35670:
                  s = "1i";
                  break;

                case 35667:
                case 35671:
                  s = "2i", h = 2;
                  break;

                case 35668:
                case 35672:
                  s = "3i", h = 3;
                  break;

                case 35669:
                case 35673:
                  s = "4i", h = 4;
                  break;

                case 5126:
                  s = "1f";
                  break;

                case 35664:
                  s = "2f", h = 2;
                  break;

                case 35665:
                  s = "3f", h = 3;
                  break;

                case 35666:
                  s = "4f", h = 4;
                  break;

                case 35674:
                  s = "Matrix2fv";
                  break;

                case 35675:
                  s = "Matrix3fv";
                  break;

                case 35676:
                  s = "Matrix4fv";
              }

              if (r(c, ".uniform", s, "(", m, ","), "M" === s.charAt(0)) {
                m = Math.pow(p - 35674 + 2, 2);
                var v = t.global.def("new Float32Array(", m, ")");
                r("false,(Array.isArray(", f, ")||", f, " instanceof Float32Array)?", f, ":(", a(m, function (t) {
                  return v + "[" + t + "]=" + f + "[" + t + "]";
                }), ",", v, ")");
              } else r(1 < h ? a(h, function (t) {
                return f + "[" + t + "]";
              }) : f);

              r(");");
            }
          }

          function U(t, e, r, n) {
            function i(i) {
              var a = h[i];
              return a ? a.contextDep && n.contextDynamic || a.propDep ? a.append(t, r) : a.append(t, e) : e.def(f, ".", i);
            }

            function a() {
              function t() {
                r(l, ".drawElementsInstancedANGLE(", [d, g, v, m + "<<((" + v + "-5121)>>1)", s], ");");
              }

              function e() {
                r(l, ".drawArraysInstancedANGLE(", [d, m, g, s], ");");
              }

              p ? y ? t() : (r("if(", p, "){"), t(), r("}else{"), e(), r("}")) : e();
            }

            function o() {
              function t() {
                r(u + ".drawElements(" + [d, g, v, m + "<<((" + v + "-5121)>>1)"] + ");");
              }

              function e() {
                r(u + ".drawArrays(" + [d, m, g] + ");");
              }

              p ? y ? t() : (r("if(", p, "){"), t(), r("}else{"), e(), r("}")) : e();
            }

            var s,
                l,
                c = t.shared,
                u = c.gl,
                f = c.draw,
                h = n.draw,
                p = function () {
              var i = h.elements,
                  a = e;
              return i ? ((i.contextDep && n.contextDynamic || i.propDep) && (a = r), i = i.append(t, a)) : i = a.def(f, ".", "elements"), i && a("if(" + i + ")" + u + ".bindBuffer(34963," + i + ".buffer.buffer);"), i;
            }(),
                d = i("primitive"),
                m = i("offset"),
                g = function () {
              var i = h.count,
                  a = e;
              return i ? ((i.contextDep && n.contextDynamic || i.propDep) && (a = r), i = i.append(t, a)) : i = a.def(f, ".", "count"), i;
            }();

            if ("number" == typeof g) {
              if (0 === g) return;
            } else r("if(", g, "){"), r.exit("}");

            K && (s = i("instances"), l = t.instancing);
            var v = p + ".type",
                y = h.elements && R(h.elements);
            K && ("number" != typeof s || 0 <= s) ? "string" == typeof s ? (r("if(", s, ">0){"), a(), r("}else if(", s, "<0){"), o(), r("}")) : a() : o();
          }

          function V(t, e, r, n, i) {
            return i = (e = b()).proc("body", i), K && (e.instancing = i.def(e.shared.extensions, ".angle_instanced_arrays")), t(e, i, r, n), e.compile().body;
          }

          function H(t, e, r, n) {
            C(t, e), r.useVAO ? r.drawVAO ? e(t.shared.vao, ".setVAO(", r.drawVAO.append(t, e), ");") : e(t.shared.vao, ".setVAO(", t.shared.vao, ".targetVAO);") : (e(t.shared.vao, ".setVAO(null);"), N(t, e, r, n.attributes, function () {
              return !0;
            })), j(t, e, r, n.uniforms, function () {
              return !0;
            }), U(t, e, e, r);
          }

          function G(t, e, r, n) {
            function i() {
              return !0;
            }

            t.batchId = "a1", C(t, e), N(t, e, r, n.attributes, i), j(t, e, r, n.uniforms, i), U(t, e, e, r);
          }

          function Y(t, e, r, n) {
            function i(t) {
              return t.contextDep && o || t.propDep;
            }

            function a(t) {
              return !i(t);
            }

            C(t, e);
            var o = r.contextDep,
                s = e.def(),
                l = e.def();
            t.shared.props = l, t.batchId = s;
            var c = t.scope(),
                u = t.scope();
            e(c.entry, "for(", s, "=0;", s, "<", "a1", ";++", s, "){", l, "=", "a0", "[", s, "];", u, "}", c.exit), r.needsContext && A(t, u, r.context), r.needsFramebuffer && S(t, u, r.framebuffer), L(t, u, r.state, i), r.profile && i(r.profile) && P(t, u, r, !1, !0), n ? (r.useVAO ? r.drawVAO ? i(r.drawVAO) ? u(t.shared.vao, ".setVAO(", r.drawVAO.append(t, u), ");") : c(t.shared.vao, ".setVAO(", r.drawVAO.append(t, c), ");") : c(t.shared.vao, ".setVAO(", t.shared.vao, ".targetVAO);") : (c(t.shared.vao, ".setVAO(null);"), N(t, c, r, n.attributes, a), N(t, u, r, n.attributes, i)), j(t, c, r, n.uniforms, a), j(t, u, r, n.uniforms, i), U(t, c, u, r)) : (e = t.global.def("{}"), n = r.shader.progVar.append(t, u), l = u.def(n, ".id"), c = u.def(e, "[", l, "]"), u(t.shared.gl, ".useProgram(", n, ".program);", "if(!", c, "){", c, "=", e, "[", l, "]=", t.link(function (e) {
              return V(G, t, r, e, 2);
            }), "(", n, ");}", c, ".call(this,a0[", s, "],", s, ");"));
          }

          function W(t, r) {
            function n(e) {
              var n = r.shader[e];
              n && i.set(a.shader, "." + e, n.append(t, i));
            }

            var i = t.proc("scope", 3);
            t.batchId = "a2";
            var a = t.shared,
                o = a.current;
            A(t, i, r.context), r.framebuffer && r.framebuffer.append(t, i), z(Object.keys(r.state)).forEach(function (e) {
              var n = r.state[e].append(t, i);
              g(n) ? n.forEach(function (r, n) {
                i.set(t.next[e], "[" + n + "]", r);
              }) : i.set(a.next, "." + e, n);
            }), P(t, i, r, !0, !0), ["elements", "offset", "count", "instances", "primitive"].forEach(function (e) {
              var n = r.draw[e];
              n && i.set(a.draw, "." + e, "" + n.append(t, i));
            }), Object.keys(r.uniforms).forEach(function (n) {
              i.set(a.uniforms, "[" + e.id(n) + "]", r.uniforms[n].append(t, i));
            }), Object.keys(r.attributes).forEach(function (e) {
              var n = r.attributes[e].append(t, i),
                  a = t.scopeAttrib(e);
              Object.keys(new Z()).forEach(function (t) {
                i.set(a, "." + t, n[t]);
              });
            }), r.scopeVAO && i.set(a.vao, ".targetVAO", r.scopeVAO.append(t, i)), n("vert"), n("frag"), 0 < Object.keys(r.state).length && (i(o, ".dirty=true;"), i.exit(o, ".dirty=true;")), i("a1(", t.shared.context, ",a0,", t.batchId, ");");
          }

          function X(t, e, r) {
            var n = e.static[r];

            if (n && function (t) {
              if ("object" == _typeof(t) && !g(t)) {
                for (var e = Object.keys(t), r = 0; r < e.length; ++r) {
                  if (q.isDynamic(t[e[r]])) return !0;
                }

                return !1;
              }
            }(n)) {
              var i = t.global,
                  a = Object.keys(n),
                  o = !1,
                  s = !1,
                  l = !1,
                  c = t.global.def("{}");
              a.forEach(function (e) {
                var r = n[e];
                if (q.isDynamic(r)) "function" == typeof r && (r = n[e] = q.unbox(r)), e = B(r, null), o = o || e.thisDep, l = l || e.propDep, s = s || e.contextDep;else {
                  switch (i(c, ".", e, "="), _typeof(r)) {
                    case "number":
                      i(r);
                      break;

                    case "string":
                      i('"', r, '"');
                      break;

                    case "object":
                      Array.isArray(r) && i("[", r.join(), "]");
                      break;

                    default:
                      i(t.link(r));
                  }

                  i(";");
                }
              }), e.dynamic[r] = new q.DynamicVariable(4, {
                thisDep: o,
                contextDep: s,
                propDep: l,
                ref: c,
                append: function append(t, e) {
                  a.forEach(function (r) {
                    var i = n[r];
                    q.isDynamic(i) && (i = t.invoke(e, i), e(c, ".", r, "=", i, ";"));
                  });
                }
              }), delete e.static[r];
            }
          }

          var Z = u.Record,
              J = {
            add: 32774,
            subtract: 32778,
            "reverse subtract": 32779
          };
          r.ext_blend_minmax && (J.min = 32775, J.max = 32776);
          var K = r.angle_instanced_arrays,
              $ = r.webgl_draw_buffers,
              tt = {
            dirty: !0,
            profile: m.profile
          },
              et = {},
              rt = [],
              it = {},
              at = {};
          y("dither", 3024), y("blend.enable", 3042), x("blend.color", "blendColor", [0, 0, 0, 0]), x("blend.equation", "blendEquationSeparate", [32774, 32774]), x("blend.func", "blendFuncSeparate", [1, 0, 1, 0]), y("depth.enable", 2929, !0), x("depth.func", "depthFunc", 513), x("depth.range", "depthRange", [0, 1]), x("depth.mask", "depthMask", !0), x("colorMask", "colorMask", [!0, !0, !0, !0]), y("cull.enable", 2884), x("cull.face", "cullFace", 1029), x("frontFace", "frontFace", 2305), x("lineWidth", "lineWidth", 1), y("polygonOffset.enable", 32823), x("polygonOffset.offset", "polygonOffset", [0, 0]), y("sample.alpha", 32926), y("sample.enable", 32928), x("sample.coverage", "sampleCoverage", [1, !1]), y("stencil.enable", 2960), x("stencil.mask", "stencilMask", -1), x("stencil.func", "stencilFunc", [519, 0, -1]), x("stencil.opFront", "stencilOpSeparate", [1028, 7680, 7680, 7680]), x("stencil.opBack", "stencilOpSeparate", [1029, 7680, 7680, 7680]), y("scissor.enable", 3089), x("scissor.box", "scissor", [0, 0, t.drawingBufferWidth, t.drawingBufferHeight]), x("viewport", "viewport", [0, 0, t.drawingBufferWidth, t.drawingBufferHeight]);
          var ot = {
            gl: t,
            context: p,
            strings: e,
            next: et,
            current: tt,
            draw: h,
            elements: o,
            buffer: i,
            shader: f,
            attributes: u.state,
            vao: u,
            uniforms: c,
            framebuffer: l,
            extensions: r,
            timer: d,
            isBufferArgs: O
          },
              st = {
            primTypes: nt,
            compareFuncs: Mt,
            blendFuncs: kt,
            blendEquations: J,
            stencilOps: At,
            glTypes: Q,
            orientationType: St
          };
          $ && (st.backBuffer = [1029], st.drawBuffer = a(n.maxDrawbuffers, function (t) {
            return 0 === t ? [0] : a(t, function (t) {
              return 36064 + t;
            });
          }));
          var lt = 0;
          return {
            next: et,
            current: tt,
            procs: function () {
              var t = b(),
                  e = t.proc("poll"),
                  i = t.proc("refresh"),
                  o = t.block();
              e(o), i(o);
              var s,
                  l = t.shared,
                  c = l.gl,
                  u = l.next,
                  f = l.current;
              o(f, ".dirty=false;"), S(t, e), S(t, i, null, !0), K && (s = t.link(K)), r.oes_vertex_array_object && i(t.link(r.oes_vertex_array_object), ".bindVertexArrayOES(null);");

              for (var h = 0; h < n.maxAttributes; ++h) {
                var p = i.def(l.attributes, "[", h, "]"),
                    d = t.cond(p, ".buffer");
                d.then(c, ".enableVertexAttribArray(", h, ");", c, ".bindBuffer(", 34962, ",", p, ".buffer.buffer);", c, ".vertexAttribPointer(", h, ",", p, ".size,", p, ".type,", p, ".normalized,", p, ".stride,", p, ".offset);").else(c, ".disableVertexAttribArray(", h, ");", c, ".vertexAttrib4f(", h, ",", p, ".x,", p, ".y,", p, ".z,", p, ".w);", p, ".buffer=null;"), i(d), K && i(s, ".vertexAttribDivisorANGLE(", h, ",", p, ".divisor);");
              }

              return i(t.shared.vao, ".currentVAO=null;", t.shared.vao, ".setVAO(", t.shared.vao, ".targetVAO);"), Object.keys(it).forEach(function (r) {
                var n = it[r],
                    a = o.def(u, ".", r),
                    s = t.block();
                s("if(", a, "){", c, ".enable(", n, ")}else{", c, ".disable(", n, ")}", f, ".", r, "=", a, ";"), i(s), e("if(", a, "!==", f, ".", r, "){", s, "}");
              }), Object.keys(at).forEach(function (r) {
                var n,
                    s,
                    l = at[r],
                    h = tt[r],
                    p = t.block();
                p(c, ".", l, "("), g(h) ? (l = h.length, n = t.global.def(u, ".", r), s = t.global.def(f, ".", r), p(a(l, function (t) {
                  return n + "[" + t + "]";
                }), ");", a(l, function (t) {
                  return s + "[" + t + "]=" + n + "[" + t + "];";
                }).join("")), e("if(", a(l, function (t) {
                  return n + "[" + t + "]!==" + s + "[" + t + "]";
                }).join("||"), "){", p, "}")) : (n = o.def(u, ".", r), s = o.def(f, ".", r), p(n, ");", f, ".", r, "=", n, ";"), e("if(", n, "!==", s, "){", p, "}")), i(p);
              }), t.compile();
            }(),
            compile: function compile(t, e, r, n, i) {
              var a = b();
              return a.stats = a.link(i), Object.keys(e.static).forEach(function (t) {
                X(a, e, t);
              }), Tt.forEach(function (e) {
                X(a, t, e);
              }), r = M(t, e, r, n), function (t, e) {
                var r = t.proc("draw", 1);
                C(t, r), A(t, r, e.context), S(t, r, e.framebuffer), E(t, r, e), L(t, r, e.state), P(t, r, e, !1, !0);
                var n = e.shader.progVar.append(t, r);
                if (r(t.shared.gl, ".useProgram(", n, ".program);"), e.shader.program) H(t, r, e, e.shader.program);else {
                  r(t.shared.vao, ".setVAO(null);");
                  var i = t.global.def("{}"),
                      a = r.def(n, ".id"),
                      o = r.def(i, "[", a, "]");
                  r(t.cond(o).then(o, ".call(this,a0);").else(o, "=", i, "[", a, "]=", t.link(function (r) {
                    return V(H, t, e, r, 1);
                  }), "(", n, ");", o, ".call(this,a0);"));
                }
                0 < Object.keys(e.state).length && r(t.shared.current, ".dirty=true;");
              }(a, r), W(a, r), function (t, e) {
                function r(t) {
                  return t.contextDep && i || t.propDep;
                }

                var n = t.proc("batch", 2);
                t.batchId = "0", C(t, n);
                var i = !1,
                    a = !0;
                Object.keys(e.context).forEach(function (t) {
                  i = i || e.context[t].propDep;
                }), i || (A(t, n, e.context), a = !1);
                var o = !1;
                if ((s = e.framebuffer) ? (s.propDep ? i = o = !0 : s.contextDep && i && (o = !0), o || S(t, n, s)) : S(t, n, null), e.state.viewport && e.state.viewport.propDep && (i = !0), E(t, n, e), L(t, n, e.state, function (t) {
                  return !r(t);
                }), e.profile && r(e.profile) || P(t, n, e, !1, "a1"), e.contextDep = i, e.needsContext = a, e.needsFramebuffer = o, (a = e.shader.progVar).contextDep && i || a.propDep) Y(t, n, e, null);else if (a = a.append(t, n), n(t.shared.gl, ".useProgram(", a, ".program);"), e.shader.program) Y(t, n, e, e.shader.program);else {
                  n(t.shared.vao, ".setVAO(null);");
                  var s = t.global.def("{}"),
                      l = (o = n.def(a, ".id"), n.def(s, "[", o, "]"));
                  n(t.cond(l).then(l, ".call(this,a0,a1);").else(l, "=", s, "[", o, "]=", t.link(function (r) {
                    return V(Y, t, e, r, 2);
                  }), "(", a, ");", l, ".call(this,a0,a1);"));
                }
                0 < Object.keys(e.state).length && n(t.shared.current, ".dirty=true;");
              }(a, r), a.compile();
            }
          };
        }

        function j(t, e) {
          for (var r = 0; r < t.length; ++r) {
            if (t[r] === e) return r;
          }

          return -1;
        }

        var U = function U(t, e) {
          for (var r = Object.keys(e), n = 0; n < r.length; ++n) {
            t[r[n]] = e[r[n]];
          }

          return t;
        },
            V = 0,
            q = {
          DynamicVariable: t,
          define: function define(r, n) {
            return new t(r, e(n + ""));
          },
          isDynamic: function isDynamic(e) {
            return "function" == typeof e && !e._reglType || e instanceof t;
          },
          unbox: function unbox(e, r) {
            return "function" == typeof e ? new t(0, e) : e;
          },
          accessor: e
        },
            H = {
          next: "function" == typeof requestAnimationFrame ? function (t) {
            return requestAnimationFrame(t);
          } : function (t) {
            return setTimeout(t, 16);
          },
          cancel: "function" == typeof cancelAnimationFrame ? function (t) {
            return cancelAnimationFrame(t);
          } : clearTimeout
        },
            G = "undefined" != typeof performance && performance.now ? function () {
          return performance.now();
        } : function () {
          return +new Date();
        },
            Y = s();

        Y.zero = s();

        var W = function W(t, e) {
          var r = 1;
          e.ext_texture_filter_anisotropic && (r = t.getParameter(34047));
          var n = 1,
              i = 1;
          e.webgl_draw_buffers && (n = t.getParameter(34852), i = t.getParameter(36063));
          var a = !!e.oes_texture_float;

          if (a) {
            a = t.createTexture(), t.bindTexture(3553, a), t.texImage2D(3553, 0, 6408, 1, 1, 0, 6408, 5126, null);
            var o = t.createFramebuffer();
            if (t.bindFramebuffer(36160, o), t.framebufferTexture2D(36160, 36064, 3553, a, 0), t.bindTexture(3553, null), 36053 !== t.checkFramebufferStatus(36160)) a = !1;else {
              t.viewport(0, 0, 1, 1), t.clearColor(1, 0, 0, 1), t.clear(16384);
              var s = Y.allocType(5126, 4);
              t.readPixels(0, 0, 1, 1, 6408, 5126, s), t.getError() ? a = !1 : (t.deleteFramebuffer(o), t.deleteTexture(a), a = 1 === s[0]), Y.freeType(s);
            }
          }

          return s = !0, "undefined" != typeof navigator && (/MSIE/.test(navigator.userAgent) || /Trident\//.test(navigator.appVersion) || /Edge/.test(navigator.userAgent)) || (s = t.createTexture(), o = Y.allocType(5121, 36), t.activeTexture(33984), t.bindTexture(34067, s), t.texImage2D(34069, 0, 6408, 3, 3, 0, 6408, 5121, o), Y.freeType(o), t.bindTexture(34067, null), t.deleteTexture(s), s = !t.getError()), {
            colorBits: [t.getParameter(3410), t.getParameter(3411), t.getParameter(3412), t.getParameter(3413)],
            depthBits: t.getParameter(3414),
            stencilBits: t.getParameter(3415),
            subpixelBits: t.getParameter(3408),
            extensions: Object.keys(e).filter(function (t) {
              return !!e[t];
            }),
            maxAnisotropic: r,
            maxDrawbuffers: n,
            maxColorAttachments: i,
            pointSizeDims: t.getParameter(33901),
            lineWidthDims: t.getParameter(33902),
            maxViewportDims: t.getParameter(3386),
            maxCombinedTextureUnits: t.getParameter(35661),
            maxCubeMapSize: t.getParameter(34076),
            maxRenderbufferSize: t.getParameter(34024),
            maxTextureUnits: t.getParameter(34930),
            maxTextureSize: t.getParameter(3379),
            maxAttributes: t.getParameter(34921),
            maxVertexUniforms: t.getParameter(36347),
            maxVertexTextureUnits: t.getParameter(35660),
            maxVaryingVectors: t.getParameter(36348),
            maxFragmentUniforms: t.getParameter(36349),
            glsl: t.getParameter(35724),
            renderer: t.getParameter(7937),
            vendor: t.getParameter(7936),
            version: t.getParameter(7938),
            readFloat: a,
            npotTextureCube: s
          };
        },
            X = function X(t) {
          return t instanceof Uint8Array || t instanceof Uint16Array || t instanceof Uint32Array || t instanceof Int8Array || t instanceof Int16Array || t instanceof Int32Array || t instanceof Float32Array || t instanceof Float64Array || t instanceof Uint8ClampedArray;
        },
            Z = function Z(t) {
          return Object.keys(t).map(function (e) {
            return t[e];
          });
        },
            J = {
          shape: function shape(t) {
            for (var e = []; t.length; t = t[0]) {
              e.push(t.length);
            }

            return e;
          },
          flatten: function flatten(t, e, r, n) {
            var i = 1;
            if (e.length) for (var a = 0; a < e.length; ++a) {
              i *= e[a];
            } else i = 0;

            switch (r = n || Y.allocType(r, i), e.length) {
              case 0:
                break;

              case 1:
                for (n = e[0], e = 0; e < n; ++e) {
                  r[e] = t[e];
                }

                break;

              case 2:
                for (n = e[0], e = e[1], a = i = 0; a < n; ++a) {
                  for (var o = t[a], s = 0; s < e; ++s) {
                    r[i++] = o[s];
                  }
                }

                break;

              case 3:
                c(t, e[0], e[1], e[2], r, 0);
                break;

              default:
                !function t(e, r, n, i, a) {
                  for (var o = 1, s = n + 1; s < r.length; ++s) {
                    o *= r[s];
                  }

                  var l = r[n];

                  if (4 == r.length - n) {
                    var u = r[n + 1],
                        f = r[n + 2];

                    for (r = r[n + 3], s = 0; s < l; ++s) {
                      c(e[s], u, f, r, i, a), a += o;
                    }
                  } else for (s = 0; s < l; ++s) {
                    t(e[s], r, n + 1, i, a), a += o;
                  }
                }(t, e, 0, r, 0);
            }

            return r;
          }
        },
            K = {
          "[object Int8Array]": 5120,
          "[object Int16Array]": 5122,
          "[object Int32Array]": 5124,
          "[object Uint8Array]": 5121,
          "[object Uint8ClampedArray]": 5121,
          "[object Uint16Array]": 5123,
          "[object Uint32Array]": 5125,
          "[object Float32Array]": 5126,
          "[object Float64Array]": 5121,
          "[object ArrayBuffer]": 5121
        },
            Q = {
          int8: 5120,
          int16: 5122,
          int32: 5124,
          uint8: 5121,
          uint16: 5123,
          uint32: 5125,
          float: 5126,
          float32: 5126
        },
            $ = {
          dynamic: 35048,
          stream: 35040,
          static: 35044
        },
            tt = J.flatten,
            et = J.shape,
            rt = [];

        rt[5120] = 1, rt[5122] = 2, rt[5124] = 4, rt[5121] = 1, rt[5123] = 2, rt[5125] = 4, rt[5126] = 4;
        var nt = {
          points: 0,
          point: 0,
          lines: 1,
          line: 1,
          triangles: 4,
          triangle: 4,
          "line loop": 2,
          "line strip": 3,
          "triangle strip": 5,
          "triangle fan": 6
        },
            it = new Float32Array(1),
            at = new Uint32Array(it.buffer),
            ot = [9984, 9986, 9985, 9987],
            st = [0, 6409, 6410, 6407, 6408],
            lt = {};
        lt[6409] = lt[6406] = lt[6402] = 1, lt[34041] = lt[6410] = 2, lt[6407] = lt[35904] = 3, lt[6408] = lt[35906] = 4;
        var ct = v("HTMLCanvasElement"),
            ut = v("OffscreenCanvas"),
            ft = v("CanvasRenderingContext2D"),
            ht = v("ImageBitmap"),
            pt = v("HTMLImageElement"),
            dt = v("HTMLVideoElement"),
            mt = Object.keys(K).concat([ct, ut, ft, ht, pt, dt]),
            gt = [];
        gt[5121] = 1, gt[5126] = 4, gt[36193] = 2, gt[5123] = 2, gt[5125] = 4;
        var vt = [];
        vt[32854] = 2, vt[32855] = 2, vt[36194] = 2, vt[34041] = 4, vt[33776] = .5, vt[33777] = .5, vt[33778] = 1, vt[33779] = 1, vt[35986] = .5, vt[35987] = 1, vt[34798] = 1, vt[35840] = .5, vt[35841] = .25, vt[35842] = .5, vt[35843] = .25, vt[36196] = .5;
        var yt = [];
        yt[32854] = 2, yt[32855] = 2, yt[36194] = 2, yt[33189] = 2, yt[36168] = 1, yt[34041] = 4, yt[35907] = 4, yt[34836] = 16, yt[34842] = 8, yt[34843] = 6;

        var xt = function xt(t, e, r, n, i) {
          function a(t) {
            this.id = c++, this.refCount = 1, this.renderbuffer = t, this.format = 32854, this.height = this.width = 0, i.profile && (this.stats = {
              size: 0
            });
          }

          function o(e) {
            var r = e.renderbuffer;
            t.bindRenderbuffer(36161, null), t.deleteRenderbuffer(r), e.renderbuffer = null, e.refCount = 0, delete u[e.id], n.renderbufferCount--;
          }

          var s = {
            rgba4: 32854,
            rgb565: 36194,
            "rgb5 a1": 32855,
            depth: 33189,
            stencil: 36168,
            "depth stencil": 34041
          };
          e.ext_srgb && (s.srgba = 35907), e.ext_color_buffer_half_float && (s.rgba16f = 34842, s.rgb16f = 34843), e.webgl_color_buffer_float && (s.rgba32f = 34836);
          var l = [];
          Object.keys(s).forEach(function (t) {
            l[s[t]] = t;
          });
          var c = 0,
              u = {};
          return a.prototype.decRef = function () {
            0 >= --this.refCount && o(this);
          }, i.profile && (n.getTotalRenderbufferSize = function () {
            var t = 0;
            return Object.keys(u).forEach(function (e) {
              t += u[e].stats.size;
            }), t;
          }), {
            create: function create(e, r) {
              function o(e, r) {
                var n = 0,
                    a = 0,
                    u = 32854;
                if ("object" == _typeof(e) && e ? ("shape" in e ? (n = 0 | (a = e.shape)[0], a = 0 | a[1]) : ("radius" in e && (n = a = 0 | e.radius), "width" in e && (n = 0 | e.width), "height" in e && (a = 0 | e.height)), "format" in e && (u = s[e.format])) : "number" == typeof e ? (n = 0 | e, a = "number" == typeof r ? 0 | r : n) : e || (n = a = 1), n !== c.width || a !== c.height || u !== c.format) return o.width = c.width = n, o.height = c.height = a, c.format = u, t.bindRenderbuffer(36161, c.renderbuffer), t.renderbufferStorage(36161, u, n, a), i.profile && (c.stats.size = yt[c.format] * c.width * c.height), o.format = l[c.format], o;
              }

              var c = new a(t.createRenderbuffer());
              return u[c.id] = c, n.renderbufferCount++, o(e, r), o.resize = function (e, r) {
                var n = 0 | e,
                    a = 0 | r || n;
                return n === c.width && a === c.height || (o.width = c.width = n, o.height = c.height = a, t.bindRenderbuffer(36161, c.renderbuffer), t.renderbufferStorage(36161, c.format, n, a), i.profile && (c.stats.size = yt[c.format] * c.width * c.height)), o;
              }, o._reglType = "renderbuffer", o._renderbuffer = c, i.profile && (o.stats = c.stats), o.destroy = function () {
                c.decRef();
              }, o;
            },
            clear: function clear() {
              Z(u).forEach(o);
            },
            restore: function restore() {
              Z(u).forEach(function (e) {
                e.renderbuffer = t.createRenderbuffer(), t.bindRenderbuffer(36161, e.renderbuffer), t.renderbufferStorage(36161, e.format, e.width, e.height);
              }), t.bindRenderbuffer(36161, null);
            }
          };
        },
            bt = [];

        bt[6408] = 4, bt[6407] = 3;
        var _t = [];
        _t[5121] = 1, _t[5126] = 4, _t[36193] = 2;
        var wt = ["x", "y", "z", "w"],
            Tt = "blend.func blend.equation stencil.func stencil.opFront stencil.opBack sample.coverage viewport scissor.box polygonOffset.offset".split(" "),
            kt = {
          0: 0,
          1: 1,
          zero: 0,
          one: 1,
          "src color": 768,
          "one minus src color": 769,
          "src alpha": 770,
          "one minus src alpha": 771,
          "dst color": 774,
          "one minus dst color": 775,
          "dst alpha": 772,
          "one minus dst alpha": 773,
          "constant color": 32769,
          "one minus constant color": 32770,
          "constant alpha": 32771,
          "one minus constant alpha": 32772,
          "src alpha saturate": 776
        },
            Mt = {
          never: 512,
          less: 513,
          "<": 513,
          equal: 514,
          "=": 514,
          "==": 514,
          "===": 514,
          lequal: 515,
          "<=": 515,
          greater: 516,
          ">": 516,
          notequal: 517,
          "!=": 517,
          "!==": 517,
          gequal: 518,
          ">=": 518,
          always: 519
        },
            At = {
          0: 0,
          zero: 0,
          keep: 7680,
          replace: 7681,
          increment: 7682,
          decrement: 7683,
          "increment wrap": 34055,
          "decrement wrap": 34056,
          invert: 5386
        },
            St = {
          cw: 2304,
          ccw: 2305
        },
            Et = new D(!1, !1, !1, function () {});
        return function (t) {
          function e() {
            if (0 === J.length) w && w.update(), tt = null;else {
              tt = H.next(e), f();

              for (var t = J.length - 1; 0 <= t; --t) {
                var r = J[t];
                r && r(P, null, 0);
              }

              g.flush(), w && w.update();
            }
          }

          function r() {
            !tt && 0 < J.length && (tt = H.next(e));
          }

          function n() {
            tt && (H.cancel(e), tt = null);
          }

          function a(t) {
            t.preventDefault(), n(), K.forEach(function (t) {
              t();
            });
          }

          function o(t) {
            g.getError(), y.restore(), R.restore(), O.restore(), F.restore(), B.restore(), V.restore(), z.restore(), w && w.restore(), Y.procs.refresh(), r(), Q.forEach(function (t) {
              t();
            });
          }

          function s(t) {
            function e(t) {
              var e = {},
                  r = {};
              return Object.keys(t).forEach(function (n) {
                var i = t[n];
                q.isDynamic(i) ? r[n] = q.unbox(i, n) : e[n] = i;
              }), {
                dynamic: r,
                static: e
              };
            }

            var r = e(t.context || {}),
                n = e(t.uniforms || {}),
                i = e(t.attributes || {}),
                a = e(function (t) {
              function e(t) {
                if (t in r) {
                  var e = r[t];
                  delete r[t], Object.keys(e).forEach(function (n) {
                    r[t + "." + n] = e[n];
                  });
                }
              }

              var r = U({}, t);
              return delete r.uniforms, delete r.attributes, delete r.context, delete r.vao, "stencil" in r && r.stencil.op && (r.stencil.opBack = r.stencil.opFront = r.stencil.op, delete r.stencil.op), e("blend"), e("depth"), e("cull"), e("stencil"), e("polygonOffset"), e("scissor"), e("sample"), "vao" in t && (r.vao = t.vao), r;
            }(t));
            t = {
              gpuTime: 0,
              cpuTime: 0,
              count: 0
            };
            var o = (r = Y.compile(a, i, n, r, t)).draw,
                s = r.batch,
                l = r.scope,
                c = [];
            return U(function (t, e) {
              var r;
              if ("function" == typeof t) return l.call(this, null, t, 0);
              if ("function" == typeof e) {
                if ("number" == typeof t) for (r = 0; r < t; ++r) {
                  l.call(this, null, e, r);
                } else {
                  if (!Array.isArray(t)) return l.call(this, t, e, 0);

                  for (r = 0; r < t.length; ++r) {
                    l.call(this, t[r], e, r);
                  }
                }
              } else if ("number" == typeof t) {
                if (0 < t) return s.call(this, function (t) {
                  for (; c.length < t;) {
                    c.push(null);
                  }

                  return c;
                }(0 | t), 0 | t);
              } else {
                if (!Array.isArray(t)) return o.call(this, t);
                if (t.length) return s.call(this, t, t.length);
              }
            }, {
              stats: t
            });
          }

          function l(t, e) {
            var r = 0;
            Y.procs.poll();
            var n = e.color;
            n && (g.clearColor(+n[0] || 0, +n[1] || 0, +n[2] || 0, +n[3] || 0), r |= 16384), "depth" in e && (g.clearDepth(+e.depth), r |= 256), "stencil" in e && (g.clearStencil(0 | e.stencil), r |= 1024), g.clear(r);
          }

          function c(t) {
            return J.push(t), r(), {
              cancel: function cancel() {
                var e = j(J, t);

                J[e] = function t() {
                  var e = j(J, t);
                  J[e] = J[J.length - 1], --J.length, 0 >= J.length && n();
                };
              }
            };
          }

          function u() {
            var t = X.viewport,
                e = X.scissor_box;
            t[0] = t[1] = e[0] = e[1] = 0, P.viewportWidth = P.framebufferWidth = P.drawingBufferWidth = t[2] = e[2] = g.drawingBufferWidth, P.viewportHeight = P.framebufferHeight = P.drawingBufferHeight = t[3] = e[3] = g.drawingBufferHeight;
          }

          function f() {
            P.tick += 1, P.time = m(), u(), Y.procs.poll();
          }

          function h() {
            u(), Y.procs.refresh(), w && w.update();
          }

          function m() {
            return (G() - T) / 1e3;
          }

          if (!(t = i(t))) return null;
          var g = t.gl,
              v = g.getContextAttributes();
          g.isContextLost();

          var y = function (t, e) {
            function r(e) {
              var r;
              e = e.toLowerCase();

              try {
                r = n[e] = t.getExtension(e);
              } catch (t) {}

              return !!r;
            }

            for (var n = {}, i = 0; i < e.extensions.length; ++i) {
              var a = e.extensions[i];
              if (!r(a)) return e.onDestroy(), e.onDone('"' + a + '" extension is not supported by the current WebGL context, try upgrading your system or a different browser'), null;
            }

            return e.optionalExtensions.forEach(r), {
              extensions: n,
              restore: function restore() {
                Object.keys(n).forEach(function (t) {
                  if (n[t] && !r(t)) throw Error("(regl): error restoring extension " + t);
                });
              }
            };
          }(g, t);

          if (!y) return null;

          var x = function () {
            var t = {
              "": 0
            },
                e = [""];
            return {
              id: function id(r) {
                var n = t[r];
                return n || (n = t[r] = e.length, e.push(r), n);
              },
              str: function str(t) {
                return e[t];
              }
            };
          }(),
              b = {
            vaoCount: 0,
            bufferCount: 0,
            elementsCount: 0,
            framebufferCount: 0,
            shaderCount: 0,
            textureCount: 0,
            cubeCount: 0,
            renderbufferCount: 0,
            maxTextureUnits: 0
          },
              _ = y.extensions,
              w = function (t, e) {
            function r() {
              this.endQueryIndex = this.startQueryIndex = -1, this.sum = 0, this.stats = null;
            }

            function n(t, e, n) {
              var i = o.pop() || new r();
              i.startQueryIndex = t, i.endQueryIndex = e, i.sum = 0, i.stats = n, s.push(i);
            }

            if (!e.ext_disjoint_timer_query) return null;
            var i = [],
                a = [],
                o = [],
                s = [],
                l = [],
                c = [];
            return {
              beginQuery: function beginQuery(t) {
                var r = i.pop() || e.ext_disjoint_timer_query.createQueryEXT();
                e.ext_disjoint_timer_query.beginQueryEXT(35007, r), a.push(r), n(a.length - 1, a.length, t);
              },
              endQuery: function endQuery() {
                e.ext_disjoint_timer_query.endQueryEXT(35007);
              },
              pushScopeStats: n,
              update: function update() {
                var t, r;

                if (0 !== (t = a.length)) {
                  c.length = Math.max(c.length, t + 1), l.length = Math.max(l.length, t + 1), l[0] = 0;
                  var n = c[0] = 0;

                  for (r = t = 0; r < a.length; ++r) {
                    var u = a[r];
                    e.ext_disjoint_timer_query.getQueryObjectEXT(u, 34919) ? (n += e.ext_disjoint_timer_query.getQueryObjectEXT(u, 34918), i.push(u)) : a[t++] = u, l[r + 1] = n, c[r + 1] = t;
                  }

                  for (a.length = t, r = t = 0; r < s.length; ++r) {
                    var f = (n = s[r]).startQueryIndex;
                    u = n.endQueryIndex;
                    n.sum += l[u] - l[f], f = c[f], (u = c[u]) === f ? (n.stats.gpuTime += n.sum / 1e6, o.push(n)) : (n.startQueryIndex = f, n.endQueryIndex = u, s[t++] = n);
                  }

                  s.length = t;
                }
              },
              getNumPendingQueries: function getNumPendingQueries() {
                return a.length;
              },
              clear: function clear() {
                i.push.apply(i, a);

                for (var t = 0; t < i.length; t++) {
                  e.ext_disjoint_timer_query.deleteQueryEXT(i[t]);
                }

                a.length = 0, i.length = 0;
              },
              restore: function restore() {
                a.length = 0, i.length = 0;
              }
            };
          }(0, _),
              T = G(),
              A = g.drawingBufferWidth,
              C = g.drawingBufferHeight,
              P = {
            tick: 0,
            time: 0,
            viewportWidth: A,
            viewportHeight: C,
            framebufferWidth: A,
            framebufferHeight: C,
            drawingBufferWidth: A,
            drawingBufferHeight: C,
            pixelRatio: t.pixelRatio
          },
              I = W(g, _),
              O = p(g, b, t, function (t) {
            return z.destroyBuffer(t);
          }),
              z = S(g, _, I, b, O),
              D = d(g, _, O, b),
              R = E(g, x, b, t),
              F = k(g, _, I, function () {
            Y.procs.poll();
          }, P, b, t),
              B = xt(g, _, 0, b, t),
              V = M(g, _, I, F, B, b),
              Y = N(g, x, _, I, O, D, 0, V, {}, z, R, {
            elements: null,
            primitive: 4,
            count: -1,
            offset: 0,
            instances: -1
          }, P, w, t),
              X = (x = L(g, V, Y.procs.poll, P), Y.next),
              Z = g.canvas,
              J = [],
              K = [],
              Q = [],
              $ = [t.onDestroy],
              tt = null;

          Z && (Z.addEventListener("webglcontextlost", a, !1), Z.addEventListener("webglcontextrestored", o, !1));
          var et = V.setFBO = s({
            framebuffer: q.define.call(null, 1, "framebuffer")
          });
          return h(), v = U(s, {
            clear: function clear(t) {
              if ("framebuffer" in t) {
                if (t.framebuffer && "framebufferCube" === t.framebuffer_reglType) for (var e = 0; 6 > e; ++e) {
                  et(U({
                    framebuffer: t.framebuffer.faces[e]
                  }, t), l);
                } else et(t, l);
              } else l(0, t);
            },
            prop: q.define.bind(null, 1),
            context: q.define.bind(null, 2),
            this: q.define.bind(null, 3),
            draw: s({}),
            buffer: function buffer(t) {
              return O.create(t, 34962, !1, !1);
            },
            elements: function elements(t) {
              return D.create(t, !1);
            },
            texture: F.create2D,
            cube: F.createCube,
            renderbuffer: B.create,
            framebuffer: V.create,
            framebufferCube: V.createCube,
            vao: z.createVAO,
            attributes: v,
            frame: c,
            on: function on(t, e) {
              var r;

              switch (t) {
                case "frame":
                  return c(e);

                case "lost":
                  r = K;
                  break;

                case "restore":
                  r = Q;
                  break;

                case "destroy":
                  r = $;
              }

              return r.push(e), {
                cancel: function cancel() {
                  for (var t = 0; t < r.length; ++t) {
                    if (r[t] === e) {
                      r[t] = r[r.length - 1], r.pop();
                      break;
                    }
                  }
                }
              };
            },
            limits: I,
            hasExtension: function hasExtension(t) {
              return 0 <= I.extensions.indexOf(t.toLowerCase());
            },
            read: x,
            destroy: function destroy() {
              J.length = 0, n(), Z && (Z.removeEventListener("webglcontextlost", a), Z.removeEventListener("webglcontextrestored", o)), R.clear(), V.clear(), B.clear(), F.clear(), D.clear(), O.clear(), z.clear(), w && w.clear(), $.forEach(function (t) {
                t();
              });
            },
            _gl: g,
            _refresh: h,
            poll: function poll() {
              f(), w && w.update();
            },
            now: m,
            stats: b
          }), t.onDone(null, v), v;
        };
      });
    }, {}],
    533: [function (t, e, r) {
      /*!
       * repeat-string <https://github.com/jonschlinkert/repeat-string>
       *
       * Copyright (c) 2014-2015, Jon Schlinkert.
       * Licensed under the MIT License.
       */
      "use strict";

      var n,
          i = "";

      e.exports = function (t, e) {
        if ("string" != typeof t) throw new TypeError("expected a string");
        if (1 === e) return t;
        if (2 === e) return t + t;
        var r = t.length * e;
        if (n !== t || void 0 === n) n = t, i = "";else if (i.length >= r) return i.substr(0, r);

        for (; r > i.length && e > 1;) {
          1 & e && (i += t), e >>= 1, t += t;
        }

        return i = (i += t).substr(0, r);
      };
    }, {}],
    534: [function (t, e, r) {
      (function (t) {
        (function () {
          e.exports = t.performance && t.performance.now ? function () {
            return performance.now();
          } : Date.now || function () {
            return +new Date();
          };
        }).call(this);
      }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
    }, {}],
    535: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        for (var e = t.length, r = t[t.length - 1], n = e, i = e - 2; i >= 0; --i) {
          var a = r,
              o = t[i];
          (l = o - ((r = a + o) - a)) && (t[--n] = r, r = l);
        }

        var s = 0;

        for (i = n; i < e; ++i) {
          var l;
          a = t[i];
          (l = (o = r) - ((r = a + o) - a)) && (t[s++] = l);
        }

        return t[s++] = r, t.length = s, t;
      };
    }, {}],
    536: [function (t, e, r) {
      "use strict";

      var n = t("two-product"),
          i = t("robust-sum"),
          a = t("robust-scale"),
          o = t("robust-compress");

      function s(t, e) {
        for (var r = new Array(t.length - 1), n = 1; n < t.length; ++n) {
          for (var i = r[n - 1] = new Array(t.length - 1), a = 0, o = 0; a < t.length; ++a) {
            a !== e && (i[o++] = t[n][a]);
          }
        }

        return r;
      }

      function l(t) {
        for (var e = new Array(t), r = 0; r < t; ++r) {
          e[r] = new Array(t);

          for (var n = 0; n < t; ++n) {
            e[r][n] = ["m[", r, "][", n, "]"].join("");
          }
        }

        return e;
      }

      function c(t) {
        if (2 === t.length) return ["sum(prod(", t[0][0], ",", t[1][1], "),prod(-", t[0][1], ",", t[1][0], "))"].join("");

        for (var e = [], r = 0; r < t.length; ++r) {
          e.push(["scale(", c(s(t, r)), ",", (n = r, 1 & n ? "-" : ""), t[0][r], ")"].join(""));
        }

        return function t(e) {
          if (1 === e.length) return e[0];
          if (2 === e.length) return ["sum(", e[0], ",", e[1], ")"].join("");
          var r = e.length >> 1;
          return ["sum(", t(e.slice(0, r)), ",", t(e.slice(r)), ")"].join("");
        }(e);
        var n;
      }

      function u(t) {
        return new Function("sum", "scale", "prod", "compress", ["function robustDeterminant", t, "(m){return compress(", c(l(t)), ")};return robustDeterminant", t].join(""))(i, a, n, o);
      }

      var f = [function () {
        return [0];
      }, function (t) {
        return [t[0][0]];
      }];
      !function () {
        for (; f.length < 6;) {
          f.push(u(f.length));
        }

        for (var t = [], r = ["function robustDeterminant(m){switch(m.length){"], n = 0; n < 6; ++n) {
          t.push("det" + n), r.push("case ", n, ":return det", n, "(m);");
        }

        r.push("}var det=CACHE[m.length];if(!det)det=CACHE[m.length]=gen(m.length);return det(m);}return robustDeterminant"), t.push("CACHE", "gen", r.join(""));
        var i = Function.apply(void 0, t);

        for (e.exports = i.apply(void 0, f.concat([f, u])), n = 0; n < f.length; ++n) {
          e.exports[n] = f[n];
        }
      }();
    }, {
      "robust-compress": 535,
      "robust-scale": 542,
      "robust-sum": 545,
      "two-product": 596
    }],
    537: [function (t, e, r) {
      "use strict";

      var n = t("two-product"),
          i = t("robust-sum");

      e.exports = function (t, e) {
        for (var r = n(t[0], e[0]), a = 1; a < t.length; ++a) {
          r = i(r, n(t[a], e[a]));
        }

        return r;
      };
    }, {
      "robust-sum": 545,
      "two-product": 596
    }],
    538: [function (t, e, r) {
      "use strict";

      var n = t("two-product"),
          i = t("robust-sum"),
          a = t("robust-subtract"),
          o = t("robust-scale");

      function s(t, e) {
        for (var r = new Array(t.length - 1), n = 1; n < t.length; ++n) {
          for (var i = r[n - 1] = new Array(t.length - 1), a = 0, o = 0; a < t.length; ++a) {
            a !== e && (i[o++] = t[n][a]);
          }
        }

        return r;
      }

      function l(t) {
        if (1 === t.length) return t[0];
        if (2 === t.length) return ["sum(", t[0], ",", t[1], ")"].join("");
        var e = t.length >> 1;
        return ["sum(", l(t.slice(0, e)), ",", l(t.slice(e)), ")"].join("");
      }

      function c(t, e) {
        if ("m" === t.charAt(0)) {
          if ("w" === e.charAt(0)) {
            var r = t.split("[");
            return ["w", e.substr(1), "m", r[0].substr(1)].join("");
          }

          return ["prod(", t, ",", e, ")"].join("");
        }

        return c(e, t);
      }

      function u(t) {
        if (2 === t.length) return [["diff(", c(t[0][0], t[1][1]), ",", c(t[1][0], t[0][1]), ")"].join("")];

        for (var e = [], r = 0; r < t.length; ++r) {
          e.push(["scale(", l(u(s(t, r))), ",", (n = r, !0 & n ? "-" : ""), t[0][r], ")"].join(""));
        }

        return e;
        var n;
      }

      function f(t, e) {
        for (var r = [], n = 0; n < e - 2; ++n) {
          r.push(["prod(m", t, "[", n, "],m", t, "[", n, "])"].join(""));
        }

        return l(r);
      }

      function h(t) {
        for (var e = [], r = [], c = function (t) {
          for (var e = new Array(t), r = 0; r < t; ++r) {
            e[r] = new Array(t);

            for (var n = 0; n < t; ++n) {
              e[r][n] = ["m", n, "[", t - r - 2, "]"].join("");
            }
          }

          return e;
        }(t), h = 0; h < t; ++h) {
          c[0][h] = "1", c[t - 1][h] = "w" + h;
        }

        for (h = 0; h < t; ++h) {
          0 == (1 & h) ? e.push.apply(e, u(s(c, h))) : r.push.apply(r, u(s(c, h)));
        }

        var p = l(e),
            d = l(r),
            m = "exactInSphere" + t,
            g = [];

        for (h = 0; h < t; ++h) {
          g.push("m" + h);
        }

        var v = ["function ", m, "(", g.join(), "){"];

        for (h = 0; h < t; ++h) {
          v.push("var w", h, "=", f(h, t), ";");

          for (var y = 0; y < t; ++y) {
            y !== h && v.push("var w", h, "m", y, "=scale(w", h, ",m", y, "[0]);");
          }
        }

        return v.push("var p=", p, ",n=", d, ",d=diff(p,n);return d[d.length-1];}return ", m), new Function("sum", "diff", "prod", "scale", v.join(""))(i, a, n, o);
      }

      var p = [function () {
        return 0;
      }, function () {
        return 0;
      }, function () {
        return 0;
      }];

      function d(t) {
        var e = p[t.length];
        return e || (e = p[t.length] = h(t.length)), e.apply(void 0, t);
      }

      !function () {
        for (; p.length <= 6;) {
          p.push(h(p.length));
        }

        for (var t = [], r = ["slow"], n = 0; n <= 6; ++n) {
          t.push("a" + n), r.push("o" + n);
        }

        var i = ["function testInSphere(", t.join(), "){switch(arguments.length){case 0:case 1:return 0;"];

        for (n = 2; n <= 6; ++n) {
          i.push("case ", n, ":return o", n, "(", t.slice(0, n).join(), ");");
        }

        i.push("}var s=new Array(arguments.length);for(var i=0;i<arguments.length;++i){s[i]=arguments[i]};return slow(s);}return testInSphere"), r.push(i.join(""));
        var a = Function.apply(void 0, r);

        for (e.exports = a.apply(void 0, [d].concat(p)), n = 0; n <= 6; ++n) {
          e.exports[n] = p[n];
        }
      }();
    }, {
      "robust-scale": 542,
      "robust-subtract": 544,
      "robust-sum": 545,
      "two-product": 596
    }],
    539: [function (t, e, r) {
      "use strict";

      var n = t("robust-determinant");

      function i(t) {
        for (var e = "robustLinearSolve" + t + "d", r = ["function ", e, "(A,b){return ["], i = 0; i < t; ++i) {
          r.push("det([");

          for (var a = 0; a < t; ++a) {
            a > 0 && r.push(","), r.push("[");

            for (var o = 0; o < t; ++o) {
              o > 0 && r.push(","), o === i ? r.push("+b[", a, "]") : r.push("+A[", a, "][", o, "]");
            }

            r.push("]");
          }

          r.push("]),");
        }

        r.push("det(A)]}return ", e);
        var s = new Function("det", r.join(""));
        return s(t < 6 ? n[t] : n);
      }

      var a = [function () {
        return [0];
      }, function (t, e) {
        return [[e[0]], [t[0][0]]];
      }];
      !function () {
        for (; a.length < 6;) {
          a.push(i(a.length));
        }

        for (var t = [], r = ["function dispatchLinearSolve(A,b){switch(A.length){"], n = 0; n < 6; ++n) {
          t.push("s" + n), r.push("case ", n, ":return s", n, "(A,b);");
        }

        r.push("}var s=CACHE[A.length];if(!s)s=CACHE[A.length]=g(A.length);return s(A,b)}return dispatchLinearSolve"), t.push("CACHE", "g", r.join(""));
        var o = Function.apply(void 0, t);

        for (e.exports = o.apply(void 0, a.concat([a, i])), n = 0; n < 6; ++n) {
          e.exports[n] = a[n];
        }
      }();
    }, {
      "robust-determinant": 536
    }],
    540: [function (t, e, r) {
      "use strict";

      var n = t("two-product"),
          i = t("robust-sum"),
          a = t("robust-scale"),
          o = t("robust-subtract");

      function s(t, e) {
        for (var r = new Array(t.length - 1), n = 1; n < t.length; ++n) {
          for (var i = r[n - 1] = new Array(t.length - 1), a = 0, o = 0; a < t.length; ++a) {
            a !== e && (i[o++] = t[n][a]);
          }
        }

        return r;
      }

      function l(t) {
        if (1 === t.length) return t[0];
        if (2 === t.length) return ["sum(", t[0], ",", t[1], ")"].join("");
        var e = t.length >> 1;
        return ["sum(", l(t.slice(0, e)), ",", l(t.slice(e)), ")"].join("");
      }

      function c(t) {
        if (2 === t.length) return [["sum(prod(", t[0][0], ",", t[1][1], "),prod(-", t[0][1], ",", t[1][0], "))"].join("")];

        for (var e = [], r = 0; r < t.length; ++r) {
          e.push(["scale(", l(c(s(t, r))), ",", (n = r, 1 & n ? "-" : ""), t[0][r], ")"].join(""));
        }

        return e;
        var n;
      }

      function u(t) {
        for (var e = [], r = [], u = function (t) {
          for (var e = new Array(t), r = 0; r < t; ++r) {
            e[r] = new Array(t);

            for (var n = 0; n < t; ++n) {
              e[r][n] = ["m", n, "[", t - r - 1, "]"].join("");
            }
          }

          return e;
        }(t), f = [], h = 0; h < t; ++h) {
          0 == (1 & h) ? e.push.apply(e, c(s(u, h))) : r.push.apply(r, c(s(u, h))), f.push("m" + h);
        }

        var p = l(e),
            d = l(r),
            m = "orientation" + t + "Exact",
            g = ["function ", m, "(", f.join(), "){var p=", p, ",n=", d, ",d=sub(p,n);return d[d.length-1];};return ", m].join("");
        return new Function("sum", "prod", "scale", "sub", g)(i, n, a, o);
      }

      var f = u(3),
          h = u(4),
          p = [function () {
        return 0;
      }, function () {
        return 0;
      }, function (t, e) {
        return e[0] - t[0];
      }, function (t, e, r) {
        var n,
            i = (t[1] - r[1]) * (e[0] - r[0]),
            a = (t[0] - r[0]) * (e[1] - r[1]),
            o = i - a;

        if (i > 0) {
          if (a <= 0) return o;
          n = i + a;
        } else {
          if (!(i < 0)) return o;
          if (a >= 0) return o;
          n = -(i + a);
        }

        var s = 33306690738754716e-32 * n;
        return o >= s || o <= -s ? o : f(t, e, r);
      }, function (t, e, r, n) {
        var i = t[0] - n[0],
            a = e[0] - n[0],
            o = r[0] - n[0],
            s = t[1] - n[1],
            l = e[1] - n[1],
            c = r[1] - n[1],
            u = t[2] - n[2],
            f = e[2] - n[2],
            p = r[2] - n[2],
            d = a * c,
            m = o * l,
            g = o * s,
            v = i * c,
            y = i * l,
            x = a * s,
            b = u * (d - m) + f * (g - v) + p * (y - x),
            _ = 7771561172376103e-31 * ((Math.abs(d) + Math.abs(m)) * Math.abs(u) + (Math.abs(g) + Math.abs(v)) * Math.abs(f) + (Math.abs(y) + Math.abs(x)) * Math.abs(p));

        return b > _ || -b > _ ? b : h(t, e, r, n);
      }];

      function d(t) {
        var e = p[t.length];
        return e || (e = p[t.length] = u(t.length)), e.apply(void 0, t);
      }

      !function () {
        for (; p.length <= 5;) {
          p.push(u(p.length));
        }

        for (var t = [], r = ["slow"], n = 0; n <= 5; ++n) {
          t.push("a" + n), r.push("o" + n);
        }

        var i = ["function getOrientation(", t.join(), "){switch(arguments.length){case 0:case 1:return 0;"];

        for (n = 2; n <= 5; ++n) {
          i.push("case ", n, ":return o", n, "(", t.slice(0, n).join(), ");");
        }

        i.push("}var s=new Array(arguments.length);for(var i=0;i<arguments.length;++i){s[i]=arguments[i]};return slow(s);}return getOrientation"), r.push(i.join(""));
        var a = Function.apply(void 0, r);

        for (e.exports = a.apply(void 0, [d].concat(p)), n = 0; n <= 5; ++n) {
          e.exports[n] = p[n];
        }
      }();
    }, {
      "robust-scale": 542,
      "robust-subtract": 544,
      "robust-sum": 545,
      "two-product": 596
    }],
    541: [function (t, e, r) {
      "use strict";

      var n = t("robust-sum"),
          i = t("robust-scale");

      e.exports = function (t, e) {
        if (1 === t.length) return i(e, t[0]);
        if (1 === e.length) return i(t, e[0]);
        if (0 === t.length || 0 === e.length) return [0];
        var r = [0];
        if (t.length < e.length) for (var a = 0; a < t.length; ++a) {
          r = n(r, i(e, t[a]));
        } else for (a = 0; a < e.length; ++a) {
          r = n(r, i(t, e[a]));
        }
        return r;
      };
    }, {
      "robust-scale": 542,
      "robust-sum": 545
    }],
    542: [function (t, e, r) {
      "use strict";

      var n = t("two-product"),
          i = t("two-sum");

      e.exports = function (t, e) {
        var r = t.length;

        if (1 === r) {
          var a = n(t[0], e);
          return a[0] ? a : [a[1]];
        }

        var o = new Array(2 * r),
            s = [.1, .1],
            l = [.1, .1],
            c = 0;
        n(t[0], e, s), s[0] && (o[c++] = s[0]);

        for (var u = 1; u < r; ++u) {
          n(t[u], e, l);
          var f = s[1];
          i(f, l[0], s), s[0] && (o[c++] = s[0]);
          var h = l[1],
              p = s[1],
              d = h + p,
              m = p - (d - h);
          s[1] = d, m && (o[c++] = m);
        }

        s[1] && (o[c++] = s[1]);
        0 === c && (o[c++] = 0);
        return o.length = c, o;
      };
    }, {
      "two-product": 596,
      "two-sum": 597
    }],
    543: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, i) {
        var a = n(t, r, i),
            o = n(e, r, i);
        if (a > 0 && o > 0 || a < 0 && o < 0) return !1;
        var s = n(r, t, e),
            l = n(i, t, e);
        if (s > 0 && l > 0 || s < 0 && l < 0) return !1;
        if (0 === a && 0 === o && 0 === s && 0 === l) return function (t, e, r, n) {
          for (var i = 0; i < 2; ++i) {
            var a = t[i],
                o = e[i],
                s = Math.min(a, o),
                l = Math.max(a, o),
                c = r[i],
                u = n[i],
                f = Math.min(c, u);
            if (Math.max(c, u) < s || l < f) return !1;
          }

          return !0;
        }(t, e, r, i);
        return !0;
      };

      var n = t("robust-orientation")[3];
    }, {
      "robust-orientation": 540
    }],
    544: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        var r = 0 | t.length,
            n = 0 | e.length;
        if (1 === r && 1 === n) return function (t, e) {
          var r = t + e,
              n = r - t,
              i = t - (r - n) + (e - n);
          if (i) return [i, r];
          return [r];
        }(t[0], -e[0]);
        var i,
            a,
            o = new Array(r + n),
            s = 0,
            l = 0,
            c = 0,
            u = Math.abs,
            f = t[l],
            h = u(f),
            p = -e[c],
            d = u(p);
        h < d ? (a = f, (l += 1) < r && (f = t[l], h = u(f))) : (a = p, (c += 1) < n && (p = -e[c], d = u(p)));
        l < r && h < d || c >= n ? (i = f, (l += 1) < r && (f = t[l], h = u(f))) : (i = p, (c += 1) < n && (p = -e[c], d = u(p)));
        var m,
            g,
            v = i + a,
            y = v - i,
            x = a - y,
            b = x,
            _ = v;

        for (; l < r && c < n;) {
          h < d ? (i = f, (l += 1) < r && (f = t[l], h = u(f))) : (i = p, (c += 1) < n && (p = -e[c], d = u(p))), (x = (a = b) - (y = (v = i + a) - i)) && (o[s++] = x), b = _ - ((m = _ + v) - (g = m - _)) + (v - g), _ = m;
        }

        for (; l < r;) {
          (x = (a = b) - (y = (v = (i = f) + a) - i)) && (o[s++] = x), b = _ - ((m = _ + v) - (g = m - _)) + (v - g), _ = m, (l += 1) < r && (f = t[l]);
        }

        for (; c < n;) {
          (x = (a = b) - (y = (v = (i = p) + a) - i)) && (o[s++] = x), b = _ - ((m = _ + v) - (g = m - _)) + (v - g), _ = m, (c += 1) < n && (p = -e[c]);
        }

        b && (o[s++] = b);
        _ && (o[s++] = _);
        s || (o[s++] = 0);
        return o.length = s, o;
      };
    }, {}],
    545: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        var r = 0 | t.length,
            n = 0 | e.length;
        if (1 === r && 1 === n) return function (t, e) {
          var r = t + e,
              n = r - t,
              i = t - (r - n) + (e - n);
          if (i) return [i, r];
          return [r];
        }(t[0], e[0]);
        var i,
            a,
            o = new Array(r + n),
            s = 0,
            l = 0,
            c = 0,
            u = Math.abs,
            f = t[l],
            h = u(f),
            p = e[c],
            d = u(p);
        h < d ? (a = f, (l += 1) < r && (f = t[l], h = u(f))) : (a = p, (c += 1) < n && (p = e[c], d = u(p)));
        l < r && h < d || c >= n ? (i = f, (l += 1) < r && (f = t[l], h = u(f))) : (i = p, (c += 1) < n && (p = e[c], d = u(p)));
        var m,
            g,
            v = i + a,
            y = v - i,
            x = a - y,
            b = x,
            _ = v;

        for (; l < r && c < n;) {
          h < d ? (i = f, (l += 1) < r && (f = t[l], h = u(f))) : (i = p, (c += 1) < n && (p = e[c], d = u(p))), (x = (a = b) - (y = (v = i + a) - i)) && (o[s++] = x), b = _ - ((m = _ + v) - (g = m - _)) + (v - g), _ = m;
        }

        for (; l < r;) {
          (x = (a = b) - (y = (v = (i = f) + a) - i)) && (o[s++] = x), b = _ - ((m = _ + v) - (g = m - _)) + (v - g), _ = m, (l += 1) < r && (f = t[l]);
        }

        for (; c < n;) {
          (x = (a = b) - (y = (v = (i = p) + a) - i)) && (o[s++] = x), b = _ - ((m = _ + v) - (g = m - _)) + (v - g), _ = m, (c += 1) < n && (p = e[c]);
        }

        b && (o[s++] = b);
        _ && (o[s++] = _);
        s || (o[s++] = 0);
        return o.length = s, o;
      };
    }, {}],
    546: [function (t, e, r) {
      var n = t("buffer"),
          i = n.Buffer;

      function a(t, e) {
        for (var r in t) {
          e[r] = t[r];
        }
      }

      function o(t, e, r) {
        return i(t, e, r);
      }

      i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? e.exports = n : (a(n, r), r.Buffer = o), o.prototype = Object.create(i.prototype), a(i, o), o.from = function (t, e, r) {
        if ("number" == typeof t) throw new TypeError("Argument must not be a number");
        return i(t, e, r);
      }, o.alloc = function (t, e, r) {
        if ("number" != typeof t) throw new TypeError("Argument must be a number");
        var n = i(t);
        return void 0 !== e ? "string" == typeof r ? n.fill(e, r) : n.fill(e) : n.fill(0), n;
      }, o.allocUnsafe = function (t) {
        if ("number" != typeof t) throw new TypeError("Argument must be a number");
        return i(t);
      }, o.allocUnsafeSlow = function (t) {
        if ("number" != typeof t) throw new TypeError("Argument must be a number");
        return n.SlowBuffer(t);
      };
    }, {
      buffer: 112
    }],
    547: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        return t < 0 ? -1 : t > 0 ? 1 : 0;
      };
    }, {}],
    548: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        return i(n(t));
      };

      var n = t("boundary-cells"),
          i = t("reduce-simplicial-complex");
    }, {
      "boundary-cells": 102,
      "reduce-simplicial-complex": 527
    }],
    549: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, s) {
        r = r || 0, void 0 === s && (s = function (t) {
          for (var e = t.length, r = 0, n = 0; n < e; ++n) {
            r = 0 | Math.max(r, t[n].length);
          }

          return r - 1;
        }(t));
        if (0 === t.length || s < 1) return {
          cells: [],
          vertexIds: [],
          vertexWeights: []
        };

        var l = function (t, e) {
          for (var r = t.length, n = i.mallocUint8(r), a = 0; a < r; ++a) {
            n[a] = t[a] < e | 0;
          }

          return n;
        }(e, +r),
            c = function (t, e) {
          for (var r = t.length, o = e * (e + 1) / 2 * r | 0, s = i.mallocUint32(2 * o), l = 0, c = 0; c < r; ++c) {
            for (var u = t[c], f = (e = u.length, 0); f < e; ++f) {
              for (var h = 0; h < f; ++h) {
                var p = u[h],
                    d = u[f];
                s[l++] = 0 | Math.min(p, d), s[l++] = 0 | Math.max(p, d);
              }
            }
          }

          a(n(s, [l / 2 | 0, 2]));
          var m = 2;

          for (c = 2; c < l; c += 2) {
            s[c - 2] === s[c] && s[c - 1] === s[c + 1] || (s[m++] = s[c], s[m++] = s[c + 1]);
          }

          return n(s, [m / 2 | 0, 2]);
        }(t, s),
            u = function (t, e, r, a) {
          for (var o = t.data, s = t.shape[0], l = i.mallocDouble(s), c = 0, u = 0; u < s; ++u) {
            var f = o[2 * u],
                h = o[2 * u + 1];

            if (r[f] !== r[h]) {
              var p = e[f],
                  d = e[h];
              o[2 * c] = f, o[2 * c + 1] = h, l[c++] = (d - a) / (d - p);
            }
          }

          return t.shape[0] = c, n(l, [c]);
        }(c, e, l, +r),
            f = function (t, e) {
          var r = i.mallocInt32(2 * e),
              n = t.shape[0],
              a = t.data;
          r[0] = 0;

          for (var o = 0, s = 0; s < n; ++s) {
            var l = a[2 * s];

            if (l !== o) {
              for (r[2 * o + 1] = s; ++o < l;) {
                r[2 * o] = s, r[2 * o + 1] = s;
              }

              r[2 * o] = s;
            }
          }

          r[2 * o + 1] = n;

          for (; ++o < e;) {
            r[2 * o] = r[2 * o + 1] = n;
          }

          return r;
        }(c, 0 | e.length),
            h = o(s)(t, c.data, f, l),
            p = function (t) {
          for (var e = 0 | t.shape[0], r = t.data, n = new Array(e), i = 0; i < e; ++i) {
            n[i] = [r[2 * i], r[2 * i + 1]];
          }

          return n;
        }(c),
            d = [].slice.call(u.data, 0, u.shape[0]);

        return i.free(l), i.free(c.data), i.free(u.data), i.free(f), {
          cells: h,
          vertexIds: p,
          vertexWeights: d
        };
      };

      var n = t("ndarray"),
          i = t("typedarray-pool"),
          a = t("ndarray-sort"),
          o = t("./lib/codegen");
    }, {
      "./lib/codegen": 550,
      ndarray: 475,
      "ndarray-sort": 474,
      "typedarray-pool": 609
    }],
    550: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        var e = a[t];
        e || (e = a[t] = function (t) {
          var e = 0,
              r = new Array(t + 1);
          r[0] = [[]];

          for (var a = 1; a <= t; ++a) {
            for (var o = r[a] = i(a), s = 0; s < o.length; ++s) {
              e = Math.max(e, o[a].length);
            }
          }

          var l = ["function B(C,E,i,j){", "var a=Math.min(i,j)|0,b=Math.max(i,j)|0,l=C[2*a],h=C[2*a+1];", "while(l<h){", "var m=(l+h)>>1,v=E[2*m+1];", "if(v===b){return m}", "if(b<v){h=m}else{l=m+1}", "}", "return l;", "};", "function getContour", t, "d(F,E,C,S){", "var n=F.length,R=[];", "for(var i=0;i<n;++i){var c=F[i],l=c.length;"];

          function c(t) {
            if (!(t.length <= 0)) {
              l.push("R.push(");

              for (var e = 0; e < t.length; ++e) {
                var r = t[e];
                e > 0 && l.push(","), l.push("[");

                for (var n = 0; n < r.length; ++n) {
                  var i = r[n];
                  n > 0 && l.push(","), l.push("B(C,E,c[", i[0], "],c[", i[1], "])");
                }

                l.push("]");
              }

              l.push(");");
            }
          }

          for (a = t + 1; a > 1; --a) {
            a < t + 1 && l.push("else "), l.push("if(l===", a, "){");
            var u = [];

            for (s = 0; s < a; ++s) {
              u.push("(S[c[" + s + "]]<<" + s + ")");
            }

            l.push("var M=", u.join("+"), ";if(M===0||M===", (1 << a) - 1, "){continue}switch(M){");

            for (o = r[a - 1], s = 0; s < o.length; ++s) {
              l.push("case ", s, ":"), c(o[s]), l.push("break;");
            }

            l.push("}}");
          }

          return l.push("}return R;};return getContour", t, "d"), new Function("pool", l.join(""))(n);
        }(t));
        return e;
      };

      var n = t("typedarray-pool"),
          i = t("marching-simplex-table"),
          a = {};
    }, {
      "marching-simplex-table": 453,
      "typedarray-pool": 609
    }],
    551: [function (t, e, r) {
      "use strict";

      var n = t("bit-twiddle"),
          i = t("union-find");

      function a(t, e) {
        var r = t.length,
            n = t.length - e.length,
            i = Math.min;
        if (n) return n;

        switch (r) {
          case 0:
            return 0;

          case 1:
            return t[0] - e[0];

          case 2:
            return (s = t[0] + t[1] - e[0] - e[1]) || i(t[0], t[1]) - i(e[0], e[1]);

          case 3:
            var a = t[0] + t[1],
                o = e[0] + e[1];
            if (s = a + t[2] - (o + e[2])) return s;
            var s,
                l = i(t[0], t[1]),
                c = i(e[0], e[1]);
            return (s = i(l, t[2]) - i(c, e[2])) || i(l + t[2], a) - i(c + e[2], o);

          default:
            var u = t.slice(0);
            u.sort();
            var f = e.slice(0);
            f.sort();

            for (var h = 0; h < r; ++h) {
              if (n = u[h] - f[h]) return n;
            }

            return 0;
        }
      }

      function o(t, e) {
        return a(t[0], e[0]);
      }

      function s(t, e) {
        if (e) {
          for (var r = t.length, n = new Array(r), i = 0; i < r; ++i) {
            n[i] = [t[i], e[i]];
          }

          n.sort(o);

          for (i = 0; i < r; ++i) {
            t[i] = n[i][0], e[i] = n[i][1];
          }

          return t;
        }

        return t.sort(a), t;
      }

      function l(t) {
        if (0 === t.length) return [];

        for (var e = 1, r = t.length, n = 1; n < r; ++n) {
          var i = t[n];

          if (a(i, t[n - 1])) {
            if (n === e) {
              e++;
              continue;
            }

            t[e++] = i;
          }
        }

        return t.length = e, t;
      }

      function c(t, e) {
        for (var r = 0, n = t.length - 1, i = -1; r <= n;) {
          var o = r + n >> 1,
              s = a(t[o], e);
          s <= 0 ? (0 === s && (i = o), r = o + 1) : s > 0 && (n = o - 1);
        }

        return i;
      }

      function u(t, e) {
        for (var r = new Array(t.length), i = 0, o = r.length; i < o; ++i) {
          r[i] = [];
        }

        for (var s = [], l = (i = 0, e.length); i < l; ++i) {
          for (var u = e[i], f = u.length, h = 1, p = 1 << f; h < p; ++h) {
            s.length = n.popCount(h);

            for (var d = 0, m = 0; m < f; ++m) {
              h & 1 << m && (s[d++] = u[m]);
            }

            var g = c(t, s);
            if (!(g < 0)) for (; r[g++].push(i), !(g >= t.length || 0 !== a(t[g], s));) {
              ;
            }
          }
        }

        return r;
      }

      function f(t, e) {
        if (e < 0) return [];

        for (var r = [], i = (1 << e + 1) - 1, a = 0; a < t.length; ++a) {
          for (var o = t[a], l = i; l < 1 << o.length; l = n.nextCombination(l)) {
            for (var c = new Array(e + 1), u = 0, f = 0; f < o.length; ++f) {
              l & 1 << f && (c[u++] = o[f]);
            }

            r.push(c);
          }
        }

        return s(r);
      }

      r.dimension = function (t) {
        for (var e = 0, r = Math.max, n = 0, i = t.length; n < i; ++n) {
          e = r(e, t[n].length);
        }

        return e - 1;
      }, r.countVertices = function (t) {
        for (var e = -1, r = Math.max, n = 0, i = t.length; n < i; ++n) {
          for (var a = t[n], o = 0, s = a.length; o < s; ++o) {
            e = r(e, a[o]);
          }
        }

        return e + 1;
      }, r.cloneCells = function (t) {
        for (var e = new Array(t.length), r = 0, n = t.length; r < n; ++r) {
          e[r] = t[r].slice(0);
        }

        return e;
      }, r.compareCells = a, r.normalize = s, r.unique = l, r.findCell = c, r.incidence = u, r.dual = function (t, e) {
        if (!e) return u(l(f(t, 0)), t);

        for (var r = new Array(e), n = 0; n < e; ++n) {
          r[n] = [];
        }

        n = 0;

        for (var i = t.length; n < i; ++n) {
          for (var a = t[n], o = 0, s = a.length; o < s; ++o) {
            r[a[o]].push(n);
          }
        }

        return r;
      }, r.explode = function (t) {
        for (var e = [], r = 0, n = t.length; r < n; ++r) {
          for (var i = t[r], a = 0 | i.length, o = 1, l = 1 << a; o < l; ++o) {
            for (var c = [], u = 0; u < a; ++u) {
              o >>> u & 1 && c.push(i[u]);
            }

            e.push(c);
          }
        }

        return s(e);
      }, r.skeleton = f, r.boundary = function (t) {
        for (var e = [], r = 0, n = t.length; r < n; ++r) {
          for (var i = t[r], a = 0, o = i.length; a < o; ++a) {
            for (var l = new Array(i.length - 1), c = 0, u = 0; c < o; ++c) {
              c !== a && (l[u++] = i[c]);
            }

            e.push(l);
          }
        }

        return s(e);
      }, r.connectedComponents = function (t, e) {
        return e ? function (t, e) {
          for (var r = new i(e), n = 0; n < t.length; ++n) {
            for (var a = t[n], o = 0; o < a.length; ++o) {
              for (var s = o + 1; s < a.length; ++s) {
                r.link(a[o], a[s]);
              }
            }
          }

          var l = [],
              c = r.ranks;

          for (n = 0; n < c.length; ++n) {
            c[n] = -1;
          }

          for (n = 0; n < t.length; ++n) {
            var u = r.find(t[n][0]);
            c[u] < 0 ? (c[u] = l.length, l.push([t[n].slice(0)])) : l[c[u]].push(t[n].slice(0));
          }

          return l;
        }(t, e) : function (t) {
          for (var e = l(s(f(t, 0))), r = new i(e.length), n = 0; n < t.length; ++n) {
            for (var a = t[n], o = 0; o < a.length; ++o) {
              for (var u = c(e, [a[o]]), h = o + 1; h < a.length; ++h) {
                r.link(u, c(e, [a[h]]));
              }
            }
          }

          var p = [],
              d = r.ranks;

          for (n = 0; n < d.length; ++n) {
            d[n] = -1;
          }

          for (n = 0; n < t.length; ++n) {
            var m = r.find(c(e, [t[n][0]]));
            d[m] < 0 ? (d[m] = p.length, p.push([t[n].slice(0)])) : p[d[m]].push(t[n].slice(0));
          }

          return p;
        }(t);
      };
    }, {
      "bit-twiddle": 99,
      "union-find": 610
    }],
    552: [function (t, e, r) {
      arguments[4][99][0].apply(r, arguments);
    }, {
      dup: 99
    }],
    553: [function (t, e, r) {
      arguments[4][551][0].apply(r, arguments);
    }, {
      "bit-twiddle": 552,
      dup: 551,
      "union-find": 554
    }],
    554: [function (t, e, r) {
      "use strict";

      function n(t) {
        this.roots = new Array(t), this.ranks = new Array(t);

        for (var e = 0; e < t; ++e) {
          this.roots[e] = e, this.ranks[e] = 0;
        }
      }

      e.exports = n, n.prototype.length = function () {
        return this.roots.length;
      }, n.prototype.makeSet = function () {
        var t = this.roots.length;
        return this.roots.push(t), this.ranks.push(0), t;
      }, n.prototype.find = function (t) {
        for (var e = this.roots; e[t] !== t;) {
          var r = e[t];
          e[t] = e[r], t = r;
        }

        return t;
      }, n.prototype.link = function (t, e) {
        var r = this.find(t),
            n = this.find(e);

        if (r !== n) {
          var i = this.ranks,
              a = this.roots,
              o = i[r],
              s = i[n];
          o < s ? a[r] = n : s < o ? a[n] = r : (a[n] = r, ++i[r]);
        }
      };
    }, {}],
    555: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r) {
        for (var a = e.length, o = t.length, s = new Array(a), l = new Array(a), c = new Array(a), u = new Array(a), f = 0; f < a; ++f) {
          s[f] = l[f] = -1, c[f] = 1 / 0, u[f] = !1;
        }

        for (f = 0; f < o; ++f) {
          var h = t[f];
          if (2 !== h.length) throw new Error("Input must be a graph");
          var p = h[1],
              d = h[0];
          -1 !== l[d] ? l[d] = -2 : l[d] = p, -1 !== s[p] ? s[p] = -2 : s[p] = d;
        }

        function m(t) {
          if (u[t]) return 1 / 0;
          var r,
              i,
              a,
              o,
              c,
              f = s[t],
              h = l[t];
          return f < 0 || h < 0 ? 1 / 0 : (r = e[t], i = e[f], a = e[h], o = Math.abs(n(r, i, a)), c = Math.sqrt(Math.pow(i[0] - a[0], 2) + Math.pow(i[1] - a[1], 2)), o / c);
        }

        function g(t, e) {
          var r = k[t],
              n = k[e];
          k[t] = n, k[e] = r, M[r] = e, M[n] = t;
        }

        function v(t) {
          return c[k[t]];
        }

        function y(t) {
          return 1 & t ? t - 1 >> 1 : (t >> 1) - 1;
        }

        function x(t) {
          for (var e = v(t);;) {
            var r = e,
                n = 2 * t + 1,
                i = 2 * (t + 1),
                a = t;

            if (n < A) {
              var o = v(n);
              o < r && (a = n, r = o);
            }

            if (i < A) v(i) < r && (a = i);
            if (a === t) return t;
            g(t, a), t = a;
          }
        }

        function b(t) {
          for (var e = v(t); t > 0;) {
            var r = y(t);
            if (r >= 0) if (e < v(r)) {
              g(t, r), t = r;
              continue;
            }
            return t;
          }
        }

        function _() {
          if (A > 0) {
            var t = k[0];
            return g(0, A - 1), A -= 1, x(0), t;
          }

          return -1;
        }

        function w(t, e) {
          var r = k[t];
          return c[r] === e ? t : (c[r] = -1 / 0, b(t), _(), c[r] = e, b((A += 1) - 1));
        }

        function T(t) {
          if (!u[t]) {
            u[t] = !0;
            var e = s[t],
                r = l[t];
            s[r] >= 0 && (s[r] = e), l[e] >= 0 && (l[e] = r), M[e] >= 0 && w(M[e], m(e)), M[r] >= 0 && w(M[r], m(r));
          }
        }

        var k = [],
            M = new Array(a);

        for (f = 0; f < a; ++f) {
          (c[f] = m(f)) < 1 / 0 ? (M[f] = k.length, k.push(f)) : M[f] = -1;
        }

        var A = k.length;

        for (f = A >> 1; f >= 0; --f) {
          x(f);
        }

        for (;;) {
          var S = _();

          if (S < 0 || c[S] > r) break;
          T(S);
        }

        var E = [];

        for (f = 0; f < a; ++f) {
          u[f] || (M[f] = E.length, E.push(e[f].slice()));
        }

        E.length;

        function L(t, e) {
          if (t[e] < 0) return e;
          var r = e,
              n = e;

          do {
            var i = t[n];
            if (!u[n] || i < 0 || i === n) break;
            if (i = t[n = i], !u[n] || i < 0 || i === n) break;
            n = i, r = t[r];
          } while (r !== n);

          for (var a = e; a !== n; a = t[a]) {
            t[a] = n;
          }

          return n;
        }

        var C = [];
        return t.forEach(function (t) {
          var e = L(s, t[0]),
              r = L(l, t[1]);

          if (e >= 0 && r >= 0 && e !== r) {
            var n = M[e],
                i = M[r];
            n !== i && C.push([n, i]);
          }
        }), i.unique(i.normalize(C)), {
          positions: E,
          edges: C
        };
      };

      var n = t("robust-orientation"),
          i = t("simplicial-complex");
    }, {
      "robust-orientation": 540,
      "simplicial-complex": 553
    }],
    556: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        var r, a, o, s;
        if (e[0][0] < e[1][0]) r = e[0], a = e[1];else {
          if (!(e[0][0] > e[1][0])) return i(e, t);
          r = e[1], a = e[0];
        }
        if (t[0][0] < t[1][0]) o = t[0], s = t[1];else {
          if (!(t[0][0] > t[1][0])) return -i(t, e);
          o = t[1], s = t[0];
        }
        var l = n(r, a, s),
            c = n(r, a, o);

        if (l < 0) {
          if (c <= 0) return l;
        } else if (l > 0) {
          if (c >= 0) return l;
        } else if (c) return c;

        if (l = n(s, o, a), c = n(s, o, r), l < 0) {
          if (c <= 0) return l;
        } else if (l > 0) {
          if (c >= 0) return l;
        } else if (c) return c;

        return a[0] - s[0];
      };

      var n = t("robust-orientation");

      function i(t, e) {
        var r, i, a, o;
        if (e[0][0] < e[1][0]) r = e[0], i = e[1];else {
          if (!(e[0][0] > e[1][0])) {
            var s = Math.min(t[0][1], t[1][1]),
                l = Math.max(t[0][1], t[1][1]),
                c = Math.min(e[0][1], e[1][1]),
                u = Math.max(e[0][1], e[1][1]);
            return l < c ? l - c : s > u ? s - u : l - u;
          }

          r = e[1], i = e[0];
        }
        t[0][1] < t[1][1] ? (a = t[0], o = t[1]) : (a = t[1], o = t[0]);
        var f = n(i, r, a);
        return f || (f = n(i, r, o)) || o - i;
      }
    }, {
      "robust-orientation": 540
    }],
    557: [function (t, e, r) {
      arguments[4][242][0].apply(r, arguments);
    }, {
      dup: 242
    }],
    558: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        for (var e = t.length, r = 2 * e, n = new Array(r), a = 0; a < e; ++a) {
          var l = t[a],
              c = l[0][0] < l[1][0];
          n[2 * a] = new f(l[0][0], l, c, a), n[2 * a + 1] = new f(l[1][0], l, !c, a);
        }

        n.sort(function (t, e) {
          var r = t.x - e.x;
          return r || (r = t.create - e.create) || Math.min(t.segment[0][1], t.segment[1][1]) - Math.min(e.segment[0][1], e.segment[1][1]);
        });
        var h = i(o),
            p = [],
            d = [],
            m = [];

        for (a = 0; a < r;) {
          for (var g = n[a].x, v = []; a < r;) {
            var y = n[a];
            if (y.x !== g) break;
            a += 1, y.segment[0][0] === y.x && y.segment[1][0] === y.x ? y.create && (y.segment[0][1] < y.segment[1][1] ? (v.push(new u(y.segment[0][1], y.index, !0, !0)), v.push(new u(y.segment[1][1], y.index, !1, !1))) : (v.push(new u(y.segment[1][1], y.index, !0, !1)), v.push(new u(y.segment[0][1], y.index, !1, !0)))) : h = y.create ? h.insert(y.segment, y.index) : h.remove(y.segment);
          }

          p.push(h.root), d.push(g), m.push(v);
        }

        return new s(p, d, m);
      };

      var n = t("binary-search-bounds"),
          i = t("functional-red-black-tree"),
          a = t("robust-orientation"),
          o = t("./lib/order-segments");

      function s(t, e, r) {
        this.slabs = t, this.coordinates = e, this.horizontal = r;
      }

      function l(t, e) {
        return t.y - e;
      }

      function c(t, e) {
        for (var r = null; t;) {
          var n,
              i,
              o = t.key;
          o[0][0] < o[1][0] ? (n = o[0], i = o[1]) : (n = o[1], i = o[0]);
          var s = a(n, i, e);
          if (s < 0) t = t.left;else if (s > 0) {
            if (e[0] !== o[1][0]) r = t, t = t.right;else {
              if (l = c(t.right, e)) return l;
              t = t.left;
            }
          } else {
            if (e[0] !== o[1][0]) return t;
            var l;
            if (l = c(t.right, e)) return l;
            t = t.left;
          }
        }

        return r;
      }

      function u(t, e, r, n) {
        this.y = t, this.index = e, this.start = r, this.closed = n;
      }

      function f(t, e, r, n) {
        this.x = t, this.segment = e, this.create = r, this.index = n;
      }

      s.prototype.castUp = function (t) {
        var e = n.le(this.coordinates, t[0]);
        if (e < 0) return -1;
        this.slabs[e];
        var r = c(this.slabs[e], t),
            i = -1;

        if (r && (i = r.value), this.coordinates[e] === t[0]) {
          var s = null;

          if (r && (s = r.key), e > 0) {
            var u = c(this.slabs[e - 1], t);
            u && (s ? o(u.key, s) > 0 && (s = u.key, i = u.value) : (i = u.value, s = u.key));
          }

          var f = this.horizontal[e];

          if (f.length > 0) {
            var h = n.ge(f, t[1], l);

            if (h < f.length) {
              var p = f[h];

              if (t[1] === p.y) {
                if (p.closed) return p.index;

                for (; h < f.length - 1 && f[h + 1].y === t[1];) {
                  if ((p = f[h += 1]).closed) return p.index;
                }

                if (p.y === t[1] && !p.start) {
                  if ((h += 1) >= f.length) return i;
                  p = f[h];
                }
              }

              if (p.start) {
                if (s) {
                  var d = a(s[0], s[1], [t[0], p.y]);
                  s[0][0] > s[1][0] && (d = -d), d > 0 && (i = p.index);
                } else i = p.index;
              } else p.y !== t[1] && (i = p.index);
            }
          }
        }

        return i;
      };
    }, {
      "./lib/order-segments": 556,
      "binary-search-bounds": 557,
      "functional-red-black-tree": 246,
      "robust-orientation": 540
    }],
    559: [function (t, e, r) {
      "use strict";

      var n = t("robust-dot-product"),
          i = t("robust-sum");

      function a(t, e) {
        var r = i(n(t, e), [e[e.length - 1]]);
        return r[r.length - 1];
      }

      function o(t, e, r, n) {
        var i = -e / (n - e);
        i < 0 ? i = 0 : i > 1 && (i = 1);

        for (var a = 1 - i, o = t.length, s = new Array(o), l = 0; l < o; ++l) {
          s[l] = i * t[l] + a * r[l];
        }

        return s;
      }

      e.exports = function (t, e) {
        for (var r = [], n = [], i = a(t[t.length - 1], e), s = t[t.length - 1], l = t[0], c = 0; c < t.length; ++c, s = l) {
          var u = a(l = t[c], e);

          if (i < 0 && u > 0 || i > 0 && u < 0) {
            var f = o(s, u, l, i);
            r.push(f), n.push(f.slice());
          }

          u < 0 ? n.push(l.slice()) : u > 0 ? r.push(l.slice()) : (r.push(l.slice()), n.push(l.slice())), i = u;
        }

        return {
          positive: r,
          negative: n
        };
      }, e.exports.positive = function (t, e) {
        for (var r = [], n = a(t[t.length - 1], e), i = t[t.length - 1], s = t[0], l = 0; l < t.length; ++l, i = s) {
          var c = a(s = t[l], e);
          (n < 0 && c > 0 || n > 0 && c < 0) && r.push(o(i, c, s, n)), c >= 0 && r.push(s.slice()), n = c;
        }

        return r;
      }, e.exports.negative = function (t, e) {
        for (var r = [], n = a(t[t.length - 1], e), i = t[t.length - 1], s = t[0], l = 0; l < t.length; ++l, i = s) {
          var c = a(s = t[l], e);
          (n < 0 && c > 0 || n > 0 && c < 0) && r.push(o(i, c, s, n)), c <= 0 && r.push(s.slice()), n = c;
        }

        return r;
      };
    }, {
      "robust-dot-product": 537,
      "robust-sum": 545
    }],
    560: [function (t, e, r) {
      !function () {
        "use strict";

        var t = {
          not_string: /[^s]/,
          not_bool: /[^t]/,
          not_type: /[^T]/,
          not_primitive: /[^v]/,
          number: /[diefg]/,
          numeric_arg: /[bcdiefguxX]/,
          json: /[j]/,
          not_json: /[^j]/,
          text: /^[^\x25]+/,
          modulo: /^\x25{2}/,
          placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
          key: /^([a-z_][a-z_\d]*)/i,
          key_access: /^\.([a-z_][a-z_\d]*)/i,
          index_access: /^\[(\d+)\]/,
          sign: /^[+-]/
        };

        function e(t) {
          return i(o(t), arguments);
        }

        function n(t, r) {
          return e.apply(null, [t].concat(r || []));
        }

        function i(r, n) {
          var i,
              a,
              o,
              s,
              l,
              c,
              u,
              f,
              h,
              p = 1,
              d = r.length,
              m = "";

          for (a = 0; a < d; a++) {
            if ("string" == typeof r[a]) m += r[a];else if ("object" == _typeof(r[a])) {
              if ((s = r[a]).keys) for (i = n[p], o = 0; o < s.keys.length; o++) {
                if (null == i) throw new Error(e('[sprintf] Cannot access property "%s" of undefined value "%s"', s.keys[o], s.keys[o - 1]));
                i = i[s.keys[o]];
              } else i = s.param_no ? n[s.param_no] : n[p++];
              if (t.not_type.test(s.type) && t.not_primitive.test(s.type) && i instanceof Function && (i = i()), t.numeric_arg.test(s.type) && "number" != typeof i && isNaN(i)) throw new TypeError(e("[sprintf] expecting number but found %T", i));

              switch (t.number.test(s.type) && (f = i >= 0), s.type) {
                case "b":
                  i = parseInt(i, 10).toString(2);
                  break;

                case "c":
                  i = String.fromCharCode(parseInt(i, 10));
                  break;

                case "d":
                case "i":
                  i = parseInt(i, 10);
                  break;

                case "j":
                  i = JSON.stringify(i, null, s.width ? parseInt(s.width) : 0);
                  break;

                case "e":
                  i = s.precision ? parseFloat(i).toExponential(s.precision) : parseFloat(i).toExponential();
                  break;

                case "f":
                  i = s.precision ? parseFloat(i).toFixed(s.precision) : parseFloat(i);
                  break;

                case "g":
                  i = s.precision ? String(Number(i.toPrecision(s.precision))) : parseFloat(i);
                  break;

                case "o":
                  i = (parseInt(i, 10) >>> 0).toString(8);
                  break;

                case "s":
                  i = String(i), i = s.precision ? i.substring(0, s.precision) : i;
                  break;

                case "t":
                  i = String(!!i), i = s.precision ? i.substring(0, s.precision) : i;
                  break;

                case "T":
                  i = Object.prototype.toString.call(i).slice(8, -1).toLowerCase(), i = s.precision ? i.substring(0, s.precision) : i;
                  break;

                case "u":
                  i = parseInt(i, 10) >>> 0;
                  break;

                case "v":
                  i = i.valueOf(), i = s.precision ? i.substring(0, s.precision) : i;
                  break;

                case "x":
                  i = (parseInt(i, 10) >>> 0).toString(16);
                  break;

                case "X":
                  i = (parseInt(i, 10) >>> 0).toString(16).toUpperCase();
              }

              t.json.test(s.type) ? m += i : (!t.number.test(s.type) || f && !s.sign ? h = "" : (h = f ? "+" : "-", i = i.toString().replace(t.sign, "")), c = s.pad_char ? "0" === s.pad_char ? "0" : s.pad_char.charAt(1) : " ", u = s.width - (h + i).length, l = s.width && u > 0 ? c.repeat(u) : "", m += s.align ? h + i + l : "0" === c ? h + l + i : l + h + i);
            }
          }

          return m;
        }

        var a = Object.create(null);

        function o(e) {
          if (a[e]) return a[e];

          for (var r, n = e, i = [], o = 0; n;) {
            if (null !== (r = t.text.exec(n))) i.push(r[0]);else if (null !== (r = t.modulo.exec(n))) i.push("%");else {
              if (null === (r = t.placeholder.exec(n))) throw new SyntaxError("[sprintf] unexpected placeholder");

              if (r[2]) {
                o |= 1;
                var s = [],
                    l = r[2],
                    c = [];
                if (null === (c = t.key.exec(l))) throw new SyntaxError("[sprintf] failed to parse named argument key");

                for (s.push(c[1]); "" !== (l = l.substring(c[0].length));) {
                  if (null !== (c = t.key_access.exec(l))) s.push(c[1]);else {
                    if (null === (c = t.index_access.exec(l))) throw new SyntaxError("[sprintf] failed to parse named argument key");
                    s.push(c[1]);
                  }
                }

                r[2] = s;
              } else o |= 2;

              if (3 === o) throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
              i.push({
                placeholder: r[0],
                param_no: r[1],
                keys: r[2],
                sign: r[3],
                pad_char: r[4],
                align: r[5],
                width: r[6],
                precision: r[7],
                type: r[8]
              });
            }
            n = n.substring(r[0].length);
          }

          return a[e] = i;
        }

        void 0 !== r && (r.sprintf = e, r.vsprintf = n), "undefined" != typeof window && (window.sprintf = e, window.vsprintf = n);
      }();
    }, {}],
    561: [function (t, e, r) {
      e.exports = i;
      var n = t("events").EventEmitter;

      function i() {
        n.call(this);
      }

      t("inherits")(i, n), i.Readable = t("readable-stream/lib/_stream_readable.js"), i.Writable = t("readable-stream/lib/_stream_writable.js"), i.Duplex = t("readable-stream/lib/_stream_duplex.js"), i.Transform = t("readable-stream/lib/_stream_transform.js"), i.PassThrough = t("readable-stream/lib/_stream_passthrough.js"), i.finished = t("readable-stream/lib/internal/streams/end-of-stream.js"), i.pipeline = t("readable-stream/lib/internal/streams/pipeline.js"), i.Stream = i, i.prototype.pipe = function (t, e) {
        var r = this;

        function i(e) {
          t.writable && !1 === t.write(e) && r.pause && r.pause();
        }

        function a() {
          r.readable && r.resume && r.resume();
        }

        r.on("data", i), t.on("drain", a), t._isStdio || e && !1 === e.end || (r.on("end", s), r.on("close", l));
        var o = !1;

        function s() {
          o || (o = !0, t.end());
        }

        function l() {
          o || (o = !0, "function" == typeof t.destroy && t.destroy());
        }

        function c(t) {
          if (u(), 0 === n.listenerCount(this, "error")) throw t;
        }

        function u() {
          r.removeListener("data", i), t.removeListener("drain", a), r.removeListener("end", s), r.removeListener("close", l), r.removeListener("error", c), t.removeListener("error", c), r.removeListener("end", u), r.removeListener("close", u), t.removeListener("close", u);
        }

        return r.on("error", c), t.on("error", c), r.on("end", u), r.on("close", u), t.on("close", u), t.emit("pipe", r), t;
      };
    }, {
      events: 111,
      inherits: 438,
      "readable-stream/lib/_stream_duplex.js": 563,
      "readable-stream/lib/_stream_passthrough.js": 564,
      "readable-stream/lib/_stream_readable.js": 565,
      "readable-stream/lib/_stream_transform.js": 566,
      "readable-stream/lib/_stream_writable.js": 567,
      "readable-stream/lib/internal/streams/end-of-stream.js": 571,
      "readable-stream/lib/internal/streams/pipeline.js": 573
    }],
    562: [function (t, e, r) {
      "use strict";

      var n = {};

      function i(t, e, r) {
        r || (r = Error);

        var i = function (t) {
          var r, n;

          function i(r, n, i) {
            return t.call(this, function (t, r, n) {
              return "string" == typeof e ? e : e(t, r, n);
            }(r, n, i)) || this;
          }

          return n = t, (r = i).prototype = Object.create(n.prototype), r.prototype.constructor = r, r.__proto__ = n, i;
        }(r);

        i.prototype.name = r.name, i.prototype.code = t, n[t] = i;
      }

      function a(t, e) {
        if (Array.isArray(t)) {
          var r = t.length;
          return t = t.map(function (t) {
            return String(t);
          }), r > 2 ? "one of ".concat(e, " ").concat(t.slice(0, r - 1).join(", "), ", or ") + t[r - 1] : 2 === r ? "one of ".concat(e, " ").concat(t[0], " or ").concat(t[1]) : "of ".concat(e, " ").concat(t[0]);
        }

        return "of ".concat(e, " ").concat(String(t));
      }

      i("ERR_INVALID_OPT_VALUE", function (t, e) {
        return 'The value "' + e + '" is invalid for option "' + t + '"';
      }, TypeError), i("ERR_INVALID_ARG_TYPE", function (t, e, r) {
        var n, i, o, s;
        if ("string" == typeof e && (i = "not ", e.substr(!o || o < 0 ? 0 : +o, i.length) === i) ? (n = "must not be", e = e.replace(/^not /, "")) : n = "must be", function (t, e, r) {
          return (void 0 === r || r > t.length) && (r = t.length), t.substring(r - e.length, r) === e;
        }(t, " argument")) s = "The ".concat(t, " ").concat(n, " ").concat(a(e, "type"));else {
          var l = function (t, e, r) {
            return "number" != typeof r && (r = 0), !(r + e.length > t.length) && -1 !== t.indexOf(e, r);
          }(t, ".") ? "property" : "argument";
          s = 'The "'.concat(t, '" ').concat(l, " ").concat(n, " ").concat(a(e, "type"));
        }
        return s += ". Received type ".concat(_typeof(r));
      }, TypeError), i("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), i("ERR_METHOD_NOT_IMPLEMENTED", function (t) {
        return "The " + t + " method is not implemented";
      }), i("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), i("ERR_STREAM_DESTROYED", function (t) {
        return "Cannot call " + t + " after a stream was destroyed";
      }), i("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), i("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), i("ERR_STREAM_WRITE_AFTER_END", "write after end"), i("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), i("ERR_UNKNOWN_ENCODING", function (t) {
        return "Unknown encoding: " + t;
      }, TypeError), i("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), e.exports.codes = n;
    }, {}],
    563: [function (t, e, r) {
      (function (r) {
        (function () {
          "use strict";

          var n = Object.keys || function (t) {
            var e = [];

            for (var r in t) {
              e.push(r);
            }

            return e;
          };

          e.exports = c;
          var i = t("./_stream_readable"),
              a = t("./_stream_writable");
          t("inherits")(c, i);

          for (var o = n(a.prototype), s = 0; s < o.length; s++) {
            var l = o[s];
            c.prototype[l] || (c.prototype[l] = a.prototype[l]);
          }

          function c(t) {
            if (!(this instanceof c)) return new c(t);
            i.call(this, t), a.call(this, t), this.allowHalfOpen = !0, t && (!1 === t.readable && (this.readable = !1), !1 === t.writable && (this.writable = !1), !1 === t.allowHalfOpen && (this.allowHalfOpen = !1, this.once("end", u)));
          }

          function u() {
            this._writableState.ended || r.nextTick(f, this);
          }

          function f(t) {
            t.end();
          }

          Object.defineProperty(c.prototype, "writableHighWaterMark", {
            enumerable: !1,
            get: function get() {
              return this._writableState.highWaterMark;
            }
          }), Object.defineProperty(c.prototype, "writableBuffer", {
            enumerable: !1,
            get: function get() {
              return this._writableState && this._writableState.getBuffer();
            }
          }), Object.defineProperty(c.prototype, "writableLength", {
            enumerable: !1,
            get: function get() {
              return this._writableState.length;
            }
          }), Object.defineProperty(c.prototype, "destroyed", {
            enumerable: !1,
            get: function get() {
              return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
            },
            set: function set(t) {
              void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = t, this._writableState.destroyed = t);
            }
          });
        }).call(this);
      }).call(this, t("_process"));
    }, {
      "./_stream_readable": 565,
      "./_stream_writable": 567,
      _process: 520,
      inherits: 438
    }],
    564: [function (t, e, r) {
      "use strict";

      e.exports = i;
      var n = t("./_stream_transform");

      function i(t) {
        if (!(this instanceof i)) return new i(t);
        n.call(this, t);
      }

      t("inherits")(i, n), i.prototype._transform = function (t, e, r) {
        r(null, t);
      };
    }, {
      "./_stream_transform": 566,
      inherits: 438
    }],
    565: [function (t, e, r) {
      (function (r, n) {
        (function () {
          "use strict";

          var i;
          e.exports = M, M.ReadableState = k;
          t("events").EventEmitter;

          var a = function a(t, e) {
            return t.listeners(e).length;
          },
              o = t("./internal/streams/stream"),
              s = t("buffer").Buffer,
              l = n.Uint8Array || function () {};

          var c,
              u = t("util");
          c = u && u.debuglog ? u.debuglog("stream") : function () {};
          var f,
              h,
              p,
              d = t("./internal/streams/buffer_list"),
              m = t("./internal/streams/destroy"),
              g = t("./internal/streams/state").getHighWaterMark,
              v = t("../errors").codes,
              y = v.ERR_INVALID_ARG_TYPE,
              x = v.ERR_STREAM_PUSH_AFTER_EOF,
              b = v.ERR_METHOD_NOT_IMPLEMENTED,
              _ = v.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
          t("inherits")(M, o);
          var w = m.errorOrDestroy,
              T = ["error", "close", "destroy", "pause", "resume"];

          function k(e, r, n) {
            i = i || t("./_stream_duplex"), e = e || {}, "boolean" != typeof n && (n = r instanceof i), this.objectMode = !!e.objectMode, n && (this.objectMode = this.objectMode || !!e.readableObjectMode), this.highWaterMark = g(this, e, "readableHighWaterMark", n), this.buffer = new d(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = !1 !== e.emitClose, this.autoDestroy = !!e.autoDestroy, this.destroyed = !1, this.defaultEncoding = e.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, e.encoding && (f || (f = t("string_decoder/").StringDecoder), this.decoder = new f(e.encoding), this.encoding = e.encoding);
          }

          function M(e) {
            if (i = i || t("./_stream_duplex"), !(this instanceof M)) return new M(e);
            var r = this instanceof i;
            this._readableState = new k(e, this, r), this.readable = !0, e && ("function" == typeof e.read && (this._read = e.read), "function" == typeof e.destroy && (this._destroy = e.destroy)), o.call(this);
          }

          function A(t, e, r, n, i) {
            c("readableAddChunk", e);
            var a,
                o = t._readableState;
            if (null === e) o.reading = !1, function (t, e) {
              if (c("onEofChunk"), e.ended) return;

              if (e.decoder) {
                var r = e.decoder.end();
                r && r.length && (e.buffer.push(r), e.length += e.objectMode ? 1 : r.length);
              }

              e.ended = !0, e.sync ? L(t) : (e.needReadable = !1, e.emittedReadable || (e.emittedReadable = !0, C(t)));
            }(t, o);else if (i || (a = function (t, e) {
              var r;
              n = e, s.isBuffer(n) || n instanceof l || "string" == typeof e || void 0 === e || t.objectMode || (r = new y("chunk", ["string", "Buffer", "Uint8Array"], e));
              var n;
              return r;
            }(o, e)), a) w(t, a);else if (o.objectMode || e && e.length > 0) {
              if ("string" == typeof e || o.objectMode || Object.getPrototypeOf(e) === s.prototype || (e = function (t) {
                return s.from(t);
              }(e)), n) o.endEmitted ? w(t, new _()) : S(t, o, e, !0);else if (o.ended) w(t, new x());else {
                if (o.destroyed) return !1;
                o.reading = !1, o.decoder && !r ? (e = o.decoder.write(e), o.objectMode || 0 !== e.length ? S(t, o, e, !1) : P(t, o)) : S(t, o, e, !1);
              }
            } else n || (o.reading = !1, P(t, o));
            return !o.ended && (o.length < o.highWaterMark || 0 === o.length);
          }

          function S(t, e, r, n) {
            e.flowing && 0 === e.length && !e.sync ? (e.awaitDrain = 0, t.emit("data", r)) : (e.length += e.objectMode ? 1 : r.length, n ? e.buffer.unshift(r) : e.buffer.push(r), e.needReadable && L(t)), P(t, e);
          }

          Object.defineProperty(M.prototype, "destroyed", {
            enumerable: !1,
            get: function get() {
              return void 0 !== this._readableState && this._readableState.destroyed;
            },
            set: function set(t) {
              this._readableState && (this._readableState.destroyed = t);
            }
          }), M.prototype.destroy = m.destroy, M.prototype._undestroy = m.undestroy, M.prototype._destroy = function (t, e) {
            e(t);
          }, M.prototype.push = function (t, e) {
            var r,
                n = this._readableState;
            return n.objectMode ? r = !0 : "string" == typeof t && ((e = e || n.defaultEncoding) !== n.encoding && (t = s.from(t, e), e = ""), r = !0), A(this, t, e, !1, r);
          }, M.prototype.unshift = function (t) {
            return A(this, t, null, !0, !1);
          }, M.prototype.isPaused = function () {
            return !1 === this._readableState.flowing;
          }, M.prototype.setEncoding = function (e) {
            f || (f = t("string_decoder/").StringDecoder);
            var r = new f(e);
            this._readableState.decoder = r, this._readableState.encoding = this._readableState.decoder.encoding;

            for (var n = this._readableState.buffer.head, i = ""; null !== n;) {
              i += r.write(n.data), n = n.next;
            }

            return this._readableState.buffer.clear(), "" !== i && this._readableState.buffer.push(i), this._readableState.length = i.length, this;
          };

          function E(t, e) {
            return t <= 0 || 0 === e.length && e.ended ? 0 : e.objectMode ? 1 : t != t ? e.flowing && e.length ? e.buffer.head.data.length : e.length : (t > e.highWaterMark && (e.highWaterMark = function (t) {
              return t >= 1073741824 ? t = 1073741824 : (t--, t |= t >>> 1, t |= t >>> 2, t |= t >>> 4, t |= t >>> 8, t |= t >>> 16, t++), t;
            }(t)), t <= e.length ? t : e.ended ? e.length : (e.needReadable = !0, 0));
          }

          function L(t) {
            var e = t._readableState;
            c("emitReadable", e.needReadable, e.emittedReadable), e.needReadable = !1, e.emittedReadable || (c("emitReadable", e.flowing), e.emittedReadable = !0, r.nextTick(C, t));
          }

          function C(t) {
            var e = t._readableState;
            c("emitReadable_", e.destroyed, e.length, e.ended), e.destroyed || !e.length && !e.ended || (t.emit("readable"), e.emittedReadable = !1), e.needReadable = !e.flowing && !e.ended && e.length <= e.highWaterMark, R(t);
          }

          function P(t, e) {
            e.readingMore || (e.readingMore = !0, r.nextTick(I, t, e));
          }

          function I(t, e) {
            for (; !e.reading && !e.ended && (e.length < e.highWaterMark || e.flowing && 0 === e.length);) {
              var r = e.length;
              if (c("maybeReadMore read 0"), t.read(0), r === e.length) break;
            }

            e.readingMore = !1;
          }

          function O(t) {
            var e = t._readableState;
            e.readableListening = t.listenerCount("readable") > 0, e.resumeScheduled && !e.paused ? e.flowing = !0 : t.listenerCount("data") > 0 && t.resume();
          }

          function z(t) {
            c("readable nexttick read 0"), t.read(0);
          }

          function D(t, e) {
            c("resume", e.reading), e.reading || t.read(0), e.resumeScheduled = !1, t.emit("resume"), R(t), e.flowing && !e.reading && t.read(0);
          }

          function R(t) {
            var e = t._readableState;

            for (c("flow", e.flowing); e.flowing && null !== t.read();) {
              ;
            }
          }

          function F(t, e) {
            return 0 === e.length ? null : (e.objectMode ? r = e.buffer.shift() : !t || t >= e.length ? (r = e.decoder ? e.buffer.join("") : 1 === e.buffer.length ? e.buffer.first() : e.buffer.concat(e.length), e.buffer.clear()) : r = e.buffer.consume(t, e.decoder), r);
            var r;
          }

          function B(t) {
            var e = t._readableState;
            c("endReadable", e.endEmitted), e.endEmitted || (e.ended = !0, r.nextTick(N, e, t));
          }

          function N(t, e) {
            if (c("endReadableNT", t.endEmitted, t.length), !t.endEmitted && 0 === t.length && (t.endEmitted = !0, e.readable = !1, e.emit("end"), t.autoDestroy)) {
              var r = e._writableState;
              (!r || r.autoDestroy && r.finished) && e.destroy();
            }
          }

          function j(t, e) {
            for (var r = 0, n = t.length; r < n; r++) {
              if (t[r] === e) return r;
            }

            return -1;
          }

          M.prototype.read = function (t) {
            c("read", t), t = parseInt(t, 10);
            var e = this._readableState,
                r = t;
            if (0 !== t && (e.emittedReadable = !1), 0 === t && e.needReadable && ((0 !== e.highWaterMark ? e.length >= e.highWaterMark : e.length > 0) || e.ended)) return c("read: emitReadable", e.length, e.ended), 0 === e.length && e.ended ? B(this) : L(this), null;
            if (0 === (t = E(t, e)) && e.ended) return 0 === e.length && B(this), null;
            var n,
                i = e.needReadable;
            return c("need readable", i), (0 === e.length || e.length - t < e.highWaterMark) && c("length less than watermark", i = !0), e.ended || e.reading ? c("reading or ended", i = !1) : i && (c("do read"), e.reading = !0, e.sync = !0, 0 === e.length && (e.needReadable = !0), this._read(e.highWaterMark), e.sync = !1, e.reading || (t = E(r, e))), null === (n = t > 0 ? F(t, e) : null) ? (e.needReadable = e.length <= e.highWaterMark, t = 0) : (e.length -= t, e.awaitDrain = 0), 0 === e.length && (e.ended || (e.needReadable = !0), r !== t && e.ended && B(this)), null !== n && this.emit("data", n), n;
          }, M.prototype._read = function (t) {
            w(this, new b("_read()"));
          }, M.prototype.pipe = function (t, e) {
            var n = this,
                i = this._readableState;

            switch (i.pipesCount) {
              case 0:
                i.pipes = t;
                break;

              case 1:
                i.pipes = [i.pipes, t];
                break;

              default:
                i.pipes.push(t);
            }

            i.pipesCount += 1, c("pipe count=%d opts=%j", i.pipesCount, e);
            var o = (!e || !1 !== e.end) && t !== r.stdout && t !== r.stderr ? l : g;

            function s(e, r) {
              c("onunpipe"), e === n && r && !1 === r.hasUnpiped && (r.hasUnpiped = !0, c("cleanup"), t.removeListener("close", d), t.removeListener("finish", m), t.removeListener("drain", u), t.removeListener("error", p), t.removeListener("unpipe", s), n.removeListener("end", l), n.removeListener("end", g), n.removeListener("data", h), f = !0, !i.awaitDrain || t._writableState && !t._writableState.needDrain || u());
            }

            function l() {
              c("onend"), t.end();
            }

            i.endEmitted ? r.nextTick(o) : n.once("end", o), t.on("unpipe", s);

            var u = function (t) {
              return function () {
                var e = t._readableState;
                c("pipeOnDrain", e.awaitDrain), e.awaitDrain && e.awaitDrain--, 0 === e.awaitDrain && a(t, "data") && (e.flowing = !0, R(t));
              };
            }(n);

            t.on("drain", u);
            var f = !1;

            function h(e) {
              c("ondata");
              var r = t.write(e);
              c("dest.write", r), !1 === r && ((1 === i.pipesCount && i.pipes === t || i.pipesCount > 1 && -1 !== j(i.pipes, t)) && !f && (c("false write response, pause", i.awaitDrain), i.awaitDrain++), n.pause());
            }

            function p(e) {
              c("onerror", e), g(), t.removeListener("error", p), 0 === a(t, "error") && w(t, e);
            }

            function d() {
              t.removeListener("finish", m), g();
            }

            function m() {
              c("onfinish"), t.removeListener("close", d), g();
            }

            function g() {
              c("unpipe"), n.unpipe(t);
            }

            return n.on("data", h), function (t, e, r) {
              if ("function" == typeof t.prependListener) return t.prependListener(e, r);
              t._events && t._events[e] ? Array.isArray(t._events[e]) ? t._events[e].unshift(r) : t._events[e] = [r, t._events[e]] : t.on(e, r);
            }(t, "error", p), t.once("close", d), t.once("finish", m), t.emit("pipe", n), i.flowing || (c("pipe resume"), n.resume()), t;
          }, M.prototype.unpipe = function (t) {
            var e = this._readableState,
                r = {
              hasUnpiped: !1
            };
            if (0 === e.pipesCount) return this;
            if (1 === e.pipesCount) return t && t !== e.pipes || (t || (t = e.pipes), e.pipes = null, e.pipesCount = 0, e.flowing = !1, t && t.emit("unpipe", this, r)), this;

            if (!t) {
              var n = e.pipes,
                  i = e.pipesCount;
              e.pipes = null, e.pipesCount = 0, e.flowing = !1;

              for (var a = 0; a < i; a++) {
                n[a].emit("unpipe", this, {
                  hasUnpiped: !1
                });
              }

              return this;
            }

            var o = j(e.pipes, t);
            return -1 === o || (e.pipes.splice(o, 1), e.pipesCount -= 1, 1 === e.pipesCount && (e.pipes = e.pipes[0]), t.emit("unpipe", this, r)), this;
          }, M.prototype.on = function (t, e) {
            var n = o.prototype.on.call(this, t, e),
                i = this._readableState;
            return "data" === t ? (i.readableListening = this.listenerCount("readable") > 0, !1 !== i.flowing && this.resume()) : "readable" === t && (i.endEmitted || i.readableListening || (i.readableListening = i.needReadable = !0, i.flowing = !1, i.emittedReadable = !1, c("on readable", i.length, i.reading), i.length ? L(this) : i.reading || r.nextTick(z, this))), n;
          }, M.prototype.addListener = M.prototype.on, M.prototype.removeListener = function (t, e) {
            var n = o.prototype.removeListener.call(this, t, e);
            return "readable" === t && r.nextTick(O, this), n;
          }, M.prototype.removeAllListeners = function (t) {
            var e = o.prototype.removeAllListeners.apply(this, arguments);
            return "readable" !== t && void 0 !== t || r.nextTick(O, this), e;
          }, M.prototype.resume = function () {
            var t = this._readableState;
            return t.flowing || (c("resume"), t.flowing = !t.readableListening, function (t, e) {
              e.resumeScheduled || (e.resumeScheduled = !0, r.nextTick(D, t, e));
            }(this, t)), t.paused = !1, this;
          }, M.prototype.pause = function () {
            return c("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (c("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
          }, M.prototype.wrap = function (t) {
            var e = this,
                r = this._readableState,
                n = !1;

            for (var i in t.on("end", function () {
              if (c("wrapped end"), r.decoder && !r.ended) {
                var t = r.decoder.end();
                t && t.length && e.push(t);
              }

              e.push(null);
            }), t.on("data", function (i) {
              (c("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i) || (r.objectMode || i && i.length) && (e.push(i) || (n = !0, t.pause()));
            }), t) {
              void 0 === this[i] && "function" == typeof t[i] && (this[i] = function (e) {
                return function () {
                  return t[e].apply(t, arguments);
                };
              }(i));
            }

            for (var a = 0; a < T.length; a++) {
              t.on(T[a], this.emit.bind(this, T[a]));
            }

            return this._read = function (e) {
              c("wrapped _read", e), n && (n = !1, t.resume());
            }, this;
          }, "function" == typeof Symbol && (M.prototype[Symbol.asyncIterator] = function () {
            return void 0 === h && (h = t("./internal/streams/async_iterator")), h(this);
          }), Object.defineProperty(M.prototype, "readableHighWaterMark", {
            enumerable: !1,
            get: function get() {
              return this._readableState.highWaterMark;
            }
          }), Object.defineProperty(M.prototype, "readableBuffer", {
            enumerable: !1,
            get: function get() {
              return this._readableState && this._readableState.buffer;
            }
          }), Object.defineProperty(M.prototype, "readableFlowing", {
            enumerable: !1,
            get: function get() {
              return this._readableState.flowing;
            },
            set: function set(t) {
              this._readableState && (this._readableState.flowing = t);
            }
          }), M._fromList = F, Object.defineProperty(M.prototype, "readableLength", {
            enumerable: !1,
            get: function get() {
              return this._readableState.length;
            }
          }), "function" == typeof Symbol && (M.from = function (e, r) {
            return void 0 === p && (p = t("./internal/streams/from")), p(M, e, r);
          });
        }).call(this);
      }).call(this, t("_process"), "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
    }, {
      "../errors": 562,
      "./_stream_duplex": 563,
      "./internal/streams/async_iterator": 568,
      "./internal/streams/buffer_list": 569,
      "./internal/streams/destroy": 570,
      "./internal/streams/from": 572,
      "./internal/streams/state": 574,
      "./internal/streams/stream": 575,
      _process: 520,
      buffer: 112,
      events: 111,
      inherits: 438,
      "string_decoder/": 576,
      util: 110
    }],
    566: [function (t, e, r) {
      "use strict";

      e.exports = u;
      var n = t("../errors").codes,
          i = n.ERR_METHOD_NOT_IMPLEMENTED,
          a = n.ERR_MULTIPLE_CALLBACK,
          o = n.ERR_TRANSFORM_ALREADY_TRANSFORMING,
          s = n.ERR_TRANSFORM_WITH_LENGTH_0,
          l = t("./_stream_duplex");

      function c(t, e) {
        var r = this._transformState;
        r.transforming = !1;
        var n = r.writecb;
        if (null === n) return this.emit("error", new a());
        r.writechunk = null, r.writecb = null, null != e && this.push(e), n(t);
        var i = this._readableState;
        i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
      }

      function u(t) {
        if (!(this instanceof u)) return new u(t);
        l.call(this, t), this._transformState = {
          afterTransform: c.bind(this),
          needTransform: !1,
          transforming: !1,
          writecb: null,
          writechunk: null,
          writeencoding: null
        }, this._readableState.needReadable = !0, this._readableState.sync = !1, t && ("function" == typeof t.transform && (this._transform = t.transform), "function" == typeof t.flush && (this._flush = t.flush)), this.on("prefinish", f);
      }

      function f() {
        var t = this;
        "function" != typeof this._flush || this._readableState.destroyed ? h(this, null, null) : this._flush(function (e, r) {
          h(t, e, r);
        });
      }

      function h(t, e, r) {
        if (e) return t.emit("error", e);
        if (null != r && t.push(r), t._writableState.length) throw new s();
        if (t._transformState.transforming) throw new o();
        return t.push(null);
      }

      t("inherits")(u, l), u.prototype.push = function (t, e) {
        return this._transformState.needTransform = !1, l.prototype.push.call(this, t, e);
      }, u.prototype._transform = function (t, e, r) {
        r(new i("_transform()"));
      }, u.prototype._write = function (t, e, r) {
        var n = this._transformState;

        if (n.writecb = r, n.writechunk = t, n.writeencoding = e, !n.transforming) {
          var i = this._readableState;
          (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
        }
      }, u.prototype._read = function (t) {
        var e = this._transformState;
        null === e.writechunk || e.transforming ? e.needTransform = !0 : (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform));
      }, u.prototype._destroy = function (t, e) {
        l.prototype._destroy.call(this, t, function (t) {
          e(t);
        });
      };
    }, {
      "../errors": 562,
      "./_stream_duplex": 563,
      inherits: 438
    }],
    567: [function (t, e, r) {
      (function (r, n) {
        (function () {
          "use strict";

          function i(t) {
            var e = this;
            this.next = null, this.entry = null, this.finish = function () {
              !function (t, e, r) {
                var n = t.entry;
                t.entry = null;

                for (; n;) {
                  var i = n.callback;
                  e.pendingcb--, i(r), n = n.next;
                }

                e.corkedRequestsFree.next = t;
              }(e, t);
            };
          }

          var a;
          e.exports = M, M.WritableState = k;

          var o = {
            deprecate: t("util-deprecate")
          },
              s = t("./internal/streams/stream"),
              l = t("buffer").Buffer,
              c = n.Uint8Array || function () {};

          var u,
              f = t("./internal/streams/destroy"),
              h = t("./internal/streams/state").getHighWaterMark,
              p = t("../errors").codes,
              d = p.ERR_INVALID_ARG_TYPE,
              m = p.ERR_METHOD_NOT_IMPLEMENTED,
              g = p.ERR_MULTIPLE_CALLBACK,
              v = p.ERR_STREAM_CANNOT_PIPE,
              y = p.ERR_STREAM_DESTROYED,
              x = p.ERR_STREAM_NULL_VALUES,
              b = p.ERR_STREAM_WRITE_AFTER_END,
              _ = p.ERR_UNKNOWN_ENCODING,
              w = f.errorOrDestroy;

          function T() {}

          function k(e, n, o) {
            a = a || t("./_stream_duplex"), e = e || {}, "boolean" != typeof o && (o = n instanceof a), this.objectMode = !!e.objectMode, o && (this.objectMode = this.objectMode || !!e.writableObjectMode), this.highWaterMark = h(this, e, "writableHighWaterMark", o), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
            var s = !1 === e.decodeStrings;
            this.decodeStrings = !s, this.defaultEncoding = e.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function (t) {
              !function (t, e) {
                var n = t._writableState,
                    i = n.sync,
                    a = n.writecb;
                if ("function" != typeof a) throw new g();
                if (function (t) {
                  t.writing = !1, t.writecb = null, t.length -= t.writelen, t.writelen = 0;
                }(n), e) !function (t, e, n, i, a) {
                  --e.pendingcb, n ? (r.nextTick(a, i), r.nextTick(P, t, e), t._writableState.errorEmitted = !0, w(t, i)) : (a(i), t._writableState.errorEmitted = !0, w(t, i), P(t, e));
                }(t, n, i, e, a);else {
                  var o = L(n) || t.destroyed;
                  o || n.corked || n.bufferProcessing || !n.bufferedRequest || E(t, n), i ? r.nextTick(S, t, n, o, a) : S(t, n, o, a);
                }
              }(n, t);
            }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = !1 !== e.emitClose, this.autoDestroy = !!e.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new i(this);
          }

          function M(e) {
            var r = this instanceof (a = a || t("./_stream_duplex"));
            if (!r && !u.call(M, this)) return new M(e);
            this._writableState = new k(e, this, r), this.writable = !0, e && ("function" == typeof e.write && (this._write = e.write), "function" == typeof e.writev && (this._writev = e.writev), "function" == typeof e.destroy && (this._destroy = e.destroy), "function" == typeof e.final && (this._final = e.final)), s.call(this);
          }

          function A(t, e, r, n, i, a, o) {
            e.writelen = n, e.writecb = o, e.writing = !0, e.sync = !0, e.destroyed ? e.onwrite(new y("write")) : r ? t._writev(i, e.onwrite) : t._write(i, a, e.onwrite), e.sync = !1;
          }

          function S(t, e, r, n) {
            r || function (t, e) {
              0 === e.length && e.needDrain && (e.needDrain = !1, t.emit("drain"));
            }(t, e), e.pendingcb--, n(), P(t, e);
          }

          function E(t, e) {
            e.bufferProcessing = !0;
            var r = e.bufferedRequest;

            if (t._writev && r && r.next) {
              var n = e.bufferedRequestCount,
                  a = new Array(n),
                  o = e.corkedRequestsFree;
              o.entry = r;

              for (var s = 0, l = !0; r;) {
                a[s] = r, r.isBuf || (l = !1), r = r.next, s += 1;
              }

              a.allBuffers = l, A(t, e, !0, e.length, a, "", o.finish), e.pendingcb++, e.lastBufferedRequest = null, o.next ? (e.corkedRequestsFree = o.next, o.next = null) : e.corkedRequestsFree = new i(e), e.bufferedRequestCount = 0;
            } else {
              for (; r;) {
                var c = r.chunk,
                    u = r.encoding,
                    f = r.callback;
                if (A(t, e, !1, e.objectMode ? 1 : c.length, c, u, f), r = r.next, e.bufferedRequestCount--, e.writing) break;
              }

              null === r && (e.lastBufferedRequest = null);
            }

            e.bufferedRequest = r, e.bufferProcessing = !1;
          }

          function L(t) {
            return t.ending && 0 === t.length && null === t.bufferedRequest && !t.finished && !t.writing;
          }

          function C(t, e) {
            t._final(function (r) {
              e.pendingcb--, r && w(t, r), e.prefinished = !0, t.emit("prefinish"), P(t, e);
            });
          }

          function P(t, e) {
            var n = L(e);

            if (n && (function (t, e) {
              e.prefinished || e.finalCalled || ("function" != typeof t._final || e.destroyed ? (e.prefinished = !0, t.emit("prefinish")) : (e.pendingcb++, e.finalCalled = !0, r.nextTick(C, t, e)));
            }(t, e), 0 === e.pendingcb && (e.finished = !0, t.emit("finish"), e.autoDestroy))) {
              var i = t._readableState;
              (!i || i.autoDestroy && i.endEmitted) && t.destroy();
            }

            return n;
          }

          t("inherits")(M, s), k.prototype.getBuffer = function () {
            for (var t = this.bufferedRequest, e = []; t;) {
              e.push(t), t = t.next;
            }

            return e;
          }, function () {
            try {
              Object.defineProperty(k.prototype, "buffer", {
                get: o.deprecate(function () {
                  return this.getBuffer();
                }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
              });
            } catch (t) {}
          }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (u = Function.prototype[Symbol.hasInstance], Object.defineProperty(M, Symbol.hasInstance, {
            value: function value(t) {
              return !!u.call(this, t) || this === M && t && t._writableState instanceof k;
            }
          })) : u = function u(t) {
            return t instanceof this;
          }, M.prototype.pipe = function () {
            w(this, new v());
          }, M.prototype.write = function (t, e, n) {
            var i,
                a = this._writableState,
                o = !1,
                s = !a.objectMode && (i = t, l.isBuffer(i) || i instanceof c);
            return s && !l.isBuffer(t) && (t = function (t) {
              return l.from(t);
            }(t)), "function" == typeof e && (n = e, e = null), s ? e = "buffer" : e || (e = a.defaultEncoding), "function" != typeof n && (n = T), a.ending ? function (t, e) {
              var n = new b();
              w(t, n), r.nextTick(e, n);
            }(this, n) : (s || function (t, e, n, i) {
              var a;
              return null === n ? a = new x() : "string" == typeof n || e.objectMode || (a = new d("chunk", ["string", "Buffer"], n)), !a || (w(t, a), r.nextTick(i, a), !1);
            }(this, a, t, n)) && (a.pendingcb++, o = function (t, e, r, n, i, a) {
              if (!r) {
                var o = function (t, e, r) {
                  t.objectMode || !1 === t.decodeStrings || "string" != typeof e || (e = l.from(e, r));
                  return e;
                }(e, n, i);

                n !== o && (r = !0, i = "buffer", n = o);
              }

              var s = e.objectMode ? 1 : n.length;
              e.length += s;
              var c = e.length < e.highWaterMark;
              c || (e.needDrain = !0);

              if (e.writing || e.corked) {
                var u = e.lastBufferedRequest;
                e.lastBufferedRequest = {
                  chunk: n,
                  encoding: i,
                  isBuf: r,
                  callback: a,
                  next: null
                }, u ? u.next = e.lastBufferedRequest : e.bufferedRequest = e.lastBufferedRequest, e.bufferedRequestCount += 1;
              } else A(t, e, !1, s, n, i, a);

              return c;
            }(this, a, s, t, e, n)), o;
          }, M.prototype.cork = function () {
            this._writableState.corked++;
          }, M.prototype.uncork = function () {
            var t = this._writableState;
            t.corked && (t.corked--, t.writing || t.corked || t.bufferProcessing || !t.bufferedRequest || E(this, t));
          }, M.prototype.setDefaultEncoding = function (t) {
            if ("string" == typeof t && (t = t.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((t + "").toLowerCase()) > -1)) throw new _(t);
            return this._writableState.defaultEncoding = t, this;
          }, Object.defineProperty(M.prototype, "writableBuffer", {
            enumerable: !1,
            get: function get() {
              return this._writableState && this._writableState.getBuffer();
            }
          }), Object.defineProperty(M.prototype, "writableHighWaterMark", {
            enumerable: !1,
            get: function get() {
              return this._writableState.highWaterMark;
            }
          }), M.prototype._write = function (t, e, r) {
            r(new m("_write()"));
          }, M.prototype._writev = null, M.prototype.end = function (t, e, n) {
            var i = this._writableState;
            return "function" == typeof t ? (n = t, t = null, e = null) : "function" == typeof e && (n = e, e = null), null != t && this.write(t, e), i.corked && (i.corked = 1, this.uncork()), i.ending || function (t, e, n) {
              e.ending = !0, P(t, e), n && (e.finished ? r.nextTick(n) : t.once("finish", n));
              e.ended = !0, t.writable = !1;
            }(this, i, n), this;
          }, Object.defineProperty(M.prototype, "writableLength", {
            enumerable: !1,
            get: function get() {
              return this._writableState.length;
            }
          }), Object.defineProperty(M.prototype, "destroyed", {
            enumerable: !1,
            get: function get() {
              return void 0 !== this._writableState && this._writableState.destroyed;
            },
            set: function set(t) {
              this._writableState && (this._writableState.destroyed = t);
            }
          }), M.prototype.destroy = f.destroy, M.prototype._undestroy = f.undestroy, M.prototype._destroy = function (t, e) {
            e(t);
          };
        }).call(this);
      }).call(this, t("_process"), "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
    }, {
      "../errors": 562,
      "./_stream_duplex": 563,
      "./internal/streams/destroy": 570,
      "./internal/streams/state": 574,
      "./internal/streams/stream": 575,
      _process: 520,
      buffer: 112,
      inherits: 438,
      "util-deprecate": 614
    }],
    568: [function (t, e, r) {
      (function (r) {
        (function () {
          "use strict";

          var n;

          function i(t, e, r) {
            return e in t ? Object.defineProperty(t, e, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : t[e] = r, t;
          }

          var a = t("./end-of-stream"),
              o = Symbol("lastResolve"),
              s = Symbol("lastReject"),
              l = Symbol("error"),
              c = Symbol("ended"),
              u = Symbol("lastPromise"),
              f = Symbol("handlePromise"),
              h = Symbol("stream");

          function p(t, e) {
            return {
              value: t,
              done: e
            };
          }

          function d(t) {
            var e = t[o];

            if (null !== e) {
              var r = t[h].read();
              null !== r && (t[u] = null, t[o] = null, t[s] = null, e(p(r, !1)));
            }
          }

          function m(t) {
            r.nextTick(d, t);
          }

          var g = Object.getPrototypeOf(function () {}),
              v = Object.setPrototypeOf((i(n = {
            get stream() {
              return this[h];
            },

            next: function next() {
              var t = this,
                  e = this[l];
              if (null !== e) return Promise.reject(e);
              if (this[c]) return Promise.resolve(p(void 0, !0));
              if (this[h].destroyed) return new Promise(function (e, n) {
                r.nextTick(function () {
                  t[l] ? n(t[l]) : e(p(void 0, !0));
                });
              });
              var n,
                  i = this[u];
              if (i) n = new Promise(function (t, e) {
                return function (r, n) {
                  t.then(function () {
                    e[c] ? r(p(void 0, !0)) : e[f](r, n);
                  }, n);
                };
              }(i, this));else {
                var a = this[h].read();
                if (null !== a) return Promise.resolve(p(a, !1));
                n = new Promise(this[f]);
              }
              return this[u] = n, n;
            }
          }, Symbol.asyncIterator, function () {
            return this;
          }), i(n, "return", function () {
            var t = this;
            return new Promise(function (e, r) {
              t[h].destroy(null, function (t) {
                t ? r(t) : e(p(void 0, !0));
              });
            });
          }), n), g);

          e.exports = function (t) {
            var e,
                r = Object.create(v, (i(e = {}, h, {
              value: t,
              writable: !0
            }), i(e, o, {
              value: null,
              writable: !0
            }), i(e, s, {
              value: null,
              writable: !0
            }), i(e, l, {
              value: null,
              writable: !0
            }), i(e, c, {
              value: t._readableState.endEmitted,
              writable: !0
            }), i(e, f, {
              value: function value(t, e) {
                var n = r[h].read();
                n ? (r[u] = null, r[o] = null, r[s] = null, t(p(n, !1))) : (r[o] = t, r[s] = e);
              },
              writable: !0
            }), e));
            return r[u] = null, a(t, function (t) {
              if (t && "ERR_STREAM_PREMATURE_CLOSE" !== t.code) {
                var e = r[s];
                return null !== e && (r[u] = null, r[o] = null, r[s] = null, e(t)), void (r[l] = t);
              }

              var n = r[o];
              null !== n && (r[u] = null, r[o] = null, r[s] = null, n(p(void 0, !0))), r[c] = !0;
            }), t.on("readable", m.bind(null, r)), r;
          };
        }).call(this);
      }).call(this, t("_process"));
    }, {
      "./end-of-stream": 571,
      _process: 520
    }],
    569: [function (t, e, r) {
      "use strict";

      function n(t, e) {
        var r = Object.keys(t);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e && (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function i(t, e, r) {
        return e in t ? Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = r, t;
      }

      function a(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      var o = t("buffer").Buffer,
          s = t("util").inspect,
          l = s && s.custom || "inspect";

      e.exports = function () {
        function t() {
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this.head = null, this.tail = null, this.length = 0;
        }

        var e, r, c;
        return e = t, (r = [{
          key: "push",
          value: function value(t) {
            var e = {
              data: t,
              next: null
            };
            this.length > 0 ? this.tail.next = e : this.head = e, this.tail = e, ++this.length;
          }
        }, {
          key: "unshift",
          value: function value(t) {
            var e = {
              data: t,
              next: this.head
            };
            0 === this.length && (this.tail = e), this.head = e, ++this.length;
          }
        }, {
          key: "shift",
          value: function value() {
            if (0 !== this.length) {
              var t = this.head.data;
              return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, t;
            }
          }
        }, {
          key: "clear",
          value: function value() {
            this.head = this.tail = null, this.length = 0;
          }
        }, {
          key: "join",
          value: function value(t) {
            if (0 === this.length) return "";

            for (var e = this.head, r = "" + e.data; e = e.next;) {
              r += t + e.data;
            }

            return r;
          }
        }, {
          key: "concat",
          value: function value(t) {
            if (0 === this.length) return o.alloc(0);

            for (var e, r, n, i = o.allocUnsafe(t >>> 0), a = this.head, s = 0; a;) {
              e = a.data, r = i, n = s, o.prototype.copy.call(e, r, n), s += a.data.length, a = a.next;
            }

            return i;
          }
        }, {
          key: "consume",
          value: function value(t, e) {
            var r;
            return t < this.head.data.length ? (r = this.head.data.slice(0, t), this.head.data = this.head.data.slice(t)) : r = t === this.head.data.length ? this.shift() : e ? this._getString(t) : this._getBuffer(t), r;
          }
        }, {
          key: "first",
          value: function value() {
            return this.head.data;
          }
        }, {
          key: "_getString",
          value: function value(t) {
            var e = this.head,
                r = 1,
                n = e.data;

            for (t -= n.length; e = e.next;) {
              var i = e.data,
                  a = t > i.length ? i.length : t;

              if (a === i.length ? n += i : n += i.slice(0, t), 0 == (t -= a)) {
                a === i.length ? (++r, e.next ? this.head = e.next : this.head = this.tail = null) : (this.head = e, e.data = i.slice(a));
                break;
              }

              ++r;
            }

            return this.length -= r, n;
          }
        }, {
          key: "_getBuffer",
          value: function value(t) {
            var e = o.allocUnsafe(t),
                r = this.head,
                n = 1;

            for (r.data.copy(e), t -= r.data.length; r = r.next;) {
              var i = r.data,
                  a = t > i.length ? i.length : t;

              if (i.copy(e, e.length - t, 0, a), 0 == (t -= a)) {
                a === i.length ? (++n, r.next ? this.head = r.next : this.head = this.tail = null) : (this.head = r, r.data = i.slice(a));
                break;
              }

              ++n;
            }

            return this.length -= n, e;
          }
        }, {
          key: l,
          value: function value(t, e) {
            return s(this, function (t) {
              for (var e = 1; e < arguments.length; e++) {
                var r = null != arguments[e] ? arguments[e] : {};
                e % 2 ? n(Object(r), !0).forEach(function (e) {
                  i(t, e, r[e]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function (e) {
                  Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                });
              }

              return t;
            }({}, e, {
              depth: 0,
              customInspect: !1
            }));
          }
        }]) && a(e.prototype, r), c && a(e, c), t;
      }();
    }, {
      buffer: 112,
      util: 110
    }],
    570: [function (t, e, r) {
      (function (t) {
        (function () {
          "use strict";

          function r(t, e) {
            i(t, e), n(t);
          }

          function n(t) {
            t._writableState && !t._writableState.emitClose || t._readableState && !t._readableState.emitClose || t.emit("close");
          }

          function i(t, e) {
            t.emit("error", e);
          }

          e.exports = {
            destroy: function destroy(e, a) {
              var o = this,
                  s = this._readableState && this._readableState.destroyed,
                  l = this._writableState && this._writableState.destroyed;
              return s || l ? (a ? a(e) : e && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, t.nextTick(i, this, e)) : t.nextTick(i, this, e)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function (e) {
                !a && e ? o._writableState ? o._writableState.errorEmitted ? t.nextTick(n, o) : (o._writableState.errorEmitted = !0, t.nextTick(r, o, e)) : t.nextTick(r, o, e) : a ? (t.nextTick(n, o), a(e)) : t.nextTick(n, o);
              }), this);
            },
            undestroy: function undestroy() {
              this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
            },
            errorOrDestroy: function errorOrDestroy(t, e) {
              var r = t._readableState,
                  n = t._writableState;
              r && r.autoDestroy || n && n.autoDestroy ? t.destroy(e) : t.emit("error", e);
            }
          };
        }).call(this);
      }).call(this, t("_process"));
    }, {
      _process: 520
    }],
    571: [function (t, e, r) {
      "use strict";

      var n = t("../../../errors").codes.ERR_STREAM_PREMATURE_CLOSE;

      function i() {}

      e.exports = function t(e, r, a) {
        if ("function" == typeof r) return t(e, null, r);
        r || (r = {}), a = function (t) {
          var e = !1;
          return function () {
            if (!e) {
              e = !0;

              for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++) {
                n[i] = arguments[i];
              }

              t.apply(this, n);
            }
          };
        }(a || i);

        var o = r.readable || !1 !== r.readable && e.readable,
            s = r.writable || !1 !== r.writable && e.writable,
            l = function l() {
          e.writable || u();
        },
            c = e._writableState && e._writableState.finished,
            u = function u() {
          s = !1, c = !0, o || a.call(e);
        },
            f = e._readableState && e._readableState.endEmitted,
            h = function h() {
          o = !1, f = !0, s || a.call(e);
        },
            p = function p(t) {
          a.call(e, t);
        },
            d = function d() {
          var t;
          return o && !f ? (e._readableState && e._readableState.ended || (t = new n()), a.call(e, t)) : s && !c ? (e._writableState && e._writableState.ended || (t = new n()), a.call(e, t)) : void 0;
        },
            m = function m() {
          e.req.on("finish", u);
        };

        return !function (t) {
          return t.setHeader && "function" == typeof t.abort;
        }(e) ? s && !e._writableState && (e.on("end", l), e.on("close", l)) : (e.on("complete", u), e.on("abort", d), e.req ? m() : e.on("request", m)), e.on("end", h), e.on("finish", u), !1 !== r.error && e.on("error", p), e.on("close", d), function () {
          e.removeListener("complete", u), e.removeListener("abort", d), e.removeListener("request", m), e.req && e.req.removeListener("finish", u), e.removeListener("end", l), e.removeListener("close", l), e.removeListener("finish", u), e.removeListener("end", h), e.removeListener("error", p), e.removeListener("close", d);
        };
      };
    }, {
      "../../../errors": 562
    }],
    572: [function (t, e, r) {
      e.exports = function () {
        throw new Error("Readable.from is not available in the browser");
      };
    }, {}],
    573: [function (t, e, r) {
      "use strict";

      var n;
      var i = t("../../../errors").codes,
          a = i.ERR_MISSING_ARGS,
          o = i.ERR_STREAM_DESTROYED;

      function s(t) {
        if (t) throw t;
      }

      function l(e, r, i, a) {
        a = function (t) {
          var e = !1;
          return function () {
            e || (e = !0, t.apply(void 0, arguments));
          };
        }(a);

        var s = !1;
        e.on("close", function () {
          s = !0;
        }), void 0 === n && (n = t("./end-of-stream")), n(e, {
          readable: r,
          writable: i
        }, function (t) {
          if (t) return a(t);
          s = !0, a();
        });
        var l = !1;
        return function (t) {
          if (!s && !l) return l = !0, function (t) {
            return t.setHeader && "function" == typeof t.abort;
          }(e) ? e.abort() : "function" == typeof e.destroy ? e.destroy() : void a(t || new o("pipe"));
        };
      }

      function c(t) {
        t();
      }

      function u(t, e) {
        return t.pipe(e);
      }

      function f(t) {
        return t.length ? "function" != typeof t[t.length - 1] ? s : t.pop() : s;
      }

      e.exports = function () {
        for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) {
          e[r] = arguments[r];
        }

        var n,
            i = f(e);
        if (Array.isArray(e[0]) && (e = e[0]), e.length < 2) throw new a("streams");
        var o = e.map(function (t, r) {
          var a = r < e.length - 1;
          return l(t, a, r > 0, function (t) {
            n || (n = t), t && o.forEach(c), a || (o.forEach(c), i(n));
          });
        });
        return e.reduce(u);
      };
    }, {
      "../../../errors": 562,
      "./end-of-stream": 571
    }],
    574: [function (t, e, r) {
      "use strict";

      var n = t("../../../errors").codes.ERR_INVALID_OPT_VALUE;
      e.exports = {
        getHighWaterMark: function getHighWaterMark(t, e, r, i) {
          var a = function (t, e, r) {
            return null != t.highWaterMark ? t.highWaterMark : e ? t[r] : null;
          }(e, i, r);

          if (null != a) {
            if (!isFinite(a) || Math.floor(a) !== a || a < 0) throw new n(i ? r : "highWaterMark", a);
            return Math.floor(a);
          }

          return t.objectMode ? 16 : 16384;
        }
      };
    }, {
      "../../../errors": 562
    }],
    575: [function (t, e, r) {
      e.exports = t("events").EventEmitter;
    }, {
      events: 111
    }],
    576: [function (t, e, r) {
      "use strict";

      var n = t("safe-buffer").Buffer,
          i = n.isEncoding || function (t) {
        switch ((t = "" + t) && t.toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
          case "raw":
            return !0;

          default:
            return !1;
        }
      };

      function a(t) {
        var e;

        switch (this.encoding = function (t) {
          var e = function (t) {
            if (!t) return "utf8";

            for (var e;;) {
              switch (t) {
                case "utf8":
                case "utf-8":
                  return "utf8";

                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return "utf16le";

                case "latin1":
                case "binary":
                  return "latin1";

                case "base64":
                case "ascii":
                case "hex":
                  return t;

                default:
                  if (e) return;
                  t = ("" + t).toLowerCase(), e = !0;
              }
            }
          }(t);

          if ("string" != typeof e && (n.isEncoding === i || !i(t))) throw new Error("Unknown encoding: " + t);
          return e || t;
        }(t), this.encoding) {
          case "utf16le":
            this.text = l, this.end = c, e = 4;
            break;

          case "utf8":
            this.fillLast = s, e = 4;
            break;

          case "base64":
            this.text = u, this.end = f, e = 3;
            break;

          default:
            return this.write = h, void (this.end = p);
        }

        this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(e);
      }

      function o(t) {
        return t <= 127 ? 0 : t >> 5 == 6 ? 2 : t >> 4 == 14 ? 3 : t >> 3 == 30 ? 4 : t >> 6 == 2 ? -1 : -2;
      }

      function s(t) {
        var e = this.lastTotal - this.lastNeed,
            r = function (t, e, r) {
          if (128 != (192 & e[0])) return t.lastNeed = 0, "\uFFFD";

          if (t.lastNeed > 1 && e.length > 1) {
            if (128 != (192 & e[1])) return t.lastNeed = 1, "\uFFFD";
            if (t.lastNeed > 2 && e.length > 2 && 128 != (192 & e[2])) return t.lastNeed = 2, "\uFFFD";
          }
        }(this, t);

        return void 0 !== r ? r : this.lastNeed <= t.length ? (t.copy(this.lastChar, e, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (t.copy(this.lastChar, e, 0, t.length), void (this.lastNeed -= t.length));
      }

      function l(t, e) {
        if ((t.length - e) % 2 == 0) {
          var r = t.toString("utf16le", e);

          if (r) {
            var n = r.charCodeAt(r.length - 1);
            if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1], r.slice(0, -1);
          }

          return r;
        }

        return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = t[t.length - 1], t.toString("utf16le", e, t.length - 1);
      }

      function c(t) {
        var e = t && t.length ? this.write(t) : "";

        if (this.lastNeed) {
          var r = this.lastTotal - this.lastNeed;
          return e + this.lastChar.toString("utf16le", 0, r);
        }

        return e;
      }

      function u(t, e) {
        var r = (t.length - e) % 3;
        return 0 === r ? t.toString("base64", e) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = t[t.length - 1] : (this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1]), t.toString("base64", e, t.length - r));
      }

      function f(t) {
        var e = t && t.length ? this.write(t) : "";
        return this.lastNeed ? e + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : e;
      }

      function h(t) {
        return t.toString(this.encoding);
      }

      function p(t) {
        return t && t.length ? this.write(t) : "";
      }

      r.StringDecoder = a, a.prototype.write = function (t) {
        if (0 === t.length) return "";
        var e, r;

        if (this.lastNeed) {
          if (void 0 === (e = this.fillLast(t))) return "";
          r = this.lastNeed, this.lastNeed = 0;
        } else r = 0;

        return r < t.length ? e ? e + this.text(t, r) : this.text(t, r) : e || "";
      }, a.prototype.end = function (t) {
        var e = t && t.length ? this.write(t) : "";
        return this.lastNeed ? e + "\uFFFD" : e;
      }, a.prototype.text = function (t, e) {
        var r = function (t, e, r) {
          var n = e.length - 1;
          if (n < r) return 0;
          var i = o(e[n]);
          if (i >= 0) return i > 0 && (t.lastNeed = i - 1), i;
          if (--n < r || -2 === i) return 0;
          if ((i = o(e[n])) >= 0) return i > 0 && (t.lastNeed = i - 2), i;
          if (--n < r || -2 === i) return 0;
          if ((i = o(e[n])) >= 0) return i > 0 && (2 === i ? i = 0 : t.lastNeed = i - 3), i;
          return 0;
        }(this, t, e);

        if (!this.lastNeed) return t.toString("utf8", e);
        this.lastTotal = r;
        var n = t.length - (r - this.lastNeed);
        return t.copy(this.lastChar, 0, n), t.toString("utf8", e, n);
      }, a.prototype.fillLast = function (t) {
        if (this.lastNeed <= t.length) return t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
        t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, t.length), this.lastNeed -= t.length;
      };
    }, {
      "safe-buffer": 546
    }],
    577: [function (t, e, r) {
      (function (r, n) {
        (function () {
          var r = t("assert"),
              i = t("debug")("stream-parser");

          e.exports = function (t) {
            var e = t && "function" == typeof t._transform,
                r = t && "function" == typeof t._write;
            if (!e && !r) throw new Error("must pass a Writable or Transform stream in");
            i("extending Parser into stream"), t._bytes = o, t._skipBytes = s, e && (t._passthrough = l);
            e ? t._transform = u : t._write = c;
          };

          function a(t) {
            i("initializing parser stream"), t._parserBytesLeft = 0, t._parserBuffers = [], t._parserBuffered = 0, t._parserState = -1, t._parserCallback = null, "function" == typeof t.push && (t._parserOutput = t.push.bind(t)), t._parserInit = !0;
          }

          function o(t, e) {
            r(!this._parserCallback, 'there is already a "callback" set!'), r(isFinite(t) && t > 0, 'can only buffer a finite number of bytes > 0, got "' + t + '"'), this._parserInit || a(this), i("buffering %o bytes", t), this._parserBytesLeft = t, this._parserCallback = e, this._parserState = 0;
          }

          function s(t, e) {
            r(!this._parserCallback, 'there is already a "callback" set!'), r(t > 0, 'can only skip > 0 bytes, got "' + t + '"'), this._parserInit || a(this), i("skipping %o bytes", t), this._parserBytesLeft = t, this._parserCallback = e, this._parserState = 1;
          }

          function l(t, e) {
            r(!this._parserCallback, 'There is already a "callback" set!'), r(t > 0, 'can only pass through > 0 bytes, got "' + t + '"'), this._parserInit || a(this), i("passing through %o bytes", t), this._parserBytesLeft = t, this._parserCallback = e, this._parserState = 2;
          }

          function c(t, e, r) {
            this._parserInit || a(this), i("write(%o bytes)", t.length), "function" == typeof e && (r = e), h(this, t, null, r);
          }

          function u(t, e, r) {
            this._parserInit || a(this), i("transform(%o bytes)", t.length), "function" != typeof e && (e = this._parserOutput), h(this, t, e, r);
          }

          function f(t, e, r, a) {
            if (t._parserBytesLeft -= e.length, i("%o bytes left for stream piece", t._parserBytesLeft), 0 === t._parserState ? (t._parserBuffers.push(e), t._parserBuffered += e.length) : 2 === t._parserState && r(e), 0 !== t._parserBytesLeft) return a;
            var o = t._parserCallback;

            if (o && 0 === t._parserState && t._parserBuffers.length > 1 && (e = n.concat(t._parserBuffers, t._parserBuffered)), 0 !== t._parserState && (e = null), t._parserCallback = null, t._parserBuffered = 0, t._parserState = -1, t._parserBuffers.splice(0), o) {
              var s = [];
              e && s.push(e), r && s.push(r);
              var l = o.length > s.length;
              l && s.push(p(a));
              var c = o.apply(t, s);
              if (!l || a === c) return a;
            }
          }

          var h = p(function t(e, r, n, i) {
            return e._parserBytesLeft <= 0 ? i(new Error("got data but not currently parsing anything")) : r.length <= e._parserBytesLeft ? function () {
              return f(e, r, n, i);
            } : function () {
              var a = r.slice(0, e._parserBytesLeft);
              return f(e, a, n, function (o) {
                return o ? i(o) : r.length > a.length ? function () {
                  return t(e, r.slice(a.length), n, i);
                } : void 0;
              });
            };
          });

          function p(t) {
            return function () {
              for (var e = t.apply(this, arguments); "function" == typeof e;) {
                e = e();
              }

              return e;
            };
          }
        }).call(this);
      }).call(this, t("_process"), t("buffer").Buffer);
    }, {
      _process: 520,
      assert: 75,
      buffer: 112,
      debug: 578
    }],
    578: [function (t, e, r) {
      (function (n) {
        (function () {
          function i() {
            var t;

            try {
              t = r.storage.debug;
            } catch (t) {}

            return !t && void 0 !== n && "env" in n && (t = n.env.DEBUG), t;
          }

          (r = e.exports = t("./debug")).log = function () {
            return "object" == (typeof console === "undefined" ? "undefined" : _typeof(console)) && console.log && Function.prototype.apply.call(console.log, console, arguments);
          }, r.formatArgs = function (t) {
            var e = this.useColors;
            if (t[0] = (e ? "%c" : "") + this.namespace + (e ? " %c" : " ") + t[0] + (e ? "%c " : " ") + "+" + r.humanize(this.diff), !e) return;
            var n = "color: " + this.color;
            t.splice(1, 0, n, "color: inherit");
            var i = 0,
                a = 0;
            t[0].replace(/%[a-zA-Z%]/g, function (t) {
              "%%" !== t && (i++, "%c" === t && (a = i));
            }), t.splice(a, 0, n);
          }, r.save = function (t) {
            try {
              null == t ? r.storage.removeItem("debug") : r.storage.debug = t;
            } catch (t) {}
          }, r.load = i, r.useColors = function () {
            if ("undefined" != typeof window && window.process && "renderer" === window.process.type) return !0;
            return "undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" != typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
          }, r.storage = "undefined" != typeof chrome && void 0 !== chrome.storage ? chrome.storage.local : function () {
            try {
              return window.localStorage;
            } catch (t) {}
          }(), r.colors = ["lightseagreen", "forestgreen", "goldenrod", "dodgerblue", "darkorchid", "crimson"], r.formatters.j = function (t) {
            try {
              return JSON.stringify(t);
            } catch (t) {
              return "[UnexpectedJSONParseError]: " + t.message;
            }
          }, r.enable(i());
        }).call(this);
      }).call(this, t("_process"));
    }, {
      "./debug": 579,
      _process: 520
    }],
    579: [function (t, e, r) {
      var n;

      function i(t) {
        function e() {
          if (e.enabled) {
            var t = e,
                i = +new Date(),
                a = i - (n || i);
            t.diff = a, t.prev = n, t.curr = i, n = i;

            for (var o = new Array(arguments.length), s = 0; s < o.length; s++) {
              o[s] = arguments[s];
            }

            o[0] = r.coerce(o[0]), "string" != typeof o[0] && o.unshift("%O");
            var l = 0;
            o[0] = o[0].replace(/%([a-zA-Z%])/g, function (e, n) {
              if ("%%" === e) return e;
              l++;
              var i = r.formatters[n];

              if ("function" == typeof i) {
                var a = o[l];
                e = i.call(t, a), o.splice(l, 1), l--;
              }

              return e;
            }), r.formatArgs.call(t, o);
            var c = e.log || r.log || console.log.bind(console);
            c.apply(t, o);
          }
        }

        return e.namespace = t, e.enabled = r.enabled(t), e.useColors = r.useColors(), e.color = function (t) {
          var e,
              n = 0;

          for (e in t) {
            n = (n << 5) - n + t.charCodeAt(e), n |= 0;
          }

          return r.colors[Math.abs(n) % r.colors.length];
        }(t), "function" == typeof r.init && r.init(e), e;
      }

      (r = e.exports = i.debug = i.default = i).coerce = function (t) {
        return t instanceof Error ? t.stack || t.message : t;
      }, r.disable = function () {
        r.enable("");
      }, r.enable = function (t) {
        r.save(t), r.names = [], r.skips = [];

        for (var e = ("string" == typeof t ? t : "").split(/[\s,]+/), n = e.length, i = 0; i < n; i++) {
          e[i] && ("-" === (t = e[i].replace(/\*/g, ".*?"))[0] ? r.skips.push(new RegExp("^" + t.substr(1) + "$")) : r.names.push(new RegExp("^" + t + "$")));
        }
      }, r.enabled = function (t) {
        var e, n;

        for (e = 0, n = r.skips.length; e < n; e++) {
          if (r.skips[e].test(t)) return !1;
        }

        for (e = 0, n = r.names.length; e < n; e++) {
          if (r.names[e].test(t)) return !0;
        }

        return !1;
      }, r.humanize = t("ms"), r.names = [], r.skips = [], r.formatters = {};
    }, {
      ms: 580
    }],
    580: [function (t, e, r) {
      var n = 1e3,
          i = 6e4,
          a = 60 * i,
          o = 24 * a;

      function s(t, e, r) {
        if (!(t < e)) return t < 1.5 * e ? Math.floor(t / e) + " " + r : Math.ceil(t / e) + " " + r + "s";
      }

      e.exports = function (t, e) {
        e = e || {};

        var r,
            l = _typeof(t);

        if ("string" === l && t.length > 0) return function (t) {
          if ((t = String(t)).length > 100) return;
          var e = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(t);
          if (!e) return;
          var r = parseFloat(e[1]);

          switch ((e[2] || "ms").toLowerCase()) {
            case "years":
            case "year":
            case "yrs":
            case "yr":
            case "y":
              return 315576e5 * r;

            case "days":
            case "day":
            case "d":
              return r * o;

            case "hours":
            case "hour":
            case "hrs":
            case "hr":
            case "h":
              return r * a;

            case "minutes":
            case "minute":
            case "mins":
            case "min":
            case "m":
              return r * i;

            case "seconds":
            case "second":
            case "secs":
            case "sec":
            case "s":
              return r * n;

            case "milliseconds":
            case "millisecond":
            case "msecs":
            case "msec":
            case "ms":
              return r;

            default:
              return;
          }
        }(t);
        if ("number" === l && !1 === isNaN(t)) return e.long ? s(r = t, o, "day") || s(r, a, "hour") || s(r, i, "minute") || s(r, n, "second") || r + " ms" : function (t) {
          if (t >= o) return Math.round(t / o) + "d";
          if (t >= a) return Math.round(t / a) + "h";
          if (t >= i) return Math.round(t / i) + "m";
          if (t >= n) return Math.round(t / n) + "s";
          return t + "ms";
        }(t);
        throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(t));
      };
    }, {}],
    581: [function (t, e, r) {
      "use strict";

      var n = t("parenthesis");

      e.exports = function (t, e, r) {
        if (null == t) throw Error("First argument should be a string");
        if (null == e) throw Error("Separator should be a string or a RegExp");
        r ? ("string" == typeof r || Array.isArray(r)) && (r = {
          ignore: r
        }) : r = {}, null == r.escape && (r.escape = !0), null == r.ignore ? r.ignore = ["[]", "()", "{}", "<>", '""', "''", "``", "\u201C\u201D", "\xab\xbb"] : ("string" == typeof r.ignore && (r.ignore = [r.ignore]), r.ignore = r.ignore.map(function (t) {
          return 1 === t.length && (t += t), t;
        }));
        var i = n.parse(t, {
          flat: !0,
          brackets: r.ignore
        }),
            a = i[0].split(e);

        if (r.escape) {
          for (var o = [], s = 0; s < a.length; s++) {
            var l = a[s],
                c = a[s + 1];
            "\\" === l[l.length - 1] && "\\" !== l[l.length - 2] ? (o.push(l + e + c), s++) : o.push(l);
          }

          a = o;
        }

        for (s = 0; s < a.length; s++) {
          i[0] = a[s], a[s] = n.stringify(i, {
            flat: !0
          });
        }

        return a;
      };
    }, {
      parenthesis: 483
    }],
    582: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        for (var e = t.length, r = new Array(e), n = new Array(e), i = new Array(e), a = new Array(e), o = new Array(e), s = new Array(e), l = 0; l < e; ++l) {
          r[l] = -1, n[l] = 0, i[l] = !1, a[l] = 0, o[l] = -1, s[l] = [];
        }

        var c,
            u = 0,
            f = [],
            h = [];

        function p(e) {
          var l = [e],
              c = [e];

          for (r[e] = n[e] = u, i[e] = !0, u += 1; c.length > 0;) {
            e = c[c.length - 1];
            var p = t[e];

            if (a[e] < p.length) {
              for (var d = a[e]; d < p.length; ++d) {
                var m = p[d];

                if (r[m] < 0) {
                  r[m] = n[m] = u, i[m] = !0, u += 1, l.push(m), c.push(m);
                  break;
                }

                i[m] && (n[e] = 0 | Math.min(n[e], n[m])), o[m] >= 0 && s[e].push(o[m]);
              }

              a[e] = d;
            } else {
              if (n[e] === r[e]) {
                var g = [],
                    v = [],
                    y = 0;

                for (d = l.length - 1; d >= 0; --d) {
                  var x = l[d];

                  if (i[x] = !1, g.push(x), v.push(s[x]), y += s[x].length, o[x] = f.length, x === e) {
                    l.length = d;
                    break;
                  }
                }

                f.push(g);
                var b = new Array(y);

                for (d = 0; d < v.length; d++) {
                  for (var _ = 0; _ < v[d].length; _++) {
                    b[--y] = v[d][_];
                  }
                }

                h.push(b);
              }

              c.pop();
            }
          }
        }

        for (l = 0; l < e; ++l) {
          r[l] < 0 && p(l);
        }

        for (l = 0; l < h.length; l++) {
          var d = h[l];

          if (0 !== d.length) {
            d.sort(function (t, e) {
              return t - e;
            }), c = [d[0]];

            for (var m = 1; m < d.length; m++) {
              d[m] !== d[m - 1] && c.push(d[m]);
            }

            h[l] = c;
          }
        }

        return {
          components: f,
          adjacencyList: h
        };
      };
    }, {}],
    583: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        if (t.dimension <= 0) return {
          positions: [],
          cells: []
        };
        if (1 === t.dimension) return function (t, e) {
          for (var r = a(t, e), n = r.length, i = new Array(n), o = new Array(n), s = 0; s < n; ++s) {
            i[s] = [r[s]], o[s] = [s];
          }

          return {
            positions: i,
            cells: o
          };
        }(t, e);
        var r = t.order.join() + "-" + t.dtype,
            s = o[r];
        e = +e || 0;
        s || (s = o[r] = function (t, e) {
          var r = t.length,
              a = ["'use strict';"],
              o = "surfaceNets" + t.join("_") + "d" + e;
          a.push("var contour=genContour({", "order:[", t.join(), "],", "scalarArguments: 3,", "phase:function phaseFunc(p,a,b,c) { return (p > c)|0 },"), "generic" === e && a.push("getters:[0],");

          for (var s = [], l = [], c = 0; c < r; ++c) {
            s.push("d" + c), l.push("d" + c);
          }

          for (c = 0; c < 1 << r; ++c) {
            s.push("v" + c), l.push("v" + c);
          }

          for (c = 0; c < 1 << r; ++c) {
            s.push("p" + c), l.push("p" + c);
          }

          s.push("a", "b", "c"), l.push("a", "c"), a.push("vertex:function vertexFunc(", s.join(), "){");
          var u = [];

          for (c = 0; c < 1 << r; ++c) {
            u.push("(p" + c + "<<" + c + ")");
          }

          a.push("var m=(", u.join("+"), ")|0;if(m===0||m===", (1 << (1 << r)) - 1, "){return}");
          var f = [],
              h = [];
          1 << (1 << r) <= 128 ? (a.push("switch(m){"), h = a) : a.push("switch(m>>>7){");

          for (c = 0; c < 1 << (1 << r); ++c) {
            if (1 << (1 << r) > 128 && c % 128 == 0) {
              f.length > 0 && h.push("}}");
              var p = "vExtra" + f.length;
              a.push("case ", c >>> 7, ":", p, "(m&0x7f,", l.join(), ");break;"), h = ["function ", p, "(m,", l.join(), "){switch(m){"], f.push(h);
            }

            h.push("case ", 127 & c, ":");

            for (var d = new Array(r), m = new Array(r), g = new Array(r), v = new Array(r), y = 0, x = 0; x < r; ++x) {
              d[x] = [], m[x] = [], g[x] = 0, v[x] = 0;
            }

            for (x = 0; x < 1 << r; ++x) {
              for (var b = 0; b < r; ++b) {
                var _ = x ^ 1 << b;

                if (!(_ > x) && !(c & 1 << _) != !(c & 1 << x)) {
                  var w = 1;
                  c & 1 << _ ? m[b].push("v" + _ + "-v" + x) : (m[b].push("v" + x + "-v" + _), w = -w), w < 0 ? (d[b].push("-v" + x + "-v" + _), g[b] += 2) : (d[b].push("v" + x + "+v" + _), g[b] -= 2), y += 1;

                  for (var T = 0; T < r; ++T) {
                    T !== b && (_ & 1 << T ? v[T] += 1 : v[T] -= 1);
                  }
                }
              }
            }

            var k = [];

            for (b = 0; b < r; ++b) {
              if (0 === d[b].length) k.push("d" + b + "-0.5");else {
                var M = "";
                g[b] < 0 ? M = g[b] + "*c" : g[b] > 0 && (M = "+" + g[b] + "*c");
                var A = d[b].length / y * .5,
                    S = .5 + v[b] / y * .5;
                k.push("d" + b + "-" + S + "-" + A + "*(" + d[b].join("+") + M + ")/(" + m[b].join("+") + ")");
              }
            }

            h.push("a.push([", k.join(), "]);", "break;");
          }

          a.push("}},"), f.length > 0 && h.push("}}");
          var E = [];

          for (c = 0; c < 1 << r - 1; ++c) {
            E.push("v" + c);
          }

          E.push("c0", "c1", "p0", "p1", "a", "b", "c"), a.push("cell:function cellFunc(", E.join(), "){");
          var L = i(r - 1);
          a.push("if(p0){b.push(", L.map(function (t) {
            return "[" + t.map(function (t) {
              return "v" + t;
            }) + "]";
          }).join(), ")}else{b.push(", L.map(function (t) {
            var e = t.slice();
            return e.reverse(), "[" + e.map(function (t) {
              return "v" + t;
            }) + "]";
          }).join(), ")}}});function ", o, "(array,level){var verts=[],cells=[];contour(array,verts,cells,level);return {positions:verts,cells:cells};} return ", o, ";");

          for (c = 0; c < f.length; ++c) {
            a.push(f[c].join(""));
          }

          return new Function("genContour", a.join(""))(n);
        }(t.order, t.dtype));
        return s(t, e);
      };

      var n = t("ndarray-extract-contour"),
          i = t("triangulate-hypercube"),
          a = t("zero-crossings");
      var o = {};
    }, {
      "ndarray-extract-contour": 467,
      "triangulate-hypercube": 594,
      "zero-crossings": 639
    }],
    584: [function (t, e, r) {
      "use strict";

      Object.defineProperty(r, "__esModule", {
        value: !0
      });

      var n = function n(t, e) {
        if (Array.isArray(t)) return t;
        if (Symbol.iterator in Object(t)) return function (t, e) {
          var r = [],
              n = !0,
              i = !1,
              a = void 0;

          try {
            for (var o, s = t[Symbol.iterator](); !(n = (o = s.next()).done) && (r.push(o.value), !e || r.length !== e); n = !0) {
              ;
            }
          } catch (t) {
            i = !0, a = t;
          } finally {
            try {
              !n && s.return && s.return();
            } finally {
              if (i) throw a;
            }
          }

          return r;
        }(t, e);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      },
          i = 2 * Math.PI,
          a = function a(t, e, r, n, i, _a2, o) {
        var s = t.x,
            l = t.y;
        return {
          x: n * (s *= e) - i * (l *= r) + _a2,
          y: i * s + n * l + o
        };
      },
          o = function o(t, e) {
        var r = 1.5707963267948966 === e ? .551915024494 : -1.5707963267948966 === e ? -.551915024494 : 4 / 3 * Math.tan(e / 4),
            n = Math.cos(t),
            i = Math.sin(t),
            a = Math.cos(t + e),
            o = Math.sin(t + e);
        return [{
          x: n - i * r,
          y: i + n * r
        }, {
          x: a + o * r,
          y: o - a * r
        }, {
          x: a,
          y: o
        }];
      },
          s = function s(t, e, r, n) {
        var i = t * r + e * n;
        return i > 1 && (i = 1), i < -1 && (i = -1), (t * n - e * r < 0 ? -1 : 1) * Math.acos(i);
      };

      r.default = function (t) {
        var e = t.px,
            r = t.py,
            l = t.cx,
            c = t.cy,
            u = t.rx,
            f = t.ry,
            h = t.xAxisRotation,
            p = void 0 === h ? 0 : h,
            d = t.largeArcFlag,
            m = void 0 === d ? 0 : d,
            g = t.sweepFlag,
            v = void 0 === g ? 0 : g,
            y = [];
        if (0 === u || 0 === f) return [];

        var x = Math.sin(p * i / 360),
            b = Math.cos(p * i / 360),
            _ = b * (e - l) / 2 + x * (r - c) / 2,
            w = -x * (e - l) / 2 + b * (r - c) / 2;

        if (0 === _ && 0 === w) return [];
        u = Math.abs(u), f = Math.abs(f);
        var T = Math.pow(_, 2) / Math.pow(u, 2) + Math.pow(w, 2) / Math.pow(f, 2);
        T > 1 && (u *= Math.sqrt(T), f *= Math.sqrt(T));

        var k = function (t, e, r, n, a, o, l, c, u, f, h, p) {
          var d = Math.pow(a, 2),
              m = Math.pow(o, 2),
              g = Math.pow(h, 2),
              v = Math.pow(p, 2),
              y = d * m - d * v - m * g;
          y < 0 && (y = 0), y /= d * v + m * g;

          var x = (y = Math.sqrt(y) * (l === c ? -1 : 1)) * a / o * p,
              b = y * -o / a * h,
              _ = f * x - u * b + (t + r) / 2,
              w = u * x + f * b + (e + n) / 2,
              T = (h - x) / a,
              k = (p - b) / o,
              M = (-h - x) / a,
              A = (-p - b) / o,
              S = s(1, 0, T, k),
              E = s(T, k, M, A);

          return 0 === c && E > 0 && (E -= i), 1 === c && E < 0 && (E += i), [_, w, S, E];
        }(e, r, l, c, u, f, m, v, x, b, _, w),
            M = n(k, 4),
            A = M[0],
            S = M[1],
            E = M[2],
            L = M[3],
            C = Math.abs(L) / (i / 4);

        Math.abs(1 - C) < 1e-7 && (C = 1);
        var P = Math.max(Math.ceil(C), 1);
        L /= P;

        for (var I = 0; I < P; I++) {
          y.push(o(E, L)), E += L;
        }

        return y.map(function (t) {
          var e = a(t[0], u, f, b, x, A, S),
              r = e.x,
              n = e.y,
              i = a(t[1], u, f, b, x, A, S),
              o = i.x,
              s = i.y,
              l = a(t[2], u, f, b, x, A, S);
          return {
            x1: r,
            y1: n,
            x2: o,
            y2: s,
            x: l.x,
            y: l.y
          };
        });
      }, e.exports = r.default;
    }, {}],
    585: [function (t, e, r) {
      "use strict";

      var n = t("parse-svg-path"),
          i = t("abs-svg-path"),
          a = t("normalize-svg-path"),
          o = t("is-svg-path"),
          s = t("assert");

      e.exports = function (t) {
        Array.isArray(t) && 1 === t.length && "string" == typeof t[0] && (t = t[0]);
        "string" == typeof t && (s(o(t), "String is not an SVG path."), t = n(t));
        if (s(Array.isArray(t), "Argument should be a string or an array of path segments."), t = i(t), !(t = a(t)).length) return [0, 0, 0, 0];

        for (var e = [1 / 0, 1 / 0, -1 / 0, -1 / 0], r = 0, l = t.length; r < l; r++) {
          for (var c = t[r].slice(1), u = 0; u < c.length; u += 2) {
            c[u + 0] < e[0] && (e[0] = c[u + 0]), c[u + 1] < e[1] && (e[1] = c[u + 1]), c[u + 0] > e[2] && (e[2] = c[u + 0]), c[u + 1] > e[3] && (e[3] = c[u + 1]);
          }
        }

        return e;
      };
    }, {
      "abs-svg-path": 66,
      assert: 75,
      "is-svg-path": 450,
      "normalize-svg-path": 586,
      "parse-svg-path": 485
    }],
    586: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        for (var e, r = [], o = 0, s = 0, l = 0, c = 0, u = null, f = null, h = 0, p = 0, d = 0, m = t.length; d < m; d++) {
          var g = t[d],
              v = g[0];

          switch (v) {
            case "M":
              l = g[1], c = g[2];
              break;

            case "A":
              var y = n({
                px: h,
                py: p,
                cx: g[6],
                cy: g[7],
                rx: g[1],
                ry: g[2],
                xAxisRotation: g[3],
                largeArcFlag: g[4],
                sweepFlag: g[5]
              });
              if (!y.length) continue;

              for (var x, b = 0; b < y.length; b++) {
                x = y[b], g = ["C", x.x1, x.y1, x.x2, x.y2, x.x, x.y], b < y.length - 1 && r.push(g);
              }

              break;

            case "S":
              var _ = h,
                  w = p;
              "C" != e && "S" != e || (_ += _ - o, w += w - s), g = ["C", _, w, g[1], g[2], g[3], g[4]];
              break;

            case "T":
              "Q" == e || "T" == e ? (u = 2 * h - u, f = 2 * p - f) : (u = h, f = p), g = a(h, p, u, f, g[1], g[2]);
              break;

            case "Q":
              u = g[1], f = g[2], g = a(h, p, g[1], g[2], g[3], g[4]);
              break;

            case "L":
              g = i(h, p, g[1], g[2]);
              break;

            case "H":
              g = i(h, p, g[1], p);
              break;

            case "V":
              g = i(h, p, h, g[1]);
              break;

            case "Z":
              g = i(h, p, l, c);
          }

          e = v, h = g[g.length - 2], p = g[g.length - 1], g.length > 4 ? (o = g[g.length - 4], s = g[g.length - 3]) : (o = h, s = p), r.push(g);
        }

        return r;
      };

      var n = t("svg-arc-to-cubic-bezier");

      function i(t, e, r, n) {
        return ["C", t, e, r, n, r, n];
      }

      function a(t, e, r, n, i, a) {
        return ["C", t / 3 + 2 / 3 * r, e / 3 + 2 / 3 * n, i / 3 + 2 / 3 * r, a / 3 + 2 / 3 * n, i, a];
      }
    }, {
      "svg-arc-to-cubic-bezier": 584
    }],
    587: [function (t, e, r) {
      "use strict";

      var n,
          i = t("svg-path-bounds"),
          a = t("parse-svg-path"),
          o = t("draw-svg-path"),
          s = t("is-svg-path"),
          l = t("bitmap-sdf"),
          c = document.createElement("canvas"),
          u = c.getContext("2d");

      e.exports = function (t, e) {
        if (!s(t)) throw Error("Argument should be valid svg path string");
        e || (e = {});
        var r, f;
        e.shape ? (r = e.shape[0], f = e.shape[1]) : (r = c.width = e.w || e.width || 200, f = c.height = e.h || e.height || 200);
        var h = Math.min(r, f),
            p = e.stroke || 0,
            d = e.viewbox || e.viewBox || i(t),
            m = [r / (d[2] - d[0]), f / (d[3] - d[1])],
            g = Math.min(m[0] || 0, m[1] || 0) / 2;
        u.fillStyle = "black", u.fillRect(0, 0, r, f), u.fillStyle = "white", p && ("number" != typeof p && (p = 1), u.strokeStyle = p > 0 ? "white" : "black", u.lineWidth = Math.abs(p));

        if (u.translate(.5 * r, .5 * f), u.scale(g, g), function () {
          if (null != n) return n;
          var t = document.createElement("canvas").getContext("2d");
          if (t.canvas.width = t.canvas.height = 1, !window.Path2D) return n = !1;
          var e = new Path2D("M0,0h1v1h-1v-1Z");
          t.fillStyle = "black", t.fill(e);
          var r = t.getImageData(0, 0, 1, 1);
          return n = r && r.data && 255 === r.data[3];
        }()) {
          var v = new Path2D(t);
          u.fill(v), p && u.stroke(v);
        } else {
          var y = a(t);
          o(u, y), u.fill(), p && u.stroke();
        }

        return u.setTransform(1, 0, 0, 1, 0, 0), l(u, {
          cutoff: null != e.cutoff ? e.cutoff : .5,
          radius: null != e.radius ? e.radius : .5 * h
        });
      };
    }, {
      "bitmap-sdf": 100,
      "draw-svg-path": 174,
      "is-svg-path": 450,
      "parse-svg-path": 485,
      "svg-path-bounds": 585
    }],
    588: [function (t, e, r) {
      (function (r) {
        (function () {
          "use strict";

          e.exports = function t(e, r, i) {
            i = i || {};
            var o = a[e];
            o || (o = a[e] = {
              " ": {
                data: new Float32Array(0),
                shape: .2
              }
            });
            var s = o[r];
            if (!s) if (r.length <= 1 || !/\d/.test(r)) s = o[r] = function (t) {
              for (var e = t.cells, r = t.positions, n = new Float32Array(6 * e.length), i = 0, a = 0, o = 0; o < e.length; ++o) {
                for (var s = e[o], l = 0; l < 3; ++l) {
                  var c = r[s[l]];
                  n[i++] = c[0], n[i++] = c[1] + 1.4, a = Math.max(c[0], a);
                }
              }

              return {
                data: n,
                shape: a
              };
            }(n(r, {
              triangles: !0,
              font: e,
              textAlign: i.textAlign || "left",
              textBaseline: "alphabetic",
              styletags: {
                breaklines: !0,
                bolds: !0,
                italics: !0,
                subscripts: !0,
                superscripts: !0
              }
            }));else {
              for (var l = r.split(/(\d|\s)/), c = new Array(l.length), u = 0, f = 0, h = 0; h < l.length; ++h) {
                c[h] = t(e, l[h]), u += c[h].data.length, f += c[h].shape, h > 0 && (f += .02);
              }

              var p = new Float32Array(u),
                  d = 0,
                  m = -.5 * f;

              for (h = 0; h < c.length; ++h) {
                for (var g = c[h].data, v = 0; v < g.length; v += 2) {
                  p[d++] = g[v] + m, p[d++] = g[v + 1];
                }

                m += c[h].shape + .02;
              }

              s = o[r] = {
                data: p,
                shape: f
              };
            }
            return s;
          };

          var n = t("vectorize-text"),
              i = window || r.global || {},
              a = i.__TEXT_CACHE || {};
          i.__TEXT_CACHE = {};
        }).call(this);
      }).call(this, t("_process"));
    }, {
      _process: 520,
      "vectorize-text": 615
    }],
    589: [function (t, e, r) {
      (function (e, n) {
        (function () {
          var i = t("process/browser.js").nextTick,
              a = Function.prototype.apply,
              o = Array.prototype.slice,
              s = {},
              l = 0;

          function c(t, e) {
            this._id = t, this._clearFn = e;
          }

          r.setTimeout = function () {
            return new c(a.call(setTimeout, window, arguments), clearTimeout);
          }, r.setInterval = function () {
            return new c(a.call(setInterval, window, arguments), clearInterval);
          }, r.clearTimeout = r.clearInterval = function (t) {
            t.close();
          }, c.prototype.unref = c.prototype.ref = function () {}, c.prototype.close = function () {
            this._clearFn.call(window, this._id);
          }, r.enroll = function (t, e) {
            clearTimeout(t._idleTimeoutId), t._idleTimeout = e;
          }, r.unenroll = function (t) {
            clearTimeout(t._idleTimeoutId), t._idleTimeout = -1;
          }, r._unrefActive = r.active = function (t) {
            clearTimeout(t._idleTimeoutId);
            var e = t._idleTimeout;
            e >= 0 && (t._idleTimeoutId = setTimeout(function () {
              t._onTimeout && t._onTimeout();
            }, e));
          }, r.setImmediate = "function" == typeof e ? e : function (t) {
            var e = l++,
                n = !(arguments.length < 2) && o.call(arguments, 1);
            return s[e] = !0, i(function () {
              s[e] && (n ? t.apply(null, n) : t.call(null), r.clearImmediate(e));
            }), e;
          }, r.clearImmediate = "function" == typeof n ? n : function (t) {
            delete s[t];
          };
        }).call(this);
      }).call(this, t("timers").setImmediate, t("timers").clearImmediate);
    }, {
      "process/browser.js": 520,
      timers: 589
    }],
    590: [function (t, e, r) {
      !function (t) {
        var r = /^\s+/,
            n = /\s+$/,
            i = 0,
            a = t.round,
            o = t.min,
            s = t.max,
            l = t.random;

        function c(e, l) {
          if (l = l || {}, (e = e || "") instanceof c) return e;
          if (!(this instanceof c)) return new c(e, l);

          var u = function (e) {
            var i = {
              r: 0,
              g: 0,
              b: 0
            },
                a = 1,
                l = null,
                c = null,
                u = null,
                f = !1,
                h = !1;
            "string" == typeof e && (e = function (t) {
              t = t.replace(r, "").replace(n, "").toLowerCase();
              var e,
                  i = !1;
              if (S[t]) t = S[t], i = !0;else if ("transparent" == t) return {
                r: 0,
                g: 0,
                b: 0,
                a: 0,
                format: "name"
              };
              if (e = j.rgb.exec(t)) return {
                r: e[1],
                g: e[2],
                b: e[3]
              };
              if (e = j.rgba.exec(t)) return {
                r: e[1],
                g: e[2],
                b: e[3],
                a: e[4]
              };
              if (e = j.hsl.exec(t)) return {
                h: e[1],
                s: e[2],
                l: e[3]
              };
              if (e = j.hsla.exec(t)) return {
                h: e[1],
                s: e[2],
                l: e[3],
                a: e[4]
              };
              if (e = j.hsv.exec(t)) return {
                h: e[1],
                s: e[2],
                v: e[3]
              };
              if (e = j.hsva.exec(t)) return {
                h: e[1],
                s: e[2],
                v: e[3],
                a: e[4]
              };
              if (e = j.hex8.exec(t)) return {
                r: I(e[1]),
                g: I(e[2]),
                b: I(e[3]),
                a: R(e[4]),
                format: i ? "name" : "hex8"
              };
              if (e = j.hex6.exec(t)) return {
                r: I(e[1]),
                g: I(e[2]),
                b: I(e[3]),
                format: i ? "name" : "hex"
              };
              if (e = j.hex4.exec(t)) return {
                r: I(e[1] + "" + e[1]),
                g: I(e[2] + "" + e[2]),
                b: I(e[3] + "" + e[3]),
                a: R(e[4] + "" + e[4]),
                format: i ? "name" : "hex8"
              };
              if (e = j.hex3.exec(t)) return {
                r: I(e[1] + "" + e[1]),
                g: I(e[2] + "" + e[2]),
                b: I(e[3] + "" + e[3]),
                format: i ? "name" : "hex"
              };
              return !1;
            }(e));
            "object" == _typeof(e) && (U(e.r) && U(e.g) && U(e.b) ? (p = e.r, d = e.g, m = e.b, i = {
              r: 255 * C(p, 255),
              g: 255 * C(d, 255),
              b: 255 * C(m, 255)
            }, f = !0, h = "%" === String(e.r).substr(-1) ? "prgb" : "rgb") : U(e.h) && U(e.s) && U(e.v) ? (l = z(e.s), c = z(e.v), i = function (e, r, n) {
              e = 6 * C(e, 360), r = C(r, 100), n = C(n, 100);
              var i = t.floor(e),
                  a = e - i,
                  o = n * (1 - r),
                  s = n * (1 - a * r),
                  l = n * (1 - (1 - a) * r),
                  c = i % 6;
              return {
                r: 255 * [n, s, o, o, l, n][c],
                g: 255 * [l, n, n, s, o, o][c],
                b: 255 * [o, o, l, n, n, s][c]
              };
            }(e.h, l, c), f = !0, h = "hsv") : U(e.h) && U(e.s) && U(e.l) && (l = z(e.s), u = z(e.l), i = function (t, e, r) {
              var n, i, a;

              function o(t, e, r) {
                return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? t + 6 * (e - t) * r : r < .5 ? e : r < 2 / 3 ? t + (e - t) * (2 / 3 - r) * 6 : t;
              }

              if (t = C(t, 360), e = C(e, 100), r = C(r, 100), 0 === e) n = i = a = r;else {
                var s = r < .5 ? r * (1 + e) : r + e - r * e,
                    l = 2 * r - s;
                n = o(l, s, t + 1 / 3), i = o(l, s, t), a = o(l, s, t - 1 / 3);
              }
              return {
                r: 255 * n,
                g: 255 * i,
                b: 255 * a
              };
            }(e.h, l, u), f = !0, h = "hsl"), e.hasOwnProperty("a") && (a = e.a));
            var p, d, m;
            return a = L(a), {
              ok: f,
              format: e.format || h,
              r: o(255, s(i.r, 0)),
              g: o(255, s(i.g, 0)),
              b: o(255, s(i.b, 0)),
              a: a
            };
          }(e);

          this._originalInput = e, this._r = u.r, this._g = u.g, this._b = u.b, this._a = u.a, this._roundA = a(100 * this._a) / 100, this._format = l.format || u.format, this._gradientType = l.gradientType, this._r < 1 && (this._r = a(this._r)), this._g < 1 && (this._g = a(this._g)), this._b < 1 && (this._b = a(this._b)), this._ok = u.ok, this._tc_id = i++;
        }

        function u(t, e, r) {
          t = C(t, 255), e = C(e, 255), r = C(r, 255);
          var n,
              i,
              a = s(t, e, r),
              l = o(t, e, r),
              c = (a + l) / 2;
          if (a == l) n = i = 0;else {
            var u = a - l;

            switch (i = c > .5 ? u / (2 - a - l) : u / (a + l), a) {
              case t:
                n = (e - r) / u + (e < r ? 6 : 0);
                break;

              case e:
                n = (r - t) / u + 2;
                break;

              case r:
                n = (t - e) / u + 4;
            }

            n /= 6;
          }
          return {
            h: n,
            s: i,
            l: c
          };
        }

        function f(t, e, r) {
          t = C(t, 255), e = C(e, 255), r = C(r, 255);
          var n,
              i,
              a = s(t, e, r),
              l = o(t, e, r),
              c = a,
              u = a - l;
          if (i = 0 === a ? 0 : u / a, a == l) n = 0;else {
            switch (a) {
              case t:
                n = (e - r) / u + (e < r ? 6 : 0);
                break;

              case e:
                n = (r - t) / u + 2;
                break;

              case r:
                n = (t - e) / u + 4;
            }

            n /= 6;
          }
          return {
            h: n,
            s: i,
            v: c
          };
        }

        function h(t, e, r, n) {
          var i = [O(a(t).toString(16)), O(a(e).toString(16)), O(a(r).toString(16))];
          return n && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
        }

        function p(t, e, r, n) {
          return [O(D(n)), O(a(t).toString(16)), O(a(e).toString(16)), O(a(r).toString(16))].join("");
        }

        function d(t, e) {
          e = 0 === e ? 0 : e || 10;
          var r = c(t).toHsl();
          return r.s -= e / 100, r.s = P(r.s), c(r);
        }

        function m(t, e) {
          e = 0 === e ? 0 : e || 10;
          var r = c(t).toHsl();
          return r.s += e / 100, r.s = P(r.s), c(r);
        }

        function g(t) {
          return c(t).desaturate(100);
        }

        function v(t, e) {
          e = 0 === e ? 0 : e || 10;
          var r = c(t).toHsl();
          return r.l += e / 100, r.l = P(r.l), c(r);
        }

        function y(t, e) {
          e = 0 === e ? 0 : e || 10;
          var r = c(t).toRgb();
          return r.r = s(0, o(255, r.r - a(-e / 100 * 255))), r.g = s(0, o(255, r.g - a(-e / 100 * 255))), r.b = s(0, o(255, r.b - a(-e / 100 * 255))), c(r);
        }

        function x(t, e) {
          e = 0 === e ? 0 : e || 10;
          var r = c(t).toHsl();
          return r.l -= e / 100, r.l = P(r.l), c(r);
        }

        function b(t, e) {
          var r = c(t).toHsl(),
              n = (r.h + e) % 360;
          return r.h = n < 0 ? 360 + n : n, c(r);
        }

        function _(t) {
          var e = c(t).toHsl();
          return e.h = (e.h + 180) % 360, c(e);
        }

        function w(t) {
          var e = c(t).toHsl(),
              r = e.h;
          return [c(t), c({
            h: (r + 120) % 360,
            s: e.s,
            l: e.l
          }), c({
            h: (r + 240) % 360,
            s: e.s,
            l: e.l
          })];
        }

        function T(t) {
          var e = c(t).toHsl(),
              r = e.h;
          return [c(t), c({
            h: (r + 90) % 360,
            s: e.s,
            l: e.l
          }), c({
            h: (r + 180) % 360,
            s: e.s,
            l: e.l
          }), c({
            h: (r + 270) % 360,
            s: e.s,
            l: e.l
          })];
        }

        function k(t) {
          var e = c(t).toHsl(),
              r = e.h;
          return [c(t), c({
            h: (r + 72) % 360,
            s: e.s,
            l: e.l
          }), c({
            h: (r + 216) % 360,
            s: e.s,
            l: e.l
          })];
        }

        function M(t, e, r) {
          e = e || 6, r = r || 30;
          var n = c(t).toHsl(),
              i = 360 / r,
              a = [c(t)];

          for (n.h = (n.h - (i * e >> 1) + 720) % 360; --e;) {
            n.h = (n.h + i) % 360, a.push(c(n));
          }

          return a;
        }

        function A(t, e) {
          e = e || 6;

          for (var r = c(t).toHsv(), n = r.h, i = r.s, a = r.v, o = [], s = 1 / e; e--;) {
            o.push(c({
              h: n,
              s: i,
              v: a
            })), a = (a + s) % 1;
          }

          return o;
        }

        c.prototype = {
          isDark: function isDark() {
            return this.getBrightness() < 128;
          },
          isLight: function isLight() {
            return !this.isDark();
          },
          isValid: function isValid() {
            return this._ok;
          },
          getOriginalInput: function getOriginalInput() {
            return this._originalInput;
          },
          getFormat: function getFormat() {
            return this._format;
          },
          getAlpha: function getAlpha() {
            return this._a;
          },
          getBrightness: function getBrightness() {
            var t = this.toRgb();
            return (299 * t.r + 587 * t.g + 114 * t.b) / 1e3;
          },
          getLuminance: function getLuminance() {
            var e,
                r,
                n,
                i = this.toRgb();
            return e = i.r / 255, r = i.g / 255, n = i.b / 255, .2126 * (e <= .03928 ? e / 12.92 : t.pow((e + .055) / 1.055, 2.4)) + .7152 * (r <= .03928 ? r / 12.92 : t.pow((r + .055) / 1.055, 2.4)) + .0722 * (n <= .03928 ? n / 12.92 : t.pow((n + .055) / 1.055, 2.4));
          },
          setAlpha: function setAlpha(t) {
            return this._a = L(t), this._roundA = a(100 * this._a) / 100, this;
          },
          toHsv: function toHsv() {
            var t = f(this._r, this._g, this._b);
            return {
              h: 360 * t.h,
              s: t.s,
              v: t.v,
              a: this._a
            };
          },
          toHsvString: function toHsvString() {
            var t = f(this._r, this._g, this._b),
                e = a(360 * t.h),
                r = a(100 * t.s),
                n = a(100 * t.v);
            return 1 == this._a ? "hsv(" + e + ", " + r + "%, " + n + "%)" : "hsva(" + e + ", " + r + "%, " + n + "%, " + this._roundA + ")";
          },
          toHsl: function toHsl() {
            var t = u(this._r, this._g, this._b);
            return {
              h: 360 * t.h,
              s: t.s,
              l: t.l,
              a: this._a
            };
          },
          toHslString: function toHslString() {
            var t = u(this._r, this._g, this._b),
                e = a(360 * t.h),
                r = a(100 * t.s),
                n = a(100 * t.l);
            return 1 == this._a ? "hsl(" + e + ", " + r + "%, " + n + "%)" : "hsla(" + e + ", " + r + "%, " + n + "%, " + this._roundA + ")";
          },
          toHex: function toHex(t) {
            return h(this._r, this._g, this._b, t);
          },
          toHexString: function toHexString(t) {
            return "#" + this.toHex(t);
          },
          toHex8: function toHex8(t) {
            return function (t, e, r, n, i) {
              var o = [O(a(t).toString(16)), O(a(e).toString(16)), O(a(r).toString(16)), O(D(n))];
              if (i && o[0].charAt(0) == o[0].charAt(1) && o[1].charAt(0) == o[1].charAt(1) && o[2].charAt(0) == o[2].charAt(1) && o[3].charAt(0) == o[3].charAt(1)) return o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) + o[3].charAt(0);
              return o.join("");
            }(this._r, this._g, this._b, this._a, t);
          },
          toHex8String: function toHex8String(t) {
            return "#" + this.toHex8(t);
          },
          toRgb: function toRgb() {
            return {
              r: a(this._r),
              g: a(this._g),
              b: a(this._b),
              a: this._a
            };
          },
          toRgbString: function toRgbString() {
            return 1 == this._a ? "rgb(" + a(this._r) + ", " + a(this._g) + ", " + a(this._b) + ")" : "rgba(" + a(this._r) + ", " + a(this._g) + ", " + a(this._b) + ", " + this._roundA + ")";
          },
          toPercentageRgb: function toPercentageRgb() {
            return {
              r: a(100 * C(this._r, 255)) + "%",
              g: a(100 * C(this._g, 255)) + "%",
              b: a(100 * C(this._b, 255)) + "%",
              a: this._a
            };
          },
          toPercentageRgbString: function toPercentageRgbString() {
            return 1 == this._a ? "rgb(" + a(100 * C(this._r, 255)) + "%, " + a(100 * C(this._g, 255)) + "%, " + a(100 * C(this._b, 255)) + "%)" : "rgba(" + a(100 * C(this._r, 255)) + "%, " + a(100 * C(this._g, 255)) + "%, " + a(100 * C(this._b, 255)) + "%, " + this._roundA + ")";
          },
          toName: function toName() {
            return 0 === this._a ? "transparent" : !(this._a < 1) && (E[h(this._r, this._g, this._b, !0)] || !1);
          },
          toFilter: function toFilter(t) {
            var e = "#" + p(this._r, this._g, this._b, this._a),
                r = e,
                n = this._gradientType ? "GradientType = 1, " : "";

            if (t) {
              var i = c(t);
              r = "#" + p(i._r, i._g, i._b, i._a);
            }

            return "progid:DXImageTransform.Microsoft.gradient(" + n + "startColorstr=" + e + ",endColorstr=" + r + ")";
          },
          toString: function toString(t) {
            var e = !!t;
            t = t || this._format;
            var r = !1,
                n = this._a < 1 && this._a >= 0;
            return e || !n || "hex" !== t && "hex6" !== t && "hex3" !== t && "hex4" !== t && "hex8" !== t && "name" !== t ? ("rgb" === t && (r = this.toRgbString()), "prgb" === t && (r = this.toPercentageRgbString()), "hex" !== t && "hex6" !== t || (r = this.toHexString()), "hex3" === t && (r = this.toHexString(!0)), "hex4" === t && (r = this.toHex8String(!0)), "hex8" === t && (r = this.toHex8String()), "name" === t && (r = this.toName()), "hsl" === t && (r = this.toHslString()), "hsv" === t && (r = this.toHsvString()), r || this.toHexString()) : "name" === t && 0 === this._a ? this.toName() : this.toRgbString();
          },
          clone: function clone() {
            return c(this.toString());
          },
          _applyModification: function _applyModification(t, e) {
            var r = t.apply(null, [this].concat([].slice.call(e)));
            return this._r = r._r, this._g = r._g, this._b = r._b, this.setAlpha(r._a), this;
          },
          lighten: function lighten() {
            return this._applyModification(v, arguments);
          },
          brighten: function brighten() {
            return this._applyModification(y, arguments);
          },
          darken: function darken() {
            return this._applyModification(x, arguments);
          },
          desaturate: function desaturate() {
            return this._applyModification(d, arguments);
          },
          saturate: function saturate() {
            return this._applyModification(m, arguments);
          },
          greyscale: function greyscale() {
            return this._applyModification(g, arguments);
          },
          spin: function spin() {
            return this._applyModification(b, arguments);
          },
          _applyCombination: function _applyCombination(t, e) {
            return t.apply(null, [this].concat([].slice.call(e)));
          },
          analogous: function analogous() {
            return this._applyCombination(M, arguments);
          },
          complement: function complement() {
            return this._applyCombination(_, arguments);
          },
          monochromatic: function monochromatic() {
            return this._applyCombination(A, arguments);
          },
          splitcomplement: function splitcomplement() {
            return this._applyCombination(k, arguments);
          },
          triad: function triad() {
            return this._applyCombination(w, arguments);
          },
          tetrad: function tetrad() {
            return this._applyCombination(T, arguments);
          }
        }, c.fromRatio = function (t, e) {
          if ("object" == _typeof(t)) {
            var r = {};

            for (var n in t) {
              t.hasOwnProperty(n) && (r[n] = "a" === n ? t[n] : z(t[n]));
            }

            t = r;
          }

          return c(t, e);
        }, c.equals = function (t, e) {
          return !(!t || !e) && c(t).toRgbString() == c(e).toRgbString();
        }, c.random = function () {
          return c.fromRatio({
            r: l(),
            g: l(),
            b: l()
          });
        }, c.mix = function (t, e, r) {
          r = 0 === r ? 0 : r || 50;
          var n = c(t).toRgb(),
              i = c(e).toRgb(),
              a = r / 100;
          return c({
            r: (i.r - n.r) * a + n.r,
            g: (i.g - n.g) * a + n.g,
            b: (i.b - n.b) * a + n.b,
            a: (i.a - n.a) * a + n.a
          });
        }, c.readability = function (e, r) {
          var n = c(e),
              i = c(r);
          return (t.max(n.getLuminance(), i.getLuminance()) + .05) / (t.min(n.getLuminance(), i.getLuminance()) + .05);
        }, c.isReadable = function (t, e, r) {
          var n,
              i,
              a = c.readability(t, e);

          switch (i = !1, (n = function (t) {
            var e, r;
            e = ((t = t || {
              level: "AA",
              size: "small"
            }).level || "AA").toUpperCase(), r = (t.size || "small").toLowerCase(), "AA" !== e && "AAA" !== e && (e = "AA");
            "small" !== r && "large" !== r && (r = "small");
            return {
              level: e,
              size: r
            };
          }(r)).level + n.size) {
            case "AAsmall":
            case "AAAlarge":
              i = a >= 4.5;
              break;

            case "AAlarge":
              i = a >= 3;
              break;

            case "AAAsmall":
              i = a >= 7;
          }

          return i;
        }, c.mostReadable = function (t, e, r) {
          var n,
              i,
              a,
              o,
              s = null,
              l = 0;
          i = (r = r || {}).includeFallbackColors, a = r.level, o = r.size;

          for (var u = 0; u < e.length; u++) {
            (n = c.readability(t, e[u])) > l && (l = n, s = c(e[u]));
          }

          return c.isReadable(t, s, {
            level: a,
            size: o
          }) || !i ? s : (r.includeFallbackColors = !1, c.mostReadable(t, ["#fff", "#000"], r));
        };

        var S = c.names = {
          aliceblue: "f0f8ff",
          antiquewhite: "faebd7",
          aqua: "0ff",
          aquamarine: "7fffd4",
          azure: "f0ffff",
          beige: "f5f5dc",
          bisque: "ffe4c4",
          black: "000",
          blanchedalmond: "ffebcd",
          blue: "00f",
          blueviolet: "8a2be2",
          brown: "a52a2a",
          burlywood: "deb887",
          burntsienna: "ea7e5d",
          cadetblue: "5f9ea0",
          chartreuse: "7fff00",
          chocolate: "d2691e",
          coral: "ff7f50",
          cornflowerblue: "6495ed",
          cornsilk: "fff8dc",
          crimson: "dc143c",
          cyan: "0ff",
          darkblue: "00008b",
          darkcyan: "008b8b",
          darkgoldenrod: "b8860b",
          darkgray: "a9a9a9",
          darkgreen: "006400",
          darkgrey: "a9a9a9",
          darkkhaki: "bdb76b",
          darkmagenta: "8b008b",
          darkolivegreen: "556b2f",
          darkorange: "ff8c00",
          darkorchid: "9932cc",
          darkred: "8b0000",
          darksalmon: "e9967a",
          darkseagreen: "8fbc8f",
          darkslateblue: "483d8b",
          darkslategray: "2f4f4f",
          darkslategrey: "2f4f4f",
          darkturquoise: "00ced1",
          darkviolet: "9400d3",
          deeppink: "ff1493",
          deepskyblue: "00bfff",
          dimgray: "696969",
          dimgrey: "696969",
          dodgerblue: "1e90ff",
          firebrick: "b22222",
          floralwhite: "fffaf0",
          forestgreen: "228b22",
          fuchsia: "f0f",
          gainsboro: "dcdcdc",
          ghostwhite: "f8f8ff",
          gold: "ffd700",
          goldenrod: "daa520",
          gray: "808080",
          green: "008000",
          greenyellow: "adff2f",
          grey: "808080",
          honeydew: "f0fff0",
          hotpink: "ff69b4",
          indianred: "cd5c5c",
          indigo: "4b0082",
          ivory: "fffff0",
          khaki: "f0e68c",
          lavender: "e6e6fa",
          lavenderblush: "fff0f5",
          lawngreen: "7cfc00",
          lemonchiffon: "fffacd",
          lightblue: "add8e6",
          lightcoral: "f08080",
          lightcyan: "e0ffff",
          lightgoldenrodyellow: "fafad2",
          lightgray: "d3d3d3",
          lightgreen: "90ee90",
          lightgrey: "d3d3d3",
          lightpink: "ffb6c1",
          lightsalmon: "ffa07a",
          lightseagreen: "20b2aa",
          lightskyblue: "87cefa",
          lightslategray: "789",
          lightslategrey: "789",
          lightsteelblue: "b0c4de",
          lightyellow: "ffffe0",
          lime: "0f0",
          limegreen: "32cd32",
          linen: "faf0e6",
          magenta: "f0f",
          maroon: "800000",
          mediumaquamarine: "66cdaa",
          mediumblue: "0000cd",
          mediumorchid: "ba55d3",
          mediumpurple: "9370db",
          mediumseagreen: "3cb371",
          mediumslateblue: "7b68ee",
          mediumspringgreen: "00fa9a",
          mediumturquoise: "48d1cc",
          mediumvioletred: "c71585",
          midnightblue: "191970",
          mintcream: "f5fffa",
          mistyrose: "ffe4e1",
          moccasin: "ffe4b5",
          navajowhite: "ffdead",
          navy: "000080",
          oldlace: "fdf5e6",
          olive: "808000",
          olivedrab: "6b8e23",
          orange: "ffa500",
          orangered: "ff4500",
          orchid: "da70d6",
          palegoldenrod: "eee8aa",
          palegreen: "98fb98",
          paleturquoise: "afeeee",
          palevioletred: "db7093",
          papayawhip: "ffefd5",
          peachpuff: "ffdab9",
          peru: "cd853f",
          pink: "ffc0cb",
          plum: "dda0dd",
          powderblue: "b0e0e6",
          purple: "800080",
          rebeccapurple: "663399",
          red: "f00",
          rosybrown: "bc8f8f",
          royalblue: "4169e1",
          saddlebrown: "8b4513",
          salmon: "fa8072",
          sandybrown: "f4a460",
          seagreen: "2e8b57",
          seashell: "fff5ee",
          sienna: "a0522d",
          silver: "c0c0c0",
          skyblue: "87ceeb",
          slateblue: "6a5acd",
          slategray: "708090",
          slategrey: "708090",
          snow: "fffafa",
          springgreen: "00ff7f",
          steelblue: "4682b4",
          tan: "d2b48c",
          teal: "008080",
          thistle: "d8bfd8",
          tomato: "ff6347",
          turquoise: "40e0d0",
          violet: "ee82ee",
          wheat: "f5deb3",
          white: "fff",
          whitesmoke: "f5f5f5",
          yellow: "ff0",
          yellowgreen: "9acd32"
        },
            E = c.hexNames = function (t) {
          var e = {};

          for (var r in t) {
            t.hasOwnProperty(r) && (e[t[r]] = r);
          }

          return e;
        }(S);

        function L(t) {
          return t = parseFloat(t), (isNaN(t) || t < 0 || t > 1) && (t = 1), t;
        }

        function C(e, r) {
          (function (t) {
            return "string" == typeof t && -1 != t.indexOf(".") && 1 === parseFloat(t);
          })(e) && (e = "100%");

          var n = function (t) {
            return "string" == typeof t && -1 != t.indexOf("%");
          }(e);

          return e = o(r, s(0, parseFloat(e))), n && (e = parseInt(e * r, 10) / 100), t.abs(e - r) < 1e-6 ? 1 : e % r / parseFloat(r);
        }

        function P(t) {
          return o(1, s(0, t));
        }

        function I(t) {
          return parseInt(t, 16);
        }

        function O(t) {
          return 1 == t.length ? "0" + t : "" + t;
        }

        function z(t) {
          return t <= 1 && (t = 100 * t + "%"), t;
        }

        function D(e) {
          return t.round(255 * parseFloat(e)).toString(16);
        }

        function R(t) {
          return I(t) / 255;
        }

        var F,
            B,
            N,
            j = (B = "[\\s|\\(]+(" + (F = "(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)") + ")[,|\\s]+(" + F + ")[,|\\s]+(" + F + ")\\s*\\)?", N = "[\\s|\\(]+(" + F + ")[,|\\s]+(" + F + ")[,|\\s]+(" + F + ")[,|\\s]+(" + F + ")\\s*\\)?", {
          CSS_UNIT: new RegExp(F),
          rgb: new RegExp("rgb" + B),
          rgba: new RegExp("rgba" + N),
          hsl: new RegExp("hsl" + B),
          hsla: new RegExp("hsla" + N),
          hsv: new RegExp("hsv" + B),
          hsva: new RegExp("hsva" + N),
          hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
          hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
          hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
          hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        });

        function U(t) {
          return !!j.CSS_UNIT.exec(t);
        }

        void 0 !== e && e.exports ? e.exports = c : window.tinycolor = c;
      }(Math);
    }, {}],
    591: [function (t, e, r) {
      "use strict";

      e.exports = i, e.exports.float32 = e.exports.float = i, e.exports.fract32 = e.exports.fract = function (t) {
        if (t.length) {
          for (var e = i(t), r = 0, n = e.length; r < n; r++) {
            e[r] = t[r] - e[r];
          }

          return e;
        }

        return i(t - i(t));
      };
      var n = new Float32Array(1);

      function i(t) {
        if (t.length) {
          if (t instanceof Float32Array) return t;
          var e = new Float32Array(t);
          return e.set(t), e;
        }

        return n[0] = t, n[0];
      }
    }, {}],
    592: [function (t, e, r) {
      "use strict";

      var n = t("parse-unit");
      e.exports = a;

      function i(t, e) {
        var r = n(getComputedStyle(t).getPropertyValue(e));
        return r[0] * a(r[1], t);
      }

      function a(t, e) {
        switch (e = e || document.body, t = (t || "px").trim().toLowerCase(), e !== window && e !== document || (e = document.body), t) {
          case "%":
            return e.clientHeight / 100;

          case "ch":
          case "ex":
            return function (t, e) {
              var r = document.createElement("div");
              r.style["font-size"] = "128" + t, e.appendChild(r);
              var n = i(r, "font-size") / 128;
              return e.removeChild(r), n;
            }(t, e);

          case "em":
            return i(e, "font-size");

          case "rem":
            return i(document.body, "font-size");

          case "vw":
            return window.innerWidth / 100;

          case "vh":
            return window.innerHeight / 100;

          case "vmin":
            return Math.min(window.innerWidth, window.innerHeight) / 100;

          case "vmax":
            return Math.max(window.innerWidth, window.innerHeight) / 100;

          case "in":
            return 96;

          case "cm":
            return 96 / 2.54;

          case "mm":
            return 96 / 25.4;

          case "pt":
            return 96 / 72;

          case "pc":
            return 16;
        }

        return 1;
      }
    }, {
      "parse-unit": 486
    }],
    593: [function (t, e, r) {
      !function (t, n) {
        "object" == _typeof(r) && void 0 !== e ? n(r) : n((t = t || self).topojson = t.topojson || {});
      }(this, function (t) {
        "use strict";

        function e(t) {
          return t;
        }

        function r(t) {
          if (null == t) return e;
          var r,
              n,
              i = t.scale[0],
              a = t.scale[1],
              o = t.translate[0],
              s = t.translate[1];
          return function (t, e) {
            e || (r = n = 0);
            var l = 2,
                c = t.length,
                u = new Array(c);

            for (u[0] = (r += t[0]) * i + o, u[1] = (n += t[1]) * a + s; l < c;) {
              u[l] = t[l], ++l;
            }

            return u;
          };
        }

        function n(t) {
          var e,
              n = r(t.transform),
              i = 1 / 0,
              a = i,
              o = -i,
              s = -i;

          function l(t) {
            (t = n(t))[0] < i && (i = t[0]), t[0] > o && (o = t[0]), t[1] < a && (a = t[1]), t[1] > s && (s = t[1]);
          }

          function c(t) {
            switch (t.type) {
              case "GeometryCollection":
                t.geometries.forEach(c);
                break;

              case "Point":
                l(t.coordinates);
                break;

              case "MultiPoint":
                t.coordinates.forEach(l);
            }
          }

          for (e in t.arcs.forEach(function (t) {
            for (var e, r = -1, l = t.length; ++r < l;) {
              (e = n(t[r], r))[0] < i && (i = e[0]), e[0] > o && (o = e[0]), e[1] < a && (a = e[1]), e[1] > s && (s = e[1]);
            }
          }), t.objects) {
            c(t.objects[e]);
          }

          return [i, a, o, s];
        }

        function i(t, e) {
          var r = e.id,
              n = e.bbox,
              i = null == e.properties ? {} : e.properties,
              o = a(t, e);
          return null == r && null == n ? {
            type: "Feature",
            properties: i,
            geometry: o
          } : null == n ? {
            type: "Feature",
            id: r,
            properties: i,
            geometry: o
          } : {
            type: "Feature",
            id: r,
            bbox: n,
            properties: i,
            geometry: o
          };
        }

        function a(t, e) {
          var n = r(t.transform),
              i = t.arcs;

          function a(t, e) {
            e.length && e.pop();

            for (var r = i[t < 0 ? ~t : t], a = 0, o = r.length; a < o; ++a) {
              e.push(n(r[a], a));
            }

            t < 0 && function (t, e) {
              for (var r, n = t.length, i = n - e; i < --n;) {
                r = t[i], t[i++] = t[n], t[n] = r;
              }
            }(e, o);
          }

          function o(t) {
            return n(t);
          }

          function s(t) {
            for (var e = [], r = 0, n = t.length; r < n; ++r) {
              a(t[r], e);
            }

            return e.length < 2 && e.push(e[0]), e;
          }

          function l(t) {
            for (var e = s(t); e.length < 4;) {
              e.push(e[0]);
            }

            return e;
          }

          function c(t) {
            return t.map(l);
          }

          return function t(e) {
            var r,
                n = e.type;

            switch (n) {
              case "GeometryCollection":
                return {
                  type: n,
                  geometries: e.geometries.map(t)
                };

              case "Point":
                r = o(e.coordinates);
                break;

              case "MultiPoint":
                r = e.coordinates.map(o);
                break;

              case "LineString":
                r = s(e.arcs);
                break;

              case "MultiLineString":
                r = e.arcs.map(s);
                break;

              case "Polygon":
                r = c(e.arcs);
                break;

              case "MultiPolygon":
                r = e.arcs.map(c);
                break;

              default:
                return null;
            }

            return {
              type: n,
              coordinates: r
            };
          }(e);
        }

        function o(t, e) {
          var r = {},
              n = {},
              i = {},
              a = [],
              o = -1;

          function s(t, e) {
            for (var n in t) {
              var i = t[n];
              delete e[i.start], delete i.start, delete i.end, i.forEach(function (t) {
                r[t < 0 ? ~t : t] = 1;
              }), a.push(i);
            }
          }

          return e.forEach(function (r, n) {
            var i,
                a = t.arcs[r < 0 ? ~r : r];
            a.length < 3 && !a[1][0] && !a[1][1] && (i = e[++o], e[o] = r, e[n] = i);
          }), e.forEach(function (e) {
            var r,
                a,
                o = function (e) {
              var r,
                  n = t.arcs[e < 0 ? ~e : e],
                  i = n[0];
              t.transform ? (r = [0, 0], n.forEach(function (t) {
                r[0] += t[0], r[1] += t[1];
              })) : r = n[n.length - 1];
              return e < 0 ? [r, i] : [i, r];
            }(e),
                s = o[0],
                l = o[1];

            if (r = i[s]) {
              if (delete i[r.end], r.push(e), r.end = l, a = n[l]) {
                delete n[a.start];
                var c = a === r ? r : r.concat(a);
                n[c.start = r.start] = i[c.end = a.end] = c;
              } else n[r.start] = i[r.end] = r;
            } else if (r = n[l]) {
              if (delete n[r.start], r.unshift(e), r.start = s, a = i[s]) {
                delete i[a.end];
                var u = a === r ? r : a.concat(r);
                n[u.start = a.start] = i[u.end = r.end] = u;
              } else n[r.start] = i[r.end] = r;
            } else n[(r = [e]).start = s] = i[r.end = l] = r;
          }), s(i, n), s(n, i), e.forEach(function (t) {
            r[t < 0 ? ~t : t] || a.push([t]);
          }), a;
        }

        function s(t, e, r) {
          var n, i, a;
          if (arguments.length > 1) n = l(t, e, r);else for (i = 0, n = new Array(a = t.arcs.length); i < a; ++i) {
            n[i] = i;
          }
          return {
            type: "MultiLineString",
            arcs: o(t, n)
          };
        }

        function l(t, e, r) {
          var n,
              i = [],
              a = [];

          function o(t) {
            var e = t < 0 ? ~t : t;
            (a[e] || (a[e] = [])).push({
              i: t,
              g: n
            });
          }

          function s(t) {
            t.forEach(o);
          }

          function l(t) {
            t.forEach(s);
          }

          return function t(e) {
            switch (n = e, e.type) {
              case "GeometryCollection":
                e.geometries.forEach(t);
                break;

              case "LineString":
                s(e.arcs);
                break;

              case "MultiLineString":
              case "Polygon":
                l(e.arcs);
                break;

              case "MultiPolygon":
                !function (t) {
                  t.forEach(l);
                }(e.arcs);
            }
          }(e), a.forEach(null == r ? function (t) {
            i.push(t[0].i);
          } : function (t) {
            r(t[0].g, t[t.length - 1].g) && i.push(t[0].i);
          }), i;
        }

        function c(t, e) {
          var r = {},
              n = [],
              i = [];

          function s(t) {
            t.forEach(function (e) {
              e.forEach(function (e) {
                (r[e = e < 0 ? ~e : e] || (r[e] = [])).push(t);
              });
            }), n.push(t);
          }

          function l(e) {
            return function (t) {
              for (var e, r = -1, n = t.length, i = t[n - 1], a = 0; ++r < n;) {
                e = i, i = t[r], a += e[0] * i[1] - e[1] * i[0];
              }

              return Math.abs(a);
            }(a(t, {
              type: "Polygon",
              arcs: [e]
            }).coordinates[0]);
          }

          return e.forEach(function t(e) {
            switch (e.type) {
              case "GeometryCollection":
                e.geometries.forEach(t);
                break;

              case "Polygon":
                s(e.arcs);
                break;

              case "MultiPolygon":
                e.arcs.forEach(s);
            }
          }), n.forEach(function (t) {
            if (!t._) {
              var e = [],
                  n = [t];

              for (t._ = 1, i.push(e); t = n.pop();) {
                e.push(t), t.forEach(function (t) {
                  t.forEach(function (t) {
                    r[t < 0 ? ~t : t].forEach(function (t) {
                      t._ || (t._ = 1, n.push(t));
                    });
                  });
                });
              }
            }
          }), n.forEach(function (t) {
            delete t._;
          }), {
            type: "MultiPolygon",
            arcs: i.map(function (e) {
              var n,
                  i = [];
              if (e.forEach(function (t) {
                t.forEach(function (t) {
                  t.forEach(function (t) {
                    r[t < 0 ? ~t : t].length < 2 && i.push(t);
                  });
                });
              }), (n = (i = o(t, i)).length) > 1) for (var a, s, c = 1, u = l(i[0]); c < n; ++c) {
                (a = l(i[c])) > u && (s = i[0], i[0] = i[c], i[c] = s, u = a);
              }
              return i;
            }).filter(function (t) {
              return t.length > 0;
            })
          };
        }

        function u(t, e) {
          for (var r = 0, n = t.length; r < n;) {
            var i = r + n >>> 1;
            t[i] < e ? r = i + 1 : n = i;
          }

          return r;
        }

        function f(t) {
          if (null == t) return e;
          var r,
              n,
              i = t.scale[0],
              a = t.scale[1],
              o = t.translate[0],
              s = t.translate[1];
          return function (t, e) {
            e || (r = n = 0);
            var l = 2,
                c = t.length,
                u = new Array(c),
                f = Math.round((t[0] - o) / i),
                h = Math.round((t[1] - s) / a);

            for (u[0] = f - r, r = f, u[1] = h - n, n = h; l < c;) {
              u[l] = t[l], ++l;
            }

            return u;
          };
        }

        t.bbox = n, t.feature = function (t, e) {
          return "string" == typeof e && (e = t.objects[e]), "GeometryCollection" === e.type ? {
            type: "FeatureCollection",
            features: e.geometries.map(function (e) {
              return i(t, e);
            })
          } : i(t, e);
        }, t.merge = function (t) {
          return a(t, c.apply(this, arguments));
        }, t.mergeArcs = c, t.mesh = function (t) {
          return a(t, s.apply(this, arguments));
        }, t.meshArcs = s, t.neighbors = function (t) {
          var e = {},
              r = t.map(function () {
            return [];
          });

          function n(t, r) {
            t.forEach(function (t) {
              t < 0 && (t = ~t);
              var n = e[t];
              n ? n.push(r) : e[t] = [r];
            });
          }

          function i(t, e) {
            t.forEach(function (t) {
              n(t, e);
            });
          }

          var a = {
            LineString: n,
            MultiLineString: i,
            Polygon: i,
            MultiPolygon: function MultiPolygon(t, e) {
              t.forEach(function (t) {
                i(t, e);
              });
            }
          };

          for (var o in t.forEach(function t(e, r) {
            "GeometryCollection" === e.type ? e.geometries.forEach(function (e) {
              t(e, r);
            }) : e.type in a && a[e.type](e.arcs, r);
          }), e) {
            for (var s = e[o], l = s.length, c = 0; c < l; ++c) {
              for (var f = c + 1; f < l; ++f) {
                var h,
                    p = s[c],
                    d = s[f];
                (h = r[p])[o = u(h, d)] !== d && h.splice(o, 0, d), (h = r[d])[o = u(h, p)] !== p && h.splice(o, 0, p);
              }
            }
          }

          return r;
        }, t.quantize = function (t, e) {
          if (t.transform) throw new Error("already quantized");
          if (e && e.scale) l = t.bbox;else {
            if (!((r = Math.floor(e)) >= 2)) throw new Error("n must be \u22652");
            var r,
                i = (l = t.bbox || n(t))[0],
                a = l[1],
                o = l[2],
                s = l[3];
            e = {
              scale: [o - i ? (o - i) / (r - 1) : 1, s - a ? (s - a) / (r - 1) : 1],
              translate: [i, a]
            };
          }
          var l,
              c,
              u = f(e),
              h = t.objects,
              p = {};

          function d(t) {
            return u(t);
          }

          function m(t) {
            var e;

            switch (t.type) {
              case "GeometryCollection":
                e = {
                  type: "GeometryCollection",
                  geometries: t.geometries.map(m)
                };
                break;

              case "Point":
                e = {
                  type: "Point",
                  coordinates: d(t.coordinates)
                };
                break;

              case "MultiPoint":
                e = {
                  type: "MultiPoint",
                  coordinates: t.coordinates.map(d)
                };
                break;

              default:
                return t;
            }

            return null != t.id && (e.id = t.id), null != t.bbox && (e.bbox = t.bbox), null != t.properties && (e.properties = t.properties), e;
          }

          for (c in h) {
            p[c] = m(h[c]);
          }

          return {
            type: "Topology",
            bbox: l,
            transform: e,
            objects: p,
            arcs: t.arcs.map(function (t) {
              var e,
                  r = 0,
                  n = 1,
                  i = t.length,
                  a = new Array(i);

              for (a[0] = u(t[0], 0); ++r < i;) {
                ((e = u(t[r], r))[0] || e[1]) && (a[n++] = e);
              }

              return 1 === n && (a[n++] = [0, 0]), a.length = n, a;
            })
          };
        }, t.transform = r, t.untransform = f, Object.defineProperty(t, "__esModule", {
          value: !0
        });
      });
    }, {}],
    594: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        if (t < 0) return [];
        if (0 === t) return [[0]];

        for (var e = 0 | Math.round(a(t + 1)), r = [], o = 0; o < e; ++o) {
          for (var s = n.unrank(t, o), l = [0], c = 0, u = 0; u < s.length; ++u) {
            c += 1 << s[u], l.push(c);
          }

          i(s) < 1 && (l[0] = c, l[t] = 0), r.push(l);
        }

        return r;
      };

      var n = t("permutation-rank"),
          i = t("permutation-parity"),
          a = t("gamma");
    }, {
      gamma: 247,
      "permutation-parity": 488,
      "permutation-rank": 489
    }],
    595: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        var e = (t = t || {}).center || [0, 0, 0],
            r = t.up || [0, 1, 0],
            n = t.right || f(r),
            i = t.radius || 1,
            a = t.theta || 0,
            u = t.phi || 0;

        if (e = [].slice.call(e, 0, 3), r = [].slice.call(r, 0, 3), s(r, r), n = [].slice.call(n, 0, 3), s(n, n), "eye" in t) {
          var p = t.eye,
              d = [p[0] - e[0], p[1] - e[1], p[2] - e[2]];
          o(n, d, r), c(n[0], n[1], n[2]) < 1e-6 ? n = f(r) : s(n, n), i = c(d[0], d[1], d[2]);
          var m = l(r, d) / i,
              g = l(n, d) / i;
          u = Math.acos(m), a = Math.acos(g);
        }

        return i = Math.log(i), new h(t.zoomMin, t.zoomMax, e, r, n, i, a, u);
      };

      var n = t("filtered-vector"),
          i = t("gl-mat4/invert"),
          a = t("gl-mat4/rotate"),
          o = t("gl-vec3/cross"),
          s = t("gl-vec3/normalize"),
          l = t("gl-vec3/dot");

      function c(t, e, r) {
        return Math.sqrt(Math.pow(t, 2) + Math.pow(e, 2) + Math.pow(r, 2));
      }

      function u(t) {
        return Math.min(1, Math.max(-1, t));
      }

      function f(t) {
        var e = Math.abs(t[0]),
            r = Math.abs(t[1]),
            n = Math.abs(t[2]),
            i = [0, 0, 0];
        e > Math.max(r, n) ? i[2] = 1 : r > Math.max(e, n) ? i[0] = 1 : i[1] = 1;

        for (var a = 0, o = 0, l = 0; l < 3; ++l) {
          a += t[l] * t[l], o += i[l] * t[l];
        }

        for (l = 0; l < 3; ++l) {
          i[l] -= o / a * t[l];
        }

        return s(i, i), i;
      }

      function h(t, e, r, i, a, o, s, l) {
        this.center = n(r), this.up = n(i), this.right = n(a), this.radius = n([o]), this.angle = n([s, l]), this.angle.bounds = [[-1 / 0, -Math.PI / 2], [1 / 0, Math.PI / 2]], this.setDistanceLimits(t, e), this.computedCenter = this.center.curve(0), this.computedUp = this.up.curve(0), this.computedRight = this.right.curve(0), this.computedRadius = this.radius.curve(0), this.computedAngle = this.angle.curve(0), this.computedToward = [0, 0, 0], this.computedEye = [0, 0, 0], this.computedMatrix = new Array(16);

        for (var c = 0; c < 16; ++c) {
          this.computedMatrix[c] = .5;
        }

        this.recalcMatrix(0);
      }

      var p = h.prototype;
      p.setDistanceLimits = function (t, e) {
        t = t > 0 ? Math.log(t) : -1 / 0, e = e > 0 ? Math.log(e) : 1 / 0, e = Math.max(e, t), this.radius.bounds[0][0] = t, this.radius.bounds[1][0] = e;
      }, p.getDistanceLimits = function (t) {
        var e = this.radius.bounds[0];
        return t ? (t[0] = Math.exp(e[0][0]), t[1] = Math.exp(e[1][0]), t) : [Math.exp(e[0][0]), Math.exp(e[1][0])];
      }, p.recalcMatrix = function (t) {
        this.center.curve(t), this.up.curve(t), this.right.curve(t), this.radius.curve(t), this.angle.curve(t);

        for (var e = this.computedUp, r = this.computedRight, n = 0, i = 0, a = 0; a < 3; ++a) {
          i += e[a] * r[a], n += e[a] * e[a];
        }

        var l = Math.sqrt(n),
            u = 0;

        for (a = 0; a < 3; ++a) {
          r[a] -= e[a] * i / n, u += r[a] * r[a], e[a] /= l;
        }

        var f = Math.sqrt(u);

        for (a = 0; a < 3; ++a) {
          r[a] /= f;
        }

        var h = this.computedToward;
        o(h, e, r), s(h, h);

        var p = Math.exp(this.computedRadius[0]),
            d = this.computedAngle[0],
            m = this.computedAngle[1],
            g = Math.cos(d),
            v = Math.sin(d),
            y = Math.cos(m),
            x = Math.sin(m),
            b = this.computedCenter,
            _ = g * y,
            w = v * y,
            T = x,
            k = -g * x,
            M = -v * x,
            A = y,
            S = this.computedEye,
            E = this.computedMatrix;

        for (a = 0; a < 3; ++a) {
          var L = _ * r[a] + w * h[a] + T * e[a];
          E[4 * a + 1] = k * r[a] + M * h[a] + A * e[a], E[4 * a + 2] = L, E[4 * a + 3] = 0;
        }

        var C = E[1],
            P = E[5],
            I = E[9],
            O = E[2],
            z = E[6],
            D = E[10],
            R = P * D - I * z,
            F = I * O - C * D,
            B = C * z - P * O,
            N = c(R, F, B);
        R /= N, F /= N, B /= N, E[0] = R, E[4] = F, E[8] = B;

        for (a = 0; a < 3; ++a) {
          S[a] = b[a] + E[2 + 4 * a] * p;
        }

        for (a = 0; a < 3; ++a) {
          u = 0;

          for (var j = 0; j < 3; ++j) {
            u += E[a + 4 * j] * S[j];
          }

          E[12 + a] = -u;
        }

        E[15] = 1;
      }, p.getMatrix = function (t, e) {
        this.recalcMatrix(t);
        var r = this.computedMatrix;

        if (e) {
          for (var n = 0; n < 16; ++n) {
            e[n] = r[n];
          }

          return e;
        }

        return r;
      };
      var d = [0, 0, 0];
      p.rotate = function (t, e, r, n) {
        if (this.angle.move(t, e, r), n) {
          this.recalcMatrix(t);
          var i = this.computedMatrix;
          d[0] = i[2], d[1] = i[6], d[2] = i[10];

          for (var o = this.computedUp, s = this.computedRight, l = this.computedToward, c = 0; c < 3; ++c) {
            i[4 * c] = o[c], i[4 * c + 1] = s[c], i[4 * c + 2] = l[c];
          }

          a(i, i, n, d);

          for (c = 0; c < 3; ++c) {
            o[c] = i[4 * c], s[c] = i[4 * c + 1];
          }

          this.up.set(t, o[0], o[1], o[2]), this.right.set(t, s[0], s[1], s[2]);
        }
      }, p.pan = function (t, e, r, n) {
        e = e || 0, r = r || 0, n = n || 0, this.recalcMatrix(t);
        var i = this.computedMatrix,
            a = (Math.exp(this.computedRadius[0]), i[1]),
            o = i[5],
            s = i[9],
            l = c(a, o, s);
        a /= l, o /= l, s /= l;
        var u = i[0],
            f = i[4],
            h = i[8],
            p = u * a + f * o + h * s,
            d = c(u -= a * p, f -= o * p, h -= s * p),
            m = (u /= d) * e + a * r,
            g = (f /= d) * e + o * r,
            v = (h /= d) * e + s * r;
        this.center.move(t, m, g, v);
        var y = Math.exp(this.computedRadius[0]);
        y = Math.max(1e-4, y + n), this.radius.set(t, Math.log(y));
      }, p.translate = function (t, e, r, n) {
        this.center.move(t, e || 0, r || 0, n || 0);
      }, p.setMatrix = function (t, e, r, n) {
        var a = 1;
        "number" == typeof r && (a = 0 | r), (a < 0 || a > 3) && (a = 1);
        var o = (a + 2) % 3;
        e || (this.recalcMatrix(t), e = this.computedMatrix);
        var s = e[a],
            l = e[a + 4],
            f = e[a + 8];

        if (n) {
          var h = Math.abs(s),
              p = Math.abs(l),
              d = Math.abs(f),
              m = Math.max(h, p, d);
          h === m ? (s = s < 0 ? -1 : 1, l = f = 0) : d === m ? (f = f < 0 ? -1 : 1, s = l = 0) : (l = l < 0 ? -1 : 1, s = f = 0);
        } else {
          var g = c(s, l, f);
          s /= g, l /= g, f /= g;
        }

        var v,
            y,
            x = e[o],
            b = e[o + 4],
            _ = e[o + 8],
            w = x * s + b * l + _ * f,
            T = c(x -= s * w, b -= l * w, _ -= f * w),
            k = l * (_ /= T) - f * (b /= T),
            M = f * (x /= T) - s * _,
            A = s * b - l * x,
            S = c(k, M, A);

        if (k /= S, M /= S, A /= S, this.center.jump(t, H, G, Y), this.radius.idle(t), this.up.jump(t, s, l, f), this.right.jump(t, x, b, _), 2 === a) {
          var E = e[1],
              L = e[5],
              C = e[9],
              P = E * x + L * b + C * _,
              I = E * k + L * M + C * A;
          v = R < 0 ? -Math.PI / 2 : Math.PI / 2, y = Math.atan2(I, P);
        } else {
          var O = e[2],
              z = e[6],
              D = e[10],
              R = O * s + z * l + D * f,
              F = O * x + z * b + D * _,
              B = O * k + z * M + D * A;
          v = Math.asin(u(R)), y = Math.atan2(B, F);
        }

        this.angle.jump(t, y, v), this.recalcMatrix(t);
        var N = e[2],
            j = e[6],
            U = e[10],
            V = this.computedMatrix;
        i(V, e);
        var q = V[15],
            H = V[12] / q,
            G = V[13] / q,
            Y = V[14] / q,
            W = Math.exp(this.computedRadius[0]);
        this.center.jump(t, H - N * W, G - j * W, Y - U * W);
      }, p.lastT = function () {
        return Math.max(this.center.lastT(), this.up.lastT(), this.right.lastT(), this.radius.lastT(), this.angle.lastT());
      }, p.idle = function (t) {
        this.center.idle(t), this.up.idle(t), this.right.idle(t), this.radius.idle(t), this.angle.idle(t);
      }, p.flush = function (t) {
        this.center.flush(t), this.up.flush(t), this.right.flush(t), this.radius.flush(t), this.angle.flush(t);
      }, p.setDistance = function (t, e) {
        e > 0 && this.radius.set(t, Math.log(e));
      }, p.lookAt = function (t, e, r, n) {
        this.recalcMatrix(t), e = e || this.computedEye, r = r || this.computedCenter;
        var i = (n = n || this.computedUp)[0],
            a = n[1],
            o = n[2],
            s = c(i, a, o);

        if (!(s < 1e-6)) {
          i /= s, a /= s, o /= s;
          var l = e[0] - r[0],
              f = e[1] - r[1],
              h = e[2] - r[2],
              p = c(l, f, h);

          if (!(p < 1e-6)) {
            l /= p, f /= p, h /= p;
            var d = this.computedRight,
                m = d[0],
                g = d[1],
                v = d[2],
                y = i * m + a * g + o * v,
                x = c(m -= y * i, g -= y * a, v -= y * o);

            if (!(x < .01 && (x = c(m = a * h - o * f, g = o * l - i * h, v = i * f - a * l)) < 1e-6)) {
              m /= x, g /= x, v /= x, this.up.set(t, i, a, o), this.right.set(t, m, g, v), this.center.set(t, r[0], r[1], r[2]), this.radius.set(t, Math.log(p));

              var b = a * v - o * g,
                  _ = o * m - i * v,
                  w = i * g - a * m,
                  T = c(b, _, w),
                  k = i * l + a * f + o * h,
                  M = m * l + g * f + v * h,
                  A = (b /= T) * l + (_ /= T) * f + (w /= T) * h,
                  S = Math.asin(u(k)),
                  E = Math.atan2(A, M),
                  L = this.angle._state,
                  C = L[L.length - 1],
                  P = L[L.length - 2];

              C %= 2 * Math.PI;
              var I = Math.abs(C + 2 * Math.PI - E),
                  O = Math.abs(C - E),
                  z = Math.abs(C - 2 * Math.PI - E);
              I < O && (C += 2 * Math.PI), z < O && (C -= 2 * Math.PI), this.angle.jump(this.angle.lastT(), C, P), this.angle.set(t, E, S);
            }
          }
        }
      };
    }, {
      "filtered-vector": 241,
      "gl-mat4/invert": 290,
      "gl-mat4/rotate": 296,
      "gl-vec3/cross": 359,
      "gl-vec3/dot": 364,
      "gl-vec3/normalize": 381
    }],
    596: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r) {
        var i = t * e,
            a = n * t,
            o = a - (a - t),
            s = t - o,
            l = n * e,
            c = l - (l - e),
            u = e - c,
            f = s * u - (i - o * c - s * c - o * u);
        if (r) return r[0] = f, r[1] = i, r;
        return [f, i];
      };

      var n = +(Math.pow(2, 27) + 1);
    }, {}],
    597: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r) {
        var n = t + e,
            i = n - t,
            a = e - i,
            o = t - (n - i);
        if (r) return r[0] = o + a, r[1] = n, r;
        return [o + a, n];
      };
    }, {}],
    598: [function (t, e, r) {
      "use strict";

      var n = t("../prototype/is");

      e.exports = function (t) {
        if ("function" != typeof t) return !1;
        if (!hasOwnProperty.call(t, "length")) return !1;

        try {
          if ("number" != typeof t.length) return !1;
          if ("function" != typeof t.call) return !1;
          if ("function" != typeof t.apply) return !1;
        } catch (t) {
          return !1;
        }

        return !n(t);
      };
    }, {
      "../prototype/is": 605
    }],
    599: [function (t, e, r) {
      "use strict";

      var n = t("../value/is"),
          i = t("../object/is"),
          a = t("../string/coerce"),
          o = t("./to-short-string"),
          s = function s(t, e) {
        return t.replace("%v", o(e));
      };

      e.exports = function (t, e, r) {
        if (!i(r)) throw new TypeError(s(e, t));

        if (!n(t)) {
          if ("default" in r) return r.default;
          if (r.isOptional) return null;
        }

        var o = a(r.errorMessage);
        throw n(o) || (o = e), new TypeError(s(o, t));
      };
    }, {
      "../object/is": 602,
      "../string/coerce": 606,
      "../value/is": 608,
      "./to-short-string": 601
    }],
    600: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        try {
          return t.toString();
        } catch (e) {
          try {
            return String(t);
          } catch (t) {
            return null;
          }
        }
      };
    }, {}],
    601: [function (t, e, r) {
      "use strict";

      var n = t("./safe-to-string"),
          i = /[\n\r\u2028\u2029]/g;

      e.exports = function (t) {
        var e = n(t);
        return null === e ? "<Non-coercible to string value>" : (e.length > 100 && (e = e.slice(0, 99) + "\u2026"), e = e.replace(i, function (t) {
          switch (t) {
            case "\n":
              return "\\n";

            case "\r":
              return "\\r";

            case "\u2028":
              return "\\u2028";

            case "\u2029":
              return "\\u2029";

            default:
              throw new Error("Unexpected character");
          }
        }));
      };
    }, {
      "./safe-to-string": 600
    }],
    602: [function (t, e, r) {
      "use strict";

      var n = t("../value/is"),
          i = {
        object: !0,
        function: !0,
        undefined: !0
      };

      e.exports = function (t) {
        return !!n(t) && hasOwnProperty.call(i, _typeof(t));
      };
    }, {
      "../value/is": 608
    }],
    603: [function (t, e, r) {
      "use strict";

      var n = t("../lib/resolve-exception"),
          i = t("./is");

      e.exports = function (t) {
        return i(t) ? t : n(t, "%v is not a plain function", arguments[1]);
      };
    }, {
      "../lib/resolve-exception": 599,
      "./is": 604
    }],
    604: [function (t, e, r) {
      "use strict";

      var n = t("../function/is"),
          i = /^\s*class[\s{/}]/,
          a = Function.prototype.toString;

      e.exports = function (t) {
        return !!n(t) && !i.test(a.call(t));
      };
    }, {
      "../function/is": 598
    }],
    605: [function (t, e, r) {
      "use strict";

      var n = t("../object/is");

      e.exports = function (t) {
        if (!n(t)) return !1;

        try {
          return !!t.constructor && t.constructor.prototype === t;
        } catch (t) {
          return !1;
        }
      };
    }, {
      "../object/is": 602
    }],
    606: [function (t, e, r) {
      "use strict";

      var n = t("../value/is"),
          i = t("../object/is"),
          a = Object.prototype.toString;

      e.exports = function (t) {
        if (!n(t)) return null;

        if (i(t)) {
          var e = t.toString;
          if ("function" != typeof e) return null;
          if (e === a) return null;
        }

        try {
          return "" + t;
        } catch (t) {
          return null;
        }
      };
    }, {
      "../object/is": 602,
      "../value/is": 608
    }],
    607: [function (t, e, r) {
      "use strict";

      var n = t("../lib/resolve-exception"),
          i = t("./is");

      e.exports = function (t) {
        return i(t) ? t : n(t, "Cannot use %v", arguments[1]);
      };
    }, {
      "../lib/resolve-exception": 599,
      "./is": 608
    }],
    608: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        return null != t;
      };
    }, {}],
    609: [function (t, e, r) {
      (function (e) {
        (function () {
          "use strict";

          var n = t("bit-twiddle"),
              i = t("dup"),
              a = t("buffer").Buffer;
          e.__TYPEDARRAY_POOL || (e.__TYPEDARRAY_POOL = {
            UINT8: i([32, 0]),
            UINT16: i([32, 0]),
            UINT32: i([32, 0]),
            BIGUINT64: i([32, 0]),
            INT8: i([32, 0]),
            INT16: i([32, 0]),
            INT32: i([32, 0]),
            BIGINT64: i([32, 0]),
            FLOAT: i([32, 0]),
            DOUBLE: i([32, 0]),
            DATA: i([32, 0]),
            UINT8C: i([32, 0]),
            BUFFER: i([32, 0])
          });
          var o = "undefined" != typeof Uint8ClampedArray,
              s = "undefined" != typeof BigUint64Array,
              l = "undefined" != typeof BigInt64Array,
              c = e.__TYPEDARRAY_POOL;
          c.UINT8C || (c.UINT8C = i([32, 0])), c.BIGUINT64 || (c.BIGUINT64 = i([32, 0])), c.BIGINT64 || (c.BIGINT64 = i([32, 0])), c.BUFFER || (c.BUFFER = i([32, 0]));
          var u = c.DATA,
              f = c.BUFFER;

          function h(t) {
            if (t) {
              var e = t.length || t.byteLength,
                  r = n.log2(e);
              u[r].push(t);
            }
          }

          function p(t) {
            t = n.nextPow2(t);
            var e = n.log2(t),
                r = u[e];
            return r.length > 0 ? r.pop() : new ArrayBuffer(t);
          }

          function d(t) {
            return new Uint8Array(p(t), 0, t);
          }

          function m(t) {
            return new Uint16Array(p(2 * t), 0, t);
          }

          function g(t) {
            return new Uint32Array(p(4 * t), 0, t);
          }

          function v(t) {
            return new Int8Array(p(t), 0, t);
          }

          function y(t) {
            return new Int16Array(p(2 * t), 0, t);
          }

          function x(t) {
            return new Int32Array(p(4 * t), 0, t);
          }

          function b(t) {
            return new Float32Array(p(4 * t), 0, t);
          }

          function _(t) {
            return new Float64Array(p(8 * t), 0, t);
          }

          function w(t) {
            return o ? new Uint8ClampedArray(p(t), 0, t) : d(t);
          }

          function T(t) {
            return s ? new BigUint64Array(p(8 * t), 0, t) : null;
          }

          function k(t) {
            return l ? new BigInt64Array(p(8 * t), 0, t) : null;
          }

          function M(t) {
            return new DataView(p(t), 0, t);
          }

          function A(t) {
            t = n.nextPow2(t);
            var e = n.log2(t),
                r = f[e];
            return r.length > 0 ? r.pop() : new a(t);
          }

          r.free = function (t) {
            if (a.isBuffer(t)) f[n.log2(t.length)].push(t);else {
              if ("[object ArrayBuffer]" !== Object.prototype.toString.call(t) && (t = t.buffer), !t) return;
              var e = t.length || t.byteLength,
                  r = 0 | n.log2(e);
              u[r].push(t);
            }
          }, r.freeUint8 = r.freeUint16 = r.freeUint32 = r.freeBigUint64 = r.freeInt8 = r.freeInt16 = r.freeInt32 = r.freeBigInt64 = r.freeFloat32 = r.freeFloat = r.freeFloat64 = r.freeDouble = r.freeUint8Clamped = r.freeDataView = function (t) {
            h(t.buffer);
          }, r.freeArrayBuffer = h, r.freeBuffer = function (t) {
            f[n.log2(t.length)].push(t);
          }, r.malloc = function (t, e) {
            if (void 0 === e || "arraybuffer" === e) return p(t);

            switch (e) {
              case "uint8":
                return d(t);

              case "uint16":
                return m(t);

              case "uint32":
                return g(t);

              case "int8":
                return v(t);

              case "int16":
                return y(t);

              case "int32":
                return x(t);

              case "float":
              case "float32":
                return b(t);

              case "double":
              case "float64":
                return _(t);

              case "uint8_clamped":
                return w(t);

              case "bigint64":
                return k(t);

              case "biguint64":
                return T(t);

              case "buffer":
                return A(t);

              case "data":
              case "dataview":
                return M(t);

              default:
                return null;
            }

            return null;
          }, r.mallocArrayBuffer = p, r.mallocUint8 = d, r.mallocUint16 = m, r.mallocUint32 = g, r.mallocInt8 = v, r.mallocInt16 = y, r.mallocInt32 = x, r.mallocFloat32 = r.mallocFloat = b, r.mallocFloat64 = r.mallocDouble = _, r.mallocUint8Clamped = w, r.mallocBigUint64 = T, r.mallocBigInt64 = k, r.mallocDataView = M, r.mallocBuffer = A, r.clearCache = function () {
            for (var t = 0; t < 32; ++t) {
              c.UINT8[t].length = 0, c.UINT16[t].length = 0, c.UINT32[t].length = 0, c.INT8[t].length = 0, c.INT16[t].length = 0, c.INT32[t].length = 0, c.FLOAT[t].length = 0, c.DOUBLE[t].length = 0, c.BIGUINT64[t].length = 0, c.BIGINT64[t].length = 0, c.UINT8C[t].length = 0, u[t].length = 0, f[t].length = 0;
            }
          };
        }).call(this);
      }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
    }, {
      "bit-twiddle": 99,
      buffer: 112,
      dup: 176
    }],
    610: [function (t, e, r) {
      "use strict";

      function n(t) {
        this.roots = new Array(t), this.ranks = new Array(t);

        for (var e = 0; e < t; ++e) {
          this.roots[e] = e, this.ranks[e] = 0;
        }
      }

      e.exports = n;
      var i = n.prototype;
      Object.defineProperty(i, "length", {
        get: function get() {
          return this.roots.length;
        }
      }), i.makeSet = function () {
        var t = this.roots.length;
        return this.roots.push(t), this.ranks.push(0), t;
      }, i.find = function (t) {
        for (var e = t, r = this.roots; r[t] !== t;) {
          t = r[t];
        }

        for (; r[e] !== t;) {
          var n = r[e];
          r[e] = t, e = n;
        }

        return t;
      }, i.link = function (t, e) {
        var r = this.find(t),
            n = this.find(e);

        if (r !== n) {
          var i = this.ranks,
              a = this.roots,
              o = i[r],
              s = i[n];
          o < s ? a[r] = n : s < o ? a[n] = r : (a[n] = r, ++i[r]);
        }
      };
    }, {}],
    611: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r) {
        return 0 === t.length ? t : e ? (r || t.sort(e), function (t, e) {
          for (var r = 1, n = t.length, i = t[0], a = t[0], o = 1; o < n; ++o) {
            if (a = i, e(i = t[o], a)) {
              if (o === r) {
                r++;
                continue;
              }

              t[r++] = i;
            }
          }

          return t.length = r, t;
        }(t, e)) : (r || t.sort(), function (t) {
          for (var e = 1, r = t.length, n = t[0], i = t[0], a = 1; a < r; ++a, i = n) {
            if (i = n, (n = t[a]) !== i) {
              if (a === e) {
                e++;
                continue;
              }

              t[e++] = n;
            }
          }

          return t.length = e, t;
        }(t));
      };
    }, {}],
    612: [function (t, e, r) {
      var n = /[\'\"]/;

      e.exports = function (t) {
        return t ? (n.test(t.charAt(0)) && (t = t.substr(1)), n.test(t.charAt(t.length - 1)) && (t = t.substr(0, t.length - 1)), t) : "";
      };
    }, {}],
    613: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r) {
        Array.isArray(r) || (r = [].slice.call(arguments, 2));

        for (var n = 0, i = r.length; n < i; n++) {
          var a = r[n];

          for (var o in a) {
            if ((void 0 === e[o] || Array.isArray(e[o]) || t[o] !== e[o]) && o in e) {
              var s;
              if (!0 === a[o]) s = e[o];else {
                if (!1 === a[o]) continue;
                if ("function" == typeof a[o] && void 0 === (s = a[o](e[o], t, e))) continue;
              }
              t[o] = s;
            }
          }
        }

        return t;
      };
    }, {}],
    614: [function (t, e, r) {
      (function (t) {
        (function () {
          function r(e) {
            try {
              if (!t.localStorage) return !1;
            } catch (t) {
              return !1;
            }

            var r = t.localStorage[e];
            return null != r && "true" === String(r).toLowerCase();
          }

          e.exports = function (t, e) {
            if (r("noDeprecation")) return t;
            var n = !1;
            return function () {
              if (!n) {
                if (r("throwDeprecation")) throw new Error(e);
                r("traceDeprecation") ? console.trace(e) : console.warn(e), n = !0;
              }

              return t.apply(this, arguments);
            };
          };
        }).call(this);
      }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
    }, {}],
    615: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        "object" == _typeof(e) && null !== e || (e = {});
        return n(t, e.canvas || i, e.context || a, e);
      };

      var n = t("./lib/vtext"),
          i = null,
          a = null;
      "undefined" != typeof document && ((i = document.createElement("canvas")).width = 8192, i.height = 1024, a = i.getContext("2d"));
    }, {
      "./lib/vtext": 616
    }],
    616: [function (t, e, r) {
      e.exports = function (t, e, r, n) {
        var a = 64,
            o = 1.25,
            s = {
          breaklines: !1,
          bolds: !1,
          italics: !1,
          subscripts: !1,
          superscripts: !1
        };
        n && (n.size && n.size > 0 && (a = n.size), n.lineSpacing && n.lineSpacing > 0 && (o = n.lineSpacing), n.styletags && n.styletags.breaklines && (s.breaklines = !!n.styletags.breaklines), n.styletags && n.styletags.bolds && (s.bolds = !!n.styletags.bolds), n.styletags && n.styletags.italics && (s.italics = !!n.styletags.italics), n.styletags && n.styletags.subscripts && (s.subscripts = !!n.styletags.subscripts), n.styletags && n.styletags.superscripts && (s.superscripts = !!n.styletags.superscripts));
        return r.font = [n.fontStyle, n.fontVariant, n.fontWeight, a + "px", n.font].filter(function (t) {
          return t;
        }).join(" "), r.textAlign = "start", r.textBaseline = "alphabetic", r.direction = "ltr", h(function (t, e, r, n, a, o) {
          r = r.replace(/\n/g, ""), r = !0 === o.breaklines ? r.replace(/\<br\>/g, "\n") : r.replace(/\<br\>/g, " ");
          var s = "",
              l = [];

          for (p = 0; p < r.length; ++p) {
            l[p] = s;
          }

          !0 === o.bolds && (l = c("b", "b|", r, l));
          !0 === o.italics && (l = c("i", "i|", r, l));
          !0 === o.superscripts && (l = c("sup", "+1", r, l));
          !0 === o.subscripts && (l = c("sub", "-1", r, l));
          var u = [],
              f = "";

          for (p = 0; p < r.length; ++p) {
            null !== l[p] && (f += r[p], u.push(l[p]));
          }

          var h,
              p,
              d,
              m,
              g,
              v = f.split("\n"),
              y = v.length,
              x = Math.round(a * n),
              b = n,
              _ = 2 * n,
              w = 0,
              T = y * x + _;

          t.height < T && (t.height = T);
          e.fillStyle = "#000", e.fillRect(0, 0, t.width, t.height), e.fillStyle = "#fff";
          var k = 0,
              M = "";

          function A() {
            if ("" !== M) {
              var t = e.measureText(M).width;
              e.fillText(M, b + d, _ + m), d += t;
            }
          }

          function S() {
            return Math.round(g) + "px ";
          }

          function E(t, r) {
            var n = "" + e.font;

            if (!0 === o.subscripts) {
              var i = t.indexOf("-"),
                  a = r.indexOf("-"),
                  s = i > -1 ? parseInt(t[1 + i]) : 0,
                  l = a > -1 ? parseInt(r[1 + a]) : 0;
              s !== l && (n = n.replace(S(), "?px "), g *= Math.pow(.75, l - s), n = n.replace("?px ", S())), m += .25 * x * (l - s);
            }

            if (!0 === o.superscripts) {
              var c = t.indexOf("+"),
                  u = r.indexOf("+"),
                  f = c > -1 ? parseInt(t[1 + c]) : 0,
                  h = u > -1 ? parseInt(r[1 + u]) : 0;
              f !== h && (n = n.replace(S(), "?px "), g *= Math.pow(.75, h - f), n = n.replace("?px ", S())), m -= .25 * x * (h - f);
            }

            if (!0 === o.bolds) {
              var p = t.indexOf("b|") > -1,
                  d = r.indexOf("b|") > -1;
              !p && d && (n = v ? n.replace("italic ", "italic bold ") : "bold " + n), p && !d && (n = n.replace("bold ", ""));
            }

            if (!0 === o.italics) {
              var v = t.indexOf("i|") > -1,
                  y = r.indexOf("i|") > -1;
              !v && y && (n = "italic " + n), v && !y && (n = n.replace("italic ", ""));
            }

            e.font = n;
          }

          for (h = 0; h < y; ++h) {
            var L = v[h] + "\n";

            for (d = 0, m = h * x, g = n, M = "", p = 0; p < L.length; ++p) {
              var C = p + k < u.length ? u[p + k] : u[u.length - 1];
              s === C ? M += L[p] : (A(), M = L[p], void 0 !== C && (E(s, C), s = C));
            }

            A(), k += L.length;
            var P = 0 | Math.round(d + 2 * b);
            w < P && (w = P);
          }

          var I = w,
              O = _ + x * y;
          return i(e.getImageData(0, 0, I, O).data, [O, I, 4]).pick(-1, -1, 0).transpose(1, 0);
        }(e, r, t, a, o, s), n, a);
      }, e.exports.processPixels = h;
      var n = t("surface-nets"),
          i = t("ndarray"),
          a = t("simplify-planar-graph"),
          o = t("clean-pslg"),
          s = t("cdt2d"),
          l = t("planar-graph-to-polyline");

      function c(t, e, r, n) {
        for (var i = "<" + t + ">", a = "</" + t + ">", o = i.length, s = a.length, l = "+" === e[0] || "-" === e[0], c = 0, u = -s; c > -1 && -1 !== (c = r.indexOf(i, c)) && -1 !== (u = r.indexOf(a, c + o)) && !(u <= c);) {
          for (var f = c; f < u + s; ++f) {
            if (f < c + o || f >= u) n[f] = null, r = r.substr(0, f) + " " + r.substr(f + 1);else if (null !== n[f]) {
              var h = n[f].indexOf(e[0]);
              -1 === h ? n[f] += e : l && (n[f] = n[f].substr(0, h + 1) + (1 + parseInt(n[f][h + 1])) + n[f].substr(h + 2));
            }
          }

          var p = c + o,
              d = r.substr(p, u - p).indexOf(i);
          c = -1 !== d ? d : u + s;
        }

        return n;
      }

      function u(t, e) {
        var r = n(t, 128);
        return e ? a(r.cells, r.positions, .25) : {
          edges: r.cells,
          positions: r.positions
        };
      }

      function f(t, e, r, n) {
        var i = u(t, n),
            a = function (t, e, r) {
          for (var n = e.textAlign || "start", i = e.textBaseline || "alphabetic", a = [1 << 30, 1 << 30], o = [0, 0], s = t.length, l = 0; l < s; ++l) {
            for (var c = t[l], u = 0; u < 2; ++u) {
              a[u] = 0 | Math.min(a[u], c[u]), o[u] = 0 | Math.max(o[u], c[u]);
            }
          }

          var f = 0;

          switch (n) {
            case "center":
              f = -.5 * (a[0] + o[0]);
              break;

            case "right":
            case "end":
              f = -o[0];
              break;

            case "left":
            case "start":
              f = -a[0];
              break;

            default:
              throw new Error("vectorize-text: Unrecognized textAlign: '" + n + "'");
          }

          var h = 0;

          switch (i) {
            case "hanging":
            case "top":
              h = -a[1];
              break;

            case "middle":
              h = -.5 * (a[1] + o[1]);
              break;

            case "alphabetic":
            case "ideographic":
              h = -3 * r;
              break;

            case "bottom":
              h = -o[1];
              break;

            default:
              throw new Error("vectorize-text: Unrecoginized textBaseline: '" + i + "'");
          }

          var p = 1 / r;
          return "lineHeight" in e ? p *= +e.lineHeight : "width" in e ? p = e.width / (o[0] - a[0]) : "height" in e && (p = e.height / (o[1] - a[1])), t.map(function (t) {
            return [p * (t[0] + f), p * (t[1] + h)];
          });
        }(i.positions, e, r),
            c = i.edges,
            f = "ccw" === e.orientation;

        if (o(a, c), e.polygons || e.polygon || e.polyline) {
          for (var h = l(c, a), p = new Array(h.length), d = 0; d < h.length; ++d) {
            for (var m = h[d], g = new Array(m.length), v = 0; v < m.length; ++v) {
              for (var y = m[v], x = new Array(y.length), b = 0; b < y.length; ++b) {
                x[b] = a[y[b]].slice();
              }

              f && x.reverse(), g[v] = x;
            }

            p[d] = g;
          }

          return p;
        }

        return e.triangles || e.triangulate || e.triangle ? {
          cells: s(a, c, {
            delaunay: !1,
            exterior: !1,
            interior: !0
          }),
          positions: a
        } : {
          edges: c,
          positions: a
        };
      }

      function h(t, e, r) {
        try {
          return f(t, e, r, !0);
        } catch (t) {}

        try {
          return f(t, e, r, !1);
        } catch (t) {}

        return e.polygons || e.polyline || e.polygon ? [] : e.triangles || e.triangulate || e.triangle ? {
          cells: [],
          positions: []
        } : {
          edges: [],
          positions: []
        };
      }
    }, {
      cdt2d: 113,
      "clean-pslg": 122,
      ndarray: 475,
      "planar-graph-to-polyline": 493,
      "simplify-planar-graph": 555,
      "surface-nets": 583
    }],
    617: [function (t, e, r) {
      !function () {
        "use strict";

        if ("undefined" == typeof ses || !ses.ok || ses.ok()) {
          "undefined" != typeof ses && (ses.weakMapPermitHostObjects = m);
          var t = !1;

          if ("function" == typeof WeakMap) {
            var r = WeakMap;
            if ("undefined" != typeof navigator && /Firefox/.test(navigator.userAgent)) ;else {
              var n = new r(),
                  i = Object.freeze({});
              if (n.set(i, 1), 1 === n.get(i)) return void (e.exports = WeakMap);
              t = !0;
            }
          }

          Object.prototype.hasOwnProperty;
          var a = Object.getOwnPropertyNames,
              o = Object.defineProperty,
              s = Object.isExtensible,
              l = "weakmap:ident:" + Math.random() + "___";

          if ("undefined" != typeof crypto && "function" == typeof crypto.getRandomValues && "function" == typeof ArrayBuffer && "function" == typeof Uint8Array) {
            var c = new ArrayBuffer(25),
                u = new Uint8Array(c);
            crypto.getRandomValues(u), l = "weakmap:rand:" + Array.prototype.map.call(u, function (t) {
              return (t % 36).toString(36);
            }).join("") + "___";
          }

          if (o(Object, "getOwnPropertyNames", {
            value: function value(t) {
              return a(t).filter(g);
            }
          }), "getPropertyNames" in Object) {
            var f = Object.getPropertyNames;
            o(Object, "getPropertyNames", {
              value: function value(t) {
                return f(t).filter(g);
              }
            });
          }

          !function () {
            var t = Object.freeze;
            o(Object, "freeze", {
              value: function value(e) {
                return v(e), t(e);
              }
            });
            var e = Object.seal;
            o(Object, "seal", {
              value: function value(t) {
                return v(t), e(t);
              }
            });
            var r = Object.preventExtensions;
            o(Object, "preventExtensions", {
              value: function value(t) {
                return v(t), r(t);
              }
            });
          }();

          var h = !1,
              p = 0,
              d = function d() {
            this instanceof d || x();
            var t = [],
                e = [],
                r = p++;
            return Object.create(d.prototype, {
              get___: {
                value: y(function (n, i) {
                  var a,
                      o = v(n);
                  return o ? r in o ? o[r] : i : (a = t.indexOf(n)) >= 0 ? e[a] : i;
                })
              },
              has___: {
                value: y(function (e) {
                  var n = v(e);
                  return n ? r in n : t.indexOf(e) >= 0;
                })
              },
              set___: {
                value: y(function (n, i) {
                  var a,
                      o = v(n);
                  return o ? o[r] = i : (a = t.indexOf(n)) >= 0 ? e[a] = i : (a = t.length, e[a] = i, t[a] = n), this;
                })
              },
              delete___: {
                value: y(function (n) {
                  var i,
                      a,
                      o = v(n);
                  return o ? r in o && delete o[r] : !((i = t.indexOf(n)) < 0) && (a = t.length - 1, t[i] = void 0, e[i] = e[a], t[i] = t[a], t.length = a, e.length = a, !0);
                })
              }
            });
          };

          d.prototype = Object.create(Object.prototype, {
            get: {
              value: function value(t, e) {
                return this.get___(t, e);
              },
              writable: !0,
              configurable: !0
            },
            has: {
              value: function value(t) {
                return this.has___(t);
              },
              writable: !0,
              configurable: !0
            },
            set: {
              value: function value(t, e) {
                return this.set___(t, e);
              },
              writable: !0,
              configurable: !0
            },
            delete: {
              value: function value(t) {
                return this.delete___(t);
              },
              writable: !0,
              configurable: !0
            }
          }), "function" == typeof r ? function () {
            function n() {
              this instanceof d || x();
              var e,
                  n = new r(),
                  i = void 0,
                  a = !1;
              return e = t ? function (t, e) {
                return n.set(t, e), n.has(t) || (i || (i = new d()), i.set(t, e)), this;
              } : function (t, e) {
                if (a) try {
                  n.set(t, e);
                } catch (r) {
                  i || (i = new d()), i.set___(t, e);
                } else n.set(t, e);
                return this;
              }, Object.create(d.prototype, {
                get___: {
                  value: y(function (t, e) {
                    return i ? n.has(t) ? n.get(t) : i.get___(t, e) : n.get(t, e);
                  })
                },
                has___: {
                  value: y(function (t) {
                    return n.has(t) || !!i && i.has___(t);
                  })
                },
                set___: {
                  value: y(e)
                },
                delete___: {
                  value: y(function (t) {
                    var e = !!n.delete(t);
                    return i && i.delete___(t) || e;
                  })
                },
                permitHostObjects___: {
                  value: y(function (t) {
                    if (t !== m) throw new Error("bogus call to permitHostObjects___");
                    a = !0;
                  })
                }
              });
            }

            t && "undefined" != typeof Proxy && (Proxy = void 0), n.prototype = d.prototype, e.exports = n, Object.defineProperty(WeakMap.prototype, "constructor", {
              value: WeakMap,
              enumerable: !1,
              configurable: !0,
              writable: !0
            });
          }() : ("undefined" != typeof Proxy && (Proxy = void 0), e.exports = d);
        }

        function m(t) {
          t.permitHostObjects___ && t.permitHostObjects___(m);
        }

        function g(t) {
          return !("weakmap:" == t.substr(0, "weakmap:".length) && "___" === t.substr(t.length - 3));
        }

        function v(t) {
          if (t !== Object(t)) throw new TypeError("Not an object: " + t);
          var e = t[l];
          if (e && e.key === t) return e;

          if (s(t)) {
            e = {
              key: t
            };

            try {
              return o(t, l, {
                value: e,
                writable: !1,
                enumerable: !1,
                configurable: !1
              }), e;
            } catch (t) {
              return;
            }
          }
        }

        function y(t) {
          return t.prototype = null, Object.freeze(t);
        }

        function x() {
          h || "undefined" == typeof console || (h = !0, console.warn("WeakMap should be invoked as new WeakMap(), not WeakMap(). This will be an error in the future."));
        }
      }();
    }, {}],
    618: [function (t, e, r) {
      var n = t("./hidden-store.js");

      e.exports = function () {
        var t = {};
        return function (e) {
          if (("object" != _typeof(e) || null === e) && "function" != typeof e) throw new Error("Weakmap-shim: Key must be object");
          var r = e.valueOf(t);
          return r && r.identity === t ? r : n(e, t);
        };
      };
    }, {
      "./hidden-store.js": 619
    }],
    619: [function (t, e, r) {
      e.exports = function (t, e) {
        var r = {
          identity: e
        },
            n = t.valueOf;
        return Object.defineProperty(t, "valueOf", {
          value: function value(t) {
            return t !== e ? n.apply(this, arguments) : r;
          },
          writable: !0
        }), r;
      };
    }, {}],
    620: [function (t, e, r) {
      var n = t("./create-store.js");

      e.exports = function () {
        var t = n();
        return {
          get: function get(e, r) {
            var n = t(e);
            return n.hasOwnProperty("value") ? n.value : r;
          },
          set: function set(e, r) {
            return t(e).value = r, this;
          },
          has: function has(e) {
            return "value" in t(e);
          },
          delete: function _delete(e) {
            return delete t(e).value;
          }
        };
      };
    }, {
      "./create-store.js": 618
    }],
    621: [function (t, e, r) {
      var n = t("get-canvas-context");

      e.exports = function (t) {
        return n("webgl", t);
      };
    }, {
      "get-canvas-context": 248
    }],
    622: [function (t, e, r) {
      var n = t("../main"),
          i = t("object-assign"),
          a = n.instance();

      function o(t) {
        this.local = this.regionalOptions[t || ""] || this.regionalOptions[""];
      }

      o.prototype = new n.baseCalendar(), i(o.prototype, {
        name: "Chinese",
        jdEpoch: 1721425.5,
        hasYearZero: !1,
        minMonth: 0,
        firstMonth: 0,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Chinese",
            epochs: ["BEC", "EC"],
            monthNumbers: function monthNumbers(t, e) {
              if ("string" == typeof t) {
                var r = t.match(l);
                return r ? r[0] : "";
              }

              var n = this._validateYear(t),
                  i = t.month(),
                  a = "" + this.toChineseMonth(n, i);

              return e && a.length < 2 && (a = "0" + a), this.isIntercalaryMonth(n, i) && (a += "i"), a;
            },
            monthNames: function monthNames(t) {
              if ("string" == typeof t) {
                var e = t.match(c);
                return e ? e[0] : "";
              }

              var r = this._validateYear(t),
                  n = t.month(),
                  i = ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708"][this.toChineseMonth(r, n) - 1];

              return this.isIntercalaryMonth(r, n) && (i = "\u95F0" + i), i;
            },
            monthNamesShort: function monthNamesShort(t) {
              if ("string" == typeof t) {
                var e = t.match(u);
                return e ? e[0] : "";
              }

              var r = this._validateYear(t),
                  n = t.month(),
                  i = ["\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D", "\u4E03", "\u516B", "\u4E5D", "\u5341", "\u5341\u4E00", "\u5341\u4E8C"][this.toChineseMonth(r, n) - 1];

              return this.isIntercalaryMonth(r, n) && (i = "\u95F0" + i), i;
            },
            parseMonth: function parseMonth(t, e) {
              t = this._validateYear(t);
              var r,
                  n = parseInt(e);
              if (isNaN(n)) "\u95F0" === e[0] && (r = !0, e = e.substring(1)), "\u6708" === e[e.length - 1] && (e = e.substring(0, e.length - 1)), n = 1 + ["\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D", "\u4E03", "\u516B", "\u4E5D", "\u5341", "\u5341\u4E00", "\u5341\u4E8C"].indexOf(e);else {
                var i = e[e.length - 1];
                r = "i" === i || "I" === i;
              }
              return this.toMonthIndex(t, n, r);
            },
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            digits: null,
            dateFormat: "yyyy/mm/dd",
            firstDay: 1,
            isRTL: !1
          }
        },
        _validateYear: function _validateYear(t, e) {
          if (t.year && (t = t.year()), "number" != typeof t || t < 1888 || t > 2111) throw e.replace(/\{0\}/, this.local.name);
          return t;
        },
        toMonthIndex: function toMonthIndex(t, e, r) {
          var i = this.intercalaryMonth(t);
          if (r && e !== i || e < 1 || e > 12) throw n.local.invalidMonth.replace(/\{0\}/, this.local.name);
          return i ? !r && e <= i ? e - 1 : e : e - 1;
        },
        toChineseMonth: function toChineseMonth(t, e) {
          t.year && (e = (t = t.year()).month());
          var r = this.intercalaryMonth(t);
          if (e < 0 || e > (r ? 12 : 11)) throw n.local.invalidMonth.replace(/\{0\}/, this.local.name);
          return r ? e < r ? e + 1 : e : e + 1;
        },
        intercalaryMonth: function intercalaryMonth(t) {
          return t = this._validateYear(t), f[t - f[0]] >> 13;
        },
        isIntercalaryMonth: function isIntercalaryMonth(t, e) {
          t.year && (e = (t = t.year()).month());
          var r = this.intercalaryMonth(t);
          return !!r && r === e;
        },
        leapYear: function leapYear(t) {
          return 0 !== this.intercalaryMonth(t);
        },
        weekOfYear: function weekOfYear(t, e, r) {
          var i,
              o = this._validateYear(t, n.local.invalidyear),
              s = h[o - h[0]],
              l = s >> 9 & 4095,
              c = s >> 5 & 15,
              u = 31 & s;

          (i = a.newDate(l, c, u)).add(4 - (i.dayOfWeek() || 7), "d");
          var f = this.toJD(t, e, r) - i.toJD();
          return 1 + Math.floor(f / 7);
        },
        monthsInYear: function monthsInYear(t) {
          return this.leapYear(t) ? 13 : 12;
        },
        daysInMonth: function daysInMonth(t, e) {
          t.year && (e = t.month(), t = t.year()), t = this._validateYear(t);
          var r = f[t - f[0]];
          if (e > (r >> 13 ? 12 : 11)) throw n.local.invalidMonth.replace(/\{0\}/, this.local.name);
          return r & 1 << 12 - e ? 30 : 29;
        },
        weekDay: function weekDay(t, e, r) {
          return (this.dayOfWeek(t, e, r) || 7) < 6;
        },
        toJD: function toJD(t, e, r) {
          var i = this._validate(t, s, r, n.local.invalidDate);

          t = this._validateYear(i.year()), e = i.month(), r = i.day();

          var o = this.isIntercalaryMonth(t, e),
              s = this.toChineseMonth(t, e),
              l = function (t, e, r, n, i) {
            var a, o, s;
            if ("object" == _typeof(t)) o = t, a = e || {};else {
              var l;
              if (!("number" == typeof t && t >= 1888 && t <= 2111)) throw new Error("Lunar year outside range 1888-2111");
              if (!("number" == typeof e && e >= 1 && e <= 12)) throw new Error("Lunar month outside range 1 - 12");
              if (!("number" == typeof r && r >= 1 && r <= 30)) throw new Error("Lunar day outside range 1 - 30");
              "object" == _typeof(n) ? (l = !1, a = n) : (l = !!n, a = i || {}), o = {
                year: t,
                month: e,
                day: r,
                isIntercalary: l
              };
            }
            s = o.day - 1;
            var c,
                u = f[o.year - f[0]],
                p = u >> 13;
            c = p && (o.month > p || o.isIntercalary) ? o.month : o.month - 1;

            for (var d = 0; d < c; d++) {
              s += u & 1 << 12 - d ? 30 : 29;
            }

            var m = h[o.year - h[0]],
                g = new Date(m >> 9 & 4095, (m >> 5 & 15) - 1, (31 & m) + s);
            return a.year = g.getFullYear(), a.month = 1 + g.getMonth(), a.day = g.getDate(), a;
          }(t, s, r, o);

          return a.toJD(l.year, l.month, l.day);
        },
        fromJD: function fromJD(t) {
          var e = a.fromJD(t),
              r = function (t, e, r, n) {
            var i, a;
            if ("object" == _typeof(t)) i = t, a = e || {};else {
              if (!("number" == typeof t && t >= 1888 && t <= 2111)) throw new Error("Solar year outside range 1888-2111");
              if (!("number" == typeof e && e >= 1 && e <= 12)) throw new Error("Solar month outside range 1 - 12");
              if (!("number" == typeof r && r >= 1 && r <= 31)) throw new Error("Solar day outside range 1 - 31");
              i = {
                year: t,
                month: e,
                day: r
              }, a = n || {};
            }
            var o = h[i.year - h[0]],
                s = i.year << 9 | i.month << 5 | i.day;
            a.year = s >= o ? i.year : i.year - 1, o = h[a.year - h[0]];
            var l,
                c = new Date(o >> 9 & 4095, (o >> 5 & 15) - 1, 31 & o),
                u = new Date(i.year, i.month - 1, i.day);
            l = Math.round((u - c) / 864e5);
            var p,
                d = f[a.year - f[0]];

            for (p = 0; p < 13; p++) {
              var m = d & 1 << 12 - p ? 30 : 29;
              if (l < m) break;
              l -= m;
            }

            var g = d >> 13;
            !g || p < g ? (a.isIntercalary = !1, a.month = 1 + p) : p === g ? (a.isIntercalary = !0, a.month = p) : (a.isIntercalary = !1, a.month = p);
            return a.day = 1 + l, a;
          }(e.year(), e.month(), e.day()),
              n = this.toMonthIndex(r.year, r.month, r.isIntercalary);

          return this.newDate(r.year, n, r.day);
        },
        fromString: function fromString(t) {
          var e = t.match(s),
              r = this._validateYear(+e[1]),
              n = +e[2],
              i = !!e[3],
              a = this.toMonthIndex(r, n, i),
              o = +e[4];

          return this.newDate(r, a, o);
        },
        add: function add(t, e, r) {
          var n = t.year(),
              i = t.month(),
              a = this.isIntercalaryMonth(n, i),
              s = this.toChineseMonth(n, i),
              l = Object.getPrototypeOf(o.prototype).add.call(this, t, e, r);

          if ("y" === r) {
            var c = l.year(),
                u = l.month(),
                f = this.isIntercalaryMonth(c, s),
                h = a && f ? this.toMonthIndex(c, s, !0) : this.toMonthIndex(c, s, !1);
            h !== u && l.month(h);
          }

          return l;
        }
      });
      var s = /^\s*(-?\d\d\d\d|\d\d)[-/](\d?\d)([iI]?)[-/](\d?\d)/m,
          l = /^\d?\d[iI]?/m,
          c = /^\u95f0?\u5341?[\u4e00\u4e8c\u4e09\u56db\u4e94\u516d\u4e03\u516b\u4e5d]?\u6708/m,
          u = /^\u95f0?\u5341?[\u4e00\u4e8c\u4e09\u56db\u4e94\u516d\u4e03\u516b\u4e5d]?/m;
      n.calendars.chinese = o;
      var f = [1887, 5780, 5802, 19157, 2742, 50359, 1198, 2646, 46378, 7466, 3412, 30122, 5482, 67949, 2396, 5294, 43597, 6732, 6954, 36181, 2772, 4954, 18781, 2396, 54427, 5274, 6730, 47781, 5800, 6868, 21210, 4790, 59703, 2350, 5270, 46667, 3402, 3496, 38325, 1388, 4782, 18735, 2350, 52374, 6804, 7498, 44457, 2906, 1388, 29294, 4700, 63789, 6442, 6804, 56138, 5802, 2772, 38235, 1210, 4698, 22827, 5418, 63125, 3476, 5802, 43701, 2484, 5302, 27223, 2646, 70954, 7466, 3412, 54698, 5482, 2412, 38062, 5294, 2636, 32038, 6954, 60245, 2772, 4826, 43357, 2394, 5274, 39501, 6730, 72357, 5800, 5844, 53978, 4790, 2358, 38039, 5270, 87627, 3402, 3496, 54708, 5484, 4782, 43311, 2350, 3222, 27978, 7498, 68965, 2904, 5484, 45677, 4700, 6444, 39573, 6804, 6986, 19285, 2772, 62811, 1210, 4698, 47403, 5418, 5780, 38570, 5546, 76469, 2420, 5302, 51799, 2646, 5414, 36501, 3412, 5546, 18869, 2412, 54446, 5276, 6732, 48422, 6822, 2900, 28010, 4826, 92509, 2394, 5274, 55883, 6730, 6820, 47956, 5812, 2778, 18779, 2358, 62615, 5270, 5450, 46757, 3492, 5556, 27318, 4718, 67887, 2350, 3222, 52554, 7498, 3428, 38252, 5468, 4700, 31022, 6444, 64149, 6804, 6986, 43861, 2772, 5338, 35421, 2650, 70955, 5418, 5780, 54954, 5546, 2740, 38074, 5302, 2646, 29991, 3366, 61011, 3412, 5546, 43445, 2412, 5294, 35406, 6732, 72998, 6820, 6996, 52586, 2778, 2396, 38045, 5274, 6698, 23333, 6820, 64338, 5812, 2746, 43355, 2358, 5270, 39499, 5450, 79525, 3492, 5548],
          h = [1887, 966732, 967231, 967733, 968265, 968766, 969297, 969798, 970298, 970829, 971330, 971830, 972362, 972863, 973395, 973896, 974397, 974928, 975428, 975929, 976461, 976962, 977462, 977994, 978494, 979026, 979526, 980026, 980558, 981059, 981559, 982091, 982593, 983124, 983624, 984124, 984656, 985157, 985656, 986189, 986690, 987191, 987722, 988222, 988753, 989254, 989754, 990286, 990788, 991288, 991819, 992319, 992851, 993352, 993851, 994383, 994885, 995385, 995917, 996418, 996918, 997450, 997949, 998481, 998982, 999483, 1000014, 1000515, 1001016, 1001548, 1002047, 1002578, 1003080, 1003580, 1004111, 1004613, 1005113, 1005645, 1006146, 1006645, 1007177, 1007678, 1008209, 1008710, 1009211, 1009743, 1010243, 1010743, 1011275, 1011775, 1012306, 1012807, 1013308, 1013840, 1014341, 1014841, 1015373, 1015874, 1016404, 1016905, 1017405, 1017937, 1018438, 1018939, 1019471, 1019972, 1020471, 1021002, 1021503, 1022035, 1022535, 1023036, 1023568, 1024069, 1024568, 1025100, 1025601, 1026102, 1026633, 1027133, 1027666, 1028167, 1028666, 1029198, 1029699, 1030199, 1030730, 1031231, 1031763, 1032264, 1032764, 1033296, 1033797, 1034297, 1034828, 1035329, 1035830, 1036362, 1036861, 1037393, 1037894, 1038394, 1038925, 1039427, 1039927, 1040459, 1040959, 1041491, 1041992, 1042492, 1043023, 1043524, 1044024, 1044556, 1045057, 1045558, 1046090, 1046590, 1047121, 1047622, 1048122, 1048654, 1049154, 1049655, 1050187, 1050689, 1051219, 1051720, 1052220, 1052751, 1053252, 1053752, 1054284, 1054786, 1055285, 1055817, 1056317, 1056849, 1057349, 1057850, 1058382, 1058883, 1059383, 1059915, 1060415, 1060947, 1061447, 1061947, 1062479, 1062981, 1063480, 1064012, 1064514, 1065014, 1065545, 1066045, 1066577, 1067078, 1067578, 1068110, 1068611, 1069112, 1069642, 1070142, 1070674, 1071175, 1071675, 1072207, 1072709, 1073209, 1073740, 1074241, 1074741, 1075273, 1075773, 1076305, 1076807, 1077308, 1077839, 1078340, 1078840, 1079372, 1079871, 1080403, 1080904];
    }, {
      "../main": 636,
      "object-assign": 479
    }],
    623: [function (t, e, r) {
      var n = t("../main"),
          i = t("object-assign");

      function a(t) {
        this.local = this.regionalOptions[t || ""] || this.regionalOptions[""];
      }

      a.prototype = new n.baseCalendar(), i(a.prototype, {
        name: "Coptic",
        jdEpoch: 1825029.5,
        daysPerMonth: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 5],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Coptic",
            epochs: ["BAM", "AM"],
            monthNames: ["Thout", "Paopi", "Hathor", "Koiak", "Tobi", "Meshir", "Paremhat", "Paremoude", "Pashons", "Paoni", "Epip", "Mesori", "Pi Kogi Enavot"],
            monthNamesShort: ["Tho", "Pao", "Hath", "Koi", "Tob", "Mesh", "Pat", "Pad", "Pash", "Pao", "Epi", "Meso", "PiK"],
            dayNames: ["Tkyriaka", "Pesnau", "Pshoment", "Peftoou", "Ptiou", "Psoou", "Psabbaton"],
            dayNamesShort: ["Tky", "Pes", "Psh", "Pef", "Pti", "Pso", "Psa"],
            dayNamesMin: ["Tk", "Pes", "Psh", "Pef", "Pt", "Pso", "Psa"],
            digits: null,
            dateFormat: "dd/mm/yyyy",
            firstDay: 0,
            isRTL: !1
          }
        },
        leapYear: function leapYear(t) {
          var e = this._validate(t, this.minMonth, this.minDay, n.local.invalidYear);

          return (t = e.year() + (e.year() < 0 ? 1 : 0)) % 4 == 3 || t % 4 == -1;
        },
        monthsInYear: function monthsInYear(t) {
          return this._validate(t, this.minMonth, this.minDay, n.local.invalidYear || n.regionalOptions[""].invalidYear), 13;
        },
        weekOfYear: function weekOfYear(t, e, r) {
          var n = this.newDate(t, e, r);
          return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
        },
        daysInMonth: function daysInMonth(t, e) {
          var r = this._validate(t, e, this.minDay, n.local.invalidMonth);

          return this.daysPerMonth[r.month() - 1] + (13 === r.month() && this.leapYear(r.year()) ? 1 : 0);
        },
        weekDay: function weekDay(t, e, r) {
          return (this.dayOfWeek(t, e, r) || 7) < 6;
        },
        toJD: function toJD(t, e, r) {
          var i = this._validate(t, e, r, n.local.invalidDate);

          return (t = i.year()) < 0 && t++, i.day() + 30 * (i.month() - 1) + 365 * (t - 1) + Math.floor(t / 4) + this.jdEpoch - 1;
        },
        fromJD: function fromJD(t) {
          var e = Math.floor(t) + .5 - this.jdEpoch,
              r = Math.floor((e - Math.floor((e + 366) / 1461)) / 365) + 1;
          r <= 0 && r--, e = Math.floor(t) + .5 - this.newDate(r, 1, 1).toJD();
          var n = Math.floor(e / 30) + 1,
              i = e - 30 * (n - 1) + 1;
          return this.newDate(r, n, i);
        }
      }), n.calendars.coptic = a;
    }, {
      "../main": 636,
      "object-assign": 479
    }],
    624: [function (t, e, r) {
      var n = t("../main"),
          i = t("object-assign");

      function a(t) {
        this.local = this.regionalOptions[t || ""] || this.regionalOptions[""];
      }

      a.prototype = new n.baseCalendar(), i(a.prototype, {
        name: "Discworld",
        jdEpoch: 1721425.5,
        daysPerMonth: [16, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Discworld",
            epochs: ["BUC", "UC"],
            monthNames: ["Ick", "Offle", "February", "March", "April", "May", "June", "Grune", "August", "Spune", "Sektober", "Ember", "December"],
            monthNamesShort: ["Ick", "Off", "Feb", "Mar", "Apr", "May", "Jun", "Gru", "Aug", "Spu", "Sek", "Emb", "Dec"],
            dayNames: ["Sunday", "Octeday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Oct", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Oc", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            digits: null,
            dateFormat: "yyyy/mm/dd",
            firstDay: 2,
            isRTL: !1
          }
        },
        leapYear: function leapYear(t) {
          return this._validate(t, this.minMonth, this.minDay, n.local.invalidYear), !1;
        },
        monthsInYear: function monthsInYear(t) {
          return this._validate(t, this.minMonth, this.minDay, n.local.invalidYear), 13;
        },
        daysInYear: function daysInYear(t) {
          return this._validate(t, this.minMonth, this.minDay, n.local.invalidYear), 400;
        },
        weekOfYear: function weekOfYear(t, e, r) {
          var n = this.newDate(t, e, r);
          return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 8) + 1;
        },
        daysInMonth: function daysInMonth(t, e) {
          var r = this._validate(t, e, this.minDay, n.local.invalidMonth);

          return this.daysPerMonth[r.month() - 1];
        },
        daysInWeek: function daysInWeek() {
          return 8;
        },
        dayOfWeek: function dayOfWeek(t, e, r) {
          return (this._validate(t, e, r, n.local.invalidDate).day() + 1) % 8;
        },
        weekDay: function weekDay(t, e, r) {
          var n = this.dayOfWeek(t, e, r);
          return n >= 2 && n <= 6;
        },
        extraInfo: function extraInfo(t, e, r) {
          var i = this._validate(t, e, r, n.local.invalidDate);

          return {
            century: o[Math.floor((i.year() - 1) / 100) + 1] || ""
          };
        },
        toJD: function toJD(t, e, r) {
          var i = this._validate(t, e, r, n.local.invalidDate);

          return t = i.year() + (i.year() < 0 ? 1 : 0), e = i.month(), (r = i.day()) + (e > 1 ? 16 : 0) + (e > 2 ? 32 * (e - 2) : 0) + 400 * (t - 1) + this.jdEpoch - 1;
        },
        fromJD: function fromJD(t) {
          t = Math.floor(t + .5) - Math.floor(this.jdEpoch) - 1;
          var e = Math.floor(t / 400) + 1;
          t -= 400 * (e - 1), t += t > 15 ? 16 : 0;
          var r = Math.floor(t / 32) + 1,
              n = t - 32 * (r - 1) + 1;
          return this.newDate(e <= 0 ? e - 1 : e, r, n);
        }
      });
      var o = {
        20: "Fruitbat",
        21: "Anchovy"
      };
      n.calendars.discworld = a;
    }, {
      "../main": 636,
      "object-assign": 479
    }],
    625: [function (t, e, r) {
      var n = t("../main"),
          i = t("object-assign");

      function a(t) {
        this.local = this.regionalOptions[t || ""] || this.regionalOptions[""];
      }

      a.prototype = new n.baseCalendar(), i(a.prototype, {
        name: "Ethiopian",
        jdEpoch: 1724220.5,
        daysPerMonth: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 5],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Ethiopian",
            epochs: ["BEE", "EE"],
            monthNames: ["Meskerem", "Tikemet", "Hidar", "Tahesas", "Tir", "Yekatit", "Megabit", "Miazia", "Genbot", "Sene", "Hamle", "Nehase", "Pagume"],
            monthNamesShort: ["Mes", "Tik", "Hid", "Tah", "Tir", "Yek", "Meg", "Mia", "Gen", "Sen", "Ham", "Neh", "Pag"],
            dayNames: ["Ehud", "Segno", "Maksegno", "Irob", "Hamus", "Arb", "Kidame"],
            dayNamesShort: ["Ehu", "Seg", "Mak", "Iro", "Ham", "Arb", "Kid"],
            dayNamesMin: ["Eh", "Se", "Ma", "Ir", "Ha", "Ar", "Ki"],
            digits: null,
            dateFormat: "dd/mm/yyyy",
            firstDay: 0,
            isRTL: !1
          }
        },
        leapYear: function leapYear(t) {
          var e = this._validate(t, this.minMonth, this.minDay, n.local.invalidYear);

          return (t = e.year() + (e.year() < 0 ? 1 : 0)) % 4 == 3 || t % 4 == -1;
        },
        monthsInYear: function monthsInYear(t) {
          return this._validate(t, this.minMonth, this.minDay, n.local.invalidYear || n.regionalOptions[""].invalidYear), 13;
        },
        weekOfYear: function weekOfYear(t, e, r) {
          var n = this.newDate(t, e, r);
          return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
        },
        daysInMonth: function daysInMonth(t, e) {
          var r = this._validate(t, e, this.minDay, n.local.invalidMonth);

          return this.daysPerMonth[r.month() - 1] + (13 === r.month() && this.leapYear(r.year()) ? 1 : 0);
        },
        weekDay: function weekDay(t, e, r) {
          return (this.dayOfWeek(t, e, r) || 7) < 6;
        },
        toJD: function toJD(t, e, r) {
          var i = this._validate(t, e, r, n.local.invalidDate);

          return (t = i.year()) < 0 && t++, i.day() + 30 * (i.month() - 1) + 365 * (t - 1) + Math.floor(t / 4) + this.jdEpoch - 1;
        },
        fromJD: function fromJD(t) {
          var e = Math.floor(t) + .5 - this.jdEpoch,
              r = Math.floor((e - Math.floor((e + 366) / 1461)) / 365) + 1;
          r <= 0 && r--, e = Math.floor(t) + .5 - this.newDate(r, 1, 1).toJD();
          var n = Math.floor(e / 30) + 1,
              i = e - 30 * (n - 1) + 1;
          return this.newDate(r, n, i);
        }
      }), n.calendars.ethiopian = a;
    }, {
      "../main": 636,
      "object-assign": 479
    }],
    626: [function (t, e, r) {
      var n = t("../main"),
          i = t("object-assign");

      function a(t) {
        this.local = this.regionalOptions[t || ""] || this.regionalOptions[""];
      }

      function o(t, e) {
        return t - e * Math.floor(t / e);
      }

      a.prototype = new n.baseCalendar(), i(a.prototype, {
        name: "Hebrew",
        jdEpoch: 347995.5,
        daysPerMonth: [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 29],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 7,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Hebrew",
            epochs: ["BAM", "AM"],
            monthNames: ["Nisan", "Iyar", "Sivan", "Tammuz", "Av", "Elul", "Tishrei", "Cheshvan", "Kislev", "Tevet", "Shevat", "Adar", "Adar II"],
            monthNamesShort: ["Nis", "Iya", "Siv", "Tam", "Av", "Elu", "Tis", "Che", "Kis", "Tev", "She", "Ada", "Ad2"],
            dayNames: ["Yom Rishon", "Yom Sheni", "Yom Shlishi", "Yom Revi'i", "Yom Chamishi", "Yom Shishi", "Yom Shabbat"],
            dayNamesShort: ["Ris", "She", "Shl", "Rev", "Cha", "Shi", "Sha"],
            dayNamesMin: ["Ri", "She", "Shl", "Re", "Ch", "Shi", "Sha"],
            digits: null,
            dateFormat: "dd/mm/yyyy",
            firstDay: 0,
            isRTL: !1
          }
        },
        leapYear: function leapYear(t) {
          var e = this._validate(t, this.minMonth, this.minDay, n.local.invalidYear);

          return this._leapYear(e.year());
        },
        _leapYear: function _leapYear(t) {
          return o(7 * (t = t < 0 ? t + 1 : t) + 1, 19) < 7;
        },
        monthsInYear: function monthsInYear(t) {
          return this._validate(t, this.minMonth, this.minDay, n.local.invalidYear), this._leapYear(t.year ? t.year() : t) ? 13 : 12;
        },
        weekOfYear: function weekOfYear(t, e, r) {
          var n = this.newDate(t, e, r);
          return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
        },
        daysInYear: function daysInYear(t) {
          return t = this._validate(t, this.minMonth, this.minDay, n.local.invalidYear).year(), this.toJD(-1 === t ? 1 : t + 1, 7, 1) - this.toJD(t, 7, 1);
        },
        daysInMonth: function daysInMonth(t, e) {
          return t.year && (e = t.month(), t = t.year()), this._validate(t, e, this.minDay, n.local.invalidMonth), 12 === e && this.leapYear(t) || 8 === e && 5 === o(this.daysInYear(t), 10) ? 30 : 9 === e && 3 === o(this.daysInYear(t), 10) ? 29 : this.daysPerMonth[e - 1];
        },
        weekDay: function weekDay(t, e, r) {
          return 6 !== this.dayOfWeek(t, e, r);
        },
        extraInfo: function extraInfo(t, e, r) {
          var i = this._validate(t, e, r, n.local.invalidDate);

          return {
            yearType: (this.leapYear(i) ? "embolismic" : "common") + " " + ["deficient", "regular", "complete"][this.daysInYear(i) % 10 - 3]
          };
        },
        toJD: function toJD(t, e, r) {
          var i = this._validate(t, e, r, n.local.invalidDate);

          t = i.year(), e = i.month(), r = i.day();
          var a = t <= 0 ? t + 1 : t,
              o = this.jdEpoch + this._delay1(a) + this._delay2(a) + r + 1;

          if (e < 7) {
            for (var s = 7; s <= this.monthsInYear(t); s++) {
              o += this.daysInMonth(t, s);
            }

            for (s = 1; s < e; s++) {
              o += this.daysInMonth(t, s);
            }
          } else for (s = 7; s < e; s++) {
            o += this.daysInMonth(t, s);
          }

          return o;
        },
        _delay1: function _delay1(t) {
          var e = Math.floor((235 * t - 234) / 19),
              r = 12084 + 13753 * e,
              n = 29 * e + Math.floor(r / 25920);
          return o(3 * (n + 1), 7) < 3 && n++, n;
        },
        _delay2: function _delay2(t) {
          var e = this._delay1(t - 1),
              r = this._delay1(t);

          return this._delay1(t + 1) - r == 356 ? 2 : r - e == 382 ? 1 : 0;
        },
        fromJD: function fromJD(t) {
          t = Math.floor(t) + .5;

          for (var e = Math.floor(98496 * (t - this.jdEpoch) / 35975351) - 1; t >= this.toJD(-1 === e ? 1 : e + 1, 7, 1);) {
            e++;
          }

          for (var r = t < this.toJD(e, 1, 1) ? 7 : 1; t > this.toJD(e, r, this.daysInMonth(e, r));) {
            r++;
          }

          var n = t - this.toJD(e, r, 1) + 1;
          return this.newDate(e, r, n);
        }
      }), n.calendars.hebrew = a;
    }, {
      "../main": 636,
      "object-assign": 479
    }],
    627: [function (t, e, r) {
      var n = t("../main"),
          i = t("object-assign");

      function a(t) {
        this.local = this.regionalOptions[t || ""] || this.regionalOptions[""];
      }

      a.prototype = new n.baseCalendar(), i(a.prototype, {
        name: "Islamic",
        jdEpoch: 1948439.5,
        daysPerMonth: [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Islamic",
            epochs: ["BH", "AH"],
            monthNames: ["Muharram", "Safar", "Rabi' al-awwal", "Rabi' al-thani", "Jumada al-awwal", "Jumada al-thani", "Rajab", "Sha'aban", "Ramadan", "Shawwal", "Dhu al-Qi'dah", "Dhu al-Hijjah"],
            monthNamesShort: ["Muh", "Saf", "Rab1", "Rab2", "Jum1", "Jum2", "Raj", "Sha'", "Ram", "Shaw", "DhuQ", "DhuH"],
            dayNames: ["Yawm al-ahad", "Yawm al-ithnayn", "Yawm ath-thulaathaa'", "Yawm al-arbi'aa'", "Yawm al-kham\u012Bs", "Yawm al-jum'a", "Yawm as-sabt"],
            dayNamesShort: ["Aha", "Ith", "Thu", "Arb", "Kha", "Jum", "Sab"],
            dayNamesMin: ["Ah", "It", "Th", "Ar", "Kh", "Ju", "Sa"],
            digits: null,
            dateFormat: "yyyy/mm/dd",
            firstDay: 6,
            isRTL: !1
          }
        },
        leapYear: function leapYear(t) {
          return (11 * this._validate(t, this.minMonth, this.minDay, n.local.invalidYear).year() + 14) % 30 < 11;
        },
        weekOfYear: function weekOfYear(t, e, r) {
          var n = this.newDate(t, e, r);
          return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
        },
        daysInYear: function daysInYear(t) {
          return this.leapYear(t) ? 355 : 354;
        },
        daysInMonth: function daysInMonth(t, e) {
          var r = this._validate(t, e, this.minDay, n.local.invalidMonth);

          return this.daysPerMonth[r.month() - 1] + (12 === r.month() && this.leapYear(r.year()) ? 1 : 0);
        },
        weekDay: function weekDay(t, e, r) {
          return 5 !== this.dayOfWeek(t, e, r);
        },
        toJD: function toJD(t, e, r) {
          var i = this._validate(t, e, r, n.local.invalidDate);

          return t = i.year(), e = i.month(), t = t <= 0 ? t + 1 : t, (r = i.day()) + Math.ceil(29.5 * (e - 1)) + 354 * (t - 1) + Math.floor((3 + 11 * t) / 30) + this.jdEpoch - 1;
        },
        fromJD: function fromJD(t) {
          t = Math.floor(t) + .5;
          var e = Math.floor((30 * (t - this.jdEpoch) + 10646) / 10631);
          e = e <= 0 ? e - 1 : e;
          var r = Math.min(12, Math.ceil((t - 29 - this.toJD(e, 1, 1)) / 29.5) + 1),
              n = t - this.toJD(e, r, 1) + 1;
          return this.newDate(e, r, n);
        }
      }), n.calendars.islamic = a;
    }, {
      "../main": 636,
      "object-assign": 479
    }],
    628: [function (t, e, r) {
      var n = t("../main"),
          i = t("object-assign");

      function a(t) {
        this.local = this.regionalOptions[t || ""] || this.regionalOptions[""];
      }

      a.prototype = new n.baseCalendar(), i(a.prototype, {
        name: "Julian",
        jdEpoch: 1721423.5,
        daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Julian",
            epochs: ["BC", "AD"],
            monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            digits: null,
            dateFormat: "mm/dd/yyyy",
            firstDay: 0,
            isRTL: !1
          }
        },
        leapYear: function leapYear(t) {
          var e = this._validate(t, this.minMonth, this.minDay, n.local.invalidYear);

          return (t = e.year() < 0 ? e.year() + 1 : e.year()) % 4 == 0;
        },
        weekOfYear: function weekOfYear(t, e, r) {
          var n = this.newDate(t, e, r);
          return n.add(4 - (n.dayOfWeek() || 7), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
        },
        daysInMonth: function daysInMonth(t, e) {
          var r = this._validate(t, e, this.minDay, n.local.invalidMonth);

          return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
        },
        weekDay: function weekDay(t, e, r) {
          return (this.dayOfWeek(t, e, r) || 7) < 6;
        },
        toJD: function toJD(t, e, r) {
          var i = this._validate(t, e, r, n.local.invalidDate);

          return t = i.year(), e = i.month(), r = i.day(), t < 0 && t++, e <= 2 && (t--, e += 12), Math.floor(365.25 * (t + 4716)) + Math.floor(30.6001 * (e + 1)) + r - 1524.5;
        },
        fromJD: function fromJD(t) {
          var e = Math.floor(t + .5) + 1524,
              r = Math.floor((e - 122.1) / 365.25),
              n = Math.floor(365.25 * r),
              i = Math.floor((e - n) / 30.6001),
              a = i - Math.floor(i < 14 ? 1 : 13),
              o = r - Math.floor(a > 2 ? 4716 : 4715),
              s = e - n - Math.floor(30.6001 * i);
          return o <= 0 && o--, this.newDate(o, a, s);
        }
      }), n.calendars.julian = a;
    }, {
      "../main": 636,
      "object-assign": 479
    }],
    629: [function (t, e, r) {
      var n = t("../main"),
          i = t("object-assign");

      function a(t) {
        this.local = this.regionalOptions[t || ""] || this.regionalOptions[""];
      }

      function o(t, e) {
        return t - e * Math.floor(t / e);
      }

      function s(t, e) {
        return o(t - 1, e) + 1;
      }

      a.prototype = new n.baseCalendar(), i(a.prototype, {
        name: "Mayan",
        jdEpoch: 584282.5,
        hasYearZero: !0,
        minMonth: 0,
        firstMonth: 0,
        minDay: 0,
        regionalOptions: {
          "": {
            name: "Mayan",
            epochs: ["", ""],
            monthNames: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17"],
            monthNamesShort: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17"],
            dayNames: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19"],
            dayNamesShort: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19"],
            dayNamesMin: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19"],
            digits: null,
            dateFormat: "YYYY.m.d",
            firstDay: 0,
            isRTL: !1,
            haabMonths: ["Pop", "Uo", "Zip", "Zotz", "Tzec", "Xul", "Yaxkin", "Mol", "Chen", "Yax", "Zac", "Ceh", "Mac", "Kankin", "Muan", "Pax", "Kayab", "Cumku", "Uayeb"],
            tzolkinMonths: ["Imix", "Ik", "Akbal", "Kan", "Chicchan", "Cimi", "Manik", "Lamat", "Muluc", "Oc", "Chuen", "Eb", "Ben", "Ix", "Men", "Cib", "Caban", "Etznab", "Cauac", "Ahau"]
          }
        },
        leapYear: function leapYear(t) {
          return this._validate(t, this.minMonth, this.minDay, n.local.invalidYear), !1;
        },
        formatYear: function formatYear(t) {
          t = this._validate(t, this.minMonth, this.minDay, n.local.invalidYear).year();
          var e = Math.floor(t / 400);
          return t %= 400, t += t < 0 ? 400 : 0, e + "." + Math.floor(t / 20) + "." + t % 20;
        },
        forYear: function forYear(t) {
          if ((t = t.split(".")).length < 3) throw "Invalid Mayan year";

          for (var e = 0, r = 0; r < t.length; r++) {
            var n = parseInt(t[r], 10);
            if (Math.abs(n) > 19 || r > 0 && n < 0) throw "Invalid Mayan year";
            e = 20 * e + n;
          }

          return e;
        },
        monthsInYear: function monthsInYear(t) {
          return this._validate(t, this.minMonth, this.minDay, n.local.invalidYear), 18;
        },
        weekOfYear: function weekOfYear(t, e, r) {
          return this._validate(t, e, r, n.local.invalidDate), 0;
        },
        daysInYear: function daysInYear(t) {
          return this._validate(t, this.minMonth, this.minDay, n.local.invalidYear), 360;
        },
        daysInMonth: function daysInMonth(t, e) {
          return this._validate(t, e, this.minDay, n.local.invalidMonth), 20;
        },
        daysInWeek: function daysInWeek() {
          return 5;
        },
        dayOfWeek: function dayOfWeek(t, e, r) {
          return this._validate(t, e, r, n.local.invalidDate).day();
        },
        weekDay: function weekDay(t, e, r) {
          return this._validate(t, e, r, n.local.invalidDate), !0;
        },
        extraInfo: function extraInfo(t, e, r) {
          var i = this._validate(t, e, r, n.local.invalidDate).toJD(),
              a = this._toHaab(i),
              o = this._toTzolkin(i);

          return {
            haabMonthName: this.local.haabMonths[a[0] - 1],
            haabMonth: a[0],
            haabDay: a[1],
            tzolkinDayName: this.local.tzolkinMonths[o[0] - 1],
            tzolkinDay: o[0],
            tzolkinTrecena: o[1]
          };
        },
        _toHaab: function _toHaab(t) {
          var e = o((t -= this.jdEpoch) + 8 + 340, 365);
          return [Math.floor(e / 20) + 1, o(e, 20)];
        },
        _toTzolkin: function _toTzolkin(t) {
          return [s((t -= this.jdEpoch) + 20, 20), s(t + 4, 13)];
        },
        toJD: function toJD(t, e, r) {
          var i = this._validate(t, e, r, n.local.invalidDate);

          return i.day() + 20 * i.month() + 360 * i.year() + this.jdEpoch;
        },
        fromJD: function fromJD(t) {
          t = Math.floor(t) + .5 - this.jdEpoch;
          var e = Math.floor(t / 360);
          t %= 360, t += t < 0 ? 360 : 0;
          var r = Math.floor(t / 20),
              n = t % 20;
          return this.newDate(e, r, n);
        }
      }), n.calendars.mayan = a;
    }, {
      "../main": 636,
      "object-assign": 479
    }],
    630: [function (t, e, r) {
      var n = t("../main"),
          i = t("object-assign");

      function a(t) {
        this.local = this.regionalOptions[t || ""] || this.regionalOptions[""];
      }

      a.prototype = new n.baseCalendar();
      var o = n.instance("gregorian");
      i(a.prototype, {
        name: "Nanakshahi",
        jdEpoch: 2257673.5,
        daysPerMonth: [31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 30, 30],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Nanakshahi",
            epochs: ["BN", "AN"],
            monthNames: ["Chet", "Vaisakh", "Jeth", "Harh", "Sawan", "Bhadon", "Assu", "Katak", "Maghar", "Poh", "Magh", "Phagun"],
            monthNamesShort: ["Che", "Vai", "Jet", "Har", "Saw", "Bha", "Ass", "Kat", "Mgr", "Poh", "Mgh", "Pha"],
            dayNames: ["Somvaar", "Mangalvar", "Budhvaar", "Veervaar", "Shukarvaar", "Sanicharvaar", "Etvaar"],
            dayNamesShort: ["Som", "Mangal", "Budh", "Veer", "Shukar", "Sanichar", "Et"],
            dayNamesMin: ["So", "Ma", "Bu", "Ve", "Sh", "Sa", "Et"],
            digits: null,
            dateFormat: "dd-mm-yyyy",
            firstDay: 0,
            isRTL: !1
          }
        },
        leapYear: function leapYear(t) {
          var e = this._validate(t, this.minMonth, this.minDay, n.local.invalidYear || n.regionalOptions[""].invalidYear);

          return o.leapYear(e.year() + (e.year() < 1 ? 1 : 0) + 1469);
        },
        weekOfYear: function weekOfYear(t, e, r) {
          var n = this.newDate(t, e, r);
          return n.add(1 - (n.dayOfWeek() || 7), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
        },
        daysInMonth: function daysInMonth(t, e) {
          var r = this._validate(t, e, this.minDay, n.local.invalidMonth);

          return this.daysPerMonth[r.month() - 1] + (12 === r.month() && this.leapYear(r.year()) ? 1 : 0);
        },
        weekDay: function weekDay(t, e, r) {
          return (this.dayOfWeek(t, e, r) || 7) < 6;
        },
        toJD: function toJD(t, e, r) {
          var i = this._validate(t, e, r, n.local.invalidMonth);

          (t = i.year()) < 0 && t++;

          for (var a = i.day(), s = 1; s < i.month(); s++) {
            a += this.daysPerMonth[s - 1];
          }

          return a + o.toJD(t + 1468, 3, 13);
        },
        fromJD: function fromJD(t) {
          t = Math.floor(t + .5);

          for (var e = Math.floor((t - (this.jdEpoch - 1)) / 366); t >= this.toJD(e + 1, 1, 1);) {
            e++;
          }

          for (var r = t - Math.floor(this.toJD(e, 1, 1) + .5) + 1, n = 1; r > this.daysInMonth(e, n);) {
            r -= this.daysInMonth(e, n), n++;
          }

          return this.newDate(e, n, r);
        }
      }), n.calendars.nanakshahi = a;
    }, {
      "../main": 636,
      "object-assign": 479
    }],
    631: [function (t, e, r) {
      var n = t("../main"),
          i = t("object-assign");

      function a(t) {
        this.local = this.regionalOptions[t || ""] || this.regionalOptions[""];
      }

      a.prototype = new n.baseCalendar(), i(a.prototype, {
        name: "Nepali",
        jdEpoch: 1700709.5,
        daysPerMonth: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        daysPerYear: 365,
        regionalOptions: {
          "": {
            name: "Nepali",
            epochs: ["BBS", "ABS"],
            monthNames: ["Baisakh", "Jestha", "Ashadh", "Shrawan", "Bhadra", "Ashwin", "Kartik", "Mangsir", "Paush", "Mangh", "Falgun", "Chaitra"],
            monthNamesShort: ["Bai", "Je", "As", "Shra", "Bha", "Ash", "Kar", "Mang", "Pau", "Ma", "Fal", "Chai"],
            dayNames: ["Aaitabaar", "Sombaar", "Manglbaar", "Budhabaar", "Bihibaar", "Shukrabaar", "Shanibaar"],
            dayNamesShort: ["Aaita", "Som", "Mangl", "Budha", "Bihi", "Shukra", "Shani"],
            dayNamesMin: ["Aai", "So", "Man", "Bu", "Bi", "Shu", "Sha"],
            digits: null,
            dateFormat: "dd/mm/yyyy",
            firstDay: 1,
            isRTL: !1
          }
        },
        leapYear: function leapYear(t) {
          return this.daysInYear(t) !== this.daysPerYear;
        },
        weekOfYear: function weekOfYear(t, e, r) {
          var n = this.newDate(t, e, r);
          return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
        },
        daysInYear: function daysInYear(t) {
          if (t = this._validate(t, this.minMonth, this.minDay, n.local.invalidYear).year(), void 0 === this.NEPALI_CALENDAR_DATA[t]) return this.daysPerYear;

          for (var e = 0, r = this.minMonth; r <= 12; r++) {
            e += this.NEPALI_CALENDAR_DATA[t][r];
          }

          return e;
        },
        daysInMonth: function daysInMonth(t, e) {
          return t.year && (e = t.month(), t = t.year()), this._validate(t, e, this.minDay, n.local.invalidMonth), void 0 === this.NEPALI_CALENDAR_DATA[t] ? this.daysPerMonth[e - 1] : this.NEPALI_CALENDAR_DATA[t][e];
        },
        weekDay: function weekDay(t, e, r) {
          return 6 !== this.dayOfWeek(t, e, r);
        },
        toJD: function toJD(t, e, r) {
          var i = this._validate(t, e, r, n.local.invalidDate);

          t = i.year(), e = i.month(), r = i.day();
          var a = n.instance(),
              o = 0,
              s = e,
              l = t;

          this._createMissingCalendarData(t);

          var c = t - (s > 9 || 9 === s && r >= this.NEPALI_CALENDAR_DATA[l][0] ? 56 : 57);

          for (9 !== e && (o = r, s--); 9 !== s;) {
            s <= 0 && (s = 12, l--), o += this.NEPALI_CALENDAR_DATA[l][s], s--;
          }

          return 9 === e ? (o += r - this.NEPALI_CALENDAR_DATA[l][0]) < 0 && (o += a.daysInYear(c)) : o += this.NEPALI_CALENDAR_DATA[l][9] - this.NEPALI_CALENDAR_DATA[l][0], a.newDate(c, 1, 1).add(o, "d").toJD();
        },
        fromJD: function fromJD(t) {
          var e = n.instance().fromJD(t),
              r = e.year(),
              i = e.dayOfYear(),
              a = r + 56;

          this._createMissingCalendarData(a);

          for (var o = 9, s = this.NEPALI_CALENDAR_DATA[a][0], l = this.NEPALI_CALENDAR_DATA[a][o] - s + 1; i > l;) {
            ++o > 12 && (o = 1, a++), l += this.NEPALI_CALENDAR_DATA[a][o];
          }

          var c = this.NEPALI_CALENDAR_DATA[a][o] - (l - i);
          return this.newDate(a, o, c);
        },
        _createMissingCalendarData: function _createMissingCalendarData(t) {
          var e = this.daysPerMonth.slice(0);
          e.unshift(17);

          for (var r = t - 1; r < t + 2; r++) {
            void 0 === this.NEPALI_CALENDAR_DATA[r] && (this.NEPALI_CALENDAR_DATA[r] = e);
          }
        },
        NEPALI_CALENDAR_DATA: {
          1970: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1971: [18, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
          1972: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          1973: [19, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          1974: [19, 31, 31, 32, 30, 31, 31, 30, 29, 30, 29, 30, 30],
          1975: [18, 31, 31, 32, 32, 30, 31, 30, 29, 30, 29, 30, 30],
          1976: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          1977: [18, 31, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31],
          1978: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1979: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          1980: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          1981: [18, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          1982: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1983: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          1984: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          1985: [18, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          1986: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1987: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          1988: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          1989: [18, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          1990: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1991: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          1992: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          1993: [18, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          1994: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1995: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          1996: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          1997: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1998: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1999: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2e3: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2001: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2002: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2003: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2004: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2005: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2006: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2007: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2008: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
          2009: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2010: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2011: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2012: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          2013: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2014: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2015: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2016: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          2017: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2018: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2019: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2020: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2021: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2022: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          2023: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2024: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2025: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2026: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2027: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2028: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2029: [18, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
          2030: [17, 31, 32, 31, 32, 31, 30, 30, 30, 30, 30, 30, 31],
          2031: [17, 31, 32, 31, 32, 31, 31, 31, 31, 31, 31, 31, 31],
          2032: [17, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32],
          2033: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2034: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2035: [17, 30, 32, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
          2036: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2037: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2038: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2039: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          2040: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2041: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2042: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2043: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          2044: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2045: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2046: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2047: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2048: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2049: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          2050: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2051: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2052: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2053: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          2054: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2055: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 30, 29, 30],
          2056: [17, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
          2057: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2058: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2059: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2060: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2061: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2062: [17, 30, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31],
          2063: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2064: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2065: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2066: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
          2067: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2068: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2069: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2070: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          2071: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2072: [17, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2073: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2074: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2075: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2076: [16, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          2077: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2078: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2079: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2080: [16, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          2081: [17, 31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2082: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2083: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
          2084: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
          2085: [17, 31, 32, 31, 32, 31, 31, 30, 30, 29, 30, 30, 30],
          2086: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2087: [16, 31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
          2088: [16, 30, 31, 32, 32, 30, 31, 30, 30, 29, 30, 30, 30],
          2089: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2090: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2091: [16, 31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
          2092: [16, 31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2093: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2094: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
          2095: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 30, 30, 30],
          2096: [17, 30, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2097: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2098: [17, 31, 31, 32, 31, 31, 31, 29, 30, 29, 30, 30, 31],
          2099: [17, 31, 31, 32, 31, 31, 31, 30, 29, 29, 30, 30, 30],
          2100: [17, 31, 32, 31, 32, 30, 31, 30, 29, 30, 29, 30, 30]
        }
      }), n.calendars.nepali = a;
    }, {
      "../main": 636,
      "object-assign": 479
    }],
    632: [function (t, e, r) {
      var n = t("../main"),
          i = t("object-assign");

      function a(t) {
        this.local = this.regionalOptions[t || ""] || this.regionalOptions[""];
      }

      function o(t, e) {
        return t - e * Math.floor(t / e);
      }

      a.prototype = new n.baseCalendar(), i(a.prototype, {
        name: "Persian",
        jdEpoch: 1948320.5,
        daysPerMonth: [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Persian",
            epochs: ["BP", "AP"],
            monthNames: ["Farvardin", "Ordibehesht", "Khordad", "Tir", "Mordad", "Shahrivar", "Mehr", "Aban", "Azar", "Day", "Bahman", "Esfand"],
            monthNamesShort: ["Far", "Ord", "Kho", "Tir", "Mor", "Sha", "Meh", "Aba", "Aza", "Day", "Bah", "Esf"],
            dayNames: ["Yekshambe", "Doshambe", "Seshambe", "Ch\xe6harshambe", "Panjshambe", "Jom'e", "Shambe"],
            dayNamesShort: ["Yek", "Do", "Se", "Ch\xe6", "Panj", "Jom", "Sha"],
            dayNamesMin: ["Ye", "Do", "Se", "Ch", "Pa", "Jo", "Sh"],
            digits: null,
            dateFormat: "yyyy/mm/dd",
            firstDay: 6,
            isRTL: !1
          }
        },
        leapYear: function leapYear(t) {
          var e = this._validate(t, this.minMonth, this.minDay, n.local.invalidYear);

          return 682 * ((e.year() - (e.year() > 0 ? 474 : 473)) % 2820 + 474 + 38) % 2816 < 682;
        },
        weekOfYear: function weekOfYear(t, e, r) {
          var n = this.newDate(t, e, r);
          return n.add(-(n.dayOfWeek() + 1) % 7, "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
        },
        daysInMonth: function daysInMonth(t, e) {
          var r = this._validate(t, e, this.minDay, n.local.invalidMonth);

          return this.daysPerMonth[r.month() - 1] + (12 === r.month() && this.leapYear(r.year()) ? 1 : 0);
        },
        weekDay: function weekDay(t, e, r) {
          return 5 !== this.dayOfWeek(t, e, r);
        },
        toJD: function toJD(t, e, r) {
          var i = this._validate(t, e, r, n.local.invalidDate);

          t = i.year(), e = i.month(), r = i.day();
          var a = t - (t >= 0 ? 474 : 473),
              s = 474 + o(a, 2820);
          return r + (e <= 7 ? 31 * (e - 1) : 30 * (e - 1) + 6) + Math.floor((682 * s - 110) / 2816) + 365 * (s - 1) + 1029983 * Math.floor(a / 2820) + this.jdEpoch - 1;
        },
        fromJD: function fromJD(t) {
          var e = (t = Math.floor(t) + .5) - this.toJD(475, 1, 1),
              r = Math.floor(e / 1029983),
              n = o(e, 1029983),
              i = 2820;

          if (1029982 !== n) {
            var a = Math.floor(n / 366),
                s = o(n, 366);
            i = Math.floor((2134 * a + 2816 * s + 2815) / 1028522) + a + 1;
          }

          var l = i + 2820 * r + 474;
          l = l <= 0 ? l - 1 : l;
          var c = t - this.toJD(l, 1, 1) + 1,
              u = c <= 186 ? Math.ceil(c / 31) : Math.ceil((c - 6) / 30),
              f = t - this.toJD(l, u, 1) + 1;
          return this.newDate(l, u, f);
        }
      }), n.calendars.persian = a, n.calendars.jalali = a;
    }, {
      "../main": 636,
      "object-assign": 479
    }],
    633: [function (t, e, r) {
      var n = t("../main"),
          i = t("object-assign"),
          a = n.instance();

      function o(t) {
        this.local = this.regionalOptions[t || ""] || this.regionalOptions[""];
      }

      o.prototype = new n.baseCalendar(), i(o.prototype, {
        name: "Taiwan",
        jdEpoch: 2419402.5,
        yearsOffset: 1911,
        daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Taiwan",
            epochs: ["BROC", "ROC"],
            monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            digits: null,
            dateFormat: "yyyy/mm/dd",
            firstDay: 1,
            isRTL: !1
          }
        },
        leapYear: function leapYear(t) {
          var e = this._validate(t, this.minMonth, this.minDay, n.local.invalidYear);

          t = this._t2gYear(e.year());
          return a.leapYear(t);
        },
        weekOfYear: function weekOfYear(t, e, r) {
          var i = this._validate(t, this.minMonth, this.minDay, n.local.invalidYear);

          t = this._t2gYear(i.year());
          return a.weekOfYear(t, i.month(), i.day());
        },
        daysInMonth: function daysInMonth(t, e) {
          var r = this._validate(t, e, this.minDay, n.local.invalidMonth);

          return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
        },
        weekDay: function weekDay(t, e, r) {
          return (this.dayOfWeek(t, e, r) || 7) < 6;
        },
        toJD: function toJD(t, e, r) {
          var i = this._validate(t, e, r, n.local.invalidDate);

          t = this._t2gYear(i.year());
          return a.toJD(t, i.month(), i.day());
        },
        fromJD: function fromJD(t) {
          var e = a.fromJD(t),
              r = this._g2tYear(e.year());

          return this.newDate(r, e.month(), e.day());
        },
        _t2gYear: function _t2gYear(t) {
          return t + this.yearsOffset + (t >= -this.yearsOffset && t <= -1 ? 1 : 0);
        },
        _g2tYear: function _g2tYear(t) {
          return t - this.yearsOffset - (t >= 1 && t <= this.yearsOffset ? 1 : 0);
        }
      }), n.calendars.taiwan = o;
    }, {
      "../main": 636,
      "object-assign": 479
    }],
    634: [function (t, e, r) {
      var n = t("../main"),
          i = t("object-assign"),
          a = n.instance();

      function o(t) {
        this.local = this.regionalOptions[t || ""] || this.regionalOptions[""];
      }

      o.prototype = new n.baseCalendar(), i(o.prototype, {
        name: "Thai",
        jdEpoch: 1523098.5,
        yearsOffset: 543,
        daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Thai",
            epochs: ["BBE", "BE"],
            monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            digits: null,
            dateFormat: "dd/mm/yyyy",
            firstDay: 0,
            isRTL: !1
          }
        },
        leapYear: function leapYear(t) {
          var e = this._validate(t, this.minMonth, this.minDay, n.local.invalidYear);

          t = this._t2gYear(e.year());
          return a.leapYear(t);
        },
        weekOfYear: function weekOfYear(t, e, r) {
          var i = this._validate(t, this.minMonth, this.minDay, n.local.invalidYear);

          t = this._t2gYear(i.year());
          return a.weekOfYear(t, i.month(), i.day());
        },
        daysInMonth: function daysInMonth(t, e) {
          var r = this._validate(t, e, this.minDay, n.local.invalidMonth);

          return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
        },
        weekDay: function weekDay(t, e, r) {
          return (this.dayOfWeek(t, e, r) || 7) < 6;
        },
        toJD: function toJD(t, e, r) {
          var i = this._validate(t, e, r, n.local.invalidDate);

          t = this._t2gYear(i.year());
          return a.toJD(t, i.month(), i.day());
        },
        fromJD: function fromJD(t) {
          var e = a.fromJD(t),
              r = this._g2tYear(e.year());

          return this.newDate(r, e.month(), e.day());
        },
        _t2gYear: function _t2gYear(t) {
          return t - this.yearsOffset - (t >= 1 && t <= this.yearsOffset ? 1 : 0);
        },
        _g2tYear: function _g2tYear(t) {
          return t + this.yearsOffset + (t >= -this.yearsOffset && t <= -1 ? 1 : 0);
        }
      }), n.calendars.thai = o;
    }, {
      "../main": 636,
      "object-assign": 479
    }],
    635: [function (t, e, r) {
      var n = t("../main"),
          i = t("object-assign");

      function a(t) {
        this.local = this.regionalOptions[t || ""] || this.regionalOptions[""];
      }

      a.prototype = new n.baseCalendar(), i(a.prototype, {
        name: "UmmAlQura",
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Umm al-Qura",
            epochs: ["BH", "AH"],
            monthNames: ["Al-Muharram", "Safar", "Rabi' al-awwal", "Rabi' Al-Thani", "Jumada Al-Awwal", "Jumada Al-Thani", "Rajab", "Sha'aban", "Ramadan", "Shawwal", "Dhu al-Qi'dah", "Dhu al-Hijjah"],
            monthNamesShort: ["Muh", "Saf", "Rab1", "Rab2", "Jum1", "Jum2", "Raj", "Sha'", "Ram", "Shaw", "DhuQ", "DhuH"],
            dayNames: ["Yawm al-Ahad", "Yawm al-Ithnain", "Yawm al-Thal\u0101th\u0101\u2019", "Yawm al-Arba\u2018\u0101\u2019", "Yawm al-Kham\u012Bs", "Yawm al-Jum\u2018a", "Yawm al-Sabt"],
            dayNamesMin: ["Ah", "Ith", "Th", "Ar", "Kh", "Ju", "Sa"],
            digits: null,
            dateFormat: "yyyy/mm/dd",
            firstDay: 6,
            isRTL: !0
          }
        },
        leapYear: function leapYear(t) {
          var e = this._validate(t, this.minMonth, this.minDay, n.local.invalidYear);

          return 355 === this.daysInYear(e.year());
        },
        weekOfYear: function weekOfYear(t, e, r) {
          var n = this.newDate(t, e, r);
          return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
        },
        daysInYear: function daysInYear(t) {
          for (var e = 0, r = 1; r <= 12; r++) {
            e += this.daysInMonth(t, r);
          }

          return e;
        },
        daysInMonth: function daysInMonth(t, e) {
          for (var r = this._validate(t, e, this.minDay, n.local.invalidMonth).toJD() - 24e5 + .5, i = 0, a = 0; a < o.length; a++) {
            if (o[a] > r) return o[i] - o[i - 1];
            i++;
          }

          return 30;
        },
        weekDay: function weekDay(t, e, r) {
          return 5 !== this.dayOfWeek(t, e, r);
        },
        toJD: function toJD(t, e, r) {
          var i = this._validate(t, e, r, n.local.invalidDate),
              a = 12 * (i.year() - 1) + i.month() - 15292;

          return i.day() + o[a - 1] - 1 + 24e5 - .5;
        },
        fromJD: function fromJD(t) {
          for (var e = t - 24e5 + .5, r = 0, n = 0; n < o.length && !(o[n] > e); n++) {
            r++;
          }

          var i = r + 15292,
              a = Math.floor((i - 1) / 12),
              s = a + 1,
              l = i - 12 * a,
              c = e - o[r - 1] + 1;
          return this.newDate(s, l, c);
        },
        isValid: function isValid(t, e, r) {
          var i = n.baseCalendar.prototype.isValid.apply(this, arguments);
          return i && (i = (t = null != t.year ? t.year : t) >= 1276 && t <= 1500), i;
        },
        _validate: function _validate(t, e, r, i) {
          var a = n.baseCalendar.prototype._validate.apply(this, arguments);

          if (a.year < 1276 || a.year > 1500) throw i.replace(/\{0\}/, this.local.name);
          return a;
        }
      }), n.calendars.ummalqura = a;
      var o = [20, 50, 79, 109, 138, 168, 197, 227, 256, 286, 315, 345, 374, 404, 433, 463, 492, 522, 551, 581, 611, 641, 670, 700, 729, 759, 788, 818, 847, 877, 906, 936, 965, 995, 1024, 1054, 1083, 1113, 1142, 1172, 1201, 1231, 1260, 1290, 1320, 1350, 1379, 1409, 1438, 1468, 1497, 1527, 1556, 1586, 1615, 1645, 1674, 1704, 1733, 1763, 1792, 1822, 1851, 1881, 1910, 1940, 1969, 1999, 2028, 2058, 2087, 2117, 2146, 2176, 2205, 2235, 2264, 2294, 2323, 2353, 2383, 2413, 2442, 2472, 2501, 2531, 2560, 2590, 2619, 2649, 2678, 2708, 2737, 2767, 2796, 2826, 2855, 2885, 2914, 2944, 2973, 3003, 3032, 3062, 3091, 3121, 3150, 3180, 3209, 3239, 3268, 3298, 3327, 3357, 3386, 3416, 3446, 3476, 3505, 3535, 3564, 3594, 3623, 3653, 3682, 3712, 3741, 3771, 3800, 3830, 3859, 3889, 3918, 3948, 3977, 4007, 4036, 4066, 4095, 4125, 4155, 4185, 4214, 4244, 4273, 4303, 4332, 4362, 4391, 4421, 4450, 4480, 4509, 4539, 4568, 4598, 4627, 4657, 4686, 4716, 4745, 4775, 4804, 4834, 4863, 4893, 4922, 4952, 4981, 5011, 5040, 5070, 5099, 5129, 5158, 5188, 5218, 5248, 5277, 5307, 5336, 5366, 5395, 5425, 5454, 5484, 5513, 5543, 5572, 5602, 5631, 5661, 5690, 5720, 5749, 5779, 5808, 5838, 5867, 5897, 5926, 5956, 5985, 6015, 6044, 6074, 6103, 6133, 6162, 6192, 6221, 6251, 6281, 6311, 6340, 6370, 6399, 6429, 6458, 6488, 6517, 6547, 6576, 6606, 6635, 6665, 6694, 6724, 6753, 6783, 6812, 6842, 6871, 6901, 6930, 6960, 6989, 7019, 7048, 7078, 7107, 7137, 7166, 7196, 7225, 7255, 7284, 7314, 7344, 7374, 7403, 7433, 7462, 7492, 7521, 7551, 7580, 7610, 7639, 7669, 7698, 7728, 7757, 7787, 7816, 7846, 7875, 7905, 7934, 7964, 7993, 8023, 8053, 8083, 8112, 8142, 8171, 8201, 8230, 8260, 8289, 8319, 8348, 8378, 8407, 8437, 8466, 8496, 8525, 8555, 8584, 8614, 8643, 8673, 8702, 8732, 8761, 8791, 8821, 8850, 8880, 8909, 8938, 8968, 8997, 9027, 9056, 9086, 9115, 9145, 9175, 9205, 9234, 9264, 9293, 9322, 9352, 9381, 9410, 9440, 9470, 9499, 9529, 9559, 9589, 9618, 9648, 9677, 9706, 9736, 9765, 9794, 9824, 9853, 9883, 9913, 9943, 9972, 10002, 10032, 10061, 10090, 10120, 10149, 10178, 10208, 10237, 10267, 10297, 10326, 10356, 10386, 10415, 10445, 10474, 10504, 10533, 10562, 10592, 10621, 10651, 10680, 10710, 10740, 10770, 10799, 10829, 10858, 10888, 10917, 10947, 10976, 11005, 11035, 11064, 11094, 11124, 11153, 11183, 11213, 11242, 11272, 11301, 11331, 11360, 11389, 11419, 11448, 11478, 11507, 11537, 11567, 11596, 11626, 11655, 11685, 11715, 11744, 11774, 11803, 11832, 11862, 11891, 11921, 11950, 11980, 12010, 12039, 12069, 12099, 12128, 12158, 12187, 12216, 12246, 12275, 12304, 12334, 12364, 12393, 12423, 12453, 12483, 12512, 12542, 12571, 12600, 12630, 12659, 12688, 12718, 12747, 12777, 12807, 12837, 12866, 12896, 12926, 12955, 12984, 13014, 13043, 13072, 13102, 13131, 13161, 13191, 13220, 13250, 13280, 13310, 13339, 13368, 13398, 13427, 13456, 13486, 13515, 13545, 13574, 13604, 13634, 13664, 13693, 13723, 13752, 13782, 13811, 13840, 13870, 13899, 13929, 13958, 13988, 14018, 14047, 14077, 14107, 14136, 14166, 14195, 14224, 14254, 14283, 14313, 14342, 14372, 14401, 14431, 14461, 14490, 14520, 14550, 14579, 14609, 14638, 14667, 14697, 14726, 14756, 14785, 14815, 14844, 14874, 14904, 14933, 14963, 14993, 15021, 15051, 15081, 15110, 15140, 15169, 15199, 15228, 15258, 15287, 15317, 15347, 15377, 15406, 15436, 15465, 15494, 15524, 15553, 15582, 15612, 15641, 15671, 15701, 15731, 15760, 15790, 15820, 15849, 15878, 15908, 15937, 15966, 15996, 16025, 16055, 16085, 16114, 16144, 16174, 16204, 16233, 16262, 16292, 16321, 16350, 16380, 16409, 16439, 16468, 16498, 16528, 16558, 16587, 16617, 16646, 16676, 16705, 16734, 16764, 16793, 16823, 16852, 16882, 16912, 16941, 16971, 17001, 17030, 17060, 17089, 17118, 17148, 17177, 17207, 17236, 17266, 17295, 17325, 17355, 17384, 17414, 17444, 17473, 17502, 17532, 17561, 17591, 17620, 17650, 17679, 17709, 17738, 17768, 17798, 17827, 17857, 17886, 17916, 17945, 17975, 18004, 18034, 18063, 18093, 18122, 18152, 18181, 18211, 18241, 18270, 18300, 18330, 18359, 18388, 18418, 18447, 18476, 18506, 18535, 18565, 18595, 18625, 18654, 18684, 18714, 18743, 18772, 18802, 18831, 18860, 18890, 18919, 18949, 18979, 19008, 19038, 19068, 19098, 19127, 19156, 19186, 19215, 19244, 19274, 19303, 19333, 19362, 19392, 19422, 19452, 19481, 19511, 19540, 19570, 19599, 19628, 19658, 19687, 19717, 19746, 19776, 19806, 19836, 19865, 19895, 19924, 19954, 19983, 20012, 20042, 20071, 20101, 20130, 20160, 20190, 20219, 20249, 20279, 20308, 20338, 20367, 20396, 20426, 20455, 20485, 20514, 20544, 20573, 20603, 20633, 20662, 20692, 20721, 20751, 20780, 20810, 20839, 20869, 20898, 20928, 20957, 20987, 21016, 21046, 21076, 21105, 21135, 21164, 21194, 21223, 21253, 21282, 21312, 21341, 21371, 21400, 21430, 21459, 21489, 21519, 21548, 21578, 21607, 21637, 21666, 21696, 21725, 21754, 21784, 21813, 21843, 21873, 21902, 21932, 21962, 21991, 22021, 22050, 22080, 22109, 22138, 22168, 22197, 22227, 22256, 22286, 22316, 22346, 22375, 22405, 22434, 22464, 22493, 22522, 22552, 22581, 22611, 22640, 22670, 22700, 22730, 22759, 22789, 22818, 22848, 22877, 22906, 22936, 22965, 22994, 23024, 23054, 23083, 23113, 23143, 23173, 23202, 23232, 23261, 23290, 23320, 23349, 23379, 23408, 23438, 23467, 23497, 23527, 23556, 23586, 23616, 23645, 23674, 23704, 23733, 23763, 23792, 23822, 23851, 23881, 23910, 23940, 23970, 23999, 24029, 24058, 24088, 24117, 24147, 24176, 24206, 24235, 24265, 24294, 24324, 24353, 24383, 24413, 24442, 24472, 24501, 24531, 24560, 24590, 24619, 24648, 24678, 24707, 24737, 24767, 24796, 24826, 24856, 24885, 24915, 24944, 24974, 25003, 25032, 25062, 25091, 25121, 25150, 25180, 25210, 25240, 25269, 25299, 25328, 25358, 25387, 25416, 25446, 25475, 25505, 25534, 25564, 25594, 25624, 25653, 25683, 25712, 25742, 25771, 25800, 25830, 25859, 25888, 25918, 25948, 25977, 26007, 26037, 26067, 26096, 26126, 26155, 26184, 26214, 26243, 26272, 26302, 26332, 26361, 26391, 26421, 26451, 26480, 26510, 26539, 26568, 26598, 26627, 26656, 26686, 26715, 26745, 26775, 26805, 26834, 26864, 26893, 26923, 26952, 26982, 27011, 27041, 27070, 27099, 27129, 27159, 27188, 27218, 27248, 27277, 27307, 27336, 27366, 27395, 27425, 27454, 27484, 27513, 27542, 27572, 27602, 27631, 27661, 27691, 27720, 27750, 27779, 27809, 27838, 27868, 27897, 27926, 27956, 27985, 28015, 28045, 28074, 28104, 28134, 28163, 28193, 28222, 28252, 28281, 28310, 28340, 28369, 28399, 28428, 28458, 28488, 28517, 28547, 28577, 28607, 28636, 28665, 28695, 28724, 28754, 28783, 28813, 28843, 28872, 28901, 28931, 28960, 28990, 29019, 29049, 29078, 29108, 29137, 29167, 29196, 29226, 29255, 29285, 29315, 29345, 29375, 29404, 29434, 29463, 29492, 29522, 29551, 29580, 29610, 29640, 29669, 29699, 29729, 29759, 29788, 29818, 29847, 29876, 29906, 29935, 29964, 29994, 30023, 30053, 30082, 30112, 30141, 30171, 30200, 30230, 30259, 30289, 30318, 30348, 30378, 30408, 30437, 30467, 30496, 30526, 30555, 30585, 30614, 30644, 30673, 30703, 30732, 30762, 30791, 30821, 30850, 30880, 30909, 30939, 30968, 30998, 31027, 31057, 31086, 31116, 31145, 31175, 31204, 31234, 31263, 31293, 31322, 31352, 31381, 31411, 31441, 31471, 31500, 31530, 31559, 31589, 31618, 31648, 31676, 31706, 31736, 31766, 31795, 31825, 31854, 31884, 31913, 31943, 31972, 32002, 32031, 32061, 32090, 32120, 32150, 32180, 32209, 32239, 32268, 32298, 32327, 32357, 32386, 32416, 32445, 32475, 32504, 32534, 32563, 32593, 32622, 32652, 32681, 32711, 32740, 32770, 32799, 32829, 32858, 32888, 32917, 32947, 32976, 33006, 33035, 33065, 33094, 33124, 33153, 33183, 33213, 33243, 33272, 33302, 33331, 33361, 33390, 33420, 33450, 33479, 33509, 33539, 33568, 33598, 33627, 33657, 33686, 33716, 33745, 33775, 33804, 33834, 33863, 33893, 33922, 33952, 33981, 34011, 34040, 34069, 34099, 34128, 34158, 34187, 34217, 34247, 34277, 34306, 34336, 34365, 34395, 34424, 34454, 34483, 34512, 34542, 34571, 34601, 34631, 34660, 34690, 34719, 34749, 34778, 34808, 34837, 34867, 34896, 34926, 34955, 34985, 35015, 35044, 35074, 35103, 35133, 35162, 35192, 35222, 35251, 35280, 35310, 35340, 35370, 35399, 35429, 35458, 35488, 35517, 35547, 35576, 35605, 35635, 35665, 35694, 35723, 35753, 35782, 35811, 35841, 35871, 35901, 35930, 35960, 35989, 36019, 36048, 36078, 36107, 36136, 36166, 36195, 36225, 36254, 36284, 36314, 36343, 36373, 36403, 36433, 36462, 36492, 36521, 36551, 36580, 36610, 36639, 36669, 36698, 36728, 36757, 36786, 36816, 36845, 36875, 36904, 36934, 36963, 36993, 37022, 37052, 37081, 37111, 37141, 37170, 37200, 37229, 37259, 37288, 37318, 37347, 37377, 37406, 37436, 37465, 37495, 37524, 37554, 37584, 37613, 37643, 37672, 37701, 37731, 37760, 37790, 37819, 37849, 37878, 37908, 37938, 37967, 37997, 38027, 38056, 38085, 38115, 38144, 38174, 38203, 38233, 38262, 38292, 38322, 38351, 38381, 38410, 38440, 38469, 38499, 38528, 38558, 38587, 38617, 38646, 38676, 38705, 38735, 38764, 38794, 38823, 38853, 38882, 38912, 38941, 38971, 39001, 39030, 39059, 39089, 39118, 39148, 39178, 39208, 39237, 39267, 39297, 39326, 39355, 39385, 39414, 39444, 39473, 39503, 39532, 39562, 39592, 39621, 39650, 39680, 39709, 39739, 39768, 39798, 39827, 39857, 39886, 39916, 39946, 39975, 40005, 40035, 40064, 40094, 40123, 40153, 40182, 40212, 40241, 40271, 40300, 40330, 40359, 40389, 40418, 40448, 40477, 40507, 40536, 40566, 40595, 40625, 40655, 40685, 40714, 40744, 40773, 40803, 40832, 40862, 40892, 40921, 40951, 40980, 41009, 41039, 41068, 41098, 41127, 41157, 41186, 41216, 41245, 41275, 41304, 41334, 41364, 41393, 41422, 41452, 41481, 41511, 41540, 41570, 41599, 41629, 41658, 41688, 41718, 41748, 41777, 41807, 41836, 41865, 41894, 41924, 41953, 41983, 42012, 42042, 42072, 42102, 42131, 42161, 42190, 42220, 42249, 42279, 42308, 42337, 42367, 42397, 42426, 42456, 42485, 42515, 42545, 42574, 42604, 42633, 42662, 42692, 42721, 42751, 42780, 42810, 42839, 42869, 42899, 42929, 42958, 42988, 43017, 43046, 43076, 43105, 43135, 43164, 43194, 43223, 43253, 43283, 43312, 43342, 43371, 43401, 43430, 43460, 43489, 43519, 43548, 43578, 43607, 43637, 43666, 43696, 43726, 43755, 43785, 43814, 43844, 43873, 43903, 43932, 43962, 43991, 44021, 44050, 44080, 44109, 44139, 44169, 44198, 44228, 44258, 44287, 44317, 44346, 44375, 44405, 44434, 44464, 44493, 44523, 44553, 44582, 44612, 44641, 44671, 44700, 44730, 44759, 44788, 44818, 44847, 44877, 44906, 44936, 44966, 44996, 45025, 45055, 45084, 45114, 45143, 45172, 45202, 45231, 45261, 45290, 45320, 45350, 45380, 45409, 45439, 45468, 45498, 45527, 45556, 45586, 45615, 45644, 45674, 45704, 45733, 45763, 45793, 45823, 45852, 45882, 45911, 45940, 45970, 45999, 46028, 46058, 46088, 46117, 46147, 46177, 46206, 46236, 46265, 46295, 46324, 46354, 46383, 46413, 46442, 46472, 46501, 46531, 46560, 46590, 46620, 46649, 46679, 46708, 46738, 46767, 46797, 46826, 46856, 46885, 46915, 46944, 46974, 47003, 47033, 47063, 47092, 47122, 47151, 47181, 47210, 47240, 47269, 47298, 47328, 47357, 47387, 47417, 47446, 47476, 47506, 47535, 47565, 47594, 47624, 47653, 47682, 47712, 47741, 47771, 47800, 47830, 47860, 47890, 47919, 47949, 47978, 48008, 48037, 48066, 48096, 48125, 48155, 48184, 48214, 48244, 48273, 48303, 48333, 48362, 48392, 48421, 48450, 48480, 48509, 48538, 48568, 48598, 48627, 48657, 48687, 48717, 48746, 48776, 48805, 48834, 48864, 48893, 48922, 48952, 48982, 49011, 49041, 49071, 49100, 49130, 49160, 49189, 49218, 49248, 49277, 49306, 49336, 49365, 49395, 49425, 49455, 49484, 49514, 49543, 49573, 49602, 49632, 49661, 49690, 49720, 49749, 49779, 49809, 49838, 49868, 49898, 49927, 49957, 49986, 50016, 50045, 50075, 50104, 50133, 50163, 50192, 50222, 50252, 50281, 50311, 50340, 50370, 50400, 50429, 50459, 50488, 50518, 50547, 50576, 50606, 50635, 50665, 50694, 50724, 50754, 50784, 50813, 50843, 50872, 50902, 50931, 50960, 50990, 51019, 51049, 51078, 51108, 51138, 51167, 51197, 51227, 51256, 51286, 51315, 51345, 51374, 51403, 51433, 51462, 51492, 51522, 51552, 51582, 51611, 51641, 51670, 51699, 51729, 51758, 51787, 51816, 51846, 51876, 51906, 51936, 51965, 51995, 52025, 52054, 52083, 52113, 52142, 52171, 52200, 52230, 52260, 52290, 52319, 52349, 52379, 52408, 52438, 52467, 52497, 52526, 52555, 52585, 52614, 52644, 52673, 52703, 52733, 52762, 52792, 52822, 52851, 52881, 52910, 52939, 52969, 52998, 53028, 53057, 53087, 53116, 53146, 53176, 53205, 53235, 53264, 53294, 53324, 53353, 53383, 53412, 53441, 53471, 53500, 53530, 53559, 53589, 53619, 53648, 53678, 53708, 53737, 53767, 53796, 53825, 53855, 53884, 53913, 53943, 53973, 54003, 54032, 54062, 54092, 54121, 54151, 54180, 54209, 54239, 54268, 54297, 54327, 54357, 54387, 54416, 54446, 54476, 54505, 54535, 54564, 54593, 54623, 54652, 54681, 54711, 54741, 54770, 54800, 54830, 54859, 54889, 54919, 54948, 54977, 55007, 55036, 55066, 55095, 55125, 55154, 55184, 55213, 55243, 55273, 55302, 55332, 55361, 55391, 55420, 55450, 55479, 55508, 55538, 55567, 55597, 55627, 55657, 55686, 55716, 55745, 55775, 55804, 55834, 55863, 55892, 55922, 55951, 55981, 56011, 56040, 56070, 56100, 56129, 56159, 56188, 56218, 56247, 56276, 56306, 56335, 56365, 56394, 56424, 56454, 56483, 56513, 56543, 56572, 56601, 56631, 56660, 56690, 56719, 56749, 56778, 56808, 56837, 56867, 56897, 56926, 56956, 56985, 57015, 57044, 57074, 57103, 57133, 57162, 57192, 57221, 57251, 57280, 57310, 57340, 57369, 57399, 57429, 57458, 57487, 57517, 57546, 57576, 57605, 57634, 57664, 57694, 57723, 57753, 57783, 57813, 57842, 57871, 57901, 57930, 57959, 57989, 58018, 58048, 58077, 58107, 58137, 58167, 58196, 58226, 58255, 58285, 58314, 58343, 58373, 58402, 58432, 58461, 58491, 58521, 58551, 58580, 58610, 58639, 58669, 58698, 58727, 58757, 58786, 58816, 58845, 58875, 58905, 58934, 58964, 58994, 59023, 59053, 59082, 59111, 59141, 59170, 59200, 59229, 59259, 59288, 59318, 59348, 59377, 59407, 59436, 59466, 59495, 59525, 59554, 59584, 59613, 59643, 59672, 59702, 59731, 59761, 59791, 59820, 59850, 59879, 59909, 59939, 59968, 59997, 60027, 60056, 60086, 60115, 60145, 60174, 60204, 60234, 60264, 60293, 60323, 60352, 60381, 60411, 60440, 60469, 60499, 60528, 60558, 60588, 60618, 60648, 60677, 60707, 60736, 60765, 60795, 60824, 60853, 60883, 60912, 60942, 60972, 61002, 61031, 61061, 61090, 61120, 61149, 61179, 61208, 61237, 61267, 61296, 61326, 61356, 61385, 61415, 61445, 61474, 61504, 61533, 61563, 61592, 61621, 61651, 61680, 61710, 61739, 61769, 61799, 61828, 61858, 61888, 61917, 61947, 61976, 62006, 62035, 62064, 62094, 62123, 62153, 62182, 62212, 62242, 62271, 62301, 62331, 62360, 62390, 62419, 62448, 62478, 62507, 62537, 62566, 62596, 62625, 62655, 62685, 62715, 62744, 62774, 62803, 62832, 62862, 62891, 62921, 62950, 62980, 63009, 63039, 63069, 63099, 63128, 63157, 63187, 63216, 63246, 63275, 63305, 63334, 63363, 63393, 63423, 63453, 63482, 63512, 63541, 63571, 63600, 63630, 63659, 63689, 63718, 63747, 63777, 63807, 63836, 63866, 63895, 63925, 63955, 63984, 64014, 64043, 64073, 64102, 64131, 64161, 64190, 64220, 64249, 64279, 64309, 64339, 64368, 64398, 64427, 64457, 64486, 64515, 64545, 64574, 64603, 64633, 64663, 64692, 64722, 64752, 64782, 64811, 64841, 64870, 64899, 64929, 64958, 64987, 65017, 65047, 65076, 65106, 65136, 65166, 65195, 65225, 65254, 65283, 65313, 65342, 65371, 65401, 65431, 65460, 65490, 65520, 65549, 65579, 65608, 65638, 65667, 65697, 65726, 65755, 65785, 65815, 65844, 65874, 65903, 65933, 65963, 65992, 66022, 66051, 66081, 66110, 66140, 66169, 66199, 66228, 66258, 66287, 66317, 66346, 66376, 66405, 66435, 66465, 66494, 66524, 66553, 66583, 66612, 66641, 66671, 66700, 66730, 66760, 66789, 66819, 66849, 66878, 66908, 66937, 66967, 66996, 67025, 67055, 67084, 67114, 67143, 67173, 67203, 67233, 67262, 67292, 67321, 67351, 67380, 67409, 67439, 67468, 67497, 67527, 67557, 67587, 67617, 67646, 67676, 67705, 67735, 67764, 67793, 67823, 67852, 67882, 67911, 67941, 67971, 68e3, 68030, 68060, 68089, 68119, 68148, 68177, 68207, 68236, 68266, 68295, 68325, 68354, 68384, 68414, 68443, 68473, 68502, 68532, 68561, 68591, 68620, 68650, 68679, 68708, 68738, 68768, 68797, 68827, 68857, 68886, 68916, 68946, 68975, 69004, 69034, 69063, 69092, 69122, 69152, 69181, 69211, 69240, 69270, 69300, 69330, 69359, 69388, 69418, 69447, 69476, 69506, 69535, 69565, 69595, 69624, 69654, 69684, 69713, 69743, 69772, 69802, 69831, 69861, 69890, 69919, 69949, 69978, 70008, 70038, 70067, 70097, 70126, 70156, 70186, 70215, 70245, 70274, 70303, 70333, 70362, 70392, 70421, 70451, 70481, 70510, 70540, 70570, 70599, 70629, 70658, 70687, 70717, 70746, 70776, 70805, 70835, 70864, 70894, 70924, 70954, 70983, 71013, 71042, 71071, 71101, 71130, 71159, 71189, 71218, 71248, 71278, 71308, 71337, 71367, 71397, 71426, 71455, 71485, 71514, 71543, 71573, 71602, 71632, 71662, 71691, 71721, 71751, 71781, 71810, 71839, 71869, 71898, 71927, 71957, 71986, 72016, 72046, 72075, 72105, 72135, 72164, 72194, 72223, 72253, 72282, 72311, 72341, 72370, 72400, 72429, 72459, 72489, 72518, 72548, 72577, 72607, 72637, 72666, 72695, 72725, 72754, 72784, 72813, 72843, 72872, 72902, 72931, 72961, 72991, 73020, 73050, 73080, 73109, 73139, 73168, 73197, 73227, 73256, 73286, 73315, 73345, 73375, 73404, 73434, 73464, 73493, 73523, 73552, 73581, 73611, 73640, 73669, 73699, 73729, 73758, 73788, 73818, 73848, 73877, 73907, 73936, 73965, 73995, 74024, 74053, 74083, 74113, 74142, 74172, 74202, 74231, 74261, 74291, 74320, 74349, 74379, 74408, 74437, 74467, 74497, 74526, 74556, 74586, 74615, 74645, 74675, 74704, 74733, 74763, 74792, 74822, 74851, 74881, 74910, 74940, 74969, 74999, 75029, 75058, 75088, 75117, 75147, 75176, 75206, 75235, 75264, 75294, 75323, 75353, 75383, 75412, 75442, 75472, 75501, 75531, 75560, 75590, 75619, 75648, 75678, 75707, 75737, 75766, 75796, 75826, 75856, 75885, 75915, 75944, 75974, 76003, 76032, 76062, 76091, 76121, 76150, 76180, 76210, 76239, 76269, 76299, 76328, 76358, 76387, 76416, 76446, 76475, 76505, 76534, 76564, 76593, 76623, 76653, 76682, 76712, 76741, 76771, 76801, 76830, 76859, 76889, 76918, 76948, 76977, 77007, 77036, 77066, 77096, 77125, 77155, 77185, 77214, 77243, 77273, 77302, 77332, 77361, 77390, 77420, 77450, 77479, 77509, 77539, 77569, 77598, 77627, 77657, 77686, 77715, 77745, 77774, 77804, 77833, 77863, 77893, 77923, 77952, 77982, 78011, 78041, 78070, 78099, 78129, 78158, 78188, 78217, 78247, 78277, 78307, 78336, 78366, 78395, 78425, 78454, 78483, 78513, 78542, 78572, 78601, 78631, 78661, 78690, 78720, 78750, 78779, 78808, 78838, 78867, 78897, 78926, 78956, 78985, 79015, 79044, 79074, 79104, 79133, 79163, 79192, 79222, 79251, 79281, 79310, 79340, 79369, 79399, 79428, 79458, 79487, 79517, 79546, 79576, 79606, 79635, 79665, 79695, 79724, 79753, 79783, 79812, 79841, 79871, 79900, 79930, 79960, 79990];
    }, {
      "../main": 636,
      "object-assign": 479
    }],
    636: [function (t, e, r) {
      var n = t("object-assign");

      function i() {
        this.regionalOptions = [], this.regionalOptions[""] = {
          invalidCalendar: "Calendar {0} not found",
          invalidDate: "Invalid {0} date",
          invalidMonth: "Invalid {0} month",
          invalidYear: "Invalid {0} year",
          differentCalendars: "Cannot mix {0} and {1} dates"
        }, this.local = this.regionalOptions[""], this.calendars = {}, this._localCals = {};
      }

      function a(t, e, r, n) {
        if (this._calendar = t, this._year = e, this._month = r, this._day = n, 0 === this._calendar._validateLevel && !this._calendar.isValid(this._year, this._month, this._day)) throw (c.local.invalidDate || c.regionalOptions[""].invalidDate).replace(/\{0\}/, this._calendar.local.name);
      }

      function o(t, e) {
        return "000000".substring(0, e - (t = "" + t).length) + t;
      }

      function s() {
        this.shortYearCutoff = "+10";
      }

      function l(t) {
        this.local = this.regionalOptions[t] || this.regionalOptions[""];
      }

      n(i.prototype, {
        instance: function instance(t, e) {
          t = (t || "gregorian").toLowerCase(), e = e || "";
          var r = this._localCals[t + "-" + e];
          if (!r && this.calendars[t] && (r = new this.calendars[t](e), this._localCals[t + "-" + e] = r), !r) throw (this.local.invalidCalendar || this.regionalOptions[""].invalidCalendar).replace(/\{0\}/, t);
          return r;
        },
        newDate: function newDate(t, e, r, n, i) {
          return (n = (null != t && t.year ? t.calendar() : "string" == typeof n ? this.instance(n, i) : n) || this.instance()).newDate(t, e, r);
        },
        substituteDigits: function substituteDigits(t) {
          return function (e) {
            return (e + "").replace(/[0-9]/g, function (e) {
              return t[e];
            });
          };
        },
        substituteChineseDigits: function substituteChineseDigits(t, e) {
          return function (r) {
            for (var n = "", i = 0; r > 0;) {
              var a = r % 10;
              n = (0 === a ? "" : t[a] + e[i]) + n, i++, r = Math.floor(r / 10);
            }

            return 0 === n.indexOf(t[1] + e[1]) && (n = n.substr(1)), n || t[0];
          };
        }
      }), n(a.prototype, {
        newDate: function newDate(t, e, r) {
          return this._calendar.newDate(null == t ? this : t, e, r);
        },
        year: function year(t) {
          return 0 === arguments.length ? this._year : this.set(t, "y");
        },
        month: function month(t) {
          return 0 === arguments.length ? this._month : this.set(t, "m");
        },
        day: function day(t) {
          return 0 === arguments.length ? this._day : this.set(t, "d");
        },
        date: function date(t, e, r) {
          if (!this._calendar.isValid(t, e, r)) throw (c.local.invalidDate || c.regionalOptions[""].invalidDate).replace(/\{0\}/, this._calendar.local.name);
          return this._year = t, this._month = e, this._day = r, this;
        },
        leapYear: function leapYear() {
          return this._calendar.leapYear(this);
        },
        epoch: function epoch() {
          return this._calendar.epoch(this);
        },
        formatYear: function formatYear() {
          return this._calendar.formatYear(this);
        },
        monthOfYear: function monthOfYear() {
          return this._calendar.monthOfYear(this);
        },
        weekOfYear: function weekOfYear() {
          return this._calendar.weekOfYear(this);
        },
        daysInYear: function daysInYear() {
          return this._calendar.daysInYear(this);
        },
        dayOfYear: function dayOfYear() {
          return this._calendar.dayOfYear(this);
        },
        daysInMonth: function daysInMonth() {
          return this._calendar.daysInMonth(this);
        },
        dayOfWeek: function dayOfWeek() {
          return this._calendar.dayOfWeek(this);
        },
        weekDay: function weekDay() {
          return this._calendar.weekDay(this);
        },
        extraInfo: function extraInfo() {
          return this._calendar.extraInfo(this);
        },
        add: function add(t, e) {
          return this._calendar.add(this, t, e);
        },
        set: function set(t, e) {
          return this._calendar.set(this, t, e);
        },
        compareTo: function compareTo(t) {
          if (this._calendar.name !== t._calendar.name) throw (c.local.differentCalendars || c.regionalOptions[""].differentCalendars).replace(/\{0\}/, this._calendar.local.name).replace(/\{1\}/, t._calendar.local.name);
          var e = this._year !== t._year ? this._year - t._year : this._month !== t._month ? this.monthOfYear() - t.monthOfYear() : this._day - t._day;
          return 0 === e ? 0 : e < 0 ? -1 : 1;
        },
        calendar: function calendar() {
          return this._calendar;
        },
        toJD: function toJD() {
          return this._calendar.toJD(this);
        },
        fromJD: function fromJD(t) {
          return this._calendar.fromJD(t);
        },
        toJSDate: function toJSDate() {
          return this._calendar.toJSDate(this);
        },
        fromJSDate: function fromJSDate(t) {
          return this._calendar.fromJSDate(t);
        },
        toString: function toString() {
          return (this.year() < 0 ? "-" : "") + o(Math.abs(this.year()), 4) + "-" + o(this.month(), 2) + "-" + o(this.day(), 2);
        }
      }), n(s.prototype, {
        _validateLevel: 0,
        newDate: function newDate(t, e, r) {
          return null == t ? this.today() : (t.year && (this._validate(t, e, r, c.local.invalidDate || c.regionalOptions[""].invalidDate), r = t.day(), e = t.month(), t = t.year()), new a(this, t, e, r));
        },
        today: function today() {
          return this.fromJSDate(new Date());
        },
        epoch: function epoch(t) {
          return this._validate(t, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear).year() < 0 ? this.local.epochs[0] : this.local.epochs[1];
        },
        formatYear: function formatYear(t) {
          var e = this._validate(t, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear);

          return (e.year() < 0 ? "-" : "") + o(Math.abs(e.year()), 4);
        },
        monthsInYear: function monthsInYear(t) {
          return this._validate(t, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear), 12;
        },
        monthOfYear: function monthOfYear(t, e) {
          var r = this._validate(t, e, this.minDay, c.local.invalidMonth || c.regionalOptions[""].invalidMonth);

          return (r.month() + this.monthsInYear(r) - this.firstMonth) % this.monthsInYear(r) + this.minMonth;
        },
        fromMonthOfYear: function fromMonthOfYear(t, e) {
          var r = (e + this.firstMonth - 2 * this.minMonth) % this.monthsInYear(t) + this.minMonth;
          return this._validate(t, r, this.minDay, c.local.invalidMonth || c.regionalOptions[""].invalidMonth), r;
        },
        daysInYear: function daysInYear(t) {
          var e = this._validate(t, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear);

          return this.leapYear(e) ? 366 : 365;
        },
        dayOfYear: function dayOfYear(t, e, r) {
          var n = this._validate(t, e, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);

          return n.toJD() - this.newDate(n.year(), this.fromMonthOfYear(n.year(), this.minMonth), this.minDay).toJD() + 1;
        },
        daysInWeek: function daysInWeek() {
          return 7;
        },
        dayOfWeek: function dayOfWeek(t, e, r) {
          var n = this._validate(t, e, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);

          return (Math.floor(this.toJD(n)) + 2) % this.daysInWeek();
        },
        extraInfo: function extraInfo(t, e, r) {
          return this._validate(t, e, r, c.local.invalidDate || c.regionalOptions[""].invalidDate), {};
        },
        add: function add(t, e, r) {
          return this._validate(t, this.minMonth, this.minDay, c.local.invalidDate || c.regionalOptions[""].invalidDate), this._correctAdd(t, this._add(t, e, r), e, r);
        },
        _add: function _add(t, e, r) {
          if (this._validateLevel++, "d" === r || "w" === r) {
            var n = t.toJD() + e * ("w" === r ? this.daysInWeek() : 1),
                i = t.calendar().fromJD(n);
            return this._validateLevel--, [i.year(), i.month(), i.day()];
          }

          try {
            var a = t.year() + ("y" === r ? e : 0),
                o = t.monthOfYear() + ("m" === r ? e : 0);
            i = t.day();
            "y" === r ? (t.month() !== this.fromMonthOfYear(a, o) && (o = this.newDate(a, t.month(), this.minDay).monthOfYear()), o = Math.min(o, this.monthsInYear(a)), i = Math.min(i, this.daysInMonth(a, this.fromMonthOfYear(a, o)))) : "m" === r && (!function (t) {
              for (; o < t.minMonth;) {
                a--, o += t.monthsInYear(a);
              }

              for (var e = t.monthsInYear(a); o > e - 1 + t.minMonth;) {
                a++, o -= e, e = t.monthsInYear(a);
              }
            }(this), i = Math.min(i, this.daysInMonth(a, this.fromMonthOfYear(a, o))));
            var s = [a, this.fromMonthOfYear(a, o), i];
            return this._validateLevel--, s;
          } catch (t) {
            throw this._validateLevel--, t;
          }
        },
        _correctAdd: function _correctAdd(t, e, r, n) {
          if (!(this.hasYearZero || "y" !== n && "m" !== n || 0 !== e[0] && t.year() > 0 == e[0] > 0)) {
            var i = {
              y: [1, 1, "y"],
              m: [1, this.monthsInYear(-1), "m"],
              w: [this.daysInWeek(), this.daysInYear(-1), "d"],
              d: [1, this.daysInYear(-1), "d"]
            }[n],
                a = r < 0 ? -1 : 1;
            e = this._add(t, r * i[0] + a * i[1], i[2]);
          }

          return t.date(e[0], e[1], e[2]);
        },
        set: function set(t, e, r) {
          this._validate(t, this.minMonth, this.minDay, c.local.invalidDate || c.regionalOptions[""].invalidDate);

          var n = "y" === r ? e : t.year(),
              i = "m" === r ? e : t.month(),
              a = "d" === r ? e : t.day();
          return "y" !== r && "m" !== r || (a = Math.min(a, this.daysInMonth(n, i))), t.date(n, i, a);
        },
        isValid: function isValid(t, e, r) {
          this._validateLevel++;
          var n = this.hasYearZero || 0 !== t;

          if (n) {
            var i = this.newDate(t, e, this.minDay);
            n = e >= this.minMonth && e - this.minMonth < this.monthsInYear(i) && r >= this.minDay && r - this.minDay < this.daysInMonth(i);
          }

          return this._validateLevel--, n;
        },
        toJSDate: function toJSDate(t, e, r) {
          var n = this._validate(t, e, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);

          return c.instance().fromJD(this.toJD(n)).toJSDate();
        },
        fromJSDate: function fromJSDate(t) {
          return this.fromJD(c.instance().fromJSDate(t).toJD());
        },
        _validate: function _validate(t, e, r, n) {
          if (t.year) {
            if (0 === this._validateLevel && this.name !== t.calendar().name) throw (c.local.differentCalendars || c.regionalOptions[""].differentCalendars).replace(/\{0\}/, this.local.name).replace(/\{1\}/, t.calendar().local.name);
            return t;
          }

          try {
            if (this._validateLevel++, 1 === this._validateLevel && !this.isValid(t, e, r)) throw n.replace(/\{0\}/, this.local.name);
            var i = this.newDate(t, e, r);
            return this._validateLevel--, i;
          } catch (t) {
            throw this._validateLevel--, t;
          }
        }
      }), l.prototype = new s(), n(l.prototype, {
        name: "Gregorian",
        jdEpoch: 1721425.5,
        daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Gregorian",
            epochs: ["BCE", "CE"],
            monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            digits: null,
            dateFormat: "mm/dd/yyyy",
            firstDay: 0,
            isRTL: !1
          }
        },
        leapYear: function leapYear(t) {
          var e = this._validate(t, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear);

          return (t = e.year() + (e.year() < 0 ? 1 : 0)) % 4 == 0 && (t % 100 != 0 || t % 400 == 0);
        },
        weekOfYear: function weekOfYear(t, e, r) {
          var n = this.newDate(t, e, r);
          return n.add(4 - (n.dayOfWeek() || 7), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
        },
        daysInMonth: function daysInMonth(t, e) {
          var r = this._validate(t, e, this.minDay, c.local.invalidMonth || c.regionalOptions[""].invalidMonth);

          return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
        },
        weekDay: function weekDay(t, e, r) {
          return (this.dayOfWeek(t, e, r) || 7) < 6;
        },
        toJD: function toJD(t, e, r) {
          var n = this._validate(t, e, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);

          t = n.year(), e = n.month(), r = n.day(), t < 0 && t++, e < 3 && (e += 12, t--);
          var i = Math.floor(t / 100),
              a = 2 - i + Math.floor(i / 4);
          return Math.floor(365.25 * (t + 4716)) + Math.floor(30.6001 * (e + 1)) + r + a - 1524.5;
        },
        fromJD: function fromJD(t) {
          var e = Math.floor(t + .5),
              r = Math.floor((e - 1867216.25) / 36524.25),
              n = (r = e + 1 + r - Math.floor(r / 4)) + 1524,
              i = Math.floor((n - 122.1) / 365.25),
              a = Math.floor(365.25 * i),
              o = Math.floor((n - a) / 30.6001),
              s = n - a - Math.floor(30.6001 * o),
              l = o - (o > 13.5 ? 13 : 1),
              c = i - (l > 2.5 ? 4716 : 4715);
          return c <= 0 && c--, this.newDate(c, l, s);
        },
        toJSDate: function toJSDate(t, e, r) {
          var n = this._validate(t, e, r, c.local.invalidDate || c.regionalOptions[""].invalidDate),
              i = new Date(n.year(), n.month() - 1, n.day());

          return i.setHours(0), i.setMinutes(0), i.setSeconds(0), i.setMilliseconds(0), i.setHours(i.getHours() > 12 ? i.getHours() + 2 : 0), i;
        },
        fromJSDate: function fromJSDate(t) {
          return this.newDate(t.getFullYear(), t.getMonth() + 1, t.getDate());
        }
      });
      var c = e.exports = new i();
      c.cdate = a, c.baseCalendar = s, c.calendars.gregorian = l;
    }, {
      "object-assign": 479
    }],
    637: [function (t, e, r) {
      var n = t("object-assign"),
          i = t("./main");
      n(i.regionalOptions[""], {
        invalidArguments: "Invalid arguments",
        invalidFormat: "Cannot format a date from another calendar",
        missingNumberAt: "Missing number at position {0}",
        unknownNameAt: "Unknown name at position {0}",
        unexpectedLiteralAt: "Unexpected literal at position {0}",
        unexpectedText: "Additional text found at end"
      }), i.local = i.regionalOptions[""], n(i.cdate.prototype, {
        formatDate: function formatDate(t, e) {
          return "string" != typeof t && (e = t, t = ""), this._calendar.formatDate(t || "", this, e);
        }
      }), n(i.baseCalendar.prototype, {
        UNIX_EPOCH: i.instance().newDate(1970, 1, 1).toJD(),
        SECS_PER_DAY: 86400,
        TICKS_EPOCH: i.instance().jdEpoch,
        TICKS_PER_DAY: 864e9,
        ATOM: "yyyy-mm-dd",
        COOKIE: "D, dd M yyyy",
        FULL: "DD, MM d, yyyy",
        ISO_8601: "yyyy-mm-dd",
        JULIAN: "J",
        RFC_822: "D, d M yy",
        RFC_850: "DD, dd-M-yy",
        RFC_1036: "D, d M yy",
        RFC_1123: "D, d M yyyy",
        RFC_2822: "D, d M yyyy",
        RSS: "D, d M yy",
        TICKS: "!",
        TIMESTAMP: "@",
        W3C: "yyyy-mm-dd",
        formatDate: function formatDate(t, e, r) {
          if ("string" != typeof t && (r = e, e = t, t = ""), !e) return "";
          if (e.calendar() !== this) throw i.local.invalidFormat || i.regionalOptions[""].invalidFormat;
          t = t || this.local.dateFormat;

          for (var n, a, o, s, l = (r = r || {}).dayNamesShort || this.local.dayNamesShort, c = r.dayNames || this.local.dayNames, u = r.monthNumbers || this.local.monthNumbers, f = r.monthNamesShort || this.local.monthNamesShort, h = r.monthNames || this.local.monthNames, p = (r.calculateWeek || this.local.calculateWeek, function (e, r) {
            for (var n = 1; w + n < t.length && t.charAt(w + n) === e;) {
              n++;
            }

            return w += n - 1, Math.floor(n / (r || 1)) > 1;
          }), d = function d(t, e, r, n) {
            var i = "" + e;
            if (p(t, n)) for (; i.length < r;) {
              i = "0" + i;
            }
            return i;
          }, m = this, g = function g(t) {
            return "function" == typeof u ? u.call(m, t, p("m")) : x(d("m", t.month(), 2));
          }, v = function v(t, e) {
            return e ? "function" == typeof h ? h.call(m, t) : h[t.month() - m.minMonth] : "function" == typeof f ? f.call(m, t) : f[t.month() - m.minMonth];
          }, y = this.local.digits, x = function x(t) {
            return r.localNumbers && y ? y(t) : t;
          }, b = "", _ = !1, w = 0; w < t.length; w++) {
            if (_) "'" !== t.charAt(w) || p("'") ? b += t.charAt(w) : _ = !1;else switch (t.charAt(w)) {
              case "d":
                b += x(d("d", e.day(), 2));
                break;

              case "D":
                b += (n = "D", a = e.dayOfWeek(), o = l, s = c, p(n) ? s[a] : o[a]);
                break;

              case "o":
                b += d("o", e.dayOfYear(), 3);
                break;

              case "w":
                b += d("w", e.weekOfYear(), 2);
                break;

              case "m":
                b += g(e);
                break;

              case "M":
                b += v(e, p("M"));
                break;

              case "y":
                b += p("y", 2) ? e.year() : (e.year() % 100 < 10 ? "0" : "") + e.year() % 100;
                break;

              case "Y":
                p("Y", 2), b += e.formatYear();
                break;

              case "J":
                b += e.toJD();
                break;

              case "@":
                b += (e.toJD() - this.UNIX_EPOCH) * this.SECS_PER_DAY;
                break;

              case "!":
                b += (e.toJD() - this.TICKS_EPOCH) * this.TICKS_PER_DAY;
                break;

              case "'":
                p("'") ? b += "'" : _ = !0;
                break;

              default:
                b += t.charAt(w);
            }
          }

          return b;
        },
        parseDate: function parseDate(t, e, r) {
          if (null == e) throw i.local.invalidArguments || i.regionalOptions[""].invalidArguments;
          if ("" === (e = "object" == _typeof(e) ? e.toString() : e + "")) return null;
          t = t || this.local.dateFormat;
          var n = (r = r || {}).shortYearCutoff || this.shortYearCutoff;
          n = "string" != typeof n ? n : this.today().year() % 100 + parseInt(n, 10);

          for (var a = r.dayNamesShort || this.local.dayNamesShort, o = r.dayNames || this.local.dayNames, s = r.parseMonth || this.local.parseMonth, l = r.monthNumbers || this.local.monthNumbers, c = r.monthNamesShort || this.local.monthNamesShort, u = r.monthNames || this.local.monthNames, f = -1, h = -1, p = -1, d = -1, m = -1, g = !1, v = !1, y = function y(e, r) {
            for (var n = 1; A + n < t.length && t.charAt(A + n) === e;) {
              n++;
            }

            return A += n - 1, Math.floor(n / (r || 1)) > 1;
          }, x = function x(t, r) {
            var n = y(t, r),
                a = [2, 3, n ? 4 : 2, n ? 4 : 2, 10, 11, 20]["oyYJ@!".indexOf(t) + 1],
                o = new RegExp("^-?\\d{1," + a + "}"),
                s = e.substring(M).match(o);
            if (!s) throw (i.local.missingNumberAt || i.regionalOptions[""].missingNumberAt).replace(/\{0\}/, M);
            return M += s[0].length, parseInt(s[0], 10);
          }, b = this, _ = function _() {
            if ("function" == typeof l) {
              y("m");
              var t = l.call(b, e.substring(M));
              return M += t.length, t;
            }

            return x("m");
          }, w = function w(t, r, n, a) {
            for (var o = y(t, a) ? n : r, s = 0; s < o.length; s++) {
              if (e.substr(M, o[s].length).toLowerCase() === o[s].toLowerCase()) return M += o[s].length, s + b.minMonth;
            }

            throw (i.local.unknownNameAt || i.regionalOptions[""].unknownNameAt).replace(/\{0\}/, M);
          }, T = function T() {
            if ("function" == typeof u) {
              var t = y("M") ? u.call(b, e.substring(M)) : c.call(b, e.substring(M));
              return M += t.length, t;
            }

            return w("M", c, u);
          }, k = function k() {
            if (e.charAt(M) !== t.charAt(A)) throw (i.local.unexpectedLiteralAt || i.regionalOptions[""].unexpectedLiteralAt).replace(/\{0\}/, M);
            M++;
          }, M = 0, A = 0; A < t.length; A++) {
            if (v) "'" !== t.charAt(A) || y("'") ? k() : v = !1;else switch (t.charAt(A)) {
              case "d":
                d = x("d");
                break;

              case "D":
                w("D", a, o);
                break;

              case "o":
                m = x("o");
                break;

              case "w":
                x("w");
                break;

              case "m":
                p = _();
                break;

              case "M":
                p = T();
                break;

              case "y":
                var S = A;
                g = !y("y", 2), A = S, h = x("y", 2);
                break;

              case "Y":
                h = x("Y", 2);
                break;

              case "J":
                f = x("J") + .5, "." === e.charAt(M) && (M++, x("J"));
                break;

              case "@":
                f = x("@") / this.SECS_PER_DAY + this.UNIX_EPOCH;
                break;

              case "!":
                f = x("!") / this.TICKS_PER_DAY + this.TICKS_EPOCH;
                break;

              case "*":
                M = e.length;
                break;

              case "'":
                y("'") ? k() : v = !0;
                break;

              default:
                k();
            }
          }

          if (M < e.length) throw i.local.unexpectedText || i.regionalOptions[""].unexpectedText;

          if (-1 === h ? h = this.today().year() : h < 100 && g && (h += -1 === n ? 1900 : this.today().year() - this.today().year() % 100 - (h <= n ? 0 : 100)), "string" == typeof p && (p = s.call(this, h, p)), m > -1) {
            p = 1, d = m;

            for (var E = this.daysInMonth(h, p); d > E; E = this.daysInMonth(h, p)) {
              p++, d -= E;
            }
          }

          return f > -1 ? this.fromJD(f) : this.newDate(h, p, d);
        },
        determineDate: function determineDate(t, e, r, n, i) {
          r && "object" != _typeof(r) && (i = n, n = r, r = null), "string" != typeof n && (i = n, n = "");
          var a = this;
          return e = e ? e.newDate() : null, t = null == t ? e : "string" == typeof t ? function (t) {
            try {
              return a.parseDate(n, t, i);
            } catch (t) {}

            for (var e = ((t = t.toLowerCase()).match(/^c/) && r ? r.newDate() : null) || a.today(), o = /([+-]?[0-9]+)\s*(d|w|m|y)?/g, s = o.exec(t); s;) {
              e.add(parseInt(s[1], 10), s[2] || "d"), s = o.exec(t);
            }

            return e;
          }(t) : "number" == typeof t ? isNaN(t) || t === 1 / 0 || t === -1 / 0 ? e : a.today().add(t, "d") : a.newDate(t);
        }
      });
    }, {
      "./main": 636,
      "object-assign": 479
    }],
    638: [function (t, e, r) {
      e.exports = t("cwise-compiler")({
        args: ["array", {
          offset: [1],
          array: 0
        }, "scalar", "scalar", "index"],
        pre: {
          body: "{}",
          args: [],
          thisVars: [],
          localVars: []
        },
        post: {
          body: "{}",
          args: [],
          thisVars: [],
          localVars: []
        },
        body: {
          body: "{\n        var _inline_1_da = _inline_1_arg0_ - _inline_1_arg3_\n        var _inline_1_db = _inline_1_arg1_ - _inline_1_arg3_\n        if((_inline_1_da >= 0) !== (_inline_1_db >= 0)) {\n          _inline_1_arg2_.push(_inline_1_arg4_[0] + 0.5 + 0.5 * (_inline_1_da + _inline_1_db) / (_inline_1_da - _inline_1_db))\n        }\n      }",
          args: [{
            name: "_inline_1_arg0_",
            lvalue: !1,
            rvalue: !0,
            count: 1
          }, {
            name: "_inline_1_arg1_",
            lvalue: !1,
            rvalue: !0,
            count: 1
          }, {
            name: "_inline_1_arg2_",
            lvalue: !1,
            rvalue: !0,
            count: 1
          }, {
            name: "_inline_1_arg3_",
            lvalue: !1,
            rvalue: !0,
            count: 2
          }, {
            name: "_inline_1_arg4_",
            lvalue: !1,
            rvalue: !0,
            count: 1
          }],
          thisVars: [],
          localVars: ["_inline_1_da", "_inline_1_db"]
        },
        funcName: "zeroCrossings"
      });
    }, {
      "cwise-compiler": 152
    }],
    639: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        var r = [];
        return e = +e || 0, n(t.hi(t.shape[0] - 1), r, e), r;
      };

      var n = t("./lib/zc-core");
    }, {
      "./lib/zc-core": 638
    }],
    640: [function (t, e, r) {
      "use strict";

      e.exports = [{
        path: "",
        backoff: 0
      }, {
        path: "M-2.4,-3V3L0.6,0Z",
        backoff: .6
      }, {
        path: "M-3.7,-2.5V2.5L1.3,0Z",
        backoff: 1.3
      }, {
        path: "M-4.45,-3L-1.65,-0.2V0.2L-4.45,3L1.55,0Z",
        backoff: 1.55
      }, {
        path: "M-2.2,-2.2L-0.2,-0.2V0.2L-2.2,2.2L-1.4,3L1.6,0L-1.4,-3Z",
        backoff: 1.6
      }, {
        path: "M-4.4,-2.1L-0.6,-0.2V0.2L-4.4,2.1L-4,3L2,0L-4,-3Z",
        backoff: 2
      }, {
        path: "M2,0A2,2 0 1,1 0,-2A2,2 0 0,1 2,0Z",
        backoff: 0,
        noRotate: !0
      }, {
        path: "M2,2V-2H-2V2Z",
        backoff: 0,
        noRotate: !0
      }];
    }, {}],
    641: [function (t, e, r) {
      "use strict";

      var n = t("./arrow_paths"),
          i = t("../../plots/font_attributes"),
          a = t("../../plots/cartesian/constants"),
          o = t("../../plot_api/plot_template").templatedArray;
      t("../../constants/axis_placeable_objects");
      e.exports = o("annotation", {
        visible: {
          valType: "boolean",
          dflt: !0,
          editType: "calc+arraydraw"
        },
        text: {
          valType: "string",
          editType: "calc+arraydraw"
        },
        textangle: {
          valType: "angle",
          dflt: 0,
          editType: "calc+arraydraw"
        },
        font: i({
          editType: "calc+arraydraw",
          colorEditType: "arraydraw"
        }),
        width: {
          valType: "number",
          min: 1,
          dflt: null,
          editType: "calc+arraydraw"
        },
        height: {
          valType: "number",
          min: 1,
          dflt: null,
          editType: "calc+arraydraw"
        },
        opacity: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 1,
          editType: "arraydraw"
        },
        align: {
          valType: "enumerated",
          values: ["left", "center", "right"],
          dflt: "center",
          editType: "arraydraw"
        },
        valign: {
          valType: "enumerated",
          values: ["top", "middle", "bottom"],
          dflt: "middle",
          editType: "arraydraw"
        },
        bgcolor: {
          valType: "color",
          dflt: "rgba(0,0,0,0)",
          editType: "arraydraw"
        },
        bordercolor: {
          valType: "color",
          dflt: "rgba(0,0,0,0)",
          editType: "arraydraw"
        },
        borderpad: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "calc+arraydraw"
        },
        borderwidth: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "calc+arraydraw"
        },
        showarrow: {
          valType: "boolean",
          dflt: !0,
          editType: "calc+arraydraw"
        },
        arrowcolor: {
          valType: "color",
          editType: "arraydraw"
        },
        arrowhead: {
          valType: "integer",
          min: 0,
          max: n.length,
          dflt: 1,
          editType: "arraydraw"
        },
        startarrowhead: {
          valType: "integer",
          min: 0,
          max: n.length,
          dflt: 1,
          editType: "arraydraw"
        },
        arrowside: {
          valType: "flaglist",
          flags: ["end", "start"],
          extras: ["none"],
          dflt: "end",
          editType: "arraydraw"
        },
        arrowsize: {
          valType: "number",
          min: .3,
          dflt: 1,
          editType: "calc+arraydraw"
        },
        startarrowsize: {
          valType: "number",
          min: .3,
          dflt: 1,
          editType: "calc+arraydraw"
        },
        arrowwidth: {
          valType: "number",
          min: .1,
          editType: "calc+arraydraw"
        },
        standoff: {
          valType: "number",
          min: 0,
          dflt: 0,
          editType: "calc+arraydraw"
        },
        startstandoff: {
          valType: "number",
          min: 0,
          dflt: 0,
          editType: "calc+arraydraw"
        },
        ax: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        ay: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        axref: {
          valType: "enumerated",
          dflt: "pixel",
          values: ["pixel", a.idRegex.x.toString()],
          editType: "calc"
        },
        ayref: {
          valType: "enumerated",
          dflt: "pixel",
          values: ["pixel", a.idRegex.y.toString()],
          editType: "calc"
        },
        xref: {
          valType: "enumerated",
          values: ["paper", a.idRegex.x.toString()],
          editType: "calc"
        },
        x: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        xanchor: {
          valType: "enumerated",
          values: ["auto", "left", "center", "right"],
          dflt: "auto",
          editType: "calc+arraydraw"
        },
        xshift: {
          valType: "number",
          dflt: 0,
          editType: "calc+arraydraw"
        },
        yref: {
          valType: "enumerated",
          values: ["paper", a.idRegex.y.toString()],
          editType: "calc"
        },
        y: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        yanchor: {
          valType: "enumerated",
          values: ["auto", "top", "middle", "bottom"],
          dflt: "auto",
          editType: "calc+arraydraw"
        },
        yshift: {
          valType: "number",
          dflt: 0,
          editType: "calc+arraydraw"
        },
        clicktoshow: {
          valType: "enumerated",
          values: [!1, "onoff", "onout"],
          dflt: !1,
          editType: "arraydraw"
        },
        xclick: {
          valType: "any",
          editType: "arraydraw"
        },
        yclick: {
          valType: "any",
          editType: "arraydraw"
        },
        hovertext: {
          valType: "string",
          editType: "arraydraw"
        },
        hoverlabel: {
          bgcolor: {
            valType: "color",
            editType: "arraydraw"
          },
          bordercolor: {
            valType: "color",
            editType: "arraydraw"
          },
          font: i({
            editType: "arraydraw"
          }),
          editType: "arraydraw"
        },
        captureevents: {
          valType: "boolean",
          editType: "arraydraw"
        },
        editType: "calc",
        _deprecated: {
          ref: {
            valType: "string",
            editType: "calc"
          }
        }
      });
    }, {
      "../../constants/axis_placeable_objects": 764,
      "../../plot_api/plot_template": 834,
      "../../plots/cartesian/constants": 851,
      "../../plots/font_attributes": 873,
      "./arrow_paths": 640
    }],
    642: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../plots/cartesian/axes"),
          a = t("./draw").draw;

      function o(t) {
        var e = t._fullLayout;
        n.filterVisible(e.annotations).forEach(function (e) {
          var r = i.getFromId(t, e.xref),
              n = i.getFromId(t, e.yref),
              a = i.getRefType(e.xref),
              o = i.getRefType(e.yref);
          e._extremes = {}, "range" === a && s(e, r), "range" === o && s(e, n);
        });
      }

      function s(t, e) {
        var r,
            n = e._id,
            a = n.charAt(0),
            o = t[a],
            s = t["a" + a],
            l = t[a + "ref"],
            c = t["a" + a + "ref"],
            u = t["_" + a + "padplus"],
            f = t["_" + a + "padminus"],
            h = {
          x: 1,
          y: -1
        }[a] * t[a + "shift"],
            p = 3 * t.arrowsize * t.arrowwidth || 0,
            d = p + h,
            m = p - h,
            g = 3 * t.startarrowsize * t.arrowwidth || 0,
            v = g + h,
            y = g - h;

        if (c === l) {
          var x = i.findExtremes(e, [e.r2c(o)], {
            ppadplus: d,
            ppadminus: m
          }),
              b = i.findExtremes(e, [e.r2c(s)], {
            ppadplus: Math.max(u, v),
            ppadminus: Math.max(f, y)
          });
          r = {
            min: [x.min[0], b.min[0]],
            max: [x.max[0], b.max[0]]
          };
        } else v = s ? v + s : v, y = s ? y - s : y, r = i.findExtremes(e, [e.r2c(o)], {
          ppadplus: Math.max(u, d, v),
          ppadminus: Math.max(f, m, y)
        });

        t._extremes[n] = r;
      }

      e.exports = function (t) {
        var e = t._fullLayout;
        if (n.filterVisible(e.annotations).length && t._fullData.length) return n.syncOrAsync([a, o], t);
      };
    }, {
      "../../lib": 795,
      "../../plots/cartesian/axes": 845,
      "./draw": 647
    }],
    643: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../registry"),
          a = t("../../plot_api/plot_template").arrayEditor;

      function o(t, e) {
        var r,
            n,
            i,
            a,
            o,
            l,
            c,
            u = t._fullLayout.annotations,
            f = [],
            h = [],
            p = [],
            d = (e || []).length;

        for (r = 0; r < u.length; r++) {
          if (a = (i = u[r]).clicktoshow) {
            for (n = 0; n < d; n++) {
              if (l = (o = e[n]).xaxis, c = o.yaxis, l._id === i.xref && c._id === i.yref && l.d2r(o.x) === s(i._xclick, l) && c.d2r(o.y) === s(i._yclick, c)) {
                (i.visible ? "onout" === a ? h : p : f).push(r);
                break;
              }
            }

            n === d && i.visible && "onout" === a && h.push(r);
          }
        }

        return {
          on: f,
          off: h,
          explicitOff: p
        };
      }

      function s(t, e) {
        return "log" === e.type ? e.l2r(t) : e.d2r(t);
      }

      e.exports = {
        hasClickToShow: function hasClickToShow(t, e) {
          var r = o(t, e);
          return r.on.length > 0 || r.explicitOff.length > 0;
        },
        onClick: function onClick(t, e) {
          var r,
              s,
              l = o(t, e),
              c = l.on,
              u = l.off.concat(l.explicitOff),
              f = {},
              h = t._fullLayout.annotations;
          if (!c.length && !u.length) return;

          for (r = 0; r < c.length; r++) {
            (s = a(t.layout, "annotations", h[c[r]])).modifyItem("visible", !0), n.extendFlat(f, s.getUpdateObj());
          }

          for (r = 0; r < u.length; r++) {
            (s = a(t.layout, "annotations", h[u[r]])).modifyItem("visible", !1), n.extendFlat(f, s.getUpdateObj());
          }

          return i.call("update", t, {}, f);
        }
      };
    }, {
      "../../lib": 795,
      "../../plot_api/plot_template": 834,
      "../../registry": 923
    }],
    644: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../color");

      e.exports = function (t, e, r, a) {
        a("opacity");
        var o = a("bgcolor"),
            s = a("bordercolor"),
            l = i.opacity(s);
        a("borderpad");
        var c = a("borderwidth"),
            u = a("showarrow");

        if (a("text", u ? " " : r._dfltTitle.annotation), a("textangle"), n.coerceFont(a, "font", r.font), a("width"), a("align"), a("height") && a("valign"), u) {
          var f,
              h,
              p = a("arrowside");
          -1 !== p.indexOf("end") && (f = a("arrowhead"), h = a("arrowsize")), -1 !== p.indexOf("start") && (a("startarrowhead", f), a("startarrowsize", h)), a("arrowcolor", l ? e.bordercolor : i.defaultLine), a("arrowwidth", 2 * (l && c || 1)), a("standoff"), a("startstandoff");
        }

        var d = a("hovertext"),
            m = r.hoverlabel || {};

        if (d) {
          var g = a("hoverlabel.bgcolor", m.bgcolor || (i.opacity(o) ? i.rgb(o) : i.defaultLine)),
              v = a("hoverlabel.bordercolor", m.bordercolor || i.contrast(g));
          n.coerceFont(a, "hoverlabel.font", {
            family: m.font.family,
            size: m.font.size,
            color: m.font.color || v
          });
        }

        a("captureevents", !!d);
      };
    }, {
      "../../lib": 795,
      "../color": 658
    }],
    645: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../lib/to_log_range");

      e.exports = function (t, e, r, a) {
        e = e || {};
        var o = "log" === r && "linear" === e.type,
            s = "linear" === r && "log" === e.type;
        if (o || s) for (var l, c, u = t._fullLayout.annotations, f = e._id.charAt(0), h = 0; h < u.length; h++) {
          l = u[h], c = "annotations[" + h + "].", l[f + "ref"] === e._id && p(f), l["a" + f + "ref"] === e._id && p("a" + f);
        }

        function p(t) {
          var r = l[t],
              s = null;
          s = o ? i(r, e.range) : Math.pow(10, r), n(s) || (s = null), a(c + t, s);
        }
      };
    }, {
      "../../lib/to_log_range": 822,
      "fast-isnumeric": 240
    }],
    646: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../plots/cartesian/axes"),
          a = t("../../plots/array_container_defaults"),
          o = t("./common_defaults"),
          s = t("./attributes");

      function l(t, e, r) {
        function a(r, i) {
          return n.coerce(t, e, s, r, i);
        }

        var l = a("visible"),
            c = a("clicktoshow");

        if (l || c) {
          o(t, e, r, a);

          for (var u = e.showarrow, f = ["x", "y"], h = [-10, -30], p = {
            _fullLayout: r
          }, d = 0; d < 2; d++) {
            var m = f[d],
                g = i.coerceRef(t, e, p, m, "", "paper");
            if ("paper" !== g) i.getFromId(p, g)._annIndices.push(e._index);

            if (i.coercePosition(e, p, a, g, m, .5), u) {
              var v = "a" + m,
                  y = i.coerceRef(t, e, p, v, "pixel", ["pixel", "paper"]);
              "pixel" !== y && y !== g && (y = e[v] = "pixel");
              var x = "pixel" === y ? h[d] : .4;
              i.coercePosition(e, p, a, y, v, x);
            }

            a(m + "anchor"), a(m + "shift");
          }

          if (n.noneOrAll(t, e, ["x", "y"]), u && n.noneOrAll(t, e, ["ax", "ay"]), c) {
            var b = a("xclick"),
                _ = a("yclick");

            e._xclick = void 0 === b ? e.x : i.cleanPosition(b, p, e.xref), e._yclick = void 0 === _ ? e.y : i.cleanPosition(_, p, e.yref);
          }
        }
      }

      e.exports = function (t, e) {
        a(t, e, {
          name: "annotations",
          handleItemDefaults: l
        });
      };
    }, {
      "../../lib": 795,
      "../../plots/array_container_defaults": 840,
      "../../plots/cartesian/axes": 845,
      "./attributes": 641,
      "./common_defaults": 644
    }],
    647: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../registry"),
          a = t("../../plots/plots"),
          o = t("../../lib"),
          s = o.strTranslate,
          l = t("../../plots/cartesian/axes"),
          c = t("../color"),
          u = t("../drawing"),
          f = t("../fx"),
          h = t("../../lib/svg_text_utils"),
          p = t("../../lib/setcursor"),
          d = t("../dragelement"),
          m = t("../../plot_api/plot_template").arrayEditor,
          g = t("./draw_arrow_head");

      function v(t, e) {
        var r = t._fullLayout.annotations[e] || {},
            n = l.getFromId(t, r.xref),
            i = l.getFromId(t, r.yref);
        n && n.setScale(), i && i.setScale(), x(t, r, e, !1, n, i);
      }

      function y(t, e, r, n, i) {
        var a = i[r],
            o = i[r + "ref"],
            s = -1 !== r.indexOf("y"),
            c = "domain" === l.getRefType(o),
            u = s ? n.h : n.w;
        return t ? c ? a + (s ? -e : e) / t._length : t.p2r(t.r2p(a) + e) : a + (s ? -e : e) / u;
      }

      function x(t, e, r, a, v, x) {
        var b,
            _,
            w = t._fullLayout,
            T = t._fullLayout._size,
            k = t._context.edits;

        a ? (b = "annotation-" + a, _ = a + ".annotations") : (b = "annotation", _ = "annotations");
        var M = m(t.layout, _, e),
            A = M.modifyBase,
            S = M.modifyItem,
            E = M.getUpdateObj;

        w._infolayer.selectAll("." + b + '[data-index="' + r + '"]').remove();

        var L = "clip" + w._uid + "_ann" + r;

        if (e._input && !1 !== e.visible) {
          var C = {
            x: {},
            y: {}
          },
              P = +e.textangle || 0,
              I = w._infolayer.append("g").classed(b, !0).attr("data-index", String(r)).style("opacity", e.opacity),
              O = I.append("g").classed("annotation-text-g", !0),
              z = k[e.showarrow ? "annotationTail" : "annotationPosition"],
              D = e.captureevents || k.annotationText || z,
              R = O.append("g").style("pointer-events", D ? "all" : null).call(p, "pointer").on("click", function () {
            t._dragging = !1, t.emit("plotly_clickannotation", Y(n.event));
          });

          e.hovertext && R.on("mouseover", function () {
            var r = e.hoverlabel,
                n = r.font,
                i = this.getBoundingClientRect(),
                a = t.getBoundingClientRect();
            f.loneHover({
              x0: i.left - a.left,
              x1: i.right - a.left,
              y: (i.top + i.bottom) / 2 - a.top,
              text: e.hovertext,
              color: r.bgcolor,
              borderColor: r.bordercolor,
              fontFamily: n.family,
              fontSize: n.size,
              fontColor: n.color
            }, {
              container: w._hoverlayer.node(),
              outerContainer: w._paper.node(),
              gd: t
            });
          }).on("mouseout", function () {
            f.loneUnhover(w._hoverlayer.node());
          });

          var F = e.borderwidth,
              B = e.borderpad,
              N = F + B,
              j = R.append("rect").attr("class", "bg").style("stroke-width", F + "px").call(c.stroke, e.bordercolor).call(c.fill, e.bgcolor),
              U = e.width || e.height,
              V = w._topclips.selectAll("#" + L).data(U ? [0] : []);

          V.enter().append("clipPath").classed("annclip", !0).attr("id", L).append("rect"), V.exit().remove();
          var q = e.font,
              H = w._meta ? o.templateString(e.text, w._meta) : e.text,
              G = R.append("text").classed("annotation-text", !0).text(H);
          k.annotationText ? G.call(h.makeEditable, {
            delegate: R,
            gd: t
          }).call(W).on("edit", function (r) {
            e.text = r, this.call(W), S("text", r), v && v.autorange && A(v._name + ".autorange", !0), x && x.autorange && A(x._name + ".autorange", !0), i.call("_guiRelayout", t, E());
          }) : G.call(W);
        } else n.selectAll("#" + L).remove();

        function Y(t) {
          var n = {
            index: r,
            annotation: e._input,
            fullAnnotation: e,
            event: t
          };
          return a && (n.subplotId = a), n;
        }

        function W(r) {
          return r.call(u.font, q).attr({
            "text-anchor": {
              left: "start",
              right: "end"
            }[e.align] || "middle"
          }), h.convertToTspans(r, t, X), r;
        }

        function X() {
          var r = G.selectAll("a");
          1 === r.size() && r.text() === G.text() && R.insert("a", ":first-child").attr({
            "xlink:xlink:href": r.attr("xlink:href"),
            "xlink:xlink:show": r.attr("xlink:show")
          }).style({
            cursor: "pointer"
          }).node().appendChild(j.node());
          var n = R.select(".annotation-text-math-group"),
              f = !n.empty(),
              m = u.bBox((f ? n : G).node()),
              b = m.width,
              _ = m.height,
              M = e.width || b,
              D = e.height || _,
              B = Math.round(M + 2 * N),
              q = Math.round(D + 2 * N);

          function H(t, e) {
            return "auto" === e && (e = t < 1 / 3 ? "left" : t > 2 / 3 ? "right" : "center"), {
              center: 0,
              middle: 0,
              left: .5,
              bottom: -.5,
              right: -.5,
              top: .5
            }[e];
          }

          for (var W = !1, X = ["x", "y"], Z = 0; Z < X.length; Z++) {
            var J,
                K,
                Q,
                $,
                tt,
                et = X[Z],
                rt = e[et + "ref"] || et,
                nt = e["a" + et + "ref"],
                it = {
              x: v,
              y: x
            }[et],
                at = (P + ("x" === et ? 0 : -90)) * Math.PI / 180,
                ot = B * Math.cos(at),
                st = q * Math.sin(at),
                lt = Math.abs(ot) + Math.abs(st),
                ct = e[et + "anchor"],
                ut = e[et + "shift"] * ("x" === et ? 1 : -1),
                ft = C[et],
                ht = l.getRefType(rt);

            if (it && "domain" !== ht) {
              var pt = it.r2fraction(e[et]);
              (pt < 0 || pt > 1) && (nt === rt ? ((pt = it.r2fraction(e["a" + et])) < 0 || pt > 1) && (W = !0) : W = !0), J = it._offset + it.r2p(e[et]), $ = .5;
            } else {
              var dt = "domain" === ht;
              "x" === et ? (Q = e[et], J = dt ? it._offset + it._length * Q : J = T.l + T.w * Q) : (Q = 1 - e[et], J = dt ? it._offset + it._length * Q : J = T.t + T.h * Q), $ = e.showarrow ? .5 : Q;
            }

            if (e.showarrow) {
              ft.head = J;
              var mt = e["a" + et];

              if (tt = ot * H(.5, e.xanchor) - st * H(.5, e.yanchor), nt === rt) {
                var gt = l.getRefType(nt);
                "domain" === gt ? ("y" === et && (mt = 1 - mt), ft.tail = it._offset + it._length * mt) : "paper" === gt ? "y" === et ? (mt = 1 - mt, ft.tail = T.t + T.h * mt) : ft.tail = T.l + T.w * mt : ft.tail = it._offset + it.r2p(mt), K = tt;
              } else ft.tail = J + mt, K = tt + mt;

              ft.text = ft.tail + tt;
              var vt = w["x" === et ? "width" : "height"];

              if ("paper" === rt && (ft.head = o.constrain(ft.head, 1, vt - 1)), "pixel" === nt) {
                var yt = -Math.max(ft.tail - 3, ft.text),
                    xt = Math.min(ft.tail + 3, ft.text) - vt;
                yt > 0 ? (ft.tail += yt, ft.text += yt) : xt > 0 && (ft.tail -= xt, ft.text -= xt);
              }

              ft.tail += ut, ft.head += ut;
            } else K = tt = lt * H($, ct), ft.text = J + tt;

            ft.text += ut, tt += ut, K += ut, e["_" + et + "padplus"] = lt / 2 + K, e["_" + et + "padminus"] = lt / 2 - K, e["_" + et + "size"] = lt, e["_" + et + "shift"] = tt;
          }

          if (W) R.remove();else {
            var bt = 0,
                _t = 0;
            if ("left" !== e.align && (bt = (M - b) * ("center" === e.align ? .5 : 1)), "top" !== e.valign && (_t = (D - _) * ("middle" === e.valign ? .5 : 1)), f) n.select("svg").attr({
              x: N + bt - 1,
              y: N + _t
            }).call(u.setClipUrl, U ? L : null, t);else {
              var wt = N + _t - m.top,
                  Tt = N + bt - m.left;
              G.call(h.positionText, Tt, wt).call(u.setClipUrl, U ? L : null, t);
            }
            V.select("rect").call(u.setRect, N, N, M, D), j.call(u.setRect, F / 2, F / 2, B - F, q - F), R.call(u.setTranslate, Math.round(C.x.text - B / 2), Math.round(C.y.text - q / 2)), O.attr({
              transform: "rotate(" + P + "," + C.x.text + "," + C.y.text + ")"
            });

            var kt,
                Mt = function Mt(r, n) {
              I.selectAll(".annotation-arrow-g").remove();

              var l = C.x.head,
                  f = C.y.head,
                  h = C.x.tail + r,
                  p = C.y.tail + n,
                  m = C.x.text + r,
                  b = C.y.text + n,
                  _ = o.rotationXYMatrix(P, m, b),
                  w = o.apply2DTransform(_),
                  M = o.apply2DTransform2(_),
                  L = +j.attr("width"),
                  z = +j.attr("height"),
                  D = m - .5 * L,
                  F = D + L,
                  B = b - .5 * z,
                  N = B + z,
                  U = [[D, B, D, N], [D, N, F, N], [F, N, F, B], [F, B, D, B]].map(M);

              if (!U.reduce(function (t, e) {
                return t ^ !!o.segmentsIntersect(l, f, l + 1e6, f + 1e6, e[0], e[1], e[2], e[3]);
              }, !1)) {
                U.forEach(function (t) {
                  var e = o.segmentsIntersect(h, p, l, f, t[0], t[1], t[2], t[3]);
                  e && (h = e.x, p = e.y);
                });
                var V = e.arrowwidth,
                    q = e.arrowcolor,
                    H = e.arrowside,
                    G = I.append("g").style({
                  opacity: c.opacity(q)
                }).classed("annotation-arrow-g", !0),
                    Y = G.append("path").attr("d", "M" + h + "," + p + "L" + l + "," + f).style("stroke-width", V + "px").call(c.stroke, c.rgb(q));

                if (g(Y, H, e), k.annotationPosition && Y.node().parentNode && !a) {
                  var W = l,
                      X = f;

                  if (e.standoff) {
                    var Z = Math.sqrt(Math.pow(l - h, 2) + Math.pow(f - p, 2));
                    W += e.standoff * (h - l) / Z, X += e.standoff * (p - f) / Z;
                  }

                  var J,
                      K,
                      Q = G.append("path").classed("annotation-arrow", !0).classed("anndrag", !0).classed("cursor-move", !0).attr({
                    d: "M3,3H-3V-3H3ZM0,0L" + (h - W) + "," + (p - X),
                    transform: s(W, X)
                  }).style("stroke-width", V + 6 + "px").call(c.stroke, "rgba(0,0,0,0)").call(c.fill, "rgba(0,0,0,0)");
                  d.init({
                    element: Q.node(),
                    gd: t,
                    prepFn: function prepFn() {
                      var t = u.getTranslate(R);
                      J = t.x, K = t.y, v && v.autorange && A(v._name + ".autorange", !0), x && x.autorange && A(x._name + ".autorange", !0);
                    },
                    moveFn: function moveFn(t, r) {
                      var n = w(J, K),
                          i = n[0] + t,
                          a = n[1] + r;
                      R.call(u.setTranslate, i, a), S("x", y(v, t, "x", T, e)), S("y", y(x, r, "y", T, e)), e.axref === e.xref && S("ax", y(v, t, "ax", T, e)), e.ayref === e.yref && S("ay", y(x, r, "ay", T, e)), G.attr("transform", s(t, r)), O.attr({
                        transform: "rotate(" + P + "," + i + "," + a + ")"
                      });
                    },
                    doneFn: function doneFn() {
                      i.call("_guiRelayout", t, E());
                      var e = document.querySelector(".js-notes-box-panel");
                      e && e.redraw(e.selectedObj);
                    }
                  });
                }
              }
            };

            if (e.showarrow && Mt(0, 0), z) d.init({
              element: R.node(),
              gd: t,
              prepFn: function prepFn() {
                kt = O.attr("transform");
              },
              moveFn: function moveFn(t, r) {
                var n = "pointer";
                if (e.showarrow) e.axref === e.xref ? S("ax", y(v, t, "ax", T, e)) : S("ax", e.ax + t), e.ayref === e.yref ? S("ay", y(x, r, "ay", T.w, e)) : S("ay", e.ay + r), Mt(t, r);else {
                  if (a) return;
                  var i, o;
                  if (v) i = y(v, t, "x", T, e);else {
                    var l = e._xsize / T.w,
                        c = e.x + (e._xshift - e.xshift) / T.w - l / 2;
                    i = d.align(c + t / T.w, l, 0, 1, e.xanchor);
                  }
                  if (x) o = y(x, r, "y", T, e);else {
                    var u = e._ysize / T.h,
                        f = e.y - (e._yshift + e.yshift) / T.h - u / 2;
                    o = d.align(f - r / T.h, u, 0, 1, e.yanchor);
                  }
                  S("x", i), S("y", o), v && x || (n = d.getCursor(v ? .5 : i, x ? .5 : o, e.xanchor, e.yanchor));
                }
                O.attr({
                  transform: s(t, r) + kt
                }), p(R, n);
              },
              clickFn: function clickFn(r, n) {
                e.captureevents && t.emit("plotly_clickannotation", Y(n));
              },
              doneFn: function doneFn() {
                p(R), i.call("_guiRelayout", t, E());
                var e = document.querySelector(".js-notes-box-panel");
                e && e.redraw(e.selectedObj);
              }
            });
          }
        }
      }

      e.exports = {
        draw: function draw(t) {
          var e = t._fullLayout;

          e._infolayer.selectAll(".annotation").remove();

          for (var r = 0; r < e.annotations.length; r++) {
            e.annotations[r].visible && v(t, r);
          }

          return a.previousPromises(t);
        },
        drawOne: v,
        drawRaw: x
      };
    }, {
      "../../lib": 795,
      "../../lib/setcursor": 816,
      "../../lib/svg_text_utils": 820,
      "../../plot_api/plot_template": 834,
      "../../plots/cartesian/axes": 845,
      "../../plots/plots": 909,
      "../../registry": 923,
      "../color": 658,
      "../dragelement": 677,
      "../drawing": 680,
      "../fx": 698,
      "./draw_arrow_head": 648,
      "@plotly/d3": 57
    }],
    648: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../color"),
          a = t("./arrow_paths"),
          o = t("../../lib"),
          s = o.strScale,
          l = o.strRotate,
          c = o.strTranslate;

      e.exports = function (t, e, r) {
        var o,
            u,
            f,
            h,
            p = t.node(),
            d = a[r.arrowhead || 0],
            m = a[r.startarrowhead || 0],
            g = (r.arrowwidth || 1) * (r.arrowsize || 1),
            v = (r.arrowwidth || 1) * (r.startarrowsize || 1),
            y = e.indexOf("start") >= 0,
            x = e.indexOf("end") >= 0,
            b = d.backoff * g + r.standoff,
            _ = m.backoff * v + r.startstandoff;

        if ("line" === p.nodeName) {
          o = {
            x: +t.attr("x1"),
            y: +t.attr("y1")
          }, u = {
            x: +t.attr("x2"),
            y: +t.attr("y2")
          };
          var w = o.x - u.x,
              T = o.y - u.y;
          if (h = (f = Math.atan2(T, w)) + Math.PI, b && _ && b + _ > Math.sqrt(w * w + T * T)) return void z();

          if (b) {
            if (b * b > w * w + T * T) return void z();
            var k = b * Math.cos(f),
                M = b * Math.sin(f);
            u.x += k, u.y += M, t.attr({
              x2: u.x,
              y2: u.y
            });
          }

          if (_) {
            if (_ * _ > w * w + T * T) return void z();

            var A = _ * Math.cos(f),
                S = _ * Math.sin(f);

            o.x -= A, o.y -= S, t.attr({
              x1: o.x,
              y1: o.y
            });
          }
        } else if ("path" === p.nodeName) {
          var E = p.getTotalLength(),
              L = "";
          if (E < b + _) return void z();
          var C = p.getPointAtLength(0),
              P = p.getPointAtLength(.1);
          f = Math.atan2(C.y - P.y, C.x - P.x), o = p.getPointAtLength(Math.min(_, E)), L = "0px," + _ + "px,";
          var I = p.getPointAtLength(E),
              O = p.getPointAtLength(E - .1);
          h = Math.atan2(I.y - O.y, I.x - O.x), u = p.getPointAtLength(Math.max(0, E - b)), L += E - (L ? _ + b : b) + "px," + E + "px", t.style("stroke-dasharray", L);
        }

        function z() {
          t.style("stroke-dasharray", "0px,100px");
        }

        function D(e, a, o, u) {
          e.path && (e.noRotate && (o = 0), n.select(p.parentNode).append("path").attr({
            class: t.attr("class"),
            d: e.path,
            transform: c(a.x, a.y) + l(180 * o / Math.PI) + s(u)
          }).style({
            fill: i.rgb(r.arrowcolor),
            "stroke-width": 0
          }));
        }

        y && D(m, o, f, v), x && D(d, u, h, g);
      };
    }, {
      "../../lib": 795,
      "../color": 658,
      "./arrow_paths": 640,
      "@plotly/d3": 57
    }],
    649: [function (t, e, r) {
      "use strict";

      var n = t("./draw"),
          i = t("./click");
      e.exports = {
        moduleType: "component",
        name: "annotations",
        layoutAttributes: t("./attributes"),
        supplyLayoutDefaults: t("./defaults"),
        includeBasePlot: t("../../plots/cartesian/include_components")("annotations"),
        calcAutorange: t("./calc_autorange"),
        draw: n.draw,
        drawOne: n.drawOne,
        drawRaw: n.drawRaw,
        hasClickToShow: i.hasClickToShow,
        onClick: i.onClick,
        convertCoords: t("./convert_coords")
      };
    }, {
      "../../plots/cartesian/include_components": 857,
      "./attributes": 641,
      "./calc_autorange": 642,
      "./click": 643,
      "./convert_coords": 645,
      "./defaults": 646,
      "./draw": 647
    }],
    650: [function (t, e, r) {
      "use strict";

      var n = t("../annotations/attributes"),
          i = t("../../plot_api/edit_types").overrideAll,
          a = t("../../plot_api/plot_template").templatedArray;
      e.exports = i(a("annotation", {
        visible: n.visible,
        x: {
          valType: "any"
        },
        y: {
          valType: "any"
        },
        z: {
          valType: "any"
        },
        ax: {
          valType: "number"
        },
        ay: {
          valType: "number"
        },
        xanchor: n.xanchor,
        xshift: n.xshift,
        yanchor: n.yanchor,
        yshift: n.yshift,
        text: n.text,
        textangle: n.textangle,
        font: n.font,
        width: n.width,
        height: n.height,
        opacity: n.opacity,
        align: n.align,
        valign: n.valign,
        bgcolor: n.bgcolor,
        bordercolor: n.bordercolor,
        borderpad: n.borderpad,
        borderwidth: n.borderwidth,
        showarrow: n.showarrow,
        arrowcolor: n.arrowcolor,
        arrowhead: n.arrowhead,
        startarrowhead: n.startarrowhead,
        arrowside: n.arrowside,
        arrowsize: n.arrowsize,
        startarrowsize: n.startarrowsize,
        arrowwidth: n.arrowwidth,
        standoff: n.standoff,
        startstandoff: n.startstandoff,
        hovertext: n.hovertext,
        hoverlabel: n.hoverlabel,
        captureevents: n.captureevents
      }), "calc", "from-root");
    }, {
      "../../plot_api/edit_types": 827,
      "../../plot_api/plot_template": 834,
      "../annotations/attributes": 641
    }],
    651: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../plots/cartesian/axes");

      function a(t, e) {
        var r = e.fullSceneLayout.domain,
            a = e.fullLayout._size,
            o = {
          pdata: null,
          type: "linear",
          autorange: !1,
          range: [-1 / 0, 1 / 0]
        };
        t._xa = {}, n.extendFlat(t._xa, o), i.setConvert(t._xa), t._xa._offset = a.l + r.x[0] * a.w, t._xa.l2p = function () {
          return .5 * (1 + t._pdata[0] / t._pdata[3]) * a.w * (r.x[1] - r.x[0]);
        }, t._ya = {}, n.extendFlat(t._ya, o), i.setConvert(t._ya), t._ya._offset = a.t + (1 - r.y[1]) * a.h, t._ya.l2p = function () {
          return .5 * (1 - t._pdata[1] / t._pdata[3]) * a.h * (r.y[1] - r.y[0]);
        };
      }

      e.exports = function (t) {
        for (var e = t.fullSceneLayout.annotations, r = 0; r < e.length; r++) {
          a(e[r], t);
        }

        t.fullLayout._infolayer.selectAll(".annotation-" + t.id).remove();
      };
    }, {
      "../../lib": 795,
      "../../plots/cartesian/axes": 845
    }],
    652: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../plots/cartesian/axes"),
          a = t("../../plots/array_container_defaults"),
          o = t("../annotations/common_defaults"),
          s = t("./attributes");

      function l(t, e, r, a) {
        function l(r, i) {
          return n.coerce(t, e, s, r, i);
        }

        function c(t) {
          var n = t + "axis",
              a = {
            _fullLayout: {}
          };
          return a._fullLayout[n] = r[n], i.coercePosition(e, a, l, t, t, .5);
        }

        l("visible") && (o(t, e, a.fullLayout, l), c("x"), c("y"), c("z"), n.noneOrAll(t, e, ["x", "y", "z"]), e.xref = "x", e.yref = "y", e.zref = "z", l("xanchor"), l("yanchor"), l("xshift"), l("yshift"), e.showarrow && (e.axref = "pixel", e.ayref = "pixel", l("ax", -10), l("ay", -30), n.noneOrAll(t, e, ["ax", "ay"])));
      }

      e.exports = function (t, e, r) {
        a(t, e, {
          name: "annotations",
          handleItemDefaults: l,
          fullLayout: r.fullLayout
        });
      };
    }, {
      "../../lib": 795,
      "../../plots/array_container_defaults": 840,
      "../../plots/cartesian/axes": 845,
      "../annotations/common_defaults": 644,
      "./attributes": 650
    }],
    653: [function (t, e, r) {
      "use strict";

      var n = t("../annotations/draw").drawRaw,
          i = t("../../plots/gl3d/project"),
          a = ["x", "y", "z"];

      e.exports = function (t) {
        for (var e = t.fullSceneLayout, r = t.dataScale, o = e.annotations, s = 0; s < o.length; s++) {
          for (var l = o[s], c = !1, u = 0; u < 3; u++) {
            var f = a[u],
                h = l[f],
                p = e[f + "axis"].r2fraction(h);

            if (p < 0 || p > 1) {
              c = !0;
              break;
            }
          }

          c ? t.fullLayout._infolayer.select(".annotation-" + t.id + '[data-index="' + s + '"]').remove() : (l._pdata = i(t.glplot.cameraParams, [e.xaxis.r2l(l.x) * r[0], e.yaxis.r2l(l.y) * r[1], e.zaxis.r2l(l.z) * r[2]]), n(t.graphDiv, l, s, t.id, l._xa, l._ya));
        }
      };
    }, {
      "../../plots/gl3d/project": 896,
      "../annotations/draw": 647
    }],
    654: [function (t, e, r) {
      "use strict";

      var n = t("../../registry"),
          i = t("../../lib");
      e.exports = {
        moduleType: "component",
        name: "annotations3d",
        schema: {
          subplots: {
            scene: {
              annotations: t("./attributes")
            }
          }
        },
        layoutAttributes: t("./attributes"),
        handleDefaults: t("./defaults"),
        includeBasePlot: function includeBasePlot(t, e) {
          var r = n.subplotsRegistry.gl3d;
          if (!r) return;

          for (var a = r.attrRegex, o = Object.keys(t), s = 0; s < o.length; s++) {
            var l = o[s];
            a.test(l) && (t[l].annotations || []).length && (i.pushUnique(e._basePlotModules, r), i.pushUnique(e._subplots.gl3d, l));
          }
        },
        convert: t("./convert"),
        draw: t("./draw")
      };
    }, {
      "../../lib": 795,
      "../../registry": 923,
      "./attributes": 650,
      "./convert": 651,
      "./defaults": 652,
      "./draw": 653
    }],
    655: [function (t, e, r) {
      "use strict";

      e.exports = t("world-calendars/dist/main"), t("world-calendars/dist/plus"), t("world-calendars/dist/calendars/chinese"), t("world-calendars/dist/calendars/coptic"), t("world-calendars/dist/calendars/discworld"), t("world-calendars/dist/calendars/ethiopian"), t("world-calendars/dist/calendars/hebrew"), t("world-calendars/dist/calendars/islamic"), t("world-calendars/dist/calendars/julian"), t("world-calendars/dist/calendars/mayan"), t("world-calendars/dist/calendars/nanakshahi"), t("world-calendars/dist/calendars/nepali"), t("world-calendars/dist/calendars/persian"), t("world-calendars/dist/calendars/taiwan"), t("world-calendars/dist/calendars/thai"), t("world-calendars/dist/calendars/ummalqura");
    }, {
      "world-calendars/dist/calendars/chinese": 622,
      "world-calendars/dist/calendars/coptic": 623,
      "world-calendars/dist/calendars/discworld": 624,
      "world-calendars/dist/calendars/ethiopian": 625,
      "world-calendars/dist/calendars/hebrew": 626,
      "world-calendars/dist/calendars/islamic": 627,
      "world-calendars/dist/calendars/julian": 628,
      "world-calendars/dist/calendars/mayan": 629,
      "world-calendars/dist/calendars/nanakshahi": 630,
      "world-calendars/dist/calendars/nepali": 631,
      "world-calendars/dist/calendars/persian": 632,
      "world-calendars/dist/calendars/taiwan": 633,
      "world-calendars/dist/calendars/thai": 634,
      "world-calendars/dist/calendars/ummalqura": 635,
      "world-calendars/dist/main": 636,
      "world-calendars/dist/plus": 637
    }],
    656: [function (t, e, r) {
      "use strict";

      var n = t("./calendars"),
          i = t("../../lib"),
          a = t("../../constants/numerical"),
          o = a.EPOCHJD,
          s = a.ONEDAY,
          l = {
        valType: "enumerated",
        values: Object.keys(n.calendars),
        editType: "calc",
        dflt: "gregorian"
      },
          c = function c(t, e, r, n) {
        var a = {};
        return a[r] = l, i.coerce(t, e, a, r, n);
      },
          u = {
        d: {
          0: "dd",
          "-": "d"
        },
        e: {
          0: "d",
          "-": "d"
        },
        a: {
          0: "D",
          "-": "D"
        },
        A: {
          0: "DD",
          "-": "DD"
        },
        j: {
          0: "oo",
          "-": "o"
        },
        W: {
          0: "ww",
          "-": "w"
        },
        m: {
          0: "mm",
          "-": "m"
        },
        b: {
          0: "M",
          "-": "M"
        },
        B: {
          0: "MM",
          "-": "MM"
        },
        y: {
          0: "yy",
          "-": "yy"
        },
        Y: {
          0: "yyyy",
          "-": "yyyy"
        },
        U: "##",
        w: "##",
        c: {
          0: "D M d %X yyyy",
          "-": "D M d %X yyyy"
        },
        x: {
          0: "mm/dd/yyyy",
          "-": "mm/dd/yyyy"
        }
      };

      var f = {};

      function h(t) {
        var e = f[t];
        return e || (e = f[t] = n.instance(t));
      }

      function p(t) {
        return i.extendFlat({}, l, {
          description: t
        });
      }

      function d(t) {
        return "Sets the calendar system to use with `" + t + "` date data.";
      }

      var m = {
        xcalendar: p(d("x"))
      },
          g = i.extendFlat({}, m, {
        ycalendar: p(d("y"))
      }),
          v = i.extendFlat({}, g, {
        zcalendar: p(d("z"))
      }),
          y = p(["Sets the calendar system to use for `range` and `tick0`", "if this is a date axis. This does not set the calendar for", "interpreting data on this axis, that's specified in the trace", "or via the global `layout.calendar`"].join(" "));
      e.exports = {
        moduleType: "component",
        name: "calendars",
        schema: {
          traces: {
            scatter: g,
            bar: g,
            box: g,
            heatmap: g,
            contour: g,
            histogram: g,
            histogram2d: g,
            histogram2dcontour: g,
            scatter3d: v,
            surface: v,
            mesh3d: v,
            scattergl: g,
            ohlc: m,
            candlestick: m
          },
          layout: {
            calendar: p(["Sets the default calendar system to use for interpreting and", "displaying dates throughout the plot."].join(" "))
          },
          subplots: {
            xaxis: {
              calendar: y
            },
            yaxis: {
              calendar: y
            },
            scene: {
              xaxis: {
                calendar: y
              },
              yaxis: {
                calendar: y
              },
              zaxis: {
                calendar: y
              }
            },
            polar: {
              radialaxis: {
                calendar: y
              }
            }
          },
          transforms: {
            filter: {
              valuecalendar: p(["WARNING: All transforms are deprecated and may be removed from the API in next major version.", "Sets the calendar system to use for `value`, if it is a date."].join(" ")),
              targetcalendar: p(["WARNING: All transforms are deprecated and may be removed from the API in next major version.", "Sets the calendar system to use for `target`, if it is an", "array of dates. If `target` is a string (eg *x*) we use the", "corresponding trace attribute (eg `xcalendar`) if it exists,", "even if `targetcalendar` is provided."].join(" "))
            }
          }
        },
        layoutAttributes: l,
        handleDefaults: c,
        handleTraceDefaults: function handleTraceDefaults(t, e, r, n) {
          for (var i = 0; i < r.length; i++) {
            c(t, e, r[i] + "calendar", n.calendar);
          }
        },
        CANONICAL_SUNDAY: {
          chinese: "2000-01-02",
          coptic: "2000-01-03",
          discworld: "2000-01-03",
          ethiopian: "2000-01-05",
          hebrew: "5000-01-01",
          islamic: "1000-01-02",
          julian: "2000-01-03",
          mayan: "5000-01-01",
          nanakshahi: "1000-01-05",
          nepali: "2000-01-05",
          persian: "1000-01-01",
          jalali: "1000-01-01",
          taiwan: "1000-01-04",
          thai: "2000-01-04",
          ummalqura: "1400-01-06"
        },
        CANONICAL_TICK: {
          chinese: "2000-01-01",
          coptic: "2000-01-01",
          discworld: "2000-01-01",
          ethiopian: "2000-01-01",
          hebrew: "5000-01-01",
          islamic: "1000-01-01",
          julian: "2000-01-01",
          mayan: "5000-01-01",
          nanakshahi: "1000-01-01",
          nepali: "2000-01-01",
          persian: "1000-01-01",
          jalali: "1000-01-01",
          taiwan: "1000-01-01",
          thai: "2000-01-01",
          ummalqura: "1400-01-01"
        },
        DFLTRANGE: {
          chinese: ["2000-01-01", "2001-01-01"],
          coptic: ["1700-01-01", "1701-01-01"],
          discworld: ["1800-01-01", "1801-01-01"],
          ethiopian: ["2000-01-01", "2001-01-01"],
          hebrew: ["5700-01-01", "5701-01-01"],
          islamic: ["1400-01-01", "1401-01-01"],
          julian: ["2000-01-01", "2001-01-01"],
          mayan: ["5200-01-01", "5201-01-01"],
          nanakshahi: ["0500-01-01", "0501-01-01"],
          nepali: ["2000-01-01", "2001-01-01"],
          persian: ["1400-01-01", "1401-01-01"],
          jalali: ["1400-01-01", "1401-01-01"],
          taiwan: ["0100-01-01", "0101-01-01"],
          thai: ["2500-01-01", "2501-01-01"],
          ummalqura: ["1400-01-01", "1401-01-01"]
        },
        getCal: h,
        worldCalFmt: function worldCalFmt(t, e, r) {
          for (var n, i, a, l, c, f = Math.floor((e + .05) / s) + o, p = h(r).fromJD(f), d = 0; -1 !== (d = t.indexOf("%", d));) {
            "0" === (n = t.charAt(d + 1)) || "-" === n || "_" === n ? (a = 3, i = t.charAt(d + 2), "_" === n && (n = "-")) : (i = n, n = "0", a = 2), (l = u[i]) ? (c = "##" === l ? "##" : p.formatDate(l[n]), t = t.substr(0, d) + c + t.substr(d + a), d += c.length) : d += a;
          }

          return t;
        }
      };
    }, {
      "../../constants/numerical": 771,
      "../../lib": 795,
      "./calendars": 655
    }],
    657: [function (t, e, r) {
      "use strict";

      r.defaults = ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf"], r.defaultLine = "#444", r.lightLine = "#eee", r.background = "#fff", r.borderLine = "#BEC8D9", r.lightFraction = 1e3 / 11;
    }, {}],
    658: [function (t, e, r) {
      "use strict";

      var n = t("tinycolor2"),
          i = t("fast-isnumeric"),
          a = t("../../lib/array").isTypedArray,
          o = e.exports = {},
          s = t("./attributes");
      o.defaults = s.defaults;
      var l = o.defaultLine = s.defaultLine;
      o.lightLine = s.lightLine;
      var c = o.background = s.background;

      function u(t) {
        if (i(t) || "string" != typeof t) return t;
        var e = t.trim();
        if ("rgb" !== e.substr(0, 3)) return t;
        var r = e.match(/^rgba?\s*\(([^()]*)\)$/);
        if (!r) return t;
        var n = r[1].trim().split(/\s*[\s,]\s*/),
            a = "a" === e.charAt(3) && 4 === n.length;
        if (!a && 3 !== n.length) return t;

        for (var o = 0; o < n.length; o++) {
          if (!n[o].length) return t;
          if (n[o] = Number(n[o]), !(n[o] >= 0)) return t;
          if (3 === o) n[o] > 1 && (n[o] = 1);else if (n[o] >= 1) return t;
        }

        var s = Math.round(255 * n[0]) + ", " + Math.round(255 * n[1]) + ", " + Math.round(255 * n[2]);
        return a ? "rgba(" + s + ", " + n[3] + ")" : "rgb(" + s + ")";
      }

      o.tinyRGB = function (t) {
        var e = t.toRgb();
        return "rgb(" + Math.round(e.r) + ", " + Math.round(e.g) + ", " + Math.round(e.b) + ")";
      }, o.rgb = function (t) {
        return o.tinyRGB(n(t));
      }, o.opacity = function (t) {
        return t ? n(t).getAlpha() : 0;
      }, o.addOpacity = function (t, e) {
        var r = n(t).toRgb();
        return "rgba(" + Math.round(r.r) + ", " + Math.round(r.g) + ", " + Math.round(r.b) + ", " + e + ")";
      }, o.combine = function (t, e) {
        var r = n(t).toRgb();
        if (1 === r.a) return n(t).toRgbString();
        var i = n(e || c).toRgb(),
            a = 1 === i.a ? i : {
          r: 255 * (1 - i.a) + i.r * i.a,
          g: 255 * (1 - i.a) + i.g * i.a,
          b: 255 * (1 - i.a) + i.b * i.a
        },
            o = {
          r: a.r * (1 - r.a) + r.r * r.a,
          g: a.g * (1 - r.a) + r.g * r.a,
          b: a.b * (1 - r.a) + r.b * r.a
        };
        return n(o).toRgbString();
      }, o.contrast = function (t, e, r) {
        var i = n(t);
        return 1 !== i.getAlpha() && (i = n(o.combine(t, c))), (i.isDark() ? e ? i.lighten(e) : c : r ? i.darken(r) : l).toString();
      }, o.stroke = function (t, e) {
        var r = n(e);
        t.style({
          stroke: o.tinyRGB(r),
          "stroke-opacity": r.getAlpha()
        });
      }, o.fill = function (t, e) {
        var r = n(e);
        t.style({
          fill: o.tinyRGB(r),
          "fill-opacity": r.getAlpha()
        });
      }, o.clean = function (t) {
        if (t && "object" == _typeof(t)) {
          var e,
              r,
              n,
              i,
              s = Object.keys(t);

          for (e = 0; e < s.length; e++) {
            if (i = t[n = s[e]], "color" === n.substr(n.length - 5)) {
              if (Array.isArray(i)) for (r = 0; r < i.length; r++) {
                i[r] = u(i[r]);
              } else t[n] = u(i);
            } else if ("colorscale" === n.substr(n.length - 10) && Array.isArray(i)) for (r = 0; r < i.length; r++) {
              Array.isArray(i[r]) && (i[r][1] = u(i[r][1]));
            } else if (Array.isArray(i)) {
              var l = i[0];
              if (!Array.isArray(l) && l && "object" == _typeof(l)) for (r = 0; r < i.length; r++) {
                o.clean(i[r]);
              }
            } else i && "object" == _typeof(i) && !a(i) && o.clean(i);
          }
        }
      };
    }, {
      "../../lib/array": 777,
      "./attributes": 657,
      "fast-isnumeric": 240,
      tinycolor2: 590
    }],
    659: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/cartesian/layout_attributes"),
          i = t("../../plots/font_attributes"),
          a = t("../../lib/extend").extendFlat,
          o = t("../../plot_api/edit_types").overrideAll;
      e.exports = o({
        thicknessmode: {
          valType: "enumerated",
          values: ["fraction", "pixels"],
          dflt: "pixels"
        },
        thickness: {
          valType: "number",
          min: 0,
          dflt: 30
        },
        lenmode: {
          valType: "enumerated",
          values: ["fraction", "pixels"],
          dflt: "fraction"
        },
        len: {
          valType: "number",
          min: 0,
          dflt: 1
        },
        x: {
          valType: "number",
          dflt: 1.02,
          min: -2,
          max: 3
        },
        xanchor: {
          valType: "enumerated",
          values: ["left", "center", "right"],
          dflt: "left"
        },
        xpad: {
          valType: "number",
          min: 0,
          dflt: 10
        },
        y: {
          valType: "number",
          dflt: .5,
          min: -2,
          max: 3
        },
        yanchor: {
          valType: "enumerated",
          values: ["top", "middle", "bottom"],
          dflt: "middle"
        },
        ypad: {
          valType: "number",
          min: 0,
          dflt: 10
        },
        outlinecolor: n.linecolor,
        outlinewidth: n.linewidth,
        bordercolor: n.linecolor,
        borderwidth: {
          valType: "number",
          min: 0,
          dflt: 0
        },
        bgcolor: {
          valType: "color",
          dflt: "rgba(0,0,0,0)"
        },
        tickmode: n.tickmode,
        nticks: n.nticks,
        tick0: n.tick0,
        dtick: n.dtick,
        tickvals: n.tickvals,
        ticktext: n.ticktext,
        ticks: a({}, n.ticks, {
          dflt: ""
        }),
        ticklabeloverflow: a({}, n.ticklabeloverflow, {}),
        ticklabelposition: {
          valType: "enumerated",
          values: ["outside", "inside", "outside top", "inside top", "outside bottom", "inside bottom"],
          dflt: "outside"
        },
        ticklen: n.ticklen,
        tickwidth: n.tickwidth,
        tickcolor: n.tickcolor,
        showticklabels: n.showticklabels,
        tickfont: i({}),
        tickangle: n.tickangle,
        tickformat: n.tickformat,
        tickformatstops: n.tickformatstops,
        tickprefix: n.tickprefix,
        showtickprefix: n.showtickprefix,
        ticksuffix: n.ticksuffix,
        showticksuffix: n.showticksuffix,
        separatethousands: n.separatethousands,
        exponentformat: n.exponentformat,
        minexponent: n.minexponent,
        showexponent: n.showexponent,
        title: {
          text: {
            valType: "string"
          },
          font: i({}),
          side: {
            valType: "enumerated",
            values: ["right", "top", "bottom"],
            dflt: "top"
          }
        },
        _deprecated: {
          title: {
            valType: "string"
          },
          titlefont: i({}),
          titleside: {
            valType: "enumerated",
            values: ["right", "top", "bottom"],
            dflt: "top"
          }
        }
      }, "colorbars", "from-root");
    }, {
      "../../lib/extend": 785,
      "../../plot_api/edit_types": 827,
      "../../plots/cartesian/layout_attributes": 859,
      "../../plots/font_attributes": 873
    }],
    660: [function (t, e, r) {
      "use strict";

      e.exports = {
        cn: {
          colorbar: "colorbar",
          cbbg: "cbbg",
          cbfill: "cbfill",
          cbfills: "cbfills",
          cbline: "cbline",
          cblines: "cblines",
          cbaxis: "cbaxis",
          cbtitleunshift: "cbtitleunshift",
          cbtitle: "cbtitle",
          cboutline: "cboutline",
          crisp: "crisp",
          jsPlaceholder: "js-placeholder"
        }
      };
    }, {}],
    661: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../plot_api/plot_template"),
          a = t("../../plots/cartesian/tick_value_defaults"),
          o = t("../../plots/cartesian/tick_mark_defaults"),
          s = t("../../plots/cartesian/tick_label_defaults"),
          l = t("./attributes");

      e.exports = function (t, e, r) {
        var c = i.newContainer(e, "colorbar"),
            u = t.colorbar || {};

        function f(t, e) {
          return n.coerce(u, c, l, t, e);
        }

        var h = f("thicknessmode");
        f("thickness", "fraction" === h ? 30 / (r.width - r.margin.l - r.margin.r) : 30);
        var p = f("lenmode");
        f("len", "fraction" === p ? 1 : r.height - r.margin.t - r.margin.b), f("x"), f("xanchor"), f("xpad"), f("y"), f("yanchor"), f("ypad"), n.noneOrAll(u, c, ["x", "y"]), f("outlinecolor"), f("outlinewidth"), f("bordercolor"), f("borderwidth"), f("bgcolor");
        var d = f("ticklabelposition");
        f("ticklabeloverflow", -1 !== d.indexOf("inside") ? "hide past domain" : "hide past div"), a(u, c, f, "linear");
        var m = r.font,
            g = {
          outerTicks: !1,
          font: m
        };
        -1 !== d.indexOf("inside") && (g.bgColor = "black"), s(u, c, f, "linear", g), o(u, c, f, "linear", g), f("title.text", r._dfltTitle.colorbar);
        var v = c.tickfont,
            y = n.extendFlat({}, v, {
          color: m.color,
          size: n.bigFont(v.size)
        });
        n.coerceFont(f, "title.font", y), f("title.side");
      };
    }, {
      "../../lib": 795,
      "../../plot_api/plot_template": 834,
      "../../plots/cartesian/tick_label_defaults": 866,
      "../../plots/cartesian/tick_mark_defaults": 867,
      "../../plots/cartesian/tick_value_defaults": 868,
      "./attributes": 659
    }],
    662: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("tinycolor2"),
          a = t("../../plots/plots"),
          o = t("../../registry"),
          s = t("../../plots/cartesian/axes"),
          l = t("../dragelement"),
          c = t("../../lib"),
          u = c.strTranslate,
          f = t("../../lib/extend").extendFlat,
          h = t("../../lib/setcursor"),
          p = t("../drawing"),
          d = t("../color"),
          m = t("../titles"),
          g = t("../../lib/svg_text_utils"),
          v = t("../colorscale/helpers").flipScale,
          y = t("../../plots/cartesian/axis_defaults"),
          x = t("../../plots/cartesian/position_defaults"),
          b = t("../../plots/cartesian/layout_attributes"),
          _ = t("../../constants/alignment"),
          w = _.LINE_SPACING,
          T = _.FROM_TL,
          k = _.FROM_BR,
          M = t("./constants").cn;

      e.exports = {
        draw: function draw(t) {
          var e = t._fullLayout._infolayer.selectAll("g." + M.colorbar).data(function (t) {
            var e,
                r,
                n,
                i,
                a = t._fullLayout,
                o = t.calcdata,
                s = [];

            function l(t) {
              return f(t, {
                _fillcolor: null,
                _line: {
                  color: null,
                  width: null,
                  dash: null
                },
                _levels: {
                  start: null,
                  end: null,
                  size: null
                },
                _filllevels: null,
                _fillgradient: null,
                _zrange: null
              });
            }

            function c() {
              "function" == typeof i.calc ? i.calc(t, n, e) : (e._fillgradient = r.reversescale ? v(r.colorscale) : r.colorscale, e._zrange = [r[i.min], r[i.max]]);
            }

            for (var u = 0; u < o.length; u++) {
              var h = o[u],
                  p = (n = h[0].trace)._module.colorbar;
              if (!0 === n.visible && p) for (var d = Array.isArray(p), m = d ? p : [p], g = 0; g < m.length; g++) {
                var y = (i = m[g]).container;
                (r = y ? n[y] : n) && r.showscale && ((e = l(r.colorbar))._id = "cb" + n.uid + (d && y ? "-" + y : ""), e._traceIndex = n.index, e._propPrefix = (y ? y + "." : "") + "colorbar.", e._meta = n._meta, c(), s.push(e));
              }
            }

            for (var x in a._colorAxes) {
              if ((r = a[x]).showscale) {
                var b = a._colorAxes[x];
                (e = l(r.colorbar))._id = "cb" + x, e._propPrefix = x + ".colorbar.", e._meta = a._meta, i = {
                  min: "cmin",
                  max: "cmax"
                }, "heatmap" !== b[0] && (n = b[1], i.calc = n._module.colorbar.calc), c(), s.push(e);
              }
            }

            return s;
          }(t), function (t) {
            return t._id;
          });

          e.enter().append("g").attr("class", function (t) {
            return t._id;
          }).classed(M.colorbar, !0), e.each(function (e) {
            var r = n.select(this);
            c.ensureSingle(r, "rect", M.cbbg), c.ensureSingle(r, "g", M.cbfills), c.ensureSingle(r, "g", M.cblines), c.ensureSingle(r, "g", M.cbaxis, function (t) {
              t.classed(M.crisp, !0);
            }), c.ensureSingle(r, "g", M.cbtitleunshift, function (t) {
              t.append("g").classed(M.cbtitle, !0);
            }), c.ensureSingle(r, "rect", M.cboutline);

            var v = function (t, e, r) {
              var o = r._fullLayout,
                  l = o._size,
                  h = e._fillcolor,
                  v = e._line,
                  _ = e.title,
                  A = _.side,
                  S = e._zrange || n.extent(("function" == typeof h ? h : v.color).domain()),
                  E = "function" == typeof v.color ? v.color : function () {
                return v.color;
              },
                  L = "function" == typeof h ? h : function () {
                return h;
              },
                  C = e._levels,
                  P = function (t, e, r) {
                var n,
                    i,
                    a = e._levels,
                    o = [],
                    s = [],
                    l = a.end + a.size / 100,
                    c = a.size,
                    u = 1.001 * r[0] - .001 * r[1],
                    f = 1.001 * r[1] - .001 * r[0];

                for (i = 0; i < 1e5 && (n = a.start + i * c, !(c > 0 ? n >= l : n <= l)); i++) {
                  n > u && n < f && o.push(n);
                }

                if (e._fillgradient) s = [0];else if ("function" == typeof e._fillcolor) {
                  var h = e._filllevels;
                  if (h) for (l = h.end + h.size / 100, c = h.size, i = 0; i < 1e5 && (n = h.start + i * c, !(c > 0 ? n >= l : n <= l)); i++) {
                    n > r[0] && n < r[1] && s.push(n);
                  } else (s = o.map(function (t) {
                    return t - a.size / 2;
                  })).push(s[s.length - 1] + a.size);
                } else e._fillcolor && "string" == typeof e._fillcolor && (s = [0]);
                a.size < 0 && (o.reverse(), s.reverse());
                return {
                  line: o,
                  fill: s
                };
              }(0, e, S),
                  I = P.fill,
                  O = P.line,
                  z = Math.round(e.thickness * ("fraction" === e.thicknessmode ? l.w : 1)),
                  D = z / l.w,
                  R = Math.round(e.len * ("fraction" === e.lenmode ? l.h : 1)),
                  F = R / l.h,
                  B = e.xpad / l.w,
                  N = (e.borderwidth + e.outlinewidth) / 2,
                  j = e.ypad / l.h,
                  U = Math.round(e.x * l.w + e.xpad),
                  V = e.x - D * ({
                middle: .5,
                right: 1
              }[e.xanchor] || 0),
                  q = e.y + F * (({
                top: -.5,
                bottom: .5
              }[e.yanchor] || 0) - .5),
                  H = Math.round(l.h * (1 - q)),
                  G = H - R;

              e._lenFrac = F, e._thickFrac = D, e._xLeftFrac = V, e._yBottomFrac = q;

              var Y = e._axis = function (t, e, r) {
                var n = t._fullLayout,
                    i = {
                  type: "linear",
                  range: r,
                  tickmode: e.tickmode,
                  nticks: e.nticks,
                  tick0: e.tick0,
                  dtick: e.dtick,
                  tickvals: e.tickvals,
                  ticktext: e.ticktext,
                  ticks: e.ticks,
                  ticklen: e.ticklen,
                  tickwidth: e.tickwidth,
                  tickcolor: e.tickcolor,
                  showticklabels: e.showticklabels,
                  ticklabelposition: e.ticklabelposition,
                  ticklabeloverflow: e.ticklabeloverflow,
                  tickfont: e.tickfont,
                  tickangle: e.tickangle,
                  tickformat: e.tickformat,
                  exponentformat: e.exponentformat,
                  minexponent: e.minexponent,
                  separatethousands: e.separatethousands,
                  showexponent: e.showexponent,
                  showtickprefix: e.showtickprefix,
                  tickprefix: e.tickprefix,
                  showticksuffix: e.showticksuffix,
                  ticksuffix: e.ticksuffix,
                  title: e.title,
                  showline: !0,
                  anchor: "free",
                  side: "right",
                  position: 1
                },
                    a = {
                  type: "linear",
                  _id: "y" + e._id
                },
                    o = {
                  letter: "y",
                  font: n.font,
                  noHover: !0,
                  noTickson: !0,
                  noTicklabelmode: !0,
                  calendar: n.calendar
                };

                function s(t, e) {
                  return c.coerce(i, a, b, t, e);
                }

                return y(i, a, s, o, n), x(i, a, s, o), a;
              }(r, e, S);

              Y.position = e.x + B + D, -1 !== ["top", "bottom"].indexOf(A) && (Y.title.side = A, Y.titlex = e.x + B, Y.titley = q + ("top" === _.side ? F - j : j));

              if (v.color && "auto" === e.tickmode) {
                Y.tickmode = "linear", Y.tick0 = C.start;
                var W = C.size,
                    X = c.constrain((H - G) / 50, 4, 15) + 1,
                    Z = (S[1] - S[0]) / ((e.nticks || X) * W);

                if (Z > 1) {
                  var J = Math.pow(10, Math.floor(Math.log(Z) / Math.LN10));
                  W *= J * c.roundUp(Z / J, [2, 5, 10]), (Math.abs(C.start) / C.size + 1e-6) % 1 < 2e-6 && (Y.tick0 = 0);
                }

                Y.dtick = W;
              }

              Y.domain = [q + j, q + F - j], Y.setScale(), t.attr("transform", u(Math.round(l.l), Math.round(l.t)));
              var K,
                  Q = t.select("." + M.cbtitleunshift).attr("transform", u(-Math.round(l.l), -Math.round(l.t))),
                  $ = t.select("." + M.cbaxis),
                  tt = 0;

              function et(n, i) {
                var a = {
                  propContainer: Y,
                  propName: e._propPrefix + "title",
                  traceIndex: e._traceIndex,
                  _meta: e._meta,
                  placeholder: o._dfltTitle.colorbar,
                  containerGroup: t.select("." + M.cbtitle)
                },
                    s = "h" === n.charAt(0) ? n.substr(1) : "h" + n;
                t.selectAll("." + s + ",." + s + "-math-group").remove(), m.draw(r, n, f(a, i || {}));
              }

              return c.syncOrAsync([a.previousPromises, function () {
                if (-1 !== ["top", "bottom"].indexOf(A)) {
                  var t,
                      r = l.l + (e.x + B) * l.w,
                      n = Y.title.font.size;
                  t = "top" === A ? (1 - (q + F - j)) * l.h + l.t + 3 + .75 * n : (1 - (q + j)) * l.h + l.t - 3 - .25 * n, et(Y._id + "title", {
                    attributes: {
                      x: r,
                      y: t,
                      "text-anchor": "start"
                    }
                  });
                }
              }, function () {
                if (-1 !== ["top", "bottom"].indexOf(A)) {
                  var a = t.select("." + M.cbtitle),
                      o = a.select("text"),
                      f = [-e.outlinewidth / 2, e.outlinewidth / 2],
                      h = a.select(".h" + Y._id + "title-math-group").node(),
                      d = 15.6;

                  if (o.node() && (d = parseInt(o.node().style.fontSize, 10) * w), h ? (tt = p.bBox(h).height) > d && (f[1] -= (tt - d) / 2) : o.node() && !o.classed(M.jsPlaceholder) && (tt = p.bBox(o.node()).height), tt) {
                    if (tt += 5, "top" === A) Y.domain[1] -= tt / l.h, f[1] *= -1;else {
                      Y.domain[0] += tt / l.h;
                      var m = g.lineCount(o);
                      f[1] += (1 - m) * d;
                    }
                    a.attr("transform", u(f[0], f[1])), Y.setScale();
                  }
                }

                t.selectAll("." + M.cbfills + ",." + M.cblines).attr("transform", u(0, Math.round(l.h * (1 - Y.domain[1])))), $.attr("transform", u(0, Math.round(-l.t)));
                var y = t.select("." + M.cbfills).selectAll("rect." + M.cbfill).attr("style", "").data(I);
                y.enter().append("rect").classed(M.cbfill, !0).style("stroke", "none"), y.exit().remove();
                var x = S.map(Y.c2p).map(Math.round).sort(function (t, e) {
                  return t - e;
                });
                y.each(function (t, a) {
                  var o = [0 === a ? S[0] : (I[a] + I[a - 1]) / 2, a === I.length - 1 ? S[1] : (I[a] + I[a + 1]) / 2].map(Y.c2p).map(Math.round);
                  o[1] = c.constrain(o[1] + (o[1] > o[0]) ? 1 : -1, x[0], x[1]);
                  var s = n.select(this).attr({
                    x: U,
                    width: Math.max(z, 2),
                    y: n.min(o),
                    height: Math.max(n.max(o) - n.min(o), 2)
                  });
                  if (e._fillgradient) p.gradient(s, r, e._id, "vertical", e._fillgradient, "fill");else {
                    var l = L(t).replace("e-", "");
                    s.attr("fill", i(l).toHexString());
                  }
                });
                var b = t.select("." + M.cblines).selectAll("path." + M.cbline).data(v.color && v.width ? O : []);
                b.enter().append("path").classed(M.cbline, !0), b.exit().remove(), b.each(function (t) {
                  n.select(this).attr("d", "M" + U + "," + (Math.round(Y.c2p(t)) + v.width / 2 % 1) + "h" + z).call(p.lineGroupStyle, v.width, E(t), v.dash);
                }), $.selectAll("g." + Y._id + "tick,path").remove();

                var _ = U + z + (e.outlinewidth || 0) / 2 - ("outside" === e.ticks ? 1 : 0),
                    T = s.calcTicks(Y),
                    k = s.getTickSigns(Y)[2];

                return s.drawTicks(r, Y, {
                  vals: "inside" === Y.ticks ? s.clipEnds(Y, T) : T,
                  layer: $,
                  path: s.makeTickPath(Y, _, k),
                  transFn: s.makeTransTickFn(Y)
                }), s.drawLabels(r, Y, {
                  vals: T,
                  layer: $,
                  transFn: s.makeTransTickLabelFn(Y),
                  labelFns: s.makeLabelFns(Y, _)
                });
              }, function () {
                if (-1 === ["top", "bottom"].indexOf(A)) {
                  var t = Y.title.font.size,
                      e = Y._offset + Y._length / 2,
                      i = l.l + (Y.position || 0) * l.w + ("right" === Y.side ? 10 + t * (Y.showticklabels ? 1 : .5) : -10 - t * (Y.showticklabels ? .5 : 0));
                  et("h" + Y._id + "title", {
                    avoid: {
                      selection: n.select(r).selectAll("g." + Y._id + "tick"),
                      side: A,
                      offsetLeft: l.l,
                      offsetTop: 0,
                      maxShift: o.width
                    },
                    attributes: {
                      x: i,
                      y: e,
                      "text-anchor": "middle"
                    },
                    transform: {
                      rotate: "-90",
                      offset: 0
                    }
                  });
                }
              }, a.previousPromises, function () {
                var n = z + e.outlinewidth / 2;

                if (-1 === Y.ticklabelposition.indexOf("inside") && (n += p.bBox($.node()).width), (K = Q.select("text")).node() && !K.classed(M.jsPlaceholder)) {
                  var i,
                      o = Q.select(".h" + Y._id + "title-math-group").node();
                  i = o && -1 !== ["top", "bottom"].indexOf(A) ? p.bBox(o).width : p.bBox(Q.node()).right - U - l.l, n = Math.max(n, i);
                }

                var s = 2 * e.xpad + n + e.borderwidth + e.outlinewidth / 2,
                    c = H - G;
                t.select("." + M.cbbg).attr({
                  x: U - e.xpad - (e.borderwidth + e.outlinewidth) / 2,
                  y: G - N,
                  width: Math.max(s, 2),
                  height: Math.max(c + 2 * N, 2)
                }).call(d.fill, e.bgcolor).call(d.stroke, e.bordercolor).style("stroke-width", e.borderwidth), t.selectAll("." + M.cboutline).attr({
                  x: U,
                  y: G + e.ypad + ("top" === A ? tt : 0),
                  width: Math.max(z, 2),
                  height: Math.max(c - 2 * e.ypad - tt, 2)
                }).call(d.stroke, e.outlinecolor).style({
                  fill: "none",
                  "stroke-width": e.outlinewidth
                });
                var f = ({
                  center: .5,
                  right: 1
                }[e.xanchor] || 0) * s;
                t.attr("transform", u(l.l - f, l.t));
                var h = {},
                    m = T[e.yanchor],
                    g = k[e.yanchor];
                "pixels" === e.lenmode ? (h.y = e.y, h.t = c * m, h.b = c * g) : (h.t = h.b = 0, h.yt = e.y + e.len * m, h.yb = e.y - e.len * g);
                var v = T[e.xanchor],
                    y = k[e.xanchor];
                if ("pixels" === e.thicknessmode) h.x = e.x, h.l = s * v, h.r = s * y;else {
                  var x = s - z;
                  h.l = x * v, h.r = x * y, h.xl = e.x - e.thickness * v, h.xr = e.x + e.thickness * y;
                }
                a.autoMargin(r, e._id, h);
              }], r);
            }(r, e, t);

            v && v.then && (t._promises || []).push(v), t._context.edits.colorbarPosition && function (t, e, r) {
              var n,
                  i,
                  a,
                  s = r._fullLayout._size;
              l.init({
                element: t.node(),
                gd: r,
                prepFn: function prepFn() {
                  n = t.attr("transform"), h(t);
                },
                moveFn: function moveFn(r, o) {
                  t.attr("transform", n + u(r, o)), i = l.align(e._xLeftFrac + r / s.w, e._thickFrac, 0, 1, e.xanchor), a = l.align(e._yBottomFrac - o / s.h, e._lenFrac, 0, 1, e.yanchor);
                  var c = l.getCursor(i, a, e.xanchor, e.yanchor);
                  h(t, c);
                },
                doneFn: function doneFn() {
                  if (h(t), void 0 !== i && void 0 !== a) {
                    var n = {};
                    n[e._propPrefix + "x"] = i, n[e._propPrefix + "y"] = a, void 0 !== e._traceIndex ? o.call("_guiRestyle", r, n, e._traceIndex) : o.call("_guiRelayout", r, n);
                  }
                }
              });
            }(r, e, t);
          }), e.exit().each(function (e) {
            a.autoMargin(t, e._id);
          }).remove(), e.order();
        }
      };
    }, {
      "../../constants/alignment": 763,
      "../../lib": 795,
      "../../lib/extend": 785,
      "../../lib/setcursor": 816,
      "../../lib/svg_text_utils": 820,
      "../../plots/cartesian/axes": 845,
      "../../plots/cartesian/axis_defaults": 847,
      "../../plots/cartesian/layout_attributes": 859,
      "../../plots/cartesian/position_defaults": 862,
      "../../plots/plots": 909,
      "../../registry": 923,
      "../color": 658,
      "../colorscale/helpers": 669,
      "../dragelement": 677,
      "../drawing": 680,
      "../titles": 756,
      "./constants": 660,
      "@plotly/d3": 57,
      tinycolor2: 590
    }],
    663: [function (t, e, r) {
      "use strict";

      var n = t("../../lib");

      e.exports = function (t) {
        return n.isPlainObject(t.colorbar);
      };
    }, {
      "../../lib": 795
    }],
    664: [function (t, e, r) {
      "use strict";

      e.exports = {
        moduleType: "component",
        name: "colorbar",
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        draw: t("./draw").draw,
        hasColorbar: t("./has_colorbar")
      };
    }, {
      "./attributes": 659,
      "./defaults": 661,
      "./draw": 662,
      "./has_colorbar": 663
    }],
    665: [function (t, e, r) {
      "use strict";

      var n = t("../colorbar/attributes"),
          i = t("../../lib/regex").counter,
          a = t("./scales.js").scales;
      Object.keys(a);

      function o(t) {
        return "`" + t + "`";
      }

      e.exports = function (t, e) {
        t = t || "";
        var r,
            s = (e = e || {}).cLetter || "c",
            l = ("onlyIfNumerical" in e ? e.onlyIfNumerical : Boolean(t), "noScale" in e ? e.noScale : "marker.line" === t),
            c = "showScaleDflt" in e ? e.showScaleDflt : "z" === s,
            u = "string" == typeof e.colorscaleDflt ? a[e.colorscaleDflt] : null,
            f = e.editTypeOverride || "",
            h = t ? t + "." : "";
        "colorAttr" in e ? (r = e.colorAttr, e.colorAttr) : o(h + (r = {
          z: "z",
          c: "color"
        }[s]));
        var p = s + "auto",
            d = s + "min",
            m = s + "max",
            g = s + "mid",
            v = (o(h + p), o(h + d), o(h + m), {});
        v[d] = v[m] = void 0;
        var y = {};
        y[p] = !1;
        var x = {};
        return "color" === r && (x.color = {
          valType: "color",
          arrayOk: !0,
          editType: f || "style"
        }, e.anim && (x.color.anim = !0)), x[p] = {
          valType: "boolean",
          dflt: !0,
          editType: "calc",
          impliedEdits: v
        }, x[d] = {
          valType: "number",
          dflt: null,
          editType: f || "plot",
          impliedEdits: y
        }, x[m] = {
          valType: "number",
          dflt: null,
          editType: f || "plot",
          impliedEdits: y
        }, x[g] = {
          valType: "number",
          dflt: null,
          editType: "calc",
          impliedEdits: v
        }, x.colorscale = {
          valType: "colorscale",
          editType: "calc",
          dflt: u,
          impliedEdits: {
            autocolorscale: !1
          }
        }, x.autocolorscale = {
          valType: "boolean",
          dflt: !1 !== e.autoColorDflt,
          editType: "calc",
          impliedEdits: {
            colorscale: void 0
          }
        }, x.reversescale = {
          valType: "boolean",
          dflt: !1,
          editType: "plot"
        }, l || (x.showscale = {
          valType: "boolean",
          dflt: c,
          editType: "calc"
        }, x.colorbar = n), e.noColorAxis || (x.coloraxis = {
          valType: "subplotid",
          regex: i("coloraxis"),
          dflt: null,
          editType: "calc"
        }), x;
      };
    }, {
      "../../lib/regex": 812,
      "../colorbar/attributes": 659,
      "./scales.js": 673
    }],
    666: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../lib"),
          a = t("./helpers").extractOpts;

      e.exports = function (t, e, r) {
        var o,
            s = t._fullLayout,
            l = r.vals,
            c = r.containerStr,
            u = c ? i.nestedProperty(e, c).get() : e,
            f = a(u),
            h = !1 !== f.auto,
            p = f.min,
            d = f.max,
            m = f.mid,
            g = function g() {
          return i.aggNums(Math.min, null, l);
        },
            v = function v() {
          return i.aggNums(Math.max, null, l);
        };

        (void 0 === p ? p = g() : h && (p = u._colorAx && n(p) ? Math.min(p, g()) : g()), void 0 === d ? d = v() : h && (d = u._colorAx && n(d) ? Math.max(d, v()) : v()), h && void 0 !== m && (d - m > m - p ? p = m - (d - m) : d - m < m - p && (d = m + (m - p))), p === d && (p -= .5, d += .5), f._sync("min", p), f._sync("max", d), f.autocolorscale) && (o = p * d < 0 ? s.colorscale.diverging : p >= 0 ? s.colorscale.sequential : s.colorscale.sequentialminus, f._sync("colorscale", o));
      };
    }, {
      "../../lib": 795,
      "./helpers": 669,
      "fast-isnumeric": 240
    }],
    667: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./helpers").hasColorscale,
          a = t("./helpers").extractOpts;

      e.exports = function (t, e) {
        function r(t, e) {
          var r = t["_" + e];
          void 0 !== r && (t[e] = r);
        }

        function o(t, i) {
          var o = i.container ? n.nestedProperty(t, i.container).get() : t;
          if (o) if (o.coloraxis) o._colorAx = e[o.coloraxis];else {
            var s = a(o),
                l = s.auto;
            (l || void 0 === s.min) && r(o, i.min), (l || void 0 === s.max) && r(o, i.max), s.autocolorscale && r(o, "colorscale");
          }
        }

        for (var s = 0; s < t.length; s++) {
          var l = t[s],
              c = l._module.colorbar;
          if (c) if (Array.isArray(c)) for (var u = 0; u < c.length; u++) {
            o(l, c[u]);
          } else o(l, c);
          i(l, "marker.line") && o(l, {
            container: "marker.line",
            min: "cmin",
            max: "cmax"
          });
        }

        for (var f in e._colorAxes) {
          o(e[f], {
            min: "cmin",
            max: "cmax"
          });
        }
      };
    }, {
      "../../lib": 795,
      "./helpers": 669
    }],
    668: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../lib"),
          a = t("../colorbar/has_colorbar"),
          o = t("../colorbar/defaults"),
          s = t("./scales").isValid,
          l = t("../../registry").traceIs;

      function c(t, e) {
        var r = e.slice(0, e.length - 1);
        return e ? i.nestedProperty(t, r).get() || {} : t;
      }

      e.exports = function t(e, r, u, f, h) {
        var p = h.prefix,
            d = h.cLetter,
            m = ("_module" in r),
            g = c(e, p),
            v = c(r, p),
            y = c(r._template || {}, p) || {},
            x = function x() {
          return delete e.coloraxis, delete r.coloraxis, t(e, r, u, f, h);
        };

        if (m) {
          var b = u._colorAxes || {},
              _ = f(p + "coloraxis");

          if (_) {
            var w = l(r, "contour") && i.nestedProperty(r, "contours.coloring").get() || "heatmap",
                T = b[_];
            return void (T ? (T[2].push(x), T[0] !== w && (T[0] = !1, i.warn(["Ignoring coloraxis:", _, "setting", "as it is linked to incompatible colorscales."].join(" ")))) : b[_] = [w, r, [x]]);
          }
        }

        var k = g[d + "min"],
            M = g[d + "max"],
            A = n(k) && n(M) && k < M;
        f(p + d + "auto", !A) ? f(p + d + "mid") : (f(p + d + "min"), f(p + d + "max"));
        var S,
            E,
            L = g.colorscale,
            C = y.colorscale;
        (void 0 !== L && (S = !s(L)), void 0 !== C && (S = !s(C)), f(p + "autocolorscale", S), f(p + "colorscale"), f(p + "reversescale"), "marker.line." !== p) && (p && m && (E = a(g)), f(p + "showscale", E) && (p && y && (v._template = y), o(g, v, u)));
      };
    }, {
      "../../lib": 795,
      "../../registry": 923,
      "../colorbar/defaults": 661,
      "../colorbar/has_colorbar": 663,
      "./scales": 673,
      "fast-isnumeric": 240
    }],
    669: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("tinycolor2"),
          a = t("fast-isnumeric"),
          o = t("../../lib"),
          s = t("../color"),
          l = t("./scales").isValid;
      var c = ["showscale", "autocolorscale", "colorscale", "reversescale", "colorbar"],
          u = ["min", "max", "mid", "auto"];

      function f(t) {
        var e,
            r,
            n,
            i = t._colorAx,
            a = i || t,
            o = {};

        for (r = 0; r < c.length; r++) {
          o[n = c[r]] = a[n];
        }

        if (i) for (e = "c", r = 0; r < u.length; r++) {
          o[n = u[r]] = a["c" + n];
        } else {
          var s;

          for (r = 0; r < u.length; r++) {
            ((s = "c" + (n = u[r])) in a || (s = "z" + n) in a) && (o[n] = a[s]);
          }

          e = s.charAt(0);
        }
        return o._sync = function (t, r) {
          var n = -1 !== u.indexOf(t) ? e + t : t;
          a[n] = a["_" + n] = r;
        }, o;
      }

      function h(t) {
        for (var e = f(t), r = e.min, n = e.max, i = e.reversescale ? p(e.colorscale) : e.colorscale, a = i.length, o = new Array(a), s = new Array(a), l = 0; l < a; l++) {
          var c = i[l];
          o[l] = r + c[0] * (n - r), s[l] = c[1];
        }

        return {
          domain: o,
          range: s
        };
      }

      function p(t) {
        for (var e = t.length, r = new Array(e), n = e - 1, i = 0; n >= 0; n--, i++) {
          var a = t[n];
          r[i] = [1 - a[0], a[1]];
        }

        return r;
      }

      function d(t, e) {
        e = e || {};

        for (var r = t.domain, o = t.range, l = o.length, c = new Array(l), u = 0; u < l; u++) {
          var f = i(o[u]).toRgb();
          c[u] = [f.r, f.g, f.b, f.a];
        }

        var h,
            p = n.scale.linear().domain(r).range(c).clamp(!0),
            d = e.noNumericCheck,
            g = e.returnArray;
        return (h = d && g ? p : d ? function (t) {
          return m(p(t));
        } : g ? function (t) {
          return a(t) ? p(t) : i(t).isValid() ? t : s.defaultLine;
        } : function (t) {
          return a(t) ? m(p(t)) : i(t).isValid() ? t : s.defaultLine;
        }).domain = p.domain, h.range = function () {
          return o;
        }, h;
      }

      function m(t) {
        var e = {
          r: t[0],
          g: t[1],
          b: t[2],
          a: t[3]
        };
        return i(e).toRgbString();
      }

      e.exports = {
        hasColorscale: function hasColorscale(t, e, r) {
          var n = e ? o.nestedProperty(t, e).get() || {} : t,
              i = n[r || "color"],
              s = !1;
          if (o.isArrayOrTypedArray(i)) for (var c = 0; c < i.length; c++) {
            if (a(i[c])) {
              s = !0;
              break;
            }
          }
          return o.isPlainObject(n) && (s || !0 === n.showscale || a(n.cmin) && a(n.cmax) || l(n.colorscale) || o.isPlainObject(n.colorbar));
        },
        extractOpts: f,
        extractScale: h,
        flipScale: p,
        makeColorScaleFunc: d,
        makeColorScaleFuncFromTrace: function makeColorScaleFuncFromTrace(t, e) {
          return d(h(t), e);
        }
      };
    }, {
      "../../lib": 795,
      "../color": 658,
      "./scales": 673,
      "@plotly/d3": 57,
      "fast-isnumeric": 240,
      tinycolor2: 590
    }],
    670: [function (t, e, r) {
      "use strict";

      var n = t("./scales"),
          i = t("./helpers");
      e.exports = {
        moduleType: "component",
        name: "colorscale",
        attributes: t("./attributes"),
        layoutAttributes: t("./layout_attributes"),
        supplyLayoutDefaults: t("./layout_defaults"),
        handleDefaults: t("./defaults"),
        crossTraceDefaults: t("./cross_trace_defaults"),
        calc: t("./calc"),
        scales: n.scales,
        defaultScale: n.defaultScale,
        getScale: n.get,
        isValidScale: n.isValid,
        hasColorscale: i.hasColorscale,
        extractOpts: i.extractOpts,
        extractScale: i.extractScale,
        flipScale: i.flipScale,
        makeColorScaleFunc: i.makeColorScaleFunc,
        makeColorScaleFuncFromTrace: i.makeColorScaleFuncFromTrace
      };
    }, {
      "./attributes": 665,
      "./calc": 666,
      "./cross_trace_defaults": 667,
      "./defaults": 668,
      "./helpers": 669,
      "./layout_attributes": 671,
      "./layout_defaults": 672,
      "./scales": 673
    }],
    671: [function (t, e, r) {
      "use strict";

      var n = t("../../lib/extend").extendFlat,
          i = t("./attributes"),
          a = t("./scales").scales;
      e.exports = {
        editType: "calc",
        colorscale: {
          editType: "calc",
          sequential: {
            valType: "colorscale",
            dflt: a.Reds,
            editType: "calc"
          },
          sequentialminus: {
            valType: "colorscale",
            dflt: a.Blues,
            editType: "calc"
          },
          diverging: {
            valType: "colorscale",
            dflt: a.RdBu,
            editType: "calc"
          }
        },
        coloraxis: n({
          _isSubplotObj: !0,
          editType: "calc"
        }, i("", {
          colorAttr: "corresponding trace color array(s)",
          noColorAxis: !0,
          showScaleDflt: !0
        }))
      };
    }, {
      "../../lib/extend": 785,
      "./attributes": 665,
      "./scales": 673
    }],
    672: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../plot_api/plot_template"),
          a = t("./layout_attributes"),
          o = t("./defaults");

      e.exports = function (t, e) {
        function r(r, i) {
          return n.coerce(t, e, a, r, i);
        }

        r("colorscale.sequential"), r("colorscale.sequentialminus"), r("colorscale.diverging");
        var s,
            l,
            c = e._colorAxes;

        function u(t, e) {
          return n.coerce(s, l, a.coloraxis, t, e);
        }

        for (var f in c) {
          var h = c[f];
          if (h[0]) s = t[f] || {}, (l = i.newContainer(e, f, "coloraxis"))._name = f, o(s, l, e, u, {
            prefix: "",
            cLetter: "c"
          });else {
            for (var p = 0; p < h[2].length; p++) {
              h[2][p]();
            }

            delete e._colorAxes[f];
          }
        }
      };
    }, {
      "../../lib": 795,
      "../../plot_api/plot_template": 834,
      "./defaults": 668,
      "./layout_attributes": 671
    }],
    673: [function (t, e, r) {
      "use strict";

      var n = t("tinycolor2"),
          i = {
        Greys: [[0, "rgb(0,0,0)"], [1, "rgb(255,255,255)"]],
        YlGnBu: [[0, "rgb(8,29,88)"], [.125, "rgb(37,52,148)"], [.25, "rgb(34,94,168)"], [.375, "rgb(29,145,192)"], [.5, "rgb(65,182,196)"], [.625, "rgb(127,205,187)"], [.75, "rgb(199,233,180)"], [.875, "rgb(237,248,217)"], [1, "rgb(255,255,217)"]],
        Greens: [[0, "rgb(0,68,27)"], [.125, "rgb(0,109,44)"], [.25, "rgb(35,139,69)"], [.375, "rgb(65,171,93)"], [.5, "rgb(116,196,118)"], [.625, "rgb(161,217,155)"], [.75, "rgb(199,233,192)"], [.875, "rgb(229,245,224)"], [1, "rgb(247,252,245)"]],
        YlOrRd: [[0, "rgb(128,0,38)"], [.125, "rgb(189,0,38)"], [.25, "rgb(227,26,28)"], [.375, "rgb(252,78,42)"], [.5, "rgb(253,141,60)"], [.625, "rgb(254,178,76)"], [.75, "rgb(254,217,118)"], [.875, "rgb(255,237,160)"], [1, "rgb(255,255,204)"]],
        Bluered: [[0, "rgb(0,0,255)"], [1, "rgb(255,0,0)"]],
        RdBu: [[0, "rgb(5,10,172)"], [.35, "rgb(106,137,247)"], [.5, "rgb(190,190,190)"], [.6, "rgb(220,170,132)"], [.7, "rgb(230,145,90)"], [1, "rgb(178,10,28)"]],
        Reds: [[0, "rgb(220,220,220)"], [.2, "rgb(245,195,157)"], [.4, "rgb(245,160,105)"], [1, "rgb(178,10,28)"]],
        Blues: [[0, "rgb(5,10,172)"], [.35, "rgb(40,60,190)"], [.5, "rgb(70,100,245)"], [.6, "rgb(90,120,245)"], [.7, "rgb(106,137,247)"], [1, "rgb(220,220,220)"]],
        Picnic: [[0, "rgb(0,0,255)"], [.1, "rgb(51,153,255)"], [.2, "rgb(102,204,255)"], [.3, "rgb(153,204,255)"], [.4, "rgb(204,204,255)"], [.5, "rgb(255,255,255)"], [.6, "rgb(255,204,255)"], [.7, "rgb(255,153,255)"], [.8, "rgb(255,102,204)"], [.9, "rgb(255,102,102)"], [1, "rgb(255,0,0)"]],
        Rainbow: [[0, "rgb(150,0,90)"], [.125, "rgb(0,0,200)"], [.25, "rgb(0,25,255)"], [.375, "rgb(0,152,255)"], [.5, "rgb(44,255,150)"], [.625, "rgb(151,255,0)"], [.75, "rgb(255,234,0)"], [.875, "rgb(255,111,0)"], [1, "rgb(255,0,0)"]],
        Portland: [[0, "rgb(12,51,131)"], [.25, "rgb(10,136,186)"], [.5, "rgb(242,211,56)"], [.75, "rgb(242,143,56)"], [1, "rgb(217,30,30)"]],
        Jet: [[0, "rgb(0,0,131)"], [.125, "rgb(0,60,170)"], [.375, "rgb(5,255,255)"], [.625, "rgb(255,255,0)"], [.875, "rgb(250,0,0)"], [1, "rgb(128,0,0)"]],
        Hot: [[0, "rgb(0,0,0)"], [.3, "rgb(230,0,0)"], [.6, "rgb(255,210,0)"], [1, "rgb(255,255,255)"]],
        Blackbody: [[0, "rgb(0,0,0)"], [.2, "rgb(230,0,0)"], [.4, "rgb(230,210,0)"], [.7, "rgb(255,255,255)"], [1, "rgb(160,200,255)"]],
        Earth: [[0, "rgb(0,0,130)"], [.1, "rgb(0,180,180)"], [.2, "rgb(40,210,40)"], [.4, "rgb(230,230,50)"], [.6, "rgb(120,70,20)"], [1, "rgb(255,255,255)"]],
        Electric: [[0, "rgb(0,0,0)"], [.15, "rgb(30,0,100)"], [.4, "rgb(120,0,100)"], [.6, "rgb(160,90,0)"], [.8, "rgb(230,200,0)"], [1, "rgb(255,250,220)"]],
        Viridis: [[0, "#440154"], [.06274509803921569, "#48186a"], [.12549019607843137, "#472d7b"], [.18823529411764706, "#424086"], [.25098039215686274, "#3b528b"], [.3137254901960784, "#33638d"], [.3764705882352941, "#2c728e"], [.4392156862745098, "#26828e"], [.5019607843137255, "#21918c"], [.5647058823529412, "#1fa088"], [.6274509803921569, "#28ae80"], [.6901960784313725, "#3fbc73"], [.7529411764705882, "#5ec962"], [.8156862745098039, "#84d44b"], [.8784313725490196, "#addc30"], [.9411764705882353, "#d8e219"], [1, "#fde725"]],
        Cividis: [[0, "rgb(0,32,76)"], [.058824, "rgb(0,42,102)"], [.117647, "rgb(0,52,110)"], [.176471, "rgb(39,63,108)"], [.235294, "rgb(60,74,107)"], [.294118, "rgb(76,85,107)"], [.352941, "rgb(91,95,109)"], [.411765, "rgb(104,106,112)"], [.470588, "rgb(117,117,117)"], [.529412, "rgb(131,129,120)"], [.588235, "rgb(146,140,120)"], [.647059, "rgb(161,152,118)"], [.705882, "rgb(176,165,114)"], [.764706, "rgb(192,177,109)"], [.823529, "rgb(209,191,102)"], [.882353, "rgb(225,204,92)"], [.941176, "rgb(243,219,79)"], [1, "rgb(255,233,69)"]]
      },
          a = i.RdBu;

      function o(t) {
        var e = 0;
        if (!Array.isArray(t) || t.length < 2) return !1;
        if (!t[0] || !t[t.length - 1]) return !1;
        if (0 != +t[0][0] || 1 != +t[t.length - 1][0]) return !1;

        for (var r = 0; r < t.length; r++) {
          var i = t[r];
          if (2 !== i.length || +i[0] < e || !n(i[1]).isValid()) return !1;
          e = +i[0];
        }

        return !0;
      }

      e.exports = {
        scales: i,
        defaultScale: a,
        get: function get(t, e) {
          if (e || (e = a), !t) return e;

          function r() {
            try {
              t = i[t] || JSON.parse(t);
            } catch (r) {
              t = e;
            }
          }

          return "string" == typeof t && (r(), "string" == typeof t && r()), o(t) ? t : e;
        },
        isValid: function isValid(t) {
          return void 0 !== i[t] || o(t);
        }
      };
    }, {
      tinycolor2: 590
    }],
    674: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, n, i) {
        var a = (t - r) / (n - r),
            o = a + e / (n - r),
            s = (a + o) / 2;
        return "left" === i || "bottom" === i ? a : "center" === i || "middle" === i ? s : "right" === i || "top" === i ? o : a < 2 / 3 - s ? a : o > 4 / 3 - s ? o : s;
      };
    }, {}],
    675: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = [["sw-resize", "s-resize", "se-resize"], ["w-resize", "move", "e-resize"], ["nw-resize", "n-resize", "ne-resize"]];

      e.exports = function (t, e, r, a) {
        return t = "left" === r ? 0 : "center" === r ? 1 : "right" === r ? 2 : n.constrain(Math.floor(3 * t), 0, 2), e = "bottom" === a ? 0 : "middle" === a ? 1 : "top" === a ? 2 : n.constrain(Math.floor(3 * e), 0, 2), i[e][t];
      };
    }, {
      "../../lib": 795
    }],
    676: [function (t, e, r) {
      "use strict";

      r.selectMode = function (t) {
        return "lasso" === t || "select" === t;
      }, r.drawMode = function (t) {
        return "drawclosedpath" === t || "drawopenpath" === t || "drawline" === t || "drawrect" === t || "drawcircle" === t;
      }, r.openMode = function (t) {
        return "drawline" === t || "drawopenpath" === t;
      }, r.rectMode = function (t) {
        return "select" === t || "drawline" === t || "drawrect" === t || "drawcircle" === t;
      }, r.freeMode = function (t) {
        return "lasso" === t || "drawclosedpath" === t || "drawopenpath" === t;
      }, r.selectingOrDrawing = function (t) {
        return r.freeMode(t) || r.rectMode(t);
      };
    }, {}],
    677: [function (t, e, r) {
      "use strict";

      var n = t("mouse-event-offset"),
          i = t("has-hover"),
          a = t("has-passive-events"),
          o = t("../../lib").removeElement,
          s = t("../../plots/cartesian/constants"),
          l = e.exports = {};
      l.align = t("./align"), l.getCursor = t("./cursor");
      var c = t("./unhover");

      function u() {
        var t = document.createElement("div");
        t.className = "dragcover";
        var e = t.style;
        return e.position = "fixed", e.left = 0, e.right = 0, e.top = 0, e.bottom = 0, e.zIndex = 999999999, e.background = "none", document.body.appendChild(t), t;
      }

      function f(t) {
        return n(t.changedTouches ? t.changedTouches[0] : t, document.body);
      }

      l.unhover = c.wrapped, l.unhoverRaw = c.raw, l.init = function (t) {
        var e,
            r,
            n,
            c,
            h,
            p,
            d,
            m,
            g = t.gd,
            v = 1,
            y = g._context.doubleClickDelay,
            x = t.element;
        g._mouseDownTime || (g._mouseDownTime = 0), x.style.pointerEvents = "all", x.onmousedown = _, a ? (x._ontouchstart && x.removeEventListener("touchstart", x._ontouchstart), x._ontouchstart = _, x.addEventListener("touchstart", _, {
          passive: !1
        })) : x.ontouchstart = _;

        var b = t.clampFn || function (t, e, r) {
          return Math.abs(t) < r && (t = 0), Math.abs(e) < r && (e = 0), [t, e];
        };

        function _(a) {
          g._dragged = !1, g._dragging = !0;
          var o = f(a);
          e = o[0], r = o[1], d = a.target, p = a, m = 2 === a.buttons || a.ctrlKey, void 0 === a.clientX && void 0 === a.clientY && (a.clientX = e, a.clientY = r), (n = new Date().getTime()) - g._mouseDownTime < y ? v += 1 : (v = 1, g._mouseDownTime = n), t.prepFn && t.prepFn(a, e, r), i && !m ? (h = u()).style.cursor = window.getComputedStyle(x).cursor : i || (h = document, c = window.getComputedStyle(document.documentElement).cursor, document.documentElement.style.cursor = window.getComputedStyle(x).cursor), document.addEventListener("mouseup", T), document.addEventListener("touchend", T), !1 !== t.dragmode && (a.preventDefault(), document.addEventListener("mousemove", w), document.addEventListener("touchmove", w, {
            passive: !1
          }));
        }

        function w(n) {
          n.preventDefault();
          var i = f(n),
              a = t.minDrag || s.MINDRAG,
              o = b(i[0] - e, i[1] - r, a),
              c = o[0],
              u = o[1];
          (c || u) && (g._dragged = !0, l.unhover(g, n)), g._dragged && t.moveFn && !m && (g._dragdata = {
            element: x,
            dx: c,
            dy: u
          }, t.moveFn(c, u));
        }

        function T(e) {
          if (delete g._dragdata, !1 !== t.dragmode && (e.preventDefault(), document.removeEventListener("mousemove", w), document.removeEventListener("touchmove", w)), document.removeEventListener("mouseup", T), document.removeEventListener("touchend", T), i ? o(h) : c && (h.documentElement.style.cursor = c, c = null), g._dragging) {
            if (g._dragging = !1, new Date().getTime() - g._mouseDownTime > y && (v = Math.max(v - 1, 1)), g._dragged) t.doneFn && t.doneFn();else if (t.clickFn && t.clickFn(v, p), !m) {
              var r;

              try {
                r = new MouseEvent("click", e);
              } catch (t) {
                var n = f(e);
                (r = document.createEvent("MouseEvents")).initMouseEvent("click", e.bubbles, e.cancelable, e.view, e.detail, e.screenX, e.screenY, n[0], n[1], e.ctrlKey, e.altKey, e.shiftKey, e.metaKey, e.button, e.relatedTarget);
              }

              d.dispatchEvent(r);
            }
            g._dragging = !1, g._dragged = !1;
          } else g._dragged = !1;
        }
      }, l.coverSlip = u;
    }, {
      "../../lib": 795,
      "../../plots/cartesian/constants": 851,
      "./align": 674,
      "./cursor": 675,
      "./unhover": 678,
      "has-hover": 434,
      "has-passive-events": 435,
      "mouse-event-offset": 463
    }],
    678: [function (t, e, r) {
      "use strict";

      var n = t("../../lib/events"),
          i = t("../../lib/throttle"),
          a = t("../../lib/dom").getGraphDiv,
          o = t("../fx/constants"),
          s = e.exports = {};
      s.wrapped = function (t, e, r) {
        (t = a(t))._fullLayout && i.clear(t._fullLayout._uid + o.HOVERID), s.raw(t, e, r);
      }, s.raw = function (t, e) {
        var r = t._fullLayout,
            i = t._hoverdata;
        e || (e = {}), e.target && !t._dragged && !1 === n.triggerHandler(t, "plotly_beforehover", e) || (r._hoverlayer.selectAll("g").remove(), r._hoverlayer.selectAll("line").remove(), r._hoverlayer.selectAll("circle").remove(), t._hoverdata = void 0, e.target && i && t.emit("plotly_unhover", {
          event: e,
          points: i
        }));
      };
    }, {
      "../../lib/dom": 783,
      "../../lib/events": 784,
      "../../lib/throttle": 821,
      "../fx/constants": 692
    }],
    679: [function (t, e, r) {
      "use strict";

      r.dash = {
        valType: "string",
        values: ["solid", "dot", "dash", "longdash", "dashdot", "longdashdot"],
        dflt: "solid",
        editType: "style"
      }, r.pattern = {
        shape: {
          valType: "enumerated",
          values: ["", "/", "\\", "x", "-", "|", "+", "."],
          dflt: "",
          arrayOk: !0,
          editType: "style"
        },
        bgcolor: {
          valType: "color",
          arrayOk: !0,
          editType: "style"
        },
        size: {
          valType: "number",
          min: 0,
          dflt: 8,
          arrayOk: !0,
          editType: "style"
        },
        solidity: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: .3,
          arrayOk: !0,
          editType: "style"
        },
        editType: "style"
      };
    }, {}],
    680: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("fast-isnumeric"),
          a = t("tinycolor2"),
          o = t("../../registry"),
          s = t("../color"),
          l = t("../colorscale"),
          c = t("../../lib"),
          u = c.strTranslate,
          f = t("../../lib/svg_text_utils"),
          h = t("../../constants/xmlns_namespaces"),
          p = t("../../constants/alignment").LINE_SPACING,
          d = t("../../constants/interactions").DESELECTDIM,
          m = t("../../traces/scatter/subtypes"),
          g = t("../../traces/scatter/make_bubble_size_func"),
          v = t("../../components/fx/helpers").appendArrayPointValue,
          y = e.exports = {};
      y.font = function (t, e, r, n) {
        c.isPlainObject(e) && (n = e.color, r = e.size, e = e.family), e && t.style("font-family", e), r + 1 && t.style("font-size", r + "px"), n && t.call(s.fill, n);
      }, y.setPosition = function (t, e, r) {
        t.attr("x", e).attr("y", r);
      }, y.setSize = function (t, e, r) {
        t.attr("width", e).attr("height", r);
      }, y.setRect = function (t, e, r, n, i) {
        t.call(y.setPosition, e, r).call(y.setSize, n, i);
      }, y.translatePoint = function (t, e, r, n) {
        var a = r.c2p(t.x),
            o = n.c2p(t.y);
        return !!(i(a) && i(o) && e.node()) && ("text" === e.node().nodeName ? e.attr("x", a).attr("y", o) : e.attr("transform", u(a, o)), !0);
      }, y.translatePoints = function (t, e, r) {
        t.each(function (t) {
          var i = n.select(this);
          y.translatePoint(t, i, e, r);
        });
      }, y.hideOutsideRangePoint = function (t, e, r, n, i, a) {
        e.attr("display", r.isPtWithinRange(t, i) && n.isPtWithinRange(t, a) ? null : "none");
      }, y.hideOutsideRangePoints = function (t, e) {
        if (e._hasClipOnAxisFalse) {
          var r = e.xaxis,
              i = e.yaxis;
          t.each(function (e) {
            var a = e[0].trace,
                s = a.xcalendar,
                l = a.ycalendar,
                c = o.traceIs(a, "bar-like") ? ".bartext" : ".point,.textpoint";
            t.selectAll(c).each(function (t) {
              y.hideOutsideRangePoint(t, n.select(this), r, i, s, l);
            });
          });
        }
      }, y.crispRound = function (t, e, r) {
        return e && i(e) ? t._context.staticPlot ? e : e < 1 ? 1 : Math.round(e) : r || 0;
      }, y.singleLineStyle = function (t, e, r, n, i) {
        e.style("fill", "none");
        var a = (((t || [])[0] || {}).trace || {}).line || {},
            o = r || a.width || 0,
            l = i || a.dash || "";
        s.stroke(e, n || a.color), y.dashLine(e, l, o);
      }, y.lineGroupStyle = function (t, e, r, i) {
        t.style("fill", "none").each(function (t) {
          var a = (((t || [])[0] || {}).trace || {}).line || {},
              o = e || a.width || 0,
              l = i || a.dash || "";
          n.select(this).call(s.stroke, r || a.color).call(y.dashLine, l, o);
        });
      }, y.dashLine = function (t, e, r) {
        r = +r || 0, e = y.dashStyle(e, r), t.style({
          "stroke-dasharray": e,
          "stroke-width": r + "px"
        });
      }, y.dashStyle = function (t, e) {
        e = +e || 1;
        var r = Math.max(e, 3);
        return "solid" === t ? t = "" : "dot" === t ? t = r + "px," + r + "px" : "dash" === t ? t = 3 * r + "px," + 3 * r + "px" : "longdash" === t ? t = 5 * r + "px," + 5 * r + "px" : "dashdot" === t ? t = 3 * r + "px," + r + "px," + r + "px," + r + "px" : "longdashdot" === t && (t = 5 * r + "px," + 2 * r + "px," + r + "px," + 2 * r + "px"), t;
      }, y.singleFillStyle = function (t) {
        var e = (((n.select(t.node()).data()[0] || [])[0] || {}).trace || {}).fillcolor;
        e && t.call(s.fill, e);
      }, y.fillGroupStyle = function (t) {
        t.style("stroke-width", 0).each(function (t) {
          var e = n.select(this);
          t[0].trace && e.call(s.fill, t[0].trace.fillcolor);
        });
      };
      var x = t("./symbol_defs");
      y.symbolNames = [], y.symbolFuncs = [], y.symbolNeedLines = {}, y.symbolNoDot = {}, y.symbolNoFill = {}, y.symbolList = [], Object.keys(x).forEach(function (t) {
        var e = x[t],
            r = e.n;
        y.symbolList.push(r, String(r), t, r + 100, String(r + 100), t + "-open"), y.symbolNames[r] = t, y.symbolFuncs[r] = e.f, e.needLine && (y.symbolNeedLines[r] = !0), e.noDot ? y.symbolNoDot[r] = !0 : y.symbolList.push(r + 200, String(r + 200), t + "-dot", r + 300, String(r + 300), t + "-open-dot"), e.noFill && (y.symbolNoFill[r] = !0);
      });
      var b = y.symbolNames.length;

      function _(t, e) {
        var r = t % 100;
        return y.symbolFuncs[r](e) + (t >= 200 ? "M0,0.5L0.5,0L0,-0.5L-0.5,0Z" : "");
      }

      y.symbolNumber = function (t) {
        if (i(t)) t = +t;else if ("string" == typeof t) {
          var e = 0;
          t.indexOf("-open") > 0 && (e = 100, t = t.replace("-open", "")), t.indexOf("-dot") > 0 && (e += 200, t = t.replace("-dot", "")), (t = y.symbolNames.indexOf(t)) >= 0 && (t += e);
        }
        return t % 100 >= b || t >= 400 ? 0 : Math.floor(Math.max(t, 0));
      };

      var w = {
        x1: 1,
        x2: 0,
        y1: 0,
        y2: 0
      },
          T = {
        x1: 0,
        x2: 0,
        y1: 1,
        y2: 0
      },
          k = n.format("~.1f"),
          M = {
        radial: {
          node: "radialGradient"
        },
        radialreversed: {
          node: "radialGradient",
          reversed: !0
        },
        horizontal: {
          node: "linearGradient",
          attrs: w
        },
        horizontalreversed: {
          node: "linearGradient",
          attrs: w,
          reversed: !0
        },
        vertical: {
          node: "linearGradient",
          attrs: T
        },
        verticalreversed: {
          node: "linearGradient",
          attrs: T,
          reversed: !0
        }
      };
      y.gradient = function (t, e, r, i, o, l) {
        for (var u = o.length, f = M[i], h = new Array(u), p = 0; p < u; p++) {
          f.reversed ? h[u - 1 - p] = [k(100 * (1 - o[p][0])), o[p][1]] : h[p] = [k(100 * o[p][0]), o[p][1]];
        }

        var d = e._fullLayout,
            m = "g" + d._uid + "-" + r,
            g = d._defs.select(".gradients").selectAll("#" + m).data([i + h.join(";")], c.identity);

        g.exit().remove(), g.enter().append(f.node).each(function () {
          var t = n.select(this);
          f.attrs && t.attr(f.attrs), t.attr("id", m);
          var e = t.selectAll("stop").data(h);
          e.exit().remove(), e.enter().append("stop"), e.each(function (t) {
            var e = a(t[1]);
            n.select(this).attr({
              offset: t[0] + "%",
              "stop-color": s.tinyRGB(e),
              "stop-opacity": e.getAlpha()
            });
          });
        }), t.style(l, z(m, e)).style(l + "-opacity", null);

        var v = function v(t) {
          return "." + t.attr("class").replace(/\s/g, ".");
        },
            y = v(n.select(t.node().parentNode)) + ">" + v(t);

        d._gradientUrlQueryParts[y] = 1;
      }, y.pattern = function (t, e, r, i, a, o, s, l, u) {
        var f,
            h,
            p,
            d,
            m,
            g,
            v,
            y,
            x,
            b,
            _,
            w = e._fullLayout,
            T = "p" + w._uid + "-" + r,
            k = {};

        switch (i) {
          case "/":
            f = s * Math.sqrt(2), h = s * Math.sqrt(2), g = "path", k = {
              d: p = "M-" + f / 4 + "," + h / 4 + "l" + f / 2 + ",-" + h / 2 + "M0," + h + "L" + f + ",0M" + f / 4 * 3 + "," + h / 4 * 5 + "l" + f / 2 + ",-" + h / 2,
              stroke: o,
              "stroke-width": (d = l * s) + "px"
            };
            break;

          case "\\":
            f = s * Math.sqrt(2), h = s * Math.sqrt(2), g = "path", k = {
              d: p = "M" + f / 4 * 3 + ",-" + h / 4 + "l" + f / 2 + "," + h / 2 + "M0,0L" + f + "," + h + "M-" + f / 4 + "," + h / 4 * 3 + "l" + f / 2 + "," + h / 2,
              stroke: o,
              "stroke-width": (d = l * s) + "px"
            };
            break;

          case "x":
            f = s * Math.sqrt(2), h = s * Math.sqrt(2), p = "M-" + f / 4 + "," + h / 4 + "l" + f / 2 + ",-" + h / 2 + "M0," + h + "L" + f + ",0M" + f / 4 * 3 + "," + h / 4 * 5 + "l" + f / 2 + ",-" + h / 2 + "M" + f / 4 * 3 + ",-" + h / 4 + "l" + f / 2 + "," + h / 2 + "M0,0L" + f + "," + h + "M-" + f / 4 + "," + h / 4 * 3 + "l" + f / 2 + "," + h / 2, d = s - s * Math.sqrt(1 - l), g = "path", k = {
              d: p,
              stroke: o,
              "stroke-width": d + "px"
            };
            break;

          case "|":
            g = "path", g = "path", k = {
              d: p = "M" + (f = s) / 2 + ",0L" + f / 2 + "," + (h = s),
              stroke: o,
              "stroke-width": (d = l * s) + "px"
            };
            break;

          case "-":
            g = "path", g = "path", k = {
              d: p = "M0," + (h = s) / 2 + "L" + (f = s) + "," + h / 2,
              stroke: o,
              "stroke-width": (d = l * s) + "px"
            };
            break;

          case "+":
            g = "path", p = "M" + (f = s) / 2 + ",0L" + f / 2 + "," + (h = s) + "M0," + h / 2 + "L" + f + "," + h / 2, d = s - s * Math.sqrt(1 - l), g = "path", k = {
              d: p,
              stroke: o,
              "stroke-width": d + "px"
            };
            break;

          case ".":
            f = s, h = s, l < Math.PI / 4 ? m = Math.sqrt(l * s * s / Math.PI) : (v = l, y = Math.PI / 4, x = 1, b = s / 2, _ = s / Math.sqrt(2), m = b + (_ - b) * (v - y) / (x - y)), g = "circle", k = {
              cx: f / 2,
              cy: h / 2,
              r: m,
              fill: o
            };
        }

        var M = w._defs.select(".patterns").selectAll("#" + T).data([i + ";" + a + ";" + o + ";" + s + ";" + l], c.identity);

        M.exit().remove(), M.enter().append("pattern").each(function () {
          var t = n.select(this);

          if (t.attr({
            id: T,
            width: f + "px",
            height: h + "px",
            patternUnits: "userSpaceOnUse"
          }), a) {
            var e = t.selectAll("rect").data([0]);
            e.exit().remove(), e.enter().append("rect").attr({
              width: f + "px",
              height: h + "px",
              fill: a
            });
          }

          var r = t.selectAll(g).data([0]);
          r.exit().remove(), r.enter().append(g).attr(k);
        }), t.style(u, z(T, e)).style(u + "-opacity", null), t.classed("pattern_filled", !0);
        var A = "." + n.select(t.node().parentNode).attr("class").replace(/\s/g, ".") + ">.pattern_filled";
        w._patternUrlQueryParts[A] = 1;
      }, y.initGradients = function (t) {
        var e = t._fullLayout;
        c.ensureSingle(e._defs, "g", "gradients").selectAll("linearGradient,radialGradient").remove(), e._gradientUrlQueryParts = {};
      }, y.initPatterns = function (t) {
        var e = t._fullLayout;
        c.ensureSingle(e._defs, "g", "patterns").selectAll("pattern").remove(), e._patternUrlQueryParts = {};
      }, y.getPatternAttr = function (t, e, r) {
        return t && c.isArrayOrTypedArray(t) ? e < t.length ? t[e] : r : t;
      }, y.pointStyle = function (t, e, r) {
        if (t.size()) {
          var i = y.makePointStyleFns(e);
          t.each(function (t) {
            y.singlePointStyle(t, n.select(this), e, i, r);
          });
        }
      }, y.singlePointStyle = function (t, e, r, n, i) {
        var a = r.marker,
            o = a.line;

        if (e.style("opacity", n.selectedOpacityFn ? n.selectedOpacityFn(t) : void 0 === t.mo ? a.opacity : t.mo), n.ms2mrc) {
          var l;
          l = "various" === t.ms || "various" === a.size ? 3 : n.ms2mrc(t.ms), t.mrc = l, n.selectedSizeFn && (l = t.mrc = n.selectedSizeFn(t));
          var u = y.symbolNumber(t.mx || a.symbol) || 0;
          t.om = u % 200 >= 100, e.attr("d", _(u, l));
        }

        var f,
            h,
            p,
            d = !1;
        if (t.so) p = o.outlierwidth, h = o.outliercolor, f = a.outliercolor;else {
          var m = (o || {}).width;
          p = (t.mlw + 1 || m + 1 || (t.trace ? (t.trace.marker.line || {}).width : 0) + 1) - 1 || 0, h = "mlc" in t ? t.mlcc = n.lineScale(t.mlc) : c.isArrayOrTypedArray(o.color) ? s.defaultLine : o.color, c.isArrayOrTypedArray(a.color) && (f = s.defaultLine, d = !0), f = "mc" in t ? t.mcc = n.markerScale(t.mc) : a.color || "rgba(0,0,0,0)", n.selectedColorFn && (f = n.selectedColorFn(t));
        }
        if (t.om) e.call(s.stroke, f).style({
          "stroke-width": (p || 1) + "px",
          fill: "none"
        });else {
          e.style("stroke-width", (t.isBlank ? 0 : p) + "px");
          var g = a.gradient,
              v = t.mgt;
          v ? d = !0 : v = g && g.type, c.isArrayOrTypedArray(v) && (v = v[0], M[v] || (v = 0));
          var x = a.pattern,
              b = x && y.getPatternAttr(x.shape, t.i, "");

          if (v && "none" !== v) {
            var w = t.mgc;
            w ? d = !0 : w = g.color;
            var T = r.uid;
            d && (T += "-" + t.i), y.gradient(e, i, T, v, [[0, w], [1, f]], "fill");
          } else if (b) {
            var k = y.getPatternAttr(x.bgcolor, t.i, null),
                A = y.getPatternAttr(x.size, t.i, 8),
                S = y.getPatternAttr(x.solidity, t.i, .3),
                E = c.isArrayOrTypedArray(x.shape) || c.isArrayOrTypedArray(x.bgcolor) || c.isArrayOrTypedArray(x.size) || c.isArrayOrTypedArray(x.solidity),
                L = r.uid;
            E && (L += "-" + t.i), y.pattern(e, i, L, b, k, f, A, S, "fill");
          } else s.fill(e, f);

          p && s.stroke(e, h);
        }
      }, y.makePointStyleFns = function (t) {
        var e = {},
            r = t.marker;
        return e.markerScale = y.tryColorscale(r, ""), e.lineScale = y.tryColorscale(r, "line"), o.traceIs(t, "symbols") && (e.ms2mrc = m.isBubble(t) ? g(t) : function () {
          return (r.size || 6) / 2;
        }), t.selectedpoints && c.extendFlat(e, y.makeSelectedPointStyleFns(t)), e;
      }, y.makeSelectedPointStyleFns = function (t) {
        var e = {},
            r = t.selected || {},
            n = t.unselected || {},
            i = t.marker || {},
            a = r.marker || {},
            s = n.marker || {},
            l = i.opacity,
            u = a.opacity,
            f = s.opacity,
            h = void 0 !== u,
            p = void 0 !== f;
        (c.isArrayOrTypedArray(l) || h || p) && (e.selectedOpacityFn = function (t) {
          var e = void 0 === t.mo ? i.opacity : t.mo;
          return t.selected ? h ? u : e : p ? f : d * e;
        });
        var m = i.color,
            g = a.color,
            v = s.color;
        (g || v) && (e.selectedColorFn = function (t) {
          var e = t.mcc || m;
          return t.selected ? g || e : v || e;
        });

        var y = i.size,
            x = a.size,
            b = s.size,
            _ = void 0 !== x,
            w = void 0 !== b;

        return o.traceIs(t, "symbols") && (_ || w) && (e.selectedSizeFn = function (t) {
          var e = t.mrc || y / 2;
          return t.selected ? _ ? x / 2 : e : w ? b / 2 : e;
        }), e;
      }, y.makeSelectedTextStyleFns = function (t) {
        var e = {},
            r = t.selected || {},
            n = t.unselected || {},
            i = t.textfont || {},
            a = r.textfont || {},
            o = n.textfont || {},
            l = i.color,
            c = a.color,
            u = o.color;
        return e.selectedTextColorFn = function (t) {
          var e = t.tc || l;
          return t.selected ? c || e : u || (c ? e : s.addOpacity(e, d));
        }, e;
      }, y.selectedPointStyle = function (t, e) {
        if (t.size() && e.selectedpoints) {
          var r = y.makeSelectedPointStyleFns(e),
              i = e.marker || {},
              a = [];
          r.selectedOpacityFn && a.push(function (t, e) {
            t.style("opacity", r.selectedOpacityFn(e));
          }), r.selectedColorFn && a.push(function (t, e) {
            s.fill(t, r.selectedColorFn(e));
          }), r.selectedSizeFn && a.push(function (t, e) {
            var n = e.mx || i.symbol || 0,
                a = r.selectedSizeFn(e);
            t.attr("d", _(y.symbolNumber(n), a)), e.mrc2 = a;
          }), a.length && t.each(function (t) {
            for (var e = n.select(this), r = 0; r < a.length; r++) {
              a[r](e, t);
            }
          });
        }
      }, y.tryColorscale = function (t, e) {
        var r = e ? c.nestedProperty(t, e).get() : t;

        if (r) {
          var n = r.color;
          if ((r.colorscale || r._colorAx) && c.isArrayOrTypedArray(n)) return l.makeColorScaleFuncFromTrace(r);
        }

        return c.identity;
      };
      var A = {
        start: 1,
        end: -1,
        middle: 0,
        bottom: 1,
        top: -1
      };

      function S(t, e, r, i) {
        var a = n.select(t.node().parentNode),
            o = -1 !== e.indexOf("top") ? "top" : -1 !== e.indexOf("bottom") ? "bottom" : "middle",
            s = -1 !== e.indexOf("left") ? "end" : -1 !== e.indexOf("right") ? "start" : "middle",
            l = i ? i / .8 + 1 : 0,
            c = (f.lineCount(t) - 1) * p + 1,
            h = A[s] * l,
            d = .75 * r + A[o] * l + (A[o] - 1) * c * r / 2;
        t.attr("text-anchor", s), a.attr("transform", u(h, d));
      }

      function E(t, e) {
        var r = t.ts || e.textfont.size;
        return i(r) && r > 0 ? r : 0;
      }

      y.textPointStyle = function (t, e, r) {
        if (t.size()) {
          var i;

          if (e.selectedpoints) {
            var a = y.makeSelectedTextStyleFns(e);
            i = a.selectedTextColorFn;
          }

          var o = e.texttemplate,
              s = r._fullLayout;
          t.each(function (t) {
            var a = n.select(this),
                l = o ? c.extractOption(t, e, "txt", "texttemplate") : c.extractOption(t, e, "tx", "text");

            if (l || 0 === l) {
              if (o) {
                var u = e._module.formatLabels,
                    h = u ? u(t, e, s) : {},
                    p = {};
                v(p, e, t.i);
                var d = e._meta || {};
                l = c.texttemplateString(l, h, s._d3locale, p, t, d);
              }

              var m = t.tp || e.textposition,
                  g = E(t, e),
                  x = i ? i(t) : t.tc || e.textfont.color;
              a.call(y.font, t.tf || e.textfont.family, g, x).text(l).call(f.convertToTspans, r).call(S, m, g, t.mrc);
            } else a.remove();
          });
        }
      }, y.selectedTextStyle = function (t, e) {
        if (t.size() && e.selectedpoints) {
          var r = y.makeSelectedTextStyleFns(e);
          t.each(function (t) {
            var i = n.select(this),
                a = r.selectedTextColorFn(t),
                o = t.tp || e.textposition,
                l = E(t, e);
            s.fill(i, a), S(i, o, l, t.mrc2 || t.mrc);
          });
        }
      };

      function L(t, e, r, i) {
        var a = t[0] - e[0],
            o = t[1] - e[1],
            s = r[0] - e[0],
            l = r[1] - e[1],
            c = Math.pow(a * a + o * o, .25),
            u = Math.pow(s * s + l * l, .25),
            f = (u * u * a - c * c * s) * i,
            h = (u * u * o - c * c * l) * i,
            p = 3 * u * (c + u),
            d = 3 * c * (c + u);
        return [[n.round(e[0] + (p && f / p), 2), n.round(e[1] + (p && h / p), 2)], [n.round(e[0] - (d && f / d), 2), n.round(e[1] - (d && h / d), 2)]];
      }

      y.smoothopen = function (t, e) {
        if (t.length < 3) return "M" + t.join("L");
        var r,
            n = "M" + t[0],
            i = [];

        for (r = 1; r < t.length - 1; r++) {
          i.push(L(t[r - 1], t[r], t[r + 1], e));
        }

        for (n += "Q" + i[0][0] + " " + t[1], r = 2; r < t.length - 1; r++) {
          n += "C" + i[r - 2][1] + " " + i[r - 1][0] + " " + t[r];
        }

        return n += "Q" + i[t.length - 3][1] + " " + t[t.length - 1];
      }, y.smoothclosed = function (t, e) {
        if (t.length < 3) return "M" + t.join("L") + "Z";
        var r,
            n = "M" + t[0],
            i = t.length - 1,
            a = [L(t[i], t[0], t[1], e)];

        for (r = 1; r < i; r++) {
          a.push(L(t[r - 1], t[r], t[r + 1], e));
        }

        for (a.push(L(t[i - 1], t[i], t[0], e)), r = 1; r <= i; r++) {
          n += "C" + a[r - 1][1] + " " + a[r][0] + " " + t[r];
        }

        return n += "C" + a[i][1] + " " + a[0][0] + " " + t[0] + "Z";
      };

      var C = {
        hv: function hv(t, e) {
          return "H" + n.round(e[0], 2) + "V" + n.round(e[1], 2);
        },
        vh: function vh(t, e) {
          return "V" + n.round(e[1], 2) + "H" + n.round(e[0], 2);
        },
        hvh: function hvh(t, e) {
          return "H" + n.round((t[0] + e[0]) / 2, 2) + "V" + n.round(e[1], 2) + "H" + n.round(e[0], 2);
        },
        vhv: function vhv(t, e) {
          return "V" + n.round((t[1] + e[1]) / 2, 2) + "H" + n.round(e[0], 2) + "V" + n.round(e[1], 2);
        }
      },
          P = function P(t, e) {
        return "L" + n.round(e[0], 2) + "," + n.round(e[1], 2);
      };

      y.steps = function (t) {
        var e = C[t] || P;
        return function (t) {
          for (var r = "M" + n.round(t[0][0], 2) + "," + n.round(t[0][1], 2), i = 1; i < t.length; i++) {
            r += e(t[i - 1], t[i]);
          }

          return r;
        };
      }, y.makeTester = function () {
        var t = c.ensureSingleById(n.select("body"), "svg", "js-plotly-tester", function (t) {
          t.attr(h.svgAttrs).style({
            position: "absolute",
            left: "-10000px",
            top: "-10000px",
            width: "9000px",
            height: "9000px",
            "z-index": "1"
          });
        }),
            e = c.ensureSingle(t, "path", "js-reference-point", function (t) {
          t.attr("d", "M0,0H1V1H0Z").style({
            "stroke-width": 0,
            fill: "black"
          });
        });
        y.tester = t, y.testref = e;
      }, y.savedBBoxes = {};
      var I = 0;

      function O(t) {
        var e = t.getAttribute("data-unformatted");
        if (null !== e) return e + t.getAttribute("data-math") + t.getAttribute("text-anchor") + t.getAttribute("style");
      }

      function z(t, e) {
        if (!t) return null;
        var r = e._context,
            n = r._exportedPlot ? "" : r._baseUrl || "";
        return n ? "url('" + n + "#" + t + "')" : "url(#" + t + ")";
      }

      y.bBox = function (t, e, r) {
        var i, a, o;

        if (r || (r = O(t)), r) {
          if (i = y.savedBBoxes[r]) return c.extendFlat({}, i);
        } else if (1 === t.childNodes.length) {
          var s = t.childNodes[0];

          if (r = O(s)) {
            var l = +s.getAttribute("x") || 0,
                u = +s.getAttribute("y") || 0,
                h = s.getAttribute("transform");

            if (!h) {
              var p = y.bBox(s, !1, r);
              return l && (p.left += l, p.right += l), u && (p.top += u, p.bottom += u), p;
            }

            if (r += "~" + l + "~" + u + "~" + h, i = y.savedBBoxes[r]) return c.extendFlat({}, i);
          }
        }

        e ? a = t : (o = y.tester.node(), a = t.cloneNode(!0), o.appendChild(a)), n.select(a).attr("transform", null).call(f.positionText, 0, 0);
        var d = a.getBoundingClientRect(),
            m = y.testref.node().getBoundingClientRect();
        e || o.removeChild(a);
        var g = {
          height: d.height,
          width: d.width,
          left: d.left - m.left,
          top: d.top - m.top,
          right: d.right - m.left,
          bottom: d.bottom - m.top
        };
        return I >= 1e4 && (y.savedBBoxes = {}, I = 0), r && (y.savedBBoxes[r] = g), I++, c.extendFlat({}, g);
      }, y.setClipUrl = function (t, e, r) {
        t.attr("clip-path", z(e, r));
      }, y.getTranslate = function (t) {
        var e = (t[t.attr ? "attr" : "getAttribute"]("transform") || "").replace(/.*\btranslate\((-?\d*\.?\d*)[^-\d]*(-?\d*\.?\d*)[^\d].*/, function (t, e, r) {
          return [e, r].join(" ");
        }).split(" ");
        return {
          x: +e[0] || 0,
          y: +e[1] || 0
        };
      }, y.setTranslate = function (t, e, r) {
        var n = t.attr ? "attr" : "getAttribute",
            i = t.attr ? "attr" : "setAttribute",
            a = t[n]("transform") || "";
        return e = e || 0, r = r || 0, a = a.replace(/(\btranslate\(.*?\);?)/, "").trim(), a = (a += u(e, r)).trim(), t[i]("transform", a), a;
      }, y.getScale = function (t) {
        var e = (t[t.attr ? "attr" : "getAttribute"]("transform") || "").replace(/.*\bscale\((\d*\.?\d*)[^\d]*(\d*\.?\d*)[^\d].*/, function (t, e, r) {
          return [e, r].join(" ");
        }).split(" ");
        return {
          x: +e[0] || 1,
          y: +e[1] || 1
        };
      }, y.setScale = function (t, e, r) {
        var n = t.attr ? "attr" : "getAttribute",
            i = t.attr ? "attr" : "setAttribute",
            a = t[n]("transform") || "";
        return e = e || 1, r = r || 1, a = a.replace(/(\bscale\(.*?\);?)/, "").trim(), a = (a += "scale(" + e + "," + r + ")").trim(), t[i]("transform", a), a;
      };
      var D = /\s*sc.*/;

      y.setPointGroupScale = function (t, e, r) {
        if (e = e || 1, r = r || 1, t) {
          var n = 1 === e && 1 === r ? "" : "scale(" + e + "," + r + ")";
          t.each(function () {
            var t = (this.getAttribute("transform") || "").replace(D, "");
            t = (t += n).trim(), this.setAttribute("transform", t);
          });
        }
      };

      var R = /translate\([^)]*\)\s*$/;

      y.setTextPointsScale = function (t, e, r) {
        t && t.each(function () {
          var t,
              i = n.select(this),
              a = i.select("text");

          if (a.node()) {
            var o = parseFloat(a.attr("x") || 0),
                s = parseFloat(a.attr("y") || 0),
                l = (i.attr("transform") || "").match(R);
            t = 1 === e && 1 === r ? [] : [u(o, s), "scale(" + e + "," + r + ")", u(-o, -s)], l && t.push(l), i.attr("transform", t.join(""));
          }
        });
      };
    }, {
      "../../components/fx/helpers": 694,
      "../../constants/alignment": 763,
      "../../constants/interactions": 770,
      "../../constants/xmlns_namespaces": 772,
      "../../lib": 795,
      "../../lib/svg_text_utils": 820,
      "../../registry": 923,
      "../../traces/scatter/make_bubble_size_func": 1216,
      "../../traces/scatter/subtypes": 1224,
      "../color": 658,
      "../colorscale": 670,
      "./symbol_defs": 681,
      "@plotly/d3": 57,
      "fast-isnumeric": 240,
      tinycolor2: 590
    }],
    681: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3");
      e.exports = {
        circle: {
          n: 0,
          f: function f(t) {
            var e = n.round(t, 2);
            return "M" + e + ",0A" + e + "," + e + " 0 1,1 0,-" + e + "A" + e + "," + e + " 0 0,1 " + e + ",0Z";
          }
        },
        square: {
          n: 1,
          f: function f(t) {
            var e = n.round(t, 2);
            return "M" + e + "," + e + "H-" + e + "V-" + e + "H" + e + "Z";
          }
        },
        diamond: {
          n: 2,
          f: function f(t) {
            var e = n.round(1.3 * t, 2);
            return "M" + e + ",0L0," + e + "L-" + e + ",0L0,-" + e + "Z";
          }
        },
        cross: {
          n: 3,
          f: function f(t) {
            var e = n.round(.4 * t, 2),
                r = n.round(1.2 * t, 2);
            return "M" + r + "," + e + "H" + e + "V" + r + "H-" + e + "V" + e + "H-" + r + "V-" + e + "H-" + e + "V-" + r + "H" + e + "V-" + e + "H" + r + "Z";
          }
        },
        x: {
          n: 4,
          f: function f(t) {
            var e = n.round(.8 * t / Math.sqrt(2), 2),
                r = "l" + e + "," + e,
                i = "l" + e + ",-" + e,
                a = "l-" + e + ",-" + e,
                o = "l-" + e + "," + e;
            return "M0," + e + r + i + a + i + a + o + a + o + r + o + r + "Z";
          }
        },
        "triangle-up": {
          n: 5,
          f: function f(t) {
            var e = n.round(2 * t / Math.sqrt(3), 2);
            return "M-" + e + "," + n.round(t / 2, 2) + "H" + e + "L0,-" + n.round(t, 2) + "Z";
          }
        },
        "triangle-down": {
          n: 6,
          f: function f(t) {
            var e = n.round(2 * t / Math.sqrt(3), 2);
            return "M-" + e + ",-" + n.round(t / 2, 2) + "H" + e + "L0," + n.round(t, 2) + "Z";
          }
        },
        "triangle-left": {
          n: 7,
          f: function f(t) {
            var e = n.round(2 * t / Math.sqrt(3), 2);
            return "M" + n.round(t / 2, 2) + ",-" + e + "V" + e + "L-" + n.round(t, 2) + ",0Z";
          }
        },
        "triangle-right": {
          n: 8,
          f: function f(t) {
            var e = n.round(2 * t / Math.sqrt(3), 2);
            return "M-" + n.round(t / 2, 2) + ",-" + e + "V" + e + "L" + n.round(t, 2) + ",0Z";
          }
        },
        "triangle-ne": {
          n: 9,
          f: function f(t) {
            var e = n.round(.6 * t, 2),
                r = n.round(1.2 * t, 2);
            return "M-" + r + ",-" + e + "H" + e + "V" + r + "Z";
          }
        },
        "triangle-se": {
          n: 10,
          f: function f(t) {
            var e = n.round(.6 * t, 2),
                r = n.round(1.2 * t, 2);
            return "M" + e + ",-" + r + "V" + e + "H-" + r + "Z";
          }
        },
        "triangle-sw": {
          n: 11,
          f: function f(t) {
            var e = n.round(.6 * t, 2),
                r = n.round(1.2 * t, 2);
            return "M" + r + "," + e + "H-" + e + "V-" + r + "Z";
          }
        },
        "triangle-nw": {
          n: 12,
          f: function f(t) {
            var e = n.round(.6 * t, 2),
                r = n.round(1.2 * t, 2);
            return "M-" + e + "," + r + "V-" + e + "H" + r + "Z";
          }
        },
        pentagon: {
          n: 13,
          f: function f(t) {
            var e = n.round(.951 * t, 2),
                r = n.round(.588 * t, 2),
                i = n.round(-t, 2),
                a = n.round(-.309 * t, 2);
            return "M" + e + "," + a + "L" + r + "," + n.round(.809 * t, 2) + "H-" + r + "L-" + e + "," + a + "L0," + i + "Z";
          }
        },
        hexagon: {
          n: 14,
          f: function f(t) {
            var e = n.round(t, 2),
                r = n.round(t / 2, 2),
                i = n.round(t * Math.sqrt(3) / 2, 2);
            return "M" + i + ",-" + r + "V" + r + "L0," + e + "L-" + i + "," + r + "V-" + r + "L0,-" + e + "Z";
          }
        },
        hexagon2: {
          n: 15,
          f: function f(t) {
            var e = n.round(t, 2),
                r = n.round(t / 2, 2),
                i = n.round(t * Math.sqrt(3) / 2, 2);
            return "M-" + r + "," + i + "H" + r + "L" + e + ",0L" + r + ",-" + i + "H-" + r + "L-" + e + ",0Z";
          }
        },
        octagon: {
          n: 16,
          f: function f(t) {
            var e = n.round(.924 * t, 2),
                r = n.round(.383 * t, 2);
            return "M-" + r + ",-" + e + "H" + r + "L" + e + ",-" + r + "V" + r + "L" + r + "," + e + "H-" + r + "L-" + e + "," + r + "V-" + r + "Z";
          }
        },
        star: {
          n: 17,
          f: function f(t) {
            var e = 1.4 * t,
                r = n.round(.225 * e, 2),
                i = n.round(.951 * e, 2),
                a = n.round(.363 * e, 2),
                o = n.round(.588 * e, 2),
                s = n.round(-e, 2),
                l = n.round(-.309 * e, 2),
                c = n.round(.118 * e, 2),
                u = n.round(.809 * e, 2);
            return "M" + r + "," + l + "H" + i + "L" + a + "," + c + "L" + o + "," + u + "L0," + n.round(.382 * e, 2) + "L-" + o + "," + u + "L-" + a + "," + c + "L-" + i + "," + l + "H-" + r + "L0," + s + "Z";
          }
        },
        hexagram: {
          n: 18,
          f: function f(t) {
            var e = n.round(.66 * t, 2),
                r = n.round(.38 * t, 2),
                i = n.round(.76 * t, 2);
            return "M-" + i + ",0l-" + r + ",-" + e + "h" + i + "l" + r + ",-" + e + "l" + r + "," + e + "h" + i + "l-" + r + "," + e + "l" + r + "," + e + "h-" + i + "l-" + r + "," + e + "l-" + r + ",-" + e + "h-" + i + "Z";
          }
        },
        "star-triangle-up": {
          n: 19,
          f: function f(t) {
            var e = n.round(t * Math.sqrt(3) * .8, 2),
                r = n.round(.8 * t, 2),
                i = n.round(1.6 * t, 2),
                a = n.round(4 * t, 2),
                o = "A " + a + "," + a + " 0 0 1 ";
            return "M-" + e + "," + r + o + e + "," + r + o + "0,-" + i + o + "-" + e + "," + r + "Z";
          }
        },
        "star-triangle-down": {
          n: 20,
          f: function f(t) {
            var e = n.round(t * Math.sqrt(3) * .8, 2),
                r = n.round(.8 * t, 2),
                i = n.round(1.6 * t, 2),
                a = n.round(4 * t, 2),
                o = "A " + a + "," + a + " 0 0 1 ";
            return "M" + e + ",-" + r + o + "-" + e + ",-" + r + o + "0," + i + o + e + ",-" + r + "Z";
          }
        },
        "star-square": {
          n: 21,
          f: function f(t) {
            var e = n.round(1.1 * t, 2),
                r = n.round(2 * t, 2),
                i = "A " + r + "," + r + " 0 0 1 ";
            return "M-" + e + ",-" + e + i + "-" + e + "," + e + i + e + "," + e + i + e + ",-" + e + i + "-" + e + ",-" + e + "Z";
          }
        },
        "star-diamond": {
          n: 22,
          f: function f(t) {
            var e = n.round(1.4 * t, 2),
                r = n.round(1.9 * t, 2),
                i = "A " + r + "," + r + " 0 0 1 ";
            return "M-" + e + ",0" + i + "0," + e + i + e + ",0" + i + "0,-" + e + i + "-" + e + ",0Z";
          }
        },
        "diamond-tall": {
          n: 23,
          f: function f(t) {
            var e = n.round(.7 * t, 2),
                r = n.round(1.4 * t, 2);
            return "M0," + r + "L" + e + ",0L0,-" + r + "L-" + e + ",0Z";
          }
        },
        "diamond-wide": {
          n: 24,
          f: function f(t) {
            var e = n.round(1.4 * t, 2),
                r = n.round(.7 * t, 2);
            return "M0," + r + "L" + e + ",0L0,-" + r + "L-" + e + ",0Z";
          }
        },
        hourglass: {
          n: 25,
          f: function f(t) {
            var e = n.round(t, 2);
            return "M" + e + "," + e + "H-" + e + "L" + e + ",-" + e + "H-" + e + "Z";
          },
          noDot: !0
        },
        bowtie: {
          n: 26,
          f: function f(t) {
            var e = n.round(t, 2);
            return "M" + e + "," + e + "V-" + e + "L-" + e + "," + e + "V-" + e + "Z";
          },
          noDot: !0
        },
        "circle-cross": {
          n: 27,
          f: function f(t) {
            var e = n.round(t, 2);
            return "M0," + e + "V-" + e + "M" + e + ",0H-" + e + "M" + e + ",0A" + e + "," + e + " 0 1,1 0,-" + e + "A" + e + "," + e + " 0 0,1 " + e + ",0Z";
          },
          needLine: !0,
          noDot: !0
        },
        "circle-x": {
          n: 28,
          f: function f(t) {
            var e = n.round(t, 2),
                r = n.round(t / Math.sqrt(2), 2);
            return "M" + r + "," + r + "L-" + r + ",-" + r + "M" + r + ",-" + r + "L-" + r + "," + r + "M" + e + ",0A" + e + "," + e + " 0 1,1 0,-" + e + "A" + e + "," + e + " 0 0,1 " + e + ",0Z";
          },
          needLine: !0,
          noDot: !0
        },
        "square-cross": {
          n: 29,
          f: function f(t) {
            var e = n.round(t, 2);
            return "M0," + e + "V-" + e + "M" + e + ",0H-" + e + "M" + e + "," + e + "H-" + e + "V-" + e + "H" + e + "Z";
          },
          needLine: !0,
          noDot: !0
        },
        "square-x": {
          n: 30,
          f: function f(t) {
            var e = n.round(t, 2);
            return "M" + e + "," + e + "L-" + e + ",-" + e + "M" + e + ",-" + e + "L-" + e + "," + e + "M" + e + "," + e + "H-" + e + "V-" + e + "H" + e + "Z";
          },
          needLine: !0,
          noDot: !0
        },
        "diamond-cross": {
          n: 31,
          f: function f(t) {
            var e = n.round(1.3 * t, 2);
            return "M" + e + ",0L0," + e + "L-" + e + ",0L0,-" + e + "ZM0,-" + e + "V" + e + "M-" + e + ",0H" + e;
          },
          needLine: !0,
          noDot: !0
        },
        "diamond-x": {
          n: 32,
          f: function f(t) {
            var e = n.round(1.3 * t, 2),
                r = n.round(.65 * t, 2);
            return "M" + e + ",0L0," + e + "L-" + e + ",0L0,-" + e + "ZM-" + r + ",-" + r + "L" + r + "," + r + "M-" + r + "," + r + "L" + r + ",-" + r;
          },
          needLine: !0,
          noDot: !0
        },
        "cross-thin": {
          n: 33,
          f: function f(t) {
            var e = n.round(1.4 * t, 2);
            return "M0," + e + "V-" + e + "M" + e + ",0H-" + e;
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "x-thin": {
          n: 34,
          f: function f(t) {
            var e = n.round(t, 2);
            return "M" + e + "," + e + "L-" + e + ",-" + e + "M" + e + ",-" + e + "L-" + e + "," + e;
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        asterisk: {
          n: 35,
          f: function f(t) {
            var e = n.round(1.2 * t, 2),
                r = n.round(.85 * t, 2);
            return "M0," + e + "V-" + e + "M" + e + ",0H-" + e + "M" + r + "," + r + "L-" + r + ",-" + r + "M" + r + ",-" + r + "L-" + r + "," + r;
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        hash: {
          n: 36,
          f: function f(t) {
            var e = n.round(t / 2, 2),
                r = n.round(t, 2);
            return "M" + e + "," + r + "V-" + r + "m-" + r + ",0V" + r + "M" + r + "," + e + "H-" + r + "m0,-" + r + "H" + r;
          },
          needLine: !0,
          noFill: !0
        },
        "y-up": {
          n: 37,
          f: function f(t) {
            var e = n.round(1.2 * t, 2),
                r = n.round(1.6 * t, 2),
                i = n.round(.8 * t, 2);
            return "M-" + e + "," + i + "L0,0M" + e + "," + i + "L0,0M0,-" + r + "L0,0";
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "y-down": {
          n: 38,
          f: function f(t) {
            var e = n.round(1.2 * t, 2),
                r = n.round(1.6 * t, 2),
                i = n.round(.8 * t, 2);
            return "M-" + e + ",-" + i + "L0,0M" + e + ",-" + i + "L0,0M0," + r + "L0,0";
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "y-left": {
          n: 39,
          f: function f(t) {
            var e = n.round(1.2 * t, 2),
                r = n.round(1.6 * t, 2),
                i = n.round(.8 * t, 2);
            return "M" + i + "," + e + "L0,0M" + i + ",-" + e + "L0,0M-" + r + ",0L0,0";
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "y-right": {
          n: 40,
          f: function f(t) {
            var e = n.round(1.2 * t, 2),
                r = n.round(1.6 * t, 2),
                i = n.round(.8 * t, 2);
            return "M-" + i + "," + e + "L0,0M-" + i + ",-" + e + "L0,0M" + r + ",0L0,0";
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "line-ew": {
          n: 41,
          f: function f(t) {
            var e = n.round(1.4 * t, 2);
            return "M" + e + ",0H-" + e;
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "line-ns": {
          n: 42,
          f: function f(t) {
            var e = n.round(1.4 * t, 2);
            return "M0," + e + "V-" + e;
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "line-ne": {
          n: 43,
          f: function f(t) {
            var e = n.round(t, 2);
            return "M" + e + ",-" + e + "L-" + e + "," + e;
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "line-nw": {
          n: 44,
          f: function f(t) {
            var e = n.round(t, 2);
            return "M" + e + "," + e + "L-" + e + ",-" + e;
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "arrow-up": {
          n: 45,
          f: function f(t) {
            var e = n.round(t, 2);
            return "M0,0L-" + e + "," + n.round(2 * t, 2) + "H" + e + "Z";
          },
          noDot: !0
        },
        "arrow-down": {
          n: 46,
          f: function f(t) {
            var e = n.round(t, 2);
            return "M0,0L-" + e + ",-" + n.round(2 * t, 2) + "H" + e + "Z";
          },
          noDot: !0
        },
        "arrow-left": {
          n: 47,
          f: function f(t) {
            var e = n.round(2 * t, 2),
                r = n.round(t, 2);
            return "M0,0L" + e + ",-" + r + "V" + r + "Z";
          },
          noDot: !0
        },
        "arrow-right": {
          n: 48,
          f: function f(t) {
            var e = n.round(2 * t, 2),
                r = n.round(t, 2);
            return "M0,0L-" + e + ",-" + r + "V" + r + "Z";
          },
          noDot: !0
        },
        "arrow-bar-up": {
          n: 49,
          f: function f(t) {
            var e = n.round(t, 2);
            return "M-" + e + ",0H" + e + "M0,0L-" + e + "," + n.round(2 * t, 2) + "H" + e + "Z";
          },
          needLine: !0,
          noDot: !0
        },
        "arrow-bar-down": {
          n: 50,
          f: function f(t) {
            var e = n.round(t, 2);
            return "M-" + e + ",0H" + e + "M0,0L-" + e + ",-" + n.round(2 * t, 2) + "H" + e + "Z";
          },
          needLine: !0,
          noDot: !0
        },
        "arrow-bar-left": {
          n: 51,
          f: function f(t) {
            var e = n.round(2 * t, 2),
                r = n.round(t, 2);
            return "M0,-" + r + "V" + r + "M0,0L" + e + ",-" + r + "V" + r + "Z";
          },
          needLine: !0,
          noDot: !0
        },
        "arrow-bar-right": {
          n: 52,
          f: function f(t) {
            var e = n.round(2 * t, 2),
                r = n.round(t, 2);
            return "M0,-" + r + "V" + r + "M0,0L-" + e + ",-" + r + "V" + r + "Z";
          },
          needLine: !0,
          noDot: !0
        }
      };
    }, {
      "@plotly/d3": 57
    }],
    682: [function (t, e, r) {
      "use strict";

      e.exports = {
        visible: {
          valType: "boolean",
          editType: "calc"
        },
        type: {
          valType: "enumerated",
          values: ["percent", "constant", "sqrt", "data"],
          editType: "calc"
        },
        symmetric: {
          valType: "boolean",
          editType: "calc"
        },
        array: {
          valType: "data_array",
          editType: "calc"
        },
        arrayminus: {
          valType: "data_array",
          editType: "calc"
        },
        value: {
          valType: "number",
          min: 0,
          dflt: 10,
          editType: "calc"
        },
        valueminus: {
          valType: "number",
          min: 0,
          dflt: 10,
          editType: "calc"
        },
        traceref: {
          valType: "integer",
          min: 0,
          dflt: 0,
          editType: "style"
        },
        tracerefminus: {
          valType: "integer",
          min: 0,
          dflt: 0,
          editType: "style"
        },
        copy_ystyle: {
          valType: "boolean",
          editType: "plot"
        },
        copy_zstyle: {
          valType: "boolean",
          editType: "style"
        },
        color: {
          valType: "color",
          editType: "style"
        },
        thickness: {
          valType: "number",
          min: 0,
          dflt: 2,
          editType: "style"
        },
        width: {
          valType: "number",
          min: 0,
          editType: "plot"
        },
        editType: "calc",
        _deprecated: {
          opacity: {
            valType: "number",
            editType: "style"
          }
        }
      };
    }, {}],
    683: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../registry"),
          a = t("../../plots/cartesian/axes"),
          o = t("../../lib"),
          s = t("./compute_error");

      function l(t, e, r, i) {
        var l = e["error_" + i] || {},
            c = [];

        if (l.visible && -1 !== ["linear", "log"].indexOf(r.type)) {
          for (var u = s(l), f = 0; f < t.length; f++) {
            var h = t[f],
                p = h.i;
            if (void 0 === p) p = f;else if (null === p) continue;
            var d = h[i];

            if (n(r.c2l(d))) {
              var m = u(d, p);

              if (n(m[0]) && n(m[1])) {
                var g = h[i + "s"] = d - m[0],
                    v = h[i + "h"] = d + m[1];
                c.push(g, v);
              }
            }
          }

          var y = r._id,
              x = e._extremes[y],
              b = a.findExtremes(r, c, o.extendFlat({
            tozero: x.opts.tozero
          }, {
            padded: !0
          }));
          x.min = x.min.concat(b.min), x.max = x.max.concat(b.max);
        }
      }

      e.exports = function (t) {
        for (var e = t.calcdata, r = 0; r < e.length; r++) {
          var n = e[r],
              o = n[0].trace;

          if (!0 === o.visible && i.traceIs(o, "errorBarsOK")) {
            var s = a.getFromId(t, o.xaxis),
                c = a.getFromId(t, o.yaxis);
            l(n, o, s, "x"), l(n, o, c, "y");
          }
        }
      };
    }, {
      "../../lib": 795,
      "../../plots/cartesian/axes": 845,
      "../../registry": 923,
      "./compute_error": 684,
      "fast-isnumeric": 240
    }],
    684: [function (t, e, r) {
      "use strict";

      function n(t, e) {
        return "percent" === t ? function (t) {
          return Math.abs(t * e / 100);
        } : "constant" === t ? function () {
          return Math.abs(e);
        } : "sqrt" === t ? function (t) {
          return Math.sqrt(Math.abs(t));
        } : void 0;
      }

      e.exports = function (t) {
        var e = t.type,
            r = t.symmetric;

        if ("data" === e) {
          var i = t.array || [];
          if (r) return function (t, e) {
            var r = +i[e];
            return [r, r];
          };
          var a = t.arrayminus || [];
          return function (t, e) {
            var r = +i[e],
                n = +a[e];
            return isNaN(r) && isNaN(n) ? [NaN, NaN] : [n || 0, r || 0];
          };
        }

        var o = n(e, t.value),
            s = n(e, t.valueminus);
        return r || void 0 === t.valueminus ? function (t) {
          var e = o(t);
          return [e, e];
        } : function (t) {
          return [s(t), o(t)];
        };
      };
    }, {}],
    685: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../registry"),
          a = t("../../lib"),
          o = t("../../plot_api/plot_template"),
          s = t("./attributes");

      e.exports = function (t, e, r, l) {
        var c = "error_" + l.axis,
            u = o.newContainer(e, c),
            f = t[c] || {};

        function h(t, e) {
          return a.coerce(f, u, s, t, e);
        }

        if (!1 !== h("visible", void 0 !== f.array || void 0 !== f.value || "sqrt" === f.type)) {
          var p = h("type", "array" in f ? "data" : "percent"),
              d = !0;
          "sqrt" !== p && (d = h("symmetric", !(("data" === p ? "arrayminus" : "valueminus") in f))), "data" === p ? (h("array"), h("traceref"), d || (h("arrayminus"), h("tracerefminus"))) : "percent" !== p && "constant" !== p || (h("value"), d || h("valueminus"));
          var m = "copy_" + l.inherit + "style";
          if (l.inherit) (e["error_" + l.inherit] || {}).visible && h(m, !(f.color || n(f.thickness) || n(f.width)));
          l.inherit && u[m] || (h("color", r), h("thickness"), h("width", i.traceIs(e, "gl3d") ? 0 : 4));
        }
      };
    }, {
      "../../lib": 795,
      "../../plot_api/plot_template": 834,
      "../../registry": 923,
      "./attributes": 682,
      "fast-isnumeric": 240
    }],
    686: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../plot_api/edit_types").overrideAll,
          a = t("./attributes"),
          o = {
        error_x: n.extendFlat({}, a),
        error_y: n.extendFlat({}, a)
      };
      delete o.error_x.copy_zstyle, delete o.error_y.copy_zstyle, delete o.error_y.copy_ystyle;
      var s = {
        error_x: n.extendFlat({}, a),
        error_y: n.extendFlat({}, a),
        error_z: n.extendFlat({}, a)
      };
      delete s.error_x.copy_ystyle, delete s.error_y.copy_ystyle, delete s.error_z.copy_ystyle, delete s.error_z.copy_zstyle, e.exports = {
        moduleType: "component",
        name: "errorbars",
        schema: {
          traces: {
            scatter: o,
            bar: o,
            histogram: o,
            scatter3d: i(s, "calc", "nested"),
            scattergl: i(o, "calc", "nested")
          }
        },
        supplyDefaults: t("./defaults"),
        calc: t("./calc"),
        makeComputeError: t("./compute_error"),
        plot: t("./plot"),
        style: t("./style"),
        hoverInfo: function hoverInfo(t, e, r) {
          (e.error_y || {}).visible && (r.yerr = t.yh - t.y, e.error_y.symmetric || (r.yerrneg = t.y - t.ys));
          (e.error_x || {}).visible && (r.xerr = t.xh - t.x, e.error_x.symmetric || (r.xerrneg = t.x - t.xs));
        }
      };
    }, {
      "../../lib": 795,
      "../../plot_api/edit_types": 827,
      "./attributes": 682,
      "./calc": 683,
      "./compute_error": 684,
      "./defaults": 685,
      "./plot": 687,
      "./style": 688
    }],
    687: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("fast-isnumeric"),
          a = t("../drawing"),
          o = t("../../traces/scatter/subtypes");

      e.exports = function (t, e, r, s) {
        var l = r.xaxis,
            c = r.yaxis,
            u = s && s.duration > 0;
        e.each(function (e) {
          var f,
              h = e[0].trace,
              p = h.error_x || {},
              d = h.error_y || {};
          h.ids && (f = function f(t) {
            return t.id;
          });
          var m = o.hasMarkers(h) && h.marker.maxdisplayed > 0;
          d.visible || p.visible || (e = []);
          var g = n.select(this).selectAll("g.errorbar").data(e, f);

          if (g.exit().remove(), e.length) {
            p.visible || g.selectAll("path.xerror").remove(), d.visible || g.selectAll("path.yerror").remove(), g.style("opacity", 1);
            var v = g.enter().append("g").classed("errorbar", !0);
            u && v.style("opacity", 0).transition().duration(s.duration).style("opacity", 1), a.setClipUrl(g, r.layerClipId, t), g.each(function (t) {
              var e = n.select(this),
                  r = function (t, e, r) {
                var n = {
                  x: e.c2p(t.x),
                  y: r.c2p(t.y)
                };
                void 0 !== t.yh && (n.yh = r.c2p(t.yh), n.ys = r.c2p(t.ys), i(n.ys) || (n.noYS = !0, n.ys = r.c2p(t.ys, !0)));
                void 0 !== t.xh && (n.xh = e.c2p(t.xh), n.xs = e.c2p(t.xs), i(n.xs) || (n.noXS = !0, n.xs = e.c2p(t.xs, !0)));
                return n;
              }(t, l, c);

              if (!m || t.vis) {
                var a,
                    o = e.select("path.yerror");

                if (d.visible && i(r.x) && i(r.yh) && i(r.ys)) {
                  var f = d.width;
                  a = "M" + (r.x - f) + "," + r.yh + "h" + 2 * f + "m-" + f + ",0V" + r.ys, r.noYS || (a += "m-" + f + ",0h" + 2 * f), !o.size() ? o = e.append("path").style("vector-effect", "non-scaling-stroke").classed("yerror", !0) : u && (o = o.transition().duration(s.duration).ease(s.easing)), o.attr("d", a);
                } else o.remove();

                var h = e.select("path.xerror");

                if (p.visible && i(r.y) && i(r.xh) && i(r.xs)) {
                  var g = (p.copy_ystyle ? d : p).width;
                  a = "M" + r.xh + "," + (r.y - g) + "v" + 2 * g + "m0,-" + g + "H" + r.xs, r.noXS || (a += "m0,-" + g + "v" + 2 * g), !h.size() ? h = e.append("path").style("vector-effect", "non-scaling-stroke").classed("xerror", !0) : u && (h = h.transition().duration(s.duration).ease(s.easing)), h.attr("d", a);
                } else h.remove();
              }
            });
          }
        });
      };
    }, {
      "../../traces/scatter/subtypes": 1224,
      "../drawing": 680,
      "@plotly/d3": 57,
      "fast-isnumeric": 240
    }],
    688: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../color");

      e.exports = function (t) {
        t.each(function (t) {
          var e = t[0].trace,
              r = e.error_y || {},
              a = e.error_x || {},
              o = n.select(this);
          o.selectAll("path.yerror").style("stroke-width", r.thickness + "px").call(i.stroke, r.color), a.copy_ystyle && (a = r), o.selectAll("path.xerror").style("stroke-width", a.thickness + "px").call(i.stroke, a.color);
        });
      };
    }, {
      "../color": 658,
      "@plotly/d3": 57
    }],
    689: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/font_attributes"),
          i = t("./layout_attributes").hoverlabel,
          a = t("../../lib/extend").extendFlat;
      e.exports = {
        hoverlabel: {
          bgcolor: a({}, i.bgcolor, {
            arrayOk: !0
          }),
          bordercolor: a({}, i.bordercolor, {
            arrayOk: !0
          }),
          font: n({
            arrayOk: !0,
            editType: "none"
          }),
          align: a({}, i.align, {
            arrayOk: !0
          }),
          namelength: a({}, i.namelength, {
            arrayOk: !0
          }),
          editType: "none"
        }
      };
    }, {
      "../../lib/extend": 785,
      "../../plots/font_attributes": 873,
      "./layout_attributes": 699
    }],
    690: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../registry");

      function a(t, e, r, i) {
        i = i || n.identity, Array.isArray(t) && (e[0][r] = i(t));
      }

      e.exports = function (t) {
        var e = t.calcdata,
            r = t._fullLayout;

        function o(t) {
          return function (e) {
            return n.coerceHoverinfo({
              hoverinfo: e
            }, {
              _module: t._module
            }, r);
          };
        }

        for (var s = 0; s < e.length; s++) {
          var l = e[s],
              c = l[0].trace;

          if (!i.traceIs(c, "pie-like")) {
            var u = i.traceIs(c, "2dMap") ? a : n.fillArray;
            u(c.hoverinfo, l, "hi", o(c)), c.hovertemplate && u(c.hovertemplate, l, "ht"), c.hoverlabel && (u(c.hoverlabel.bgcolor, l, "hbg"), u(c.hoverlabel.bordercolor, l, "hbc"), u(c.hoverlabel.font.size, l, "hts"), u(c.hoverlabel.font.color, l, "htc"), u(c.hoverlabel.font.family, l, "htf"), u(c.hoverlabel.namelength, l, "hnl"), u(c.hoverlabel.align, l, "hta"));
          }
        }
      };
    }, {
      "../../lib": 795,
      "../../registry": 923
    }],
    691: [function (t, e, r) {
      "use strict";

      var n = t("../../registry"),
          i = t("./hover").hover;

      e.exports = function (t, e, r) {
        var a = n.getComponentMethod("annotations", "onClick")(t, t._hoverdata);

        function o() {
          t.emit("plotly_click", {
            points: t._hoverdata,
            event: e
          });
        }

        void 0 !== r && i(t, e, r, !0), t._hoverdata && e && e.target && (a && a.then ? a.then(o) : o(), e.stopImmediatePropagation && e.stopImmediatePropagation());
      };
    }, {
      "../../registry": 923,
      "./hover": 695
    }],
    692: [function (t, e, r) {
      "use strict";

      e.exports = {
        YANGLE: 60,
        HOVERARROWSIZE: 6,
        HOVERTEXTPAD: 3,
        HOVERFONTSIZE: 13,
        HOVERFONT: "Arial, sans-serif",
        HOVERMINTIME: 50,
        HOVERID: "-hover"
      };
    }, {}],
    693: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./attributes"),
          a = t("./hoverlabel_defaults");

      e.exports = function (t, e, r, o) {
        var s = n.extendFlat({}, o.hoverlabel);
        e.hovertemplate && (s.namelength = -1), a(t, e, function (r, a) {
          return n.coerce(t, e, i, r, a);
        }, s);
      };
    }, {
      "../../lib": 795,
      "./attributes": 689,
      "./hoverlabel_defaults": 696
    }],
    694: [function (t, e, r) {
      "use strict";

      var n = t("../../lib");
      r.getSubplot = function (t) {
        return t.subplot || t.xaxis + t.yaxis || t.geo;
      }, r.isTraceInSubplots = function (t, e) {
        if ("splom" === t.type) {
          for (var n = t.xaxes || [], i = t.yaxes || [], a = 0; a < n.length; a++) {
            for (var o = 0; o < i.length; o++) {
              if (-1 !== e.indexOf(n[a] + i[o])) return !0;
            }
          }

          return !1;
        }

        return -1 !== e.indexOf(r.getSubplot(t));
      }, r.flat = function (t, e) {
        for (var r = new Array(t.length), n = 0; n < t.length; n++) {
          r[n] = e;
        }

        return r;
      }, r.p2c = function (t, e) {
        for (var r = new Array(t.length), n = 0; n < t.length; n++) {
          r[n] = t[n].p2c(e);
        }

        return r;
      }, r.getDistanceFunction = function (t, e, n, i) {
        return "closest" === t ? i || r.quadrature(e, n) : "x" === t.charAt(0) ? e : n;
      }, r.getClosest = function (t, e, r) {
        if (!1 !== r.index) r.index >= 0 && r.index < t.length ? r.distance = 0 : r.index = !1;else for (var n = 0; n < t.length; n++) {
          var i = e(t[n]);
          i <= r.distance && (r.index = n, r.distance = i);
        }
        return r;
      }, r.inbox = function (t, e, r) {
        return t * e < 0 || 0 === t ? r : 1 / 0;
      }, r.quadrature = function (t, e) {
        return function (r) {
          var n = t(r),
              i = e(r);
          return Math.sqrt(n * n + i * i);
        };
      }, r.makeEventData = function (t, e, n) {
        var i = "index" in t ? t.index : t.pointNumber,
            a = {
          data: e._input,
          fullData: e,
          curveNumber: e.index,
          pointNumber: i
        };

        if (e._indexToPoints) {
          var o = e._indexToPoints[i];
          1 === o.length ? a.pointIndex = o[0] : a.pointIndices = o;
        } else a.pointIndex = i;

        return e._module.eventData ? a = e._module.eventData(a, t, e, n, i) : ("xVal" in t ? a.x = t.xVal : "x" in t && (a.x = t.x), "yVal" in t ? a.y = t.yVal : "y" in t && (a.y = t.y), t.xa && (a.xaxis = t.xa), t.ya && (a.yaxis = t.ya), void 0 !== t.zLabelVal && (a.z = t.zLabelVal)), r.appendArrayPointValue(a, e, i), a;
      }, r.appendArrayPointValue = function (t, e, r) {
        var i = e._arrayAttrs;
        if (i) for (var s = 0; s < i.length; s++) {
          var l = i[s],
              c = a(l);

          if (void 0 === t[c]) {
            var u = o(n.nestedProperty(e, l).get(), r);
            void 0 !== u && (t[c] = u);
          }
        }
      }, r.appendArrayMultiPointValues = function (t, e, r) {
        var i = e._arrayAttrs;
        if (i) for (var s = 0; s < i.length; s++) {
          var l = i[s],
              c = a(l);

          if (void 0 === t[c]) {
            for (var u = n.nestedProperty(e, l).get(), f = new Array(r.length), h = 0; h < r.length; h++) {
              f[h] = o(u, r[h]);
            }

            t[c] = f;
          }
        }
      };
      var i = {
        ids: "id",
        locations: "location",
        labels: "label",
        values: "value",
        "marker.colors": "color",
        parents: "parent"
      };

      function a(t) {
        return i[t] || t;
      }

      function o(t, e) {
        return Array.isArray(e) ? Array.isArray(t) && Array.isArray(t[e[0]]) ? t[e[0]][e[1]] : void 0 : t[e];
      }

      var s = {
        x: !0,
        y: !0
      },
          l = {
        "x unified": !0,
        "y unified": !0
      };
      r.isUnifiedHover = function (t) {
        return "string" == typeof t && !!l[t];
      }, r.isXYhover = function (t) {
        return "string" == typeof t && !!s[t];
      };
    }, {
      "../../lib": 795
    }],
    695: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("fast-isnumeric"),
          a = t("tinycolor2"),
          o = t("../../lib"),
          s = o.strTranslate,
          l = o.strRotate,
          c = t("../../lib/events"),
          u = t("../../lib/svg_text_utils"),
          f = t("../../lib/override_cursor"),
          h = t("../drawing"),
          p = t("../color"),
          d = t("../dragelement"),
          m = t("../../plots/cartesian/axes"),
          g = t("../../registry"),
          v = t("./helpers"),
          y = t("./constants"),
          x = t("../legend/defaults"),
          b = t("../legend/draw"),
          _ = y.YANGLE,
          w = Math.PI * _ / 180,
          T = 1 / Math.sin(w),
          k = Math.cos(w),
          M = Math.sin(w),
          A = y.HOVERARROWSIZE,
          S = y.HOVERTEXTPAD,
          E = {
        box: !0,
        ohlc: !0,
        violin: !0,
        candlestick: !0
      };

      function L(t) {
        return [t.trace.index, t.index, t.x0, t.y0, t.name, t.attr, t.xa, t.ya || ""].join(",");
      }

      r.hover = function (t, e, r, a) {
        t = o.getGraphDiv(t), o.throttle(t._fullLayout._uid + y.HOVERID, y.HOVERMINTIME, function () {
          !function (t, e, r, a) {
            r || (r = "xy");

            var s = Array.isArray(r) ? r : [r],
                l = t._fullLayout,
                u = l._plots || [],
                h = u[r],
                m = l._has("cartesian");

            if (h) {
              var y = h.overlays.map(function (t) {
                return t.id;
              });
              s = s.concat(y);
            }

            for (var x = s.length, b = new Array(x), _ = new Array(x), w = !1, k = 0; k < x; k++) {
              var M = s[k];
              if (u[M]) w = !0, b[k] = u[M].xaxis, _[k] = u[M].yaxis;else {
                if (!l[M] || !l[M]._subplot) return void o.warn("Unrecognized subplot: " + M);
                var A = l[M]._subplot;
                b[k] = A.xaxis, _[k] = A.yaxis;
              }
            }

            var S = e.hovermode || l.hovermode;
            S && !w && (S = "closest");
            if (-1 === ["x", "y", "closest", "x unified", "y unified"].indexOf(S) || !t.calcdata || t.querySelector(".zoombox") || t._dragging) return d.unhoverRaw(t, e);
            var C = l.hoverdistance;
            -1 === C && (C = 1 / 0);
            var I = l.spikedistance;
            -1 === I && (I = 1 / 0);
            var F,
                N,
                j,
                U,
                V,
                q,
                H,
                G,
                Y,
                W,
                X,
                Z,
                J,
                K = [],
                Q = [],
                $ = {
              hLinePoint: null,
              vLinePoint: null
            },
                tt = !1;
            if (Array.isArray(e)) for (S = "array", j = 0; j < e.length; j++) {
              (V = t.calcdata[e[j].curveNumber || 0]) && (q = V[0].trace, "skip" !== V[0].trace.hoverinfo && (Q.push(V), "h" === q.orientation && (tt = !0)));
            } else {
              for (U = 0; U < t.calcdata.length; U++) {
                V = t.calcdata[U], "skip" !== (q = V[0].trace).hoverinfo && v.isTraceInSubplots(q, s) && (Q.push(V), "h" === q.orientation && (tt = !0));
              }

              var et, rt;
              if (!e.target) et = "xpx" in e ? e.xpx : b[0]._length / 2, rt = "ypx" in e ? e.ypx : _[0]._length / 2;else {
                if (!1 === c.triggerHandler(t, "plotly_beforehover", e)) return;
                var nt = e.composedPath && e.composedPath()[0];
                nt || (nt = e.target);
                var it = nt.getBoundingClientRect();
                et = e.clientX - it.left, rt = e.clientY - it.top, l._calcInverseTransform(t);
                var at = o.apply3DTransform(l._invTransform)(et, rt);
                if (et = at[0], rt = at[1], et < 0 || et > b[0]._length || rt < 0 || rt > _[0]._length) return d.unhoverRaw(t, e);
              }
              if (e.pointerX = et + b[0]._offset, e.pointerY = rt + _[0]._offset, F = "xval" in e ? v.flat(s, e.xval) : v.p2c(b, et), N = "yval" in e ? v.flat(s, e.yval) : v.p2c(_, rt), !i(F[0]) || !i(N[0])) return o.warn("Fx.hover failed", e, t), d.unhoverRaw(t, e);
            }
            var ot = 1 / 0;

            function st(t, r) {
              for (U = 0; U < Q.length; U++) {
                if ((V = Q[U]) && V[0] && V[0].trace && !0 === (q = V[0].trace).visible && 0 !== q._length && -1 === ["carpet", "contourcarpet"].indexOf(q._module.name)) {
                  if ("splom" === q.type ? H = s[G = 0] : (H = v.getSubplot(q), G = s.indexOf(H)), Y = S, v.isUnifiedHover(Y) && (Y = Y.charAt(0)), Z = {
                    cd: V,
                    trace: q,
                    xa: b[G],
                    ya: _[G],
                    maxHoverDistance: C,
                    maxSpikeDistance: I,
                    index: !1,
                    distance: Math.min(ot, C),
                    spikeDistance: 1 / 0,
                    xSpike: void 0,
                    ySpike: void 0,
                    color: p.defaultLine,
                    name: q.name,
                    x0: void 0,
                    x1: void 0,
                    y0: void 0,
                    y1: void 0,
                    xLabelVal: void 0,
                    yLabelVal: void 0,
                    zLabelVal: void 0,
                    text: void 0
                  }, l[H] && (Z.subplot = l[H]._subplot), l._splomScenes && l._splomScenes[q.uid] && (Z.scene = l._splomScenes[q.uid]), J = K.length, "array" === Y) {
                    var n = e[U];
                    "pointNumber" in n ? (Z.index = n.pointNumber, Y = "closest") : (Y = "", "xval" in n && (W = n.xval, Y = "x"), "yval" in n && (X = n.yval, Y = Y ? "closest" : "y"));
                  } else void 0 !== t && void 0 !== r ? (W = t, X = r) : (W = F[G], X = N[G]);

                  if (0 !== C) if (q._module && q._module.hoverPoints) {
                    var a = q._module.hoverPoints(Z, W, X, Y, {
                      finiteRange: !0,
                      hoverLayer: l._hoverlayer
                    });

                    if (a) for (var c, u = 0; u < a.length; u++) {
                      c = a[u], i(c.x0) && i(c.y0) && K.push(z(c, S));
                    }
                  } else o.log("Unrecognized trace type in hover:", q);

                  if ("closest" === S && K.length > J && (K.splice(0, J), ot = K[0].distance), m && 0 !== I && 0 === K.length) {
                    Z.distance = I, Z.index = !1;

                    var f = q._module.hoverPoints(Z, W, X, "closest", {
                      hoverLayer: l._hoverlayer
                    });

                    if (f && (f = f.filter(function (t) {
                      return t.spikeDistance <= I;
                    })), f && f.length) {
                      var h,
                          d = f.filter(function (t) {
                        return t.xa.showspikes && "hovered data" !== t.xa.spikesnap;
                      });

                      if (d.length) {
                        var g = d[0];
                        i(g.x0) && i(g.y0) && (h = ct(g), (!$.vLinePoint || $.vLinePoint.spikeDistance > h.spikeDistance) && ($.vLinePoint = h));
                      }

                      var y = f.filter(function (t) {
                        return t.ya.showspikes && "hovered data" !== t.ya.spikesnap;
                      });

                      if (y.length) {
                        var x = y[0];
                        i(x.x0) && i(x.y0) && (h = ct(x), (!$.hLinePoint || $.hLinePoint.spikeDistance > h.spikeDistance) && ($.hLinePoint = h));
                      }
                    }
                  }
                }
              }
            }

            function lt(t, e) {
              for (var r, n = null, i = 1 / 0, a = 0; a < t.length; a++) {
                (r = t[a].spikeDistance) <= i && r <= e && (n = t[a], i = r);
              }

              return n;
            }

            function ct(t) {
              return t ? {
                xa: t.xa,
                ya: t.ya,
                x: void 0 !== t.xSpike ? t.xSpike : (t.x0 + t.x1) / 2,
                y: void 0 !== t.ySpike ? t.ySpike : (t.y0 + t.y1) / 2,
                distance: t.distance,
                spikeDistance: t.spikeDistance,
                curveNumber: t.trace.index,
                color: t.color,
                pointNumber: t.index
              } : null;
            }

            st();
            var ut = {
              fullLayout: l,
              container: l._hoverlayer,
              outerContainer: l._paperdiv,
              event: e
            },
                ft = t._spikepoints,
                ht = {
              vLinePoint: $.vLinePoint,
              hLinePoint: $.hLinePoint
            };

            if (t._spikepoints = ht, m && 0 !== I && 0 !== K.length) {
              var pt = lt(K.filter(function (t) {
                return t.ya.showspikes;
              }), I);
              $.hLinePoint = ct(pt);
              var dt = lt(K.filter(function (t) {
                return t.xa.showspikes;
              }), I);
              $.vLinePoint = ct(dt);
            }

            if (0 === K.length) {
              var mt = d.unhoverRaw(t, e);
              return !m || null === $.hLinePoint && null === $.vLinePoint || R(ft) && D(t, $, ut), mt;
            }

            m && R(ft) && D(t, $, ut);

            var gt = function gt() {
              K.sort(function (t, e) {
                return t.distance - e.distance;
              }), K = function (t, e) {
                for (var r = e.charAt(0), n = [], i = [], a = [], o = 0; o < t.length; o++) {
                  var s = t[o];
                  g.traceIs(s.trace, "bar-like") || g.traceIs(s.trace, "box-violin") ? a.push(s) : s.trace[r + "period"] ? i.push(s) : n.push(s);
                }

                return n.concat(i).concat(a);
              }(K, S);
            };

            if (gt(), v.isXYhover(Y) && 0 !== K[0].length && "splom" !== K[0].trace.type) {
              var vt = K[0],
                  yt = (K = E[vt.trace.type] ? K.filter(function (t) {
                return t.trace.index === vt.trace.index;
              }) : [vt]).length,
                  xt = B("x", vt, l),
                  bt = B("y", vt, l);
              st(xt, bt);

              var _t,
                  wt = [],
                  Tt = {},
                  kt = 0,
                  Mt = function Mt(t) {
                var e = E[t.trace.type] ? L(t) : t.trace.index;

                if (Tt[e]) {
                  var r = Tt[e] - 1,
                      n = wt[r];
                  r > 0 && Math.abs(t.distance) < Math.abs(n.distance) && (wt[r] = t);
                } else kt++, Tt[e] = kt, wt.push(t);
              };

              for (_t = 0; _t < yt; _t++) {
                Mt(K[_t]);
              }

              for (_t = K.length - 1; _t > yt - 1; _t--) {
                Mt(K[_t]);
              }

              K = wt, gt();
            }

            var At = t._hoverdata,
                St = [];

            for (j = 0; j < K.length; j++) {
              var Et = K[j],
                  Lt = v.makeEventData(Et, Et.trace, Et.cd);

              if (!1 !== Et.hovertemplate) {
                var Ct = !1;
                Et.cd[Et.index] && Et.cd[Et.index].ht && (Ct = Et.cd[Et.index].ht), Et.hovertemplate = Ct || Et.trace.hovertemplate || !1;
              }

              Et.eventData = [Lt], St.push(Lt);
            }

            t._hoverdata = St;
            var Pt = "y" === S && (Q.length > 1 || K.length > 1) || "closest" === S && tt && K.length > 1,
                It = p.combine(l.plot_bgcolor || p.background, l.paper_bgcolor),
                Ot = {
              hovermode: S,
              rotateLabels: Pt,
              bgColor: It,
              container: l._hoverlayer,
              outerContainer: l._paperdiv,
              commonLabelOpts: l.hoverlabel,
              hoverdistance: l.hoverdistance
            },
                zt = P(K, Ot, t);
            v.isUnifiedHover(S) || (!function (t, e, r) {
              var n,
                  i,
                  a,
                  o,
                  s,
                  l,
                  c,
                  u = 0,
                  f = 1,
                  h = t.size(),
                  p = new Array(h),
                  d = 0;

              function m(t) {
                var e = t[0],
                    r = t[t.length - 1];

                if (i = e.pmin - e.pos - e.dp + e.size, a = r.pos + r.dp + r.size - e.pmax, i > .01) {
                  for (s = t.length - 1; s >= 0; s--) {
                    t[s].dp += i;
                  }

                  n = !1;
                }

                if (!(a < .01)) {
                  if (i < -.01) {
                    for (s = t.length - 1; s >= 0; s--) {
                      t[s].dp -= a;
                    }

                    n = !1;
                  }

                  if (n) {
                    var c = 0;

                    for (o = 0; o < t.length; o++) {
                      (l = t[o]).pos + l.dp + l.size > e.pmax && c++;
                    }

                    for (o = t.length - 1; o >= 0 && !(c <= 0); o--) {
                      (l = t[o]).pos > e.pmax - 1 && (l.del = !0, c--);
                    }

                    for (o = 0; o < t.length && !(c <= 0); o++) {
                      if ((l = t[o]).pos < e.pmin + 1) for (l.del = !0, c--, a = 2 * l.size, s = t.length - 1; s >= 0; s--) {
                        t[s].dp -= a;
                      }
                    }

                    for (o = t.length - 1; o >= 0 && !(c <= 0); o--) {
                      (l = t[o]).pos + l.dp + l.size > e.pmax && (l.del = !0, c--);
                    }
                  }
                }
              }

              t.each(function (t) {
                var n = t[e],
                    i = "x" === n._id.charAt(0),
                    a = n.range;

                0 === d && a && a[0] > a[1] !== i && (f = -1), p[d++] = [{
                  datum: t,
                  traceIndex: t.trace.index,
                  dp: 0,
                  pos: t.pos,
                  posref: t.posref,
                  size: t.by * (i ? T : 1) / 2,
                  pmin: 0,
                  pmax: i ? r.width : r.height
                }];
              }), p.sort(function (t, e) {
                return t[0].posref - e[0].posref || f * (e[0].traceIndex - t[0].traceIndex);
              });

              for (; !n && u <= h;) {
                for (u++, n = !0, o = 0; o < p.length - 1;) {
                  var g = p[o],
                      v = p[o + 1],
                      y = g[g.length - 1],
                      x = v[0];

                  if ((i = y.pos + y.dp + y.size - x.pos - x.dp + x.size) > .01 && y.pmin === x.pmin && y.pmax === x.pmax) {
                    for (s = v.length - 1; s >= 0; s--) {
                      v[s].dp += i;
                    }

                    for (g.push.apply(g, v), p.splice(o + 1, 1), c = 0, s = g.length - 1; s >= 0; s--) {
                      c += g[s].dp;
                    }

                    for (a = c / g.length, s = g.length - 1; s >= 0; s--) {
                      g[s].dp -= a;
                    }

                    n = !1;
                  } else o++;
                }

                p.forEach(m);
              }

              for (o = p.length - 1; o >= 0; o--) {
                var b = p[o];

                for (s = b.length - 1; s >= 0; s--) {
                  var _ = b[s],
                      w = _.datum;
                  w.offset = _.dp, w.del = _.del;
                }
              }
            }(zt, Pt ? "xa" : "ya", l), O(zt, Pt, l._invScaleX, l._invScaleY));

            if (e.target && e.target.tagName) {
              var Dt = g.getComponentMethod("annotations", "hasClickToShow")(t, St);
              f(n.select(e.target), Dt ? "pointer" : "");
            }

            if (!e.target || a || !function (t, e, r) {
              if (!r || r.length !== t._hoverdata.length) return !0;

              for (var n = r.length - 1; n >= 0; n--) {
                var i = r[n],
                    a = t._hoverdata[n];
                if (i.curveNumber !== a.curveNumber || String(i.pointNumber) !== String(a.pointNumber) || String(i.pointNumbers) !== String(a.pointNumbers)) return !0;
              }

              return !1;
            }(t, 0, At)) return;
            At && t.emit("plotly_unhover", {
              event: e,
              points: At
            });
            t.emit("plotly_hover", {
              event: e,
              points: t._hoverdata,
              xaxes: b,
              yaxes: _,
              xvals: F,
              yvals: N
            });
          }(t, e, r, a);
        });
      }, r.loneHover = function (t, e) {
        var r = !0;
        Array.isArray(t) || (r = !1, t = [t]);
        var i = t.map(function (t) {
          return {
            color: t.color || p.defaultLine,
            x0: t.x0 || t.x || 0,
            x1: t.x1 || t.x || 0,
            y0: t.y0 || t.y || 0,
            y1: t.y1 || t.y || 0,
            xLabel: t.xLabel,
            yLabel: t.yLabel,
            zLabel: t.zLabel,
            text: t.text,
            name: t.name,
            idealAlign: t.idealAlign,
            borderColor: t.borderColor,
            fontFamily: t.fontFamily,
            fontSize: t.fontSize,
            fontColor: t.fontColor,
            nameLength: t.nameLength,
            textAlign: t.textAlign,
            trace: t.trace || {
              index: 0,
              hoverinfo: ""
            },
            xa: {
              _offset: 0
            },
            ya: {
              _offset: 0
            },
            index: 0,
            hovertemplate: t.hovertemplate || !1,
            eventData: t.eventData || !1,
            hovertemplateLabels: t.hovertemplateLabels || !1
          };
        }),
            a = n.select(e.container),
            o = e.outerContainer ? n.select(e.outerContainer) : a,
            s = {
          hovermode: "closest",
          rotateLabels: !1,
          bgColor: e.bgColor || p.background,
          container: a,
          outerContainer: o
        },
            l = P(i, s, e.gd),
            c = 0,
            u = 0;
        l.sort(function (t, e) {
          return t.y0 - e.y0;
        }).each(function (t, r) {
          var n = t.y0 - t.by / 2;
          t.offset = n - 5 < c ? c - n + 5 : 0, c = n + t.by + t.offset, r === e.anchorIndex && (u = t.offset);
        }).each(function (t) {
          t.offset -= u;
        });
        var f = e.gd._fullLayout._invScaleX,
            h = e.gd._fullLayout._invScaleY;
        return O(l, s.rotateLabels, f, h), r ? l : l.node();
      };
      var C = /<extra>([\s\S]*)<\/extra>/;

      function P(t, e, r) {
        var i = r._fullLayout,
            a = e.hovermode,
            c = e.rotateLabels,
            f = e.bgColor,
            d = e.container,
            m = e.outerContainer,
            g = e.commonLabelOpts || {},
            w = e.fontFamily || y.HOVERFONT,
            T = e.fontSize || y.HOVERFONTSIZE,
            k = t[0],
            M = k.xa,
            E = k.ya,
            C = a.charAt(0),
            P = k[C + "Label"],
            O = m.node().getBoundingClientRect(),
            z = O.top,
            D = O.width,
            R = O.height,
            F = void 0 !== P && k.distance <= e.hoverdistance && ("x" === a || "y" === a);

        if (F) {
          var B,
              N,
              j = !0;

          for (B = 0; B < t.length; B++) {
            if (j && void 0 === t[B].zLabel && (j = !1), N = t[B].hoverinfo || t[B].trace.hoverinfo) {
              var U = Array.isArray(N) ? N : N.split("+");

              if (-1 === U.indexOf("all") && -1 === U.indexOf(a)) {
                F = !1;
                break;
              }
            }
          }

          j && (F = !1);
        }

        var V = d.selectAll("g.axistext").data(F ? [0] : []);

        if (V.enter().append("g").classed("axistext", !0), V.exit().remove(), V.each(function () {
          var t = n.select(this),
              e = o.ensureSingle(t, "path", "", function (t) {
            t.style({
              "stroke-width": "1px"
            });
          }),
              l = o.ensureSingle(t, "text", "", function (t) {
            t.attr("data-notex", 1);
          }),
              c = g.bgcolor || p.defaultLine,
              f = g.bordercolor || p.contrast(c),
              d = p.contrast(c),
              m = {
            family: g.font.family || w,
            size: g.font.size || T,
            color: g.font.color || d
          };
          e.style({
            fill: c,
            stroke: f
          }), l.text(P).call(h.font, m).call(u.positionText, 0, 0).call(u.convertToTspans, r), t.attr("transform", "");
          var v,
              y,
              x = l.node().getBoundingClientRect();

          if ("x" === a) {
            var b = "top" === M.side ? "-" : "";
            l.attr("text-anchor", "middle").call(u.positionText, 0, "top" === M.side ? z - x.bottom - A - S : z - x.top + A + S), v = M._offset + (k.x0 + k.x1) / 2, y = E._offset + ("top" === M.side ? 0 : E._length);

            var _ = x.width / 2 + S;

            v < _ ? (v = _, e.attr("d", "M-" + (_ - A) + ",0L-" + (_ - 2 * A) + "," + b + A + "H" + (S + x.width / 2) + "v" + b + (2 * S + x.height) + "H-" + _ + "V" + b + A + "Z")) : v > i.width - _ ? (v = i.width - _, e.attr("d", "M" + (_ - A) + ",0L" + _ + "," + b + A + "v" + b + (2 * S + x.height) + "H-" + _ + "V" + b + A + "H" + (_ - 2 * A) + "Z")) : e.attr("d", "M0,0L" + A + "," + b + A + "H" + (S + x.width / 2) + "v" + b + (2 * S + x.height) + "H-" + (S + x.width / 2) + "V" + b + A + "H-" + A + "Z");
          } else {
            var L, C, I;
            "right" === E.side ? (L = "start", C = 1, I = "", v = M._offset + M._length) : (L = "end", C = -1, I = "-", v = M._offset), y = E._offset + (k.y0 + k.y1) / 2, l.attr("text-anchor", L), e.attr("d", "M0,0L" + I + A + "," + A + "V" + (S + x.height / 2) + "h" + I + (2 * S + x.width) + "V-" + (S + x.height / 2) + "H" + I + A + "V-" + A + "Z");
            var O,
                D = x.height / 2,
                R = z - x.top - D,
                F = "clip" + i._uid + "commonlabel" + E._id;

            if (v < x.width + 2 * S + A) {
              O = "M-" + (A + S) + "-" + D + "h-" + (x.width - S) + "V" + D + "h" + (x.width - S) + "Z";
              var B = x.width - v + S;
              u.positionText(l, B, R), "end" === L && l.selectAll("tspan").each(function () {
                var t = n.select(this),
                    e = h.tester.append("text").text(t.text()).call(h.font, m),
                    r = e.node().getBoundingClientRect();
                Math.round(r.width) < Math.round(x.width) && t.attr("x", B - r.width), e.remove();
              });
            } else u.positionText(l, C * (S + A), R), O = null;

            var N = i._topclips.selectAll("#" + F).data(O ? [0] : []);

            N.enter().append("clipPath").attr("id", F).append("path"), N.exit().remove(), N.select("path").attr("d", O), h.setClipUrl(l, O ? F : null, r);
          }

          t.attr("transform", s(v, y));
        }), v.isUnifiedHover(a)) {
          if (d.selectAll("g.hovertext").remove(), 0 === t.length) return;
          var q = {
            showlegend: !0,
            legend: {
              title: {
                text: P,
                font: i.hoverlabel.font
              },
              font: i.hoverlabel.font,
              bgcolor: i.hoverlabel.bgcolor,
              bordercolor: i.hoverlabel.bordercolor,
              borderwidth: 1,
              tracegroupgap: 7,
              traceorder: i.legend ? i.legend.traceorder : void 0,
              orientation: "v"
            }
          },
              H = {};
          x(q, H, r._fullData);
          var G = H.legend;
          G.entries = [];

          for (var Y = 0; Y < t.length; Y++) {
            var W = I(t[Y], !0, a, i, P),
                X = W[0],
                Z = W[1],
                J = t[Y];
            J.name = Z, J.text = "" !== Z ? Z + " : " + X : X;
            var K = J.cd[J.index];
            K && (K.mc && (J.mc = K.mc), K.mcc && (J.mc = K.mcc), K.mlc && (J.mlc = K.mlc), K.mlcc && (J.mlc = K.mlcc), K.mlw && (J.mlw = K.mlw), K.mrc && (J.mrc = K.mrc), K.dir && (J.dir = K.dir)), J._distinct = !0, G.entries.push([J]);
          }

          G.entries.sort(function (t, e) {
            return t[0].trace.index - e[0].trace.index;
          }), G.layer = d, G._inHover = !0, b(r, G);
          var Q = t[0],
              $ = (Q.y0 + Q.y1) / 2,
              tt = (Q.x0 + Q.x1) / 2,
              et = d.select("g.legend"),
              rt = et.node().getBoundingClientRect();
          tt += M._offset, $ += E._offset - rt.height / 2;
          var nt = rt.width + 2 * S;
          !(tt + nt <= D) && tt - nt >= 0 ? tt -= nt : tt += 2 * S;
          var it = rt.height + 2 * S,
              at = $ + it >= R;
          return it <= R && ($ <= z ? $ = E._offset + 2 * S : at && ($ = R - it)), et.attr("transform", s(tt, $)), et;
        }

        var ot = d.selectAll("g.hovertext").data(t, function (t) {
          return L(t);
        });
        return ot.enter().append("g").classed("hovertext", !0).each(function () {
          var t = n.select(this);
          t.append("rect").call(p.fill, p.addOpacity(f, .8)), t.append("text").classed("name", !0), t.append("path").style("stroke-width", "1px"), t.append("text").classed("nums", !0).call(h.font, w, T);
        }), ot.exit().remove(), ot.each(function (t) {
          var e = n.select(this).attr("transform", ""),
              o = t.color;
          Array.isArray(o) && (o = o[t.eventData[0].pointNumber]);
          var d = t.bgcolor || o,
              m = p.combine(p.opacity(d) ? d : p.defaultLine, f),
              g = p.combine(p.opacity(o) ? o : p.defaultLine, f),
              v = t.borderColor || p.contrast(m),
              y = I(t, F, a, i, P, e),
              x = y[0],
              b = y[1],
              k = e.select("text.nums").call(h.font, t.fontFamily || w, t.fontSize || T, t.fontColor || v).text(x).attr("data-notex", 1).call(u.positionText, 0, 0).call(u.convertToTspans, r),
              M = e.select("text.name"),
              E = 0,
              L = 0;

          if (b && b !== x) {
            M.call(h.font, t.fontFamily || w, t.fontSize || T, g).text(b).attr("data-notex", 1).call(u.positionText, 0, 0).call(u.convertToTspans, r);
            var C = M.node().getBoundingClientRect();
            E = C.width + 2 * S, L = C.height + 2 * S;
          } else M.remove(), e.select("rect").remove();

          e.select("path").style({
            fill: m,
            stroke: v
          });
          var O,
              B,
              N = k.node().getBoundingClientRect(),
              j = t.xa._offset + (t.x0 + t.x1) / 2,
              U = t.ya._offset + (t.y0 + t.y1) / 2,
              V = Math.abs(t.x1 - t.x0),
              q = Math.abs(t.y1 - t.y0),
              H = N.width + A + S + E;
          if (t.ty0 = z - N.top, t.bx = N.width + 2 * S, t.by = Math.max(N.height + 2 * S, L), t.anchor = "start", t.txwidth = N.width, t.tx2width = E, t.offset = 0, c) t.pos = j, O = U + q / 2 + H <= R, B = U - q / 2 - H >= 0, "top" !== t.idealAlign && O || !B ? O ? (U += q / 2, t.anchor = "start") : t.anchor = "middle" : (U -= q / 2, t.anchor = "end");else if (t.pos = U, O = j + V / 2 + H <= D, B = j - V / 2 - H >= 0, "left" !== t.idealAlign && O || !B) {
            if (O) j += V / 2, t.anchor = "start";else {
              t.anchor = "middle";
              var G = H / 2,
                  Y = j + G - D,
                  W = j - G;
              Y > 0 && (j -= Y), W < 0 && (j += -W);
            }
          } else j -= V / 2, t.anchor = "end";
          k.attr("text-anchor", t.anchor), E && M.attr("text-anchor", t.anchor), e.attr("transform", s(j, U) + (c ? l(_) : ""));
        }), ot;
      }

      function I(t, e, r, n, i, a) {
        var s = "",
            l = "";
        void 0 !== t.nameOverride && (t.name = t.nameOverride), t.name && (t.trace._meta && (t.name = o.templateString(t.name, t.trace._meta)), s = F(t.name, t.nameLength));
        var c = r.charAt(0),
            u = "x" === c ? "y" : "x";
        void 0 !== t.zLabel ? (void 0 !== t.xLabel && (l += "x: " + t.xLabel + "<br>"), void 0 !== t.yLabel && (l += "y: " + t.yLabel + "<br>"), "choropleth" !== t.trace.type && "choroplethmapbox" !== t.trace.type && (l += (l ? "z: " : "") + t.zLabel)) : e && t[c + "Label"] === i ? l = t[u + "Label"] || "" : void 0 === t.xLabel ? void 0 !== t.yLabel && "scattercarpet" !== t.trace.type && (l = t.yLabel) : l = void 0 === t.yLabel ? t.xLabel : "(" + t.xLabel + ", " + t.yLabel + ")", !t.text && 0 !== t.text || Array.isArray(t.text) || (l += (l ? "<br>" : "") + t.text), void 0 !== t.extraText && (l += (l ? "<br>" : "") + t.extraText), a && "" === l && !t.hovertemplate && ("" === s && a.remove(), l = s);
        var f = t.hovertemplate || !1;

        if (f) {
          var h = t.hovertemplateLabels || t;
          t[c + "Label"] !== i && (h[c + "other"] = h[c + "Val"], h[c + "otherLabel"] = h[c + "Label"]), l = (l = o.hovertemplateString(f, h, n._d3locale, t.eventData[0] || {}, t.trace._meta)).replace(C, function (e, r) {
            return s = F(r, t.nameLength), "";
          });
        }

        return [l, s];
      }

      function O(t, e, r, i) {
        var a = function a(t) {
          return t * r;
        },
            o = function o(t) {
          return t * i;
        };

        t.each(function (t) {
          var r = n.select(this);
          if (t.del) return r.remove();
          var i = r.select("text.nums"),
              s = t.anchor,
              l = "end" === s ? -1 : 1,
              c = {
            start: 1,
            end: -1,
            middle: 0
          }[s],
              f = c * (A + S),
              p = f + c * (t.txwidth + S),
              d = 0,
              m = t.offset,
              g = "middle" === s;
          g && (f -= t.tx2width / 2, p += t.txwidth / 2 + S), e && (m *= -M, d = t.offset * k), r.select("path").attr("d", g ? "M-" + a(t.bx / 2 + t.tx2width / 2) + "," + o(m - t.by / 2) + "h" + a(t.bx) + "v" + o(t.by) + "h-" + a(t.bx) + "Z" : "M0,0L" + a(l * A + d) + "," + o(A + m) + "v" + o(t.by / 2 - A) + "h" + a(l * t.bx) + "v-" + o(t.by) + "H" + a(l * A + d) + "V" + o(m - A) + "Z");
          var v = d + f,
              y = m + t.ty0 - t.by / 2 + S,
              x = t.textAlign || "auto";
          "auto" !== x && ("left" === x && "start" !== s ? (i.attr("text-anchor", "start"), v = g ? -t.bx / 2 - t.tx2width / 2 + S : -t.bx - S) : "right" === x && "end" !== s && (i.attr("text-anchor", "end"), v = g ? t.bx / 2 - t.tx2width / 2 - S : t.bx + S)), i.call(u.positionText, a(v), o(y)), t.tx2width && (r.select("text.name").call(u.positionText, a(p + c * S + d), o(m + t.ty0 - t.by / 2 + S)), r.select("rect").call(h.setRect, a(p + (c - 1) * t.tx2width / 2 + d), o(m - t.by / 2 - 1), a(t.tx2width), o(t.by + 2)));
        });
      }

      function z(t, e) {
        var r = t.index,
            n = t.trace || {},
            a = t.cd[0],
            s = t.cd[r] || {};

        function l(t) {
          return t || i(t) && 0 === t;
        }

        var c = Array.isArray(r) ? function (t, e) {
          var i = o.castOption(a, r, t);
          return l(i) ? i : o.extractOption({}, n, "", e);
        } : function (t, e) {
          return o.extractOption(s, n, t, e);
        };

        function u(e, r, n) {
          var i = c(r, n);
          l(i) && (t[e] = i);
        }

        if (u("hoverinfo", "hi", "hoverinfo"), u("bgcolor", "hbg", "hoverlabel.bgcolor"), u("borderColor", "hbc", "hoverlabel.bordercolor"), u("fontFamily", "htf", "hoverlabel.font.family"), u("fontSize", "hts", "hoverlabel.font.size"), u("fontColor", "htc", "hoverlabel.font.color"), u("nameLength", "hnl", "hoverlabel.namelength"), u("textAlign", "hta", "hoverlabel.align"), t.posref = "y" === e || "closest" === e && "h" === n.orientation ? t.xa._offset + (t.x0 + t.x1) / 2 : t.ya._offset + (t.y0 + t.y1) / 2, t.x0 = o.constrain(t.x0, 0, t.xa._length), t.x1 = o.constrain(t.x1, 0, t.xa._length), t.y0 = o.constrain(t.y0, 0, t.ya._length), t.y1 = o.constrain(t.y1, 0, t.ya._length), void 0 !== t.xLabelVal && (t.xLabel = "xLabel" in t ? t.xLabel : m.hoverLabelText(t.xa, t.xLabelVal, n.xhoverformat), t.xVal = t.xa.c2d(t.xLabelVal)), void 0 !== t.yLabelVal && (t.yLabel = "yLabel" in t ? t.yLabel : m.hoverLabelText(t.ya, t.yLabelVal, n.yhoverformat), t.yVal = t.ya.c2d(t.yLabelVal)), void 0 !== t.zLabelVal && void 0 === t.zLabel && (t.zLabel = String(t.zLabelVal)), !(isNaN(t.xerr) || "log" === t.xa.type && t.xerr <= 0)) {
          var f = m.tickText(t.xa, t.xa.c2l(t.xerr), "hover").text;
          void 0 !== t.xerrneg ? t.xLabel += " +" + f + " / -" + m.tickText(t.xa, t.xa.c2l(t.xerrneg), "hover").text : t.xLabel += " \xb1 " + f, "x" === e && (t.distance += 1);
        }

        if (!(isNaN(t.yerr) || "log" === t.ya.type && t.yerr <= 0)) {
          var h = m.tickText(t.ya, t.ya.c2l(t.yerr), "hover").text;
          void 0 !== t.yerrneg ? t.yLabel += " +" + h + " / -" + m.tickText(t.ya, t.ya.c2l(t.yerrneg), "hover").text : t.yLabel += " \xb1 " + h, "y" === e && (t.distance += 1);
        }

        var p = t.hoverinfo || t.trace.hoverinfo;
        return p && "all" !== p && (-1 === (p = Array.isArray(p) ? p : p.split("+")).indexOf("x") && (t.xLabel = void 0), -1 === p.indexOf("y") && (t.yLabel = void 0), -1 === p.indexOf("z") && (t.zLabel = void 0), -1 === p.indexOf("text") && (t.text = void 0), -1 === p.indexOf("name") && (t.name = void 0)), t;
      }

      function D(t, e, r) {
        var n,
            i,
            o = r.container,
            s = r.fullLayout,
            l = s._size,
            c = r.event,
            u = !!e.hLinePoint,
            f = !!e.vLinePoint;

        if (o.selectAll(".spikeline").remove(), f || u) {
          var d = p.combine(s.plot_bgcolor, s.paper_bgcolor);

          if (u) {
            var g,
                v,
                y = e.hLinePoint;
            n = y && y.xa, "cursor" === (i = y && y.ya).spikesnap ? (g = c.pointerX, v = c.pointerY) : (g = n._offset + y.x, v = i._offset + y.y);

            var x,
                b,
                _ = a.readability(y.color, d) < 1.5 ? p.contrast(d) : y.color,
                w = i.spikemode,
                T = i.spikethickness,
                k = i.spikecolor || _,
                M = m.getPxPosition(t, i);

            if (-1 !== w.indexOf("toaxis") || -1 !== w.indexOf("across")) {
              if (-1 !== w.indexOf("toaxis") && (x = M, b = g), -1 !== w.indexOf("across")) {
                var A = i._counterDomainMin,
                    S = i._counterDomainMax;
                "free" === i.anchor && (A = Math.min(A, i.position), S = Math.max(S, i.position)), x = l.l + A * l.w, b = l.l + S * l.w;
              }

              o.insert("line", ":first-child").attr({
                x1: x,
                x2: b,
                y1: v,
                y2: v,
                "stroke-width": T,
                stroke: k,
                "stroke-dasharray": h.dashStyle(i.spikedash, T)
              }).classed("spikeline", !0).classed("crisp", !0), o.insert("line", ":first-child").attr({
                x1: x,
                x2: b,
                y1: v,
                y2: v,
                "stroke-width": T + 2,
                stroke: d
              }).classed("spikeline", !0).classed("crisp", !0);
            }

            -1 !== w.indexOf("marker") && o.insert("circle", ":first-child").attr({
              cx: M + ("right" !== i.side ? T : -T),
              cy: v,
              r: T,
              fill: k
            }).classed("spikeline", !0);
          }

          if (f) {
            var E,
                L,
                C = e.vLinePoint;
            n = C && C.xa, i = C && C.ya, "cursor" === n.spikesnap ? (E = c.pointerX, L = c.pointerY) : (E = n._offset + C.x, L = i._offset + C.y);
            var P,
                I,
                O = a.readability(C.color, d) < 1.5 ? p.contrast(d) : C.color,
                z = n.spikemode,
                D = n.spikethickness,
                R = n.spikecolor || O,
                F = m.getPxPosition(t, n);

            if (-1 !== z.indexOf("toaxis") || -1 !== z.indexOf("across")) {
              if (-1 !== z.indexOf("toaxis") && (P = F, I = L), -1 !== z.indexOf("across")) {
                var B = n._counterDomainMin,
                    N = n._counterDomainMax;
                "free" === n.anchor && (B = Math.min(B, n.position), N = Math.max(N, n.position)), P = l.t + (1 - N) * l.h, I = l.t + (1 - B) * l.h;
              }

              o.insert("line", ":first-child").attr({
                x1: E,
                x2: E,
                y1: P,
                y2: I,
                "stroke-width": D,
                stroke: R,
                "stroke-dasharray": h.dashStyle(n.spikedash, D)
              }).classed("spikeline", !0).classed("crisp", !0), o.insert("line", ":first-child").attr({
                x1: E,
                x2: E,
                y1: P,
                y2: I,
                "stroke-width": D + 2,
                stroke: d
              }).classed("spikeline", !0).classed("crisp", !0);
            }

            -1 !== z.indexOf("marker") && o.insert("circle", ":first-child").attr({
              cx: E,
              cy: F - ("top" !== n.side ? D : -D),
              r: D,
              fill: R
            }).classed("spikeline", !0);
          }
        }
      }

      function R(t, e) {
        return !e || e.vLinePoint !== t._spikepoints.vLinePoint || e.hLinePoint !== t._spikepoints.hLinePoint;
      }

      function F(t, e) {
        return u.plainText(t || "", {
          len: e,
          allowedTags: ["br", "sub", "sup", "b", "i", "em"]
        });
      }

      function B(t, e, r) {
        var n = e[t + "a"],
            i = e[t + "Val"];
        "category" === n.type ? i = n._categoriesMap[i] : "date" === n.type && (i = n.d2c(i));
        var a = e.cd[e.index];
        return a && a.t && a.t.posLetter === n._id && ("group" !== r.boxmode && "group" !== r.violinmode || (i += a.t.dPos)), i;
      }
    }, {
      "../../lib": 795,
      "../../lib/events": 784,
      "../../lib/override_cursor": 806,
      "../../lib/svg_text_utils": 820,
      "../../plots/cartesian/axes": 845,
      "../../registry": 923,
      "../color": 658,
      "../dragelement": 677,
      "../drawing": 680,
      "../legend/defaults": 710,
      "../legend/draw": 711,
      "./constants": 692,
      "./helpers": 694,
      "@plotly/d3": 57,
      "fast-isnumeric": 240,
      tinycolor2: 590
    }],
    696: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../color"),
          a = t("./helpers").isUnifiedHover;

      e.exports = function (t, e, r, o) {
        function s(t) {
          o.font[t] || (o.font[t] = e.legend ? e.legend.font[t] : e.font[t]);
        }

        o = o || {}, e && a(e.hovermode) && (o.font || (o.font = {}), s("size"), s("family"), s("color"), e.legend ? (o.bgcolor || (o.bgcolor = i.combine(e.legend.bgcolor, e.paper_bgcolor)), o.bordercolor || (o.bordercolor = e.legend.bordercolor)) : o.bgcolor || (o.bgcolor = e.paper_bgcolor)), r("hoverlabel.bgcolor", o.bgcolor), r("hoverlabel.bordercolor", o.bordercolor), r("hoverlabel.namelength", o.namelength), n.coerceFont(r, "hoverlabel.font", o.font), r("hoverlabel.align", o.align);
      };
    }, {
      "../../lib": 795,
      "../color": 658,
      "./helpers": 694
    }],
    697: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./layout_attributes");

      e.exports = function (t, e) {
        function r(r, a) {
          return void 0 !== e[r] ? e[r] : n.coerce(t, e, i, r, a);
        }

        return r("clickmode"), r("hovermode");
      };
    }, {
      "../../lib": 795,
      "./layout_attributes": 699
    }],
    698: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../lib"),
          a = t("../dragelement"),
          o = t("./helpers"),
          s = t("./layout_attributes"),
          l = t("./hover");
      e.exports = {
        moduleType: "component",
        name: "fx",
        constants: t("./constants"),
        schema: {
          layout: s
        },
        attributes: t("./attributes"),
        layoutAttributes: s,
        supplyLayoutGlobalDefaults: t("./layout_global_defaults"),
        supplyDefaults: t("./defaults"),
        supplyLayoutDefaults: t("./layout_defaults"),
        calc: t("./calc"),
        getDistanceFunction: o.getDistanceFunction,
        getClosest: o.getClosest,
        inbox: o.inbox,
        quadrature: o.quadrature,
        appendArrayPointValue: o.appendArrayPointValue,
        castHoverOption: function castHoverOption(t, e, r) {
          return i.castOption(t, e, "hoverlabel." + r);
        },
        castHoverinfo: function castHoverinfo(t, e, r) {
          return i.castOption(t, r, "hoverinfo", function (r) {
            return i.coerceHoverinfo({
              hoverinfo: r
            }, {
              _module: t._module
            }, e);
          });
        },
        hover: l.hover,
        unhover: a.unhover,
        loneHover: l.loneHover,
        loneUnhover: function loneUnhover(t) {
          var e = i.isD3Selection(t) ? t : n.select(t);
          e.selectAll("g.hovertext").remove(), e.selectAll(".spikeline").remove();
        },
        click: t("./click")
      };
    }, {
      "../../lib": 795,
      "../dragelement": 677,
      "./attributes": 689,
      "./calc": 690,
      "./click": 691,
      "./constants": 692,
      "./defaults": 693,
      "./helpers": 694,
      "./hover": 695,
      "./layout_attributes": 699,
      "./layout_defaults": 700,
      "./layout_global_defaults": 701,
      "@plotly/d3": 57
    }],
    699: [function (t, e, r) {
      "use strict";

      var n = t("./constants"),
          i = t("../../plots/font_attributes")({
        editType: "none"
      });
      i.family.dflt = n.HOVERFONT, i.size.dflt = n.HOVERFONTSIZE, e.exports = {
        clickmode: {
          valType: "flaglist",
          flags: ["event", "select"],
          dflt: "event",
          editType: "plot",
          extras: ["none"]
        },
        dragmode: {
          valType: "enumerated",
          values: ["zoom", "pan", "select", "lasso", "drawclosedpath", "drawopenpath", "drawline", "drawrect", "drawcircle", "orbit", "turntable", !1],
          dflt: "zoom",
          editType: "modebar"
        },
        hovermode: {
          valType: "enumerated",
          values: ["x", "y", "closest", !1, "x unified", "y unified"],
          dflt: "closest",
          editType: "modebar"
        },
        hoverdistance: {
          valType: "integer",
          min: -1,
          dflt: 20,
          editType: "none"
        },
        spikedistance: {
          valType: "integer",
          min: -1,
          dflt: -1,
          editType: "none"
        },
        hoverlabel: {
          bgcolor: {
            valType: "color",
            editType: "none"
          },
          bordercolor: {
            valType: "color",
            editType: "none"
          },
          font: i,
          align: {
            valType: "enumerated",
            values: ["left", "right", "auto"],
            dflt: "auto",
            editType: "none"
          },
          namelength: {
            valType: "integer",
            min: -1,
            dflt: 15,
            editType: "none"
          },
          editType: "none"
        },
        selectdirection: {
          valType: "enumerated",
          values: ["h", "v", "d", "any"],
          dflt: "any",
          editType: "none"
        }
      };
    }, {
      "../../plots/font_attributes": 873,
      "./constants": 692
    }],
    700: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./layout_attributes"),
          a = t("./hovermode_defaults"),
          o = t("./hoverlabel_defaults");

      e.exports = function (t, e) {
        function r(r, a) {
          return n.coerce(t, e, i, r, a);
        }

        a(t, e) && (r("hoverdistance"), r("spikedistance")), "select" === r("dragmode") && r("selectdirection");

        var s = e._has("mapbox"),
            l = e._has("geo"),
            c = e._basePlotModules.length;

        "zoom" === e.dragmode && ((s || l) && 1 === c || s && l && 2 === c) && (e.dragmode = "pan"), o(t, e, r);
      };
    }, {
      "../../lib": 795,
      "./hoverlabel_defaults": 696,
      "./hovermode_defaults": 697,
      "./layout_attributes": 699
    }],
    701: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./hoverlabel_defaults"),
          a = t("./layout_attributes");

      e.exports = function (t, e) {
        i(t, e, function (r, i) {
          return n.coerce(t, e, a, r, i);
        });
      };
    }, {
      "../../lib": 795,
      "./hoverlabel_defaults": 696,
      "./layout_attributes": 699
    }],
    702: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../lib/regex").counter,
          a = t("../../plots/domain").attributes,
          o = t("../../plots/cartesian/constants").idRegex,
          s = t("../../plot_api/plot_template"),
          l = {
        rows: {
          valType: "integer",
          min: 1,
          editType: "plot"
        },
        roworder: {
          valType: "enumerated",
          values: ["top to bottom", "bottom to top"],
          dflt: "top to bottom",
          editType: "plot"
        },
        columns: {
          valType: "integer",
          min: 1,
          editType: "plot"
        },
        subplots: {
          valType: "info_array",
          freeLength: !0,
          dimensions: 2,
          items: {
            valType: "enumerated",
            values: [i("xy").toString(), ""],
            editType: "plot"
          },
          editType: "plot"
        },
        xaxes: {
          valType: "info_array",
          freeLength: !0,
          items: {
            valType: "enumerated",
            values: [o.x.toString(), ""],
            editType: "plot"
          },
          editType: "plot"
        },
        yaxes: {
          valType: "info_array",
          freeLength: !0,
          items: {
            valType: "enumerated",
            values: [o.y.toString(), ""],
            editType: "plot"
          },
          editType: "plot"
        },
        pattern: {
          valType: "enumerated",
          values: ["independent", "coupled"],
          dflt: "coupled",
          editType: "plot"
        },
        xgap: {
          valType: "number",
          min: 0,
          max: 1,
          editType: "plot"
        },
        ygap: {
          valType: "number",
          min: 0,
          max: 1,
          editType: "plot"
        },
        domain: a({
          name: "grid",
          editType: "plot",
          noGridCell: !0
        }, {}),
        xside: {
          valType: "enumerated",
          values: ["bottom", "bottom plot", "top plot", "top"],
          dflt: "bottom plot",
          editType: "plot"
        },
        yside: {
          valType: "enumerated",
          values: ["left", "left plot", "right plot", "right"],
          dflt: "left plot",
          editType: "plot"
        },
        editType: "plot"
      };

      function c(t, e, r) {
        var n = e[r + "axes"],
            i = Object.keys((t._splomAxes || {})[r] || {});
        return Array.isArray(n) ? n : i.length ? i : void 0;
      }

      function u(t, e, r, n, i, a) {
        var o = e(t + "gap", r),
            s = e("domain." + t);
        e(t + "side", n);

        for (var l = new Array(i), c = s[0], u = (s[1] - c) / (i - o), f = u * (1 - o), h = 0; h < i; h++) {
          var p = c + u * h;
          l[a ? i - 1 - h : h] = [p, p + f];
        }

        return l;
      }

      function f(t, e, r, n, i) {
        var a,
            o = new Array(r);

        function s(t, r) {
          -1 !== e.indexOf(r) && void 0 === n[r] ? (o[t] = r, n[r] = t) : o[t] = "";
        }

        if (Array.isArray(t)) for (a = 0; a < r; a++) {
          s(a, t[a]);
        } else for (s(0, i), a = 1; a < r; a++) {
          s(a, i + (a + 1));
        }
        return o;
      }

      e.exports = {
        moduleType: "component",
        name: "grid",
        schema: {
          layout: {
            grid: l
          }
        },
        layoutAttributes: l,
        sizeDefaults: function sizeDefaults(t, e) {
          var r = t.grid || {},
              i = c(e, r, "x"),
              a = c(e, r, "y");

          if (t.grid || i || a) {
            var o,
                f,
                h = Array.isArray(r.subplots) && Array.isArray(r.subplots[0]),
                p = Array.isArray(i),
                d = Array.isArray(a),
                m = p && i !== r.xaxes && d && a !== r.yaxes;
            h ? (o = r.subplots.length, f = r.subplots[0].length) : (d && (o = a.length), p && (f = i.length));
            var g = s.newContainer(e, "grid"),
                v = k("rows", o),
                y = k("columns", f);

            if (v * y > 1) {
              if (!h && !p && !d) "independent" === k("pattern") && (h = !0);
              g._hasSubplotGrid = h;

              var x,
                  b,
                  _ = "top to bottom" === k("roworder"),
                  w = h ? .2 : .1,
                  T = h ? .3 : .1;

              m && e._splomGridDflt && (x = e._splomGridDflt.xside, b = e._splomGridDflt.yside), g._domains = {
                x: u("x", k, w, x, y),
                y: u("y", k, T, b, v, _)
              };
            } else delete e.grid;
          }

          function k(t, e) {
            return n.coerce(r, g, l, t, e);
          }
        },
        contentDefaults: function contentDefaults(t, e) {
          var r = e.grid;

          if (r && r._domains) {
            var n,
                i,
                a,
                o,
                s,
                l,
                u,
                h = t.grid || {},
                p = e._subplots,
                d = r._hasSubplotGrid,
                m = r.rows,
                g = r.columns,
                v = "independent" === r.pattern,
                y = r._axisMap = {};

            if (d) {
              var x = h.subplots || [];
              l = r.subplots = new Array(m);
              var b = 1;

              for (n = 0; n < m; n++) {
                var _ = l[n] = new Array(g),
                    w = x[n] || [];

                for (i = 0; i < g; i++) {
                  if (v ? (s = 1 === b ? "xy" : "x" + b + "y" + b, b++) : s = w[i], _[i] = "", -1 !== p.cartesian.indexOf(s)) {
                    if (u = s.indexOf("y"), a = s.slice(0, u), o = s.slice(u), void 0 !== y[a] && y[a] !== i || void 0 !== y[o] && y[o] !== n) continue;
                    _[i] = s, y[a] = i, y[o] = n;
                  }
                }
              }
            } else {
              var T = c(e, h, "x"),
                  k = c(e, h, "y");
              r.xaxes = f(T, p.xaxis, g, y, "x"), r.yaxes = f(k, p.yaxis, m, y, "y");
            }

            var M = r._anchors = {},
                A = "top to bottom" === r.roworder;

            for (var S in y) {
              var E,
                  L,
                  C,
                  P = S.charAt(0),
                  I = r[P + "side"];
              if (I.length < 8) M[S] = "free";else if ("x" === P) {
                if ("t" === I.charAt(0) === A ? (E = 0, L = 1, C = m) : (E = m - 1, L = -1, C = -1), d) {
                  var O = y[S];

                  for (n = E; n !== C; n += L) {
                    if ((s = l[n][O]) && (u = s.indexOf("y"), s.slice(0, u) === S)) {
                      M[S] = s.slice(u);
                      break;
                    }
                  }
                } else for (n = E; n !== C; n += L) {
                  if (o = r.yaxes[n], -1 !== p.cartesian.indexOf(S + o)) {
                    M[S] = o;
                    break;
                  }
                }
              } else if ("l" === I.charAt(0) ? (E = 0, L = 1, C = g) : (E = g - 1, L = -1, C = -1), d) {
                var z = y[S];

                for (n = E; n !== C; n += L) {
                  if ((s = l[z][n]) && (u = s.indexOf("y"), s.slice(u) === S)) {
                    M[S] = s.slice(0, u);
                    break;
                  }
                }
              } else for (n = E; n !== C; n += L) {
                if (a = r.xaxes[n], -1 !== p.cartesian.indexOf(a + S)) {
                  M[S] = a;
                  break;
                }
              }
            }
          }
        }
      };
    }, {
      "../../lib": 795,
      "../../lib/regex": 812,
      "../../plot_api/plot_template": 834,
      "../../plots/cartesian/constants": 851,
      "../../plots/domain": 872
    }],
    703: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/cartesian/constants"),
          i = t("../../plot_api/plot_template").templatedArray;
      t("../../constants/axis_placeable_objects");
      e.exports = i("image", {
        visible: {
          valType: "boolean",
          dflt: !0,
          editType: "arraydraw"
        },
        source: {
          valType: "string",
          editType: "arraydraw"
        },
        layer: {
          valType: "enumerated",
          values: ["below", "above"],
          dflt: "above",
          editType: "arraydraw"
        },
        sizex: {
          valType: "number",
          dflt: 0,
          editType: "arraydraw"
        },
        sizey: {
          valType: "number",
          dflt: 0,
          editType: "arraydraw"
        },
        sizing: {
          valType: "enumerated",
          values: ["fill", "contain", "stretch"],
          dflt: "contain",
          editType: "arraydraw"
        },
        opacity: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 1,
          editType: "arraydraw"
        },
        x: {
          valType: "any",
          dflt: 0,
          editType: "arraydraw"
        },
        y: {
          valType: "any",
          dflt: 0,
          editType: "arraydraw"
        },
        xanchor: {
          valType: "enumerated",
          values: ["left", "center", "right"],
          dflt: "left",
          editType: "arraydraw"
        },
        yanchor: {
          valType: "enumerated",
          values: ["top", "middle", "bottom"],
          dflt: "top",
          editType: "arraydraw"
        },
        xref: {
          valType: "enumerated",
          values: ["paper", n.idRegex.x.toString()],
          dflt: "paper",
          editType: "arraydraw"
        },
        yref: {
          valType: "enumerated",
          values: ["paper", n.idRegex.y.toString()],
          dflt: "paper",
          editType: "arraydraw"
        },
        editType: "arraydraw"
      });
    }, {
      "../../constants/axis_placeable_objects": 764,
      "../../plot_api/plot_template": 834,
      "../../plots/cartesian/constants": 851
    }],
    704: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../lib/to_log_range");

      e.exports = function (t, e, r, a) {
        e = e || {};
        var o = "log" === r && "linear" === e.type,
            s = "linear" === r && "log" === e.type;
        if (o || s) for (var l, c, u = t._fullLayout.images, f = e._id.charAt(0), h = 0; h < u.length; h++) {
          if (c = "images[" + h + "].", (l = u[h])[f + "ref"] === e._id) {
            var p = l[f],
                d = l["size" + f],
                m = null,
                g = null;

            if (o) {
              m = i(p, e.range);
              var v = d / Math.pow(10, m) / 2;
              g = 2 * Math.log(v + Math.sqrt(1 + v * v)) / Math.LN10;
            } else g = (m = Math.pow(10, p)) * (Math.pow(10, d / 2) - Math.pow(10, -d / 2));

            n(m) ? n(g) || (g = null) : (m = null, g = null), a(c + f, m), a(c + "size" + f, g);
          }
        }
      };
    }, {
      "../../lib/to_log_range": 822,
      "fast-isnumeric": 240
    }],
    705: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../plots/cartesian/axes"),
          a = t("../../plots/array_container_defaults"),
          o = t("./attributes");

      function s(t, e, r) {
        function a(r, i) {
          return n.coerce(t, e, o, r, i);
        }

        var s = a("source");
        if (!a("visible", !!s)) return e;
        a("layer"), a("xanchor"), a("yanchor"), a("sizex"), a("sizey"), a("sizing"), a("opacity");

        for (var l = {
          _fullLayout: r
        }, c = ["x", "y"], u = 0; u < 2; u++) {
          var f = c[u],
              h = i.coerceRef(t, e, l, f, "paper", void 0);
          if ("paper" !== h) i.getFromId(l, h)._imgIndices.push(e._index);
          i.coercePosition(e, l, a, h, f, 0);
        }

        return e;
      }

      e.exports = function (t, e) {
        a(t, e, {
          name: "images",
          handleItemDefaults: s
        });
      };
    }, {
      "../../lib": 795,
      "../../plots/array_container_defaults": 840,
      "../../plots/cartesian/axes": 845,
      "./attributes": 703
    }],
    706: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../drawing"),
          a = t("../../plots/cartesian/axes"),
          o = t("../../plots/cartesian/axis_ids"),
          s = t("../../constants/xmlns_namespaces");

      e.exports = function (t) {
        var e,
            r,
            l = t._fullLayout,
            c = [],
            u = {},
            f = [];

        for (r = 0; r < l.images.length; r++) {
          var h = l.images[r];
          if (h.visible) if ("below" === h.layer && "paper" !== h.xref && "paper" !== h.yref) {
            e = o.ref2id(h.xref) + o.ref2id(h.yref);
            var p = l._plots[e];

            if (!p) {
              f.push(h);
              continue;
            }

            p.mainplot && (e = p.mainplot.id), u[e] || (u[e] = []), u[e].push(h);
          } else "above" === h.layer ? c.push(h) : f.push(h);
        }

        var d = {
          left: {
            sizing: "xMin",
            offset: 0
          },
          center: {
            sizing: "xMid",
            offset: -.5
          },
          right: {
            sizing: "xMax",
            offset: -1
          }
        },
            m = {
          top: {
            sizing: "YMin",
            offset: 0
          },
          middle: {
            sizing: "YMid",
            offset: -.5
          },
          bottom: {
            sizing: "YMax",
            offset: -1
          }
        };

        function g(e) {
          var r = n.select(this);
          if (this._imgSrc !== e.source) if (r.attr("xmlns", s.svg), e.source && "data:" === e.source.slice(0, 5)) r.attr("xlink:href", e.source), this._imgSrc = e.source;else {
            var i = new Promise(function (t) {
              var n = new Image();

              function i() {
                r.remove(), t();
              }

              this.img = n, n.setAttribute("crossOrigin", "anonymous"), n.onerror = i, n.onload = function () {
                var e = document.createElement("canvas");
                e.width = this.width, e.height = this.height, e.getContext("2d").drawImage(this, 0, 0);
                var n = e.toDataURL("image/png");
                r.attr("xlink:href", n), t();
              }, r.on("error", i), n.src = e.source, this._imgSrc = e.source;
            }.bind(this));

            t._promises.push(i);
          }
        }

        function v(e) {
          var r,
              o,
              s = n.select(this),
              c = a.getFromId(t, e.xref),
              u = a.getFromId(t, e.yref),
              f = "domain" === a.getRefType(e.xref),
              h = "domain" === a.getRefType(e.yref),
              p = l._size;
          r = void 0 !== c ? "string" == typeof e.xref && f ? c._length * e.sizex : Math.abs(c.l2p(e.sizex) - c.l2p(0)) : e.sizex * p.w, o = void 0 !== u ? "string" == typeof e.yref && h ? u._length * e.sizey : Math.abs(u.l2p(e.sizey) - u.l2p(0)) : e.sizey * p.h;
          var g,
              v,
              y = r * d[e.xanchor].offset,
              x = o * m[e.yanchor].offset,
              b = d[e.xanchor].sizing + m[e.yanchor].sizing;

          switch (g = void 0 !== c ? "string" == typeof e.xref && f ? c._length * e.x + c._offset : c.r2p(e.x) + c._offset : e.x * p.w + p.l, g += y, v = void 0 !== u ? "string" == typeof e.yref && h ? u._length * (1 - e.y) + u._offset : u.r2p(e.y) + u._offset : p.h - e.y * p.h + p.t, v += x, e.sizing) {
            case "fill":
              b += " slice";
              break;

            case "stretch":
              b = "none";
          }

          s.attr({
            x: g,
            y: v,
            width: r,
            height: o,
            preserveAspectRatio: b,
            opacity: e.opacity
          });

          var _ = (c && "domain" !== a.getRefType(e.xref) ? c._id : "") + (u && "domain" !== a.getRefType(e.yref) ? u._id : "");

          i.setClipUrl(s, _ ? "clip" + l._uid + _ : null, t);
        }

        var y = l._imageLowerLayer.selectAll("image").data(f),
            x = l._imageUpperLayer.selectAll("image").data(c);

        y.enter().append("image"), x.enter().append("image"), y.exit().remove(), x.exit().remove(), y.each(function (t) {
          g.bind(this)(t), v.bind(this)(t);
        }), x.each(function (t) {
          g.bind(this)(t), v.bind(this)(t);
        });
        var b = Object.keys(l._plots);

        for (r = 0; r < b.length; r++) {
          e = b[r];
          var _ = l._plots[e];

          if (_.imagelayer) {
            var w = _.imagelayer.selectAll("image").data(u[e] || []);

            w.enter().append("image"), w.exit().remove(), w.each(function (t) {
              g.bind(this)(t), v.bind(this)(t);
            });
          }
        }
      };
    }, {
      "../../constants/xmlns_namespaces": 772,
      "../../plots/cartesian/axes": 845,
      "../../plots/cartesian/axis_ids": 848,
      "../drawing": 680,
      "@plotly/d3": 57
    }],
    707: [function (t, e, r) {
      "use strict";

      e.exports = {
        moduleType: "component",
        name: "images",
        layoutAttributes: t("./attributes"),
        supplyLayoutDefaults: t("./defaults"),
        includeBasePlot: t("../../plots/cartesian/include_components")("images"),
        draw: t("./draw"),
        convertCoords: t("./convert_coords")
      };
    }, {
      "../../plots/cartesian/include_components": 857,
      "./attributes": 703,
      "./convert_coords": 704,
      "./defaults": 705,
      "./draw": 706
    }],
    708: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/font_attributes"),
          i = t("../color/attributes");
      e.exports = {
        bgcolor: {
          valType: "color",
          editType: "legend"
        },
        bordercolor: {
          valType: "color",
          dflt: i.defaultLine,
          editType: "legend"
        },
        borderwidth: {
          valType: "number",
          min: 0,
          dflt: 0,
          editType: "legend"
        },
        font: n({
          editType: "legend"
        }),
        orientation: {
          valType: "enumerated",
          values: ["v", "h"],
          dflt: "v",
          editType: "legend"
        },
        traceorder: {
          valType: "flaglist",
          flags: ["reversed", "grouped"],
          extras: ["normal"],
          editType: "legend"
        },
        tracegroupgap: {
          valType: "number",
          min: 0,
          dflt: 10,
          editType: "legend"
        },
        itemsizing: {
          valType: "enumerated",
          values: ["trace", "constant"],
          dflt: "trace",
          editType: "legend"
        },
        itemwidth: {
          valType: "number",
          min: 30,
          dflt: 30,
          editType: "legend"
        },
        itemclick: {
          valType: "enumerated",
          values: ["toggle", "toggleothers", !1],
          dflt: "toggle",
          editType: "legend"
        },
        itemdoubleclick: {
          valType: "enumerated",
          values: ["toggle", "toggleothers", !1],
          dflt: "toggleothers",
          editType: "legend"
        },
        x: {
          valType: "number",
          min: -2,
          max: 3,
          editType: "legend"
        },
        xanchor: {
          valType: "enumerated",
          values: ["auto", "left", "center", "right"],
          dflt: "left",
          editType: "legend"
        },
        y: {
          valType: "number",
          min: -2,
          max: 3,
          editType: "legend"
        },
        yanchor: {
          valType: "enumerated",
          values: ["auto", "top", "middle", "bottom"],
          editType: "legend"
        },
        uirevision: {
          valType: "any",
          editType: "none"
        },
        valign: {
          valType: "enumerated",
          values: ["top", "middle", "bottom"],
          dflt: "middle",
          editType: "legend"
        },
        title: {
          text: {
            valType: "string",
            dflt: "",
            editType: "legend"
          },
          font: n({
            editType: "legend"
          }),
          side: {
            valType: "enumerated",
            values: ["top", "left", "top left"],
            editType: "legend"
          },
          editType: "legend"
        },
        editType: "legend"
      };
    }, {
      "../../plots/font_attributes": 873,
      "../color/attributes": 657
    }],
    709: [function (t, e, r) {
      "use strict";

      e.exports = {
        scrollBarWidth: 6,
        scrollBarMinHeight: 20,
        scrollBarColor: "#808BA4",
        scrollBarMargin: 4,
        scrollBarEnterAttrs: {
          rx: 20,
          ry: 3,
          width: 0,
          height: 0
        },
        titlePad: 2,
        itemGap: 5
      };
    }, {}],
    710: [function (t, e, r) {
      "use strict";

      var n = t("../../registry"),
          i = t("../../lib"),
          a = t("../../plot_api/plot_template"),
          o = t("./attributes"),
          s = t("../../plots/layout_attributes"),
          l = t("./helpers");

      e.exports = function (t, e, r) {
        for (var c = t.legend || {}, u = 0, f = !1, h = "normal", p = 0; p < r.length; p++) {
          var d = r[p];
          d.visible && ((d.showlegend || d._dfltShowLegend && !(d._module && d._module.attributes && d._module.attributes.showlegend && !1 === d._module.attributes.showlegend.dflt)) && (u++, d.showlegend && (f = !0, (n.traceIs(d, "pie-like") || !0 === d._input.showlegend) && u++)), (n.traceIs(d, "bar") && "stack" === e.barmode || -1 !== ["tonextx", "tonexty"].indexOf(d.fill)) && (h = l.isGrouped({
            traceorder: h
          }) ? "grouped+reversed" : "reversed"), void 0 !== d.legendgroup && "" !== d.legendgroup && (h = l.isReversed({
            traceorder: h
          }) ? "reversed+grouped" : "grouped"));
        }

        var m = i.coerce(t, e, s, "showlegend", f && u > 1);

        if (!1 !== m || c.uirevision) {
          var g = a.newContainer(e, "legend");

          if (T("uirevision", e.uirevision), !1 !== m) {
            T("bgcolor", e.paper_bgcolor), T("bordercolor"), T("borderwidth");

            var v,
                y,
                x,
                b = i.coerceFont(T, "font", e.font),
                _ = "h" === T("orientation");

            if (_ ? (v = 0, n.getComponentMethod("rangeslider", "isVisible")(t.xaxis) ? (y = 1.1, x = "bottom") : (y = -.1, x = "top")) : (v = 1.02, y = 1, x = "auto"), T("traceorder", h), l.isGrouped(e.legend) && T("tracegroupgap"), T("itemsizing"), T("itemwidth"), T("itemclick"), T("itemdoubleclick"), T("x", v), T("xanchor"), T("y", y), T("yanchor", x), T("valign"), i.noneOrAll(c, g, ["x", "y"]), T("title.text")) {
              T("title.side", _ ? "left" : "top");
              var w = i.extendFlat({}, b, {
                size: i.bigFont(b.size)
              });
              i.coerceFont(T, "title.font", w);
            }
          }
        }

        function T(t, e) {
          return i.coerce(c, g, o, t, e);
        }
      };
    }, {
      "../../lib": 795,
      "../../plot_api/plot_template": 834,
      "../../plots/layout_attributes": 900,
      "../../registry": 923,
      "./attributes": 708,
      "./helpers": 714
    }],
    711: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../lib"),
          a = t("../../plots/plots"),
          o = t("../../registry"),
          s = t("../../lib/events"),
          l = t("../dragelement"),
          c = t("../drawing"),
          u = t("../color"),
          f = t("../../lib/svg_text_utils"),
          h = t("./handle_click"),
          p = t("./constants"),
          d = t("../../constants/alignment"),
          m = d.LINE_SPACING,
          g = d.FROM_TL,
          v = d.FROM_BR,
          y = t("./get_legend_data"),
          x = t("./style"),
          b = t("./helpers");

      function _(t, e, r, n, i) {
        var a = r.data()[0][0].trace,
            l = {
          event: i,
          node: r.node(),
          curveNumber: a.index,
          expandedIndex: a._expandedIndex,
          data: t.data,
          layout: t.layout,
          frames: t._transitionData._frames,
          config: t._context,
          fullData: t._fullData,
          fullLayout: t._fullLayout
        };
        if (a._group && (l.group = a._group), o.traceIs(a, "pie-like") && (l.label = r.datum()[0].label), !1 !== s.triggerHandler(t, "plotly_legendclick", l)) if (1 === n) e._clickTimeout = setTimeout(function () {
          t._fullLayout && h(r, t, n);
        }, t._context.doubleClickDelay);else if (2 === n) {
          e._clickTimeout && clearTimeout(e._clickTimeout), t._legendMouseDownTime = 0, !1 !== s.triggerHandler(t, "plotly_legenddoubleclick", l) && h(r, t, n);
        }
      }

      function w(t, e, r) {
        var n,
            a = t.data()[0][0],
            s = a.trace,
            l = o.traceIs(s, "pie-like"),
            u = !r._inHover && e._context.edits.legendText && !l,
            h = r._maxNameLength;
        r.entries ? n = a.text : (n = l ? a.label : s.name, s._meta && (n = i.templateString(n, s._meta)));
        var d = i.ensureSingle(t, "text", "legendtext");
        d.attr("text-anchor", "start").call(c.font, r.font).text(u ? T(n, h) : n);
        var m = r.itemwidth + 2 * p.itemGap;
        f.positionText(d, m, 0), u ? d.call(f.makeEditable, {
          gd: e,
          text: n
        }).call(M, t, e, r).on("edit", function (n) {
          this.text(T(n, h)).call(M, t, e, r);
          var l = a.trace._fullInput || {},
              c = {};

          if (o.hasTransform(l, "groupby")) {
            var u = o.getTransformIndices(l, "groupby"),
                f = u[u.length - 1],
                p = i.keyedContainer(l, "transforms[" + f + "].styles", "target", "value.name");
            p.set(a.trace._group, n), c = p.constructUpdate();
          } else c.name = n;

          return o.call("_guiRestyle", e, c, s.index);
        }) : M(d, t, e, r);
      }

      function T(t, e) {
        var r = Math.max(4, e);
        if (t && t.trim().length >= r / 2) return t;

        for (var n = r - (t = t || "").length; n > 0; n--) {
          t += " ";
        }

        return t;
      }

      function k(t, e) {
        var r,
            a = e._context.doubleClickDelay,
            o = 1,
            s = i.ensureSingle(t, "rect", "legendtoggle", function (t) {
          e._context.staticPlot || t.style("cursor", "pointer").attr("pointer-events", "all"), t.call(u.fill, "rgba(0,0,0,0)");
        });
        e._context.staticPlot || (s.on("mousedown", function () {
          (r = new Date().getTime()) - e._legendMouseDownTime < a ? o += 1 : (o = 1, e._legendMouseDownTime = r);
        }), s.on("mouseup", function () {
          if (!e._dragged && !e._editing) {
            var r = e._fullLayout.legend;
            new Date().getTime() - e._legendMouseDownTime > a && (o = Math.max(o - 1, 1)), _(e, r, t, o, n.event);
          }
        }));
      }

      function M(t, e, r, n, i) {
        n._inHover && t.attr("data-notex", !0), f.convertToTspans(t, r, function () {
          !function (t, e, r, n) {
            var i = t.data()[0][0];
            if (!r._inHover && i && !i.trace.showlegend) return void t.remove();
            var a = t.select("g[class*=math-group]"),
                o = a.node();
            r || (r = e._fullLayout.legend);
            var s,
                l,
                u = r.borderwidth,
                h = (1 === n ? r.title : r).font.size * m;

            if (o) {
              var d = c.bBox(o);
              s = d.height, l = d.width, 1 === n ? c.setTranslate(a, u, u + .75 * s) : c.setTranslate(a, 0, .25 * s);
            } else {
              var g = t.select(1 === n ? ".legendtitletext" : ".legendtext"),
                  v = f.lineCount(g),
                  y = g.node();
              s = h * v, l = y ? c.bBox(y).width : 0, 1 === n ? ("left" === r.title.side && (l += 2 * p.itemGap), f.positionText(g, u + p.titlePad, u + h)) : f.positionText(g, r.itemwidth + 2 * p.itemGap, -h * ((v - 1) / 2 - .3));
            }

            1 === n ? (r._titleWidth = l, r._titleHeight = s) : (i.lineHeight = h, i.height = Math.max(s, 16) + 3, i.width = l);
          }(e, r, n, i);
        });
      }

      function A(t) {
        return i.isRightAnchor(t) ? "right" : i.isCenterAnchor(t) ? "center" : "left";
      }

      function S(t) {
        return i.isBottomAnchor(t) ? "bottom" : i.isMiddleAnchor(t) ? "middle" : "top";
      }

      e.exports = function (t, e) {
        return e || (e = t._fullLayout.legend || {}), function (t, e) {
          var r,
              s,
              f = t._fullLayout,
              h = "legend" + f._uid,
              d = e._inHover;
          d ? (r = e.layer, h += "-hover") : r = f._infolayer;
          if (!r) return;
          t._legendMouseDownTime || (t._legendMouseDownTime = 0);

          if (d) {
            if (!e.entries) return;
            s = y(e.entries, e);
          } else {
            if (!t.calcdata) return;
            s = f.showlegend && y(t.calcdata, e);
          }

          var m = f.hiddenlabels || [];
          if (!(d || f.showlegend && s.length)) return r.selectAll(".legend").remove(), f._topdefs.select("#" + h).remove(), a.autoMargin(t, "legend");
          var T = i.ensureSingle(r, "g", "legend", function (t) {
            d || t.attr("pointer-events", "all");
          }),
              E = i.ensureSingleById(f._topdefs, "clipPath", h, function (t) {
            t.append("rect");
          }),
              L = i.ensureSingle(T, "rect", "bg", function (t) {
            t.attr("shape-rendering", "crispEdges");
          });
          L.call(u.stroke, e.bordercolor).call(u.fill, e.bgcolor).style("stroke-width", e.borderwidth + "px");
          var C = i.ensureSingle(T, "g", "scrollbox"),
              P = e.title;

          if (e._titleWidth = 0, e._titleHeight = 0, P.text) {
            var I = i.ensureSingle(C, "text", "legendtitletext");
            I.attr("text-anchor", "start").call(c.font, P.font).text(P.text), M(I, C, t, e, 1);
          } else C.selectAll(".legendtitletext").remove();

          var O = i.ensureSingle(T, "rect", "scrollbar", function (t) {
            t.attr(p.scrollBarEnterAttrs).call(u.fill, p.scrollBarColor);
          }),
              z = C.selectAll("g.groups").data(s);
          z.enter().append("g").attr("class", "groups"), z.exit().remove();
          var D = z.selectAll("g.traces").data(i.identity);
          D.enter().append("g").attr("class", "traces"), D.exit().remove(), D.style("opacity", function (t) {
            var e = t[0].trace;
            return o.traceIs(e, "pie-like") ? -1 !== m.indexOf(t[0].label) ? .5 : 1 : "legendonly" === e.visible ? .5 : 1;
          }).each(function () {
            n.select(this).call(w, t, e);
          }).call(x, t, e).each(function () {
            d || n.select(this).call(k, t);
          }), i.syncOrAsync([a.previousPromises, function () {
            return function (t, e, r, i) {
              var a = t._fullLayout;
              i || (i = a.legend);
              var o = a._size,
                  s = b.isVertical(i),
                  l = b.isGrouped(i),
                  u = i.borderwidth,
                  f = 2 * u,
                  h = p.itemGap,
                  d = i.itemwidth + 2 * h,
                  m = 2 * (u + h),
                  g = S(i),
                  v = i.y < 0 || 0 === i.y && "top" === g,
                  y = i.y > 1 || 1 === i.y && "bottom" === g,
                  x = i.tracegroupgap;
              i._maxHeight = Math.max(v || y ? a.height / 2 : o.h, 30);
              var _ = 0;
              i._width = 0, i._height = 0;

              var w = function (t) {
                var e = 0,
                    r = 0,
                    n = t.title.side;
                n && (-1 !== n.indexOf("left") && (e = t._titleWidth), -1 !== n.indexOf("top") && (r = t._titleHeight));
                return [e, r];
              }(i);

              if (s) r.each(function (t) {
                var e = t[0].height;
                c.setTranslate(this, u + w[0], u + w[1] + i._height + e / 2 + h), i._height += e, i._width = Math.max(i._width, t[0].width);
              }), _ = d + i._width, i._width += h + d + f, i._height += m, l && (e.each(function (t, e) {
                c.setTranslate(this, 0, e * i.tracegroupgap);
              }), i._height += (i._lgroupsLength - 1) * i.tracegroupgap);else {
                var T = A(i),
                    k = i.x < 0 || 0 === i.x && "right" === T,
                    M = i.x > 1 || 1 === i.x && "left" === T,
                    E = y || v,
                    L = a.width / 2;
                i._maxWidth = Math.max(k ? E && "left" === T ? o.l + o.w : L : M ? E && "right" === T ? o.r + o.w : L : o.w, 2 * d);
                var C = 0,
                    P = 0;
                r.each(function (t) {
                  var e = t[0].width + d;
                  C = Math.max(C, e), P += e;
                }), _ = null;
                var I = 0;

                if (l) {
                  var O = 0,
                      z = 0,
                      D = 0;
                  e.each(function () {
                    var t = 0,
                        e = 0;
                    n.select(this).selectAll("g.traces").each(function (r) {
                      var n = r[0].height;
                      c.setTranslate(this, w[0], w[1] + u + h + n / 2 + e), e += n, t = Math.max(t, d + r[0].width);
                    }), O = Math.max(O, e);
                    var r = t + h;
                    r + u + z > i._maxWidth && (I = Math.max(I, z), z = 0, D += O + x, O = e), c.setTranslate(this, z, D), z += r;
                  }), i._width = Math.max(I, z) + u, i._height = D + O + m;
                } else {
                  var R = r.size(),
                      F = P + f + (R - 1) * h < i._maxWidth,
                      B = 0,
                      N = 0,
                      j = 0,
                      U = 0;
                  r.each(function (t) {
                    var e = t[0].height,
                        r = d + t[0].width,
                        n = (F ? r : C) + h;
                    n + u + N - h >= i._maxWidth && (I = Math.max(I, U), N = 0, j += B, i._height += B, B = 0), c.setTranslate(this, w[0] + u + N, w[1] + u + j + e / 2 + h), U = N + r + h, N += n, B = Math.max(B, e);
                  }), F ? (i._width = N + f, i._height = B + m) : (i._width = Math.max(I, U) + f, i._height += B + m);
                }
              }
              i._width = Math.ceil(Math.max(i._width + w[0], i._titleWidth + 2 * (u + p.titlePad))), i._height = Math.ceil(Math.max(i._height + w[1], i._titleHeight + 2 * (u + p.itemGap))), i._effHeight = Math.min(i._height, i._maxHeight);
              var V = t._context.edits,
                  q = V.legendText || V.legendPosition;
              r.each(function (t) {
                var e = n.select(this).select(".legendtoggle"),
                    r = t[0].height,
                    i = q ? d : _ || d + t[0].width;
                s || (i += h / 2), c.setRect(e, 0, -r / 2, i, r);
              });
            }(t, z, D, e);
          }, function () {
            if (d || !function (t) {
              var e = t._fullLayout.legend,
                  r = A(e),
                  n = S(e);
              return a.autoMargin(t, "legend", {
                x: e.x,
                y: e.y,
                l: e._width * g[r],
                r: e._width * v[r],
                b: e._effHeight * v[n],
                t: e._effHeight * g[n]
              });
            }(t)) {
              var s,
                  u,
                  m,
                  y,
                  x = f._size,
                  b = e.borderwidth,
                  w = x.l + x.w * e.x - g[A(e)] * e._width,
                  k = x.t + x.h * (1 - e.y) - g[S(e)] * e._effHeight;

              if (!d && f.margin.autoexpand) {
                var M = w,
                    P = k;
                w = i.constrain(w, 0, f.width - e._width), k = i.constrain(k, 0, f.height - e._effHeight), w !== M && i.log("Constrain legend.x to make legend fit inside graph"), k !== P && i.log("Constrain legend.y to make legend fit inside graph");
              }

              if (d || c.setTranslate(T, w, k), O.on(".drag", null), T.on("wheel", null), d || e._height <= e._maxHeight || t._context.staticPlot) {
                var I = e._effHeight;
                d && (I = e._height), L.attr({
                  width: e._width - b,
                  height: I - b,
                  x: b / 2,
                  y: b / 2
                }), c.setTranslate(C, 0, 0), E.select("rect").attr({
                  width: e._width - 2 * b,
                  height: I - 2 * b,
                  x: b,
                  y: b
                }), c.setClipUrl(C, h, t), c.setRect(O, 0, 0, 0, 0), delete e._scrollY;
              } else {
                var z,
                    D,
                    R,
                    F = Math.max(p.scrollBarMinHeight, e._effHeight * e._effHeight / e._height),
                    B = e._effHeight - F - 2 * p.scrollBarMargin,
                    N = e._height - e._effHeight,
                    j = B / N,
                    U = Math.min(e._scrollY || 0, N);
                L.attr({
                  width: e._width - 2 * b + p.scrollBarWidth + p.scrollBarMargin,
                  height: e._effHeight - b,
                  x: b / 2,
                  y: b / 2
                }), E.select("rect").attr({
                  width: e._width - 2 * b + p.scrollBarWidth + p.scrollBarMargin,
                  height: e._effHeight - 2 * b,
                  x: b,
                  y: b + U
                }), c.setClipUrl(C, h, t), H(U, F, j), T.on("wheel", function () {
                  H(U = i.constrain(e._scrollY + n.event.deltaY / B * N, 0, N), F, j), 0 !== U && U !== N && n.event.preventDefault();
                });
                var V = n.behavior.drag().on("dragstart", function () {
                  var t = n.event.sourceEvent;
                  z = "touchstart" === t.type ? t.changedTouches[0].clientY : t.clientY, R = U;
                }).on("drag", function () {
                  var t = n.event.sourceEvent;
                  2 === t.buttons || t.ctrlKey || (D = "touchmove" === t.type ? t.changedTouches[0].clientY : t.clientY, H(U = function (t, e, r) {
                    var n = (r - e) / j + t;
                    return i.constrain(n, 0, N);
                  }(R, z, D), F, j));
                });
                O.call(V);
                var q = n.behavior.drag().on("dragstart", function () {
                  var t = n.event.sourceEvent;
                  "touchstart" === t.type && (z = t.changedTouches[0].clientY, R = U);
                }).on("drag", function () {
                  var t = n.event.sourceEvent;
                  "touchmove" === t.type && (D = t.changedTouches[0].clientY, H(U = function (t, e, r) {
                    var n = (e - r) / j + t;
                    return i.constrain(n, 0, N);
                  }(R, z, D), F, j));
                });
                C.call(q);
              }

              if (t._context.edits.legendPosition) T.classed("cursor-move", !0), l.init({
                element: T.node(),
                gd: t,
                prepFn: function prepFn() {
                  var t = c.getTranslate(T);
                  m = t.x, y = t.y;
                },
                moveFn: function moveFn(t, r) {
                  var n = m + t,
                      i = y + r;
                  c.setTranslate(T, n, i), s = l.align(n, 0, x.l, x.l + x.w, e.xanchor), u = l.align(i, 0, x.t + x.h, x.t, e.yanchor);
                },
                doneFn: function doneFn() {
                  void 0 !== s && void 0 !== u && o.call("_guiRelayout", t, {
                    "legend.x": s,
                    "legend.y": u
                  });
                },
                clickFn: function clickFn(e, n) {
                  var i = r.selectAll("g.traces").filter(function () {
                    var t = this.getBoundingClientRect();
                    return n.clientX >= t.left && n.clientX <= t.right && n.clientY >= t.top && n.clientY <= t.bottom;
                  });
                  i.size() > 0 && _(t, T, i, e, n);
                }
              });
            }

            function H(r, n, i) {
              e._scrollY = t._fullLayout.legend._scrollY = r, c.setTranslate(C, 0, -r), c.setRect(O, e._width, p.scrollBarMargin + r * i, p.scrollBarWidth, n), E.select("rect").attr("y", b + r);
            }
          }], t);
        }(t, e);
      };
    }, {
      "../../constants/alignment": 763,
      "../../lib": 795,
      "../../lib/events": 784,
      "../../lib/svg_text_utils": 820,
      "../../plots/plots": 909,
      "../../registry": 923,
      "../color": 658,
      "../dragelement": 677,
      "../drawing": 680,
      "./constants": 709,
      "./get_legend_data": 712,
      "./handle_click": 713,
      "./helpers": 714,
      "./style": 716,
      "@plotly/d3": 57
    }],
    712: [function (t, e, r) {
      "use strict";

      var n = t("../../registry"),
          i = t("./helpers");

      e.exports = function (t, e) {
        var r,
            a,
            o = {},
            s = [],
            l = !1,
            c = {},
            u = 0,
            f = 0;

        function h(t, r) {
          if ("" !== t && i.isGrouped(e)) -1 === s.indexOf(t) ? (s.push(t), l = !0, o[t] = [[r]]) : o[t].push([r]);else {
            var n = "~~i" + u;
            s.push(n), o[n] = [[r]], u++;
          }
        }

        for (r = 0; r < t.length; r++) {
          var p = t[r],
              d = p[0],
              m = d.trace,
              g = m.legendgroup;
          if (e._inHover || m.visible && m.showlegend) if (n.traceIs(m, "pie-like")) for (c[g] || (c[g] = {}), a = 0; a < p.length; a++) {
            var v = p[a].label;
            c[g][v] || (h(g, {
              label: v,
              color: p[a].color,
              i: p[a].i,
              trace: m,
              pts: p[a].pts
            }), c[g][v] = !0, f = Math.max(f, (v || "").length));
          } else h(g, d), f = Math.max(f, (m.name || "").length);
        }

        if (!s.length) return [];
        var y,
            x,
            b = s.length;
        if (l && i.isGrouped(e)) for (x = new Array(b), r = 0; r < b; r++) {
          y = o[s[r]], x[r] = i.isReversed(e) ? y.reverse() : y;
        } else {
          for (x = [new Array(b)], r = 0; r < b; r++) {
            y = o[s[r]][0], x[0][i.isReversed(e) ? b - r - 1 : r] = y;
          }

          b = 1;
        }
        return e._lgroupsLength = b, e._maxNameLength = f, x;
      };
    }, {
      "../../registry": 923,
      "./helpers": 714
    }],
    713: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../registry"),
          a = !0;

      e.exports = function (t, e, r) {
        var o = e._fullLayout;

        if (!e._dragged && !e._editing) {
          var s,
              l = o.legend.itemclick,
              c = o.legend.itemdoubleclick;

          if (1 === r && "toggle" === l && "toggleothers" === c && a && e.data && e._context.showTips ? (n.notifier(n._(e, "Double-click on legend to isolate one trace"), "long"), a = !1) : a = !1, 1 === r ? s = l : 2 === r && (s = c), s) {
            var u,
                f,
                h,
                p,
                d,
                m = o.hiddenlabels ? o.hiddenlabels.slice() : [],
                g = t.data()[0][0],
                v = e._fullData,
                y = g.trace,
                x = y.legendgroup,
                b = {},
                _ = [],
                w = [],
                T = [];

            if (i.traceIs(y, "pie-like")) {
              var k = g.label,
                  M = m.indexOf(k);
              "toggle" === s ? -1 === M ? m.push(k) : m.splice(M, 1) : "toggleothers" === s && (m = [], e.calcdata[0].forEach(function (t) {
                k !== t.label && m.push(t.label);
              }), e._fullLayout.hiddenlabels && e._fullLayout.hiddenlabels.length === m.length && -1 === M && (m = [])), i.call("_guiRelayout", e, "hiddenlabels", m);
            } else {
              var A,
                  S = x && x.length,
                  E = [];
              if (S) for (u = 0; u < v.length; u++) {
                (A = v[u]).visible && A.legendgroup === x && E.push(u);
              }

              if ("toggle" === s) {
                var L;

                switch (y.visible) {
                  case !0:
                    L = "legendonly";
                    break;

                  case !1:
                    L = !1;
                    break;

                  case "legendonly":
                    L = !0;
                }

                if (S) for (u = 0; u < v.length; u++) {
                  !1 !== v[u].visible && v[u].legendgroup === x && B(v[u], L);
                } else B(y, L);
              } else if ("toggleothers" === s) {
                var C,
                    P,
                    I,
                    O,
                    z = !0;

                for (u = 0; u < v.length; u++) {
                  if (C = v[u] === y, I = !0 !== v[u].showlegend, !(C || I || (P = S && v[u].legendgroup === x) || !0 !== v[u].visible || i.traceIs(v[u], "notLegendIsolatable"))) {
                    z = !1;
                    break;
                  }
                }

                for (u = 0; u < v.length; u++) {
                  if (!1 !== v[u].visible && !i.traceIs(v[u], "notLegendIsolatable")) switch (y.visible) {
                    case "legendonly":
                      B(v[u], !0);
                      break;

                    case !0:
                      O = !!z || "legendonly", C = v[u] === y, I = !0 !== v[u].showlegend && !v[u].legendgroup, P = C || S && v[u].legendgroup === x, B(v[u], !(!P && !I) || O);
                  }
                }
              }

              for (u = 0; u < w.length; u++) {
                if (h = w[u]) {
                  var D = h.constructUpdate(),
                      R = Object.keys(D);

                  for (f = 0; f < R.length; f++) {
                    p = R[f], (b[p] = b[p] || [])[T[u]] = D[p];
                  }
                }
              }

              for (d = Object.keys(b), u = 0; u < d.length; u++) {
                for (p = d[u], f = 0; f < _.length; f++) {
                  b[p].hasOwnProperty(f) || (b[p][f] = void 0);
                }
              }

              i.call("_guiRestyle", e, b, _);
            }
          }
        }

        function F(t, e, r) {
          var n = _.indexOf(t),
              i = b[e];

          return i || (i = b[e] = []), -1 === _.indexOf(t) && (_.push(t), n = _.length - 1), i[n] = r, n;
        }

        function B(t, e) {
          var r = t._fullInput;

          if (i.hasTransform(r, "groupby")) {
            var a = w[r.index];

            if (!a) {
              var o = i.getTransformIndices(r, "groupby"),
                  s = o[o.length - 1];
              a = n.keyedContainer(r, "transforms[" + s + "].styles", "target", "value.visible"), w[r.index] = a;
            }

            var l = a.get(t._group);
            void 0 === l && (l = !0), !1 !== l && a.set(t._group, e), T[r.index] = F(r.index, "visible", !1 !== r.visible);
          } else {
            var c = !1 !== r.visible && e;
            F(r.index, "visible", c);
          }
        }
      };
    }, {
      "../../lib": 795,
      "../../registry": 923
    }],
    714: [function (t, e, r) {
      "use strict";

      r.isGrouped = function (t) {
        return -1 !== (t.traceorder || "").indexOf("grouped");
      }, r.isVertical = function (t) {
        return "h" !== t.orientation;
      }, r.isReversed = function (t) {
        return -1 !== (t.traceorder || "").indexOf("reversed");
      };
    }, {}],
    715: [function (t, e, r) {
      "use strict";

      e.exports = {
        moduleType: "component",
        name: "legend",
        layoutAttributes: t("./attributes"),
        supplyLayoutDefaults: t("./defaults"),
        draw: t("./draw"),
        style: t("./style")
      };
    }, {
      "./attributes": 708,
      "./defaults": 710,
      "./draw": 711,
      "./style": 716
    }],
    716: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../registry"),
          a = t("../../lib"),
          o = a.strTranslate,
          s = t("../drawing"),
          l = t("../color"),
          c = t("../colorscale/helpers").extractOpts,
          u = t("../../traces/scatter/subtypes"),
          f = t("../../traces/pie/style_one"),
          h = t("../../traces/pie/helpers").castOption,
          p = t("./constants");

      function d(t, e) {
        return (e ? "radial" : "horizontal") + (t ? "" : "reversed");
      }

      function m(t) {
        var e = t[0].trace,
            r = e.contours,
            n = u.hasLines(e),
            i = u.hasMarkers(e),
            a = e.visible && e.fill && "none" !== e.fill,
            o = !1,
            s = !1;

        if (r) {
          var l = r.coloring;
          "lines" === l ? o = !0 : n = "none" === l || "heatmap" === l || r.showlines, "constraint" === r.type ? a = "=" !== r._operation : "fill" !== l && "heatmap" !== l || (s = !0);
        }

        return {
          showMarker: i,
          showLine: n,
          showFill: a,
          showGradientLine: o,
          showGradientFill: s,
          anyLine: n || o,
          anyFill: a || s
        };
      }

      e.exports = function (t, e, r) {
        var g = e._fullLayout;
        r || (r = g.legend);

        var v = "constant" === r.itemsizing,
            y = r.itemwidth,
            x = (y + 2 * p.itemGap) / 2,
            b = o(x, 0),
            _ = function _(t, e, r, n) {
          var i;
          if (t + 1) i = t;else {
            if (!(e && e.width > 0)) return 0;
            i = e.width;
          }
          return v ? n : Math.min(i, r);
        };

        function w(t, r, a) {
          var o = t[0].trace,
              c = o.marker || {},
              u = c.line || {},
              f = a ? o.visible && o.type === a : i.traceIs(o, "bar"),
              h = n.select(r).select("g.legendpoints").selectAll("path.legend" + a).data(f ? [t] : []);
          h.enter().append("path").classed("legend" + a, !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", b), h.exit().remove(), h.each(function (t) {
            var r = n.select(this),
                i = t[0],
                a = _(i.mlw, c.line, 5, 2);

            r.style("stroke-width", a + "px");
            var f = i.mc || c.color,
                h = c.pattern,
                p = h && s.getPatternAttr(h.shape, 0, "");

            if (p) {
              var d = s.getPatternAttr(h.bgcolor, 0, null),
                  m = Math.min(12, s.getPatternAttr(h.size, 0, 8)),
                  g = s.getPatternAttr(h.solidity, 0, .3),
                  v = "legend-" + o.uid;
              r.call(s.pattern, e, v, p, d, f, m, g, "fill");
            } else r.call(l.fill, f);

            a && l.stroke(r, i.mlc || u.color);
          });
        }

        function T(t, e, r) {
          var o = t[0],
              s = o.trace,
              l = r ? s.visible && s.type === r : i.traceIs(s, r),
              c = n.select(e).select("g.legendpoints").selectAll("path.legend" + r).data(l ? [t] : []);

          if (c.enter().append("path").classed("legend" + r, !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", b), c.exit().remove(), c.size()) {
            var u = (s.marker || {}).line,
                p = _(h(u.width, o.pts), u, 5, 2),
                d = a.minExtend(s, {
              marker: {
                line: {
                  width: p
                }
              }
            });

            d.marker.line.color = u.color;
            var m = a.minExtend(o, {
              trace: d
            });
            f(c, m, d);
          }
        }

        t.each(function (t) {
          var e = n.select(this),
              i = a.ensureSingle(e, "g", "layers");
          i.style("opacity", t[0].trace.opacity);
          var s = r.valign,
              l = t[0].lineHeight,
              c = t[0].height;

          if ("middle" !== s && l && c) {
            var u = {
              top: 1,
              bottom: -1
            }[s] * (.5 * (l - c + 3));
            i.attr("transform", o(0, u));
          } else i.attr("transform", null);

          i.selectAll("g.legendfill").data([t]).enter().append("g").classed("legendfill", !0), i.selectAll("g.legendlines").data([t]).enter().append("g").classed("legendlines", !0);
          var f = i.selectAll("g.legendsymbols").data([t]);
          f.enter().append("g").classed("legendsymbols", !0), f.selectAll("g.legendpoints").data([t]).enter().append("g").classed("legendpoints", !0);
        }).each(function (t) {
          var r,
              i = t[0].trace,
              o = [];
          if (i.visible) switch (i.type) {
            case "histogram2d":
            case "heatmap":
              o = [["M-15,-2V4H15V-2Z"]], r = !0;
              break;

            case "choropleth":
            case "choroplethmapbox":
              o = [["M-6,-6V6H6V-6Z"]], r = !0;
              break;

            case "densitymapbox":
              o = [["M-6,0 a6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0"]], r = "radial";
              break;

            case "cone":
              o = [["M-6,2 A2,2 0 0,0 -6,6 V6L6,4Z"], ["M-6,-6 A2,2 0 0,0 -6,-2 L6,-4Z"], ["M-6,-2 A2,2 0 0,0 -6,2 L6,0Z"]], r = !1;
              break;

            case "streamtube":
              o = [["M-6,2 A2,2 0 0,0 -6,6 H6 A2,2 0 0,1 6,2 Z"], ["M-6,-6 A2,2 0 0,0 -6,-2 H6 A2,2 0 0,1 6,-6 Z"], ["M-6,-2 A2,2 0 0,0 -6,2 H6 A2,2 0 0,1 6,-2 Z"]], r = !1;
              break;

            case "surface":
              o = [["M-6,-6 A2,3 0 0,0 -6,0 H6 A2,3 0 0,1 6,-6 Z"], ["M-6,1 A2,3 0 0,1 -6,6 H6 A2,3 0 0,0 6,0 Z"]], r = !0;
              break;

            case "mesh3d":
              o = [["M-6,6H0L-6,-6Z"], ["M6,6H0L6,-6Z"], ["M-6,-6H6L0,6Z"]], r = !1;
              break;

            case "volume":
              o = [["M-6,6H0L-6,-6Z"], ["M6,6H0L6,-6Z"], ["M-6,-6H6L0,6Z"]], r = !0;
              break;

            case "isosurface":
              o = [["M-6,6H0L-6,-6Z"], ["M6,6H0L6,-6Z"], ["M-6,-6 A12,24 0 0,0 6,-6 L0,6Z"]], r = !1;
          }
          var u = n.select(this).select("g.legendpoints").selectAll("path.legend3dandfriends").data(o);
          u.enter().append("path").classed("legend3dandfriends", !0).attr("transform", b).style("stroke-miterlimit", 1), u.exit().remove(), u.each(function (t, o) {
            var u,
                f = n.select(this),
                h = c(i),
                p = h.colorscale,
                m = h.reversescale;

            if (p) {
              if (!r) {
                var g = p.length;
                u = 0 === o ? p[m ? g - 1 : 0][1] : 1 === o ? p[m ? 0 : g - 1][1] : p[Math.floor((g - 1) / 2)][1];
              }
            } else {
              var v = i.vertexcolor || i.facecolor || i.color;
              u = a.isArrayOrTypedArray(v) ? v[o] || v[0] : v;
            }

            f.attr("d", t[0]), u ? f.call(l.fill, u) : f.call(function (t) {
              if (t.size()) {
                var n = "legendfill-" + i.uid;
                s.gradient(t, e, n, d(m, "radial" === r), p, "fill");
              }
            });
          });
        }).each(function (t) {
          var e = t[0].trace,
              r = "waterfall" === e.type;

          if (t[0]._distinct && r) {
            var i = t[0].trace[t[0].dir].marker;
            return t[0].mc = i.color, t[0].mlw = i.line.width, t[0].mlc = i.line.color, w(t, this, "waterfall");
          }

          var a = [];
          e.visible && r && (a = t[0].hasTotals ? [["increasing", "M-6,-6V6H0Z"], ["totals", "M6,6H0L-6,-6H-0Z"], ["decreasing", "M6,6V-6H0Z"]] : [["increasing", "M-6,-6V6H6Z"], ["decreasing", "M6,6V-6H-6Z"]]);
          var o = n.select(this).select("g.legendpoints").selectAll("path.legendwaterfall").data(a);
          o.enter().append("path").classed("legendwaterfall", !0).attr("transform", b).style("stroke-miterlimit", 1), o.exit().remove(), o.each(function (t) {
            var r = n.select(this),
                i = e[t[0]].marker,
                a = _(void 0, i.line, 5, 2);

            r.attr("d", t[1]).style("stroke-width", a + "px").call(l.fill, i.color), a && r.call(l.stroke, i.line.color);
          });
        }).each(function (t) {
          w(t, this, "funnel");
        }).each(function (t) {
          w(t, this);
        }).each(function (t) {
          var r = t[0].trace,
              o = n.select(this).select("g.legendpoints").selectAll("path.legendbox").data(r.visible && i.traceIs(r, "box-violin") ? [t] : []);
          o.enter().append("path").classed("legendbox", !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", b), o.exit().remove(), o.each(function () {
            var t = n.select(this);

            if ("all" !== r.boxpoints && "all" !== r.points || 0 !== l.opacity(r.fillcolor) || 0 !== l.opacity((r.line || {}).color)) {
              var i = _(void 0, r.line, 5, 2);

              t.style("stroke-width", i + "px").call(l.fill, r.fillcolor), i && l.stroke(t, r.line.color);
            } else {
              var c = a.minExtend(r, {
                marker: {
                  size: v ? 12 : a.constrain(r.marker.size, 2, 16),
                  sizeref: 1,
                  sizemin: 1,
                  sizemode: "diameter"
                }
              });
              o.call(s.pointStyle, c, e);
            }
          });
        }).each(function (t) {
          T(t, this, "funnelarea");
        }).each(function (t) {
          T(t, this, "pie");
        }).each(function (t) {
          var r,
              i,
              o = m(t),
              l = o.showFill,
              f = o.showLine,
              h = o.showGradientLine,
              p = o.showGradientFill,
              g = o.anyFill,
              v = o.anyLine,
              x = t[0],
              b = x.trace,
              w = c(b),
              T = w.colorscale,
              k = w.reversescale,
              M = u.hasMarkers(b) || !g ? "M5,0" : v ? "M5,-2" : "M5,-3",
              A = n.select(this),
              S = A.select(".legendfill").selectAll("path").data(l || p ? [t] : []);

          if (S.enter().append("path").classed("js-fill", !0), S.exit().remove(), S.attr("d", M + "h" + y + "v6h-" + y + "z").call(l ? s.fillGroupStyle : function (t) {
            if (t.size()) {
              var r = "legendfill-" + b.uid;
              s.gradient(t, e, r, d(k), T, "fill");
            }
          }), f || h) {
            var E = _(void 0, b.line, 10, 5);

            i = a.minExtend(b, {
              line: {
                width: E
              }
            }), r = [a.minExtend(x, {
              trace: i
            })];
          }

          var L = A.select(".legendlines").selectAll("path").data(f || h ? [r] : []);
          L.enter().append("path").classed("js-line", !0), L.exit().remove(), L.attr("d", M + (h ? "l" + y + ",0.0001" : "h" + y)).call(f ? s.lineGroupStyle : function (t) {
            if (t.size()) {
              var r = "legendline-" + b.uid;
              s.lineGroupStyle(t), s.gradient(t, e, r, d(k), T, "stroke");
            }
          });
        }).each(function (t) {
          var r,
              i,
              o = m(t),
              l = o.anyFill,
              c = o.anyLine,
              f = o.showLine,
              h = o.showMarker,
              p = t[0],
              d = p.trace,
              g = !h && !c && !l && u.hasText(d);

          function y(t, e, r, n) {
            var i = a.nestedProperty(d, t).get(),
                o = a.isArrayOrTypedArray(i) && e ? e(i) : i;

            if (v && o && void 0 !== n && (o = n), r) {
              if (o < r[0]) return r[0];
              if (o > r[1]) return r[1];
            }

            return o;
          }

          function x(t) {
            return p._distinct && p.index && t[p.index] ? t[p.index] : t[0];
          }

          if (h || g || f) {
            var _ = {},
                w = {};

            if (h) {
              _.mc = y("marker.color", x), _.mx = y("marker.symbol", x), _.mo = y("marker.opacity", a.mean, [.2, 1]), _.mlc = y("marker.line.color", x), _.mlw = y("marker.line.width", a.mean, [0, 5], 2), w.marker = {
                sizeref: 1,
                sizemin: 1,
                sizemode: "diameter"
              };
              var T = y("marker.size", a.mean, [2, 16], 12);
              _.ms = T, w.marker.size = T;
            }

            f && (w.line = {
              width: y("line.width", x, [0, 10], 5)
            }), g && (_.tx = "Aa", _.tp = y("textposition", x), _.ts = 10, _.tc = y("textfont.color", x), _.tf = y("textfont.family", x)), r = [a.minExtend(p, _)], (i = a.minExtend(d, w)).selectedpoints = null, i.texttemplate = null;
          }

          var k = n.select(this).select("g.legendpoints"),
              M = k.selectAll("path.scatterpts").data(h ? r : []);
          M.enter().insert("path", ":first-child").classed("scatterpts", !0).attr("transform", b), M.exit().remove(), M.call(s.pointStyle, i, e), h && (r[0].mrc = 3);
          var A = k.selectAll("g.pointtext").data(g ? r : []);
          A.enter().append("g").classed("pointtext", !0).append("text").attr("transform", b), A.exit().remove(), A.selectAll("text").call(s.textPointStyle, i, e);
        }).each(function (t) {
          var e = t[0].trace,
              r = n.select(this).select("g.legendpoints").selectAll("path.legendcandle").data(e.visible && "candlestick" === e.type ? [t, t] : []);
          r.enter().append("path").classed("legendcandle", !0).attr("d", function (t, e) {
            return e ? "M-15,0H-8M-8,6V-6H8Z" : "M15,0H8M8,-6V6H-8Z";
          }).attr("transform", b).style("stroke-miterlimit", 1), r.exit().remove(), r.each(function (t, r) {
            var i = n.select(this),
                a = e[r ? "increasing" : "decreasing"],
                o = _(void 0, a.line, 5, 2);

            i.style("stroke-width", o + "px").call(l.fill, a.fillcolor), o && l.stroke(i, a.line.color);
          });
        }).each(function (t) {
          var e = t[0].trace,
              r = n.select(this).select("g.legendpoints").selectAll("path.legendohlc").data(e.visible && "ohlc" === e.type ? [t, t] : []);
          r.enter().append("path").classed("legendohlc", !0).attr("d", function (t, e) {
            return e ? "M-15,0H0M-8,-6V0" : "M15,0H0M8,6V0";
          }).attr("transform", b).style("stroke-miterlimit", 1), r.exit().remove(), r.each(function (t, r) {
            var i = n.select(this),
                a = e[r ? "increasing" : "decreasing"],
                o = _(void 0, a.line, 5, 2);

            i.style("fill", "none").call(s.dashLine, a.line.dash, o), o && l.stroke(i, a.line.color);
          });
        });
      };
    }, {
      "../../lib": 795,
      "../../registry": 923,
      "../../traces/pie/helpers": 1178,
      "../../traces/pie/style_one": 1184,
      "../../traces/scatter/subtypes": 1224,
      "../color": 658,
      "../colorscale/helpers": 669,
      "../drawing": 680,
      "./constants": 709,
      "@plotly/d3": 57
    }],
    717: [function (t, e, r) {
      "use strict";

      t("./constants");
      e.exports = {
        editType: "modebar",
        orientation: {
          valType: "enumerated",
          values: ["v", "h"],
          dflt: "h",
          editType: "modebar"
        },
        bgcolor: {
          valType: "color",
          editType: "modebar"
        },
        color: {
          valType: "color",
          editType: "modebar"
        },
        activecolor: {
          valType: "color",
          editType: "modebar"
        },
        uirevision: {
          valType: "any",
          editType: "none"
        },
        add: {
          valType: "string",
          arrayOk: !0,
          dflt: "",
          editType: "modebar"
        },
        remove: {
          valType: "string",
          arrayOk: !0,
          dflt: "",
          editType: "modebar"
        }
      };
    }, {
      "./constants": 719
    }],
    718: [function (t, e, r) {
      "use strict";

      var n = t("../../registry"),
          i = t("../../plots/plots"),
          a = t("../../plots/cartesian/axis_ids"),
          o = t("../../fonts/ploticon"),
          s = t("../shapes/draw").eraseActiveShape,
          l = t("../../lib"),
          c = l._,
          u = e.exports = {};

      function f(t, e) {
        var r,
            i,
            o = e.currentTarget,
            s = o.getAttribute("data-attr"),
            l = o.getAttribute("data-val") || !0,
            c = t._fullLayout,
            u = {},
            f = a.list(t, null, !0),
            h = c._cartesianSpikesEnabled;

        if ("zoom" === s) {
          var p,
              d = "in" === l ? .5 : 2,
              m = (1 + d) / 2,
              g = (1 - d) / 2;

          for (i = 0; i < f.length; i++) {
            if (!(r = f[i]).fixedrange) if (p = r._name, "auto" === l) u[p + ".autorange"] = !0;else if ("reset" === l) {
              if (void 0 === r._rangeInitial) u[p + ".autorange"] = !0;else {
                var v = r._rangeInitial.slice();

                u[p + ".range[0]"] = v[0], u[p + ".range[1]"] = v[1];
              }
              void 0 !== r._showSpikeInitial && (u[p + ".showspikes"] = r._showSpikeInitial, "on" !== h || r._showSpikeInitial || (h = "off"));
            } else {
              var y = [r.r2l(r.range[0]), r.r2l(r.range[1])],
                  x = [m * y[0] + g * y[1], m * y[1] + g * y[0]];
              u[p + ".range[0]"] = r.l2r(x[0]), u[p + ".range[1]"] = r.l2r(x[1]);
            }
          }
        } else "hovermode" !== s || "x" !== l && "y" !== l || (l = c._isHoriz ? "y" : "x", o.setAttribute("data-val", l)), u[s] = l;

        c._cartesianSpikesEnabled = h, n.call("_guiRelayout", t, u);
      }

      function h(t, e) {
        for (var r = e.currentTarget, i = r.getAttribute("data-attr"), a = r.getAttribute("data-val") || !0, o = t._fullLayout._subplots.gl3d || [], s = {}, l = i.split("."), c = 0; c < o.length; c++) {
          s[o[c] + "." + l[1]] = a;
        }

        var u = "pan" === a ? a : "zoom";
        s.dragmode = u, n.call("_guiRelayout", t, s);
      }

      function p(t, e) {
        for (var r = e.currentTarget.getAttribute("data-attr"), i = "resetLastSave" === r, a = "resetDefault" === r, o = t._fullLayout, s = o._subplots.gl3d || [], l = {}, c = 0; c < s.length; c++) {
          var u,
              f = s[c],
              h = f + ".camera",
              p = f + ".aspectratio",
              d = f + ".aspectmode",
              m = o[f]._scene;
          i ? (l[h + ".up"] = m.viewInitial.up, l[h + ".eye"] = m.viewInitial.eye, l[h + ".center"] = m.viewInitial.center, u = !0) : a && (l[h + ".up"] = null, l[h + ".eye"] = null, l[h + ".center"] = null, u = !0), u && (l[p + ".x"] = m.viewInitial.aspectratio.x, l[p + ".y"] = m.viewInitial.aspectratio.y, l[p + ".z"] = m.viewInitial.aspectratio.z, l[d] = m.viewInitial.aspectmode);
        }

        n.call("_guiRelayout", t, l);
      }

      function d(t, e) {
        var r = e.currentTarget,
            n = r._previousVal,
            i = t._fullLayout,
            a = i._subplots.gl3d || [],
            o = ["xaxis", "yaxis", "zaxis"],
            s = {},
            l = {};
        if (n) l = n, r._previousVal = null;else {
          for (var c = 0; c < a.length; c++) {
            var u = a[c],
                f = i[u],
                h = u + ".hovermode";
            s[h] = f.hovermode, l[h] = !1;

            for (var p = 0; p < 3; p++) {
              var d = o[p],
                  m = u + "." + d + ".showspikes";
              l[m] = !1, s[m] = f[d].showspikes;
            }
          }

          r._previousVal = s;
        }
        return l;
      }

      function m(t, e) {
        for (var r = e.currentTarget, i = r.getAttribute("data-attr"), a = r.getAttribute("data-val") || !0, o = t._fullLayout, s = o._subplots.geo || [], l = 0; l < s.length; l++) {
          var c = s[l],
              u = o[c];

          if ("zoom" === i) {
            var f = u.projection.scale,
                h = "in" === a ? 2 * f : .5 * f;
            n.call("_guiRelayout", t, c + ".projection.scale", h);
          }
        }

        "reset" === i && x(t, "geo");
      }

      function g(t) {
        var e = t._fullLayout;
        return !e.hovermode && (e._has("cartesian") ? e._isHoriz ? "y" : "x" : "closest");
      }

      function v(t) {
        var e = g(t);
        n.call("_guiRelayout", t, "hovermode", e);
      }

      function y(t, e) {
        for (var r = e.currentTarget.getAttribute("data-val"), i = t._fullLayout, a = i._subplots.mapbox || [], o = {}, s = 0; s < a.length; s++) {
          var l = a[s],
              c = i[l].zoom,
              u = "in" === r ? 1.05 * c : c / 1.05;
          o[l + ".zoom"] = u;
        }

        n.call("_guiRelayout", t, o);
      }

      function x(t, e) {
        for (var r = t._fullLayout, i = r._subplots[e] || [], a = {}, o = 0; o < i.length; o++) {
          for (var s = i[o], l = r[s]._subplot.viewInitial, c = Object.keys(l), u = 0; u < c.length; u++) {
            var f = c[u];
            a[s + "." + f] = l[f];
          }
        }

        n.call("_guiRelayout", t, a);
      }

      u.toImage = {
        name: "toImage",
        title: function title(t) {
          var e = (t._context.toImageButtonOptions || {}).format || "png";
          return c(t, "png" === e ? "Download plot as a png" : "Download plot");
        },
        icon: o.camera,
        click: function click(t) {
          var e = t._context.toImageButtonOptions,
              r = {
            format: e.format || "png"
          };
          l.notifier(c(t, "Taking snapshot - this may take a few seconds"), "long"), "svg" !== r.format && l.isIE() && (l.notifier(c(t, "IE only supports svg.  Changing format to svg."), "long"), r.format = "svg"), ["filename", "width", "height", "scale"].forEach(function (t) {
            t in e && (r[t] = e[t]);
          }), n.call("downloadImage", t, r).then(function (e) {
            l.notifier(c(t, "Snapshot succeeded") + " - " + e, "long");
          }).catch(function () {
            l.notifier(c(t, "Sorry, there was a problem downloading your snapshot!"), "long");
          });
        }
      }, u.sendDataToCloud = {
        name: "sendDataToCloud",
        title: function title(t) {
          return c(t, "Edit in Chart Studio");
        },
        icon: o.disk,
        click: function click(t) {
          i.sendDataToCloud(t);
        }
      }, u.editInChartStudio = {
        name: "editInChartStudio",
        title: function title(t) {
          return c(t, "Edit in Chart Studio");
        },
        icon: o.pencil,
        click: function click(t) {
          i.sendDataToCloud(t);
        }
      }, u.zoom2d = {
        name: "zoom2d",
        _cat: "zoom",
        title: function title(t) {
          return c(t, "Zoom");
        },
        attr: "dragmode",
        val: "zoom",
        icon: o.zoombox,
        click: f
      }, u.pan2d = {
        name: "pan2d",
        _cat: "pan",
        title: function title(t) {
          return c(t, "Pan");
        },
        attr: "dragmode",
        val: "pan",
        icon: o.pan,
        click: f
      }, u.select2d = {
        name: "select2d",
        _cat: "select",
        title: function title(t) {
          return c(t, "Box Select");
        },
        attr: "dragmode",
        val: "select",
        icon: o.selectbox,
        click: f
      }, u.lasso2d = {
        name: "lasso2d",
        _cat: "lasso",
        title: function title(t) {
          return c(t, "Lasso Select");
        },
        attr: "dragmode",
        val: "lasso",
        icon: o.lasso,
        click: f
      }, u.drawclosedpath = {
        name: "drawclosedpath",
        title: function title(t) {
          return c(t, "Draw closed freeform");
        },
        attr: "dragmode",
        val: "drawclosedpath",
        icon: o.drawclosedpath,
        click: f
      }, u.drawopenpath = {
        name: "drawopenpath",
        title: function title(t) {
          return c(t, "Draw open freeform");
        },
        attr: "dragmode",
        val: "drawopenpath",
        icon: o.drawopenpath,
        click: f
      }, u.drawline = {
        name: "drawline",
        title: function title(t) {
          return c(t, "Draw line");
        },
        attr: "dragmode",
        val: "drawline",
        icon: o.drawline,
        click: f
      }, u.drawrect = {
        name: "drawrect",
        title: function title(t) {
          return c(t, "Draw rectangle");
        },
        attr: "dragmode",
        val: "drawrect",
        icon: o.drawrect,
        click: f
      }, u.drawcircle = {
        name: "drawcircle",
        title: function title(t) {
          return c(t, "Draw circle");
        },
        attr: "dragmode",
        val: "drawcircle",
        icon: o.drawcircle,
        click: f
      }, u.eraseshape = {
        name: "eraseshape",
        title: function title(t) {
          return c(t, "Erase active shape");
        },
        icon: o.eraseshape,
        click: s
      }, u.zoomIn2d = {
        name: "zoomIn2d",
        _cat: "zoomin",
        title: function title(t) {
          return c(t, "Zoom in");
        },
        attr: "zoom",
        val: "in",
        icon: o.zoom_plus,
        click: f
      }, u.zoomOut2d = {
        name: "zoomOut2d",
        _cat: "zoomout",
        title: function title(t) {
          return c(t, "Zoom out");
        },
        attr: "zoom",
        val: "out",
        icon: o.zoom_minus,
        click: f
      }, u.autoScale2d = {
        name: "autoScale2d",
        _cat: "autoscale",
        title: function title(t) {
          return c(t, "Autoscale");
        },
        attr: "zoom",
        val: "auto",
        icon: o.autoscale,
        click: f
      }, u.resetScale2d = {
        name: "resetScale2d",
        _cat: "resetscale",
        title: function title(t) {
          return c(t, "Reset axes");
        },
        attr: "zoom",
        val: "reset",
        icon: o.home,
        click: f
      }, u.hoverClosestCartesian = {
        name: "hoverClosestCartesian",
        _cat: "hoverclosest",
        title: function title(t) {
          return c(t, "Show closest data on hover");
        },
        attr: "hovermode",
        val: "closest",
        icon: o.tooltip_basic,
        gravity: "ne",
        click: f
      }, u.hoverCompareCartesian = {
        name: "hoverCompareCartesian",
        _cat: "hoverCompare",
        title: function title(t) {
          return c(t, "Compare data on hover");
        },
        attr: "hovermode",
        val: function val(t) {
          return t._fullLayout._isHoriz ? "y" : "x";
        },
        icon: o.tooltip_compare,
        gravity: "ne",
        click: f
      }, u.zoom3d = {
        name: "zoom3d",
        _cat: "zoom",
        title: function title(t) {
          return c(t, "Zoom");
        },
        attr: "scene.dragmode",
        val: "zoom",
        icon: o.zoombox,
        click: h
      }, u.pan3d = {
        name: "pan3d",
        _cat: "pan",
        title: function title(t) {
          return c(t, "Pan");
        },
        attr: "scene.dragmode",
        val: "pan",
        icon: o.pan,
        click: h
      }, u.orbitRotation = {
        name: "orbitRotation",
        title: function title(t) {
          return c(t, "Orbital rotation");
        },
        attr: "scene.dragmode",
        val: "orbit",
        icon: o["3d_rotate"],
        click: h
      }, u.tableRotation = {
        name: "tableRotation",
        title: function title(t) {
          return c(t, "Turntable rotation");
        },
        attr: "scene.dragmode",
        val: "turntable",
        icon: o["z-axis"],
        click: h
      }, u.resetCameraDefault3d = {
        name: "resetCameraDefault3d",
        _cat: "resetCameraDefault",
        title: function title(t) {
          return c(t, "Reset camera to default");
        },
        attr: "resetDefault",
        icon: o.home,
        click: p
      }, u.resetCameraLastSave3d = {
        name: "resetCameraLastSave3d",
        _cat: "resetCameraLastSave",
        title: function title(t) {
          return c(t, "Reset camera to last save");
        },
        attr: "resetLastSave",
        icon: o.movie,
        click: p
      }, u.hoverClosest3d = {
        name: "hoverClosest3d",
        _cat: "hoverclosest",
        title: function title(t) {
          return c(t, "Toggle show closest data on hover");
        },
        attr: "hovermode",
        val: null,
        toggle: !0,
        icon: o.tooltip_basic,
        gravity: "ne",
        click: function click(t, e) {
          var r = d(t, e);
          n.call("_guiRelayout", t, r);
        }
      }, u.zoomInGeo = {
        name: "zoomInGeo",
        _cat: "zoomin",
        title: function title(t) {
          return c(t, "Zoom in");
        },
        attr: "zoom",
        val: "in",
        icon: o.zoom_plus,
        click: m
      }, u.zoomOutGeo = {
        name: "zoomOutGeo",
        _cat: "zoomout",
        title: function title(t) {
          return c(t, "Zoom out");
        },
        attr: "zoom",
        val: "out",
        icon: o.zoom_minus,
        click: m
      }, u.resetGeo = {
        name: "resetGeo",
        _cat: "reset",
        title: function title(t) {
          return c(t, "Reset");
        },
        attr: "reset",
        val: null,
        icon: o.autoscale,
        click: m
      }, u.hoverClosestGeo = {
        name: "hoverClosestGeo",
        _cat: "hoverclosest",
        title: function title(t) {
          return c(t, "Toggle show closest data on hover");
        },
        attr: "hovermode",
        val: null,
        toggle: !0,
        icon: o.tooltip_basic,
        gravity: "ne",
        click: v
      }, u.hoverClosestGl2d = {
        name: "hoverClosestGl2d",
        _cat: "hoverclosest",
        title: function title(t) {
          return c(t, "Toggle show closest data on hover");
        },
        attr: "hovermode",
        val: null,
        toggle: !0,
        icon: o.tooltip_basic,
        gravity: "ne",
        click: v
      }, u.hoverClosestPie = {
        name: "hoverClosestPie",
        _cat: "hoverclosest",
        title: function title(t) {
          return c(t, "Toggle show closest data on hover");
        },
        attr: "hovermode",
        val: "closest",
        icon: o.tooltip_basic,
        gravity: "ne",
        click: v
      }, u.resetViewSankey = {
        name: "resetSankeyGroup",
        title: function title(t) {
          return c(t, "Reset view");
        },
        icon: o.home,
        click: function click(t) {
          for (var e = {
            "node.groups": [],
            "node.x": [],
            "node.y": []
          }, r = 0; r < t._fullData.length; r++) {
            var i = t._fullData[r]._viewInitial;
            e["node.groups"].push(i.node.groups.slice()), e["node.x"].push(i.node.x.slice()), e["node.y"].push(i.node.y.slice());
          }

          n.call("restyle", t, e);
        }
      }, u.toggleHover = {
        name: "toggleHover",
        title: function title(t) {
          return c(t, "Toggle show closest data on hover");
        },
        attr: "hovermode",
        val: null,
        toggle: !0,
        icon: o.tooltip_basic,
        gravity: "ne",
        click: function click(t, e) {
          var r = d(t, e);
          r.hovermode = g(t), n.call("_guiRelayout", t, r);
        }
      }, u.resetViews = {
        name: "resetViews",
        title: function title(t) {
          return c(t, "Reset views");
        },
        icon: o.home,
        click: function click(t, e) {
          var r = e.currentTarget;
          r.setAttribute("data-attr", "zoom"), r.setAttribute("data-val", "reset"), f(t, e), r.setAttribute("data-attr", "resetLastSave"), p(t, e), x(t, "geo"), x(t, "mapbox");
        }
      }, u.toggleSpikelines = {
        name: "toggleSpikelines",
        title: function title(t) {
          return c(t, "Toggle Spike Lines");
        },
        icon: o.spikeline,
        attr: "_cartesianSpikesEnabled",
        val: "on",
        click: function click(t) {
          var e = t._fullLayout,
              r = e._cartesianSpikesEnabled;
          e._cartesianSpikesEnabled = "on" === r ? "off" : "on", n.call("_guiRelayout", t, function (t) {
            for (var e = "on" === t._fullLayout._cartesianSpikesEnabled, r = a.list(t, null, !0), n = {}, i = 0; i < r.length; i++) {
              var o = r[i];
              n[o._name + ".showspikes"] = !!e || o._showSpikeInitial;
            }

            return n;
          }(t));
        }
      }, u.resetViewMapbox = {
        name: "resetViewMapbox",
        _cat: "resetView",
        title: function title(t) {
          return c(t, "Reset view");
        },
        attr: "reset",
        icon: o.home,
        click: function click(t) {
          x(t, "mapbox");
        }
      }, u.zoomInMapbox = {
        name: "zoomInMapbox",
        _cat: "zoomin",
        title: function title(t) {
          return c(t, "Zoom in");
        },
        attr: "zoom",
        val: "in",
        icon: o.zoom_plus,
        click: y
      }, u.zoomOutMapbox = {
        name: "zoomOutMapbox",
        _cat: "zoomout",
        title: function title(t) {
          return c(t, "Zoom out");
        },
        attr: "zoom",
        val: "out",
        icon: o.zoom_minus,
        click: y
      };
    }, {
      "../../fonts/ploticon": 774,
      "../../lib": 795,
      "../../plots/cartesian/axis_ids": 848,
      "../../plots/plots": 909,
      "../../registry": 923,
      "../shapes/draw": 742
    }],
    719: [function (t, e, r) {
      "use strict";

      var n = t("./buttons"),
          i = Object.keys(n),
          a = ["drawline", "drawopenpath", "drawclosedpath", "drawcircle", "drawrect", "eraseshape"],
          o = ["v1hovermode", "hoverclosest", "hovercompare", "togglehover", "togglespikelines"].concat(a),
          s = [];
      i.forEach(function (t) {
        !function (t) {
          if (-1 === o.indexOf(t._cat || t.name)) {
            var e = t.name,
                r = (t._cat || t.name).toLowerCase();
            -1 === s.indexOf(e) && s.push(e), -1 === s.indexOf(r) && s.push(r);
          }
        }(n[t]);
      }), s.sort(), e.exports = {
        DRAW_MODES: a,
        backButtons: o,
        foreButtons: s
      };
    }, {
      "./buttons": 718
    }],
    720: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../color"),
          a = t("../../plot_api/plot_template"),
          o = t("./attributes");

      e.exports = function (t, e) {
        var r = t.modebar || {},
            s = a.newContainer(e, "modebar");

        function l(t, e) {
          return n.coerce(r, s, o, t, e);
        }

        l("orientation"), l("bgcolor", i.addOpacity(e.paper_bgcolor, .5));
        var c = i.contrast(i.rgb(e.modebar.bgcolor));
        l("color", i.addOpacity(c, .3)), l("activecolor", i.addOpacity(c, .7)), l("uirevision", e.uirevision), l("add"), l("remove");
      };
    }, {
      "../../lib": 795,
      "../../plot_api/plot_template": 834,
      "../color": 658,
      "./attributes": 717
    }],
    721: [function (t, e, r) {
      "use strict";

      e.exports = {
        moduleType: "component",
        name: "modebar",
        layoutAttributes: t("./attributes"),
        supplyLayoutDefaults: t("./defaults"),
        manage: t("./manage")
      };
    }, {
      "./attributes": 717,
      "./defaults": 720,
      "./manage": 722
    }],
    722: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/cartesian/axis_ids"),
          i = t("../../traces/scatter/subtypes"),
          a = t("../../registry"),
          o = t("../fx/helpers").isUnifiedHover,
          s = t("./modebar"),
          l = t("./buttons"),
          c = t("./constants").DRAW_MODES;

      e.exports = function (t) {
        var e = t._fullLayout,
            r = t._context,
            u = e._modeBar;

        if (r.displayModeBar || r.watermark) {
          if (!Array.isArray(r.modeBarButtonsToRemove)) throw new Error(["*modeBarButtonsToRemove* configuration options", "must be an array."].join(" "));
          if (!Array.isArray(r.modeBarButtonsToAdd)) throw new Error(["*modeBarButtonsToAdd* configuration options", "must be an array."].join(" "));
          var f,
              h = r.modeBarButtons;
          f = Array.isArray(h) && h.length ? function (t) {
            for (var e = 0; e < t.length; e++) {
              for (var r = t[e], n = 0; n < r.length; n++) {
                var i = r[n];

                if ("string" == typeof i) {
                  if (void 0 === l[i]) throw new Error(["*modeBarButtons* configuration options", "invalid button name"].join(" "));
                  t[e][n] = l[i];
                }
              }
            }

            return t;
          }(h) : !r.displayModeBar && r.watermark ? [] : function (t) {
            var e = t._fullLayout,
                r = t._fullData,
                s = t._context;

            function u(t, e) {
              if ("string" == typeof e) {
                if (e.toLowerCase() === t.toLowerCase()) return !0;
              } else {
                var r = e.name,
                    n = e._cat || e.name;
                if (r === t || n === t.toLowerCase()) return !0;
              }

              return !1;
            }

            var f = e.modebar.add;
            "string" == typeof f && (f = [f]);
            var h = e.modebar.remove;
            "string" == typeof h && (h = [h]);

            var p = s.modeBarButtonsToAdd.concat(f.filter(function (t) {
              for (var e = 0; e < s.modeBarButtonsToRemove.length; e++) {
                if (u(t, s.modeBarButtonsToRemove[e])) return !1;
              }

              return !0;
            })),
                d = s.modeBarButtonsToRemove.concat(h.filter(function (t) {
              for (var e = 0; e < s.modeBarButtonsToAdd.length; e++) {
                if (u(t, s.modeBarButtonsToAdd[e])) return !1;
              }

              return !0;
            })),
                m = e._has("cartesian"),
                g = e._has("gl3d"),
                v = e._has("geo"),
                y = e._has("pie"),
                x = e._has("funnelarea"),
                b = e._has("gl2d"),
                _ = e._has("ternary"),
                w = e._has("mapbox"),
                T = e._has("polar"),
                k = e._has("sankey"),
                M = function (t) {
              for (var e = n.list({
                _fullLayout: t
              }, null, !0), r = 0; r < e.length; r++) {
                if (!e[r].fixedrange) return !1;
              }

              return !0;
            }(e),
                A = o(e.hovermode),
                S = [];

            function E(t) {
              if (t.length) {
                for (var e = [], r = 0; r < t.length; r++) {
                  for (var n = t[r], i = l[n], a = i.name.toLowerCase(), o = (i._cat || i.name).toLowerCase(), s = !1, c = 0; c < d.length; c++) {
                    var u = d[c].toLowerCase();

                    if (u === a || u === o) {
                      s = !0;
                      break;
                    }
                  }

                  s || e.push(l[n]);
                }

                S.push(e);
              }
            }

            var L = ["toImage"];
            s.showEditInChartStudio ? L.push("editInChartStudio") : s.showSendToCloud && L.push("sendDataToCloud");
            E(L);
            var C = [],
                P = [],
                I = [],
                O = [];
            (m || b || y || x || _) + v + g + w + T > 1 ? (P = ["toggleHover"], I = ["resetViews"]) : v ? (C = ["zoomInGeo", "zoomOutGeo"], P = ["hoverClosestGeo"], I = ["resetGeo"]) : g ? (P = ["hoverClosest3d"], I = ["resetCameraDefault3d", "resetCameraLastSave3d"]) : w ? (C = ["zoomInMapbox", "zoomOutMapbox"], P = ["toggleHover"], I = ["resetViewMapbox"]) : b ? P = ["hoverClosestGl2d"] : y ? P = ["hoverClosestPie"] : k ? (P = ["hoverClosestCartesian", "hoverCompareCartesian"], I = ["resetViewSankey"]) : P = ["toggleHover"];
            m && (P = ["toggleSpikelines", "hoverClosestCartesian", "hoverCompareCartesian"]);
            ((function (t) {
              for (var e = 0; e < t.length; e++) {
                if (!a.traceIs(t[e], "noHover")) return !1;
              }

              return !0;
            })(r) || A) && (P = []);
            !m && !b || M || (C = ["zoomIn2d", "zoomOut2d", "autoScale2d"], "resetViews" !== I[0] && (I = ["resetScale2d"]));
            g ? O = ["zoom3d", "pan3d", "orbitRotation", "tableRotation"] : (m || b) && !M || _ ? O = ["zoom2d", "pan2d"] : w || v ? O = ["pan2d"] : T && (O = ["zoom2d"]);
            (function (t) {
              for (var e = !1, r = 0; r < t.length && !e; r++) {
                var n = t[r];
                n._module && n._module.selectPoints && (a.traceIs(n, "scatter-like") ? (i.hasMarkers(n) || i.hasText(n)) && (e = !0) : a.traceIs(n, "box-violin") && "all" !== n.boxpoints && "all" !== n.points || (e = !0));
              }

              return e;
            })(r) && O.push("select2d", "lasso2d");

            var z = [],
                D = function D(t) {
              -1 === z.indexOf(t) && -1 !== P.indexOf(t) && z.push(t);
            };

            if (Array.isArray(p)) {
              for (var R = [], F = 0; F < p.length; F++) {
                var B = p[F];
                "string" == typeof B ? (B = B.toLowerCase(), -1 !== c.indexOf(B) ? (e._has("mapbox") || e._has("cartesian")) && O.push(B) : "togglespikelines" === B ? D("toggleSpikelines") : "togglehover" === B ? D("toggleHover") : "hovercompare" === B ? D("hoverCompareCartesian") : "hoverclosest" === B ? (D("hoverClosestCartesian"), D("hoverClosestGeo"), D("hoverClosest3d"), D("hoverClosestGl2d"), D("hoverClosestPie")) : "v1hovermode" === B && (D("toggleHover"), D("hoverClosestCartesian"), D("hoverCompareCartesian"), D("hoverClosestGeo"), D("hoverClosest3d"), D("hoverClosestGl2d"), D("hoverClosestPie"))) : R.push(B);
              }

              p = R;
            }

            return E(O), E(C.concat(I)), E(z), function (t, e) {
              if (e.length) if (Array.isArray(e[0])) for (var r = 0; r < e.length; r++) {
                t.push(e[r]);
              } else t.push(e);
              return t;
            }(S, p);
          }(t), u ? u.update(t, f) : e._modeBar = s(t, f);
        } else u && (u.destroy(), delete e._modeBar);
      };
    }, {
      "../../plots/cartesian/axis_ids": 848,
      "../../registry": 923,
      "../../traces/scatter/subtypes": 1224,
      "../fx/helpers": 694,
      "./buttons": 718,
      "./constants": 719,
      "./modebar": 723
    }],
    723: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("fast-isnumeric"),
          a = t("../../lib"),
          o = t("../../fonts/ploticon"),
          s = new DOMParser();

      function l(t) {
        this.container = t.container, this.element = document.createElement("div"), this.update(t.graphInfo, t.buttons), this.container.appendChild(this.element);
      }

      var c = l.prototype;
      c.update = function (t, e) {
        this.graphInfo = t;
        var r = this.graphInfo._context,
            n = this.graphInfo._fullLayout,
            i = "modebar-" + n._uid;
        this.element.setAttribute("id", i), this._uid = i, this.element.className = "modebar", "hover" === r.displayModeBar && (this.element.className += " modebar--hover ease-bg"), "v" === n.modebar.orientation && (this.element.className += " vertical", e = e.reverse());
        var o = n.modebar,
            s = "hover" === r.displayModeBar ? ".js-plotly-plot .plotly:hover " : "";
        a.deleteRelatedStyleRule(i), a.addRelatedStyleRule(i, s + "#" + i + " .modebar-group", "background-color: " + o.bgcolor), a.addRelatedStyleRule(i, "#" + i + " .modebar-btn .icon path", "fill: " + o.color), a.addRelatedStyleRule(i, "#" + i + " .modebar-btn:hover .icon path", "fill: " + o.activecolor), a.addRelatedStyleRule(i, "#" + i + " .modebar-btn.active .icon path", "fill: " + o.activecolor);
        var l = !this.hasButtons(e),
            c = this.hasLogo !== r.displaylogo,
            u = this.locale !== r.locale;

        if (this.locale = r.locale, (l || c || u) && (this.removeAllButtons(), this.updateButtons(e), r.watermark || r.displaylogo)) {
          var f = this.getLogo();
          r.watermark && (f.className = f.className + " watermark"), "v" === n.modebar.orientation ? this.element.insertBefore(f, this.element.childNodes[0]) : this.element.appendChild(f), this.hasLogo = !0;
        }

        this.updateActiveButton();
      }, c.updateButtons = function (t) {
        var e = this;
        this.buttons = t, this.buttonElements = [], this.buttonsNames = [], this.buttons.forEach(function (t) {
          var r = e.createGroup();
          t.forEach(function (t) {
            var n = t.name;
            if (!n) throw new Error("must provide button 'name' in button config");
            if (-1 !== e.buttonsNames.indexOf(n)) throw new Error("button name '" + n + "' is taken");
            e.buttonsNames.push(n);
            var i = e.createButton(t);
            e.buttonElements.push(i), r.appendChild(i);
          }), e.element.appendChild(r);
        });
      }, c.createGroup = function () {
        var t = document.createElement("div");
        return t.className = "modebar-group", t;
      }, c.createButton = function (t) {
        var e = this,
            r = document.createElement("a");
        r.setAttribute("rel", "tooltip"), r.className = "modebar-btn";
        var i = t.title;
        void 0 === i ? i = t.name : "function" == typeof i && (i = i(this.graphInfo)), (i || 0 === i) && r.setAttribute("data-title", i), void 0 !== t.attr && r.setAttribute("data-attr", t.attr);
        var a = t.val;
        if (void 0 !== a && ("function" == typeof a && (a = a(this.graphInfo)), r.setAttribute("data-val", a)), "function" != typeof t.click) throw new Error("must provide button 'click' function in button config");
        r.addEventListener("click", function (r) {
          t.click(e.graphInfo, r), e.updateActiveButton(r.currentTarget);
        }), r.setAttribute("data-toggle", t.toggle || !1), t.toggle && n.select(r).classed("active", !0);
        var s = t.icon;
        return "function" == typeof s ? r.appendChild(s()) : r.appendChild(this.createIcon(s || o.question)), r.setAttribute("data-gravity", t.gravity || "n"), r;
      }, c.createIcon = function (t) {
        var e,
            r = i(t.height) ? Number(t.height) : t.ascent - t.descent,
            n = "http://www.w3.org/2000/svg";

        if (t.path) {
          (e = document.createElementNS(n, "svg")).setAttribute("viewBox", [0, 0, t.width, r].join(" ")), e.setAttribute("class", "icon");
          var a = document.createElementNS(n, "path");
          a.setAttribute("d", t.path), t.transform ? a.setAttribute("transform", t.transform) : void 0 !== t.ascent && a.setAttribute("transform", "matrix(1 0 0 -1 0 " + t.ascent + ")"), e.appendChild(a);
        }

        t.svg && (e = s.parseFromString(t.svg, "application/xml").childNodes[0]);
        return e.setAttribute("height", "1em"), e.setAttribute("width", "1em"), e;
      }, c.updateActiveButton = function (t) {
        var e = this.graphInfo._fullLayout,
            r = void 0 !== t ? t.getAttribute("data-attr") : null;
        this.buttonElements.forEach(function (t) {
          var i = t.getAttribute("data-val") || !0,
              o = t.getAttribute("data-attr"),
              s = "true" === t.getAttribute("data-toggle"),
              l = n.select(t);
          if (s) o === r && l.classed("active", !l.classed("active"));else {
            var c = null === o ? o : a.nestedProperty(e, o).get();
            l.classed("active", c === i);
          }
        });
      }, c.hasButtons = function (t) {
        var e = this.buttons;
        if (!e) return !1;
        if (t.length !== e.length) return !1;

        for (var r = 0; r < t.length; ++r) {
          if (t[r].length !== e[r].length) return !1;

          for (var n = 0; n < t[r].length; n++) {
            if (t[r][n].name !== e[r][n].name) return !1;
          }
        }

        return !0;
      }, c.getLogo = function () {
        var t = this.createGroup(),
            e = document.createElement("a");
        return e.href = "https://plotly.com/", e.target = "_blank", e.setAttribute("data-title", a._(this.graphInfo, "Produced with Plotly")), e.className = "modebar-btn plotlyjsicon modebar-btn--logo", e.appendChild(this.createIcon(o.newplotlylogo)), t.appendChild(e), t;
      }, c.removeAllButtons = function () {
        for (; this.element.firstChild;) {
          this.element.removeChild(this.element.firstChild);
        }

        this.hasLogo = !1;
      }, c.destroy = function () {
        a.removeElement(this.container.querySelector(".modebar")), a.deleteRelatedStyleRule(this._uid);
      }, e.exports = function (t, e) {
        var r = t._fullLayout,
            i = new l({
          graphInfo: t,
          container: r._modebardiv.node(),
          buttons: e
        });
        return r._privateplot && n.select(i.element).append("span").classed("badge-private float--left", !0).text("PRIVATE"), i;
      };
    }, {
      "../../fonts/ploticon": 774,
      "../../lib": 795,
      "@plotly/d3": 57,
      "fast-isnumeric": 240
    }],
    724: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/font_attributes"),
          i = t("../color/attributes"),
          a = (0, t("../../plot_api/plot_template").templatedArray)("button", {
        visible: {
          valType: "boolean",
          dflt: !0,
          editType: "plot"
        },
        step: {
          valType: "enumerated",
          values: ["month", "year", "day", "hour", "minute", "second", "all"],
          dflt: "month",
          editType: "plot"
        },
        stepmode: {
          valType: "enumerated",
          values: ["backward", "todate"],
          dflt: "backward",
          editType: "plot"
        },
        count: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "plot"
        },
        label: {
          valType: "string",
          editType: "plot"
        },
        editType: "plot"
      });
      e.exports = {
        visible: {
          valType: "boolean",
          editType: "plot"
        },
        buttons: a,
        x: {
          valType: "number",
          min: -2,
          max: 3,
          editType: "plot"
        },
        xanchor: {
          valType: "enumerated",
          values: ["auto", "left", "center", "right"],
          dflt: "left",
          editType: "plot"
        },
        y: {
          valType: "number",
          min: -2,
          max: 3,
          editType: "plot"
        },
        yanchor: {
          valType: "enumerated",
          values: ["auto", "top", "middle", "bottom"],
          dflt: "bottom",
          editType: "plot"
        },
        font: n({
          editType: "plot"
        }),
        bgcolor: {
          valType: "color",
          dflt: i.lightLine,
          editType: "plot"
        },
        activecolor: {
          valType: "color",
          editType: "plot"
        },
        bordercolor: {
          valType: "color",
          dflt: i.defaultLine,
          editType: "plot"
        },
        borderwidth: {
          valType: "number",
          min: 0,
          dflt: 0,
          editType: "plot"
        },
        editType: "plot"
      };
    }, {
      "../../plot_api/plot_template": 834,
      "../../plots/font_attributes": 873,
      "../color/attributes": 657
    }],
    725: [function (t, e, r) {
      "use strict";

      e.exports = {
        yPad: .02,
        minButtonWidth: 30,
        rx: 3,
        ry: 3,
        lightAmount: 25,
        darkAmount: 10
      };
    }, {}],
    726: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../color"),
          a = t("../../plot_api/plot_template"),
          o = t("../../plots/array_container_defaults"),
          s = t("./attributes"),
          l = t("./constants");

      function c(t, e, r, i) {
        var a = i.calendar;

        function o(r, i) {
          return n.coerce(t, e, s.buttons, r, i);
        }

        if (o("visible")) {
          var l = o("step");
          "all" !== l && (!a || "gregorian" === a || "month" !== l && "year" !== l ? o("stepmode") : e.stepmode = "backward", o("count")), o("label");
        }
      }

      e.exports = function (t, e, r, u, f) {
        var h = t.rangeselector || {},
            p = a.newContainer(e, "rangeselector");

        function d(t, e) {
          return n.coerce(h, p, s, t, e);
        }

        if (d("visible", o(h, p, {
          name: "buttons",
          handleItemDefaults: c,
          calendar: f
        }).length > 0)) {
          var m = function (t, e, r) {
            for (var n = r.filter(function (r) {
              return e[r].anchor === t._id;
            }), i = 0, a = 0; a < n.length; a++) {
              var o = e[n[a]].domain;
              o && (i = Math.max(o[1], i));
            }

            return [t.domain[0], i + l.yPad];
          }(e, r, u);

          d("x", m[0]), d("y", m[1]), n.noneOrAll(t, e, ["x", "y"]), d("xanchor"), d("yanchor"), n.coerceFont(d, "font", r.font);
          var g = d("bgcolor");
          d("activecolor", i.contrast(g, l.lightAmount, l.darkAmount)), d("bordercolor"), d("borderwidth");
        }
      };
    }, {
      "../../lib": 795,
      "../../plot_api/plot_template": 834,
      "../../plots/array_container_defaults": 840,
      "../color": 658,
      "./attributes": 724,
      "./constants": 725
    }],
    727: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../registry"),
          a = t("../../plots/plots"),
          o = t("../color"),
          s = t("../drawing"),
          l = t("../../lib"),
          c = l.strTranslate,
          u = t("../../lib/svg_text_utils"),
          f = t("../../plots/cartesian/axis_ids"),
          h = t("../../constants/alignment"),
          p = h.LINE_SPACING,
          d = h.FROM_TL,
          m = h.FROM_BR,
          g = t("./constants"),
          v = t("./get_update_object");

      function y(t) {
        return t._id;
      }

      function x(t, e, r) {
        var n = l.ensureSingle(t, "rect", "selector-rect", function (t) {
          t.attr("shape-rendering", "crispEdges");
        });
        n.attr({
          rx: g.rx,
          ry: g.ry
        }), n.call(o.stroke, e.bordercolor).call(o.fill, function (t, e) {
          return e._isActive || e._isHovered ? t.activecolor : t.bgcolor;
        }(e, r)).style("stroke-width", e.borderwidth + "px");
      }

      function b(t, e, r, n) {
        l.ensureSingle(t, "text", "selector-text", function (t) {
          t.attr("text-anchor", "middle");
        }).call(s.font, e.font).text(function (t, e) {
          if (t.label) return e ? l.templateString(t.label, e) : t.label;
          return "all" === t.step ? "all" : t.count + t.step.charAt(0);
        }(r, n._fullLayout._meta)).call(function (t) {
          u.convertToTspans(t, n);
        });
      }

      e.exports = function (t) {
        var e = t._fullLayout._infolayer.selectAll(".rangeselector").data(function (t) {
          for (var e = f.list(t, "x", !0), r = [], n = 0; n < e.length; n++) {
            var i = e[n];
            i.rangeselector && i.rangeselector.visible && r.push(i);
          }

          return r;
        }(t), y);

        e.enter().append("g").classed("rangeselector", !0), e.exit().remove(), e.style({
          cursor: "pointer",
          "pointer-events": "all"
        }), e.each(function (e) {
          var r = n.select(this),
              o = e,
              f = o.rangeselector,
              h = r.selectAll("g.button").data(l.filterVisible(f.buttons));
          h.enter().append("g").classed("button", !0), h.exit().remove(), h.each(function (e) {
            var r = n.select(this),
                a = v(o, e);
            e._isActive = function (t, e, r) {
              if ("all" === e.step) return !0 === t.autorange;
              var n = Object.keys(r);
              return t.range[0] === r[n[0]] && t.range[1] === r[n[1]];
            }(o, e, a), r.call(x, f, e), r.call(b, f, e, t), r.on("click", function () {
              t._dragged || i.call("_guiRelayout", t, a);
            }), r.on("mouseover", function () {
              e._isHovered = !0, r.call(x, f, e);
            }), r.on("mouseout", function () {
              e._isHovered = !1, r.call(x, f, e);
            });
          }), function (t, e, r, i, o) {
            var f = 0,
                h = 0,
                v = r.borderwidth;
            e.each(function () {
              var t = n.select(this).select(".selector-text"),
                  e = r.font.size * p,
                  i = Math.max(e * u.lineCount(t), 16) + 3;
              h = Math.max(h, i);
            }), e.each(function () {
              var t = n.select(this),
                  e = t.select(".selector-rect"),
                  i = t.select(".selector-text"),
                  a = i.node() && s.bBox(i.node()).width,
                  o = r.font.size * p,
                  l = u.lineCount(i),
                  d = Math.max(a + 10, g.minButtonWidth);
              t.attr("transform", c(v + f, v)), e.attr({
                x: 0,
                y: 0,
                width: d,
                height: h
              }), u.positionText(i, d / 2, h / 2 - (l - 1) * o / 2 + 3), f += d + 5;
            });
            var y = t._fullLayout._size,
                x = y.l + y.w * r.x,
                b = y.t + y.h * (1 - r.y),
                _ = "left";
            l.isRightAnchor(r) && (x -= f, _ = "right");
            l.isCenterAnchor(r) && (x -= f / 2, _ = "center");
            var w = "top";
            l.isBottomAnchor(r) && (b -= h, w = "bottom");
            l.isMiddleAnchor(r) && (b -= h / 2, w = "middle");
            f = Math.ceil(f), h = Math.ceil(h), x = Math.round(x), b = Math.round(b), a.autoMargin(t, i + "-range-selector", {
              x: r.x,
              y: r.y,
              l: f * d[_],
              r: f * m[_],
              b: h * m[w],
              t: h * d[w]
            }), o.attr("transform", c(x, b));
          }(t, h, f, o._name, r);
        });
      };
    }, {
      "../../constants/alignment": 763,
      "../../lib": 795,
      "../../lib/svg_text_utils": 820,
      "../../plots/cartesian/axis_ids": 848,
      "../../plots/plots": 909,
      "../../registry": 923,
      "../color": 658,
      "../drawing": 680,
      "./constants": 725,
      "./get_update_object": 728,
      "@plotly/d3": 57
    }],
    728: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3");

      e.exports = function (t, e) {
        var r = t._name,
            i = {};
        if ("all" === e.step) i[r + ".autorange"] = !0;else {
          var a = function (t, e) {
            var r,
                i = t.range,
                a = new Date(t.r2l(i[1])),
                o = e.step,
                s = e.count;

            switch (e.stepmode) {
              case "backward":
                r = t.l2r(+n.time[o].utc.offset(a, -s));
                break;

              case "todate":
                var l = n.time[o].utc.offset(a, -s);
                r = t.l2r(+n.time[o].utc.ceil(l));
            }

            var c = i[1];
            return [r, c];
          }(t, e);

          i[r + ".range[0]"] = a[0], i[r + ".range[1]"] = a[1];
        }
        return i;
      };
    }, {
      "@plotly/d3": 57
    }],
    729: [function (t, e, r) {
      "use strict";

      e.exports = {
        moduleType: "component",
        name: "rangeselector",
        schema: {
          subplots: {
            xaxis: {
              rangeselector: t("./attributes")
            }
          }
        },
        layoutAttributes: t("./attributes"),
        handleDefaults: t("./defaults"),
        draw: t("./draw")
      };
    }, {
      "./attributes": 724,
      "./defaults": 726,
      "./draw": 727
    }],
    730: [function (t, e, r) {
      "use strict";

      var n = t("../color/attributes");
      e.exports = {
        bgcolor: {
          valType: "color",
          dflt: n.background,
          editType: "plot"
        },
        bordercolor: {
          valType: "color",
          dflt: n.defaultLine,
          editType: "plot"
        },
        borderwidth: {
          valType: "integer",
          dflt: 0,
          min: 0,
          editType: "plot"
        },
        autorange: {
          valType: "boolean",
          dflt: !0,
          editType: "calc",
          impliedEdits: {
            "range[0]": void 0,
            "range[1]": void 0
          }
        },
        range: {
          valType: "info_array",
          items: [{
            valType: "any",
            editType: "calc",
            impliedEdits: {
              "^autorange": !1
            }
          }, {
            valType: "any",
            editType: "calc",
            impliedEdits: {
              "^autorange": !1
            }
          }],
          editType: "calc",
          impliedEdits: {
            autorange: !1
          }
        },
        thickness: {
          valType: "number",
          dflt: .15,
          min: 0,
          max: 1,
          editType: "plot"
        },
        visible: {
          valType: "boolean",
          dflt: !0,
          editType: "calc"
        },
        editType: "calc"
      };
    }, {
      "../color/attributes": 657
    }],
    731: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/cartesian/axis_ids").list,
          i = t("../../plots/cartesian/autorange").getAutoRange,
          a = t("./constants");

      e.exports = function (t) {
        for (var e = n(t, "x", !0), r = 0; r < e.length; r++) {
          var o = e[r],
              s = o[a.name];
          s && s.visible && s.autorange && (s._input.autorange = !0, s._input.range = s.range = i(t, o));
        }
      };
    }, {
      "../../plots/cartesian/autorange": 844,
      "../../plots/cartesian/axis_ids": 848,
      "./constants": 732
    }],
    732: [function (t, e, r) {
      "use strict";

      e.exports = {
        name: "rangeslider",
        containerClassName: "rangeslider-container",
        bgClassName: "rangeslider-bg",
        rangePlotClassName: "rangeslider-rangeplot",
        maskMinClassName: "rangeslider-mask-min",
        maskMaxClassName: "rangeslider-mask-max",
        slideBoxClassName: "rangeslider-slidebox",
        grabberMinClassName: "rangeslider-grabber-min",
        grabAreaMinClassName: "rangeslider-grabarea-min",
        handleMinClassName: "rangeslider-handle-min",
        grabberMaxClassName: "rangeslider-grabber-max",
        grabAreaMaxClassName: "rangeslider-grabarea-max",
        handleMaxClassName: "rangeslider-handle-max",
        maskMinOppAxisClassName: "rangeslider-mask-min-opp-axis",
        maskMaxOppAxisClassName: "rangeslider-mask-max-opp-axis",
        maskColor: "rgba(0,0,0,0.4)",
        maskOppAxisColor: "rgba(0,0,0,0.2)",
        slideBoxFill: "transparent",
        slideBoxCursor: "ew-resize",
        grabAreaFill: "transparent",
        grabAreaCursor: "col-resize",
        grabAreaWidth: 10,
        handleWidth: 4,
        handleRadius: 1,
        handleStrokeWidth: 1,
        extraPad: 15
      };
    }, {}],
    733: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../plot_api/plot_template"),
          a = t("../../plots/cartesian/axis_ids"),
          o = t("./attributes"),
          s = t("./oppaxis_attributes");

      e.exports = function (t, e, r) {
        var l = t[r],
            c = e[r];

        if (l.rangeslider || e._requestRangeslider[c._id]) {
          n.isPlainObject(l.rangeslider) || (l.rangeslider = {});
          var u,
              f,
              h = l.rangeslider,
              p = i.newContainer(c, "rangeslider");

          if (_("visible")) {
            _("bgcolor", e.plot_bgcolor), _("bordercolor"), _("borderwidth"), _("thickness"), _("autorange", !c.isValidRange(h.range)), _("range");
            var d = e._subplots;
            if (d) for (var m = d.cartesian.filter(function (t) {
              return t.substr(0, t.indexOf("y")) === a.name2id(r);
            }).map(function (t) {
              return t.substr(t.indexOf("y"), t.length);
            }), g = n.simpleMap(m, a.id2name), v = 0; v < g.length; v++) {
              var y = g[v];
              u = h[y] || {}, f = i.newContainer(p, y, "yaxis");
              var x,
                  b = e[y];
              u.range && b.isValidRange(u.range) && (x = "fixed"), "match" !== w("rangemode", x) && w("range", b.range.slice());
            }
            p._input = h;
          }
        }

        function _(t, e) {
          return n.coerce(h, p, o, t, e);
        }

        function w(t, e) {
          return n.coerce(u, f, s, t, e);
        }
      };
    }, {
      "../../lib": 795,
      "../../plot_api/plot_template": 834,
      "../../plots/cartesian/axis_ids": 848,
      "./attributes": 730,
      "./oppaxis_attributes": 737
    }],
    734: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../registry"),
          a = t("../../plots/plots"),
          o = t("../../lib"),
          s = o.strTranslate,
          l = t("../drawing"),
          c = t("../color"),
          u = t("../titles"),
          f = t("../../plots/cartesian"),
          h = t("../../plots/cartesian/axis_ids"),
          p = t("../dragelement"),
          d = t("../../lib/setcursor"),
          m = t("./constants");

      function g(t, e, r, n) {
        var i = o.ensureSingle(t, "rect", m.bgClassName, function (t) {
          t.attr({
            x: 0,
            y: 0,
            "shape-rendering": "crispEdges"
          });
        }),
            a = n.borderwidth % 2 == 0 ? n.borderwidth : n.borderwidth - 1,
            c = -n._offsetShift,
            u = l.crispRound(e, n.borderwidth);
        i.attr({
          width: n._width + a,
          height: n._height + a,
          transform: s(c, c),
          fill: n.bgcolor,
          stroke: n.bordercolor,
          "stroke-width": u
        });
      }

      function v(t, e, r, n) {
        var i = e._fullLayout;
        o.ensureSingleById(i._topdefs, "clipPath", n._clipId, function (t) {
          t.append("rect").attr({
            x: 0,
            y: 0
          });
        }).select("rect").attr({
          width: n._width,
          height: n._height
        });
      }

      function y(t, e, r, i) {
        var s,
            c = e.calcdata,
            u = t.selectAll("g." + m.rangePlotClassName).data(r._subplotsWith, o.identity);
        u.enter().append("g").attr("class", function (t) {
          return m.rangePlotClassName + " " + t;
        }).call(l.setClipUrl, i._clipId, e), u.order(), u.exit().remove(), u.each(function (t, o) {
          var l = n.select(this),
              u = 0 === o,
              p = h.getFromId(e, t, "y"),
              d = p._name,
              m = i[d],
              g = {
            data: [],
            layout: {
              xaxis: {
                type: r.type,
                domain: [0, 1],
                range: i.range.slice(),
                calendar: r.calendar
              },
              width: i._width,
              height: i._height,
              margin: {
                t: 0,
                b: 0,
                l: 0,
                r: 0
              }
            },
            _context: e._context
          };
          r.rangebreaks && (g.layout.xaxis.rangebreaks = r.rangebreaks), g.layout[d] = {
            type: p.type,
            domain: [0, 1],
            range: "match" !== m.rangemode ? m.range.slice() : p.range.slice(),
            calendar: p.calendar
          }, p.rangebreaks && (g.layout[d].rangebreaks = p.rangebreaks), a.supplyDefaults(g);
          var v = g._fullLayout.xaxis,
              y = g._fullLayout[d];
          v.clearCalc(), v.setScale(), y.clearCalc(), y.setScale();
          var x = {
            id: t,
            plotgroup: l,
            xaxis: v,
            yaxis: y,
            isRangePlot: !0
          };
          u ? s = x : (x.mainplot = "xy", x.mainplotinfo = s), f.rangePlot(e, x, function (t, e) {
            for (var r = [], n = 0; n < t.length; n++) {
              var i = t[n],
                  a = i[0].trace;
              a.xaxis + a.yaxis === e && r.push(i);
            }

            return r;
          }(c, t));
        });
      }

      function x(t, e, r, n, i) {
        (o.ensureSingle(t, "rect", m.maskMinClassName, function (t) {
          t.attr({
            x: 0,
            y: 0,
            "shape-rendering": "crispEdges"
          });
        }).attr("height", n._height).call(c.fill, m.maskColor), o.ensureSingle(t, "rect", m.maskMaxClassName, function (t) {
          t.attr({
            y: 0,
            "shape-rendering": "crispEdges"
          });
        }).attr("height", n._height).call(c.fill, m.maskColor), "match" !== i.rangemode) && (o.ensureSingle(t, "rect", m.maskMinOppAxisClassName, function (t) {
          t.attr({
            y: 0,
            "shape-rendering": "crispEdges"
          });
        }).attr("width", n._width).call(c.fill, m.maskOppAxisColor), o.ensureSingle(t, "rect", m.maskMaxOppAxisClassName, function (t) {
          t.attr({
            y: 0,
            "shape-rendering": "crispEdges"
          });
        }).attr("width", n._width).style("border-top", m.maskOppBorder).call(c.fill, m.maskOppAxisColor));
      }

      function b(t, e, r, n) {
        e._context.staticPlot || o.ensureSingle(t, "rect", m.slideBoxClassName, function (t) {
          t.attr({
            y: 0,
            cursor: m.slideBoxCursor,
            "shape-rendering": "crispEdges"
          });
        }).attr({
          height: n._height,
          fill: m.slideBoxFill
        });
      }

      function _(t, e, r, n) {
        var i = o.ensureSingle(t, "g", m.grabberMinClassName),
            a = o.ensureSingle(t, "g", m.grabberMaxClassName),
            s = {
          x: 0,
          width: m.handleWidth,
          rx: m.handleRadius,
          fill: c.background,
          stroke: c.defaultLine,
          "stroke-width": m.handleStrokeWidth,
          "shape-rendering": "crispEdges"
        },
            l = {
          y: Math.round(n._height / 4),
          height: Math.round(n._height / 2)
        };
        o.ensureSingle(i, "rect", m.handleMinClassName, function (t) {
          t.attr(s);
        }).attr(l), o.ensureSingle(a, "rect", m.handleMaxClassName, function (t) {
          t.attr(s);
        }).attr(l);
        var u = {
          width: m.grabAreaWidth,
          x: 0,
          y: 0,
          fill: m.grabAreaFill,
          cursor: e._context.staticPlot ? void 0 : m.grabAreaCursor
        };
        o.ensureSingle(i, "rect", m.grabAreaMinClassName, function (t) {
          t.attr(u);
        }).attr("height", n._height), o.ensureSingle(a, "rect", m.grabAreaMaxClassName, function (t) {
          t.attr(u);
        }).attr("height", n._height);
      }

      e.exports = function (t) {
        for (var e = t._fullLayout, r = e._rangeSliderData, a = 0; a < r.length; a++) {
          var l = r[a][m.name];
          l._clipId = l._id + "-" + e._uid;
        }

        var c = e._infolayer.selectAll("g." + m.containerClassName).data(r, function (t) {
          return t._name;
        });

        c.exit().each(function (t) {
          var r = t[m.name];

          e._topdefs.select("#" + r._clipId).remove();
        }).remove(), 0 !== r.length && (c.enter().append("g").classed(m.containerClassName, !0).attr("pointer-events", "all"), c.each(function (r) {
          var a = n.select(this),
              l = r[m.name],
              c = e[h.id2name(r.anchor)],
              f = l[h.id2name(r.anchor)];

          if (l.range) {
            var w,
                T = o.simpleMap(l.range, r.r2l),
                k = o.simpleMap(r.range, r.r2l);
            w = k[0] < k[1] ? [Math.min(T[0], k[0]), Math.max(T[1], k[1])] : [Math.max(T[0], k[0]), Math.min(T[1], k[1])], l.range = l._input.range = o.simpleMap(w, r.l2r);
          }

          r.cleanRange("rangeslider.range");
          var M = e._size,
              A = r.domain;
          l._width = M.w * (A[1] - A[0]);
          var S = Math.round(M.l + M.w * A[0]),
              E = Math.round(M.t + M.h * (1 - r._counterDomainMin) + ("bottom" === r.side ? r._depth : 0) + l._offsetShift + m.extraPad);
          a.attr("transform", s(S, E)), l._rl = o.simpleMap(l.range, r.r2l);
          var L = l._rl[0],
              C = l._rl[1],
              P = C - L;

          if (l.p2d = function (t) {
            return t / l._width * P + L;
          }, l.d2p = function (t) {
            return (t - L) / P * l._width;
          }, r.rangebreaks) {
            var I = r.locateBreaks(L, C);

            if (I.length) {
              var O,
                  z,
                  D = 0;

              for (O = 0; O < I.length; O++) {
                D += (z = I[O]).max - z.min;
              }

              var R = l._width / (C - L - D),
                  F = [-R * L];

              for (O = 0; O < I.length; O++) {
                z = I[O], F.push(F[F.length - 1] - R * (z.max - z.min));
              }

              for (l.d2p = function (t) {
                for (var e = F[0], r = 0; r < I.length; r++) {
                  var n = I[r];
                  if (t >= n.max) e = F[r + 1];else if (t < n.min) break;
                }

                return e + R * t;
              }, O = 0; O < I.length; O++) {
                (z = I[O]).pmin = l.d2p(z.min), z.pmax = l.d2p(z.max);
              }

              l.p2d = function (t) {
                for (var e = F[0], r = 0; r < I.length; r++) {
                  var n = I[r];
                  if (t >= n.pmax) e = F[r + 1];else if (t < n.pmin) break;
                }

                return (t - e) / R;
              };
            }
          }

          if ("match" !== f.rangemode) {
            var B = c.r2l(f.range[0]),
                N = c.r2l(f.range[1]) - B;

            l.d2pOppAxis = function (t) {
              return (t - B) / N * l._height;
            };
          }

          a.call(g, t, r, l).call(v, t, r, l).call(y, t, r, l).call(x, t, r, l, f).call(b, t, r, l).call(_, t, r, l), function (t, e, r, a) {
            if (e._context.staticPlot) return;
            var s = t.select("rect." + m.slideBoxClassName).node(),
                l = t.select("rect." + m.grabAreaMinClassName).node(),
                c = t.select("rect." + m.grabAreaMaxClassName).node();

            function u() {
              var u = n.event,
                  f = u.target,
                  h = u.clientX || u.touches[0].clientX,
                  m = h - t.node().getBoundingClientRect().left,
                  g = a.d2p(r._rl[0]),
                  v = a.d2p(r._rl[1]),
                  y = p.coverSlip();

              function x(t) {
                var u,
                    p,
                    x,
                    b = +(t.clientX || t.touches[0].clientX) - h;

                switch (f) {
                  case s:
                    x = "ew-resize", u = g + b, p = v + b;
                    break;

                  case l:
                    x = "col-resize", u = g + b, p = v;
                    break;

                  case c:
                    x = "col-resize", u = g, p = v + b;
                    break;

                  default:
                    x = "ew-resize", u = m, p = m + b;
                }

                if (p < u) {
                  var _ = p;
                  p = u, u = _;
                }

                a._pixelMin = u, a._pixelMax = p, d(n.select(y), x), function (t, e, r, n) {
                  function a(t) {
                    return r.l2r(o.constrain(t, n._rl[0], n._rl[1]));
                  }

                  var s = a(n.p2d(n._pixelMin)),
                      l = a(n.p2d(n._pixelMax));
                  window.requestAnimationFrame(function () {
                    i.call("_guiRelayout", e, r._name + ".range", [s, l]);
                  });
                }(0, e, r, a);
              }

              function b() {
                y.removeEventListener("mousemove", x), y.removeEventListener("mouseup", b), this.removeEventListener("touchmove", x), this.removeEventListener("touchend", b), o.removeElement(y);
              }

              this.addEventListener("touchmove", x), this.addEventListener("touchend", b), y.addEventListener("mousemove", x), y.addEventListener("mouseup", b);
            }

            t.on("mousedown", u), t.on("touchstart", u);
          }(a, t, r, l), function (t, e, r, n, i, a) {
            var l = m.handleWidth / 2;

            function c(t) {
              return o.constrain(t, 0, n._width);
            }

            function u(t) {
              return o.constrain(t, 0, n._height);
            }

            function f(t) {
              return o.constrain(t, -l, n._width + l);
            }

            var h = c(n.d2p(r._rl[0])),
                p = c(n.d2p(r._rl[1]));

            if (t.select("rect." + m.slideBoxClassName).attr("x", h).attr("width", p - h), t.select("rect." + m.maskMinClassName).attr("width", h), t.select("rect." + m.maskMaxClassName).attr("x", p).attr("width", n._width - p), "match" !== a.rangemode) {
              var d = n._height - u(n.d2pOppAxis(i._rl[1])),
                  g = n._height - u(n.d2pOppAxis(i._rl[0]));
              t.select("rect." + m.maskMinOppAxisClassName).attr("x", h).attr("height", d).attr("width", p - h), t.select("rect." + m.maskMaxOppAxisClassName).attr("x", h).attr("y", g).attr("height", n._height - g).attr("width", p - h), t.select("rect." + m.slideBoxClassName).attr("y", d).attr("height", g - d);
            }

            var v = Math.round(f(h - l)) - .5,
                y = Math.round(f(p - l)) + .5;
            t.select("g." + m.grabberMinClassName).attr("transform", s(v, .5)), t.select("g." + m.grabberMaxClassName).attr("transform", s(y, .5));
          }(a, 0, r, l, c, f), "bottom" === r.side && u.draw(t, r._id + "title", {
            propContainer: r,
            propName: r._name + ".title",
            placeholder: e._dfltTitle.x,
            attributes: {
              x: r._offset + r._length / 2,
              y: E + l._height + l._offsetShift + 10 + 1.5 * r.title.font.size,
              "text-anchor": "middle"
            }
          });
        }));
      };
    }, {
      "../../lib": 795,
      "../../lib/setcursor": 816,
      "../../plots/cartesian": 858,
      "../../plots/cartesian/axis_ids": 848,
      "../../plots/plots": 909,
      "../../registry": 923,
      "../color": 658,
      "../dragelement": 677,
      "../drawing": 680,
      "../titles": 756,
      "./constants": 732,
      "@plotly/d3": 57
    }],
    735: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/cartesian/axis_ids"),
          i = t("../../lib/svg_text_utils"),
          a = t("./constants"),
          o = t("../../constants/alignment").LINE_SPACING,
          s = a.name;

      function l(t) {
        var e = t && t[s];
        return e && e.visible;
      }

      r.isVisible = l, r.makeData = function (t) {
        var e = n.list({
          _fullLayout: t
        }, "x", !0),
            r = t.margin,
            i = [];
        if (!t._has("gl2d")) for (var a = 0; a < e.length; a++) {
          var o = e[a];

          if (l(o)) {
            i.push(o);
            var c = o[s];
            c._id = s + o._id, c._height = (t.height - r.b - r.t) * c.thickness, c._offsetShift = Math.floor(c.borderwidth / 2);
          }
        }
        t._rangeSliderData = i;
      }, r.autoMarginOpts = function (t, e) {
        var r = t._fullLayout,
            n = e[s],
            l = e._id.charAt(0),
            c = 0,
            u = 0;

        "bottom" === e.side && (c = e._depth, e.title.text !== r._dfltTitle[l] && (u = 1.5 * e.title.font.size + 10 + n._offsetShift, u += (e.title.text.match(i.BR_TAG_ALL) || []).length * e.title.font.size * o));
        return {
          x: 0,
          y: e._counterDomainMin,
          l: 0,
          r: 0,
          t: 0,
          b: n._height + c + Math.max(r.margin.b, u),
          pad: a.extraPad + 2 * n._offsetShift
        };
      };
    }, {
      "../../constants/alignment": 763,
      "../../lib/svg_text_utils": 820,
      "../../plots/cartesian/axis_ids": 848,
      "./constants": 732
    }],
    736: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./attributes"),
          a = t("./oppaxis_attributes"),
          o = t("./helpers");
      e.exports = {
        moduleType: "component",
        name: "rangeslider",
        schema: {
          subplots: {
            xaxis: {
              rangeslider: n.extendFlat({}, i, {
                yaxis: a
              })
            }
          }
        },
        layoutAttributes: t("./attributes"),
        handleDefaults: t("./defaults"),
        calcAutorange: t("./calc_autorange"),
        draw: t("./draw"),
        isVisible: o.isVisible,
        makeData: o.makeData,
        autoMarginOpts: o.autoMarginOpts
      };
    }, {
      "../../lib": 795,
      "./attributes": 730,
      "./calc_autorange": 731,
      "./defaults": 733,
      "./draw": 734,
      "./helpers": 735,
      "./oppaxis_attributes": 737
    }],
    737: [function (t, e, r) {
      "use strict";

      e.exports = {
        _isSubplotObj: !0,
        rangemode: {
          valType: "enumerated",
          values: ["auto", "fixed", "match"],
          dflt: "match",
          editType: "calc"
        },
        range: {
          valType: "info_array",
          items: [{
            valType: "any",
            editType: "plot"
          }, {
            valType: "any",
            editType: "plot"
          }],
          editType: "plot"
        },
        editType: "calc"
      };
    }, {}],
    738: [function (t, e, r) {
      "use strict";

      var n = t("../annotations/attributes"),
          i = t("../../traces/scatter/attributes").line,
          a = t("../drawing/attributes").dash,
          o = t("../../lib/extend").extendFlat,
          s = t("../../plot_api/plot_template").templatedArray;
      t("../../constants/axis_placeable_objects");
      e.exports = s("shape", {
        visible: {
          valType: "boolean",
          dflt: !0,
          editType: "calc+arraydraw"
        },
        type: {
          valType: "enumerated",
          values: ["circle", "rect", "path", "line"],
          editType: "calc+arraydraw"
        },
        layer: {
          valType: "enumerated",
          values: ["below", "above"],
          dflt: "above",
          editType: "arraydraw"
        },
        xref: o({}, n.xref, {}),
        xsizemode: {
          valType: "enumerated",
          values: ["scaled", "pixel"],
          dflt: "scaled",
          editType: "calc+arraydraw"
        },
        xanchor: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        x0: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        x1: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        yref: o({}, n.yref, {}),
        ysizemode: {
          valType: "enumerated",
          values: ["scaled", "pixel"],
          dflt: "scaled",
          editType: "calc+arraydraw"
        },
        yanchor: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        y0: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        y1: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        path: {
          valType: "string",
          editType: "calc+arraydraw"
        },
        opacity: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 1,
          editType: "arraydraw"
        },
        line: {
          color: o({}, i.color, {
            editType: "arraydraw"
          }),
          width: o({}, i.width, {
            editType: "calc+arraydraw"
          }),
          dash: o({}, a, {
            editType: "arraydraw"
          }),
          editType: "calc+arraydraw"
        },
        fillcolor: {
          valType: "color",
          dflt: "rgba(0,0,0,0)",
          editType: "arraydraw"
        },
        fillrule: {
          valType: "enumerated",
          values: ["evenodd", "nonzero"],
          dflt: "evenodd",
          editType: "arraydraw"
        },
        editable: {
          valType: "boolean",
          dflt: !1,
          editType: "calc+arraydraw"
        },
        editType: "arraydraw"
      });
    }, {
      "../../constants/axis_placeable_objects": 764,
      "../../lib/extend": 785,
      "../../plot_api/plot_template": 834,
      "../../traces/scatter/attributes": 1199,
      "../annotations/attributes": 641,
      "../drawing/attributes": 679
    }],
    739: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../plots/cartesian/axes"),
          a = t("./constants"),
          o = t("./helpers");

      function s(t) {
        return c(t.line.width, t.xsizemode, t.x0, t.x1, t.path, !1);
      }

      function l(t) {
        return c(t.line.width, t.ysizemode, t.y0, t.y1, t.path, !0);
      }

      function c(t, e, r, i, s, l) {
        var c = t / 2,
            u = l;

        if ("pixel" === e) {
          var f = s ? o.extractPathCoords(s, l ? a.paramIsY : a.paramIsX) : [r, i],
              h = n.aggNums(Math.max, null, f),
              p = n.aggNums(Math.min, null, f),
              d = p < 0 ? Math.abs(p) + c : c,
              m = h > 0 ? h + c : c;
          return {
            ppad: c,
            ppadplus: u ? d : m,
            ppadminus: u ? m : d
          };
        }

        return {
          ppad: c
        };
      }

      function u(t, e, r, n, i) {
        var s = "category" === t.type || "multicategory" === t.type ? t.r2c : t.d2c;
        if (void 0 !== e) return [s(e), s(r)];

        if (n) {
          var l,
              c,
              u,
              f,
              h = 1 / 0,
              p = -1 / 0,
              d = n.match(a.segmentRE);

          for ("date" === t.type && (s = o.decodeDate(s)), l = 0; l < d.length; l++) {
            void 0 !== (c = i[d[l].charAt(0)].drawn) && (!(u = d[l].substr(1).match(a.paramRE)) || u.length < c || ((f = s(u[c])) < h && (h = f), f > p && (p = f)));
          }

          return p >= h ? [h, p] : void 0;
        }
      }

      e.exports = function (t) {
        var e = t._fullLayout,
            r = n.filterVisible(e.shapes);
        if (r.length && t._fullData.length) for (var o = 0; o < r.length; o++) {
          var c,
              f,
              h = r[o];
          h._extremes = {};
          var p = i.getRefType(h.xref),
              d = i.getRefType(h.yref);

          if ("paper" !== h.xref && "domain" !== p) {
            var m = "pixel" === h.xsizemode ? h.xanchor : h.x0,
                g = "pixel" === h.xsizemode ? h.xanchor : h.x1;
            (f = u(c = i.getFromId(t, h.xref), m, g, h.path, a.paramIsX)) && (h._extremes[c._id] = i.findExtremes(c, f, s(h)));
          }

          if ("paper" !== h.yref && "domain" !== d) {
            var v = "pixel" === h.ysizemode ? h.yanchor : h.y0,
                y = "pixel" === h.ysizemode ? h.yanchor : h.y1;
            (f = u(c = i.getFromId(t, h.yref), v, y, h.path, a.paramIsY)) && (h._extremes[c._id] = i.findExtremes(c, f, l(h)));
          }
        }
      };
    }, {
      "../../lib": 795,
      "../../plots/cartesian/axes": 845,
      "./constants": 740,
      "./helpers": 749
    }],
    740: [function (t, e, r) {
      "use strict";

      e.exports = {
        segmentRE: /[MLHVQCTSZ][^MLHVQCTSZ]*/g,
        paramRE: /[^\s,]+/g,
        paramIsX: {
          M: {
            0: !0,
            drawn: 0
          },
          L: {
            0: !0,
            drawn: 0
          },
          H: {
            0: !0,
            drawn: 0
          },
          V: {},
          Q: {
            0: !0,
            2: !0,
            drawn: 2
          },
          C: {
            0: !0,
            2: !0,
            4: !0,
            drawn: 4
          },
          T: {
            0: !0,
            drawn: 0
          },
          S: {
            0: !0,
            2: !0,
            drawn: 2
          },
          Z: {}
        },
        paramIsY: {
          M: {
            1: !0,
            drawn: 1
          },
          L: {
            1: !0,
            drawn: 1
          },
          H: {},
          V: {
            0: !0,
            drawn: 0
          },
          Q: {
            1: !0,
            3: !0,
            drawn: 3
          },
          C: {
            1: !0,
            3: !0,
            5: !0,
            drawn: 5
          },
          T: {
            1: !0,
            drawn: 1
          },
          S: {
            1: !0,
            3: !0,
            drawn: 5
          },
          Z: {}
        },
        numParams: {
          M: 2,
          L: 2,
          H: 1,
          V: 1,
          Q: 4,
          C: 6,
          T: 2,
          S: 4,
          Z: 0
        }
      };
    }, {}],
    741: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../plots/cartesian/axes"),
          a = t("../../plots/array_container_defaults"),
          o = t("./attributes"),
          s = t("./helpers");

      function l(t, e, r) {
        function a(r, i) {
          return n.coerce(t, e, o, r, i);
        }

        if (a("visible")) {
          var l = a("path"),
              c = a("type", l ? "path" : "rect");
          "path" !== e.type && delete e.path, a("editable"), a("layer"), a("opacity"), a("fillcolor"), a("fillrule"), a("line.width") && (a("line.color"), a("line.dash"));

          for (var u = a("xsizemode"), f = a("ysizemode"), h = ["x", "y"], p = 0; p < 2; p++) {
            var d,
                m,
                g,
                v = h[p],
                y = v + "anchor",
                x = "x" === v ? u : f,
                b = {
              _fullLayout: r
            },
                _ = i.coerceRef(t, e, b, v, void 0, "paper");

            if ("range" === i.getRefType(_) ? ((d = i.getFromId(b, _))._shapeIndices.push(e._index), g = s.rangeToShapePosition(d), m = s.shapePositionToRange(d)) : m = g = n.identity, "path" !== c) {
              var w = v + "0",
                  T = v + "1",
                  k = t[w],
                  M = t[T];
              t[w] = m(t[w], !0), t[T] = m(t[T], !0), "pixel" === x ? (a(w, 0), a(T, 10)) : (i.coercePosition(e, b, a, _, w, .25), i.coercePosition(e, b, a, _, T, .75)), e[w] = g(e[w]), e[T] = g(e[T]), t[w] = k, t[T] = M;
            }

            if ("pixel" === x) {
              var A = t[y];
              t[y] = m(t[y], !0), i.coercePosition(e, b, a, _, y, .25), e[y] = g(e[y]), t[y] = A;
            }
          }

          "path" === c ? a("path") : n.noneOrAll(t, e, ["x0", "x1", "y0", "y1"]);
        }
      }

      e.exports = function (t, e) {
        a(t, e, {
          name: "shapes",
          handleItemDefaults: l
        });
      };
    }, {
      "../../lib": 795,
      "../../plots/array_container_defaults": 840,
      "../../plots/cartesian/axes": 845,
      "./attributes": 738,
      "./helpers": 749
    }],
    742: [function (t, e, r) {
      "use strict";

      var n = t("../../registry"),
          i = t("../../lib"),
          a = t("../../plots/cartesian/axes"),
          o = t("./draw_newshape/helpers").readPaths,
          s = t("./draw_newshape/display_outlines"),
          l = t("../../plots/cartesian/handle_outline").clearOutlineControllers,
          c = t("../color"),
          u = t("../drawing"),
          f = t("../../plot_api/plot_template").arrayEditor,
          h = t("../dragelement"),
          p = t("../../lib/setcursor"),
          d = t("./constants"),
          m = t("./helpers");

      function g(t) {
        var e = t._fullLayout;

        for (var r in e._shapeUpperLayer.selectAll("path").remove(), e._shapeLowerLayer.selectAll("path").remove(), e._plots) {
          var n = e._plots[r].shapelayer;
          n && n.selectAll("path").remove();
        }

        for (var i = 0; i < e.shapes.length; i++) {
          e.shapes[i].visible && x(t, i);
        }
      }

      function v(t) {
        return !!t._fullLayout._drawing;
      }

      function y(t) {
        return !t._context.edits.shapePosition;
      }

      function x(t, e) {
        t._fullLayout._paperdiv.selectAll('.shapelayer [data-index="' + e + '"]').remove();

        var r = m.makeOptionsAndPlotinfo(t, e),
            l = r.options,
            x = r.plotinfo;
        if (l._input && !1 !== l.visible) if ("below" !== l.layer) k(t._fullLayout._shapeUpperLayer);else if ("paper" === l.xref || "paper" === l.yref) k(t._fullLayout._shapeLowerLayer);else {
          if (x._hadPlotinfo) k((x.mainplotinfo || x).shapelayer);else k(t._fullLayout._shapeLowerLayer);
        }

        function k(r) {
          var k = _(t, l),
              M = {
            "data-index": e,
            "fill-rule": l.fillrule,
            d: k
          },
              A = l.opacity,
              S = l.fillcolor,
              E = l.line.width ? l.line.color : "rgba(0,0,0,0)",
              L = l.line.width,
              C = l.line.dash;

          L || !0 !== l.editable || (L = 5, C = "solid");
          var P = "Z" !== k[k.length - 1],
              I = y(t) && l.editable && t._fullLayout._activeShapeIndex === e;
          I && (S = P ? "rgba(0,0,0,0)" : t._fullLayout.activeshape.fillcolor, A = t._fullLayout.activeshape.opacity);
          var O,
              z = r.append("path").attr(M).style("opacity", A).call(c.stroke, E).call(c.fill, S).call(u.dashLine, C, L);

          if (b(z, t, l), (I || t._context.edits.shapePosition) && (O = f(t.layout, "shapes", l)), I) {
            z.style({
              cursor: "move"
            });
            var D = {
              element: z.node(),
              plotinfo: x,
              gd: t,
              editHelpers: O,
              isActiveShape: !0
            },
                R = o(k, t);
            s(R, z, D);
          } else t._context.edits.shapePosition ? function (t, e, r, o, s, l) {
            var c,
                f,
                g,
                y,
                x,
                T,
                k,
                M,
                A,
                S,
                E,
                L,
                C,
                P,
                I,
                O,
                z = "pixel" === r.xsizemode,
                D = "pixel" === r.ysizemode,
                R = "line" === r.type,
                F = "path" === r.type,
                B = l.modifyItem,
                N = a.getFromId(t, r.xref),
                j = a.getRefType(r.xref),
                U = a.getFromId(t, r.yref),
                V = a.getRefType(r.yref),
                q = m.getDataToPixel(t, N, !1, j),
                H = m.getDataToPixel(t, U, !0, V),
                G = m.getPixelToData(t, N, !1, j),
                Y = m.getPixelToData(t, U, !0, V),
                W = R ? function () {
              var t = Math.max(r.line.width, 10),
                  n = s.append("g").attr("data-index", o);
              n.append("path").attr("d", e.attr("d")).style({
                cursor: "move",
                "stroke-width": t,
                "stroke-opacity": "0"
              });
              var i = {
                "fill-opacity": "0"
              },
                  a = Math.max(t / 2, 10);
              return n.append("circle").attr({
                "data-line-point": "start-point",
                cx: z ? q(r.xanchor) + r.x0 : q(r.x0),
                cy: D ? H(r.yanchor) - r.y0 : H(r.y0),
                r: a
              }).style(i).classed("cursor-grab", !0), n.append("circle").attr({
                "data-line-point": "end-point",
                cx: z ? q(r.xanchor) + r.x1 : q(r.x1),
                cy: D ? H(r.yanchor) - r.y1 : H(r.y1),
                r: a
              }).style(i).classed("cursor-grab", !0), n;
            }() : e,
                X = {
              element: W.node(),
              gd: t,
              prepFn: function prepFn(n) {
                if (v(t)) return;
                z && (x = q(r.xanchor));
                D && (T = H(r.yanchor));
                "path" === r.type ? I = r.path : (c = z ? r.x0 : q(r.x0), f = D ? r.y0 : H(r.y0), g = z ? r.x1 : q(r.x1), y = D ? r.y1 : H(r.y1));
                c < g ? (A = c, C = "x0", S = g, P = "x1") : (A = g, C = "x1", S = c, P = "x0");
                !D && f < y || D && f > y ? (k = f, E = "y0", M = y, L = "y1") : (k = y, E = "y1", M = f, L = "y0");
                Z(n), Q(s, r), function (t, e, r) {
                  var n = e.xref,
                      i = e.yref,
                      o = a.getFromId(r, n),
                      s = a.getFromId(r, i),
                      l = "";
                  "paper" === n || o.autorange || (l += n);
                  "paper" === i || s.autorange || (l += i);
                  u.setClipUrl(t, l ? "clip" + r._fullLayout._uid + l : null, r);
                }(e, r, t), X.moveFn = "move" === O ? J : K, X.altKey = n.altKey;
              },
              doneFn: function doneFn() {
                if (v(t)) return;
                p(e), $(s), b(e, t, r), n.call("_guiRelayout", t, l.getUpdateObj());
              },
              clickFn: function clickFn() {
                if (v(t)) return;
                $(s);
              }
            };

            function Z(r) {
              if (v(t)) O = null;else if (R) O = "path" === r.target.tagName ? "move" : "start-point" === r.target.attributes["data-line-point"].value ? "resize-over-start-point" : "resize-over-end-point";else {
                var n = X.element.getBoundingClientRect(),
                    i = n.right - n.left,
                    a = n.bottom - n.top,
                    o = r.clientX - n.left,
                    s = r.clientY - n.top,
                    l = !F && i > 10 && a > 10 && !r.shiftKey ? h.getCursor(o / i, 1 - s / a) : "move";
                p(e, l), O = l.split("-")[0];
              }
            }

            function J(n, i) {
              if ("path" === r.type) {
                var a = function a(t) {
                  return t;
                },
                    o = a,
                    l = a;

                z ? B("xanchor", r.xanchor = G(x + n)) : (o = function o(t) {
                  return G(q(t) + n);
                }, N && "date" === N.type && (o = m.encodeDate(o))), D ? B("yanchor", r.yanchor = Y(T + i)) : (l = function l(t) {
                  return Y(H(t) + i);
                }, U && "date" === U.type && (l = m.encodeDate(l))), B("path", r.path = w(I, o, l));
              } else z ? B("xanchor", r.xanchor = G(x + n)) : (B("x0", r.x0 = G(c + n)), B("x1", r.x1 = G(g + n))), D ? B("yanchor", r.yanchor = Y(T + i)) : (B("y0", r.y0 = Y(f + i)), B("y1", r.y1 = Y(y + i)));

              e.attr("d", _(t, r)), Q(s, r);
            }

            function K(n, i) {
              if (F) {
                var a = function a(t) {
                  return t;
                },
                    o = a,
                    l = a;

                z ? B("xanchor", r.xanchor = G(x + n)) : (o = function o(t) {
                  return G(q(t) + n);
                }, N && "date" === N.type && (o = m.encodeDate(o))), D ? B("yanchor", r.yanchor = Y(T + i)) : (l = function l(t) {
                  return Y(H(t) + i);
                }, U && "date" === U.type && (l = m.encodeDate(l))), B("path", r.path = w(I, o, l));
              } else if (R) {
                if ("resize-over-start-point" === O) {
                  var u = c + n,
                      h = D ? f - i : f + i;
                  B("x0", r.x0 = z ? u : G(u)), B("y0", r.y0 = D ? h : Y(h));
                } else if ("resize-over-end-point" === O) {
                  var p = g + n,
                      d = D ? y - i : y + i;
                  B("x1", r.x1 = z ? p : G(p)), B("y1", r.y1 = D ? d : Y(d));
                }
              } else {
                var v = function v(t) {
                  return -1 !== O.indexOf(t);
                },
                    b = v("n"),
                    j = v("s"),
                    V = v("w"),
                    W = v("e"),
                    X = b ? k + i : k,
                    Z = j ? M + i : M,
                    J = V ? A + n : A,
                    K = W ? S + n : S;

                D && (b && (X = k - i), j && (Z = M - i)), (!D && Z - X > 10 || D && X - Z > 10) && (B(E, r[E] = D ? X : Y(X)), B(L, r[L] = D ? Z : Y(Z))), K - J > 10 && (B(C, r[C] = z ? J : G(J)), B(P, r[P] = z ? K : G(K)));
              }

              e.attr("d", _(t, r)), Q(s, r);
            }

            function Q(t, e) {
              (z || D) && function () {
                var r = "path" !== e.type,
                    n = t.selectAll(".visual-cue").data([0]);
                n.enter().append("path").attr({
                  fill: "#fff",
                  "fill-rule": "evenodd",
                  stroke: "#000",
                  "stroke-width": 1
                }).classed("visual-cue", !0);
                var a = q(z ? e.xanchor : i.midRange(r ? [e.x0, e.x1] : m.extractPathCoords(e.path, d.paramIsX))),
                    o = H(D ? e.yanchor : i.midRange(r ? [e.y0, e.y1] : m.extractPathCoords(e.path, d.paramIsY)));

                if (a = m.roundPositionForSharpStrokeRendering(a, 1), o = m.roundPositionForSharpStrokeRendering(o, 1), z && D) {
                  var s = "M" + (a - 1 - 1) + "," + (o - 1 - 1) + "h-8v2h8 v8h2v-8 h8v-2h-8 v-8h-2 Z";
                  n.attr("d", s);
                } else if (z) {
                  var l = "M" + (a - 1 - 1) + "," + (o - 9 - 1) + "v18 h2 v-18 Z";
                  n.attr("d", l);
                } else {
                  var c = "M" + (a - 9 - 1) + "," + (o - 1 - 1) + "h18 v2 h-18 Z";
                  n.attr("d", c);
                }
              }();
            }

            function $(t) {
              t.selectAll(".visual-cue").remove();
            }

            h.init(X), W.node().onmousemove = Z;
          }(t, z, l, e, r, O) : !0 === l.editable && z.style("pointer-events", P || c.opacity(S) * A <= .5 ? "stroke" : "all");

          z.node().addEventListener("click", function () {
            return function (t, e) {
              if (!y(t)) return;
              var r = +e.node().getAttribute("data-index");

              if (r >= 0) {
                if (r === t._fullLayout._activeShapeIndex) return void T(t);
                t._fullLayout._activeShapeIndex = r, t._fullLayout._deactivateShape = T, g(t);
              }
            }(t, z);
          });
        }
      }

      function b(t, e, r) {
        var n = (r.xref + r.yref).replace(/paper/g, "").replace(/[xyz][1-9]* *domain/g, "");
        u.setClipUrl(t, n ? "clip" + e._fullLayout._uid + n : null, e);
      }

      function _(t, e) {
        var r,
            n,
            o,
            s,
            l,
            c,
            u,
            f,
            h = e.type,
            p = a.getRefType(e.xref),
            g = a.getRefType(e.yref),
            v = a.getFromId(t, e.xref),
            y = a.getFromId(t, e.yref),
            x = t._fullLayout._size;
        if (v ? "domain" === p ? n = function n(t) {
          return v._offset + v._length * t;
        } : (r = m.shapePositionToRange(v), n = function n(t) {
          return v._offset + v.r2p(r(t, !0));
        }) : n = function n(t) {
          return x.l + x.w * t;
        }, y ? "domain" === g ? s = function s(t) {
          return y._offset + y._length * (1 - t);
        } : (o = m.shapePositionToRange(y), s = function s(t) {
          return y._offset + y.r2p(o(t, !0));
        }) : s = function s(t) {
          return x.t + x.h * (1 - t);
        }, "path" === h) return v && "date" === v.type && (n = m.decodeDate(n)), y && "date" === y.type && (s = m.decodeDate(s)), function (t, e, r) {
          var n = t.path,
              a = t.xsizemode,
              o = t.ysizemode,
              s = t.xanchor,
              l = t.yanchor;
          return n.replace(d.segmentRE, function (t) {
            var n = 0,
                c = t.charAt(0),
                u = d.paramIsX[c],
                f = d.paramIsY[c],
                h = d.numParams[c],
                p = t.substr(1).replace(d.paramRE, function (t) {
              return u[n] ? t = "pixel" === a ? e(s) + Number(t) : e(t) : f[n] && (t = "pixel" === o ? r(l) - Number(t) : r(t)), ++n > h && (t = "X"), t;
            });
            return n > h && (p = p.replace(/[\s,]*X.*/, ""), i.log("Ignoring extra params in segment " + t)), c + p;
          });
        }(e, n, s);

        if ("pixel" === e.xsizemode) {
          var b = n(e.xanchor);
          l = b + e.x0, c = b + e.x1;
        } else l = n(e.x0), c = n(e.x1);

        if ("pixel" === e.ysizemode) {
          var _ = s(e.yanchor);

          u = _ - e.y0, f = _ - e.y1;
        } else u = s(e.y0), f = s(e.y1);

        if ("line" === h) return "M" + l + "," + u + "L" + c + "," + f;
        if ("rect" === h) return "M" + l + "," + u + "H" + c + "V" + f + "H" + l + "Z";
        var w = (l + c) / 2,
            T = (u + f) / 2,
            k = Math.abs(w - l),
            M = Math.abs(T - u),
            A = "A" + k + "," + M,
            S = w + k + "," + T;
        return "M" + S + A + " 0 1,1 " + (w + "," + (T - M)) + A + " 0 0,1 " + S + "Z";
      }

      function w(t, e, r) {
        return t.replace(d.segmentRE, function (t) {
          var n = 0,
              i = t.charAt(0),
              a = d.paramIsX[i],
              o = d.paramIsY[i],
              s = d.numParams[i];
          return i + t.substr(1).replace(d.paramRE, function (t) {
            return n >= s || (a[n] ? t = e(t) : o[n] && (t = r(t)), n++), t;
          });
        });
      }

      function T(t) {
        y(t) && t._fullLayout._activeShapeIndex >= 0 && (l(t), delete t._fullLayout._activeShapeIndex, g(t));
      }

      e.exports = {
        draw: g,
        drawOne: x,
        eraseActiveShape: function eraseActiveShape(t) {
          if (!y(t)) return;
          l(t);
          var e = t._fullLayout._activeShapeIndex,
              r = (t.layout || {}).shapes || [];

          if (e < r.length) {
            for (var i = [], a = 0; a < r.length; a++) {
              a !== e && i.push(r[a]);
            }

            delete t._fullLayout._activeShapeIndex, n.call("_guiRelayout", t, {
              shapes: i
            });
          }
        }
      };
    }, {
      "../../lib": 795,
      "../../lib/setcursor": 816,
      "../../plot_api/plot_template": 834,
      "../../plots/cartesian/axes": 845,
      "../../plots/cartesian/handle_outline": 855,
      "../../registry": 923,
      "../color": 658,
      "../dragelement": 677,
      "../drawing": 680,
      "./constants": 740,
      "./draw_newshape/display_outlines": 746,
      "./draw_newshape/helpers": 747,
      "./helpers": 749
    }],
    743: [function (t, e, r) {
      "use strict";

      var n = t("../../drawing/attributes").dash,
          i = t("../../../lib/extend").extendFlat;
      e.exports = {
        newshape: {
          line: {
            color: {
              valType: "color",
              editType: "none"
            },
            width: {
              valType: "number",
              min: 0,
              dflt: 4,
              editType: "none"
            },
            dash: i({}, n, {
              dflt: "solid",
              editType: "none"
            }),
            editType: "none"
          },
          fillcolor: {
            valType: "color",
            dflt: "rgba(0,0,0,0)",
            editType: "none"
          },
          fillrule: {
            valType: "enumerated",
            values: ["evenodd", "nonzero"],
            dflt: "evenodd",
            editType: "none"
          },
          opacity: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: 1,
            editType: "none"
          },
          layer: {
            valType: "enumerated",
            values: ["below", "above"],
            dflt: "above",
            editType: "none"
          },
          drawdirection: {
            valType: "enumerated",
            values: ["ortho", "horizontal", "vertical", "diagonal"],
            dflt: "diagonal",
            editType: "none"
          },
          editType: "none"
        },
        activeshape: {
          fillcolor: {
            valType: "color",
            dflt: "rgb(255,0,255)",
            editType: "none"
          },
          opacity: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: .5,
            editType: "none"
          },
          editType: "none"
        }
      };
    }, {
      "../../../lib/extend": 785,
      "../../drawing/attributes": 679
    }],
    744: [function (t, e, r) {
      "use strict";

      e.exports = {
        CIRCLE_SIDES: 32,
        i000: 0,
        i090: 8,
        i180: 16,
        i270: 24,
        cos45: Math.cos(Math.PI / 4),
        sin45: Math.sin(Math.PI / 4),
        SQRT2: Math.sqrt(2)
      };
    }, {}],
    745: [function (t, e, r) {
      "use strict";

      var n = t("../../color");

      e.exports = function (t, e, r) {
        if (r("newshape.drawdirection"), r("newshape.layer"), r("newshape.fillcolor"), r("newshape.fillrule"), r("newshape.opacity"), r("newshape.line.width")) {
          var i = (t || {}).plot_bgcolor || "#FFF";
          r("newshape.line.color", n.contrast(i)), r("newshape.line.dash");
        }

        r("activeshape.fillcolor"), r("activeshape.opacity");
      };
    }, {
      "../../color": 658
    }],
    746: [function (t, e, r) {
      "use strict";

      var n = t("../../dragelement"),
          i = t("../../dragelement/helpers").drawMode,
          a = t("../../../registry"),
          o = t("./constants"),
          s = o.i000,
          l = o.i090,
          c = o.i180,
          u = o.i270,
          f = t("../../../plots/cartesian/handle_outline").clearOutlineControllers,
          h = t("./helpers"),
          p = h.pointsShapeRectangle,
          d = h.pointsShapeEllipse,
          m = h.writePaths,
          g = t("./newshapes");

      e.exports = function t(e, r, o, h) {
        h || (h = 0);
        var v = o.gd;

        function y() {
          t(e, r, o, h++), d(e[0]) && x({
            redrawing: !0
          });
        }

        function x(t) {
          o.isActiveShape = !1;
          var e = g(r, o);
          Object.keys(e).length && a.call((t || {}).redrawing ? "relayout" : "_guiRelayout", v, e);
        }

        var b,
            _,
            w,
            T,
            k,
            M = o.isActiveShape,
            A = v._fullLayout._zoomlayer,
            S = o.dragmode;

        (i(S) ? v._fullLayout._drawing = !0 : v._fullLayout._activeShapeIndex >= 0 && f(v), r.attr("d", m(e)), M && !h) && (k = function (t, e) {
          for (var r = 0; r < e.length; r++) {
            var n = e[r];
            t[r] = [];

            for (var i = 0; i < n.length; i++) {
              t[r][i] = [];

              for (var a = 0; a < n[i].length; a++) {
                t[r][i][a] = n[i][a];
              }
            }
          }

          return t;
        }([], e), function (t) {
          b = [];

          for (var r = 0; r < e.length; r++) {
            var i = e[r],
                a = !p(i) && d(i);
            b[r] = [];

            for (var o = 0; o < i.length; o++) {
              if ("Z" !== i[o][0] && (!a || o === s || o === l || o === c || o === u)) {
                var f = i[o][1],
                    h = i[o][2],
                    m = t.append("circle").classed("cursor-grab", !0).attr("data-i", r).attr("data-j", o).attr("cx", f).attr("cy", h).attr("r", 4).style({
                  "mix-blend-mode": "luminosity",
                  fill: "black",
                  stroke: "white",
                  "stroke-width": 1
                });
                b[r][o] = {
                  element: m.node(),
                  gd: v,
                  prepFn: E,
                  doneFn: C,
                  clickFn: P
                }, n.init(b[r][o]);
              }
            }
          }
        }(A.append("g").attr("class", "outline-controllers")), function () {
          if (_ = [], !e.length) return;
          _[0] = {
            element: r[0][0],
            gd: v,
            prepFn: O,
            doneFn: z
          }, n.init(_[0]);
        }());

        function E(t) {
          w = +t.srcElement.getAttribute("data-i"), T = +t.srcElement.getAttribute("data-j"), b[w][T].moveFn = L;
        }

        function L(t, r) {
          if (e.length) {
            var n = k[w][T][1],
                i = k[w][T][2],
                a = e[w],
                o = a.length;

            if (p(a)) {
              for (var s = 0; s < o; s++) {
                if (s !== T) {
                  var l = a[s];
                  l[1] === a[T][1] && (l[1] = n + t), l[2] === a[T][2] && (l[2] = i + r);
                }
              }

              if (a[T][1] = n + t, a[T][2] = i + r, !p(a)) for (var c = 0; c < o; c++) {
                for (var u = 0; u < a[c].length; u++) {
                  a[c][u] = k[w][c][u];
                }
              }
            } else a[T][1] = n + t, a[T][2] = i + r;

            y();
          }
        }

        function C() {
          x();
        }

        function P(t, r) {
          if (2 === t) {
            w = +r.srcElement.getAttribute("data-i"), T = +r.srcElement.getAttribute("data-j");
            var n = e[w];
            p(n) || d(n) || function () {
              if (e.length && e[w] && e[w].length) {
                for (var t = [], r = 0; r < e[w].length; r++) {
                  r !== T && t.push(e[w][r]);
                }

                t.length > 1 && (2 !== t.length || "Z" !== t[1][0]) && (0 === T && (t[0][0] = "M"), e[w] = t, y(), x());
              }
            }();
          }
        }

        function I(t, r) {
          !function (t, r) {
            if (e.length) for (var n = 0; n < e.length; n++) {
              for (var i = 0; i < e[n].length; i++) {
                for (var a = 0; a + 2 < e[n][i].length; a += 2) {
                  e[n][i][a + 1] = k[n][i][a + 1] + t, e[n][i][a + 2] = k[n][i][a + 2] + r;
                }
              }
            }
          }(t, r), y();
        }

        function O(t) {
          (w = +t.srcElement.getAttribute("data-i")) || (w = 0), _[w].moveFn = I;
        }

        function z() {
          x();
        }
      };
    }, {
      "../../../plots/cartesian/handle_outline": 855,
      "../../../registry": 923,
      "../../dragelement": 677,
      "../../dragelement/helpers": 676,
      "./constants": 744,
      "./helpers": 747,
      "./newshapes": 748
    }],
    747: [function (t, e, r) {
      "use strict";

      var n = t("parse-svg-path"),
          i = t("./constants"),
          a = i.CIRCLE_SIDES,
          o = i.SQRT2,
          s = t("../../../plots/cartesian/helpers"),
          l = s.p2r,
          c = s.r2p,
          u = [0, 3, 4, 5, 6, 1, 2],
          f = [0, 3, 4, 1, 2];

      function h(t, e) {
        return Math.abs(t - e) <= 1e-6;
      }

      function p(t, e) {
        var r = e[1] - t[1],
            n = e[2] - t[2];
        return Math.sqrt(r * r + n * n);
      }

      r.writePaths = function (t) {
        var e = t.length;
        if (!e) return "M0,0Z";

        for (var r = "", n = 0; n < e; n++) {
          for (var i = t[n].length, a = 0; a < i; a++) {
            var o = t[n][a][0];
            if ("Z" === o) r += "Z";else for (var s = t[n][a].length, l = 0; l < s; l++) {
              var c = l;
              "Q" === o || "S" === o ? c = f[l] : "C" === o && (c = u[l]), r += t[n][a][c], l > 0 && l < s - 1 && (r += ",");
            }
          }
        }

        return r;
      }, r.readPaths = function (t, e, r, i) {
        var o,
            s,
            u,
            f = n(t),
            h = [],
            p = -1,
            d = 0,
            m = 0,
            g = function g() {
          s = d, u = m;
        };

        g();

        for (var v = 0; v < f.length; v++) {
          var y,
              x,
              b,
              _,
              w = [],
              T = f[v][0],
              k = T;

          switch (T) {
            case "M":
              p++, h[p] = [], d = +f[v][1], m = +f[v][2], w.push([k, d, m]), g();
              break;

            case "Q":
            case "S":
              y = +f[v][1], b = +f[v][2], d = +f[v][3], m = +f[v][4], w.push([k, d, m, y, b]);
              break;

            case "C":
              y = +f[v][1], b = +f[v][2], x = +f[v][3], _ = +f[v][4], d = +f[v][5], m = +f[v][6], w.push([k, d, m, y, b, x, _]);
              break;

            case "T":
            case "L":
              d = +f[v][1], m = +f[v][2], w.push([k, d, m]);
              break;

            case "H":
              k = "L", d = +f[v][1], w.push([k, d, m]);
              break;

            case "V":
              k = "L", m = +f[v][1], w.push([k, d, m]);
              break;

            case "A":
              k = "L";
              var M = +f[v][1],
                  A = +f[v][2];
              +f[v][4] || (M = -M, A = -A);
              var S = d - M,
                  E = m;

              for (o = 1; o <= a / 2; o++) {
                var L = 2 * Math.PI * o / a;
                w.push([k, S + M * Math.cos(L), E + A * Math.sin(L)]);
              }

              break;

            case "Z":
              d === s && m === u || (d = s, m = u, w.push([k, d, m]));
          }

          for (var C = (r || {}).domain, P = e._fullLayout._size, I = r && "pixel" === r.xsizemode, O = r && "pixel" === r.ysizemode, z = !1 === i, D = 0; D < w.length; D++) {
            for (o = 0; o + 2 < 7; o += 2) {
              var R = w[D][o + 1],
                  F = w[D][o + 2];
              void 0 !== R && void 0 !== F && (d = R, m = F, r && (r.xaxis && r.xaxis.p2r ? (z && (R -= r.xaxis._offset), R = I ? c(r.xaxis, r.xanchor) + R : l(r.xaxis, R)) : (z && (R -= P.l), C ? R = C.x[0] + R / P.w : R /= P.w), r.yaxis && r.yaxis.p2r ? (z && (F -= r.yaxis._offset), F = O ? c(r.yaxis, r.yanchor) - F : l(r.yaxis, F)) : (z && (F -= P.t), F = C ? C.y[1] - F / P.h : 1 - F / P.h)), w[D][o + 1] = R, w[D][o + 2] = F);
            }

            h[p].push(w[D].slice());
          }
        }

        return h;
      }, r.pointsShapeRectangle = function (t) {
        if (5 !== t.length) return !1;

        for (var e = 1; e < 3; e++) {
          if (!h(t[0][e] - t[1][e], t[3][e] - t[2][e])) return !1;
          if (!h(t[0][e] - t[3][e], t[1][e] - t[2][e])) return !1;
        }

        return !(!h(t[0][1], t[1][1]) && !h(t[0][1], t[3][1])) && !!(p(t[0], t[1]) * p(t[0], t[3]));
      }, r.pointsShapeEllipse = function (t) {
        var e = t.length;
        if (e !== a + 1) return !1;
        e = a;

        for (var r = 0; r < e; r++) {
          var n = (2 * e - r) % e,
              i = (e / 2 + n) % e,
              o = (e / 2 + r) % e;
          if (!h(p(t[r], t[o]), p(t[n], t[i]))) return !1;
        }

        return !0;
      }, r.handleEllipse = function (t, e, n) {
        if (!t) return [e, n];
        var i = r.ellipseOver({
          x0: e[0],
          y0: e[1],
          x1: n[0],
          y1: n[1]
        }),
            s = (i.x1 + i.x0) / 2,
            l = (i.y1 + i.y0) / 2,
            c = (i.x1 - i.x0) / 2,
            u = (i.y1 - i.y0) / 2;
        c || (c = u /= o), u || (u = c /= o);

        for (var f = [], h = 0; h < a; h++) {
          var p = 2 * h * Math.PI / a;
          f.push([s + c * Math.cos(p), l + u * Math.sin(p)]);
        }

        return f;
      }, r.ellipseOver = function (t) {
        var e = t.x0,
            r = t.y0,
            n = t.x1,
            i = t.y1,
            a = n - e,
            s = i - r,
            l = ((e -= a) + n) / 2,
            c = ((r -= s) + i) / 2;
        return {
          x0: l - (a *= o),
          y0: c - (s *= o),
          x1: l + a,
          y1: c + s
        };
      };
    }, {
      "../../../plots/cartesian/helpers": 856,
      "./constants": 744,
      "parse-svg-path": 485
    }],
    748: [function (t, e, r) {
      "use strict";

      var n = t("../../dragelement/helpers"),
          i = n.drawMode,
          a = n.openMode,
          o = t("./constants"),
          s = o.i000,
          l = o.i090,
          c = o.i180,
          u = o.i270,
          f = o.cos45,
          h = o.sin45,
          p = t("../../../plots/cartesian/helpers"),
          d = p.p2r,
          m = p.r2p,
          g = t("../../../plots/cartesian/handle_outline").clearSelect,
          v = t("./helpers"),
          y = v.readPaths,
          x = v.writePaths,
          b = v.ellipseOver;

      e.exports = function (t, e) {
        if (t.length) {
          var r = t[0][0];

          if (r) {
            var n = r.getAttribute("d"),
                o = e.gd,
                p = o._fullLayout.newshape,
                v = e.plotinfo,
                _ = v.xaxis,
                w = v.yaxis,
                T = !!v.domain || !v.xaxis,
                k = !!v.domain || !v.yaxis,
                M = e.isActiveShape,
                A = e.dragmode,
                S = (o.layout || {}).shapes || [];

            if (!i(A) && void 0 !== M) {
              var E = o._fullLayout._activeShapeIndex;
              if (E < S.length) switch (o._fullLayout.shapes[E].type) {
                case "rect":
                  A = "drawrect";
                  break;

                case "circle":
                  A = "drawcircle";
                  break;

                case "line":
                  A = "drawline";
                  break;

                case "path":
                  var L = S[E].path || "";
                  A = "Z" === L[L.length - 1] ? "drawclosedpath" : "drawopenpath";
              }
            }

            var C,
                P = a(A),
                I = y(n, o, v, M),
                O = {
              editable: !0,
              xref: T ? "paper" : _._id,
              yref: k ? "paper" : w._id,
              layer: p.layer,
              opacity: p.opacity,
              line: {
                color: p.line.color,
                width: p.line.width,
                dash: p.line.dash
              }
            };
            if (P || (O.fillcolor = p.fillcolor, O.fillrule = p.fillrule), 1 === I.length && (C = I[0]), C && "drawrect" === A) O.type = "rect", O.x0 = C[0][1], O.y0 = C[0][2], O.x1 = C[2][1], O.y1 = C[2][2];else if (C && "drawline" === A) O.type = "line", O.x0 = C[0][1], O.y0 = C[0][2], O.x1 = C[1][1], O.y1 = C[1][2];else if (C && "drawcircle" === A) {
              O.type = "circle";
              var z = C[s][1],
                  D = C[l][1],
                  R = C[c][1],
                  F = C[u][1],
                  B = C[s][2],
                  N = C[l][2],
                  j = C[c][2],
                  U = C[u][2],
                  V = v.xaxis && ("date" === v.xaxis.type || "log" === v.xaxis.type),
                  q = v.yaxis && ("date" === v.yaxis.type || "log" === v.yaxis.type);
              V && (z = m(v.xaxis, z), D = m(v.xaxis, D), R = m(v.xaxis, R), F = m(v.xaxis, F)), q && (B = m(v.yaxis, B), N = m(v.yaxis, N), j = m(v.yaxis, j), U = m(v.yaxis, U));
              var H = (D + F) / 2,
                  G = (B + j) / 2,
                  Y = b({
                x0: H,
                y0: G,
                x1: H + (F - D + R - z) / 2 * f,
                y1: G + (U - N + j - B) / 2 * h
              });
              V && (Y.x0 = d(v.xaxis, Y.x0), Y.x1 = d(v.xaxis, Y.x1)), q && (Y.y0 = d(v.yaxis, Y.y0), Y.y1 = d(v.yaxis, Y.y1)), O.x0 = Y.x0, O.y0 = Y.y0, O.x1 = Y.x1, O.y1 = Y.y1;
            } else O.type = "path", _ && w && function (t, e, r) {
              var n = "date" === e.type,
                  i = "date" === r.type;
              if (!n && !i) return t;

              for (var a = 0; a < t.length; a++) {
                for (var o = 0; o < t[a].length; o++) {
                  for (var s = 0; s + 2 < t[a][o].length; s += 2) {
                    n && (t[a][o][s + 1] = t[a][o][s + 1].replace(" ", "_")), i && (t[a][o][s + 2] = t[a][o][s + 2].replace(" ", "_"));
                  }
                }
              }
            }(I, _, w), O.path = x(I), C = null;
            g(o);

            for (var W = e.editHelpers, X = (W || {}).modifyItem, Z = [], J = 0; J < S.length; J++) {
              var K = o._fullLayout.shapes[J];

              if (Z[J] = K._input, void 0 !== M && J === o._fullLayout._activeShapeIndex) {
                var Q = O;

                switch (K.type) {
                  case "line":
                  case "rect":
                  case "circle":
                    X("x0", Q.x0), X("x1", Q.x1), X("y0", Q.y0), X("y1", Q.y1);
                    break;

                  case "path":
                    X("path", Q.path);
                }
              }
            }

            return void 0 === M ? (Z.push(O), Z) : W ? W.getUpdateObj() : {};
          }
        }
      };
    }, {
      "../../../plots/cartesian/handle_outline": 855,
      "../../../plots/cartesian/helpers": 856,
      "../../dragelement/helpers": 676,
      "./constants": 744,
      "./helpers": 747
    }],
    749: [function (t, e, r) {
      "use strict";

      var n = t("./constants"),
          i = t("../../lib");
      r.rangeToShapePosition = function (t) {
        return "log" === t.type ? t.r2d : function (t) {
          return t;
        };
      }, r.shapePositionToRange = function (t) {
        return "log" === t.type ? t.d2r : function (t) {
          return t;
        };
      }, r.decodeDate = function (t) {
        return function (e) {
          return e.replace && (e = e.replace("_", " ")), t(e);
        };
      }, r.encodeDate = function (t) {
        return function (e) {
          return t(e).replace(" ", "_");
        };
      }, r.extractPathCoords = function (t, e) {
        var r = [];
        return t.match(n.segmentRE).forEach(function (t) {
          var a = e[t.charAt(0)].drawn;

          if (void 0 !== a) {
            var o = t.substr(1).match(n.paramRE);
            !o || o.length < a || r.push(i.cleanNumber(o[a]));
          }
        }), r;
      }, r.getDataToPixel = function (t, e, n, i) {
        var a,
            o = t._fullLayout._size;
        if (e) {
          if ("domain" === i) a = function a(t) {
            return e._length * (n ? 1 - t : t) + e._offset;
          };else {
            var s = r.shapePositionToRange(e);
            a = function a(t) {
              return e._offset + e.r2p(s(t, !0));
            }, "date" === e.type && (a = r.decodeDate(a));
          }
        } else a = n ? function (t) {
          return o.t + o.h * (1 - t);
        } : function (t) {
          return o.l + o.w * t;
        };
        return a;
      }, r.getPixelToData = function (t, e, n, i) {
        var a,
            o = t._fullLayout._size;
        if (e) {
          if ("domain" === i) a = function a(t) {
            var r = (t - e._offset) / e._length;
            return n ? 1 - r : r;
          };else {
            var s = r.rangeToShapePosition(e);

            a = function a(t) {
              return s(e.p2r(t - e._offset));
            };
          }
        } else a = n ? function (t) {
          return 1 - (t - o.t) / o.h;
        } : function (t) {
          return (t - o.l) / o.w;
        };
        return a;
      }, r.roundPositionForSharpStrokeRendering = function (t, e) {
        var r = 1 === Math.round(e % 2),
            n = Math.round(t);
        return r ? n + .5 : n;
      }, r.makeOptionsAndPlotinfo = function (t, e) {
        var r = t._fullLayout.shapes[e] || {},
            n = t._fullLayout._plots[r.xref + r.yref];
        return !!n ? n._hadPlotinfo = !0 : (n = {}, r.xref && "paper" !== r.xref && (n.xaxis = t._fullLayout[r.xref + "axis"]), r.yref && "paper" !== r.yref && (n.yaxis = t._fullLayout[r.yref + "axis"])), n.xsizemode = r.xsizemode, n.ysizemode = r.ysizemode, n.xanchor = r.xanchor, n.yanchor = r.yanchor, {
          options: r,
          plotinfo: n
        };
      };
    }, {
      "../../lib": 795,
      "./constants": 740
    }],
    750: [function (t, e, r) {
      "use strict";

      var n = t("./draw");
      e.exports = {
        moduleType: "component",
        name: "shapes",
        layoutAttributes: t("./attributes"),
        supplyLayoutDefaults: t("./defaults"),
        supplyDrawNewShapeDefaults: t("./draw_newshape/defaults"),
        includeBasePlot: t("../../plots/cartesian/include_components")("shapes"),
        calcAutorange: t("./calc_autorange"),
        draw: n.draw,
        drawOne: n.drawOne
      };
    }, {
      "../../plots/cartesian/include_components": 857,
      "./attributes": 738,
      "./calc_autorange": 739,
      "./defaults": 741,
      "./draw": 742,
      "./draw_newshape/defaults": 745
    }],
    751: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/font_attributes"),
          i = t("../../plots/pad_attributes"),
          a = t("../../lib/extend").extendDeepAll,
          o = t("../../plot_api/edit_types").overrideAll,
          s = t("../../plots/animation_attributes"),
          l = t("../../plot_api/plot_template").templatedArray,
          c = t("./constants"),
          u = l("step", {
        visible: {
          valType: "boolean",
          dflt: !0
        },
        method: {
          valType: "enumerated",
          values: ["restyle", "relayout", "animate", "update", "skip"],
          dflt: "restyle"
        },
        args: {
          valType: "info_array",
          freeLength: !0,
          items: [{
            valType: "any"
          }, {
            valType: "any"
          }, {
            valType: "any"
          }]
        },
        label: {
          valType: "string"
        },
        value: {
          valType: "string"
        },
        execute: {
          valType: "boolean",
          dflt: !0
        }
      });
      e.exports = o(l("slider", {
        visible: {
          valType: "boolean",
          dflt: !0
        },
        active: {
          valType: "number",
          min: 0,
          dflt: 0
        },
        steps: u,
        lenmode: {
          valType: "enumerated",
          values: ["fraction", "pixels"],
          dflt: "fraction"
        },
        len: {
          valType: "number",
          min: 0,
          dflt: 1
        },
        x: {
          valType: "number",
          min: -2,
          max: 3,
          dflt: 0
        },
        pad: a(i({
          editType: "arraydraw"
        }), {}, {
          t: {
            dflt: 20
          }
        }),
        xanchor: {
          valType: "enumerated",
          values: ["auto", "left", "center", "right"],
          dflt: "left"
        },
        y: {
          valType: "number",
          min: -2,
          max: 3,
          dflt: 0
        },
        yanchor: {
          valType: "enumerated",
          values: ["auto", "top", "middle", "bottom"],
          dflt: "top"
        },
        transition: {
          duration: {
            valType: "number",
            min: 0,
            dflt: 150
          },
          easing: {
            valType: "enumerated",
            values: s.transition.easing.values,
            dflt: "cubic-in-out"
          }
        },
        currentvalue: {
          visible: {
            valType: "boolean",
            dflt: !0
          },
          xanchor: {
            valType: "enumerated",
            values: ["left", "center", "right"],
            dflt: "left"
          },
          offset: {
            valType: "number",
            dflt: 10
          },
          prefix: {
            valType: "string"
          },
          suffix: {
            valType: "string"
          },
          font: n({})
        },
        font: n({}),
        activebgcolor: {
          valType: "color",
          dflt: c.gripBgActiveColor
        },
        bgcolor: {
          valType: "color",
          dflt: c.railBgColor
        },
        bordercolor: {
          valType: "color",
          dflt: c.railBorderColor
        },
        borderwidth: {
          valType: "number",
          min: 0,
          dflt: c.railBorderWidth
        },
        ticklen: {
          valType: "number",
          min: 0,
          dflt: c.tickLength
        },
        tickcolor: {
          valType: "color",
          dflt: c.tickColor
        },
        tickwidth: {
          valType: "number",
          min: 0,
          dflt: 1
        },
        minorticklen: {
          valType: "number",
          min: 0,
          dflt: c.minorTickLength
        }
      }), "arraydraw", "from-root");
    }, {
      "../../lib/extend": 785,
      "../../plot_api/edit_types": 827,
      "../../plot_api/plot_template": 834,
      "../../plots/animation_attributes": 839,
      "../../plots/font_attributes": 873,
      "../../plots/pad_attributes": 908,
      "./constants": 752
    }],
    752: [function (t, e, r) {
      "use strict";

      e.exports = {
        name: "sliders",
        containerClassName: "slider-container",
        groupClassName: "slider-group",
        inputAreaClass: "slider-input-area",
        railRectClass: "slider-rail-rect",
        railTouchRectClass: "slider-rail-touch-rect",
        gripRectClass: "slider-grip-rect",
        tickRectClass: "slider-tick-rect",
        inputProxyClass: "slider-input-proxy",
        labelsClass: "slider-labels",
        labelGroupClass: "slider-label-group",
        labelClass: "slider-label",
        currentValueClass: "slider-current-value",
        railHeight: 5,
        menuIndexAttrName: "slider-active-index",
        autoMarginIdRoot: "slider-",
        minWidth: 30,
        minHeight: 30,
        textPadX: 40,
        arrowOffsetX: 4,
        railRadius: 2,
        railWidth: 5,
        railBorder: 4,
        railBorderWidth: 1,
        railBorderColor: "#bec8d9",
        railBgColor: "#f8fafc",
        railInset: 8,
        stepInset: 10,
        gripRadius: 10,
        gripWidth: 20,
        gripHeight: 20,
        gripBorder: 20,
        gripBorderWidth: 1,
        gripBorderColor: "#bec8d9",
        gripBgColor: "#f6f8fa",
        gripBgActiveColor: "#dbdde0",
        labelPadding: 8,
        labelOffset: 0,
        tickWidth: 1,
        tickColor: "#333",
        tickOffset: 25,
        tickLength: 7,
        minorTickOffset: 25,
        minorTickColor: "#333",
        minorTickLength: 4,
        currentValuePadding: 8,
        currentValueInset: 0
      };
    }, {}],
    753: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../plots/array_container_defaults"),
          a = t("./attributes"),
          o = t("./constants").name,
          s = a.steps;

      function l(t, e, r) {
        function o(r, i) {
          return n.coerce(t, e, a, r, i);
        }

        for (var s = i(t, e, {
          name: "steps",
          handleItemDefaults: c
        }), l = 0, u = 0; u < s.length; u++) {
          s[u].visible && l++;
        }

        if (l < 2 ? e.visible = !1 : o("visible")) {
          e._stepCount = l;
          var f = e._visibleSteps = n.filterVisible(s);
          (s[o("active")] || {}).visible || (e.active = f[0]._index), o("x"), o("y"), n.noneOrAll(t, e, ["x", "y"]), o("xanchor"), o("yanchor"), o("len"), o("lenmode"), o("pad.t"), o("pad.r"), o("pad.b"), o("pad.l"), n.coerceFont(o, "font", r.font), o("currentvalue.visible") && (o("currentvalue.xanchor"), o("currentvalue.prefix"), o("currentvalue.suffix"), o("currentvalue.offset"), n.coerceFont(o, "currentvalue.font", e.font)), o("transition.duration"), o("transition.easing"), o("bgcolor"), o("activebgcolor"), o("bordercolor"), o("borderwidth"), o("ticklen"), o("tickwidth"), o("tickcolor"), o("minorticklen");
        }
      }

      function c(t, e) {
        function r(r, i) {
          return n.coerce(t, e, s, r, i);
        }

        if ("skip" === t.method || Array.isArray(t.args) ? r("visible") : e.visible = !1) {
          r("method"), r("args");
          var i = r("label", "step-" + e._index);
          r("value", i), r("execute");
        }
      }

      e.exports = function (t, e) {
        i(t, e, {
          name: o,
          handleItemDefaults: l
        });
      };
    }, {
      "../../lib": 795,
      "../../plots/array_container_defaults": 840,
      "./attributes": 751,
      "./constants": 752
    }],
    754: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../plots/plots"),
          a = t("../color"),
          o = t("../drawing"),
          s = t("../../lib"),
          l = s.strTranslate,
          c = t("../../lib/svg_text_utils"),
          u = t("../../plot_api/plot_template").arrayEditor,
          f = t("./constants"),
          h = t("../../constants/alignment"),
          p = h.LINE_SPACING,
          d = h.FROM_TL,
          m = h.FROM_BR;

      function g(t) {
        return f.autoMarginIdRoot + t._index;
      }

      function v(t) {
        return t._index;
      }

      function y(t, e) {
        var r = o.tester.selectAll("g." + f.labelGroupClass).data(e._visibleSteps);
        r.enter().append("g").classed(f.labelGroupClass, !0);
        var a = 0,
            l = 0;
        r.each(function (t) {
          var r = _(n.select(this), {
            step: t
          }, e).node();

          if (r) {
            var i = o.bBox(r);
            l = Math.max(l, i.height), a = Math.max(a, i.width);
          }
        }), r.remove();
        var u = e._dims = {};
        u.inputAreaWidth = Math.max(f.railWidth, f.gripHeight);
        var h = t._fullLayout._size;
        u.lx = h.l + h.w * e.x, u.ly = h.t + h.h * (1 - e.y), "fraction" === e.lenmode ? u.outerLength = Math.round(h.w * e.len) : u.outerLength = e.len, u.inputAreaStart = 0, u.inputAreaLength = Math.round(u.outerLength - e.pad.l - e.pad.r);
        var p = (u.inputAreaLength - 2 * f.stepInset) / (e._stepCount - 1),
            v = a + f.labelPadding;

        if (u.labelStride = Math.max(1, Math.ceil(v / p)), u.labelHeight = l, u.currentValueMaxWidth = 0, u.currentValueHeight = 0, u.currentValueTotalHeight = 0, u.currentValueMaxLines = 1, e.currentvalue.visible) {
          var y = o.tester.append("g");
          r.each(function (t) {
            var r = x(y, e, t.label),
                n = r.node() && o.bBox(r.node()) || {
              width: 0,
              height: 0
            },
                i = c.lineCount(r);
            u.currentValueMaxWidth = Math.max(u.currentValueMaxWidth, Math.ceil(n.width)), u.currentValueHeight = Math.max(u.currentValueHeight, Math.ceil(n.height)), u.currentValueMaxLines = Math.max(u.currentValueMaxLines, i);
          }), u.currentValueTotalHeight = u.currentValueHeight + e.currentvalue.offset, y.remove();
        }

        u.height = u.currentValueTotalHeight + f.tickOffset + e.ticklen + f.labelOffset + u.labelHeight + e.pad.t + e.pad.b;
        var b = "left";
        s.isRightAnchor(e) && (u.lx -= u.outerLength, b = "right"), s.isCenterAnchor(e) && (u.lx -= u.outerLength / 2, b = "center");
        var w = "top";
        s.isBottomAnchor(e) && (u.ly -= u.height, w = "bottom"), s.isMiddleAnchor(e) && (u.ly -= u.height / 2, w = "middle"), u.outerLength = Math.ceil(u.outerLength), u.height = Math.ceil(u.height), u.lx = Math.round(u.lx), u.ly = Math.round(u.ly);
        var T = {
          y: e.y,
          b: u.height * m[w],
          t: u.height * d[w]
        };
        "fraction" === e.lenmode ? (T.l = 0, T.xl = e.x - e.len * d[b], T.r = 0, T.xr = e.x + e.len * m[b]) : (T.x = e.x, T.l = u.outerLength * d[b], T.r = u.outerLength * m[b]), i.autoMargin(t, g(e), T);
      }

      function x(t, e, r) {
        if (e.currentvalue.visible) {
          var n,
              i,
              a = e._dims;

          switch (e.currentvalue.xanchor) {
            case "right":
              n = a.inputAreaLength - f.currentValueInset - a.currentValueMaxWidth, i = "left";
              break;

            case "center":
              n = .5 * a.inputAreaLength, i = "middle";
              break;

            default:
              n = f.currentValueInset, i = "left";
          }

          var l = s.ensureSingle(t, "text", f.labelClass, function (t) {
            t.attr({
              "text-anchor": i,
              "data-notex": 1
            });
          }),
              u = e.currentvalue.prefix ? e.currentvalue.prefix : "";
          if ("string" == typeof r) u += r;else {
            var h = e.steps[e.active].label,
                d = e._gd._fullLayout._meta;
            d && (h = s.templateString(h, d)), u += h;
          }
          e.currentvalue.suffix && (u += e.currentvalue.suffix), l.call(o.font, e.currentvalue.font).text(u).call(c.convertToTspans, e._gd);
          var m = c.lineCount(l),
              g = (a.currentValueMaxLines + 1 - m) * e.currentvalue.font.size * p;
          return c.positionText(l, n, g), l;
        }
      }

      function b(t, e, r) {
        s.ensureSingle(t, "rect", f.gripRectClass, function (n) {
          n.call(M, e, t, r).style("pointer-events", "all");
        }).attr({
          width: f.gripWidth,
          height: f.gripHeight,
          rx: f.gripRadius,
          ry: f.gripRadius
        }).call(a.stroke, r.bordercolor).call(a.fill, r.bgcolor).style("stroke-width", r.borderwidth + "px");
      }

      function _(t, e, r) {
        var n = s.ensureSingle(t, "text", f.labelClass, function (t) {
          t.attr({
            "text-anchor": "middle",
            "data-notex": 1
          });
        }),
            i = e.step.label,
            a = r._gd._fullLayout._meta;
        return a && (i = s.templateString(i, a)), n.call(o.font, r.font).text(i).call(c.convertToTspans, r._gd), n;
      }

      function w(t, e) {
        var r = s.ensureSingle(t, "g", f.labelsClass),
            i = e._dims,
            a = r.selectAll("g." + f.labelGroupClass).data(i.labelSteps);
        a.enter().append("g").classed(f.labelGroupClass, !0), a.exit().remove(), a.each(function (t) {
          var r = n.select(this);
          r.call(_, t, e), o.setTranslate(r, E(e, t.fraction), f.tickOffset + e.ticklen + e.font.size * p + f.labelOffset + i.currentValueTotalHeight);
        });
      }

      function T(t, e, r, n, i) {
        var a = Math.round(n * (r._stepCount - 1)),
            o = r._visibleSteps[a]._index;
        o !== r.active && k(t, e, r, o, !0, i);
      }

      function k(t, e, r, n, a, o) {
        var s = r.active;
        r.active = n, u(t.layout, f.name, r).applyUpdate("active", n);
        var l = r.steps[r.active];
        e.call(S, r, o), e.call(x, r), t.emit("plotly_sliderchange", {
          slider: r,
          step: r.steps[r.active],
          interaction: a,
          previousActive: s
        }), l && l.method && a && (e._nextMethod ? (e._nextMethod.step = l, e._nextMethod.doCallback = a, e._nextMethod.doTransition = o) : (e._nextMethod = {
          step: l,
          doCallback: a,
          doTransition: o
        }, e._nextMethodRaf = window.requestAnimationFrame(function () {
          var r = e._nextMethod.step;
          r.method && (r.execute && i.executeAPICommand(t, r.method, r.args), e._nextMethod = null, e._nextMethodRaf = null);
        })));
      }

      function M(t, e, r) {
        var i = r.node(),
            o = n.select(e);

        function s() {
          return r.data()[0];
        }

        t.on("mousedown", function () {
          var t = s();
          e.emit("plotly_sliderstart", {
            slider: t
          });
          var l = r.select("." + f.gripRectClass);
          n.event.stopPropagation(), n.event.preventDefault(), l.call(a.fill, t.activebgcolor);
          var c = L(t, n.mouse(i)[0]);
          T(e, r, t, c, !0), t._dragging = !0, o.on("mousemove", function () {
            var t = s(),
                a = L(t, n.mouse(i)[0]);
            T(e, r, t, a, !1);
          }), o.on("mouseup", function () {
            var t = s();
            t._dragging = !1, l.call(a.fill, t.bgcolor), o.on("mouseup", null), o.on("mousemove", null), e.emit("plotly_sliderend", {
              slider: t,
              step: t.steps[t.active]
            });
          });
        });
      }

      function A(t, e) {
        var r = t.selectAll("rect." + f.tickRectClass).data(e._visibleSteps),
            i = e._dims;
        r.enter().append("rect").classed(f.tickRectClass, !0), r.exit().remove(), r.attr({
          width: e.tickwidth + "px",
          "shape-rendering": "crispEdges"
        }), r.each(function (t, r) {
          var s = r % i.labelStride == 0,
              l = n.select(this);
          l.attr({
            height: s ? e.ticklen : e.minorticklen
          }).call(a.fill, e.tickcolor), o.setTranslate(l, E(e, r / (e._stepCount - 1)) - .5 * e.tickwidth, (s ? f.tickOffset : f.minorTickOffset) + i.currentValueTotalHeight);
        });
      }

      function S(t, e, r) {
        for (var n = t.select("rect." + f.gripRectClass), i = 0, a = 0; a < e._stepCount; a++) {
          if (e._visibleSteps[a]._index === e.active) {
            i = a;
            break;
          }
        }

        var o = E(e, i / (e._stepCount - 1));

        if (!e._invokingCommand) {
          var s = n;
          r && e.transition.duration > 0 && (s = s.transition().duration(e.transition.duration).ease(e.transition.easing)), s.attr("transform", l(o - .5 * f.gripWidth, e._dims.currentValueTotalHeight));
        }
      }

      function E(t, e) {
        var r = t._dims;
        return r.inputAreaStart + f.stepInset + (r.inputAreaLength - 2 * f.stepInset) * Math.min(1, Math.max(0, e));
      }

      function L(t, e) {
        var r = t._dims;
        return Math.min(1, Math.max(0, (e - f.stepInset - r.inputAreaStart) / (r.inputAreaLength - 2 * f.stepInset - 2 * r.inputAreaStart)));
      }

      function C(t, e, r) {
        var n = r._dims,
            i = s.ensureSingle(t, "rect", f.railTouchRectClass, function (n) {
          n.call(M, e, t, r).style("pointer-events", "all");
        });
        i.attr({
          width: n.inputAreaLength,
          height: Math.max(n.inputAreaWidth, f.tickOffset + r.ticklen + n.labelHeight)
        }).call(a.fill, r.bgcolor).attr("opacity", 0), o.setTranslate(i, 0, n.currentValueTotalHeight);
      }

      function P(t, e) {
        var r = e._dims,
            n = r.inputAreaLength - 2 * f.railInset,
            i = s.ensureSingle(t, "rect", f.railRectClass);
        i.attr({
          width: n,
          height: f.railWidth,
          rx: f.railRadius,
          ry: f.railRadius,
          "shape-rendering": "crispEdges"
        }).call(a.stroke, e.bordercolor).call(a.fill, e.bgcolor).style("stroke-width", e.borderwidth + "px"), o.setTranslate(i, f.railInset, .5 * (r.inputAreaWidth - f.railWidth) + r.currentValueTotalHeight);
      }

      e.exports = function (t) {
        var e = t._fullLayout,
            r = function (t, e) {
          for (var r = t[f.name], n = [], i = 0; i < r.length; i++) {
            var a = r[i];
            a.visible && (a._gd = e, n.push(a));
          }

          return n;
        }(e, t),
            a = e._infolayer.selectAll("g." + f.containerClassName).data(r.length > 0 ? [0] : []);

        function s(e) {
          e._commandObserver && (e._commandObserver.remove(), delete e._commandObserver), i.autoMargin(t, g(e));
        }

        if (a.enter().append("g").classed(f.containerClassName, !0).style("cursor", "ew-resize"), a.exit().each(function () {
          n.select(this).selectAll("g." + f.groupClassName).each(s);
        }).remove(), 0 !== r.length) {
          var l = a.selectAll("g." + f.groupClassName).data(r, v);
          l.enter().append("g").classed(f.groupClassName, !0), l.exit().each(s).remove();

          for (var c = 0; c < r.length; c++) {
            var u = r[c];
            y(t, u);
          }

          l.each(function (e) {
            var r = n.select(this);
            !function (t) {
              var e = t._dims;
              e.labelSteps = [];

              for (var r = t._stepCount, n = 0; n < r; n += e.labelStride) {
                e.labelSteps.push({
                  fraction: n / (r - 1),
                  step: t._visibleSteps[n]
                });
              }
            }(e), i.manageCommandObserver(t, e, e._visibleSteps, function (e) {
              var n = r.data()[0];
              n.active !== e.index && (n._dragging || k(t, r, n, e.index, !1, !0));
            }), function (t, e, r) {
              (r.steps[r.active] || {}).visible || (r.active = r._visibleSteps[0]._index);
              e.call(x, r).call(P, r).call(w, r).call(A, r).call(C, t, r).call(b, t, r);
              var n = r._dims;
              o.setTranslate(e, n.lx + r.pad.l, n.ly + r.pad.t), e.call(S, r, !1), e.call(x, r);
            }(t, n.select(this), e);
          });
        }
      };
    }, {
      "../../constants/alignment": 763,
      "../../lib": 795,
      "../../lib/svg_text_utils": 820,
      "../../plot_api/plot_template": 834,
      "../../plots/plots": 909,
      "../color": 658,
      "../drawing": 680,
      "./constants": 752,
      "@plotly/d3": 57
    }],
    755: [function (t, e, r) {
      "use strict";

      var n = t("./constants");
      e.exports = {
        moduleType: "component",
        name: n.name,
        layoutAttributes: t("./attributes"),
        supplyLayoutDefaults: t("./defaults"),
        draw: t("./draw")
      };
    }, {
      "./attributes": 751,
      "./constants": 752,
      "./defaults": 753,
      "./draw": 754
    }],
    756: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("fast-isnumeric"),
          a = t("../../plots/plots"),
          o = t("../../registry"),
          s = t("../../lib"),
          l = s.strTranslate,
          c = t("../drawing"),
          u = t("../color"),
          f = t("../../lib/svg_text_utils"),
          h = t("../../constants/interactions"),
          p = t("../../constants/alignment").OPPOSITE_SIDE,
          d = / [XY][0-9]* /;
      e.exports = {
        draw: function draw(t, e, r) {
          var m,
              g = r.propContainer,
              v = r.propName,
              y = r.placeholder,
              x = r.traceIndex,
              b = r.avoid || {},
              _ = r.attributes,
              w = r.transform,
              T = r.containerGroup,
              k = t._fullLayout,
              M = 1,
              A = !1,
              S = g.title,
              E = (S && S.text ? S.text : "").trim(),
              L = S && S.font ? S.font : {},
              C = L.family,
              P = L.size,
              I = L.color;
          "title.text" === v ? m = "titleText" : -1 !== v.indexOf("axis") ? m = "axisTitleText" : v.indexOf(!0) && (m = "colorbarTitleText");
          var O = t._context.edits[m];
          "" === E ? M = 0 : E.replace(d, " % ") === y.replace(d, " % ") && (M = .2, A = !0, O || (E = "")), r._meta ? E = s.templateString(E, r._meta) : k._meta && (E = s.templateString(E, k._meta));
          var z = E || O;
          T || (T = s.ensureSingle(k._infolayer, "g", "g-" + e));
          var D = T.selectAll("text").data(z ? [0] : []);
          if (D.enter().append("text"), D.text(E).attr("class", e), D.exit().remove(), !z) return T;

          function R(t) {
            s.syncOrAsync([F, B], t);
          }

          function F(e) {
            var r;
            return w ? (r = "", w.rotate && (r += "rotate(" + [w.rotate, _.x, _.y] + ")"), w.offset && (r += l(0, w.offset))) : r = null, e.attr("transform", r), e.style({
              "font-family": C,
              "font-size": n.round(P, 2) + "px",
              fill: u.rgb(I),
              opacity: M * u.opacity(I),
              "font-weight": a.fontWeight
            }).attr(_).call(f.convertToTspans, t), a.previousPromises(t);
          }

          function B(t) {
            var e = n.select(t.node().parentNode);

            if (b && b.selection && b.side && E) {
              e.attr("transform", null);
              var r = p[b.side],
                  a = "left" === b.side || "top" === b.side ? -1 : 1,
                  o = i(b.pad) ? b.pad : 2,
                  u = c.bBox(e.node()),
                  f = {
                left: 0,
                top: 0,
                right: k.width,
                bottom: k.height
              },
                  h = b.maxShift || a * (f[b.side] - u[b.side]),
                  d = 0;
              if (h < 0) d = h;else {
                var m = b.offsetLeft || 0,
                    g = b.offsetTop || 0;
                u.left -= m, u.right -= m, u.top -= g, u.bottom -= g, b.selection.each(function () {
                  var t = c.bBox(this);
                  s.bBoxIntersect(u, t, o) && (d = Math.max(d, a * (t[b.side] - u[r]) + o));
                }), d = Math.min(h, d);
              }

              if (d > 0 || h < 0) {
                var v = {
                  left: [-d, 0],
                  right: [d, 0],
                  top: [0, -d],
                  bottom: [0, d]
                }[b.side];
                e.attr("transform", l(v[0], v[1]));
              }
            }
          }

          return D.call(R), O && (E ? D.on(".opacity", null) : (M = 0, A = !0, D.text(y).on("mouseover.opacity", function () {
            n.select(this).transition().duration(h.SHOW_PLACEHOLDER).style("opacity", 1);
          }).on("mouseout.opacity", function () {
            n.select(this).transition().duration(h.HIDE_PLACEHOLDER).style("opacity", 0);
          })), D.call(f.makeEditable, {
            gd: t
          }).on("edit", function (e) {
            void 0 !== x ? o.call("_guiRestyle", t, v, e, x) : o.call("_guiRelayout", t, v, e);
          }).on("cancel", function () {
            this.text(this.attr("data-unformatted")).call(R);
          }).on("input", function (t) {
            this.text(t || " ").call(f.positionText, _.x, _.y);
          })), D.classed("js-placeholder", A), T;
        }
      };
    }, {
      "../../constants/alignment": 763,
      "../../constants/interactions": 770,
      "../../lib": 795,
      "../../lib/svg_text_utils": 820,
      "../../plots/plots": 909,
      "../../registry": 923,
      "../color": 658,
      "../drawing": 680,
      "@plotly/d3": 57,
      "fast-isnumeric": 240
    }],
    757: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/font_attributes"),
          i = t("../color/attributes"),
          a = t("../../lib/extend").extendFlat,
          o = t("../../plot_api/edit_types").overrideAll,
          s = t("../../plots/pad_attributes"),
          l = t("../../plot_api/plot_template").templatedArray,
          c = l("button", {
        visible: {
          valType: "boolean"
        },
        method: {
          valType: "enumerated",
          values: ["restyle", "relayout", "animate", "update", "skip"],
          dflt: "restyle"
        },
        args: {
          valType: "info_array",
          freeLength: !0,
          items: [{
            valType: "any"
          }, {
            valType: "any"
          }, {
            valType: "any"
          }]
        },
        args2: {
          valType: "info_array",
          freeLength: !0,
          items: [{
            valType: "any"
          }, {
            valType: "any"
          }, {
            valType: "any"
          }]
        },
        label: {
          valType: "string",
          dflt: ""
        },
        execute: {
          valType: "boolean",
          dflt: !0
        }
      });
      e.exports = o(l("updatemenu", {
        _arrayAttrRegexps: [/^updatemenus\[(0|[1-9][0-9]+)\]\.buttons/],
        visible: {
          valType: "boolean"
        },
        type: {
          valType: "enumerated",
          values: ["dropdown", "buttons"],
          dflt: "dropdown"
        },
        direction: {
          valType: "enumerated",
          values: ["left", "right", "up", "down"],
          dflt: "down"
        },
        active: {
          valType: "integer",
          min: -1,
          dflt: 0
        },
        showactive: {
          valType: "boolean",
          dflt: !0
        },
        buttons: c,
        x: {
          valType: "number",
          min: -2,
          max: 3,
          dflt: -.05
        },
        xanchor: {
          valType: "enumerated",
          values: ["auto", "left", "center", "right"],
          dflt: "right"
        },
        y: {
          valType: "number",
          min: -2,
          max: 3,
          dflt: 1
        },
        yanchor: {
          valType: "enumerated",
          values: ["auto", "top", "middle", "bottom"],
          dflt: "top"
        },
        pad: a(s({
          editType: "arraydraw"
        }), {}),
        font: n({}),
        bgcolor: {
          valType: "color"
        },
        bordercolor: {
          valType: "color",
          dflt: i.borderLine
        },
        borderwidth: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "arraydraw"
        }
      }), "arraydraw", "from-root");
    }, {
      "../../lib/extend": 785,
      "../../plot_api/edit_types": 827,
      "../../plot_api/plot_template": 834,
      "../../plots/font_attributes": 873,
      "../../plots/pad_attributes": 908,
      "../color/attributes": 657
    }],
    758: [function (t, e, r) {
      "use strict";

      e.exports = {
        name: "updatemenus",
        containerClassName: "updatemenu-container",
        headerGroupClassName: "updatemenu-header-group",
        headerClassName: "updatemenu-header",
        headerArrowClassName: "updatemenu-header-arrow",
        dropdownButtonGroupClassName: "updatemenu-dropdown-button-group",
        dropdownButtonClassName: "updatemenu-dropdown-button",
        buttonClassName: "updatemenu-button",
        itemRectClassName: "updatemenu-item-rect",
        itemTextClassName: "updatemenu-item-text",
        menuIndexAttrName: "updatemenu-active-index",
        autoMarginIdRoot: "updatemenu-",
        blankHeaderOpts: {
          label: "  "
        },
        minWidth: 30,
        minHeight: 30,
        textPadX: 24,
        arrowPadX: 16,
        rx: 2,
        ry: 2,
        textOffsetX: 12,
        textOffsetY: 3,
        arrowOffsetX: 4,
        gapButtonHeader: 5,
        gapButton: 2,
        activeColor: "#F4FAFF",
        hoverColor: "#F4FAFF",
        arrowSymbol: {
          left: "\u25C4",
          right: "\u25BA",
          up: "\u25B2",
          down: "\u25BC"
        }
      };
    }, {}],
    759: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../plots/array_container_defaults"),
          a = t("./attributes"),
          o = t("./constants").name,
          s = a.buttons;

      function l(t, e, r) {
        function o(r, i) {
          return n.coerce(t, e, a, r, i);
        }

        o("visible", i(t, e, {
          name: "buttons",
          handleItemDefaults: c
        }).length > 0) && (o("active"), o("direction"), o("type"), o("showactive"), o("x"), o("y"), n.noneOrAll(t, e, ["x", "y"]), o("xanchor"), o("yanchor"), o("pad.t"), o("pad.r"), o("pad.b"), o("pad.l"), n.coerceFont(o, "font", r.font), o("bgcolor", r.paper_bgcolor), o("bordercolor"), o("borderwidth"));
      }

      function c(t, e) {
        function r(r, i) {
          return n.coerce(t, e, s, r, i);
        }

        r("visible", "skip" === t.method || Array.isArray(t.args)) && (r("method"), r("args"), r("args2"), r("label"), r("execute"));
      }

      e.exports = function (t, e) {
        i(t, e, {
          name: o,
          handleItemDefaults: l
        });
      };
    }, {
      "../../lib": 795,
      "../../plots/array_container_defaults": 840,
      "./attributes": 757,
      "./constants": 758
    }],
    760: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../plots/plots"),
          a = t("../color"),
          o = t("../drawing"),
          s = t("../../lib"),
          l = t("../../lib/svg_text_utils"),
          c = t("../../plot_api/plot_template").arrayEditor,
          u = t("../../constants/alignment").LINE_SPACING,
          f = t("./constants"),
          h = t("./scrollbox");

      function p(t) {
        return t._index;
      }

      function d(t, e) {
        return +t.attr(f.menuIndexAttrName) === e._index;
      }

      function m(t, e, r, n, i, a, o, s) {
        e.active = o, c(t.layout, f.name, e).applyUpdate("active", o), "buttons" === e.type ? v(t, n, null, null, e) : "dropdown" === e.type && (i.attr(f.menuIndexAttrName, "-1"), g(t, n, i, a, e), s || v(t, n, i, a, e));
      }

      function g(t, e, r, n, i) {
        var a = s.ensureSingle(e, "g", f.headerClassName, function (t) {
          t.style("pointer-events", "all");
        }),
            l = i._dims,
            c = i.active,
            u = i.buttons[c] || f.blankHeaderOpts,
            h = {
          y: i.pad.t,
          yPad: 0,
          x: i.pad.l,
          xPad: 0,
          index: 0
        },
            p = {
          width: l.headerWidth,
          height: l.headerHeight
        };
        a.call(y, i, u, t).call(A, i, h, p), s.ensureSingle(e, "text", f.headerArrowClassName, function (t) {
          t.attr("text-anchor", "end").call(o.font, i.font).text(f.arrowSymbol[i.direction]);
        }).attr({
          x: l.headerWidth - f.arrowOffsetX + i.pad.l,
          y: l.headerHeight / 2 + f.textOffsetY + i.pad.t
        }), a.on("click", function () {
          r.call(S, String(d(r, i) ? -1 : i._index)), v(t, e, r, n, i);
        }), a.on("mouseover", function () {
          a.call(w);
        }), a.on("mouseout", function () {
          a.call(T, i);
        }), o.setTranslate(e, l.lx, l.ly);
      }

      function v(t, e, r, a, o) {
        r || (r = e).attr("pointer-events", "all");
        var l = function (t) {
          return -1 == +t.attr(f.menuIndexAttrName);
        }(r) && "buttons" !== o.type ? [] : o.buttons,
            c = "dropdown" === o.type ? f.dropdownButtonClassName : f.buttonClassName,
            u = r.selectAll("g." + c).data(s.filterVisible(l)),
            h = u.enter().append("g").classed(c, !0),
            p = u.exit();
        "dropdown" === o.type ? (h.attr("opacity", "0").transition().attr("opacity", "1"), p.transition().attr("opacity", "0").remove()) : p.remove();
        var d = 0,
            g = 0,
            v = o._dims,
            x = -1 !== ["up", "down"].indexOf(o.direction);
        "dropdown" === o.type && (x ? g = v.headerHeight + f.gapButtonHeader : d = v.headerWidth + f.gapButtonHeader), "dropdown" === o.type && "up" === o.direction && (g = -f.gapButtonHeader + f.gapButton - v.openHeight), "dropdown" === o.type && "left" === o.direction && (d = -f.gapButtonHeader + f.gapButton - v.openWidth);
        var b = {
          x: v.lx + d + o.pad.l,
          y: v.ly + g + o.pad.t,
          yPad: f.gapButton,
          xPad: f.gapButton,
          index: 0
        },
            k = {
          l: b.x + o.borderwidth,
          t: b.y + o.borderwidth
        };
        u.each(function (s, l) {
          var c = n.select(this);
          c.call(y, o, s, t).call(A, o, b), c.on("click", function () {
            n.event.defaultPrevented || (s.execute && (s.args2 && o.active === l ? (m(t, o, 0, e, r, a, -1), i.executeAPICommand(t, s.method, s.args2)) : (m(t, o, 0, e, r, a, l), i.executeAPICommand(t, s.method, s.args))), t.emit("plotly_buttonclicked", {
              menu: o,
              button: s,
              active: o.active
            }));
          }), c.on("mouseover", function () {
            c.call(w);
          }), c.on("mouseout", function () {
            c.call(T, o), u.call(_, o);
          });
        }), u.call(_, o), x ? (k.w = Math.max(v.openWidth, v.headerWidth), k.h = b.y - k.t) : (k.w = b.x - k.l, k.h = Math.max(v.openHeight, v.headerHeight)), k.direction = o.direction, a && (u.size() ? function (t, e, r, n, i, a) {
          var o,
              s,
              l,
              c = i.direction,
              u = "up" === c || "down" === c,
              h = i._dims,
              p = i.active;
          if (u) for (s = 0, l = 0; l < p; l++) {
            s += h.heights[l] + f.gapButton;
          } else for (o = 0, l = 0; l < p; l++) {
            o += h.widths[l] + f.gapButton;
          }
          n.enable(a, o, s), n.hbar && n.hbar.attr("opacity", "0").transition().attr("opacity", "1");
          n.vbar && n.vbar.attr("opacity", "0").transition().attr("opacity", "1");
        }(0, 0, 0, a, o, k) : function (t) {
          var e = !!t.hbar,
              r = !!t.vbar;
          e && t.hbar.transition().attr("opacity", "0").each("end", function () {
            e = !1, r || t.disable();
          });
          r && t.vbar.transition().attr("opacity", "0").each("end", function () {
            r = !1, e || t.disable();
          });
        }(a));
      }

      function y(t, e, r, n) {
        t.call(x, e).call(b, e, r, n);
      }

      function x(t, e) {
        s.ensureSingle(t, "rect", f.itemRectClassName, function (t) {
          t.attr({
            rx: f.rx,
            ry: f.ry,
            "shape-rendering": "crispEdges"
          });
        }).call(a.stroke, e.bordercolor).call(a.fill, e.bgcolor).style("stroke-width", e.borderwidth + "px");
      }

      function b(t, e, r, n) {
        var i = s.ensureSingle(t, "text", f.itemTextClassName, function (t) {
          t.attr({
            "text-anchor": "start",
            "data-notex": 1
          });
        }),
            a = r.label,
            c = n._fullLayout._meta;
        c && (a = s.templateString(a, c)), i.call(o.font, e.font).text(a).call(l.convertToTspans, n);
      }

      function _(t, e) {
        var r = e.active;
        t.each(function (t, i) {
          var o = n.select(this);
          i === r && e.showactive && o.select("rect." + f.itemRectClassName).call(a.fill, f.activeColor);
        });
      }

      function w(t) {
        t.select("rect." + f.itemRectClassName).call(a.fill, f.hoverColor);
      }

      function T(t, e) {
        t.select("rect." + f.itemRectClassName).call(a.fill, e.bgcolor);
      }

      function k(t, e) {
        var r = e._dims = {
          width1: 0,
          height1: 0,
          heights: [],
          widths: [],
          totalWidth: 0,
          totalHeight: 0,
          openWidth: 0,
          openHeight: 0,
          lx: 0,
          ly: 0
        },
            a = o.tester.selectAll("g." + f.dropdownButtonClassName).data(s.filterVisible(e.buttons));
        a.enter().append("g").classed(f.dropdownButtonClassName, !0);
        var c = -1 !== ["up", "down"].indexOf(e.direction);
        a.each(function (i, a) {
          var s = n.select(this);
          s.call(y, e, i, t);
          var h = s.select("." + f.itemTextClassName),
              p = h.node() && o.bBox(h.node()).width,
              d = Math.max(p + f.textPadX, f.minWidth),
              m = e.font.size * u,
              g = l.lineCount(h),
              v = Math.max(m * g, f.minHeight) + f.textOffsetY;
          v = Math.ceil(v), d = Math.ceil(d), r.widths[a] = d, r.heights[a] = v, r.height1 = Math.max(r.height1, v), r.width1 = Math.max(r.width1, d), c ? (r.totalWidth = Math.max(r.totalWidth, d), r.openWidth = r.totalWidth, r.totalHeight += v + f.gapButton, r.openHeight += v + f.gapButton) : (r.totalWidth += d + f.gapButton, r.openWidth += d + f.gapButton, r.totalHeight = Math.max(r.totalHeight, v), r.openHeight = r.totalHeight);
        }), c ? r.totalHeight -= f.gapButton : r.totalWidth -= f.gapButton, r.headerWidth = r.width1 + f.arrowPadX, r.headerHeight = r.height1, "dropdown" === e.type && (c ? (r.width1 += f.arrowPadX, r.totalHeight = r.height1) : r.totalWidth = r.width1, r.totalWidth += f.arrowPadX), a.remove();
        var h = r.totalWidth + e.pad.l + e.pad.r,
            p = r.totalHeight + e.pad.t + e.pad.b,
            d = t._fullLayout._size;
        r.lx = d.l + d.w * e.x, r.ly = d.t + d.h * (1 - e.y);
        var m = "left";
        s.isRightAnchor(e) && (r.lx -= h, m = "right"), s.isCenterAnchor(e) && (r.lx -= h / 2, m = "center");
        var g = "top";
        s.isBottomAnchor(e) && (r.ly -= p, g = "bottom"), s.isMiddleAnchor(e) && (r.ly -= p / 2, g = "middle"), r.totalWidth = Math.ceil(r.totalWidth), r.totalHeight = Math.ceil(r.totalHeight), r.lx = Math.round(r.lx), r.ly = Math.round(r.ly), i.autoMargin(t, M(e), {
          x: e.x,
          y: e.y,
          l: h * ({
            right: 1,
            center: .5
          }[m] || 0),
          r: h * ({
            left: 1,
            center: .5
          }[m] || 0),
          b: p * ({
            top: 1,
            middle: .5
          }[g] || 0),
          t: p * ({
            bottom: 1,
            middle: .5
          }[g] || 0)
        });
      }

      function M(t) {
        return f.autoMarginIdRoot + t._index;
      }

      function A(t, e, r, n) {
        n = n || {};
        var i = t.select("." + f.itemRectClassName),
            a = t.select("." + f.itemTextClassName),
            s = e.borderwidth,
            c = r.index,
            h = e._dims;
        o.setTranslate(t, s + r.x, s + r.y);
        var p = -1 !== ["up", "down"].indexOf(e.direction),
            d = n.height || (p ? h.heights[c] : h.height1);
        i.attr({
          x: 0,
          y: 0,
          width: n.width || (p ? h.width1 : h.widths[c]),
          height: d
        });
        var m = e.font.size * u,
            g = (l.lineCount(a) - 1) * m / 2;
        l.positionText(a, f.textOffsetX, d / 2 - g + f.textOffsetY), p ? r.y += h.heights[c] + r.yPad : r.x += h.widths[c] + r.xPad, r.index++;
      }

      function S(t, e) {
        t.attr(f.menuIndexAttrName, e || "-1").selectAll("g." + f.dropdownButtonClassName).remove();
      }

      e.exports = function (t) {
        var e = t._fullLayout,
            r = s.filterVisible(e[f.name]);

        function a(e) {
          i.autoMargin(t, M(e));
        }

        var o = e._menulayer.selectAll("g." + f.containerClassName).data(r.length > 0 ? [0] : []);

        if (o.enter().append("g").classed(f.containerClassName, !0).style("cursor", "pointer"), o.exit().each(function () {
          n.select(this).selectAll("g." + f.headerGroupClassName).each(a);
        }).remove(), 0 !== r.length) {
          var l = o.selectAll("g." + f.headerGroupClassName).data(r, p);
          l.enter().append("g").classed(f.headerGroupClassName, !0);

          for (var c = s.ensureSingle(o, "g", f.dropdownButtonGroupClassName, function (t) {
            t.style("pointer-events", "all");
          }), u = 0; u < r.length; u++) {
            var y = r[u];
            k(t, y);
          }

          var x = "updatemenus" + e._uid,
              b = new h(t, c, x);
          l.enter().size() && (c.node().parentNode.appendChild(c.node()), c.call(S)), l.exit().each(function (t) {
            c.call(S), a(t);
          }).remove(), l.each(function (e) {
            var r = n.select(this),
                a = "dropdown" === e.type ? c : null;
            i.manageCommandObserver(t, e, e.buttons, function (n) {
              m(t, e, e.buttons[n.index], r, a, b, n.index, !0);
            }), "dropdown" === e.type ? (g(t, r, c, b, e), d(c, e) && v(t, r, c, b, e)) : v(t, r, null, null, e);
          });
        }
      };
    }, {
      "../../constants/alignment": 763,
      "../../lib": 795,
      "../../lib/svg_text_utils": 820,
      "../../plot_api/plot_template": 834,
      "../../plots/plots": 909,
      "../color": 658,
      "../drawing": 680,
      "./constants": 758,
      "./scrollbox": 762,
      "@plotly/d3": 57
    }],
    761: [function (t, e, r) {
      arguments[4][755][0].apply(r, arguments);
    }, {
      "./attributes": 757,
      "./constants": 758,
      "./defaults": 759,
      "./draw": 760,
      dup: 755
    }],
    762: [function (t, e, r) {
      "use strict";

      e.exports = s;
      var n = t("@plotly/d3"),
          i = t("../color"),
          a = t("../drawing"),
          o = t("../../lib");

      function s(t, e, r) {
        this.gd = t, this.container = e, this.id = r, this.position = null, this.translateX = null, this.translateY = null, this.hbar = null, this.vbar = null, this.bg = this.container.selectAll("rect.scrollbox-bg").data([0]), this.bg.exit().on(".drag", null).on("wheel", null).remove(), this.bg.enter().append("rect").classed("scrollbox-bg", !0).style("pointer-events", "all").attr({
          opacity: 0,
          x: 0,
          y: 0,
          width: 0,
          height: 0
        });
      }

      s.barWidth = 2, s.barLength = 20, s.barRadius = 2, s.barPad = 1, s.barColor = "#808BA4", s.prototype.enable = function (t, e, r) {
        var o = this.gd._fullLayout,
            l = o.width,
            c = o.height;
        this.position = t;

        var u,
            f,
            h,
            p,
            d = this.position.l,
            m = this.position.w,
            g = this.position.t,
            v = this.position.h,
            y = this.position.direction,
            x = "down" === y,
            b = "left" === y,
            _ = "up" === y,
            w = m,
            T = v;

        x || b || "right" === y || _ || (this.position.direction = "down", x = !0), x || _ ? (f = (u = d) + w, x ? (h = g, T = (p = Math.min(h + T, c)) - h) : T = (p = g + T) - (h = Math.max(p - T, 0))) : (p = (h = g) + T, b ? w = (f = d + w) - (u = Math.max(f - w, 0)) : (u = d, w = (f = Math.min(u + w, l)) - u)), this._box = {
          l: u,
          t: h,
          w: w,
          h: T
        };
        var k = m > w,
            M = s.barLength + 2 * s.barPad,
            A = s.barWidth + 2 * s.barPad,
            S = d,
            E = g + v;
        E + A > c && (E = c - A);
        var L = this.container.selectAll("rect.scrollbar-horizontal").data(k ? [0] : []);
        L.exit().on(".drag", null).remove(), L.enter().append("rect").classed("scrollbar-horizontal", !0).call(i.fill, s.barColor), k ? (this.hbar = L.attr({
          rx: s.barRadius,
          ry: s.barRadius,
          x: S,
          y: E,
          width: M,
          height: A
        }), this._hbarXMin = S + M / 2, this._hbarTranslateMax = w - M) : (delete this.hbar, delete this._hbarXMin, delete this._hbarTranslateMax);
        var C = v > T,
            P = s.barWidth + 2 * s.barPad,
            I = s.barLength + 2 * s.barPad,
            O = d + m,
            z = g;
        O + P > l && (O = l - P);
        var D = this.container.selectAll("rect.scrollbar-vertical").data(C ? [0] : []);
        D.exit().on(".drag", null).remove(), D.enter().append("rect").classed("scrollbar-vertical", !0).call(i.fill, s.barColor), C ? (this.vbar = D.attr({
          rx: s.barRadius,
          ry: s.barRadius,
          x: O,
          y: z,
          width: P,
          height: I
        }), this._vbarYMin = z + I / 2, this._vbarTranslateMax = T - I) : (delete this.vbar, delete this._vbarYMin, delete this._vbarTranslateMax);

        var R = this.id,
            F = u - .5,
            B = C ? f + P + .5 : f + .5,
            N = h - .5,
            j = k ? p + A + .5 : p + .5,
            U = o._topdefs.selectAll("#" + R).data(k || C ? [0] : []);

        if (U.exit().remove(), U.enter().append("clipPath").attr("id", R).append("rect"), k || C ? (this._clipRect = U.select("rect").attr({
          x: Math.floor(F),
          y: Math.floor(N),
          width: Math.ceil(B) - Math.floor(F),
          height: Math.ceil(j) - Math.floor(N)
        }), this.container.call(a.setClipUrl, R, this.gd), this.bg.attr({
          x: d,
          y: g,
          width: m,
          height: v
        })) : (this.bg.attr({
          width: 0,
          height: 0
        }), this.container.on("wheel", null).on(".drag", null).call(a.setClipUrl, null), delete this._clipRect), k || C) {
          var V = n.behavior.drag().on("dragstart", function () {
            n.event.sourceEvent.preventDefault();
          }).on("drag", this._onBoxDrag.bind(this));
          this.container.on("wheel", null).on("wheel", this._onBoxWheel.bind(this)).on(".drag", null).call(V);
          var q = n.behavior.drag().on("dragstart", function () {
            n.event.sourceEvent.preventDefault(), n.event.sourceEvent.stopPropagation();
          }).on("drag", this._onBarDrag.bind(this));
          k && this.hbar.on(".drag", null).call(q), C && this.vbar.on(".drag", null).call(q);
        }

        this.setTranslate(e, r);
      }, s.prototype.disable = function () {
        (this.hbar || this.vbar) && (this.bg.attr({
          width: 0,
          height: 0
        }), this.container.on("wheel", null).on(".drag", null).call(a.setClipUrl, null), delete this._clipRect), this.hbar && (this.hbar.on(".drag", null), this.hbar.remove(), delete this.hbar, delete this._hbarXMin, delete this._hbarTranslateMax), this.vbar && (this.vbar.on(".drag", null), this.vbar.remove(), delete this.vbar, delete this._vbarYMin, delete this._vbarTranslateMax);
      }, s.prototype._onBoxDrag = function () {
        var t = this.translateX,
            e = this.translateY;
        this.hbar && (t -= n.event.dx), this.vbar && (e -= n.event.dy), this.setTranslate(t, e);
      }, s.prototype._onBoxWheel = function () {
        var t = this.translateX,
            e = this.translateY;
        this.hbar && (t += n.event.deltaY), this.vbar && (e += n.event.deltaY), this.setTranslate(t, e);
      }, s.prototype._onBarDrag = function () {
        var t = this.translateX,
            e = this.translateY;

        if (this.hbar) {
          var r = t + this._hbarXMin,
              i = r + this._hbarTranslateMax;
          t = (o.constrain(n.event.x, r, i) - r) / (i - r) * (this.position.w - this._box.w);
        }

        if (this.vbar) {
          var a = e + this._vbarYMin,
              s = a + this._vbarTranslateMax;
          e = (o.constrain(n.event.y, a, s) - a) / (s - a) * (this.position.h - this._box.h);
        }

        this.setTranslate(t, e);
      }, s.prototype.setTranslate = function (t, e) {
        var r = this.position.w - this._box.w,
            n = this.position.h - this._box.h;

        if (t = o.constrain(t || 0, 0, r), e = o.constrain(e || 0, 0, n), this.translateX = t, this.translateY = e, this.container.call(a.setTranslate, this._box.l - this.position.l - t, this._box.t - this.position.t - e), this._clipRect && this._clipRect.attr({
          x: Math.floor(this.position.l + t - .5),
          y: Math.floor(this.position.t + e - .5)
        }), this.hbar) {
          var i = t / r;
          this.hbar.call(a.setTranslate, t + i * this._hbarTranslateMax, e);
        }

        if (this.vbar) {
          var s = e / n;
          this.vbar.call(a.setTranslate, t, e + s * this._vbarTranslateMax);
        }
      };
    }, {
      "../../lib": 795,
      "../color": 658,
      "../drawing": 680,
      "@plotly/d3": 57
    }],
    763: [function (t, e, r) {
      "use strict";

      e.exports = {
        FROM_BL: {
          left: 0,
          center: .5,
          right: 1,
          bottom: 0,
          middle: .5,
          top: 1
        },
        FROM_TL: {
          left: 0,
          center: .5,
          right: 1,
          bottom: 1,
          middle: .5,
          top: 0
        },
        FROM_BR: {
          left: 1,
          center: .5,
          right: 0,
          bottom: 0,
          middle: .5,
          top: 1
        },
        LINE_SPACING: 1.3,
        CAP_SHIFT: .7,
        MID_SHIFT: .35,
        OPPOSITE_SIDE: {
          left: "right",
          right: "left",
          top: "bottom",
          bottom: "top"
        }
      };
    }, {}],
    764: [function (t, e, r) {
      "use strict";

      e.exports = {
        axisRefDescription: function axisRefDescription(t, e, r) {
          return ["If set to a", t, "axis id (e.g. *" + t + "* or", "*" + t + "2*), the `" + t + "` position refers to a", t, "coordinate. If set to *paper*, the `" + t + "`", "position refers to the distance from the", e, "of the plotting", "area in normalized coordinates where *0* (*1*) corresponds to the", e, "(" + r + "). If set to a", t, "axis ID followed by", "*domain* (separated by a space), the position behaves like for", "*paper*, but refers to the distance in fractions of the domain", "length from the", e, "of the domain of that axis: e.g.,", "*" + t + "2 domain* refers to the domain of the second", t, " axis and a", t, "position of 0.5 refers to the", "point between the", e, "and the", r, "of the domain of the", "second", t, "axis."].join(" ");
        }
      };
    }, {}],
    765: [function (t, e, r) {
      "use strict";

      e.exports = {
        INCREASING: {
          COLOR: "#3D9970",
          SYMBOL: "\u25B2"
        },
        DECREASING: {
          COLOR: "#FF4136",
          SYMBOL: "\u25BC"
        }
      };
    }, {}],
    766: [function (t, e, r) {
      "use strict";

      e.exports = {
        FORMAT_LINK: "https://github.com/d3/d3-3.x-api-reference/blob/master/Formatting.md#d3_format",
        DATE_FORMAT_LINK: "https://github.com/d3/d3-time-format#locale_format"
      };
    }, {}],
    767: [function (t, e, r) {
      "use strict";

      e.exports = {
        COMPARISON_OPS: ["=", "!=", "<", ">=", ">", "<="],
        COMPARISON_OPS2: ["=", "<", ">=", ">", "<="],
        INTERVAL_OPS: ["[]", "()", "[)", "(]", "][", ")(", "](", ")["],
        SET_OPS: ["{}", "}{"],
        CONSTRAINT_REDUCTION: {
          "=": "=",
          "<": "<",
          "<=": "<",
          ">": ">",
          ">=": ">",
          "[]": "[]",
          "()": "[]",
          "[)": "[]",
          "(]": "[]",
          "][": "][",
          ")(": "][",
          "](": "][",
          ")[": "]["
        }
      };
    }, {}],
    768: [function (t, e, r) {
      "use strict";

      e.exports = {
        solid: [[], 0],
        dot: [[.5, 1], 200],
        dash: [[.5, 1], 50],
        longdash: [[.5, 1], 10],
        dashdot: [[.5, .625, .875, 1], 50],
        longdashdot: [[.5, .7, .8, 1], 10]
      };
    }, {}],
    769: [function (t, e, r) {
      "use strict";

      e.exports = {
        circle: "\u25CF",
        "circle-open": "\u25CB",
        square: "\u25A0",
        "square-open": "\u25A1",
        diamond: "\u25C6",
        "diamond-open": "\u25C7",
        cross: "+",
        x: "\u274C"
      };
    }, {}],
    770: [function (t, e, r) {
      "use strict";

      e.exports = {
        SHOW_PLACEHOLDER: 100,
        HIDE_PLACEHOLDER: 1e3,
        DESELECTDIM: .2
      };
    }, {}],
    771: [function (t, e, r) {
      "use strict";

      e.exports = {
        BADNUM: void 0,
        FP_SAFE: 1e-4 * Number.MAX_VALUE,
        ONEMAXYEAR: 316224e5,
        ONEAVGYEAR: 315576e5,
        ONEMINYEAR: 31536e6,
        ONEMAXQUARTER: 79488e5,
        ONEAVGQUARTER: 78894e5,
        ONEMINQUARTER: 76896e5,
        ONEMAXMONTH: 26784e5,
        ONEAVGMONTH: 26298e5,
        ONEMINMONTH: 24192e5,
        ONEWEEK: 6048e5,
        ONEDAY: 864e5,
        ONEHOUR: 36e5,
        ONEMIN: 6e4,
        ONESEC: 1e3,
        EPOCHJD: 2440587.5,
        ALMOST_EQUAL: .999999,
        LOG_CLIP: 10,
        MINUS_SIGN: "\u2212"
      };
    }, {}],
    772: [function (t, e, r) {
      "use strict";

      r.xmlns = "http://www.w3.org/2000/xmlns/", r.svg = "http://www.w3.org/2000/svg", r.xlink = "http://www.w3.org/1999/xlink", r.svgAttrs = {
        xmlns: r.svg,
        "xmlns:xlink": r.xlink
      };
    }, {}],
    773: [function (t, e, r) {
      "use strict";

      r.version = t("./version").version, t("native-promise-only"), t("../build/plotcss");

      for (var n = t("./registry"), i = r.register = n.register, a = t("./plot_api"), o = Object.keys(a), s = 0; s < o.length; s++) {
        var l = o[s];
        "_" !== l.charAt(0) && (r[l] = a[l]), i({
          moduleType: "apiMethod",
          name: l,
          fn: a[l]
        });
      }

      i(t("./traces/scatter")), i([t("./components/legend"), t("./components/fx"), t("./components/annotations"), t("./components/annotations3d"), t("./components/shapes"), t("./components/images"), t("./components/updatemenus"), t("./components/sliders"), t("./components/rangeslider"), t("./components/rangeselector"), t("./components/grid"), t("./components/errorbars"), t("./components/colorscale"), t("./components/colorbar"), t("./components/modebar")]), i([t("./locale-en"), t("./locale-en-us")]), window.PlotlyLocales && Array.isArray(window.PlotlyLocales) && (i(window.PlotlyLocales), delete window.PlotlyLocales), r.Icons = t("./fonts/ploticon");
      var c = t("./components/fx"),
          u = t("./plots/plots");
      r.Plots = {
        resize: u.resize,
        graphJson: u.graphJson,
        sendDataToCloud: u.sendDataToCloud
      }, r.Fx = {
        hover: c.hover,
        unhover: c.unhover,
        loneHover: c.loneHover,
        loneUnhover: c.loneUnhover
      }, r.Snapshot = t("./snapshot"), r.PlotSchema = t("./plot_api/plot_schema");
    }, {
      "../build/plotcss": 1,
      "./components/annotations": 649,
      "./components/annotations3d": 654,
      "./components/colorbar": 664,
      "./components/colorscale": 670,
      "./components/errorbars": 686,
      "./components/fx": 698,
      "./components/grid": 702,
      "./components/images": 707,
      "./components/legend": 715,
      "./components/modebar": 721,
      "./components/rangeselector": 729,
      "./components/rangeslider": 736,
      "./components/shapes": 750,
      "./components/sliders": 755,
      "./components/updatemenus": 761,
      "./fonts/ploticon": 774,
      "./locale-en": 825,
      "./locale-en-us": 824,
      "./plot_api": 829,
      "./plot_api/plot_schema": 833,
      "./plots/plots": 909,
      "./registry": 923,
      "./snapshot": 928,
      "./traces/scatter": 1211,
      "./version": 1382,
      "native-promise-only": 466
    }],
    774: [function (t, e, r) {
      "use strict";

      e.exports = {
        undo: {
          width: 857.1,
          height: 1e3,
          path: "m857 350q0-87-34-166t-91-137-137-92-166-34q-96 0-183 41t-147 114q-4 6-4 13t5 11l76 77q6 5 14 5 9-1 13-7 41-53 100-82t126-29q58 0 110 23t92 61 61 91 22 111-22 111-61 91-92 61-110 23q-55 0-105-20t-90-57l77-77q17-16 8-38-10-23-33-23h-250q-15 0-25 11t-11 25v250q0 24 22 33 22 10 39-8l72-72q60 57 137 88t159 31q87 0 166-34t137-92 91-137 34-166z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        home: {
          width: 928.6,
          height: 1e3,
          path: "m786 296v-267q0-15-11-26t-25-10h-214v214h-143v-214h-214q-15 0-25 10t-11 26v267q0 1 0 2t0 2l321 264 321-264q1-1 1-4z m124 39l-34-41q-5-5-12-6h-2q-7 0-12 3l-386 322-386-322q-7-4-13-4-7 2-12 7l-35 41q-4 5-3 13t6 12l401 334q18 15 42 15t43-15l136-114v109q0 8 5 13t13 5h107q8 0 13-5t5-13v-227l122-102q5-5 6-12t-4-13z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        "camera-retro": {
          width: 1e3,
          height: 1e3,
          path: "m518 386q0 8-5 13t-13 5q-37 0-63-27t-26-63q0-8 5-13t13-5 12 5 5 13q0 23 16 38t38 16q8 0 13 5t5 13z m125-73q0-59-42-101t-101-42-101 42-42 101 42 101 101 42 101-42 42-101z m-572-320h858v71h-858v-71z m643 320q0 89-62 152t-152 62-151-62-63-152 63-151 151-63 152 63 62 151z m-571 358h214v72h-214v-72z m-72-107h858v143h-462l-36-71h-360v-72z m929 143v-714q0-30-21-51t-50-21h-858q-29 0-50 21t-21 51v714q0 30 21 51t50 21h858q29 0 50-21t21-51z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        zoombox: {
          width: 1e3,
          height: 1e3,
          path: "m1000-25l-250 251c40 63 63 138 63 218 0 224-182 406-407 406-224 0-406-182-406-406s183-406 407-406c80 0 155 22 218 62l250-250 125 125z m-812 250l0 438 437 0 0-438-437 0z m62 375l313 0 0-312-313 0 0 312z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        pan: {
          width: 1e3,
          height: 1e3,
          path: "m1000 350l-187 188 0-125-250 0 0 250 125 0-188 187-187-187 125 0 0-250-250 0 0 125-188-188 186-187 0 125 252 0 0-250-125 0 187-188 188 188-125 0 0 250 250 0 0-126 187 188z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        zoom_plus: {
          width: 875,
          height: 1e3,
          path: "m1 787l0-875 875 0 0 875-875 0z m687-500l-187 0 0-187-125 0 0 187-188 0 0 125 188 0 0 187 125 0 0-187 187 0 0-125z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        zoom_minus: {
          width: 875,
          height: 1e3,
          path: "m0 788l0-876 875 0 0 876-875 0z m688-500l-500 0 0 125 500 0 0-125z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        autoscale: {
          width: 1e3,
          height: 1e3,
          path: "m250 850l-187 0-63 0 0-62 0-188 63 0 0 188 187 0 0 62z m688 0l-188 0 0-62 188 0 0-188 62 0 0 188 0 62-62 0z m-875-938l0 188-63 0 0-188 0-62 63 0 187 0 0 62-187 0z m875 188l0-188-188 0 0-62 188 0 62 0 0 62 0 188-62 0z m-125 188l-1 0-93-94-156 156 156 156 92-93 2 0 0 250-250 0 0-2 93-92-156-156-156 156 94 92 0 2-250 0 0-250 0 0 93 93 157-156-157-156-93 94 0 0 0-250 250 0 0 0-94 93 156 157 156-157-93-93 0 0 250 0 0 250z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        tooltip_basic: {
          width: 1500,
          height: 1e3,
          path: "m375 725l0 0-375-375 375-374 0-1 1125 0 0 750-1125 0z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        tooltip_compare: {
          width: 1125,
          height: 1e3,
          path: "m187 786l0 2-187-188 188-187 0 0 937 0 0 373-938 0z m0-499l0 1-187-188 188-188 0 0 937 0 0 376-938-1z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        plotlylogo: {
          width: 1542,
          height: 1e3,
          path: "m0-10h182v-140h-182v140z m228 146h183v-286h-183v286z m225 714h182v-1000h-182v1000z m225-285h182v-715h-182v715z m225 142h183v-857h-183v857z m231-428h182v-429h-182v429z m225-291h183v-138h-183v138z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        "z-axis": {
          width: 1e3,
          height: 1e3,
          path: "m833 5l-17 108v41l-130-65 130-66c0 0 0 38 0 39 0-1 36-14 39-25 4-15-6-22-16-30-15-12-39-16-56-20-90-22-187-23-279-23-261 0-341 34-353 59 3 60 228 110 228 110-140-8-351-35-351-116 0-120 293-142 474-142 155 0 477 22 477 142 0 50-74 79-163 96z m-374 94c-58-5-99-21-99-40 0-24 65-43 144-43 79 0 143 19 143 43 0 19-42 34-98 40v216h87l-132 135-133-135h88v-216z m167 515h-136v1c16 16 31 34 46 52l84 109v54h-230v-71h124v-1c-16-17-28-32-44-51l-89-114v-51h245v72z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        "3d_rotate": {
          width: 1e3,
          height: 1e3,
          path: "m922 660c-5 4-9 7-14 11-359 263-580-31-580-31l-102 28 58-400c0 1 1 1 2 2 118 108 351 249 351 249s-62 27-100 42c88 83 222 183 347 122 16-8 30-17 44-27-2 1-4 2-6 4z m36-329c0 0 64 229-88 296-62 27-124 14-175-11 157-78 225-208 249-266 8-19 11-31 11-31 2 5 6 15 11 32-5-13-8-20-8-20z m-775-239c70-31 117-50 198-32-121 80-199 346-199 346l-96-15-58-12c0 0 55-226 155-287z m603 133l-317-139c0 0 4-4 19-14 7-5 24-15 24-15s-177-147-389 4c235-287 536-112 536-112l31-22 100 299-4-1z m-298-153c6-4 14-9 24-15 0 0-17 10-24 15z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        camera: {
          width: 1e3,
          height: 1e3,
          path: "m500 450c-83 0-150-67-150-150 0-83 67-150 150-150 83 0 150 67 150 150 0 83-67 150-150 150z m400 150h-120c-16 0-34 13-39 29l-31 93c-6 15-23 28-40 28h-340c-16 0-34-13-39-28l-31-94c-6-15-23-28-40-28h-120c-55 0-100-45-100-100v-450c0-55 45-100 100-100h800c55 0 100 45 100 100v450c0 55-45 100-100 100z m-400-550c-138 0-250 112-250 250 0 138 112 250 250 250 138 0 250-112 250-250 0-138-112-250-250-250z m365 380c-19 0-35 16-35 35 0 19 16 35 35 35 19 0 35-16 35-35 0-19-16-35-35-35z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        movie: {
          width: 1e3,
          height: 1e3,
          path: "m938 413l-188-125c0 37-17 71-44 94 64 38 107 107 107 187 0 121-98 219-219 219-121 0-219-98-219-219 0-61 25-117 66-156h-115c30 33 49 76 49 125 0 103-84 187-187 187s-188-84-188-187c0-57 26-107 65-141-38-22-65-62-65-109v-250c0-70 56-126 125-126h500c69 0 125 56 125 126l188-126c34 0 62 28 62 63v375c0 35-28 63-62 63z m-750 0c-69 0-125 56-125 125s56 125 125 125 125-56 125-125-56-125-125-125z m406-1c-87 0-157 70-157 157 0 86 70 156 157 156s156-70 156-156-70-157-156-157z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        question: {
          width: 857.1,
          height: 1e3,
          path: "m500 82v107q0 8-5 13t-13 5h-107q-8 0-13-5t-5-13v-107q0-8 5-13t13-5h107q8 0 13 5t5 13z m143 375q0 49-31 91t-77 65-95 23q-136 0-207-119-9-14 4-24l74-55q4-4 10-4 9 0 14 7 30 38 48 51 19 14 48 14 27 0 48-15t21-33q0-21-11-34t-38-25q-35-16-65-48t-29-70v-20q0-8 5-13t13-5h107q8 0 13 5t5 13q0 10 12 27t30 28q18 10 28 16t25 19 25 27 16 34 7 45z m214-107q0-117-57-215t-156-156-215-58-216 58-155 156-58 215 58 215 155 156 216 58 215-58 156-156 57-215z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        disk: {
          width: 857.1,
          height: 1e3,
          path: "m214-7h429v214h-429v-214z m500 0h72v500q0 8-6 21t-11 20l-157 156q-5 6-19 12t-22 5v-232q0-22-15-38t-38-16h-322q-22 0-37 16t-16 38v232h-72v-714h72v232q0 22 16 38t37 16h465q22 0 38-16t15-38v-232z m-214 518v178q0 8-5 13t-13 5h-107q-7 0-13-5t-5-13v-178q0-8 5-13t13-5h107q7 0 13 5t5 13z m357-18v-518q0-22-15-38t-38-16h-750q-23 0-38 16t-16 38v750q0 22 16 38t38 16h517q23 0 50-12t42-26l156-157q16-15 27-42t11-49z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        drawopenpath: {
          width: 70,
          height: 70,
          path: "M33.21,85.65a7.31,7.31,0,0,1-2.59-.48c-8.16-3.11-9.27-19.8-9.88-41.3-.1-3.58-.19-6.68-.35-9-.15-2.1-.67-3.48-1.43-3.79-2.13-.88-7.91,2.32-12,5.86L3,32.38c1.87-1.64,11.55-9.66,18.27-6.9,2.13.87,4.75,3.14,5.17,9,.17,2.43.26,5.59.36,9.25a224.17,224.17,0,0,0,1.5,23.4c1.54,10.76,4,12.22,4.48,12.4.84.32,2.79-.46,5.76-3.59L43,80.07C41.53,81.57,37.68,85.64,33.21,85.65ZM74.81,69a11.34,11.34,0,0,0,6.09-6.72L87.26,44.5,74.72,32,56.9,38.35c-2.37.86-5.57,3.42-6.61,6L38.65,72.14l8.42,8.43ZM55,46.27a7.91,7.91,0,0,1,3.64-3.17l14.8-5.3,8,8L76.11,60.6l-.06.19a6.37,6.37,0,0,1-3,3.43L48.25,74.59,44.62,71Zm16.57,7.82A6.9,6.9,0,1,0,64.64,61,6.91,6.91,0,0,0,71.54,54.09Zm-4.05,0a2.85,2.85,0,1,1-2.85-2.85A2.86,2.86,0,0,1,67.49,54.09Zm-4.13,5.22L60.5,56.45,44.26,72.7l2.86,2.86ZM97.83,35.67,84.14,22l-8.57,8.57L89.26,44.24Zm-13.69-8,8,8-2.85,2.85-8-8Z",
          transform: "matrix(1 0 0 1 -15 -15)"
        },
        drawclosedpath: {
          width: 90,
          height: 90,
          path: "M88.41,21.12a26.56,26.56,0,0,0-36.18,0l-2.07,2-2.07-2a26.57,26.57,0,0,0-36.18,0,23.74,23.74,0,0,0,0,34.8L48,90.12a3.22,3.22,0,0,0,4.42,0l36-34.21a23.73,23.73,0,0,0,0-34.79ZM84,51.24,50.16,83.35,16.35,51.25a17.28,17.28,0,0,1,0-25.47,20,20,0,0,1,27.3,0l4.29,4.07a3.23,3.23,0,0,0,4.44,0l4.29-4.07a20,20,0,0,1,27.3,0,17.27,17.27,0,0,1,0,25.46ZM66.76,47.68h-33v6.91h33ZM53.35,35H46.44V68h6.91Z",
          transform: "matrix(1 0 0 1 -5 -5)"
        },
        lasso: {
          width: 1031,
          height: 1e3,
          path: "m1018 538c-36 207-290 336-568 286-277-48-473-256-436-463 10-57 36-108 76-151-13-66 11-137 68-183 34-28 75-41 114-42l-55-70 0 0c-2-1-3-2-4-3-10-14-8-34 5-45 14-11 34-8 45 4 1 1 2 3 2 5l0 0 113 140c16 11 31 24 45 40 4 3 6 7 8 11 48-3 100 0 151 9 278 48 473 255 436 462z m-624-379c-80 14-149 48-197 96 42 42 109 47 156 9 33-26 47-66 41-105z m-187-74c-19 16-33 37-39 60 50-32 109-55 174-68-42-25-95-24-135 8z m360 75c-34-7-69-9-102-8 8 62-16 128-68 170-73 59-175 54-244-5-9 20-16 40-20 61-28 159 121 317 333 354s407-60 434-217c28-159-121-318-333-355z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        selectbox: {
          width: 1e3,
          height: 1e3,
          path: "m0 850l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-285l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        drawline: {
          width: 70,
          height: 70,
          path: "M60.64,62.3a11.29,11.29,0,0,0,6.09-6.72l6.35-17.72L60.54,25.31l-17.82,6.4c-2.36.86-5.57,3.41-6.6,6L24.48,65.5l8.42,8.42ZM40.79,39.63a7.89,7.89,0,0,1,3.65-3.17l14.79-5.31,8,8L61.94,54l-.06.19a6.44,6.44,0,0,1-3,3.43L34.07,68l-3.62-3.63Zm16.57,7.81a6.9,6.9,0,1,0-6.89,6.9A6.9,6.9,0,0,0,57.36,47.44Zm-4,0a2.86,2.86,0,1,1-2.85-2.85A2.86,2.86,0,0,1,53.32,47.44Zm-4.13,5.22L46.33,49.8,30.08,66.05l2.86,2.86ZM83.65,29,70,15.34,61.4,23.9,75.09,37.59ZM70,21.06l8,8-2.84,2.85-8-8ZM87,80.49H10.67V87H87Z",
          transform: "matrix(1 0 0 1 -15 -15)"
        },
        drawrect: {
          width: 80,
          height: 80,
          path: "M78,22V79H21V22H78m9-9H12V88H87V13ZM68,46.22H31V54H68ZM53,32H45.22V69H53Z",
          transform: "matrix(1 0 0 1 -10 -10)"
        },
        drawcircle: {
          width: 80,
          height: 80,
          path: "M50,84.72C26.84,84.72,8,69.28,8,50.3S26.84,15.87,50,15.87,92,31.31,92,50.3,73.16,84.72,50,84.72Zm0-60.59c-18.6,0-33.74,11.74-33.74,26.17S31.4,76.46,50,76.46,83.74,64.72,83.74,50.3,68.6,24.13,50,24.13Zm17.15,22h-34v7.11h34Zm-13.8-13H46.24v34h7.11Z",
          transform: "matrix(1 0 0 1 -10 -10)"
        },
        eraseshape: {
          width: 80,
          height: 80,
          path: "M82.77,78H31.85L6,49.57,31.85,21.14H82.77a8.72,8.72,0,0,1,8.65,8.77V69.24A8.72,8.72,0,0,1,82.77,78ZM35.46,69.84H82.77a.57.57,0,0,0,.49-.6V29.91a.57.57,0,0,0-.49-.61H35.46L17,49.57Zm32.68-34.7-24,24,5,5,24-24Zm-19,.53-5,5,24,24,5-5Z",
          transform: "matrix(1 0 0 1 -10 -10)"
        },
        spikeline: {
          width: 1e3,
          height: 1e3,
          path: "M512 409c0-57-46-104-103-104-57 0-104 47-104 104 0 57 47 103 104 103 57 0 103-46 103-103z m-327-39l92 0 0 92-92 0z m-185 0l92 0 0 92-92 0z m370-186l92 0 0 93-92 0z m0-184l92 0 0 92-92 0z",
          transform: "matrix(1.5 0 0 -1.5 0 850)"
        },
        pencil: {
          width: 1792,
          height: 1792,
          path: "M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z",
          transform: "matrix(1 0 0 1 0 1)"
        },
        newplotlylogo: {
          name: "newplotlylogo",
          svg: "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 132 132'><defs><style>.cls-1 {fill: #3f4f75;} .cls-2 {fill: #80cfbe;} .cls-3 {fill: #fff;}</style></defs><title>plotly-logomark</title><g id='symbol'><rect class='cls-1' width='132' height='132' rx='6' ry='6'/><circle class='cls-2' cx='78' cy='54' r='6'/><circle class='cls-2' cx='102' cy='30' r='6'/><circle class='cls-2' cx='78' cy='30' r='6'/><circle class='cls-2' cx='54' cy='30' r='6'/><circle class='cls-2' cx='30' cy='30' r='6'/><circle class='cls-2' cx='30' cy='54' r='6'/><path class='cls-3' d='M30,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,30,72Z'/><path class='cls-3' d='M78,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,78,72Z'/><path class='cls-3' d='M54,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,54,48Z'/><path class='cls-3' d='M102,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,102,48Z'/></g></svg>"
        }
      };
    }, {}],
    775: [function (t, e, r) {
      "use strict";

      r.isLeftAnchor = function (t) {
        return "left" === t.xanchor || "auto" === t.xanchor && t.x <= 1 / 3;
      }, r.isCenterAnchor = function (t) {
        return "center" === t.xanchor || "auto" === t.xanchor && t.x > 1 / 3 && t.x < 2 / 3;
      }, r.isRightAnchor = function (t) {
        return "right" === t.xanchor || "auto" === t.xanchor && t.x >= 2 / 3;
      }, r.isTopAnchor = function (t) {
        return "top" === t.yanchor || "auto" === t.yanchor && t.y >= 2 / 3;
      }, r.isMiddleAnchor = function (t) {
        return "middle" === t.yanchor || "auto" === t.yanchor && t.y > 1 / 3 && t.y < 2 / 3;
      }, r.isBottomAnchor = function (t) {
        return "bottom" === t.yanchor || "auto" === t.yanchor && t.y <= 1 / 3;
      };
    }, {}],
    776: [function (t, e, r) {
      "use strict";

      var n = t("./mod"),
          i = n.mod,
          a = n.modHalf,
          o = Math.PI,
          s = 2 * o;

      function l(t) {
        return Math.abs(t[1] - t[0]) > s - 1e-14;
      }

      function c(t, e) {
        return a(e - t, s);
      }

      function u(t, e) {
        if (l(e)) return !0;
        var r, n;
        e[0] < e[1] ? (r = e[0], n = e[1]) : (r = e[1], n = e[0]), (r = i(r, s)) > (n = i(n, s)) && (n += s);
        var a = i(t, s),
            o = a + s;
        return a >= r && a <= n || o >= r && o <= n;
      }

      function f(t, e, r, n, i, a, c) {
        i = i || 0, a = a || 0;
        var u,
            f,
            h,
            p,
            d,
            m = l([r, n]);

        function g(t, e) {
          return [t * Math.cos(e) + i, a - t * Math.sin(e)];
        }

        m ? (u = 0, f = o, h = s) : r < n ? (u = r, h = n) : (u = n, h = r), t < e ? (p = t, d = e) : (p = e, d = t);
        var v,
            y = Math.abs(h - u) <= o ? 0 : 1;

        function x(t, e, r) {
          return "A" + [t, t] + " " + [0, y, r] + " " + g(t, e);
        }

        return m ? v = null === p ? "M" + g(d, u) + x(d, f, 0) + x(d, h, 0) + "Z" : "M" + g(p, u) + x(p, f, 0) + x(p, h, 0) + "ZM" + g(d, u) + x(d, f, 1) + x(d, h, 1) + "Z" : null === p ? (v = "M" + g(d, u) + x(d, h, 0), c && (v += "L0,0Z")) : v = "M" + g(p, u) + "L" + g(d, u) + x(d, h, 0) + "L" + g(p, h) + x(p, u, 1) + "Z", v;
      }

      e.exports = {
        deg2rad: function deg2rad(t) {
          return t / 180 * o;
        },
        rad2deg: function rad2deg(t) {
          return t / o * 180;
        },
        angleDelta: c,
        angleDist: function angleDist(t, e) {
          return Math.abs(c(t, e));
        },
        isFullCircle: l,
        isAngleInsideSector: u,
        isPtInsideSector: function isPtInsideSector(t, e, r, n) {
          return !!u(e, n) && (r[0] < r[1] ? (i = r[0], a = r[1]) : (i = r[1], a = r[0]), t >= i && t <= a);
          var i, a;
        },
        pathArc: function pathArc(t, e, r, n, i) {
          return f(null, t, e, r, n, i, 0);
        },
        pathSector: function pathSector(t, e, r, n, i) {
          return f(null, t, e, r, n, i, 1);
        },
        pathAnnulus: function pathAnnulus(t, e, r, n, i, a) {
          return f(t, e, r, n, i, a, 1);
        }
      };
    }, {
      "./mod": 802
    }],
    777: [function (t, e, r) {
      "use strict";

      var n = Array.isArray,
          i = ArrayBuffer,
          a = DataView;

      function o(t) {
        return i.isView(t) && !(t instanceof a);
      }

      function s(t) {
        return n(t) || o(t);
      }

      function l(t, e, r) {
        if (s(t)) {
          if (s(t[0])) {
            for (var n = r, i = 0; i < t.length; i++) {
              n = e(n, t[i].length);
            }

            return n;
          }

          return t.length;
        }

        return 0;
      }

      r.isTypedArray = o, r.isArrayOrTypedArray = s, r.isArray1D = function (t) {
        return !s(t[0]);
      }, r.ensureArray = function (t, e) {
        return n(t) || (t = []), t.length = e, t;
      }, r.concat = function () {
        var t,
            e,
            r,
            i,
            a,
            o,
            s,
            l,
            c = [],
            u = !0,
            f = 0;

        for (r = 0; r < arguments.length; r++) {
          (o = (i = arguments[r]).length) && (e ? c.push(i) : (e = i, a = o), n(i) ? t = !1 : (u = !1, f ? t !== i.constructor && (t = !1) : t = i.constructor), f += o);
        }

        if (!f) return [];
        if (!c.length) return e;
        if (u) return e.concat.apply(e, c);

        if (t) {
          for ((s = new t(f)).set(e), r = 0; r < c.length; r++) {
            i = c[r], s.set(i, a), a += i.length;
          }

          return s;
        }

        for (s = new Array(f), l = 0; l < e.length; l++) {
          s[l] = e[l];
        }

        for (r = 0; r < c.length; r++) {
          for (i = c[r], l = 0; l < i.length; l++) {
            s[a + l] = i[l];
          }

          a += l;
        }

        return s;
      }, r.maxRowLength = function (t) {
        return l(t, Math.max, 0);
      }, r.minRowLength = function (t) {
        return l(t, Math.min, 1 / 0);
      };
    }, {}],
    778: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../constants/numerical").BADNUM,
          a = /^['"%,$#\s']+|[, ]|['"%,$#\s']+$/g;

      e.exports = function (t) {
        return "string" == typeof t && (t = t.replace(a, "")), n(t) ? Number(t) : i;
      };
    }, {
      "../constants/numerical": 771,
      "fast-isnumeric": 240
    }],
    779: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        var e = t._fullLayout;
        e._glcanvas && e._glcanvas.size() && e._glcanvas.each(function (t) {
          t.regl && t.regl.clear({
            color: !0,
            depth: !0
          });
        });
      };
    }, {}],
    780: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        t._responsiveChartHandler && (window.removeEventListener("resize", t._responsiveChartHandler), delete t._responsiveChartHandler);
      };
    }, {}],
    781: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("tinycolor2"),
          a = t("../plots/attributes"),
          o = t("../components/colorscale/scales"),
          s = t("../constants/interactions").DESELECTDIM,
          l = t("./nested_property"),
          c = t("./regex").counter,
          u = t("./mod").modHalf,
          f = t("./array").isArrayOrTypedArray;

      function h(t, e) {
        var n = r.valObjectMeta[e.valType];
        if (e.arrayOk && f(t)) return !0;
        if (n.validateFunction) return n.validateFunction(t, e);
        var i = {},
            a = i,
            o = {
          set: function set(t) {
            a = t;
          }
        };
        return n.coerceFunction(t, o, i, e), a !== i;
      }

      r.valObjectMeta = {
        data_array: {
          coerceFunction: function coerceFunction(t, e, r) {
            f(t) ? e.set(t) : void 0 !== r && e.set(r);
          }
        },
        enumerated: {
          coerceFunction: function coerceFunction(t, e, r, n) {
            n.coerceNumber && (t = +t), -1 === n.values.indexOf(t) ? e.set(r) : e.set(t);
          },
          validateFunction: function validateFunction(t, e) {
            e.coerceNumber && (t = +t);

            for (var r = e.values, n = 0; n < r.length; n++) {
              var i = String(r[n]);

              if ("/" === i.charAt(0) && "/" === i.charAt(i.length - 1)) {
                if (new RegExp(i.substr(1, i.length - 2)).test(t)) return !0;
              } else if (t === r[n]) return !0;
            }

            return !1;
          }
        },
        boolean: {
          coerceFunction: function coerceFunction(t, e, r) {
            !0 === t || !1 === t ? e.set(t) : e.set(r);
          }
        },
        number: {
          coerceFunction: function coerceFunction(t, e, r, i) {
            !n(t) || void 0 !== i.min && t < i.min || void 0 !== i.max && t > i.max ? e.set(r) : e.set(+t);
          }
        },
        integer: {
          coerceFunction: function coerceFunction(t, e, r, i) {
            t % 1 || !n(t) || void 0 !== i.min && t < i.min || void 0 !== i.max && t > i.max ? e.set(r) : e.set(+t);
          }
        },
        string: {
          coerceFunction: function coerceFunction(t, e, r, n) {
            if ("string" != typeof t) {
              var i = "number" == typeof t;
              !0 !== n.strict && i ? e.set(String(t)) : e.set(r);
            } else n.noBlank && !t ? e.set(r) : e.set(t);
          }
        },
        color: {
          coerceFunction: function coerceFunction(t, e, r) {
            i(t).isValid() ? e.set(t) : e.set(r);
          }
        },
        colorlist: {
          coerceFunction: function coerceFunction(t, e, r) {
            Array.isArray(t) && t.length && t.every(function (t) {
              return i(t).isValid();
            }) ? e.set(t) : e.set(r);
          }
        },
        colorscale: {
          coerceFunction: function coerceFunction(t, e, r) {
            e.set(o.get(t, r));
          }
        },
        angle: {
          coerceFunction: function coerceFunction(t, e, r) {
            "auto" === t ? e.set("auto") : n(t) ? e.set(u(+t, 360)) : e.set(r);
          }
        },
        subplotid: {
          coerceFunction: function coerceFunction(t, e, r, n) {
            var i = n.regex || c(r);
            "string" == typeof t && i.test(t) ? e.set(t) : e.set(r);
          },
          validateFunction: function validateFunction(t, e) {
            var r = e.dflt;
            return t === r || "string" == typeof t && !!c(r).test(t);
          }
        },
        flaglist: {
          coerceFunction: function coerceFunction(t, e, r, n) {
            if ("string" == typeof t) {
              if (-1 === (n.extras || []).indexOf(t)) {
                for (var i = t.split("+"), a = 0; a < i.length;) {
                  var o = i[a];
                  -1 === n.flags.indexOf(o) || i.indexOf(o) < a ? i.splice(a, 1) : a++;
                }

                i.length ? e.set(i.join("+")) : e.set(r);
              } else e.set(t);
            } else e.set(r);
          }
        },
        any: {
          coerceFunction: function coerceFunction(t, e, r) {
            void 0 === t ? e.set(r) : e.set(t);
          }
        },
        info_array: {
          coerceFunction: function coerceFunction(t, e, n, i) {
            function a(t, e, n) {
              var i,
                  a = {
                set: function set(t) {
                  i = t;
                }
              };
              return void 0 === n && (n = e.dflt), r.valObjectMeta[e.valType].coerceFunction(t, a, n, e), i;
            }

            var o = 2 === i.dimensions || "1-2" === i.dimensions && Array.isArray(t) && Array.isArray(t[0]);

            if (Array.isArray(t)) {
              var s,
                  l,
                  c,
                  u,
                  f,
                  h,
                  p = i.items,
                  d = [],
                  m = Array.isArray(p),
                  g = m && o && Array.isArray(p[0]),
                  v = o && m && !g,
                  y = m && !v ? p.length : t.length;
              if (n = Array.isArray(n) ? n : [], o) for (s = 0; s < y; s++) {
                for (d[s] = [], c = Array.isArray(t[s]) ? t[s] : [], f = v ? p.length : m ? p[s].length : c.length, l = 0; l < f; l++) {
                  u = v ? p[l] : m ? p[s][l] : p, void 0 !== (h = a(c[l], u, (n[s] || [])[l])) && (d[s][l] = h);
                }
              } else for (s = 0; s < y; s++) {
                void 0 !== (h = a(t[s], m ? p[s] : p, n[s])) && (d[s] = h);
              }
              e.set(d);
            } else e.set(n);
          },
          validateFunction: function validateFunction(t, e) {
            if (!Array.isArray(t)) return !1;
            var r = e.items,
                n = Array.isArray(r),
                i = 2 === e.dimensions;
            if (!e.freeLength && t.length !== r.length) return !1;

            for (var a = 0; a < t.length; a++) {
              if (i) {
                if (!Array.isArray(t[a]) || !e.freeLength && t[a].length !== r[a].length) return !1;

                for (var o = 0; o < t[a].length; o++) {
                  if (!h(t[a][o], n ? r[a][o] : r)) return !1;
                }
              } else if (!h(t[a], n ? r[a] : r)) return !1;
            }

            return !0;
          }
        }
      }, r.coerce = function (t, e, n, i, a) {
        var o = l(n, i).get(),
            s = l(t, i),
            c = l(e, i),
            u = s.get(),
            p = e._template;
        if (void 0 === u && p && (u = l(p, i).get(), p = 0), void 0 === a && (a = o.dflt), o.arrayOk && f(u)) return c.set(u), u;
        var d = r.valObjectMeta[o.valType].coerceFunction;
        d(u, c, a, o);
        var m = c.get();
        return p && m === a && !h(u, o) && (d(u = l(p, i).get(), c, a, o), m = c.get()), m;
      }, r.coerce2 = function (t, e, n, i, a) {
        var o = l(t, i),
            s = r.coerce(t, e, n, i, a),
            c = o.get();
        return null != c && s;
      }, r.coerceFont = function (t, e, r) {
        var n = {};
        return r = r || {}, n.family = t(e + ".family", r.family), n.size = t(e + ".size", r.size), n.color = t(e + ".color", r.color), n;
      }, r.coercePattern = function (t, e) {
        t(e + ".shape") && (t(e + ".size"), t(e + ".bgcolor"), t(e + ".solidity"));
      }, r.coerceHoverinfo = function (t, e, n) {
        var i,
            o = e._module.attributes,
            s = o.hoverinfo ? o : a,
            l = s.hoverinfo;

        if (1 === n._dataLength) {
          var c = "all" === l.dflt ? l.flags.slice() : l.dflt.split("+");
          c.splice(c.indexOf("name"), 1), i = c.join("+");
        }

        return r.coerce(t, e, s, "hoverinfo", i);
      }, r.coerceSelectionMarkerOpacity = function (t, e) {
        if (t.marker) {
          var r,
              n,
              i = t.marker.opacity;
          if (void 0 !== i) f(i) || t.selected || t.unselected || (r = i, n = s * i), e("selected.marker.opacity", r), e("unselected.marker.opacity", n);
        }
      }, r.validate = h;
    }, {
      "../components/colorscale/scales": 673,
      "../constants/interactions": 770,
      "../plots/attributes": 841,
      "./array": 777,
      "./mod": 802,
      "./nested_property": 803,
      "./regex": 812,
      "fast-isnumeric": 240,
      tinycolor2: 590
    }],
    782: [function (t, e, r) {
      "use strict";

      var n,
          i,
          a = t("d3-time-format").timeFormat,
          o = t("fast-isnumeric"),
          s = t("./loggers"),
          l = t("./mod").mod,
          c = t("../constants/numerical"),
          u = c.BADNUM,
          f = c.ONEDAY,
          h = c.ONEHOUR,
          p = c.ONEMIN,
          d = c.ONESEC,
          m = c.EPOCHJD,
          g = t("../registry"),
          v = t("d3-time-format").utcFormat,
          y = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\d)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m,
          x = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\di?)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m,
          b = new Date().getFullYear() - 70;

      function _(t) {
        return t && g.componentsRegistry.calendars && "string" == typeof t && "gregorian" !== t;
      }

      function w(t, e) {
        return String(t + Math.pow(10, e)).substr(1);
      }

      r.dateTick0 = function (t, e) {
        var n = function (t, e) {
          return _(t) ? e ? g.getComponentMethod("calendars", "CANONICAL_SUNDAY")[t] : g.getComponentMethod("calendars", "CANONICAL_TICK")[t] : e ? "2000-01-02" : "2000-01-01";
        }(t, !!e);

        if (e < 2) return n;
        var i = r.dateTime2ms(n, t);
        return i += f * (e - 1), r.ms2DateTime(i, 0, t);
      }, r.dfltRange = function (t) {
        return _(t) ? g.getComponentMethod("calendars", "DFLTRANGE")[t] : ["2000-01-01", "2001-01-01"];
      }, r.isJSDate = function (t) {
        return "object" == _typeof(t) && null !== t && "function" == typeof t.getTime;
      }, r.dateTime2ms = function (t, e) {
        if (r.isJSDate(t)) {
          var a = t.getTimezoneOffset() * p,
              o = (t.getUTCMinutes() - t.getMinutes()) * p + (t.getUTCSeconds() - t.getSeconds()) * d + (t.getUTCMilliseconds() - t.getMilliseconds());

          if (o) {
            var s = 3 * p;
            a = a - s / 2 + l(o - a + s / 2, s);
          }

          return (t = Number(t) - a) >= n && t <= i ? t : u;
        }

        if ("string" != typeof t && "number" != typeof t) return u;
        t = String(t);

        var c = _(e),
            v = t.charAt(0);

        !c || "G" !== v && "g" !== v || (t = t.substr(1), e = "");
        var w = c && "chinese" === e.substr(0, 7),
            T = t.match(w ? x : y);
        if (!T) return u;
        var k = T[1],
            M = T[3] || "1",
            A = Number(T[5] || 1),
            S = Number(T[7] || 0),
            E = Number(T[9] || 0),
            L = Number(T[11] || 0);

        if (c) {
          if (2 === k.length) return u;
          var C;
          k = Number(k);

          try {
            var P = g.getComponentMethod("calendars", "getCal")(e);

            if (w) {
              var I = "i" === M.charAt(M.length - 1);
              M = parseInt(M, 10), C = P.newDate(k, P.toMonthIndex(k, M, I), A);
            } else C = P.newDate(k, Number(M), A);
          } catch (t) {
            return u;
          }

          return C ? (C.toJD() - m) * f + S * h + E * p + L * d : u;
        }

        k = 2 === k.length ? (Number(k) + 2e3 - b) % 100 + b : Number(k), M -= 1;
        var O = new Date(Date.UTC(2e3, M, A, S, E));
        return O.setUTCFullYear(k), O.getUTCMonth() !== M || O.getUTCDate() !== A ? u : O.getTime() + L * d;
      }, n = r.MIN_MS = r.dateTime2ms("-9999"), i = r.MAX_MS = r.dateTime2ms("9999-12-31 23:59:59.9999"), r.isDateTime = function (t, e) {
        return r.dateTime2ms(t, e) !== u;
      };
      var T = 90 * f,
          k = 3 * h,
          M = 5 * p;

      function A(t, e, r, n, i) {
        if ((e || r || n || i) && (t += " " + w(e, 2) + ":" + w(r, 2), (n || i) && (t += ":" + w(n, 2), i))) {
          for (var a = 4; i % 10 == 0;) {
            a -= 1, i /= 10;
          }

          t += "." + w(i, a);
        }

        return t;
      }

      r.ms2DateTime = function (t, e, r) {
        if ("number" != typeof t || !(t >= n && t <= i)) return u;
        e || (e = 0);
        var a,
            o,
            s,
            c,
            y,
            x,
            b = Math.floor(10 * l(t + .05, 1)),
            w = Math.round(t - b / 10);

        if (_(r)) {
          var S = Math.floor(w / f) + m,
              E = Math.floor(l(t, f));

          try {
            a = g.getComponentMethod("calendars", "getCal")(r).fromJD(S).formatDate("yyyy-mm-dd");
          } catch (t) {
            a = v("G%Y-%m-%d")(new Date(w));
          }

          if ("-" === a.charAt(0)) for (; a.length < 11;) {
            a = "-0" + a.substr(1);
          } else for (; a.length < 10;) {
            a = "0" + a;
          }
          o = e < T ? Math.floor(E / h) : 0, s = e < T ? Math.floor(E % h / p) : 0, c = e < k ? Math.floor(E % p / d) : 0, y = e < M ? E % d * 10 + b : 0;
        } else x = new Date(w), a = v("%Y-%m-%d")(x), o = e < T ? x.getUTCHours() : 0, s = e < T ? x.getUTCMinutes() : 0, c = e < k ? x.getUTCSeconds() : 0, y = e < M ? 10 * x.getUTCMilliseconds() + b : 0;

        return A(a, o, s, c, y);
      }, r.ms2DateTimeLocal = function (t) {
        if (!(t >= n + f && t <= i - f)) return u;
        var e = Math.floor(10 * l(t + .05, 1)),
            r = new Date(Math.round(t - e / 10));
        return A(a("%Y-%m-%d")(r), r.getHours(), r.getMinutes(), r.getSeconds(), 10 * r.getUTCMilliseconds() + e);
      }, r.cleanDate = function (t, e, n) {
        if (t === u) return e;

        if (r.isJSDate(t) || "number" == typeof t && isFinite(t)) {
          if (_(n)) return s.error("JS Dates and milliseconds are incompatible with world calendars", t), e;
          if (!(t = r.ms2DateTimeLocal(+t)) && void 0 !== e) return e;
        } else if (!r.isDateTime(t, n)) return s.error("unrecognized date", t), e;

        return t;
      };
      var S = /%\d?f/g;

      function E(t, e, r, n) {
        t = t.replace(S, function (t) {
          var r = Math.min(+t.charAt(1) || 6, 6);
          return (e / 1e3 % 1 + 2).toFixed(r).substr(2).replace(/0+$/, "") || "0";
        });
        var i = new Date(Math.floor(e + .05));
        if (_(n)) try {
          t = g.getComponentMethod("calendars", "worldCalFmt")(t, e, n);
        } catch (t) {
          return "Invalid";
        }
        return r(t)(i);
      }

      var L = [59, 59.9, 59.99, 59.999, 59.9999];

      r.formatDate = function (t, e, r, n, i, a) {
        if (i = _(i) && i, !e) if ("y" === r) e = a.year;else if ("m" === r) e = a.month;else {
          if ("d" !== r) return function (t, e) {
            var r = l(t + .05, f),
                n = w(Math.floor(r / h), 2) + ":" + w(l(Math.floor(r / p), 60), 2);

            if ("M" !== e) {
              o(e) || (e = 0);
              var i = (100 + Math.min(l(t / d, 60), L[e])).toFixed(e).substr(1);
              e > 0 && (i = i.replace(/0+$/, "").replace(/[\.]$/, "")), n += ":" + i;
            }

            return n;
          }(t, r) + "\n" + E(a.dayMonthYear, t, n, i);
          e = a.dayMonth + "\n" + a.year;
        }
        return E(e, t, n, i);
      };

      var C = 3 * f;
      r.incrementMonth = function (t, e, r) {
        r = _(r) && r;
        var n = l(t, f);
        if (t = Math.round(t - n), r) try {
          var i = Math.round(t / f) + m,
              a = g.getComponentMethod("calendars", "getCal")(r),
              o = a.fromJD(i);
          return e % 12 ? a.add(o, e, "m") : a.add(o, e / 12, "y"), (o.toJD() - m) * f + n;
        } catch (e) {
          s.error("invalid ms " + t + " in calendar " + r);
        }
        var c = new Date(t + C);
        return c.setUTCMonth(c.getUTCMonth() + e) + n - C;
      }, r.findExactDates = function (t, e) {
        for (var r, n, i = 0, a = 0, s = 0, l = 0, c = _(e) && g.getComponentMethod("calendars", "getCal")(e), u = 0; u < t.length; u++) {
          if (n = t[u], o(n)) {
            if (!(n % f)) if (c) try {
              1 === (r = c.fromJD(n / f + m)).day() ? 1 === r.month() ? i++ : a++ : s++;
            } catch (t) {} else 1 === (r = new Date(n)).getUTCDate() ? 0 === r.getUTCMonth() ? i++ : a++ : s++;
          } else l++;
        }

        s += a += i;
        var h = t.length - l;
        return {
          exactYears: i / h,
          exactMonths: a / h,
          exactDays: s / h
        };
      };
    }, {
      "../constants/numerical": 771,
      "../registry": 923,
      "./loggers": 799,
      "./mod": 802,
      "d3-time-format": 167,
      "fast-isnumeric": 240
    }],
    783: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("./loggers"),
          a = t("./matrix"),
          o = t("gl-mat4");

      function s(t) {
        var e = t && t.parentNode;
        e && e.removeChild(t);
      }

      function l(t, e, r) {
        var n = "plotly.js-style-" + t,
            a = document.getElementById(n);
        a || ((a = document.createElement("style")).setAttribute("id", n), a.appendChild(document.createTextNode("")), document.head.appendChild(a));
        var o = a.sheet;
        o.insertRule ? o.insertRule(e + "{" + r + "}", 0) : o.addRule ? o.addRule(e, r, 0) : i.warn("addStyleRule failed");
      }

      function c(t) {
        var e = window.getComputedStyle(t, null),
            r = e.getPropertyValue("-webkit-transform") || e.getPropertyValue("-moz-transform") || e.getPropertyValue("-ms-transform") || e.getPropertyValue("-o-transform") || e.getPropertyValue("transform");
        return "none" === r ? null : r.replace("matrix", "").replace("3d", "").slice(1, -1).split(",").map(function (t) {
          return +t;
        });
      }

      function u(t) {
        for (var e = []; f(t);) {
          e.push(t), t = t.parentNode;
        }

        return e;
      }

      function f(t) {
        return t && (t instanceof Element || t instanceof HTMLElement);
      }

      e.exports = {
        getGraphDiv: function getGraphDiv(t) {
          var e;

          if ("string" == typeof t) {
            if (null === (e = document.getElementById(t))) throw new Error("No DOM element with id '" + t + "' exists on the page.");
            return e;
          }

          if (null == t) throw new Error("DOM element provided is null or undefined");
          return t;
        },
        isPlotDiv: function isPlotDiv(t) {
          var e = n.select(t);
          return e.node() instanceof HTMLElement && e.size() && e.classed("js-plotly-plot");
        },
        removeElement: s,
        addStyleRule: function addStyleRule(t, e) {
          l("global", t, e);
        },
        addRelatedStyleRule: l,
        deleteRelatedStyleRule: function deleteRelatedStyleRule(t) {
          var e = "plotly.js-style-" + t,
              r = document.getElementById(e);
          r && s(r);
        },
        getFullTransformMatrix: function getFullTransformMatrix(t) {
          var e = u(t),
              r = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
          return e.forEach(function (t) {
            var e = c(t);

            if (e) {
              var n = a.convertCssMatrix(e);
              r = o.multiply(r, r, n);
            }
          }), r;
        },
        getElementTransformMatrix: c,
        getElementAndAncestors: u,
        equalDomRects: function equalDomRects(t, e) {
          return t && e && t.x === e.x && t.y === e.y && t.top === e.top && t.left === e.left && t.right === e.right && t.bottom === e.bottom;
        }
      };
    }, {
      "./loggers": 799,
      "./matrix": 801,
      "@plotly/d3": 57,
      "gl-mat4": 289
    }],
    784: [function (t, e, r) {
      "use strict";

      var n = t("events").EventEmitter,
          i = {
        init: function init(t) {
          if (t._ev instanceof n) return t;
          var e = new n(),
              r = new n();
          return t._ev = e, t._internalEv = r, t.on = e.on.bind(e), t.once = e.once.bind(e), t.removeListener = e.removeListener.bind(e), t.removeAllListeners = e.removeAllListeners.bind(e), t._internalOn = r.on.bind(r), t._internalOnce = r.once.bind(r), t._removeInternalListener = r.removeListener.bind(r), t._removeAllInternalListeners = r.removeAllListeners.bind(r), t.emit = function (n, i) {
            "undefined" != typeof jQuery && jQuery(t).trigger(n, i), e.emit(n, i), r.emit(n, i);
          }, t;
        },
        triggerHandler: function triggerHandler(t, e, r) {
          var n, i;
          "undefined" != typeof jQuery && (n = jQuery(t).triggerHandler(e, r));
          var a = t._ev;
          if (!a) return n;
          var o,
              s = a._events[e];
          if (!s) return n;

          function l(t) {
            return t.listener ? (a.removeListener(e, t.listener), t.fired ? void 0 : (t.fired = !0, t.listener.apply(a, [r]))) : t.apply(a, [r]);
          }

          for (s = Array.isArray(s) ? s : [s], o = 0; o < s.length - 1; o++) {
            l(s[o]);
          }

          return i = l(s[o]), void 0 !== n ? n : i;
        },
        purge: function purge(t) {
          return delete t._ev, delete t.on, delete t.once, delete t.removeListener, delete t.removeAllListeners, delete t.emit, delete t._ev, delete t._internalEv, delete t._internalOn, delete t._internalOnce, delete t._removeInternalListener, delete t._removeAllInternalListeners, t;
        }
      };
      e.exports = i;
    }, {
      events: 111
    }],
    785: [function (t, e, r) {
      "use strict";

      var n = t("./is_plain_object.js"),
          i = Array.isArray;

      function a(t, e, r, o) {
        var s,
            l,
            c,
            u,
            f,
            h,
            p = t[0],
            d = t.length;

        if (2 === d && i(p) && i(t[1]) && 0 === p.length) {
          if (function (t, e) {
            var r, n;

            for (r = 0; r < t.length; r++) {
              if (null !== (n = t[r]) && "object" == _typeof(n)) return !1;
              void 0 !== n && (e[r] = n);
            }

            return !0;
          }(t[1], p)) return p;
          p.splice(0, p.length);
        }

        for (var m = 1; m < d; m++) {
          for (l in s = t[m]) {
            c = p[l], u = s[l], o && i(u) ? p[l] = u : e && u && (n(u) || (f = i(u))) ? (f ? (f = !1, h = c && i(c) ? c : []) : h = c && n(c) ? c : {}, p[l] = a([h, u], e, r, o)) : (void 0 !== u || r) && (p[l] = u);
          }
        }

        return p;
      }

      r.extendFlat = function () {
        return a(arguments, !1, !1, !1);
      }, r.extendDeep = function () {
        return a(arguments, !0, !1, !1);
      }, r.extendDeepAll = function () {
        return a(arguments, !0, !0, !1);
      }, r.extendDeepNoArrays = function () {
        return a(arguments, !0, !1, !0);
      };
    }, {
      "./is_plain_object.js": 796
    }],
    786: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        for (var e = {}, r = [], n = 0, i = 0; i < t.length; i++) {
          var a = t[i];
          1 !== e[a] && (e[a] = 1, r[n++] = a);
        }

        return r;
      };
    }, {}],
    787: [function (t, e, r) {
      "use strict";

      function n(t) {
        return !0 === t.visible;
      }

      function i(t) {
        var e = t[0].trace;
        return !0 === e.visible && 0 !== e._length;
      }

      e.exports = function (t) {
        for (var e, r = (e = t, Array.isArray(e) && Array.isArray(e[0]) && e[0][0] && e[0][0].trace ? i : n), a = [], o = 0; o < t.length; o++) {
          var s = t[o];
          r(s) && a.push(s);
        }

        return a;
      };
    }, {}],
    788: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("country-regex"),
          a = t("@turf/area"),
          o = t("@turf/centroid"),
          s = t("@turf/bbox"),
          l = t("./identity"),
          c = t("./loggers"),
          u = t("./is_plain_object"),
          f = t("./nested_property"),
          h = t("./polygon"),
          p = Object.keys(i),
          d = {
        "ISO-3": l,
        "USA-states": l,
        "country names": function countryNames(t) {
          for (var e = 0; e < p.length; e++) {
            var r = p[e];
            if (new RegExp(i[r]).test(t.trim().toLowerCase())) return r;
          }

          return c.log("Unrecognized country name: " + t + "."), !1;
        }
      };

      function m(t) {
        var e = t.geojson,
            r = window.PlotlyGeoAssets || {},
            n = "string" == typeof e ? r[e] : e;
        return u(n) ? n : (c.error("Oops ... something went wrong when fetching " + e), !1);
      }

      e.exports = {
        locationToFeature: function locationToFeature(t, e, r) {
          if (!e || "string" != typeof e) return !1;
          var n,
              i,
              a,
              o = d[t](e);

          if (o) {
            if ("USA-states" === t) for (n = [], a = 0; a < r.length; a++) {
              (i = r[a]).properties && i.properties.gu && "USA" === i.properties.gu && n.push(i);
            } else n = r;

            for (a = 0; a < n.length; a++) {
              if ((i = n[a]).id === o) return i;
            }

            c.log(["Location with id", o, "does not have a matching topojson feature at this resolution."].join(" "));
          }

          return !1;
        },
        feature2polygons: function feature2polygons(t) {
          var e,
              r,
              n,
              i,
              a = t.geometry,
              o = a.coordinates,
              s = t.id,
              l = [];

          function c(t) {
            for (var e = 0; e < t.length - 1; e++) {
              if (t[e][0] > 0 && t[e + 1][0] < 0) return e;
            }

            return null;
          }

          switch (e = "RUS" === s || "FJI" === s ? function (t) {
            var e;
            if (null === c(t)) e = t;else for (e = new Array(t.length), i = 0; i < t.length; i++) {
              e[i] = [t[i][0] < 0 ? t[i][0] + 360 : t[i][0], t[i][1]];
            }
            l.push(h.tester(e));
          } : "ATA" === s ? function (t) {
            var e = c(t);
            if (null === e) return l.push(h.tester(t));
            var r = new Array(t.length + 1),
                n = 0;

            for (i = 0; i < t.length; i++) {
              i > e ? r[n++] = [t[i][0] + 360, t[i][1]] : i === e ? (r[n++] = t[i], r[n++] = [t[i][0], -90]) : r[n++] = t[i];
            }

            var a = h.tester(r);
            a.pts.pop(), l.push(a);
          } : function (t) {
            l.push(h.tester(t));
          }, a.type) {
            case "MultiPolygon":
              for (r = 0; r < o.length; r++) {
                for (n = 0; n < o[r].length; n++) {
                  e(o[r][n]);
                }
              }

              break;

            case "Polygon":
              for (r = 0; r < o.length; r++) {
                e(o[r]);
              }

          }

          return l;
        },
        getTraceGeojson: m,
        extractTraceFeature: function extractTraceFeature(t) {
          var e = t[0].trace,
              r = m(e);
          if (!r) return !1;
          var n,
              i = {},
              s = [];

          for (n = 0; n < e._length; n++) {
            var l = t[n];
            (l.loc || 0 === l.loc) && (i[l.loc] = l);
          }

          function u(t) {
            var r = f(t, e.featureidkey || "id").get(),
                n = i[r];

            if (n) {
              var l = t.geometry;

              if ("Polygon" === l.type || "MultiPolygon" === l.type) {
                var u = {
                  type: "Feature",
                  id: r,
                  geometry: l,
                  properties: {}
                };
                u.properties.ct = function (t) {
                  var e,
                      r = t.geometry;
                  if ("MultiPolygon" === r.type) for (var n = r.coordinates, i = 0, s = 0; s < n.length; s++) {
                    var l = {
                      type: "Polygon",
                      coordinates: n[s]
                    },
                        c = a.default(l);
                    c > i && (i = c, e = l);
                  } else e = r;
                  return o.default(e).geometry.coordinates;
                }(u), n.fIn = t, n.fOut = u, s.push(u);
              } else c.log(["Location", n.loc, "does not have a valid GeoJSON geometry.", "Traces with locationmode *geojson-id* only support", "*Polygon* and *MultiPolygon* geometries."].join(" "));
            }

            delete i[r];
          }

          switch (r.type) {
            case "FeatureCollection":
              var h = r.features;

              for (n = 0; n < h.length; n++) {
                u(h[n]);
              }

              break;

            case "Feature":
              u(r);
              break;

            default:
              return c.warn(["Invalid GeoJSON type", (r.type || "none") + ".", "Traces with locationmode *geojson-id* only support", "*FeatureCollection* and *Feature* types."].join(" ")), !1;
          }

          for (var p in i) {
            c.log(["Location *" + p + "*", "does not have a matching feature with id-key", "*" + e.featureidkey + "*."].join(" "));
          }

          return s;
        },
        fetchTraceGeoData: function fetchTraceGeoData(t) {
          var e = window.PlotlyGeoAssets || {},
              r = [];

          function i(t) {
            return new Promise(function (r, i) {
              n.json(t, function (n, a) {
                if (n) {
                  delete e[t];
                  var o = 404 === n.status ? 'GeoJSON at URL "' + t + '" does not exist.' : "Unexpected error while fetching from " + t;
                  return i(new Error(o));
                }

                return e[t] = a, r(a);
              });
            });
          }

          function a(t) {
            return new Promise(function (r, n) {
              var i = 0,
                  a = setInterval(function () {
                return e[t] && "pending" !== e[t] ? (clearInterval(a), r(e[t])) : i > 100 ? (clearInterval(a), n("Unexpected error while fetching from " + t)) : void i++;
              }, 50);
            });
          }

          for (var o = 0; o < t.length; o++) {
            var s = t[o][0].trace.geojson;
            "string" == typeof s && (e[s] ? "pending" === e[s] && r.push(a(s)) : (e[s] = "pending", r.push(i(s))));
          }

          return r;
        },
        computeBbox: function computeBbox(t) {
          return s.default(t);
        }
      };
    }, {
      "./identity": 793,
      "./is_plain_object": 796,
      "./loggers": 799,
      "./nested_property": 803,
      "./polygon": 807,
      "@plotly/d3": 57,
      "@turf/area": 60,
      "@turf/bbox": 61,
      "@turf/centroid": 62,
      "country-regex": 140
    }],
    789: [function (t, e, r) {
      "use strict";

      var n = t("../constants/numerical").BADNUM;
      r.calcTraceToLineCoords = function (t) {
        for (var e = t[0].trace.connectgaps, r = [], i = [], a = 0; a < t.length; a++) {
          var o = t[a].lonlat;
          o[0] !== n ? i.push(o) : !e && i.length > 0 && (r.push(i), i = []);
        }

        return i.length > 0 && r.push(i), r;
      }, r.makeLine = function (t) {
        return 1 === t.length ? {
          type: "LineString",
          coordinates: t[0]
        } : {
          type: "MultiLineString",
          coordinates: t
        };
      }, r.makePolygon = function (t) {
        if (1 === t.length) return {
          type: "Polygon",
          coordinates: t
        };

        for (var e = new Array(t.length), r = 0; r < t.length; r++) {
          e[r] = [t[r]];
        }

        return {
          type: "MultiPolygon",
          coordinates: e
        };
      }, r.makeBlank = function () {
        return {
          type: "Point",
          coordinates: []
        };
      };
    }, {
      "../constants/numerical": 771
    }],
    790: [function (t, e, r) {
      "use strict";

      var n,
          i,
          a,
          o = t("./mod").mod;

      function s(t, e, r, n, i, a, o, s) {
        var l = r - t,
            c = i - t,
            u = o - i,
            f = n - e,
            h = a - e,
            p = s - a,
            d = l * p - u * f;
        if (0 === d) return null;
        var m = (c * p - u * h) / d,
            g = (c * f - l * h) / d;
        return g < 0 || g > 1 || m < 0 || m > 1 ? null : {
          x: t + l * m,
          y: e + f * m
        };
      }

      function l(t, e, r, n, i) {
        var a = n * t + i * e;
        if (a < 0) return n * n + i * i;

        if (a > r) {
          var o = n - t,
              s = i - e;
          return o * o + s * s;
        }

        var l = n * e - i * t;
        return l * l / r;
      }

      r.segmentsIntersect = s, r.segmentDistance = function (t, e, r, n, i, a, o, c) {
        if (s(t, e, r, n, i, a, o, c)) return 0;
        var u = r - t,
            f = n - e,
            h = o - i,
            p = c - a,
            d = u * u + f * f,
            m = h * h + p * p,
            g = Math.min(l(u, f, d, i - t, a - e), l(u, f, d, o - t, c - e), l(h, p, m, t - i, e - a), l(h, p, m, r - i, n - a));
        return Math.sqrt(g);
      }, r.getTextLocation = function (t, e, r, s) {
        if (t === i && s === a || (n = {}, i = t, a = s), n[r]) return n[r];
        var l = t.getPointAtLength(o(r - s / 2, e)),
            c = t.getPointAtLength(o(r + s / 2, e)),
            u = Math.atan((c.y - l.y) / (c.x - l.x)),
            f = t.getPointAtLength(o(r, e)),
            h = {
          x: (4 * f.x + l.x + c.x) / 6,
          y: (4 * f.y + l.y + c.y) / 6,
          theta: u
        };
        return n[r] = h, h;
      }, r.clearLocationCache = function () {
        i = null;
      }, r.getVisibleSegment = function (t, e, r) {
        var n,
            i,
            a = e.left,
            o = e.right,
            s = e.top,
            l = e.bottom,
            c = 0,
            u = t.getTotalLength(),
            f = u;

        function h(e) {
          var r = t.getPointAtLength(e);
          0 === e ? n = r : e === u && (i = r);
          var c = r.x < a ? a - r.x : r.x > o ? r.x - o : 0,
              f = r.y < s ? s - r.y : r.y > l ? r.y - l : 0;
          return Math.sqrt(c * c + f * f);
        }

        for (var p = h(c); p;) {
          if ((c += p + r) > f) return;
          p = h(c);
        }

        for (p = h(f); p;) {
          if (c > (f -= p + r)) return;
          p = h(f);
        }

        return {
          min: c,
          max: f,
          len: f - c,
          total: u,
          isClosed: 0 === c && f === u && Math.abs(n.x - i.x) < .1 && Math.abs(n.y - i.y) < .1
        };
      }, r.findPointOnPath = function (t, e, r, n) {
        for (var i, a, o, s = (n = n || {}).pathLength || t.getTotalLength(), l = n.tolerance || .001, c = n.iterationLimit || 30, u = t.getPointAtLength(0)[r] > t.getPointAtLength(s)[r] ? -1 : 1, f = 0, h = 0, p = s; f < c;) {
          if (i = (h + p) / 2, o = (a = t.getPointAtLength(i))[r] - e, Math.abs(o) < l) return a;
          u * o > 0 ? p = i : h = i, f++;
        }

        return a;
      };
    }, {
      "./mod": 802
    }],
    791: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("tinycolor2"),
          a = t("color-normalize"),
          o = t("../components/colorscale"),
          s = t("../components/color/attributes").defaultLine,
          l = t("./array").isArrayOrTypedArray,
          c = a(s);

      function u(t, e) {
        var r = t;
        return r[3] *= e, r;
      }

      function f(t) {
        if (n(t)) return c;
        var e = a(t);
        return e.length ? e : c;
      }

      function h(t) {
        return n(t) ? t : 1;
      }

      e.exports = {
        formatColor: function formatColor(t, e, r) {
          var n,
              i,
              s,
              p,
              d,
              m = t.color,
              g = l(m),
              v = l(e),
              y = o.extractOpts(t),
              x = [];
          if (n = void 0 !== y.colorscale ? o.makeColorScaleFuncFromTrace(t) : f, i = g ? function (t, e) {
            return void 0 === t[e] ? c : a(n(t[e]));
          } : f, s = v ? function (t, e) {
            return void 0 === t[e] ? 1 : h(t[e]);
          } : h, g || v) for (var b = 0; b < r; b++) {
            p = i(m, b), d = s(e, b), x[b] = u(p, d);
          } else x = u(a(m), e);
          return x;
        },
        parseColorScale: function parseColorScale(t) {
          var e = o.extractOpts(t),
              r = e.colorscale;
          return e.reversescale && (r = o.flipScale(e.colorscale)), r.map(function (t) {
            var e = t[0],
                r = i(t[1]).toRgb();
            return {
              index: e,
              rgb: [r.r, r.g, r.b, r.a]
            };
          });
        }
      };
    }, {
      "../components/color/attributes": 657,
      "../components/colorscale": 670,
      "./array": 777,
      "color-normalize": 126,
      "fast-isnumeric": 240,
      tinycolor2: 590
    }],
    792: [function (t, e, r) {
      "use strict";

      var n = t("./identity");

      function i(t) {
        return [t];
      }

      e.exports = {
        keyFun: function keyFun(t) {
          return t.key;
        },
        repeat: i,
        descend: n,
        wrap: i,
        unwrap: function unwrap(t) {
          return t[0];
        }
      };
    }, {
      "./identity": 793
    }],
    793: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        return t;
      };
    }, {}],
    794: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        if (!e) return t;
        var r = 1 / Math.abs(e),
            n = r > 1 ? (r * t + r * e) / r : t + e,
            i = String(n).length;

        if (i > 16) {
          var a = String(e).length;

          if (i >= String(t).length + a) {
            var o = parseFloat(n).toPrecision(12);
            -1 === o.indexOf("e+") && (n = +o);
          }
        }

        return n;
      };
    }, {}],
    795: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("d3-time-format").utcFormat,
          a = t("fast-isnumeric"),
          o = t("../constants/numerical"),
          s = o.FP_SAFE,
          l = -s,
          c = o.BADNUM,
          u = e.exports = {};
      u.nestedProperty = t("./nested_property"), u.keyedContainer = t("./keyed_container"), u.relativeAttr = t("./relative_attr"), u.isPlainObject = t("./is_plain_object"), u.toLogRange = t("./to_log_range"), u.relinkPrivateKeys = t("./relink_private");
      var f = t("./array");
      u.isTypedArray = f.isTypedArray, u.isArrayOrTypedArray = f.isArrayOrTypedArray, u.isArray1D = f.isArray1D, u.ensureArray = f.ensureArray, u.concat = f.concat, u.maxRowLength = f.maxRowLength, u.minRowLength = f.minRowLength;
      var h = t("./mod");
      u.mod = h.mod, u.modHalf = h.modHalf;
      var p = t("./coerce");
      u.valObjectMeta = p.valObjectMeta, u.coerce = p.coerce, u.coerce2 = p.coerce2, u.coerceFont = p.coerceFont, u.coercePattern = p.coercePattern, u.coerceHoverinfo = p.coerceHoverinfo, u.coerceSelectionMarkerOpacity = p.coerceSelectionMarkerOpacity, u.validate = p.validate;
      var d = t("./dates");
      u.dateTime2ms = d.dateTime2ms, u.isDateTime = d.isDateTime, u.ms2DateTime = d.ms2DateTime, u.ms2DateTimeLocal = d.ms2DateTimeLocal, u.cleanDate = d.cleanDate, u.isJSDate = d.isJSDate, u.formatDate = d.formatDate, u.incrementMonth = d.incrementMonth, u.dateTick0 = d.dateTick0, u.dfltRange = d.dfltRange, u.findExactDates = d.findExactDates, u.MIN_MS = d.MIN_MS, u.MAX_MS = d.MAX_MS;
      var m = t("./search");
      u.findBin = m.findBin, u.sorterAsc = m.sorterAsc, u.sorterDes = m.sorterDes, u.distinctVals = m.distinctVals, u.roundUp = m.roundUp, u.sort = m.sort, u.findIndexOfMin = m.findIndexOfMin;
      var g = t("./stats");
      u.aggNums = g.aggNums, u.len = g.len, u.mean = g.mean, u.median = g.median, u.midRange = g.midRange, u.variance = g.variance, u.stdev = g.stdev, u.interp = g.interp;
      var v = t("./matrix");
      u.init2dArray = v.init2dArray, u.transposeRagged = v.transposeRagged, u.dot = v.dot, u.translationMatrix = v.translationMatrix, u.rotationMatrix = v.rotationMatrix, u.rotationXYMatrix = v.rotationXYMatrix, u.apply3DTransform = v.apply3DTransform, u.apply2DTransform = v.apply2DTransform, u.apply2DTransform2 = v.apply2DTransform2, u.convertCssMatrix = v.convertCssMatrix, u.inverseTransformMatrix = v.inverseTransformMatrix;
      var y = t("./angles");
      u.deg2rad = y.deg2rad, u.rad2deg = y.rad2deg, u.angleDelta = y.angleDelta, u.angleDist = y.angleDist, u.isFullCircle = y.isFullCircle, u.isAngleInsideSector = y.isAngleInsideSector, u.isPtInsideSector = y.isPtInsideSector, u.pathArc = y.pathArc, u.pathSector = y.pathSector, u.pathAnnulus = y.pathAnnulus;
      var x = t("./anchor_utils");
      u.isLeftAnchor = x.isLeftAnchor, u.isCenterAnchor = x.isCenterAnchor, u.isRightAnchor = x.isRightAnchor, u.isTopAnchor = x.isTopAnchor, u.isMiddleAnchor = x.isMiddleAnchor, u.isBottomAnchor = x.isBottomAnchor;
      var b = t("./geometry2d");
      u.segmentsIntersect = b.segmentsIntersect, u.segmentDistance = b.segmentDistance, u.getTextLocation = b.getTextLocation, u.clearLocationCache = b.clearLocationCache, u.getVisibleSegment = b.getVisibleSegment, u.findPointOnPath = b.findPointOnPath;

      var _ = t("./extend");

      u.extendFlat = _.extendFlat, u.extendDeep = _.extendDeep, u.extendDeepAll = _.extendDeepAll, u.extendDeepNoArrays = _.extendDeepNoArrays;
      var w = t("./loggers");
      u.log = w.log, u.warn = w.warn, u.error = w.error;
      var T = t("./regex");
      u.counterRegex = T.counter;
      var k = t("./throttle");
      u.throttle = k.throttle, u.throttleDone = k.done, u.clearThrottle = k.clear;
      var M = t("./dom");

      function A(t) {
        var e = {};

        for (var r in t) {
          for (var n = t[r], i = 0; i < n.length; i++) {
            e[n[i]] = +r;
          }
        }

        return e;
      }

      u.getGraphDiv = M.getGraphDiv, u.isPlotDiv = M.isPlotDiv, u.removeElement = M.removeElement, u.addStyleRule = M.addStyleRule, u.addRelatedStyleRule = M.addRelatedStyleRule, u.deleteRelatedStyleRule = M.deleteRelatedStyleRule, u.getFullTransformMatrix = M.getFullTransformMatrix, u.getElementTransformMatrix = M.getElementTransformMatrix, u.getElementAndAncestors = M.getElementAndAncestors, u.equalDomRects = M.equalDomRects, u.clearResponsive = t("./clear_responsive"), u.preserveDrawingBuffer = t("./preserve_drawing_buffer"), u.makeTraceGroups = t("./make_trace_groups"), u._ = t("./localize"), u.notifier = t("./notifier"), u.filterUnique = t("./filter_unique"), u.filterVisible = t("./filter_visible"), u.pushUnique = t("./push_unique"), u.increment = t("./increment"), u.cleanNumber = t("./clean_number"), u.ensureNumber = function (t) {
        return a(t) ? (t = Number(t)) > s || t < l ? c : t : c;
      }, u.isIndex = function (t, e) {
        return !(void 0 !== e && t >= e) && a(t) && t >= 0 && t % 1 == 0;
      }, u.noop = t("./noop"), u.identity = t("./identity"), u.repeat = function (t, e) {
        for (var r = new Array(e), n = 0; n < e; n++) {
          r[n] = t;
        }

        return r;
      }, u.swapAttrs = function (t, e, r, n) {
        r || (r = "x"), n || (n = "y");

        for (var i = 0; i < e.length; i++) {
          var a = e[i],
              o = u.nestedProperty(t, a.replace("?", r)),
              s = u.nestedProperty(t, a.replace("?", n)),
              l = o.get();
          o.set(s.get()), s.set(l);
        }
      }, u.raiseToTop = function (t) {
        t.parentNode.appendChild(t);
      }, u.cancelTransition = function (t) {
        return t.transition().duration(0);
      }, u.constrain = function (t, e, r) {
        return e > r ? Math.max(r, Math.min(e, t)) : Math.max(e, Math.min(r, t));
      }, u.bBoxIntersect = function (t, e, r) {
        return r = r || 0, t.left <= e.right + r && e.left <= t.right + r && t.top <= e.bottom + r && e.top <= t.bottom + r;
      }, u.simpleMap = function (t, e, r, n, i) {
        for (var a = t.length, o = new Array(a), s = 0; s < a; s++) {
          o[s] = e(t[s], r, n, i);
        }

        return o;
      }, u.randstr = function t(e, r, n, i) {
        if (n || (n = 16), void 0 === r && (r = 24), r <= 0) return "0";
        var a,
            o,
            s = Math.log(Math.pow(2, r)) / Math.log(n),
            l = "";

        for (a = 2; s === 1 / 0; a *= 2) {
          s = Math.log(Math.pow(2, r / a)) / Math.log(n) * a;
        }

        var c = s - Math.floor(s);

        for (a = 0; a < Math.floor(s); a++) {
          l = Math.floor(Math.random() * n).toString(n) + l;
        }

        c && (o = Math.pow(n, c), l = Math.floor(Math.random() * o).toString(n) + l);
        var f = parseInt(l, n);
        return e && e[l] || f !== 1 / 0 && f >= Math.pow(2, r) ? i > 10 ? (u.warn("randstr failed uniqueness"), l) : t(e, r, n, (i || 0) + 1) : l;
      }, u.OptionControl = function (t, e) {
        t || (t = {}), e || (e = "opt");
        var r = {
          optionList: [],
          _newoption: function _newoption(n) {
            n[e] = t, r[n.name] = n, r.optionList.push(n);
          }
        };
        return r["_" + e] = t, r;
      }, u.smooth = function (t, e) {
        if ((e = Math.round(e) || 0) < 2) return t;
        var r,
            n,
            i,
            a,
            o = t.length,
            s = 2 * o,
            l = 2 * e - 1,
            c = new Array(l),
            u = new Array(o);

        for (r = 0; r < l; r++) {
          c[r] = (1 - Math.cos(Math.PI * (r + 1) / e)) / (2 * e);
        }

        for (r = 0; r < o; r++) {
          for (a = 0, n = 0; n < l; n++) {
            (i = r + n + 1 - e) < -o ? i -= s * Math.round(i / s) : i >= s && (i -= s * Math.floor(i / s)), i < 0 ? i = -1 - i : i >= o && (i = s - 1 - i), a += t[i] * c[n];
          }

          u[r] = a;
        }

        return u;
      }, u.syncOrAsync = function (t, e, r) {
        var n;

        function i() {
          return u.syncOrAsync(t, e, r);
        }

        for (; t.length;) {
          if ((n = (0, t.splice(0, 1)[0])(e)) && n.then) return n.then(i).then(void 0, u.promiseError);
        }

        return r && r(e);
      }, u.stripTrailingSlash = function (t) {
        return "/" === t.substr(-1) ? t.substr(0, t.length - 1) : t;
      }, u.noneOrAll = function (t, e, r) {
        if (t) {
          var n,
              i = !1,
              a = !0;

          for (n = 0; n < r.length; n++) {
            null != t[r[n]] ? i = !0 : a = !1;
          }

          if (i && !a) for (n = 0; n < r.length; n++) {
            t[r[n]] = e[r[n]];
          }
        }
      }, u.mergeArray = function (t, e, r, n) {
        var i = "function" == typeof n;
        if (u.isArrayOrTypedArray(t)) for (var a = Math.min(t.length, e.length), o = 0; o < a; o++) {
          var s = t[o];
          e[o][r] = i ? n(s) : s;
        }
      }, u.mergeArrayCastPositive = function (t, e, r) {
        return u.mergeArray(t, e, r, function (t) {
          var e = +t;
          return isFinite(e) && e > 0 ? e : 0;
        });
      }, u.fillArray = function (t, e, r, n) {
        if (n = n || u.identity, u.isArrayOrTypedArray(t)) for (var i = 0; i < e.length; i++) {
          e[i][r] = n(t[i]);
        }
      }, u.castOption = function (t, e, r, n) {
        n = n || u.identity;
        var i = u.nestedProperty(t, r).get();
        return u.isArrayOrTypedArray(i) ? Array.isArray(e) && u.isArrayOrTypedArray(i[e[0]]) ? n(i[e[0]][e[1]]) : n(i[e]) : i;
      }, u.extractOption = function (t, e, r, n) {
        if (r in t) return t[r];
        var i = u.nestedProperty(e, n).get();
        return Array.isArray(i) ? void 0 : i;
      }, u.tagSelected = function (t, e, r) {
        var n,
            i,
            a = e.selectedpoints,
            o = e._indexToPoints;
        o && (n = A(o));

        for (var s = 0; s < a.length; s++) {
          var l = a[s];

          if (u.isIndex(l) || u.isArrayOrTypedArray(l) && u.isIndex(l[0]) && u.isIndex(l[1])) {
            var c = n ? n[l] : l,
                f = r ? r[c] : c;
            void 0 !== (i = f) && i < t.length && (t[f].selected = 1);
          }
        }
      }, u.selIndices2selPoints = function (t) {
        var e = t.selectedpoints,
            r = t._indexToPoints;

        if (r) {
          for (var n = A(r), i = [], a = 0; a < e.length; a++) {
            var o = e[a];

            if (u.isIndex(o)) {
              var s = n[o];
              u.isIndex(s) && i.push(s);
            }
          }

          return i;
        }

        return e;
      }, u.getTargetArray = function (t, e) {
        var r = e.target;

        if ("string" == typeof r && r) {
          var n = u.nestedProperty(t, r).get();
          return !!Array.isArray(n) && n;
        }

        return !!Array.isArray(r) && r;
      }, u.minExtend = function (t, e) {
        var r = {};
        "object" != _typeof(e) && (e = {});
        var n,
            i,
            a,
            o = Object.keys(t);

        for (n = 0; n < o.length; n++) {
          a = t[i = o[n]], "_" !== i.charAt(0) && "function" != typeof a && ("module" === i ? r[i] = a : Array.isArray(a) ? r[i] = "colorscale" === i ? a.slice() : a.slice(0, 3) : u.isTypedArray(a) ? r[i] = a.subarray(0, 3) : r[i] = a && "object" == _typeof(a) ? u.minExtend(t[i], e[i]) : a);
        }

        for (o = Object.keys(e), n = 0; n < o.length; n++) {
          "object" == _typeof(a = e[i = o[n]]) && i in r && "object" == _typeof(r[i]) || (r[i] = a);
        }

        return r;
      }, u.titleCase = function (t) {
        return t.charAt(0).toUpperCase() + t.substr(1);
      }, u.containsAny = function (t, e) {
        for (var r = 0; r < e.length; r++) {
          if (-1 !== t.indexOf(e[r])) return !0;
        }

        return !1;
      }, u.isIE = function () {
        return void 0 !== window.navigator.msSaveBlob;
      };
      var S = /Version\/[\d\.]+.*Safari/;

      u.isSafari = function () {
        return S.test(window.navigator.userAgent);
      };

      var E = /iPad|iPhone|iPod/;

      u.isIOS = function () {
        return E.test(window.navigator.userAgent);
      };

      var L = /Firefox\/(\d+)\.\d+/;
      u.getFirefoxVersion = function () {
        var t = L.exec(window.navigator.userAgent);

        if (t && 2 === t.length) {
          var e = parseInt(t[1]);
          if (!isNaN(e)) return e;
        }

        return null;
      }, u.isD3Selection = function (t) {
        return t instanceof n.selection;
      }, u.ensureSingle = function (t, e, r, n) {
        var i = t.select(e + (r ? "." + r : ""));
        if (i.size()) return i;
        var a = t.append(e);
        return r && a.classed(r, !0), n && a.call(n), a;
      }, u.ensureSingleById = function (t, e, r, n) {
        var i = t.select(e + "#" + r);
        if (i.size()) return i;
        var a = t.append(e).attr("id", r);
        return n && a.call(n), a;
      }, u.objectFromPath = function (t, e) {
        for (var r, n = t.split("."), i = r = {}, a = 0; a < n.length; a++) {
          var o = n[a],
              s = null,
              l = n[a].match(/(.*)\[([0-9]+)\]/);
          l ? (o = l[1], s = l[2], r = r[o] = [], a === n.length - 1 ? r[s] = e : r[s] = {}, r = r[s]) : (a === n.length - 1 ? r[o] = e : r[o] = {}, r = r[o]);
        }

        return i;
      };
      var C = /^([^\[\.]+)\.(.+)?/,
          P = /^([^\.]+)\[([0-9]+)\](\.)?(.+)?/;
      u.expandObjectPaths = function (t) {
        var e, r, n, i, a, o, s;
        if ("object" == _typeof(t) && !Array.isArray(t)) for (r in t) {
          t.hasOwnProperty(r) && ((e = r.match(C)) ? (i = t[r], n = e[1], delete t[r], t[n] = u.extendDeepNoArrays(t[n] || {}, u.objectFromPath(r, u.expandObjectPaths(i))[n])) : (e = r.match(P)) ? (i = t[r], n = e[1], a = parseInt(e[2]), delete t[r], t[n] = t[n] || [], "." === e[3] ? (s = e[4], o = t[n][a] = t[n][a] || {}, u.extendDeepNoArrays(o, u.objectFromPath(s, u.expandObjectPaths(i)))) : t[n][a] = u.expandObjectPaths(i)) : t[r] = u.expandObjectPaths(t[r]));
        }
        return t;
      }, u.numSeparate = function (t, e, r) {
        if (r || (r = !1), "string" != typeof e || 0 === e.length) throw new Error("Separator string required for formatting!");
        "number" == typeof t && (t = String(t));
        var n = /(\d+)(\d{3})/,
            i = e.charAt(0),
            a = e.charAt(1),
            o = t.split("."),
            s = o[0],
            l = o.length > 1 ? i + o[1] : "";
        if (a && (o.length > 1 || s.length > 4 || r)) for (; n.test(s);) {
          s = s.replace(n, "$1" + a + "$2");
        }
        return s + l;
      }, u.TEMPLATE_STRING_REGEX = /%{([^\s%{}:]*)([:|\|][^}]*)?}/g;
      var I = /^\w*$/;

      u.templateString = function (t, e) {
        var r = {};
        return t.replace(u.TEMPLATE_STRING_REGEX, function (t, n) {
          var i;
          return I.test(n) ? i = e[n] : (r[n] = r[n] || u.nestedProperty(e, n).get, i = r[n]()), u.isValidTextValue(i) ? i : "";
        });
      };

      var O = {
        max: 10,
        count: 0,
        name: "hovertemplate"
      };

      u.hovertemplateString = function () {
        return R.apply(O, arguments);
      };

      var z = {
        max: 10,
        count: 0,
        name: "texttemplate"
      };

      u.texttemplateString = function () {
        return R.apply(z, arguments);
      };

      var D = /^[:|\|]/;

      function R(t, e, r) {
        var a = this,
            o = arguments;
        e || (e = {});
        var s = {};
        return t.replace(u.TEMPLATE_STRING_REGEX, function (t, l, c) {
          var f,
              h,
              p,
              d = "_xother" === l || "_yother" === l,
              m = "_xother_" === l || "_yother_" === l,
              g = "xother_" === l || "yother_" === l,
              v = "xother" === l || "yother" === l || d || g || m,
              y = l;

          if ((d || m) && (y = y.substring(1)), (g || m) && (y = y.substring(0, y.length - 1)), v) {
            if (void 0 === (f = e[y])) return "";
          } else for (p = 3; p < o.length; p++) {
            if (h = o[p]) {
              if (h.hasOwnProperty(y)) {
                f = h[y];
                break;
              }

              if (I.test(y) || (f = u.nestedProperty(h, y).get(), (f = s[y] || u.nestedProperty(h, y).get()) && (s[y] = f)), void 0 !== f) break;
            }
          }

          if (void 0 === f && a) return a.count < a.max && (u.warn("Variable '" + y + "' in " + a.name + " could not be found!"), f = t), a.count === a.max && u.warn("Too many " + a.name + " warnings - additional warnings will be suppressed"), a.count++, t;

          if (c) {
            var x;

            if (":" === c[0] && (f = (x = r ? r.numberFormat : n.format)(c.replace(D, ""))(f)), "|" === c[0]) {
              x = r ? r.timeFormat : i;
              var b = u.dateTime2ms(f);
              f = u.formatDate(b, c.replace(D, ""), !1, x);
            }
          } else {
            var _ = y + "Label";

            e.hasOwnProperty(_) && (f = e[_]);
          }

          return v && (f = "(" + f + ")", (d || m) && (f = " " + f), (g || m) && (f += " ")), f;
        });
      }

      u.subplotSort = function (t, e) {
        for (var r = Math.min(t.length, e.length) + 1, n = 0, i = 0, a = 0; a < r; a++) {
          var o = t.charCodeAt(a) || 0,
              s = e.charCodeAt(a) || 0,
              l = o >= 48 && o <= 57,
              c = s >= 48 && s <= 57;

          if (l && (n = 10 * n + o - 48), c && (i = 10 * i + s - 48), !l || !c) {
            if (n !== i) return n - i;
            if (o !== s) return o - s;
          }
        }

        return i - n;
      };

      var F = 2e9;
      u.seedPseudoRandom = function () {
        F = 2e9;
      }, u.pseudoRandom = function () {
        var t = F;
        return F = (69069 * F + 1) % 4294967296, Math.abs(F - t) < 429496729 ? u.pseudoRandom() : F / 4294967296;
      }, u.fillText = function (t, e, r) {
        var n = Array.isArray(r) ? function (t) {
          r.push(t);
        } : function (t) {
          r.text = t;
        },
            i = u.extractOption(t, e, "htx", "hovertext");
        if (u.isValidTextValue(i)) return n(i);
        var a = u.extractOption(t, e, "tx", "text");
        return u.isValidTextValue(a) ? n(a) : void 0;
      }, u.isValidTextValue = function (t) {
        return t || 0 === t;
      }, u.formatPercent = function (t, e) {
        e = e || 0;

        for (var r = (Math.round(100 * t * Math.pow(10, e)) * Math.pow(.1, e)).toFixed(e) + "%", n = 0; n < e; n++) {
          -1 !== r.indexOf(".") && (r = (r = r.replace("0%", "%")).replace(".%", "%"));
        }

        return r;
      }, u.isHidden = function (t) {
        var e = window.getComputedStyle(t).display;
        return !e || "none" === e;
      }, u.strTranslate = function (t, e) {
        return t || e ? "translate(" + t + "," + e + ")" : "";
      }, u.strRotate = function (t) {
        return t ? "rotate(" + t + ")" : "";
      }, u.strScale = function (t) {
        return 1 !== t ? "scale(" + t + ")" : "";
      }, u.getTextTransform = function (t) {
        var e = t.noCenter,
            r = t.textX,
            n = t.textY,
            i = t.targetX,
            a = t.targetY,
            o = t.anchorX || 0,
            s = t.anchorY || 0,
            l = t.rotate,
            c = t.scale;
        return c ? c > 1 && (c = 1) : c = 0, u.strTranslate(i - c * (r + o), a - c * (n + s)) + u.strScale(c) + (l ? "rotate(" + l + (e ? "" : " " + r + " " + n) + ")" : "");
      }, u.ensureUniformFontSize = function (t, e) {
        var r = u.extendFlat({}, e);
        return r.size = Math.max(e.size, t._fullLayout.uniformtext.minsize || 0), r;
      }, u.join2 = function (t, e, r) {
        var n = t.length;
        return n > 1 ? t.slice(0, -1).join(e) + r + t[n - 1] : t.join(e);
      }, u.bigFont = function (t) {
        return Math.round(1.2 * t);
      };
      var B = u.getFirefoxVersion(),
          N = null !== B && B < 86;

      u.getPositionFromD3Event = function () {
        return N ? [n.event.layerX, n.event.layerY] : [n.event.offsetX, n.event.offsetY];
      };
    }, {
      "../constants/numerical": 771,
      "./anchor_utils": 775,
      "./angles": 776,
      "./array": 777,
      "./clean_number": 778,
      "./clear_responsive": 780,
      "./coerce": 781,
      "./dates": 782,
      "./dom": 783,
      "./extend": 785,
      "./filter_unique": 786,
      "./filter_visible": 787,
      "./geometry2d": 790,
      "./identity": 793,
      "./increment": 794,
      "./is_plain_object": 796,
      "./keyed_container": 797,
      "./localize": 798,
      "./loggers": 799,
      "./make_trace_groups": 800,
      "./matrix": 801,
      "./mod": 802,
      "./nested_property": 803,
      "./noop": 804,
      "./notifier": 805,
      "./preserve_drawing_buffer": 809,
      "./push_unique": 810,
      "./regex": 812,
      "./relative_attr": 813,
      "./relink_private": 814,
      "./search": 815,
      "./stats": 818,
      "./throttle": 821,
      "./to_log_range": 822,
      "@plotly/d3": 57,
      "d3-time-format": 167,
      "fast-isnumeric": 240
    }],
    796: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        return window && window.process && window.process.versions ? "[object Object]" === Object.prototype.toString.call(t) : "[object Object]" === Object.prototype.toString.call(t) && Object.getPrototypeOf(t).hasOwnProperty("hasOwnProperty");
      };
    }, {}],
    797: [function (t, e, r) {
      "use strict";

      var n = t("./nested_property"),
          i = /^\w*$/;

      e.exports = function (t, e, r, a) {
        var o, s, l;
        r = r || "name", a = a || "value";
        var c = {};
        e && e.length ? (l = n(t, e), s = l.get()) : s = t, e = e || "";
        var u = {};
        if (s) for (o = 0; o < s.length; o++) {
          u[s[o][r]] = o;
        }
        var f = i.test(a),
            h = {
          set: function set(t, e) {
            var i = null === e ? 4 : 0;

            if (!s) {
              if (!l || 4 === i) return;
              s = [], l.set(s);
            }

            var o = u[t];

            if (void 0 === o) {
              if (4 === i) return;
              i |= 3, o = s.length, u[t] = o;
            } else e !== (f ? s[o][a] : n(s[o], a).get()) && (i |= 2);

            var p = s[o] = s[o] || {};
            return p[r] = t, f ? p[a] = e : n(p, a).set(e), null !== e && (i &= -5), c[o] = c[o] | i, h;
          },
          get: function get(t) {
            if (s) {
              var e = u[t];
              return void 0 === e ? void 0 : f ? s[e][a] : n(s[e], a).get();
            }
          },
          rename: function rename(t, e) {
            var n = u[t];
            return void 0 === n || (c[n] = 1 | c[n], u[e] = n, delete u[t], s[n][r] = e), h;
          },
          remove: function remove(t) {
            var e = u[t];
            if (void 0 === e) return h;
            var i = s[e];
            if (Object.keys(i).length > 2) return c[e] = 2 | c[e], h.set(t, null);

            if (f) {
              for (o = e; o < s.length; o++) {
                c[o] = 3 | c[o];
              }

              for (o = e; o < s.length; o++) {
                u[s[o][r]]--;
              }

              s.splice(e, 1), delete u[t];
            } else n(i, a).set(null), c[e] = 6 | c[e];

            return h;
          },
          constructUpdate: function constructUpdate() {
            for (var t, i, o = {}, l = Object.keys(c), u = 0; u < l.length; u++) {
              i = l[u], t = e + "[" + i + "]", s[i] ? (1 & c[i] && (o[t + "." + r] = s[i][r]), 2 & c[i] && (o[t + "." + a] = f ? 4 & c[i] ? null : s[i][a] : 4 & c[i] ? null : n(s[i], a).get())) : o[t] = null;
            }

            return o;
          }
        };
        return h;
      };
    }, {
      "./nested_property": 803
    }],
    798: [function (t, e, r) {
      "use strict";

      var n = t("../registry");

      e.exports = function (t, e) {
        for (var r = t._context.locale, i = 0; i < 2; i++) {
          for (var a = t._context.locales, o = 0; o < 2; o++) {
            var s = (a[r] || {}).dictionary;

            if (s) {
              var l = s[e];
              if (l) return l;
            }

            a = n.localeRegistry;
          }

          var c = r.split("-")[0];
          if (c === r) break;
          r = c;
        }

        return e;
      };
    }, {
      "../registry": 923
    }],
    799: [function (t, e, r) {
      "use strict";

      var n = t("../plot_api/plot_config").dfltConfig,
          i = t("./notifier"),
          a = e.exports = {};
      a.log = function () {
        var t;

        if (n.logging > 1) {
          var e = ["LOG:"];

          for (t = 0; t < arguments.length; t++) {
            e.push(arguments[t]);
          }

          console.trace.apply(console, e);
        }

        if (n.notifyOnLogging > 1) {
          var r = [];

          for (t = 0; t < arguments.length; t++) {
            r.push(arguments[t]);
          }

          i(r.join("<br>"), "long");
        }
      }, a.warn = function () {
        var t;

        if (n.logging > 0) {
          var e = ["WARN:"];

          for (t = 0; t < arguments.length; t++) {
            e.push(arguments[t]);
          }

          console.trace.apply(console, e);
        }

        if (n.notifyOnLogging > 0) {
          var r = [];

          for (t = 0; t < arguments.length; t++) {
            r.push(arguments[t]);
          }

          i(r.join("<br>"), "stick");
        }
      }, a.error = function () {
        var t;

        if (n.logging > 0) {
          var e = ["ERROR:"];

          for (t = 0; t < arguments.length; t++) {
            e.push(arguments[t]);
          }

          console.error.apply(console, e);
        }

        if (n.notifyOnLogging > 0) {
          var r = [];

          for (t = 0; t < arguments.length; t++) {
            r.push(arguments[t]);
          }

          i(r.join("<br>"), "stick");
        }
      };
    }, {
      "../plot_api/plot_config": 832,
      "./notifier": 805
    }],
    800: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3");

      e.exports = function (t, e, r) {
        var i = t.selectAll("g." + r.replace(/\s/g, ".")).data(e, function (t) {
          return t[0].trace.uid;
        });
        i.exit().remove(), i.enter().append("g").attr("class", r), i.order();
        var a = t.classed("rangeplot") ? "nodeRangePlot3" : "node3";
        return i.each(function (t) {
          t[0][a] = n.select(this);
        }), i;
      };
    }, {
      "@plotly/d3": 57
    }],
    801: [function (t, e, r) {
      "use strict";

      var n = t("gl-mat4");
      r.init2dArray = function (t, e) {
        for (var r = new Array(t), n = 0; n < t; n++) {
          r[n] = new Array(e);
        }

        return r;
      }, r.transposeRagged = function (t) {
        var e,
            r,
            n = 0,
            i = t.length;

        for (e = 0; e < i; e++) {
          n = Math.max(n, t[e].length);
        }

        var a = new Array(n);

        for (e = 0; e < n; e++) {
          for (a[e] = new Array(i), r = 0; r < i; r++) {
            a[e][r] = t[r][e];
          }
        }

        return a;
      }, r.dot = function (t, e) {
        if (!t.length || !e.length || t.length !== e.length) return null;
        var n,
            i,
            a = t.length;
        if (t[0].length) for (n = new Array(a), i = 0; i < a; i++) {
          n[i] = r.dot(t[i], e);
        } else if (e[0].length) {
          var o = r.transposeRagged(e);

          for (n = new Array(o.length), i = 0; i < o.length; i++) {
            n[i] = r.dot(t, o[i]);
          }
        } else for (n = 0, i = 0; i < a; i++) {
          n += t[i] * e[i];
        }
        return n;
      }, r.translationMatrix = function (t, e) {
        return [[1, 0, t], [0, 1, e], [0, 0, 1]];
      }, r.rotationMatrix = function (t) {
        var e = t * Math.PI / 180;
        return [[Math.cos(e), -Math.sin(e), 0], [Math.sin(e), Math.cos(e), 0], [0, 0, 1]];
      }, r.rotationXYMatrix = function (t, e, n) {
        return r.dot(r.dot(r.translationMatrix(e, n), r.rotationMatrix(t)), r.translationMatrix(-e, -n));
      }, r.apply3DTransform = function (t) {
        return function () {
          var e = arguments,
              n = 1 === arguments.length ? e[0] : [e[0], e[1], e[2] || 0];
          return r.dot(t, [n[0], n[1], n[2], 1]).slice(0, 3);
        };
      }, r.apply2DTransform = function (t) {
        return function () {
          var e = arguments;
          3 === e.length && (e = e[0]);
          var n = 1 === arguments.length ? e[0] : [e[0], e[1]];
          return r.dot(t, [n[0], n[1], 1]).slice(0, 2);
        };
      }, r.apply2DTransform2 = function (t) {
        var e = r.apply2DTransform(t);
        return function (t) {
          return e(t.slice(0, 2)).concat(e(t.slice(2, 4)));
        };
      }, r.convertCssMatrix = function (t) {
        if (t) {
          var e = t.length;
          if (16 === e) return t;
          if (6 === e) return [t[0], t[1], 0, 0, t[2], t[3], 0, 0, 0, 0, 1, 0, t[4], t[5], 0, 1];
        }

        return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
      }, r.inverseTransformMatrix = function (t) {
        var e = [];
        return n.invert(e, t), [[e[0], e[1], e[2], e[3]], [e[4], e[5], e[6], e[7]], [e[8], e[9], e[10], e[11]], [e[12], e[13], e[14], e[15]]];
      };
    }, {
      "gl-mat4": 289
    }],
    802: [function (t, e, r) {
      "use strict";

      e.exports = {
        mod: function mod(t, e) {
          var r = t % e;
          return r < 0 ? r + e : r;
        },
        modHalf: function modHalf(t, e) {
          return Math.abs(t) > e / 2 ? t - Math.round(t / e) * e : t;
        }
      };
    }, {}],
    803: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("./array").isArrayOrTypedArray;

      function a(t, e) {
        return function () {
          var r,
              n,
              o,
              s,
              l,
              c = t;

          for (s = 0; s < e.length - 1; s++) {
            if (-1 === (r = e[s])) {
              for (n = !0, o = [], l = 0; l < c.length; l++) {
                o[l] = a(c[l], e.slice(s + 1))(), o[l] !== o[0] && (n = !1);
              }

              return n ? o[0] : o;
            }

            if ("number" == typeof r && !i(c)) return;
            if ("object" != _typeof(c = c[r]) || null === c) return;
          }

          if ("object" == _typeof(c) && null !== c && null !== (o = c[e[s]])) return o;
        };
      }

      e.exports = function (t, e) {
        if (n(e)) e = String(e);else if ("string" != typeof e || "[-1]" === e.substr(e.length - 4)) throw "bad property string";

        for (var r, i, o, s = 0, c = e.split("."); s < c.length;) {
          if (r = String(c[s]).match(/^([^\[\]]*)((\[\-?[0-9]*\])+)$/)) {
            if (r[1]) c[s] = r[1];else {
              if (0 !== s) throw "bad property string";
              c.splice(0, 1);
            }

            for (i = r[2].substr(1, r[2].length - 2).split("]["), o = 0; o < i.length; o++) {
              s++, c.splice(s, 0, Number(i[o]));
            }
          }

          s++;
        }

        return "object" != _typeof(t) ? function (t, e, r) {
          return {
            set: function set() {
              throw "bad container";
            },
            get: function get() {},
            astr: e,
            parts: r,
            obj: t
          };
        }(t, e, c) : {
          set: l(t, c, e),
          get: a(t, c),
          astr: e,
          parts: c,
          obj: t
        };
      };

      var o = /(^|\.)args\[/;

      function s(t, e) {
        return void 0 === t || null === t && !e.match(o);
      }

      function l(t, e, r) {
        return function (n) {
          var a,
              o,
              l = t,
              h = "",
              p = [[t, h]],
              d = s(n, r);

          for (o = 0; o < e.length - 1; o++) {
            if ("number" == typeof (a = e[o]) && !i(l)) throw "array index but container is not an array";

            if (-1 === a) {
              if (d = !u(l, e.slice(o + 1), n, r)) break;
              return;
            }

            if (!f(l, a, e[o + 1], d)) break;
            if ("object" != _typeof(l = l[a]) || null === l) throw "container is not an object";
            h = c(h, a), p.push([l, h]);
          }

          if (d) {
            if (o === e.length - 1 && (delete l[e[o]], Array.isArray(l) && +e[o] == l.length - 1)) for (; l.length && void 0 === l[l.length - 1];) {
              l.pop();
            }
          } else l[e[o]] = n;
        };
      }

      function c(t, e) {
        var r = e;
        return n(e) ? r = "[" + e + "]" : t && (r = "." + e), t + r;
      }

      function u(t, e, r, n) {
        var a,
            o = i(r),
            c = !0,
            u = r,
            h = n.replace("-1", 0),
            p = !o && s(r, h),
            d = e[0];

        for (a = 0; a < t.length; a++) {
          h = n.replace("-1", a), o && (p = s(u = r[a % r.length], h)), p && (c = !1), f(t, a, d, p) && l(t[a], e, n.replace("-1", a))(u);
        }

        return c;
      }

      function f(t, e, r, n) {
        if (void 0 === t[e]) {
          if (n) return !1;
          t[e] = "number" == typeof r ? [] : {};
        }

        return !0;
      }
    }, {
      "./array": 777,
      "fast-isnumeric": 240
    }],
    804: [function (t, e, r) {
      "use strict";

      e.exports = function () {};
    }, {}],
    805: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("fast-isnumeric"),
          a = [];

      e.exports = function (t, e) {
        if (-1 === a.indexOf(t)) {
          a.push(t);
          var r = 1e3;
          i(e) ? r = e : "long" === e && (r = 3e3);
          var o = n.select("body").selectAll(".plotly-notifier").data([0]);
          o.enter().append("div").classed("plotly-notifier", !0), o.selectAll(".notifier-note").data(a).enter().append("div").classed("notifier-note", !0).style("opacity", 0).each(function (t) {
            var i = n.select(this);
            i.append("button").classed("notifier-close", !0).html("&times;").on("click", function () {
              i.transition().call(s);
            });

            for (var a = i.append("p"), o = t.split(/<br\s*\/?>/g), l = 0; l < o.length; l++) {
              l && a.append("br"), a.append("span").text(o[l]);
            }

            "stick" === e ? i.transition().duration(350).style("opacity", 1) : i.transition().duration(700).style("opacity", 1).transition().delay(r).call(s);
          });
        }

        function s(t) {
          t.duration(700).style("opacity", 0).each("end", function (t) {
            var e = a.indexOf(t);
            -1 !== e && a.splice(e, 1), n.select(this).remove();
          });
        }
      };
    }, {
      "@plotly/d3": 57,
      "fast-isnumeric": 240
    }],
    806: [function (t, e, r) {
      "use strict";

      var n = t("./setcursor"),
          i = "data-savedcursor";

      e.exports = function (t, e) {
        var r = t.attr(i);

        if (e) {
          if (!r) {
            for (var a = (t.attr("class") || "").split(" "), o = 0; o < a.length; o++) {
              var s = a[o];
              0 === s.indexOf("cursor-") && t.attr(i, s.substr(7)).classed(s, !1);
            }

            t.attr(i) || t.attr(i, "!!");
          }

          n(t, e);
        } else r && (t.attr(i, null), "!!" === r ? n(t) : n(t, r));
      };
    }, {
      "./setcursor": 816
    }],
    807: [function (t, e, r) {
      "use strict";

      var n = t("./matrix").dot,
          i = t("../constants/numerical").BADNUM,
          a = e.exports = {};
      a.tester = function (t) {
        var e,
            r = t.slice(),
            n = r[0][0],
            a = n,
            o = r[0][1],
            s = o;

        for (r.push(r[0]), e = 1; e < r.length; e++) {
          n = Math.min(n, r[e][0]), a = Math.max(a, r[e][0]), o = Math.min(o, r[e][1]), s = Math.max(s, r[e][1]);
        }

        var l,
            c = !1;
        5 === r.length && (r[0][0] === r[1][0] ? r[2][0] === r[3][0] && r[0][1] === r[3][1] && r[1][1] === r[2][1] && (c = !0, l = function l(t) {
          return t[0] === r[0][0];
        }) : r[0][1] === r[1][1] && r[2][1] === r[3][1] && r[0][0] === r[3][0] && r[1][0] === r[2][0] && (c = !0, l = function l(t) {
          return t[1] === r[0][1];
        }));
        var u = !0,
            f = r[0];

        for (e = 1; e < r.length; e++) {
          if (f[0] !== r[e][0] || f[1] !== r[e][1]) {
            u = !1;
            break;
          }
        }

        return {
          xmin: n,
          xmax: a,
          ymin: o,
          ymax: s,
          pts: r,
          contains: c ? function (t, e) {
            var r = t[0],
                c = t[1];
            return !(r === i || r < n || r > a || c === i || c < o || c > s) && (!e || !l(t));
          } : function (t, e) {
            var l = t[0],
                c = t[1];
            if (l === i || l < n || l > a || c === i || c < o || c > s) return !1;
            var u,
                f,
                h,
                p,
                d,
                m = r.length,
                g = r[0][0],
                v = r[0][1],
                y = 0;

            for (u = 1; u < m; u++) {
              if (f = g, h = v, g = r[u][0], v = r[u][1], !(l < (p = Math.min(f, g)) || l > Math.max(f, g) || c > Math.max(h, v))) if (c < Math.min(h, v)) l !== p && y++;else {
                if (c === (d = g === f ? c : h + (l - f) * (v - h) / (g - f))) return 1 !== u || !e;
                c <= d && l !== p && y++;
              }
            }

            return y % 2 == 1;
          },
          isRect: c,
          degenerate: u
        };
      }, a.isSegmentBent = function (t, e, r, i) {
        var a,
            o,
            s,
            l = t[e],
            c = [t[r][0] - l[0], t[r][1] - l[1]],
            u = n(c, c),
            f = Math.sqrt(u),
            h = [-c[1] / f, c[0] / f];

        for (a = e + 1; a < r; a++) {
          if (o = [t[a][0] - l[0], t[a][1] - l[1]], (s = n(o, c)) < 0 || s > u || Math.abs(n(o, h)) > i) return !0;
        }

        return !1;
      }, a.filter = function (t, e) {
        var r = [t[0]],
            n = 0,
            i = 0;

        function o(o) {
          t.push(o);
          var s = r.length,
              l = n;
          r.splice(i + 1);

          for (var c = l + 1; c < t.length; c++) {
            (c === t.length - 1 || a.isSegmentBent(t, l, c + 1, e)) && (r.push(t[c]), r.length < s - 2 && (n = c, i = r.length - 1), l = c);
          }
        }

        t.length > 1 && o(t.pop());
        return {
          addPt: o,
          raw: t,
          filtered: r
        };
      };
    }, {
      "../constants/numerical": 771,
      "./matrix": 801
    }],
    808: [function (t, e, r) {
      (function (r) {
        (function () {
          "use strict";

          var n = t("./show_no_webgl_msg"),
              i = t("regl");

          e.exports = function (t, e) {
            var a = t._fullLayout,
                o = !0;
            return a._glcanvas.each(function (n) {
              if (!n.regl && (!n.pick || a._has("parcoords"))) {
                try {
                  n.regl = i({
                    canvas: this,
                    attributes: {
                      antialias: !n.pick,
                      preserveDrawingBuffer: !0
                    },
                    pixelRatio: t._context.plotGlPixelRatio || r.devicePixelRatio,
                    extensions: e || []
                  });
                } catch (t) {
                  o = !1;
                }

                n.regl || (o = !1), o && this.addEventListener("webglcontextlost", function (e) {
                  t && t.emit && t.emit("plotly_webglcontextlost", {
                    event: e,
                    layer: n.key
                  });
                }, !1);
              }
            }), o || n({
              container: a._glcontainer.node()
            }), o;
          };
        }).call(this);
      }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
    }, {
      "./show_no_webgl_msg": 817,
      regl: 532
    }],
    809: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("is-mobile");

      e.exports = function (t) {
        var e;
        if ("string" != typeof (e = t && t.hasOwnProperty("userAgent") ? t.userAgent : function () {
          var t;
          "undefined" != typeof navigator && (t = navigator.userAgent);
          t && t.headers && "string" == typeof t.headers["user-agent"] && (t = t.headers["user-agent"]);
          return t;
        }())) return !0;
        var r = i({
          ua: {
            headers: {
              "user-agent": e
            }
          },
          tablet: !0,
          featureDetect: !1
        });
        if (!r) for (var a = e.split(" "), o = 1; o < a.length; o++) {
          if (-1 !== a[o].indexOf("Safari")) for (var s = o - 1; s > -1; s--) {
            var l = a[s];

            if ("Version/" === l.substr(0, 8)) {
              var c = l.substr(8).split(".")[0];
              if (n(c) && (c = +c), c >= 13) return !0;
            }
          }
        }
        return r;
      };
    }, {
      "fast-isnumeric": 240,
      "is-mobile": 446
    }],
    810: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        if (e instanceof RegExp) {
          for (var r = e.toString(), n = 0; n < t.length; n++) {
            if (t[n] instanceof RegExp && t[n].toString() === r) return t;
          }

          t.push(e);
        } else !e && 0 !== e || -1 !== t.indexOf(e) || t.push(e);

        return t;
      };
    }, {}],
    811: [function (t, e, r) {
      "use strict";

      var n = t("../lib"),
          i = t("../plot_api/plot_config").dfltConfig;
      var a = {
        add: function add(t, e, r, n, a) {
          var o, s;
          t.undoQueue = t.undoQueue || {
            index: 0,
            queue: [],
            sequence: !1
          }, s = t.undoQueue.index, t.autoplay ? t.undoQueue.inSequence || (t.autoplay = !1) : (!t.undoQueue.sequence || t.undoQueue.beginSequence ? (o = {
            undo: {
              calls: [],
              args: []
            },
            redo: {
              calls: [],
              args: []
            }
          }, t.undoQueue.queue.splice(s, t.undoQueue.queue.length - s, o), t.undoQueue.index += 1) : o = t.undoQueue.queue[s - 1], t.undoQueue.beginSequence = !1, o && (o.undo.calls.unshift(e), o.undo.args.unshift(r), o.redo.calls.push(n), o.redo.args.push(a)), t.undoQueue.queue.length > i.queueLength && (t.undoQueue.queue.shift(), t.undoQueue.index--));
        },
        startSequence: function startSequence(t) {
          t.undoQueue = t.undoQueue || {
            index: 0,
            queue: [],
            sequence: !1
          }, t.undoQueue.sequence = !0, t.undoQueue.beginSequence = !0;
        },
        stopSequence: function stopSequence(t) {
          t.undoQueue = t.undoQueue || {
            index: 0,
            queue: [],
            sequence: !1
          }, t.undoQueue.sequence = !1, t.undoQueue.beginSequence = !1;
        },
        undo: function undo(t) {
          var e, r;

          if (!(void 0 === t.undoQueue || isNaN(t.undoQueue.index) || t.undoQueue.index <= 0)) {
            for (t.undoQueue.index--, e = t.undoQueue.queue[t.undoQueue.index], t.undoQueue.inSequence = !0, r = 0; r < e.undo.calls.length; r++) {
              a.plotDo(t, e.undo.calls[r], e.undo.args[r]);
            }

            t.undoQueue.inSequence = !1, t.autoplay = !1;
          }
        },
        redo: function redo(t) {
          var e, r;

          if (!(void 0 === t.undoQueue || isNaN(t.undoQueue.index) || t.undoQueue.index >= t.undoQueue.queue.length)) {
            for (e = t.undoQueue.queue[t.undoQueue.index], t.undoQueue.inSequence = !0, r = 0; r < e.redo.calls.length; r++) {
              a.plotDo(t, e.redo.calls[r], e.redo.args[r]);
            }

            t.undoQueue.inSequence = !1, t.autoplay = !1, t.undoQueue.index++;
          }
        }
      };
      a.plotDo = function (t, e, r) {
        t.autoplay = !0, r = function (t, e) {
          for (var r, i = [], a = 0; a < e.length; a++) {
            r = e[a], i[a] = r === t ? r : "object" == _typeof(r) ? Array.isArray(r) ? n.extendDeep([], r) : n.extendDeepAll({}, r) : r;
          }

          return i;
        }(t, r), e.apply(null, r);
      }, e.exports = a;
    }, {
      "../lib": 795,
      "../plot_api/plot_config": 832
    }],
    812: [function (t, e, r) {
      "use strict";

      r.counter = function (t, e, r, n) {
        var i = (e || "") + (r ? "" : "$"),
            a = !1 === n ? "" : "^";
        return "xy" === t ? new RegExp(a + "x([2-9]|[1-9][0-9]+)?y([2-9]|[1-9][0-9]+)?" + i) : new RegExp(a + t + "([2-9]|[1-9][0-9]+)?" + i);
      };
    }, {}],
    813: [function (t, e, r) {
      "use strict";

      var n = /^(.*)(\.[^\.\[\]]+|\[\d\])$/,
          i = /^[^\.\[\]]+$/;

      e.exports = function (t, e) {
        for (; e;) {
          var r = t.match(n);
          if (r) t = r[1];else {
            if (!t.match(i)) throw new Error("bad relativeAttr call:" + [t, e]);
            t = "";
          }
          if ("^" !== e.charAt(0)) break;
          e = e.slice(1);
        }

        return t && "[" !== e.charAt(0) ? t + "." + e : t + e;
      };
    }, {}],
    814: [function (t, e, r) {
      "use strict";

      var n = t("./array").isArrayOrTypedArray,
          i = t("./is_plain_object");

      e.exports = function t(e, r) {
        for (var a in r) {
          var o = r[a],
              s = e[a];
          if (s !== o) if ("_" === a.charAt(0) || "function" == typeof o) {
            if (a in e) continue;
            e[a] = o;
          } else if (n(o) && n(s) && i(o[0])) {
            if ("customdata" === a || "ids" === a) continue;

            for (var l = Math.min(o.length, s.length), c = 0; c < l; c++) {
              s[c] !== o[c] && i(o[c]) && i(s[c]) && t(s[c], o[c]);
            }
          } else i(o) && i(s) && (t(s, o), Object.keys(s).length || delete e[a]);
        }
      };
    }, {
      "./array": 777,
      "./is_plain_object": 796
    }],
    815: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("./loggers"),
          a = t("./identity"),
          o = t("../constants/numerical").BADNUM;

      function s(t, e) {
        return t < e;
      }

      function l(t, e) {
        return t <= e;
      }

      function c(t, e) {
        return t > e;
      }

      function u(t, e) {
        return t >= e;
      }

      r.findBin = function (t, e, r) {
        if (n(e.start)) return r ? Math.ceil((t - e.start) / e.size - 1e-9) - 1 : Math.floor((t - e.start) / e.size + 1e-9);
        var a,
            o,
            f = 0,
            h = e.length,
            p = 0,
            d = h > 1 ? (e[h - 1] - e[0]) / (h - 1) : 1;

        for (o = d >= 0 ? r ? s : l : r ? u : c, t += 1e-9 * d * (r ? -1 : 1) * (d >= 0 ? 1 : -1); f < h && p++ < 100;) {
          o(e[a = Math.floor((f + h) / 2)], t) ? f = a + 1 : h = a;
        }

        return p > 90 && i.log("Long binary search..."), f - 1;
      }, r.sorterAsc = function (t, e) {
        return t - e;
      }, r.sorterDes = function (t, e) {
        return e - t;
      }, r.distinctVals = function (t, e) {
        var n,
            i = (e || {}).unitMinDiff,
            a = t.slice();

        for (a.sort(r.sorterAsc), n = a.length - 1; n > -1 && a[n] === o; n--) {
          ;
        }

        var s = 1;
        i || (s = a[n] - a[0] || 1);

        for (var l, c = s / (n || 1) / 1e4, u = [], f = 0; f <= n; f++) {
          var h = a[f],
              p = h - l;
          void 0 === l ? (u.push(h), l = h) : p > c && (s = Math.min(s, p), u.push(h), l = h);
        }

        return {
          vals: u,
          minDiff: s
        };
      }, r.roundUp = function (t, e, r) {
        for (var n, i = 0, a = e.length - 1, o = 0, s = r ? 0 : 1, l = r ? 1 : 0, c = r ? Math.ceil : Math.floor; i < a && o++ < 100;) {
          e[n = c((i + a) / 2)] <= t ? i = n + s : a = n - l;
        }

        return e[i];
      }, r.sort = function (t, e) {
        for (var r = 0, n = 0, i = 1; i < t.length; i++) {
          var a = e(t[i], t[i - 1]);
          if (a < 0 ? r = 1 : a > 0 && (n = 1), r && n) return t.sort(e);
        }

        return n ? t : t.reverse();
      }, r.findIndexOfMin = function (t, e) {
        e = e || a;

        for (var r, n = 1 / 0, i = 0; i < t.length; i++) {
          var o = e(t[i]);
          o < n && (n = o, r = i);
        }

        return r;
      };
    }, {
      "../constants/numerical": 771,
      "./identity": 793,
      "./loggers": 799,
      "fast-isnumeric": 240
    }],
    816: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        (t.attr("class") || "").split(" ").forEach(function (e) {
          0 === e.indexOf("cursor-") && t.classed(e, !1);
        }), e && t.classed("cursor-" + e, !0);
      };
    }, {}],
    817: [function (t, e, r) {
      "use strict";

      var n = t("../components/color"),
          i = function i() {};

      e.exports = function (t) {
        for (var e in t) {
          "function" == typeof t[e] && (t[e] = i);
        }

        t.destroy = function () {
          t.container.parentNode.removeChild(t.container);
        };

        var r = document.createElement("div");
        r.className = "no-webgl", r.style.cursor = "pointer", r.style.fontSize = "24px", r.style.color = n.defaults[0], r.style.position = "absolute", r.style.left = r.style.top = "0px", r.style.width = r.style.height = "100%", r.style["background-color"] = n.lightLine, r.style["z-index"] = 30;
        var a = document.createElement("p");
        return a.textContent = "WebGL is not supported by your browser - visit https://get.webgl.org for more info", a.style.position = "relative", a.style.top = "50%", a.style.left = "50%", a.style.height = "30%", a.style.width = "50%", a.style.margin = "-15% 0 0 -25%", r.appendChild(a), t.container.appendChild(r), t.container.style.background = "#FFFFFF", t.container.onclick = function () {
          window.open("https://get.webgl.org");
        }, !1;
      };
    }, {
      "../components/color": 658
    }],
    818: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("./array").isArrayOrTypedArray;
      r.aggNums = function (t, e, a, o) {
        var s, l;

        if ((!o || o > a.length) && (o = a.length), n(e) || (e = !1), i(a[0])) {
          for (l = new Array(o), s = 0; s < o; s++) {
            l[s] = r.aggNums(t, e, a[s]);
          }

          a = l;
        }

        for (s = 0; s < o; s++) {
          n(e) ? n(a[s]) && (e = t(+e, +a[s])) : e = a[s];
        }

        return e;
      }, r.len = function (t) {
        return r.aggNums(function (t) {
          return t + 1;
        }, 0, t);
      }, r.mean = function (t, e) {
        return e || (e = r.len(t)), r.aggNums(function (t, e) {
          return t + e;
        }, 0, t) / e;
      }, r.midRange = function (t) {
        if (void 0 !== t && 0 !== t.length) return (r.aggNums(Math.max, null, t) + r.aggNums(Math.min, null, t)) / 2;
      }, r.variance = function (t, e, i) {
        return e || (e = r.len(t)), n(i) || (i = r.mean(t, e)), r.aggNums(function (t, e) {
          return t + Math.pow(e - i, 2);
        }, 0, t) / e;
      }, r.stdev = function (t, e, n) {
        return Math.sqrt(r.variance(t, e, n));
      }, r.median = function (t) {
        var e = t.slice().sort();
        return r.interp(e, .5);
      }, r.interp = function (t, e) {
        if (!n(e)) throw "n should be a finite number";
        if ((e = e * t.length - .5) < 0) return t[0];
        if (e > t.length - 1) return t[t.length - 1];
        var r = e % 1;
        return r * t[Math.ceil(e)] + (1 - r) * t[Math.floor(e)];
      };
    }, {
      "./array": 777,
      "fast-isnumeric": 240
    }],
    819: [function (t, e, r) {
      "use strict";

      var n = t("color-normalize");

      e.exports = function (t) {
        return t ? n(t) : [0, 0, 0, 1];
      };
    }, {
      "color-normalize": 126
    }],
    820: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../lib"),
          a = i.strTranslate,
          o = t("../constants/xmlns_namespaces"),
          s = t("../constants/alignment").LINE_SPACING;

      function l(t, e) {
        return t.node().getBoundingClientRect()[e];
      }

      var c = /([^$]*)([$]+[^$]*[$]+)([^$]*)/;

      r.convertToTspans = function (t, e, A) {
        var S = t.text(),
            L = !t.attr("data-notex") && "undefined" != typeof MathJax && S.match(c),
            C = n.select(t.node().parentNode);

        if (!C.empty()) {
          var P = t.attr("class") ? t.attr("class").split(" ")[0] : "text";
          return P += "-math", C.selectAll("svg." + P).remove(), C.selectAll("g." + P + "-group").remove(), t.style("display", null).attr({
            "data-unformatted": S,
            "data-math": "N"
          }), L ? (e && e._promises || []).push(new Promise(function (e) {
            t.style("display", "none");
            var r = parseInt(t.node().style.fontSize, 10),
                o = {
              fontSize: r
            };
            !function (t, e, r) {
              var a, o, s, l;
              MathJax.Hub.Queue(function () {
                return o = i.extendDeepAll({}, MathJax.Hub.config), s = MathJax.Hub.processSectionDelay, void 0 !== MathJax.Hub.processSectionDelay && (MathJax.Hub.processSectionDelay = 0), MathJax.Hub.Config({
                  messageStyle: "none",
                  tex2jax: {
                    inlineMath: [["$", "$"], ["\\(", "\\)"]]
                  },
                  displayAlign: "left"
                });
              }, function () {
                if ("SVG" !== (a = MathJax.Hub.config.menuSettings.renderer)) return MathJax.Hub.setRenderer("SVG");
              }, function () {
                var r = "math-output-" + i.randstr({}, 64);
                return l = n.select("body").append("div").attr({
                  id: r
                }).style({
                  visibility: "hidden",
                  position: "absolute"
                }).style({
                  "font-size": e.fontSize + "px"
                }).text(t.replace(u, "\\lt ").replace(f, "\\gt ")), MathJax.Hub.Typeset(l.node());
              }, function () {
                var e = n.select("body").select("#MathJax_SVG_glyphs");
                if (l.select(".MathJax_SVG").empty() || !l.select("svg").node()) i.log("There was an error in the tex syntax.", t), r();else {
                  var o = l.select("svg").node().getBoundingClientRect();
                  r(l.select(".MathJax_SVG"), e, o);
                }
                if (l.remove(), "SVG" !== a) return MathJax.Hub.setRenderer(a);
              }, function () {
                return void 0 !== s && (MathJax.Hub.processSectionDelay = s), MathJax.Hub.Config(o);
              });
            }(L[2], o, function (n, i, o) {
              C.selectAll("svg." + P).remove(), C.selectAll("g." + P + "-group").remove();
              var s = n && n.select("svg");
              if (!s || !s.node()) return I(), void e();
              var c = C.append("g").classed(P + "-group", !0).attr({
                "pointer-events": "none",
                "data-unformatted": S,
                "data-math": "Y"
              });
              c.node().appendChild(s.node()), i && i.node() && s.node().insertBefore(i.node().cloneNode(!0), s.node().firstChild), s.attr({
                class: P,
                height: o.height,
                preserveAspectRatio: "xMinYMin meet"
              }).style({
                overflow: "visible",
                "pointer-events": "none"
              });
              var u = t.node().style.fill || "black",
                  f = s.select("g");
              f.attr({
                fill: u,
                stroke: u
              });
              var h = l(f, "width"),
                  p = l(f, "height"),
                  d = +t.attr("x") - h * {
                start: 0,
                middle: .5,
                end: 1
              }[t.attr("text-anchor") || "start"],
                  m = -(r || l(t, "height")) / 4;
              "y" === P[0] ? (c.attr({
                transform: "rotate(" + [-90, +t.attr("x"), +t.attr("y")] + ")" + a(-h / 2, m - p / 2)
              }), s.attr({
                x: +t.attr("x"),
                y: +t.attr("y")
              })) : "l" === P[0] ? s.attr({
                x: t.attr("x"),
                y: m - p / 2
              }) : "a" === P[0] && 0 !== P.indexOf("atitle") ? s.attr({
                x: 0,
                y: m
              }) : s.attr({
                x: d,
                y: +t.attr("y") + m - p / 2
              }), A && A.call(t, c), e(c);
            });
          })) : I(), t;
        }

        function I() {
          C.empty() || (P = t.attr("class") + "-math", C.select("svg." + P).remove()), t.text("").style("white-space", "pre"), function (t, e) {
            e = e.replace(g, " ");
            var r,
                a = !1,
                l = [],
                c = -1;

            function u() {
              c++;
              var e = document.createElementNS(o.svg, "tspan");
              n.select(e).attr({
                class: "line",
                dy: c * s + "em"
              }), t.appendChild(e), r = e;
              var i = l;
              if (l = [{
                node: e
              }], i.length > 1) for (var a = 1; a < i.length; a++) {
                f(i[a]);
              }
            }

            function f(t) {
              var e,
                  i = t.type,
                  a = {};

              if ("a" === i) {
                e = "a";
                var s = t.target,
                    c = t.href,
                    u = t.popup;
                c && (a = {
                  "xlink:xlink:show": "_blank" === s || "_" !== s.charAt(0) ? "new" : "replace",
                  target: s,
                  "xlink:xlink:href": c
                }, u && (a.onclick = 'window.open(this.href.baseVal,this.target.baseVal,"' + u + '");return false;'));
              } else e = "tspan";

              t.style && (a.style = t.style);
              var f = document.createElementNS(o.svg, e);

              if ("sup" === i || "sub" === i) {
                A(r, "\u200B"), r.appendChild(f);
                var h = document.createElementNS(o.svg, "tspan");
                A(h, "\u200B"), n.select(h).attr("dy", d[i]), a.dy = p[i], r.appendChild(f), r.appendChild(h);
              } else r.appendChild(f);

              n.select(f).attr(a), r = t.node = f, l.push(t);
            }

            function A(t, e) {
              t.appendChild(document.createTextNode(e));
            }

            function S(t) {
              if (1 !== l.length) {
                var n = l.pop();
                t !== n.type && i.log("Start tag <" + n.type + "> doesnt match end tag <" + t + ">. Pretending it did match.", e), r = l[l.length - 1].node;
              } else i.log("Ignoring unexpected end tag </" + t + ">.", e);
            }

            x.test(e) ? u() : (r = t, l = [{
              node: t
            }]);

            for (var L = e.split(v), C = 0; C < L.length; C++) {
              var P = L[C],
                  I = P.match(y),
                  O = I && I[2].toLowerCase(),
                  z = h[O];
              if ("br" === O) u();else if (void 0 === z) A(r, E(P));else if (I[1]) S(O);else {
                var D = I[4],
                    R = {
                  type: O
                },
                    F = k(D, b);

                if (F ? (F = F.replace(M, "$1 fill:"), z && (F += ";" + z)) : z && (F = z), F && (R.style = F), "a" === O) {
                  a = !0;
                  var B = k(D, _);

                  if (B) {
                    var N = document.createElement("a");
                    N.href = B, -1 !== m.indexOf(N.protocol) && (R.href = encodeURI(decodeURI(B)), R.target = k(D, w) || "_blank", R.popup = k(D, T));
                  }
                }

                f(R);
              }
            }

            return a;
          }(t.node(), S) && t.style("pointer-events", "all"), r.positionText(t), A && A.call(t);
        }
      };

      var u = /(<|&lt;|&#60;)/g,
          f = /(>|&gt;|&#62;)/g;
      var h = {
        sup: "font-size:70%",
        sub: "font-size:70%",
        b: "font-weight:bold",
        i: "font-style:italic",
        a: "cursor:pointer",
        span: "",
        em: "font-style:italic;font-weight:bold"
      },
          p = {
        sub: "0.3em",
        sup: "-0.6em"
      },
          d = {
        sub: "-0.21em",
        sup: "0.42em"
      },
          m = ["http:", "https:", "mailto:", "", void 0, ":"],
          g = r.NEWLINES = /(\r\n?|\n)/g,
          v = /(<[^<>]*>)/,
          y = /<(\/?)([^ >]*)(\s+(.*))?>/i,
          x = /<br(\s+.*)?>/i;
      r.BR_TAG_ALL = /<br(\s+.*)?>/gi;
      var b = /(^|[\s"'])style\s*=\s*("([^"]*);?"|'([^']*);?')/i,
          _ = /(^|[\s"'])href\s*=\s*("([^"]*)"|'([^']*)')/i,
          w = /(^|[\s"'])target\s*=\s*("([^"\s]*)"|'([^'\s]*)')/i,
          T = /(^|[\s"'])popup\s*=\s*("([\w=,]*)"|'([\w=,]*)')/i;

      function k(t, e) {
        if (!t) return null;
        var r = t.match(e),
            n = r && (r[3] || r[4]);
        return n && E(n);
      }

      var M = /(^|;)\s*color:/;

      r.plainText = function (t, e) {
        for (var r = void 0 !== (e = e || {}).len && -1 !== e.len ? e.len : 1 / 0, n = void 0 !== e.allowedTags ? e.allowedTags : ["br"], i = "...".length, a = t.split(v), o = [], s = "", l = 0, c = 0; c < a.length; c++) {
          var u = a[c],
              f = u.match(y),
              h = f && f[2].toLowerCase();
          if (h) -1 !== n.indexOf(h) && (o.push(u), s = h);else {
            var p = u.length;
            if (l + p < r) o.push(u), l += p;else if (l < r) {
              var d = r - l;
              s && ("br" !== s || d <= i || p <= i) && o.pop(), r > i ? o.push(u.substr(0, d - i) + "...") : o.push(u.substr(0, d));
              break;
            }
            s = "";
          }
        }

        return o.join("");
      };

      var A = {
        mu: "\u03BC",
        amp: "&",
        lt: "<",
        gt: ">",
        nbsp: "\xa0",
        times: "\xd7",
        plusmn: "\xb1",
        deg: "\xb0"
      },
          S = /&(#\d+|#x[\da-fA-F]+|[a-z]+);/g;

      function E(t) {
        return t.replace(S, function (t, e) {
          return ("#" === e.charAt(0) ? function (t) {
            if (t > 1114111) return;
            var e = String.fromCodePoint;
            if (e) return e(t);
            var r = String.fromCharCode;
            return t <= 65535 ? r(t) : r(55232 + (t >> 10), t % 1024 + 56320);
          }("x" === e.charAt(1) ? parseInt(e.substr(2), 16) : parseInt(e.substr(1), 10)) : A[e]) || t;
        });
      }

      function L(t, e, r) {
        var n,
            a,
            o,
            s = r.horizontalAlign,
            l = r.verticalAlign || "top",
            c = t.node().getBoundingClientRect(),
            u = e.node().getBoundingClientRect();
        return a = "bottom" === l ? function () {
          return c.bottom - n.height;
        } : "middle" === l ? function () {
          return c.top + (c.height - n.height) / 2;
        } : function () {
          return c.top;
        }, o = "right" === s ? function () {
          return c.right - n.width;
        } : "center" === s ? function () {
          return c.left + (c.width - n.width) / 2;
        } : function () {
          return c.left;
        }, function () {
          n = this.node().getBoundingClientRect();
          var t = o() - u.left,
              e = a() - u.top,
              s = r.gd || {};

          if (r.gd) {
            s._fullLayout._calcInverseTransform(s);

            var l = i.apply3DTransform(s._fullLayout._invTransform)(t, e);
            t = l[0], e = l[1];
          }

          return this.style({
            top: e + "px",
            left: t + "px",
            "z-index": 1e3
          }), this;
        };
      }

      r.convertEntities = E, r.sanitizeHTML = function (t) {
        t = t.replace(g, " ");

        for (var e = document.createElement("p"), r = e, i = [], a = t.split(v), o = 0; o < a.length; o++) {
          var s = a[o],
              l = s.match(y),
              c = l && l[2].toLowerCase();
          if (c in h) {
            if (l[1]) i.length && (r = i.pop());else {
              var u = l[4],
                  f = k(u, b),
                  p = f ? {
                style: f
              } : {};

              if ("a" === c) {
                var d = k(u, _);

                if (d) {
                  var x = document.createElement("a");

                  if (x.href = d, -1 !== m.indexOf(x.protocol)) {
                    p.href = encodeURI(decodeURI(d));
                    var T = k(u, w);
                    T && (p.target = T);
                  }
                }
              }

              var M = document.createElement(c);
              r.appendChild(M), n.select(M).attr(p), r = M, i.push(M);
            }
          } else r.appendChild(document.createTextNode(E(s)));
        }

        return e.innerHTML;
      }, r.lineCount = function (t) {
        return t.selectAll("tspan.line").size() || 1;
      }, r.positionText = function (t, e, r) {
        return t.each(function () {
          var t = n.select(this);

          function i(e, r) {
            return void 0 === r ? null === (r = t.attr(e)) && (t.attr(e, 0), r = 0) : t.attr(e, r), r;
          }

          var a = i("x", e),
              o = i("y", r);
          "text" === this.nodeName && t.selectAll("tspan.line").attr({
            x: a,
            y: o
          });
        });
      };
      r.makeTextShadow = function (t) {
        var e = "1px ",
            r = "1px ",
            n = "1px ";
        return e + r + n + t + ", -" + e + "-" + r + n + t + ", " + e + "-" + r + n + t + ", -" + e + r + n + t;
      }, r.makeEditable = function (t, e) {
        var r = e.gd,
            i = e.delegate,
            a = n.dispatch("edit", "input", "cancel"),
            o = i || t;
        if (t.style({
          "pointer-events": i ? "none" : "all"
        }), 1 !== t.size()) throw new Error("boo");

        function s() {
          !function () {
            var i = n.select(r).select(".svg-container"),
                o = i.append("div"),
                s = t.node().style,
                c = parseFloat(s.fontSize || 12),
                u = e.text;
            void 0 === u && (u = t.attr("data-unformatted"));
            o.classed("plugin-editable editable", !0).style({
              position: "absolute",
              "font-family": s.fontFamily || "Arial",
              "font-size": c,
              color: e.fill || s.fill || "black",
              opacity: 1,
              "background-color": e.background || "transparent",
              outline: "#ffffff33 1px solid",
              margin: [-c / 8 + 1, 0, 0, -1].join("px ") + "px",
              padding: "0",
              "box-sizing": "border-box"
            }).attr({
              contenteditable: !0
            }).text(u).call(L(t, i, e)).on("blur", function () {
              r._editing = !1, t.text(this.textContent).style({
                opacity: 1
              });
              var e,
                  i = n.select(this).attr("class");
              (e = i ? "." + i.split(" ")[0] + "-math-group" : "[class*=-math-group]") && n.select(t.node().parentNode).select(e).style({
                opacity: 0
              });
              var o = this.textContent;
              n.select(this).transition().duration(0).remove(), n.select(document).on("mouseup", null), a.edit.call(t, o);
            }).on("focus", function () {
              var t = this;
              r._editing = !0, n.select(document).on("mouseup", function () {
                if (n.event.target === t) return !1;
                document.activeElement === o.node() && o.node().blur();
              });
            }).on("keyup", function () {
              27 === n.event.which ? (r._editing = !1, t.style({
                opacity: 1
              }), n.select(this).style({
                opacity: 0
              }).on("blur", function () {
                return !1;
              }).transition().remove(), a.cancel.call(t, this.textContent)) : (a.input.call(t, this.textContent), n.select(this).call(L(t, i, e)));
            }).on("keydown", function () {
              13 === n.event.which && this.blur();
            }).call(l);
          }(), t.style({
            opacity: 0
          });
          var i,
              s = o.attr("class");
          (i = s ? "." + s.split(" ")[0] + "-math-group" : "[class*=-math-group]") && n.select(t.node().parentNode).select(i).style({
            opacity: 0
          });
        }

        function l(t) {
          var e = t.node(),
              r = document.createRange();
          r.selectNodeContents(e);
          var n = window.getSelection();
          n.removeAllRanges(), n.addRange(r), e.focus();
        }

        return e.immediate ? s() : o.on("click", s), n.rebind(t, a, "on");
      };
    }, {
      "../constants/alignment": 763,
      "../constants/xmlns_namespaces": 772,
      "../lib": 795,
      "@plotly/d3": 57
    }],
    821: [function (t, e, r) {
      "use strict";

      var n = {};

      function i(t) {
        t && null !== t.timer && (clearTimeout(t.timer), t.timer = null);
      }

      r.throttle = function (t, e, r) {
        var a = n[t],
            o = Date.now();

        if (!a) {
          for (var s in n) {
            n[s].ts < o - 6e4 && delete n[s];
          }

          a = n[t] = {
            ts: 0,
            timer: null
          };
        }

        function l() {
          r(), a.ts = Date.now(), a.onDone && (a.onDone(), a.onDone = null);
        }

        i(a), o > a.ts + e ? l() : a.timer = setTimeout(function () {
          l(), a.timer = null;
        }, e);
      }, r.done = function (t) {
        var e = n[t];
        return e && e.timer ? new Promise(function (t) {
          var r = e.onDone;

          e.onDone = function () {
            r && r(), t(), e.onDone = null;
          };
        }) : Promise.resolve();
      }, r.clear = function (t) {
        if (t) i(n[t]), delete n[t];else for (var e in n) {
          r.clear(e);
        }
      };
    }, {}],
    822: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric");

      e.exports = function (t, e) {
        if (t > 0) return Math.log(t) / Math.LN10;
        var r = Math.log(Math.min(e[0], e[1])) / Math.LN10;
        return n(r) || (r = Math.log(Math.max(e[0], e[1])) / Math.LN10 - 6), r;
      };
    }, {
      "fast-isnumeric": 240
    }],
    823: [function (t, e, r) {
      "use strict";

      var n = e.exports = {},
          i = t("../plots/geo/constants").locationmodeToLayer,
          a = t("topojson-client").feature;
      n.getTopojsonName = function (t) {
        return [t.scope.replace(/ /g, "-"), "_", t.resolution.toString(), "m"].join("");
      }, n.getTopojsonPath = function (t, e) {
        return t + e + ".json";
      }, n.getTopojsonFeatures = function (t, e) {
        var r = i[t.locationmode],
            n = e.objects[r];
        return a(e, n).features;
      };
    }, {
      "../plots/geo/constants": 875,
      "topojson-client": 593
    }],
    824: [function (t, e, r) {
      "use strict";

      e.exports = {
        moduleType: "locale",
        name: "en-US",
        dictionary: {
          "Click to enter Colorscale title": "Click to enter Colorscale title"
        },
        format: {
          date: "%m/%d/%Y"
        }
      };
    }, {}],
    825: [function (t, e, r) {
      "use strict";

      e.exports = {
        moduleType: "locale",
        name: "en",
        dictionary: {
          "Click to enter Colorscale title": "Click to enter Colourscale title"
        },
        format: {
          days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          periods: ["AM", "PM"],
          dateTime: "%a %b %e %X %Y",
          date: "%d/%m/%Y",
          time: "%H:%M:%S",
          decimal: ".",
          thousands: ",",
          grouping: [3],
          currency: ["$", ""],
          year: "%Y",
          month: "%b %Y",
          dayMonth: "%b %-d",
          dayMonthYear: "%b %-d, %Y"
        }
      };
    }, {}],
    826: [function (t, e, r) {
      "use strict";

      var n = t("../registry");

      e.exports = function (t) {
        for (var e, r, i = n.layoutArrayContainers, a = n.layoutArrayRegexes, o = t.split("[")[0], s = 0; s < a.length; s++) {
          if ((r = t.match(a[s])) && 0 === r.index) {
            e = r[0];
            break;
          }
        }

        if (e || (e = i[i.indexOf(o)]), !e) return !1;
        var l = t.substr(e.length);
        return l ? !!(r = l.match(/^\[(0|[1-9][0-9]*)\](\.(.+))?$/)) && {
          array: e,
          index: Number(r[1]),
          property: r[3] || ""
        } : {
          array: e,
          index: "",
          property: ""
        };
      };
    }, {
      "../registry": 923
    }],
    827: [function (t, e, r) {
      "use strict";

      var n = t("../lib"),
          i = n.extendFlat,
          a = n.isPlainObject,
          o = {
        valType: "flaglist",
        extras: ["none"],
        flags: ["calc", "clearAxisTypes", "plot", "style", "markerSize", "colorbars"]
      },
          s = {
        valType: "flaglist",
        extras: ["none"],
        flags: ["calc", "plot", "legend", "ticks", "axrange", "layoutstyle", "modebar", "camera", "arraydraw", "colorbars"]
      },
          l = o.flags.slice().concat(["fullReplot"]),
          c = s.flags.slice().concat("layoutReplot");

      function u(t) {
        for (var e = {}, r = 0; r < t.length; r++) {
          e[t[r]] = !1;
        }

        return e;
      }

      function f(t, e, r) {
        var n = i({}, t);

        for (var o in n) {
          var s = n[o];
          a(s) && (n[o] = h(s, e, r, o));
        }

        return "from-root" === r && (n.editType = e), n;
      }

      function h(t, e, r, n) {
        if (t.valType) {
          var a = i({}, t);

          if (a.editType = e, Array.isArray(t.items)) {
            a.items = new Array(t.items.length);

            for (var o = 0; o < t.items.length; o++) {
              a.items[o] = h(t.items[o], e, "from-root");
            }
          }

          return a;
        }

        return f(t, e, "_" === n.charAt(0) ? "nested" : "from-root");
      }

      e.exports = {
        traces: o,
        layout: s,
        traceFlags: function traceFlags() {
          return u(l);
        },
        layoutFlags: function layoutFlags() {
          return u(c);
        },
        update: function update(t, e) {
          var r = e.editType;
          if (r && "none" !== r) for (var n = r.split("+"), i = 0; i < n.length; i++) {
            t[n[i]] = !0;
          }
        },
        overrideAll: f
      };
    }, {
      "../lib": 795
    }],
    828: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("gl-mat4/fromQuat"),
          a = t("../registry"),
          o = t("../lib"),
          s = t("../plots/plots"),
          l = t("../plots/cartesian/axis_ids"),
          c = t("../components/color"),
          u = l.cleanId,
          f = l.getFromTrace,
          h = a.traceIs;

      function p(t, e) {
        var r = t[e],
            n = e.charAt(0);
        r && "paper" !== r && (t[e] = u(r, n, !0));
      }

      function d(t) {
        function e(e, r) {
          var n = t[e],
              i = t.title && t.title[r];
          n && !i && (t.title || (t.title = {}), t.title[r] = t[e], delete t[e]);
        }

        t && ("string" != typeof t.title && "number" != typeof t.title || (t.title = {
          text: t.title
        }), e("titlefont", "font"), e("titleposition", "position"), e("titleside", "side"), e("titleoffset", "offset"));
      }

      function m(t) {
        if (!o.isPlainObject(t)) return !1;
        var e = t.name;
        return delete t.name, delete t.showlegend, ("string" == typeof e || "number" == typeof e) && String(e);
      }

      function g(t, e, r, n) {
        if (r && !n) return t;
        if (n && !r) return e;
        if (!t.trim()) return e;
        if (!e.trim()) return t;
        var i,
            a = Math.min(t.length, e.length);

        for (i = 0; i < a && t.charAt(i) === e.charAt(i); i++) {
          ;
        }

        return t.substr(0, i).trim();
      }

      function v(t) {
        var e = "middle",
            r = "center";
        return "string" == typeof t && (-1 !== t.indexOf("top") ? e = "top" : -1 !== t.indexOf("bottom") && (e = "bottom"), -1 !== t.indexOf("left") ? r = "left" : -1 !== t.indexOf("right") && (r = "right")), e + " " + r;
      }

      function y(t, e) {
        return e in t && "object" == _typeof(t[e]) && 0 === Object.keys(t[e]).length;
      }

      r.clearPromiseQueue = function (t) {
        Array.isArray(t._promises) && t._promises.length > 0 && o.log("Clearing previous rejected promises from queue."), t._promises = [];
      }, r.cleanLayout = function (t) {
        var e, n;
        t || (t = {}), t.xaxis1 && (t.xaxis || (t.xaxis = t.xaxis1), delete t.xaxis1), t.yaxis1 && (t.yaxis || (t.yaxis = t.yaxis1), delete t.yaxis1), t.scene1 && (t.scene || (t.scene = t.scene1), delete t.scene1);
        var a = (s.subplotsRegistry.cartesian || {}).attrRegex,
            l = (s.subplotsRegistry.polar || {}).attrRegex,
            f = (s.subplotsRegistry.ternary || {}).attrRegex,
            h = (s.subplotsRegistry.gl3d || {}).attrRegex,
            m = Object.keys(t);

        for (e = 0; e < m.length; e++) {
          var g = m[e];

          if (a && a.test(g)) {
            var v = t[g];
            v.anchor && "free" !== v.anchor && (v.anchor = u(v.anchor)), v.overlaying && (v.overlaying = u(v.overlaying)), v.type || (v.isdate ? v.type = "date" : v.islog ? v.type = "log" : !1 === v.isdate && !1 === v.islog && (v.type = "linear")), "withzero" !== v.autorange && "tozero" !== v.autorange || (v.autorange = !0, v.rangemode = "tozero"), delete v.islog, delete v.isdate, delete v.categories, y(v, "domain") && delete v.domain, void 0 !== v.autotick && (void 0 === v.tickmode && (v.tickmode = v.autotick ? "auto" : "linear"), delete v.autotick), d(v);
          } else if (l && l.test(g)) {
            d(t[g].radialaxis);
          } else if (f && f.test(g)) {
            var x = t[g];
            d(x.aaxis), d(x.baxis), d(x.caxis);
          } else if (h && h.test(g)) {
            var b = t[g],
                _ = b.cameraposition;

            if (Array.isArray(_) && 4 === _[0].length) {
              var w = _[0],
                  T = _[1],
                  k = _[2],
                  M = i([], w),
                  A = [];

              for (n = 0; n < 3; ++n) {
                A[n] = T[n] + k * M[2 + 4 * n];
              }

              b.camera = {
                eye: {
                  x: A[0],
                  y: A[1],
                  z: A[2]
                },
                center: {
                  x: T[0],
                  y: T[1],
                  z: T[2]
                },
                up: {
                  x: 0,
                  y: 0,
                  z: 1
                }
              }, delete b.cameraposition;
            }

            d(b.xaxis), d(b.yaxis), d(b.zaxis);
          }
        }

        var S = Array.isArray(t.annotations) ? t.annotations.length : 0;

        for (e = 0; e < S; e++) {
          var E = t.annotations[e];
          o.isPlainObject(E) && (E.ref && ("paper" === E.ref ? (E.xref = "paper", E.yref = "paper") : "data" === E.ref && (E.xref = "x", E.yref = "y"), delete E.ref), p(E, "xref"), p(E, "yref"));
        }

        var L = Array.isArray(t.shapes) ? t.shapes.length : 0;

        for (e = 0; e < L; e++) {
          var C = t.shapes[e];
          o.isPlainObject(C) && (p(C, "xref"), p(C, "yref"));
        }

        var P = Array.isArray(t.images) ? t.images.length : 0;

        for (e = 0; e < P; e++) {
          var I = t.images[e];
          o.isPlainObject(I) && (p(I, "xref"), p(I, "yref"));
        }

        var O = t.legend;
        return O && (O.x > 3 ? (O.x = 1.02, O.xanchor = "left") : O.x < -2 && (O.x = -.02, O.xanchor = "right"), O.y > 3 ? (O.y = 1.02, O.yanchor = "bottom") : O.y < -2 && (O.y = -.02, O.yanchor = "top")), d(t), "rotate" === t.dragmode && (t.dragmode = "orbit"), c.clean(t), t.template && t.template.layout && r.cleanLayout(t.template.layout), t;
      }, r.cleanData = function (t) {
        for (var e = 0; e < t.length; e++) {
          var n,
              i = t[e];

          if ("histogramy" === i.type && "xbins" in i && !("ybins" in i) && (i.ybins = i.xbins, delete i.xbins), i.error_y && "opacity" in i.error_y) {
            var l = c.defaults,
                f = i.error_y.color || (h(i, "bar") ? c.defaultLine : l[e % l.length]);
            i.error_y.color = c.addOpacity(c.rgb(f), c.opacity(f) * i.error_y.opacity), delete i.error_y.opacity;
          }

          if ("bardir" in i && ("h" !== i.bardir || !h(i, "bar") && "histogram" !== i.type.substr(0, 9) || (i.orientation = "h", r.swapXYData(i)), delete i.bardir), "histogramy" === i.type && r.swapXYData(i), "histogramx" !== i.type && "histogramy" !== i.type || (i.type = "histogram"), "scl" in i && !("colorscale" in i) && (i.colorscale = i.scl, delete i.scl), "reversescl" in i && !("reversescale" in i) && (i.reversescale = i.reversescl, delete i.reversescl), i.xaxis && (i.xaxis = u(i.xaxis, "x")), i.yaxis && (i.yaxis = u(i.yaxis, "y")), h(i, "gl3d") && i.scene && (i.scene = s.subplotsRegistry.gl3d.cleanId(i.scene)), !h(i, "pie-like") && !h(i, "bar-like")) if (Array.isArray(i.textposition)) for (n = 0; n < i.textposition.length; n++) {
            i.textposition[n] = v(i.textposition[n]);
          } else i.textposition && (i.textposition = v(i.textposition));
          var p = a.getModule(i);

          if (p && p.colorbar) {
            var x = p.colorbar.container,
                b = x ? i[x] : i;
            b && b.colorscale && ("YIGnBu" === b.colorscale && (b.colorscale = "YlGnBu"), "YIOrRd" === b.colorscale && (b.colorscale = "YlOrRd"));
          }

          if ("surface" === i.type && o.isPlainObject(i.contours)) {
            var _ = ["x", "y", "z"];

            for (n = 0; n < _.length; n++) {
              var w = i.contours[_[n]];
              o.isPlainObject(w) && (w.highlightColor && (w.highlightcolor = w.highlightColor, delete w.highlightColor), w.highlightWidth && (w.highlightwidth = w.highlightWidth, delete w.highlightWidth));
            }
          }

          if ("candlestick" === i.type || "ohlc" === i.type) {
            var T = !1 !== (i.increasing || {}).showlegend,
                k = !1 !== (i.decreasing || {}).showlegend,
                M = m(i.increasing),
                A = m(i.decreasing);

            if (!1 !== M && !1 !== A) {
              var S = g(M, A, T, k);
              S && (i.name = S);
            } else !M && !A || i.name || (i.name = M || A);
          }

          if (Array.isArray(i.transforms)) {
            var E = i.transforms;

            for (n = 0; n < E.length; n++) {
              var L = E[n];
              if (o.isPlainObject(L)) switch (L.type) {
                case "filter":
                  L.filtersrc && (L.target = L.filtersrc, delete L.filtersrc), L.calendar && (L.valuecalendar || (L.valuecalendar = L.calendar), delete L.calendar);
                  break;

                case "groupby":
                  if (L.styles = L.styles || L.style, L.styles && !Array.isArray(L.styles)) {
                    var C = L.styles,
                        P = Object.keys(C);
                    L.styles = [];

                    for (var I = 0; I < P.length; I++) {
                      L.styles.push({
                        target: P[I],
                        value: C[P[I]]
                      });
                    }
                  }

              }
            }
          }

          y(i, "line") && delete i.line, "marker" in i && (y(i.marker, "line") && delete i.marker.line, y(i, "marker") && delete i.marker), c.clean(i), i.autobinx && (delete i.autobinx, delete i.xbins), i.autobiny && (delete i.autobiny, delete i.ybins), d(i), i.colorbar && d(i.colorbar), i.marker && i.marker.colorbar && d(i.marker.colorbar), i.line && i.line.colorbar && d(i.line.colorbar), i.aaxis && d(i.aaxis), i.baxis && d(i.baxis);
        }
      }, r.swapXYData = function (t) {
        var e;

        if (o.swapAttrs(t, ["?", "?0", "d?", "?bins", "nbins?", "autobin?", "?src", "error_?"]), Array.isArray(t.z) && Array.isArray(t.z[0]) && (t.transpose ? delete t.transpose : t.transpose = !0), t.error_x && t.error_y) {
          var r = t.error_y,
              n = "copy_ystyle" in r ? r.copy_ystyle : !(r.color || r.thickness || r.width);
          o.swapAttrs(t, ["error_?.copy_ystyle"]), n && o.swapAttrs(t, ["error_?.color", "error_?.thickness", "error_?.width"]);
        }

        if ("string" == typeof t.hoverinfo) {
          var i = t.hoverinfo.split("+");

          for (e = 0; e < i.length; e++) {
            "x" === i[e] ? i[e] = "y" : "y" === i[e] && (i[e] = "x");
          }

          t.hoverinfo = i.join("+");
        }
      }, r.coerceTraceIndices = function (t, e) {
        if (n(e)) return [e];
        if (!Array.isArray(e) || !e.length) return t.data.map(function (t, e) {
          return e;
        });

        if (Array.isArray(e)) {
          for (var r = [], i = 0; i < e.length; i++) {
            o.isIndex(e[i], t.data.length) ? r.push(e[i]) : o.warn("trace index (", e[i], ") is not a number or is out of bounds");
          }

          return r;
        }

        return e;
      }, r.manageArrayContainers = function (t, e, r) {
        var i = t.obj,
            a = t.parts,
            s = a.length,
            l = a[s - 1],
            c = n(l);

        if (c && null === e) {
          var u = a.slice(0, s - 1).join(".");
          o.nestedProperty(i, u).get().splice(l, 1);
        } else c && void 0 === t.get() ? (void 0 === t.get() && (r[t.astr] = null), t.set(e)) : t.set(e);
      };
      var x = /(\.[^\[\]\.]+|\[[^\[\]\.]+\])$/;

      function b(t) {
        var e = t.search(x);
        if (e > 0) return t.substr(0, e);
      }

      r.hasParent = function (t, e) {
        for (var r = b(e); r;) {
          if (r in t) return !0;
          r = b(r);
        }

        return !1;
      };

      var _ = ["x", "y", "z"];

      r.clearAxisTypes = function (t, e, r) {
        for (var n = 0; n < e.length; n++) {
          for (var i = t._fullData[n], a = 0; a < 3; a++) {
            var s = f(t, i, _[a]);

            if (s && "log" !== s.type) {
              var l = s._name,
                  c = s._id.substr(1);

              if ("scene" === c.substr(0, 5)) {
                if (void 0 !== r[c]) continue;
                l = c + "." + l;
              }

              var u = l + ".type";
              void 0 === r[l] && void 0 === r[u] && o.nestedProperty(t.layout, u).set(null);
            }
          }
        }
      };
    }, {
      "../components/color": 658,
      "../lib": 795,
      "../plots/cartesian/axis_ids": 848,
      "../plots/plots": 909,
      "../registry": 923,
      "fast-isnumeric": 240,
      "gl-mat4/fromQuat": 279
    }],
    829: [function (t, e, r) {
      "use strict";

      var n = t("./plot_api");
      r._doPlot = n._doPlot, r.newPlot = n.newPlot, r.restyle = n.restyle, r.relayout = n.relayout, r.redraw = n.redraw, r.update = n.update, r._guiRestyle = n._guiRestyle, r._guiRelayout = n._guiRelayout, r._guiUpdate = n._guiUpdate, r._storeDirectGUIEdit = n._storeDirectGUIEdit, r.react = n.react, r.extendTraces = n.extendTraces, r.prependTraces = n.prependTraces, r.addTraces = n.addTraces, r.deleteTraces = n.deleteTraces, r.moveTraces = n.moveTraces, r.purge = n.purge, r.addFrames = n.addFrames, r.deleteFrames = n.deleteFrames, r.animate = n.animate, r.setPlotConfig = n.setPlotConfig, r.toImage = t("./to_image"), r.validate = t("./validate"), r.downloadImage = t("../snapshot/download");
      var i = t("./template_api");
      r.makeTemplate = i.makeTemplate, r.validateTemplate = i.validateTemplate;
    }, {
      "../snapshot/download": 925,
      "./plot_api": 831,
      "./template_api": 836,
      "./to_image": 837,
      "./validate": 838
    }],
    830: [function (t, e, r) {
      "use strict";

      var n = t("../lib/is_plain_object"),
          i = t("../lib/noop"),
          a = t("../lib/loggers"),
          o = t("../lib/search").sorterAsc,
          s = t("../registry");
      r.containerArrayMatch = t("./container_array_match");

      var l = r.isAddVal = function (t) {
        return "add" === t || n(t);
      },
          c = r.isRemoveVal = function (t) {
        return null === t || "remove" === t;
      };

      r.applyContainerArrayChanges = function (t, e, r, n, u) {
        var f = e.astr,
            h = s.getComponentMethod(f, "supplyLayoutDefaults"),
            p = s.getComponentMethod(f, "draw"),
            d = s.getComponentMethod(f, "drawOne"),
            m = n.replot || n.recalc || h === i || p === i,
            g = t.layout,
            v = t._fullLayout;

        if (r[""]) {
          Object.keys(r).length > 1 && a.warn("Full array edits are incompatible with other edits", f);
          var y = r[""][""];
          if (c(y)) e.set(null);else {
            if (!Array.isArray(y)) return a.warn("Unrecognized full array edit value", f, y), !0;
            e.set(y);
          }
          return !m && (h(g, v), p(t), !0);
        }

        var x,
            b,
            _,
            w,
            T,
            k,
            M,
            A,
            S = Object.keys(r).map(Number).sort(o),
            E = e.get(),
            L = E || [],
            C = u(v, f).get(),
            P = [],
            I = -1,
            O = L.length;

        for (x = 0; x < S.length; x++) {
          if (w = r[_ = S[x]], T = Object.keys(w), k = w[""], M = l(k), _ < 0 || _ > L.length - (M ? 0 : 1)) a.warn("index out of range", f, _);else if (void 0 !== k) T.length > 1 && a.warn("Insertion & removal are incompatible with edits to the same index.", f, _), c(k) ? P.push(_) : M ? ("add" === k && (k = {}), L.splice(_, 0, k), C && C.splice(_, 0, {})) : a.warn("Unrecognized full object edit value", f, _, k), -1 === I && (I = _);else for (b = 0; b < T.length; b++) {
            A = f + "[" + _ + "].", u(L[_], T[b], A).set(w[T[b]]);
          }
        }

        for (x = P.length - 1; x >= 0; x--) {
          L.splice(P[x], 1), C && C.splice(P[x], 1);
        }

        if (L.length ? E || e.set(L) : e.set(null), m) return !1;

        if (h(g, v), d !== i) {
          var z;
          if (-1 === I) z = S;else {
            for (O = Math.max(L.length, O), z = [], x = 0; x < S.length && !((_ = S[x]) >= I); x++) {
              z.push(_);
            }

            for (x = I; x < O; x++) {
              z.push(x);
            }
          }

          for (x = 0; x < z.length; x++) {
            d(t, z[x]);
          }
        } else p(t);

        return !0;
      };
    }, {
      "../lib/is_plain_object": 796,
      "../lib/loggers": 799,
      "../lib/noop": 804,
      "../lib/search": 815,
      "../registry": 923,
      "./container_array_match": 826
    }],
    831: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("fast-isnumeric"),
          a = t("has-hover"),
          o = t("../lib"),
          s = o.nestedProperty,
          l = t("../lib/events"),
          c = t("../lib/queue"),
          u = t("../registry"),
          f = t("./plot_schema"),
          h = t("../plots/plots"),
          p = t("../plots/cartesian/axes"),
          d = t("../components/drawing"),
          m = t("../components/color"),
          g = t("../plots/cartesian/graph_interact").initInteractions,
          v = t("../constants/xmlns_namespaces"),
          y = t("../plots/cartesian/select").clearSelect,
          x = t("./plot_config").dfltConfig,
          b = t("./manage_arrays"),
          _ = t("./helpers"),
          w = t("./subroutines"),
          T = t("./edit_types"),
          k = t("../plots/cartesian/constants").AX_NAME_PATTERN,
          M = 0;

      function A(t) {
        var e = t._fullLayout;
        e._redrawFromAutoMarginCount ? e._redrawFromAutoMarginCount-- : t.emit("plotly_afterplot");
      }

      function S(t, e) {
        try {
          t._fullLayout._paper.style("background", e);
        } catch (t) {
          o.error(t);
        }
      }

      function E(t, e) {
        S(t, m.combine(e, "white"));
      }

      function L(t, e) {
        if (!t._context) {
          t._context = o.extendDeep({}, x);
          var r = n.select("base");
          t._context._baseUrl = r.size() && r.attr("href") ? window.location.href.split("#")[0] : "";
        }

        var i,
            s,
            l,
            c = t._context;

        if (e) {
          for (s = Object.keys(e), i = 0; i < s.length; i++) {
            "editable" !== (l = s[i]) && "edits" !== l && l in c && ("setBackground" === l && "opaque" === e[l] ? c[l] = E : c[l] = e[l]);
          }

          e.plot3dPixelRatio && !c.plotGlPixelRatio && (c.plotGlPixelRatio = c.plot3dPixelRatio);
          var u = e.editable;
          if (void 0 !== u) for (c.editable = u, s = Object.keys(c.edits), i = 0; i < s.length; i++) {
            c.edits[s[i]] = u;
          }
          if (e.edits) for (s = Object.keys(e.edits), i = 0; i < s.length; i++) {
            (l = s[i]) in c.edits && (c.edits[l] = e.edits[l]);
          }
          c._exportedPlot = e._exportedPlot;
        }

        c.staticPlot && (c.editable = !1, c.edits = {}, c.autosizable = !1, c.scrollZoom = !1, c.doubleClick = !1, c.showTips = !1, c.showLink = !1, c.displayModeBar = !1), "hover" !== c.displayModeBar || a || (c.displayModeBar = !0), "transparent" !== c.setBackground && "function" == typeof c.setBackground || (c.setBackground = S), c._hasZeroHeight = c._hasZeroHeight || 0 === t.clientHeight, c._hasZeroWidth = c._hasZeroWidth || 0 === t.clientWidth;
        var f = c.scrollZoom,
            h = c._scrollZoom = {};
        if (!0 === f) h.cartesian = 1, h.gl3d = 1, h.geo = 1, h.mapbox = 1;else if ("string" == typeof f) {
          var p = f.split("+");

          for (i = 0; i < p.length; i++) {
            h[p[i]] = 1;
          }
        } else !1 !== f && (h.gl3d = 1, h.geo = 1, h.mapbox = 1);
      }

      function C(t, e) {
        var r,
            n,
            i = e + 1,
            a = [];

        for (r = 0; r < t.length; r++) {
          (n = t[r]) < 0 ? a.push(i + n) : a.push(n);
        }

        return a;
      }

      function P(t, e, r) {
        var n, i;

        for (n = 0; n < e.length; n++) {
          if ((i = e[n]) !== parseInt(i, 10)) throw new Error("all values in " + r + " must be integers");
          if (i >= t.data.length || i < -t.data.length) throw new Error(r + " must be valid indices for gd.data.");
          if (e.indexOf(i, n + 1) > -1 || i >= 0 && e.indexOf(-t.data.length + i) > -1 || i < 0 && e.indexOf(t.data.length + i) > -1) throw new Error("each index in " + r + " must be unique.");
        }
      }

      function I(t, e, r) {
        if (!Array.isArray(t.data)) throw new Error("gd.data must be an array.");
        if (void 0 === e) throw new Error("currentIndices is a required argument.");
        if (Array.isArray(e) || (e = [e]), P(t, e, "currentIndices"), void 0 === r || Array.isArray(r) || (r = [r]), void 0 !== r && P(t, r, "newIndices"), void 0 !== r && e.length !== r.length) throw new Error("current and new indices must be of equal length.");
      }

      function O(t, e, r, n, a) {
        !function (t, e, r, n) {
          var i = o.isPlainObject(n);
          if (!Array.isArray(t.data)) throw new Error("gd.data must be an array");
          if (!o.isPlainObject(e)) throw new Error("update must be a key:value object");
          if (void 0 === r) throw new Error("indices must be an integer or array of integers");

          for (var a in P(t, r, "indices"), e) {
            if (!Array.isArray(e[a]) || e[a].length !== r.length) throw new Error("attribute " + a + " must be an array of length equal to indices array length");
            if (i && (!(a in n) || !Array.isArray(n[a]) || n[a].length !== e[a].length)) throw new Error("when maxPoints is set as a key:value object it must contain a 1:1 corrispondence with the keys and number of traces in the update object");
          }
        }(t, e, r, n);

        for (var l = function (t, e, r, n) {
          var a,
              l,
              c,
              u,
              f,
              h = o.isPlainObject(n),
              p = [];

          for (var d in Array.isArray(r) || (r = [r]), r = C(r, t.data.length - 1), e) {
            for (var m = 0; m < r.length; m++) {
              if (a = t.data[r[m]], l = (c = s(a, d)).get(), u = e[d][m], !o.isArrayOrTypedArray(u)) throw new Error("attribute: " + d + " index: " + m + " must be an array");
              if (!o.isArrayOrTypedArray(l)) throw new Error("cannot extend missing or non-array attribute: " + d);
              if (l.constructor !== u.constructor) throw new Error("cannot extend array with an array of a different type: " + d);
              f = h ? n[d][m] : n, i(f) || (f = -1), p.push({
                prop: c,
                target: l,
                insert: u,
                maxp: Math.floor(f)
              });
            }
          }

          return p;
        }(t, e, r, n), c = {}, u = {}, f = 0; f < l.length; f++) {
          var h = l[f].prop,
              p = l[f].maxp,
              d = a(l[f].target, l[f].insert, p);
          h.set(d[0]), Array.isArray(c[h.astr]) || (c[h.astr] = []), c[h.astr].push(d[1]), Array.isArray(u[h.astr]) || (u[h.astr] = []), u[h.astr].push(l[f].target.length);
        }

        return {
          update: c,
          maxPoints: u
        };
      }

      function z(t, e) {
        var r = new t.constructor(t.length + e.length);
        return r.set(t), r.set(e, t.length), r;
      }

      function D(t, e, n, i) {
        t = o.getGraphDiv(t), _.clearPromiseQueue(t);
        var a = {};
        if ("string" == typeof e) a[e] = n;else {
          if (!o.isPlainObject(e)) return o.warn("Restyle fail.", e, n, i), Promise.reject();
          a = o.extendFlat({}, e), void 0 === i && (i = n);
        }
        Object.keys(a).length && (t.changed = !0);

        var s = _.coerceTraceIndices(t, i),
            l = N(t, a, s),
            u = l.flags;

        u.calc && (t.calcdata = void 0), u.clearAxisTypes && _.clearAxisTypes(t, s, {});
        var f = [];
        u.fullReplot ? f.push(r._doPlot) : (f.push(h.previousPromises), h.supplyDefaults(t), u.markerSize && (h.doCalcdata(t), q(f)), u.style && f.push(w.doTraceStyle), u.colorbars && f.push(w.doColorBars), f.push(A)), f.push(h.rehover, h.redrag), c.add(t, D, [t, l.undoit, l.traces], D, [t, l.redoit, l.traces]);
        var p = o.syncOrAsync(f, t);
        return p && p.then || (p = Promise.resolve()), p.then(function () {
          return t.emit("plotly_restyle", l.eventData), t;
        });
      }

      function R(t) {
        return void 0 === t ? null : t;
      }

      function F(t, e) {
        return e ? function (e, r, n) {
          var i = s(e, r),
              a = i.set;
          return i.set = function (e) {
            B((n || "") + r, i.get(), e, t), a(e);
          }, i;
        } : s;
      }

      function B(t, e, r, n) {
        if (Array.isArray(e) || Array.isArray(r)) for (var i = Array.isArray(e) ? e : [], a = Array.isArray(r) ? r : [], s = Math.max(i.length, a.length), l = 0; l < s; l++) {
          B(t + "[" + l + "]", i[l], a[l], n);
        } else if (o.isPlainObject(e) || o.isPlainObject(r)) {
          var c = o.isPlainObject(e) ? e : {},
              u = o.isPlainObject(r) ? r : {},
              f = o.extendFlat({}, c, u);

          for (var h in f) {
            B(t + "." + h, c[h], u[h], n);
          }
        } else void 0 === n[t] && (n[t] = R(e));
      }

      function N(t, e, r) {
        var n,
            i = t._fullLayout,
            a = t._fullData,
            l = t.data,
            c = i._guiEditing,
            d = F(i._preGUI, c),
            m = o.extendDeepAll({}, e);
        j(e);
        var g,
            v = T.traceFlags(),
            y = {},
            x = {};

        function b() {
          return r.map(function () {});
        }

        function w(t) {
          var e = p.id2name(t);
          -1 === g.indexOf(e) && g.push(e);
        }

        function k(t) {
          return "LAYOUT" + t + ".autorange";
        }

        function M(t) {
          return "LAYOUT" + t + ".range";
        }

        function A(t) {
          for (var e = t; e < a.length; e++) {
            if (a[e]._input === l[t]) return a[e];
          }
        }

        function S(n, a, o) {
          if (Array.isArray(n)) n.forEach(function (t) {
            S(t, a, o);
          });else if (!(n in e) && !_.hasParent(e, n)) {
            var s;
            if ("LAYOUT" === n.substr(0, 6)) s = d(t.layout, n.replace("LAYOUT", ""));else {
              var u = r[o];
              s = F(i._tracePreGUI[A(u)._fullInput.uid], c)(l[u], n);
            }
            n in x || (x[n] = b()), void 0 === x[n][o] && (x[n][o] = R(s.get())), void 0 !== a && s.set(a);
          }
        }

        function E(t) {
          return function (e) {
            return a[e][t];
          };
        }

        function L(t) {
          return function (e, n) {
            return !1 === e ? a[r[n]][t] : null;
          };
        }

        for (var C in e) {
          if (_.hasParent(e, C)) throw new Error("cannot set " + C + " and a parent attribute simultaneously");
          var P,
              I,
              O,
              z,
              D,
              B,
              N = e[C];

          if ("autobinx" !== C && "autobiny" !== C || (C = C.charAt(C.length - 1) + "bins", N = Array.isArray(N) ? N.map(L(C)) : !1 === N ? r.map(E(C)) : null), y[C] = N, "LAYOUT" !== C.substr(0, 6)) {
            for (x[C] = b(), n = 0; n < r.length; n++) {
              if (P = l[r[n]], I = A(r[n]), z = (O = F(i._tracePreGUI[I._fullInput.uid], c)(P, C)).get(), void 0 !== (D = Array.isArray(N) ? N[n % N.length] : N)) {
                var U = O.parts[O.parts.length - 1],
                    V = C.substr(0, C.length - U.length - 1),
                    q = V ? V + "." : "",
                    H = V ? s(I, V).get() : I;
                if ((B = f.getTraceValObject(I, O.parts)) && B.impliedEdits && null !== D) for (var G in B.impliedEdits) {
                  S(o.relativeAttr(C, G), B.impliedEdits[G], n);
                } else if ("thicknessmode" !== U && "lenmode" !== U || z === D || "fraction" !== D && "pixels" !== D || !H) {
                  if ("type" === C && ("pie" === D != ("pie" === z) || "funnelarea" === D != ("funnelarea" === z))) {
                    var Y = "x",
                        W = "y";
                    "bar" !== D && "bar" !== z || "h" !== P.orientation || (Y = "y", W = "x"), o.swapAttrs(P, ["?", "?src"], "labels", Y), o.swapAttrs(P, ["d?", "?0"], "label", Y), o.swapAttrs(P, ["?", "?src"], "values", W), "pie" === z || "funnelarea" === z ? (s(P, "marker.color").set(s(P, "marker.colors").get()), i._pielayer.selectAll("g.trace").remove()) : u.traceIs(P, "cartesian") && s(P, "marker.colors").set(s(P, "marker.color").get());
                  }
                } else {
                  var X = i._size,
                      Z = H.orient,
                      J = "top" === Z || "bottom" === Z;

                  if ("thicknessmode" === U) {
                    var K = J ? X.h : X.w;
                    S(q + "thickness", H.thickness * ("fraction" === D ? 1 / K : K), n);
                  } else {
                    var Q = J ? X.w : X.h;
                    S(q + "len", H.len * ("fraction" === D ? 1 / Q : Q), n);
                  }
                }
                x[C][n] = R(z);

                if (-1 !== ["swapxy", "swapxyaxes", "orientation", "orientationaxes"].indexOf(C)) {
                  if ("orientation" === C) {
                    O.set(D);
                    var $ = P.x && !P.y ? "h" : "v";
                    if ((O.get() || $) === I.orientation) continue;
                  } else "orientationaxes" === C && (P.orientation = {
                    v: "h",
                    h: "v"
                  }[I.orientation]);

                  _.swapXYData(P), v.calc = v.clearAxisTypes = !0;
                } else -1 !== h.dataArrayContainers.indexOf(O.parts[0]) ? (_.manageArrayContainers(O, D, x), v.calc = !0) : (B ? B.arrayOk && !u.traceIs(I, "regl") && (o.isArrayOrTypedArray(D) || o.isArrayOrTypedArray(z)) ? v.calc = !0 : T.update(v, B) : v.calc = !0, O.set(D));
              }
            }

            if (-1 !== ["swapxyaxes", "orientationaxes"].indexOf(C) && p.swap(t, r), "orientationaxes" === C) {
              var tt = s(t.layout, "hovermode"),
                  et = tt.get();
              "x" === et ? tt.set("y") : "y" === et ? tt.set("x") : "x unified" === et ? tt.set("y unified") : "y unified" === et && tt.set("x unified");
            }

            if (-1 !== ["orientation", "type"].indexOf(C)) {
              for (g = [], n = 0; n < r.length; n++) {
                var rt = l[r[n]];
                u.traceIs(rt, "cartesian") && (w(rt.xaxis || "x"), w(rt.yaxis || "y"));
              }

              S(g.map(k), !0, 0), S(g.map(M), [0, 1], 0);
            }
          } else O = d(t.layout, C.replace("LAYOUT", "")), x[C] = [R(O.get())], O.set(Array.isArray(N) ? N[0] : N), v.calc = !0;
        }

        return (v.calc || v.plot) && (v.fullReplot = !0), {
          flags: v,
          undoit: x,
          redoit: y,
          traces: r,
          eventData: o.extendDeepNoArrays([], [m, r])
        };
      }

      function j(t) {
        var e,
            r,
            n,
            i = o.counterRegex("axis", ".title", !1, !1),
            a = /colorbar\.title$/,
            s = Object.keys(t);

        for (e = 0; e < s.length; e++) {
          r = s[e], n = t[r], "title" !== r && !i.test(r) && !a.test(r) || "string" != typeof n && "number" != typeof n ? r.indexOf("titlefont") > -1 ? l(r, r.replace("titlefont", "title.font")) : r.indexOf("titleposition") > -1 ? l(r, r.replace("titleposition", "title.position")) : r.indexOf("titleside") > -1 ? l(r, r.replace("titleside", "title.side")) : r.indexOf("titleoffset") > -1 && l(r, r.replace("titleoffset", "title.offset")) : l(r, r.replace("title", "title.text"));
        }

        function l(e, r) {
          t[r] = t[e], delete t[e];
        }
      }

      function U(t, e, r) {
        t = o.getGraphDiv(t), _.clearPromiseQueue(t);
        var n = {};
        if ("string" == typeof e) n[e] = r;else {
          if (!o.isPlainObject(e)) return o.warn("Relayout fail.", e, r), Promise.reject();
          n = o.extendFlat({}, e);
        }
        Object.keys(n).length && (t.changed = !0);
        var i = W(t, n),
            a = i.flags;
        a.calc && (t.calcdata = void 0);
        var s = [h.previousPromises];
        a.layoutReplot ? s.push(w.layoutReplot) : Object.keys(n).length && (V(t, a, i) || h.supplyDefaults(t), a.legend && s.push(w.doLegend), a.layoutstyle && s.push(w.layoutStyles), a.axrange && q(s, i.rangesAltered), a.ticks && s.push(w.doTicksRelayout), a.modebar && s.push(w.doModeBar), a.camera && s.push(w.doCamera), a.colorbars && s.push(w.doColorBars), s.push(A)), s.push(h.rehover, h.redrag), c.add(t, U, [t, i.undoit], U, [t, i.redoit]);
        var l = o.syncOrAsync(s, t);
        return l && l.then || (l = Promise.resolve(t)), l.then(function () {
          return t.emit("plotly_relayout", i.eventData), t;
        });
      }

      function V(t, e, r) {
        var n = t._fullLayout;
        if (!e.axrange) return !1;

        for (var i in e) {
          if ("axrange" !== i && e[i]) return !1;
        }

        for (var a in r.rangesAltered) {
          var o = p.id2name(a),
              s = t.layout[o],
              l = n[o];
          if (l.autorange = s.autorange, s.range && (l.range = s.range.slice()), l.cleanRange(), l._matchGroup) for (var c in l._matchGroup) {
            if (c !== a) {
              var u = n[p.id2name(c)];
              u.autorange = l.autorange, u.range = l.range.slice(), u._input.range = l.range.slice();
            }
          }
        }

        return !0;
      }

      function q(t, e) {
        var r = e ? function (t) {
          var r = [],
              n = !0;

          for (var i in e) {
            var a = p.getFromId(t, i);
            if (r.push(i), -1 !== (a.ticklabelposition || "").indexOf("inside") && a._anchorAxis && r.push(a._anchorAxis._id), a._matchGroup) for (var o in a._matchGroup) {
              e[o] || r.push(o);
            }
            a.automargin && (n = !1);
          }

          return p.draw(t, r, {
            skipTitle: n
          });
        } : function (t) {
          return p.draw(t, "redraw");
        };
        t.push(y, w.doAutoRangeAndConstraints, r, w.drawData, w.finalDraw);
      }

      var H = /^[xyz]axis[0-9]*\.range(\[[0|1]\])?$/,
          G = /^[xyz]axis[0-9]*\.autorange$/,
          Y = /^[xyz]axis[0-9]*\.domain(\[[0|1]\])?$/;

      function W(t, e) {
        var r,
            n,
            i,
            a = t.layout,
            l = t._fullLayout,
            c = l._guiEditing,
            h = F(l._preGUI, c),
            d = Object.keys(e),
            m = p.list(t),
            g = o.extendDeepAll({}, e),
            v = {};

        for (j(e), d = Object.keys(e), n = 0; n < d.length; n++) {
          if (0 === d[n].indexOf("allaxes")) {
            for (i = 0; i < m.length; i++) {
              var y = m[i]._id.substr(1),
                  x = -1 !== y.indexOf("scene") ? y + "." : "",
                  w = d[n].replace("allaxes", x + m[i]._name);

              e[w] || (e[w] = e[d[n]]);
            }

            delete e[d[n]];
          }
        }

        var M = T.layoutFlags(),
            A = {},
            S = {};

        function E(t, r) {
          if (Array.isArray(t)) t.forEach(function (t) {
            E(t, r);
          });else if (!(t in e) && !_.hasParent(e, t)) {
            var n = h(a, t);
            t in S || (S[t] = R(n.get())), void 0 !== r && n.set(r);
          }
        }

        var L,
            C = {};

        function P(t) {
          var e = p.name2id(t.split(".")[0]);
          return C[e] = 1, e;
        }

        for (var I in e) {
          if (_.hasParent(e, I)) throw new Error("cannot set " + I + " and a parent attribute simultaneously");

          for (var O = h(a, I), z = e[I], D = O.parts.length - 1; D > 0 && "string" != typeof O.parts[D];) {
            D--;
          }

          var B = O.parts[D],
              N = O.parts[D - 1] + "." + B,
              U = O.parts.slice(0, D).join("."),
              V = s(t.layout, U).get(),
              q = s(l, U).get(),
              W = O.get();

          if (void 0 !== z) {
            A[I] = z, S[I] = "reverse" === B ? z : R(W);
            var Z = f.getLayoutValObject(l, O.parts);
            if (Z && Z.impliedEdits && null !== z) for (var J in Z.impliedEdits) {
              E(o.relativeAttr(I, J), Z.impliedEdits[J]);
            }
            if (-1 !== ["width", "height"].indexOf(I)) {
              if (z) {
                E("autosize", null);
                var K = "height" === I ? "width" : "height";
                E(K, l[K]);
              } else l[I] = t._initialAutoSize[I];
            } else if ("autosize" === I) E("width", z ? null : l.width), E("height", z ? null : l.height);else if (N.match(H)) P(N), s(l, U + "._inputRange").set(null);else if (N.match(G)) {
              P(N), s(l, U + "._inputRange").set(null);
              var Q = s(l, U).get();
              Q._inputDomain && (Q._input.domain = Q._inputDomain.slice());
            } else N.match(Y) && s(l, U + "._inputDomain").set(null);

            if ("type" === B) {
              L = V;
              var $ = "linear" === q.type && "log" === z,
                  tt = "log" === q.type && "linear" === z;

              if ($ || tt) {
                if (L && L.range) {
                  if (q.autorange) $ && (L.range = L.range[1] > L.range[0] ? [1, 2] : [2, 1]);else {
                    var et = L.range[0],
                        rt = L.range[1];
                    $ ? (et <= 0 && rt <= 0 && E(U + ".autorange", !0), et <= 0 ? et = rt / 1e6 : rt <= 0 && (rt = et / 1e6), E(U + ".range[0]", Math.log(et) / Math.LN10), E(U + ".range[1]", Math.log(rt) / Math.LN10)) : (E(U + ".range[0]", Math.pow(10, et)), E(U + ".range[1]", Math.pow(10, rt)));
                  }
                } else E(U + ".autorange", !0);
                Array.isArray(l._subplots.polar) && l._subplots.polar.length && l[O.parts[0]] && "radialaxis" === O.parts[1] && delete l[O.parts[0]]._subplot.viewInitial["radialaxis.range"], u.getComponentMethod("annotations", "convertCoords")(t, q, z, E), u.getComponentMethod("images", "convertCoords")(t, q, z, E);
              } else E(U + ".autorange", !0), E(U + ".range", null);

              s(l, U + "._inputRange").set(null);
            } else if (B.match(k)) {
              var nt = s(l, I).get(),
                  it = (z || {}).type;
              it && "-" !== it || (it = "linear"), u.getComponentMethod("annotations", "convertCoords")(t, nt, it, E), u.getComponentMethod("images", "convertCoords")(t, nt, it, E);
            }

            var at = b.containerArrayMatch(I);

            if (at) {
              r = at.array, n = at.index;
              var ot = at.property,
                  st = Z || {
                editType: "calc"
              };
              "" !== n && "" === ot && (b.isAddVal(z) ? S[I] = null : b.isRemoveVal(z) ? S[I] = (s(a, r).get() || [])[n] : o.warn("unrecognized full object value", e)), T.update(M, st), v[r] || (v[r] = {});
              var lt = v[r][n];
              lt || (lt = v[r][n] = {}), lt[ot] = z, delete e[I];
            } else "reverse" === B ? (V.range ? V.range.reverse() : (E(U + ".autorange", !0), V.range = [1, 0]), q.autorange ? M.calc = !0 : M.plot = !0) : (l._has("scatter-like") && l._has("regl") && "dragmode" === I && ("lasso" === z || "select" === z) && "lasso" !== W && "select" !== W || l._has("gl2d") ? M.plot = !0 : Z ? T.update(M, Z) : M.calc = !0, O.set(z));
          }
        }

        for (r in v) {
          b.applyContainerArrayChanges(t, h(a, r), v[r], M, h) || (M.plot = !0);
        }

        for (var ct in C) {
          var ut = (L = p.getFromId(t, ct)) && L._constraintGroup;

          if (ut) for (var ft in M.calc = !0, ut) {
            C[ft] || (p.getFromId(t, ft)._constraintShrinkable = !0);
          }
        }

        return (X(t) || e.height || e.width) && (M.plot = !0), (M.plot || M.calc) && (M.layoutReplot = !0), {
          flags: M,
          rangesAltered: C,
          undoit: S,
          redoit: A,
          eventData: g
        };
      }

      function X(t) {
        var e = t._fullLayout,
            r = e.width,
            n = e.height;
        return t.layout.autosize && h.plotAutoSize(t, t.layout, e), e.width !== r || e.height !== n;
      }

      function Z(t, e, n, i) {
        t = o.getGraphDiv(t), _.clearPromiseQueue(t), o.isPlainObject(e) || (e = {}), o.isPlainObject(n) || (n = {}), Object.keys(e).length && (t.changed = !0), Object.keys(n).length && (t.changed = !0);

        var a = _.coerceTraceIndices(t, i),
            s = N(t, o.extendFlat({}, e), a),
            l = s.flags,
            u = W(t, o.extendFlat({}, n)),
            f = u.flags;

        (l.calc || f.calc) && (t.calcdata = void 0), l.clearAxisTypes && _.clearAxisTypes(t, a, n);
        var p = [];
        f.layoutReplot ? p.push(w.layoutReplot) : l.fullReplot ? p.push(r._doPlot) : (p.push(h.previousPromises), V(t, f, u) || h.supplyDefaults(t), l.style && p.push(w.doTraceStyle), (l.colorbars || f.colorbars) && p.push(w.doColorBars), f.legend && p.push(w.doLegend), f.layoutstyle && p.push(w.layoutStyles), f.axrange && q(p, u.rangesAltered), f.ticks && p.push(w.doTicksRelayout), f.modebar && p.push(w.doModeBar), f.camera && p.push(w.doCamera), p.push(A)), p.push(h.rehover, h.redrag), c.add(t, Z, [t, s.undoit, u.undoit, s.traces], Z, [t, s.redoit, u.redoit, s.traces]);
        var d = o.syncOrAsync(p, t);
        return d && d.then || (d = Promise.resolve(t)), d.then(function () {
          return t.emit("plotly_update", {
            data: s.eventData,
            layout: u.eventData
          }), t;
        });
      }

      function J(t) {
        return function (e) {
          e._fullLayout._guiEditing = !0;
          var r = t.apply(null, arguments);
          return e._fullLayout._guiEditing = !1, r;
        };
      }

      var K = [{
        pattern: /^hiddenlabels/,
        attr: "legend.uirevision"
      }, {
        pattern: /^((x|y)axis\d*)\.((auto)?range|title\.text)/
      }, {
        pattern: /axis\d*\.showspikes$/,
        attr: "modebar.uirevision"
      }, {
        pattern: /(hover|drag)mode$/,
        attr: "modebar.uirevision"
      }, {
        pattern: /^(scene\d*)\.camera/
      }, {
        pattern: /^(geo\d*)\.(projection|center|fitbounds)/
      }, {
        pattern: /^(ternary\d*\.[abc]axis)\.(min|title\.text)$/
      }, {
        pattern: /^(polar\d*\.radialaxis)\.((auto)?range|angle|title\.text)/
      }, {
        pattern: /^(polar\d*\.angularaxis)\.rotation/
      }, {
        pattern: /^(mapbox\d*)\.(center|zoom|bearing|pitch)/
      }, {
        pattern: /^legend\.(x|y)$/,
        attr: "editrevision"
      }, {
        pattern: /^(shapes|annotations)/,
        attr: "editrevision"
      }, {
        pattern: /^title\.text$/,
        attr: "editrevision"
      }],
          Q = [{
        pattern: /^selectedpoints$/,
        attr: "selectionrevision"
      }, {
        pattern: /(^|value\.)visible$/,
        attr: "legend.uirevision"
      }, {
        pattern: /^dimensions\[\d+\]\.constraintrange/
      }, {
        pattern: /^node\.(x|y|groups)/
      }, {
        pattern: /^level$/
      }, {
        pattern: /(^|value\.)name$/
      }, {
        pattern: /colorbar\.title\.text$/
      }, {
        pattern: /colorbar\.(x|y)$/,
        attr: "editrevision"
      }];

      function $(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r],
              i = t.match(n.pattern);
          if (i) return {
            head: i[1],
            attr: n.attr
          };
        }
      }

      function tt(t, e) {
        var r = s(e, t).get();
        if (void 0 !== r) return r;
        var n = t.split(".");

        for (n.pop(); n.length > 1;) {
          if (n.pop(), void 0 !== (r = s(e, n.join(".") + ".uirevision").get())) return r;
        }

        return e.uirevision;
      }

      function et(t, e) {
        for (var r = 0; r < e.length; r++) {
          if (e[r]._fullInput.uid === t) return r;
        }

        return -1;
      }

      function rt(t, e, r) {
        for (var n = 0; n < e.length; n++) {
          if (e[n].uid === t) return n;
        }

        return !e[r] || e[r].uid ? -1 : r;
      }

      function nt(t, e) {
        var r = o.isPlainObject(t),
            n = Array.isArray(t);
        return r || n ? (r && o.isPlainObject(e) || n && Array.isArray(e)) && JSON.stringify(t) === JSON.stringify(e) : t === e;
      }

      function it(t, e, r, n) {
        var i,
            a,
            l,
            c = n.getValObject,
            u = n.flags,
            f = n.immutable,
            h = n.inArray,
            p = n.arrayIndex;

        function d() {
          var t = i.editType;
          h && -1 !== t.indexOf("arraydraw") ? o.pushUnique(u.arrays[h], p) : (T.update(u, i), "none" !== t && u.nChanges++, n.transition && i.anim && u.nChangesAnim++, (H.test(l) || G.test(l)) && (u.rangesAltered[r[0]] = 1), Y.test(l) && s(e, "_inputDomain").set(null), "datarevision" === a && (u.newDataRevision = 1));
        }

        function m(t) {
          return "data_array" === t.valType || t.arrayOk;
        }

        for (a in t) {
          if (u.calc && !n.transition) return;
          var g = t[a],
              v = e[a],
              y = r.concat(a);

          if (l = y.join("."), "_" !== a.charAt(0) && "function" != typeof g && g !== v) {
            if (("tick0" === a || "dtick" === a) && "geo" !== r[0]) {
              var x = e.tickmode;
              if ("auto" === x || "array" === x || !x) continue;
            }

            if (("range" !== a || !e.autorange) && ("zmin" !== a && "zmax" !== a || "contourcarpet" !== e.type) && (i = c(y)) && (!i._compareAsJSON || JSON.stringify(g) !== JSON.stringify(v))) {
              var b,
                  _ = i.valType,
                  w = m(i),
                  k = Array.isArray(g),
                  M = Array.isArray(v);

              if (k && M) {
                var A = "_input_" + a,
                    S = t[A],
                    E = e[A];
                if (Array.isArray(S) && S === E) continue;
              }

              if (void 0 === v) w && k ? u.calc = !0 : d();else if (i._isLinkedToArray) {
                var L = [],
                    C = !1;
                h || (u.arrays[a] = L);
                var P = Math.min(g.length, v.length),
                    I = Math.max(g.length, v.length);

                if (P !== I) {
                  if ("arraydraw" !== i.editType) {
                    d();
                    continue;
                  }

                  C = !0;
                }

                for (b = 0; b < P; b++) {
                  it(g[b], v[b], y.concat(b), o.extendFlat({
                    inArray: a,
                    arrayIndex: b
                  }, n));
                }

                if (C) for (b = P; b < I; b++) {
                  L.push(b);
                }
              } else !_ && o.isPlainObject(g) ? it(g, v, y, n) : w ? k && M ? (f && (u.calc = !0), (f || n.newDataRevision) && d()) : k !== M ? u.calc = !0 : d() : k && M && g.length === v.length && String(g) === String(v) || d();
            }
          }
        }

        for (a in e) {
          if (!(a in t) && "_" !== a.charAt(0) && "function" != typeof e[a]) {
            if (m(i = c(r.concat(a))) && Array.isArray(e[a])) return void (u.calc = !0);
            d();
          }
        }
      }

      function at(t) {
        var e = t._fullLayout,
            r = t.getBoundingClientRect();

        if (!o.equalDomRects(r, e._lastBBox)) {
          var n = e._invTransform = o.inverseTransformMatrix(o.getFullTransformMatrix(t));
          e._invScaleX = Math.sqrt(n[0][0] * n[0][0] + n[0][1] * n[0][1] + n[0][2] * n[0][2]), e._invScaleY = Math.sqrt(n[1][0] * n[1][0] + n[1][1] * n[1][1] + n[1][2] * n[1][2]), e._lastBBox = r;
        }
      }

      r.animate = function (t, e, r) {
        if (t = o.getGraphDiv(t), !o.isPlotDiv(t)) throw new Error("This element is not a Plotly plot: " + t + ". It's likely that you've failed to create a plot before animating it. For more details, see https://plotly.com/javascript/animations/");
        var n = t._transitionData;
        n._frameQueue || (n._frameQueue = []);
        var i = (r = h.supplyAnimationDefaults(r)).transition,
            a = r.frame;

        function s(t) {
          return Array.isArray(i) ? t >= i.length ? i[0] : i[t] : i;
        }

        function l(t) {
          return Array.isArray(a) ? t >= a.length ? a[0] : a[t] : a;
        }

        function c(t, e) {
          var r = 0;
          return function () {
            if (t && ++r === e) return t();
          };
        }

        return void 0 === n._frameWaitingCnt && (n._frameWaitingCnt = 0), new Promise(function (a, u) {
          function f() {
            n._currentFrame && n._currentFrame.onComplete && n._currentFrame.onComplete();

            var e = n._currentFrame = n._frameQueue.shift();

            if (e) {
              var r = e.name ? e.name.toString() : null;
              t._fullLayout._currentFrame = r, n._lastFrameAt = Date.now(), n._timeToNext = e.frameOpts.duration, h.transition(t, e.frame.data, e.frame.layout, _.coerceTraceIndices(t, e.frame.traces), e.frameOpts, e.transitionOpts).then(function () {
                e.onComplete && e.onComplete();
              }), t.emit("plotly_animatingframe", {
                name: r,
                frame: e.frame,
                animation: {
                  frame: e.frameOpts,
                  transition: e.transitionOpts
                }
              });
            } else t.emit("plotly_animated"), window.cancelAnimationFrame(n._animationRaf), n._animationRaf = null;
          }

          function p() {
            t.emit("plotly_animating"), n._lastFrameAt = -1 / 0, n._timeToNext = 0, n._runningTransitions = 0, n._currentFrame = null;

            var e = function e() {
              n._animationRaf = window.requestAnimationFrame(e), Date.now() - n._lastFrameAt > n._timeToNext && f();
            };

            e();
          }

          var d,
              m,
              g = 0;

          function v(t) {
            return Array.isArray(i) ? g >= i.length ? t.transitionOpts = i[g] : t.transitionOpts = i[0] : t.transitionOpts = i, g++, t;
          }

          var y = [],
              x = null == e,
              b = Array.isArray(e);
          if (!x && !b && o.isPlainObject(e)) y.push({
            type: "object",
            data: v(o.extendFlat({}, e))
          });else if (x || -1 !== ["string", "number"].indexOf(_typeof(e))) for (d = 0; d < n._frames.length; d++) {
            (m = n._frames[d]) && (x || String(m.group) === String(e)) && y.push({
              type: "byname",
              name: String(m.name),
              data: v({
                name: m.name
              })
            });
          } else if (b) for (d = 0; d < e.length; d++) {
            var w = e[d];
            -1 !== ["number", "string"].indexOf(_typeof(w)) ? (w = String(w), y.push({
              type: "byname",
              name: w,
              data: v({
                name: w
              })
            })) : o.isPlainObject(w) && y.push({
              type: "object",
              data: v(o.extendFlat({}, w))
            });
          }

          for (d = 0; d < y.length; d++) {
            if ("byname" === (m = y[d]).type && !n._frameHash[m.data.name]) return o.warn('animate failure: frame not found: "' + m.data.name + '"'), void u();
          }

          -1 !== ["next", "immediate"].indexOf(r.mode) && function () {
            if (0 !== n._frameQueue.length) {
              for (; n._frameQueue.length;) {
                var e = n._frameQueue.pop();

                e.onInterrupt && e.onInterrupt();
              }

              t.emit("plotly_animationinterrupted", []);
            }
          }(), "reverse" === r.direction && y.reverse();
          var T = t._fullLayout._currentFrame;

          if (T && r.fromcurrent) {
            var k = -1;

            for (d = 0; d < y.length; d++) {
              if ("byname" === (m = y[d]).type && m.name === T) {
                k = d;
                break;
              }
            }

            if (k > 0 && k < y.length - 1) {
              var M = [];

              for (d = 0; d < y.length; d++) {
                m = y[d], ("byname" !== y[d].type || d > k) && M.push(m);
              }

              y = M;
            }
          }

          y.length > 0 ? function (e) {
            if (0 !== e.length) {
              for (var i = 0; i < e.length; i++) {
                var o;
                o = "byname" === e[i].type ? h.computeFrame(t, e[i].name) : e[i].data;
                var f = l(i),
                    d = s(i);
                d.duration = Math.min(d.duration, f.duration);
                var m = {
                  frame: o,
                  name: e[i].name,
                  frameOpts: f,
                  transitionOpts: d
                };
                i === e.length - 1 && (m.onComplete = c(a, 2), m.onInterrupt = u), n._frameQueue.push(m);
              }

              "immediate" === r.mode && (n._lastFrameAt = -1 / 0), n._animationRaf || p();
            }
          }(y) : (t.emit("plotly_animated"), a());
        });
      }, r.addFrames = function (t, e, r) {
        if (t = o.getGraphDiv(t), null == e) return Promise.resolve();
        if (!o.isPlotDiv(t)) throw new Error("This element is not a Plotly plot: " + t + ". It's likely that you've failed to create a plot before adding frames. For more details, see https://plotly.com/javascript/animations/");
        var n,
            i,
            a,
            s,
            l = t._transitionData._frames,
            u = t._transitionData._frameHash;
        if (!Array.isArray(e)) throw new Error("addFrames failure: frameList must be an Array of frame definitions" + e);
        var f = l.length + 2 * e.length,
            p = [],
            d = {};

        for (n = e.length - 1; n >= 0; n--) {
          if (o.isPlainObject(e[n])) {
            var m = e[n].name,
                g = (u[m] || d[m] || {}).name,
                v = e[n].name,
                y = u[g] || d[g];
            g && v && "number" == typeof v && y && M < 5 && (M++, o.warn('addFrames: overwriting frame "' + (u[g] || d[g]).name + '" with a frame whose name of type "number" also equates to "' + g + '". This is valid but may potentially lead to unexpected behavior since all plotly.js frame names are stored internally as strings.'), 5 === M && o.warn("addFrames: This API call has yielded too many of these warnings. For the rest of this call, further warnings about numeric frame names will be suppressed.")), d[m] = {
              name: m
            }, p.push({
              frame: h.supplyFrameDefaults(e[n]),
              index: r && void 0 !== r[n] && null !== r[n] ? r[n] : f + n
            });
          }
        }

        p.sort(function (t, e) {
          return t.index > e.index ? -1 : t.index < e.index ? 1 : 0;
        });
        var x = [],
            b = [],
            _ = l.length;

        for (n = p.length - 1; n >= 0; n--) {
          if ("number" == typeof (i = p[n].frame).name && o.warn("Warning: addFrames accepts frames with numeric names, but the numbers areimplicitly cast to strings"), !i.name) for (; u[i.name = "frame " + t._transitionData._counter++];) {
            ;
          }

          if (u[i.name]) {
            for (a = 0; a < l.length && (l[a] || {}).name !== i.name; a++) {
              ;
            }

            x.push({
              type: "replace",
              index: a,
              value: i
            }), b.unshift({
              type: "replace",
              index: a,
              value: l[a]
            });
          } else s = Math.max(0, Math.min(p[n].index, _)), x.push({
            type: "insert",
            index: s,
            value: i
          }), b.unshift({
            type: "delete",
            index: s
          }), _++;
        }

        var w = h.modifyFrames,
            T = h.modifyFrames,
            k = [t, b],
            A = [t, x];
        return c && c.add(t, w, k, T, A), h.modifyFrames(t, x);
      }, r.deleteFrames = function (t, e) {
        if (t = o.getGraphDiv(t), !o.isPlotDiv(t)) throw new Error("This element is not a Plotly plot: " + t);
        var r,
            n,
            i = t._transitionData._frames,
            a = [],
            s = [];
        if (!e) for (e = [], r = 0; r < i.length; r++) {
          e.push(r);
        }

        for ((e = e.slice()).sort(), r = e.length - 1; r >= 0; r--) {
          n = e[r], a.push({
            type: "delete",
            index: n
          }), s.unshift({
            type: "insert",
            index: n,
            value: i[n]
          });
        }

        var l = h.modifyFrames,
            u = h.modifyFrames,
            f = [t, s],
            p = [t, a];
        return c && c.add(t, l, f, u, p), h.modifyFrames(t, a);
      }, r.addTraces = function t(e, n, i) {
        e = o.getGraphDiv(e);
        var a,
            s,
            l = [],
            u = r.deleteTraces,
            f = t,
            h = [e, l],
            p = [e, n];

        for (function (t, e, r) {
          var n, i;
          if (!Array.isArray(t.data)) throw new Error("gd.data must be an array.");
          if (void 0 === e) throw new Error("traces must be defined.");

          for (Array.isArray(e) || (e = [e]), n = 0; n < e.length; n++) {
            if ("object" != _typeof(i = e[n]) || Array.isArray(i) || null === i) throw new Error("all values in traces array must be non-array objects");
          }

          if (void 0 === r || Array.isArray(r) || (r = [r]), void 0 !== r && r.length !== e.length) throw new Error("if indices is specified, traces.length must equal indices.length");
        }(e, n, i), Array.isArray(n) || (n = [n]), n = n.map(function (t) {
          return o.extendFlat({}, t);
        }), _.cleanData(n), a = 0; a < n.length; a++) {
          e.data.push(n[a]);
        }

        for (a = 0; a < n.length; a++) {
          l.push(-n.length + a);
        }

        if (void 0 === i) return s = r.redraw(e), c.add(e, u, h, f, p), s;
        Array.isArray(i) || (i = [i]);

        try {
          I(e, l, i);
        } catch (t) {
          throw e.data.splice(e.data.length - n.length, n.length), t;
        }

        return c.startSequence(e), c.add(e, u, h, f, p), s = r.moveTraces(e, l, i), c.stopSequence(e), s;
      }, r.deleteTraces = function t(e, n) {
        e = o.getGraphDiv(e);
        var i,
            a,
            s = [],
            l = r.addTraces,
            u = t,
            f = [e, s, n],
            h = [e, n];
        if (void 0 === n) throw new Error("indices must be an integer or array of integers.");

        for (Array.isArray(n) || (n = [n]), P(e, n, "indices"), (n = C(n, e.data.length - 1)).sort(o.sorterDes), i = 0; i < n.length; i += 1) {
          a = e.data.splice(n[i], 1)[0], s.push(a);
        }

        var p = r.redraw(e);
        return c.add(e, l, f, u, h), p;
      }, r.extendTraces = function t(e, n, i, a) {
        function s(t, e, r) {
          var n, i;
          if (o.isTypedArray(t)) {
            if (r < 0) {
              var a = new t.constructor(0),
                  s = z(t, e);
              r < 0 ? (n = s, i = a) : (n = a, i = s);
            } else if (n = new t.constructor(r), i = new t.constructor(t.length + e.length - r), r === e.length) n.set(e), i.set(t);else if (r < e.length) {
              var l = e.length - r;
              n.set(e.subarray(l)), i.set(t), i.set(e.subarray(0, l), t.length);
            } else {
              var c = r - e.length,
                  u = t.length - c;
              n.set(t.subarray(u)), n.set(e, c), i.set(t.subarray(0, u));
            }
          } else n = t.concat(e), i = r >= 0 && r < n.length ? n.splice(0, n.length - r) : [];
          return [n, i];
        }

        var l = O(e = o.getGraphDiv(e), n, i, a, s),
            u = r.redraw(e),
            f = [e, l.update, i, l.maxPoints];
        return c.add(e, r.prependTraces, f, t, arguments), u;
      }, r.moveTraces = function t(e, n, i) {
        var a,
            s = [],
            l = [],
            u = t,
            f = t,
            h = [e = o.getGraphDiv(e), i, n],
            p = [e, n, i];
        if (I(e, n, i), n = Array.isArray(n) ? n : [n], void 0 === i) for (i = [], a = 0; a < n.length; a++) {
          i.push(-n.length + a);
        }

        for (i = Array.isArray(i) ? i : [i], n = C(n, e.data.length - 1), i = C(i, e.data.length - 1), a = 0; a < e.data.length; a++) {
          -1 === n.indexOf(a) && s.push(e.data[a]);
        }

        for (a = 0; a < n.length; a++) {
          l.push({
            newIndex: i[a],
            trace: e.data[n[a]]
          });
        }

        for (l.sort(function (t, e) {
          return t.newIndex - e.newIndex;
        }), a = 0; a < l.length; a += 1) {
          s.splice(l[a].newIndex, 0, l[a].trace);
        }

        e.data = s;
        var d = r.redraw(e);
        return c.add(e, u, h, f, p), d;
      }, r.prependTraces = function t(e, n, i, a) {
        function s(t, e, r) {
          var n, i;
          if (o.isTypedArray(t)) {
            if (r <= 0) {
              var a = new t.constructor(0),
                  s = z(e, t);
              r < 0 ? (n = s, i = a) : (n = a, i = s);
            } else if (n = new t.constructor(r), i = new t.constructor(t.length + e.length - r), r === e.length) n.set(e), i.set(t);else if (r < e.length) {
              var l = e.length - r;
              n.set(e.subarray(0, l)), i.set(e.subarray(l)), i.set(t, l);
            } else {
              var c = r - e.length;
              n.set(e), n.set(t.subarray(0, c), e.length), i.set(t.subarray(c));
            }
          } else n = e.concat(t), i = r >= 0 && r < n.length ? n.splice(r, n.length) : [];
          return [n, i];
        }

        var l = O(e = o.getGraphDiv(e), n, i, a, s),
            u = r.redraw(e),
            f = [e, l.update, i, l.maxPoints];
        return c.add(e, r.extendTraces, f, t, arguments), u;
      }, r.newPlot = function (t, e, n, i) {
        return t = o.getGraphDiv(t), h.cleanPlot([], {}, t._fullData || [], t._fullLayout || {}), h.purge(t), r._doPlot(t, e, n, i);
      }, r._doPlot = function (t, e, i, a) {
        var s;

        if (t = o.getGraphDiv(t), l.init(t), o.isPlainObject(e)) {
          var c = e;
          e = c.data, i = c.layout, a = c.config, s = c.frames;
        }

        if (!1 === l.triggerHandler(t, "plotly_beforeplot", [e, i, a])) return Promise.reject();
        e || i || o.isPlotDiv(t) || o.warn("Calling _doPlot as if redrawing but this container doesn't yet have a plot.", t), L(t, a), i || (i = {}), n.select(t).classed("js-plotly-plot", !0), d.makeTester(), Array.isArray(t._promises) || (t._promises = []);
        var f = 0 === (t.data || []).length && Array.isArray(e);
        Array.isArray(e) && (_.cleanData(e), f ? t.data = e : t.data.push.apply(t.data, e), t.empty = !1), t.layout && !f || (t.layout = _.cleanLayout(i)), h.supplyDefaults(t);

        var m = t._fullLayout,
            y = m._has("cartesian");

        m._replotting = !0, (f || m._shouldCreateBgLayer) && (!function (t) {
          var e = n.select(t),
              r = t._fullLayout;

          if (r._calcInverseTransform = at, r._calcInverseTransform(t), r._container = e.selectAll(".plot-container").data([0]), r._container.enter().insert("div", ":first-child").classed("plot-container", !0).classed("plotly", !0), r._paperdiv = r._container.selectAll(".svg-container").data([0]), r._paperdiv.enter().append("div").classed("user-select-none", !0).classed("svg-container", !0).style("position", "relative"), r._glcontainer = r._paperdiv.selectAll(".gl-container").data([{}]), r._glcontainer.enter().append("div").classed("gl-container", !0), r._paperdiv.selectAll(".main-svg").remove(), r._paperdiv.select(".modebar-container").remove(), r._paper = r._paperdiv.insert("svg", ":first-child").classed("main-svg", !0), r._toppaper = r._paperdiv.append("svg").classed("main-svg", !0), r._modebardiv = r._paperdiv.append("div"), delete r._modeBar, r._hoverpaper = r._paperdiv.append("svg").classed("main-svg", !0), !r._uid) {
            var i = {};
            n.selectAll("defs").each(function () {
              this.id && (i[this.id.split("-")[1]] = 1);
            }), r._uid = o.randstr(i);
          }

          r._paperdiv.selectAll(".main-svg").attr(v.svgAttrs), r._defs = r._paper.append("defs").attr("id", "defs-" + r._uid), r._clips = r._defs.append("g").classed("clips", !0), r._topdefs = r._toppaper.append("defs").attr("id", "topdefs-" + r._uid), r._topclips = r._topdefs.append("g").classed("clips", !0), r._bgLayer = r._paper.append("g").classed("bglayer", !0), r._draggers = r._paper.append("g").classed("draglayer", !0);

          var a = r._paper.append("g").classed("layer-below", !0);

          r._imageLowerLayer = a.append("g").classed("imagelayer", !0), r._shapeLowerLayer = a.append("g").classed("shapelayer", !0), r._cartesianlayer = r._paper.append("g").classed("cartesianlayer", !0), r._polarlayer = r._paper.append("g").classed("polarlayer", !0), r._ternarylayer = r._paper.append("g").classed("ternarylayer", !0), r._geolayer = r._paper.append("g").classed("geolayer", !0), r._funnelarealayer = r._paper.append("g").classed("funnelarealayer", !0), r._pielayer = r._paper.append("g").classed("pielayer", !0), r._treemaplayer = r._paper.append("g").classed("treemaplayer", !0), r._sunburstlayer = r._paper.append("g").classed("sunburstlayer", !0), r._indicatorlayer = r._toppaper.append("g").classed("indicatorlayer", !0), r._glimages = r._paper.append("g").classed("glimages", !0);

          var s = r._toppaper.append("g").classed("layer-above", !0);

          r._imageUpperLayer = s.append("g").classed("imagelayer", !0), r._shapeUpperLayer = s.append("g").classed("shapelayer", !0), r._infolayer = r._toppaper.append("g").classed("infolayer", !0), r._menulayer = r._toppaper.append("g").classed("menulayer", !0), r._zoomlayer = r._toppaper.append("g").classed("zoomlayer", !0), r._hoverlayer = r._hoverpaper.append("g").classed("hoverlayer", !0), r._modebardiv.classed("modebar-container", !0).style("position", "absolute").style("top", "0px").style("right", "0px"), t.emit("plotly_framework");
        }(t), m._shouldCreateBgLayer && delete m._shouldCreateBgLayer), d.initGradients(t), d.initPatterns(t), f && p.saveShowSpikeInitial(t);
        var x = !t.calcdata || t.calcdata.length !== (t._fullData || []).length;
        x && h.doCalcdata(t);

        for (var b = 0; b < t.calcdata.length; b++) {
          t.calcdata[b][0].trace = t._fullData[b];
        }

        t._context.responsive ? t._responsiveChartHandler || (t._responsiveChartHandler = function () {
          o.isHidden(t) || h.resize(t);
        }, window.addEventListener("resize", t._responsiveChartHandler)) : o.clearResponsive(t);
        var T = o.extendFlat({}, m._size),
            k = 0;

        function M() {
          if (h.clearAutoMarginIds(t), w.drawMarginPushers(t), p.allowAutoMargin(t), m._has("pie")) for (var e = t._fullData, r = 0; r < e.length; r++) {
            var n = e[r];
            "pie" === n.type && n.automargin && h.allowAutoMargin(t, "pie." + n.uid + ".automargin");
          }
          return h.doAutoMargin(t), h.previousPromises(t);
        }

        function S() {
          t._transitioning || (w.doAutoRangeAndConstraints(t), f && p.saveRangeInitial(t), u.getComponentMethod("rangeslider", "calcAutorange")(t));
        }

        var E = [h.previousPromises, function () {
          if (s) return r.addFrames(t, s);
        }, function e() {
          for (var r = m._basePlotModules, n = 0; n < r.length; n++) {
            r[n].drawFramework && r[n].drawFramework(t);
          }

          if (!m._glcanvas && m._has("gl") && (m._glcanvas = m._glcontainer.selectAll(".gl-canvas").data([{
            key: "contextLayer",
            context: !0,
            pick: !1
          }, {
            key: "focusLayer",
            context: !1,
            pick: !1
          }, {
            key: "pickLayer",
            context: !1,
            pick: !0
          }], function (t) {
            return t.key;
          }), m._glcanvas.enter().append("canvas").attr("class", function (t) {
            return "gl-canvas gl-canvas-" + t.key.replace("Layer", "");
          }).style({
            position: "absolute",
            top: 0,
            left: 0,
            overflow: "visible",
            "pointer-events": "none"
          })), m._glcanvas) {
            m._glcanvas.attr("width", m.width).attr("height", m.height);

            var i = m._glcanvas.data()[0].regl;

            if (i && (Math.floor(m.width) !== i._gl.drawingBufferWidth || Math.floor(m.height) !== i._gl.drawingBufferHeight)) {
              var a = "WebGL context buffer and canvas dimensions do not match due to browser/WebGL bug.";
              if (!k) return o.log(a + " Clearing graph and plotting again."), h.cleanPlot([], {}, t._fullData, m), h.supplyDefaults(t), m = t._fullLayout, h.doCalcdata(t), k++, e();
              o.error(a);
            }
          }

          return "h" === m.modebar.orientation ? m._modebardiv.style("height", null).style("width", "100%") : m._modebardiv.style("width", null).style("height", m.height + "px"), h.previousPromises(t);
        }, M, function () {
          if (h.didMarginChange(T, m._size)) return o.syncOrAsync([M, w.layoutStyles], t);
        }];
        y && E.push(function () {
          if (x) return o.syncOrAsync([u.getComponentMethod("shapes", "calcAutorange"), u.getComponentMethod("annotations", "calcAutorange"), S], t);
          S();
        }), E.push(w.layoutStyles), y && E.push(function () {
          return p.draw(t, f ? "" : "redraw");
        }, function (t) {
          t._fullLayout._insideTickLabelsAutorange && U(t, t._fullLayout._insideTickLabelsAutorange).then(function () {
            t._fullLayout._insideTickLabelsAutorange = void 0;
          });
        }), E.push(w.drawData, w.finalDraw, g, h.addLinks, h.rehover, h.redrag, h.doAutoMargin, function (t) {
          t._fullLayout._insideTickLabelsAutorange && f && p.saveRangeInitial(t, !0);
        }, h.previousPromises);
        var C = o.syncOrAsync(E, t);
        return C && C.then || (C = Promise.resolve()), C.then(function () {
          return A(t), t;
        });
      }, r.purge = function (t) {
        var e = (t = o.getGraphDiv(t))._fullLayout || {},
            r = t._fullData || [];
        return h.cleanPlot([], {}, r, e), h.purge(t), l.purge(t), e._container && e._container.remove(), delete t._context, t;
      }, r.react = function (t, e, n, i) {
        var a, l;
        t = o.getGraphDiv(t), _.clearPromiseQueue(t);
        var c = t._fullData,
            p = t._fullLayout;

        if (o.isPlotDiv(t) && c && p) {
          if (o.isPlainObject(e)) {
            var d = e;
            e = d.data, n = d.layout, i = d.config, a = d.frames;
          }

          var m = !1;

          if (i) {
            var g = o.extendDeep({}, t._context);
            t._context = void 0, L(t, i), m = function t(e, r) {
              var n;

              for (n in e) {
                if ("_" !== n.charAt(0)) {
                  var i = e[n],
                      a = r[n];
                  if (i !== a) if (o.isPlainObject(i) && o.isPlainObject(a)) {
                    if (t(i, a)) return !0;
                  } else {
                    if (!Array.isArray(i) || !Array.isArray(a)) return !0;
                    if (i.length !== a.length) return !0;

                    for (var s = 0; s < i.length; s++) {
                      if (i[s] !== a[s]) {
                        if (!o.isPlainObject(i[s]) || !o.isPlainObject(a[s])) return !0;
                        if (t(i[s], a[s])) return !0;
                      }
                    }
                  }
                }
              }
            }(g, t._context);
          }

          t.data = e || [], _.cleanData(t.data), t.layout = n || {}, _.cleanLayout(t.layout), function (t, e, r, n) {
            var i,
                a,
                l,
                c,
                u,
                f,
                h,
                p,
                d = n._preGUI,
                m = [],
                g = {};

            for (i in d) {
              if (u = $(i, K)) {
                if (a = u.attr || u.head + ".uirevision", (c = (l = s(n, a).get()) && tt(a, e)) && c === l && (null === (f = d[i]) && (f = void 0), nt(p = (h = s(e, i)).get(), f))) {
                  void 0 === p && "autorange" === i.substr(i.length - 9) && m.push(i.substr(0, i.length - 10)), h.set(R(s(n, i).get()));
                  continue;
                }
              } else o.warn("unrecognized GUI edit: " + i);

              delete d[i], "range[" === i.substr(i.length - 8, 6) && (g[i.substr(0, i.length - 9)] = 1);
            }

            for (var v = 0; v < m.length; v++) {
              var y = m[v];

              if (g[y]) {
                var x = s(e, y).get();
                x && delete x.autorange;
              }
            }

            var b = n._tracePreGUI;

            for (var _ in b) {
              var w,
                  T = b[_],
                  k = null;

              for (i in T) {
                if (!k) {
                  var M = et(_, r);

                  if (M < 0) {
                    delete b[_];
                    break;
                  }

                  var A = rt(_, t, (w = r[M]._fullInput).index);

                  if (A < 0) {
                    delete b[_];
                    break;
                  }

                  k = t[A];
                }

                if (u = $(i, Q)) {
                  if (u.attr ? c = (l = s(n, u.attr).get()) && tt(u.attr, e) : (l = w.uirevision, void 0 === (c = k.uirevision) && (c = e.uirevision)), c && c === l && (null === (f = T[i]) && (f = void 0), nt(p = (h = s(k, i)).get(), f))) {
                    h.set(R(s(w, i).get()));
                    continue;
                  }
                } else o.warn("unrecognized GUI edit: " + i + " in trace uid " + _);

                delete T[i];
              }
            }
          }(t.data, t.layout, c, p), h.supplyDefaults(t, {
            skipUpdateCalc: !0
          });

          var v = t._fullData,
              y = t._fullLayout,
              x = void 0 === y.datarevision,
              b = y.transition,
              k = function (t, e, r, n, i) {
            var a = T.layoutFlags();

            function o(t) {
              return f.getLayoutValObject(r, t);
            }

            a.arrays = {}, a.rangesAltered = {}, a.nChanges = 0, a.nChangesAnim = 0, it(e, r, [], {
              getValObject: o,
              flags: a,
              immutable: n,
              transition: i,
              gd: t
            }), (a.plot || a.calc) && (a.layoutReplot = !0);
            i && a.nChanges && a.nChangesAnim && (a.anim = a.nChanges === a.nChangesAnim ? "all" : "some");
            return a;
          }(t, p, y, x, b),
              M = k.newDataRevision,
              S = function (t, e, r, n, i, a) {
            var o = e.length === r.length;
            if (!i && !o) return {
              fullReplot: !0,
              calc: !0
            };
            var s,
                l,
                c = T.traceFlags();
            c.arrays = {}, c.nChanges = 0, c.nChangesAnim = 0;
            var u = {
              getValObject: function getValObject(t) {
                var e = f.getTraceValObject(l, t);
                return !l._module.animatable && e.anim && (e.anim = !1), e;
              },
              flags: c,
              immutable: n,
              transition: i,
              newDataRevision: a,
              gd: t
            },
                p = {};

            for (s = 0; s < e.length; s++) {
              if (r[s]) {
                if (l = r[s]._fullInput, h.hasMakesDataTransform(l) && (l = r[s]), p[l.uid]) continue;
                p[l.uid] = 1, it(e[s]._fullInput, l, [], u);
              }
            }

            (c.calc || c.plot) && (c.fullReplot = !0);
            i && c.nChanges && c.nChangesAnim && (c.anim = c.nChanges === c.nChangesAnim && o ? "all" : "some");
            return c;
          }(t, c, v, x, b, M);

          if (X(t) && (k.layoutReplot = !0), S.calc || k.calc) {
            t.calcdata = void 0;

            for (var E = Object.getOwnPropertyNames(y), C = 0; C < E.length; C++) {
              var P = E[C],
                  I = P.substring(0, 5);

              if ("xaxis" === I || "yaxis" === I) {
                var O = y[P]._emptyCategories;
                O && O();
              }
            }
          } else h.supplyDefaultsUpdateCalc(t.calcdata, v);

          var z = [];
          if (a && (t._transitionData = {}, h.createTransitionData(t), z.push(function () {
            return r.addFrames(t, a);
          })), y.transition && !m && (S.anim || k.anim)) k.ticks && z.push(w.doTicksRelayout), h.doCalcdata(t), w.doAutoRangeAndConstraints(t), z.push(function () {
            return h.transitionFromReact(t, S, k, p);
          });else if (S.fullReplot || k.layoutReplot || m) t._fullLayout._skipDefaults = !0, z.push(r._doPlot);else {
            for (var D in k.arrays) {
              var F = k.arrays[D];

              if (F.length) {
                var B = u.getComponentMethod(D, "drawOne");
                if (B !== o.noop) for (var N = 0; N < F.length; N++) {
                  B(t, F[N]);
                } else {
                  var j = u.getComponentMethod(D, "draw");
                  if (j === o.noop) throw new Error("cannot draw components: " + D);
                  j(t);
                }
              }
            }

            z.push(h.previousPromises), S.style && z.push(w.doTraceStyle), (S.colorbars || k.colorbars) && z.push(w.doColorBars), k.legend && z.push(w.doLegend), k.layoutstyle && z.push(w.layoutStyles), k.axrange && q(z), k.ticks && z.push(w.doTicksRelayout), k.modebar && z.push(w.doModeBar), k.camera && z.push(w.doCamera), z.push(A);
          }
          z.push(h.rehover, h.redrag), (l = o.syncOrAsync(z, t)) && l.then || (l = Promise.resolve(t));
        } else l = r.newPlot(t, e, n, i);

        return l.then(function () {
          return t.emit("plotly_react", {
            data: e,
            layout: n
          }), t;
        });
      }, r.redraw = function (t) {
        if (t = o.getGraphDiv(t), !o.isPlotDiv(t)) throw new Error("This element is not a Plotly plot: " + t);
        return _.cleanData(t.data), _.cleanLayout(t.layout), t.calcdata = void 0, r._doPlot(t).then(function () {
          return t.emit("plotly_redraw"), t;
        });
      }, r.relayout = U, r.restyle = D, r.setPlotConfig = function (t) {
        return o.extendFlat(x, t);
      }, r.update = Z, r._guiRelayout = J(U), r._guiRestyle = J(D), r._guiUpdate = J(Z), r._storeDirectGUIEdit = function (t, e, r) {
        for (var n in r) {
          B(n, s(t, n).get(), r[n], e);
        }
      };
    }, {
      "../components/color": 658,
      "../components/drawing": 680,
      "../constants/xmlns_namespaces": 772,
      "../lib": 795,
      "../lib/events": 784,
      "../lib/queue": 811,
      "../plots/cartesian/axes": 845,
      "../plots/cartesian/constants": 851,
      "../plots/cartesian/graph_interact": 854,
      "../plots/cartesian/select": 864,
      "../plots/plots": 909,
      "../registry": 923,
      "./edit_types": 827,
      "./helpers": 828,
      "./manage_arrays": 830,
      "./plot_config": 832,
      "./plot_schema": 833,
      "./subroutines": 835,
      "@plotly/d3": 57,
      "fast-isnumeric": 240,
      "has-hover": 434
    }],
    832: [function (t, e, r) {
      "use strict";

      var n = {
        staticPlot: {
          valType: "boolean",
          dflt: !1
        },
        plotlyServerURL: {
          valType: "string",
          dflt: ""
        },
        editable: {
          valType: "boolean",
          dflt: !1
        },
        edits: {
          annotationPosition: {
            valType: "boolean",
            dflt: !1
          },
          annotationTail: {
            valType: "boolean",
            dflt: !1
          },
          annotationText: {
            valType: "boolean",
            dflt: !1
          },
          axisTitleText: {
            valType: "boolean",
            dflt: !1
          },
          colorbarPosition: {
            valType: "boolean",
            dflt: !1
          },
          colorbarTitleText: {
            valType: "boolean",
            dflt: !1
          },
          legendPosition: {
            valType: "boolean",
            dflt: !1
          },
          legendText: {
            valType: "boolean",
            dflt: !1
          },
          shapePosition: {
            valType: "boolean",
            dflt: !1
          },
          titleText: {
            valType: "boolean",
            dflt: !1
          }
        },
        autosizable: {
          valType: "boolean",
          dflt: !1
        },
        responsive: {
          valType: "boolean",
          dflt: !1
        },
        fillFrame: {
          valType: "boolean",
          dflt: !1
        },
        frameMargins: {
          valType: "number",
          dflt: 0,
          min: 0,
          max: .5
        },
        scrollZoom: {
          valType: "flaglist",
          flags: ["cartesian", "gl3d", "geo", "mapbox"],
          extras: [!0, !1],
          dflt: "gl3d+geo+mapbox"
        },
        doubleClick: {
          valType: "enumerated",
          values: [!1, "reset", "autosize", "reset+autosize"],
          dflt: "reset+autosize"
        },
        doubleClickDelay: {
          valType: "number",
          dflt: 300,
          min: 0
        },
        showAxisDragHandles: {
          valType: "boolean",
          dflt: !0
        },
        showAxisRangeEntryBoxes: {
          valType: "boolean",
          dflt: !0
        },
        showTips: {
          valType: "boolean",
          dflt: !0
        },
        showLink: {
          valType: "boolean",
          dflt: !1
        },
        linkText: {
          valType: "string",
          dflt: "Edit chart",
          noBlank: !0
        },
        sendData: {
          valType: "boolean",
          dflt: !0
        },
        showSources: {
          valType: "any",
          dflt: !1
        },
        displayModeBar: {
          valType: "enumerated",
          values: ["hover", !0, !1],
          dflt: "hover"
        },
        showSendToCloud: {
          valType: "boolean",
          dflt: !1
        },
        showEditInChartStudio: {
          valType: "boolean",
          dflt: !1
        },
        modeBarButtonsToRemove: {
          valType: "any",
          dflt: []
        },
        modeBarButtonsToAdd: {
          valType: "any",
          dflt: []
        },
        modeBarButtons: {
          valType: "any",
          dflt: !1
        },
        toImageButtonOptions: {
          valType: "any",
          dflt: {}
        },
        displaylogo: {
          valType: "boolean",
          dflt: !0
        },
        watermark: {
          valType: "boolean",
          dflt: !1
        },
        plotGlPixelRatio: {
          valType: "number",
          dflt: 2,
          min: 1,
          max: 4
        },
        setBackground: {
          valType: "any",
          dflt: "transparent"
        },
        topojsonURL: {
          valType: "string",
          noBlank: !0,
          dflt: "https://cdn.plot.ly/"
        },
        mapboxAccessToken: {
          valType: "string",
          dflt: null
        },
        logging: {
          valType: "integer",
          min: 0,
          max: 2,
          dflt: 1
        },
        notifyOnLogging: {
          valType: "integer",
          min: 0,
          max: 2,
          dflt: 0
        },
        queueLength: {
          valType: "integer",
          min: 0,
          dflt: 0
        },
        globalTransforms: {
          valType: "any",
          dflt: []
        },
        locale: {
          valType: "string",
          dflt: "en-US"
        },
        locales: {
          valType: "any",
          dflt: {}
        }
      },
          i = {};
      !function t(e, r) {
        for (var n in e) {
          var i = e[n];
          i.valType ? r[n] = i.dflt : (r[n] || (r[n] = {}), t(i, r[n]));
        }
      }(n, i), e.exports = {
        configAttributes: n,
        dfltConfig: i
      };
    }, {}],
    833: [function (t, e, r) {
      "use strict";

      var n = t("../registry"),
          i = t("../lib"),
          a = t("../plots/attributes"),
          o = t("../plots/layout_attributes"),
          s = t("../plots/frame_attributes"),
          l = t("../plots/animation_attributes"),
          c = t("./plot_config").configAttributes,
          u = t("./edit_types"),
          f = i.extendDeepAll,
          h = i.isPlainObject,
          p = i.isArrayOrTypedArray,
          d = i.nestedProperty,
          m = i.valObjectMeta,
          g = ["_isSubplotObj", "_isLinkedToArray", "_arrayAttrRegexps", "_deprecated"];

      function v(t, e, r) {
        if (!t) return !1;
        if (t._isLinkedToArray) if (y(e[r])) r++;else if (r < e.length) return !1;

        for (; r < e.length; r++) {
          var n = t[e[r]];
          if (!h(n)) break;
          if (t = n, r === e.length - 1) break;

          if (t._isLinkedToArray) {
            if (!y(e[++r])) return !1;
          } else if ("info_array" === t.valType) {
            var i = e[++r];
            if (!y(i)) return !1;
            var a = t.items;

            if (Array.isArray(a)) {
              if (i >= a.length) return !1;

              if (2 === t.dimensions) {
                if (r++, e.length === r) return t;
                var o = e[r];
                if (!y(o)) return !1;
                t = a[i][o];
              } else t = a[i];
            } else t = a;
          }
        }

        return t;
      }

      function y(t) {
        return t === Math.round(t) && t >= 0;
      }

      function x() {
        var t,
            e,
            r = {};

        for (t in f(r, o), n.subplotsRegistry) {
          if ((e = n.subplotsRegistry[t]).layoutAttributes) if (Array.isArray(e.attr)) for (var i = 0; i < e.attr.length; i++) {
            w(r, e, e.attr[i]);
          } else w(r, e, "subplot" === e.attr ? e.name : e.attr);
        }

        for (t in n.componentsRegistry) {
          var a = (e = n.componentsRegistry[t]).schema;

          if (a && (a.subplots || a.layout)) {
            var s = a.subplots;
            if (s && s.xaxis && !s.yaxis) for (var l in s.xaxis) {
              delete r.yaxis[l];
            }
          } else "colorscale" === e.name ? f(r, e.layoutAttributes) : e.layoutAttributes && T(r, e.layoutAttributes, e.name);
        }

        return {
          layoutAttributes: _(r)
        };
      }

      function b() {
        var t = {
          frames: f({}, s)
        };
        return _(t), t.frames;
      }

      function _(t) {
        return function (t) {
          r.crawl(t, function (t, e, n) {
            r.isValObject(t) ? !0 !== t.arrayOk && "data_array" !== t.valType || (n[e + "src"] = {
              valType: "string",
              editType: "none"
            }) : h(t) && (t.role = "object");
          });
        }(t), function (t) {
          r.crawl(t, function (t, e, r) {
            if (t) {
              var n = t._isLinkedToArray;
              n && (delete t._isLinkedToArray, r[e] = {
                items: {}
              }, r[e].items[n] = t, r[e].role = "object");
            }
          });
        }(t), function (t) {
          !function t(e) {
            for (var r in e) {
              if (h(e[r])) t(e[r]);else if (Array.isArray(e[r])) for (var n = 0; n < e[r].length; n++) {
                t(e[r][n]);
              } else e[r] instanceof RegExp && (e[r] = e[r].toString());
            }
          }(t);
        }(t), t;
      }

      function w(t, e, r) {
        var n = d(t, r),
            i = f({}, e.layoutAttributes);
        i._isSubplotObj = !0, n.set(i);
      }

      function T(t, e, r) {
        var n = d(t, r);
        n.set(f(n.get() || {}, e));
      }

      r.IS_SUBPLOT_OBJ = "_isSubplotObj", r.IS_LINKED_TO_ARRAY = "_isLinkedToArray", r.DEPRECATED = "_deprecated", r.UNDERSCORE_ATTRS = g, r.get = function () {
        var t = {};
        n.allTypes.forEach(function (e) {
          t[e] = function (t) {
            var e, i;
            e = n.modules[t]._module, i = e.basePlotModule;
            var o = {
              type: null
            },
                s = f({}, a),
                l = f({}, e.attributes);
            r.crawl(l, function (t, e, r, n, i) {
              d(s, i).set(void 0), void 0 === t && d(l, i).set(void 0);
            }), f(o, s), n.traceIs(t, "noOpacity") && delete o.opacity;
            n.traceIs(t, "showLegend") || (delete o.showlegend, delete o.legendgroup);
            n.traceIs(t, "noHover") && (delete o.hoverinfo, delete o.hoverlabel);
            e.selectPoints || delete o.selectedpoints;
            f(o, l), i.attributes && f(o, i.attributes);
            o.type = t;
            var c = {
              meta: e.meta || {},
              categories: e.categories || {},
              animatable: Boolean(e.animatable),
              type: t,
              attributes: _(o)
            };

            if (e.layoutAttributes) {
              var u = {};
              f(u, e.layoutAttributes), c.layoutAttributes = _(u);
            }

            e.animatable || r.crawl(c, function (t) {
              r.isValObject(t) && "anim" in t && delete t.anim;
            });
            return c;
          }(e);
        });
        var e = {};
        return Object.keys(n.transformsRegistry).forEach(function (t) {
          e[t] = function (t) {
            var e = n.transformsRegistry[t],
                r = f({}, e.attributes);
            return Object.keys(n.componentsRegistry).forEach(function (e) {
              var i = n.componentsRegistry[e];
              i.schema && i.schema.transforms && i.schema.transforms[t] && Object.keys(i.schema.transforms[t]).forEach(function (e) {
                T(r, i.schema.transforms[t][e], e);
              });
            }), {
              attributes: _(r)
            };
          }(t);
        }), {
          defs: {
            valObjects: m,
            metaKeys: g.concat(["description", "role", "editType", "impliedEdits"]),
            editType: {
              traces: u.traces,
              layout: u.layout
            },
            impliedEdits: {}
          },
          traces: t,
          layout: x(),
          transforms: e,
          frames: b(),
          animation: _(l),
          config: _(c)
        };
      }, r.crawl = function (t, e, n, i) {
        var a = n || 0;
        i = i || "", Object.keys(t).forEach(function (n) {
          var o = t[n];

          if (-1 === g.indexOf(n)) {
            var s = (i ? i + "." : "") + n;
            e(o, n, t, a, s), r.isValObject(o) || h(o) && "impliedEdits" !== n && r.crawl(o, e, a + 1, s);
          }
        });
      }, r.isValObject = function (t) {
        return t && void 0 !== t.valType;
      }, r.findArrayAttributes = function (t) {
        var e,
            n,
            i = [],
            o = [],
            s = [];

        function l(t, r, a, l) {
          o = o.slice(0, l).concat([r]), s = s.slice(0, l).concat([t && t._isLinkedToArray]), t && ("data_array" === t.valType || !0 === t.arrayOk) && !("colorbar" === o[l - 1] && ("ticktext" === r || "tickvals" === r)) && function t(e, r, a) {
            var l = e[o[r]],
                c = a + o[r];
            if (r === o.length - 1) p(l) && i.push(n + c);else if (s[r]) {
              if (Array.isArray(l)) for (var u = 0; u < l.length; u++) {
                h(l[u]) && t(l[u], r + 1, c + "[" + u + "].");
              }
            } else h(l) && t(l, r + 1, c + ".");
          }(e, 0, "");
        }

        e = t, n = "", r.crawl(a, l), t._module && t._module.attributes && r.crawl(t._module.attributes, l);
        var c = t.transforms;
        if (c) for (var u = 0; u < c.length; u++) {
          var f = c[u],
              d = f._module;
          d && (n = "transforms[" + u + "].", e = f, r.crawl(d.attributes, l));
        }
        return i;
      }, r.getTraceValObject = function (t, e) {
        var r,
            i,
            o = e[0],
            s = 1;

        if ("transforms" === o) {
          if (1 === e.length) return a.transforms;
          var l = t.transforms;
          if (!Array.isArray(l) || !l.length) return !1;
          var c = e[1];
          if (!y(c) || c >= l.length) return !1;
          i = (r = (n.transformsRegistry[l[c].type] || {}).attributes) && r[e[2]], s = 3;
        } else {
          var u = t._module;
          if (u || (u = (n.modules[t.type || a.type.dflt] || {})._module), !u) return !1;

          if (!(i = (r = u.attributes) && r[o])) {
            var f = u.basePlotModule;
            f && f.attributes && (i = f.attributes[o]);
          }

          i || (i = a[o]);
        }

        return v(i, e, s);
      }, r.getLayoutValObject = function (t, e) {
        return v(function (t, e) {
          var r,
              i,
              a,
              s,
              l = t._basePlotModules;

          if (l) {
            var c;

            for (r = 0; r < l.length; r++) {
              if ((a = l[r]).attrRegex && a.attrRegex.test(e)) {
                if (a.layoutAttrOverrides) return a.layoutAttrOverrides;
                !c && a.layoutAttributes && (c = a.layoutAttributes);
              }

              var u = a.baseLayoutAttrOverrides;
              if (u && e in u) return u[e];
            }

            if (c) return c;
          }

          var f = t._modules;
          if (f) for (r = 0; r < f.length; r++) {
            if ((s = f[r].layoutAttributes) && e in s) return s[e];
          }

          for (i in n.componentsRegistry) {
            if ("colorscale" === (a = n.componentsRegistry[i]).name && 0 === e.indexOf("coloraxis")) return a.layoutAttributes[e];
            if (!a.schema && e === a.name) return a.layoutAttributes;
          }

          return e in o && o[e];
        }(t, e[0]), e, 1);
      };
    }, {
      "../lib": 795,
      "../plots/animation_attributes": 839,
      "../plots/attributes": 841,
      "../plots/frame_attributes": 874,
      "../plots/layout_attributes": 900,
      "../registry": 923,
      "./edit_types": 827,
      "./plot_config": 832
    }],
    834: [function (t, e, r) {
      "use strict";

      var n = t("../lib"),
          i = t("../plots/attributes"),
          a = {
        name: {
          valType: "string",
          editType: "none"
        }
      };

      function o(t) {
        return t && "string" == typeof t;
      }

      function s(t) {
        var e = t.length - 1;
        return "s" !== t.charAt(e) && n.warn("bad argument to arrayDefaultKey: " + t), t.substr(0, t.length - 1) + "defaults";
      }

      a.templateitemname = {
        valType: "string",
        editType: "calc"
      }, r.templatedArray = function (t, e) {
        return e._isLinkedToArray = t, e.name = a.name, e.templateitemname = a.templateitemname, e;
      }, r.traceTemplater = function (t) {
        var e,
            r,
            a = {};

        for (e in t) {
          r = t[e], Array.isArray(r) && r.length && (a[e] = 0);
        }

        return {
          newTrace: function newTrace(o) {
            var s = {
              type: e = n.coerce(o, {}, i, "type"),
              _template: null
            };

            if (e in a) {
              r = t[e];
              var l = a[e] % r.length;
              a[e]++, s._template = r[l];
            }

            return s;
          }
        };
      }, r.newContainer = function (t, e, r) {
        var i = t._template,
            a = i && (i[e] || r && i[r]);
        return n.isPlainObject(a) || (a = null), t[e] = {
          _template: a
        };
      }, r.arrayTemplater = function (t, e, r) {
        var n = t._template,
            i = n && n[s(e)],
            a = n && n[e];
        Array.isArray(a) && a.length || (a = []);
        var l = {};
        return {
          newItem: function newItem(t) {
            var e = {
              name: t.name,
              _input: t
            },
                n = e.templateitemname = t.templateitemname;
            if (!o(n)) return e._template = i, e;

            for (var s = 0; s < a.length; s++) {
              var c = a[s];
              if (c.name === n) return l[n] = 1, e._template = c, e;
            }

            return e[r] = t[r] || !1, e._template = !1, e;
          },
          defaultItems: function defaultItems() {
            for (var t = [], e = 0; e < a.length; e++) {
              var r = a[e],
                  n = r.name;

              if (o(n) && !l[n]) {
                var i = {
                  _template: r,
                  name: n,
                  _input: {
                    _templateitemname: n
                  }
                };
                i.templateitemname = r.templateitemname, t.push(i), l[n] = 1;
              }
            }

            return t;
          }
        };
      }, r.arrayDefaultKey = s, r.arrayEditor = function (t, e, r) {
        var i = (n.nestedProperty(t, e).get() || []).length,
            a = r._index,
            o = a >= i && (r._input || {})._templateitemname;
        o && (a = i);
        var s,
            l = e + "[" + a + "]";

        function c() {
          s = {}, o && (s[l] = {}, s[l].templateitemname = o);
        }

        function u(t, e) {
          o ? n.nestedProperty(s[l], t).set(e) : s[l + "." + t] = e;
        }

        function f() {
          var t = s;
          return c(), t;
        }

        return c(), {
          modifyBase: function modifyBase(t, e) {
            s[t] = e;
          },
          modifyItem: u,
          getUpdateObj: f,
          applyUpdate: function applyUpdate(e, r) {
            e && u(e, r);
            var i = f();

            for (var a in i) {
              n.nestedProperty(t, a).set(i[a]);
            }
          }
        };
      };
    }, {
      "../lib": 795,
      "../plots/attributes": 841
    }],
    835: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../registry"),
          a = t("../plots/plots"),
          o = t("../lib"),
          s = t("../lib/clear_gl_canvases"),
          l = t("../components/color"),
          c = t("../components/drawing"),
          u = t("../components/titles"),
          f = t("../components/modebar"),
          h = t("../plots/cartesian/axes"),
          p = t("../constants/alignment"),
          d = t("../plots/cartesian/constraints"),
          m = d.enforce,
          g = d.clean,
          v = t("../plots/cartesian/autorange").doAutoRange;

      function y(t, e, r) {
        for (var n = 0; n < r.length; n++) {
          var i = r[n][0],
              a = r[n][1];
          if (!(i[0] >= t[1] || i[1] <= t[0]) && a[0] < e[1] && a[1] > e[0]) return !0;
        }

        return !1;
      }

      function x(t) {
        var e,
            i,
            s,
            u,
            d,
            m,
            g = t._fullLayout,
            v = g._size,
            x = v.p,
            _ = h.list(t, "", !0);

        if (g._paperdiv.style({
          width: t._context.responsive && g.autosize && !t._context._hasZeroWidth && !t.layout.width ? "100%" : g.width + "px",
          height: t._context.responsive && g.autosize && !t._context._hasZeroHeight && !t.layout.height ? "100%" : g.height + "px"
        }).selectAll(".main-svg").call(c.setSize, g.width, g.height), t._context.setBackground(t, g.paper_bgcolor), r.drawMainTitle(t), f.manage(t), !g._has("cartesian")) return a.previousPromises(t);

        function T(t, e, r) {
          var n = t._lw / 2;
          return "x" === t._id.charAt(0) ? e ? "top" === r ? e._offset - x - n : e._offset + e._length + x + n : v.t + v.h * (1 - (t.position || 0)) + n % 1 : e ? "right" === r ? e._offset + e._length + x + n : e._offset - x - n : v.l + v.w * (t.position || 0) + n % 1;
        }

        for (e = 0; e < _.length; e++) {
          var k = (u = _[e])._anchorAxis;
          u._linepositions = {}, u._lw = c.crispRound(t, u.linewidth, 1), u._mainLinePosition = T(u, k, u.side), u._mainMirrorPosition = u.mirror && k ? T(u, k, p.OPPOSITE_SIDE[u.side]) : null;
        }

        var M = [],
            A = [],
            S = [],
            E = 1 === l.opacity(g.paper_bgcolor) && 1 === l.opacity(g.plot_bgcolor) && g.paper_bgcolor === g.plot_bgcolor;

        for (i in g._plots) {
          if ((s = g._plots[i]).mainplot) s.bg && s.bg.remove(), s.bg = void 0;else {
            var L = s.xaxis.domain,
                C = s.yaxis.domain,
                P = s.plotgroup;

            if (y(L, C, S)) {
              var I = P.node(),
                  O = s.bg = o.ensureSingle(P, "rect", "bg");
              I.insertBefore(O.node(), I.childNodes[0]), A.push(i);
            } else P.select("rect.bg").remove(), S.push([L, C]), E || (M.push(i), A.push(i));
          }
        }

        var z,
            D,
            R,
            F,
            B,
            N,
            j,
            U,
            V,
            q,
            H,
            G,
            Y,
            W = g._bgLayer.selectAll(".bg").data(M);

        for (W.enter().append("rect").classed("bg", !0), W.exit().remove(), W.each(function (t) {
          g._plots[t].bg = n.select(this);
        }), e = 0; e < A.length; e++) {
          s = g._plots[A[e]], d = s.xaxis, m = s.yaxis, s.bg && void 0 !== d._offset && void 0 !== m._offset && s.bg.call(c.setRect, d._offset - x, m._offset - x, d._length + 2 * x, m._length + 2 * x).call(l.fill, g.plot_bgcolor).style("stroke-width", 0);
        }

        if (!g._hasOnlyLargeSploms) for (i in g._plots) {
          s = g._plots[i], d = s.xaxis, m = s.yaxis;
          var X,
              Z,
              J = s.clipId = "clip" + g._uid + i + "plot",
              K = o.ensureSingleById(g._clips, "clipPath", J, function (t) {
            t.classed("plotclip", !0).append("rect");
          });
          s.clipRect = K.select("rect").attr({
            width: d._length,
            height: m._length
          }), c.setTranslate(s.plot, d._offset, m._offset), s._hasClipOnAxisFalse ? (X = null, Z = J) : (X = J, Z = null), c.setClipUrl(s.plot, X, t), s.layerClipId = Z;
        }

        function Q(t) {
          return "M" + z + "," + t + "H" + D;
        }

        function $(t) {
          return "M" + d._offset + "," + t + "h" + d._length;
        }

        function tt(t) {
          return "M" + t + "," + U + "V" + j;
        }

        function et(t) {
          return "M" + t + "," + m._offset + "v" + m._length;
        }

        function rt(t, e, r) {
          if (!t.showline || i !== t._mainSubplot) return "";
          if (!t._anchorAxis) return r(t._mainLinePosition);
          var n = e(t._mainLinePosition);
          return t.mirror && (n += e(t._mainMirrorPosition)), n;
        }

        for (i in g._plots) {
          s = g._plots[i], d = s.xaxis, m = s.yaxis;
          var nt = "M0,0";
          b(d, i) && (B = w(d, "left", m, _), z = d._offset - (B ? x + B : 0), N = w(d, "right", m, _), D = d._offset + d._length + (N ? x + N : 0), R = T(d, m, "bottom"), F = T(d, m, "top"), !(Y = !d._anchorAxis || i !== d._mainSubplot) || "allticks" !== d.mirror && "all" !== d.mirror || (d._linepositions[i] = [R, F]), nt = rt(d, Q, $), Y && d.showline && ("all" === d.mirror || "allticks" === d.mirror) && (nt += Q(R) + Q(F)), s.xlines.style("stroke-width", d._lw + "px").call(l.stroke, d.showline ? d.linecolor : "rgba(0,0,0,0)")), s.xlines.attr("d", nt);
          var it = "M0,0";
          b(m, i) && (H = w(m, "bottom", d, _), j = m._offset + m._length + (H ? x : 0), G = w(m, "top", d, _), U = m._offset - (G ? x : 0), V = T(m, d, "left"), q = T(m, d, "right"), !(Y = !m._anchorAxis || i !== m._mainSubplot) || "allticks" !== m.mirror && "all" !== m.mirror || (m._linepositions[i] = [V, q]), it = rt(m, tt, et), Y && m.showline && ("all" === m.mirror || "allticks" === m.mirror) && (it += tt(V) + tt(q)), s.ylines.style("stroke-width", m._lw + "px").call(l.stroke, m.showline ? m.linecolor : "rgba(0,0,0,0)")), s.ylines.attr("d", it);
        }

        return h.makeClipPaths(t), a.previousPromises(t);
      }

      function b(t, e) {
        return (t.ticks || t.showline) && (e === t._mainSubplot || "all" === t.mirror || "allticks" === t.mirror);
      }

      function _(t, e, r) {
        if (!r.showline || !r._lw) return !1;
        if ("all" === r.mirror || "allticks" === r.mirror) return !0;
        var n = r._anchorAxis;
        if (!n) return !1;
        var i = p.FROM_BL[e];
        return r.side === e ? n.domain[i] === t.domain[i] : r.mirror && n.domain[1 - i] === t.domain[1 - i];
      }

      function w(t, e, r, n) {
        if (_(t, e, r)) return r._lw;

        for (var i = 0; i < n.length; i++) {
          var a = n[i];
          if (a._mainAxis === r._mainAxis && _(t, e, a)) return a._lw;
        }

        return 0;
      }

      function T(t, e) {
        var r = t.title,
            n = t._size,
            i = 0;

        switch ("start" === e ? i = r.pad.l : "end" === e && (i = -r.pad.r), r.xref) {
          case "paper":
            return n.l + n.w * r.x + i;

          case "container":
          default:
            return t.width * r.x + i;
        }
      }

      function k(t, e) {
        var r = t.title,
            n = t._size,
            i = 0;
        if ("0em" !== e && e ? e === p.CAP_SHIFT + "em" && (i = r.pad.t) : i = -r.pad.b, "auto" === r.y) return n.t / 2;

        switch (r.yref) {
          case "paper":
            return n.t + n.h - n.h * r.y + i;

          case "container":
          default:
            return t.height - t.height * r.y + i;
        }
      }

      r.layoutStyles = function (t) {
        return o.syncOrAsync([a.doAutoMargin, x], t);
      }, r.drawMainTitle = function (t) {
        var e = t._fullLayout,
            r = function (t) {
          var e = t.title,
              r = "middle";
          o.isRightAnchor(e) ? r = "end" : o.isLeftAnchor(e) && (r = "start");
          return r;
        }(e),
            n = function (t) {
          var e = t.title,
              r = "0em";
          o.isTopAnchor(e) ? r = p.CAP_SHIFT + "em" : o.isMiddleAnchor(e) && (r = p.MID_SHIFT + "em");
          return r;
        }(e);

        u.draw(t, "gtitle", {
          propContainer: e,
          propName: "title.text",
          placeholder: e._dfltTitle.plot,
          attributes: {
            x: T(e, r),
            y: k(e, n),
            "text-anchor": r,
            dy: n
          }
        });
      }, r.doTraceStyle = function (t) {
        var e,
            n = t.calcdata,
            o = [];

        for (e = 0; e < n.length; e++) {
          var l = n[e],
              c = l[0] || {},
              u = c.trace || {},
              f = u._module || {},
              h = f.arraysToCalcdata;
          h && h(l, u);
          var p = f.editStyle;
          p && o.push({
            fn: p,
            cd0: c
          });
        }

        if (o.length) {
          for (e = 0; e < o.length; e++) {
            var d = o[e];
            d.fn(t, d.cd0);
          }

          s(t), r.redrawReglTraces(t);
        }

        return a.style(t), i.getComponentMethod("legend", "draw")(t), a.previousPromises(t);
      }, r.doColorBars = function (t) {
        return i.getComponentMethod("colorbar", "draw")(t), a.previousPromises(t);
      }, r.layoutReplot = function (t) {
        var e = t.layout;
        return t.layout = void 0, i.call("_doPlot", t, "", e);
      }, r.doLegend = function (t) {
        return i.getComponentMethod("legend", "draw")(t), a.previousPromises(t);
      }, r.doTicksRelayout = function (t) {
        return h.draw(t, "redraw"), t._fullLayout._hasOnlyLargeSploms && (i.subplotsRegistry.splom.updateGrid(t), s(t), r.redrawReglTraces(t)), r.drawMainTitle(t), a.previousPromises(t);
      }, r.doModeBar = function (t) {
        var e = t._fullLayout;
        f.manage(t);

        for (var r = 0; r < e._basePlotModules.length; r++) {
          var n = e._basePlotModules[r].updateFx;
          n && n(t);
        }

        return a.previousPromises(t);
      }, r.doCamera = function (t) {
        for (var e = t._fullLayout, r = e._subplots.gl3d, n = 0; n < r.length; n++) {
          var i = e[r[n]];

          i._scene.setViewport(i);
        }
      }, r.drawData = function (t) {
        var e = t._fullLayout;
        s(t);

        for (var n = e._basePlotModules, o = 0; o < n.length; o++) {
          n[o].plot(t);
        }

        return r.redrawReglTraces(t), a.style(t), i.getComponentMethod("shapes", "draw")(t), i.getComponentMethod("annotations", "draw")(t), i.getComponentMethod("images", "draw")(t), e._replotting = !1, a.previousPromises(t);
      }, r.redrawReglTraces = function (t) {
        var e = t._fullLayout;

        if (e._has("regl")) {
          var r,
              n,
              i = t._fullData,
              a = [],
              s = [];

          for (e._hasOnlyLargeSploms && e._splomGrid.draw(), r = 0; r < i.length; r++) {
            var l = i[r];
            !0 === l.visible && 0 !== l._length && ("splom" === l.type ? e._splomScenes[l.uid].draw() : "scattergl" === l.type ? o.pushUnique(a, l.xaxis + l.yaxis) : "scatterpolargl" === l.type && o.pushUnique(s, l.subplot));
          }

          for (r = 0; r < a.length; r++) {
            (n = e._plots[a[r]])._scene && n._scene.draw();
          }

          for (r = 0; r < s.length; r++) {
            (n = e[s[r]]._subplot)._scene && n._scene.draw();
          }
        }
      }, r.doAutoRangeAndConstraints = function (t) {
        for (var e, r = h.list(t, "", !0), n = {}, i = 0; i < r.length; i++) {
          if (!n[(e = r[i])._id]) {
            n[e._id] = 1, g(t, e), v(t, e);
            var a = e._matchGroup;
            if (a) for (var o in a) {
              var s = h.getFromId(t, o);
              v(t, s, e.range), n[o] = 1;
            }
          }
        }

        m(t);
      }, r.finalDraw = function (t) {
        i.getComponentMethod("rangeslider", "draw")(t), i.getComponentMethod("rangeselector", "draw")(t);
      }, r.drawMarginPushers = function (t) {
        i.getComponentMethod("legend", "draw")(t), i.getComponentMethod("rangeselector", "draw")(t), i.getComponentMethod("sliders", "draw")(t), i.getComponentMethod("updatemenus", "draw")(t), i.getComponentMethod("colorbar", "draw")(t);
      };
    }, {
      "../components/color": 658,
      "../components/drawing": 680,
      "../components/modebar": 721,
      "../components/titles": 756,
      "../constants/alignment": 763,
      "../lib": 795,
      "../lib/clear_gl_canvases": 779,
      "../plots/cartesian/autorange": 844,
      "../plots/cartesian/axes": 845,
      "../plots/cartesian/constraints": 852,
      "../plots/plots": 909,
      "../registry": 923,
      "@plotly/d3": 57
    }],
    836: [function (t, e, r) {
      "use strict";

      var n = t("../lib"),
          i = n.isPlainObject,
          a = t("./plot_schema"),
          o = t("../plots/plots"),
          s = t("../plots/attributes"),
          l = t("./plot_template"),
          c = t("./plot_config").dfltConfig;

      function u(t, e) {
        t = n.extendDeep({}, t);
        var r,
            a,
            o = Object.keys(t).sort();

        function s(e, r, n) {
          if (i(r) && i(e)) u(e, r);else if (Array.isArray(r) && Array.isArray(e)) {
            var o = l.arrayTemplater({
              _template: t
            }, n);

            for (a = 0; a < r.length; a++) {
              var s = r[a],
                  c = o.newItem(s)._template;

              c && u(c, s);
            }

            var f = o.defaultItems();

            for (a = 0; a < f.length; a++) {
              r.push(f[a]._template);
            }

            for (a = 0; a < r.length; a++) {
              delete r[a].templateitemname;
            }
          }
        }

        for (r = 0; r < o.length; r++) {
          var c = o[r],
              h = t[c];
          if (c in e ? s(h, e[c], c) : e[c] = h, f(c) === c) for (var p in e) {
            var d = f(p);
            p === d || d !== c || p in t || s(h, e[p], c);
          }
        }
      }

      function f(t) {
        return t.replace(/[0-9]+$/, "");
      }

      function h(t, e, r, a, o) {
        var s = o && r(o);

        for (var c in t) {
          var u = t[c],
              p = m(t, c, a),
              d = m(t, c, o),
              g = r(d);

          if (!g) {
            var v = f(c);
            v !== c && (g = r(d = m(t, v, o)));
          }

          if ((!s || s !== g) && !(!g || g._noTemplating || "data_array" === g.valType || g.arrayOk && Array.isArray(u))) if (!g.valType && i(u)) h(u, e, r, p, d);else if (g._isLinkedToArray && Array.isArray(u)) for (var y = !1, x = 0, b = {}, _ = 0; _ < u.length; _++) {
            var w = u[_];

            if (i(w)) {
              var T = w.name;
              if (T) b[T] || (h(w, e, r, m(u, x, p), m(u, x, d)), x++, b[T] = 1);else if (!y) {
                var k = m(t, l.arrayDefaultKey(c), a),
                    M = m(u, x, p);
                h(w, e, r, M, m(u, x, d));
                var A = n.nestedProperty(e, M);
                n.nestedProperty(e, k).set(A.get()), A.set(null), y = !0;
              }
            }
          } else {
            n.nestedProperty(e, p).set(u);
          }
        }
      }

      function p(t, e) {
        return a.getLayoutValObject(t, n.nestedProperty({}, e).parts);
      }

      function d(t, e) {
        return a.getTraceValObject(t, n.nestedProperty({}, e).parts);
      }

      function m(t, e, r) {
        return r ? Array.isArray(t) ? r + "[" + e + "]" : r + "." + e : e;
      }

      function g(t) {
        for (var e = 0; e < t.length; e++) {
          if (i(t[e])) return !0;
        }
      }

      function v(t) {
        var e;

        switch (t.code) {
          case "data":
            e = "The template has no key data.";
            break;

          case "layout":
            e = "The template has no key layout.";
            break;

          case "missing":
            e = t.path ? "There are no templates for item " + t.path + " with name " + t.templateitemname : "There are no templates for trace " + t.index + ", of type " + t.traceType + ".";
            break;

          case "unused":
            e = t.path ? "The template item at " + t.path + " was not used in constructing the plot." : t.dataCount ? "Some of the templates of type " + t.traceType + " were not used. The template has " + t.templateCount + " traces, the data only has " + t.dataCount + " of this type." : "The template has " + t.templateCount + " traces of type " + t.traceType + " but there are none in the data.";
            break;

          case "reused":
            e = "Some of the templates of type " + t.traceType + " were used more than once. The template has " + t.templateCount + " traces, the data has " + t.dataCount + " of this type.";
        }

        return t.msg = e, t;
      }

      r.makeTemplate = function (t) {
        t = n.isPlainObject(t) ? t : n.getGraphDiv(t), t = n.extendDeep({
          _context: c
        }, {
          data: t.data,
          layout: t.layout
        }), o.supplyDefaults(t);
        var e = t.data || [],
            r = t.layout || {};
        r._basePlotModules = t._fullLayout._basePlotModules, r._modules = t._fullLayout._modules;
        var a = {
          data: {},
          layout: {}
        };
        e.forEach(function (t) {
          var e = {};
          h(t, e, d.bind(null, t));
          var r = n.coerce(t, {}, s, "type"),
              i = a.data[r];
          i || (i = a.data[r] = []), i.push(e);
        }), h(r, a.layout, p.bind(null, r)), delete a.layout.template;
        var l = r.template;

        if (i(l)) {
          var f,
              m,
              g,
              v,
              y,
              x,
              b = l.layout;
          i(b) && u(b, a.layout);
          var _ = l.data;

          if (i(_)) {
            for (m in a.data) {
              if (g = _[m], Array.isArray(g)) {
                for (x = (y = a.data[m]).length, v = g.length, f = 0; f < x; f++) {
                  u(g[f % v], y[f]);
                }

                for (f = x; f < v; f++) {
                  y.push(n.extendDeep({}, g[f]));
                }
              }
            }

            for (m in _) {
              m in a.data || (a.data[m] = n.extendDeep([], _[m]));
            }
          }
        }

        return a;
      }, r.validateTemplate = function (t, e) {
        var r = n.extendDeep({}, {
          _context: c,
          data: t.data,
          layout: t.layout
        }),
            a = r.layout || {};
        i(e) || (e = a.template || {});
        var s = e.layout,
            l = e.data,
            u = [];
        r.layout = a, r.layout.template = e, o.supplyDefaults(r);
        var h = r._fullLayout,
            p = r._fullData,
            d = {};

        if (i(s) ? (!function t(e, r) {
          for (var n in e) {
            if ("_" !== n.charAt(0) && i(e[n])) {
              var a,
                  o = f(n),
                  s = [];

              for (a = 0; a < r.length; a++) {
                s.push(m(e, n, r[a])), o !== n && s.push(m(e, o, r[a]));
              }

              for (a = 0; a < s.length; a++) {
                d[s[a]] = 1;
              }

              t(e[n], s);
            }
          }
        }(h, ["layout"]), function t(e, r) {
          for (var n in e) {
            if (-1 === n.indexOf("defaults") && i(e[n])) {
              var a = m(e, n, r);
              d[a] ? t(e[n], a) : u.push({
                code: "unused",
                path: a
              });
            }
          }
        }(s, "layout")) : u.push({
          code: "layout"
        }), i(l)) {
          for (var y, x = {}, b = 0; b < p.length; b++) {
            var _ = p[b];
            x[y = _.type] = (x[y] || 0) + 1, _._fullInput._template || u.push({
              code: "missing",
              index: _._fullInput.index,
              traceType: y
            });
          }

          for (y in l) {
            var w = l[y].length,
                T = x[y] || 0;
            w > T ? u.push({
              code: "unused",
              traceType: y,
              templateCount: w,
              dataCount: T
            }) : T > w && u.push({
              code: "reused",
              traceType: y,
              templateCount: w,
              dataCount: T
            });
          }
        } else u.push({
          code: "data"
        });

        if (function t(e, r) {
          for (var n in e) {
            if ("_" !== n.charAt(0)) {
              var a = e[n],
                  o = m(e, n, r);
              i(a) ? (Array.isArray(e) && !1 === a._template && a.templateitemname && u.push({
                code: "missing",
                path: o,
                templateitemname: a.templateitemname
              }), t(a, o)) : Array.isArray(a) && g(a) && t(a, o);
            }
          }
        }({
          data: p,
          layout: h
        }, ""), u.length) return u.map(v);
      };
    }, {
      "../lib": 795,
      "../plots/attributes": 841,
      "../plots/plots": 909,
      "./plot_config": 832,
      "./plot_schema": 833,
      "./plot_template": 834
    }],
    837: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("./plot_api"),
          a = t("../plots/plots"),
          o = t("../lib"),
          s = t("../snapshot/helpers"),
          l = t("../snapshot/tosvg"),
          c = t("../snapshot/svgtoimg"),
          u = t("../version").version,
          f = {
        format: {
          valType: "enumerated",
          values: ["png", "jpeg", "webp", "svg", "full-json"],
          dflt: "png"
        },
        width: {
          valType: "number",
          min: 1
        },
        height: {
          valType: "number",
          min: 1
        },
        scale: {
          valType: "number",
          min: 0,
          dflt: 1
        },
        setBackground: {
          valType: "any",
          dflt: !1
        },
        imageDataOnly: {
          valType: "boolean",
          dflt: !1
        }
      };

      e.exports = function (t, e) {
        var r, h, p, d;

        function m(t) {
          return !(t in e) || o.validate(e[t], f[t]);
        }

        if (e = e || {}, o.isPlainObject(t) ? (r = t.data || [], h = t.layout || {}, p = t.config || {}, d = {}) : (t = o.getGraphDiv(t), r = o.extendDeep([], t.data), h = o.extendDeep({}, t.layout), p = t._context, d = t._fullLayout || {}), !m("width") && null !== e.width || !m("height") && null !== e.height) throw new Error("Height and width should be pixel values.");
        if (!m("format")) throw new Error("Export format is not " + o.join2(f.format.values, ", ", " or ") + ".");
        var g = {};

        function v(t, r) {
          return o.coerce(e, g, f, t, r);
        }

        var y = v("format"),
            x = v("width"),
            b = v("height"),
            _ = v("scale"),
            w = v("setBackground"),
            T = v("imageDataOnly"),
            k = document.createElement("div");

        k.style.position = "absolute", k.style.left = "-5000px", document.body.appendChild(k);
        var M = o.extendFlat({}, h);
        x ? M.width = x : null === e.width && n(d.width) && (M.width = d.width), b ? M.height = b : null === e.height && n(d.height) && (M.height = d.height);
        var A = o.extendFlat({}, p, {
          _exportedPlot: !0,
          staticPlot: !0,
          setBackground: w
        }),
            S = s.getRedrawFunc(k);

        function E() {
          return new Promise(function (t) {
            setTimeout(t, s.getDelay(k._fullLayout));
          });
        }

        function L() {
          return new Promise(function (t, e) {
            var r = l(k, y, _),
                n = k._fullLayout.width,
                f = k._fullLayout.height;

            function h() {
              i.purge(k), document.body.removeChild(k);
            }

            if ("full-json" === y) {
              var p = a.graphJson(k, !1, "keepdata", "object", !0, !0);
              return p.version = u, p = JSON.stringify(p), h(), t(T ? p : s.encodeJSON(p));
            }

            if (h(), "svg" === y) return t(T ? r : s.encodeSVG(r));
            var d = document.createElement("canvas");
            d.id = o.randstr(), c({
              format: y,
              width: n,
              height: f,
              scale: _,
              canvas: d,
              svg: r,
              promise: !0
            }).then(t).catch(e);
          });
        }

        return new Promise(function (t, e) {
          i.newPlot(k, r, M, A).then(S).then(E).then(L).then(function (e) {
            t(function (t) {
              return T ? t.replace(s.IMAGE_URL_PREFIX, "") : t;
            }(e));
          }).catch(function (t) {
            e(t);
          });
        });
      };
    }, {
      "../lib": 795,
      "../plots/plots": 909,
      "../snapshot/helpers": 927,
      "../snapshot/svgtoimg": 929,
      "../snapshot/tosvg": 931,
      "../version": 1382,
      "./plot_api": 831,
      "fast-isnumeric": 240
    }],
    838: [function (t, e, r) {
      "use strict";

      var n = t("../lib"),
          i = t("../plots/plots"),
          a = t("./plot_schema"),
          o = t("./plot_config").dfltConfig,
          s = n.isPlainObject,
          l = Array.isArray,
          c = n.isArrayOrTypedArray;

      function u(t, e, r, i, a, o) {
        o = o || [];

        for (var f = Object.keys(t), h = 0; h < f.length; h++) {
          var p = f[h];

          if ("transforms" !== p) {
            var v = o.slice();
            v.push(p);
            var y = t[p],
                x = e[p],
                b = g(r, p),
                _ = (b || {}).valType,
                w = "info_array" === _,
                T = "colorscale" === _,
                k = (b || {}).items;
            if (m(r, p)) {
              if (s(y) && s(x) && "any" !== _) u(y, x, b, i, a, v);else if (w && l(y)) {
                y.length > x.length && i.push(d("unused", a, v.concat(x.length)));
                var M,
                    A,
                    S,
                    E,
                    L,
                    C = x.length,
                    P = Array.isArray(k);
                if (P && (C = Math.min(C, k.length)), 2 === b.dimensions) for (A = 0; A < C; A++) {
                  if (l(y[A])) {
                    y[A].length > x[A].length && i.push(d("unused", a, v.concat(A, x[A].length)));
                    var I = x[A].length;

                    for (M = 0; M < (P ? Math.min(I, k[A].length) : I); M++) {
                      S = P ? k[A][M] : k, E = y[A][M], L = x[A][M], n.validate(E, S) ? L !== E && L !== +E && i.push(d("dynamic", a, v.concat(A, M), E, L)) : i.push(d("value", a, v.concat(A, M), E));
                    }
                  } else i.push(d("array", a, v.concat(A), y[A]));
                } else for (A = 0; A < C; A++) {
                  S = P ? k[A] : k, E = y[A], L = x[A], n.validate(E, S) ? L !== E && L !== +E && i.push(d("dynamic", a, v.concat(A), E, L)) : i.push(d("value", a, v.concat(A), E));
                }
              } else if (b.items && !w && l(y)) {
                var O,
                    z,
                    D = k[Object.keys(k)[0]],
                    R = [];

                for (O = 0; O < x.length; O++) {
                  var F = x[O]._index || O;

                  if ((z = v.slice()).push(F), s(y[F]) && s(x[O])) {
                    R.push(F);
                    var B = y[F],
                        N = x[O];
                    s(B) && !1 !== B.visible && !1 === N.visible ? i.push(d("invisible", a, z)) : u(B, N, D, i, a, z);
                  }
                }

                for (O = 0; O < y.length; O++) {
                  (z = v.slice()).push(O), s(y[O]) ? -1 === R.indexOf(O) && i.push(d("unused", a, z)) : i.push(d("object", a, z, y[O]));
                }
              } else !s(y) && s(x) ? i.push(d("object", a, v, y)) : c(y) || !c(x) || w || T ? p in e ? n.validate(y, b) ? "enumerated" === b.valType && (b.coerceNumber && y !== +x || y !== x) && i.push(d("dynamic", a, v, y, x)) : i.push(d("value", a, v, y)) : i.push(d("unused", a, v, y)) : i.push(d("array", a, v, y));
            } else i.push(d("schema", a, v));
          }
        }

        return i;
      }

      function f(t, e) {
        for (var r = t.layout.layoutAttributes, i = 0; i < e.length; i++) {
          var a = e[i],
              o = t.traces[a.type],
              s = o.layoutAttributes;
          s && (a.subplot ? n.extendFlat(r[o.attributes.subplot.dflt], s) : n.extendFlat(r, s));
        }

        return r;
      }

      e.exports = function (t, e) {
        void 0 === t && (t = []), void 0 === e && (e = {});
        var r,
            c,
            h = a.get(),
            p = [],
            m = {
          _context: n.extendFlat({}, o)
        };
        l(t) ? (m.data = n.extendDeep([], t), r = t) : (m.data = [], r = [], p.push(d("array", "data"))), s(e) ? (m.layout = n.extendDeep({}, e), c = e) : (m.layout = {}, c = {}, arguments.length > 1 && p.push(d("object", "layout"))), i.supplyDefaults(m);

        for (var g = m._fullData, v = r.length, y = 0; y < v; y++) {
          var x = r[y],
              b = ["data", y];

          if (s(x)) {
            var _ = g[y],
                w = _.type,
                T = h.traces[w].attributes;
            T.type = {
              valType: "enumerated",
              values: [w]
            }, !1 === _.visible && !1 !== x.visible && p.push(d("invisible", b)), u(x, _, T, p, b);
            var k = x.transforms,
                M = _.transforms;

            if (k) {
              l(k) || p.push(d("array", b, ["transforms"])), b.push("transforms");

              for (var A = 0; A < k.length; A++) {
                var S = ["transforms", A],
                    E = k[A].type;

                if (s(k[A])) {
                  var L = h.transforms[E] ? h.transforms[E].attributes : {};
                  L.type = {
                    valType: "enumerated",
                    values: Object.keys(h.transforms)
                  }, u(k[A], M[A], L, p, b, S);
                } else p.push(d("object", b, S));
              }
            }
          } else p.push(d("object", b));
        }

        var C = m._fullLayout,
            P = f(h, g);
        return u(c, C, P, p, "layout"), 0 === p.length ? void 0 : p;
      };

      var h = {
        object: function object(t, e) {
          return ("layout" === t && "" === e ? "The layout argument" : "data" === t[0] && "" === e ? "Trace " + t[1] + " in the data argument" : p(t) + "key " + e) + " must be linked to an object container";
        },
        array: function array(t, e) {
          return ("data" === t ? "The data argument" : p(t) + "key " + e) + " must be linked to an array container";
        },
        schema: function schema(t, e) {
          return p(t) + "key " + e + " is not part of the schema";
        },
        unused: function unused(t, e, r) {
          var n = s(r) ? "container" : "key";
          return p(t) + n + " " + e + " did not get coerced";
        },
        dynamic: function dynamic(t, e, r, n) {
          return [p(t) + "key", e, "(set to '" + r + "')", "got reset to", "'" + n + "'", "during defaults."].join(" ");
        },
        invisible: function invisible(t, e) {
          return (e ? p(t) + "item " + e : "Trace " + t[1]) + " got defaulted to be not visible";
        },
        value: function value(t, e, r) {
          return [p(t) + "key " + e, "is set to an invalid value (" + r + ")"].join(" ");
        }
      };

      function p(t) {
        return l(t) ? "In data trace " + t[1] + ", " : "In " + t + ", ";
      }

      function d(t, e, r, i, a) {
        var o, s;
        r = r || "", l(e) ? (o = e[0], s = e[1]) : (o = e, s = null);

        var c = function (t) {
          if (!l(t)) return String(t);

          for (var e = "", r = 0; r < t.length; r++) {
            var n = t[r];
            "number" == typeof n ? e = e.substr(0, e.length - 1) + "[" + n + "]" : e += n, r < t.length - 1 && (e += ".");
          }

          return e;
        }(r),
            u = h[t](e, c, i, a);

        return n.log(u), {
          code: t,
          container: o,
          trace: s,
          path: r,
          astr: c,
          msg: u
        };
      }

      function m(t, e) {
        var r = y(e),
            n = r.keyMinusId,
            i = r.id;
        return !!(n in t && t[n]._isSubplotObj && i) || e in t;
      }

      function g(t, e) {
        return e in t ? t[e] : t[y(e).keyMinusId];
      }

      var v = n.counterRegex("([a-z]+)");

      function y(t) {
        var e = t.match(v);
        return {
          keyMinusId: e && e[1],
          id: e && e[2]
        };
      }
    }, {
      "../lib": 795,
      "../plots/plots": 909,
      "./plot_config": 832,
      "./plot_schema": 833
    }],
    839: [function (t, e, r) {
      "use strict";

      e.exports = {
        mode: {
          valType: "enumerated",
          dflt: "afterall",
          values: ["immediate", "next", "afterall"]
        },
        direction: {
          valType: "enumerated",
          values: ["forward", "reverse"],
          dflt: "forward"
        },
        fromcurrent: {
          valType: "boolean",
          dflt: !1
        },
        frame: {
          duration: {
            valType: "number",
            min: 0,
            dflt: 500
          },
          redraw: {
            valType: "boolean",
            dflt: !0
          }
        },
        transition: {
          duration: {
            valType: "number",
            min: 0,
            dflt: 500,
            editType: "none"
          },
          easing: {
            valType: "enumerated",
            dflt: "cubic-in-out",
            values: ["linear", "quad", "cubic", "sin", "exp", "circle", "elastic", "back", "bounce", "linear-in", "quad-in", "cubic-in", "sin-in", "exp-in", "circle-in", "elastic-in", "back-in", "bounce-in", "linear-out", "quad-out", "cubic-out", "sin-out", "exp-out", "circle-out", "elastic-out", "back-out", "bounce-out", "linear-in-out", "quad-in-out", "cubic-in-out", "sin-in-out", "exp-in-out", "circle-in-out", "elastic-in-out", "back-in-out", "bounce-in-out"],
            editType: "none"
          },
          ordering: {
            valType: "enumerated",
            values: ["layout first", "traces first"],
            dflt: "layout first",
            editType: "none"
          }
        }
      };
    }, {}],
    840: [function (t, e, r) {
      "use strict";

      var n = t("../lib"),
          i = t("../plot_api/plot_template");

      e.exports = function (t, e, r) {
        var a,
            o,
            s = r.name,
            l = r.inclusionAttr || "visible",
            c = e[s],
            u = n.isArrayOrTypedArray(t[s]) ? t[s] : [],
            f = e[s] = [],
            h = i.arrayTemplater(e, s, l);

        for (a = 0; a < u.length; a++) {
          var p = u[a];
          n.isPlainObject(p) ? o = h.newItem(p) : (o = h.newItem({}))[l] = !1, o._index = a, !1 !== o[l] && r.handleItemDefaults(p, o, e, r), f.push(o);
        }

        var d = h.defaultItems();

        for (a = 0; a < d.length; a++) {
          (o = d[a])._index = f.length, r.handleItemDefaults({}, o, e, r, {}), f.push(o);
        }

        if (n.isArrayOrTypedArray(c)) {
          var m = Math.min(c.length, f.length);

          for (a = 0; a < m; a++) {
            n.relinkPrivateKeys(f[a], c[a]);
          }
        }

        return f;
      };
    }, {
      "../lib": 795,
      "../plot_api/plot_template": 834
    }],
    841: [function (t, e, r) {
      "use strict";

      var n = t("../components/fx/attributes");
      e.exports = {
        type: {
          valType: "enumerated",
          values: [],
          dflt: "scatter",
          editType: "calc+clearAxisTypes",
          _noTemplating: !0
        },
        visible: {
          valType: "enumerated",
          values: [!0, !1, "legendonly"],
          dflt: !0,
          editType: "calc"
        },
        showlegend: {
          valType: "boolean",
          dflt: !0,
          editType: "style"
        },
        legendgroup: {
          valType: "string",
          dflt: "",
          editType: "style"
        },
        opacity: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 1,
          editType: "style"
        },
        name: {
          valType: "string",
          editType: "style"
        },
        uid: {
          valType: "string",
          editType: "plot",
          anim: !0
        },
        ids: {
          valType: "data_array",
          editType: "calc",
          anim: !0
        },
        customdata: {
          valType: "data_array",
          editType: "calc"
        },
        meta: {
          valType: "any",
          arrayOk: !0,
          editType: "plot"
        },
        selectedpoints: {
          valType: "any",
          editType: "calc"
        },
        hoverinfo: {
          valType: "flaglist",
          flags: ["x", "y", "z", "text", "name"],
          extras: ["all", "none", "skip"],
          arrayOk: !0,
          dflt: "all",
          editType: "none"
        },
        hoverlabel: n.hoverlabel,
        stream: {
          token: {
            valType: "string",
            noBlank: !0,
            strict: !0,
            editType: "calc"
          },
          maxpoints: {
            valType: "number",
            min: 0,
            max: 1e4,
            dflt: 500,
            editType: "calc"
          },
          editType: "calc"
        },
        transforms: {
          _isLinkedToArray: "transform",
          editType: "calc"
        },
        uirevision: {
          valType: "any",
          editType: "none"
        }
      };
    }, {
      "../components/fx/attributes": 689
    }],
    842: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../lib"),
          a = i.dateTime2ms,
          o = i.incrementMonth,
          s = t("../../constants/numerical").ONEAVGMONTH;

      e.exports = function (t, e, r, i) {
        if ("date" !== e.type) return i;
        var l = t[r + "periodalignment"];
        if (!l) return i;
        var c,
            u = t[r + "period"];

        if (n(u)) {
          if ((u = +u) <= 0) return i;
        } else if ("string" == typeof u && "M" === u.charAt(0)) {
          var f = +u.substring(1);
          if (!(f > 0 && Math.round(f) === f)) return i;
          c = f;
        }

        for (var h = e.calendar, p = "start" === l, d = "end" === l, m = t[r + "period0"], g = a(m, h) || 0, v = [], y = i.length, x = 0; x < y; x++) {
          var b,
              _,
              w,
              T = i[x];

          if (c) {
            for (b = Math.round((T - g) / (c * s)), w = o(g, c * b, h); w > T;) {
              w = o(w, -c, h);
            }

            for (; w <= T;) {
              w = o(w, c, h);
            }

            _ = o(w, -c, h);
          } else {
            for (w = g + (b = Math.round((T - g) / u)) * u; w > T;) {
              w -= u;
            }

            for (; w <= T;) {
              w += u;
            }

            _ = w - u;
          }

          v[x] = p ? _ : d ? w : (_ + w) / 2;
        }

        return v;
      };
    }, {
      "../../constants/numerical": 771,
      "../../lib": 795,
      "fast-isnumeric": 240
    }],
    843: [function (t, e, r) {
      "use strict";

      e.exports = {
        xaxis: {
          valType: "subplotid",
          dflt: "x",
          editType: "calc+clearAxisTypes"
        },
        yaxis: {
          valType: "subplotid",
          dflt: "y",
          editType: "calc+clearAxisTypes"
        }
      };
    }, {}],
    844: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("fast-isnumeric"),
          a = t("../../lib"),
          o = t("../../constants/numerical").FP_SAFE,
          s = t("../../registry"),
          l = t("../../components/drawing"),
          c = t("./axis_ids"),
          u = c.getFromId,
          f = c.isLinked;

      function h(t, e) {
        var r,
            n,
            i = [],
            o = t._fullLayout,
            s = d(o, e, 0),
            l = d(o, e, 1),
            c = m(t, e),
            u = c.min,
            f = c.max;
        if (0 === u.length || 0 === f.length) return a.simpleMap(e.range, e.r2l);
        var h = u[0].val,
            g = f[0].val;

        for (r = 1; r < u.length && h === g; r++) {
          h = Math.min(h, u[r].val);
        }

        for (r = 1; r < f.length && h === g; r++) {
          g = Math.max(g, f[r].val);
        }

        var v = !1;

        if (e.range) {
          var y = a.simpleMap(e.range, e.r2l);
          v = y[1] < y[0];
        }

        "reversed" === e.autorange && (v = !0, e.autorange = !0);

        var x,
            b,
            _,
            w,
            T,
            k,
            M = e.rangemode,
            A = "tozero" === M,
            S = "nonnegative" === M,
            E = e._length,
            L = E / 10,
            C = 0;

        for (r = 0; r < u.length; r++) {
          for (x = u[r], n = 0; n < f.length; n++) {
            (k = (b = f[n]).val - x.val - p(e, x.val, b.val)) > 0 && ((T = E - s(x) - l(b)) > L ? k / T > C && (_ = x, w = b, C = k / T) : k / E > C && (_ = {
              val: x.val,
              nopad: 1
            }, w = {
              val: b.val,
              nopad: 1
            }, C = k / E));
          }
        }

        if (h === g) {
          var P = h - 1,
              I = h + 1;
          if (A) {
            if (0 === h) i = [0, 1];else {
              var O = (h > 0 ? f : u).reduce(function (t, e) {
                return Math.max(t, l(e));
              }, 0),
                  z = h / (1 - Math.min(.5, O / E));
              i = h > 0 ? [0, z] : [z, 0];
            }
          } else i = S ? [Math.max(0, P), Math.max(1, I)] : [P, I];
        } else A ? (_.val >= 0 && (_ = {
          val: 0,
          nopad: 1
        }), w.val <= 0 && (w = {
          val: 0,
          nopad: 1
        })) : S && (_.val - C * s(_) < 0 && (_ = {
          val: 0,
          nopad: 1
        }), w.val <= 0 && (w = {
          val: 1,
          nopad: 1
        })), C = (w.val - _.val - p(e, x.val, b.val)) / (E - s(_) - l(w)), i = [_.val - C * s(_), w.val + C * l(w)];

        return v && i.reverse(), a.simpleMap(i, e.l2r || Number);
      }

      function p(t, e, r) {
        var n = 0;
        if (t.rangebreaks) for (var i = t.locateBreaks(e, r), a = 0; a < i.length; a++) {
          var o = i[a];
          n += o.max - o.min;
        }
        return n;
      }

      function d(t, e, r) {
        var i = .05 * e._length,
            o = e._anchorAxis || {};

        if (-1 !== (e.ticklabelposition || "").indexOf("inside") || -1 !== (o.ticklabelposition || "").indexOf("inside")) {
          var s = "reversed" === e.autorange;

          if (!s) {
            var c = a.simpleMap(e.range, e.r2l);
            s = c[1] < c[0];
          }

          s && (r = !r);
        }

        var u = 0;
        return f(t, e._id) || (u = function (t, e, r) {
          var i = 0,
              o = "x" === e._id.charAt(0);

          for (var s in t._plots) {
            var c = t._plots[s];

            if (e._id === c.xaxis._id || e._id === c.yaxis._id) {
              var u = (o ? c.yaxis : c.xaxis) || {};

              if (-1 !== (u.ticklabelposition || "").indexOf("inside") && (!r && ("left" === u.side || "bottom" === u.side) || r && ("top" === u.side || "right" === u.side))) {
                if (u._vals) {
                  var f = a.deg2rad(u._tickAngles[u._id + "tick"] || 0),
                      h = Math.abs(Math.cos(f)),
                      p = Math.abs(Math.sin(f));

                  if (!u._vals[0].bb) {
                    var d = u._id + "tick";

                    u._selections[d].each(function (t) {
                      var e = n.select(this);
                      e.select(".text-math-group").empty() && (t.bb = l.bBox(e.node()));
                    });
                  }

                  for (var m = 0; m < u._vals.length; m++) {
                    var g = u._vals[m].bb;

                    if (g) {
                      var v = 6 + g.width,
                          y = 6 + g.height;
                      i = Math.max(i, o ? Math.max(v * h, y * p) : Math.max(y * h, v * p));
                    }
                  }
                }

                "inside" === u.ticks && "inside" === u.ticklabelposition && (i += u.ticklen || 0);
              }
            }
          }

          return i;
        }(t, e, r)), i = Math.max(u, i), "domain" === e.constrain && e._inputDomain && (i *= (e._inputDomain[1] - e._inputDomain[0]) / (e.domain[1] - e.domain[0])), function (t) {
          return t.nopad ? 0 : t.pad + (t.extrapad ? i : u);
        };
      }

      e.exports = {
        getAutoRange: h,
        makePadFn: d,
        doAutoRange: function doAutoRange(t, e, r) {
          if (e.setScale(), e.autorange) {
            e.range = r ? r.slice() : h(t, e), e._r = e.range.slice(), e._rl = a.simpleMap(e._r, e.r2l);
            var n = e._input,
                i = {};
            i[e._attr + ".range"] = e.range, i[e._attr + ".autorange"] = e.autorange, s.call("_storeDirectGUIEdit", t.layout, t._fullLayout._preGUI, i), n.range = e.range.slice(), n.autorange = e.autorange;
          }

          var o = e._anchorAxis;

          if (o && o.rangeslider) {
            var l = o.rangeslider[e._name];
            l && "auto" === l.rangemode && (l.range = h(t, e)), o._input.rangeslider[e._name] = a.extendFlat({}, l);
          }
        },
        findExtremes: function findExtremes(t, e, r) {
          r || (r = {});
          t._m || t.setScale();

          var n,
              a,
              s,
              l,
              c,
              u,
              f,
              h,
              p,
              d = [],
              m = [],
              y = e.length,
              b = r.padded || !1,
              _ = r.tozero && ("linear" === t.type || "-" === t.type),
              w = "log" === t.type,
              T = !1,
              k = r.vpadLinearized || !1;

          function M(t) {
            if (Array.isArray(t)) return T = !0, function (e) {
              return Math.max(Number(t[e] || 0), 0);
            };
            var e = Math.max(Number(t || 0), 0);
            return function () {
              return e;
            };
          }

          var A = M((t._m > 0 ? r.ppadplus : r.ppadminus) || r.ppad || 0),
              S = M((t._m > 0 ? r.ppadminus : r.ppadplus) || r.ppad || 0),
              E = M(r.vpadplus || r.vpad),
              L = M(r.vpadminus || r.vpad);

          if (!T) {
            if (h = 1 / 0, p = -1 / 0, w) for (n = 0; n < y; n++) {
              (a = e[n]) < h && a > 0 && (h = a), a > p && a < o && (p = a);
            } else for (n = 0; n < y; n++) {
              (a = e[n]) < h && a > -o && (h = a), a > p && a < o && (p = a);
            }
            e = [h, p], y = 2;
          }

          var C = {
            tozero: _,
            extrapad: b
          };

          function P(r) {
            s = e[r], i(s) && (u = A(r), f = S(r), k ? (l = t.c2l(s) - L(r), c = t.c2l(s) + E(r)) : (h = s - L(r), p = s + E(r), w && h < p / 10 && (h = p / 10), l = t.c2l(h), c = t.c2l(p)), _ && (l = Math.min(0, l), c = Math.max(0, c)), x(l) && g(d, l, f, C), x(c) && v(m, c, u, C));
          }

          var I = Math.min(6, y);

          for (n = 0; n < I; n++) {
            P(n);
          }

          for (n = y - 1; n >= I; n--) {
            P(n);
          }

          return {
            min: d,
            max: m,
            opts: r
          };
        },
        concatExtremes: m
      };

      function m(t, e, r) {
        var n,
            i,
            a,
            o = e._id,
            s = t._fullData,
            l = t._fullLayout,
            c = [],
            f = [];

        function h(t, e) {
          for (n = 0; n < e.length; n++) {
            var r = t[e[n]],
                s = (r._extremes || {})[o];

            if (!0 === r.visible && s) {
              for (i = 0; i < s.min.length; i++) {
                a = s.min[i], g(c, a.val, a.pad, {
                  extrapad: a.extrapad
                });
              }

              for (i = 0; i < s.max.length; i++) {
                a = s.max[i], v(f, a.val, a.pad, {
                  extrapad: a.extrapad
                });
              }
            }
          }
        }

        if (h(s, e._traceIndices), h(l.annotations || [], e._annIndices || []), h(l.shapes || [], e._shapeIndices || []), e._matchGroup && !r) for (var p in e._matchGroup) {
          if (p !== e._id) {
            var d = u(t, p),
                y = m(t, d, !0),
                x = e._length / d._length;

            for (i = 0; i < y.min.length; i++) {
              a = y.min[i], g(c, a.val, a.pad * x, {
                extrapad: a.extrapad
              });
            }

            for (i = 0; i < y.max.length; i++) {
              a = y.max[i], v(f, a.val, a.pad * x, {
                extrapad: a.extrapad
              });
            }
          }
        }
        return {
          min: c,
          max: f
        };
      }

      function g(t, e, r, n) {
        y(t, e, r, n, b);
      }

      function v(t, e, r, n) {
        y(t, e, r, n, _);
      }

      function y(t, e, r, n, i) {
        for (var a = n.tozero, o = n.extrapad, s = !0, l = 0; l < t.length && s; l++) {
          var c = t[l];

          if (i(c.val, e) && c.pad >= r && (c.extrapad || !o)) {
            s = !1;
            break;
          }

          i(e, c.val) && c.pad <= r && (o || !c.extrapad) && (t.splice(l, 1), l--);
        }

        if (s) {
          var u = a && 0 === e;
          t.push({
            val: e,
            pad: u ? 0 : r,
            extrapad: !u && o
          });
        }
      }

      function x(t) {
        return i(t) && Math.abs(t) < o;
      }

      function b(t, e) {
        return t <= e;
      }

      function _(t, e) {
        return t >= e;
      }
    }, {
      "../../components/drawing": 680,
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../../registry": 923,
      "./axis_ids": 848,
      "@plotly/d3": 57,
      "fast-isnumeric": 240
    }],
    845: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("fast-isnumeric"),
          a = t("../../plots/plots"),
          o = t("../../registry"),
          s = t("../../lib"),
          l = s.strTranslate,
          c = t("../../lib/svg_text_utils"),
          u = t("../../components/titles"),
          f = t("../../components/color"),
          h = t("../../components/drawing"),
          p = t("./layout_attributes"),
          d = t("./clean_ticks"),
          m = t("../../constants/numerical"),
          g = m.ONEMAXYEAR,
          v = m.ONEAVGYEAR,
          y = m.ONEMINYEAR,
          x = m.ONEMAXQUARTER,
          b = m.ONEAVGQUARTER,
          _ = m.ONEMINQUARTER,
          w = m.ONEMAXMONTH,
          T = m.ONEAVGMONTH,
          k = m.ONEMINMONTH,
          M = m.ONEWEEK,
          A = m.ONEDAY,
          S = A / 2,
          E = m.ONEHOUR,
          L = m.ONEMIN,
          C = m.ONESEC,
          P = m.MINUS_SIGN,
          I = m.BADNUM,
          O = {
        K: "zeroline"
      },
          z = {
        K: "gridline",
        L: "path"
      },
          D = {
        K: "tick",
        L: "path"
      },
          R = {
        K: "tick",
        L: "text"
      },
          F = t("../../constants/alignment"),
          B = F.MID_SHIFT,
          N = F.CAP_SHIFT,
          j = F.LINE_SPACING,
          U = F.OPPOSITE_SIDE,
          V = e.exports = {};
      V.setConvert = t("./set_convert");
      var q = t("./axis_autotype"),
          H = t("./axis_ids"),
          G = H.idSort,
          Y = H.isLinked;
      V.id2name = H.id2name, V.name2id = H.name2id, V.cleanId = H.cleanId, V.list = H.list, V.listIds = H.listIds, V.getFromId = H.getFromId, V.getFromTrace = H.getFromTrace;
      var W = t("./autorange");
      V.getAutoRange = W.getAutoRange, V.findExtremes = W.findExtremes;

      function X(t) {
        var e = 1e-4 * (t[1] - t[0]);
        return [t[0] - e, t[1] + e];
      }

      V.coerceRef = function (t, e, r, n, i, a) {
        var o = n.charAt(n.length - 1),
            l = r._fullLayout._subplots[o + "axis"],
            c = n + "ref",
            u = {};
        return i || (i = l[0] || ("string" == typeof a ? a : a[0])), a || (a = i), l = l.concat(l.map(function (t) {
          return t + " domain";
        })), u[c] = {
          valType: "enumerated",
          values: l.concat(a ? "string" == typeof a ? [a] : a : []),
          dflt: i
        }, s.coerce(t, e, u, c);
      }, V.getRefType = function (t) {
        return void 0 === t ? t : "paper" === t ? "paper" : "pixel" === t ? "pixel" : /( domain)$/.test(t) ? "domain" : "range";
      }, V.coercePosition = function (t, e, r, n, i, a) {
        var o, l;
        if ("range" !== V.getRefType(n)) o = s.ensureNumber, l = r(i, a);else {
          var c = V.getFromId(e, n);
          l = r(i, a = c.fraction2r(a)), o = c.cleanPos;
        }
        t[i] = o(l);
      }, V.cleanPosition = function (t, e, r) {
        return ("paper" === r || "pixel" === r ? s.ensureNumber : V.getFromId(e, r).cleanPos)(t);
      }, V.redrawComponents = function (t, e) {
        e = e || V.listIds(t);
        var r = t._fullLayout;

        function n(n, i, a, s) {
          for (var l = o.getComponentMethod(n, i), c = {}, u = 0; u < e.length; u++) {
            for (var f = r[V.id2name(e[u])][a], h = 0; h < f.length; h++) {
              var p = f[h];
              if (!c[p] && (l(t, p), c[p] = 1, s)) return;
            }
          }
        }

        n("annotations", "drawOne", "_annIndices"), n("shapes", "drawOne", "_shapeIndices"), n("images", "draw", "_imgIndices", !0);
      };

      var Z = V.getDataConversions = function (t, e, r, n) {
        var i,
            a = "x" === r || "y" === r || "z" === r ? r : n;

        if (Array.isArray(a)) {
          if (i = {
            type: q(n, void 0, {
              autotypenumbers: t._fullLayout.autotypenumbers
            }),
            _categories: []
          }, V.setConvert(i), "category" === i.type) for (var o = 0; o < n.length; o++) {
            i.d2c(n[o]);
          }
        } else i = V.getFromTrace(t, e, a);

        return i ? {
          d2c: i.d2c,
          c2d: i.c2d
        } : "ids" === a ? {
          d2c: K,
          c2d: K
        } : {
          d2c: J,
          c2d: J
        };
      };

      function J(t) {
        return +t;
      }

      function K(t) {
        return String(t);
      }

      function Q(t) {
        return +t.substring(1);
      }

      V.getDataToCoordFunc = function (t, e, r, n) {
        return Z(t, e, r, n).d2c;
      }, V.counterLetter = function (t) {
        var e = t.charAt(0);
        return "x" === e ? "y" : "y" === e ? "x" : void 0;
      }, V.minDtick = function (t, e, r, n) {
        -1 === ["log", "category", "multicategory"].indexOf(t.type) && n ? void 0 === t._minDtick ? (t._minDtick = e, t._forceTick0 = r) : t._minDtick && ((t._minDtick / e + 1e-6) % 1 < 2e-6 && ((r - t._forceTick0) / e % 1 + 1.000001) % 1 < 2e-6 ? (t._minDtick = e, t._forceTick0 = r) : ((e / t._minDtick + 1e-6) % 1 > 2e-6 || ((r - t._forceTick0) / t._minDtick % 1 + 1.000001) % 1 > 2e-6) && (t._minDtick = 0)) : t._minDtick = 0;
      }, V.saveRangeInitial = function (t, e) {
        for (var r = V.list(t, "", !0), n = !1, i = 0; i < r.length; i++) {
          var a = r[i],
              o = void 0 === a._rangeInitial,
              s = o || !(a.range[0] === a._rangeInitial[0] && a.range[1] === a._rangeInitial[1]);
          (o && !1 === a.autorange || e && s) && (a._rangeInitial = a.range.slice(), n = !0);
        }

        return n;
      }, V.saveShowSpikeInitial = function (t, e) {
        for (var r = V.list(t, "", !0), n = !1, i = "on", a = 0; a < r.length; a++) {
          var o = r[a],
              s = void 0 === o._showSpikeInitial,
              l = s || !(o.showspikes === o._showspikes);
          (s || e && l) && (o._showSpikeInitial = o.showspikes, n = !0), "on" !== i || o.showspikes || (i = "off");
        }

        return t._fullLayout._cartesianSpikesEnabled = i, n;
      }, V.autoBin = function (t, e, r, n, a, o) {
        var l,
            c = s.aggNums(Math.min, null, t),
            u = s.aggNums(Math.max, null, t);
        if ("category" === e.type || "multicategory" === e.type) return {
          start: c - .5,
          end: u + .5,
          size: Math.max(1, Math.round(o) || 1),
          _dataSpan: u - c
        };
        if (a || (a = e.calendar), l = "log" === e.type ? {
          type: "linear",
          range: [c, u]
        } : {
          type: e.type,
          range: s.simpleMap([c, u], e.c2r, 0, a),
          calendar: a
        }, V.setConvert(l), o = o && d.dtick(o, l.type)) l.dtick = o, l.tick0 = d.tick0(void 0, l.type, a);else {
          var f;
          if (r) f = (u - c) / r;else {
            var h = s.distinctVals(t),
                p = Math.pow(10, Math.floor(Math.log(h.minDiff) / Math.LN10)),
                m = p * s.roundUp(h.minDiff / p, [.9, 1.9, 4.9, 9.9], !0);
            f = Math.max(m, 2 * s.stdev(t) / Math.pow(t.length, n ? .25 : .4)), i(f) || (f = 1);
          }
          V.autoTicks(l, f);
        }
        var g,
            v = l.dtick,
            y = V.tickIncrement(V.tickFirst(l), v, "reverse", a);
        if ("number" == typeof v) g = (y = function (t, e, r, n, a) {
          var o = 0,
              s = 0,
              l = 0,
              c = 0;

          function u(e) {
            return (1 + 100 * (e - t) / r.dtick) % 100 < 2;
          }

          for (var f = 0; f < e.length; f++) {
            e[f] % 1 == 0 ? l++ : i(e[f]) || c++, u(e[f]) && o++, u(e[f] + r.dtick / 2) && s++;
          }

          var h = e.length - c;
          if (l === h && "date" !== r.type) r.dtick < 1 ? t = n - .5 * r.dtick : (t -= .5) + r.dtick < n && (t += r.dtick);else if (s < .1 * h && (o > .3 * h || u(n) || u(a))) {
            var p = r.dtick / 2;
            t += t + p < n ? p : -p;
          }
          return t;
        }(y, t, l, c, u)) + (1 + Math.floor((u - y) / v)) * v;else for ("M" === l.dtick.charAt(0) && (y = function (t, e, r, n, i) {
          var a = s.findExactDates(e, i);

          if (a.exactDays > .8) {
            var o = Number(r.substr(1));
            a.exactYears > .8 && o % 12 == 0 ? t = V.tickIncrement(t, "M6", "reverse") + 1.5 * A : a.exactMonths > .8 ? t = V.tickIncrement(t, "M1", "reverse") + 15.5 * A : t -= S;
            var l = V.tickIncrement(t, r);
            if (l <= n) return l;
          }

          return t;
        }(y, t, v, c, a)), g = y, 0; g <= u;) {
          g = V.tickIncrement(g, v, !1, a);
        }
        return {
          start: e.c2r(y, 0, a),
          end: e.c2r(g, 0, a),
          size: v,
          _dataSpan: u - c
        };
      }, V.prepTicks = function (t, e) {
        var r = s.simpleMap(t.range, t.r2l, void 0, void 0, e);

        if (t._dtickInit = t.dtick, t._tick0Init = t.tick0, "auto" === t.tickmode || !t.dtick) {
          var n,
              a = t.nticks;
          a || ("category" === t.type || "multicategory" === t.type ? (n = t.tickfont ? s.bigFont(t.tickfont.size || 12) : 15, a = t._length / n) : (n = "y" === t._id.charAt(0) ? 40 : 80, a = s.constrain(t._length / n, 4, 9) + 1), "radialaxis" === t._name && (a *= 2)), "array" === t.tickmode && (a *= 100), t._roughDTick = Math.abs(r[1] - r[0]) / a, V.autoTicks(t, t._roughDTick), t._minDtick > 0 && t.dtick < 2 * t._minDtick && (t.dtick = t._minDtick, t.tick0 = t.l2r(t._forceTick0));
        }

        "period" === t.ticklabelmode && function (t) {
          var e;

          function r() {
            return !(i(t.dtick) || "M" !== t.dtick.charAt(0));
          }

          var n = r(),
              a = V.getTickFormat(t);

          if (a) {
            var o = t._dtickInit !== t.dtick;
            /%[fLQsSMX]/.test(a) || (/%[HI]/.test(a) ? (e = E, o && !n && t.dtick < E && (t.dtick = E)) : /%p/.test(a) ? (e = S, o && !n && t.dtick < S && (t.dtick = S)) : /%[Aadejuwx]/.test(a) ? (e = A, o && !n && t.dtick < A && (t.dtick = A)) : /%[UVW]/.test(a) ? (e = M, o && !n && t.dtick < M && (t.dtick = M)) : /%[Bbm]/.test(a) ? (e = T, o && (n ? Q(t.dtick) < 1 : t.dtick < k) && (t.dtick = "M1")) : /%[q]/.test(a) ? (e = b, o && (n ? Q(t.dtick) < 3 : t.dtick < _) && (t.dtick = "M3")) : /%[Yy]/.test(a) && (e = v, o && (n ? Q(t.dtick) < 12 : t.dtick < y) && (t.dtick = "M12")));
          }

          (n = r()) && t.tick0 === t._dowTick0 && (t.tick0 = t._rawTick0);
          t._definedDelta = e;
        }(t), t.tick0 || (t.tick0 = "date" === t.type ? "2000-01-01" : 0), "date" === t.type && t.dtick < .1 && (t.dtick = .1), st(t);
      }, V.calcTicks = function (t, e) {
        V.prepTicks(t, e);
        var r = s.simpleMap(t.range, t.r2l, void 0, void 0, e);
        if ("array" === t.tickmode) return function (t) {
          var e = t.tickvals,
              r = t.ticktext,
              n = new Array(e.length),
              i = X(s.simpleMap(t.range, t.r2l)),
              a = Math.min(i[0], i[1]),
              o = Math.max(i[0], i[1]),
              l = 0;
          Array.isArray(r) || (r = []);
          var c = "category" === t.type ? t.d2l_noadd : t.d2l;
          "log" === t.type && "L" !== String(t.dtick).charAt(0) && (t.dtick = "L" + Math.pow(10, Math.floor(Math.min(t.range[0], t.range[1])) - 1));

          for (var u = 0; u < e.length; u++) {
            var f = c(e[u]);
            f > a && f < o && (void 0 === r[u] ? n[l] = V.tickText(t, f) : n[l] = lt(t, f, String(r[u])), l++);
          }

          l < e.length && n.splice(l, e.length - l);
          t.rangebreaks && (n = n.filter(function (e) {
            return t.maskBreaks(e.x) !== I;
          }));
          return n;
        }(t);
        var n = X(r),
            a = n[0],
            o = n[1],
            l = r[1] < r[0],
            c = Math.min(r[0], r[1]),
            u = Math.max(r[0], r[1]),
            f = "log" === t.type && !(i(t.dtick) || "L" === t.dtick.charAt(0)),
            h = "period" === t.ticklabelmode;
        if (t._tmin = V.tickFirst(t, e), t._tmin < a !== l) return [];
        "category" !== t.type && "multicategory" !== t.type || (o = l ? Math.max(-.5, o) : Math.min(t._categories.length - .5, o));
        var p = t._tmin;
        t.rangebreaks && t._tick0Init !== t.tick0 && (p = At(p, t), l || (p = V.tickIncrement(p, t.dtick, !l, t.calendar))), h && (p = V.tickIncrement(p, t.dtick, !l, t.calendar));

        for (var d, m = Math.max(1e3, t._length || 0), L = [], C = null; l ? p >= o : p <= o; p = V.tickIncrement(p, t.dtick, l, t.calendar)) {
          if (t.rangebreaks && !l) {
            if (p < a) continue;
            if (t.maskBreaks(p) === I && At(p, t) >= u) break;
          }

          if (L.length > m || p === C) break;
          C = p;
          var P = !1;
          f && p !== (0 | p) && (P = !0), L.push({
            minor: P,
            value: p
          });
        }

        if (h && function (t, e, r) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n].value,
                a = n,
                o = n + 1;
            n < t.length - 1 ? (a = n, o = n + 1) : n > 0 ? (a = n - 1, o = n) : (a = n, o = n);
            var s,
                l = t[a].value,
                c = t[o].value,
                u = Math.abs(c - l),
                f = r || u,
                h = 0;
            f >= y ? h = u >= y && u <= g ? u : v : r === b && f >= _ ? h = u >= _ && u <= x ? u : b : f >= k ? h = u >= k && u <= w ? u : T : r === M && f >= M ? h = M : f >= A ? h = A : r === S && f >= S ? h = S : r === E && f >= E && (h = E), h >= u && (h = u, s = !0);
            var p = i + h;

            if (e.rangebreaks && h > 0) {
              for (var d = 0, m = 0; m < 84; m++) {
                var L = (m + .5) / 84;
                e.maskBreaks(i * (1 - L) + L * p) !== I && d++;
              }

              (h *= d / 84) || (t[n].drop = !0), s && u > M && (h = u);
            }

            (h > 0 || 0 === n) && (t[n].periodX = i + h / 2);
          }
        }(L, t, t._definedDelta), t.rangebreaks) {
          var O = "y" === t._id.charAt(0),
              z = 1;

          "auto" === t.tickmode && (z = t.tickfont ? t.tickfont.size : 12);
          var D = NaN;

          for (d = L.length - 1; d > -1; d--) {
            if (L[d].drop) L.splice(d, 1);else {
              L[d].value = At(L[d].value, t);
              var R = t.c2p(L[d].value);
              (O ? D > R - z : D < R + z) ? L.splice(l ? d + 1 : d, 1) : D = R;
            }
          }
        }

        Mt(t) && 360 === Math.abs(r[1] - r[0]) && L.pop(), t._tmax = (L[L.length - 1] || {}).value, t._prevDateHead = "", t._inCalcTicks = !0;
        var F,
            B,
            N = [];

        for (d = 0; d < L.length; d++) {
          var j = L[d].minor,
              U = L[d].value;
          F = V.tickText(t, U, !1, j), void 0 !== (B = L[d].periodX) && (F.periodX = B, (B > u || B < c) && (B > u && (F.periodX = u), B < c && (F.periodX = c), F.text = " ", t._prevDateHead = "")), N.push(F);
        }

        return t._inCalcTicks = !1, N;
      };
      var $ = [2, 5, 10],
          tt = [1, 2, 3, 6, 12],
          et = [1, 2, 5, 10, 15, 30],
          rt = [1, 2, 3, 7, 14],
          nt = [-.046, 0, .301, .477, .602, .699, .778, .845, .903, .954, 1],
          it = [-.301, 0, .301, .699, 1],
          at = [15, 30, 45, 90, 180];

      function ot(t, e, r) {
        return e * s.roundUp(t / e, r);
      }

      function st(t) {
        var e = t.dtick;

        if (t._tickexponent = 0, i(e) || "string" == typeof e || (e = 1), "category" !== t.type && "multicategory" !== t.type || (t._tickround = null), "date" === t.type) {
          var r = t.r2l(t.tick0),
              n = t.l2r(r).replace(/(^-|i)/g, ""),
              a = n.length;
          if ("M" === String(e).charAt(0)) a > 10 || "01-01" !== n.substr(5) ? t._tickround = "d" : t._tickround = +e.substr(1) % 12 == 0 ? "y" : "m";else if (e >= A && a <= 10 || e >= 15 * A) t._tickround = "d";else if (e >= L && a <= 16 || e >= E) t._tickround = "M";else if (e >= C && a <= 19 || e >= L) t._tickround = "S";else {
            var o = t.l2r(r + e).replace(/^-/, "").length;
            t._tickround = Math.max(a, o) - 20, t._tickround < 0 && (t._tickround = 4);
          }
        } else if (i(e) || "L" === e.charAt(0)) {
          var s = t.range.map(t.r2d || Number);
          i(e) || (e = Number(e.substr(1))), t._tickround = 2 - Math.floor(Math.log(e) / Math.LN10 + .01);
          var l = Math.max(Math.abs(s[0]), Math.abs(s[1])),
              c = Math.floor(Math.log(l) / Math.LN10 + .01),
              u = void 0 === t.minexponent ? 3 : t.minexponent;
          Math.abs(c) > u && (ut(t.exponentformat) && !ft(c) ? t._tickexponent = 3 * Math.round((c - 1) / 3) : t._tickexponent = c);
        } else t._tickround = null;
      }

      function lt(t, e, r) {
        var n = t.tickfont || {};
        return {
          x: e,
          dx: 0,
          dy: 0,
          text: r || "",
          fontSize: n.size,
          font: n.family,
          fontColor: n.color
        };
      }

      V.autoTicks = function (t, e) {
        var r;

        function n(t) {
          return Math.pow(t, Math.floor(Math.log(e) / Math.LN10));
        }

        if ("date" === t.type) {
          t.tick0 = s.dateTick0(t.calendar, 0);
          var a = 2 * e;
          if (a > v) e /= v, r = n(10), t.dtick = "M" + 12 * ot(e, r, $);else if (a > T) e /= T, t.dtick = "M" + ot(e, 1, tt);else if (a > A) {
            t.dtick = ot(e, A, t._hasDayOfWeekBreaks ? [1, 2, 7, 14] : rt);
            var o = V.getTickFormat(t),
                l = "period" === t.ticklabelmode;
            l && (t._rawTick0 = t.tick0), /%[uVW]/.test(o) ? t.tick0 = s.dateTick0(t.calendar, 2) : t.tick0 = s.dateTick0(t.calendar, 1), l && (t._dowTick0 = t.tick0);
          } else a > E ? t.dtick = ot(e, E, tt) : a > L ? t.dtick = ot(e, L, et) : a > C ? t.dtick = ot(e, C, et) : (r = n(10), t.dtick = ot(e, r, $));
        } else if ("log" === t.type) {
          t.tick0 = 0;
          var c = s.simpleMap(t.range, t.r2l);
          if (e > .7) t.dtick = Math.ceil(e);else if (Math.abs(c[1] - c[0]) < 1) {
            var u = 1.5 * Math.abs((c[1] - c[0]) / e);
            e = Math.abs(Math.pow(10, c[1]) - Math.pow(10, c[0])) / u, r = n(10), t.dtick = "L" + ot(e, r, $);
          } else t.dtick = e > .3 ? "D2" : "D1";
        } else "category" === t.type || "multicategory" === t.type ? (t.tick0 = 0, t.dtick = Math.ceil(Math.max(e, 1))) : Mt(t) ? (t.tick0 = 0, r = 1, t.dtick = ot(e, r, at)) : (t.tick0 = 0, r = n(10), t.dtick = ot(e, r, $));

        if (0 === t.dtick && (t.dtick = 1), !i(t.dtick) && "string" != typeof t.dtick) {
          var f = t.dtick;
          throw t.dtick = 1, "ax.dtick error: " + String(f);
        }
      }, V.tickIncrement = function (t, e, r, a) {
        var o = r ? -1 : 1;
        if (i(e)) return s.increment(t, o * e);
        var l = e.charAt(0),
            c = o * Number(e.substr(1));
        if ("M" === l) return s.incrementMonth(t, c, a);
        if ("L" === l) return Math.log(Math.pow(10, t) + c) / Math.LN10;

        if ("D" === l) {
          var u = "D2" === e ? it : nt,
              f = t + .01 * o,
              h = s.roundUp(s.mod(f, 1), u, r);
          return Math.floor(f) + Math.log(n.round(Math.pow(10, h), 1)) / Math.LN10;
        }

        throw "unrecognized dtick " + String(e);
      }, V.tickFirst = function (t, e) {
        var r = t.r2l || Number,
            a = s.simpleMap(t.range, r, void 0, void 0, e),
            o = a[1] < a[0],
            l = o ? Math.floor : Math.ceil,
            c = X(a)[0],
            u = t.dtick,
            f = r(t.tick0);

        if (i(u)) {
          var h = l((c - f) / u) * u + f;
          return "category" !== t.type && "multicategory" !== t.type || (h = s.constrain(h, 0, t._categories.length - 1)), h;
        }

        var p = u.charAt(0),
            d = Number(u.substr(1));

        if ("M" === p) {
          for (var m, g, v, y = 0, x = f; y < 10;) {
            if (((m = V.tickIncrement(x, u, o, t.calendar)) - c) * (x - c) <= 0) return o ? Math.min(x, m) : Math.max(x, m);
            g = (c - (x + m) / 2) / (m - x), v = p + (Math.abs(Math.round(g)) || 1) * d, x = V.tickIncrement(x, v, g < 0 ? !o : o, t.calendar), y++;
          }

          return s.error("tickFirst did not converge", t), x;
        }

        if ("L" === p) return Math.log(l((Math.pow(10, c) - f) / d) * d + f) / Math.LN10;

        if ("D" === p) {
          var b = "D2" === u ? it : nt,
              _ = s.roundUp(s.mod(c, 1), b, o);

          return Math.floor(c) + Math.log(n.round(Math.pow(10, _), 1)) / Math.LN10;
        }

        throw "unrecognized dtick " + String(u);
      }, V.tickText = function (t, e, r, n) {
        var a,
            o = lt(t, e),
            l = "array" === t.tickmode,
            c = r || l,
            u = t.type,
            f = "category" === u ? t.d2l_noadd : t.d2l;

        if (l && Array.isArray(t.ticktext)) {
          var h = s.simpleMap(t.range, t.r2l),
              p = (Math.abs(h[1] - h[0]) - (t._lBreaks || 0)) / 1e4;

          for (a = 0; a < t.ticktext.length && !(Math.abs(e - f(t.tickvals[a])) < p); a++) {
            ;
          }

          if (a < t.ticktext.length) return o.text = String(t.ticktext[a]), o;
        }

        function d(n) {
          if (void 0 === n) return !0;
          if (r) return "none" === n;
          var i = {
            first: t._tmin,
            last: t._tmax
          }[n];
          return "all" !== n && e !== i;
        }

        var m = r ? "never" : "none" !== t.exponentformat && d(t.showexponent) ? "hide" : "";

        if ("date" === u ? function (t, e, r, n) {
          var a = t._tickround,
              o = r && t.hoverformat || V.getTickFormat(t);
          n && (a = i(a) ? 4 : {
            y: "m",
            m: "d",
            d: "M",
            M: "S",
            S: 4
          }[a]);
          var l,
              c = s.formatDate(e.x, o, a, t._dateFormat, t.calendar, t._extraFormat),
              u = c.indexOf("\n");
          -1 !== u && (l = c.substr(u + 1), c = c.substr(0, u));
          n && ("00:00:00" === c || "00:00" === c ? (c = l, l = "") : 8 === c.length && (c = c.replace(/:00$/, "")));
          if (l) if (r) "d" === a ? c += ", " + l : c = l + (c ? ", " + c : "");else if (t._inCalcTicks && t._prevDateHead === l) {
            var f = St(t),
                h = t._realSide || t.side;
            (!f && "top" === h || f && "bottom" === h) && (c += "<br> ");
          } else t._prevDateHead = l, c += "<br>" + l;
          e.text = c;
        }(t, o, r, c) : "log" === u ? function (t, e, r, n, a) {
          var o = t.dtick,
              l = e.x,
              c = t.tickformat,
              u = "string" == typeof o && o.charAt(0);
          "never" === a && (a = "");
          n && "L" !== u && (o = "L3", u = "L");
          if (c || "L" === u) e.text = ht(Math.pow(10, l), t, a, n);else if (i(o) || "D" === u && s.mod(l + .01, 1) < .1) {
            var f = Math.round(l),
                h = Math.abs(f),
                p = t.exponentformat;
            "power" === p || ut(p) && ft(f) ? (e.text = 0 === f ? 1 : 1 === f ? "10" : "10<sup>" + (f > 1 ? "" : P) + h + "</sup>", e.fontSize *= 1.25) : ("e" === p || "E" === p) && h > 2 ? e.text = "1" + p + (f > 0 ? "+" : P) + h : (e.text = ht(Math.pow(10, l), t, "", "fakehover"), "D1" === o && "y" === t._id.charAt(0) && (e.dy -= e.fontSize / 6));
          } else {
            if ("D" !== u) throw "unrecognized dtick " + String(o);
            e.text = String(Math.round(Math.pow(10, s.mod(l, 1)))), e.fontSize *= .75;
          }

          if ("D1" === t.dtick) {
            var d = String(e.text).charAt(0);
            "0" !== d && "1" !== d || ("y" === t._id.charAt(0) ? e.dx -= e.fontSize / 4 : (e.dy += e.fontSize / 2, e.dx += (t.range[1] > t.range[0] ? 1 : -1) * e.fontSize * (l < 0 ? .5 : .25)));
          }
        }(t, o, 0, c, m) : "category" === u ? function (t, e) {
          var r = t._categories[Math.round(e.x)];

          void 0 === r && (r = "");
          e.text = String(r);
        }(t, o) : "multicategory" === u ? function (t, e, r) {
          var n = Math.round(e.x),
              i = t._categories[n] || [],
              a = void 0 === i[1] ? "" : String(i[1]),
              o = void 0 === i[0] ? "" : String(i[0]);
          r ? e.text = o + " - " + a : (e.text = a, e.text2 = o);
        }(t, o, r) : Mt(t) ? function (t, e, r, n, i) {
          if ("radians" !== t.thetaunit || r) e.text = ht(e.x, t, i, n);else {
            var a = e.x / 180;
            if (0 === a) e.text = "0";else {
              var o = function (t) {
                function e(t, e) {
                  return Math.abs(t - e) <= 1e-6;
                }

                var r = function (t) {
                  for (var r = 1; !e(Math.round(t * r) / r, t);) {
                    r *= 10;
                  }

                  return r;
                }(t),
                    n = t * r,
                    i = Math.abs(function t(r, n) {
                  return e(n, 0) ? r : t(n, r % n);
                }(n, r));

                return [Math.round(n / i), Math.round(r / i)];
              }(a);

              if (o[1] >= 100) e.text = ht(s.deg2rad(e.x), t, i, n);else {
                var l = e.x < 0;
                1 === o[1] ? 1 === o[0] ? e.text = "\u03C0" : e.text = o[0] + "\u03C0" : e.text = ["<sup>", o[0], "</sup>", "\u2044", "<sub>", o[1], "</sub>", "\u03C0"].join(""), l && (e.text = P + e.text);
              }
            }
          }
        }(t, o, r, c, m) : function (t, e, r, n, i) {
          "never" === i ? i = "" : "all" === t.showexponent && Math.abs(e.x / t.dtick) < 1e-6 && (i = "hide");
          e.text = ht(e.x, t, i, n);
        }(t, o, 0, c, m), n || (t.tickprefix && !d(t.showtickprefix) && (o.text = t.tickprefix + o.text), t.ticksuffix && !d(t.showticksuffix) && (o.text += t.ticksuffix)), "boundaries" === t.tickson || t.showdividers) {
          var g = function g(e) {
            var r = t.l2p(e);
            return r >= 0 && r <= t._length ? e : null;
          };

          o.xbnd = [g(o.x - .5), g(o.x + t.dtick - .5)];
        }

        return o;
      }, V.hoverLabelText = function (t, e, r) {
        r && (t = s.extendFlat({}, t, {
          hoverformat: r
        }));
        var n = Array.isArray(e) ? e[0] : e,
            i = Array.isArray(e) ? e[1] : void 0;
        if (void 0 !== i && i !== n) return V.hoverLabelText(t, n, r) + " - " + V.hoverLabelText(t, i, r);
        var a = "log" === t.type && n <= 0,
            o = V.tickText(t, t.c2l(a ? -n : n), "hover").text;
        return a ? 0 === n ? "0" : P + o : o;
      };
      var ct = ["f", "p", "n", "\u03BC", "m", "", "k", "M", "G", "T"];

      function ut(t) {
        return "SI" === t || "B" === t;
      }

      function ft(t) {
        return t > 14 || t < -15;
      }

      function ht(t, e, r, n) {
        var a = t < 0,
            o = e._tickround,
            l = r || e.exponentformat || "B",
            c = e._tickexponent,
            u = V.getTickFormat(e),
            f = e.separatethousands;

        if (n) {
          var h = {
            exponentformat: l,
            minexponent: e.minexponent,
            dtick: "none" === e.showexponent ? e.dtick : i(t) && Math.abs(t) || 1,
            range: "none" === e.showexponent ? e.range.map(e.r2d) : [0, t || 1]
          };
          st(h), o = (Number(h._tickround) || 0) + 4, c = h._tickexponent, e.hoverformat && (u = e.hoverformat);
        }

        if (u) return e._numFormat(u)(t).replace(/-/g, P);
        var p,
            d = Math.pow(10, -o) / 2;
        if ("none" === l && (c = 0), (t = Math.abs(t)) < d) t = "0", a = !1;else {
          if (t += d, c && (t *= Math.pow(10, -c), o += c), 0 === o) t = String(Math.floor(t));else if (o < 0) {
            t = (t = String(Math.round(t))).substr(0, t.length + o);

            for (var m = o; m < 0; m++) {
              t += "0";
            }
          } else {
            var g = (t = String(t)).indexOf(".") + 1;
            g && (t = t.substr(0, g + o).replace(/\.?0+$/, ""));
          }
          t = s.numSeparate(t, e._separators, f);
        }
        c && "hide" !== l && (ut(l) && ft(c) && (l = "power"), p = c < 0 ? P + -c : "power" !== l ? "+" + c : String(c), "e" === l || "E" === l ? t += l + p : "power" === l ? t += "\xd710<sup>" + p + "</sup>" : "B" === l && 9 === c ? t += "B" : ut(l) && (t += ct[c / 3 + 5]));
        return a ? P + t : t;
      }

      function pt(t, e) {
        for (var r = [], n = {}, i = 0; i < e.length; i++) {
          var a = e[i];
          n[a.text2] ? n[a.text2].push(a.x) : n[a.text2] = [a.x];
        }

        for (var o in n) {
          r.push(lt(t, s.interp(n[o], .5), o));
        }

        return r;
      }

      function dt(t) {
        return void 0 !== t.periodX ? t.periodX : t.x;
      }

      function mt(t) {
        return [t.text, t.x, t.axInfo, t.font, t.fontSize, t.fontColor].join("_");
      }

      function gt(t) {
        var e = t.title.font.size,
            r = (t.title.text.match(c.BR_TAG_ALL) || []).length;
        return t.title.hasOwnProperty("standoff") ? r ? e * (N + r * j) : e * N : r ? e * (r + 1) * j : e;
      }

      function vt(t, e) {
        var r = t.l2p(e);
        return r > 1 && r < t._length - 1;
      }

      function yt(t) {
        var e = n.select(t),
            r = e.select(".text-math-group");
        return r.empty() ? e.select("text") : r;
      }

      function xt(t) {
        return t._id + ".automargin";
      }

      function bt(t) {
        return xt(t) + ".mirror";
      }

      function _t(t) {
        return t._id + ".rangeslider";
      }

      function wt(t, e) {
        for (var r = 0; r < e.length; r++) {
          -1 === t.indexOf(e[r]) && t.push(e[r]);
        }
      }

      function Tt(t, e, r) {
        var n,
            i,
            a = [],
            o = [],
            l = t.layout;

        for (n = 0; n < e.length; n++) {
          a.push(V.getFromId(t, e[n]));
        }

        for (n = 0; n < r.length; n++) {
          o.push(V.getFromId(t, r[n]));
        }

        var c = Object.keys(p),
            u = ["anchor", "domain", "overlaying", "position", "side", "tickangle", "editType"],
            f = ["linear", "log"];

        for (n = 0; n < c.length; n++) {
          var h = c[n],
              d = a[0][h],
              m = o[0][h],
              g = !0,
              v = !1,
              y = !1;

          if ("_" !== h.charAt(0) && "function" != typeof d && -1 === u.indexOf(h)) {
            for (i = 1; i < a.length && g; i++) {
              var x = a[i][h];
              "type" === h && -1 !== f.indexOf(d) && -1 !== f.indexOf(x) && d !== x ? v = !0 : x !== d && (g = !1);
            }

            for (i = 1; i < o.length && g; i++) {
              var b = o[i][h];
              "type" === h && -1 !== f.indexOf(m) && -1 !== f.indexOf(b) && m !== b ? y = !0 : o[i][h] !== m && (g = !1);
            }

            g && (v && (l[a[0]._name].type = "linear"), y && (l[o[0]._name].type = "linear"), kt(l, h, a, o, t._fullLayout._dfltTitle));
          }
        }

        for (n = 0; n < t._fullLayout.annotations.length; n++) {
          var _ = t._fullLayout.annotations[n];
          -1 !== e.indexOf(_.xref) && -1 !== r.indexOf(_.yref) && s.swapAttrs(l.annotations[n], ["?"]);
        }
      }

      function kt(t, e, r, n, i) {
        var a,
            o = s.nestedProperty,
            l = o(t[r[0]._name], e).get(),
            c = o(t[n[0]._name], e).get();

        for ("title" === e && (l && l.text === i.x && (l.text = i.y), c && c.text === i.y && (c.text = i.x)), a = 0; a < r.length; a++) {
          o(t, r[a]._name + "." + e).set(c);
        }

        for (a = 0; a < n.length; a++) {
          o(t, n[a]._name + "." + e).set(l);
        }
      }

      function Mt(t) {
        return "angularaxis" === t._id;
      }

      function At(t, e) {
        for (var r = e._rangebreaks.length, n = 0; n < r; n++) {
          var i = e._rangebreaks[n];
          if (t >= i.min && t < i.max) return i.max;
        }

        return t;
      }

      function St(t) {
        return -1 !== (t.ticklabelposition || "").indexOf("inside");
      }

      function Et(t, e) {
        St(t._anchorAxis || {}) && t._hideCounterAxisInsideTickLabels && t._hideCounterAxisInsideTickLabels(e);
      }

      V.getTickFormat = function (t) {
        var e, r, n, i, a, o, s, l;

        function c(t) {
          return "string" != typeof t ? t : Number(t.replace("M", "")) * T;
        }

        function u(t, e) {
          var r = ["L", "D"];

          if (_typeof(t) == _typeof(e)) {
            if ("number" == typeof t) return t - e;
            var n = r.indexOf(t.charAt(0)),
                i = r.indexOf(e.charAt(0));
            return n === i ? Number(t.replace(/(L|D)/g, "")) - Number(e.replace(/(L|D)/g, "")) : n - i;
          }

          return "number" == typeof t ? 1 : -1;
        }

        function f(t, e) {
          var r = null === e[0],
              n = null === e[1],
              i = u(t, e[0]) >= 0,
              a = u(t, e[1]) <= 0;
          return (r || i) && (n || a);
        }

        if (t.tickformatstops && t.tickformatstops.length > 0) switch (t.type) {
          case "date":
          case "linear":
            for (e = 0; e < t.tickformatstops.length; e++) {
              if ((n = t.tickformatstops[e]).enabled && (i = t.dtick, a = n.dtickrange, o = void 0, s = void 0, l = void 0, o = c || function (t) {
                return t;
              }, s = a[0], l = a[1], (!s && "number" != typeof s || o(s) <= o(i)) && (!l && "number" != typeof l || o(l) >= o(i)))) {
                r = n;
                break;
              }
            }

            break;

          case "log":
            for (e = 0; e < t.tickformatstops.length; e++) {
              if ((n = t.tickformatstops[e]).enabled && f(t.dtick, n.dtickrange)) {
                r = n;
                break;
              }
            }

        }
        return r ? r.value : t.tickformat;
      }, V.getSubplots = function (t, e) {
        var r = t._fullLayout._subplots,
            n = r.cartesian.concat(r.gl2d || []),
            i = e ? V.findSubplotsWithAxis(n, e) : n;
        return i.sort(function (t, e) {
          var r = t.substr(1).split("y"),
              n = e.substr(1).split("y");
          return r[0] === n[0] ? +r[1] - +n[1] : +r[0] - +n[0];
        }), i;
      }, V.findSubplotsWithAxis = function (t, e) {
        for (var r = new RegExp("x" === e._id.charAt(0) ? "^" + e._id + "y" : e._id + "$"), n = [], i = 0; i < t.length; i++) {
          var a = t[i];
          r.test(a) && n.push(a);
        }

        return n;
      }, V.makeClipPaths = function (t) {
        var e = t._fullLayout;

        if (!e._hasOnlyLargeSploms) {
          var r,
              i,
              a = {
            _offset: 0,
            _length: e.width,
            _id: ""
          },
              o = {
            _offset: 0,
            _length: e.height,
            _id: ""
          },
              s = V.list(t, "x", !0),
              l = V.list(t, "y", !0),
              c = [];

          for (r = 0; r < s.length; r++) {
            for (c.push({
              x: s[r],
              y: o
            }), i = 0; i < l.length; i++) {
              0 === r && c.push({
                x: a,
                y: l[i]
              }), c.push({
                x: s[r],
                y: l[i]
              });
            }
          }

          var u = e._clips.selectAll(".axesclip").data(c, function (t) {
            return t.x._id + t.y._id;
          });

          u.enter().append("clipPath").classed("axesclip", !0).attr("id", function (t) {
            return "clip" + e._uid + t.x._id + t.y._id;
          }).append("rect"), u.exit().remove(), u.each(function (t) {
            n.select(this).select("rect").attr({
              x: t.x._offset || 0,
              y: t.y._offset || 0,
              width: t.x._length || 1,
              height: t.y._length || 1
            });
          });
        }
      }, V.draw = function (t, e, r) {
        var n = t._fullLayout;
        "redraw" === e && n._paper.selectAll("g.subplot").each(function (t) {
          var e = t[0],
              r = n._plots[e];

          if (r) {
            var i = r.xaxis,
                a = r.yaxis;
            r.xaxislayer.selectAll("." + i._id + "tick").remove(), r.yaxislayer.selectAll("." + a._id + "tick").remove(), r.xaxislayer.selectAll("." + i._id + "tick2").remove(), r.yaxislayer.selectAll("." + a._id + "tick2").remove(), r.xaxislayer.selectAll("." + i._id + "divider").remove(), r.yaxislayer.selectAll("." + a._id + "divider").remove(), r.gridlayer && r.gridlayer.selectAll("path").remove(), r.zerolinelayer && r.zerolinelayer.selectAll("path").remove(), n._infolayer.select(".g-" + i._id + "title").remove(), n._infolayer.select(".g-" + a._id + "title").remove();
          }
        });
        var i = e && "redraw" !== e ? e : V.listIds(t);
        return s.syncOrAsync(i.map(function (e) {
          return function () {
            if (e) {
              var n = V.getFromId(t, e),
                  i = V.drawOne(t, n, r);
              return n._r = n.range.slice(), n._rl = s.simpleMap(n._r, n.r2l), i;
            }
          };
        }));
      }, V.drawOne = function (t, e, r) {
        var n, i, l;
        r = r || {}, e.setScale();
        var c = t._fullLayout,
            p = e._id,
            d = p.charAt(0),
            m = V.counterLetter(p),
            g = c._plots[e._mainSubplot];

        if (g) {
          var v = g[d + "axislayer"],
              y = e._mainLinePosition,
              x = e._mainMirrorPosition,
              b = e._vals = V.calcTicks(e),
              _ = [e.mirror, y, x].join("_");

          for (n = 0; n < b.length; n++) {
            b[n].axInfo = _;
          }

          e._selections = {}, e._tickAngles && (e._prevTickAngles = e._tickAngles), e._tickAngles = {}, e._depth = null;
          var w = {};

          if (e.visible) {
            var T,
                k,
                M = V.makeTransTickFn(e),
                A = V.makeTransTickLabelFn(e),
                S = "inside" === e.ticks,
                E = "outside" === e.ticks;

            if ("boundaries" === e.tickson) {
              var L = function (t, e) {
                var r,
                    n = [],
                    i = function i(t, e) {
                  var r = t.xbnd[e];
                  null !== r && n.push(s.extendFlat({}, t, {
                    x: r
                  }));
                };

                if (e.length) {
                  for (r = 0; r < e.length; r++) {
                    i(e[r], 0);
                  }

                  i(e[r - 1], 1);
                }

                return n;
              }(0, b);

              k = V.clipEnds(e, L), T = S ? k : L;
            } else k = V.clipEnds(e, b), T = S && "period" !== e.ticklabelmode ? k : b;

            var C = e._gridVals = k,
                P = function (t, e) {
              var r,
                  n,
                  i = [],
                  a = e.length && e[e.length - 1].x < e[0].x,
                  o = function o(t, e) {
                var r = t.xbnd[e];
                null !== r && i.push(s.extendFlat({}, t, {
                  x: r
                }));
              };

              if (t.showdividers && e.length) {
                for (r = 0; r < e.length; r++) {
                  var l = e[r];
                  l.text2 !== n && o(l, a ? 1 : 0), n = l.text2;
                }

                o(e[r - 1], a ? 0 : 1);
              }

              return i;
            }(e, b);

            if (!c._hasOnlyLargeSploms) {
              var I = e._subplotsWith,
                  O = {};

              for (n = 0; n < I.length; n++) {
                i = I[n];
                var z = (l = c._plots[i])[m + "axis"],
                    D = z._mainAxis._id;

                if (!O[D]) {
                  O[D] = 1;
                  var R = "x" === d ? "M0," + z._offset + "v" + z._length : "M" + z._offset + ",0h" + z._length;
                  V.drawGrid(t, e, {
                    vals: C,
                    counterAxis: z,
                    layer: l.gridlayer.select("." + p),
                    path: R,
                    transFn: M
                  }), V.drawZeroLine(t, e, {
                    counterAxis: z,
                    layer: l.zerolinelayer,
                    path: R,
                    transFn: M
                  });
                }
              }
            }

            var F = V.getTickSigns(e),
                B = [];

            if (e.ticks) {
              var N,
                  q,
                  H,
                  G = V.makeTickPath(e, y, F[2]);

              if (e._anchorAxis && e.mirror && !0 !== e.mirror ? (N = V.makeTickPath(e, x, F[3]), q = G + N) : (N = "", q = G), e.showdividers && E && "boundaries" === e.tickson) {
                var Y = {};

                for (n = 0; n < P.length; n++) {
                  Y[P[n].x] = 1;
                }

                H = function H(t) {
                  return Y[t.x] ? N : q;
                };
              } else H = q;

              V.drawTicks(t, e, {
                vals: T,
                layer: v,
                path: H,
                transFn: M
              }), "allticks" === e.mirror && (B = Object.keys(e._linepositions || {}));
            }

            for (n = 0; n < B.length; n++) {
              i = B[n], l = c._plots[i];
              var W = e._linepositions[i] || [],
                  X = V.makeTickPath(e, W[0], F[0]) + V.makeTickPath(e, W[1], F[1]);
              V.drawTicks(t, e, {
                vals: T,
                layer: l[d + "axislayer"],
                path: X,
                transFn: M
              });
            }

            var Z = [];

            if (Z.push(function () {
              return V.drawLabels(t, e, {
                vals: b,
                layer: v,
                plotinfo: l,
                transFn: A,
                labelFns: V.makeLabelFns(e, y)
              });
            }), "multicategory" === e.type) {
              var J = {
                x: 2,
                y: 10
              }[d];
              Z.push(function () {
                var r = {
                  x: "height",
                  y: "width"
                }[d],
                    n = Q()[r] + J + (e._tickAngles[p + "tick"] ? e.tickfont.size * j : 0);
                return V.drawLabels(t, e, {
                  vals: pt(e, b),
                  layer: v,
                  cls: p + "tick2",
                  repositionOnUpdate: !0,
                  secondary: !0,
                  transFn: M,
                  labelFns: V.makeLabelFns(e, y + n * F[4])
                });
              }), Z.push(function () {
                return e._depth = F[4] * (Q("tick2")[e.side] - y), function (t, e, r) {
                  var n = e._id + "divider",
                      i = r.vals,
                      a = r.layer.selectAll("path." + n).data(i, mt);
                  a.exit().remove(), a.enter().insert("path", ":first-child").classed(n, 1).classed("crisp", 1).call(f.stroke, e.dividercolor).style("stroke-width", h.crispRound(t, e.dividerwidth, 1) + "px"), a.attr("transform", r.transFn).attr("d", r.path);
                }(t, e, {
                  vals: P,
                  layer: v,
                  path: V.makeTickPath(e, y, F[4], e._depth),
                  transFn: M
                });
              });
            } else e.title.hasOwnProperty("standoff") && Z.push(function () {
              e._depth = F[4] * (Q()[e.side] - y);
            });

            var K = o.getComponentMethod("rangeslider", "isVisible")(e);
            return Z.push(function () {
              var r,
                  n,
                  i,
                  s,
                  l = e.side.charAt(0),
                  u = U[e.side].charAt(0),
                  f = V.getPxPosition(t, e),
                  h = E ? e.ticklen : 0;

              if ((e.automargin || K) && ("multicategory" === e.type ? r = Q("tick2") : (r = Q(), "x" === d && "b" === l && (e._depth = Math.max(r.width > 0 ? r.bottom - f : 0, h)))), e.automargin) {
                n = {
                  x: 0,
                  y: 0,
                  r: 0,
                  l: 0,
                  t: 0,
                  b: 0
                };
                var p = [0, 1];

                if ("x" === d) {
                  if ("b" === l ? n[l] = e._depth : (n[l] = e._depth = Math.max(r.width > 0 ? f - r.top : 0, h), p.reverse()), r.width > 0) {
                    var g = r.right - (e._offset + e._length);
                    g > 0 && (n.xr = 1, n.r = g);
                    var v = e._offset - r.left;
                    v > 0 && (n.xl = 0, n.l = v);
                  }
                } else if ("l" === l ? n[l] = e._depth = Math.max(r.height > 0 ? f - r.left : 0, h) : (n[l] = e._depth = Math.max(r.height > 0 ? r.right - f : 0, h), p.reverse()), r.height > 0) {
                  var y = r.bottom - (e._offset + e._length);
                  y > 0 && (n.yb = 0, n.b = y);
                  var x = e._offset - r.top;
                  x > 0 && (n.yt = 1, n.t = x);
                }

                n[m] = "free" === e.anchor ? e.position : e._anchorAxis.domain[p[0]], e.title.text !== c._dfltTitle[d] && (n[l] += gt(e) + (e.title.standoff || 0)), e.mirror && "free" !== e.anchor && ((i = {
                  x: 0,
                  y: 0,
                  r: 0,
                  l: 0,
                  t: 0,
                  b: 0
                })[u] = e.linewidth, e.mirror && !0 !== e.mirror && (i[u] += h), !0 === e.mirror || "ticks" === e.mirror ? i[m] = e._anchorAxis.domain[p[1]] : "all" !== e.mirror && "allticks" !== e.mirror || (i[m] = [e._counterDomainMin, e._counterDomainMax][p[1]]));
              }

              K && (s = o.getComponentMethod("rangeslider", "autoMarginOpts")(t, e)), a.autoMargin(t, xt(e), n), a.autoMargin(t, bt(e), i), a.autoMargin(t, _t(e), s);
            }), r.skipTitle || K && "bottom" === e.side || Z.push(function () {
              return function (t, e) {
                var r,
                    n = t._fullLayout,
                    i = e._id,
                    a = i.charAt(0),
                    o = e.title.font.size;
                if (e.title.hasOwnProperty("standoff")) r = e._depth + e.title.standoff + gt(e);else {
                  var s = St(e);
                  if ("multicategory" === e.type) r = e._depth;else {
                    var l = 1.5 * o;
                    s && (l = .5 * o, "outside" === e.ticks && (l += e.ticklen)), r = 10 + l + (e.linewidth ? e.linewidth - 1 : 0);
                  }
                  s || (r += "x" === a ? "top" === e.side ? o * (e.showticklabels ? 1 : 0) : o * (e.showticklabels ? 1.5 : .5) : "right" === e.side ? o * (e.showticklabels ? 1 : .5) : o * (e.showticklabels ? .5 : 0));
                }
                var c,
                    f,
                    p,
                    d,
                    m = V.getPxPosition(t, e);
                "x" === a ? (f = e._offset + e._length / 2, p = "top" === e.side ? m - r : m + r) : (p = e._offset + e._length / 2, f = "right" === e.side ? m + r : m - r, c = {
                  rotate: "-90",
                  offset: 0
                });

                if ("multicategory" !== e.type) {
                  var g = e._selections[e._id + "tick"];

                  if (d = {
                    selection: g,
                    side: e.side
                  }, g && g.node() && g.node().parentNode) {
                    var v = h.getTranslate(g.node().parentNode);
                    d.offsetLeft = v.x, d.offsetTop = v.y;
                  }

                  e.title.hasOwnProperty("standoff") && (d.pad = 0);
                }

                return u.draw(t, i + "title", {
                  propContainer: e,
                  propName: e._name + ".title.text",
                  placeholder: n._dfltTitle[a],
                  avoid: d,
                  transform: c,
                  attributes: {
                    x: f,
                    y: p,
                    "text-anchor": "middle"
                  }
                });
              }(t, e);
            }), s.syncOrAsync(Z);
          }
        }

        function Q(t) {
          var r = p + (t || "tick");
          return w[r] || (w[r] = function (t, e) {
            var r, n, i, a;
            t._selections[e].size() ? (r = 1 / 0, n = -1 / 0, i = 1 / 0, a = -1 / 0, t._selections[e].each(function () {
              var t = yt(this),
                  e = h.bBox(t.node().parentNode);
              r = Math.min(r, e.top), n = Math.max(n, e.bottom), i = Math.min(i, e.left), a = Math.max(a, e.right);
            })) : (r = 0, n = 0, i = 0, a = 0);
            return {
              top: r,
              bottom: n,
              left: i,
              right: a,
              height: n - r,
              width: a - i
            };
          }(e, r)), w[r];
        }
      }, V.getTickSigns = function (t) {
        var e = t._id.charAt(0),
            r = {
          x: "top",
          y: "right"
        }[e],
            n = t.side === r ? 1 : -1,
            i = [-1, 1, n, -n];

        return "inside" !== t.ticks == ("x" === e) && (i = i.map(function (t) {
          return -t;
        })), t.side && i.push({
          l: -1,
          t: -1,
          r: 1,
          b: 1
        }[t.side.charAt(0)]), i;
      }, V.makeTransTickFn = function (t) {
        return "x" === t._id.charAt(0) ? function (e) {
          return l(t._offset + t.l2p(e.x), 0);
        } : function (e) {
          return l(0, t._offset + t.l2p(e.x));
        };
      }, V.makeTransTickLabelFn = function (t) {
        var e = function (t) {
          var e = t.ticklabelposition || "",
              r = function r(t) {
            return -1 !== e.indexOf(t);
          },
              n = r("top"),
              i = r("left"),
              a = r("right"),
              o = r("bottom"),
              s = r("inside"),
              l = o || i || n || a;

          if (!l && !s) return [0, 0];
          var c = t.side,
              u = l ? (t.tickwidth || 0) / 2 : 0,
              f = 3,
              h = t.tickfont ? t.tickfont.size : 12;
          (o || n) && (u += h * N, f += (t.linewidth || 0) / 2);
          (i || a) && (u += (t.linewidth || 0) / 2, f += 3);
          s && "top" === c && (f -= h * (1 - N));
          (i || n) && (u = -u);
          "bottom" !== c && "right" !== c || (f = -f);
          return [l ? u : 0, s ? f : 0];
        }(t),
            r = e[0],
            n = e[1];

        return "x" === t._id.charAt(0) ? function (e) {
          return l(r + t._offset + t.l2p(dt(e)), n);
        } : function (e) {
          return l(n, r + t._offset + t.l2p(dt(e)));
        };
      }, V.makeTickPath = function (t, e, r, n) {
        n = void 0 !== n ? n : t.ticklen;

        var i = t._id.charAt(0),
            a = (t.linewidth || 1) / 2;

        return "x" === i ? "M0," + (e + a * r) + "v" + n * r : "M" + (e + a * r) + ",0h" + n * r;
      }, V.makeLabelFns = function (t, e, r) {
        var n = t.ticklabelposition || "",
            a = function a(t) {
          return -1 !== n.indexOf(t);
        },
            o = a("top"),
            l = a("left"),
            c = a("right"),
            u = a("bottom") || l || o || c,
            f = a("inside"),
            h = "inside" === n && "inside" === t.ticks || !f && "outside" === t.ticks && "boundaries" !== t.tickson,
            p = 0,
            d = 0,
            m = h ? t.ticklen : 0;

        if (f ? m *= -1 : u && (m = 0), h && (p += m, r)) {
          var g = s.deg2rad(r);
          p = m * Math.cos(g) + 1, d = m * Math.sin(g);
        }

        t.showticklabels && (h || t.showline) && (p += .2 * t.tickfont.size);

        var v,
            y,
            x,
            b,
            _,
            w = {
          labelStandoff: p += (t.linewidth || 1) / 2 * (f ? -1 : 1),
          labelShift: d
        },
            T = 0,
            k = t.side,
            M = t._id.charAt(0),
            A = t.tickangle;

        if ("x" === M) b = (_ = !f && "bottom" === k || f && "top" === k) ? 1 : -1, f && (b *= -1), v = d * b, y = e + p * b, x = _ ? 1 : -.2, 90 === Math.abs(A) && (f ? x += B : x = -90 === A && "bottom" === k ? N : 90 === A && "top" === k ? B : .5, T = B / 2 * (A / 90)), w.xFn = function (t) {
          return t.dx + v + T * t.fontSize;
        }, w.yFn = function (t) {
          return t.dy + y + t.fontSize * x;
        }, w.anchorFn = function (t, e) {
          if (u) {
            if (l) return "end";
            if (c) return "start";
          }

          return i(e) && 0 !== e && 180 !== e ? e * b < 0 !== f ? "end" : "start" : "middle";
        }, w.heightFn = function (e, r, n) {
          return r < -60 || r > 60 ? -.5 * n : "top" === t.side !== f ? -n : 0;
        };else if ("y" === M) {
          if (b = (_ = !f && "left" === k || f && "right" === k) ? 1 : -1, f && (b *= -1), v = p, y = d * b, x = 0, f || 90 !== Math.abs(A) || (x = -90 === A && "left" === k || 90 === A && "right" === k ? N : .5), f) {
            var S = i(A) ? +A : 0;

            if (0 !== S) {
              var E = s.deg2rad(S);
              T = Math.abs(Math.sin(E)) * N * b, x = 0;
            }
          }

          w.xFn = function (t) {
            return t.dx + e - (v + t.fontSize * x) * b + T * t.fontSize;
          }, w.yFn = function (t) {
            return t.dy + y + t.fontSize * B;
          }, w.anchorFn = function (t, e) {
            return i(e) && 90 === Math.abs(e) ? "middle" : _ ? "end" : "start";
          }, w.heightFn = function (e, r, n) {
            return "right" === t.side && (r *= -1), r < -30 ? -n : r < 30 ? -.5 * n : 0;
          };
        }
        return w;
      }, V.drawTicks = function (t, e, r) {
        r = r || {};
        var n = e._id + "tick",
            i = r.vals;
        "period" === e.ticklabelmode && (i = i.slice()).shift();
        var a = r.layer.selectAll("path." + n).data(e.ticks ? i : [], mt);
        a.exit().remove(), a.enter().append("path").classed(n, 1).classed("ticks", 1).classed("crisp", !1 !== r.crisp).call(f.stroke, e.tickcolor).style("stroke-width", h.crispRound(t, e.tickwidth, 1) + "px").attr("d", r.path).style("display", null), Et(e, [D]), a.attr("transform", r.transFn);
      }, V.drawGrid = function (t, e, r) {
        r = r || {};
        var n = e._id + "grid",
            i = r.vals,
            a = r.counterAxis;
        if (!1 === e.showgrid) i = [];else if (a && V.shouldShowZeroLine(t, e, a)) for (var o = "array" === e.tickmode, s = 0; s < i.length; s++) {
          var l = i[s].x;

          if (o ? !l : Math.abs(l) < e.dtick / 100) {
            if (i = i.slice(0, s).concat(i.slice(s + 1)), !o) break;
            s--;
          }
        }
        var c = r.layer.selectAll("path." + n).data(i, mt);
        c.exit().remove(), c.enter().append("path").classed(n, 1).classed("crisp", !1 !== r.crisp), e._gw = h.crispRound(t, e.gridwidth, 1), c.attr("transform", r.transFn).attr("d", r.path).call(f.stroke, e.gridcolor || "#ddd").style("stroke-width", e._gw + "px").style("display", null), Et(e, [z]), "function" == typeof r.path && c.attr("d", r.path);
      }, V.drawZeroLine = function (t, e, r) {
        r = r || r;
        var n = e._id + "zl",
            i = V.shouldShowZeroLine(t, e, r.counterAxis),
            a = r.layer.selectAll("path." + n).data(i ? [{
          x: 0,
          id: e._id
        }] : []);
        a.exit().remove(), a.enter().append("path").classed(n, 1).classed("zl", 1).classed("crisp", !1 !== r.crisp).each(function () {
          r.layer.selectAll("path").sort(function (t, e) {
            return G(t.id, e.id);
          });
        }), a.attr("transform", r.transFn).attr("d", r.path).call(f.stroke, e.zerolinecolor || f.defaultLine).style("stroke-width", h.crispRound(t, e.zerolinewidth, e._gw || 1) + "px").style("display", null), Et(e, [O]);
      }, V.drawLabels = function (t, e, r) {
        r = r || {};
        var a = t._fullLayout,
            o = e._id,
            u = o.charAt(0),
            f = r.cls || o + "tick",
            p = r.vals,
            d = r.labelFns,
            m = r.secondary ? 0 : e.tickangle,
            g = (e._prevTickAngles || {})[f],
            v = r.layer.selectAll("g." + f).data(e.showticklabels ? p : [], mt),
            y = [];

        function x(t, a) {
          t.each(function (t) {
            var o = n.select(this),
                s = o.select(".text-math-group"),
                u = d.anchorFn(t, a),
                f = r.transFn.call(o.node(), t) + (i(a) && 0 != +a ? " rotate(" + a + "," + d.xFn(t) + "," + (d.yFn(t) - t.fontSize / 2) + ")" : ""),
                p = c.lineCount(o),
                m = j * t.fontSize,
                g = d.heightFn(t, i(a) ? +a : 0, (p - 1) * m);

            if (g && (f += l(0, g)), s.empty()) {
              var v = o.select("text");
              v.attr({
                transform: f,
                "text-anchor": u
              }), v.style("opacity", 1), e._adjustTickLabelsOverflow && e._adjustTickLabelsOverflow();
            } else {
              var y = h.bBox(s.node()).width * {
                end: -.5,
                start: .5
              }[u];
              s.attr("transform", f + l(y, 0));
            }
          });
        }

        v.enter().append("g").classed(f, 1).append("text").attr("text-anchor", "middle").each(function (e) {
          var r = n.select(this),
              i = t._promises.length;
          r.call(c.positionText, d.xFn(e), d.yFn(e)).call(h.font, e.font, e.fontSize, e.fontColor).text(e.text).call(c.convertToTspans, t), t._promises[i] ? y.push(t._promises.pop().then(function () {
            x(r, m);
          })) : x(r, m);
        }), Et(e, [R]), v.exit().remove(), r.repositionOnUpdate && v.each(function (t) {
          n.select(this).select("text").call(c.positionText, d.xFn(t), d.yFn(t));
        }), e._adjustTickLabelsOverflow = function () {
          var r = e.ticklabeloverflow;

          if (r && "allow" !== r) {
            var i = -1 !== r.indexOf("hide"),
                o = "x" === e._id.charAt(0),
                l = 0,
                c = o ? t._fullLayout.width : t._fullLayout.height;

            if (-1 !== r.indexOf("domain")) {
              var u = s.simpleMap(e.range, e.r2l);
              l = e.l2p(u[0]) + e._offset, c = e.l2p(u[1]) + e._offset;
            }

            var f = Math.min(l, c),
                p = Math.max(l, c),
                d = e.side,
                m = 1 / 0,
                g = -1 / 0;

            for (var y in v.each(function (t) {
              var r = n.select(this);

              if (r.select(".text-math-group").empty()) {
                var a = h.bBox(r.node()),
                    s = 0;
                o ? (a.right > p || a.left < f) && (s = 1) : (a.bottom > p || a.top + (e.tickangle ? 0 : t.fontSize / 4) < f) && (s = 1);
                var l = r.select("text");
                s ? i && l.style("opacity", 0) : (l.style("opacity", 1), m = "bottom" === d || "right" === d ? Math.min(m, o ? a.top : a.left) : -1 / 0, g = "top" === d || "left" === d ? Math.max(g, o ? a.bottom : a.right) : 1 / 0);
              }
            }), a._plots) {
              var x = a._plots[y];

              if (e._id === x.xaxis._id || e._id === x.yaxis._id) {
                var b = o ? x.yaxis : x.xaxis;
                b && (b["_visibleLabelMin_" + e._id] = m, b["_visibleLabelMax_" + e._id] = g);
              }
            }
          }
        }, e._hideCounterAxisInsideTickLabels = function (t) {
          var r = "x" === e._id.charAt(0),
              i = [];

          for (var o in a._plots) {
            var s = a._plots[o];
            e._id !== s.xaxis._id && e._id !== s.yaxis._id || i.push(r ? s.yaxis : s.xaxis);
          }

          i.forEach(function (r, i) {
            r && St(r) && (t || [O, z, D, R]).forEach(function (t) {
              var o = "tick" === t.K && "text" === t.L && "period" === e.ticklabelmode,
                  s = a._plots[e._mainSubplot];
              (t.K === O.K ? s.zerolinelayer.selectAll("." + e._id + "zl") : t.K === z.K ? s.gridlayer.selectAll("." + e._id) : s[e._id.charAt(0) + "axislayer"]).each(function () {
                var a = n.select(this);
                t.L && (a = a.selectAll(t.L)), a.each(function (a) {
                  var s = e.l2p(o ? dt(a) : a.x) + e._offset,
                      l = n.select(this);

                  s < e["_visibleLabelMax_" + r._id] && s > e["_visibleLabelMin_" + r._id] ? l.style("display", "none") : "tick" !== t.K || i || l.style("display", null);
                });
              });
            });
          });
        }, x(v, g + 1 ? g : m);
        var b = null;
        e._selections && (e._selections[f] = v);
        var _ = [function () {
          return y.length && Promise.all(y);
        }];
        e.automargin && a._redrawFromAutoMarginCount && 90 === g ? (b = 90, _.push(function () {
          x(v, g);
        })) : _.push(function () {
          if (x(v, m), p.length && "x" === u && !i(m) && ("log" !== e.type || "D" !== String(e.dtick).charAt(0))) {
            b = 0;
            var t,
                n = 0,
                a = [];

            if (v.each(function (t) {
              n = Math.max(n, t.fontSize);
              var r = e.l2p(t.x),
                  i = yt(this),
                  o = h.bBox(i.node());
              a.push({
                top: 0,
                bottom: 10,
                height: 10,
                left: r - o.width / 2,
                right: r + o.width / 2 + 2,
                width: o.width + 2
              });
            }), "boundaries" !== e.tickson && !e.showdividers || r.secondary) {
              var o = p.length,
                  l = Math.abs((p[o - 1].x - p[0].x) * e._m) / (o - 1),
                  c = e.ticklabelposition || "",
                  f = function f(t) {
                return -1 !== c.indexOf(t);
              },
                  d = f("top"),
                  g = f("left"),
                  y = f("right"),
                  _ = f("bottom") || g || d || y ? (e.tickwidth || 0) + 6 : 0,
                  w = l < 2.5 * n || "multicategory" === e.type;

              for (t = 0; t < a.length - 1; t++) {
                if (s.bBoxIntersect(a[t], a[t + 1], _)) {
                  b = w ? 90 : 30;
                  break;
                }
              }
            } else {
              var T = 2;

              for (e.ticks && (T += e.tickwidth / 2), t = 0; t < a.length; t++) {
                var k = p[t].xbnd,
                    M = a[t];

                if (null !== k[0] && M.left - e.l2p(k[0]) < T || null !== k[1] && e.l2p(k[1]) - M.right < T) {
                  b = 90;
                  break;
                }
              }
            }

            b && x(v, b);
          }
        }), e._tickAngles && _.push(function () {
          e._tickAngles[f] = null === b ? i(m) ? m : 0 : b;
        });
        var w = e._anchorAxis;
        w && w.autorange && St(e) && !Y(a, e._id) && (a._insideTickLabelsAutorange || (a._insideTickLabelsAutorange = {}), a._insideTickLabelsAutorange[w._name + ".autorange"] = w.autorange, _.push(function () {
          v.each(function (t, r) {
            var n = yt(this);
            n.select(".text-math-group").empty() && (e._vals[r].bb = h.bBox(n.node()));
          });
        }));
        var T = s.syncOrAsync(_);
        return T && T.then && t._promises.push(T), T;
      }, V.getPxPosition = function (t, e) {
        var r,
            n = t._fullLayout._size,
            i = e._id.charAt(0),
            a = e.side;

        return "free" !== e.anchor ? r = e._anchorAxis : "x" === i ? r = {
          _offset: n.t + (1 - (e.position || 0)) * n.h,
          _length: 0
        } : "y" === i && (r = {
          _offset: n.l + (e.position || 0) * n.w,
          _length: 0
        }), "top" === a || "left" === a ? r._offset : "bottom" === a || "right" === a ? r._offset + r._length : void 0;
      }, V.shouldShowZeroLine = function (t, e, r) {
        var n = s.simpleMap(e.range, e.r2l);
        return n[0] * n[1] <= 0 && e.zeroline && ("linear" === e.type || "-" === e.type) && !(e.rangebreaks && e.maskBreaks(0) === I) && (vt(e, 0) || !function (t, e, r, n) {
          var i = r._mainAxis;
          if (!i) return;

          var a = t._fullLayout,
              o = e._id.charAt(0),
              s = V.counterLetter(e._id),
              l = e._offset + (Math.abs(n[0]) < Math.abs(n[1]) == ("x" === o) ? 0 : e._length);

          function c(t) {
            if (!t.showline || !t.linewidth) return !1;
            var r = Math.max((t.linewidth + e.zerolinewidth) / 2, 1);

            function n(t) {
              return "number" == typeof t && Math.abs(t - l) < r;
            }

            if (n(t._mainLinePosition) || n(t._mainMirrorPosition)) return !0;
            var i = t._linepositions || {};

            for (var a in i) {
              if (n(i[a][0]) || n(i[a][1])) return !0;
            }
          }

          var u = a._plots[r._mainSubplot];
          if (!(u.mainplotinfo || u).overlays.length) return c(r);

          for (var f = V.list(t, s), h = 0; h < f.length; h++) {
            var p = f[h];
            if (p._mainAxis === i && c(p)) return !0;
          }
        }(t, e, r, n) || function (t, e) {
          for (var r = t._fullData, n = e._mainSubplot, i = e._id.charAt(0), a = 0; a < r.length; a++) {
            var s = r[a];

            if (!0 === s.visible && s.xaxis + s.yaxis === n) {
              if (o.traceIs(s, "bar-like") && s.orientation === {
                x: "h",
                y: "v"
              }[i]) return !0;
              if (s.fill && s.fill.charAt(s.fill.length - 1) === i) return !0;
            }
          }

          return !1;
        }(t, e));
      }, V.clipEnds = function (t, e) {
        return e.filter(function (e) {
          return vt(t, e.x);
        });
      }, V.allowAutoMargin = function (t) {
        for (var e = V.list(t, "", !0), r = 0; r < e.length; r++) {
          var n = e[r];
          n.automargin && (a.allowAutoMargin(t, xt(n)), n.mirror && a.allowAutoMargin(t, bt(n))), o.getComponentMethod("rangeslider", "isVisible")(n) && a.allowAutoMargin(t, _t(n));
        }
      }, V.swap = function (t, e) {
        for (var r = function (t, e) {
          var r,
              n,
              i = [];

          for (r = 0; r < e.length; r++) {
            var a = [],
                o = t._fullData[e[r]].xaxis,
                s = t._fullData[e[r]].yaxis;

            if (o && s) {
              for (n = 0; n < i.length; n++) {
                -1 === i[n].x.indexOf(o) && -1 === i[n].y.indexOf(s) || a.push(n);
              }

              if (a.length) {
                var l,
                    c = i[a[0]];
                if (a.length > 1) for (n = 1; n < a.length; n++) {
                  l = i[a[n]], wt(c.x, l.x), wt(c.y, l.y);
                }
                wt(c.x, [o]), wt(c.y, [s]);
              } else i.push({
                x: [o],
                y: [s]
              });
            }
          }

          return i;
        }(t, e), n = 0; n < r.length; n++) {
          Tt(t, r[n].x, r[n].y);
        }
      };
    }, {
      "../../components/color": 658,
      "../../components/drawing": 680,
      "../../components/titles": 756,
      "../../constants/alignment": 763,
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../../lib/svg_text_utils": 820,
      "../../plots/plots": 909,
      "../../registry": 923,
      "./autorange": 844,
      "./axis_autotype": 846,
      "./axis_ids": 848,
      "./clean_ticks": 850,
      "./layout_attributes": 859,
      "./set_convert": 865,
      "@plotly/d3": 57,
      "fast-isnumeric": 240
    }],
    846: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../lib"),
          a = t("../../constants/numerical").BADNUM,
          o = i.isArrayOrTypedArray,
          s = i.isDateTime,
          l = i.cleanNumber,
          c = Math.round;

      function u(t, e) {
        return e ? n(t) : "number" == typeof t;
      }

      function f(t) {
        return Math.max(1, (t - 1) / 1e3);
      }

      e.exports = function (t, e, r) {
        var i = t,
            h = r.noMultiCategory;
        if (o(i) && !i.length) return "-";
        if (!h && function (t) {
          return o(t[0]) && o(t[1]);
        }(i)) return "multicategory";

        if (h && Array.isArray(i[0])) {
          for (var p = [], d = 0; d < i.length; d++) {
            if (o(i[d])) for (var m = 0; m < i[d].length; m++) {
              p.push(i[d][m]);
            }
          }

          i = p;
        }

        if (function (t, e) {
          for (var r = t.length, i = f(r), a = 0, o = 0, l = {}, u = 0; u < r; u += i) {
            var h = c(u),
                p = t[h],
                d = String(p);
            l[d] || (l[d] = 1, s(p, e) && a++, n(p) && o++);
          }

          return a > 2 * o;
        }(i, e)) return "date";
        var g = "strict" !== r.autotypenumbers;
        return function (t, e) {
          for (var r = t.length, n = f(r), i = 0, o = 0, s = {}, u = 0; u < r; u += n) {
            var h = c(u),
                p = t[h],
                d = String(p);

            if (!s[d]) {
              s[d] = 1;

              var m = _typeof(p);

              "boolean" === m ? o++ : (e ? l(p) !== a : "number" === m) ? i++ : "string" === m && o++;
            }
          }

          return o > 2 * i;
        }(i, g) ? "category" : function (t, e) {
          for (var r = t.length, n = 0; n < r; n++) {
            if (u(t[n], e)) return !0;
          }

          return !1;
        }(i, g) ? "linear" : "-";
      };
    }, {
      "../../constants/numerical": 771,
      "../../lib": 795,
      "fast-isnumeric": 240
    }],
    847: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../registry"),
          a = t("../../lib"),
          o = t("../array_container_defaults"),
          s = t("./layout_attributes"),
          l = t("./tick_value_defaults"),
          c = t("./tick_mark_defaults"),
          u = t("./tick_label_defaults"),
          f = t("./category_order_defaults"),
          h = t("./line_grid_defaults"),
          p = t("./set_convert"),
          d = t("./constants").WEEKDAY_PATTERN,
          m = t("./constants").HOUR_PATTERN;

      function g(t, e, r) {
        function i(r, n) {
          return a.coerce(t, e, s.rangebreaks, r, n);
        }

        if (i("enabled")) {
          var o = i("bounds");

          if (o && o.length >= 2) {
            var l,
                c,
                u = "";
            if (2 === o.length) for (l = 0; l < 2; l++) {
              if (c = y(o[l])) {
                u = d;
                break;
              }
            }
            var f = i("pattern", u);
            if (f === d) for (l = 0; l < 2; l++) {
              (c = y(o[l])) && (e.bounds[l] = o[l] = c - 1);
            }
            if (f) for (l = 0; l < 2; l++) {
              switch (c = o[l], f) {
                case d:
                  if (!n(c)) return void (e.enabled = !1);
                  if ((c = +c) !== Math.floor(c) || c < 0 || c >= 7) return void (e.enabled = !1);
                  e.bounds[l] = o[l] = c;
                  break;

                case m:
                  if (!n(c)) return void (e.enabled = !1);
                  if ((c = +c) < 0 || c > 24) return void (e.enabled = !1);
                  e.bounds[l] = o[l] = c;
              }
            }

            if (!1 === r.autorange) {
              var h = r.range;

              if (h[0] < h[1]) {
                if (o[0] < h[0] && o[1] > h[1]) return void (e.enabled = !1);
              } else if (o[0] > h[0] && o[1] < h[1]) return void (e.enabled = !1);
            }
          } else {
            var p = i("values");
            if (!p || !p.length) return void (e.enabled = !1);
            i("dvalue");
          }
        }
      }

      e.exports = function (t, e, r, n, m) {
        var v,
            y = n.letter,
            x = n.font || {},
            b = n.splomStash || {},
            _ = r("visible", !n.visibleDflt),
            w = e._template || {},
            T = e.type || w.type || "-";

        "date" === T && (i.getComponentMethod("calendars", "handleDefaults")(t, e, "calendar", n.calendar), n.noTicklabelmode || (v = r("ticklabelmode")));
        var k = "";
        n.noTicklabelposition && "multicategory" !== T || (k = a.coerce(t, e, {
          ticklabelposition: {
            valType: "enumerated",
            dflt: "outside",
            values: "period" === v ? ["outside", "inside"] : "x" === y ? ["outside", "inside", "outside left", "inside left", "outside right", "inside right"] : ["outside", "inside", "outside top", "inside top", "outside bottom", "inside bottom"]
          }
        }, "ticklabelposition")), n.noTicklabeloverflow || r("ticklabeloverflow", -1 !== k.indexOf("inside") ? "hide past domain" : "category" === T || "multicategory" === T ? "allow" : "hide past div"), p(e, m);
        var M = !e.isValidRange(t.range);
        M && n.reverseDflt && (M = "reversed"), !r("autorange", M) || "linear" !== T && "-" !== T || r("rangemode"), r("range"), e.cleanRange(), f(t, e, r, n), "category" === T || n.noHover || r("hoverformat");
        var A = r("color"),
            S = A !== s.color.dflt ? A : x.color,
            E = b.label || m._dfltTitle[y];
        if (u(t, e, r, T, n, {
          pass: 1
        }), !_) return e;
        r("title.text", E), a.coerceFont(r, "title.font", {
          family: x.family,
          size: a.bigFont(x.size),
          color: S
        }), l(t, e, r, T), u(t, e, r, T, n, {
          pass: 2
        }), c(t, e, r, n), h(t, e, r, {
          dfltColor: A,
          bgColor: n.bgColor,
          showGrid: n.showGrid,
          attributes: s
        }), (e.showline || e.ticks) && r("mirror"), n.automargin && r("automargin");
        var L,
            C = "multicategory" === T;
        n.noTickson || "category" !== T && !C || !e.ticks && !e.showgrid || (C && (L = "boundaries"), "boundaries" === r("tickson", L) && delete e.ticklabelposition);
        C && r("showdividers") && (r("dividercolor"), r("dividerwidth"));
        if ("date" === T) if (o(t, e, {
          name: "rangebreaks",
          inclusionAttr: "enabled",
          handleItemDefaults: g
        }), e.rangebreaks.length) {
          for (var P = 0; P < e.rangebreaks.length; P++) {
            if (e.rangebreaks[P].pattern === d) {
              e._hasDayOfWeekBreaks = !0;
              break;
            }
          }

          if (p(e, m), m._has("scattergl") || m._has("splom")) for (var I = 0; I < n.data.length; I++) {
            var O = n.data[I];
            "scattergl" !== O.type && "splom" !== O.type || (O.visible = !1, a.warn(O.type + " traces do not work on axes with rangebreaks. Setting trace " + O.index + " to `visible: false`."));
          }
        } else delete e.rangebreaks;
        return e;
      };

      var v = {
        sun: 1,
        mon: 2,
        tue: 3,
        wed: 4,
        thu: 5,
        fri: 6,
        sat: 7
      };

      function y(t) {
        if ("string" == typeof t) return v[t.substr(0, 3).toLowerCase()];
      }
    }, {
      "../../lib": 795,
      "../../registry": 923,
      "../array_container_defaults": 840,
      "./category_order_defaults": 849,
      "./constants": 851,
      "./layout_attributes": 859,
      "./line_grid_defaults": 861,
      "./set_convert": 865,
      "./tick_label_defaults": 866,
      "./tick_mark_defaults": 867,
      "./tick_value_defaults": 868,
      "fast-isnumeric": 240
    }],
    848: [function (t, e, r) {
      "use strict";

      var n = t("../../registry"),
          i = t("./constants");

      function a(t, e) {
        if (e && e.length) for (var r = 0; r < e.length; r++) {
          if (e[r][t]) return !0;
        }
        return !1;
      }

      r.id2name = function (t) {
        if ("string" == typeof t && t.match(i.AX_ID_PATTERN)) {
          var e = t.split(" ")[0].substr(1);
          return "1" === e && (e = ""), t.charAt(0) + "axis" + e;
        }
      }, r.name2id = function (t) {
        if (t.match(i.AX_NAME_PATTERN)) {
          var e = t.substr(5);
          return "1" === e && (e = ""), t.charAt(0) + e;
        }
      }, r.cleanId = function (t, e, r) {
        var n = /( domain)$/.test(t);

        if ("string" == typeof t && t.match(i.AX_ID_PATTERN) && (!e || t.charAt(0) === e) && (!n || r)) {
          var a = t.split(" ")[0].substr(1).replace(/^0+/, "");
          return "1" === a && (a = ""), t.charAt(0) + a + (n && r ? " domain" : "");
        }
      }, r.list = function (t, e, n) {
        var i = t._fullLayout;
        if (!i) return [];
        var a,
            o = r.listIds(t, e),
            s = new Array(o.length);

        for (a = 0; a < o.length; a++) {
          var l = o[a];
          s[a] = i[l.charAt(0) + "axis" + l.substr(1)];
        }

        if (!n) {
          var c = i._subplots.gl3d || [];

          for (a = 0; a < c.length; a++) {
            var u = i[c[a]];
            e ? s.push(u[e + "axis"]) : s.push(u.xaxis, u.yaxis, u.zaxis);
          }
        }

        return s;
      }, r.listIds = function (t, e) {
        var r = t._fullLayout;
        if (!r) return [];
        var n = r._subplots;
        return e ? n[e + "axis"] : n.xaxis.concat(n.yaxis);
      }, r.getFromId = function (t, e, n) {
        var i = t._fullLayout;
        return e = void 0 === e || "string" != typeof e ? e : e.replace(" domain", ""), "x" === n ? e = e.replace(/y[0-9]*/, "") : "y" === n && (e = e.replace(/x[0-9]*/, "")), i[r.id2name(e)];
      }, r.getFromTrace = function (t, e, i) {
        var a = t._fullLayout,
            o = null;

        if (n.traceIs(e, "gl3d")) {
          var s = e.scene;
          "scene" === s.substr(0, 5) && (o = a[s][i + "axis"]);
        } else o = r.getFromId(t, e[i + "axis"] || i);

        return o;
      }, r.idSort = function (t, e) {
        var r = t.charAt(0),
            n = e.charAt(0);
        return r !== n ? r > n ? 1 : -1 : +(t.substr(1) || 1) - +(e.substr(1) || 1);
      }, r.ref2id = function (t) {
        return !!/^[xyz]/.test(t) && t.split(" ")[0];
      }, r.isLinked = function (t, e) {
        return a(e, t._axisMatchGroups) || a(e, t._axisConstraintGroups);
      };
    }, {
      "../../registry": 923,
      "./constants": 851
    }],
    849: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, n) {
        if ("category" === e.type) {
          var i,
              a = t.categoryarray,
              o = Array.isArray(a) && a.length > 0;
          o && (i = "array");
          var s,
              l = r("categoryorder", i);
          "array" === l && (s = r("categoryarray")), o || "array" !== l || (l = e.categoryorder = "trace"), "trace" === l ? e._initialCategories = [] : "array" === l ? e._initialCategories = s.slice() : (s = function (t, e) {
            var r,
                n,
                i,
                a = e.dataAttr || t._id.charAt(0),
                o = {};

            if (e.axData) r = e.axData;else for (r = [], n = 0; n < e.data.length; n++) {
              var s = e.data[n];
              s[a + "axis"] === t._id && r.push(s);
            }

            for (n = 0; n < r.length; n++) {
              var l = r[n][a];

              for (i = 0; i < l.length; i++) {
                var c = l[i];
                null != c && (o[c] = 1);
              }
            }

            return Object.keys(o);
          }(e, n).sort(), "category ascending" === l ? e._initialCategories = s : "category descending" === l && (e._initialCategories = s.reverse()));
        }
      };
    }, {}],
    850: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../lib"),
          a = t("../../constants/numerical"),
          o = a.ONEDAY,
          s = a.ONEWEEK;
      r.dtick = function (t, e) {
        var r = "log" === e,
            i = "date" === e,
            a = "category" === e,
            s = i ? o : 1;
        if (!t) return s;
        if (n(t)) return (t = Number(t)) <= 0 ? s : a ? Math.max(1, Math.round(t)) : i ? Math.max(.1, t) : t;
        if ("string" != typeof t || !i && !r) return s;
        var l = t.charAt(0),
            c = t.substr(1);
        return (c = n(c) ? Number(c) : 0) <= 0 || !(i && "M" === l && c === Math.round(c) || r && "L" === l || r && "D" === l && (1 === c || 2 === c)) ? s : t;
      }, r.tick0 = function (t, e, r, a) {
        return "date" === e ? i.cleanDate(t, i.dateTick0(r, a % s == 0 ? 1 : 0)) : "D1" !== a && "D2" !== a ? n(t) ? Number(t) : 0 : void 0;
      };
    }, {
      "../../constants/numerical": 771,
      "../../lib": 795,
      "fast-isnumeric": 240
    }],
    851: [function (t, e, r) {
      "use strict";

      var n = t("../../lib/regex").counter;
      e.exports = {
        idRegex: {
          x: n("x", "( domain)?"),
          y: n("y", "( domain)?")
        },
        attrRegex: n("[xy]axis"),
        xAxisMatch: n("xaxis"),
        yAxisMatch: n("yaxis"),
        AX_ID_PATTERN: /^[xyz][0-9]*( domain)?$/,
        AX_NAME_PATTERN: /^[xyz]axis[0-9]*$/,
        SUBPLOT_PATTERN: /^x([0-9]*)y([0-9]*)$/,
        HOUR_PATTERN: "hour",
        WEEKDAY_PATTERN: "day of week",
        MINDRAG: 8,
        MINSELECT: 12,
        MINZOOM: 20,
        DRAGGERSIZE: 20,
        BENDPX: 1.5,
        REDRAWDELAY: 50,
        SELECTDELAY: 100,
        SELECTID: "-select",
        DFLTRANGEX: [-1, 6],
        DFLTRANGEY: [-1, 4],
        traceLayerClasses: ["imagelayer", "heatmaplayer", "contourcarpetlayer", "contourlayer", "funnellayer", "waterfalllayer", "barlayer", "carpetlayer", "violinlayer", "boxlayer", "ohlclayer", "scattercarpetlayer", "scatterlayer"],
        clipOnAxisFalseQuery: [".scatterlayer", ".barlayer", ".funnellayer", ".waterfalllayer"],
        layerValue2layerClass: {
          "above traces": "above",
          "below traces": "below"
        }
      };
    }, {
      "../../lib/regex": 812
    }],
    852: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./autorange"),
          a = t("./axis_ids").id2name,
          o = t("./layout_attributes"),
          s = t("./scale_zoom"),
          l = t("./set_convert"),
          c = t("../../constants/numerical").ALMOST_EQUAL,
          u = t("../../constants/alignment").FROM_BL;

      function f(t, e, r) {
        var i = r.axIds,
            s = r.layoutOut,
            l = r.hasImage,
            c = s._axisConstraintGroups,
            u = s._axisMatchGroups,
            f = e._id,
            m = f.charAt(0),
            g = ((s._splomAxes || {})[m] || {})[f] || {},
            v = e._id,
            y = "x" === v.charAt(0);

        function x(r, i) {
          return n.coerce(t, e, o, r, i);
        }

        e._matchGroup = null, e._constraintGroup = null, x("constrain", l ? "domain" : "range"), n.coerce(t, e, {
          constraintoward: {
            valType: "enumerated",
            values: y ? ["left", "center", "right"] : ["bottom", "middle", "top"],
            dflt: y ? "center" : "middle"
          }
        }, "constraintoward");

        var b,
            _,
            w = e.type,
            T = [];

        for (b = 0; b < i.length; b++) {
          if ((_ = i[b]) !== v) s[a(_)].type === w && T.push(_);
        }

        var k = p(c, v);

        if (k) {
          var M = [];

          for (b = 0; b < T.length; b++) {
            k[_ = T[b]] || M.push(_);
          }

          T = M;
        }

        var A,
            S,
            E = T.length;
        E && (t.matches || g.matches) && (A = n.coerce(t, e, {
          matches: {
            valType: "enumerated",
            values: T,
            dflt: -1 !== T.indexOf(g.matches) ? g.matches : void 0
          }
        }, "matches"));
        var L = l && !y ? e.anchor : void 0;

        if (E && !A && (t.scaleanchor || L) && (S = n.coerce(t, e, {
          scaleanchor: {
            valType: "enumerated",
            values: T
          }
        }, "scaleanchor", L)), A) {
          e._matchGroup = d(u, v, A, 1);
          var C = s[a(A)],
              P = h(s, e) / h(s, C);
          y !== ("x" === A.charAt(0)) && (P = (y ? "x" : "y") + P), d(c, v, A, P);
        } else t.matches && -1 !== i.indexOf(t.matches) && n.warn("ignored " + e._name + '.matches: "' + t.matches + '" to avoid an infinite loop');

        if (S) {
          var I = x("scaleratio");
          I || (I = e.scaleratio = 1), d(c, v, S, I);
        } else t.scaleanchor && -1 !== i.indexOf(t.scaleanchor) && n.warn("ignored " + e._name + '.scaleanchor: "' + t.scaleanchor + '" to avoid either an infinite loop and possibly inconsistent scaleratios, or because this axis declares a *matches* constraint.');
      }

      function h(t, e) {
        var r = e.domain;
        return r || (r = t[a(e.overlaying)].domain), r[1] - r[0];
      }

      function p(t, e) {
        for (var r = 0; r < t.length; r++) {
          if (t[r][e]) return t[r];
        }

        return null;
      }

      function d(t, e, r, n) {
        var i,
            a,
            o,
            s,
            l,
            c = p(t, e);
        null === c ? ((c = {})[e] = 1, l = t.length, t.push(c)) : l = t.indexOf(c);
        var u = Object.keys(c);

        for (i = 0; i < t.length; i++) {
          if (o = t[i], i !== l && o[r]) {
            var f = o[r];

            for (a = 0; a < u.length; a++) {
              o[s = u[a]] = m(f, m(n, c[s]));
            }

            return void t.splice(l, 1);
          }
        }

        if (1 !== n) for (a = 0; a < u.length; a++) {
          var h = u[a];
          c[h] = m(n, c[h]);
        }
        c[r] = 1;
      }

      function m(t, e) {
        var r,
            n,
            i = "",
            a = "";
        "string" == typeof t && (r = (i = t.match(/^[xy]*/)[0]).length, t = +t.substr(r)), "string" == typeof e && (n = (a = e.match(/^[xy]*/)[0]).length, e = +e.substr(n));
        var o = t * e;
        return r || n ? r && n && i.charAt(0) !== a.charAt(0) ? r === n ? o : (r > n ? i.substr(n) : a.substr(r)) + o : i + a + t * e : o;
      }

      function g(t, e) {
        for (var r = e._size, n = r.h / r.w, i = {}, a = Object.keys(t), o = 0; o < a.length; o++) {
          var s = a[o],
              l = t[s];

          if ("string" == typeof l) {
            var c = l.match(/^[xy]*/)[0],
                u = c.length;
            l = +l.substr(u);

            for (var f = "y" === c.charAt(0) ? n : 1 / n, h = 0; h < u; h++) {
              l *= f;
            }
          }

          i[s] = l;
        }

        return i;
      }

      function v(t, e) {
        var r = t._inputDomain,
            n = u[t.constraintoward],
            i = r[0] + (r[1] - r[0]) * n;
        t.domain = t._input.domain = [i + (r[0] - i) / e, i + (r[1] - i) / e], t.setScale();
      }

      r.handleDefaults = function (t, e, r) {
        var i,
            o,
            s,
            c,
            u,
            h,
            p,
            d,
            m = r.axIds,
            g = r.axHasImage,
            v = e._axisConstraintGroups = [],
            y = e._axisMatchGroups = [];

        for (i = 0; i < m.length; i++) {
          f(u = t[c = a(m[i])], h = e[c], {
            axIds: m,
            layoutOut: e,
            hasImage: g[c]
          });
        }

        function x(t, r) {
          for (i = 0; i < t.length; i++) {
            for (s in o = t[i]) {
              e[a(s)][r] = o;
            }
          }
        }

        for (x(y, "_matchGroup"), i = 0; i < v.length; i++) {
          for (s in o = v[i]) {
            if ((h = e[a(s)]).fixedrange) {
              for (var b in o) {
                var _ = a(b);

                !1 === (t[_] || {}).fixedrange && n.warn("fixedrange was specified as false for axis " + _ + " but was overridden because another axis in its constraint group has fixedrange true"), e[_].fixedrange = !0;
              }

              break;
            }
          }
        }

        for (i = 0; i < v.length;) {
          for (s in o = v[i]) {
            (h = e[a(s)])._matchGroup && Object.keys(h._matchGroup).length === Object.keys(o).length && (v.splice(i, 1), i--);
            break;
          }

          i++;
        }

        x(v, "_constraintGroup");
        var w = ["constrain", "range", "autorange", "rangemode", "rangebreaks", "categoryorder", "categoryarray"],
            T = !1,
            k = !1;

        function M() {
          d = h[p], "rangebreaks" === p && (k = h._hasDayOfWeekBreaks);
        }

        for (i = 0; i < y.length; i++) {
          o = y[i];

          for (var A = 0; A < w.length; A++) {
            var S;

            for (s in p = w[A], d = null, o) {
              if (u = t[c = a(s)], h = e[c], p in h) {
                if (!h.matches && (S = h, p in u)) {
                  M();
                  break;
                }

                null === d && p in u && M();
              }
            }

            if ("range" === p && d && (T = !0), "autorange" === p && null === d && T && (d = !1), null === d && p in S && (d = S[p]), null !== d) for (s in o) {
              (h = e[a(s)])[p] = "range" === p ? d.slice() : d, "rangebreaks" === p && (h._hasDayOfWeekBreaks = k, l(h, e));
            }
          }
        }
      }, r.enforce = function (t) {
        var e,
            r,
            n,
            o,
            l,
            u,
            f,
            h,
            p = t._fullLayout,
            d = p._axisConstraintGroups || [];

        for (e = 0; e < d.length; e++) {
          n = g(d[e], p);
          var m = Object.keys(n),
              y = 1 / 0,
              x = 0,
              b = 1 / 0,
              _ = {},
              w = {},
              T = !1;

          for (r = 0; r < m.length; r++) {
            w[o = m[r]] = l = p[a(o)], l._inputDomain ? l.domain = l._inputDomain.slice() : l._inputDomain = l.domain.slice(), l._inputRange || (l._inputRange = l.range.slice()), l.setScale(), _[o] = u = Math.abs(l._m) / n[o], y = Math.min(y, u), "domain" !== l.constrain && l._constraintShrinkable || (b = Math.min(b, u)), delete l._constraintShrinkable, x = Math.max(x, u), "domain" === l.constrain && (T = !0);
          }

          if (!(y > c * x) || T) for (r = 0; r < m.length; r++) {
            if (u = _[o = m[r]], f = (l = w[o]).constrain, u !== b || "domain" === f) if (h = u / b, "range" === f) s(l, h);else {
              var k = l._inputDomain,
                  M = (l.domain[1] - l.domain[0]) / (k[1] - k[0]),
                  A = (l.r2l(l.range[1]) - l.r2l(l.range[0])) / (l.r2l(l._inputRange[1]) - l.r2l(l._inputRange[0]));

              if ((h /= M) * A < 1) {
                l.domain = l._input.domain = k.slice(), s(l, h);
                continue;
              }

              if (A < 1 && (l.range = l._input.range = l._inputRange.slice(), h *= A), l.autorange) {
                var S = l.r2l(l.range[0]),
                    E = l.r2l(l.range[1]),
                    L = (S + E) / 2,
                    C = L,
                    P = L,
                    I = Math.abs(E - L),
                    O = L - I * h * 1.0001,
                    z = L + I * h * 1.0001,
                    D = i.makePadFn(p, l, 0),
                    R = i.makePadFn(p, l, 1);
                v(l, h);
                var F,
                    B,
                    N = Math.abs(l._m),
                    j = i.concatExtremes(t, l),
                    U = j.min,
                    V = j.max;

                for (B = 0; B < U.length; B++) {
                  (F = U[B].val - D(U[B]) / N) > O && F < C && (C = F);
                }

                for (B = 0; B < V.length; B++) {
                  (F = V[B].val + R(V[B]) / N) < z && F > P && (P = F);
                }

                h /= (P - C) / (2 * I), C = l.l2r(C), P = l.l2r(P), l.range = l._input.range = S < E ? [C, P] : [P, C];
              }

              v(l, h);
            }
          }
        }
      }, r.getAxisGroup = function (t, e) {
        for (var r = t._axisMatchGroups, n = 0; n < r.length; n++) {
          if (r[n][e]) return "g" + n;
        }

        return e;
      }, r.clean = function (t, e) {
        if (e._inputDomain) {
          for (var r = !1, n = e._id, i = t._fullLayout._axisConstraintGroups, a = 0; a < i.length; a++) {
            if (i[a][n]) {
              r = !0;
              break;
            }
          }

          r && "domain" === e.constrain || (e._input.domain = e.domain = e._inputDomain, delete e._inputDomain);
        }
      };
    }, {
      "../../constants/alignment": 763,
      "../../constants/numerical": 771,
      "../../lib": 795,
      "./autorange": 844,
      "./axis_ids": 848,
      "./layout_attributes": 859,
      "./scale_zoom": 863,
      "./set_convert": 865
    }],
    853: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("tinycolor2"),
          a = t("has-passive-events"),
          o = t("../../registry"),
          s = t("../../lib"),
          l = s.strTranslate,
          c = t("../../lib/svg_text_utils"),
          u = t("../../components/color"),
          f = t("../../components/drawing"),
          h = t("../../components/fx"),
          p = t("./axes"),
          d = t("../../lib/setcursor"),
          m = t("../../components/dragelement"),
          g = t("../../components/dragelement/helpers"),
          v = g.selectingOrDrawing,
          y = g.freeMode,
          x = t("../../constants/alignment").FROM_TL,
          b = t("../../lib/clear_gl_canvases"),
          _ = t("../../plot_api/subroutines").redrawReglTraces,
          w = t("../plots"),
          T = t("./axis_ids").getFromId,
          k = t("./select").prepSelect,
          M = t("./select").clearSelect,
          A = t("./select").selectOnClick,
          S = t("./scale_zoom"),
          E = t("./constants"),
          L = E.MINDRAG,
          C = E.MINZOOM,
          P = !0;

      function I(t, e, r, n) {
        var i = s.ensureSingle(t.draglayer, e, r, function (e) {
          e.classed("drag", !0).style({
            fill: "transparent",
            "stroke-width": 0
          }).attr("data-subplot", t.id);
        });
        return i.call(d, n), i.node();
      }

      function O(t, e, r, i, a, o, s) {
        var l = I(t, "rect", e, r);
        return n.select(l).call(f.setRect, i, a, o, s), l;
      }

      function z(t, e) {
        for (var r = 0; r < t.length; r++) {
          if (!t[r].fixedrange) return e;
        }

        return "";
      }

      function D(t, e, r, n, i) {
        for (var a = 0; a < t.length; a++) {
          var o = t[a];
          if (!o.fixedrange) if (o.rangebreaks) {
            var s = "y" === o._id.charAt(0),
                l = s ? 1 - e : e,
                c = s ? 1 - r : r;

            n[o._name + ".range[0]"] = o.l2r(o.p2l(l * o._length)), n[o._name + ".range[1]"] = o.l2r(o.p2l(c * o._length));
          } else {
            var u = o._rl[0],
                f = o._rl[1] - u;
            n[o._name + ".range[0]"] = o.l2r(u + f * e), n[o._name + ".range[1]"] = o.l2r(u + f * r);
          }
        }

        if (i && i.length) {
          var h = (e + (1 - r)) / 2;
          D(i, h, 1 - h, n, []);
        }
      }

      function R(t, e) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          if (!n.fixedrange) if (n.rangebreaks) {
            var i = n._length,
                a = (n.p2l(0 + e) - n.p2l(0) + (n.p2l(i + e) - n.p2l(i))) / 2;
            n.range = [n.l2r(n._rl[0] - a), n.l2r(n._rl[1] - a)];
          } else n.range = [n.l2r(n._rl[0] - e / n._m), n.l2r(n._rl[1] - e / n._m)];
        }
      }

      function F(t) {
        return 1 - (t >= 0 ? Math.min(t, .9) : 1 / (1 / Math.max(t, -.3) + 3.222));
      }

      function B(t, e, r, n, i) {
        return t.append("path").attr("class", "zoombox").style({
          fill: e > .2 ? "rgba(0,0,0,0)" : "rgba(255,255,255,0)",
          "stroke-width": 0
        }).attr("transform", l(r, n)).attr("d", i + "Z");
      }

      function N(t, e, r) {
        return t.append("path").attr("class", "zoombox-corners").style({
          fill: u.background,
          stroke: u.defaultLine,
          "stroke-width": 1,
          opacity: 0
        }).attr("transform", l(e, r)).attr("d", "M0,0Z");
      }

      function j(t, e, r, n, i, a) {
        t.attr("d", n + "M" + r.l + "," + r.t + "v" + r.h + "h" + r.w + "v-" + r.h + "h-" + r.w + "Z"), U(t, e, i, a);
      }

      function U(t, e, r, n) {
        r || (t.transition().style("fill", n > .2 ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.3)").duration(200), e.transition().style("opacity", 1).duration(200));
      }

      function V(t) {
        n.select(t).selectAll(".zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners").remove();
      }

      function q(t) {
        P && t.data && t._context.showTips && (s.notifier(s._(t, "Double-click to zoom back out"), "long"), P = !1);
      }

      function H(t) {
        var e = Math.floor(Math.min(t.b - t.t, t.r - t.l, C) / 2);
        return "M" + (t.l - 3.5) + "," + (t.t - .5 + e) + "h3v" + -e + "h" + e + "v-3h-" + (e + 3) + "ZM" + (t.r + 3.5) + "," + (t.t - .5 + e) + "h-3v" + -e + "h" + -e + "v-3h" + (e + 3) + "ZM" + (t.r + 3.5) + "," + (t.b + .5 - e) + "h-3v" + e + "h" + -e + "v3h" + (e + 3) + "ZM" + (t.l - 3.5) + "," + (t.b + .5 - e) + "h3v" + e + "h" + e + "v3h-" + (e + 3) + "Z";
      }

      function G(t, e, r, n, i) {
        for (var a, o, l, c, u = !1, f = {}, h = {}, p = (i || {}).xaHash, d = (i || {}).yaHash, m = 0; m < e.length; m++) {
          var g = e[m];

          for (a in r) {
            if (g[a]) {
              for (l in g) {
                i && (p[l] || d[l]) || ("x" === l.charAt(0) ? r : n)[l] || (f[l] = a);
              }

              for (o in n) {
                i && (p[o] || d[o]) || !g[o] || (u = !0);
              }
            }
          }

          for (o in n) {
            if (g[o]) for (c in g) {
              i && (p[c] || d[c]) || ("x" === c.charAt(0) ? r : n)[c] || (h[c] = o);
            }
          }
        }

        u && (s.extendFlat(f, h), h = {});
        var v = {},
            y = [];

        for (l in f) {
          var x = T(t, l);
          y.push(x), v[x._id] = x;
        }

        var b = {},
            _ = [];

        for (c in h) {
          var w = T(t, c);
          _.push(w), b[w._id] = w;
        }

        return {
          xaHash: v,
          yaHash: b,
          xaxes: y,
          yaxes: _,
          xLinks: f,
          yLinks: h,
          isSubplotConstrained: u
        };
      }

      function Y(t, e) {
        if (a) {
          var r = void 0 !== t.onwheel ? "wheel" : "mousewheel";
          t._onwheel && t.removeEventListener(r, t._onwheel), t._onwheel = e, t.addEventListener(r, e, {
            passive: !1
          });
        } else void 0 !== t.onwheel ? t.onwheel = e : void 0 !== t.onmousewheel ? t.onmousewheel = e : t.isAddedWheelEvent || (t.isAddedWheelEvent = !0, t.addEventListener("wheel", e, {
          passive: !1
        }));
      }

      function W(t) {
        var e = [];

        for (var r in t) {
          e.push(t[r]);
        }

        return e;
      }

      e.exports = {
        makeDragBox: function makeDragBox(t, e, r, a, l, u, d, g) {
          var P,
              I,
              U,
              X,
              Z,
              J,
              K,
              Q,
              $,
              tt,
              et,
              rt,
              nt,
              it,
              at,
              ot,
              st,
              lt,
              ct,
              ut,
              ft,
              ht,
              pt,
              dt = t._fullLayout._zoomlayer,
              mt = d + g === "nsew",
              gt = 1 === (d + g).length;

          function vt() {
            if (P = e.xaxis, I = e.yaxis, $ = P._length, tt = I._length, K = P._offset, Q = I._offset, (U = {})[P._id] = P, (X = {})[I._id] = I, d && g) for (var r = e.overlays, n = 0; n < r.length; n++) {
              var i = r[n].xaxis;
              U[i._id] = i;
              var a = r[n].yaxis;
              X[a._id] = a;
            }
            Z = W(U), J = W(X), nt = z(Z, g), it = z(J, d), at = !it && !nt, rt = G(t, t._fullLayout._axisMatchGroups, U, X);
            var o = (et = G(t, t._fullLayout._axisConstraintGroups, U, X, rt)).isSubplotConstrained || rt.isSubplotConstrained;
            ot = g || o, st = d || o;
            var s = t._fullLayout;
            lt = s._has("scattergl"), ct = s._has("splom"), ut = s._has("svg");
          }

          vt();

          var yt = function (t, e, r) {
            if (!t) return "pointer";
            if ("nsew" === t) return r ? "" : "pan" === e ? "move" : "crosshair";
            return t.toLowerCase() + "-resize";
          }(it + nt, t._fullLayout.dragmode, mt),
              xt = O(e, d + g + "drag", yt, r, a, l, u);

          if (at && !mt) return xt.onmousedown = null, xt.style.pointerEvents = "none", xt;

          var bt,
              _t,
              wt,
              Tt,
              kt,
              Mt,
              At,
              St,
              Et,
              Lt,
              Ct = {
            element: xt,
            gd: t,
            plotinfo: e
          };

          function Pt() {
            Ct.plotinfo.selection = !1, M(t);
          }

          function It(t, r) {
            var i = Ct.gd;
            if (i._fullLayout._activeShapeIndex >= 0) i._fullLayout._deactivateShape(i);else {
              var a = i._fullLayout.clickmode;
              if (V(i), 2 !== t || gt || qt(), mt) a.indexOf("select") > -1 && A(r, i, Z, J, e.id, Ct), a.indexOf("event") > -1 && h.click(i, r, e.id);else if (1 === t && gt) {
                var s = d ? I : P,
                    l = "s" === d || "w" === g ? 0 : 1,
                    u = s._name + ".range[" + l + "]",
                    f = function (t, e) {
                  var r,
                      i = t.range[e],
                      a = Math.abs(i - t.range[1 - e]);
                  return "date" === t.type ? i : "log" === t.type ? (r = Math.ceil(Math.max(0, -Math.log(a) / Math.LN10)) + 3, n.format("." + r + "g")(Math.pow(10, i))) : (r = Math.floor(Math.log(Math.abs(i)) / Math.LN10) - Math.floor(Math.log(a) / Math.LN10) + 4, n.format("." + String(r) + "g")(i));
                }(s, l),
                    p = "left",
                    m = "middle";

                if (s.fixedrange) return;
                d ? (m = "n" === d ? "top" : "bottom", "right" === s.side && (p = "right")) : "e" === g && (p = "right"), i._context.showAxisRangeEntryBoxes && n.select(xt).call(c.makeEditable, {
                  gd: i,
                  immediate: !0,
                  background: i._fullLayout.paper_bgcolor,
                  text: String(f),
                  fill: s.tickfont ? s.tickfont.color : "#444",
                  horizontalAlign: p,
                  verticalAlign: m
                }).on("edit", function (t) {
                  var e = s.d2r(t);
                  void 0 !== e && o.call("_guiRelayout", i, u, e);
                });
              }
            }
          }

          function Ot(e, r) {
            if (t._transitioningWithDuration) return !1;
            var n = Math.max(0, Math.min($, ht * e + bt)),
                i = Math.max(0, Math.min(tt, pt * r + _t)),
                a = Math.abs(n - bt),
                o = Math.abs(i - _t);

            function s() {
              At = "", wt.r = wt.l, wt.t = wt.b, Et.attr("d", "M0,0Z");
            }

            if (wt.l = Math.min(bt, n), wt.r = Math.max(bt, n), wt.t = Math.min(_t, i), wt.b = Math.max(_t, i), et.isSubplotConstrained) a > C || o > C ? (At = "xy", a / $ > o / tt ? (o = a * tt / $, _t > i ? wt.t = _t - o : wt.b = _t + o) : (a = o * $ / tt, bt > n ? wt.l = bt - a : wt.r = bt + a), Et.attr("d", H(wt))) : s();else if (rt.isSubplotConstrained) {
              if (a > C || o > C) {
                At = "xy";
                var l = Math.min(wt.l / $, (tt - wt.b) / tt),
                    c = Math.max(wt.r / $, (tt - wt.t) / tt);
                wt.l = l * $, wt.r = c * $, wt.b = (1 - l) * tt, wt.t = (1 - c) * tt, Et.attr("d", H(wt));
              } else s();
            } else !it || o < Math.min(Math.max(.6 * a, L), C) ? a < L || !nt ? s() : (wt.t = 0, wt.b = tt, At = "x", Et.attr("d", function (t, e) {
              return "M" + (t.l - .5) + "," + (e - C - .5) + "h-3v" + (2 * C + 1) + "h3ZM" + (t.r + .5) + "," + (e - C - .5) + "h3v" + (2 * C + 1) + "h-3Z";
            }(wt, _t))) : !nt || a < Math.min(.6 * o, C) ? (wt.l = 0, wt.r = $, At = "y", Et.attr("d", function (t, e) {
              return "M" + (e - C - .5) + "," + (t.t - .5) + "v-3h" + (2 * C + 1) + "v3ZM" + (e - C - .5) + "," + (t.b + .5) + "v3h" + (2 * C + 1) + "v-3Z";
            }(wt, bt))) : (At = "xy", Et.attr("d", H(wt)));
            wt.w = wt.r - wt.l, wt.h = wt.b - wt.t, At && (Lt = !0), t._dragged = Lt, j(St, Et, wt, kt, Mt, Tt), zt(), t.emit("plotly_relayouting", ft), Mt = !0;
          }

          function zt() {
            ft = {}, "xy" !== At && "x" !== At || (D(Z, wt.l / $, wt.r / $, ft, et.xaxes), Ut("x", ft)), "xy" !== At && "y" !== At || (D(J, (tt - wt.b) / tt, (tt - wt.t) / tt, ft, et.yaxes), Ut("y", ft));
          }

          function Dt() {
            zt(), V(t), Ht(), q(t);
          }

          Ct.prepFn = function (e, r, n) {
            var a = Ct.dragmode,
                o = t._fullLayout.dragmode;
            o !== a && (Ct.dragmode = o), vt(), ht = t._fullLayout._invScaleX, pt = t._fullLayout._invScaleY, at || (mt ? e.shiftKey ? "pan" === o ? o = "zoom" : v(o) || (o = "pan") : e.ctrlKey && (o = "pan") : o = "pan"), y(o) ? Ct.minDrag = 1 : Ct.minDrag = void 0, v(o) ? (Ct.xaxes = Z, Ct.yaxes = J, k(e, r, n, Ct, o)) : (Ct.clickFn = It, v(a) && Pt(), at || ("zoom" === o ? (Ct.moveFn = Ot, Ct.doneFn = Dt, Ct.minDrag = 1, function (e, r, n) {
              var a = xt.getBoundingClientRect();
              bt = r - a.left, _t = n - a.top, t._fullLayout._calcInverseTransform(t);
              var o = s.apply3DTransform(t._fullLayout._invTransform)(bt, _t);
              bt = o[0], _t = o[1], wt = {
                l: bt,
                r: bt,
                w: 0,
                t: _t,
                b: _t,
                h: 0
              }, Tt = t._hmpixcount ? t._hmlumcount / t._hmpixcount : i(t._fullLayout.plot_bgcolor).getLuminance(), Mt = !1, At = "xy", Lt = !1, St = B(dt, Tt, K, Q, kt = "M0,0H" + $ + "V" + tt + "H0V0"), Et = N(dt, K, Q);
            }(0, r, n)) : "pan" === o && (Ct.moveFn = jt, Ct.doneFn = Ht))), t._fullLayout._redrag = function () {
              var e = t._dragdata;

              if (e && e.element === xt) {
                var r = t._fullLayout.dragmode;
                v(r) || (vt(), Gt([0, 0, $, tt]), Ct.moveFn(e.dx, e.dy));
              }
            };
          }, m.init(Ct);
          var Rt = [0, 0, $, tt],
              Ft = null,
              Bt = E.REDRAWDELAY,
              Nt = e.mainplot ? t._fullLayout._plots[e.mainplot] : e;

          function jt(e, r) {
            if (e *= ht, r *= pt, !t._transitioningWithDuration) {
              if (t._fullLayout._replotting = !0, "ew" === nt || "ns" === it) {
                var n = nt ? -e : 0,
                    i = it ? -r : 0;

                if (rt.isSubplotConstrained) {
                  if (nt && it) {
                    var a = (e / $ - r / tt) / 2;
                    n = -(e = a * $), i = -(r = -a * tt);
                  }

                  it ? n = -i * $ / tt : i = -n * tt / $;
                }

                return nt && (R(Z, e), Ut("x")), it && (R(J, r), Ut("y")), Gt([n, i, $, tt]), Vt(), void t.emit("plotly_relayouting", ft);
              }

              var o,
                  s,
                  l = "w" === nt == ("n" === it) ? 1 : -1;

              if (nt && it && (et.isSubplotConstrained || rt.isSubplotConstrained)) {
                var c = (e / $ + l * r / tt) / 2;
                e = c * $, r = l * c * tt;
              }

              if ("w" === nt ? e = p(Z, 0, e) : "e" === nt ? e = p(Z, 1, -e) : nt || (e = 0), "n" === it ? r = p(J, 1, r) : "s" === it ? r = p(J, 0, -r) : it || (r = 0), o = "w" === nt ? e : 0, s = "n" === it ? r : 0, et.isSubplotConstrained && !rt.isSubplotConstrained || rt.isSubplotConstrained && nt && it && l > 0) {
                var u;

                if (rt.isSubplotConstrained || !nt && 1 === it.length) {
                  for (u = 0; u < Z.length; u++) {
                    Z[u].range = Z[u]._r.slice(), S(Z[u], 1 - r / tt);
                  }

                  o = (e = r * $ / tt) / 2;
                }

                if (rt.isSubplotConstrained || !it && 1 === nt.length) {
                  for (u = 0; u < J.length; u++) {
                    J[u].range = J[u]._r.slice(), S(J[u], 1 - e / $);
                  }

                  s = (r = e * tt / $) / 2;
                }
              }

              rt.isSubplotConstrained && it || Ut("x"), rt.isSubplotConstrained && nt || Ut("y");
              var f = $ - e,
                  h = tt - r;
              !rt.isSubplotConstrained || nt && it || (nt ? (s = o ? 0 : e * tt / $, h = f * tt / $) : (o = s ? 0 : r * $ / tt, f = h * $ / tt)), Gt([o, s, f, h]), Vt(), t.emit("plotly_relayouting", ft);
            }

            function p(t, e, r) {
              for (var n, i, a = 1 - e, o = 0; o < t.length; o++) {
                var s = t[o];

                if (!s.fixedrange) {
                  n = s, i = s._rl[a] + (s._rl[e] - s._rl[a]) / F(r / s._length);
                  var l = s.l2r(i);
                  !1 !== l && void 0 !== l && (s.range[e] = l);
                }
              }

              return n._length * (n._rl[e] - i) / (n._rl[e] - n._rl[a]);
            }
          }

          function Ut(t, e) {
            for (var r = rt.isSubplotConstrained ? {
              x: J,
              y: Z
            }[t] : rt[t + "axes"], n = rt.isSubplotConstrained ? {
              x: Z,
              y: J
            }[t] : [], i = 0; i < r.length; i++) {
              var a = r[i],
                  o = a._id,
                  s = rt.xLinks[o] || rt.yLinks[o],
                  l = n[0] || U[s] || X[s];
              l && (e ? (e[a._name + ".range[0]"] = e[l._name + ".range[0]"], e[a._name + ".range[1]"] = e[l._name + ".range[1]"]) : a.range = l.range.slice());
            }
          }

          function Vt() {
            var e,
                r = [];

            function n(t) {
              for (e = 0; e < t.length; e++) {
                t[e].fixedrange || r.push(t[e]._id);
              }
            }

            for (ot && (n(Z), n(et.xaxes), n(rt.xaxes)), st && (n(J), n(et.yaxes), n(rt.yaxes)), ft = {}, e = 0; e < r.length; e++) {
              var i = r[e],
                  a = T(t, i);
              p.drawOne(t, a, {
                skipTitle: !0
              }), ft[a._name + ".range[0]"] = a.range[0], ft[a._name + ".range[1]"] = a.range[1];
            }

            p.redrawComponents(t, r);
          }

          function qt() {
            if (!t._transitioningWithDuration) {
              var e = t._context.doubleClick,
                  r = [];
              nt && (r = r.concat(Z)), it && (r = r.concat(J)), rt.xaxes && (r = r.concat(rt.xaxes)), rt.yaxes && (r = r.concat(rt.yaxes));
              var n,
                  i,
                  a,
                  s = {};
              if ("reset+autosize" === e) for (e = "autosize", i = 0; i < r.length; i++) {
                if ((n = r[i])._rangeInitial && (n.range[0] !== n._rangeInitial[0] || n.range[1] !== n._rangeInitial[1]) || !n._rangeInitial && !n.autorange) {
                  e = "reset";
                  break;
                }
              }
              if ("autosize" === e) for (i = 0; i < r.length; i++) {
                (n = r[i]).fixedrange || (s[n._name + ".autorange"] = !0);
              } else if ("reset" === e) for ((nt || et.isSubplotConstrained) && (r = r.concat(et.xaxes)), it && !et.isSubplotConstrained && (r = r.concat(et.yaxes)), et.isSubplotConstrained && (nt ? it || (r = r.concat(J)) : r = r.concat(Z)), i = 0; i < r.length; i++) {
                (n = r[i]).fixedrange || (n._rangeInitial ? (a = n._rangeInitial, s[n._name + ".range[0]"] = a[0], s[n._name + ".range[1]"] = a[1]) : s[n._name + ".autorange"] = !0);
              }
              t.emit("plotly_doubleclick", null), o.call("_guiRelayout", t, s);
            }
          }

          function Ht() {
            Gt([0, 0, $, tt]), s.syncOrAsync([w.previousPromises, function () {
              t._fullLayout._replotting = !1, o.call("_guiRelayout", t, ft);
            }], t);
          }

          function Gt(e) {
            var r,
                n,
                i,
                a,
                l = t._fullLayout,
                c = l._plots,
                u = l._subplots.cartesian;
            if (ct && o.subplotsRegistry.splom.drag(t), lt) for (r = 0; r < u.length; r++) {
              if (i = (n = c[u[r]]).xaxis, a = n.yaxis, n._scene) {
                var h = s.simpleMap(i.range, i.r2l),
                    p = s.simpleMap(a.range, a.r2l);

                n._scene.update({
                  range: [h[0], p[0], h[1], p[1]]
                });
              }
            }

            if ((ct || lt) && (b(t), _(t)), ut) {
              var m = e[2] / P._length,
                  v = e[3] / I._length;

              for (r = 0; r < u.length; r++) {
                i = (n = c[u[r]]).xaxis, a = n.yaxis;
                var y,
                    x,
                    w,
                    T,
                    k = (ot || rt.isSubplotConstrained) && !i.fixedrange && U[i._id],
                    M = (st || rt.isSubplotConstrained) && !a.fixedrange && X[a._id];

                if (k ? (y = m, w = g || rt.isSubplotConstrained ? e[0] : Xt(i, y)) : rt.xaHash[i._id] ? (y = m, w = e[0] * i._length / P._length) : rt.yaHash[i._id] ? (y = v, w = "ns" === it ? -e[1] * i._length / I._length : Xt(i, y, {
                  n: "top",
                  s: "bottom"
                }[it])) : w = Wt(i, y = Yt(i, m, v)), M ? (x = v, T = d || rt.isSubplotConstrained ? e[1] : Xt(a, x)) : rt.yaHash[a._id] ? (x = v, T = e[1] * a._length / I._length) : rt.xaHash[a._id] ? (x = m, T = "ew" === nt ? -e[0] * a._length / P._length : Xt(a, x, {
                  e: "right",
                  w: "left"
                }[nt])) : T = Wt(a, x = Yt(a, m, v)), y || x) {
                  y || (y = 1), x || (x = 1);
                  var A = i._offset - w / y,
                      S = a._offset - T / x;
                  n.clipRect.call(f.setTranslate, w, T).call(f.setScale, y, x), n.plot.call(f.setTranslate, A, S).call(f.setScale, 1 / y, 1 / x), y === n.xScaleFactor && x === n.yScaleFactor || (f.setPointGroupScale(n.zoomScalePts, y, x), f.setTextPointsScale(n.zoomScaleTxt, y, x)), f.hideOutsideRangePoints(n.clipOnAxisFalseTraces, n), n.xScaleFactor = y, n.yScaleFactor = x;
                }
              }
            }
          }

          function Yt(t, e, r) {
            return t.fixedrange ? 0 : ot && et.xaHash[t._id] ? e : st && (et.isSubplotConstrained ? et.xaHash : et.yaHash)[t._id] ? r : 0;
          }

          function Wt(t, e) {
            return e ? (t.range = t._r.slice(), S(t, e), Xt(t, e)) : 0;
          }

          function Xt(t, e, r) {
            return t._length * (1 - e) * x[r || t.constraintoward || "middle"];
          }

          return d.length * g.length != 1 && Y(xt, function (e) {
            if (t._context._scrollZoom.cartesian || t._fullLayout._enablescrollzoom) {
              if (Pt(), t._transitioningWithDuration) return e.preventDefault(), void e.stopPropagation();
              vt(), clearTimeout(Ft);
              var r = -e.deltaY;

              if (isFinite(r) || (r = e.wheelDelta / 10), isFinite(r)) {
                var n,
                    i = Math.exp(-Math.min(Math.max(r, -20), 20) / 200),
                    a = Nt.draglayer.select(".nsewdrag").node().getBoundingClientRect(),
                    o = (e.clientX - a.left) / a.width,
                    l = (a.bottom - e.clientY) / a.height;

                if (ot) {
                  for (g || (o = .5), n = 0; n < Z.length; n++) {
                    c(Z[n], o, i);
                  }

                  Ut("x"), Rt[2] *= i, Rt[0] += Rt[2] * o * (1 / i - 1);
                }

                if (st) {
                  for (d || (l = .5), n = 0; n < J.length; n++) {
                    c(J[n], l, i);
                  }

                  Ut("y"), Rt[3] *= i, Rt[1] += Rt[3] * (1 - l) * (1 / i - 1);
                }

                Gt(Rt), Vt(), t.emit("plotly_relayouting", ft), Ft = setTimeout(function () {
                  t._fullLayout && (Rt = [0, 0, $, tt], Ht());
                }, Bt), e.preventDefault();
              } else s.log("Did not find wheel motion attributes: ", e);
            }

            function c(t, e, r) {
              if (!t.fixedrange) {
                var n = s.simpleMap(t.range, t.r2l),
                    i = n[0] + (n[1] - n[0]) * e;
                t.range = n.map(function (e) {
                  return t.l2r(i + (e - i) * r);
                });
              }
            }
          }), xt;
        },
        makeDragger: I,
        makeRectDragger: O,
        makeZoombox: B,
        makeCorners: N,
        updateZoombox: j,
        xyCorners: H,
        transitionZoombox: U,
        removeZoombox: V,
        showDoubleClickNotifier: q,
        attachWheelEventHandler: Y
      };
    }, {
      "../../components/color": 658,
      "../../components/dragelement": 677,
      "../../components/dragelement/helpers": 676,
      "../../components/drawing": 680,
      "../../components/fx": 698,
      "../../constants/alignment": 763,
      "../../lib": 795,
      "../../lib/clear_gl_canvases": 779,
      "../../lib/setcursor": 816,
      "../../lib/svg_text_utils": 820,
      "../../plot_api/subroutines": 835,
      "../../registry": 923,
      "../plots": 909,
      "./axes": 845,
      "./axis_ids": 848,
      "./constants": 851,
      "./scale_zoom": 863,
      "./select": 864,
      "@plotly/d3": 57,
      "has-passive-events": 435,
      tinycolor2: 590
    }],
    854: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../components/fx"),
          a = t("../../components/dragelement"),
          o = t("../../lib/setcursor"),
          s = t("./dragbox").makeDragBox,
          l = t("./constants").DRAGGERSIZE;
      r.initInteractions = function (t) {
        var e = t._fullLayout;
        if (t._context.staticPlot) n.select(t).selectAll(".drag").remove();else if (e._has("cartesian") || e._has("splom")) {
          Object.keys(e._plots || {}).sort(function (t, r) {
            if ((e._plots[t].mainplot && !0) === (e._plots[r].mainplot && !0)) {
              var n = t.split("y"),
                  i = r.split("y");
              return n[0] === i[0] ? Number(n[1] || 1) - Number(i[1] || 1) : Number(n[0] || 1) - Number(i[0] || 1);
            }

            return e._plots[t].mainplot ? 1 : -1;
          }).forEach(function (r) {
            var n = e._plots[r],
                o = n.xaxis,
                c = n.yaxis;

            if (!n.mainplot) {
              var u = s(t, n, o._offset, c._offset, o._length, c._length, "ns", "ew");
              u.onmousemove = function (e) {
                t._fullLayout._rehover = function () {
                  t._fullLayout._hoversubplot === r && t._fullLayout._plots[r] && i.hover(t, e, r);
                }, i.hover(t, e, r), t._fullLayout._lasthover = u, t._fullLayout._hoversubplot = r;
              }, u.onmouseout = function (e) {
                t._dragging || (t._fullLayout._hoversubplot = null, a.unhover(t, e));
              }, t._context.showAxisDragHandles && (s(t, n, o._offset - l, c._offset - l, l, l, "n", "w"), s(t, n, o._offset + o._length, c._offset - l, l, l, "n", "e"), s(t, n, o._offset - l, c._offset + c._length, l, l, "s", "w"), s(t, n, o._offset + o._length, c._offset + c._length, l, l, "s", "e"));
            }

            if (t._context.showAxisDragHandles) {
              if (r === o._mainSubplot) {
                var f = o._mainLinePosition;
                "top" === o.side && (f -= l), s(t, n, o._offset + .1 * o._length, f, .8 * o._length, l, "", "ew"), s(t, n, o._offset, f, .1 * o._length, l, "", "w"), s(t, n, o._offset + .9 * o._length, f, .1 * o._length, l, "", "e");
              }

              if (r === c._mainSubplot) {
                var h = c._mainLinePosition;
                "right" !== c.side && (h -= l), s(t, n, h, c._offset + .1 * c._length, l, .8 * c._length, "ns", ""), s(t, n, h, c._offset + .9 * c._length, l, .1 * c._length, "s", ""), s(t, n, h, c._offset, l, .1 * c._length, "n", "");
              }
            }
          });

          var o = e._hoverlayer.node();

          o.onmousemove = function (r) {
            r.target = t._fullLayout._lasthover, i.hover(t, r, e._hoversubplot);
          }, o.onclick = function (e) {
            e.target = t._fullLayout._lasthover, i.click(t, e);
          }, o.onmousedown = function (e) {
            t._fullLayout._lasthover.onmousedown(e);
          }, r.updateFx(t);
        }
      }, r.updateFx = function (t) {
        var e = t._fullLayout,
            r = "pan" === e.dragmode ? "move" : "crosshair";
        o(e._draggers, r);
      };
    }, {
      "../../components/dragelement": 677,
      "../../components/fx": 698,
      "../../lib/setcursor": 816,
      "./constants": 851,
      "./dragbox": 853,
      "@plotly/d3": 57
    }],
    855: [function (t, e, r) {
      "use strict";

      e.exports = {
        clearOutlineControllers: function clearOutlineControllers(t) {
          var e = t._fullLayout._zoomlayer;
          e && e.selectAll(".outline-controllers").remove();
        },
        clearSelect: function clearSelect(t) {
          var e = t._fullLayout._zoomlayer;
          e && e.selectAll(".select-outline").remove(), t._fullLayout._drawing = !1;
        }
      };
    }, {}],
    856: [function (t, e, r) {
      "use strict";

      var n = t("../../lib").strTranslate;

      function i(t, e) {
        switch (t.type) {
          case "log":
            return t.p2d(e);

          case "date":
            return t.p2r(e, 0, t.calendar);

          default:
            return t.p2r(e);
        }
      }

      e.exports = {
        p2r: i,
        r2p: function r2p(t, e) {
          switch (t.type) {
            case "log":
              return t.d2p(e);

            case "date":
              return t.r2p(e, 0, t.calendar);

            default:
              return t.r2p(e);
          }
        },
        axValue: function axValue(t) {
          var e = "y" === t._id.charAt(0) ? 1 : 0;
          return function (r) {
            return i(t, r[e]);
          };
        },
        getTransform: function getTransform(t) {
          return n(t.xaxis._offset, t.yaxis._offset);
        }
      };
    }, {
      "../../lib": 795
    }],
    857: [function (t, e, r) {
      "use strict";

      var n = t("../../registry"),
          i = t("../../lib"),
          a = t("./axis_ids");

      e.exports = function (t) {
        return function (e, r) {
          var o = e[t];
          if (Array.isArray(o)) for (var s = n.subplotsRegistry.cartesian, l = s.idRegex, c = r._subplots, u = c.xaxis, f = c.yaxis, h = c.cartesian, p = r._has("cartesian") || r._has("gl2d"), d = 0; d < o.length; d++) {
            var m = o[d];

            if (i.isPlainObject(m)) {
              var g = a.cleanId(m.xref, "x", !1),
                  v = a.cleanId(m.yref, "y", !1),
                  y = l.x.test(g),
                  x = l.y.test(v);

              if (y || x) {
                p || i.pushUnique(r._basePlotModules, s);
                var b = !1;
                y && -1 === u.indexOf(g) && (u.push(g), b = !0), x && -1 === f.indexOf(v) && (f.push(v), b = !0), b && y && x && h.push(g + v);
              }
            }
          }
        };
      };
    }, {
      "../../lib": 795,
      "../../registry": 923,
      "./axis_ids": 848
    }],
    858: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../registry"),
          a = t("../../lib"),
          o = t("../plots"),
          s = t("../../components/drawing"),
          l = t("../get_data").getModuleCalcData,
          c = t("./axis_ids"),
          u = t("./constants"),
          f = t("../../constants/xmlns_namespaces"),
          h = a.ensureSingle;

      function p(t, e, r) {
        return a.ensureSingle(t, e, r, function (t) {
          t.datum(r);
        });
      }

      function d(t, e, r, a, o) {
        for (var c, f, h, p = u.traceLayerClasses, d = t._fullLayout, m = d._modules, g = [], v = [], y = 0; y < m.length; y++) {
          var x = (c = m[y]).name,
              b = i.modules[x].categories;

          if (b.svg) {
            var _ = c.layerName || x + "layer",
                w = c.plot;

            h = (f = l(r, w))[0], r = f[1], h.length && g.push({
              i: p.indexOf(_),
              className: _,
              plotMethod: w,
              cdModule: h
            }), b.zoomScale && v.push("." + _);
          }
        }

        g.sort(function (t, e) {
          return t.i - e.i;
        });
        var T = e.plot.selectAll("g.mlayer").data(g, function (t) {
          return t.className;
        });

        if (T.enter().append("g").attr("class", function (t) {
          return t.className;
        }).classed("mlayer", !0).classed("rangeplot", e.isRangePlot), T.exit().remove(), T.order(), T.each(function (r) {
          var i = n.select(this),
              l = r.className;
          r.plotMethod(t, e, r.cdModule, i, a, o), -1 === u.clipOnAxisFalseQuery.indexOf("." + l) && s.setClipUrl(i, e.layerClipId, t);
        }), d._has("scattergl") && (c = i.getModule("scattergl"), h = l(r, c)[0], c.plot(t, e, h)), !t._context.staticPlot && (e._hasClipOnAxisFalse && (e.clipOnAxisFalseTraces = e.plot.selectAll(u.clipOnAxisFalseQuery.join(",")).selectAll(".trace")), v.length)) {
          var k = e.plot.selectAll(v.join(",")).selectAll(".trace");
          e.zoomScalePts = k.selectAll("path.point"), e.zoomScaleTxt = k.selectAll(".textpoint");
        }
      }

      function m(t, e) {
        var r = e.plotgroup,
            n = e.id,
            i = u.layerValue2layerClass[e.xaxis.layer],
            a = u.layerValue2layerClass[e.yaxis.layer],
            o = t._fullLayout._hasOnlyLargeSploms;

        if (e.mainplot) {
          var s = e.mainplotinfo,
              l = s.plotgroup,
              f = n + "-x",
              d = n + "-y";
          e.gridlayer = s.gridlayer, e.zerolinelayer = s.zerolinelayer, h(s.overlinesBelow, "path", f), h(s.overlinesBelow, "path", d), h(s.overaxesBelow, "g", f), h(s.overaxesBelow, "g", d), e.plot = h(s.overplot, "g", n), h(s.overlinesAbove, "path", f), h(s.overlinesAbove, "path", d), h(s.overaxesAbove, "g", f), h(s.overaxesAbove, "g", d), e.xlines = l.select(".overlines-" + i).select("." + f), e.ylines = l.select(".overlines-" + a).select("." + d), e.xaxislayer = l.select(".overaxes-" + i).select("." + f), e.yaxislayer = l.select(".overaxes-" + a).select("." + d);
        } else if (o) e.xlines = h(r, "path", "xlines-above"), e.ylines = h(r, "path", "ylines-above"), e.xaxislayer = h(r, "g", "xaxislayer-above"), e.yaxislayer = h(r, "g", "yaxislayer-above");else {
          var m = h(r, "g", "layer-subplot");
          e.shapelayer = h(m, "g", "shapelayer"), e.imagelayer = h(m, "g", "imagelayer"), e.gridlayer = h(r, "g", "gridlayer"), e.zerolinelayer = h(r, "g", "zerolinelayer"), h(r, "path", "xlines-below"), h(r, "path", "ylines-below"), e.overlinesBelow = h(r, "g", "overlines-below"), h(r, "g", "xaxislayer-below"), h(r, "g", "yaxislayer-below"), e.overaxesBelow = h(r, "g", "overaxes-below"), e.plot = h(r, "g", "plot"), e.overplot = h(r, "g", "overplot"), e.xlines = h(r, "path", "xlines-above"), e.ylines = h(r, "path", "ylines-above"), e.overlinesAbove = h(r, "g", "overlines-above"), h(r, "g", "xaxislayer-above"), h(r, "g", "yaxislayer-above"), e.overaxesAbove = h(r, "g", "overaxes-above"), e.xlines = r.select(".xlines-" + i), e.ylines = r.select(".ylines-" + a), e.xaxislayer = r.select(".xaxislayer-" + i), e.yaxislayer = r.select(".yaxislayer-" + a);
        }

        o || (p(e.gridlayer, "g", e.xaxis._id), p(e.gridlayer, "g", e.yaxis._id), e.gridlayer.selectAll("g").map(function (t) {
          return t[0];
        }).sort(c.idSort)), e.xlines.style("fill", "none").classed("crisp", !0), e.ylines.style("fill", "none").classed("crisp", !0);
      }

      function g(t, e) {
        if (t) {
          var r = {};

          for (var i in t.each(function (t) {
            var i = t[0];
            n.select(this).remove(), v(i, e), r[i] = !0;
          }), e._plots) {
            for (var a = e._plots[i].overlays || [], o = 0; o < a.length; o++) {
              var s = a[o];
              r[s.id] && s.plot.selectAll(".trace").remove();
            }
          }
        }
      }

      function v(t, e) {
        e._draggers.selectAll("g." + t).remove(), e._defs.select("#clip" + e._uid + t + "plot").remove();
      }

      r.name = "cartesian", r.attr = ["xaxis", "yaxis"], r.idRoot = ["x", "y"], r.idRegex = u.idRegex, r.attrRegex = u.attrRegex, r.attributes = t("./attributes"), r.layoutAttributes = t("./layout_attributes"), r.supplyLayoutDefaults = t("./layout_defaults"), r.transitionAxes = t("./transition_axes"), r.finalizeSubplots = function (t, e) {
        var r,
            n,
            i,
            o = e._subplots,
            s = o.xaxis,
            l = o.yaxis,
            f = o.cartesian,
            h = f.concat(o.gl2d || []),
            p = {},
            d = {};

        for (r = 0; r < h.length; r++) {
          var m = h[r].split("y");
          p[m[0]] = 1, d["y" + m[1]] = 1;
        }

        for (r = 0; r < s.length; r++) {
          p[n = s[r]] || (i = (t[c.id2name(n)] || {}).anchor, u.idRegex.y.test(i) || (i = "y"), f.push(n + i), h.push(n + i), d[i] || (d[i] = 1, a.pushUnique(l, i)));
        }

        for (r = 0; r < l.length; r++) {
          d[i = l[r]] || (n = (t[c.id2name(i)] || {}).anchor, u.idRegex.x.test(n) || (n = "x"), f.push(n + i), h.push(n + i), p[n] || (p[n] = 1, a.pushUnique(s, n)));
        }

        if (!h.length) {
          for (var g in n = "", i = "", t) {
            if (u.attrRegex.test(g)) "x" === g.charAt(0) ? (!n || +g.substr(5) < +n.substr(5)) && (n = g) : (!i || +g.substr(5) < +i.substr(5)) && (i = g);
          }

          n = n ? c.name2id(n) : "x", i = i ? c.name2id(i) : "y", s.push(n), l.push(i), f.push(n + i);
        }
      }, r.plot = function (t, e, r, n) {
        var i,
            a = t._fullLayout,
            o = a._subplots.cartesian,
            s = t.calcdata;
        if (!Array.isArray(e)) for (e = [], i = 0; i < s.length; i++) {
          e.push(i);
        }

        for (i = 0; i < o.length; i++) {
          for (var l, c = o[i], u = a._plots[c], f = [], h = 0; h < s.length; h++) {
            var p = s[h],
                m = p[0].trace;
            m.xaxis + m.yaxis === c && ((-1 !== e.indexOf(m.index) || m.carpet) && (l && l[0].trace.xaxis + l[0].trace.yaxis === c && -1 !== ["tonextx", "tonexty", "tonext"].indexOf(m.fill) && -1 === f.indexOf(l) && f.push(l), f.push(p)), l = p);
          }

          d(t, u, f, r, n);
        }
      }, r.clean = function (t, e, r, n) {
        var i,
            a,
            o,
            s = n._plots || {},
            l = e._plots || {},
            u = n._subplots || {};
        if (n._hasOnlyLargeSploms && !e._hasOnlyLargeSploms) for (o in s) {
          (i = s[o]).plotgroup && i.plotgroup.remove();
        }

        var f = n._has && n._has("gl"),
            h = e._has && e._has("gl");

        if (f && !h) for (o in s) {
          (i = s[o])._scene && i._scene.destroy();
        }

        if (u.xaxis && u.yaxis) {
          var p = c.listIds({
            _fullLayout: n
          });

          for (a = 0; a < p.length; a++) {
            var d = p[a];
            e[c.id2name(d)] || n._infolayer.selectAll(".g-" + d + "title").remove();
          }
        }

        var m = n._has && n._has("cartesian"),
            y = e._has && e._has("cartesian");

        if (m && !y) g(n._cartesianlayer.selectAll(".subplot"), n), n._defs.selectAll(".axesclip").remove(), delete n._axisConstraintGroups, delete n._axisMatchGroups;else if (u.cartesian) for (a = 0; a < u.cartesian.length; a++) {
          var x = u.cartesian[a];

          if (!l[x]) {
            var b = "." + x + ",." + x + "-x,." + x + "-y";
            n._cartesianlayer.selectAll(b).remove(), v(x, n);
          }
        }
      }, r.drawFramework = function (t) {
        var e = t._fullLayout,
            r = function (t) {
          var e,
              r,
              n,
              i,
              a,
              o,
              s = t._fullLayout,
              l = s._subplots.cartesian,
              c = l.length,
              u = [],
              f = [];

          for (e = 0; e < c; e++) {
            n = l[e], i = s._plots[n], a = i.xaxis, o = i.yaxis;
            var h = a._mainAxis,
                p = o._mainAxis,
                d = h._id + p._id,
                m = s._plots[d];
            i.overlays = [], d !== n && m ? (i.mainplot = d, i.mainplotinfo = m, f.push(n)) : (i.mainplot = void 0, i.mainplotinfo = void 0, u.push(n));
          }

          for (e = 0; e < f.length; e++) {
            n = f[e], (i = s._plots[n]).mainplotinfo.overlays.push(i);
          }

          var g = u.concat(f),
              v = new Array(c);

          for (e = 0; e < c; e++) {
            n = g[e], i = s._plots[n], a = i.xaxis, o = i.yaxis;
            var y = [n, a.layer, o.layer, a.overlaying || "", o.overlaying || ""];

            for (r = 0; r < i.overlays.length; r++) {
              y.push(i.overlays[r].id);
            }

            v[e] = y;
          }

          return v;
        }(t),
            i = e._cartesianlayer.selectAll(".subplot").data(r, String);

        i.enter().append("g").attr("class", function (t) {
          return "subplot " + t[0];
        }), i.order(), i.exit().call(g, e), i.each(function (r) {
          var i = r[0],
              a = e._plots[i];
          a.plotgroup = n.select(this), m(t, a), a.draglayer = h(e._draggers, "g", i);
        });
      }, r.rangePlot = function (t, e, r) {
        m(t, e), d(t, e, r), o.style(t);
      }, r.toSVG = function (t) {
        var e = t._fullLayout._glimages,
            r = n.select(t).selectAll(".svg-container");
        r.filter(function (t, e) {
          return e === r.size() - 1;
        }).selectAll(".gl-canvas-context, .gl-canvas-focus").each(function () {
          var t = this.toDataURL("image/png");
          e.append("svg:image").attr({
            xmlns: f.svg,
            "xlink:href": t,
            preserveAspectRatio: "none",
            x: 0,
            y: 0,
            width: this.width,
            height: this.height
          });
        });
      }, r.updateFx = t("./graph_interact").updateFx;
    }, {
      "../../components/drawing": 680,
      "../../constants/xmlns_namespaces": 772,
      "../../lib": 795,
      "../../registry": 923,
      "../get_data": 882,
      "../plots": 909,
      "./attributes": 843,
      "./axis_ids": 848,
      "./constants": 851,
      "./graph_interact": 854,
      "./layout_attributes": 859,
      "./layout_defaults": 860,
      "./transition_axes": 869,
      "@plotly/d3": 57
    }],
    859: [function (t, e, r) {
      "use strict";

      var n = t("../font_attributes"),
          i = t("../../components/color/attributes"),
          a = t("../../components/drawing/attributes").dash,
          o = t("../../lib/extend").extendFlat,
          s = t("../../plot_api/plot_template").templatedArray,
          l = t("../../constants/docs"),
          c = (l.FORMAT_LINK, l.DATE_FORMAT_LINK, t("../../constants/numerical").ONEDAY),
          u = t("./constants"),
          f = u.HOUR_PATTERN,
          h = u.WEEKDAY_PATTERN;
      e.exports = {
        visible: {
          valType: "boolean",
          editType: "plot"
        },
        color: {
          valType: "color",
          dflt: i.defaultLine,
          editType: "ticks"
        },
        title: {
          text: {
            valType: "string",
            editType: "ticks"
          },
          font: n({
            editType: "ticks"
          }),
          standoff: {
            valType: "number",
            min: 0,
            editType: "ticks"
          },
          editType: "ticks"
        },
        type: {
          valType: "enumerated",
          values: ["-", "linear", "log", "date", "category", "multicategory"],
          dflt: "-",
          editType: "calc",
          _noTemplating: !0
        },
        autotypenumbers: {
          valType: "enumerated",
          values: ["convert types", "strict"],
          dflt: "convert types",
          editType: "calc"
        },
        autorange: {
          valType: "enumerated",
          values: [!0, !1, "reversed"],
          dflt: !0,
          editType: "axrange",
          impliedEdits: {
            "range[0]": void 0,
            "range[1]": void 0
          }
        },
        rangemode: {
          valType: "enumerated",
          values: ["normal", "tozero", "nonnegative"],
          dflt: "normal",
          editType: "plot"
        },
        range: {
          valType: "info_array",
          items: [{
            valType: "any",
            editType: "axrange",
            impliedEdits: {
              "^autorange": !1
            },
            anim: !0
          }, {
            valType: "any",
            editType: "axrange",
            impliedEdits: {
              "^autorange": !1
            },
            anim: !0
          }],
          editType: "axrange",
          impliedEdits: {
            autorange: !1
          },
          anim: !0
        },
        fixedrange: {
          valType: "boolean",
          dflt: !1,
          editType: "calc"
        },
        scaleanchor: {
          valType: "enumerated",
          values: [u.idRegex.x.toString(), u.idRegex.y.toString()],
          editType: "plot"
        },
        scaleratio: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "plot"
        },
        constrain: {
          valType: "enumerated",
          values: ["range", "domain"],
          editType: "plot"
        },
        constraintoward: {
          valType: "enumerated",
          values: ["left", "center", "right", "top", "middle", "bottom"],
          editType: "plot"
        },
        matches: {
          valType: "enumerated",
          values: [u.idRegex.x.toString(), u.idRegex.y.toString()],
          editType: "calc"
        },
        rangebreaks: s("rangebreak", {
          enabled: {
            valType: "boolean",
            dflt: !0,
            editType: "calc"
          },
          bounds: {
            valType: "info_array",
            items: [{
              valType: "any",
              editType: "calc"
            }, {
              valType: "any",
              editType: "calc"
            }],
            editType: "calc"
          },
          pattern: {
            valType: "enumerated",
            values: [h, f, ""],
            editType: "calc"
          },
          values: {
            valType: "info_array",
            freeLength: !0,
            editType: "calc",
            items: {
              valType: "any",
              editType: "calc"
            }
          },
          dvalue: {
            valType: "number",
            editType: "calc",
            min: 0,
            dflt: c
          },
          editType: "calc"
        }),
        tickmode: {
          valType: "enumerated",
          values: ["auto", "linear", "array"],
          editType: "ticks",
          impliedEdits: {
            tick0: void 0,
            dtick: void 0
          }
        },
        nticks: {
          valType: "integer",
          min: 0,
          dflt: 0,
          editType: "ticks"
        },
        tick0: {
          valType: "any",
          editType: "ticks",
          impliedEdits: {
            tickmode: "linear"
          }
        },
        dtick: {
          valType: "any",
          editType: "ticks",
          impliedEdits: {
            tickmode: "linear"
          }
        },
        tickvals: {
          valType: "data_array",
          editType: "ticks"
        },
        ticktext: {
          valType: "data_array",
          editType: "ticks"
        },
        ticks: {
          valType: "enumerated",
          values: ["outside", "inside", ""],
          editType: "ticks"
        },
        tickson: {
          valType: "enumerated",
          values: ["labels", "boundaries"],
          dflt: "labels",
          editType: "ticks"
        },
        ticklabelmode: {
          valType: "enumerated",
          values: ["instant", "period"],
          dflt: "instant",
          editType: "ticks"
        },
        ticklabelposition: {
          valType: "enumerated",
          values: ["outside", "inside", "outside top", "inside top", "outside left", "inside left", "outside right", "inside right", "outside bottom", "inside bottom"],
          dflt: "outside",
          editType: "calc"
        },
        ticklabeloverflow: {
          valType: "enumerated",
          values: ["allow", "hide past div", "hide past domain"],
          editType: "calc"
        },
        mirror: {
          valType: "enumerated",
          values: [!0, "ticks", !1, "all", "allticks"],
          dflt: !1,
          editType: "ticks+layoutstyle"
        },
        ticklen: {
          valType: "number",
          min: 0,
          dflt: 5,
          editType: "ticks"
        },
        tickwidth: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "ticks"
        },
        tickcolor: {
          valType: "color",
          dflt: i.defaultLine,
          editType: "ticks"
        },
        showticklabels: {
          valType: "boolean",
          dflt: !0,
          editType: "ticks"
        },
        automargin: {
          valType: "boolean",
          dflt: !1,
          editType: "ticks"
        },
        showspikes: {
          valType: "boolean",
          dflt: !1,
          editType: "modebar"
        },
        spikecolor: {
          valType: "color",
          dflt: null,
          editType: "none"
        },
        spikethickness: {
          valType: "number",
          dflt: 3,
          editType: "none"
        },
        spikedash: o({}, a, {
          dflt: "dash",
          editType: "none"
        }),
        spikemode: {
          valType: "flaglist",
          flags: ["toaxis", "across", "marker"],
          dflt: "toaxis",
          editType: "none"
        },
        spikesnap: {
          valType: "enumerated",
          values: ["data", "cursor", "hovered data"],
          dflt: "hovered data",
          editType: "none"
        },
        tickfont: n({
          editType: "ticks"
        }),
        tickangle: {
          valType: "angle",
          dflt: "auto",
          editType: "ticks"
        },
        tickprefix: {
          valType: "string",
          dflt: "",
          editType: "ticks"
        },
        showtickprefix: {
          valType: "enumerated",
          values: ["all", "first", "last", "none"],
          dflt: "all",
          editType: "ticks"
        },
        ticksuffix: {
          valType: "string",
          dflt: "",
          editType: "ticks"
        },
        showticksuffix: {
          valType: "enumerated",
          values: ["all", "first", "last", "none"],
          dflt: "all",
          editType: "ticks"
        },
        showexponent: {
          valType: "enumerated",
          values: ["all", "first", "last", "none"],
          dflt: "all",
          editType: "ticks"
        },
        exponentformat: {
          valType: "enumerated",
          values: ["none", "e", "E", "power", "SI", "B"],
          dflt: "B",
          editType: "ticks"
        },
        minexponent: {
          valType: "number",
          dflt: 3,
          min: 0,
          editType: "ticks"
        },
        separatethousands: {
          valType: "boolean",
          dflt: !1,
          editType: "ticks"
        },
        tickformat: {
          valType: "string",
          dflt: "",
          editType: "ticks"
        },
        tickformatstops: s("tickformatstop", {
          enabled: {
            valType: "boolean",
            dflt: !0,
            editType: "ticks"
          },
          dtickrange: {
            valType: "info_array",
            items: [{
              valType: "any",
              editType: "ticks"
            }, {
              valType: "any",
              editType: "ticks"
            }],
            editType: "ticks"
          },
          value: {
            valType: "string",
            dflt: "",
            editType: "ticks"
          },
          editType: "ticks"
        }),
        hoverformat: {
          valType: "string",
          dflt: "",
          editType: "none"
        },
        showline: {
          valType: "boolean",
          dflt: !1,
          editType: "ticks+layoutstyle"
        },
        linecolor: {
          valType: "color",
          dflt: i.defaultLine,
          editType: "layoutstyle"
        },
        linewidth: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "ticks+layoutstyle"
        },
        showgrid: {
          valType: "boolean",
          editType: "ticks"
        },
        gridcolor: {
          valType: "color",
          dflt: i.lightLine,
          editType: "ticks"
        },
        gridwidth: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "ticks"
        },
        zeroline: {
          valType: "boolean",
          editType: "ticks"
        },
        zerolinecolor: {
          valType: "color",
          dflt: i.defaultLine,
          editType: "ticks"
        },
        zerolinewidth: {
          valType: "number",
          dflt: 1,
          editType: "ticks"
        },
        showdividers: {
          valType: "boolean",
          dflt: !0,
          editType: "ticks"
        },
        dividercolor: {
          valType: "color",
          dflt: i.defaultLine,
          editType: "ticks"
        },
        dividerwidth: {
          valType: "number",
          dflt: 1,
          editType: "ticks"
        },
        anchor: {
          valType: "enumerated",
          values: ["free", u.idRegex.x.toString(), u.idRegex.y.toString()],
          editType: "plot"
        },
        side: {
          valType: "enumerated",
          values: ["top", "bottom", "left", "right"],
          editType: "plot"
        },
        overlaying: {
          valType: "enumerated",
          values: ["free", u.idRegex.x.toString(), u.idRegex.y.toString()],
          editType: "plot"
        },
        layer: {
          valType: "enumerated",
          values: ["above traces", "below traces"],
          dflt: "above traces",
          editType: "plot"
        },
        domain: {
          valType: "info_array",
          items: [{
            valType: "number",
            min: 0,
            max: 1,
            editType: "plot"
          }, {
            valType: "number",
            min: 0,
            max: 1,
            editType: "plot"
          }],
          dflt: [0, 1],
          editType: "plot"
        },
        position: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 0,
          editType: "plot"
        },
        categoryorder: {
          valType: "enumerated",
          values: ["trace", "category ascending", "category descending", "array", "total ascending", "total descending", "min ascending", "min descending", "max ascending", "max descending", "sum ascending", "sum descending", "mean ascending", "mean descending", "median ascending", "median descending"],
          dflt: "trace",
          editType: "calc"
        },
        categoryarray: {
          valType: "data_array",
          editType: "calc"
        },
        uirevision: {
          valType: "any",
          editType: "none"
        },
        editType: "calc",
        _deprecated: {
          autotick: {
            valType: "boolean",
            editType: "ticks"
          },
          title: {
            valType: "string",
            editType: "ticks"
          },
          titlefont: n({
            editType: "ticks"
          })
        }
      };
    }, {
      "../../components/color/attributes": 657,
      "../../components/drawing/attributes": 679,
      "../../constants/docs": 766,
      "../../constants/numerical": 771,
      "../../lib/extend": 785,
      "../../plot_api/plot_template": 834,
      "../font_attributes": 873,
      "./constants": 851
    }],
    860: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../components/color"),
          a = t("../../components/fx/helpers").isUnifiedHover,
          o = t("../../components/fx/hovermode_defaults"),
          s = t("../../plot_api/plot_template"),
          l = t("../layout_attributes"),
          c = t("./layout_attributes"),
          u = t("./type_defaults"),
          f = t("./axis_defaults"),
          h = t("./constraints"),
          p = t("./position_defaults"),
          d = t("./axis_ids"),
          m = d.id2name,
          g = d.name2id,
          v = t("./constants").AX_ID_PATTERN,
          y = t("../../registry"),
          x = y.traceIs,
          b = y.getComponentMethod;

      function _(t, e, r) {
        Array.isArray(t[e]) ? t[e].push(r) : t[e] = [r];
      }

      e.exports = function (t, e, r) {
        var y,
            w,
            T = e.autotypenumbers,
            k = {},
            M = {},
            A = {},
            S = {},
            E = {},
            L = {},
            C = {},
            P = {},
            I = {},
            O = {};

        for (y = 0; y < r.length; y++) {
          var z = r[y];

          if (x(z, "cartesian") || x(z, "gl2d")) {
            var D, R;
            if (z.xaxis) D = m(z.xaxis), _(k, D, z);else if (z.xaxes) for (w = 0; w < z.xaxes.length; w++) {
              _(k, m(z.xaxes[w]), z);
            }
            if (z.yaxis) R = m(z.yaxis), _(k, R, z);else if (z.yaxes) for (w = 0; w < z.yaxes.length; w++) {
              _(k, m(z.yaxes[w]), z);
            }
            if ("funnel" === z.type ? "h" === z.orientation ? (D && (M[D] = !0), R && (C[R] = !0)) : R && (A[R] = !0) : "image" === z.type ? (R && (P[R] = !0), D && (P[D] = !0)) : (R && (E[R] = !0, L[R] = !0), x(z, "carpet") && ("carpet" !== z.type || z._cheater) || D && (S[D] = !0)), "carpet" === z.type && z._cheater && D && (M[D] = !0), x(z, "2dMap") && (I[D] = !0, I[R] = !0), x(z, "oriented")) O["h" === z.orientation ? R : D] = !0;
          }
        }

        var F = e._subplots,
            B = F.xaxis,
            N = F.yaxis,
            j = n.simpleMap(B, m),
            U = n.simpleMap(N, m),
            V = j.concat(U),
            q = i.background;
        B.length && N.length && (q = n.coerce(t, e, l, "plot_bgcolor"));
        var H,
            G,
            Y,
            W,
            X,
            Z = i.combine(q, e.paper_bgcolor);

        function J() {
          var t = k[H] || [];
          X._traceIndices = t.map(function (t) {
            return t._expandedIndex;
          }), X._annIndices = [], X._shapeIndices = [], X._imgIndices = [], X._subplotsWith = [], X._counterAxes = [], X._name = X._attr = H, X._id = G;
        }

        function K(t, e) {
          return n.coerce(W, X, c, t, e);
        }

        function Q(t, e) {
          return n.coerce2(W, X, c, t, e);
        }

        function $(t) {
          return "x" === t ? N : B;
        }

        function tt(e, r) {
          for (var n = "x" === e ? j : U, i = [], a = 0; a < n.length; a++) {
            var o = n[a];
            o === r || (t[o] || {}).overlaying || i.push(g(o));
          }

          return i;
        }

        var et = {
          x: $("x"),
          y: $("y")
        },
            rt = et.x.concat(et.y),
            nt = {},
            it = [];

        function at() {
          var t = W.matches;
          v.test(t) && -1 === rt.indexOf(t) && (nt[t] = W.type, it = Object.keys(nt));
        }

        var ot = o(t, e),
            st = a(ot);

        for (y = 0; y < V.length; y++) {
          H = V[y], G = g(H), Y = H.charAt(0), n.isPlainObject(t[H]) || (t[H] = {}), W = t[H], X = s.newContainer(e, H, Y + "axis"), J();
          var lt = "x" === Y && !S[H] && M[H] || "y" === Y && !E[H] && A[H],
              ct = "y" === Y && (!L[H] && C[H] || P[H]),
              ut = {
            letter: Y,
            font: e.font,
            outerTicks: I[H],
            showGrid: !O[H],
            data: k[H] || [],
            bgColor: Z,
            calendar: e.calendar,
            automargin: !0,
            visibleDflt: lt,
            reverseDflt: ct,
            autotypenumbersDflt: T,
            splomStash: ((e._splomAxes || {})[Y] || {})[G]
          };
          K("uirevision", e.uirevision), u(W, X, K, ut), f(W, X, K, ut, e);
          var ft = st && Y === ot.charAt(0),
              ht = Q("spikecolor", st ? X.color : void 0),
              pt = Q("spikethickness", st ? 1.5 : void 0),
              dt = Q("spikedash", st ? "dot" : void 0),
              mt = Q("spikemode", st ? "across" : void 0),
              gt = Q("spikesnap");
          K("showspikes", !!(ft || ht || pt || dt || mt || gt)) || (delete X.spikecolor, delete X.spikethickness, delete X.spikedash, delete X.spikemode, delete X.spikesnap), p(W, X, K, {
            letter: Y,
            counterAxes: et[Y],
            overlayableAxes: tt(Y, H),
            grid: e.grid
          }), K("title.standoff"), at(), X._input = W;
        }

        for (y = 0; y < it.length;) {
          G = it[y++], Y = (H = m(G)).charAt(0), n.isPlainObject(t[H]) || (t[H] = {}), W = t[H], X = s.newContainer(e, H, Y + "axis"), J();
          var vt = {
            letter: Y,
            font: e.font,
            outerTicks: I[H],
            showGrid: !O[H],
            data: [],
            bgColor: Z,
            calendar: e.calendar,
            automargin: !0,
            visibleDflt: !1,
            reverseDflt: !1,
            autotypenumbersDflt: T,
            splomStash: ((e._splomAxes || {})[Y] || {})[G]
          };
          K("uirevision", e.uirevision), X.type = nt[G] || "linear", f(W, X, K, vt, e), p(W, X, K, {
            letter: Y,
            counterAxes: et[Y],
            overlayableAxes: tt(Y, H),
            grid: e.grid
          }), K("fixedrange"), at(), X._input = W;
        }

        var yt = b("rangeslider", "handleDefaults"),
            xt = b("rangeselector", "handleDefaults");

        for (y = 0; y < j.length; y++) {
          H = j[y], W = t[H], X = e[H], yt(t, e, H), "date" === X.type && xt(W, X, e, U, X.calendar), K("fixedrange");
        }

        for (y = 0; y < U.length; y++) {
          H = U[y], W = t[H], X = e[H];
          var bt = e[m(X.anchor)];
          K("fixedrange", b("rangeslider", "isVisible")(bt));
        }

        h.handleDefaults(t, e, {
          axIds: rt.concat(it).sort(d.idSort),
          axHasImage: P
        });
      };
    }, {
      "../../components/color": 658,
      "../../components/fx/helpers": 694,
      "../../components/fx/hovermode_defaults": 697,
      "../../lib": 795,
      "../../plot_api/plot_template": 834,
      "../../registry": 923,
      "../layout_attributes": 900,
      "./axis_defaults": 847,
      "./axis_ids": 848,
      "./constants": 851,
      "./constraints": 852,
      "./layout_attributes": 859,
      "./position_defaults": 862,
      "./type_defaults": 870
    }],
    861: [function (t, e, r) {
      "use strict";

      var n = t("tinycolor2").mix,
          i = t("../../components/color/attributes").lightFraction,
          a = t("../../lib");

      e.exports = function (t, e, r, o) {
        var s = (o = o || {}).dfltColor;

        function l(r, n) {
          return a.coerce2(t, e, o.attributes, r, n);
        }

        var c = l("linecolor", s),
            u = l("linewidth");
        r("showline", o.showLine || !!c || !!u) || (delete e.linecolor, delete e.linewidth);
        var f = l("gridcolor", n(s, o.bgColor, o.blend || i).toRgbString()),
            h = l("gridwidth");

        if (r("showgrid", o.showGrid || !!f || !!h) || (delete e.gridcolor, delete e.gridwidth), !o.noZeroLine) {
          var p = l("zerolinecolor", s),
              d = l("zerolinewidth");
          r("zeroline", o.showGrid || !!p || !!d) || (delete e.zerolinecolor, delete e.zerolinewidth);
        }
      };
    }, {
      "../../components/color/attributes": 657,
      "../../lib": 795,
      tinycolor2: 590
    }],
    862: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../lib");

      e.exports = function (t, e, r, a) {
        var o,
            s,
            l,
            c,
            u = a.counterAxes || [],
            f = a.overlayableAxes || [],
            h = a.letter,
            p = a.grid;
        p && (s = p._domains[h][p._axisMap[e._id]], o = p._anchors[e._id], s && (l = p[h + "side"].split(" ")[0], c = p.domain[h]["right" === l || "top" === l ? 1 : 0])), s = s || [0, 1], o = o || (n(t.position) ? "free" : u[0] || "free"), l = l || ("x" === h ? "bottom" : "left"), c = c || 0, "free" === i.coerce(t, e, {
          anchor: {
            valType: "enumerated",
            values: ["free"].concat(u),
            dflt: o
          }
        }, "anchor") && r("position", c), i.coerce(t, e, {
          side: {
            valType: "enumerated",
            values: "x" === h ? ["bottom", "top"] : ["left", "right"],
            dflt: l
          }
        }, "side");
        var d = !1;

        if (f.length && (d = i.coerce(t, e, {
          overlaying: {
            valType: "enumerated",
            values: [!1].concat(f),
            dflt: !1
          }
        }, "overlaying")), !d) {
          var m = r("domain", s);
          m[0] > m[1] - 1 / 4096 && (e.domain = s), i.noneOrAll(t.domain, e.domain, s);
        }

        return r("layer"), e;
      };
    }, {
      "../../lib": 795,
      "fast-isnumeric": 240
    }],
    863: [function (t, e, r) {
      "use strict";

      var n = t("../../constants/alignment").FROM_BL;

      e.exports = function (t, e, r) {
        void 0 === r && (r = n[t.constraintoward || "center"]);
        var i = [t.r2l(t.range[0]), t.r2l(t.range[1])],
            a = i[0] + (i[1] - i[0]) * r;
        t.range = t._input.range = [t.l2r(a + (i[0] - a) * e), t.l2r(a + (i[1] - a) * e)], t.setScale();
      };
    }, {
      "../../constants/alignment": 763
    }],
    864: [function (t, e, r) {
      "use strict";

      var n = t("polybooljs"),
          i = t("../../registry"),
          a = t("../../components/drawing").dashStyle,
          o = t("../../components/color"),
          s = t("../../components/fx"),
          l = t("../../components/fx/helpers").makeEventData,
          c = t("../../components/dragelement/helpers"),
          u = c.freeMode,
          f = c.rectMode,
          h = c.drawMode,
          p = c.openMode,
          d = c.selectMode,
          m = t("../../components/shapes/draw_newshape/display_outlines"),
          g = t("../../components/shapes/draw_newshape/helpers").handleEllipse,
          v = t("../../components/shapes/draw_newshape/newshapes"),
          y = t("../../lib"),
          x = t("../../lib/polygon"),
          b = t("../../lib/throttle"),
          _ = t("./axis_ids").getFromId,
          w = t("../../lib/clear_gl_canvases"),
          T = t("../../plot_api/subroutines").redrawReglTraces,
          k = t("./constants"),
          M = k.MINSELECT,
          A = x.filter,
          S = x.tester,
          E = t("./handle_outline").clearSelect,
          L = t("./helpers"),
          C = L.p2r,
          P = L.axValue,
          I = L.getTransform;

      function O(t, e, r, n, i, a, o) {
        var s,
            l,
            c,
            u,
            f,
            h,
            d,
            g,
            v,
            y = e._hoverdata,
            x = e._fullLayout.clickmode.indexOf("event") > -1,
            b = [];

        if (function (t) {
          return t && Array.isArray(t) && !0 !== t[0].hoverOnBox;
        }(y)) {
          F(t, e, a);

          var _ = function (t, e) {
            var r,
                n,
                i = t[0],
                a = -1,
                o = [];

            for (n = 0; n < e.length; n++) {
              if (r = e[n], i.fullData._expandedIndex === r.cd[0].trace._expandedIndex) {
                if (!0 === i.hoverOnBox) break;
                void 0 !== i.pointNumber ? a = i.pointNumber : void 0 !== i.binNumber && (a = i.binNumber, o = i.pointNumbers);
                break;
              }
            }

            return {
              pointNumber: a,
              pointNumbers: o,
              searchInfo: r
            };
          }(y, s = N(e, r, n, i));

          if (_.pointNumbers.length > 0 ? function (t, e) {
            var r,
                n,
                i,
                a = [];

            for (i = 0; i < t.length; i++) {
              (r = t[i]).cd[0].trace.selectedpoints && r.cd[0].trace.selectedpoints.length > 0 && a.push(r);
            }

            if (1 === a.length && a[0] === e.searchInfo && (n = e.searchInfo.cd[0].trace).selectedpoints.length === e.pointNumbers.length) {
              for (i = 0; i < e.pointNumbers.length; i++) {
                if (n.selectedpoints.indexOf(e.pointNumbers[i]) < 0) return !1;
              }

              return !0;
            }

            return !1;
          }(s, _) : function (t) {
            var e,
                r,
                n,
                i = 0;

            for (n = 0; n < t.length; n++) {
              if (e = t[n], (r = e.cd[0].trace).selectedpoints) {
                if (r.selectedpoints.length > 1) return !1;
                if ((i += r.selectedpoints.length) > 1) return !1;
              }
            }

            return 1 === i;
          }(s) && (h = j(_))) {
            for (o && o.remove(), v = 0; v < s.length; v++) {
              (l = s[v])._module.selectPoints(l, !1);
            }

            U(e, s), B(a), x && e.emit("plotly_deselect", null);
          } else {
            for (d = t.shiftKey && (void 0 !== h ? h : j(_)), c = function (t, e, r) {
              return {
                pointNumber: t,
                searchInfo: e,
                subtract: r
              };
            }(_.pointNumber, _.searchInfo, d), u = R(a.selectionDefs.concat([c])), v = 0; v < s.length; v++) {
              if (f = V(s[v]._module.selectPoints(s[v], u), s[v]), b.length) for (var w = 0; w < f.length; w++) {
                b.push(f[w]);
              } else b = f;
            }

            if (U(e, s, g = {
              points: b
            }), c && a && a.selectionDefs.push(c), o) {
              var T = a.mergedPolygons,
                  k = p(a.dragmode);
              m(q(T, k), o, a);
            }

            x && e.emit("plotly_selected", g);
          }
        }
      }

      function z(t) {
        return "pointNumber" in t && "searchInfo" in t;
      }

      function D(t) {
        return {
          xmin: 0,
          xmax: 0,
          ymin: 0,
          ymax: 0,
          pts: [],
          contains: function contains(e, r, n, i) {
            var a = t.searchInfo.cd[0].trace._expandedIndex;
            return i.cd[0].trace._expandedIndex === a && n === t.pointNumber;
          },
          isRect: !1,
          degenerate: !1,
          subtract: t.subtract
        };
      }

      function R(t) {
        for (var e = [], r = z(t[0]) ? 0 : t[0][0][0], n = r, i = z(t[0]) ? 0 : t[0][0][1], a = i, o = 0; o < t.length; o++) {
          if (z(t[o])) e.push(D(t[o]));else {
            var s = x.tester(t[o]);
            s.subtract = t[o].subtract, e.push(s), r = Math.min(r, s.xmin), n = Math.max(n, s.xmax), i = Math.min(i, s.ymin), a = Math.max(a, s.ymax);
          }
        }

        return {
          xmin: r,
          xmax: n,
          ymin: i,
          ymax: a,
          pts: [],
          contains: function contains(t, r, n, i) {
            for (var a = !1, o = 0; o < e.length; o++) {
              e[o].contains(t, r, n, i) && (a = !1 === e[o].subtract);
            }

            return a;
          },
          isRect: !1,
          degenerate: !1
        };
      }

      function F(t, e, r) {
        e._fullLayout._drawing = !1;
        var n = e._fullLayout,
            i = r.plotinfo,
            a = r.dragmode,
            o = n._lastSelectedSubplot && n._lastSelectedSubplot === i.id,
            s = (t.shiftKey || t.altKey) && !(h(a) && p(a));
        o && s && i.selection && i.selection.selectionDefs && !r.selectionDefs ? (r.selectionDefs = i.selection.selectionDefs, r.mergedPolygons = i.selection.mergedPolygons) : s && i.selection || B(r), o || (E(e), n._lastSelectedSubplot = i.id);
      }

      function B(t) {
        var e = t.dragmode,
            r = t.plotinfo,
            n = t.gd;

        if (n._fullLayout._activeShapeIndex >= 0 && n._fullLayout._deactivateShape(n), h(e)) {
          var a = n._fullLayout._zoomlayer.selectAll(".select-outline-" + r.id);

          if (a && n._fullLayout._drawing) {
            var o = v(a, t);
            o && i.call("_guiRelayout", n, {
              shapes: o
            }), n._fullLayout._drawing = !1;
          }
        }

        r.selection = {}, r.selection.selectionDefs = t.selectionDefs = [], r.selection.mergedPolygons = t.mergedPolygons = [];
      }

      function N(t, e, r, n) {
        var i,
            a,
            o,
            s = [],
            l = e.map(function (t) {
          return t._id;
        }),
            c = r.map(function (t) {
          return t._id;
        });

        for (o = 0; o < t.calcdata.length; o++) {
          if (!0 === (a = (i = t.calcdata[o])[0].trace).visible && a._module && a._module.selectPoints) if (!n || a.subplot !== n && a.geo !== n) {
            if ("splom" === a.type && a._xaxes[l[0]] && a._yaxes[c[0]]) {
              var u = h(a._module, i, e[0], r[0]);
              u.scene = t._fullLayout._splomScenes[a.uid], s.push(u);
            } else if ("sankey" === a.type) {
              var f = h(a._module, i, e[0], r[0]);
              s.push(f);
            } else {
              if (-1 === l.indexOf(a.xaxis)) continue;
              if (-1 === c.indexOf(a.yaxis)) continue;
              s.push(h(a._module, i, _(t, a.xaxis), _(t, a.yaxis)));
            }
          } else s.push(h(a._module, i, e[0], r[0]));
        }

        return s;

        function h(t, e, r, n) {
          return {
            _module: t,
            cd: e,
            xaxis: r,
            yaxis: n
          };
        }
      }

      function j(t) {
        var e = t.searchInfo.cd[0].trace,
            r = t.pointNumber,
            n = t.pointNumbers,
            i = n.length > 0 ? n[0] : r;
        return !!e.selectedpoints && e.selectedpoints.indexOf(i) > -1;
      }

      function U(t, e, r) {
        var n, a, o, s;

        for (n = 0; n < e.length; n++) {
          var l = e[n].cd[0].trace._fullInput,
              c = t._fullLayout._tracePreGUI[l.uid] || {};
          void 0 === c.selectedpoints && (c.selectedpoints = l._input.selectedpoints || null);
        }

        if (r) {
          var u = r.points || [];

          for (n = 0; n < e.length; n++) {
            (s = e[n].cd[0].trace)._input.selectedpoints = s._fullInput.selectedpoints = [], s._fullInput !== s && (s.selectedpoints = []);
          }

          for (n = 0; n < u.length; n++) {
            var f = u[n],
                h = f.data,
                p = f.fullData;
            f.pointIndices ? ([].push.apply(h.selectedpoints, f.pointIndices), s._fullInput !== s && [].push.apply(p.selectedpoints, f.pointIndices)) : (h.selectedpoints.push(f.pointIndex), s._fullInput !== s && p.selectedpoints.push(f.pointIndex));
          }
        } else for (n = 0; n < e.length; n++) {
          delete (s = e[n].cd[0].trace).selectedpoints, delete s._input.selectedpoints, s._fullInput !== s && delete s._fullInput.selectedpoints;
        }

        var d = !1;

        for (n = 0; n < e.length; n++) {
          s = (o = (a = e[n]).cd)[0].trace, i.traceIs(s, "regl") && (d = !0);
          var m = a._module,
              g = m.styleOnSelect || m.style;
          g && (g(t, o, o[0].node3), o[0].nodeRangePlot3 && g(t, o, o[0].nodeRangePlot3));
        }

        d && (w(t), T(t));
      }

      function V(t, e) {
        if (Array.isArray(t)) for (var r = e.cd, n = e.cd[0].trace, i = 0; i < t.length; i++) {
          t[i] = l(t[i], n, r);
        }
        return t;
      }

      function q(t, e) {
        for (var r = [], n = 0; n < t.length; n++) {
          r[n] = [];

          for (var i = 0; i < t[n].length; i++) {
            r[n][i] = [], r[n][i][0] = i ? "L" : "M";

            for (var a = 0; a < t[n][i].length; a++) {
              r[n][i].push(t[n][i][a]);
            }
          }

          e || r[n].push(["Z", r[n][0][1], r[n][0][2]]);
        }

        return r;
      }

      e.exports = {
        prepSelect: function prepSelect(t, e, r, i, l) {
          var c = u(l),
              v = f(l),
              x = p(l),
              _ = h(l),
              w = d(l),
              T = "drawcircle" === l,
              E = "drawline" === l || T,
              L = i.gd,
              z = L._fullLayout,
              D = z._zoomlayer,
              j = i.element.getBoundingClientRect(),
              H = i.plotinfo,
              G = I(H),
              Y = e - j.left,
              W = r - j.top;

          z._calcInverseTransform(L);

          var X = y.apply3DTransform(z._invTransform)(Y, W);
          Y = X[0], W = X[1];
          var Z,
              J,
              K,
              Q,
              $,
              tt,
              et,
              rt = z._invScaleX,
              nt = z._invScaleY,
              it = Y,
              at = W,
              ot = "M" + Y + "," + W,
              st = i.xaxes[0]._length,
              lt = i.yaxes[0]._length,
              ct = i.xaxes.concat(i.yaxes),
              ut = t.altKey && !(h(l) && x);
          F(t, L, i), c && (Z = A([[Y, W]], k.BENDPX));
          var ft = D.selectAll("path.select-outline-" + H.id).data(_ ? [0] : [1, 2]),
              ht = z.newshape;
          ft.enter().append("path").attr("class", function (t) {
            return "select-outline select-outline-" + t + " select-outline-" + H.id;
          }).style(_ ? {
            opacity: ht.opacity / 2,
            fill: x ? void 0 : ht.fillcolor,
            stroke: ht.line.color,
            "stroke-dasharray": a(ht.line.dash, ht.line.width),
            "stroke-width": ht.line.width + "px"
          } : {}).attr("fill-rule", ht.fillrule).classed("cursor-move", !!_).attr("transform", G).attr("d", ot + "Z");
          var pt,
              dt = D.append("path").attr("class", "zoombox-corners").style({
            fill: o.background,
            stroke: o.defaultLine,
            "stroke-width": 1
          }).attr("transform", G).attr("d", "M0,0Z"),
              mt = z._uid + k.SELECTID,
              gt = [],
              vt = N(L, i.xaxes, i.yaxes, i.subplot);

          function yt(t, e) {
            return t - e;
          }

          pt = H.fillRangeItems ? H.fillRangeItems : v ? function (t, e) {
            var r = t.range = {};

            for ($ = 0; $ < ct.length; $++) {
              var n = ct[$],
                  i = n._id.charAt(0);

              r[n._id] = [C(n, e[i + "min"]), C(n, e[i + "max"])].sort(yt);
            }
          } : function (t, e, r) {
            var n = t.lassoPoints = {};

            for ($ = 0; $ < ct.length; $++) {
              var i = ct[$];
              n[i._id] = r.filtered.map(P(i));
            }
          }, i.moveFn = function (t, e) {
            it = Math.max(0, Math.min(st, rt * t + Y)), at = Math.max(0, Math.min(lt, nt * e + W));
            var r = Math.abs(it - Y),
                a = Math.abs(at - W);

            if (v) {
              var o, s, l;

              if (w) {
                var u = z.selectdirection;

                switch (o = "any" === u ? a < Math.min(.6 * r, M) ? "h" : r < Math.min(.6 * a, M) ? "v" : "d" : u) {
                  case "h":
                    s = T ? lt / 2 : 0, l = lt;
                    break;

                  case "v":
                    s = T ? st / 2 : 0, l = st;
                }
              }

              if (_) switch (z.newshape.drawdirection) {
                case "vertical":
                  o = "h", s = T ? lt / 2 : 0, l = lt;
                  break;

                case "horizontal":
                  o = "v", s = T ? st / 2 : 0, l = st;
                  break;

                case "ortho":
                  r < a ? (o = "h", s = W, l = at) : (o = "v", s = Y, l = it);
                  break;

                default:
                  o = "d";
              }
              "h" === o ? ((Q = E ? g(T, [it, s], [it, l]) : [[Y, s], [Y, l], [it, l], [it, s]]).xmin = E ? it : Math.min(Y, it), Q.xmax = E ? it : Math.max(Y, it), Q.ymin = Math.min(s, l), Q.ymax = Math.max(s, l), dt.attr("d", "M" + Q.xmin + "," + (W - M) + "h-4v" + 2 * M + "h4ZM" + (Q.xmax - 1) + "," + (W - M) + "h4v" + 2 * M + "h-4Z")) : "v" === o ? ((Q = E ? g(T, [s, at], [l, at]) : [[s, W], [s, at], [l, at], [l, W]]).xmin = Math.min(s, l), Q.xmax = Math.max(s, l), Q.ymin = E ? at : Math.min(W, at), Q.ymax = E ? at : Math.max(W, at), dt.attr("d", "M" + (Y - M) + "," + Q.ymin + "v-4h" + 2 * M + "v4ZM" + (Y - M) + "," + (Q.ymax - 1) + "v4h" + 2 * M + "v-4Z")) : "d" === o && ((Q = E ? g(T, [Y, W], [it, at]) : [[Y, W], [Y, at], [it, at], [it, W]]).xmin = Math.min(Y, it), Q.xmax = Math.max(Y, it), Q.ymin = Math.min(W, at), Q.ymax = Math.max(W, at), dt.attr("d", "M0,0Z"));
            } else c && (Z.addPt([it, at]), Q = Z.filtered);

            i.selectionDefs && i.selectionDefs.length ? (K = function (t, e, r) {
              if (r) return n.difference({
                regions: t,
                inverted: !1
              }, {
                regions: [e],
                inverted: !1
              }).regions;
              return n.union({
                regions: t,
                inverted: !1
              }, {
                regions: [e],
                inverted: !1
              }).regions;
            }(i.mergedPolygons, Q, ut), Q.subtract = ut, J = R(i.selectionDefs.concat([Q]))) : (K = [Q], J = S(Q)), m(q(K, x), ft, i), w && b.throttle(mt, k.SELECTDELAY, function () {
              var t;
              gt = [];
              var e,
                  r = [];

              for ($ = 0; $ < vt.length; $++) {
                if (e = (tt = vt[$])._module.selectPoints(tt, J), r.push(e), t = V(e, tt), gt.length) for (var n = 0; n < t.length; n++) {
                  gt.push(t[n]);
                } else gt = t;
              }

              U(L, vt, et = {
                points: gt
              }), pt(et, Q, Z), i.gd.emit("plotly_selecting", et);
            });
          }, i.clickFn = function (t, e) {
            if (dt.remove(), L._fullLayout._activeShapeIndex >= 0) L._fullLayout._deactivateShape(L);else if (!_) {
              var r = z.clickmode;
              b.done(mt).then(function () {
                if (b.clear(mt), 2 === t) {
                  for (ft.remove(), $ = 0; $ < vt.length; $++) {
                    (tt = vt[$])._module.selectPoints(tt, !1);
                  }

                  U(L, vt), B(i), L.emit("plotly_deselect", null);
                } else r.indexOf("select") > -1 && O(e, L, i.xaxes, i.yaxes, i.subplot, i, ft), "event" === r && L.emit("plotly_selected", void 0);

                s.click(L, e);
              }).catch(y.error);
            }
          }, i.doneFn = function () {
            dt.remove(), b.done(mt).then(function () {
              b.clear(mt), i.gd.emit("plotly_selected", et), Q && i.selectionDefs && (Q.subtract = ut, i.selectionDefs.push(Q), i.mergedPolygons.length = 0, [].push.apply(i.mergedPolygons, K)), i.doneFnCompleted && i.doneFnCompleted(gt);
            }).catch(y.error), _ && B(i);
          };
        },
        clearSelect: E,
        clearSelectionsCache: B,
        selectOnClick: O
      };
    }, {
      "../../components/color": 658,
      "../../components/dragelement/helpers": 676,
      "../../components/drawing": 680,
      "../../components/fx": 698,
      "../../components/fx/helpers": 694,
      "../../components/shapes/draw_newshape/display_outlines": 746,
      "../../components/shapes/draw_newshape/helpers": 747,
      "../../components/shapes/draw_newshape/newshapes": 748,
      "../../lib": 795,
      "../../lib/clear_gl_canvases": 779,
      "../../lib/polygon": 807,
      "../../lib/throttle": 821,
      "../../plot_api/subroutines": 835,
      "../../registry": 923,
      "./axis_ids": 848,
      "./constants": 851,
      "./handle_outline": 855,
      "./helpers": 856,
      polybooljs: 496
    }],
    865: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("d3-time-format").utcFormat,
          a = t("fast-isnumeric"),
          o = t("../../lib"),
          s = o.cleanNumber,
          l = o.ms2DateTime,
          c = o.dateTime2ms,
          u = o.ensureNumber,
          f = o.isArrayOrTypedArray,
          h = t("../../constants/numerical"),
          p = h.FP_SAFE,
          d = h.BADNUM,
          m = h.LOG_CLIP,
          g = h.ONEWEEK,
          v = h.ONEDAY,
          y = h.ONEHOUR,
          x = h.ONEMIN,
          b = h.ONESEC,
          _ = t("./axis_ids"),
          w = t("./constants"),
          T = w.HOUR_PATTERN,
          k = w.WEEKDAY_PATTERN;

      function M(t) {
        return Math.pow(10, t);
      }

      function A(t) {
        return null != t;
      }

      e.exports = function (t, e) {
        e = e || {};
        var r = t._id || "x",
            h = r.charAt(0);

        function S(e, r) {
          if (e > 0) return Math.log(e) / Math.LN10;

          if (e <= 0 && r && t.range && 2 === t.range.length) {
            var n = t.range[0],
                i = t.range[1];
            return .5 * (n + i - 2 * m * Math.abs(n - i));
          }

          return d;
        }

        function E(e, r, n, i) {
          if ((i || {}).msUTC && a(e)) return +e;
          var s = c(e, n || t.calendar);

          if (s === d) {
            if (!a(e)) return d;
            e = +e;
            var l = Math.floor(10 * o.mod(e + .05, 1)),
                u = Math.round(e - l / 10);
            s = c(new Date(u)) + l / 10;
          }

          return s;
        }

        function L(e, r, n) {
          return l(e, r, n || t.calendar);
        }

        function C(e) {
          return t._categories[Math.round(e)];
        }

        function P(e) {
          if (A(e)) {
            if (void 0 === t._categoriesMap && (t._categoriesMap = {}), void 0 !== t._categoriesMap[e]) return t._categoriesMap[e];

            t._categories.push("number" == typeof e ? String(e) : e);

            var r = t._categories.length - 1;
            return t._categoriesMap[e] = r, r;
          }

          return d;
        }

        function I(e) {
          if (t._categoriesMap) return t._categoriesMap[e];
        }

        function O(t) {
          var e = I(t);
          return void 0 !== e ? e : a(t) ? +t : void 0;
        }

        function z(t) {
          return a(t) ? +t : I(t);
        }

        function D(t, e, r) {
          return n.round(r + e * t, 2);
        }

        function R(t, e, r) {
          return (t - r) / e;
        }

        var F = function F(e) {
          return a(e) ? D(e, t._m, t._b) : d;
        },
            B = function B(e) {
          return R(e, t._m, t._b);
        };

        if (t.rangebreaks) {
          var N = "y" === h;
          F = function F(e) {
            if (!a(e)) return d;
            var r = t._rangebreaks.length;
            if (!r) return D(e, t._m, t._b);
            var n = N;
            t.range[0] > t.range[1] && (n = !n);

            for (var i = n ? -1 : 1, o = i * e, s = 0, l = 0; l < r; l++) {
              var c = i * t._rangebreaks[l].min,
                  u = i * t._rangebreaks[l].max;
              if (o < c) break;

              if (!(o > u)) {
                s = o < (c + u) / 2 ? l : l + 1;
                break;
              }

              s = l + 1;
            }

            var f = t._B[s] || 0;
            return isFinite(f) ? D(e, t._m2, f) : 0;
          }, B = function B(e) {
            var r = t._rangebreaks.length;
            if (!r) return R(e, t._m, t._b);

            for (var n = 0, i = 0; i < r && !(e < t._rangebreaks[i].pmin); i++) {
              e > t._rangebreaks[i].pmax && (n = i + 1);
            }

            return R(e, t._m2, t._B[n]);
          };
        }

        t.c2l = "log" === t.type ? S : u, t.l2c = "log" === t.type ? M : u, t.l2p = F, t.p2l = B, t.c2p = "log" === t.type ? function (t, e) {
          return F(S(t, e));
        } : F, t.p2c = "log" === t.type ? function (t) {
          return M(B(t));
        } : B, -1 !== ["linear", "-"].indexOf(t.type) ? (t.d2r = t.r2d = t.d2c = t.r2c = t.d2l = t.r2l = s, t.c2d = t.c2r = t.l2d = t.l2r = u, t.d2p = t.r2p = function (e) {
          return t.l2p(s(e));
        }, t.p2d = t.p2r = B, t.cleanPos = u) : "log" === t.type ? (t.d2r = t.d2l = function (t, e) {
          return S(s(t), e);
        }, t.r2d = t.r2c = function (t) {
          return M(s(t));
        }, t.d2c = t.r2l = s, t.c2d = t.l2r = u, t.c2r = S, t.l2d = M, t.d2p = function (e, r) {
          return t.l2p(t.d2r(e, r));
        }, t.p2d = function (t) {
          return M(B(t));
        }, t.r2p = function (e) {
          return t.l2p(s(e));
        }, t.p2r = B, t.cleanPos = u) : "date" === t.type ? (t.d2r = t.r2d = o.identity, t.d2c = t.r2c = t.d2l = t.r2l = E, t.c2d = t.c2r = t.l2d = t.l2r = L, t.d2p = t.r2p = function (e, r, n) {
          return t.l2p(E(e, 0, n));
        }, t.p2d = t.p2r = function (t, e, r) {
          return L(B(t), e, r);
        }, t.cleanPos = function (e) {
          return o.cleanDate(e, d, t.calendar);
        }) : "category" === t.type ? (t.d2c = t.d2l = P, t.r2d = t.c2d = t.l2d = C, t.d2r = t.d2l_noadd = O, t.r2c = function (e) {
          var r = z(e);
          return void 0 !== r ? r : t.fraction2r(.5);
        }, t.l2r = t.c2r = u, t.r2l = z, t.d2p = function (e) {
          return t.l2p(t.r2c(e));
        }, t.p2d = function (t) {
          return C(B(t));
        }, t.r2p = t.d2p, t.p2r = B, t.cleanPos = function (t) {
          return "string" == typeof t && "" !== t ? t : u(t);
        }) : "multicategory" === t.type && (t.r2d = t.c2d = t.l2d = C, t.d2r = t.d2l_noadd = O, t.r2c = function (e) {
          var r = O(e);
          return void 0 !== r ? r : t.fraction2r(.5);
        }, t.r2c_just_indices = I, t.l2r = t.c2r = u, t.r2l = O, t.d2p = function (e) {
          return t.l2p(t.r2c(e));
        }, t.p2d = function (t) {
          return C(B(t));
        }, t.r2p = t.d2p, t.p2r = B, t.cleanPos = function (t) {
          return Array.isArray(t) || "string" == typeof t && "" !== t ? t : u(t);
        }, t.setupMultiCategory = function (n) {
          var i,
              a,
              s = t._traceIndices,
              l = t._matchGroup;
          if (l && 0 === t._categories.length) for (var c in l) {
            if (c !== r) {
              var u = e[_.id2name(c)];

              s = s.concat(u._traceIndices);
            }
          }
          var p = [[0, {}], [0, {}]],
              d = [];

          for (i = 0; i < s.length; i++) {
            var m = n[s[i]];

            if (h in m) {
              var g = m[h],
                  v = m._length || o.minRowLength(g);
              if (f(g[0]) && f(g[1])) for (a = 0; a < v; a++) {
                var y = g[0][a],
                    x = g[1][a];
                A(y) && A(x) && (d.push([y, x]), y in p[0][1] || (p[0][1][y] = p[0][0]++), x in p[1][1] || (p[1][1][x] = p[1][0]++));
              }
            }
          }

          for (d.sort(function (t, e) {
            var r = p[0][1],
                n = r[t[0]] - r[e[0]];
            if (n) return n;
            var i = p[1][1];
            return i[t[1]] - i[e[1]];
          }), i = 0; i < d.length; i++) {
            P(d[i]);
          }
        }), t.fraction2r = function (e) {
          var r = t.r2l(t.range[0]),
              n = t.r2l(t.range[1]);
          return t.l2r(r + e * (n - r));
        }, t.r2fraction = function (e) {
          var r = t.r2l(t.range[0]),
              n = t.r2l(t.range[1]);
          return (t.r2l(e) - r) / (n - r);
        }, t.cleanRange = function (e, r) {
          r || (r = {}), e || (e = "range");
          var n,
              i,
              s = o.nestedProperty(t, e).get();
          if (i = (i = "date" === t.type ? o.dfltRange(t.calendar) : "y" === h ? w.DFLTRANGEY : r.dfltRange || w.DFLTRANGEX).slice(), "tozero" !== t.rangemode && "nonnegative" !== t.rangemode || (i[0] = 0), s && 2 === s.length) for ("date" !== t.type || t.autorange || (s[0] = o.cleanDate(s[0], d, t.calendar), s[1] = o.cleanDate(s[1], d, t.calendar)), n = 0; n < 2; n++) {
            if ("date" === t.type) {
              if (!o.isDateTime(s[n], t.calendar)) {
                t[e] = i;
                break;
              }

              if (t.r2l(s[0]) === t.r2l(s[1])) {
                var l = o.constrain(t.r2l(s[0]), o.MIN_MS + 1e3, o.MAX_MS - 1e3);
                s[0] = t.l2r(l - 1e3), s[1] = t.l2r(l + 1e3);
                break;
              }
            } else {
              if (!a(s[n])) {
                if (!a(s[1 - n])) {
                  t[e] = i;
                  break;
                }

                s[n] = s[1 - n] * (n ? 10 : .1);
              }

              if (s[n] < -p ? s[n] = -p : s[n] > p && (s[n] = p), s[0] === s[1]) {
                var c = Math.max(1, Math.abs(1e-6 * s[0]));
                s[0] -= c, s[1] += c;
              }
            }
          } else o.nestedProperty(t, e).set(i);
        }, t.setScale = function (r) {
          var n = e._size;

          if (t.overlaying) {
            var i = _.getFromId({
              _fullLayout: e
            }, t.overlaying);

            t.domain = i.domain;
          }

          var a = r && t._r ? "_r" : "range",
              o = t.calendar;
          t.cleanRange(a);
          var s,
              l,
              c = t.r2l(t[a][0], o),
              u = t.r2l(t[a][1], o),
              f = "y" === h;

          if ((f ? (t._offset = n.t + (1 - t.domain[1]) * n.h, t._length = n.h * (t.domain[1] - t.domain[0]), t._m = t._length / (c - u), t._b = -t._m * u) : (t._offset = n.l + t.domain[0] * n.w, t._length = n.w * (t.domain[1] - t.domain[0]), t._m = t._length / (u - c), t._b = -t._m * c), t._rangebreaks = [], t._lBreaks = 0, t._m2 = 0, t._B = [], t.rangebreaks) && (t._rangebreaks = t.locateBreaks(Math.min(c, u), Math.max(c, u)), t._rangebreaks.length)) {
            for (s = 0; s < t._rangebreaks.length; s++) {
              l = t._rangebreaks[s], t._lBreaks += Math.abs(l.max - l.min);
            }

            var p = f;
            c > u && (p = !p), p && t._rangebreaks.reverse();
            var d = p ? -1 : 1;

            for (t._m2 = d * t._length / (Math.abs(u - c) - t._lBreaks), t._B.push(-t._m2 * (f ? u : c)), s = 0; s < t._rangebreaks.length; s++) {
              l = t._rangebreaks[s], t._B.push(t._B[t._B.length - 1] - d * t._m2 * (l.max - l.min));
            }

            for (s = 0; s < t._rangebreaks.length; s++) {
              (l = t._rangebreaks[s]).pmin = F(l.min), l.pmax = F(l.max);
            }
          }

          if (!isFinite(t._m) || !isFinite(t._b) || t._length < 0) throw e._replotting = !1, new Error("Something went wrong with axis scaling");
        }, t.maskBreaks = function (e) {
          for (var r, n, i, a, l, c = t.rangebreaks || [], u = 0; u < c.length; u++) {
            var f = c[u];
            if (f.enabled) if (f.bounds) {
              var h = f.pattern;

              switch (n = (r = o.simpleMap(f.bounds, h ? s : t.d2c))[0], i = r[1], h) {
                case k:
                  a = (l = new Date(e)).getUTCDay(), n > i && (i += 7, a < n && (a += 7));
                  break;

                case T:
                  a = (l = new Date(e)).getUTCHours() + (l.getUTCMinutes() / 60 + l.getUTCSeconds() / 3600 + l.getUTCMilliseconds() / 36e5), n > i && (i += 24, a < n && (a += 24));
                  break;

                case "":
                  a = e;
              }

              if (a >= n && a < i) return d;
            } else for (var p = o.simpleMap(f.values, t.d2c).sort(o.sorterAsc), m = 0; m < p.length; m++) {
              if (i = (n = p[m]) + f.dvalue, e >= n && e < i) return d;
            }
          }

          return e;
        }, t.locateBreaks = function (e, r) {
          var n,
              i,
              a,
              l,
              c = [];
          if (!t.rangebreaks) return c;

          var u = t.rangebreaks.slice().sort(function (t, e) {
            return t.pattern === k && e.pattern === T ? -1 : e.pattern === k && t.pattern === T ? 1 : 0;
          }),
              f = function f(t, n) {
            if ((t = o.constrain(t, e, r)) !== (n = o.constrain(n, e, r))) {
              for (var i = !0, a = 0; a < c.length; a++) {
                var s = c[a];
                t < s.max && n >= s.min && (t < s.min && (s.min = t), n > s.max && (s.max = n), i = !1);
              }

              i && c.push({
                min: t,
                max: n
              });
            }
          };

          for (n = 0; n < u.length; n++) {
            var h = u[n];
            if (h.enabled) if (h.bounds) {
              var p = e,
                  d = r;
              h.pattern && (p = Math.floor(p)), a = (i = o.simpleMap(h.bounds, h.pattern ? s : t.r2l))[0], l = i[1];

              var m,
                  _,
                  w = new Date(p);

              switch (h.pattern) {
                case k:
                  _ = g, m = (l - a + (l < a ? 7 : 0)) * v, p += a * v - (w.getUTCDay() * v + w.getUTCHours() * y + w.getUTCMinutes() * x + w.getUTCSeconds() * b + w.getUTCMilliseconds());
                  break;

                case T:
                  _ = v, m = (l - a + (l < a ? 24 : 0)) * y, p += a * y - (w.getUTCHours() * y + w.getUTCMinutes() * x + w.getUTCSeconds() * b + w.getUTCMilliseconds());
                  break;

                default:
                  p = Math.min(i[0], i[1]), m = _ = (d = Math.max(i[0], i[1])) - p;
              }

              for (var M = p; M < d; M += _) {
                f(M, M + m);
              }
            } else for (var A = o.simpleMap(h.values, t.d2c), S = 0; S < A.length; S++) {
              f(a = A[S], l = a + h.dvalue);
            }
          }

          return c.sort(function (t, e) {
            return t.min - e.min;
          }), c;
        }, t.makeCalcdata = function (e, r, n) {
          var i,
              a,
              s,
              l,
              c = t.type,
              u = "date" === c && e[r + "calendar"];

          if (r in e) {
            if (i = e[r], l = e._length || o.minRowLength(i), o.isTypedArray(i) && ("linear" === c || "log" === c)) {
              if (l === i.length) return i;
              if (i.subarray) return i.subarray(0, l);
            }

            if ("multicategory" === c) return function (t, e) {
              for (var r = new Array(e), n = 0; n < e; n++) {
                var i = (t[0] || [])[n],
                    a = (t[1] || [])[n];
                r[n] = I([i, a]);
              }

              return r;
            }(i, l);

            for (a = new Array(l), s = 0; s < l; s++) {
              a[s] = t.d2c(i[s], 0, u, n);
            }
          } else {
            var f = r + "0" in e ? t.d2c(e[r + "0"], 0, u) : 0,
                h = e["d" + r] ? Number(e["d" + r]) : 1;

            for (i = e[{
              x: "y",
              y: "x"
            }[r]], l = e._length || i.length, a = new Array(l), s = 0; s < l; s++) {
              a[s] = f + s * h;
            }
          }

          if (t.rangebreaks) for (s = 0; s < l; s++) {
            a[s] = t.maskBreaks(a[s]);
          }
          return a;
        }, t.isValidRange = function (e) {
          return Array.isArray(e) && 2 === e.length && a(t.r2l(e[0])) && a(t.r2l(e[1]));
        }, t.isPtWithinRange = function (e, r) {
          var n = t.c2l(e[h], null, r),
              i = t.r2l(t.range[0]),
              a = t.r2l(t.range[1]);
          return i < a ? i <= n && n <= a : a <= n && n <= i;
        }, t._emptyCategories = function () {
          t._categories = [], t._categoriesMap = {};
        }, t.clearCalc = function () {
          var r = t._matchGroup;

          if (r) {
            var n = null,
                i = null;

            for (var a in r) {
              var o = e[_.id2name(a)];

              if (o._categories) {
                n = o._categories, i = o._categoriesMap;
                break;
              }
            }

            n && i ? (t._categories = n, t._categoriesMap = i) : t._emptyCategories();
          } else t._emptyCategories();

          if (t._initialCategories) for (var s = 0; s < t._initialCategories.length; s++) {
            P(t._initialCategories[s]);
          }
        }, t.sortByInitialCategories = function () {
          var n = [];
          if (t._emptyCategories(), t._initialCategories) for (var i = 0; i < t._initialCategories.length; i++) {
            P(t._initialCategories[i]);
          }
          n = n.concat(t._traceIndices);
          var a = t._matchGroup;

          for (var o in a) {
            if (r !== o) {
              var s = e[_.id2name(o)];

              s._categories = t._categories, s._categoriesMap = t._categoriesMap, n = n.concat(s._traceIndices);
            }
          }

          return n;
        };
        var j = e._d3locale;
        "date" === t.type && (t._dateFormat = j ? j.timeFormat : i, t._extraFormat = e._extraFormat), t._separators = e.separators, t._numFormat = j ? j.numberFormat : n.format, delete t._minDtick, delete t._forceTick0;
      };
    }, {
      "../../constants/numerical": 771,
      "../../lib": 795,
      "./axis_ids": 848,
      "./constants": 851,
      "@plotly/d3": 57,
      "d3-time-format": 167,
      "fast-isnumeric": 240
    }],
    866: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../components/color").contrast,
          a = t("./layout_attributes"),
          o = t("../array_container_defaults");

      function s(t) {
        var e = ["showexponent", "showtickprefix", "showticksuffix"].filter(function (e) {
          return void 0 !== t[e];
        });
        if (e.every(function (r) {
          return t[r] === t[e[0]];
        }) || 1 === e.length) return t[e[0]];
      }

      function l(t, e) {
        function r(r, i) {
          return n.coerce(t, e, a.tickformatstops, r, i);
        }

        r("enabled") && (r("dtickrange"), r("value"));
      }

      e.exports = function (t, e, r, c, u, f) {
        f && 1 !== f.pass || function (t, e, r, n, i) {
          var a = s(t);
          r("tickprefix") && r("showtickprefix", a);
          r("ticksuffix", i.tickSuffixDflt) && r("showticksuffix", a);
        }(t, 0, r, 0, u), f && 2 !== f.pass || function (t, e, r, c, u) {
          var f = s(t);
          r("tickprefix") && r("showtickprefix", f);
          r("ticksuffix", u.tickSuffixDflt) && r("showticksuffix", f);

          if (r("showticklabels")) {
            var h = u.font || {},
                p = e.color,
                d = -1 !== (e.ticklabelposition || "").indexOf("inside") ? i(u.bgColor) : p && p !== a.color.dflt ? p : h.color;

            if (n.coerceFont(r, "tickfont", {
              family: h.family,
              size: h.size,
              color: d
            }), r("tickangle"), "category" !== c) {
              var m = r("tickformat");
              o(t, e, {
                name: "tickformatstops",
                inclusionAttr: "enabled",
                handleItemDefaults: l
              }), e.tickformatstops.length || delete e.tickformatstops, m || "date" === c || (r("showexponent", f), r("exponentformat"), r("minexponent"), r("separatethousands"));
            }
          }
        }(t, e, r, c, u);
      };
    }, {
      "../../components/color": 658,
      "../../lib": 795,
      "../array_container_defaults": 840,
      "./layout_attributes": 859
    }],
    867: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./layout_attributes");

      e.exports = function (t, e, r, a) {
        var o = n.coerce2(t, e, i, "ticklen"),
            s = n.coerce2(t, e, i, "tickwidth"),
            l = n.coerce2(t, e, i, "tickcolor", e.color);
        r("ticks", a.outerTicks || o || s || l ? "outside" : "") || (delete e.ticklen, delete e.tickwidth, delete e.tickcolor);
      };
    }, {
      "../../lib": 795,
      "./layout_attributes": 859
    }],
    868: [function (t, e, r) {
      "use strict";

      var n = t("./clean_ticks"),
          i = t("../../lib").isArrayOrTypedArray;

      e.exports = function (t, e, r, a) {
        function o(r) {
          var n = t[r];
          return void 0 !== n ? n : (e._template || {})[r];
        }

        var s = o("tick0"),
            l = o("dtick"),
            c = o("tickvals"),
            u = r("tickmode", i(c) ? "array" : l ? "linear" : "auto");
        if ("auto" === u) r("nticks");else if ("linear" === u) {
          var f = e.dtick = n.dtick(l, a);
          e.tick0 = n.tick0(s, a, e.calendar, f);
        } else if ("multicategory" !== a) {
          void 0 === r("tickvals") ? e.tickmode = "auto" : r("ticktext");
        }
      };
    }, {
      "../../lib": 795,
      "./clean_ticks": 850
    }],
    869: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../registry"),
          a = t("../../lib"),
          o = t("../../components/drawing"),
          s = t("./axes");

      e.exports = function (t, e, r, l) {
        var c = t._fullLayout;

        if (0 !== e.length) {
          var u, f, h, p;
          l && (u = l());
          var d = n.ease(r.easing);
          return t._transitionData._interruptCallbacks.push(function () {
            return window.cancelAnimationFrame(p), p = null, function () {
              for (var r = {}, n = 0; n < e.length; n++) {
                var a = e[n],
                    o = a.plotinfo.xaxis,
                    s = a.plotinfo.yaxis;
                a.xr0 && (r[o._name + ".range"] = a.xr0.slice()), a.yr0 && (r[s._name + ".range"] = a.yr0.slice());
              }

              return i.call("relayout", t, r).then(function () {
                for (var t = 0; t < e.length; t++) {
                  m(e[t].plotinfo);
                }
              });
            }();
          }), f = Date.now(), p = window.requestAnimationFrame(function n() {
            h = Date.now();

            for (var a = Math.min(1, (h - f) / r.duration), o = d(a), s = 0; s < e.length; s++) {
              g(e[s], o);
            }

            h - f > r.duration ? (!function () {
              for (var r = {}, n = 0; n < e.length; n++) {
                var a = e[n],
                    o = a.plotinfo.xaxis,
                    s = a.plotinfo.yaxis;
                a.xr1 && (r[o._name + ".range"] = a.xr1.slice()), a.yr1 && (r[s._name + ".range"] = a.yr1.slice());
              }

              u && u(), i.call("relayout", t, r).then(function () {
                for (var t = 0; t < e.length; t++) {
                  m(e[t].plotinfo);
                }
              });
            }(), p = window.cancelAnimationFrame(n)) : p = window.requestAnimationFrame(n);
          }), Promise.resolve();
        }

        function m(t) {
          var e = t.xaxis,
              r = t.yaxis;
          c._defs.select("#" + t.clipId + "> rect").call(o.setTranslate, 0, 0).call(o.setScale, 1, 1), t.plot.call(o.setTranslate, e._offset, r._offset).call(o.setScale, 1, 1);
          var n = t.plot.selectAll(".scatterlayer .trace");
          n.selectAll(".point").call(o.setPointGroupScale, 1, 1), n.selectAll(".textpoint").call(o.setTextPointsScale, 1, 1), n.call(o.hideOutsideRangePoints, t);
        }

        function g(e, r) {
          var n = e.plotinfo,
              i = n.xaxis,
              l = n.yaxis,
              c = i._length,
              u = l._length,
              f = !!e.xr1,
              h = !!e.yr1,
              p = [];

          if (f) {
            var d = a.simpleMap(e.xr0, i.r2l),
                m = a.simpleMap(e.xr1, i.r2l),
                g = d[1] - d[0],
                v = m[1] - m[0];
            p[0] = (d[0] * (1 - r) + r * m[0] - d[0]) / (d[1] - d[0]) * c, p[2] = c * (1 - r + r * v / g), i.range[0] = i.l2r(d[0] * (1 - r) + r * m[0]), i.range[1] = i.l2r(d[1] * (1 - r) + r * m[1]);
          } else p[0] = 0, p[2] = c;

          if (h) {
            var y = a.simpleMap(e.yr0, l.r2l),
                x = a.simpleMap(e.yr1, l.r2l),
                b = y[1] - y[0],
                _ = x[1] - x[0];

            p[1] = (y[1] * (1 - r) + r * x[1] - y[1]) / (y[0] - y[1]) * u, p[3] = u * (1 - r + r * _ / b), l.range[0] = i.l2r(y[0] * (1 - r) + r * x[0]), l.range[1] = l.l2r(y[1] * (1 - r) + r * x[1]);
          } else p[1] = 0, p[3] = u;

          s.drawOne(t, i, {
            skipTitle: !0
          }), s.drawOne(t, l, {
            skipTitle: !0
          }), s.redrawComponents(t, [i._id, l._id]);
          var w = f ? c / p[2] : 1,
              T = h ? u / p[3] : 1,
              k = f ? p[0] : 0,
              M = h ? p[1] : 0,
              A = f ? p[0] / p[2] * c : 0,
              S = h ? p[1] / p[3] * u : 0,
              E = i._offset - A,
              L = l._offset - S;
          n.clipRect.call(o.setTranslate, k, M).call(o.setScale, 1 / w, 1 / T), n.plot.call(o.setTranslate, E, L).call(o.setScale, w, T), o.setPointGroupScale(n.zoomScalePts, 1 / w, 1 / T), o.setTextPointsScale(n.zoomScaleTxt, 1 / w, 1 / T);
        }

        s.redrawComponents(t);
      };
    }, {
      "../../components/drawing": 680,
      "../../lib": 795,
      "../../registry": 923,
      "./axes": 845,
      "@plotly/d3": 57
    }],
    870: [function (t, e, r) {
      "use strict";

      var n = t("../../registry").traceIs,
          i = t("./axis_autotype");

      function a(t) {
        return {
          v: "x",
          h: "y"
        }[t.orientation || "v"];
      }

      function o(t, e) {
        var r = a(t),
            i = n(t, "box-violin"),
            o = n(t._fullInput || {}, "candlestick");
        return i && !o && e === r && void 0 === t[r] && void 0 === t[r + "0"];
      }

      e.exports = function (t, e, r, s) {
        r("autotypenumbers", s.autotypenumbersDflt), "-" === r("type", (s.splomStash || {}).type) && (!function (t, e) {
          if ("-" !== t.type) return;
          var r,
              s = t._id,
              l = s.charAt(0);
          -1 !== s.indexOf("scene") && (s = l);

          var c = function (t, e, r) {
            for (var n = 0; n < t.length; n++) {
              var i = t[n];
              if ("splom" === i.type && i._length > 0 && (i["_" + r + "axes"] || {})[e]) return i;

              if ((i[r + "axis"] || r) === e) {
                if (o(i, r)) return i;
                if ((i[r] || []).length || i[r + "0"]) return i;
              }
            }
          }(e, s, l);

          if (!c) return;
          if ("histogram" === c.type && l === {
            v: "y",
            h: "x"
          }[c.orientation || "v"]) return void (t.type = "linear");
          var u = l + "calendar",
              f = c[u],
              h = {
            noMultiCategory: !n(c, "cartesian") || n(c, "noMultiCategory")
          };
          "box" === c.type && c._hasPreCompStats && l === {
            h: "x",
            v: "y"
          }[c.orientation || "v"] && (h.noMultiCategory = !0);

          if (h.autotypenumbers = t.autotypenumbers, o(c, l)) {
            var p = a(c),
                d = [];

            for (r = 0; r < e.length; r++) {
              var m = e[r];
              n(m, "box-violin") && (m[l + "axis"] || l) === s && (void 0 !== m[p] ? d.push(m[p][0]) : void 0 !== m.name ? d.push(m.name) : d.push("text"), m[u] !== f && (f = void 0));
            }

            t.type = i(d, f, h);
          } else if ("splom" === c.type) {
            var g = c.dimensions[c._axesDim[s]];
            g.visible && (t.type = i(g.values, f, h));
          } else t.type = i(c[l] || [c[l + "0"]], f, h);
        }(e, s.data), "-" === e.type ? e.type = "linear" : t.type = e.type);
      };
    }, {
      "../../registry": 923,
      "./axis_autotype": 846
    }],
    871: [function (t, e, r) {
      "use strict";

      var n = t("../registry"),
          i = t("../lib");

      function a(t, e, r) {
        var n,
            a,
            o,
            s = !1;
        if ("data" === e.type) n = t._fullData[null !== e.traces ? e.traces[0] : 0];else {
          if ("layout" !== e.type) return !1;
          n = t._fullLayout;
        }
        return a = i.nestedProperty(n, e.prop).get(), (o = r[e.type] = r[e.type] || {}).hasOwnProperty(e.prop) && o[e.prop] !== a && (s = !0), o[e.prop] = a, {
          changed: s,
          value: a
        };
      }

      function o(t, e) {
        var r = [],
            n = e[0],
            a = {};
        if ("string" == typeof n) a[n] = e[1];else {
          if (!i.isPlainObject(n)) return r;
          a = n;
        }
        return l(a, function (t, e, n) {
          r.push({
            type: "layout",
            prop: t,
            value: n
          });
        }, "", 0), r;
      }

      function s(t, e) {
        var r,
            n,
            a,
            o,
            s = [];
        if (n = e[0], a = e[1], r = e[2], o = {}, "string" == typeof n) o[n] = a;else {
          if (!i.isPlainObject(n)) return s;
          o = n, void 0 === r && (r = a);
        }
        return void 0 === r && (r = null), l(o, function (e, n, i) {
          var a, o;

          if (Array.isArray(i)) {
            o = i.slice();
            var l = Math.min(o.length, t.data.length);
            r && (l = Math.min(l, r.length)), a = [];

            for (var c = 0; c < l; c++) {
              a[c] = r ? r[c] : c;
            }
          } else o = i, a = r ? r.slice() : null;

          if (null === a) Array.isArray(o) && (o = o[0]);else if (Array.isArray(a)) {
            if (!Array.isArray(o)) {
              var u = o;
              o = [];

              for (var f = 0; f < a.length; f++) {
                o[f] = u;
              }
            }

            o.length = Math.min(a.length, o.length);
          }
          s.push({
            type: "data",
            prop: e,
            traces: a,
            value: o
          });
        }, "", 0), s;
      }

      function l(t, e, r, n) {
        Object.keys(t).forEach(function (a) {
          var o = t[a];

          if ("_" !== a[0]) {
            var s = r + (n > 0 ? "." : "") + a;
            i.isPlainObject(o) ? l(o, e, s, n + 1) : e(s, a, o);
          }
        });
      }

      r.manageCommandObserver = function (t, e, n, o) {
        var s = {},
            l = !0;
        e && e._commandObserver && (s = e._commandObserver), s.cache || (s.cache = {}), s.lookupTable = {};
        var c = r.hasSimpleAPICommandBindings(t, n, s.lookupTable);

        if (e && e._commandObserver) {
          if (c) return s;
          if (e._commandObserver.remove) return e._commandObserver.remove(), e._commandObserver = null, s;
        }

        if (c) {
          a(t, c, s.cache), s.check = function () {
            if (l) {
              var e = a(t, c, s.cache);
              return e.changed && o && void 0 !== s.lookupTable[e.value] && (s.disable(), Promise.resolve(o({
                value: e.value,
                type: c.type,
                prop: c.prop,
                traces: c.traces,
                index: s.lookupTable[e.value]
              })).then(s.enable, s.enable)), e.changed;
            }
          };

          for (var u = ["plotly_relayout", "plotly_redraw", "plotly_restyle", "plotly_update", "plotly_animatingframe", "plotly_afterplot"], f = 0; f < u.length; f++) {
            t._internalOn(u[f], s.check);
          }

          s.remove = function () {
            for (var e = 0; e < u.length; e++) {
              t._removeInternalListener(u[e], s.check);
            }
          };
        } else i.log("Unable to automatically bind plot updates to API command"), s.lookupTable = {}, s.remove = function () {};

        return s.disable = function () {
          l = !1;
        }, s.enable = function () {
          l = !0;
        }, e && (e._commandObserver = s), s;
      }, r.hasSimpleAPICommandBindings = function (t, e, n) {
        var i,
            a,
            o = e.length;

        for (i = 0; i < o; i++) {
          var s,
              l = e[i],
              c = l.method,
              u = l.args;
          if (Array.isArray(u) || (u = []), !c) return !1;
          var f = r.computeAPICommandBindings(t, c, u);
          if (1 !== f.length) return !1;

          if (a) {
            if ((s = f[0]).type !== a.type) return !1;
            if (s.prop !== a.prop) return !1;

            if (Array.isArray(a.traces)) {
              if (!Array.isArray(s.traces)) return !1;
              s.traces.sort();

              for (var h = 0; h < a.traces.length; h++) {
                if (a.traces[h] !== s.traces[h]) return !1;
              }
            } else if (s.prop !== a.prop) return !1;
          } else a = f[0], Array.isArray(a.traces) && a.traces.sort();

          var p = (s = f[0]).value;

          if (Array.isArray(p)) {
            if (1 !== p.length) return !1;
            p = p[0];
          }

          n && (n[p] = i);
        }

        return a;
      }, r.executeAPICommand = function (t, e, r) {
        if ("skip" === e) return Promise.resolve();
        var a = n.apiMethodRegistry[e],
            o = [t];
        Array.isArray(r) || (r = []);

        for (var s = 0; s < r.length; s++) {
          o.push(r[s]);
        }

        return a.apply(null, o).catch(function (t) {
          return i.warn("API call to Plotly." + e + " rejected.", t), Promise.reject(t);
        });
      }, r.computeAPICommandBindings = function (t, e, r) {
        var n;

        switch (Array.isArray(r) || (r = []), e) {
          case "restyle":
            n = s(t, r);
            break;

          case "relayout":
            n = o(t, r);
            break;

          case "update":
            n = s(t, [r[0], r[2]]).concat(o(t, [r[1]]));
            break;

          case "animate":
            n = function (t, e) {
              return Array.isArray(e[0]) && 1 === e[0].length && -1 !== ["string", "number"].indexOf(_typeof(e[0][0])) ? [{
                type: "layout",
                prop: "_currentFrame",
                value: e[0][0].toString()
              }] : [];
            }(0, r);

            break;

          default:
            n = [];
        }

        return n;
      };
    }, {
      "../lib": 795,
      "../registry": 923
    }],
    872: [function (t, e, r) {
      "use strict";

      var n = t("../lib/extend").extendFlat;
      r.attributes = function (t, e) {
        e = e || {};
        var r = {
          valType: "info_array",
          editType: (t = t || {}).editType,
          items: [{
            valType: "number",
            min: 0,
            max: 1,
            editType: t.editType
          }, {
            valType: "number",
            min: 0,
            max: 1,
            editType: t.editType
          }],
          dflt: [0, 1]
        },
            i = (t.name && t.name, t.trace, e.description && e.description, {
          x: n({}, r, {}),
          y: n({}, r, {}),
          editType: t.editType
        });
        return t.noGridCell || (i.row = {
          valType: "integer",
          min: 0,
          dflt: 0,
          editType: t.editType
        }, i.column = {
          valType: "integer",
          min: 0,
          dflt: 0,
          editType: t.editType
        }), i;
      }, r.defaults = function (t, e, r, n) {
        var i = n && n.x || [0, 1],
            a = n && n.y || [0, 1],
            o = e.grid;

        if (o) {
          var s = r("domain.column");
          void 0 !== s && (s < o.columns ? i = o._domains.x[s] : delete t.domain.column);
          var l = r("domain.row");
          void 0 !== l && (l < o.rows ? a = o._domains.y[l] : delete t.domain.row);
        }

        var c = r("domain.x", i),
            u = r("domain.y", a);
        c[0] < c[1] || (t.domain.x = i.slice()), u[0] < u[1] || (t.domain.y = a.slice());
      };
    }, {
      "../lib/extend": 785
    }],
    873: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        var e = t.editType,
            r = t.colorEditType;
        void 0 === r && (r = e);
        var n = {
          family: {
            valType: "string",
            noBlank: !0,
            strict: !0,
            editType: e
          },
          size: {
            valType: "number",
            min: 1,
            editType: e
          },
          color: {
            valType: "color",
            editType: r
          },
          editType: e
        };
        return t.arrayOk && (n.family.arrayOk = !0, n.size.arrayOk = !0, n.color.arrayOk = !0), n;
      };
    }, {}],
    874: [function (t, e, r) {
      "use strict";

      e.exports = {
        _isLinkedToArray: "frames_entry",
        group: {
          valType: "string"
        },
        name: {
          valType: "string"
        },
        traces: {
          valType: "any"
        },
        baseframe: {
          valType: "string"
        },
        data: {
          valType: "any"
        },
        layout: {
          valType: "any"
        }
      };
    }, {}],
    875: [function (t, e, r) {
      "use strict";

      r.projNames = {
        equirectangular: "equirectangular",
        mercator: "mercator",
        orthographic: "orthographic",
        "natural earth": "naturalEarth",
        kavrayskiy7: "kavrayskiy7",
        miller: "miller",
        robinson: "robinson",
        eckert4: "eckert4",
        "azimuthal equal area": "azimuthalEqualArea",
        "azimuthal equidistant": "azimuthalEquidistant",
        "conic equal area": "conicEqualArea",
        "conic conformal": "conicConformal",
        "conic equidistant": "conicEquidistant",
        gnomonic: "gnomonic",
        stereographic: "stereographic",
        mollweide: "mollweide",
        hammer: "hammer",
        "transverse mercator": "transverseMercator",
        "albers usa": "albersUsa",
        "winkel tripel": "winkel3",
        aitoff: "aitoff",
        sinusoidal: "sinusoidal"
      }, r.axesNames = ["lonaxis", "lataxis"], r.lonaxisSpan = {
        orthographic: 180,
        "azimuthal equal area": 360,
        "azimuthal equidistant": 360,
        "conic conformal": 180,
        gnomonic: 160,
        stereographic: 180,
        "transverse mercator": 180,
        "*": 360
      }, r.lataxisSpan = {
        "conic conformal": 150,
        stereographic: 179.5,
        "*": 180
      }, r.scopeDefaults = {
        world: {
          lonaxisRange: [-180, 180],
          lataxisRange: [-90, 90],
          projType: "equirectangular",
          projRotate: [0, 0, 0]
        },
        usa: {
          lonaxisRange: [-180, -50],
          lataxisRange: [15, 80],
          projType: "albers usa"
        },
        europe: {
          lonaxisRange: [-30, 60],
          lataxisRange: [30, 85],
          projType: "conic conformal",
          projRotate: [15, 0, 0],
          projParallels: [0, 60]
        },
        asia: {
          lonaxisRange: [22, 160],
          lataxisRange: [-15, 55],
          projType: "mercator",
          projRotate: [0, 0, 0]
        },
        africa: {
          lonaxisRange: [-30, 60],
          lataxisRange: [-40, 40],
          projType: "mercator",
          projRotate: [0, 0, 0]
        },
        "north america": {
          lonaxisRange: [-180, -45],
          lataxisRange: [5, 85],
          projType: "conic conformal",
          projRotate: [-100, 0, 0],
          projParallels: [29.5, 45.5]
        },
        "south america": {
          lonaxisRange: [-100, -30],
          lataxisRange: [-60, 15],
          projType: "mercator",
          projRotate: [0, 0, 0]
        }
      }, r.clipPad = .001, r.precision = .1, r.landColor = "#F0DC82", r.waterColor = "#3399FF", r.locationmodeToLayer = {
        "ISO-3": "countries",
        "USA-states": "subunits",
        "country names": "countries"
      }, r.sphereSVG = {
        type: "Sphere"
      }, r.fillLayers = {
        ocean: 1,
        land: 1,
        lakes: 1
      }, r.lineLayers = {
        subunits: 1,
        countries: 1,
        coastlines: 1,
        rivers: 1,
        frame: 1
      }, r.layers = ["bg", "ocean", "land", "lakes", "subunits", "countries", "coastlines", "rivers", "lataxis", "lonaxis", "frame", "backplot", "frontplot"], r.layersForChoropleth = ["bg", "ocean", "land", "subunits", "countries", "coastlines", "lataxis", "lonaxis", "frame", "backplot", "rivers", "lakes", "frontplot"], r.layerNameToAdjective = {
        ocean: "ocean",
        land: "land",
        lakes: "lake",
        subunits: "subunit",
        countries: "country",
        coastlines: "coastline",
        rivers: "river",
        frame: "frame"
      };
    }, {}],
    876: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../registry"),
          a = t("../../lib"),
          o = a.strTranslate,
          s = t("../../components/color"),
          l = t("../../components/drawing"),
          c = t("../../components/fx"),
          u = t("../plots"),
          f = t("../cartesian/axes"),
          h = t("../cartesian/autorange").getAutoRange,
          p = t("../../components/dragelement"),
          d = t("../cartesian/select").prepSelect,
          m = t("../cartesian/select").clearSelect,
          g = t("../cartesian/select").selectOnClick,
          v = t("./zoom"),
          y = t("./constants"),
          x = t("../../lib/geo_location_utils"),
          b = t("../../lib/topojson_utils"),
          _ = t("topojson-client").feature;

      function w(t) {
        this.id = t.id, this.graphDiv = t.graphDiv, this.container = t.container, this.topojsonURL = t.topojsonURL, this.isStatic = t.staticPlot, this.topojsonName = null, this.topojson = null, this.projection = null, this.scope = null, this.viewInitial = null, this.fitScale = null, this.bounds = null, this.midPt = null, this.hasChoropleth = !1, this.traceHash = {}, this.layers = {}, this.basePaths = {}, this.dataPaths = {}, this.dataPoints = {}, this.clipDef = null, this.clipRect = null, this.bgRect = null, this.makeFramework();
      }

      t("./projections")(n);
      var T = w.prototype;

      function k(t, e) {
        var r = y.clipPad,
            n = t[0] + r,
            i = t[1] - r,
            a = e[0] + r,
            o = e[1] - r;
        n > 0 && i < 0 && (i += 360);
        var s = (i - n) / 4;
        return {
          type: "Polygon",
          coordinates: [[[n, a], [n, o], [n + s, o], [n + 2 * s, o], [n + 3 * s, o], [i, o], [i, a], [i - s, a], [i - 2 * s, a], [i - 3 * s, a], [n, a]]]
        };
      }

      e.exports = function (t) {
        return new w(t);
      }, T.plot = function (t, e, r) {
        var n = this,
            i = e[this.id],
            a = [],
            o = !1;

        for (var s in y.layerNameToAdjective) {
          if ("frame" !== s && i["show" + s]) {
            o = !0;
            break;
          }
        }

        for (var l = 0; l < t.length; l++) {
          if (t[0][0].trace.locationmode) {
            o = !0;
            break;
          }
        }

        if (o) {
          var c = b.getTopojsonName(i);
          null !== n.topojson && c === n.topojsonName || (n.topojsonName = c, void 0 === PlotlyGeoAssets.topojson[n.topojsonName] && a.push(n.fetchTopojson()));
        }

        a = a.concat(x.fetchTraceGeoData(t)), r.push(new Promise(function (r, i) {
          Promise.all(a).then(function () {
            n.topojson = PlotlyGeoAssets.topojson[n.topojsonName], n.update(t, e), r();
          }).catch(i);
        }));
      }, T.fetchTopojson = function () {
        var t = this,
            e = b.getTopojsonPath(t.topojsonURL, t.topojsonName);
        return new Promise(function (r, i) {
          n.json(e, function (n, a) {
            if (n) return 404 === n.status ? i(new Error(["plotly.js could not find topojson file at", e, ".", "Make sure the *topojsonURL* plot config option", "is set properly."].join(" "))) : i(new Error(["unexpected error while fetching topojson file at", e].join(" ")));
            PlotlyGeoAssets.topojson[t.topojsonName] = a, r();
          });
        });
      }, T.update = function (t, e) {
        var r = e[this.id];
        this.hasChoropleth = !1;

        for (var n = 0; n < t.length; n++) {
          var i = t[n],
              a = i[0].trace;
          "choropleth" === a.type && (this.hasChoropleth = !0), !0 === a.visible && a._length > 0 && a._module.calcGeoJSON(i, e);
        }

        if (!this.updateProjection(t, e)) {
          this.viewInitial && this.scope === r.scope || this.saveViewInitial(r), this.scope = r.scope, this.updateBaseLayers(e, r), this.updateDims(e, r), this.updateFx(e, r), u.generalUpdatePerTraceModule(this.graphDiv, this, t, r);
          var o = this.layers.frontplot.select(".scatterlayer");
          this.dataPoints.point = o.selectAll(".point"), this.dataPoints.text = o.selectAll("text"), this.dataPaths.line = o.selectAll(".js-line");
          var s = this.layers.backplot.select(".choroplethlayer");
          this.dataPaths.choropleth = s.selectAll("path"), this.render();
        }
      }, T.updateProjection = function (t, e) {
        var r = this.graphDiv,
            o = e[this.id],
            s = e._size,
            l = o.domain,
            c = o.projection,
            u = o.lonaxis,
            f = o.lataxis,
            p = u._ax,
            d = f._ax,
            m = this.projection = function (t) {
          for (var e = t.projection.type, r = n.geo[y.projNames[e]](), i = t._isClipped ? y.lonaxisSpan[e] / 2 : null, a = ["center", "rotate", "parallels", "clipExtent"], o = function o(t) {
            return t ? r : [];
          }, s = 0; s < a.length; s++) {
            var l = a[s];
            "function" != typeof r[l] && (r[l] = o);
          }

          r.isLonLatOverEdges = function (t) {
            if (null === r(t)) return !0;

            if (i) {
              var e = r.rotate();
              return n.geo.distance(t, [-e[0], -e[1]]) > i * Math.PI / 180;
            }

            return !1;
          }, r.getPath = function () {
            return n.geo.path().projection(r);
          }, r.getBounds = function (t) {
            return r.getPath().bounds(t);
          }, r.fitExtent = function (t, e) {
            var n = t[1][0] - t[0][0],
                i = t[1][1] - t[0][1],
                a = r.clipExtent && r.clipExtent();
            r.scale(150).translate([0, 0]), a && r.clipExtent(null);
            var o = r.getBounds(e),
                s = Math.min(n / (o[1][0] - o[0][0]), i / (o[1][1] - o[0][1])),
                l = +t[0][0] + (n - s * (o[1][0] + o[0][0])) / 2,
                c = +t[0][1] + (i - s * (o[1][1] + o[0][1])) / 2;
            return a && r.clipExtent(a), r.scale(150 * s).translate([l, c]);
          }, r.precision(y.precision), i && r.clipAngle(i - y.clipPad);
          return r;
        }(o),
            g = [[s.l + s.w * l.x[0], s.t + s.h * (1 - l.y[1])], [s.l + s.w * l.x[1], s.t + s.h * (1 - l.y[0])]],
            v = o.center || {},
            x = c.rotation || {},
            b = u.range || [],
            _ = f.range || [];

        if (o.fitbounds) {
          p._length = g[1][0] - g[0][0], d._length = g[1][1] - g[0][1], p.range = h(r, p), d.range = h(r, d);
          var w = (p.range[0] + p.range[1]) / 2,
              T = (d.range[0] + d.range[1]) / 2;
          if (o._isScoped) v = {
            lon: w,
            lat: T
          };else if (o._isClipped) {
            v = {
              lon: w,
              lat: T
            }, x = {
              lon: w,
              lat: T,
              roll: x.roll
            };
            var M = c.type,
                A = y.lonaxisSpan[M] / 2 || 180,
                S = y.lataxisSpan[M] / 2 || 90;
            b = [w - A, w + A], _ = [T - S, T + S];
          } else v = {
            lon: w,
            lat: T
          }, x = {
            lon: w,
            lat: x.lat,
            roll: x.roll
          };
        }

        m.center([v.lon - x.lon, v.lat - x.lat]).rotate([-x.lon, -x.lat, x.roll]).parallels(c.parallels);
        var E = k(b, _);
        m.fitExtent(g, E);
        var L = this.bounds = m.getBounds(E),
            C = this.fitScale = m.scale(),
            P = m.translate();

        if (!isFinite(L[0][0]) || !isFinite(L[0][1]) || !isFinite(L[1][0]) || !isFinite(L[1][1]) || isNaN(P[0]) || isNaN(P[0])) {
          for (var I = ["fitbounds", "projection.rotation", "center", "lonaxis.range", "lataxis.range"], O = "Invalid geo settings, relayout'ing to default view.", z = {}, D = 0; D < I.length; D++) {
            z[this.id + "." + I[D]] = null;
          }

          return this.viewInitial = null, a.warn(O), r._promises.push(i.call("relayout", r, z)), O;
        }

        if (o.fitbounds) {
          var R = m.getBounds(k(p.range, d.range)),
              F = Math.min((L[1][0] - L[0][0]) / (R[1][0] - R[0][0]), (L[1][1] - L[0][1]) / (R[1][1] - R[0][1]));
          isFinite(F) ? m.scale(F * C) : a.warn("Something went wrong during" + this.id + "fitbounds computations.");
        } else m.scale(c.scale * C);

        var B = this.midPt = [(L[0][0] + L[1][0]) / 2, (L[0][1] + L[1][1]) / 2];

        if (m.translate([P[0] + (B[0] - P[0]), P[1] + (B[1] - P[1])]).clipExtent(L), o._isAlbersUsa) {
          var N = m([v.lon, v.lat]),
              j = m.translate();
          m.translate([j[0] - (N[0] - j[0]), j[1] - (N[1] - j[1])]);
        }
      }, T.updateBaseLayers = function (t, e) {
        var r = this,
            i = r.topojson,
            a = r.layers,
            o = r.basePaths;

        function c(t) {
          return "lonaxis" === t || "lataxis" === t;
        }

        function u(t) {
          return Boolean(y.lineLayers[t]);
        }

        function h(t) {
          return Boolean(y.fillLayers[t]);
        }

        var p = (this.hasChoropleth ? y.layersForChoropleth : y.layers).filter(function (t) {
          return u(t) || h(t) ? e["show" + t] : !c(t) || e[t].showgrid;
        }),
            d = r.framework.selectAll(".layer").data(p, String);
        d.exit().each(function (t) {
          delete a[t], delete o[t], n.select(this).remove();
        }), d.enter().append("g").attr("class", function (t) {
          return "layer " + t;
        }).each(function (t) {
          var e = a[t] = n.select(this);
          "bg" === t ? r.bgRect = e.append("rect").style("pointer-events", "all") : c(t) ? o[t] = e.append("path").style("fill", "none") : "backplot" === t ? e.append("g").classed("choroplethlayer", !0) : "frontplot" === t ? e.append("g").classed("scatterlayer", !0) : u(t) ? o[t] = e.append("path").style("fill", "none").style("stroke-miterlimit", 2) : h(t) && (o[t] = e.append("path").style("stroke", "none"));
        }), d.order(), d.each(function (r) {
          var n = o[r],
              a = y.layerNameToAdjective[r];
          "frame" === r ? n.datum(y.sphereSVG) : u(r) || h(r) ? n.datum(_(i, i.objects[r])) : c(r) && n.datum(function (t, e, r) {
            var n,
                i,
                a,
                o = e[t],
                s = y.scopeDefaults[e.scope];
            "lonaxis" === t ? (n = s.lonaxisRange, i = s.lataxisRange, a = function a(t, e) {
              return [t, e];
            }) : "lataxis" === t && (n = s.lataxisRange, i = s.lonaxisRange, a = function a(t, e) {
              return [e, t];
            });
            var l = {
              type: "linear",
              range: [n[0], n[1] - 1e-6],
              tick0: o.tick0,
              dtick: o.dtick
            };
            f.setConvert(l, r);
            var c = f.calcTicks(l);
            e.isScoped || "lonaxis" !== t || c.pop();

            for (var u = c.length, h = new Array(u), p = 0; p < u; p++) {
              for (var d = c[p].x, m = h[p] = [], g = i[0]; g < i[1] + 2.5; g += 2.5) {
                m.push(a(d, g));
              }
            }

            return {
              type: "MultiLineString",
              coordinates: h
            };
          }(r, e, t)).call(s.stroke, e[r].gridcolor).call(l.dashLine, "", e[r].gridwidth), u(r) ? n.call(s.stroke, e[a + "color"]).call(l.dashLine, "", e[a + "width"]) : h(r) && n.call(s.fill, e[a + "color"]);
        });
      }, T.updateDims = function (t, e) {
        var r = this.bounds,
            n = (e.framewidth || 0) / 2,
            i = r[0][0] - n,
            a = r[0][1] - n,
            o = r[1][0] - i + n,
            c = r[1][1] - a + n;
        l.setRect(this.clipRect, i, a, o, c), this.bgRect.call(l.setRect, i, a, o, c).call(s.fill, e.bgcolor), this.xaxis._offset = i, this.xaxis._length = o, this.yaxis._offset = a, this.yaxis._length = c;
      }, T.updateFx = function (t, e) {
        var r = this,
            o = r.graphDiv,
            s = r.bgRect,
            l = t.dragmode,
            u = t.clickmode;

        if (!r.isStatic) {
          var f;
          "select" === l ? f = function f(t, e) {
            (t.range = {})[r.id] = [y([e.xmin, e.ymin]), y([e.xmax, e.ymax])];
          } : "lasso" === l && (f = function f(t, e, n) {
            (t.lassoPoints = {})[r.id] = n.filtered.map(y);
          });
          var h = {
            element: r.bgRect.node(),
            gd: o,
            plotinfo: {
              id: r.id,
              xaxis: r.xaxis,
              yaxis: r.yaxis,
              fillRangeItems: f
            },
            xaxes: [r.xaxis],
            yaxes: [r.yaxis],
            subplot: r.id,
            clickFn: function clickFn(t) {
              2 === t && m(o);
            }
          };
          "pan" === l ? (s.node().onmousedown = null, s.call(v(r, e)), s.on("dblclick.zoom", function () {
            var t = r.viewInitial,
                e = {};

            for (var n in t) {
              e[r.id + "." + n] = t[n];
            }

            i.call("_guiRelayout", o, e), o.emit("plotly_doubleclick", null);
          }), o._context._scrollZoom.geo || s.on("wheel.zoom", null)) : "select" !== l && "lasso" !== l || (s.on(".zoom", null), h.prepFn = function (t, e, r) {
            d(t, e, r, h, l);
          }, p.init(h)), s.on("mousemove", function () {
            var t = r.projection.invert(a.getPositionFromD3Event());
            if (!t || isNaN(t[0]) || isNaN(t[1])) return p.unhover(o, n.event);
            r.xaxis.p2c = function () {
              return t[0];
            }, r.yaxis.p2c = function () {
              return t[1];
            }, c.hover(o, n.event, r.id);
          }), s.on("mouseout", function () {
            o._dragging || p.unhover(o, n.event);
          }), s.on("click", function () {
            "select" !== l && "lasso" !== l && (u.indexOf("select") > -1 && g(n.event, o, [r.xaxis], [r.yaxis], r.id, h), u.indexOf("event") > -1 && c.click(o, n.event));
          });
        }

        function y(t) {
          return r.projection.invert([t[0] + r.xaxis._offset, t[1] + r.yaxis._offset]);
        }
      }, T.makeFramework = function () {
        var t = this,
            e = t.graphDiv,
            r = e._fullLayout,
            i = "clip" + r._uid + t.id;
        t.clipDef = r._clips.append("clipPath").attr("id", i), t.clipRect = t.clipDef.append("rect"), t.framework = n.select(t.container).append("g").attr("class", "geo " + t.id).call(l.setClipUrl, i, e), t.project = function (e) {
          var r = t.projection(e);
          return r ? [r[0] - t.xaxis._offset, r[1] - t.yaxis._offset] : [null, null];
        }, t.xaxis = {
          _id: "x",
          c2p: function c2p(e) {
            return t.project(e)[0];
          }
        }, t.yaxis = {
          _id: "y",
          c2p: function c2p(e) {
            return t.project(e)[1];
          }
        }, t.mockAxis = {
          type: "linear",
          showexponent: "all",
          exponentformat: "B"
        }, f.setConvert(t.mockAxis, r);
      }, T.saveViewInitial = function (t) {
        var e,
            r = t.center || {},
            n = t.projection,
            i = n.rotation || {};
        this.viewInitial = {
          fitbounds: t.fitbounds,
          "projection.scale": n.scale
        }, e = t._isScoped ? {
          "center.lon": r.lon,
          "center.lat": r.lat
        } : t._isClipped ? {
          "projection.rotation.lon": i.lon,
          "projection.rotation.lat": i.lat
        } : {
          "center.lon": r.lon,
          "center.lat": r.lat,
          "projection.rotation.lon": i.lon
        }, a.extendFlat(this.viewInitial, e);
      }, T.render = function () {
        var t,
            e = this.projection,
            r = e.getPath();

        function n(t) {
          var r = e(t.lonlat);
          return r ? o(r[0], r[1]) : null;
        }

        function i(t) {
          return e.isLonLatOverEdges(t.lonlat) ? "none" : null;
        }

        for (t in this.basePaths) {
          this.basePaths[t].attr("d", r);
        }

        for (t in this.dataPaths) {
          this.dataPaths[t].attr("d", function (t) {
            return r(t.geojson);
          });
        }

        for (t in this.dataPoints) {
          this.dataPoints[t].attr("display", i).attr("transform", n);
        }
      };
    }, {
      "../../components/color": 658,
      "../../components/dragelement": 677,
      "../../components/drawing": 680,
      "../../components/fx": 698,
      "../../lib": 795,
      "../../lib/geo_location_utils": 788,
      "../../lib/topojson_utils": 823,
      "../../registry": 923,
      "../cartesian/autorange": 844,
      "../cartesian/axes": 845,
      "../cartesian/select": 864,
      "../plots": 909,
      "./constants": 875,
      "./projections": 880,
      "./zoom": 881,
      "@plotly/d3": 57,
      "topojson-client": 593
    }],
    877: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/get_data").getSubplotCalcData,
          i = t("../../lib").counterRegex,
          a = t("./geo"),
          o = "geo",
          s = i(o),
          l = {};
      l.geo = {
        valType: "subplotid",
        dflt: o,
        editType: "calc"
      }, e.exports = {
        attr: o,
        name: o,
        idRoot: o,
        idRegex: s,
        attrRegex: s,
        attributes: l,
        layoutAttributes: t("./layout_attributes"),
        supplyLayoutDefaults: t("./layout_defaults"),
        plot: function plot(t) {
          for (var e = t._fullLayout, r = t.calcdata, i = e._subplots.geo, s = 0; s < i.length; s++) {
            var l = i[s],
                c = n(r, o, l),
                u = e[l]._subplot;
            u || (u = a({
              id: l,
              graphDiv: t,
              container: e._geolayer.node(),
              topojsonURL: t._context.topojsonURL,
              staticPlot: t._context.staticPlot
            }), e[l]._subplot = u), u.plot(c, e, t._promises);
          }
        },
        updateFx: function updateFx(t) {
          for (var e = t._fullLayout, r = e._subplots.geo, n = 0; n < r.length; n++) {
            var i = e[r[n]];

            i._subplot.updateFx(e, i);
          }
        },
        clean: function clean(t, e, r, n) {
          for (var i = n._subplots.geo || [], a = 0; a < i.length; a++) {
            var o = i[a],
                s = n[o]._subplot;
            !e[o] && s && (s.framework.remove(), s.clipDef.remove());
          }
        }
      };
    }, {
      "../../lib": 795,
      "../../plots/get_data": 882,
      "./geo": 876,
      "./layout_attributes": 878,
      "./layout_defaults": 879
    }],
    878: [function (t, e, r) {
      "use strict";

      var n = t("../../components/color/attributes"),
          i = t("../domain").attributes,
          a = t("./constants"),
          o = t("../../plot_api/edit_types").overrideAll,
          s = {
        range: {
          valType: "info_array",
          items: [{
            valType: "number"
          }, {
            valType: "number"
          }]
        },
        showgrid: {
          valType: "boolean",
          dflt: !1
        },
        tick0: {
          valType: "number",
          dflt: 0
        },
        dtick: {
          valType: "number"
        },
        gridcolor: {
          valType: "color",
          dflt: n.lightLine
        },
        gridwidth: {
          valType: "number",
          min: 0,
          dflt: 1
        }
      };
      (e.exports = o({
        domain: i({
          name: "geo"
        }, {}),
        fitbounds: {
          valType: "enumerated",
          values: [!1, "locations", "geojson"],
          dflt: !1,
          editType: "plot"
        },
        resolution: {
          valType: "enumerated",
          values: [110, 50],
          dflt: 110,
          coerceNumber: !0
        },
        scope: {
          valType: "enumerated",
          values: Object.keys(a.scopeDefaults),
          dflt: "world"
        },
        projection: {
          type: {
            valType: "enumerated",
            values: Object.keys(a.projNames)
          },
          rotation: {
            lon: {
              valType: "number"
            },
            lat: {
              valType: "number"
            },
            roll: {
              valType: "number"
            }
          },
          parallels: {
            valType: "info_array",
            items: [{
              valType: "number"
            }, {
              valType: "number"
            }]
          },
          scale: {
            valType: "number",
            min: 0,
            dflt: 1
          }
        },
        center: {
          lon: {
            valType: "number"
          },
          lat: {
            valType: "number"
          }
        },
        visible: {
          valType: "boolean",
          dflt: !0
        },
        showcoastlines: {
          valType: "boolean"
        },
        coastlinecolor: {
          valType: "color",
          dflt: n.defaultLine
        },
        coastlinewidth: {
          valType: "number",
          min: 0,
          dflt: 1
        },
        showland: {
          valType: "boolean",
          dflt: !1
        },
        landcolor: {
          valType: "color",
          dflt: a.landColor
        },
        showocean: {
          valType: "boolean",
          dflt: !1
        },
        oceancolor: {
          valType: "color",
          dflt: a.waterColor
        },
        showlakes: {
          valType: "boolean",
          dflt: !1
        },
        lakecolor: {
          valType: "color",
          dflt: a.waterColor
        },
        showrivers: {
          valType: "boolean",
          dflt: !1
        },
        rivercolor: {
          valType: "color",
          dflt: a.waterColor
        },
        riverwidth: {
          valType: "number",
          min: 0,
          dflt: 1
        },
        showcountries: {
          valType: "boolean"
        },
        countrycolor: {
          valType: "color",
          dflt: n.defaultLine
        },
        countrywidth: {
          valType: "number",
          min: 0,
          dflt: 1
        },
        showsubunits: {
          valType: "boolean"
        },
        subunitcolor: {
          valType: "color",
          dflt: n.defaultLine
        },
        subunitwidth: {
          valType: "number",
          min: 0,
          dflt: 1
        },
        showframe: {
          valType: "boolean"
        },
        framecolor: {
          valType: "color",
          dflt: n.defaultLine
        },
        framewidth: {
          valType: "number",
          min: 0,
          dflt: 1
        },
        bgcolor: {
          valType: "color",
          dflt: n.background
        },
        lonaxis: s,
        lataxis: s
      }, "plot", "from-root")).uirevision = {
        valType: "any",
        editType: "none"
      };
    }, {
      "../../components/color/attributes": 657,
      "../../plot_api/edit_types": 827,
      "../domain": 872,
      "./constants": 875
    }],
    879: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../subplot_defaults"),
          a = t("../get_data").getSubplotData,
          o = t("./constants"),
          s = t("./layout_attributes"),
          l = o.axesNames;

      function c(t, e, r, i) {
        var s = a(i.fullData, "geo", i.id).map(function (t) {
          return t._expandedIndex;
        }),
            c = r("resolution"),
            u = r("scope"),
            f = o.scopeDefaults[u],
            h = r("projection.type", f.projType),
            p = e._isAlbersUsa = "albers usa" === h;
        p && (u = e.scope = "usa");
        var d = e._isScoped = "world" !== u,
            m = e._isConic = -1 !== h.indexOf("conic"),
            g = e._isClipped = !!o.lonaxisSpan[h];

        if (!1 === t.visible) {
          var v = n.extendDeep({}, e._template);
          v.showcoastlines = !1, v.showcountries = !1, v.showframe = !1, v.showlakes = !1, v.showland = !1, v.showocean = !1, v.showrivers = !1, v.showsubunits = !1, v.lonaxis && (v.lonaxis.showgrid = !1), v.lataxis && (v.lataxis.showgrid = !1), e._template = v;
        }

        for (var y = r("visible"), x = 0; x < l.length; x++) {
          var b,
              _ = l[x],
              w = [30, 10][x];
          if (d) b = f[_ + "Range"];else {
            var T = o[_ + "Span"],
                k = (T[h] || T["*"]) / 2,
                M = r("projection.rotation." + _.substr(0, 3), f.projRotate[x]);
            b = [M - k, M + k];
          }
          var A = r(_ + ".range", b);
          r(_ + ".tick0"), r(_ + ".dtick", w), r(_ + ".showgrid", !!y && void 0) && (r(_ + ".gridcolor"), r(_ + ".gridwidth")), e[_]._ax = {
            type: "linear",
            _id: _.slice(0, 3),
            _traceIndices: s,
            setScale: n.identity,
            c2l: n.identity,
            r2l: n.identity,
            autorange: !0,
            range: A.slice(),
            _m: 1,
            _input: {}
          };
        }

        var S = e.lonaxis.range,
            E = e.lataxis.range,
            L = S[0],
            C = S[1];
        L > 0 && C < 0 && (C += 360);
        var P,
            I,
            O,
            z = (L + C) / 2;

        if (!p) {
          var D = d ? f.projRotate : [z, 0, 0];
          P = r("projection.rotation.lon", D[0]), r("projection.rotation.lat", D[1]), r("projection.rotation.roll", D[2]), r("showcoastlines", !d && y) && (r("coastlinecolor"), r("coastlinewidth")), r("showocean", !!y && void 0) && r("oceancolor");
        }

        (p ? (I = -96.6, O = 38.7) : (I = d ? z : P, O = (E[0] + E[1]) / 2), r("center.lon", I), r("center.lat", O), m) && r("projection.parallels", f.projParallels || [0, 60]);
        r("projection.scale"), r("showland", !!y && void 0) && r("landcolor"), r("showlakes", !!y && void 0) && r("lakecolor"), r("showrivers", !!y && void 0) && (r("rivercolor"), r("riverwidth")), r("showcountries", d && "usa" !== u && y) && (r("countrycolor"), r("countrywidth")), ("usa" === u || "north america" === u && 50 === c) && (r("showsubunits", y), r("subunitcolor"), r("subunitwidth")), d || r("showframe", y) && (r("framecolor"), r("framewidth")), r("bgcolor"), r("fitbounds") && (delete e.projection.scale, d ? (delete e.center.lon, delete e.center.lat) : g ? (delete e.center.lon, delete e.center.lat, delete e.projection.rotation.lon, delete e.projection.rotation.lat, delete e.lonaxis.range, delete e.lataxis.range) : (delete e.center.lon, delete e.center.lat, delete e.projection.rotation.lon));
      }

      e.exports = function (t, e, r) {
        i(t, e, r, {
          type: "geo",
          attributes: s,
          handleDefaults: c,
          fullData: r,
          partition: "y"
        });
      };
    }, {
      "../../lib": 795,
      "../get_data": 882,
      "../subplot_defaults": 917,
      "./constants": 875,
      "./layout_attributes": 878
    }],
    880: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        function e(t, e) {
          return {
            type: "Feature",
            id: t.id,
            properties: t.properties,
            geometry: r(t.geometry, e)
          };
        }

        function r(e, n) {
          if (!e) return null;
          if ("GeometryCollection" === e.type) return {
            type: "GeometryCollection",
            geometries: object.geometries.map(function (t) {
              return r(t, n);
            })
          };
          if (!c.hasOwnProperty(e.type)) return null;
          var i = c[e.type];
          return t.geo.stream(e, n(i)), i.result();
        }

        t.geo.project = function (t, e) {
          var i = e.stream;
          if (!i) throw new Error("not yet supported");
          return (t && n.hasOwnProperty(t.type) ? n[t.type] : r)(t, i);
        };

        var n = {
          Feature: e,
          FeatureCollection: function FeatureCollection(t, r) {
            return {
              type: "FeatureCollection",
              features: t.features.map(function (t) {
                return e(t, r);
              })
            };
          }
        },
            i = [],
            a = [],
            o = {
          point: function point(t, e) {
            i.push([t, e]);
          },
          result: function result() {
            var t = i.length ? i.length < 2 ? {
              type: "Point",
              coordinates: i[0]
            } : {
              type: "MultiPoint",
              coordinates: i
            } : null;
            return i = [], t;
          }
        },
            s = {
          lineStart: u,
          point: function point(t, e) {
            i.push([t, e]);
          },
          lineEnd: function lineEnd() {
            i.length && (a.push(i), i = []);
          },
          result: function result() {
            var t = a.length ? a.length < 2 ? {
              type: "LineString",
              coordinates: a[0]
            } : {
              type: "MultiLineString",
              coordinates: a
            } : null;
            return a = [], t;
          }
        },
            l = {
          polygonStart: u,
          lineStart: u,
          point: function point(t, e) {
            i.push([t, e]);
          },
          lineEnd: function lineEnd() {
            var t = i.length;

            if (t) {
              do {
                i.push(i[0].slice());
              } while (++t < 4);

              a.push(i), i = [];
            }
          },
          polygonEnd: u,
          result: function result() {
            if (!a.length) return null;
            var t = [],
                e = [];
            return a.forEach(function (r) {
              !function (t) {
                if ((e = t.length) < 4) return !1;
                var e,
                    r = 0,
                    n = t[e - 1][1] * t[0][0] - t[e - 1][0] * t[0][1];

                for (; ++r < e;) {
                  n += t[r - 1][1] * t[r][0] - t[r - 1][0] * t[r][1];
                }

                return n <= 0;
              }(r) ? e.push(r) : t.push([r]);
            }), e.forEach(function (e) {
              var r = e[0];
              t.some(function (t) {
                if (function (t, e) {
                  for (var r = e[0], n = e[1], i = !1, a = 0, o = t.length, s = o - 1; a < o; s = a++) {
                    var l = t[a],
                        c = l[0],
                        u = l[1],
                        f = t[s],
                        h = f[0],
                        p = f[1];
                    u > n ^ p > n && r < (h - c) * (n - u) / (p - u) + c && (i = !i);
                  }

                  return i;
                }(t[0], r)) return t.push(e), !0;
              }) || t.push([e]);
            }), a = [], t.length ? t.length > 1 ? {
              type: "MultiPolygon",
              coordinates: t
            } : {
              type: "Polygon",
              coordinates: t[0]
            } : null;
          }
        },
            c = {
          Point: o,
          MultiPoint: o,
          LineString: s,
          MultiLineString: s,
          Polygon: l,
          MultiPolygon: l,
          Sphere: l
        };

        function u() {}

        var f = 1e-6,
            h = Math.PI,
            p = h / 2,
            d = (Math.sqrt(h), h / 180),
            m = 180 / h;

        function g(t) {
          return t > 1 ? p : t < -1 ? -p : Math.asin(t);
        }

        function v(t) {
          return t > 1 ? 0 : t < -1 ? h : Math.acos(t);
        }

        var y = t.geo.projection,
            x = t.geo.projectionMutator;

        function b(t, e) {
          var r = (2 + p) * Math.sin(e);
          e /= 2;

          for (var n = 0, i = 1 / 0; n < 10 && Math.abs(i) > f; n++) {
            var a = Math.cos(e);
            e -= i = (e + Math.sin(e) * (a + 2) - r) / (2 * a * (1 + a));
          }

          return [2 / Math.sqrt(h * (4 + h)) * t * (1 + Math.cos(e)), 2 * Math.sqrt(h / (4 + h)) * Math.sin(e)];
        }

        t.geo.interrupt = function (e) {
          var r,
              n = [[[[-h, 0], [0, p], [h, 0]]], [[[-h, 0], [0, -p], [h, 0]]]];

          function i(t, r) {
            for (var i = r < 0 ? -1 : 1, a = n[+(r < 0)], o = 0, s = a.length - 1; o < s && t > a[o][2][0]; ++o) {
              ;
            }

            var l = e(t - a[o][1][0], r);
            return l[0] += e(a[o][1][0], i * r > i * a[o][0][1] ? a[o][0][1] : r)[0], l;
          }

          function a() {
            r = n.map(function (t) {
              return t.map(function (t) {
                var r,
                    n = e(t[0][0], t[0][1])[0],
                    i = e(t[2][0], t[2][1])[0],
                    a = e(t[1][0], t[0][1])[1],
                    o = e(t[1][0], t[1][1])[1];
                return a > o && (r = a, a = o, o = r), [[n, a], [i, o]];
              });
            });
          }

          e.invert && (i.invert = function (t, a) {
            for (var o = r[+(a < 0)], s = n[+(a < 0)], l = 0, u = o.length; l < u; ++l) {
              var f = o[l];

              if (f[0][0] <= t && t < f[1][0] && f[0][1] <= a && a < f[1][1]) {
                var h = e.invert(t - e(s[l][1][0], 0)[0], a);
                return h[0] += s[l][1][0], c(i(h[0], h[1]), [t, a]) ? h : null;
              }
            }
          });
          var o = t.geo.projection(i),
              s = o.stream;

          function l(t, e) {
            for (var r, n, i, a = -1, o = t.length, s = t[0], l = []; ++a < o;) {
              n = ((r = t[a])[0] - s[0]) / e, i = (r[1] - s[1]) / e;

              for (var c = 0; c < e; ++c) {
                l.push([s[0] + c * n, s[1] + c * i]);
              }

              s = r;
            }

            return l.push(r), l;
          }

          function c(t, e) {
            return Math.abs(t[0] - e[0]) < f && Math.abs(t[1] - e[1]) < f;
          }

          return o.stream = function (e) {
            var r = o.rotate(),
                i = s(e),
                a = (o.rotate([0, 0]), s(e));
            return o.rotate(r), i.sphere = function () {
              t.geo.stream(function () {
                for (var e = 1e-6, r = [], i = 0, a = n[0].length; i < a; ++i) {
                  var o = 180 * (p = n[0][i])[0][0] / h,
                      s = 180 * p[0][1] / h,
                      c = 180 * p[1][1] / h,
                      u = 180 * p[2][0] / h,
                      f = 180 * p[2][1] / h;
                  r.push(l([[o + e, s + e], [o + e, c - e], [u - e, c - e], [u - e, f + e]], 30));
                }

                for (i = n[1].length - 1; i >= 0; --i) {
                  var p;
                  o = 180 * (p = n[1][i])[0][0] / h, s = 180 * p[0][1] / h, c = 180 * p[1][1] / h, u = 180 * p[2][0] / h, f = 180 * p[2][1] / h;
                  r.push(l([[u - e, f - e], [u - e, c + e], [o + e, c + e], [o + e, s - e]], 30));
                }

                return {
                  type: "Polygon",
                  coordinates: [t.merge(r)]
                };
              }(), a);
            }, i;
          }, o.lobes = function (t) {
            return arguments.length ? (n = t.map(function (t) {
              return t.map(function (t) {
                return [[t[0][0] * h / 180, t[0][1] * h / 180], [t[1][0] * h / 180, t[1][1] * h / 180], [t[2][0] * h / 180, t[2][1] * h / 180]];
              });
            }), a(), o) : n.map(function (t) {
              return t.map(function (t) {
                return [[180 * t[0][0] / h, 180 * t[0][1] / h], [180 * t[1][0] / h, 180 * t[1][1] / h], [180 * t[2][0] / h, 180 * t[2][1] / h]];
              });
            });
          }, o;
        }, b.invert = function (t, e) {
          var r = .5 * e * Math.sqrt((4 + h) / h),
              n = g(r),
              i = Math.cos(n);
          return [t / (2 / Math.sqrt(h * (4 + h)) * (1 + i)), g((n + r * (i + 2)) / (2 + p))];
        }, (t.geo.eckert4 = function () {
          return y(b);
        }).raw = b;
        var _ = t.geo.azimuthalEqualArea.raw;

        function w(t, e) {
          if (arguments.length < 2 && (e = t), 1 === e) return _;
          if (e === 1 / 0) return T;

          function r(r, n) {
            var i = _(r / e, n);

            return i[0] *= t, i;
          }

          return r.invert = function (r, n) {
            var i = _.invert(r / t, n);

            return i[0] *= e, i;
          }, r;
        }

        function T(t, e) {
          return [t * Math.cos(e) / Math.cos(e /= 2), 2 * Math.sin(e)];
        }

        function k(t, e) {
          return [3 * t / (2 * h) * Math.sqrt(h * h / 3 - e * e), e];
        }

        function M(t, e) {
          return [t, 1.25 * Math.log(Math.tan(h / 4 + .4 * e))];
        }

        function A(t) {
          return function (e) {
            var r,
                n = t * Math.sin(e),
                i = 30;

            do {
              e -= r = (e + Math.sin(e) - n) / (1 + Math.cos(e));
            } while (Math.abs(r) > f && --i > 0);

            return e / 2;
          };
        }

        T.invert = function (t, e) {
          var r = 2 * g(e / 2);
          return [t * Math.cos(r / 2) / Math.cos(r), r];
        }, (t.geo.hammer = function () {
          var t = 2,
              e = x(w),
              r = e(t);
          return r.coefficient = function (r) {
            return arguments.length ? e(t = +r) : t;
          }, r;
        }).raw = w, k.invert = function (t, e) {
          return [2 / 3 * h * t / Math.sqrt(h * h / 3 - e * e), e];
        }, (t.geo.kavrayskiy7 = function () {
          return y(k);
        }).raw = k, M.invert = function (t, e) {
          return [t, 2.5 * Math.atan(Math.exp(.8 * e)) - .625 * h];
        }, (t.geo.miller = function () {
          return y(M);
        }).raw = M, A(h);

        var S = function (t, e, r) {
          var n = A(r);

          function i(r, i) {
            return [t * r * Math.cos(i = n(i)), e * Math.sin(i)];
          }

          return i.invert = function (n, i) {
            var a = g(i / e);
            return [n / (t * Math.cos(a)), g((2 * a + Math.sin(2 * a)) / r)];
          }, i;
        }(Math.SQRT2 / p, Math.SQRT2, h);

        function E(t, e) {
          var r = e * e,
              n = r * r;
          return [t * (.8707 - .131979 * r + n * (n * (.003971 * r - .001529 * n) - .013791)), e * (1.007226 + r * (.015085 + n * (.028874 * r - .044475 - .005916 * n)))];
        }

        (t.geo.mollweide = function () {
          return y(S);
        }).raw = S, E.invert = function (t, e) {
          var r,
              n = e,
              i = 25;

          do {
            var a = n * n,
                o = a * a;
            n -= r = (n * (1.007226 + a * (.015085 + o * (.028874 * a - .044475 - .005916 * o))) - e) / (1.007226 + a * (.045255 + o * (.259866 * a - .311325 - .005916 * 11 * o)));
          } while (Math.abs(r) > f && --i > 0);

          return [t / (.8707 + (a = n * n) * (a * (a * a * a * (.003971 - .001529 * a) - .013791) - .131979)), n];
        }, (t.geo.naturalEarth = function () {
          return y(E);
        }).raw = E;
        var L = [[.9986, -.062], [1, 0], [.9986, .062], [.9954, .124], [.99, .186], [.9822, .248], [.973, .31], [.96, .372], [.9427, .434], [.9216, .4958], [.8962, .5571], [.8679, .6176], [.835, .6769], [.7986, .7346], [.7597, .7903], [.7186, .8435], [.6732, .8936], [.6213, .9394], [.5722, .9761], [.5322, 1]];

        function C(t, e) {
          var r,
              n = Math.min(18, 36 * Math.abs(e) / h),
              i = Math.floor(n),
              a = n - i,
              o = (r = L[i])[0],
              s = r[1],
              l = (r = L[++i])[0],
              c = r[1],
              u = (r = L[Math.min(19, ++i)])[0],
              f = r[1];
          return [t * (l + a * (u - o) / 2 + a * a * (u - 2 * l + o) / 2), (e > 0 ? p : -p) * (c + a * (f - s) / 2 + a * a * (f - 2 * c + s) / 2)];
        }

        function P(t, e) {
          return [t * Math.cos(e), e];
        }

        function I(t, e) {
          var r,
              n = Math.cos(e),
              i = (r = v(n * Math.cos(t /= 2))) ? r / Math.sin(r) : 1;
          return [2 * n * Math.sin(t) * i, Math.sin(e) * i];
        }

        function O(t, e) {
          var r = I(t, e);
          return [(r[0] + t / p) / 2, (r[1] + e) / 2];
        }

        L.forEach(function (t) {
          t[1] *= 1.0144;
        }), C.invert = function (t, e) {
          var r = e / p,
              n = 90 * r,
              i = Math.min(18, Math.abs(n / 5)),
              a = Math.max(0, Math.floor(i));

          do {
            var o = L[a][1],
                s = L[a + 1][1],
                l = L[Math.min(19, a + 2)][1],
                c = l - o,
                u = l - 2 * s + o,
                f = 2 * (Math.abs(r) - s) / c,
                h = u / c,
                g = f * (1 - h * f * (1 - 2 * h * f));

            if (g >= 0 || 1 === a) {
              n = (e >= 0 ? 5 : -5) * (g + i);
              var v,
                  y = 50;

              do {
                g = (i = Math.min(18, Math.abs(n) / 5)) - (a = Math.floor(i)), o = L[a][1], s = L[a + 1][1], l = L[Math.min(19, a + 2)][1], n -= (v = (e >= 0 ? p : -p) * (s + g * (l - o) / 2 + g * g * (l - 2 * s + o) / 2) - e) * m;
              } while (Math.abs(v) > 1e-12 && --y > 0);

              break;
            }
          } while (--a >= 0);

          var x = L[a][0],
              b = L[a + 1][0],
              _ = L[Math.min(19, a + 2)][0];
          return [t / (b + g * (_ - x) / 2 + g * g * (_ - 2 * b + x) / 2), n * d];
        }, (t.geo.robinson = function () {
          return y(C);
        }).raw = C, P.invert = function (t, e) {
          return [t / Math.cos(e), e];
        }, (t.geo.sinusoidal = function () {
          return y(P);
        }).raw = P, I.invert = function (t, e) {
          if (!(t * t + 4 * e * e > h * h + f)) {
            var r = t,
                n = e,
                i = 25;

            do {
              var a,
                  o = Math.sin(r),
                  s = Math.sin(r / 2),
                  l = Math.cos(r / 2),
                  c = Math.sin(n),
                  u = Math.cos(n),
                  p = Math.sin(2 * n),
                  d = c * c,
                  m = u * u,
                  g = s * s,
                  y = 1 - m * l * l,
                  x = y ? v(u * l) * Math.sqrt(a = 1 / y) : a = 0,
                  b = 2 * x * u * s - t,
                  _ = x * c - e,
                  w = a * (m * g + x * u * l * d),
                  T = a * (.5 * o * p - 2 * x * c * s),
                  k = .25 * a * (p * s - x * c * m * o),
                  M = a * (d * l + x * g * u),
                  A = T * k - M * w;

              if (!A) break;
              var S = (_ * T - b * M) / A,
                  E = (b * k - _ * w) / A;
              r -= S, n -= E;
            } while ((Math.abs(S) > f || Math.abs(E) > f) && --i > 0);

            return [r, n];
          }
        }, (t.geo.aitoff = function () {
          return y(I);
        }).raw = I, O.invert = function (t, e) {
          var r = t,
              n = e,
              i = 25;

          do {
            var a,
                o = Math.cos(n),
                s = Math.sin(n),
                l = Math.sin(2 * n),
                c = s * s,
                u = o * o,
                h = Math.sin(r),
                d = Math.cos(r / 2),
                m = Math.sin(r / 2),
                g = m * m,
                y = 1 - u * d * d,
                x = y ? v(o * d) * Math.sqrt(a = 1 / y) : a = 0,
                b = .5 * (2 * x * o * m + r / p) - t,
                _ = .5 * (x * s + n) - e,
                w = .5 * a * (u * g + x * o * d * c) + .5 / p,
                T = a * (h * l / 4 - x * s * m),
                k = .125 * a * (l * m - x * s * u * h),
                M = .5 * a * (c * d + x * g * o) + .5,
                A = T * k - M * w,
                S = (_ * T - b * M) / A,
                E = (b * k - _ * w) / A;

            r -= S, n -= E;
          } while ((Math.abs(S) > f || Math.abs(E) > f) && --i > 0);

          return [r, n];
        }, (t.geo.winkel3 = function () {
          return y(O);
        }).raw = O;
      };
    }, {}],
    881: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../lib"),
          a = t("../../registry"),
          o = Math.PI / 180,
          s = 180 / Math.PI,
          l = {
        cursor: "pointer"
      },
          c = {
        cursor: "auto"
      };

      function u(t, e) {
        return n.behavior.zoom().translate(e.translate()).scale(e.scale());
      }

      function f(t, e, r) {
        var n = t.id,
            o = t.graphDiv,
            s = o.layout,
            l = s[n],
            c = o._fullLayout,
            u = c[n],
            f = {},
            h = {};

        function p(t, e) {
          f[n + "." + t] = i.nestedProperty(l, t).get(), a.call("_storeDirectGUIEdit", s, c._preGUI, f);
          var r = i.nestedProperty(u, t);
          r.get() !== e && (r.set(e), i.nestedProperty(l, t).set(e), h[n + "." + t] = e);
        }

        r(p), p("projection.scale", e.scale() / t.fitScale), p("fitbounds", !1), o.emit("plotly_relayout", h);
      }

      function h(t, e) {
        var r = u(0, e);

        function i(r) {
          var n = e.invert(t.midPt);
          r("center.lon", n[0]), r("center.lat", n[1]);
        }

        return r.on("zoomstart", function () {
          n.select(this).style(l);
        }).on("zoom", function () {
          e.scale(n.event.scale).translate(n.event.translate), t.render();
          var r = e.invert(t.midPt);
          t.graphDiv.emit("plotly_relayouting", {
            "geo.projection.scale": e.scale() / t.fitScale,
            "geo.center.lon": r[0],
            "geo.center.lat": r[1]
          });
        }).on("zoomend", function () {
          n.select(this).style(c), f(t, e, i);
        }), r;
      }

      function p(t, e) {
        var r,
            i,
            a,
            o,
            s,
            h,
            p,
            d,
            m,
            g = u(0, e);

        function v(t) {
          return e.invert(t);
        }

        function y(r) {
          var n = e.rotate(),
              i = e.invert(t.midPt);
          r("projection.rotation.lon", -n[0]), r("center.lon", i[0]), r("center.lat", i[1]);
        }

        return g.on("zoomstart", function () {
          n.select(this).style(l), r = n.mouse(this), i = e.rotate(), a = e.translate(), o = i, s = v(r);
        }).on("zoom", function () {
          if (h = n.mouse(this), function (t) {
            var r = v(t);
            if (!r) return !0;
            var n = e(r);
            return Math.abs(n[0] - t[0]) > 2 || Math.abs(n[1] - t[1]) > 2;
          }(r)) return g.scale(e.scale()), void g.translate(e.translate());
          e.scale(n.event.scale), e.translate([a[0], n.event.translate[1]]), s ? v(h) && (d = v(h), p = [o[0] + (d[0] - s[0]), i[1], i[2]], e.rotate(p), o = p) : s = v(r = h), m = !0, t.render();
          var l = e.rotate(),
              c = e.invert(t.midPt);
          t.graphDiv.emit("plotly_relayouting", {
            "geo.projection.scale": e.scale() / t.fitScale,
            "geo.center.lon": c[0],
            "geo.center.lat": c[1],
            "geo.projection.rotation.lon": -l[0]
          });
        }).on("zoomend", function () {
          n.select(this).style(c), m && f(t, e, y);
        }), g;
      }

      function d(t, e) {
        var r,
            i = {
          r: e.rotate(),
          k: e.scale()
        },
            a = u(0, e),
            o = function (t) {
          var e = 0,
              r = arguments.length,
              i = [];

          for (; ++e < r;) {
            i.push(arguments[e]);
          }

          var a = n.dispatch.apply(null, i);
          return a.of = function (e, r) {
            return function (i) {
              var o;

              try {
                o = i.sourceEvent = n.event, i.target = t, n.event = i, a[i.type].apply(e, r);
              } finally {
                n.event = o;
              }
            };
          }, a;
        }(a, "zoomstart", "zoom", "zoomend"),
            s = 0,
            h = a.on;

        function p(t) {
          s++ || t({
            type: "zoomstart"
          });
        }

        function d(t) {
          t({
            type: "zoom"
          });
        }

        function b(t) {
          --s || t({
            type: "zoomend"
          });
        }

        function _(t) {
          var r = e.rotate();
          t("projection.rotation.lon", -r[0]), t("projection.rotation.lat", -r[1]);
        }

        return a.on("zoomstart", function () {
          n.select(this).style(l);
          var t = n.mouse(this),
              s = e.rotate(),
              c = s,
              u = e.translate(),
              f = g(s);
          r = m(e, t), h.call(a, "zoom", function () {
            var a = n.mouse(this);

            if (e.scale(i.k = n.event.scale), r) {
              if (m(e, a)) {
                e.rotate(s).translate(u);
                var l = m(e, a),
                    h = y(r, l),
                    p = T(v(f, h)),
                    g = i.r = x(p, r, c);
                isFinite(g[0]) && isFinite(g[1]) && isFinite(g[2]) || (g = c), e.rotate(g), c = g;
              }
            } else r = m(e, t = a);

            d(o.of(this, arguments));
          }), p(o.of(this, arguments));
        }).on("zoomend", function () {
          n.select(this).style(c), h.call(a, "zoom", null), b(o.of(this, arguments)), f(t, e, _);
        }).on("zoom.redraw", function () {
          t.render();
          var r = e.rotate();
          t.graphDiv.emit("plotly_relayouting", {
            "geo.projection.scale": e.scale() / t.fitScale,
            "geo.projection.rotation.lon": -r[0],
            "geo.projection.rotation.lat": -r[1]
          });
        }), n.rebind(a, o, "on");
      }

      function m(t, e) {
        var r = t.invert(e);
        return r && isFinite(r[0]) && isFinite(r[1]) && function (t) {
          var e = t[0] * o,
              r = t[1] * o,
              n = Math.cos(r);
          return [n * Math.cos(e), n * Math.sin(e), Math.sin(r)];
        }(r);
      }

      function g(t) {
        var e = .5 * t[0] * o,
            r = .5 * t[1] * o,
            n = .5 * t[2] * o,
            i = Math.sin(e),
            a = Math.cos(e),
            s = Math.sin(r),
            l = Math.cos(r),
            c = Math.sin(n),
            u = Math.cos(n);
        return [a * l * u + i * s * c, i * l * u - a * s * c, a * s * u + i * l * c, a * l * c - i * s * u];
      }

      function v(t, e) {
        var r = t[0],
            n = t[1],
            i = t[2],
            a = t[3],
            o = e[0],
            s = e[1],
            l = e[2],
            c = e[3];
        return [r * o - n * s - i * l - a * c, r * s + n * o + i * c - a * l, r * l - n * c + i * o + a * s, r * c + n * l - i * s + a * o];
      }

      function y(t, e) {
        if (t && e) {
          var r = function (t, e) {
            return [t[1] * e[2] - t[2] * e[1], t[2] * e[0] - t[0] * e[2], t[0] * e[1] - t[1] * e[0]];
          }(t, e),
              n = Math.sqrt(k(r, r)),
              i = .5 * Math.acos(Math.max(-1, Math.min(1, k(t, e)))),
              a = Math.sin(i) / n;

          return n && [Math.cos(i), r[2] * a, -r[1] * a, r[0] * a];
        }
      }

      function x(t, e, r) {
        var n = w(e, 2, t[0]);
        n = w(n, 1, t[1]), n = w(n, 0, t[2] - r[2]);
        var i,
            a,
            o = e[0],
            l = e[1],
            c = e[2],
            u = n[0],
            f = n[1],
            h = n[2],
            p = Math.atan2(l, o) * s,
            d = Math.sqrt(o * o + l * l);
        Math.abs(f) > d ? (a = (f > 0 ? 90 : -90) - p, i = 0) : (a = Math.asin(f / d) * s - p, i = Math.sqrt(d * d - f * f));
        var m = 180 - a - 2 * p,
            g = (Math.atan2(h, u) - Math.atan2(c, i)) * s,
            v = (Math.atan2(h, u) - Math.atan2(c, -i)) * s;
        return b(r[0], r[1], a, g) <= b(r[0], r[1], m, v) ? [a, g, r[2]] : [m, v, r[2]];
      }

      function b(t, e, r, n) {
        var i = _(r - t),
            a = _(n - e);

        return Math.sqrt(i * i + a * a);
      }

      function _(t) {
        return (t % 360 + 540) % 360 - 180;
      }

      function w(t, e, r) {
        var n = r * o,
            i = t.slice(),
            a = 0 === e ? 1 : 0,
            s = 2 === e ? 1 : 2,
            l = Math.cos(n),
            c = Math.sin(n);
        return i[a] = t[a] * l - t[s] * c, i[s] = t[s] * l + t[a] * c, i;
      }

      function T(t) {
        return [Math.atan2(2 * (t[0] * t[1] + t[2] * t[3]), 1 - 2 * (t[1] * t[1] + t[2] * t[2])) * s, Math.asin(Math.max(-1, Math.min(1, 2 * (t[0] * t[2] - t[3] * t[1])))) * s, Math.atan2(2 * (t[0] * t[3] + t[1] * t[2]), 1 - 2 * (t[2] * t[2] + t[3] * t[3])) * s];
      }

      function k(t, e) {
        for (var r = 0, n = 0, i = t.length; n < i; ++n) {
          r += t[n] * e[n];
        }

        return r;
      }

      e.exports = function (t, e) {
        var r = t.projection;
        return (e._isScoped ? h : e._isClipped ? d : p)(t, r);
      };
    }, {
      "../../lib": 795,
      "../../registry": 923,
      "@plotly/d3": 57
    }],
    882: [function (t, e, r) {
      "use strict";

      var n = t("../registry"),
          i = t("./cartesian/constants").SUBPLOT_PATTERN;
      r.getSubplotCalcData = function (t, e, r) {
        var i = n.subplotsRegistry[e];
        if (!i) return [];

        for (var a = i.attr, o = [], s = 0; s < t.length; s++) {
          var l = t[s];
          l[0].trace[a] === r && o.push(l);
        }

        return o;
      }, r.getModuleCalcData = function (t, e) {
        var r,
            i = [],
            a = [];
        if (!(r = "string" == typeof e ? n.getModule(e).plot : "function" == typeof e ? e : e.plot)) return [i, t];

        for (var o = 0; o < t.length; o++) {
          var s = t[o],
              l = s[0].trace;
          !0 === l.visible && 0 !== l._length && (l._module.plot === r ? i.push(s) : a.push(s));
        }

        return [i, a];
      }, r.getSubplotData = function (t, e, r) {
        if (!n.subplotsRegistry[e]) return [];
        var a,
            o,
            s,
            l = n.subplotsRegistry[e].attr,
            c = [];

        if ("gl2d" === e) {
          var u = r.match(i);
          o = "x" + u[1], s = "y" + u[2];
        }

        for (var f = 0; f < t.length; f++) {
          a = t[f], "gl2d" === e && n.traceIs(a, "gl2d") ? a[l[0]] === o && a[l[1]] === s && c.push(a) : a[l] === r && c.push(a);
        }

        return c;
      };
    }, {
      "../registry": 923,
      "./cartesian/constants": 851
    }],
    883: [function (t, e, r) {
      "use strict";

      var n = t("mouse-change"),
          i = t("mouse-wheel"),
          a = t("mouse-event-offset"),
          o = t("../cartesian/constants"),
          s = t("has-passive-events");

      function l(t, e) {
        this.element = t, this.plot = e, this.mouseListener = null, this.wheelListener = null, this.lastInputTime = Date.now(), this.lastPos = [0, 0], this.boxEnabled = !1, this.boxInited = !1, this.boxStart = [0, 0], this.boxEnd = [0, 0], this.dragStart = [0, 0];
      }

      e.exports = function (t) {
        var e = t.mouseContainer,
            r = t.glplot,
            c = new l(e, r);

        function u() {
          t.xaxis.autorange = !1, t.yaxis.autorange = !1;
        }

        function f(e, n, i) {
          var a,
              s,
              l = t.calcDataBox(),
              f = r.viewBox,
              h = c.lastPos[0],
              p = c.lastPos[1],
              d = o.MINDRAG * r.pixelRatio,
              m = o.MINZOOM * r.pixelRatio;

          function g(e, r, n) {
            var i = Math.min(r, n),
                a = Math.max(r, n);
            i !== a ? (l[e] = i, l[e + 2] = a, c.dataBox = l, t.setRanges(l)) : (t.selectBox.selectBox = [0, 0, 1, 1], t.glplot.setDirty());
          }

          switch (n *= r.pixelRatio, i *= r.pixelRatio, i = f[3] - f[1] - i, t.fullLayout.dragmode) {
            case "zoom":
              if (e) {
                var v = n / (f[2] - f[0]) * (l[2] - l[0]) + l[0],
                    y = i / (f[3] - f[1]) * (l[3] - l[1]) + l[1];
                c.boxInited || (c.boxStart[0] = v, c.boxStart[1] = y, c.dragStart[0] = n, c.dragStart[1] = i), c.boxEnd[0] = v, c.boxEnd[1] = y, c.boxInited = !0, c.boxEnabled || c.boxStart[0] === c.boxEnd[0] && c.boxStart[1] === c.boxEnd[1] || (c.boxEnabled = !0);
                var x = Math.abs(c.dragStart[0] - n) < m,
                    b = Math.abs(c.dragStart[1] - i) < m;
                if (!function () {
                  for (var e = t.graphDiv._fullLayout._axisConstraintGroups, r = t.xaxis._id, n = t.yaxis._id, i = 0; i < e.length; i++) {
                    if (-1 !== e[i][r]) {
                      if (-1 !== e[i][n]) return !0;
                      break;
                    }
                  }

                  return !1;
                }() || x && b) x && (c.boxEnd[0] = c.boxStart[0]), b && (c.boxEnd[1] = c.boxStart[1]);else {
                  a = c.boxEnd[0] - c.boxStart[0], s = c.boxEnd[1] - c.boxStart[1];

                  var _ = (l[3] - l[1]) / (l[2] - l[0]);

                  Math.abs(a * _) > Math.abs(s) ? (c.boxEnd[1] = c.boxStart[1] + Math.abs(a) * _ * (s >= 0 ? 1 : -1), c.boxEnd[1] < l[1] ? (c.boxEnd[1] = l[1], c.boxEnd[0] = c.boxStart[0] + (l[1] - c.boxStart[1]) / Math.abs(_)) : c.boxEnd[1] > l[3] && (c.boxEnd[1] = l[3], c.boxEnd[0] = c.boxStart[0] + (l[3] - c.boxStart[1]) / Math.abs(_))) : (c.boxEnd[0] = c.boxStart[0] + Math.abs(s) / _ * (a >= 0 ? 1 : -1), c.boxEnd[0] < l[0] ? (c.boxEnd[0] = l[0], c.boxEnd[1] = c.boxStart[1] + (l[0] - c.boxStart[0]) * Math.abs(_)) : c.boxEnd[0] > l[2] && (c.boxEnd[0] = l[2], c.boxEnd[1] = c.boxStart[1] + (l[2] - c.boxStart[0]) * Math.abs(_)));
                }
              } else c.boxEnabled ? (a = c.boxStart[0] !== c.boxEnd[0], s = c.boxStart[1] !== c.boxEnd[1], a || s ? (a && (g(0, c.boxStart[0], c.boxEnd[0]), t.xaxis.autorange = !1), s && (g(1, c.boxStart[1], c.boxEnd[1]), t.yaxis.autorange = !1), t.relayoutCallback()) : t.glplot.setDirty(), c.boxEnabled = !1, c.boxInited = !1) : c.boxInited && (c.boxInited = !1);

              break;

            case "pan":
              c.boxEnabled = !1, c.boxInited = !1, e ? (c.panning || (c.dragStart[0] = n, c.dragStart[1] = i), Math.abs(c.dragStart[0] - n) < d && (n = c.dragStart[0]), Math.abs(c.dragStart[1] - i) < d && (i = c.dragStart[1]), a = (h - n) * (l[2] - l[0]) / (r.viewBox[2] - r.viewBox[0]), s = (p - i) * (l[3] - l[1]) / (r.viewBox[3] - r.viewBox[1]), l[0] += a, l[2] += a, l[1] += s, l[3] += s, t.setRanges(l), c.panning = !0, c.lastInputTime = Date.now(), u(), t.cameraChanged(), t.handleAnnotations()) : c.panning && (c.panning = !1, t.relayoutCallback());
          }

          c.lastPos[0] = n, c.lastPos[1] = i;
        }

        return c.mouseListener = n(e, f), e.addEventListener("touchstart", function (t) {
          var r = a(t.changedTouches[0], e);
          f(0, r[0], r[1]), f(1, r[0], r[1]), t.preventDefault();
        }, !!s && {
          passive: !1
        }), e.addEventListener("touchmove", function (t) {
          t.preventDefault();
          var r = a(t.changedTouches[0], e);
          f(1, r[0], r[1]), t.preventDefault();
        }, !!s && {
          passive: !1
        }), e.addEventListener("touchend", function (t) {
          f(0, c.lastPos[0], c.lastPos[1]), t.preventDefault();
        }, !!s && {
          passive: !1
        }), c.wheelListener = i(e, function (e, n) {
          if (!t.scrollZoom) return !1;
          var i = t.calcDataBox(),
              a = r.viewBox,
              o = c.lastPos[0],
              s = c.lastPos[1],
              l = Math.exp(5 * n / (a[3] - a[1])),
              f = o / (a[2] - a[0]) * (i[2] - i[0]) + i[0],
              h = s / (a[3] - a[1]) * (i[3] - i[1]) + i[1];
          return i[0] = (i[0] - f) * l + f, i[2] = (i[2] - f) * l + f, i[1] = (i[1] - h) * l + h, i[3] = (i[3] - h) * l + h, t.setRanges(i), c.lastInputTime = Date.now(), u(), t.cameraChanged(), t.handleAnnotations(), t.relayoutCallback(), !0;
        }, !0), c;
      };
    }, {
      "../cartesian/constants": 851,
      "has-passive-events": 435,
      "mouse-change": 462,
      "mouse-event-offset": 463,
      "mouse-wheel": 465
    }],
    884: [function (t, e, r) {
      "use strict";

      var n = t("../cartesian/axes"),
          i = t("../../lib/str2rgbarray");

      function a(t) {
        this.scene = t, this.gl = t.gl, this.pixelRatio = t.pixelRatio, this.screenBox = [0, 0, 1, 1], this.viewBox = [0, 0, 1, 1], this.dataBox = [-1, -1, 1, 1], this.borderLineEnable = [!1, !1, !1, !1], this.borderLineWidth = [1, 1, 1, 1], this.borderLineColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.ticks = [[], []], this.tickEnable = [!0, !0, !1, !1], this.tickPad = [15, 15, 15, 15], this.tickAngle = [0, 0, 0, 0], this.tickColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.tickMarkLength = [0, 0, 0, 0], this.tickMarkWidth = [0, 0, 0, 0], this.tickMarkColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.labels = ["x", "y"], this.labelEnable = [!0, !0, !1, !1], this.labelAngle = [0, Math.PI / 2, 0, 3 * Math.PI / 2], this.labelPad = [15, 15, 15, 15], this.labelSize = [12, 12], this.labelFont = ["sans-serif", "sans-serif"], this.labelColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.title = "", this.titleEnable = !0, this.titleCenter = [0, 0, 0, 0], this.titleAngle = 0, this.titleColor = [0, 0, 0, 1], this.titleFont = "sans-serif", this.titleSize = 18, this.gridLineEnable = [!0, !0], this.gridLineColor = [[0, 0, 0, .5], [0, 0, 0, .5]], this.gridLineWidth = [1, 1], this.zeroLineEnable = [!0, !0], this.zeroLineWidth = [1, 1], this.zeroLineColor = [[0, 0, 0, 1], [0, 0, 0, 1]], this.borderColor = [0, 0, 0, 0], this.backgroundColor = [0, 0, 0, 0], this.static = this.scene.staticPlot;
      }

      var o = a.prototype,
          s = ["xaxis", "yaxis"];
      o.merge = function (t) {
        var e, r, n, a, o, l, c, u, f, h, p;

        for (this.titleEnable = !1, this.backgroundColor = i(t.plot_bgcolor), h = 0; h < 2; ++h) {
          var d = (e = s[h]).charAt(0);

          for (n = (r = t[this.scene[e]._name]).title.text === this.scene.fullLayout._dfltTitle[d] ? "" : r.title.text, p = 0; p <= 2; p += 2) {
            this.labelEnable[h + p] = !1, this.labels[h + p] = n, this.labelColor[h + p] = i(r.title.font.color), this.labelFont[h + p] = r.title.font.family, this.labelSize[h + p] = r.title.font.size, this.labelPad[h + p] = this.getLabelPad(e, r), this.tickEnable[h + p] = !1, this.tickColor[h + p] = i((r.tickfont || {}).color), this.tickAngle[h + p] = "auto" === r.tickangle ? 0 : Math.PI * -r.tickangle / 180, this.tickPad[h + p] = this.getTickPad(r), this.tickMarkLength[h + p] = 0, this.tickMarkWidth[h + p] = r.tickwidth || 0, this.tickMarkColor[h + p] = i(r.tickcolor), this.borderLineEnable[h + p] = !1, this.borderLineColor[h + p] = i(r.linecolor), this.borderLineWidth[h + p] = r.linewidth || 0;
          }

          c = this.hasSharedAxis(r), o = this.hasAxisInDfltPos(e, r) && !c, l = this.hasAxisInAltrPos(e, r) && !c, a = r.mirror || !1, u = c ? -1 !== String(a).indexOf("all") : !!a, f = c ? "allticks" === a : -1 !== String(a).indexOf("ticks"), o ? this.labelEnable[h] = !0 : l && (this.labelEnable[h + 2] = !0), o ? this.tickEnable[h] = r.showticklabels : l && (this.tickEnable[h + 2] = r.showticklabels), (o || u) && (this.borderLineEnable[h] = r.showline), (l || u) && (this.borderLineEnable[h + 2] = r.showline), (o || f) && (this.tickMarkLength[h] = this.getTickMarkLength(r)), (l || f) && (this.tickMarkLength[h + 2] = this.getTickMarkLength(r)), this.gridLineEnable[h] = r.showgrid, this.gridLineColor[h] = i(r.gridcolor), this.gridLineWidth[h] = r.gridwidth, this.zeroLineEnable[h] = r.zeroline, this.zeroLineColor[h] = i(r.zerolinecolor), this.zeroLineWidth[h] = r.zerolinewidth;
        }
      }, o.hasSharedAxis = function (t) {
        var e = this.scene,
            r = e.fullLayout._subplots.gl2d;
        return 0 !== n.findSubplotsWithAxis(r, t).indexOf(e.id);
      }, o.hasAxisInDfltPos = function (t, e) {
        var r = e.side;
        return "xaxis" === t ? "bottom" === r : "yaxis" === t ? "left" === r : void 0;
      }, o.hasAxisInAltrPos = function (t, e) {
        var r = e.side;
        return "xaxis" === t ? "top" === r : "yaxis" === t ? "right" === r : void 0;
      }, o.getLabelPad = function (t, e) {
        var r = e.title.font.size,
            n = e.showticklabels;
        return "xaxis" === t ? "top" === e.side ? r * (1.5 + (n ? 1 : 0)) - 10 : r * (1.5 + (n ? .5 : 0)) - 10 : "yaxis" === t ? "right" === e.side ? 10 + r * (1.5 + (n ? 1 : .5)) : 10 + r * (1.5 + (n ? .5 : 0)) : void 0;
      }, o.getTickPad = function (t) {
        return "outside" === t.ticks ? 10 + t.ticklen : 15;
      }, o.getTickMarkLength = function (t) {
        if (!t.ticks) return 0;
        var e = t.ticklen;
        return "inside" === t.ticks ? -e : e;
      }, e.exports = function (t) {
        return new a(t);
      };
    }, {
      "../../lib/str2rgbarray": 819,
      "../cartesian/axes": 845
    }],
    885: [function (t, e, r) {
      "use strict";

      var n = t("../../plot_api/edit_types").overrideAll,
          i = t("./scene2d"),
          a = t("../layout_attributes"),
          o = t("../../constants/xmlns_namespaces"),
          s = t("../cartesian/constants"),
          l = t("../cartesian"),
          c = t("../../components/fx/layout_attributes"),
          u = t("../get_data").getSubplotData;
      r.name = "gl2d", r.attr = ["xaxis", "yaxis"], r.idRoot = ["x", "y"], r.idRegex = s.idRegex, r.attrRegex = s.attrRegex, r.attributes = t("../cartesian/attributes"), r.supplyLayoutDefaults = function (t, e, r) {
        e._has("cartesian") || l.supplyLayoutDefaults(t, e, r);
      }, r.layoutAttrOverrides = n(l.layoutAttributes, "plot", "from-root"), r.baseLayoutAttrOverrides = n({
        plot_bgcolor: a.plot_bgcolor,
        hoverlabel: c.hoverlabel
      }, "plot", "nested"), r.plot = function (t) {
        for (var e = t._fullLayout, r = t._fullData, n = e._subplots.gl2d, a = 0; a < n.length; a++) {
          var o = n[a],
              s = e._plots[o],
              l = u(r, "gl2d", o),
              c = s._scene2d;
          void 0 === c && (c = new i({
            id: o,
            graphDiv: t,
            container: t.querySelector(".gl-container"),
            staticPlot: t._context.staticPlot,
            plotGlPixelRatio: t._context.plotGlPixelRatio
          }, e), s._scene2d = c), c.plot(l, t.calcdata, e, t.layout);
        }
      }, r.clean = function (t, e, r, n) {
        for (var i = n._subplots.gl2d || [], a = 0; a < i.length; a++) {
          var o = i[a],
              s = n._plots[o];

          if (s._scene2d) {
            var c = u(t, "gl2d", o);
            0 === c.length && (s._scene2d.destroy(), delete n._plots[o]);
          }
        }

        l.clean.apply(this, arguments);
      }, r.drawFramework = function (t) {
        t._context.staticPlot || l.drawFramework(t);
      }, r.toSVG = function (t) {
        for (var e = t._fullLayout, r = e._subplots.gl2d, n = 0; n < r.length; n++) {
          var i = e._plots[r[n]]._scene2d,
              a = i.toImage("png");
          e._glimages.append("svg:image").attr({
            xmlns: o.svg,
            "xlink:href": a,
            x: 0,
            y: 0,
            width: "100%",
            height: "100%",
            preserveAspectRatio: "none"
          }), i.destroy();
        }
      }, r.updateFx = function (t) {
        for (var e = t._fullLayout, r = e._subplots.gl2d, n = 0; n < r.length; n++) {
          e._plots[r[n]]._scene2d.updateFx(e.dragmode);
        }
      };
    }, {
      "../../components/fx/layout_attributes": 699,
      "../../constants/xmlns_namespaces": 772,
      "../../plot_api/edit_types": 827,
      "../cartesian": 858,
      "../cartesian/attributes": 843,
      "../cartesian/constants": 851,
      "../get_data": 882,
      "../layout_attributes": 900,
      "./scene2d": 886
    }],
    886: [function (t, e, r) {
      "use strict";

      var n,
          i,
          a = t("../../registry"),
          o = t("../../plots/cartesian/axes"),
          s = t("../../components/fx"),
          l = t("gl-plot2d"),
          c = t("gl-spikes2d"),
          u = t("gl-select-box"),
          f = t("webgl-context"),
          h = t("./convert"),
          p = t("./camera"),
          d = t("../../lib/show_no_webgl_msg"),
          m = t("../cartesian/constraints"),
          g = m.enforce,
          v = m.clean,
          y = t("../cartesian/autorange").doAutoRange,
          x = t("../../components/dragelement/helpers"),
          b = x.drawMode,
          _ = x.selectMode,
          w = ["xaxis", "yaxis"],
          T = t("../cartesian/constants").SUBPLOT_PATTERN;

      function k(t, e) {
        this.container = t.container, this.graphDiv = t.graphDiv, this.pixelRatio = t.plotGlPixelRatio || window.devicePixelRatio, this.id = t.id, this.staticPlot = !!t.staticPlot, this.scrollZoom = this.graphDiv._context._scrollZoom.cartesian, this.fullData = null, this.updateRefs(e), this.makeFramework(), this.stopped || (this.glplotOptions = h(this), this.glplotOptions.merge(e), this.glplot = l(this.glplotOptions), this.camera = p(this), this.traces = {}, this.spikes = c(this.glplot), this.selectBox = u(this.glplot, {
          innerFill: !1,
          outerFill: !0
        }), this.lastButtonState = 0, this.pickResult = null, this.isMouseOver = !0, this.stopped = !1, this.redraw = this.draw.bind(this), this.redraw());
      }

      e.exports = k;
      var M = k.prototype;
      M.makeFramework = function () {
        if (this.staticPlot) {
          if (!(i || (n = document.createElement("canvas"), i = f({
            canvas: n,
            preserveDrawingBuffer: !1,
            premultipliedAlpha: !0,
            antialias: !0
          })))) throw new Error("Error creating static canvas/context for image server");
          this.canvas = n, this.gl = i;
        } else {
          var t = this.container.querySelector(".gl-canvas-focus"),
              e = f({
            canvas: t,
            preserveDrawingBuffer: !0,
            premultipliedAlpha: !0
          });
          if (!e) return d(this), void (this.stopped = !0);
          this.canvas = t, this.gl = e;
        }

        var r = this.canvas;
        r.style.width = "100%", r.style.height = "100%", r.style.position = "absolute", r.style.top = "0px", r.style.left = "0px", r.style["pointer-events"] = "none", this.updateSize(r);
        var a = this.svgContainer = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        a.style.position = "absolute", a.style.top = a.style.left = "0px", a.style.width = a.style.height = "100%", a.style["z-index"] = 20, a.style["pointer-events"] = "none";
        var o = this.mouseContainer = document.createElement("div");
        o.style.position = "absolute", o.style["pointer-events"] = "auto", this.pickCanvas = this.container.querySelector(".gl-canvas-pick");
        var s = this.container;
        s.appendChild(a), s.appendChild(o);
        var l = this;
        o.addEventListener("mouseout", function () {
          l.isMouseOver = !1, l.unhover();
        }), o.addEventListener("mouseover", function () {
          l.isMouseOver = !0;
        });
      }, M.toImage = function (t) {
        t || (t = "png"), this.stopped = !0, this.staticPlot && this.container.appendChild(n), this.updateSize(this.canvas);
        var e = this.glplot.gl,
            r = e.drawingBufferWidth,
            i = e.drawingBufferHeight;
        e.clearColor(1, 1, 1, 0), e.clear(e.COLOR_BUFFER_BIT | e.DEPTH_BUFFER_BIT), this.glplot.setDirty(), this.glplot.draw(), e.bindFramebuffer(e.FRAMEBUFFER, null);
        var a = new Uint8Array(r * i * 4);
        e.readPixels(0, 0, r, i, e.RGBA, e.UNSIGNED_BYTE, a);

        for (var o = 0, s = i - 1; o < s; ++o, --s) {
          for (var l = 0; l < r; ++l) {
            for (var c = 0; c < 4; ++c) {
              var u = a[4 * (r * o + l) + c];
              a[4 * (r * o + l) + c] = a[4 * (r * s + l) + c], a[4 * (r * s + l) + c] = u;
            }
          }
        }

        var f = document.createElement("canvas");
        f.width = r, f.height = i;
        var h,
            p = f.getContext("2d"),
            d = p.createImageData(r, i);

        switch (d.data.set(a), p.putImageData(d, 0, 0), t) {
          case "jpeg":
            h = f.toDataURL("image/jpeg");
            break;

          case "webp":
            h = f.toDataURL("image/webp");
            break;

          default:
            h = f.toDataURL("image/png");
        }

        return this.staticPlot && this.container.removeChild(n), h;
      }, M.updateSize = function (t) {
        t || (t = this.canvas);
        var e = this.pixelRatio,
            r = this.fullLayout,
            n = r.width,
            i = r.height,
            a = 0 | Math.ceil(e * n),
            o = 0 | Math.ceil(e * i);
        return t.width === a && t.height === o || (t.width = a, t.height = o), t;
      }, M.computeTickMarks = function () {
        this.xaxis.setScale(), this.yaxis.setScale();

        for (var t = [o.calcTicks(this.xaxis), o.calcTicks(this.yaxis)], e = 0; e < 2; ++e) {
          for (var r = 0; r < t[e].length; ++r) {
            t[e][r].text = t[e][r].text + "";
          }
        }

        return t;
      }, M.updateRefs = function (t) {
        this.fullLayout = t;
        var e = this.id.match(T),
            r = "xaxis" + e[1],
            n = "yaxis" + e[2];
        this.xaxis = this.fullLayout[r], this.yaxis = this.fullLayout[n];
      }, M.relayoutCallback = function () {
        var t = this.graphDiv,
            e = this.xaxis,
            r = this.yaxis,
            n = t.layout,
            i = {},
            o = i[e._name + ".range"] = e.range.slice(),
            s = i[r._name + ".range"] = r.range.slice();
        i[e._name + ".autorange"] = e.autorange, i[r._name + ".autorange"] = r.autorange, a.call("_storeDirectGUIEdit", t.layout, t._fullLayout._preGUI, i);
        var l = n[e._name];
        l.range = o, l.autorange = e.autorange;
        var c = n[r._name];
        c.range = s, c.autorange = r.autorange, i.lastInputTime = this.camera.lastInputTime, t.emit("plotly_relayout", i);
      }, M.cameraChanged = function () {
        var t = this.camera;
        this.glplot.setDataBox(this.calcDataBox());
        var e = this.computeTickMarks();
        (function (t, e) {
          for (var r = 0; r < 2; ++r) {
            var n = t[r],
                i = e[r];
            if (n.length !== i.length) return !0;

            for (var a = 0; a < n.length; ++a) {
              if (n[a].x !== i[a].x) return !0;
            }
          }

          return !1;
        })(e, this.glplotOptions.ticks) && (this.glplotOptions.ticks = e, this.glplotOptions.dataBox = t.dataBox, this.glplot.update(this.glplotOptions), this.handleAnnotations());
      }, M.handleAnnotations = function () {
        for (var t = this.graphDiv, e = this.fullLayout.annotations, r = 0; r < e.length; r++) {
          var n = e[r];
          n.xref === this.xaxis._id && n.yref === this.yaxis._id && a.getComponentMethod("annotations", "drawOne")(t, r);
        }
      }, M.destroy = function () {
        if (this.glplot) {
          var t = this.traces;
          t && Object.keys(t).map(function (e) {
            t[e].dispose(), delete t[e];
          }), this.glplot.dispose(), this.container.removeChild(this.svgContainer), this.container.removeChild(this.mouseContainer), this.fullData = null, this.glplot = null, this.stopped = !0, this.camera.mouseListener.enabled = !1, this.mouseContainer.removeEventListener("wheel", this.camera.wheelListener), this.camera = null;
        }
      }, M.plot = function (t, e, r) {
        var n = this.glplot;
        this.updateRefs(r), this.xaxis.clearCalc(), this.yaxis.clearCalc(), this.updateTraces(t, e), this.updateFx(r.dragmode);
        var i = r.width,
            a = r.height;
        this.updateSize(this.canvas);
        var o = this.glplotOptions;
        o.merge(r), o.screenBox = [0, 0, i, a];
        var s = {
          _fullLayout: {
            _axisConstraintGroups: r._axisConstraintGroups,
            xaxis: this.xaxis,
            yaxis: this.yaxis,
            _size: r._size
          }
        };
        v(s, this.xaxis), v(s, this.yaxis);
        var l,
            c,
            u = r._size,
            f = this.xaxis.domain,
            h = this.yaxis.domain;

        for (o.viewBox = [u.l + f[0] * u.w, u.b + h[0] * u.h, i - u.r - (1 - f[1]) * u.w, a - u.t - (1 - h[1]) * u.h], this.mouseContainer.style.width = u.w * (f[1] - f[0]) + "px", this.mouseContainer.style.height = u.h * (h[1] - h[0]) + "px", this.mouseContainer.height = u.h * (h[1] - h[0]), this.mouseContainer.style.left = u.l + f[0] * u.w + "px", this.mouseContainer.style.top = u.t + (1 - h[1]) * u.h + "px", c = 0; c < 2; ++c) {
          (l = this[w[c]])._length = o.viewBox[c + 2] - o.viewBox[c], y(this.graphDiv, l), l.setScale();
        }

        g(s), o.ticks = this.computeTickMarks(), o.dataBox = this.calcDataBox(), o.merge(r), n.update(o), this.glplot.draw();
      }, M.calcDataBox = function () {
        var t = this.xaxis,
            e = this.yaxis,
            r = t.range,
            n = e.range,
            i = t.r2l,
            a = e.r2l;
        return [i(r[0]), a(n[0]), i(r[1]), a(n[1])];
      }, M.setRanges = function (t) {
        var e = this.xaxis,
            r = this.yaxis,
            n = e.l2r,
            i = r.l2r;
        e.range = [n(t[0]), n(t[2])], r.range = [i(t[1]), i(t[3])];
      }, M.updateTraces = function (t, e) {
        var r,
            n,
            i,
            a = Object.keys(this.traces);
        this.fullData = t;

        t: for (r = 0; r < a.length; r++) {
          var o = a[r],
              s = this.traces[o];

          for (n = 0; n < t.length; n++) {
            if ((i = t[n]).uid === o && i.type === s.type) continue t;
          }

          s.dispose(), delete this.traces[o];
        }

        for (r = 0; r < t.length; r++) {
          i = t[r];
          var l = e[r],
              c = this.traces[i.uid];
          c ? c.update(i, l) : (c = i._module.plot(this, i, l), this.traces[i.uid] = c);
        }

        this.glplot.objects.sort(function (t, e) {
          return t._trace.index - e._trace.index;
        });
      }, M.updateFx = function (t) {
        _(t) || b(t) ? (this.pickCanvas.style["pointer-events"] = "none", this.mouseContainer.style["pointer-events"] = "none") : (this.pickCanvas.style["pointer-events"] = "auto", this.mouseContainer.style["pointer-events"] = "auto"), this.mouseContainer.style.cursor = "pan" === t ? "move" : "zoom" === t ? "crosshair" : null;
      }, M.emitPointAction = function (t, e) {
        for (var r, n = t.trace.uid, i = t.pointIndex, a = 0; a < this.fullData.length; a++) {
          this.fullData[a].uid === n && (r = this.fullData[a]);
        }

        var o = {
          x: t.traceCoord[0],
          y: t.traceCoord[1],
          curveNumber: r.index,
          pointNumber: i,
          data: r._input,
          fullData: this.fullData,
          xaxis: this.xaxis,
          yaxis: this.yaxis
        };
        s.appendArrayPointValue(o, r, i), this.graphDiv.emit(e, {
          points: [o]
        });
      }, M.draw = function () {
        if (!this.stopped) {
          requestAnimationFrame(this.redraw);
          var t = this.glplot,
              e = this.camera,
              r = e.mouseListener,
              n = 1 === this.lastButtonState && 0 === r.buttons,
              i = this.fullLayout;
          this.lastButtonState = r.buttons, this.cameraChanged();
          var a,
              o = r.x * t.pixelRatio,
              l = this.canvas.height - t.pixelRatio * r.y;

          if (e.boxEnabled && "zoom" === i.dragmode) {
            this.selectBox.enabled = !0;

            for (var c = this.selectBox.selectBox = [Math.min(e.boxStart[0], e.boxEnd[0]), Math.min(e.boxStart[1], e.boxEnd[1]), Math.max(e.boxStart[0], e.boxEnd[0]), Math.max(e.boxStart[1], e.boxEnd[1])], u = 0; u < 2; u++) {
              e.boxStart[u] === e.boxEnd[u] && (c[u] = t.dataBox[u], c[u + 2] = t.dataBox[u + 2]);
            }

            t.setDirty();
          } else if (!e.panning && this.isMouseOver) {
            this.selectBox.enabled = !1;

            var f = i._size,
                h = this.xaxis.domain,
                p = this.yaxis.domain,
                d = (a = t.pick(o / t.pixelRatio + f.l + h[0] * f.w, l / t.pixelRatio - (f.t + (1 - p[1]) * f.h))) && a.object._trace.handlePick(a);

            if (d && n && this.emitPointAction(d, "plotly_click"), a && "skip" !== a.object._trace.hoverinfo && i.hovermode && d && (!this.lastPickResult || this.lastPickResult.traceUid !== d.trace.uid || this.lastPickResult.dataCoord[0] !== d.dataCoord[0] || this.lastPickResult.dataCoord[1] !== d.dataCoord[1])) {
              var m = d;
              this.lastPickResult = {
                traceUid: d.trace ? d.trace.uid : null,
                dataCoord: d.dataCoord.slice()
              }, this.spikes.update({
                center: a.dataCoord
              }), m.screenCoord = [((t.viewBox[2] - t.viewBox[0]) * (a.dataCoord[0] - t.dataBox[0]) / (t.dataBox[2] - t.dataBox[0]) + t.viewBox[0]) / t.pixelRatio, (this.canvas.height - (t.viewBox[3] - t.viewBox[1]) * (a.dataCoord[1] - t.dataBox[1]) / (t.dataBox[3] - t.dataBox[1]) - t.viewBox[1]) / t.pixelRatio], this.emitPointAction(d, "plotly_hover");
              var g = this.fullData[m.trace.index] || {},
                  v = m.pointIndex,
                  y = s.castHoverinfo(g, i, v);

              if (y && "all" !== y) {
                var x = y.split("+");
                -1 === x.indexOf("x") && (m.traceCoord[0] = void 0), -1 === x.indexOf("y") && (m.traceCoord[1] = void 0), -1 === x.indexOf("z") && (m.traceCoord[2] = void 0), -1 === x.indexOf("text") && (m.textLabel = void 0), -1 === x.indexOf("name") && (m.name = void 0);
              }

              s.loneHover({
                x: m.screenCoord[0],
                y: m.screenCoord[1],
                xLabel: this.hoverFormatter("xaxis", m.traceCoord[0]),
                yLabel: this.hoverFormatter("yaxis", m.traceCoord[1]),
                zLabel: m.traceCoord[2],
                text: m.textLabel,
                name: m.name,
                color: s.castHoverOption(g, v, "bgcolor") || m.color,
                borderColor: s.castHoverOption(g, v, "bordercolor"),
                fontFamily: s.castHoverOption(g, v, "font.family"),
                fontSize: s.castHoverOption(g, v, "font.size"),
                fontColor: s.castHoverOption(g, v, "font.color"),
                nameLength: s.castHoverOption(g, v, "namelength"),
                textAlign: s.castHoverOption(g, v, "align")
              }, {
                container: this.svgContainer,
                gd: this.graphDiv
              });
            }
          }

          a || this.unhover(), t.draw();
        }
      }, M.unhover = function () {
        this.lastPickResult && (this.spikes.update({}), this.lastPickResult = null, this.graphDiv.emit("plotly_unhover"), s.loneUnhover(this.svgContainer));
      }, M.hoverFormatter = function (t, e) {
        if (void 0 !== e) {
          var r = this[t];
          return o.tickText(r, r.c2l(e), "hover").text;
        }
      };
    }, {
      "../../components/dragelement/helpers": 676,
      "../../components/fx": 698,
      "../../lib/show_no_webgl_msg": 817,
      "../../plots/cartesian/axes": 845,
      "../../registry": 923,
      "../cartesian/autorange": 844,
      "../cartesian/constants": 851,
      "../cartesian/constraints": 852,
      "./camera": 883,
      "./convert": 884,
      "gl-plot2d": 313,
      "gl-select-box": 328,
      "gl-spikes2d": 337,
      "webgl-context": 621
    }],
    887: [function (t, e, r) {
      "use strict";

      var n = t("../../plot_api/edit_types").overrideAll,
          i = t("../../components/fx/layout_attributes"),
          a = t("./scene"),
          o = t("../get_data").getSubplotData,
          s = t("../../lib"),
          l = t("../../constants/xmlns_namespaces");
      r.name = "gl3d", r.attr = "scene", r.idRoot = "scene", r.idRegex = r.attrRegex = s.counterRegex("scene"), r.attributes = t("./layout/attributes"), r.layoutAttributes = t("./layout/layout_attributes"), r.baseLayoutAttrOverrides = n({
        hoverlabel: i.hoverlabel
      }, "plot", "nested"), r.supplyLayoutDefaults = t("./layout/defaults"), r.plot = function (t) {
        for (var e = t._fullLayout, r = t._fullData, n = e._subplots.gl3d, i = 0; i < n.length; i++) {
          var s = n[i],
              l = o(r, "gl3d", s),
              c = e[s],
              u = c.camera,
              f = c._scene;
          f || (f = new a({
            id: s,
            graphDiv: t,
            container: t.querySelector(".gl-container"),
            staticPlot: t._context.staticPlot,
            plotGlPixelRatio: t._context.plotGlPixelRatio,
            camera: u
          }, e), c._scene = f), f.viewInitial || (f.viewInitial = {
            up: {
              x: u.up.x,
              y: u.up.y,
              z: u.up.z
            },
            eye: {
              x: u.eye.x,
              y: u.eye.y,
              z: u.eye.z
            },
            center: {
              x: u.center.x,
              y: u.center.y,
              z: u.center.z
            }
          }), f.plot(l, e, t.layout);
        }
      }, r.clean = function (t, e, r, n) {
        for (var i = n._subplots.gl3d || [], a = 0; a < i.length; a++) {
          var o = i[a];
          !e[o] && n[o]._scene && (n[o]._scene.destroy(), n._infolayer && n._infolayer.selectAll(".annotation-" + o).remove());
        }
      }, r.toSVG = function (t) {
        for (var e = t._fullLayout, r = e._subplots.gl3d, n = e._size, i = 0; i < r.length; i++) {
          var a = e[r[i]],
              o = a.domain,
              s = a._scene,
              c = s.toImage("png");
          e._glimages.append("svg:image").attr({
            xmlns: l.svg,
            "xlink:href": c,
            x: n.l + n.w * o.x[0],
            y: n.t + n.h * (1 - o.y[1]),
            width: n.w * (o.x[1] - o.x[0]),
            height: n.h * (o.y[1] - o.y[0]),
            preserveAspectRatio: "none"
          }), s.destroy();
        }
      }, r.cleanId = function (t) {
        if (t.match(/^scene[0-9]*$/)) {
          var e = t.substr(5);
          return "1" === e && (e = ""), "scene" + e;
        }
      }, r.updateFx = function (t) {
        for (var e = t._fullLayout, r = e._subplots.gl3d, n = 0; n < r.length; n++) {
          e[r[n]]._scene.updateFx(e.dragmode, e.hovermode);
        }
      };
    }, {
      "../../components/fx/layout_attributes": 699,
      "../../constants/xmlns_namespaces": 772,
      "../../lib": 795,
      "../../plot_api/edit_types": 827,
      "../get_data": 882,
      "./layout/attributes": 888,
      "./layout/defaults": 892,
      "./layout/layout_attributes": 893,
      "./scene": 897
    }],
    888: [function (t, e, r) {
      "use strict";

      e.exports = {
        scene: {
          valType: "subplotid",
          dflt: "scene",
          editType: "calc+clearAxisTypes"
        }
      };
    }, {}],
    889: [function (t, e, r) {
      "use strict";

      var n = t("../../../components/color"),
          i = t("../../cartesian/layout_attributes"),
          a = t("../../../lib/extend").extendFlat,
          o = t("../../../plot_api/edit_types").overrideAll;
      e.exports = o({
        visible: i.visible,
        showspikes: {
          valType: "boolean",
          dflt: !0
        },
        spikesides: {
          valType: "boolean",
          dflt: !0
        },
        spikethickness: {
          valType: "number",
          min: 0,
          dflt: 2
        },
        spikecolor: {
          valType: "color",
          dflt: n.defaultLine
        },
        showbackground: {
          valType: "boolean",
          dflt: !1
        },
        backgroundcolor: {
          valType: "color",
          dflt: "rgba(204, 204, 204, 0.5)"
        },
        showaxeslabels: {
          valType: "boolean",
          dflt: !0
        },
        color: i.color,
        categoryorder: i.categoryorder,
        categoryarray: i.categoryarray,
        title: {
          text: i.title.text,
          font: i.title.font
        },
        type: a({}, i.type, {
          values: ["-", "linear", "log", "date", "category"]
        }),
        autotypenumbers: i.autotypenumbers,
        autorange: i.autorange,
        rangemode: i.rangemode,
        range: a({}, i.range, {
          items: [{
            valType: "any",
            editType: "plot",
            impliedEdits: {
              "^autorange": !1
            }
          }, {
            valType: "any",
            editType: "plot",
            impliedEdits: {
              "^autorange": !1
            }
          }],
          anim: !1
        }),
        tickmode: i.tickmode,
        nticks: i.nticks,
        tick0: i.tick0,
        dtick: i.dtick,
        tickvals: i.tickvals,
        ticktext: i.ticktext,
        ticks: i.ticks,
        mirror: i.mirror,
        ticklen: i.ticklen,
        tickwidth: i.tickwidth,
        tickcolor: i.tickcolor,
        showticklabels: i.showticklabels,
        tickfont: i.tickfont,
        tickangle: i.tickangle,
        tickprefix: i.tickprefix,
        showtickprefix: i.showtickprefix,
        ticksuffix: i.ticksuffix,
        showticksuffix: i.showticksuffix,
        showexponent: i.showexponent,
        exponentformat: i.exponentformat,
        minexponent: i.minexponent,
        separatethousands: i.separatethousands,
        tickformat: i.tickformat,
        tickformatstops: i.tickformatstops,
        hoverformat: i.hoverformat,
        showline: i.showline,
        linecolor: i.linecolor,
        linewidth: i.linewidth,
        showgrid: i.showgrid,
        gridcolor: a({}, i.gridcolor, {
          dflt: "rgb(204, 204, 204)"
        }),
        gridwidth: i.gridwidth,
        zeroline: i.zeroline,
        zerolinecolor: i.zerolinecolor,
        zerolinewidth: i.zerolinewidth,
        _deprecated: {
          title: i._deprecated.title,
          titlefont: i._deprecated.titlefont
        }
      }, "plot", "from-root");
    }, {
      "../../../components/color": 658,
      "../../../lib/extend": 785,
      "../../../plot_api/edit_types": 827,
      "../../cartesian/layout_attributes": 859
    }],
    890: [function (t, e, r) {
      "use strict";

      var n = t("tinycolor2").mix,
          i = t("../../../lib"),
          a = t("../../../plot_api/plot_template"),
          o = t("./axis_attributes"),
          s = t("../../cartesian/type_defaults"),
          l = t("../../cartesian/axis_defaults"),
          c = ["xaxis", "yaxis", "zaxis"];

      e.exports = function (t, e, r) {
        var u, f;

        function h(t, e) {
          return i.coerce(u, f, o, t, e);
        }

        for (var p = 0; p < c.length; p++) {
          var d = c[p];
          u = t[d] || {}, (f = a.newContainer(e, d))._id = d[0] + r.scene, f._name = d, s(u, f, h, r), l(u, f, h, {
            font: r.font,
            letter: d[0],
            data: r.data,
            showGrid: !0,
            noTickson: !0,
            noTicklabelmode: !0,
            noTicklabelposition: !0,
            noTicklabeloverflow: !0,
            bgColor: r.bgColor,
            calendar: r.calendar
          }, r.fullLayout), h("gridcolor", n(f.color, r.bgColor, 13600 / 187).toRgbString()), h("title.text", d[0]), f.setScale = i.noop, h("showspikes") && (h("spikesides"), h("spikethickness"), h("spikecolor", f.color)), h("showaxeslabels"), h("showbackground") && h("backgroundcolor");
        }
      };
    }, {
      "../../../lib": 795,
      "../../../plot_api/plot_template": 834,
      "../../cartesian/axis_defaults": 847,
      "../../cartesian/type_defaults": 870,
      "./axis_attributes": 889,
      tinycolor2: 590
    }],
    891: [function (t, e, r) {
      "use strict";

      var n = t("../../../lib/str2rgbarray"),
          i = t("../../../lib"),
          a = ["xaxis", "yaxis", "zaxis"];

      function o() {
        this.bounds = [[-10, -10, -10], [10, 10, 10]], this.ticks = [[], [], []], this.tickEnable = [!0, !0, !0], this.tickFont = ["sans-serif", "sans-serif", "sans-serif"], this.tickSize = [12, 12, 12], this.tickAngle = [0, 0, 0], this.tickColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.tickPad = [18, 18, 18], this.labels = ["x", "y", "z"], this.labelEnable = [!0, !0, !0], this.labelFont = ["Open Sans", "Open Sans", "Open Sans"], this.labelSize = [20, 20, 20], this.labelColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.labelPad = [30, 30, 30], this.lineEnable = [!0, !0, !0], this.lineMirror = [!1, !1, !1], this.lineWidth = [1, 1, 1], this.lineColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.lineTickEnable = [!0, !0, !0], this.lineTickMirror = [!1, !1, !1], this.lineTickLength = [10, 10, 10], this.lineTickWidth = [1, 1, 1], this.lineTickColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.gridEnable = [!0, !0, !0], this.gridWidth = [1, 1, 1], this.gridColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.zeroEnable = [!0, !0, !0], this.zeroLineColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.zeroLineWidth = [2, 2, 2], this.backgroundEnable = [!0, !0, !0], this.backgroundColor = [[.8, .8, .8, .5], [.8, .8, .8, .5], [.8, .8, .8, .5]], this._defaultTickPad = this.tickPad.slice(), this._defaultLabelPad = this.labelPad.slice(), this._defaultLineTickLength = this.lineTickLength.slice();
      }

      o.prototype.merge = function (t, e) {
        for (var r = 0; r < 3; ++r) {
          var o = e[a[r]];
          o.visible ? (this.labels[r] = t._meta ? i.templateString(o.title.text, t._meta) : o.title.text, "font" in o.title && (o.title.font.color && (this.labelColor[r] = n(o.title.font.color)), o.title.font.family && (this.labelFont[r] = o.title.font.family), o.title.font.size && (this.labelSize[r] = o.title.font.size)), "showline" in o && (this.lineEnable[r] = o.showline), "linecolor" in o && (this.lineColor[r] = n(o.linecolor)), "linewidth" in o && (this.lineWidth[r] = o.linewidth), "showgrid" in o && (this.gridEnable[r] = o.showgrid), "gridcolor" in o && (this.gridColor[r] = n(o.gridcolor)), "gridwidth" in o && (this.gridWidth[r] = o.gridwidth), "log" === o.type ? this.zeroEnable[r] = !1 : "zeroline" in o && (this.zeroEnable[r] = o.zeroline), "zerolinecolor" in o && (this.zeroLineColor[r] = n(o.zerolinecolor)), "zerolinewidth" in o && (this.zeroLineWidth[r] = o.zerolinewidth), "ticks" in o && o.ticks ? this.lineTickEnable[r] = !0 : this.lineTickEnable[r] = !1, "ticklen" in o && (this.lineTickLength[r] = this._defaultLineTickLength[r] = o.ticklen), "tickcolor" in o && (this.lineTickColor[r] = n(o.tickcolor)), "tickwidth" in o && (this.lineTickWidth[r] = o.tickwidth), "tickangle" in o && (this.tickAngle[r] = "auto" === o.tickangle ? -3600 : Math.PI * -o.tickangle / 180), "showticklabels" in o && (this.tickEnable[r] = o.showticklabels), "tickfont" in o && (o.tickfont.color && (this.tickColor[r] = n(o.tickfont.color)), o.tickfont.family && (this.tickFont[r] = o.tickfont.family), o.tickfont.size && (this.tickSize[r] = o.tickfont.size)), "mirror" in o ? -1 !== ["ticks", "all", "allticks"].indexOf(o.mirror) ? (this.lineTickMirror[r] = !0, this.lineMirror[r] = !0) : !0 === o.mirror ? (this.lineTickMirror[r] = !1, this.lineMirror[r] = !0) : (this.lineTickMirror[r] = !1, this.lineMirror[r] = !1) : this.lineMirror[r] = !1, "showbackground" in o && !1 !== o.showbackground ? (this.backgroundEnable[r] = !0, this.backgroundColor[r] = n(o.backgroundcolor)) : this.backgroundEnable[r] = !1) : (this.tickEnable[r] = !1, this.labelEnable[r] = !1, this.lineEnable[r] = !1, this.lineTickEnable[r] = !1, this.gridEnable[r] = !1, this.zeroEnable[r] = !1, this.backgroundEnable[r] = !1);
        }
      }, e.exports = function (t, e) {
        var r = new o();
        return r.merge(t, e), r;
      };
    }, {
      "../../../lib": 795,
      "../../../lib/str2rgbarray": 819
    }],
    892: [function (t, e, r) {
      "use strict";

      var n = t("../../../lib"),
          i = t("../../../components/color"),
          a = t("../../../registry"),
          o = t("../../subplot_defaults"),
          s = t("./axis_defaults"),
          l = t("./layout_attributes"),
          c = t("../../get_data").getSubplotData;

      function u(t, e, r, n) {
        for (var o = r("bgcolor"), l = i.combine(o, n.paper_bgcolor), u = ["up", "center", "eye"], f = 0; f < u.length; f++) {
          r("camera." + u[f] + ".x"), r("camera." + u[f] + ".y"), r("camera." + u[f] + ".z");
        }

        r("camera.projection.type");
        var h = !!r("aspectratio.x") && !!r("aspectratio.y") && !!r("aspectratio.z"),
            p = r("aspectmode", h ? "manual" : "auto");
        h || (t.aspectratio = e.aspectratio = {
          x: 1,
          y: 1,
          z: 1
        }, "manual" === p && (e.aspectmode = "auto"), t.aspectmode = e.aspectmode);
        var d = c(n.fullData, "gl3d", n.id);
        s(t, e, {
          font: n.font,
          scene: n.id,
          data: d,
          bgColor: l,
          calendar: n.calendar,
          autotypenumbersDflt: n.autotypenumbersDflt,
          fullLayout: n.fullLayout
        }), a.getComponentMethod("annotations3d", "handleDefaults")(t, e, n);
        var m = n.getDfltFromLayout("dragmode");
        if (!1 !== m && !m) if (m = "orbit", t.camera && t.camera.up) {
          var g = t.camera.up.x,
              v = t.camera.up.y,
              y = t.camera.up.z;
          0 !== y && (g && v && y ? y / Math.sqrt(g * g + v * v + y * y) > .999 && (m = "turntable") : m = "turntable");
        } else m = "turntable";
        r("dragmode", m), r("hovermode", n.getDfltFromLayout("hovermode"));
      }

      e.exports = function (t, e, r) {
        var i = e._basePlotModules.length > 1;
        o(t, e, r, {
          type: "gl3d",
          attributes: l,
          handleDefaults: u,
          fullLayout: e,
          font: e.font,
          fullData: r,
          getDfltFromLayout: function getDfltFromLayout(e) {
            if (!i) return n.validate(t[e], l[e]) ? t[e] : void 0;
          },
          autotypenumbersDflt: e.autotypenumbers,
          paper_bgcolor: e.paper_bgcolor,
          calendar: e.calendar
        });
      };
    }, {
      "../../../components/color": 658,
      "../../../lib": 795,
      "../../../registry": 923,
      "../../get_data": 882,
      "../../subplot_defaults": 917,
      "./axis_defaults": 890,
      "./layout_attributes": 893
    }],
    893: [function (t, e, r) {
      "use strict";

      var n = t("./axis_attributes"),
          i = t("../../domain").attributes,
          a = t("../../../lib/extend").extendFlat,
          o = t("../../../lib").counterRegex;

      function s(t, e, r) {
        return {
          x: {
            valType: "number",
            dflt: t,
            editType: "camera"
          },
          y: {
            valType: "number",
            dflt: e,
            editType: "camera"
          },
          z: {
            valType: "number",
            dflt: r,
            editType: "camera"
          },
          editType: "camera"
        };
      }

      e.exports = {
        _arrayAttrRegexps: [o("scene", ".annotations", !0)],
        bgcolor: {
          valType: "color",
          dflt: "rgba(0,0,0,0)",
          editType: "plot"
        },
        camera: {
          up: a(s(0, 0, 1), {}),
          center: a(s(0, 0, 0), {}),
          eye: a(s(1.25, 1.25, 1.25), {}),
          projection: {
            type: {
              valType: "enumerated",
              values: ["perspective", "orthographic"],
              dflt: "perspective",
              editType: "calc"
            },
            editType: "calc"
          },
          editType: "camera"
        },
        domain: i({
          name: "scene",
          editType: "plot"
        }),
        aspectmode: {
          valType: "enumerated",
          values: ["auto", "cube", "data", "manual"],
          dflt: "auto",
          editType: "plot",
          impliedEdits: {
            "aspectratio.x": void 0,
            "aspectratio.y": void 0,
            "aspectratio.z": void 0
          }
        },
        aspectratio: {
          x: {
            valType: "number",
            min: 0,
            editType: "plot",
            impliedEdits: {
              "^aspectmode": "manual"
            }
          },
          y: {
            valType: "number",
            min: 0,
            editType: "plot",
            impliedEdits: {
              "^aspectmode": "manual"
            }
          },
          z: {
            valType: "number",
            min: 0,
            editType: "plot",
            impliedEdits: {
              "^aspectmode": "manual"
            }
          },
          editType: "plot",
          impliedEdits: {
            aspectmode: "manual"
          }
        },
        xaxis: n,
        yaxis: n,
        zaxis: n,
        dragmode: {
          valType: "enumerated",
          values: ["orbit", "turntable", "zoom", "pan", !1],
          editType: "plot"
        },
        hovermode: {
          valType: "enumerated",
          values: ["closest", !1],
          dflt: "closest",
          editType: "modebar"
        },
        uirevision: {
          valType: "any",
          editType: "none"
        },
        editType: "plot",
        _deprecated: {
          cameraposition: {
            valType: "info_array",
            editType: "camera"
          }
        }
      };
    }, {
      "../../../lib": 795,
      "../../../lib/extend": 785,
      "../../domain": 872,
      "./axis_attributes": 889
    }],
    894: [function (t, e, r) {
      "use strict";

      var n = t("../../../lib/str2rgbarray"),
          i = ["xaxis", "yaxis", "zaxis"];

      function a() {
        this.enabled = [!0, !0, !0], this.colors = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.drawSides = [!0, !0, !0], this.lineWidth = [1, 1, 1];
      }

      a.prototype.merge = function (t) {
        for (var e = 0; e < 3; ++e) {
          var r = t[i[e]];
          r.visible ? (this.enabled[e] = r.showspikes, this.colors[e] = n(r.spikecolor), this.drawSides[e] = r.spikesides, this.lineWidth[e] = r.spikethickness) : (this.enabled[e] = !1, this.drawSides[e] = !1);
        }
      }, e.exports = function (t) {
        var e = new a();
        return e.merge(t), e;
      };
    }, {
      "../../../lib/str2rgbarray": 819
    }],
    895: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        for (var e = t.axesOptions, r = t.glplot.axesPixels, s = t.fullSceneLayout, l = [[], [], []], c = 0; c < 3; ++c) {
          var u = s[a[c]];
          if (u._length = (r[c].hi - r[c].lo) * r[c].pixelsPerDataUnit / t.dataScale[c], Math.abs(u._length) === 1 / 0 || isNaN(u._length)) l[c] = [];else {
            u._input_range = u.range.slice(), u.range[0] = r[c].lo / t.dataScale[c], u.range[1] = r[c].hi / t.dataScale[c], u._m = 1 / (t.dataScale[c] * r[c].pixelsPerDataUnit), u.range[0] === u.range[1] && (u.range[0] -= 1, u.range[1] += 1);
            var f = u.tickmode;

            if ("auto" === u.tickmode) {
              u.tickmode = "linear";
              var h = u.nticks || i.constrain(u._length / 40, 4, 9);
              n.autoTicks(u, Math.abs(u.range[1] - u.range[0]) / h);
            }

            for (var p = n.calcTicks(u, {
              msUTC: !0
            }), d = 0; d < p.length; ++d) {
              p[d].x = p[d].x * t.dataScale[c], "date" === u.type && (p[d].text = p[d].text.replace(/\<br\>/g, " "));
            }

            l[c] = p, u.tickmode = f;
          }
        }

        e.ticks = l;

        for (c = 0; c < 3; ++c) {
          o[c] = .5 * (t.glplot.bounds[0][c] + t.glplot.bounds[1][c]);

          for (d = 0; d < 2; ++d) {
            e.bounds[d][c] = t.glplot.bounds[d][c];
          }
        }

        t.contourLevels = function (t) {
          for (var e = new Array(3), r = 0; r < 3; ++r) {
            for (var n = t[r], i = new Array(n.length), a = 0; a < n.length; ++a) {
              i[a] = n[a].x;
            }

            e[r] = i;
          }

          return e;
        }(l);
      };

      var n = t("../../cartesian/axes"),
          i = t("../../../lib"),
          a = ["xaxis", "yaxis", "zaxis"],
          o = [0, 0, 0];
    }, {
      "../../../lib": 795,
      "../../cartesian/axes": 845
    }],
    896: [function (t, e, r) {
      "use strict";

      function n(t, e) {
        var r,
            n,
            i = [0, 0, 0, 0];

        for (r = 0; r < 4; ++r) {
          for (n = 0; n < 4; ++n) {
            i[n] += t[4 * r + n] * e[r];
          }
        }

        return i;
      }

      e.exports = function (t, e) {
        return n(t.projection, n(t.view, n(t.model, [e[0], e[1], e[2], 1])));
      };
    }, {}],
    897: [function (t, e, r) {
      "use strict";

      var n,
          i,
          a = t("gl-plot3d"),
          o = a.createCamera,
          s = a.createScene,
          l = t("webgl-context"),
          c = t("has-passive-events"),
          u = t("../../registry"),
          f = t("../../lib"),
          h = f.preserveDrawingBuffer(),
          p = t("../../plots/cartesian/axes"),
          d = t("../../components/fx"),
          m = t("../../lib/str2rgbarray"),
          g = t("../../lib/show_no_webgl_msg"),
          v = t("./project"),
          y = t("./layout/convert"),
          x = t("./layout/spikes"),
          b = t("./layout/tick_marks");

      function _(t, e) {
        var r = document.createElement("div"),
            n = t.container;
        this.graphDiv = t.graphDiv;
        var i = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        i.style.position = "absolute", i.style.top = i.style.left = "0px", i.style.width = i.style.height = "100%", i.style["z-index"] = 20, i.style["pointer-events"] = "none", r.appendChild(i), this.svgContainer = i, r.id = t.id, r.style.position = "absolute", r.style.top = r.style.left = "0px", r.style.width = r.style.height = "100%", n.appendChild(r), this.fullLayout = e, this.id = t.id || "scene", this.fullSceneLayout = e[this.id], this.plotArgs = [[], {}, {}], this.axesOptions = y(e, e[this.id]), this.spikeOptions = x(e[this.id]), this.container = r, this.staticMode = !!t.staticPlot, this.pixelRatio = this.pixelRatio || t.plotGlPixelRatio || 2, this.dataScale = [1, 1, 1], this.contourLevels = [[], [], []], this.convertAnnotations = u.getComponentMethod("annotations3d", "convert"), this.drawAnnotations = u.getComponentMethod("annotations3d", "draw"), this.initializeGLPlot();
      }

      var w = _.prototype;

      w.prepareOptions = function () {
        var t = {
          canvas: this.canvas,
          gl: this.gl,
          glOptions: {
            preserveDrawingBuffer: h,
            premultipliedAlpha: !0,
            antialias: !0
          },
          container: this.container,
          axes: this.axesOptions,
          spikes: this.spikeOptions,
          pickRadius: 10,
          snapToData: !0,
          autoScale: !0,
          autoBounds: !1,
          cameraObject: this.camera,
          pixelRatio: this.pixelRatio
        };

        if (this.staticMode) {
          if (!(i || (n = document.createElement("canvas"), i = l({
            canvas: n,
            preserveDrawingBuffer: !0,
            premultipliedAlpha: !0,
            antialias: !0
          })))) throw new Error("error creating static canvas/context for image server");
          t.gl = i, t.canvas = n;
        }

        return t;
      };

      var T = !0;
      w.tryCreatePlot = function () {
        var t = this.prepareOptions(),
            e = !0;

        try {
          this.glplot = s(t);
        } catch (r) {
          if (this.staticMode || !T || h) e = !1;else {
            f.warn(["webgl setup failed possibly due to", "false preserveDrawingBuffer config.", "The mobile/tablet device may not be detected by is-mobile module.", "Enabling preserveDrawingBuffer in second attempt to create webgl scene..."].join(" "));

            try {
              h = t.glOptions.preserveDrawingBuffer = !0, this.glplot = s(t);
            } catch (r) {
              h = t.glOptions.preserveDrawingBuffer = !1, e = !1;
            }
          }
        }

        return T = !1, e;
      }, w.initializeGLCamera = function () {
        var t = this.fullSceneLayout.camera,
            e = "orthographic" === t.projection.type;
        this.camera = o(this.container, {
          center: [t.center.x, t.center.y, t.center.z],
          eye: [t.eye.x, t.eye.y, t.eye.z],
          up: [t.up.x, t.up.y, t.up.z],
          _ortho: e,
          zoomMin: .01,
          zoomMax: 100,
          mode: "orbit"
        });
      }, w.initializeGLPlot = function () {
        var t = this;
        if (t.initializeGLCamera(), !t.tryCreatePlot()) return g(t);
        t.traces = {}, t.make4thDimension();

        var e = t.graphDiv,
            r = e.layout,
            n = function n() {
          var e = {};
          return t.isCameraChanged(r) && (e[t.id + ".camera"] = t.getCamera()), t.isAspectChanged(r) && (e[t.id + ".aspectratio"] = t.glplot.getAspectratio(), "manual" !== r[t.id].aspectmode && (t.fullSceneLayout.aspectmode = r[t.id].aspectmode = e[t.id + ".aspectmode"] = "manual")), e;
        },
            i = function i(t) {
          if (!1 !== t.fullSceneLayout.dragmode) {
            var e = n();
            t.saveLayout(r), t.graphDiv.emit("plotly_relayout", e);
          }
        };

        return t.glplot.canvas && (t.glplot.canvas.addEventListener("mouseup", function () {
          i(t);
        }), t.glplot.canvas.addEventListener("wheel", function (r) {
          if (e._context._scrollZoom.gl3d) {
            if (t.camera._ortho) {
              var n = r.deltaX > r.deltaY ? 1.1 : 1 / 1.1,
                  a = t.glplot.getAspectratio();
              t.glplot.setAspectratio({
                x: n * a.x,
                y: n * a.y,
                z: n * a.z
              });
            }

            i(t);
          }
        }, !!c && {
          passive: !1
        }), t.glplot.canvas.addEventListener("mousemove", function () {
          if (!1 !== t.fullSceneLayout.dragmode && 0 !== t.camera.mouseListener.buttons) {
            var e = n();
            t.graphDiv.emit("plotly_relayouting", e);
          }
        }), t.staticMode || t.glplot.canvas.addEventListener("webglcontextlost", function (r) {
          e && e.emit && e.emit("plotly_webglcontextlost", {
            event: r,
            layer: t.id
          });
        }, !1)), t.glplot.oncontextloss = function () {
          t.recoverContext();
        }, t.glplot.onrender = function () {
          t.render();
        }, !0;
      }, w.render = function () {
        var t,
            e = this,
            r = e.graphDiv,
            n = e.svgContainer,
            i = e.container.getBoundingClientRect();

        r._fullLayout._calcInverseTransform(r);

        var a = r._fullLayout._invScaleX,
            o = r._fullLayout._invScaleY,
            s = i.width * a,
            l = i.height * o;
        n.setAttributeNS(null, "viewBox", "0 0 " + s + " " + l), n.setAttributeNS(null, "width", s), n.setAttributeNS(null, "height", l), b(e), e.glplot.axes.update(e.axesOptions);

        for (var c, u = Object.keys(e.traces), h = null, m = e.glplot.selection, g = 0; g < u.length; ++g) {
          "skip" !== (t = e.traces[u[g]]).data.hoverinfo && t.handlePick(m) && (h = t), t.setContourLevels && t.setContourLevels();
        }

        function y(t, r, n) {
          var i = e.fullSceneLayout[t + "axis"];
          return "log" !== i.type && (r = i.d2l(r)), p.hoverLabelText(i, r, n);
        }

        if (null !== h) {
          var x = v(e.glplot.cameraParams, m.dataCoordinate);
          t = h.data;

          var _,
              w = r._fullData[t.index],
              T = m.index,
              k = {
            xLabel: y("x", m.traceCoordinate[0], t.xhoverformat),
            yLabel: y("y", m.traceCoordinate[1], t.yhoverformat),
            zLabel: y("z", m.traceCoordinate[2], t.zhoverformat)
          },
              M = d.castHoverinfo(w, e.fullLayout, T),
              A = (M || "").split("+"),
              S = M && "all" === M;

          w.hovertemplate || S || (-1 === A.indexOf("x") && (k.xLabel = void 0), -1 === A.indexOf("y") && (k.yLabel = void 0), -1 === A.indexOf("z") && (k.zLabel = void 0), -1 === A.indexOf("text") && (m.textLabel = void 0), -1 === A.indexOf("name") && (h.name = void 0));
          var E = [];
          "cone" === t.type || "streamtube" === t.type ? (k.uLabel = y("x", m.traceCoordinate[3], t.uhoverformat), (S || -1 !== A.indexOf("u")) && E.push("u: " + k.uLabel), k.vLabel = y("y", m.traceCoordinate[4], t.vhoverformat), (S || -1 !== A.indexOf("v")) && E.push("v: " + k.vLabel), k.wLabel = y("z", m.traceCoordinate[5], t.whoverformat), (S || -1 !== A.indexOf("w")) && E.push("w: " + k.wLabel), k.normLabel = m.traceCoordinate[6].toPrecision(3), (S || -1 !== A.indexOf("norm")) && E.push("norm: " + k.normLabel), "streamtube" === t.type && (k.divergenceLabel = m.traceCoordinate[7].toPrecision(3), (S || -1 !== A.indexOf("divergence")) && E.push("divergence: " + k.divergenceLabel)), m.textLabel && E.push(m.textLabel), _ = E.join("<br>")) : "isosurface" === t.type || "volume" === t.type ? (k.valueLabel = p.hoverLabelText(e._mockAxis, e._mockAxis.d2l(m.traceCoordinate[3]), t.valuehoverformat), E.push("value: " + k.valueLabel), m.textLabel && E.push(m.textLabel), _ = E.join("<br>")) : _ = m.textLabel;
          var L = {
            x: m.traceCoordinate[0],
            y: m.traceCoordinate[1],
            z: m.traceCoordinate[2],
            data: w._input,
            fullData: w,
            curveNumber: w.index,
            pointNumber: T
          };
          d.appendArrayPointValue(L, w, T), t._module.eventData && (L = w._module.eventData(L, m, w, {}, T));
          var C = {
            points: [L]
          };
          e.fullSceneLayout.hovermode && d.loneHover({
            trace: w,
            x: (.5 + .5 * x[0] / x[3]) * s,
            y: (.5 - .5 * x[1] / x[3]) * l,
            xLabel: k.xLabel,
            yLabel: k.yLabel,
            zLabel: k.zLabel,
            text: _,
            name: h.name,
            color: d.castHoverOption(w, T, "bgcolor") || h.color,
            borderColor: d.castHoverOption(w, T, "bordercolor"),
            fontFamily: d.castHoverOption(w, T, "font.family"),
            fontSize: d.castHoverOption(w, T, "font.size"),
            fontColor: d.castHoverOption(w, T, "font.color"),
            nameLength: d.castHoverOption(w, T, "namelength"),
            textAlign: d.castHoverOption(w, T, "align"),
            hovertemplate: f.castOption(w, T, "hovertemplate"),
            hovertemplateLabels: f.extendFlat({}, L, k),
            eventData: [L]
          }, {
            container: n,
            gd: r
          }), m.buttons && m.distance < 5 ? r.emit("plotly_click", C) : r.emit("plotly_hover", C), c = C;
        } else d.loneUnhover(n), r.emit("plotly_unhover", c);

        e.drawAnnotations(e);
      }, w.recoverContext = function () {
        var t = this;
        t.glplot.dispose();

        var e = function e() {
          t.glplot.gl.isContextLost() ? requestAnimationFrame(e) : t.initializeGLPlot() ? t.plot.apply(t, t.plotArgs) : f.error("Catastrophic and unrecoverable WebGL error. Context lost.");
        };

        requestAnimationFrame(e);
      };
      var k = ["xaxis", "yaxis", "zaxis"];

      function M(t, e, r) {
        for (var n = t.fullSceneLayout, i = 0; i < 3; i++) {
          var a = k[i],
              o = a.charAt(0),
              s = n[a],
              l = e[o],
              c = e[o + "calendar"],
              u = e["_" + o + "length"];
          if (f.isArrayOrTypedArray(l)) for (var h, p = 0; p < (u || l.length); p++) {
            if (f.isArrayOrTypedArray(l[p])) for (var d = 0; d < l[p].length; ++d) {
              h = s.d2l(l[p][d], 0, c), !isNaN(h) && isFinite(h) && (r[0][i] = Math.min(r[0][i], h), r[1][i] = Math.max(r[1][i], h));
            } else h = s.d2l(l[p], 0, c), !isNaN(h) && isFinite(h) && (r[0][i] = Math.min(r[0][i], h), r[1][i] = Math.max(r[1][i], h));
          } else r[0][i] = Math.min(r[0][i], 0), r[1][i] = Math.max(r[1][i], u - 1);
        }
      }

      w.plot = function (t, e, r) {
        if (this.plotArgs = [t, e, r], !this.glplot.contextLost) {
          var n,
              i,
              a,
              o,
              s,
              l,
              c = e[this.id],
              u = r[this.id];
          this.fullLayout = e, this.fullSceneLayout = c, this.axesOptions.merge(e, c), this.spikeOptions.merge(c), this.setViewport(c), this.updateFx(c.dragmode, c.hovermode), this.camera.enableWheel = this.graphDiv._context._scrollZoom.gl3d, this.glplot.setClearColor(m(c.bgcolor)), this.setConvert(s), t ? Array.isArray(t) || (t = [t]) : t = [];
          var f = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]];

          for (a = 0; a < t.length; ++a) {
            !0 === (n = t[a]).visible && 0 !== n._length && M(this, n, f);
          }

          !function (t, e) {
            for (var r = t.fullSceneLayout, n = r.annotations || [], i = 0; i < 3; i++) {
              for (var a = k[i], o = a.charAt(0), s = r[a], l = 0; l < n.length; l++) {
                var c = n[l];

                if (c.visible) {
                  var u = s.r2l(c[o]);
                  !isNaN(u) && isFinite(u) && (e[0][i] = Math.min(e[0][i], u), e[1][i] = Math.max(e[1][i], u));
                }
              }
            }
          }(this, f);
          var h = [1, 1, 1];

          for (o = 0; o < 3; ++o) {
            f[1][o] === f[0][o] ? h[o] = 1 : h[o] = 1 / (f[1][o] - f[0][o]);
          }

          for (this.dataScale = h, this.convertAnnotations(this), a = 0; a < t.length; ++a) {
            !0 === (n = t[a]).visible && 0 !== n._length && ((i = this.traces[n.uid]) ? i.data.type === n.type ? i.update(n) : (i.dispose(), i = n._module.plot(this, n), this.traces[n.uid] = i) : (i = n._module.plot(this, n), this.traces[n.uid] = i), i.name = n.name);
          }

          var p = Object.keys(this.traces);

          t: for (a = 0; a < p.length; ++a) {
            for (o = 0; o < t.length; ++o) {
              if (t[o].uid === p[a] && !0 === t[o].visible && 0 !== t[o]._length) continue t;
            }

            (i = this.traces[p[a]]).dispose(), delete this.traces[p[a]];
          }

          this.glplot.objects.sort(function (t, e) {
            return t._trace.data.index - e._trace.data.index;
          });
          var d,
              g = [[0, 0, 0], [0, 0, 0]],
              v = [],
              y = {};

          for (a = 0; a < 3; ++a) {
            if ((l = (s = c[k[a]]).type) in y ? (y[l].acc *= h[a], y[l].count += 1) : y[l] = {
              acc: h[a],
              count: 1
            }, s.autorange) {
              g[0][a] = 1 / 0, g[1][a] = -1 / 0;

              var x = this.glplot.objects,
                  b = this.fullSceneLayout.annotations || [],
                  _ = s._name.charAt(0);

              for (o = 0; o < x.length; o++) {
                var w = x[o],
                    T = w.bounds,
                    A = w._trace.data._pad || 0;
                "ErrorBars" === w.constructor.name && s._lowerLogErrorBound ? g[0][a] = Math.min(g[0][a], s._lowerLogErrorBound) : g[0][a] = Math.min(g[0][a], T[0][a] / h[a] - A), g[1][a] = Math.max(g[1][a], T[1][a] / h[a] + A);
              }

              for (o = 0; o < b.length; o++) {
                var S = b[o];

                if (S.visible) {
                  var E = s.r2l(S[_]);
                  g[0][a] = Math.min(g[0][a], E), g[1][a] = Math.max(g[1][a], E);
                }
              }

              if ("rangemode" in s && "tozero" === s.rangemode && (g[0][a] = Math.min(g[0][a], 0), g[1][a] = Math.max(g[1][a], 0)), g[0][a] > g[1][a]) g[0][a] = -1, g[1][a] = 1;else {
                var L = g[1][a] - g[0][a];
                g[0][a] -= L / 32, g[1][a] += L / 32;
              }

              if ("reversed" === s.autorange) {
                var C = g[0][a];
                g[0][a] = g[1][a], g[1][a] = C;
              }
            } else {
              var P = s.range;
              g[0][a] = s.r2l(P[0]), g[1][a] = s.r2l(P[1]);
            }

            g[0][a] === g[1][a] && (g[0][a] -= 1, g[1][a] += 1), v[a] = g[1][a] - g[0][a], this.glplot.setBounds(a, {
              min: g[0][a] * h[a],
              max: g[1][a] * h[a]
            });
          }

          var I = c.aspectmode;
          if ("cube" === I) d = [1, 1, 1];else if ("manual" === I) {
            var O = c.aspectratio;
            d = [O.x, O.y, O.z];
          } else {
            if ("auto" !== I && "data" !== I) throw new Error("scene.js aspectRatio was not one of the enumerated types");
            var z = [1, 1, 1];

            for (a = 0; a < 3; ++a) {
              var D = y[l = (s = c[k[a]]).type];
              z[a] = Math.pow(D.acc, 1 / D.count) / h[a];
            }

            d = "data" === I || Math.max.apply(null, z) / Math.min.apply(null, z) <= 4 ? z : [1, 1, 1];
          }
          c.aspectratio.x = u.aspectratio.x = d[0], c.aspectratio.y = u.aspectratio.y = d[1], c.aspectratio.z = u.aspectratio.z = d[2], this.glplot.setAspectratio(c.aspectratio), this.viewInitial.aspectratio || (this.viewInitial.aspectratio = {
            x: c.aspectratio.x,
            y: c.aspectratio.y,
            z: c.aspectratio.z
          }), this.viewInitial.aspectmode || (this.viewInitial.aspectmode = c.aspectmode);
          var R = c.domain || null,
              F = e._size || null;

          if (R && F) {
            var B = this.container.style;
            B.position = "absolute", B.left = F.l + R.x[0] * F.w + "px", B.top = F.t + (1 - R.y[1]) * F.h + "px", B.width = F.w * (R.x[1] - R.x[0]) + "px", B.height = F.h * (R.y[1] - R.y[0]) + "px";
          }

          this.glplot.redraw();
        }
      }, w.destroy = function () {
        this.glplot && (this.camera.mouseListener.enabled = !1, this.container.removeEventListener("wheel", this.camera.wheelListener), this.camera = null, this.glplot.dispose(), this.container.parentNode.removeChild(this.container), this.glplot = null);
      }, w.getCamera = function () {
        var t;
        return this.camera.view.recalcMatrix(this.camera.view.lastT()), {
          up: {
            x: (t = this.camera).up[0],
            y: t.up[1],
            z: t.up[2]
          },
          center: {
            x: t.center[0],
            y: t.center[1],
            z: t.center[2]
          },
          eye: {
            x: t.eye[0],
            y: t.eye[1],
            z: t.eye[2]
          },
          projection: {
            type: !0 === t._ortho ? "orthographic" : "perspective"
          }
        };
      }, w.setViewport = function (t) {
        var e,
            r = t.camera;
        this.camera.lookAt.apply(this, [[(e = r).eye.x, e.eye.y, e.eye.z], [e.center.x, e.center.y, e.center.z], [e.up.x, e.up.y, e.up.z]]), this.glplot.setAspectratio(t.aspectratio), "orthographic" === r.projection.type !== this.camera._ortho && (this.glplot.redraw(), this.glplot.clearRGBA(), this.glplot.dispose(), this.initializeGLPlot());
      }, w.isCameraChanged = function (t) {
        var e = this.getCamera(),
            r = f.nestedProperty(t, this.id + ".camera").get();

        function n(t, e, r, n) {
          var i = ["up", "center", "eye"],
              a = ["x", "y", "z"];
          return e[i[r]] && t[i[r]][a[n]] === e[i[r]][a[n]];
        }

        var i = !1;
        if (void 0 === r) i = !0;else {
          for (var a = 0; a < 3; a++) {
            for (var o = 0; o < 3; o++) {
              if (!n(e, r, a, o)) {
                i = !0;
                break;
              }
            }
          }

          (!r.projection || e.projection && e.projection.type !== r.projection.type) && (i = !0);
        }
        return i;
      }, w.isAspectChanged = function (t) {
        var e = this.glplot.getAspectratio(),
            r = f.nestedProperty(t, this.id + ".aspectratio").get();
        return void 0 === r || r.x !== e.x || r.y !== e.y || r.z !== e.z;
      }, w.saveLayout = function (t) {
        var e,
            r,
            n,
            i,
            a,
            o,
            s = this.fullLayout,
            l = this.isCameraChanged(t),
            c = this.isAspectChanged(t),
            h = l || c;

        if (h) {
          var p = {};
          if (l && (e = this.getCamera(), n = (r = f.nestedProperty(t, this.id + ".camera")).get(), p[this.id + ".camera"] = n), c && (i = this.glplot.getAspectratio(), o = (a = f.nestedProperty(t, this.id + ".aspectratio")).get(), p[this.id + ".aspectratio"] = o), u.call("_storeDirectGUIEdit", t, s._preGUI, p), l) r.set(e), f.nestedProperty(s, this.id + ".camera").set(e);
          if (c) a.set(i), f.nestedProperty(s, this.id + ".aspectratio").set(i), this.glplot.redraw();
        }

        return h;
      }, w.updateFx = function (t, e) {
        var r = this.camera;
        if (r) if ("orbit" === t) r.mode = "orbit", r.keyBindingMode = "rotate";else if ("turntable" === t) {
          r.up = [0, 0, 1], r.mode = "turntable", r.keyBindingMode = "rotate";
          var n = this.graphDiv,
              i = n._fullLayout,
              a = this.fullSceneLayout.camera,
              o = a.up.x,
              s = a.up.y,
              l = a.up.z;

          if (l / Math.sqrt(o * o + s * s + l * l) < .999) {
            var c = this.id + ".camera.up",
                h = {
              x: 0,
              y: 0,
              z: 1
            },
                p = {};
            p[c] = h;
            var d = n.layout;
            u.call("_storeDirectGUIEdit", d, i._preGUI, p), a.up = h, f.nestedProperty(d, c).set(h);
          }
        } else r.keyBindingMode = t;
        this.fullSceneLayout.hovermode = e;
      }, w.toImage = function (t) {
        t || (t = "png"), this.staticMode && this.container.appendChild(n), this.glplot.redraw();
        var e = this.glplot.gl,
            r = e.drawingBufferWidth,
            i = e.drawingBufferHeight;
        e.bindFramebuffer(e.FRAMEBUFFER, null);
        var a = new Uint8Array(r * i * 4);
        e.readPixels(0, 0, r, i, e.RGBA, e.UNSIGNED_BYTE, a), function (t, e, r) {
          for (var n = 0, i = r - 1; n < i; ++n, --i) {
            for (var a = 0; a < e; ++a) {
              for (var o = 0; o < 4; ++o) {
                var s = 4 * (e * n + a) + o,
                    l = 4 * (e * i + a) + o,
                    c = t[s];
                t[s] = t[l], t[l] = c;
              }
            }
          }
        }(a, r, i), function (t, e, r) {
          for (var n = 0; n < r; ++n) {
            for (var i = 0; i < e; ++i) {
              var a = 4 * (e * n + i),
                  o = t[a + 3];
              if (o > 0) for (var s = 255 / o, l = 0; l < 3; ++l) {
                t[a + l] = Math.min(s * t[a + l], 255);
              }
            }
          }
        }(a, r, i);
        var o = document.createElement("canvas");
        o.width = r, o.height = i;
        var s,
            l = o.getContext("2d"),
            c = l.createImageData(r, i);

        switch (c.data.set(a), l.putImageData(c, 0, 0), t) {
          case "jpeg":
            s = o.toDataURL("image/jpeg");
            break;

          case "webp":
            s = o.toDataURL("image/webp");
            break;

          default:
            s = o.toDataURL("image/png");
        }

        return this.staticMode && this.container.removeChild(n), s;
      }, w.setConvert = function () {
        for (var t = 0; t < 3; t++) {
          var e = this.fullSceneLayout[k[t]];
          p.setConvert(e, this.fullLayout), e.setScale = f.noop;
        }
      }, w.make4thDimension = function () {
        var t = this.graphDiv._fullLayout;
        this._mockAxis = {
          type: "linear",
          showexponent: "all",
          exponentformat: "B"
        }, p.setConvert(this._mockAxis, t);
      }, e.exports = _;
    }, {
      "../../components/fx": 698,
      "../../lib": 795,
      "../../lib/show_no_webgl_msg": 817,
      "../../lib/str2rgbarray": 819,
      "../../plots/cartesian/axes": 845,
      "../../registry": 923,
      "./layout/convert": 891,
      "./layout/spikes": 894,
      "./layout/tick_marks": 895,
      "./project": 896,
      "gl-plot3d": 317,
      "has-passive-events": 435,
      "webgl-context": 621
    }],
    898: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, n) {
        n = n || t.length;

        for (var i = new Array(n), a = 0; a < n; a++) {
          i[a] = [t[a], e[a], r[a]];
        }

        return i;
      };
    }, {}],
    899: [function (t, e, r) {
      "use strict";

      var n = t("../constants/docs");
      n.FORMAT_LINK, n.DATE_FORMAT_LINK;

      e.exports = function (t, e) {
        return {
          valType: "string",
          dflt: "",
          editType: "none"
        };
      };
    }, {
      "../constants/docs": 766
    }],
    900: [function (t, e, r) {
      "use strict";

      var n = t("./font_attributes"),
          i = t("./animation_attributes"),
          a = t("../components/color/attributes"),
          o = t("../components/shapes/draw_newshape/attributes"),
          s = t("./pad_attributes"),
          l = t("../lib/extend").extendFlat,
          c = n({
        editType: "calc"
      });
      c.family.dflt = '"Open Sans", verdana, arial, sans-serif', c.size.dflt = 12, c.color.dflt = a.defaultLine, e.exports = {
        font: c,
        title: {
          text: {
            valType: "string",
            editType: "layoutstyle"
          },
          font: n({
            editType: "layoutstyle"
          }),
          xref: {
            valType: "enumerated",
            dflt: "container",
            values: ["container", "paper"],
            editType: "layoutstyle"
          },
          yref: {
            valType: "enumerated",
            dflt: "container",
            values: ["container", "paper"],
            editType: "layoutstyle"
          },
          x: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: .5,
            editType: "layoutstyle"
          },
          y: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: "auto",
            editType: "layoutstyle"
          },
          xanchor: {
            valType: "enumerated",
            dflt: "auto",
            values: ["auto", "left", "center", "right"],
            editType: "layoutstyle"
          },
          yanchor: {
            valType: "enumerated",
            dflt: "auto",
            values: ["auto", "top", "middle", "bottom"],
            editType: "layoutstyle"
          },
          pad: l(s({
            editType: "layoutstyle"
          }), {}),
          editType: "layoutstyle"
        },
        uniformtext: {
          mode: {
            valType: "enumerated",
            values: [!1, "hide", "show"],
            dflt: !1,
            editType: "plot"
          },
          minsize: {
            valType: "number",
            min: 0,
            dflt: 0,
            editType: "plot"
          },
          editType: "plot"
        },
        autosize: {
          valType: "boolean",
          dflt: !1,
          editType: "none"
        },
        width: {
          valType: "number",
          min: 10,
          dflt: 700,
          editType: "plot"
        },
        height: {
          valType: "number",
          min: 10,
          dflt: 450,
          editType: "plot"
        },
        margin: {
          l: {
            valType: "number",
            min: 0,
            dflt: 80,
            editType: "plot"
          },
          r: {
            valType: "number",
            min: 0,
            dflt: 80,
            editType: "plot"
          },
          t: {
            valType: "number",
            min: 0,
            dflt: 100,
            editType: "plot"
          },
          b: {
            valType: "number",
            min: 0,
            dflt: 80,
            editType: "plot"
          },
          pad: {
            valType: "number",
            min: 0,
            dflt: 0,
            editType: "plot"
          },
          autoexpand: {
            valType: "boolean",
            dflt: !0,
            editType: "plot"
          },
          editType: "plot"
        },
        computed: {
          valType: "any",
          editType: "none"
        },
        paper_bgcolor: {
          valType: "color",
          dflt: a.background,
          editType: "plot"
        },
        plot_bgcolor: {
          valType: "color",
          dflt: a.background,
          editType: "layoutstyle"
        },
        autotypenumbers: {
          valType: "enumerated",
          values: ["convert types", "strict"],
          dflt: "convert types",
          editType: "calc"
        },
        separators: {
          valType: "string",
          editType: "plot"
        },
        hidesources: {
          valType: "boolean",
          dflt: !1,
          editType: "plot"
        },
        showlegend: {
          valType: "boolean",
          editType: "legend"
        },
        colorway: {
          valType: "colorlist",
          dflt: a.defaults,
          editType: "calc"
        },
        datarevision: {
          valType: "any",
          editType: "calc"
        },
        uirevision: {
          valType: "any",
          editType: "none"
        },
        editrevision: {
          valType: "any",
          editType: "none"
        },
        selectionrevision: {
          valType: "any",
          editType: "none"
        },
        template: {
          valType: "any",
          editType: "calc"
        },
        newshape: o.newshape,
        activeshape: o.activeshape,
        meta: {
          valType: "any",
          arrayOk: !0,
          editType: "plot"
        },
        transition: l({}, i.transition, {
          editType: "none"
        }),
        _deprecated: {
          title: {
            valType: "string",
            editType: "layoutstyle"
          },
          titlefont: n({
            editType: "layoutstyle"
          })
        }
      };
    }, {
      "../components/color/attributes": 657,
      "../components/shapes/draw_newshape/attributes": 743,
      "../lib/extend": 785,
      "./animation_attributes": 839,
      "./font_attributes": 873,
      "./pad_attributes": 908
    }],
    901: [function (t, e, r) {
      "use strict";

      var n = '\xa9 <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
          i = ['\xa9 <a target="_blank" href="https://carto.com/">Carto</a>', n].join(" "),
          a = ['Map tiles by <a target="_blank" href="https://stamen.com">Stamen Design</a>', 'under <a target="_blank" href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>', "|", 'Data by <a target="_blank" href="https://openstreetmap.org">OpenStreetMap</a> contributors', 'under <a target="_blank" href="https://www.openstreetmap.org/copyright">ODbL</a>'].join(" "),
          o = {
        "open-street-map": {
          id: "osm",
          version: 8,
          sources: {
            "plotly-osm-tiles": {
              type: "raster",
              attribution: n,
              tiles: ["https://a.tile.openstreetmap.org/{z}/{x}/{y}.png", "https://b.tile.openstreetmap.org/{z}/{x}/{y}.png"],
              tileSize: 256
            }
          },
          layers: [{
            id: "plotly-osm-tiles",
            type: "raster",
            source: "plotly-osm-tiles",
            minzoom: 0,
            maxzoom: 22
          }]
        },
        "white-bg": {
          id: "white-bg",
          version: 8,
          sources: {},
          layers: [{
            id: "white-bg",
            type: "background",
            paint: {
              "background-color": "#FFFFFF"
            },
            minzoom: 0,
            maxzoom: 22
          }]
        },
        "carto-positron": {
          id: "carto-positron",
          version: 8,
          sources: {
            "plotly-carto-positron": {
              type: "raster",
              attribution: i,
              tiles: ["https://cartodb-basemaps-c.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"],
              tileSize: 256
            }
          },
          layers: [{
            id: "plotly-carto-positron",
            type: "raster",
            source: "plotly-carto-positron",
            minzoom: 0,
            maxzoom: 22
          }]
        },
        "carto-darkmatter": {
          id: "carto-darkmatter",
          version: 8,
          sources: {
            "plotly-carto-darkmatter": {
              type: "raster",
              attribution: i,
              tiles: ["https://cartodb-basemaps-c.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png"],
              tileSize: 256
            }
          },
          layers: [{
            id: "plotly-carto-darkmatter",
            type: "raster",
            source: "plotly-carto-darkmatter",
            minzoom: 0,
            maxzoom: 22
          }]
        },
        "stamen-terrain": {
          id: "stamen-terrain",
          version: 8,
          sources: {
            "plotly-stamen-terrain": {
              type: "raster",
              attribution: a,
              tiles: ["https://stamen-tiles.a.ssl.fastly.net/terrain/{z}/{x}/{y}.png"],
              tileSize: 256
            }
          },
          layers: [{
            id: "plotly-stamen-terrain",
            type: "raster",
            source: "plotly-stamen-terrain",
            minzoom: 0,
            maxzoom: 22
          }]
        },
        "stamen-toner": {
          id: "stamen-toner",
          version: 8,
          sources: {
            "plotly-stamen-toner": {
              type: "raster",
              attribution: a,
              tiles: ["https://stamen-tiles.a.ssl.fastly.net/toner/{z}/{x}/{y}.png"],
              tileSize: 256
            }
          },
          layers: [{
            id: "plotly-stamen-toner",
            type: "raster",
            source: "plotly-stamen-toner",
            minzoom: 0,
            maxzoom: 22
          }]
        },
        "stamen-watercolor": {
          id: "stamen-watercolor",
          version: 8,
          sources: {
            "plotly-stamen-watercolor": {
              type: "raster",
              attribution: ['Map tiles by <a target="_blank" href="https://stamen.com">Stamen Design</a>', 'under <a target="_blank" href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>', "|", 'Data by <a target="_blank" href="https://openstreetmap.org">OpenStreetMap</a> contributors', 'under <a target="_blank" href="https://creativecommons.org/licenses/by-sa/3.0">CC BY SA</a>'].join(" "),
              tiles: ["https://stamen-tiles.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.png"],
              tileSize: 256
            }
          },
          layers: [{
            id: "plotly-stamen-watercolor",
            type: "raster",
            source: "plotly-stamen-watercolor",
            minzoom: 0,
            maxzoom: 22
          }]
        }
      },
          s = Object.keys(o);
      e.exports = {
        requiredVersion: "1.10.1",
        styleUrlPrefix: "mapbox://styles/mapbox/",
        styleUrlSuffix: "v9",
        styleValuesMapbox: ["basic", "streets", "outdoors", "light", "dark", "satellite", "satellite-streets"],
        styleValueDflt: "basic",
        stylesNonMapbox: o,
        styleValuesNonMapbox: s,
        traceLayerPrefix: "plotly-trace-layer-",
        layoutLayerPrefix: "plotly-layout-layer-",
        wrongVersionErrorMsg: ["Your custom plotly.js bundle is not using the correct mapbox-gl version", "Please install mapbox-gl@1.10.1."].join("\n"),
        noAccessTokenErrorMsg: ["Missing Mapbox access token.", "Mapbox trace type require a Mapbox access token to be registered.", "For example:", "  Plotly.newPlot(gd, data, layout, { mapboxAccessToken: 'my-access-token' });", "More info here: https://www.mapbox.com/help/define-access-token/"].join("\n"),
        missingStyleErrorMsg: ["No valid mapbox style found, please set `mapbox.style` to one of:", s.join(", "), "or register a Mapbox access token to use a Mapbox-served style."].join("\n"),
        multipleTokensErrorMsg: ["Set multiple mapbox access token across different mapbox subplot,", "using first token found as mapbox-gl does not allow multipleaccess tokens on the same page."].join("\n"),
        mapOnErrorMsg: "Mapbox error.",
        mapboxLogo: {
          path0: "m 10.5,1.24 c -5.11,0 -9.25,4.15 -9.25,9.25 0,5.1 4.15,9.25 9.25,9.25 5.1,0 9.25,-4.15 9.25,-9.25 0,-5.11 -4.14,-9.25 -9.25,-9.25 z m 4.39,11.53 c -1.93,1.93 -4.78,2.31 -6.7,2.31 -0.7,0 -1.41,-0.05 -2.1,-0.16 0,0 -1.02,-5.64 2.14,-8.81 0.83,-0.83 1.95,-1.28 3.13,-1.28 1.27,0 2.49,0.51 3.39,1.42 1.84,1.84 1.89,4.75 0.14,6.52 z",
          path1: "M 10.5,-0.01 C 4.7,-0.01 0,4.7 0,10.49 c 0,5.79 4.7,10.5 10.5,10.5 5.8,0 10.5,-4.7 10.5,-10.5 C 20.99,4.7 16.3,-0.01 10.5,-0.01 Z m 0,19.75 c -5.11,0 -9.25,-4.15 -9.25,-9.25 0,-5.1 4.14,-9.26 9.25,-9.26 5.11,0 9.25,4.15 9.25,9.25 0,5.13 -4.14,9.26 -9.25,9.26 z",
          path2: "M 14.74,6.25 C 12.9,4.41 9.98,4.35 8.23,6.1 5.07,9.27 6.09,14.91 6.09,14.91 c 0,0 5.64,1.02 8.81,-2.14 C 16.64,11 16.59,8.09 14.74,6.25 Z m -2.27,4.09 -0.91,1.87 -0.9,-1.87 -1.86,-0.91 1.86,-0.9 0.9,-1.87 0.91,1.87 1.86,0.9 z",
          polygon: "11.56,12.21 10.66,10.34 8.8,9.43 10.66,8.53 11.56,6.66 12.47,8.53 14.33,9.43 12.47,10.34"
        },
        styleRules: {
          map: "overflow:hidden;position:relative;",
          "missing-css": "display:none;",
          canary: "background-color:salmon;",
          "ctrl-bottom-left": "position: absolute; pointer-events: none; z-index: 2; bottom: 0; left: 0;",
          "ctrl-bottom-right": "position: absolute; pointer-events: none; z-index: 2; right: 0; bottom: 0;",
          ctrl: "clear: both; pointer-events: auto; transform: translate(0, 0);",
          "ctrl-attrib.mapboxgl-compact .mapboxgl-ctrl-attrib-inner": "display: none;",
          "ctrl-attrib.mapboxgl-compact:hover .mapboxgl-ctrl-attrib-inner": "display: block; margin-top:2px",
          "ctrl-attrib.mapboxgl-compact:hover": "padding: 2px 24px 2px 4px; visibility: visible; margin-top: 6px;",
          "ctrl-attrib.mapboxgl-compact::after": 'content: ""; cursor: pointer; position: absolute; background-image: url(\'data:image/svg+xml;charset=utf-8,%3Csvg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"%3E %3Cpath fill="%23333333" fill-rule="evenodd" d="M4,10a6,6 0 1,0 12,0a6,6 0 1,0 -12,0 M9,7a1,1 0 1,0 2,0a1,1 0 1,0 -2,0 M9,10a1,1 0 1,1 2,0l0,3a1,1 0 1,1 -2,0"/%3E %3C/svg%3E\'); background-color: rgba(255, 255, 255, 0.5); width: 24px; height: 24px; box-sizing: border-box; border-radius: 12px;',
          "ctrl-attrib.mapboxgl-compact": "min-height: 20px; padding: 0; margin: 10px; position: relative; background-color: #fff; border-radius: 3px 12px 12px 3px;",
          "ctrl-bottom-right > .mapboxgl-ctrl-attrib.mapboxgl-compact::after": "bottom: 0; right: 0",
          "ctrl-bottom-left > .mapboxgl-ctrl-attrib.mapboxgl-compact::after": "bottom: 0; left: 0",
          "ctrl-bottom-left .mapboxgl-ctrl": "margin: 0 0 10px 10px; float: left;",
          "ctrl-bottom-right .mapboxgl-ctrl": "margin: 0 10px 10px 0; float: right;",
          "ctrl-attrib": "color: rgba(0, 0, 0, 0.75); text-decoration: none; font-size: 12px",
          "ctrl-attrib a": "color: rgba(0, 0, 0, 0.75); text-decoration: none; font-size: 12px",
          "ctrl-attrib a:hover": "color: inherit; text-decoration: underline;",
          "ctrl-attrib .mapbox-improve-map": "font-weight: bold; margin-left: 2px;",
          "attrib-empty": "display: none;",
          "ctrl-logo": 'display:block; width: 21px; height: 21px; background-image: url(\'data:image/svg+xml;charset=utf-8,%3C?xml version="1.0" encoding="utf-8"?%3E %3Csvg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21 21" style="enable-background:new 0 0 21 21;" xml:space="preserve"%3E%3Cg transform="translate(0,0.01)"%3E%3Cpath d="m 10.5,1.24 c -5.11,0 -9.25,4.15 -9.25,9.25 0,5.1 4.15,9.25 9.25,9.25 5.1,0 9.25,-4.15 9.25,-9.25 0,-5.11 -4.14,-9.25 -9.25,-9.25 z m 4.39,11.53 c -1.93,1.93 -4.78,2.31 -6.7,2.31 -0.7,0 -1.41,-0.05 -2.1,-0.16 0,0 -1.02,-5.64 2.14,-8.81 0.83,-0.83 1.95,-1.28 3.13,-1.28 1.27,0 2.49,0.51 3.39,1.42 1.84,1.84 1.89,4.75 0.14,6.52 z" style="opacity:0.9;fill:%23ffffff;enable-background:new" class="st0"/%3E%3Cpath d="M 10.5,-0.01 C 4.7,-0.01 0,4.7 0,10.49 c 0,5.79 4.7,10.5 10.5,10.5 5.8,0 10.5,-4.7 10.5,-10.5 C 20.99,4.7 16.3,-0.01 10.5,-0.01 Z m 0,19.75 c -5.11,0 -9.25,-4.15 -9.25,-9.25 0,-5.1 4.14,-9.26 9.25,-9.26 5.11,0 9.25,4.15 9.25,9.25 0,5.13 -4.14,9.26 -9.25,9.26 z" style="opacity:0.35;enable-background:new" class="st1"/%3E%3Cpath d="M 14.74,6.25 C 12.9,4.41 9.98,4.35 8.23,6.1 5.07,9.27 6.09,14.91 6.09,14.91 c 0,0 5.64,1.02 8.81,-2.14 C 16.64,11 16.59,8.09 14.74,6.25 Z m -2.27,4.09 -0.91,1.87 -0.9,-1.87 -1.86,-0.91 1.86,-0.9 0.9,-1.87 0.91,1.87 1.86,0.9 z" style="opacity:0.35;enable-background:new" class="st1"/%3E%3Cpolygon points="11.56,12.21 10.66,10.34 8.8,9.43 10.66,8.53 11.56,6.66 12.47,8.53 14.33,9.43 12.47,10.34 " style="opacity:0.9;fill:%23ffffff;enable-background:new" class="st0"/%3E%3C/g%3E%3C/svg%3E\')'
        }
      };
    }, {}],
    902: [function (t, e, r) {
      "use strict";

      var n = t("../../lib");

      e.exports = function (t, e) {
        var r = t.split(" "),
            i = r[0],
            a = r[1],
            o = n.isArrayOrTypedArray(e) ? n.mean(e) : e,
            s = .5 + o / 100,
            l = 1.5 + o / 100,
            c = ["", ""],
            u = [0, 0];

        switch (i) {
          case "top":
            c[0] = "top", u[1] = -l;
            break;

          case "bottom":
            c[0] = "bottom", u[1] = l;
        }

        switch (a) {
          case "left":
            c[1] = "right", u[0] = -s;
            break;

          case "right":
            c[1] = "left", u[0] = s;
        }

        return {
          anchor: c[0] && c[1] ? c.join("-") : c[0] ? c[0] : c[1] ? c[1] : "center",
          offset: u
        };
      };
    }, {
      "../../lib": 795
    }],
    903: [function (t, e, r) {
      "use strict";

      var n = t("mapbox-gl/dist/mapbox-gl-unminified"),
          i = t("../../lib"),
          a = i.strTranslate,
          o = i.strScale,
          s = t("../../plots/get_data").getSubplotCalcData,
          l = t("../../constants/xmlns_namespaces"),
          c = t("@plotly/d3"),
          u = t("../../components/drawing"),
          f = t("../../lib/svg_text_utils"),
          h = t("./mapbox"),
          p = r.constants = t("./constants");

      function d(t) {
        return "string" == typeof t && (-1 !== p.styleValuesMapbox.indexOf(t) || 0 === t.indexOf("mapbox://"));
      }

      r.name = "mapbox", r.attr = "subplot", r.idRoot = "mapbox", r.idRegex = r.attrRegex = i.counterRegex("mapbox"), r.attributes = {
        subplot: {
          valType: "subplotid",
          dflt: "mapbox",
          editType: "calc"
        }
      }, r.layoutAttributes = t("./layout_attributes"), r.supplyLayoutDefaults = t("./layout_defaults"), r.plot = function (t) {
        var e = t._fullLayout,
            r = t.calcdata,
            a = e._subplots.mapbox;
        if (n.version !== p.requiredVersion) throw new Error(p.wrongVersionErrorMsg);

        var o = function (t, e) {
          var r = t._fullLayout;
          if ("" === t._context.mapboxAccessToken) return "";

          for (var n = [], a = [], o = !1, s = !1, l = 0; l < e.length; l++) {
            var c = r[e[l]],
                u = c.accesstoken;
            d(c.style) && (u ? i.pushUnique(n, u) : (d(c._input.style) && (i.error("Uses Mapbox map style, but did not set an access token."), o = !0), s = !0)), u && i.pushUnique(a, u);
          }

          if (s) {
            var f = o ? p.noAccessTokenErrorMsg : p.missingStyleErrorMsg;
            throw i.error(f), new Error(f);
          }

          return n.length ? (n.length > 1 && i.warn(p.multipleTokensErrorMsg), n[0]) : (a.length && i.log(["Listed mapbox access token(s)", a.join(","), "but did not use a Mapbox map style, ignoring token(s)."].join(" ")), "");
        }(t, a);

        n.accessToken = o;

        for (var l = 0; l < a.length; l++) {
          var c = a[l],
              u = s(r, "mapbox", c),
              f = e[c],
              m = f._subplot;
          m || (m = new h(t, c), e[c]._subplot = m), m.viewInitial || (m.viewInitial = {
            center: i.extendFlat({}, f.center),
            zoom: f.zoom,
            bearing: f.bearing,
            pitch: f.pitch
          }), m.plot(u, e, t._promises);
        }
      }, r.clean = function (t, e, r, n) {
        for (var i = n._subplots.mapbox || [], a = 0; a < i.length; a++) {
          var o = i[a];
          !e[o] && n[o]._subplot && n[o]._subplot.destroy();
        }
      }, r.toSVG = function (t) {
        for (var e = t._fullLayout, r = e._subplots.mapbox, n = e._size, i = 0; i < r.length; i++) {
          var s = e[r[i]],
              h = s.domain,
              d = s._subplot.toImage("png");

          e._glimages.append("svg:image").attr({
            xmlns: l.svg,
            "xlink:href": d,
            x: n.l + n.w * h.x[0],
            y: n.t + n.h * (1 - h.y[1]),
            width: n.w * (h.x[1] - h.x[0]),
            height: n.h * (h.y[1] - h.y[0]),
            preserveAspectRatio: "none"
          });

          var m = c.select(s._subplot.div);

          if (!(null === m.select(".mapboxgl-ctrl-logo").node().offsetParent)) {
            var g = e._glimages.append("g");

            g.attr("transform", a(n.l + n.w * h.x[0] + 10, n.t + n.h * (1 - h.y[0]) - 31)), g.append("path").attr("d", p.mapboxLogo.path0).style({
              opacity: .9,
              fill: "#ffffff",
              "enable-background": "new"
            }), g.append("path").attr("d", p.mapboxLogo.path1).style("opacity", .35).style("enable-background", "new"), g.append("path").attr("d", p.mapboxLogo.path2).style("opacity", .35).style("enable-background", "new"), g.append("polygon").attr("points", p.mapboxLogo.polygon).style({
              opacity: .9,
              fill: "#ffffff",
              "enable-background": "new"
            });
          }

          var v = m.select(".mapboxgl-ctrl-attrib").text().replace("Improve this map", ""),
              y = e._glimages.append("g"),
              x = y.append("text");

          x.text(v).classed("static-attribution", !0).attr({
            "font-size": 12,
            "font-family": "Arial",
            color: "rgba(0, 0, 0, 0.75)",
            "text-anchor": "end",
            "data-unformatted": v
          });

          var b = u.bBox(x.node()),
              _ = n.w * (h.x[1] - h.x[0]);

          if (b.width > _ / 2) {
            var w = v.split("|").join("<br>");
            x.text(w).attr("data-unformatted", w).call(f.convertToTspans, t), b = u.bBox(x.node());
          }

          x.attr("transform", a(-3, 8 - b.height)), y.insert("rect", ".static-attribution").attr({
            x: -b.width - 6,
            y: -b.height - 3,
            width: b.width + 6,
            height: b.height + 3,
            fill: "rgba(255, 255, 255, 0.75)"
          });
          var T = 1;
          b.width + 6 > _ && (T = _ / (b.width + 6));
          var k = [n.l + n.w * h.x[1], n.t + n.h * (1 - h.y[0])];
          y.attr("transform", a(k[0], k[1]) + o(T));
        }
      }, r.updateFx = function (t) {
        for (var e = t._fullLayout, r = e._subplots.mapbox, n = 0; n < r.length; n++) {
          e[r[n]]._subplot.updateFx(e);
        }
      };
    }, {
      "../../components/drawing": 680,
      "../../constants/xmlns_namespaces": 772,
      "../../lib": 795,
      "../../lib/svg_text_utils": 820,
      "../../plots/get_data": 882,
      "./constants": 901,
      "./layout_attributes": 905,
      "./layout_defaults": 906,
      "./mapbox": 907,
      "@plotly/d3": 57,
      "mapbox-gl/dist/mapbox-gl-unminified": 452
    }],
    904: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../lib/svg_text_utils").sanitizeHTML,
          a = t("./convert_text_opts"),
          o = t("./constants");

      function s(t, e) {
        this.subplot = t, this.uid = t.uid + "-" + e, this.index = e, this.idSource = "source-" + this.uid, this.idLayer = o.layoutLayerPrefix + this.uid, this.sourceType = null, this.source = null, this.layerType = null, this.below = null, this.visible = !1;
      }

      var l = s.prototype;

      function c(t) {
        if (!t.visible) return !1;
        var e = t.source;

        if (Array.isArray(e) && e.length > 0) {
          for (var r = 0; r < e.length; r++) {
            if ("string" != typeof e[r] || 0 === e[r].length) return !1;
          }

          return !0;
        }

        return n.isPlainObject(e) || "string" == typeof e && e.length > 0;
      }

      function u(t) {
        var e = {},
            r = {};

        switch (t.type) {
          case "circle":
            n.extendFlat(r, {
              "circle-radius": t.circle.radius,
              "circle-color": t.color,
              "circle-opacity": t.opacity
            });
            break;

          case "line":
            n.extendFlat(r, {
              "line-width": t.line.width,
              "line-color": t.color,
              "line-opacity": t.opacity,
              "line-dasharray": t.line.dash
            });
            break;

          case "fill":
            n.extendFlat(r, {
              "fill-color": t.color,
              "fill-outline-color": t.fill.outlinecolor,
              "fill-opacity": t.opacity
            });
            break;

          case "symbol":
            var i = t.symbol,
                o = a(i.textposition, i.iconsize);
            n.extendFlat(e, {
              "icon-image": i.icon + "-15",
              "icon-size": i.iconsize / 10,
              "text-field": i.text,
              "text-size": i.textfont.size,
              "text-anchor": o.anchor,
              "text-offset": o.offset,
              "symbol-placement": i.placement
            }), n.extendFlat(r, {
              "icon-color": t.color,
              "text-color": i.textfont.color,
              "text-opacity": t.opacity
            });
            break;

          case "raster":
            n.extendFlat(r, {
              "raster-fade-duration": 0,
              "raster-opacity": t.opacity
            });
        }

        return {
          layout: e,
          paint: r
        };
      }

      l.update = function (t) {
        this.visible ? this.needsNewImage(t) ? this.updateImage(t) : this.needsNewSource(t) ? (this.removeLayer(), this.updateSource(t), this.updateLayer(t)) : this.needsNewLayer(t) ? this.updateLayer(t) : this.updateStyle(t) : (this.updateSource(t), this.updateLayer(t)), this.visible = c(t);
      }, l.needsNewImage = function (t) {
        return this.subplot.map.getSource(this.idSource) && "image" === this.sourceType && "image" === t.sourcetype && (this.source !== t.source || JSON.stringify(this.coordinates) !== JSON.stringify(t.coordinates));
      }, l.needsNewSource = function (t) {
        return this.sourceType !== t.sourcetype || JSON.stringify(this.source) !== JSON.stringify(t.source) || this.layerType !== t.type;
      }, l.needsNewLayer = function (t) {
        return this.layerType !== t.type || this.below !== this.subplot.belowLookup["layout-" + this.index];
      }, l.lookupBelow = function () {
        return this.subplot.belowLookup["layout-" + this.index];
      }, l.updateImage = function (t) {
        this.subplot.map.getSource(this.idSource).updateImage({
          url: t.source,
          coordinates: t.coordinates
        });
        var e = this.findFollowingMapboxLayerId(this.lookupBelow());
        null !== e && this.subplot.map.moveLayer(this.idLayer, e);
      }, l.updateSource = function (t) {
        var e = this.subplot.map;

        if (e.getSource(this.idSource) && e.removeSource(this.idSource), this.sourceType = t.sourcetype, this.source = t.source, c(t)) {
          var r = function (t) {
            var e,
                r = t.sourcetype,
                n = t.source,
                a = {
              type: r
            };
            "geojson" === r ? e = "data" : "vector" === r ? e = "string" == typeof n ? "url" : "tiles" : "raster" === r ? (e = "tiles", a.tileSize = 256) : "image" === r && (e = "url", a.coordinates = t.coordinates);
            a[e] = n, t.sourceattribution && (a.attribution = i(t.sourceattribution));
            return a;
          }(t);

          e.addSource(this.idSource, r);
        }
      }, l.findFollowingMapboxLayerId = function (t) {
        if ("traces" === t) for (var e = this.subplot.getMapLayers(), r = 0; r < e.length; r++) {
          var n = e[r].id;

          if ("string" == typeof n && 0 === n.indexOf(o.traceLayerPrefix)) {
            t = n;
            break;
          }
        }
        return t;
      }, l.updateLayer = function (t) {
        var e = this.subplot,
            r = u(t),
            n = this.lookupBelow(),
            i = this.findFollowingMapboxLayerId(n);
        this.removeLayer(), c(t) && e.addLayer({
          id: this.idLayer,
          source: this.idSource,
          "source-layer": t.sourcelayer || "",
          type: t.type,
          minzoom: t.minzoom,
          maxzoom: t.maxzoom,
          layout: r.layout,
          paint: r.paint
        }, i), this.layerType = t.type, this.below = n;
      }, l.updateStyle = function (t) {
        if (c(t)) {
          var e = u(t);
          this.subplot.setOptions(this.idLayer, "setLayoutProperty", e.layout), this.subplot.setOptions(this.idLayer, "setPaintProperty", e.paint);
        }
      }, l.removeLayer = function () {
        var t = this.subplot.map;
        t.getLayer(this.idLayer) && t.removeLayer(this.idLayer);
      }, l.dispose = function () {
        var t = this.subplot.map;
        t.getLayer(this.idLayer) && t.removeLayer(this.idLayer), t.getSource(this.idSource) && t.removeSource(this.idSource);
      }, e.exports = function (t, e, r) {
        var n = new s(t, e);
        return n.update(r), n;
      };
    }, {
      "../../lib": 795,
      "../../lib/svg_text_utils": 820,
      "./constants": 901,
      "./convert_text_opts": 902
    }],
    905: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../components/color").defaultLine,
          a = t("../domain").attributes,
          o = t("../font_attributes"),
          s = t("../../traces/scatter/attributes").textposition,
          l = t("../../plot_api/edit_types").overrideAll,
          c = t("../../plot_api/plot_template").templatedArray,
          u = t("./constants"),
          f = o({});
      f.family.dflt = "Open Sans Regular, Arial Unicode MS Regular", (e.exports = l({
        _arrayAttrRegexps: [n.counterRegex("mapbox", ".layers", !0)],
        domain: a({
          name: "mapbox"
        }),
        accesstoken: {
          valType: "string",
          noBlank: !0,
          strict: !0
        },
        style: {
          valType: "any",
          values: u.styleValuesMapbox.concat(u.styleValuesNonMapbox),
          dflt: u.styleValueDflt
        },
        center: {
          lon: {
            valType: "number",
            dflt: 0
          },
          lat: {
            valType: "number",
            dflt: 0
          }
        },
        zoom: {
          valType: "number",
          dflt: 1
        },
        bearing: {
          valType: "number",
          dflt: 0
        },
        pitch: {
          valType: "number",
          dflt: 0
        },
        layers: c("layer", {
          visible: {
            valType: "boolean",
            dflt: !0
          },
          sourcetype: {
            valType: "enumerated",
            values: ["geojson", "vector", "raster", "image"],
            dflt: "geojson"
          },
          source: {
            valType: "any"
          },
          sourcelayer: {
            valType: "string",
            dflt: ""
          },
          sourceattribution: {
            valType: "string"
          },
          type: {
            valType: "enumerated",
            values: ["circle", "line", "fill", "symbol", "raster"],
            dflt: "circle"
          },
          coordinates: {
            valType: "any"
          },
          below: {
            valType: "string"
          },
          color: {
            valType: "color",
            dflt: i
          },
          opacity: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: 1
          },
          minzoom: {
            valType: "number",
            min: 0,
            max: 24,
            dflt: 0
          },
          maxzoom: {
            valType: "number",
            min: 0,
            max: 24,
            dflt: 24
          },
          circle: {
            radius: {
              valType: "number",
              dflt: 15
            }
          },
          line: {
            width: {
              valType: "number",
              dflt: 2
            },
            dash: {
              valType: "data_array"
            }
          },
          fill: {
            outlinecolor: {
              valType: "color",
              dflt: i
            }
          },
          symbol: {
            icon: {
              valType: "string",
              dflt: "marker"
            },
            iconsize: {
              valType: "number",
              dflt: 10
            },
            text: {
              valType: "string",
              dflt: ""
            },
            placement: {
              valType: "enumerated",
              values: ["point", "line", "line-center"],
              dflt: "point"
            },
            textfont: f,
            textposition: n.extendFlat({}, s, {
              arrayOk: !1
            })
          }
        })
      }, "plot", "from-root")).uirevision = {
        valType: "any",
        editType: "none"
      };
    }, {
      "../../components/color": 658,
      "../../lib": 795,
      "../../plot_api/edit_types": 827,
      "../../plot_api/plot_template": 834,
      "../../traces/scatter/attributes": 1199,
      "../domain": 872,
      "../font_attributes": 873,
      "./constants": 901
    }],
    906: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../subplot_defaults"),
          a = t("../array_container_defaults"),
          o = t("./layout_attributes");

      function s(t, e, r, n) {
        r("accesstoken", n.accessToken), r("style"), r("center.lon"), r("center.lat"), r("zoom"), r("bearing"), r("pitch"), a(t, e, {
          name: "layers",
          handleItemDefaults: l
        }), e._input = t;
      }

      function l(t, e) {
        function r(r, i) {
          return n.coerce(t, e, o.layers, r, i);
        }

        if (r("visible")) {
          var i,
              a = r("sourcetype"),
              s = "raster" === a || "image" === a;
          r("source"), r("sourceattribution"), "vector" === a && r("sourcelayer"), "image" === a && r("coordinates"), s && (i = "raster");
          var l = r("type", i);
          s && "raster" !== l && (l = e.type = "raster", n.log("Source types *raster* and *image* must drawn *raster* layer type.")), r("below"), r("color"), r("opacity"), r("minzoom"), r("maxzoom"), "circle" === l && r("circle.radius"), "line" === l && (r("line.width"), r("line.dash")), "fill" === l && r("fill.outlinecolor"), "symbol" === l && (r("symbol.icon"), r("symbol.iconsize"), r("symbol.text"), n.coerceFont(r, "symbol.textfont"), r("symbol.textposition"), r("symbol.placement"));
        }
      }

      e.exports = function (t, e, r) {
        i(t, e, r, {
          type: "mapbox",
          attributes: o,
          handleDefaults: s,
          partition: "y",
          accessToken: e._mapboxAccessToken
        });
      };
    }, {
      "../../lib": 795,
      "../array_container_defaults": 840,
      "../subplot_defaults": 917,
      "./layout_attributes": 905
    }],
    907: [function (t, e, r) {
      "use strict";

      var n = t("mapbox-gl/dist/mapbox-gl-unminified"),
          i = t("../../lib"),
          a = t("../../lib/geo_location_utils"),
          o = t("../../registry"),
          s = t("../cartesian/axes"),
          l = t("../../components/dragelement"),
          c = t("../../components/fx"),
          u = t("../../components/dragelement/helpers"),
          f = u.rectMode,
          h = u.drawMode,
          p = u.selectMode,
          d = t("../cartesian/select").prepSelect,
          m = t("../cartesian/select").clearSelect,
          g = t("../cartesian/select").clearSelectionsCache,
          v = t("../cartesian/select").selectOnClick,
          y = t("./constants"),
          x = t("./layers");

      function b(t, e) {
        this.id = e, this.gd = t;
        var r = t._fullLayout,
            n = t._context;
        this.container = r._glcontainer.node(), this.isStatic = n.staticPlot, this.uid = r._uid + "-" + this.id, this.div = null, this.xaxis = null, this.yaxis = null, this.createFramework(r), this.map = null, this.accessToken = null, this.styleObj = null, this.traceHash = {}, this.layerList = [], this.belowLookup = {}, this.dragging = !1, this.wheeling = !1;
      }

      var _ = b.prototype;
      _.plot = function (t, e, r) {
        var n,
            i = this,
            a = e[i.id];
        i.map && a.accesstoken !== i.accessToken && (i.map.remove(), i.map = null, i.styleObj = null, i.traceHash = {}, i.layerList = []), n = i.map ? new Promise(function (r, n) {
          i.updateMap(t, e, r, n);
        }) : new Promise(function (r, n) {
          i.createMap(t, e, r, n);
        }), r.push(n);
      }, _.createMap = function (t, e, r, i) {
        var o = this,
            s = e[o.id],
            l = o.styleObj = T(s.style);
        o.accessToken = s.accesstoken;
        var c = o.map = new n.Map({
          container: o.div,
          style: l.style,
          center: M(s.center),
          zoom: s.zoom,
          bearing: s.bearing,
          pitch: s.pitch,
          interactive: !o.isStatic,
          preserveDrawingBuffer: o.isStatic,
          doubleClickZoom: !1,
          boxZoom: !1,
          attributionControl: !1
        }).addControl(new n.AttributionControl({
          compact: !0
        }));
        c._canvas.style.left = "0px", c._canvas.style.top = "0px", o.rejectOnError(i), o.isStatic || o.initFx(t, e);
        var u = [];
        u.push(new Promise(function (t) {
          c.once("load", t);
        })), u = u.concat(a.fetchTraceGeoData(t)), Promise.all(u).then(function () {
          o.fillBelowLookup(t, e), o.updateData(t), o.updateLayout(e), o.resolveOnRender(r);
        }).catch(i);
      }, _.updateMap = function (t, e, r, n) {
        var i = this,
            o = i.map,
            s = e[this.id];
        i.rejectOnError(n);
        var l = [],
            c = T(s.style);
        JSON.stringify(i.styleObj) !== JSON.stringify(c) && (i.styleObj = c, o.setStyle(c.style), i.traceHash = {}, l.push(new Promise(function (t) {
          o.once("styledata", t);
        }))), l = l.concat(a.fetchTraceGeoData(t)), Promise.all(l).then(function () {
          i.fillBelowLookup(t, e), i.updateData(t), i.updateLayout(e), i.resolveOnRender(r);
        }).catch(n);
      }, _.fillBelowLookup = function (t, e) {
        var r,
            n,
            i = e[this.id].layers,
            a = this.belowLookup = {},
            o = !1;

        for (r = 0; r < t.length; r++) {
          var s = t[r][0].trace,
              l = s._module;
          "string" == typeof s.below ? n = s.below : l.getBelow && (n = l.getBelow(s, this)), "" === n && (o = !0), a["trace-" + s.uid] = n || "";
        }

        for (r = 0; r < i.length; r++) {
          var c = i[r];
          n = "string" == typeof c.below ? c.below : o ? "traces" : "", a["layout-" + r] = n;
        }

        var u,
            f,
            h = {};

        for (u in a) {
          h[n = a[u]] ? h[n].push(u) : h[n] = [u];
        }

        for (n in h) {
          var p = h[n];
          if (p.length > 1) for (r = 0; r < p.length; r++) {
            0 === (u = p[r]).indexOf("trace-") ? (f = u.split("trace-")[1], this.traceHash[f] && (this.traceHash[f].below = null)) : 0 === u.indexOf("layout-") && (f = u.split("layout-")[1], this.layerList[f] && (this.layerList[f].below = null));
          }
        }
      };
      var w = {
        choroplethmapbox: 0,
        densitymapbox: 1,
        scattermapbox: 2
      };

      function T(t) {
        var e = {};
        return i.isPlainObject(t) ? (e.id = t.id, e.style = t) : "string" == typeof t ? (e.id = t, -1 !== y.styleValuesMapbox.indexOf(t) ? e.style = k(t) : y.stylesNonMapbox[t] ? e.style = y.stylesNonMapbox[t] : e.style = t) : (e.id = y.styleValueDflt, e.style = k(y.styleValueDflt)), e.transition = {
          duration: 0,
          delay: 0
        }, e;
      }

      function k(t) {
        return y.styleUrlPrefix + t + "-" + y.styleUrlSuffix;
      }

      function M(t) {
        return [t.lon, t.lat];
      }

      _.updateData = function (t) {
        var e,
            r,
            n,
            i,
            a = this.traceHash,
            o = t.slice().sort(function (t, e) {
          return w[t[0].trace.type] - w[e[0].trace.type];
        });

        for (n = 0; n < o.length; n++) {
          var s = o[n],
              l = !1;
          (e = a[(r = s[0].trace).uid]) && (e.type === r.type ? (e.update(s), l = !0) : e.dispose()), !l && r._module && (a[r.uid] = r._module.plot(this, s));
        }

        var c = Object.keys(a);

        t: for (n = 0; n < c.length; n++) {
          var u = c[n];

          for (i = 0; i < t.length; i++) {
            if (u === (r = t[i][0].trace).uid) continue t;
          }

          (e = a[u]).dispose(), delete a[u];
        }
      }, _.updateLayout = function (t) {
        var e = this.map,
            r = t[this.id];
        this.dragging || this.wheeling || (e.setCenter(M(r.center)), e.setZoom(r.zoom), e.setBearing(r.bearing), e.setPitch(r.pitch)), this.updateLayers(t), this.updateFramework(t), this.updateFx(t), this.map.resize(), this.gd._context._scrollZoom.mapbox ? e.scrollZoom.enable() : e.scrollZoom.disable();
      }, _.resolveOnRender = function (t) {
        var e = this.map;
        e.on("render", function r() {
          e.loaded() && (e.off("render", r), setTimeout(t, 10));
        });
      }, _.rejectOnError = function (t) {
        var e = this.map;

        function r() {
          t(new Error(y.mapOnErrorMsg));
        }

        e.once("error", r), e.once("style.error", r), e.once("source.error", r), e.once("tile.error", r), e.once("layer.error", r);
      }, _.createFramework = function (t) {
        var e = this,
            r = e.div = document.createElement("div");
        r.id = e.uid, r.style.position = "absolute", e.container.appendChild(r), e.xaxis = {
          _id: "x",
          c2p: function c2p(t) {
            return e.project(t).x;
          }
        }, e.yaxis = {
          _id: "y",
          c2p: function c2p(t) {
            return e.project(t).y;
          }
        }, e.updateFramework(t), e.mockAxis = {
          type: "linear",
          showexponent: "all",
          exponentformat: "B"
        }, s.setConvert(e.mockAxis, t);
      }, _.initFx = function (t, e) {
        var r = this,
            n = r.gd,
            i = r.map;

        function a() {
          c.loneUnhover(e._hoverlayer);
        }

        function s() {
          var t = r.getView();
          n.emit("plotly_relayouting", r.getViewEditsWithDerived(t));
        }

        i.on("moveend", function (t) {
          if (r.map) {
            var e = n._fullLayout;

            if (t.originalEvent || r.wheeling) {
              var i = e[r.id];
              o.call("_storeDirectGUIEdit", n.layout, e._preGUI, r.getViewEdits(i));
              var a = r.getView();
              i._input.center = i.center = a.center, i._input.zoom = i.zoom = a.zoom, i._input.bearing = i.bearing = a.bearing, i._input.pitch = i.pitch = a.pitch, n.emit("plotly_relayout", r.getViewEditsWithDerived(a));
            }

            t.originalEvent && "mouseup" === t.originalEvent.type ? r.dragging = !1 : r.wheeling && (r.wheeling = !1), e._rehover && e._rehover();
          }
        }), i.on("wheel", function () {
          r.wheeling = !0;
        }), i.on("mousemove", function (t) {
          var e = r.div.getBoundingClientRect(),
              a = [t.originalEvent.offsetX, t.originalEvent.offsetY];
          t.target.getBoundingClientRect = function () {
            return e;
          }, r.xaxis.p2c = function () {
            return i.unproject(a).lng;
          }, r.yaxis.p2c = function () {
            return i.unproject(a).lat;
          }, n._fullLayout._rehover = function () {
            n._fullLayout._hoversubplot === r.id && n._fullLayout[r.id] && c.hover(n, t, r.id);
          }, c.hover(n, t, r.id), n._fullLayout._hoversubplot = r.id;
        }), i.on("dragstart", function () {
          r.dragging = !0, a();
        }), i.on("zoomstart", a), i.on("mouseout", function () {
          n._fullLayout._hoversubplot = null;
        }), i.on("drag", s), i.on("zoom", s), i.on("dblclick", function () {
          var t = n._fullLayout[r.id];
          o.call("_storeDirectGUIEdit", n.layout, n._fullLayout._preGUI, r.getViewEdits(t));
          var e = r.viewInitial;
          i.setCenter(M(e.center)), i.setZoom(e.zoom), i.setBearing(e.bearing), i.setPitch(e.pitch);
          var a = r.getView();
          t._input.center = t.center = a.center, t._input.zoom = t.zoom = a.zoom, t._input.bearing = t.bearing = a.bearing, t._input.pitch = t.pitch = a.pitch, n.emit("plotly_doubleclick", null), n.emit("plotly_relayout", r.getViewEditsWithDerived(a));
        }), r.clearSelect = function () {
          g(r.dragOptions), m(r.dragOptions.gd);
        }, r.onClickInPanFn = function (t) {
          return function (e) {
            var i = n._fullLayout.clickmode;
            i.indexOf("select") > -1 && v(e.originalEvent, n, [r.xaxis], [r.yaxis], r.id, t), i.indexOf("event") > -1 && c.click(n, e.originalEvent);
          };
        };
      }, _.updateFx = function (t) {
        var e = this,
            r = e.map,
            n = e.gd;

        if (!e.isStatic) {
          var a,
              o = t.dragmode;
          a = f(o) ? function (t, r) {
            (t.range = {})[e.id] = [c([r.xmin, r.ymin]), c([r.xmax, r.ymax])];
          } : function (t, r, n) {
            (t.lassoPoints = {})[e.id] = n.filtered.map(c);
          };
          var s = e.dragOptions;
          e.dragOptions = i.extendDeep(s || {}, {
            dragmode: t.dragmode,
            element: e.div,
            gd: n,
            plotinfo: {
              id: e.id,
              domain: t[e.id].domain,
              xaxis: e.xaxis,
              yaxis: e.yaxis,
              fillRangeItems: a
            },
            xaxes: [e.xaxis],
            yaxes: [e.yaxis],
            subplot: e.id
          }), r.off("click", e.onClickInPanHandler), p(o) || h(o) ? (r.dragPan.disable(), r.on("zoomstart", e.clearSelect), e.dragOptions.prepFn = function (t, r, n) {
            d(t, r, n, e.dragOptions, o);
          }, l.init(e.dragOptions)) : (r.dragPan.enable(), r.off("zoomstart", e.clearSelect), e.div.onmousedown = null, e.onClickInPanHandler = e.onClickInPanFn(e.dragOptions), r.on("click", e.onClickInPanHandler));
        }

        function c(t) {
          var r = e.map.unproject(t);
          return [r.lng, r.lat];
        }
      }, _.updateFramework = function (t) {
        var e = t[this.id].domain,
            r = t._size,
            n = this.div.style;
        n.width = r.w * (e.x[1] - e.x[0]) + "px", n.height = r.h * (e.y[1] - e.y[0]) + "px", n.left = r.l + e.x[0] * r.w + "px", n.top = r.t + (1 - e.y[1]) * r.h + "px", this.xaxis._offset = r.l + e.x[0] * r.w, this.xaxis._length = r.w * (e.x[1] - e.x[0]), this.yaxis._offset = r.t + (1 - e.y[1]) * r.h, this.yaxis._length = r.h * (e.y[1] - e.y[0]);
      }, _.updateLayers = function (t) {
        var e,
            r = t[this.id].layers,
            n = this.layerList;

        if (r.length !== n.length) {
          for (e = 0; e < n.length; e++) {
            n[e].dispose();
          }

          for (n = this.layerList = [], e = 0; e < r.length; e++) {
            n.push(x(this, e, r[e]));
          }
        } else for (e = 0; e < r.length; e++) {
          n[e].update(r[e]);
        }
      }, _.destroy = function () {
        this.map && (this.map.remove(), this.map = null, this.container.removeChild(this.div));
      }, _.toImage = function () {
        return this.map.stop(), this.map.getCanvas().toDataURL();
      }, _.setOptions = function (t, e, r) {
        for (var n in r) {
          this.map[e](t, n, r[n]);
        }
      }, _.getMapLayers = function () {
        return this.map.getStyle().layers;
      }, _.addLayer = function (t, e) {
        var r = this.map;

        if ("string" == typeof e) {
          if ("" === e) return void r.addLayer(t, e);

          for (var n = this.getMapLayers(), a = 0; a < n.length; a++) {
            if (e === n[a].id) return void r.addLayer(t, e);
          }

          i.warn(["Trying to add layer with *below* value", e, "referencing a layer that does not exist", "or that does not yet exist."].join(" "));
        }

        r.addLayer(t);
      }, _.project = function (t) {
        return this.map.project(new n.LngLat(t[0], t[1]));
      }, _.getView = function () {
        var t = this.map,
            e = t.getCenter(),
            r = {
          lon: e.lng,
          lat: e.lat
        },
            n = t.getCanvas(),
            i = n.width,
            a = n.height;
        return {
          center: r,
          zoom: t.getZoom(),
          bearing: t.getBearing(),
          pitch: t.getPitch(),
          _derived: {
            coordinates: [t.unproject([0, 0]).toArray(), t.unproject([i, 0]).toArray(), t.unproject([i, a]).toArray(), t.unproject([0, a]).toArray()]
          }
        };
      }, _.getViewEdits = function (t) {
        for (var e = this.id, r = ["center", "zoom", "bearing", "pitch"], n = {}, i = 0; i < r.length; i++) {
          var a = r[i];
          n[e + "." + a] = t[a];
        }

        return n;
      }, _.getViewEditsWithDerived = function (t) {
        var e = this.id,
            r = this.getViewEdits(t);
        return r[e + "._derived"] = t._derived, r;
      }, e.exports = b;
    }, {
      "../../components/dragelement": 677,
      "../../components/dragelement/helpers": 676,
      "../../components/fx": 698,
      "../../lib": 795,
      "../../lib/geo_location_utils": 788,
      "../../registry": 923,
      "../cartesian/axes": 845,
      "../cartesian/select": 864,
      "./constants": 901,
      "./layers": 904,
      "mapbox-gl/dist/mapbox-gl-unminified": 452
    }],
    908: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        var e = t.editType;
        return {
          t: {
            valType: "number",
            dflt: 0,
            editType: e
          },
          r: {
            valType: "number",
            dflt: 0,
            editType: e
          },
          b: {
            valType: "number",
            dflt: 0,
            editType: e
          },
          l: {
            valType: "number",
            dflt: 0,
            editType: e
          },
          editType: e
        };
      };
    }, {}],
    909: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("d3-time-format").timeFormatLocale,
          a = t("fast-isnumeric"),
          o = t("../registry"),
          s = t("../plot_api/plot_schema"),
          l = t("../plot_api/plot_template"),
          c = t("../lib"),
          u = t("../components/color"),
          f = t("../constants/numerical").BADNUM,
          h = t("./cartesian/axis_ids"),
          p = t("./cartesian/handle_outline").clearSelect,
          d = t("./animation_attributes"),
          m = t("./frame_attributes"),
          g = t("../plots/get_data").getModuleCalcData,
          v = c.relinkPrivateKeys,
          y = c._,
          x = e.exports = {};
      c.extendFlat(x, o), x.attributes = t("./attributes"), x.attributes.type.values = x.allTypes, x.fontAttrs = t("./font_attributes"), x.layoutAttributes = t("./layout_attributes"), x.fontWeight = "normal";

      var b = x.transformsRegistry,
          _ = t("./command");

      x.executeAPICommand = _.executeAPICommand, x.computeAPICommandBindings = _.computeAPICommandBindings, x.manageCommandObserver = _.manageCommandObserver, x.hasSimpleAPICommandBindings = _.hasSimpleAPICommandBindings, x.redrawText = function (t) {
        return t = c.getGraphDiv(t), new Promise(function (e) {
          setTimeout(function () {
            t._fullLayout && (o.getComponentMethod("annotations", "draw")(t), o.getComponentMethod("legend", "draw")(t), o.getComponentMethod("colorbar", "draw")(t), e(x.previousPromises(t)));
          }, 300);
        });
      }, x.resize = function (t) {
        var e;
        t = c.getGraphDiv(t);
        var r = new Promise(function (r, n) {
          t && !c.isHidden(t) || n(new Error("Resize must be passed a displayed plot div element.")), t._redrawTimer && clearTimeout(t._redrawTimer), t._resolveResize && (e = t._resolveResize), t._resolveResize = r, t._redrawTimer = setTimeout(function () {
            if (!t.layout || t.layout.width && t.layout.height || c.isHidden(t)) r(t);else {
              delete t.layout.width, delete t.layout.height;
              var e = t.changed;
              t.autoplay = !0, o.call("relayout", t, {
                autosize: !0
              }).then(function () {
                t.changed = e, t._resolveResize === r && (delete t._resolveResize, r(t));
              });
            }
          }, 100);
        });
        return e && e(r), r;
      }, x.previousPromises = function (t) {
        if ((t._promises || []).length) return Promise.all(t._promises).then(function () {
          t._promises = [];
        });
      }, x.addLinks = function (t) {
        if (t._context.showLink || t._context.showSources) {
          var e = t._fullLayout,
              r = c.ensureSingle(e._paper, "text", "js-plot-link-container", function (t) {
            t.style({
              "font-family": '"Open Sans", Arial, sans-serif',
              "font-size": "12px",
              fill: u.defaultLine,
              "pointer-events": "all"
            }).each(function () {
              var t = n.select(this);
              t.append("tspan").classed("js-link-to-tool", !0), t.append("tspan").classed("js-link-spacer", !0), t.append("tspan").classed("js-sourcelinks", !0);
            });
          }),
              i = r.node(),
              a = {
            y: e._paper.attr("height") - 9
          };
          document.body.contains(i) && i.getComputedTextLength() >= e.width - 20 ? (a["text-anchor"] = "start", a.x = 5) : (a["text-anchor"] = "end", a.x = e._paper.attr("width") - 7), r.attr(a);
          var o = r.select(".js-link-to-tool"),
              s = r.select(".js-link-spacer"),
              l = r.select(".js-sourcelinks");
          t._context.showSources && t._context.showSources(t), t._context.showLink && function (t, e) {
            e.text("");
            var r = e.append("a").attr({
              "xlink:xlink:href": "#",
              class: "link--impt link--embedview",
              "font-weight": "bold"
            }).text(t._context.linkText + " " + String.fromCharCode(187));
            if (t._context.sendData) r.on("click", function () {
              x.sendDataToCloud(t);
            });else {
              var n = window.location.pathname.split("/"),
                  i = window.location.search;
              r.attr({
                "xlink:xlink:show": "new",
                "xlink:xlink:href": "/" + n[2].split(".")[0] + "/" + n[1] + i
              });
            }
          }(t, o), s.text(o.text() && l.text() ? " - " : "");
        }
      }, x.sendDataToCloud = function (t) {
        var e = (window.PLOTLYENV || {}).BASE_URL || t._context.plotlyServerURL;

        if (e) {
          t.emit("plotly_beforeexport");
          var r = n.select(t).append("div").attr("id", "hiddenform").style("display", "none"),
              i = r.append("form").attr({
            action: e + "/external",
            method: "post",
            target: "_blank"
          });
          return i.append("input").attr({
            type: "text",
            name: "data"
          }).node().value = x.graphJson(t, !1, "keepdata"), i.node().submit(), r.remove(), t.emit("plotly_afterexport"), !1;
        }
      };
      var w = ["days", "shortDays", "months", "shortMonths", "periods", "dateTime", "date", "time", "decimal", "thousands", "grouping", "currency"],
          T = ["year", "month", "dayMonth", "dayMonthYear"];

      function k(t, e) {
        var r = t._context.locale;
        r || (r = "en-US");
        var n = !1,
            i = {};

        function a(t) {
          for (var r = !0, a = 0; a < e.length; a++) {
            var o = e[a];
            i[o] || (t[o] ? i[o] = t[o] : r = !1);
          }

          r && (n = !0);
        }

        for (var s = 0; s < 2; s++) {
          for (var l = t._context.locales, c = 0; c < 2; c++) {
            var u = (l[r] || {}).format;
            if (u && (a(u), n)) break;
            l = o.localeRegistry;
          }

          var f = r.split("-")[0];
          if (n || f === r) break;
          r = f;
        }

        return n || a(o.localeRegistry.en.format), i;
      }

      function M(t, e) {
        var r = {
          _fullLayout: e
        },
            n = "x" === t._id.charAt(0),
            i = t._mainAxis._anchorAxis,
            a = "",
            o = "",
            s = "";

        if (i && (s = i._mainAxis._id, a = n ? t._id + s : s + t._id), !a || !e._plots[a]) {
          a = "";

          for (var l = t._counterAxes, c = 0; c < l.length; c++) {
            var u = l[c],
                f = n ? t._id + u : u + t._id;
            o || (o = f);
            var p = h.getFromId(r, u);

            if (s && p.overlaying === s) {
              a = f;
              break;
            }
          }
        }

        return a || o;
      }

      function A(t) {
        var e = t.transforms;
        if (Array.isArray(e) && e.length) for (var r = 0; r < e.length; r++) {
          var n = e[r],
              i = n._module || b[n.type];
          if (i && i.makesData) return !0;
        }
        return !1;
      }

      function S(t, e, r, n) {
        for (var i = t.transforms, a = [t], o = 0; o < i.length; o++) {
          var s = i[o],
              l = b[s.type];
          l && l.transform && (a = l.transform(a, {
            transform: s,
            fullTrace: t,
            fullData: e,
            layout: r,
            fullLayout: n,
            transformIndex: o
          }));
        }

        return a;
      }

      function E(t) {
        return "string" == typeof t && "px" === t.substr(t.length - 2) && parseFloat(t);
      }

      function L(t) {
        var e = t.margin;

        if (!t._size) {
          var r = t._size = {
            l: Math.round(e.l),
            r: Math.round(e.r),
            t: Math.round(e.t),
            b: Math.round(e.b),
            p: Math.round(e.pad)
          };
          r.w = Math.round(t.width) - r.l - r.r, r.h = Math.round(t.height) - r.t - r.b;
        }

        t._pushmargin || (t._pushmargin = {}), t._pushmarginIds || (t._pushmarginIds = {});
      }

      x.supplyDefaults = function (t, e) {
        var r = e && e.skipUpdateCalc,
            a = t._fullLayout || {};
        if (a._skipDefaults) delete a._skipDefaults;else {
          var s,
              l = t._fullLayout = {},
              u = t.layout || {},
              f = t._fullData || [],
              h = t._fullData = [],
              d = t.data || [],
              m = t.calcdata || [],
              g = t._context || {};
          t._transitionData || x.createTransitionData(t), l._dfltTitle = {
            plot: y(t, "Click to enter Plot title"),
            x: y(t, "Click to enter X axis title"),
            y: y(t, "Click to enter Y axis title"),
            colorbar: y(t, "Click to enter Colorscale title"),
            annotation: y(t, "new text")
          }, l._traceWord = y(t, "trace");
          var b = k(t, w);

          if (l._mapboxAccessToken = g.mapboxAccessToken, a._initialAutoSizeIsDone) {
            var _ = a.width,
                M = a.height;
            x.supplyLayoutGlobalDefaults(u, l, b), u.width || (l.width = _), u.height || (l.height = M), x.sanitizeMargins(l);
          } else {
            x.supplyLayoutGlobalDefaults(u, l, b);
            var A = !u.width || !u.height,
                S = l.autosize,
                E = g.autosizable;
            A && (S || E) ? x.plotAutoSize(t, u, l) : A && x.sanitizeMargins(l), !S && A && (u.width = l.width, u.height = l.height);
          }

          l._d3locale = function (t, e) {
            return t.decimal = e.charAt(0), t.thousands = e.charAt(1), {
              numberFormat: n.locale(t).numberFormat,
              timeFormat: i(t).utcFormat
            };
          }(b, l.separators), l._extraFormat = k(t, T), l._initialAutoSizeIsDone = !0, l._dataLength = d.length, l._modules = [], l._visibleModules = [], l._basePlotModules = [];

          var C = l._subplots = function () {
            var t,
                e,
                r = o.collectableSubplotTypes,
                n = {};

            if (!r) {
              r = [];
              var i = o.subplotsRegistry;

              for (var a in i) {
                var s = i[a].attr;
                if (s && (r.push(a), Array.isArray(s))) for (e = 0; e < s.length; e++) {
                  c.pushUnique(r, s[e]);
                }
              }
            }

            for (t = 0; t < r.length; t++) {
              n[r[t]] = [];
            }

            return n;
          }(),
              P = l._splomAxes = {
            x: {},
            y: {}
          },
              I = l._splomSubplots = {};

          l._splomGridDflt = {}, l._scatterStackOpts = {}, l._firstScatter = {}, l._alignmentOpts = {}, l._colorAxes = {}, l._requestRangeslider = {}, l._traceUids = function (t, e) {
            var r,
                n,
                i = e.length,
                a = [];

            for (r = 0; r < t.length; r++) {
              var o = t[r]._fullInput;
              o !== n && a.push(o), n = o;
            }

            var s = a.length,
                l = new Array(i),
                u = {};

            function f(t, e) {
              l[e] = t, u[t] = 1;
            }

            function h(t, e) {
              if (t && "string" == typeof t && !u[t]) return f(t, e), !0;
            }

            for (r = 0; r < i; r++) {
              var p = e[r].uid;
              "number" == typeof p && (p = String(p)), h(p, r) || r < s && h(a[r].uid, r) || f(c.randstr(u), r);
            }

            return l;
          }(f, d), l._globalTransforms = (t._context || {}).globalTransforms, x.supplyDataDefaults(d, h, u, l);
          var O = Object.keys(P.x),
              z = Object.keys(P.y);

          if (O.length > 1 && z.length > 1) {
            for (o.getComponentMethod("grid", "sizeDefaults")(u, l), s = 0; s < O.length; s++) {
              c.pushUnique(C.xaxis, O[s]);
            }

            for (s = 0; s < z.length; s++) {
              c.pushUnique(C.yaxis, z[s]);
            }

            for (var D in I) {
              c.pushUnique(C.cartesian, D);
            }
          }

          if (l._has = x._hasPlotType.bind(l), f.length === h.length) for (s = 0; s < h.length; s++) {
            v(h[s], f[s]);
          }
          x.supplyLayoutModuleDefaults(u, l, h, t._transitionData);
          var R = l._visibleModules,
              F = [];

          for (s = 0; s < R.length; s++) {
            var B = R[s].crossTraceDefaults;
            B && c.pushUnique(F, B);
          }

          for (s = 0; s < F.length; s++) {
            F[s](h, l);
          }

          l._hasOnlyLargeSploms = 1 === l._basePlotModules.length && "splom" === l._basePlotModules[0].name && O.length > 15 && z.length > 15 && 0 === l.shapes.length && 0 === l.images.length, x.linkSubplots(h, l, f, a), x.cleanPlot(h, l, f, a);
          var N = !(!a._has || !a._has("gl2d")),
              j = !(!l._has || !l._has("gl2d")),
              U = !(!a._has || !a._has("cartesian")) || N,
              V = !(!l._has || !l._has("cartesian")) || j;
          U && !V ? a._bgLayer.remove() : V && !U && (l._shouldCreateBgLayer = !0), a._zoomlayer && !t._dragging && p({
            _fullLayout: a
          }), function (t, e) {
            var r,
                n = [];
            e.meta && (r = e._meta = {
              meta: e.meta,
              layout: {
                meta: e.meta
              }
            });

            for (var i = 0; i < t.length; i++) {
              var a = t[i];
              a.meta ? n[a.index] = a._meta = {
                meta: a.meta
              } : e.meta && (a._meta = {
                meta: e.meta
              }), e.meta && (a._meta.layout = {
                meta: e.meta
              });
            }

            n.length && (r || (r = e._meta = {}), r.data = n);
          }(h, l), v(l, a), o.getComponentMethod("colorscale", "crossTraceDefaults")(h, l), l._preGUI || (l._preGUI = {}), l._tracePreGUI || (l._tracePreGUI = {});
          var q,
              H = l._tracePreGUI,
              G = {};

          for (q in H) {
            G[q] = "old";
          }

          for (s = 0; s < h.length; s++) {
            G[q = h[s]._fullInput.uid] || (H[q] = {}), G[q] = "new";
          }

          for (q in G) {
            "old" === G[q] && delete H[q];
          }

          L(l), o.getComponentMethod("rangeslider", "makeData")(l), r || m.length !== h.length || x.supplyDefaultsUpdateCalc(m, h);
        }
      }, x.supplyDefaultsUpdateCalc = function (t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r],
              i = (t[r] || [])[0];

          if (i && i.trace) {
            var a = i.trace;

            if (a._hasCalcTransform) {
              var o,
                  s,
                  l,
                  u = a._arrayAttrs;

              for (o = 0; o < u.length; o++) {
                s = u[o], l = c.nestedProperty(a, s).get().slice(), c.nestedProperty(n, s).set(l);
              }
            }

            i.trace = n;
          }
        }
      }, x.createTransitionData = function (t) {
        t._transitionData || (t._transitionData = {}), t._transitionData._frames || (t._transitionData._frames = []), t._transitionData._frameHash || (t._transitionData._frameHash = {}), t._transitionData._counter || (t._transitionData._counter = 0), t._transitionData._interruptCallbacks || (t._transitionData._interruptCallbacks = []);
      }, x._hasPlotType = function (t) {
        var e,
            r = this._basePlotModules || [];

        for (e = 0; e < r.length; e++) {
          if (r[e].name === t) return !0;
        }

        var n = this._modules || [];

        for (e = 0; e < n.length; e++) {
          var i = n[e].name;
          if (i === t) return !0;
          var a = o.modules[i];
          if (a && a.categories[t]) return !0;
        }

        return !1;
      }, x.cleanPlot = function (t, e, r, n) {
        var i,
            a,
            o = n._basePlotModules || [];

        for (i = 0; i < o.length; i++) {
          var s = o[i];
          s.clean && s.clean(t, e, r, n);
        }

        var l = n._has && n._has("gl"),
            c = e._has && e._has("gl");

        l && !c && void 0 !== n._glcontainer && (n._glcontainer.selectAll(".gl-canvas").remove(), n._glcontainer.selectAll(".no-webgl").remove(), n._glcanvas = null);
        var u = !!n._infolayer;

        t: for (i = 0; i < r.length; i++) {
          var f = r[i].uid;

          for (a = 0; a < t.length; a++) {
            if (f === t[a].uid) continue t;
          }

          u && n._infolayer.select(".cb" + f).remove();
        }
      }, x.linkSubplots = function (t, e, r, n) {
        var i,
            a,
            s = n._plots || {},
            l = e._plots = {},
            u = e._subplots,
            f = {
          _fullData: t,
          _fullLayout: e
        },
            p = u.cartesian.concat(u.gl2d || []);

        for (i = 0; i < p.length; i++) {
          var d,
              m = p[i],
              g = s[m],
              v = h.getFromId(f, m, "x"),
              y = h.getFromId(f, m, "y");

          for (g ? d = l[m] = g : (d = l[m] = {}).id = m, v._counterAxes.push(y._id), y._counterAxes.push(v._id), v._subplotsWith.push(m), y._subplotsWith.push(m), d.xaxis = v, d.yaxis = y, d._hasClipOnAxisFalse = !1, a = 0; a < t.length; a++) {
            var x = t[a];

            if (x.xaxis === d.xaxis._id && x.yaxis === d.yaxis._id && !1 === x.cliponaxis) {
              d._hasClipOnAxisFalse = !0;
              break;
            }
          }
        }

        var b,
            _ = h.list(f, null, !0);

        for (i = 0; i < _.length; i++) {
          var w = null;
          (b = _[i]).overlaying && (w = h.getFromId(f, b.overlaying)) && w.overlaying && (b.overlaying = !1, w = null), b._mainAxis = w || b, w && (b.domain = w.domain.slice()), b._anchorAxis = "free" === b.anchor ? null : h.getFromId(f, b.anchor);
        }

        for (i = 0; i < _.length; i++) {
          if ((b = _[i])._counterAxes.sort(h.idSort), b._subplotsWith.sort(c.subplotSort), b._mainSubplot = M(b, e), b._counterAxes.length && (b.spikemode && -1 !== b.spikemode.indexOf("across") || b.automargin && b.mirror && "free" !== b.anchor || o.getComponentMethod("rangeslider", "isVisible")(b))) {
            var T = 1,
                k = 0;

            for (a = 0; a < b._counterAxes.length; a++) {
              var A = h.getFromId(f, b._counterAxes[a]);
              T = Math.min(T, A.domain[0]), k = Math.max(k, A.domain[1]);
            }

            T < k && (b._counterDomainMin = T, b._counterDomainMax = k);
          }
        }
      }, x.clearExpandedTraceDefaultColors = function (t) {
        var e, r, n;

        for (r = [], (e = t._module._colorAttrs) || (t._module._colorAttrs = e = [], s.crawl(t._module.attributes, function (t, n, i, a) {
          r[a] = n, r.length = a + 1, "color" === t.valType && void 0 === t.dflt && e.push(r.join("."));
        })), n = 0; n < e.length; n++) {
          c.nestedProperty(t, "_input." + e[n]).get() || c.nestedProperty(t, e[n]).set(null);
        }
      }, x.supplyDataDefaults = function (t, e, r, n) {
        var i,
            a,
            s,
            u = n._modules,
            f = n._visibleModules,
            h = n._basePlotModules,
            p = 0,
            d = 0;

        function m(t) {
          e.push(t);
          var r = t._module;
          r && (c.pushUnique(u, r), !0 === t.visible && c.pushUnique(f, r), c.pushUnique(h, t._module.basePlotModule), p++, !1 !== t._input.visible && d++);
        }

        n._transformModules = [];

        var g = {},
            y = [],
            b = (r.template || {}).data || {},
            _ = l.traceTemplater(b);

        for (i = 0; i < t.length; i++) {
          if (s = t[i], (a = _.newTrace(s)).uid = n._traceUids[i], x.supplyTraceDefaults(s, a, d, n, i), a.index = i, a._input = s, a._expandedIndex = p, a.transforms && a.transforms.length) for (var w = !1 !== s.visible && !1 === a.visible, T = S(a, e, r, n), k = 0; k < T.length; k++) {
            var M = T[k],
                A = {
              _template: a._template,
              type: a.type,
              uid: a.uid + k
            };
            w && !1 === M.visible && delete M.visible, x.supplyTraceDefaults(M, A, p, n, i), v(A, M), A.index = i, A._input = s, A._fullInput = a, A._expandedIndex = p, A._expandedInput = M, m(A);
          } else a._fullInput = a, a._expandedInput = a, m(a);
          o.traceIs(a, "carpetAxis") && (g[a.carpet] = a), o.traceIs(a, "carpetDependent") && y.push(i);
        }

        for (i = 0; i < y.length; i++) {
          if ((a = e[y[i]]).visible) {
            var E = g[a.carpet];
            a._carpet = E, E && E.visible ? (a.xaxis = E.xaxis, a.yaxis = E.yaxis) : a.visible = !1;
          }
        }
      }, x.supplyAnimationDefaults = function (t) {
        var e;
        t = t || {};
        var r = {};

        function n(e, n) {
          return c.coerce(t || {}, r, d, e, n);
        }

        if (n("mode"), n("direction"), n("fromcurrent"), Array.isArray(t.frame)) for (r.frame = [], e = 0; e < t.frame.length; e++) {
          r.frame[e] = x.supplyAnimationFrameDefaults(t.frame[e] || {});
        } else r.frame = x.supplyAnimationFrameDefaults(t.frame || {});
        if (Array.isArray(t.transition)) for (r.transition = [], e = 0; e < t.transition.length; e++) {
          r.transition[e] = x.supplyAnimationTransitionDefaults(t.transition[e] || {});
        } else r.transition = x.supplyAnimationTransitionDefaults(t.transition || {});
        return r;
      }, x.supplyAnimationFrameDefaults = function (t) {
        var e = {};

        function r(r, n) {
          return c.coerce(t || {}, e, d.frame, r, n);
        }

        return r("duration"), r("redraw"), e;
      }, x.supplyAnimationTransitionDefaults = function (t) {
        var e = {};

        function r(r, n) {
          return c.coerce(t || {}, e, d.transition, r, n);
        }

        return r("duration"), r("easing"), e;
      }, x.supplyFrameDefaults = function (t) {
        var e = {};

        function r(r, n) {
          return c.coerce(t, e, m, r, n);
        }

        return r("group"), r("name"), r("traces"), r("baseframe"), r("data"), r("layout"), e;
      }, x.supplyTraceDefaults = function (t, e, r, n, i) {
        var a,
            s = n.colorway || u.defaults,
            l = s[r % s.length];

        function f(r, n) {
          return c.coerce(t, e, x.attributes, r, n);
        }

        var h = f("visible");
        f("type"), f("name", n._traceWord + " " + i), f("uirevision", n.uirevision);
        var p = x.getModule(e);

        if (e._module = p, p) {
          var d = p.basePlotModule,
              m = d.attr,
              g = d.attributes;

          if (m && g) {
            var v = n._subplots,
                y = "";

            if (h || "gl2d" !== d.name) {
              if (Array.isArray(m)) for (a = 0; a < m.length; a++) {
                var b = m[a],
                    _ = c.coerce(t, e, g, b);

                v[b] && c.pushUnique(v[b], _), y += _;
              } else y = c.coerce(t, e, g, m);
              v[d.name] && c.pushUnique(v[d.name], y);
            }
          }
        }

        return h && (f("customdata"), f("ids"), f("meta"), o.traceIs(e, "showLegend") ? (c.coerce(t, e, p.attributes.showlegend ? p.attributes : x.attributes, "showlegend"), f("legendgroup"), e._dfltShowLegend = !0) : e._dfltShowLegend = !1, p && p.supplyDefaults(t, e, l, n), o.traceIs(e, "noOpacity") || f("opacity"), o.traceIs(e, "notLegendIsolatable") && (e.visible = !!e.visible), o.traceIs(e, "noHover") || (e.hovertemplate || c.coerceHoverinfo(t, e, n), "parcats" !== e.type && o.getComponentMethod("fx", "supplyDefaults")(t, e, l, n)), p && p.selectPoints && f("selectedpoints"), x.supplyTransformDefaults(t, e, n)), e;
      }, x.hasMakesDataTransform = A, x.supplyTransformDefaults = function (t, e, r) {
        if (e._length || A(t)) {
          var n = r._globalTransforms || [],
              i = r._transformModules || [];
          if (Array.isArray(t.transforms) || 0 !== n.length) for (var a = t.transforms || [], o = n.concat(a), s = e.transforms = [], l = 0; l < o.length; l++) {
            var u,
                f = o[l],
                h = f.type,
                p = b[h],
                d = !(f._module && f._module === p),
                m = p && "function" == typeof p.transform;
            p || c.warn("Unrecognized transform type " + h + "."), p && p.supplyDefaults && (d || m) ? ((u = p.supplyDefaults(f, e, r, t)).type = h, u._module = p, c.pushUnique(i, p)) : u = c.extendFlat({}, f), s.push(u);
          }
        }
      }, x.supplyLayoutGlobalDefaults = function (t, e, r) {
        function n(r, n) {
          return c.coerce(t, e, x.layoutAttributes, r, n);
        }

        var i = t.template;
        c.isPlainObject(i) && (e.template = i, e._template = i.layout, e._dataTemplate = i.data), n("autotypenumbers");
        var a = c.coerceFont(n, "font");
        n("title.text", e._dfltTitle.plot), c.coerceFont(n, "title.font", {
          family: a.family,
          size: Math.round(1.4 * a.size),
          color: a.color
        }), n("title.xref"), n("title.yref"), n("title.x"), n("title.y"), n("title.xanchor"), n("title.yanchor"), n("title.pad.t"), n("title.pad.r"), n("title.pad.b"), n("title.pad.l"), n("uniformtext.mode") && n("uniformtext.minsize"), n("autosize", !(t.width && t.height)), n("width"), n("height"), n("margin.l"), n("margin.r"), n("margin.t"), n("margin.b"), n("margin.pad"), n("margin.autoexpand"), t.width && t.height && x.sanitizeMargins(e), o.getComponentMethod("grid", "sizeDefaults")(t, e), n("paper_bgcolor"), n("separators", r.decimal + r.thousands), n("hidesources"), n("colorway"), n("datarevision");
        var s = n("uirevision");
        n("editrevision", s), n("selectionrevision", s), o.getComponentMethod("modebar", "supplyLayoutDefaults")(t, e), o.getComponentMethod("shapes", "supplyDrawNewShapeDefaults")(t, e, n), n("meta"), c.isPlainObject(t.transition) && (n("transition.duration"), n("transition.easing"), n("transition.ordering")), o.getComponentMethod("calendars", "handleDefaults")(t, e, "calendar"), o.getComponentMethod("fx", "supplyLayoutGlobalDefaults")(t, e, n);
      }, x.plotAutoSize = function (t, e, r) {
        var n,
            i,
            o = t._context || {},
            s = o.frameMargins,
            l = c.isPlotDiv(t);
        if (l && t.emit("plotly_autosize"), o.fillFrame) n = window.innerWidth, i = window.innerHeight, document.body.style.overflow = "hidden";else {
          var u = l ? window.getComputedStyle(t) : {};

          if (n = E(u.width) || E(u.maxWidth) || r.width, i = E(u.height) || E(u.maxHeight) || r.height, a(s) && s > 0) {
            var f = 1 - 2 * s;
            n = Math.round(f * n), i = Math.round(f * i);
          }
        }
        var h = x.layoutAttributes.width.min,
            p = x.layoutAttributes.height.min;
        n < h && (n = h), i < p && (i = p);
        var d = !e.width && Math.abs(r.width - n) > 1,
            m = !e.height && Math.abs(r.height - i) > 1;
        (m || d) && (d && (r.width = n), m && (r.height = i)), t._initialAutoSize || (t._initialAutoSize = {
          width: n,
          height: i
        }), x.sanitizeMargins(r);
      }, x.supplyLayoutModuleDefaults = function (t, e, r, n) {
        var i,
            a,
            s,
            l = o.componentsRegistry,
            u = e._basePlotModules,
            f = o.subplotsRegistry.cartesian;

        for (i in l) {
          (s = l[i]).includeBasePlot && s.includeBasePlot(t, e);
        }

        for (var h in u.length || u.push(f), e._has("cartesian") && (o.getComponentMethod("grid", "contentDefaults")(t, e), f.finalizeSubplots(t, e)), e._subplots) {
          e._subplots[h].sort(c.subplotSort);
        }

        for (a = 0; a < u.length; a++) {
          (s = u[a]).supplyLayoutDefaults && s.supplyLayoutDefaults(t, e, r);
        }

        var p = e._modules;

        for (a = 0; a < p.length; a++) {
          (s = p[a]).supplyLayoutDefaults && s.supplyLayoutDefaults(t, e, r);
        }

        var d = e._transformModules;

        for (a = 0; a < d.length; a++) {
          (s = d[a]).supplyLayoutDefaults && s.supplyLayoutDefaults(t, e, r, n);
        }

        for (i in l) {
          (s = l[i]).supplyLayoutDefaults && s.supplyLayoutDefaults(t, e, r);
        }
      }, x.purge = function (t) {
        var e = t._fullLayout || {};
        void 0 !== e._glcontainer && (e._glcontainer.selectAll(".gl-canvas").remove(), e._glcontainer.remove(), e._glcanvas = null), e._modeBar && e._modeBar.destroy(), t._transitionData && (t._transitionData._interruptCallbacks && (t._transitionData._interruptCallbacks.length = 0), t._transitionData._animationRaf && window.cancelAnimationFrame(t._transitionData._animationRaf)), c.clearThrottle(), c.clearResponsive(t), delete t.data, delete t.layout, delete t._fullData, delete t._fullLayout, delete t.calcdata, delete t.empty, delete t.fid, delete t.undoqueue, delete t.undonum, delete t.autoplay, delete t.changed, delete t._promises, delete t._redrawTimer, delete t._hmlumcount, delete t._hmpixcount, delete t._transitionData, delete t._transitioning, delete t._initialAutoSize, delete t._transitioningWithDuration, delete t._dragging, delete t._dragged, delete t._dragdata, delete t._hoverdata, delete t._snapshotInProgress, delete t._editing, delete t._mouseDownTime, delete t._legendMouseDownTime, t.removeAllListeners && t.removeAllListeners();
      }, x.style = function (t) {
        var e,
            r = t._fullLayout._visibleModules,
            n = [];

        for (e = 0; e < r.length; e++) {
          var i = r[e];
          i.style && c.pushUnique(n, i.style);
        }

        for (e = 0; e < n.length; e++) {
          n[e](t);
        }
      }, x.sanitizeMargins = function (t) {
        if (t && t.margin) {
          var e,
              r = t.width,
              n = t.height,
              i = t.margin,
              a = r - (i.l + i.r),
              o = n - (i.t + i.b);
          a < 0 && (e = (r - 1) / (i.l + i.r), i.l = Math.floor(e * i.l), i.r = Math.floor(e * i.r)), o < 0 && (e = (n - 1) / (i.t + i.b), i.t = Math.floor(e * i.t), i.b = Math.floor(e * i.b));
        }
      }, x.clearAutoMarginIds = function (t) {
        t._fullLayout._pushmarginIds = {};
      }, x.allowAutoMargin = function (t, e) {
        t._fullLayout._pushmarginIds[e] = 1;
      };
      x.autoMargin = function (t, e, r) {
        var n = t._fullLayout,
            i = n.width,
            a = n.height,
            o = n.margin,
            s = c.constrain(i - o.l - o.r, 2, 64),
            l = c.constrain(a - o.t - o.b, 2, 64),
            u = Math.max(0, i - s),
            f = Math.max(0, a - l),
            h = n._pushmargin,
            p = n._pushmarginIds;

        if (!1 !== o.autoexpand) {
          if (r) {
            var d = r.pad;

            if (void 0 === d && (d = Math.min(12, o.l, o.r, o.t, o.b)), u) {
              var m = (r.l + r.r) / u;
              m > 1 && (r.l /= m, r.r /= m);
            }

            if (f) {
              var g = (r.t + r.b) / f;
              g > 1 && (r.t /= g, r.b /= g);
            }

            var v = void 0 !== r.xl ? r.xl : r.x,
                y = void 0 !== r.xr ? r.xr : r.x,
                b = void 0 !== r.yt ? r.yt : r.y,
                _ = void 0 !== r.yb ? r.yb : r.y;

            h[e] = {
              l: {
                val: v,
                size: r.l + d
              },
              r: {
                val: y,
                size: r.r + d
              },
              b: {
                val: _,
                size: r.b + d
              },
              t: {
                val: b,
                size: r.t + d
              }
            }, p[e] = 1;
          } else delete h[e], delete p[e];

          if (!n._replotting) return x.doAutoMargin(t);
        }
      }, x.doAutoMargin = function (t) {
        var e = t._fullLayout,
            r = e.width,
            n = e.height;
        e._size || (e._size = {}), L(e);
        var i = e._size,
            s = e.margin,
            l = c.extendFlat({}, i),
            u = s.l,
            f = s.r,
            p = s.t,
            d = s.b,
            m = e._pushmargin,
            g = e._pushmarginIds;

        if (!1 !== e.margin.autoexpand) {
          for (var v in m) {
            g[v] || delete m[v];
          }

          for (var y in m.base = {
            l: {
              val: 0,
              size: u
            },
            r: {
              val: 1,
              size: f
            },
            t: {
              val: 1,
              size: p
            },
            b: {
              val: 0,
              size: d
            }
          }, m) {
            var b = m[y].l || {},
                _ = m[y].b || {},
                w = b.val,
                T = b.size,
                k = _.val,
                M = _.size;

            for (var A in m) {
              if (a(T) && m[A].r) {
                var S = m[A].r.val,
                    E = m[A].r.size;

                if (S > w) {
                  var C = (T * S + (E - r) * w) / (S - w),
                      P = (E * (1 - w) + (T - r) * (1 - S)) / (S - w);
                  C + P > u + f && (u = C, f = P);
                }
              }

              if (a(M) && m[A].t) {
                var I = m[A].t.val,
                    O = m[A].t.size;

                if (I > k) {
                  var z = (M * I + (O - n) * k) / (I - k),
                      D = (O * (1 - k) + (M - n) * (1 - I)) / (I - k);
                  z + D > d + p && (d = z, p = D);
                }
              }
            }
          }
        }

        var R = c.constrain(r - s.l - s.r, 2, 64),
            F = c.constrain(n - s.t - s.b, 2, 64),
            B = Math.max(0, r - R),
            N = Math.max(0, n - F);

        if (B) {
          var j = (u + f) / B;
          j > 1 && (u /= j, f /= j);
        }

        if (N) {
          var U = (d + p) / N;
          U > 1 && (d /= U, p /= U);
        }

        if (i.l = Math.round(u), i.r = Math.round(f), i.t = Math.round(p), i.b = Math.round(d), i.p = Math.round(s.pad), i.w = Math.round(r) - i.l - i.r, i.h = Math.round(n) - i.t - i.b, !e._replotting && x.didMarginChange(l, i)) {
          "_redrawFromAutoMarginCount" in e ? e._redrawFromAutoMarginCount++ : e._redrawFromAutoMarginCount = 1;
          var V = 3 * (1 + Object.keys(g).length);
          if (e._redrawFromAutoMarginCount < V) return o.call("_doPlot", t);
          e._size = l, c.warn("Too many auto-margin redraws.");
        }

        !function (t) {
          var e = h.list(t, "", !0);
          ["_adjustTickLabelsOverflow", "_hideCounterAxisInsideTickLabels"].forEach(function (t) {
            for (var r = 0; r < e.length; r++) {
              var n = e[r][t];
              n && n();
            }
          });
        }(t);
      };
      var C = ["l", "r", "t", "b", "p", "w", "h"];

      function P(t, e, r) {
        var n = !1;
        var i = [x.previousPromises, function () {
          if (t._transitionData) return t._transitioning = !1, function (t) {
            var e = Promise.resolve();
            if (!t) return e;

            for (; t.length;) {
              e = e.then(t.shift());
            }

            return e;
          }(t._transitionData._interruptCallbacks);
        }, r.prepareFn, x.rehover, function () {
          return t.emit("plotly_transitioning", []), new Promise(function (i) {
            t._transitioning = !0, e.duration > 0 && (t._transitioningWithDuration = !0), t._transitionData._interruptCallbacks.push(function () {
              n = !0;
            }), r.redraw && t._transitionData._interruptCallbacks.push(function () {
              return o.call("redraw", t);
            }), t._transitionData._interruptCallbacks.push(function () {
              t.emit("plotly_transitioninterrupted", []);
            });
            var a = 0,
                s = 0;

            function l() {
              return a++, function () {
                s++, n || s !== a || function (e) {
                  if (!t._transitionData) return;
                  (function (t) {
                    if (t) for (; t.length;) {
                      t.shift();
                    }
                  })(t._transitionData._interruptCallbacks), Promise.resolve().then(function () {
                    if (r.redraw) return o.call("redraw", t);
                  }).then(function () {
                    t._transitioning = !1, t._transitioningWithDuration = !1, t.emit("plotly_transitioned", []);
                  }).then(e);
                }(i);
              };
            }

            r.runFn(l), setTimeout(l());
          });
        }],
            a = c.syncOrAsync(i, t);
        return a && a.then || (a = Promise.resolve()), a.then(function () {
          return t;
        });
      }

      x.didMarginChange = function (t, e) {
        for (var r = 0; r < C.length; r++) {
          var n = C[r],
              i = t[n],
              o = e[n];
          if (!a(i) || Math.abs(o - i) > 1) return !0;
        }

        return !1;
      }, x.graphJson = function (t, e, r, n, i, a) {
        (i && e && !t._fullData || i && !e && !t._fullLayout) && x.supplyDefaults(t);
        var o = i ? t._fullData : t.data,
            s = i ? t._fullLayout : t.layout,
            l = (t._transitionData || {})._frames;

        function u(t, e) {
          if ("function" == typeof t) return e ? "_function_" : null;

          if (c.isPlainObject(t)) {
            var n,
                i = {};
            return Object.keys(t).sort().forEach(function (a) {
              if (-1 === ["_", "["].indexOf(a.charAt(0))) if ("function" != typeof t[a]) {
                if ("keepdata" === r) {
                  if ("src" === a.substr(a.length - 3)) return;
                } else if ("keepstream" === r) {
                  if ("string" == typeof (n = t[a + "src"]) && n.indexOf(":") > 0 && !c.isPlainObject(t.stream)) return;
                } else if ("keepall" !== r && "string" == typeof (n = t[a + "src"]) && n.indexOf(":") > 0) return;

                i[a] = u(t[a], e);
              } else e && (i[a] = "_function");
            }), i;
          }

          return Array.isArray(t) ? t.map(function (t) {
            return u(t, e);
          }) : c.isTypedArray(t) ? c.simpleMap(t, c.identity) : c.isJSDate(t) ? c.ms2DateTimeLocal(+t) : t;
        }

        var f = {
          data: (o || []).map(function (t) {
            var r = u(t);
            return e && delete r.fit, r;
          })
        };

        if (!e && (f.layout = u(s), i)) {
          var h = s._size;
          f.layout.computed = {
            margin: {
              b: h.b,
              l: h.l,
              r: h.r,
              t: h.t
            }
          };
        }

        return l && (f.frames = u(l)), a && (f.config = u(t._context, !0)), "object" === n ? f : JSON.stringify(f);
      }, x.modifyFrames = function (t, e) {
        var r,
            n,
            i,
            a = t._transitionData._frames,
            o = t._transitionData._frameHash;

        for (r = 0; r < e.length; r++) {
          switch ((n = e[r]).type) {
            case "replace":
              i = n.value;
              var s = (a[n.index] || {}).name,
                  l = i.name;
              a[n.index] = o[l] = i, l !== s && (delete o[s], o[l] = i);
              break;

            case "insert":
              o[(i = n.value).name] = i, a.splice(n.index, 0, i);
              break;

            case "delete":
              delete o[(i = a[n.index]).name], a.splice(n.index, 1);
          }
        }

        return Promise.resolve();
      }, x.computeFrame = function (t, e) {
        var r,
            n,
            i,
            a,
            o = t._transitionData._frameHash;
        if (!e) throw new Error("computeFrame must be given a string frame name");
        var s = o[e.toString()];
        if (!s) return !1;

        for (var l = [s], c = [s.name]; s.baseframe && (s = o[s.baseframe.toString()]) && -1 === c.indexOf(s.name);) {
          l.push(s), c.push(s.name);
        }

        for (var u = {}; s = l.pop();) {
          if (s.layout && (u.layout = x.extendLayout(u.layout, s.layout)), s.data) {
            if (u.data || (u.data = []), !(n = s.traces)) for (n = [], r = 0; r < s.data.length; r++) {
              n[r] = r;
            }

            for (u.traces || (u.traces = []), r = 0; r < s.data.length; r++) {
              null != (i = n[r]) && (-1 === (a = u.traces.indexOf(i)) && (a = u.data.length, u.traces[a] = i), u.data[a] = x.extendTrace(u.data[a], s.data[r]));
            }
          }
        }

        return u;
      }, x.recomputeFrameHash = function (t) {
        for (var e = t._transitionData._frameHash = {}, r = t._transitionData._frames, n = 0; n < r.length; n++) {
          var i = r[n];
          i && i.name && (e[i.name] = i);
        }
      }, x.extendObjectWithContainers = function (t, e, r) {
        var n,
            i,
            a,
            o,
            s,
            l,
            u,
            f = c.extendDeepNoArrays({}, e || {}),
            h = c.expandObjectPaths(f),
            p = {};
        if (r && r.length) for (a = 0; a < r.length; a++) {
          void 0 === (i = (n = c.nestedProperty(h, r[a])).get()) ? c.nestedProperty(p, r[a]).set(null) : (n.set(null), c.nestedProperty(p, r[a]).set(i));
        }
        if (t = c.extendDeepNoArrays(t || {}, h), r && r.length) for (a = 0; a < r.length; a++) {
          if (l = c.nestedProperty(p, r[a]).get()) {
            for (u = (s = c.nestedProperty(t, r[a])).get(), Array.isArray(u) || (u = [], s.set(u)), o = 0; o < l.length; o++) {
              var d = l[o];
              u[o] = null === d ? null : x.extendObjectWithContainers(u[o], d);
            }

            s.set(u);
          }
        }
        return t;
      }, x.dataArrayContainers = ["transforms", "dimensions"], x.layoutArrayContainers = o.layoutArrayContainers, x.extendTrace = function (t, e) {
        return x.extendObjectWithContainers(t, e, x.dataArrayContainers);
      }, x.extendLayout = function (t, e) {
        return x.extendObjectWithContainers(t, e, x.layoutArrayContainers);
      }, x.transition = function (t, e, r, n, i, a) {
        var o = {
          redraw: i.redraw
        },
            s = {},
            l = [];
        return o.prepareFn = function () {
          for (var i = Array.isArray(e) ? e.length : 0, a = n.slice(0, i), o = 0; o < a.length; o++) {
            var u = a[o],
                f = t._fullData[u]._module;

            if (f) {
              if (f.animatable) {
                var h = f.basePlotModule.name;
                s[h] || (s[h] = []), s[h].push(u);
              }

              t.data[a[o]] = x.extendTrace(t.data[a[o]], e[o]);
            }
          }

          var p = c.expandObjectPaths(c.extendDeepNoArrays({}, r)),
              d = /^[xy]axis[0-9]*$/;

          for (var m in p) {
            d.test(m) && delete p[m].range;
          }

          x.extendLayout(t.layout, p), delete t.calcdata, x.supplyDefaults(t), x.doCalcdata(t);
          var g = c.expandObjectPaths(r);

          if (g) {
            var v = t._fullLayout._plots;

            for (var y in v) {
              var b = v[y],
                  _ = b.xaxis,
                  w = b.yaxis,
                  T = _.range.slice(),
                  k = w.range.slice(),
                  M = null,
                  A = null,
                  S = null,
                  E = null;

              Array.isArray(g[_._name + ".range"]) ? M = g[_._name + ".range"].slice() : Array.isArray((g[_._name] || {}).range) && (M = g[_._name].range.slice()), Array.isArray(g[w._name + ".range"]) ? A = g[w._name + ".range"].slice() : Array.isArray((g[w._name] || {}).range) && (A = g[w._name].range.slice()), T && M && (_.r2l(T[0]) !== _.r2l(M[0]) || _.r2l(T[1]) !== _.r2l(M[1])) && (S = {
                xr0: T,
                xr1: M
              }), k && A && (w.r2l(k[0]) !== w.r2l(A[0]) || w.r2l(k[1]) !== w.r2l(A[1])) && (E = {
                yr0: k,
                yr1: A
              }), (S || E) && l.push(c.extendFlat({
                plotinfo: b
              }, S, E));
            }
          }

          return Promise.resolve();
        }, o.runFn = function (e) {
          var n,
              i,
              o = t._fullLayout._basePlotModules,
              u = l.length;
          if (r) for (i = 0; i < o.length; i++) {
            o[i].transitionAxes && o[i].transitionAxes(t, l, a, e);
          }

          for (var f in u ? ((n = c.extendFlat({}, a)).duration = 0, delete s.cartesian) : n = a, s) {
            var h = s[f];

            t._fullData[h[0]]._module.basePlotModule.plot(t, h, n, e);
          }
        }, P(t, a, o);
      }, x.transitionFromReact = function (t, e, r, n) {
        var i = t._fullLayout,
            a = i.transition,
            o = {},
            s = [];
        return o.prepareFn = function () {
          var t = i._plots;

          for (var a in o.redraw = !1, "some" === e.anim && (o.redraw = !0), "some" === r.anim && (o.redraw = !0), t) {
            var l = t[a],
                u = l.xaxis,
                f = l.yaxis,
                h = n[u._name].range.slice(),
                p = n[f._name].range.slice(),
                d = u.range.slice(),
                m = f.range.slice();

            u.setScale(), f.setScale();
            var g = null,
                v = null;
            u.r2l(h[0]) === u.r2l(d[0]) && u.r2l(h[1]) === u.r2l(d[1]) || (g = {
              xr0: h,
              xr1: d
            }), f.r2l(p[0]) === f.r2l(m[0]) && f.r2l(p[1]) === f.r2l(m[1]) || (v = {
              yr0: p,
              yr1: m
            }), (g || v) && s.push(c.extendFlat({
              plotinfo: l
            }, g, v));
          }

          return Promise.resolve();
        }, o.runFn = function (r) {
          for (var n, i, o, l = t._fullData, u = t._fullLayout._basePlotModules, f = [], h = 0; h < l.length; h++) {
            f.push(h);
          }

          function p() {
            if (t._fullLayout) for (var e = 0; e < u.length; e++) {
              u[e].transitionAxes && u[e].transitionAxes(t, s, n, r);
            }
          }

          function d() {
            if (t._fullLayout) for (var e = 0; e < u.length; e++) {
              u[e].plot(t, o, i, r);
            }
          }

          s.length && e.anim ? "traces first" === a.ordering ? (n = c.extendFlat({}, a, {
            duration: 0
          }), o = f, i = a, setTimeout(p, a.duration), d()) : (n = a, o = null, i = c.extendFlat({}, a, {
            duration: 0
          }), setTimeout(d, n.duration), p()) : s.length ? (n = a, p()) : e.anim && (o = f, i = a, d());
        }, P(t, a, o);
      }, x.doCalcdata = function (t, e) {
        var r,
            n,
            i,
            a,
            l = h.list(t),
            u = t._fullData,
            p = t._fullLayout,
            d = new Array(u.length),
            m = (t.calcdata || []).slice();

        for (t.calcdata = d, p._numBoxes = 0, p._numViolins = 0, p._violinScaleGroupStats = {}, t._hmpixcount = 0, t._hmlumcount = 0, p._piecolormap = {}, p._sunburstcolormap = {}, p._treemapcolormap = {}, p._funnelareacolormap = {}, i = 0; i < u.length; i++) {
          Array.isArray(e) && -1 === e.indexOf(i) && (d[i] = m[i]);
        }

        for (i = 0; i < u.length; i++) {
          (r = u[i])._arrayAttrs = s.findArrayAttributes(r), r._extremes = {};
        }

        var g = p._subplots.polar || [];

        for (i = 0; i < g.length; i++) {
          l.push(p[g[i]].radialaxis, p[g[i]].angularaxis);
        }

        for (var v in p._colorAxes) {
          var y = p[v];
          !1 !== y.cauto && (delete y.cmin, delete y.cmax);
        }

        var x = !1;

        function _(e) {
          if (r = u[e], n = r._module, !0 === r.visible && r.transforms) {
            if (n && n.calc) {
              var i = n.calc(t, r);
              i[0] && i[0].t && i[0].t._scene && delete i[0].t._scene.dirty;
            }

            for (a = 0; a < r.transforms.length; a++) {
              var o = r.transforms[a];
              (n = b[o.type]) && n.calcTransform && (r._hasCalcTransform = !0, x = !0, n.calcTransform(t, r, o));
            }
          }
        }

        function w(e, i) {
          if (r = u[e], !!(n = r._module).isContainer === i) {
            var o = [];

            if (!0 === r.visible && 0 !== r._length) {
              delete r._indexToPoints;
              var s = r.transforms || [];

              for (a = s.length - 1; a >= 0; a--) {
                if (s[a].enabled) {
                  r._indexToPoints = s[a]._indexToPoints;
                  break;
                }
              }

              n && n.calc && (o = n.calc(t, r));
            }

            Array.isArray(o) && o[0] || (o = [{
              x: f,
              y: f
            }]), o[0].t || (o[0].t = {}), o[0].trace = r, d[e] = o;
          }
        }

        for (O(l, u, p), i = 0; i < u.length; i++) {
          w(i, !0);
        }

        for (i = 0; i < u.length; i++) {
          _(i);
        }

        for (x && O(l, u, p), i = 0; i < u.length; i++) {
          w(i, !0);
        }

        for (i = 0; i < u.length; i++) {
          w(i, !1);
        }

        z(t);

        var T = function (t, e) {
          var r,
              n,
              i,
              a,
              s,
              l = [];

          function u(t, r, n) {
            var i = r._id.charAt(0);

            if ("histogram2dcontour" === t) {
              var a = r._counterAxes[0],
                  o = h.getFromId(e, a),
                  s = "x" === i || "x" === a && "category" === o.type,
                  l = "y" === i || "y" === a && "category" === o.type;
              return function (t, e) {
                return 0 === t || 0 === e || s && t === n[e].length - 1 || l && e === n.length - 1 ? -1 : ("y" === i ? e : t) - 1;
              };
            }

            return function (t, e) {
              return "y" === i ? e : t;
            };
          }

          var f = {
            min: function min(t) {
              return c.aggNums(Math.min, null, t);
            },
            max: function max(t) {
              return c.aggNums(Math.max, null, t);
            },
            sum: function sum(t) {
              return c.aggNums(function (t, e) {
                return t + e;
              }, null, t);
            },
            total: function total(t) {
              return c.aggNums(function (t, e) {
                return t + e;
              }, null, t);
            },
            mean: function mean(t) {
              return c.mean(t);
            },
            median: function median(t) {
              return c.median(t);
            }
          };

          for (r = 0; r < t.length; r++) {
            var p = t[r];

            if ("category" === p.type) {
              var d = p.categoryorder.match(I);

              if (d) {
                var m = d[1],
                    g = d[2],
                    v = p._id.charAt(0),
                    y = "x" === v,
                    x = [];

                for (n = 0; n < p._categories.length; n++) {
                  x.push([p._categories[n], []]);
                }

                for (n = 0; n < p._traceIndices.length; n++) {
                  var b = p._traceIndices[n],
                      _ = e._fullData[b];

                  if (!0 === _.visible) {
                    var w = _.type;
                    o.traceIs(_, "histogram") && (delete _._xautoBinFinished, delete _._yautoBinFinished);
                    var T = "splom" === w,
                        k = "scattergl" === w,
                        M = e.calcdata[b];

                    for (i = 0; i < M.length; i++) {
                      var A,
                          S,
                          E = M[i];

                      if (T) {
                        var L = _._axesDim[p._id];

                        if (!y) {
                          var C = _._diag[L][0];
                          C && (p = e._fullLayout[h.id2name(C)]);
                        }

                        var P = E.trace.dimensions[L].values;

                        for (a = 0; a < P.length; a++) {
                          for (A = p._categoriesMap[P[a]], s = 0; s < E.trace.dimensions.length; s++) {
                            if (s !== L) {
                              var O = E.trace.dimensions[s];
                              x[A][1].push(O.values[a]);
                            }
                          }
                        }
                      } else if (k) {
                        for (a = 0; a < E.t.x.length; a++) {
                          y ? (A = E.t.x[a], S = E.t.y[a]) : (A = E.t.y[a], S = E.t.x[a]), x[A][1].push(S);
                        }

                        E.t && E.t._scene && delete E.t._scene.dirty;
                      } else if (E.hasOwnProperty("z")) {
                        S = E.z;
                        var z = u(_.type, p, S);

                        for (a = 0; a < S.length; a++) {
                          for (s = 0; s < S[a].length; s++) {
                            (A = z(s, a)) + 1 && x[A][1].push(S[a][s]);
                          }
                        }
                      } else for (void 0 === (A = E.p) && (A = E[v]), void 0 === (S = E.s) && (S = E.v), void 0 === S && (S = y ? E.y : E.x), Array.isArray(S) || (S = void 0 === S ? [] : [S]), a = 0; a < S.length; a++) {
                        x[A][1].push(S[a]);
                      }
                    }
                  }
                }

                p._categoriesValue = x;
                var D = [];

                for (n = 0; n < x.length; n++) {
                  D.push([x[n][0], f[m](x[n][1])]);
                }

                D.sort(function (t, e) {
                  return t[1] - e[1];
                }), p._categoriesAggregatedValue = D, p._initialCategories = D.map(function (t) {
                  return t[0];
                }), "descending" === g && p._initialCategories.reverse(), l = l.concat(p.sortByInitialCategories());
              }
            }
          }

          return l;
        }(l, t);

        if (T.length) {
          for (p._numBoxes = 0, p._numViolins = 0, i = 0; i < T.length; i++) {
            w(T[i], !0);
          }

          for (i = 0; i < T.length; i++) {
            w(T[i], !1);
          }

          z(t);
        }

        o.getComponentMethod("fx", "calc")(t), o.getComponentMethod("errorbars", "calc")(t);
      };
      var I = /(total|sum|min|max|mean|median) (ascending|descending)/;

      function O(t, e, r) {
        var n = {};

        function i(t) {
          t.clearCalc(), "multicategory" === t.type && t.setupMultiCategory(e), n[t._id] = 1;
        }

        c.simpleMap(t, i);

        for (var a = r._axisMatchGroups || [], o = 0; o < a.length; o++) {
          for (var s in a[o]) {
            n[s] || i(r[h.id2name(s)]);
          }
        }
      }

      function z(t) {
        var e,
            r,
            n,
            i = t._fullLayout,
            a = i._visibleModules,
            o = {};

        for (r = 0; r < a.length; r++) {
          var s = a[r],
              l = s.crossTraceCalc;

          if (l) {
            var u = s.basePlotModule.name;
            o[u] ? c.pushUnique(o[u], l) : o[u] = [l];
          }
        }

        for (n in o) {
          var f = o[n],
              h = i._subplots[n];
          if (Array.isArray(h)) for (e = 0; e < h.length; e++) {
            var p = h[e],
                d = "cartesian" === n ? i._plots[p] : i[p];

            for (r = 0; r < f.length; r++) {
              f[r](t, d, p);
            }
          } else for (r = 0; r < f.length; r++) {
            f[r](t);
          }
        }
      }

      x.rehover = function (t) {
        t._fullLayout._rehover && t._fullLayout._rehover();
      }, x.redrag = function (t) {
        t._fullLayout._redrag && t._fullLayout._redrag();
      }, x.generalUpdatePerTraceModule = function (t, e, r, n) {
        var i,
            a = e.traceHash,
            o = {};

        for (i = 0; i < r.length; i++) {
          var s = r[i],
              l = s[0].trace;
          l.visible && (o[l.type] = o[l.type] || [], o[l.type].push(s));
        }

        for (var u in a) {
          if (!o[u]) {
            var f = a[u][0];
            f[0].trace.visible = !1, o[u] = [f];
          }
        }

        for (var h in o) {
          var p = o[h];

          p[0][0].trace._module.plot(t, e, c.filterVisible(p), n);
        }

        e.traceHash = o;
      }, x.plotBasePlot = function (t, e, r, n, i) {
        var a = o.getModule(t),
            s = g(e.calcdata, a)[0];
        a.plot(e, s, n, i);
      }, x.cleanBasePlot = function (t, e, r, n, i) {
        var a = i._has && i._has(t),
            o = r._has && r._has(t);

        a && !o && i["_" + t + "layer"].selectAll("g.trace").remove();
      };
    }, {
      "../components/color": 658,
      "../constants/numerical": 771,
      "../lib": 795,
      "../plot_api/plot_schema": 833,
      "../plot_api/plot_template": 834,
      "../plots/get_data": 882,
      "../registry": 923,
      "./animation_attributes": 839,
      "./attributes": 841,
      "./cartesian/axis_ids": 848,
      "./cartesian/handle_outline": 855,
      "./command": 871,
      "./font_attributes": 873,
      "./frame_attributes": 874,
      "./layout_attributes": 900,
      "@plotly/d3": 57,
      "d3-time-format": 167,
      "fast-isnumeric": 240
    }],
    910: [function (t, e, r) {
      "use strict";

      e.exports = {
        attr: "subplot",
        name: "polar",
        axisNames: ["angularaxis", "radialaxis"],
        axisName2dataArray: {
          angularaxis: "theta",
          radialaxis: "r"
        },
        layerNames: ["draglayer", "plotbg", "backplot", "angular-grid", "radial-grid", "frontplot", "angular-line", "radial-line", "angular-axis", "radial-axis"],
        radialDragBoxSize: 50,
        angularDragBoxSize: 30,
        cornerLen: 25,
        cornerHalfWidth: 2,
        MINDRAG: 8,
        MINZOOM: 20,
        OFFEDGE: 20
      };
    }, {}],
    911: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../lib/polygon").tester,
          a = n.findIndexOfMin,
          o = n.isAngleInsideSector,
          s = n.angleDelta,
          l = n.angleDist;

      function c(t, e, r, n) {
        var i,
            a,
            o = n[0],
            s = n[1],
            l = f(Math.sin(e) - Math.sin(t)),
            c = f(Math.cos(e) - Math.cos(t)),
            u = Math.tan(r),
            h = f(1 / u),
            p = l / c,
            d = s - p * o;
        return h ? l && c ? a = u * (i = d / (u - p)) : c ? (i = s * h, a = s) : (i = o, a = o * u) : l && c ? (i = 0, a = d) : c ? (i = 0, a = s) : i = a = NaN, [i, a];
      }

      function u(t, e, r, i) {
        return n.isFullCircle([e, r]) ? function (t, e) {
          var r,
              n = e.length,
              i = new Array(n + 1);

          for (r = 0; r < n; r++) {
            var a = e[r];
            i[r] = [t * Math.cos(a), t * Math.sin(a)];
          }

          return i[r] = i[0].slice(), i;
        }(t, i) : function (t, e, r, i) {
          var s,
              u,
              f = i.length,
              h = [];

          function p(e) {
            return [t * Math.cos(e), t * Math.sin(e)];
          }

          function d(t, e, r) {
            return c(t, e, r, p(t));
          }

          function m(t) {
            return n.mod(t, f);
          }

          function g(t) {
            return o(t, [e, r]);
          }

          var v = a(i, function (t) {
            return g(t) ? l(t, e) : 1 / 0;
          }),
              y = d(i[v], i[m(v - 1)], e);

          for (h.push(y), s = v, u = 0; u < f; s++, u++) {
            var x = i[m(s)];
            if (!g(x)) break;
            h.push(p(x));
          }

          var b = a(i, function (t) {
            return g(t) ? l(t, r) : 1 / 0;
          }),
              _ = d(i[b], i[m(b + 1)], r);

          return h.push(_), h.push([0, 0]), h.push(h[0].slice()), h;
        }(t, e, r, i);
      }

      function f(t) {
        return Math.abs(t) > 1e-10 ? t : 0;
      }

      function h(t, e, r) {
        e = e || 0, r = r || 0;

        for (var n = t.length, i = new Array(n), a = 0; a < n; a++) {
          var o = t[a];
          i[a] = [e + o[0], r - o[1]];
        }

        return i;
      }

      e.exports = {
        isPtInsidePolygon: function isPtInsidePolygon(t, e, r, n, a) {
          if (!o(e, n)) return !1;
          var s, l;
          r[0] < r[1] ? (s = r[0], l = r[1]) : (s = r[1], l = r[0]);
          var c = i(u(s, n[0], n[1], a)),
              f = i(u(l, n[0], n[1], a)),
              h = [t * Math.cos(e), t * Math.sin(e)];
          return f.contains(h) && !c.contains(h);
        },
        findPolygonOffset: function findPolygonOffset(t, e, r, n) {
          for (var i = 1 / 0, a = 1 / 0, o = u(t, e, r, n), s = 0; s < o.length; s++) {
            var l = o[s];
            i = Math.min(i, l[0]), a = Math.min(a, -l[1]);
          }

          return [i, a];
        },
        findEnclosingVertexAngles: function findEnclosingVertexAngles(t, e) {
          var r = a(e, function (e) {
            var r = s(e, t);
            return r > 0 ? r : 1 / 0;
          }),
              i = n.mod(r + 1, e.length);
          return [e[r], e[i]];
        },
        findIntersectionXY: c,
        findXYatLength: function findXYatLength(t, e, r, n) {
          var i = -e * r,
              a = e * e + 1,
              o = 2 * (e * i - r),
              s = i * i + r * r - t * t,
              l = Math.sqrt(o * o - 4 * a * s),
              c = (-o + l) / (2 * a),
              u = (-o - l) / (2 * a);
          return [[c, e * c + i + n], [u, e * u + i + n]];
        },
        clampTiny: f,
        pathPolygon: function pathPolygon(t, e, r, n, i, a) {
          return "M" + h(u(t, e, r, n), i, a).join("L");
        },
        pathPolygonAnnulus: function pathPolygonAnnulus(t, e, r, n, i, a, o) {
          var s, l;
          t < e ? (s = t, l = e) : (s = e, l = t);
          var c = h(u(s, r, n, i), a, o);
          return "M" + h(u(l, r, n, i), a, o).reverse().join("L") + "M" + c.join("L");
        }
      };
    }, {
      "../../lib": 795,
      "../../lib/polygon": 807
    }],
    912: [function (t, e, r) {
      "use strict";

      var n = t("../get_data").getSubplotCalcData,
          i = t("../../lib").counterRegex,
          a = t("./polar"),
          o = t("./constants"),
          s = o.attr,
          l = o.name,
          c = i(l),
          u = {};
      u[s] = {
        valType: "subplotid",
        dflt: l,
        editType: "calc"
      }, e.exports = {
        attr: s,
        name: l,
        idRoot: l,
        idRegex: c,
        attrRegex: c,
        attributes: u,
        layoutAttributes: t("./layout_attributes"),
        supplyLayoutDefaults: t("./layout_defaults"),
        plot: function plot(t) {
          for (var e = t._fullLayout, r = t.calcdata, i = e._subplots[l], o = 0; o < i.length; o++) {
            var s = i[o],
                c = n(r, l, s),
                u = e[s]._subplot;
            u || (u = a(t, s), e[s]._subplot = u), u.plot(c, e, t._promises);
          }
        },
        clean: function clean(t, e, r, n) {
          for (var i = n._subplots[l] || [], a = n._has && n._has("gl"), o = e._has && e._has("gl"), s = a && !o, c = 0; c < i.length; c++) {
            var u = i[c],
                f = n[u]._subplot;
            if (!e[u] && f) for (var h in f.framework.remove(), f.layers["radial-axis-title"].remove(), f.clipPaths) {
              f.clipPaths[h].remove();
            }
            s && f._scene && (f._scene.destroy(), f._scene = null);
          }
        },
        toSVG: t("../cartesian").toSVG
      };
    }, {
      "../../lib": 795,
      "../cartesian": 858,
      "../get_data": 882,
      "./constants": 910,
      "./layout_attributes": 913,
      "./layout_defaults": 914,
      "./polar": 915
    }],
    913: [function (t, e, r) {
      "use strict";

      var n = t("../../components/color/attributes"),
          i = t("../cartesian/layout_attributes"),
          a = t("../domain").attributes,
          o = t("../../lib").extendFlat,
          s = t("../../plot_api/edit_types").overrideAll,
          l = s({
        color: i.color,
        showline: o({}, i.showline, {
          dflt: !0
        }),
        linecolor: i.linecolor,
        linewidth: i.linewidth,
        showgrid: o({}, i.showgrid, {
          dflt: !0
        }),
        gridcolor: i.gridcolor,
        gridwidth: i.gridwidth
      }, "plot", "from-root"),
          c = s({
        tickmode: i.tickmode,
        nticks: i.nticks,
        tick0: i.tick0,
        dtick: i.dtick,
        tickvals: i.tickvals,
        ticktext: i.ticktext,
        ticks: i.ticks,
        ticklen: i.ticklen,
        tickwidth: i.tickwidth,
        tickcolor: i.tickcolor,
        showticklabels: i.showticklabels,
        showtickprefix: i.showtickprefix,
        tickprefix: i.tickprefix,
        showticksuffix: i.showticksuffix,
        ticksuffix: i.ticksuffix,
        showexponent: i.showexponent,
        exponentformat: i.exponentformat,
        minexponent: i.minexponent,
        separatethousands: i.separatethousands,
        tickfont: i.tickfont,
        tickangle: i.tickangle,
        tickformat: i.tickformat,
        tickformatstops: i.tickformatstops,
        layer: i.layer
      }, "plot", "from-root"),
          u = {
        visible: o({}, i.visible, {
          dflt: !0
        }),
        type: o({}, i.type, {
          values: ["-", "linear", "log", "date", "category"]
        }),
        autotypenumbers: i.autotypenumbers,
        autorange: o({}, i.autorange, {
          editType: "plot"
        }),
        rangemode: {
          valType: "enumerated",
          values: ["tozero", "nonnegative", "normal"],
          dflt: "tozero",
          editType: "calc"
        },
        range: o({}, i.range, {
          items: [{
            valType: "any",
            editType: "plot",
            impliedEdits: {
              "^autorange": !1
            }
          }, {
            valType: "any",
            editType: "plot",
            impliedEdits: {
              "^autorange": !1
            }
          }],
          editType: "plot"
        }),
        categoryorder: i.categoryorder,
        categoryarray: i.categoryarray,
        angle: {
          valType: "angle",
          editType: "plot"
        },
        side: {
          valType: "enumerated",
          values: ["clockwise", "counterclockwise"],
          dflt: "clockwise",
          editType: "plot"
        },
        title: {
          text: o({}, i.title.text, {
            editType: "plot",
            dflt: ""
          }),
          font: o({}, i.title.font, {
            editType: "plot"
          }),
          editType: "plot"
        },
        hoverformat: i.hoverformat,
        uirevision: {
          valType: "any",
          editType: "none"
        },
        editType: "calc",
        _deprecated: {
          title: i._deprecated.title,
          titlefont: i._deprecated.titlefont
        }
      };
      o(u, l, c);
      var f = {
        visible: o({}, i.visible, {
          dflt: !0
        }),
        type: {
          valType: "enumerated",
          values: ["-", "linear", "category"],
          dflt: "-",
          editType: "calc",
          _noTemplating: !0
        },
        autotypenumbers: i.autotypenumbers,
        categoryorder: i.categoryorder,
        categoryarray: i.categoryarray,
        thetaunit: {
          valType: "enumerated",
          values: ["radians", "degrees"],
          dflt: "degrees",
          editType: "calc"
        },
        period: {
          valType: "number",
          editType: "calc",
          min: 0
        },
        direction: {
          valType: "enumerated",
          values: ["counterclockwise", "clockwise"],
          dflt: "counterclockwise",
          editType: "calc"
        },
        rotation: {
          valType: "angle",
          editType: "calc"
        },
        hoverformat: i.hoverformat,
        uirevision: {
          valType: "any",
          editType: "none"
        },
        editType: "calc"
      };
      o(f, l, c), e.exports = {
        domain: a({
          name: "polar",
          editType: "plot"
        }),
        sector: {
          valType: "info_array",
          items: [{
            valType: "number",
            editType: "plot"
          }, {
            valType: "number",
            editType: "plot"
          }],
          dflt: [0, 360],
          editType: "plot"
        },
        hole: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 0,
          editType: "plot"
        },
        bgcolor: {
          valType: "color",
          editType: "plot",
          dflt: n.background
        },
        radialaxis: u,
        angularaxis: f,
        gridshape: {
          valType: "enumerated",
          values: ["circular", "linear"],
          dflt: "circular",
          editType: "plot"
        },
        uirevision: {
          valType: "any",
          editType: "none"
        },
        editType: "calc"
      };
    }, {
      "../../components/color/attributes": 657,
      "../../lib": 795,
      "../../plot_api/edit_types": 827,
      "../cartesian/layout_attributes": 859,
      "../domain": 872
    }],
    914: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../components/color"),
          a = t("../../plot_api/plot_template"),
          o = t("../subplot_defaults"),
          s = t("../get_data").getSubplotData,
          l = t("../cartesian/tick_value_defaults"),
          c = t("../cartesian/tick_mark_defaults"),
          u = t("../cartesian/tick_label_defaults"),
          f = t("../cartesian/category_order_defaults"),
          h = t("../cartesian/line_grid_defaults"),
          p = t("../cartesian/axis_autotype"),
          d = t("./layout_attributes"),
          m = t("./set_convert"),
          g = t("./constants"),
          v = g.axisNames;

      function y(t, e, r, o) {
        var p = r("bgcolor");
        o.bgColor = i.combine(p, o.paper_bgcolor);
        var y = r("sector");
        r("hole");

        var b,
            _ = s(o.fullData, g.name, o.id),
            w = o.layoutOut;

        function T(t, e) {
          return r(b + "." + t, e);
        }

        for (var k = 0; k < v.length; k++) {
          b = v[k], n.isPlainObject(t[b]) || (t[b] = {});
          var M = t[b],
              A = a.newContainer(e, b);
          A._id = A._name = b, A._attr = o.id + "." + b, A._traceIndices = _.map(function (t) {
            return t._expandedIndex;
          });
          var S = g.axisName2dataArray[b],
              E = x(M, A, T, _, S, o);
          f(M, A, T, {
            axData: _,
            dataAttr: S
          });
          var L,
              C,
              P = T("visible");

          switch (m(A, e, w), T("uirevision", e.uirevision), P && (C = (L = T("color")) === M.color ? L : o.font.color), A._m = 1, b) {
            case "radialaxis":
              var I = T("autorange", !A.isValidRange(M.range));
              M.autorange = I, !I || "linear" !== E && "-" !== E || T("rangemode"), "reversed" === I && (A._m = -1), T("range"), A.cleanRange("range", {
                dfltRange: [0, 1]
              }), P && (T("side"), T("angle", y[0]), T("title.text"), n.coerceFont(T, "title.font", {
                family: o.font.family,
                size: n.bigFont(o.font.size),
                color: C
              }));
              break;

            case "angularaxis":
              if ("date" === E) {
                n.log("Polar plots do not support date angular axes yet.");

                for (var O = 0; O < _.length; O++) {
                  _[O].visible = !1;
                }

                E = M.type = A.type = "linear";
              }

              T("linear" === E ? "thetaunit" : "period");
              var z = T("direction");
              T("rotation", {
                counterclockwise: 0,
                clockwise: 90
              }[z]);
          }

          if (P) l(M, A, T, A.type), u(M, A, T, A.type, {
            tickSuffixDflt: "degrees" === A.thetaunit ? "\xb0" : void 0
          }), c(M, A, T, {
            outerTicks: !0
          }), T("showticklabels") && (n.coerceFont(T, "tickfont", {
            family: o.font.family,
            size: o.font.size,
            color: C
          }), T("tickangle"), T("tickformat")), h(M, A, T, {
            dfltColor: L,
            bgColor: o.bgColor,
            blend: 60,
            showLine: !0,
            showGrid: !0,
            noZeroLine: !0,
            attributes: d[b]
          }), T("layer");
          "category" !== E && T("hoverformat"), A._input = M;
        }

        "category" === e.angularaxis.type && r("gridshape");
      }

      function x(t, e, r, n, i, a) {
        var o = r("autotypenumbers", a.autotypenumbersDflt);

        if ("-" === r("type")) {
          for (var s, l = 0; l < n.length; l++) {
            if (n[l].visible) {
              s = n[l];
              break;
            }
          }

          s && s[i] && (e.type = p(s[i], "gregorian", {
            noMultiCategory: !0,
            autotypenumbers: o
          })), "-" === e.type ? e.type = "linear" : t.type = e.type;
        }

        return e.type;
      }

      e.exports = function (t, e, r) {
        o(t, e, r, {
          type: g.name,
          attributes: d,
          handleDefaults: y,
          font: e.font,
          autotypenumbersDflt: e.autotypenumbers,
          paper_bgcolor: e.paper_bgcolor,
          fullData: r,
          layoutOut: e
        });
      };
    }, {
      "../../components/color": 658,
      "../../lib": 795,
      "../../plot_api/plot_template": 834,
      "../cartesian/axis_autotype": 846,
      "../cartesian/category_order_defaults": 849,
      "../cartesian/line_grid_defaults": 861,
      "../cartesian/tick_label_defaults": 866,
      "../cartesian/tick_mark_defaults": 867,
      "../cartesian/tick_value_defaults": 868,
      "../get_data": 882,
      "../subplot_defaults": 917,
      "./constants": 910,
      "./layout_attributes": 913,
      "./set_convert": 916
    }],
    915: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("tinycolor2"),
          a = t("../../registry"),
          o = t("../../lib"),
          s = o.strRotate,
          l = o.strTranslate,
          c = t("../../components/color"),
          u = t("../../components/drawing"),
          f = t("../plots"),
          h = t("../../plots/cartesian/axes"),
          p = t("../cartesian/set_convert"),
          d = t("./set_convert"),
          m = t("../cartesian/autorange").doAutoRange,
          g = t("../cartesian/dragbox"),
          v = t("../../components/dragelement"),
          y = t("../../components/fx"),
          x = t("../../components/titles"),
          b = t("../cartesian/select").prepSelect,
          _ = t("../cartesian/select").selectOnClick,
          w = t("../cartesian/select").clearSelect,
          T = t("../../lib/setcursor"),
          k = t("../../lib/clear_gl_canvases"),
          M = t("../../plot_api/subroutines").redrawReglTraces,
          A = t("../../constants/alignment").MID_SHIFT,
          S = t("./constants"),
          E = t("./helpers"),
          L = o._,
          C = o.mod,
          P = o.deg2rad,
          I = o.rad2deg;

      function O(t, e) {
        this.id = e, this.gd = t, this._hasClipOnAxisFalse = null, this.vangles = null, this.radialAxisAngle = null, this.traceHash = {}, this.layers = {}, this.clipPaths = {}, this.clipIds = {}, this.viewInitial = {};
        var r = t._fullLayout,
            n = "clip" + r._uid + e;
        this.clipIds.forTraces = n + "-for-traces", this.clipPaths.forTraces = r._clips.append("clipPath").attr("id", this.clipIds.forTraces), this.clipPaths.forTraces.append("path"), this.framework = r._polarlayer.append("g").attr("class", e), this.radialTickLayout = null, this.angularTickLayout = null;
      }

      var z = O.prototype;

      function D(t) {
        var e = t.ticks + String(t.ticklen) + String(t.showticklabels);
        return "side" in t && (e += t.side), e;
      }

      function R(t, e) {
        return e[o.findIndexOfMin(e, function (e) {
          return o.angleDist(t, e);
        })];
      }

      function F(t, e, r) {
        return e ? (t.attr("display", null), t.attr(r)) : t && t.attr("display", "none"), t;
      }

      e.exports = function (t, e) {
        return new O(t, e);
      }, z.plot = function (t, e) {
        var r = e[this.id];
        this._hasClipOnAxisFalse = !1;

        for (var n = 0; n < t.length; n++) {
          if (!1 === t[n][0].trace.cliponaxis) {
            this._hasClipOnAxisFalse = !0;
            break;
          }
        }

        this.updateLayers(e, r), this.updateLayout(e, r), f.generalUpdatePerTraceModule(this.gd, this, t, r), this.updateFx(e, r);
      }, z.updateLayers = function (t, e) {
        var r = this.layers,
            i = e.radialaxis,
            a = e.angularaxis,
            o = S.layerNames,
            s = o.indexOf("frontplot"),
            l = o.slice(0, s),
            c = "below traces" === a.layer,
            u = "below traces" === i.layer;
        c && l.push("angular-line"), u && l.push("radial-line"), c && l.push("angular-axis"), u && l.push("radial-axis"), l.push("frontplot"), c || l.push("angular-line"), u || l.push("radial-line"), c || l.push("angular-axis"), u || l.push("radial-axis");
        var f = this.framework.selectAll(".polarsublayer").data(l, String);
        f.enter().append("g").attr("class", function (t) {
          return "polarsublayer " + t;
        }).each(function (t) {
          var e = r[t] = n.select(this);

          switch (t) {
            case "frontplot":
              e.append("g").classed("barlayer", !0), e.append("g").classed("scatterlayer", !0);
              break;

            case "backplot":
              e.append("g").classed("maplayer", !0);
              break;

            case "plotbg":
              r.bg = e.append("path");
              break;

            case "radial-grid":
            case "angular-grid":
              e.style("fill", "none");
              break;

            case "radial-line":
              e.append("line").style("fill", "none");
              break;

            case "angular-line":
              e.append("path").style("fill", "none");
          }
        }), f.order();
      }, z.updateLayout = function (t, e) {
        var r = this.layers,
            n = t._size,
            i = e.radialaxis,
            a = e.angularaxis,
            o = e.domain.x,
            s = e.domain.y;
        this.xOffset = n.l + n.w * o[0], this.yOffset = n.t + n.h * (1 - s[1]);
        var f = this.xLength = n.w * (o[1] - o[0]),
            h = this.yLength = n.h * (s[1] - s[0]),
            p = e.sector;
        this.sectorInRad = p.map(P);

        var d,
            m,
            g,
            v,
            y,
            x = this.sectorBBox = function (t) {
          var e,
              r,
              n,
              i,
              a = t[0],
              o = t[1] - a,
              s = C(a, 360),
              l = s + o,
              c = Math.cos(P(s)),
              u = Math.sin(P(s)),
              f = Math.cos(P(l)),
              h = Math.sin(P(l));
          i = s <= 90 && l >= 90 || s > 90 && l >= 450 ? 1 : u <= 0 && h <= 0 ? 0 : Math.max(u, h);
          e = s <= 180 && l >= 180 || s > 180 && l >= 540 ? -1 : c >= 0 && f >= 0 ? 0 : Math.min(c, f);
          r = s <= 270 && l >= 270 || s > 270 && l >= 630 ? -1 : u >= 0 && h >= 0 ? 0 : Math.min(u, h);
          n = l >= 360 ? 1 : c <= 0 && f <= 0 ? 0 : Math.max(c, f);
          return [e, r, n, i];
        }(p),
            b = x[2] - x[0],
            _ = x[3] - x[1],
            w = h / f,
            T = Math.abs(_ / b);

        w > T ? (d = f, y = (h - (m = f * T)) / n.h / 2, g = [o[0], o[1]], v = [s[0] + y, s[1] - y]) : (m = h, y = (f - (d = h / T)) / n.w / 2, g = [o[0] + y, o[1] - y], v = [s[0], s[1]]), this.xLength2 = d, this.yLength2 = m, this.xDomain2 = g, this.yDomain2 = v;
        var k = this.xOffset2 = n.l + n.w * g[0],
            M = this.yOffset2 = n.t + n.h * (1 - v[1]),
            A = this.radius = d / b,
            S = this.innerRadius = e.hole * A,
            E = this.cx = k - A * x[0],
            L = this.cy = M + A * x[3],
            I = this.cxx = E - k,
            O = this.cyy = L - M;
        this.radialAxis = this.mockAxis(t, e, i, {
          _id: "x",
          side: {
            counterclockwise: "top",
            clockwise: "bottom"
          }[i.side],
          _realSide: i.side,
          domain: [S / n.w, A / n.w]
        }), this.angularAxis = this.mockAxis(t, e, a, {
          side: "right",
          domain: [0, Math.PI],
          autorange: !1
        }), this.doAutoRange(t, e), this.updateAngularAxis(t, e), this.updateRadialAxis(t, e), this.updateRadialAxisTitle(t, e), this.xaxis = this.mockCartesianAxis(t, e, {
          _id: "x",
          domain: g
        }), this.yaxis = this.mockCartesianAxis(t, e, {
          _id: "y",
          domain: v
        });
        var z = this.pathSubplot();
        this.clipPaths.forTraces.select("path").attr("d", z).attr("transform", l(I, O)), r.frontplot.attr("transform", l(k, M)).call(u.setClipUrl, this._hasClipOnAxisFalse ? null : this.clipIds.forTraces, this.gd), r.bg.attr("d", z).attr("transform", l(E, L)).call(c.fill, e.bgcolor);
      }, z.mockAxis = function (t, e, r, n) {
        var i = o.extendFlat({}, r, n);
        return d(i, e, t), i;
      }, z.mockCartesianAxis = function (t, e, r) {
        var n = this,
            i = r._id,
            a = o.extendFlat({
          type: "linear"
        }, r);
        p(a, t);
        var s = {
          x: [0, 2],
          y: [1, 3]
        };
        return a.setRange = function () {
          var t = n.sectorBBox,
              r = s[i],
              o = n.radialAxis._rl,
              l = (o[1] - o[0]) / (1 - e.hole);
          a.range = [t[r[0]] * l, t[r[1]] * l];
        }, a.isPtWithinRange = "x" === i ? function (t) {
          return n.isPtInside(t);
        } : function () {
          return !0;
        }, a.setRange(), a.setScale(), a;
      }, z.doAutoRange = function (t, e) {
        var r = this.gd,
            n = this.radialAxis,
            i = e.radialaxis;
        n.setScale(), m(r, n);
        var a = n.range;
        i.range = a.slice(), i._input.range = a.slice(), n._rl = [n.r2l(a[0], null, "gregorian"), n.r2l(a[1], null, "gregorian")];
      }, z.updateRadialAxis = function (t, e) {
        var r = this,
            n = r.gd,
            i = r.layers,
            a = r.radius,
            u = r.innerRadius,
            f = r.cx,
            p = r.cy,
            d = e.radialaxis,
            m = C(e.sector[0], 360),
            g = r.radialAxis,
            v = u < a;
        r.fillViewInitialKey("radialaxis.angle", d.angle), r.fillViewInitialKey("radialaxis.range", g.range.slice()), g.setGeometry(), "auto" === g.tickangle && m > 90 && m <= 270 && (g.tickangle = 180);

        var y = function y(t) {
          return l(g.l2p(t.x) + u, 0);
        },
            x = D(d);

        if (r.radialTickLayout !== x && (i["radial-axis"].selectAll(".xtick").remove(), r.radialTickLayout = x), v) {
          g.setScale();

          var b = h.calcTicks(g),
              _ = h.clipEnds(g, b),
              w = h.getTickSigns(g)[2];

          h.drawTicks(n, g, {
            vals: b,
            layer: i["radial-axis"],
            path: h.makeTickPath(g, 0, w),
            transFn: y,
            crisp: !1
          }), h.drawGrid(n, g, {
            vals: _,
            layer: i["radial-grid"],
            path: function path(t) {
              return r.pathArc(g.r2p(t.x) + u);
            },
            transFn: o.noop,
            crisp: !1
          }), h.drawLabels(n, g, {
            vals: b,
            layer: i["radial-axis"],
            transFn: y,
            labelFns: h.makeLabelFns(g, 0)
          });
        }

        var T = r.radialAxisAngle = r.vangles ? I(R(P(d.angle), r.vangles)) : d.angle,
            k = l(f, p),
            M = k + s(-T);
        F(i["radial-axis"], v && (d.showticklabels || d.ticks), {
          transform: M
        }), F(i["radial-grid"], v && d.showgrid, {
          transform: k
        }), F(i["radial-line"].select("line"), v && d.showline, {
          x1: u,
          y1: 0,
          x2: a,
          y2: 0,
          transform: M
        }).attr("stroke-width", d.linewidth).call(c.stroke, d.linecolor);
      }, z.updateRadialAxisTitle = function (t, e, r) {
        var n = this.gd,
            i = this.radius,
            a = this.cx,
            o = this.cy,
            s = e.radialaxis,
            l = this.id + "title",
            c = void 0 !== r ? r : this.radialAxisAngle,
            f = P(c),
            h = Math.cos(f),
            p = Math.sin(f),
            d = 0;

        if (s.title) {
          var m = u.bBox(this.layers["radial-axis"].node()).height,
              g = s.title.font.size;
          d = "counterclockwise" === s.side ? -m - .4 * g : m + .8 * g;
        }

        this.layers["radial-axis-title"] = x.draw(n, l, {
          propContainer: s,
          propName: this.id + ".radialaxis.title",
          placeholder: L(n, "Click to enter radial axis title"),
          attributes: {
            x: a + i / 2 * h + d * p,
            y: o - i / 2 * p + d * h,
            "text-anchor": "middle"
          },
          transform: {
            rotate: -c
          }
        });
      }, z.updateAngularAxis = function (t, e) {
        var r = this,
            n = r.gd,
            i = r.layers,
            a = r.radius,
            u = r.innerRadius,
            f = r.cx,
            p = r.cy,
            d = e.angularaxis,
            m = r.angularAxis;
        r.fillViewInitialKey("angularaxis.rotation", d.rotation), m.setGeometry(), m.setScale();

        var g = function g(t) {
          return m.t2g(t.x);
        };

        "linear" === m.type && "radians" === m.thetaunit && (m.tick0 = I(m.tick0), m.dtick = I(m.dtick));

        var v = function v(t) {
          return l(f + a * Math.cos(t), p - a * Math.sin(t));
        },
            y = h.makeLabelFns(m, 0).labelStandoff,
            x = {
          xFn: function xFn(t) {
            var e = g(t);
            return Math.cos(e) * y;
          },
          yFn: function yFn(t) {
            var e = g(t),
                r = Math.sin(e) > 0 ? .2 : 1;
            return -Math.sin(e) * (y + t.fontSize * r) + Math.abs(Math.cos(e)) * (t.fontSize * A);
          },
          anchorFn: function anchorFn(t) {
            var e = g(t),
                r = Math.cos(e);
            return Math.abs(r) < .1 ? "middle" : r > 0 ? "start" : "end";
          },
          heightFn: function heightFn(t, e, r) {
            var n = g(t);
            return -.5 * (1 + Math.sin(n)) * r;
          }
        },
            b = D(d);

        r.angularTickLayout !== b && (i["angular-axis"].selectAll("." + m._id + "tick").remove(), r.angularTickLayout = b);

        var _,
            w = h.calcTicks(m);

        if ("linear" === e.gridshape ? (_ = w.map(g), o.angleDelta(_[0], _[1]) < 0 && (_ = _.slice().reverse())) : _ = null, r.vangles = _, "category" === m.type && (w = w.filter(function (t) {
          return o.isAngleInsideSector(g(t), r.sectorInRad);
        })), m.visible) {
          var T = "inside" === m.ticks ? -1 : 1,
              k = (m.linewidth || 1) / 2;
          h.drawTicks(n, m, {
            vals: w,
            layer: i["angular-axis"],
            path: "M" + T * k + ",0h" + T * m.ticklen,
            transFn: function transFn(t) {
              var e = g(t);
              return v(e) + s(-I(e));
            },
            crisp: !1
          }), h.drawGrid(n, m, {
            vals: w,
            layer: i["angular-grid"],
            path: function path(t) {
              var e = g(t),
                  r = Math.cos(e),
                  n = Math.sin(e);
              return "M" + [f + u * r, p - u * n] + "L" + [f + a * r, p - a * n];
            },
            transFn: o.noop,
            crisp: !1
          }), h.drawLabels(n, m, {
            vals: w,
            layer: i["angular-axis"],
            repositionOnUpdate: !0,
            transFn: function transFn(t) {
              return v(g(t));
            },
            labelFns: x
          });
        }

        F(i["angular-line"].select("path"), d.showline, {
          d: r.pathSubplot(),
          transform: l(f, p)
        }).attr("stroke-width", d.linewidth).call(c.stroke, d.linecolor);
      }, z.updateFx = function (t, e) {
        this.gd._context.staticPlot || (this.updateAngularDrag(t), this.updateRadialDrag(t, e, 0), this.updateRadialDrag(t, e, 1), this.updateMainDrag(t));
      }, z.updateMainDrag = function (t) {
        var e,
            r,
            s = this,
            c = s.gd,
            u = s.layers,
            f = t._zoomlayer,
            h = S.MINZOOM,
            p = S.OFFEDGE,
            d = s.radius,
            m = s.innerRadius,
            x = s.cx,
            T = s.cy,
            k = s.cxx,
            M = s.cyy,
            A = s.sectorInRad,
            L = s.vangles,
            C = s.radialAxis,
            P = E.clampTiny,
            I = E.findXYatLength,
            O = E.findEnclosingVertexAngles,
            z = S.cornerHalfWidth,
            D = S.cornerLen / 2,
            R = g.makeDragger(u, "path", "maindrag", "crosshair");
        n.select(R).attr("d", s.pathSubplot()).attr("transform", l(x, T));
        var F,
            B,
            N,
            j,
            U,
            V,
            q,
            H,
            G,
            Y = {
          element: R,
          gd: c,
          subplot: s.id,
          plotinfo: {
            id: s.id,
            xaxis: s.xaxis,
            yaxis: s.yaxis
          },
          xaxes: [s.xaxis],
          yaxes: [s.yaxis]
        };

        function W(t, e) {
          return Math.sqrt(t * t + e * e);
        }

        function X(t, e) {
          return W(t - k, e - M);
        }

        function Z(t, e) {
          return Math.atan2(M - e, t - k);
        }

        function J(t, e) {
          return [t * Math.cos(e), t * Math.sin(-e)];
        }

        function K(t, e) {
          if (0 === t) return s.pathSector(2 * z);
          var r = D / t,
              n = e - r,
              i = e + r,
              a = Math.max(0, Math.min(t, d)),
              o = a - z,
              l = a + z;
          return "M" + J(o, n) + "A" + [o, o] + " 0,0,0 " + J(o, i) + "L" + J(l, i) + "A" + [l, l] + " 0,0,1 " + J(l, n) + "Z";
        }

        function Q(t, e, r) {
          if (0 === t) return s.pathSector(2 * z);
          var n,
              i,
              a = J(t, e),
              o = J(t, r),
              l = P((a[0] + o[0]) / 2),
              c = P((a[1] + o[1]) / 2);

          if (l && c) {
            var u = c / l,
                f = -1 / u,
                h = I(z, u, l, c);
            n = I(D, f, h[0][0], h[0][1]), i = I(D, f, h[1][0], h[1][1]);
          } else {
            var p, d;
            c ? (p = D, d = z) : (p = z, d = D), n = [[l - p, c - d], [l + p, c - d]], i = [[l - p, c + d], [l + p, c + d]];
          }

          return "M" + n.join("L") + "L" + i.reverse().join("L") + "Z";
        }

        function $(t, e) {
          return e = Math.max(Math.min(e, d), m), t < p ? t = 0 : d - t < p ? t = d : e < p ? e = 0 : d - e < p && (e = d), Math.abs(e - t) > h ? (t < e ? (N = t, j = e) : (N = e, j = t), !0) : (N = null, j = null, !1);
        }

        function tt(t, e) {
          t = t || U, e = e || "M0,0Z", H.attr("d", t), G.attr("d", e), g.transitionZoombox(H, G, V, q), V = !0;
          var r = {};
          at(r), c.emit("plotly_relayouting", r);
        }

        function et(t, n) {
          var i,
              a,
              o = F + (t *= e),
              l = B + (n *= r),
              c = X(F, B),
              u = Math.min(X(o, l), d),
              f = Z(F, B);
          $(c, u) && (i = U + s.pathSector(j), N && (i += s.pathSector(N)), a = K(N, f) + K(j, f)), tt(i, a);
        }

        function rt(t, e, r, n) {
          var i = E.findIntersectionXY(r, n, r, [t - k, M - e]);
          return W(i[0], i[1]);
        }

        function nt(t, e) {
          var r,
              n,
              i = F + t,
              a = B + e,
              o = Z(F, B),
              l = Z(i, a),
              c = O(o, L),
              u = O(l, L);
          $(rt(F, B, c[0], c[1]), Math.min(rt(i, a, u[0], u[1]), d)) && (r = U + s.pathSector(j), N && (r += s.pathSector(N)), n = [Q(N, c[0], c[1]), Q(j, c[0], c[1])].join(" ")), tt(r, n);
        }

        function it() {
          if (g.removeZoombox(c), null !== N && null !== j) {
            var t = {};
            at(t), g.showDoubleClickNotifier(c), a.call("_guiRelayout", c, t);
          }
        }

        function at(t) {
          var e = C._rl,
              r = (e[1] - e[0]) / (1 - m / d) / d,
              n = [e[0] + (N - m) * r, e[0] + (j - m) * r];
          t[s.id + ".radialaxis.range"] = n;
        }

        function ot(t, e) {
          var r = c._fullLayout.clickmode;

          if (g.removeZoombox(c), 2 === t) {
            var n = {};

            for (var i in s.viewInitial) {
              n[s.id + "." + i] = s.viewInitial[i];
            }

            c.emit("plotly_doubleclick", null), a.call("_guiRelayout", c, n);
          }

          r.indexOf("select") > -1 && 1 === t && _(e, c, [s.xaxis], [s.yaxis], s.id, Y), r.indexOf("event") > -1 && y.click(c, e, s.id);
        }

        Y.prepFn = function (t, n, a) {
          var l = c._fullLayout.dragmode,
              u = R.getBoundingClientRect();

          c._fullLayout._calcInverseTransform(c);

          var h = c._fullLayout._invTransform;
          e = c._fullLayout._invScaleX, r = c._fullLayout._invScaleY;
          var p = o.apply3DTransform(h)(n - u.left, a - u.top);

          if (F = p[0], B = p[1], L) {
            var m = E.findPolygonOffset(d, A[0], A[1], L);
            F += k + m[0], B += M + m[1];
          }

          switch (l) {
            case "zoom":
              Y.moveFn = L ? nt : et, Y.clickFn = ot, Y.doneFn = it, function () {
                N = null, j = null, U = s.pathSubplot(), V = !1;
                var t = c._fullLayout[s.id];
                q = i(t.bgcolor).getLuminance(), (H = g.makeZoombox(f, q, x, T, U)).attr("fill-rule", "evenodd"), G = g.makeCorners(f, x, T), w(c);
              }();
              break;

            case "select":
            case "lasso":
              b(t, n, a, Y, l);
          }
        }, R.onmousemove = function (t) {
          y.hover(c, t, s.id), c._fullLayout._lasthover = R, c._fullLayout._hoversubplot = s.id;
        }, R.onmouseout = function (t) {
          c._dragging || v.unhover(c, t);
        }, v.init(Y);
      }, z.updateRadialDrag = function (t, e, r) {
        var i = this,
            c = i.gd,
            u = i.layers,
            f = i.radius,
            h = i.innerRadius,
            p = i.cx,
            d = i.cy,
            m = i.radialAxis,
            y = S.radialDragBoxSize,
            x = y / 2;

        if (m.visible) {
          var b,
              _,
              T,
              A = P(i.radialAxisAngle),
              E = m._rl,
              L = E[0],
              C = E[1],
              O = E[r],
              z = .75 * (E[1] - E[0]) / (1 - e.hole) / f;

          r ? (b = p + (f + x) * Math.cos(A), _ = d - (f + x) * Math.sin(A), T = "radialdrag") : (b = p + (h - x) * Math.cos(A), _ = d - (h - x) * Math.sin(A), T = "radialdrag-inner");
          var D,
              B,
              N,
              j = g.makeRectDragger(u, T, "crosshair", -x, -x, y, y),
              U = {
            element: j,
            gd: c
          };
          F(n.select(j), m.visible && h < f, {
            transform: l(b, _)
          }), U.prepFn = function () {
            D = null, B = null, N = null, U.moveFn = V, U.doneFn = q, w(c);
          }, U.clampFn = function (t, e) {
            return Math.sqrt(t * t + e * e) < S.MINDRAG && (t = 0, e = 0), [t, e];
          }, v.init(U);
        }

        function V(t, e) {
          if (D) D(t, e);else {
            var n = [t, -e],
                a = [Math.cos(A), Math.sin(A)],
                s = Math.abs(o.dot(n, a) / Math.sqrt(o.dot(n, n)));
            isNaN(s) || (D = s < .5 ? H : G);
          }
          var l = {};
          !function (t) {
            null !== B ? t[i.id + ".radialaxis.angle"] = B : null !== N && (t[i.id + ".radialaxis.range[" + r + "]"] = N);
          }(l), c.emit("plotly_relayouting", l);
        }

        function q() {
          null !== B ? a.call("_guiRelayout", c, i.id + ".radialaxis.angle", B) : null !== N && a.call("_guiRelayout", c, i.id + ".radialaxis.range[" + r + "]", N);
        }

        function H(t, e) {
          if (0 !== r) {
            var n = b + t,
                a = _ + e;
            B = Math.atan2(d - a, n - p), i.vangles && (B = R(B, i.vangles)), B = I(B);
            var o = l(p, d) + s(-B);
            u["radial-axis"].attr("transform", o), u["radial-line"].select("line").attr("transform", o);
            var c = i.gd._fullLayout,
                f = c[i.id];
            i.updateRadialAxisTitle(c, f, B);
          }
        }

        function G(t, e) {
          var n = o.dot([t, -e], [Math.cos(A), Math.sin(A)]);

          if (N = O - z * n, z > 0 == (r ? N > L : N < C)) {
            var s = c._fullLayout,
                l = s[i.id];
            m.range[r] = N, m._rl[r] = N, i.updateRadialAxis(s, l), i.xaxis.setRange(), i.xaxis.setScale(), i.yaxis.setRange(), i.yaxis.setScale();
            var u = !1;

            for (var f in i.traceHash) {
              var h = i.traceHash[f],
                  p = o.filterVisible(h);
              h[0][0].trace._module.plot(c, i, p, l), a.traceIs(f, "gl") && p.length && (u = !0);
            }

            u && (k(c), M(c));
          } else N = null;
        }
      }, z.updateAngularDrag = function (t) {
        var e = this,
            r = e.gd,
            i = e.layers,
            c = e.radius,
            f = e.angularAxis,
            h = e.cx,
            p = e.cy,
            d = e.cxx,
            m = e.cyy,
            y = S.angularDragBoxSize,
            x = g.makeDragger(i, "path", "angulardrag", "move"),
            b = {
          element: x,
          gd: r
        };

        function _(t, e) {
          return Math.atan2(m + y - e, t - d - y);
        }

        n.select(x).attr("d", e.pathAnnulus(c, c + y)).attr("transform", l(h, p)).call(T, "move");
        var A,
            E,
            L,
            C,
            P,
            O,
            z = i.frontplot.select(".scatterlayer").selectAll(".trace"),
            D = z.selectAll(".point"),
            R = z.selectAll(".textpoint");

        function F(c, g) {
          var v = e.gd._fullLayout,
              y = v[e.id],
              x = _(A + c * t._invScaleX, E + g * t._invScaleY),
              b = I(x - O);

          if (C = L + b, i.frontplot.attr("transform", l(e.xOffset2, e.yOffset2) + s([-b, d, m])), e.vangles) {
            P = e.radialAxisAngle + b;
            var w = l(h, p) + s(-b),
                T = l(h, p) + s(-P);
            i.bg.attr("transform", w), i["radial-grid"].attr("transform", w), i["radial-axis"].attr("transform", T), i["radial-line"].select("line").attr("transform", T), e.updateRadialAxisTitle(v, y, P);
          } else e.clipPaths.forTraces.select("path").attr("transform", l(d, m) + s(b));

          D.each(function () {
            var t = n.select(this),
                e = u.getTranslate(t);
            t.attr("transform", l(e.x, e.y) + s([b]));
          }), R.each(function () {
            var t = n.select(this),
                e = t.select("text"),
                r = u.getTranslate(t);
            t.attr("transform", s([b, e.attr("x"), e.attr("y")]) + l(r.x, r.y));
          }), f.rotation = o.modHalf(C, 360), e.updateAngularAxis(v, y), e._hasClipOnAxisFalse && !o.isFullCircle(e.sectorInRad) && z.call(u.hideOutsideRangePoints, e);
          var S = !1;

          for (var F in e.traceHash) {
            if (a.traceIs(F, "gl")) {
              var N = e.traceHash[F],
                  j = o.filterVisible(N);
              N[0][0].trace._module.plot(r, e, j, y), j.length && (S = !0);
            }
          }

          S && (k(r), M(r));
          var U = {};
          B(U), r.emit("plotly_relayouting", U);
        }

        function B(t) {
          t[e.id + ".angularaxis.rotation"] = C, e.vangles && (t[e.id + ".radialaxis.angle"] = P);
        }

        function N() {
          R.select("text").attr("transform", null);
          var t = {};
          B(t), a.call("_guiRelayout", r, t);
        }

        b.prepFn = function (n, i, a) {
          var s = t[e.id];
          L = s.angularaxis.rotation;
          var l = x.getBoundingClientRect();
          A = i - l.left, E = a - l.top, r._fullLayout._calcInverseTransform(r);
          var c = o.apply3DTransform(t._invTransform)(A, E);
          A = c[0], E = c[1], O = _(A, E), b.moveFn = F, b.doneFn = N, w(r);
        }, e.vangles && !o.isFullCircle(e.sectorInRad) && (b.prepFn = o.noop, T(n.select(x), null)), v.init(b);
      }, z.isPtInside = function (t) {
        var e = this.sectorInRad,
            r = this.vangles,
            n = this.angularAxis.c2g(t.theta),
            i = this.radialAxis,
            a = i.c2l(t.r),
            s = i._rl;
        return (r ? E.isPtInsidePolygon : o.isPtInsideSector)(a, n, s, e, r);
      }, z.pathArc = function (t) {
        var e = this.sectorInRad,
            r = this.vangles;
        return (r ? E.pathPolygon : o.pathArc)(t, e[0], e[1], r);
      }, z.pathSector = function (t) {
        var e = this.sectorInRad,
            r = this.vangles;
        return (r ? E.pathPolygon : o.pathSector)(t, e[0], e[1], r);
      }, z.pathAnnulus = function (t, e) {
        var r = this.sectorInRad,
            n = this.vangles;
        return (n ? E.pathPolygonAnnulus : o.pathAnnulus)(t, e, r[0], r[1], n);
      }, z.pathSubplot = function () {
        var t = this.innerRadius,
            e = this.radius;
        return t ? this.pathAnnulus(t, e) : this.pathSector(e);
      }, z.fillViewInitialKey = function (t, e) {
        t in this.viewInitial || (this.viewInitial[t] = e);
      };
    }, {
      "../../components/color": 658,
      "../../components/dragelement": 677,
      "../../components/drawing": 680,
      "../../components/fx": 698,
      "../../components/titles": 756,
      "../../constants/alignment": 763,
      "../../lib": 795,
      "../../lib/clear_gl_canvases": 779,
      "../../lib/setcursor": 816,
      "../../plot_api/subroutines": 835,
      "../../plots/cartesian/axes": 845,
      "../../registry": 923,
      "../cartesian/autorange": 844,
      "../cartesian/dragbox": 853,
      "../cartesian/select": 864,
      "../cartesian/set_convert": 865,
      "../plots": 909,
      "./constants": 910,
      "./helpers": 911,
      "./set_convert": 916,
      "@plotly/d3": 57,
      tinycolor2: 590
    }],
    916: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../cartesian/set_convert"),
          a = n.deg2rad,
          o = n.rad2deg;

      e.exports = function (t, e, r) {
        switch (i(t, r), t._id) {
          case "x":
          case "radialaxis":
            !function (t, e) {
              var r = e._subplot;

              t.setGeometry = function () {
                var e = t._rl[0],
                    n = t._rl[1],
                    i = r.innerRadius,
                    a = (r.radius - i) / (n - e),
                    o = i / a,
                    s = e > n ? function (t) {
                  return t <= 0;
                } : function (t) {
                  return t >= 0;
                };
                t.c2g = function (r) {
                  var n = t.c2l(r) - e;
                  return (s(n) ? n : 0) + o;
                }, t.g2c = function (r) {
                  return t.l2c(r + e - o);
                }, t.g2p = function (t) {
                  return t * a;
                }, t.c2p = function (e) {
                  return t.g2p(t.c2g(e));
                };
              };
            }(t, e);
            break;

          case "angularaxis":
            !function (t, e) {
              var r = t.type;

              if ("linear" === r) {
                var i = t.d2c,
                    s = t.c2d;
                t.d2c = function (t, e) {
                  return function (t, e) {
                    return "degrees" === e ? a(t) : t;
                  }(i(t), e);
                }, t.c2d = function (t, e) {
                  return s(function (t, e) {
                    return "degrees" === e ? o(t) : t;
                  }(t, e));
                };
              }

              t.makeCalcdata = function (e, i) {
                var a,
                    o,
                    s = e[i],
                    l = e._length,
                    c = function c(r) {
                  return t.d2c(r, e.thetaunit);
                };

                if (s) {
                  if (n.isTypedArray(s) && "linear" === r) {
                    if (l === s.length) return s;
                    if (s.subarray) return s.subarray(0, l);
                  }

                  for (a = new Array(l), o = 0; o < l; o++) {
                    a[o] = c(s[o]);
                  }
                } else {
                  var u = i + "0",
                      f = "d" + i,
                      h = u in e ? c(e[u]) : 0,
                      p = e[f] ? c(e[f]) : (t.period || 2 * Math.PI) / l;

                  for (a = new Array(l), o = 0; o < l; o++) {
                    a[o] = h + o * p;
                  }
                }

                return a;
              }, t.setGeometry = function () {
                var i,
                    s,
                    l,
                    c,
                    u = e.sector,
                    f = u.map(a),
                    h = {
                  clockwise: -1,
                  counterclockwise: 1
                }[t.direction],
                    p = a(t.rotation),
                    d = function d(t) {
                  return h * t + p;
                },
                    m = function m(t) {
                  return (t - p) / h;
                };

                switch (r) {
                  case "linear":
                    s = i = n.identity, c = a, l = o, t.range = n.isFullCircle(f) ? [u[0], u[0] + 360] : f.map(m).map(o);
                    break;

                  case "category":
                    var g = t._categories.length,
                        v = t.period ? Math.max(t.period, g) : g;
                    0 === v && (v = 1), s = c = function c(t) {
                      return 2 * t * Math.PI / v;
                    }, i = l = function l(t) {
                      return t * v / Math.PI / 2;
                    }, t.range = [0, v];
                }

                t.c2g = function (t) {
                  return d(s(t));
                }, t.g2c = function (t) {
                  return i(m(t));
                }, t.t2g = function (t) {
                  return d(c(t));
                }, t.g2t = function (t) {
                  return l(m(t));
                };
              };
            }(t, e);
        }
      };
    }, {
      "../../lib": 795,
      "../cartesian/set_convert": 865
    }],
    917: [function (t, e, r) {
      "use strict";

      var n = t("../lib"),
          i = t("../plot_api/plot_template"),
          a = t("./domain").defaults;

      e.exports = function (t, e, r, o) {
        var s,
            l,
            c = o.type,
            u = o.attributes,
            f = o.handleDefaults,
            h = o.partition || "x",
            p = e._subplots[c],
            d = p.length,
            m = d && p[0].replace(/\d+$/, "");

        function g(t, e) {
          return n.coerce(s, l, u, t, e);
        }

        for (var v = 0; v < d; v++) {
          var y = p[v];
          s = t[y] ? t[y] : t[y] = {}, l = i.newContainer(e, y, m), g("uirevision", e.uirevision);
          var x = {};
          x[h] = [v / d, (v + 1) / d], a(l, e, g, x), o.id = y, f(s, l, g, o);
        }
      };
    }, {
      "../lib": 795,
      "../plot_api/plot_template": 834,
      "./domain": 872
    }],
    918: [function (t, e, r) {
      "use strict";

      var n = t("../constants/docs");
      n.FORMAT_LINK, n.DATE_FORMAT_LINK;

      function i(t) {
        var e = t.description ? " " + t.description : "",
            r = t.keys || [];

        if (r.length > 0) {
          for (var n = [], i = 0; i < r.length; i++) {
            n[i] = "`" + r[i] + "`";
          }

          e += "Finally, the template string has access to ", e = 1 === r.length ? "variable " + n[0] : "variables " + n.slice(0, -1).join(", ") + " and " + n.slice(-1) + ".";
        }

        return e;
      }

      r.hovertemplateAttrs = function (t, e) {
        t = t || {};
        i(e = e || {});
        var r = {
          valType: "string",
          dflt: "",
          editType: t.editType || "none"
        };
        return !1 !== t.arrayOk && (r.arrayOk = !0), r;
      }, r.texttemplateAttrs = function (t, e) {
        t = t || {};
        i(e = e || {});
        var r = {
          valType: "string",
          dflt: "",
          editType: t.editType || "calc"
        };
        return !1 !== t.arrayOk && (r.arrayOk = !0), r;
      };
    }, {
      "../constants/docs": 766
    }],
    919: [function (t, e, r) {
      "use strict";

      var n = t("./ternary"),
          i = t("../../plots/get_data").getSubplotCalcData,
          a = t("../../lib").counterRegex;
      r.name = "ternary";
      var o = r.attr = "subplot";
      r.idRoot = "ternary", r.idRegex = r.attrRegex = a("ternary"), (r.attributes = {})[o] = {
        valType: "subplotid",
        dflt: "ternary",
        editType: "calc"
      }, r.layoutAttributes = t("./layout_attributes"), r.supplyLayoutDefaults = t("./layout_defaults"), r.plot = function (t) {
        for (var e = t._fullLayout, r = t.calcdata, a = e._subplots.ternary, o = 0; o < a.length; o++) {
          var s = a[o],
              l = i(r, "ternary", s),
              c = e[s]._subplot;
          c || (c = new n({
            id: s,
            graphDiv: t,
            container: e._ternarylayer.node()
          }, e), e[s]._subplot = c), c.plot(l, e, t._promises);
        }
      }, r.clean = function (t, e, r, n) {
        for (var i = n._subplots.ternary || [], a = 0; a < i.length; a++) {
          var o = i[a],
              s = n[o]._subplot;
          !e[o] && s && (s.plotContainer.remove(), s.clipDef.remove(), s.clipDefRelative.remove(), s.layers["a-title"].remove(), s.layers["b-title"].remove(), s.layers["c-title"].remove());
        }
      };
    }, {
      "../../lib": 795,
      "../../plots/get_data": 882,
      "./layout_attributes": 920,
      "./layout_defaults": 921,
      "./ternary": 922
    }],
    920: [function (t, e, r) {
      "use strict";

      var n = t("../../components/color/attributes"),
          i = t("../domain").attributes,
          a = t("../cartesian/layout_attributes"),
          o = t("../../plot_api/edit_types").overrideAll,
          s = t("../../lib/extend").extendFlat,
          l = {
        title: {
          text: a.title.text,
          font: a.title.font
        },
        color: a.color,
        tickmode: a.tickmode,
        nticks: s({}, a.nticks, {
          dflt: 6,
          min: 1
        }),
        tick0: a.tick0,
        dtick: a.dtick,
        tickvals: a.tickvals,
        ticktext: a.ticktext,
        ticks: a.ticks,
        ticklen: a.ticklen,
        tickwidth: a.tickwidth,
        tickcolor: a.tickcolor,
        showticklabels: a.showticklabels,
        showtickprefix: a.showtickprefix,
        tickprefix: a.tickprefix,
        showticksuffix: a.showticksuffix,
        ticksuffix: a.ticksuffix,
        showexponent: a.showexponent,
        exponentformat: a.exponentformat,
        minexponent: a.minexponent,
        separatethousands: a.separatethousands,
        tickfont: a.tickfont,
        tickangle: a.tickangle,
        tickformat: a.tickformat,
        tickformatstops: a.tickformatstops,
        hoverformat: a.hoverformat,
        showline: s({}, a.showline, {
          dflt: !0
        }),
        linecolor: a.linecolor,
        linewidth: a.linewidth,
        showgrid: s({}, a.showgrid, {
          dflt: !0
        }),
        gridcolor: a.gridcolor,
        gridwidth: a.gridwidth,
        layer: a.layer,
        min: {
          valType: "number",
          dflt: 0,
          min: 0
        },
        _deprecated: {
          title: a._deprecated.title,
          titlefont: a._deprecated.titlefont
        }
      },
          c = e.exports = o({
        domain: i({
          name: "ternary"
        }),
        bgcolor: {
          valType: "color",
          dflt: n.background
        },
        sum: {
          valType: "number",
          dflt: 1,
          min: 0
        },
        aaxis: l,
        baxis: l,
        caxis: l
      }, "plot", "from-root");
      c.uirevision = {
        valType: "any",
        editType: "none"
      }, c.aaxis.uirevision = c.baxis.uirevision = c.caxis.uirevision = {
        valType: "any",
        editType: "none"
      };
    }, {
      "../../components/color/attributes": 657,
      "../../lib/extend": 785,
      "../../plot_api/edit_types": 827,
      "../cartesian/layout_attributes": 859,
      "../domain": 872
    }],
    921: [function (t, e, r) {
      "use strict";

      var n = t("../../components/color"),
          i = t("../../plot_api/plot_template"),
          a = t("../../lib"),
          o = t("../subplot_defaults"),
          s = t("../cartesian/tick_label_defaults"),
          l = t("../cartesian/tick_mark_defaults"),
          c = t("../cartesian/tick_value_defaults"),
          u = t("../cartesian/line_grid_defaults"),
          f = t("./layout_attributes"),
          h = ["aaxis", "baxis", "caxis"];

      function p(t, e, r, a) {
        var o,
            s,
            l,
            c = r("bgcolor"),
            u = r("sum");
        a.bgColor = n.combine(c, a.paper_bgcolor);

        for (var f = 0; f < h.length; f++) {
          s = t[o = h[f]] || {}, (l = i.newContainer(e, o))._name = o, d(s, l, a, e);
        }

        var p = e.aaxis,
            m = e.baxis,
            g = e.caxis;
        p.min + m.min + g.min >= u && (p.min = 0, m.min = 0, g.min = 0, t.aaxis && delete t.aaxis.min, t.baxis && delete t.baxis.min, t.caxis && delete t.caxis.min);
      }

      function d(t, e, r, n) {
        var i = f[e._name];

        function o(r, n) {
          return a.coerce(t, e, i, r, n);
        }

        o("uirevision", n.uirevision), e.type = "linear";

        var h = o("color"),
            p = h !== i.color.dflt ? h : r.font.color,
            d = e._name.charAt(0).toUpperCase(),
            m = "Component " + d,
            g = o("title.text", m);

        e._hovertitle = g === m ? g : d, a.coerceFont(o, "title.font", {
          family: r.font.family,
          size: a.bigFont(r.font.size),
          color: p
        }), o("min"), c(t, e, o, "linear"), s(t, e, o, "linear", {}), l(t, e, o, {
          outerTicks: !0
        }), o("showticklabels") && (a.coerceFont(o, "tickfont", {
          family: r.font.family,
          size: r.font.size,
          color: p
        }), o("tickangle"), o("tickformat")), u(t, e, o, {
          dfltColor: h,
          bgColor: r.bgColor,
          blend: 60,
          showLine: !0,
          showGrid: !0,
          noZeroLine: !0,
          attributes: i
        }), o("hoverformat"), o("layer");
      }

      e.exports = function (t, e, r) {
        o(t, e, r, {
          type: "ternary",
          attributes: f,
          handleDefaults: p,
          font: e.font,
          paper_bgcolor: e.paper_bgcolor
        });
      };
    }, {
      "../../components/color": 658,
      "../../lib": 795,
      "../../plot_api/plot_template": 834,
      "../cartesian/line_grid_defaults": 861,
      "../cartesian/tick_label_defaults": 866,
      "../cartesian/tick_mark_defaults": 867,
      "../cartesian/tick_value_defaults": 868,
      "../subplot_defaults": 917,
      "./layout_attributes": 920
    }],
    922: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("tinycolor2"),
          a = t("../../registry"),
          o = t("../../lib"),
          s = o.strTranslate,
          l = o._,
          c = t("../../components/color"),
          u = t("../../components/drawing"),
          f = t("../cartesian/set_convert"),
          h = t("../../lib/extend").extendFlat,
          p = t("../plots"),
          d = t("../cartesian/axes"),
          m = t("../../components/dragelement"),
          g = t("../../components/fx"),
          v = t("../../components/dragelement/helpers"),
          y = v.freeMode,
          x = v.rectMode,
          b = t("../../components/titles"),
          _ = t("../cartesian/select").prepSelect,
          w = t("../cartesian/select").selectOnClick,
          T = t("../cartesian/select").clearSelect,
          k = t("../cartesian/select").clearSelectionsCache,
          M = t("../cartesian/constants");

      function A(t, e) {
        this.id = t.id, this.graphDiv = t.graphDiv, this.init(e), this.makeFramework(e), this.aTickLayout = null, this.bTickLayout = null, this.cTickLayout = null;
      }

      e.exports = A;
      var S = A.prototype;
      S.init = function (t) {
        this.container = t._ternarylayer, this.defs = t._defs, this.layoutId = t._uid, this.traceHash = {}, this.layers = {};
      }, S.plot = function (t, e) {
        var r = e[this.id],
            n = e._size;
        this._hasClipOnAxisFalse = !1;

        for (var i = 0; i < t.length; i++) {
          if (!1 === t[i][0].trace.cliponaxis) {
            this._hasClipOnAxisFalse = !0;
            break;
          }
        }

        this.updateLayers(r), this.adjustLayout(r, n), p.generalUpdatePerTraceModule(this.graphDiv, this, t, r), this.layers.plotbg.select("path").call(c.fill, r.bgcolor);
      }, S.makeFramework = function (t) {
        var e = this.graphDiv,
            r = t[this.id],
            n = this.clipId = "clip" + this.layoutId + this.id,
            i = this.clipIdRelative = "clip-relative" + this.layoutId + this.id;
        this.clipDef = o.ensureSingleById(t._clips, "clipPath", n, function (t) {
          t.append("path").attr("d", "M0,0Z");
        }), this.clipDefRelative = o.ensureSingleById(t._clips, "clipPath", i, function (t) {
          t.append("path").attr("d", "M0,0Z");
        }), this.plotContainer = o.ensureSingle(this.container, "g", this.id), this.updateLayers(r), u.setClipUrl(this.layers.backplot, n, e), u.setClipUrl(this.layers.grids, n, e);
      }, S.updateLayers = function (t) {
        var e = this.layers,
            r = ["draglayer", "plotbg", "backplot", "grids"];
        "below traces" === t.aaxis.layer && r.push("aaxis", "aline"), "below traces" === t.baxis.layer && r.push("baxis", "bline"), "below traces" === t.caxis.layer && r.push("caxis", "cline"), r.push("frontplot"), "above traces" === t.aaxis.layer && r.push("aaxis", "aline"), "above traces" === t.baxis.layer && r.push("baxis", "bline"), "above traces" === t.caxis.layer && r.push("caxis", "cline");
        var i = this.plotContainer.selectAll("g.toplevel").data(r, String),
            a = ["agrid", "bgrid", "cgrid"];
        i.enter().append("g").attr("class", function (t) {
          return "toplevel " + t;
        }).each(function (t) {
          var r = n.select(this);
          e[t] = r, "frontplot" === t ? r.append("g").classed("scatterlayer", !0) : "backplot" === t ? r.append("g").classed("maplayer", !0) : "plotbg" === t ? r.append("path").attr("d", "M0,0Z") : "aline" === t || "bline" === t || "cline" === t ? r.append("path") : "grids" === t && a.forEach(function (t) {
            e[t] = r.append("g").classed("grid " + t, !0);
          });
        }), i.order();
      };
      var E = Math.sqrt(4 / 3);
      S.adjustLayout = function (t, e) {
        var r,
            n,
            i,
            a,
            o,
            l,
            p = this,
            d = t.domain,
            m = (d.x[0] + d.x[1]) / 2,
            g = (d.y[0] + d.y[1]) / 2,
            v = d.x[1] - d.x[0],
            y = d.y[1] - d.y[0],
            x = v * e.w,
            b = y * e.h,
            _ = t.sum,
            w = t.aaxis.min,
            T = t.baxis.min,
            k = t.caxis.min;
        x > E * b ? i = (a = b) * E : a = (i = x) / E, o = v * i / x, l = y * a / b, r = e.l + e.w * m - i / 2, n = e.t + e.h * (1 - g) - a / 2, p.x0 = r, p.y0 = n, p.w = i, p.h = a, p.sum = _, p.xaxis = {
          type: "linear",
          range: [w + 2 * k - _, _ - w - 2 * T],
          domain: [m - o / 2, m + o / 2],
          _id: "x"
        }, f(p.xaxis, p.graphDiv._fullLayout), p.xaxis.setScale(), p.xaxis.isPtWithinRange = function (t) {
          return t.a >= p.aaxis.range[0] && t.a <= p.aaxis.range[1] && t.b >= p.baxis.range[1] && t.b <= p.baxis.range[0] && t.c >= p.caxis.range[1] && t.c <= p.caxis.range[0];
        }, p.yaxis = {
          type: "linear",
          range: [w, _ - T - k],
          domain: [g - l / 2, g + l / 2],
          _id: "y"
        }, f(p.yaxis, p.graphDiv._fullLayout), p.yaxis.setScale(), p.yaxis.isPtWithinRange = function () {
          return !0;
        };
        var M = p.yaxis.domain[0],
            A = p.aaxis = h({}, t.aaxis, {
          range: [w, _ - T - k],
          side: "left",
          tickangle: (+t.aaxis.tickangle || 0) - 30,
          domain: [M, M + l * E],
          anchor: "free",
          position: 0,
          _id: "y",
          _length: i
        });
        f(A, p.graphDiv._fullLayout), A.setScale();
        var S = p.baxis = h({}, t.baxis, {
          range: [_ - w - k, T],
          side: "bottom",
          domain: p.xaxis.domain,
          anchor: "free",
          position: 0,
          _id: "x",
          _length: i
        });
        f(S, p.graphDiv._fullLayout), S.setScale();
        var L = p.caxis = h({}, t.caxis, {
          range: [_ - w - T, k],
          side: "right",
          tickangle: (+t.caxis.tickangle || 0) + 30,
          domain: [M, M + l * E],
          anchor: "free",
          position: 0,
          _id: "y",
          _length: i
        });
        f(L, p.graphDiv._fullLayout), L.setScale();
        var C = "M" + r + "," + (n + a) + "h" + i + "l-" + i / 2 + ",-" + a + "Z";
        p.clipDef.select("path").attr("d", C), p.layers.plotbg.select("path").attr("d", C);
        var P = "M0," + a + "h" + i + "l-" + i / 2 + ",-" + a + "Z";
        p.clipDefRelative.select("path").attr("d", P);
        var I = s(r, n);
        p.plotContainer.selectAll(".scatterlayer,.maplayer").attr("transform", I), p.clipDefRelative.select("path").attr("transform", null);
        var O = s(r - S._offset, n + a);
        p.layers.baxis.attr("transform", O), p.layers.bgrid.attr("transform", O);
        var z = s(r + i / 2, n) + "rotate(30)" + s(0, -A._offset);
        p.layers.aaxis.attr("transform", z), p.layers.agrid.attr("transform", z);
        var D = s(r + i / 2, n) + "rotate(-30)" + s(0, -L._offset);
        p.layers.caxis.attr("transform", D), p.layers.cgrid.attr("transform", D), p.drawAxes(!0), p.layers.aline.select("path").attr("d", A.showline ? "M" + r + "," + (n + a) + "l" + i / 2 + ",-" + a : "M0,0").call(c.stroke, A.linecolor || "#000").style("stroke-width", (A.linewidth || 0) + "px"), p.layers.bline.select("path").attr("d", S.showline ? "M" + r + "," + (n + a) + "h" + i : "M0,0").call(c.stroke, S.linecolor || "#000").style("stroke-width", (S.linewidth || 0) + "px"), p.layers.cline.select("path").attr("d", L.showline ? "M" + (r + i / 2) + "," + n + "l" + i / 2 + "," + a : "M0,0").call(c.stroke, L.linecolor || "#000").style("stroke-width", (L.linewidth || 0) + "px"), p.graphDiv._context.staticPlot || p.initInteractions(), u.setClipUrl(p.layers.frontplot, p._hasClipOnAxisFalse ? null : p.clipId, p.graphDiv);
      }, S.drawAxes = function (t) {
        var e = this.graphDiv,
            r = this.id.substr(7) + "title",
            n = this.layers,
            i = this.aaxis,
            a = this.baxis,
            o = this.caxis;

        if (this.drawAx(i), this.drawAx(a), this.drawAx(o), t) {
          var s = Math.max(i.showticklabels ? i.tickfont.size / 2 : 0, (o.showticklabels ? .75 * o.tickfont.size : 0) + ("outside" === o.ticks ? .87 * o.ticklen : 0)),
              c = (a.showticklabels ? a.tickfont.size : 0) + ("outside" === a.ticks ? a.ticklen : 0) + 3;
          n["a-title"] = b.draw(e, "a" + r, {
            propContainer: i,
            propName: this.id + ".aaxis.title",
            placeholder: l(e, "Click to enter Component A title"),
            attributes: {
              x: this.x0 + this.w / 2,
              y: this.y0 - i.title.font.size / 3 - s,
              "text-anchor": "middle"
            }
          }), n["b-title"] = b.draw(e, "b" + r, {
            propContainer: a,
            propName: this.id + ".baxis.title",
            placeholder: l(e, "Click to enter Component B title"),
            attributes: {
              x: this.x0 - c,
              y: this.y0 + this.h + .83 * a.title.font.size + c,
              "text-anchor": "middle"
            }
          }), n["c-title"] = b.draw(e, "c" + r, {
            propContainer: o,
            propName: this.id + ".caxis.title",
            placeholder: l(e, "Click to enter Component C title"),
            attributes: {
              x: this.x0 + this.w + c,
              y: this.y0 + this.h + .83 * o.title.font.size + c,
              "text-anchor": "middle"
            }
          });
        }
      }, S.drawAx = function (t) {
        var e,
            r = this.graphDiv,
            n = t._name,
            i = n.charAt(0),
            a = t._id,
            s = this.layers[n],
            l = i + "tickLayout",
            c = (e = t).ticks + String(e.ticklen) + String(e.showticklabels);
        this[l] !== c && (s.selectAll("." + a + "tick").remove(), this[l] = c), t.setScale();
        var u = d.calcTicks(t),
            f = d.clipEnds(t, u),
            h = d.makeTransTickFn(t),
            p = d.getTickSigns(t)[2],
            m = o.deg2rad(30),
            g = p * (t.linewidth || 1) / 2,
            v = p * t.ticklen,
            y = this.w,
            x = this.h,
            b = "b" === i ? "M0," + g + "l" + Math.sin(m) * v + "," + Math.cos(m) * v : "M" + g + ",0l" + Math.cos(m) * v + "," + -Math.sin(m) * v,
            _ = {
          a: "M0,0l" + x + ",-" + y / 2,
          b: "M0,0l-" + y / 2 + ",-" + x,
          c: "M0,0l-" + x + "," + y / 2
        }[i];
        d.drawTicks(r, t, {
          vals: "inside" === t.ticks ? f : u,
          layer: s,
          path: b,
          transFn: h,
          crisp: !1
        }), d.drawGrid(r, t, {
          vals: f,
          layer: this.layers[i + "grid"],
          path: _,
          transFn: h,
          crisp: !1
        }), d.drawLabels(r, t, {
          vals: u,
          layer: s,
          transFn: h,
          labelFns: d.makeLabelFns(t, 0, 30)
        });
      };
      var L = M.MINZOOM / 2 + .87,
          C = "m-0.87,.5h" + L + "v3h-" + (L + 5.2) + "l" + (L / 2 + 2.6) + ",-" + (.87 * L + 4.5) + "l2.6,1.5l-" + L / 2 + "," + .87 * L + "Z",
          P = "m0.87,.5h-" + L + "v3h" + (L + 5.2) + "l-" + (L / 2 + 2.6) + ",-" + (.87 * L + 4.5) + "l-2.6,1.5l" + L / 2 + "," + .87 * L + "Z",
          I = "m0,1l" + L / 2 + "," + .87 * L + "l2.6,-1.5l-" + (L / 2 + 2.6) + ",-" + (.87 * L + 4.5) + "l-" + (L / 2 + 2.6) + "," + (.87 * L + 4.5) + "l2.6,1.5l" + L / 2 + ",-" + .87 * L + "Z",
          O = !0;

      function z(t) {
        n.select(t).selectAll(".zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners").remove();
      }

      S.clearSelect = function () {
        k(this.dragOptions), T(this.dragOptions.gd);
      }, S.initInteractions = function () {
        var t,
            e,
            r,
            n,
            f,
            h,
            p,
            d,
            v,
            b,
            T,
            k,
            A = this,
            S = A.layers.plotbg.select("path").node(),
            L = A.graphDiv,
            D = L._fullLayout._zoomlayer;

        function R(t) {
          var e = {};
          return e[A.id + ".aaxis.min"] = t.a, e[A.id + ".baxis.min"] = t.b, e[A.id + ".caxis.min"] = t.c, e;
        }

        function F(t, e) {
          var r = L._fullLayout.clickmode;
          z(L), 2 === t && (L.emit("plotly_doubleclick", null), a.call("_guiRelayout", L, R({
            a: 0,
            b: 0,
            c: 0
          }))), r.indexOf("select") > -1 && 1 === t && w(e, L, [A.xaxis], [A.yaxis], A.id, A.dragOptions), r.indexOf("event") > -1 && g.click(L, e, A.id);
        }

        function B(t, e) {
          return 1 - e / A.h;
        }

        function N(t, e) {
          return 1 - (t + (A.h - e) / Math.sqrt(3)) / A.w;
        }

        function j(t, e) {
          return (t - (A.h - e) / Math.sqrt(3)) / A.w;
        }

        function U(i, a) {
          var o = r + i * t,
              s = n + a * e,
              l = Math.max(0, Math.min(1, B(0, n), B(0, s))),
              c = Math.max(0, Math.min(1, N(r, n), N(o, s))),
              u = Math.max(0, Math.min(1, j(r, n), j(o, s))),
              m = (l / 2 + u) * A.w,
              g = (1 - l / 2 - c) * A.w,
              y = (m + g) / 2,
              x = g - m,
              _ = (1 - l) * A.h,
              w = _ - x / E;

          x < M.MINZOOM ? (p = f, T.attr("d", v), k.attr("d", "M0,0Z")) : (p = {
            a: f.a + l * h,
            b: f.b + c * h,
            c: f.c + u * h
          }, T.attr("d", v + "M" + m + "," + _ + "H" + g + "L" + y + "," + w + "L" + m + "," + _ + "Z"), k.attr("d", "M" + r + "," + n + "m0.5,0.5h5v-2h-5v-5h-2v5h-5v2h5v5h2ZM" + m + "," + _ + C + "M" + g + "," + _ + P + "M" + y + "," + w + I)), b || (T.transition().style("fill", d > .2 ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.3)").duration(200), k.transition().style("opacity", 1).duration(200), b = !0), L.emit("plotly_relayouting", R(p));
        }

        function V() {
          z(L), p !== f && (a.call("_guiRelayout", L, R(p)), O && L.data && L._context.showTips && (o.notifier(l(L, "Double-click to zoom back out"), "long"), O = !1));
        }

        function q(t, e) {
          var r = t / A.xaxis._m,
              n = e / A.yaxis._m,
              i = [(p = {
            a: f.a - n,
            b: f.b + (r + n) / 2,
            c: f.c - (r - n) / 2
          }).a, p.b, p.c].sort(o.sorterAsc),
              a = i.indexOf(p.a),
              l = i.indexOf(p.b),
              c = i.indexOf(p.c);
          i[0] < 0 && (i[1] + i[0] / 2 < 0 ? (i[2] += i[0] + i[1], i[0] = i[1] = 0) : (i[2] += i[0] / 2, i[1] += i[0] / 2, i[0] = 0), p = {
            a: i[a],
            b: i[l],
            c: i[c]
          }, e = (f.a - p.a) * A.yaxis._m, t = (f.c - p.c - f.b + p.b) * A.xaxis._m);
          var h = s(A.x0 + t, A.y0 + e);
          A.plotContainer.selectAll(".scatterlayer,.maplayer").attr("transform", h);
          var d = s(-t, -e);
          A.clipDefRelative.select("path").attr("transform", d), A.aaxis.range = [p.a, A.sum - p.b - p.c], A.baxis.range = [A.sum - p.a - p.c, p.b], A.caxis.range = [A.sum - p.a - p.b, p.c], A.drawAxes(!1), A._hasClipOnAxisFalse && A.plotContainer.select(".scatterlayer").selectAll(".trace").call(u.hideOutsideRangePoints, A), L.emit("plotly_relayouting", R(p));
        }

        function H() {
          a.call("_guiRelayout", L, R(p));
        }

        this.dragOptions = {
          element: S,
          gd: L,
          plotinfo: {
            id: A.id,
            domain: L._fullLayout[A.id].domain,
            xaxis: A.xaxis,
            yaxis: A.yaxis
          },
          subplot: A.id,
          prepFn: function prepFn(a, l, u) {
            A.dragOptions.xaxes = [A.xaxis], A.dragOptions.yaxes = [A.yaxis], t = L._fullLayout._invScaleX, e = L._fullLayout._invScaleY;
            var m = A.dragOptions.dragmode = L._fullLayout.dragmode;
            y(m) ? A.dragOptions.minDrag = 1 : A.dragOptions.minDrag = void 0, "zoom" === m ? (A.dragOptions.moveFn = U, A.dragOptions.clickFn = F, A.dragOptions.doneFn = V, function (t, e, a) {
              var l = S.getBoundingClientRect();
              r = e - l.left, n = a - l.top, L._fullLayout._calcInverseTransform(L);
              var u = L._fullLayout._invTransform,
                  m = o.apply3DTransform(u)(r, n);
              r = m[0], n = m[1], f = {
                a: A.aaxis.range[0],
                b: A.baxis.range[1],
                c: A.caxis.range[1]
              }, p = f, h = A.aaxis.range[1] - f.a, d = i(A.graphDiv._fullLayout[A.id].bgcolor).getLuminance(), v = "M0," + A.h + "L" + A.w / 2 + ", 0L" + A.w + "," + A.h + "Z", b = !1, T = D.append("path").attr("class", "zoombox").attr("transform", s(A.x0, A.y0)).style({
                fill: d > .2 ? "rgba(0,0,0,0)" : "rgba(255,255,255,0)",
                "stroke-width": 0
              }).attr("d", v), k = D.append("path").attr("class", "zoombox-corners").attr("transform", s(A.x0, A.y0)).style({
                fill: c.background,
                stroke: c.defaultLine,
                "stroke-width": 1,
                opacity: 0
              }).attr("d", "M0,0Z"), A.clearSelect(L);
            }(0, l, u)) : "pan" === m ? (A.dragOptions.moveFn = q, A.dragOptions.clickFn = F, A.dragOptions.doneFn = H, f = {
              a: A.aaxis.range[0],
              b: A.baxis.range[1],
              c: A.caxis.range[1]
            }, p = f, A.clearSelect(L)) : (x(m) || y(m)) && _(a, l, u, A.dragOptions, m);
          }
        }, S.onmousemove = function (t) {
          g.hover(L, t, A.id), L._fullLayout._lasthover = S, L._fullLayout._hoversubplot = A.id;
        }, S.onmouseout = function (t) {
          L._dragging || m.unhover(L, t);
        }, m.init(this.dragOptions);
      };
    }, {
      "../../components/color": 658,
      "../../components/dragelement": 677,
      "../../components/dragelement/helpers": 676,
      "../../components/drawing": 680,
      "../../components/fx": 698,
      "../../components/titles": 756,
      "../../lib": 795,
      "../../lib/extend": 785,
      "../../registry": 923,
      "../cartesian/axes": 845,
      "../cartesian/constants": 851,
      "../cartesian/select": 864,
      "../cartesian/set_convert": 865,
      "../plots": 909,
      "@plotly/d3": 57,
      tinycolor2: 590
    }],
    923: [function (t, e, r) {
      "use strict";

      var n = t("./lib/loggers"),
          i = t("./lib/noop"),
          a = t("./lib/push_unique"),
          o = t("./lib/is_plain_object"),
          s = t("./lib/dom").addStyleRule,
          l = t("./lib/extend"),
          c = t("./plots/attributes"),
          u = t("./plots/layout_attributes"),
          f = l.extendFlat,
          h = l.extendDeepAll;

      function p(t) {
        var e = t.name,
            i = t.categories,
            a = t.meta;
        if (r.modules[e]) n.log("Type " + e + " already registered");else {
          r.subplotsRegistry[t.basePlotModule.name] || function (t) {
            var e = t.name;
            if (r.subplotsRegistry[e]) return void n.log("Plot type " + e + " already registered.");

            for (var i in v(t), r.subplotsRegistry[e] = t, r.componentsRegistry) {
              b(i, t.name);
            }
          }(t.basePlotModule);

          for (var o = {}, l = 0; l < i.length; l++) {
            o[i[l]] = !0, r.allCategories[i[l]] = !0;
          }

          for (var c in r.modules[e] = {
            _module: t,
            categories: o
          }, a && Object.keys(a).length && (r.modules[e].meta = a), r.allTypes.push(e), r.componentsRegistry) {
            y(c, e);
          }

          t.layoutAttributes && f(r.traceLayoutAttributes, t.layoutAttributes);
          var u = t.basePlotModule,
              h = u.name;

          if ("mapbox" === h) {
            var p = u.constants.styleRules;

            for (var d in p) {
              s(".js-plotly-plot .plotly .mapboxgl-" + d, p[d]);
            }
          }

          "geo" !== h && "mapbox" !== h || void 0 === (typeof window === "undefined" ? "undefined" : _typeof(window)) || void 0 !== window.PlotlyGeoAssets || (window.PlotlyGeoAssets = {
            topojson: {}
          });
        }
      }

      function d(t) {
        if ("string" != typeof t.name) throw new Error("Component module *name* must be a string.");
        var e = t.name;

        for (var n in r.componentsRegistry[e] = t, t.layoutAttributes && (t.layoutAttributes._isLinkedToArray && a(r.layoutArrayContainers, e), v(t)), r.modules) {
          y(e, n);
        }

        for (var i in r.subplotsRegistry) {
          b(e, i);
        }

        for (var o in r.transformsRegistry) {
          x(e, o);
        }

        t.schema && t.schema.layout && h(u, t.schema.layout);
      }

      function m(t) {
        if ("string" != typeof t.name) throw new Error("Transform module *name* must be a string.");
        var e = "Transform module " + t.name,
            i = "function" == typeof t.transform,
            a = "function" == typeof t.calcTransform;
        if (!i && !a) throw new Error(e + " is missing a *transform* or *calcTransform* method.");

        for (var s in i && a && n.log([e + " has both a *transform* and *calcTransform* methods.", "Please note that all *transform* methods are executed", "before all *calcTransform* methods."].join(" ")), o(t.attributes) || n.log(e + " registered without an *attributes* object."), "function" != typeof t.supplyDefaults && n.log(e + " registered without a *supplyDefaults* method."), r.transformsRegistry[t.name] = t, r.componentsRegistry) {
          x(s, t.name);
        }
      }

      function g(t) {
        var e = t.name,
            n = e.split("-")[0],
            i = t.dictionary,
            a = t.format,
            o = i && Object.keys(i).length,
            s = a && Object.keys(a).length,
            l = r.localeRegistry,
            c = l[e];

        if (c || (l[e] = c = {}), n !== e) {
          var u = l[n];
          u || (l[n] = u = {}), o && u.dictionary === c.dictionary && (u.dictionary = i), s && u.format === c.format && (u.format = a);
        }

        o && (c.dictionary = i), s && (c.format = a);
      }

      function v(t) {
        if (t.layoutAttributes) {
          var e = t.layoutAttributes._arrayAttrRegexps;
          if (e) for (var n = 0; n < e.length; n++) {
            a(r.layoutArrayRegexes, e[n]);
          }
        }
      }

      function y(t, e) {
        var n = r.componentsRegistry[t].schema;

        if (n && n.traces) {
          var i = n.traces[e];
          i && h(r.modules[e]._module.attributes, i);
        }
      }

      function x(t, e) {
        var n = r.componentsRegistry[t].schema;

        if (n && n.transforms) {
          var i = n.transforms[e];
          i && h(r.transformsRegistry[e].attributes, i);
        }
      }

      function b(t, e) {
        var n = r.componentsRegistry[t].schema;

        if (n && n.subplots) {
          var i = r.subplotsRegistry[e],
              a = i.layoutAttributes,
              o = "subplot" === i.attr ? i.name : i.attr;
          Array.isArray(o) && (o = o[0]);
          var s = n.subplots[o];
          a && s && h(a, s);
        }
      }

      function _(t) {
        return "object" == _typeof(t) && (t = t.type), t;
      }

      r.modules = {}, r.allCategories = {}, r.allTypes = [], r.subplotsRegistry = {}, r.transformsRegistry = {}, r.componentsRegistry = {}, r.layoutArrayContainers = [], r.layoutArrayRegexes = [], r.traceLayoutAttributes = {}, r.localeRegistry = {}, r.apiMethodRegistry = {}, r.collectableSubplotTypes = null, r.register = function (t) {
        if (r.collectableSubplotTypes = null, !t) throw new Error("No argument passed to Plotly.register.");
        t && !Array.isArray(t) && (t = [t]);

        for (var e = 0; e < t.length; e++) {
          var n = t[e];
          if (!n) throw new Error("Invalid module was attempted to be registered!");

          switch (n.moduleType) {
            case "trace":
              p(n);
              break;

            case "transform":
              m(n);
              break;

            case "component":
              d(n);
              break;

            case "locale":
              g(n);
              break;

            case "apiMethod":
              var i = n.name;
              r.apiMethodRegistry[i] = n.fn;
              break;

            default:
              throw new Error("Invalid module was attempted to be registered!");
          }
        }
      }, r.getModule = function (t) {
        var e = r.modules[_(t)];

        return !!e && e._module;
      }, r.traceIs = function (t, e) {
        if ("various" === (t = _(t))) return !1;
        var i = r.modules[t];
        return i || (t && n.log("Unrecognized trace type " + t + "."), i = r.modules[c.type.dflt]), !!i.categories[e];
      }, r.getTransformIndices = function (t, e) {
        for (var r = [], n = t.transforms || [], i = 0; i < n.length; i++) {
          n[i].type === e && r.push(i);
        }

        return r;
      }, r.hasTransform = function (t, e) {
        for (var r = t.transforms || [], n = 0; n < r.length; n++) {
          if (r[n].type === e) return !0;
        }

        return !1;
      }, r.getComponentMethod = function (t, e) {
        var n = r.componentsRegistry[t];
        return n && n[e] || i;
      }, r.call = function () {
        var t = arguments[0],
            e = [].slice.call(arguments, 1);
        return r.apiMethodRegistry[t].apply(null, e);
      };
    }, {
      "./lib/dom": 783,
      "./lib/extend": 785,
      "./lib/is_plain_object": 796,
      "./lib/loggers": 799,
      "./lib/noop": 804,
      "./lib/push_unique": 810,
      "./plots/attributes": 841,
      "./plots/layout_attributes": 900
    }],
    924: [function (t, e, r) {
      "use strict";

      var n = t("../registry"),
          i = t("../lib"),
          a = i.extendFlat,
          o = i.extendDeep;

      function s(t) {
        var e;

        switch (t) {
          case "themes__thumb":
            e = {
              autosize: !0,
              width: 150,
              height: 150,
              title: {
                text: ""
              },
              showlegend: !1,
              margin: {
                l: 5,
                r: 5,
                t: 5,
                b: 5,
                pad: 0
              },
              annotations: []
            };
            break;

          case "thumbnail":
            e = {
              title: {
                text: ""
              },
              hidesources: !0,
              showlegend: !1,
              borderwidth: 0,
              bordercolor: "",
              margin: {
                l: 1,
                r: 1,
                t: 1,
                b: 1,
                pad: 0
              },
              annotations: []
            };
            break;

          default:
            e = {};
        }

        return e;
      }

      e.exports = function (t, e) {
        var r,
            i,
            l = t.data,
            c = t.layout,
            u = o([], l),
            f = o({}, c, s(e.tileClass)),
            h = t._context || {};

        if (e.width && (f.width = e.width), e.height && (f.height = e.height), "thumbnail" === e.tileClass || "themes__thumb" === e.tileClass) {
          f.annotations = [];
          var p = Object.keys(f);

          for (r = 0; r < p.length; r++) {
            i = p[r], ["xaxis", "yaxis", "zaxis"].indexOf(i.slice(0, 5)) > -1 && (f[p[r]].title = {
              text: ""
            });
          }

          for (r = 0; r < u.length; r++) {
            var d = u[r];
            d.showscale = !1, d.marker && (d.marker.showscale = !1), n.traceIs(d, "pie-like") && (d.textposition = "none");
          }
        }

        if (Array.isArray(e.annotations)) for (r = 0; r < e.annotations.length; r++) {
          f.annotations.push(e.annotations[r]);
        }
        var m = Object.keys(f).filter(function (t) {
          return t.match(/^scene\d*$/);
        });

        if (m.length) {
          var g = {};

          for ("thumbnail" === e.tileClass && (g = {
            title: {
              text: ""
            },
            showaxeslabels: !1,
            showticklabels: !1,
            linetickenable: !1
          }), r = 0; r < m.length; r++) {
            var v = f[m[r]];
            v.xaxis || (v.xaxis = {}), v.yaxis || (v.yaxis = {}), v.zaxis || (v.zaxis = {}), a(v.xaxis, g), a(v.yaxis, g), a(v.zaxis, g), v._scene = null;
          }
        }

        var y = document.createElement("div");
        e.tileClass && (y.className = e.tileClass);
        var x = {
          gd: y,
          td: y,
          layout: f,
          data: u,
          config: {
            staticPlot: void 0 === e.staticPlot || e.staticPlot,
            plotGlPixelRatio: void 0 === e.plotGlPixelRatio ? 2 : e.plotGlPixelRatio,
            displaylogo: e.displaylogo || !1,
            showLink: e.showLink || !1,
            showTips: e.showTips || !1,
            mapboxAccessToken: h.mapboxAccessToken
          }
        };
        return "transparent" !== e.setBackground && (x.config.setBackground = e.setBackground || "opaque"), x.gd.defaultLayout = s(e.tileClass), x;
      };
    }, {
      "../lib": 795,
      "../registry": 923
    }],
    925: [function (t, e, r) {
      "use strict";

      var n = t("../lib"),
          i = t("../plot_api/to_image"),
          a = t("./filesaver"),
          o = t("./helpers");

      e.exports = function (t, e) {
        var r;
        return n.isPlainObject(t) || (r = n.getGraphDiv(t)), (e = e || {}).format = e.format || "png", e.width = e.width || null, e.height = e.height || null, e.imageDataOnly = !0, new Promise(function (s, l) {
          r && r._snapshotInProgress && l(new Error("Snapshotting already in progress.")), n.isIE() && "svg" !== e.format && l(new Error(o.MSG_IE_BAD_FORMAT)), r && (r._snapshotInProgress = !0);
          var c = i(t, e),
              u = e.filename || t.fn || "newplot";
          u += "." + e.format.replace("-", "."), c.then(function (t) {
            return r && (r._snapshotInProgress = !1), a(t, u, e.format);
          }).then(function (t) {
            s(t);
          }).catch(function (t) {
            r && (r._snapshotInProgress = !1), l(t);
          });
        });
      };
    }, {
      "../lib": 795,
      "../plot_api/to_image": 837,
      "./filesaver": 926,
      "./helpers": 927
    }],
    926: [function (t, e, r) {
      "use strict";

      var n = t("../lib"),
          i = t("./helpers");

      e.exports = function (t, e, r) {
        var a = document.createElement("a"),
            o = ("download" in a);
        return new Promise(function (s, l) {
          var c, u;

          if (n.isSafari()) {
            var f = "svg" === r ? "," : ";base64,";
            return i.octetStream(f + encodeURIComponent(t)), s(e);
          }

          return n.isIE() ? (c = i.createBlob(t, "svg"), window.navigator.msSaveBlob(c, e), c = null, s(e)) : o ? (c = i.createBlob(t, r), u = i.createObjectURL(c), a.href = u, a.download = e, document.body.appendChild(a), a.click(), document.body.removeChild(a), i.revokeObjectURL(u), c = null, s(e)) : void l(new Error("download error"));
        });
      };
    }, {
      "../lib": 795,
      "./helpers": 927
    }],
    927: [function (t, e, r) {
      "use strict";

      var n = t("../registry");
      r.getDelay = function (t) {
        return t._has && (t._has("gl3d") || t._has("gl2d") || t._has("mapbox")) ? 500 : 0;
      }, r.getRedrawFunc = function (t) {
        return function () {
          n.getComponentMethod("colorbar", "draw")(t);
        };
      }, r.encodeSVG = function (t) {
        return "data:image/svg+xml," + encodeURIComponent(t);
      }, r.encodeJSON = function (t) {
        return "data:application/json," + encodeURIComponent(t);
      };
      var i = window.URL || window.webkitURL;
      r.createObjectURL = function (t) {
        return i.createObjectURL(t);
      }, r.revokeObjectURL = function (t) {
        return i.revokeObjectURL(t);
      }, r.createBlob = function (t, e) {
        if ("svg" === e) return new window.Blob([t], {
          type: "image/svg+xml;charset=utf-8"
        });
        if ("full-json" === e) return new window.Blob([t], {
          type: "application/json;charset=utf-8"
        });

        var r = function (t) {
          for (var e = t.length, r = new ArrayBuffer(e), n = new Uint8Array(r), i = 0; i < e; i++) {
            n[i] = t.charCodeAt(i);
          }

          return r;
        }(window.atob(t));

        return new window.Blob([r], {
          type: "image/" + e
        });
      }, r.octetStream = function (t) {
        document.location.href = "data:application/octet-stream" + t;
      }, r.IMAGE_URL_PREFIX = /^data:image\/\w+;base64,/, r.MSG_IE_BAD_FORMAT = "Sorry IE does not support downloading from canvas. Try {format:'svg'} instead.";
    }, {
      "../registry": 923
    }],
    928: [function (t, e, r) {
      "use strict";

      var n = t("./helpers"),
          i = {
        getDelay: n.getDelay,
        getRedrawFunc: n.getRedrawFunc,
        clone: t("./cloneplot"),
        toSVG: t("./tosvg"),
        svgToImg: t("./svgtoimg"),
        toImage: t("./toimage"),
        downloadImage: t("./download")
      };
      e.exports = i;
    }, {
      "./cloneplot": 924,
      "./download": 925,
      "./helpers": 927,
      "./svgtoimg": 929,
      "./toimage": 930,
      "./tosvg": 931
    }],
    929: [function (t, e, r) {
      "use strict";

      var n = t("../lib"),
          i = t("events").EventEmitter,
          a = t("./helpers");

      e.exports = function (t) {
        var e = t.emitter || new i(),
            r = new Promise(function (i, o) {
          var s = window.Image,
              l = t.svg,
              c = t.format || "png";

          if (n.isIE() && "svg" !== c) {
            var u = new Error(a.MSG_IE_BAD_FORMAT);
            return o(u), t.promise ? r : e.emit("error", u);
          }

          var f,
              h,
              p = t.canvas,
              d = t.scale || 1,
              m = t.width || 300,
              g = t.height || 150,
              v = d * m,
              y = d * g,
              x = p.getContext("2d"),
              b = new s();
          "svg" === c || n.isSafari() ? h = a.encodeSVG(l) : (f = a.createBlob(l, "svg"), h = a.createObjectURL(f)), p.width = v, p.height = y, b.onload = function () {
            var r;

            switch (f = null, a.revokeObjectURL(h), "svg" !== c && x.drawImage(b, 0, 0, v, y), c) {
              case "jpeg":
                r = p.toDataURL("image/jpeg");
                break;

              case "png":
                r = p.toDataURL("image/png");
                break;

              case "webp":
                r = p.toDataURL("image/webp");
                break;

              case "svg":
                r = h;
                break;

              default:
                var n = "Image format is not jpeg, png, svg or webp.";
                if (o(new Error(n)), !t.promise) return e.emit("error", n);
            }

            i(r), t.promise || e.emit("success", r);
          }, b.onerror = function (r) {
            if (f = null, a.revokeObjectURL(h), o(r), !t.promise) return e.emit("error", r);
          }, b.src = h;
        });
        return t.promise ? r : e;
      };
    }, {
      "../lib": 795,
      "./helpers": 927,
      events: 111
    }],
    930: [function (t, e, r) {
      "use strict";

      var n = t("events").EventEmitter,
          i = t("../registry"),
          a = t("../lib"),
          o = t("./helpers"),
          s = t("./cloneplot"),
          l = t("./tosvg"),
          c = t("./svgtoimg");

      e.exports = function (t, e) {
        var r = new n(),
            u = s(t, {
          format: "png"
        }),
            f = u.gd;
        f.style.position = "absolute", f.style.left = "-5000px", document.body.appendChild(f);
        var h = o.getRedrawFunc(f);
        return i.call("_doPlot", f, u.data, u.layout, u.config).then(h).then(function () {
          var t = o.getDelay(f._fullLayout);
          setTimeout(function () {
            var t = l(f),
                n = document.createElement("canvas");
            n.id = a.randstr(), (r = c({
              format: e.format,
              width: f._fullLayout.width,
              height: f._fullLayout.height,
              canvas: n,
              emitter: r,
              svg: t
            })).clean = function () {
              f && document.body.removeChild(f);
            };
          }, t);
        }).catch(function (t) {
          r.emit("error", t);
        }), r;
      };
    }, {
      "../lib": 795,
      "../registry": 923,
      "./cloneplot": 924,
      "./helpers": 927,
      "./svgtoimg": 929,
      "./tosvg": 931,
      events: 111
    }],
    931: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../lib"),
          a = t("../components/drawing"),
          o = t("../components/color"),
          s = t("../constants/xmlns_namespaces"),
          l = /"/g,
          c = new RegExp('("TOBESTRIPPED)|(TOBESTRIPPED")', "g");

      e.exports = function (t, e, r) {
        var u,
            f,
            h = t._fullLayout,
            p = h._paper,
            d = h._toppaper,
            m = h.width,
            g = h.height;
        p.insert("rect", ":first-child").call(a.setRect, 0, 0, m, g).call(o.fill, h.paper_bgcolor);
        var v = h._basePlotModules || [];

        for (u = 0; u < v.length; u++) {
          var y = v[u];
          y.toSVG && y.toSVG(t);
        }

        if (d) {
          var x = d.node().childNodes,
              b = Array.prototype.slice.call(x);

          for (u = 0; u < b.length; u++) {
            var _ = b[u];
            _.childNodes.length && p.node().appendChild(_);
          }
        }

        h._draggers && h._draggers.remove(), p.node().style.background = "", p.selectAll("text").attr({
          "data-unformatted": null,
          "data-math": null
        }).each(function () {
          var t = n.select(this);

          if ("hidden" !== this.style.visibility && "none" !== this.style.display) {
            t.style({
              visibility: null,
              display: null
            });
            var e = this.style.fontFamily;
            e && -1 !== e.indexOf('"') && t.style("font-family", e.replace(l, "TOBESTRIPPED"));
          } else t.remove();
        });
        var w = [];
        if (h._gradientUrlQueryParts) for (f in h._gradientUrlQueryParts) {
          w.push(f);
        }
        if (h._patternUrlQueryParts) for (f in h._patternUrlQueryParts) {
          w.push(f);
        }
        w.length && p.selectAll(w.join(",")).each(function () {
          var t = n.select(this),
              e = this.style.fill;
          e && -1 !== e.indexOf("url(") && t.style("fill", e.replace(l, "TOBESTRIPPED"));
          var r = this.style.stroke;
          r && -1 !== r.indexOf("url(") && t.style("stroke", r.replace(l, "TOBESTRIPPED"));
        }), "pdf" !== e && "eps" !== e || p.selectAll("#MathJax_SVG_glyphs path").attr("stroke-width", 0), p.node().setAttributeNS(s.xmlns, "xmlns", s.svg), p.node().setAttributeNS(s.xmlns, "xmlns:xlink", s.xlink), "svg" === e && r && (p.attr("width", r * m), p.attr("height", r * g), p.attr("viewBox", "0 0 " + m + " " + g));
        var T = new window.XMLSerializer().serializeToString(p.node());
        return T = function (t) {
          var e = n.select("body").append("div").style({
            display: "none"
          }).html(""),
              r = t.replace(/(&[^;]*;)/gi, function (t) {
            return "&lt;" === t ? "&#60;" : "&rt;" === t ? "&#62;" : -1 !== t.indexOf("<") || -1 !== t.indexOf(">") ? "" : e.html(t).text();
          });
          return e.remove(), r;
        }(T), T = (T = T.replace(/&(?!\w+;|\#[0-9]+;| \#x[0-9A-F]+;)/g, "&amp;")).replace(c, "'"), i.isIE() && (T = (T = (T = T.replace(/"/gi, "'")).replace(/(\('#)([^']*)('\))/gi, '("#$2")')).replace(/(\\')/gi, '"')), T;
      };
    }, {
      "../components/color": 658,
      "../components/drawing": 680,
      "../constants/xmlns_namespaces": 772,
      "../lib": 795,
      "@plotly/d3": 57
    }],
    932: [function (t, e, r) {
      "use strict";

      var n = t("../../lib");

      e.exports = function (t, e) {
        for (var r = 0; r < t.length; r++) {
          t[r].i = r;
        }

        n.mergeArray(e.text, t, "tx"), n.mergeArray(e.hovertext, t, "htx");
        var i = e.marker;

        if (i) {
          n.mergeArray(i.opacity, t, "mo", !0), n.mergeArray(i.color, t, "mc");
          var a = i.line;
          a && (n.mergeArray(a.color, t, "mlc"), n.mergeArrayCastPositive(a.width, t, "mlw"));
        }
      };
    }, {
      "../../lib": 795
    }],
    933: [function (t, e, r) {
      "use strict";

      var n = t("../scatter/attributes"),
          i = t("../../plots/hoverformat_attributes"),
          a = t("../../plots/template_attributes").hovertemplateAttrs,
          o = t("../../plots/template_attributes").texttemplateAttrs,
          s = t("../../components/colorscale/attributes"),
          l = t("../../plots/font_attributes"),
          c = t("./constants"),
          u = t("../../components/drawing/attributes").pattern,
          f = t("../../lib/extend").extendFlat,
          h = l({
        editType: "calc",
        arrayOk: !0,
        colorEditType: "style"
      }),
          p = f({}, n.marker.line.width, {
        dflt: 0
      }),
          d = f({
        width: p,
        editType: "calc"
      }, s("marker.line")),
          m = f({
        line: d,
        editType: "calc"
      }, s("marker"), {
        opacity: {
          valType: "number",
          arrayOk: !0,
          dflt: 1,
          min: 0,
          max: 1,
          editType: "style"
        },
        pattern: u
      });
      e.exports = {
        x: n.x,
        x0: n.x0,
        dx: n.dx,
        y: n.y,
        y0: n.y0,
        dy: n.dy,
        xperiod: n.xperiod,
        yperiod: n.yperiod,
        xperiod0: n.xperiod0,
        yperiod0: n.yperiod0,
        xperiodalignment: n.xperiodalignment,
        yperiodalignment: n.yperiodalignment,
        xhoverformat: i("x"),
        yhoverformat: i("y"),
        text: n.text,
        texttemplate: o({
          editType: "plot"
        }, {
          keys: c.eventDataKeys
        }),
        hovertext: n.hovertext,
        hovertemplate: a({}, {
          keys: c.eventDataKeys
        }),
        textposition: {
          valType: "enumerated",
          values: ["inside", "outside", "auto", "none"],
          dflt: "auto",
          arrayOk: !0,
          editType: "calc"
        },
        insidetextanchor: {
          valType: "enumerated",
          values: ["end", "middle", "start"],
          dflt: "end",
          editType: "plot"
        },
        textangle: {
          valType: "angle",
          dflt: "auto",
          editType: "plot"
        },
        textfont: f({}, h, {}),
        insidetextfont: f({}, h, {}),
        outsidetextfont: f({}, h, {}),
        constraintext: {
          valType: "enumerated",
          values: ["inside", "outside", "both", "none"],
          dflt: "both",
          editType: "calc"
        },
        cliponaxis: f({}, n.cliponaxis, {}),
        orientation: {
          valType: "enumerated",
          values: ["v", "h"],
          editType: "calc+clearAxisTypes"
        },
        base: {
          valType: "any",
          dflt: null,
          arrayOk: !0,
          editType: "calc"
        },
        offset: {
          valType: "number",
          dflt: null,
          arrayOk: !0,
          editType: "calc"
        },
        width: {
          valType: "number",
          dflt: null,
          min: 0,
          arrayOk: !0,
          editType: "calc"
        },
        marker: m,
        offsetgroup: {
          valType: "string",
          dflt: "",
          editType: "calc"
        },
        alignmentgroup: {
          valType: "string",
          dflt: "",
          editType: "calc"
        },
        selected: {
          marker: {
            opacity: n.selected.marker.opacity,
            color: n.selected.marker.color,
            editType: "style"
          },
          textfont: n.selected.textfont,
          editType: "style"
        },
        unselected: {
          marker: {
            opacity: n.unselected.marker.opacity,
            color: n.unselected.marker.color,
            editType: "style"
          },
          textfont: n.unselected.textfont,
          editType: "style"
        },
        _deprecated: {
          bardir: {
            valType: "enumerated",
            editType: "calc",
            values: ["v", "h"]
          }
        }
      };
    }, {
      "../../components/colorscale/attributes": 665,
      "../../components/drawing/attributes": 679,
      "../../lib/extend": 785,
      "../../plots/font_attributes": 873,
      "../../plots/hoverformat_attributes": 899,
      "../../plots/template_attributes": 918,
      "../scatter/attributes": 1199,
      "./constants": 935
    }],
    934: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/cartesian/axes"),
          i = t("../../plots/cartesian/align_period"),
          a = t("../../components/colorscale/helpers").hasColorscale,
          o = t("../../components/colorscale/calc"),
          s = t("./arrays_to_calcdata"),
          l = t("../scatter/calc_selection");

      e.exports = function (t, e) {
        var r,
            c,
            u,
            f,
            h = n.getFromId(t, e.xaxis || "x"),
            p = n.getFromId(t, e.yaxis || "y"),
            d = {
          msUTC: !(!e.base && 0 !== e.base)
        };
        "h" === e.orientation ? (r = h.makeCalcdata(e, "x", d), u = p.makeCalcdata(e, "y"), c = i(e, p, "y", u), f = !!e.yperiodalignment) : (r = p.makeCalcdata(e, "y", d), u = h.makeCalcdata(e, "x"), c = i(e, h, "x", u), f = !!e.xperiodalignment);

        for (var m = Math.min(c.length, r.length), g = new Array(m), v = 0; v < m; v++) {
          g[v] = {
            p: c[v],
            s: r[v]
          }, f && (g[v].orig_p = u[v]), e.ids && (g[v].id = String(e.ids[v]));
        }

        return a(e, "marker") && o(t, e, {
          vals: e.marker.color,
          containerStr: "marker",
          cLetter: "c"
        }), a(e, "marker.line") && o(t, e, {
          vals: e.marker.line.color,
          containerStr: "marker.line",
          cLetter: "c"
        }), s(g, e), l(g, e), g;
      };
    }, {
      "../../components/colorscale/calc": 666,
      "../../components/colorscale/helpers": 669,
      "../../plots/cartesian/align_period": 842,
      "../../plots/cartesian/axes": 845,
      "../scatter/calc_selection": 1201,
      "./arrays_to_calcdata": 932
    }],
    935: [function (t, e, r) {
      "use strict";

      e.exports = {
        TEXTPAD: 3,
        eventDataKeys: ["value", "label"]
      };
    }, {}],
    936: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../lib").isArrayOrTypedArray,
          a = t("../../constants/numerical").BADNUM,
          o = t("../../registry"),
          s = t("../../plots/cartesian/axes"),
          l = t("../../plots/cartesian/constraints").getAxisGroup,
          c = t("./sieve.js");

      function u(t, e, r, o, u) {
        if (o.length) {
          var b, _, w, T;

          switch (function (t, e) {
            var r, a;

            for (r = 0; r < e.length; r++) {
              var o,
                  s = e[r],
                  l = s[0].trace,
                  c = "funnel" === l.type ? l._base : l.base,
                  u = "h" === l.orientation ? l.xcalendar : l.ycalendar,
                  f = "category" === t.type || "multicategory" === t.type ? function () {
                return null;
              } : t.d2c;

              if (i(c)) {
                for (a = 0; a < Math.min(c.length, s.length); a++) {
                  o = f(c[a], 0, u), n(o) ? (s[a].b = +o, s[a].hasB = 1) : s[a].b = 0;
                }

                for (; a < s.length; a++) {
                  s[a].b = 0;
                }
              } else {
                o = f(c, 0, u);
                var h = n(o);

                for (o = h ? o : 0, a = 0; a < s.length; a++) {
                  s[a].b = o, h && (s[a].hasB = 1);
                }
              }
            }
          }(r, o), u.mode) {
            case "overlay":
              f(e, r, o, u);
              break;

            case "group":
              for (b = [], _ = [], w = 0; w < o.length; w++) {
                void 0 === (T = o[w])[0].trace.offset ? _.push(T) : b.push(T);
              }

              _.length && function (t, e, r, n, i) {
                var o = new c(n, {
                  sepNegVal: !1,
                  overlapNoMerge: !i.norm
                });
                (function (t, e, r, n) {
                  for (var i = t._fullLayout, a = r.positions, o = r.distinctPositions, s = r.minDiff, c = r.traces, u = c.length, f = a.length !== o.length, h = s * (1 - n.gap), g = l(i, e._id) + c[0][0].trace.orientation, v = i._alignmentOpts[g] || {}, y = 0; y < u; y++) {
                    var x,
                        b,
                        _ = c[y],
                        w = _[0].trace,
                        T = v[w.alignmentgroup] || {},
                        k = Object.keys(T.offsetGroups || {}).length,
                        M = (x = k ? h / k : f ? h / u : h) * (1 - (n.groupgap || 0));
                    b = k ? ((2 * w._offsetIndex + 1 - k) * x - M) / 2 : f ? ((2 * y + 1 - u) * x - M) / 2 : -M / 2;
                    var A = _[0].t;
                    A.barwidth = M, A.poffset = b, A.bargroupwidth = h, A.bardelta = s;
                  }

                  r.binWidth = c[0][0].t.barwidth / 100, p(r), d(e, r), m(e, r, f);
                })(t, e, o, i), function (t) {
                  for (var e = t.traces, r = 0; r < e.length; r++) {
                    var n = e[r];
                    if (void 0 === n[0].trace.base) for (var i = new c([n], {
                      sepNegVal: !0,
                      overlapNoMerge: !0
                    }), o = 0; o < n.length; o++) {
                      var s = n[o];

                      if (s.p !== a) {
                        var l = i.put(s.p, s.b + s.s);
                        l && (s.b = l);
                      }
                    }
                  }
                }(o), i.norm ? (v(o), y(r, o, i)) : g(r, o);
              }(t, e, r, _, u), b.length && f(e, r, b, u);
              break;

            case "stack":
            case "relative":
              for (b = [], _ = [], w = 0; w < o.length; w++) {
                void 0 === (T = o[w])[0].trace.base ? _.push(T) : b.push(T);
              }

              _.length && function (t, e, r, n, i) {
                var o = new c(n, {
                  sepNegVal: "relative" === i.mode,
                  overlapNoMerge: !(i.norm || "stack" === i.mode || "relative" === i.mode)
                });
                h(e, o, i), function (t, e, r) {
                  var n,
                      i,
                      o,
                      l,
                      c,
                      u,
                      f = x(t),
                      h = e.traces;

                  for (l = 0; l < h.length; l++) {
                    if (n = h[l], "funnel" === (i = n[0].trace).type) for (c = 0; c < n.length; c++) {
                      (u = n[c]).s !== a && e.put(u.p, -.5 * u.s);
                    }
                  }

                  for (l = 0; l < h.length; l++) {
                    n = h[l], i = n[0].trace, o = "funnel" === i.type;
                    var p = [];

                    for (c = 0; c < n.length; c++) {
                      if ((u = n[c]).s !== a) {
                        var d;
                        d = o ? u.s : u.s + u.b;
                        var m = e.put(u.p, d),
                            g = m + d;
                        u.b = m, u[f] = g, r.norm || (p.push(g), u.hasB && p.push(m));
                      }
                    }

                    r.norm || (i._extremes[t._id] = s.findExtremes(t, p, {
                      tozero: !0,
                      padded: !0
                    }));
                  }
                }(r, o, i);

                for (var l = 0; l < n.length; l++) {
                  for (var u = n[l], f = 0; f < u.length; f++) {
                    var p = u[f];
                    if (p.s !== a) p.b + p.s === o.get(p.p, p.s) && (p._outmost = !0);
                  }
                }

                i.norm && y(r, o, i);
              }(0, e, r, _, u), b.length && f(e, r, b, u);
          }

          !function (t, e) {
            var r,
                i,
                a,
                o = x(e),
                s = {},
                l = 1 / 0,
                c = -1 / 0;

            for (r = 0; r < t.length; r++) {
              for (a = t[r], i = 0; i < a.length; i++) {
                var u = a[i].p;
                n(u) && (l = Math.min(l, u), c = Math.max(c, u));
              }
            }

            var f = 1e4 / (c - l),
                h = s.round = function (t) {
              return String(Math.round(f * (t - l)));
            };

            for (r = 0; r < t.length; r++) {
              (a = t[r])[0].t.extents = s;
              var p = a[0].t.poffset,
                  d = Array.isArray(p);

              for (i = 0; i < a.length; i++) {
                var m = a[i],
                    g = m[o] - m.w / 2;

                if (n(g)) {
                  var v = m[o] + m.w / 2,
                      y = h(m.p);
                  s[y] ? s[y] = [Math.min(g, s[y][0]), Math.max(v, s[y][1])] : s[y] = [g, v];
                }

                m.p0 = m.p + (d ? p[i] : p), m.p1 = m.p0 + m.w, m.s0 = m.b, m.s1 = m.s0 + m.s;
              }
            }
          }(o, e);
        }
      }

      function f(t, e, r, n) {
        for (var i = 0; i < r.length; i++) {
          var a = r[i],
              o = new c([a], {
            unitMinDiff: n.xCat || n.yCat,
            sepNegVal: !1,
            overlapNoMerge: !n.norm
          });
          h(t, o, n), n.norm ? (v(o), y(e, o, n)) : g(e, o);
        }
      }

      function h(t, e, r) {
        for (var n = e.minDiff, i = e.traces, a = n * (1 - r.gap), o = a * (1 - (r.groupgap || 0)), s = -o / 2, l = 0; l < i.length; l++) {
          var c = i[l][0].t;
          c.barwidth = o, c.poffset = s, c.bargroupwidth = a, c.bardelta = n;
        }

        e.binWidth = i[0][0].t.barwidth / 100, p(e), d(t, e), m(t, e);
      }

      function p(t) {
        var e,
            r,
            a = t.traces;

        for (e = 0; e < a.length; e++) {
          var o,
              s = a[e],
              l = s[0],
              c = l.trace,
              u = l.t,
              f = c._offset || c.offset,
              h = u.poffset;

          if (i(f)) {
            for (o = Array.prototype.slice.call(f, 0, s.length), r = 0; r < o.length; r++) {
              n(o[r]) || (o[r] = h);
            }

            for (r = o.length; r < s.length; r++) {
              o.push(h);
            }

            u.poffset = o;
          } else void 0 !== f && (u.poffset = f);

          var p = c._width || c.width,
              d = u.barwidth;

          if (i(p)) {
            var m = Array.prototype.slice.call(p, 0, s.length);

            for (r = 0; r < m.length; r++) {
              n(m[r]) || (m[r] = d);
            }

            for (r = m.length; r < s.length; r++) {
              m.push(d);
            }

            if (u.barwidth = m, void 0 === f) {
              for (o = [], r = 0; r < s.length; r++) {
                o.push(h + (d - m[r]) / 2);
              }

              u.poffset = o;
            }
          } else void 0 !== p && (u.barwidth = p, void 0 === f && (u.poffset = h + (d - p) / 2));
        }
      }

      function d(t, e) {
        for (var r = e.traces, n = x(t), i = 0; i < r.length; i++) {
          for (var a = r[i], o = a[0].t, s = o.poffset, l = Array.isArray(s), c = o.barwidth, u = Array.isArray(c), f = 0; f < a.length; f++) {
            var h = a[f],
                p = h.w = u ? c[f] : c;
            h[n] = h.p + (l ? s[f] : s) + p / 2;
          }
        }
      }

      function m(t, e, r) {
        var n = e.traces,
            i = e.minDiff / 2;
        s.minDtick(t, e.minDiff, e.distinctPositions[0], r);

        for (var a = 0; a < n.length; a++) {
          var o,
              l,
              c,
              u,
              f = n[a],
              h = f[0],
              p = h.trace,
              d = [];

          for (u = 0; u < f.length; u++) {
            l = (o = f[u]).p - i, c = o.p + i, d.push(l, c);
          }

          if (p.width || p.offset) {
            var m = h.t,
                g = m.poffset,
                v = m.barwidth,
                y = Array.isArray(g),
                x = Array.isArray(v);

            for (u = 0; u < f.length; u++) {
              o = f[u];

              var b = y ? g[u] : g,
                  _ = x ? v[u] : v;

              c = (l = o.p + b) + _, d.push(l, c);
            }
          }

          p._extremes[t._id] = s.findExtremes(t, d, {
            padded: !1
          });
        }
      }

      function g(t, e) {
        for (var r = e.traces, n = x(t), i = 0; i < r.length; i++) {
          for (var a = r[i], o = a[0].trace, l = [], c = !1, u = 0; u < a.length; u++) {
            var f = a[u],
                h = f.b,
                p = h + f.s;
            f[n] = p, l.push(p), f.hasB && l.push(h), f.hasB && f.b || (c = !0);
          }

          o._extremes[t._id] = s.findExtremes(t, l, {
            tozero: c,
            padded: !0
          });
        }
      }

      function v(t) {
        for (var e = t.traces, r = 0; r < e.length; r++) {
          for (var n = e[r], i = 0; i < n.length; i++) {
            var o = n[i];
            o.s !== a && t.put(o.p, o.b + o.s);
          }
        }
      }

      function y(t, e, r) {
        var i = e.traces,
            o = x(t),
            l = "fraction" === r.norm ? 1 : 100,
            c = l / 1e9,
            u = t.l2c(t.c2l(0)),
            f = "stack" === r.mode ? l : u;

        function h(e) {
          return n(t.c2l(e)) && (e < u - c || e > f + c || !n(u));
        }

        for (var p = 0; p < i.length; p++) {
          for (var d = i[p], m = d[0].trace, g = [], v = !1, y = !1, b = 0; b < d.length; b++) {
            var _ = d[b];

            if (_.s !== a) {
              var w = Math.abs(l / e.get(_.p, _.s));
              _.b *= w, _.s *= w;
              var T = _.b,
                  k = T + _.s;
              _[o] = k, g.push(k), y = y || h(k), _.hasB && (g.push(T), y = y || h(T)), _.hasB && _.b || (v = !0);
            }
          }

          m._extremes[t._id] = s.findExtremes(t, g, {
            tozero: v,
            padded: y
          });
        }
      }

      function x(t) {
        return t._id.charAt(0);
      }

      e.exports = {
        crossTraceCalc: function crossTraceCalc(t, e) {
          for (var r = e.xaxis, n = e.yaxis, i = t._fullLayout, a = t._fullData, s = t.calcdata, l = [], c = [], f = 0; f < a.length; f++) {
            var h = a[f];
            if (!0 === h.visible && o.traceIs(h, "bar") && h.xaxis === r._id && h.yaxis === n._id && ("h" === h.orientation ? l.push(s[f]) : c.push(s[f]), h._computePh)) for (var p = t.calcdata[f], d = 0; d < p.length; d++) {
              "function" == typeof p[d].ph0 && (p[d].ph0 = p[d].ph0()), "function" == typeof p[d].ph1 && (p[d].ph1 = p[d].ph1());
            }
          }

          var m = {
            xCat: "category" === r.type || "multicategory" === r.type,
            yCat: "category" === n.type || "multicategory" === n.type,
            mode: i.barmode,
            norm: i.barnorm,
            gap: i.bargap,
            groupgap: i.bargroupgap
          };
          u(t, r, n, c, m), u(t, n, r, l, m);
        },
        setGroupPositions: u
      };
    }, {
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../../plots/cartesian/axes": 845,
      "../../plots/cartesian/constraints": 852,
      "../../registry": 923,
      "./sieve.js": 946,
      "fast-isnumeric": 240
    }],
    937: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../components/color"),
          a = t("../../registry"),
          o = t("../scatter/xy_defaults"),
          s = t("../scatter/period_defaults"),
          l = t("./style_defaults"),
          c = t("../../plots/cartesian/constraints").getAxisGroup,
          u = t("./attributes"),
          f = n.coerceFont;

      function h(t, e, r, n) {
        var i = e.orientation,
            a = e[{
          v: "x",
          h: "y"
        }[i] + "axis"],
            o = c(r, a) + i,
            s = r._alignmentOpts || {},
            l = n("alignmentgroup"),
            u = s[o];
        u || (u = s[o] = {});
        var f = u[l];
        f ? f.traces.push(e) : f = u[l] = {
          traces: [e],
          alignmentIndex: Object.keys(u).length,
          offsetGroups: {}
        };
        var h = n("offsetgroup"),
            p = f.offsetGroups,
            d = p[h];
        h && (d || (d = p[h] = {
          offsetIndex: Object.keys(p).length
        }), e._offsetIndex = d.offsetIndex);
      }

      function p(t, e, r, i, a, o) {
        var s = !(!1 === (o = o || {}).moduleHasSelected),
            l = !(!1 === o.moduleHasUnselected),
            c = !(!1 === o.moduleHasConstrain),
            u = !(!1 === o.moduleHasCliponaxis),
            h = !(!1 === o.moduleHasTextangle),
            p = !(!1 === o.moduleHasInsideanchor),
            d = !!o.hasPathbar,
            m = Array.isArray(a) || "auto" === a,
            g = m || "inside" === a,
            v = m || "outside" === a;

        if (g || v) {
          var y = f(i, "textfont", r.font),
              x = n.extendFlat({}, y),
              b = !(t.textfont && t.textfont.color);

          if (b && delete x.color, f(i, "insidetextfont", x), d) {
            var _ = n.extendFlat({}, y);

            b && delete _.color, f(i, "pathbar.textfont", _);
          }

          v && f(i, "outsidetextfont", y), s && i("selected.textfont.color"), l && i("unselected.textfont.color"), c && i("constraintext"), u && i("cliponaxis"), h && i("textangle"), i("texttemplate");
        }

        g && p && i("insidetextanchor");
      }

      e.exports = {
        supplyDefaults: function supplyDefaults(t, e, r, c) {
          function f(r, i) {
            return n.coerce(t, e, u, r, i);
          }

          if (o(t, e, c, f)) {
            s(t, e, c, f), f("xhoverformat"), f("yhoverformat"), f("orientation", e.x && !e.y ? "h" : "v"), f("base"), f("offset"), f("width"), f("text"), f("hovertext"), f("hovertemplate");
            var h = f("textposition");
            p(t, e, c, f, h, {
              moduleHasSelected: !0,
              moduleHasUnselected: !0,
              moduleHasConstrain: !0,
              moduleHasCliponaxis: !0,
              moduleHasTextangle: !0,
              moduleHasInsideanchor: !0
            }), l(t, e, f, r, c);
            var d = (e.marker.line || {}).color,
                m = a.getComponentMethod("errorbars", "supplyDefaults");
            m(t, e, d || i.defaultLine, {
              axis: "y"
            }), m(t, e, d || i.defaultLine, {
              axis: "x",
              inherit: "y"
            }), n.coerceSelectionMarkerOpacity(e, f);
          } else e.visible = !1;
        },
        crossTraceDefaults: function crossTraceDefaults(t, e) {
          var r;

          function i(t) {
            return n.coerce(r._input, r, u, t);
          }

          if ("group" === e.barmode) for (var a = 0; a < t.length; a++) {
            "bar" === (r = t[a]).type && (r._input, h(0, r, e, i));
          }
        },
        handleGroupingDefaults: h,
        handleText: p
      };
    }, {
      "../../components/color": 658,
      "../../lib": 795,
      "../../plots/cartesian/constraints": 852,
      "../../registry": 923,
      "../scatter/period_defaults": 1219,
      "../scatter/xy_defaults": 1226,
      "./attributes": 933,
      "./style_defaults": 948
    }],
    938: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r) {
        return t.x = "xVal" in e ? e.xVal : e.x, t.y = "yVal" in e ? e.yVal : e.y, e.xa && (t.xaxis = e.xa), e.ya && (t.yaxis = e.ya), "h" === r.orientation ? (t.label = t.y, t.value = t.x) : (t.label = t.x, t.value = t.y), t;
      };
    }, {}],
    939: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("tinycolor2"),
          a = t("../../lib").isArrayOrTypedArray;
      r.coerceString = function (t, e, r) {
        if ("string" == typeof e) {
          if (e || !t.noBlank) return e;
        } else if (("number" == typeof e || !0 === e) && !t.strict) return String(e);

        return void 0 !== r ? r : t.dflt;
      }, r.coerceNumber = function (t, e, r) {
        if (n(e)) {
          e = +e;
          var i = t.min,
              a = t.max;
          if (!(void 0 !== i && e < i || void 0 !== a && e > a)) return e;
        }

        return void 0 !== r ? r : t.dflt;
      }, r.coerceColor = function (t, e, r) {
        return i(e).isValid() ? e : void 0 !== r ? r : t.dflt;
      }, r.coerceEnumerated = function (t, e, r) {
        return t.coerceNumber && (e = +e), -1 !== t.values.indexOf(e) ? e : void 0 !== r ? r : t.dflt;
      }, r.getValue = function (t, e) {
        var r;
        return Array.isArray(t) ? e < t.length && (r = t[e]) : r = t, r;
      }, r.getLineWidth = function (t, e) {
        return 0 < e.mlw ? e.mlw : a(t.marker.line.width) ? 0 : t.marker.line.width;
      };
    }, {
      "../../lib": 795,
      "fast-isnumeric": 240,
      tinycolor2: 590
    }],
    940: [function (t, e, r) {
      "use strict";

      var n = t("../../components/fx"),
          i = t("../../registry"),
          a = t("../../components/color"),
          o = t("../../lib").fillText,
          s = t("./helpers").getLineWidth,
          l = t("../../plots/cartesian/axes").hoverLabelText,
          c = t("../../constants/numerical").BADNUM;

      function u(t, e, r, i, a) {
        var s,
            u,
            f,
            h,
            p,
            d,
            m,
            g = t.cd,
            v = g[0].trace,
            y = g[0].t,
            x = "closest" === i,
            b = "waterfall" === v.type,
            _ = t.maxHoverDistance,
            w = t.maxSpikeDistance;
        "h" === v.orientation ? (s = r, u = e, f = "y", h = "x", p = I, d = C) : (s = e, u = r, f = "x", h = "y", d = I, p = C);
        var T = v[f + "period"];

        function k(t) {
          return A(t, -1);
        }

        function M(t) {
          return A(t, 1);
        }

        function A(t, e) {
          return T ? t.p + e * Math.abs(t.p - t.orig_p) : t[f] + e * t.w / 2;
        }

        var S = x || T ? k : function (t) {
          return Math.min(k(t), t.p - y.bardelta / 2);
        },
            E = x || T ? M : function (t) {
          return Math.max(M(t), t.p + y.bardelta / 2);
        };

        function L(t, e, r) {
          return a.finiteRange && (r = 0), n.inbox(t - s, e - s, r + Math.min(1, Math.abs(e - t) / m) - 1);
        }

        function C(t) {
          return L(S(t), E(t), _);
        }

        function P(t) {
          var e = t[h];

          if (b) {
            var r = Math.abs(t.rawS) || 0;
            u > 0 ? e += r : u < 0 && (e -= r);
          }

          return e;
        }

        function I(t) {
          var e = u,
              r = t.b,
              i = P(t);
          return n.inbox(r - e, i - e, _ + (i - e) / (i - r) - 1);
        }

        var O = t[f + "a"],
            z = t[h + "a"];
        m = Math.abs(O.r2c(O.range[1]) - O.r2c(O.range[0]));
        var D = n.getDistanceFunction(i, p, d, function (t) {
          return (p(t) + d(t)) / 2;
        });

        if (n.getClosest(g, D, t), !1 !== t.index && g[t.index].p !== c) {
          x || (S = function S(t) {
            return Math.min(k(t), t.p - y.bargroupwidth / 2);
          }, E = function E(t) {
            return Math.max(M(t), t.p + y.bargroupwidth / 2);
          });
          var R = g[t.index],
              F = v.base ? R.b + R.s : R.s;
          t[h + "0"] = t[h + "1"] = z.c2p(R[h], !0), t[h + "LabelVal"] = F;
          var B = y.extents[y.extents.round(R.p)];
          t[f + "0"] = O.c2p(x ? S(R) : B[0], !0), t[f + "1"] = O.c2p(x ? E(R) : B[1], !0);
          var N = void 0 !== R.orig_p;
          return t[f + "LabelVal"] = N ? R.orig_p : R.p, t.labelLabel = l(O, t[f + "LabelVal"], v[f + "hoverformat"]), t.valueLabel = l(z, t[h + "LabelVal"], v[h + "hoverformat"]), t.baseLabel = l(z, R.b, v[h + "hoverformat"]), t.spikeDistance = (function (t) {
            var e = u,
                r = t.b,
                i = P(t);
            return n.inbox(r - e, i - e, w + (i - e) / (i - r) - 1);
          }(R) + function (t) {
            return L(k(t), M(t), w);
          }(R)) / 2, t[f + "Spike"] = O.c2p(R.p, !0), o(R, v, t), t.hovertemplate = v.hovertemplate, t;
        }
      }

      function f(t, e) {
        var r = e.mcc || t.marker.color,
            n = e.mlcc || t.marker.line.color,
            i = s(t, e);
        return a.opacity(r) ? r : a.opacity(n) && i ? n : void 0;
      }

      e.exports = {
        hoverPoints: function hoverPoints(t, e, r, n, a) {
          var o = u(t, e, r, n, a);

          if (o) {
            var s = o.cd,
                l = s[0].trace,
                c = s[o.index];
            return o.color = f(l, c), i.getComponentMethod("errorbars", "hoverInfo")(c, l, o), [o];
          }
        },
        hoverOnBars: u,
        getTraceColor: f
      };
    }, {
      "../../components/color": 658,
      "../../components/fx": 698,
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../../plots/cartesian/axes": 845,
      "../../registry": 923,
      "./helpers": 939
    }],
    941: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        layoutAttributes: t("./layout_attributes"),
        supplyDefaults: t("./defaults").supplyDefaults,
        crossTraceDefaults: t("./defaults").crossTraceDefaults,
        supplyLayoutDefaults: t("./layout_defaults"),
        calc: t("./calc"),
        crossTraceCalc: t("./cross_trace_calc").crossTraceCalc,
        colorbar: t("../scatter/marker_colorbar"),
        arraysToCalcdata: t("./arrays_to_calcdata"),
        plot: t("./plot").plot,
        style: t("./style").style,
        styleOnSelect: t("./style").styleOnSelect,
        hoverPoints: t("./hover").hoverPoints,
        eventData: t("./event_data"),
        selectPoints: t("./select"),
        moduleType: "trace",
        name: "bar",
        basePlotModule: t("../../plots/cartesian"),
        categories: ["bar-like", "cartesian", "svg", "bar", "oriented", "errorBarsOK", "showLegend", "zoomScale"],
        animatable: !0,
        meta: {}
      };
    }, {
      "../../plots/cartesian": 858,
      "../scatter/marker_colorbar": 1217,
      "./arrays_to_calcdata": 932,
      "./attributes": 933,
      "./calc": 934,
      "./cross_trace_calc": 936,
      "./defaults": 937,
      "./event_data": 938,
      "./hover": 940,
      "./layout_attributes": 942,
      "./layout_defaults": 943,
      "./plot": 944,
      "./select": 945,
      "./style": 947
    }],
    942: [function (t, e, r) {
      "use strict";

      e.exports = {
        barmode: {
          valType: "enumerated",
          values: ["stack", "group", "overlay", "relative"],
          dflt: "group",
          editType: "calc"
        },
        barnorm: {
          valType: "enumerated",
          values: ["", "fraction", "percent"],
          dflt: "",
          editType: "calc"
        },
        bargap: {
          valType: "number",
          min: 0,
          max: 1,
          editType: "calc"
        },
        bargroupgap: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 0,
          editType: "calc"
        }
      };
    }, {}],
    943: [function (t, e, r) {
      "use strict";

      var n = t("../../registry"),
          i = t("../../plots/cartesian/axes"),
          a = t("../../lib"),
          o = t("./layout_attributes");

      e.exports = function (t, e, r) {
        function s(r, n) {
          return a.coerce(t, e, o, r, n);
        }

        for (var l = !1, c = !1, u = !1, f = {}, h = s("barmode"), p = 0; p < r.length; p++) {
          var d = r[p];

          if (n.traceIs(d, "bar") && d.visible) {
            if (l = !0, "group" === h) {
              var m = d.xaxis + d.yaxis;
              f[m] && (u = !0), f[m] = !0;
            }

            if (d.visible && "histogram" === d.type) "category" !== i.getFromId({
              _fullLayout: e
            }, d["v" === d.orientation ? "xaxis" : "yaxis"]).type && (c = !0);
          }
        }

        l ? ("overlay" !== h && s("barnorm"), s("bargap", c && !u ? 0 : .2), s("bargroupgap")) : delete e.barmode;
      };
    }, {
      "../../lib": 795,
      "../../plots/cartesian/axes": 845,
      "../../registry": 923,
      "./layout_attributes": 942
    }],
    944: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("fast-isnumeric"),
          a = t("../../lib"),
          o = t("../../lib/svg_text_utils"),
          s = t("../../components/color"),
          l = t("../../components/drawing"),
          c = t("../../registry"),
          u = t("../../plots/cartesian/axes").tickText,
          f = t("./uniform_text"),
          h = f.recordMinTextSize,
          p = f.clearMinTextSize,
          d = t("./style"),
          m = t("./helpers"),
          g = t("./constants"),
          v = t("./attributes"),
          y = v.text,
          x = v.textposition,
          b = t("../../components/fx/helpers").appendArrayPointValue,
          _ = g.TEXTPAD;

      function w(t) {
        return t.id;
      }

      function T(t) {
        if (t.ids) return w;
      }

      function k(t, e) {
        return t < e ? 1 : -1;
      }

      function M(t, e, r, n) {
        var i;
        return !e.uniformtext.mode && A(r) ? (n && (i = n()), t.transition().duration(r.duration).ease(r.easing).each("end", function () {
          i && i();
        }).each("interrupt", function () {
          i && i();
        })) : t;
      }

      function A(t) {
        return t && t.duration > 0;
      }

      function S(t) {
        return "auto" === t ? 0 : t;
      }

      function E(t, e) {
        var r = Math.PI / 180 * e,
            n = Math.abs(Math.sin(r)),
            i = Math.abs(Math.cos(r));
        return {
          x: t.width * i + t.height * n,
          y: t.width * n + t.height * i
        };
      }

      function L(t, e, r, n, i, a) {
        var o = !!a.isHorizontal,
            s = !!a.constrained,
            l = a.angle || 0,
            c = a.anchor || "end",
            u = "end" === c,
            f = "start" === c,
            h = ((a.leftToRight || 0) + 1) / 2,
            p = 1 - h,
            d = i.width,
            m = i.height,
            g = Math.abs(e - t),
            v = Math.abs(n - r),
            y = g > 2 * _ && v > 2 * _ ? _ : 0;
        g -= 2 * y, v -= 2 * y;
        var x = S(l);
        "auto" !== l || d <= g && m <= v || !(d > g || m > v) || (d > v || m > g) && d < m == g < v || (x += 90);
        var b = E(i, x),
            w = 1;
        s && (w = Math.min(1, g / b.x, v / b.y));
        var T = i.left * p + i.right * h,
            M = (i.top + i.bottom) / 2,
            A = (t + _) * p + (e - _) * h,
            L = (r + n) / 2,
            C = 0,
            P = 0;

        if (f || u) {
          var I = (o ? b.x : b.y) / 2,
              O = o ? k(t, e) : k(r, n);
          o ? f ? (A = t + O * y, C = -O * I) : (A = e - O * y, C = O * I) : f ? (L = r + O * y, P = -O * I) : (L = n - O * y, P = O * I);
        }

        return {
          textX: T,
          textY: M,
          targetX: A,
          targetY: L,
          anchorX: C,
          anchorY: P,
          scale: w,
          rotate: x
        };
      }

      e.exports = {
        plot: function plot(t, e, r, f, g, v) {
          var w = e.xaxis,
              C = e.yaxis,
              P = t._fullLayout;
          g || (g = {
            mode: P.barmode,
            norm: P.barmode,
            gap: P.bargap,
            groupgap: P.bargroupgap
          }, p("bar", P));
          var I = a.makeTraceGroups(f, r, "trace bars").each(function (r) {
            var c = n.select(this),
                f = r[0].trace,
                p = "waterfall" === f.type,
                I = "funnel" === f.type,
                O = "bar" === f.type || I,
                z = 0;
            p && f.connector.visible && "between" === f.connector.mode && (z = f.connector.line.width / 2);
            var D = "h" === f.orientation,
                R = A(g),
                F = a.ensureSingle(c, "g", "points"),
                B = T(f),
                N = F.selectAll("g.point").data(a.identity, B);
            N.enter().append("g").classed("point", !0), N.exit().remove(), N.each(function (c, p) {
              var T,
                  A,
                  I = n.select(this),
                  F = function (t, e, r, n) {
                var i = [],
                    a = [],
                    o = n ? e : r,
                    s = n ? r : e;
                return i[0] = o.c2p(t.s0, !0), a[0] = s.c2p(t.p0, !0), i[1] = o.c2p(t.s1, !0), a[1] = s.c2p(t.p1, !0), n ? [i, a] : [a, i];
              }(c, w, C, D),
                  B = F[0][0],
                  N = F[0][1],
                  j = F[1][0],
                  U = F[1][1],
                  V = 0 == (D ? N - B : U - j);

              if (V && O && m.getLineWidth(f, c) && (V = !1), V || (V = !(i(B) && i(N) && i(j) && i(U))), c.isBlank = V, V && (D ? N = B : U = j), z && !V && (D ? (B -= k(B, N) * z, N += k(B, N) * z) : (j -= k(j, U) * z, U += k(j, U) * z)), "waterfall" === f.type) {
                if (!V) {
                  var q = f[c.dir].marker;
                  T = q.line.width, A = q.color;
                }
              } else T = m.getLineWidth(f, c), A = c.mc || f.marker.color;

              function H(t) {
                var e = n.round(T / 2 % 1, 2);
                return 0 === g.gap && 0 === g.groupgap ? n.round(Math.round(t) - e, 2) : t;
              }

              if (!t._context.staticPlot) {
                var G = s.opacity(A) < 1 || T > .01 ? H : function (t, e, r) {
                  return r && t === e ? t : Math.abs(t - e) >= 2 ? H(t) : t > e ? Math.ceil(t) : Math.floor(t);
                };
                B = G(B, N, D), N = G(N, B, D), j = G(j, U, !D), U = G(U, j, !D);
              }

              var Y = M(a.ensureSingle(I, "path"), P, g, v);

              if (Y.style("vector-effect", "non-scaling-stroke").attr("d", isNaN((N - B) * (U - j)) || V && t._context.staticPlot ? "M0,0Z" : "M" + B + "," + j + "V" + U + "H" + N + "V" + j + "Z").call(l.setClipUrl, e.layerClipId, t), !P.uniformtext.mode && R) {
                var W = l.makePointStyleFns(f);
                l.singlePointStyle(c, Y, f, W, t);
              }

              !function (t, e, r, n, i, s, c, f, p, g, v) {
                var w,
                    T = e.xaxis,
                    A = e.yaxis,
                    C = t._fullLayout;

                function P(e, r, n) {
                  return a.ensureSingle(e, "text").text(r).attr({
                    class: "bartext bartext-" + w,
                    "text-anchor": "middle",
                    "data-notex": 1
                  }).call(l.font, n).call(o.convertToTspans, t);
                }

                var I = n[0].trace,
                    O = "h" === I.orientation,
                    z = function (t, e, r, n, i) {
                  var o,
                      s = e[0].trace;
                  o = s.texttemplate ? function (t, e, r, n, i) {
                    var o = e[0].trace,
                        s = a.castOption(o, r, "texttemplate");
                    if (!s) return "";
                    var l,
                        c,
                        f,
                        h,
                        p = "waterfall" === o.type,
                        d = "funnel" === o.type;
                    "h" === o.orientation ? (l = "y", c = i, f = "x", h = n) : (l = "x", c = n, f = "y", h = i);

                    function m(t) {
                      return u(h, h.c2l(t), !0).text;
                    }

                    var g = e[r],
                        v = {};
                    v.label = g.p, v.labelLabel = v[l + "Label"] = (y = g.p, u(c, c.c2l(y), !0).text);
                    var y;
                    var x = a.castOption(o, g.i, "text");
                    (0 === x || x) && (v.text = x);
                    v.value = g.s, v.valueLabel = v[f + "Label"] = m(g.s);
                    var _ = {};
                    b(_, o, g.i), p && (v.delta = +g.rawS || g.s, v.deltaLabel = m(v.delta), v.final = g.v, v.finalLabel = m(v.final), v.initial = v.final - v.delta, v.initialLabel = m(v.initial));
                    d && (v.value = g.s, v.valueLabel = m(v.value), v.percentInitial = g.begR, v.percentInitialLabel = a.formatPercent(g.begR), v.percentPrevious = g.difR, v.percentPreviousLabel = a.formatPercent(g.difR), v.percentTotal = g.sumR, v.percenTotalLabel = a.formatPercent(g.sumR));
                    var w = a.castOption(o, g.i, "customdata");
                    w && (v.customdata = w);
                    return a.texttemplateString(s, v, t._d3locale, _, v, o._meta || {});
                  }(t, e, r, n, i) : s.textinfo ? function (t, e, r, n) {
                    var i = t[0].trace,
                        o = "h" === i.orientation,
                        s = "waterfall" === i.type,
                        l = "funnel" === i.type;

                    function c(t) {
                      return u(o ? r : n, +t, !0).text;
                    }

                    var f,
                        h = i.textinfo,
                        p = t[e],
                        d = h.split("+"),
                        m = [],
                        g = function g(t) {
                      return -1 !== d.indexOf(t);
                    };

                    g("label") && m.push((v = t[e].p, u(o ? n : r, v, !0).text));
                    var v;
                    g("text") && (0 === (f = a.castOption(i, p.i, "text")) || f) && m.push(f);

                    if (s) {
                      var y = +p.rawS || p.s,
                          x = p.v,
                          b = x - y;
                      g("initial") && m.push(c(b)), g("delta") && m.push(c(y)), g("final") && m.push(c(x));
                    }

                    if (l) {
                      g("value") && m.push(c(p.s));
                      var _ = 0;
                      g("percent initial") && _++, g("percent previous") && _++, g("percent total") && _++;
                      var w = _ > 1;
                      g("percent initial") && (f = a.formatPercent(p.begR), w && (f += " of initial"), m.push(f)), g("percent previous") && (f = a.formatPercent(p.difR), w && (f += " of previous"), m.push(f)), g("percent total") && (f = a.formatPercent(p.sumR), w && (f += " of total"), m.push(f));
                    }

                    return m.join("<br>");
                  }(e, r, n, i) : m.getValue(s.text, r);
                  return m.coerceString(y, o);
                }(C, n, i, T, A);

                w = function (t, e) {
                  var r = m.getValue(t.textposition, e);
                  return m.coerceEnumerated(x, r);
                }(I, i);

                var D = "stack" === g.mode || "relative" === g.mode,
                    R = n[i],
                    F = !D || R._outmost;
                if (!z || "none" === w || (R.isBlank || s === c || f === p) && ("auto" === w || "inside" === w)) return void r.select("text").remove();
                var B = C.font,
                    N = d.getBarColor(n[i], I),
                    j = d.getInsideTextFont(I, i, B, N),
                    U = d.getOutsideTextFont(I, i, B),
                    V = r.datum();
                O ? "log" === T.type && V.s0 <= 0 && (s = T.range[0] < T.range[1] ? 0 : T._length) : "log" === A.type && V.s0 <= 0 && (f = A.range[0] < A.range[1] ? A._length : 0);

                var q,
                    H,
                    G,
                    Y,
                    W,
                    X = Math.abs(c - s) - 2 * _,
                    Z = Math.abs(p - f) - 2 * _;

                "outside" === w && (F || R.hasB || (w = "inside"));
                if ("auto" === w) if (F) {
                  w = "inside", W = a.ensureUniformFontSize(t, j), q = P(r, z, W), H = l.bBox(q.node()), G = H.width, Y = H.height;
                  var J = G <= X && Y <= Z,
                      K = G <= Z && Y <= X,
                      Q = O ? X >= G * (Z / Y) : Z >= Y * (X / G);
                  G > 0 && Y > 0 && (J || K || Q) ? w = "inside" : (w = "outside", q.remove(), q = null);
                } else w = "inside";

                if (!q) {
                  W = a.ensureUniformFontSize(t, "outside" === w ? U : j);
                  var $ = (q = P(r, z, W)).attr("transform");
                  if (q.attr("transform", ""), H = l.bBox(q.node()), G = H.width, Y = H.height, q.attr("transform", $), G <= 0 || Y <= 0) return void q.remove();
                }

                var tt,
                    et,
                    rt = I.textangle;
                "outside" === w ? (et = "both" === I.constraintext || "outside" === I.constraintext, tt = function (t, e, r, n, i, a) {
                  var o,
                      s = !!a.isHorizontal,
                      l = !!a.constrained,
                      c = a.angle || 0,
                      u = i.width,
                      f = i.height,
                      h = Math.abs(e - t),
                      p = Math.abs(n - r);
                  o = s ? p > 2 * _ ? _ : 0 : h > 2 * _ ? _ : 0;
                  var d = 1;
                  l && (d = s ? Math.min(1, p / f) : Math.min(1, h / u));
                  var m = S(c),
                      g = E(i, m),
                      v = (s ? g.x : g.y) / 2,
                      y = (i.left + i.right) / 2,
                      x = (i.top + i.bottom) / 2,
                      b = (t + e) / 2,
                      w = (r + n) / 2,
                      T = 0,
                      M = 0,
                      A = s ? k(e, t) : k(r, n);
                  s ? (b = e - A * o, T = A * v) : (w = n + A * o, M = -A * v);
                  return {
                    textX: y,
                    textY: x,
                    targetX: b,
                    targetY: w,
                    anchorX: T,
                    anchorY: M,
                    scale: d,
                    rotate: m
                  };
                }(s, c, f, p, H, {
                  isHorizontal: O,
                  constrained: et,
                  angle: rt
                })) : (et = "both" === I.constraintext || "inside" === I.constraintext, tt = L(s, c, f, p, H, {
                  isHorizontal: O,
                  constrained: et,
                  angle: rt,
                  anchor: I.insidetextanchor
                }));
                tt.fontSize = W.size, h(I.type, tt, C), R.transform = tt, M(q, C, g, v).attr("transform", a.getTextTransform(tt));
              }(t, e, I, r, p, B, N, j, U, g, v), e.layerClipId && l.hideOutsideRangePoint(c, I.select("text"), w, C, f.xcalendar, f.ycalendar);
            });
            var j = !1 === f.cliponaxis;
            l.setClipUrl(c, j ? null : e.layerClipId, t);
          });
          c.getComponentMethod("errorbars", "plot")(t, I, e, g);
        },
        toMoveInsideBar: L
      };
    }, {
      "../../components/color": 658,
      "../../components/drawing": 680,
      "../../components/fx/helpers": 694,
      "../../lib": 795,
      "../../lib/svg_text_utils": 820,
      "../../plots/cartesian/axes": 845,
      "../../registry": 923,
      "./attributes": 933,
      "./constants": 935,
      "./helpers": 939,
      "./style": 947,
      "./uniform_text": 949,
      "@plotly/d3": 57,
      "fast-isnumeric": 240
    }],
    945: [function (t, e, r) {
      "use strict";

      function n(t, e, r, n, i) {
        var a = e.c2p(n ? t.s0 : t.p0, !0),
            o = e.c2p(n ? t.s1 : t.p1, !0),
            s = r.c2p(n ? t.p0 : t.s0, !0),
            l = r.c2p(n ? t.p1 : t.s1, !0);
        return i ? [(a + o) / 2, (s + l) / 2] : n ? [o, (s + l) / 2] : [(a + o) / 2, l];
      }

      e.exports = function (t, e) {
        var r,
            i = t.cd,
            a = t.xaxis,
            o = t.yaxis,
            s = i[0].trace,
            l = "funnel" === s.type,
            c = "h" === s.orientation,
            u = [];
        if (!1 === e) for (r = 0; r < i.length; r++) {
          i[r].selected = 0;
        } else for (r = 0; r < i.length; r++) {
          var f = i[r],
              h = "ct" in f ? f.ct : n(f, a, o, c, l);
          e.contains(h, !1, r, t) ? (u.push({
            pointNumber: r,
            x: a.c2d(f.x),
            y: o.c2d(f.y)
          }), f.selected = 1) : f.selected = 0;
        }
        return u;
      };
    }, {}],
    946: [function (t, e, r) {
      "use strict";

      e.exports = a;
      var n = t("../../lib").distinctVals,
          i = t("../../constants/numerical").BADNUM;

      function a(t, e) {
        this.traces = t, this.sepNegVal = e.sepNegVal, this.overlapNoMerge = e.overlapNoMerge;

        for (var r = 1 / 0, a = [], o = 0; o < t.length; o++) {
          for (var s = t[o], l = 0; l < s.length; l++) {
            var c = s[l];
            c.p !== i && a.push(c.p);
          }

          s[0] && s[0].width1 && (r = Math.min(s[0].width1, r));
        }

        this.positions = a;
        var u = n(a, {
          unitMinDiff: e.unitMinDiff
        });
        this.distinctPositions = u.vals, 1 === u.vals.length && r !== 1 / 0 ? this.minDiff = r : this.minDiff = Math.min(u.minDiff, r), this.binWidth = this.minDiff, this.bins = {};
      }

      a.prototype.put = function (t, e) {
        var r = this.getLabel(t, e),
            n = this.bins[r] || 0;
        return this.bins[r] = n + e, n;
      }, a.prototype.get = function (t, e) {
        var r = this.getLabel(t, e);
        return this.bins[r] || 0;
      }, a.prototype.getLabel = function (t, e) {
        return (e < 0 && this.sepNegVal ? "v" : "^") + (this.overlapNoMerge ? t : Math.round(t / this.binWidth));
      };
    }, {
      "../../constants/numerical": 771,
      "../../lib": 795
    }],
    947: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../components/color"),
          a = t("../../components/drawing"),
          o = t("../../lib"),
          s = t("../../registry"),
          l = t("./uniform_text").resizeText,
          c = t("./attributes"),
          u = c.textfont,
          f = c.insidetextfont,
          h = c.outsidetextfont,
          p = t("./helpers");

      function d(t, e, r) {
        a.pointStyle(t.selectAll("path"), e, r), m(t, e, r);
      }

      function m(t, e, r) {
        t.selectAll("text").each(function (t) {
          var i = n.select(this),
              s = o.ensureUniformFontSize(r, g(i, t, e, r));
          a.font(i, s);
        });
      }

      function g(t, e, r, n) {
        var i = n._fullLayout.font,
            a = r.textfont;

        if (t.classed("bartext-inside")) {
          var o = _(e, r);

          a = y(r, e.i, i, o);
        } else t.classed("bartext-outside") && (a = x(r, e.i, i));

        return a;
      }

      function v(t, e, r) {
        return b(u, t.textfont, e, r);
      }

      function y(t, e, r, n) {
        var a = v(t, e, r);
        return (void 0 === t._input.textfont || void 0 === t._input.textfont.color || Array.isArray(t.textfont.color) && void 0 === t.textfont.color[e]) && (a = {
          color: i.contrast(n),
          family: a.family,
          size: a.size
        }), b(f, t.insidetextfont, e, a);
      }

      function x(t, e, r) {
        var n = v(t, e, r);
        return b(h, t.outsidetextfont, e, n);
      }

      function b(t, e, r, n) {
        e = e || {};
        var i = p.getValue(e.family, r),
            a = p.getValue(e.size, r),
            o = p.getValue(e.color, r);
        return {
          family: p.coerceString(t.family, i, n.family),
          size: p.coerceNumber(t.size, a, n.size),
          color: p.coerceColor(t.color, o, n.color)
        };
      }

      function _(t, e) {
        return "waterfall" === e.type ? e[t.dir].marker.color : t.mcc || t.mc || e.marker.color;
      }

      e.exports = {
        style: function style(t) {
          var e = n.select(t).selectAll("g.barlayer").selectAll("g.trace");
          l(t, e, "bar");
          var r = e.size(),
              i = t._fullLayout;
          e.style("opacity", function (t) {
            return t[0].trace.opacity;
          }).each(function (t) {
            ("stack" === i.barmode && r > 1 || 0 === i.bargap && 0 === i.bargroupgap && !t[0].trace.marker.line.width) && n.select(this).attr("shape-rendering", "crispEdges");
          }), e.selectAll("g.points").each(function (e) {
            d(n.select(this), e[0].trace, t);
          }), s.getComponentMethod("errorbars", "style")(e);
        },
        styleTextPoints: m,
        styleOnSelect: function styleOnSelect(t, e, r) {
          var i = e[0].trace;
          i.selectedpoints ? function (t, e, r) {
            a.selectedPointStyle(t.selectAll("path"), e), function (t, e, r) {
              t.each(function (t) {
                var i,
                    s = n.select(this);

                if (t.selected) {
                  i = o.ensureUniformFontSize(r, g(s, t, e, r));
                  var l = e.selected.textfont && e.selected.textfont.color;
                  l && (i.color = l), a.font(s, i);
                } else a.selectedTextStyle(s, e);
              });
            }(t.selectAll("text"), e, r);
          }(r, i, t) : (d(r, i, t), s.getComponentMethod("errorbars", "style")(r));
        },
        getInsideTextFont: y,
        getOutsideTextFont: x,
        getBarColor: _,
        resizeText: l
      };
    }, {
      "../../components/color": 658,
      "../../components/drawing": 680,
      "../../lib": 795,
      "../../registry": 923,
      "./attributes": 933,
      "./helpers": 939,
      "./uniform_text": 949,
      "@plotly/d3": 57
    }],
    948: [function (t, e, r) {
      "use strict";

      var n = t("../../components/color"),
          i = t("../../components/colorscale/helpers").hasColorscale,
          a = t("../../components/colorscale/defaults"),
          o = t("../../lib").coercePattern;

      e.exports = function (t, e, r, s, l) {
        r("marker.color", s), i(t, "marker") && a(t, e, l, r, {
          prefix: "marker.",
          cLetter: "c"
        }), r("marker.line.color", n.defaultLine), i(t, "marker.line") && a(t, e, l, r, {
          prefix: "marker.line.",
          cLetter: "c"
        }), r("marker.line.width"), r("marker.opacity"), o(r, "marker.pattern"), r("selected.marker.color"), r("unselected.marker.color");
      };
    }, {
      "../../components/color": 658,
      "../../components/colorscale/defaults": 668,
      "../../components/colorscale/helpers": 669,
      "../../lib": 795
    }],
    949: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../lib");

      function a(t) {
        return "_" + t + "Text_minsize";
      }

      e.exports = {
        recordMinTextSize: function recordMinTextSize(t, e, r) {
          if (r.uniformtext.mode) {
            var n = a(t),
                i = r.uniformtext.minsize,
                o = e.scale * e.fontSize;
            e.hide = o < i, r[n] = r[n] || 1 / 0, e.hide || (r[n] = Math.min(r[n], Math.max(o, i)));
          }
        },
        clearMinTextSize: function clearMinTextSize(t, e) {
          e[a(t)] = void 0;
        },
        resizeText: function resizeText(t, e, r) {
          var a = t._fullLayout,
              o = a["_" + r + "Text_minsize"];

          if (o) {
            var s,
                l = "hide" === a.uniformtext.mode;

            switch (r) {
              case "funnelarea":
              case "pie":
              case "sunburst":
                s = "g.slice";
                break;

              case "treemap":
                s = "g.slice, g.pathbar";
                break;

              default:
                s = "g.points > g.point";
            }

            e.selectAll(s).each(function (t) {
              var e = t.transform;
              e && (e.scale = l && e.hide ? 0 : o / e.fontSize, n.select(this).select("text").attr("transform", i.getTextTransform(e)));
            });
          }
        }
      };
    }, {
      "../../lib": 795,
      "@plotly/d3": 57
    }],
    950: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/template_attributes").hovertemplateAttrs,
          i = t("../../lib/extend").extendFlat,
          a = t("../scatterpolar/attributes"),
          o = t("../bar/attributes");
      e.exports = {
        r: a.r,
        theta: a.theta,
        r0: a.r0,
        dr: a.dr,
        theta0: a.theta0,
        dtheta: a.dtheta,
        thetaunit: a.thetaunit,
        base: i({}, o.base, {}),
        offset: i({}, o.offset, {}),
        width: i({}, o.width, {}),
        text: i({}, o.text, {}),
        hovertext: i({}, o.hovertext, {}),
        marker: o.marker,
        hoverinfo: a.hoverinfo,
        hovertemplate: n(),
        selected: o.selected,
        unselected: o.unselected
      };
    }, {
      "../../lib/extend": 785,
      "../../plots/template_attributes": 918,
      "../bar/attributes": 933,
      "../scatterpolar/attributes": 1273
    }],
    951: [function (t, e, r) {
      "use strict";

      var n = t("../../components/colorscale/helpers").hasColorscale,
          i = t("../../components/colorscale/calc"),
          a = t("../bar/arrays_to_calcdata"),
          o = t("../bar/cross_trace_calc").setGroupPositions,
          s = t("../scatter/calc_selection"),
          l = t("../../registry").traceIs,
          c = t("../../lib").extendFlat;
      e.exports = {
        calc: function calc(t, e) {
          for (var r = t._fullLayout, o = e.subplot, l = r[o].radialaxis, c = r[o].angularaxis, u = l.makeCalcdata(e, "r"), f = c.makeCalcdata(e, "theta"), h = e._length, p = new Array(h), d = u, m = f, g = 0; g < h; g++) {
            p[g] = {
              p: m[g],
              s: d[g]
            };
          }

          function v(t) {
            var r = e[t];
            void 0 !== r && (e["_" + t] = Array.isArray(r) ? c.makeCalcdata(e, t) : c.d2c(r, e.thetaunit));
          }

          return "linear" === c.type && (v("width"), v("offset")), n(e, "marker") && i(t, e, {
            vals: e.marker.color,
            containerStr: "marker",
            cLetter: "c"
          }), n(e, "marker.line") && i(t, e, {
            vals: e.marker.line.color,
            containerStr: "marker.line",
            cLetter: "c"
          }), a(p, e), s(p, e), p;
        },
        crossTraceCalc: function crossTraceCalc(t, e, r) {
          for (var n = t.calcdata, i = [], a = 0; a < n.length; a++) {
            var s = n[a],
                u = s[0].trace;
            !0 === u.visible && l(u, "bar") && u.subplot === r && i.push(s);
          }

          var f = c({}, e.radialaxis, {
            _id: "x"
          }),
              h = e.angularaxis;
          o(t, h, f, i, {
            mode: e.barmode,
            norm: e.barnorm,
            gap: e.bargap,
            groupgap: e.bargroupgap
          });
        }
      };
    }, {
      "../../components/colorscale/calc": 666,
      "../../components/colorscale/helpers": 669,
      "../../lib": 795,
      "../../registry": 923,
      "../bar/arrays_to_calcdata": 932,
      "../bar/cross_trace_calc": 936,
      "../scatter/calc_selection": 1201
    }],
    952: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../scatterpolar/defaults").handleRThetaDefaults,
          a = t("../bar/style_defaults"),
          o = t("./attributes");

      e.exports = function (t, e, r, s) {
        function l(r, i) {
          return n.coerce(t, e, o, r, i);
        }

        i(t, e, s, l) ? (l("thetaunit"), l("base"), l("offset"), l("width"), l("text"), l("hovertext"), l("hovertemplate"), a(t, e, l, r, s), n.coerceSelectionMarkerOpacity(e, l)) : e.visible = !1;
      };
    }, {
      "../../lib": 795,
      "../bar/style_defaults": 948,
      "../scatterpolar/defaults": 1275,
      "./attributes": 950
    }],
    953: [function (t, e, r) {
      "use strict";

      var n = t("../../components/fx"),
          i = t("../../lib"),
          a = t("../bar/hover").getTraceColor,
          o = i.fillText,
          s = t("../scatterpolar/hover").makeHoverPointText,
          l = t("../../plots/polar/helpers").isPtInsidePolygon;

      e.exports = function (t, e, r) {
        var c = t.cd,
            u = c[0].trace,
            f = t.subplot,
            h = f.radialAxis,
            p = f.angularAxis,
            d = f.vangles,
            m = d ? l : i.isPtInsideSector,
            g = t.maxHoverDistance,
            v = p._period || 2 * Math.PI,
            y = Math.abs(h.g2p(Math.sqrt(e * e + r * r))),
            x = Math.atan2(r, e);
        h.range[0] > h.range[1] && (x += Math.PI);

        if (n.getClosest(c, function (t) {
          return m(y, x, [t.rp0, t.rp1], [t.thetag0, t.thetag1], d) ? g + Math.min(1, Math.abs(t.thetag1 - t.thetag0) / v) - 1 + (t.rp1 - y) / (t.rp1 - t.rp0) - 1 : 1 / 0;
        }, t), !1 !== t.index) {
          var b = c[t.index];
          t.x0 = t.x1 = b.ct[0], t.y0 = t.y1 = b.ct[1];

          var _ = i.extendFlat({}, b, {
            r: b.s,
            theta: b.p
          });

          return o(b, u, t), s(_, u, f, t), t.hovertemplate = u.hovertemplate, t.color = a(u, b), t.xLabelVal = t.yLabelVal = void 0, b.s < 0 && (t.idealAlign = "left"), [t];
        }
      };
    }, {
      "../../components/fx": 698,
      "../../lib": 795,
      "../../plots/polar/helpers": 911,
      "../bar/hover": 940,
      "../scatterpolar/hover": 1277
    }],
    954: [function (t, e, r) {
      "use strict";

      e.exports = {
        moduleType: "trace",
        name: "barpolar",
        basePlotModule: t("../../plots/polar"),
        categories: ["polar", "bar", "showLegend"],
        attributes: t("./attributes"),
        layoutAttributes: t("./layout_attributes"),
        supplyDefaults: t("./defaults"),
        supplyLayoutDefaults: t("./layout_defaults"),
        calc: t("./calc").calc,
        crossTraceCalc: t("./calc").crossTraceCalc,
        plot: t("./plot"),
        colorbar: t("../scatter/marker_colorbar"),
        formatLabels: t("../scatterpolar/format_labels"),
        style: t("../bar/style").style,
        styleOnSelect: t("../bar/style").styleOnSelect,
        hoverPoints: t("./hover"),
        selectPoints: t("../bar/select"),
        meta: {}
      };
    }, {
      "../../plots/polar": 912,
      "../bar/select": 945,
      "../bar/style": 947,
      "../scatter/marker_colorbar": 1217,
      "../scatterpolar/format_labels": 1276,
      "./attributes": 950,
      "./calc": 951,
      "./defaults": 952,
      "./hover": 953,
      "./layout_attributes": 955,
      "./layout_defaults": 956,
      "./plot": 957
    }],
    955: [function (t, e, r) {
      "use strict";

      e.exports = {
        barmode: {
          valType: "enumerated",
          values: ["stack", "overlay"],
          dflt: "stack",
          editType: "calc"
        },
        bargap: {
          valType: "number",
          dflt: .1,
          min: 0,
          max: 1,
          editType: "calc"
        }
      };
    }, {}],
    956: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./layout_attributes");

      e.exports = function (t, e, r) {
        var a,
            o = {};

        function s(r, o) {
          return n.coerce(t[a] || {}, e[a], i, r, o);
        }

        for (var l = 0; l < r.length; l++) {
          var c = r[l];
          "barpolar" === c.type && !0 === c.visible && (o[a = c.subplot] || (s("barmode"), s("bargap"), o[a] = 1));
        }
      };
    }, {
      "../../lib": 795,
      "./layout_attributes": 955
    }],
    957: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("fast-isnumeric"),
          a = t("../../lib"),
          o = t("../../components/drawing"),
          s = t("../../plots/polar/helpers");

      e.exports = function (t, e, r) {
        var l = e.xaxis,
            c = e.yaxis,
            u = e.radialAxis,
            f = e.angularAxis,
            h = function (t) {
          var e = t.cxx,
              r = t.cyy;
          if (t.vangles) return function (n, i, o, l) {
            var c, u;
            a.angleDelta(o, l) > 0 ? (c = o, u = l) : (c = l, u = o);
            var f = [s.findEnclosingVertexAngles(c, t.vangles)[0], (c + u) / 2, s.findEnclosingVertexAngles(u, t.vangles)[1]];
            return s.pathPolygonAnnulus(n, i, c, u, f, e, r);
          };
          return function (t, n, i, o) {
            return a.pathAnnulus(t, n, i, o, e, r);
          };
        }(e),
            p = e.layers.frontplot.select("g.barlayer");

        a.makeTraceGroups(p, r, "trace bars").each(function () {
          var r = n.select(this),
              s = a.ensureSingle(r, "g", "points").selectAll("g.point").data(a.identity);
          s.enter().append("g").style("vector-effect", "non-scaling-stroke").style("stroke-miterlimit", 2).classed("point", !0), s.exit().remove(), s.each(function (t) {
            var e,
                r = n.select(this),
                o = t.rp0 = u.c2p(t.s0),
                s = t.rp1 = u.c2p(t.s1),
                p = t.thetag0 = f.c2g(t.p0),
                d = t.thetag1 = f.c2g(t.p1);

            if (i(o) && i(s) && i(p) && i(d) && o !== s && p !== d) {
              var m = u.c2g(t.s1),
                  g = (p + d) / 2;
              t.ct = [l.c2p(m * Math.cos(g)), c.c2p(m * Math.sin(g))], e = h(o, s, p, d);
            } else e = "M0,0Z";

            a.ensureSingle(r, "path").attr("d", e);
          }), o.setClipUrl(r, e._hasClipOnAxisFalse ? e.clipIds.forTraces : null, t);
        });
      };
    }, {
      "../../components/drawing": 680,
      "../../lib": 795,
      "../../plots/polar/helpers": 911,
      "@plotly/d3": 57,
      "fast-isnumeric": 240
    }],
    958: [function (t, e, r) {
      "use strict";

      var n = t("../scatter/attributes"),
          i = t("../bar/attributes"),
          a = t("../../components/color/attributes"),
          o = t("../../plots/hoverformat_attributes"),
          s = t("../../plots/template_attributes").hovertemplateAttrs,
          l = t("../../lib/extend").extendFlat,
          c = n.marker,
          u = c.line;
      e.exports = {
        y: {
          valType: "data_array",
          editType: "calc+clearAxisTypes"
        },
        x: {
          valType: "data_array",
          editType: "calc+clearAxisTypes"
        },
        x0: {
          valType: "any",
          editType: "calc+clearAxisTypes"
        },
        y0: {
          valType: "any",
          editType: "calc+clearAxisTypes"
        },
        dx: {
          valType: "number",
          editType: "calc"
        },
        dy: {
          valType: "number",
          editType: "calc"
        },
        xperiod: n.xperiod,
        yperiod: n.yperiod,
        xperiod0: n.xperiod0,
        yperiod0: n.yperiod0,
        xperiodalignment: n.xperiodalignment,
        yperiodalignment: n.yperiodalignment,
        xhoverformat: o("x"),
        yhoverformat: o("y"),
        name: {
          valType: "string",
          editType: "calc+clearAxisTypes"
        },
        q1: {
          valType: "data_array",
          editType: "calc+clearAxisTypes"
        },
        median: {
          valType: "data_array",
          editType: "calc+clearAxisTypes"
        },
        q3: {
          valType: "data_array",
          editType: "calc+clearAxisTypes"
        },
        lowerfence: {
          valType: "data_array",
          editType: "calc"
        },
        upperfence: {
          valType: "data_array",
          editType: "calc"
        },
        notched: {
          valType: "boolean",
          editType: "calc"
        },
        notchwidth: {
          valType: "number",
          min: 0,
          max: .5,
          dflt: .25,
          editType: "calc"
        },
        notchspan: {
          valType: "data_array",
          editType: "calc"
        },
        boxpoints: {
          valType: "enumerated",
          values: ["all", "outliers", "suspectedoutliers", !1],
          editType: "calc"
        },
        jitter: {
          valType: "number",
          min: 0,
          max: 1,
          editType: "calc"
        },
        pointpos: {
          valType: "number",
          min: -2,
          max: 2,
          editType: "calc"
        },
        boxmean: {
          valType: "enumerated",
          values: [!0, "sd", !1],
          editType: "calc"
        },
        mean: {
          valType: "data_array",
          editType: "calc"
        },
        sd: {
          valType: "data_array",
          editType: "calc"
        },
        orientation: {
          valType: "enumerated",
          values: ["v", "h"],
          editType: "calc+clearAxisTypes"
        },
        quartilemethod: {
          valType: "enumerated",
          values: ["linear", "exclusive", "inclusive"],
          dflt: "linear",
          editType: "calc"
        },
        width: {
          valType: "number",
          min: 0,
          dflt: 0,
          editType: "calc"
        },
        marker: {
          outliercolor: {
            valType: "color",
            dflt: "rgba(0, 0, 0, 0)",
            editType: "style"
          },
          symbol: l({}, c.symbol, {
            arrayOk: !1,
            editType: "plot"
          }),
          opacity: l({}, c.opacity, {
            arrayOk: !1,
            dflt: 1,
            editType: "style"
          }),
          size: l({}, c.size, {
            arrayOk: !1,
            editType: "calc"
          }),
          color: l({}, c.color, {
            arrayOk: !1,
            editType: "style"
          }),
          line: {
            color: l({}, u.color, {
              arrayOk: !1,
              dflt: a.defaultLine,
              editType: "style"
            }),
            width: l({}, u.width, {
              arrayOk: !1,
              dflt: 0,
              editType: "style"
            }),
            outliercolor: {
              valType: "color",
              editType: "style"
            },
            outlierwidth: {
              valType: "number",
              min: 0,
              dflt: 1,
              editType: "style"
            },
            editType: "style"
          },
          editType: "plot"
        },
        line: {
          color: {
            valType: "color",
            editType: "style"
          },
          width: {
            valType: "number",
            min: 0,
            dflt: 2,
            editType: "style"
          },
          editType: "plot"
        },
        fillcolor: n.fillcolor,
        whiskerwidth: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: .5,
          editType: "calc"
        },
        offsetgroup: i.offsetgroup,
        alignmentgroup: i.alignmentgroup,
        selected: {
          marker: n.selected.marker,
          editType: "style"
        },
        unselected: {
          marker: n.unselected.marker,
          editType: "style"
        },
        text: l({}, n.text, {}),
        hovertext: l({}, n.hovertext, {}),
        hovertemplate: s({}),
        hoveron: {
          valType: "flaglist",
          flags: ["boxes", "points"],
          dflt: "boxes+points",
          editType: "style"
        }
      };
    }, {
      "../../components/color/attributes": 657,
      "../../lib/extend": 785,
      "../../plots/hoverformat_attributes": 899,
      "../../plots/template_attributes": 918,
      "../bar/attributes": 933,
      "../scatter/attributes": 1199
    }],
    959: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../plots/cartesian/axes"),
          a = t("../../plots/cartesian/align_period"),
          o = t("../../lib"),
          s = t("../../constants/numerical").BADNUM,
          l = o._;

      e.exports = function (t, e) {
        var r,
            c,
            y,
            x,
            b,
            _,
            w,
            T = t._fullLayout,
            k = i.getFromId(t, e.xaxis || "x"),
            M = i.getFromId(t, e.yaxis || "y"),
            A = [],
            S = "violin" === e.type ? "_numViolins" : "_numBoxes";

        "h" === e.orientation ? (y = k, x = "x", b = M, _ = "y", w = !!e.yperiodalignment) : (y = M, x = "y", b = k, _ = "x", w = !!e.xperiodalignment);

        var E,
            L,
            C,
            P,
            I,
            O,
            z = function (t, e, r, i) {
          var s,
              l = (e + "0" in t),
              c = ("d" + e in t);

          if (e in t || l && c) {
            var u = r.makeCalcdata(t, e);
            return [a(t, r, e, u), u];
          }

          s = l ? t[e + "0"] : "name" in t && ("category" === r.type || n(t.name) && -1 !== ["linear", "log"].indexOf(r.type) || o.isDateTime(t.name) && "date" === r.type) ? t.name : i;

          for (var f = "multicategory" === r.type ? r.r2c_just_indices(s) : r.d2c(s, 0, t[e + "calendar"]), h = t._length, p = new Array(h), d = 0; d < h; d++) {
            p[d] = f;
          }

          return [p];
        }(e, _, b, T[S]),
            D = z[0],
            R = z[1],
            F = o.distinctVals(D),
            B = F.vals,
            N = F.minDiff / 2,
            j = "all" === (e.boxpoints || e.points) ? o.identity : function (t) {
          return t.v < E.lf || t.v > E.uf;
        };

        if (e._hasPreCompStats) {
          var U = e[x],
              V = function V(t) {
            return y.d2c((e[t] || [])[r]);
          },
              q = 1 / 0,
              H = -1 / 0;

          for (r = 0; r < e._length; r++) {
            var G = D[r];

            if (n(G)) {
              if ((E = {}).pos = E[_] = G, w && R && (E.orig_p = R[r]), E.q1 = V("q1"), E.med = V("median"), E.q3 = V("q3"), L = [], U && o.isArrayOrTypedArray(U[r])) for (c = 0; c < U[r].length; c++) {
                (O = y.d2c(U[r][c])) !== s && (u(I = {
                  v: O,
                  i: [r, c]
                }, e, [r, c]), L.push(I));
              }

              if (E.pts = L.sort(f), P = (C = E[x] = L.map(h)).length, E.med !== s && E.q1 !== s && E.q3 !== s && E.med >= E.q1 && E.q3 >= E.med) {
                var Y = V("lowerfence");
                E.lf = Y !== s && Y <= E.q1 ? Y : p(E, C, P);
                var W = V("upperfence");
                E.uf = W !== s && W >= E.q3 ? W : d(E, C, P);
                var X = V("mean");
                E.mean = X !== s ? X : P ? o.mean(C, P) : (E.q1 + E.q3) / 2;
                var Z = V("sd");
                E.sd = X !== s && Z >= 0 ? Z : P ? o.stdev(C, P, E.mean) : E.q3 - E.q1, E.lo = m(E), E.uo = g(E);
                var J = V("notchspan");
                J = J !== s && J > 0 ? J : v(E, P), E.ln = E.med - J, E.un = E.med + J;
                var K = E.lf,
                    Q = E.uf;
                e.boxpoints && C.length && (K = Math.min(K, C[0]), Q = Math.max(Q, C[P - 1])), e.notched && (K = Math.min(K, E.ln), Q = Math.max(Q, E.un)), E.min = K, E.max = Q;
              } else {
                var $;
                o.warn(["Invalid input - make sure that q1 <= median <= q3", "q1 = " + E.q1, "median = " + E.med, "q3 = " + E.q3].join("\n")), $ = E.med !== s ? E.med : E.q1 !== s ? E.q3 !== s ? (E.q1 + E.q3) / 2 : E.q1 : E.q3 !== s ? E.q3 : 0, E.med = $, E.q1 = E.q3 = $, E.lf = E.uf = $, E.mean = E.sd = $, E.ln = E.un = $, E.min = E.max = $;
              }

              q = Math.min(q, E.min), H = Math.max(H, E.max), E.pts2 = L.filter(j), A.push(E);
            }
          }

          e._extremes[y._id] = i.findExtremes(y, [q, H], {
            padded: !0
          });
        } else {
          var tt = y.makeCalcdata(e, x),
              et = function (t, e) {
            for (var r = t.length, n = new Array(r + 1), i = 0; i < r; i++) {
              n[i] = t[i] - e;
            }

            return n[r] = t[r - 1] + e, n;
          }(B, N),
              rt = B.length,
              nt = function (t) {
            for (var e = new Array(t), r = 0; r < t; r++) {
              e[r] = [];
            }

            return e;
          }(rt);

          for (r = 0; r < e._length; r++) {
            if (O = tt[r], n(O)) {
              var it = o.findBin(D[r], et);
              it >= 0 && it < rt && (u(I = {
                v: O,
                i: r
              }, e, r), nt[it].push(I));
            }
          }

          var at = 1 / 0,
              ot = -1 / 0,
              st = e.quartilemethod,
              lt = "exclusive" === st,
              ct = "inclusive" === st;

          for (r = 0; r < rt; r++) {
            if (nt[r].length > 0) {
              var ut, ft;
              if ((E = {}).pos = E[_] = B[r], L = E.pts = nt[r].sort(f), P = (C = E[x] = L.map(h)).length, E.min = C[0], E.max = C[P - 1], E.mean = o.mean(C, P), E.sd = o.stdev(C, P, E.mean), E.med = o.interp(C, .5), P % 2 && (lt || ct)) lt ? (ut = C.slice(0, P / 2), ft = C.slice(P / 2 + 1)) : ct && (ut = C.slice(0, P / 2 + 1), ft = C.slice(P / 2)), E.q1 = o.interp(ut, .5), E.q3 = o.interp(ft, .5);else E.q1 = o.interp(C, .25), E.q3 = o.interp(C, .75);
              E.lf = p(E, C, P), E.uf = d(E, C, P), E.lo = m(E), E.uo = g(E);
              var ht = v(E, P);
              E.ln = E.med - ht, E.un = E.med + ht, at = Math.min(at, E.ln), ot = Math.max(ot, E.un), E.pts2 = L.filter(j), A.push(E);
            }
          }

          e._extremes[y._id] = i.findExtremes(y, e.notched ? tt.concat([at, ot]) : tt, {
            padded: !0
          });
        }

        return function (t, e) {
          if (o.isArrayOrTypedArray(e.selectedpoints)) for (var r = 0; r < t.length; r++) {
            for (var n = t[r].pts || [], i = {}, a = 0; a < n.length; a++) {
              i[n[a].i] = a;
            }

            o.tagSelected(n, e, i);
          }
        }(A, e), A.length > 0 ? (A[0].t = {
          num: T[S],
          dPos: N,
          posLetter: _,
          valLetter: x,
          labels: {
            med: l(t, "median:"),
            min: l(t, "min:"),
            q1: l(t, "q1:"),
            q3: l(t, "q3:"),
            max: l(t, "max:"),
            mean: "sd" === e.boxmean ? l(t, "mean \xB1 \u03C3:") : l(t, "mean:"),
            lf: l(t, "lower fence:"),
            uf: l(t, "upper fence:")
          }
        }, T[S]++, A) : [{
          t: {
            empty: !0
          }
        }];
      };

      var c = {
        text: "tx",
        hovertext: "htx"
      };

      function u(t, e, r) {
        for (var n in c) {
          o.isArrayOrTypedArray(e[n]) && (Array.isArray(r) ? o.isArrayOrTypedArray(e[n][r[0]]) && (t[c[n]] = e[n][r[0]][r[1]]) : t[c[n]] = e[n][r]);
        }
      }

      function f(t, e) {
        return t.v - e.v;
      }

      function h(t) {
        return t.v;
      }

      function p(t, e, r) {
        return 0 === r ? t.q1 : Math.min(t.q1, e[Math.min(o.findBin(2.5 * t.q1 - 1.5 * t.q3, e, !0) + 1, r - 1)]);
      }

      function d(t, e, r) {
        return 0 === r ? t.q3 : Math.max(t.q3, e[Math.max(o.findBin(2.5 * t.q3 - 1.5 * t.q1, e), 0)]);
      }

      function m(t) {
        return 4 * t.q1 - 3 * t.q3;
      }

      function g(t) {
        return 4 * t.q3 - 3 * t.q1;
      }

      function v(t, e) {
        return 0 === e ? 0 : 1.57 * (t.q3 - t.q1) / Math.sqrt(e);
      }
    }, {
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../../plots/cartesian/align_period": 842,
      "../../plots/cartesian/axes": 845,
      "fast-isnumeric": 240
    }],
    960: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/cartesian/axes"),
          i = t("../../lib"),
          a = t("../../plots/cartesian/constraints").getAxisGroup,
          o = ["v", "h"];

      function s(t, e, r, o) {
        var s,
            l,
            c,
            u = e.calcdata,
            f = e._fullLayout,
            h = o._id,
            p = h.charAt(0),
            d = [],
            m = 0;

        for (s = 0; s < r.length; s++) {
          for (c = u[r[s]], l = 0; l < c.length; l++) {
            d.push(o.c2l(c[l].pos, !0)), m += (c[l].pts2 || []).length;
          }
        }

        if (d.length) {
          var g = i.distinctVals(d, {
            unitMinDiff: "category" === o.type || "multicategory" === o.type
          }),
              v = g.minDiff / 2;
          n.minDtick(o, g.minDiff, g.vals[0], !0);

          var y = f["violin" === t ? "_numViolins" : "_numBoxes"],
              x = "group" === f[t + "mode"] && y > 1,
              b = 1 - f[t + "gap"],
              _ = 1 - f[t + "groupgap"];

          for (s = 0; s < r.length; s++) {
            var w,
                T,
                k,
                M,
                A,
                S,
                E = (c = u[r[s]])[0].trace,
                L = c[0].t,
                C = E.width,
                P = E.side;
            if (C) w = T = M = C / 2, k = 0;else if (w = v, x) {
              var I = a(f, o._id) + E.orientation,
                  O = (f._alignmentOpts[I] || {})[E.alignmentgroup] || {},
                  z = Object.keys(O.offsetGroups || {}).length,
                  D = z || y;
              T = w * b * _ / D, k = 2 * w * (((z ? E._offsetIndex : L.num) + .5) / D - .5) * b, M = w * b / D;
            } else T = w * b * _, k = 0, M = w;
            L.dPos = w, L.bPos = k, L.bdPos = T, L.wHover = M;
            var R,
                F,
                B,
                N,
                j,
                U,
                V = k + T,
                q = Boolean(C);

            if ("positive" === P ? (A = w * (C ? 1 : .5), R = V, S = R = k) : "negative" === P ? (A = R = k, S = w * (C ? 1 : .5), F = V) : (A = S = w, R = F = V), (E.boxpoints || E.points) && m > 0) {
              var H = E.pointpos,
                  G = E.jitter,
                  Y = E.marker.size / 2,
                  W = 0;
              H + G >= 0 && ((W = V * (H + G)) > A ? (q = !0, j = Y, B = W) : W > R && (j = Y, B = A)), W <= A && (B = A);
              var X = 0;
              H - G <= 0 && ((X = -V * (H - G)) > S ? (q = !0, U = Y, N = X) : X > F && (U = Y, N = S)), X <= S && (N = S);
            } else B = A, N = S;

            var Z = new Array(c.length);

            for (l = 0; l < c.length; l++) {
              Z[l] = c[l].pos;
            }

            E._extremes[h] = n.findExtremes(o, Z, {
              padded: q,
              vpadminus: N,
              vpadplus: B,
              vpadLinearized: !0,
              ppadminus: {
                x: U,
                y: j
              }[p],
              ppadplus: {
                x: j,
                y: U
              }[p]
            });
          }
        }
      }

      e.exports = {
        crossTraceCalc: function crossTraceCalc(t, e) {
          for (var r = t.calcdata, n = e.xaxis, i = e.yaxis, a = 0; a < o.length; a++) {
            for (var l = o[a], c = "h" === l ? i : n, u = [], f = 0; f < r.length; f++) {
              var h = r[f],
                  p = h[0].t,
                  d = h[0].trace;
              !0 !== d.visible || "box" !== d.type && "candlestick" !== d.type || p.empty || (d.orientation || "v") !== l || d.xaxis !== n._id || d.yaxis !== i._id || u.push(f);
            }

            s("box", t, u, c);
          }
        },
        setPositionOffset: s
      };
    }, {
      "../../lib": 795,
      "../../plots/cartesian/axes": 845,
      "../../plots/cartesian/constraints": 852
    }],
    961: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../registry"),
          a = t("../../components/color"),
          o = t("../scatter/period_defaults"),
          s = t("../bar/defaults").handleGroupingDefaults,
          l = t("../../plots/cartesian/axis_autotype"),
          c = t("./attributes");

      function u(t, e, r, a) {
        function o(t) {
          var e = 0;
          return t && t.length && (e += 1, n.isArrayOrTypedArray(t[0]) && t[0].length && (e += 1)), e;
        }

        function s(e) {
          return n.validate(t[e], c[e]);
        }

        var u,
            f = r("y"),
            h = r("x");

        if ("box" === e.type) {
          var p = r("q1"),
              d = r("median"),
              m = r("q3");
          e._hasPreCompStats = p && p.length && d && d.length && m && m.length, u = Math.min(n.minRowLength(p), n.minRowLength(d), n.minRowLength(m));
        }

        var g,
            v,
            y = o(f),
            x = o(h),
            b = y && n.minRowLength(f),
            _ = x && n.minRowLength(h),
            w = a.calendar,
            T = {
          autotypenumbers: a.autotypenumbers
        };

        if (e._hasPreCompStats) switch (String(x) + String(y)) {
          case "00":
            var k = s("x0") || s("dx");
            g = (s("y0") || s("dy")) && !k ? "h" : "v", v = u;
            break;

          case "10":
            g = "v", v = Math.min(u, _);
            break;

          case "20":
            g = "h", v = Math.min(u, h.length);
            break;

          case "01":
            g = "h", v = Math.min(u, b);
            break;

          case "02":
            g = "v", v = Math.min(u, f.length);
            break;

          case "12":
            g = "v", v = Math.min(u, _, f.length);
            break;

          case "21":
            g = "h", v = Math.min(u, h.length, b);
            break;

          case "11":
            v = 0;
            break;

          case "22":
            var M,
                A = !1;

            for (M = 0; M < h.length; M++) {
              if ("category" === l(h[M], w, T)) {
                A = !0;
                break;
              }
            }

            if (A) g = "v", v = Math.min(u, _, f.length);else {
              for (M = 0; M < f.length; M++) {
                if ("category" === l(f[M], w, T)) {
                  A = !0;
                  break;
                }
              }

              A ? (g = "h", v = Math.min(u, h.length, b)) : (g = "v", v = Math.min(u, _, f.length));
            }
        } else y > 0 ? (g = "v", v = x > 0 ? Math.min(_, b) : Math.min(b)) : x > 0 ? (g = "h", v = Math.min(_)) : v = 0;

        if (v) {
          e._length = v;
          var S = r("orientation", g);
          e._hasPreCompStats ? "v" === S && 0 === x ? (r("x0", 0), r("dx", 1)) : "h" === S && 0 === y && (r("y0", 0), r("dy", 1)) : "v" === S && 0 === x ? r("x0") : "h" === S && 0 === y && r("y0"), i.getComponentMethod("calendars", "handleTraceDefaults")(t, e, ["x", "y"], a);
        } else e.visible = !1;
      }

      function f(t, e, r, i) {
        var a = i.prefix,
            o = n.coerce2(t, e, c, "marker.outliercolor"),
            s = r("marker.line.outliercolor"),
            l = "outliers";
        e._hasPreCompStats ? l = "all" : (o || s) && (l = "suspectedoutliers");
        var u = r(a + "points", l);
        u ? (r("jitter", "all" === u ? .3 : 0), r("pointpos", "all" === u ? -1.5 : 0), r("marker.symbol"), r("marker.opacity"), r("marker.size"), r("marker.color", e.line.color), r("marker.line.color"), r("marker.line.width"), "suspectedoutliers" === u && (r("marker.line.outliercolor", e.marker.color), r("marker.line.outlierwidth")), r("selected.marker.color"), r("unselected.marker.color"), r("selected.marker.size"), r("unselected.marker.size"), r("text"), r("hovertext")) : delete e.marker;
        var f = r("hoveron");
        "all" !== f && -1 === f.indexOf("points") || r("hovertemplate"), n.coerceSelectionMarkerOpacity(e, r);
      }

      e.exports = {
        supplyDefaults: function supplyDefaults(t, e, r, i) {
          function s(r, i) {
            return n.coerce(t, e, c, r, i);
          }

          if (u(t, e, s, i), !1 !== e.visible) {
            o(t, e, i, s), s("xhoverformat"), s("yhoverformat");
            var l = e._hasPreCompStats;
            l && (s("lowerfence"), s("upperfence")), s("line.color", (t.marker || {}).color || r), s("line.width"), s("fillcolor", a.addOpacity(e.line.color, .5));
            var h = !1;

            if (l) {
              var p = s("mean"),
                  d = s("sd");
              p && p.length && (h = !0, d && d.length && (h = "sd"));
            }

            s("boxmean", h), s("whiskerwidth"), s("width"), s("quartilemethod");
            var m = !1;

            if (l) {
              var g = s("notchspan");
              g && g.length && (m = !0);
            } else n.validate(t.notchwidth, c.notchwidth) && (m = !0);

            s("notched", m) && s("notchwidth"), f(t, e, s, {
              prefix: "box"
            });
          }
        },
        crossTraceDefaults: function crossTraceDefaults(t, e) {
          var r, i;

          function a(t) {
            return n.coerce(i._input, i, c, t);
          }

          for (var o = 0; o < t.length; o++) {
            var l = (i = t[o]).type;
            "box" !== l && "violin" !== l || (r = i._input, "group" === e[l + "mode"] && s(r, i, e, a));
          }
        },
        handleSampleDefaults: u,
        handlePointsDefaults: f
      };
    }, {
      "../../components/color": 658,
      "../../lib": 795,
      "../../plots/cartesian/axis_autotype": 846,
      "../../registry": 923,
      "../bar/defaults": 937,
      "../scatter/period_defaults": 1219,
      "./attributes": 958
    }],
    962: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        return e.hoverOnBox && (t.hoverOnBox = e.hoverOnBox), "xVal" in e && (t.x = e.xVal), "yVal" in e && (t.y = e.yVal), e.xa && (t.xaxis = e.xa), e.ya && (t.yaxis = e.ya), t;
      };
    }, {}],
    963: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/cartesian/axes"),
          i = t("../../lib"),
          a = t("../../components/fx"),
          o = t("../../components/color"),
          s = i.fillText;

      function l(t, e, r, s) {
        var l,
            c,
            u,
            f,
            h,
            p,
            d,
            m,
            g,
            v,
            y,
            x,
            b,
            _,
            w = t.cd,
            T = t.xa,
            k = t.ya,
            M = w[0].trace,
            A = w[0].t,
            S = "violin" === M.type,
            E = [],
            L = A.bdPos,
            C = A.wHover,
            P = function P(t) {
          return u.c2l(t.pos) + A.bPos - u.c2l(p);
        };

        S && "both" !== M.side ? ("positive" === M.side && (g = function g(t) {
          var e = P(t);
          return a.inbox(e, e + C, v);
        }, x = L, b = 0), "negative" === M.side && (g = function g(t) {
          var e = P(t);
          return a.inbox(e - C, e, v);
        }, x = 0, b = L)) : (g = function g(t) {
          var e = P(t);
          return a.inbox(e - C, e + C, v);
        }, x = b = L), _ = S ? function (t) {
          return a.inbox(t.span[0] - h, t.span[1] - h, v);
        } : function (t) {
          return a.inbox(t.min - h, t.max - h, v);
        }, "h" === M.orientation ? (h = e, p = r, d = _, m = g, l = "y", u = k, c = "x", f = T) : (h = r, p = e, d = g, m = _, l = "x", u = T, c = "y", f = k);
        var I = Math.min(1, L / Math.abs(u.r2c(u.range[1]) - u.r2c(u.range[0])));

        function O(t) {
          return (d(t) + m(t)) / 2;
        }

        v = t.maxHoverDistance - I, y = t.maxSpikeDistance - I;
        var z = a.getDistanceFunction(s, d, m, O);
        if (a.getClosest(w, z, t), !1 === t.index) return [];
        var D = w[t.index],
            R = M.line.color,
            F = (M.marker || {}).color;
        o.opacity(R) && M.line.width ? t.color = R : o.opacity(F) && M.boxpoints ? t.color = F : t.color = M.fillcolor, t[l + "0"] = u.c2p(D.pos + A.bPos - b, !0), t[l + "1"] = u.c2p(D.pos + A.bPos + x, !0), t[l + "LabelVal"] = void 0 !== D.orig_p ? D.orig_p : D.pos;
        var B = l + "Spike";
        t.spikeDistance = O(D) * y / v, t[B] = u.c2p(D.pos, !0);
        var N = {},
            j = ["med", "q1", "q3", "min", "max"];
        (M.boxmean || (M.meanline || {}).visible) && j.push("mean"), (M.boxpoints || M.points) && j.push("lf", "uf");

        for (var U = 0; U < j.length; U++) {
          var V = j[U];

          if (V in D && !(D[V] in N)) {
            N[D[V]] = !0;
            var q = D[V],
                H = f.c2p(q, !0),
                G = i.extendFlat({}, t);
            G.attr = V, G[c + "0"] = G[c + "1"] = H, G[c + "LabelVal"] = q, G[c + "Label"] = (A.labels ? A.labels[V] + " " : "") + n.hoverLabelText(f, q, M[c + "hoverformat"]), G.hoverOnBox = !0, "mean" === V && "sd" in D && "sd" === M.boxmean && (G[c + "err"] = D.sd), t.name = "", t.spikeDistance = void 0, t[B] = void 0, G.hovertemplate = !1, E.push(G);
          }
        }

        return E;
      }

      function c(t, e, r) {
        for (var n, o, l, c = t.cd, u = t.xa, f = t.ya, h = c[0].trace, p = u.c2p(e), d = f.c2p(r), m = a.quadrature(function (t) {
          var e = Math.max(3, t.mrc || 0);
          return Math.max(Math.abs(u.c2p(t.x) - p) - e, 1 - 3 / e);
        }, function (t) {
          var e = Math.max(3, t.mrc || 0);
          return Math.max(Math.abs(f.c2p(t.y) - d) - e, 1 - 3 / e);
        }), g = !1, v = 0; v < c.length; v++) {
          o = c[v];

          for (var y = 0; y < (o.pts || []).length; y++) {
            var x = m(l = o.pts[y]);
            x <= t.distance && (t.distance = x, g = [v, y]);
          }
        }

        if (!g) return !1;
        l = (o = c[g[0]]).pts[g[1]];

        var b = u.c2p(l.x, !0),
            _ = f.c2p(l.y, !0),
            w = l.mrc || 1;

        n = i.extendFlat({}, t, {
          index: l.i,
          color: (h.marker || {}).color,
          name: h.name,
          x0: b - w,
          x1: b + w,
          y0: _ - w,
          y1: _ + w,
          spikeDistance: t.distance,
          hovertemplate: h.hovertemplate
        });
        var T,
            k = o.orig_p,
            M = void 0 !== k ? k : o.pos;
        return "h" === h.orientation ? (T = f, n.xLabelVal = l.x, n.yLabelVal = M) : (T = u, n.xLabelVal = M, n.yLabelVal = l.y), n[T._id.charAt(0) + "Spike"] = T.c2p(o.pos, !0), s(l, h, n), n;
      }

      e.exports = {
        hoverPoints: function hoverPoints(t, e, r, n) {
          var i,
              a = t.cd[0].trace.hoveron,
              o = [];
          return -1 !== a.indexOf("boxes") && (o = o.concat(l(t, e, r, n))), -1 !== a.indexOf("points") && (i = c(t, e, r)), "closest" === n ? i ? [i] : o : i ? (o.push(i), o) : o;
        },
        hoverOnBoxes: l,
        hoverOnPoints: c
      };
    }, {
      "../../components/color": 658,
      "../../components/fx": 698,
      "../../lib": 795,
      "../../plots/cartesian/axes": 845
    }],
    964: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        layoutAttributes: t("./layout_attributes"),
        supplyDefaults: t("./defaults").supplyDefaults,
        crossTraceDefaults: t("./defaults").crossTraceDefaults,
        supplyLayoutDefaults: t("./layout_defaults").supplyLayoutDefaults,
        calc: t("./calc"),
        crossTraceCalc: t("./cross_trace_calc").crossTraceCalc,
        plot: t("./plot").plot,
        style: t("./style").style,
        styleOnSelect: t("./style").styleOnSelect,
        hoverPoints: t("./hover").hoverPoints,
        eventData: t("./event_data"),
        selectPoints: t("./select"),
        moduleType: "trace",
        name: "box",
        basePlotModule: t("../../plots/cartesian"),
        categories: ["cartesian", "svg", "symbols", "oriented", "box-violin", "showLegend", "boxLayout", "zoomScale"],
        meta: {}
      };
    }, {
      "../../plots/cartesian": 858,
      "./attributes": 958,
      "./calc": 959,
      "./cross_trace_calc": 960,
      "./defaults": 961,
      "./event_data": 962,
      "./hover": 963,
      "./layout_attributes": 965,
      "./layout_defaults": 966,
      "./plot": 967,
      "./select": 968,
      "./style": 969
    }],
    965: [function (t, e, r) {
      "use strict";

      e.exports = {
        boxmode: {
          valType: "enumerated",
          values: ["group", "overlay"],
          dflt: "overlay",
          editType: "calc"
        },
        boxgap: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: .3,
          editType: "calc"
        },
        boxgroupgap: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: .3,
          editType: "calc"
        }
      };
    }, {}],
    966: [function (t, e, r) {
      "use strict";

      var n = t("../../registry"),
          i = t("../../lib"),
          a = t("./layout_attributes");

      function o(t, e, r, i, a) {
        for (var o = a + "Layout", s = !1, l = 0; l < r.length; l++) {
          var c = r[l];

          if (n.traceIs(c, o)) {
            s = !0;
            break;
          }
        }

        s && (i(a + "mode"), i(a + "gap"), i(a + "groupgap"));
      }

      e.exports = {
        supplyLayoutDefaults: function supplyLayoutDefaults(t, e, r) {
          o(0, 0, r, function (r, n) {
            return i.coerce(t, e, a, r, n);
          }, "box");
        },
        _supply: o
      };
    }, {
      "../../lib": 795,
      "../../registry": 923,
      "./layout_attributes": 965
    }],
    967: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../lib"),
          a = t("../../components/drawing");

      function o(t, e, r, a) {
        var o,
            s,
            l = "h" === r.orientation,
            c = e.val,
            u = e.pos,
            f = !!u.rangebreaks,
            h = a.bPos,
            p = a.wdPos || 0,
            d = a.bPosPxOffset || 0,
            m = r.whiskerwidth || 0,
            g = r.notched || !1,
            v = g ? 1 - 2 * r.notchwidth : 1;
        Array.isArray(a.bdPos) ? (o = a.bdPos[0], s = a.bdPos[1]) : (o = a.bdPos, s = a.bdPos);
        var y = t.selectAll("path.box").data("violin" !== r.type || r.box.visible ? i.identity : []);
        y.enter().append("path").style("vector-effect", "non-scaling-stroke").attr("class", "box"), y.exit().remove(), y.each(function (t) {
          if (t.empty) return "M0,0Z";

          var e = u.c2l(t.pos + h, !0),
              a = u.l2p(e - o) + d,
              y = u.l2p(e + s) + d,
              x = f ? (a + y) / 2 : u.l2p(e) + d,
              b = r.whiskerwidth,
              _ = f ? a * b + (1 - b) * x : u.l2p(e - p) + d,
              w = f ? y * b + (1 - b) * x : u.l2p(e + p) + d,
              T = u.l2p(e - o * v) + d,
              k = u.l2p(e + s * v) + d,
              M = c.c2p(t.q1, !0),
              A = c.c2p(t.q3, !0),
              S = i.constrain(c.c2p(t.med, !0), Math.min(M, A) + 1, Math.max(M, A) - 1),
              E = void 0 === t.lf || !1 === r.boxpoints,
              L = c.c2p(E ? t.min : t.lf, !0),
              C = c.c2p(E ? t.max : t.uf, !0),
              P = c.c2p(t.ln, !0),
              I = c.c2p(t.un, !0);

          l ? n.select(this).attr("d", "M" + S + "," + T + "V" + k + "M" + M + "," + a + "V" + y + (g ? "H" + P + "L" + S + "," + k + "L" + I + "," + y : "") + "H" + A + "V" + a + (g ? "H" + I + "L" + S + "," + T + "L" + P + "," + a : "") + "ZM" + M + "," + x + "H" + L + "M" + A + "," + x + "H" + C + (0 === m ? "" : "M" + L + "," + _ + "V" + w + "M" + C + "," + _ + "V" + w)) : n.select(this).attr("d", "M" + T + "," + S + "H" + k + "M" + a + "," + M + "H" + y + (g ? "V" + P + "L" + k + "," + S + "L" + y + "," + I : "") + "V" + A + "H" + a + (g ? "V" + I + "L" + T + "," + S + "L" + a + "," + P : "") + "ZM" + x + "," + M + "V" + L + "M" + x + "," + A + "V" + C + (0 === m ? "" : "M" + _ + "," + L + "H" + w + "M" + _ + "," + C + "H" + w));
        });
      }

      function s(t, e, r, n) {
        var o = e.x,
            s = e.y,
            l = n.bdPos,
            c = n.bPos,
            u = r.boxpoints || r.points;
        i.seedPseudoRandom();
        var f = t.selectAll("g.points").data(u ? function (t) {
          return t.forEach(function (t) {
            t.t = n, t.trace = r;
          }), t;
        } : []);
        f.enter().append("g").attr("class", "points"), f.exit().remove();
        var h = f.selectAll("path").data(function (t) {
          var e,
              n,
              a = t.pts2,
              o = Math.max((t.max - t.min) / 10, t.q3 - t.q1),
              s = 1e-9 * o,
              f = .01 * o,
              h = [],
              p = 0;

          if (r.jitter) {
            if (0 === o) for (p = 1, h = new Array(a.length), e = 0; e < a.length; e++) {
              h[e] = 1;
            } else for (e = 0; e < a.length; e++) {
              var d = Math.max(0, e - 5),
                  m = a[d].v,
                  g = Math.min(a.length - 1, e + 5),
                  v = a[g].v;
              "all" !== u && (a[e].v < t.lf ? v = Math.min(v, t.lf) : m = Math.max(m, t.uf));
              var y = Math.sqrt(f * (g - d) / (v - m + s)) || 0;
              y = i.constrain(Math.abs(y), 0, 1), h.push(y), p = Math.max(y, p);
            }
            n = 2 * r.jitter / (p || 1);
          }

          for (e = 0; e < a.length; e++) {
            var x = a[e],
                b = x.v,
                _ = r.jitter ? n * h[e] * (i.pseudoRandom() - .5) : 0,
                w = t.pos + c + l * (r.pointpos + _);

            "h" === r.orientation ? (x.y = w, x.x = b) : (x.x = w, x.y = b), "suspectedoutliers" === u && b < t.uo && b > t.lo && (x.so = !0);
          }

          return a;
        });
        h.enter().append("path").classed("point", !0), h.exit().remove(), h.call(a.translatePoints, o, s);
      }

      function l(t, e, r, a) {
        var o,
            s,
            l = e.val,
            c = e.pos,
            u = !!c.rangebreaks,
            f = a.bPos,
            h = a.bPosPxOffset || 0,
            p = r.boxmean || (r.meanline || {}).visible;
        Array.isArray(a.bdPos) ? (o = a.bdPos[0], s = a.bdPos[1]) : (o = a.bdPos, s = a.bdPos);
        var d = t.selectAll("path.mean").data("box" === r.type && r.boxmean || "violin" === r.type && r.box.visible && r.meanline.visible ? i.identity : []);
        d.enter().append("path").attr("class", "mean").style({
          fill: "none",
          "vector-effect": "non-scaling-stroke"
        }), d.exit().remove(), d.each(function (t) {
          var e = c.c2l(t.pos + f, !0),
              i = c.l2p(e - o) + h,
              a = c.l2p(e + s) + h,
              d = u ? (i + a) / 2 : c.l2p(e) + h,
              m = l.c2p(t.mean, !0),
              g = l.c2p(t.mean - t.sd, !0),
              v = l.c2p(t.mean + t.sd, !0);
          "h" === r.orientation ? n.select(this).attr("d", "M" + m + "," + i + "V" + a + ("sd" === p ? "m0,0L" + g + "," + d + "L" + m + "," + i + "L" + v + "," + d + "Z" : "")) : n.select(this).attr("d", "M" + i + "," + m + "H" + a + ("sd" === p ? "m0,0L" + d + "," + g + "L" + i + "," + m + "L" + d + "," + v + "Z" : ""));
        });
      }

      e.exports = {
        plot: function plot(t, e, r, a) {
          var c = e.xaxis,
              u = e.yaxis;
          i.makeTraceGroups(a, r, "trace boxes").each(function (t) {
            var e,
                r,
                i = n.select(this),
                a = t[0],
                f = a.t,
                h = a.trace;
            (f.wdPos = f.bdPos * h.whiskerwidth, !0 !== h.visible || f.empty) ? i.remove() : ("h" === h.orientation ? (e = u, r = c) : (e = c, r = u), o(i, {
              pos: e,
              val: r
            }, h, f), s(i, {
              x: c,
              y: u
            }, h, f), l(i, {
              pos: e,
              val: r
            }, h, f));
          });
        },
        plotBoxAndWhiskers: o,
        plotPoints: s,
        plotBoxMean: l
      };
    }, {
      "../../components/drawing": 680,
      "../../lib": 795,
      "@plotly/d3": 57
    }],
    968: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        var r,
            n,
            i = t.cd,
            a = t.xaxis,
            o = t.yaxis,
            s = [];
        if (!1 === e) for (r = 0; r < i.length; r++) {
          for (n = 0; n < (i[r].pts || []).length; n++) {
            i[r].pts[n].selected = 0;
          }
        } else for (r = 0; r < i.length; r++) {
          for (n = 0; n < (i[r].pts || []).length; n++) {
            var l = i[r].pts[n],
                c = a.c2p(l.x),
                u = o.c2p(l.y);
            e.contains([c, u], null, l.i, t) ? (s.push({
              pointNumber: l.i,
              x: a.c2d(l.x),
              y: o.c2d(l.y)
            }), l.selected = 1) : l.selected = 0;
          }
        }
        return s;
      };
    }, {}],
    969: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../components/color"),
          a = t("../../components/drawing");
      e.exports = {
        style: function style(t, e, r) {
          var o = r || n.select(t).selectAll("g.trace.boxes");
          o.style("opacity", function (t) {
            return t[0].trace.opacity;
          }), o.each(function (e) {
            var r = n.select(this),
                o = e[0].trace,
                s = o.line.width;

            function l(t, e, r, n) {
              t.style("stroke-width", e + "px").call(i.stroke, r).call(i.fill, n);
            }

            var c = r.selectAll("path.box");
            if ("candlestick" === o.type) c.each(function (t) {
              if (!t.empty) {
                var e = n.select(this),
                    r = o[t.dir];
                l(e, r.line.width, r.line.color, r.fillcolor), e.style("opacity", o.selectedpoints && !t.selected ? .3 : 1);
              }
            });else {
              l(c, s, o.line.color, o.fillcolor), r.selectAll("path.mean").style({
                "stroke-width": s,
                "stroke-dasharray": 2 * s + "px," + s + "px"
              }).call(i.stroke, o.line.color);
              var u = r.selectAll("path.point");
              a.pointStyle(u, o, t);
            }
          });
        },
        styleOnSelect: function styleOnSelect(t, e, r) {
          var n = e[0].trace,
              i = r.selectAll("path.point");
          n.selectedpoints ? a.selectedPointStyle(i, n) : a.pointStyle(i, n, t);
        }
      };
    }, {
      "../../components/color": 658,
      "../../components/drawing": 680,
      "@plotly/d3": 57
    }],
    970: [function (t, e, r) {
      "use strict";

      var n = t("../../lib").extendFlat,
          i = t("../../plots/hoverformat_attributes"),
          a = t("../ohlc/attributes"),
          o = t("../box/attributes");

      function s(t) {
        return {
          line: {
            color: n({}, o.line.color, {
              dflt: t
            }),
            width: o.line.width,
            editType: "style"
          },
          fillcolor: o.fillcolor,
          editType: "style"
        };
      }

      e.exports = {
        xperiod: a.xperiod,
        xperiod0: a.xperiod0,
        xperiodalignment: a.xperiodalignment,
        xhoverformat: i("x"),
        yhoverformat: i("y"),
        x: a.x,
        open: a.open,
        high: a.high,
        low: a.low,
        close: a.close,
        line: {
          width: n({}, o.line.width, {}),
          editType: "style"
        },
        increasing: s(a.increasing.line.color.dflt),
        decreasing: s(a.decreasing.line.color.dflt),
        text: a.text,
        hovertext: a.hovertext,
        whiskerwidth: n({}, o.whiskerwidth, {
          dflt: 0
        }),
        hoverlabel: a.hoverlabel
      };
    }, {
      "../../lib": 795,
      "../../plots/hoverformat_attributes": 899,
      "../box/attributes": 958,
      "../ohlc/attributes": 1145
    }],
    971: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../plots/cartesian/axes"),
          a = t("../../plots/cartesian/align_period"),
          o = t("../ohlc/calc").calcCommon;

      function s(t, e, r, n) {
        return {
          min: r,
          q1: Math.min(t, n),
          med: n,
          q3: Math.max(t, n),
          max: e
        };
      }

      e.exports = function (t, e) {
        var r = t._fullLayout,
            l = i.getFromId(t, e.xaxis),
            c = i.getFromId(t, e.yaxis),
            u = l.makeCalcdata(e, "x"),
            f = a(e, l, "x", u),
            h = o(t, e, u, f, c, s);
        return h.length ? (n.extendFlat(h[0].t, {
          num: r._numBoxes,
          dPos: n.distinctVals(f).minDiff / 2,
          posLetter: "x",
          valLetter: "y"
        }), r._numBoxes++, h) : [{
          t: {
            empty: !0
          }
        }];
      };
    }, {
      "../../lib": 795,
      "../../plots/cartesian/align_period": 842,
      "../../plots/cartesian/axes": 845,
      "../ohlc/calc": 1146
    }],
    972: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../components/color"),
          a = t("../ohlc/ohlc_defaults"),
          o = t("../scatter/period_defaults"),
          s = t("./attributes");

      function l(t, e, r, n) {
        var a = r(n + ".line.color");
        r(n + ".line.width", e.line.width), r(n + ".fillcolor", i.addOpacity(a, .5));
      }

      e.exports = function (t, e, r, i) {
        function c(r, i) {
          return n.coerce(t, e, s, r, i);
        }

        a(t, e, c, i) ? (o(t, e, i, c, {
          x: !0
        }), c("xhoverformat"), c("yhoverformat"), c("line.width"), l(t, e, c, "increasing"), l(t, e, c, "decreasing"), c("text"), c("hovertext"), c("whiskerwidth"), i._requestRangeslider[e.xaxis] = !0) : e.visible = !1;
      };
    }, {
      "../../components/color": 658,
      "../../lib": 795,
      "../ohlc/ohlc_defaults": 1150,
      "../scatter/period_defaults": 1219,
      "./attributes": 970
    }],
    973: [function (t, e, r) {
      "use strict";

      e.exports = {
        moduleType: "trace",
        name: "candlestick",
        basePlotModule: t("../../plots/cartesian"),
        categories: ["cartesian", "svg", "showLegend", "candlestick", "boxLayout"],
        meta: {},
        attributes: t("./attributes"),
        layoutAttributes: t("../box/layout_attributes"),
        supplyLayoutDefaults: t("../box/layout_defaults").supplyLayoutDefaults,
        crossTraceCalc: t("../box/cross_trace_calc").crossTraceCalc,
        supplyDefaults: t("./defaults"),
        calc: t("./calc"),
        plot: t("../box/plot").plot,
        layerName: "boxlayer",
        style: t("../box/style").style,
        hoverPoints: t("../ohlc/hover").hoverPoints,
        selectPoints: t("../ohlc/select")
      };
    }, {
      "../../plots/cartesian": 858,
      "../box/cross_trace_calc": 960,
      "../box/layout_attributes": 965,
      "../box/layout_defaults": 966,
      "../box/plot": 967,
      "../box/style": 969,
      "../ohlc/hover": 1148,
      "../ohlc/select": 1152,
      "./attributes": 970,
      "./calc": 971,
      "./defaults": 972
    }],
    974: [function (t, e, r) {
      "use strict";

      var n = t("./axis_defaults"),
          i = t("../../plot_api/plot_template");

      e.exports = function (t, e, r, a, o) {
        a("a") || (a("da"), a("a0")), a("b") || (a("db"), a("b0")), function (t, e, r, a) {
          ["aaxis", "baxis"].forEach(function (o) {
            var s = o.charAt(0),
                l = t[o] || {},
                c = i.newContainer(e, o),
                u = {
              tickfont: "x",
              id: s + "axis",
              letter: s,
              font: e.font,
              name: o,
              data: t[s],
              calendar: e.calendar,
              dfltColor: a,
              bgColor: r.paper_bgcolor,
              autotypenumbersDflt: r.autotypenumbers,
              fullLayout: r
            };
            n(l, c, u), c._categories = c._categories || [], t[o] || "-" === l.type || (t[o] = {
              type: l.type
            });
          });
        }(t, e, r, o);
      };
    }, {
      "../../plot_api/plot_template": 834,
      "./axis_defaults": 979
    }],
    975: [function (t, e, r) {
      "use strict";

      var n = t("../../lib").isArrayOrTypedArray;

      e.exports = function (t) {
        return function t(e, r) {
          if (!n(e) || r >= 10) return null;

          for (var i = 1 / 0, a = -1 / 0, o = e.length, s = 0; s < o; s++) {
            var l = e[s];

            if (n(l)) {
              var c = t(l, r + 1);
              c && (i = Math.min(c[0], i), a = Math.max(c[1], a));
            } else i = Math.min(l, i), a = Math.max(l, a);
          }

          return [i, a];
        }(t, 0);
      };
    }, {
      "../../lib": 795
    }],
    976: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/font_attributes"),
          i = t("./axis_attributes"),
          a = t("../../components/color/attributes"),
          o = n({
        editType: "calc"
      });
      o.family.dflt = '"Open Sans", verdana, arial, sans-serif', o.size.dflt = 12, o.color.dflt = a.defaultLine, e.exports = {
        carpet: {
          valType: "string",
          editType: "calc"
        },
        x: {
          valType: "data_array",
          editType: "calc+clearAxisTypes"
        },
        y: {
          valType: "data_array",
          editType: "calc+clearAxisTypes"
        },
        a: {
          valType: "data_array",
          editType: "calc"
        },
        a0: {
          valType: "number",
          dflt: 0,
          editType: "calc"
        },
        da: {
          valType: "number",
          dflt: 1,
          editType: "calc"
        },
        b: {
          valType: "data_array",
          editType: "calc"
        },
        b0: {
          valType: "number",
          dflt: 0,
          editType: "calc"
        },
        db: {
          valType: "number",
          dflt: 1,
          editType: "calc"
        },
        cheaterslope: {
          valType: "number",
          dflt: 1,
          editType: "calc"
        },
        aaxis: i,
        baxis: i,
        font: o,
        color: {
          valType: "color",
          dflt: a.defaultLine,
          editType: "plot"
        },
        transforms: void 0
      };
    }, {
      "../../components/color/attributes": 657,
      "../../plots/font_attributes": 873,
      "./axis_attributes": 978
    }],
    977: [function (t, e, r) {
      "use strict";

      var n = t("../../lib").isArrayOrTypedArray;

      e.exports = function (t, e, r, i) {
        var a,
            o,
            s,
            l,
            c,
            u,
            f,
            h,
            p,
            d,
            m,
            g,
            v,
            y = n(r) ? "a" : "b",
            x = ("a" === y ? t.aaxis : t.baxis).smoothing,
            b = "a" === y ? t.a2i : t.b2j,
            _ = "a" === y ? r : i,
            w = "a" === y ? i : r,
            T = "a" === y ? e.a.length : e.b.length,
            k = "a" === y ? e.b.length : e.a.length,
            M = Math.floor("a" === y ? t.b2j(w) : t.a2i(w)),
            A = "a" === y ? function (e) {
          return t.evalxy([], e, M);
        } : function (e) {
          return t.evalxy([], M, e);
        };

        x && (s = Math.max(0, Math.min(k - 2, M)), l = M - s, o = "a" === y ? function (e, r) {
          return t.dxydi([], e, s, r, l);
        } : function (e, r) {
          return t.dxydj([], s, e, l, r);
        });
        var S = b(_[0]),
            E = b(_[1]),
            L = S < E ? 1 : -1,
            C = 1e-8 * (E - S),
            P = L > 0 ? Math.floor : Math.ceil,
            I = L > 0 ? Math.ceil : Math.floor,
            O = L > 0 ? Math.min : Math.max,
            z = L > 0 ? Math.max : Math.min,
            D = P(S + C),
            R = I(E - C),
            F = [[f = A(S)]];

        for (a = D; a * L < R * L; a += L) {
          c = [], m = z(S, a), v = (g = O(E, a + L)) - m, u = Math.max(0, Math.min(T - 2, Math.floor(.5 * (m + g)))), h = A(g), x && (p = o(u, m - u), d = o(u, g - u), c.push([f[0] + p[0] / 3 * v, f[1] + p[1] / 3 * v]), c.push([h[0] - d[0] / 3 * v, h[1] - d[1] / 3 * v])), c.push(h), F.push(c), f = h;
        }

        return F;
      };
    }, {
      "../../lib": 795
    }],
    978: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/font_attributes"),
          i = t("../../components/color/attributes"),
          a = t("../../plots/cartesian/layout_attributes"),
          o = t("../../plot_api/edit_types").overrideAll,
          s = t("../../constants/docs");
      s.FORMAT_LINK, s.DATE_FORMAT_LINK;
      e.exports = {
        color: {
          valType: "color",
          editType: "calc"
        },
        smoothing: {
          valType: "number",
          dflt: 1,
          min: 0,
          max: 1.3,
          editType: "calc"
        },
        title: {
          text: {
            valType: "string",
            dflt: "",
            editType: "calc"
          },
          font: n({
            editType: "calc"
          }),
          offset: {
            valType: "number",
            dflt: 10,
            editType: "calc"
          },
          editType: "calc"
        },
        type: {
          valType: "enumerated",
          values: ["-", "linear", "date", "category"],
          dflt: "-",
          editType: "calc"
        },
        autotypenumbers: a.autotypenumbers,
        autorange: {
          valType: "enumerated",
          values: [!0, !1, "reversed"],
          dflt: !0,
          editType: "calc"
        },
        rangemode: {
          valType: "enumerated",
          values: ["normal", "tozero", "nonnegative"],
          dflt: "normal",
          editType: "calc"
        },
        range: {
          valType: "info_array",
          editType: "calc",
          items: [{
            valType: "any",
            editType: "calc"
          }, {
            valType: "any",
            editType: "calc"
          }]
        },
        fixedrange: {
          valType: "boolean",
          dflt: !1,
          editType: "calc"
        },
        cheatertype: {
          valType: "enumerated",
          values: ["index", "value"],
          dflt: "value",
          editType: "calc"
        },
        tickmode: {
          valType: "enumerated",
          values: ["linear", "array"],
          dflt: "array",
          editType: "calc"
        },
        nticks: {
          valType: "integer",
          min: 0,
          dflt: 0,
          editType: "calc"
        },
        tickvals: {
          valType: "data_array",
          editType: "calc"
        },
        ticktext: {
          valType: "data_array",
          editType: "calc"
        },
        showticklabels: {
          valType: "enumerated",
          values: ["start", "end", "both", "none"],
          dflt: "start",
          editType: "calc"
        },
        tickfont: n({
          editType: "calc"
        }),
        tickangle: {
          valType: "angle",
          dflt: "auto",
          editType: "calc"
        },
        tickprefix: {
          valType: "string",
          dflt: "",
          editType: "calc"
        },
        showtickprefix: {
          valType: "enumerated",
          values: ["all", "first", "last", "none"],
          dflt: "all",
          editType: "calc"
        },
        ticksuffix: {
          valType: "string",
          dflt: "",
          editType: "calc"
        },
        showticksuffix: {
          valType: "enumerated",
          values: ["all", "first", "last", "none"],
          dflt: "all",
          editType: "calc"
        },
        showexponent: {
          valType: "enumerated",
          values: ["all", "first", "last", "none"],
          dflt: "all",
          editType: "calc"
        },
        exponentformat: {
          valType: "enumerated",
          values: ["none", "e", "E", "power", "SI", "B"],
          dflt: "B",
          editType: "calc"
        },
        minexponent: {
          valType: "number",
          dflt: 3,
          min: 0,
          editType: "calc"
        },
        separatethousands: {
          valType: "boolean",
          dflt: !1,
          editType: "calc"
        },
        tickformat: {
          valType: "string",
          dflt: "",
          editType: "calc"
        },
        tickformatstops: o(a.tickformatstops, "calc", "from-root"),
        categoryorder: {
          valType: "enumerated",
          values: ["trace", "category ascending", "category descending", "array"],
          dflt: "trace",
          editType: "calc"
        },
        categoryarray: {
          valType: "data_array",
          editType: "calc"
        },
        labelpadding: {
          valType: "integer",
          dflt: 10,
          editType: "calc"
        },
        labelprefix: {
          valType: "string",
          editType: "calc"
        },
        labelsuffix: {
          valType: "string",
          dflt: "",
          editType: "calc"
        },
        showline: {
          valType: "boolean",
          dflt: !1,
          editType: "calc"
        },
        linecolor: {
          valType: "color",
          dflt: i.defaultLine,
          editType: "calc"
        },
        linewidth: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "calc"
        },
        gridcolor: {
          valType: "color",
          editType: "calc"
        },
        gridwidth: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "calc"
        },
        showgrid: {
          valType: "boolean",
          dflt: !0,
          editType: "calc"
        },
        minorgridcount: {
          valType: "integer",
          min: 0,
          dflt: 0,
          editType: "calc"
        },
        minorgridwidth: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "calc"
        },
        minorgridcolor: {
          valType: "color",
          dflt: i.lightLine,
          editType: "calc"
        },
        startline: {
          valType: "boolean",
          editType: "calc"
        },
        startlinecolor: {
          valType: "color",
          editType: "calc"
        },
        startlinewidth: {
          valType: "number",
          dflt: 1,
          editType: "calc"
        },
        endline: {
          valType: "boolean",
          editType: "calc"
        },
        endlinewidth: {
          valType: "number",
          dflt: 1,
          editType: "calc"
        },
        endlinecolor: {
          valType: "color",
          editType: "calc"
        },
        tick0: {
          valType: "number",
          min: 0,
          dflt: 0,
          editType: "calc"
        },
        dtick: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "calc"
        },
        arraytick0: {
          valType: "integer",
          min: 0,
          dflt: 0,
          editType: "calc"
        },
        arraydtick: {
          valType: "integer",
          min: 1,
          dflt: 1,
          editType: "calc"
        },
        _deprecated: {
          title: {
            valType: "string",
            editType: "calc"
          },
          titlefont: n({
            editType: "calc"
          }),
          titleoffset: {
            valType: "number",
            dflt: 10,
            editType: "calc"
          }
        },
        editType: "calc"
      };
    }, {
      "../../components/color/attributes": 657,
      "../../constants/docs": 766,
      "../../plot_api/edit_types": 827,
      "../../plots/cartesian/layout_attributes": 859,
      "../../plots/font_attributes": 873
    }],
    979: [function (t, e, r) {
      "use strict";

      var n = t("./attributes"),
          i = t("../../components/color").addOpacity,
          a = t("../../registry"),
          o = t("../../lib"),
          s = t("../../plots/cartesian/tick_value_defaults"),
          l = t("../../plots/cartesian/tick_label_defaults"),
          c = t("../../plots/cartesian/category_order_defaults"),
          u = t("../../plots/cartesian/set_convert"),
          f = t("../../plots/cartesian/axis_autotype");

      e.exports = function (t, e, r) {
        var h = r.letter,
            p = r.font || {},
            d = n[h + "axis"];

        function m(r, n) {
          return o.coerce(t, e, d, r, n);
        }

        function g(r, n) {
          return o.coerce2(t, e, d, r, n);
        }

        r.name && (e._name = r.name, e._id = r.name), m("autotypenumbers", r.autotypenumbersDflt);
        var v = m("type");
        ("-" === v && (r.data && function (t, e) {
          if ("-" !== t.type) return;

          var r = t._id.charAt(0),
              n = t[r + "calendar"];

          t.type = f(e, n, {
            autotypenumbers: t.autotypenumbers
          });
        }(e, r.data), "-" === e.type ? e.type = "linear" : v = t.type = e.type), m("smoothing"), m("cheatertype"), m("showticklabels"), m("labelprefix", h + " = "), m("labelsuffix"), m("showtickprefix"), m("showticksuffix"), m("separatethousands"), m("tickformat"), m("exponentformat"), m("minexponent"), m("showexponent"), m("categoryorder"), m("tickmode"), m("tickvals"), m("ticktext"), m("tick0"), m("dtick"), "array" === e.tickmode && (m("arraytick0"), m("arraydtick")), m("labelpadding"), e._hovertitle = h, "date" === v) && a.getComponentMethod("calendars", "handleDefaults")(t, e, "calendar", r.calendar);
        u(e, r.fullLayout), e.c2p = o.identity;
        var y = m("color", r.dfltColor),
            x = y === t.color ? y : p.color;
        m("title.text") && (o.coerceFont(m, "title.font", {
          family: p.family,
          size: o.bigFont(p.size),
          color: x
        }), m("title.offset")), m("tickangle"), m("autorange", !e.isValidRange(t.range)) && m("rangemode"), m("range"), e.cleanRange(), m("fixedrange"), s(t, e, m, v), l(t, e, m, v, r), c(t, e, m, {
          data: r.data,
          dataAttr: h
        });

        var b = g("gridcolor", i(y, .3)),
            _ = g("gridwidth"),
            w = m("showgrid");

        w || (delete e.gridcolor, delete e.gridwidth);
        var T = g("startlinecolor", y),
            k = g("startlinewidth", _);
        m("startline", e.showgrid || !!T || !!k) || (delete e.startlinecolor, delete e.startlinewidth);
        var M = g("endlinecolor", y),
            A = g("endlinewidth", _);
        return m("endline", e.showgrid || !!M || !!A) || (delete e.endlinecolor, delete e.endlinewidth), w ? (m("minorgridcount"), m("minorgridwidth", _), m("minorgridcolor", i(b, .06)), e.minorgridcount || (delete e.minorgridwidth, delete e.minorgridcolor)) : (delete e.gridcolor, delete e.gridWidth), "none" === e.showticklabels && (delete e.tickfont, delete e.tickangle, delete e.showexponent, delete e.exponentformat, delete e.minexponent, delete e.tickformat, delete e.showticksuffix, delete e.showtickprefix), e.showticksuffix || delete e.ticksuffix, e.showtickprefix || delete e.tickprefix, m("tickmode"), e;
      };
    }, {
      "../../components/color": 658,
      "../../lib": 795,
      "../../plots/cartesian/axis_autotype": 846,
      "../../plots/cartesian/category_order_defaults": 849,
      "../../plots/cartesian/set_convert": 865,
      "../../plots/cartesian/tick_label_defaults": 866,
      "../../plots/cartesian/tick_value_defaults": 868,
      "../../registry": 923,
      "./attributes": 976
    }],
    980: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/cartesian/axes"),
          i = t("../../lib").isArray1D,
          a = t("./cheater_basis"),
          o = t("./array_minmax"),
          s = t("./calc_gridlines"),
          l = t("./calc_labels"),
          c = t("./calc_clippath"),
          u = t("../heatmap/clean_2d_array"),
          f = t("./smooth_fill_2d_array"),
          h = t("../heatmap/convert_column_xyz"),
          p = t("./set_convert");

      e.exports = function (t, e) {
        var r = n.getFromId(t, e.xaxis),
            d = n.getFromId(t, e.yaxis),
            m = e.aaxis,
            g = e.baxis,
            v = e.x,
            y = e.y,
            x = [];
        v && i(v) && x.push("x"), y && i(y) && x.push("y"), x.length && h(e, m, g, "a", "b", x);

        var b = e._a = e._a || e.a,
            _ = e._b = e._b || e.b;

        v = e._x || e.x, y = e._y || e.y;
        var w = {};

        if (e._cheater) {
          var T = "index" === m.cheatertype ? b.length : b,
              k = "index" === g.cheatertype ? _.length : _;
          v = a(T, k, e.cheaterslope);
        }

        e._x = v = u(v), e._y = y = u(y), f(v, b, _), f(y, b, _), p(e), e.setScale();
        var M = o(v),
            A = o(y),
            S = .5 * (M[1] - M[0]),
            E = .5 * (M[1] + M[0]),
            L = .5 * (A[1] - A[0]),
            C = .5 * (A[1] + A[0]);
        return M = [E - 1.3 * S, E + 1.3 * S], A = [C - 1.3 * L, C + 1.3 * L], e._extremes[r._id] = n.findExtremes(r, M, {
          padded: !0
        }), e._extremes[d._id] = n.findExtremes(d, A, {
          padded: !0
        }), s(e, "a", "b"), s(e, "b", "a"), l(e, m), l(e, g), w.clipsegments = c(e._xctrl, e._yctrl, m, g), w.x = v, w.y = y, w.a = b, w.b = _, [w];
      };
    }, {
      "../../lib": 795,
      "../../plots/cartesian/axes": 845,
      "../heatmap/clean_2d_array": 1079,
      "../heatmap/convert_column_xyz": 1081,
      "./array_minmax": 975,
      "./calc_clippath": 981,
      "./calc_gridlines": 982,
      "./calc_labels": 983,
      "./cheater_basis": 985,
      "./set_convert": 998,
      "./smooth_fill_2d_array": 999
    }],
    981: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, n) {
        var i,
            a,
            o,
            s = [],
            l = !!r.smoothing,
            c = !!n.smoothing,
            u = t[0].length - 1,
            f = t.length - 1;

        for (i = 0, a = [], o = []; i <= u; i++) {
          a[i] = t[0][i], o[i] = e[0][i];
        }

        for (s.push({
          x: a,
          y: o,
          bicubic: l
        }), i = 0, a = [], o = []; i <= f; i++) {
          a[i] = t[i][u], o[i] = e[i][u];
        }

        for (s.push({
          x: a,
          y: o,
          bicubic: c
        }), i = u, a = [], o = []; i >= 0; i--) {
          a[u - i] = t[f][i], o[u - i] = e[f][i];
        }

        for (s.push({
          x: a,
          y: o,
          bicubic: l
        }), i = f, a = [], o = []; i >= 0; i--) {
          a[f - i] = t[i][0], o[f - i] = e[i][0];
        }

        return s.push({
          x: a,
          y: o,
          bicubic: c
        }), s;
      };
    }, {}],
    982: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/cartesian/axes"),
          i = t("../../lib/extend").extendFlat;

      e.exports = function (t, e, r) {
        var a,
            o,
            s,
            l,
            c,
            u,
            f,
            h,
            p,
            d,
            m,
            g,
            v,
            y,
            x = t["_" + e],
            b = t[e + "axis"],
            _ = b._gridlines = [],
            w = b._minorgridlines = [],
            T = b._boundarylines = [],
            k = t["_" + r],
            M = t[r + "axis"];

        "array" === b.tickmode && (b.tickvals = x.slice());
        var A = t._xctrl,
            S = t._yctrl,
            E = A[0].length,
            L = A.length,
            C = t._a.length,
            P = t._b.length;
        n.prepTicks(b), "array" === b.tickmode && delete b.tickvals;
        var I = b.smoothing ? 3 : 1;

        function O(n) {
          var i,
              a,
              o,
              s,
              l,
              c,
              u,
              f,
              p,
              d,
              m,
              g,
              v = [],
              y = [],
              x = {};
          if ("b" === e) for (a = t.b2j(n), o = Math.floor(Math.max(0, Math.min(P - 2, a))), s = a - o, x.length = P, x.crossLength = C, x.xy = function (e) {
            return t.evalxy([], e, a);
          }, x.dxy = function (e, r) {
            return t.dxydi([], e, o, r, s);
          }, i = 0; i < C; i++) {
            c = Math.min(C - 2, i), u = i - c, f = t.evalxy([], i, a), M.smoothing && i > 0 && (p = t.dxydi([], i - 1, o, 0, s), v.push(l[0] + p[0] / 3), y.push(l[1] + p[1] / 3), d = t.dxydi([], i - 1, o, 1, s), v.push(f[0] - d[0] / 3), y.push(f[1] - d[1] / 3)), v.push(f[0]), y.push(f[1]), l = f;
          } else for (i = t.a2i(n), c = Math.floor(Math.max(0, Math.min(C - 2, i))), u = i - c, x.length = C, x.crossLength = P, x.xy = function (e) {
            return t.evalxy([], i, e);
          }, x.dxy = function (e, r) {
            return t.dxydj([], c, e, u, r);
          }, a = 0; a < P; a++) {
            o = Math.min(P - 2, a), s = a - o, f = t.evalxy([], i, a), M.smoothing && a > 0 && (m = t.dxydj([], c, a - 1, u, 0), v.push(l[0] + m[0] / 3), y.push(l[1] + m[1] / 3), g = t.dxydj([], c, a - 1, u, 1), v.push(f[0] - g[0] / 3), y.push(f[1] - g[1] / 3)), v.push(f[0]), y.push(f[1]), l = f;
          }
          return x.axisLetter = e, x.axis = b, x.crossAxis = M, x.value = n, x.constvar = r, x.index = h, x.x = v, x.y = y, x.smoothing = M.smoothing, x;
        }

        function z(n) {
          var i,
              a,
              o,
              s,
              l,
              c = [],
              u = [],
              f = {};
          if (f.length = x.length, f.crossLength = k.length, "b" === e) for (o = Math.max(0, Math.min(P - 2, n)), l = Math.min(1, Math.max(0, n - o)), f.xy = function (e) {
            return t.evalxy([], e, n);
          }, f.dxy = function (e, r) {
            return t.dxydi([], e, o, r, l);
          }, i = 0; i < E; i++) {
            c[i] = A[n * I][i], u[i] = S[n * I][i];
          } else for (a = Math.max(0, Math.min(C - 2, n)), s = Math.min(1, Math.max(0, n - a)), f.xy = function (e) {
            return t.evalxy([], n, e);
          }, f.dxy = function (e, r) {
            return t.dxydj([], a, e, s, r);
          }, i = 0; i < L; i++) {
            c[i] = A[i][n * I], u[i] = S[i][n * I];
          }
          return f.axisLetter = e, f.axis = b, f.crossAxis = M, f.value = x[n], f.constvar = r, f.index = n, f.x = c, f.y = u, f.smoothing = M.smoothing, f;
        }

        if ("array" === b.tickmode) {
          for (l = 5e-15, u = (c = [Math.floor((x.length - 1 - b.arraytick0) / b.arraydtick * (1 + l)), Math.ceil(-b.arraytick0 / b.arraydtick / (1 + l))].sort(function (t, e) {
            return t - e;
          }))[0] - 1, f = c[1] + 1, h = u; h < f; h++) {
            (o = b.arraytick0 + b.arraydtick * h) < 0 || o > x.length - 1 || _.push(i(z(o), {
              color: b.gridcolor,
              width: b.gridwidth
            }));
          }

          for (h = u; h < f; h++) {
            if (s = b.arraytick0 + b.arraydtick * h, m = Math.min(s + b.arraydtick, x.length - 1), !(s < 0 || s > x.length - 1 || m < 0 || m > x.length - 1)) for (g = x[s], v = x[m], a = 0; a < b.minorgridcount; a++) {
              (y = m - s) <= 0 || (d = g + (v - g) * (a + 1) / (b.minorgridcount + 1) * (b.arraydtick / y)) < x[0] || d > x[x.length - 1] || w.push(i(O(d), {
                color: b.minorgridcolor,
                width: b.minorgridwidth
              }));
            }
          }

          b.startline && T.push(i(z(0), {
            color: b.startlinecolor,
            width: b.startlinewidth
          })), b.endline && T.push(i(z(x.length - 1), {
            color: b.endlinecolor,
            width: b.endlinewidth
          }));
        } else {
          for (l = 5e-15, u = (c = [Math.floor((x[x.length - 1] - b.tick0) / b.dtick * (1 + l)), Math.ceil((x[0] - b.tick0) / b.dtick / (1 + l))].sort(function (t, e) {
            return t - e;
          }))[0], f = c[1], h = u; h <= f; h++) {
            p = b.tick0 + b.dtick * h, _.push(i(O(p), {
              color: b.gridcolor,
              width: b.gridwidth
            }));
          }

          for (h = u - 1; h < f + 1; h++) {
            for (p = b.tick0 + b.dtick * h, a = 0; a < b.minorgridcount; a++) {
              (d = p + b.dtick * (a + 1) / (b.minorgridcount + 1)) < x[0] || d > x[x.length - 1] || w.push(i(O(d), {
                color: b.minorgridcolor,
                width: b.minorgridwidth
              }));
            }
          }

          b.startline && T.push(i(O(x[0]), {
            color: b.startlinecolor,
            width: b.startlinewidth
          })), b.endline && T.push(i(O(x[x.length - 1]), {
            color: b.endlinecolor,
            width: b.endlinewidth
          }));
        }
      };
    }, {
      "../../lib/extend": 785,
      "../../plots/cartesian/axes": 845
    }],
    983: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/cartesian/axes"),
          i = t("../../lib/extend").extendFlat;

      e.exports = function (t, e) {
        var r,
            a,
            o,
            s = e._labels = [],
            l = e._gridlines;

        for (r = 0; r < l.length; r++) {
          o = l[r], -1 !== ["start", "both"].indexOf(e.showticklabels) && (a = n.tickText(e, o.value), i(a, {
            prefix: void 0,
            suffix: void 0,
            endAnchor: !0,
            xy: o.xy(0),
            dxy: o.dxy(0, 0),
            axis: o.axis,
            length: o.crossAxis.length,
            font: o.axis.tickfont,
            isFirst: 0 === r,
            isLast: r === l.length - 1
          }), s.push(a)), -1 !== ["end", "both"].indexOf(e.showticklabels) && (a = n.tickText(e, o.value), i(a, {
            endAnchor: !1,
            xy: o.xy(o.crossLength - 1),
            dxy: o.dxy(o.crossLength - 2, 1),
            axis: o.axis,
            length: o.crossAxis.length,
            font: o.axis.tickfont,
            isFirst: 0 === r,
            isLast: r === l.length - 1
          }), s.push(a));
        }
      };
    }, {
      "../../lib/extend": 785,
      "../../plots/cartesian/axes": 845
    }],
    984: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, n) {
        var i = t[0] - e[0],
            a = t[1] - e[1],
            o = r[0] - e[0],
            s = r[1] - e[1],
            l = Math.pow(i * i + a * a, .25),
            c = Math.pow(o * o + s * s, .25),
            u = (c * c * i - l * l * o) * n,
            f = (c * c * a - l * l * s) * n,
            h = c * (l + c) * 3,
            p = l * (l + c) * 3;
        return [[e[0] + (h && u / h), e[1] + (h && f / h)], [e[0] - (p && u / p), e[1] - (p && f / p)]];
      };
    }, {}],
    985: [function (t, e, r) {
      "use strict";

      var n = t("../../lib").isArrayOrTypedArray;

      e.exports = function (t, e, r) {
        var i,
            a,
            o,
            s,
            l,
            c,
            u = [],
            f = n(t) ? t.length : t,
            h = n(e) ? e.length : e,
            p = n(t) ? t : null,
            d = n(e) ? e : null;
        p && (o = (p.length - 1) / (p[p.length - 1] - p[0]) / (f - 1)), d && (s = (d.length - 1) / (d[d.length - 1] - d[0]) / (h - 1));
        var m = 1 / 0,
            g = -1 / 0;

        for (a = 0; a < h; a++) {
          for (u[a] = [], l = d ? (d[a] - d[0]) * s : a / (h - 1), i = 0; i < f; i++) {
            c = (p ? (p[i] - p[0]) * o : i / (f - 1)) - l * r, m = Math.min(c, m), g = Math.max(c, g), u[a][i] = c;
          }
        }

        var v = 1 / (g - m),
            y = -m * v;

        for (a = 0; a < h; a++) {
          for (i = 0; i < f; i++) {
            u[a][i] = v * u[a][i] + y;
          }
        }

        return u;
      };
    }, {
      "../../lib": 795
    }],
    986: [function (t, e, r) {
      "use strict";

      var n = t("./catmull_rom"),
          i = t("../../lib").ensureArray;

      function a(t, e, r) {
        var n = -.5 * r[0] + 1.5 * e[0],
            i = -.5 * r[1] + 1.5 * e[1];
        return [(2 * n + t[0]) / 3, (2 * i + t[1]) / 3];
      }

      e.exports = function (t, e, r, o, s, l) {
        var c,
            u,
            f,
            h,
            p,
            d,
            m,
            g,
            v,
            y,
            x = r[0].length,
            b = r.length,
            _ = s ? 3 * x - 2 : x,
            w = l ? 3 * b - 2 : b;

        for (t = i(t, w), e = i(e, w), f = 0; f < w; f++) {
          t[f] = i(t[f], _), e[f] = i(e[f], _);
        }

        for (u = 0, h = 0; u < b; u++, h += l ? 3 : 1) {
          for (p = t[h], d = e[h], m = r[u], g = o[u], c = 0, f = 0; c < x; c++, f += s ? 3 : 1) {
            p[f] = m[c], d[f] = g[c];
          }
        }

        if (s) for (u = 0, h = 0; u < b; u++, h += l ? 3 : 1) {
          for (c = 1, f = 3; c < x - 1; c++, f += 3) {
            v = n([r[u][c - 1], o[u][c - 1]], [r[u][c], o[u][c]], [r[u][c + 1], o[u][c + 1]], s), t[h][f - 1] = v[0][0], e[h][f - 1] = v[0][1], t[h][f + 1] = v[1][0], e[h][f + 1] = v[1][1];
          }

          y = a([t[h][0], e[h][0]], [t[h][2], e[h][2]], [t[h][3], e[h][3]]), t[h][1] = y[0], e[h][1] = y[1], y = a([t[h][_ - 1], e[h][_ - 1]], [t[h][_ - 3], e[h][_ - 3]], [t[h][_ - 4], e[h][_ - 4]]), t[h][_ - 2] = y[0], e[h][_ - 2] = y[1];
        }
        if (l) for (f = 0; f < _; f++) {
          for (h = 3; h < w - 3; h += 3) {
            v = n([t[h - 3][f], e[h - 3][f]], [t[h][f], e[h][f]], [t[h + 3][f], e[h + 3][f]], l), t[h - 1][f] = v[0][0], e[h - 1][f] = v[0][1], t[h + 1][f] = v[1][0], e[h + 1][f] = v[1][1];
          }

          y = a([t[0][f], e[0][f]], [t[2][f], e[2][f]], [t[3][f], e[3][f]]), t[1][f] = y[0], e[1][f] = y[1], y = a([t[w - 1][f], e[w - 1][f]], [t[w - 3][f], e[w - 3][f]], [t[w - 4][f], e[w - 4][f]]), t[w - 2][f] = y[0], e[w - 2][f] = y[1];
        }
        if (s && l) for (h = 1; h < w; h += (h + 1) % 3 == 0 ? 2 : 1) {
          for (f = 3; f < _ - 3; f += 3) {
            v = n([t[h][f - 3], e[h][f - 3]], [t[h][f], e[h][f]], [t[h][f + 3], e[h][f + 3]], s), t[h][f - 1] = .5 * (t[h][f - 1] + v[0][0]), e[h][f - 1] = .5 * (e[h][f - 1] + v[0][1]), t[h][f + 1] = .5 * (t[h][f + 1] + v[1][0]), e[h][f + 1] = .5 * (e[h][f + 1] + v[1][1]);
          }

          y = a([t[h][0], e[h][0]], [t[h][2], e[h][2]], [t[h][3], e[h][3]]), t[h][1] = .5 * (t[h][1] + y[0]), e[h][1] = .5 * (e[h][1] + y[1]), y = a([t[h][_ - 1], e[h][_ - 1]], [t[h][_ - 3], e[h][_ - 3]], [t[h][_ - 4], e[h][_ - 4]]), t[h][_ - 2] = .5 * (t[h][_ - 2] + y[0]), e[h][_ - 2] = .5 * (e[h][_ - 2] + y[1]);
        }
        return [t, e];
      };
    }, {
      "../../lib": 795,
      "./catmull_rom": 984
    }],
    987: [function (t, e, r) {
      "use strict";

      e.exports = {
        RELATIVE_CULL_TOLERANCE: 1e-6
      };
    }, {}],
    988: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r) {
        return e && r ? function (e, r, n, i, a) {
          var o, s, l, c, u, f;
          e || (e = []), r *= 3, n *= 3;

          var h = i * i,
              p = 1 - i,
              d = p * p,
              m = p * i * 2,
              g = -3 * d,
              v = 3 * (d - m),
              y = 3 * (m - h),
              x = 3 * h,
              b = a * a,
              _ = b * a,
              w = 1 - a,
              T = w * w,
              k = T * w;

          for (f = 0; f < t.length; f++) {
            o = g * (u = t[f])[n][r] + v * u[n][r + 1] + y * u[n][r + 2] + x * u[n][r + 3], s = g * u[n + 1][r] + v * u[n + 1][r + 1] + y * u[n + 1][r + 2] + x * u[n + 1][r + 3], l = g * u[n + 2][r] + v * u[n + 2][r + 1] + y * u[n + 2][r + 2] + x * u[n + 2][r + 3], c = g * u[n + 3][r] + v * u[n + 3][r + 1] + y * u[n + 3][r + 2] + x * u[n + 3][r + 3], e[f] = k * o + 3 * (T * a * s + w * b * l) + _ * c;
          }

          return e;
        } : e ? function (e, r, n, i, a) {
          var o, s, l, c;
          e || (e = []), r *= 3;
          var u = i * i,
              f = 1 - i,
              h = f * f,
              p = f * i * 2,
              d = -3 * h,
              m = 3 * (h - p),
              g = 3 * (p - u),
              v = 3 * u,
              y = 1 - a;

          for (l = 0; l < t.length; l++) {
            o = d * (c = t[l])[n][r] + m * c[n][r + 1] + g * c[n][r + 2] + v * c[n][r + 3], s = d * c[n + 1][r] + m * c[n + 1][r + 1] + g * c[n + 1][r + 2] + v * c[n + 1][r + 3], e[l] = y * o + a * s;
          }

          return e;
        } : r ? function (e, r, n, i, a) {
          var o, s, l, c, u, f;
          e || (e = []), n *= 3;
          var h = a * a,
              p = h * a,
              d = 1 - a,
              m = d * d,
              g = m * d;

          for (u = 0; u < t.length; u++) {
            o = (f = t[u])[n][r + 1] - f[n][r], s = f[n + 1][r + 1] - f[n + 1][r], l = f[n + 2][r + 1] - f[n + 2][r], c = f[n + 3][r + 1] - f[n + 3][r], e[u] = g * o + 3 * (m * a * s + d * h * l) + p * c;
          }

          return e;
        } : function (e, r, n, i, a) {
          var o, s, l, c;
          e || (e = []);
          var u = 1 - a;

          for (l = 0; l < t.length; l++) {
            o = (c = t[l])[n][r + 1] - c[n][r], s = c[n + 1][r + 1] - c[n + 1][r], e[l] = u * o + a * s;
          }

          return e;
        };
      };
    }, {}],
    989: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r) {
        return e && r ? function (e, r, n, i, a) {
          var o, s, l, c, u, f;
          e || (e = []), r *= 3, n *= 3;

          var h = i * i,
              p = h * i,
              d = 1 - i,
              m = d * d,
              g = m * d,
              v = a * a,
              y = 1 - a,
              x = y * y,
              b = y * a * 2,
              _ = -3 * x,
              w = 3 * (x - b),
              T = 3 * (b - v),
              k = 3 * v;

          for (f = 0; f < t.length; f++) {
            o = _ * (u = t[f])[n][r] + w * u[n + 1][r] + T * u[n + 2][r] + k * u[n + 3][r], s = _ * u[n][r + 1] + w * u[n + 1][r + 1] + T * u[n + 2][r + 1] + k * u[n + 3][r + 1], l = _ * u[n][r + 2] + w * u[n + 1][r + 2] + T * u[n + 2][r + 2] + k * u[n + 3][r + 2], c = _ * u[n][r + 3] + w * u[n + 1][r + 3] + T * u[n + 2][r + 3] + k * u[n + 3][r + 3], e[f] = g * o + 3 * (m * i * s + d * h * l) + p * c;
          }

          return e;
        } : e ? function (e, r, n, i, a) {
          var o, s, l, c, u, f;
          e || (e = []), r *= 3;
          var h = a * a,
              p = h * a,
              d = 1 - a,
              m = d * d,
              g = m * d;

          for (u = 0; u < t.length; u++) {
            o = (f = t[u])[n + 1][r] - f[n][r], s = f[n + 1][r + 1] - f[n][r + 1], l = f[n + 1][r + 2] - f[n][r + 2], c = f[n + 1][r + 3] - f[n][r + 3], e[u] = g * o + 3 * (m * a * s + d * h * l) + p * c;
          }

          return e;
        } : r ? function (e, r, n, i, a) {
          var o, s, l, c;
          e || (e = []), n *= 3;
          var u = 1 - i,
              f = a * a,
              h = 1 - a,
              p = h * h,
              d = h * a * 2,
              m = -3 * p,
              g = 3 * (p - d),
              v = 3 * (d - f),
              y = 3 * f;

          for (l = 0; l < t.length; l++) {
            o = m * (c = t[l])[n][r] + g * c[n + 1][r] + v * c[n + 2][r] + y * c[n + 3][r], s = m * c[n][r + 1] + g * c[n + 1][r + 1] + v * c[n + 2][r + 1] + y * c[n + 3][r + 1], e[l] = u * o + i * s;
          }

          return e;
        } : function (e, r, n, i, a) {
          var o, s, l, c;
          e || (e = []);
          var u = 1 - i;

          for (l = 0; l < t.length; l++) {
            o = (c = t[l])[n + 1][r] - c[n][r], s = c[n + 1][r + 1] - c[n][r + 1], e[l] = u * o + i * s;
          }

          return e;
        };
      };
    }, {}],
    990: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, n, i) {
        var a = e - 2,
            o = r - 2;
        return n && i ? function (e, r, n) {
          var i, s, l, c, u, f;
          e || (e = []);
          var h = Math.max(0, Math.min(Math.floor(r), a)),
              p = Math.max(0, Math.min(Math.floor(n), o)),
              d = Math.max(0, Math.min(1, r - h)),
              m = Math.max(0, Math.min(1, n - p));
          h *= 3, p *= 3;

          var g = d * d,
              v = g * d,
              y = 1 - d,
              x = y * y,
              b = x * y,
              _ = m * m,
              w = _ * m,
              T = 1 - m,
              k = T * T,
              M = k * T;

          for (f = 0; f < t.length; f++) {
            i = b * (u = t[f])[p][h] + 3 * (x * d * u[p][h + 1] + y * g * u[p][h + 2]) + v * u[p][h + 3], s = b * u[p + 1][h] + 3 * (x * d * u[p + 1][h + 1] + y * g * u[p + 1][h + 2]) + v * u[p + 1][h + 3], l = b * u[p + 2][h] + 3 * (x * d * u[p + 2][h + 1] + y * g * u[p + 2][h + 2]) + v * u[p + 2][h + 3], c = b * u[p + 3][h] + 3 * (x * d * u[p + 3][h + 1] + y * g * u[p + 3][h + 2]) + v * u[p + 3][h + 3], e[f] = M * i + 3 * (k * m * s + T * _ * l) + w * c;
          }

          return e;
        } : n ? function (e, r, n) {
          e || (e = []);
          var i,
              s,
              l,
              c,
              u,
              f,
              h = Math.max(0, Math.min(Math.floor(r), a)),
              p = Math.max(0, Math.min(Math.floor(n), o)),
              d = Math.max(0, Math.min(1, r - h)),
              m = Math.max(0, Math.min(1, n - p));
          h *= 3;

          var g = d * d,
              v = g * d,
              y = 1 - d,
              x = y * y,
              b = x * y,
              _ = 1 - m;

          for (u = 0; u < t.length; u++) {
            i = _ * (f = t[u])[p][h] + m * f[p + 1][h], s = _ * f[p][h + 1] + m * f[p + 1][h + 1], l = _ * f[p][h + 2] + m * f[p + 1][h + 1], c = _ * f[p][h + 3] + m * f[p + 1][h + 1], e[u] = b * i + 3 * (x * d * s + y * g * l) + v * c;
          }

          return e;
        } : i ? function (e, r, n) {
          e || (e = []);
          var i,
              s,
              l,
              c,
              u,
              f,
              h = Math.max(0, Math.min(Math.floor(r), a)),
              p = Math.max(0, Math.min(Math.floor(n), o)),
              d = Math.max(0, Math.min(1, r - h)),
              m = Math.max(0, Math.min(1, n - p));
          p *= 3;

          var g = m * m,
              v = g * m,
              y = 1 - m,
              x = y * y,
              b = x * y,
              _ = 1 - d;

          for (u = 0; u < t.length; u++) {
            i = _ * (f = t[u])[p][h] + d * f[p][h + 1], s = _ * f[p + 1][h] + d * f[p + 1][h + 1], l = _ * f[p + 2][h] + d * f[p + 2][h + 1], c = _ * f[p + 3][h] + d * f[p + 3][h + 1], e[u] = b * i + 3 * (x * m * s + y * g * l) + v * c;
          }

          return e;
        } : function (e, r, n) {
          e || (e = []);
          var i,
              s,
              l,
              c,
              u = Math.max(0, Math.min(Math.floor(r), a)),
              f = Math.max(0, Math.min(Math.floor(n), o)),
              h = Math.max(0, Math.min(1, r - u)),
              p = Math.max(0, Math.min(1, n - f)),
              d = 1 - p,
              m = 1 - h;

          for (l = 0; l < t.length; l++) {
            i = m * (c = t[l])[f][u] + h * c[f][u + 1], s = m * c[f + 1][u] + h * c[f + 1][u + 1], e[l] = d * i + p * s;
          }

          return e;
        };
      };
    }, {}],
    991: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./xy_defaults"),
          a = t("./ab_defaults"),
          o = t("./attributes"),
          s = t("../../components/color/attributes");

      e.exports = function (t, e, r, l) {
        function c(r, i) {
          return n.coerce(t, e, o, r, i);
        }

        e._clipPathId = "clip" + e.uid + "carpet";
        var u = c("color", s.defaultLine);
        (n.coerceFont(c, "font"), c("carpet"), a(t, e, l, c, u), e.a && e.b) ? (e.a.length < 3 && (e.aaxis.smoothing = 0), e.b.length < 3 && (e.baxis.smoothing = 0), i(t, e, c) || (e.visible = !1), e._cheater && c("cheaterslope")) : e.visible = !1;
      };
    }, {
      "../../components/color/attributes": 657,
      "../../lib": 795,
      "./ab_defaults": 974,
      "./attributes": 976,
      "./xy_defaults": 1e3
    }],
    992: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        plot: t("./plot"),
        calc: t("./calc"),
        animatable: !0,
        isContainer: !0,
        moduleType: "trace",
        name: "carpet",
        basePlotModule: t("../../plots/cartesian"),
        categories: ["cartesian", "svg", "carpet", "carpetAxis", "notLegendIsolatable", "noMultiCategory", "noHover", "noSortingByValue"],
        meta: {}
      };
    }, {
      "../../plots/cartesian": 858,
      "./attributes": 976,
      "./calc": 980,
      "./defaults": 991,
      "./plot": 997
    }],
    993: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        for (var r, n = t._fullData.length, i = 0; i < n; i++) {
          var a = t._fullData[i];
          if (a.index !== e.index && "carpet" === a.type && (r || (r = a), a.carpet === e.carpet)) return a;
        }

        return r;
      };
    }, {}],
    994: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r) {
        if (0 === t.length) return "";
        var n,
            i = [],
            a = r ? 3 : 1;

        for (n = 0; n < t.length; n += a) {
          i.push(t[n] + "," + e[n]), r && n < t.length - a && (i.push("C"), i.push([t[n + 1] + "," + e[n + 1], t[n + 2] + "," + e[n + 2] + " "].join(" ")));
        }

        return i.join(r ? "" : "L");
      };
    }, {}],
    995: [function (t, e, r) {
      "use strict";

      var n = t("../../lib").isArrayOrTypedArray;

      e.exports = function (t, e, r) {
        var i;

        for (n(t) ? t.length > e.length && (t = t.slice(0, e.length)) : t = [], i = 0; i < e.length; i++) {
          t[i] = r(e[i]);
        }

        return t;
      };
    }, {
      "../../lib": 795
    }],
    996: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, n, i, a) {
        var o = i[0] * t.dpdx(e),
            s = i[1] * t.dpdy(r),
            l = 1,
            c = 1;

        if (a) {
          var u = Math.sqrt(i[0] * i[0] + i[1] * i[1]),
              f = Math.sqrt(a[0] * a[0] + a[1] * a[1]),
              h = (i[0] * a[0] + i[1] * a[1]) / u / f;
          c = Math.max(0, h);
        }

        var p = 180 * Math.atan2(s, o) / Math.PI;
        return p < -90 ? (p += 180, l = -l) : p > 90 && (p -= 180, l = -l), {
          angle: p,
          flip: l,
          p: t.c2p(n, e, r),
          offsetMultplier: c
        };
      };
    }, {}],
    997: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../components/drawing"),
          a = t("./map_1d_array"),
          o = t("./makepath"),
          s = t("./orient_text"),
          l = t("../../lib/svg_text_utils"),
          c = t("../../lib"),
          u = c.strRotate,
          f = c.strTranslate,
          h = t("../../constants/alignment");

      function p(t, e, r, i, s, l) {
        var c = "const-" + s + "-lines",
            u = r.selectAll("." + c).data(l);
        u.enter().append("path").classed(c, !0).style("vector-effect", "non-scaling-stroke"), u.each(function (r) {
          var i = r,
              s = i.x,
              l = i.y,
              c = a([], s, t.c2p),
              u = a([], l, e.c2p),
              f = "M" + o(c, u, i.smoothing);
          n.select(this).attr("d", f).style("stroke-width", i.width).style("stroke", i.color).style("fill", "none");
        }), u.exit().remove();
      }

      function d(t, e, r, a, o, c, h, p) {
        var d = c.selectAll("text." + p).data(h);
        d.enter().append("text").classed(p, !0);
        var m = 0,
            g = {};
        return d.each(function (o, c) {
          var h;
          if ("auto" === o.axis.tickangle) h = s(a, e, r, o.xy, o.dxy);else {
            var p = (o.axis.tickangle + 180) * Math.PI / 180;
            h = s(a, e, r, o.xy, [Math.cos(p), Math.sin(p)]);
          }
          c || (g = {
            angle: h.angle,
            flip: h.flip
          });
          var d = (o.endAnchor ? -1 : 1) * h.flip,
              v = n.select(this).attr({
            "text-anchor": d > 0 ? "start" : "end",
            "data-notex": 1
          }).call(i.font, o.font).text(o.text).call(l.convertToTspans, t),
              y = i.bBox(this);
          v.attr("transform", f(h.p[0], h.p[1]) + u(h.angle) + f(o.axis.labelpadding * d, .3 * y.height)), m = Math.max(m, y.width + o.axis.labelpadding);
        }), d.exit().remove(), g.maxExtent = m, g;
      }

      e.exports = function (t, e, r, i) {
        var l = e.xaxis,
            u = e.yaxis,
            f = t._fullLayout._clips;
        c.makeTraceGroups(i, r, "trace").each(function (e) {
          var r = n.select(this),
              i = e[0],
              h = i.trace,
              m = h.aaxis,
              g = h.baxis,
              y = c.ensureSingle(r, "g", "minorlayer"),
              x = c.ensureSingle(r, "g", "majorlayer"),
              b = c.ensureSingle(r, "g", "boundarylayer"),
              _ = c.ensureSingle(r, "g", "labellayer");

          r.style("opacity", h.opacity), p(l, u, x, m, "a", m._gridlines), p(l, u, x, g, "b", g._gridlines), p(l, u, y, m, "a", m._minorgridlines), p(l, u, y, g, "b", g._minorgridlines), p(l, u, b, m, "a-boundary", m._boundarylines), p(l, u, b, g, "b-boundary", g._boundarylines);
          var w = d(t, l, u, h, i, _, m._labels, "a-label"),
              T = d(t, l, u, h, i, _, g._labels, "b-label");
          !function (t, e, r, n, i, a, o, l) {
            var u,
                f,
                h,
                p,
                d = c.aggNums(Math.min, null, r.a),
                m = c.aggNums(Math.max, null, r.a),
                g = c.aggNums(Math.min, null, r.b),
                y = c.aggNums(Math.max, null, r.b);
            u = .5 * (d + m), f = g, h = r.ab2xy(u, f, !0), p = r.dxyda_rough(u, f), void 0 === o.angle && c.extendFlat(o, s(r, i, a, h, r.dxydb_rough(u, f)));
            v(t, e, r, n, h, p, r.aaxis, i, a, o, "a-title"), u = d, f = .5 * (g + y), h = r.ab2xy(u, f, !0), p = r.dxydb_rough(u, f), void 0 === l.angle && c.extendFlat(l, s(r, i, a, h, r.dxyda_rough(u, f)));
            v(t, e, r, n, h, p, r.baxis, i, a, l, "b-title");
          }(t, _, h, i, l, u, w, T), function (t, e, r, n, i) {
            var s,
                l,
                u,
                f,
                h = r.select("#" + t._clipPathId);
            h.size() || (h = r.append("clipPath").classed("carpetclip", !0));
            var p = c.ensureSingle(h, "path", "carpetboundary"),
                d = e.clipsegments,
                m = [];

            for (f = 0; f < d.length; f++) {
              s = d[f], l = a([], s.x, n.c2p), u = a([], s.y, i.c2p), m.push(o(l, u, s.bicubic));
            }

            var g = "M" + m.join("L") + "Z";
            h.attr("id", t._clipPathId), p.attr("d", g);
          }(h, i, f, l, u);
        });
      };

      var m = h.LINE_SPACING,
          g = (1 - h.MID_SHIFT) / m + 1;

      function v(t, e, r, a, o, c, h, p, d, v, y) {
        var x = [];
        h.title.text && x.push(h.title.text);
        var b = e.selectAll("text." + y).data(x),
            _ = v.maxExtent;
        b.enter().append("text").classed(y, !0), b.each(function () {
          var e = s(r, p, d, o, c);
          -1 === ["start", "both"].indexOf(h.showticklabels) && (_ = 0);
          var a = h.title.font.size;
          _ += a + h.title.offset;
          var y = (v.angle + (v.flip < 0 ? 180 : 0) - e.angle + 450) % 360,
              x = y > 90 && y < 270,
              b = n.select(this);
          b.text(h.title.text).call(l.convertToTspans, t), x && (_ = (-l.lineCount(b) + g) * m * a - _), b.attr("transform", f(e.p[0], e.p[1]) + u(e.angle) + f(0, _)).attr("text-anchor", "middle").call(i.font, h.title.font);
        }), b.exit().remove();
      }
    }, {
      "../../components/drawing": 680,
      "../../constants/alignment": 763,
      "../../lib": 795,
      "../../lib/svg_text_utils": 820,
      "./makepath": 994,
      "./map_1d_array": 995,
      "./orient_text": 996,
      "@plotly/d3": 57
    }],
    998: [function (t, e, r) {
      "use strict";

      var n = t("./constants"),
          i = t("../../lib/search").findBin,
          a = t("./compute_control_points"),
          o = t("./create_spline_evaluator"),
          s = t("./create_i_derivative_evaluator"),
          l = t("./create_j_derivative_evaluator");

      e.exports = function (t) {
        var e = t._a,
            r = t._b,
            c = e.length,
            u = r.length,
            f = t.aaxis,
            h = t.baxis,
            p = e[0],
            d = e[c - 1],
            m = r[0],
            g = r[u - 1],
            v = e[e.length - 1] - e[0],
            y = r[r.length - 1] - r[0],
            x = v * n.RELATIVE_CULL_TOLERANCE,
            b = y * n.RELATIVE_CULL_TOLERANCE;
        p -= x, d += x, m -= b, g += b, t.isVisible = function (t, e) {
          return t > p && t < d && e > m && e < g;
        }, t.isOccluded = function (t, e) {
          return t < p || t > d || e < m || e > g;
        }, t.setScale = function () {
          var e = t._x,
              r = t._y,
              n = a(t._xctrl, t._yctrl, e, r, f.smoothing, h.smoothing);
          t._xctrl = n[0], t._yctrl = n[1], t.evalxy = o([t._xctrl, t._yctrl], c, u, f.smoothing, h.smoothing), t.dxydi = s([t._xctrl, t._yctrl], f.smoothing, h.smoothing), t.dxydj = l([t._xctrl, t._yctrl], f.smoothing, h.smoothing);
        }, t.i2a = function (t) {
          var r = Math.max(0, Math.floor(t[0]), c - 2),
              n = t[0] - r;
          return (1 - n) * e[r] + n * e[r + 1];
        }, t.j2b = function (t) {
          var e = Math.max(0, Math.floor(t[1]), c - 2),
              n = t[1] - e;
          return (1 - n) * r[e] + n * r[e + 1];
        }, t.ij2ab = function (e) {
          return [t.i2a(e[0]), t.j2b(e[1])];
        }, t.a2i = function (t) {
          var r = Math.max(0, Math.min(i(t, e), c - 2)),
              n = e[r],
              a = e[r + 1];
          return Math.max(0, Math.min(c - 1, r + (t - n) / (a - n)));
        }, t.b2j = function (t) {
          var e = Math.max(0, Math.min(i(t, r), u - 2)),
              n = r[e],
              a = r[e + 1];
          return Math.max(0, Math.min(u - 1, e + (t - n) / (a - n)));
        }, t.ab2ij = function (e) {
          return [t.a2i(e[0]), t.b2j(e[1])];
        }, t.i2c = function (e, r) {
          return t.evalxy([], e, r);
        }, t.ab2xy = function (n, i, a) {
          if (!a && (n < e[0] || n > e[c - 1] | i < r[0] || i > r[u - 1])) return [!1, !1];
          var o = t.a2i(n),
              s = t.b2j(i),
              l = t.evalxy([], o, s);

          if (a) {
            var f,
                h,
                p,
                d,
                m = 0,
                g = 0,
                v = [];
            n < e[0] ? (f = 0, h = 0, m = (n - e[0]) / (e[1] - e[0])) : n > e[c - 1] ? (f = c - 2, h = 1, m = (n - e[c - 1]) / (e[c - 1] - e[c - 2])) : h = o - (f = Math.max(0, Math.min(c - 2, Math.floor(o)))), i < r[0] ? (p = 0, d = 0, g = (i - r[0]) / (r[1] - r[0])) : i > r[u - 1] ? (p = u - 2, d = 1, g = (i - r[u - 1]) / (r[u - 1] - r[u - 2])) : d = s - (p = Math.max(0, Math.min(u - 2, Math.floor(s)))), m && (t.dxydi(v, f, p, h, d), l[0] += v[0] * m, l[1] += v[1] * m), g && (t.dxydj(v, f, p, h, d), l[0] += v[0] * g, l[1] += v[1] * g);
          }

          return l;
        }, t.c2p = function (t, e, r) {
          return [e.c2p(t[0]), r.c2p(t[1])];
        }, t.p2x = function (t, e, r) {
          return [e.p2c(t[0]), r.p2c(t[1])];
        }, t.dadi = function (t) {
          var r = Math.max(0, Math.min(e.length - 2, t));
          return e[r + 1] - e[r];
        }, t.dbdj = function (t) {
          var e = Math.max(0, Math.min(r.length - 2, t));
          return r[e + 1] - r[e];
        }, t.dxyda = function (e, r, n, i) {
          var a = t.dxydi(null, e, r, n, i),
              o = t.dadi(e, n);
          return [a[0] / o, a[1] / o];
        }, t.dxydb = function (e, r, n, i) {
          var a = t.dxydj(null, e, r, n, i),
              o = t.dbdj(r, i);
          return [a[0] / o, a[1] / o];
        }, t.dxyda_rough = function (e, r, n) {
          var i = v * (n || .1),
              a = t.ab2xy(e + i, r, !0),
              o = t.ab2xy(e - i, r, !0);
          return [.5 * (a[0] - o[0]) / i, .5 * (a[1] - o[1]) / i];
        }, t.dxydb_rough = function (e, r, n) {
          var i = y * (n || .1),
              a = t.ab2xy(e, r + i, !0),
              o = t.ab2xy(e, r - i, !0);
          return [.5 * (a[0] - o[0]) / i, .5 * (a[1] - o[1]) / i];
        }, t.dpdx = function (t) {
          return t._m;
        }, t.dpdy = function (t) {
          return t._m;
        };
      };
    }, {
      "../../lib/search": 815,
      "./compute_control_points": 986,
      "./constants": 987,
      "./create_i_derivative_evaluator": 988,
      "./create_j_derivative_evaluator": 989,
      "./create_spline_evaluator": 990
    }],
    999: [function (t, e, r) {
      "use strict";

      var n = t("../../lib");

      e.exports = function (t, e, r) {
        var i,
            a,
            o,
            s = [],
            l = [],
            c = t[0].length,
            u = t.length;

        function f(e, r) {
          var n,
              i = 0,
              a = 0;
          return e > 0 && void 0 !== (n = t[r][e - 1]) && (a++, i += n), e < c - 1 && void 0 !== (n = t[r][e + 1]) && (a++, i += n), r > 0 && void 0 !== (n = t[r - 1][e]) && (a++, i += n), r < u - 1 && void 0 !== (n = t[r + 1][e]) && (a++, i += n), i / Math.max(1, a);
        }

        var h,
            p,
            d,
            m,
            g,
            v,
            y,
            x,
            b,
            _,
            w,
            T = 0;

        for (i = 0; i < c; i++) {
          for (a = 0; a < u; a++) {
            void 0 === t[a][i] && (s.push(i), l.push(a), t[a][i] = f(i, a)), T = Math.max(T, Math.abs(t[a][i]));
          }
        }

        if (!s.length) return t;
        var k = 0,
            M = 0,
            A = s.length;

        do {
          for (k = 0, o = 0; o < A; o++) {
            i = s[o], a = l[o];
            var S,
                E,
                L,
                C,
                P,
                I,
                O = 0,
                z = 0;
            0 === i ? (L = e[P = Math.min(c - 1, 2)], C = e[1], S = t[a][P], z += (E = t[a][1]) + (E - S) * (e[0] - C) / (C - L), O++) : i === c - 1 && (L = e[P = Math.max(0, c - 3)], C = e[c - 2], S = t[a][P], z += (E = t[a][c - 2]) + (E - S) * (e[c - 1] - C) / (C - L), O++), (0 === i || i === c - 1) && a > 0 && a < u - 1 && (h = r[a + 1] - r[a], z += ((p = r[a] - r[a - 1]) * t[a + 1][i] + h * t[a - 1][i]) / (p + h), O++), 0 === a ? (L = r[I = Math.min(u - 1, 2)], C = r[1], S = t[I][i], z += (E = t[1][i]) + (E - S) * (r[0] - C) / (C - L), O++) : a === u - 1 && (L = r[I = Math.max(0, u - 3)], C = r[u - 2], S = t[I][i], z += (E = t[u - 2][i]) + (E - S) * (r[u - 1] - C) / (C - L), O++), (0 === a || a === u - 1) && i > 0 && i < c - 1 && (h = e[i + 1] - e[i], z += ((p = e[i] - e[i - 1]) * t[a][i + 1] + h * t[a][i - 1]) / (p + h), O++), O ? z /= O : (d = e[i + 1] - e[i], m = e[i] - e[i - 1], x = (g = r[a + 1] - r[a]) * (v = r[a] - r[a - 1]) * (g + v), z = ((y = d * m * (d + m)) * (v * t[a + 1][i] + g * t[a - 1][i]) + x * (m * t[a][i + 1] + d * t[a][i - 1])) / (x * (m + d) + y * (v + g))), k += (_ = (b = z - t[a][i]) / T) * _, w = O ? 0 : .85, t[a][i] += b * (1 + w);
          }

          k = Math.sqrt(k);
        } while (M++ < 100 && k > 1e-5);

        return n.log("Smoother converged to", k, "after", M, "iterations"), t;
      };
    }, {
      "../../lib": 795
    }],
    1e3: [function (t, e, r) {
      "use strict";

      var n = t("../../lib").isArray1D;

      e.exports = function (t, e, r) {
        var i = r("x"),
            a = i && i.length,
            o = r("y"),
            s = o && o.length;
        if (!a && !s) return !1;
        if (e._cheater = !i, a && !n(i) || s && !n(o)) e._length = null;else {
          var l = a ? i.length : 1 / 0;
          s && (l = Math.min(l, o.length)), e.a && e.a.length && (l = Math.min(l, e.a.length)), e.b && e.b.length && (l = Math.min(l, e.b.length)), e._length = l;
        }
        return !0;
      };
    }, {
      "../../lib": 795
    }],
    1001: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/template_attributes").hovertemplateAttrs,
          i = t("../scattergeo/attributes"),
          a = t("../../components/colorscale/attributes"),
          o = t("../../plots/attributes"),
          s = t("../../components/color/attributes").defaultLine,
          l = t("../../lib/extend").extendFlat,
          c = i.marker.line;
      e.exports = l({
        locations: {
          valType: "data_array",
          editType: "calc"
        },
        locationmode: i.locationmode,
        z: {
          valType: "data_array",
          editType: "calc"
        },
        geojson: l({}, i.geojson, {}),
        featureidkey: i.featureidkey,
        text: l({}, i.text, {}),
        hovertext: l({}, i.hovertext, {}),
        marker: {
          line: {
            color: l({}, c.color, {
              dflt: s
            }),
            width: l({}, c.width, {
              dflt: 1
            }),
            editType: "calc"
          },
          opacity: {
            valType: "number",
            arrayOk: !0,
            min: 0,
            max: 1,
            dflt: 1,
            editType: "style"
          },
          editType: "calc"
        },
        selected: {
          marker: {
            opacity: i.selected.marker.opacity,
            editType: "plot"
          },
          editType: "plot"
        },
        unselected: {
          marker: {
            opacity: i.unselected.marker.opacity,
            editType: "plot"
          },
          editType: "plot"
        },
        hoverinfo: l({}, o.hoverinfo, {
          editType: "calc",
          flags: ["location", "z", "text", "name"]
        }),
        hovertemplate: n(),
        showlegend: l({}, o.showlegend, {
          dflt: !1
        })
      }, a("", {
        cLetter: "z",
        editTypeOverride: "calc"
      }));
    }, {
      "../../components/color/attributes": 657,
      "../../components/colorscale/attributes": 665,
      "../../lib/extend": 785,
      "../../plots/attributes": 841,
      "../../plots/template_attributes": 918,
      "../scattergeo/attributes": 1241
    }],
    1002: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../constants/numerical").BADNUM,
          a = t("../../components/colorscale/calc"),
          o = t("../scatter/arrays_to_calcdata"),
          s = t("../scatter/calc_selection");

      function l(t) {
        return t && "string" == typeof t;
      }

      e.exports = function (t, e) {
        var r,
            c = e._length,
            u = new Array(c);
        r = e.geojson ? function (t) {
          return l(t) || n(t);
        } : l;

        for (var f = 0; f < c; f++) {
          var h = u[f] = {},
              p = e.locations[f],
              d = e.z[f];
          r(p) && n(d) ? (h.loc = p, h.z = d) : (h.loc = null, h.z = i), h.index = f;
        }

        return o(u, e), a(t, e, {
          vals: e.z,
          containerStr: "",
          cLetter: "z"
        }), s(u, e), u;
      };
    }, {
      "../../components/colorscale/calc": 666,
      "../../constants/numerical": 771,
      "../scatter/arrays_to_calcdata": 1198,
      "../scatter/calc_selection": 1201,
      "fast-isnumeric": 240
    }],
    1003: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../components/colorscale/defaults"),
          a = t("./attributes");

      e.exports = function (t, e, r, o) {
        function s(r, i) {
          return n.coerce(t, e, a, r, i);
        }

        var l = s("locations"),
            c = s("z");

        if (l && l.length && n.isArrayOrTypedArray(c) && c.length) {
          e._length = Math.min(l.length, c.length);
          var u,
              f = s("geojson");
          ("string" == typeof f && "" !== f || n.isPlainObject(f)) && (u = "geojson-id"), "geojson-id" === s("locationmode", u) && s("featureidkey"), s("text"), s("hovertext"), s("hovertemplate"), s("marker.line.width") && s("marker.line.color"), s("marker.opacity"), i(t, e, o, s, {
            prefix: "",
            cLetter: "z"
          }), n.coerceSelectionMarkerOpacity(e, s);
        } else e.visible = !1;
      };
    }, {
      "../../components/colorscale/defaults": 668,
      "../../lib": 795,
      "./attributes": 1001
    }],
    1004: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, n, i) {
        t.location = e.location, t.z = e.z;
        var a = n[i];
        return a.fIn && a.fIn.properties && (t.properties = a.fIn.properties), t.ct = a.ct, t;
      };
    }, {}],
    1005: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/cartesian/axes"),
          i = t("./attributes"),
          a = t("../../lib").fillText;

      e.exports = function (t, e, r) {
        var o,
            s,
            l,
            c,
            u = t.cd,
            f = u[0].trace,
            h = t.subplot,
            p = [e, r],
            d = [e + 360, r];

        for (s = 0; s < u.length; s++) {
          if (c = !1, (o = u[s])._polygons) {
            for (l = 0; l < o._polygons.length; l++) {
              o._polygons[l].contains(p) && (c = !c), o._polygons[l].contains(d) && (c = !c);
            }

            if (c) break;
          }
        }

        if (c && o) return t.x0 = t.x1 = t.xa.c2p(o.ct), t.y0 = t.y1 = t.ya.c2p(o.ct), t.index = o.index, t.location = o.loc, t.z = o.z, t.zLabel = n.tickText(h.mockAxis, h.mockAxis.c2l(o.z), "hover").text, t.hovertemplate = o.hovertemplate, function (t, e, r) {
          if (e.hovertemplate) return;
          var n = r.hi || e.hoverinfo,
              o = String(r.loc),
              s = "all" === n ? i.hoverinfo.flags : n.split("+"),
              l = -1 !== s.indexOf("name"),
              c = -1 !== s.indexOf("location"),
              u = -1 !== s.indexOf("z"),
              f = -1 !== s.indexOf("text"),
              h = [];
          !l && c ? t.nameOverride = o : (l && (t.nameOverride = e.name), c && h.push(o));
          u && h.push(t.zLabel);
          f && a(r, e, h);
          t.extraText = h.join("<br>");
        }(t, f, o), [t];
      };
    }, {
      "../../lib": 795,
      "../../plots/cartesian/axes": 845,
      "./attributes": 1001
    }],
    1006: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        colorbar: t("../heatmap/colorbar"),
        calc: t("./calc"),
        calcGeoJSON: t("./plot").calcGeoJSON,
        plot: t("./plot").plot,
        style: t("./style").style,
        styleOnSelect: t("./style").styleOnSelect,
        hoverPoints: t("./hover"),
        eventData: t("./event_data"),
        selectPoints: t("./select"),
        moduleType: "trace",
        name: "choropleth",
        basePlotModule: t("../../plots/geo"),
        categories: ["geo", "noOpacity", "showLegend"],
        meta: {}
      };
    }, {
      "../../plots/geo": 877,
      "../heatmap/colorbar": 1080,
      "./attributes": 1001,
      "./calc": 1002,
      "./defaults": 1003,
      "./event_data": 1004,
      "./hover": 1005,
      "./plot": 1007,
      "./select": 1008,
      "./style": 1009
    }],
    1007: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../lib"),
          a = t("../../lib/geo_location_utils"),
          o = t("../../lib/topojson_utils").getTopojsonFeatures,
          s = t("../../plots/cartesian/autorange").findExtremes,
          l = t("./style").style;
      e.exports = {
        calcGeoJSON: function calcGeoJSON(t, e) {
          for (var r = t[0].trace, n = e[r.geo], i = n._subplot, l = r.locationmode, c = r._length, u = "geojson-id" === l ? a.extractTraceFeature(t) : o(r, i.topojson), f = [], h = [], p = 0; p < c; p++) {
            var d = t[p],
                m = "geojson-id" === l ? d.fOut : a.locationToFeature(l, d.loc, u);

            if (m) {
              d.geojson = m, d.ct = m.properties.ct, d._polygons = a.feature2polygons(m);
              var g = a.computeBbox(m);
              f.push(g[0], g[2]), h.push(g[1], g[3]);
            } else d.geojson = null;
          }

          if ("geojson" === n.fitbounds && "geojson-id" === l) {
            var v = a.computeBbox(a.getTraceGeojson(r));
            f = [v[0], v[2]], h = [v[1], v[3]];
          }

          var y = {
            padded: !0
          };
          r._extremes.lon = s(n.lonaxis._ax, f, y), r._extremes.lat = s(n.lataxis._ax, h, y);
        },
        plot: function plot(t, e, r) {
          var a = e.layers.backplot.select(".choroplethlayer");
          i.makeTraceGroups(a, r, "trace choropleth").each(function (e) {
            var r = n.select(this).selectAll("path.choroplethlocation").data(i.identity);
            r.enter().append("path").classed("choroplethlocation", !0), r.exit().remove(), l(t, e);
          });
        }
      };
    }, {
      "../../lib": 795,
      "../../lib/geo_location_utils": 788,
      "../../lib/topojson_utils": 823,
      "../../plots/cartesian/autorange": 844,
      "./style": 1009,
      "@plotly/d3": 57
    }],
    1008: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        var r,
            n,
            i,
            a,
            o,
            s = t.cd,
            l = t.xaxis,
            c = t.yaxis,
            u = [];
        if (!1 === e) for (r = 0; r < s.length; r++) {
          s[r].selected = 0;
        } else for (r = 0; r < s.length; r++) {
          (i = (n = s[r]).ct) && (a = l.c2p(i), o = c.c2p(i), e.contains([a, o], null, r, t) ? (u.push({
            pointNumber: r,
            lon: i[0],
            lat: i[1]
          }), n.selected = 1) : n.selected = 0);
        }
        return u;
      };
    }, {}],
    1009: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../components/color"),
          a = t("../../components/drawing"),
          o = t("../../components/colorscale");

      function s(t, e) {
        var r = e[0].trace,
            s = e[0].node3.selectAll(".choroplethlocation"),
            l = r.marker || {},
            c = l.line || {},
            u = o.makeColorScaleFuncFromTrace(r);
        s.each(function (t) {
          n.select(this).attr("fill", u(t.z)).call(i.stroke, t.mlc || c.color).call(a.dashLine, "", t.mlw || c.width || 0).style("opacity", l.opacity);
        }), a.selectedPointStyle(s, r, t);
      }

      e.exports = {
        style: function style(t, e) {
          e && s(t, e);
        },
        styleOnSelect: function styleOnSelect(t, e) {
          var r = e[0].node3,
              n = e[0].trace;
          n.selectedpoints ? a.selectedPointStyle(r.selectAll(".choroplethlocation"), n, t) : s(t, e);
        }
      };
    }, {
      "../../components/color": 658,
      "../../components/colorscale": 670,
      "../../components/drawing": 680,
      "@plotly/d3": 57
    }],
    1010: [function (t, e, r) {
      "use strict";

      var n = t("../choropleth/attributes"),
          i = t("../../components/colorscale/attributes"),
          a = t("../../plots/template_attributes").hovertemplateAttrs,
          o = t("../../plots/attributes"),
          s = t("../../lib/extend").extendFlat;
      e.exports = s({
        locations: {
          valType: "data_array",
          editType: "calc"
        },
        z: {
          valType: "data_array",
          editType: "calc"
        },
        geojson: {
          valType: "any",
          editType: "calc"
        },
        featureidkey: s({}, n.featureidkey, {}),
        below: {
          valType: "string",
          editType: "plot"
        },
        text: n.text,
        hovertext: n.hovertext,
        marker: {
          line: {
            color: s({}, n.marker.line.color, {
              editType: "plot"
            }),
            width: s({}, n.marker.line.width, {
              editType: "plot"
            }),
            editType: "calc"
          },
          opacity: s({}, n.marker.opacity, {
            editType: "plot"
          }),
          editType: "calc"
        },
        selected: {
          marker: {
            opacity: s({}, n.selected.marker.opacity, {
              editType: "plot"
            }),
            editType: "plot"
          },
          editType: "plot"
        },
        unselected: {
          marker: {
            opacity: s({}, n.unselected.marker.opacity, {
              editType: "plot"
            }),
            editType: "plot"
          },
          editType: "plot"
        },
        hoverinfo: n.hoverinfo,
        hovertemplate: a({}, {
          keys: ["properties"]
        }),
        showlegend: s({}, o.showlegend, {
          dflt: !1
        })
      }, i("", {
        cLetter: "z",
        editTypeOverride: "calc"
      }));
    }, {
      "../../components/colorscale/attributes": 665,
      "../../lib/extend": 785,
      "../../plots/attributes": 841,
      "../../plots/template_attributes": 918,
      "../choropleth/attributes": 1001
    }],
    1011: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../lib"),
          a = t("../../components/colorscale"),
          o = t("../../components/drawing"),
          s = t("../../lib/geojson_utils").makeBlank,
          l = t("../../lib/geo_location_utils");

      function c(t) {
        var e,
            r = t[0].trace,
            n = r._opts;

        if (r.selectedpoints) {
          for (var a = o.makeSelectedPointStyleFns(r), s = 0; s < t.length; s++) {
            var l = t[s];
            l.fOut && (l.fOut.properties.mo2 = a.selectedOpacityFn(l));
          }

          e = {
            type: "identity",
            property: "mo2"
          };
        } else e = i.isArrayOrTypedArray(r.marker.opacity) ? {
          type: "identity",
          property: "mo"
        } : r.marker.opacity;

        return i.extendFlat(n.fill.paint, {
          "fill-opacity": e
        }), i.extendFlat(n.line.paint, {
          "line-opacity": e
        }), n;
      }

      e.exports = {
        convert: function convert(t) {
          var e = t[0].trace,
              r = !0 === e.visible && 0 !== e._length,
              o = {
            layout: {
              visibility: "none"
            },
            paint: {}
          },
              u = {
            layout: {
              visibility: "none"
            },
            paint: {}
          },
              f = e._opts = {
            fill: o,
            line: u,
            geojson: s()
          };
          if (!r) return f;
          var h = l.extractTraceFeature(t);
          if (!h) return f;
          var p,
              d,
              m,
              g = a.makeColorScaleFuncFromTrace(e),
              v = e.marker,
              y = v.line || {};
          i.isArrayOrTypedArray(v.opacity) && (p = function p(t) {
            var e = t.mo;
            return n(e) ? +i.constrain(e, 0, 1) : 0;
          }), i.isArrayOrTypedArray(y.color) && (d = function d(t) {
            return t.mlc;
          }), i.isArrayOrTypedArray(y.width) && (m = function m(t) {
            return t.mlw;
          });

          for (var x = 0; x < t.length; x++) {
            var b = t[x],
                _ = b.fOut;

            if (_) {
              var w = _.properties;
              w.fc = g(b.z), p && (w.mo = p(b)), d && (w.mlc = d(b)), m && (w.mlw = m(b)), b.ct = w.ct, b._polygons = l.feature2polygons(_);
            }
          }

          var T = p ? {
            type: "identity",
            property: "mo"
          } : v.opacity;
          return i.extendFlat(o.paint, {
            "fill-color": {
              type: "identity",
              property: "fc"
            },
            "fill-opacity": T
          }), i.extendFlat(u.paint, {
            "line-color": d ? {
              type: "identity",
              property: "mlc"
            } : y.color,
            "line-width": m ? {
              type: "identity",
              property: "mlw"
            } : y.width,
            "line-opacity": T
          }), o.layout.visibility = "visible", u.layout.visibility = "visible", f.geojson = {
            type: "FeatureCollection",
            features: h
          }, c(t), f;
        },
        convertOnSelect: c
      };
    }, {
      "../../components/colorscale": 670,
      "../../components/drawing": 680,
      "../../lib": 795,
      "../../lib/geo_location_utils": 788,
      "../../lib/geojson_utils": 789,
      "fast-isnumeric": 240
    }],
    1012: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../components/colorscale/defaults"),
          a = t("./attributes");

      e.exports = function (t, e, r, o) {
        function s(r, i) {
          return n.coerce(t, e, a, r, i);
        }

        var l = s("locations"),
            c = s("z"),
            u = s("geojson");
        n.isArrayOrTypedArray(l) && l.length && n.isArrayOrTypedArray(c) && c.length && ("string" == typeof u && "" !== u || n.isPlainObject(u)) ? (s("featureidkey"), e._length = Math.min(l.length, c.length), s("below"), s("text"), s("hovertext"), s("hovertemplate"), s("marker.line.width") && s("marker.line.color"), s("marker.opacity"), i(t, e, o, s, {
          prefix: "",
          cLetter: "z"
        }), n.coerceSelectionMarkerOpacity(e, s)) : e.visible = !1;
      };
    }, {
      "../../components/colorscale/defaults": 668,
      "../../lib": 795,
      "./attributes": 1010
    }],
    1013: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        colorbar: t("../heatmap/colorbar"),
        calc: t("../choropleth/calc"),
        plot: t("./plot"),
        hoverPoints: t("../choropleth/hover"),
        eventData: t("../choropleth/event_data"),
        selectPoints: t("../choropleth/select"),
        styleOnSelect: function styleOnSelect(t, e) {
          e && e[0].trace._glTrace.updateOnSelect(e);
        },
        getBelow: function getBelow(t, e) {
          for (var r = e.getMapLayers(), n = r.length - 2; n >= 0; n--) {
            var i = r[n].id;
            if ("string" == typeof i && 0 === i.indexOf("water")) for (var a = n + 1; a < r.length; a++) {
              if ("string" == typeof (i = r[a].id) && -1 === i.indexOf("plotly-")) return i;
            }
          }
        },
        moduleType: "trace",
        name: "choroplethmapbox",
        basePlotModule: t("../../plots/mapbox"),
        categories: ["mapbox", "gl", "noOpacity", "showLegend"],
        meta: {
          hr_name: "choropleth_mapbox"
        }
      };
    }, {
      "../../plots/mapbox": 903,
      "../choropleth/calc": 1002,
      "../choropleth/event_data": 1004,
      "../choropleth/hover": 1005,
      "../choropleth/select": 1008,
      "../heatmap/colorbar": 1080,
      "./attributes": 1010,
      "./defaults": 1012,
      "./plot": 1014
    }],
    1014: [function (t, e, r) {
      "use strict";

      var n = t("./convert").convert,
          i = t("./convert").convertOnSelect,
          a = t("../../plots/mapbox/constants").traceLayerPrefix;

      function o(t, e) {
        this.type = "choroplethmapbox", this.subplot = t, this.uid = e, this.sourceId = "source-" + e, this.layerList = [["fill", a + e + "-fill"], ["line", a + e + "-line"]], this.below = null;
      }

      var s = o.prototype;
      s.update = function (t) {
        this._update(n(t));
      }, s.updateOnSelect = function (t) {
        this._update(i(t));
      }, s._update = function (t) {
        var e = this.subplot,
            r = this.layerList,
            n = e.belowLookup["trace-" + this.uid];
        e.map.getSource(this.sourceId).setData(t.geojson), n !== this.below && (this._removeLayers(), this._addLayers(t, n), this.below = n);

        for (var i = 0; i < r.length; i++) {
          var a = r[i],
              o = a[0],
              s = a[1],
              l = t[o];
          e.setOptions(s, "setLayoutProperty", l.layout), "visible" === l.layout.visibility && e.setOptions(s, "setPaintProperty", l.paint);
        }
      }, s._addLayers = function (t, e) {
        for (var r = this.subplot, n = this.layerList, i = this.sourceId, a = 0; a < n.length; a++) {
          var o = n[a],
              s = o[0],
              l = t[s];
          r.addLayer({
            type: s,
            id: o[1],
            source: i,
            layout: l.layout,
            paint: l.paint
          }, e);
        }
      }, s._removeLayers = function () {
        for (var t = this.subplot.map, e = this.layerList, r = e.length - 1; r >= 0; r--) {
          t.removeLayer(e[r][1]);
        }
      }, s.dispose = function () {
        var t = this.subplot.map;
        this._removeLayers(), t.removeSource(this.sourceId);
      }, e.exports = function (t, e) {
        var r = e[0].trace,
            i = new o(t, r.uid),
            a = i.sourceId,
            s = n(e),
            l = i.below = t.belowLookup["trace-" + r.uid];
        return t.map.addSource(a, {
          type: "geojson",
          data: s.geojson
        }), i._addLayers(s, l), e[0].trace._glTrace = i, i;
      };
    }, {
      "../../plots/mapbox/constants": 901,
      "./convert": 1011
    }],
    1015: [function (t, e, r) {
      "use strict";

      var n = t("../../components/colorscale/attributes"),
          i = t("../../plots/hoverformat_attributes"),
          a = t("../../plots/template_attributes").hovertemplateAttrs,
          o = t("../mesh3d/attributes"),
          s = t("../../plots/attributes"),
          l = t("../../lib/extend").extendFlat,
          c = {
        x: {
          valType: "data_array",
          editType: "calc+clearAxisTypes"
        },
        y: {
          valType: "data_array",
          editType: "calc+clearAxisTypes"
        },
        z: {
          valType: "data_array",
          editType: "calc+clearAxisTypes"
        },
        u: {
          valType: "data_array",
          editType: "calc"
        },
        v: {
          valType: "data_array",
          editType: "calc"
        },
        w: {
          valType: "data_array",
          editType: "calc"
        },
        sizemode: {
          valType: "enumerated",
          values: ["scaled", "absolute"],
          editType: "calc",
          dflt: "scaled"
        },
        sizeref: {
          valType: "number",
          editType: "calc",
          min: 0
        },
        anchor: {
          valType: "enumerated",
          editType: "calc",
          values: ["tip", "tail", "cm", "center"],
          dflt: "cm"
        },
        text: {
          valType: "string",
          dflt: "",
          arrayOk: !0,
          editType: "calc"
        },
        hovertext: {
          valType: "string",
          dflt: "",
          arrayOk: !0,
          editType: "calc"
        },
        hovertemplate: a({
          editType: "calc"
        }, {
          keys: ["norm"]
        }),
        uhoverformat: i("u", 1),
        vhoverformat: i("v", 1),
        whoverformat: i("w", 1),
        xhoverformat: i("x"),
        yhoverformat: i("y"),
        zhoverformat: i("z"),
        showlegend: l({}, s.showlegend, {
          dflt: !1
        })
      };
      l(c, n("", {
        colorAttr: "u/v/w norm",
        showScaleDflt: !0,
        editTypeOverride: "calc"
      }));
      ["opacity", "lightposition", "lighting"].forEach(function (t) {
        c[t] = o[t];
      }), c.hoverinfo = l({}, s.hoverinfo, {
        editType: "calc",
        flags: ["x", "y", "z", "u", "v", "w", "norm", "text", "name"],
        dflt: "x+y+z+norm+text+name"
      }), c.transforms = void 0, e.exports = c;
    }, {
      "../../components/colorscale/attributes": 665,
      "../../lib/extend": 785,
      "../../plots/attributes": 841,
      "../../plots/hoverformat_attributes": 899,
      "../../plots/template_attributes": 918,
      "../mesh3d/attributes": 1140
    }],
    1016: [function (t, e, r) {
      "use strict";

      var n = t("../../components/colorscale/calc");

      e.exports = function (t, e) {
        for (var r = e.u, i = e.v, a = e.w, o = Math.min(e.x.length, e.y.length, e.z.length, r.length, i.length, a.length), s = -1 / 0, l = 1 / 0, c = 0; c < o; c++) {
          var u = r[c],
              f = i[c],
              h = a[c],
              p = Math.sqrt(u * u + f * f + h * h);
          s = Math.max(s, p), l = Math.min(l, p);
        }

        e._len = o, e._normMax = s, n(t, e, {
          vals: [l, s],
          containerStr: "",
          cLetter: "c"
        });
      };
    }, {
      "../../components/colorscale/calc": 666
    }],
    1017: [function (t, e, r) {
      "use strict";

      var n = t("gl-cone3d"),
          i = t("gl-cone3d").createConeMesh,
          a = t("../../lib").simpleMap,
          o = t("../../lib/gl_format_color").parseColorScale,
          s = t("../../components/colorscale").extractOpts,
          l = t("../../plots/gl3d/zip3");

      function c(t, e) {
        this.scene = t, this.uid = e, this.mesh = null, this.data = null;
      }

      var u = c.prototype;

      u.handlePick = function (t) {
        if (t.object === this.mesh) {
          var e = t.index = t.data.index,
              r = this.data.x[e],
              n = this.data.y[e],
              i = this.data.z[e],
              a = this.data.u[e],
              o = this.data.v[e],
              s = this.data.w[e];
          t.traceCoordinate = [r, n, i, a, o, s, Math.sqrt(a * a + o * o + s * s)];
          var l = this.data.hovertext || this.data.text;
          return Array.isArray(l) && void 0 !== l[e] ? t.textLabel = l[e] : l && (t.textLabel = l), !0;
        }
      };

      var f = {
        xaxis: 0,
        yaxis: 1,
        zaxis: 2
      },
          h = {
        tip: 1,
        tail: 0,
        cm: .25,
        center: .5
      },
          p = {
        tip: 1,
        tail: 1,
        cm: .75,
        center: .5
      };

      function d(t, e) {
        var r = t.fullSceneLayout,
            i = t.dataScale,
            c = {};

        function u(t, e) {
          var n = r[e],
              o = i[f[e]];
          return a(t, function (t) {
            return n.d2l(t) * o;
          });
        }

        c.vectors = l(u(e.u, "xaxis"), u(e.v, "yaxis"), u(e.w, "zaxis"), e._len), c.positions = l(u(e.x, "xaxis"), u(e.y, "yaxis"), u(e.z, "zaxis"), e._len);
        var d = s(e);
        c.colormap = o(e), c.vertexIntensityBounds = [d.min / e._normMax, d.max / e._normMax], c.coneOffset = h[e.anchor], "scaled" === e.sizemode ? c.coneSize = e.sizeref || .5 : c.coneSize = e.sizeref && e._normMax ? e.sizeref / e._normMax : .5;
        var m = n(c),
            g = e.lightposition;
        return m.lightPosition = [g.x, g.y, g.z], m.ambient = e.lighting.ambient, m.diffuse = e.lighting.diffuse, m.specular = e.lighting.specular, m.roughness = e.lighting.roughness, m.fresnel = e.lighting.fresnel, m.opacity = e.opacity, e._pad = p[e.anchor] * m.vectorScale * m.coneScale * e._normMax, m;
      }

      u.update = function (t) {
        this.data = t;
        var e = d(this.scene, t);
        this.mesh.update(e);
      }, u.dispose = function () {
        this.scene.glplot.remove(this.mesh), this.mesh.dispose();
      }, e.exports = function (t, e) {
        var r = t.glplot.gl,
            n = d(t, e),
            a = i(r, n),
            o = new c(t, e.uid);
        return o.mesh = a, o.data = e, a._trace = o, t.glplot.add(a), o;
      };
    }, {
      "../../components/colorscale": 670,
      "../../lib": 795,
      "../../lib/gl_format_color": 791,
      "../../plots/gl3d/zip3": 898,
      "gl-cone3d": 259
    }],
    1018: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../components/colorscale/defaults"),
          a = t("./attributes");

      e.exports = function (t, e, r, o) {
        function s(r, i) {
          return n.coerce(t, e, a, r, i);
        }

        var l = s("u"),
            c = s("v"),
            u = s("w"),
            f = s("x"),
            h = s("y"),
            p = s("z");
        l && l.length && c && c.length && u && u.length && f && f.length && h && h.length && p && p.length ? (s("sizeref"), s("sizemode"), s("anchor"), s("lighting.ambient"), s("lighting.diffuse"), s("lighting.specular"), s("lighting.roughness"), s("lighting.fresnel"), s("lightposition.x"), s("lightposition.y"), s("lightposition.z"), i(t, e, o, s, {
          prefix: "",
          cLetter: "c"
        }), s("text"), s("hovertext"), s("hovertemplate"), s("uhoverformat"), s("vhoverformat"), s("whoverformat"), s("xhoverformat"), s("yhoverformat"), s("zhoverformat"), e._length = null) : e.visible = !1;
      };
    }, {
      "../../components/colorscale/defaults": 668,
      "../../lib": 795,
      "./attributes": 1015
    }],
    1019: [function (t, e, r) {
      "use strict";

      e.exports = {
        moduleType: "trace",
        name: "cone",
        basePlotModule: t("../../plots/gl3d"),
        categories: ["gl3d", "showLegend"],
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        colorbar: {
          min: "cmin",
          max: "cmax"
        },
        calc: t("./calc"),
        plot: t("./convert"),
        eventData: function eventData(t, e) {
          return t.norm = e.traceCoordinate[6], t;
        },
        meta: {}
      };
    }, {
      "../../plots/gl3d": 887,
      "./attributes": 1015,
      "./calc": 1016,
      "./convert": 1017,
      "./defaults": 1018
    }],
    1020: [function (t, e, r) {
      "use strict";

      var n = t("../heatmap/attributes"),
          i = t("../scatter/attributes"),
          a = t("../../plots/hoverformat_attributes"),
          o = t("../../components/colorscale/attributes"),
          s = t("../../components/drawing/attributes").dash,
          l = t("../../plots/font_attributes"),
          c = t("../../lib/extend").extendFlat,
          u = t("../../constants/filter_ops"),
          f = u.COMPARISON_OPS2,
          h = u.INTERVAL_OPS,
          p = (t("../../constants/docs").FORMAT_LINK, i.line);
      e.exports = c({
        z: n.z,
        x: n.x,
        x0: n.x0,
        dx: n.dx,
        y: n.y,
        y0: n.y0,
        dy: n.dy,
        xperiod: n.xperiod,
        yperiod: n.yperiod,
        xperiod0: i.xperiod0,
        yperiod0: i.yperiod0,
        xperiodalignment: n.xperiodalignment,
        yperiodalignment: n.yperiodalignment,
        text: n.text,
        hovertext: n.hovertext,
        transpose: n.transpose,
        xtype: n.xtype,
        ytype: n.ytype,
        xhoverformat: a("x"),
        yhoverformat: a("y"),
        zhoverformat: a("z", 1),
        hovertemplate: n.hovertemplate,
        hoverongaps: n.hoverongaps,
        connectgaps: c({}, n.connectgaps, {}),
        fillcolor: {
          valType: "color",
          editType: "calc"
        },
        autocontour: {
          valType: "boolean",
          dflt: !0,
          editType: "calc",
          impliedEdits: {
            "contours.start": void 0,
            "contours.end": void 0,
            "contours.size": void 0
          }
        },
        ncontours: {
          valType: "integer",
          dflt: 15,
          min: 1,
          editType: "calc"
        },
        contours: {
          type: {
            valType: "enumerated",
            values: ["levels", "constraint"],
            dflt: "levels",
            editType: "calc"
          },
          start: {
            valType: "number",
            dflt: null,
            editType: "plot",
            impliedEdits: {
              "^autocontour": !1
            }
          },
          end: {
            valType: "number",
            dflt: null,
            editType: "plot",
            impliedEdits: {
              "^autocontour": !1
            }
          },
          size: {
            valType: "number",
            dflt: null,
            min: 0,
            editType: "plot",
            impliedEdits: {
              "^autocontour": !1
            }
          },
          coloring: {
            valType: "enumerated",
            values: ["fill", "heatmap", "lines", "none"],
            dflt: "fill",
            editType: "calc"
          },
          showlines: {
            valType: "boolean",
            dflt: !0,
            editType: "plot"
          },
          showlabels: {
            valType: "boolean",
            dflt: !1,
            editType: "plot"
          },
          labelfont: l({
            editType: "plot",
            colorEditType: "style"
          }),
          labelformat: {
            valType: "string",
            dflt: "",
            editType: "plot"
          },
          operation: {
            valType: "enumerated",
            values: [].concat(f).concat(h),
            dflt: "=",
            editType: "calc"
          },
          value: {
            valType: "any",
            dflt: 0,
            editType: "calc"
          },
          editType: "calc",
          impliedEdits: {
            autocontour: !1
          }
        },
        line: {
          color: c({}, p.color, {
            editType: "style+colorbars"
          }),
          width: {
            valType: "number",
            min: 0,
            editType: "style+colorbars"
          },
          dash: s,
          smoothing: c({}, p.smoothing, {}),
          editType: "plot"
        }
      }, o("", {
        cLetter: "z",
        autoColorDflt: !1,
        editTypeOverride: "calc"
      }));
    }, {
      "../../components/colorscale/attributes": 665,
      "../../components/drawing/attributes": 679,
      "../../constants/docs": 766,
      "../../constants/filter_ops": 767,
      "../../lib/extend": 785,
      "../../plots/font_attributes": 873,
      "../../plots/hoverformat_attributes": 899,
      "../heatmap/attributes": 1077,
      "../scatter/attributes": 1199
    }],
    1021: [function (t, e, r) {
      "use strict";

      var n = t("../../components/colorscale"),
          i = t("../heatmap/calc"),
          a = t("./set_contours"),
          o = t("./end_plus");

      e.exports = function (t, e) {
        var r = i(t, e),
            s = r[0].z;
        a(e, s);
        var l,
            c = e.contours,
            u = n.extractOpts(e);

        if ("heatmap" === c.coloring && u.auto && !1 === e.autocontour) {
          var f = c.start,
              h = o(c),
              p = c.size || 1,
              d = Math.floor((h - f) / p) + 1;
          isFinite(p) || (p = 1, d = 1);
          var m = f - p / 2;
          l = [m, m + d * p];
        } else l = s;

        return n.calc(t, e, {
          vals: l,
          cLetter: "z"
        }), r;
      };
    }, {
      "../../components/colorscale": 670,
      "../heatmap/calc": 1078,
      "./end_plus": 1031,
      "./set_contours": 1039
    }],
    1022: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        var r,
            n = t[0],
            i = n.z;

        switch (e.type) {
          case "levels":
            var a = Math.min(i[0][0], i[0][1]);

            for (r = 0; r < t.length; r++) {
              var o = t[r];
              o.prefixBoundary = !o.edgepaths.length && (a > o.level || o.starts.length && a === o.level);
            }

            break;

          case "constraint":
            if (n.prefixBoundary = !1, n.edgepaths.length) return;
            var s = n.x.length,
                l = n.y.length,
                c = -1 / 0,
                u = 1 / 0;

            for (r = 0; r < l; r++) {
              u = Math.min(u, i[r][0]), u = Math.min(u, i[r][s - 1]), c = Math.max(c, i[r][0]), c = Math.max(c, i[r][s - 1]);
            }

            for (r = 1; r < s - 1; r++) {
              u = Math.min(u, i[0][r]), u = Math.min(u, i[l - 1][r]), c = Math.max(c, i[0][r]), c = Math.max(c, i[l - 1][r]);
            }

            var f,
                h,
                p = e.value;

            switch (e._operation) {
              case ">":
                p > c && (n.prefixBoundary = !0);
                break;

              case "<":
                (p < u || n.starts.length && p === u) && (n.prefixBoundary = !0);
                break;

              case "[]":
                f = Math.min(p[0], p[1]), ((h = Math.max(p[0], p[1])) < u || f > c || n.starts.length && h === u) && (n.prefixBoundary = !0);
                break;

              case "][":
                f = Math.min(p[0], p[1]), h = Math.max(p[0], p[1]), f < u && h > c && (n.prefixBoundary = !0);
            }

        }
      };
    }, {}],
    1023: [function (t, e, r) {
      "use strict";

      var n = t("../../components/colorscale"),
          i = t("./make_color_map"),
          a = t("./end_plus");
      e.exports = {
        min: "zmin",
        max: "zmax",
        calc: function calc(t, e, r) {
          var o = e.contours,
              s = e.line,
              l = o.size || 1,
              c = o.coloring,
              u = i(e, {
            isColorbar: !0
          });

          if ("heatmap" === c) {
            var f = n.extractOpts(e);
            r._fillgradient = f.reversescale ? n.flipScale(f.colorscale) : f.colorscale, r._zrange = [f.min, f.max];
          } else "fill" === c && (r._fillcolor = u);

          r._line = {
            color: "lines" === c ? u : s.color,
            width: !1 !== o.showlines ? s.width : 0,
            dash: s.dash
          }, r._levels = {
            start: o.start,
            end: a(o),
            size: l
          };
        }
      };
    }, {
      "../../components/colorscale": 670,
      "./end_plus": 1031,
      "./make_color_map": 1036
    }],
    1024: [function (t, e, r) {
      "use strict";

      e.exports = {
        BOTTOMSTART: [1, 9, 13, 104, 713],
        TOPSTART: [4, 6, 7, 104, 713],
        LEFTSTART: [8, 12, 14, 208, 1114],
        RIGHTSTART: [2, 3, 11, 208, 1114],
        NEWDELTA: [null, [-1, 0], [0, -1], [-1, 0], [1, 0], null, [0, -1], [-1, 0], [0, 1], [0, 1], null, [0, 1], [1, 0], [1, 0], [0, -1]],
        CHOOSESADDLE: {
          104: [4, 1],
          208: [2, 8],
          713: [7, 13],
          1114: [11, 14]
        },
        SADDLEREMAINDER: {
          1: 4,
          2: 8,
          4: 1,
          7: 13,
          8: 2,
          11: 14,
          13: 7,
          14: 11
        },
        LABELDISTANCE: 2,
        LABELINCREASE: 10,
        LABELMIN: 3,
        LABELMAX: 10,
        LABELOPTIMIZER: {
          EDGECOST: 1,
          ANGLECOST: 1,
          NEIGHBORCOST: 5,
          SAMELEVELFACTOR: 10,
          SAMELEVELDISTANCE: 5,
          MAXCOST: 100,
          INITIALSEARCHPOINTS: 10,
          ITERATIONS: 5
        }
      };
    }, {}],
    1025: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("./label_defaults"),
          a = t("../../components/color"),
          o = a.addOpacity,
          s = a.opacity,
          l = t("../../constants/filter_ops"),
          c = l.CONSTRAINT_REDUCTION,
          u = l.COMPARISON_OPS2;

      e.exports = function (t, e, r, a, l, f) {
        var h,
            p,
            d,
            m = e.contours,
            g = r("contours.operation");
        (m._operation = c[g], function (t, e) {
          var r;
          -1 === u.indexOf(e.operation) ? (t("contours.value", [0, 1]), Array.isArray(e.value) ? e.value.length > 2 ? e.value = e.value.slice(2) : 0 === e.length ? e.value = [0, 1] : e.length < 2 ? (r = parseFloat(e.value[0]), e.value = [r, r + 1]) : e.value = [parseFloat(e.value[0]), parseFloat(e.value[1])] : n(e.value) && (r = parseFloat(e.value), e.value = [r, r + 1])) : (t("contours.value", 0), n(e.value) || (Array.isArray(e.value) ? e.value = parseFloat(e.value[0]) : e.value = 0));
        }(r, m), "=" === g ? h = m.showlines = !0 : (h = r("contours.showlines"), d = r("fillcolor", o((t.line || {}).color || l, .5))), h) && (p = r("line.color", d && s(d) ? o(e.fillcolor, 1) : l), r("line.width", 2), r("line.dash"));
        r("line.smoothing"), i(r, a, p, f);
      };
    }, {
      "../../components/color": 658,
      "../../constants/filter_ops": 767,
      "./label_defaults": 1035,
      "fast-isnumeric": 240
    }],
    1026: [function (t, e, r) {
      "use strict";

      var n = t("../../constants/filter_ops"),
          i = t("fast-isnumeric");

      function a(t, e) {
        var r,
            a = Array.isArray(e);

        function o(t) {
          return i(t) ? +t : null;
        }

        return -1 !== n.COMPARISON_OPS2.indexOf(t) ? r = o(a ? e[0] : e) : -1 !== n.INTERVAL_OPS.indexOf(t) ? r = a ? [o(e[0]), o(e[1])] : [o(e), o(e)] : -1 !== n.SET_OPS.indexOf(t) && (r = a ? e.map(o) : [o(e)]), r;
      }

      function o(t) {
        return function (e) {
          e = a(t, e);
          var r = Math.min(e[0], e[1]),
              n = Math.max(e[0], e[1]);
          return {
            start: r,
            end: n,
            size: n - r
          };
        };
      }

      function s(t) {
        return function (e) {
          return {
            start: e = a(t, e),
            end: 1 / 0,
            size: 1 / 0
          };
        };
      }

      e.exports = {
        "[]": o("[]"),
        "][": o("]["),
        ">": s(">"),
        "<": s("<"),
        "=": s("=")
      };
    }, {
      "../../constants/filter_ops": 767,
      "fast-isnumeric": 240
    }],
    1027: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, n) {
        var i = n("contours.start"),
            a = n("contours.end"),
            o = !1 === i || !1 === a,
            s = r("contours.size");
        !(o ? e.autocontour = !0 : r("autocontour", !1)) && s || r("ncontours");
      };
    }, {}],
    1028: [function (t, e, r) {
      "use strict";

      var n = t("../../lib");

      function i(t) {
        return n.extendFlat({}, t, {
          edgepaths: n.extendDeep([], t.edgepaths),
          paths: n.extendDeep([], t.paths),
          starts: n.extendDeep([], t.starts)
        });
      }

      e.exports = function (t, e) {
        var r,
            a,
            o,
            s = function s(t) {
          return t.reverse();
        },
            l = function l(t) {
          return t;
        };

        switch (e) {
          case "=":
          case "<":
            return t;

          case ">":
            for (1 !== t.length && n.warn("Contour data invalid for the specified inequality operation."), a = t[0], r = 0; r < a.edgepaths.length; r++) {
              a.edgepaths[r] = s(a.edgepaths[r]);
            }

            for (r = 0; r < a.paths.length; r++) {
              a.paths[r] = s(a.paths[r]);
            }

            for (r = 0; r < a.starts.length; r++) {
              a.starts[r] = s(a.starts[r]);
            }

            return t;

          case "][":
            var c = s;
            s = l, l = c;

          case "[]":
            for (2 !== t.length && n.warn("Contour data invalid for the specified inequality range operation."), a = i(t[0]), o = i(t[1]), r = 0; r < a.edgepaths.length; r++) {
              a.edgepaths[r] = s(a.edgepaths[r]);
            }

            for (r = 0; r < a.paths.length; r++) {
              a.paths[r] = s(a.paths[r]);
            }

            for (r = 0; r < a.starts.length; r++) {
              a.starts[r] = s(a.starts[r]);
            }

            for (; o.edgepaths.length;) {
              a.edgepaths.push(l(o.edgepaths.shift()));
            }

            for (; o.paths.length;) {
              a.paths.push(l(o.paths.shift()));
            }

            for (; o.starts.length;) {
              a.starts.push(l(o.starts.shift()));
            }

            return [a];
        }
      };
    }, {
      "../../lib": 795
    }],
    1029: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../heatmap/xyz_defaults"),
          a = t("../scatter/period_defaults"),
          o = t("./constraint_defaults"),
          s = t("./contours_defaults"),
          l = t("./style_defaults"),
          c = t("./attributes");

      e.exports = function (t, e, r, u) {
        function f(r, i) {
          return n.coerce(t, e, c, r, i);
        }

        if (i(t, e, f, u)) {
          a(t, e, u, f), f("xhoverformat"), f("yhoverformat"), f("text"), f("hovertext"), f("hovertemplate"), f("hoverongaps");
          var h = "constraint" === f("contours.type");
          f("connectgaps", n.isArray1D(e.z)), h ? o(t, e, f, u, r) : (s(t, e, f, function (r) {
            return n.coerce2(t, e, c, r);
          }), l(t, e, f, u));
        } else e.visible = !1;
      };
    }, {
      "../../lib": 795,
      "../heatmap/xyz_defaults": 1091,
      "../scatter/period_defaults": 1219,
      "./attributes": 1020,
      "./constraint_defaults": 1025,
      "./contours_defaults": 1027,
      "./style_defaults": 1041
    }],
    1030: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./constraint_mapping"),
          a = t("./end_plus");

      e.exports = function (t, e, r) {
        for (var o = "constraint" === t.type ? i[t._operation](t.value) : t, s = o.size, l = [], c = a(o), u = r.trace._carpetTrace, f = u ? {
          xaxis: u.aaxis,
          yaxis: u.baxis,
          x: r.a,
          y: r.b
        } : {
          xaxis: e.xaxis,
          yaxis: e.yaxis,
          x: r.x,
          y: r.y
        }, h = o.start; h < c; h += s) {
          if (l.push(n.extendFlat({
            level: h,
            crossings: {},
            starts: [],
            edgepaths: [],
            paths: [],
            z: r.z,
            smoothing: r.trace.line.smoothing
          }, f)), l.length > 1e3) {
            n.warn("Too many contours, clipping at 1000", t);
            break;
          }
        }

        return l;
      };
    }, {
      "../../lib": 795,
      "./constraint_mapping": 1026,
      "./end_plus": 1031
    }],
    1031: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        return t.end + t.size / 1e6;
      };
    }, {}],
    1032: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./constants");

      function a(t, e, r, n) {
        return Math.abs(t[0] - e[0]) < r && Math.abs(t[1] - e[1]) < n;
      }

      function o(t, e, r, o, l) {
        var c,
            u = e.join(","),
            f = t.crossings[u],
            h = function (t, e, r) {
          var n = 0,
              a = 0;
          t > 20 && e ? 208 === t || 1114 === t ? n = 0 === r[0] ? 1 : -1 : a = 0 === r[1] ? 1 : -1 : -1 !== i.BOTTOMSTART.indexOf(t) ? a = 1 : -1 !== i.LEFTSTART.indexOf(t) ? n = 1 : -1 !== i.TOPSTART.indexOf(t) ? a = -1 : n = -1;
          return [n, a];
        }(f, r, e),
            p = [s(t, e, [-h[0], -h[1]])],
            d = t.z.length,
            m = t.z[0].length,
            g = e.slice(),
            v = h.slice();

        for (c = 0; c < 1e4; c++) {
          if (f > 20 ? (f = i.CHOOSESADDLE[f][(h[0] || h[1]) < 0 ? 0 : 1], t.crossings[u] = i.SADDLEREMAINDER[f]) : delete t.crossings[u], !(h = i.NEWDELTA[f])) {
            n.log("Found bad marching index:", f, e, t.level);
            break;
          }

          p.push(s(t, e, h)), e[0] += h[0], e[1] += h[1], u = e.join(","), a(p[p.length - 1], p[p.length - 2], o, l) && p.pop();
          var y = h[0] && (e[0] < 0 || e[0] > m - 2) || h[1] && (e[1] < 0 || e[1] > d - 2);
          if (e[0] === g[0] && e[1] === g[1] && h[0] === v[0] && h[1] === v[1] || r && y) break;
          f = t.crossings[u];
        }

        1e4 === c && n.log("Infinite loop in contour?");

        var x,
            b,
            _,
            w,
            T,
            k,
            M,
            A,
            S,
            E,
            L,
            C,
            P,
            I,
            O,
            z = a(p[0], p[p.length - 1], o, l),
            D = 0,
            R = .2 * t.smoothing,
            F = [],
            B = 0;

        for (c = 1; c < p.length; c++) {
          C = p[c], P = p[c - 1], I = void 0, O = void 0, I = C[2] - P[2], O = C[3] - P[3], D += M = Math.sqrt(I * I + O * O), F.push(M);
        }

        var N = D / F.length * R;

        function j(t) {
          return p[t % p.length];
        }

        for (c = p.length - 2; c >= B; c--) {
          if ((x = F[c]) < N) {
            for (_ = 0, b = c - 1; b >= B && x + F[b] < N; b--) {
              x += F[b];
            }

            if (z && c === p.length - 2) for (_ = 0; _ < b && x + F[_] < N; _++) {
              x += F[_];
            }
            T = c - b + _ + 1, k = Math.floor((c + b + _ + 2) / 2), w = z || c !== p.length - 2 ? z || -1 !== b ? T % 2 ? j(k) : [(j(k)[0] + j(k + 1)[0]) / 2, (j(k)[1] + j(k + 1)[1]) / 2] : p[0] : p[p.length - 1], p.splice(b + 1, c - b + 1, w), c = b + 1, _ && (B = _), z && (c === p.length - 2 ? p[_] = p[p.length - 1] : 0 === c && (p[p.length - 1] = p[0]));
          }
        }

        for (p.splice(0, B), c = 0; c < p.length; c++) {
          p[c].length = 2;
        }

        if (!(p.length < 2)) if (z) p.pop(), t.paths.push(p);else {
          r || n.log("Unclosed interior contour?", t.level, g.join(","), p.join("L"));
          var U = !1;

          for (A = 0; A < t.edgepaths.length; A++) {
            if (E = t.edgepaths[A], !U && a(E[0], p[p.length - 1], o, l)) {
              p.pop(), U = !0;
              var V = !1;

              for (S = 0; S < t.edgepaths.length; S++) {
                if (a((L = t.edgepaths[S])[L.length - 1], p[0], o, l)) {
                  V = !0, p.shift(), t.edgepaths.splice(A, 1), S === A ? t.paths.push(p.concat(L)) : (S > A && S--, t.edgepaths[S] = L.concat(p, E));
                  break;
                }
              }

              V || (t.edgepaths[A] = p.concat(E));
            }
          }

          for (A = 0; A < t.edgepaths.length && !U; A++) {
            a((E = t.edgepaths[A])[E.length - 1], p[0], o, l) && (p.shift(), t.edgepaths[A] = E.concat(p), U = !0);
          }

          U || t.edgepaths.push(p);
        }
      }

      function s(t, e, r) {
        var n = e[0] + Math.max(r[0], 0),
            i = e[1] + Math.max(r[1], 0),
            a = t.z[i][n],
            o = t.xaxis,
            s = t.yaxis;

        if (r[1]) {
          var l = (t.level - a) / (t.z[i][n + 1] - a);
          return [o.c2p((1 - l) * t.x[n] + l * t.x[n + 1], !0), s.c2p(t.y[i], !0), n + l, i];
        }

        var c = (t.level - a) / (t.z[i + 1][n] - a);
        return [o.c2p(t.x[n], !0), s.c2p((1 - c) * t.y[i] + c * t.y[i + 1], !0), n, i + c];
      }

      e.exports = function (t, e, r) {
        var i, a, s, l;

        for (e = e || .01, r = r || .01, a = 0; a < t.length; a++) {
          for (s = t[a], l = 0; l < s.starts.length; l++) {
            o(s, s.starts[l], "edge", e, r);
          }

          for (i = 0; Object.keys(s.crossings).length && i < 1e4;) {
            i++, o(s, Object.keys(s.crossings)[0].split(",").map(Number), void 0, e, r);
          }

          1e4 === i && n.log("Infinite loop in contour?");
        }
      };
    }, {
      "../../lib": 795,
      "./constants": 1024
    }],
    1033: [function (t, e, r) {
      "use strict";

      var n = t("../../components/color"),
          i = t("../heatmap/hover");

      e.exports = function (t, e, r, a, o) {
        o || (o = {}), o.isContour = !0;
        var s = i(t, e, r, a, o);
        return s && s.forEach(function (t) {
          var e = t.trace;
          "constraint" === e.contours.type && (e.fillcolor && n.opacity(e.fillcolor) ? t.color = n.addOpacity(e.fillcolor, 1) : e.contours.showlines && n.opacity(e.line.color) && (t.color = n.addOpacity(e.line.color, 1)));
        }), s;
      };
    }, {
      "../../components/color": 658,
      "../heatmap/hover": 1084
    }],
    1034: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        calc: t("./calc"),
        plot: t("./plot").plot,
        style: t("./style"),
        colorbar: t("./colorbar"),
        hoverPoints: t("./hover"),
        moduleType: "trace",
        name: "contour",
        basePlotModule: t("../../plots/cartesian"),
        categories: ["cartesian", "svg", "2dMap", "contour", "showLegend"],
        meta: {}
      };
    }, {
      "../../plots/cartesian": 858,
      "./attributes": 1020,
      "./calc": 1021,
      "./colorbar": 1023,
      "./defaults": 1029,
      "./hover": 1033,
      "./plot": 1038,
      "./style": 1040
    }],
    1035: [function (t, e, r) {
      "use strict";

      var n = t("../../lib");

      e.exports = function (t, e, r, i) {
        if (i || (i = {}), t("contours.showlabels")) {
          var a = e.font;
          n.coerceFont(t, "contours.labelfont", {
            family: a.family,
            size: a.size,
            color: r
          }), t("contours.labelformat");
        }

        !1 !== i.hasHover && t("zhoverformat");
      };
    }, {
      "../../lib": 795
    }],
    1036: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../components/colorscale"),
          a = t("./end_plus");

      e.exports = function (t) {
        var e = t.contours,
            r = e.start,
            o = a(e),
            s = e.size || 1,
            l = Math.floor((o - r) / s) + 1,
            c = "lines" === e.coloring ? 0 : 1,
            u = i.extractOpts(t);
        isFinite(s) || (s = 1, l = 1);
        var f,
            h,
            p = u.reversescale ? i.flipScale(u.colorscale) : u.colorscale,
            d = p.length,
            m = new Array(d),
            g = new Array(d);

        if ("heatmap" === e.coloring) {
          var v = u.min,
              y = u.max;

          for (h = 0; h < d; h++) {
            f = p[h], m[h] = f[0] * (y - v) + v, g[h] = f[1];
          }

          var x = n.extent([v, y, e.start, e.start + s * (l - 1)]),
              b = x[v < y ? 0 : 1],
              _ = x[v < y ? 1 : 0];
          b !== v && (m.splice(0, 0, b), g.splice(0, 0, g[0])), _ !== y && (m.push(_), g.push(g[g.length - 1]));
        } else for (h = 0; h < d; h++) {
          f = p[h], m[h] = (f[0] * (l + c - 1) - c / 2) * s + r, g[h] = f[1];
        }

        return i.makeColorScaleFunc({
          domain: m,
          range: g
        }, {
          noNumericCheck: !0
        });
      };
    }, {
      "../../components/colorscale": 670,
      "./end_plus": 1031,
      "@plotly/d3": 57
    }],
    1037: [function (t, e, r) {
      "use strict";

      var n = t("./constants");

      function i(t, e) {
        var r = (e[0][0] > t ? 0 : 1) + (e[0][1] > t ? 0 : 2) + (e[1][1] > t ? 0 : 4) + (e[1][0] > t ? 0 : 8);
        return 5 === r || 10 === r ? t > (e[0][0] + e[0][1] + e[1][0] + e[1][1]) / 4 ? 5 === r ? 713 : 1114 : 5 === r ? 104 : 208 : 15 === r ? 0 : r;
      }

      e.exports = function (t) {
        var e,
            r,
            a,
            o,
            s,
            l,
            c,
            u,
            f,
            h = t[0].z,
            p = h.length,
            d = h[0].length,
            m = 2 === p || 2 === d;

        for (r = 0; r < p - 1; r++) {
          for (o = [], 0 === r && (o = o.concat(n.BOTTOMSTART)), r === p - 2 && (o = o.concat(n.TOPSTART)), e = 0; e < d - 1; e++) {
            for (a = o.slice(), 0 === e && (a = a.concat(n.LEFTSTART)), e === d - 2 && (a = a.concat(n.RIGHTSTART)), s = e + "," + r, l = [[h[r][e], h[r][e + 1]], [h[r + 1][e], h[r + 1][e + 1]]], f = 0; f < t.length; f++) {
              (c = i((u = t[f]).level, l)) && (u.crossings[s] = c, -1 !== a.indexOf(c) && (u.starts.push([e, r]), m && -1 !== a.indexOf(c, a.indexOf(c) + 1) && u.starts.push([e, r])));
            }
          }
        }
      };
    }, {
      "./constants": 1024
    }],
    1038: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../lib"),
          a = t("../../components/drawing"),
          o = t("../../components/colorscale"),
          s = t("../../lib/svg_text_utils"),
          l = t("../../plots/cartesian/axes"),
          c = t("../../plots/cartesian/set_convert"),
          u = t("../heatmap/plot"),
          f = t("./make_crossings"),
          h = t("./find_all_paths"),
          p = t("./empty_pathinfo"),
          d = t("./convert_to_constraints"),
          m = t("./close_boundaries"),
          g = t("./constants"),
          v = g.LABELOPTIMIZER;

      function y(t, e) {
        var r,
            n,
            o,
            s,
            l,
            c,
            u,
            f = "",
            h = 0,
            p = t.edgepaths.map(function (t, e) {
          return e;
        }),
            d = !0;

        function m(t) {
          return Math.abs(t[1] - e[2][1]) < .01;
        }

        function g(t) {
          return Math.abs(t[0] - e[0][0]) < .01;
        }

        function v(t) {
          return Math.abs(t[0] - e[2][0]) < .01;
        }

        for (; p.length;) {
          for (c = a.smoothopen(t.edgepaths[h], t.smoothing), f += d ? c : c.replace(/^M/, "L"), p.splice(p.indexOf(h), 1), r = t.edgepaths[h][t.edgepaths[h].length - 1], s = -1, o = 0; o < 4; o++) {
            if (!r) {
              i.log("Missing end?", h, t);
              break;
            }

            for (u = r, Math.abs(u[1] - e[0][1]) < .01 && !v(r) ? n = e[1] : g(r) ? n = e[0] : m(r) ? n = e[3] : v(r) && (n = e[2]), l = 0; l < t.edgepaths.length; l++) {
              var y = t.edgepaths[l][0];
              Math.abs(r[0] - n[0]) < .01 ? Math.abs(r[0] - y[0]) < .01 && (y[1] - r[1]) * (n[1] - y[1]) >= 0 && (n = y, s = l) : Math.abs(r[1] - n[1]) < .01 ? Math.abs(r[1] - y[1]) < .01 && (y[0] - r[0]) * (n[0] - y[0]) >= 0 && (n = y, s = l) : i.log("endpt to newendpt is not vert. or horz.", r, n, y);
            }

            if (r = n, s >= 0) break;
            f += "L" + n;
          }

          if (s === t.edgepaths.length) {
            i.log("unclosed perimeter path");
            break;
          }

          h = s, (d = -1 === p.indexOf(h)) && (h = p[0], f += "Z");
        }

        for (h = 0; h < t.paths.length; h++) {
          f += a.smoothclosed(t.paths[h], t.smoothing);
        }

        return f;
      }

      function x(t, e, r, n) {
        var a = e.width / 2,
            o = e.height / 2,
            s = t.x,
            l = t.y,
            c = t.theta,
            u = Math.cos(c) * a,
            f = Math.sin(c) * a,
            h = (s > n.center ? n.right - s : s - n.left) / (u + Math.abs(Math.sin(c) * o)),
            p = (l > n.middle ? n.bottom - l : l - n.top) / (Math.abs(f) + Math.cos(c) * o);
        if (h < 1 || p < 1) return 1 / 0;
        var d = v.EDGECOST * (1 / (h - 1) + 1 / (p - 1));
        d += v.ANGLECOST * c * c;

        for (var m = s - u, g = l - f, y = s + u, x = l + f, b = 0; b < r.length; b++) {
          var _ = r[b],
              w = Math.cos(_.theta) * _.width / 2,
              T = Math.sin(_.theta) * _.width / 2,
              k = 2 * i.segmentDistance(m, g, y, x, _.x - w, _.y - T, _.x + w, _.y + T) / (e.height + _.height),
              M = _.level === e.level,
              A = M ? v.SAMELEVELDISTANCE : 1;

          if (k <= A) return 1 / 0;
          d += v.NEIGHBORCOST * (M ? v.SAMELEVELFACTOR : 1) / (k - A);
        }

        return d;
      }

      function b(t) {
        var e,
            r,
            n = t.trace._emptypoints,
            i = [],
            a = t.z.length,
            o = t.z[0].length,
            s = [];

        for (e = 0; e < o; e++) {
          s.push(1);
        }

        for (e = 0; e < a; e++) {
          i.push(s.slice());
        }

        for (e = 0; e < n.length; e++) {
          i[(r = n[e])[0]][r[1]] = 0;
        }

        return t.zmask = i, i;
      }

      r.plot = function (t, e, o, s) {
        var l = e.xaxis,
            c = e.yaxis;
        i.makeTraceGroups(s, o, "contour").each(function (o) {
          var s = n.select(this),
              v = o[0],
              x = v.trace,
              _ = v.x,
              w = v.y,
              T = x.contours,
              k = p(T, e, v),
              M = i.ensureSingle(s, "g", "heatmapcoloring"),
              A = [];
          "heatmap" === T.coloring && (A = [o]), u(t, e, A, M), f(k), h(k);
          var S = l.c2p(_[0], !0),
              E = l.c2p(_[_.length - 1], !0),
              L = c.c2p(w[0], !0),
              C = c.c2p(w[w.length - 1], !0),
              P = [[S, C], [E, C], [E, L], [S, L]],
              I = k;
          "constraint" === T.type && (I = d(k, T._operation)), function (t, e, r) {
            var n = i.ensureSingle(t, "g", "contourbg").selectAll("path").data("fill" === r.coloring ? [0] : []);
            n.enter().append("path"), n.exit().remove(), n.attr("d", "M" + e.join("L") + "Z").style("stroke", "none");
          }(s, P, T), function (t, e, r, a) {
            var o = "fill" === a.coloring || "constraint" === a.type && "=" !== a._operation,
                s = "M" + r.join("L") + "Z";
            o && m(e, a);
            var l = i.ensureSingle(t, "g", "contourfill").selectAll("path").data(o ? e : []);
            l.enter().append("path"), l.exit().remove(), l.each(function (t) {
              var e = (t.prefixBoundary ? s : "") + y(t, r);
              e ? n.select(this).attr("d", e).style("stroke", "none") : n.select(this).remove();
            });
          }(s, I, P, T), function (t, e, o, s, l) {
            var c = i.ensureSingle(t, "g", "contourlines"),
                u = !1 !== l.showlines,
                f = l.showlabels,
                h = u && f,
                p = r.createLines(c, u || f, e),
                d = r.createLineClip(c, h, o, s.trace.uid),
                m = t.selectAll("g.contourlabels").data(f ? [0] : []);

            if (m.exit().remove(), m.enter().append("g").classed("contourlabels", !0), f) {
              var v = [],
                  y = [];
              i.clearLocationCache();
              var x = r.labelFormatter(o, s),
                  b = a.tester.append("text").attr("data-notex", 1).call(a.font, l.labelfont),
                  _ = e[0].xaxis,
                  w = e[0].yaxis,
                  T = _._length,
                  k = w._length,
                  M = _.range,
                  A = w.range,
                  S = i.aggNums(Math.min, null, s.x),
                  E = i.aggNums(Math.max, null, s.x),
                  L = i.aggNums(Math.min, null, s.y),
                  C = i.aggNums(Math.max, null, s.y),
                  P = Math.max(_.c2p(S, !0), 0),
                  I = Math.min(_.c2p(E, !0), T),
                  O = Math.max(w.c2p(C, !0), 0),
                  z = Math.min(w.c2p(L, !0), k),
                  D = {};
              M[0] < M[1] ? (D.left = P, D.right = I) : (D.left = I, D.right = P), A[0] < A[1] ? (D.top = O, D.bottom = z) : (D.top = z, D.bottom = O), D.middle = (D.top + D.bottom) / 2, D.center = (D.left + D.right) / 2, v.push([[D.left, D.top], [D.right, D.top], [D.right, D.bottom], [D.left, D.bottom]]);
              var R = Math.sqrt(T * T + k * k),
                  F = g.LABELDISTANCE * R / Math.max(1, e.length / g.LABELINCREASE);
              p.each(function (t) {
                var e = r.calcTextOpts(t.level, x, b, o);
                n.select(this).selectAll("path").each(function () {
                  var t = i.getVisibleSegment(this, D, e.height / 2);
                  if (t && !(t.len < (e.width + e.height) * g.LABELMIN)) for (var n = Math.min(Math.ceil(t.len / F), g.LABELMAX), a = 0; a < n; a++) {
                    var o = r.findBestTextLocation(this, t, e, y, D);
                    if (!o) break;
                    r.addLabelData(o, e, y, v);
                  }
                });
              }), b.remove(), r.drawLabels(m, y, o, d, h ? v : null);
            }

            f && !u && p.remove();
          }(s, k, t, v, T), function (t, e, r, n, o) {
            var s = n.trace,
                l = r._fullLayout._clips,
                c = "clip" + s.uid,
                u = l.selectAll("#" + c).data(s.connectgaps ? [] : [0]);

            if (u.enter().append("clipPath").classed("contourclip", !0).attr("id", c), u.exit().remove(), !1 === s.connectgaps) {
              var p = {
                level: .9,
                crossings: {},
                starts: [],
                edgepaths: [],
                paths: [],
                xaxis: e.xaxis,
                yaxis: e.yaxis,
                x: n.x,
                y: n.y,
                z: b(n),
                smoothing: 0
              };
              f([p]), h([p]), m([p], {
                type: "levels"
              }), i.ensureSingle(u, "path", "").attr("d", (p.prefixBoundary ? "M" + o.join("L") + "Z" : "") + y(p, o));
            } else c = null;

            a.setClipUrl(t, c, r);
          }(s, e, t, v, P);
        });
      }, r.createLines = function (t, e, r) {
        var n = r[0].smoothing,
            i = t.selectAll("g.contourlevel").data(e ? r : []);

        if (i.exit().remove(), i.enter().append("g").classed("contourlevel", !0), e) {
          var o = i.selectAll("path.openline").data(function (t) {
            return t.pedgepaths || t.edgepaths;
          });
          o.exit().remove(), o.enter().append("path").classed("openline", !0), o.attr("d", function (t) {
            return a.smoothopen(t, n);
          }).style("stroke-miterlimit", 1).style("vector-effect", "non-scaling-stroke");
          var s = i.selectAll("path.closedline").data(function (t) {
            return t.ppaths || t.paths;
          });
          s.exit().remove(), s.enter().append("path").classed("closedline", !0), s.attr("d", function (t) {
            return a.smoothclosed(t, n);
          }).style("stroke-miterlimit", 1).style("vector-effect", "non-scaling-stroke");
        }

        return i;
      }, r.createLineClip = function (t, e, r, n) {
        var i = e ? "clipline" + n : null,
            o = r._fullLayout._clips.selectAll("#" + i).data(e ? [0] : []);

        return o.exit().remove(), o.enter().append("clipPath").classed("contourlineclip", !0).attr("id", i), a.setClipUrl(t, i, r), o;
      }, r.labelFormatter = function (t, e) {
        var r = t._fullLayout,
            n = e.trace,
            i = n.contours,
            a = {
          type: "linear",
          _id: "ycontour",
          showexponent: "all",
          exponentformat: "B"
        };
        if (i.labelformat) a.tickformat = i.labelformat, c(a, r);else {
          var s = o.extractOpts(n);
          if (s && s.colorbar && s.colorbar._axis) a = s.colorbar._axis;else {
            if ("constraint" === i.type) {
              var u = i.value;
              Array.isArray(u) ? a.range = [u[0], u[u.length - 1]] : a.range = [u, u];
            } else a.range = [i.start, i.end], a.nticks = (i.end - i.start) / i.size;

            a.range[0] === a.range[1] && (a.range[1] += a.range[0] || 1), a.nticks || (a.nticks = 1e3), c(a, r), l.prepTicks(a), a._tmin = null, a._tmax = null;
          }
        }
        return function (t) {
          return l.tickText(a, t).text;
        };
      }, r.calcTextOpts = function (t, e, r, n) {
        var i = e(t);
        r.text(i).call(s.convertToTspans, n);
        var o = r.node(),
            l = a.bBox(o, !0);
        return {
          text: i,
          width: l.width,
          height: l.height,
          fontSize: +o.style["font-size"].replace("px", ""),
          level: t,
          dy: (l.top + l.bottom) / 2
        };
      }, r.findBestTextLocation = function (t, e, r, n, a) {
        var o,
            s,
            l,
            c,
            u,
            f = r.width;
        e.isClosed ? (s = e.len / v.INITIALSEARCHPOINTS, o = e.min + s / 2, l = e.max) : (s = (e.len - f) / (v.INITIALSEARCHPOINTS + 1), o = e.min + s + f / 2, l = e.max - (s + f) / 2);

        for (var h = 1 / 0, p = 0; p < v.ITERATIONS; p++) {
          for (var d = o; d < l; d += s) {
            var m = i.getTextLocation(t, e.total, d, f),
                g = x(m, r, n, a);
            g < h && (h = g, u = m, c = d);
          }

          if (h > 2 * v.MAXCOST) break;
          p && (s /= 2), l = (o = c - s / 2) + 1.5 * s;
        }

        if (h <= v.MAXCOST) return u;
      }, r.addLabelData = function (t, e, r, n) {
        var i = e.fontSize,
            a = e.width + i / 3,
            o = Math.max(0, e.height - i / 3),
            s = t.x,
            l = t.y,
            c = t.theta,
            u = Math.sin(c),
            f = Math.cos(c),
            h = function h(t, e) {
          return [s + t * f - e * u, l + t * u + e * f];
        },
            p = [h(-a / 2, -o / 2), h(-a / 2, o / 2), h(a / 2, o / 2), h(a / 2, -o / 2)];

        r.push({
          text: e.text,
          x: s,
          y: l,
          dy: e.dy,
          theta: c,
          level: e.level,
          width: a,
          height: o
        }), n.push(p);
      }, r.drawLabels = function (t, e, r, a, o) {
        var l = t.selectAll("text").data(e, function (t) {
          return t.text + "," + t.x + "," + t.y + "," + t.theta;
        });

        if (l.exit().remove(), l.enter().append("text").attr({
          "data-notex": 1,
          "text-anchor": "middle"
        }).each(function (t) {
          var e = t.x + Math.sin(t.theta) * t.dy,
              i = t.y - Math.cos(t.theta) * t.dy;
          n.select(this).text(t.text).attr({
            x: e,
            y: i,
            transform: "rotate(" + 180 * t.theta / Math.PI + " " + e + " " + i + ")"
          }).call(s.convertToTspans, r);
        }), o) {
          for (var c = "", u = 0; u < o.length; u++) {
            c += "M" + o[u].join("L") + "Z";
          }

          i.ensureSingle(a, "path", "").attr("d", c);
        }
      };
    }, {
      "../../components/colorscale": 670,
      "../../components/drawing": 680,
      "../../lib": 795,
      "../../lib/svg_text_utils": 820,
      "../../plots/cartesian/axes": 845,
      "../../plots/cartesian/set_convert": 865,
      "../heatmap/plot": 1088,
      "./close_boundaries": 1022,
      "./constants": 1024,
      "./convert_to_constraints": 1028,
      "./empty_pathinfo": 1030,
      "./find_all_paths": 1032,
      "./make_crossings": 1037,
      "@plotly/d3": 57
    }],
    1039: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/cartesian/axes"),
          i = t("../../lib");

      function a(t, e, r) {
        var i = {
          type: "linear",
          range: [t, e]
        };
        return n.autoTicks(i, (e - t) / (r || 15)), i;
      }

      e.exports = function (t, e) {
        var r = t.contours;

        if (t.autocontour) {
          var o = t.zmin,
              s = t.zmax;
          (t.zauto || void 0 === o) && (o = i.aggNums(Math.min, null, e)), (t.zauto || void 0 === s) && (s = i.aggNums(Math.max, null, e));
          var l = a(o, s, t.ncontours);
          r.size = l.dtick, r.start = n.tickFirst(l), l.range.reverse(), r.end = n.tickFirst(l), r.start === o && (r.start += r.size), r.end === s && (r.end -= r.size), r.start > r.end && (r.start = r.end = (r.start + r.end) / 2), t._input.contours || (t._input.contours = {}), i.extendFlat(t._input.contours, {
            start: r.start,
            end: r.end,
            size: r.size
          }), t._input.autocontour = !0;
        } else if ("constraint" !== r.type) {
          var c,
              u = r.start,
              f = r.end,
              h = t._input.contours;
          if (u > f && (r.start = h.start = f, f = r.end = h.end = u, u = r.start), !(r.size > 0)) c = u === f ? 1 : a(u, f, t.ncontours).dtick, h.size = r.size = c;
        }
      };
    }, {
      "../../lib": 795,
      "../../plots/cartesian/axes": 845
    }],
    1040: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../components/drawing"),
          a = t("../heatmap/style"),
          o = t("./make_color_map");

      e.exports = function (t) {
        var e = n.select(t).selectAll("g.contour");
        e.style("opacity", function (t) {
          return t[0].trace.opacity;
        }), e.each(function (t) {
          var e = n.select(this),
              r = t[0].trace,
              a = r.contours,
              s = r.line,
              l = a.size || 1,
              c = a.start,
              u = "constraint" === a.type,
              f = !u && "lines" === a.coloring,
              h = !u && "fill" === a.coloring,
              p = f || h ? o(r) : null;
          e.selectAll("g.contourlevel").each(function (t) {
            n.select(this).selectAll("path").call(i.lineGroupStyle, s.width, f ? p(t.level) : s.color, s.dash);
          });
          var d = a.labelfont;
          if (e.selectAll("g.contourlabels text").each(function (t) {
            i.font(n.select(this), {
              family: d.family,
              size: d.size,
              color: d.color || (f ? p(t.level) : s.color)
            });
          }), u) e.selectAll("g.contourfill path").style("fill", r.fillcolor);else if (h) {
            var m;
            e.selectAll("g.contourfill path").style("fill", function (t) {
              return void 0 === m && (m = t.level), p(t.level + .5 * l);
            }), void 0 === m && (m = c), e.selectAll("g.contourbg path").style("fill", p(m - .5 * l));
          }
        }), a(t);
      };
    }, {
      "../../components/drawing": 680,
      "../heatmap/style": 1089,
      "./make_color_map": 1036,
      "@plotly/d3": 57
    }],
    1041: [function (t, e, r) {
      "use strict";

      var n = t("../../components/colorscale/defaults"),
          i = t("./label_defaults");

      e.exports = function (t, e, r, a, o) {
        var s,
            l = r("contours.coloring"),
            c = "";
        "fill" === l && (s = r("contours.showlines")), !1 !== s && ("lines" !== l && (c = r("line.color", "#000")), r("line.width", .5), r("line.dash")), "none" !== l && (!0 !== t.showlegend && (e.showlegend = !1), e._dfltShowLegend = !1, n(t, e, a, r, {
          prefix: "",
          cLetter: "z"
        })), r("line.smoothing"), i(r, a, c, o);
      };
    }, {
      "../../components/colorscale/defaults": 668,
      "./label_defaults": 1035
    }],
    1042: [function (t, e, r) {
      "use strict";

      var n = t("../heatmap/attributes"),
          i = t("../contour/attributes"),
          a = t("../../components/colorscale/attributes"),
          o = t("../../lib/extend").extendFlat,
          s = i.contours;
      e.exports = o({
        carpet: {
          valType: "string",
          editType: "calc"
        },
        z: n.z,
        a: n.x,
        a0: n.x0,
        da: n.dx,
        b: n.y,
        b0: n.y0,
        db: n.dy,
        text: n.text,
        hovertext: n.hovertext,
        transpose: n.transpose,
        atype: n.xtype,
        btype: n.ytype,
        fillcolor: i.fillcolor,
        autocontour: i.autocontour,
        ncontours: i.ncontours,
        contours: {
          type: s.type,
          start: s.start,
          end: s.end,
          size: s.size,
          coloring: {
            valType: "enumerated",
            values: ["fill", "lines", "none"],
            dflt: "fill",
            editType: "calc"
          },
          showlines: s.showlines,
          showlabels: s.showlabels,
          labelfont: s.labelfont,
          labelformat: s.labelformat,
          operation: s.operation,
          value: s.value,
          editType: "calc",
          impliedEdits: {
            autocontour: !1
          }
        },
        line: {
          color: i.line.color,
          width: i.line.width,
          dash: i.line.dash,
          smoothing: i.line.smoothing,
          editType: "plot"
        },
        transforms: void 0
      }, a("", {
        cLetter: "z",
        autoColorDflt: !1
      }));
    }, {
      "../../components/colorscale/attributes": 665,
      "../../lib/extend": 785,
      "../contour/attributes": 1020,
      "../heatmap/attributes": 1077
    }],
    1043: [function (t, e, r) {
      "use strict";

      var n = t("../../components/colorscale/calc"),
          i = t("../../lib"),
          a = t("../heatmap/convert_column_xyz"),
          o = t("../heatmap/clean_2d_array"),
          s = t("../heatmap/interp2d"),
          l = t("../heatmap/find_empties"),
          c = t("../heatmap/make_bound_array"),
          u = t("./defaults"),
          f = t("../carpet/lookup_carpetid"),
          h = t("../contour/set_contours");

      e.exports = function (t, e) {
        var r = e._carpetTrace = f(t, e);

        if (r && r.visible && "legendonly" !== r.visible) {
          if (!e.a || !e.b) {
            var p = t.data[r.index],
                d = t.data[e.index];
            d.a || (d.a = p.a), d.b || (d.b = p.b), u(d, e, e._defaultColor, t._fullLayout);
          }

          var m = function (t, e) {
            var r,
                u,
                f,
                h,
                p,
                d,
                m,
                g = e._carpetTrace,
                v = g.aaxis,
                y = g.baxis;
            v._minDtick = 0, y._minDtick = 0, i.isArray1D(e.z) && a(e, v, y, "a", "b", ["z"]);
            r = e._a = e._a || e.a, h = e._b = e._b || e.b, r = r ? v.makeCalcdata(e, "_a") : [], h = h ? y.makeCalcdata(e, "_b") : [], u = e.a0 || 0, f = e.da || 1, p = e.b0 || 0, d = e.db || 1, m = e._z = o(e._z || e.z, e.transpose), e._emptypoints = l(m), s(m, e._emptypoints);

            var x = i.maxRowLength(m),
                b = "scaled" === e.xtype ? "" : r,
                _ = c(e, b, u, f, x, v),
                w = "scaled" === e.ytype ? "" : h,
                T = c(e, w, p, d, m.length, y),
                k = {
              a: _,
              b: T,
              z: m
            };

            "levels" === e.contours.type && "none" !== e.contours.coloring && n(t, e, {
              vals: m,
              containerStr: "",
              cLetter: "z"
            });
            return [k];
          }(t, e);

          return h(e, e._z), m;
        }
      };
    }, {
      "../../components/colorscale/calc": 666,
      "../../lib": 795,
      "../carpet/lookup_carpetid": 993,
      "../contour/set_contours": 1039,
      "../heatmap/clean_2d_array": 1079,
      "../heatmap/convert_column_xyz": 1081,
      "../heatmap/find_empties": 1083,
      "../heatmap/interp2d": 1086,
      "../heatmap/make_bound_array": 1087,
      "./defaults": 1044
    }],
    1044: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../heatmap/xyz_defaults"),
          a = t("./attributes"),
          o = t("../contour/constraint_defaults"),
          s = t("../contour/contours_defaults"),
          l = t("../contour/style_defaults");

      e.exports = function (t, e, r, c) {
        function u(r, i) {
          return n.coerce(t, e, a, r, i);
        }

        if (u("carpet"), t.a && t.b) {
          if (!i(t, e, u, c, "a", "b")) return void (e.visible = !1);
          u("text"), "constraint" === u("contours.type") ? o(t, e, u, c, r, {
            hasHover: !1
          }) : (s(t, e, u, function (r) {
            return n.coerce2(t, e, a, r);
          }), l(t, e, u, c, {
            hasHover: !1
          }));
        } else e._defaultColor = r, e._length = null;
      };
    }, {
      "../../lib": 795,
      "../contour/constraint_defaults": 1025,
      "../contour/contours_defaults": 1027,
      "../contour/style_defaults": 1041,
      "../heatmap/xyz_defaults": 1091,
      "./attributes": 1042
    }],
    1045: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        colorbar: t("../contour/colorbar"),
        calc: t("./calc"),
        plot: t("./plot"),
        style: t("../contour/style"),
        moduleType: "trace",
        name: "contourcarpet",
        basePlotModule: t("../../plots/cartesian"),
        categories: ["cartesian", "svg", "carpet", "contour", "symbols", "showLegend", "hasLines", "carpetDependent", "noHover", "noSortingByValue"],
        meta: {}
      };
    }, {
      "../../plots/cartesian": 858,
      "../contour/colorbar": 1023,
      "../contour/style": 1040,
      "./attributes": 1042,
      "./calc": 1043,
      "./defaults": 1044,
      "./plot": 1046
    }],
    1046: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../carpet/map_1d_array"),
          a = t("../carpet/makepath"),
          o = t("../../components/drawing"),
          s = t("../../lib"),
          l = t("../contour/make_crossings"),
          c = t("../contour/find_all_paths"),
          u = t("../contour/plot"),
          f = t("../contour/constants"),
          h = t("../contour/convert_to_constraints"),
          p = t("../contour/empty_pathinfo"),
          d = t("../contour/close_boundaries"),
          m = t("../carpet/lookup_carpetid"),
          g = t("../carpet/axis_aligned_line");

      function v(t, e, r) {
        var n = t.getPointAtLength(e),
            i = t.getPointAtLength(r),
            a = i.x - n.x,
            o = i.y - n.y,
            s = Math.sqrt(a * a + o * o);
        return [a / s, o / s];
      }

      function y(t) {
        var e = Math.sqrt(t[0] * t[0] + t[1] * t[1]);
        return [t[0] / e, t[1] / e];
      }

      function x(t, e) {
        var r = Math.abs(t[0] * e[0] + t[1] * e[1]);
        return Math.sqrt(1 - r * r) / r;
      }

      e.exports = function (t, e, r, b) {
        var _ = e.xaxis,
            w = e.yaxis;
        s.makeTraceGroups(b, r, "contour").each(function (r) {
          var b = n.select(this),
              T = r[0],
              k = T.trace,
              M = k._carpetTrace = m(t, k),
              A = t.calcdata[M.index][0];

          if (M.visible && "legendonly" !== M.visible) {
            var S = T.a,
                E = T.b,
                L = k.contours,
                C = p(L, e, T),
                P = "constraint" === L.type,
                I = L._operation,
                O = P ? "=" === I ? "lines" : "fill" : L.coloring,
                z = [[S[0], E[E.length - 1]], [S[S.length - 1], E[E.length - 1]], [S[S.length - 1], E[0]], [S[0], E[0]]];
            l(C);
            var D = 1e-8 * (S[S.length - 1] - S[0]),
                R = 1e-8 * (E[E.length - 1] - E[0]);
            c(C, D, R);
            var F,
                B,
                N,
                j,
                U = C;
            "constraint" === L.type && (U = h(C, I)), function (t, e) {
              var r, n, i, a, o, s, l, c, u;

              for (r = 0; r < t.length; r++) {
                for (a = t[r], o = a.pedgepaths = [], s = a.ppaths = [], n = 0; n < a.edgepaths.length; n++) {
                  for (u = a.edgepaths[n], l = [], i = 0; i < u.length; i++) {
                    l[i] = e(u[i]);
                  }

                  o.push(l);
                }

                for (n = 0; n < a.paths.length; n++) {
                  for (u = a.paths[n], c = [], i = 0; i < u.length; i++) {
                    c[i] = e(u[i]);
                  }

                  s.push(c);
                }
              }
            }(C, H);
            var V = [];

            for (j = A.clipsegments.length - 1; j >= 0; j--) {
              F = A.clipsegments[j], B = i([], F.x, _.c2p), N = i([], F.y, w.c2p), B.reverse(), N.reverse(), V.push(a(B, N, F.bicubic));
            }

            var q = "M" + V.join("L") + "Z";
            !function (t, e, r, n, o, l) {
              var c,
                  u,
                  f,
                  h,
                  p = s.ensureSingle(t, "g", "contourbg").selectAll("path").data("fill" !== l || o ? [] : [0]);
              p.enter().append("path"), p.exit().remove();
              var d = [];

              for (h = 0; h < e.length; h++) {
                c = e[h], u = i([], c.x, r.c2p), f = i([], c.y, n.c2p), d.push(a(u, f, c.bicubic));
              }

              p.attr("d", "M" + d.join("L") + "Z").style("stroke", "none");
            }(b, A.clipsegments, _, w, P, O), function (t, e, r, i, a, l, c, u, f, h, p) {
              var m = "fill" === h;
              m && d(a, t.contours);
              var v = s.ensureSingle(e, "g", "contourfill").selectAll("path").data(m ? a : []);
              v.enter().append("path"), v.exit().remove(), v.each(function (t) {
                var e = (t.prefixBoundary ? p : "") + function (t, e, r, n, i, a, l, c) {
                  var u,
                      f,
                      h,
                      p,
                      d,
                      m,
                      v,
                      y = "",
                      x = e.edgepaths.map(function (t, e) {
                    return e;
                  }),
                      b = !0,
                      _ = 1e-4 * Math.abs(r[0][0] - r[2][0]),
                      w = 1e-4 * Math.abs(r[0][1] - r[2][1]);

                  function T(t) {
                    return Math.abs(t[1] - r[0][1]) < w;
                  }

                  function k(t) {
                    return Math.abs(t[1] - r[2][1]) < w;
                  }

                  function M(t) {
                    return Math.abs(t[0] - r[0][0]) < _;
                  }

                  function A(t) {
                    return Math.abs(t[0] - r[2][0]) < _;
                  }

                  function S(t, e) {
                    var r,
                        n,
                        o,
                        s,
                        u = "";

                    for (T(t) && !A(t) || k(t) && !M(t) ? (s = i.aaxis, o = g(i, a, [t[0], e[0]], .5 * (t[1] + e[1]))) : (s = i.baxis, o = g(i, a, .5 * (t[0] + e[0]), [t[1], e[1]])), r = 1; r < o.length; r++) {
                      for (u += s.smoothing ? "C" : "L", n = 0; n < o[r].length; n++) {
                        var f = o[r][n];
                        u += [l.c2p(f[0]), c.c2p(f[1])] + " ";
                      }
                    }

                    return u;
                  }

                  u = 0, f = null;

                  for (; x.length;) {
                    var E = e.edgepaths[u][0];

                    for (f && (y += S(f, E)), v = o.smoothopen(e.edgepaths[u].map(n), e.smoothing), y += b ? v : v.replace(/^M/, "L"), x.splice(x.indexOf(u), 1), f = e.edgepaths[u][e.edgepaths[u].length - 1], d = -1, p = 0; p < 4; p++) {
                      if (!f) {
                        s.log("Missing end?", u, e);
                        break;
                      }

                      for (T(f) && !A(f) ? h = r[1] : M(f) ? h = r[0] : k(f) ? h = r[3] : A(f) && (h = r[2]), m = 0; m < e.edgepaths.length; m++) {
                        var L = e.edgepaths[m][0];
                        Math.abs(f[0] - h[0]) < _ ? Math.abs(f[0] - L[0]) < _ && (L[1] - f[1]) * (h[1] - L[1]) >= 0 && (h = L, d = m) : Math.abs(f[1] - h[1]) < w ? Math.abs(f[1] - L[1]) < w && (L[0] - f[0]) * (h[0] - L[0]) >= 0 && (h = L, d = m) : s.log("endpt to newendpt is not vert. or horz.", f, h, L);
                      }

                      if (d >= 0) break;
                      y += S(f, h), f = h;
                    }

                    if (d === e.edgepaths.length) {
                      s.log("unclosed perimeter path");
                      break;
                    }

                    u = d, (b = -1 === x.indexOf(u)) && (u = x[0], y += S(f, h) + "Z", f = null);
                  }

                  for (u = 0; u < e.paths.length; u++) {
                    y += o.smoothclosed(e.paths[u].map(n), e.smoothing);
                  }

                  return y;
                }(0, t, l, c, u, f, r, i);

                e ? n.select(this).attr("d", e).style("stroke", "none") : n.select(this).remove();
              });
            }(k, b, _, w, U, z, H, M, A, O, q), function (t, e, r, i, a, l, c) {
              var h = s.ensureSingle(t, "g", "contourlines"),
                  p = !1 !== a.showlines,
                  d = a.showlabels,
                  m = p && d,
                  g = u.createLines(h, p || d, e),
                  b = u.createLineClip(h, m, r, i.trace.uid),
                  _ = t.selectAll("g.contourlabels").data(d ? [0] : []);

              if (_.exit().remove(), _.enter().append("g").classed("contourlabels", !0), d) {
                var w = l.xaxis,
                    T = l.yaxis,
                    k = w._length,
                    M = T._length,
                    A = [[[0, 0], [k, 0], [k, M], [0, M]]],
                    S = [];
                s.clearLocationCache();
                var E = u.labelFormatter(r, i),
                    L = o.tester.append("text").attr("data-notex", 1).call(o.font, a.labelfont),
                    C = {
                  left: 0,
                  right: k,
                  center: k / 2,
                  top: 0,
                  bottom: M,
                  middle: M / 2
                },
                    P = Math.sqrt(k * k + M * M),
                    I = f.LABELDISTANCE * P / Math.max(1, e.length / f.LABELINCREASE);
                g.each(function (t) {
                  var e = u.calcTextOpts(t.level, E, L, r);
                  n.select(this).selectAll("path").each(function (r) {
                    var n = s.getVisibleSegment(this, C, e.height / 2);
                    if (n && (function (t, e, r, n, i, a) {
                      for (var o, s = 0; s < r.pedgepaths.length; s++) {
                        e === r.pedgepaths[s] && (o = r.edgepaths[s]);
                      }

                      if (!o) return;
                      var l = i.a[0],
                          c = i.a[i.a.length - 1],
                          u = i.b[0],
                          f = i.b[i.b.length - 1];

                      function h(t, e) {
                        var r,
                            n = 0;
                        return (Math.abs(t[0] - l) < .1 || Math.abs(t[0] - c) < .1) && (r = y(i.dxydb_rough(t[0], t[1], .1)), n = Math.max(n, a * x(e, r) / 2)), (Math.abs(t[1] - u) < .1 || Math.abs(t[1] - f) < .1) && (r = y(i.dxyda_rough(t[0], t[1], .1)), n = Math.max(n, a * x(e, r) / 2)), n;
                      }

                      var p = v(t, 0, 1),
                          d = v(t, n.total, n.total - 1),
                          m = h(o[0], p),
                          g = n.total - h(o[o.length - 1], d);
                      n.min < m && (n.min = m);
                      n.max > g && (n.max = g);
                      n.len = n.max - n.min;
                    }(this, r, t, n, c, e.height), !(n.len < (e.width + e.height) * f.LABELMIN))) for (var i = Math.min(Math.ceil(n.len / I), f.LABELMAX), a = 0; a < i; a++) {
                      var o = u.findBestTextLocation(this, n, e, S, C);
                      if (!o) break;
                      u.addLabelData(o, e, S, A);
                    }
                  });
                }), L.remove(), u.drawLabels(_, S, r, b, m ? A : null);
              }

              d && !p && g.remove();
            }(b, C, t, T, L, e, M), o.setClipUrl(b, M._clipPathId, t);
          }

          function H(t) {
            var e = M.ab2xy(t[0], t[1], !0);
            return [_.c2p(e[0]), w.c2p(e[1])];
          }
        });
      };
    }, {
      "../../components/drawing": 680,
      "../../lib": 795,
      "../carpet/axis_aligned_line": 977,
      "../carpet/lookup_carpetid": 993,
      "../carpet/makepath": 994,
      "../carpet/map_1d_array": 995,
      "../contour/close_boundaries": 1022,
      "../contour/constants": 1024,
      "../contour/convert_to_constraints": 1028,
      "../contour/empty_pathinfo": 1030,
      "../contour/find_all_paths": 1032,
      "../contour/make_crossings": 1037,
      "../contour/plot": 1038,
      "@plotly/d3": 57
    }],
    1047: [function (t, e, r) {
      "use strict";

      var n = t("../../components/colorscale/attributes"),
          i = t("../../plots/template_attributes").hovertemplateAttrs,
          a = t("../../plots/attributes"),
          o = t("../scattermapbox/attributes"),
          s = t("../../lib/extend").extendFlat;
      e.exports = s({
        lon: o.lon,
        lat: o.lat,
        z: {
          valType: "data_array",
          editType: "calc"
        },
        radius: {
          valType: "number",
          editType: "plot",
          arrayOk: !0,
          min: 1,
          dflt: 30
        },
        below: {
          valType: "string",
          editType: "plot"
        },
        text: o.text,
        hovertext: o.hovertext,
        hoverinfo: s({}, a.hoverinfo, {
          flags: ["lon", "lat", "z", "text", "name"]
        }),
        hovertemplate: i(),
        showlegend: s({}, a.showlegend, {
          dflt: !1
        })
      }, n("", {
        cLetter: "z",
        editTypeOverride: "calc"
      }));
    }, {
      "../../components/colorscale/attributes": 665,
      "../../lib/extend": 785,
      "../../plots/attributes": 841,
      "../../plots/template_attributes": 918,
      "../scattermapbox/attributes": 1264
    }],
    1048: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../lib").isArrayOrTypedArray,
          a = t("../../constants/numerical").BADNUM,
          o = t("../../components/colorscale/calc"),
          s = t("../../lib")._;

      e.exports = function (t, e) {
        for (var r = e._length, l = new Array(r), c = e.z, u = i(c) && c.length, f = 0; f < r; f++) {
          var h = l[f] = {},
              p = e.lon[f],
              d = e.lat[f];

          if (h.lonlat = n(p) && n(d) ? [+p, +d] : [a, a], u) {
            var m = c[f];
            h.z = n(m) ? m : a;
          }
        }

        return o(t, e, {
          vals: u ? c : [0, 1],
          containerStr: "",
          cLetter: "z"
        }), r && (l[0].t = {
          labels: {
            lat: s(t, "lat:") + " ",
            lon: s(t, "lon:") + " "
          }
        }), l;
      };
    }, {
      "../../components/colorscale/calc": 666,
      "../../constants/numerical": 771,
      "../../lib": 795,
      "fast-isnumeric": 240
    }],
    1049: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../lib"),
          a = t("../../components/color"),
          o = t("../../components/colorscale"),
          s = t("../../constants/numerical").BADNUM,
          l = t("../../lib/geojson_utils").makeBlank;

      e.exports = function (t) {
        var e = t[0].trace,
            r = !0 === e.visible && 0 !== e._length,
            c = e._opts = {
          heatmap: {
            layout: {
              visibility: "none"
            },
            paint: {}
          },
          geojson: l()
        };
        if (!r) return c;
        var u,
            f = [],
            h = e.z,
            p = e.radius,
            d = i.isArrayOrTypedArray(h) && h.length,
            m = i.isArrayOrTypedArray(p);

        for (u = 0; u < t.length; u++) {
          var g = t[u],
              v = g.lonlat;

          if (v[0] !== s) {
            var y = {};

            if (d) {
              var x = g.z;
              y.z = x !== s ? x : 0;
            }

            m && (y.r = n(p[u]) && p[u] > 0 ? +p[u] : 0), f.push({
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: v
              },
              properties: y
            });
          }
        }

        var b = o.extractOpts(e),
            _ = b.reversescale ? o.flipScale(b.colorscale) : b.colorscale,
            w = _[0][1],
            T = ["interpolate", ["linear"], ["heatmap-density"], 0, a.opacity(w) < 1 ? w : a.addOpacity(w, 0)];

        for (u = 1; u < _.length; u++) {
          T.push(_[u][0], _[u][1]);
        }

        var k = ["interpolate", ["linear"], ["get", "z"], b.min, 0, b.max, 1];
        return i.extendFlat(c.heatmap.paint, {
          "heatmap-weight": d ? k : 1 / (b.max - b.min),
          "heatmap-color": T,
          "heatmap-radius": m ? {
            type: "identity",
            property: "r"
          } : e.radius,
          "heatmap-opacity": e.opacity
        }), c.geojson = {
          type: "FeatureCollection",
          features: f
        }, c.heatmap.layout.visibility = "visible", c;
      };
    }, {
      "../../components/color": 658,
      "../../components/colorscale": 670,
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../../lib/geojson_utils": 789,
      "fast-isnumeric": 240
    }],
    1050: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../components/colorscale/defaults"),
          a = t("./attributes");

      e.exports = function (t, e, r, o) {
        function s(r, i) {
          return n.coerce(t, e, a, r, i);
        }

        var l = s("lon") || [],
            c = s("lat") || [],
            u = Math.min(l.length, c.length);
        u ? (e._length = u, s("z"), s("radius"), s("below"), s("text"), s("hovertext"), s("hovertemplate"), i(t, e, o, s, {
          prefix: "",
          cLetter: "z"
        })) : e.visible = !1;
      };
    }, {
      "../../components/colorscale/defaults": 668,
      "../../lib": 795,
      "./attributes": 1047
    }],
    1051: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        return t.lon = e.lon, t.lat = e.lat, t.z = e.z, t;
      };
    }, {}],
    1052: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/cartesian/axes"),
          i = t("../scattermapbox/hover").hoverPoints,
          a = t("../scattermapbox/hover").getExtraText;

      e.exports = function (t, e, r) {
        var o = i(t, e, r);

        if (o) {
          var s = o[0],
              l = s.cd,
              c = l[0].trace,
              u = l[s.index];

          if (delete s.color, "z" in u) {
            var f = s.subplot.mockAxis;
            s.z = u.z, s.zLabel = n.tickText(f, f.c2l(u.z), "hover").text;
          }

          return s.extraText = a(c, u, l[0].t.labels), [s];
        }
      };
    }, {
      "../../plots/cartesian/axes": 845,
      "../scattermapbox/hover": 1269
    }],
    1053: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        colorbar: t("../heatmap/colorbar"),
        formatLabels: t("../scattermapbox/format_labels"),
        calc: t("./calc"),
        plot: t("./plot"),
        hoverPoints: t("./hover"),
        eventData: t("./event_data"),
        getBelow: function getBelow(t, e) {
          for (var r = e.getMapLayers(), n = 0; n < r.length; n++) {
            var i = r[n],
                a = i.id;
            if ("symbol" === i.type && "string" == typeof a && -1 === a.indexOf("plotly-")) return a;
          }
        },
        moduleType: "trace",
        name: "densitymapbox",
        basePlotModule: t("../../plots/mapbox"),
        categories: ["mapbox", "gl", "showLegend"],
        meta: {
          hr_name: "density_mapbox"
        }
      };
    }, {
      "../../plots/mapbox": 903,
      "../heatmap/colorbar": 1080,
      "../scattermapbox/format_labels": 1268,
      "./attributes": 1047,
      "./calc": 1048,
      "./defaults": 1050,
      "./event_data": 1051,
      "./hover": 1052,
      "./plot": 1054
    }],
    1054: [function (t, e, r) {
      "use strict";

      var n = t("./convert"),
          i = t("../../plots/mapbox/constants").traceLayerPrefix;

      function a(t, e) {
        this.type = "densitymapbox", this.subplot = t, this.uid = e, this.sourceId = "source-" + e, this.layerList = [["heatmap", i + e + "-heatmap"]], this.below = null;
      }

      var o = a.prototype;
      o.update = function (t) {
        var e = this.subplot,
            r = this.layerList,
            i = n(t),
            a = e.belowLookup["trace-" + this.uid];
        e.map.getSource(this.sourceId).setData(i.geojson), a !== this.below && (this._removeLayers(), this._addLayers(i, a), this.below = a);

        for (var o = 0; o < r.length; o++) {
          var s = r[o],
              l = s[0],
              c = s[1],
              u = i[l];
          e.setOptions(c, "setLayoutProperty", u.layout), "visible" === u.layout.visibility && e.setOptions(c, "setPaintProperty", u.paint);
        }
      }, o._addLayers = function (t, e) {
        for (var r = this.subplot, n = this.layerList, i = this.sourceId, a = 0; a < n.length; a++) {
          var o = n[a],
              s = o[0],
              l = t[s];
          r.addLayer({
            type: s,
            id: o[1],
            source: i,
            layout: l.layout,
            paint: l.paint
          }, e);
        }
      }, o._removeLayers = function () {
        for (var t = this.subplot.map, e = this.layerList, r = e.length - 1; r >= 0; r--) {
          t.removeLayer(e[r][1]);
        }
      }, o.dispose = function () {
        var t = this.subplot.map;
        this._removeLayers(), t.removeSource(this.sourceId);
      }, e.exports = function (t, e) {
        var r = e[0].trace,
            i = new a(t, r.uid),
            o = i.sourceId,
            s = n(e),
            l = i.below = t.belowLookup["trace-" + r.uid];
        return t.map.addSource(o, {
          type: "geojson",
          data: s.geojson
        }), i._addLayers(s, l), i;
      };
    }, {
      "../../plots/mapbox/constants": 901,
      "./convert": 1049
    }],
    1055: [function (t, e, r) {
      "use strict";

      var n = t("../../lib");

      e.exports = function (t, e) {
        for (var r = 0; r < t.length; r++) {
          t[r].i = r;
        }

        n.mergeArray(e.text, t, "tx"), n.mergeArray(e.hovertext, t, "htx");
        var i = e.marker;

        if (i) {
          n.mergeArray(i.opacity, t, "mo"), n.mergeArray(i.color, t, "mc");
          var a = i.line;
          a && (n.mergeArray(a.color, t, "mlc"), n.mergeArrayCastPositive(a.width, t, "mlw"));
        }
      };
    }, {
      "../../lib": 795
    }],
    1056: [function (t, e, r) {
      "use strict";

      var n,
          i = t("../bar/attributes"),
          a = t("../scatter/attributes").line,
          o = t("../../plots/attributes"),
          s = t("../../plots/hoverformat_attributes"),
          l = t("../../plots/template_attributes").hovertemplateAttrs,
          c = t("../../plots/template_attributes").texttemplateAttrs,
          u = t("./constants"),
          f = t("../../lib/extend").extendFlat,
          h = t("../../components/color");
      e.exports = {
        x: i.x,
        x0: i.x0,
        dx: i.dx,
        y: i.y,
        y0: i.y0,
        dy: i.dy,
        xperiod: i.xperiod,
        yperiod: i.yperiod,
        xperiod0: i.xperiod0,
        yperiod0: i.yperiod0,
        xperiodalignment: i.xperiodalignment,
        yperiodalignment: i.yperiodalignment,
        xhoverformat: s("x"),
        yhoverformat: s("y"),
        hovertext: i.hovertext,
        hovertemplate: l({}, {
          keys: u.eventDataKeys
        }),
        hoverinfo: f({}, o.hoverinfo, {
          flags: ["name", "x", "y", "text", "percent initial", "percent previous", "percent total"]
        }),
        textinfo: {
          valType: "flaglist",
          flags: ["label", "text", "percent initial", "percent previous", "percent total", "value"],
          extras: ["none"],
          editType: "plot",
          arrayOk: !1
        },
        texttemplate: c({
          editType: "plot"
        }, {
          keys: u.eventDataKeys.concat(["label", "value"])
        }),
        text: i.text,
        textposition: i.textposition,
        insidetextanchor: f({}, i.insidetextanchor, {
          dflt: "middle"
        }),
        textangle: f({}, i.textangle, {
          dflt: 0
        }),
        textfont: i.textfont,
        insidetextfont: i.insidetextfont,
        outsidetextfont: i.outsidetextfont,
        constraintext: i.constraintext,
        cliponaxis: i.cliponaxis,
        orientation: f({}, i.orientation, {}),
        offset: f({}, i.offset, {
          arrayOk: !1
        }),
        width: f({}, i.width, {
          arrayOk: !1
        }),
        marker: (n = f({}, i.marker), delete n.pattern, n),
        connector: {
          fillcolor: {
            valType: "color",
            editType: "style"
          },
          line: {
            color: f({}, a.color, {
              dflt: h.defaultLine
            }),
            width: f({}, a.width, {
              dflt: 0,
              editType: "plot"
            }),
            dash: a.dash,
            editType: "style"
          },
          visible: {
            valType: "boolean",
            dflt: !0,
            editType: "plot"
          },
          editType: "plot"
        },
        offsetgroup: i.offsetgroup,
        alignmentgroup: i.alignmentgroup
      };
    }, {
      "../../components/color": 658,
      "../../lib/extend": 785,
      "../../plots/attributes": 841,
      "../../plots/hoverformat_attributes": 899,
      "../../plots/template_attributes": 918,
      "../bar/attributes": 933,
      "../scatter/attributes": 1199,
      "./constants": 1058
    }],
    1057: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/cartesian/axes"),
          i = t("../../plots/cartesian/align_period"),
          a = t("./arrays_to_calcdata"),
          o = t("../scatter/calc_selection"),
          s = t("../../constants/numerical").BADNUM;

      function l(t) {
        return t === s ? 0 : t;
      }

      e.exports = function (t, e) {
        var r,
            c,
            u,
            f,
            h,
            p,
            d = n.getFromId(t, e.xaxis || "x"),
            m = n.getFromId(t, e.yaxis || "y");
        "h" === e.orientation ? (r = d.makeCalcdata(e, "x"), u = m.makeCalcdata(e, "y"), c = i(e, m, "y", u), p = !!e.yperiodalignment) : (r = m.makeCalcdata(e, "y"), u = d.makeCalcdata(e, "x"), c = i(e, d, "x", u), p = !!e.xperiodalignment);
        var g,
            v = Math.min(c.length, r.length),
            y = new Array(v);

        for (e._base = [], f = 0; f < v; f++) {
          r[f] < 0 && (r[f] = s);
          var x = !1;
          r[f] !== s && f + 1 < v && r[f + 1] !== s && (x = !0), h = y[f] = {
            p: c[f],
            s: r[f],
            cNext: x
          }, e._base[f] = -.5 * h.s, p && (y[f].orig_p = u[f]), e.ids && (h.id = String(e.ids[f])), 0 === f && (y[0].vTotal = 0), y[0].vTotal += l(h.s), h.begR = l(h.s) / l(y[0].s);
        }

        for (f = 0; f < v; f++) {
          (h = y[f]).s !== s && (h.sumR = h.s / y[0].vTotal, h.difR = void 0 !== g ? h.s / g : 1, g = h.s);
        }

        return a(y, e), o(y, e), y;
      };
    }, {
      "../../constants/numerical": 771,
      "../../plots/cartesian/align_period": 842,
      "../../plots/cartesian/axes": 845,
      "../scatter/calc_selection": 1201,
      "./arrays_to_calcdata": 1055
    }],
    1058: [function (t, e, r) {
      "use strict";

      e.exports = {
        eventDataKeys: ["percentInitial", "percentPrevious", "percentTotal"]
      };
    }, {}],
    1059: [function (t, e, r) {
      "use strict";

      var n = t("../bar/cross_trace_calc").setGroupPositions;

      e.exports = function (t, e) {
        var r,
            i,
            a = t._fullLayout,
            o = t._fullData,
            s = t.calcdata,
            l = e.xaxis,
            c = e.yaxis,
            u = [],
            f = [],
            h = [];

        for (i = 0; i < o.length; i++) {
          var p = o[i],
              d = "h" === p.orientation;
          !0 === p.visible && p.xaxis === l._id && p.yaxis === c._id && "funnel" === p.type && (r = s[i], d ? h.push(r) : f.push(r), u.push(r));
        }

        var m = {
          mode: a.funnelmode,
          norm: a.funnelnorm,
          gap: a.funnelgap,
          groupgap: a.funnelgroupgap
        };

        for (n(t, l, c, f, m), n(t, c, l, h, m), i = 0; i < u.length; i++) {
          r = u[i];

          for (var g = 0; g < r.length; g++) {
            g + 1 < r.length && (r[g].nextP0 = r[g + 1].p0, r[g].nextS0 = r[g + 1].s0, r[g].nextP1 = r[g + 1].p1, r[g].nextS1 = r[g + 1].s1);
          }
        }
      };
    }, {
      "../bar/cross_trace_calc": 936
    }],
    1060: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../bar/defaults").handleGroupingDefaults,
          a = t("../bar/defaults").handleText,
          o = t("../scatter/xy_defaults"),
          s = t("../scatter/period_defaults"),
          l = t("./attributes"),
          c = t("../../components/color");
      e.exports = {
        supplyDefaults: function supplyDefaults(t, e, r, i) {
          function u(r, i) {
            return n.coerce(t, e, l, r, i);
          }

          if (o(t, e, i, u)) {
            s(t, e, i, u), u("xhoverformat"), u("yhoverformat"), u("orientation", e.y && !e.x ? "v" : "h"), u("offset"), u("width");
            var f = u("text");
            u("hovertext"), u("hovertemplate");
            var h = u("textposition");
            a(t, e, i, u, h, {
              moduleHasSelected: !1,
              moduleHasUnselected: !1,
              moduleHasConstrain: !0,
              moduleHasCliponaxis: !0,
              moduleHasTextangle: !0,
              moduleHasInsideanchor: !0
            }), "none" === e.textposition || e.texttemplate || u("textinfo", Array.isArray(f) ? "text+value" : "value");
            var p = u("marker.color", r);
            if (u("marker.line.color", c.defaultLine), u("marker.line.width"), u("connector.visible")) u("connector.fillcolor", function (t) {
              var e = n.isArrayOrTypedArray(t) ? "#000" : t;
              return c.addOpacity(e, .5 * c.opacity(e));
            }(p)), u("connector.line.width") && (u("connector.line.color"), u("connector.line.dash"));
          } else e.visible = !1;
        },
        crossTraceDefaults: function crossTraceDefaults(t, e) {
          var r, a;

          function o(t) {
            return n.coerce(a._input, a, l, t);
          }

          if ("group" === e.funnelmode) for (var s = 0; s < t.length; s++) {
            r = (a = t[s])._input, i(r, a, e, o);
          }
        }
      };
    }, {
      "../../components/color": 658,
      "../../lib": 795,
      "../bar/defaults": 937,
      "../scatter/period_defaults": 1219,
      "../scatter/xy_defaults": 1226,
      "./attributes": 1056
    }],
    1061: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        return t.x = "xVal" in e ? e.xVal : e.x, t.y = "yVal" in e ? e.yVal : e.y, "percentInitial" in e && (t.percentInitial = e.percentInitial), "percentPrevious" in e && (t.percentPrevious = e.percentPrevious), "percentTotal" in e && (t.percentTotal = e.percentTotal), e.xa && (t.xaxis = e.xa), e.ya && (t.yaxis = e.ya), t;
      };
    }, {}],
    1062: [function (t, e, r) {
      "use strict";

      var n = t("../../components/color").opacity,
          i = t("../bar/hover").hoverOnBars,
          a = t("../../lib").formatPercent;

      e.exports = function (t, e, r, o, s) {
        var l = i(t, e, r, o, s);

        if (l) {
          var c = l.cd,
              u = c[0].trace,
              f = "h" === u.orientation,
              h = c[l.index];
          l[(f ? "x" : "y") + "LabelVal"] = h.s, l.percentInitial = h.begR, l.percentInitialLabel = a(h.begR, 1), l.percentPrevious = h.difR, l.percentPreviousLabel = a(h.difR, 1), l.percentTotal = h.sumR, l.percentTotalLabel = a(h.sumR, 1);
          var p = h.hi || u.hoverinfo,
              d = [];

          if (p && "none" !== p && "skip" !== p) {
            var m = "all" === p,
                g = p.split("+"),
                v = function v(t) {
              return m || -1 !== g.indexOf(t);
            };

            v("percent initial") && d.push(l.percentInitialLabel + " of initial"), v("percent previous") && d.push(l.percentPreviousLabel + " of previous"), v("percent total") && d.push(l.percentTotalLabel + " of total");
          }

          return l.extraText = d.join("<br>"), l.color = function (t, e) {
            var r = t.marker,
                i = e.mc || r.color,
                a = e.mlc || r.line.color,
                o = e.mlw || r.line.width;
            if (n(i)) return i;
            if (n(a) && o) return a;
          }(u, h), [l];
        }
      };
    }, {
      "../../components/color": 658,
      "../../lib": 795,
      "../bar/hover": 940
    }],
    1063: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        layoutAttributes: t("./layout_attributes"),
        supplyDefaults: t("./defaults").supplyDefaults,
        crossTraceDefaults: t("./defaults").crossTraceDefaults,
        supplyLayoutDefaults: t("./layout_defaults"),
        calc: t("./calc"),
        crossTraceCalc: t("./cross_trace_calc"),
        plot: t("./plot"),
        style: t("./style").style,
        hoverPoints: t("./hover"),
        eventData: t("./event_data"),
        selectPoints: t("../bar/select"),
        moduleType: "trace",
        name: "funnel",
        basePlotModule: t("../../plots/cartesian"),
        categories: ["bar-like", "cartesian", "svg", "oriented", "showLegend", "zoomScale"],
        meta: {}
      };
    }, {
      "../../plots/cartesian": 858,
      "../bar/select": 945,
      "./attributes": 1056,
      "./calc": 1057,
      "./cross_trace_calc": 1059,
      "./defaults": 1060,
      "./event_data": 1061,
      "./hover": 1062,
      "./layout_attributes": 1064,
      "./layout_defaults": 1065,
      "./plot": 1066,
      "./style": 1067
    }],
    1064: [function (t, e, r) {
      "use strict";

      e.exports = {
        funnelmode: {
          valType: "enumerated",
          values: ["stack", "group", "overlay"],
          dflt: "stack",
          editType: "calc"
        },
        funnelgap: {
          valType: "number",
          min: 0,
          max: 1,
          editType: "calc"
        },
        funnelgroupgap: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 0,
          editType: "calc"
        }
      };
    }, {}],
    1065: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./layout_attributes");

      e.exports = function (t, e, r) {
        var a = !1;

        function o(r, a) {
          return n.coerce(t, e, i, r, a);
        }

        for (var s = 0; s < r.length; s++) {
          var l = r[s];

          if (l.visible && "funnel" === l.type) {
            a = !0;
            break;
          }
        }

        a && (o("funnelmode"), o("funnelgap", .2), o("funnelgroupgap"));
      };
    }, {
      "../../lib": 795,
      "./layout_attributes": 1064
    }],
    1066: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../lib"),
          a = t("../../components/drawing"),
          o = t("../../constants/numerical").BADNUM,
          s = t("../bar/plot"),
          l = t("../bar/uniform_text").clearMinTextSize;

      function c(t, e, r, n) {
        var i = [],
            a = [],
            o = n ? e : r,
            s = n ? r : e;
        return i[0] = o.c2p(t.s0, !0), a[0] = s.c2p(t.p0, !0), i[1] = o.c2p(t.s1, !0), a[1] = s.c2p(t.p1, !0), i[2] = o.c2p(t.nextS0, !0), a[2] = s.c2p(t.nextP0, !0), i[3] = o.c2p(t.nextS1, !0), a[3] = s.c2p(t.nextP1, !0), n ? [i, a] : [a, i];
      }

      e.exports = function (t, e, r, u) {
        var f = t._fullLayout;
        l("funnel", f), function (t, e, r, s) {
          var l = e.xaxis,
              u = e.yaxis;
          i.makeTraceGroups(s, r, "trace bars").each(function (r) {
            var s = n.select(this),
                f = r[0].trace,
                h = i.ensureSingle(s, "g", "regions");

            if (f.connector && f.connector.visible) {
              var p = "h" === f.orientation,
                  d = h.selectAll("g.region").data(i.identity);
              d.enter().append("g").classed("region", !0), d.exit().remove();
              var m = d.size();
              d.each(function (r, s) {
                if (s === m - 1 || r.cNext) {
                  var f = c(r, l, u, p),
                      h = f[0],
                      d = f[1],
                      g = "";
                  h[0] !== o && d[0] !== o && h[1] !== o && d[1] !== o && h[2] !== o && d[2] !== o && h[3] !== o && d[3] !== o && (g += p ? "M" + h[0] + "," + d[1] + "L" + h[2] + "," + d[2] + "H" + h[3] + "L" + h[1] + "," + d[1] + "Z" : "M" + h[1] + "," + d[1] + "L" + h[2] + "," + d[3] + "V" + d[2] + "L" + h[1] + "," + d[0] + "Z"), "" === g && (g = "M0,0Z"), i.ensureSingle(n.select(this), "path").attr("d", g).call(a.setClipUrl, e.layerClipId, t);
                }
              });
            } else h.remove();
          });
        }(t, e, r, u), function (t, e, r, o) {
          var s = e.xaxis,
              l = e.yaxis;
          i.makeTraceGroups(o, r, "trace bars").each(function (r) {
            var o = n.select(this),
                u = r[0].trace,
                f = i.ensureSingle(o, "g", "lines");

            if (u.connector && u.connector.visible && u.connector.line.width) {
              var h = "h" === u.orientation,
                  p = f.selectAll("g.line").data(i.identity);
              p.enter().append("g").classed("line", !0), p.exit().remove();
              var d = p.size();
              p.each(function (r, o) {
                if (o === d - 1 || r.cNext) {
                  var u = c(r, s, l, h),
                      f = u[0],
                      p = u[1],
                      m = "";
                  void 0 !== f[3] && void 0 !== p[3] && (h ? (m += "M" + f[0] + "," + p[1] + "L" + f[2] + "," + p[2], m += "M" + f[1] + "," + p[1] + "L" + f[3] + "," + p[2]) : (m += "M" + f[1] + "," + p[1] + "L" + f[2] + "," + p[3], m += "M" + f[1] + "," + p[0] + "L" + f[2] + "," + p[2])), "" === m && (m = "M0,0Z"), i.ensureSingle(n.select(this), "path").attr("d", m).call(a.setClipUrl, e.layerClipId, t);
                }
              });
            } else f.remove();
          });
        }(t, e, r, u), s.plot(t, e, r, u, {
          mode: f.funnelmode,
          norm: f.funnelmode,
          gap: f.funnelgap,
          groupgap: f.funnelgroupgap
        });
      };
    }, {
      "../../components/drawing": 680,
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../bar/plot": 944,
      "../bar/uniform_text": 949,
      "@plotly/d3": 57
    }],
    1067: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../components/drawing"),
          a = t("../../components/color"),
          o = t("../../constants/interactions").DESELECTDIM,
          s = t("../bar/style"),
          l = t("../bar/uniform_text").resizeText,
          c = s.styleTextPoints;
      e.exports = {
        style: function style(t, e, r) {
          var s = r || n.select(t).selectAll("g.funnellayer").selectAll("g.trace");
          l(t, s, "funnel"), s.style("opacity", function (t) {
            return t[0].trace.opacity;
          }), s.each(function (e) {
            var r = n.select(this),
                s = e[0].trace;
            r.selectAll(".point > path").each(function (t) {
              if (!t.isBlank) {
                var e = s.marker;
                n.select(this).call(a.fill, t.mc || e.color).call(a.stroke, t.mlc || e.line.color).call(i.dashLine, e.line.dash, t.mlw || e.line.width).style("opacity", s.selectedpoints && !t.selected ? o : 1);
              }
            }), c(r, s, t), r.selectAll(".regions").each(function () {
              n.select(this).selectAll("path").style("stroke-width", 0).call(a.fill, s.connector.fillcolor);
            }), r.selectAll(".lines").each(function () {
              var t = s.connector.line;
              i.lineGroupStyle(n.select(this).selectAll("path"), t.width, t.color, t.dash);
            });
          });
        }
      };
    }, {
      "../../components/color": 658,
      "../../components/drawing": 680,
      "../../constants/interactions": 770,
      "../bar/style": 947,
      "../bar/uniform_text": 949,
      "@plotly/d3": 57
    }],
    1068: [function (t, e, r) {
      "use strict";

      var n = t("../pie/attributes"),
          i = t("../../plots/attributes"),
          a = t("../../plots/domain").attributes,
          o = t("../../plots/template_attributes").hovertemplateAttrs,
          s = t("../../plots/template_attributes").texttemplateAttrs,
          l = t("../../lib/extend").extendFlat;
      e.exports = {
        labels: n.labels,
        label0: n.label0,
        dlabel: n.dlabel,
        values: n.values,
        marker: {
          colors: n.marker.colors,
          line: {
            color: l({}, n.marker.line.color, {
              dflt: null
            }),
            width: l({}, n.marker.line.width, {
              dflt: 1
            }),
            editType: "calc"
          },
          editType: "calc"
        },
        text: n.text,
        hovertext: n.hovertext,
        scalegroup: l({}, n.scalegroup, {}),
        textinfo: l({}, n.textinfo, {
          flags: ["label", "text", "value", "percent"]
        }),
        texttemplate: s({
          editType: "plot"
        }, {
          keys: ["label", "color", "value", "text", "percent"]
        }),
        hoverinfo: l({}, i.hoverinfo, {
          flags: ["label", "text", "value", "percent", "name"]
        }),
        hovertemplate: o({}, {
          keys: ["label", "color", "value", "text", "percent"]
        }),
        textposition: l({}, n.textposition, {
          values: ["inside", "none"],
          dflt: "inside"
        }),
        textfont: n.textfont,
        insidetextfont: n.insidetextfont,
        title: {
          text: n.title.text,
          font: n.title.font,
          position: l({}, n.title.position, {
            values: ["top left", "top center", "top right"],
            dflt: "top center"
          }),
          editType: "plot"
        },
        domain: a({
          name: "funnelarea",
          trace: !0,
          editType: "calc"
        }),
        aspectratio: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "plot"
        },
        baseratio: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: .333,
          editType: "plot"
        }
      };
    }, {
      "../../lib/extend": 785,
      "../../plots/attributes": 841,
      "../../plots/domain": 872,
      "../../plots/template_attributes": 918,
      "../pie/attributes": 1173
    }],
    1069: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/plots");
      r.name = "funnelarea", r.plot = function (t, e, i, a) {
        n.plotBasePlot(r.name, t, e, i, a);
      }, r.clean = function (t, e, i, a) {
        n.cleanBasePlot(r.name, t, e, i, a);
      };
    }, {
      "../../plots/plots": 909
    }],
    1070: [function (t, e, r) {
      "use strict";

      var n = t("../pie/calc");
      e.exports = {
        calc: function calc(t, e) {
          return n.calc(t, e);
        },
        crossTraceCalc: function crossTraceCalc(t) {
          n.crossTraceCalc(t, {
            type: "funnelarea"
          });
        }
      };
    }, {
      "../pie/calc": 1175
    }],
    1071: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./attributes"),
          a = t("../../plots/domain").defaults,
          o = t("../bar/defaults").handleText,
          s = t("../pie/defaults").handleLabelsAndValues;

      e.exports = function (t, e, r, l) {
        function c(r, a) {
          return n.coerce(t, e, i, r, a);
        }

        var u = c("labels"),
            f = c("values"),
            h = s(u, f),
            p = h.len;

        if (e._hasLabels = h.hasLabels, e._hasValues = h.hasValues, !e._hasLabels && e._hasValues && (c("label0"), c("dlabel")), p) {
          e._length = p, c("marker.line.width") && c("marker.line.color", l.paper_bgcolor), c("marker.colors"), c("scalegroup");
          var d,
              m = c("text"),
              g = c("texttemplate");

          if (g || (d = c("textinfo", Array.isArray(m) ? "text+percent" : "percent")), c("hovertext"), c("hovertemplate"), g || d && "none" !== d) {
            var v = c("textposition");
            o(t, e, l, c, v, {
              moduleHasSelected: !1,
              moduleHasUnselected: !1,
              moduleHasConstrain: !1,
              moduleHasCliponaxis: !1,
              moduleHasTextangle: !1,
              moduleHasInsideanchor: !1
            });
          }

          a(e, l, c), c("title.text") && (c("title.position"), n.coerceFont(c, "title.font", l.font)), c("aspectratio"), c("baseratio");
        } else e.visible = !1;
      };
    }, {
      "../../lib": 795,
      "../../plots/domain": 872,
      "../bar/defaults": 937,
      "../pie/defaults": 1176,
      "./attributes": 1068
    }],
    1072: [function (t, e, r) {
      "use strict";

      e.exports = {
        moduleType: "trace",
        name: "funnelarea",
        basePlotModule: t("./base_plot"),
        categories: ["pie-like", "funnelarea", "showLegend"],
        attributes: t("./attributes"),
        layoutAttributes: t("./layout_attributes"),
        supplyDefaults: t("./defaults"),
        supplyLayoutDefaults: t("./layout_defaults"),
        calc: t("./calc").calc,
        crossTraceCalc: t("./calc").crossTraceCalc,
        plot: t("./plot"),
        style: t("./style"),
        styleOne: t("../pie/style_one"),
        meta: {}
      };
    }, {
      "../pie/style_one": 1184,
      "./attributes": 1068,
      "./base_plot": 1069,
      "./calc": 1070,
      "./defaults": 1071,
      "./layout_attributes": 1073,
      "./layout_defaults": 1074,
      "./plot": 1075,
      "./style": 1076
    }],
    1073: [function (t, e, r) {
      "use strict";

      var n = t("../pie/layout_attributes").hiddenlabels;
      e.exports = {
        hiddenlabels: n,
        funnelareacolorway: {
          valType: "colorlist",
          editType: "calc"
        },
        extendfunnelareacolors: {
          valType: "boolean",
          dflt: !0,
          editType: "calc"
        }
      };
    }, {
      "../pie/layout_attributes": 1180
    }],
    1074: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./layout_attributes");

      e.exports = function (t, e) {
        function r(r, a) {
          return n.coerce(t, e, i, r, a);
        }

        r("hiddenlabels"), r("funnelareacolorway", e.colorway), r("extendfunnelareacolors");
      };
    }, {
      "../../lib": 795,
      "./layout_attributes": 1073
    }],
    1075: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../components/drawing"),
          a = t("../../lib"),
          o = a.strScale,
          s = a.strTranslate,
          l = t("../../lib/svg_text_utils"),
          c = t("../bar/plot").toMoveInsideBar,
          u = t("../bar/uniform_text"),
          f = u.recordMinTextSize,
          h = u.clearMinTextSize,
          p = t("../pie/helpers"),
          d = t("../pie/plot"),
          m = d.attachFxHandlers,
          g = d.determineInsideTextFont,
          v = d.layoutAreas,
          y = d.prerenderTitles,
          x = d.positionTitleOutside,
          b = d.formatSliceLabel;

      function _(t, e) {
        return "l" + (e[0] - t[0]) + "," + (e[1] - t[1]);
      }

      e.exports = function (t, e) {
        var r = t._fullLayout;
        h("funnelarea", r), y(e, t), v(e, r._size), a.makeTraceGroups(r._funnelarealayer, e, "trace").each(function (e) {
          var u = n.select(this),
              h = e[0],
              d = h.trace;
          !function (t) {
            if (!t.length) return;
            var e = t[0],
                r = e.trace,
                n = r.aspectratio,
                i = r.baseratio;
            i > .999 && (i = .999);
            var a,
                o = Math.pow(i, 2),
                s = e.vTotal,
                l = s,
                c = s * o / (1 - o) / s;

            function u() {
              var t,
                  e = {
                x: t = Math.sqrt(c),
                y: -t
              };
              return [e.x, e.y];
            }

            var f,
                h,
                p = [];

            for (p.push(u()), f = t.length - 1; f > -1; f--) {
              if (!(h = t[f]).hidden) {
                var d = h.v / l;
                c += d, p.push(u());
              }
            }

            var m = 1 / 0,
                g = -1 / 0;

            for (f = 0; f < p.length; f++) {
              a = p[f], m = Math.min(m, a[1]), g = Math.max(g, a[1]);
            }

            for (f = 0; f < p.length; f++) {
              p[f][1] -= (g + m) / 2;
            }

            var v = p[p.length - 1][0],
                y = e.r,
                x = (g - m) / 2,
                b = y / v,
                _ = y / x * n;

            for (e.r = _ * x, f = 0; f < p.length; f++) {
              p[f][0] *= b, p[f][1] *= _;
            }

            var w = [-(a = p[0])[0], a[1]],
                T = [a[0], a[1]],
                k = 0;

            for (f = t.length - 1; f > -1; f--) {
              if (!(h = t[f]).hidden) {
                var M = p[k += 1][0],
                    A = p[k][1];
                h.TL = [-M, A], h.TR = [M, A], h.BL = w, h.BR = T, h.pxmid = (S = h.TR, E = h.BR, [.5 * (S[0] + E[0]), .5 * (S[1] + E[1])]), w = h.TL, T = h.TR;
              }
            }

            var S, E;
          }(e), u.each(function () {
            var u = n.select(this).selectAll("g.slice").data(e);
            u.enter().append("g").classed("slice", !0), u.exit().remove(), u.each(function (o, s) {
              if (o.hidden) n.select(this).selectAll("path,g").remove();else {
                o.pointNumber = o.i, o.curveNumber = d.index;
                var u = h.cx,
                    v = h.cy,
                    y = n.select(this),
                    x = y.selectAll("path.surface").data([o]);
                x.enter().append("path").classed("surface", !0).style({
                  "pointer-events": "all"
                }), y.call(m, t, e);
                var w = "M" + (u + o.TR[0]) + "," + (v + o.TR[1]) + _(o.TR, o.BR) + _(o.BR, o.BL) + _(o.BL, o.TL) + "Z";
                x.attr("d", w), b(t, o, h);
                var T = p.castOption(d.textposition, o.pts),
                    k = y.selectAll("g.slicetext").data(o.text && "none" !== T ? [0] : []);
                k.enter().append("g").classed("slicetext", !0), k.exit().remove(), k.each(function () {
                  var h = a.ensureSingle(n.select(this), "text", "", function (t) {
                    t.attr("data-notex", 1);
                  }),
                      p = a.ensureUniformFontSize(t, g(d, o, r.font));
                  h.text(o.text).attr({
                    class: "slicetext",
                    transform: "",
                    "text-anchor": "middle"
                  }).call(i.font, p).call(l.convertToTspans, t);

                  var m,
                      y,
                      x,
                      b = i.bBox(h.node()),
                      _ = Math.min(o.BL[1], o.BR[1]) + v,
                      w = Math.max(o.TL[1], o.TR[1]) + v;

                  y = Math.max(o.TL[0], o.BL[0]) + u, x = Math.min(o.TR[0], o.BR[0]) + u, (m = c(y, x, _, w, b, {
                    isHorizontal: !0,
                    constrained: !0,
                    angle: 0,
                    anchor: "middle"
                  })).fontSize = p.size, f(d.type, m, r), e[s].transform = m, h.attr("transform", a.getTextTransform(m));
                });
              }
            });
            var v = n.select(this).selectAll("g.titletext").data(d.title.text ? [0] : []);
            v.enter().append("g").classed("titletext", !0), v.exit().remove(), v.each(function () {
              var e = a.ensureSingle(n.select(this), "text", "", function (t) {
                t.attr("data-notex", 1);
              }),
                  c = d.title.text;
              d._meta && (c = a.templateString(c, d._meta)), e.text(c).attr({
                class: "titletext",
                transform: "",
                "text-anchor": "middle"
              }).call(i.font, d.title.font).call(l.convertToTspans, t);
              var u = x(h, r._size);
              e.attr("transform", s(u.x, u.y) + o(Math.min(1, u.scale)) + s(u.tx, u.ty));
            });
          });
        });
      };
    }, {
      "../../components/drawing": 680,
      "../../lib": 795,
      "../../lib/svg_text_utils": 820,
      "../bar/plot": 944,
      "../bar/uniform_text": 949,
      "../pie/helpers": 1178,
      "../pie/plot": 1182,
      "@plotly/d3": 57
    }],
    1076: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../pie/style_one"),
          a = t("../bar/uniform_text").resizeText;

      e.exports = function (t) {
        var e = t._fullLayout._funnelarealayer.selectAll(".trace");

        a(t, e, "funnelarea"), e.each(function (t) {
          var e = t[0].trace,
              r = n.select(this);
          r.style({
            opacity: e.opacity
          }), r.selectAll("path.surface").each(function (t) {
            n.select(this).call(i, t, e);
          });
        });
      };
    }, {
      "../bar/uniform_text": 949,
      "../pie/style_one": 1184,
      "@plotly/d3": 57
    }],
    1077: [function (t, e, r) {
      "use strict";

      var n = t("../scatter/attributes"),
          i = t("../../plots/attributes"),
          a = t("../../plots/hoverformat_attributes"),
          o = t("../../plots/template_attributes").hovertemplateAttrs,
          s = t("../../components/colorscale/attributes"),
          l = t("../../lib/extend").extendFlat;
      e.exports = l({
        z: {
          valType: "data_array",
          editType: "calc"
        },
        x: l({}, n.x, {
          impliedEdits: {
            xtype: "array"
          }
        }),
        x0: l({}, n.x0, {
          impliedEdits: {
            xtype: "scaled"
          }
        }),
        dx: l({}, n.dx, {
          impliedEdits: {
            xtype: "scaled"
          }
        }),
        y: l({}, n.y, {
          impliedEdits: {
            ytype: "array"
          }
        }),
        y0: l({}, n.y0, {
          impliedEdits: {
            ytype: "scaled"
          }
        }),
        dy: l({}, n.dy, {
          impliedEdits: {
            ytype: "scaled"
          }
        }),
        xperiod: l({}, n.xperiod, {
          impliedEdits: {
            xtype: "scaled"
          }
        }),
        yperiod: l({}, n.yperiod, {
          impliedEdits: {
            ytype: "scaled"
          }
        }),
        xperiod0: l({}, n.xperiod0, {
          impliedEdits: {
            xtype: "scaled"
          }
        }),
        yperiod0: l({}, n.yperiod0, {
          impliedEdits: {
            ytype: "scaled"
          }
        }),
        xperiodalignment: l({}, n.xperiodalignment, {
          impliedEdits: {
            xtype: "scaled"
          }
        }),
        yperiodalignment: l({}, n.yperiodalignment, {
          impliedEdits: {
            ytype: "scaled"
          }
        }),
        text: {
          valType: "data_array",
          editType: "calc"
        },
        hovertext: {
          valType: "data_array",
          editType: "calc"
        },
        transpose: {
          valType: "boolean",
          dflt: !1,
          editType: "calc"
        },
        xtype: {
          valType: "enumerated",
          values: ["array", "scaled"],
          editType: "calc+clearAxisTypes"
        },
        ytype: {
          valType: "enumerated",
          values: ["array", "scaled"],
          editType: "calc+clearAxisTypes"
        },
        zsmooth: {
          valType: "enumerated",
          values: ["fast", "best", !1],
          dflt: !1,
          editType: "calc"
        },
        hoverongaps: {
          valType: "boolean",
          dflt: !0,
          editType: "none"
        },
        connectgaps: {
          valType: "boolean",
          editType: "calc"
        },
        xgap: {
          valType: "number",
          dflt: 0,
          min: 0,
          editType: "plot"
        },
        ygap: {
          valType: "number",
          dflt: 0,
          min: 0,
          editType: "plot"
        },
        xhoverformat: a("x"),
        yhoverformat: a("y"),
        zhoverformat: a("z", 1),
        hovertemplate: o(),
        showlegend: l({}, i.showlegend, {
          dflt: !1
        })
      }, {
        transforms: void 0
      }, s("", {
        cLetter: "z",
        autoColorDflt: !1
      }));
    }, {
      "../../components/colorscale/attributes": 665,
      "../../lib/extend": 785,
      "../../plots/attributes": 841,
      "../../plots/hoverformat_attributes": 899,
      "../../plots/template_attributes": 918,
      "../scatter/attributes": 1199
    }],
    1078: [function (t, e, r) {
      "use strict";

      var n = t("../../registry"),
          i = t("../../lib"),
          a = t("../../plots/cartesian/axes"),
          o = t("../../plots/cartesian/align_period"),
          s = t("../histogram2d/calc"),
          l = t("../../components/colorscale/calc"),
          c = t("./convert_column_xyz"),
          u = t("./clean_2d_array"),
          f = t("./interp2d"),
          h = t("./find_empties"),
          p = t("./make_bound_array"),
          d = t("../../constants/numerical").BADNUM;

      function m(t) {
        for (var e = [], r = t.length, n = 0; n < r; n++) {
          var i = t[n];
          i !== d && e.push(i);
        }

        return e;
      }

      e.exports = function (t, e) {
        var r,
            g,
            v,
            y,
            x,
            b,
            _,
            w,
            T,
            k,
            M,
            A = a.getFromId(t, e.xaxis || "x"),
            S = a.getFromId(t, e.yaxis || "y"),
            E = n.traceIs(e, "contour"),
            L = n.traceIs(e, "histogram"),
            C = n.traceIs(e, "gl2d"),
            P = E ? "best" : e.zsmooth;

        if (A._minDtick = 0, S._minDtick = 0, L) y = (M = s(t, e)).orig_x, r = M.x, g = M.x0, v = M.dx, w = M.orig_y, x = M.y, b = M.y0, _ = M.dy, T = M.z;else {
          var I = e.z;
          i.isArray1D(I) ? (c(e, A, S, "x", "y", ["z"]), r = e._x, x = e._y, I = e._z) : (y = e.x ? A.makeCalcdata(e, "x") : [], w = e.y ? S.makeCalcdata(e, "y") : [], r = o(e, A, "x", y), x = o(e, S, "y", w), e._x = r, e._y = x), g = e.x0, v = e.dx, b = e.y0, _ = e.dy, T = u(I, e, A, S);
        }

        function O(t) {
          P = e._input.zsmooth = e.zsmooth = !1, i.warn('cannot use zsmooth: "fast": ' + t);
        }

        if ((A.rangebreaks || S.rangebreaks) && (T = function (t, e, r) {
          for (var n = [], i = -1, a = 0; a < r.length; a++) {
            if (e[a] !== d) {
              i++, n[i] = [];

              for (var o = 0; o < r[a].length; o++) {
                t[o] !== d && n[i].push(r[a][o]);
              }
            }
          }

          return n;
        }(r, x, T), L || (r = m(r), x = m(x), e._x = r, e._y = x)), L || !E && !e.connectgaps || (e._emptypoints = h(T), f(T, e._emptypoints)), "fast" === P) if ("log" === A.type || "log" === S.type) O("log axis found");else if (!L) {
          if (r.length) {
            var z = (r[r.length - 1] - r[0]) / (r.length - 1),
                D = Math.abs(z / 100);

            for (k = 0; k < r.length - 1; k++) {
              if (Math.abs(r[k + 1] - r[k] - z) > D) {
                O("x scale is not linear");
                break;
              }
            }
          }

          if (x.length && "fast" === P) {
            var R = (x[x.length - 1] - x[0]) / (x.length - 1),
                F = Math.abs(R / 100);

            for (k = 0; k < x.length - 1; k++) {
              if (Math.abs(x[k + 1] - x[k] - R) > F) {
                O("y scale is not linear");
                break;
              }
            }
          }
        }
        var B = i.maxRowLength(T),
            N = "scaled" === e.xtype ? "" : r,
            j = p(e, N, g, v, B, A),
            U = "scaled" === e.ytype ? "" : x,
            V = p(e, U, b, _, T.length, S);
        C || (e._extremes[A._id] = a.findExtremes(A, j), e._extremes[S._id] = a.findExtremes(S, V));
        var q = {
          x: j,
          y: V,
          z: T,
          text: e._text || e.text,
          hovertext: e._hovertext || e.hovertext
        };

        if (e.xperiodalignment && y && (q.orig_x = y), e.yperiodalignment && w && (q.orig_y = w), N && N.length === j.length - 1 && (q.xCenter = N), U && U.length === V.length - 1 && (q.yCenter = U), L && (q.xRanges = M.xRanges, q.yRanges = M.yRanges, q.pts = M.pts), E || l(t, e, {
          vals: T,
          cLetter: "z"
        }), E && e.contours && "heatmap" === e.contours.coloring) {
          var H = {
            type: "contour" === e.type ? "heatmap" : "histogram2d",
            xcalendar: e.xcalendar,
            ycalendar: e.ycalendar
          };
          q.xfill = p(H, N, g, v, B, A), q.yfill = p(H, U, b, _, T.length, S);
        }

        return [q];
      };
    }, {
      "../../components/colorscale/calc": 666,
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../../plots/cartesian/align_period": 842,
      "../../plots/cartesian/axes": 845,
      "../../registry": 923,
      "../histogram2d/calc": 1110,
      "./clean_2d_array": 1079,
      "./convert_column_xyz": 1081,
      "./find_empties": 1083,
      "./interp2d": 1086,
      "./make_bound_array": 1087
    }],
    1079: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../lib"),
          a = t("../../constants/numerical").BADNUM;

      e.exports = function (t, e, r, o) {
        var s, l, c, u, f, h;

        function p(t) {
          if (n(t)) return +t;
        }

        if (e && e.transpose) {
          for (s = 0, f = 0; f < t.length; f++) {
            s = Math.max(s, t[f].length);
          }

          if (0 === s) return !1;
          c = function c(t) {
            return t.length;
          }, u = function u(t, e, r) {
            return (t[r] || [])[e];
          };
        } else s = t.length, c = function c(t, e) {
          return t[e].length;
        }, u = function u(t, e, r) {
          return (t[e] || [])[r];
        };

        var d = function d(t, e, r) {
          return e === a || r === a ? a : u(t, e, r);
        };

        function m(t) {
          if (e && "carpet" !== e.type && "contourcarpet" !== e.type && t && "category" === t.type && e["_" + t._id.charAt(0)].length) {
            var r = t._id.charAt(0),
                n = {},
                o = e["_" + r + "CategoryMap"] || e[r];

            for (f = 0; f < o.length; f++) {
              n[o[f]] = f;
            }

            return function (e) {
              var r = n[t._categories[e]];
              return r + 1 ? r : a;
            };
          }

          return i.identity;
        }

        var g = m(r),
            v = m(o);
        o && "category" === o.type && (s = o._categories.length);
        var y = new Array(s);

        for (f = 0; f < s; f++) {
          for (l = r && "category" === r.type ? r._categories.length : c(t, f), y[f] = new Array(l), h = 0; h < l; h++) {
            y[f][h] = p(d(t, v(f), g(h)));
          }
        }

        return y;
      };
    }, {
      "../../constants/numerical": 771,
      "../../lib": 795,
      "fast-isnumeric": 240
    }],
    1080: [function (t, e, r) {
      "use strict";

      e.exports = {
        min: "zmin",
        max: "zmax"
      };
    }, {}],
    1081: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../constants/numerical").BADNUM,
          a = t("../../plots/cartesian/align_period");

      e.exports = function (t, e, r, o, s, l) {
        var c = t._length,
            u = e.makeCalcdata(t, o),
            f = r.makeCalcdata(t, s);
        u = a(t, e, o, u), f = a(t, r, s, f);
        var h,
            p,
            d,
            m,
            g = t.text,
            v = void 0 !== g && n.isArray1D(g),
            y = t.hovertext,
            x = void 0 !== y && n.isArray1D(y),
            b = n.distinctVals(u),
            _ = b.vals,
            w = n.distinctVals(f),
            T = w.vals,
            k = [],
            M = T.length,
            A = _.length;

        for (h = 0; h < l.length; h++) {
          k[h] = n.init2dArray(M, A);
        }

        v && (d = n.init2dArray(M, A)), x && (m = n.init2dArray(M, A));
        var S = n.init2dArray(M, A);

        for (h = 0; h < c; h++) {
          if (u[h] !== i && f[h] !== i) {
            var E = n.findBin(u[h] + b.minDiff / 2, _),
                L = n.findBin(f[h] + w.minDiff / 2, T);

            for (p = 0; p < l.length; p++) {
              var C = t[l[p]];
              k[p][L][E] = C[h], S[L][E] = h;
            }

            v && (d[L][E] = g[h]), x && (m[L][E] = y[h]);
          }
        }

        for (t["_" + o] = _, t["_" + s] = T, p = 0; p < l.length; p++) {
          t["_" + l[p]] = k[p];
        }

        v && (t._text = d), x && (t._hovertext = m), e && "category" === e.type && (t["_" + o + "CategoryMap"] = _.map(function (t) {
          return e._categories[t];
        })), r && "category" === r.type && (t["_" + s + "CategoryMap"] = T.map(function (t) {
          return r._categories[t];
        })), t._after2before = S;
      };
    }, {
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../../plots/cartesian/align_period": 842
    }],
    1082: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./xyz_defaults"),
          a = t("../scatter/period_defaults"),
          o = t("./style_defaults"),
          s = t("../../components/colorscale/defaults"),
          l = t("./attributes");

      e.exports = function (t, e, r, c) {
        function u(r, i) {
          return n.coerce(t, e, l, r, i);
        }

        i(t, e, u, c) ? (a(t, e, c, u), u("xhoverformat"), u("yhoverformat"), u("text"), u("hovertext"), u("hovertemplate"), o(t, e, u, c), u("hoverongaps"), u("connectgaps", n.isArray1D(e.z) && !1 !== e.zsmooth), s(t, e, c, u, {
          prefix: "",
          cLetter: "z"
        })) : e.visible = !1;
      };
    }, {
      "../../components/colorscale/defaults": 668,
      "../../lib": 795,
      "../scatter/period_defaults": 1219,
      "./attributes": 1077,
      "./style_defaults": 1090,
      "./xyz_defaults": 1091
    }],
    1083: [function (t, e, r) {
      "use strict";

      var n = t("../../lib").maxRowLength;

      e.exports = function (t) {
        var e,
            r,
            i,
            a,
            o,
            s,
            l,
            c,
            u = [],
            f = {},
            h = [],
            p = t[0],
            d = [],
            m = [0, 0, 0],
            g = n(t);

        for (r = 0; r < t.length; r++) {
          for (e = d, d = p, p = t[r + 1] || [], i = 0; i < g; i++) {
            void 0 === d[i] && ((s = (void 0 !== d[i - 1] ? 1 : 0) + (void 0 !== d[i + 1] ? 1 : 0) + (void 0 !== e[i] ? 1 : 0) + (void 0 !== p[i] ? 1 : 0)) ? (0 === r && s++, 0 === i && s++, r === t.length - 1 && s++, i === d.length - 1 && s++, s < 4 && (f[[r, i]] = [r, i, s]), u.push([r, i, s])) : h.push([r, i]));
          }
        }

        for (; h.length;) {
          for (l = {}, c = !1, o = h.length - 1; o >= 0; o--) {
            (s = ((f[[(r = (a = h[o])[0]) - 1, i = a[1]]] || m)[2] + (f[[r + 1, i]] || m)[2] + (f[[r, i - 1]] || m)[2] + (f[[r, i + 1]] || m)[2]) / 20) && (l[a] = [r, i, s], h.splice(o, 1), c = !0);
          }

          if (!c) throw "findEmpties iterated with no new neighbors";

          for (a in l) {
            f[a] = l[a], u.push(l[a]);
          }
        }

        return u.sort(function (t, e) {
          return e[2] - t[2];
        });
      };
    }, {
      "../../lib": 795
    }],
    1084: [function (t, e, r) {
      "use strict";

      var n = t("../../components/fx"),
          i = t("../../lib"),
          a = t("../../plots/cartesian/axes"),
          o = t("../../components/colorscale").extractOpts;

      e.exports = function (t, e, r, s, l) {
        l || (l = {});
        var c,
            u,
            f,
            h,
            p = l.isContour,
            d = t.cd[0],
            m = d.trace,
            g = t.xa,
            v = t.ya,
            y = d.x,
            x = d.y,
            b = d.z,
            _ = d.xCenter,
            w = d.yCenter,
            T = d.zmask,
            k = m.zhoverformat,
            M = y,
            A = x;

        if (!1 !== t.index) {
          try {
            f = Math.round(t.index[1]), h = Math.round(t.index[0]);
          } catch (e) {
            return void i.error("Error hovering on heatmap, pointNumber must be [row,col], found:", t.index);
          }

          if (f < 0 || f >= b[0].length || h < 0 || h > b.length) return;
        } else {
          if (n.inbox(e - y[0], e - y[y.length - 1], 0) > 0 || n.inbox(r - x[0], r - x[x.length - 1], 0) > 0) return;

          if (p) {
            var S;

            for (M = [2 * y[0] - y[1]], S = 1; S < y.length; S++) {
              M.push((y[S] + y[S - 1]) / 2);
            }

            for (M.push([2 * y[y.length - 1] - y[y.length - 2]]), A = [2 * x[0] - x[1]], S = 1; S < x.length; S++) {
              A.push((x[S] + x[S - 1]) / 2);
            }

            A.push([2 * x[x.length - 1] - x[x.length - 2]]);
          }

          f = Math.max(0, Math.min(M.length - 2, i.findBin(e, M))), h = Math.max(0, Math.min(A.length - 2, i.findBin(r, A)));
        }

        var E,
            L,
            C = g.c2p(y[f]),
            P = g.c2p(y[f + 1]),
            I = v.c2p(x[h]),
            O = v.c2p(x[h + 1]);
        p ? (E = d.orig_x || y, L = d.orig_y || x, P = C, c = E[f], O = I, u = L[h]) : (E = d.orig_x || _ || y, L = d.orig_y || w || x, c = _ ? E[f] : (E[f] + E[f + 1]) / 2, u = w ? L[h] : (L[h] + L[h + 1]) / 2, g && "category" === g.type && (c = y[f]), v && "category" === v.type && (u = x[h]), m.zsmooth && (C = P = g.c2p(c), I = O = v.c2p(u)));
        var z = b[h][f];

        if (T && !T[h][f] && (z = void 0), void 0 !== z || m.hoverongaps) {
          var D;
          Array.isArray(d.hovertext) && Array.isArray(d.hovertext[h]) ? D = d.hovertext[h][f] : Array.isArray(d.text) && Array.isArray(d.text[h]) && (D = d.text[h][f]);
          var R = o(m),
              F = {
            type: "linear",
            range: [R.min, R.max],
            hoverformat: k,
            _separators: g._separators,
            _numFormat: g._numFormat
          },
              B = a.tickText(F, z, "hover").text;
          return [i.extendFlat(t, {
            index: m._after2before ? m._after2before[h][f] : [h, f],
            distance: t.maxHoverDistance,
            spikeDistance: t.maxSpikeDistance,
            x0: C,
            x1: P,
            y0: I,
            y1: O,
            xLabelVal: c,
            yLabelVal: u,
            zLabelVal: z,
            zLabel: B,
            text: D
          })];
        }
      };
    }, {
      "../../components/colorscale": 670,
      "../../components/fx": 698,
      "../../lib": 795,
      "../../plots/cartesian/axes": 845
    }],
    1085: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        calc: t("./calc"),
        plot: t("./plot"),
        colorbar: t("./colorbar"),
        style: t("./style"),
        hoverPoints: t("./hover"),
        moduleType: "trace",
        name: "heatmap",
        basePlotModule: t("../../plots/cartesian"),
        categories: ["cartesian", "svg", "2dMap", "showLegend"],
        meta: {}
      };
    }, {
      "../../plots/cartesian": 858,
      "./attributes": 1077,
      "./calc": 1078,
      "./colorbar": 1080,
      "./defaults": 1082,
      "./hover": 1084,
      "./plot": 1088,
      "./style": 1089
    }],
    1086: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = [[-1, 0], [1, 0], [0, -1], [0, 1]];

      function a(t) {
        return .5 - .25 * Math.min(1, .5 * t);
      }

      function o(t, e, r) {
        var n,
            a,
            o,
            s,
            l,
            c,
            u,
            f,
            h,
            p,
            d,
            m,
            g,
            v = 0;

        for (s = 0; s < e.length; s++) {
          for (a = (n = e[s])[0], o = n[1], d = t[a][o], p = 0, h = 0, l = 0; l < 4; l++) {
            (u = t[a + (c = i[l])[0]]) && void 0 !== (f = u[o + c[1]]) && (0 === p ? m = g = f : (m = Math.min(m, f), g = Math.max(g, f)), h++, p += f);
          }

          if (0 === h) throw "iterateInterp2d order is wrong: no defined neighbors";
          t[a][o] = p / h, void 0 === d ? h < 4 && (v = 1) : (t[a][o] = (1 + r) * t[a][o] - r * d, g > m && (v = Math.max(v, Math.abs(t[a][o] - d) / (g - m))));
        }

        return v;
      }

      e.exports = function (t, e) {
        var r,
            i = 1;

        for (o(t, e), r = 0; r < e.length && !(e[r][2] < 4); r++) {
          ;
        }

        for (e = e.slice(r), r = 0; r < 100 && i > .01; r++) {
          i = o(t, e, a(i));
        }

        return i > .01 && n.log("interp2d didn't converge quickly", i), t;
      };
    }, {
      "../../lib": 795
    }],
    1087: [function (t, e, r) {
      "use strict";

      var n = t("../../registry"),
          i = t("../../lib").isArrayOrTypedArray;

      e.exports = function (t, e, r, a, o, s) {
        var l,
            c,
            u,
            f = [],
            h = n.traceIs(t, "contour"),
            p = n.traceIs(t, "histogram"),
            d = n.traceIs(t, "gl2d");

        if (i(e) && e.length > 1 && !p && "category" !== s.type) {
          var m = e.length;
          if (!(m <= o)) return h ? e.slice(0, o) : e.slice(0, o + 1);
          if (h || d) f = e.slice(0, o);else if (1 === o) f = [e[0] - .5, e[0] + .5];else {
            for (f = [1.5 * e[0] - .5 * e[1]], u = 1; u < m; u++) {
              f.push(.5 * (e[u - 1] + e[u]));
            }

            f.push(1.5 * e[m - 1] - .5 * e[m - 2]);
          }

          if (m < o) {
            var g = f[f.length - 1],
                v = g - f[f.length - 2];

            for (u = m; u < o; u++) {
              g += v, f.push(g);
            }
          }
        } else {
          var y = t[s._id.charAt(0) + "calendar"];
          if (p) l = s.r2c(r, 0, y);else if (i(e) && 1 === e.length) l = e[0];else if (void 0 === r) l = 0;else {
            l = ("log" === s.type ? s.d2c : s.r2c)(r, 0, y);
          }

          for (c = a || 1, u = h || d ? 0 : -.5; u < o; u++) {
            f.push(l + c * u);
          }
        }

        return f;
      };
    }, {
      "../../lib": 795,
      "../../registry": 923
    }],
    1088: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("tinycolor2"),
          a = t("../../registry"),
          o = t("../../lib"),
          s = t("../../components/colorscale").makeColorScaleFuncFromTrace,
          l = t("../../constants/xmlns_namespaces");

      function c(t, e) {
        var r = e.length - 2,
            n = o.constrain(o.findBin(t, e), 0, r),
            i = e[n],
            a = e[n + 1],
            s = o.constrain(n + (t - i) / (a - i) - .5, 0, r),
            l = Math.round(s),
            c = Math.abs(s - l);
        return s && s !== r && c ? {
          bin0: l,
          frac: c,
          bin1: Math.round(l + c / (s - l))
        } : {
          bin0: l,
          bin1: l,
          frac: 0
        };
      }

      function u(t, e) {
        var r = e.length - 1,
            n = o.constrain(o.findBin(t, e), 0, r),
            i = e[n],
            a = (t - i) / (e[n + 1] - i) || 0;
        return a <= 0 ? {
          bin0: n,
          bin1: n,
          frac: 0
        } : a < .5 ? {
          bin0: n,
          bin1: n + 1,
          frac: a
        } : {
          bin0: n + 1,
          bin1: n,
          frac: 1 - a
        };
      }

      function f(t, e, r) {
        t[e] = r[0], t[e + 1] = r[1], t[e + 2] = r[2], t[e + 3] = Math.round(255 * r[3]);
      }

      e.exports = function (t, e, r, h) {
        var p = e.xaxis,
            d = e.yaxis;
        o.makeTraceGroups(h, r, "hm").each(function (e) {
          var r,
              h,
              m,
              g,
              v,
              y,
              x = n.select(this),
              b = e[0],
              _ = b.trace,
              w = b.z,
              T = b.x,
              k = b.y,
              M = b.xCenter,
              A = b.yCenter,
              S = a.traceIs(_, "contour"),
              E = S ? "best" : _.zsmooth,
              L = w.length,
              C = o.maxRowLength(w),
              P = !1,
              I = !1;

          for (y = 0; void 0 === r && y < T.length - 1;) {
            r = p.c2p(T[y]), y++;
          }

          for (y = T.length - 1; void 0 === h && y > 0;) {
            h = p.c2p(T[y]), y--;
          }

          for (h < r && (m = h, h = r, r = m, P = !0), y = 0; void 0 === g && y < k.length - 1;) {
            g = d.c2p(k[y]), y++;
          }

          for (y = k.length - 1; void 0 === v && y > 0;) {
            v = d.c2p(k[y]), y--;
          }

          if (v < g && (m = g, g = v, v = m, I = !0), S && (M = T, A = k, T = b.xfill, k = b.yfill), "fast" !== E) {
            var O = "best" === E ? 0 : .5;
            r = Math.max(-O * p._length, r), h = Math.min((1 + O) * p._length, h), g = Math.max(-O * d._length, g), v = Math.min((1 + O) * d._length, v);
          }

          var z = Math.round(h - r),
              D = Math.round(v - g);

          if (z <= 0 || D <= 0) {
            x.selectAll("image").data([]).exit().remove();
          } else {
            var R, F;
            "fast" === E ? (R = C, F = L) : (R = z, F = D);
            var B = document.createElement("canvas");
            B.width = R, B.height = F;
            var N,
                j,
                U = B.getContext("2d"),
                V = s(_, {
              noNumericCheck: !0,
              returnArray: !0
            });
            "fast" === E ? (N = P ? function (t) {
              return C - 1 - t;
            } : o.identity, j = I ? function (t) {
              return L - 1 - t;
            } : o.identity) : (N = function N(t) {
              return o.constrain(Math.round(p.c2p(T[t]) - r), 0, z);
            }, j = function j(t) {
              return o.constrain(Math.round(d.c2p(k[t]) - g), 0, D);
            });
            var q,
                H,
                G,
                Y,
                W,
                X = j(0),
                Z = [X, X],
                J = P ? 0 : 1,
                K = I ? 0 : 1,
                Q = 0,
                $ = 0,
                tt = 0,
                et = 0;

            if (E) {
              var rt,
                  nt = 0;

              try {
                rt = new Uint8Array(z * D * 4);
              } catch (t) {
                rt = new Array(z * D * 4);
              }

              if ("best" === E) {
                var it,
                    at,
                    ot,
                    st = M || T,
                    lt = A || k,
                    ct = new Array(st.length),
                    ut = new Array(lt.length),
                    ft = new Array(z),
                    ht = M ? u : c,
                    pt = A ? u : c;

                for (y = 0; y < st.length; y++) {
                  ct[y] = Math.round(p.c2p(st[y]) - r);
                }

                for (y = 0; y < lt.length; y++) {
                  ut[y] = Math.round(d.c2p(lt[y]) - g);
                }

                for (y = 0; y < z; y++) {
                  ft[y] = ht(y, ct);
                }

                for (H = 0; H < D; H++) {
                  for (at = w[(it = pt(H, ut)).bin0], ot = w[it.bin1], y = 0; y < z; y++, nt += 4) {
                    f(rt, nt, W = kt(at, ot, ft[y], it));
                  }
                }
              } else for (H = 0; H < L; H++) {
                for (Y = w[H], Z = j(H), y = 0; y < z; y++) {
                  W = Tt(Y[y], 1), f(rt, nt = 4 * (Z * z + N(y)), W);
                }
              }

              var dt = U.createImageData(z, D);

              try {
                dt.data.set(rt);
              } catch (t) {
                var mt = dt.data,
                    gt = mt.length;

                for (H = 0; H < gt; H++) {
                  mt[H] = rt[H];
                }
              }

              U.putImageData(dt, 0, 0);
            } else {
              var vt = _.xgap,
                  yt = _.ygap,
                  xt = Math.floor(vt / 2),
                  bt = Math.floor(yt / 2);

              for (H = 0; H < L; H++) {
                if (Y = w[H], Z.reverse(), Z[K] = j(H + 1), Z[0] !== Z[1] && void 0 !== Z[0] && void 0 !== Z[1]) for (q = [G = N(0), G], y = 0; y < C; y++) {
                  q.reverse(), q[J] = N(y + 1), q[0] !== q[1] && void 0 !== q[0] && void 0 !== q[1] && (W = Tt(Y[y], (q[1] - q[0]) * (Z[1] - Z[0])), U.fillStyle = "rgba(" + W.join(",") + ")", U.fillRect(q[0] + xt, Z[0] + bt, q[1] - q[0] - vt, Z[1] - Z[0] - yt));
                }
              }
            }

            $ = Math.round($ / Q), tt = Math.round(tt / Q), et = Math.round(et / Q);

            var _t = i("rgb(" + $ + "," + tt + "," + et + ")");

            t._hmpixcount = (t._hmpixcount || 0) + Q, t._hmlumcount = (t._hmlumcount || 0) + Q * _t.getLuminance();
            var wt = x.selectAll("image").data(e);
            wt.enter().append("svg:image").attr({
              xmlns: l.svg,
              preserveAspectRatio: "none"
            }), wt.attr({
              height: D,
              width: z,
              x: r,
              y: g,
              "xlink:href": B.toDataURL("image/png")
            });
          }

          function Tt(t, e) {
            if (void 0 !== t) {
              var r = V(t);
              return r[0] = Math.round(r[0]), r[1] = Math.round(r[1]), r[2] = Math.round(r[2]), Q += e, $ += r[0] * e, tt += r[1] * e, et += r[2] * e, r;
            }

            return [0, 0, 0, 0];
          }

          function kt(t, e, r, n) {
            var i = t[r.bin0];
            if (void 0 === i) return Tt(void 0, 1);
            var a,
                o = t[r.bin1],
                s = e[r.bin0],
                l = e[r.bin1],
                c = o - i || 0,
                u = s - i || 0;
            return a = void 0 === o ? void 0 === l ? 0 : void 0 === s ? 2 * (l - i) : 2 * (2 * l - s - i) / 3 : void 0 === l ? void 0 === s ? 0 : 2 * (2 * i - o - s) / 3 : void 0 === s ? 2 * (2 * l - o - i) / 3 : l + i - o - s, Tt(i + r.frac * c + n.frac * (u + r.frac * a));
          }
        });
      };
    }, {
      "../../components/colorscale": 670,
      "../../constants/xmlns_namespaces": 772,
      "../../lib": 795,
      "../../registry": 923,
      "@plotly/d3": 57,
      tinycolor2: 590
    }],
    1089: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3");

      e.exports = function (t) {
        n.select(t).selectAll(".hm image").style("opacity", function (t) {
          return t.trace.opacity;
        });
      };
    }, {
      "@plotly/d3": 57
    }],
    1090: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r) {
        !1 === r("zsmooth") && (r("xgap"), r("ygap")), r("zhoverformat");
      };
    }, {}],
    1091: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../lib"),
          a = t("../../registry");

      function o(t, e) {
        var r = e(t);
        return "scaled" === (r ? e(t + "type", "array") : "scaled") && (e(t + "0"), e("d" + t)), r;
      }

      e.exports = function (t, e, r, s, l, c) {
        var u,
            f,
            h = r("z");
        if (l = l || "x", c = c || "y", void 0 === h || !h.length) return 0;

        if (i.isArray1D(t.z)) {
          u = r(l), f = r(c);
          var p = i.minRowLength(u),
              d = i.minRowLength(f);
          if (0 === p || 0 === d) return 0;
          e._length = Math.min(p, d, h.length);
        } else {
          if (u = o(l, r), f = o(c, r), !function (t) {
            for (var e, r = !0, a = !1, o = !1, s = 0; s < t.length; s++) {
              if (e = t[s], !i.isArrayOrTypedArray(e)) {
                r = !1;
                break;
              }

              e.length > 0 && (a = !0);

              for (var l = 0; l < e.length; l++) {
                if (n(e[l])) {
                  o = !0;
                  break;
                }
              }
            }

            return r && a && o;
          }(h)) return 0;
          r("transpose"), e._length = null;
        }

        return "heatmapgl" === t.type || a.getComponentMethod("calendars", "handleTraceDefaults")(t, e, [l, c], s), !0;
      };
    }, {
      "../../lib": 795,
      "../../registry": 923,
      "fast-isnumeric": 240
    }],
    1092: [function (t, e, r) {
      "use strict";

      for (var n = t("../heatmap/attributes"), i = t("../../components/colorscale/attributes"), a = t("../../lib/extend").extendFlat, o = t("../../plot_api/edit_types").overrideAll, s = ["z", "x", "x0", "dx", "y", "y0", "dy", "text", "transpose", "xtype", "ytype"], l = {}, c = 0; c < s.length; c++) {
        var u = s[c];
        l[u] = n[u];
      }

      l.zsmooth = {
        valType: "enumerated",
        values: ["fast", !1],
        dflt: "fast",
        editType: "calc"
      }, a(l, i("", {
        cLetter: "z",
        autoColorDflt: !1
      })), e.exports = o(l, "calc", "nested");
    }, {
      "../../components/colorscale/attributes": 665,
      "../../lib/extend": 785,
      "../../plot_api/edit_types": 827,
      "../heatmap/attributes": 1077
    }],
    1093: [function (t, e, r) {
      "use strict";

      var n = t("gl-heatmap2d"),
          i = t("../../plots/cartesian/axes"),
          a = t("../../lib/str2rgbarray");

      function o(t, e) {
        this.scene = t, this.uid = e, this.type = "heatmapgl", this.name = "", this.hoverinfo = "all", this.xData = [], this.yData = [], this.zData = [], this.textLabels = [], this.idToIndex = [], this.bounds = [0, 0, 0, 0], this.options = {
          zsmooth: "fast",
          z: [],
          x: [],
          y: [],
          shape: [0, 0],
          colorLevels: [0],
          colorValues: [0, 0, 0, 1]
        }, this.heatmap = n(t.glplot, this.options), this.heatmap._trace = this;
      }

      var s = o.prototype;
      s.handlePick = function (t) {
        var e = this.options,
            r = e.shape,
            n = t.pointId,
            i = n % r[0],
            a = Math.floor(n / r[0]),
            o = n;
        return {
          trace: this,
          dataCoord: t.dataCoord,
          traceCoord: [e.x[i], e.y[a], e.z[o]],
          textLabel: this.textLabels[n],
          name: this.name,
          pointIndex: [a, i],
          hoverinfo: this.hoverinfo
        };
      }, s.update = function (t, e) {
        var r = e[0];
        this.index = t.index, this.name = t.name, this.hoverinfo = t.hoverinfo;
        var n = r.z;
        this.options.z = [].concat.apply([], n);
        var o = n[0].length,
            s = n.length;
        this.options.shape = [o, s], this.options.x = r.x, this.options.y = r.y, this.options.zsmooth = t.zsmooth;

        var l = function (t) {
          for (var e = t.colorscale, r = t.zmin, n = t.zmax, i = e.length, o = new Array(i), s = new Array(4 * i), l = 0; l < i; l++) {
            var c = e[l],
                u = a(c[1]);
            o[l] = r + c[0] * (n - r);

            for (var f = 0; f < 4; f++) {
              s[4 * l + f] = u[f];
            }
          }

          return {
            colorLevels: o,
            colorValues: s
          };
        }(t);

        this.options.colorLevels = l.colorLevels, this.options.colorValues = l.colorValues, this.textLabels = [].concat.apply([], t.text), this.heatmap.update(this.options);
        var c,
            u,
            f = this.scene.xaxis,
            h = this.scene.yaxis;
        !1 === t.zsmooth && (c = {
          ppad: r.x[1] - r.x[0]
        }, u = {
          ppad: r.y[1] - r.y[0]
        }), t._extremes[f._id] = i.findExtremes(f, r.x, c), t._extremes[h._id] = i.findExtremes(h, r.y, u);
      }, s.dispose = function () {
        this.heatmap.dispose();
      }, e.exports = function (t, e, r) {
        var n = new o(t, e.uid);
        return n.update(e, r), n;
      };
    }, {
      "../../lib/str2rgbarray": 819,
      "../../plots/cartesian/axes": 845,
      "gl-heatmap2d": 269
    }],
    1094: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../heatmap/xyz_defaults"),
          a = t("../../components/colorscale/defaults"),
          o = t("./attributes");

      e.exports = function (t, e, r, s) {
        function l(r, i) {
          return n.coerce(t, e, o, r, i);
        }

        i(t, e, l, s) ? (l("text"), l("zsmooth"), a(t, e, s, l, {
          prefix: "",
          cLetter: "z"
        })) : e.visible = !1;
      };
    }, {
      "../../components/colorscale/defaults": 668,
      "../../lib": 795,
      "../heatmap/xyz_defaults": 1091,
      "./attributes": 1092
    }],
    1095: [function (t, e, r) {
      "use strict";

      ["*heatmapgl* trace is deprecated!", "Please consider switching to the *heatmap* or *image* trace types.", "Alternatively you could contribute/sponsor rewriting this trace type", "based on cartesian features and using regl framework."].join(" ");
      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        colorbar: t("../heatmap/colorbar"),
        calc: t("../heatmap/calc"),
        plot: t("./convert"),
        moduleType: "trace",
        name: "heatmapgl",
        basePlotModule: t("../../plots/gl2d"),
        categories: ["gl", "gl2d", "2dMap"],
        meta: {}
      };
    }, {
      "../../plots/gl2d": 885,
      "../heatmap/calc": 1078,
      "../heatmap/colorbar": 1080,
      "./attributes": 1092,
      "./convert": 1093,
      "./defaults": 1094
    }],
    1096: [function (t, e, r) {
      "use strict";

      var n = t("../bar/attributes"),
          i = t("../../plots/hoverformat_attributes"),
          a = t("../../plots/template_attributes").hovertemplateAttrs,
          o = t("./bin_attributes"),
          s = t("./constants"),
          l = t("../../lib/extend").extendFlat;
      e.exports = {
        x: {
          valType: "data_array",
          editType: "calc+clearAxisTypes"
        },
        y: {
          valType: "data_array",
          editType: "calc+clearAxisTypes"
        },
        xhoverformat: i("x"),
        yhoverformat: i("y"),
        text: l({}, n.text, {}),
        hovertext: l({}, n.hovertext, {}),
        orientation: n.orientation,
        histfunc: {
          valType: "enumerated",
          values: ["count", "sum", "avg", "min", "max"],
          dflt: "count",
          editType: "calc"
        },
        histnorm: {
          valType: "enumerated",
          values: ["", "percent", "probability", "density", "probability density"],
          dflt: "",
          editType: "calc"
        },
        cumulative: {
          enabled: {
            valType: "boolean",
            dflt: !1,
            editType: "calc"
          },
          direction: {
            valType: "enumerated",
            values: ["increasing", "decreasing"],
            dflt: "increasing",
            editType: "calc"
          },
          currentbin: {
            valType: "enumerated",
            values: ["include", "exclude", "half"],
            dflt: "include",
            editType: "calc"
          },
          editType: "calc"
        },
        nbinsx: {
          valType: "integer",
          min: 0,
          dflt: 0,
          editType: "calc"
        },
        xbins: o("x", !0),
        nbinsy: {
          valType: "integer",
          min: 0,
          dflt: 0,
          editType: "calc"
        },
        ybins: o("y", !0),
        autobinx: {
          valType: "boolean",
          dflt: null,
          editType: "calc"
        },
        autobiny: {
          valType: "boolean",
          dflt: null,
          editType: "calc"
        },
        bingroup: {
          valType: "string",
          dflt: "",
          editType: "calc"
        },
        hovertemplate: a({}, {
          keys: s.eventDataKeys
        }),
        marker: n.marker,
        offsetgroup: n.offsetgroup,
        alignmentgroup: n.alignmentgroup,
        selected: n.selected,
        unselected: n.unselected,
        _deprecated: {
          bardir: n._deprecated.bardir
        }
      };
    }, {
      "../../lib/extend": 785,
      "../../plots/hoverformat_attributes": 899,
      "../../plots/template_attributes": 918,
      "../bar/attributes": 933,
      "./bin_attributes": 1098,
      "./constants": 1102
    }],
    1097: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        for (var r = t.length, n = 0, i = 0; i < r; i++) {
          e[i] ? (t[i] /= e[i], n += t[i]) : t[i] = null;
        }

        return n;
      };
    }, {}],
    1098: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        return {
          start: {
            valType: "any",
            editType: "calc"
          },
          end: {
            valType: "any",
            editType: "calc"
          },
          size: {
            valType: "any",
            editType: "calc"
          },
          editType: "calc"
        };
      };
    }, {}],
    1099: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric");
      e.exports = {
        count: function count(t, e, r) {
          return r[t]++, 1;
        },
        sum: function sum(t, e, r, i) {
          var a = i[e];
          return n(a) ? (a = Number(a), r[t] += a, a) : 0;
        },
        avg: function avg(t, e, r, i, a) {
          var o = i[e];
          return n(o) && (o = Number(o), r[t] += o, a[t]++), 0;
        },
        min: function min(t, e, r, i) {
          var a = i[e];

          if (n(a)) {
            if (a = Number(a), !n(r[t])) return r[t] = a, a;

            if (r[t] > a) {
              var o = a - r[t];
              return r[t] = a, o;
            }
          }

          return 0;
        },
        max: function max(t, e, r, i) {
          var a = i[e];

          if (n(a)) {
            if (a = Number(a), !n(r[t])) return r[t] = a, a;

            if (r[t] < a) {
              var o = a - r[t];
              return r[t] = a, o;
            }
          }

          return 0;
        }
      };
    }, {
      "fast-isnumeric": 240
    }],
    1100: [function (t, e, r) {
      "use strict";

      var n = t("../../constants/numerical"),
          i = n.ONEAVGYEAR,
          a = n.ONEAVGMONTH,
          o = n.ONEDAY,
          s = n.ONEHOUR,
          l = n.ONEMIN,
          c = n.ONESEC,
          u = t("../../plots/cartesian/axes").tickIncrement;

      function f(t, e, r, n) {
        if (t * e <= 0) return 1 / 0;

        for (var i = Math.abs(e - t), a = "date" === r.type, o = h(i, a), s = 0; s < 10; s++) {
          var l = h(80 * o, a);
          if (o === l) break;
          if (!p(l, t, e, a, r, n)) break;
          o = l;
        }

        return o;
      }

      function h(t, e) {
        return e && t > c ? t > o ? t > 1.1 * i ? i : t > 1.1 * a ? a : o : t > s ? s : t > l ? l : c : Math.pow(10, Math.floor(Math.log(t) / Math.LN10));
      }

      function p(t, e, r, n, a, s) {
        if (n && t > o) {
          var l = d(e, a, s),
              c = d(r, a, s),
              u = t === i ? 0 : 1;
          return l[u] !== c[u];
        }

        return Math.floor(r / t) - Math.floor(e / t) > .1;
      }

      function d(t, e, r) {
        var n = e.c2d(t, i, r).split("-");
        return "" === n[0] && (n.unshift(), n[0] = "-" + n[0]), n;
      }

      e.exports = function (t, e, r, n, a) {
        var s,
            l,
            c = -1.1 * e,
            h = -.1 * e,
            p = t - h,
            d = r[0],
            m = r[1],
            g = Math.min(f(d + h, d + p, n, a), f(m + h, m + p, n, a)),
            v = Math.min(f(d + c, d + h, n, a), f(m + c, m + h, n, a));

        if (g > v && v < Math.abs(m - d) / 4e3 ? (s = g, l = !1) : (s = Math.min(g, v), l = !0), "date" === n.type && s > o) {
          var y = s === i ? 1 : 6,
              x = s === i ? "M12" : "M1";
          return function (e, r) {
            var o = n.c2d(e, i, a),
                s = o.indexOf("-", y);
            s > 0 && (o = o.substr(0, s));
            var c = n.d2c(o, 0, a);

            if (c < e) {
              var f = u(c, x, !1, a);
              (c + f) / 2 < e + t && (c = f);
            }

            return r && l ? u(c, x, !0, a) : c;
          };
        }

        return function (e, r) {
          var n = s * Math.round(e / s);
          return n + s / 10 < e && n + .9 * s < e + t && (n += s), r && l && (n -= s), n;
        };
      };
    }, {
      "../../constants/numerical": 771,
      "../../plots/cartesian/axes": 845
    }],
    1101: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../lib"),
          a = t("../../registry"),
          o = t("../../plots/cartesian/axes"),
          s = t("../bar/arrays_to_calcdata"),
          l = t("./bin_functions"),
          c = t("./norm_functions"),
          u = t("./average"),
          f = t("./bin_label_vals");

      function h(t, e, r, s, l) {
        var c,
            u,
            f,
            p,
            d,
            m,
            g,
            v = s + "bins",
            y = t._fullLayout,
            x = e["_" + s + "bingroup"],
            b = y._histogramBinOpts[x],
            _ = "overlay" === y.barmode,
            w = function w(t) {
          return r.r2c(t, 0, p);
        },
            T = function T(t) {
          return r.c2r(t, 0, p);
        },
            k = "date" === r.type ? function (t) {
          return t || 0 === t ? i.cleanDate(t, null, p) : null;
        } : function (t) {
          return n(t) ? Number(t) : null;
        };

        function M(t, e, r) {
          e[t + "Found"] ? (e[t] = k(e[t]), null === e[t] && (e[t] = r[t])) : (m[t] = e[t] = r[t], i.nestedProperty(u[0], v + "." + t).set(r[t]));
        }

        if (e["_" + s + "autoBinFinished"]) delete e["_" + s + "autoBinFinished"];else {
          u = b.traces;
          var A = [],
              S = !0,
              E = !1,
              L = !1;

          for (c = 0; c < u.length; c++) {
            if ((f = u[c]).visible) {
              var C = b.dirs[c];
              d = f["_" + C + "pos0"] = r.makeCalcdata(f, C), A = i.concat(A, d), delete f["_" + s + "autoBinFinished"], !0 === e.visible && (S ? S = !1 : (delete f._autoBin, f["_" + s + "autoBinFinished"] = 1), a.traceIs(f, "2dMap") && (E = !0), "histogram2dcontour" === f.type && (L = !0));
            }
          }

          p = u[0][s + "calendar"];
          var P = o.autoBin(A, r, b.nbins, E, p, b.sizeFound && b.size),
              I = u[0]._autoBin = {};

          if (m = I[b.dirs[0]] = {}, L && (b.size || (P.start = T(o.tickIncrement(w(P.start), P.size, !0, p))), void 0 === b.end && (P.end = T(o.tickIncrement(w(P.end), P.size, !1, p)))), _ && !a.traceIs(e, "2dMap") && 0 === P._dataSpan && "category" !== r.type && "multicategory" !== r.type) {
            if (l) return [P, d, !0];

            P = function (t, e, r, n, a) {
              var o,
                  s,
                  l,
                  c = t._fullLayout,
                  u = function (t, e) {
                for (var r = e.xaxis, n = e.yaxis, i = e.orientation, a = [], o = t._fullData, s = 0; s < o.length; s++) {
                  var l = o[s];
                  "histogram" === l.type && !0 === l.visible && l.orientation === i && l.xaxis === r && l.yaxis === n && a.push(l);
                }

                return a;
              }(t, e),
                  f = !1,
                  p = 1 / 0,
                  d = [e];

              for (o = 0; o < u.length; o++) {
                if ((s = u[o]) === e) f = !0;else if (f) {
                  var m = h(t, s, r, n, !0),
                      g = m[0],
                      v = m[2];
                  s["_" + n + "autoBinFinished"] = 1, s["_" + n + "pos0"] = m[1], v ? d.push(s) : p = Math.min(p, g.size);
                } else l = c._histogramBinOpts[s["_" + n + "bingroup"]], p = Math.min(p, l.size || s[a].size);
              }

              var y = new Array(d.length);

              for (o = 0; o < d.length; o++) {
                for (var x = d[o]["_" + n + "pos0"], b = 0; b < x.length; b++) {
                  if (void 0 !== x[b]) {
                    y[o] = x[b];
                    break;
                  }
                }
              }

              isFinite(p) || (p = i.distinctVals(y).minDiff);

              for (o = 0; o < d.length; o++) {
                var _ = (s = d[o])[n + "calendar"],
                    w = {
                  start: r.c2r(y[o] - p / 2, 0, _),
                  end: r.c2r(y[o] + p / 2, 0, _),
                  size: p
                };
                s._input[a] = s[a] = w, (l = c._histogramBinOpts[s["_" + n + "bingroup"]]) && i.extendFlat(l, w);
              }

              return e[a];
            }(t, e, r, s, v);
          }

          (g = f.cumulative || {}).enabled && "include" !== g.currentbin && ("decreasing" === g.direction ? P.start = T(o.tickIncrement(w(P.start), P.size, !0, p)) : P.end = T(o.tickIncrement(w(P.end), P.size, !1, p))), b.size = P.size, b.sizeFound || (m.size = P.size, i.nestedProperty(u[0], v + ".size").set(P.size)), M("start", b, P), M("end", b, P);
        }
        d = e["_" + s + "pos0"], delete e["_" + s + "pos0"];
        var O = e._input[v] || {},
            z = i.extendFlat({}, b),
            D = b.start,
            R = r.r2l(O.start),
            F = void 0 !== R;

        if ((b.startFound || F) && R !== r.r2l(D)) {
          var B = F ? R : i.aggNums(Math.min, null, d),
              N = {
            type: "category" === r.type || "multicategory" === r.type ? "linear" : r.type,
            r2l: r.r2l,
            dtick: b.size,
            tick0: D,
            calendar: p,
            range: [B, o.tickIncrement(B, b.size, !1, p)].map(r.l2r)
          },
              j = o.tickFirst(N);
          j > r.r2l(B) && (j = o.tickIncrement(j, b.size, !0, p)), z.start = r.l2r(j), F || i.nestedProperty(e, v + ".start").set(z.start);
        }

        var U = b.end,
            V = r.r2l(O.end),
            q = void 0 !== V;

        if ((b.endFound || q) && V !== r.r2l(U)) {
          var H = q ? V : i.aggNums(Math.max, null, d);
          z.end = r.l2r(H), q || i.nestedProperty(e, v + ".start").set(z.end);
        }

        var G = "autobin" + s;
        return !1 === e._input[G] && (e._input[v] = i.extendFlat({}, e[v] || {}), delete e._input[G], delete e[G]), [z, d];
      }

      e.exports = {
        calc: function calc(t, e) {
          var r,
              a,
              p,
              d,
              m = [],
              g = [],
              v = o.getFromId(t, "h" === e.orientation ? e.yaxis : e.xaxis),
              y = "h" === e.orientation ? "y" : "x",
              x = {
            x: "y",
            y: "x"
          }[y],
              b = e[y + "calendar"],
              _ = e.cumulative,
              w = h(t, e, v, y),
              T = w[0],
              k = w[1],
              M = "string" == typeof T.size,
              A = [],
              S = M ? A : T,
              E = [],
              L = [],
              C = [],
              P = 0,
              I = e.histnorm,
              O = e.histfunc,
              z = -1 !== I.indexOf("density");
          _.enabled && z && (I = I.replace(/ ?density$/, ""), z = !1);

          var D,
              R = "max" === O || "min" === O ? null : 0,
              F = l.count,
              B = c[I],
              N = !1,
              j = function j(t) {
            return v.r2c(t, 0, b);
          };

          for (i.isArrayOrTypedArray(e[x]) && "count" !== O && (D = e[x], N = "avg" === O, F = l[O]), r = j(T.start), p = j(T.end) + (r - o.tickIncrement(r, T.size, !1, b)) / 1e6; r < p && m.length < 1e6 && (a = o.tickIncrement(r, T.size, !1, b), m.push((r + a) / 2), g.push(R), C.push([]), A.push(r), z && E.push(1 / (a - r)), N && L.push(0), !(a <= r));) {
            r = a;
          }

          A.push(r), M || "date" !== v.type || (S = {
            start: j(S.start),
            end: j(S.end),
            size: S.size
          }), t._fullLayout._roundFnOpts || (t._fullLayout._roundFnOpts = {});
          var U = e["_" + y + "bingroup"],
              V = {
            leftGap: 1 / 0,
            rightGap: 1 / 0
          };
          U && (t._fullLayout._roundFnOpts[U] || (t._fullLayout._roundFnOpts[U] = V), V = t._fullLayout._roundFnOpts[U]);
          var q,
              H = g.length,
              G = !0,
              Y = V.leftGap,
              W = V.rightGap,
              X = {};

          for (r = 0; r < k.length; r++) {
            var Z = k[r];
            (d = i.findBin(Z, S)) >= 0 && d < H && (P += F(d, r, g, D, L), G && C[d].length && Z !== k[C[d][0]] && (G = !1), C[d].push(r), X[r] = d, Y = Math.min(Y, Z - A[d]), W = Math.min(W, A[d + 1] - Z));
          }

          V.leftGap = Y, V.rightGap = W, G || (q = function q(e, r) {
            return function () {
              var n = t._fullLayout._roundFnOpts[U];
              return f(n.leftGap, n.rightGap, A, v, b)(e, r);
            };
          }), N && (P = u(g, L)), B && B(g, P, E), _.enabled && function (t, e, r) {
            var n, i, a;

            function o(e) {
              a = t[e], t[e] /= 2;
            }

            function s(e) {
              i = t[e], t[e] = a + i / 2, a += i;
            }

            if ("half" === r) {
              if ("increasing" === e) for (o(0), n = 1; n < t.length; n++) {
                s(n);
              } else for (o(t.length - 1), n = t.length - 2; n >= 0; n--) {
                s(n);
              }
            } else if ("increasing" === e) {
              for (n = 1; n < t.length; n++) {
                t[n] += t[n - 1];
              }

              "exclude" === r && (t.unshift(0), t.pop());
            } else {
              for (n = t.length - 2; n >= 0; n--) {
                t[n] += t[n + 1];
              }

              "exclude" === r && (t.push(0), t.shift());
            }
          }(g, _.direction, _.currentbin);
          var J = Math.min(m.length, g.length),
              K = [],
              Q = 0,
              $ = J - 1;

          for (r = 0; r < J; r++) {
            if (g[r]) {
              Q = r;
              break;
            }
          }

          for (r = J - 1; r >= Q; r--) {
            if (g[r]) {
              $ = r;
              break;
            }
          }

          for (r = Q; r <= $; r++) {
            if (n(m[r]) && n(g[r])) {
              var tt = {
                p: m[r],
                s: g[r],
                b: 0
              };
              _.enabled || (tt.pts = C[r], G ? tt.ph0 = tt.ph1 = C[r].length ? k[C[r][0]] : m[r] : (e._computePh = !0, tt.ph0 = q(A[r]), tt.ph1 = q(A[r + 1], !0))), K.push(tt);
            }
          }

          return 1 === K.length && (K[0].width1 = o.tickIncrement(K[0].p, T.size, !1, b) - K[0].p), s(K, e), i.isArrayOrTypedArray(e.selectedpoints) && i.tagSelected(K, e, X), K;
        },
        calcAllAutoBins: h
      };
    }, {
      "../../lib": 795,
      "../../plots/cartesian/axes": 845,
      "../../registry": 923,
      "../bar/arrays_to_calcdata": 932,
      "./average": 1097,
      "./bin_functions": 1099,
      "./bin_label_vals": 1100,
      "./norm_functions": 1108,
      "fast-isnumeric": 240
    }],
    1102: [function (t, e, r) {
      "use strict";

      e.exports = {
        eventDataKeys: ["binNumber"]
      };
    }, {}],
    1103: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../plots/cartesian/axis_ids"),
          a = t("../../registry").traceIs,
          o = t("../bar/defaults").handleGroupingDefaults,
          s = n.nestedProperty,
          l = t("../../plots/cartesian/constraints").getAxisGroup,
          c = [{
        aStr: {
          x: "xbins.start",
          y: "ybins.start"
        },
        name: "start"
      }, {
        aStr: {
          x: "xbins.end",
          y: "ybins.end"
        },
        name: "end"
      }, {
        aStr: {
          x: "xbins.size",
          y: "ybins.size"
        },
        name: "size"
      }, {
        aStr: {
          x: "nbinsx",
          y: "nbinsy"
        },
        name: "nbins"
      }],
          u = ["x", "y"];

      e.exports = function (t, e) {
        var r,
            f,
            h,
            p,
            d,
            m,
            g,
            v = e._histogramBinOpts = {},
            y = [],
            x = {},
            b = [];

        function _(t, e) {
          return n.coerce(r._input, r, r._module.attributes, t, e);
        }

        function w(t) {
          return "v" === t.orientation ? "x" : "y";
        }

        function T(t, r, a) {
          var o = t.uid + "__" + a;
          r || (r = o);

          var s = function (t, r) {
            return i.getFromTrace({
              _fullLayout: e
            }, t, r).type;
          }(t, a),
              l = t[a + "calendar"] || "",
              c = v[r],
              u = !0;

          c && (s === c.axType && l === c.calendar ? (u = !1, c.traces.push(t), c.dirs.push(a)) : (r = o, s !== c.axType && n.warn(["Attempted to group the bins of trace", t.index, "set on a", "type:" + s, "axis", "with bins on", "type:" + c.axType, "axis."].join(" ")), l !== c.calendar && n.warn(["Attempted to group the bins of trace", t.index, "set with a", l, "calendar", "with bins", c.calendar ? "on a " + c.calendar + " calendar" : "w/o a set calendar"].join(" ")))), u && (v[r] = {
            traces: [t],
            dirs: [a],
            axType: s,
            calendar: t[a + "calendar"] || ""
          }), t["_" + a + "bingroup"] = r;
        }

        for (d = 0; d < t.length; d++) {
          r = t[d], a(r, "histogram") && (y.push(r), delete r._xautoBinFinished, delete r._yautoBinFinished, a(r, "2dMap") || o(r._input, r, e, _));
        }

        var k = e._alignmentOpts || {};

        for (d = 0; d < y.length; d++) {
          if (r = y[d], h = "", !a(r, "2dMap")) {
            if (p = w(r), "group" === e.barmode && r.alignmentgroup) {
              var M = r[p + "axis"],
                  A = l(e, M) + r.orientation;
              (k[A] || {})[r.alignmentgroup] && (h = A);
            }

            h || "overlay" === e.barmode || (h = l(e, r.xaxis) + l(e, r.yaxis) + w(r));
          }

          h ? (x[h] || (x[h] = []), x[h].push(r)) : b.push(r);
        }

        for (h in x) {
          if (1 !== (f = x[h]).length) {
            var S = !1;

            for (f.length && (r = f[0], S = _("bingroup")), h = S || h, d = 0; d < f.length; d++) {
              var E = (r = f[d])._input.bingroup;
              E && E !== h && n.warn(["Trace", r.index, "must match", "within bingroup", h + ".", "Ignoring its bingroup:", E, "setting."].join(" ")), r.bingroup = h, T(r, h, w(r));
            }
          } else b.push(f[0]);
        }

        for (d = 0; d < b.length; d++) {
          r = b[d];

          var L = _("bingroup");

          if (a(r, "2dMap")) for (g = 0; g < 2; g++) {
            var C = _((p = u[g]) + "bingroup", L ? L + "__" + p : null);

            T(r, C, p);
          } else T(r, L, w(r));
        }

        for (h in v) {
          var P = v[h];

          for (f = P.traces, m = 0; m < c.length; m++) {
            var I,
                O,
                z = c[m],
                D = z.name;

            if ("nbins" !== D || !P.sizeFound) {
              for (d = 0; d < f.length; d++) {
                if (r = f[d], p = P.dirs[d], I = z.aStr[p], void 0 !== s(r._input, I).get()) {
                  P[D] = _(I), P[D + "Found"] = !0;
                  break;
                }

                (O = (r._autoBin || {})[p] || {})[D] && s(r, I).set(O[D]);
              }

              if ("start" === D || "end" === D) for (; d < f.length; d++) {
                (r = f[d])["_" + p + "bingroup"] && _(I, (O = (r._autoBin || {})[p] || {})[D]);
              }
              "nbins" !== D || P.sizeFound || P.nbinsFound || (r = f[0], P[D] = _(I));
            }
          }
        }
      };
    }, {
      "../../lib": 795,
      "../../plots/cartesian/axis_ids": 848,
      "../../plots/cartesian/constraints": 852,
      "../../registry": 923,
      "../bar/defaults": 937
    }],
    1104: [function (t, e, r) {
      "use strict";

      var n = t("../../registry"),
          i = t("../../lib"),
          a = t("../../components/color"),
          o = t("../bar/style_defaults"),
          s = t("./attributes");

      e.exports = function (t, e, r, l) {
        function c(r, n) {
          return i.coerce(t, e, s, r, n);
        }

        var u = c("x"),
            f = c("y");
        c("cumulative.enabled") && (c("cumulative.direction"), c("cumulative.currentbin")), c("text"), c("hovertext"), c("hovertemplate"), c("xhoverformat"), c("yhoverformat");
        var h = c("orientation", f && !u ? "h" : "v"),
            p = "v" === h ? "x" : "y",
            d = "v" === h ? "y" : "x",
            m = u && f ? Math.min(i.minRowLength(u) && i.minRowLength(f)) : i.minRowLength(e[p] || []);

        if (m) {
          e._length = m, n.getComponentMethod("calendars", "handleTraceDefaults")(t, e, ["x", "y"], l), e[d] && c("histfunc"), c("histnorm"), c("autobin" + p), o(t, e, c, r, l), i.coerceSelectionMarkerOpacity(e, c);
          var g = (e.marker.line || {}).color,
              v = n.getComponentMethod("errorbars", "supplyDefaults");
          v(t, e, g || a.defaultLine, {
            axis: "y"
          }), v(t, e, g || a.defaultLine, {
            axis: "x",
            inherit: "y"
          });
        } else e.visible = !1;
      };
    }, {
      "../../components/color": 658,
      "../../lib": 795,
      "../../registry": 923,
      "../bar/style_defaults": 948,
      "./attributes": 1096
    }],
    1105: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, n, i) {
        if (t.x = "xVal" in e ? e.xVal : e.x, t.y = "yVal" in e ? e.yVal : e.y, "zLabelVal" in e && (t.z = e.zLabelVal), e.xa && (t.xaxis = e.xa), e.ya && (t.yaxis = e.ya), !(r.cumulative || {}).enabled) {
          var a,
              o = Array.isArray(i) ? n[0].pts[i[0]][i[1]] : n[i].pts;

          if (t.pointNumbers = o, t.binNumber = t.pointNumber, delete t.pointNumber, delete t.pointIndex, r._indexToPoints) {
            a = [];

            for (var s = 0; s < o.length; s++) {
              a = a.concat(r._indexToPoints[o[s]]);
            }
          } else a = o;

          t.pointIndices = a;
        }

        return t;
      };
    }, {}],
    1106: [function (t, e, r) {
      "use strict";

      var n = t("../bar/hover").hoverPoints,
          i = t("../../plots/cartesian/axes").hoverLabelText;

      e.exports = function (t, e, r, a, o) {
        var s = n(t, e, r, a, o);

        if (s) {
          var l = (t = s[0]).cd[t.index],
              c = t.cd[0].trace;

          if (!c.cumulative.enabled) {
            var u = "h" === c.orientation ? "y" : "x";
            t[u + "Label"] = i(t[u + "a"], [l.ph0, l.ph1], c[u + "hoverformat"]);
          }

          return s;
        }
      };
    }, {
      "../../plots/cartesian/axes": 845,
      "../bar/hover": 940
    }],
    1107: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        layoutAttributes: t("../bar/layout_attributes"),
        supplyDefaults: t("./defaults"),
        crossTraceDefaults: t("./cross_trace_defaults"),
        supplyLayoutDefaults: t("../bar/layout_defaults"),
        calc: t("./calc").calc,
        crossTraceCalc: t("../bar/cross_trace_calc").crossTraceCalc,
        plot: t("../bar/plot").plot,
        layerName: "barlayer",
        style: t("../bar/style").style,
        styleOnSelect: t("../bar/style").styleOnSelect,
        colorbar: t("../scatter/marker_colorbar"),
        hoverPoints: t("./hover"),
        selectPoints: t("../bar/select"),
        eventData: t("./event_data"),
        moduleType: "trace",
        name: "histogram",
        basePlotModule: t("../../plots/cartesian"),
        categories: ["bar-like", "cartesian", "svg", "bar", "histogram", "oriented", "errorBarsOK", "showLegend"],
        meta: {}
      };
    }, {
      "../../plots/cartesian": 858,
      "../bar/cross_trace_calc": 936,
      "../bar/layout_attributes": 942,
      "../bar/layout_defaults": 943,
      "../bar/plot": 944,
      "../bar/select": 945,
      "../bar/style": 947,
      "../scatter/marker_colorbar": 1217,
      "./attributes": 1096,
      "./calc": 1101,
      "./cross_trace_defaults": 1103,
      "./defaults": 1104,
      "./event_data": 1105,
      "./hover": 1106
    }],
    1108: [function (t, e, r) {
      "use strict";

      e.exports = {
        percent: function percent(t, e) {
          for (var r = t.length, n = 100 / e, i = 0; i < r; i++) {
            t[i] *= n;
          }
        },
        probability: function probability(t, e) {
          for (var r = t.length, n = 0; n < r; n++) {
            t[n] /= e;
          }
        },
        density: function density(t, e, r, n) {
          var i = t.length;
          n = n || 1;

          for (var a = 0; a < i; a++) {
            t[a] *= r[a] * n;
          }
        },
        "probability density": function probabilityDensity(t, e, r, n) {
          var i = t.length;
          n && (e /= n);

          for (var a = 0; a < i; a++) {
            t[a] *= r[a] / e;
          }
        }
      };
    }, {}],
    1109: [function (t, e, r) {
      "use strict";

      var n = t("../histogram/attributes"),
          i = t("../histogram/bin_attributes"),
          a = t("../heatmap/attributes"),
          o = t("../../plots/attributes"),
          s = t("../../plots/hoverformat_attributes"),
          l = t("../../plots/template_attributes").hovertemplateAttrs,
          c = t("../../components/colorscale/attributes"),
          u = t("../../lib/extend").extendFlat;
      e.exports = u({
        x: n.x,
        y: n.y,
        z: {
          valType: "data_array",
          editType: "calc"
        },
        marker: {
          color: {
            valType: "data_array",
            editType: "calc"
          },
          editType: "calc"
        },
        histnorm: n.histnorm,
        histfunc: n.histfunc,
        nbinsx: n.nbinsx,
        xbins: i("x"),
        nbinsy: n.nbinsy,
        ybins: i("y"),
        autobinx: n.autobinx,
        autobiny: n.autobiny,
        bingroup: u({}, n.bingroup, {}),
        xbingroup: u({}, n.bingroup, {}),
        ybingroup: u({}, n.bingroup, {}),
        xgap: a.xgap,
        ygap: a.ygap,
        zsmooth: a.zsmooth,
        xhoverformat: s("x"),
        yhoverformat: s("y"),
        zhoverformat: s("z", 1),
        hovertemplate: l({}, {
          keys: "z"
        }),
        showlegend: u({}, o.showlegend, {
          dflt: !1
        })
      }, c("", {
        cLetter: "z",
        autoColorDflt: !1
      }));
    }, {
      "../../components/colorscale/attributes": 665,
      "../../lib/extend": 785,
      "../../plots/attributes": 841,
      "../../plots/hoverformat_attributes": 899,
      "../../plots/template_attributes": 918,
      "../heatmap/attributes": 1077,
      "../histogram/attributes": 1096,
      "../histogram/bin_attributes": 1098
    }],
    1110: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../plots/cartesian/axes"),
          a = t("../histogram/bin_functions"),
          o = t("../histogram/norm_functions"),
          s = t("../histogram/average"),
          l = t("../histogram/bin_label_vals"),
          c = t("../histogram/calc").calcAllAutoBins;

      function u(t, e, r, n) {
        var i,
            a = new Array(t);
        if (n) for (i = 0; i < t; i++) {
          a[i] = 1 / (e[i + 1] - e[i]);
        } else {
          var o = 1 / r;

          for (i = 0; i < t; i++) {
            a[i] = o;
          }
        }
        return a;
      }

      function f(t, e) {
        return {
          start: t(e.start),
          end: t(e.end),
          size: e.size
        };
      }

      function h(t, e, r, n, i, a) {
        var o,
            s = t.length - 1,
            c = new Array(s),
            u = l(r, n, t, i, a);

        for (o = 0; o < s; o++) {
          var f = (e || [])[o];
          c[o] = void 0 === f ? [u(t[o]), u(t[o + 1], !0)] : [f, f];
        }

        return c;
      }

      e.exports = function (t, e) {
        var r,
            l,
            p,
            d,
            m = i.getFromId(t, e.xaxis),
            g = i.getFromId(t, e.yaxis),
            v = e.xcalendar,
            y = e.ycalendar,
            x = function x(t) {
          return m.r2c(t, 0, v);
        },
            b = function b(t) {
          return g.r2c(t, 0, y);
        },
            _ = c(t, e, m, "x"),
            w = _[0],
            T = _[1],
            k = c(t, e, g, "y"),
            M = k[0],
            A = k[1],
            S = e._length;

        T.length > S && T.splice(S, T.length - S), A.length > S && A.splice(S, A.length - S);
        var E = [],
            L = [],
            C = [],
            P = "string" == typeof w.size,
            I = "string" == typeof M.size,
            O = [],
            z = [],
            D = P ? O : w,
            R = I ? z : M,
            F = 0,
            B = [],
            N = [],
            j = e.histnorm,
            U = e.histfunc,
            V = -1 !== j.indexOf("density"),
            q = "max" === U || "min" === U ? null : 0,
            H = a.count,
            G = o[j],
            Y = !1,
            W = [],
            X = [],
            Z = "z" in e ? e.z : "marker" in e && Array.isArray(e.marker.color) ? e.marker.color : "";
        Z && "count" !== U && (Y = "avg" === U, H = a[U]);
        var J = w.size,
            K = x(w.start),
            Q = x(w.end) + (K - i.tickIncrement(K, J, !1, v)) / 1e6;

        for (r = K; r < Q; r = i.tickIncrement(r, J, !1, v)) {
          L.push(q), O.push(r), Y && C.push(0);
        }

        O.push(r);
        var $,
            tt = L.length,
            et = (r - K) / tt,
            rt = ($ = K + et / 2, m.c2r($, 0, v)),
            nt = M.size,
            it = b(M.start),
            at = b(M.end) + (it - i.tickIncrement(it, nt, !1, y)) / 1e6;

        for (r = it; r < at; r = i.tickIncrement(r, nt, !1, y)) {
          E.push(L.slice()), z.push(r);
          var ot = new Array(tt);

          for (l = 0; l < tt; l++) {
            ot[l] = [];
          }

          N.push(ot), Y && B.push(C.slice());
        }

        z.push(r);

        var st = E.length,
            lt = (r - it) / st,
            ct = function (t) {
          return g.c2r(t, 0, y);
        }(it + lt / 2);

        V && (W = u(L.length, D, et, P), X = u(E.length, R, lt, I)), P || "date" !== m.type || (D = f(x, D)), I || "date" !== g.type || (R = f(b, R));
        var ut = !0,
            ft = !0,
            ht = new Array(tt),
            pt = new Array(st),
            dt = 1 / 0,
            mt = 1 / 0,
            gt = 1 / 0,
            vt = 1 / 0;

        for (r = 0; r < S; r++) {
          var yt = T[r],
              xt = A[r];
          p = n.findBin(yt, D), d = n.findBin(xt, R), p >= 0 && p < tt && d >= 0 && d < st && (F += H(p, r, E[d], Z, B[d]), N[d][p].push(r), ut && (void 0 === ht[p] ? ht[p] = yt : ht[p] !== yt && (ut = !1)), ft && (void 0 === pt[d] ? pt[d] = xt : pt[d] !== xt && (ft = !1)), dt = Math.min(dt, yt - O[p]), mt = Math.min(mt, O[p + 1] - yt), gt = Math.min(gt, xt - z[d]), vt = Math.min(vt, z[d + 1] - xt));
        }

        if (Y) for (d = 0; d < st; d++) {
          F += s(E[d], B[d]);
        }
        if (G) for (d = 0; d < st; d++) {
          G(E[d], F, W, X[d]);
        }
        return {
          x: T,
          xRanges: h(O, ut && ht, dt, mt, m, v),
          x0: rt,
          dx: et,
          y: A,
          yRanges: h(z, ft && pt, gt, vt, g, y),
          y0: ct,
          dy: lt,
          z: E,
          pts: N
        };
      };
    }, {
      "../../lib": 795,
      "../../plots/cartesian/axes": 845,
      "../histogram/average": 1097,
      "../histogram/bin_functions": 1099,
      "../histogram/bin_label_vals": 1100,
      "../histogram/calc": 1101,
      "../histogram/norm_functions": 1108
    }],
    1111: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./sample_defaults"),
          a = t("../heatmap/style_defaults"),
          o = t("../../components/colorscale/defaults"),
          s = t("./attributes");

      e.exports = function (t, e, r, l) {
        function c(r, i) {
          return n.coerce(t, e, s, r, i);
        }

        i(t, e, c, l), !1 !== e.visible && (a(t, e, c, l), o(t, e, l, c, {
          prefix: "",
          cLetter: "z"
        }), c("hovertemplate"), c("xhoverformat"), c("yhoverformat"));
      };
    }, {
      "../../components/colorscale/defaults": 668,
      "../../lib": 795,
      "../heatmap/style_defaults": 1090,
      "./attributes": 1109,
      "./sample_defaults": 1114
    }],
    1112: [function (t, e, r) {
      "use strict";

      var n = t("../heatmap/hover"),
          i = t("../../plots/cartesian/axes").hoverLabelText;

      e.exports = function (t, e, r, a, o) {
        var s = n(t, e, r, a, o);

        if (s) {
          var l = (t = s[0]).index,
              c = l[0],
              u = l[1],
              f = t.cd[0],
              h = f.trace,
              p = f.xRanges[u],
              d = f.yRanges[c];
          return t.xLabel = i(t.xa, [p[0], p[1]], h.xhoverformat), t.yLabel = i(t.ya, [d[0], d[1]], h.yhoverformat), s;
        }
      };
    }, {
      "../../plots/cartesian/axes": 845,
      "../heatmap/hover": 1084
    }],
    1113: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        crossTraceDefaults: t("../histogram/cross_trace_defaults"),
        calc: t("../heatmap/calc"),
        plot: t("../heatmap/plot"),
        layerName: "heatmaplayer",
        colorbar: t("../heatmap/colorbar"),
        style: t("../heatmap/style"),
        hoverPoints: t("./hover"),
        eventData: t("../histogram/event_data"),
        moduleType: "trace",
        name: "histogram2d",
        basePlotModule: t("../../plots/cartesian"),
        categories: ["cartesian", "svg", "2dMap", "histogram", "showLegend"],
        meta: {}
      };
    }, {
      "../../plots/cartesian": 858,
      "../heatmap/calc": 1078,
      "../heatmap/colorbar": 1080,
      "../heatmap/plot": 1088,
      "../heatmap/style": 1089,
      "../histogram/cross_trace_defaults": 1103,
      "../histogram/event_data": 1105,
      "./attributes": 1109,
      "./defaults": 1111,
      "./hover": 1112
    }],
    1114: [function (t, e, r) {
      "use strict";

      var n = t("../../registry"),
          i = t("../../lib");

      e.exports = function (t, e, r, a) {
        var o = r("x"),
            s = r("y"),
            l = i.minRowLength(o),
            c = i.minRowLength(s);
        l && c ? (e._length = Math.min(l, c), n.getComponentMethod("calendars", "handleTraceDefaults")(t, e, ["x", "y"], a), (r("z") || r("marker.color")) && r("histfunc"), r("histnorm"), r("autobinx"), r("autobiny")) : e.visible = !1;
      };
    }, {
      "../../lib": 795,
      "../../registry": 923
    }],
    1115: [function (t, e, r) {
      "use strict";

      var n = t("../histogram2d/attributes"),
          i = t("../contour/attributes"),
          a = t("../../components/colorscale/attributes"),
          o = t("../../plots/hoverformat_attributes"),
          s = t("../../lib/extend").extendFlat;
      e.exports = s({
        x: n.x,
        y: n.y,
        z: n.z,
        marker: n.marker,
        histnorm: n.histnorm,
        histfunc: n.histfunc,
        nbinsx: n.nbinsx,
        xbins: n.xbins,
        nbinsy: n.nbinsy,
        ybins: n.ybins,
        autobinx: n.autobinx,
        autobiny: n.autobiny,
        bingroup: n.bingroup,
        xbingroup: n.xbingroup,
        ybingroup: n.ybingroup,
        autocontour: i.autocontour,
        ncontours: i.ncontours,
        contours: i.contours,
        line: {
          color: i.line.color,
          width: s({}, i.line.width, {
            dflt: .5
          }),
          dash: i.line.dash,
          smoothing: i.line.smoothing,
          editType: "plot"
        },
        xhoverformat: o("x"),
        yhoverformat: o("y"),
        zhoverformat: o("z", 1),
        hovertemplate: n.hovertemplate
      }, a("", {
        cLetter: "z",
        editTypeOverride: "calc"
      }));
    }, {
      "../../components/colorscale/attributes": 665,
      "../../lib/extend": 785,
      "../../plots/hoverformat_attributes": 899,
      "../contour/attributes": 1020,
      "../histogram2d/attributes": 1109
    }],
    1116: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../histogram2d/sample_defaults"),
          a = t("../contour/contours_defaults"),
          o = t("../contour/style_defaults"),
          s = t("./attributes");

      e.exports = function (t, e, r, l) {
        function c(r, i) {
          return n.coerce(t, e, s, r, i);
        }

        i(t, e, c, l), !1 !== e.visible && (a(t, e, c, function (r) {
          return n.coerce2(t, e, s, r);
        }), o(t, e, c, l), c("hovertemplate"), c("xhoverformat"), c("yhoverformat"));
      };
    }, {
      "../../lib": 795,
      "../contour/contours_defaults": 1027,
      "../contour/style_defaults": 1041,
      "../histogram2d/sample_defaults": 1114,
      "./attributes": 1115
    }],
    1117: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        crossTraceDefaults: t("../histogram/cross_trace_defaults"),
        calc: t("../contour/calc"),
        plot: t("../contour/plot").plot,
        layerName: "contourlayer",
        style: t("../contour/style"),
        colorbar: t("../contour/colorbar"),
        hoverPoints: t("../contour/hover"),
        moduleType: "trace",
        name: "histogram2dcontour",
        basePlotModule: t("../../plots/cartesian"),
        categories: ["cartesian", "svg", "2dMap", "contour", "histogram", "showLegend"],
        meta: {}
      };
    }, {
      "../../plots/cartesian": 858,
      "../contour/calc": 1021,
      "../contour/colorbar": 1023,
      "../contour/hover": 1033,
      "../contour/plot": 1038,
      "../contour/style": 1040,
      "../histogram/cross_trace_defaults": 1103,
      "./attributes": 1115,
      "./defaults": 1116
    }],
    1118: [function (t, e, r) {
      "use strict";

      for (var n = t("../../plots/attributes"), i = t("../../plots/template_attributes").hovertemplateAttrs, a = t("../../lib/extend").extendFlat, o = t("./constants").colormodel, s = ["rgb", "rgba", "rgba256", "hsl", "hsla"], l = [], c = [], u = 0; u < s.length; u++) {
        var f = o[s[u]];
        l.push("For the `" + s[u] + "` colormodel, it is [" + (f.zminDflt || f.min).join(", ") + "]."), c.push("For the `" + s[u] + "` colormodel, it is [" + (f.zmaxDflt || f.max).join(", ") + "].");
      }

      e.exports = a({
        source: {
          valType: "string",
          editType: "calc"
        },
        z: {
          valType: "data_array",
          editType: "calc"
        },
        colormodel: {
          valType: "enumerated",
          values: s,
          editType: "calc"
        },
        zsmooth: {
          valType: "enumerated",
          values: ["fast", !1],
          dflt: !1,
          editType: "plot"
        },
        zmin: {
          valType: "info_array",
          items: [{
            valType: "number",
            editType: "calc"
          }, {
            valType: "number",
            editType: "calc"
          }, {
            valType: "number",
            editType: "calc"
          }, {
            valType: "number",
            editType: "calc"
          }],
          editType: "calc"
        },
        zmax: {
          valType: "info_array",
          items: [{
            valType: "number",
            editType: "calc"
          }, {
            valType: "number",
            editType: "calc"
          }, {
            valType: "number",
            editType: "calc"
          }, {
            valType: "number",
            editType: "calc"
          }],
          editType: "calc"
        },
        x0: {
          valType: "any",
          dflt: 0,
          editType: "calc+clearAxisTypes"
        },
        y0: {
          valType: "any",
          dflt: 0,
          editType: "calc+clearAxisTypes"
        },
        dx: {
          valType: "number",
          dflt: 1,
          editType: "calc"
        },
        dy: {
          valType: "number",
          dflt: 1,
          editType: "calc"
        },
        text: {
          valType: "data_array",
          editType: "plot"
        },
        hovertext: {
          valType: "data_array",
          editType: "plot"
        },
        hoverinfo: a({}, n.hoverinfo, {
          flags: ["x", "y", "z", "color", "name", "text"],
          dflt: "x+y+z+text+name"
        }),
        hovertemplate: i({}, {
          keys: ["z", "color", "colormodel"]
        }),
        transforms: void 0
      });
    }, {
      "../../lib/extend": 785,
      "../../plots/attributes": 841,
      "../../plots/template_attributes": 918,
      "./constants": 1120
    }],
    1119: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./constants"),
          a = t("fast-isnumeric"),
          o = t("../../plots/cartesian/axes"),
          s = t("../../lib").maxRowLength,
          l = t("./helpers").getImageSize;

      function c(t, e, r, i) {
        return function (a) {
          return n.constrain((a - t) * e, r, i);
        };
      }

      function u(t, e) {
        return function (r) {
          return n.constrain(r, t, e);
        };
      }

      e.exports = function (t, e) {
        var r, n;
        if (e._hasZ) r = e.z.length, n = s(e.z);else if (e._hasSource) {
          var f = l(e.source);
          r = f.height, n = f.width;
        }
        var h,
            p = o.getFromId(t, e.xaxis || "x"),
            d = o.getFromId(t, e.yaxis || "y"),
            m = p.d2c(e.x0) - e.dx / 2,
            g = d.d2c(e.y0) - e.dy / 2,
            v = [m, m + n * e.dx],
            y = [g, g + r * e.dy];
        if (p && "log" === p.type) for (h = 0; h < n; h++) {
          v.push(m + h * e.dx);
        }
        if (d && "log" === d.type) for (h = 0; h < r; h++) {
          y.push(g + h * e.dy);
        }
        return e._extremes[p._id] = o.findExtremes(p, v), e._extremes[d._id] = o.findExtremes(d, y), e._scaler = function (t) {
          var e = i.colormodel[t.colormodel],
              r = (e.colormodel || t.colormodel).length;
          t._sArray = [];

          for (var n = 0; n < r; n++) {
            e.min[n] !== t.zmin[n] || e.max[n] !== t.zmax[n] ? t._sArray.push(c(t.zmin[n], (e.max[n] - e.min[n]) / (t.zmax[n] - t.zmin[n]), e.min[n], e.max[n])) : t._sArray.push(u(e.min[n], e.max[n]));
          }

          return function (e) {
            for (var n = e.slice(0, r), i = 0; i < r; i++) {
              var o = n[i];
              if (!a(o)) return !1;
              n[i] = t._sArray[i](o);
            }

            return n;
          };
        }(e), [{
          x0: m,
          y0: g,
          z: e.z,
          w: n,
          h: r
        }];
      };
    }, {
      "../../lib": 795,
      "../../plots/cartesian/axes": 845,
      "./constants": 1120,
      "./helpers": 1123,
      "fast-isnumeric": 240
    }],
    1120: [function (t, e, r) {
      "use strict";

      e.exports = {
        colormodel: {
          rgb: {
            min: [0, 0, 0],
            max: [255, 255, 255],
            fmt: function fmt(t) {
              return t.slice(0, 3);
            },
            suffix: ["", "", ""]
          },
          rgba: {
            min: [0, 0, 0, 0],
            max: [255, 255, 255, 1],
            fmt: function fmt(t) {
              return t.slice(0, 4);
            },
            suffix: ["", "", "", ""]
          },
          rgba256: {
            colormodel: "rgba",
            zminDflt: [0, 0, 0, 0],
            zmaxDflt: [255, 255, 255, 255],
            min: [0, 0, 0, 0],
            max: [255, 255, 255, 1],
            fmt: function fmt(t) {
              return t.slice(0, 4);
            },
            suffix: ["", "", "", ""]
          },
          hsl: {
            min: [0, 0, 0],
            max: [360, 100, 100],
            fmt: function fmt(t) {
              var e = t.slice(0, 3);
              return e[1] = e[1] + "%", e[2] = e[2] + "%", e;
            },
            suffix: ["\xb0", "%", "%"]
          },
          hsla: {
            min: [0, 0, 0, 0],
            max: [360, 100, 100, 1],
            fmt: function fmt(t) {
              var e = t.slice(0, 4);
              return e[1] = e[1] + "%", e[2] = e[2] + "%", e;
            },
            suffix: ["\xb0", "%", "%", ""]
          }
        },
        pixelatedStyle: ["image-rendering: optimizeSpeed", "image-rendering: -moz-crisp-edges", "image-rendering: -o-crisp-edges", "image-rendering: -webkit-optimize-contrast", "image-rendering: optimize-contrast", "image-rendering: crisp-edges", "image-rendering: pixelated", ""].join("; ")
      };
    }, {}],
    1121: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./attributes"),
          a = t("./constants"),
          o = t("../../snapshot/helpers").IMAGE_URL_PREFIX;

      e.exports = function (t, e) {
        function r(r, a) {
          return n.coerce(t, e, i, r, a);
        }

        r("source"), e.source && !e.source.match(o) && delete e.source, e._hasSource = !!e.source;
        var s,
            l = r("z");
        (e._hasZ = !(void 0 === l || !l.length || !l[0] || !l[0].length), e._hasZ || e._hasSource) ? (r("x0"), r("y0"), r("dx"), r("dy"), e._hasZ ? (r("colormodel", "rgb"), r("zmin", (s = a.colormodel[e.colormodel]).zminDflt || s.min), r("zmax", s.zmaxDflt || s.max)) : e._hasSource && (e.colormodel = "rgba256", s = a.colormodel[e.colormodel], e.zmin = s.zminDflt, e.zmax = s.zmaxDflt), r("zsmooth"), r("text"), r("hovertext"), r("hovertemplate"), e._length = null) : e.visible = !1;
      };
    }, {
      "../../lib": 795,
      "../../snapshot/helpers": 927,
      "./attributes": 1118,
      "./constants": 1120
    }],
    1122: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        return "xVal" in e && (t.x = e.xVal), "yVal" in e && (t.y = e.yVal), e.xa && (t.xaxis = e.xa), e.ya && (t.yaxis = e.ya), t.color = e.color, t.colormodel = e.trace.colormodel, t.z || (t.z = e.color), t;
      };
    }, {}],
    1123: [function (t, e, r) {
      "use strict";

      var n = t("probe-image-size/sync"),
          i = t("../../snapshot/helpers").IMAGE_URL_PREFIX,
          a = t("buffer/").Buffer;

      r.getImageSize = function (t) {
        var e = t.replace(i, ""),
            r = new a(e, "base64");
        return n(r);
      };
    }, {
      "../../snapshot/helpers": 927,
      "buffer/": 112,
      "probe-image-size/sync": 519
    }],
    1124: [function (t, e, r) {
      "use strict";

      var n = t("../../components/fx"),
          i = t("../../lib"),
          a = t("./constants");

      e.exports = function (t, e, r) {
        var o = t.cd[0],
            s = o.trace,
            l = t.xa,
            c = t.ya;

        if (!(n.inbox(e - o.x0, e - (o.x0 + o.w * s.dx), 0) > 0 || n.inbox(r - o.y0, r - (o.y0 + o.h * s.dy), 0) > 0)) {
          var u,
              f = Math.floor((e - o.x0) / s.dx),
              h = Math.floor(Math.abs(r - o.y0) / s.dy);

          if (s._hasZ ? u = o.z[h][f] : s._hasSource && (u = s._canvas.el.getContext("2d").getImageData(f, h, 1, 1).data), u) {
            var p,
                d = o.hi || s.hoverinfo;

            if (d) {
              var m = d.split("+");
              -1 !== m.indexOf("all") && (m = ["color"]), -1 !== m.indexOf("color") && (p = !0);
            }

            var g,
                v = a.colormodel[s.colormodel],
                y = v.colormodel || s.colormodel,
                x = y.length,
                b = s._scaler(u),
                _ = v.suffix,
                w = [];

            (s.hovertemplate || p) && (w.push("[" + [b[0] + _[0], b[1] + _[1], b[2] + _[2]].join(", ")), 4 === x && w.push(", " + b[3] + _[3]), w.push("]"), w = w.join(""), t.extraText = y.toUpperCase() + ": " + w), Array.isArray(s.hovertext) && Array.isArray(s.hovertext[h]) ? g = s.hovertext[h][f] : Array.isArray(s.text) && Array.isArray(s.text[h]) && (g = s.text[h][f]);
            var T = c.c2p(o.y0 + (h + .5) * s.dy),
                k = o.x0 + (f + .5) * s.dx,
                M = o.y0 + (h + .5) * s.dy,
                A = "[" + u.slice(0, s.colormodel.length).join(", ") + "]";
            return [i.extendFlat(t, {
              index: [h, f],
              x0: l.c2p(o.x0 + f * s.dx),
              x1: l.c2p(o.x0 + (f + 1) * s.dx),
              y0: T,
              y1: T,
              color: b,
              xVal: k,
              xLabelVal: k,
              yVal: M,
              yLabelVal: M,
              zLabelVal: A,
              text: g,
              hovertemplateLabels: {
                zLabel: A,
                colorLabel: w,
                "color[0]Label": b[0] + _[0],
                "color[1]Label": b[1] + _[1],
                "color[2]Label": b[2] + _[2],
                "color[3]Label": b[3] + _[3]
              }
            })];
          }
        }
      };
    }, {
      "../../components/fx": 698,
      "../../lib": 795,
      "./constants": 1120
    }],
    1125: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        calc: t("./calc"),
        plot: t("./plot"),
        style: t("./style"),
        hoverPoints: t("./hover"),
        eventData: t("./event_data"),
        moduleType: "trace",
        name: "image",
        basePlotModule: t("../../plots/cartesian"),
        categories: ["cartesian", "svg", "2dMap", "noSortingByValue"],
        animatable: !1,
        meta: {}
      };
    }, {
      "../../plots/cartesian": 858,
      "./attributes": 1118,
      "./calc": 1119,
      "./defaults": 1121,
      "./event_data": 1122,
      "./hover": 1124,
      "./plot": 1126,
      "./style": 1127
    }],
    1126: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../lib"),
          a = i.strTranslate,
          o = t("../../constants/xmlns_namespaces"),
          s = t("./constants"),
          l = i.isIOS() || i.isSafari() || i.isIE();

      e.exports = function (t, e, r, c) {
        var u = e.xaxis,
            f = e.yaxis,
            h = !(l || t._context._exportedPlot);
        i.makeTraceGroups(c, r, "im").each(function (e) {
          var r = n.select(this),
              l = e[0],
              c = l.trace,
              p = ("fast" === c.zsmooth || !1 === c.zsmooth && h) && !c._hasZ && c._hasSource && "linear" === u.type && "linear" === f.type;
          c._realImage = p;
          var d,
              m,
              g,
              v,
              y,
              x,
              b = l.z,
              _ = l.x0,
              w = l.y0,
              T = l.w,
              k = l.h,
              M = c.dx,
              A = c.dy;

          for (x = 0; void 0 === d && x < T;) {
            d = u.c2p(_ + x * M), x++;
          }

          for (x = T; void 0 === m && x > 0;) {
            m = u.c2p(_ + x * M), x--;
          }

          for (x = 0; void 0 === v && x < k;) {
            v = f.c2p(w + x * A), x++;
          }

          for (x = k; void 0 === y && x > 0;) {
            y = f.c2p(w + x * A), x--;
          }

          if (m < d && (g = m, m = d, d = g), y < v && (g = v, v = y, y = g), !p) {
            d = Math.max(-.5 * u._length, d), m = Math.min(1.5 * u._length, m), v = Math.max(-.5 * f._length, v), y = Math.min(1.5 * f._length, y);
          }

          var S = Math.round(m - d),
              E = Math.round(y - v);

          if (S <= 0 || E <= 0) {
            r.selectAll("image").data([]).exit().remove();
          } else {
            var L = r.selectAll("image").data([e]);
            L.enter().append("svg:image").attr({
              xmlns: o.svg,
              preserveAspectRatio: "none"
            }), L.exit().remove();
            var C = !1 === c.zsmooth ? s.pixelatedStyle : "";

            if (p) {
              var P = i.simpleMap(u.range, u.r2l),
                  I = i.simpleMap(f.range, f.r2l),
                  O = P[1] < P[0],
                  z = I[1] > I[0];

              if (O || z) {
                var D = d + S / 2,
                    R = v + E / 2;
                C += "transform:" + a(D + "px", R + "px") + "scale(" + (O ? -1 : 1) + "," + (z ? -1 : 1) + ")" + a(-D + "px", -R + "px") + ";";
              }
            }

            L.attr("style", C);
            var F = new Promise(function (t) {
              if (c._hasZ) t();else if (c._hasSource) if (c._canvas && c._canvas.el.width === T && c._canvas.el.height === k && c._canvas.source === c.source) t();else {
                var e = document.createElement("canvas");
                e.width = T, e.height = k;
                var r = e.getContext("2d");
                c._image = c._image || new Image();
                var n = c._image;
                n.onload = function () {
                  r.drawImage(n, 0, 0), c._canvas = {
                    el: e,
                    source: c.source
                  }, t();
                }, n.setAttribute("src", c.source);
              }
            }).then(function () {
              var t;
              if (c._hasZ) t = B(function (t, e) {
                return b[e][t];
              }).toDataURL("image/png");else if (c._hasSource) if (p) t = c.source;else {
                var e = c._canvas.el.getContext("2d").getImageData(0, 0, T, k).data;

                t = B(function (t, r) {
                  var n = 4 * (r * T + t);
                  return [e[n], e[n + 1], e[n + 2], e[n + 3]];
                }).toDataURL("image/png");
              }
              L.attr({
                "xlink:href": t,
                height: E,
                width: S,
                x: d,
                y: v
              });
            });

            t._promises.push(F);
          }

          function B(t) {
            var e = document.createElement("canvas");
            e.width = S, e.height = E;

            var r,
                n = e.getContext("2d"),
                a = function a(t) {
              return i.constrain(Math.round(u.c2p(_ + t * M) - d), 0, S);
            },
                o = function o(t) {
              return i.constrain(Math.round(f.c2p(w + t * A) - v), 0, E);
            },
                h = s.colormodel[c.colormodel],
                p = h.colormodel || c.colormodel,
                m = h.fmt;

            for (x = 0; x < l.w; x++) {
              var g = a(x),
                  y = a(x + 1);
              if (y !== g && !isNaN(y) && !isNaN(g)) for (var b = 0; b < l.h; b++) {
                var T = o(b),
                    k = o(b + 1);
                k === T || isNaN(k) || isNaN(T) || !t(x, b) || (r = c._scaler(t(x, b)), n.fillStyle = r ? p + "(" + m(r).join(",") + ")" : "rgba(0,0,0,0)", n.fillRect(g, T, y - g, k - T));
              }
            }

            return e;
          }
        });
      };
    }, {
      "../../constants/xmlns_namespaces": 772,
      "../../lib": 795,
      "./constants": 1120,
      "@plotly/d3": 57
    }],
    1127: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3");

      e.exports = function (t) {
        n.select(t).selectAll(".im image").style("opacity", function (t) {
          return t[0].trace.opacity;
        });
      };
    }, {
      "@plotly/d3": 57
    }],
    1128: [function (t, e, r) {
      "use strict";

      var n = t("../../lib/extend").extendFlat,
          i = t("../../lib/extend").extendDeep,
          a = t("../../plot_api/edit_types").overrideAll,
          o = t("../../plots/font_attributes"),
          s = t("../../components/color/attributes"),
          l = t("../../plots/domain").attributes,
          c = t("../../plots/cartesian/layout_attributes"),
          u = t("../../plot_api/plot_template").templatedArray,
          f = t("../../constants/delta.js"),
          h = (t("../../constants/docs").FORMAT_LINK, o({
        editType: "plot",
        colorEditType: "plot"
      })),
          p = {
        color: {
          valType: "color",
          editType: "plot"
        },
        line: {
          color: {
            valType: "color",
            dflt: s.defaultLine,
            editType: "plot"
          },
          width: {
            valType: "number",
            min: 0,
            dflt: 0,
            editType: "plot"
          },
          editType: "calc"
        },
        thickness: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 1,
          editType: "plot"
        },
        editType: "calc"
      },
          d = {
        valType: "info_array",
        items: [{
          valType: "number",
          editType: "plot"
        }, {
          valType: "number",
          editType: "plot"
        }],
        editType: "plot"
      },
          m = u("step", i({}, p, {
        range: d
      }));
      e.exports = {
        mode: {
          valType: "flaglist",
          editType: "calc",
          flags: ["number", "delta", "gauge"],
          dflt: "number"
        },
        value: {
          valType: "number",
          editType: "calc",
          anim: !0
        },
        align: {
          valType: "enumerated",
          values: ["left", "center", "right"],
          editType: "plot"
        },
        domain: l({
          name: "indicator",
          trace: !0,
          editType: "calc"
        }),
        title: {
          text: {
            valType: "string",
            editType: "plot"
          },
          align: {
            valType: "enumerated",
            values: ["left", "center", "right"],
            editType: "plot"
          },
          font: n({}, h, {}),
          editType: "plot"
        },
        number: {
          valueformat: {
            valType: "string",
            dflt: "",
            editType: "plot"
          },
          font: n({}, h, {}),
          prefix: {
            valType: "string",
            dflt: "",
            editType: "plot"
          },
          suffix: {
            valType: "string",
            dflt: "",
            editType: "plot"
          },
          editType: "plot"
        },
        delta: {
          reference: {
            valType: "number",
            editType: "calc"
          },
          position: {
            valType: "enumerated",
            values: ["top", "bottom", "left", "right"],
            dflt: "bottom",
            editType: "plot"
          },
          relative: {
            valType: "boolean",
            editType: "plot",
            dflt: !1
          },
          valueformat: {
            valType: "string",
            editType: "plot"
          },
          increasing: {
            symbol: {
              valType: "string",
              dflt: f.INCREASING.SYMBOL,
              editType: "plot"
            },
            color: {
              valType: "color",
              dflt: f.INCREASING.COLOR,
              editType: "plot"
            },
            editType: "plot"
          },
          decreasing: {
            symbol: {
              valType: "string",
              dflt: f.DECREASING.SYMBOL,
              editType: "plot"
            },
            color: {
              valType: "color",
              dflt: f.DECREASING.COLOR,
              editType: "plot"
            },
            editType: "plot"
          },
          font: n({}, h, {}),
          editType: "calc"
        },
        gauge: {
          shape: {
            valType: "enumerated",
            editType: "plot",
            dflt: "angular",
            values: ["angular", "bullet"]
          },
          bar: i({}, p, {
            color: {
              dflt: "green"
            }
          }),
          bgcolor: {
            valType: "color",
            editType: "plot"
          },
          bordercolor: {
            valType: "color",
            dflt: s.defaultLine,
            editType: "plot"
          },
          borderwidth: {
            valType: "number",
            min: 0,
            dflt: 1,
            editType: "plot"
          },
          axis: a({
            range: d,
            visible: n({}, c.visible, {
              dflt: !0
            }),
            tickmode: c.tickmode,
            nticks: c.nticks,
            tick0: c.tick0,
            dtick: c.dtick,
            tickvals: c.tickvals,
            ticktext: c.ticktext,
            ticks: n({}, c.ticks, {
              dflt: "outside"
            }),
            ticklen: c.ticklen,
            tickwidth: c.tickwidth,
            tickcolor: c.tickcolor,
            showticklabels: c.showticklabels,
            tickfont: o({}),
            tickangle: c.tickangle,
            tickformat: c.tickformat,
            tickformatstops: c.tickformatstops,
            tickprefix: c.tickprefix,
            showtickprefix: c.showtickprefix,
            ticksuffix: c.ticksuffix,
            showticksuffix: c.showticksuffix,
            separatethousands: c.separatethousands,
            exponentformat: c.exponentformat,
            minexponent: c.minexponent,
            showexponent: c.showexponent,
            editType: "plot"
          }, "plot"),
          steps: m,
          threshold: {
            line: {
              color: n({}, p.line.color, {}),
              width: n({}, p.line.width, {
                dflt: 1
              }),
              editType: "plot"
            },
            thickness: n({}, p.thickness, {
              dflt: .85
            }),
            value: {
              valType: "number",
              editType: "calc",
              dflt: !1
            },
            editType: "plot"
          },
          editType: "plot"
        }
      };
    }, {
      "../../components/color/attributes": 657,
      "../../constants/delta.js": 765,
      "../../constants/docs": 766,
      "../../lib/extend": 785,
      "../../plot_api/edit_types": 827,
      "../../plot_api/plot_template": 834,
      "../../plots/cartesian/layout_attributes": 859,
      "../../plots/domain": 872,
      "../../plots/font_attributes": 873
    }],
    1129: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/plots");
      r.name = "indicator", r.plot = function (t, e, i, a) {
        n.plotBasePlot(r.name, t, e, i, a);
      }, r.clean = function (t, e, i, a) {
        n.cleanBasePlot(r.name, t, e, i, a);
      };
    }, {
      "../../plots/plots": 909
    }],
    1130: [function (t, e, r) {
      "use strict";

      e.exports = {
        calc: function calc(t, e) {
          var r = [],
              n = e.value;
          "number" != typeof e._lastValue && (e._lastValue = e.value);
          var i = e._lastValue,
              a = i;
          return e._hasDelta && "number" == typeof e.delta.reference && (a = e.delta.reference), r[0] = {
            y: n,
            lastY: i,
            delta: n - a,
            relativeDelta: (n - a) / a
          }, r;
        }
      };
    }, {}],
    1131: [function (t, e, r) {
      "use strict";

      e.exports = {
        defaultNumberFontSize: 80,
        bulletNumberDomainSize: .25,
        bulletPadding: .025,
        innerRadius: .75,
        valueThickness: .5,
        titlePadding: 5,
        horizontalPadding: 10
      };
    }, {}],
    1132: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./attributes"),
          a = t("../../plots/domain").defaults,
          o = t("../../plot_api/plot_template"),
          s = t("../../plots/array_container_defaults"),
          l = t("./constants.js"),
          c = t("../../plots/cartesian/tick_value_defaults"),
          u = t("../../plots/cartesian/tick_mark_defaults"),
          f = t("../../plots/cartesian/tick_label_defaults");

      function h(t, e) {
        function r(r, a) {
          return n.coerce(t, e, i.gauge.steps, r, a);
        }

        r("color"), r("line.color"), r("line.width"), r("range"), r("thickness");
      }

      e.exports = {
        supplyDefaults: function supplyDefaults(t, e, r, p) {
          function d(r, a) {
            return n.coerce(t, e, i, r, a);
          }

          a(e, p, d), d("mode"), e._hasNumber = -1 !== e.mode.indexOf("number"), e._hasDelta = -1 !== e.mode.indexOf("delta"), e._hasGauge = -1 !== e.mode.indexOf("gauge");
          var m = d("value");
          e._range = [0, "number" == typeof m ? 1.5 * m : 1];

          var g,
              v,
              y,
              x,
              b,
              _,
              w = new Array(2);

          function T(t, e) {
            return n.coerce(y, x, i.gauge, t, e);
          }

          function k(t, e) {
            return n.coerce(b, _, i.gauge.axis, t, e);
          }

          if (e._hasNumber && (d("number.valueformat"), d("number.font.color", p.font.color), d("number.font.family", p.font.family), d("number.font.size"), void 0 === e.number.font.size && (e.number.font.size = l.defaultNumberFontSize, w[0] = !0), d("number.prefix"), d("number.suffix"), g = e.number.font.size), e._hasDelta && (d("delta.font.color", p.font.color), d("delta.font.family", p.font.family), d("delta.font.size"), void 0 === e.delta.font.size && (e.delta.font.size = (e._hasNumber ? .5 : 1) * (g || l.defaultNumberFontSize), w[1] = !0), d("delta.reference", e.value), d("delta.relative"), d("delta.valueformat", e.delta.relative ? "2%" : ""), d("delta.increasing.symbol"), d("delta.increasing.color"), d("delta.decreasing.symbol"), d("delta.decreasing.color"), d("delta.position"), v = e.delta.font.size), e._scaleNumbers = (!e._hasNumber || w[0]) && (!e._hasDelta || w[1]) || !1, d("title.font.color", p.font.color), d("title.font.family", p.font.family), d("title.font.size", .25 * (g || v || l.defaultNumberFontSize)), d("title.text"), e._hasGauge) {
            (y = t.gauge) || (y = {}), x = o.newContainer(e, "gauge"), T("shape"), (e._isBullet = "bullet" === e.gauge.shape) || d("title.align", "center"), (e._isAngular = "angular" === e.gauge.shape) || d("align", "center"), T("bgcolor", p.paper_bgcolor), T("borderwidth"), T("bordercolor"), T("bar.color"), T("bar.line.color"), T("bar.line.width"), T("bar.thickness", l.valueThickness * ("bullet" === e.gauge.shape ? .5 : 1)), s(y, x, {
              name: "steps",
              handleItemDefaults: h
            }), T("threshold.value"), T("threshold.thickness"), T("threshold.line.width"), T("threshold.line.color"), b = {}, y && (b = y.axis || {}), _ = o.newContainer(x, "axis"), k("visible"), e._range = k("range", e._range);
            var M = {
              outerTicks: !0
            };
            c(b, _, k, "linear"), f(b, _, k, "linear", M), u(b, _, k, M);
          } else d("title.align", "center"), d("align", "center"), e._isAngular = e._isBullet = !1;

          e._length = null;
        }
      };
    }, {
      "../../lib": 795,
      "../../plot_api/plot_template": 834,
      "../../plots/array_container_defaults": 840,
      "../../plots/cartesian/tick_label_defaults": 866,
      "../../plots/cartesian/tick_mark_defaults": 867,
      "../../plots/cartesian/tick_value_defaults": 868,
      "../../plots/domain": 872,
      "./attributes": 1128,
      "./constants.js": 1131
    }],
    1133: [function (t, e, r) {
      "use strict";

      e.exports = {
        moduleType: "trace",
        name: "indicator",
        basePlotModule: t("./base_plot"),
        categories: ["svg", "noOpacity", "noHover"],
        animatable: !0,
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults").supplyDefaults,
        calc: t("./calc").calc,
        plot: t("./plot"),
        meta: {}
      };
    }, {
      "./attributes": 1128,
      "./base_plot": 1129,
      "./calc": 1130,
      "./defaults": 1132,
      "./plot": 1134
    }],
    1134: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../lib"),
          a = i.strScale,
          o = i.strTranslate,
          s = i.rad2deg,
          l = t("../../constants/alignment").MID_SHIFT,
          c = t("../../components/drawing"),
          u = t("./constants"),
          f = t("../../lib/svg_text_utils"),
          h = t("../../plots/cartesian/axes"),
          p = t("../../plots/cartesian/axis_defaults"),
          d = t("../../plots/cartesian/position_defaults"),
          m = t("../../plots/cartesian/layout_attributes"),
          g = t("../../components/color"),
          v = {
        left: "start",
        center: "middle",
        right: "end"
      },
          y = {
        left: 0,
        center: .5,
        right: 1
      },
          x = /[yzafpn\xb5mkMGTPEZY]/;

      function b(t) {
        return t && t.duration > 0;
      }

      function _(t) {
        t.each(function (t) {
          g.stroke(n.select(this), t.line.color);
        }).each(function (t) {
          g.fill(n.select(this), t.color);
        }).style("stroke-width", function (t) {
          return t.line.width;
        });
      }

      function w(t, e, r) {
        var n = t._fullLayout,
            a = i.extendFlat({
          type: "linear",
          ticks: "outside",
          range: r,
          showline: !0
        }, e),
            o = {
          type: "linear",
          _id: "x" + e._id
        },
            s = {
          letter: "x",
          font: n.font,
          noHover: !0,
          noTickson: !0
        };

        function l(t, e) {
          return i.coerce(a, o, m, t, e);
        }

        return p(a, o, l, s, n), d(a, o, l, s), o;
      }

      function T(t, e, r) {
        return [Math.min(e / t.width, r / t.height), t, e + "x" + r];
      }

      function k(t, e, r, i) {
        var a = document.createElementNS("http://www.w3.org/2000/svg", "text"),
            o = n.select(a);
        return o.text(t).attr("x", 0).attr("y", 0).attr("text-anchor", r).attr("data-unformatted", t).call(f.convertToTspans, i).call(c.font, e), c.bBox(o.node());
      }

      function M(t, e, r, n, a, o) {
        var s = "_cache" + e;
        t[s] && t[s].key === a || (t[s] = {
          key: a,
          value: r
        });
        var l = i.aggNums(o, null, [t[s].value, n], 2);
        return t[s].value = l, l;
      }

      e.exports = function (t, e, r, p) {
        var d,
            m = t._fullLayout;
        b(r) && p && (d = p()), i.makeTraceGroups(m._indicatorlayer, e, "trace").each(function (e) {
          var p,
              A,
              S,
              E,
              L,
              C = e[0].trace,
              P = n.select(this),
              I = C._hasGauge,
              O = C._isAngular,
              z = C._isBullet,
              D = C.domain,
              R = {
            w: m._size.w * (D.x[1] - D.x[0]),
            h: m._size.h * (D.y[1] - D.y[0]),
            l: m._size.l + m._size.w * D.x[0],
            r: m._size.r + m._size.w * (1 - D.x[1]),
            t: m._size.t + m._size.h * (1 - D.y[1]),
            b: m._size.b + m._size.h * D.y[0]
          },
              F = R.l + R.w / 2,
              B = R.t + R.h / 2,
              N = Math.min(R.w / 2, R.h),
              j = u.innerRadius * N,
              U = C.align || "center";

          if (A = B, I) {
            if (O && (p = F, A = B + N / 2, S = function S(t) {
              return function (t, e) {
                var r = Math.sqrt(t.width / 2 * (t.width / 2) + t.height * t.height);
                return [e / r, t, e];
              }(t, .9 * j);
            }), z) {
              var V = u.bulletPadding,
                  q = 1 - u.bulletNumberDomainSize + V;
              p = R.l + (q + (1 - q) * y[U]) * R.w, S = function S(t) {
                return T(t, (u.bulletNumberDomainSize - V) * R.w, R.h);
              };
            }
          } else p = R.l + y[U] * R.w, S = function S(t) {
            return T(t, R.w, R.h);
          };

          !function (t, e, r, s) {
            var l,
                u,
                p,
                d = r[0].trace,
                m = s.numbersX,
                _ = s.numbersY,
                T = d.align || "center",
                A = v[T],
                S = s.transitionOpts,
                E = s.onComplete,
                L = i.ensureSingle(e, "g", "numbers"),
                C = [];
            d._hasNumber && C.push("number");
            d._hasDelta && (C.push("delta"), "left" === d.delta.position && C.reverse());
            var P = L.selectAll("text").data(C);

            function I(e, r, n, i) {
              if (!e.match("s") || n >= 0 == i >= 0 || r(n).slice(-1).match(x) || r(i).slice(-1).match(x)) return r;
              var a = e.slice().replace("s", "f").replace(/\d+/, function (t) {
                return parseInt(t) - 1;
              }),
                  o = w(t, {
                tickformat: a
              });
              return function (t) {
                return Math.abs(t) < 1 ? h.tickText(o, t).text : r(t);
              };
            }

            P.enter().append("text"), P.attr("text-anchor", function () {
              return A;
            }).attr("class", function (t) {
              return t;
            }).attr("x", null).attr("y", null).attr("dx", null).attr("dy", null), P.exit().remove();
            var O,
                z = d.mode + d.align;
            d._hasDelta && (O = function () {
              var e = w(t, {
                tickformat: d.delta.valueformat
              }, d._range);
              e.setScale(), h.prepTicks(e);

              var i = function i(t) {
                return h.tickText(e, t).text;
              },
                  a = function a(t) {
                return d.delta.relative ? t.relativeDelta : t.delta;
              },
                  o = function o(t, e) {
                return 0 === t || "number" != typeof t || isNaN(t) ? "-" : (t > 0 ? d.delta.increasing.symbol : d.delta.decreasing.symbol) + e(t);
              },
                  s = function s(t) {
                return t.delta >= 0 ? d.delta.increasing.color : d.delta.decreasing.color;
              };

              void 0 === d._deltaLastValue && (d._deltaLastValue = a(r[0]));
              var l = L.select("text.delta");

              function p() {
                l.text(o(a(r[0]), i)).call(g.fill, s(r[0])).call(f.convertToTspans, t);
              }

              return l.call(c.font, d.delta.font).call(g.fill, s({
                delta: d._deltaLastValue
              })), b(S) ? l.transition().duration(S.duration).ease(S.easing).tween("text", function () {
                var t = n.select(this),
                    e = a(r[0]),
                    l = d._deltaLastValue,
                    c = I(d.delta.valueformat, i, l, e),
                    u = n.interpolateNumber(l, e);
                return d._deltaLastValue = e, function (e) {
                  t.text(o(u(e), c)), t.call(g.fill, s({
                    delta: u(e)
                  }));
                };
              }).each("end", function () {
                p(), E && E();
              }).each("interrupt", function () {
                p(), E && E();
              }) : p(), u = k(o(a(r[0]), i), d.delta.font, A, t), l;
            }(), z += d.delta.position + d.delta.font.size + d.delta.font.family + d.delta.valueformat, z += d.delta.increasing.symbol + d.delta.decreasing.symbol, p = u);
            d._hasNumber && (!function () {
              var e = w(t, {
                tickformat: d.number.valueformat
              }, d._range);
              e.setScale(), h.prepTicks(e);

              var i = function i(t) {
                return h.tickText(e, t).text;
              },
                  a = d.number.suffix,
                  o = d.number.prefix,
                  s = L.select("text.number");

              function u() {
                var e = "number" == typeof r[0].y ? o + i(r[0].y) + a : "-";
                s.text(e).call(c.font, d.number.font).call(f.convertToTspans, t);
              }

              b(S) ? s.transition().duration(S.duration).ease(S.easing).each("end", function () {
                u(), E && E();
              }).each("interrupt", function () {
                u(), E && E();
              }).attrTween("text", function () {
                var t = n.select(this),
                    e = n.interpolateNumber(r[0].lastY, r[0].y);
                d._lastValue = r[0].y;
                var s = I(d.number.valueformat, i, r[0].lastY, r[0].y);
                return function (r) {
                  t.text(o + s(e(r)) + a);
                };
              }) : u(), l = k(o + i(r[0].y) + a, d.number.font, A, t);
            }(), z += d.number.font.size + d.number.font.family + d.number.valueformat + d.number.suffix + d.number.prefix, p = l);

            if (d._hasDelta && d._hasNumber) {
              var D,
                  R,
                  F = [(l.left + l.right) / 2, (l.top + l.bottom) / 2],
                  B = [(u.left + u.right) / 2, (u.top + u.bottom) / 2],
                  N = .75 * d.delta.font.size;
              "left" === d.delta.position && (D = M(d, "deltaPos", 0, -1 * (l.width * y[d.align] + u.width * (1 - y[d.align]) + N), z, Math.min), R = F[1] - B[1], p = {
                width: l.width + u.width + N,
                height: Math.max(l.height, u.height),
                left: u.left + D,
                right: l.right,
                top: Math.min(l.top, u.top + R),
                bottom: Math.max(l.bottom, u.bottom + R)
              }), "right" === d.delta.position && (D = M(d, "deltaPos", 0, l.width * (1 - y[d.align]) + u.width * y[d.align] + N, z, Math.max), R = F[1] - B[1], p = {
                width: l.width + u.width + N,
                height: Math.max(l.height, u.height),
                left: l.left,
                right: u.right + D,
                top: Math.min(l.top, u.top + R),
                bottom: Math.max(l.bottom, u.bottom + R)
              }), "bottom" === d.delta.position && (D = null, R = u.height, p = {
                width: Math.max(l.width, u.width),
                height: l.height + u.height,
                left: Math.min(l.left, u.left),
                right: Math.max(l.right, u.right),
                top: l.bottom - l.height,
                bottom: l.bottom + u.height
              }), "top" === d.delta.position && (D = null, R = l.top, p = {
                width: Math.max(l.width, u.width),
                height: l.height + u.height,
                left: Math.min(l.left, u.left),
                right: Math.max(l.right, u.right),
                top: l.bottom - l.height - u.height,
                bottom: l.bottom
              }), O.attr({
                dx: D,
                dy: R
              });
            }

            (d._hasNumber || d._hasDelta) && L.attr("transform", function () {
              var t = s.numbersScaler(p);
              z += t[2];
              var e,
                  r = M(d, "numbersScale", 1, t[0], z, Math.min);
              d._scaleNumbers || (r = 1), e = d._isAngular ? _ - r * p.bottom : _ - r * (p.top + p.bottom) / 2, d._numbersTop = r * p.top + e;
              var n = p[T];
              "center" === T && (n = (p.left + p.right) / 2);
              var i = m - r * n;
              return i = M(d, "numbersTranslate", 0, i, z, Math.max), o(i, e) + a(r);
            });
          }(t, P, e, {
            numbersX: p,
            numbersY: A,
            numbersScaler: S,
            transitionOpts: r,
            onComplete: d
          }), I && (E = {
            range: C.gauge.axis.range,
            color: C.gauge.bgcolor,
            line: {
              color: C.gauge.bordercolor,
              width: 0
            },
            thickness: 1
          }, L = {
            range: C.gauge.axis.range,
            color: "rgba(0, 0, 0, 0)",
            line: {
              color: C.gauge.bordercolor,
              width: C.gauge.borderwidth
            },
            thickness: 1
          });
          var H = P.selectAll("g.angular").data(O ? e : []);
          H.exit().remove();
          var G = P.selectAll("g.angularaxis").data(O ? e : []);
          G.exit().remove(), O && function (t, e, r, i) {
            var a,
                c,
                u,
                f,
                p = r[0].trace,
                d = i.size,
                m = i.radius,
                g = i.innerRadius,
                v = i.gaugeBg,
                y = i.gaugeOutline,
                x = [d.l + d.w / 2, d.t + d.h / 2 + m / 2],
                T = i.gauge,
                k = i.layer,
                M = i.transitionOpts,
                A = i.onComplete,
                S = Math.PI / 2;

            function E(t) {
              var e = p.gauge.axis.range[0],
                  r = (t - e) / (p.gauge.axis.range[1] - e) * Math.PI - S;
              return r < -S ? -S : r > S ? S : r;
            }

            function L(t) {
              return n.svg.arc().innerRadius((g + m) / 2 - t / 2 * (m - g)).outerRadius((g + m) / 2 + t / 2 * (m - g)).startAngle(-S);
            }

            function C(t) {
              t.attr("d", function (t) {
                return L(t.thickness).startAngle(E(t.range[0])).endAngle(E(t.range[1]))();
              });
            }

            T.enter().append("g").classed("angular", !0), T.attr("transform", o(x[0], x[1])), k.enter().append("g").classed("angularaxis", !0).classed("crisp", !0), k.selectAll("g.xangularaxistick,path,text").remove(), (a = w(t, p.gauge.axis)).type = "linear", a.range = p.gauge.axis.range, a._id = "xangularaxis", a.ticklabeloverflow = "allow", a.setScale();

            var P = function P(t) {
              return (a.range[0] - t.x) / (a.range[1] - a.range[0]) * Math.PI + Math.PI;
            },
                I = {},
                O = h.makeLabelFns(a, 0).labelStandoff;

            I.xFn = function (t) {
              var e = P(t);
              return Math.cos(e) * O;
            }, I.yFn = function (t) {
              var e = P(t),
                  r = Math.sin(e) > 0 ? .2 : 1;
              return -Math.sin(e) * (O + t.fontSize * r) + Math.abs(Math.cos(e)) * (t.fontSize * l);
            }, I.anchorFn = function (t) {
              var e = P(t),
                  r = Math.cos(e);
              return Math.abs(r) < .1 ? "middle" : r > 0 ? "start" : "end";
            }, I.heightFn = function (t, e, r) {
              var n = P(t);
              return -.5 * (1 + Math.sin(n)) * r;
            };

            var z = function z(t) {
              return o(x[0] + m * Math.cos(t), x[1] - m * Math.sin(t));
            };

            u = function u(t) {
              return z(P(t));
            };

            if (c = h.calcTicks(a), f = h.getTickSigns(a)[2], a.visible) {
              f = "inside" === a.ticks ? -1 : 1;
              var D = (a.linewidth || 1) / 2;
              h.drawTicks(t, a, {
                vals: c,
                layer: k,
                path: "M" + f * D + ",0h" + f * a.ticklen,
                transFn: function transFn(t) {
                  var e = P(t);
                  return z(e) + "rotate(" + -s(e) + ")";
                }
              }), h.drawLabels(t, a, {
                vals: c,
                layer: k,
                transFn: u,
                labelFns: I
              });
            }

            var R = [v].concat(p.gauge.steps),
                F = T.selectAll("g.bg-arc").data(R);
            F.enter().append("g").classed("bg-arc", !0).append("path"), F.select("path").call(C).call(_), F.exit().remove();
            var B = L(p.gauge.bar.thickness),
                N = T.selectAll("g.value-arc").data([p.gauge.bar]);
            N.enter().append("g").classed("value-arc", !0).append("path");
            var j = N.select("path");
            b(M) ? (j.transition().duration(M.duration).ease(M.easing).each("end", function () {
              A && A();
            }).each("interrupt", function () {
              A && A();
            }).attrTween("d", (U = B, V = E(r[0].lastY), q = E(r[0].y), function () {
              var t = n.interpolate(V, q);
              return function (e) {
                return U.endAngle(t(e))();
              };
            })), p._lastValue = r[0].y) : j.attr("d", "number" == typeof r[0].y ? B.endAngle(E(r[0].y)) : "M0,0Z");
            var U, V, q;
            j.call(_), N.exit().remove(), R = [];
            var H = p.gauge.threshold.value;
            (H || 0 === H) && R.push({
              range: [H, H],
              color: p.gauge.threshold.color,
              line: {
                color: p.gauge.threshold.line.color,
                width: p.gauge.threshold.line.width
              },
              thickness: p.gauge.threshold.thickness
            });
            var G = T.selectAll("g.threshold-arc").data(R);
            G.enter().append("g").classed("threshold-arc", !0).append("path"), G.select("path").call(C).call(_), G.exit().remove();
            var Y = T.selectAll("g.gauge-outline").data([y]);
            Y.enter().append("g").classed("gauge-outline", !0).append("path"), Y.select("path").call(C).call(_), Y.exit().remove();
          }(t, 0, e, {
            radius: N,
            innerRadius: j,
            gauge: H,
            layer: G,
            size: R,
            gaugeBg: E,
            gaugeOutline: L,
            transitionOpts: r,
            onComplete: d
          });
          var Y = P.selectAll("g.bullet").data(z ? e : []);
          Y.exit().remove();
          var W = P.selectAll("g.bulletaxis").data(z ? e : []);
          W.exit().remove(), z && function (t, e, r, n) {
            var i,
                a,
                s,
                l,
                c,
                f = r[0].trace,
                p = n.gauge,
                d = n.layer,
                m = n.gaugeBg,
                v = n.gaugeOutline,
                y = n.size,
                x = f.domain,
                T = n.transitionOpts,
                k = n.onComplete;
            p.enter().append("g").classed("bullet", !0), p.attr("transform", o(y.l, y.t)), d.enter().append("g").classed("bulletaxis", !0).classed("crisp", !0), d.selectAll("g.xbulletaxistick,path,text").remove();
            var M = y.h,
                A = f.gauge.bar.thickness * M,
                S = x.x[0],
                E = x.x[0] + (x.x[1] - x.x[0]) * (f._hasNumber || f._hasDelta ? 1 - u.bulletNumberDomainSize : 1);
            (i = w(t, f.gauge.axis))._id = "xbulletaxis", i.domain = [S, E], i.setScale(), a = h.calcTicks(i), s = h.makeTransTickFn(i), l = h.getTickSigns(i)[2], c = y.t + y.h, i.visible && (h.drawTicks(t, i, {
              vals: "inside" === i.ticks ? h.clipEnds(i, a) : a,
              layer: d,
              path: h.makeTickPath(i, c, l),
              transFn: s
            }), h.drawLabels(t, i, {
              vals: a,
              layer: d,
              transFn: s,
              labelFns: h.makeLabelFns(i, c)
            }));

            function L(t) {
              t.attr("width", function (t) {
                return Math.max(0, i.c2p(t.range[1]) - i.c2p(t.range[0]));
              }).attr("x", function (t) {
                return i.c2p(t.range[0]);
              }).attr("y", function (t) {
                return .5 * (1 - t.thickness) * M;
              }).attr("height", function (t) {
                return t.thickness * M;
              });
            }

            var C = [m].concat(f.gauge.steps),
                P = p.selectAll("g.bg-bullet").data(C);
            P.enter().append("g").classed("bg-bullet", !0).append("rect"), P.select("rect").call(L).call(_), P.exit().remove();
            var I = p.selectAll("g.value-bullet").data([f.gauge.bar]);
            I.enter().append("g").classed("value-bullet", !0).append("rect"), I.select("rect").attr("height", A).attr("y", (M - A) / 2).call(_), b(T) ? I.select("rect").transition().duration(T.duration).ease(T.easing).each("end", function () {
              k && k();
            }).each("interrupt", function () {
              k && k();
            }).attr("width", Math.max(0, i.c2p(Math.min(f.gauge.axis.range[1], r[0].y)))) : I.select("rect").attr("width", "number" == typeof r[0].y ? Math.max(0, i.c2p(Math.min(f.gauge.axis.range[1], r[0].y))) : 0);
            I.exit().remove();
            var O = r.filter(function () {
              return f.gauge.threshold.value || 0 === f.gauge.threshold.value;
            }),
                z = p.selectAll("g.threshold-bullet").data(O);
            z.enter().append("g").classed("threshold-bullet", !0).append("line"), z.select("line").attr("x1", i.c2p(f.gauge.threshold.value)).attr("x2", i.c2p(f.gauge.threshold.value)).attr("y1", (1 - f.gauge.threshold.thickness) / 2 * M).attr("y2", (1 - (1 - f.gauge.threshold.thickness) / 2) * M).call(g.stroke, f.gauge.threshold.line.color).style("stroke-width", f.gauge.threshold.line.width), z.exit().remove();
            var D = p.selectAll("g.gauge-outline").data([v]);
            D.enter().append("g").classed("gauge-outline", !0).append("rect"), D.select("rect").call(L).call(_), D.exit().remove();
          }(t, 0, e, {
            gauge: Y,
            layer: W,
            size: R,
            gaugeBg: E,
            gaugeOutline: L,
            transitionOpts: r,
            onComplete: d
          });
          var X = P.selectAll("text.title").data(e);
          X.exit().remove(), X.enter().append("text").classed("title", !0), X.attr("text-anchor", function () {
            return z ? v.right : v[C.title.align];
          }).text(C.title.text).call(c.font, C.title.font).call(f.convertToTspans, t), X.attr("transform", function () {
            var t,
                e = R.l + R.w * y[C.title.align],
                r = u.titlePadding,
                n = c.bBox(X.node());

            if (I) {
              if (O) if (C.gauge.axis.visible) t = c.bBox(G.node()).top - r - n.bottom;else t = R.t + R.h / 2 - N / 2 - n.bottom - r;
              z && (t = A - (n.top + n.bottom) / 2, e = R.l - u.bulletPadding * R.w);
            } else t = C._numbersTop - r - n.bottom;

            return o(e, t);
          });
        });
      };
    }, {
      "../../components/color": 658,
      "../../components/drawing": 680,
      "../../constants/alignment": 763,
      "../../lib": 795,
      "../../lib/svg_text_utils": 820,
      "../../plots/cartesian/axes": 845,
      "../../plots/cartesian/axis_defaults": 847,
      "../../plots/cartesian/layout_attributes": 859,
      "../../plots/cartesian/position_defaults": 862,
      "./constants": 1131,
      "@plotly/d3": 57
    }],
    1135: [function (t, e, r) {
      "use strict";

      var n = t("../../components/colorscale/attributes"),
          i = t("../../plots/hoverformat_attributes"),
          a = t("../../plots/template_attributes").hovertemplateAttrs,
          o = t("../mesh3d/attributes"),
          s = t("../../plots/attributes"),
          l = t("../../lib/extend").extendFlat,
          c = t("../../plot_api/edit_types").overrideAll;
      var u = e.exports = c(l({
        x: {
          valType: "data_array"
        },
        y: {
          valType: "data_array"
        },
        z: {
          valType: "data_array"
        },
        value: {
          valType: "data_array"
        },
        isomin: {
          valType: "number"
        },
        isomax: {
          valType: "number"
        },
        surface: {
          show: {
            valType: "boolean",
            dflt: !0
          },
          count: {
            valType: "integer",
            dflt: 2,
            min: 1
          },
          fill: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: 1
          },
          pattern: {
            valType: "flaglist",
            flags: ["A", "B", "C", "D", "E"],
            extras: ["all", "odd", "even"],
            dflt: "all"
          }
        },
        spaceframe: {
          show: {
            valType: "boolean",
            dflt: !1
          },
          fill: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: .15
          }
        },
        slices: {
          x: {
            show: {
              valType: "boolean",
              dflt: !1
            },
            locations: {
              valType: "data_array",
              dflt: []
            },
            fill: {
              valType: "number",
              min: 0,
              max: 1,
              dflt: 1
            }
          },
          y: {
            show: {
              valType: "boolean",
              dflt: !1
            },
            locations: {
              valType: "data_array",
              dflt: []
            },
            fill: {
              valType: "number",
              min: 0,
              max: 1,
              dflt: 1
            }
          },
          z: {
            show: {
              valType: "boolean",
              dflt: !1
            },
            locations: {
              valType: "data_array",
              dflt: []
            },
            fill: {
              valType: "number",
              min: 0,
              max: 1,
              dflt: 1
            }
          }
        },
        caps: {
          x: {
            show: {
              valType: "boolean",
              dflt: !0
            },
            fill: {
              valType: "number",
              min: 0,
              max: 1,
              dflt: 1
            }
          },
          y: {
            show: {
              valType: "boolean",
              dflt: !0
            },
            fill: {
              valType: "number",
              min: 0,
              max: 1,
              dflt: 1
            }
          },
          z: {
            show: {
              valType: "boolean",
              dflt: !0
            },
            fill: {
              valType: "number",
              min: 0,
              max: 1,
              dflt: 1
            }
          }
        },
        text: {
          valType: "string",
          dflt: "",
          arrayOk: !0
        },
        hovertext: {
          valType: "string",
          dflt: "",
          arrayOk: !0
        },
        hovertemplate: a(),
        xhoverformat: i("x"),
        yhoverformat: i("y"),
        zhoverformat: i("z"),
        valuehoverformat: i("value", 1),
        showlegend: l({}, s.showlegend, {
          dflt: !1
        })
      }, n("", {
        colorAttr: "`value`",
        showScaleDflt: !0,
        editTypeOverride: "calc"
      }), {
        opacity: o.opacity,
        lightposition: o.lightposition,
        lighting: o.lighting,
        flatshading: o.flatshading,
        contour: o.contour,
        hoverinfo: l({}, s.hoverinfo)
      }), "calc", "nested");
      u.flatshading.dflt = !0, u.lighting.facenormalsepsilon.dflt = 0, u.x.editType = u.y.editType = u.z.editType = u.value.editType = "calc+clearAxisTypes", u.transforms = void 0;
    }, {
      "../../components/colorscale/attributes": 665,
      "../../lib/extend": 785,
      "../../plot_api/edit_types": 827,
      "../../plots/attributes": 841,
      "../../plots/hoverformat_attributes": 899,
      "../../plots/template_attributes": 918,
      "../mesh3d/attributes": 1140
    }],
    1136: [function (t, e, r) {
      "use strict";

      var n = t("../../components/colorscale/calc"),
          i = t("../streamtube/calc").processGrid,
          a = t("../streamtube/calc").filter;

      e.exports = function (t, e) {
        e._len = Math.min(e.x.length, e.y.length, e.z.length, e.value.length), e._x = a(e.x, e._len), e._y = a(e.y, e._len), e._z = a(e.z, e._len), e._value = a(e.value, e._len);
        var r = i(e);
        e._gridFill = r.fill, e._Xs = r.Xs, e._Ys = r.Ys, e._Zs = r.Zs, e._len = r.len;

        for (var o = 1 / 0, s = -1 / 0, l = 0; l < e._len; l++) {
          var c = e._value[l];
          o = Math.min(o, c), s = Math.max(s, c);
        }

        e._minValues = o, e._maxValues = s, e._vMin = void 0 === e.isomin || null === e.isomin ? o : e.isomin, e._vMax = void 0 === e.isomax || null === e.isomin ? s : e.isomax, n(t, e, {
          vals: [e._vMin, e._vMax],
          containerStr: "",
          cLetter: "c"
        });
      };
    }, {
      "../../components/colorscale/calc": 666,
      "../streamtube/calc": 1307
    }],
    1137: [function (t, e, r) {
      "use strict";

      var n = t("gl-mesh3d"),
          i = t("../../lib/gl_format_color").parseColorScale,
          a = t("../../lib/str2rgbarray"),
          o = t("../../components/colorscale").extractOpts,
          s = t("../../plots/gl3d/zip3"),
          l = function l(t, e) {
        for (var r = e.length - 1; r > 0; r--) {
          var n = Math.min(e[r], e[r - 1]),
              i = Math.max(e[r], e[r - 1]);
          if (i > n && n < t && t <= i) return {
            id: r,
            distRatio: (i - t) / (i - n)
          };
        }

        return {
          id: 0,
          distRatio: 0
        };
      };

      function c(t, e, r) {
        this.scene = t, this.uid = r, this.mesh = e, this.name = "", this.data = null, this.showContour = !1;
      }

      var u = c.prototype;
      u.handlePick = function (t) {
        if (t.object === this.mesh) {
          var e = t.data.index,
              r = this.data._meshX[e],
              n = this.data._meshY[e],
              i = this.data._meshZ[e],
              a = this.data._Ys.length,
              o = this.data._Zs.length,
              s = l(r, this.data._Xs).id,
              c = l(n, this.data._Ys).id,
              u = l(i, this.data._Zs).id,
              f = t.index = u + o * c + o * a * s;
          t.traceCoordinate = [this.data._meshX[f], this.data._meshY[f], this.data._meshZ[f], this.data._value[f]];
          var h = this.data.hovertext || this.data.text;
          return Array.isArray(h) && void 0 !== h[f] ? t.textLabel = h[f] : h && (t.textLabel = h), !0;
        }
      }, u.update = function (t) {
        var e = this.scene,
            r = e.fullSceneLayout;

        function n(t, e, r, n) {
          return e.map(function (e) {
            return t.d2l(e, 0, n) * r;
          });
        }

        this.data = h(t);
        var l = {
          positions: s(n(r.xaxis, t._meshX, e.dataScale[0], t.xcalendar), n(r.yaxis, t._meshY, e.dataScale[1], t.ycalendar), n(r.zaxis, t._meshZ, e.dataScale[2], t.zcalendar)),
          cells: s(t._meshI, t._meshJ, t._meshK),
          lightPosition: [t.lightposition.x, t.lightposition.y, t.lightposition.z],
          ambient: t.lighting.ambient,
          diffuse: t.lighting.diffuse,
          specular: t.lighting.specular,
          roughness: t.lighting.roughness,
          fresnel: t.lighting.fresnel,
          vertexNormalsEpsilon: t.lighting.vertexnormalsepsilon,
          faceNormalsEpsilon: t.lighting.facenormalsepsilon,
          opacity: t.opacity,
          contourEnable: t.contour.show,
          contourColor: a(t.contour.color).slice(0, 3),
          contourWidth: t.contour.width,
          useFacetNormals: t.flatshading
        },
            c = o(t);
        l.vertexIntensity = t._meshIntensity, l.vertexIntensityBounds = [c.min, c.max], l.colormap = i(t), this.mesh.update(l);
      }, u.dispose = function () {
        this.scene.glplot.remove(this.mesh), this.mesh.dispose();
      };
      var f = ["xyz", "xzy", "yxz", "yzx", "zxy", "zyx"];

      function h(t) {
        t._meshI = [], t._meshJ = [], t._meshK = [];

        var e,
            r,
            n,
            i,
            a,
            o,
            s,
            c = t.surface.show,
            u = t.spaceframe.show,
            h = t.surface.fill,
            p = t.spaceframe.fill,
            d = !1,
            m = !1,
            g = 0,
            v = t._Xs,
            y = t._Ys,
            x = t._Zs,
            b = v.length,
            _ = y.length,
            w = x.length,
            T = f.indexOf(t._gridFill.replace(/-/g, "").replace(/\+/g, "")),
            k = function k(t, e, r) {
          switch (T) {
            case 5:
              return r + w * e + w * _ * t;

            case 4:
              return r + w * t + w * b * e;

            case 3:
              return e + _ * r + _ * w * t;

            case 2:
              return e + _ * t + _ * b * r;

            case 1:
              return t + b * r + b * w * e;

            default:
              return t + b * e + b * _ * r;
          }
        },
            M = t._minValues,
            A = t._maxValues,
            S = t._vMin,
            E = t._vMax;

        function L(t, e, s) {
          for (var l = o.length, c = r; c < l; c++) {
            if (t === n[c] && e === i[c] && s === a[c]) return c;
          }

          return -1;
        }

        function C() {
          r = e;
        }

        function P() {
          n = [], i = [], a = [], o = [], e = 0, C();
        }

        function I(t, r, s, l) {
          return n.push(t), i.push(r), a.push(s), o.push(l), ++e - 1;
        }

        function O(t, e, r) {
          for (var n = [], i = 0; i < t.length; i++) {
            n[i] = t[i] * (1 - r) + r * e[i];
          }

          return n;
        }

        function z(t) {
          s = t;
        }

        function D(t, e) {
          return "all" === t || null === t || t.indexOf(e) > -1;
        }

        function R(t, e) {
          return null === t ? e : t;
        }

        function F(e, r, n) {
          C();
          var i,
              a,
              o,
              l = [r],
              c = [n];
          if (s >= 1) l = [r], c = [n];else if (s > 0) {
            var u = function (t, e) {
              var r = t[0],
                  n = t[1],
                  i = t[2],
                  a = function (t, e, r) {
                for (var n = [], i = 0; i < t.length; i++) {
                  n[i] = (t[i] + e[i] + r[i]) / 3;
                }

                return n;
              }(r, n, i),
                  o = Math.sqrt(1 - s),
                  l = O(a, r, o),
                  c = O(a, n, o),
                  u = O(a, i, o),
                  f = e[0],
                  h = e[1],
                  p = e[2];

              return {
                xyzv: [[r, n, c], [c, l, r], [n, i, u], [u, c, n], [i, r, l], [l, u, i]],
                abc: [[f, h, -1], [-1, -1, f], [h, p, -1], [-1, -1, h], [p, f, -1], [-1, -1, p]]
              };
            }(r, n);

            l = u.xyzv, c = u.abc;
          }

          for (var f = 0; f < l.length; f++) {
            r = l[f], n = c[f];

            for (var h = [], p = 0; p < 3; p++) {
              var d = r[p][0],
                  m = r[p][1],
                  v = r[p][2],
                  y = r[p][3],
                  x = n[p] > -1 ? n[p] : L(d, m, v);
              h[p] = x > -1 ? x : I(d, m, v, R(e, y));
            }

            i = h[0], a = h[1], o = h[2], t._meshI.push(i), t._meshJ.push(a), t._meshK.push(o), ++g;
          }
        }

        function B(t, e, r, n) {
          var i = t[3];
          i < r && (i = r), i > n && (i = n);

          for (var a = (t[3] - i) / (t[3] - e[3] + 1e-9), o = [], s = 0; s < 4; s++) {
            o[s] = (1 - a) * t[s] + a * e[s];
          }

          return o;
        }

        function N(t, e, r) {
          return t >= e && t <= r;
        }

        function j(t) {
          var e = .001 * (E - S);
          return t >= S - e && t <= E + e;
        }

        function U(e) {
          for (var r = [], n = 0; n < 4; n++) {
            var i = e[n];
            r.push([t._x[i], t._y[i], t._z[i], t._value[i]]);
          }

          return r;
        }

        function V(t, e, r, n, i, a) {
          a || (a = 1), r = [-1, -1, -1];
          var o = !1,
              s = [N(e[0][3], n, i), N(e[1][3], n, i), N(e[2][3], n, i)];
          if (!s[0] && !s[1] && !s[2]) return !1;

          var l = function l(t, e, r) {
            return j(e[0][3]) && j(e[1][3]) && j(e[2][3]) ? (F(t, e, r), !0) : a < 3 && V(t, e, r, S, E, ++a);
          };

          if (s[0] && s[1] && s[2]) return l(t, e, r) || o;
          var c = !1;
          return [[0, 1, 2], [2, 0, 1], [1, 2, 0]].forEach(function (a) {
            if (s[a[0]] && s[a[1]] && !s[a[2]]) {
              var u = e[a[0]],
                  f = e[a[1]],
                  h = e[a[2]],
                  p = B(h, u, n, i),
                  d = B(h, f, n, i);
              o = l(t, [d, p, u], [-1, -1, r[a[0]]]) || o, o = l(t, [u, f, d], [r[a[0]], r[a[1]], -1]) || o, c = !0;
            }
          }), c || [[0, 1, 2], [1, 2, 0], [2, 0, 1]].forEach(function (a) {
            if (s[a[0]] && !s[a[1]] && !s[a[2]]) {
              var u = e[a[0]],
                  f = e[a[1]],
                  h = e[a[2]],
                  p = B(f, u, n, i),
                  d = B(h, u, n, i);
              o = l(t, [d, p, u], [-1, -1, r[a[0]]]) || o, c = !0;
            }
          }), o;
        }

        function q(t, e, r, n) {
          var i = !1,
              a = U(e),
              o = [N(a[0][3], r, n), N(a[1][3], r, n), N(a[2][3], r, n), N(a[3][3], r, n)];
          if (!(o[0] || o[1] || o[2] || o[3])) return i;
          if (o[0] && o[1] && o[2] && o[3]) return m && (i = function (t, e, r) {
            var n = function n(_n4, i, a) {
              F(t, [e[_n4], e[i], e[a]], [r[_n4], r[i], r[a]]);
            };

            n(0, 1, 2), n(3, 0, 1), n(2, 3, 0), n(1, 2, 3);
          }(t, a, e) || i), i;
          var s = !1;
          return [[0, 1, 2, 3], [3, 0, 1, 2], [2, 3, 0, 1], [1, 2, 3, 0]].forEach(function (l) {
            if (o[l[0]] && o[l[1]] && o[l[2]] && !o[l[3]]) {
              var c = a[l[0]],
                  u = a[l[1]],
                  f = a[l[2]],
                  h = a[l[3]];
              if (m) i = F(t, [c, u, f], [e[l[0]], e[l[1]], e[l[2]]]) || i;else {
                var p = B(h, c, r, n),
                    d = B(h, u, r, n),
                    g = B(h, f, r, n);
                i = F(null, [p, d, g], [-1, -1, -1]) || i;
              }
              s = !0;
            }
          }), s ? i : ([[0, 1, 2, 3], [1, 2, 3, 0], [2, 3, 0, 1], [3, 0, 1, 2], [0, 2, 3, 1], [1, 3, 2, 0]].forEach(function (l) {
            if (o[l[0]] && o[l[1]] && !o[l[2]] && !o[l[3]]) {
              var c = a[l[0]],
                  u = a[l[1]],
                  f = a[l[2]],
                  h = a[l[3]],
                  p = B(f, c, r, n),
                  d = B(f, u, r, n),
                  g = B(h, u, r, n),
                  v = B(h, c, r, n);
              m ? (i = F(t, [c, v, p], [e[l[0]], -1, -1]) || i, i = F(t, [u, d, g], [e[l[1]], -1, -1]) || i) : i = function (t, e, r) {
                var n = function n(_n5, i, a) {
                  F(t, [e[_n5], e[i], e[a]], [r[_n5], r[i], r[a]]);
                };

                n(0, 1, 2), n(2, 3, 0);
              }(null, [p, d, g, v], [-1, -1, -1, -1]) || i, s = !0;
            }
          }), s || [[0, 1, 2, 3], [1, 2, 3, 0], [2, 3, 0, 1], [3, 0, 1, 2]].forEach(function (l) {
            if (o[l[0]] && !o[l[1]] && !o[l[2]] && !o[l[3]]) {
              var c = a[l[0]],
                  u = a[l[1]],
                  f = a[l[2]],
                  h = a[l[3]],
                  p = B(u, c, r, n),
                  d = B(f, c, r, n),
                  g = B(h, c, r, n);
              m ? (i = F(t, [c, p, d], [e[l[0]], -1, -1]) || i, i = F(t, [c, d, g], [e[l[0]], -1, -1]) || i, i = F(t, [c, g, p], [e[l[0]], -1, -1]) || i) : i = F(null, [p, d, g], [-1, -1, -1]) || i, s = !0;
            }
          }), i);
        }

        function H(t, e, r, n, i, a, o, s, l, c, u) {
          var f = !1;
          return d && (D(t, "A") && (f = q(null, [e, r, n, a], c, u) || f), D(t, "B") && (f = q(null, [r, n, i, l], c, u) || f), D(t, "C") && (f = q(null, [r, a, o, l], c, u) || f), D(t, "D") && (f = q(null, [n, a, s, l], c, u) || f), D(t, "E") && (f = q(null, [r, n, a, l], c, u) || f)), m && (f = q(t, [r, n, a, l], c, u) || f), f;
        }

        function G(t, e, r, n, i, a, o, s) {
          return [!0 === s[0] || V(t, U([e, r, n]), [e, r, n], a, o), !0 === s[1] || V(t, U([n, i, e]), [n, i, e], a, o)];
        }

        function Y(t, e, r, n, i, a, o, s, l) {
          return s ? G(t, e, r, i, n, a, o, l) : G(t, r, i, n, e, a, o, l);
        }

        function W(t, e, r, n, i, a, o) {
          var s,
              l,
              c,
              u,
              f = !1,
              h = function h() {
            f = V(t, [s, l, c], [-1, -1, -1], i, a) || f, f = V(t, [c, u, s], [-1, -1, -1], i, a) || f;
          },
              p = o[0],
              d = o[1],
              m = o[2];

          return p && (s = O(U([k(e, r - 0, n - 0)])[0], U([k(e - 1, r - 0, n - 0)])[0], p), l = O(U([k(e, r - 0, n - 1)])[0], U([k(e - 1, r - 0, n - 1)])[0], p), c = O(U([k(e, r - 1, n - 1)])[0], U([k(e - 1, r - 1, n - 1)])[0], p), u = O(U([k(e, r - 1, n - 0)])[0], U([k(e - 1, r - 1, n - 0)])[0], p), h()), d && (s = O(U([k(e - 0, r, n - 0)])[0], U([k(e - 0, r - 1, n - 0)])[0], d), l = O(U([k(e - 0, r, n - 1)])[0], U([k(e - 0, r - 1, n - 1)])[0], d), c = O(U([k(e - 1, r, n - 1)])[0], U([k(e - 1, r - 1, n - 1)])[0], d), u = O(U([k(e - 1, r, n - 0)])[0], U([k(e - 1, r - 1, n - 0)])[0], d), h()), m && (s = O(U([k(e - 0, r - 0, n)])[0], U([k(e - 0, r - 0, n - 1)])[0], m), l = O(U([k(e - 0, r - 1, n)])[0], U([k(e - 0, r - 1, n - 1)])[0], m), c = O(U([k(e - 1, r - 1, n)])[0], U([k(e - 1, r - 1, n - 1)])[0], m), u = O(U([k(e - 1, r - 0, n)])[0], U([k(e - 1, r - 0, n - 1)])[0], m), h()), f;
        }

        function X(t, e, r, n, i, a, o, s, l, c, u, f) {
          var h = t;
          return f ? (d && "even" === t && (h = null), H(h, e, r, n, i, a, o, s, l, c, u)) : (d && "odd" === t && (h = null), H(h, l, s, o, a, i, n, r, e, c, u));
        }

        function Z(t, e, r, n, i) {
          for (var a = [], o = 0, s = 0; s < e.length; s++) {
            for (var l = e[s], c = 1; c < w; c++) {
              for (var u = 1; u < _; u++) {
                a.push(Y(t, k(l, u - 1, c - 1), k(l, u - 1, c), k(l, u, c - 1), k(l, u, c), r, n, (l + u + c) % 2, i && i[o] ? i[o] : [])), o++;
              }
            }
          }

          return a;
        }

        function J(t, e, r, n, i) {
          for (var a = [], o = 0, s = 0; s < e.length; s++) {
            for (var l = e[s], c = 1; c < b; c++) {
              for (var u = 1; u < w; u++) {
                a.push(Y(t, k(c - 1, l, u - 1), k(c, l, u - 1), k(c - 1, l, u), k(c, l, u), r, n, (c + l + u) % 2, i && i[o] ? i[o] : [])), o++;
              }
            }
          }

          return a;
        }

        function K(t, e, r, n, i) {
          for (var a = [], o = 0, s = 0; s < e.length; s++) {
            for (var l = e[s], c = 1; c < _; c++) {
              for (var u = 1; u < b; u++) {
                a.push(Y(t, k(u - 1, c - 1, l), k(u - 1, c, l), k(u, c - 1, l), k(u, c, l), r, n, (u + c + l) % 2, i && i[o] ? i[o] : [])), o++;
              }
            }
          }

          return a;
        }

        function Q(t, e, r) {
          for (var n = 1; n < w; n++) {
            for (var i = 1; i < _; i++) {
              for (var a = 1; a < b; a++) {
                X(t, k(a - 1, i - 1, n - 1), k(a - 1, i - 1, n), k(a - 1, i, n - 1), k(a - 1, i, n), k(a, i - 1, n - 1), k(a, i - 1, n), k(a, i, n - 1), k(a, i, n), e, r, (a + i + n) % 2);
              }
            }
          }
        }

        function $(t, e, r) {
          d = !0, Q(t, e, r), d = !1;
        }

        function tt(t, e, r, n, i, a) {
          for (var o = [], s = 0, l = 0; l < e.length; l++) {
            for (var c = e[l], u = 1; u < w; u++) {
              for (var f = 1; f < _; f++) {
                o.push(W(t, c, f, u, r, n, i[l], a && a[s] && a[s])), s++;
              }
            }
          }

          return o;
        }

        function et(t, e, r, n, i, a) {
          for (var o = [], s = 0, l = 0; l < e.length; l++) {
            for (var c = e[l], u = 1; u < b; u++) {
              for (var f = 1; f < w; f++) {
                o.push(W(t, u, c, f, r, n, i[l], a && a[s] && a[s])), s++;
              }
            }
          }

          return o;
        }

        function rt(t, e, r, n, i, a) {
          for (var o = [], s = 0, l = 0; l < e.length; l++) {
            for (var c = e[l], u = 1; u < _; u++) {
              for (var f = 1; f < b; f++) {
                o.push(W(t, f, u, c, r, n, i[l], a && a[s] && a[s])), s++;
              }
            }
          }

          return o;
        }

        function nt(t, e) {
          for (var r = [], n = t; n < e; n++) {
            r.push(n);
          }

          return r;
        }

        return function () {
          if (P(), function () {
            for (var e = 0; e < b; e++) {
              for (var r = 0; r < _; r++) {
                for (var n = 0; n < w; n++) {
                  var i = k(e, r, n);
                  I(t._x[i], t._y[i], t._z[i], t._value[i]);
                }
              }
            }
          }(), u && p && (z(p), m = !0, Q(null, S, E), m = !1), c && h) {
            z(h);

            for (var e = t.surface.pattern, r = t.surface.count, s = 0; s < r; s++) {
              var f = 1 === r ? .5 : s / (r - 1),
                  d = (1 - f) * S + f * E,
                  T = Math.abs(d - M) > Math.abs(d - A) ? [M, d] : [d, A];
              $(e, T[0], T[1]);
            }
          }

          var L = [[Math.min(S, A), Math.max(S, A)], [Math.min(M, E), Math.max(M, E)]];
          ["x", "y", "z"].forEach(function (e) {
            for (var r = [], n = 0; n < L.length; n++) {
              var i = 0,
                  a = L[n][0],
                  o = L[n][1],
                  s = t.slices[e];

              if (s.show && s.fill) {
                z(s.fill);
                var c = [],
                    u = [],
                    f = [];
                if (s.locations.length) for (var h = 0; h < s.locations.length; h++) {
                  var p = l(s.locations[h], "x" === e ? v : "y" === e ? y : x);
                  0 === p.distRatio ? c.push(p.id) : p.id > 0 && (u.push(p.id), "x" === e ? f.push([p.distRatio, 0, 0]) : "y" === e ? f.push([0, p.distRatio, 0]) : f.push([0, 0, p.distRatio]));
                } else c = nt(1, "x" === e ? b - 1 : "y" === e ? _ - 1 : w - 1);
                u.length > 0 && (r[i] = "x" === e ? tt(null, u, a, o, f, r[i]) : "y" === e ? et(null, u, a, o, f, r[i]) : rt(null, u, a, o, f, r[i]), i++), c.length > 0 && (r[i] = "x" === e ? Z(null, c, a, o, r[i]) : "y" === e ? J(null, c, a, o, r[i]) : K(null, c, a, o, r[i]), i++);
              }

              var d = t.caps[e];
              d.show && d.fill && (z(d.fill), r[i] = "x" === e ? Z(null, [0, b - 1], a, o, r[i]) : "y" === e ? J(null, [0, _ - 1], a, o, r[i]) : K(null, [0, w - 1], a, o, r[i]), i++);
            }
          }), 0 === g && P(), t._meshX = n, t._meshY = i, t._meshZ = a, t._meshIntensity = o, t._Xs = v, t._Ys = y, t._Zs = x;
        }(), t;
      }

      e.exports = {
        findNearestOnAxis: l,
        generateIsoMeshes: h,
        createIsosurfaceTrace: function createIsosurfaceTrace(t, e) {
          var r = t.glplot.gl,
              i = n({
            gl: r
          }),
              a = new c(t, i, e.uid);
          return i._trace = a, a.update(e), t.glplot.add(i), a;
        }
      };
    }, {
      "../../components/colorscale": 670,
      "../../lib/gl_format_color": 791,
      "../../lib/str2rgbarray": 819,
      "../../plots/gl3d/zip3": 898,
      "gl-mesh3d": 306
    }],
    1138: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../registry"),
          a = t("./attributes"),
          o = t("../../components/colorscale/defaults");

      function s(t, e, r, n, a) {
        var s = a("isomin"),
            l = a("isomax");
        null != l && null != s && s > l && (e.isomin = null, e.isomax = null);
        var c = a("x"),
            u = a("y"),
            f = a("z"),
            h = a("value");
        c && c.length && u && u.length && f && f.length && h && h.length ? (i.getComponentMethod("calendars", "handleTraceDefaults")(t, e, ["x", "y", "z"], n), a("valuehoverformat"), ["x", "y", "z"].forEach(function (t) {
          a(t + "hoverformat");
          var e = "caps." + t;
          a(e + ".show") && a(e + ".fill");
          var r = "slices." + t;
          a(r + ".show") && (a(r + ".fill"), a(r + ".locations"));
        }), a("spaceframe.show") && a("spaceframe.fill"), a("surface.show") && (a("surface.count"), a("surface.fill"), a("surface.pattern")), a("contour.show") && (a("contour.color"), a("contour.width")), ["text", "hovertext", "hovertemplate", "lighting.ambient", "lighting.diffuse", "lighting.specular", "lighting.roughness", "lighting.fresnel", "lighting.vertexnormalsepsilon", "lighting.facenormalsepsilon", "lightposition.x", "lightposition.y", "lightposition.z", "flatshading", "opacity"].forEach(function (t) {
          a(t);
        }), o(t, e, n, a, {
          prefix: "",
          cLetter: "c"
        }), e._length = null) : e.visible = !1;
      }

      e.exports = {
        supplyDefaults: function supplyDefaults(t, e, r, i) {
          s(t, e, r, i, function (r, i) {
            return n.coerce(t, e, a, r, i);
          });
        },
        supplyIsoDefaults: s
      };
    }, {
      "../../components/colorscale/defaults": 668,
      "../../lib": 795,
      "../../registry": 923,
      "./attributes": 1135
    }],
    1139: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults").supplyDefaults,
        calc: t("./calc"),
        colorbar: {
          min: "cmin",
          max: "cmax"
        },
        plot: t("./convert").createIsosurfaceTrace,
        moduleType: "trace",
        name: "isosurface",
        basePlotModule: t("../../plots/gl3d"),
        categories: ["gl3d", "showLegend"],
        meta: {}
      };
    }, {
      "../../plots/gl3d": 887,
      "./attributes": 1135,
      "./calc": 1136,
      "./convert": 1137,
      "./defaults": 1138
    }],
    1140: [function (t, e, r) {
      "use strict";

      var n = t("../../components/colorscale/attributes"),
          i = t("../../plots/hoverformat_attributes"),
          a = t("../../plots/template_attributes").hovertemplateAttrs,
          o = t("../surface/attributes"),
          s = t("../../plots/attributes"),
          l = t("../../lib/extend").extendFlat;
      e.exports = l({
        x: {
          valType: "data_array",
          editType: "calc+clearAxisTypes"
        },
        y: {
          valType: "data_array",
          editType: "calc+clearAxisTypes"
        },
        z: {
          valType: "data_array",
          editType: "calc+clearAxisTypes"
        },
        i: {
          valType: "data_array",
          editType: "calc"
        },
        j: {
          valType: "data_array",
          editType: "calc"
        },
        k: {
          valType: "data_array",
          editType: "calc"
        },
        text: {
          valType: "string",
          dflt: "",
          arrayOk: !0,
          editType: "calc"
        },
        hovertext: {
          valType: "string",
          dflt: "",
          arrayOk: !0,
          editType: "calc"
        },
        hovertemplate: a({
          editType: "calc"
        }),
        xhoverformat: i("x"),
        yhoverformat: i("y"),
        zhoverformat: i("z"),
        delaunayaxis: {
          valType: "enumerated",
          values: ["x", "y", "z"],
          dflt: "z",
          editType: "calc"
        },
        alphahull: {
          valType: "number",
          dflt: -1,
          editType: "calc"
        },
        intensity: {
          valType: "data_array",
          editType: "calc"
        },
        intensitymode: {
          valType: "enumerated",
          values: ["vertex", "cell"],
          dflt: "vertex",
          editType: "calc"
        },
        color: {
          valType: "color",
          editType: "calc"
        },
        vertexcolor: {
          valType: "data_array",
          editType: "calc"
        },
        facecolor: {
          valType: "data_array",
          editType: "calc"
        },
        transforms: void 0
      }, n("", {
        colorAttr: "`intensity`",
        showScaleDflt: !0,
        editTypeOverride: "calc"
      }), {
        opacity: o.opacity,
        flatshading: {
          valType: "boolean",
          dflt: !1,
          editType: "calc"
        },
        contour: {
          show: l({}, o.contours.x.show, {}),
          color: o.contours.x.color,
          width: o.contours.x.width,
          editType: "calc"
        },
        lightposition: {
          x: l({}, o.lightposition.x, {
            dflt: 1e5
          }),
          y: l({}, o.lightposition.y, {
            dflt: 1e5
          }),
          z: l({}, o.lightposition.z, {
            dflt: 0
          }),
          editType: "calc"
        },
        lighting: l({
          vertexnormalsepsilon: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: 1e-12,
            editType: "calc"
          },
          facenormalsepsilon: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: 1e-6,
            editType: "calc"
          },
          editType: "calc"
        }, o.lighting),
        hoverinfo: l({}, s.hoverinfo, {
          editType: "calc"
        }),
        showlegend: l({}, s.showlegend, {
          dflt: !1
        })
      });
    }, {
      "../../components/colorscale/attributes": 665,
      "../../lib/extend": 785,
      "../../plots/attributes": 841,
      "../../plots/hoverformat_attributes": 899,
      "../../plots/template_attributes": 918,
      "../surface/attributes": 1323
    }],
    1141: [function (t, e, r) {
      "use strict";

      var n = t("../../components/colorscale/calc");

      e.exports = function (t, e) {
        e.intensity && n(t, e, {
          vals: e.intensity,
          containerStr: "",
          cLetter: "c"
        });
      };
    }, {
      "../../components/colorscale/calc": 666
    }],
    1142: [function (t, e, r) {
      "use strict";

      var n = t("gl-mesh3d"),
          i = t("delaunay-triangulate"),
          a = t("alpha-shape"),
          o = t("convex-hull"),
          s = t("../../lib/gl_format_color").parseColorScale,
          l = t("../../lib/str2rgbarray"),
          c = t("../../components/colorscale").extractOpts,
          u = t("../../plots/gl3d/zip3");

      function f(t, e, r) {
        this.scene = t, this.uid = r, this.mesh = e, this.name = "", this.color = "#fff", this.data = null, this.showContour = !1;
      }

      var h = f.prototype;

      function p(t) {
        for (var e = [], r = t.length, n = 0; n < r; n++) {
          e[n] = l(t[n]);
        }

        return e;
      }

      function d(t, e, r, n) {
        for (var i = [], a = e.length, o = 0; o < a; o++) {
          i[o] = t.d2l(e[o], 0, n) * r;
        }

        return i;
      }

      function m(t) {
        for (var e = [], r = t.length, n = 0; n < r; n++) {
          e[n] = Math.round(t[n]);
        }

        return e;
      }

      function g(t, e) {
        for (var r = t.length, n = 0; n < r; n++) {
          if (t[n] <= -.5 || t[n] >= e - .5) return !1;
        }

        return !0;
      }

      h.handlePick = function (t) {
        if (t.object === this.mesh) {
          var e = t.index = t.data.index;
          t.data._cellCenter ? t.traceCoordinate = t.data.dataCoordinate : t.traceCoordinate = [this.data.x[e], this.data.y[e], this.data.z[e]];
          var r = this.data.hovertext || this.data.text;
          return Array.isArray(r) && void 0 !== r[e] ? t.textLabel = r[e] : r && (t.textLabel = r), !0;
        }
      }, h.update = function (t) {
        var e = this.scene,
            r = e.fullSceneLayout;
        this.data = t;
        var n,
            f = t.x.length,
            h = u(d(r.xaxis, t.x, e.dataScale[0], t.xcalendar), d(r.yaxis, t.y, e.dataScale[1], t.ycalendar), d(r.zaxis, t.z, e.dataScale[2], t.zcalendar));

        if (t.i && t.j && t.k) {
          if (t.i.length !== t.j.length || t.j.length !== t.k.length || !g(t.i, f) || !g(t.j, f) || !g(t.k, f)) return;
          n = u(m(t.i), m(t.j), m(t.k));
        } else n = 0 === t.alphahull ? o(h) : t.alphahull > 0 ? a(t.alphahull, h) : function (t, e) {
          for (var r = ["x", "y", "z"].indexOf(t), n = [], a = e.length, o = 0; o < a; o++) {
            n[o] = [e[o][(r + 1) % 3], e[o][(r + 2) % 3]];
          }

          return i(n);
        }(t.delaunayaxis, h);

        var v = {
          positions: h,
          cells: n,
          lightPosition: [t.lightposition.x, t.lightposition.y, t.lightposition.z],
          ambient: t.lighting.ambient,
          diffuse: t.lighting.diffuse,
          specular: t.lighting.specular,
          roughness: t.lighting.roughness,
          fresnel: t.lighting.fresnel,
          vertexNormalsEpsilon: t.lighting.vertexnormalsepsilon,
          faceNormalsEpsilon: t.lighting.facenormalsepsilon,
          opacity: t.opacity,
          contourEnable: t.contour.show,
          contourColor: l(t.contour.color).slice(0, 3),
          contourWidth: t.contour.width,
          useFacetNormals: t.flatshading
        };

        if (t.intensity) {
          var y = c(t);
          this.color = "#fff";
          var x = t.intensitymode;
          v[x + "Intensity"] = t.intensity, v[x + "IntensityBounds"] = [y.min, y.max], v.colormap = s(t);
        } else t.vertexcolor ? (this.color = t.vertexcolor[0], v.vertexColors = p(t.vertexcolor)) : t.facecolor ? (this.color = t.facecolor[0], v.cellColors = p(t.facecolor)) : (this.color = t.color, v.meshColor = l(t.color));

        this.mesh.update(v);
      }, h.dispose = function () {
        this.scene.glplot.remove(this.mesh), this.mesh.dispose();
      }, e.exports = function (t, e) {
        var r = t.glplot.gl,
            i = n({
          gl: r
        }),
            a = new f(t, i, e.uid);
        return i._trace = a, a.update(e), t.glplot.add(i), a;
      };
    }, {
      "../../components/colorscale": 670,
      "../../lib/gl_format_color": 791,
      "../../lib/str2rgbarray": 819,
      "../../plots/gl3d/zip3": 898,
      "alpha-shape": 70,
      "convex-hull": 136,
      "delaunay-triangulate": 171,
      "gl-mesh3d": 306
    }],
    1143: [function (t, e, r) {
      "use strict";

      var n = t("../../registry"),
          i = t("../../lib"),
          a = t("../../components/colorscale/defaults"),
          o = t("./attributes");

      e.exports = function (t, e, r, s) {
        function l(r, n) {
          return i.coerce(t, e, o, r, n);
        }

        function c(t) {
          var e = t.map(function (t) {
            var e = l(t);
            return e && i.isArrayOrTypedArray(e) ? e : null;
          });
          return e.every(function (t) {
            return t && t.length === e[0].length;
          }) && e;
        }

        c(["x", "y", "z"]) ? (c(["i", "j", "k"]), (!e.i || e.j && e.k) && (!e.j || e.k && e.i) && (!e.k || e.i && e.j) ? (n.getComponentMethod("calendars", "handleTraceDefaults")(t, e, ["x", "y", "z"], s), ["lighting.ambient", "lighting.diffuse", "lighting.specular", "lighting.roughness", "lighting.fresnel", "lighting.vertexnormalsepsilon", "lighting.facenormalsepsilon", "lightposition.x", "lightposition.y", "lightposition.z", "flatshading", "alphahull", "delaunayaxis", "opacity"].forEach(function (t) {
          l(t);
        }), l("contour.show") && (l("contour.color"), l("contour.width")), "intensity" in t ? (l("intensity"), l("intensitymode"), a(t, e, s, l, {
          prefix: "",
          cLetter: "c"
        })) : (e.showscale = !1, "facecolor" in t ? l("facecolor") : "vertexcolor" in t ? l("vertexcolor") : l("color", r)), l("text"), l("hovertext"), l("hovertemplate"), l("xhoverformat"), l("yhoverformat"), l("zhoverformat"), e._length = null) : e.visible = !1) : e.visible = !1;
      };
    }, {
      "../../components/colorscale/defaults": 668,
      "../../lib": 795,
      "../../registry": 923,
      "./attributes": 1140
    }],
    1144: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        calc: t("./calc"),
        colorbar: {
          min: "cmin",
          max: "cmax"
        },
        plot: t("./convert"),
        moduleType: "trace",
        name: "mesh3d",
        basePlotModule: t("../../plots/gl3d"),
        categories: ["gl3d", "showLegend"],
        meta: {}
      };
    }, {
      "../../plots/gl3d": 887,
      "./attributes": 1140,
      "./calc": 1141,
      "./convert": 1142,
      "./defaults": 1143
    }],
    1145: [function (t, e, r) {
      "use strict";

      var n = t("../../lib").extendFlat,
          i = t("../scatter/attributes"),
          a = t("../../plots/hoverformat_attributes"),
          o = t("../../components/drawing/attributes").dash,
          s = t("../../components/fx/attributes"),
          l = t("../../constants/delta.js"),
          c = l.INCREASING.COLOR,
          u = l.DECREASING.COLOR,
          f = i.line;

      function h(t) {
        return {
          line: {
            color: n({}, f.color, {
              dflt: t
            }),
            width: f.width,
            dash: o,
            editType: "style"
          },
          editType: "style"
        };
      }

      e.exports = {
        xperiod: i.xperiod,
        xperiod0: i.xperiod0,
        xperiodalignment: i.xperiodalignment,
        xhoverformat: a("x"),
        yhoverformat: a("y"),
        x: {
          valType: "data_array",
          editType: "calc+clearAxisTypes"
        },
        open: {
          valType: "data_array",
          editType: "calc"
        },
        high: {
          valType: "data_array",
          editType: "calc"
        },
        low: {
          valType: "data_array",
          editType: "calc"
        },
        close: {
          valType: "data_array",
          editType: "calc"
        },
        line: {
          width: n({}, f.width, {}),
          dash: n({}, o, {}),
          editType: "style"
        },
        increasing: h(c),
        decreasing: h(u),
        text: {
          valType: "string",
          dflt: "",
          arrayOk: !0,
          editType: "calc"
        },
        hovertext: {
          valType: "string",
          dflt: "",
          arrayOk: !0,
          editType: "calc"
        },
        tickwidth: {
          valType: "number",
          min: 0,
          max: .5,
          dflt: .3,
          editType: "calc"
        },
        hoverlabel: n({}, s.hoverlabel, {
          split: {
            valType: "boolean",
            dflt: !1,
            editType: "style"
          }
        })
      };
    }, {
      "../../components/drawing/attributes": 679,
      "../../components/fx/attributes": 689,
      "../../constants/delta.js": 765,
      "../../lib": 795,
      "../../plots/hoverformat_attributes": 899,
      "../scatter/attributes": 1199
    }],
    1146: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = n._,
          a = t("../../plots/cartesian/axes"),
          o = t("../../plots/cartesian/align_period"),
          s = t("../../constants/numerical").BADNUM;

      function l(t, e, r, n) {
        return {
          o: t,
          h: e,
          l: r,
          c: n
        };
      }

      function c(t, e, r, o, l, c) {
        for (var u = l.makeCalcdata(e, "open"), f = l.makeCalcdata(e, "high"), h = l.makeCalcdata(e, "low"), p = l.makeCalcdata(e, "close"), d = Array.isArray(e.text), m = Array.isArray(e.hovertext), g = !0, v = null, y = !!e.xperiodalignment, x = [], b = 0; b < o.length; b++) {
          var _ = o[b],
              w = u[b],
              T = f[b],
              k = h[b],
              M = p[b];

          if (_ !== s && w !== s && T !== s && k !== s && M !== s) {
            M === w ? null !== v && M !== v && (g = M > v) : g = M > w, v = M;
            var A = c(w, T, k, M);
            A.pos = _, A.yc = (w + M) / 2, A.i = b, A.dir = g ? "increasing" : "decreasing", A.x = A.pos, A.y = [k, T], y && (A.orig_p = r[b]), d && (A.tx = e.text[b]), m && (A.htx = e.hovertext[b]), x.push(A);
          } else x.push({
            pos: _,
            empty: !0
          });
        }

        return e._extremes[l._id] = a.findExtremes(l, n.concat(h, f), {
          padded: !0
        }), x.length && (x[0].t = {
          labels: {
            open: i(t, "open:") + " ",
            high: i(t, "high:") + " ",
            low: i(t, "low:") + " ",
            close: i(t, "close:") + " "
          }
        }), x;
      }

      e.exports = {
        calc: function calc(t, e) {
          var r = a.getFromId(t, e.xaxis),
              i = a.getFromId(t, e.yaxis),
              s = function (t, e, r) {
            var i = r._minDiff;

            if (!i) {
              var a,
                  s = t._fullData,
                  l = [];

              for (i = 1 / 0, a = 0; a < s.length; a++) {
                var c = s[a];

                if ("ohlc" === c.type && !0 === c.visible && c.xaxis === e._id) {
                  l.push(c);
                  var u = e.makeCalcdata(c, "x");
                  c._origX = u;
                  var f = o(r, e, "x", u);
                  c._xcalc = f;
                  var h = n.distinctVals(f).minDiff;
                  h && isFinite(h) && (i = Math.min(i, h));
                }
              }

              for (i === 1 / 0 && (i = 1), a = 0; a < l.length; a++) {
                l[a]._minDiff = i;
              }
            }

            return i * r.tickwidth;
          }(t, r, e),
              u = e._minDiff;

          e._minDiff = null;
          var f = e._origX;
          e._origX = null;
          var h = e._xcalc;
          e._xcalc = null;
          var p = c(t, e, f, h, i, l);
          return e._extremes[r._id] = a.findExtremes(r, h, {
            vpad: u / 2
          }), p.length ? (n.extendFlat(p[0].t, {
            wHover: u / 2,
            tickLen: s
          }), p) : [{
            t: {
              empty: !0
            }
          }];
        },
        calcCommon: c
      };
    }, {
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../../plots/cartesian/align_period": 842,
      "../../plots/cartesian/axes": 845
    }],
    1147: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./ohlc_defaults"),
          a = t("../scatter/period_defaults"),
          o = t("./attributes");

      function s(t, e, r, n) {
        r(n + ".line.color"), r(n + ".line.width", e.line.width), r(n + ".line.dash", e.line.dash);
      }

      e.exports = function (t, e, r, l) {
        function c(r, i) {
          return n.coerce(t, e, o, r, i);
        }

        i(t, e, c, l) ? (a(t, e, l, c, {
          x: !0
        }), c("xhoverformat"), c("yhoverformat"), c("line.width"), c("line.dash"), s(t, e, c, "increasing"), s(t, e, c, "decreasing"), c("text"), c("hovertext"), c("tickwidth"), l._requestRangeslider[e.xaxis] = !0) : e.visible = !1;
      };
    }, {
      "../../lib": 795,
      "../scatter/period_defaults": 1219,
      "./attributes": 1145,
      "./ohlc_defaults": 1150
    }],
    1148: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/cartesian/axes"),
          i = t("../../lib"),
          a = t("../../components/fx"),
          o = t("../../components/color"),
          s = t("../../lib").fillText,
          l = t("../../constants/delta.js"),
          c = {
        increasing: l.INCREASING.SYMBOL,
        decreasing: l.DECREASING.SYMBOL
      };

      function u(t, e, r, n) {
        var i,
            s,
            l = t.cd,
            c = t.xa,
            u = l[0].trace,
            f = l[0].t,
            h = u.type,
            p = "ohlc" === h ? "l" : "min",
            d = "ohlc" === h ? "h" : "max",
            m = f.bPos || 0,
            g = f.bdPos || f.tickLen,
            v = f.wHover,
            y = Math.min(1, g / Math.abs(c.r2c(c.range[1]) - c.r2c(c.range[0])));

        function x(t) {
          var r = function (t) {
            return t.pos + m - e;
          }(t);

          return a.inbox(r - v, r + v, i);
        }

        function b(t) {
          var e = t[p],
              n = t[d];
          return e === n || a.inbox(e - r, n - r, i);
        }

        function _(t) {
          return (x(t) + b(t)) / 2;
        }

        i = t.maxHoverDistance - y, s = t.maxSpikeDistance - y;
        var w = a.getDistanceFunction(n, x, b, _);
        if (a.getClosest(l, w, t), !1 === t.index) return null;
        var T = l[t.index];
        if (T.empty) return null;
        var k = u[T.dir],
            M = k.line.color;
        return o.opacity(M) && k.line.width ? t.color = M : t.color = k.fillcolor, t.x0 = c.c2p(T.pos + m - g, !0), t.x1 = c.c2p(T.pos + m + g, !0), t.xLabelVal = void 0 !== T.orig_p ? T.orig_p : T.pos, t.spikeDistance = _(T) * s / i, t.xSpike = c.c2p(T.pos, !0), t;
      }

      function f(t, e, r, a) {
        var o = t.cd,
            s = t.ya,
            l = o[0].trace,
            c = o[0].t,
            f = [],
            h = u(t, e, r, a);
        if (!h) return [];
        var p = o[h.index].hi || l.hoverinfo,
            d = p.split("+");
        if (!("all" === p || -1 !== d.indexOf("y"))) return [];

        for (var m = ["high", "open", "close", "low"], g = {}, v = 0; v < m.length; v++) {
          var y,
              x = m[v],
              b = l[x][h.index],
              _ = s.c2p(b, !0);

          b in g ? (y = g[b]).yLabel += "<br>" + c.labels[x] + n.hoverLabelText(s, b, l.yhoverformat) : ((y = i.extendFlat({}, h)).y0 = y.y1 = _, y.yLabelVal = b, y.yLabel = c.labels[x] + n.hoverLabelText(s, b, l.yhoverformat), y.name = "", f.push(y), g[b] = y);
        }

        return f;
      }

      function h(t, e, r, i) {
        var a = t.cd,
            o = t.ya,
            l = a[0].trace,
            f = a[0].t,
            h = u(t, e, r, i);
        if (!h) return [];
        var p = a[h.index],
            d = h.index = p.i,
            m = p.dir;

        function g(t) {
          return f.labels[t] + n.hoverLabelText(o, l[t][d], l.yhoverformat);
        }

        var v = p.hi || l.hoverinfo,
            y = v.split("+"),
            x = "all" === v,
            b = x || -1 !== y.indexOf("y"),
            _ = x || -1 !== y.indexOf("text"),
            w = b ? [g("open"), g("high"), g("low"), g("close") + "  " + c[m]] : [];

        return _ && s(p, l, w), h.extraText = w.join("<br>"), h.y0 = h.y1 = o.c2p(p.yc, !0), [h];
      }

      e.exports = {
        hoverPoints: function hoverPoints(t, e, r, n) {
          return t.cd[0].trace.hoverlabel.split ? f(t, e, r, n) : h(t, e, r, n);
        },
        hoverSplit: f,
        hoverOnPoints: h
      };
    }, {
      "../../components/color": 658,
      "../../components/fx": 698,
      "../../constants/delta.js": 765,
      "../../lib": 795,
      "../../plots/cartesian/axes": 845
    }],
    1149: [function (t, e, r) {
      "use strict";

      e.exports = {
        moduleType: "trace",
        name: "ohlc",
        basePlotModule: t("../../plots/cartesian"),
        categories: ["cartesian", "svg", "showLegend"],
        meta: {},
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        calc: t("./calc").calc,
        plot: t("./plot"),
        style: t("./style"),
        hoverPoints: t("./hover").hoverPoints,
        selectPoints: t("./select")
      };
    }, {
      "../../plots/cartesian": 858,
      "./attributes": 1145,
      "./calc": 1146,
      "./defaults": 1147,
      "./hover": 1148,
      "./plot": 1151,
      "./select": 1152,
      "./style": 1153
    }],
    1150: [function (t, e, r) {
      "use strict";

      var n = t("../../registry"),
          i = t("../../lib");

      e.exports = function (t, e, r, a) {
        var o = r("x"),
            s = r("open"),
            l = r("high"),
            c = r("low"),
            u = r("close");

        if (r("hoverlabel.split"), n.getComponentMethod("calendars", "handleTraceDefaults")(t, e, ["x"], a), s && l && c && u) {
          var f = Math.min(s.length, l.length, c.length, u.length);
          return o && (f = Math.min(f, i.minRowLength(o))), e._length = f, f;
        }
      };
    }, {
      "../../lib": 795,
      "../../registry": 923
    }],
    1151: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../lib");

      e.exports = function (t, e, r, a) {
        var o = e.yaxis,
            s = e.xaxis,
            l = !!s.rangebreaks;
        i.makeTraceGroups(a, r, "trace ohlc").each(function (t) {
          var e = n.select(this),
              r = t[0],
              a = r.t;
          if (!0 !== r.trace.visible || a.empty) e.remove();else {
            var c = a.tickLen,
                u = e.selectAll("path").data(i.identity);
            u.enter().append("path"), u.exit().remove(), u.attr("d", function (t) {
              if (t.empty) return "M0,0Z";
              var e = s.c2p(t.pos - c, !0),
                  r = s.c2p(t.pos + c, !0),
                  n = l ? (e + r) / 2 : s.c2p(t.pos, !0);
              return "M" + e + "," + o.c2p(t.o, !0) + "H" + n + "M" + n + "," + o.c2p(t.h, !0) + "V" + o.c2p(t.l, !0) + "M" + r + "," + o.c2p(t.c, !0) + "H" + n;
            });
          }
        });
      };
    }, {
      "../../lib": 795,
      "@plotly/d3": 57
    }],
    1152: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        var r,
            n = t.cd,
            i = t.xaxis,
            a = t.yaxis,
            o = [],
            s = n[0].t.bPos || 0;
        if (!1 === e) for (r = 0; r < n.length; r++) {
          n[r].selected = 0;
        } else for (r = 0; r < n.length; r++) {
          var l = n[r];
          e.contains([i.c2p(l.pos + s), a.c2p(l.yc)], null, l.i, t) ? (o.push({
            pointNumber: l.i,
            x: i.c2d(l.pos),
            y: a.c2d(l.yc)
          }), l.selected = 1) : l.selected = 0;
        }
        return o;
      };
    }, {}],
    1153: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../components/drawing"),
          a = t("../../components/color");

      e.exports = function (t, e, r) {
        var o = r || n.select(t).selectAll("g.ohlclayer").selectAll("g.trace");
        o.style("opacity", function (t) {
          return t[0].trace.opacity;
        }), o.each(function (t) {
          var e = t[0].trace;
          n.select(this).selectAll("path").each(function (t) {
            if (!t.empty) {
              var r = e[t.dir].line;
              n.select(this).style("fill", "none").call(a.stroke, r.color).call(i.dashLine, r.dash, r.width).style("opacity", e.selectedpoints && !t.selected ? .3 : 1);
            }
          });
        });
      };
    }, {
      "../../components/color": 658,
      "../../components/drawing": 680,
      "@plotly/d3": 57
    }],
    1154: [function (t, e, r) {
      "use strict";

      var n = t("../../lib/extend").extendFlat,
          i = t("../../plots/attributes"),
          a = t("../../plots/font_attributes"),
          o = t("../../components/colorscale/attributes"),
          s = t("../../plots/template_attributes").hovertemplateAttrs,
          l = t("../../plots/domain").attributes,
          c = n({
        editType: "calc"
      }, o("line", {
        editTypeOverride: "calc"
      }), {
        shape: {
          valType: "enumerated",
          values: ["linear", "hspline"],
          dflt: "linear",
          editType: "plot"
        },
        hovertemplate: s({
          editType: "plot",
          arrayOk: !1
        }, {
          keys: ["count", "probability"]
        })
      });
      e.exports = {
        domain: l({
          name: "parcats",
          trace: !0,
          editType: "calc"
        }),
        hoverinfo: n({}, i.hoverinfo, {
          flags: ["count", "probability"],
          editType: "plot",
          arrayOk: !1
        }),
        hoveron: {
          valType: "enumerated",
          values: ["category", "color", "dimension"],
          dflt: "category",
          editType: "plot"
        },
        hovertemplate: s({
          editType: "plot",
          arrayOk: !1
        }, {
          keys: ["count", "probability", "category", "categorycount", "colorcount", "bandcolorcount"]
        }),
        arrangement: {
          valType: "enumerated",
          values: ["perpendicular", "freeform", "fixed"],
          dflt: "perpendicular",
          editType: "plot"
        },
        bundlecolors: {
          valType: "boolean",
          dflt: !0,
          editType: "plot"
        },
        sortpaths: {
          valType: "enumerated",
          values: ["forward", "backward"],
          dflt: "forward",
          editType: "plot"
        },
        labelfont: a({
          editType: "calc"
        }),
        tickfont: a({
          editType: "calc"
        }),
        dimensions: {
          _isLinkedToArray: "dimension",
          label: {
            valType: "string",
            editType: "calc"
          },
          categoryorder: {
            valType: "enumerated",
            values: ["trace", "category ascending", "category descending", "array"],
            dflt: "trace",
            editType: "calc"
          },
          categoryarray: {
            valType: "data_array",
            editType: "calc"
          },
          ticktext: {
            valType: "data_array",
            editType: "calc"
          },
          values: {
            valType: "data_array",
            dflt: [],
            editType: "calc"
          },
          displayindex: {
            valType: "integer",
            editType: "calc"
          },
          editType: "calc",
          visible: {
            valType: "boolean",
            dflt: !0,
            editType: "calc"
          }
        },
        line: c,
        counts: {
          valType: "number",
          min: 0,
          dflt: 1,
          arrayOk: !0,
          editType: "calc"
        },
        customdata: void 0,
        hoverlabel: void 0,
        ids: void 0,
        legendgroup: void 0,
        opacity: void 0,
        selectedpoints: void 0,
        showlegend: void 0
      };
    }, {
      "../../components/colorscale/attributes": 665,
      "../../lib/extend": 785,
      "../../plots/attributes": 841,
      "../../plots/domain": 872,
      "../../plots/font_attributes": 873,
      "../../plots/template_attributes": 918
    }],
    1155: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/get_data").getModuleCalcData,
          i = t("./plot");
      r.name = "parcats", r.plot = function (t, e, r, a) {
        var o = n(t.calcdata, "parcats");

        if (o.length) {
          var s = o[0];
          i(t, s, r, a);
        }
      }, r.clean = function (t, e, r, n) {
        var i = n._has && n._has("parcats"),
            a = e._has && e._has("parcats");

        i && !a && n._paperdiv.selectAll(".parcats").remove();
      };
    }, {
      "../../plots/get_data": 882,
      "./plot": 1160
    }],
    1156: [function (t, e, r) {
      "use strict";

      var n = t("../../lib/gup").wrap,
          i = t("../../components/colorscale/helpers").hasColorscale,
          a = t("../../components/colorscale/calc"),
          o = t("../../lib/filter_unique.js"),
          s = t("../../components/drawing"),
          l = t("../../lib"),
          c = t("fast-isnumeric");

      function u(t, e, r) {
        t.valueInds.push(e), t.count += r;
      }

      function f(t, e, r) {
        return {
          categoryInds: t,
          color: e,
          rawColor: r,
          valueInds: [],
          count: 0
        };
      }

      function h(t, e, r) {
        t.valueInds.push(e), t.count += r;
      }

      e.exports = function (t, e) {
        var r = l.filterVisible(e.dimensions);
        if (0 === r.length) return [];
        var p,
            d,
            m,
            g = r.map(function (t) {
          var e;
          if ("trace" === t.categoryorder) e = null;else if ("array" === t.categoryorder) e = t.categoryarray;else {
            e = o(t.values);

            for (var r = !0, n = 0; n < e.length; n++) {
              if (!c(e[n])) {
                r = !1;
                break;
              }
            }

            e.sort(r ? l.sorterAsc : void 0), "category descending" === t.categoryorder && (e = e.reverse());
          }
          return function (t, e) {
            e = null == e ? [] : e.map(function (t) {
              return t;
            });
            var r = {},
                n = {},
                i = [];
            e.forEach(function (t, e) {
              r[t] = 0, n[t] = e;
            });

            for (var a = 0; a < t.length; a++) {
              var o,
                  s = t[a];
              void 0 === r[s] ? (r[s] = 1, o = e.push(s) - 1, n[s] = o) : (r[s]++, o = n[s]), i.push(o);
            }

            var l = e.map(function (t) {
              return r[t];
            });
            return {
              uniqueValues: e,
              uniqueCounts: l,
              inds: i
            };
          }(t.values, e);
        });
        p = l.isArrayOrTypedArray(e.counts) ? e.counts : [e.counts], function (t) {
          var e;
          if (function (t) {
            for (var e = new Array(t.length), r = 0; r < t.length; r++) {
              if (t[r] < 0 || t[r] >= t.length) return !1;
              if (void 0 !== e[t[r]]) return !1;
              e[t[r]] = !0;
            }

            return !0;
          }(t.map(function (t) {
            return t.displayindex;
          }))) for (e = 0; e < t.length; e++) {
            t[e]._displayindex = t[e].displayindex;
          } else for (e = 0; e < t.length; e++) {
            t[e]._displayindex = e;
          }
        }(r), r.forEach(function (t, e) {
          !function (t, e) {
            t._categoryarray = e.uniqueValues, null === t.ticktext || void 0 === t.ticktext ? t._ticktext = [] : t._ticktext = t.ticktext.slice();

            for (var r = t._ticktext.length; r < e.uniqueValues.length; r++) {
              t._ticktext.push(e.uniqueValues[r]);
            }
          }(t, g[e]);
        });
        var v,
            y = e.line;
        y ? (i(e, "line") && a(t, e, {
          vals: e.line.color,
          containerStr: "line",
          cLetter: "c"
        }), v = s.tryColorscale(y)) : v = l.identity;

        var x,
            b,
            _,
            w,
            T,
            k = r[0].values.length,
            M = {},
            A = g.map(function (t) {
          return t.inds;
        });

        for (m = 0, x = 0; x < k; x++) {
          var S = [];

          for (b = 0; b < A.length; b++) {
            S.push(A[b][x]);
          }

          d = p[x % p.length], m += d;
          var E = (_ = x, w = void 0, T = void 0, l.isArrayOrTypedArray(y.color) ? T = w = y.color[_ % y.color.length] : w = y.color, {
            color: v(w),
            rawColor: T
          }),
              L = S + "-" + E.rawColor;
          void 0 === M[L] && (M[L] = f(S, E.color, E.rawColor)), h(M[L], x, d);
        }

        var C,
            P = r.map(function (t, e) {
          return function (t, e, r, n, i) {
            return {
              dimensionInd: t,
              containerInd: e,
              displayInd: r,
              dimensionLabel: n,
              count: i,
              categories: [],
              dragX: null
            };
          }(e, t._index, t._displayindex, t.label, m);
        });

        for (x = 0; x < k; x++) {
          for (d = p[x % p.length], b = 0; b < P.length; b++) {
            var I = P[b].containerInd,
                O = g[b].inds[x],
                z = P[b].categories;

            if (void 0 === z[O]) {
              var D = e.dimensions[I]._categoryarray[O],
                  R = e.dimensions[I]._ticktext[O];
              z[O] = {
                dimensionInd: b,
                categoryInd: C = O,
                categoryValue: D,
                displayInd: C,
                categoryLabel: R,
                valueInds: [],
                count: 0,
                dragY: null
              };
            }

            u(z[O], x, d);
          }
        }

        return n(function (t, e, r) {
          var n = t.map(function (t) {
            return t.categories.length;
          }).reduce(function (t, e) {
            return Math.max(t, e);
          });
          return {
            dimensions: t,
            paths: e,
            trace: void 0,
            maxCats: n,
            count: r
          };
        }(P, M, m));
      };
    }, {
      "../../components/colorscale/calc": 666,
      "../../components/colorscale/helpers": 669,
      "../../components/drawing": 680,
      "../../lib": 795,
      "../../lib/filter_unique.js": 786,
      "../../lib/gup": 792,
      "fast-isnumeric": 240
    }],
    1157: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../components/colorscale/helpers").hasColorscale,
          a = t("../../components/colorscale/defaults"),
          o = t("../../plots/domain").defaults,
          s = t("../../plots/array_container_defaults"),
          l = t("./attributes"),
          c = t("../parcoords/merge_length");

      function u(t, e) {
        function r(r, i) {
          return n.coerce(t, e, l.dimensions, r, i);
        }

        var i = r("values"),
            a = r("visible");

        if (i && i.length || (a = e.visible = !1), a) {
          r("label"), r("displayindex", e._index);
          var o,
              s = t.categoryarray,
              c = Array.isArray(s) && s.length > 0;
          c && (o = "array");
          var u = r("categoryorder", o);
          "array" === u ? (r("categoryarray"), r("ticktext")) : (delete t.categoryarray, delete t.ticktext), c || "array" !== u || (e.categoryorder = "trace");
        }
      }

      e.exports = function (t, e, r, f) {
        function h(r, i) {
          return n.coerce(t, e, l, r, i);
        }

        var p = s(t, e, {
          name: "dimensions",
          handleItemDefaults: u
        }),
            d = function (t, e, r, o, s) {
          s("line.shape"), s("line.hovertemplate");
          var l = s("line.color", o.colorway[0]);

          if (i(t, "line") && n.isArrayOrTypedArray(l)) {
            if (l.length) return s("line.colorscale"), a(t, e, o, s, {
              prefix: "line.",
              cLetter: "c"
            }), l.length;
            e.line.color = r;
          }

          return 1 / 0;
        }(t, e, r, f, h);

        o(e, f, h), Array.isArray(p) && p.length || (e.visible = !1), c(e, p, "values", d), h("hoveron"), h("hovertemplate"), h("arrangement"), h("bundlecolors"), h("sortpaths"), h("counts");
        var m = {
          family: f.font.family,
          size: Math.round(f.font.size),
          color: f.font.color
        };
        n.coerceFont(h, "labelfont", m);
        var g = {
          family: f.font.family,
          size: Math.round(f.font.size / 1.2),
          color: f.font.color
        };
        n.coerceFont(h, "tickfont", g);
      };
    }, {
      "../../components/colorscale/defaults": 668,
      "../../components/colorscale/helpers": 669,
      "../../lib": 795,
      "../../plots/array_container_defaults": 840,
      "../../plots/domain": 872,
      "../parcoords/merge_length": 1170,
      "./attributes": 1154
    }],
    1158: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        calc: t("./calc"),
        plot: t("./plot"),
        colorbar: {
          container: "line",
          min: "cmin",
          max: "cmax"
        },
        moduleType: "trace",
        name: "parcats",
        basePlotModule: t("./base_plot"),
        categories: ["noOpacity"],
        meta: {}
      };
    }, {
      "./attributes": 1154,
      "./base_plot": 1155,
      "./calc": 1156,
      "./defaults": 1157,
      "./plot": 1160
    }],
    1159: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../plot_api/plot_api"),
          a = t("../../components/fx"),
          o = t("../../lib"),
          s = o.strTranslate,
          l = t("../../components/drawing"),
          c = t("tinycolor2"),
          u = t("../../lib/svg_text_utils");

      function f(t, e, r, i) {
        var a = t.map(R.bind(0, e, r)),
            c = i.selectAll("g.parcatslayer").data([null]);
        c.enter().append("g").attr("class", "parcatslayer").style("pointer-events", "all");
        var f = c.selectAll("g.trace.parcats").data(a, h),
            v = f.enter().append("g").attr("class", "trace parcats");
        f.attr("transform", function (t) {
          return s(t.x, t.y);
        }), v.append("g").attr("class", "paths");
        var y = f.select("g.paths").selectAll("path.path").data(function (t) {
          return t.paths;
        }, h);
        y.attr("fill", function (t) {
          return t.model.color;
        });

        var _ = y.enter().append("path").attr("class", "path").attr("stroke-opacity", 0).attr("fill", function (t) {
          return t.model.color;
        }).attr("fill-opacity", 0);

        b(_), y.attr("d", function (t) {
          return t.svgD;
        }), _.empty() || y.sort(d), y.exit().remove(), y.on("mouseover", m).on("mouseout", g).on("click", x), v.append("g").attr("class", "dimensions");
        var k = f.select("g.dimensions").selectAll("g.dimension").data(function (t) {
          return t.dimensions;
        }, h);
        k.enter().append("g").attr("class", "dimension"), k.attr("transform", function (t) {
          return s(t.x, 0);
        }), k.exit().remove();
        var M = k.selectAll("g.category").data(function (t) {
          return t.categories;
        }, h),
            A = M.enter().append("g").attr("class", "category");
        M.attr("transform", function (t) {
          return s(0, t.y);
        }), A.append("rect").attr("class", "catrect").attr("pointer-events", "none"), M.select("rect.catrect").attr("fill", "none").attr("width", function (t) {
          return t.width;
        }).attr("height", function (t) {
          return t.height;
        }), w(A);
        var S = M.selectAll("rect.bandrect").data(function (t) {
          return t.bands;
        }, h);
        S.each(function () {
          o.raiseToTop(this);
        }), S.attr("fill", function (t) {
          return t.color;
        });
        var O = S.enter().append("rect").attr("class", "bandrect").attr("stroke-opacity", 0).attr("fill", function (t) {
          return t.color;
        }).attr("fill-opacity", 0);
        S.attr("fill", function (t) {
          return t.color;
        }).attr("width", function (t) {
          return t.width;
        }).attr("height", function (t) {
          return t.height;
        }).attr("y", function (t) {
          return t.y;
        }).attr("cursor", function (t) {
          return "fixed" === t.parcatsViewModel.arrangement ? "default" : "perpendicular" === t.parcatsViewModel.arrangement ? "ns-resize" : "move";
        }), T(O), S.exit().remove(), A.append("text").attr("class", "catlabel").attr("pointer-events", "none");
        var z = e._fullLayout.paper_bgcolor;
        M.select("text.catlabel").attr("text-anchor", function (t) {
          return p(t) ? "start" : "end";
        }).attr("alignment-baseline", "middle").style("text-shadow", u.makeTextShadow(z)).style("fill", "rgb(0, 0, 0)").attr("x", function (t) {
          return p(t) ? t.width + 5 : -5;
        }).attr("y", function (t) {
          return t.height / 2;
        }).text(function (t) {
          return t.model.categoryLabel;
        }).each(function (t) {
          l.font(n.select(this), t.parcatsViewModel.categorylabelfont), u.convertToTspans(n.select(this), e);
        }), A.append("text").attr("class", "dimlabel"), M.select("text.dimlabel").attr("text-anchor", "middle").attr("alignment-baseline", "baseline").attr("cursor", function (t) {
          return "fixed" === t.parcatsViewModel.arrangement ? "default" : "ew-resize";
        }).attr("x", function (t) {
          return t.width / 2;
        }).attr("y", -5).text(function (t, e) {
          return 0 === e ? t.parcatsViewModel.model.dimensions[t.model.dimensionInd].dimensionLabel : null;
        }).each(function (t) {
          l.font(n.select(this), t.parcatsViewModel.labelfont);
        }), M.selectAll("rect.bandrect").on("mouseover", E).on("mouseout", L), M.exit().remove(), k.call(n.behavior.drag().origin(function (t) {
          return {
            x: t.x,
            y: 0
          };
        }).on("dragstart", C).on("drag", P).on("dragend", I)), f.each(function (t) {
          t.traceSelection = n.select(this), t.pathSelection = n.select(this).selectAll("g.paths").selectAll("path.path"), t.dimensionSelection = n.select(this).selectAll("g.dimensions").selectAll("g.dimension");
        }), f.exit().remove();
      }

      function h(t) {
        return t.key;
      }

      function p(t) {
        var e = t.parcatsViewModel.dimensions.length,
            r = t.parcatsViewModel.dimensions[e - 1].model.dimensionInd;
        return t.model.dimensionInd === r;
      }

      function d(t, e) {
        return t.model.rawColor > e.model.rawColor ? 1 : t.model.rawColor < e.model.rawColor ? -1 : 0;
      }

      function m(t) {
        if (!t.parcatsViewModel.dragDimension && -1 === t.parcatsViewModel.hoverinfoItems.indexOf("skip")) {
          o.raiseToTop(this), _(n.select(this));
          var e = v(t),
              r = y(t);

          if (t.parcatsViewModel.graphDiv.emit("plotly_hover", {
            points: e,
            event: n.event,
            constraints: r
          }), -1 === t.parcatsViewModel.hoverinfoItems.indexOf("none")) {
            var i,
                s,
                l,
                u = n.mouse(this)[0],
                f = t.parcatsViewModel.graphDiv,
                h = t.parcatsViewModel.trace,
                p = f._fullLayout,
                d = p._paperdiv.node().getBoundingClientRect(),
                m = t.parcatsViewModel.graphDiv.getBoundingClientRect();

            for (l = 0; l < t.leftXs.length - 1; l++) {
              if (t.leftXs[l] + t.dimWidths[l] - 2 <= u && u <= t.leftXs[l + 1] + 2) {
                var g = t.parcatsViewModel.dimensions[l],
                    x = t.parcatsViewModel.dimensions[l + 1];
                i = (g.x + g.width + x.x) / 2, s = (t.topYs[l] + t.topYs[l + 1] + t.height) / 2;
                break;
              }
            }

            var b = t.parcatsViewModel.x + i,
                w = t.parcatsViewModel.y + s,
                T = c.mostReadable(t.model.color, ["black", "white"]),
                k = t.model.count,
                M = k / t.parcatsViewModel.model.count,
                A = {
              countLabel: k,
              probabilityLabel: M.toFixed(3)
            },
                S = [];
            -1 !== t.parcatsViewModel.hoverinfoItems.indexOf("count") && S.push(["Count:", A.countLabel].join(" ")), -1 !== t.parcatsViewModel.hoverinfoItems.indexOf("probability") && S.push(["P:", A.probabilityLabel].join(" "));
            var E = S.join("<br>"),
                L = n.mouse(f)[0];
            a.loneHover({
              trace: h,
              x: b - d.left + m.left,
              y: w - d.top + m.top,
              text: E,
              color: t.model.color,
              borderColor: "black",
              fontFamily: 'Monaco, "Courier New", monospace',
              fontSize: 10,
              fontColor: T,
              idealAlign: L < b ? "right" : "left",
              hovertemplate: (h.line || {}).hovertemplate,
              hovertemplateLabels: A,
              eventData: [{
                data: h._input,
                fullData: h,
                count: k,
                probability: M
              }]
            }, {
              container: p._hoverlayer.node(),
              outerContainer: p._paper.node(),
              gd: f
            });
          }
        }
      }

      function g(t) {
        if (!t.parcatsViewModel.dragDimension && (b(n.select(this)), a.loneUnhover(t.parcatsViewModel.graphDiv._fullLayout._hoverlayer.node()), t.parcatsViewModel.pathSelection.sort(d), -1 === t.parcatsViewModel.hoverinfoItems.indexOf("skip"))) {
          var e = v(t),
              r = y(t);
          t.parcatsViewModel.graphDiv.emit("plotly_unhover", {
            points: e,
            event: n.event,
            constraints: r
          });
        }
      }

      function v(t) {
        for (var e = [], r = O(t.parcatsViewModel), n = 0; n < t.model.valueInds.length; n++) {
          var i = t.model.valueInds[n];
          e.push({
            curveNumber: r,
            pointNumber: i
          });
        }

        return e;
      }

      function y(t) {
        for (var e = {}, r = t.parcatsViewModel.model.dimensions, n = 0; n < r.length; n++) {
          var i = r[n],
              a = i.categories[t.model.categoryInds[n]];
          e[i.containerInd] = a.categoryValue;
        }

        return void 0 !== t.model.rawColor && (e.color = t.model.rawColor), e;
      }

      function x(t) {
        if (-1 === t.parcatsViewModel.hoverinfoItems.indexOf("skip")) {
          var e = v(t),
              r = y(t);
          t.parcatsViewModel.graphDiv.emit("plotly_click", {
            points: e,
            event: n.event,
            constraints: r
          });
        }
      }

      function b(t) {
        t.attr("fill", function (t) {
          return t.model.color;
        }).attr("fill-opacity", .6).attr("stroke", "lightgray").attr("stroke-width", .2).attr("stroke-opacity", 1);
      }

      function _(t) {
        t.attr("fill-opacity", .8).attr("stroke", function (t) {
          return c.mostReadable(t.model.color, ["black", "white"]);
        }).attr("stroke-width", .3);
      }

      function w(t) {
        t.select("rect.catrect").attr("stroke", "black").attr("stroke-width", 1).attr("stroke-opacity", 1);
      }

      function T(t) {
        t.attr("stroke", "black").attr("stroke-width", .2).attr("stroke-opacity", 1).attr("fill-opacity", 1);
      }

      function k(t) {
        var e = t.parcatsViewModel.pathSelection,
            r = t.categoryViewModel.model.dimensionInd,
            n = t.categoryViewModel.model.categoryInd;
        return e.filter(function (e) {
          return e.model.categoryInds[r] === n && e.model.color === t.color;
        });
      }

      function M(t, e, r) {
        var i = n.select(t).datum(),
            a = i.categoryViewModel.model,
            o = i.parcatsViewModel.graphDiv,
            s = n.select(t.parentNode).selectAll("rect.bandrect"),
            l = [];
        s.each(function (t) {
          k(t).each(function (t) {
            Array.prototype.push.apply(l, v(t));
          });
        });
        var c = {};
        c[a.dimensionInd] = a.categoryValue, o.emit(e, {
          points: l,
          event: r,
          constraints: c
        });
      }

      function A(t, e, r) {
        var i = n.select(t).datum(),
            a = i.categoryViewModel.model,
            o = i.parcatsViewModel.graphDiv,
            s = k(i),
            l = [];
        s.each(function (t) {
          Array.prototype.push.apply(l, v(t));
        });
        var c = {};
        c[a.dimensionInd] = a.categoryValue, void 0 !== i.rawColor && (c.color = i.rawColor), o.emit(e, {
          points: l,
          event: r,
          constraints: c
        });
      }

      function S(t, e, r) {
        t._fullLayout._calcInverseTransform(t);

        var i,
            a,
            o = t._fullLayout._invScaleX,
            s = t._fullLayout._invScaleY,
            l = n.select(r.parentNode).select("rect.catrect"),
            c = l.node().getBoundingClientRect(),
            u = l.datum(),
            f = u.parcatsViewModel,
            h = f.model.dimensions[u.model.dimensionInd],
            p = f.trace,
            d = c.top + c.height / 2;
        f.dimensions.length > 1 && h.displayInd === f.dimensions.length - 1 ? (i = c.left, a = "left") : (i = c.left + c.width, a = "right");
        var m = u.model.count,
            g = u.model.categoryLabel,
            v = m / u.parcatsViewModel.model.count,
            y = {
          countLabel: m,
          categoryLabel: g,
          probabilityLabel: v.toFixed(3)
        },
            x = [];
        -1 !== u.parcatsViewModel.hoverinfoItems.indexOf("count") && x.push(["Count:", y.countLabel].join(" ")), -1 !== u.parcatsViewModel.hoverinfoItems.indexOf("probability") && x.push(["P(" + y.categoryLabel + "):", y.probabilityLabel].join(" "));
        var b = x.join("<br>");
        return {
          trace: p,
          x: o * (i - e.left),
          y: s * (d - e.top),
          text: b,
          color: "lightgray",
          borderColor: "black",
          fontFamily: 'Monaco, "Courier New", monospace',
          fontSize: 12,
          fontColor: "black",
          idealAlign: a,
          hovertemplate: p.hovertemplate,
          hovertemplateLabels: y,
          eventData: [{
            data: p._input,
            fullData: p,
            count: m,
            category: g,
            probability: v
          }]
        };
      }

      function E(t) {
        if (!t.parcatsViewModel.dragDimension && -1 === t.parcatsViewModel.hoverinfoItems.indexOf("skip")) {
          if (n.mouse(this)[1] < -1) return;

          var e,
              r = t.parcatsViewModel.graphDiv,
              i = r._fullLayout,
              s = i._paperdiv.node().getBoundingClientRect(),
              l = t.parcatsViewModel.hoveron;

          if ("color" === l ? (!function (t) {
            var e = n.select(t).datum(),
                r = k(e);
            _(r), r.each(function () {
              o.raiseToTop(this);
            }), n.select(t.parentNode).selectAll("rect.bandrect").filter(function (t) {
              return t.color === e.color;
            }).each(function () {
              o.raiseToTop(this), n.select(this).attr("stroke", "black").attr("stroke-width", 1.5);
            });
          }(this), A(this, "plotly_hover", n.event)) : (!function (t) {
            n.select(t.parentNode).selectAll("rect.bandrect").each(function (t) {
              var e = k(t);
              _(e), e.each(function () {
                o.raiseToTop(this);
              });
            }), n.select(t.parentNode).select("rect.catrect").attr("stroke", "black").attr("stroke-width", 2.5);
          }(this), M(this, "plotly_hover", n.event)), -1 === t.parcatsViewModel.hoverinfoItems.indexOf("none")) "category" === l ? e = S(r, s, this) : "color" === l ? e = function (t, e, r) {
            t._fullLayout._calcInverseTransform(t);

            var i,
                a,
                o = t._fullLayout._invScaleX,
                s = t._fullLayout._invScaleY,
                l = r.getBoundingClientRect(),
                u = n.select(r).datum(),
                f = u.categoryViewModel,
                h = f.parcatsViewModel,
                p = h.model.dimensions[f.model.dimensionInd],
                d = h.trace,
                m = l.y + l.height / 2;
            h.dimensions.length > 1 && p.displayInd === h.dimensions.length - 1 ? (i = l.left, a = "left") : (i = l.left + l.width, a = "right");
            var g = f.model.categoryLabel,
                v = u.parcatsViewModel.model.count,
                y = 0;
            u.categoryViewModel.bands.forEach(function (t) {
              t.color === u.color && (y += t.count);
            });
            var x = f.model.count,
                b = 0;
            h.pathSelection.each(function (t) {
              t.model.color === u.color && (b += t.model.count);
            });

            var _ = y / v,
                w = y / b,
                T = y / x,
                k = {
              countLabel: v,
              categoryLabel: g,
              probabilityLabel: _.toFixed(3)
            },
                M = [];

            -1 !== f.parcatsViewModel.hoverinfoItems.indexOf("count") && M.push(["Count:", k.countLabel].join(" ")), -1 !== f.parcatsViewModel.hoverinfoItems.indexOf("probability") && (M.push("P(color \u2229 " + g + "): " + k.probabilityLabel), M.push("P(" + g + " | color): " + w.toFixed(3)), M.push("P(color | " + g + "): " + T.toFixed(3)));
            var A = M.join("<br>"),
                S = c.mostReadable(u.color, ["black", "white"]);
            return {
              trace: d,
              x: o * (i - e.left),
              y: s * (m - e.top),
              text: A,
              color: u.color,
              borderColor: "black",
              fontFamily: 'Monaco, "Courier New", monospace',
              fontColor: S,
              fontSize: 10,
              idealAlign: a,
              hovertemplate: d.hovertemplate,
              hovertemplateLabels: k,
              eventData: [{
                data: d._input,
                fullData: d,
                category: g,
                count: v,
                probability: _,
                categorycount: x,
                colorcount: b,
                bandcolorcount: y
              }]
            };
          }(r, s, this) : "dimension" === l && (e = function (t, e, r) {
            var i = [];
            return n.select(r.parentNode.parentNode).selectAll("g.category").select("rect.catrect").each(function () {
              i.push(S(t, e, this));
            }), i;
          }(r, s, this)), e && a.loneHover(e, {
            container: i._hoverlayer.node(),
            outerContainer: i._paper.node(),
            gd: r
          });
        }
      }

      function L(t) {
        var e = t.parcatsViewModel;

        if (!e.dragDimension && (b(e.pathSelection), w(e.dimensionSelection.selectAll("g.category")), T(e.dimensionSelection.selectAll("g.category").selectAll("rect.bandrect")), a.loneUnhover(e.graphDiv._fullLayout._hoverlayer.node()), e.pathSelection.sort(d), -1 === e.hoverinfoItems.indexOf("skip"))) {
          "color" === t.parcatsViewModel.hoveron ? A(this, "plotly_unhover", n.event) : M(this, "plotly_unhover", n.event);
        }
      }

      function C(t) {
        "fixed" !== t.parcatsViewModel.arrangement && (t.dragDimensionDisplayInd = t.model.displayInd, t.initialDragDimensionDisplayInds = t.parcatsViewModel.model.dimensions.map(function (t) {
          return t.displayInd;
        }), t.dragHasMoved = !1, t.dragCategoryDisplayInd = null, n.select(this).selectAll("g.category").select("rect.catrect").each(function (e) {
          var r = n.mouse(this)[0],
              i = n.mouse(this)[1];
          -2 <= r && r <= e.width + 2 && -2 <= i && i <= e.height + 2 && (t.dragCategoryDisplayInd = e.model.displayInd, t.initialDragCategoryDisplayInds = t.model.categories.map(function (t) {
            return t.displayInd;
          }), e.model.dragY = e.y, o.raiseToTop(this.parentNode), n.select(this.parentNode).selectAll("rect.bandrect").each(function (e) {
            e.y < i && i <= e.y + e.height && (t.potentialClickBand = this);
          }));
        }), t.parcatsViewModel.dragDimension = t, a.loneUnhover(t.parcatsViewModel.graphDiv._fullLayout._hoverlayer.node()));
      }

      function P(t) {
        if ("fixed" !== t.parcatsViewModel.arrangement && (t.dragHasMoved = !0, null !== t.dragDimensionDisplayInd)) {
          var e = t.dragDimensionDisplayInd,
              r = e - 1,
              i = e + 1,
              a = t.parcatsViewModel.dimensions[e];

          if (null !== t.dragCategoryDisplayInd) {
            var o = a.categories[t.dragCategoryDisplayInd];
            o.model.dragY += n.event.dy;
            var s = o.model.dragY,
                l = o.model.displayInd,
                c = a.categories,
                u = c[l - 1],
                f = c[l + 1];
            void 0 !== u && s < u.y + u.height / 2 && (o.model.displayInd = u.model.displayInd, u.model.displayInd = l), void 0 !== f && s + o.height > f.y + f.height / 2 && (o.model.displayInd = f.model.displayInd, f.model.displayInd = l), t.dragCategoryDisplayInd = o.model.displayInd;
          }

          if (null === t.dragCategoryDisplayInd || "freeform" === t.parcatsViewModel.arrangement) {
            a.model.dragX = n.event.x;
            var h = t.parcatsViewModel.dimensions[r],
                p = t.parcatsViewModel.dimensions[i];
            void 0 !== h && a.model.dragX < h.x + h.width && (a.model.displayInd = h.model.displayInd, h.model.displayInd = e), void 0 !== p && a.model.dragX + a.width > p.x && (a.model.displayInd = p.model.displayInd, p.model.displayInd = t.dragDimensionDisplayInd), t.dragDimensionDisplayInd = a.model.displayInd;
          }

          N(t.parcatsViewModel), B(t.parcatsViewModel), D(t.parcatsViewModel), z(t.parcatsViewModel);
        }
      }

      function I(t) {
        if ("fixed" !== t.parcatsViewModel.arrangement && null !== t.dragDimensionDisplayInd) {
          n.select(this).selectAll("text").attr("font-weight", "normal");
          var e = {},
              r = O(t.parcatsViewModel),
              a = t.parcatsViewModel.model.dimensions.map(function (t) {
            return t.displayInd;
          }),
              o = t.initialDragDimensionDisplayInds.some(function (t, e) {
            return t !== a[e];
          });
          o && a.forEach(function (r, n) {
            var i = t.parcatsViewModel.model.dimensions[n].containerInd;
            e["dimensions[" + i + "].displayindex"] = r;
          });
          var s = !1;

          if (null !== t.dragCategoryDisplayInd) {
            var l = t.model.categories.map(function (t) {
              return t.displayInd;
            });

            if (s = t.initialDragCategoryDisplayInds.some(function (t, e) {
              return t !== l[e];
            })) {
              var c = t.model.categories.slice().sort(function (t, e) {
                return t.displayInd - e.displayInd;
              }),
                  u = c.map(function (t) {
                return t.categoryValue;
              }),
                  f = c.map(function (t) {
                return t.categoryLabel;
              });
              e["dimensions[" + t.model.containerInd + "].categoryarray"] = [u], e["dimensions[" + t.model.containerInd + "].ticktext"] = [f], e["dimensions[" + t.model.containerInd + "].categoryorder"] = "array";
            }
          }

          if (-1 === t.parcatsViewModel.hoverinfoItems.indexOf("skip") && !t.dragHasMoved && t.potentialClickBand && ("color" === t.parcatsViewModel.hoveron ? A(t.potentialClickBand, "plotly_click", n.event.sourceEvent) : M(t.potentialClickBand, "plotly_click", n.event.sourceEvent)), t.model.dragX = null, null !== t.dragCategoryDisplayInd) t.parcatsViewModel.dimensions[t.dragDimensionDisplayInd].categories[t.dragCategoryDisplayInd].model.dragY = null, t.dragCategoryDisplayInd = null;
          t.dragDimensionDisplayInd = null, t.parcatsViewModel.dragDimension = null, t.dragHasMoved = null, t.potentialClickBand = null, N(t.parcatsViewModel), B(t.parcatsViewModel), n.transition().duration(300).ease("cubic-in-out").each(function () {
            D(t.parcatsViewModel, !0), z(t.parcatsViewModel, !0);
          }).each("end", function () {
            (o || s) && i.restyle(t.parcatsViewModel.graphDiv, e, [r]);
          });
        }
      }

      function O(t) {
        for (var e, r = t.graphDiv._fullData, n = 0; n < r.length; n++) {
          if (t.key === r[n].uid) {
            e = n;
            break;
          }
        }

        return e;
      }

      function z(t, e) {
        var r;
        void 0 === e && (e = !1), t.pathSelection.data(function (t) {
          return t.paths;
        }, h), (r = t.pathSelection, e ? r.transition() : r).attr("d", function (t) {
          return t.svgD;
        });
      }

      function D(t, e) {
        function r(t) {
          return e ? t.transition() : t;
        }

        void 0 === e && (e = !1), t.dimensionSelection.data(function (t) {
          return t.dimensions;
        }, h);
        var i = t.dimensionSelection.selectAll("g.category").data(function (t) {
          return t.categories;
        }, h);
        r(t.dimensionSelection).attr("transform", function (t) {
          return s(t.x, 0);
        }), r(i).attr("transform", function (t) {
          return s(0, t.y);
        }), i.select(".dimlabel").text(function (t, e) {
          return 0 === e ? t.parcatsViewModel.model.dimensions[t.model.dimensionInd].dimensionLabel : null;
        }), i.select(".catlabel").attr("text-anchor", function (t) {
          return p(t) ? "start" : "end";
        }).attr("x", function (t) {
          return p(t) ? t.width + 5 : -5;
        }).each(function (t) {
          var e, r;
          p(t) ? (e = t.width + 5, r = "start") : (e = -5, r = "end"), n.select(this).selectAll("tspan").attr("x", e).attr("text-anchor", r);
        });
        var a = i.selectAll("rect.bandrect").data(function (t) {
          return t.bands;
        }, h),
            l = a.enter().append("rect").attr("class", "bandrect").attr("cursor", "move").attr("stroke-opacity", 0).attr("fill", function (t) {
          return t.color;
        }).attr("fill-opacity", 0);
        a.attr("fill", function (t) {
          return t.color;
        }).attr("width", function (t) {
          return t.width;
        }).attr("height", function (t) {
          return t.height;
        }).attr("y", function (t) {
          return t.y;
        }), T(l), a.each(function () {
          o.raiseToTop(this);
        }), a.exit().remove();
      }

      function R(t, e, r) {
        var n,
            i = r[0],
            a = e.margin || {
          l: 80,
          r: 80,
          t: 100,
          b: 80
        },
            o = i.trace,
            s = o.domain,
            l = e.width,
            c = e.height,
            u = Math.floor(l * (s.x[1] - s.x[0])),
            f = Math.floor(c * (s.y[1] - s.y[0])),
            h = s.x[0] * l + a.l,
            p = e.height - s.y[1] * e.height + a.t,
            d = o.line.shape;
        n = "all" === o.hoverinfo ? ["count", "probability"] : (o.hoverinfo || "").split("+");
        var m = {
          trace: o,
          key: o.uid,
          model: i,
          x: h,
          y: p,
          width: u,
          height: f,
          hoveron: o.hoveron,
          hoverinfoItems: n,
          arrangement: o.arrangement,
          bundlecolors: o.bundlecolors,
          sortpaths: o.sortpaths,
          labelfont: o.labelfont,
          categorylabelfont: o.tickfont,
          pathShape: d,
          dragDimension: null,
          margin: a,
          paths: [],
          dimensions: [],
          graphDiv: t,
          traceSelection: null,
          pathSelection: null,
          dimensionSelection: null
        };
        return i.dimensions && (N(m), B(m)), m;
      }

      function F(t, e, r, i, a) {
        var o,
            s,
            l = [],
            c = [];

        for (s = 0; s < r.length - 1; s++) {
          o = n.interpolateNumber(r[s] + t[s], t[s + 1]), l.push(o(a)), c.push(o(1 - a));
        }

        var u = "M " + t[0] + "," + e[0];

        for (u += "l" + r[0] + ",0 ", s = 1; s < r.length; s++) {
          u += "C" + l[s - 1] + "," + e[s - 1] + " " + c[s - 1] + "," + e[s] + " " + t[s] + "," + e[s], u += "l" + r[s] + ",0 ";
        }

        for (u += "l0," + i + " ", u += "l -" + r[r.length - 1] + ",0 ", s = r.length - 2; s >= 0; s--) {
          u += "C" + c[s] + "," + (e[s + 1] + i) + " " + l[s] + "," + (e[s] + i) + " " + (t[s] + r[s]) + "," + (e[s] + i), u += "l-" + r[s] + ",0 ";
        }

        return u += "Z";
      }

      function B(t) {
        var e = t.dimensions,
            r = t.model,
            n = e.map(function (t) {
          return t.categories.map(function (t) {
            return t.y;
          });
        }),
            i = t.model.dimensions.map(function (t) {
          return t.categories.map(function (t) {
            return t.displayInd;
          });
        }),
            a = t.model.dimensions.map(function (t) {
          return t.displayInd;
        }),
            o = t.dimensions.map(function (t) {
          return t.model.dimensionInd;
        }),
            s = e.map(function (t) {
          return t.x;
        }),
            l = e.map(function (t) {
          return t.width;
        }),
            c = [];

        for (var u in r.paths) {
          r.paths.hasOwnProperty(u) && c.push(r.paths[u]);
        }

        function f(t) {
          var e = t.categoryInds.map(function (t, e) {
            return i[e][t];
          });
          return o.map(function (t) {
            return e[t];
          });
        }

        c.sort(function (e, r) {
          var n = f(e),
              i = f(r);
          return "backward" === t.sortpaths && (n.reverse(), i.reverse()), n.push(e.valueInds[0]), i.push(r.valueInds[0]), t.bundlecolors && (n.unshift(e.rawColor), i.unshift(r.rawColor)), n < i ? -1 : n > i ? 1 : 0;
        });

        for (var h = new Array(c.length), p = e[0].model.count, d = e[0].categories.map(function (t) {
          return t.height;
        }).reduce(function (t, e) {
          return t + e;
        }), m = 0; m < c.length; m++) {
          var g,
              v = c[m];
          g = p > 0 ? d * (v.count / p) : 0;

          for (var y, x = new Array(n.length), b = 0; b < v.categoryInds.length; b++) {
            var _ = v.categoryInds[b],
                w = i[b][_],
                T = a[b];
            x[T] = n[T][w], n[T][w] += g;
            var k = t.dimensions[T].categories[w],
                M = k.bands.length,
                A = k.bands[M - 1];

            if (void 0 === A || v.rawColor !== A.rawColor) {
              var S = void 0 === A ? 0 : A.y + A.height;
              k.bands.push({
                key: S,
                color: v.color,
                rawColor: v.rawColor,
                height: g,
                width: k.width,
                count: v.count,
                y: S,
                categoryViewModel: k,
                parcatsViewModel: t
              });
            } else {
              var E = k.bands[M - 1];
              E.height += g, E.count += v.count;
            }
          }

          y = "hspline" === t.pathShape ? F(s, x, l, g, .5) : F(s, x, l, g, 0), h[m] = {
            key: v.valueInds[0],
            model: v,
            height: g,
            leftXs: s,
            topYs: x,
            dimWidths: l,
            svgD: y,
            parcatsViewModel: t
          };
        }

        t.paths = h;
      }

      function N(t) {
        var e = t.model.dimensions.map(function (t) {
          return {
            displayInd: t.displayInd,
            dimensionInd: t.dimensionInd
          };
        });
        e.sort(function (t, e) {
          return t.displayInd - e.displayInd;
        });
        var r = [];

        for (var n in e) {
          var i = e[n].dimensionInd,
              a = t.model.dimensions[i];
          r.push(j(t, a));
        }

        t.dimensions = r;
      }

      function j(t, e) {
        var r,
            n = t.model.dimensions.length,
            i = e.displayInd;
        r = 40 + (n > 1 ? (t.width - 80 - 16) / (n - 1) : 0) * i;
        var a,
            o,
            s,
            l,
            c,
            u = [],
            f = t.model.maxCats,
            h = e.categories.length,
            p = e.count,
            d = t.height - 8 * (f - 1),
            m = 8 * (f - h) / 2,
            g = e.categories.map(function (t) {
          return {
            displayInd: t.displayInd,
            categoryInd: t.categoryInd
          };
        });

        for (g.sort(function (t, e) {
          return t.displayInd - e.displayInd;
        }), c = 0; c < h; c++) {
          l = g[c].categoryInd, o = e.categories[l], a = p > 0 ? o.count / p * d : 0, s = {
            key: o.valueInds[0],
            model: o,
            width: 16,
            height: a,
            y: null !== o.dragY ? o.dragY : m,
            bands: [],
            parcatsViewModel: t
          }, m = m + a + 8, u.push(s);
        }

        return {
          key: e.dimensionInd,
          x: null !== e.dragX ? e.dragX : r,
          y: 0,
          width: 16,
          model: e,
          categories: u,
          parcatsViewModel: t,
          dragCategoryDisplayInd: null,
          dragDimensionDisplayInd: null,
          initialDragDimensionDisplayInds: null,
          initialDragCategoryDisplayInds: null,
          dragHasMoved: null,
          potentialClickBand: null
        };
      }

      e.exports = function (t, e, r, n) {
        f(r, t, n, e);
      };
    }, {
      "../../components/drawing": 680,
      "../../components/fx": 698,
      "../../lib": 795,
      "../../lib/svg_text_utils": 820,
      "../../plot_api/plot_api": 831,
      "@plotly/d3": 57,
      tinycolor2: 590
    }],
    1160: [function (t, e, r) {
      "use strict";

      var n = t("./parcats");

      e.exports = function (t, e, r, i) {
        var a = t._fullLayout,
            o = a._paper,
            s = a._size;
        n(t, o, e, {
          width: s.w,
          height: s.h,
          margin: {
            t: s.t,
            r: s.r,
            b: s.b,
            l: s.l
          }
        }, r, i);
      };
    }, {
      "./parcats": 1159
    }],
    1161: [function (t, e, r) {
      "use strict";

      var n = t("../../components/colorscale/attributes"),
          i = t("../../plots/cartesian/layout_attributes"),
          a = t("../../plots/font_attributes"),
          o = t("../../plots/domain").attributes,
          s = t("../../lib/extend").extendFlat,
          l = t("../../plot_api/plot_template").templatedArray;
      e.exports = {
        domain: o({
          name: "parcoords",
          trace: !0,
          editType: "plot"
        }),
        labelangle: {
          valType: "angle",
          dflt: 0,
          editType: "plot"
        },
        labelside: {
          valType: "enumerated",
          values: ["top", "bottom"],
          dflt: "top",
          editType: "plot"
        },
        labelfont: a({
          editType: "plot"
        }),
        tickfont: a({
          editType: "plot"
        }),
        rangefont: a({
          editType: "plot"
        }),
        dimensions: l("dimension", {
          label: {
            valType: "string",
            editType: "plot"
          },
          tickvals: s({}, i.tickvals, {
            editType: "plot"
          }),
          ticktext: s({}, i.ticktext, {
            editType: "plot"
          }),
          tickformat: s({}, i.tickformat, {
            editType: "plot"
          }),
          visible: {
            valType: "boolean",
            dflt: !0,
            editType: "plot"
          },
          range: {
            valType: "info_array",
            items: [{
              valType: "number",
              editType: "plot"
            }, {
              valType: "number",
              editType: "plot"
            }],
            editType: "plot"
          },
          constraintrange: {
            valType: "info_array",
            freeLength: !0,
            dimensions: "1-2",
            items: [{
              valType: "number",
              editType: "plot"
            }, {
              valType: "number",
              editType: "plot"
            }],
            editType: "plot"
          },
          multiselect: {
            valType: "boolean",
            dflt: !0,
            editType: "plot"
          },
          values: {
            valType: "data_array",
            editType: "calc"
          },
          editType: "calc"
        }),
        line: s({
          editType: "calc"
        }, n("line", {
          colorscaleDflt: "Viridis",
          autoColorDflt: !1,
          editTypeOverride: "calc"
        }))
      };
    }, {
      "../../components/colorscale/attributes": 665,
      "../../lib/extend": 785,
      "../../plot_api/plot_template": 834,
      "../../plots/cartesian/layout_attributes": 859,
      "../../plots/domain": 872,
      "../../plots/font_attributes": 873
    }],
    1162: [function (t, e, r) {
      "use strict";

      var n = t("./constants"),
          i = t("@plotly/d3"),
          a = t("../../lib/gup").keyFun,
          o = t("../../lib/gup").repeat,
          s = t("../../lib").sorterAsc,
          l = t("../../lib").strTranslate,
          c = n.bar.snapRatio;

      function u(t, e) {
        return t * (1 - c) + e * c;
      }

      var f = n.bar.snapClose;

      function h(t, e) {
        return t * (1 - f) + e * f;
      }

      function p(t, e, r, n) {
        if (function (t, e) {
          for (var r = 0; r < e.length; r++) {
            if (t >= e[r][0] && t <= e[r][1]) return !0;
          }

          return !1;
        }(r, n)) return r;
        var i = t ? -1 : 1,
            a = 0,
            o = e.length - 1;

        if (i < 0) {
          var s = a;
          a = o, o = s;
        }

        for (var l = e[a], c = l, f = a; i * f < i * o; f += i) {
          var p = f + i,
              d = e[p];
          if (i * r < i * h(l, d)) return u(l, c);
          if (i * r < i * d || p === o) return u(d, l);
          c = l, l = d;
        }
      }

      function d(t) {
        t.attr("x", -n.bar.captureWidth / 2).attr("width", n.bar.captureWidth);
      }

      function m(t) {
        t.attr("visibility", "visible").style("visibility", "visible").attr("fill", "yellow").attr("opacity", 0);
      }

      function g(t) {
        if (!t.brush.filterSpecified) return "0," + t.height;

        for (var e, r, n, i = v(t.brush.filter.getConsolidated(), t.height), a = [0], o = i.length ? i[0][0] : null, s = 0; s < i.length; s++) {
          r = (e = i[s])[1] - e[0], a.push(o), a.push(r), (n = s + 1) < i.length && (o = i[n][0] - e[1]);
        }

        return a.push(t.height), a;
      }

      function v(t, e) {
        return t.map(function (t) {
          return t.map(function (t) {
            return Math.max(0, t * e);
          }).sort(s);
        });
      }

      function y() {
        i.select(document.body).style("cursor", null);
      }

      function x(t) {
        t.attr("stroke-dasharray", g);
      }

      function b(t, e) {
        var r = i.select(t).selectAll(".highlight, .highlight-shadow");
        x(e ? r.transition().duration(n.bar.snapDuration).each("end", e) : r);
      }

      function _(t, e) {
        var r,
            i = t.brush,
            a = NaN,
            o = {};

        if (i.filterSpecified) {
          var s = t.height,
              l = i.filter.getConsolidated(),
              c = v(l, s),
              u = NaN,
              f = NaN,
              h = NaN;

          for (r = 0; r <= c.length; r++) {
            var p = c[r];

            if (p && p[0] <= e && e <= p[1]) {
              u = r;
              break;
            }

            if (f = r ? r - 1 : NaN, p && p[0] > e) {
              h = r;
              break;
            }
          }

          if (a = u, isNaN(a) && (a = isNaN(f) || isNaN(h) ? isNaN(f) ? h : f : e - c[f][1] < c[h][0] - e ? f : h), !isNaN(a)) {
            var d = c[a],
                m = function (t, e) {
              var r = n.bar.handleHeight;
              if (!(e > t[1] + r || e < t[0] - r)) return e >= .9 * t[1] + .1 * t[0] ? "n" : e <= .9 * t[0] + .1 * t[1] ? "s" : "ns";
            }(d, e);

            m && (o.interval = l[a], o.intervalPix = d, o.region = m);
          }
        }

        if (t.ordinal && !o.region) {
          var g = t.unitTickvals,
              y = t.unitToPaddedPx.invert(e);

          for (r = 0; r < g.length; r++) {
            var x = [.25 * g[Math.max(r - 1, 0)] + .75 * g[r], .25 * g[Math.min(r + 1, g.length - 1)] + .75 * g[r]];

            if (y >= x[0] && y <= x[1]) {
              o.clickableOrdinalRange = x;
              break;
            }
          }
        }

        return o;
      }

      function w(t, e) {
        i.event.sourceEvent.stopPropagation();
        var r = e.height - i.mouse(t)[1] - 2 * n.verticalPadding,
            a = e.brush.svgBrush;
        a.wasDragged = !0, a._dragging = !0, a.grabbingBar ? a.newExtent = [r - a.grabPoint, r + a.barLength - a.grabPoint].map(e.unitToPaddedPx.invert) : a.newExtent = [a.startExtent, e.unitToPaddedPx.invert(r)].sort(s), e.brush.filterSpecified = !0, a.extent = a.stayingIntervals.concat([a.newExtent]), a.brushCallback(e), b(t.parentNode);
      }

      function T(t, e) {
        var r = _(e, e.height - i.mouse(t)[1] - 2 * n.verticalPadding),
            a = "crosshair";

        r.clickableOrdinalRange ? a = "pointer" : r.region && (a = r.region + "-resize"), i.select(document.body).style("cursor", a);
      }

      function k(t) {
        t.on("mousemove", function (t) {
          i.event.preventDefault(), t.parent.inBrushDrag || T(this, t);
        }).on("mouseleave", function (t) {
          t.parent.inBrushDrag || y();
        }).call(i.behavior.drag().on("dragstart", function (t) {
          !function (t, e) {
            i.event.sourceEvent.stopPropagation();

            var r = e.height - i.mouse(t)[1] - 2 * n.verticalPadding,
                a = e.unitToPaddedPx.invert(r),
                o = e.brush,
                s = _(e, r),
                l = s.interval,
                c = o.svgBrush;

            if (c.wasDragged = !1, c.grabbingBar = "ns" === s.region, c.grabbingBar) {
              var u = l.map(e.unitToPaddedPx);
              c.grabPoint = r - u[0] - n.verticalPadding, c.barLength = u[1] - u[0];
            }

            c.clickableOrdinalRange = s.clickableOrdinalRange, c.stayingIntervals = e.multiselect && o.filterSpecified ? o.filter.getConsolidated() : [], l && (c.stayingIntervals = c.stayingIntervals.filter(function (t) {
              return t[0] !== l[0] && t[1] !== l[1];
            })), c.startExtent = s.region ? l["s" === s.region ? 1 : 0] : a, e.parent.inBrushDrag = !0, c.brushStartCallback();
          }(this, t);
        }).on("drag", function (t) {
          w(this, t);
        }).on("dragend", function (t) {
          !function (t, e) {
            var r = e.brush,
                n = r.filter,
                a = r.svgBrush;
            a._dragging || (T(t, e), w(t, e), e.brush.svgBrush.wasDragged = !1), a._dragging = !1, i.event.sourceEvent.stopPropagation();
            var o = a.grabbingBar;
            if (a.grabbingBar = !1, a.grabLocation = void 0, e.parent.inBrushDrag = !1, y(), !a.wasDragged) return a.wasDragged = void 0, a.clickableOrdinalRange ? r.filterSpecified && e.multiselect ? a.extent.push(a.clickableOrdinalRange) : (a.extent = [a.clickableOrdinalRange], r.filterSpecified = !0) : o ? (a.extent = a.stayingIntervals, 0 === a.extent.length && A(r)) : A(r), a.brushCallback(e), b(t.parentNode), void a.brushEndCallback(r.filterSpecified ? n.getConsolidated() : []);

            var s = function s() {
              n.set(n.getConsolidated());
            };

            if (e.ordinal) {
              var l = e.unitTickvals;
              l[l.length - 1] < l[0] && l.reverse(), a.newExtent = [p(0, l, a.newExtent[0], a.stayingIntervals), p(1, l, a.newExtent[1], a.stayingIntervals)];
              var c = a.newExtent[1] > a.newExtent[0];
              a.extent = a.stayingIntervals.concat(c ? [a.newExtent] : []), a.extent.length || A(r), a.brushCallback(e), c ? b(t.parentNode, s) : (s(), b(t.parentNode));
            } else s();

            a.brushEndCallback(r.filterSpecified ? n.getConsolidated() : []);
          }(this, t);
        }));
      }

      function M(t, e) {
        return t[0] - e[0];
      }

      function A(t) {
        t.filterSpecified = !1, t.svgBrush.extent = [[-1 / 0, 1 / 0]];
      }

      function S(t) {
        for (var e, r = t.slice(), n = [], i = r.shift(); i;) {
          for (e = i.slice(); (i = r.shift()) && i[0] <= e[1];) {
            e[1] = Math.max(e[1], i[1]);
          }

          n.push(e);
        }

        return 1 === n.length && n[0][0] > n[0][1] && (n = []), n;
      }

      e.exports = {
        makeBrush: function makeBrush(t, e, r, n, i, a) {
          var o,
              l = function () {
            var t,
                e,
                r = [];
            return {
              set: function set(n) {
                1 === (r = n.map(function (t) {
                  return t.slice().sort(s);
                }).sort(M)).length && r[0][0] === -1 / 0 && r[0][1] === 1 / 0 && (r = [[0, -1]]), t = S(r), e = r.reduce(function (t, e) {
                  return [Math.min(t[0], e[0]), Math.max(t[1], e[1])];
                }, [1 / 0, -1 / 0]);
              },
              get: function get() {
                return r.slice();
              },
              getConsolidated: function getConsolidated() {
                return t;
              },
              getBounds: function getBounds() {
                return e;
              }
            };
          }();

          return l.set(r), {
            filter: l,
            filterSpecified: e,
            svgBrush: {
              extent: [],
              brushStartCallback: n,
              brushCallback: (o = i, function (t) {
                var e = t.brush,
                    r = function (t) {
                  return t.svgBrush.extent.map(function (t) {
                    return t.slice();
                  });
                }(e).slice();

                e.filter.set(r), o();
              }),
              brushEndCallback: a
            }
          };
        },
        ensureAxisBrush: function ensureAxisBrush(t, e) {
          var r = t.selectAll("." + n.cn.axisBrush).data(o, a);
          r.enter().append("g").classed(n.cn.axisBrush, !0), function (t, e) {
            var r = t.selectAll(".background").data(o);
            r.enter().append("rect").classed("background", !0).call(d).call(m).style("pointer-events", "auto").attr("transform", l(0, n.verticalPadding)), r.call(k).attr("height", function (t) {
              return t.height - n.verticalPadding;
            });
            var i = t.selectAll(".highlight-shadow").data(o);
            i.enter().append("line").classed("highlight-shadow", !0).attr("x", -n.bar.width / 2).attr("stroke-width", n.bar.width + n.bar.strokeWidth).attr("stroke", e).attr("opacity", n.bar.strokeOpacity).attr("stroke-linecap", "butt"), i.attr("y1", function (t) {
              return t.height;
            }).call(x);
            var a = t.selectAll(".highlight").data(o);
            a.enter().append("line").classed("highlight", !0).attr("x", -n.bar.width / 2).attr("stroke-width", n.bar.width - n.bar.strokeWidth).attr("stroke", n.bar.fillColor).attr("opacity", n.bar.fillOpacity).attr("stroke-linecap", "butt"), a.attr("y1", function (t) {
              return t.height;
            }).call(x);
          }(r, e);
        },
        cleanRanges: function cleanRanges(t, e) {
          if (Array.isArray(t[0]) ? (t = t.map(function (t) {
            return t.sort(s);
          }), t = e.multiselect ? S(t.sort(M)) : [t[0]]) : t = [t.sort(s)], e.tickvals) {
            var r = e.tickvals.slice().sort(s);
            if (!(t = t.map(function (t) {
              var e = [p(0, r, t[0], []), p(1, r, t[1], [])];
              if (e[1] > e[0]) return e;
            }).filter(function (t) {
              return t;
            })).length) return;
          }

          return t.length > 1 ? t : t[0];
        }
      };
    }, {
      "../../lib": 795,
      "../../lib/gup": 792,
      "./constants": 1165,
      "@plotly/d3": 57
    }],
    1163: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../plots/get_data").getModuleCalcData,
          a = t("./plot"),
          o = t("../../constants/xmlns_namespaces");
      r.name = "parcoords", r.plot = function (t) {
        var e = i(t.calcdata, "parcoords")[0];
        e.length && a(t, e);
      }, r.clean = function (t, e, r, n) {
        var i = n._has && n._has("parcoords"),
            a = e._has && e._has("parcoords");

        i && !a && (n._paperdiv.selectAll(".parcoords").remove(), n._glimages.selectAll("*").remove());
      }, r.toSVG = function (t) {
        var e = t._fullLayout._glimages,
            r = n.select(t).selectAll(".svg-container");
        r.filter(function (t, e) {
          return e === r.size() - 1;
        }).selectAll(".gl-canvas-context, .gl-canvas-focus").each(function () {
          var t = this.toDataURL("image/png");
          e.append("svg:image").attr({
            xmlns: o.svg,
            "xlink:href": t,
            preserveAspectRatio: "none",
            x: 0,
            y: 0,
            width: this.width,
            height: this.height
          });
        }), window.setTimeout(function () {
          n.selectAll("#filterBarPattern").attr("id", "filterBarPattern");
        }, 60);
      };
    }, {
      "../../constants/xmlns_namespaces": 772,
      "../../plots/get_data": 882,
      "./plot": 1172,
      "@plotly/d3": 57
    }],
    1164: [function (t, e, r) {
      "use strict";

      var n = t("../../lib").isArrayOrTypedArray,
          i = t("../../components/colorscale"),
          a = t("../../lib/gup").wrap;

      e.exports = function (t, e) {
        var r, o;
        return i.hasColorscale(e, "line") && n(e.line.color) ? (r = e.line.color, o = i.extractOpts(e.line).colorscale, i.calc(t, e, {
          vals: r,
          containerStr: "line",
          cLetter: "c"
        })) : (r = function (t) {
          for (var e = new Array(t), r = 0; r < t; r++) {
            e[r] = .5;
          }

          return e;
        }(e._length), o = [[0, e.line.color], [1, e.line.color]]), a({
          lineColor: r,
          cscale: o
        });
      };
    }, {
      "../../components/colorscale": 670,
      "../../lib": 795,
      "../../lib/gup": 792
    }],
    1165: [function (t, e, r) {
      "use strict";

      e.exports = {
        maxDimensionCount: 60,
        overdrag: 45,
        verticalPadding: 2,
        tickDistance: 50,
        canvasPixelRatio: 1,
        blockLineCount: 5e3,
        layers: ["contextLineLayer", "focusLineLayer", "pickLineLayer"],
        axisTitleOffset: 28,
        axisExtentOffset: 10,
        deselectedLineColor: "#777",
        bar: {
          width: 4,
          captureWidth: 10,
          fillColor: "magenta",
          fillOpacity: 1,
          snapDuration: 150,
          snapRatio: .25,
          snapClose: .01,
          strokeOpacity: 1,
          strokeWidth: 1,
          handleHeight: 8,
          handleOpacity: 1,
          handleOverlap: 0
        },
        cn: {
          axisExtentText: "axis-extent-text",
          parcoordsLineLayers: "parcoords-line-layers",
          parcoordsLineLayer: "parcoords-lines",
          parcoords: "parcoords",
          parcoordsControlView: "parcoords-control-view",
          yAxis: "y-axis",
          axisOverlays: "axis-overlays",
          axis: "axis",
          axisHeading: "axis-heading",
          axisTitle: "axis-title",
          axisExtent: "axis-extent",
          axisExtentTop: "axis-extent-top",
          axisExtentTopText: "axis-extent-top-text",
          axisExtentBottom: "axis-extent-bottom",
          axisExtentBottomText: "axis-extent-bottom-text",
          axisBrush: "axis-brush"
        },
        id: {
          filterBarPattern: "filter-bar-pattern"
        }
      };
    }, {}],
    1166: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../components/colorscale/helpers").hasColorscale,
          a = t("../../components/colorscale/defaults"),
          o = t("../../plots/domain").defaults,
          s = t("../../plots/array_container_defaults"),
          l = t("../../plots/cartesian/axes"),
          c = t("./attributes"),
          u = t("./axisbrush"),
          f = t("./constants").maxDimensionCount,
          h = t("./merge_length");

      function p(t, e, r, i) {
        function a(r, i) {
          return n.coerce(t, e, c.dimensions, r, i);
        }

        var o = a("values"),
            s = a("visible");

        if (o && o.length || (s = e.visible = !1), s) {
          a("label"), a("tickvals"), a("ticktext"), a("tickformat");
          var f = a("range");
          e._ax = {
            _id: "y",
            type: "linear",
            showexponent: "all",
            exponentformat: "B",
            range: f
          }, l.setConvert(e._ax, i.layout), a("multiselect");
          var h = a("constraintrange");
          h && (e.constraintrange = u.cleanRanges(h, e));
        }
      }

      e.exports = function (t, e, r, l) {
        function u(r, i) {
          return n.coerce(t, e, c, r, i);
        }

        var d = t.dimensions;
        Array.isArray(d) && d.length > f && (n.log("parcoords traces support up to " + f + " dimensions at the moment"), d.splice(f));

        var m = s(t, e, {
          name: "dimensions",
          layout: l,
          handleItemDefaults: p
        }),
            g = function (t, e, r, o, s) {
          var l = s("line.color", r);

          if (i(t, "line") && n.isArrayOrTypedArray(l)) {
            if (l.length) return s("line.colorscale"), a(t, e, o, s, {
              prefix: "line.",
              cLetter: "c"
            }), l.length;
            e.line.color = r;
          }

          return 1 / 0;
        }(t, e, r, l, u);

        o(e, l, u), Array.isArray(m) && m.length || (e.visible = !1), h(e, m, "values", g);
        var v = {
          family: l.font.family,
          size: Math.round(l.font.size / 1.2),
          color: l.font.color
        };
        n.coerceFont(u, "labelfont", v), n.coerceFont(u, "tickfont", v), n.coerceFont(u, "rangefont", v), u("labelangle"), u("labelside");
      };
    }, {
      "../../components/colorscale/defaults": 668,
      "../../components/colorscale/helpers": 669,
      "../../lib": 795,
      "../../plots/array_container_defaults": 840,
      "../../plots/cartesian/axes": 845,
      "../../plots/domain": 872,
      "./attributes": 1161,
      "./axisbrush": 1162,
      "./constants": 1165,
      "./merge_length": 1170
    }],
    1167: [function (t, e, r) {
      "use strict";

      var n = t("../../lib").isTypedArray;
      r.convertTypedArray = function (t) {
        return n(t) ? Array.prototype.slice.call(t) : t;
      }, r.isOrdinal = function (t) {
        return !!t.tickvals;
      }, r.isVisible = function (t) {
        return t.visible || !("visible" in t);
      };
    }, {
      "../../lib": 795
    }],
    1168: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        calc: t("./calc"),
        plot: t("./plot"),
        colorbar: {
          container: "line",
          min: "cmin",
          max: "cmax"
        },
        moduleType: "trace",
        name: "parcoords",
        basePlotModule: t("./base_plot"),
        categories: ["gl", "regl", "noOpacity", "noHover"],
        meta: {}
      };
    }, {
      "./attributes": 1161,
      "./base_plot": 1163,
      "./calc": 1164,
      "./defaults": 1166,
      "./plot": 1172
    }],
    1169: [function (t, e, r) {
      "use strict";

      var n = t("glslify"),
          i = n(["precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nattribute vec4 p01_04, p05_08, p09_12, p13_16,\n               p17_20, p21_24, p25_28, p29_32,\n               p33_36, p37_40, p41_44, p45_48,\n               p49_52, p53_56, p57_60, colors;\n\nuniform mat4 dim0A, dim1A, dim0B, dim1B, dim0C, dim1C, dim0D, dim1D,\n             loA, hiA, loB, hiB, loC, hiC, loD, hiD;\n\nuniform vec2 resolution, viewBoxPos, viewBoxSize;\nuniform sampler2D mask, palette;\nuniform float maskHeight;\nuniform float drwLayer; // 0: context, 1: focus, 2: pick\nuniform vec4 contextColor;\n\nbool isPick    = (drwLayer > 1.5);\nbool isContext = (drwLayer < 0.5);\n\nconst vec4 ZEROS = vec4(0.0, 0.0, 0.0, 0.0);\nconst vec4 UNITS = vec4(1.0, 1.0, 1.0, 1.0);\n\nfloat val(mat4 p, mat4 v) {\n    return dot(matrixCompMult(p, v) * UNITS, UNITS);\n}\n\nfloat axisY(float ratio, mat4 A, mat4 B, mat4 C, mat4 D) {\n    float y1 = val(A, dim0A) + val(B, dim0B) + val(C, dim0C) + val(D, dim0D);\n    float y2 = val(A, dim1A) + val(B, dim1B) + val(C, dim1C) + val(D, dim1D);\n    return y1 * (1.0 - ratio) + y2 * ratio;\n}\n\nint iMod(int a, int b) {\n    return a - b * (a / b);\n}\n\nbool fOutside(float p, float lo, float hi) {\n    return (lo < hi) && (lo > p || p > hi);\n}\n\nbool vOutside(vec4 p, vec4 lo, vec4 hi) {\n    return (\n        fOutside(p[0], lo[0], hi[0]) ||\n        fOutside(p[1], lo[1], hi[1]) ||\n        fOutside(p[2], lo[2], hi[2]) ||\n        fOutside(p[3], lo[3], hi[3])\n    );\n}\n\nbool mOutside(mat4 p, mat4 lo, mat4 hi) {\n    return (\n        vOutside(p[0], lo[0], hi[0]) ||\n        vOutside(p[1], lo[1], hi[1]) ||\n        vOutside(p[2], lo[2], hi[2]) ||\n        vOutside(p[3], lo[3], hi[3])\n    );\n}\n\nbool outsideBoundingBox(mat4 A, mat4 B, mat4 C, mat4 D) {\n    return mOutside(A, loA, hiA) ||\n           mOutside(B, loB, hiB) ||\n           mOutside(C, loC, hiC) ||\n           mOutside(D, loD, hiD);\n}\n\nbool outsideRasterMask(mat4 A, mat4 B, mat4 C, mat4 D) {\n    mat4 pnts[4];\n    pnts[0] = A;\n    pnts[1] = B;\n    pnts[2] = C;\n    pnts[3] = D;\n\n    for(int i = 0; i < 4; ++i) {\n        for(int j = 0; j < 4; ++j) {\n            for(int k = 0; k < 4; ++k) {\n                if(0 == iMod(\n                    int(255.0 * texture2D(mask,\n                        vec2(\n                            (float(i * 2 + j / 2) + 0.5) / 8.0,\n                            (pnts[i][j][k] * (maskHeight - 1.0) + 1.0) / maskHeight\n                        ))[3]\n                    ) / int(pow(2.0, float(iMod(j * 4 + k, 8)))),\n                    2\n                )) return true;\n            }\n        }\n    }\n    return false;\n}\n\nvec4 position(bool isContext, float v, mat4 A, mat4 B, mat4 C, mat4 D) {\n    float x = 0.5 * sign(v) + 0.5;\n    float y = axisY(x, A, B, C, D);\n    float z = 1.0 - abs(v);\n\n    z += isContext ? 0.0 : 2.0 * float(\n        outsideBoundingBox(A, B, C, D) ||\n        outsideRasterMask(A, B, C, D)\n    );\n\n    return vec4(\n        2.0 * (vec2(x, y) * viewBoxSize + viewBoxPos) / resolution - 1.0,\n        z,\n        1.0\n    );\n}\n\nvoid main() {\n    mat4 A = mat4(p01_04, p05_08, p09_12, p13_16);\n    mat4 B = mat4(p17_20, p21_24, p25_28, p29_32);\n    mat4 C = mat4(p33_36, p37_40, p41_44, p45_48);\n    mat4 D = mat4(p49_52, p53_56, p57_60, ZEROS);\n\n    float v = colors[3];\n\n    gl_Position = position(isContext, v, A, B, C, D);\n\n    fragColor =\n        isContext ? vec4(contextColor) :\n        isPick ? vec4(colors.rgb, 1.0) : texture2D(palette, vec2(abs(v), 0.5));\n}\n"]),
          a = n(["precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nvoid main() {\n    gl_FragColor = fragColor;\n}\n"]),
          o = t("./constants").maxDimensionCount,
          s = t("../../lib"),
          l = new Uint8Array(4),
          c = new Uint8Array(4),
          u = {
        shape: [256, 1],
        format: "rgba",
        type: "uint8",
        mag: "nearest",
        min: "nearest"
      };

      function f(t, e, r, n, i) {
        var a = t._gl;
        a.enable(a.SCISSOR_TEST), a.scissor(e, r, n, i), t.clear({
          color: [0, 0, 0, 0],
          depth: 1
        });
      }

      function h(t, e, r, n, i, a) {
        var o = a.key;
        r.drawCompleted || (!function (t) {
          t.read({
            x: 0,
            y: 0,
            width: 1,
            height: 1,
            data: l
          });
        }(t), r.drawCompleted = !0), function s(l) {
          var c = Math.min(n, i - l * n);
          0 === l && (window.cancelAnimationFrame(r.currentRafs[o]), delete r.currentRafs[o], f(t, a.scissorX, a.scissorY, a.scissorWidth, a.viewBoxSize[1])), r.clearOnly || (a.count = 2 * c, a.offset = 2 * l * n, e(a), l * n + c < i && (r.currentRafs[o] = window.requestAnimationFrame(function () {
            s(l + 1);
          })), r.drawCompleted = !1);
        }(0);
      }

      function p(t, e) {
        for (var r = new Array(256), n = 0; n < 256; n++) {
          r[n] = t(n / 255).concat(e);
        }

        return r;
      }

      function d(t, e) {
        return (t >>> 8 * e) % 256 / 255;
      }

      function m(t, e, r) {
        for (var n = new Array(8 * e), i = 0, a = 0; a < e; a++) {
          for (var o = 0; o < 2; o++) {
            for (var s = 0; s < 4; s++) {
              var l = 4 * t + s,
                  c = r[64 * a + l];
              63 === l && 0 === o && (c *= -1), n[i++] = c;
            }
          }
        }

        return n;
      }

      function g(t) {
        var e = "0" + t;
        return e.substr(e.length - 2);
      }

      function v(t) {
        return t < o ? "p" + g(t + 1) + "_" + g(t + 4) : "colors";
      }

      function y(t, e, r, n, i, a, o, l, c, u, f, h, p) {
        for (var d = [[], []], m = 0; m < 64; m++) {
          d[0][m] = m === i ? 1 : 0, d[1][m] = m === a ? 1 : 0;
        }

        var g = t.lines.canvasOverdrag,
            v = t.domain,
            y = t.canvasWidth,
            x = t.canvasHeight,
            b = t.deselectedLines.color;
        return s.extendFlat({
          key: f,
          resolution: [y, x],
          viewBoxPos: [o + g, l],
          viewBoxSize: [c, u],
          i0: i,
          i1: a,
          dim0A: d[0].slice(0, 16),
          dim0B: d[0].slice(16, 32),
          dim0C: d[0].slice(32, 48),
          dim0D: d[0].slice(48, 64),
          dim1A: d[1].slice(0, 16),
          dim1B: d[1].slice(16, 32),
          dim1C: d[1].slice(32, 48),
          dim1D: d[1].slice(48, 64),
          drwLayer: h,
          contextColor: [b[0] / 255, b[1] / 255, b[2] / 255, b[3] < 1 ? b[3] : Math.max(1 / 255, Math.pow(1 / t.lines.color.length, 1 / 3))],
          scissorX: (n === e ? 0 : o + g) + (t.pad.l - g) + t.layoutWidth * v.x[0],
          scissorWidth: (n === r ? y - o + g : c + .5) + (n === e ? o + g : 0),
          scissorY: l + t.pad.b + t.layoutHeight * v.y[0],
          scissorHeight: u,
          viewportX: t.pad.l - g + t.layoutWidth * v.x[0],
          viewportY: t.pad.b + t.layoutHeight * v.y[0],
          viewportWidth: y,
          viewportHeight: x
        }, p);
      }

      function x(t) {
        var e = Math.max(0, Math.floor(2047 * t[0]), 0),
            r = Math.min(2047, Math.ceil(2047 * t[1]), 2047);
        return [Math.min(e, r), Math.max(e, r)];
      }

      e.exports = function (t, e) {
        var r,
            n,
            l,
            g,
            b,
            _ = e.context,
            w = e.pick,
            T = e.regl,
            k = {
          currentRafs: {},
          drawCompleted: !0,
          clearOnly: !1
        },
            M = function (t) {
          for (var e = {}, r = 0; r <= o; r += 4) {
            e[v(r)] = t.buffer({
              usage: "dynamic",
              type: "float",
              data: new Uint8Array(0)
            });
          }

          return e;
        }(T),
            A = T.texture(u),
            S = [];

        L(e);
        var E = T({
          profile: !1,
          blend: {
            enable: _,
            func: {
              srcRGB: "src alpha",
              dstRGB: "one minus src alpha",
              srcAlpha: 1,
              dstAlpha: 1
            },
            equation: {
              rgb: "add",
              alpha: "add"
            },
            color: [0, 0, 0, 0]
          },
          depth: {
            enable: !_,
            mask: !0,
            func: "less",
            range: [0, 1]
          },
          cull: {
            enable: !0,
            face: "back"
          },
          scissor: {
            enable: !0,
            box: {
              x: T.prop("scissorX"),
              y: T.prop("scissorY"),
              width: T.prop("scissorWidth"),
              height: T.prop("scissorHeight")
            }
          },
          viewport: {
            x: T.prop("viewportX"),
            y: T.prop("viewportY"),
            width: T.prop("viewportWidth"),
            height: T.prop("viewportHeight")
          },
          dither: !1,
          vert: i,
          frag: a,
          primitive: "lines",
          lineWidth: 1,
          attributes: M,
          uniforms: {
            resolution: T.prop("resolution"),
            viewBoxPos: T.prop("viewBoxPos"),
            viewBoxSize: T.prop("viewBoxSize"),
            dim0A: T.prop("dim0A"),
            dim1A: T.prop("dim1A"),
            dim0B: T.prop("dim0B"),
            dim1B: T.prop("dim1B"),
            dim0C: T.prop("dim0C"),
            dim1C: T.prop("dim1C"),
            dim0D: T.prop("dim0D"),
            dim1D: T.prop("dim1D"),
            loA: T.prop("loA"),
            hiA: T.prop("hiA"),
            loB: T.prop("loB"),
            hiB: T.prop("hiB"),
            loC: T.prop("loC"),
            hiC: T.prop("hiC"),
            loD: T.prop("loD"),
            hiD: T.prop("hiD"),
            palette: A,
            contextColor: T.prop("contextColor"),
            mask: T.prop("maskTexture"),
            drwLayer: T.prop("drwLayer"),
            maskHeight: T.prop("maskHeight")
          },
          offset: T.prop("offset"),
          count: T.prop("count")
        });

        function L(t) {
          r = t.model, n = t.viewModel, l = n.dimensions.slice(), g = l[0] ? l[0].values.length : 0;

          var e = r.lines,
              i = w ? e.color.map(function (t, r) {
            return r / e.color.length;
          }) : e.color,
              a = function (t, e, r) {
            for (var n, i = new Array(t * (o + 4)), a = 0, s = 0; s < t; s++) {
              for (var l = 0; l < o; l++) {
                i[a++] = l < e.length ? e[l].paddedUnitValues[s] : .5;
              }

              i[a++] = d(s, 2), i[a++] = d(s, 1), i[a++] = d(s, 0), i[a++] = (n = r[s], Math.max(1e-6, Math.min(.999999, n)));
            }

            return i;
          }(g, l, i);

          !function (t, e, r) {
            for (var n = 0; n <= o; n += 4) {
              t[v(n)](m(n / 4, e, r));
            }
          }(M, g, a), _ || w || (A = T.texture(s.extendFlat({
            data: p(r.unitToColor, 255)
          }, u)));
        }

        return {
          render: function render(t, e, n) {
            var i,
                a,
                o,
                s = t.length,
                c = 1 / 0,
                u = -1 / 0;

            for (i = 0; i < s; i++) {
              t[i].dim0.canvasX < c && (c = t[i].dim0.canvasX, a = i), t[i].dim1.canvasX > u && (u = t[i].dim1.canvasX, o = i);
            }

            0 === s && f(T, 0, 0, r.canvasWidth, r.canvasHeight);

            var p = function (t) {
              var e,
                  r,
                  n,
                  i = [[], []];

              for (n = 0; n < 64; n++) {
                var a = !t && n < l.length ? l[n].brush.filter.getBounds() : [-1 / 0, 1 / 0];
                i[0][n] = a[0], i[1][n] = a[1];
              }

              var o = new Array(16384);

              for (e = 0; e < 16384; e++) {
                o[e] = 255;
              }

              if (!t) for (e = 0; e < l.length; e++) {
                var s = e % 8,
                    c = (e - s) / 8,
                    u = Math.pow(2, s),
                    f = l[e].brush.filter.get();

                if (!(f.length < 2)) {
                  var h = x(f[0])[1];

                  for (r = 1; r < f.length; r++) {
                    var p = x(f[r]);

                    for (n = h + 1; n < p[0]; n++) {
                      o[8 * n + c] &= ~u;
                    }

                    h = Math.max(h, p[1]);
                  }
                }
              }
              var d = {
                shape: [8, 2048],
                format: "alpha",
                type: "uint8",
                mag: "nearest",
                min: "nearest",
                data: o
              };
              return b ? b(d) : b = T.texture(d), {
                maskTexture: b,
                maskHeight: 2048,
                loA: i[0].slice(0, 16),
                loB: i[0].slice(16, 32),
                loC: i[0].slice(32, 48),
                loD: i[0].slice(48, 64),
                hiA: i[1].slice(0, 16),
                hiB: i[1].slice(16, 32),
                hiC: i[1].slice(32, 48),
                hiD: i[1].slice(48, 64)
              };
            }(_);

            for (i = 0; i < s; i++) {
              var d = t[i],
                  m = d.dim0.crossfilterDimensionIndex,
                  v = d.dim1.crossfilterDimensionIndex,
                  M = d.canvasX,
                  A = d.canvasY,
                  L = M + d.panelSizeX;

              if (e || !S[m] || S[m][0] !== M || S[m][1] !== L) {
                S[m] = [M, L];
                var C = y(r, a, o, i, m, v, M, A, d.panelSizeX, d.panelSizeY, d.dim0.crossfilterDimensionIndex, _ ? 0 : w ? 2 : 1, p);
                k.clearOnly = n;
                var P = e ? r.lines.blockLineCount : g;
                h(T, E, k, P, g, C);
              }
            }
          },
          readPixel: function readPixel(t, e) {
            return T.read({
              x: t,
              y: e,
              width: 1,
              height: 1,
              data: c
            }), c;
          },
          readPixels: function readPixels(t, e, r, n) {
            var i = new Uint8Array(4 * r * n);
            return T.read({
              x: t,
              y: e,
              width: r,
              height: n,
              data: i
            }), i;
          },
          destroy: function destroy() {
            for (var e in t.style["pointer-events"] = "none", A.destroy(), b && b.destroy(), M) {
              M[e].destroy();
            }
          },
          update: L
        };
      };
    }, {
      "../../lib": 795,
      "./constants": 1165,
      glslify: 433
    }],
    1170: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, n) {
        var i, a;

        for (n || (n = 1 / 0), i = 0; i < e.length; i++) {
          (a = e[i]).visible && (n = Math.min(n, a[r].length));
        }

        for (n === 1 / 0 && (n = 0), t._length = n, i = 0; i < e.length; i++) {
          (a = e[i]).visible && (a._length = n);
        }

        return n;
      };
    }, {}],
    1171: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("color-rgba"),
          a = t("../../plots/cartesian/axes"),
          o = t("../../lib"),
          s = o.strRotate,
          l = o.strTranslate,
          c = t("../../lib/svg_text_utils"),
          u = t("../../components/drawing"),
          f = t("../../components/colorscale"),
          h = t("../../lib/gup"),
          p = h.keyFun,
          d = h.repeat,
          m = h.unwrap,
          g = t("./helpers"),
          v = t("./constants"),
          y = t("./axisbrush"),
          x = t("./lines");

      function b(t, e, r) {
        return o.aggNums(t, null, e, r);
      }

      function _(t, e) {
        return T(b(Math.min, t, e), b(Math.max, t, e));
      }

      function w(t) {
        var e = t.range;
        return e ? T(e[0], e[1]) : _(t.values, t._length);
      }

      function T(t, e) {
        return !isNaN(t) && isFinite(t) || (t = 0), !isNaN(e) && isFinite(e) || (e = 0), t === e && (0 === t ? (t -= 1, e += 1) : (t *= .9, e *= 1.1)), [t, e];
      }

      function k(t, e, r, i, a) {
        var o,
            s,
            l = w(r);
        return i ? n.scale.ordinal().domain(i.map((o = n.format(r.tickformat), s = a, s ? function (t, e) {
          var r = s[e];
          return null == r ? o(t) : r;
        } : o))).range(i.map(function (r) {
          var n = (r - l[0]) / (l[1] - l[0]);
          return t - e + n * (2 * e - t);
        })) : n.scale.linear().domain(l).range([t - e, e]);
      }

      function M(t) {
        if (t.tickvals) {
          var e = w(t);
          return n.scale.ordinal().domain(t.tickvals).range(t.tickvals.map(function (t) {
            return (t - e[0]) / (e[1] - e[0]);
          }));
        }
      }

      function A(t) {
        var e = t.map(function (t) {
          return t[0];
        }),
            r = t.map(function (t) {
          var e = i(t[1]);
          return n.rgb("rgb(" + e[0] + "," + e[1] + "," + e[2] + ")");
        }),
            a = "rgb".split("").map(function (t) {
          return n.scale.linear().clamp(!0).domain(e).range(r.map((i = t, function (t) {
            return t[i];
          })));
          var i;
        });
        return function (t) {
          return a.map(function (e) {
            return e(t);
          });
        };
      }

      function S(t) {
        return t.dimensions.some(function (t) {
          return t.brush.filterSpecified;
        });
      }

      function E(t, e, r) {
        var a = m(e),
            s = a.trace,
            l = g.convertTypedArray(a.lineColor),
            c = s.line,
            u = {
          color: i(v.deselectedLineColor)
        },
            h = f.extractOpts(c),
            p = h.reversescale ? f.flipScale(a.cscale) : a.cscale,
            d = s.domain,
            y = s.dimensions,
            x = t.width,
            b = s.labelangle,
            _ = s.labelside,
            T = s.labelfont,
            k = s.tickfont,
            M = s.rangefont,
            S = o.extendDeepNoArrays({}, c, {
          color: l.map(n.scale.linear().domain(w({
            values: l,
            range: [h.min, h.max],
            _length: s._length
          }))),
          blockLineCount: v.blockLineCount,
          canvasOverdrag: v.overdrag * v.canvasPixelRatio
        }),
            E = Math.floor(x * (d.x[1] - d.x[0])),
            L = Math.floor(t.height * (d.y[1] - d.y[0])),
            C = t.margin || {
          l: 80,
          r: 80,
          t: 100,
          b: 80
        },
            P = E,
            I = L;
        return {
          key: r,
          colCount: y.filter(g.isVisible).length,
          dimensions: y,
          tickDistance: v.tickDistance,
          unitToColor: A(p),
          lines: S,
          deselectedLines: u,
          labelAngle: b,
          labelSide: _,
          labelFont: T,
          tickFont: k,
          rangeFont: M,
          layoutWidth: x,
          layoutHeight: t.height,
          domain: d,
          translateX: d.x[0] * x,
          translateY: t.height - d.y[1] * t.height,
          pad: C,
          canvasWidth: P * v.canvasPixelRatio + 2 * S.canvasOverdrag,
          canvasHeight: I * v.canvasPixelRatio,
          width: P,
          height: I,
          canvasPixelRatio: v.canvasPixelRatio
        };
      }

      function L(t, e, r) {
        var i = r.width,
            a = r.height,
            s = r.dimensions,
            l = r.canvasPixelRatio,
            c = function c(t) {
          return i * t / Math.max(1, r.colCount - 1);
        },
            u = v.verticalPadding / a,
            f = function (t, e) {
          return n.scale.linear().range([e, t - e]);
        }(a, v.verticalPadding),
            h = {
          key: r.key,
          xScale: c,
          model: r,
          inBrushDrag: !1
        },
            p = {};

        return h.dimensions = s.filter(g.isVisible).map(function (i, s) {
          var d = function (t, e) {
            return n.scale.linear().domain(w(t)).range([e, 1 - e]);
          }(i, u),
              m = p[i.label];

          p[i.label] = (m || 0) + 1;

          var x = i.label + (m ? "__" + m : ""),
              b = i.constraintrange,
              _ = b && b.length;

          _ && !Array.isArray(b[0]) && (b = [b]);
          var T = _ ? b.map(function (t) {
            return t.map(d);
          }) : [[-1 / 0, 1 / 0]],
              A = i.values;
          A.length > i._length && (A = A.slice(0, i._length));
          var E,
              L = i.tickvals;

          function C(t, e) {
            return {
              val: t,
              text: E[e]
            };
          }

          function P(t, e) {
            return t.val - e.val;
          }

          if (Array.isArray(L) && L.length) {
            E = i.ticktext, Array.isArray(E) && E.length ? E.length > L.length ? E = E.slice(0, L.length) : L.length > E.length && (L = L.slice(0, E.length)) : E = L.map(n.format(i.tickformat));

            for (var I = 1; I < L.length; I++) {
              if (L[I] < L[I - 1]) {
                for (var O = L.map(C).sort(P), z = 0; z < L.length; z++) {
                  L[z] = O[z].val, E[z] = O[z].text;
                }

                break;
              }
            }
          } else L = void 0;

          return A = g.convertTypedArray(A), {
            key: x,
            label: i.label,
            tickFormat: i.tickformat,
            tickvals: L,
            ticktext: E,
            ordinal: g.isOrdinal(i),
            multiselect: i.multiselect,
            xIndex: s,
            crossfilterDimensionIndex: s,
            visibleIndex: i._index,
            height: a,
            values: A,
            paddedUnitValues: A.map(d),
            unitTickvals: L && L.map(d),
            xScale: c,
            x: c(s),
            canvasX: c(s) * l,
            unitToPaddedPx: f,
            domainScale: k(a, v.verticalPadding, i, L, E),
            ordinalScale: M(i),
            parent: h,
            model: r,
            brush: y.makeBrush(t, _, T, function () {
              t.linePickActive(!1);
            }, function () {
              var e = h;
              e.focusLayer && e.focusLayer.render(e.panels, !0);
              var r = S(e);
              !t.contextShown() && r ? (e.contextLayer && e.contextLayer.render(e.panels, !0), t.contextShown(!0)) : t.contextShown() && !r && (e.contextLayer && e.contextLayer.render(e.panels, !0, !0), t.contextShown(!1));
            }, function (r) {
              if (h.focusLayer.render(h.panels, !0), h.pickLayer && h.pickLayer.render(h.panels, !0), t.linePickActive(!0), e && e.filterChanged) {
                var n = d.invert,
                    a = r.map(function (t) {
                  return t.map(n).sort(o.sorterAsc);
                }).sort(function (t, e) {
                  return t[0] - e[0];
                });
                e.filterChanged(h.key, i._index, a);
              }
            })
          };
        }), h;
      }

      function C(t) {
        t.classed(v.cn.axisExtentText, !0).attr("text-anchor", "middle").style("cursor", "default");
      }

      function P(t, e) {
        var r = "top" === e ? 1 : -1,
            n = t * Math.PI / 180;
        return {
          dir: r,
          dx: Math.sin(n),
          dy: Math.cos(n),
          degrees: t
        };
      }

      function I(t, e) {
        for (var r = e.panels || (e.panels = []), n = t.data(), i = 0; i < n.length - 1; i++) {
          var a = r[i] || (r[i] = {}),
              o = n[i],
              s = n[i + 1];
          a.dim0 = o, a.dim1 = s, a.canvasX = o.canvasX, a.panelSizeX = s.canvasX - o.canvasX, a.panelSizeY = e.model.canvasHeight, a.y = 0, a.canvasY = 0;
        }
      }

      function O(t, e) {
        return a.tickText(t._ax, e, !1).text;
      }

      function z(t, e) {
        if (t.ordinal) return "";
        var r = t.domainScale.domain(),
            n = r[e ? r.length - 1 : 0];
        return O(t.model.dimensions[t.visibleIndex], n);
      }

      e.exports = function (t, e, r, i) {
        var f = t._fullLayout,
            h = f._toppaper,
            b = f._glcontainer,
            w = t._fullLayout.paper_bgcolor;
        !function (t) {
          for (var e = 0; e < t.length; e++) {
            for (var r = 0; r < t[e].length; r++) {
              for (var n = t[e][r].trace, i = n.dimensions, o = 0; o < i.length; o++) {
                var s = i[o].values,
                    l = i[o]._ax;
                l && (l.range ? l.range = T(l.range[0], l.range[1]) : l.range = _(s, n._length), l.dtick || (l.dtick = .01 * (Math.abs(l.range[1] - l.range[0]) || 1)), l.tickformat = i[o].tickformat, a.calcTicks(l), l.cleanRange());
              }
            }
          }
        }(e);
        var k,
            M,
            A = (k = !0, M = !1, {
          linePickActive: function linePickActive(t) {
            return arguments.length ? k = !!t : k;
          },
          contextShown: function contextShown(t) {
            return arguments.length ? M = !!t : M;
          }
        }),
            D = e.filter(function (t) {
          return m(t).trace.visible;
        }).map(E.bind(0, r)).map(L.bind(0, A, i));
        b.each(function (t, e) {
          return o.extendFlat(t, D[e]);
        });
        var R = b.selectAll(".gl-canvas").each(function (t) {
          t.viewModel = D[0], t.viewModel.paperColor = w, t.model = t.viewModel ? t.viewModel.model : null;
        }),
            F = null;
        R.filter(function (t) {
          return t.pick;
        }).style("pointer-events", "auto").on("mousemove", function (t) {
          if (A.linePickActive() && t.lineLayer && i && i.hover) {
            var e = n.event,
                r = this.width,
                a = this.height,
                o = n.mouse(this),
                s = o[0],
                l = o[1];
            if (s < 0 || l < 0 || s >= r || l >= a) return;
            var c = t.lineLayer.readPixel(s, a - 1 - l),
                u = 0 !== c[3],
                f = u ? c[2] + 256 * (c[1] + 256 * c[0]) : null,
                h = {
              x: s,
              y: l,
              clientX: e.clientX,
              clientY: e.clientY,
              dataIndex: t.model.key,
              curveNumber: f
            };
            f !== F && (u ? i.hover(h) : i.unhover && i.unhover(h), F = f);
          }
        }), R.style("opacity", function (t) {
          return t.pick ? 0 : 1;
        }), h.style("background", "rgba(255, 255, 255, 0)");
        var B = h.selectAll("." + v.cn.parcoords).data(D, p);
        B.exit().remove(), B.enter().append("g").classed(v.cn.parcoords, !0).style("shape-rendering", "crispEdges").style("pointer-events", "none"), B.attr("transform", function (t) {
          return l(t.model.translateX, t.model.translateY);
        });
        var N = B.selectAll("." + v.cn.parcoordsControlView).data(d, p);
        N.enter().append("g").classed(v.cn.parcoordsControlView, !0), N.attr("transform", function (t) {
          return l(t.model.pad.l, t.model.pad.t);
        });
        var j = N.selectAll("." + v.cn.yAxis).data(function (t) {
          return t.dimensions;
        }, p);
        j.enter().append("g").classed(v.cn.yAxis, !0), N.each(function (t) {
          I(j, t);
        }), R.each(function (t) {
          if (t.viewModel) {
            !t.lineLayer || i ? t.lineLayer = x(this, t) : t.lineLayer.update(t), (t.key || 0 === t.key) && (t.viewModel[t.key] = t.lineLayer);
            var e = !t.context || i;
            t.lineLayer.render(t.viewModel.panels, e);
          }
        }), j.attr("transform", function (t) {
          return l(t.xScale(t.xIndex), 0);
        }), j.call(n.behavior.drag().origin(function (t) {
          return t;
        }).on("drag", function (t) {
          var e = t.parent;
          A.linePickActive(!1), t.x = Math.max(-v.overdrag, Math.min(t.model.width + v.overdrag, n.event.x)), t.canvasX = t.x * t.model.canvasPixelRatio, j.sort(function (t, e) {
            return t.x - e.x;
          }).each(function (e, r) {
            e.xIndex = r, e.x = t === e ? e.x : e.xScale(e.xIndex), e.canvasX = e.x * e.model.canvasPixelRatio;
          }), I(j, e), j.filter(function (e) {
            return 0 !== Math.abs(t.xIndex - e.xIndex);
          }).attr("transform", function (t) {
            return l(t.xScale(t.xIndex), 0);
          }), n.select(this).attr("transform", l(t.x, 0)), j.each(function (r, n, i) {
            i === t.parent.key && (e.dimensions[n] = r);
          }), e.contextLayer && e.contextLayer.render(e.panels, !1, !S(e)), e.focusLayer.render && e.focusLayer.render(e.panels);
        }).on("dragend", function (t) {
          var e = t.parent;
          t.x = t.xScale(t.xIndex), t.canvasX = t.x * t.model.canvasPixelRatio, I(j, e), n.select(this).attr("transform", function (t) {
            return l(t.x, 0);
          }), e.contextLayer && e.contextLayer.render(e.panels, !1, !S(e)), e.focusLayer && e.focusLayer.render(e.panels), e.pickLayer && e.pickLayer.render(e.panels, !0), A.linePickActive(!0), i && i.axesMoved && i.axesMoved(e.key, e.dimensions.map(function (t) {
            return t.crossfilterDimensionIndex;
          }));
        })), j.exit().remove();
        var U = j.selectAll("." + v.cn.axisOverlays).data(d, p);
        U.enter().append("g").classed(v.cn.axisOverlays, !0), U.selectAll("." + v.cn.axis).remove();
        var V = U.selectAll("." + v.cn.axis).data(d, p);
        V.enter().append("g").classed(v.cn.axis, !0), V.each(function (t) {
          var e = t.model.height / t.model.tickDistance,
              r = t.domainScale,
              i = r.domain();
          n.select(this).call(n.svg.axis().orient("left").tickSize(4).outerTickSize(2).ticks(e, t.tickFormat).tickValues(t.ordinal ? i : null).tickFormat(function (e) {
            return g.isOrdinal(t) ? e : O(t.model.dimensions[t.visibleIndex], e);
          }).scale(r)), u.font(V.selectAll("text"), t.model.tickFont);
        }), V.selectAll(".domain, .tick>line").attr("fill", "none").attr("stroke", "black").attr("stroke-opacity", .25).attr("stroke-width", "1px"), V.selectAll("text").style("text-shadow", c.makeTextShadow(w)).style("cursor", "default");
        var q = U.selectAll("." + v.cn.axisHeading).data(d, p);
        q.enter().append("g").classed(v.cn.axisHeading, !0);
        var H = q.selectAll("." + v.cn.axisTitle).data(d, p);
        H.enter().append("text").classed(v.cn.axisTitle, !0).attr("text-anchor", "middle").style("cursor", "ew-resize").style("pointer-events", "auto"), H.text(function (t) {
          return t.label;
        }).each(function (e) {
          var r = n.select(this);
          u.font(r, e.model.labelFont), c.convertToTspans(r, t);
        }).attr("transform", function (t) {
          var e = P(t.model.labelAngle, t.model.labelSide),
              r = v.axisTitleOffset;
          return (e.dir > 0 ? "" : l(0, 2 * r + t.model.height)) + s(e.degrees) + l(-r * e.dx, -r * e.dy);
        }).attr("text-anchor", function (t) {
          var e = P(t.model.labelAngle, t.model.labelSide);
          return 2 * Math.abs(e.dx) > Math.abs(e.dy) ? e.dir * e.dx < 0 ? "start" : "end" : "middle";
        });
        var G = U.selectAll("." + v.cn.axisExtent).data(d, p);
        G.enter().append("g").classed(v.cn.axisExtent, !0);
        var Y = G.selectAll("." + v.cn.axisExtentTop).data(d, p);
        Y.enter().append("g").classed(v.cn.axisExtentTop, !0), Y.attr("transform", l(0, -v.axisExtentOffset));
        var W = Y.selectAll("." + v.cn.axisExtentTopText).data(d, p);
        W.enter().append("text").classed(v.cn.axisExtentTopText, !0).call(C), W.text(function (t) {
          return z(t, !0);
        }).each(function (t) {
          u.font(n.select(this), t.model.rangeFont);
        });
        var X = G.selectAll("." + v.cn.axisExtentBottom).data(d, p);
        X.enter().append("g").classed(v.cn.axisExtentBottom, !0), X.attr("transform", function (t) {
          return l(0, t.model.height + v.axisExtentOffset);
        });
        var Z = X.selectAll("." + v.cn.axisExtentBottomText).data(d, p);
        Z.enter().append("text").classed(v.cn.axisExtentBottomText, !0).attr("dy", "0.75em").call(C), Z.text(function (t) {
          return z(t, !1);
        }).each(function (t) {
          u.font(n.select(this), t.model.rangeFont);
        }), y.ensureAxisBrush(U, w);
      };
    }, {
      "../../components/colorscale": 670,
      "../../components/drawing": 680,
      "../../lib": 795,
      "../../lib/gup": 792,
      "../../lib/svg_text_utils": 820,
      "../../plots/cartesian/axes": 845,
      "./axisbrush": 1162,
      "./constants": 1165,
      "./helpers": 1167,
      "./lines": 1169,
      "@plotly/d3": 57,
      "color-rgba": 128
    }],
    1172: [function (t, e, r) {
      "use strict";

      var n = t("./parcoords"),
          i = t("../../lib/prepare_regl"),
          a = t("./helpers").isVisible;

      function o(t, e, r) {
        var n = e.indexOf(r),
            i = t.indexOf(n);
        return -1 === i && (i += e.length), i;
      }

      e.exports = function (t, e) {
        var r = t._fullLayout;

        if (i(t)) {
          var s = {},
              l = {},
              c = {},
              u = {},
              f = r._size;
          e.forEach(function (e, r) {
            var n = e[0].trace;
            c[r] = n.index;
            var i = u[r] = n._fullInput.index;
            s[r] = t.data[i].dimensions, l[r] = t.data[i].dimensions.slice();
          });
          n(t, e, {
            width: f.w,
            height: f.h,
            margin: {
              t: f.t,
              r: f.r,
              b: f.b,
              l: f.l
            }
          }, {
            filterChanged: function filterChanged(e, n, i) {
              var a = l[e][n],
                  o = i.map(function (t) {
                return t.slice();
              }),
                  s = "dimensions[" + n + "].constraintrange",
                  f = r._tracePreGUI[t._fullData[c[e]]._fullInput.uid];

              if (void 0 === f[s]) {
                var h = a.constraintrange;
                f[s] = h || null;
              }

              var p = t._fullData[c[e]].dimensions[n];
              o.length ? (1 === o.length && (o = o[0]), a.constraintrange = o, p.constraintrange = o.slice(), o = [o]) : (delete a.constraintrange, delete p.constraintrange, o = null);
              var d = {};
              d[s] = o, t.emit("plotly_restyle", [d, [u[e]]]);
            },
            hover: function hover(e) {
              t.emit("plotly_hover", e);
            },
            unhover: function unhover(e) {
              t.emit("plotly_unhover", e);
            },
            axesMoved: function axesMoved(e, r) {
              var n = function (t, e) {
                return function (r, n) {
                  return o(t, e, r) - o(t, e, n);
                };
              }(r, l[e].filter(a));

              s[e].sort(n), l[e].filter(function (t) {
                return !a(t);
              }).sort(function (t) {
                return l[e].indexOf(t);
              }).forEach(function (t) {
                s[e].splice(s[e].indexOf(t), 1), s[e].splice(l[e].indexOf(t), 0, t);
              }), t.emit("plotly_restyle", [{
                dimensions: [s[e]]
              }, [u[e]]]);
            }
          });
        }
      };
    }, {
      "../../lib/prepare_regl": 808,
      "./helpers": 1167,
      "./parcoords": 1171
    }],
    1173: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/attributes"),
          i = t("../../plots/domain").attributes,
          a = t("../../plots/font_attributes"),
          o = t("../../components/color/attributes"),
          s = t("../../plots/template_attributes").hovertemplateAttrs,
          l = t("../../plots/template_attributes").texttemplateAttrs,
          c = t("../../lib/extend").extendFlat,
          u = a({
        editType: "plot",
        arrayOk: !0,
        colorEditType: "plot"
      });
      e.exports = {
        labels: {
          valType: "data_array",
          editType: "calc"
        },
        label0: {
          valType: "number",
          dflt: 0,
          editType: "calc"
        },
        dlabel: {
          valType: "number",
          dflt: 1,
          editType: "calc"
        },
        values: {
          valType: "data_array",
          editType: "calc"
        },
        marker: {
          colors: {
            valType: "data_array",
            editType: "calc"
          },
          line: {
            color: {
              valType: "color",
              dflt: o.defaultLine,
              arrayOk: !0,
              editType: "style"
            },
            width: {
              valType: "number",
              min: 0,
              dflt: 0,
              arrayOk: !0,
              editType: "style"
            },
            editType: "calc"
          },
          editType: "calc"
        },
        text: {
          valType: "data_array",
          editType: "plot"
        },
        hovertext: {
          valType: "string",
          dflt: "",
          arrayOk: !0,
          editType: "style"
        },
        scalegroup: {
          valType: "string",
          dflt: "",
          editType: "calc"
        },
        textinfo: {
          valType: "flaglist",
          flags: ["label", "text", "value", "percent"],
          extras: ["none"],
          editType: "calc"
        },
        hoverinfo: c({}, n.hoverinfo, {
          flags: ["label", "text", "value", "percent", "name"]
        }),
        hovertemplate: s({}, {
          keys: ["label", "color", "value", "percent", "text"]
        }),
        texttemplate: l({
          editType: "plot"
        }, {
          keys: ["label", "color", "value", "percent", "text"]
        }),
        textposition: {
          valType: "enumerated",
          values: ["inside", "outside", "auto", "none"],
          dflt: "auto",
          arrayOk: !0,
          editType: "plot"
        },
        textfont: c({}, u, {}),
        insidetextorientation: {
          valType: "enumerated",
          values: ["horizontal", "radial", "tangential", "auto"],
          dflt: "auto",
          editType: "plot"
        },
        insidetextfont: c({}, u, {}),
        outsidetextfont: c({}, u, {}),
        automargin: {
          valType: "boolean",
          dflt: !1,
          editType: "plot"
        },
        title: {
          text: {
            valType: "string",
            dflt: "",
            editType: "plot"
          },
          font: c({}, u, {}),
          position: {
            valType: "enumerated",
            values: ["top left", "top center", "top right", "middle center", "bottom left", "bottom center", "bottom right"],
            editType: "plot"
          },
          editType: "plot"
        },
        domain: i({
          name: "pie",
          trace: !0,
          editType: "calc"
        }),
        hole: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 0,
          editType: "calc"
        },
        sort: {
          valType: "boolean",
          dflt: !0,
          editType: "calc"
        },
        direction: {
          valType: "enumerated",
          values: ["clockwise", "counterclockwise"],
          dflt: "counterclockwise",
          editType: "calc"
        },
        rotation: {
          valType: "number",
          min: -360,
          max: 360,
          dflt: 0,
          editType: "calc"
        },
        pull: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 0,
          arrayOk: !0,
          editType: "calc"
        },
        _deprecated: {
          title: {
            valType: "string",
            dflt: "",
            editType: "calc"
          },
          titlefont: c({}, u, {}),
          titleposition: {
            valType: "enumerated",
            values: ["top left", "top center", "top right", "middle center", "bottom left", "bottom center", "bottom right"],
            editType: "calc"
          }
        }
      };
    }, {
      "../../components/color/attributes": 657,
      "../../lib/extend": 785,
      "../../plots/attributes": 841,
      "../../plots/domain": 872,
      "../../plots/font_attributes": 873,
      "../../plots/template_attributes": 918
    }],
    1174: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/plots");
      r.name = "pie", r.plot = function (t, e, i, a) {
        n.plotBasePlot(r.name, t, e, i, a);
      }, r.clean = function (t, e, i, a) {
        n.cleanBasePlot(r.name, t, e, i, a);
      };
    }, {
      "../../plots/plots": 909
    }],
    1175: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("tinycolor2"),
          a = t("../../components/color"),
          o = {};

      function s(t) {
        return function (e, r) {
          return !!e && !!(e = i(e)).isValid() && (e = a.addOpacity(e, e.getAlpha()), t[r] || (t[r] = e), e);
        };
      }

      function l(t, e) {
        var r,
            n = JSON.stringify(t),
            a = e[n];

        if (!a) {
          for (a = t.slice(), r = 0; r < t.length; r++) {
            a.push(i(t[r]).lighten(20).toHexString());
          }

          for (r = 0; r < t.length; r++) {
            a.push(i(t[r]).darken(20).toHexString());
          }

          e[n] = a;
        }

        return a;
      }

      e.exports = {
        calc: function calc(t, e) {
          var r,
              i,
              a = [],
              o = t._fullLayout,
              l = o.hiddenlabels || [],
              c = e.labels,
              u = e.marker.colors || [],
              f = e.values,
              h = e._length,
              p = e._hasValues && h;
          if (e.dlabel) for (c = new Array(h), r = 0; r < h; r++) {
            c[r] = String(e.label0 + r * e.dlabel);
          }
          var d = {},
              m = s(o["_" + e.type + "colormap"]),
              g = 0,
              v = !1;

          for (r = 0; r < h; r++) {
            var y, x, b;

            if (p) {
              if (y = f[r], !n(y)) continue;
              if ((y = +y) < 0) continue;
            } else y = 1;

            void 0 !== (x = c[r]) && "" !== x || (x = r);
            var _ = d[x = String(x)];
            void 0 === _ ? (d[x] = a.length, (b = -1 !== l.indexOf(x)) || (g += y), a.push({
              v: y,
              label: x,
              color: m(u[r], x),
              i: r,
              pts: [r],
              hidden: b
            })) : (v = !0, (i = a[_]).v += y, i.pts.push(r), i.hidden || (g += y), !1 === i.color && u[r] && (i.color = m(u[r], x)));
          }

          return ("funnelarea" === e.type ? v : e.sort) && a.sort(function (t, e) {
            return e.v - t.v;
          }), a[0] && (a[0].vTotal = g), a;
        },
        crossTraceCalc: function crossTraceCalc(t, e) {
          var r = (e || {}).type;
          r || (r = "pie");
          var n = t._fullLayout,
              i = t.calcdata,
              a = n[r + "colorway"],
              s = n["_" + r + "colormap"];
          n["extend" + r + "colors"] && (a = l(a, o));

          for (var c = 0, u = 0; u < i.length; u++) {
            var f = i[u];
            if (f[0].trace.type === r) for (var h = 0; h < f.length; h++) {
              var p = f[h];
              !1 === p.color && (s[p.label] ? p.color = s[p.label] : (s[p.label] = p.color = a[c % a.length], c++));
            }
          }
        },
        makePullColorFn: s,
        generateExtendedColors: l
      };
    }, {
      "../../components/color": 658,
      "fast-isnumeric": 240,
      tinycolor2: 590
    }],
    1176: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../lib"),
          a = t("./attributes"),
          o = t("../../plots/domain").defaults,
          s = t("../bar/defaults").handleText;

      function l(t, e) {
        var r = Array.isArray(t),
            a = i.isArrayOrTypedArray(e),
            o = Math.min(r ? t.length : 1 / 0, a ? e.length : 1 / 0);

        if (isFinite(o) || (o = 0), o && a) {
          for (var s, l = 0; l < o; l++) {
            var c = e[l];

            if (n(c) && c > 0) {
              s = !0;
              break;
            }
          }

          s || (o = 0);
        }

        return {
          hasLabels: r,
          hasValues: a,
          len: o
        };
      }

      e.exports = {
        handleLabelsAndValues: l,
        supplyDefaults: function supplyDefaults(t, e, r, n) {
          function c(r, n) {
            return i.coerce(t, e, a, r, n);
          }

          var u = l(c("labels"), c("values")),
              f = u.len;

          if (e._hasLabels = u.hasLabels, e._hasValues = u.hasValues, !e._hasLabels && e._hasValues && (c("label0"), c("dlabel")), f) {
            e._length = f, c("marker.line.width") && c("marker.line.color"), c("marker.colors"), c("scalegroup");
            var h,
                p = c("text"),
                d = c("texttemplate");

            if (d || (h = c("textinfo", Array.isArray(p) ? "text+percent" : "percent")), c("hovertext"), c("hovertemplate"), d || h && "none" !== h) {
              var m = c("textposition");
              s(t, e, n, c, m, {
                moduleHasSelected: !1,
                moduleHasUnselected: !1,
                moduleHasConstrain: !1,
                moduleHasCliponaxis: !1,
                moduleHasTextangle: !1,
                moduleHasInsideanchor: !1
              }), (Array.isArray(m) || "auto" === m || "outside" === m) && c("automargin"), ("inside" === m || "auto" === m || Array.isArray(m)) && c("insidetextorientation");
            }

            o(e, n, c);
            var g = c("hole");

            if (c("title.text")) {
              var v = c("title.position", g ? "middle center" : "top center");
              g || "middle center" !== v || (e.title.position = "top center"), i.coerceFont(c, "title.font", n.font);
            }

            c("sort"), c("direction"), c("rotation"), c("pull");
          } else e.visible = !1;
        }
      };
    }, {
      "../../lib": 795,
      "../../plots/domain": 872,
      "../bar/defaults": 937,
      "./attributes": 1173,
      "fast-isnumeric": 240
    }],
    1177: [function (t, e, r) {
      "use strict";

      var n = t("../../components/fx/helpers").appendArrayMultiPointValues;

      e.exports = function (t, e) {
        var r = {
          curveNumber: e.index,
          pointNumbers: t.pts,
          data: e._input,
          fullData: e,
          label: t.label,
          color: t.color,
          value: t.v,
          percent: t.percent,
          text: t.text,
          v: t.v
        };
        return 1 === t.pts.length && (r.pointNumber = r.i = t.pts[0]), n(r, e, t.pts), "funnelarea" === e.type && (delete r.v, delete r.i), r;
      };
    }, {
      "../../components/fx/helpers": 694
    }],
    1178: [function (t, e, r) {
      "use strict";

      var n = t("../../lib");

      function i(t) {
        return -1 !== t.indexOf("e") ? t.replace(/[.]?0+e/, "e") : -1 !== t.indexOf(".") ? t.replace(/[.]?0+$/, "") : t;
      }

      r.formatPiePercent = function (t, e) {
        var r = i((100 * t).toPrecision(3));
        return n.numSeparate(r, e) + "%";
      }, r.formatPieValue = function (t, e) {
        var r = i(t.toPrecision(10));
        return n.numSeparate(r, e);
      }, r.getFirstFilled = function (t, e) {
        if (Array.isArray(t)) for (var r = 0; r < e.length; r++) {
          var n = t[e[r]];
          if (n || 0 === n || "" === n) return n;
        }
      }, r.castOption = function (t, e) {
        return Array.isArray(t) ? r.getFirstFilled(t, e) : t || void 0;
      }, r.getRotationAngle = function (t) {
        return ("auto" === t ? 0 : t) * Math.PI / 180;
      };
    }, {
      "../../lib": 795
    }],
    1179: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults").supplyDefaults,
        supplyLayoutDefaults: t("./layout_defaults"),
        layoutAttributes: t("./layout_attributes"),
        calc: t("./calc").calc,
        crossTraceCalc: t("./calc").crossTraceCalc,
        plot: t("./plot").plot,
        style: t("./style"),
        styleOne: t("./style_one"),
        moduleType: "trace",
        name: "pie",
        basePlotModule: t("./base_plot"),
        categories: ["pie-like", "pie", "showLegend"],
        meta: {}
      };
    }, {
      "./attributes": 1173,
      "./base_plot": 1174,
      "./calc": 1175,
      "./defaults": 1176,
      "./layout_attributes": 1180,
      "./layout_defaults": 1181,
      "./plot": 1182,
      "./style": 1183,
      "./style_one": 1184
    }],
    1180: [function (t, e, r) {
      "use strict";

      e.exports = {
        hiddenlabels: {
          valType: "data_array",
          editType: "calc"
        },
        piecolorway: {
          valType: "colorlist",
          editType: "calc"
        },
        extendpiecolors: {
          valType: "boolean",
          dflt: !0,
          editType: "calc"
        }
      };
    }, {}],
    1181: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./layout_attributes");

      e.exports = function (t, e) {
        function r(r, a) {
          return n.coerce(t, e, i, r, a);
        }

        r("hiddenlabels"), r("piecolorway", e.colorway), r("extendpiecolors");
      };
    }, {
      "../../lib": 795,
      "./layout_attributes": 1180
    }],
    1182: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../plots/plots"),
          a = t("../../components/fx"),
          o = t("../../components/color"),
          s = t("../../components/drawing"),
          l = t("../../lib"),
          c = l.strScale,
          u = l.strTranslate,
          f = t("../../lib/svg_text_utils"),
          h = t("../bar/uniform_text"),
          p = h.recordMinTextSize,
          d = h.clearMinTextSize,
          m = t("../bar/constants").TEXTPAD,
          g = t("./helpers"),
          v = t("./event_data"),
          y = t("../../lib").isValidTextValue;

      function x(t, e, r) {
        var i = r[0],
            o = i.trace,
            s = i.cx,
            c = i.cy;
        "_hasHoverLabel" in o || (o._hasHoverLabel = !1), "_hasHoverEvent" in o || (o._hasHoverEvent = !1), t.on("mouseover", function (t) {
          var r = e._fullLayout,
              u = e._fullData[o.index];

          if (!e._dragging && !1 !== r.hovermode) {
            var f = u.hoverinfo;

            if (Array.isArray(f) && (f = a.castHoverinfo({
              hoverinfo: [g.castOption(f, t.pts)],
              _module: o._module
            }, r, 0)), "all" === f && (f = "label+text+value+percent+name"), u.hovertemplate || "none" !== f && "skip" !== f && f) {
              var h = t.rInscribed || 0,
                  p = s + t.pxmid[0] * (1 - h),
                  d = c + t.pxmid[1] * (1 - h),
                  m = r.separators,
                  y = [];

              if (f && -1 !== f.indexOf("label") && y.push(t.label), t.text = g.castOption(u.hovertext || u.text, t.pts), f && -1 !== f.indexOf("text")) {
                var x = t.text;
                l.isValidTextValue(x) && y.push(x);
              }

              t.value = t.v, t.valueLabel = g.formatPieValue(t.v, m), f && -1 !== f.indexOf("value") && y.push(t.valueLabel), t.percent = t.v / i.vTotal, t.percentLabel = g.formatPiePercent(t.percent, m), f && -1 !== f.indexOf("percent") && y.push(t.percentLabel);
              var b = u.hoverlabel,
                  _ = b.font;
              a.loneHover({
                trace: o,
                x0: p - h * i.r,
                x1: p + h * i.r,
                y: d,
                text: y.join("<br>"),
                name: u.hovertemplate || -1 !== f.indexOf("name") ? u.name : void 0,
                idealAlign: t.pxmid[0] < 0 ? "left" : "right",
                color: g.castOption(b.bgcolor, t.pts) || t.color,
                borderColor: g.castOption(b.bordercolor, t.pts),
                fontFamily: g.castOption(_.family, t.pts),
                fontSize: g.castOption(_.size, t.pts),
                fontColor: g.castOption(_.color, t.pts),
                nameLength: g.castOption(b.namelength, t.pts),
                textAlign: g.castOption(b.align, t.pts),
                hovertemplate: g.castOption(u.hovertemplate, t.pts),
                hovertemplateLabels: t,
                eventData: [v(t, u)]
              }, {
                container: r._hoverlayer.node(),
                outerContainer: r._paper.node(),
                gd: e
              }), o._hasHoverLabel = !0;
            }

            o._hasHoverEvent = !0, e.emit("plotly_hover", {
              points: [v(t, u)],
              event: n.event
            });
          }
        }), t.on("mouseout", function (t) {
          var r = e._fullLayout,
              i = e._fullData[o.index],
              s = n.select(this).datum();
          o._hasHoverEvent && (t.originalEvent = n.event, e.emit("plotly_unhover", {
            points: [v(s, i)],
            event: n.event
          }), o._hasHoverEvent = !1), o._hasHoverLabel && (a.loneUnhover(r._hoverlayer.node()), o._hasHoverLabel = !1);
        }), t.on("click", function (t) {
          var r = e._fullLayout,
              i = e._fullData[o.index];
          e._dragging || !1 === r.hovermode || (e._hoverdata = [v(t, i)], a.click(e, n.event));
        });
      }

      function b(t, e, r) {
        var n = g.castOption(t.insidetextfont.color, e.pts);
        !n && t._input.textfont && (n = g.castOption(t._input.textfont.color, e.pts));
        var i = g.castOption(t.insidetextfont.family, e.pts) || g.castOption(t.textfont.family, e.pts) || r.family,
            a = g.castOption(t.insidetextfont.size, e.pts) || g.castOption(t.textfont.size, e.pts) || r.size;
        return {
          color: n || o.contrast(e.color),
          family: i,
          size: a
        };
      }

      function _(t, e) {
        for (var r, n, i = 0; i < t.length; i++) {
          if ((n = (r = t[i][0]).trace).title.text) {
            var a = n.title.text;
            n._meta && (a = l.templateString(a, n._meta));
            var o = s.tester.append("text").attr("data-notex", 1).text(a).call(s.font, n.title.font).call(f.convertToTspans, e),
                c = s.bBox(o.node(), !0);
            r.titleBox = {
              width: c.width,
              height: c.height
            }, o.remove();
          }
        }
      }

      function w(t, e, r) {
        var n = r.r || e.rpx1,
            i = e.rInscribed;
        if (e.startangle === e.stopangle) return {
          rCenter: 1 - i,
          scale: 0,
          rotate: 0,
          textPosAngle: 0
        };
        var a,
            o = e.ring,
            s = 1 === o && Math.abs(e.startangle - e.stopangle) === 2 * Math.PI,
            l = e.halfangle,
            c = e.midangle,
            u = r.trace.insidetextorientation,
            f = "horizontal" === u,
            h = "tangential" === u,
            p = "radial" === u,
            d = "auto" === u,
            m = [];

        if (!d) {
          var g,
              v = function v(r, i) {
            if (function (t, e) {
              var r = t.startangle,
                  n = t.stopangle;
              return r > e && e > n || r < e && e < n;
            }(e, r)) {
              var s = Math.abs(r - e.startangle),
                  l = Math.abs(r - e.stopangle),
                  c = s < l ? s : l;
              (a = "tan" === i ? k(t, n, o, c, 0) : T(t, n, o, c, Math.PI / 2)).textPosAngle = r, m.push(a);
            }
          };

          if (f || h) {
            for (g = 4; g >= -4; g -= 2) {
              v(Math.PI * g, "tan");
            }

            for (g = 4; g >= -4; g -= 2) {
              v(Math.PI * (g + 1), "tan");
            }
          }

          if (f || p) {
            for (g = 4; g >= -4; g -= 2) {
              v(Math.PI * (g + 1.5), "rad");
            }

            for (g = 4; g >= -4; g -= 2) {
              v(Math.PI * (g + .5), "rad");
            }
          }
        }

        if (s || d || f) {
          var y = Math.sqrt(t.width * t.width + t.height * t.height);
          if ((a = {
            scale: i * n * 2 / y,
            rCenter: 1 - i,
            rotate: 0
          }).textPosAngle = (e.startangle + e.stopangle) / 2, a.scale >= 1) return a;
          m.push(a);
        }

        (d || p) && ((a = T(t, n, o, l, c)).textPosAngle = (e.startangle + e.stopangle) / 2, m.push(a)), (d || h) && ((a = k(t, n, o, l, c)).textPosAngle = (e.startangle + e.stopangle) / 2, m.push(a));

        for (var x = 0, b = 0, _ = 0; _ < m.length; _++) {
          var w = m[_].scale;
          if (b < w && (b = w, x = _), !d && b >= 1) break;
        }

        return m[x];
      }

      function T(t, e, r, n, i) {
        e = Math.max(0, e - 2 * m);
        var a = t.width / t.height,
            o = S(a, n, e, r);
        return {
          scale: 2 * o / t.height,
          rCenter: M(a, o / e),
          rotate: A(i)
        };
      }

      function k(t, e, r, n, i) {
        e = Math.max(0, e - 2 * m);
        var a = t.height / t.width,
            o = S(a, n, e, r);
        return {
          scale: 2 * o / t.width,
          rCenter: M(a, o / e),
          rotate: A(i + Math.PI / 2)
        };
      }

      function M(t, e) {
        return Math.cos(e) - t * e;
      }

      function A(t) {
        return (180 / Math.PI * t + 720) % 180 - 90;
      }

      function S(t, e, r, n) {
        var i = t + 1 / (2 * Math.tan(e));
        return r * Math.min(1 / (Math.sqrt(i * i + .5) + i), n / (Math.sqrt(t * t + n / 2) + t));
      }

      function E(t, e) {
        return t.v !== e.vTotal || e.trace.hole ? Math.min(1 / (1 + 1 / Math.sin(t.halfangle)), t.ring / 2) : 1;
      }

      function L(t, e) {
        var r = e.pxmid[0],
            n = e.pxmid[1],
            i = t.width / 2,
            a = t.height / 2;
        return r < 0 && (i *= -1), n < 0 && (a *= -1), {
          scale: 1,
          rCenter: 1,
          rotate: 0,
          x: i + Math.abs(a) * (i > 0 ? 1 : -1) / 2,
          y: a / (1 + r * r / (n * n)),
          outside: !0
        };
      }

      function C(t, e) {
        var r,
            n,
            i,
            a = t.trace,
            o = {
          x: t.cx,
          y: t.cy
        },
            s = {
          tx: 0,
          ty: 0
        };
        s.ty += a.title.font.size, i = I(a), -1 !== a.title.position.indexOf("top") ? (o.y -= (1 + i) * t.r, s.ty -= t.titleBox.height) : -1 !== a.title.position.indexOf("bottom") && (o.y += (1 + i) * t.r);
        var l,
            c,
            u = (l = t.r, c = t.trace.aspectratio, l / (void 0 === c ? 1 : c)),
            f = e.w * (a.domain.x[1] - a.domain.x[0]) / 2;
        return -1 !== a.title.position.indexOf("left") ? (f += u, o.x -= (1 + i) * u, s.tx += t.titleBox.width / 2) : -1 !== a.title.position.indexOf("center") ? f *= 2 : -1 !== a.title.position.indexOf("right") && (f += u, o.x += (1 + i) * u, s.tx -= t.titleBox.width / 2), r = f / t.titleBox.width, n = P(t, e) / t.titleBox.height, {
          x: o.x,
          y: o.y,
          scale: Math.min(r, n),
          tx: s.tx,
          ty: s.ty
        };
      }

      function P(t, e) {
        var r = t.trace,
            n = e.h * (r.domain.y[1] - r.domain.y[0]);
        return Math.min(t.titleBox.height, n / 2);
      }

      function I(t) {
        var e,
            r = t.pull;
        if (!r) return 0;
        if (Array.isArray(r)) for (r = 0, e = 0; e < t.pull.length; e++) {
          t.pull[e] > r && (r = t.pull[e]);
        }
        return r;
      }

      function O(t, e) {
        for (var r = [], n = 0; n < t.length; n++) {
          var i = t[n][0],
              a = i.trace,
              o = a.domain,
              s = e.w * (o.x[1] - o.x[0]),
              l = e.h * (o.y[1] - o.y[0]);
          a.title.text && "middle center" !== a.title.position && (l -= P(i, e));
          var c = s / 2,
              u = l / 2;
          "funnelarea" !== a.type || a.scalegroup || (u /= a.aspectratio), i.r = Math.min(c, u) / (1 + I(a)), i.cx = e.l + e.w * (a.domain.x[1] + a.domain.x[0]) / 2, i.cy = e.t + e.h * (1 - a.domain.y[0]) - l / 2, a.title.text && -1 !== a.title.position.indexOf("bottom") && (i.cy -= P(i, e)), a.scalegroup && -1 === r.indexOf(a.scalegroup) && r.push(a.scalegroup);
        }

        !function (t, e) {
          for (var r, n, i, a = 0; a < e.length; a++) {
            var o = 1 / 0,
                s = e[a];

            for (n = 0; n < t.length; n++) {
              if (r = t[n][0], (i = r.trace).scalegroup === s) {
                var l;
                if ("pie" === i.type) l = r.r * r.r;else if ("funnelarea" === i.type) {
                  var c, u;
                  i.aspectratio > 1 ? (c = r.r, u = c / i.aspectratio) : (u = r.r, c = u * i.aspectratio), c *= (1 + i.baseratio) / 2, l = c * u;
                }
                o = Math.min(o, l / r.vTotal);
              }
            }

            for (n = 0; n < t.length; n++) {
              if (r = t[n][0], (i = r.trace).scalegroup === s) {
                var f = o * r.vTotal;
                "funnelarea" === i.type && (f /= (1 + i.baseratio) / 2, f /= i.aspectratio), r.r = Math.sqrt(f);
              }
            }
          }
        }(t, r);
      }

      function z(t, e) {
        return [t * Math.sin(e), -t * Math.cos(e)];
      }

      function D(t, e, r) {
        var n = t._fullLayout,
            i = r.trace,
            a = i.texttemplate,
            o = i.textinfo;

        if (!a && o && "none" !== o) {
          var s,
              c = o.split("+"),
              u = function u(t) {
            return -1 !== c.indexOf(t);
          },
              f = u("label"),
              h = u("text"),
              p = u("value"),
              d = u("percent"),
              m = n.separators;

          if (s = f ? [e.label] : [], h) {
            var v = g.getFirstFilled(i.text, e.pts);
            y(v) && s.push(v);
          }

          p && s.push(g.formatPieValue(e.v, m)), d && s.push(g.formatPiePercent(e.v / r.vTotal, m)), e.text = s.join("<br>");
        }

        if (a) {
          var x = l.castOption(i, e.i, "texttemplate");

          if (x) {
            var b = function (t) {
              return {
                label: t.label,
                value: t.v,
                valueLabel: g.formatPieValue(t.v, n.separators),
                percent: t.v / r.vTotal,
                percentLabel: g.formatPiePercent(t.v / r.vTotal, n.separators),
                color: t.color,
                text: t.text,
                customdata: l.castOption(i, t.i, "customdata")
              };
            }(e),
                _ = g.getFirstFilled(i.text, e.pts);

            (y(_) || "" === _) && (b.text = _), e.text = l.texttemplateString(x, b, t._fullLayout._d3locale, b, i._meta || {});
          } else e.text = "";
        }
      }

      function R(t, e) {
        var r = t.rotate * Math.PI / 180,
            n = Math.cos(r),
            i = Math.sin(r),
            a = (e.left + e.right) / 2,
            o = (e.top + e.bottom) / 2;
        t.textX = a * n - o * i, t.textY = a * i + o * n, t.noCenter = !0;
      }

      e.exports = {
        plot: function plot(t, e) {
          var r = t._fullLayout,
              a = r._size;
          d("pie", r), _(e, t), O(e, a);
          var h = l.makeTraceGroups(r._pielayer, e, "trace").each(function (e) {
            var h = n.select(this),
                d = e[0],
                m = d.trace;
            !function (t) {
              var e,
                  r,
                  n,
                  i = t[0],
                  a = i.r,
                  o = i.trace,
                  s = g.getRotationAngle(o.rotation),
                  l = 2 * Math.PI / i.vTotal,
                  c = "px0",
                  u = "px1";

              if ("counterclockwise" === o.direction) {
                for (e = 0; e < t.length && t[e].hidden; e++) {
                  ;
                }

                if (e === t.length) return;
                s += l * t[e].v, l *= -1, c = "px1", u = "px0";
              }

              for (n = z(a, s), e = 0; e < t.length; e++) {
                (r = t[e]).hidden || (r[c] = n, r.startangle = s, s += l * r.v / 2, r.pxmid = z(a, s), r.midangle = s, s += l * r.v / 2, n = z(a, s), r.stopangle = s, r[u] = n, r.largeArc = r.v > i.vTotal / 2 ? 1 : 0, r.halfangle = Math.PI * Math.min(r.v / i.vTotal, .5), r.ring = 1 - o.hole, r.rInscribed = E(r, i));
              }
            }(e), h.attr("stroke-linejoin", "round"), h.each(function () {
              var v = n.select(this).selectAll("g.slice").data(e);
              v.enter().append("g").classed("slice", !0), v.exit().remove();

              var y = [[[], []], [[], []]],
                  _ = !1;

              v.each(function (i, a) {
                if (i.hidden) n.select(this).selectAll("path,g").remove();else {
                  i.pointNumber = i.i, i.curveNumber = m.index, y[i.pxmid[1] < 0 ? 0 : 1][i.pxmid[0] < 0 ? 0 : 1].push(i);
                  var o = d.cx,
                      c = d.cy,
                      u = n.select(this),
                      h = u.selectAll("path.surface").data([i]);

                  if (h.enter().append("path").classed("surface", !0).style({
                    "pointer-events": "all"
                  }), u.call(x, t, e), m.pull) {
                    var v = +g.castOption(m.pull, i.pts) || 0;
                    v > 0 && (o += v * i.pxmid[0], c += v * i.pxmid[1]);
                  }

                  i.cxFinal = o, i.cyFinal = c;
                  var T = m.hole;

                  if (i.v === d.vTotal) {
                    var k = "M" + (o + i.px0[0]) + "," + (c + i.px0[1]) + C(i.px0, i.pxmid, !0, 1) + C(i.pxmid, i.px0, !0, 1) + "Z";
                    T ? h.attr("d", "M" + (o + T * i.px0[0]) + "," + (c + T * i.px0[1]) + C(i.px0, i.pxmid, !1, T) + C(i.pxmid, i.px0, !1, T) + "Z" + k) : h.attr("d", k);
                  } else {
                    var M = C(i.px0, i.px1, !0, 1);

                    if (T) {
                      var A = 1 - T;
                      h.attr("d", "M" + (o + T * i.px1[0]) + "," + (c + T * i.px1[1]) + C(i.px1, i.px0, !1, T) + "l" + A * i.px0[0] + "," + A * i.px0[1] + M + "Z");
                    } else h.attr("d", "M" + o + "," + c + "l" + i.px0[0] + "," + i.px0[1] + M + "Z");
                  }

                  D(t, i, d);
                  var S = g.castOption(m.textposition, i.pts),
                      E = u.selectAll("g.slicetext").data(i.text && "none" !== S ? [0] : []);
                  E.enter().append("g").classed("slicetext", !0), E.exit().remove(), E.each(function () {
                    var u = l.ensureSingle(n.select(this), "text", "", function (t) {
                      t.attr("data-notex", 1);
                    }),
                        h = l.ensureUniformFontSize(t, "outside" === S ? function (t, e, r) {
                      var n = g.castOption(t.outsidetextfont.color, e.pts) || g.castOption(t.textfont.color, e.pts) || r.color,
                          i = g.castOption(t.outsidetextfont.family, e.pts) || g.castOption(t.textfont.family, e.pts) || r.family,
                          a = g.castOption(t.outsidetextfont.size, e.pts) || g.castOption(t.textfont.size, e.pts) || r.size;
                      return {
                        color: n,
                        family: i,
                        size: a
                      };
                    }(m, i, r.font) : b(m, i, r.font));
                    u.text(i.text).attr({
                      class: "slicetext",
                      transform: "",
                      "text-anchor": "middle"
                    }).call(s.font, h).call(f.convertToTspans, t);
                    var v,
                        y = s.bBox(u.node());
                    if ("outside" === S) v = L(y, i);else if (v = w(y, i, d), "auto" === S && v.scale < 1) {
                      var x = l.ensureUniformFontSize(t, m.outsidetextfont);
                      u.call(s.font, x), v = L(y = s.bBox(u.node()), i);
                    }
                    var T = v.textPosAngle,
                        k = void 0 === T ? i.pxmid : z(d.r, T);

                    if (v.targetX = o + k[0] * v.rCenter + (v.x || 0), v.targetY = c + k[1] * v.rCenter + (v.y || 0), R(v, y), v.outside) {
                      var M = v.targetY;
                      i.yLabelMin = M - y.height / 2, i.yLabelMid = M, i.yLabelMax = M + y.height / 2, i.labelExtraX = 0, i.labelExtraY = 0, _ = !0;
                    }

                    v.fontSize = h.size, p(m.type, v, r), e[a].transform = v, u.attr("transform", l.getTextTransform(v));
                  });
                }

                function C(t, e, r, n) {
                  var a = n * (e[0] - t[0]),
                      o = n * (e[1] - t[1]);
                  return "a" + n * d.r + "," + n * d.r + " 0 " + i.largeArc + (r ? " 1 " : " 0 ") + a + "," + o;
                }
              });
              var T = n.select(this).selectAll("g.titletext").data(m.title.text ? [0] : []);

              if (T.enter().append("g").classed("titletext", !0), T.exit().remove(), T.each(function () {
                var e,
                    r = l.ensureSingle(n.select(this), "text", "", function (t) {
                  t.attr("data-notex", 1);
                }),
                    i = m.title.text;
                m._meta && (i = l.templateString(i, m._meta)), r.text(i).attr({
                  class: "titletext",
                  transform: "",
                  "text-anchor": "middle"
                }).call(s.font, m.title.font).call(f.convertToTspans, t), e = "middle center" === m.title.position ? function (t) {
                  var e = Math.sqrt(t.titleBox.width * t.titleBox.width + t.titleBox.height * t.titleBox.height);
                  return {
                    x: t.cx,
                    y: t.cy,
                    scale: t.trace.hole * t.r * 2 / e,
                    tx: 0,
                    ty: -t.titleBox.height / 2 + t.trace.title.font.size
                  };
                }(d) : C(d, a), r.attr("transform", u(e.x, e.y) + c(Math.min(1, e.scale)) + u(e.tx, e.ty));
              }), _ && function (t, e) {
                var r, n, i, a, o, s, l, c, u, f, h, p, d;

                function m(t, e) {
                  return t.pxmid[1] - e.pxmid[1];
                }

                function v(t, e) {
                  return e.pxmid[1] - t.pxmid[1];
                }

                function y(t, r) {
                  r || (r = {});
                  var i,
                      c,
                      u,
                      h,
                      p = r.labelExtraY + (n ? r.yLabelMax : r.yLabelMin),
                      d = n ? t.yLabelMin : t.yLabelMax,
                      m = n ? t.yLabelMax : t.yLabelMin,
                      v = t.cyFinal + o(t.px0[1], t.px1[1]),
                      y = p - d;
                  if (y * l > 0 && (t.labelExtraY = y), Array.isArray(e.pull)) for (c = 0; c < f.length; c++) {
                    (u = f[c]) === t || (g.castOption(e.pull, t.pts) || 0) >= (g.castOption(e.pull, u.pts) || 0) || ((t.pxmid[1] - u.pxmid[1]) * l > 0 ? (y = u.cyFinal + o(u.px0[1], u.px1[1]) - d - t.labelExtraY) * l > 0 && (t.labelExtraY += y) : (m + t.labelExtraY - v) * l > 0 && (i = 3 * s * Math.abs(c - f.indexOf(t)), (h = u.cxFinal + a(u.px0[0], u.px1[0]) + i - (t.cxFinal + t.pxmid[0]) - t.labelExtraX) * s > 0 && (t.labelExtraX += h)));
                  }
                }

                for (n = 0; n < 2; n++) {
                  for (i = n ? m : v, o = n ? Math.max : Math.min, l = n ? 1 : -1, r = 0; r < 2; r++) {
                    for (a = r ? Math.max : Math.min, s = r ? 1 : -1, (c = t[n][r]).sort(i), u = t[1 - n][r], f = u.concat(c), p = [], h = 0; h < c.length; h++) {
                      void 0 !== c[h].yLabelMid && p.push(c[h]);
                    }

                    for (d = !1, h = 0; n && h < u.length; h++) {
                      if (void 0 !== u[h].yLabelMid) {
                        d = u[h];
                        break;
                      }
                    }

                    for (h = 0; h < p.length; h++) {
                      var x = h && p[h - 1];
                      d && !h && (x = d), y(p[h], x);
                    }
                  }
                }
              }(y, m), function (t, e) {
                t.each(function (t) {
                  var r = n.select(this);

                  if (t.labelExtraX || t.labelExtraY) {
                    var i = r.select("g.slicetext text");
                    t.transform.targetX += t.labelExtraX, t.transform.targetY += t.labelExtraY, i.attr("transform", l.getTextTransform(t.transform));
                    var a = t.cxFinal + t.pxmid[0],
                        s = "M" + a + "," + (t.cyFinal + t.pxmid[1]),
                        c = (t.yLabelMax - t.yLabelMin) * (t.pxmid[0] < 0 ? -1 : 1) / 4;

                    if (t.labelExtraX) {
                      var u = t.labelExtraX * t.pxmid[1] / t.pxmid[0],
                          f = t.yLabelMid + t.labelExtraY - (t.cyFinal + t.pxmid[1]);
                      Math.abs(u) > Math.abs(f) ? s += "l" + f * t.pxmid[0] / t.pxmid[1] + "," + f + "H" + (a + t.labelExtraX + c) : s += "l" + t.labelExtraX + "," + u + "v" + (f - u) + "h" + c;
                    } else s += "V" + (t.yLabelMid + t.labelExtraY) + "h" + c;

                    l.ensureSingle(r, "path", "textline").call(o.stroke, e.outsidetextfont.color).attr({
                      "stroke-width": Math.min(2, e.outsidetextfont.size / 8),
                      d: s,
                      fill: "none"
                    });
                  } else r.select("path.textline").remove();
                });
              }(v, m), _ && m.automargin) {
                var k = s.bBox(h.node()),
                    M = m.domain,
                    A = a.w * (M.x[1] - M.x[0]),
                    S = a.h * (M.y[1] - M.y[0]),
                    E = (.5 * A - d.r) / a.w,
                    P = (.5 * S - d.r) / a.h;
                i.autoMargin(t, "pie." + m.uid + ".automargin", {
                  xl: M.x[0] - E,
                  xr: M.x[1] + E,
                  yb: M.y[0] - P,
                  yt: M.y[1] + P,
                  l: Math.max(d.cx - d.r - k.left, 0),
                  r: Math.max(k.right - (d.cx + d.r), 0),
                  b: Math.max(k.bottom - (d.cy + d.r), 0),
                  t: Math.max(d.cy - d.r - k.top, 0),
                  pad: 5
                });
              }
            });
          });
          setTimeout(function () {
            h.selectAll("tspan").each(function () {
              var t = n.select(this);
              t.attr("dy") && t.attr("dy", t.attr("dy"));
            });
          }, 0);
        },
        formatSliceLabel: D,
        transformInsideText: w,
        determineInsideTextFont: b,
        positionTitleOutside: C,
        prerenderTitles: _,
        layoutAreas: O,
        attachFxHandlers: x,
        computeTransform: R
      };
    }, {
      "../../components/color": 658,
      "../../components/drawing": 680,
      "../../components/fx": 698,
      "../../lib": 795,
      "../../lib/svg_text_utils": 820,
      "../../plots/plots": 909,
      "../bar/constants": 935,
      "../bar/uniform_text": 949,
      "./event_data": 1177,
      "./helpers": 1178,
      "@plotly/d3": 57
    }],
    1183: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("./style_one"),
          a = t("../bar/uniform_text").resizeText;

      e.exports = function (t) {
        var e = t._fullLayout._pielayer.selectAll(".trace");

        a(t, e, "pie"), e.each(function (t) {
          var e = t[0].trace,
              r = n.select(this);
          r.style({
            opacity: e.opacity
          }), r.selectAll("path.surface").each(function (t) {
            n.select(this).call(i, t, e);
          });
        });
      };
    }, {
      "../bar/uniform_text": 949,
      "./style_one": 1184,
      "@plotly/d3": 57
    }],
    1184: [function (t, e, r) {
      "use strict";

      var n = t("../../components/color"),
          i = t("./helpers").castOption;

      e.exports = function (t, e, r) {
        var a = r.marker.line,
            o = i(a.color, e.pts) || n.defaultLine,
            s = i(a.width, e.pts) || 0;
        t.style("stroke-width", s).call(n.fill, e.color).call(n.stroke, o);
      };
    }, {
      "../../components/color": 658,
      "./helpers": 1178
    }],
    1185: [function (t, e, r) {
      "use strict";

      var n = t("../scatter/attributes");
      e.exports = {
        x: n.x,
        y: n.y,
        xy: {
          valType: "data_array",
          editType: "calc"
        },
        indices: {
          valType: "data_array",
          editType: "calc"
        },
        xbounds: {
          valType: "data_array",
          editType: "calc"
        },
        ybounds: {
          valType: "data_array",
          editType: "calc"
        },
        text: n.text,
        marker: {
          color: {
            valType: "color",
            arrayOk: !1,
            editType: "calc"
          },
          opacity: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: 1,
            arrayOk: !1,
            editType: "calc"
          },
          blend: {
            valType: "boolean",
            dflt: null,
            editType: "calc"
          },
          sizemin: {
            valType: "number",
            min: .1,
            max: 2,
            dflt: .5,
            editType: "calc"
          },
          sizemax: {
            valType: "number",
            min: .1,
            dflt: 20,
            editType: "calc"
          },
          border: {
            color: {
              valType: "color",
              arrayOk: !1,
              editType: "calc"
            },
            arearatio: {
              valType: "number",
              min: 0,
              max: 1,
              dflt: 0,
              editType: "calc"
            },
            editType: "calc"
          },
          editType: "calc"
        },
        transforms: void 0
      };
    }, {
      "../scatter/attributes": 1199
    }],
    1186: [function (t, e, r) {
      "use strict";

      var n = t("gl-pointcloud2d"),
          i = t("../../lib/str2rgbarray"),
          a = t("../../plots/cartesian/autorange").findExtremes,
          o = t("../scatter/get_trace_color");

      function s(t, e) {
        this.scene = t, this.uid = e, this.type = "pointcloud", this.pickXData = [], this.pickYData = [], this.xData = [], this.yData = [], this.textLabels = [], this.color = "rgb(0, 0, 0)", this.name = "", this.hoverinfo = "all", this.idToIndex = new Int32Array(0), this.bounds = [0, 0, 0, 0], this.pointcloudOptions = {
          positions: new Float32Array(0),
          idToIndex: this.idToIndex,
          sizemin: .5,
          sizemax: 12,
          color: [0, 0, 0, 1],
          areaRatio: 1,
          borderColor: [0, 0, 0, 1]
        }, this.pointcloud = n(t.glplot, this.pointcloudOptions), this.pointcloud._trace = this;
      }

      var l = s.prototype;
      l.handlePick = function (t) {
        var e = this.idToIndex[t.pointId];
        return {
          trace: this,
          dataCoord: t.dataCoord,
          traceCoord: this.pickXYData ? [this.pickXYData[2 * e], this.pickXYData[2 * e + 1]] : [this.pickXData[e], this.pickYData[e]],
          textLabel: Array.isArray(this.textLabels) ? this.textLabels[e] : this.textLabels,
          color: this.color,
          name: this.name,
          pointIndex: e,
          hoverinfo: this.hoverinfo
        };
      }, l.update = function (t) {
        this.index = t.index, this.textLabels = t.text, this.name = t.name, this.hoverinfo = t.hoverinfo, this.bounds = [1 / 0, 1 / 0, -1 / 0, -1 / 0], this.updateFast(t), this.color = o(t, {});
      }, l.updateFast = function (t) {
        var e,
            r,
            n,
            o,
            s,
            l,
            c = this.xData = this.pickXData = t.x,
            u = this.yData = this.pickYData = t.y,
            f = this.pickXYData = t.xy,
            h = t.xbounds && t.ybounds,
            p = t.indices,
            d = this.bounds;

        if (f) {
          if (n = f, e = f.length >>> 1, h) d[0] = t.xbounds[0], d[2] = t.xbounds[1], d[1] = t.ybounds[0], d[3] = t.ybounds[1];else for (l = 0; l < e; l++) {
            o = n[2 * l], s = n[2 * l + 1], o < d[0] && (d[0] = o), o > d[2] && (d[2] = o), s < d[1] && (d[1] = s), s > d[3] && (d[3] = s);
          }
          if (p) r = p;else for (r = new Int32Array(e), l = 0; l < e; l++) {
            r[l] = l;
          }
        } else for (e = c.length, n = new Float32Array(2 * e), r = new Int32Array(e), l = 0; l < e; l++) {
          o = c[l], s = u[l], r[l] = l, n[2 * l] = o, n[2 * l + 1] = s, o < d[0] && (d[0] = o), o > d[2] && (d[2] = o), s < d[1] && (d[1] = s), s > d[3] && (d[3] = s);
        }

        this.idToIndex = r, this.pointcloudOptions.idToIndex = r, this.pointcloudOptions.positions = n;
        var m = i(t.marker.color),
            g = i(t.marker.border.color),
            v = t.opacity * t.marker.opacity;
        m[3] *= v, this.pointcloudOptions.color = m;
        var y = t.marker.blend;

        if (null === y) {
          y = c.length < 100 || u.length < 100;
        }

        this.pointcloudOptions.blend = y, g[3] *= v, this.pointcloudOptions.borderColor = g;
        var x = t.marker.sizemin,
            b = Math.max(t.marker.sizemax, t.marker.sizemin);
        this.pointcloudOptions.sizeMin = x, this.pointcloudOptions.sizeMax = b, this.pointcloudOptions.areaRatio = t.marker.border.arearatio, this.pointcloud.update(this.pointcloudOptions);
        var _ = this.scene.xaxis,
            w = this.scene.yaxis,
            T = b / 2 || .5;
        t._extremes[_._id] = a(_, [d[0], d[2]], {
          ppad: T
        }), t._extremes[w._id] = a(w, [d[1], d[3]], {
          ppad: T
        });
      }, l.dispose = function () {
        this.pointcloud.dispose();
      }, e.exports = function (t, e) {
        var r = new s(t, e.uid);
        return r.update(e), r;
      };
    }, {
      "../../lib/str2rgbarray": 819,
      "../../plots/cartesian/autorange": 844,
      "../scatter/get_trace_color": 1209,
      "gl-pointcloud2d": 319
    }],
    1187: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./attributes");

      e.exports = function (t, e, r) {
        function a(r, a) {
          return n.coerce(t, e, i, r, a);
        }

        a("x"), a("y"), a("xbounds"), a("ybounds"), t.xy && t.xy instanceof Float32Array && (e.xy = t.xy), t.indices && t.indices instanceof Int32Array && (e.indices = t.indices), a("text"), a("marker.color", r), a("marker.opacity"), a("marker.blend"), a("marker.sizemin"), a("marker.sizemax"), a("marker.border.color", r), a("marker.border.arearatio"), e._length = null;
      };
    }, {
      "../../lib": 795,
      "./attributes": 1185
    }],
    1188: [function (t, e, r) {
      "use strict";

      ["*pointcloud* trace is deprecated!", "Please consider switching to the *scattergl* trace type."].join(" ");
      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        calc: t("../scatter3d/calc"),
        plot: t("./convert"),
        moduleType: "trace",
        name: "pointcloud",
        basePlotModule: t("../../plots/gl2d"),
        categories: ["gl", "gl2d", "showLegend"],
        meta: {}
      };
    }, {
      "../../plots/gl2d": 885,
      "../scatter3d/calc": 1228,
      "./attributes": 1185,
      "./convert": 1186,
      "./defaults": 1187
    }],
    1189: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/font_attributes"),
          i = t("../../plots/attributes"),
          a = t("../../components/color/attributes"),
          o = t("../../components/fx/attributes"),
          s = t("../../plots/domain").attributes,
          l = t("../../plots/template_attributes").hovertemplateAttrs,
          c = t("../../components/colorscale/attributes"),
          u = t("../../plot_api/plot_template").templatedArray,
          f = t("../../lib/extend").extendFlat,
          h = t("../../plot_api/edit_types").overrideAll;
      t("../../constants/docs").FORMAT_LINK;
      (e.exports = h({
        hoverinfo: f({}, i.hoverinfo, {
          flags: [],
          arrayOk: !1
        }),
        hoverlabel: o.hoverlabel,
        domain: s({
          name: "sankey",
          trace: !0
        }),
        orientation: {
          valType: "enumerated",
          values: ["v", "h"],
          dflt: "h"
        },
        valueformat: {
          valType: "string",
          dflt: ".3s"
        },
        valuesuffix: {
          valType: "string",
          dflt: ""
        },
        arrangement: {
          valType: "enumerated",
          values: ["snap", "perpendicular", "freeform", "fixed"],
          dflt: "snap"
        },
        textfont: n({}),
        customdata: void 0,
        node: {
          label: {
            valType: "data_array",
            dflt: []
          },
          groups: {
            valType: "info_array",
            impliedEdits: {
              x: [],
              y: []
            },
            dimensions: 2,
            freeLength: !0,
            dflt: [],
            items: {
              valType: "number",
              editType: "calc"
            }
          },
          x: {
            valType: "data_array",
            dflt: []
          },
          y: {
            valType: "data_array",
            dflt: []
          },
          color: {
            valType: "color",
            arrayOk: !0
          },
          customdata: {
            valType: "data_array",
            editType: "calc"
          },
          line: {
            color: {
              valType: "color",
              dflt: a.defaultLine,
              arrayOk: !0
            },
            width: {
              valType: "number",
              min: 0,
              dflt: .5,
              arrayOk: !0
            }
          },
          pad: {
            valType: "number",
            arrayOk: !1,
            min: 0,
            dflt: 20
          },
          thickness: {
            valType: "number",
            arrayOk: !1,
            min: 1,
            dflt: 20
          },
          hoverinfo: {
            valType: "enumerated",
            values: ["all", "none", "skip"],
            dflt: "all"
          },
          hoverlabel: o.hoverlabel,
          hovertemplate: l({}, {
            keys: ["value", "label"]
          })
        },
        link: {
          label: {
            valType: "data_array",
            dflt: []
          },
          color: {
            valType: "color",
            arrayOk: !0
          },
          customdata: {
            valType: "data_array",
            editType: "calc"
          },
          line: {
            color: {
              valType: "color",
              dflt: a.defaultLine,
              arrayOk: !0
            },
            width: {
              valType: "number",
              min: 0,
              dflt: 0,
              arrayOk: !0
            }
          },
          source: {
            valType: "data_array",
            dflt: []
          },
          target: {
            valType: "data_array",
            dflt: []
          },
          value: {
            valType: "data_array",
            dflt: []
          },
          hoverinfo: {
            valType: "enumerated",
            values: ["all", "none", "skip"],
            dflt: "all"
          },
          hoverlabel: o.hoverlabel,
          hovertemplate: l({}, {
            keys: ["value", "label"]
          }),
          colorscales: u("concentrationscales", {
            editType: "calc",
            label: {
              valType: "string",
              editType: "calc",
              dflt: ""
            },
            cmax: {
              valType: "number",
              editType: "calc",
              dflt: 1
            },
            cmin: {
              valType: "number",
              editType: "calc",
              dflt: 0
            },
            colorscale: f(c().colorscale, {
              dflt: [[0, "white"], [1, "black"]]
            })
          })
        }
      }, "calc", "nested")).transforms = void 0;
    }, {
      "../../components/color/attributes": 657,
      "../../components/colorscale/attributes": 665,
      "../../components/fx/attributes": 689,
      "../../constants/docs": 766,
      "../../lib/extend": 785,
      "../../plot_api/edit_types": 827,
      "../../plot_api/plot_template": 834,
      "../../plots/attributes": 841,
      "../../plots/domain": 872,
      "../../plots/font_attributes": 873,
      "../../plots/template_attributes": 918
    }],
    1190: [function (t, e, r) {
      "use strict";

      var n = t("../../plot_api/edit_types").overrideAll,
          i = t("../../plots/get_data").getModuleCalcData,
          a = t("./plot"),
          o = t("../../components/fx/layout_attributes"),
          s = t("../../lib/setcursor"),
          l = t("../../components/dragelement"),
          c = t("../../plots/cartesian/select").prepSelect,
          u = t("../../lib"),
          f = t("../../registry");

      function h(t, e) {
        var r = t._fullData[e],
            n = t._fullLayout,
            i = n.dragmode,
            a = "pan" === n.dragmode ? "move" : "crosshair",
            o = r._bgRect;

        if ("pan" !== i && "zoom" !== i) {
          s(o, a);
          var h = {
            _id: "x",
            c2p: u.identity,
            _offset: r._sankey.translateX,
            _length: r._sankey.width
          },
              p = {
            _id: "y",
            c2p: u.identity,
            _offset: r._sankey.translateY,
            _length: r._sankey.height
          },
              d = {
            gd: t,
            element: o.node(),
            plotinfo: {
              id: e,
              xaxis: h,
              yaxis: p,
              fillRangeItems: u.noop
            },
            subplot: e,
            xaxes: [h],
            yaxes: [p],
            doneFnCompleted: function doneFnCompleted(r) {
              var n,
                  i = t._fullData[e],
                  a = i.node.groups.slice(),
                  o = [];

              function s(t) {
                for (var e = i._sankey.graph.nodes, r = 0; r < e.length; r++) {
                  if (e[r].pointNumber === t) return e[r];
                }
              }

              for (var l = 0; l < r.length; l++) {
                var c = s(r[l].pointNumber);
                if (c) if (c.group) {
                  for (var u = 0; u < c.childrenNodes.length; u++) {
                    o.push(c.childrenNodes[u].pointNumber);
                  }

                  a[c.pointNumber - i.node._count] = !1;
                } else o.push(c.pointNumber);
              }

              n = a.filter(Boolean).concat([o]), f.call("_guiRestyle", t, {
                "node.groups": [n]
              }, e);
            },
            prepFn: function prepFn(t, e, r) {
              c(t, e, r, d, i);
            }
          };
          l.init(d);
        }
      }

      r.name = "sankey", r.baseLayoutAttrOverrides = n({
        hoverlabel: o.hoverlabel
      }, "plot", "nested"), r.plot = function (t) {
        var e = i(t.calcdata, "sankey")[0];
        a(t, e), r.updateFx(t);
      }, r.clean = function (t, e, r, n) {
        var i = n._has && n._has("sankey"),
            a = e._has && e._has("sankey");

        i && !a && (n._paperdiv.selectAll(".sankey").remove(), n._paperdiv.selectAll(".bgsankey").remove());
      }, r.updateFx = function (t) {
        for (var e = 0; e < t._fullData.length; e++) {
          h(t, e);
        }
      };
    }, {
      "../../components/dragelement": 677,
      "../../components/fx/layout_attributes": 699,
      "../../lib": 795,
      "../../lib/setcursor": 816,
      "../../plot_api/edit_types": 827,
      "../../plots/cartesian/select": 864,
      "../../plots/get_data": 882,
      "../../registry": 923,
      "./plot": 1195
    }],
    1191: [function (t, e, r) {
      "use strict";

      var n = t("strongly-connected-components"),
          i = t("../../lib"),
          a = t("../../lib/gup").wrap,
          o = i.isArrayOrTypedArray,
          s = i.isIndex,
          l = t("../../components/colorscale");

      function c(t) {
        var e,
            r = t.node,
            a = t.link,
            c = [],
            u = o(a.color),
            f = o(a.customdata),
            h = {},
            p = {},
            d = a.colorscales.length;

        for (e = 0; e < d; e++) {
          var m = a.colorscales[e],
              g = l.extractScale(m, {
            cLetter: "c"
          }),
              v = l.makeColorScaleFunc(g);
          p[m.label] = v;
        }

        var y = 0;

        for (e = 0; e < a.value.length; e++) {
          a.source[e] > y && (y = a.source[e]), a.target[e] > y && (y = a.target[e]);
        }

        var x,
            b = y + 1;
        t.node._count = b;
        var _ = t.node.groups,
            w = {};

        for (e = 0; e < _.length; e++) {
          var T = _[e];

          for (x = 0; x < T.length; x++) {
            var k = T[x],
                M = b + e;
            w.hasOwnProperty(k) ? i.warn("Node " + k + " is already part of a group.") : w[k] = M;
          }
        }

        var A = {
          source: [],
          target: []
        };

        for (e = 0; e < a.value.length; e++) {
          var S = a.value[e],
              E = a.source[e],
              L = a.target[e];

          if (S > 0 && s(E, b) && s(L, b) && (!w.hasOwnProperty(E) || !w.hasOwnProperty(L) || w[E] !== w[L])) {
            w.hasOwnProperty(L) && (L = w[L]), w.hasOwnProperty(E) && (E = w[E]), L = +L, h[E = +E] = h[L] = !0;
            var C = "";
            a.label && a.label[e] && (C = a.label[e]);
            var P = null;
            C && p.hasOwnProperty(C) && (P = p[C]), c.push({
              pointNumber: e,
              label: C,
              color: u ? a.color[e] : a.color,
              customdata: f ? a.customdata[e] : a.customdata,
              concentrationscale: P,
              source: E,
              target: L,
              value: +S
            }), A.source.push(E), A.target.push(L);
          }
        }

        var I = b + _.length,
            O = o(r.color),
            z = o(r.customdata),
            D = [];

        for (e = 0; e < I; e++) {
          if (h[e]) {
            var R = r.label[e];
            D.push({
              group: e > b - 1,
              childrenNodes: [],
              pointNumber: e,
              label: R,
              color: O ? r.color[e] : r.color,
              customdata: z ? r.customdata[e] : r.customdata
            });
          }
        }

        var F = !1;
        return function (t, e, r) {
          for (var a = i.init2dArray(t, 0), o = 0; o < Math.min(e.length, r.length); o++) {
            if (i.isIndex(e[o], t) && i.isIndex(r[o], t)) {
              if (e[o] === r[o]) return !0;
              a[e[o]].push(r[o]);
            }
          }

          return n(a).components.some(function (t) {
            return t.length > 1;
          });
        }(I, A.source, A.target) && (F = !0), {
          circular: F,
          links: c,
          nodes: D,
          groups: _,
          groupLookup: w
        };
      }

      e.exports = function (t, e) {
        var r = c(e);
        return a({
          circular: r.circular,
          _nodes: r.nodes,
          _links: r.links,
          _groups: r.groups,
          _groupLookup: r.groupLookup
        });
      };
    }, {
      "../../components/colorscale": 670,
      "../../lib": 795,
      "../../lib/gup": 792,
      "strongly-connected-components": 582
    }],
    1192: [function (t, e, r) {
      "use strict";

      e.exports = {
        nodeTextOffsetHorizontal: 4,
        nodeTextOffsetVertical: 3,
        nodePadAcross: 10,
        sankeyIterations: 50,
        forceIterations: 5,
        forceTicksPerFrame: 10,
        duration: 500,
        ease: "linear",
        cn: {
          sankey: "sankey",
          sankeyLinks: "sankey-links",
          sankeyLink: "sankey-link",
          sankeyNodeSet: "sankey-node-set",
          sankeyNode: "sankey-node",
          nodeRect: "node-rect",
          nodeLabel: "node-label"
        }
      };
    }, {}],
    1193: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./attributes"),
          a = t("../../components/color"),
          o = t("tinycolor2"),
          s = t("../../plots/domain").defaults,
          l = t("../../components/fx/hoverlabel_defaults"),
          c = t("../../plot_api/plot_template"),
          u = t("../../plots/array_container_defaults");

      function f(t, e) {
        function r(r, a) {
          return n.coerce(t, e, i.link.colorscales, r, a);
        }

        r("label"), r("cmin"), r("cmax"), r("colorscale");
      }

      e.exports = function (t, e, r, h) {
        function p(r, a) {
          return n.coerce(t, e, i, r, a);
        }

        var d = n.extendDeep(h.hoverlabel, t.hoverlabel),
            m = t.node,
            g = c.newContainer(e, "node");

        function v(t, e) {
          return n.coerce(m, g, i.node, t, e);
        }

        v("label"), v("groups"), v("x"), v("y"), v("pad"), v("thickness"), v("line.color"), v("line.width"), v("hoverinfo", t.hoverinfo), l(m, g, v, d), v("hovertemplate");
        var y = h.colorway;
        v("color", g.label.map(function (t, e) {
          return a.addOpacity(function (t) {
            return y[t % y.length];
          }(e), .8);
        })), v("customdata");
        var x = t.link || {},
            b = c.newContainer(e, "link");

        function _(t, e) {
          return n.coerce(x, b, i.link, t, e);
        }

        _("label"), _("source"), _("target"), _("value"), _("line.color"), _("line.width"), _("hoverinfo", t.hoverinfo), l(x, b, _, d), _("hovertemplate");
        var w,
            T = o(h.paper_bgcolor).getLuminance() < .333 ? "rgba(255, 255, 255, 0.6)" : "rgba(0, 0, 0, 0.2)";
        _("color", n.repeat(T, b.value.length)), _("customdata"), u(x, b, {
          name: "colorscales",
          handleItemDefaults: f
        }), s(e, h, p), p("orientation"), p("valueformat"), p("valuesuffix"), g.x.length && g.y.length && (w = "freeform"), p("arrangement", w), n.coerceFont(p, "textfont", n.extendFlat({}, h.font)), e._length = null;
      };
    }, {
      "../../components/color": 658,
      "../../components/fx/hoverlabel_defaults": 696,
      "../../lib": 795,
      "../../plot_api/plot_template": 834,
      "../../plots/array_container_defaults": 840,
      "../../plots/domain": 872,
      "./attributes": 1189,
      tinycolor2: 590
    }],
    1194: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        calc: t("./calc"),
        plot: t("./plot"),
        moduleType: "trace",
        name: "sankey",
        basePlotModule: t("./base_plot"),
        selectPoints: t("./select.js"),
        categories: ["noOpacity"],
        meta: {}
      };
    }, {
      "./attributes": 1189,
      "./base_plot": 1190,
      "./calc": 1191,
      "./defaults": 1193,
      "./plot": 1195,
      "./select.js": 1197
    }],
    1195: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("./render"),
          a = t("../../components/fx"),
          o = t("../../components/color"),
          s = t("../../lib"),
          l = t("./constants").cn,
          c = s._;

      function u(t) {
        return "" !== t;
      }

      function f(t, e) {
        return t.filter(function (t) {
          return t.key === e.traceId;
        });
      }

      function h(t, e) {
        n.select(t).select("path").style("fill-opacity", e), n.select(t).select("rect").style("fill-opacity", e);
      }

      function p(t) {
        n.select(t).select("text.name").style("fill", "black");
      }

      function d(t) {
        return function (e) {
          return -1 !== t.node.sourceLinks.indexOf(e.link) || -1 !== t.node.targetLinks.indexOf(e.link);
        };
      }

      function m(t) {
        return function (e) {
          return -1 !== e.node.sourceLinks.indexOf(t.link) || -1 !== e.node.targetLinks.indexOf(t.link);
        };
      }

      function g(t, e, r) {
        e && r && f(r, e).selectAll("." + l.sankeyLink).filter(d(e)).call(y.bind(0, e, r, !1));
      }

      function v(t, e, r) {
        e && r && f(r, e).selectAll("." + l.sankeyLink).filter(d(e)).call(x.bind(0, e, r, !1));
      }

      function y(t, e, r, n) {
        var i = n.datum().link.label;
        n.style("fill-opacity", function (t) {
          if (!t.link.concentrationscale) return .4;
        }), i && f(e, t).selectAll("." + l.sankeyLink).filter(function (t) {
          return t.link.label === i;
        }).style("fill-opacity", function (t) {
          if (!t.link.concentrationscale) return .4;
        }), r && f(e, t).selectAll("." + l.sankeyNode).filter(m(t)).call(g);
      }

      function x(t, e, r, n) {
        var i = n.datum().link.label;
        n.style("fill-opacity", function (t) {
          return t.tinyColorAlpha;
        }), i && f(e, t).selectAll("." + l.sankeyLink).filter(function (t) {
          return t.link.label === i;
        }).style("fill-opacity", function (t) {
          return t.tinyColorAlpha;
        }), r && f(e, t).selectAll(l.sankeyNode).filter(m(t)).call(v);
      }

      function b(t, e) {
        var r = t.hoverlabel || {},
            n = s.nestedProperty(r, e).get();
        return !Array.isArray(n) && n;
      }

      e.exports = function (t, e) {
        for (var r = t._fullLayout, s = r._paper, f = r._size, d = 0; d < t._fullData.length; d++) {
          if (t._fullData[d].visible && t._fullData[d].type === l.sankey && !t._fullData[d]._viewInitial) {
            var m = t._fullData[d].node;
            t._fullData[d]._viewInitial = {
              node: {
                groups: m.groups.slice(),
                x: m.x.slice(),
                y: m.y.slice()
              }
            };
          }
        }

        var _ = c(t, "source:") + " ",
            w = c(t, "target:") + " ",
            T = c(t, "concentration:") + " ",
            k = c(t, "incoming flow count:") + " ",
            M = c(t, "outgoing flow count:") + " ";

        i(t, s, e, {
          width: f.w,
          height: f.h,
          margin: {
            t: f.t,
            r: f.r,
            b: f.b,
            l: f.l
          }
        }, {
          linkEvents: {
            hover: function hover(e, r, i) {
              !1 !== t._fullLayout.hovermode && (n.select(e).call(y.bind(0, r, i, !0)), "skip" !== r.link.trace.link.hoverinfo && (r.link.fullData = r.link.trace, t.emit("plotly_hover", {
                event: n.event,
                points: [r.link]
              })));
            },
            follow: function follow(e, i) {
              if (!1 !== t._fullLayout.hovermode) {
                var s = i.link.trace.link;

                if ("none" !== s.hoverinfo && "skip" !== s.hoverinfo) {
                  for (var l = [], c = 0, f = 0; f < i.flow.links.length; f++) {
                    var d = i.flow.links[f];

                    if ("closest" !== t._fullLayout.hovermode || i.link.pointNumber === d.pointNumber) {
                      i.link.pointNumber === d.pointNumber && (c = f), d.fullData = d.trace, s = i.link.trace.link;
                      var m = v(d),
                          g = {
                        valueLabel: n.format(i.valueFormat)(d.value) + i.valueSuffix
                      };
                      l.push({
                        x: m[0],
                        y: m[1],
                        name: g.valueLabel,
                        text: [d.label || "", _ + d.source.label, w + d.target.label, d.concentrationscale ? T + n.format("%0.2f")(d.flow.labelConcentration) : ""].filter(u).join("<br>"),
                        color: b(s, "bgcolor") || o.addOpacity(d.color, 1),
                        borderColor: b(s, "bordercolor"),
                        fontFamily: b(s, "font.family"),
                        fontSize: b(s, "font.size"),
                        fontColor: b(s, "font.color"),
                        nameLength: b(s, "namelength"),
                        textAlign: b(s, "align"),
                        idealAlign: n.event.x < m[0] ? "right" : "left",
                        hovertemplate: s.hovertemplate,
                        hovertemplateLabels: g,
                        eventData: [d]
                      });
                    }
                  }

                  a.loneHover(l, {
                    container: r._hoverlayer.node(),
                    outerContainer: r._paper.node(),
                    gd: t,
                    anchorIndex: c
                  }).each(function () {
                    i.link.concentrationscale || h(this, .65), p(this);
                  });
                }
              }

              function v(t) {
                var e, r;
                t.circular ? (e = (t.circularPathData.leftInnerExtent + t.circularPathData.rightInnerExtent) / 2, r = t.circularPathData.verticalFullExtent) : (e = (t.source.x1 + t.target.x0) / 2, r = (t.y0 + t.y1) / 2);
                var n = [e, r];
                return "v" === t.trace.orientation && n.reverse(), n[0] += i.parent.translateX, n[1] += i.parent.translateY, n;
              }
            },
            unhover: function unhover(e, i, o) {
              !1 !== t._fullLayout.hovermode && (n.select(e).call(x.bind(0, i, o, !0)), "skip" !== i.link.trace.link.hoverinfo && (i.link.fullData = i.link.trace, t.emit("plotly_unhover", {
                event: n.event,
                points: [i.link]
              })), a.loneUnhover(r._hoverlayer.node()));
            },
            select: function select(e, r) {
              var i = r.link;
              i.originalEvent = n.event, t._hoverdata = [i], a.click(t, {
                target: !0
              });
            }
          },
          nodeEvents: {
            hover: function hover(e, r, i) {
              !1 !== t._fullLayout.hovermode && (n.select(e).call(g, r, i), "skip" !== r.node.trace.node.hoverinfo && (r.node.fullData = r.node.trace, t.emit("plotly_hover", {
                event: n.event,
                points: [r.node]
              })));
            },
            follow: function follow(e, i) {
              if (!1 !== t._fullLayout.hovermode) {
                var o = i.node.trace.node;

                if ("none" !== o.hoverinfo && "skip" !== o.hoverinfo) {
                  var s = n.select(e).select("." + l.nodeRect),
                      c = t._fullLayout._paperdiv.node().getBoundingClientRect(),
                      f = s.node().getBoundingClientRect(),
                      d = f.left - 2 - c.left,
                      m = f.right + 2 - c.left,
                      g = f.top + f.height / 4 - c.top,
                      v = {
                    valueLabel: n.format(i.valueFormat)(i.node.value) + i.valueSuffix
                  };

                  i.node.fullData = i.node.trace, t._fullLayout._calcInverseTransform(t);

                  var y = t._fullLayout._invScaleX,
                      x = t._fullLayout._invScaleY,
                      _ = a.loneHover({
                    x0: y * d,
                    x1: y * m,
                    y: x * g,
                    name: n.format(i.valueFormat)(i.node.value) + i.valueSuffix,
                    text: [i.node.label, k + i.node.targetLinks.length, M + i.node.sourceLinks.length].filter(u).join("<br>"),
                    color: b(o, "bgcolor") || i.tinyColorHue,
                    borderColor: b(o, "bordercolor"),
                    fontFamily: b(o, "font.family"),
                    fontSize: b(o, "font.size"),
                    fontColor: b(o, "font.color"),
                    nameLength: b(o, "namelength"),
                    textAlign: b(o, "align"),
                    idealAlign: "left",
                    hovertemplate: o.hovertemplate,
                    hovertemplateLabels: v,
                    eventData: [i.node]
                  }, {
                    container: r._hoverlayer.node(),
                    outerContainer: r._paper.node(),
                    gd: t
                  });

                  h(_, .85), p(_);
                }
              }
            },
            unhover: function unhover(e, i, o) {
              !1 !== t._fullLayout.hovermode && (n.select(e).call(v, i, o), "skip" !== i.node.trace.node.hoverinfo && (i.node.fullData = i.node.trace, t.emit("plotly_unhover", {
                event: n.event,
                points: [i.node]
              })), a.loneUnhover(r._hoverlayer.node()));
            },
            select: function select(e, r, i) {
              var o = r.node;
              o.originalEvent = n.event, t._hoverdata = [o], n.select(e).call(v, r, i), a.click(t, {
                target: !0
              });
            }
          }
        });
      };
    }, {
      "../../components/color": 658,
      "../../components/fx": 698,
      "../../lib": 795,
      "./constants": 1192,
      "./render": 1196,
      "@plotly/d3": 57
    }],
    1196: [function (t, e, r) {
      "use strict";

      var n = t("d3-force"),
          i = t("d3-interpolate").interpolateNumber,
          a = t("@plotly/d3"),
          o = t("@plotly/d3-sankey"),
          s = t("@plotly/d3-sankey-circular"),
          l = t("./constants"),
          c = t("tinycolor2"),
          u = t("../../components/color"),
          f = t("../../components/drawing"),
          h = t("../../lib"),
          p = h.strTranslate,
          d = h.strRotate,
          m = t("../../lib/gup"),
          g = m.keyFun,
          v = m.repeat,
          y = m.unwrap,
          x = t("../../lib/svg_text_utils"),
          b = t("../../registry"),
          _ = t("../../constants/alignment"),
          w = _.CAP_SHIFT,
          T = _.LINE_SPACING;

      function k(t, e, r) {
        var n,
            i = y(e),
            a = i.trace,
            u = a.domain,
            f = "h" === a.orientation,
            p = a.node.pad,
            d = a.node.thickness,
            m = t.width * (u.x[1] - u.x[0]),
            g = t.height * (u.y[1] - u.y[0]),
            v = i._nodes,
            x = i._links,
            b = i.circular;
        (n = b ? s.sankeyCircular().circularLinkGap(0) : o.sankey()).iterations(l.sankeyIterations).size(f ? [m, g] : [g, m]).nodeWidth(d).nodePadding(p).nodeId(function (t) {
          return t.pointNumber;
        }).nodes(v).links(x);

        var _,
            w,
            T,
            k = n();

        for (var M in n.nodePadding() < p && h.warn("node.pad was reduced to ", n.nodePadding(), " to fit within the figure."), i._groupLookup) {
          var A,
              S = parseInt(i._groupLookup[M]);

          for (_ = 0; _ < k.nodes.length; _++) {
            if (k.nodes[_].pointNumber === S) {
              A = k.nodes[_];
              break;
            }
          }

          if (A) {
            var E = {
              pointNumber: parseInt(M),
              x0: A.x0,
              x1: A.x1,
              y0: A.y0,
              y1: A.y1,
              partOfGroup: !0,
              sourceLinks: [],
              targetLinks: []
            };
            k.nodes.unshift(E), A.childrenNodes.unshift(E);
          }
        }

        if (function () {
          for (_ = 0; _ < k.nodes.length; _++) {
            var t,
                e,
                r = k.nodes[_],
                n = {};

            for (w = 0; w < r.targetLinks.length; w++) {
              t = (e = r.targetLinks[w]).source.pointNumber + ":" + e.target.pointNumber, n.hasOwnProperty(t) || (n[t] = []), n[t].push(e);
            }

            var i = Object.keys(n);

            for (w = 0; w < i.length; w++) {
              var a = n[t = i[w]],
                  o = 0,
                  s = {};

              for (T = 0; T < a.length; T++) {
                s[(e = a[T]).label] || (s[e.label] = 0), s[e.label] += e.value, o += e.value;
              }

              for (T = 0; T < a.length; T++) {
                (e = a[T]).flow = {
                  value: o,
                  labelConcentration: s[e.label] / o,
                  concentration: e.value / o,
                  links: a
                }, e.concentrationscale && (e.color = c(e.concentrationscale(e.flow.labelConcentration)));
              }
            }

            var l = 0;

            for (w = 0; w < r.sourceLinks.length; w++) {
              l += r.sourceLinks[w].value;
            }

            for (w = 0; w < r.sourceLinks.length; w++) {
              (e = r.sourceLinks[w]).concentrationOut = e.value / l;
            }

            var u = 0;

            for (w = 0; w < r.targetLinks.length; w++) {
              u += r.targetLinks[w].value;
            }

            for (w = 0; w < r.targetLinks.length; w++) {
              (e = r.targetLinks[w]).concenrationIn = e.value / u;
            }
          }
        }(), a.node.x.length && a.node.y.length) {
          for (_ = 0; _ < Math.min(a.node.x.length, a.node.y.length, k.nodes.length); _++) {
            if (a.node.x[_] && a.node.y[_]) {
              var L = [a.node.x[_] * m, a.node.y[_] * g];
              k.nodes[_].x0 = L[0] - d / 2, k.nodes[_].x1 = L[0] + d / 2;
              var C = k.nodes[_].y1 - k.nodes[_].y0;
              k.nodes[_].y0 = L[1] - C / 2, k.nodes[_].y1 = L[1] + C / 2;
            }
          }

          if ("snap" === a.arrangement) !function (t) {
            t.forEach(function (t) {
              var e,
                  r,
                  n,
                  i = 0,
                  a = t.length;

              for (t.sort(function (t, e) {
                return t.y0 - e.y0;
              }), n = 0; n < a; ++n) {
                (e = t[n]).y0 >= i || (r = i - e.y0) > 1e-6 && (e.y0 += r, e.y1 += r), i = e.y1 + p;
              }
            });
          }(function (t) {
            var e,
                r,
                n = t.map(function (t, e) {
              return {
                x0: t.x0,
                index: e
              };
            }).sort(function (t, e) {
              return t.x0 - e.x0;
            }),
                i = [],
                a = -1,
                o = -1 / 0;

            for (_ = 0; _ < n.length; _++) {
              var s = t[n[_].index];
              s.x0 > o + d && (a += 1, e = s.x0), o = s.x0, i[a] || (i[a] = []), i[a].push(s), r = e - s.x0, s.x0 += r, s.x1 += r;
            }

            return i;
          }(v = k.nodes));
          n.update(k);
        }

        return {
          circular: b,
          key: r,
          trace: a,
          guid: h.randstr(),
          horizontal: f,
          width: m,
          height: g,
          nodePad: a.node.pad,
          nodeLineColor: a.node.line.color,
          nodeLineWidth: a.node.line.width,
          linkLineColor: a.link.line.color,
          linkLineWidth: a.link.line.width,
          valueFormat: a.valueformat,
          valueSuffix: a.valuesuffix,
          textFont: a.textfont,
          translateX: u.x[0] * t.width + t.margin.l,
          translateY: t.height - u.y[1] * t.height + t.margin.t,
          dragParallel: f ? g : m,
          dragPerpendicular: f ? m : g,
          arrangement: a.arrangement,
          sankey: n,
          graph: k,
          forceLayouts: {},
          interactionState: {
            dragInProgress: !1,
            hovered: !1
          }
        };
      }

      function M(t, e, r) {
        var n = c(e.color),
            i = e.source.label + "|" + e.target.label + "__" + r;
        return e.trace = t.trace, e.curveNumber = t.trace.index, {
          circular: t.circular,
          key: i,
          traceId: t.key,
          pointNumber: e.pointNumber,
          link: e,
          tinyColorHue: u.tinyRGB(n),
          tinyColorAlpha: n.getAlpha(),
          linkPath: A,
          linkLineColor: t.linkLineColor,
          linkLineWidth: t.linkLineWidth,
          valueFormat: t.valueFormat,
          valueSuffix: t.valueSuffix,
          sankey: t.sankey,
          parent: t,
          interactionState: t.interactionState,
          flow: e.flow
        };
      }

      function A() {
        return function (t) {
          if (t.link.circular) return e = t.link, r = e.width / 2, n = e.circularPathData, "top" === e.circularLinkType ? "M " + n.targetX + " " + (n.targetY + r) + " L" + n.rightInnerExtent + " " + (n.targetY + r) + "A" + (n.rightLargeArcRadius + r) + " " + (n.rightSmallArcRadius + r) + " 0 0 1 " + (n.rightFullExtent - r) + " " + (n.targetY - n.rightSmallArcRadius) + "L" + (n.rightFullExtent - r) + " " + n.verticalRightInnerExtent + "A" + (n.rightLargeArcRadius + r) + " " + (n.rightLargeArcRadius + r) + " 0 0 1 " + n.rightInnerExtent + " " + (n.verticalFullExtent - r) + "L" + n.leftInnerExtent + " " + (n.verticalFullExtent - r) + "A" + (n.leftLargeArcRadius + r) + " " + (n.leftLargeArcRadius + r) + " 0 0 1 " + (n.leftFullExtent + r) + " " + n.verticalLeftInnerExtent + "L" + (n.leftFullExtent + r) + " " + (n.sourceY - n.leftSmallArcRadius) + "A" + (n.leftLargeArcRadius + r) + " " + (n.leftSmallArcRadius + r) + " 0 0 1 " + n.leftInnerExtent + " " + (n.sourceY + r) + "L" + n.sourceX + " " + (n.sourceY + r) + "L" + n.sourceX + " " + (n.sourceY - r) + "L" + n.leftInnerExtent + " " + (n.sourceY - r) + "A" + (n.leftLargeArcRadius - r) + " " + (n.leftSmallArcRadius - r) + " 0 0 0 " + (n.leftFullExtent - r) + " " + (n.sourceY - n.leftSmallArcRadius) + "L" + (n.leftFullExtent - r) + " " + n.verticalLeftInnerExtent + "A" + (n.leftLargeArcRadius - r) + " " + (n.leftLargeArcRadius - r) + " 0 0 0 " + n.leftInnerExtent + " " + (n.verticalFullExtent + r) + "L" + n.rightInnerExtent + " " + (n.verticalFullExtent + r) + "A" + (n.rightLargeArcRadius - r) + " " + (n.rightLargeArcRadius - r) + " 0 0 0 " + (n.rightFullExtent + r) + " " + n.verticalRightInnerExtent + "L" + (n.rightFullExtent + r) + " " + (n.targetY - n.rightSmallArcRadius) + "A" + (n.rightLargeArcRadius - r) + " " + (n.rightSmallArcRadius - r) + " 0 0 0 " + n.rightInnerExtent + " " + (n.targetY - r) + "L" + n.targetX + " " + (n.targetY - r) + "Z" : "M " + n.targetX + " " + (n.targetY - r) + " L" + n.rightInnerExtent + " " + (n.targetY - r) + "A" + (n.rightLargeArcRadius + r) + " " + (n.rightSmallArcRadius + r) + " 0 0 0 " + (n.rightFullExtent - r) + " " + (n.targetY + n.rightSmallArcRadius) + "L" + (n.rightFullExtent - r) + " " + n.verticalRightInnerExtent + "A" + (n.rightLargeArcRadius + r) + " " + (n.rightLargeArcRadius + r) + " 0 0 0 " + n.rightInnerExtent + " " + (n.verticalFullExtent + r) + "L" + n.leftInnerExtent + " " + (n.verticalFullExtent + r) + "A" + (n.leftLargeArcRadius + r) + " " + (n.leftLargeArcRadius + r) + " 0 0 0 " + (n.leftFullExtent + r) + " " + n.verticalLeftInnerExtent + "L" + (n.leftFullExtent + r) + " " + (n.sourceY + n.leftSmallArcRadius) + "A" + (n.leftLargeArcRadius + r) + " " + (n.leftSmallArcRadius + r) + " 0 0 0 " + n.leftInnerExtent + " " + (n.sourceY - r) + "L" + n.sourceX + " " + (n.sourceY - r) + "L" + n.sourceX + " " + (n.sourceY + r) + "L" + n.leftInnerExtent + " " + (n.sourceY + r) + "A" + (n.leftLargeArcRadius - r) + " " + (n.leftSmallArcRadius - r) + " 0 0 1 " + (n.leftFullExtent - r) + " " + (n.sourceY + n.leftSmallArcRadius) + "L" + (n.leftFullExtent - r) + " " + n.verticalLeftInnerExtent + "A" + (n.leftLargeArcRadius - r) + " " + (n.leftLargeArcRadius - r) + " 0 0 1 " + n.leftInnerExtent + " " + (n.verticalFullExtent - r) + "L" + n.rightInnerExtent + " " + (n.verticalFullExtent - r) + "A" + (n.rightLargeArcRadius - r) + " " + (n.rightLargeArcRadius - r) + " 0 0 1 " + (n.rightFullExtent + r) + " " + n.verticalRightInnerExtent + "L" + (n.rightFullExtent + r) + " " + (n.targetY + n.rightSmallArcRadius) + "A" + (n.rightLargeArcRadius - r) + " " + (n.rightSmallArcRadius - r) + " 0 0 1 " + n.rightInnerExtent + " " + (n.targetY + r) + "L" + n.targetX + " " + (n.targetY + r) + "Z";
          var e,
              r,
              n,
              a = t.link.source.x1,
              o = t.link.target.x0,
              s = i(a, o),
              l = s(.5),
              c = s(.5),
              u = t.link.y0 - t.link.width / 2,
              f = t.link.y0 + t.link.width / 2,
              h = t.link.y1 - t.link.width / 2,
              p = t.link.y1 + t.link.width / 2;
          return "M" + a + "," + u + "C" + l + "," + u + " " + c + "," + h + " " + o + "," + h + "L" + o + "," + p + "C" + c + "," + p + " " + l + "," + f + " " + a + "," + f + "Z";
        };
      }

      function S(t, e) {
        var r = c(e.color),
            n = l.nodePadAcross,
            i = t.nodePad / 2;
        e.dx = e.x1 - e.x0, e.dy = e.y1 - e.y0;
        var a = e.dx,
            o = Math.max(.5, e.dy),
            s = "node_" + e.pointNumber;
        return e.group && (s = h.randstr()), e.trace = t.trace, e.curveNumber = t.trace.index, {
          index: e.pointNumber,
          key: s,
          partOfGroup: e.partOfGroup || !1,
          group: e.group,
          traceId: t.key,
          trace: t.trace,
          node: e,
          nodePad: t.nodePad,
          nodeLineColor: t.nodeLineColor,
          nodeLineWidth: t.nodeLineWidth,
          textFont: t.textFont,
          size: t.horizontal ? t.height : t.width,
          visibleWidth: Math.ceil(a),
          visibleHeight: o,
          zoneX: -n,
          zoneY: -i,
          zoneWidth: a + 2 * n,
          zoneHeight: o + 2 * i,
          labelY: t.horizontal ? e.dy / 2 + 1 : e.dx / 2 + 1,
          left: 1 === e.originalLayer,
          sizeAcross: t.width,
          forceLayouts: t.forceLayouts,
          horizontal: t.horizontal,
          darkBackground: r.getBrightness() <= 128,
          tinyColorHue: u.tinyRGB(r),
          tinyColorAlpha: r.getAlpha(),
          valueFormat: t.valueFormat,
          valueSuffix: t.valueSuffix,
          sankey: t.sankey,
          graph: t.graph,
          arrangement: t.arrangement,
          uniqueNodeLabelPathId: [t.guid, t.key, s].join("_"),
          interactionState: t.interactionState,
          figure: t
        };
      }

      function E(t) {
        t.attr("transform", function (t) {
          return p(t.node.x0.toFixed(3), t.node.y0.toFixed(3));
        });
      }

      function L(t) {
        t.call(E);
      }

      function C(t, e) {
        t.call(L), e.attr("d", A());
      }

      function P(t) {
        t.attr("width", function (t) {
          return t.node.x1 - t.node.x0;
        }).attr("height", function (t) {
          return t.visibleHeight;
        });
      }

      function I(t) {
        return t.link.width > 1 || t.linkLineWidth > 0;
      }

      function O(t) {
        return p(t.translateX, t.translateY) + (t.horizontal ? "matrix(1 0 0 1 0 0)" : "matrix(0 1 1 0 0 0)");
      }

      function z(t, e, r) {
        t.on(".basic", null).on("mouseover.basic", function (t) {
          t.interactionState.dragInProgress || t.partOfGroup || (r.hover(this, t, e), t.interactionState.hovered = [this, t]);
        }).on("mousemove.basic", function (t) {
          t.interactionState.dragInProgress || t.partOfGroup || (r.follow(this, t), t.interactionState.hovered = [this, t]);
        }).on("mouseout.basic", function (t) {
          t.interactionState.dragInProgress || t.partOfGroup || (r.unhover(this, t, e), t.interactionState.hovered = !1);
        }).on("click.basic", function (t) {
          t.interactionState.hovered && (r.unhover(this, t, e), t.interactionState.hovered = !1), t.interactionState.dragInProgress || t.partOfGroup || r.select(this, t, e);
        });
      }

      function D(t, e, r, i) {
        var o = a.behavior.drag().origin(function (t) {
          return {
            x: t.node.x0 + t.visibleWidth / 2,
            y: t.node.y0 + t.visibleHeight / 2
          };
        }).on("dragstart", function (a) {
          if ("fixed" !== a.arrangement && (h.ensureSingle(i._fullLayout._infolayer, "g", "dragcover", function (t) {
            i._fullLayout._dragCover = t;
          }), h.raiseToTop(this), a.interactionState.dragInProgress = a.node, F(a.node), a.interactionState.hovered && (r.nodeEvents.unhover.apply(0, a.interactionState.hovered), a.interactionState.hovered = !1), "snap" === a.arrangement)) {
            var o = a.traceId + "|" + a.key;
            a.forceLayouts[o] ? a.forceLayouts[o].alpha(1) : function (t, e, r, i) {
              !function (t) {
                for (var e = 0; e < t.length; e++) {
                  t[e].y = (t[e].y0 + t[e].y1) / 2, t[e].x = (t[e].x0 + t[e].x1) / 2;
                }
              }(r.graph.nodes);
              var a = r.graph.nodes.filter(function (t) {
                return t.originalX === r.node.originalX;
              }).filter(function (t) {
                return !t.partOfGroup;
              });
              r.forceLayouts[e] = n.forceSimulation(a).alphaDecay(0).force("collide", n.forceCollide().radius(function (t) {
                return t.dy / 2 + r.nodePad / 2;
              }).strength(1).iterations(l.forceIterations)).force("constrain", function (t, e, r, n) {
                return function () {
                  for (var t = 0, i = 0; i < r.length; i++) {
                    var a = r[i];
                    a === n.interactionState.dragInProgress ? (a.x = a.lastDraggedX, a.y = a.lastDraggedY) : (a.vx = (a.originalX - a.x) / l.forceTicksPerFrame, a.y = Math.min(n.size - a.dy / 2, Math.max(a.dy / 2, a.y))), t = Math.max(t, Math.abs(a.vx), Math.abs(a.vy));
                  }

                  !n.interactionState.dragInProgress && t < .1 && n.forceLayouts[e].alpha() > 0 && n.forceLayouts[e].alpha(0);
                };
              }(0, e, a, r)).stop();
            }(0, o, a), function (t, e, r, n, i) {
              window.requestAnimationFrame(function a() {
                var o;

                for (o = 0; o < l.forceTicksPerFrame; o++) {
                  r.forceLayouts[n].tick();
                }

                if (function (t) {
                  for (var e = 0; e < t.length; e++) {
                    t[e].y0 = t[e].y - t[e].dy / 2, t[e].y1 = t[e].y0 + t[e].dy, t[e].x0 = t[e].x - t[e].dx / 2, t[e].x1 = t[e].x0 + t[e].dx;
                  }
                }(r.graph.nodes), r.sankey.update(r.graph), C(t.filter(B(r)), e), r.forceLayouts[n].alpha() > 0) window.requestAnimationFrame(a);else {
                  var s = r.node.originalX;
                  r.node.x0 = s - r.visibleWidth / 2, r.node.x1 = s + r.visibleWidth / 2, R(r, i);
                }
              });
            }(t, e, a, o, i);
          }
        }).on("drag", function (r) {
          if ("fixed" !== r.arrangement) {
            var n = a.event.x,
                i = a.event.y;
            "snap" === r.arrangement ? (r.node.x0 = n - r.visibleWidth / 2, r.node.x1 = n + r.visibleWidth / 2, r.node.y0 = i - r.visibleHeight / 2, r.node.y1 = i + r.visibleHeight / 2) : ("freeform" === r.arrangement && (r.node.x0 = n - r.visibleWidth / 2, r.node.x1 = n + r.visibleWidth / 2), i = Math.max(0, Math.min(r.size - r.visibleHeight / 2, i)), r.node.y0 = i - r.visibleHeight / 2, r.node.y1 = i + r.visibleHeight / 2), F(r.node), "snap" !== r.arrangement && (r.sankey.update(r.graph), C(t.filter(B(r)), e));
          }
        }).on("dragend", function (t) {
          if ("fixed" !== t.arrangement) {
            t.interactionState.dragInProgress = !1;

            for (var e = 0; e < t.node.childrenNodes.length; e++) {
              t.node.childrenNodes[e].x = t.node.x, t.node.childrenNodes[e].y = t.node.y;
            }

            "snap" !== t.arrangement && R(t, i);
          }
        });
        t.on(".drag", null).call(o);
      }

      function R(t, e) {
        for (var r = [], n = [], i = 0; i < t.graph.nodes.length; i++) {
          var a = (t.graph.nodes[i].x0 + t.graph.nodes[i].x1) / 2,
              o = (t.graph.nodes[i].y0 + t.graph.nodes[i].y1) / 2;
          r.push(a / t.figure.width), n.push(o / t.figure.height);
        }

        b.call("_guiRestyle", e, {
          "node.x": [r],
          "node.y": [n]
        }, t.trace.index).then(function () {
          e._fullLayout._dragCover && e._fullLayout._dragCover.remove();
        });
      }

      function F(t) {
        t.lastDraggedX = t.x0 + t.dx / 2, t.lastDraggedY = t.y0 + t.dy / 2;
      }

      function B(t) {
        return function (e) {
          return e.node.originalX === t.node.originalX;
        };
      }

      e.exports = function (t, e, r, n, i) {
        var o = !1;
        h.ensureSingle(t._fullLayout._infolayer, "g", "first-render", function () {
          o = !0;
        });
        var s = t._fullLayout._dragCover,
            m = r.filter(function (t) {
          return y(t).trace.visible;
        }).map(k.bind(null, n)),
            b = e.selectAll("." + l.cn.sankey).data(m, g);
        b.exit().remove(), b.enter().append("g").classed(l.cn.sankey, !0).style("box-sizing", "content-box").style("position", "absolute").style("left", 0).style("shape-rendering", "geometricPrecision").style("pointer-events", "auto").attr("transform", O), b.each(function (e, r) {
          t._fullData[r]._sankey = e;
          var n = "bgsankey-" + e.trace.uid + "-" + r;
          h.ensureSingle(t._fullLayout._draggers, "rect", n), t._fullData[r]._bgRect = a.select("." + n), t._fullData[r]._bgRect.style("pointer-events", "all").attr("width", e.width).attr("height", e.height).attr("x", e.translateX).attr("y", e.translateY).classed("bgsankey", !0).style({
            fill: "transparent",
            "stroke-width": 0
          });
        }), b.transition().ease(l.ease).duration(l.duration).attr("transform", O);

        var _ = b.selectAll("." + l.cn.sankeyLinks).data(v, g);

        _.enter().append("g").classed(l.cn.sankeyLinks, !0).style("fill", "none");

        var L = _.selectAll("." + l.cn.sankeyLink).data(function (t) {
          return t.graph.links.filter(function (t) {
            return t.value;
          }).map(M.bind(null, t));
        }, g);

        L.enter().append("path").classed(l.cn.sankeyLink, !0).call(z, b, i.linkEvents), L.style("stroke", function (t) {
          return I(t) ? u.tinyRGB(c(t.linkLineColor)) : t.tinyColorHue;
        }).style("stroke-opacity", function (t) {
          return I(t) ? u.opacity(t.linkLineColor) : t.tinyColorAlpha;
        }).style("fill", function (t) {
          return t.tinyColorHue;
        }).style("fill-opacity", function (t) {
          return t.tinyColorAlpha;
        }).style("stroke-width", function (t) {
          return I(t) ? t.linkLineWidth : 1;
        }).attr("d", A()), L.style("opacity", function () {
          return t._context.staticPlot || o || s ? 1 : 0;
        }).transition().ease(l.ease).duration(l.duration).style("opacity", 1), L.exit().transition().ease(l.ease).duration(l.duration).style("opacity", 0).remove();
        var C = b.selectAll("." + l.cn.sankeyNodeSet).data(v, g);
        C.enter().append("g").classed(l.cn.sankeyNodeSet, !0), C.style("cursor", function (t) {
          switch (t.arrangement) {
            case "fixed":
              return "default";

            case "perpendicular":
              return "ns-resize";

            default:
              return "move";
          }
        });
        var R = C.selectAll("." + l.cn.sankeyNode).data(function (t) {
          var e = t.graph.nodes;
          return function (t) {
            var e,
                r = [];

            for (e = 0; e < t.length; e++) {
              t[e].originalX = (t[e].x0 + t[e].x1) / 2, t[e].originalY = (t[e].y0 + t[e].y1) / 2, -1 === r.indexOf(t[e].originalX) && r.push(t[e].originalX);
            }

            for (r.sort(function (t, e) {
              return t - e;
            }), e = 0; e < t.length; e++) {
              t[e].originalLayerIndex = r.indexOf(t[e].originalX), t[e].originalLayer = t[e].originalLayerIndex / (r.length - 1);
            }
          }(e), e.map(S.bind(null, t));
        }, g);
        R.enter().append("g").classed(l.cn.sankeyNode, !0).call(E).style("opacity", function (e) {
          return !t._context.staticPlot && !o || e.partOfGroup ? 0 : 1;
        }), R.call(z, b, i.nodeEvents).call(D, L, i, t), R.transition().ease(l.ease).duration(l.duration).call(E).style("opacity", function (t) {
          return t.partOfGroup ? 0 : 1;
        }), R.exit().transition().ease(l.ease).duration(l.duration).style("opacity", 0).remove();
        var F = R.selectAll("." + l.cn.nodeRect).data(v);
        F.enter().append("rect").classed(l.cn.nodeRect, !0).call(P), F.style("stroke-width", function (t) {
          return t.nodeLineWidth;
        }).style("stroke", function (t) {
          return u.tinyRGB(c(t.nodeLineColor));
        }).style("stroke-opacity", function (t) {
          return u.opacity(t.nodeLineColor);
        }).style("fill", function (t) {
          return t.tinyColorHue;
        }).style("fill-opacity", function (t) {
          return t.tinyColorAlpha;
        }), F.transition().ease(l.ease).duration(l.duration).call(P);
        var B = R.selectAll("." + l.cn.nodeLabel).data(v);
        B.enter().append("text").classed(l.cn.nodeLabel, !0).style("cursor", "default"), B.attr("data-notex", 1).text(function (t) {
          return t.node.label;
        }).each(function (e) {
          var r = a.select(this);
          f.font(r, e.textFont), x.convertToTspans(r, t);
        }).style("text-shadow", x.makeTextShadow(t._fullLayout.paper_bgcolor)).attr("text-anchor", function (t) {
          return t.horizontal && t.left ? "end" : "start";
        }).attr("transform", function (t) {
          var e = a.select(this),
              r = x.lineCount(e),
              n = t.textFont.size * ((r - 1) * T - w),
              i = t.nodeLineWidth / 2 + 3,
              o = ((t.horizontal ? t.visibleHeight : t.visibleWidth) - n) / 2;
          t.horizontal && (t.left ? i = -i : i += t.visibleWidth);
          var s = t.horizontal ? "" : "scale(-1,1)" + d(90);
          return p(t.horizontal ? i : o, t.horizontal ? o : i) + s;
        }), B.transition().ease(l.ease).duration(l.duration);
      };
    }, {
      "../../components/color": 658,
      "../../components/drawing": 680,
      "../../constants/alignment": 763,
      "../../lib": 795,
      "../../lib/gup": 792,
      "../../lib/svg_text_utils": 820,
      "../../registry": 923,
      "./constants": 1192,
      "@plotly/d3": 57,
      "@plotly/d3-sankey": 56,
      "@plotly/d3-sankey-circular": 55,
      "d3-force": 161,
      "d3-interpolate": 163,
      tinycolor2: 590
    }],
    1197: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        for (var r = [], n = t.cd[0].trace, i = n._sankey.graph.nodes, a = 0; a < i.length; a++) {
          var o = i[a];

          if (!o.partOfGroup) {
            var s = [(o.x0 + o.x1) / 2, (o.y0 + o.y1) / 2];
            "v" === n.orientation && s.reverse(), e && e.contains(s, !1, a, t) && r.push({
              pointNumber: o.pointNumber
            });
          }
        }

        return r;
      };
    }, {}],
    1198: [function (t, e, r) {
      "use strict";

      var n = t("../../lib");

      e.exports = function (t, e) {
        for (var r = 0; r < t.length; r++) {
          t[r].i = r;
        }

        n.mergeArray(e.text, t, "tx"), n.mergeArray(e.texttemplate, t, "txt"), n.mergeArray(e.hovertext, t, "htx"), n.mergeArray(e.customdata, t, "data"), n.mergeArray(e.textposition, t, "tp"), e.textfont && (n.mergeArrayCastPositive(e.textfont.size, t, "ts"), n.mergeArray(e.textfont.color, t, "tc"), n.mergeArray(e.textfont.family, t, "tf"));
        var i = e.marker;

        if (i) {
          n.mergeArrayCastPositive(i.size, t, "ms"), n.mergeArrayCastPositive(i.opacity, t, "mo"), n.mergeArray(i.symbol, t, "mx"), n.mergeArray(i.color, t, "mc");
          var a = i.line;
          i.line && (n.mergeArray(a.color, t, "mlc"), n.mergeArrayCastPositive(a.width, t, "mlw"));
          var o = i.gradient;
          o && "none" !== o.type && (n.mergeArray(o.type, t, "mgt"), n.mergeArray(o.color, t, "mgc"));
        }
      };
    }, {
      "../../lib": 795
    }],
    1199: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/hoverformat_attributes"),
          i = t("../../plots/template_attributes").texttemplateAttrs,
          a = t("../../plots/template_attributes").hovertemplateAttrs,
          o = t("../../components/colorscale/attributes"),
          s = t("../../plots/font_attributes"),
          l = t("../../components/drawing/attributes").dash,
          c = t("../../components/drawing"),
          u = t("./constants"),
          f = t("../../lib/extend").extendFlat;
      e.exports = {
        x: {
          valType: "data_array",
          editType: "calc+clearAxisTypes",
          anim: !0
        },
        x0: {
          valType: "any",
          dflt: 0,
          editType: "calc+clearAxisTypes",
          anim: !0
        },
        dx: {
          valType: "number",
          dflt: 1,
          editType: "calc",
          anim: !0
        },
        y: {
          valType: "data_array",
          editType: "calc+clearAxisTypes",
          anim: !0
        },
        y0: {
          valType: "any",
          dflt: 0,
          editType: "calc+clearAxisTypes",
          anim: !0
        },
        dy: {
          valType: "number",
          dflt: 1,
          editType: "calc",
          anim: !0
        },
        xperiod: {
          valType: "any",
          dflt: 0,
          editType: "calc"
        },
        yperiod: {
          valType: "any",
          dflt: 0,
          editType: "calc"
        },
        xperiod0: {
          valType: "any",
          editType: "calc"
        },
        yperiod0: {
          valType: "any",
          editType: "calc"
        },
        xperiodalignment: {
          valType: "enumerated",
          values: ["start", "middle", "end"],
          dflt: "middle",
          editType: "calc"
        },
        yperiodalignment: {
          valType: "enumerated",
          values: ["start", "middle", "end"],
          dflt: "middle",
          editType: "calc"
        },
        xhoverformat: n("x"),
        yhoverformat: n("y"),
        stackgroup: {
          valType: "string",
          dflt: "",
          editType: "calc"
        },
        orientation: {
          valType: "enumerated",
          values: ["v", "h"],
          editType: "calc"
        },
        groupnorm: {
          valType: "enumerated",
          values: ["", "fraction", "percent"],
          dflt: "",
          editType: "calc"
        },
        stackgaps: {
          valType: "enumerated",
          values: ["infer zero", "interpolate"],
          dflt: "infer zero",
          editType: "calc"
        },
        text: {
          valType: "string",
          dflt: "",
          arrayOk: !0,
          editType: "calc"
        },
        texttemplate: i({}, {}),
        hovertext: {
          valType: "string",
          dflt: "",
          arrayOk: !0,
          editType: "style"
        },
        mode: {
          valType: "flaglist",
          flags: ["lines", "markers", "text"],
          extras: ["none"],
          editType: "calc"
        },
        hoveron: {
          valType: "flaglist",
          flags: ["points", "fills"],
          editType: "style"
        },
        hovertemplate: a({}, {
          keys: u.eventDataKeys
        }),
        line: {
          color: {
            valType: "color",
            editType: "style",
            anim: !0
          },
          width: {
            valType: "number",
            min: 0,
            dflt: 2,
            editType: "style",
            anim: !0
          },
          shape: {
            valType: "enumerated",
            values: ["linear", "spline", "hv", "vh", "hvh", "vhv"],
            dflt: "linear",
            editType: "plot"
          },
          smoothing: {
            valType: "number",
            min: 0,
            max: 1.3,
            dflt: 1,
            editType: "plot"
          },
          dash: f({}, l, {
            editType: "style"
          }),
          simplify: {
            valType: "boolean",
            dflt: !0,
            editType: "plot"
          },
          editType: "plot"
        },
        connectgaps: {
          valType: "boolean",
          dflt: !1,
          editType: "calc"
        },
        cliponaxis: {
          valType: "boolean",
          dflt: !0,
          editType: "plot"
        },
        fill: {
          valType: "enumerated",
          values: ["none", "tozeroy", "tozerox", "tonexty", "tonextx", "toself", "tonext"],
          editType: "calc"
        },
        fillcolor: {
          valType: "color",
          editType: "style",
          anim: !0
        },
        marker: f({
          symbol: {
            valType: "enumerated",
            values: c.symbolList,
            dflt: "circle",
            arrayOk: !0,
            editType: "style"
          },
          opacity: {
            valType: "number",
            min: 0,
            max: 1,
            arrayOk: !0,
            editType: "style",
            anim: !0
          },
          size: {
            valType: "number",
            min: 0,
            dflt: 6,
            arrayOk: !0,
            editType: "calc",
            anim: !0
          },
          maxdisplayed: {
            valType: "number",
            min: 0,
            dflt: 0,
            editType: "plot"
          },
          sizeref: {
            valType: "number",
            dflt: 1,
            editType: "calc"
          },
          sizemin: {
            valType: "number",
            min: 0,
            dflt: 0,
            editType: "calc"
          },
          sizemode: {
            valType: "enumerated",
            values: ["diameter", "area"],
            dflt: "diameter",
            editType: "calc"
          },
          line: f({
            width: {
              valType: "number",
              min: 0,
              arrayOk: !0,
              editType: "style",
              anim: !0
            },
            editType: "calc"
          }, o("marker.line", {
            anim: !0
          })),
          gradient: {
            type: {
              valType: "enumerated",
              values: ["radial", "horizontal", "vertical", "none"],
              arrayOk: !0,
              dflt: "none",
              editType: "calc"
            },
            color: {
              valType: "color",
              arrayOk: !0,
              editType: "calc"
            },
            editType: "calc"
          },
          editType: "calc"
        }, o("marker", {
          anim: !0
        })),
        selected: {
          marker: {
            opacity: {
              valType: "number",
              min: 0,
              max: 1,
              editType: "style"
            },
            color: {
              valType: "color",
              editType: "style"
            },
            size: {
              valType: "number",
              min: 0,
              editType: "style"
            },
            editType: "style"
          },
          textfont: {
            color: {
              valType: "color",
              editType: "style"
            },
            editType: "style"
          },
          editType: "style"
        },
        unselected: {
          marker: {
            opacity: {
              valType: "number",
              min: 0,
              max: 1,
              editType: "style"
            },
            color: {
              valType: "color",
              editType: "style"
            },
            size: {
              valType: "number",
              min: 0,
              editType: "style"
            },
            editType: "style"
          },
          textfont: {
            color: {
              valType: "color",
              editType: "style"
            },
            editType: "style"
          },
          editType: "style"
        },
        textposition: {
          valType: "enumerated",
          values: ["top left", "top center", "top right", "middle left", "middle center", "middle right", "bottom left", "bottom center", "bottom right"],
          dflt: "middle center",
          arrayOk: !0,
          editType: "calc"
        },
        textfont: s({
          editType: "calc",
          colorEditType: "style",
          arrayOk: !0
        })
      };
    }, {
      "../../components/colorscale/attributes": 665,
      "../../components/drawing": 680,
      "../../components/drawing/attributes": 679,
      "../../lib/extend": 785,
      "../../plots/font_attributes": 873,
      "../../plots/hoverformat_attributes": 899,
      "../../plots/template_attributes": 918,
      "./constants": 1203
    }],
    1200: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../lib"),
          a = t("../../plots/cartesian/axes"),
          o = t("../../plots/cartesian/align_period"),
          s = t("../../constants/numerical").BADNUM,
          l = t("./subtypes"),
          c = t("./colorscale_calc"),
          u = t("./arrays_to_calcdata"),
          f = t("./calc_selection");

      function h(t, e, r, n, i, o, s) {
        var c = e._length,
            u = t._fullLayout,
            f = r._id,
            h = n._id,
            p = u._firstScatter[m(e)] === e.uid,
            d = (g(e, u, r, n) || {}).orientation,
            v = e.fill;
        r._minDtick = 0, n._minDtick = 0;
        var y = {
          padded: !0
        },
            x = {
          padded: !0
        };
        s && (y.ppad = x.ppad = s);
        var b = c < 2 || i[0] !== i[c - 1] || o[0] !== o[c - 1];
        b && ("tozerox" === v || "tonextx" === v && (p || "h" === d)) ? y.tozero = !0 : (e.error_y || {}).visible || "tonexty" !== v && "tozeroy" !== v && (l.hasMarkers(e) || l.hasText(e)) || (y.padded = !1, y.ppad = 0), b && ("tozeroy" === v || "tonexty" === v && (p || "v" === d)) ? x.tozero = !0 : "tonextx" !== v && "tozerox" !== v || (x.padded = !1), f && (e._extremes[f] = a.findExtremes(r, i, y)), h && (e._extremes[h] = a.findExtremes(n, o, x));
      }

      function p(t, e) {
        if (l.hasMarkers(t)) {
          var r,
              n = t.marker,
              o = 1.6 * (t.marker.sizeref || 1);

          if (r = "area" === t.marker.sizemode ? function (t) {
            return Math.max(Math.sqrt((t || 0) / o), 3);
          } : function (t) {
            return Math.max((t || 0) / o, 3);
          }, i.isArrayOrTypedArray(n.size)) {
            var s = {
              type: "linear"
            };
            a.setConvert(s);

            for (var c = s.makeCalcdata(t.marker, "size"), u = new Array(e), f = 0; f < e; f++) {
              u[f] = r(c[f]);
            }

            return u;
          }

          return r(n.size);
        }
      }

      function d(t, e) {
        var r = m(e),
            n = t._firstScatter;
        n[r] || (n[r] = e.uid);
      }

      function m(t) {
        var e = t.stackgroup;
        return t.xaxis + t.yaxis + t.type + (e ? "-" + e : "");
      }

      function g(t, e, r, n) {
        var i = t.stackgroup;

        if (i) {
          var a = e._scatterStackOpts[r._id + n._id][i],
              o = "v" === a.orientation ? n : r;
          return "linear" === o.type || "log" === o.type ? a : void 0;
        }
      }

      e.exports = {
        calc: function calc(t, e) {
          var r,
              l,
              m,
              v,
              y,
              x,
              b = t._fullLayout,
              _ = a.getFromId(t, e.xaxis || "x"),
              w = a.getFromId(t, e.yaxis || "y"),
              T = _.makeCalcdata(e, "x"),
              k = w.makeCalcdata(e, "y"),
              M = o(e, _, "x", T),
              A = o(e, w, "y", k),
              S = e._length,
              E = new Array(S),
              L = e.ids,
              C = g(e, b, _, w),
              P = !1;

          d(b, e);
          var I,
              O = "x",
              z = "y";
          C ? (i.pushUnique(C.traceIndices, e._expandedIndex), (r = "v" === C.orientation) ? (z = "s", I = "x") : (O = "s", I = "y"), y = "interpolate" === C.stackgaps) : h(t, e, _, w, M, A, p(e, S));
          var D = !!e.xperiodalignment,
              R = !!e.yperiodalignment;

          for (l = 0; l < S; l++) {
            var F = E[l] = {},
                B = n(M[l]),
                N = n(A[l]);
            B && N ? (F[O] = M[l], F[z] = A[l], D && (F.orig_x = T[l]), R && (F.orig_y = k[l])) : C && (r ? B : N) ? (F[I] = r ? M[l] : A[l], F.gap = !0, y ? (F.s = s, P = !0) : F.s = 0) : F[O] = F[z] = s, L && (F.id = String(L[l]));
          }

          if (u(E, e), c(t, e), f(E, e), C) {
            for (l = 0; l < E.length;) {
              E[l][I] === s ? E.splice(l, 1) : l++;
            }

            if (i.sort(E, function (t, e) {
              return t[I] - e[I] || t.i - e.i;
            }), P) {
              for (l = 0; l < E.length - 1 && E[l].gap;) {
                l++;
              }

              for ((x = E[l].s) || (x = E[l].s = 0), m = 0; m < l; m++) {
                E[m].s = x;
              }

              for (v = E.length - 1; v > l && E[v].gap;) {
                v--;
              }

              for (x = E[v].s, m = E.length - 1; m > v; m--) {
                E[m].s = x;
              }

              for (; l < v;) {
                if (E[++l].gap) {
                  for (m = l + 1; E[m].gap;) {
                    m++;
                  }

                  for (var j = E[l - 1][I], U = E[l - 1].s, V = (E[m].s - U) / (E[m][I] - j); l < m;) {
                    E[l].s = U + (E[l][I] - j) * V, l++;
                  }
                }
              }
            }
          }

          return E;
        },
        calcMarkerSize: p,
        calcAxisExpansion: h,
        setFirstScatter: d,
        getStackOpts: g
      };
    }, {
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../../plots/cartesian/align_period": 842,
      "../../plots/cartesian/axes": 845,
      "./arrays_to_calcdata": 1198,
      "./calc_selection": 1201,
      "./colorscale_calc": 1202,
      "./subtypes": 1224,
      "fast-isnumeric": 240
    }],
    1201: [function (t, e, r) {
      "use strict";

      var n = t("../../lib");

      e.exports = function (t, e) {
        n.isArrayOrTypedArray(e.selectedpoints) && n.tagSelected(t, e);
      };
    }, {
      "../../lib": 795
    }],
    1202: [function (t, e, r) {
      "use strict";

      var n = t("../../components/colorscale/helpers").hasColorscale,
          i = t("../../components/colorscale/calc"),
          a = t("./subtypes");

      e.exports = function (t, e) {
        a.hasLines(e) && n(e, "line") && i(t, e, {
          vals: e.line.color,
          containerStr: "line",
          cLetter: "c"
        }), a.hasMarkers(e) && (n(e, "marker") && i(t, e, {
          vals: e.marker.color,
          containerStr: "marker",
          cLetter: "c"
        }), n(e, "marker.line") && i(t, e, {
          vals: e.marker.line.color,
          containerStr: "marker.line",
          cLetter: "c"
        }));
      };
    }, {
      "../../components/colorscale/calc": 666,
      "../../components/colorscale/helpers": 669,
      "./subtypes": 1224
    }],
    1203: [function (t, e, r) {
      "use strict";

      e.exports = {
        PTS_LINESONLY: 20,
        minTolerance: .2,
        toleranceGrowth: 10,
        maxScreensAway: 20,
        eventDataKeys: []
      };
    }, {}],
    1204: [function (t, e, r) {
      "use strict";

      var n = t("./calc");

      function i(t, e, r, n, i, a, o) {
        i[n] = !0;
        var s = {
          i: null,
          gap: !0,
          s: 0
        };

        if (s[o] = r, t.splice(e, 0, s), e && r === t[e - 1][o]) {
          var l = t[e - 1];
          s.s = l.s, s.i = l.i, s.gap = l.gap;
        } else a && (s.s = function (t, e, r, n) {
          var i = t[e - 1],
              a = t[e + 1];
          return a ? i ? i.s + (a.s - i.s) * (r - i[n]) / (a[n] - i[n]) : a.s : i.s;
        }(t, e, r, o));

        e || (t[0].t = t[1].t, t[0].trace = t[1].trace, delete t[1].t, delete t[1].trace);
      }

      e.exports = function (t, e) {
        var r = e.xaxis,
            a = e.yaxis,
            o = r._id + a._id,
            s = t._fullLayout._scatterStackOpts[o];

        if (s) {
          var l,
              c,
              u,
              f,
              h,
              p,
              d,
              m,
              g,
              v,
              y,
              x,
              b,
              _,
              w,
              T = t.calcdata;

          for (var k in s) {
            var M = (v = s[k]).traceIndices;

            if (M.length) {
              for (y = "interpolate" === v.stackgaps, x = v.groupnorm, "v" === v.orientation ? (b = "x", _ = "y") : (b = "y", _ = "x"), w = new Array(M.length), l = 0; l < w.length; l++) {
                w[l] = !1;
              }

              p = T[M[0]];
              var A = new Array(p.length);

              for (l = 0; l < p.length; l++) {
                A[l] = p[l][b];
              }

              for (l = 1; l < M.length; l++) {
                for (h = T[M[l]], c = u = 0; c < h.length; c++) {
                  for (d = h[c][b]; d > A[u] && u < A.length; u++) {
                    i(h, c, A[u], l, w, y, b), c++;
                  }

                  if (d !== A[u]) {
                    for (f = 0; f < l; f++) {
                      i(T[M[f]], u, d, f, w, y, b);
                    }

                    A.splice(u, 0, d);
                  }

                  u++;
                }

                for (; u < A.length; u++) {
                  i(h, c, A[u], l, w, y, b), c++;
                }
              }

              var S = A.length;

              for (c = 0; c < p.length; c++) {
                for (m = p[c][_] = p[c].s, l = 1; l < M.length; l++) {
                  (h = T[M[l]])[0].trace._rawLength = h[0].trace._length, h[0].trace._length = S, m += h[c].s, h[c][_] = m;
                }

                if (x) for (g = ("fraction" === x ? m : m / 100) || 1, l = 0; l < M.length; l++) {
                  var E = T[M[l]][c];
                  E[_] /= g, E.sNorm = E.s / g;
                }
              }

              for (l = 0; l < M.length; l++) {
                var L = (h = T[M[l]])[0].trace,
                    C = n.calcMarkerSize(L, L._rawLength),
                    P = Array.isArray(C);

                if (C && w[l] || P) {
                  var I = C;

                  for (C = new Array(S), c = 0; c < S; c++) {
                    C[c] = h[c].gap ? 0 : P ? I[h[c].i] : I;
                  }
                }

                var O = new Array(S),
                    z = new Array(S);

                for (c = 0; c < S; c++) {
                  O[c] = h[c].x, z[c] = h[c].y;
                }

                n.calcAxisExpansion(t, L, r, a, O, z, C), h[0].t.orientation = v.orientation;
              }
            }
          }
        }
      };
    }, {
      "./calc": 1200
    }],
    1205: [function (t, e, r) {
      "use strict";

      e.exports = function (t) {
        for (var e = 0; e < t.length; e++) {
          var r = t[e];

          if ("scatter" === r.type) {
            var n = r.fill;
            if ("none" !== n && "toself" !== n && (r.opacity = void 0, "tonexty" === n || "tonextx" === n)) for (var i = e - 1; i >= 0; i--) {
              var a = t[i];

              if ("scatter" === a.type && a.xaxis === r.xaxis && a.yaxis === r.yaxis) {
                a.opacity = void 0;
                break;
              }
            }
          }
        }
      };
    }, {}],
    1206: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../registry"),
          a = t("./attributes"),
          o = t("./constants"),
          s = t("./subtypes"),
          l = t("./xy_defaults"),
          c = t("./period_defaults"),
          u = t("./stack_defaults"),
          f = t("./marker_defaults"),
          h = t("./line_defaults"),
          p = t("./line_shape_defaults"),
          d = t("./text_defaults"),
          m = t("./fillcolor_defaults");

      e.exports = function (t, e, r, g) {
        function v(r, i) {
          return n.coerce(t, e, a, r, i);
        }

        var y = l(t, e, g, v);

        if (y || (e.visible = !1), e.visible) {
          c(t, e, g, v), v("xhoverformat"), v("yhoverformat");
          var x = u(t, e, g, v),
              b = !x && y < o.PTS_LINESONLY ? "lines+markers" : "lines";
          v("text"), v("hovertext"), v("mode", b), s.hasLines(e) && (h(t, e, r, g, v), p(t, e, v), v("connectgaps"), v("line.simplify")), s.hasMarkers(e) && f(t, e, r, g, v, {
            gradient: !0
          }), s.hasText(e) && (v("texttemplate"), d(t, e, g, v));
          var _ = [];
          (s.hasMarkers(e) || s.hasText(e)) && (v("cliponaxis"), v("marker.maxdisplayed"), _.push("points")), v("fill", x ? x.fillDflt : "none"), "none" !== e.fill && (m(t, e, r, v), s.hasLines(e) || p(t, e, v));
          var w = (e.line || {}).color,
              T = (e.marker || {}).color;
          "tonext" !== e.fill && "toself" !== e.fill || _.push("fills"), v("hoveron", _.join("+") || "points"), "fills" !== e.hoveron && v("hovertemplate");
          var k = i.getComponentMethod("errorbars", "supplyDefaults");
          k(t, e, w || T || r, {
            axis: "y"
          }), k(t, e, w || T || r, {
            axis: "x",
            inherit: "y"
          }), n.coerceSelectionMarkerOpacity(e, v);
        }
      };
    }, {
      "../../lib": 795,
      "../../registry": 923,
      "./attributes": 1199,
      "./constants": 1203,
      "./fillcolor_defaults": 1207,
      "./line_defaults": 1212,
      "./line_shape_defaults": 1214,
      "./marker_defaults": 1218,
      "./period_defaults": 1219,
      "./stack_defaults": 1222,
      "./subtypes": 1224,
      "./text_defaults": 1225,
      "./xy_defaults": 1226
    }],
    1207: [function (t, e, r) {
      "use strict";

      var n = t("../../components/color"),
          i = t("../../lib").isArrayOrTypedArray;

      e.exports = function (t, e, r, a) {
        var o = !1;

        if (e.marker) {
          var s = e.marker.color,
              l = (e.marker.line || {}).color;
          s && !i(s) ? o = s : l && !i(l) && (o = l);
        }

        a("fillcolor", n.addOpacity((e.line || {}).color || o || r, .5));
      };
    }, {
      "../../components/color": 658,
      "../../lib": 795
    }],
    1208: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/cartesian/axes");

      e.exports = function (t, e, r) {
        var i = {},
            a = {
          _fullLayout: r
        },
            o = n.getFromTrace(a, e, "x"),
            s = n.getFromTrace(a, e, "y");
        return i.xLabel = n.tickText(o, o.c2l(t.x), !0).text, i.yLabel = n.tickText(s, s.c2l(t.y), !0).text, i;
      };
    }, {
      "../../plots/cartesian/axes": 845
    }],
    1209: [function (t, e, r) {
      "use strict";

      var n = t("../../components/color"),
          i = t("./subtypes");

      e.exports = function (t, e) {
        var r, a;
        if ("lines" === t.mode) return (r = t.line.color) && n.opacity(r) ? r : t.fillcolor;
        if ("none" === t.mode) return t.fill ? t.fillcolor : "";
        var o = e.mcc || (t.marker || {}).color,
            s = e.mlcc || ((t.marker || {}).line || {}).color;
        return (a = o && n.opacity(o) ? o : s && n.opacity(s) && (e.mlw || ((t.marker || {}).line || {}).width) ? s : "") ? n.opacity(a) < .3 ? n.addOpacity(a, .3) : a : (r = (t.line || {}).color) && n.opacity(r) && i.hasLines(t) && t.line.width ? r : t.fillcolor;
      };
    }, {
      "../../components/color": 658,
      "./subtypes": 1224
    }],
    1210: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../components/fx"),
          a = t("../../registry"),
          o = t("./get_trace_color"),
          s = t("../../components/color"),
          l = n.fillText;

      e.exports = function (t, e, r, c) {
        var u = t.cd,
            f = u[0].trace,
            h = t.xa,
            p = t.ya,
            d = h.c2p(e),
            m = p.c2p(r),
            g = [d, m],
            v = f.hoveron || "",
            y = -1 !== f.mode.indexOf("markers") ? 3 : .5;

        if (-1 !== v.indexOf("points")) {
          var x = function x(t) {
            var e = Math.max(y, t.mrc || 0),
                r = h.c2p(t.x) - d,
                n = p.c2p(t.y) - m;
            return Math.max(Math.sqrt(r * r + n * n) - e, 1 - y / e);
          },
              b = i.getDistanceFunction(c, function (t) {
            var e = Math.max(3, t.mrc || 0),
                r = 1 - 1 / e,
                n = Math.abs(h.c2p(t.x) - d);
            return void 0 !== t.orig_x && (n += h.c2p(t.orig_x) - h.c2p(t.x)), n < e ? r * n / e : n - e + r;
          }, function (t) {
            var e = Math.max(3, t.mrc || 0),
                r = 1 - 1 / e,
                n = Math.abs(p.c2p(t.y) - m);
            return void 0 !== t.orig_y && (n += p.c2p(t.orig_y) - p.c2p(t.y)), n < e ? r * n / e : n - e + r;
          }, x);

          if (i.getClosest(u, b, t), !1 !== t.index) {
            var _ = u[t.index],
                w = h.c2p(_.x, !0),
                T = p.c2p(_.y, !0),
                k = _.mrc || 1;
            t.index = _.i;
            var M = u[0].t.orientation,
                A = M && (_.sNorm || _.s),
                S = "h" === M ? A : void 0 !== _.orig_x ? _.orig_x : _.x,
                E = "v" === M ? A : void 0 !== _.orig_y ? _.orig_y : _.y;
            return n.extendFlat(t, {
              color: o(f, _),
              x0: w - k,
              x1: w + k,
              xLabelVal: S,
              y0: T - k,
              y1: T + k,
              yLabelVal: E,
              spikeDistance: x(_),
              hovertemplate: f.hovertemplate
            }), l(_, f, t), a.getComponentMethod("errorbars", "hoverInfo")(_, f, t), [t];
          }
        }

        if (-1 !== v.indexOf("fills") && f._polygons) {
          var L,
              C,
              P,
              I,
              O,
              z,
              D,
              R,
              F,
              B = f._polygons,
              N = [],
              j = !1,
              U = 1 / 0,
              V = -1 / 0,
              q = 1 / 0,
              H = -1 / 0;

          for (L = 0; L < B.length; L++) {
            (P = B[L]).contains(g) && (j = !j, N.push(P), q = Math.min(q, P.ymin), H = Math.max(H, P.ymax));
          }

          if (j) {
            var G = ((q = Math.max(q, 0)) + (H = Math.min(H, p._length))) / 2;

            for (L = 0; L < N.length; L++) {
              for (I = N[L].pts, C = 1; C < I.length; C++) {
                (R = I[C - 1][1]) > G != (F = I[C][1]) >= G && (z = I[C - 1][0], D = I[C][0], F - R && (O = z + (D - z) * (G - R) / (F - R), U = Math.min(U, O), V = Math.max(V, O)));
              }
            }

            U = Math.max(U, 0), V = Math.min(V, h._length);
            var Y = s.defaultLine;
            return s.opacity(f.fillcolor) ? Y = f.fillcolor : s.opacity((f.line || {}).color) && (Y = f.line.color), n.extendFlat(t, {
              distance: t.maxHoverDistance,
              x0: U,
              x1: V,
              y0: G,
              y1: G,
              color: Y,
              hovertemplate: !1
            }), delete t.index, f.text && !Array.isArray(f.text) ? t.text = String(f.text) : t.text = f.name, [t];
          }
        }
      };
    }, {
      "../../components/color": 658,
      "../../components/fx": 698,
      "../../lib": 795,
      "../../registry": 923,
      "./get_trace_color": 1209
    }],
    1211: [function (t, e, r) {
      "use strict";

      var n = t("./subtypes");
      e.exports = {
        hasLines: n.hasLines,
        hasMarkers: n.hasMarkers,
        hasText: n.hasText,
        isBubble: n.isBubble,
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        crossTraceDefaults: t("./cross_trace_defaults"),
        calc: t("./calc").calc,
        crossTraceCalc: t("./cross_trace_calc"),
        arraysToCalcdata: t("./arrays_to_calcdata"),
        plot: t("./plot"),
        colorbar: t("./marker_colorbar"),
        formatLabels: t("./format_labels"),
        style: t("./style").style,
        styleOnSelect: t("./style").styleOnSelect,
        hoverPoints: t("./hover"),
        selectPoints: t("./select"),
        animatable: !0,
        moduleType: "trace",
        name: "scatter",
        basePlotModule: t("../../plots/cartesian"),
        categories: ["cartesian", "svg", "symbols", "errorBarsOK", "showLegend", "scatter-like", "zoomScale"],
        meta: {}
      };
    }, {
      "../../plots/cartesian": 858,
      "./arrays_to_calcdata": 1198,
      "./attributes": 1199,
      "./calc": 1200,
      "./cross_trace_calc": 1204,
      "./cross_trace_defaults": 1205,
      "./defaults": 1206,
      "./format_labels": 1208,
      "./hover": 1210,
      "./marker_colorbar": 1217,
      "./plot": 1220,
      "./select": 1221,
      "./style": 1223,
      "./subtypes": 1224
    }],
    1212: [function (t, e, r) {
      "use strict";

      var n = t("../../lib").isArrayOrTypedArray,
          i = t("../../components/colorscale/helpers").hasColorscale,
          a = t("../../components/colorscale/defaults");

      e.exports = function (t, e, r, o, s, l) {
        var c = (t.marker || {}).color;
        (s("line.color", r), i(t, "line")) ? a(t, e, o, s, {
          prefix: "line.",
          cLetter: "c"
        }) : s("line.color", !n(c) && c || r);
        s("line.width"), (l || {}).noDash || s("line.dash");
      };
    }, {
      "../../components/colorscale/defaults": 668,
      "../../components/colorscale/helpers": 669,
      "../../lib": 795
    }],
    1213: [function (t, e, r) {
      "use strict";

      var n = t("../../constants/numerical"),
          i = n.BADNUM,
          a = n.LOG_CLIP,
          o = a + .5,
          s = a - .5,
          l = t("../../lib"),
          c = l.segmentsIntersect,
          u = l.constrain,
          f = t("./constants");

      e.exports = function (t, e) {
        var r,
            n,
            a,
            h,
            p,
            d,
            m,
            g,
            v,
            y,
            x,
            b,
            _,
            w,
            T,
            k,
            M,
            A,
            S = e.xaxis,
            E = e.yaxis,
            L = "log" === S.type,
            C = "log" === E.type,
            P = S._length,
            I = E._length,
            O = e.connectGaps,
            z = e.baseTolerance,
            D = e.shape,
            R = "linear" === D,
            F = e.fill && "none" !== e.fill,
            B = [],
            N = f.minTolerance,
            j = t.length,
            U = new Array(j),
            V = 0;

        function q(r) {
          var n = t[r];
          if (!n) return !1;
          var a = e.linearized ? S.l2p(n.x) : S.c2p(n.x),
              l = e.linearized ? E.l2p(n.y) : E.c2p(n.y);

          if (a === i) {
            if (L && (a = S.c2p(n.x, !0)), a === i) return !1;
            C && l === i && (a *= Math.abs(S._m * I * (S._m > 0 ? o : s) / (E._m * P * (E._m > 0 ? o : s)))), a *= 1e3;
          }

          if (l === i) {
            if (C && (l = E.c2p(n.y, !0)), l === i) return !1;
            l *= 1e3;
          }

          return [a, l];
        }

        function H(t, e, r, n) {
          var i = r - t,
              a = n - e,
              o = .5 - t,
              s = .5 - e,
              l = i * i + a * a,
              c = i * o + a * s;

          if (c > 0 && c < l) {
            var u = o * a - s * i;
            if (u * u < l) return !0;
          }
        }

        function G(t, e) {
          var r = t[0] / P,
              n = t[1] / I,
              i = Math.max(0, -r, r - 1, -n, n - 1);
          return i && void 0 !== M && H(r, n, M, A) && (i = 0), i && e && H(r, n, e[0] / P, e[1] / I) && (i = 0), (1 + f.toleranceGrowth * i) * z;
        }

        function Y(t, e) {
          var r = t[0] - e[0],
              n = t[1] - e[1];
          return Math.sqrt(r * r + n * n);
        }

        var W,
            X,
            Z,
            J,
            K,
            Q,
            $,
            tt = f.maxScreensAway,
            et = -P * tt,
            rt = P * (1 + tt),
            nt = -I * tt,
            it = I * (1 + tt),
            at = [[et, nt, rt, nt], [rt, nt, rt, it], [rt, it, et, it], [et, it, et, nt]];

        function ot(t) {
          if (t[0] < et || t[0] > rt || t[1] < nt || t[1] > it) return [u(t[0], et, rt), u(t[1], nt, it)];
        }

        function st(t, e) {
          return t[0] === e[0] && (t[0] === et || t[0] === rt) || t[1] === e[1] && (t[1] === nt || t[1] === it) || void 0;
        }

        function lt(t, e, r) {
          return function (n, i) {
            var a = ot(n),
                o = ot(i),
                s = [];
            if (a && o && st(a, o)) return s;
            a && s.push(a), o && s.push(o);
            var c = 2 * l.constrain((n[t] + i[t]) / 2, e, r) - ((a || n)[t] + (o || i)[t]);
            c && ((a && o ? c > 0 == a[t] > o[t] ? a : o : a || o)[t] += c);
            return s;
          };
        }

        function ct(t) {
          var e = t[0],
              r = t[1],
              n = e === U[V - 1][0],
              i = r === U[V - 1][1];
          if (!n || !i) if (V > 1) {
            var a = e === U[V - 2][0],
                o = r === U[V - 2][1];
            n && (e === et || e === rt) && a ? o ? V-- : U[V - 1] = t : i && (r === nt || r === it) && o ? a ? V-- : U[V - 1] = t : U[V++] = t;
          } else U[V++] = t;
        }

        function ut(t) {
          U[V - 1][0] !== t[0] && U[V - 1][1] !== t[1] && ct([Z, J]), ct(t), K = null, Z = J = 0;
        }

        function ft(t) {
          if (M = t[0] / P, A = t[1] / I, W = t[0] < et ? et : t[0] > rt ? rt : 0, X = t[1] < nt ? nt : t[1] > it ? it : 0, W || X) {
            if (V) {
              if (K) {
                var e = $(K, t);
                e.length > 1 && (ut(e[0]), U[V++] = e[1]);
              } else Q = $(U[V - 1], t)[0], U[V++] = Q;
            } else U[V++] = [W || t[0], X || t[1]];
            var r = U[V - 1];
            W && X && (r[0] !== W || r[1] !== X) ? (K && (Z !== W && J !== X ? ct(Z && J ? (n = K, a = (i = t)[0] - n[0], o = (i[1] - n[1]) / a, (n[1] * i[0] - i[1] * n[0]) / a > 0 ? [o > 0 ? et : rt, it] : [o > 0 ? rt : et, nt]) : [Z || W, J || X]) : Z && J && ct([Z, J])), ct([W, X])) : Z - W && J - X && ct([W || Z, X || J]), K = t, Z = W, J = X;
          } else K && ut($(K, t)[0]), U[V++] = t;

          var n, i, a, o;
        }

        for ("linear" === D || "spline" === D ? $ = function $(t, e) {
          for (var r = [], n = 0, i = 0; i < 4; i++) {
            var a = at[i],
                o = c(t[0], t[1], e[0], e[1], a[0], a[1], a[2], a[3]);
            o && (!n || Math.abs(o.x - r[0][0]) > 1 || Math.abs(o.y - r[0][1]) > 1) && (o = [o.x, o.y], n && Y(o, t) < Y(r[0], t) ? r.unshift(o) : r.push(o), n++);
          }

          return r;
        } : "hv" === D || "vh" === D ? $ = function $(t, e) {
          var r = [],
              n = ot(t),
              i = ot(e);
          return n && i && st(n, i) || (n && r.push(n), i && r.push(i)), r;
        } : "hvh" === D ? $ = lt(0, et, rt) : "vhv" === D && ($ = lt(1, nt, it)), r = 0; r < j; r++) {
          if (n = q(r)) {
            for (V = 0, K = null, ft(n), r++; r < j; r++) {
              if (!(h = q(r))) {
                if (O) continue;
                break;
              }

              if (R && e.simplify) {
                var ht = q(r + 1);

                if (y = Y(h, n), F && (0 === V || V === j - 1) || !(y < G(h, ht) * N)) {
                  for (g = [(h[0] - n[0]) / y, (h[1] - n[1]) / y], p = n, x = y, b = w = T = 0, m = !1, a = h, r++; r < t.length; r++) {
                    if (d = ht, ht = q(r + 1), !d) {
                      if (O) continue;
                      break;
                    }

                    if (k = (v = [d[0] - n[0], d[1] - n[1]])[0] * g[1] - v[1] * g[0], w = Math.min(w, k), (T = Math.max(T, k)) - w > G(d, ht)) break;
                    a = d, (_ = v[0] * g[0] + v[1] * g[1]) > x ? (x = _, h = d, m = !1) : _ < b && (b = _, p = d, m = !0);
                  }

                  if (m ? (ft(h), a !== p && ft(p)) : (p !== n && ft(p), a !== h && ft(h)), ft(a), r >= t.length || !d) break;
                  ft(d), n = d;
                }
              } else ft(h);
            }

            K && ct([Z || K[0], J || K[1]]), B.push(U.slice(0, V));
          }
        }

        return B;
      };
    }, {
      "../../constants/numerical": 771,
      "../../lib": 795,
      "./constants": 1203
    }],
    1214: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r) {
        "spline" === r("line.shape") && r("line.smoothing");
      };
    }, {}],
    1215: [function (t, e, r) {
      "use strict";

      var n = {
        tonextx: 1,
        tonexty: 1,
        tonext: 1
      };

      e.exports = function (t, e, r) {
        var i,
            a,
            o,
            s,
            l,
            c = {},
            u = !1,
            f = -1,
            h = 0,
            p = -1;

        for (a = 0; a < r.length; a++) {
          (o = (i = r[a][0].trace).stackgroup || "") ? o in c ? l = c[o] : (l = c[o] = h, h++) : i.fill in n && p >= 0 ? l = p : (l = p = h, h++), l < f && (u = !0), i._groupIndex = f = l;
        }

        var d = r.slice();
        u && d.sort(function (t, e) {
          var r = t[0].trace,
              n = e[0].trace;
          return r._groupIndex - n._groupIndex || r.index - n.index;
        });
        var m = {};

        for (a = 0; a < d.length; a++) {
          o = (i = d[a][0].trace).stackgroup || "", !0 === i.visible ? (i._nexttrace = null, i.fill in n && (s = m[o], i._prevtrace = s || null, s && (s._nexttrace = i)), i._ownfill = i.fill && ("tozero" === i.fill.substr(0, 6) || "toself" === i.fill || "to" === i.fill.substr(0, 2) && !i._prevtrace), m[o] = i) : i._prevtrace = i._nexttrace = i._ownfill = null;
        }

        return d;
      };
    }, {}],
    1216: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric");

      e.exports = function (t) {
        var e = t.marker,
            r = e.sizeref || 1,
            i = e.sizemin || 0,
            a = "area" === e.sizemode ? function (t) {
          return Math.sqrt(t / r);
        } : function (t) {
          return t / r;
        };
        return function (t) {
          var e = a(t / 2);
          return n(e) && e > 0 ? Math.max(e, i) : 0;
        };
      };
    }, {
      "fast-isnumeric": 240
    }],
    1217: [function (t, e, r) {
      "use strict";

      e.exports = {
        container: "marker",
        min: "cmin",
        max: "cmax"
      };
    }, {}],
    1218: [function (t, e, r) {
      "use strict";

      var n = t("../../components/color"),
          i = t("../../components/colorscale/helpers").hasColorscale,
          a = t("../../components/colorscale/defaults"),
          o = t("./subtypes");

      e.exports = function (t, e, r, s, l, c) {
        var u = o.isBubble(t),
            f = (t.line || {}).color;
        (c = c || {}, f && (r = f), l("marker.symbol"), l("marker.opacity", u ? .7 : 1), l("marker.size"), l("marker.color", r), i(t, "marker") && a(t, e, s, l, {
          prefix: "marker.",
          cLetter: "c"
        }), c.noSelect || (l("selected.marker.color"), l("unselected.marker.color"), l("selected.marker.size"), l("unselected.marker.size")), c.noLine || (l("marker.line.color", f && !Array.isArray(f) && e.marker.color !== f ? f : u ? n.background : n.defaultLine), i(t, "marker.line") && a(t, e, s, l, {
          prefix: "marker.line.",
          cLetter: "c"
        }), l("marker.line.width", u ? 1 : 0)), u && (l("marker.sizeref"), l("marker.sizemin"), l("marker.sizemode")), c.gradient) && "none" !== l("marker.gradient.type") && l("marker.gradient.color");
      };
    }, {
      "../../components/color": 658,
      "../../components/colorscale/defaults": 668,
      "../../components/colorscale/helpers": 669,
      "./subtypes": 1224
    }],
    1219: [function (t, e, r) {
      "use strict";

      var n = t("../../lib").dateTick0,
          i = t("../../constants/numerical").ONEWEEK;

      function a(t, e) {
        return n(e, t % i == 0 ? 1 : 0);
      }

      e.exports = function (t, e, r, n, i) {
        if (i || (i = {
          x: !0,
          y: !0
        }), i.x) {
          var o = n("xperiod");
          o && (n("xperiod0", a(o, e.xcalendar)), n("xperiodalignment"));
        }

        if (i.y) {
          var s = n("yperiod");
          s && (n("yperiod0", a(s, e.ycalendar)), n("yperiodalignment"));
        }
      };
    }, {
      "../../constants/numerical": 771,
      "../../lib": 795
    }],
    1220: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../registry"),
          a = t("../../lib"),
          o = a.ensureSingle,
          s = a.identity,
          l = t("../../components/drawing"),
          c = t("./subtypes"),
          u = t("./line_points"),
          f = t("./link_traces"),
          h = t("../../lib/polygon").tester;

      function p(t, e, r, f, p, d, m) {
        var g;
        !function (t, e, r, i, o) {
          var s = r.xaxis,
              l = r.yaxis,
              u = n.extent(a.simpleMap(s.range, s.r2c)),
              f = n.extent(a.simpleMap(l.range, l.r2c)),
              h = i[0].trace;
          if (!c.hasMarkers(h)) return;
          var p = h.marker.maxdisplayed;
          if (0 === p) return;
          var d = i.filter(function (t) {
            return t.x >= u[0] && t.x <= u[1] && t.y >= f[0] && t.y <= f[1];
          }),
              m = Math.ceil(d.length / p),
              g = 0;
          o.forEach(function (t, r) {
            var n = t[0].trace;
            c.hasMarkers(n) && n.marker.maxdisplayed > 0 && r < e && g++;
          });
          var v = Math.round(g * m / 3 + Math.floor(g / 3) * m / 7.1);
          i.forEach(function (t) {
            delete t.vis;
          }), d.forEach(function (t, e) {
            0 === Math.round((e + v) % m) && (t.vis = !0);
          });
        }(0, e, r, f, p);
        var v = !!m && m.duration > 0;

        function y(t) {
          return v ? t.transition() : t;
        }

        var x = r.xaxis,
            b = r.yaxis,
            _ = f[0].trace,
            w = _.line,
            T = n.select(d),
            k = o(T, "g", "errorbars"),
            M = o(T, "g", "lines"),
            A = o(T, "g", "points"),
            S = o(T, "g", "text");

        if (i.getComponentMethod("errorbars", "plot")(t, k, r, m), !0 === _.visible) {
          var E, L;
          y(T).style("opacity", _.opacity);

          var C = _.fill.charAt(_.fill.length - 1);

          "x" !== C && "y" !== C && (C = ""), f[0][r.isRangePlot ? "nodeRangePlot3" : "node3"] = T;
          var P,
              I,
              O = "",
              z = [],
              D = _._prevtrace;
          D && (O = D._prevRevpath || "", L = D._nextFill, z = D._polygons);
          var R,
              F,
              B,
              N,
              j,
              U,
              V,
              q = "",
              H = "",
              G = [],
              Y = a.noop;

          if (E = _._ownFill, c.hasLines(_) || "none" !== _.fill) {
            for (L && L.datum(f), -1 !== ["hv", "vh", "hvh", "vhv"].indexOf(w.shape) ? (R = l.steps(w.shape), F = l.steps(w.shape.split("").reverse().join(""))) : R = F = "spline" === w.shape ? function (t) {
              var e = t[t.length - 1];
              return t.length > 1 && t[0][0] === e[0] && t[0][1] === e[1] ? l.smoothclosed(t.slice(1), w.smoothing) : l.smoothopen(t, w.smoothing);
            } : function (t) {
              return "M" + t.join("L");
            }, B = function B(t) {
              return F(t.reverse());
            }, G = u(f, {
              xaxis: x,
              yaxis: b,
              connectGaps: _.connectgaps,
              baseTolerance: Math.max(w.width || 1, 3) / 4,
              shape: w.shape,
              simplify: w.simplify,
              fill: _.fill
            }), V = _._polygons = new Array(G.length), g = 0; g < G.length; g++) {
              _._polygons[g] = h(G[g]);
            }

            G.length && (N = G[0][0], U = (j = G[G.length - 1])[j.length - 1]), Y = function Y(t) {
              return function (e) {
                if (P = R(e), I = B(e), q ? C ? (q += "L" + P.substr(1), H = I + "L" + H.substr(1)) : (q += "Z" + P, H = I + "Z" + H) : (q = P, H = I), c.hasLines(_) && e.length > 1) {
                  var r = n.select(this);
                  if (r.datum(f), t) y(r.style("opacity", 0).attr("d", P).call(l.lineGroupStyle)).style("opacity", 1);else {
                    var i = y(r);
                    i.attr("d", P), l.singleLineStyle(f, i);
                  }
                }
              };
            };
          }

          var W = M.selectAll(".js-line").data(G);
          y(W.exit()).style("opacity", 0).remove(), W.each(Y(!1)), W.enter().append("path").classed("js-line", !0).style("vector-effect", "non-scaling-stroke").call(l.lineGroupStyle).each(Y(!0)), l.setClipUrl(W, r.layerClipId, t), G.length ? (E ? (E.datum(f), N && U && (C ? ("y" === C ? N[1] = U[1] = b.c2p(0, !0) : "x" === C && (N[0] = U[0] = x.c2p(0, !0)), y(E).attr("d", "M" + U + "L" + N + "L" + q.substr(1)).call(l.singleFillStyle)) : y(E).attr("d", q + "Z").call(l.singleFillStyle))) : L && ("tonext" === _.fill.substr(0, 6) && q && O ? ("tonext" === _.fill ? y(L).attr("d", q + "Z" + O + "Z").call(l.singleFillStyle) : y(L).attr("d", q + "L" + O.substr(1) + "Z").call(l.singleFillStyle), _._polygons = _._polygons.concat(z)) : (Z(L), _._polygons = null)), _._prevRevpath = H, _._prevPolygons = V) : (E ? Z(E) : L && Z(L), _._polygons = _._prevRevpath = _._prevPolygons = null), A.datum(f), S.datum(f), function (e, i, a) {
            var o,
                u = a[0].trace,
                f = c.hasMarkers(u),
                h = c.hasText(u),
                p = tt(u),
                d = et,
                m = et;

            if (f || h) {
              var g = s,
                  _ = u.stackgroup,
                  w = _ && "infer zero" === t._fullLayout._scatterStackOpts[x._id + b._id][_].stackgaps;
              u.marker.maxdisplayed || u._needsCull ? g = w ? K : J : _ && !w && (g = Q), f && (d = g), h && (m = g);
            }

            var T,
                k = (o = e.selectAll("path.point").data(d, p)).enter().append("path").classed("point", !0);
            v && k.call(l.pointStyle, u, t).call(l.translatePoints, x, b).style("opacity", 0).transition().style("opacity", 1), o.order(), f && (T = l.makePointStyleFns(u)), o.each(function (e) {
              var i = n.select(this),
                  a = y(i);
              l.translatePoint(e, a, x, b) ? (l.singlePointStyle(e, a, u, T, t), r.layerClipId && l.hideOutsideRangePoint(e, a, x, b, u.xcalendar, u.ycalendar), u.customdata && i.classed("plotly-customdata", null !== e.data && void 0 !== e.data)) : a.remove();
            }), v ? o.exit().transition().style("opacity", 0).remove() : o.exit().remove(), (o = i.selectAll("g").data(m, p)).enter().append("g").classed("textpoint", !0).append("text"), o.order(), o.each(function (t) {
              var e = n.select(this),
                  i = y(e.select("text"));
              l.translatePoint(t, i, x, b) ? r.layerClipId && l.hideOutsideRangePoint(t, e, x, b, u.xcalendar, u.ycalendar) : e.remove();
            }), o.selectAll("text").call(l.textPointStyle, u, t).each(function (t) {
              var e = x.c2p(t.x),
                  r = b.c2p(t.y);
              n.select(this).selectAll("tspan.line").each(function () {
                y(n.select(this)).attr({
                  x: e,
                  y: r
                });
              });
            }), o.exit().remove();
          }(A, S, f);
          var X = !1 === _.cliponaxis ? null : r.layerClipId;
          l.setClipUrl(A, X, t), l.setClipUrl(S, X, t);
        }

        function Z(t) {
          y(t).attr("d", "M0,0Z");
        }

        function J(t) {
          return t.filter(function (t) {
            return !t.gap && t.vis;
          });
        }

        function K(t) {
          return t.filter(function (t) {
            return t.vis;
          });
        }

        function Q(t) {
          return t.filter(function (t) {
            return !t.gap;
          });
        }

        function $(t) {
          return t.id;
        }

        function tt(t) {
          if (t.ids) return $;
        }

        function et() {
          return !1;
        }
      }

      e.exports = function (t, e, r, i, a, c) {
        var u,
            h,
            d = !a,
            m = !!a && a.duration > 0,
            g = f(t, e, r);
        ((u = i.selectAll("g.trace").data(g, function (t) {
          return t[0].trace.uid;
        })).enter().append("g").attr("class", function (t) {
          return "trace scatter trace" + t[0].trace.uid;
        }).style("stroke-miterlimit", 2), u.order(), function (t, e, r) {
          e.each(function (e) {
            var i = o(n.select(this), "g", "fills");
            l.setClipUrl(i, r.layerClipId, t);
            var a = e[0].trace,
                c = [];
            a._ownfill && c.push("_ownFill"), a._nexttrace && c.push("_nextFill");
            var u = i.selectAll("g").data(c, s);
            u.enter().append("g"), u.exit().each(function (t) {
              a[t] = null;
            }).remove(), u.order().each(function (t) {
              a[t] = o(n.select(this), "path", "js-fill");
            });
          });
        }(t, u, e), m) ? (c && (h = c()), n.transition().duration(a.duration).ease(a.easing).each("end", function () {
          h && h();
        }).each("interrupt", function () {
          h && h();
        }).each(function () {
          i.selectAll("g.trace").each(function (r, n) {
            p(t, n, e, r, g, this, a);
          });
        })) : u.each(function (r, n) {
          p(t, n, e, r, g, this, a);
        });
        d && u.exit().remove(), i.selectAll("path:not([d])").remove();
      };
    }, {
      "../../components/drawing": 680,
      "../../lib": 795,
      "../../lib/polygon": 807,
      "../../registry": 923,
      "./line_points": 1213,
      "./link_traces": 1215,
      "./subtypes": 1224,
      "@plotly/d3": 57
    }],
    1221: [function (t, e, r) {
      "use strict";

      var n = t("./subtypes");

      e.exports = function (t, e) {
        var r,
            i,
            a,
            o,
            s = t.cd,
            l = t.xaxis,
            c = t.yaxis,
            u = [],
            f = s[0].trace;
        if (!n.hasMarkers(f) && !n.hasText(f)) return [];
        if (!1 === e) for (r = 0; r < s.length; r++) {
          s[r].selected = 0;
        } else for (r = 0; r < s.length; r++) {
          i = s[r], a = l.c2p(i.x), o = c.c2p(i.y), null !== i.i && e.contains([a, o], !1, r, t) ? (u.push({
            pointNumber: i.i,
            x: l.c2d(i.x),
            y: c.c2d(i.y)
          }), i.selected = 1) : i.selected = 0;
        }
        return u;
      };
    }, {
      "./subtypes": 1224
    }],
    1222: [function (t, e, r) {
      "use strict";

      var n = ["orientation", "groupnorm", "stackgaps"];

      e.exports = function (t, e, r, i) {
        var a = r._scatterStackOpts,
            o = i("stackgroup");

        if (o) {
          var s = e.xaxis + e.yaxis,
              l = a[s];
          l || (l = a[s] = {});
          var c = l[o],
              u = !1;
          c ? c.traces.push(e) : (c = l[o] = {
            traceIndices: [],
            traces: [e]
          }, u = !0);

          for (var f = {
            orientation: e.x && !e.y ? "h" : "v"
          }, h = 0; h < n.length; h++) {
            var p = n[h],
                d = p + "Found";

            if (!c[d]) {
              var m = void 0 !== t[p],
                  g = "orientation" === p;
              if ((m || u) && (c[p] = i(p, f[p]), g && (c.fillDflt = "h" === c[p] ? "tonextx" : "tonexty"), m && (c[d] = !0, !u && (delete c.traces[0][p], g)))) for (var v = 0; v < c.traces.length - 1; v++) {
                var y = c.traces[v];
                y._input.fill !== y.fill && (y.fill = c.fillDflt);
              }
            }
          }

          return c;
        }
      };
    }, {}],
    1223: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../components/drawing"),
          a = t("../../registry");

      function o(t, e, r) {
        i.pointStyle(t.selectAll("path.point"), e, r);
      }

      function s(t, e, r) {
        i.textPointStyle(t.selectAll("text"), e, r);
      }

      e.exports = {
        style: function style(t) {
          var e = n.select(t).selectAll("g.trace.scatter");
          e.style("opacity", function (t) {
            return t[0].trace.opacity;
          }), e.selectAll("g.points").each(function (e) {
            o(n.select(this), e.trace || e[0].trace, t);
          }), e.selectAll("g.text").each(function (e) {
            s(n.select(this), e.trace || e[0].trace, t);
          }), e.selectAll("g.trace path.js-line").call(i.lineGroupStyle), e.selectAll("g.trace path.js-fill").call(i.fillGroupStyle), a.getComponentMethod("errorbars", "style")(e);
        },
        stylePoints: o,
        styleText: s,
        styleOnSelect: function styleOnSelect(t, e, r) {
          var n = e[0].trace;
          n.selectedpoints ? (i.selectedPointStyle(r.selectAll("path.point"), n), i.selectedTextStyle(r.selectAll("text"), n)) : (o(r, n, t), s(r, n, t));
        }
      };
    }, {
      "../../components/drawing": 680,
      "../../registry": 923,
      "@plotly/d3": 57
    }],
    1224: [function (t, e, r) {
      "use strict";

      var n = t("../../lib");
      e.exports = {
        hasLines: function hasLines(t) {
          return t.visible && t.mode && -1 !== t.mode.indexOf("lines");
        },
        hasMarkers: function hasMarkers(t) {
          return t.visible && (t.mode && -1 !== t.mode.indexOf("markers") || "splom" === t.type);
        },
        hasText: function hasText(t) {
          return t.visible && t.mode && -1 !== t.mode.indexOf("text");
        },
        isBubble: function isBubble(t) {
          return n.isPlainObject(t.marker) && n.isArrayOrTypedArray(t.marker.size);
        }
      };
    }, {
      "../../lib": 795
    }],
    1225: [function (t, e, r) {
      "use strict";

      var n = t("../../lib");

      e.exports = function (t, e, r, i, a) {
        a = a || {}, i("textposition"), n.coerceFont(i, "textfont", r.font), a.noSelect || (i("selected.textfont.color"), i("unselected.textfont.color"));
      };
    }, {
      "../../lib": 795
    }],
    1226: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../registry");

      e.exports = function (t, e, r, a) {
        var o,
            s = a("x"),
            l = a("y");

        if (i.getComponentMethod("calendars", "handleTraceDefaults")(t, e, ["x", "y"], r), s) {
          var c = n.minRowLength(s);
          l ? o = Math.min(c, n.minRowLength(l)) : (o = c, a("y0"), a("dy"));
        } else {
          if (!l) return 0;
          o = n.minRowLength(l), a("x0"), a("dx");
        }

        return e._length = o, o;
      };
    }, {
      "../../lib": 795,
      "../../registry": 923
    }],
    1227: [function (t, e, r) {
      "use strict";

      var n = t("../scatter/attributes"),
          i = t("../../components/colorscale/attributes"),
          a = t("../../plots/hoverformat_attributes"),
          o = t("../../plots/template_attributes").hovertemplateAttrs,
          s = t("../../plots/template_attributes").texttemplateAttrs,
          l = t("../../plots/attributes"),
          c = t("../../constants/gl3d_dashes"),
          u = t("../../constants/gl3d_markers"),
          f = t("../../lib/extend").extendFlat,
          h = t("../../plot_api/edit_types").overrideAll,
          p = n.line,
          d = n.marker,
          m = d.line,
          g = f({
        width: p.width,
        dash: {
          valType: "enumerated",
          values: Object.keys(c),
          dflt: "solid"
        }
      }, i("line"));
      var v = e.exports = h({
        x: n.x,
        y: n.y,
        z: {
          valType: "data_array"
        },
        text: f({}, n.text, {}),
        texttemplate: s({}, {}),
        hovertext: f({}, n.hovertext, {}),
        hovertemplate: o(),
        xhoverformat: a("x"),
        yhoverformat: a("y"),
        zhoverformat: a("z"),
        mode: f({}, n.mode, {
          dflt: "lines+markers"
        }),
        surfaceaxis: {
          valType: "enumerated",
          values: [-1, 0, 1, 2],
          dflt: -1
        },
        surfacecolor: {
          valType: "color"
        },
        projection: {
          x: {
            show: {
              valType: "boolean",
              dflt: !1
            },
            opacity: {
              valType: "number",
              min: 0,
              max: 1,
              dflt: 1
            },
            scale: {
              valType: "number",
              min: 0,
              max: 10,
              dflt: 2 / 3
            }
          },
          y: {
            show: {
              valType: "boolean",
              dflt: !1
            },
            opacity: {
              valType: "number",
              min: 0,
              max: 1,
              dflt: 1
            },
            scale: {
              valType: "number",
              min: 0,
              max: 10,
              dflt: 2 / 3
            }
          },
          z: {
            show: {
              valType: "boolean",
              dflt: !1
            },
            opacity: {
              valType: "number",
              min: 0,
              max: 1,
              dflt: 1
            },
            scale: {
              valType: "number",
              min: 0,
              max: 10,
              dflt: 2 / 3
            }
          }
        },
        connectgaps: n.connectgaps,
        line: g,
        marker: f({
          symbol: {
            valType: "enumerated",
            values: Object.keys(u),
            dflt: "circle",
            arrayOk: !0
          },
          size: f({}, d.size, {
            dflt: 8
          }),
          sizeref: d.sizeref,
          sizemin: d.sizemin,
          sizemode: d.sizemode,
          opacity: f({}, d.opacity, {
            arrayOk: !1
          }),
          colorbar: d.colorbar,
          line: f({
            width: f({}, m.width, {
              arrayOk: !1
            })
          }, i("marker.line"))
        }, i("marker")),
        textposition: f({}, n.textposition, {
          dflt: "top center"
        }),
        textfont: {
          color: n.textfont.color,
          size: n.textfont.size,
          family: f({}, n.textfont.family, {
            arrayOk: !1
          })
        },
        hoverinfo: f({}, l.hoverinfo)
      }, "calc", "nested");
      v.x.editType = v.y.editType = v.z.editType = "calc+clearAxisTypes";
    }, {
      "../../components/colorscale/attributes": 665,
      "../../constants/gl3d_dashes": 768,
      "../../constants/gl3d_markers": 769,
      "../../lib/extend": 785,
      "../../plot_api/edit_types": 827,
      "../../plots/attributes": 841,
      "../../plots/hoverformat_attributes": 899,
      "../../plots/template_attributes": 918,
      "../scatter/attributes": 1199
    }],
    1228: [function (t, e, r) {
      "use strict";

      var n = t("../scatter/arrays_to_calcdata"),
          i = t("../scatter/colorscale_calc");

      e.exports = function (t, e) {
        var r = [{
          x: !1,
          y: !1,
          trace: e,
          t: {}
        }];
        return n(r, e), i(t, e), r;
      };
    }, {
      "../scatter/arrays_to_calcdata": 1198,
      "../scatter/colorscale_calc": 1202
    }],
    1229: [function (t, e, r) {
      "use strict";

      var n = t("../../registry");

      function i(t, e, r, i) {
        if (!e || !e.visible) return null;

        for (var a = n.getComponentMethod("errorbars", "makeComputeError")(e), o = new Array(t.length), s = 0; s < t.length; s++) {
          var l = a(+t[s], s);

          if ("log" === i.type) {
            var c = i.c2l(t[s]),
                u = t[s] - l[0],
                f = t[s] + l[1];

            if (o[s] = [(i.c2l(u, !0) - c) * r, (i.c2l(f, !0) - c) * r], u > 0) {
              var h = i.c2l(u);
              i._lowerLogErrorBound || (i._lowerLogErrorBound = h), i._lowerErrorBound = Math.min(i._lowerLogErrorBound, h);
            }
          } else o[s] = [-l[0] * r, l[1] * r];
        }

        return o;
      }

      e.exports = function (t, e, r) {
        var n = [i(t.x, t.error_x, e[0], r.xaxis), i(t.y, t.error_y, e[1], r.yaxis), i(t.z, t.error_z, e[2], r.zaxis)],
            a = function (t) {
          for (var e = 0; e < t.length; e++) {
            if (t[e]) return t[e].length;
          }

          return 0;
        }(n);

        if (0 === a) return null;

        for (var o = new Array(a), s = 0; s < a; s++) {
          for (var l = [[0, 0, 0], [0, 0, 0]], c = 0; c < 3; c++) {
            if (n[c]) for (var u = 0; u < 2; u++) {
              l[u][c] = n[c][s][u];
            }
          }

          o[s] = l;
        }

        return o;
      };
    }, {
      "../../registry": 923
    }],
    1230: [function (t, e, r) {
      "use strict";

      var n = t("gl-line3d"),
          i = t("gl-scatter3d"),
          a = t("gl-error3d"),
          o = t("gl-mesh3d"),
          s = t("delaunay-triangulate"),
          l = t("../../lib"),
          c = t("../../lib/str2rgbarray"),
          u = t("../../lib/gl_format_color").formatColor,
          f = t("../scatter/make_bubble_size_func"),
          h = t("../../constants/gl3d_dashes"),
          p = t("../../constants/gl3d_markers"),
          d = t("../../plots/cartesian/axes"),
          m = t("../../components/fx/helpers").appendArrayPointValue,
          g = t("./calc_errors");

      function v(t, e) {
        this.scene = t, this.uid = e, this.linePlot = null, this.scatterPlot = null, this.errorBars = null, this.textMarkers = null, this.delaunayMesh = null, this.color = null, this.mode = "", this.dataPoints = [], this.axesBounds = [[-1 / 0, -1 / 0, -1 / 0], [1 / 0, 1 / 0, 1 / 0]], this.textLabels = null, this.data = null;
      }

      var y = v.prototype;

      function x(t) {
        return null == t ? 0 : t.indexOf("left") > -1 ? -1 : t.indexOf("right") > -1 ? 1 : 0;
      }

      function b(t) {
        return null == t ? 0 : t.indexOf("top") > -1 ? -1 : t.indexOf("bottom") > -1 ? 1 : 0;
      }

      function _(t, e) {
        return e(4 * t);
      }

      function w(t) {
        return p[t];
      }

      function T(t, e, r, n, i) {
        var a = null;

        if (l.isArrayOrTypedArray(t)) {
          a = [];

          for (var o = 0; o < e; o++) {
            void 0 === t[o] ? a[o] = n : a[o] = r(t[o], i);
          }
        } else a = r(t, l.identity);

        return a;
      }

      function k(t, e) {
        var r,
            n,
            i,
            a,
            o,
            s,
            h = [],
            p = t.fullSceneLayout,
            v = t.dataScale,
            y = p.xaxis,
            k = p.yaxis,
            M = p.zaxis,
            A = e.marker,
            S = e.line,
            E = e.x || [],
            L = e.y || [],
            C = e.z || [],
            P = E.length,
            I = e.xcalendar,
            O = e.ycalendar,
            z = e.zcalendar;

        for (o = 0; o < P; o++) {
          r = y.d2l(E[o], 0, I) * v[0], n = k.d2l(L[o], 0, O) * v[1], i = M.d2l(C[o], 0, z) * v[2], h[o] = [r, n, i];
        }

        if (Array.isArray(e.text)) s = e.text;else if (void 0 !== e.text) for (s = new Array(P), o = 0; o < P; o++) {
          s[o] = e.text;
        }

        function D(t, e) {
          var r = p[t];
          return d.tickText(r, r.d2l(e), !0).text;
        }

        var R = e.texttemplate;

        if (R) {
          var F = t.fullLayout._d3locale,
              B = Array.isArray(R),
              N = B ? Math.min(R.length, P) : P,
              j = B ? function (t) {
            return R[t];
          } : function () {
            return R;
          };

          for (s = new Array(N), o = 0; o < N; o++) {
            var U = {
              x: E[o],
              y: L[o],
              z: C[o]
            },
                V = {
              xLabel: D("xaxis", E[o]),
              yLabel: D("yaxis", L[o]),
              zLabel: D("zaxis", C[o])
            },
                q = {};
            m(q, e, o);
            var H = e._meta || {};
            s[o] = l.texttemplateString(j(o), V, F, q, U, H);
          }
        }

        if (a = {
          position: h,
          mode: e.mode,
          text: s
        }, "line" in e && (a.lineColor = u(S, 1, P), a.lineWidth = S.width, a.lineDashes = S.dash), "marker" in e) {
          var G = f(e);
          a.scatterColor = u(A, 1, P), a.scatterSize = T(A.size, P, _, 20, G), a.scatterMarker = T(A.symbol, P, w, "\u25CF"), a.scatterLineWidth = A.line.width, a.scatterLineColor = u(A.line, 1, P), a.scatterAngle = 0;
        }

        "textposition" in e && (a.textOffset = function (t) {
          var e = [0, 0];
          if (Array.isArray(t)) for (var r = 0; r < t.length; r++) {
            e[r] = [0, 0], t[r] && (e[r][0] = x(t[r]), e[r][1] = b(t[r]));
          } else e[0] = x(t), e[1] = b(t);
          return e;
        }(e.textposition), a.textColor = u(e.textfont, 1, P), a.textSize = T(e.textfont.size, P, l.identity, 12), a.textFont = e.textfont.family, a.textAngle = 0);
        var Y = ["x", "y", "z"];

        for (a.project = [!1, !1, !1], a.projectScale = [1, 1, 1], a.projectOpacity = [1, 1, 1], o = 0; o < 3; ++o) {
          var W = e.projection[Y[o]];
          (a.project[o] = W.show) && (a.projectOpacity[o] = W.opacity, a.projectScale[o] = W.scale);
        }

        a.errorBounds = g(e, v, p);

        var X = function (t) {
          for (var e = [0, 0, 0], r = [[0, 0, 0], [0, 0, 0], [0, 0, 0]], n = [1, 1, 1], i = 0; i < 3; i++) {
            var a = t[i];
            a && !1 !== a.copy_zstyle && !1 !== t[2].visible && (a = t[2]), a && a.visible && (e[i] = a.width / 2, r[i] = c(a.color), n[i] = a.thickness);
          }

          return {
            capSize: e,
            color: r,
            lineWidth: n
          };
        }([e.error_x, e.error_y, e.error_z]);

        return a.errorColor = X.color, a.errorLineWidth = X.lineWidth, a.errorCapSize = X.capSize, a.delaunayAxis = e.surfaceaxis, a.delaunayColor = c(e.surfacecolor), a;
      }

      function M(t) {
        if (l.isArrayOrTypedArray(t)) {
          var e = t[0];
          return l.isArrayOrTypedArray(e) && (t = e), "rgb(" + t.slice(0, 3).map(function (t) {
            return Math.round(255 * t);
          }) + ")";
        }

        return null;
      }

      function A(t) {
        return l.isArrayOrTypedArray(t) ? 4 === t.length && "number" == typeof t[0] ? M(t) : t.map(M) : null;
      }

      y.handlePick = function (t) {
        if (t.object && (t.object === this.linePlot || t.object === this.delaunayMesh || t.object === this.textMarkers || t.object === this.scatterPlot)) {
          var e = t.index = t.data.index;
          return t.object.highlight && t.object.highlight(null), this.scatterPlot && (t.object = this.scatterPlot, this.scatterPlot.highlight(t.data)), t.textLabel = "", this.textLabels && (Array.isArray(this.textLabels) ? (this.textLabels[e] || 0 === this.textLabels[e]) && (t.textLabel = this.textLabels[e]) : t.textLabel = this.textLabels), t.traceCoordinate = [this.data.x[e], this.data.y[e], this.data.z[e]], !0;
        }
      }, y.update = function (t) {
        var e,
            r,
            l,
            c,
            u = this.scene.glplot.gl,
            f = h.solid;
        this.data = t;
        var p = k(this.scene, t);
        "mode" in p && (this.mode = p.mode), "lineDashes" in p && p.lineDashes in h && (f = h[p.lineDashes]), this.color = A(p.scatterColor) || A(p.lineColor), this.dataPoints = p.position, e = {
          gl: this.scene.glplot.gl,
          position: p.position,
          color: p.lineColor,
          lineWidth: p.lineWidth || 1,
          dashes: f[0],
          dashScale: f[1],
          opacity: t.opacity,
          connectGaps: t.connectgaps
        }, -1 !== this.mode.indexOf("lines") ? this.linePlot ? this.linePlot.update(e) : (this.linePlot = n(e), this.linePlot._trace = this, this.scene.glplot.add(this.linePlot)) : this.linePlot && (this.scene.glplot.remove(this.linePlot), this.linePlot.dispose(), this.linePlot = null);
        var d = t.opacity;

        if (t.marker && t.marker.opacity && (d *= t.marker.opacity), r = {
          gl: this.scene.glplot.gl,
          position: p.position,
          color: p.scatterColor,
          size: p.scatterSize,
          glyph: p.scatterMarker,
          opacity: d,
          orthographic: !0,
          lineWidth: p.scatterLineWidth,
          lineColor: p.scatterLineColor,
          project: p.project,
          projectScale: p.projectScale,
          projectOpacity: p.projectOpacity
        }, -1 !== this.mode.indexOf("markers") ? this.scatterPlot ? this.scatterPlot.update(r) : (this.scatterPlot = i(r), this.scatterPlot._trace = this, this.scatterPlot.highlightScale = 1, this.scene.glplot.add(this.scatterPlot)) : this.scatterPlot && (this.scene.glplot.remove(this.scatterPlot), this.scatterPlot.dispose(), this.scatterPlot = null), c = {
          gl: this.scene.glplot.gl,
          position: p.position,
          glyph: p.text,
          color: p.textColor,
          size: p.textSize,
          angle: p.textAngle,
          alignment: p.textOffset,
          font: p.textFont,
          orthographic: !0,
          lineWidth: 0,
          project: !1,
          opacity: t.opacity
        }, this.textLabels = t.hovertext || t.text, -1 !== this.mode.indexOf("text") ? this.textMarkers ? this.textMarkers.update(c) : (this.textMarkers = i(c), this.textMarkers._trace = this, this.textMarkers.highlightScale = 1, this.scene.glplot.add(this.textMarkers)) : this.textMarkers && (this.scene.glplot.remove(this.textMarkers), this.textMarkers.dispose(), this.textMarkers = null), l = {
          gl: this.scene.glplot.gl,
          position: p.position,
          color: p.errorColor,
          error: p.errorBounds,
          lineWidth: p.errorLineWidth,
          capSize: p.errorCapSize,
          opacity: t.opacity
        }, this.errorBars ? p.errorBounds ? this.errorBars.update(l) : (this.scene.glplot.remove(this.errorBars), this.errorBars.dispose(), this.errorBars = null) : p.errorBounds && (this.errorBars = a(l), this.errorBars._trace = this, this.scene.glplot.add(this.errorBars)), p.delaunayAxis >= 0) {
          var m = function (t, e, r) {
            var n,
                i = (r + 1) % 3,
                a = (r + 2) % 3,
                o = [],
                l = [];

            for (n = 0; n < t.length; ++n) {
              var c = t[n];
              !isNaN(c[i]) && isFinite(c[i]) && !isNaN(c[a]) && isFinite(c[a]) && (o.push([c[i], c[a]]), l.push(n));
            }

            var u = s(o);

            for (n = 0; n < u.length; ++n) {
              for (var f = u[n], h = 0; h < f.length; ++h) {
                f[h] = l[f[h]];
              }
            }

            return {
              positions: t,
              cells: u,
              meshColor: e
            };
          }(p.position, p.delaunayColor, p.delaunayAxis);

          m.opacity = t.opacity, this.delaunayMesh ? this.delaunayMesh.update(m) : (m.gl = u, this.delaunayMesh = o(m), this.delaunayMesh._trace = this, this.scene.glplot.add(this.delaunayMesh));
        } else this.delaunayMesh && (this.scene.glplot.remove(this.delaunayMesh), this.delaunayMesh.dispose(), this.delaunayMesh = null);
      }, y.dispose = function () {
        this.linePlot && (this.scene.glplot.remove(this.linePlot), this.linePlot.dispose()), this.scatterPlot && (this.scene.glplot.remove(this.scatterPlot), this.scatterPlot.dispose()), this.errorBars && (this.scene.glplot.remove(this.errorBars), this.errorBars.dispose()), this.textMarkers && (this.scene.glplot.remove(this.textMarkers), this.textMarkers.dispose()), this.delaunayMesh && (this.scene.glplot.remove(this.delaunayMesh), this.delaunayMesh.dispose());
      }, e.exports = function (t, e) {
        var r = new v(t, e.uid);
        return r.update(e), r;
      };
    }, {
      "../../components/fx/helpers": 694,
      "../../constants/gl3d_dashes": 768,
      "../../constants/gl3d_markers": 769,
      "../../lib": 795,
      "../../lib/gl_format_color": 791,
      "../../lib/str2rgbarray": 819,
      "../../plots/cartesian/axes": 845,
      "../scatter/make_bubble_size_func": 1216,
      "./calc_errors": 1229,
      "delaunay-triangulate": 171,
      "gl-error3d": 264,
      "gl-line3d": 272,
      "gl-mesh3d": 306,
      "gl-scatter3d": 325
    }],
    1231: [function (t, e, r) {
      "use strict";

      var n = t("../../registry"),
          i = t("../../lib"),
          a = t("../scatter/subtypes"),
          o = t("../scatter/marker_defaults"),
          s = t("../scatter/line_defaults"),
          l = t("../scatter/text_defaults"),
          c = t("./attributes");

      e.exports = function (t, e, r, u) {
        function f(r, n) {
          return i.coerce(t, e, c, r, n);
        }

        if (function (t, e, r, i) {
          var a = 0,
              o = r("x"),
              s = r("y"),
              l = r("z");
          n.getComponentMethod("calendars", "handleTraceDefaults")(t, e, ["x", "y", "z"], i), o && s && l && (a = Math.min(o.length, s.length, l.length), e._length = e._xlength = e._ylength = e._zlength = a);
          return a;
        }(t, e, f, u)) {
          f("text"), f("hovertext"), f("hovertemplate"), f("xhoverformat"), f("yhoverformat"), f("zhoverformat"), f("mode"), a.hasLines(e) && (f("connectgaps"), s(t, e, r, u, f)), a.hasMarkers(e) && o(t, e, r, u, f, {
            noSelect: !0
          }), a.hasText(e) && (f("texttemplate"), l(t, e, u, f, {
            noSelect: !0
          }));
          var h = (e.line || {}).color,
              p = (e.marker || {}).color;
          f("surfaceaxis") >= 0 && f("surfacecolor", h || p);

          for (var d = ["x", "y", "z"], m = 0; m < 3; ++m) {
            var g = "projection." + d[m];
            f(g + ".show") && (f(g + ".opacity"), f(g + ".scale"));
          }

          var v = n.getComponentMethod("errorbars", "supplyDefaults");
          v(t, e, h || p || r, {
            axis: "z"
          }), v(t, e, h || p || r, {
            axis: "y",
            inherit: "z"
          }), v(t, e, h || p || r, {
            axis: "x",
            inherit: "z"
          });
        } else e.visible = !1;
      };
    }, {
      "../../lib": 795,
      "../../registry": 923,
      "../scatter/line_defaults": 1212,
      "../scatter/marker_defaults": 1218,
      "../scatter/subtypes": 1224,
      "../scatter/text_defaults": 1225,
      "./attributes": 1227
    }],
    1232: [function (t, e, r) {
      "use strict";

      e.exports = {
        plot: t("./convert"),
        attributes: t("./attributes"),
        markerSymbols: t("../../constants/gl3d_markers"),
        supplyDefaults: t("./defaults"),
        colorbar: [{
          container: "marker",
          min: "cmin",
          max: "cmax"
        }, {
          container: "line",
          min: "cmin",
          max: "cmax"
        }],
        calc: t("./calc"),
        moduleType: "trace",
        name: "scatter3d",
        basePlotModule: t("../../plots/gl3d"),
        categories: ["gl3d", "symbols", "showLegend", "scatter-like"],
        meta: {}
      };
    }, {
      "../../constants/gl3d_markers": 769,
      "../../plots/gl3d": 887,
      "./attributes": 1227,
      "./calc": 1228,
      "./convert": 1230,
      "./defaults": 1231
    }],
    1233: [function (t, e, r) {
      "use strict";

      var n = t("../scatter/attributes"),
          i = t("../../plots/attributes"),
          a = t("../../plots/template_attributes").hovertemplateAttrs,
          o = t("../../plots/template_attributes").texttemplateAttrs,
          s = t("../../components/colorscale/attributes"),
          l = t("../../lib/extend").extendFlat,
          c = n.marker,
          u = n.line,
          f = c.line;
      e.exports = {
        carpet: {
          valType: "string",
          editType: "calc"
        },
        a: {
          valType: "data_array",
          editType: "calc"
        },
        b: {
          valType: "data_array",
          editType: "calc"
        },
        mode: l({}, n.mode, {
          dflt: "markers"
        }),
        text: l({}, n.text, {}),
        texttemplate: o({
          editType: "plot"
        }, {
          keys: ["a", "b", "text"]
        }),
        hovertext: l({}, n.hovertext, {}),
        line: {
          color: u.color,
          width: u.width,
          dash: u.dash,
          shape: l({}, u.shape, {
            values: ["linear", "spline"]
          }),
          smoothing: u.smoothing,
          editType: "calc"
        },
        connectgaps: n.connectgaps,
        fill: l({}, n.fill, {
          values: ["none", "toself", "tonext"],
          dflt: "none"
        }),
        fillcolor: n.fillcolor,
        marker: l({
          symbol: c.symbol,
          opacity: c.opacity,
          maxdisplayed: c.maxdisplayed,
          size: c.size,
          sizeref: c.sizeref,
          sizemin: c.sizemin,
          sizemode: c.sizemode,
          line: l({
            width: f.width,
            editType: "calc"
          }, s("marker.line")),
          gradient: c.gradient,
          editType: "calc"
        }, s("marker")),
        textfont: n.textfont,
        textposition: n.textposition,
        selected: n.selected,
        unselected: n.unselected,
        hoverinfo: l({}, i.hoverinfo, {
          flags: ["a", "b", "text", "name"]
        }),
        hoveron: n.hoveron,
        hovertemplate: a()
      };
    }, {
      "../../components/colorscale/attributes": 665,
      "../../lib/extend": 785,
      "../../plots/attributes": 841,
      "../../plots/template_attributes": 918,
      "../scatter/attributes": 1199
    }],
    1234: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../scatter/colorscale_calc"),
          a = t("../scatter/arrays_to_calcdata"),
          o = t("../scatter/calc_selection"),
          s = t("../scatter/calc").calcMarkerSize,
          l = t("../carpet/lookup_carpetid");

      e.exports = function (t, e) {
        var r = e._carpetTrace = l(t, e);

        if (r && r.visible && "legendonly" !== r.visible) {
          var c;
          e.xaxis = r.xaxis, e.yaxis = r.yaxis;
          var u,
              f,
              h = e._length,
              p = new Array(h),
              d = !1;

          for (c = 0; c < h; c++) {
            if (u = e.a[c], f = e.b[c], n(u) && n(f)) {
              var m = r.ab2xy(+u, +f, !0),
                  g = r.isVisible(+u, +f);
              g || (d = !0), p[c] = {
                x: m[0],
                y: m[1],
                a: u,
                b: f,
                vis: g
              };
            } else p[c] = {
              x: !1,
              y: !1
            };
          }

          return e._needsCull = d, p[0].carpet = r, p[0].trace = e, s(e, h), i(t, e), a(p, e), o(p, e), p;
        }
      };
    }, {
      "../carpet/lookup_carpetid": 993,
      "../scatter/arrays_to_calcdata": 1198,
      "../scatter/calc": 1200,
      "../scatter/calc_selection": 1201,
      "../scatter/colorscale_calc": 1202,
      "fast-isnumeric": 240
    }],
    1235: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../scatter/constants"),
          a = t("../scatter/subtypes"),
          o = t("../scatter/marker_defaults"),
          s = t("../scatter/line_defaults"),
          l = t("../scatter/line_shape_defaults"),
          c = t("../scatter/text_defaults"),
          u = t("../scatter/fillcolor_defaults"),
          f = t("./attributes");

      e.exports = function (t, e, r, h) {
        function p(r, i) {
          return n.coerce(t, e, f, r, i);
        }

        p("carpet"), e.xaxis = "x", e.yaxis = "y";
        var d = p("a"),
            m = p("b"),
            g = Math.min(d.length, m.length);

        if (g) {
          e._length = g, p("text"), p("texttemplate"), p("hovertext"), p("mode", g < i.PTS_LINESONLY ? "lines+markers" : "lines"), a.hasLines(e) && (s(t, e, r, h, p), l(t, e, p), p("connectgaps")), a.hasMarkers(e) && o(t, e, r, h, p, {
            gradient: !0
          }), a.hasText(e) && c(t, e, h, p);
          var v = [];
          (a.hasMarkers(e) || a.hasText(e)) && (p("marker.maxdisplayed"), v.push("points")), p("fill"), "none" !== e.fill && (u(t, e, r, p), a.hasLines(e) || l(t, e, p)), "tonext" !== e.fill && "toself" !== e.fill || v.push("fills"), "fills" !== p("hoveron", v.join("+") || "points") && p("hovertemplate"), n.coerceSelectionMarkerOpacity(e, p);
        } else e.visible = !1;
      };
    }, {
      "../../lib": 795,
      "../scatter/constants": 1203,
      "../scatter/fillcolor_defaults": 1207,
      "../scatter/line_defaults": 1212,
      "../scatter/line_shape_defaults": 1214,
      "../scatter/marker_defaults": 1218,
      "../scatter/subtypes": 1224,
      "../scatter/text_defaults": 1225,
      "./attributes": 1233
    }],
    1236: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, n, i) {
        var a = n[i];
        return t.a = a.a, t.b = a.b, t.y = a.y, t;
      };
    }, {}],
    1237: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        var r = {},
            n = e._carpet,
            i = n.ab2ij([t.a, t.b]),
            a = Math.floor(i[0]),
            o = i[0] - a,
            s = Math.floor(i[1]),
            l = i[1] - s,
            c = n.evalxy([], a, s, o, l);
        return r.yLabel = c[1].toFixed(3), r;
      };
    }, {}],
    1238: [function (t, e, r) {
      "use strict";

      var n = t("../scatter/hover"),
          i = t("../../lib").fillText;

      e.exports = function (t, e, r, a) {
        var o = n(t, e, r, a);

        if (o && !1 !== o[0].index) {
          var s = o[0];

          if (void 0 === s.index) {
            var l = 1 - s.y0 / t.ya._length,
                c = t.xa._length,
                u = c * l / 2,
                f = c - u;
            return s.x0 = Math.max(Math.min(s.x0, f), u), s.x1 = Math.max(Math.min(s.x1, f), u), o;
          }

          var h = s.cd[s.index];
          s.a = h.a, s.b = h.b, s.xLabelVal = void 0, s.yLabelVal = void 0;

          var p = s.trace,
              d = p._carpet,
              m = p._module.formatLabels(h, p);

          s.yLabel = m.yLabel, delete s.text;
          var g = [];

          if (!p.hovertemplate) {
            var v = (h.hi || p.hoverinfo).split("+");
            -1 !== v.indexOf("all") && (v = ["a", "b", "text"]), -1 !== v.indexOf("a") && y(d.aaxis, h.a), -1 !== v.indexOf("b") && y(d.baxis, h.b), g.push("y: " + s.yLabel), -1 !== v.indexOf("text") && i(h, p, g), s.extraText = g.join("<br>");
          }

          return o;
        }

        function y(t, e) {
          var r;
          r = t.labelprefix && t.labelprefix.length > 0 ? t.labelprefix.replace(/ = $/, "") : t._hovertitle, g.push(r + ": " + e.toFixed(3) + t.labelsuffix);
        }
      };
    }, {
      "../../lib": 795,
      "../scatter/hover": 1210
    }],
    1239: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        colorbar: t("../scatter/marker_colorbar"),
        formatLabels: t("./format_labels"),
        calc: t("./calc"),
        plot: t("./plot"),
        style: t("../scatter/style").style,
        styleOnSelect: t("../scatter/style").styleOnSelect,
        hoverPoints: t("./hover"),
        selectPoints: t("../scatter/select"),
        eventData: t("./event_data"),
        moduleType: "trace",
        name: "scattercarpet",
        basePlotModule: t("../../plots/cartesian"),
        categories: ["svg", "carpet", "symbols", "showLegend", "carpetDependent", "zoomScale"],
        meta: {}
      };
    }, {
      "../../plots/cartesian": 858,
      "../scatter/marker_colorbar": 1217,
      "../scatter/select": 1221,
      "../scatter/style": 1223,
      "./attributes": 1233,
      "./calc": 1234,
      "./defaults": 1235,
      "./event_data": 1236,
      "./format_labels": 1237,
      "./hover": 1238,
      "./plot": 1240
    }],
    1240: [function (t, e, r) {
      "use strict";

      var n = t("../scatter/plot"),
          i = t("../../plots/cartesian/axes"),
          a = t("../../components/drawing");

      e.exports = function (t, e, r, o) {
        var s,
            l,
            c,
            u = r[0][0].carpet,
            f = {
          xaxis: i.getFromId(t, u.xaxis || "x"),
          yaxis: i.getFromId(t, u.yaxis || "y"),
          plot: e.plot
        };

        for (n(t, f, r, o), s = 0; s < r.length; s++) {
          l = r[s][0].trace, c = o.selectAll("g.trace" + l.uid + " .js-line"), a.setClipUrl(c, r[s][0].carpet._clipPathId, t);
        }
      };
    }, {
      "../../components/drawing": 680,
      "../../plots/cartesian/axes": 845,
      "../scatter/plot": 1220
    }],
    1241: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/template_attributes").hovertemplateAttrs,
          i = t("../../plots/template_attributes").texttemplateAttrs,
          a = t("../scatter/attributes"),
          o = t("../../plots/attributes"),
          s = t("../../components/colorscale/attributes"),
          l = t("../../components/drawing/attributes").dash,
          c = t("../../lib/extend").extendFlat,
          u = t("../../plot_api/edit_types").overrideAll,
          f = a.marker,
          h = a.line,
          p = f.line;
      e.exports = u({
        lon: {
          valType: "data_array"
        },
        lat: {
          valType: "data_array"
        },
        locations: {
          valType: "data_array"
        },
        locationmode: {
          valType: "enumerated",
          values: ["ISO-3", "USA-states", "country names", "geojson-id"],
          dflt: "ISO-3"
        },
        geojson: {
          valType: "any",
          editType: "calc"
        },
        featureidkey: {
          valType: "string",
          editType: "calc",
          dflt: "id"
        },
        mode: c({}, a.mode, {
          dflt: "markers"
        }),
        text: c({}, a.text, {}),
        texttemplate: i({
          editType: "plot"
        }, {
          keys: ["lat", "lon", "location", "text"]
        }),
        hovertext: c({}, a.hovertext, {}),
        textfont: a.textfont,
        textposition: a.textposition,
        line: {
          color: h.color,
          width: h.width,
          dash: l
        },
        connectgaps: a.connectgaps,
        marker: c({
          symbol: f.symbol,
          opacity: f.opacity,
          size: f.size,
          sizeref: f.sizeref,
          sizemin: f.sizemin,
          sizemode: f.sizemode,
          colorbar: f.colorbar,
          line: c({
            width: p.width
          }, s("marker.line")),
          gradient: f.gradient
        }, s("marker")),
        fill: {
          valType: "enumerated",
          values: ["none", "toself"],
          dflt: "none"
        },
        fillcolor: a.fillcolor,
        selected: a.selected,
        unselected: a.unselected,
        hoverinfo: c({}, o.hoverinfo, {
          flags: ["lon", "lat", "location", "text", "name"]
        }),
        hovertemplate: n()
      }, "calc", "nested");
    }, {
      "../../components/colorscale/attributes": 665,
      "../../components/drawing/attributes": 679,
      "../../lib/extend": 785,
      "../../plot_api/edit_types": 827,
      "../../plots/attributes": 841,
      "../../plots/template_attributes": 918,
      "../scatter/attributes": 1199
    }],
    1242: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../constants/numerical").BADNUM,
          a = t("../scatter/colorscale_calc"),
          o = t("../scatter/arrays_to_calcdata"),
          s = t("../scatter/calc_selection"),
          l = t("../../lib")._;

      function c(t) {
        return t && "string" == typeof t;
      }

      e.exports = function (t, e) {
        var r,
            u = Array.isArray(e.locations),
            f = u ? e.locations.length : e._length,
            h = new Array(f);
        r = e.geojson ? function (t) {
          return c(t) || n(t);
        } : c;

        for (var p = 0; p < f; p++) {
          var d = h[p] = {};

          if (u) {
            var m = e.locations[p];
            d.loc = r(m) ? m : null;
          } else {
            var g = e.lon[p],
                v = e.lat[p];
            n(g) && n(v) ? d.lonlat = [+g, +v] : d.lonlat = [i, i];
          }
        }

        return o(h, e), a(t, e), s(h, e), f && (h[0].t = {
          labels: {
            lat: l(t, "lat:") + " ",
            lon: l(t, "lon:") + " "
          }
        }), h;
      };
    }, {
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../scatter/arrays_to_calcdata": 1198,
      "../scatter/calc_selection": 1201,
      "../scatter/colorscale_calc": 1202,
      "fast-isnumeric": 240
    }],
    1243: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../scatter/subtypes"),
          a = t("../scatter/marker_defaults"),
          o = t("../scatter/line_defaults"),
          s = t("../scatter/text_defaults"),
          l = t("../scatter/fillcolor_defaults"),
          c = t("./attributes");

      e.exports = function (t, e, r, u) {
        function f(r, i) {
          return n.coerce(t, e, c, r, i);
        }

        var h,
            p = f("locations");

        if (p && p.length) {
          var d,
              m = f("geojson");
          ("string" == typeof m && "" !== m || n.isPlainObject(m)) && (d = "geojson-id"), "geojson-id" === f("locationmode", d) && f("featureidkey"), h = p.length;
        } else {
          var g = f("lon") || [],
              v = f("lat") || [];
          h = Math.min(g.length, v.length);
        }

        h ? (e._length = h, f("text"), f("hovertext"), f("hovertemplate"), f("mode"), i.hasLines(e) && (o(t, e, r, u, f), f("connectgaps")), i.hasMarkers(e) && a(t, e, r, u, f, {
          gradient: !0
        }), i.hasText(e) && (f("texttemplate"), s(t, e, u, f)), f("fill"), "none" !== e.fill && l(t, e, r, f), n.coerceSelectionMarkerOpacity(e, f)) : e.visible = !1;
      };
    }, {
      "../../lib": 795,
      "../scatter/fillcolor_defaults": 1207,
      "../scatter/line_defaults": 1212,
      "../scatter/marker_defaults": 1218,
      "../scatter/subtypes": 1224,
      "../scatter/text_defaults": 1225,
      "./attributes": 1241
    }],
    1244: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, n, i) {
        t.lon = e.lon, t.lat = e.lat, t.location = e.loc ? e.loc : null;
        var a = n[i];
        return a.fIn && a.fIn.properties && (t.properties = a.fIn.properties), t;
      };
    }, {}],
    1245: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/cartesian/axes");

      e.exports = function (t, e, r) {
        var i = {},
            a = r[e.geo]._subplot.mockAxis,
            o = t.lonlat;
        return i.lonLabel = n.tickText(a, a.c2l(o[0]), !0).text, i.latLabel = n.tickText(a, a.c2l(o[1]), !0).text, i;
      };
    }, {
      "../../plots/cartesian/axes": 845
    }],
    1246: [function (t, e, r) {
      "use strict";

      var n = t("../../components/fx"),
          i = t("../../constants/numerical").BADNUM,
          a = t("../scatter/get_trace_color"),
          o = t("../../lib").fillText,
          s = t("./attributes");

      e.exports = function (t, e, r) {
        var l = t.cd,
            c = l[0].trace,
            u = t.xa,
            f = t.ya,
            h = t.subplot,
            p = h.projection.isLonLatOverEdges,
            d = h.project;

        if (n.getClosest(l, function (t) {
          var n = t.lonlat;
          if (n[0] === i) return 1 / 0;
          if (p(n)) return 1 / 0;
          var a = d(n),
              o = d([e, r]),
              s = Math.abs(a[0] - o[0]),
              l = Math.abs(a[1] - o[1]),
              c = Math.max(3, t.mrc || 0);
          return Math.max(Math.sqrt(s * s + l * l) - c, 1 - 3 / c);
        }, t), !1 !== t.index) {
          var m = l[t.index],
              g = m.lonlat,
              v = [u.c2p(g), f.c2p(g)],
              y = m.mrc || 1;
          t.x0 = v[0] - y, t.x1 = v[0] + y, t.y0 = v[1] - y, t.y1 = v[1] + y, t.loc = m.loc, t.lon = g[0], t.lat = g[1];
          var x = {};
          x[c.geo] = {
            _subplot: h
          };

          var b = c._module.formatLabels(m, c, x);

          return t.lonLabel = b.lonLabel, t.latLabel = b.latLabel, t.color = a(c, m), t.extraText = function (t, e, r, n) {
            if (t.hovertemplate) return;
            var i = e.hi || t.hoverinfo,
                a = "all" === i ? s.hoverinfo.flags : i.split("+"),
                l = -1 !== a.indexOf("location") && Array.isArray(t.locations),
                c = -1 !== a.indexOf("lon"),
                u = -1 !== a.indexOf("lat"),
                f = -1 !== a.indexOf("text"),
                h = [];

            function p(t) {
              return t + "\xb0";
            }

            l ? h.push(e.loc) : c && u ? h.push("(" + p(r.latLabel) + ", " + p(r.lonLabel) + ")") : c ? h.push(n.lon + p(r.lonLabel)) : u && h.push(n.lat + p(r.latLabel));
            f && o(e, t, h);
            return h.join("<br>");
          }(c, m, t, l[0].t.labels), t.hovertemplate = c.hovertemplate, [t];
        }
      };
    }, {
      "../../components/fx": 698,
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../scatter/get_trace_color": 1209,
      "./attributes": 1241
    }],
    1247: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        colorbar: t("../scatter/marker_colorbar"),
        formatLabels: t("./format_labels"),
        calc: t("./calc"),
        calcGeoJSON: t("./plot").calcGeoJSON,
        plot: t("./plot").plot,
        style: t("./style"),
        styleOnSelect: t("../scatter/style").styleOnSelect,
        hoverPoints: t("./hover"),
        eventData: t("./event_data"),
        selectPoints: t("./select"),
        moduleType: "trace",
        name: "scattergeo",
        basePlotModule: t("../../plots/geo"),
        categories: ["geo", "symbols", "showLegend", "scatter-like"],
        meta: {}
      };
    }, {
      "../../plots/geo": 877,
      "../scatter/marker_colorbar": 1217,
      "../scatter/style": 1223,
      "./attributes": 1241,
      "./calc": 1242,
      "./defaults": 1243,
      "./event_data": 1244,
      "./format_labels": 1245,
      "./hover": 1246,
      "./plot": 1248,
      "./select": 1249,
      "./style": 1250
    }],
    1248: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../lib"),
          a = t("../../lib/topojson_utils").getTopojsonFeatures,
          o = t("../../lib/geojson_utils"),
          s = t("../../lib/geo_location_utils"),
          l = t("../../plots/cartesian/autorange").findExtremes,
          c = t("../../constants/numerical").BADNUM,
          u = t("../scatter/calc").calcMarkerSize,
          f = t("../scatter/subtypes"),
          h = t("./style");
      e.exports = {
        calcGeoJSON: function calcGeoJSON(t, e) {
          var r,
              n,
              i = t[0].trace,
              o = e[i.geo],
              f = o._subplot,
              h = i._length;

          if (Array.isArray(i.locations)) {
            var p = i.locationmode,
                d = "geojson-id" === p ? s.extractTraceFeature(t) : a(i, f.topojson);

            for (r = 0; r < h; r++) {
              n = t[r];
              var m = "geojson-id" === p ? n.fOut : s.locationToFeature(p, n.loc, d);
              n.lonlat = m ? m.properties.ct : [c, c];
            }
          }

          var g,
              v,
              y = {
            padded: !0
          };

          if ("geojson" === o.fitbounds && "geojson-id" === i.locationmode) {
            var x = s.computeBbox(s.getTraceGeojson(i));
            g = [x[0], x[2]], v = [x[1], x[3]];
          } else {
            for (g = new Array(h), v = new Array(h), r = 0; r < h; r++) {
              n = t[r], g[r] = n.lonlat[0], v[r] = n.lonlat[1];
            }

            y.ppad = u(i, h);
          }

          i._extremes.lon = l(o.lonaxis._ax, g, y), i._extremes.lat = l(o.lataxis._ax, v, y);
        },
        plot: function plot(t, e, r) {
          var a = e.layers.frontplot.select(".scatterlayer"),
              s = i.makeTraceGroups(a, r, "trace scattergeo");

          function l(t, e) {
            t.lonlat[0] === c && n.select(e).remove();
          }

          s.selectAll("*").remove(), s.each(function (e) {
            var r = n.select(this),
                a = e[0].trace;

            if (f.hasLines(a) || "none" !== a.fill) {
              var s = o.calcTraceToLineCoords(e),
                  c = "none" !== a.fill ? o.makePolygon(s) : o.makeLine(s);
              r.selectAll("path.js-line").data([{
                geojson: c,
                trace: a
              }]).enter().append("path").classed("js-line", !0).style("stroke-miterlimit", 2);
            }

            f.hasMarkers(a) && r.selectAll("path.point").data(i.identity).enter().append("path").classed("point", !0).each(function (t) {
              l(t, this);
            }), f.hasText(a) && r.selectAll("g").data(i.identity).enter().append("g").append("text").each(function (t) {
              l(t, this);
            }), h(t, e);
          });
        }
      };
    }, {
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../../lib/geo_location_utils": 788,
      "../../lib/geojson_utils": 789,
      "../../lib/topojson_utils": 823,
      "../../plots/cartesian/autorange": 844,
      "../scatter/calc": 1200,
      "../scatter/subtypes": 1224,
      "./style": 1250,
      "@plotly/d3": 57
    }],
    1249: [function (t, e, r) {
      "use strict";

      var n = t("../scatter/subtypes"),
          i = t("../../constants/numerical").BADNUM;

      e.exports = function (t, e) {
        var r,
            a,
            o,
            s,
            l,
            c = t.cd,
            u = t.xaxis,
            f = t.yaxis,
            h = [],
            p = c[0].trace;
        if (!n.hasMarkers(p) && !n.hasText(p)) return [];
        if (!1 === e) for (l = 0; l < c.length; l++) {
          c[l].selected = 0;
        } else for (l = 0; l < c.length; l++) {
          (a = (r = c[l]).lonlat)[0] !== i && (o = u.c2p(a), s = f.c2p(a), e.contains([o, s], null, l, t) ? (h.push({
            pointNumber: l,
            lon: a[0],
            lat: a[1]
          }), r.selected = 1) : r.selected = 0);
        }
        return h;
      };
    }, {
      "../../constants/numerical": 771,
      "../scatter/subtypes": 1224
    }],
    1250: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../components/drawing"),
          a = t("../../components/color"),
          o = t("../scatter/style"),
          s = o.stylePoints,
          l = o.styleText;

      e.exports = function (t, e) {
        e && function (t, e) {
          var r = e[0].trace,
              o = e[0].node3;
          o.style("opacity", e[0].trace.opacity), s(o, r, t), l(o, r, t), o.selectAll("path.js-line").style("fill", "none").each(function (t) {
            var e = n.select(this),
                r = t.trace,
                o = r.line || {};
            e.call(a.stroke, o.color).call(i.dashLine, o.dash || "", o.width || 0), "none" !== r.fill && e.call(a.fill, r.fillcolor);
          });
        }(t, e);
      };
    }, {
      "../../components/color": 658,
      "../../components/drawing": 680,
      "../scatter/style": 1223,
      "@plotly/d3": 57
    }],
    1251: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/attributes"),
          i = t("../scatter/attributes"),
          a = t("../../plots/hoverformat_attributes"),
          o = t("../../components/colorscale/attributes"),
          s = t("../../lib/extend").extendFlat,
          l = t("../../plot_api/edit_types").overrideAll,
          c = t("./constants").DASHES,
          u = i.line,
          f = i.marker,
          h = f.line,
          p = e.exports = l({
        x: i.x,
        x0: i.x0,
        dx: i.dx,
        y: i.y,
        y0: i.y0,
        dy: i.dy,
        xperiod: i.xperiod,
        yperiod: i.yperiod,
        xperiod0: i.xperiod0,
        yperiod0: i.yperiod0,
        xperiodalignment: i.xperiodalignment,
        yperiodalignment: i.yperiodalignment,
        xhoverformat: a("x"),
        yhoverformat: a("y"),
        text: i.text,
        hovertext: i.hovertext,
        textposition: i.textposition,
        textfont: i.textfont,
        mode: {
          valType: "flaglist",
          flags: ["lines", "markers", "text"],
          extras: ["none"]
        },
        line: {
          color: u.color,
          width: u.width,
          shape: {
            valType: "enumerated",
            values: ["linear", "hv", "vh", "hvh", "vhv"],
            dflt: "linear",
            editType: "plot"
          },
          dash: {
            valType: "enumerated",
            values: Object.keys(c),
            dflt: "solid"
          }
        },
        marker: s({}, o("marker"), {
          symbol: f.symbol,
          size: f.size,
          sizeref: f.sizeref,
          sizemin: f.sizemin,
          sizemode: f.sizemode,
          opacity: f.opacity,
          colorbar: f.colorbar,
          line: s({}, o("marker.line"), {
            width: h.width
          })
        }),
        connectgaps: i.connectgaps,
        fill: s({}, i.fill, {
          dflt: "none"
        }),
        fillcolor: i.fillcolor,
        selected: {
          marker: i.selected.marker,
          textfont: i.selected.textfont
        },
        unselected: {
          marker: i.unselected.marker,
          textfont: i.unselected.textfont
        },
        opacity: n.opacity
      }, "calc", "nested");
      p.x.editType = p.y.editType = p.x0.editType = p.y0.editType = "calc+clearAxisTypes", p.hovertemplate = i.hovertemplate, p.texttemplate = i.texttemplate;
    }, {
      "../../components/colorscale/attributes": 665,
      "../../lib/extend": 785,
      "../../plot_api/edit_types": 827,
      "../../plots/attributes": 841,
      "../../plots/hoverformat_attributes": 899,
      "../scatter/attributes": 1199,
      "./constants": 1253
    }],
    1252: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/point-cluster"),
          i = t("../../lib"),
          a = t("../../plots/cartesian/axis_ids"),
          o = t("../../plots/cartesian/autorange").findExtremes,
          s = t("../../plots/cartesian/align_period"),
          l = t("../scatter/calc"),
          c = l.calcMarkerSize,
          u = l.calcAxisExpansion,
          f = l.setFirstScatter,
          h = t("../scatter/colorscale_calc"),
          p = t("./convert"),
          d = t("./scene_update"),
          m = t("../../constants/numerical").BADNUM,
          g = t("./constants").TOO_MANY_POINTS;

      function v(t, e, r) {
        var n = t._extremes[e._id],
            i = o(e, r._bnds, {
          padded: !0
        });
        n.min = n.min.concat(i.min), n.max = n.max.concat(i.max);
      }

      e.exports = function (t, e) {
        var r,
            o = t._fullLayout,
            l = a.getFromId(t, e.xaxis),
            y = a.getFromId(t, e.yaxis),
            x = o._plots[e.xaxis + e.yaxis],
            b = e._length,
            _ = b >= g,
            w = 2 * b,
            T = {},
            k = l.makeCalcdata(e, "x"),
            M = y.makeCalcdata(e, "y"),
            A = s(e, l, "x", k),
            S = s(e, y, "y", M);

        e._x = A, e._y = S, e.xperiodalignment && (e._origX = k), e.yperiodalignment && (e._origY = M);
        var E = new Array(w),
            L = new Array(b);

        for (r = 0; r < b; r++) {
          E[2 * r] = A[r] === m ? NaN : A[r], E[2 * r + 1] = S[r] === m ? NaN : S[r], L[r] = r;
        }

        if ("log" === l.type) for (r = 0; r < w; r += 2) {
          E[r] = l.c2l(E[r]);
        }
        if ("log" === y.type) for (r = 1; r < w; r += 2) {
          E[r] = y.c2l(E[r]);
        }
        _ && "log" !== l.type && "log" !== y.type ? T.tree = n(E) : T.ids = L, h(t, e);

        var C,
            P = function (t, e, r, n, a, o) {
          var s = p.style(t, r);
          s.marker && (s.marker.positions = n);
          s.line && n.length > 1 && i.extendFlat(s.line, p.linePositions(t, r, n));

          if (s.errorX || s.errorY) {
            var l = p.errorBarPositions(t, r, n, a, o);
            s.errorX && i.extendFlat(s.errorX, l.x), s.errorY && i.extendFlat(s.errorY, l.y);
          }

          s.text && (i.extendFlat(s.text, {
            positions: n
          }, p.textPosition(t, r, s.text, s.marker)), i.extendFlat(s.textSel, {
            positions: n
          }, p.textPosition(t, r, s.text, s.markerSel)), i.extendFlat(s.textUnsel, {
            positions: n
          }, p.textPosition(t, r, s.text, s.markerUnsel)));
          return s;
        }(t, 0, e, E, A, S),
            I = d(t, x);

        return f(o, e), _ ? P.marker && (C = 2 * (P.marker.sizeAvg || Math.max(P.marker.size, 3))) : C = c(e, b), u(t, e, l, y, A, S, C), P.errorX && v(e, l, P.errorX), P.errorY && v(e, y, P.errorY), P.fill && !I.fill2d && (I.fill2d = !0), P.marker && !I.scatter2d && (I.scatter2d = !0), P.line && !I.line2d && (I.line2d = !0), !P.errorX && !P.errorY || I.error2d || (I.error2d = !0), P.text && !I.glText && (I.glText = !0), P.marker && (P.marker.snap = b), I.lineOptions.push(P.line), I.errorXOptions.push(P.errorX), I.errorYOptions.push(P.errorY), I.fillOptions.push(P.fill), I.markerOptions.push(P.marker), I.markerSelectedOptions.push(P.markerSel), I.markerUnselectedOptions.push(P.markerUnsel), I.textOptions.push(P.text), I.textSelectedOptions.push(P.textSel), I.textUnselectedOptions.push(P.textUnsel), I.selectBatch.push([]), I.unselectBatch.push([]), T._scene = I, T.index = I.count, T.x = A, T.y = S, T.positions = E, I.count++, [{
          x: !1,
          y: !1,
          t: T,
          trace: e
        }];
      };
    }, {
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../../plots/cartesian/align_period": 842,
      "../../plots/cartesian/autorange": 844,
      "../../plots/cartesian/axis_ids": 848,
      "../scatter/calc": 1200,
      "../scatter/colorscale_calc": 1202,
      "./constants": 1253,
      "./convert": 1254,
      "./scene_update": 1262,
      "@plotly/point-cluster": 58
    }],
    1253: [function (t, e, r) {
      "use strict";

      e.exports = {
        TOO_MANY_POINTS: 1e5,
        SYMBOL_SDF_SIZE: 200,
        SYMBOL_SIZE: 20,
        SYMBOL_STROKE: 1,
        DOT_RE: /-dot/,
        OPEN_RE: /-open/,
        DASHES: {
          solid: [1],
          dot: [1, 1],
          dash: [4, 1],
          longdash: [8, 1],
          dashdot: [4, 1, 1, 1],
          longdashdot: [8, 1, 1, 1]
        }
      };
    }, {}],
    1254: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("svg-path-sdf"),
          a = t("color-normalize"),
          o = t("../../registry"),
          s = t("../../lib"),
          l = t("../../components/drawing"),
          c = t("../../plots/cartesian/axis_ids"),
          u = t("../../lib/gl_format_color").formatColor,
          f = t("../scatter/subtypes"),
          h = t("../scatter/make_bubble_size_func"),
          p = t("./helpers"),
          d = t("./constants"),
          m = t("../../constants/interactions").DESELECTDIM,
          g = {
        start: 1,
        left: 1,
        end: -1,
        right: -1,
        middle: 0,
        center: 0,
        bottom: 1,
        top: -1
      },
          v = t("../../components/fx/helpers").appendArrayPointValue;

      function y(t, e) {
        var r,
            i = t._fullLayout,
            a = e._length,
            o = e.textfont,
            l = e.textposition,
            c = Array.isArray(l) ? l : [l],
            u = o.color,
            f = o.size,
            h = o.family,
            p = {},
            d = e.texttemplate;

        if (d) {
          p.text = [];
          var m = i._d3locale,
              g = Array.isArray(d),
              y = g ? Math.min(d.length, a) : a,
              x = g ? function (t) {
            return d[t];
          } : function () {
            return d;
          };

          for (r = 0; r < y; r++) {
            var b = {
              i: r
            },
                _ = e._module.formatLabels(b, e, i),
                w = {};

            v(w, e, r);
            var T = e._meta || {};
            p.text.push(s.texttemplateString(x(r), _, m, w, b, T));
          }
        } else Array.isArray(e.text) && e.text.length < a ? p.text = e.text.slice() : p.text = e.text;

        if (Array.isArray(p.text)) for (r = p.text.length; r < a; r++) {
          p.text[r] = "";
        }

        for (p.opacity = e.opacity, p.font = {}, p.align = [], p.baseline = [], r = 0; r < c.length; r++) {
          var k = c[r].split(/\s+/);

          switch (k[1]) {
            case "left":
              p.align.push("right");
              break;

            case "right":
              p.align.push("left");
              break;

            default:
              p.align.push(k[1]);
          }

          switch (k[0]) {
            case "top":
              p.baseline.push("bottom");
              break;

            case "bottom":
              p.baseline.push("top");
              break;

            default:
              p.baseline.push(k[0]);
          }
        }

        if (Array.isArray(u)) for (p.color = new Array(a), r = 0; r < a; r++) {
          p.color[r] = u[r];
        } else p.color = u;
        if (s.isArrayOrTypedArray(f) || Array.isArray(h)) for (p.font = new Array(a), r = 0; r < a; r++) {
          var M = p.font[r] = {};
          M.size = s.isTypedArray(f) ? f[r] : Array.isArray(f) ? n(f[r]) ? f[r] : 0 : f, M.family = Array.isArray(h) ? h[r] : h;
        } else p.font = {
          size: f,
          family: h
        };
        return p;
      }

      function x(t) {
        var e,
            r,
            n = t._length,
            i = t.marker,
            o = {},
            l = s.isArrayOrTypedArray(i.symbol),
            c = s.isArrayOrTypedArray(i.color),
            f = s.isArrayOrTypedArray(i.line.color),
            d = s.isArrayOrTypedArray(i.opacity),
            m = s.isArrayOrTypedArray(i.size),
            g = s.isArrayOrTypedArray(i.line.width);

        if (l || (r = p.isOpenSymbol(i.symbol)), l || c || f || d) {
          o.colors = new Array(n), o.borderColors = new Array(n);
          var v = u(i, i.opacity, n),
              y = u(i.line, i.opacity, n);

          if (!Array.isArray(y[0])) {
            var x = y;

            for (y = Array(n), e = 0; e < n; e++) {
              y[e] = x;
            }
          }

          if (!Array.isArray(v[0])) {
            var b = v;

            for (v = Array(n), e = 0; e < n; e++) {
              v[e] = b;
            }
          }

          for (o.colors = v, o.borderColors = y, e = 0; e < n; e++) {
            if (l) {
              var _ = i.symbol[e];
              r = p.isOpenSymbol(_);
            }

            r && (y[e] = v[e].slice(), v[e] = v[e].slice(), v[e][3] = 0);
          }

          o.opacity = t.opacity;
        } else r ? (o.color = a(i.color, "uint8"), o.color[3] = 0, o.borderColor = a(i.color, "uint8")) : (o.color = a(i.color, "uint8"), o.borderColor = a(i.line.color, "uint8")), o.opacity = t.opacity * i.opacity;

        if (l) for (o.markers = new Array(n), e = 0; e < n; e++) {
          o.markers[e] = E(i.symbol[e]);
        } else o.marker = E(i.symbol);
        var w,
            T = h(t);

        if (m || g) {
          var k,
              M = o.sizes = new Array(n),
              A = o.borderSizes = new Array(n),
              S = 0;

          if (m) {
            for (e = 0; e < n; e++) {
              M[e] = T(i.size[e]), S += M[e];
            }

            k = S / n;
          } else for (w = T(i.size), e = 0; e < n; e++) {
            M[e] = w;
          }

          if (g) for (e = 0; e < n; e++) {
            A[e] = i.line.width[e] / 2;
          } else for (w = i.line.width / 2, e = 0; e < n; e++) {
            A[e] = w;
          }
          o.sizeAvg = k;
        } else o.size = T(i && i.size || 10), o.borderSizes = T(i.line.width);

        return o;
      }

      function b(t, e) {
        var r = t.marker,
            n = {};
        return e ? (e.marker && e.marker.symbol ? n = x(s.extendFlat({}, r, e.marker)) : e.marker && (e.marker.size && (n.size = e.marker.size / 2), e.marker.color && (n.colors = e.marker.color), void 0 !== e.marker.opacity && (n.opacity = e.marker.opacity)), n) : n;
      }

      function _(t, e, r) {
        var n = {};
        if (!r) return n;

        if (r.textfont) {
          var i = {
            opacity: 1,
            text: e.text,
            texttemplate: e.texttemplate,
            textposition: e.textposition,
            textfont: s.extendFlat({}, e.textfont)
          };
          r.textfont && s.extendFlat(i.textfont, r.textfont), n = y(t, i);
        }

        return n;
      }

      function w(t, e) {
        var r = {
          capSize: 2 * e.width,
          lineWidth: e.thickness,
          color: e.color
        };
        return e.copy_ystyle && (r = t.error_y), r;
      }

      var T = d.SYMBOL_SDF_SIZE,
          k = d.SYMBOL_SIZE,
          M = d.SYMBOL_STROKE,
          A = {},
          S = l.symbolFuncs[0](.05 * k);

      function E(t) {
        if ("circle" === t) return null;
        var e,
            r,
            n = l.symbolNumber(t),
            a = l.symbolFuncs[n % 100],
            o = !!l.symbolNoDot[n % 100],
            s = !!l.symbolNoFill[n % 100],
            c = p.isDotSymbol(t);
        return A[t] ? A[t] : (e = c && !o ? a(1.1 * k) + S : a(k), r = i(e, {
          w: T,
          h: T,
          viewBox: [-k, -k, k, k],
          stroke: s ? M : -M
        }), A[t] = r, r || null);
      }

      e.exports = {
        style: function style(t, e) {
          var r,
              n = {
            marker: void 0,
            markerSel: void 0,
            markerUnsel: void 0,
            line: void 0,
            fill: void 0,
            errorX: void 0,
            errorY: void 0,
            text: void 0,
            textSel: void 0,
            textUnsel: void 0
          };
          if (!0 !== e.visible) return n;

          if (f.hasText(e) && (n.text = y(t, e), n.textSel = _(t, e, e.selected), n.textUnsel = _(t, e, e.unselected)), f.hasMarkers(e) && (n.marker = x(e), n.markerSel = b(e, e.selected), n.markerUnsel = b(e, e.unselected), !e.unselected && s.isArrayOrTypedArray(e.marker.opacity))) {
            var i = e.marker.opacity;

            for (n.markerUnsel.opacity = new Array(i.length), r = 0; r < i.length; r++) {
              n.markerUnsel.opacity[r] = m * i[r];
            }
          }

          if (f.hasLines(e)) {
            n.line = {
              overlay: !0,
              thickness: e.line.width,
              color: e.line.color,
              opacity: e.opacity
            };
            var a = (d.DASHES[e.line.dash] || [1]).slice();

            for (r = 0; r < a.length; ++r) {
              a[r] *= e.line.width;
            }

            n.line.dashes = a;
          }

          return e.error_x && e.error_x.visible && (n.errorX = w(e, e.error_x)), e.error_y && e.error_y.visible && (n.errorY = w(e, e.error_y)), e.fill && "none" !== e.fill && (n.fill = {
            closed: !0,
            fill: e.fillcolor,
            thickness: 0
          }), n;
        },
        markerStyle: x,
        markerSelection: b,
        linePositions: function linePositions(t, e, r) {
          var n,
              i,
              a = r.length,
              o = a / 2;
          if (f.hasLines(e) && o) if ("hv" === e.line.shape) {
            for (n = [], i = 0; i < o - 1; i++) {
              isNaN(r[2 * i]) || isNaN(r[2 * i + 1]) ? n.push(NaN, NaN, NaN, NaN) : (n.push(r[2 * i], r[2 * i + 1]), isNaN(r[2 * i + 2]) || isNaN(r[2 * i + 3]) ? n.push(NaN, NaN) : n.push(r[2 * i + 2], r[2 * i + 1]));
            }

            n.push(r[a - 2], r[a - 1]);
          } else if ("hvh" === e.line.shape) {
            for (n = [], i = 0; i < o - 1; i++) {
              if (isNaN(r[2 * i]) || isNaN(r[2 * i + 1]) || isNaN(r[2 * i + 2]) || isNaN(r[2 * i + 3])) isNaN(r[2 * i]) || isNaN(r[2 * i + 1]) ? n.push(NaN, NaN) : n.push(r[2 * i], r[2 * i + 1]), n.push(NaN, NaN);else {
                var s = (r[2 * i] + r[2 * i + 2]) / 2;
                n.push(r[2 * i], r[2 * i + 1], s, r[2 * i + 1], s, r[2 * i + 3]);
              }
            }

            n.push(r[a - 2], r[a - 1]);
          } else if ("vhv" === e.line.shape) {
            for (n = [], i = 0; i < o - 1; i++) {
              if (isNaN(r[2 * i]) || isNaN(r[2 * i + 1]) || isNaN(r[2 * i + 2]) || isNaN(r[2 * i + 3])) isNaN(r[2 * i]) || isNaN(r[2 * i + 1]) ? n.push(NaN, NaN) : n.push(r[2 * i], r[2 * i + 1]), n.push(NaN, NaN);else {
                var l = (r[2 * i + 1] + r[2 * i + 3]) / 2;
                n.push(r[2 * i], r[2 * i + 1], r[2 * i], l, r[2 * i + 2], l);
              }
            }

            n.push(r[a - 2], r[a - 1]);
          } else if ("vh" === e.line.shape) {
            for (n = [], i = 0; i < o - 1; i++) {
              isNaN(r[2 * i]) || isNaN(r[2 * i + 1]) ? n.push(NaN, NaN, NaN, NaN) : (n.push(r[2 * i], r[2 * i + 1]), isNaN(r[2 * i + 2]) || isNaN(r[2 * i + 3]) ? n.push(NaN, NaN) : n.push(r[2 * i], r[2 * i + 3]));
            }

            n.push(r[a - 2], r[a - 1]);
          } else n = r;
          var c = !1;

          for (i = 0; i < n.length; i++) {
            if (isNaN(n[i])) {
              c = !0;
              break;
            }
          }

          var u = c || n.length > d.TOO_MANY_POINTS || f.hasMarkers(e) ? "rect" : "round";

          if (c && e.connectgaps) {
            var h = n[0],
                p = n[1];

            for (i = 0; i < n.length; i += 2) {
              isNaN(n[i]) || isNaN(n[i + 1]) ? (n[i] = h, n[i + 1] = p) : (h = n[i], p = n[i + 1]);
            }
          }

          return {
            join: u,
            positions: n
          };
        },
        errorBarPositions: function errorBarPositions(t, e, r, i, a) {
          var s = o.getComponentMethod("errorbars", "makeComputeError"),
              l = c.getFromId(t, e.xaxis),
              u = c.getFromId(t, e.yaxis),
              f = r.length / 2,
              h = {};

          function p(t, i) {
            var a = i._id.charAt(0),
                o = e["error_" + a];

            if (o && o.visible && ("linear" === i.type || "log" === i.type)) {
              for (var l = s(o), c = {
                x: 0,
                y: 1
              }[a], u = {
                x: [0, 1, 2, 3],
                y: [2, 3, 0, 1]
              }[a], p = new Float64Array(4 * f), d = 1 / 0, m = -1 / 0, g = 0, v = 0; g < f; g++, v += 4) {
                var y = t[g];

                if (n(y)) {
                  var x = r[2 * g + c],
                      b = l(y, g),
                      _ = b[0],
                      w = b[1];

                  if (n(_) && n(w)) {
                    var T = y - _,
                        k = y + w;
                    p[v + u[0]] = x - i.c2l(T), p[v + u[1]] = i.c2l(k) - x, p[v + u[2]] = 0, p[v + u[3]] = 0, d = Math.min(d, y - _), m = Math.max(m, y + w);
                  }
                }
              }

              h[a] = {
                positions: r,
                errors: p,
                _bnds: [d, m]
              };
            }
          }

          return p(i, l), p(a, u), h;
        },
        textPosition: function textPosition(t, e, r, n) {
          var i,
              a = e._length,
              o = {};

          if (f.hasMarkers(e)) {
            var s = r.font,
                l = r.align,
                c = r.baseline;

            for (o.offset = new Array(a), i = 0; i < a; i++) {
              var u = n.sizes ? n.sizes[i] : n.size,
                  h = Array.isArray(s) ? s[i].size : s.size,
                  p = Array.isArray(l) ? l.length > 1 ? l[i] : l[0] : l,
                  d = Array.isArray(c) ? c.length > 1 ? c[i] : c[0] : c,
                  m = g[p],
                  v = g[d],
                  y = u ? u / .8 + 1 : 0,
                  x = -v * y - .5 * v;
              o.offset[i] = [m * y / h, x / h];
            }
          }

          return o;
        }
      };
    }, {
      "../../components/drawing": 680,
      "../../components/fx/helpers": 694,
      "../../constants/interactions": 770,
      "../../lib": 795,
      "../../lib/gl_format_color": 791,
      "../../plots/cartesian/axis_ids": 848,
      "../../registry": 923,
      "../scatter/make_bubble_size_func": 1216,
      "../scatter/subtypes": 1224,
      "./constants": 1253,
      "./helpers": 1258,
      "color-normalize": 126,
      "fast-isnumeric": 240,
      "svg-path-sdf": 587
    }],
    1255: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../registry"),
          a = t("./helpers"),
          o = t("./attributes"),
          s = t("../scatter/constants"),
          l = t("../scatter/subtypes"),
          c = t("../scatter/xy_defaults"),
          u = t("../scatter/period_defaults"),
          f = t("../scatter/marker_defaults"),
          h = t("../scatter/line_defaults"),
          p = t("../scatter/fillcolor_defaults"),
          d = t("../scatter/text_defaults");

      e.exports = function (t, e, r, m) {
        function g(r, i) {
          return n.coerce(t, e, o, r, i);
        }

        var v = !!t.marker && a.isOpenSymbol(t.marker.symbol),
            y = l.isBubble(t),
            x = c(t, e, m, g);

        if (x) {
          u(t, e, m, g), g("xhoverformat"), g("yhoverformat");
          var b = x < s.PTS_LINESONLY ? "lines+markers" : "lines";
          g("text"), g("hovertext"), g("hovertemplate"), g("mode", b), l.hasLines(e) && (g("connectgaps"), h(t, e, r, m, g), g("line.shape")), l.hasMarkers(e) && (f(t, e, r, m, g), g("marker.line.width", v || y ? 1 : 0)), l.hasText(e) && (g("texttemplate"), d(t, e, m, g));
          var _ = (e.line || {}).color,
              w = (e.marker || {}).color;
          g("fill"), "none" !== e.fill && p(t, e, r, g);
          var T = i.getComponentMethod("errorbars", "supplyDefaults");
          T(t, e, _ || w || r, {
            axis: "y"
          }), T(t, e, _ || w || r, {
            axis: "x",
            inherit: "y"
          }), n.coerceSelectionMarkerOpacity(e, g);
        } else e.visible = !1;
      };
    }, {
      "../../lib": 795,
      "../../registry": 923,
      "../scatter/constants": 1203,
      "../scatter/fillcolor_defaults": 1207,
      "../scatter/line_defaults": 1212,
      "../scatter/marker_defaults": 1218,
      "../scatter/period_defaults": 1219,
      "../scatter/subtypes": 1224,
      "../scatter/text_defaults": 1225,
      "../scatter/xy_defaults": 1226,
      "./attributes": 1251,
      "./helpers": 1258
    }],
    1256: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../components/color"),
          a = t("../../constants/interactions").DESELECTDIM;
      e.exports = {
        styleTextSelection: function styleTextSelection(t) {
          var e,
              r,
              o = t[0],
              s = o.trace,
              l = o.t,
              c = l._scene,
              u = l.index,
              f = c.selectBatch[u],
              h = c.unselectBatch[u],
              p = c.textOptions[u],
              d = c.textSelectedOptions[u] || {},
              m = c.textUnselectedOptions[u] || {},
              g = n.extendFlat({}, p);

          if (f.length || h.length) {
            var v = d.color,
                y = m.color,
                x = p.color,
                b = Array.isArray(x);

            for (g.color = new Array(s._length), e = 0; e < f.length; e++) {
              r = f[e], g.color[r] = v || (b ? x[r] : x);
            }

            for (e = 0; e < h.length; e++) {
              r = h[e];

              var _ = b ? x[r] : x;

              g.color[r] = y || (v ? _ : i.addOpacity(_, a));
            }
          }

          c.glText[u].update(g);
        }
      };
    }, {
      "../../components/color": 658,
      "../../constants/interactions": 770,
      "../../lib": 795
    }],
    1257: [function (t, e, r) {
      "use strict";

      var n = t("../scatter/format_labels");

      e.exports = function (t, e, r) {
        var i = t.i;
        return "x" in t || (t.x = e._x[i]), "y" in t || (t.y = e._y[i]), n(t, e, r);
      };
    }, {
      "../scatter/format_labels": 1208
    }],
    1258: [function (t, e, r) {
      "use strict";

      var n = t("./constants");
      r.isOpenSymbol = function (t) {
        return "string" == typeof t ? n.OPEN_RE.test(t) : t % 200 > 100;
      }, r.isDotSymbol = function (t) {
        return "string" == typeof t ? n.DOT_RE.test(t) : t > 200;
      };
    }, {
      "./constants": 1253
    }],
    1259: [function (t, e, r) {
      "use strict";

      var n = t("../../registry"),
          i = t("../../lib"),
          a = t("../scatter/get_trace_color");

      function o(t, e, r, o) {
        var s = t.xa,
            l = t.ya,
            c = t.distance,
            u = t.dxy,
            f = t.index,
            h = {
          pointNumber: f,
          x: e[f],
          y: r[f]
        };
        h.tx = Array.isArray(o.text) ? o.text[f] : o.text, h.htx = Array.isArray(o.hovertext) ? o.hovertext[f] : o.hovertext, h.data = Array.isArray(o.customdata) ? o.customdata[f] : o.customdata, h.tp = Array.isArray(o.textposition) ? o.textposition[f] : o.textposition;
        var p = o.textfont;
        p && (h.ts = i.isArrayOrTypedArray(p.size) ? p.size[f] : p.size, h.tc = Array.isArray(p.color) ? p.color[f] : p.color, h.tf = Array.isArray(p.family) ? p.family[f] : p.family);
        var d = o.marker;
        d && (h.ms = i.isArrayOrTypedArray(d.size) ? d.size[f] : d.size, h.mo = i.isArrayOrTypedArray(d.opacity) ? d.opacity[f] : d.opacity, h.mx = i.isArrayOrTypedArray(d.symbol) ? d.symbol[f] : d.symbol, h.mc = i.isArrayOrTypedArray(d.color) ? d.color[f] : d.color);
        var m = d && d.line;
        m && (h.mlc = Array.isArray(m.color) ? m.color[f] : m.color, h.mlw = i.isArrayOrTypedArray(m.width) ? m.width[f] : m.width);
        var g = d && d.gradient;
        g && "none" !== g.type && (h.mgt = Array.isArray(g.type) ? g.type[f] : g.type, h.mgc = Array.isArray(g.color) ? g.color[f] : g.color);
        var v = s.c2p(h.x, !0),
            y = l.c2p(h.y, !0),
            x = h.mrc || 1,
            b = o.hoverlabel;
        b && (h.hbg = Array.isArray(b.bgcolor) ? b.bgcolor[f] : b.bgcolor, h.hbc = Array.isArray(b.bordercolor) ? b.bordercolor[f] : b.bordercolor, h.hts = i.isArrayOrTypedArray(b.font.size) ? b.font.size[f] : b.font.size, h.htc = Array.isArray(b.font.color) ? b.font.color[f] : b.font.color, h.htf = Array.isArray(b.font.family) ? b.font.family[f] : b.font.family, h.hnl = i.isArrayOrTypedArray(b.namelength) ? b.namelength[f] : b.namelength);
        var _ = o.hoverinfo;
        _ && (h.hi = Array.isArray(_) ? _[f] : _);
        var w = o.hovertemplate;
        w && (h.ht = Array.isArray(w) ? w[f] : w);
        var T = {};
        T[t.index] = h;
        var k = o._origX,
            M = o._origY,
            A = i.extendFlat({}, t, {
          color: a(o, h),
          x0: v - x,
          x1: v + x,
          xLabelVal: k ? k[f] : h.x,
          y0: y - x,
          y1: y + x,
          yLabelVal: M ? M[f] : h.y,
          cd: T,
          distance: c,
          spikeDistance: u,
          hovertemplate: h.ht
        });
        return h.htx ? A.text = h.htx : h.tx ? A.text = h.tx : o.text && (A.text = o.text), i.fillText(h, o, A), n.getComponentMethod("errorbars", "hoverInfo")(h, o, A), A;
      }

      e.exports = {
        hoverPoints: function hoverPoints(t, e, r, n) {
          var i,
              a,
              s,
              l,
              c,
              u,
              f,
              h,
              p,
              d = t.cd,
              m = d[0].t,
              g = d[0].trace,
              v = t.xa,
              y = t.ya,
              x = m.x,
              b = m.y,
              _ = v.c2p(e),
              w = y.c2p(r),
              T = t.distance;

          if (m.tree) {
            var k = v.p2c(_ - T),
                M = v.p2c(_ + T),
                A = y.p2c(w - T),
                S = y.p2c(w + T);
            i = "x" === n ? m.tree.range(Math.min(k, M), Math.min(y._rl[0], y._rl[1]), Math.max(k, M), Math.max(y._rl[0], y._rl[1])) : m.tree.range(Math.min(k, M), Math.min(A, S), Math.max(k, M), Math.max(A, S));
          } else i = m.ids;

          var E = T;
          if ("x" === n) for (c = 0; c < i.length; c++) {
            s = x[i[c]], u = Math.abs(v.c2p(s) - _), g._origX && void 0 !== g._origX[c] && (u += v.c2p(g._origX[c]) - v.c2p(s)), u < E && (E = u, f = y.c2p(b[i[c]]) - w, g._origY && void 0 !== g._origY[c] && (f += y.c2p(g._origY[c]) - y.c2p(l)), p = Math.sqrt(u * u + f * f), a = i[c]);
          } else for (c = i.length - 1; c > -1; c--) {
            s = x[i[c]], l = b[i[c]], u = v.c2p(s) - _, f = y.c2p(l) - w, (h = Math.sqrt(u * u + f * f)) < E && (E = p = h, a = i[c]);
          }
          return t.index = a, t.distance = E, t.dxy = p, void 0 === a ? [t] : [o(t, x, b, g)];
        },
        calcHover: o
      };
    }, {
      "../../lib": 795,
      "../../registry": 923,
      "../scatter/get_trace_color": 1209
    }],
    1260: [function (t, e, r) {
      "use strict";

      var n = t("./hover");
      e.exports = {
        moduleType: "trace",
        name: "scattergl",
        basePlotModule: t("../../plots/cartesian"),
        categories: ["gl", "regl", "cartesian", "symbols", "errorBarsOK", "showLegend", "scatter-like"],
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        crossTraceDefaults: t("../scatter/cross_trace_defaults"),
        colorbar: t("../scatter/marker_colorbar"),
        formatLabels: t("./format_labels"),
        calc: t("./calc"),
        plot: t("./plot"),
        hoverPoints: n.hoverPoints,
        selectPoints: t("./select"),
        meta: {}
      };
    }, {
      "../../plots/cartesian": 858,
      "../scatter/cross_trace_defaults": 1205,
      "../scatter/marker_colorbar": 1217,
      "./attributes": 1251,
      "./calc": 1252,
      "./defaults": 1255,
      "./format_labels": 1257,
      "./hover": 1259,
      "./plot": 1261,
      "./select": 1263
    }],
    1261: [function (t, e, r) {
      "use strict";

      var n = t("regl-scatter2d"),
          i = t("regl-line2d"),
          a = t("regl-error2d"),
          o = t("gl-text"),
          s = t("../../lib"),
          l = t("../../components/dragelement/helpers").selectMode,
          c = t("../../lib/prepare_regl"),
          u = t("../scatter/subtypes"),
          f = t("../scatter/link_traces"),
          h = t("./edit_style").styleTextSelection;

      function p(t, e, r) {
        var n = t._size,
            i = t.width,
            a = t.height;
        return [n.l + e.domain[0] * n.w, n.b + r.domain[0] * n.h, i - n.r - (1 - e.domain[1]) * n.w, a - n.t - (1 - r.domain[1]) * n.h];
      }

      e.exports = function (t, e, r) {
        if (r.length) {
          var d,
              m,
              g = t._fullLayout,
              v = e._scene,
              y = e.xaxis,
              x = e.yaxis;
          if (v) if (c(t, ["ANGLE_instanced_arrays", "OES_element_index_uint"])) {
            var b = v.count,
                _ = g._glcanvas.data()[0].regl;

            if (f(t, e, r), v.dirty) {
              if (!0 === v.error2d && (v.error2d = a(_)), !0 === v.line2d && (v.line2d = i(_)), !0 === v.scatter2d && (v.scatter2d = n(_, {
                constPointSize: !0
              })), !0 === v.fill2d && (v.fill2d = i(_)), !0 === v.glText) for (v.glText = new Array(b), d = 0; d < b; d++) {
                v.glText[d] = new o(_);
              }

              if (v.glText) {
                if (b > v.glText.length) {
                  var w = b - v.glText.length;

                  for (d = 0; d < w; d++) {
                    v.glText.push(new o(_));
                  }
                } else if (b < v.glText.length) {
                  var T = v.glText.length - b;
                  v.glText.splice(b, T).forEach(function (t) {
                    t.destroy();
                  });
                }

                for (d = 0; d < b; d++) {
                  v.glText[d].update(v.textOptions[d]);
                }
              }

              if (v.line2d && (v.line2d.update(v.lineOptions), v.lineOptions = v.lineOptions.map(function (t) {
                if (t && t.positions) {
                  for (var e = t.positions, r = 0; r < e.length && (isNaN(e[r]) || isNaN(e[r + 1]));) {
                    r += 2;
                  }

                  for (var n = e.length - 2; n > r && (isNaN(e[n]) || isNaN(e[n + 1]));) {
                    n -= 2;
                  }

                  t.positions = e.slice(r, n + 2);
                }

                return t;
              }), v.line2d.update(v.lineOptions)), v.error2d) {
                var k = (v.errorXOptions || []).concat(v.errorYOptions || []);
                v.error2d.update(k);
              }

              v.scatter2d && v.scatter2d.update(v.markerOptions), v.fillOrder = s.repeat(null, b), v.fill2d && (v.fillOptions = v.fillOptions.map(function (t, e) {
                var n = r[e];

                if (t && n && n[0] && n[0].trace) {
                  var i,
                      a,
                      o = n[0],
                      s = o.trace,
                      l = o.t,
                      c = v.lineOptions[e],
                      u = [];
                  s._ownfill && u.push(e), s._nexttrace && u.push(e + 1), u.length && (v.fillOrder[e] = u);
                  var f,
                      h,
                      p = [],
                      d = c && c.positions || l.positions;

                  if ("tozeroy" === s.fill) {
                    for (f = 0; f < d.length && isNaN(d[f + 1]);) {
                      f += 2;
                    }

                    for (h = d.length - 2; h > f && isNaN(d[h + 1]);) {
                      h -= 2;
                    }

                    0 !== d[f + 1] && (p = [d[f], 0]), p = p.concat(d.slice(f, h + 2)), 0 !== d[h + 1] && (p = p.concat([d[h], 0]));
                  } else if ("tozerox" === s.fill) {
                    for (f = 0; f < d.length && isNaN(d[f]);) {
                      f += 2;
                    }

                    for (h = d.length - 2; h > f && isNaN(d[h]);) {
                      h -= 2;
                    }

                    0 !== d[f] && (p = [0, d[f + 1]]), p = p.concat(d.slice(f, h + 2)), 0 !== d[h] && (p = p.concat([0, d[h + 1]]));
                  } else if ("toself" === s.fill || "tonext" === s.fill) {
                    for (p = [], i = 0, t.splitNull = !0, a = 0; a < d.length; a += 2) {
                      (isNaN(d[a]) || isNaN(d[a + 1])) && ((p = p.concat(d.slice(i, a))).push(d[i], d[i + 1]), p.push(null, null), i = a + 2);
                    }

                    p = p.concat(d.slice(i)), i && p.push(d[i], d[i + 1]);
                  } else {
                    var m = s._nexttrace;

                    if (m) {
                      var g = v.lineOptions[e + 1];

                      if (g) {
                        var y = g.positions;

                        if ("tonexty" === s.fill) {
                          for (p = d.slice(), e = Math.floor(y.length / 2); e--;) {
                            var x = y[2 * e],
                                b = y[2 * e + 1];
                            isNaN(x) || isNaN(b) || p.push(x, b);
                          }

                          t.fill = m.fillcolor;
                        }
                      }
                    }
                  }

                  if (s._prevtrace && "tonext" === s._prevtrace.fill) {
                    var _ = v.lineOptions[e - 1].positions,
                        w = p.length / 2,
                        T = [i = w];

                    for (a = 0; a < _.length; a += 2) {
                      (isNaN(_[a]) || isNaN(_[a + 1])) && (T.push(a / 2 + w + 1), i = a + 2);
                    }

                    p = p.concat(_), t.hole = T;
                  }

                  return t.fillmode = s.fill, t.opacity = s.opacity, t.positions = p, t;
                }
              }), v.fill2d.update(v.fillOptions));
            }

            var M = g.dragmode,
                A = l(M),
                S = g.clickmode.indexOf("select") > -1;

            for (d = 0; d < b; d++) {
              var E = r[d][0],
                  L = E.trace,
                  C = E.t,
                  P = C.index,
                  I = L._length,
                  O = C.x,
                  z = C.y;

              if (L.selectedpoints || A || S) {
                if (A || (A = !0), L.selectedpoints) {
                  var D = v.selectBatch[P] = s.selIndices2selPoints(L),
                      R = {};

                  for (m = 0; m < D.length; m++) {
                    R[D[m]] = 1;
                  }

                  var F = [];

                  for (m = 0; m < I; m++) {
                    R[m] || F.push(m);
                  }

                  v.unselectBatch[P] = F;
                }

                var B = C.xpx = new Array(I),
                    N = C.ypx = new Array(I);

                for (m = 0; m < I; m++) {
                  B[m] = y.c2p(O[m]), N[m] = x.c2p(z[m]);
                }
              } else C.xpx = C.ypx = null;
            }

            if (A) {
              if (v.select2d || (v.select2d = n(g._glcanvas.data()[1].regl)), v.scatter2d) {
                var j = new Array(b);

                for (d = 0; d < b; d++) {
                  j[d] = v.selectBatch[d].length || v.unselectBatch[d].length ? v.markerUnselectedOptions[d] : {};
                }

                v.scatter2d.update(j);
              }

              v.select2d && (v.select2d.update(v.markerOptions), v.select2d.update(v.markerSelectedOptions)), v.glText && r.forEach(function (t) {
                var e = ((t || [])[0] || {}).trace || {};
                u.hasText(e) && h(t);
              });
            } else v.scatter2d && v.scatter2d.update(v.markerOptions);

            var U = {
              viewport: p(g, y, x),
              range: [(y._rl || y.range)[0], (x._rl || x.range)[0], (y._rl || y.range)[1], (x._rl || x.range)[1]]
            },
                V = s.repeat(U, v.count);
            v.fill2d && v.fill2d.update(V), v.line2d && v.line2d.update(V), v.error2d && v.error2d.update(V.concat(V)), v.scatter2d && v.scatter2d.update(V), v.select2d && v.select2d.update(V), v.glText && v.glText.forEach(function (t) {
              t.update(U);
            });
          } else v.init();
        }
      };
    }, {
      "../../components/dragelement/helpers": 676,
      "../../lib": 795,
      "../../lib/prepare_regl": 808,
      "../scatter/link_traces": 1215,
      "../scatter/subtypes": 1224,
      "./edit_style": 1256,
      "gl-text": 346,
      "regl-error2d": 528,
      "regl-line2d": 529,
      "regl-scatter2d": 530
    }],
    1262: [function (t, e, r) {
      "use strict";

      var n = t("../../lib");

      e.exports = function (t, e) {
        var r = e._scene,
            i = {
          count: 0,
          dirty: !0,
          lineOptions: [],
          fillOptions: [],
          markerOptions: [],
          markerSelectedOptions: [],
          markerUnselectedOptions: [],
          errorXOptions: [],
          errorYOptions: [],
          textOptions: [],
          textSelectedOptions: [],
          textUnselectedOptions: [],
          selectBatch: [],
          unselectBatch: []
        },
            a = {
          fill2d: !1,
          scatter2d: !1,
          error2d: !1,
          line2d: !1,
          glText: !1,
          select2d: !1
        };
        return e._scene || ((r = e._scene = {}).init = function () {
          n.extendFlat(r, a, i);
        }, r.init(), r.update = function (t) {
          var e = n.repeat(t, r.count);
          if (r.fill2d && r.fill2d.update(e), r.scatter2d && r.scatter2d.update(e), r.line2d && r.line2d.update(e), r.error2d && r.error2d.update(e.concat(e)), r.select2d && r.select2d.update(e), r.glText) for (var i = 0; i < r.count; i++) {
            r.glText[i].update(t);
          }
        }, r.draw = function () {
          for (var t = r.count, e = r.fill2d, i = r.error2d, a = r.line2d, o = r.scatter2d, s = r.glText, l = r.select2d, c = r.selectBatch, u = r.unselectBatch, f = 0; f < t; f++) {
            if (e && r.fillOrder[f] && e.draw(r.fillOrder[f]), a && r.lineOptions[f] && a.draw(f), i && (r.errorXOptions[f] && i.draw(f), r.errorYOptions[f] && i.draw(f + t)), o && r.markerOptions[f]) if (u[f].length) {
              var h = n.repeat([], r.count);
              h[f] = u[f], o.draw(h);
            } else c[f].length || o.draw(f);
            s[f] && r.textOptions[f] && s[f].render();
          }

          l && l.draw(c), r.dirty = !1;
        }, r.destroy = function () {
          r.fill2d && r.fill2d.destroy && r.fill2d.destroy(), r.scatter2d && r.scatter2d.destroy && r.scatter2d.destroy(), r.error2d && r.error2d.destroy && r.error2d.destroy(), r.line2d && r.line2d.destroy && r.line2d.destroy(), r.select2d && r.select2d.destroy && r.select2d.destroy(), r.glText && r.glText.forEach(function (t) {
            t.destroy && t.destroy();
          }), r.lineOptions = null, r.fillOptions = null, r.markerOptions = null, r.markerSelectedOptions = null, r.markerUnselectedOptions = null, r.errorXOptions = null, r.errorYOptions = null, r.textOptions = null, r.textSelectedOptions = null, r.textUnselectedOptions = null, r.selectBatch = null, r.unselectBatch = null, e._scene = null;
        }), r.dirty || n.extendFlat(r, i), r;
      };
    }, {
      "../../lib": 795
    }],
    1263: [function (t, e, r) {
      "use strict";

      var n = t("../scatter/subtypes"),
          i = t("./edit_style").styleTextSelection;

      e.exports = function (t, e) {
        var r = t.cd,
            a = t.xaxis,
            o = t.yaxis,
            s = [],
            l = r[0].trace,
            c = r[0].t,
            u = l._length,
            f = c.x,
            h = c.y,
            p = c._scene,
            d = c.index;
        if (!p) return s;
        var m = n.hasText(l),
            g = n.hasMarkers(l),
            v = !g && !m;
        if (!0 !== l.visible || v) return s;
        var y = [],
            x = [];
        if (!1 !== e && !e.degenerate) for (var b = 0; b < u; b++) {
          e.contains([c.xpx[b], c.ypx[b]], !1, b, t) ? (y.push(b), s.push({
            pointNumber: b,
            x: a.c2d(f[b]),
            y: o.c2d(h[b])
          })) : x.push(b);
        }

        if (g) {
          var _ = p.scatter2d;

          if (y.length || x.length) {
            if (!p.selectBatch[d].length && !p.unselectBatch[d].length) {
              var w = new Array(p.count);
              w[d] = p.markerUnselectedOptions[d], _.update.apply(_, w);
            }
          } else {
            var T = new Array(p.count);
            T[d] = p.markerOptions[d], _.update.apply(_, T);
          }
        }

        return p.selectBatch[d] = y, p.unselectBatch[d] = x, m && i(r), s;
      };
    }, {
      "../scatter/subtypes": 1224,
      "./edit_style": 1256
    }],
    1264: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/template_attributes").hovertemplateAttrs,
          i = t("../../plots/template_attributes").texttemplateAttrs,
          a = t("../scattergeo/attributes"),
          o = t("../scatter/attributes"),
          s = t("../../plots/mapbox/layout_attributes"),
          l = t("../../plots/attributes"),
          c = t("../../components/colorscale/attributes"),
          u = t("../../lib/extend").extendFlat,
          f = t("../../plot_api/edit_types").overrideAll,
          h = a.line,
          p = a.marker;
      e.exports = f({
        lon: a.lon,
        lat: a.lat,
        mode: u({}, o.mode, {
          dflt: "markers"
        }),
        text: u({}, o.text, {}),
        texttemplate: i({
          editType: "plot"
        }, {
          keys: ["lat", "lon", "text"]
        }),
        hovertext: u({}, o.hovertext, {}),
        line: {
          color: h.color,
          width: h.width
        },
        connectgaps: o.connectgaps,
        marker: u({
          symbol: {
            valType: "string",
            dflt: "circle",
            arrayOk: !0
          },
          angle: {
            valType: "number",
            dflt: "auto",
            arrayOk: !0
          },
          allowoverlap: {
            valType: "boolean",
            dflt: !1
          },
          opacity: p.opacity,
          size: p.size,
          sizeref: p.sizeref,
          sizemin: p.sizemin,
          sizemode: p.sizemode
        }, c("marker")),
        fill: a.fill,
        fillcolor: o.fillcolor,
        textfont: s.layers.symbol.textfont,
        textposition: s.layers.symbol.textposition,
        below: {
          valType: "string"
        },
        selected: {
          marker: o.selected.marker
        },
        unselected: {
          marker: o.unselected.marker
        },
        hoverinfo: u({}, l.hoverinfo, {
          flags: ["lon", "lat", "text", "name"]
        }),
        hovertemplate: n()
      }, "calc", "nested");
    }, {
      "../../components/colorscale/attributes": 665,
      "../../lib/extend": 785,
      "../../plot_api/edit_types": 827,
      "../../plots/attributes": 841,
      "../../plots/mapbox/layout_attributes": 905,
      "../../plots/template_attributes": 918,
      "../scatter/attributes": 1199,
      "../scattergeo/attributes": 1241
    }],
    1265: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../lib"),
          a = t("../../constants/numerical").BADNUM,
          o = t("../../lib/geojson_utils"),
          s = t("../../components/colorscale"),
          l = t("../../components/drawing"),
          c = t("../scatter/make_bubble_size_func"),
          u = t("../scatter/subtypes"),
          f = t("../../plots/mapbox/convert_text_opts"),
          h = t("../../components/fx/helpers").appendArrayPointValue,
          p = t("../../lib/svg_text_utils").NEWLINES,
          d = t("../../lib/svg_text_utils").BR_TAG_ALL;

      function m() {
        return {
          geojson: o.makeBlank(),
          layout: {
            visibility: "none"
          },
          paint: {}
        };
      }

      function g(t, e) {
        return i.isArrayOrTypedArray(t) ? e ? function (e) {
          return n(t[e]) ? +t[e] : 0;
        } : function (e) {
          return t[e];
        } : t ? function () {
          return t;
        } : v;
      }

      function v() {
        return "";
      }

      function y(t) {
        return t[0] === a;
      }

      e.exports = function (t, e) {
        var r,
            a = e[0].trace,
            x = !0 === a.visible && 0 !== a._length,
            b = "none" !== a.fill,
            _ = u.hasLines(a),
            w = u.hasMarkers(a),
            T = u.hasText(a),
            k = w && "circle" === a.marker.symbol,
            M = w && "circle" !== a.marker.symbol,
            A = m(),
            S = m(),
            E = m(),
            L = m(),
            C = {
          fill: A,
          line: S,
          circle: E,
          symbol: L
        };

        if (!x) return C;

        if ((b || _) && (r = o.calcTraceToLineCoords(e)), b && (A.geojson = o.makePolygon(r), A.layout.visibility = "visible", i.extendFlat(A.paint, {
          "fill-color": a.fillcolor
        })), _ && (S.geojson = o.makeLine(r), S.layout.visibility = "visible", i.extendFlat(S.paint, {
          "line-width": a.line.width,
          "line-color": a.line.color,
          "line-opacity": a.opacity
        })), k) {
          var P = function (t) {
            var e,
                r,
                a,
                o,
                u = t[0].trace,
                f = u.marker,
                h = u.selectedpoints,
                p = i.isArrayOrTypedArray(f.color),
                d = i.isArrayOrTypedArray(f.size),
                m = i.isArrayOrTypedArray(f.opacity);

            function g(t) {
              return u.opacity * t;
            }

            p && (r = s.hasColorscale(u, "marker") ? s.makeColorScaleFuncFromTrace(f) : i.identity);
            d && (a = c(u));
            m && (o = function o(t) {
              return g(n(t) ? +i.constrain(t, 0, 1) : 0);
            });
            var v,
                x = [];

            for (e = 0; e < t.length; e++) {
              var b = t[e],
                  _ = b.lonlat;

              if (!y(_)) {
                var w = {};
                r && (w.mcc = b.mcc = r(b.mc)), a && (w.mrc = b.mrc = a(b.ms)), o && (w.mo = o(b.mo)), h && (w.selected = b.selected || 0), x.push({
                  type: "Feature",
                  geometry: {
                    type: "Point",
                    coordinates: _
                  },
                  properties: w
                });
              }
            }

            if (h) for (v = l.makeSelectedPointStyleFns(u), e = 0; e < x.length; e++) {
              var T = x[e].properties;
              v.selectedOpacityFn && (T.mo = g(v.selectedOpacityFn(T))), v.selectedColorFn && (T.mcc = v.selectedColorFn(T)), v.selectedSizeFn && (T.mrc = v.selectedSizeFn(T));
            }
            return {
              geojson: {
                type: "FeatureCollection",
                features: x
              },
              mcc: p || v && v.selectedColorFn ? {
                type: "identity",
                property: "mcc"
              } : f.color,
              mrc: d || v && v.selectedSizeFn ? {
                type: "identity",
                property: "mrc"
              } : (k = f.size, k / 2),
              mo: m || v && v.selectedOpacityFn ? {
                type: "identity",
                property: "mo"
              } : g(f.opacity)
            };
            var k;
          }(e);

          E.geojson = P.geojson, E.layout.visibility = "visible", i.extendFlat(E.paint, {
            "circle-color": P.mcc,
            "circle-radius": P.mrc,
            "circle-opacity": P.mo
          });
        }

        if ((M || T) && (L.geojson = function (t, e) {
          for (var r = e._fullLayout, n = t[0].trace, a = n.marker || {}, o = a.symbol, s = a.angle, l = "circle" !== o ? g(o) : v, c = "auto" !== s ? g(s, !0) : v, f = u.hasText(n) ? g(n.text) : v, m = [], x = 0; x < t.length; x++) {
            var b = t[x];

            if (!y(b.lonlat)) {
              var _,
                  w = n.texttemplate;

              if (w) {
                var T = Array.isArray(w) ? w[x] || "" : w,
                    k = n._module.formatLabels(b, n, r),
                    M = {};

                h(M, n, b.i);
                var A = n._meta || {};
                _ = i.texttemplateString(T, k, r._d3locale, M, b, A);
              } else _ = f(x);

              _ && (_ = _.replace(p, "").replace(d, "\n")), m.push({
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: b.lonlat
                },
                properties: {
                  symbol: l(x),
                  angle: c(x),
                  text: _
                }
              });
            }
          }

          return {
            type: "FeatureCollection",
            features: m
          };
        }(e, t), i.extendFlat(L.layout, {
          visibility: "visible",
          "icon-image": "{symbol}-15",
          "text-field": "{text}"
        }), M && (i.extendFlat(L.layout, {
          "icon-size": a.marker.size / 10
        }), "angle" in a.marker && "auto" !== a.marker.angle && i.extendFlat(L.layout, {
          "icon-rotate": {
            type: "identity",
            property: "angle"
          },
          "icon-rotation-alignment": "map"
        }), L.layout["icon-allow-overlap"] = a.marker.allowoverlap, i.extendFlat(L.paint, {
          "icon-opacity": a.opacity * a.marker.opacity,
          "icon-color": a.marker.color
        })), T)) {
          var I = (a.marker || {}).size,
              O = f(a.textposition, I);
          i.extendFlat(L.layout, {
            "text-size": a.textfont.size,
            "text-anchor": O.anchor,
            "text-offset": O.offset
          }), i.extendFlat(L.paint, {
            "text-color": a.textfont.color,
            "text-opacity": a.opacity
          });
        }

        return C;
      };
    }, {
      "../../components/colorscale": 670,
      "../../components/drawing": 680,
      "../../components/fx/helpers": 694,
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../../lib/geojson_utils": 789,
      "../../lib/svg_text_utils": 820,
      "../../plots/mapbox/convert_text_opts": 902,
      "../scatter/make_bubble_size_func": 1216,
      "../scatter/subtypes": 1224,
      "fast-isnumeric": 240
    }],
    1266: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../scatter/subtypes"),
          a = t("../scatter/marker_defaults"),
          o = t("../scatter/line_defaults"),
          s = t("../scatter/text_defaults"),
          l = t("../scatter/fillcolor_defaults"),
          c = t("./attributes");

      e.exports = function (t, e, r, u) {
        function f(r, i) {
          return n.coerce(t, e, c, r, i);
        }

        if (function (t, e, r) {
          var n = r("lon") || [],
              i = r("lat") || [],
              a = Math.min(n.length, i.length);
          return e._length = a, a;
        }(0, e, f)) {
          if (f("text"), f("texttemplate"), f("hovertext"), f("hovertemplate"), f("mode"), f("below"), i.hasLines(e) && (o(t, e, r, u, f, {
            noDash: !0
          }), f("connectgaps")), i.hasMarkers(e)) {
            a(t, e, r, u, f, {
              noLine: !0
            }), f("marker.allowoverlap"), f("marker.angle");
            var h = e.marker;
            "circle" !== h.symbol && (n.isArrayOrTypedArray(h.size) && (h.size = h.size[0]), n.isArrayOrTypedArray(h.color) && (h.color = h.color[0]));
          }

          i.hasText(e) && s(t, e, u, f, {
            noSelect: !0
          }), f("fill"), "none" !== e.fill && l(t, e, r, f), n.coerceSelectionMarkerOpacity(e, f);
        } else e.visible = !1;
      };
    }, {
      "../../lib": 795,
      "../scatter/fillcolor_defaults": 1207,
      "../scatter/line_defaults": 1212,
      "../scatter/marker_defaults": 1218,
      "../scatter/subtypes": 1224,
      "../scatter/text_defaults": 1225,
      "./attributes": 1264
    }],
    1267: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        return t.lon = e.lon, t.lat = e.lat, t;
      };
    }, {}],
    1268: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/cartesian/axes");

      e.exports = function (t, e, r) {
        var i = {},
            a = r[e.subplot]._subplot.mockAxis,
            o = t.lonlat;
        return i.lonLabel = n.tickText(a, a.c2l(o[0]), !0).text, i.latLabel = n.tickText(a, a.c2l(o[1]), !0).text, i;
      };
    }, {
      "../../plots/cartesian/axes": 845
    }],
    1269: [function (t, e, r) {
      "use strict";

      var n = t("../../components/fx"),
          i = t("../../lib"),
          a = t("../scatter/get_trace_color"),
          o = i.fillText,
          s = t("../../constants/numerical").BADNUM;

      function l(t, e, r) {
        if (!t.hovertemplate) {
          var n = (e.hi || t.hoverinfo).split("+"),
              i = -1 !== n.indexOf("all"),
              a = -1 !== n.indexOf("lon"),
              s = -1 !== n.indexOf("lat"),
              l = e.lonlat,
              c = [];
          return i || a && s ? c.push("(" + u(l[1]) + ", " + u(l[0]) + ")") : a ? c.push(r.lon + u(l[0])) : s && c.push(r.lat + u(l[1])), (i || -1 !== n.indexOf("text")) && o(e, t, c), c.join("<br>");
        }

        function u(t) {
          return t + "\xb0";
        }
      }

      e.exports = {
        hoverPoints: function hoverPoints(t, e, r) {
          var o = t.cd,
              c = o[0].trace,
              u = t.xa,
              f = t.ya,
              h = t.subplot,
              p = 360 * (e >= 0 ? Math.floor((e + 180) / 360) : Math.ceil((e - 180) / 360)),
              d = e - p;

          if (n.getClosest(o, function (t) {
            var e = t.lonlat;
            if (e[0] === s) return 1 / 0;
            var n = i.modHalf(e[0], 360),
                a = e[1],
                o = h.project([n, a]),
                l = o.x - u.c2p([d, a]),
                c = o.y - f.c2p([n, r]),
                p = Math.max(3, t.mrc || 0);
            return Math.max(Math.sqrt(l * l + c * c) - p, 1 - 3 / p);
          }, t), !1 !== t.index) {
            var m = o[t.index],
                g = m.lonlat,
                v = [i.modHalf(g[0], 360) + p, g[1]],
                y = u.c2p(v),
                x = f.c2p(v),
                b = m.mrc || 1;
            t.x0 = y - b, t.x1 = y + b, t.y0 = x - b, t.y1 = x + b;
            var _ = {};
            _[c.subplot] = {
              _subplot: h
            };

            var w = c._module.formatLabels(m, c, _);

            return t.lonLabel = w.lonLabel, t.latLabel = w.latLabel, t.color = a(c, m), t.extraText = l(c, m, o[0].t.labels), t.hovertemplate = c.hovertemplate, [t];
          }
        },
        getExtraText: l
      };
    }, {
      "../../components/fx": 698,
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../scatter/get_trace_color": 1209
    }],
    1270: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        colorbar: t("../scatter/marker_colorbar"),
        formatLabels: t("./format_labels"),
        calc: t("../scattergeo/calc"),
        plot: t("./plot"),
        hoverPoints: t("./hover").hoverPoints,
        eventData: t("./event_data"),
        selectPoints: t("./select"),
        styleOnSelect: function styleOnSelect(t, e) {
          e && e[0].trace._glTrace.update(e);
        },
        moduleType: "trace",
        name: "scattermapbox",
        basePlotModule: t("../../plots/mapbox"),
        categories: ["mapbox", "gl", "symbols", "showLegend", "scatter-like"],
        meta: {}
      };
    }, {
      "../../plots/mapbox": 903,
      "../scatter/marker_colorbar": 1217,
      "../scattergeo/calc": 1242,
      "./attributes": 1264,
      "./defaults": 1266,
      "./event_data": 1267,
      "./format_labels": 1268,
      "./hover": 1269,
      "./plot": 1271,
      "./select": 1272
    }],
    1271: [function (t, e, r) {
      "use strict";

      var n = t("./convert"),
          i = t("../../plots/mapbox/constants").traceLayerPrefix,
          a = ["fill", "line", "circle", "symbol"];

      function o(t, e) {
        this.type = "scattermapbox", this.subplot = t, this.uid = e, this.sourceIds = {
          fill: "source-" + e + "-fill",
          line: "source-" + e + "-line",
          circle: "source-" + e + "-circle",
          symbol: "source-" + e + "-symbol"
        }, this.layerIds = {
          fill: i + e + "-fill",
          line: i + e + "-line",
          circle: i + e + "-circle",
          symbol: i + e + "-symbol"
        }, this.below = null;
      }

      var s = o.prototype;
      s.addSource = function (t, e) {
        this.subplot.map.addSource(this.sourceIds[t], {
          type: "geojson",
          data: e.geojson
        });
      }, s.setSourceData = function (t, e) {
        this.subplot.map.getSource(this.sourceIds[t]).setData(e.geojson);
      }, s.addLayer = function (t, e, r) {
        this.subplot.addLayer({
          type: t,
          id: this.layerIds[t],
          source: this.sourceIds[t],
          layout: e.layout,
          paint: e.paint
        }, r);
      }, s.update = function (t) {
        var e,
            r,
            i,
            o = this.subplot,
            s = o.map,
            l = n(o.gd, t),
            c = o.belowLookup["trace-" + this.uid];

        if (c !== this.below) {
          for (e = a.length - 1; e >= 0; e--) {
            r = a[e], s.removeLayer(this.layerIds[r]);
          }

          for (e = 0; e < a.length; e++) {
            i = l[r = a[e]], this.addLayer(r, i, c);
          }

          this.below = c;
        }

        for (e = 0; e < a.length; e++) {
          i = l[r = a[e]], o.setOptions(this.layerIds[r], "setLayoutProperty", i.layout), "visible" === i.layout.visibility && (this.setSourceData(r, i), o.setOptions(this.layerIds[r], "setPaintProperty", i.paint));
        }

        t[0].trace._glTrace = this;
      }, s.dispose = function () {
        for (var t = this.subplot.map, e = a.length - 1; e >= 0; e--) {
          var r = a[e];
          t.removeLayer(this.layerIds[r]), t.removeSource(this.sourceIds[r]);
        }
      }, e.exports = function (t, e) {
        for (var r = e[0].trace, i = new o(t, r.uid), s = n(t.gd, e), l = i.below = t.belowLookup["trace-" + r.uid], c = 0; c < a.length; c++) {
          var u = a[c],
              f = s[u];
          i.addSource(u, f), i.addLayer(u, f, l);
        }

        return e[0].trace._glTrace = i, i;
      };
    }, {
      "../../plots/mapbox/constants": 901,
      "./convert": 1265
    }],
    1272: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../scatter/subtypes"),
          a = t("../../constants/numerical").BADNUM;

      e.exports = function (t, e) {
        var r,
            o = t.cd,
            s = t.xaxis,
            l = t.yaxis,
            c = [],
            u = o[0].trace;
        if (!i.hasMarkers(u)) return [];
        if (!1 === e) for (r = 0; r < o.length; r++) {
          o[r].selected = 0;
        } else for (r = 0; r < o.length; r++) {
          var f = o[r],
              h = f.lonlat;

          if (h[0] !== a) {
            var p = [n.modHalf(h[0], 360), h[1]],
                d = [s.c2p(p), l.c2p(p)];
            e.contains(d, null, r, t) ? (c.push({
              pointNumber: r,
              lon: h[0],
              lat: h[1]
            }), f.selected = 1) : f.selected = 0;
          }
        }
        return c;
      };
    }, {
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../scatter/subtypes": 1224
    }],
    1273: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/template_attributes").hovertemplateAttrs,
          i = t("../../plots/template_attributes").texttemplateAttrs,
          a = t("../../lib/extend").extendFlat,
          o = t("../scatter/attributes"),
          s = t("../../plots/attributes"),
          l = o.line;
      e.exports = {
        mode: o.mode,
        r: {
          valType: "data_array",
          editType: "calc+clearAxisTypes"
        },
        theta: {
          valType: "data_array",
          editType: "calc+clearAxisTypes"
        },
        r0: {
          valType: "any",
          dflt: 0,
          editType: "calc+clearAxisTypes"
        },
        dr: {
          valType: "number",
          dflt: 1,
          editType: "calc"
        },
        theta0: {
          valType: "any",
          dflt: 0,
          editType: "calc+clearAxisTypes"
        },
        dtheta: {
          valType: "number",
          editType: "calc"
        },
        thetaunit: {
          valType: "enumerated",
          values: ["radians", "degrees", "gradians"],
          dflt: "degrees",
          editType: "calc+clearAxisTypes"
        },
        text: o.text,
        texttemplate: i({
          editType: "plot"
        }, {
          keys: ["r", "theta", "text"]
        }),
        hovertext: o.hovertext,
        line: {
          color: l.color,
          width: l.width,
          dash: l.dash,
          shape: a({}, l.shape, {
            values: ["linear", "spline"]
          }),
          smoothing: l.smoothing,
          editType: "calc"
        },
        connectgaps: o.connectgaps,
        marker: o.marker,
        cliponaxis: a({}, o.cliponaxis, {
          dflt: !1
        }),
        textposition: o.textposition,
        textfont: o.textfont,
        fill: a({}, o.fill, {
          values: ["none", "toself", "tonext"],
          dflt: "none"
        }),
        fillcolor: o.fillcolor,
        hoverinfo: a({}, s.hoverinfo, {
          flags: ["r", "theta", "text", "name"]
        }),
        hoveron: o.hoveron,
        hovertemplate: n(),
        selected: o.selected,
        unselected: o.unselected
      };
    }, {
      "../../lib/extend": 785,
      "../../plots/attributes": 841,
      "../../plots/template_attributes": 918,
      "../scatter/attributes": 1199
    }],
    1274: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../../constants/numerical").BADNUM,
          a = t("../../plots/cartesian/axes"),
          o = t("../scatter/colorscale_calc"),
          s = t("../scatter/arrays_to_calcdata"),
          l = t("../scatter/calc_selection"),
          c = t("../scatter/calc").calcMarkerSize;

      e.exports = function (t, e) {
        for (var r = t._fullLayout, u = e.subplot, f = r[u].radialaxis, h = r[u].angularaxis, p = f.makeCalcdata(e, "r"), d = h.makeCalcdata(e, "theta"), m = e._length, g = new Array(m), v = 0; v < m; v++) {
          var y = p[v],
              x = d[v],
              b = g[v] = {};
          n(y) && n(x) ? (b.r = y, b.theta = x) : b.r = i;
        }

        var _ = c(e, m);

        return e._extremes.x = a.findExtremes(f, p, {
          ppad: _
        }), o(t, e), s(g, e), l(g, e), g;
      };
    }, {
      "../../constants/numerical": 771,
      "../../plots/cartesian/axes": 845,
      "../scatter/arrays_to_calcdata": 1198,
      "../scatter/calc": 1200,
      "../scatter/calc_selection": 1201,
      "../scatter/colorscale_calc": 1202,
      "fast-isnumeric": 240
    }],
    1275: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../scatter/subtypes"),
          a = t("../scatter/marker_defaults"),
          o = t("../scatter/line_defaults"),
          s = t("../scatter/line_shape_defaults"),
          l = t("../scatter/text_defaults"),
          c = t("../scatter/fillcolor_defaults"),
          u = t("../scatter/constants").PTS_LINESONLY,
          f = t("./attributes");

      function h(t, e, r, n) {
        var i,
            a = n("r"),
            o = n("theta");
        if (a) o ? i = Math.min(a.length, o.length) : (i = a.length, n("theta0"), n("dtheta"));else {
          if (!o) return 0;
          i = e.theta.length, n("r0"), n("dr");
        }
        return e._length = i, i;
      }

      e.exports = {
        handleRThetaDefaults: h,
        supplyDefaults: function supplyDefaults(t, e, r, p) {
          function d(r, i) {
            return n.coerce(t, e, f, r, i);
          }

          var m = h(t, e, p, d);

          if (m) {
            d("thetaunit"), d("mode", m < u ? "lines+markers" : "lines"), d("text"), d("hovertext"), "fills" !== e.hoveron && d("hovertemplate"), i.hasLines(e) && (o(t, e, r, p, d), s(t, e, d), d("connectgaps")), i.hasMarkers(e) && a(t, e, r, p, d, {
              gradient: !0
            }), i.hasText(e) && (d("texttemplate"), l(t, e, p, d));
            var g = [];
            (i.hasMarkers(e) || i.hasText(e)) && (d("cliponaxis"), d("marker.maxdisplayed"), g.push("points")), d("fill"), "none" !== e.fill && (c(t, e, r, d), i.hasLines(e) || s(t, e, d)), "tonext" !== e.fill && "toself" !== e.fill || g.push("fills"), d("hoveron", g.join("+") || "points"), n.coerceSelectionMarkerOpacity(e, d);
          } else e.visible = !1;
        }
      };
    }, {
      "../../lib": 795,
      "../scatter/constants": 1203,
      "../scatter/fillcolor_defaults": 1207,
      "../scatter/line_defaults": 1212,
      "../scatter/line_shape_defaults": 1214,
      "../scatter/marker_defaults": 1218,
      "../scatter/subtypes": 1224,
      "../scatter/text_defaults": 1225,
      "./attributes": 1273
    }],
    1276: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../plots/cartesian/axes");

      e.exports = function (t, e, r) {
        var a,
            o,
            s = {},
            l = r[e.subplot]._subplot;
        l ? (a = l.radialAxis, o = l.angularAxis) : (a = (l = r[e.subplot]).radialaxis, o = l.angularaxis);
        var c = a.c2l(t.r);
        s.rLabel = i.tickText(a, c, !0).text;
        var u = "degrees" === o.thetaunit ? n.rad2deg(t.theta) : t.theta;
        return s.thetaLabel = i.tickText(o, u, !0).text, s;
      };
    }, {
      "../../lib": 795,
      "../../plots/cartesian/axes": 845
    }],
    1277: [function (t, e, r) {
      "use strict";

      var n = t("../scatter/hover");

      function i(t, e, r, n) {
        var i = r.radialAxis,
            a = r.angularAxis;
        i._hovertitle = "r", a._hovertitle = "\u03B8";
        var o = {};
        o[e.subplot] = {
          _subplot: r
        };

        var s = e._module.formatLabels(t, e, o);

        n.rLabel = s.rLabel, n.thetaLabel = s.thetaLabel;
        var l = t.hi || e.hoverinfo,
            c = [];

        function u(t, e) {
          c.push(t._hovertitle + ": " + e);
        }

        if (!e.hovertemplate) {
          var f = l.split("+");
          -1 !== f.indexOf("all") && (f = ["r", "theta", "text"]), -1 !== f.indexOf("r") && u(i, n.rLabel), -1 !== f.indexOf("theta") && u(a, n.thetaLabel), -1 !== f.indexOf("text") && n.text && (c.push(n.text), delete n.text), n.extraText = c.join("<br>");
        }
      }

      e.exports = {
        hoverPoints: function hoverPoints(t, e, r, a) {
          var o = n(t, e, r, a);

          if (o && !1 !== o[0].index) {
            var s = o[0];
            if (void 0 === s.index) return o;
            var l = t.subplot,
                c = s.cd[s.index],
                u = s.trace;
            if (l.isPtInside(c)) return s.xLabelVal = void 0, s.yLabelVal = void 0, i(c, u, l, s), s.hovertemplate = u.hovertemplate, o;
          }
        },
        makeHoverPointText: i
      };
    }, {
      "../scatter/hover": 1210
    }],
    1278: [function (t, e, r) {
      "use strict";

      e.exports = {
        moduleType: "trace",
        name: "scatterpolar",
        basePlotModule: t("../../plots/polar"),
        categories: ["polar", "symbols", "showLegend", "scatter-like"],
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults").supplyDefaults,
        colorbar: t("../scatter/marker_colorbar"),
        formatLabels: t("./format_labels"),
        calc: t("./calc"),
        plot: t("./plot"),
        style: t("../scatter/style").style,
        styleOnSelect: t("../scatter/style").styleOnSelect,
        hoverPoints: t("./hover").hoverPoints,
        selectPoints: t("../scatter/select"),
        meta: {}
      };
    }, {
      "../../plots/polar": 912,
      "../scatter/marker_colorbar": 1217,
      "../scatter/select": 1221,
      "../scatter/style": 1223,
      "./attributes": 1273,
      "./calc": 1274,
      "./defaults": 1275,
      "./format_labels": 1276,
      "./hover": 1277,
      "./plot": 1279
    }],
    1279: [function (t, e, r) {
      "use strict";

      var n = t("../scatter/plot"),
          i = t("../../constants/numerical").BADNUM;

      e.exports = function (t, e, r) {
        for (var a = e.layers.frontplot.select("g.scatterlayer"), o = {
          xaxis: e.xaxis,
          yaxis: e.yaxis,
          plot: e.framework,
          layerClipId: e._hasClipOnAxisFalse ? e.clipIds.forTraces : null
        }, s = e.radialAxis, l = e.angularAxis, c = 0; c < r.length; c++) {
          for (var u = r[c], f = 0; f < u.length; f++) {
            var h = u[f],
                p = h.r;
            if (p === i) h.x = h.y = i;else {
              var d = s.c2g(p),
                  m = l.c2g(h.theta);
              h.x = d * Math.cos(m), h.y = d * Math.sin(m);
            }
          }
        }

        n(t, o, r, a);
      };
    }, {
      "../../constants/numerical": 771,
      "../scatter/plot": 1220
    }],
    1280: [function (t, e, r) {
      "use strict";

      var n = t("../scatterpolar/attributes"),
          i = t("../scattergl/attributes"),
          a = t("../../plots/template_attributes").texttemplateAttrs;
      e.exports = {
        mode: n.mode,
        r: n.r,
        theta: n.theta,
        r0: n.r0,
        dr: n.dr,
        theta0: n.theta0,
        dtheta: n.dtheta,
        thetaunit: n.thetaunit,
        text: n.text,
        texttemplate: a({
          editType: "plot"
        }, {
          keys: ["r", "theta", "text"]
        }),
        hovertext: n.hovertext,
        hovertemplate: n.hovertemplate,
        line: i.line,
        connectgaps: i.connectgaps,
        marker: i.marker,
        fill: i.fill,
        fillcolor: i.fillcolor,
        textposition: i.textposition,
        textfont: i.textfont,
        hoverinfo: n.hoverinfo,
        selected: n.selected,
        unselected: n.unselected
      };
    }, {
      "../../plots/template_attributes": 918,
      "../scattergl/attributes": 1251,
      "../scatterpolar/attributes": 1273
    }],
    1281: [function (t, e, r) {
      "use strict";

      var n = t("../scatter/colorscale_calc"),
          i = t("../scatter/calc").calcMarkerSize,
          a = t("../scattergl/convert"),
          o = t("../../plots/cartesian/axes"),
          s = t("../scattergl/constants").TOO_MANY_POINTS;

      e.exports = function (t, e) {
        var r = t._fullLayout,
            l = e.subplot,
            c = r[l].radialaxis,
            u = r[l].angularaxis,
            f = e._r = c.makeCalcdata(e, "r"),
            h = e._theta = u.makeCalcdata(e, "theta"),
            p = e._length,
            d = {};
        p < f.length && (f = f.slice(0, p)), p < h.length && (h = h.slice(0, p)), d.r = f, d.theta = h, n(t, e);
        var m,
            g = d.opts = a.style(t, e);
        return p < s ? m = i(e, p) : g.marker && (m = 2 * (g.marker.sizeAvg || Math.max(g.marker.size, 3))), e._extremes.x = o.findExtremes(c, f, {
          ppad: m
        }), [{
          x: !1,
          y: !1,
          t: d,
          trace: e
        }];
      };
    }, {
      "../../plots/cartesian/axes": 845,
      "../scatter/calc": 1200,
      "../scatter/colorscale_calc": 1202,
      "../scattergl/constants": 1253,
      "../scattergl/convert": 1254
    }],
    1282: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../scatter/subtypes"),
          a = t("../scatterpolar/defaults").handleRThetaDefaults,
          o = t("../scatter/marker_defaults"),
          s = t("../scatter/line_defaults"),
          l = t("../scatter/text_defaults"),
          c = t("../scatter/fillcolor_defaults"),
          u = t("../scatter/constants").PTS_LINESONLY,
          f = t("./attributes");

      e.exports = function (t, e, r, h) {
        function p(r, i) {
          return n.coerce(t, e, f, r, i);
        }

        var d = a(t, e, h, p);
        d ? (p("thetaunit"), p("mode", d < u ? "lines+markers" : "lines"), p("text"), p("hovertext"), "fills" !== e.hoveron && p("hovertemplate"), i.hasLines(e) && (s(t, e, r, h, p), p("connectgaps")), i.hasMarkers(e) && o(t, e, r, h, p), i.hasText(e) && (p("texttemplate"), l(t, e, h, p)), p("fill"), "none" !== e.fill && c(t, e, r, p), n.coerceSelectionMarkerOpacity(e, p)) : e.visible = !1;
      };
    }, {
      "../../lib": 795,
      "../scatter/constants": 1203,
      "../scatter/fillcolor_defaults": 1207,
      "../scatter/line_defaults": 1212,
      "../scatter/marker_defaults": 1218,
      "../scatter/subtypes": 1224,
      "../scatter/text_defaults": 1225,
      "../scatterpolar/defaults": 1275,
      "./attributes": 1280
    }],
    1283: [function (t, e, r) {
      "use strict";

      var n = t("../scatterpolar/format_labels");

      e.exports = function (t, e, r) {
        var i = t.i;
        return "r" in t || (t.r = e._r[i]), "theta" in t || (t.theta = e._theta[i]), n(t, e, r);
      };
    }, {
      "../scatterpolar/format_labels": 1276
    }],
    1284: [function (t, e, r) {
      "use strict";

      var n = t("../scattergl/hover"),
          i = t("../scatterpolar/hover").makeHoverPointText;
      e.exports = {
        hoverPoints: function hoverPoints(t, e, r, a) {
          var o = t.cd[0].t,
              s = o.r,
              l = o.theta,
              c = n.hoverPoints(t, e, r, a);

          if (c && !1 !== c[0].index) {
            var u = c[0];
            if (void 0 === u.index) return c;
            var f = t.subplot,
                h = u.cd[u.index],
                p = u.trace;
            if (h.r = s[u.index], h.theta = l[u.index], f.isPtInside(h)) return u.xLabelVal = void 0, u.yLabelVal = void 0, i(h, p, f, u), c;
          }
        }
      };
    }, {
      "../scattergl/hover": 1259,
      "../scatterpolar/hover": 1277
    }],
    1285: [function (t, e, r) {
      "use strict";

      e.exports = {
        moduleType: "trace",
        name: "scatterpolargl",
        basePlotModule: t("../../plots/polar"),
        categories: ["gl", "regl", "polar", "symbols", "showLegend", "scatter-like"],
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        colorbar: t("../scatter/marker_colorbar"),
        formatLabels: t("./format_labels"),
        calc: t("./calc"),
        plot: t("./plot"),
        hoverPoints: t("./hover").hoverPoints,
        selectPoints: t("../scattergl/select"),
        meta: {}
      };
    }, {
      "../../plots/polar": 912,
      "../scatter/marker_colorbar": 1217,
      "../scattergl/select": 1263,
      "./attributes": 1280,
      "./calc": 1281,
      "./defaults": 1282,
      "./format_labels": 1283,
      "./hover": 1284,
      "./plot": 1286
    }],
    1286: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/point-cluster"),
          i = t("fast-isnumeric"),
          a = t("../scattergl/plot"),
          o = t("../scattergl/scene_update"),
          s = t("../scattergl/convert"),
          l = t("../../lib"),
          c = t("../scattergl/constants").TOO_MANY_POINTS;

      e.exports = function (t, e, r) {
        if (r.length) {
          var u = e.radialAxis,
              f = e.angularAxis,
              h = o(t, e);
          return r.forEach(function (r) {
            if (r && r[0] && r[0].trace) {
              var a,
                  o = r[0],
                  p = o.trace,
                  d = o.t,
                  m = p._length,
                  g = d.r,
                  v = d.theta,
                  y = d.opts,
                  x = g.slice(),
                  b = v.slice();

              for (a = 0; a < g.length; a++) {
                e.isPtInside({
                  r: g[a],
                  theta: v[a]
                }) || (x[a] = NaN, b[a] = NaN);
              }

              var _ = new Array(2 * m),
                  w = Array(m),
                  T = Array(m);

              for (a = 0; a < m; a++) {
                var k,
                    M,
                    A = x[a];

                if (i(A)) {
                  var S = u.c2g(A),
                      E = f.c2g(b[a], p.thetaunit);
                  k = S * Math.cos(E), M = S * Math.sin(E);
                } else k = M = NaN;

                w[a] = _[2 * a] = k, T[a] = _[2 * a + 1] = M;
              }

              d.tree = n(_), y.marker && m >= c && (y.marker.cluster = d.tree), y.marker && (y.markerSel.positions = y.markerUnsel.positions = y.marker.positions = _), y.line && _.length > 1 && l.extendFlat(y.line, s.linePositions(t, p, _)), y.text && (l.extendFlat(y.text, {
                positions: _
              }, s.textPosition(t, p, y.text, y.marker)), l.extendFlat(y.textSel, {
                positions: _
              }, s.textPosition(t, p, y.text, y.markerSel)), l.extendFlat(y.textUnsel, {
                positions: _
              }, s.textPosition(t, p, y.text, y.markerUnsel))), y.fill && !h.fill2d && (h.fill2d = !0), y.marker && !h.scatter2d && (h.scatter2d = !0), y.line && !h.line2d && (h.line2d = !0), y.text && !h.glText && (h.glText = !0), h.lineOptions.push(y.line), h.fillOptions.push(y.fill), h.markerOptions.push(y.marker), h.markerSelectedOptions.push(y.markerSel), h.markerUnselectedOptions.push(y.markerUnsel), h.textOptions.push(y.text), h.textSelectedOptions.push(y.textSel), h.textUnselectedOptions.push(y.textUnsel), h.selectBatch.push([]), h.unselectBatch.push([]), d.x = w, d.y = T, d.rawx = w, d.rawy = T, d.r = g, d.theta = v, d.positions = _, d._scene = h, d.index = h.count, h.count++;
            }
          }), a(t, e, r);
        }
      };
    }, {
      "../../lib": 795,
      "../scattergl/constants": 1253,
      "../scattergl/convert": 1254,
      "../scattergl/plot": 1261,
      "../scattergl/scene_update": 1262,
      "@plotly/point-cluster": 58,
      "fast-isnumeric": 240
    }],
    1287: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/template_attributes").hovertemplateAttrs,
          i = t("../../plots/template_attributes").texttemplateAttrs,
          a = t("../scatter/attributes"),
          o = t("../../plots/attributes"),
          s = t("../../components/colorscale/attributes"),
          l = t("../../components/drawing/attributes").dash,
          c = t("../../lib/extend").extendFlat,
          u = a.marker,
          f = a.line,
          h = u.line;
      e.exports = {
        a: {
          valType: "data_array",
          editType: "calc"
        },
        b: {
          valType: "data_array",
          editType: "calc"
        },
        c: {
          valType: "data_array",
          editType: "calc"
        },
        sum: {
          valType: "number",
          dflt: 0,
          min: 0,
          editType: "calc"
        },
        mode: c({}, a.mode, {
          dflt: "markers"
        }),
        text: c({}, a.text, {}),
        texttemplate: i({
          editType: "plot"
        }, {
          keys: ["a", "b", "c", "text"]
        }),
        hovertext: c({}, a.hovertext, {}),
        line: {
          color: f.color,
          width: f.width,
          dash: l,
          shape: c({}, f.shape, {
            values: ["linear", "spline"]
          }),
          smoothing: f.smoothing,
          editType: "calc"
        },
        connectgaps: a.connectgaps,
        cliponaxis: a.cliponaxis,
        fill: c({}, a.fill, {
          values: ["none", "toself", "tonext"],
          dflt: "none"
        }),
        fillcolor: a.fillcolor,
        marker: c({
          symbol: u.symbol,
          opacity: u.opacity,
          maxdisplayed: u.maxdisplayed,
          size: u.size,
          sizeref: u.sizeref,
          sizemin: u.sizemin,
          sizemode: u.sizemode,
          line: c({
            width: h.width,
            editType: "calc"
          }, s("marker.line")),
          gradient: u.gradient,
          editType: "calc"
        }, s("marker")),
        textfont: a.textfont,
        textposition: a.textposition,
        selected: a.selected,
        unselected: a.unselected,
        hoverinfo: c({}, o.hoverinfo, {
          flags: ["a", "b", "c", "text", "name"]
        }),
        hoveron: a.hoveron,
        hovertemplate: n()
      };
    }, {
      "../../components/colorscale/attributes": 665,
      "../../components/drawing/attributes": 679,
      "../../lib/extend": 785,
      "../../plots/attributes": 841,
      "../../plots/template_attributes": 918,
      "../scatter/attributes": 1199
    }],
    1288: [function (t, e, r) {
      "use strict";

      var n = t("fast-isnumeric"),
          i = t("../scatter/colorscale_calc"),
          a = t("../scatter/arrays_to_calcdata"),
          o = t("../scatter/calc_selection"),
          s = t("../scatter/calc").calcMarkerSize,
          l = ["a", "b", "c"],
          c = {
        a: ["b", "c"],
        b: ["a", "c"],
        c: ["a", "b"]
      };

      e.exports = function (t, e) {
        var r,
            u,
            f,
            h,
            p,
            d,
            m = t._fullLayout[e.subplot].sum,
            g = e.sum || m,
            v = {
          a: e.a,
          b: e.b,
          c: e.c
        };

        for (r = 0; r < l.length; r++) {
          if (!v[f = l[r]]) {
            for (p = v[c[f][0]], d = v[c[f][1]], h = new Array(p.length), u = 0; u < p.length; u++) {
              h[u] = g - p[u] - d[u];
            }

            v[f] = h;
          }
        }

        var y,
            x,
            b,
            _,
            w,
            T,
            k = e._length,
            M = new Array(k);

        for (r = 0; r < k; r++) {
          y = v.a[r], x = v.b[r], b = v.c[r], n(y) && n(x) && n(b) ? (1 !== (_ = m / ((y = +y) + (x = +x) + (b = +b))) && (y *= _, x *= _, b *= _), T = y, w = b - x, M[r] = {
            x: w,
            y: T,
            a: y,
            b: x,
            c: b
          }) : M[r] = {
            x: !1,
            y: !1
          };
        }

        return s(e, k), i(t, e), a(M, e), o(M, e), M;
      };
    }, {
      "../scatter/arrays_to_calcdata": 1198,
      "../scatter/calc": 1200,
      "../scatter/calc_selection": 1201,
      "../scatter/colorscale_calc": 1202,
      "fast-isnumeric": 240
    }],
    1289: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../scatter/constants"),
          a = t("../scatter/subtypes"),
          o = t("../scatter/marker_defaults"),
          s = t("../scatter/line_defaults"),
          l = t("../scatter/line_shape_defaults"),
          c = t("../scatter/text_defaults"),
          u = t("../scatter/fillcolor_defaults"),
          f = t("./attributes");

      e.exports = function (t, e, r, h) {
        function p(r, i) {
          return n.coerce(t, e, f, r, i);
        }

        var d,
            m = p("a"),
            g = p("b"),
            v = p("c");

        if (m ? (d = m.length, g ? (d = Math.min(d, g.length), v && (d = Math.min(d, v.length))) : d = v ? Math.min(d, v.length) : 0) : g && v && (d = Math.min(g.length, v.length)), d) {
          e._length = d, p("sum"), p("text"), p("hovertext"), "fills" !== e.hoveron && p("hovertemplate"), p("mode", d < i.PTS_LINESONLY ? "lines+markers" : "lines"), a.hasLines(e) && (s(t, e, r, h, p), l(t, e, p), p("connectgaps")), a.hasMarkers(e) && o(t, e, r, h, p, {
            gradient: !0
          }), a.hasText(e) && (p("texttemplate"), c(t, e, h, p));
          var y = [];
          (a.hasMarkers(e) || a.hasText(e)) && (p("cliponaxis"), p("marker.maxdisplayed"), y.push("points")), p("fill"), "none" !== e.fill && (u(t, e, r, p), a.hasLines(e) || l(t, e, p)), "tonext" !== e.fill && "toself" !== e.fill || y.push("fills"), p("hoveron", y.join("+") || "points"), n.coerceSelectionMarkerOpacity(e, p);
        } else e.visible = !1;
      };
    }, {
      "../../lib": 795,
      "../scatter/constants": 1203,
      "../scatter/fillcolor_defaults": 1207,
      "../scatter/line_defaults": 1212,
      "../scatter/line_shape_defaults": 1214,
      "../scatter/marker_defaults": 1218,
      "../scatter/subtypes": 1224,
      "../scatter/text_defaults": 1225,
      "./attributes": 1287
    }],
    1290: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e, r, n, i) {
        if (e.xa && (t.xaxis = e.xa), e.ya && (t.yaxis = e.ya), n[i]) {
          var a = n[i];
          t.a = a.a, t.b = a.b, t.c = a.c;
        } else t.a = e.a, t.b = e.b, t.c = e.c;

        return t;
      };
    }, {}],
    1291: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/cartesian/axes");

      e.exports = function (t, e, r) {
        var i = {},
            a = r[e.subplot]._subplot;
        return i.aLabel = n.tickText(a.aaxis, t.a, !0).text, i.bLabel = n.tickText(a.baxis, t.b, !0).text, i.cLabel = n.tickText(a.caxis, t.c, !0).text, i;
      };
    }, {
      "../../plots/cartesian/axes": 845
    }],
    1292: [function (t, e, r) {
      "use strict";

      var n = t("../scatter/hover");

      e.exports = function (t, e, r, i) {
        var a = n(t, e, r, i);

        if (a && !1 !== a[0].index) {
          var o = a[0];

          if (void 0 === o.index) {
            var s = 1 - o.y0 / t.ya._length,
                l = t.xa._length,
                c = l * s / 2,
                u = l - c;
            return o.x0 = Math.max(Math.min(o.x0, u), c), o.x1 = Math.max(Math.min(o.x1, u), c), a;
          }

          var f = o.cd[o.index],
              h = o.trace,
              p = o.subplot;
          o.a = f.a, o.b = f.b, o.c = f.c, o.xLabelVal = void 0, o.yLabelVal = void 0;
          var d = {};
          d[h.subplot] = {
            _subplot: p
          };

          var m = h._module.formatLabels(f, h, d);

          o.aLabel = m.aLabel, o.bLabel = m.bLabel, o.cLabel = m.cLabel;
          var g = f.hi || h.hoverinfo,
              v = [];

          if (!h.hovertemplate) {
            var y = g.split("+");
            -1 !== y.indexOf("all") && (y = ["a", "b", "c"]), -1 !== y.indexOf("a") && x(p.aaxis, o.aLabel), -1 !== y.indexOf("b") && x(p.baxis, o.bLabel), -1 !== y.indexOf("c") && x(p.caxis, o.cLabel);
          }

          return o.extraText = v.join("<br>"), o.hovertemplate = h.hovertemplate, a;
        }

        function x(t, e) {
          v.push(t._hovertitle + ": " + e);
        }
      };
    }, {
      "../scatter/hover": 1210
    }],
    1293: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        colorbar: t("../scatter/marker_colorbar"),
        formatLabels: t("./format_labels"),
        calc: t("./calc"),
        plot: t("./plot"),
        style: t("../scatter/style").style,
        styleOnSelect: t("../scatter/style").styleOnSelect,
        hoverPoints: t("./hover"),
        selectPoints: t("../scatter/select"),
        eventData: t("./event_data"),
        moduleType: "trace",
        name: "scatterternary",
        basePlotModule: t("../../plots/ternary"),
        categories: ["ternary", "symbols", "showLegend", "scatter-like"],
        meta: {}
      };
    }, {
      "../../plots/ternary": 919,
      "../scatter/marker_colorbar": 1217,
      "../scatter/select": 1221,
      "../scatter/style": 1223,
      "./attributes": 1287,
      "./calc": 1288,
      "./defaults": 1289,
      "./event_data": 1290,
      "./format_labels": 1291,
      "./hover": 1292,
      "./plot": 1294
    }],
    1294: [function (t, e, r) {
      "use strict";

      var n = t("../scatter/plot");

      e.exports = function (t, e, r) {
        var i = e.plotContainer;
        i.select(".scatterlayer").selectAll("*").remove();
        var a = {
          xaxis: e.xaxis,
          yaxis: e.yaxis,
          plot: i,
          layerClipId: e._hasClipOnAxisFalse ? e.clipIdRelative : null
        },
            o = e.layers.frontplot.select("g.scatterlayer");
        n(t, a, r, o);
      };
    }, {
      "../scatter/plot": 1220
    }],
    1295: [function (t, e, r) {
      "use strict";

      var n = t("../scatter/attributes"),
          i = t("../../components/colorscale/attributes"),
          a = t("../../plots/hoverformat_attributes"),
          o = t("../../plots/template_attributes").hovertemplateAttrs,
          s = t("../scattergl/attributes"),
          l = t("../../plots/cartesian/constants").idRegex,
          c = t("../../plot_api/plot_template").templatedArray,
          u = t("../../lib/extend").extendFlat,
          f = n.marker,
          h = f.line,
          p = u(i("marker.line", {
        editTypeOverride: "calc"
      }), {
        width: u({}, h.width, {
          editType: "calc"
        }),
        editType: "calc"
      }),
          d = u(i("marker"), {
        symbol: f.symbol,
        size: u({}, f.size, {
          editType: "markerSize"
        }),
        sizeref: f.sizeref,
        sizemin: f.sizemin,
        sizemode: f.sizemode,
        opacity: f.opacity,
        colorbar: f.colorbar,
        line: p,
        editType: "calc"
      });

      function m(t) {
        return {
          valType: "info_array",
          freeLength: !0,
          editType: "calc",
          items: {
            valType: "subplotid",
            regex: l[t],
            editType: "plot"
          }
        };
      }

      d.color.editType = d.cmin.editType = d.cmax.editType = "style", e.exports = {
        dimensions: c("dimension", {
          visible: {
            valType: "boolean",
            dflt: !0,
            editType: "calc"
          },
          label: {
            valType: "string",
            editType: "calc"
          },
          values: {
            valType: "data_array",
            editType: "calc+clearAxisTypes"
          },
          axis: {
            type: {
              valType: "enumerated",
              values: ["linear", "log", "date", "category"],
              editType: "calc+clearAxisTypes"
            },
            matches: {
              valType: "boolean",
              dflt: !1,
              editType: "calc"
            },
            editType: "calc+clearAxisTypes"
          },
          editType: "calc+clearAxisTypes"
        }),
        text: u({}, s.text, {}),
        hovertext: u({}, s.hovertext, {}),
        hovertemplate: o(),
        xhoverformat: a("x"),
        yhoverformat: a("y"),
        marker: d,
        xaxes: m("x"),
        yaxes: m("y"),
        diagonal: {
          visible: {
            valType: "boolean",
            dflt: !0,
            editType: "calc"
          },
          editType: "calc"
        },
        showupperhalf: {
          valType: "boolean",
          dflt: !0,
          editType: "calc"
        },
        showlowerhalf: {
          valType: "boolean",
          dflt: !0,
          editType: "calc"
        },
        selected: {
          marker: s.selected.marker,
          editType: "calc"
        },
        unselected: {
          marker: s.unselected.marker,
          editType: "calc"
        },
        opacity: s.opacity
      };
    }, {
      "../../components/colorscale/attributes": 665,
      "../../lib/extend": 785,
      "../../plot_api/plot_template": 834,
      "../../plots/cartesian/constants": 851,
      "../../plots/hoverformat_attributes": 899,
      "../../plots/template_attributes": 918,
      "../scatter/attributes": 1199,
      "../scattergl/attributes": 1251
    }],
    1296: [function (t, e, r) {
      "use strict";

      var n = t("regl-line2d"),
          i = t("../../registry"),
          a = t("../../lib/prepare_regl"),
          o = t("../../plots/get_data").getModuleCalcData,
          s = t("../../plots/cartesian"),
          l = t("../../plots/cartesian/axis_ids").getFromId,
          c = t("../../plots/cartesian/axes").shouldShowZeroLine;

      function u(t, e, r) {
        for (var n = r.matrixOptions.data.length, i = e._visibleDims, a = r.viewOpts.ranges = new Array(n), o = 0; o < i.length; o++) {
          var s = i[o],
              c = a[o] = new Array(4),
              u = l(t, e._diag[s][0]);
          u && (c[0] = u.r2l(u.range[0]), c[2] = u.r2l(u.range[1]));
          var f = l(t, e._diag[s][1]);
          f && (c[1] = f.r2l(f.range[0]), c[3] = f.r2l(f.range[1]));
        }

        r.selectBatch.length || r.unselectBatch.length ? r.matrix.update({
          ranges: a
        }, {
          ranges: a
        }) : r.matrix.update({
          ranges: a
        });
      }

      function f(t) {
        var e = t._fullLayout,
            r = e._glcanvas.data()[0].regl,
            i = e._splomGrid;

        i || (i = e._splomGrid = n(r)), i.update(function (t) {
          var e,
              r = t._fullLayout,
              n = r._size,
              i = [0, 0, r.width, r.height],
              a = {};

          function o(t, e, r, n, o, s) {
            var l = e[t + "color"],
                c = e[t + "width"],
                u = String(l + c);
            u in a ? a[u].data.push(NaN, NaN, r, n, o, s) : a[u] = {
              data: [r, n, o, s],
              join: "rect",
              thickness: c,
              color: l,
              viewport: i,
              range: i,
              overlay: !1
            };
          }

          for (e in r._splomSubplots) {
            var s,
                l,
                u = r._plots[e],
                f = u.xaxis,
                h = u.yaxis,
                p = f._gridVals,
                d = h._gridVals,
                m = n.b + h.domain[0] * n.h,
                g = -h._m,
                v = -g * h.r2l(h.range[0], h.calendar);
            if (f.showgrid) for (e = 0; e < p.length; e++) {
              s = f._offset + f.l2p(p[e].x), o("grid", f, s, m, s, m + h._length);
            }
            if (h.showgrid) for (e = 0; e < d.length; e++) {
              l = m + v + g * d[e].x, o("grid", h, f._offset, l, f._offset + f._length, l);
            }
            c(t, f, h) && (s = f._offset + f.l2p(0), o("zeroline", f, s, m, s, m + h._length)), c(t, h, f) && (l = m + v + 0, o("zeroline", h, f._offset, l, f._offset + f._length, l));
          }

          var y = [];

          for (e in a) {
            y.push(a[e]);
          }

          return y;
        }(t));
      }

      e.exports = {
        name: "splom",
        attr: s.attr,
        attrRegex: s.attrRegex,
        layoutAttributes: s.layoutAttributes,
        supplyLayoutDefaults: s.supplyLayoutDefaults,
        drawFramework: s.drawFramework,
        plot: function plot(t) {
          var e = t._fullLayout,
              r = i.getModule("splom"),
              n = o(t.calcdata, r)[0];
          a(t, ["ANGLE_instanced_arrays", "OES_element_index_uint"]) && (e._hasOnlyLargeSploms && f(t), r.plot(t, {}, n));
        },
        drag: function drag(t) {
          var e = t.calcdata,
              r = t._fullLayout;
          r._hasOnlyLargeSploms && f(t);

          for (var n = 0; n < e.length; n++) {
            var i = e[n][0].trace,
                a = r._splomScenes[i.uid];
            "splom" === i.type && a && a.matrix && u(t, i, a);
          }
        },
        updateGrid: f,
        clean: function clean(t, e, r, n) {
          var i,
              a = {};

          if (n._splomScenes) {
            for (i = 0; i < t.length; i++) {
              var o = t[i];
              "splom" === o.type && (a[o.uid] = 1);
            }

            for (i = 0; i < r.length; i++) {
              var l = r[i];

              if (!a[l.uid]) {
                var c = n._splomScenes[l.uid];
                c && c.destroy && c.destroy(), n._splomScenes[l.uid] = null, delete n._splomScenes[l.uid];
              }
            }
          }

          0 === Object.keys(n._splomScenes || {}).length && delete n._splomScenes, n._splomGrid && !e._hasOnlyLargeSploms && n._hasOnlyLargeSploms && (n._splomGrid.destroy(), n._splomGrid = null, delete n._splomGrid), s.clean(t, e, r, n);
        },
        updateFx: s.updateFx,
        toSVG: s.toSVG
      };
    }, {
      "../../lib/prepare_regl": 808,
      "../../plots/cartesian": 858,
      "../../plots/cartesian/axes": 845,
      "../../plots/cartesian/axis_ids": 848,
      "../../plots/get_data": 882,
      "../../registry": 923,
      "regl-line2d": 529
    }],
    1297: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../plots/cartesian/axis_ids"),
          a = t("../scatter/calc").calcMarkerSize,
          o = t("../scatter/calc").calcAxisExpansion,
          s = t("../scatter/colorscale_calc"),
          l = t("../scattergl/convert").markerSelection,
          c = t("../scattergl/convert").markerStyle,
          u = t("./scene_update"),
          f = t("../../constants/numerical").BADNUM,
          h = t("../scattergl/constants").TOO_MANY_POINTS;

      e.exports = function (t, e) {
        var r,
            p,
            d,
            m,
            g,
            v,
            y = e.dimensions,
            x = e._length,
            b = {},
            _ = b.cdata = [],
            w = b.data = [],
            T = e._visibleDims = [];

        function k(t, r) {
          for (var i = t.makeCalcdata({
            v: r.values,
            vcalendar: e.calendar
          }, "v"), a = 0; a < i.length; a++) {
            i[a] = i[a] === f ? NaN : i[a];
          }

          _.push(i), w.push("log" === t.type ? n.simpleMap(i, t.c2l) : i);
        }

        for (r = 0; r < y.length; r++) {
          if ((d = y[r]).visible) {
            if (m = i.getFromId(t, e._diag[r][0]), g = i.getFromId(t, e._diag[r][1]), m && g && m.type !== g.type) {
              n.log("Skipping splom dimension " + r + " with conflicting axis types");
              continue;
            }

            m ? (k(m, d), g && "category" === g.type && (g._categories = m._categories.slice())) : k(g, d), T.push(r);
          }
        }

        for (s(t, e), n.extendFlat(b, c(e)), v = _.length * x > h ? 2 * (b.sizeAvg || Math.max(b.size, 3)) : a(e, x), p = 0; p < T.length; p++) {
          d = y[r = T[p]], m = i.getFromId(t, e._diag[r][0]) || {}, g = i.getFromId(t, e._diag[r][1]) || {}, o(t, e, m, g, _[p], _[p], v);
        }

        var M = u(t, e);
        return M.matrix || (M.matrix = !0), M.matrixOptions = b, M.selectedOptions = l(e, e.selected), M.unselectedOptions = l(e, e.unselected), [{
          x: !1,
          y: !1,
          t: {},
          trace: e
        }];
      };
    }, {
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../../plots/cartesian/axis_ids": 848,
      "../scatter/calc": 1200,
      "../scatter/colorscale_calc": 1202,
      "../scattergl/constants": 1253,
      "../scattergl/convert": 1254,
      "./scene_update": 1304
    }],
    1298: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../plots/array_container_defaults"),
          a = t("./attributes"),
          o = t("../scatter/subtypes"),
          s = t("../scatter/marker_defaults"),
          l = t("../parcoords/merge_length"),
          c = t("../scattergl/helpers").isOpenSymbol;

      function u(t, e) {
        function r(r, i) {
          return n.coerce(t, e, a.dimensions, r, i);
        }

        r("label");
        var i = r("values");
        i && i.length ? r("visible") : e.visible = !1, r("axis.type"), r("axis.matches");
      }

      e.exports = function (t, e, r, f) {
        function h(r, i) {
          return n.coerce(t, e, a, r, i);
        }

        var p = i(t, e, {
          name: "dimensions",
          handleItemDefaults: u
        }),
            d = h("diagonal.visible"),
            m = h("showupperhalf"),
            g = h("showlowerhalf");

        if (l(e, p, "values") && (d || m || g)) {
          h("text"), h("hovertext"), h("hovertemplate"), h("xhoverformat"), h("yhoverformat"), s(t, e, r, f, h);
          var v = c(e.marker.symbol),
              y = o.isBubble(e);
          h("marker.line.width", v || y ? 1 : 0), function (t, e, r, n) {
            var i,
                a,
                o = e.dimensions,
                s = o.length,
                l = e.showupperhalf,
                c = e.showlowerhalf,
                u = e.diagonal.visible,
                f = new Array(s),
                h = new Array(s);

            for (i = 0; i < s; i++) {
              var p = i ? i + 1 : "";
              f[i] = "x" + p, h[i] = "y" + p;
            }

            var d = n("xaxes", f),
                m = n("yaxes", h),
                g = e._diag = new Array(s);
            e._xaxes = {}, e._yaxes = {};
            var v = [],
                y = [];

            function x(t, n, i, a) {
              if (t) {
                var o = t.charAt(0),
                    s = r._splomAxes[o];

                if (e["_" + o + "axes"][t] = 1, a.push(t), !(t in s)) {
                  var l = s[t] = {};
                  i && (l.label = i.label || "", i.visible && i.axis && (i.axis.type && (l.type = i.axis.type), i.axis.matches && (l.matches = n)));
                }
              }
            }

            var b = !u && !c,
                _ = !u && !l;

            for (e._axesDim = {}, i = 0; i < s; i++) {
              var w = o[i],
                  T = 0 === i,
                  k = i === s - 1,
                  M = T && b || k && _ ? void 0 : d[i],
                  A = T && _ || k && b ? void 0 : m[i];
              x(M, A, w, v), x(A, M, w, y), g[i] = [M, A], e._axesDim[M] = i, e._axesDim[A] = i;
            }

            for (i = 0; i < v.length; i++) {
              for (a = 0; a < y.length; a++) {
                var S = v[i] + y[a];
                i > a && l || i < a && c ? r._splomSubplots[S] = 1 : i !== a || !u && c && l || (r._splomSubplots[S] = 1);
              }
            }

            (!c || !u && l && c) && (r._splomGridDflt.xside = "bottom", r._splomGridDflt.yside = "left");
          }(0, e, f, h), n.coerceSelectionMarkerOpacity(e, h);
        } else e.visible = !1;
      };
    }, {
      "../../lib": 795,
      "../../plots/array_container_defaults": 840,
      "../parcoords/merge_length": 1170,
      "../scatter/marker_defaults": 1218,
      "../scatter/subtypes": 1224,
      "../scattergl/helpers": 1258,
      "./attributes": 1295
    }],
    1299: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../scatter/colorscale_calc"),
          a = t("../scattergl/convert").markerStyle;

      e.exports = function (t, e) {
        var r = e.trace,
            o = t._fullLayout._splomScenes[r.uid];

        if (o) {
          i(t, r), n.extendFlat(o.matrixOptions, a(r));
          var s = n.extendFlat({}, o.matrixOptions, o.viewOpts);
          o.matrix.update(s, null);
        }
      };
    }, {
      "../../lib": 795,
      "../scatter/colorscale_calc": 1202,
      "../scattergl/convert": 1254
    }],
    1300: [function (t, e, r) {
      "use strict";

      r.getDimIndex = function (t, e) {
        for (var r = e._id, n = {
          x: 0,
          y: 1
        }[r.charAt(0)], i = t._visibleDims, a = 0; a < i.length; a++) {
          var o = i[a];
          if (t._diag[o][n] === r) return a;
        }

        return !1;
      };
    }, {}],
    1301: [function (t, e, r) {
      "use strict";

      var n = t("./helpers"),
          i = t("../scattergl/hover").calcHover;
      e.exports = {
        hoverPoints: function hoverPoints(t, e, r) {
          var a = t.cd[0].trace,
              o = t.scene.matrixOptions.cdata,
              s = t.xa,
              l = t.ya,
              c = s.c2p(e),
              u = l.c2p(r),
              f = t.distance,
              h = n.getDimIndex(a, s),
              p = n.getDimIndex(a, l);
          if (!1 === h || !1 === p) return [t];

          for (var d, m, g = o[h], v = o[p], y = f, x = 0; x < g.length; x++) {
            var b = g[x],
                _ = v[x],
                w = s.c2p(b) - c,
                T = l.c2p(_) - u,
                k = Math.sqrt(w * w + T * T);
            k < y && (y = m = k, d = x);
          }

          return t.index = d, t.distance = y, t.dxy = m, void 0 === d ? [t] : [i(t, g, v, a)];
        }
      };
    }, {
      "../scattergl/hover": 1259,
      "./helpers": 1300
    }],
    1302: [function (t, e, r) {
      "use strict";

      var n = t("../../registry"),
          i = t("../../components/grid");
      e.exports = {
        moduleType: "trace",
        name: "splom",
        basePlotModule: t("./base_plot"),
        categories: ["gl", "regl", "cartesian", "symbols", "showLegend", "scatter-like"],
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        colorbar: t("../scatter/marker_colorbar"),
        calc: t("./calc"),
        plot: t("./plot"),
        hoverPoints: t("./hover").hoverPoints,
        selectPoints: t("./select"),
        editStyle: t("./edit_style"),
        meta: {}
      }, n.register(i);
    }, {
      "../../components/grid": 702,
      "../../registry": 923,
      "../scatter/marker_colorbar": 1217,
      "./attributes": 1295,
      "./base_plot": 1296,
      "./calc": 1297,
      "./defaults": 1298,
      "./edit_style": 1299,
      "./hover": 1301,
      "./plot": 1303,
      "./select": 1305
    }],
    1303: [function (t, e, r) {
      "use strict";

      var n = t("regl-splom"),
          i = t("../../lib"),
          a = t("../../plots/cartesian/axis_ids"),
          o = t("../../components/dragelement/helpers").selectMode;

      function s(t, e) {
        var r,
            s,
            l,
            c,
            u,
            f = t._fullLayout,
            h = f._size,
            p = e.trace,
            d = e.t,
            m = f._splomScenes[p.uid],
            g = m.matrixOptions,
            v = g.cdata,
            y = f._glcanvas.data()[0].regl,
            x = f.dragmode;

        if (0 !== v.length) {
          g.lower = p.showupperhalf, g.upper = p.showlowerhalf, g.diagonal = p.diagonal.visible;
          var b = p._visibleDims,
              _ = v.length,
              w = m.viewOpts = {};

          for (w.ranges = new Array(_), w.domains = new Array(_), u = 0; u < b.length; u++) {
            l = b[u];
            var T = w.ranges[u] = new Array(4),
                k = w.domains[u] = new Array(4);
            (r = a.getFromId(t, p._diag[l][0])) && (T[0] = r._rl[0], T[2] = r._rl[1], k[0] = r.domain[0], k[2] = r.domain[1]), (s = a.getFromId(t, p._diag[l][1])) && (T[1] = s._rl[0], T[3] = s._rl[1], k[1] = s.domain[0], k[3] = s.domain[1]);
          }

          w.viewport = [h.l, h.b, h.w + h.l, h.h + h.b], !0 === m.matrix && (m.matrix = n(y));
          var M = f.clickmode.indexOf("select") > -1,
              A = !0;

          if (o(x) || !!p.selectedpoints || M) {
            var S = p._length;

            if (p.selectedpoints) {
              m.selectBatch = p.selectedpoints;
              var E = p.selectedpoints,
                  L = {};

              for (l = 0; l < E.length; l++) {
                L[E[l]] = !0;
              }

              var C = [];

              for (l = 0; l < S; l++) {
                L[l] || C.push(l);
              }

              m.unselectBatch = C;
            }

            var P = d.xpx = new Array(_),
                I = d.ypx = new Array(_);

            for (u = 0; u < b.length; u++) {
              if (l = b[u], r = a.getFromId(t, p._diag[l][0])) for (P[u] = new Array(S), c = 0; c < S; c++) {
                P[u][c] = r.c2p(v[u][c]);
              }
              if (s = a.getFromId(t, p._diag[l][1])) for (I[u] = new Array(S), c = 0; c < S; c++) {
                I[u][c] = s.c2p(v[u][c]);
              }
            }

            if (m.selectBatch.length || m.unselectBatch.length) {
              var O = i.extendFlat({}, g, m.unselectedOptions, w),
                  z = i.extendFlat({}, g, m.selectedOptions, w);
              m.matrix.update(O, z), A = !1;
            }
          } else d.xpx = d.ypx = null;

          if (A) {
            var D = i.extendFlat({}, g, w);
            m.matrix.update(D, null);
          }
        }
      }

      e.exports = function (t, e, r) {
        if (r.length) for (var n = 0; n < r.length; n++) {
          s(t, r[n][0]);
        }
      };
    }, {
      "../../components/dragelement/helpers": 676,
      "../../lib": 795,
      "../../plots/cartesian/axis_ids": 848,
      "regl-splom": 531
    }],
    1304: [function (t, e, r) {
      "use strict";

      var n = t("../../lib");

      e.exports = function (t, e) {
        var r = t._fullLayout,
            i = e.uid,
            a = r._splomScenes;
        a || (a = r._splomScenes = {});
        var o = {
          dirty: !0,
          selectBatch: [],
          unselectBatch: []
        },
            s = a[e.uid];
        return s || ((s = a[i] = n.extendFlat({}, o, {
          matrix: !1,
          selectBatch: [],
          unselectBatch: []
        })).draw = function () {
          s.matrix && s.matrix.draw && (s.selectBatch.length || s.unselectBatch.length ? s.matrix.draw(s.unselectBatch, s.selectBatch) : s.matrix.draw()), s.dirty = !1;
        }, s.destroy = function () {
          s.matrix && s.matrix.destroy && s.matrix.destroy(), s.matrixOptions = null, s.selectBatch = null, s.unselectBatch = null, s = null;
        }), s.dirty || n.extendFlat(s, o), s;
      };
    }, {
      "../../lib": 795
    }],
    1305: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../scatter/subtypes"),
          a = t("./helpers");

      e.exports = function (t, e) {
        var r = t.cd,
            o = r[0].trace,
            s = r[0].t,
            l = t.scene,
            c = l.matrixOptions.cdata,
            u = t.xaxis,
            f = t.yaxis,
            h = [];
        if (!l) return h;
        var p = !i.hasMarkers(o) && !i.hasText(o);
        if (!0 !== o.visible || p) return h;
        var d = a.getDimIndex(o, u),
            m = a.getDimIndex(o, f);
        if (!1 === d || !1 === m) return h;
        var g = s.xpx[d],
            v = s.ypx[m],
            y = c[d],
            x = c[m],
            b = [],
            _ = [];
        if (!1 !== e && !e.degenerate) for (var w = 0; w < y.length; w++) {
          e.contains([g[w], v[w]], null, w, t) ? (b.push(w), h.push({
            pointNumber: w,
            x: y[w],
            y: x[w]
          })) : _.push(w);
        }
        var T = l.matrixOptions;
        return b.length || _.length ? l.selectBatch.length || l.unselectBatch.length || l.matrix.update(l.unselectedOptions, n.extendFlat({}, T, l.selectedOptions, l.viewOpts)) : l.matrix.update(T, null), l.selectBatch = b, l.unselectBatch = _, h;
      };
    }, {
      "../../lib": 795,
      "../scatter/subtypes": 1224,
      "./helpers": 1300
    }],
    1306: [function (t, e, r) {
      "use strict";

      var n = t("../../components/colorscale/attributes"),
          i = t("../../plots/hoverformat_attributes"),
          a = t("../../plots/template_attributes").hovertemplateAttrs,
          o = t("../mesh3d/attributes"),
          s = t("../../plots/attributes"),
          l = t("../../lib/extend").extendFlat,
          c = {
        x: {
          valType: "data_array",
          editType: "calc+clearAxisTypes"
        },
        y: {
          valType: "data_array",
          editType: "calc+clearAxisTypes"
        },
        z: {
          valType: "data_array",
          editType: "calc+clearAxisTypes"
        },
        u: {
          valType: "data_array",
          editType: "calc"
        },
        v: {
          valType: "data_array",
          editType: "calc"
        },
        w: {
          valType: "data_array",
          editType: "calc"
        },
        starts: {
          x: {
            valType: "data_array",
            editType: "calc"
          },
          y: {
            valType: "data_array",
            editType: "calc"
          },
          z: {
            valType: "data_array",
            editType: "calc"
          },
          editType: "calc"
        },
        maxdisplayed: {
          valType: "integer",
          min: 0,
          dflt: 1e3,
          editType: "calc"
        },
        sizeref: {
          valType: "number",
          editType: "calc",
          min: 0,
          dflt: 1
        },
        text: {
          valType: "string",
          dflt: "",
          editType: "calc"
        },
        hovertext: {
          valType: "string",
          dflt: "",
          editType: "calc"
        },
        hovertemplate: a({
          editType: "calc"
        }, {
          keys: ["tubex", "tubey", "tubez", "tubeu", "tubev", "tubew", "norm", "divergence"]
        }),
        uhoverformat: i("u", 1),
        vhoverformat: i("v", 1),
        whoverformat: i("w", 1),
        xhoverformat: i("x"),
        yhoverformat: i("y"),
        zhoverformat: i("z"),
        showlegend: l({}, s.showlegend, {
          dflt: !1
        })
      };
      l(c, n("", {
        colorAttr: "u/v/w norm",
        showScaleDflt: !0,
        editTypeOverride: "calc"
      }));
      ["opacity", "lightposition", "lighting"].forEach(function (t) {
        c[t] = o[t];
      }), c.hoverinfo = l({}, s.hoverinfo, {
        editType: "calc",
        flags: ["x", "y", "z", "u", "v", "w", "norm", "divergence", "text", "name"],
        dflt: "x+y+z+norm+text+name"
      }), c.transforms = void 0, e.exports = c;
    }, {
      "../../components/colorscale/attributes": 665,
      "../../lib/extend": 785,
      "../../plots/attributes": 841,
      "../../plots/hoverformat_attributes": 899,
      "../../plots/template_attributes": 918,
      "../mesh3d/attributes": 1140
    }],
    1307: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../components/colorscale/calc");

      function a(t) {
        var e,
            r,
            i,
            a,
            s,
            l,
            c,
            u,
            f,
            h,
            p,
            d,
            m = t._x,
            g = t._y,
            v = t._z,
            y = t._len,
            x = -1 / 0,
            b = 1 / 0,
            _ = -1 / 0,
            w = 1 / 0,
            T = -1 / 0,
            k = 1 / 0,
            M = "";

        for (y && (c = m[0], f = g[0], p = v[0]), y > 1 && (u = m[y - 1], h = g[y - 1], d = v[y - 1]), e = 0; e < y; e++) {
          x = Math.max(x, m[e]), b = Math.min(b, m[e]), _ = Math.max(_, g[e]), w = Math.min(w, g[e]), T = Math.max(T, v[e]), k = Math.min(k, v[e]), a || m[e] === c || (a = !0, M += "x"), s || g[e] === f || (s = !0, M += "y"), l || v[e] === p || (l = !0, M += "z");
        }

        a || (M += "x"), s || (M += "y"), l || (M += "z");
        var A = o(t._x),
            S = o(t._y),
            E = o(t._z);
        M = (M = (M = M.replace("x", (c > u ? "-" : "+") + "x")).replace("y", (f > h ? "-" : "+") + "y")).replace("z", (p > d ? "-" : "+") + "z");

        var L = function L() {
          y = 0, A = [], S = [], E = [];
        };

        (!y || y < A.length * S.length * E.length) && L();

        var C = function C(t) {
          return "x" === t ? m : "y" === t ? g : v;
        },
            P = function P(t) {
          return "x" === t ? A : "y" === t ? S : E;
        },
            I = function I(t) {
          return t[y - 1] < t[0] ? -1 : 1;
        },
            O = C(M[1]),
            z = C(M[3]),
            D = C(M[5]),
            R = P(M[1]).length,
            F = P(M[3]).length,
            B = P(M[5]).length,
            N = !1,
            j = function j(t, e, r) {
          return R * (F * t + e) + r;
        },
            U = I(C(M[1])),
            V = I(C(M[3])),
            q = I(C(M[5]));

        for (e = 0; e < B - 1; e++) {
          for (r = 0; r < F - 1; r++) {
            for (i = 0; i < R - 1; i++) {
              var H = j(e, r, i),
                  G = j(e, r, i + 1),
                  Y = j(e, r + 1, i),
                  W = j(e + 1, r, i);
              if (O[H] * U < O[G] * U && z[H] * V < z[Y] * V && D[H] * q < D[W] * q || (N = !0), N) break;
            }

            if (N) break;
          }

          if (N) break;
        }

        return N && (n.warn("Encountered arbitrary coordinates! Unable to input data grid."), L()), {
          xMin: b,
          yMin: w,
          zMin: k,
          xMax: x,
          yMax: _,
          zMax: T,
          Xs: A,
          Ys: S,
          Zs: E,
          len: y,
          fill: M
        };
      }

      function o(t) {
        return n.distinctVals(t).vals;
      }

      function s(t, e) {
        if (void 0 === e && (e = t.length), n.isTypedArray(t)) return t.subarray(0, e);

        for (var r = [], i = 0; i < e; i++) {
          r[i] = +t[i];
        }

        return r;
      }

      e.exports = {
        calc: function calc(t, e) {
          e._len = Math.min(e.u.length, e.v.length, e.w.length, e.x.length, e.y.length, e.z.length), e._u = s(e.u, e._len), e._v = s(e.v, e._len), e._w = s(e.w, e._len), e._x = s(e.x, e._len), e._y = s(e.y, e._len), e._z = s(e.z, e._len);
          var r = a(e);
          e._gridFill = r.fill, e._Xs = r.Xs, e._Ys = r.Ys, e._Zs = r.Zs, e._len = r.len;
          var n,
              o,
              l,
              c = 0;
          e.starts && (n = s(e.starts.x || []), o = s(e.starts.y || []), l = s(e.starts.z || []), c = Math.min(n.length, o.length, l.length)), e._startsX = n || [], e._startsY = o || [], e._startsZ = l || [];
          var u,
              f = 0,
              h = 1 / 0;

          for (u = 0; u < e._len; u++) {
            var p = e._u[u],
                d = e._v[u],
                m = e._w[u],
                g = Math.sqrt(p * p + d * d + m * m);
            f = Math.max(f, g), h = Math.min(h, g);
          }

          for (i(t, e, {
            vals: [h, f],
            containerStr: "",
            cLetter: "c"
          }), u = 0; u < c; u++) {
            var v = n[u];
            r.xMax = Math.max(r.xMax, v), r.xMin = Math.min(r.xMin, v);
            var y = o[u];
            r.yMax = Math.max(r.yMax, y), r.yMin = Math.min(r.yMin, y);
            var x = l[u];
            r.zMax = Math.max(r.zMax, x), r.zMin = Math.min(r.zMin, x);
          }

          e._slen = c, e._normMax = f, e._xbnds = [r.xMin, r.xMax], e._ybnds = [r.yMin, r.yMax], e._zbnds = [r.zMin, r.zMax];
        },
        filter: s,
        processGrid: a
      };
    }, {
      "../../components/colorscale/calc": 666,
      "../../lib": 795
    }],
    1308: [function (t, e, r) {
      "use strict";

      var n = t("gl-streamtube3d"),
          i = n.createTubeMesh,
          a = t("../../lib"),
          o = t("../../lib/gl_format_color").parseColorScale,
          s = t("../../components/colorscale").extractOpts,
          l = t("../../plots/gl3d/zip3"),
          c = {
        xaxis: 0,
        yaxis: 1,
        zaxis: 2
      };

      function u(t, e) {
        this.scene = t, this.uid = e, this.mesh = null, this.data = null;
      }

      var f = u.prototype;

      function h(t) {
        var e = t.length;
        return e > 2 ? t.slice(1, e - 1) : 2 === e ? [(t[0] + t[1]) / 2] : t;
      }

      function p(t) {
        var e = t.length;
        return 1 === e ? [.5, .5] : [t[1] - t[0], t[e - 1] - t[e - 2]];
      }

      function d(t, e) {
        var r = t.fullSceneLayout,
            i = t.dataScale,
            u = e._len,
            f = {};

        function d(t, e) {
          var n = r[e],
              o = i[c[e]];
          return a.simpleMap(t, function (t) {
            return n.d2l(t) * o;
          });
        }

        if (f.vectors = l(d(e._u, "xaxis"), d(e._v, "yaxis"), d(e._w, "zaxis"), u), !u) return {
          positions: [],
          cells: []
        };
        var m = d(e._Xs, "xaxis"),
            g = d(e._Ys, "yaxis"),
            v = d(e._Zs, "zaxis");
        if (f.meshgrid = [m, g, v], f.gridFill = e._gridFill, e._slen) f.startingPositions = l(d(e._startsX, "xaxis"), d(e._startsY, "yaxis"), d(e._startsZ, "zaxis"));else {
          for (var y = g[0], x = h(m), b = h(v), _ = new Array(x.length * b.length), w = 0, T = 0; T < x.length; T++) {
            for (var k = 0; k < b.length; k++) {
              _[w++] = [x[T], y, b[k]];
            }
          }

          f.startingPositions = _;
        }
        f.colormap = o(e), f.tubeSize = e.sizeref, f.maxLength = e.maxdisplayed;
        var M = d(e._xbnds, "xaxis"),
            A = d(e._ybnds, "yaxis"),
            S = d(e._zbnds, "zaxis"),
            E = p(m),
            L = p(g),
            C = p(v),
            P = [[M[0] - E[0], A[0] - L[0], S[0] - C[0]], [M[1] + E[1], A[1] + L[1], S[1] + C[1]]],
            I = n(f, P),
            O = s(e);
        I.vertexIntensityBounds = [O.min / e._normMax, O.max / e._normMax];
        var z = e.lightposition;
        return I.lightPosition = [z.x, z.y, z.z], I.ambient = e.lighting.ambient, I.diffuse = e.lighting.diffuse, I.specular = e.lighting.specular, I.roughness = e.lighting.roughness, I.fresnel = e.lighting.fresnel, I.opacity = e.opacity, e._pad = I.tubeScale * e.sizeref * 2, I;
      }

      f.handlePick = function (t) {
        var e = this.scene.fullSceneLayout,
            r = this.scene.dataScale;

        function n(t, n) {
          var i = e[n],
              a = r[c[n]];
          return i.l2c(t) / a;
        }

        if (t.object === this.mesh) {
          var i = t.data.position,
              a = t.data.velocity;
          return t.traceCoordinate = [n(i[0], "xaxis"), n(i[1], "yaxis"), n(i[2], "zaxis"), n(a[0], "xaxis"), n(a[1], "yaxis"), n(a[2], "zaxis"), t.data.intensity * this.data._normMax, t.data.divergence], t.textLabel = this.data.hovertext || this.data.text, !0;
        }
      }, f.update = function (t) {
        this.data = t;
        var e = d(this.scene, t);
        this.mesh.update(e);
      }, f.dispose = function () {
        this.scene.glplot.remove(this.mesh), this.mesh.dispose();
      }, e.exports = function (t, e) {
        var r = t.glplot.gl,
            n = d(t, e),
            a = i(r, n),
            o = new u(t, e.uid);
        return o.mesh = a, o.data = e, a._trace = o, t.glplot.add(a), o;
      };
    }, {
      "../../components/colorscale": 670,
      "../../lib": 795,
      "../../lib/gl_format_color": 791,
      "../../plots/gl3d/zip3": 898,
      "gl-streamtube3d": 343
    }],
    1309: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../components/colorscale/defaults"),
          a = t("./attributes");

      e.exports = function (t, e, r, o) {
        function s(r, i) {
          return n.coerce(t, e, a, r, i);
        }

        var l = s("u"),
            c = s("v"),
            u = s("w"),
            f = s("x"),
            h = s("y"),
            p = s("z");
        l && l.length && c && c.length && u && u.length && f && f.length && h && h.length && p && p.length ? (s("starts.x"), s("starts.y"), s("starts.z"), s("maxdisplayed"), s("sizeref"), s("lighting.ambient"), s("lighting.diffuse"), s("lighting.specular"), s("lighting.roughness"), s("lighting.fresnel"), s("lightposition.x"), s("lightposition.y"), s("lightposition.z"), i(t, e, o, s, {
          prefix: "",
          cLetter: "c"
        }), s("text"), s("hovertext"), s("hovertemplate"), s("uhoverformat"), s("vhoverformat"), s("whoverformat"), s("xhoverformat"), s("yhoverformat"), s("zhoverformat"), e._length = null) : e.visible = !1;
      };
    }, {
      "../../components/colorscale/defaults": 668,
      "../../lib": 795,
      "./attributes": 1306
    }],
    1310: [function (t, e, r) {
      "use strict";

      e.exports = {
        moduleType: "trace",
        name: "streamtube",
        basePlotModule: t("../../plots/gl3d"),
        categories: ["gl3d", "showLegend"],
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        colorbar: {
          min: "cmin",
          max: "cmax"
        },
        calc: t("./calc").calc,
        plot: t("./convert"),
        eventData: function eventData(t, e) {
          return t.tubex = t.x, t.tubey = t.y, t.tubez = t.z, t.tubeu = e.traceCoordinate[3], t.tubev = e.traceCoordinate[4], t.tubew = e.traceCoordinate[5], t.norm = e.traceCoordinate[6], t.divergence = e.traceCoordinate[7], delete t.x, delete t.y, delete t.z, t;
        },
        meta: {}
      };
    }, {
      "../../plots/gl3d": 887,
      "./attributes": 1306,
      "./calc": 1307,
      "./convert": 1308,
      "./defaults": 1309
    }],
    1311: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/attributes"),
          i = t("../../plots/template_attributes").hovertemplateAttrs,
          a = t("../../plots/template_attributes").texttemplateAttrs,
          o = t("../../components/colorscale/attributes"),
          s = t("../../plots/domain").attributes,
          l = t("../pie/attributes"),
          c = t("./constants"),
          u = t("../../lib/extend").extendFlat;
      e.exports = {
        labels: {
          valType: "data_array",
          editType: "calc"
        },
        parents: {
          valType: "data_array",
          editType: "calc"
        },
        values: {
          valType: "data_array",
          editType: "calc"
        },
        branchvalues: {
          valType: "enumerated",
          values: ["remainder", "total"],
          dflt: "remainder",
          editType: "calc"
        },
        count: {
          valType: "flaglist",
          flags: ["branches", "leaves"],
          dflt: "leaves",
          editType: "calc"
        },
        level: {
          valType: "any",
          editType: "plot",
          anim: !0
        },
        maxdepth: {
          valType: "integer",
          editType: "plot",
          dflt: -1
        },
        marker: u({
          colors: {
            valType: "data_array",
            editType: "calc"
          },
          line: {
            color: u({}, l.marker.line.color, {
              dflt: null
            }),
            width: u({}, l.marker.line.width, {
              dflt: 1
            }),
            editType: "calc"
          },
          editType: "calc"
        }, o("marker", {
          colorAttr: "colors",
          anim: !1
        })),
        leaf: {
          opacity: {
            valType: "number",
            editType: "style",
            min: 0,
            max: 1
          },
          editType: "plot"
        },
        text: l.text,
        textinfo: {
          valType: "flaglist",
          flags: ["label", "text", "value", "current path", "percent root", "percent entry", "percent parent"],
          extras: ["none"],
          editType: "plot"
        },
        texttemplate: a({
          editType: "plot"
        }, {
          keys: c.eventDataKeys.concat(["label", "value"])
        }),
        hovertext: l.hovertext,
        hoverinfo: u({}, n.hoverinfo, {
          flags: ["label", "text", "value", "name", "current path", "percent root", "percent entry", "percent parent"],
          dflt: "label+text+value+name"
        }),
        hovertemplate: i({}, {
          keys: c.eventDataKeys
        }),
        textfont: l.textfont,
        insidetextorientation: l.insidetextorientation,
        insidetextfont: l.insidetextfont,
        outsidetextfont: u({}, l.outsidetextfont, {}),
        rotation: {
          valType: "angle",
          dflt: 0,
          editType: "plot"
        },
        sort: l.sort,
        root: {
          color: {
            valType: "color",
            editType: "calc",
            dflt: "rgba(0,0,0,0)"
          },
          editType: "calc"
        },
        domain: s({
          name: "sunburst",
          trace: !0,
          editType: "calc"
        })
      };
    }, {
      "../../components/colorscale/attributes": 665,
      "../../lib/extend": 785,
      "../../plots/attributes": 841,
      "../../plots/domain": 872,
      "../../plots/template_attributes": 918,
      "../pie/attributes": 1173,
      "./constants": 1314
    }],
    1312: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/plots");
      r.name = "sunburst", r.plot = function (t, e, i, a) {
        n.plotBasePlot(r.name, t, e, i, a);
      }, r.clean = function (t, e, i, a) {
        n.cleanBasePlot(r.name, t, e, i, a);
      };
    }, {
      "../../plots/plots": 909
    }],
    1313: [function (t, e, r) {
      "use strict";

      var n = t("d3-hierarchy"),
          i = t("fast-isnumeric"),
          a = t("../../lib"),
          o = t("../../components/colorscale").makeColorScaleFuncFromTrace,
          s = t("../pie/calc").makePullColorFn,
          l = t("../pie/calc").generateExtendedColors,
          c = t("../../components/colorscale").calc,
          u = t("../../constants/numerical").ALMOST_EQUAL,
          f = {},
          h = {};
      r.calc = function (t, e) {
        var r,
            l,
            f,
            h,
            p,
            d,
            m = t._fullLayout,
            g = e.ids,
            v = a.isArrayOrTypedArray(g),
            y = e.labels,
            x = e.parents,
            b = e.values,
            _ = a.isArrayOrTypedArray(b),
            w = [],
            T = {},
            k = {},
            M = function M(t) {
          return t || "number" == typeof t;
        },
            A = function A(t) {
          return !_ || i(b[t]) && b[t] >= 0;
        };

        v ? (r = Math.min(g.length, x.length), l = function l(t) {
          return M(g[t]) && A(t);
        }, f = function f(t) {
          return String(g[t]);
        }) : (r = Math.min(y.length, x.length), l = function l(t) {
          return M(y[t]) && A(t);
        }, f = function f(t) {
          return String(y[t]);
        }), _ && (r = Math.min(r, b.length));

        for (var S = 0; S < r; S++) {
          if (l(S)) {
            var E = f(S),
                L = M(x[S]) ? String(x[S]) : "",
                C = {
              i: S,
              id: E,
              pid: L,
              label: M(y[S]) ? String(y[S]) : ""
            };
            _ && (C.v = +b[S]), w.push(C), p = E, T[h = L] ? T[h].push(p) : T[h] = [p], k[p] = 1;
          }
        }

        if (T[""]) {
          if (T[""].length > 1) {
            for (var P = a.randstr(), I = 0; I < w.length; I++) {
              "" === w[I].pid && (w[I].pid = P);
            }

            w.unshift({
              hasMultipleRoots: !0,
              id: P,
              pid: "",
              label: ""
            });
          }
        } else {
          var O,
              z = [];

          for (O in T) {
            k[O] || z.push(O);
          }

          if (1 !== z.length) return a.warn(["Multiple implied roots, cannot build", e.type, "hierarchy of", e.name + ".", "These roots include:", z.join(", ")].join(" "));
          O = z[0], w.unshift({
            hasImpliedRoot: !0,
            id: O,
            pid: "",
            label: O
          });
        }

        try {
          d = n.stratify().id(function (t) {
            return t.id;
          }).parentId(function (t) {
            return t.pid;
          })(w);
        } catch (t) {
          return a.warn(["Failed to build", e.type, "hierarchy of", e.name + ".", "Error:", t.message].join(" "));
        }

        var D = n.hierarchy(d),
            R = !1;
        if (_) switch (e.branchvalues) {
          case "remainder":
            D.sum(function (t) {
              return t.data.v;
            });
            break;

          case "total":
            D.each(function (t) {
              var r = t.data.data,
                  n = r.v;

              if (t.children) {
                var i = t.children.reduce(function (t, e) {
                  return t + e.data.data.v;
                }, 0);
                if ((r.hasImpliedRoot || r.hasMultipleRoots) && (n = i), n < i * u) return R = !0, a.warn(["Total value for node", t.data.data.id, "of", e.name, "is smaller than the sum of its children.", "\nparent value =", n, "\nchildren sum =", i].join(" "));
              }

              t.value = n;
            });
        } else !function t(e, r, n) {
          var i = 0,
              a = e.children;

          if (a) {
            for (var o = a.length, s = 0; s < o; s++) {
              i += t(a[s], r, n);
            }

            n.branches && i++;
          } else n.leaves && i++;

          e.value = e.data.data.value = i, r._values || (r._values = []);
          return r._values[e.data.data.i] = i, i;
        }(D, e, {
          branches: -1 !== e.count.indexOf("branches"),
          leaves: -1 !== e.count.indexOf("leaves")
        });

        if (!R) {
          var F, B;
          e.sort && D.sort(function (t, e) {
            return e.value - t.value;
          });
          var N = e.marker.colors || [],
              j = !!N.length;
          return e._hasColorscale ? (j || (N = _ ? e.values : e._values), c(t, e, {
            vals: N,
            containerStr: "marker",
            cLetter: "c"
          }), B = o(e.marker)) : F = s(m["_" + e.type + "colormap"]), D.each(function (t) {
            var r = t.data.data;
            r.color = e._hasColorscale ? B(N[r.i]) : F(N[r.i], r.id);
          }), w[0].hierarchy = D, w;
        }
      }, r._runCrossTraceCalc = function (t, e) {
        var r = e._fullLayout,
            n = e.calcdata,
            i = r[t + "colorway"],
            a = r["_" + t + "colormap"];
        r["extend" + t + "colors"] && (i = l(i, "treemap" === t ? h : f));
        var o,
            s = 0;

        function c(t) {
          var e = t.data.data,
              r = e.id;
          !1 === e.color && (a[r] ? e.color = a[r] : t.parent ? t.parent.parent ? e.color = t.parent.data.data.color : (a[r] = e.color = i[s % i.length], s++) : e.color = o);
        }

        for (var u = 0; u < n.length; u++) {
          var p = n[u][0];
          p.trace.type === t && p.hierarchy && (o = p.trace.root.color, p.hierarchy.each(c));
        }
      }, r.crossTraceCalc = function (t) {
        return r._runCrossTraceCalc("sunburst", t);
      };
    }, {
      "../../components/colorscale": 670,
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../pie/calc": 1175,
      "d3-hierarchy": 162,
      "fast-isnumeric": 240
    }],
    1314: [function (t, e, r) {
      "use strict";

      e.exports = {
        CLICK_TRANSITION_TIME: 750,
        CLICK_TRANSITION_EASING: "linear",
        eventDataKeys: ["currentPath", "root", "entry", "percentRoot", "percentEntry", "percentParent"]
      };
    }, {}],
    1315: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./attributes"),
          a = t("../../plots/domain").defaults,
          o = t("../bar/defaults").handleText,
          s = t("../../components/colorscale"),
          l = s.hasColorscale,
          c = s.handleDefaults;

      e.exports = function (t, e, r, s) {
        function u(r, a) {
          return n.coerce(t, e, i, r, a);
        }

        var f = u("labels"),
            h = u("parents");

        if (f && f.length && h && h.length) {
          var p = u("values");
          p && p.length ? u("branchvalues") : u("count"), u("level"), u("maxdepth"), u("marker.line.width") && u("marker.line.color", s.paper_bgcolor), u("marker.colors");
          var d = e._hasColorscale = l(t, "marker", "colors") || (t.marker || {}).coloraxis;
          d && c(t, e, s, u, {
            prefix: "marker.",
            cLetter: "c"
          }), u("leaf.opacity", d ? 1 : .7);
          var m = u("text");
          u("texttemplate"), e.texttemplate || u("textinfo", Array.isArray(m) ? "text+label" : "label"), u("hovertext"), u("hovertemplate");
          o(t, e, s, u, "auto", {
            moduleHasSelected: !1,
            moduleHasUnselected: !1,
            moduleHasConstrain: !1,
            moduleHasCliponaxis: !1,
            moduleHasTextangle: !1,
            moduleHasInsideanchor: !1
          }), u("insidetextorientation"), u("sort"), u("rotation"), u("root.color"), a(e, s, u), e._length = null;
        } else e.visible = !1;
      };
    }, {
      "../../components/colorscale": 670,
      "../../lib": 795,
      "../../plots/domain": 872,
      "../bar/defaults": 937,
      "./attributes": 1311
    }],
    1316: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../registry"),
          a = t("../../components/fx/helpers").appendArrayPointValue,
          o = t("../../components/fx"),
          s = t("../../lib"),
          l = t("../../lib/events"),
          c = t("./helpers"),
          u = t("../pie/helpers").formatPieValue;

      function f(t, e, r) {
        for (var n = t.data.data, i = {
          curveNumber: e.index,
          pointNumber: n.i,
          data: e._input,
          fullData: e
        }, o = 0; o < r.length; o++) {
          var s = r[o];
          s in t && (i[s] = t[s]);
        }

        return "parentString" in t && !c.isHierarchyRoot(t) && (i.parent = t.parentString), a(i, e, n.i), i;
      }

      e.exports = function (t, e, r, a, h) {
        var p = a[0],
            d = p.trace,
            m = p.hierarchy,
            g = "sunburst" === d.type,
            v = "treemap" === d.type;
        "_hasHoverLabel" in d || (d._hasHoverLabel = !1), "_hasHoverEvent" in d || (d._hasHoverEvent = !1);
        t.on("mouseover", function (i) {
          var a = r._fullLayout;

          if (!r._dragging && !1 !== a.hovermode) {
            var l = r._fullData[d.index],
                y = i.data.data,
                x = y.i,
                b = c.isHierarchyRoot(i),
                _ = c.getParent(m, i),
                w = c.getValue(i),
                T = function T(t) {
              return s.castOption(l, x, t);
            },
                k = T("hovertemplate"),
                M = o.castHoverinfo(l, a, x),
                A = a.separators;

            if (k || M && "none" !== M && "skip" !== M) {
              var S, E;
              g && (S = p.cx + i.pxmid[0] * (1 - i.rInscribed), E = p.cy + i.pxmid[1] * (1 - i.rInscribed)), v && (S = i._hoverX, E = i._hoverY);

              var L,
                  C = {},
                  P = [],
                  I = [],
                  O = function O(t) {
                return -1 !== P.indexOf(t);
              };

              M && (P = "all" === M ? l._module.attributes.hoverinfo.flags : M.split("+")), C.label = y.label, O("label") && C.label && I.push(C.label), y.hasOwnProperty("v") && (C.value = y.v, C.valueLabel = u(C.value, A), O("value") && I.push(C.valueLabel)), C.currentPath = i.currentPath = c.getPath(i.data), O("current path") && !b && I.push(C.currentPath);

              var z = [],
                  D = function D() {
                -1 === z.indexOf(L) && (I.push(L), z.push(L));
              };

              C.percentParent = i.percentParent = w / c.getValue(_), C.parent = i.parentString = c.getPtLabel(_), O("percent parent") && (L = c.formatPercent(C.percentParent, A) + " of " + C.parent, D()), C.percentEntry = i.percentEntry = w / c.getValue(e), C.entry = i.entry = c.getPtLabel(e), !O("percent entry") || b || i.onPathbar || (L = c.formatPercent(C.percentEntry, A) + " of " + C.entry, D()), C.percentRoot = i.percentRoot = w / c.getValue(m), C.root = i.root = c.getPtLabel(m), O("percent root") && !b && (L = c.formatPercent(C.percentRoot, A) + " of " + C.root, D()), C.text = T("hovertext") || T("text"), O("text") && (L = C.text, s.isValidTextValue(L) && I.push(L));
              var R = {
                trace: l,
                y: E,
                text: I.join("<br>"),
                name: k || O("name") ? l.name : void 0,
                color: T("hoverlabel.bgcolor") || y.color,
                borderColor: T("hoverlabel.bordercolor"),
                fontFamily: T("hoverlabel.font.family"),
                fontSize: T("hoverlabel.font.size"),
                fontColor: T("hoverlabel.font.color"),
                nameLength: T("hoverlabel.namelength"),
                textAlign: T("hoverlabel.align"),
                hovertemplate: k,
                hovertemplateLabels: C,
                eventData: [f(i, l, h.eventDataKeys)]
              };
              g && (R.x0 = S - i.rInscribed * i.rpx1, R.x1 = S + i.rInscribed * i.rpx1, R.idealAlign = i.pxmid[0] < 0 ? "left" : "right"), v && (R.x = S, R.idealAlign = S < 0 ? "left" : "right"), o.loneHover(R, {
                container: a._hoverlayer.node(),
                outerContainer: a._paper.node(),
                gd: r
              }), d._hasHoverLabel = !0;
            }

            if (v) {
              var F = t.select("path.surface");
              h.styleOne(F, i, l, {
                hovered: !0
              });
            }

            d._hasHoverEvent = !0, r.emit("plotly_hover", {
              points: [f(i, l, h.eventDataKeys)],
              event: n.event
            });
          }
        }), t.on("mouseout", function (e) {
          var i = r._fullLayout,
              a = r._fullData[d.index],
              s = n.select(this).datum();

          if (d._hasHoverEvent && (e.originalEvent = n.event, r.emit("plotly_unhover", {
            points: [f(s, a, h.eventDataKeys)],
            event: n.event
          }), d._hasHoverEvent = !1), d._hasHoverLabel && (o.loneUnhover(i._hoverlayer.node()), d._hasHoverLabel = !1), v) {
            var l = t.select("path.surface");
            h.styleOne(l, s, a, {
              hovered: !1
            });
          }
        }), t.on("click", function (t) {
          var e = r._fullLayout,
              a = r._fullData[d.index],
              s = g && (c.isHierarchyRoot(t) || c.isLeaf(t)),
              u = c.getPtId(t),
              p = c.isEntry(t) ? c.findEntryWithChild(m, u) : c.findEntryWithLevel(m, u),
              v = c.getPtId(p),
              y = {
            points: [f(t, a, h.eventDataKeys)],
            event: n.event
          };
          s || (y.nextLevel = v);
          var x = l.triggerHandler(r, "plotly_" + d.type + "click", y);

          if (!1 !== x && e.hovermode && (r._hoverdata = [f(t, a, h.eventDataKeys)], o.click(r, n.event)), !s && !1 !== x && !r._dragging && !r._transitioning) {
            i.call("_storeDirectGUIEdit", a, e._tracePreGUI[a.uid], {
              level: a.level
            });
            var b = {
              data: [{
                level: v
              }],
              traces: [d.index]
            },
                _ = {
              frame: {
                redraw: !1,
                duration: h.transitionTime
              },
              transition: {
                duration: h.transitionTime,
                easing: h.transitionEasing
              },
              mode: "immediate",
              fromcurrent: !0
            };
            o.loneUnhover(e._hoverlayer.node()), i.call("animate", r, b, _);
          }
        });
      };
    }, {
      "../../components/fx": 698,
      "../../components/fx/helpers": 694,
      "../../lib": 795,
      "../../lib/events": 784,
      "../../registry": 923,
      "../pie/helpers": 1178,
      "./helpers": 1317,
      "@plotly/d3": 57
    }],
    1317: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../components/color"),
          a = t("../../lib/setcursor"),
          o = t("../pie/helpers");

      function s(t) {
        return t.data.data.pid;
      }

      r.findEntryWithLevel = function (t, e) {
        var n;
        return e && t.eachAfter(function (t) {
          if (r.getPtId(t) === e) return n = t.copy();
        }), n || t;
      }, r.findEntryWithChild = function (t, e) {
        var n;
        return t.eachAfter(function (t) {
          for (var i = t.children || [], a = 0; a < i.length; a++) {
            var o = i[a];
            if (r.getPtId(o) === e) return n = t.copy();
          }
        }), n || t;
      }, r.isEntry = function (t) {
        return !t.parent;
      }, r.isLeaf = function (t) {
        return !t.children;
      }, r.getPtId = function (t) {
        return t.data.data.id;
      }, r.getPtLabel = function (t) {
        return t.data.data.label;
      }, r.getValue = function (t) {
        return t.value;
      }, r.isHierarchyRoot = function (t) {
        return "" === s(t);
      }, r.setSliceCursor = function (t, e, n) {
        var i = n.isTransitioning;

        if (!i) {
          var o = t.datum();
          i = n.hideOnRoot && r.isHierarchyRoot(o) || n.hideOnLeaves && r.isLeaf(o);
        }

        a(t, i ? null : "pointer");
      }, r.getInsideTextFontKey = function (t, e, r, i, a) {
        var o = (a || {}).onPathbar ? "pathbar.textfont" : "insidetextfont",
            s = r.data.data.i;
        return n.castOption(e, s, o + "." + t) || n.castOption(e, s, "textfont." + t) || i.size;
      }, r.getOutsideTextFontKey = function (t, e, r, i) {
        var a = r.data.data.i;
        return n.castOption(e, a, "outsidetextfont." + t) || n.castOption(e, a, "textfont." + t) || i.size;
      }, r.isOutsideText = function (t, e) {
        return !t._hasColorscale && r.isHierarchyRoot(e);
      }, r.determineTextFont = function (t, e, a, o) {
        return r.isOutsideText(t, e) ? function (t, e, n) {
          return {
            color: r.getOutsideTextFontKey("color", t, e, n),
            family: r.getOutsideTextFontKey("family", t, e, n),
            size: r.getOutsideTextFontKey("size", t, e, n)
          };
        }(t, e, a) : function (t, e, a, o) {
          var s = (o || {}).onPathbar,
              l = e.data.data,
              c = l.i,
              u = n.castOption(t, c, (s ? "pathbar.textfont" : "insidetextfont") + ".color");
          return !u && t._input.textfont && (u = n.castOption(t._input, c, "textfont.color")), {
            color: u || i.contrast(l.color),
            family: r.getInsideTextFontKey("family", t, e, a, o),
            size: r.getInsideTextFontKey("size", t, e, a, o)
          };
        }(t, e, a, o);
      }, r.hasTransition = function (t) {
        return !!(t && t.duration > 0);
      }, r.getMaxDepth = function (t) {
        return t.maxdepth >= 0 ? t.maxdepth : 1 / 0;
      }, r.isHeader = function (t, e) {
        return !(r.isLeaf(t) || t.depth === e._maxDepth - 1);
      }, r.getParent = function (t, e) {
        return r.findEntryWithLevel(t, s(e));
      }, r.listPath = function (t, e) {
        var n = t.parent;
        if (!n) return [];
        var i = e ? [n.data[e]] : [n];
        return r.listPath(n, e).concat(i);
      }, r.getPath = function (t) {
        return r.listPath(t, "label").join("/") + "/";
      }, r.formatValue = o.formatPieValue, r.formatPercent = function (t, e) {
        var r = n.formatPercent(t, 0);
        return "0%" === r && (r = o.formatPiePercent(t, e)), r;
      };
    }, {
      "../../components/color": 658,
      "../../lib": 795,
      "../../lib/setcursor": 816,
      "../pie/helpers": 1178
    }],
    1318: [function (t, e, r) {
      "use strict";

      e.exports = {
        moduleType: "trace",
        name: "sunburst",
        basePlotModule: t("./base_plot"),
        categories: [],
        animatable: !0,
        attributes: t("./attributes"),
        layoutAttributes: t("./layout_attributes"),
        supplyDefaults: t("./defaults"),
        supplyLayoutDefaults: t("./layout_defaults"),
        calc: t("./calc").calc,
        crossTraceCalc: t("./calc").crossTraceCalc,
        plot: t("./plot").plot,
        style: t("./style").style,
        colorbar: t("../scatter/marker_colorbar"),
        meta: {}
      };
    }, {
      "../scatter/marker_colorbar": 1217,
      "./attributes": 1311,
      "./base_plot": 1312,
      "./calc": 1313,
      "./defaults": 1315,
      "./layout_attributes": 1319,
      "./layout_defaults": 1320,
      "./plot": 1321,
      "./style": 1322
    }],
    1319: [function (t, e, r) {
      "use strict";

      e.exports = {
        sunburstcolorway: {
          valType: "colorlist",
          editType: "calc"
        },
        extendsunburstcolors: {
          valType: "boolean",
          dflt: !0,
          editType: "calc"
        }
      };
    }, {}],
    1320: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./layout_attributes");

      e.exports = function (t, e) {
        function r(r, a) {
          return n.coerce(t, e, i, r, a);
        }

        r("sunburstcolorway", e.colorway), r("extendsunburstcolors");
      };
    }, {
      "../../lib": 795,
      "./layout_attributes": 1319
    }],
    1321: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("d3-hierarchy"),
          a = t("../../components/drawing"),
          o = t("../../lib"),
          s = t("../../lib/svg_text_utils"),
          l = t("../bar/uniform_text"),
          c = l.recordMinTextSize,
          u = l.clearMinTextSize,
          f = t("../pie/plot"),
          h = t("../pie/helpers").getRotationAngle,
          p = f.computeTransform,
          d = f.transformInsideText,
          m = t("./style").styleOne,
          g = t("../bar/style").resizeText,
          v = t("./fx"),
          y = t("./constants"),
          x = t("./helpers");

      function b(t, e, l, u) {
        var f = t._fullLayout,
            g = !f.uniformtext.mode && x.hasTransition(u),
            b = n.select(l).selectAll("g.slice"),
            w = e[0],
            T = w.trace,
            k = w.hierarchy,
            M = x.findEntryWithLevel(k, T.level),
            A = x.getMaxDepth(T),
            S = f._size,
            E = T.domain,
            L = S.w * (E.x[1] - E.x[0]),
            C = S.h * (E.y[1] - E.y[0]),
            P = .5 * Math.min(L, C),
            I = w.cx = S.l + S.w * (E.x[1] + E.x[0]) / 2,
            O = w.cy = S.t + S.h * (1 - E.y[0]) - C / 2;
        if (!M) return b.remove();
        var z = null,
            D = {};
        g && b.each(function (t) {
          D[x.getPtId(t)] = {
            rpx0: t.rpx0,
            rpx1: t.rpx1,
            x0: t.x0,
            x1: t.x1,
            transform: t.transform
          }, !z && x.isEntry(t) && (z = t);
        });

        var R = function (t) {
          return i.partition().size([2 * Math.PI, t.height + 1])(t);
        }(M).descendants(),
            F = M.height + 1,
            B = 0,
            N = A;

        w.hasMultipleRoots && x.isHierarchyRoot(M) && (R = R.slice(1), F -= 1, B = 1, N += 1), R = R.filter(function (t) {
          return t.y1 <= N;
        });
        var j = h(T.rotation);
        j && R.forEach(function (t) {
          t.x0 += j, t.x1 += j;
        });

        var U = Math.min(F, A),
            V = function V(t) {
          return (t - B) / U * P;
        },
            q = function q(t, e) {
          return [t * Math.cos(e), -t * Math.sin(e)];
        },
            H = function H(t) {
          return o.pathAnnulus(t.rpx0, t.rpx1, t.x0, t.x1, I, O);
        },
            G = function G(t) {
          return I + _(t)[0] * (t.transform.rCenter || 0) + (t.transform.x || 0);
        },
            Y = function Y(t) {
          return O + _(t)[1] * (t.transform.rCenter || 0) + (t.transform.y || 0);
        };

        (b = b.data(R, x.getPtId)).enter().append("g").classed("slice", !0), g ? b.exit().transition().each(function () {
          var t = n.select(this);
          t.select("path.surface").transition().attrTween("d", function (t) {
            var e = function (t) {
              var e,
                  r = x.getPtId(t),
                  i = D[r],
                  a = D[x.getPtId(M)];

              if (a) {
                var o = (t.x1 > a.x1 ? 2 * Math.PI : 0) + j;
                e = t.rpx1 < a.rpx1 ? {
                  rpx0: 0,
                  rpx1: 0
                } : {
                  x0: o,
                  x1: o
                };
              } else {
                var s,
                    l = x.getPtId(t.parent);
                b.each(function (t) {
                  if (x.getPtId(t) === l) return s = t;
                });
                var c,
                    u = s.children;
                u.forEach(function (t, e) {
                  if (x.getPtId(t) === r) return c = e;
                });
                var f = u.length,
                    h = n.interpolate(s.x0, s.x1);
                e = {
                  rpx0: P,
                  rpx1: P,
                  x0: h(c / f),
                  x1: h((c + 1) / f)
                };
              }

              return n.interpolate(i, e);
            }(t);

            return function (t) {
              return H(e(t));
            };
          }), t.select("g.slicetext").attr("opacity", 0);
        }).remove() : b.exit().remove(), b.order();
        var W = null;

        if (g && z) {
          var X = x.getPtId(z);
          b.each(function (t) {
            null === W && x.getPtId(t) === X && (W = t.x1);
          });
        }

        var Z = b;

        function J(t) {
          var e = t.parent,
              r = D[x.getPtId(e)],
              i = {};

          if (r) {
            var a = e.children,
                o = a.indexOf(t),
                s = a.length,
                l = n.interpolate(r.x0, r.x1);
            i.x0 = l(o / s), i.x1 = l(o / s);
          } else i.x0 = i.x1 = 0;

          return i;
        }

        g && (Z = Z.transition().each("end", function () {
          var e = n.select(this);
          x.setSliceCursor(e, t, {
            hideOnRoot: !0,
            hideOnLeaves: !0,
            isTransitioning: !1
          });
        })), Z.each(function (i) {
          var l = n.select(this),
              u = o.ensureSingle(l, "path", "surface", function (t) {
            t.style("pointer-events", "all");
          });
          i.rpx0 = V(i.y0), i.rpx1 = V(i.y1), i.xmid = (i.x0 + i.x1) / 2, i.pxmid = q(i.rpx1, i.xmid), i.midangle = -(i.xmid - Math.PI / 2), i.startangle = -(i.x0 - Math.PI / 2), i.stopangle = -(i.x1 - Math.PI / 2), i.halfangle = .5 * Math.min(o.angleDelta(i.x0, i.x1) || Math.PI, Math.PI), i.ring = 1 - i.rpx0 / i.rpx1, i.rInscribed = function (t) {
            return 0 === t.rpx0 && o.isFullCircle([t.x0, t.x1]) ? 1 : Math.max(0, Math.min(1 / (1 + 1 / Math.sin(t.halfangle)), t.ring / 2));
          }(i), g ? u.transition().attrTween("d", function (t) {
            var e = function (t) {
              var e,
                  r = D[x.getPtId(t)],
                  i = {
                x0: t.x0,
                x1: t.x1,
                rpx0: t.rpx0,
                rpx1: t.rpx1
              };
              if (r) e = r;else if (z) {
                if (t.parent) {
                  if (W) {
                    var a = (t.x1 > W ? 2 * Math.PI : 0) + j;
                    e = {
                      x0: a,
                      x1: a
                    };
                  } else e = {
                    rpx0: P,
                    rpx1: P
                  }, o.extendFlat(e, J(t));
                } else e = {
                  rpx0: 0,
                  rpx1: 0
                };
              } else e = {
                x0: j,
                x1: j
              };
              return n.interpolate(e, i);
            }(t);

            return function (t) {
              return H(e(t));
            };
          }) : u.attr("d", H), l.call(v, M, t, e, {
            eventDataKeys: y.eventDataKeys,
            transitionTime: y.CLICK_TRANSITION_TIME,
            transitionEasing: y.CLICK_TRANSITION_EASING
          }).call(x.setSliceCursor, t, {
            hideOnRoot: !0,
            hideOnLeaves: !0,
            isTransitioning: t._transitioning
          }), u.call(m, i, T);

          var h = o.ensureSingle(l, "g", "slicetext"),
              b = o.ensureSingle(h, "text", "", function (t) {
            t.attr("data-notex", 1);
          }),
              _ = o.ensureUniformFontSize(t, x.determineTextFont(T, i, f.font));

          b.text(r.formatSliceLabel(i, M, T, e, f)).classed("slicetext", !0).attr("text-anchor", "middle").call(a.font, _).call(s.convertToTspans, t);
          var k = a.bBox(b.node());
          i.transform = d(k, i, w), i.transform.targetX = G(i), i.transform.targetY = Y(i);

          var A = function A(t, e) {
            var r = t.transform;
            return p(r, e), r.fontSize = _.size, c(T.type, r, f), o.getTextTransform(r);
          };

          g ? b.transition().attrTween("transform", function (t) {
            var e = function (t) {
              var e,
                  r = D[x.getPtId(t)],
                  i = t.transform;
              if (r) e = r;else if (e = {
                rpx1: t.rpx1,
                transform: {
                  textPosAngle: i.textPosAngle,
                  scale: 0,
                  rotate: i.rotate,
                  rCenter: i.rCenter,
                  x: i.x,
                  y: i.y
                }
              }, z) {
                if (t.parent) {
                  if (W) {
                    var a = t.x1 > W ? 2 * Math.PI : 0;
                    e.x0 = e.x1 = a;
                  } else o.extendFlat(e, J(t));
                } else e.x0 = e.x1 = j;
              } else e.x0 = e.x1 = j;
              var s = n.interpolate(e.transform.textPosAngle, t.transform.textPosAngle),
                  l = n.interpolate(e.rpx1, t.rpx1),
                  u = n.interpolate(e.x0, t.x0),
                  h = n.interpolate(e.x1, t.x1),
                  p = n.interpolate(e.transform.scale, i.scale),
                  d = n.interpolate(e.transform.rotate, i.rotate),
                  m = 0 === i.rCenter ? 3 : 0 === e.transform.rCenter ? 1 / 3 : 1,
                  g = n.interpolate(e.transform.rCenter, i.rCenter);
              return function (t) {
                var e = l(t),
                    r = u(t),
                    n = h(t),
                    a = function (t) {
                  return g(Math.pow(t, m));
                }(t),
                    o = {
                  pxmid: q(e, (r + n) / 2),
                  rpx1: e,
                  transform: {
                    textPosAngle: s(t),
                    rCenter: a,
                    x: i.x,
                    y: i.y
                  }
                };

                return c(T.type, i, f), {
                  transform: {
                    targetX: G(o),
                    targetY: Y(o),
                    scale: p(t),
                    rotate: d(t),
                    rCenter: a
                  }
                };
              };
            }(t);

            return function (t) {
              return A(e(t), k);
            };
          }) : b.attr("transform", A(i, k));
        });
      }

      function _(t) {
        return e = t.rpx1, r = t.transform.textPosAngle, [e * Math.sin(r), -e * Math.cos(r)];
        var e, r;
      }

      r.plot = function (t, e, r, i) {
        var a,
            o,
            s = t._fullLayout,
            l = s._sunburstlayer,
            c = !r,
            f = !s.uniformtext.mode && x.hasTransition(r);
        (u("sunburst", s), (a = l.selectAll("g.trace.sunburst").data(e, function (t) {
          return t[0].trace.uid;
        })).enter().append("g").classed("trace", !0).classed("sunburst", !0).attr("stroke-linejoin", "round"), a.order(), f) ? (i && (o = i()), n.transition().duration(r.duration).ease(r.easing).each("end", function () {
          o && o();
        }).each("interrupt", function () {
          o && o();
        }).each(function () {
          l.selectAll("g.trace").each(function (e) {
            b(t, e, this, r);
          });
        })) : (a.each(function (e) {
          b(t, e, this, r);
        }), s.uniformtext.mode && g(t, s._sunburstlayer.selectAll(".trace"), "sunburst"));
        c && a.exit().remove();
      }, r.formatSliceLabel = function (t, e, r, n, i) {
        var a = r.texttemplate,
            s = r.textinfo;
        if (!(a || s && "none" !== s)) return "";
        var l = i.separators,
            c = n[0],
            u = t.data.data,
            f = c.hierarchy,
            h = x.isHierarchyRoot(t),
            p = x.getParent(f, t),
            d = x.getValue(t);

        if (!a) {
          var m,
              g = s.split("+"),
              v = function v(t) {
            return -1 !== g.indexOf(t);
          },
              y = [];

          if (v("label") && u.label && y.push(u.label), u.hasOwnProperty("v") && v("value") && y.push(x.formatValue(u.v, l)), !h) {
            v("current path") && y.push(x.getPath(t.data));
            var b = 0;
            v("percent parent") && b++, v("percent entry") && b++, v("percent root") && b++;

            var _ = b > 1;

            if (b) {
              var w,
                  T = function T(t) {
                m = x.formatPercent(w, l), _ && (m += " of " + t), y.push(m);
              };

              v("percent parent") && !h && (w = d / x.getValue(p), T("parent")), v("percent entry") && (w = d / x.getValue(e), T("entry")), v("percent root") && (w = d / x.getValue(f), T("root"));
            }
          }

          return v("text") && (m = o.castOption(r, u.i, "text"), o.isValidTextValue(m) && y.push(m)), y.join("<br>");
        }

        var k = o.castOption(r, u.i, "texttemplate");
        if (!k) return "";
        var M = {};
        u.label && (M.label = u.label), u.hasOwnProperty("v") && (M.value = u.v, M.valueLabel = x.formatValue(u.v, l)), M.currentPath = x.getPath(t.data), h || (M.percentParent = d / x.getValue(p), M.percentParentLabel = x.formatPercent(M.percentParent, l), M.parent = x.getPtLabel(p)), M.percentEntry = d / x.getValue(e), M.percentEntryLabel = x.formatPercent(M.percentEntry, l), M.entry = x.getPtLabel(e), M.percentRoot = d / x.getValue(f), M.percentRootLabel = x.formatPercent(M.percentRoot, l), M.root = x.getPtLabel(f), u.hasOwnProperty("color") && (M.color = u.color);
        var A = o.castOption(r, u.i, "text");
        return (o.isValidTextValue(A) || "" === A) && (M.text = A), M.customdata = o.castOption(r, u.i, "customdata"), o.texttemplateString(k, M, i._d3locale, M, r._meta || {});
      };
    }, {
      "../../components/drawing": 680,
      "../../lib": 795,
      "../../lib/svg_text_utils": 820,
      "../bar/style": 947,
      "../bar/uniform_text": 949,
      "../pie/helpers": 1178,
      "../pie/plot": 1182,
      "./constants": 1314,
      "./fx": 1316,
      "./helpers": 1317,
      "./style": 1322,
      "@plotly/d3": 57,
      "d3-hierarchy": 162
    }],
    1322: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../components/color"),
          a = t("../../lib"),
          o = t("../bar/uniform_text").resizeText;

      function s(t, e, r) {
        var n = e.data.data,
            o = !e.children,
            s = n.i,
            l = a.castOption(r, s, "marker.line.color") || i.defaultLine,
            c = a.castOption(r, s, "marker.line.width") || 0;
        t.style("stroke-width", c).call(i.fill, n.color).call(i.stroke, l).style("opacity", o ? r.leaf.opacity : null);
      }

      e.exports = {
        style: function style(t) {
          var e = t._fullLayout._sunburstlayer.selectAll(".trace");

          o(t, e, "sunburst"), e.each(function (t) {
            var e = n.select(this),
                r = t[0].trace;
            e.style("opacity", r.opacity), e.selectAll("path.surface").each(function (t) {
              n.select(this).call(s, t, r);
            });
          });
        },
        styleOne: s
      };
    }, {
      "../../components/color": 658,
      "../../lib": 795,
      "../bar/uniform_text": 949,
      "@plotly/d3": 57
    }],
    1323: [function (t, e, r) {
      "use strict";

      var n = t("../../components/color"),
          i = t("../../components/colorscale/attributes"),
          a = t("../../plots/hoverformat_attributes"),
          o = t("../../plots/template_attributes").hovertemplateAttrs,
          s = t("../../plots/attributes"),
          l = t("../../lib/extend").extendFlat,
          c = t("../../plot_api/edit_types").overrideAll;

      function u(t) {
        return {
          show: {
            valType: "boolean",
            dflt: !1
          },
          start: {
            valType: "number",
            dflt: null,
            editType: "plot"
          },
          end: {
            valType: "number",
            dflt: null,
            editType: "plot"
          },
          size: {
            valType: "number",
            dflt: null,
            min: 0,
            editType: "plot"
          },
          project: {
            x: {
              valType: "boolean",
              dflt: !1
            },
            y: {
              valType: "boolean",
              dflt: !1
            },
            z: {
              valType: "boolean",
              dflt: !1
            }
          },
          color: {
            valType: "color",
            dflt: n.defaultLine
          },
          usecolormap: {
            valType: "boolean",
            dflt: !1
          },
          width: {
            valType: "number",
            min: 1,
            max: 16,
            dflt: 2
          },
          highlight: {
            valType: "boolean",
            dflt: !0
          },
          highlightcolor: {
            valType: "color",
            dflt: n.defaultLine
          },
          highlightwidth: {
            valType: "number",
            min: 1,
            max: 16,
            dflt: 2
          }
        };
      }

      var f = e.exports = c(l({
        z: {
          valType: "data_array"
        },
        x: {
          valType: "data_array"
        },
        y: {
          valType: "data_array"
        },
        text: {
          valType: "string",
          dflt: "",
          arrayOk: !0
        },
        hovertext: {
          valType: "string",
          dflt: "",
          arrayOk: !0
        },
        hovertemplate: o(),
        xhoverformat: a("x"),
        yhoverformat: a("y"),
        zhoverformat: a("z"),
        connectgaps: {
          valType: "boolean",
          dflt: !1,
          editType: "calc"
        },
        surfacecolor: {
          valType: "data_array"
        }
      }, i("", {
        colorAttr: "z or surfacecolor",
        showScaleDflt: !0,
        autoColorDflt: !1,
        editTypeOverride: "calc"
      }), {
        contours: {
          x: u(),
          y: u(),
          z: u()
        },
        hidesurface: {
          valType: "boolean",
          dflt: !1
        },
        lightposition: {
          x: {
            valType: "number",
            min: -1e5,
            max: 1e5,
            dflt: 10
          },
          y: {
            valType: "number",
            min: -1e5,
            max: 1e5,
            dflt: 1e4
          },
          z: {
            valType: "number",
            min: -1e5,
            max: 1e5,
            dflt: 0
          }
        },
        lighting: {
          ambient: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: .8
          },
          diffuse: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: .8
          },
          specular: {
            valType: "number",
            min: 0,
            max: 2,
            dflt: .05
          },
          roughness: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: .5
          },
          fresnel: {
            valType: "number",
            min: 0,
            max: 5,
            dflt: .2
          }
        },
        opacity: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 1
        },
        opacityscale: {
          valType: "any",
          editType: "calc"
        },
        _deprecated: {
          zauto: l({}, i.zauto, {}),
          zmin: l({}, i.zmin, {}),
          zmax: l({}, i.zmax, {})
        },
        hoverinfo: l({}, s.hoverinfo),
        showlegend: l({}, s.showlegend, {
          dflt: !1
        })
      }), "calc", "nested");
      f.x.editType = f.y.editType = f.z.editType = "calc+clearAxisTypes", f.transforms = void 0;
    }, {
      "../../components/color": 658,
      "../../components/colorscale/attributes": 665,
      "../../lib/extend": 785,
      "../../plot_api/edit_types": 827,
      "../../plots/attributes": 841,
      "../../plots/hoverformat_attributes": 899,
      "../../plots/template_attributes": 918
    }],
    1324: [function (t, e, r) {
      "use strict";

      var n = t("../../components/colorscale/calc");

      e.exports = function (t, e) {
        e.surfacecolor ? n(t, e, {
          vals: e.surfacecolor,
          containerStr: "",
          cLetter: "c"
        }) : n(t, e, {
          vals: e.z,
          containerStr: "",
          cLetter: "c"
        });
      };
    }, {
      "../../components/colorscale/calc": 666
    }],
    1325: [function (t, e, r) {
      "use strict";

      var n = t("gl-surface3d"),
          i = t("ndarray"),
          a = t("ndarray-linear-interpolate").d2,
          o = t("../heatmap/interp2d"),
          s = t("../heatmap/find_empties"),
          l = t("../../lib").isArrayOrTypedArray,
          c = t("../../lib/gl_format_color").parseColorScale,
          u = t("../../lib/str2rgbarray"),
          f = t("../../components/colorscale").extractOpts;

      function h(t, e, r) {
        this.scene = t, this.uid = r, this.surface = e, this.data = null, this.showContour = [!1, !1, !1], this.contourStart = [null, null, null], this.contourEnd = [null, null, null], this.contourSize = [0, 0, 0], this.minValues = [1 / 0, 1 / 0, 1 / 0], this.maxValues = [-1 / 0, -1 / 0, -1 / 0], this.dataScaleX = 1, this.dataScaleY = 1, this.refineData = !0, this.objectOffset = [0, 0, 0];
      }

      var p = h.prototype;
      p.getXat = function (t, e, r, n) {
        var i = l(this.data.x) ? l(this.data.x[0]) ? this.data.x[e][t] : this.data.x[t] : t;
        return void 0 === r ? i : n.d2l(i, 0, r);
      }, p.getYat = function (t, e, r, n) {
        var i = l(this.data.y) ? l(this.data.y[0]) ? this.data.y[e][t] : this.data.y[e] : e;
        return void 0 === r ? i : n.d2l(i, 0, r);
      }, p.getZat = function (t, e, r, n) {
        var i = this.data.z[e][t];
        return null === i && this.data.connectgaps && this.data._interpolatedZ && (i = this.data._interpolatedZ[e][t]), void 0 === r ? i : n.d2l(i, 0, r);
      }, p.handlePick = function (t) {
        if (t.object === this.surface) {
          var e = (t.data.index[0] - 1) / this.dataScaleX - 1,
              r = (t.data.index[1] - 1) / this.dataScaleY - 1,
              n = Math.max(Math.min(Math.round(e), this.data.z[0].length - 1), 0),
              i = Math.max(Math.min(Math.round(r), this.data._ylength - 1), 0);
          t.index = [n, i], t.traceCoordinate = [this.getXat(n, i), this.getYat(n, i), this.getZat(n, i)], t.dataCoordinate = [this.getXat(n, i, this.data.xcalendar, this.scene.fullSceneLayout.xaxis), this.getYat(n, i, this.data.ycalendar, this.scene.fullSceneLayout.yaxis), this.getZat(n, i, this.data.zcalendar, this.scene.fullSceneLayout.zaxis)];

          for (var a = 0; a < 3; a++) {
            var o = t.dataCoordinate[a];
            null != o && (t.dataCoordinate[a] *= this.scene.dataScale[a]);
          }

          var s = this.data.hovertext || this.data.text;
          return Array.isArray(s) && s[i] && void 0 !== s[i][n] ? t.textLabel = s[i][n] : t.textLabel = s || "", t.data.dataCoordinate = t.dataCoordinate.slice(), this.surface.highlight(t.data), this.scene.glplot.spikes.position = t.dataCoordinate, !0;
        }
      };
      var d = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997, 1009, 1013, 1019, 1021, 1031, 1033, 1039, 1049, 1051, 1061, 1063, 1069, 1087, 1091, 1093, 1097, 1103, 1109, 1117, 1123, 1129, 1151, 1153, 1163, 1171, 1181, 1187, 1193, 1201, 1213, 1217, 1223, 1229, 1231, 1237, 1249, 1259, 1277, 1279, 1283, 1289, 1291, 1297, 1301, 1303, 1307, 1319, 1321, 1327, 1361, 1367, 1373, 1381, 1399, 1409, 1423, 1427, 1429, 1433, 1439, 1447, 1451, 1453, 1459, 1471, 1481, 1483, 1487, 1489, 1493, 1499, 1511, 1523, 1531, 1543, 1549, 1553, 1559, 1567, 1571, 1579, 1583, 1597, 1601, 1607, 1609, 1613, 1619, 1621, 1627, 1637, 1657, 1663, 1667, 1669, 1693, 1697, 1699, 1709, 1721, 1723, 1733, 1741, 1747, 1753, 1759, 1777, 1783, 1787, 1789, 1801, 1811, 1823, 1831, 1847, 1861, 1867, 1871, 1873, 1877, 1879, 1889, 1901, 1907, 1913, 1931, 1933, 1949, 1951, 1973, 1979, 1987, 1993, 1997, 1999, 2003, 2011, 2017, 2027, 2029, 2039, 2053, 2063, 2069, 2081, 2083, 2087, 2089, 2099, 2111, 2113, 2129, 2131, 2137, 2141, 2143, 2153, 2161, 2179, 2203, 2207, 2213, 2221, 2237, 2239, 2243, 2251, 2267, 2269, 2273, 2281, 2287, 2293, 2297, 2309, 2311, 2333, 2339, 2341, 2347, 2351, 2357, 2371, 2377, 2381, 2383, 2389, 2393, 2399, 2411, 2417, 2423, 2437, 2441, 2447, 2459, 2467, 2473, 2477, 2503, 2521, 2531, 2539, 2543, 2549, 2551, 2557, 2579, 2591, 2593, 2609, 2617, 2621, 2633, 2647, 2657, 2659, 2663, 2671, 2677, 2683, 2687, 2689, 2693, 2699, 2707, 2711, 2713, 2719, 2729, 2731, 2741, 2749, 2753, 2767, 2777, 2789, 2791, 2797, 2801, 2803, 2819, 2833, 2837, 2843, 2851, 2857, 2861, 2879, 2887, 2897, 2903, 2909, 2917, 2927, 2939, 2953, 2957, 2963, 2969, 2971, 2999];

      function m(t, e) {
        if (t < e) return 0;

        for (var r = 0; 0 === Math.floor(t % e);) {
          t /= e, r++;
        }

        return r;
      }

      function g(t) {
        for (var e = [], r = 0; r < d.length; r++) {
          var n = d[r];
          e.push(m(t, n));
        }

        return e;
      }

      function v(t) {
        for (var e = g(t), r = t, n = 0; n < d.length; n++) {
          if (e[n] > 0) {
            r = d[n];
            break;
          }
        }

        return r;
      }

      function y(t, e) {
        if (!(t < 1 || e < 1)) {
          for (var r = g(t), n = g(e), i = 1, a = 0; a < d.length; a++) {
            i *= Math.pow(d[a], Math.max(r[a], n[a]));
          }

          return i;
        }
      }

      p.calcXnums = function (t) {
        var e,
            r = [];

        for (e = 1; e < t; e++) {
          var n = this.getXat(e - 1, 0),
              i = this.getXat(e, 0);
          r[e - 1] = i !== n && null != n && null != i ? Math.abs(i - n) : 0;
        }

        var a = 0;

        for (e = 1; e < t; e++) {
          a += r[e - 1];
        }

        for (e = 1; e < t; e++) {
          0 === r[e - 1] ? r[e - 1] = 1 : r[e - 1] = Math.round(a / r[e - 1]);
        }

        return r;
      }, p.calcYnums = function (t) {
        var e,
            r = [];

        for (e = 1; e < t; e++) {
          var n = this.getYat(0, e - 1),
              i = this.getYat(0, e);
          r[e - 1] = i !== n && null != n && null != i ? Math.abs(i - n) : 0;
        }

        var a = 0;

        for (e = 1; e < t; e++) {
          a += r[e - 1];
        }

        for (e = 1; e < t; e++) {
          0 === r[e - 1] ? r[e - 1] = 1 : r[e - 1] = Math.round(a / r[e - 1]);
        }

        return r;
      };
      var x = [1, 2, 4, 6, 12, 24, 36, 48, 60, 120, 180, 240, 360, 720, 840, 1260],
          b = x[9],
          _ = x[13];

      function w(t, e, r) {
        var n = r[8] + r[2] * e[0] + r[5] * e[1];
        return t[0] = (r[6] + r[0] * e[0] + r[3] * e[1]) / n, t[1] = (r[7] + r[1] * e[0] + r[4] * e[1]) / n, t;
      }

      function T(t, e, r) {
        return function (t, e, r, n) {
          for (var i = [0, 0], o = t.shape[0], s = t.shape[1], l = 0; l < o; l++) {
            for (var c = 0; c < s; c++) {
              r(i, [l, c], n), t.set(l, c, a(e, i[0], i[1]));
            }
          }
        }(t, e, w, r), t;
      }

      function k(t, e) {
        for (var r = !1, n = 0; n < t.length; n++) {
          if (e === t[n]) {
            r = !0;
            break;
          }
        }

        !1 === r && t.push(e);
      }

      p.estimateScale = function (t, e) {
        for (var r = 1 + function (t) {
          if (0 !== t.length) {
            for (var e = 1, r = 0; r < t.length; r++) {
              e = y(e, t[r]);
            }

            return e;
          }
        }(0 === e ? this.calcXnums(t) : this.calcYnums(t)); r < b;) {
          r *= 2;
        }

        for (; r > _;) {
          r--, r /= v(r), ++r < b && (r = _);
        }

        var n = Math.round(r / t);
        return n > 1 ? n : 1;
      }, p.refineCoords = function (t) {
        for (var e = this.dataScaleX, r = this.dataScaleY, n = t[0].shape[0], a = t[0].shape[1], o = 0 | Math.floor(t[0].shape[0] * e + 1), s = 0 | Math.floor(t[0].shape[1] * r + 1), l = 1 + n + 1, c = 1 + a + 1, u = i(new Float32Array(l * c), [l, c]), f = [1 / e, 0, 0, 0, 1 / r, 0, 0, 0, 1], h = 0; h < t.length; ++h) {
          this.surface.padField(u, t[h]);
          var p = i(new Float32Array(o * s), [o, s]);
          T(p, u, f), t[h] = p;
        }
      }, p.setContourLevels = function () {
        var t,
            e,
            r,
            n = [[], [], []],
            i = [!1, !1, !1],
            a = !1;

        for (t = 0; t < 3; ++t) {
          if (this.showContour[t] && (a = !0, this.contourSize[t] > 0 && null !== this.contourStart[t] && null !== this.contourEnd[t] && this.contourEnd[t] > this.contourStart[t])) for (i[t] = !0, e = this.contourStart[t]; e < this.contourEnd[t]; e += this.contourSize[t]) {
            r = e * this.scene.dataScale[t], k(n[t], r);
          }
        }

        if (a) {
          var o = [[], [], []];

          for (t = 0; t < 3; ++t) {
            this.showContour[t] && (o[t] = i[t] ? n[t] : this.scene.contourLevels[t]);
          }

          this.surface.update({
            levels: o
          });
        }
      }, p.update = function (t) {
        var e,
            r,
            n,
            a,
            l = this.scene,
            h = l.fullSceneLayout,
            p = this.surface,
            d = c(t),
            m = l.dataScale,
            g = t.z[0].length,
            v = t._ylength,
            y = l.contourLevels;
        this.data = t;
        var x = [];

        for (e = 0; e < 3; e++) {
          for (x[e] = [], r = 0; r < g; r++) {
            x[e][r] = [];
          }
        }

        for (r = 0; r < g; r++) {
          for (n = 0; n < v; n++) {
            x[0][r][n] = this.getXat(r, n, t.xcalendar, h.xaxis), x[1][r][n] = this.getYat(r, n, t.ycalendar, h.yaxis), x[2][r][n] = this.getZat(r, n, t.zcalendar, h.zaxis);
          }
        }

        if (t.connectgaps) for (t._emptypoints = s(x[2]), o(x[2], t._emptypoints), t._interpolatedZ = [], r = 0; r < g; r++) {
          for (t._interpolatedZ[r] = [], n = 0; n < v; n++) {
            t._interpolatedZ[r][n] = x[2][r][n];
          }
        }

        for (e = 0; e < 3; e++) {
          for (r = 0; r < g; r++) {
            for (n = 0; n < v; n++) {
              null == (a = x[e][r][n]) ? x[e][r][n] = NaN : a = x[e][r][n] *= m[e];
            }
          }
        }

        for (e = 0; e < 3; e++) {
          for (r = 0; r < g; r++) {
            for (n = 0; n < v; n++) {
              null != (a = x[e][r][n]) && (this.minValues[e] > a && (this.minValues[e] = a), this.maxValues[e] < a && (this.maxValues[e] = a));
            }
          }
        }

        for (e = 0; e < 3; e++) {
          this.objectOffset[e] = .5 * (this.minValues[e] + this.maxValues[e]);
        }

        for (e = 0; e < 3; e++) {
          for (r = 0; r < g; r++) {
            for (n = 0; n < v; n++) {
              null != (a = x[e][r][n]) && (x[e][r][n] -= this.objectOffset[e]);
            }
          }
        }

        var b = [i(new Float32Array(g * v), [g, v]), i(new Float32Array(g * v), [g, v]), i(new Float32Array(g * v), [g, v])];

        for (e = 0; e < 3; e++) {
          for (r = 0; r < g; r++) {
            for (n = 0; n < v; n++) {
              b[e].set(r, n, x[e][r][n]);
            }
          }
        }

        x = [];
        var w = {
          colormap: d,
          levels: [[], [], []],
          showContour: [!0, !0, !0],
          showSurface: !t.hidesurface,
          contourProject: [[!1, !1, !1], [!1, !1, !1], [!1, !1, !1]],
          contourWidth: [1, 1, 1],
          contourColor: [[1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1]],
          contourTint: [1, 1, 1],
          dynamicColor: [[1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1]],
          dynamicWidth: [1, 1, 1],
          dynamicTint: [1, 1, 1],
          opacityscale: t.opacityscale,
          opacity: t.opacity
        },
            T = f(t);

        if (w.intensityBounds = [T.min, T.max], t.surfacecolor) {
          var k = i(new Float32Array(g * v), [g, v]);

          for (r = 0; r < g; r++) {
            for (n = 0; n < v; n++) {
              k.set(r, n, t.surfacecolor[n][r]);
            }
          }

          b.push(k);
        } else w.intensityBounds[0] *= m[2], w.intensityBounds[1] *= m[2];

        (_ < b[0].shape[0] || _ < b[0].shape[1]) && (this.refineData = !1), !0 === this.refineData && (this.dataScaleX = this.estimateScale(b[0].shape[0], 0), this.dataScaleY = this.estimateScale(b[0].shape[1], 1), 1 === this.dataScaleX && 1 === this.dataScaleY || this.refineCoords(b)), t.surfacecolor && (w.intensity = b.pop());
        var M = [!0, !0, !0],
            A = ["x", "y", "z"];

        for (e = 0; e < 3; ++e) {
          var S = t.contours[A[e]];
          M[e] = S.highlight, w.showContour[e] = S.show || S.highlight, w.showContour[e] && (w.contourProject[e] = [S.project.x, S.project.y, S.project.z], S.show ? (this.showContour[e] = !0, w.levels[e] = y[e], p.highlightColor[e] = w.contourColor[e] = u(S.color), S.usecolormap ? p.highlightTint[e] = w.contourTint[e] = 0 : p.highlightTint[e] = w.contourTint[e] = 1, w.contourWidth[e] = S.width, this.contourStart[e] = S.start, this.contourEnd[e] = S.end, this.contourSize[e] = S.size) : (this.showContour[e] = !1, this.contourStart[e] = null, this.contourEnd[e] = null, this.contourSize[e] = 0), S.highlight && (w.dynamicColor[e] = u(S.highlightcolor), w.dynamicWidth[e] = S.highlightwidth));
        }

        (function (t) {
          var e = t[0].rgb,
              r = t[t.length - 1].rgb;
          return e[0] === r[0] && e[1] === r[1] && e[2] === r[2] && e[3] === r[3];
        })(d) && (w.vertexColor = !0), w.objectOffset = this.objectOffset, w.coords = b, p.update(w), p.visible = t.visible, p.enableDynamic = M, p.enableHighlight = M, p.snapToData = !0, "lighting" in t && (p.ambientLight = t.lighting.ambient, p.diffuseLight = t.lighting.diffuse, p.specularLight = t.lighting.specular, p.roughness = t.lighting.roughness, p.fresnel = t.lighting.fresnel), "lightposition" in t && (p.lightPosition = [t.lightposition.x, t.lightposition.y, t.lightposition.z]);
      }, p.dispose = function () {
        this.scene.glplot.remove(this.surface), this.surface.dispose();
      }, e.exports = function (t, e) {
        var r = t.glplot.gl,
            i = n({
          gl: r
        }),
            a = new h(t, i, e.uid);
        return i._trace = a, a.update(e), t.glplot.add(i), a;
      };
    }, {
      "../../components/colorscale": 670,
      "../../lib": 795,
      "../../lib/gl_format_color": 791,
      "../../lib/str2rgbarray": 819,
      "../heatmap/find_empties": 1083,
      "../heatmap/interp2d": 1086,
      "gl-surface3d": 345,
      ndarray: 475,
      "ndarray-linear-interpolate": 469
    }],
    1326: [function (t, e, r) {
      "use strict";

      var n = t("../../registry"),
          i = t("../../lib"),
          a = t("../../components/colorscale/defaults"),
          o = t("./attributes");

      function s(t, e, r, n) {
        var i = n("opacityscale");
        "max" === i ? e.opacityscale = [[0, .1], [1, 1]] : "min" === i ? e.opacityscale = [[0, 1], [1, .1]] : "extremes" === i ? e.opacityscale = function (t, e) {
          for (var r = [], n = 0; n < 32; n++) {
            var i = n / 31,
                a = e + (1 - e) * (1 - Math.pow(Math.sin(t * i * Math.PI), 2));
            r.push([i, Math.max(0, Math.min(1, a))]);
          }

          return r;
        }(1, .1) : function (t) {
          var e = 0;
          if (!Array.isArray(t) || t.length < 2) return !1;
          if (!t[0] || !t[t.length - 1]) return !1;
          if (0 != +t[0][0] || 1 != +t[t.length - 1][0]) return !1;

          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            if (2 !== n.length || +n[0] < e) return !1;
            e = +n[0];
          }

          return !0;
        }(i) || (e.opacityscale = void 0);
      }

      function l(t, e, r) {
        e in t && !(r in t) && (t[r] = t[e]);
      }

      e.exports = {
        supplyDefaults: function supplyDefaults(t, e, r, c) {
          var u, f;

          function h(r, n) {
            return i.coerce(t, e, o, r, n);
          }

          var p = h("x"),
              d = h("y"),
              m = h("z");
          if (!m || !m.length || p && p.length < 1 || d && d.length < 1) e.visible = !1;else {
            e._xlength = Array.isArray(p) && i.isArrayOrTypedArray(p[0]) ? m.length : m[0].length, e._ylength = m.length, n.getComponentMethod("calendars", "handleTraceDefaults")(t, e, ["x", "y", "z"], c), h("text"), h("hovertext"), h("hovertemplate"), h("xhoverformat"), h("yhoverformat"), h("zhoverformat"), ["lighting.ambient", "lighting.diffuse", "lighting.specular", "lighting.roughness", "lighting.fresnel", "lightposition.x", "lightposition.y", "lightposition.z", "hidesurface", "connectgaps", "opacity"].forEach(function (t) {
              h(t);
            });
            var g = h("surfacecolor"),
                v = ["x", "y", "z"];

            for (u = 0; u < 3; ++u) {
              var y = "contours." + v[u],
                  x = h(y + ".show"),
                  b = h(y + ".highlight");
              if (x || b) for (f = 0; f < 3; ++f) {
                h(y + ".project." + v[f]);
              }
              x && (h(y + ".color"), h(y + ".width"), h(y + ".usecolormap")), b && (h(y + ".highlightcolor"), h(y + ".highlightwidth")), h(y + ".start"), h(y + ".end"), h(y + ".size");
            }

            g || (l(t, "zmin", "cmin"), l(t, "zmax", "cmax"), l(t, "zauto", "cauto")), a(t, e, c, h, {
              prefix: "",
              cLetter: "c"
            }), s(t, e, c, h), e._length = null;
          }
        },
        opacityscaleDefaults: s
      };
    }, {
      "../../components/colorscale/defaults": 668,
      "../../lib": 795,
      "../../registry": 923,
      "./attributes": 1323
    }],
    1327: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults").supplyDefaults,
        colorbar: {
          min: "cmin",
          max: "cmax"
        },
        calc: t("./calc"),
        plot: t("./convert"),
        moduleType: "trace",
        name: "surface",
        basePlotModule: t("../../plots/gl3d"),
        categories: ["gl3d", "2dMap", "showLegend"],
        meta: {}
      };
    }, {
      "../../plots/gl3d": 887,
      "./attributes": 1323,
      "./calc": 1324,
      "./convert": 1325,
      "./defaults": 1326
    }],
    1328: [function (t, e, r) {
      "use strict";

      var n = t("../../components/annotations/attributes"),
          i = t("../../lib/extend").extendFlat,
          a = t("../../plot_api/edit_types").overrideAll,
          o = t("../../plots/font_attributes"),
          s = t("../../plots/domain").attributes;
      t("../../constants/docs").FORMAT_LINK;
      (e.exports = a({
        domain: s({
          name: "table",
          trace: !0
        }),
        columnwidth: {
          valType: "number",
          arrayOk: !0,
          dflt: null
        },
        columnorder: {
          valType: "data_array"
        },
        header: {
          values: {
            valType: "data_array",
            dflt: []
          },
          format: {
            valType: "data_array",
            dflt: []
          },
          prefix: {
            valType: "string",
            arrayOk: !0,
            dflt: null
          },
          suffix: {
            valType: "string",
            arrayOk: !0,
            dflt: null
          },
          height: {
            valType: "number",
            dflt: 28
          },
          align: i({}, n.align, {
            arrayOk: !0
          }),
          line: {
            width: {
              valType: "number",
              arrayOk: !0,
              dflt: 1
            },
            color: {
              valType: "color",
              arrayOk: !0,
              dflt: "grey"
            }
          },
          fill: {
            color: {
              valType: "color",
              arrayOk: !0,
              dflt: "white"
            }
          },
          font: i({}, o({
            arrayOk: !0
          }))
        },
        cells: {
          values: {
            valType: "data_array",
            dflt: []
          },
          format: {
            valType: "data_array",
            dflt: []
          },
          prefix: {
            valType: "string",
            arrayOk: !0,
            dflt: null
          },
          suffix: {
            valType: "string",
            arrayOk: !0,
            dflt: null
          },
          height: {
            valType: "number",
            dflt: 20
          },
          align: i({}, n.align, {
            arrayOk: !0
          }),
          line: {
            width: {
              valType: "number",
              arrayOk: !0,
              dflt: 1
            },
            color: {
              valType: "color",
              arrayOk: !0,
              dflt: "grey"
            }
          },
          fill: {
            color: {
              valType: "color",
              arrayOk: !0,
              dflt: "white"
            }
          },
          font: i({}, o({
            arrayOk: !0
          }))
        }
      }, "calc", "from-root")).transforms = void 0;
    }, {
      "../../components/annotations/attributes": 641,
      "../../constants/docs": 766,
      "../../lib/extend": 785,
      "../../plot_api/edit_types": 827,
      "../../plots/domain": 872,
      "../../plots/font_attributes": 873
    }],
    1329: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/get_data").getModuleCalcData,
          i = t("./plot");
      r.name = "table", r.plot = function (t) {
        var e = n(t.calcdata, "table")[0];
        e.length && i(t, e);
      }, r.clean = function (t, e, r, n) {
        var i = n._has && n._has("table"),
            a = e._has && e._has("table");

        i && !a && n._paperdiv.selectAll(".table").remove();
      };
    }, {
      "../../plots/get_data": 882,
      "./plot": 1336
    }],
    1330: [function (t, e, r) {
      "use strict";

      var n = t("../../lib/gup").wrap;

      e.exports = function () {
        return n({});
      };
    }, {
      "../../lib/gup": 792
    }],
    1331: [function (t, e, r) {
      "use strict";

      e.exports = {
        cellPad: 8,
        columnExtentOffset: 10,
        columnTitleOffset: 28,
        emptyHeaderHeight: 16,
        latexCheck: /^\$.*\$$/,
        goldenRatio: 1.618,
        lineBreaker: "<br>",
        maxDimensionCount: 60,
        overdrag: 45,
        releaseTransitionDuration: 120,
        releaseTransitionEase: "cubic-out",
        scrollbarCaptureWidth: 18,
        scrollbarHideDelay: 1e3,
        scrollbarHideDuration: 1e3,
        scrollbarOffset: 5,
        scrollbarWidth: 8,
        transitionDuration: 100,
        transitionEase: "cubic-out",
        uplift: 5,
        wrapSpacer: " ",
        wrapSplitCharacter: " ",
        cn: {
          table: "table",
          tableControlView: "table-control-view",
          scrollBackground: "scroll-background",
          yColumn: "y-column",
          columnBlock: "column-block",
          scrollAreaClip: "scroll-area-clip",
          scrollAreaClipRect: "scroll-area-clip-rect",
          columnBoundary: "column-boundary",
          columnBoundaryClippath: "column-boundary-clippath",
          columnBoundaryRect: "column-boundary-rect",
          columnCells: "column-cells",
          columnCell: "column-cell",
          cellRect: "cell-rect",
          cellText: "cell-text",
          cellTextHolder: "cell-text-holder",
          scrollbarKit: "scrollbar-kit",
          scrollbar: "scrollbar",
          scrollbarSlider: "scrollbar-slider",
          scrollbarGlyph: "scrollbar-glyph",
          scrollbarCaptureZone: "scrollbar-capture-zone"
        }
      };
    }, {}],
    1332: [function (t, e, r) {
      "use strict";

      var n = t("./constants"),
          i = t("../../lib/extend").extendFlat,
          a = t("fast-isnumeric");

      function o(t) {
        if (Array.isArray(t)) {
          for (var e = 0, r = 0; r < t.length; r++) {
            e = Math.max(e, o(t[r]));
          }

          return e;
        }

        return t;
      }

      function s(t, e) {
        return t + e;
      }

      function l(t) {
        var e,
            r = t.slice(),
            n = 1 / 0,
            i = 0;

        for (e = 0; e < r.length; e++) {
          Array.isArray(r[e]) || (r[e] = [r[e]]), n = Math.min(n, r[e].length), i = Math.max(i, r[e].length);
        }

        if (n !== i) for (e = 0; e < r.length; e++) {
          var a = i - r[e].length;
          a && (r[e] = r[e].concat(c(a)));
        }
        return r;
      }

      function c(t) {
        for (var e = new Array(t), r = 0; r < t; r++) {
          e[r] = "";
        }

        return e;
      }

      function u(t) {
        return t.calcdata.columns.reduce(function (e, r) {
          return r.xIndex < t.xIndex ? e + r.columnWidth : e;
        }, 0);
      }

      function f(t, e) {
        return Object.keys(t).map(function (r) {
          return i({}, t[r], {
            auxiliaryBlocks: e
          });
        });
      }

      function h(t, e) {
        for (var r, n = {}, i = 0, a = 0, o = {
          firstRowIndex: null,
          lastRowIndex: null,
          rows: []
        }, s = 0, l = 0, c = 0; c < t.length; c++) {
          r = t[c], o.rows.push({
            rowIndex: c,
            rowHeight: r
          }), ((a += r) >= e || c === t.length - 1) && (n[i] = o, o.key = l++, o.firstRowIndex = s, o.lastRowIndex = c, o = {
            firstRowIndex: null,
            lastRowIndex: null,
            rows: []
          }, i += a, s = c + 1, a = 0);
        }

        return n;
      }

      e.exports = function (t, e) {
        var r = l(e.cells.values),
            p = function p(t) {
          return t.slice(e.header.values.length, t.length);
        },
            d = l(e.header.values);

        d.length && !d[0].length && (d[0] = [""], d = l(d));

        var m = d.concat(p(r).map(function () {
          return c((d[0] || [""]).length);
        })),
            g = e.domain,
            v = Math.floor(t._fullLayout._size.w * (g.x[1] - g.x[0])),
            y = Math.floor(t._fullLayout._size.h * (g.y[1] - g.y[0])),
            x = e.header.values.length ? m[0].map(function () {
          return e.header.height;
        }) : [n.emptyHeaderHeight],
            b = r.length ? r[0].map(function () {
          return e.cells.height;
        }) : [],
            _ = x.reduce(s, 0),
            w = h(b, y - _ + n.uplift),
            T = f(h(x, _), []),
            k = f(w, T),
            M = {},
            A = e._fullInput.columnorder.concat(p(r.map(function (t, e) {
          return e;
        }))),
            S = m.map(function (t, r) {
          var n = Array.isArray(e.columnwidth) ? e.columnwidth[Math.min(r, e.columnwidth.length - 1)] : e.columnwidth;
          return a(n) ? Number(n) : 1;
        }),
            E = S.reduce(s, 0);

        S = S.map(function (t) {
          return t / E * v;
        });
        var L = Math.max(o(e.header.line.width), o(e.cells.line.width)),
            C = {
          key: e.uid + t._context.staticPlot,
          translateX: g.x[0] * t._fullLayout._size.w,
          translateY: t._fullLayout._size.h * (1 - g.y[1]),
          size: t._fullLayout._size,
          width: v,
          maxLineWidth: L,
          height: y,
          columnOrder: A,
          groupHeight: y,
          rowBlocks: k,
          headerRowBlocks: T,
          scrollY: 0,
          cells: i({}, e.cells, {
            values: r
          }),
          headerCells: i({}, e.header, {
            values: m
          }),
          gdColumns: m.map(function (t) {
            return t[0];
          }),
          gdColumnsOriginalOrder: m.map(function (t) {
            return t[0];
          }),
          prevPages: [0, 0],
          scrollbarState: {
            scrollbarScrollInProgress: !1
          },
          columns: m.map(function (t, e) {
            var r = M[t];
            return M[t] = (r || 0) + 1, {
              key: t + "__" + M[t],
              label: t,
              specIndex: e,
              xIndex: A[e],
              xScale: u,
              x: void 0,
              calcdata: void 0,
              columnWidth: S[e]
            };
          })
        };
        return C.columns.forEach(function (t) {
          t.calcdata = C, t.x = u(t);
        }), C;
      };
    }, {
      "../../lib/extend": 785,
      "./constants": 1331,
      "fast-isnumeric": 240
    }],
    1333: [function (t, e, r) {
      "use strict";

      var n = t("../../lib/extend").extendFlat;
      r.splitToPanels = function (t) {
        var e = [0, 0],
            r = n({}, t, {
          key: "header",
          type: "header",
          page: 0,
          prevPages: e,
          currentRepaint: [null, null],
          dragHandle: !0,
          values: t.calcdata.headerCells.values[t.specIndex],
          rowBlocks: t.calcdata.headerRowBlocks,
          calcdata: n({}, t.calcdata, {
            cells: t.calcdata.headerCells
          })
        });
        return [n({}, t, {
          key: "cells1",
          type: "cells",
          page: 0,
          prevPages: e,
          currentRepaint: [null, null],
          dragHandle: !1,
          values: t.calcdata.cells.values[t.specIndex],
          rowBlocks: t.calcdata.rowBlocks
        }), n({}, t, {
          key: "cells2",
          type: "cells",
          page: 1,
          prevPages: e,
          currentRepaint: [null, null],
          dragHandle: !1,
          values: t.calcdata.cells.values[t.specIndex],
          rowBlocks: t.calcdata.rowBlocks
        }), r];
      }, r.splitToCells = function (t) {
        var e = function (t) {
          var e = t.rowBlocks[t.page],
              r = e ? e.rows[0].rowIndex : 0,
              n = e ? r + e.rows.length : 0;
          return [r, n];
        }(t);

        return (t.values || []).slice(e[0], e[1]).map(function (r, n) {
          return {
            keyWithinBlock: n + ("string" == typeof r && r.match(/[<$&> ]/) ? "_keybuster_" + Math.random() : ""),
            key: e[0] + n,
            column: t,
            calcdata: t.calcdata,
            page: t.page,
            rowBlocks: t.rowBlocks,
            value: r
          };
        });
      };
    }, {
      "../../lib/extend": 785
    }],
    1334: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./attributes"),
          a = t("../../plots/domain").defaults;

      e.exports = function (t, e, r, o) {
        function s(r, a) {
          return n.coerce(t, e, i, r, a);
        }

        a(e, o, s), s("columnwidth"), s("header.values"), s("header.format"), s("header.align"), s("header.prefix"), s("header.suffix"), s("header.height"), s("header.line.width"), s("header.line.color"), s("header.fill.color"), n.coerceFont(s, "header.font", n.extendFlat({}, o.font)), function (t, e) {
          for (var r = t.columnorder || [], n = t.header.values.length, i = r.slice(0, n), a = i.slice().sort(function (t, e) {
            return t - e;
          }), o = i.map(function (t) {
            return a.indexOf(t);
          }), s = o.length; s < n; s++) {
            o.push(s);
          }

          e("columnorder", o);
        }(e, s), s("cells.values"), s("cells.format"), s("cells.align"), s("cells.prefix"), s("cells.suffix"), s("cells.height"), s("cells.line.width"), s("cells.line.color"), s("cells.fill.color"), n.coerceFont(s, "cells.font", n.extendFlat({}, o.font)), e._length = null;
      };
    }, {
      "../../lib": 795,
      "../../plots/domain": 872,
      "./attributes": 1328
    }],
    1335: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        calc: t("./calc"),
        plot: t("./plot"),
        moduleType: "trace",
        name: "table",
        basePlotModule: t("./base_plot"),
        categories: ["noOpacity"],
        meta: {}
      };
    }, {
      "./attributes": 1328,
      "./base_plot": 1329,
      "./calc": 1330,
      "./defaults": 1334,
      "./plot": 1336
    }],
    1336: [function (t, e, r) {
      "use strict";

      var n = t("./constants"),
          i = t("@plotly/d3"),
          a = t("../../lib/gup"),
          o = t("../../components/drawing"),
          s = t("../../lib/svg_text_utils"),
          l = t("../../lib").raiseToTop,
          c = t("../../lib").strTranslate,
          u = t("../../lib").cancelTransition,
          f = t("./data_preparation_helper"),
          h = t("./data_split_helpers"),
          p = t("../../components/color");

      function d(t) {
        return Math.ceil(t.calcdata.maxLineWidth / 2);
      }

      function m(t, e) {
        return "clip" + t._fullLayout._uid + "_scrollAreaBottomClip_" + e.key;
      }

      function g(t, e) {
        return "clip" + t._fullLayout._uid + "_columnBoundaryClippath_" + e.calcdata.key + "_" + e.specIndex;
      }

      function v(t) {
        return [].concat.apply([], t.map(function (t) {
          return t;
        })).map(function (t) {
          return t.__data__;
        });
      }

      function y(t, e, r) {
        var o = t.selectAll("." + n.cn.scrollbarKit).data(a.repeat, a.keyFun);
        o.enter().append("g").classed(n.cn.scrollbarKit, !0).style("shape-rendering", "geometricPrecision"), o.each(function (t) {
          var e = t.scrollbarState;
          e.totalHeight = function (t) {
            var e = t.rowBlocks;
            return z(e, e.length - 1) + (e.length ? D(e[e.length - 1], 1 / 0) : 1);
          }(t), e.scrollableAreaHeight = t.groupHeight - A(t), e.currentlyVisibleHeight = Math.min(e.totalHeight, e.scrollableAreaHeight), e.ratio = e.currentlyVisibleHeight / e.totalHeight, e.barLength = Math.max(e.ratio * e.currentlyVisibleHeight, n.goldenRatio * n.scrollbarWidth), e.barWiggleRoom = e.currentlyVisibleHeight - e.barLength, e.wiggleRoom = Math.max(0, e.totalHeight - e.scrollableAreaHeight), e.topY = 0 === e.barWiggleRoom ? 0 : t.scrollY / e.wiggleRoom * e.barWiggleRoom, e.bottomY = e.topY + e.barLength, e.dragMultiplier = e.wiggleRoom / e.barWiggleRoom;
        }).attr("transform", function (t) {
          var e = t.width + n.scrollbarWidth / 2 + n.scrollbarOffset;
          return c(e, A(t));
        });
        var s = o.selectAll("." + n.cn.scrollbar).data(a.repeat, a.keyFun);
        s.enter().append("g").classed(n.cn.scrollbar, !0);
        var l = s.selectAll("." + n.cn.scrollbarSlider).data(a.repeat, a.keyFun);
        l.enter().append("g").classed(n.cn.scrollbarSlider, !0), l.attr("transform", function (t) {
          return c(0, t.scrollbarState.topY || 0);
        });
        var u = l.selectAll("." + n.cn.scrollbarGlyph).data(a.repeat, a.keyFun);
        u.enter().append("line").classed(n.cn.scrollbarGlyph, !0).attr("stroke", "black").attr("stroke-width", n.scrollbarWidth).attr("stroke-linecap", "round").attr("y1", n.scrollbarWidth / 2), u.attr("y2", function (t) {
          return t.scrollbarState.barLength - n.scrollbarWidth / 2;
        }).attr("stroke-opacity", function (t) {
          return t.columnDragInProgress || !t.scrollbarState.barWiggleRoom || r ? 0 : .4;
        }), u.transition().delay(0).duration(0), u.transition().delay(n.scrollbarHideDelay).duration(n.scrollbarHideDuration).attr("stroke-opacity", 0);
        var f = s.selectAll("." + n.cn.scrollbarCaptureZone).data(a.repeat, a.keyFun);
        f.enter().append("line").classed(n.cn.scrollbarCaptureZone, !0).attr("stroke", "white").attr("stroke-opacity", .01).attr("stroke-width", n.scrollbarCaptureWidth).attr("stroke-linecap", "butt").attr("y1", 0).on("mousedown", function (r) {
          var n = i.event.y,
              a = this.getBoundingClientRect(),
              o = r.scrollbarState,
              s = n - a.top,
              l = i.scale.linear().domain([0, o.scrollableAreaHeight]).range([0, o.totalHeight]).clamp(!0);
          o.topY <= s && s <= o.bottomY || E(e, t, null, l(s - o.barLength / 2))(r);
        }).call(i.behavior.drag().origin(function (t) {
          return i.event.stopPropagation(), t.scrollbarState.scrollbarScrollInProgress = !0, t;
        }).on("drag", E(e, t)).on("dragend", function () {})), f.attr("y2", function (t) {
          return t.scrollbarState.scrollableAreaHeight;
        }), e._context.staticPlot && (u.remove(), f.remove());
      }

      function x(t, e, r, s) {
        var l = function (t) {
          var e = t.selectAll("." + n.cn.columnCell).data(h.splitToCells, function (t) {
            return t.keyWithinBlock;
          });
          return e.enter().append("g").classed(n.cn.columnCell, !0), e.exit().remove(), e;
        }(function (t) {
          var e = t.selectAll("." + n.cn.columnCells).data(a.repeat, a.keyFun);
          return e.enter().append("g").classed(n.cn.columnCells, !0), e.exit().remove(), e;
        }(r));

        !function (t) {
          t.each(function (t, e) {
            var r = t.calcdata.cells.font,
                n = t.column.specIndex,
                i = {
              size: w(r.size, n, e),
              color: w(r.color, n, e),
              family: w(r.family, n, e)
            };
            t.rowNumber = t.key, t.align = w(t.calcdata.cells.align, n, e), t.cellBorderWidth = w(t.calcdata.cells.line.width, n, e), t.font = i;
          });
        }(l), function (t) {
          t.attr("width", function (t) {
            return t.column.columnWidth;
          }).attr("stroke-width", function (t) {
            return t.cellBorderWidth;
          }).each(function (t) {
            var e = i.select(this);
            p.stroke(e, w(t.calcdata.cells.line.color, t.column.specIndex, t.rowNumber)), p.fill(e, w(t.calcdata.cells.fill.color, t.column.specIndex, t.rowNumber));
          });
        }(function (t) {
          var e = t.selectAll("." + n.cn.cellRect).data(a.repeat, function (t) {
            return t.keyWithinBlock;
          });
          return e.enter().append("rect").classed(n.cn.cellRect, !0), e;
        }(l));

        var c = function (t) {
          var e = t.selectAll("." + n.cn.cellText).data(a.repeat, function (t) {
            return t.keyWithinBlock;
          });
          return e.enter().append("text").classed(n.cn.cellText, !0).style("cursor", function () {
            return "auto";
          }).on("mousedown", function () {
            i.event.stopPropagation();
          }), e;
        }(function (t) {
          var e = t.selectAll("." + n.cn.cellTextHolder).data(a.repeat, function (t) {
            return t.keyWithinBlock;
          });
          return e.enter().append("g").classed(n.cn.cellTextHolder, !0).style("shape-rendering", "geometricPrecision"), e;
        }(l));

        !function (t) {
          t.each(function (t) {
            o.font(i.select(this), t.font);
          });
        }(c), b(c, e, s, t), O(l);
      }

      function b(t, e, r, a) {
        t.text(function (t) {
          var e = t.column.specIndex,
              r = t.rowNumber,
              a = t.value,
              o = "string" == typeof a,
              s = o && a.match(/<br>/i),
              l = !o || s;
          t.mayHaveMarkup = o && a.match(/[<&>]/);
          var c,
              u = "string" == typeof (c = a) && c.match(n.latexCheck);
          t.latex = u;
          var f,
              h,
              p = u ? "" : w(t.calcdata.cells.prefix, e, r) || "",
              d = u ? "" : w(t.calcdata.cells.suffix, e, r) || "",
              m = u ? null : w(t.calcdata.cells.format, e, r) || null,
              g = p + (m ? i.format(m)(t.value) : t.value) + d;

          if (t.wrappingNeeded = !t.wrapped && !l && !u && (f = _(g)), t.cellHeightMayIncrease = s || u || t.mayHaveMarkup || (void 0 === f ? _(g) : f), t.needsConvertToTspans = t.mayHaveMarkup || t.wrappingNeeded || t.latex, t.wrappingNeeded) {
            var v = (" " === n.wrapSplitCharacter ? g.replace(/<a href=/gi, "<a_href=") : g).split(n.wrapSplitCharacter),
                y = " " === n.wrapSplitCharacter ? v.map(function (t) {
              return t.replace(/<a_href=/gi, "<a href=");
            }) : v;
            t.fragments = y.map(function (t) {
              return {
                text: t,
                width: null
              };
            }), t.fragments.push({
              fragment: n.wrapSpacer,
              width: null
            }), h = y.join(n.lineBreaker) + n.lineBreaker + n.wrapSpacer;
          } else delete t.fragments, h = g;

          return h;
        }).attr("dy", function (t) {
          return t.needsConvertToTspans ? 0 : "0.75em";
        }).each(function (t) {
          var o = i.select(this),
              l = t.wrappingNeeded ? C : P;
          t.needsConvertToTspans ? s.convertToTspans(o, a, l(r, this, e, a, t)) : i.select(this.parentNode).attr("transform", function (t) {
            return c(I(t), n.cellPad);
          }).attr("text-anchor", function (t) {
            return {
              left: "start",
              center: "middle",
              right: "end"
            }[t.align];
          });
        });
      }

      function _(t) {
        return -1 !== t.indexOf(n.wrapSplitCharacter);
      }

      function w(t, e, r) {
        if (Array.isArray(t)) {
          var n = t[Math.min(e, t.length - 1)];
          return Array.isArray(n) ? n[Math.min(r, n.length - 1)] : n;
        }

        return t;
      }

      function T(t, e, r) {
        t.transition().ease(n.releaseTransitionEase).duration(n.releaseTransitionDuration).attr("transform", c(e.x, r));
      }

      function k(t) {
        return "cells" === t.type;
      }

      function M(t) {
        return "header" === t.type;
      }

      function A(t) {
        return (t.rowBlocks.length ? t.rowBlocks[0].auxiliaryBlocks : []).reduce(function (t, e) {
          return t + D(e, 1 / 0);
        }, 0);
      }

      function S(t, e, r) {
        var n = v(e)[0];

        if (void 0 !== n) {
          var i = n.rowBlocks,
              a = n.calcdata,
              o = z(i, i.length),
              s = n.calcdata.groupHeight - A(n),
              l = a.scrollY = Math.max(0, Math.min(o - s, a.scrollY)),
              u = function (t, e, r) {
            for (var n = [], i = 0, a = 0; a < t.length; a++) {
              for (var o = t[a], s = o.rows, l = 0, c = 0; c < s.length; c++) {
                l += s[c].rowHeight;
              }

              o.allRowsHeight = l;
              e < i + l && e + r > i && n.push(a), i += l;
            }

            return n;
          }(i, l, s);

          1 === u.length && (u[0] === i.length - 1 ? u.unshift(u[0] - 1) : u.push(u[0] + 1)), u[0] % 2 && u.reverse(), e.each(function (t, e) {
            t.page = u[e], t.scrollY = l;
          }), e.attr("transform", function (t) {
            var e = z(t.rowBlocks, t.page) - t.scrollY;
            return c(0, e);
          }), t && (L(t, r, e, u, n.prevPages, n, 0), L(t, r, e, u, n.prevPages, n, 1), y(r, t));
        }
      }

      function E(t, e, r, a) {
        return function (o) {
          var s = o.calcdata ? o.calcdata : o,
              l = e.filter(function (t) {
            return s.key === t.key;
          }),
              c = r || s.scrollbarState.dragMultiplier,
              u = s.scrollY;
          s.scrollY = void 0 === a ? s.scrollY + c * i.event.dy : a;
          var f = l.selectAll("." + n.cn.yColumn).selectAll("." + n.cn.columnBlock).filter(k);
          return S(t, f, l), s.scrollY === u;
        };
      }

      function L(t, e, r, n, i, a, o) {
        n[o] !== i[o] && (clearTimeout(a.currentRepaint[o]), a.currentRepaint[o] = setTimeout(function () {
          var a = r.filter(function (t, e) {
            return e === o && n[e] !== i[e];
          });
          x(t, e, a, r), i[o] = n[o];
        }));
      }

      function C(t, e, r, a) {
        return function () {
          var o = i.select(e.parentNode);
          o.each(function (t) {
            var e = t.fragments;
            o.selectAll("tspan.line").each(function (t, r) {
              e[r].width = this.getComputedTextLength();
            });
            var r,
                i,
                a = e[e.length - 1].width,
                s = e.slice(0, -1),
                l = [],
                c = 0,
                u = t.column.columnWidth - 2 * n.cellPad;

            for (t.value = ""; s.length;) {
              c + (i = (r = s.shift()).width + a) > u && (t.value += l.join(n.wrapSpacer) + n.lineBreaker, l = [], c = 0), l.push(r.text), c += i;
            }

            c && (t.value += l.join(n.wrapSpacer)), t.wrapped = !0;
          }), o.selectAll("tspan.line").remove(), b(o.select("." + n.cn.cellText), r, t, a), i.select(e.parentNode.parentNode).call(O);
        };
      }

      function P(t, e, r, a, o) {
        return function () {
          if (!o.settledY) {
            var s = i.select(e.parentNode),
                l = F(o),
                u = o.key - l.firstRowIndex,
                f = l.rows[u].rowHeight,
                h = o.cellHeightMayIncrease ? e.parentNode.getBoundingClientRect().height + 2 * n.cellPad : f,
                p = Math.max(h, f);
            p - l.rows[u].rowHeight && (l.rows[u].rowHeight = p, t.selectAll("." + n.cn.columnCell).call(O), S(null, t.filter(k), 0), y(r, a, !0)), s.attr("transform", function () {
              var t = this.parentNode.getBoundingClientRect(),
                  e = i.select(this.parentNode).select("." + n.cn.cellRect).node().getBoundingClientRect(),
                  r = this.transform.baseVal.consolidate(),
                  a = e.top - t.top + (r ? r.matrix.f : n.cellPad);
              return c(I(o, i.select(this.parentNode).select("." + n.cn.cellTextHolder).node().getBoundingClientRect().width), a);
            }), o.settledY = !0;
          }
        };
      }

      function I(t, e) {
        switch (t.align) {
          case "left":
            return n.cellPad;

          case "right":
            return t.column.columnWidth - (e || 0) - n.cellPad;

          case "center":
            return (t.column.columnWidth - (e || 0)) / 2;

          default:
            return n.cellPad;
        }
      }

      function O(t) {
        t.attr("transform", function (t) {
          var e = t.rowBlocks[0].auxiliaryBlocks.reduce(function (t, e) {
            return t + D(e, 1 / 0);
          }, 0),
              r = D(F(t), t.key);
          return c(0, r + e);
        }).selectAll("." + n.cn.cellRect).attr("height", function (t) {
          return (e = F(t), r = t.key, e.rows[r - e.firstRowIndex]).rowHeight;
          var e, r;
        });
      }

      function z(t, e) {
        for (var r = 0, n = e - 1; n >= 0; n--) {
          r += R(t[n]);
        }

        return r;
      }

      function D(t, e) {
        for (var r = 0, n = 0; n < t.rows.length && t.rows[n].rowIndex < e; n++) {
          r += t.rows[n].rowHeight;
        }

        return r;
      }

      function R(t) {
        var e = t.allRowsHeight;
        if (void 0 !== e) return e;

        for (var r = 0, n = 0; n < t.rows.length; n++) {
          r += t.rows[n].rowHeight;
        }

        return t.allRowsHeight = r, r;
      }

      function F(t) {
        return t.rowBlocks[t.page];
      }

      e.exports = function (t, e) {
        var r = !t._context.staticPlot,
            s = t._fullLayout._paper.selectAll("." + n.cn.table).data(e.map(function (e) {
          var r = a.unwrap(e).trace;
          return f(t, r);
        }), a.keyFun);

        s.exit().remove(), s.enter().append("g").classed(n.cn.table, !0).attr("overflow", "visible").style("box-sizing", "content-box").style("position", "absolute").style("left", 0).style("overflow", "visible").style("shape-rendering", "crispEdges").style("pointer-events", "all"), s.attr("width", function (t) {
          return t.width + t.size.l + t.size.r;
        }).attr("height", function (t) {
          return t.height + t.size.t + t.size.b;
        }).attr("transform", function (t) {
          return c(t.translateX, t.translateY);
        });
        var p = s.selectAll("." + n.cn.tableControlView).data(a.repeat, a.keyFun),
            b = p.enter().append("g").classed(n.cn.tableControlView, !0).style("box-sizing", "content-box");

        if (r) {
          var _ = "onwheel" in document ? "wheel" : "mousewheel";

          b.on("mousemove", function (e) {
            p.filter(function (t) {
              return e === t;
            }).call(y, t);
          }).on(_, function (e) {
            if (!e.scrollbarState.wheeling) {
              e.scrollbarState.wheeling = !0;
              var r = e.scrollY + i.event.deltaY;
              E(t, p, null, r)(e) || (i.event.stopPropagation(), i.event.preventDefault()), e.scrollbarState.wheeling = !1;
            }
          }).call(y, t, !0);
        }

        p.attr("transform", function (t) {
          return c(t.size.l, t.size.t);
        });
        var w = p.selectAll("." + n.cn.scrollBackground).data(a.repeat, a.keyFun);
        w.enter().append("rect").classed(n.cn.scrollBackground, !0).attr("fill", "none"), w.attr("width", function (t) {
          return t.width;
        }).attr("height", function (t) {
          return t.height;
        }), p.each(function (e) {
          o.setClipUrl(i.select(this), m(t, e), t);
        });
        var A = p.selectAll("." + n.cn.yColumn).data(function (t) {
          return t.columns;
        }, a.keyFun);
        A.enter().append("g").classed(n.cn.yColumn, !0), A.exit().remove(), A.attr("transform", function (t) {
          return c(t.x, 0);
        }), r && A.call(i.behavior.drag().origin(function (e) {
          return T(i.select(this), e, -n.uplift), l(this), e.calcdata.columnDragInProgress = !0, y(p.filter(function (t) {
            return e.calcdata.key === t.key;
          }), t), e;
        }).on("drag", function (t) {
          var e = i.select(this),
              r = function r(e) {
            return (t === e ? i.event.x : e.x) + e.columnWidth / 2;
          };

          t.x = Math.max(-n.overdrag, Math.min(t.calcdata.width + n.overdrag - t.columnWidth, i.event.x)), v(A).filter(function (e) {
            return e.calcdata.key === t.calcdata.key;
          }).sort(function (t, e) {
            return r(t) - r(e);
          }).forEach(function (e, r) {
            e.xIndex = r, e.x = t === e ? e.x : e.xScale(e);
          }), A.filter(function (e) {
            return t !== e;
          }).transition().ease(n.transitionEase).duration(n.transitionDuration).attr("transform", function (t) {
            return c(t.x, 0);
          }), e.call(u).attr("transform", c(t.x, -n.uplift));
        }).on("dragend", function (e) {
          var r = i.select(this),
              n = e.calcdata;
          e.x = e.xScale(e), e.calcdata.columnDragInProgress = !1, T(r, e, 0), function (t, e, r) {
            var n = e.gdColumnsOriginalOrder;
            e.gdColumns.sort(function (t, e) {
              return r[n.indexOf(t)] - r[n.indexOf(e)];
            }), e.columnorder = r, t.emit("plotly_restyle");
          }(t, n, n.columns.map(function (t) {
            return t.xIndex;
          }));
        })), A.each(function (e) {
          o.setClipUrl(i.select(this), g(t, e), t);
        });
        var L = A.selectAll("." + n.cn.columnBlock).data(h.splitToPanels, a.keyFun);
        L.enter().append("g").classed(n.cn.columnBlock, !0).attr("id", function (t) {
          return t.key;
        }), L.style("cursor", function (t) {
          return t.dragHandle ? "ew-resize" : t.calcdata.scrollbarState.barWiggleRoom ? "ns-resize" : "default";
        });
        var C = L.filter(M),
            P = L.filter(k);
        r && P.call(i.behavior.drag().origin(function (t) {
          return i.event.stopPropagation(), t;
        }).on("drag", E(t, p, -1)).on("dragend", function () {})), x(t, p, C, L), x(t, p, P, L);
        var I = p.selectAll("." + n.cn.scrollAreaClip).data(a.repeat, a.keyFun);
        I.enter().append("clipPath").classed(n.cn.scrollAreaClip, !0).attr("id", function (e) {
          return m(t, e);
        });
        var O = I.selectAll("." + n.cn.scrollAreaClipRect).data(a.repeat, a.keyFun);
        O.enter().append("rect").classed(n.cn.scrollAreaClipRect, !0).attr("x", -n.overdrag).attr("y", -n.uplift).attr("fill", "none"), O.attr("width", function (t) {
          return t.width + 2 * n.overdrag;
        }).attr("height", function (t) {
          return t.height + n.uplift;
        }), A.selectAll("." + n.cn.columnBoundary).data(a.repeat, a.keyFun).enter().append("g").classed(n.cn.columnBoundary, !0);
        var z = A.selectAll("." + n.cn.columnBoundaryClippath).data(a.repeat, a.keyFun);
        z.enter().append("clipPath").classed(n.cn.columnBoundaryClippath, !0), z.attr("id", function (e) {
          return g(t, e);
        });
        var D = z.selectAll("." + n.cn.columnBoundaryRect).data(a.repeat, a.keyFun);
        D.enter().append("rect").classed(n.cn.columnBoundaryRect, !0).attr("fill", "none"), D.attr("width", function (t) {
          return t.columnWidth + 2 * d(t);
        }).attr("height", function (t) {
          return t.calcdata.height + 2 * d(t) + n.uplift;
        }).attr("x", function (t) {
          return -d(t);
        }).attr("y", function (t) {
          return -d(t);
        }), S(null, P, p);
      };
    }, {
      "../../components/color": 658,
      "../../components/drawing": 680,
      "../../lib": 795,
      "../../lib/gup": 792,
      "../../lib/svg_text_utils": 820,
      "./constants": 1331,
      "./data_preparation_helper": 1332,
      "./data_split_helpers": 1333,
      "@plotly/d3": 57
    }],
    1337: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/template_attributes").hovertemplateAttrs,
          i = t("../../plots/template_attributes").texttemplateAttrs,
          a = t("../../components/colorscale/attributes"),
          o = t("../../plots/domain").attributes,
          s = t("../pie/attributes"),
          l = t("../sunburst/attributes"),
          c = t("./constants"),
          u = t("../../lib/extend").extendFlat;
      e.exports = {
        labels: l.labels,
        parents: l.parents,
        values: l.values,
        branchvalues: l.branchvalues,
        count: l.count,
        level: l.level,
        maxdepth: l.maxdepth,
        tiling: {
          packing: {
            valType: "enumerated",
            values: ["squarify", "binary", "dice", "slice", "slice-dice", "dice-slice"],
            dflt: "squarify",
            editType: "plot"
          },
          squarifyratio: {
            valType: "number",
            min: 1,
            dflt: 1,
            editType: "plot"
          },
          flip: {
            valType: "flaglist",
            flags: ["x", "y"],
            dflt: "",
            editType: "plot"
          },
          pad: {
            valType: "number",
            min: 0,
            dflt: 3,
            editType: "plot"
          },
          editType: "calc"
        },
        marker: u({
          pad: {
            t: {
              valType: "number",
              min: 0,
              editType: "plot"
            },
            l: {
              valType: "number",
              min: 0,
              editType: "plot"
            },
            r: {
              valType: "number",
              min: 0,
              editType: "plot"
            },
            b: {
              valType: "number",
              min: 0,
              editType: "plot"
            },
            editType: "calc"
          },
          colors: l.marker.colors,
          depthfade: {
            valType: "enumerated",
            values: [!0, !1, "reversed"],
            editType: "style"
          },
          line: l.marker.line,
          editType: "calc"
        }, a("marker", {
          colorAttr: "colors",
          anim: !1
        })),
        pathbar: {
          visible: {
            valType: "boolean",
            dflt: !0,
            editType: "plot"
          },
          side: {
            valType: "enumerated",
            values: ["top", "bottom"],
            dflt: "top",
            editType: "plot"
          },
          edgeshape: {
            valType: "enumerated",
            values: [">", "<", "|", "/", "\\"],
            dflt: ">",
            editType: "plot"
          },
          thickness: {
            valType: "number",
            min: 12,
            editType: "plot"
          },
          textfont: u({}, s.textfont, {}),
          editType: "calc"
        },
        text: s.text,
        textinfo: l.textinfo,
        texttemplate: i({
          editType: "plot"
        }, {
          keys: c.eventDataKeys.concat(["label", "value"])
        }),
        hovertext: s.hovertext,
        hoverinfo: l.hoverinfo,
        hovertemplate: n({}, {
          keys: c.eventDataKeys
        }),
        textfont: s.textfont,
        insidetextfont: s.insidetextfont,
        outsidetextfont: u({}, s.outsidetextfont, {}),
        textposition: {
          valType: "enumerated",
          values: ["top left", "top center", "top right", "middle left", "middle center", "middle right", "bottom left", "bottom center", "bottom right"],
          dflt: "top left",
          editType: "plot"
        },
        sort: s.sort,
        root: l.root,
        domain: o({
          name: "treemap",
          trace: !0,
          editType: "calc"
        })
      };
    }, {
      "../../components/colorscale/attributes": 665,
      "../../lib/extend": 785,
      "../../plots/domain": 872,
      "../../plots/template_attributes": 918,
      "../pie/attributes": 1173,
      "../sunburst/attributes": 1311,
      "./constants": 1340
    }],
    1338: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/plots");
      r.name = "treemap", r.plot = function (t, e, i, a) {
        n.plotBasePlot(r.name, t, e, i, a);
      }, r.clean = function (t, e, i, a) {
        n.cleanBasePlot(r.name, t, e, i, a);
      };
    }, {
      "../../plots/plots": 909
    }],
    1339: [function (t, e, r) {
      "use strict";

      var n = t("../sunburst/calc");
      r.calc = function (t, e) {
        return n.calc(t, e);
      }, r.crossTraceCalc = function (t) {
        return n._runCrossTraceCalc("treemap", t);
      };
    }, {
      "../sunburst/calc": 1313
    }],
    1340: [function (t, e, r) {
      "use strict";

      e.exports = {
        CLICK_TRANSITION_TIME: 750,
        CLICK_TRANSITION_EASING: "poly",
        eventDataKeys: ["currentPath", "root", "entry", "percentRoot", "percentEntry", "percentParent"],
        gapWithPathbar: 1
      };
    }, {}],
    1341: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./attributes"),
          a = t("../../components/color"),
          o = t("../../plots/domain").defaults,
          s = t("../bar/defaults").handleText,
          l = t("../bar/constants").TEXTPAD,
          c = t("../../components/colorscale"),
          u = c.hasColorscale,
          f = c.handleDefaults;

      e.exports = function (t, e, r, c) {
        function h(r, a) {
          return n.coerce(t, e, i, r, a);
        }

        var p = h("labels"),
            d = h("parents");

        if (p && p.length && d && d.length) {
          var m = h("values");
          m && m.length ? h("branchvalues") : h("count"), h("level"), h("maxdepth"), "squarify" === h("tiling.packing") && h("tiling.squarifyratio"), h("tiling.flip"), h("tiling.pad");
          var g = h("text");
          h("texttemplate"), e.texttemplate || h("textinfo", Array.isArray(g) ? "text+label" : "label"), h("hovertext"), h("hovertemplate");
          var v = h("pathbar.visible");
          s(t, e, c, h, "auto", {
            hasPathbar: v,
            moduleHasSelected: !1,
            moduleHasUnselected: !1,
            moduleHasConstrain: !1,
            moduleHasCliponaxis: !1,
            moduleHasTextangle: !1,
            moduleHasInsideanchor: !1
          }), h("textposition");
          var y = -1 !== e.textposition.indexOf("bottom");
          h("marker.line.width") && h("marker.line.color", c.paper_bgcolor);
          var x = h("marker.colors");
          (e._hasColorscale = u(t, "marker", "colors") || (t.marker || {}).coloraxis) ? f(t, e, c, h, {
            prefix: "marker.",
            cLetter: "c"
          }) : h("marker.depthfade", !(x || []).length);
          var b = 2 * e.textfont.size;
          h("marker.pad.t", y ? b / 4 : b), h("marker.pad.l", b / 4), h("marker.pad.r", b / 4), h("marker.pad.b", y ? b : b / 4), e._hovered = {
            marker: {
              line: {
                width: 2,
                color: a.contrast(c.paper_bgcolor)
              }
            }
          }, v && (h("pathbar.thickness", e.pathbar.textfont.size + 2 * l), h("pathbar.side"), h("pathbar.edgeshape")), h("sort"), h("root.color"), o(e, c, h), e._length = null;
        } else e.visible = !1;
      };
    }, {
      "../../components/color": 658,
      "../../components/colorscale": 670,
      "../../lib": 795,
      "../../plots/domain": 872,
      "../bar/constants": 935,
      "../bar/defaults": 937,
      "./attributes": 1337
    }],
    1342: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../lib"),
          a = t("../../components/drawing"),
          o = t("../../lib/svg_text_utils"),
          s = t("./partition"),
          l = t("./style").styleOne,
          c = t("./constants"),
          u = t("../sunburst/helpers"),
          f = t("../sunburst/fx");

      e.exports = function (t, e, r, h, p) {
        var d = p.barDifY,
            m = p.width,
            g = p.height,
            v = p.viewX,
            y = p.viewY,
            x = p.pathSlice,
            b = p.toMoveInsideSlice,
            _ = p.strTransform,
            w = p.hasTransition,
            T = p.handleSlicesExit,
            k = p.makeUpdateSliceInterpolator,
            M = p.makeUpdateTextInterpolator,
            A = {},
            S = t._fullLayout,
            E = e[0],
            L = E.trace,
            C = E.hierarchy,
            P = m / L._entryDepth,
            I = u.listPath(r.data, "id"),
            O = s(C.copy(), [m, g], {
          packing: "dice",
          pad: {
            inner: 0,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
          }
        }).descendants();
        (O = O.filter(function (t) {
          var e = I.indexOf(t.data.id);
          return -1 !== e && (t.x0 = P * e, t.x1 = P * (e + 1), t.y0 = d, t.y1 = d + g, t.onPathbar = !0, !0);
        })).reverse(), (h = h.data(O, u.getPtId)).enter().append("g").classed("pathbar", !0), T(h, !0, A, [m, g], x), h.order();
        var z = h;
        w && (z = z.transition().each("end", function () {
          var e = n.select(this);
          u.setSliceCursor(e, t, {
            hideOnRoot: !1,
            hideOnLeaves: !1,
            isTransitioning: !1
          });
        })), z.each(function (s) {
          s._hoverX = v(s.x1 - Math.min(m, g) / 2), s._hoverY = y(s.y1 - g / 2);
          var h = n.select(this),
              p = i.ensureSingle(h, "path", "surface", function (t) {
            t.style("pointer-events", "all");
          });
          w ? p.transition().attrTween("d", function (t) {
            var e = k(t, !0, A, [m, g]);
            return function (t) {
              return x(e(t));
            };
          }) : p.attr("d", x), h.call(f, r, t, e, {
            styleOne: l,
            eventDataKeys: c.eventDataKeys,
            transitionTime: c.CLICK_TRANSITION_TIME,
            transitionEasing: c.CLICK_TRANSITION_EASING
          }).call(u.setSliceCursor, t, {
            hideOnRoot: !1,
            hideOnLeaves: !1,
            isTransitioning: t._transitioning
          }), p.call(l, s, L, {
            hovered: !1
          }), s._text = (u.getPtLabel(s) || "").split("<br>").join(" ") || "";
          var d = i.ensureSingle(h, "g", "slicetext"),
              T = i.ensureSingle(d, "text", "", function (t) {
            t.attr("data-notex", 1);
          }),
              E = i.ensureUniformFontSize(t, u.determineTextFont(L, s, S.font, {
            onPathbar: !0
          }));
          T.text(s._text || " ").classed("slicetext", !0).attr("text-anchor", "start").call(a.font, E).call(o.convertToTspans, t), s.textBB = a.bBox(T.node()), s.transform = b(s, {
            fontSize: E.size,
            onPathbar: !0
          }), s.transform.fontSize = E.size, w ? T.transition().attrTween("transform", function (t) {
            var e = M(t, !0, A, [m, g]);
            return function (t) {
              return _(e(t));
            };
          }) : T.attr("transform", _(s));
        });
      };
    }, {
      "../../components/drawing": 680,
      "../../lib": 795,
      "../../lib/svg_text_utils": 820,
      "../sunburst/fx": 1316,
      "../sunburst/helpers": 1317,
      "./constants": 1340,
      "./partition": 1347,
      "./style": 1349,
      "@plotly/d3": 57
    }],
    1343: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../lib"),
          a = t("../../components/drawing"),
          o = t("../../lib/svg_text_utils"),
          s = t("./partition"),
          l = t("./style").styleOne,
          c = t("./constants"),
          u = t("../sunburst/helpers"),
          f = t("../sunburst/fx"),
          h = t("../sunburst/plot").formatSliceLabel;

      e.exports = function (t, e, r, p, d) {
        var m = d.width,
            g = d.height,
            v = d.viewX,
            y = d.viewY,
            x = d.pathSlice,
            b = d.toMoveInsideSlice,
            _ = d.strTransform,
            w = d.hasTransition,
            T = d.handleSlicesExit,
            k = d.makeUpdateSliceInterpolator,
            M = d.makeUpdateTextInterpolator,
            A = d.prevEntry,
            S = t._fullLayout,
            E = e[0].trace,
            L = -1 !== E.textposition.indexOf("left"),
            C = -1 !== E.textposition.indexOf("right"),
            P = -1 !== E.textposition.indexOf("bottom"),
            I = !P && !E.marker.pad.t || P && !E.marker.pad.b,
            O = s(r, [m, g], {
          packing: E.tiling.packing,
          squarifyratio: E.tiling.squarifyratio,
          flipX: E.tiling.flip.indexOf("x") > -1,
          flipY: E.tiling.flip.indexOf("y") > -1,
          pad: {
            inner: E.tiling.pad,
            top: E.marker.pad.t,
            left: E.marker.pad.l,
            right: E.marker.pad.r,
            bottom: E.marker.pad.b
          }
        }).descendants(),
            z = 1 / 0,
            D = -1 / 0;
        O.forEach(function (t) {
          var e = t.depth;
          e >= E._maxDepth ? (t.x0 = t.x1 = (t.x0 + t.x1) / 2, t.y0 = t.y1 = (t.y0 + t.y1) / 2) : (z = Math.min(z, e), D = Math.max(D, e));
        }), p = p.data(O, u.getPtId), E._maxVisibleLayers = isFinite(D) ? D - z + 1 : 0, p.enter().append("g").classed("slice", !0), T(p, !1, {}, [m, g], x), p.order();
        var R = null;

        if (w && A) {
          var F = u.getPtId(A);
          p.each(function (t) {
            null === R && u.getPtId(t) === F && (R = {
              x0: t.x0,
              x1: t.x1,
              y0: t.y0,
              y1: t.y1
            });
          });
        }

        var B = function B() {
          return R || {
            x0: 0,
            x1: m,
            y0: 0,
            y1: g
          };
        },
            N = p;

        return w && (N = N.transition().each("end", function () {
          var e = n.select(this);
          u.setSliceCursor(e, t, {
            hideOnRoot: !0,
            hideOnLeaves: !1,
            isTransitioning: !1
          });
        })), N.each(function (s) {
          var p = u.isHeader(s, E);
          s._hoverX = v(s.x1 - E.marker.pad.r), s._hoverY = y(P ? s.y1 - E.marker.pad.b / 2 : s.y0 + E.marker.pad.t / 2);
          var d = n.select(this),
              T = i.ensureSingle(d, "path", "surface", function (t) {
            t.style("pointer-events", "all");
          });
          w ? T.transition().attrTween("d", function (t) {
            var e = k(t, !1, B(), [m, g]);
            return function (t) {
              return x(e(t));
            };
          }) : T.attr("d", x), d.call(f, r, t, e, {
            styleOne: l,
            eventDataKeys: c.eventDataKeys,
            transitionTime: c.CLICK_TRANSITION_TIME,
            transitionEasing: c.CLICK_TRANSITION_EASING
          }).call(u.setSliceCursor, t, {
            isTransitioning: t._transitioning
          }), T.call(l, s, E, {
            hovered: !1
          }), s.x0 === s.x1 || s.y0 === s.y1 ? s._text = "" : s._text = p ? I ? "" : u.getPtLabel(s) || "" : h(s, r, E, e, S) || "";
          var A = i.ensureSingle(d, "g", "slicetext"),
              O = i.ensureSingle(A, "text", "", function (t) {
            t.attr("data-notex", 1);
          }),
              z = i.ensureUniformFontSize(t, u.determineTextFont(E, s, S.font));
          O.text(s._text || " ").classed("slicetext", !0).attr("text-anchor", C ? "end" : L || p ? "start" : "middle").call(a.font, z).call(o.convertToTspans, t), s.textBB = a.bBox(O.node()), s.transform = b(s, {
            fontSize: z.size,
            isHeader: p
          }), s.transform.fontSize = z.size, w ? O.transition().attrTween("transform", function (t) {
            var e = M(t, !1, B(), [m, g]);
            return function (t) {
              return _(e(t));
            };
          }) : O.attr("transform", _(s));
        }), R;
      };
    }, {
      "../../components/drawing": 680,
      "../../lib": 795,
      "../../lib/svg_text_utils": 820,
      "../sunburst/fx": 1316,
      "../sunburst/helpers": 1317,
      "../sunburst/plot": 1321,
      "./constants": 1340,
      "./partition": 1347,
      "./style": 1349,
      "@plotly/d3": 57
    }],
    1344: [function (t, e, r) {
      "use strict";

      e.exports = {
        moduleType: "trace",
        name: "treemap",
        basePlotModule: t("./base_plot"),
        categories: [],
        animatable: !0,
        attributes: t("./attributes"),
        layoutAttributes: t("./layout_attributes"),
        supplyDefaults: t("./defaults"),
        supplyLayoutDefaults: t("./layout_defaults"),
        calc: t("./calc").calc,
        crossTraceCalc: t("./calc").crossTraceCalc,
        plot: t("./plot"),
        style: t("./style").style,
        colorbar: t("../scatter/marker_colorbar"),
        meta: {}
      };
    }, {
      "../scatter/marker_colorbar": 1217,
      "./attributes": 1337,
      "./base_plot": 1338,
      "./calc": 1339,
      "./defaults": 1341,
      "./layout_attributes": 1345,
      "./layout_defaults": 1346,
      "./plot": 1348,
      "./style": 1349
    }],
    1345: [function (t, e, r) {
      "use strict";

      e.exports = {
        treemapcolorway: {
          valType: "colorlist",
          editType: "calc"
        },
        extendtreemapcolors: {
          valType: "boolean",
          dflt: !0,
          editType: "calc"
        }
      };
    }, {}],
    1346: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./layout_attributes");

      e.exports = function (t, e) {
        function r(r, a) {
          return n.coerce(t, e, i, r, a);
        }

        r("treemapcolorway", e.colorway), r("extendtreemapcolors");
      };
    }, {
      "../../lib": 795,
      "./layout_attributes": 1345
    }],
    1347: [function (t, e, r) {
      "use strict";

      var n = t("d3-hierarchy");

      e.exports = function (t, e, r) {
        var i,
            a = r.flipX,
            o = r.flipY,
            s = "dice-slice" === r.packing,
            l = r.pad[o ? "bottom" : "top"],
            c = r.pad[a ? "right" : "left"],
            u = r.pad[a ? "left" : "right"],
            f = r.pad[o ? "top" : "bottom"];
        s && (i = c, c = l, l = i, i = u, u = f, f = i);
        var h = n.treemap().tile(function (t, e) {
          switch (t) {
            case "squarify":
              return n.treemapSquarify.ratio(e);

            case "binary":
              return n.treemapBinary;

            case "dice":
              return n.treemapDice;

            case "slice":
              return n.treemapSlice;

            default:
              return n.treemapSliceDice;
          }
        }(r.packing, r.squarifyratio)).paddingInner(r.pad.inner).paddingLeft(c).paddingRight(u).paddingTop(l).paddingBottom(f).size(s ? [e[1], e[0]] : e)(t);
        return (s || a || o) && function t(e, r, n) {
          var i;
          n.swapXY && (i = e.x0, e.x0 = e.y0, e.y0 = i, i = e.x1, e.x1 = e.y1, e.y1 = i);
          n.flipX && (i = e.x0, e.x0 = r[0] - e.x1, e.x1 = r[0] - i);
          n.flipY && (i = e.y0, e.y0 = r[1] - e.y1, e.y1 = r[1] - i);
          var a = e.children;
          if (a) for (var o = 0; o < a.length; o++) {
            t(a[o], r, n);
          }
        }(h, e, {
          swapXY: s,
          flipX: a,
          flipY: o
        }), h;
      };
    }, {
      "d3-hierarchy": 162
    }],
    1348: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../sunburst/helpers"),
          a = t("../../lib"),
          o = t("../bar/constants").TEXTPAD,
          s = t("../bar/plot").toMoveInsideBar,
          l = t("../bar/uniform_text"),
          c = l.recordMinTextSize,
          u = l.clearMinTextSize,
          f = t("../bar/style").resizeText,
          h = t("./constants"),
          p = t("./draw_descendants"),
          d = t("./draw_ancestors");

      function m(t) {
        return i.isHierarchyRoot(t) ? "" : i.getPtId(t);
      }

      function g(t, e, r, l) {
        var u = t._fullLayout,
            f = e[0],
            g = f.trace,
            v = f.hierarchy,
            y = i.findEntryWithLevel(v, g.level),
            x = n.select(r),
            b = x.selectAll("g.pathbar"),
            _ = x.selectAll("g.slice");

        if (!y) return b.remove(), void _.remove();

        var w = i.isHierarchyRoot(y),
            T = !u.uniformtext.mode && i.hasTransition(l),
            k = i.getMaxDepth(g),
            M = u._size,
            A = g.domain,
            S = M.w * (A.x[1] - A.x[0]),
            E = M.h * (A.y[1] - A.y[0]),
            L = S,
            C = g.pathbar.thickness,
            P = g.marker.line.width + h.gapWithPathbar,
            I = g.pathbar.visible ? g.pathbar.side.indexOf("bottom") > -1 ? E + P : -(C + P) : 0,
            O = {
          x0: L,
          x1: L,
          y0: I,
          y1: I + C
        },
            z = function z(t, e, r) {
          var n = g.tiling.pad,
              i = function i(t) {
            return t - n <= e.x0;
          },
              a = function a(t) {
            return t + n >= e.x1;
          },
              o = function o(t) {
            return t - n <= e.y0;
          },
              s = function s(t) {
            return t + n >= e.y1;
          };

          return {
            x0: i(t.x0 - n) ? 0 : a(t.x0 - n) ? r[0] : t.x0,
            x1: i(t.x1 + n) ? 0 : a(t.x1 + n) ? r[0] : t.x1,
            y0: o(t.y0 - n) ? 0 : s(t.y0 - n) ? r[1] : t.y0,
            y1: o(t.y1 + n) ? 0 : s(t.y1 + n) ? r[1] : t.y1
          };
        },
            D = null,
            R = {},
            F = {},
            B = null,
            N = function N(t, e) {
          return e ? R[m(t)] : F[m(t)];
        },
            j = function j(t, e, r, n) {
          if (e) return R[m(v)] || O;
          var i = F[g.level] || r;
          return function (t) {
            return t.data.depth - y.data.depth < k;
          }(t) ? z(t, i, n) : {};
        };

        f.hasMultipleRoots && w && k++, g._maxDepth = k, g._backgroundColor = u.paper_bgcolor, g._entryDepth = y.data.depth, g._atRootLevel = w;

        var U = -S / 2 + M.l + M.w * (A.x[1] + A.x[0]) / 2,
            V = -E / 2 + M.t + M.h * (1 - (A.y[1] + A.y[0]) / 2),
            q = function q(t) {
          return U + t;
        },
            H = function H(t) {
          return V + t;
        },
            G = H(0),
            Y = q(0),
            W = function W(t) {
          return Y + t;
        },
            X = function X(t) {
          return G + t;
        };

        function Z(t, e) {
          return t + "," + e;
        }

        var J = W(0),
            K = function K(t) {
          t.x = Math.max(J, t.x);
        },
            Q = g.pathbar.edgeshape,
            $ = function $(t, e) {
          var r = t.x0,
              n = t.x1,
              i = t.y0,
              a = t.y1,
              l = t.textBB,
              f = function f(t) {
            return -1 !== g.textposition.indexOf(t);
          },
              h = f("bottom"),
              p = f("top") || e.isHeader && !h ? "start" : h ? "end" : "middle",
              d = f("right"),
              m = f("left") || e.onPathbar ? -1 : d ? 1 : 0,
              v = g.marker.pad;

          if (e.isHeader) {
            if ((r += v.l - o) >= (n -= v.r - o)) {
              var y = (r + n) / 2;
              r = y, n = y;
            }

            var x;
            h ? i < (x = a - v.b) && x < a && (i = x) : i < (x = i + v.t) && x < a && (a = x);
          }

          var b = s(r, n, i, a, l, {
            isHorizontal: !1,
            constrained: !0,
            angle: 0,
            anchor: p,
            leftToRight: m
          });
          return b.fontSize = e.fontSize, b.targetX = q(b.targetX), b.targetY = H(b.targetY), isNaN(b.targetX) || isNaN(b.targetY) ? {} : (r !== n && i !== a && c(g.type, b, u), {
            scale: b.scale,
            rotate: b.rotate,
            textX: b.textX,
            textY: b.textY,
            anchorX: b.anchorX,
            anchorY: b.anchorY,
            targetX: b.targetX,
            targetY: b.targetY
          });
        },
            tt = function tt(t, e) {
          for (var r, n = 0, i = t; !r && n < k;) {
            n++, (i = i.parent) ? r = N(i, e) : n = k;
          }

          return r || {};
        },
            et = function et(t, e, r, i) {
          var o,
              s = N(t, e);
          if (s) o = s;else if (e) o = O;else if (D) {
            if (t.parent) {
              var l = B || r;
              l && !e ? o = z(t, l, i) : (o = {}, a.extendFlat(o, tt(t, e)));
            } else o = t;
          } else o = {};
          return n.interpolate(o, {
            x0: t.x0,
            x1: t.x1,
            y0: t.y0,
            y1: t.y1
          });
        },
            rt = function rt(t, e, r, o) {
          var s = N(t, e),
              l = {},
              f = j(t, e, r, o);
          a.extendFlat(l, {
            transform: $({
              x0: f.x0,
              x1: f.x1,
              y0: f.y0,
              y1: f.y1,
              textBB: t.textBB,
              _text: t._text
            }, {
              isHeader: i.isHeader(t, g)
            })
          }), s ? l = s : t.parent && a.extendFlat(l, tt(t, e));
          var h = t.transform;
          return t.x0 !== t.x1 && t.y0 !== t.y1 && c(g.type, h, u), n.interpolate(l, {
            transform: {
              scale: h.scale,
              rotate: h.rotate,
              textX: h.textX,
              textY: h.textY,
              anchorX: h.anchorX,
              anchorY: h.anchorY,
              targetX: h.targetX,
              targetY: h.targetY
            }
          });
        },
            nt = function nt(t, e, r, i, a) {
          var o = i[0],
              s = i[1];
          T ? t.exit().transition().each(function () {
            var t = n.select(this);
            t.select("path.surface").transition().attrTween("d", function (t) {
              var r = function (t, e, r, i) {
                var a,
                    o = N(t, e);
                if (e) a = O;else {
                  var s = N(y, e);
                  a = s ? z(t, s, i) : {};
                }
                return n.interpolate(o, a);
              }(t, e, 0, [o, s]);

              return function (t) {
                return a(r(t));
              };
            }), t.select("g.slicetext").attr("opacity", 0);
          }).remove() : t.exit().remove();
        },
            it = function it(t) {
          var e = t.transform;
          return t.x0 !== t.x1 && t.y0 !== t.y1 && c(g.type, e, u), a.getTextTransform({
            textX: e.textX,
            textY: e.textY,
            anchorX: e.anchorX,
            anchorY: e.anchorY,
            targetX: e.targetX,
            targetY: e.targetY,
            scale: e.scale,
            rotate: e.rotate
          });
        };

        T && (b.each(function (t) {
          R[m(t)] = {
            x0: t.x0,
            x1: t.x1,
            y0: t.y0,
            y1: t.y1
          }, t.transform && (R[m(t)].transform = {
            textX: t.transform.textX,
            textY: t.transform.textY,
            anchorX: t.transform.anchorX,
            anchorY: t.transform.anchorY,
            targetX: t.transform.targetX,
            targetY: t.transform.targetY,
            scale: t.transform.scale,
            rotate: t.transform.rotate
          });
        }), _.each(function (t) {
          F[m(t)] = {
            x0: t.x0,
            x1: t.x1,
            y0: t.y0,
            y1: t.y1
          }, t.transform && (F[m(t)].transform = {
            textX: t.transform.textX,
            textY: t.transform.textY,
            anchorX: t.transform.anchorX,
            anchorY: t.transform.anchorY,
            targetX: t.transform.targetX,
            targetY: t.transform.targetY,
            scale: t.transform.scale,
            rotate: t.transform.rotate
          }), !D && i.isEntry(t) && (D = t);
        })), B = p(t, e, y, _, {
          width: S,
          height: E,
          viewX: q,
          viewY: H,
          pathSlice: function pathSlice(t) {
            var e = q(t.x0),
                r = q(t.x1),
                n = H(t.y0),
                i = H(t.y1),
                a = r - e,
                o = i - n;
            if (!a || !o) return "";
            return "M" + Z(e, n + 0) + "L" + Z(r - 0, n) + "L" + Z(r, i - 0) + "L" + Z(e + 0, i) + "Z";
          },
          toMoveInsideSlice: $,
          prevEntry: D,
          makeUpdateSliceInterpolator: et,
          makeUpdateTextInterpolator: rt,
          handleSlicesExit: nt,
          hasTransition: T,
          strTransform: it
        }), g.pathbar.visible ? d(t, e, y, b, {
          barDifY: I,
          width: L,
          height: C,
          viewX: W,
          viewY: X,
          pathSlice: function pathSlice(t) {
            var e = W(Math.max(Math.min(t.x0, t.x0), 0)),
                r = W(Math.min(Math.max(t.x1, t.x1), L)),
                n = X(t.y0),
                i = X(t.y1),
                a = C / 2,
                o = {},
                s = {};
            o.x = e, s.x = r, o.y = s.y = (n + i) / 2;
            var l = {
              x: e,
              y: n
            },
                c = {
              x: r,
              y: n
            },
                u = {
              x: r,
              y: i
            },
                f = {
              x: e,
              y: i
            };
            return ">" === Q ? (l.x -= a, c.x -= a, u.x -= a, f.x -= a) : "/" === Q ? (u.x -= a, f.x -= a, o.x -= a / 2, s.x -= a / 2) : "\\" === Q ? (l.x -= a, c.x -= a, o.x -= a / 2, s.x -= a / 2) : "<" === Q && (o.x -= a, s.x -= a), K(l), K(f), K(o), K(c), K(u), K(s), "M" + Z(l.x, l.y) + "L" + Z(c.x, c.y) + "L" + Z(s.x, s.y) + "L" + Z(u.x, u.y) + "L" + Z(f.x, f.y) + "L" + Z(o.x, o.y) + "Z";
          },
          toMoveInsideSlice: $,
          makeUpdateSliceInterpolator: et,
          makeUpdateTextInterpolator: rt,
          handleSlicesExit: nt,
          hasTransition: T,
          strTransform: it
        }) : b.remove();
      }

      e.exports = function (t, e, r, a) {
        var o,
            s,
            l = t._fullLayout,
            c = l._treemaplayer,
            h = !r;
        (u("treemap", l), (o = c.selectAll("g.trace.treemap").data(e, function (t) {
          return t[0].trace.uid;
        })).enter().append("g").classed("trace", !0).classed("treemap", !0), o.order(), !l.uniformtext.mode && i.hasTransition(r)) ? (a && (s = a()), n.transition().duration(r.duration).ease(r.easing).each("end", function () {
          s && s();
        }).each("interrupt", function () {
          s && s();
        }).each(function () {
          c.selectAll("g.trace").each(function (e) {
            g(t, e, this, r);
          });
        })) : (o.each(function (e) {
          g(t, e, this, r);
        }), l.uniformtext.mode && f(t, l._treemaplayer.selectAll(".trace"), "treemap"));
        h && o.exit().remove();
      };
    }, {
      "../../lib": 795,
      "../bar/constants": 935,
      "../bar/plot": 944,
      "../bar/style": 947,
      "../bar/uniform_text": 949,
      "../sunburst/helpers": 1317,
      "./constants": 1340,
      "./draw_ancestors": 1342,
      "./draw_descendants": 1343,
      "@plotly/d3": 57
    }],
    1349: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../components/color"),
          a = t("../../lib"),
          o = t("../sunburst/helpers"),
          s = t("../bar/uniform_text").resizeText;

      function l(t, e, r, n) {
        var s,
            l,
            c = (n || {}).hovered,
            u = e.data.data,
            f = u.i,
            h = u.color,
            p = o.isHierarchyRoot(e),
            d = 1;
        if (c) s = r._hovered.marker.line.color, l = r._hovered.marker.line.width;else if (p && h === r.root.color) d = 100, s = "rgba(0,0,0,0)", l = 0;else if (s = a.castOption(r, f, "marker.line.color") || i.defaultLine, l = a.castOption(r, f, "marker.line.width") || 0, !r._hasColorscale && !e.onPathbar) {
          var m = r.marker.depthfade;

          if (m) {
            var g,
                v = i.combine(i.addOpacity(r._backgroundColor, .75), h);

            if (!0 === m) {
              var y = o.getMaxDepth(r);
              g = isFinite(y) ? o.isLeaf(e) ? 0 : r._maxVisibleLayers - (e.data.depth - r._entryDepth) : e.data.height + 1;
            } else g = e.data.depth - r._entryDepth, r._atRootLevel || g++;

            if (g > 0) for (var x = 0; x < g; x++) {
              var b = .5 * x / g;
              h = i.combine(i.addOpacity(v, b), h);
            }
          }
        }
        t.style("stroke-width", l).call(i.fill, h).call(i.stroke, s).style("opacity", d);
      }

      e.exports = {
        style: function style(t) {
          var e = t._fullLayout._treemaplayer.selectAll(".trace");

          s(t, e, "treemap"), e.each(function (t) {
            var e = n.select(this),
                r = t[0].trace;
            e.style("opacity", r.opacity), e.selectAll("path.surface").each(function (t) {
              n.select(this).call(l, t, r, {
                hovered: !1
              });
            });
          });
        },
        styleOne: l
      };
    }, {
      "../../components/color": 658,
      "../../lib": 795,
      "../bar/uniform_text": 949,
      "../sunburst/helpers": 1317,
      "@plotly/d3": 57
    }],
    1350: [function (t, e, r) {
      "use strict";

      var n = t("../box/attributes"),
          i = t("../../lib/extend").extendFlat,
          a = t("../../plots/hoverformat_attributes");
      e.exports = {
        y: n.y,
        x: n.x,
        x0: n.x0,
        y0: n.y0,
        xhoverformat: a("x"),
        yhoverformat: a("y"),
        name: i({}, n.name, {}),
        orientation: i({}, n.orientation, {}),
        bandwidth: {
          valType: "number",
          min: 0,
          editType: "calc"
        },
        scalegroup: {
          valType: "string",
          dflt: "",
          editType: "calc"
        },
        scalemode: {
          valType: "enumerated",
          values: ["width", "count"],
          dflt: "width",
          editType: "calc"
        },
        spanmode: {
          valType: "enumerated",
          values: ["soft", "hard", "manual"],
          dflt: "soft",
          editType: "calc"
        },
        span: {
          valType: "info_array",
          items: [{
            valType: "any",
            editType: "calc"
          }, {
            valType: "any",
            editType: "calc"
          }],
          editType: "calc"
        },
        line: {
          color: {
            valType: "color",
            editType: "style"
          },
          width: {
            valType: "number",
            min: 0,
            dflt: 2,
            editType: "style"
          },
          editType: "plot"
        },
        fillcolor: n.fillcolor,
        points: i({}, n.boxpoints, {}),
        jitter: i({}, n.jitter, {}),
        pointpos: i({}, n.pointpos, {}),
        width: i({}, n.width, {}),
        marker: n.marker,
        text: n.text,
        hovertext: n.hovertext,
        hovertemplate: n.hovertemplate,
        box: {
          visible: {
            valType: "boolean",
            dflt: !1,
            editType: "plot"
          },
          width: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: .25,
            editType: "plot"
          },
          fillcolor: {
            valType: "color",
            editType: "style"
          },
          line: {
            color: {
              valType: "color",
              editType: "style"
            },
            width: {
              valType: "number",
              min: 0,
              editType: "style"
            },
            editType: "style"
          },
          editType: "plot"
        },
        meanline: {
          visible: {
            valType: "boolean",
            dflt: !1,
            editType: "plot"
          },
          color: {
            valType: "color",
            editType: "style"
          },
          width: {
            valType: "number",
            min: 0,
            editType: "style"
          },
          editType: "plot"
        },
        side: {
          valType: "enumerated",
          values: ["both", "positive", "negative"],
          dflt: "both",
          editType: "calc"
        },
        offsetgroup: n.offsetgroup,
        alignmentgroup: n.alignmentgroup,
        selected: n.selected,
        unselected: n.unselected,
        hoveron: {
          valType: "flaglist",
          flags: ["violins", "points", "kde"],
          dflt: "violins+points+kde",
          extras: ["all"],
          editType: "style"
        }
      };
    }, {
      "../../lib/extend": 785,
      "../../plots/hoverformat_attributes": 899,
      "../box/attributes": 958
    }],
    1351: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../plots/cartesian/axes"),
          a = t("../box/calc"),
          o = t("./helpers"),
          s = t("../../constants/numerical").BADNUM;

      function l(t, e, r) {
        var i = e.max - e.min;
        if (!i) return t.bandwidth ? t.bandwidth : 0;
        if (t.bandwidth) return Math.max(t.bandwidth, i / 1e4);
        var a = r.length,
            o = n.stdev(r, a - 1, e.mean);
        return Math.max(function (t, e, r) {
          return 1.059 * Math.min(e, r / 1.349) * Math.pow(t, -.2);
        }(a, o, e.q3 - e.q1), i / 100);
      }

      function c(t, e, r, n) {
        var a,
            o = t.spanmode,
            l = t.span || [],
            c = [e.min, e.max],
            u = [e.min - 2 * n, e.max + 2 * n];

        function f(n) {
          var i = l[n],
              a = "multicategory" === r.type ? r.r2c(i) : r.d2c(i, 0, t[e.valLetter + "calendar"]);
          return a === s ? u[n] : a;
        }

        var h = {
          type: "linear",
          range: a = "soft" === o ? u : "hard" === o ? c : [f(0), f(1)]
        };
        return i.setConvert(h), h.cleanRange(), a;
      }

      e.exports = function (t, e) {
        var r = a(t, e);
        if (r[0].t.empty) return r;

        for (var s = t._fullLayout, u = i.getFromId(t, e["h" === e.orientation ? "xaxis" : "yaxis"]), f = 1 / 0, h = -1 / 0, p = 0, d = 0, m = 0; m < r.length; m++) {
          var g = r[m],
              v = g.pts.map(o.extractVal),
              y = g.bandwidth = l(e, g, v),
              x = g.span = c(e, g, u, y);
          if (g.min === g.max && 0 === y) x = g.span = [g.min, g.max], g.density = [{
            v: 1,
            t: x[0]
          }], g.bandwidth = y, p = Math.max(p, 1);else {
            var b = x[1] - x[0],
                _ = Math.ceil(b / (y / 3)),
                w = b / _;

            if (!isFinite(w) || !isFinite(_)) return n.error("Something went wrong with computing the violin span"), r[0].t.empty = !0, r;
            var T = o.makeKDE(g, e, v);
            g.density = new Array(_);

            for (var k = 0, M = x[0]; M < x[1] + w / 2; k++, M += w) {
              var A = T(M);
              g.density[k] = {
                v: A,
                t: M
              }, p = Math.max(p, A);
            }
          }
          d = Math.max(d, v.length), f = Math.min(f, x[0]), h = Math.max(h, x[1]);
        }

        var S = i.findExtremes(u, [f, h], {
          padded: !0
        });
        if (e._extremes[u._id] = S, e.width) r[0].t.maxKDE = p;else {
          var E = s._violinScaleGroupStats,
              L = e.scalegroup,
              C = E[L];
          C ? (C.maxKDE = Math.max(C.maxKDE, p), C.maxCount = Math.max(C.maxCount, d)) : E[L] = {
            maxKDE: p,
            maxCount: d
          };
        }
        return r[0].t.labels.kde = n._(t, "kde:"), r;
      };
    }, {
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../../plots/cartesian/axes": 845,
      "../box/calc": 959,
      "./helpers": 1354
    }],
    1352: [function (t, e, r) {
      "use strict";

      var n = t("../box/cross_trace_calc").setPositionOffset,
          i = ["v", "h"];

      e.exports = function (t, e) {
        for (var r = t.calcdata, a = e.xaxis, o = e.yaxis, s = 0; s < i.length; s++) {
          for (var l = i[s], c = "h" === l ? o : a, u = [], f = 0; f < r.length; f++) {
            var h = r[f],
                p = h[0].t,
                d = h[0].trace;
            !0 !== d.visible || "violin" !== d.type || p.empty || d.orientation !== l || d.xaxis !== a._id || d.yaxis !== o._id || u.push(f);
          }

          n("violin", t, u, c);
        }
      };
    }, {
      "../box/cross_trace_calc": 960
    }],
    1353: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../components/color"),
          a = t("../box/defaults"),
          o = t("./attributes");

      e.exports = function (t, e, r, s) {
        function l(r, i) {
          return n.coerce(t, e, o, r, i);
        }

        function c(r, i) {
          return n.coerce2(t, e, o, r, i);
        }

        if (a.handleSampleDefaults(t, e, l, s), !1 !== e.visible) {
          l("bandwidth"), l("side"), l("width") || (l("scalegroup", e.name), l("scalemode"));
          var u,
              f = l("span");
          Array.isArray(f) && (u = "manual"), l("spanmode", u);
          var h = l("line.color", (t.marker || {}).color || r),
              p = l("line.width"),
              d = l("fillcolor", i.addOpacity(e.line.color, .5));
          a.handlePointsDefaults(t, e, l, {
            prefix: ""
          });
          var m = c("box.width"),
              g = c("box.fillcolor", d),
              v = c("box.line.color", h),
              y = c("box.line.width", p);
          l("box.visible", Boolean(m || g || v || y)) || (e.box = {
            visible: !1
          });
          var x = c("meanline.color", h),
              b = c("meanline.width", p);
          l("meanline.visible", Boolean(x || b)) || (e.meanline = {
            visible: !1
          });
        }
      };
    }, {
      "../../components/color": 658,
      "../../lib": 795,
      "../box/defaults": 961,
      "./attributes": 1350
    }],
    1354: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = function i(t) {
        return 1 / Math.sqrt(2 * Math.PI) * Math.exp(-.5 * t * t);
      };

      r.makeKDE = function (t, e, r) {
        var n = r.length,
            a = i,
            o = t.bandwidth,
            s = 1 / (n * o);
        return function (t) {
          for (var e = 0, i = 0; i < n; i++) {
            e += a((t - r[i]) / o);
          }

          return s * e;
        };
      }, r.getPositionOnKdePath = function (t, e, r) {
        var i, a;
        "h" === e.orientation ? (i = "y", a = "x") : (i = "x", a = "y");
        var o = n.findPointOnPath(t.path, r, a, {
          pathLength: t.pathLength
        }),
            s = t.posCenterPx,
            l = o[i];
        return [l, "both" === e.side ? 2 * s - l : s];
      }, r.getKdeValue = function (t, e, n) {
        var i = t.pts.map(r.extractVal);
        return r.makeKDE(t, e, i)(n) / t.posDensityScale;
      }, r.extractVal = function (t) {
        return t.v;
      };
    }, {
      "../../lib": 795
    }],
    1355: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../../plots/cartesian/axes"),
          a = t("../box/hover"),
          o = t("./helpers");

      e.exports = function (t, e, r, s, l) {
        l || (l = {});
        var c,
            u,
            f = l.hoverLayer,
            h = t.cd,
            p = h[0].trace,
            d = p.hoveron,
            m = -1 !== d.indexOf("violins"),
            g = -1 !== d.indexOf("kde"),
            v = [];

        if (m || g) {
          var y = a.hoverOnBoxes(t, e, r, s);

          if (g && y.length > 0) {
            var x,
                b,
                _,
                w,
                T,
                k = t.xa,
                M = t.ya;

            "h" === p.orientation ? (T = e, x = "y", _ = M, b = "x", w = k) : (T = r, x = "x", _ = k, b = "y", w = M);
            var A = h[t.index];

            if (T >= A.span[0] && T <= A.span[1]) {
              var S = n.extendFlat({}, t),
                  E = w.c2p(T, !0),
                  L = o.getKdeValue(A, p, T),
                  C = o.getPositionOnKdePath(A, p, E),
                  P = _._offset,
                  I = _._length;
              S[x + "0"] = C[0], S[x + "1"] = C[1], S[b + "0"] = S[b + "1"] = E, S[b + "Label"] = b + ": " + i.hoverLabelText(w, T, p[b + "hoverformat"]) + ", " + h[0].t.labels.kde + " " + L.toFixed(3), S.spikeDistance = y[0].spikeDistance;
              var O = x + "Spike";
              S[O] = y[0][O], y[0].spikeDistance = void 0, y[0][O] = void 0, S.hovertemplate = !1, v.push(S), (u = {
                stroke: t.color
              })[x + "1"] = n.constrain(P + C[0], P, P + I), u[x + "2"] = n.constrain(P + C[1], P, P + I), u[b + "1"] = u[b + "2"] = w._offset + E;
            }
          }

          m && (v = v.concat(y));
        }

        -1 !== d.indexOf("points") && (c = a.hoverOnPoints(t, e, r));
        var z = f.selectAll(".violinline-" + p.uid).data(u ? [0] : []);
        return z.enter().append("line").classed("violinline-" + p.uid, !0).attr("stroke-width", 1.5), z.exit().remove(), z.attr(u), "closest" === s ? c ? [c] : v : c ? (v.push(c), v) : v;
      };
    }, {
      "../../lib": 795,
      "../../plots/cartesian/axes": 845,
      "../box/hover": 963,
      "./helpers": 1354
    }],
    1356: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        layoutAttributes: t("./layout_attributes"),
        supplyDefaults: t("./defaults"),
        crossTraceDefaults: t("../box/defaults").crossTraceDefaults,
        supplyLayoutDefaults: t("./layout_defaults"),
        calc: t("./calc"),
        crossTraceCalc: t("./cross_trace_calc"),
        plot: t("./plot"),
        style: t("./style"),
        styleOnSelect: t("../scatter/style").styleOnSelect,
        hoverPoints: t("./hover"),
        selectPoints: t("../box/select"),
        moduleType: "trace",
        name: "violin",
        basePlotModule: t("../../plots/cartesian"),
        categories: ["cartesian", "svg", "symbols", "oriented", "box-violin", "showLegend", "violinLayout", "zoomScale"],
        meta: {}
      };
    }, {
      "../../plots/cartesian": 858,
      "../box/defaults": 961,
      "../box/select": 968,
      "../scatter/style": 1223,
      "./attributes": 1350,
      "./calc": 1351,
      "./cross_trace_calc": 1352,
      "./defaults": 1353,
      "./hover": 1355,
      "./layout_attributes": 1357,
      "./layout_defaults": 1358,
      "./plot": 1359,
      "./style": 1360
    }],
    1357: [function (t, e, r) {
      "use strict";

      var n = t("../box/layout_attributes"),
          i = t("../../lib").extendFlat;
      e.exports = {
        violinmode: i({}, n.boxmode, {}),
        violingap: i({}, n.boxgap, {}),
        violingroupgap: i({}, n.boxgroupgap, {})
      };
    }, {
      "../../lib": 795,
      "../box/layout_attributes": 965
    }],
    1358: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./layout_attributes"),
          a = t("../box/layout_defaults");

      e.exports = function (t, e, r) {
        a._supply(t, e, r, function (r, a) {
          return n.coerce(t, e, i, r, a);
        }, "violin");
      };
    }, {
      "../../lib": 795,
      "../box/layout_defaults": 966,
      "./layout_attributes": 1357
    }],
    1359: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../lib"),
          a = t("../../components/drawing"),
          o = t("../box/plot"),
          s = t("../scatter/line_points"),
          l = t("./helpers");

      e.exports = function (t, e, r, c) {
        var u = t._fullLayout,
            f = e.xaxis,
            h = e.yaxis;

        function p(t) {
          var e = s(t, {
            xaxis: f,
            yaxis: h,
            connectGaps: !0,
            baseTolerance: .75,
            shape: "spline",
            simplify: !0,
            linearized: !0
          });
          return a.smoothopen(e[0], 1);
        }

        i.makeTraceGroups(c, r, "trace violins").each(function (t) {
          var r = n.select(this),
              a = t[0],
              s = a.t,
              c = a.trace;
          if (!0 !== c.visible || s.empty) r.remove();else {
            var d = s.bPos,
                m = s.bdPos,
                g = e[s.valLetter + "axis"],
                v = e[s.posLetter + "axis"],
                y = "both" === c.side,
                x = y || "positive" === c.side,
                b = y || "negative" === c.side,
                _ = r.selectAll("path.violin").data(i.identity);

            _.enter().append("path").style("vector-effect", "non-scaling-stroke").attr("class", "violin"), _.exit().remove(), _.each(function (t) {
              var e,
                  r,
                  i,
                  a,
                  o,
                  l,
                  f,
                  h,
                  _ = n.select(this),
                  w = t.density,
                  T = w.length,
                  k = v.c2l(t.pos + d, !0),
                  M = v.l2p(k);

              if (c.width) e = s.maxKDE / m;else {
                var A = u._violinScaleGroupStats[c.scalegroup];
                e = "count" === c.scalemode ? A.maxKDE / m * (A.maxCount / t.pts.length) : A.maxKDE / m;
              }

              if (x) {
                for (f = new Array(T), o = 0; o < T; o++) {
                  (h = f[o] = {})[s.posLetter] = k + w[o].v / e, h[s.valLetter] = g.c2l(w[o].t, !0);
                }

                r = p(f);
              }

              if (b) {
                for (f = new Array(T), l = 0, o = T - 1; l < T; l++, o--) {
                  (h = f[l] = {})[s.posLetter] = k - w[o].v / e, h[s.valLetter] = g.c2l(w[o].t, !0);
                }

                i = p(f);
              }

              if (y) a = r + "L" + i.substr(1) + "Z";else {
                var S = [M, g.c2p(w[0].t)],
                    E = [M, g.c2p(w[T - 1].t)];
                "h" === c.orientation && (S.reverse(), E.reverse()), a = x ? "M" + S + "L" + r.substr(1) + "L" + E : "M" + E + "L" + i.substr(1) + "L" + S;
              }
              _.attr("d", a), t.posCenterPx = M, t.posDensityScale = e * m, t.path = _.node(), t.pathLength = t.path.getTotalLength() / (y ? 2 : 1);
            });
            var w,
                T,
                k,
                M = c.box,
                A = M.width,
                S = (M.line || {}).width;
            y ? (w = m * A, T = 0) : x ? (w = [0, m * A / 2], T = S * {
              x: 1,
              y: -1
            }[s.posLetter]) : (w = [m * A / 2, 0], T = S * {
              x: -1,
              y: 1
            }[s.posLetter]), o.plotBoxAndWhiskers(r, {
              pos: v,
              val: g
            }, c, {
              bPos: d,
              bdPos: w,
              bPosPxOffset: T
            }), o.plotBoxMean(r, {
              pos: v,
              val: g
            }, c, {
              bPos: d,
              bdPos: w,
              bPosPxOffset: T
            }), !c.box.visible && c.meanline.visible && (k = i.identity);
            var E = r.selectAll("path.meanline").data(k || []);
            E.enter().append("path").attr("class", "meanline").style("fill", "none").style("vector-effect", "non-scaling-stroke"), E.exit().remove(), E.each(function (t) {
              var e = g.c2p(t.mean, !0),
                  r = l.getPositionOnKdePath(t, c, e);
              n.select(this).attr("d", "h" === c.orientation ? "M" + e + "," + r[0] + "V" + r[1] : "M" + r[0] + "," + e + "H" + r[1]);
            }), o.plotPoints(r, {
              x: f,
              y: h
            }, c, s);
          }
        });
      };
    }, {
      "../../components/drawing": 680,
      "../../lib": 795,
      "../box/plot": 967,
      "../scatter/line_points": 1213,
      "./helpers": 1354,
      "@plotly/d3": 57
    }],
    1360: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../components/color"),
          a = t("../scatter/style").stylePoints;

      e.exports = function (t) {
        var e = n.select(t).selectAll("g.trace.violins");
        e.style("opacity", function (t) {
          return t[0].trace.opacity;
        }), e.each(function (e) {
          var r = e[0].trace,
              o = n.select(this),
              s = r.box || {},
              l = s.line || {},
              c = r.meanline || {},
              u = c.width;
          o.selectAll("path.violin").style("stroke-width", r.line.width + "px").call(i.stroke, r.line.color).call(i.fill, r.fillcolor), o.selectAll("path.box").style("stroke-width", l.width + "px").call(i.stroke, l.color).call(i.fill, s.fillcolor);
          var f = {
            "stroke-width": u + "px",
            "stroke-dasharray": 2 * u + "px," + u + "px"
          };
          o.selectAll("path.mean").style(f).call(i.stroke, c.color), o.selectAll("path.meanline").style(f).call(i.stroke, c.color), a(o, r, t);
        });
      };
    }, {
      "../../components/color": 658,
      "../scatter/style": 1223,
      "@plotly/d3": 57
    }],
    1361: [function (t, e, r) {
      "use strict";

      var n = t("../../components/colorscale/attributes"),
          i = t("../isosurface/attributes"),
          a = t("../surface/attributes"),
          o = t("../../plots/attributes"),
          s = t("../../lib/extend").extendFlat,
          l = t("../../plot_api/edit_types").overrideAll,
          c = e.exports = l(s({
        x: i.x,
        y: i.y,
        z: i.z,
        value: i.value,
        isomin: i.isomin,
        isomax: i.isomax,
        surface: i.surface,
        spaceframe: {
          show: {
            valType: "boolean",
            dflt: !1
          },
          fill: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: 1
          }
        },
        slices: i.slices,
        caps: i.caps,
        text: i.text,
        hovertext: i.hovertext,
        xhoverformat: i.xhoverformat,
        yhoverformat: i.yhoverformat,
        zhoverformat: i.zhoverformat,
        valuehoverformat: i.valuehoverformat,
        hovertemplate: i.hovertemplate
      }, n("", {
        colorAttr: "`value`",
        showScaleDflt: !0,
        editTypeOverride: "calc"
      }), {
        colorbar: i.colorbar,
        opacity: i.opacity,
        opacityscale: a.opacityscale,
        lightposition: i.lightposition,
        lighting: i.lighting,
        flatshading: i.flatshading,
        contour: i.contour,
        hoverinfo: s({}, o.hoverinfo),
        showlegend: s({}, o.showlegend, {
          dflt: !1
        })
      }), "calc", "nested");
      c.x.editType = c.y.editType = c.z.editType = c.value.editType = "calc+clearAxisTypes", c.transforms = void 0;
    }, {
      "../../components/colorscale/attributes": 665,
      "../../lib/extend": 785,
      "../../plot_api/edit_types": 827,
      "../../plots/attributes": 841,
      "../isosurface/attributes": 1135,
      "../surface/attributes": 1323
    }],
    1362: [function (t, e, r) {
      "use strict";

      var n = t("gl-mesh3d"),
          i = t("../../lib/gl_format_color").parseColorScale,
          a = t("../../lib/str2rgbarray"),
          o = t("../../components/colorscale").extractOpts,
          s = t("../../plots/gl3d/zip3"),
          l = t("../isosurface/convert").findNearestOnAxis,
          c = t("../isosurface/convert").generateIsoMeshes;

      function u(t, e, r) {
        this.scene = t, this.uid = r, this.mesh = e, this.name = "", this.data = null, this.showContour = !1;
      }

      var f = u.prototype;
      f.handlePick = function (t) {
        if (t.object === this.mesh) {
          var e = t.data.index,
              r = this.data._meshX[e],
              n = this.data._meshY[e],
              i = this.data._meshZ[e],
              a = this.data._Ys.length,
              o = this.data._Zs.length,
              s = l(r, this.data._Xs).id,
              c = l(n, this.data._Ys).id,
              u = l(i, this.data._Zs).id,
              f = t.index = u + o * c + o * a * s;
          t.traceCoordinate = [this.data._meshX[f], this.data._meshY[f], this.data._meshZ[f], this.data._value[f]];
          var h = this.data.hovertext || this.data.text;
          return Array.isArray(h) && void 0 !== h[f] ? t.textLabel = h[f] : h && (t.textLabel = h), !0;
        }
      }, f.update = function (t) {
        var e = this.scene,
            r = e.fullSceneLayout;

        function n(t, e, r, n) {
          return e.map(function (e) {
            return t.d2l(e, 0, n) * r;
          });
        }

        this.data = c(t);
        var l = {
          positions: s(n(r.xaxis, t._meshX, e.dataScale[0], t.xcalendar), n(r.yaxis, t._meshY, e.dataScale[1], t.ycalendar), n(r.zaxis, t._meshZ, e.dataScale[2], t.zcalendar)),
          cells: s(t._meshI, t._meshJ, t._meshK),
          lightPosition: [t.lightposition.x, t.lightposition.y, t.lightposition.z],
          ambient: t.lighting.ambient,
          diffuse: t.lighting.diffuse,
          specular: t.lighting.specular,
          roughness: t.lighting.roughness,
          fresnel: t.lighting.fresnel,
          vertexNormalsEpsilon: t.lighting.vertexnormalsepsilon,
          faceNormalsEpsilon: t.lighting.facenormalsepsilon,
          opacity: t.opacity,
          opacityscale: t.opacityscale,
          contourEnable: t.contour.show,
          contourColor: a(t.contour.color).slice(0, 3),
          contourWidth: t.contour.width,
          useFacetNormals: t.flatshading
        },
            u = o(t);
        l.vertexIntensity = t._meshIntensity, l.vertexIntensityBounds = [u.min, u.max], l.colormap = i(t), this.mesh.update(l);
      }, f.dispose = function () {
        this.scene.glplot.remove(this.mesh), this.mesh.dispose();
      }, e.exports = function (t, e) {
        var r = t.glplot.gl,
            i = n({
          gl: r
        }),
            a = new u(t, i, e.uid);
        return i._trace = a, a.update(e), t.glplot.add(i), a;
      };
    }, {
      "../../components/colorscale": 670,
      "../../lib/gl_format_color": 791,
      "../../lib/str2rgbarray": 819,
      "../../plots/gl3d/zip3": 898,
      "../isosurface/convert": 1137,
      "gl-mesh3d": 306
    }],
    1363: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./attributes"),
          a = t("../isosurface/defaults").supplyIsoDefaults,
          o = t("../surface/defaults").opacityscaleDefaults;

      e.exports = function (t, e, r, s) {
        function l(r, a) {
          return n.coerce(t, e, i, r, a);
        }

        a(t, e, r, s, l), o(t, e, s, l);
      };
    }, {
      "../../lib": 795,
      "../isosurface/defaults": 1138,
      "../surface/defaults": 1326,
      "./attributes": 1361
    }],
    1364: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        supplyDefaults: t("./defaults"),
        calc: t("../isosurface/calc"),
        colorbar: {
          min: "cmin",
          max: "cmax"
        },
        plot: t("./convert"),
        moduleType: "trace",
        name: "volume",
        basePlotModule: t("../../plots/gl3d"),
        categories: ["gl3d", "showLegend"],
        meta: {}
      };
    }, {
      "../../plots/gl3d": 887,
      "../isosurface/calc": 1136,
      "./attributes": 1361,
      "./convert": 1362,
      "./defaults": 1363
    }],
    1365: [function (t, e, r) {
      "use strict";

      var n = t("../bar/attributes"),
          i = t("../scatter/attributes").line,
          a = t("../../plots/attributes"),
          o = t("../../plots/hoverformat_attributes"),
          s = t("../../plots/template_attributes").hovertemplateAttrs,
          l = t("../../plots/template_attributes").texttemplateAttrs,
          c = t("./constants"),
          u = t("../../lib/extend").extendFlat,
          f = t("../../components/color");

      function h(t) {
        return {
          marker: {
            color: u({}, n.marker.color, {
              arrayOk: !1,
              editType: "style"
            }),
            line: {
              color: u({}, n.marker.line.color, {
                arrayOk: !1,
                editType: "style"
              }),
              width: u({}, n.marker.line.width, {
                arrayOk: !1,
                editType: "style"
              }),
              editType: "style"
            },
            editType: "style"
          },
          editType: "style"
        };
      }

      e.exports = {
        measure: {
          valType: "data_array",
          dflt: [],
          editType: "calc"
        },
        base: {
          valType: "number",
          dflt: null,
          arrayOk: !1,
          editType: "calc"
        },
        x: n.x,
        x0: n.x0,
        dx: n.dx,
        y: n.y,
        y0: n.y0,
        dy: n.dy,
        xperiod: n.xperiod,
        yperiod: n.yperiod,
        xperiod0: n.xperiod0,
        yperiod0: n.yperiod0,
        xperiodalignment: n.xperiodalignment,
        yperiodalignment: n.yperiodalignment,
        xhoverformat: o("x"),
        yhoverformat: o("y"),
        hovertext: n.hovertext,
        hovertemplate: s({}, {
          keys: c.eventDataKeys
        }),
        hoverinfo: u({}, a.hoverinfo, {
          flags: ["name", "x", "y", "text", "initial", "delta", "final"]
        }),
        textinfo: {
          valType: "flaglist",
          flags: ["label", "text", "initial", "delta", "final"],
          extras: ["none"],
          editType: "plot",
          arrayOk: !1
        },
        texttemplate: l({
          editType: "plot"
        }, {
          keys: c.eventDataKeys.concat(["label"])
        }),
        text: n.text,
        textposition: n.textposition,
        insidetextanchor: n.insidetextanchor,
        textangle: n.textangle,
        textfont: n.textfont,
        insidetextfont: n.insidetextfont,
        outsidetextfont: n.outsidetextfont,
        constraintext: n.constraintext,
        cliponaxis: n.cliponaxis,
        orientation: n.orientation,
        offset: n.offset,
        width: n.width,
        increasing: h(),
        decreasing: h(),
        totals: h(),
        connector: {
          line: {
            color: u({}, i.color, {
              dflt: f.defaultLine
            }),
            width: u({}, i.width, {
              editType: "plot"
            }),
            dash: i.dash,
            editType: "plot"
          },
          mode: {
            valType: "enumerated",
            values: ["spanning", "between"],
            dflt: "between",
            editType: "plot"
          },
          visible: {
            valType: "boolean",
            dflt: !0,
            editType: "plot"
          },
          editType: "plot"
        },
        offsetgroup: n.offsetgroup,
        alignmentgroup: n.alignmentgroup
      };
    }, {
      "../../components/color": 658,
      "../../lib/extend": 785,
      "../../plots/attributes": 841,
      "../../plots/hoverformat_attributes": 899,
      "../../plots/template_attributes": 918,
      "../bar/attributes": 933,
      "../scatter/attributes": 1199,
      "./constants": 1367
    }],
    1366: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/cartesian/axes"),
          i = t("../../plots/cartesian/align_period"),
          a = t("../../lib").mergeArray,
          o = t("../scatter/calc_selection"),
          s = t("../../constants/numerical").BADNUM;

      function l(t) {
        return "a" === t || "absolute" === t;
      }

      function c(t) {
        return "t" === t || "total" === t;
      }

      e.exports = function (t, e) {
        var r,
            u,
            f,
            h,
            p = n.getFromId(t, e.xaxis || "x"),
            d = n.getFromId(t, e.yaxis || "y");
        "h" === e.orientation ? (r = p.makeCalcdata(e, "x"), f = d.makeCalcdata(e, "y"), u = i(e, d, "y", f), h = !!e.yperiodalignment) : (r = d.makeCalcdata(e, "y"), f = p.makeCalcdata(e, "x"), u = i(e, p, "x", f), h = !!e.xperiodalignment);

        for (var m, g = Math.min(u.length, r.length), v = new Array(g), y = 0, x = !1, b = 0; b < g; b++) {
          var _ = r[b] || 0,
              w = !1;

          (r[b] !== s || c(e.measure[b]) || l(e.measure[b])) && b + 1 < g && (r[b + 1] !== s || c(e.measure[b + 1]) || l(e.measure[b + 1])) && (w = !0);
          var T = v[b] = {
            i: b,
            p: u[b],
            s: _,
            rawS: _,
            cNext: w
          };
          l(e.measure[b]) ? (y = T.s, T.isSum = !0, T.dir = "totals", T.s = y) : c(e.measure[b]) ? (T.isSum = !0, T.dir = "totals", T.s = y) : (T.isSum = !1, T.dir = T.rawS < 0 ? "decreasing" : "increasing", m = T.s, T.s = y + m, y += m), "totals" === T.dir && (x = !0), h && (v[b].orig_p = f[b]), e.ids && (T.id = String(e.ids[b])), T.v = (e.base || 0) + y;
        }

        return v.length && (v[0].hasTotals = x), a(e.text, v, "tx"), a(e.hovertext, v, "htx"), o(v, e), v;
      };
    }, {
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../../plots/cartesian/align_period": 842,
      "../../plots/cartesian/axes": 845,
      "../scatter/calc_selection": 1201
    }],
    1367: [function (t, e, r) {
      "use strict";

      e.exports = {
        eventDataKeys: ["initial", "delta", "final"]
      };
    }, {}],
    1368: [function (t, e, r) {
      "use strict";

      var n = t("../bar/cross_trace_calc").setGroupPositions;

      e.exports = function (t, e) {
        var r,
            i,
            a = t._fullLayout,
            o = t._fullData,
            s = t.calcdata,
            l = e.xaxis,
            c = e.yaxis,
            u = [],
            f = [],
            h = [];

        for (i = 0; i < o.length; i++) {
          var p = o[i];
          !0 === p.visible && p.xaxis === l._id && p.yaxis === c._id && "waterfall" === p.type && (r = s[i], "h" === p.orientation ? h.push(r) : f.push(r), u.push(r));
        }

        var d = {
          mode: a.waterfallmode,
          norm: a.waterfallnorm,
          gap: a.waterfallgap,
          groupgap: a.waterfallgroupgap
        };

        for (n(t, l, c, f, d), n(t, c, l, h, d), i = 0; i < u.length; i++) {
          r = u[i];

          for (var m = 0; m < r.length; m++) {
            var g = r[m];
            !1 === g.isSum && (g.s0 += 0 === m ? 0 : r[m - 1].s), m + 1 < r.length && (r[m].nextP0 = r[m + 1].p0, r[m].nextS0 = r[m + 1].s0);
          }
        }
      };
    }, {
      "../bar/cross_trace_calc": 936
    }],
    1369: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("../bar/defaults").handleGroupingDefaults,
          a = t("../bar/defaults").handleText,
          o = t("../scatter/xy_defaults"),
          s = t("../scatter/period_defaults"),
          l = t("./attributes"),
          c = t("../../components/color"),
          u = t("../../constants/delta.js"),
          f = u.INCREASING.COLOR,
          h = u.DECREASING.COLOR;

      function p(t, e, r) {
        t(e + ".marker.color", r), t(e + ".marker.line.color", c.defaultLine), t(e + ".marker.line.width");
      }

      e.exports = {
        supplyDefaults: function supplyDefaults(t, e, r, i) {
          function c(r, i) {
            return n.coerce(t, e, l, r, i);
          }

          if (o(t, e, i, c)) {
            s(t, e, i, c), c("xhoverformat"), c("yhoverformat"), c("measure"), c("orientation", e.x && !e.y ? "h" : "v"), c("base"), c("offset"), c("width"), c("text"), c("hovertext"), c("hovertemplate");
            var u = c("textposition");
            if (a(t, e, i, c, u, {
              moduleHasSelected: !1,
              moduleHasUnselected: !1,
              moduleHasConstrain: !0,
              moduleHasCliponaxis: !0,
              moduleHasTextangle: !0,
              moduleHasInsideanchor: !0
            }), "none" !== e.textposition && (c("texttemplate"), e.texttemplate || c("textinfo")), p(c, "increasing", f), p(c, "decreasing", h), p(c, "totals", "#4499FF"), c("connector.visible")) c("connector.mode"), c("connector.line.width") && (c("connector.line.color"), c("connector.line.dash"));
          } else e.visible = !1;
        },
        crossTraceDefaults: function crossTraceDefaults(t, e) {
          var r, a;

          function o(t) {
            return n.coerce(a._input, a, l, t);
          }

          if ("group" === e.waterfallmode) for (var s = 0; s < t.length; s++) {
            r = (a = t[s])._input, i(r, a, e, o);
          }
        }
      };
    }, {
      "../../components/color": 658,
      "../../constants/delta.js": 765,
      "../../lib": 795,
      "../bar/defaults": 937,
      "../scatter/period_defaults": 1219,
      "../scatter/xy_defaults": 1226,
      "./attributes": 1365
    }],
    1370: [function (t, e, r) {
      "use strict";

      e.exports = function (t, e) {
        return t.x = "xVal" in e ? e.xVal : e.x, t.y = "yVal" in e ? e.yVal : e.y, "initial" in e && (t.initial = e.initial), "delta" in e && (t.delta = e.delta), "final" in e && (t.final = e.final), e.xa && (t.xaxis = e.xa), e.ya && (t.yaxis = e.ya), t;
      };
    }, {}],
    1371: [function (t, e, r) {
      "use strict";

      var n = t("../../plots/cartesian/axes").hoverLabelText,
          i = t("../../components/color").opacity,
          a = t("../bar/hover").hoverOnBars,
          o = t("../../constants/delta.js"),
          s = o.INCREASING.SYMBOL,
          l = o.DECREASING.SYMBOL;

      e.exports = function (t, e, r, o, c) {
        var u = a(t, e, r, o, c);

        if (u) {
          var f = u.cd,
              h = f[0].trace,
              p = "h" === h.orientation,
              d = p ? "x" : "y",
              m = p ? t.xa : t.ya,
              g = f[u.index],
              v = g.isSum ? g.b + g.s : g.rawS;

          if (!g.isSum) {
            u.initial = g.b + g.s - v, u.delta = v, u.final = u.initial + u.delta;
            var y = k(Math.abs(u.delta));
            u.deltaLabel = v < 0 ? "(" + y + ")" : y, u.finalLabel = k(u.final), u.initialLabel = k(u.initial);
          }

          var x = g.hi || h.hoverinfo,
              b = [];

          if (x && "none" !== x && "skip" !== x) {
            var _ = "all" === x,
                w = x.split("+"),
                T = function T(t) {
              return _ || -1 !== w.indexOf(t);
            };

            g.isSum || (!T("final") || T(p ? "x" : "y") || b.push(u.finalLabel), T("delta") && (v < 0 ? b.push(u.deltaLabel + " " + l) : b.push(u.deltaLabel + " " + s)), T("initial") && b.push("Initial: " + u.initialLabel));
          }

          return b.length && (u.extraText = b.join("<br>")), u.color = function (t, e) {
            var r = t[e.dir].marker,
                n = r.color,
                a = r.line.color,
                o = r.line.width;
            if (i(n)) return n;
            if (i(a) && o) return a;
          }(h, g), [u];
        }

        function k(t) {
          return n(m, t, h[d + "hoverformat"]);
        }
      };
    }, {
      "../../components/color": 658,
      "../../constants/delta.js": 765,
      "../../plots/cartesian/axes": 845,
      "../bar/hover": 940
    }],
    1372: [function (t, e, r) {
      "use strict";

      e.exports = {
        attributes: t("./attributes"),
        layoutAttributes: t("./layout_attributes"),
        supplyDefaults: t("./defaults").supplyDefaults,
        crossTraceDefaults: t("./defaults").crossTraceDefaults,
        supplyLayoutDefaults: t("./layout_defaults"),
        calc: t("./calc"),
        crossTraceCalc: t("./cross_trace_calc"),
        plot: t("./plot"),
        style: t("./style").style,
        hoverPoints: t("./hover"),
        eventData: t("./event_data"),
        selectPoints: t("../bar/select"),
        moduleType: "trace",
        name: "waterfall",
        basePlotModule: t("../../plots/cartesian"),
        categories: ["bar-like", "cartesian", "svg", "oriented", "showLegend", "zoomScale"],
        meta: {}
      };
    }, {
      "../../plots/cartesian": 858,
      "../bar/select": 945,
      "./attributes": 1365,
      "./calc": 1366,
      "./cross_trace_calc": 1368,
      "./defaults": 1369,
      "./event_data": 1370,
      "./hover": 1371,
      "./layout_attributes": 1373,
      "./layout_defaults": 1374,
      "./plot": 1375,
      "./style": 1376
    }],
    1373: [function (t, e, r) {
      "use strict";

      e.exports = {
        waterfallmode: {
          valType: "enumerated",
          values: ["group", "overlay"],
          dflt: "group",
          editType: "calc"
        },
        waterfallgap: {
          valType: "number",
          min: 0,
          max: 1,
          editType: "calc"
        },
        waterfallgroupgap: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 0,
          editType: "calc"
        }
      };
    }, {}],
    1374: [function (t, e, r) {
      "use strict";

      var n = t("../../lib"),
          i = t("./layout_attributes");

      e.exports = function (t, e, r) {
        var a = !1;

        function o(r, a) {
          return n.coerce(t, e, i, r, a);
        }

        for (var s = 0; s < r.length; s++) {
          var l = r[s];

          if (l.visible && "waterfall" === l.type) {
            a = !0;
            break;
          }
        }

        a && (o("waterfallmode"), o("waterfallgap", .2), o("waterfallgroupgap"));
      };
    }, {
      "../../lib": 795,
      "./layout_attributes": 1373
    }],
    1375: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../lib"),
          a = t("../../components/drawing"),
          o = t("../../constants/numerical").BADNUM,
          s = t("../bar/plot"),
          l = t("../bar/uniform_text").clearMinTextSize;

      e.exports = function (t, e, r, c) {
        var u = t._fullLayout;
        l("waterfall", u), s.plot(t, e, r, c, {
          mode: u.waterfallmode,
          norm: u.waterfallmode,
          gap: u.waterfallgap,
          groupgap: u.waterfallgroupgap
        }), function (t, e, r, s) {
          var l = e.xaxis,
              c = e.yaxis;
          i.makeTraceGroups(s, r, "trace bars").each(function (r) {
            var s = n.select(this),
                u = r[0].trace,
                f = i.ensureSingle(s, "g", "lines");

            if (u.connector && u.connector.visible) {
              var h = "h" === u.orientation,
                  p = u.connector.mode,
                  d = f.selectAll("g.line").data(i.identity);
              d.enter().append("g").classed("line", !0), d.exit().remove();
              var m = d.size();
              d.each(function (r, s) {
                if (s === m - 1 || r.cNext) {
                  var u = function (t, e, r, n) {
                    var i = [],
                        a = [],
                        o = n ? e : r,
                        s = n ? r : e;
                    return i[0] = o.c2p(t.s0, !0), a[0] = s.c2p(t.p0, !0), i[1] = o.c2p(t.s1, !0), a[1] = s.c2p(t.p1, !0), i[2] = o.c2p(t.nextS0, !0), a[2] = s.c2p(t.nextP0, !0), n ? [i, a] : [a, i];
                  }(r, l, c, h),
                      f = u[0],
                      d = u[1],
                      g = "";

                  f[0] !== o && d[0] !== o && f[1] !== o && d[1] !== o && ("spanning" === p && !r.isSum && s > 0 && (g += h ? "M" + f[0] + "," + d[1] + "V" + d[0] : "M" + f[1] + "," + d[0] + "H" + f[0]), "between" !== p && (r.isSum || s < m - 1) && (g += h ? "M" + f[1] + "," + d[0] + "V" + d[1] : "M" + f[0] + "," + d[1] + "H" + f[1]), f[2] !== o && d[2] !== o && (g += h ? "M" + f[1] + "," + d[1] + "V" + d[2] : "M" + f[1] + "," + d[1] + "H" + f[2])), "" === g && (g = "M0,0Z"), i.ensureSingle(n.select(this), "path").attr("d", g).call(a.setClipUrl, e.layerClipId, t);
                }
              });
            } else f.remove();
          });
        }(t, e, r, c);
      };
    }, {
      "../../components/drawing": 680,
      "../../constants/numerical": 771,
      "../../lib": 795,
      "../bar/plot": 944,
      "../bar/uniform_text": 949,
      "@plotly/d3": 57
    }],
    1376: [function (t, e, r) {
      "use strict";

      var n = t("@plotly/d3"),
          i = t("../../components/drawing"),
          a = t("../../components/color"),
          o = t("../../constants/interactions").DESELECTDIM,
          s = t("../bar/style"),
          l = t("../bar/uniform_text").resizeText,
          c = s.styleTextPoints;
      e.exports = {
        style: function style(t, e, r) {
          var s = r || n.select(t).selectAll("g.waterfalllayer").selectAll("g.trace");
          l(t, s, "waterfall"), s.style("opacity", function (t) {
            return t[0].trace.opacity;
          }), s.each(function (e) {
            var r = n.select(this),
                s = e[0].trace;
            r.selectAll(".point > path").each(function (t) {
              if (!t.isBlank) {
                var e = s[t.dir].marker;
                n.select(this).call(a.fill, e.color).call(a.stroke, e.line.color).call(i.dashLine, e.line.dash, e.line.width).style("opacity", s.selectedpoints && !t.selected ? o : 1);
              }
            }), c(r, s, t), r.selectAll(".lines").each(function () {
              var t = s.connector.line;
              i.lineGroupStyle(n.select(this).selectAll("path"), t.width, t.color, t.dash);
            });
          });
        }
      };
    }, {
      "../../components/color": 658,
      "../../components/drawing": 680,
      "../../constants/interactions": 770,
      "../bar/style": 947,
      "../bar/uniform_text": 949,
      "@plotly/d3": 57
    }],
    1377: [function (t, e, r) {
      "use strict";

      var n = t("../plots/cartesian/axes"),
          i = t("../lib"),
          a = t("../plot_api/plot_schema"),
          o = t("./helpers").pointsAccessorFunction,
          s = t("../constants/numerical").BADNUM;
      r.moduleType = "transform", r.name = "aggregate";
      var l = r.attributes = {
        enabled: {
          valType: "boolean",
          dflt: !0,
          editType: "calc"
        },
        groups: {
          valType: "string",
          strict: !0,
          noBlank: !0,
          arrayOk: !0,
          dflt: "x",
          editType: "calc"
        },
        aggregations: {
          _isLinkedToArray: "aggregation",
          target: {
            valType: "string",
            editType: "calc"
          },
          func: {
            valType: "enumerated",
            values: ["count", "sum", "avg", "median", "mode", "rms", "stddev", "min", "max", "first", "last", "change", "range"],
            dflt: "first",
            editType: "calc"
          },
          funcmode: {
            valType: "enumerated",
            values: ["sample", "population"],
            dflt: "sample",
            editType: "calc"
          },
          enabled: {
            valType: "boolean",
            dflt: !0,
            editType: "calc"
          },
          editType: "calc"
        },
        editType: "calc"
      },
          c = l.aggregations;

      function u(t, e, r, a) {
        if (a.enabled) {
          for (var o = a.target, l = i.nestedProperty(e, o), c = l.get(), u = function (t, e) {
            var r = t.func,
                n = e.d2c,
                a = e.c2d;

            switch (r) {
              case "count":
                return f;

              case "first":
                return h;

              case "last":
                return p;

              case "sum":
                return function (t, e) {
                  for (var r = 0, i = 0; i < e.length; i++) {
                    var o = n(t[e[i]]);
                    o !== s && (r += o);
                  }

                  return a(r);
                };

              case "avg":
                return function (t, e) {
                  for (var r = 0, i = 0, o = 0; o < e.length; o++) {
                    var l = n(t[e[o]]);
                    l !== s && (r += l, i++);
                  }

                  return i ? a(r / i) : s;
                };

              case "min":
                return function (t, e) {
                  for (var r = 1 / 0, i = 0; i < e.length; i++) {
                    var o = n(t[e[i]]);
                    o !== s && (r = Math.min(r, o));
                  }

                  return r === 1 / 0 ? s : a(r);
                };

              case "max":
                return function (t, e) {
                  for (var r = -1 / 0, i = 0; i < e.length; i++) {
                    var o = n(t[e[i]]);
                    o !== s && (r = Math.max(r, o));
                  }

                  return r === -1 / 0 ? s : a(r);
                };

              case "range":
                return function (t, e) {
                  for (var r = 1 / 0, i = -1 / 0, o = 0; o < e.length; o++) {
                    var l = n(t[e[o]]);
                    l !== s && (r = Math.min(r, l), i = Math.max(i, l));
                  }

                  return i === -1 / 0 || r === 1 / 0 ? s : a(i - r);
                };

              case "change":
                return function (t, e) {
                  var r = n(t[e[0]]),
                      i = n(t[e[e.length - 1]]);
                  return r === s || i === s ? s : a(i - r);
                };

              case "median":
                return function (t, e) {
                  for (var r = [], o = 0; o < e.length; o++) {
                    var l = n(t[e[o]]);
                    l !== s && r.push(l);
                  }

                  if (!r.length) return s;
                  r.sort(i.sorterAsc);
                  var c = (r.length - 1) / 2;
                  return a((r[Math.floor(c)] + r[Math.ceil(c)]) / 2);
                };

              case "mode":
                return function (t, e) {
                  for (var r = {}, i = 0, o = s, l = 0; l < e.length; l++) {
                    var c = n(t[e[l]]);

                    if (c !== s) {
                      var u = r[c] = (r[c] || 0) + 1;
                      u > i && (i = u, o = c);
                    }
                  }

                  return i ? a(o) : s;
                };

              case "rms":
                return function (t, e) {
                  for (var r = 0, i = 0, o = 0; o < e.length; o++) {
                    var l = n(t[e[o]]);
                    l !== s && (r += l * l, i++);
                  }

                  return i ? a(Math.sqrt(r / i)) : s;
                };

              case "stddev":
                return function (e, r) {
                  var i,
                      a = 0,
                      o = 0,
                      l = 1,
                      c = s;

                  for (i = 0; i < r.length && c === s; i++) {
                    c = n(e[r[i]]);
                  }

                  if (c === s) return s;

                  for (; i < r.length; i++) {
                    var u = n(e[r[i]]);

                    if (u !== s) {
                      var f = u - c;
                      a += f, o += f * f, l++;
                    }
                  }

                  var h = "sample" === t.funcmode ? l - 1 : l;
                  return h ? Math.sqrt((o - a * a / l) / h) : 0;
                };
            }
          }(a, n.getDataConversions(t, e, o, c)), d = new Array(r.length), m = 0; m < r.length; m++) {
            d[m] = u(c, r[m]);
          }

          l.set(d), "count" === a.func && i.pushUnique(e._arrayAttrs, o);
        }
      }

      function f(t, e) {
        return e.length;
      }

      function h(t, e) {
        return t[e[0]];
      }

      function p(t, e) {
        return t[e[e.length - 1]];
      }

      r.supplyDefaults = function (t, e) {
        var r,
            n = {};

        function o(e, r) {
          return i.coerce(t, n, l, e, r);
        }

        if (!o("enabled")) return n;
        var s = a.findArrayAttributes(e),
            u = {};

        for (r = 0; r < s.length; r++) {
          u[s[r]] = 1;
        }

        var f = o("groups");

        if (!Array.isArray(f)) {
          if (!u[f]) return n.enabled = !1, n;
          u[f] = 0;
        }

        var h,
            p = t.aggregations || [],
            d = n.aggregations = new Array(p.length);

        function m(t, e) {
          return i.coerce(p[r], h, c, t, e);
        }

        for (r = 0; r < p.length; r++) {
          h = {
            _index: r
          };
          var g = m("target"),
              v = m("func");
          m("enabled") && g && (u[g] || "count" === v && void 0 === u[g]) ? ("stddev" === v && m("funcmode"), u[g] = 0, d[r] = h) : d[r] = {
            enabled: !1,
            _index: r
          };
        }

        for (r = 0; r < s.length; r++) {
          u[s[r]] && d.push({
            target: s[r],
            func: c.func.dflt,
            enabled: !0,
            _index: -1
          });
        }

        return n;
      }, r.calcTransform = function (t, e, r) {
        if (r.enabled) {
          var n = r.groups,
              a = i.getTargetArray(e, {
            target: n
          });

          if (a) {
            var s,
                l,
                c,
                f,
                h = {},
                p = {},
                d = [],
                m = o(e.transforms, r),
                g = a.length;

            for (e._length && (g = Math.min(g, e._length)), s = 0; s < g; s++) {
              void 0 === (c = h[l = a[s]]) ? (h[l] = d.length, f = [s], d.push(f), p[h[l]] = m(s)) : (d[c].push(s), p[h[l]] = (p[h[l]] || []).concat(m(s)));
            }

            r._indexToPoints = p;
            var v = r.aggregations;

            for (s = 0; s < v.length; s++) {
              u(t, e, d, v[s]);
            }

            "string" == typeof n && u(t, e, d, {
              target: n,
              func: "first",
              enabled: !0
            }), e._length = d.length;
          }
        }
      };
    }, {
      "../constants/numerical": 771,
      "../lib": 795,
      "../plot_api/plot_schema": 833,
      "../plots/cartesian/axes": 845,
      "./helpers": 1380
    }],
    1378: [function (t, e, r) {
      "use strict";

      var n = t("../lib"),
          i = t("../registry"),
          a = t("../plots/cartesian/axes"),
          o = t("./helpers").pointsAccessorFunction,
          s = t("../constants/filter_ops"),
          l = s.COMPARISON_OPS,
          c = s.INTERVAL_OPS,
          u = s.SET_OPS;
      r.moduleType = "transform", r.name = "filter", r.attributes = {
        enabled: {
          valType: "boolean",
          dflt: !0,
          editType: "calc"
        },
        target: {
          valType: "string",
          strict: !0,
          noBlank: !0,
          arrayOk: !0,
          dflt: "x",
          editType: "calc"
        },
        operation: {
          valType: "enumerated",
          values: [].concat(l).concat(c).concat(u),
          dflt: "=",
          editType: "calc"
        },
        value: {
          valType: "any",
          dflt: 0,
          editType: "calc"
        },
        preservegaps: {
          valType: "boolean",
          dflt: !1,
          editType: "calc"
        },
        editType: "calc"
      }, r.supplyDefaults = function (t) {
        var e = {};

        function a(i, a) {
          return n.coerce(t, e, r.attributes, i, a);
        }

        if (a("enabled")) {
          var o = a("target");
          if (n.isArrayOrTypedArray(o) && 0 === o.length) return e.enabled = !1, e;
          a("preservegaps"), a("operation"), a("value");
          var s = i.getComponentMethod("calendars", "handleDefaults");
          s(t, e, "valuecalendar", null), s(t, e, "targetcalendar", null);
        }

        return e;
      }, r.calcTransform = function (t, e, r) {
        if (r.enabled) {
          var i = n.getTargetArray(e, r);

          if (i) {
            var s = r.target,
                f = i.length;
            e._length && (f = Math.min(f, e._length));
            var h = r.targetcalendar,
                p = e._arrayAttrs,
                d = r.preservegaps;

            if ("string" == typeof s) {
              var m = n.nestedProperty(e, s + "calendar").get();
              m && (h = m);
            }

            var g,
                v,
                y = function (t, e, r) {
              var n = t.operation,
                  i = t.value,
                  a = Array.isArray(i);

              function o(t) {
                return -1 !== t.indexOf(n);
              }

              var s,
                  f = function f(r) {
                return e(r, 0, t.valuecalendar);
              },
                  h = function h(t) {
                return e(t, 0, r);
              };

              o(l) ? s = f(a ? i[0] : i) : o(c) ? s = a ? [f(i[0]), f(i[1])] : [f(i), f(i)] : o(u) && (s = a ? i.map(f) : [f(i)]);

              switch (n) {
                case "=":
                  return function (t) {
                    return h(t) === s;
                  };

                case "!=":
                  return function (t) {
                    return h(t) !== s;
                  };

                case "<":
                  return function (t) {
                    return h(t) < s;
                  };

                case "<=":
                  return function (t) {
                    return h(t) <= s;
                  };

                case ">":
                  return function (t) {
                    return h(t) > s;
                  };

                case ">=":
                  return function (t) {
                    return h(t) >= s;
                  };

                case "[]":
                  return function (t) {
                    var e = h(t);
                    return e >= s[0] && e <= s[1];
                  };

                case "()":
                  return function (t) {
                    var e = h(t);
                    return e > s[0] && e < s[1];
                  };

                case "[)":
                  return function (t) {
                    var e = h(t);
                    return e >= s[0] && e < s[1];
                  };

                case "(]":
                  return function (t) {
                    var e = h(t);
                    return e > s[0] && e <= s[1];
                  };

                case "][":
                  return function (t) {
                    var e = h(t);
                    return e <= s[0] || e >= s[1];
                  };

                case ")(":
                  return function (t) {
                    var e = h(t);
                    return e < s[0] || e > s[1];
                  };

                case "](":
                  return function (t) {
                    var e = h(t);
                    return e <= s[0] || e > s[1];
                  };

                case ")[":
                  return function (t) {
                    var e = h(t);
                    return e < s[0] || e >= s[1];
                  };

                case "{}":
                  return function (t) {
                    return -1 !== s.indexOf(h(t));
                  };

                case "}{":
                  return function (t) {
                    return -1 === s.indexOf(h(t));
                  };
              }
            }(r, a.getDataToCoordFunc(t, e, s, i), h),
                x = {},
                b = {},
                _ = 0;

            d ? (g = function g(t) {
              x[t.astr] = n.extendDeep([], t.get()), t.set(new Array(f));
            }, v = function v(t, e) {
              var r = x[t.astr][e];
              t.get()[e] = r;
            }) : (g = function g(t) {
              x[t.astr] = n.extendDeep([], t.get()), t.set([]);
            }, v = function v(t, e) {
              var r = x[t.astr][e];
              t.get().push(r);
            }), k(g);

            for (var w = o(e.transforms, r), T = 0; T < f; T++) {
              y(i[T]) ? (k(v, T), b[_++] = w(T)) : d && _++;
            }

            r._indexToPoints = b, e._length = _;
          }
        }

        function k(t, r) {
          for (var i = 0; i < p.length; i++) {
            t(n.nestedProperty(e, p[i]), r);
          }
        }
      };
    }, {
      "../constants/filter_ops": 767,
      "../lib": 795,
      "../plots/cartesian/axes": 845,
      "../registry": 923,
      "./helpers": 1380
    }],
    1379: [function (t, e, r) {
      "use strict";

      var n = t("../lib"),
          i = t("../plot_api/plot_schema"),
          a = t("../plots/plots"),
          o = t("./helpers").pointsAccessorFunction;

      function s(t, e) {
        var r,
            s,
            l,
            c,
            u,
            f,
            h,
            p,
            d,
            m,
            g = e.transform,
            v = e.transformIndex,
            y = t.transforms[v].groups,
            x = o(t.transforms, g);
        if (!n.isArrayOrTypedArray(y) || 0 === y.length) return [t];

        var b = n.filterUnique(y),
            _ = new Array(b.length),
            w = y.length,
            T = i.findArrayAttributes(t),
            k = g.styles || [],
            M = {};

        for (r = 0; r < k.length; r++) {
          M[k[r].target] = k[r].value;
        }

        g.styles && (m = n.keyedContainer(g, "styles", "target", "value.name"));
        var A = {},
            S = {};

        for (r = 0; r < b.length; r++) {
          A[f = b[r]] = r, S[f] = 0, (h = _[r] = n.extendDeepNoArrays({}, t))._group = f, h.transforms[v]._indexToPoints = {};
          var E = null;

          for (m && (E = m.get(f)), h.name = E || "" === E ? E : n.templateString(g.nameformat, {
            trace: t.name,
            group: f
          }), p = h.transforms, h.transforms = [], s = 0; s < p.length; s++) {
            h.transforms[s] = n.extendDeepNoArrays({}, p[s]);
          }

          for (s = 0; s < T.length; s++) {
            n.nestedProperty(h, T[s]).set([]);
          }
        }

        for (l = 0; l < T.length; l++) {
          for (c = T[l], s = 0, d = []; s < b.length; s++) {
            d[s] = n.nestedProperty(_[s], c).get();
          }

          for (u = n.nestedProperty(t, c).get(), s = 0; s < w; s++) {
            d[A[y[s]]].push(u[s]);
          }
        }

        for (s = 0; s < w; s++) {
          (h = _[A[y[s]]]).transforms[v]._indexToPoints[S[y[s]]] = x(s), S[y[s]]++;
        }

        for (r = 0; r < b.length; r++) {
          f = b[r], h = _[r], a.clearExpandedTraceDefaultColors(h), h = n.extendDeepNoArrays(h, M[f] || {});
        }

        return _;
      }

      r.moduleType = "transform", r.name = "groupby", r.attributes = {
        enabled: {
          valType: "boolean",
          dflt: !0,
          editType: "calc"
        },
        groups: {
          valType: "data_array",
          dflt: [],
          editType: "calc"
        },
        nameformat: {
          valType: "string",
          editType: "calc"
        },
        styles: {
          _isLinkedToArray: "style",
          target: {
            valType: "string",
            editType: "calc"
          },
          value: {
            valType: "any",
            dflt: {},
            editType: "calc",
            _compareAsJSON: !0
          },
          editType: "calc"
        },
        editType: "calc"
      }, r.supplyDefaults = function (t, e, i) {
        var a,
            o = {};

        function s(e, i) {
          return n.coerce(t, o, r.attributes, e, i);
        }

        if (!s("enabled")) return o;
        s("groups"), s("nameformat", i._dataLength > 1 ? "%{group} (%{trace})" : "%{group}");
        var l = t.styles,
            c = o.styles = [];
        if (l) for (a = 0; a < l.length; a++) {
          var u = c[a] = {};
          n.coerce(l[a], c[a], r.attributes.styles, "target");
          var f = n.coerce(l[a], c[a], r.attributes.styles, "value");
          n.isPlainObject(f) ? u.value = n.extendDeep({}, f) : f && delete u.value;
        }
        return o;
      }, r.transform = function (t, e) {
        var r,
            n,
            i,
            a = [];

        for (n = 0; n < t.length; n++) {
          for (r = s(t[n], e), i = 0; i < r.length; i++) {
            a.push(r[i]);
          }
        }

        return a;
      };
    }, {
      "../lib": 795,
      "../plot_api/plot_schema": 833,
      "../plots/plots": 909,
      "./helpers": 1380
    }],
    1380: [function (t, e, r) {
      "use strict";

      r.pointsAccessorFunction = function (t, e) {
        for (var r, n, i = 0; i < t.length && (r = t[i]) !== e; i++) {
          r._indexToPoints && !1 !== r.enabled && (n = r._indexToPoints);
        }

        return n ? function (t) {
          return n[t];
        } : function (t) {
          return [t];
        };
      };
    }, {}],
    1381: [function (t, e, r) {
      "use strict";

      var n = t("../lib"),
          i = t("../plots/cartesian/axes"),
          a = t("./helpers").pointsAccessorFunction,
          o = t("../constants/numerical").BADNUM;
      r.moduleType = "transform", r.name = "sort", r.attributes = {
        enabled: {
          valType: "boolean",
          dflt: !0,
          editType: "calc"
        },
        target: {
          valType: "string",
          strict: !0,
          noBlank: !0,
          arrayOk: !0,
          dflt: "x",
          editType: "calc"
        },
        order: {
          valType: "enumerated",
          values: ["ascending", "descending"],
          dflt: "ascending",
          editType: "calc"
        },
        editType: "calc"
      }, r.supplyDefaults = function (t) {
        var e = {};

        function i(i, a) {
          return n.coerce(t, e, r.attributes, i, a);
        }

        return i("enabled") && (i("target"), i("order")), e;
      }, r.calcTransform = function (t, e, r) {
        if (r.enabled) {
          var s = n.getTargetArray(e, r);

          if (s) {
            var l = r.target,
                c = s.length;
            e._length && (c = Math.min(c, e._length));

            var u,
                f,
                h = e._arrayAttrs,
                p = function (t, e, r, n) {
              var i,
                  a = new Array(n),
                  s = new Array(n);

              for (i = 0; i < n; i++) {
                a[i] = {
                  v: e[i],
                  i: i
                };
              }

              for (a.sort(function (t, e) {
                switch (t.order) {
                  case "ascending":
                    return function (t, r) {
                      var n = e(t.v),
                          i = e(r.v);
                      return n === o ? 1 : i === o ? -1 : n - i;
                    };

                  case "descending":
                    return function (t, r) {
                      var n = e(t.v),
                          i = e(r.v);
                      return n === o ? 1 : i === o ? -1 : i - n;
                    };
                }
              }(t, r)), i = 0; i < n; i++) {
                s[i] = a[i].i;
              }

              return s;
            }(r, s, i.getDataToCoordFunc(t, e, l, s), c),
                d = a(e.transforms, r),
                m = {};

            for (u = 0; u < h.length; u++) {
              var g = n.nestedProperty(e, h[u]),
                  v = g.get(),
                  y = new Array(c);

              for (f = 0; f < c; f++) {
                y[f] = v[p[f]];
              }

              g.set(y);
            }

            for (f = 0; f < c; f++) {
              m[f] = d(p[f]);
            }

            r._indexToPoints = m, e._length = c;
          }
        }
      };
    }, {
      "../constants/numerical": 771,
      "../lib": 795,
      "../plots/cartesian/axes": 845,
      "./helpers": 1380
    }],
    1382: [function (t, e, r) {
      "use strict";

      r.version = "2.0.0";
    }, {}]
  }, {}, [26])(26);
});